const largeArraydata =
{
  "count": 5529,
  "results": [
    {
      "id": 3063,
      "client_name": "THAIS ADRIANA BEJAS TORRES",
      "client_type_name": "EMPLEADO",
      "client_subdivision": "ACTIVO_EMPLEADO",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Villas El Carmen",
      "plan": {
        "id": 78,
        "name": "Plan empleado 80MB",
        "cost": "0.00",
        "code": "FO-80M",
        "profile": "80M/80M"
      },
      "client_mobile": "04127775205",
      "client_email": "THAISBEJAS@GMAIL.COM",
      "address": "CALLE 04 Nº 03 URB VILLAS EL CARMEN SECTOR EL MACARO, TURMERO ESTADO ARAGUA",
      "client_identification": "V15864394",
      "nap_box_name": "49",
      "created_at": "2024-04-03T10:34:20.251538",
      "service_detail": {
        "id": 3011,
        "ip": "172.18.111.2",
        "mac": "TPLG2ABDC7EB",
        "serial": "TPLG2ABDC7EB",
        "queue": "Plan_14173_1574_WispHub",
        "interface": "VLAN135_VILLAS_CARMEN",
        "created_at": "2024-06-21T16:26:55.706440",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3064,
      "client_name": "FRIGORIFICO EL SAMAN",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Saman de Guere",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04128864954",
      "client_email": "FRIGORIFICOELSAMAN2019@GMAIL.COM",
      "address": "AV INTERCOMUNAL MARACAY TURMERO LOCAL C C ARAGUANEY LOCAL NRO 3 Y 4 SECTOR SAMAN DE GUERE TURMERO ARAGUA",
      "client_identification": "J307297131",
      "nap_box_name": "11",
      "created_at": "2024-04-05T14:47:25.451415",
      "service_detail": {
        "id": 9745,
        "ip": "172.25.91.2",
        "mac": "TPLGB86283C4",
        "serial": "TPLGB86283C4",
        "queue": null,
        "interface": "VLAN122_SAMAN_GUERE",
        "created_at": "2025-11-10T11:48:11.318170",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3065,
      "client_name": "INVERSIONES N&D",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "El Macaro",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04144522627",
      "client_email": "LUCELLYDZ@GMAIL.COM",
      "address": "CARRETERA EL MACARO TURMERO LOCAL NRO 03 SECTOR EL MACARO TURMERO  ARAGUA",
      "client_identification": "J314689819",
      "nap_box_name": "CE-00141",
      "created_at": "2024-04-05T15:16:49.443443",
      "service_detail": {
        "id": 10134,
        "ip": "10.16.112.2",
        "mac": "VSOL00522C11",
        "serial": "VSOL00522C11",
        "queue": null,
        "interface": "VLAN104_EL_MACARO_OLT_ZTE",
        "created_at": "2025-11-14T14:55:45.686328",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3066,
      "client_name": "AGROREPUESTOS TURMERO (AGRORETURCA), CA",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Saman de Guere",
      "plan": {
        "id": 38,
        "name": "RECURRENTE PYME PLAN 800M",
        "cost": "110.40",
        "code": "FOP800M",
        "profile": "800M/800M"
      },
      "client_mobile": "04140476979",
      "client_email": "AGRORETURCA@GMAIL.COM",
      "address": "MARACAY TURMERO LOCAL NRO 28 SECTOR EL MACARO TURMERO ARAGUA AV PRINCIPAL DEL MACARO",
      "client_identification": "J506763362",
      "nap_box_name": "CTO-0022",
      "created_at": "2024-04-05T15:50:49.212883",
      "service_detail": {
        "id": 3693,
        "ip": "172.18.164.2",
        "mac": "TPLGB954EB48",
        "serial": "TPLGB954EB48",
        "queue": "Plan_92035_1574_WispHub",
        "interface": "VLAN100_OLTs",
        "created_at": "2024-07-11T20:44:33.410647",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3067,
      "client_name": "COLOR CENTRAL C.A",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04144638029",
      "client_email": "COLORCENTRAL41@GMAIL.COM",
      "address": "CALLE MIRANDA CC MINICENTRO GUEVARA LETRA A NIVEL PB LOCAL 41 SECTOR CENTRO TURMERO EDO ARAGUA",
      "client_identification": "J295033770",
      "nap_box_name": "CTO-00038",
      "created_at": "2024-04-05T16:08:05.300521",
      "service_detail": {
        "id": 9722,
        "ip": "172.19.132.2",
        "mac": "TPLG2ABDC7E2",
        "serial": "TPLG2ABDC7E2",
        "queue": null,
        "interface": "VLAN200_OLTs",
        "created_at": "2025-11-10T11:06:26.149834",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3069,
      "client_name": "SUMINISTROS OCTAGO 1030",
      "client_type_name": "PYME",
      "client_subdivision": "CANCELADO_PYME",
      "status_name": "Cancelado",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Saman de Guere",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04149585965",
      "client_email": "ADMONOCTAGO@GMAIL.COM",
      "address": "CALLE LA CEIBA C/TRINIDAD NRO 26 SAMAN DE GUERE TURMERO ESTADO ARAGUA",
      "client_identification": "J404791442",
      "nap_box_name": "124",
      "created_at": "2024-04-05T17:02:23.577915",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3071,
      "client_name": "COSMETICOS PACIFICO 2021 CA",
      "client_type_name": "PYME",
      "client_subdivision": "CANCELADO_PYME",
      "status_name": "Cancelado",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04127761730",
      "client_email": "COSMETICOSPACIFICO@GMAIL.COM",
      "address": "CALLE MIRANDA CC NONNO LORENZO NIVEL PB LOCAL 2 SECTOR CENTRO DE TURMERO ARAGUA",
      "client_identification": "J501476381",
      "nap_box_name": "CAJA NAP BICENTENARIO",
      "created_at": "2024-04-05T17:14:56.088628",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3073,
      "client_name": "AUTO SILENCIADORES LA GRAN REDOMA CA",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Saman de Guere",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04149454913",
      "client_email": "AUTOSILENCIADORESLGR@GMAIL.COM",
      "address": "AV INTERCOMUNAL MARACAY TURMERO C/C CALLEJON LAS CAYENAS LOCAL NRO 1 SECTOR EL SAMÁN DE GUERE TURMERO ARAGUA",
      "client_identification": "J075228758",
      "nap_box_name": "11",
      "created_at": "2024-04-05T17:31:55.334119",
      "service_detail": {
        "id": 9803,
        "ip": "172.25.43.2",
        "mac": "TPLGB7656331",
        "serial": "TPLGB7656331",
        "queue": null,
        "interface": "VLAN122_SAMAN_GUERE",
        "created_at": "2025-11-10T15:32:41.237375",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3077,
      "client_name": "INVERSIONES EDITORIAL MOREGO CA",
      "client_type_name": "PYME",
      "client_subdivision": "PAUSADO_PYME",
      "status_name": "Pausado",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04144600051",
      "client_email": "IMPRENTA.MOREGOCA@GMAIL.COM",
      "address": "CALLE CEDEÑO GALPON NRO 29 LOCAL NRO S/N SECTOR MUNICIPIO SANTIAGO MARIÑO TURMERO ARAGUA",
      "client_identification": "J403717885",
      "nap_box_name": "649",
      "created_at": "2024-04-08T21:19:53.778036",
      "service_detail": {
        "id": 6625,
        "ip": "172.20.10.2",
        "mac": "TPLGB76563B2",
        "serial": "TPLGB76563B2",
        "queue": "Plan_92036_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-09-17T08:30:52.980826",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3078,
      "client_name": "ADRIANY DE LOS ANGELES HERRERA RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villas El Carmen",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04263304969",
      "client_email": "RADRI723@GMAIL.COM",
      "address": "CALLE 2 CASA NRO 15 URB VILLAS DEL CARMEN EL MACARO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V26596420",
      "nap_box_name": "50",
      "created_at": "2024-04-10T11:28:50.111096",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3079,
      "client_name": "ANTONIO JOSE MORENO PEÑA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villa Los Tamarindos",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04127765546",
      "client_email": "ANTONIOJOSEMORENO16@GMAIL.COM",
      "address": "CALLE 5 CASA NRO 4 URB LOS TAMARINDOS EL MACARO TURMERO",
      "client_identification": "V25501371",
      "nap_box_name": "105",
      "created_at": "2024-04-10T12:19:29.929209",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3080,
      "client_name": "YONEIDA JOSEFINA ESCALONA SARRIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villa Los Tamarindos",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04140497754",
      "client_email": "MARIAGABRIELAGUEVARA69@GMAIL.COM",
      "address": "CALLE 5 CASA NRO 10 SECTOR VILLA LOS TAMARINDOS EL MACARO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V7252709",
      "nap_box_name": "105",
      "created_at": "2024-04-10T12:53:18.836196",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3081,
      "client_name": "GUSTAVO ENRIQUE BLANCO RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villa Los Tamarindos",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04122484037",
      "client_email": "GUSTAVO.E.BLANCO.R@GMAIL.COM",
      "address": "CALLE 5 CASA NRO 02 SECTOR VILLA LOS TAMARINDOS",
      "client_identification": "V17575784",
      "nap_box_name": "105",
      "created_at": "2024-04-10T13:00:53.388765",
      "service_detail": {
        "id": 3710,
        "ip": "172.18.139.2",
        "mac": "VSOL0047D419",
        "serial": "VSOL0047D419",
        "queue": "Plan_137413_1574_WispHub",
        "interface": "VLAN133_VILLA_TAMARINDOS",
        "created_at": "2024-07-11T21:35:19.273758",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3082,
      "client_name": "WENDYS YIANITZA MORALES ZABALA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villa Los Tamarindos",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243070819",
      "client_email": "BODEGAWENDYSMORALESFP@GMAIL.COM",
      "address": "CALLE 3 CASA NRO 9 SECTOR VILLA LOS TAMARINDOS TURMERO",
      "client_identification": "V11845640",
      "nap_box_name": "121",
      "created_at": "2024-04-10T13:10:52.861334",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3083,
      "client_name": "EGLIS YENNISSY BLANCO MARTINEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villa Los Tamarindos",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04129675850",
      "client_email": "BLANCOEGLIS731@GMAIL.COM",
      "address": "CALLE 4 CASA NRO 5 URB VILLAS LOS TAMARINDOS TURMERO",
      "client_identification": "V20649493",
      "nap_box_name": "106",
      "created_at": "2024-04-10T13:18:50.183074",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3084,
      "client_name": "KELVIN EFRAIN PEREZ GUILLEN",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villa Los Tamarindos",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124588636",
      "client_email": "KELVINNPEREZ@GMAIL.COM",
      "address": "CALLE 7 NRO 5 URB LOS TAMARINDOS TURMERO",
      "client_identification": "V26791046",
      "nap_box_name": "CTO-00593",
      "created_at": "2024-04-10T13:23:34.809920",
      "service_detail": {
        "id": 4699,
        "ip": "172.28.2.2",
        "mac": "TPLGBA687BCD",
        "serial": "TPLGBA687BCD",
        "queue": "queue1",
        "interface": "VLAN133_VILLA_TAMARINDOS",
        "created_at": "2024-08-12T11:33:58.768047",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3085,
      "client_name": "DANIS WILEYKA COLMENARES DELGADO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villas El Carmen",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124562683",
      "client_email": "DANISCOLMENARES3@GMAIL.COM",
      "address": "CALLLE 4 CASA NRO 1 URB VILLAS EL CARMEN TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V11085409",
      "nap_box_name": "49",
      "created_at": "2024-04-10T13:47:20.314286",
      "service_detail": {
        "id": 3798,
        "ip": "172.25.54.2",
        "mac": "TPLGF9CD406C",
        "serial": "TPLGF9CD406C",
        "queue": "Plan_129887_1574_WispHub",
        "interface": "VLAN135_VILLAS_CARMEN",
        "created_at": "2024-07-15T14:43:59.110230",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3086,
      "client_name": "PAULINA JOSEP BOLIVAR DEUS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villa Los Tamarindos",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04243542362",
      "client_email": "PAULINAJBD@GMAIL.COM",
      "address": "CALLE 3 CASA NRO 14 VILLAS LOS TAMARINDOS TURMERO",
      "client_identification": "V27048764",
      "nap_box_name": "106",
      "created_at": "2024-04-10T13:47:21.935511",
      "service_detail": {
        "id": 3713,
        "ip": "172.22.63.2",
        "mac": "TPLGBA687759",
        "serial": "TPLGBA687759",
        "queue": "Plan_138775_1574_WispHub",
        "interface": "VLAN133_VILLA_TAMARINDOS",
        "created_at": "2024-07-11T21:58:38.696906",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3087,
      "client_name": "AURELY FRANCHESCA ALCALA REYES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villas El Carmen",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121572997",
      "client_email": "REYESAURA677@GMAIL.COM",
      "address": "CR EL MACARO EDIF BARBASCO PISO 3 APTO 10 URB VILLAS DEL CARMEN 19 DE ABRIL ARAGUA ZONA POSTAL 2115",
      "client_identification": "V255011053",
      "nap_box_name": "58 DOS",
      "created_at": "2024-04-10T13:53:21.697653",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3088,
      "client_name": "ANDREYS ARIANNA ZAMBRANO MANRIQUE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "SUSPENDIDO_RESIDENCIAL",
      "status_name": "Suspendido",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villas El Carmen",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243517497",
      "client_email": "ZAMBRANOANDREYS@GMAIL.COM",
      "address": "CALLE 3ERA CASA NRO. 7 URB. VISTA HERMOSA SAN FERNANDO DE APURE ZONA POSTAL 7001",
      "client_identification": "V28456607",
      "nap_box_name": "49",
      "created_at": "2024-04-10T13:58:41.401462",
      "service_detail": {
        "id": 12754,
        "ip": "172.24.140.2",
        "mac": "TP:LG:B4:46:F5:3B",
        "serial": "TPLGB446F53B",
        "queue": null,
        "interface": "VLAN135_VILLAS_CARMEN_OLT_ZTE",
        "created_at": "2026-07-19T11:04:44.575163",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3089,
      "client_name": "CARLA AURISTELA NORIEGA ALMEIDA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villas El Carmen",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121487780",
      "client_email": "CARLANORIEGA50@GMAIL.COM",
      "address": "CALLE 8 CASA NRO. 13 URB. VILLAS EL CARMEN TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V11086945",
      "nap_box_name": "41",
      "created_at": "2024-04-10T14:04:51.564153",
      "service_detail": {
        "id": 9759,
        "ip": "172.23.206.2",
        "mac": "TPLGB446EE6D",
        "serial": "TPLGB446EE6D",
        "queue": null,
        "interface": "VLAN135_VILLAS_CARMEN_OLT_ZTE",
        "created_at": "2025-11-10T12:12:13.078865",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3090,
      "client_name": "ALEXANDER OSSIAN VALERA MARANTE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villas El Carmen",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128901892",
      "client_email": "CAMILA12112016@GMAIL.COM",
      "address": "CALLE 8 CASA  NRO. 11 URB.  VILLAS EL CARMEN TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V15970921",
      "nap_box_name": "41",
      "created_at": "2024-04-10T14:08:47.198540",
      "service_detail": {
        "id": 12335,
        "ip": "172.24.74.2",
        "mac": "TPLGB446EA8F",
        "serial": "TPLGB446EA8F",
        "queue": null,
        "interface": "VLAN135_VILLAS_CARMEN_OLT_ZTE",
        "created_at": "2026-04-16T18:35:16.404578",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3091,
      "client_name": "LAURA BRISEIDA BLANCO DE AVILA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villa Los Tamarindos",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121484389",
      "client_email": "LAURABBLANCO0@GMAIL.COM",
      "address": "CALLE 6 CASA NRO 13 URB VILLA LOS TAMARINDOS EL MACARO",
      "client_identification": "V5281001",
      "nap_box_name": "105",
      "created_at": "2024-04-10T14:12:34.737010",
      "service_detail": {
        "id": 11674,
        "ip": "172.21.143.2",
        "mac": "TPLGB68B56FB",
        "serial": "TPLGB68B56FB",
        "queue": null,
        "interface": "VLAN133_VILLA_TAMARINDOS",
        "created_at": "2026-02-19T09:45:23.906388",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3092,
      "client_name": "JOSE ENRIQUE PEREZ OJEDA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villas El Carmen",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124830375",
      "client_email": "JOSEPEREZOJEDA.PERU@GMAIL.COM",
      "address": "CALLE 07 CASA NRO 12 URB VILLAS EL CARMEN SECTOR EL MACARO 19 DE ABRIL ARAGUA ZONA POSTAL 2115",
      "client_identification": "V20589958",
      "nap_box_name": "41",
      "created_at": "2024-04-10T14:14:11.494042",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3093,
      "client_name": "ANA KARENINA QUINTERO TAIPE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villa Los Tamarindos",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121492389",
      "client_email": "AQUINTEROTAIPE@GMAIL.COM",
      "address": "CALLE 4 MARGARITA TIVERO CASA NRO 07 URB VILLA LOS TAMARINDOS SECTOR EL MACARO",
      "client_identification": "V20754214",
      "nap_box_name": "106",
      "created_at": "2024-04-10T14:19:06.709949",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3094,
      "client_name": "ERICK JOSNAY SERVEN FLORES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villa Los Tamarindos",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243812849",
      "client_email": "ELIANAMADOR1@GMAIL.COM",
      "address": "CALLE 1 CASA NRO 4 URB LOS TAMARINDOS TURMERO",
      "client_identification": "V15610828",
      "nap_box_name": "107",
      "created_at": "2024-04-10T14:21:53.564503",
      "service_detail": {
        "id": 12149,
        "ip": "172.21.62.2",
        "mac": "TPLGB954EB9D",
        "serial": "TPLGB954EB9D",
        "queue": null,
        "interface": "VLAN133_VILLA_TAMARINDOS",
        "created_at": "2026-03-21T10:43:02.258049",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3095,
      "client_name": "JESUS RAMON TORREALBA GUEVARA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villa Los Tamarindos",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04263384280",
      "client_email": "JESUSTORREALBAG@HOTMAIL.COM",
      "address": "CALLE 7 CASA 13 VILLA LOS TAMARINDOS SECTOR EL MACARO TURMERO",
      "client_identification": "V10056312",
      "nap_box_name": "CTO-00593",
      "created_at": "2024-04-10T14:24:57.380200",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3096,
      "client_name": "GLADYS JOSEFINA RODRIGUEZ CORRO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villa Los Tamarindos",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04145989628",
      "client_email": "GLADYSJRC2374@GMAIL.COM",
      "address": "CALLE MARGARITA RIVERO CASA 21 URB VILLA LOS TAMARINDOS SECTOR EL MACARO",
      "client_identification": "V13201596",
      "nap_box_name": "106",
      "created_at": "2024-04-10T14:40:00.916507",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3097,
      "client_name": "ANTONIA LETICIA RIOS DE GABAZUT",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villa Los Tamarindos",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04124516155",
      "client_email": "LETIRIOS1958@GMAIL.COM",
      "address": "CALLE 5 CASA NRO 3 URB VILLA LOS TAMARINDOS EL MACARO TURMERO EDO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V5624493",
      "nap_box_name": "105",
      "created_at": "2024-04-10T14:42:31.149088",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3098,
      "client_name": "LUIYEL MANUEL ZACARIAS MONTIEL",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villa Los Tamarindos",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04124202423",
      "client_email": "LUIYELMANUEL89@GMAIL.COM",
      "address": "CALLE CASA PASAJE LAS FLORES NRO 7 VILLA LOS TAMARINDOS EL MACARO TURMERO",
      "client_identification": "V19515407",
      "nap_box_name": "107",
      "created_at": "2024-04-10T14:46:03.589845",
      "service_detail": {
        "id": 4224,
        "ip": "172.20.201.2",
        "mac": "TPLGB954E840",
        "serial": "TPLGB954E840",
        "queue": "Plan_127996_1574_WispHub",
        "interface": "VLAN100_OLTs",
        "created_at": "2024-08-07T11:16:16.658959",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3099,
      "client_name": "YOUSI CRISTINA LOPEZ MARANA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villa Los Tamarindos",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04145438339",
      "client_email": "wilfred.aponte.ucv@gmail.com",
      "address": "CALLE MARGARITA RIVERA CALLE 4 CASA NRO 06 URB VILLAS LOS TAMARINDOS",
      "client_identification": "V9581577",
      "nap_box_name": "106",
      "created_at": "2024-04-10T14:59:36.873728",
      "service_detail": {
        "id": 9869,
        "ip": "172.20.178.2",
        "mac": "TPLGF5CB081C",
        "serial": "TPLGF5CB081C",
        "queue": null,
        "interface": "VLAN133_VILLA_TAMARINDOS",
        "created_at": "2025-11-10T18:53:49.325722",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3100,
      "client_name": "STEFANI VANESSA ACOSTA RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villa Los Tamarindos",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04241534856",
      "client_email": "STEFANIACOSTA99@GMAIL.COM",
      "address": "CALLE EFREN RODRIGUEZ CASA NRO 5 VILLA LOS TAMARINDOS TURMERO",
      "client_identification": "V27048342",
      "nap_box_name": "105",
      "created_at": "2024-04-10T15:02:27.818487",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3101,
      "client_name": "RAMON  ANTONIO TERAN CALDERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villa Los Tamarindos",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04243036075",
      "client_email": "RAMONTERANC120@GMAIL.COM",
      "address": "CALLE 3 CASA NRO 15 URBANIZACIÓN VILLA LOS TAMARINDOS EL MACARO",
      "client_identification": "V11359120",
      "nap_box_name": "121",
      "created_at": "2024-04-10T15:41:49.186969",
      "service_detail": {
        "id": 4752,
        "ip": "172.20.173.2",
        "mac": "TPLGF5CB03EF",
        "serial": "TPLGF5CB03EF",
        "queue": "Plan_138775_1574_WispHub",
        "interface": "VLAN100_OLTs",
        "created_at": "2024-08-12T14:55:15.089270",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3102,
      "client_name": "MAYARIS PAOLA DEUS RISSO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villa Los Tamarindos",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04142971394",
      "client_email": "MAYARISDEUSRISSO@GMAIL.COM",
      "address": "CALLE MARGARITA RIVERO CASA NRO 11 URB VILLA LOS TAMARINDOS TURMERO",
      "client_identification": "V30211563",
      "nap_box_name": "106",
      "created_at": "2024-04-10T15:48:09.125351",
      "service_detail": {
        "id": 12772,
        "ip": "172.20.175.2",
        "mac": "TP:LG:B9:54:E8:24",
        "serial": "TPLGB954E824",
        "queue": null,
        "interface": "VLAN133_VILLA_TAMARINDOS",
        "created_at": "2026-07-25T13:12:17.563751",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3103,
      "client_name": "JOSE MANUEL MACIAS BRICEÑO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villa Los Tamarindos",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04124651541",
      "client_email": "JOSEMACIASRP@GMAIL.COM",
      "address": "CALLE PACIANO PADRON CASA NRO 05 VILLA LOS TAMARINDOS",
      "client_identification": "V25620132",
      "nap_box_name": "105",
      "created_at": "2024-04-10T15:52:08.682783",
      "service_detail": {
        "id": 9841,
        "ip": "172.20.172.2",
        "mac": "TPLGF5CB0786",
        "serial": "TPLGF5CB0786",
        "queue": null,
        "interface": "VLAN100_OLTs",
        "created_at": "2025-11-10T17:45:10.548911",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3104,
      "client_name": "YESENIA CAROLINA MIERI SILVA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villa Los Tamarindos",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124675040",
      "client_email": "INV.MIVIEJOESHUIRE@GMAIL.COM",
      "address": "CALLE 4 CASA 10 URB LOS TAMARINDOS",
      "client_identification": "V16338263",
      "nap_box_name": "106",
      "created_at": "2024-04-10T15:55:38.495454",
      "service_detail": {
        "id": 10182,
        "ip": "172.20.171.2",
        "mac": "TPLGF5CB02A4",
        "serial": "TPLGF5CB02A4",
        "queue": null,
        "interface": "VLAN133_VILLA_TAMARINDOS",
        "created_at": "2025-11-18T12:36:43.392840",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3105,
      "client_name": "ADELAIDA DEL VALLE ASTUDILLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villa Los Tamarindos",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243031459",
      "client_email": "GOMEZRICARDO153@GMAIL.COM",
      "address": "CALLE 2 CASA NRO 9 URB VILLAS LOS TAMARINDOS EL MACARO TURMERO",
      "client_identification": "V8643694",
      "nap_box_name": "556",
      "created_at": "2024-04-10T15:58:37.168581",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3106,
      "client_name": "AYMAR JOE PUERTA SCIORTINO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villa Los Tamarindos",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243724180",
      "client_email": "AYMARSCIORTINO@GMAIL.COM",
      "address": "CALLE AMBAR CASA NRO 7 VILLAS LOS TAMARINDOS TURMERO",
      "client_identification": "V24930348",
      "nap_box_name": "107",
      "created_at": "2024-04-10T16:02:48.893221",
      "service_detail": {
        "id": 4790,
        "ip": "172.20.169.2",
        "mac": "TPLGB954F6A3",
        "serial": "TPLGB954F6A3",
        "queue": "Plan_127996_1574_WispHub",
        "interface": "VLAN100_OLTs",
        "created_at": "2024-08-12T16:16:05.423774",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3107,
      "client_name": "ANNYS NACARIS BEROES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villa Los Tamarindos",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04145993884",
      "client_email": "ANNYSBEROES98@GMAIL.COM",
      "address": "CALLE 5 NRO 22 VILLA LOS TAMARINDOS TURMERO",
      "client_identification": "V17608439",
      "nap_box_name": "105",
      "created_at": "2024-04-10T16:06:09.236972",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3108,
      "client_name": "FELICITA AURORA RODRIGUEZ  IBARRA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243558369",
      "client_email": "FELICITAAURORA2017@GMAIL.COM",
      "address": "CALLE 5-A CASA NRO 17 SECTOR HACIENDA PANTIN TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V10758785",
      "nap_box_name": "CTO-00135",
      "created_at": "2024-04-10T16:21:49.696190",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3109,
      "client_name": "MELVIN JOSE ARVELAEZ GAMARRA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Canaima",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243495528",
      "client_email": "MELVINARVELAEZ@GMAIL.COM",
      "address": "CALLE 7 CASA NRO 28 CANAIMA SECTOR PRADOS DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V24930713",
      "nap_box_name": "418",
      "created_at": "2024-04-10T16:24:48.022666",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3110,
      "client_name": "MIGUEL ARMANDO MAGALLANEZ ROMERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243382860",
      "client_email": "DMAGALLANEZH.3012@GMAIL.COM",
      "address": "CALLE 6 CASA NRO 423 URB MATA CABALLO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V22948789",
      "nap_box_name": "CTO-00031",
      "created_at": "2024-04-10T16:34:46.738549",
      "service_detail": {
        "id": 12121,
        "ip": "172.25.112.2",
        "mac": "TPLGF4EFC00A",
        "serial": "TPLGF4EFC00A",
        "queue": null,
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2026-03-18T12:22:37.180258",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3111,
      "client_name": "GENESIS KATIUSKA ESCOBAR MACHILLANDA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Guanarito",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144511800",
      "client_email": "KATIUSKAESCOBAR63@GMAIL.COM",
      "address": "CALLE LA ESTRELLA CASA NRO 15 SECTOR PEÑALVER TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V25527603",
      "nap_box_name": "231",
      "created_at": "2024-04-10T16:49:54.416735",
      "service_detail": {
        "id": 4808,
        "ip": "172.25.113.2",
        "mac": "TPLGF9CD45E4",
        "serial": "TPLGF9CD45E4",
        "queue": "Plan_114480_15811_WispHub",
        "interface": "VLAN232_GUANARITO_OLT2",
        "created_at": "2024-08-12T16:55:53.401032",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3112,
      "client_name": "JEFFERSON JOSE ROJAS TOVAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Tibisay Guevara",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243623912",
      "client_email": "JEFFERJOSE92@GMAIL.COM",
      "address": "CALLE 2 CASA NRO 62 URB TIBISAY GUEVARA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V21370481",
      "nap_box_name": "CTO-00055",
      "created_at": "2024-04-10T16:54:38.043353",
      "service_detail": {
        "id": 4839,
        "ip": "172.25.93.2",
        "mac": "TPLGF9CD4656",
        "serial": "TPLGF9CD4656",
        "queue": "Plan_124568_15811_WispHub",
        "interface": "VLAN248_TIBISAY_OLT2",
        "created_at": "2024-08-12T17:56:52.040822",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3113,
      "client_name": "YEDXY DAVIELA DIAZ MARRERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243450390",
      "client_email": "YEDXYDAVIELADIAZMARRERO@GMAIL.COM",
      "address": "CALLE 14 A CASA NRO 14 SECTOR PANTIN ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V213701092",
      "nap_box_name": "CTO-00169",
      "created_at": "2024-04-10T17:11:56.598029",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3114,
      "client_name": "RAMON ANTONIO VILLAVICENCIO RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124348812",
      "client_email": "ROSALINDABLANCO@HOTMAIL.COM",
      "address": "CALLE18-A CASA NRO 17 SECTOR PANTIN ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V13870598",
      "nap_box_name": "CTO-00434",
      "created_at": "2024-04-10T17:18:41.232793",
      "service_detail": {
        "id": 4833,
        "ip": "172.26.19.2",
        "mac": "TPLGF9CD3C69",
        "serial": "TPLGF9CD3C69",
        "queue": "Plan_161904_30183_WispHub",
        "interface": "VLAN229_PANTIN",
        "created_at": "2024-08-12T17:43:32.109042",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3115,
      "client_name": "GLEDYS MARILYN GUEDEZ RAMOS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "SUSPENDIDO_RESIDENCIAL",
      "status_name": "Suspendido",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Paya Abajo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04127560243",
      "client_email": "GLEDYSGUEDEZ24@GMAIL.COM",
      "address": "CALLE SAN ANTONIO CASA NRO01 SECTOR PAYA ABAJO",
      "client_identification": "V24929985",
      "nap_box_name": "272",
      "created_at": "2024-04-10T17:22:30.310137",
      "service_detail": {
        "id": 13041,
        "ip": "172.28.29.2",
        "mac": "TP:LG:F9:CD:46:C8",
        "serial": "TPLGF9CD46C8",
        "queue": null,
        "interface": "VLAN231_PAYABAJO",
        "created_at": "2026-09-19T09:27:51.915962",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3116,
      "client_name": "DEIVE ELIESER MARTINEZ BORGES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Esperanza",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04161473331",
      "client_email": "ANTONIOM25510@GMAIL.COM",
      "address": "CALLE 15 CASA NRO 17 URB ESPERANZA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V212039450",
      "nap_box_name": "RESERVA 3 TRONCAL LA ESPERANZA",
      "created_at": "2024-04-10T17:26:25.391155",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3117,
      "client_name": "LENIS VIRGINIA OCAR PANTOJA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villas Del Sur",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243681460",
      "client_email": "JEXIDIRIP@GMAIL.COM",
      "address": "CALLE 7 CASA NRO 8 URB VILLAS DEL SUR TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V13646008",
      "nap_box_name": "632",
      "created_at": "2024-04-11T07:59:44.009940",
      "service_detail": {
        "id": 4836,
        "ip": "172.25.67.2",
        "mac": "TPLGF9CD4625",
        "serial": "TPLGF9CD4625",
        "queue": "Plan_148293_24341_WispHub",
        "interface": "VLAN142_VILLAS_SUR",
        "created_at": "2024-08-12T17:49:47.105336",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3118,
      "client_name": "NELSON RAFAEL CAMACARO CHAVEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243315955",
      "client_email": "NCAMCARO22@GMAIL.COM",
      "address": "CALLE 06 CASA NRO 434 URB MATA CABALLO ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V118485447",
      "nap_box_name": "CTO-00312",
      "created_at": "2024-04-11T08:05:40.266036",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3119,
      "client_name": "EDUARDO RAFAEL FLORES ALONZO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados III",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128938321",
      "client_email": "EDUARF.277@GMAIL.COM",
      "address": "CALLE 2 CASA NRO 1 SECTOR PRADOS 3 ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V13133580",
      "nap_box_name": "CTO-00284",
      "created_at": "2024-04-11T08:11:00.369974",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3120,
      "client_name": "ANGEL EDUARDO RODRIGUEZ ALVEA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128847662",
      "client_email": "OSHEKAIFA@GMAIL.COM",
      "address": "CALLE12-B CASA NRO 39 URB PANTIN ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V16132525",
      "nap_box_name": "CTO-00169",
      "created_at": "2024-04-11T08:15:04.890879",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3121,
      "client_name": "EVA MARIA LOPEZ MILLAN",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Callejon Lim",
      "plan": {
        "id": 16,
        "name": "RECURRENTE RESIDENCIAL PLAN 800M",
        "cost": "55.00",
        "code": "FOR800",
        "profile": "800M/800M"
      },
      "client_mobile": "04143440830",
      "client_email": "EVAMARIALOPEZ31@HOTMAIL.COM",
      "address": "CALLLEJON LIM QTA ALDIÑA SECTOR PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V13201086",
      "nap_box_name": "453",
      "created_at": "2024-04-11T08:21:15.723063",
      "service_detail": {
        "id": 9547,
        "ip": "172.25.84.2",
        "mac": "TPLGF9CD46C9",
        "serial": "TPLGF9CD46C9",
        "queue": "queue1",
        "interface": "VLAN250_LIM_OLT2",
        "created_at": "2025-09-23T14:46:52.388013",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3122,
      "client_name": "MARTINA COLMENAREZ GAMEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Isaac Oliveira",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04125383200",
      "client_email": "MARTINACOLMENARES65@GMAIL.COM",
      "address": "CALLE 3RA TRANSVERSAL CASA NRO 132 URB ISAAC OLIVERA SECTOR LA JULIA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V7198402",
      "nap_box_name": "CTO-00259",
      "created_at": "2024-04-11T08:24:45.134353",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3123,
      "client_name": "YUDIBEL VANESSA TORRES TAVIO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Isaac Oliveira",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144737309",
      "client_email": "INDUHORNOS@HOTMAIL.COM",
      "address": "CALLE 2 CASA NRO 38 URB ISAAC OLIVERA INTERCOMUNAL TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V17042974",
      "nap_box_name": "CTO-00262",
      "created_at": "2024-04-11T08:27:27.167132",
      "service_detail": {
        "id": 11825,
        "ip": "172.25.83.2",
        "mac": "TPLGF9CD3F42",
        "serial": "TPLGF9CD3F42",
        "queue": null,
        "interface": "VLAN107_ISAAC_O",
        "created_at": "2026-02-27T11:47:42.983218",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3124,
      "client_name": "JOSE ALFREDO ESCORIHUELA GALEA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona II",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04120374789",
      "client_email": "JHOSVILGER@GMAIL.COM",
      "address": "CALLE 12 CASA NRO 7 URB LA CASONA 2 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V19948674",
      "nap_box_name": "322",
      "created_at": "2024-04-11T08:30:06.146274",
      "service_detail": {
        "id": 5115,
        "ip": "172.25.80.2",
        "mac": "TPLGF9CD46DF",
        "serial": "TPLGF9CD46DF",
        "queue": "Plan_131338_24341_WispHub",
        "interface": "VLAN110_CASONA_2",
        "created_at": "2024-08-14T15:47:46.117167",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3125,
      "client_name": "JESUS ENRIQUE NOGUERA HERRERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04243455229",
      "client_email": "JESNOGUER@GMAIL.COM",
      "address": "CALLE URDANETA CASA NRO 81 SECTOR TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V16692346",
      "nap_box_name": "25",
      "created_at": "2024-04-11T08:34:31.528818",
      "service_detail": {
        "id": 5117,
        "ip": "172.25.81.2",
        "mac": "TPLGF9CD3DA1",
        "serial": "TPLGF9CD3DA1",
        "queue": "Plan_140304_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-08-14T15:49:58.536552",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3126,
      "client_name": "CARMEN CECILIA FERNANDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124240921",
      "client_email": "VERSO100676@GMAIL.COM",
      "address": "CALLE 5-A CASA NRO 22 SECTOR PANTIN ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V19556208",
      "nap_box_name": "CTO-00135",
      "created_at": "2024-04-11T08:37:16.241217",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3127,
      "client_name": "ANGEL TAILO ZAMBRANO CALANCHE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128303923",
      "client_email": "ANGELTAILO18@GMAIL.COM",
      "address": "CALLE 3-A CASA NRO 11 URB PANTIN ROSARIO DE PAYA",
      "client_identification": "V146926416",
      "nap_box_name": "CTO-00127 DOS",
      "created_at": "2024-04-11T08:41:47.319242",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3128,
      "client_name": "DEISY DAYANA FANEITE MORA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128473940",
      "client_email": "FANEITEDAYANA457@GMAIL.COM",
      "address": "CALLE 16 B CASA NRO 41 URB PATIN ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V12853644",
      "nap_box_name": "CTO-00026",
      "created_at": "2024-04-11T08:45:40.463004",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3129,
      "client_name": "LISANGELYS MARIELA GONZALEZ NIETO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona I",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04124553716",
      "client_email": "LISANGELYS22@GMAIL.COM",
      "address": "AV INTERCOMUNAL TURMERO LA CASONA 1 CALLE 4 CASA 51",
      "client_identification": "V196559090",
      "nap_box_name": "412",
      "created_at": "2024-04-11T08:49:11.164492",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3130,
      "client_name": "ALEXANDER JAVIER CASTELLANO GUZMAN",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04144665419",
      "client_email": "ALEXANDERCASTELLANO25@GMAIL.COM",
      "address": "CALLE PROLONGACION RIVAS EDIF 6 PISO 1 APTO 1 CONJUNTO RESIDENCIAL LOS NISPEROS TURMERO ARAG",
      "client_identification": "V16692806",
      "nap_box_name": "CTO-00032",
      "created_at": "2024-04-11T09:40:15.311123",
      "service_detail": {
        "id": 5139,
        "ip": "172.25.70.2",
        "mac": "TPLGF9CD447B",
        "serial": "TPLGF9CD447B",
        "queue": "Plan_140304_15811_WispHub",
        "interface": "VLAN209_ZAMORA_OLT1",
        "created_at": "2024-08-14T17:59:25.422441",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3131,
      "client_name": "OLIVER DAVID SILVA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Paya Abajo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04127768273",
      "client_email": "NAO100191@GMAIL.COM",
      "address": "CALLE SAN MIGUEL CASA NRO 1 SECTOR PAYA ABAJO ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V14039180",
      "nap_box_name": "272",
      "created_at": "2024-04-11T10:15:12.497419",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3132,
      "client_name": "DALIARA CAROLINA SERRANO RIVERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados III",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243274451",
      "client_email": "DALICSR22@GMAIL.COM",
      "address": "CALLE 11 CASA NOR 35 URB PRADOS DE PAYA ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V25501669",
      "nap_box_name": "CTO-00204 DOS",
      "created_at": "2024-04-11T11:10:22.881625",
      "service_detail": {
        "id": 5318,
        "ip": "172.25.38.2",
        "mac": "TPLGF9CD3F80",
        "serial": "TPLGF9CD3F80",
        "queue": "Plan_161903_30183_WispHub",
        "interface": "VLAN239_PRADOS1",
        "created_at": "2024-08-16T09:11:27.738187",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3133,
      "client_name": "NISSLEIDY NATHALY BARRIOS GARCES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Bicentenario",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04129620102",
      "client_email": "GARCESNATHALY699@GMAIL.COM",
      "address": "CALLE ARAGUANEY CASA NRO 11 PB URB DESARROLLO URBANISTICO ROSARIO DE PAYA TURMERO ARAGUA",
      "client_identification": "V28142422",
      "nap_box_name": "592",
      "created_at": "2024-04-11T11:14:11.070789",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3134,
      "client_name": "FRANCIS MILAGROS CANELONES PINTO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Brisas de Paya",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04141475919",
      "client_email": "FRANCISCANELONES7@GMAIL.COM",
      "address": "CALLE PRINCIPAL MANZANA A CASA NRO 16 SECTOR BRISAS DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V23796619",
      "nap_box_name": "CTO-00206",
      "created_at": "2024-04-11T11:21:37.034878",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3135,
      "client_name": "MARTIN ALFONSO CEDENO ESCOBAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04125970810",
      "client_email": "MARTINCEDENO439@GMAIL.COM",
      "address": "CALLE 9-A CASA NRO 13 URB PANTIN TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V10225587",
      "nap_box_name": "CTO-00142",
      "created_at": "2024-04-11T11:28:46.333870",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3136,
      "client_name": "GUSTAVO ALEJANDRO NIEVES NIEVES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Bicentenario",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243191083",
      "client_email": "ALE30012560@GMAIL.COM",
      "address": "CALLE ARAGUANEY CASA NRO 04 SECTOR FUNDA BARRIO ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V30012560",
      "nap_box_name": "CTO-00446",
      "created_at": "2024-04-11T11:34:18.970580",
      "service_detail": {
        "id": 5324,
        "ip": "172.25.1.2",
        "mac": "TPLGF9CD46B0",
        "serial": "TPLGF9CD46B0",
        "queue": "Plan_161904_30183_WispHub",
        "interface": "VLAN243_BICENTENARIO",
        "created_at": "2024-08-16T09:17:44.824559",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3137,
      "client_name": "JAMES JOSEPH ZARATE MARTINEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144588278",
      "client_email": "JJMZ2379@GMAIL.COM",
      "address": "CALLE 14 CASA NRO 60 URB LA CASONA II TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V14729637",
      "nap_box_name": "CTO-00088",
      "created_at": "2024-04-11T11:36:01.539084",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3138,
      "client_name": "JENNIFER MICHEL PALENCIA GONZALEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04125079192",
      "client_email": "MICHELPALENCIA45@GMAIL.COM",
      "address": "CALLE 10 CASA NRO 13 SECTOR PANTIN ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V12169139",
      "nap_box_name": "CTO-00121",
      "created_at": "2024-04-11T11:40:16.698120",
      "service_detail": {
        "id": 3563,
        "ip": "172.25.235.2",
        "mac": "VSOL00D0FACB",
        "serial": "VSOL00D0FACB",
        "queue": "Plan_161895_30183_WispHub",
        "interface": "VLAN229_PANTIN",
        "created_at": "2024-07-09T09:59:58.835974",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3139,
      "client_name": "ALTON JOSMAR GARCIA RAMON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128957209",
      "client_email": "JOSMAR2883@GMAIL.COM",
      "address": "CALLE 1 CASA NRO 73 BARRIO PRADOS DE PAYA II ROSARIO DE PAYA II TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V16128504",
      "nap_box_name": "CTO-00301",
      "created_at": "2024-04-11T11:48:59.042982",
      "service_detail": {
        "id": 5328,
        "ip": "172.25.248.2",
        "mac": "VSOL00D0FA0F",
        "serial": "VSOL00D0FA0F",
        "queue": "queue1",
        "interface": "VLAN242_PRADOS2",
        "created_at": "2024-08-16T09:20:45.729526",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3140,
      "client_name": "LAURA VIRGINIA GUEVARA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Tibisay Guevara",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04262352640",
      "client_email": "LAURAGUEVARA800@GMAIL.COM",
      "address": "CALLE01 PARCELA 33 CASA NRO 08 SECTOR EL MACARO TIBISAY GUEVARA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V15222816",
      "nap_box_name": "CTO-00054",
      "created_at": "2024-04-11T11:53:01.327341",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3141,
      "client_name": "SABINA CARIDAD RINCONES DE ARCILES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Tibisay Guevara",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04120488485",
      "client_email": "SABINACARIDAD7@GMAIL.COM",
      "address": "CALLE NRO 1 CASA NRO 20 SECTOR EL MACARO COMUNIDAD TIBISAY GUEVARA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V8737151",
      "nap_box_name": "CTO-00054",
      "created_at": "2024-04-11T11:55:28.128459",
      "service_detail": {
        "id": 12952,
        "ip": "172.17.1.94",
        "mac": "30:C5:0F:52:C9:A6",
        "serial": "HWTCC96B62A6",
        "queue": null,
        "interface": "VLAN248_TIBISAY_OLT2",
        "created_at": "2026-09-02T11:41:49.737893",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3142,
      "client_name": "MILEYDY DEL CARMEN GUEVARA ROJO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Paya Abajo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128900992",
      "client_email": "MILEYDYG91@GMAIL.COM",
      "address": "CALLE SAN MIGUEL CASA NRO 30 SECTOR PAYA ABAJO ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V20067771",
      "nap_box_name": "CTO-00024",
      "created_at": "2024-04-11T11:59:11.749593",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3143,
      "client_name": "CANDELARIA MERCEDES BERROTERAN LIENDO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Paya Abajo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243754531",
      "client_email": "CANDELARIABERROTERAN2015@GMAIL.COM",
      "address": "CALLE SAN ANTONIO CASA NRO 87 SECTOR PAYA ABAJO ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V16690661",
      "nap_box_name": "480",
      "created_at": "2024-04-11T12:03:04.474298",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3144,
      "client_name": "NOHELYS CAROLINA CROQUER CISNERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Macarena",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04160601157",
      "client_email": "NOHELYSCROQUER99@GMAIL.COM",
      "address": "CALLE 13 CASA NRO 05 URB LA MACARENA II TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V27048048",
      "nap_box_name": "51",
      "created_at": "2024-04-11T12:13:20.281020",
      "service_detail": {
        "id": 5342,
        "ip": "172.25.229.2",
        "mac": "TPLGF9CD4668",
        "serial": "TPLGF9CD4668",
        "queue": "Plan_138775_1574_WispHub",
        "interface": "VLAN112_LA_MACARENA",
        "created_at": "2024-08-16T09:37:39.069826",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3145,
      "client_name": "GREIDY YOSEIRIS MARTINEZ HERNANDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Guanarito",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144674192",
      "client_email": "YOSEIRISMARTINEZHERNANDEZ@GMAIL.COM",
      "address": "VDA JUAN BAUTISTA LINARECASA NRO 4 SECTOR RUIZ PINEDA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V20695892",
      "nap_box_name": "CTO-00214",
      "created_at": "2024-04-11T12:25:42.476884",
      "service_detail": {
        "id": 5347,
        "ip": "172.24.254.2",
        "mac": "TPLGF9CD4673",
        "serial": "TPLGF9CD4673",
        "queue": "Plan_153953_15811_WispHub",
        "interface": "VLAN232_GUANARITO_OLT2",
        "created_at": "2024-08-16T09:52:45.455488",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3146,
      "client_name": "ERICK RAFAEL CANELON ROMERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Macarena",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128891288",
      "client_email": "ETATTOO0613@GMAIL.COM",
      "address": "CALLE 06 CASA NRO 04 BARRIO LA MACARENA TURMERO",
      "client_identification": "V196076413",
      "nap_box_name": "246",
      "created_at": "2024-04-11T12:30:24.240673",
      "service_detail": {
        "id": 10027,
        "ip": "172.23.57.2",
        "mac": "TPLGBA687C1E",
        "serial": "TPLGBA687C1E",
        "queue": null,
        "interface": "VLAN112_LA_MACARENA_ZTE",
        "created_at": "2025-11-11T15:48:22.158246",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3147,
      "client_name": "NORELAYS ALEXANDRA SILVA CHIRINOS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243635144",
      "client_email": "NOREALYS0228@GMAIL.COM",
      "address": "CALLE 5 CASA NRO 349 URB MATA CABALLO ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V28317116",
      "nap_box_name": "CTO-00179",
      "created_at": "2024-04-11T12:31:30.211752",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3148,
      "client_name": "CELIA JOSEFINA HERNANDEZ DE REQUENA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Macarena",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128972202",
      "client_email": "REQUENAHERNANDEZ7@GMAIL.COM",
      "address": "CALLE 06 CASA NRO 15 URB LA MACAREÑA II SECTOR EL MACARO",
      "client_identification": "V10751776",
      "nap_box_name": "246",
      "created_at": "2024-04-11T12:33:09.919329",
      "service_detail": {
        "id": 4771,
        "ip": "172.23.31.2",
        "mac": "TPLGBA687874",
        "serial": "TPLGBA687874",
        "queue": "Plan_137413_1574_WispHub",
        "interface": "VLAN100_OLTs",
        "created_at": "2024-08-12T15:24:16.997874",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3149,
      "client_name": "FRANCY ESTHER LINARES HERNANDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "SUSPENDIDO_RESIDENCIAL",
      "status_name": "Suspendido",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villas El Carmen",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128901242",
      "client_email": "FRANCYESTHER253@GMAIL.COM",
      "address": "CALLE 11 CASA NRO 12 URB VILLAS EL CARMEN TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V20243556",
      "nap_box_name": "40",
      "created_at": "2024-04-11T12:39:36.458233",
      "service_detail": {
        "id": 12085,
        "ip": "172.17.51.2",
        "mac": "VSOL0012D851",
        "serial": "VSOL0012D851",
        "queue": null,
        "interface": "VLAN135_VILLAS_CARMEN_OLT_ZTE",
        "created_at": "2026-03-15T19:46:05.681793",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3150,
      "client_name": "YENNIFER YAISMARA RANGEL BIGOTT",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villas El Carmen",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04122223199",
      "client_email": "YENNIRANGEL.YR@GMAIL.COM",
      "address": "AV. ARAGUA EDIF. CANAIMA PISO 10 APT. 10-B URB EL CENTRO MARACAY ARAGUA ZONA POSTAL 2104",
      "client_identification": "V17016564",
      "nap_box_name": "41",
      "created_at": "2024-04-11T12:44:59.223259",
      "service_detail": {
        "id": 3818,
        "ip": "172.23.110.2",
        "mac": "VSOL0012E1A1",
        "serial": "VSOL0012E1A1",
        "queue": "Plan_138775_1574_WispHub",
        "interface": "VLAN135_VILLAS_CARMEN_OLT_ZTE",
        "created_at": "2024-07-15T17:37:51.412422",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3151,
      "client_name": "ESTEFANI ALEJANDRA TORREALBA PARRA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243200242",
      "client_email": "ESTEFANYTORREALBA87@GMAIL.COM",
      "address": "CALLE 3 CASA NUMERO 45 SECTOR PRADOS DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V31161166",
      "nap_box_name": "CE - 288",
      "created_at": "2024-04-11T12:48:23.019567",
      "service_detail": {
        "id": 3338,
        "ip": "172.25.187.2",
        "mac": "OEMT3C620216",
        "serial": "OEMT3C620216",
        "queue": "Plan_161904_30183_WispHub",
        "interface": "VLAN242_PRADOS2",
        "created_at": "2024-07-02T15:23:30.892070",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3152,
      "client_name": "NELLY CECILIA AVILA SILVA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Paya Abajo",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04128259127",
      "client_email": "AVILANELLY835@GMAIL.COM",
      "address": "CALLE SAN ANTONIO CASA NRO 4 SECTOR PAYA ABAJO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V9430880",
      "nap_box_name": "272",
      "created_at": "2024-04-11T12:53:46.337588",
      "service_detail": {
        "id": 7447,
        "ip": "172.25.17.2",
        "mac": "TPLGF9CD45F5",
        "serial": "TPLGF9CD45F5",
        "queue": "Plan_161870_30181_WispHub",
        "interface": "VLAN231_PAYABAJO",
        "created_at": "2024-12-16T15:11:59.979649",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3153,
      "client_name": "MARY ALCIRA CASTILLO GONZALES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Durpa",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243570816",
      "client_email": "MC6114662@GMAIL.COM",
      "address": "CALLE LAS COLINAS MANZANA 19 CASA NRO 07 URB DURPA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V11662556",
      "nap_box_name": "352",
      "created_at": "2024-04-11T12:56:20.089625",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3154,
      "client_name": "KEVIN HAROLDO IZQUIEL",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243158677",
      "client_email": "KEVINIZQUIEL@GMAIL.COM",
      "address": "AV INTERCOMUNAL TURMERO LA CASONA 1 CALLE 9 CASA 53 ZONA POSTAL 2115",
      "client_identification": "V207719940",
      "nap_box_name": "408",
      "created_at": "2024-04-11T12:56:48.677993",
      "service_detail": {
        "id": 3910,
        "ip": "172.30.62.2",
        "mac": "TPLGF9CD3C46",
        "serial": "TPLGF9CD3C46",
        "queue": "Plan_131647_24341_WispHub",
        "interface": "VLAN109_CASONA_1",
        "created_at": "2024-07-16T19:52:32.126615",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3155,
      "client_name": "DANIELA AUDALYS PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128591585",
      "client_email": "DANIELA.SECRE17@GMAIL.COM",
      "address": "CALL1 CASA NRO 57 SECTOR PRADOS DE PAYA II TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V17015293",
      "nap_box_name": "CTO-00301",
      "created_at": "2024-04-11T12:59:34.494341",
      "service_detail": {
        "id": 6414,
        "ip": "172.26.1.2",
        "mac": "VSOL00D108E7",
        "serial": "VSOL00D108E7",
        "queue": "Plan_161903_30183_WispHub",
        "interface": "VLAN242_PRADOS2",
        "created_at": "2024-08-27T16:54:04.201112",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3156,
      "client_name": "PAULO JESUS OVIEDO LARA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "San Sebastian",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121486060",
      "client_email": "PAULO.26679792@GMAIL.COM",
      "address": "CALLE 5 CASA NRO 31 BARRIO SAN SEBASTIAN EL MACARO",
      "client_identification": "V26679792",
      "nap_box_name": "127",
      "created_at": "2024-04-11T13:02:27.803500",
      "service_detail": {
        "id": 3911,
        "ip": "172.25.62.2",
        "mac": "TPLGF9CD47C2",
        "serial": "TPLGF9CD47C2",
        "queue": "Plan_129887_1574_WispHub",
        "interface": "VLAN125_SAN_SEBASTIAN_ZTE",
        "created_at": "2024-07-16T19:55:13.237636",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3157,
      "client_name": "JENNY LISSETTE GONZALEZ DE SILVA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Macarena",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04123496033",
      "client_email": "JENNY.LISSETE.GONZALEZ29@GMAIL.COM",
      "address": "CALLE 5 CASA NRO 19 URB LA MACARENA II SAMAN DE GUERE TURMERO",
      "client_identification": "V9645987",
      "nap_box_name": "33",
      "created_at": "2024-04-11T13:03:19.426914",
      "service_detail": {
        "id": 3324,
        "ip": "172.22.70.2",
        "mac": "TPLGB68B5042",
        "serial": "TPLGB68B5042",
        "queue": "Plan_138775_1574_WispHub",
        "interface": "VLAN100_OLTs",
        "created_at": "2024-07-02T12:38:03.582507",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3158,
      "client_name": "MARIANA MARCELO BRACHO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243446621",
      "client_email": "MARIANAMACEROLA@GMAIL.COM",
      "address": "CALLE 12 NRO 669-A SECTOR MATA CABALLO TURMERO EDO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V14683473",
      "nap_box_name": "CTO-00433",
      "created_at": "2024-04-11T13:03:20.962062",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3160,
      "client_name": "CARMEN RAMONA ANGEL DE RAMIREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Los Hornos",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04120437999",
      "client_email": "CARMENANGEL1958@GMAIL.COM",
      "address": "CALLE CALLEJON LOS MANGOS CASA NRO 15 SECTOR LOS HORNOS DE PAYA ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V4823700",
      "nap_box_name": "437",
      "created_at": "2024-04-11T13:07:50.204164",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3161,
      "client_name": "ANA CECILIA MINDINEROS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04241718383",
      "client_email": "ANACECILIAMINDINEROS0@GMAIL.COM",
      "address": "AV INTERCOMUNAL TURMERO LA CASONA I CALLE 9C",
      "client_identification": "E82072254",
      "nap_box_name": "449",
      "created_at": "2024-04-11T13:07:51.388867",
      "service_detail": {
        "id": 5454,
        "ip": "172.25.48.2",
        "mac": "TPLGF9CD46CA",
        "serial": "TPLGF9CD46CA",
        "queue": "Plan_131337_24341_WispHub",
        "interface": "VLAN109_CASONA_1",
        "created_at": "2024-08-16T16:41:42.463759",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3162,
      "client_name": "LEDYS ELENA SOCARRAZ MOLINA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243280599",
      "client_email": "LEDYSOCARRAZ@GMAIL.COM",
      "address": "CALLE 5 CASA NRO 369 URB MATA CABALLO ROSARIO DE PAYA ARGUA ZONA POSTAL 2115",
      "client_identification": "V24172272",
      "nap_box_name": "CTO-00180",
      "created_at": "2024-04-11T13:10:15.706113",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3163,
      "client_name": "YRIS ONEY TOVAR CARVAJAL",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124402424",
      "client_email": "ELVYSLIAS@GMAIL.COM",
      "address": "CALLE 08 CASA NRO 64 URB LA CASONA 1",
      "client_identification": "V96806228",
      "nap_box_name": "450",
      "created_at": "2024-04-11T13:11:47.930920",
      "service_detail": {
        "id": 3389,
        "ip": "172.25.44.2",
        "mac": "TPLGF9CD4637",
        "serial": "TPLGF9CD4637",
        "queue": "Plan_131647_24341_WispHub",
        "interface": "VLAN109_CASONA_1",
        "created_at": "2024-07-03T08:18:38.964188",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3164,
      "client_name": "DANY MARIA VERENZUELA CAMPOS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243594159",
      "client_email": "JT143836@GMAIL.COM",
      "address": "CALLE 3 CASA 166 SECTOR MATA CABALLO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V9687679",
      "nap_box_name": "CTO-00309",
      "created_at": "2024-04-11T13:13:15.810052",
      "service_detail": {
        "id": 12750,
        "ip": "172.25.241.2",
        "mac": "TP:LG:1B:B3:64:B5",
        "serial": "TPLG1BB364B5",
        "queue": null,
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2026-07-17T16:53:14.119734",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3165,
      "client_name": "RAUL AUGUSTO PIMENTEL FERNANDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04241690462",
      "client_email": "COLMENARESMILAGROS550@GMAIL.COM",
      "address": "ROSARIO DE PAYA URB PANTIN C/15 A#02 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V15160320",
      "nap_box_name": "CTO-00201",
      "created_at": "2024-04-11T13:16:29.074527",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3166,
      "client_name": "MARTIN TOMAS DE TOVAR DE LA FUENTE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ppal Paya",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128978494",
      "client_email": "ANOTAHAY@GMAIL.COM",
      "address": "CTRA TURMERO ROSARIO DE PAYA LOCAL MAZINI NRO 3 URB HACIENDA DE PAYA ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL",
      "client_identification": "V16691690",
      "nap_box_name": "117",
      "created_at": "2024-04-11T13:17:47.903867",
      "service_detail": {
        "id": 6448,
        "ip": "172.24.250.2",
        "mac": "TPLGF9CD4790",
        "serial": "TPLGF9CD4790",
        "queue": "Plan_129889_15811_WispHub",
        "interface": "VLAN202_AHP_OLT1",
        "created_at": "2024-08-29T08:37:34.504708",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3167,
      "client_name": "YOIRIS COROMOTO SILVA PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144598200",
      "client_email": "YOIRISSILVA34@GMAIL.COM",
      "address": "CALLE 3B CASA NRO 29 URB PANTIN ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V14809134",
      "nap_box_name": "CE-00043",
      "created_at": "2024-04-11T13:19:14.272228",
      "service_detail": {
        "id": 5461,
        "ip": "172.25.234.2",
        "mac": "VSOL00D10A03",
        "serial": "VSOL00D10A03",
        "queue": "Plan_161901_30183_WispHub",
        "interface": "VLAN229_PANTIN",
        "created_at": "2024-08-16T16:58:30.981443",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3168,
      "client_name": "MARTIN TOMAS DE TOVAR DE LA FUENTE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Antigua Hacienda De Paya",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128978494",
      "client_email": "ANOTAHAY@GMAIL.COM",
      "address": "CALLE MOLINA NRO 19 LOTE 3 ANTIGUA HACIENDA DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V16691690",
      "nap_box_name": "223",
      "created_at": "2024-04-11T13:19:56.877567",
      "service_detail": {
        "id": 6447,
        "ip": "172.28.156.2",
        "mac": "HWTC188373A1",
        "serial": "HWTC188373A1",
        "queue": "Plan_153953_15811_WispHub",
        "interface": "VLAN202_AHP_OLT1",
        "created_at": "2024-08-29T08:35:08.876117",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3169,
      "client_name": "MARILIN ALEXANDRA ALFARO MARQUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Macarena",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128447305",
      "client_email": "jesus-alfaro1@hotmail.com",
      "address": "CALLE 5 CASA NRO 5 URB LA MACARENA II TURMERO",
      "client_identification": "V23520515",
      "nap_box_name": "33",
      "created_at": "2024-04-11T13:21:09.032753",
      "service_detail": {
        "id": 12650,
        "ip": "172.21.201.2",
        "mac": "TP:LG:B6:8B:4F:32",
        "serial": "TPLGB68B4F32",
        "queue": null,
        "interface": "VLAN112_LA_MACARENA_ZTE",
        "created_at": "2026-07-01T19:57:26.534852",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3170,
      "client_name": "MIGDALIA JOSEFINA ORTEGA HERNANDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121781877",
      "client_email": "ORTEGAMIGDALIA6@GMAIL.COM",
      "address": "CALLE 14-B CASA NRO 40 URB PANTIN ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V9817826",
      "nap_box_name": "CTO-00052",
      "created_at": "2024-04-11T13:21:28.824559",
      "service_detail": {
        "id": 3548,
        "ip": "172.25.240.2",
        "mac": "VSOL00D0F53F",
        "serial": "VSOL00D0F53F",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN229_PANTIN",
        "created_at": "2024-07-08T18:03:52.423664",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3171,
      "client_name": "ISBELIA COROMOTO CASTILLO PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128906357",
      "client_email": "ISABELITACOROMOTOCASTILLOPEREZ@GMAIL.COM",
      "address": "CALLE 5 A CASA NRO 7 URB PANTIN ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V13695378",
      "nap_box_name": "CTO-00135",
      "created_at": "2024-04-11T13:23:59.605215",
      "service_detail": {
        "id": 3913,
        "ip": "172.25.33.2",
        "mac": "TPLGF9CD472C",
        "serial": "TPLGF9CD472C",
        "queue": "Plan_161904_30183_WispHub",
        "interface": "VLAN229_PANTIN",
        "created_at": "2024-07-16T19:59:09.198935",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3172,
      "client_name": "HENRY MORENO CLAVIJO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Macarena",
      "plan": {
        "id": 43,
        "name": "RECURRENTE RESIDENCIAL PLAN 650M",
        "cost": "46.00",
        "code": "FOR650M",
        "profile": "650M/650M"
      },
      "client_mobile": "04127567524",
      "client_email": "HENRYMORENO83.338.038@GMAIL.COM",
      "address": "CALLE 8 CASA NRO 4 SECTOR EL MACARO LA MACARENA II TURMERO",
      "client_identification": "E83338038",
      "nap_box_name": "668",
      "created_at": "2024-04-11T13:24:56.383981",
      "service_detail": {
        "id": 3436,
        "ip": "172.20.246.2",
        "mac": "TPLGB954EFFD",
        "serial": "TPLGB954EFFD",
        "queue": "Plan_144395_1574_WispHub",
        "interface": "VLAN112_LA_MACARENA",
        "created_at": "2024-07-04T12:36:39.779401",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3173,
      "client_name": "YESSICA JOSEFINA GONZALEZ CASTILLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243642921",
      "client_email": "YESSICAGONZALEZ395@GMAIL.COM",
      "address": "CALLE 1-B CASA NRO 17 URB HACIENDA PANTIN ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V19698791",
      "nap_box_name": "CTO-00127",
      "created_at": "2024-04-11T13:25:16.854043",
      "service_detail": {
        "id": 5462,
        "ip": "172.30.37.2",
        "mac": "VSOL00D10DB7",
        "serial": "VSOL00D10DB7",
        "queue": "queue1",
        "interface": "VLAN229_PANTIN",
        "created_at": "2024-08-16T17:00:31.991790",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3174,
      "client_name": "LUIS ALFREDO BRAVO MENDOZA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04123983363",
      "client_email": "ZBRAVO193@GMAIL.COM",
      "address": "CALLE 14A CASA NRO 29 URB PANTIN ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V185971933",
      "nap_box_name": "CTO-00169",
      "created_at": "2024-04-11T13:27:20.421782",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3175,
      "client_name": "ORLANDO JOSE BEJARANO PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Macarena",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04169442682",
      "client_email": "OBP1992@GMAIL.COM",
      "address": "CALLE PRINCIPAL CASA NRO 03 URB LA MACAREÑA SECTOR EL MACARO TURMERO",
      "client_identification": "V20897493",
      "nap_box_name": "300",
      "created_at": "2024-04-11T13:27:29.026296",
      "service_detail": {
        "id": 3544,
        "ip": "172.20.133.2",
        "mac": "TPLGB954F789",
        "serial": "TPLGB954F789",
        "queue": "Plan_138775_1574_WispHub",
        "interface": "VLAN100_OLTs",
        "created_at": "2024-07-08T17:44:01.104671",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3176,
      "client_name": "HERMER YOEL GUTIERREZ BRICEÑO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124247523",
      "client_email": "HERMERGUTIERREZ@GMAIL.COM",
      "address": "AV PRINCIPAL DE PAYA CASA  CALLE 20 NRO 02 URB PANTIN ROSARIO DE PAYA",
      "client_identification": "V17969774",
      "nap_box_name": "CTO-00435",
      "created_at": "2024-04-11T13:29:03.815222",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3177,
      "client_name": "MIRTHA EMILIA ZAMBRANO SIMOSA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Macarena",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04124784927",
      "client_email": "MIRTHA.SIMOSA@GMAIL.COM",
      "address": "CALLE 11 CASA NRO 22 URB LA MACARENA II SECTOR EL MACARO TURMERO",
      "client_identification": "V14038635",
      "nap_box_name": "80 DOS",
      "created_at": "2024-04-11T13:30:36.055951",
      "service_detail": {
        "id": 3357,
        "ip": "172.19.109.2",
        "mac": "TPLGB954FB61",
        "serial": "TPLGB954FB61",
        "queue": "Plan_127983_1574_WispHub",
        "interface": "VLAN112_LA_MACARENA_ZTE",
        "created_at": "2024-07-02T16:36:03.111467",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3178,
      "client_name": "MEYBIS CLARET CHAVEZ ESQUEDA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121598364",
      "client_email": "DOCTORACHAVEZSHALOM@GMAIL.COM",
      "address": "CALLE 14-B CASA NRO 49 URB PANTIN",
      "client_identification": "V12564071",
      "nap_box_name": "CTO-00052",
      "created_at": "2024-04-11T13:32:30.462226",
      "service_detail": {
        "id": 5464,
        "ip": "172.18.56.2",
        "mac": "VSOL0051FDD9",
        "serial": "VSOL0051FDD9",
        "queue": "Plan_161905_30183_WispHub",
        "interface": "VLAN229_PANTIN",
        "created_at": "2024-08-16T17:04:14.293724",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3179,
      "client_name": "ROSI YBETT ALEJANDRA ALDANA DIAZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Macarena",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124502472",
      "client_email": "Rosialdana75@gmail.com",
      "address": "CALLE 12 CASA NRO 21 SECTOR LA MACARENA EL MACARO TURMERO",
      "client_identification": "V14903751",
      "nap_box_name": "51",
      "created_at": "2024-04-11T13:33:27.579721",
      "service_detail": {
        "id": 12992,
        "ip": "172.19.95.2",
        "mac": "HW:TC:70:1A:AE:9B",
        "serial": "HWTC701AAE9B",
        "queue": null,
        "interface": "VLAN112_LA_MACARENA_ZTE",
        "created_at": "2026-09-07T14:54:08.499859",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3180,
      "client_name": "MARIA ELENEA FERMIN PIÑERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243478745",
      "client_email": "FERMINMARIA537@GMAIL.COM",
      "address": "AV PRINCIPAL CASA NRO 685-C URB MATA CABALLO ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V12928645",
      "nap_box_name": "CTO-00210",
      "created_at": "2024-04-11T13:33:39.222025",
      "service_detail": {
        "id": 3906,
        "ip": "172.25.57.2",
        "mac": "TPLGF9CD45B9",
        "serial": "TPLGF9CD45B9",
        "queue": "Plan_161903_30183_WispHub",
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2024-07-16T18:46:47.876798",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3181,
      "client_name": "CARLOS EDUARDO GUZMAN VENOT",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "PAUSADO_RESIDENCIAL",
      "status_name": "Pausado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Plaza Jardin",
      "plan": {
        "id": 19,
        "name": "RECURRENTE RESIDENCIAL PLAN 1GB",
        "cost": "74.70",
        "code": "FOR1GB",
        "profile": "1000M/1000M"
      },
      "client_mobile": "04241813398",
      "client_email": "YOSELYN_2007_MX@GMAIL.COM",
      "address": "URB PLAZA JARDIN SECTOR LA JULIA CASA II TURMERO",
      "client_identification": "V17570976",
      "nap_box_name": "439",
      "created_at": "2024-04-11T13:36:45.474795",
      "service_detail": {
        "id": 10459,
        "ip": "172.23.100.2",
        "mac": "HWTC49200356",
        "serial": "HWTC49200356",
        "queue": null,
        "interface": "VLAN141_PLAZA_JARDIN",
        "created_at": "2025-12-02T11:03:06.077445",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3182,
      "client_name": "MANUEL ENRIQUE PEREZ ENCIZO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243963633",
      "client_email": "ENRIQUEENCIZO94@GMAIL.COM",
      "address": "CALLE 6-A CASA NRO 19 SECTOR PANTI ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V229567922",
      "nap_box_name": "CTO-0013B",
      "created_at": "2024-04-11T13:37:13.091206",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3183,
      "client_name": "MARISELE PALMERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Macarena",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04127409256",
      "client_email": "PALMERAMARISEL718@GMAIL.COM",
      "address": "CALLE 3 CASA N19 LA MACARENA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V12572356",
      "nap_box_name": "669",
      "created_at": "2024-04-11T13:38:19.974320",
      "service_detail": {
        "id": 3901,
        "ip": "172.19.52.2",
        "mac": "TPLGF5CB02E0",
        "serial": "TPLGF5CB02E0",
        "queue": "Plan_127996_1574_WispHub",
        "interface": "VLAN112_LA_MACARENA",
        "created_at": "2024-07-16T18:32:55.070846",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3184,
      "client_name": "PABLO ENRIQUE BETANCOURT LARRATE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Palmeras II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128961795",
      "client_email": "PABLOEBETANCOURT@GMAIL.COM",
      "address": "AV INTERCOMUNAL TURMERO-MARACAY CASA TERRAZA E NRO 91 URB LAS PALMERAS II TURMERO ARAGUA",
      "client_identification": "V13272980",
      "nap_box_name": "288",
      "created_at": "2024-04-11T13:39:20.100447",
      "service_detail": {
        "id": 9917,
        "ip": "172.18.42.2",
        "mac": "TPLG2ABDC814",
        "serial": "TPLG2ABDC814",
        "queue": null,
        "interface": "VLAN119_PALMERAS_2",
        "created_at": "2025-11-10T23:53:38.965695",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3185,
      "client_name": "MARIANNY DEL CARMEN TERAN  VARGAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Macarena",
      "plan": {
        "id": 16,
        "name": "RECURRENTE RESIDENCIAL PLAN 800M",
        "cost": "55.00",
        "code": "FOR800",
        "profile": "800M/800M"
      },
      "client_mobile": "04243551765",
      "client_email": "ADRIANNYS1808@GMAIL.COM",
      "address": "CALLE 8 CASA NRO 21 URB LA MACARENA II TURMERO ARAGUA",
      "client_identification": "V21204220",
      "nap_box_name": "671",
      "created_at": "2024-04-11T13:42:27.944613",
      "service_detail": {
        "id": 11224,
        "ip": "172.18.200.2",
        "mac": "TPLGB954EC64",
        "serial": "TPLGB954EC64",
        "queue": null,
        "interface": "VLAN112_LA_MACARENA_ZTE",
        "created_at": "2026-01-19T09:46:02.526281",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3186,
      "client_name": "ISMAEL ALEXANDER DIAZ ALONZO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04120368279",
      "client_email": "ISMAELDIAZALONZO@GMAIL.COM",
      "address": "CALLE 12 CASA NRO 43 LA CASONA II TURMERO",
      "client_identification": "V16725729",
      "nap_box_name": "CTO-00093",
      "created_at": "2024-04-11T13:42:38.929591",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3187,
      "client_name": "KARIM JOHANA LARTIGUEZ BALCAZAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Macarena",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04129977068",
      "client_email": "tributaria380@gmail.com",
      "address": "CALLE 12 CASA NRO 17 URB LA MACARENA II CALLE 12 NRO 17 SECTOR TURMERO EL MACARO TURMERO",
      "client_identification": "V16552731",
      "nap_box_name": "51",
      "created_at": "2024-04-11T13:45:04.730072",
      "service_detail": {
        "id": 3776,
        "ip": "172.30.213.2",
        "mac": "TPLG2ABDC6D7",
        "serial": "TPLG2ABDC6D7",
        "queue": "Plan_137413_1574_WispHub",
        "interface": "VLAN112_LA_MACARENA",
        "created_at": "2024-07-13T12:00:27.450432",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3188,
      "client_name": "DARIANNYS CECILIA JIMENEZ HERNANDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Bicentenario",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04123988991",
      "client_email": "DARIANNYSJIMENEZ78@GMAIL.COM",
      "address": "CALLE MANZANA 10 CASA NRO 03 P-A SECTOR DESARROLLO URBANISTICO ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V311170224",
      "nap_box_name": "CTO-00446",
      "created_at": "2024-04-11T13:46:21.128628",
      "service_detail": {
        "id": 3302,
        "ip": "172.25.118.2",
        "mac": "TPLGF9CD46AD",
        "serial": "TPLGF9CD46AD",
        "queue": "Plan_161903_30183_WispHub",
        "interface": "VLAN243_BICENTENARIO",
        "created_at": "2024-07-01T15:36:45.921512",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3190,
      "client_name": "BARBARA VANESSA FLAMES MONZON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Macarena",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144696239",
      "client_email": "GERSONFLAMES67@GMAIL.COM",
      "address": "CALLE 4 CASA NRO 07 SECTOR EL MACARO TURMERO",
      "client_identification": "V26302383",
      "nap_box_name": "33",
      "created_at": "2024-04-11T13:47:46.248032",
      "service_detail": {
        "id": 3270,
        "ip": "172.25.157.2",
        "mac": "TPLGB8628517",
        "serial": "TPLGB8628517",
        "queue": "Plan_92034_1574_WispHub",
        "interface": "VLAN112_LA_MACARENA",
        "created_at": "2024-07-01T09:51:06.089359",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3191,
      "client_name": "ABRAHAM SAMUEL OROPEZA PALMA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144471419",
      "client_email": "ABRAHAMOROPEZA77@GMAIL.COM",
      "address": "CALLE 13A CASA NRO 13 URB PANTIN ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V25501664",
      "nap_box_name": "CTO-00170",
      "created_at": "2024-04-11T13:49:29.125575",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3192,
      "client_name": "HARRIET HELENA RAVELO PIÑERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144654215",
      "client_email": "RAVELOHARRIET@GMAIL.COM",
      "address": "VEREDA 11 MANZANA D-12 CASA NRO 15 SECTOR SAMAN TARAZONERO II TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V18475830",
      "nap_box_name": "265",
      "created_at": "2024-04-11T13:49:50.882420",
      "service_detail": {
        "id": 6382,
        "ip": "172.26.198.2",
        "mac": "HWTCC10D569C",
        "serial": "HWTCC10D569C",
        "queue": "Plan_127996_1574_WispHub",
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2024-08-27T13:42:42.528663",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3193,
      "client_name": "JOSE RAFAEL RUIZ PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04127768038",
      "client_email": "RUIZPEREZJOSE00@GMAIL.COM",
      "address": "CALLE 21 CASA NRO 16 BARRIO ROSARIO DE PAYA SECTOR RIO SECO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V17575931",
      "nap_box_name": "603 DOS",
      "created_at": "2024-04-11T13:52:21.985091",
      "service_detail": {
        "id": 5469,
        "ip": "172.26.209.2",
        "mac": "HWTC905D049B",
        "serial": "HWTC905D049B",
        "queue": "queue1",
        "interface": "VLAN251_RIO_SECO",
        "created_at": "2024-08-16T17:10:06.559131",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3194,
      "client_name": "NANCY YAMILETH SILVA  DE DIAZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Paraiso",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04129703329",
      "client_email": "YAMILESILVA00@GMAIL.COM",
      "address": "CR EL MACARO  CASA NRO 04 URB EL PARAISO TURMERO",
      "client_identification": "V12415541",
      "nap_box_name": "346",
      "created_at": "2024-04-11T13:55:14.388729",
      "service_detail": {
        "id": 5471,
        "ip": "172.22.241.2",
        "mac": "TPLGBA687ACE",
        "serial": "TPLGBA687ACE",
        "queue": "Plan_127996_1574_WispHub",
        "interface": "VLAN105_EL_PARAISO_OLT_ZTE",
        "created_at": "2024-08-16T17:12:47.849491",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3196,
      "client_name": "JORGE EDUARDO ORTEGA PARRA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124335503",
      "client_email": "MARCOOR06TE03GA07@GMAIL.COM",
      "address": "CALLE 05 CASA NRO 359 SECTOR MATA CABALLO ROSARIO DE PAYA TURMERO ARAGUA",
      "client_identification": "V12145009",
      "nap_box_name": "CTO-00180",
      "created_at": "2024-04-11T13:59:40.318146",
      "service_detail": {
        "id": 3490,
        "ip": "172.28.31.2",
        "mac": "TPLGF9CD4717",
        "serial": "TPLGF9CD4717",
        "queue": "Plan_161904_30183_WispHub",
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2024-07-05T17:04:18.084336",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3197,
      "client_name": "GENESIS ALEJANDRA RIVAS GUERRERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villas El Carmen",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243091918",
      "client_email": "GYGDETALLES@GMAIL.COM",
      "address": "CALLE 2 CASA NRO. 18 CONJUNTO RESIDENCIAL VILLAS DEL CARMEN TURMERO ARAGUA ZONA POSTAL 2107",
      "client_identification": "V22954684",
      "nap_box_name": "50",
      "created_at": "2024-04-11T14:04:18.281978",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3198,
      "client_name": "ALFREDO JOSE CALDERA FARRERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04162413601",
      "client_email": "CALDERAPAREDES10@GMAIL.COM",
      "address": "AV INTERCOMUNAL TURMERO LA CASONA 1 CALLE 7 CASA NRO21 ZONA POSTAL 2115",
      "client_identification": "V272868952",
      "nap_box_name": "410",
      "created_at": "2024-04-11T14:07:26.316299",
      "service_detail": {
        "id": 3934,
        "ip": "172.25.49.2",
        "mac": "TPLGF9CD479A",
        "serial": "TPLGF9CD479A",
        "queue": "Plan_131337_24341_WispHub",
        "interface": "VLAN109_CASONA_1",
        "created_at": "2024-07-17T11:36:09.894336",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3199,
      "client_name": "ANNERYS ESTHER FIGUEROA PINEDA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villas El Carmen",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04140495769",
      "client_email": "ANNERYSFIGUEROA54@HOTMAIL.COM",
      "address": "CALLE 3 CASA  NRO. 13  URB. VILLAS EL CARMEN,  TURMERO, EDO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V14039729",
      "nap_box_name": "49",
      "created_at": "2024-04-11T14:07:55.046573",
      "service_detail": {
        "id": 3170,
        "ip": "172.22.95.2",
        "mac": "TPLGBA688250",
        "serial": "TPLGBA688250",
        "queue": "Plan_157310_1574_WispHub",
        "interface": "VLAN135_VILLAS_CARMEN",
        "created_at": "2024-06-27T16:22:21.967752",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3200,
      "client_name": "NANCY COROMOTO RODRIGUEZ CALANCHE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243130670",
      "client_email": "MARIAEMILIAMEJIAS11@GMAIL.COM",
      "address": "AV INTERCOMUNAL TURMERO LA CASONA 1 CALLE 7 CASA 26 ZONA POSTAL 2115",
      "client_identification": "V10867889",
      "nap_box_name": "411",
      "created_at": "2024-04-11T14:10:01.665942",
      "service_detail": {
        "id": 6449,
        "ip": "172.25.60.2",
        "mac": "TPLGF9CD46DC",
        "serial": "TPLGF9CD46DC",
        "queue": "Plan_131337_24341_WispHub",
        "interface": "VLAN109_CASONA_1",
        "created_at": "2024-08-29T08:40:34.288176",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3201,
      "client_name": "YAICE ELENA GUEVARA MARTINEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villas El Carmen",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243452270",
      "client_email": "YAICEG@HOTMAIL.COM",
      "address": "CALLE PRINCIPAL EDIF. CHIRIMOLLA PISO 3 APT 13 URB.  VILLAS DEL CARMEN TURMERO EDO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V15490135",
      "nap_box_name": "43",
      "created_at": "2024-04-11T14:10:50.986840",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3202,
      "client_name": "JOSE  RICARDO MORALES PRADA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Antigua Hacienda De Paya II",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04144565110",
      "client_email": "JOSEMORALES0906@GMAIL.COM",
      "address": "CALLE EL BOSQUE CASA NRO 006 URB ANTIGUA HACIENDA DE PAYA",
      "client_identification": "V6370090",
      "nap_box_name": "220",
      "created_at": "2024-04-11T14:11:57.454486",
      "service_detail": {
        "id": 3393,
        "ip": "172.22.125.2",
        "mac": "TPLGBA688022",
        "serial": "TPLGBA688022",
        "queue": "Plan_140304_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-07-03T08:48:43.660687",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3203,
      "client_name": "ALAIXA DEL VALLE BALTHAZAR FORT",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villas El Carmen",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124551819",
      "client_email": "ALAIXA7@GMAIL.COM",
      "address": "CALLE 8 CASA NRO 5 URB VILLAS EL CARMEN TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V5997734",
      "nap_box_name": "41",
      "created_at": "2024-04-11T14:14:07.845881",
      "service_detail": {
        "id": 3486,
        "ip": "172.21.238.2",
        "mac": "TPLGB68B4F70",
        "serial": "TPLGB68B4F70",
        "queue": "Plan_137413_1574_WispHub",
        "interface": "VLAN135_VILLAS_CARMEN",
        "created_at": "2024-07-05T13:48:48.742621",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3204,
      "client_name": "MARY CARMEN VASQUEZ  CHAVEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243147481",
      "client_email": "ESTUDIOCORREO27@GMAIL.COM",
      "address": "CALLE 4 CASA NRO 211 SECTOR MATA CABALLO ROSARIO DE PAYA",
      "client_identification": "V26535531",
      "nap_box_name": "CTO-00028",
      "created_at": "2024-04-11T14:15:07.353922",
      "service_detail": {
        "id": 5474,
        "ip": "172.21.172.2",
        "mac": "TPLGB68B5A63",
        "serial": "TPLGB68B5A63",
        "queue": "queue1",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-08-16T17:21:18.463049",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3205,
      "client_name": "ANA VICTORIA CHAVERO GODOY",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villas El Carmen",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04121482735",
      "client_email": "DAVIDMENDEZ439@GMAIL.COM",
      "address": "CALLE 9 CASA NRO 2-A URB VILLAS EL CARMEN TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V9669432",
      "nap_box_name": "41",
      "created_at": "2024-04-11T14:17:13.175397",
      "service_detail": {
        "id": 3821,
        "ip": "172.21.236.2",
        "mac": "TPLGB68B5164",
        "serial": "TPLGB68B5164",
        "queue": "Plan_138775_1574_WispHub",
        "interface": "VLAN135_VILLAS_CARMEN",
        "created_at": "2024-07-15T17:52:27.594021",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3206,
      "client_name": "EDITH ANDREINA PERDOMO CONTRERAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Canaima",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124608540",
      "client_email": "PERDOMOCONTRERASEDITHANDREINA@GMAIL.COM",
      "address": "CALLE 03 CASA 36 URB CANAIMA ROSARIO DE PAYA",
      "client_identification": "V18852999",
      "nap_box_name": "CTO-00058",
      "created_at": "2024-04-11T14:18:07.009845",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3207,
      "client_name": "OSMAR JOEL GUDINO SOTO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villas El Carmen",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04126814938",
      "client_email": "OSMARGUDINOSOTO@GMAIL.COM",
      "address": "CALLE 9 CASA NRO 15 URB VILLAS EL CARMEN TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V13201209",
      "nap_box_name": "41",
      "created_at": "2024-04-11T14:21:28.338944",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3208,
      "client_name": "JENNI YANIRES MARIN PALMA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04125208866",
      "client_email": "JENNIMP35@GMAIL.COM",
      "address": "CALLE 2 CASA NRO 482 MATA CABALLO ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V12569750",
      "nap_box_name": "CTO-00178",
      "created_at": "2024-04-11T14:23:27.145912",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3209,
      "client_name": "AIXA DUBRASKA SALAZAR ANGULO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villas El Carmen",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04249319166",
      "client_email": "BALUANDE991@GMAIL.COM",
      "address": "CALLE 8 CASA NRO 09 URB VILLAS EL CARMEN SECTOR EL MACARO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V16406604",
      "nap_box_name": "41",
      "created_at": "2024-04-11T14:25:02.171440",
      "service_detail": {
        "id": 3822,
        "ip": "172.21.82.2",
        "mac": "TPLGB954ED5C",
        "serial": "TPLGB954ED5C",
        "queue": "Plan_127996_1574_WispHub",
        "interface": "VLAN135_VILLAS_CARMEN",
        "created_at": "2024-07-15T17:56:37.848013",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3210,
      "client_name": "ISAAC JESUS CROQUER SELGA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villas El Carmen",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243349091",
      "client_email": "ISAAC.CROQUE@GMAIL.COM",
      "address": "CALLE 7 CASA NRO 16 URB. VILLAS EL CARMEN , SECTOR EL MACARO, TURMERO, EDO. ARAGUA ZONA POSTAL 2115",
      "client_identification": "V72449602",
      "nap_box_name": "41",
      "created_at": "2024-04-11T14:28:15.419882",
      "service_detail": {
        "id": 3823,
        "ip": "172.21.54.2",
        "mac": "TPLGB954E7BF",
        "serial": "TPLGB954E7BF",
        "queue": "Plan_127996_1574_WispHub",
        "interface": "VLAN135_VILLAS_CARMEN",
        "created_at": "2024-07-15T17:59:36.841254",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3211,
      "client_name": "SANDRA CAROLINA ESTEILA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Durpa",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04140387745",
      "client_email": "ESTEILA.4566@GMAIL.COM",
      "address": "CALLE SIMON RODRIGUEZ CON HENRY PITTIER MANZANA 15 CASA NRO 12 URB DESARROLLO URBANISTICO DURPA",
      "client_identification": "V15747457",
      "nap_box_name": "382",
      "created_at": "2024-04-11T14:29:28.458569",
      "service_detail": {
        "id": 5477,
        "ip": "172.18.62.2",
        "mac": "VSOL00523B61",
        "serial": "VSOL00523B61",
        "queue": "Plan_161906_30183_WispHub",
        "interface": "VLAN240_DURPA",
        "created_at": "2024-08-16T17:27:22.517561",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3212,
      "client_name": "ROANNYS GABRIELA BLANCO HENRIQUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona I",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128315353",
      "client_email": "GABYBLANCO0623@GMAIL.COM",
      "address": "CALLE 7 CASA NRO 01 URB LA CASONA 1 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V30327829",
      "nap_box_name": "410",
      "created_at": "2024-04-11T14:30:57.256280",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3213,
      "client_name": "FELIX JOSE PACHECO LANDA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "SUSPENDIDO_RESIDENCIAL",
      "status_name": "Suspendido",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Macarena",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04149446686",
      "client_email": "felixxpacheco03@gmail.com",
      "address": "CALLE 12 CASA NRO 24 URB LA MACARENA SECTOR EL MACARO TURMERO ESTADO ARAGUA",
      "client_identification": "V27048954",
      "nap_box_name": "51",
      "created_at": "2024-04-11T14:32:37.668350",
      "service_detail": {
        "id": 3905,
        "ip": "172.18.254.2",
        "mac": "TPLGB954FCEE",
        "serial": "TPLGB954FCEE",
        "queue": "Plan_92034_1574_WispHub",
        "interface": "VLAN112_LA_MACARENA",
        "created_at": "2024-07-16T18:42:56.198608",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3214,
      "client_name": "MARIA FERNANDA TORREALBA MARIN",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villas El Carmen",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04127766333",
      "client_email": "PUPY1303@GMAIL.COM",
      "address": "CALLE 10 CASA NRO 17 URB VILLAS EL CARMEN TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V23802032",
      "nap_box_name": "40 DOS",
      "created_at": "2024-04-11T14:34:13.770615",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3215,
      "client_name": "YSMELDY MARIA APOSTOL VASQUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Magdalena",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243269240",
      "client_email": "YSMELDY18@GMAIL.COM",
      "address": "CALLE 04 CASA NRO9 SECTOR LA MAGDALENA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V11980745",
      "nap_box_name": "483",
      "created_at": "2024-04-11T14:35:07.360198",
      "service_detail": {
        "id": 9927,
        "ip": "172.21.29.2",
        "mac": "TPLGB446E9A7",
        "serial": "TPLGB446E9A7",
        "queue": null,
        "interface": "VLAN114_MAGDALENA",
        "created_at": "2025-11-11T08:36:29.997387",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3216,
      "client_name": "RENNY RENE PEREZ PUELLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Lascenio Guerrero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243232047",
      "client_email": "RENNY.PEREZ74@GMAIL.COM",
      "address": "CALLE LOS APAMATES CASA NRO 464",
      "client_identification": "V14296434",
      "nap_box_name": "475",
      "created_at": "2024-04-11T14:35:27.737682",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3217,
      "client_name": "MARBELIA CAROLINA PARRA PORRAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04123987913",
      "client_email": "karenandrea3131@gmail.com",
      "address": "VDA I-10 CASA NRO 04 URB SAMAN TARAZONERO II",
      "client_identification": "V9659632",
      "nap_box_name": "38",
      "created_at": "2024-04-11T14:38:10.017311",
      "service_detail": {
        "id": 6474,
        "ip": "172.18.113.2",
        "mac": "VSOL0051E489",
        "serial": "VSOL0051E489",
        "queue": "Plan_137413_1574_WispHub",
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2024-08-29T13:02:36.771492",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3218,
      "client_name": "ROSA HERMINIA SANCHEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243308856",
      "client_email": "ROSA.SANCHEZ02.18@GMAIL.COM",
      "address": "CALLE 13  CASA NRO 32  SAMAN TARAZONERO I TURMERO",
      "client_identification": "V5272193",
      "nap_box_name": "674 DOS",
      "created_at": "2024-04-11T14:40:26.334917",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3219,
      "client_name": "RIGOBERTO JOSE VILORIA PINEDA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Los Hornos",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128876241",
      "client_email": "RIGOJVP@HOTMAIL.COM",
      "address": "CALLE LOS MANGOS CASA NRO 21 BARRIO LOS HORNOS DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V15153639",
      "nap_box_name": "437",
      "created_at": "2024-04-11T14:42:08.721747",
      "service_detail": {
        "id": 12446,
        "ip": "172.25.3.2",
        "mac": "TPLGF9CD46DB",
        "serial": "TPLGF9CD46DB",
        "queue": null,
        "interface": "VLAN247_HORNOS",
        "created_at": "2026-05-02T11:04:40.812298",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3220,
      "client_name": "LHIANA YOHELY ROJAS PEDROZA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Paraiso",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04140463751",
      "client_email": "LHIANAROJAS@GMAIL.COM",
      "address": "CALLE LA LIBERTAD CASA NRO 36 URB EL PARAISO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V18176555",
      "nap_box_name": "345",
      "created_at": "2024-04-11T14:45:11.550301",
      "service_detail": {
        "id": 3938,
        "ip": "172.24.219.2",
        "mac": "TPLGF9CD45ED",
        "serial": "TPLGF9CD45ED",
        "queue": "Plan_137413_1574_WispHub",
        "interface": "VLAN105_EL_PARAISO",
        "created_at": "2024-07-17T12:15:41.083325",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3221,
      "client_name": "VICKY CAROLINA VASQUEZ MORA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Lascenio Guerrero",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04121991329",
      "client_email": "VICKYVASQUEZ631@GMAIL.COM",
      "address": "CALLE LOS ROBLES CASA NRO443 URB LACENIO GUERRERO TURMERO",
      "client_identification": "V18176422",
      "nap_box_name": "432",
      "created_at": "2024-04-11T14:45:24.728603",
      "service_detail": {
        "id": 3922,
        "ip": "172.24.34.2",
        "mac": "VSOL0013F281",
        "serial": "VSOL0013F281",
        "queue": "Plan_127988_1574_WispHub",
        "interface": "VLAN115_LG",
        "created_at": "2024-07-17T09:16:20.220813",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3222,
      "client_name": "MARIO NICOSIA SFRAMELLI",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124881912",
      "client_email": "M.NICOSIA.SF@GMAIL.COM",
      "address": "TURMERO CASCO CENTRAL C/PETION CASA NRO 16 ARAGUA ZONA POSTAL 2115",
      "client_identification": "V10459574",
      "nap_box_name": "CTO-00072",
      "created_at": "2024-04-11T14:45:36.063780",
      "service_detail": {
        "id": 5478,
        "ip": "172.26.223.2",
        "mac": "HWTC908BA49B",
        "serial": "HWTC908BA49B",
        "queue": "Plan_153953_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-08-16T17:29:39.408795",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3223,
      "client_name": "LAURANGELA REBECA OVIEDO BASTIDAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Lascenio Guerrero",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04122994132",
      "client_email": "PSICOLAURA20@GMAIL.COM",
      "address": "URBANIZACION DOCTOR LACENIO GUERRERO CALLE LOS ROBLES CASA NRO 439",
      "client_identification": "V22296806",
      "nap_box_name": "432",
      "created_at": "2024-04-11T14:48:07.791481",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3224,
      "client_name": "MARIA NELLY ANDARA CALLES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121484477",
      "client_email": "FRANCISCOALIVE305@GMAIL.COM",
      "address": "CALLE MANZANA H2 CASA 11 SECTOR SAMAN TARAZONERO II TUURMERO ARAGUA",
      "client_identification": "V16990491",
      "nap_box_name": "510",
      "created_at": "2024-04-11T14:49:50.743405",
      "service_detail": {
        "id": 13081,
        "ip": "172.27.41.2",
        "mac": "GP:ON:00:98:1F:66",
        "serial": "GPON00981F66",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2026-09-26T16:57:46.116634",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3225,
      "client_name": "MARIANA MARAMI MONZON MOYA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Lascenio Guerrero",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04144514002",
      "client_email": "MARIAMONZON1990@GMAIL.COM",
      "address": "CALLE LOS PINOS CASA NRO 449 LACENIO GUERRERO TURMERO",
      "client_identification": "V19553121",
      "nap_box_name": "431",
      "created_at": "2024-04-11T14:52:46.192566",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3226,
      "client_name": "ROSAANA MEDERO TEJADA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144929729",
      "client_email": "ROSAANA3112@GMAIL.COM",
      "address": "CALLE 7B CASA NRO 48 URB PANTIN TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V12854658",
      "nap_box_name": "CTO-00140",
      "created_at": "2024-04-11T14:53:33.709217",
      "service_detail": {
        "id": 5480,
        "ip": "172.26.236.2",
        "mac": "HWTCD66E559C",
        "serial": "HWTCD66E559C",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN229_PANTIN",
        "created_at": "2024-08-16T17:36:09.688425",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3227,
      "client_name": "MARIA ELINA BERMUDEZ DE FIGUEREDO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Lascenio Guerrero",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04162312783",
      "client_email": "REGLAKIMBISADELSANTOCRISTO@GMAIL.COM",
      "address": "CALLE LOS PINOS CASA NRO 448 URB DOCTOR LACENIO GUERRERO EL MACARO TURMERO",
      "client_identification": "V11093849",
      "nap_box_name": "431",
      "created_at": "2024-04-11T14:55:02.708187",
      "service_detail": {
        "id": 4108,
        "ip": "172.21.72.2",
        "mac": "TPLGF5CB0A0E",
        "serial": "TPLGF5CB0A0E",
        "queue": "Plan_127996_1574_WispHub",
        "interface": "VLAN100_OLTs",
        "created_at": "2024-07-25T16:00:35.159866",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3228,
      "client_name": "EMILYS YHOSVELIN MAYORA PERALTA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121415970",
      "client_email": "EMILYSMAYORA@GMAIL.COM",
      "address": "PANTIN CALLE 9 CASA #18 ROSARIO DE PAYA TURMERO 2115",
      "client_identification": "V22949029",
      "nap_box_name": "CTO-00142",
      "created_at": "2024-04-11T14:58:03.956412",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3229,
      "client_name": "LISANDRO JOSE SALAS TORTOLERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Lascenio Guerrero",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04162621945",
      "client_email": "LISANDROSALAST@GMAIL.COM",
      "address": "AV LAS PALMAS CASA NRO 418 LACENIO GUERRERO TURMERO",
      "client_identification": "V17197725",
      "nap_box_name": "475",
      "created_at": "2024-04-11T15:00:15.628051",
      "service_detail": {
        "id": 4112,
        "ip": "172.21.7.2",
        "mac": "TPLGB954EFFB",
        "serial": "TPLGB954EFFB",
        "queue": "Plan_127744_1574_WispHub",
        "interface": "VLAN100_OLTs",
        "created_at": "2024-07-26T16:47:14.621103",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3230,
      "client_name": "RENNY ADRIAN BOLIVAR MARTINEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Magdalena",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144753363",
      "client_email": "RENNYBOLIVAR70@GMAIL.COM",
      "address": "CALLE 11 CASA NRO 24 URB LA MAGDALENA 2115 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V9665830",
      "nap_box_name": "357",
      "created_at": "2024-04-11T15:03:01.866649",
      "service_detail": {
        "id": 5125,
        "ip": "172.28.32.2",
        "mac": "MONU00DA9C61",
        "serial": "MONU00DA9C61",
        "queue": "Plan_131337_24341_WispHub",
        "interface": "VLAN114_MAGDALENA",
        "created_at": "2024-08-14T17:30:02.310951",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3231,
      "client_name": "JUAN CARLOS TOVAR LINARES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Lascenio Guerrero",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04129383795",
      "client_email": "JUANCARLOSTOVART@GMAIL.COM",
      "address": "CALLE LAS PALMAS CASA NRO 415 URB LACENIO GUERRERO",
      "client_identification": "V22286544",
      "nap_box_name": "475",
      "created_at": "2024-04-11T15:03:05.375453",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3232,
      "client_name": "EDILIA AMUNDARAY ZAMBRANO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Paraiso",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128905691",
      "client_email": "ROSALBAROJAS.A.RR@GMAIL.COM",
      "address": "CALLE LA PAZ CASA NRO 99 URB EL PARAISO TURMERO",
      "client_identification": "V5228344",
      "nap_box_name": "344",
      "created_at": "2024-04-11T15:04:20.371569",
      "service_detail": {
        "id": 3944,
        "ip": "172.23.17.2",
        "mac": "TPLGBA68783D",
        "serial": "TPLGBA68783D",
        "queue": "Plan_137413_1574_WispHub",
        "interface": "VLAN105_EL_PARAISO",
        "created_at": "2024-07-17T14:06:02.815431",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3233,
      "client_name": "SUJAIL ZULAY LOPEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Paya Abajo",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243349143",
      "client_email": "SOFFIHMORONTA@GMAIL.COM",
      "address": "CALLE SAN ANTONIO CASA NRO 157 SECTOR PAYA ABAJO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V14943024",
      "nap_box_name": "480",
      "created_at": "2024-04-11T15:06:16.298543",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3234,
      "client_name": "JEAN CARLOS RAMIREZ RONDON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Lascenio Guerrero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243372104",
      "client_email": "JC15122060@GMAIL.COM",
      "address": "AV. 102 CASA NRO 425 URB LACENIO GUERRERO TURMERO",
      "client_identification": "V15122060",
      "nap_box_name": "475",
      "created_at": "2024-04-11T15:06:46.705561",
      "service_detail": {
        "id": 5483,
        "ip": "172.20.105.2",
        "mac": "TPLGB954E7F2",
        "serial": "TPLGB954E7F2",
        "queue": "queue1",
        "interface": "VLAN100_OLTs",
        "created_at": "2024-08-16T17:44:04.529065",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3235,
      "client_name": "NERIO ANTONIO BARRETO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Paraiso",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04120458688",
      "client_email": "KEYNERBARRETO.12@GMAIL.COM",
      "address": "CALLE LA UNION CASA NRO 98 URB EL PARAISO TURMERO",
      "client_identification": "V6929208",
      "nap_box_name": "345",
      "created_at": "2024-04-11T15:07:43.769550",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3236,
      "client_name": "OMAR RUIZ RAMIREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04145979803",
      "client_email": "OMARFRUIZRAMIREZ@GMAIL.COM",
      "address": "CALLE 06 CASA NRO 383 URB MATA CABALLO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V7178382",
      "nap_box_name": "CTO-00178",
      "created_at": "2024-04-11T15:08:49.111097",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3237,
      "client_name": "JAIRO JOSE ZAMBRANO HERNANDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Lascenio Guerrero",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04144745498",
      "client_email": "JAZAMLEX@GMAIL.COM",
      "address": "CALLE LAS PALENAS CASA NRO 412 LACENIO GUERRERO TURMERO",
      "client_identification": "V9699204",
      "nap_box_name": "475",
      "created_at": "2024-04-11T15:09:19.534635",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3238,
      "client_name": "NOHEMI JOSEFINA LOPEZ LOZADA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Paraiso",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04121489435",
      "client_email": "NOHEMILOPEZ41983@GMAIL.COM",
      "address": "CALLE LA PAZ CASA NRO 126 URB EL PARAISO TURMERO",
      "client_identification": "V16132796",
      "nap_box_name": "344",
      "created_at": "2024-04-11T15:10:24.413882",
      "service_detail": {
        "id": 5485,
        "ip": "172.21.140.2",
        "mac": "TPLGB954ED6F",
        "serial": "TPLGB954ED6F",
        "queue": "Plan_127996_1574_WispHub",
        "interface": "VLAN105_EL_PARAISO",
        "created_at": "2024-08-16T17:47:49.311164",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3239,
      "client_name": "FRANKLIN EDUARDO SEIJAS SIRA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Lascenio Guerrero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04140518867",
      "client_email": "FRANKSEIJAS44@GMAIL.COM",
      "address": "CALLE BUDARE CASA NRO 408 URB DOCTOR LCENIO GUERRERO TURMERO ARAGUA",
      "client_identification": "V25066036",
      "nap_box_name": "475",
      "created_at": "2024-04-11T15:11:22.660011",
      "service_detail": {
        "id": 3275,
        "ip": "172.19.106.2",
        "mac": "TPLGB954FF1D",
        "serial": "TPLGB954FF1D",
        "queue": "Plan_127996_1574_WispHub",
        "interface": "VLAN115_LG",
        "created_at": "2024-07-01T11:30:42.419311",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3240,
      "client_name": "ELVA MARIA VASQUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Paraiso",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243366873",
      "client_email": "DIOSGONS3@GMAIL.COM",
      "address": "CALLE LA PAZ CASA NRO 84 URB EL PARAISO TURMERO",
      "client_identification": "V12854058",
      "nap_box_name": "344",
      "created_at": "2024-04-11T15:12:50.446057",
      "service_detail": {
        "id": 3964,
        "ip": "172.21.137.2",
        "mac": "TPLGB954FD56",
        "serial": "TPLGB954FD56",
        "queue": "Plan_137413_1574_WispHub",
        "interface": "VLAN105_EL_PARAISO",
        "created_at": "2024-07-17T16:01:33.514286",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3241,
      "client_name": "NELSI EDELMIRA AMADOR TOVAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Paya Abajo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04142963248",
      "client_email": "ARANSASULBARAN27@GMAIL.COM",
      "address": "CALLE  LA CAPILLA CASA II SECTOR PAYA  ABAJO ROSARIO DE PAYA",
      "client_identification": "V19698324",
      "nap_box_name": "254",
      "created_at": "2024-04-11T15:13:39.578078",
      "service_detail": {
        "id": 11474,
        "ip": "172.23.92.2",
        "mac": "VSOL0012BE21",
        "serial": "VSOL0012BE21",
        "queue": null,
        "interface": "VLAN229_PANTIN",
        "created_at": "2026-02-04T14:33:43.300540",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3242,
      "client_name": "KENNIE DEL VALLE ESPINOZA TORRES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Lascenio Guerrero",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04162306378",
      "client_email": "KENNIEESPINOZA34348@GMAIL.COM",
      "address": "CALLE 104 C/C CALLE 121 CALLE LOS PINOS CASA NRO 450 URB LACENIO GUERRERO FUNDO EL MACARO",
      "client_identification": "V12993362",
      "nap_box_name": "431",
      "created_at": "2024-04-11T15:14:11.008428",
      "service_detail": {
        "id": 4116,
        "ip": "172.19.72.2",
        "mac": "TPLGF5CB030C",
        "serial": "TPLGF5CB030C",
        "queue": "Plan_127996_1574_WispHub",
        "interface": "VLAN100_OLTs",
        "created_at": "2024-07-26T17:01:23.803685",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3243,
      "client_name": "MOISES WILLIE REVERON SILVA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128905698",
      "client_email": "MOISES_WILLIE@HOTMAIL.COM",
      "address": "RIO SECO CALLE 21CASA NRO 10 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V20055781",
      "nap_box_name": "603",
      "created_at": "2024-04-11T15:18:07.085312",
      "service_detail": {
        "id": 5487,
        "ip": "172.26.175.2",
        "mac": "HWTC9070F19B",
        "serial": "HWTC9070F19B",
        "queue": "Plan_161905_30183_WispHub",
        "interface": "VLAN251_RIO_SECO",
        "created_at": "2024-08-16T17:51:50.143016",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3244,
      "client_name": "JUSNEIDI DE JESUS SUAREZ CEDENO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Paraiso",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243550772",
      "client_email": "JUSNEIDI@HOTMAIL.COM",
      "address": "CALLE LA ESPERANZA CASA NRO 101 URB EL PARAISO MACARO TURMERO",
      "client_identification": "V14741628",
      "nap_box_name": "346",
      "created_at": "2024-04-11T15:18:08.820686",
      "service_detail": {
        "id": 5488,
        "ip": "172.19.243.2",
        "mac": "TPLGB954F684",
        "serial": "TPLGB954F684",
        "queue": "Plan_127996_1574_WispHub",
        "interface": "VLAN100_OLTs",
        "created_at": "2024-08-16T17:53:36.759399",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3245,
      "client_name": "BRENNY COROMOTO SANCHEZ DE VARGAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Paraiso",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04127769294",
      "client_email": "BRENNYSANCHEZ@GMAIL.COM",
      "address": "CALLE LA PAZ NRO 88 EL PARAISO",
      "client_identification": "V128290733",
      "nap_box_name": "344",
      "created_at": "2024-04-11T15:20:49.134318",
      "service_detail": {
        "id": 5496,
        "ip": "172.19.250.2",
        "mac": "TPLGF5CB037A",
        "serial": "TPLGF5CB037A",
        "queue": "Plan_127996_1574_WispHub",
        "interface": "VLAN105_EL_PARAISO",
        "created_at": "2024-08-16T18:15:47.149099",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3246,
      "client_name": "BEATRIZ ADRIANA CONTRERAS DOS RAMOS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Jabillar",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04145982603",
      "client_email": "BEA.ADRI15@GMAIL.COM",
      "address": "URB JABILLAR C/8 CASA #5 SECTOR EL MACARO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V19791101",
      "nap_box_name": "CTO-0078",
      "created_at": "2024-04-11T15:21:41.169559",
      "service_detail": {
        "id": 10818,
        "ip": "172.26.234.2",
        "mac": "HWTCD1527E9A",
        "serial": "HWTCD1527E9A",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2025-12-19T09:57:27.280801",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3247,
      "client_name": "NOHELYS DEL VALLE ACOSTA DELGADO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Paya Abajo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04127321467",
      "client_email": "V23528369NOHEACOSTA38@GMAIL.COM",
      "address": "CALLE SAN MIGUEL CASA NRO 2-37 SECTOR PAYA ABAJO ROSARIO DE PAYA ARAGUA",
      "client_identification": "V23528369",
      "nap_box_name": "CTO-00002",
      "created_at": "2024-04-11T15:21:55.989637",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3248,
      "client_name": "NORMARY MARGARITA HERNANDEZ VEGAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Concepcion III",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04129468537",
      "client_email": "NORMARYHERNANDEZ1212@GMAIL.COM",
      "address": "LA CONCEPCIÓN 3 CASA N 92 TURMERO CÓDIGO POSTAL 2115",
      "client_identification": "V20649129",
      "nap_box_name": "CTO-00456",
      "created_at": "2024-04-11T15:22:56.398950",
      "service_detail": {
        "id": 6628,
        "ip": "172.27.175.2",
        "mac": "MONU00114AC9",
        "serial": "MONU00114AC9",
        "queue": "Plan_131341_24341_WispHub",
        "interface": "VLAN136_CONCEPCION_3",
        "created_at": "2024-09-17T09:41:14.500106",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3249,
      "client_name": "JEAN CARLOS PEDRIQUEZ GALVIS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Paraiso",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04121718248",
      "client_email": "MONICAPEDRIGUEZ@GMAIL.COM",
      "address": "CALLE FE CASA NRO 27 URB EL PARAISO EL MACARO TURMERO",
      "client_identification": "V13621892",
      "nap_box_name": "346",
      "created_at": "2024-04-11T15:23:42.020473",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3250,
      "client_name": "CRISLER ORIANA MEDINA RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Paraiso",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121799844",
      "client_email": "CRISLER111@GMAIL.COM",
      "address": "CALLE LIBERTAD CASA NRO 60 URB. EL PARAISO",
      "client_identification": "V25841831",
      "nap_box_name": "344",
      "created_at": "2024-04-11T15:25:53.816620",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3251,
      "client_name": "THAIRIS CORORMOTO VALDEZ MARCANO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Jabillar",
      "plan": {
        "id": 16,
        "name": "RECURRENTE RESIDENCIAL PLAN 800M",
        "cost": "55.00",
        "code": "FOR800",
        "profile": "800M/800M"
      },
      "client_mobile": "04243251041",
      "client_email": "ELWISTORTOLERO2002@GMAIL.COM",
      "address": "URB JABILLAR CALLE 15 CASA NRO 7 SECTOR EL MACARO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V12340069",
      "nap_box_name": "CTO-00003",
      "created_at": "2024-04-11T15:26:15.013869",
      "service_detail": {
        "id": 11197,
        "ip": "172.26.210.2",
        "mac": "HWTCC18F239C",
        "serial": "HWTCC18F239C",
        "queue": null,
        "interface": "VLAN108_JABILLAR_OLT_ZTE",
        "created_at": "2026-01-16T11:12:20.463570",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3252,
      "client_name": "ISAAC LUCIO CATARI FAJARDO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Durpa",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121573954",
      "client_email": "ISAACCATARI@GMAIL.COM",
      "address": "CALLE LAS COLINAS MANZANA 19 CASA NRO 6 URB DESARROLLO URBANISTICO SECTOR DURPA",
      "client_identification": "V13614076",
      "nap_box_name": "352",
      "created_at": "2024-04-11T15:27:06.111305",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3253,
      "client_name": "MERLY RAMONA LARA RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Paraiso",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04127767435",
      "client_email": "MERLYLARA.LARA@GMAIL.COM",
      "address": "CALLE LA LIBERTAD CASA NRO 47 URB EL PARAISO SECTOR EL MACARO",
      "client_identification": "V15123343",
      "nap_box_name": "344",
      "created_at": "2024-04-11T15:28:06.873674",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3254,
      "client_name": "ANGEL ALEJANDRO HIDALGO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04144642808",
      "client_email": "ANGELHIDALGO2704@GMAIL.COM",
      "address": "CALLE PAEZ CASA NRO 5-1 SECTOR CENTRO DE TURMERO",
      "client_identification": "V2901151",
      "nap_box_name": "103",
      "created_at": "2024-04-11T15:32:31.735667",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3255,
      "client_name": "ISABELA JOSE DEL VECCHIO PROMARD",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Paraiso",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04140387697",
      "client_email": "DELVECCHIOISABELA95@GMAIL.COM",
      "address": "CALLE UNION CASA NRO 120 URB EL PARAISO TURMERO ARAGUA",
      "client_identification": "V25102491",
      "nap_box_name": "345",
      "created_at": "2024-04-11T15:35:44.422980",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3256,
      "client_name": "ANGELIS MARYELIS MANRIQUEZ TOVAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04125874764",
      "client_email": "MANRIQUEZANGELYS2001@GMAIL.COM",
      "address": "CALLE 7 CASA #49 RIO SECO TURMERO ARAGUA 2115",
      "client_identification": "V26935784",
      "nap_box_name": "474",
      "created_at": "2024-04-11T15:36:33.546014",
      "service_detail": {
        "id": 5498,
        "ip": "172.26.161.2",
        "mac": "HWTC544F2CA3",
        "serial": "HWTC544F2CA3",
        "queue": "Plan_161901_30183_WispHub",
        "interface": "VLAN251_RIO_SECO",
        "created_at": "2024-08-16T18:20:46.062530",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3257,
      "client_name": "TURGEL LISET MEDINA CARRERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Paraiso",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04267348492",
      "client_email": "TURGEL.MEDINA0@GMAIL.COM",
      "address": "CALLE LA FE CASA NRO 06 URB EL PARAISO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V12610846",
      "nap_box_name": "346",
      "created_at": "2024-04-11T15:37:49.797236",
      "service_detail": {
        "id": 3969,
        "ip": "172.18.90.2",
        "mac": "TPLGB777B327",
        "serial": "TPLGB777B327",
        "queue": "Plan_127996_1574_WispHub",
        "interface": "VLAN105_EL_PARAISO",
        "created_at": "2024-07-17T16:11:39.935315",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3258,
      "client_name": "ALEJANDRO DE SA FERNANDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Jabillar",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04163008380",
      "client_email": "ANGGEL.DESA@HOTMAIL.COM",
      "address": "CALLE LOS SAUCES CASA NRO 10-03 URB JABILLAR TOWN COUNTRY TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V11739871",
      "nap_box_name": "CTO-00007",
      "created_at": "2024-04-11T15:38:18.425442",
      "service_detail": {
        "id": 11121,
        "ip": "172.26.211.2",
        "mac": "HWTCC118009C",
        "serial": "HWTCC118009C",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2026-01-13T11:55:19.188154",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3259,
      "client_name": "EDWIN DAVID SOLORZANO LEON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Palmeras I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243757135",
      "client_email": "E.D.SOLORZANO15@GMAIL.COM",
      "address": "PALMERAS I CALLE 2 CASA 126 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V22287135",
      "nap_box_name": "CAJA NAP MZN 10 VALLE PARAISO",
      "created_at": "2024-04-11T15:38:29.918197",
      "service_detail": {
        "id": 3310,
        "ip": "172.25.211.2",
        "mac": "TPLGF9CD3D48",
        "serial": "TPLGF9CD3D48",
        "queue": "Plan_131647_24341_WispHub",
        "interface": "VLAN118_PALMERAS_1",
        "created_at": "2024-07-02T07:52:39.843554",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3260,
      "client_name": "MIGUEL AGUSTIN ASTORINO BARRIOS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona II",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243776912",
      "client_email": "EL.ASTORINO18@GMAIL.COM",
      "address": "CALLE 14 CASA NRO 69 URB LA CASONA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V23793764",
      "nap_box_name": "CTO-00120",
      "created_at": "2024-04-11T15:39:45.871335",
      "service_detail": {
        "id": 6373,
        "ip": "172.26.132.2",
        "mac": "HWTC46B8DD9B",
        "serial": "HWTC46B8DD9B",
        "queue": "Plan_131341_24341_WispHub",
        "interface": "VLAN110_CASONA_2",
        "created_at": "2024-08-26T17:28:28.641230",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3261,
      "client_name": "GILBERTO ALEXANDER LUNA ZAMORA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Paraiso",
      "plan": {
        "id": 16,
        "name": "RECURRENTE RESIDENCIAL PLAN 800M",
        "cost": "55.00",
        "code": "FOR800",
        "profile": "800M/800M"
      },
      "client_mobile": "04242798353",
      "client_email": "GILBERLUNA26@GMAIL.COM",
      "address": "CALLE LA PAZ CASA NRO 107 URB EL PARAISO SECTOR EL MÁCARO TURMERO ARAGUA",
      "client_identification": "V26679622",
      "nap_box_name": "344",
      "created_at": "2024-04-11T15:40:16.298720",
      "service_detail": {
        "id": 3971,
        "ip": "172.18.91.2",
        "mac": "TPLG2ABDC6CC",
        "serial": "TPLG2ABDC6CC",
        "queue": "Plan_127983_1574_WispHub",
        "interface": "VLAN105_EL_PARAISO",
        "created_at": "2024-07-17T16:13:35.681326",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3262,
      "client_name": "GABY DEL CARMEN COLMENARES MATERANO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Canaima",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04129689441",
      "client_email": "GABYCOLMENARES775@GMAIL.COM",
      "address": "CALLE #6 CASA NRO 17 SECTOR CANAIMA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V16647580",
      "nap_box_name": "356",
      "created_at": "2024-04-11T15:40:17.927780",
      "service_detail": {
        "id": 4119,
        "ip": "172.30.48.2",
        "mac": "HWTC54120AA3",
        "serial": "HWTC54120AA3",
        "queue": "Plan_161905_30183_WispHub",
        "interface": "VLAN237_CANAIMA",
        "created_at": "2024-07-27T15:34:20.815104",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3264,
      "client_name": "JOE HENRY FLORES ROJAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Paraiso",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04125394201",
      "client_email": "FRJH1976@GMAIL.COM",
      "address": "CALLE LA FE CASA NRO 5 URB EL PARAISO SAN JOAQUIN DE TURMERO ARAGUA",
      "client_identification": "V13943857",
      "nap_box_name": "346",
      "created_at": "2024-04-11T15:45:37.054109",
      "service_detail": {
        "id": 3356,
        "ip": "172.18.92.2",
        "mac": "TPLGB7656C38",
        "serial": "TPLGB7656C38",
        "queue": "Plan_137413_1574_WispHub",
        "interface": "VLAN105_EL_PARAISO",
        "created_at": "2024-07-02T16:32:09.596540",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3265,
      "client_name": "ZULIMAR MARGARITA ROJAS MORONTA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "SUSPENDIDO_RESIDENCIAL",
      "status_name": "Suspendido",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Palma Real",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243058210",
      "client_email": "ZULYDYLHAN@GMAIL.COM",
      "address": "CALLE 04 CASA NRO 69 URB PALMA REAL TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V13199089",
      "nap_box_name": "PMR-NAP-003",
      "created_at": "2024-04-11T15:45:38.522670",
      "service_detail": {
        "id": 3461,
        "ip": "172.26.237.2",
        "mac": "HWTCC14BD59C",
        "serial": "HWTCC14BD59C",
        "queue": "Plan_161905_30183_WispHub",
        "interface": "VLAN244_PALMAREAL",
        "created_at": "2024-07-04T17:13:31.657424",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3266,
      "client_name": "COHINTA DEL ROSARIO PEREZ CONTRERAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128868034",
      "client_email": "MARYLINCARDENASP@GMAIL.COM",
      "address": "CALLE 01 CASA NRO 84 SECTOR PRADOS DE PAYA II ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V10742567",
      "nap_box_name": "584 DOS",
      "created_at": "2024-04-11T15:47:26.258560",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3267,
      "client_name": "JOSE ANGEL BARRIOS QUEVEDO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados III",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04228157534",
      "client_email": "joseangelbarrios2020@gmail.com",
      "address": "CALLE 6 CASA NRO 8 SECTOR PRADO III ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V29786724",
      "nap_box_name": "395",
      "created_at": "2024-04-11T15:48:06.616308",
      "service_detail": {
        "id": 4162,
        "ip": "172.26.212.2",
        "mac": "HWTCC1ABDB9C",
        "serial": "HWTCC1ABDB9C",
        "queue": "queue1",
        "interface": "VLAN236_PRADOS3",
        "created_at": "2024-08-01T13:26:48.415869",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3268,
      "client_name": "RAFAEL DOMINGO VASQUEZ PERAZA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Paraiso",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04127760784",
      "client_email": "RAFAELVASQUEZP1974@GMAIL.COM",
      "address": "CALLE LA LIBERTAD CASA NRO 58 URB EL PARAISO SECTOR EL MACARO TURMERO ARAGUA",
      "client_identification": "V11631560",
      "nap_box_name": "344",
      "created_at": "2024-04-11T15:48:44.704774",
      "service_detail": {
        "id": 3972,
        "ip": "172.25.188.2",
        "mac": "TPLGC3C6BBD0",
        "serial": "TPLGC3C6BBD0",
        "queue": "Plan_137413_1574_WispHub",
        "interface": "VLAN105_EL_PARAISO",
        "created_at": "2024-07-17T16:15:41.383315",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3269,
      "client_name": "YORMAN ANTONIO OCHOA CASTAÑEDA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Jabillar",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04144762228",
      "client_email": "YORMAN0218@GMAIL.COM",
      "address": "RESIDENCIAS JABILLAR CALLE 2 CASA NRO 8 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V13133136",
      "nap_box_name": "CTO-0063",
      "created_at": "2024-04-11T15:49:26.644642",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3270,
      "client_name": "GUSTAVO EDUARDO RUIZ TOVAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Paraiso",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128935096",
      "client_email": "GUSTAVOERUIZT@GMAIL.COM",
      "address": "CALLE LIBERTAD CASA NRO 55 URB EL PARAISO TURMERO ARAGUA",
      "client_identification": "V14730407",
      "nap_box_name": "345",
      "created_at": "2024-04-11T15:51:32.947387",
      "service_detail": {
        "id": 3973,
        "ip": "172.18.94.2",
        "mac": "TPLGC3C6BBBC",
        "serial": "TPLGC3C6BBBC",
        "queue": "Plan_137413_1574_WispHub",
        "interface": "VLAN105_EL_PARAISO",
        "created_at": "2024-07-17T16:17:43.209591",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3271,
      "client_name": "LUIS ANTONIO OCHOA VILLARROEL",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Jabillar",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04127002142",
      "client_email": "luis8av@gmail.com",
      "address": "CRTA NACIONAL TURMERO MRACAY SECTOR EL MACARO CALLE 17 - 10 JABILLAR TOWN COUNTRY  TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V11025818",
      "nap_box_name": "CTO-00015",
      "created_at": "2024-04-11T15:52:35.043597",
      "service_detail": {
        "id": 10881,
        "ip": "172.26.149.2",
        "mac": "HWTCD6A9899C",
        "serial": "HWTCD6A9899C",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2025-12-23T08:30:06.917701",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3272,
      "client_name": "LARIBETH VICTORIA CUEVAS MONSERRATTE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "San Pablo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144882620",
      "client_email": "LARIBETHCUEVAS@GMAIL.COM",
      "address": "URB SAN PABLO CALLE HICELE CASA 8-A TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V22286884",
      "nap_box_name": "26",
      "created_at": "2024-04-11T15:52:44.024115",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3274,
      "client_name": "JUAN JOSE RUMBOS FIGUEROA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Tibisay Guevara",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04145887469",
      "client_email": "JUANRUMBOS01@GMAIL.COM",
      "address": "CALLE 1 CASA NRO 17 SECTOR TIBISAY GUEVARA EL MACARO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V15739546",
      "nap_box_name": "CTO-00054",
      "created_at": "2024-04-11T15:53:19.695053",
      "service_detail": {
        "id": 3195,
        "ip": "172.27.207.2",
        "mac": "HWTC54A491A3",
        "serial": "HWTC54A491A3",
        "queue": "Plan_92300_15811_WispHub",
        "interface": "VLAN248_TIBISAY_OLT2",
        "created_at": "2024-06-27T17:45:01.060748",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3275,
      "client_name": "BETZABETH NAZARETH GORRIN CEDEÑO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Paraiso",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04142946239",
      "client_email": "BETZABETHGO1@GMAIL.COM",
      "address": "CALLE ESPERANZA CASA NRO 1-A URB EL PARAISO TURMERO ARAGUA",
      "client_identification": "V19833282",
      "nap_box_name": "346",
      "created_at": "2024-04-11T15:54:39.479925",
      "service_detail": {
        "id": 3975,
        "ip": "172.25.8.2",
        "mac": "TPLGC3C6BBCC",
        "serial": "TPLGC3C6BBCC",
        "queue": "Plan_137413_1574_WispHub",
        "interface": "VLAN100_OLTs",
        "created_at": "2024-07-17T16:19:24.177445",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3276,
      "client_name": "ERICK NAIM ENCISO BELLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128858283",
      "client_email": "ERICK.ENCISO9898@GMAIL.COM",
      "address": "CALLE 05 CASA NRO 2 BARRIOS DE PAYA I TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V27434960",
      "nap_box_name": "CTO-00061",
      "created_at": "2024-04-11T15:55:04.893519",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3277,
      "client_name": "MERVIN ORLANDO RODRIGUEZ SANOJA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "San Pablo",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04242914320",
      "client_email": "MRODRIGUEZSANOJA@GMAIL.COM",
      "address": "CASA 3 URB SAN PABLO CALLE FAETON TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V12144071",
      "nap_box_name": "141",
      "created_at": "2024-04-11T15:55:40.193297",
      "service_detail": {
        "id": 4132,
        "ip": "172.26.227.2",
        "mac": "HWTC464A479B",
        "serial": "HWTC464A479B",
        "queue": "Plan_140304_15811_WispHub",
        "interface": "VLAN224_SAN_PABLO_OLT1",
        "created_at": "2024-07-31T10:39:37.855011",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3278,
      "client_name": "JUDITH MARLENE JASPE DE VASQUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Paraiso",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04169439475",
      "client_email": "JUDITHJASPE63@GMAIL.COM",
      "address": "CALLE LA FÉ CASA NRO 22 URB EL PARAISO TURMERO ARAGUA",
      "client_identification": "V7235734",
      "nap_box_name": "346",
      "created_at": "2024-04-11T15:58:00.437956",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3279,
      "client_name": "JAVIER ARTURO MACHADO SORIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "San Pablo",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04125378254",
      "client_email": "JAVIERAMS0907@GMAIL.COM",
      "address": "AV PRINCIPAL CASA NRO 25 URB SAN PABLO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V14944112",
      "nap_box_name": "CTO-00161",
      "created_at": "2024-04-11T16:00:01.505847",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3280,
      "client_name": "JULIO CESAR VARGAS DIAZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman de Guere",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128989835",
      "client_email": "VARGASJULIOCESAR66@GMAIL.COM",
      "address": "CALLE LA CEIBA NRO 12 SECTOR SAMAN DE GUERE TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V8744210",
      "nap_box_name": "303",
      "created_at": "2024-04-11T16:00:32.714607",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3281,
      "client_name": "LUIS ALFREDO CHIRINOS FALCON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04165390701",
      "client_email": "LUISCHIRINOS2017@GMAIL.COM",
      "address": "CALLE 9 CASA #61 RIO SECO TURMERO ARAGUA 2115",
      "client_identification": "V27864315",
      "nap_box_name": "CTO-0609",
      "created_at": "2024-04-11T16:01:33.535210",
      "service_detail": {
        "id": 5514,
        "ip": "172.26.160.2",
        "mac": "HWTC543CB8A3",
        "serial": "HWTC543CB8A3",
        "queue": "queue1",
        "interface": "VLAN251_RIO_SECO",
        "created_at": "2024-08-16T20:34:48.800294",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3282,
      "client_name": "LILA HERNANDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243604055",
      "client_email": "niangelyochoa122@gmail.com",
      "address": "CALLE 9-A CASA NRO 7 URB PANTIN TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V12993898",
      "nap_box_name": "CTO-00142",
      "created_at": "2024-04-11T16:03:29.022199",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3283,
      "client_name": "ERIKA NATALY ESPINEL MENDOZA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124003843",
      "client_email": "ERIKAESPINEL49@GMAIL.COM",
      "address": "PARADA BUS URB. MATACABALLO, AVENIDA PRINCIPAL ROSARIO DE PAYA, TURMERO 2115, ARAGUA",
      "client_identification": "V20245558",
      "nap_box_name": "CTO-00143",
      "created_at": "2024-04-11T16:05:59.130500",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3284,
      "client_name": "ELIZABETH TERESA RANGEL VILLAMIZAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04127769279",
      "client_email": "VPARRA1327@GMAIL.COM",
      "address": "CALLE 13-A CASA 3 SECTOR PANTIN ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V14502102",
      "nap_box_name": "CTO-00170",
      "created_at": "2024-04-11T16:06:18.501051",
      "service_detail": {
        "id": 5515,
        "ip": "172.26.235.2",
        "mac": "HWTCC19F289C",
        "serial": "HWTCC19F289C",
        "queue": "Plan_161905_30183_WispHub",
        "interface": "VLAN229_PANTIN",
        "created_at": "2024-08-16T20:36:52.865524",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3285,
      "client_name": "MELCIADES RIVAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04129681341",
      "client_email": "MELCIADESRIVAS025@GMAIL.COM",
      "address": "CALLE 2-B CASA NRO 47 SECTOR PANTIN ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V6042100",
      "nap_box_name": "CTO-00126",
      "created_at": "2024-04-11T16:08:36.269584",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3286,
      "client_name": "YUSMARLYN DEL CARMEN CAMPOS PALMERI",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Bicentenario",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04123489931",
      "client_email": "YUSMARLYNCAMPOS@GMAIL.COM",
      "address": "MANZANA 10 CASA #16 PB BARRIO BICENTENARIO TURMERO ARAGUA 2115",
      "client_identification": "V25620869",
      "nap_box_name": "CTO-00445",
      "created_at": "2024-04-11T16:09:26.601679",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3287,
      "client_name": "KARELIS ELENA DIAZ PANTOJA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243796977",
      "client_email": "KAREN_5068@HOTMAIL.COM",
      "address": "CALLE 12 CASA NRO 690-A URB MATA CABALLO ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V12566795",
      "nap_box_name": "CTO-0167",
      "created_at": "2024-04-11T16:10:03.447653",
      "service_detail": {
        "id": 12614,
        "ip": "172.25.213.2",
        "mac": "TP:LG:F9:CD:3F:33",
        "serial": "TPLGF9CD3F33",
        "queue": null,
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2026-06-14T14:46:10.187666",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3288,
      "client_name": "TUBALCAIN SANCHEZ FALCON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Tibisay Guevara",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04145005935",
      "client_email": "SANCHEZTUBALCAIN997@GMAIL.COM",
      "address": "CALLE 1 CASA NRO 28 BARRIO TIBISAY GUEVARA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V7971175",
      "nap_box_name": "CTO-00054",
      "created_at": "2024-04-11T16:11:29.230966",
      "service_detail": {
        "id": 4665,
        "ip": "172.26.38.2",
        "mac": "HWTC9068979B",
        "serial": "HWTC9068979B",
        "queue": "Plan_92284_15811_WispHub",
        "interface": "VLAN248_TIBISAY_OLT2",
        "created_at": "2024-08-12T10:25:06.323204",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3289,
      "client_name": "MARIA HALABI MASSRI",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124466756",
      "client_email": "MARIAHALABIMASRI@GMAIL.COM",
      "address": "CALLE 11 CASA SECTOR LAS TETRAS NRO 658-C URB MATA CABALLO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V14830343",
      "nap_box_name": "CTO-00213",
      "created_at": "2024-04-11T16:14:39.574615",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3290,
      "client_name": "SUSSY DEL VALLE JIMENEZ PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Magdalena",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128834259",
      "client_email": "KELVINALISSON15@GMAIL.COM",
      "address": "CALLE 11 CASA N#49 SECTOR LA MAGDALENA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V10756151",
      "nap_box_name": "357",
      "created_at": "2024-04-11T16:14:59.081110",
      "service_detail": {
        "id": 10038,
        "ip": "172.30.34.2",
        "mac": "VSOL00D0ED67",
        "serial": "VSOL00D0ED67",
        "queue": null,
        "interface": "VLAN114_MAGDALENA",
        "created_at": "2025-11-11T17:30:32.447524",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3291,
      "client_name": "ROBERT ALEXANDER DELGADO VILLARTE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04145862866",
      "client_email": "ROBERTALEXANDERDELGADOVILLARTE@GMAIL.COM",
      "address": "URB MATA CABALLO CALLE 10 CASA 622-A TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V12340842",
      "nap_box_name": "CTO-00569",
      "created_at": "2024-04-11T16:15:06.300528",
      "service_detail": {
        "id": 5520,
        "ip": "172.26.164.2",
        "mac": "HWTCC1B16B9C",
        "serial": "HWTCC1B16B9C",
        "queue": "Plan_161905_30183_WispHub",
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2024-08-16T20:46:46.948824",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3292,
      "client_name": "DOUGLAS JOSE TOVAR VILLEGAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243513282",
      "client_email": "DOJOTOVI@HOTMAIL.COM",
      "address": "VDA MANZANA D12 CASA NRO 3 URBANIZACION SAMAN TARAZONERO II TURMERO ARAGUA",
      "client_identification": "V12170513",
      "nap_box_name": "266",
      "created_at": "2024-04-11T16:15:46.928545",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3293,
      "client_name": "SANDRA MARIA LLOVERA CEDEÑO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243686814",
      "client_email": "SANDRALLOVERA836@GMAIL.COM",
      "address": "CALLE 7 CASA NRO 537-B URB MATA CABALLO ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V11093064",
      "nap_box_name": "CTO-00073",
      "created_at": "2024-04-11T16:17:52.500874",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3294,
      "client_name": "KEILA ABIGAIL PENA RINALDI",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Brisas de Paya",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04129688667",
      "client_email": "KALILASTORE25@GMAIL.COM",
      "address": "CALLE 1 CASA #12 SECTOR BRISAS DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V24815897",
      "nap_box_name": "367",
      "created_at": "2024-04-11T16:18:13.250160",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3295,
      "client_name": "CARLOS JAVIER FLORES ALIENDRES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Guanarito",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04128907713",
      "client_email": "CAVEIFLORES2015@GMAIL.COM",
      "address": "CALLE ARAGUANEY CASA NRO 5 SECTOR SIXTO TABORDA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V24173203",
      "nap_box_name": "434",
      "created_at": "2024-04-11T16:19:38.872094",
      "service_detail": {
        "id": 3993,
        "ip": "172.25.239.2",
        "mac": "VSOL00D0E927",
        "serial": "VSOL00D0E927",
        "queue": "Plan_139897_15811_WispHub",
        "interface": "VLAN232_GUANARITO_OLT2",
        "created_at": "2024-07-17T16:55:58.462269",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3297,
      "client_name": "DEYANIRA MARIA ORIA ROJAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124602081",
      "client_email": "YANIRA50ORIA@GMAIL.COM",
      "address": "URB LA CASONA 2 CALLE 14 CASA #76 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V12139321",
      "nap_box_name": "CTO-00120",
      "created_at": "2024-04-11T16:20:44.012202",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3298,
      "client_name": "ROSANYELY TOVAR MEJIAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128575854",
      "client_email": "RONALDGOMEZA74@GMAIL.COM",
      "address": "CALLE 12#B CASA NÚMERO 53 PANTIN",
      "client_identification": "V25880600",
      "nap_box_name": "CTO-00166",
      "created_at": "2024-04-11T16:23:14.483322",
      "service_detail": {
        "id": 5530,
        "ip": "172.25.201.2",
        "mac": "TPLGF9CD45BD",
        "serial": "TPLGF9CD45BD",
        "queue": "Plan_161904_30183_WispHub",
        "interface": "VLAN229_PANTIN",
        "created_at": "2024-08-16T21:12:34.968928",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3299,
      "client_name": "NOHELIS DEL VALLE GUERRA BRITO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vista Hermosa",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04129609540",
      "client_email": "NGUERRA_1@HOTMAIL.COM",
      "address": "CALLE EL ROSARIO  CASA NRO 31 SECTOR  VISTA  HERMOSA ROSARIO DE PAYA",
      "client_identification": "V11071718",
      "nap_box_name": "CTO-00057 DOS",
      "created_at": "2024-04-11T16:23:14.862506",
      "service_detail": {
        "id": 11989,
        "ip": "172.22.165.2",
        "mac": "TPLGBA687B3C",
        "serial": "TPLGBA687B3C",
        "queue": null,
        "interface": "VLAN230_VISTA_HERMOSA",
        "created_at": "2026-03-06T12:57:24.249900",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3300,
      "client_name": "SHARONS MICHELLE RIVERO TIREE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243278829",
      "client_email": "MICHELLERIVEROTIRRE23@GMAIL.COM",
      "address": "MATA CABALLO CALLE 5 #300 TURMERO ESTADO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V27048393",
      "nap_box_name": "CTO-00180",
      "created_at": "2024-04-11T16:24:31.174795",
      "service_detail": {
        "id": 3420,
        "ip": "172.25.230.2",
        "mac": "TPLGBA687BD6",
        "serial": "TPLGBA687BD6",
        "queue": "Plan_161904_30183_WispHub",
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2024-07-03T14:29:35.128908",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3301,
      "client_name": "JEANNETTE BELEN DELGADO LUGO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Betania",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144594273",
      "client_email": "JEANETY02@HOTMAIL.COM",
      "address": "CALLE 1 CASA NRO 25 SECTOR BETANIA ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V7192031",
      "nap_box_name": "597",
      "created_at": "2024-04-11T16:25:50.697748",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3302,
      "client_name": "YASMIN AGUIRRE MORENO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124381835",
      "client_email": "YASMINAGUIRRE4@GMAIL.COM",
      "address": "CALLE 12 A CASA NRO 6 URB PANTIN ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V12926994",
      "nap_box_name": "CTO-00165",
      "created_at": "2024-04-11T16:27:44.541417",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3303,
      "client_name": "JOSE ANTONIO TEJADA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Santa Eduviges",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128951062",
      "client_email": "JOSETOMATE.321@GMAIL.COM",
      "address": "CALLE HENRY PITTIER CASA NRO 6 URB SANTA EDUVIGES TURMERO",
      "client_identification": "V10692723",
      "nap_box_name": "86 DOS",
      "created_at": "2024-04-11T16:28:05.038157",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3304,
      "client_name": "MARIANGELA NORIETH ROJAS NIEVES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243201212",
      "client_email": "RUNNYSMENDOZA93@GMAIL.COM",
      "address": "CALLE 10 CASA NRO 628-B URB MATA CABALLO ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V21101859",
      "nap_box_name": "CTO-00569 DOS",
      "created_at": "2024-04-11T16:29:46.285032",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3305,
      "client_name": "BEATRIZ ANDREINA OVALLES PEÑA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04142940699",
      "client_email": "OVALLESANDREINA590@GMAIL.COM",
      "address": "CALLE 5-A CASA NRO 11 URB PANTIN ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V18976887",
      "nap_box_name": "CTO-00135",
      "created_at": "2024-04-11T16:29:48.555284",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3306,
      "client_name": "FRANCISCO MANUEL PACHECO RONDON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Naranjal",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128908814",
      "client_email": "FP7695013@MAIL.COM",
      "address": "CALLE LOS MAMONES NRO 7-7 SECTOR VALLE VERDE ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V9672226",
      "nap_box_name": "CTO-00187",
      "created_at": "2024-04-11T16:31:56.816355",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3307,
      "client_name": "HOSFELY YISBEL GARCIA VILLEGAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04162320596",
      "client_email": "YISBELGARCIA61@GMAIL.COM",
      "address": "CALLE 02 CASA NRO57 MATA CABALLO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V23796900",
      "nap_box_name": "CTO-435",
      "created_at": "2024-04-11T16:32:03.803032",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3308,
      "client_name": "DIHOSMAR DEL CARMEN LARA GAMEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados I",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128486554",
      "client_email": "DIHOSMARLARA2019@GMAIL.COM",
      "address": "PRADOS I CALLE NRO 11 CASA NRO #08 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V16864162",
      "nap_box_name": "CTO-00204 DOS",
      "created_at": "2024-04-11T16:32:08.843296",
      "service_detail": {
        "id": 5534,
        "ip": "172.26.177.2",
        "mac": "HWTCC1AB9C9C",
        "serial": "HWTCC1AB9C9C",
        "queue": "Plan_161905_30183_WispHub",
        "interface": "VLAN239_PRADOS1",
        "created_at": "2024-08-16T21:24:08.021664",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3309,
      "client_name": "YOGER UBALDO GAMBOA PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vista Hermosa",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124093887",
      "client_email": "MICHELLE99ER@GMAIL.COM",
      "address": "CALLE ROSARIO CASA NRO 35 URB VISTA HERMOSA ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V16132634",
      "nap_box_name": "CTO-00057 DOS",
      "created_at": "2024-04-11T16:32:12.508732",
      "service_detail": {
        "id": 11980,
        "ip": "172.26.40.2",
        "mac": "TPLGF9CD3D31",
        "serial": "TPLGF9CD3D31",
        "queue": null,
        "interface": "VLAN230_VISTA_HERMOSA",
        "created_at": "2026-03-06T12:03:54.855070",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3311,
      "client_name": "YANINE DEL CARMEN LOMELLY",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04243781370",
      "client_email": "CHUELLOALBERLIS6@GMAIL.COM",
      "address": "CALLE 06 NRO 22 URB PANTIN ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V12722535",
      "nap_box_name": "CTO-0013B",
      "created_at": "2024-04-11T16:34:50.134590",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3312,
      "client_name": "GLADYS SARAHI HERRERA TERAN",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Palma Real",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04161424421",
      "client_email": "DELGADOKARLENYS@GMAIL.COM",
      "address": "CALLE 4 CASA NRO 83 SECTOR PALMA REAL ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V19790061",
      "nap_box_name": "CTO-00391",
      "created_at": "2024-04-11T16:35:49.856944",
      "service_detail": {
        "id": 12095,
        "ip": "172.25.209.2",
        "mac": "MONU00B8B521",
        "serial": "MONU00B8B521",
        "queue": null,
        "interface": "VLAN244_PALMAREAL",
        "created_at": "2026-03-16T17:57:10.243919",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3313,
      "client_name": "NELLYDA VICENTA PEREA CORDERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Canaima",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04143103582",
      "client_email": "VICENTA.PEREA2021@GMAIL.COM",
      "address": "CALLLE 02 CASA NRO 12 SECTOR CANAIMA ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V26679889",
      "nap_box_name": "CTO-00107 ",
      "created_at": "2024-04-11T16:37:53.099856",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3315,
      "client_name": "MARIA YSABEL SUAREZ OLIVAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04127765685",
      "client_email": "MSUAREZOLIVAR57@GMAIL.COM",
      "address": "CALLE MANZANA  J1 CASA 13 SECTOR SAMAN TARAZONERO II TURMERO",
      "client_identification": "V9018735",
      "nap_box_name": "119",
      "created_at": "2024-04-11T16:38:58.508891",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3316,
      "client_name": "YOHELY EVELIN LIENDO CANTERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243054174",
      "client_email": "VALOAALBANY@GMAIL.COM",
      "address": "CALLE 5 CASA NRO 314 URB MATA CABALLO ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V19554565",
      "nap_box_name": "CTO-00182",
      "created_at": "2024-04-11T16:40:16.907471",
      "service_detail": {
        "id": 3580,
        "ip": "172.27.79.2",
        "mac": "TPLGF9CD3DB8",
        "serial": "TPLGF9CD3DB8",
        "queue": "Plan_161892_30183_WispHub",
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2024-07-09T14:36:05.536479",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3317,
      "client_name": "MARIMIR YONESSY GALINDO CASTRO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04125976808",
      "client_email": "MARIMIRGALINDO73@GMAIL.COM",
      "address": "MARIMIR YONESSY GALINDO CASTRO",
      "client_identification": "V12334073",
      "nap_box_name": "CTO-00052",
      "created_at": "2024-04-11T16:40:36.216522",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3318,
      "client_name": "MARTA EMILIA SANTRICH DE LEON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Brisas de Paya",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04141460318",
      "client_email": "MARTASANTRICH5@GMAIL.COM",
      "address": "CALLE 1 CASA NRO 33 SECTOR BRISAS DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "E84265671",
      "nap_box_name": "369",
      "created_at": "2024-04-11T16:41:27.927059",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3319,
      "client_name": "NAICARI ANAHIS MUDARRA VIELMA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243143359",
      "client_email": "NAICARIMUDARRA50@GMAIL.COM",
      "address": "URBANIZACIÓN PRADOS DE PAYA I, TURMERO, ARAGUA",
      "client_identification": "V30972350",
      "nap_box_name": "CTO-00298",
      "created_at": "2024-04-11T16:42:08.563489",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3320,
      "client_name": "NATALIA YANET LARA JIMENEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243765679",
      "client_email": "NL7718002@GMAIL.COM",
      "address": "CALLE 11 CASA NRO 654D URB MATA CABALLO ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V28025911",
      "nap_box_name": "CTO-00213",
      "created_at": "2024-04-11T16:43:12.176949",
      "service_detail": {
        "id": 5539,
        "ip": "172.25.158.2",
        "mac": "TPLGF9CD3FF1",
        "serial": "TPLGF9CD3FF1",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2024-08-16T21:45:01.802821",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3322,
      "client_name": "VIVIAN MARGARITA BOYER DE BOLIVAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Palmeras II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128983947",
      "client_email": "BOYERVM63@GMAIL.COM",
      "address": "CALLE TERRAZA C CASA C-12 NRO 12 CONJUNTO RESIDENCIAL LAS PALMERAS II",
      "client_identification": "V7233121",
      "nap_box_name": "336",
      "created_at": "2024-04-11T16:44:11.959442",
      "service_detail": {
        "id": 3817,
        "ip": "172.26.218.2",
        "mac": "HWTC46249D9B",
        "serial": "HWTC46249D9B",
        "queue": "Plan_137942_24341_WispHub",
        "interface": "VLAN119_PALMERAS_2",
        "created_at": "2024-07-15T17:13:17.530625",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3323,
      "client_name": "MARVIN JOSE MELLADO ROJAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243023056",
      "client_email": "GISBBYGADEO@GMAIL.COM",
      "address": "CALLE ROSARIO DE PAYA 7 CASA NRO 547 MATA CABALLO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V15734648",
      "nap_box_name": "CTO-00073",
      "created_at": "2024-04-11T16:46:37.708592",
      "service_detail": {
        "id": 3489,
        "ip": "172.25.225.2",
        "mac": "VSOL00129F81",
        "serial": "VSOL00129F81",
        "queue": "Plan_161904_30183_WispHub",
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2024-07-05T17:02:22.626431",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3324,
      "client_name": "CAROL DESIREE DIAZ LOPEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243086962",
      "client_email": "CAROLDDIAZ74@GMAIL.COM",
      "address": "CALLE 3 CASA NRO 130 URB MATA CABALLO ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V12261310",
      "nap_box_name": "CTO-00094",
      "created_at": "2024-04-11T16:47:10.345608",
      "service_detail": {
        "id": 6431,
        "ip": "172.26.41.2",
        "mac": "TPLGF9CD45D2",
        "serial": "TPLGF9CD45D2",
        "queue": "Plan_161870_30181_WispHub",
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2024-08-28T14:41:04.598855",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3325,
      "client_name": "MARITZA JOSEFINA RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Palma Real",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04263327850",
      "client_email": "maritzarodriguez5654@gmail.com",
      "address": "CALLE 4 CASA NRO 62 SECTOR PALMA REAL 2 ROSARIO DE PAYA ZONA POSTAL 2115 042403169025",
      "client_identification": "V7269327",
      "nap_box_name": "404",
      "created_at": "2024-04-11T16:47:37.834192",
      "service_detail": {
        "id": 5540,
        "ip": "172.26.120.2",
        "mac": "HWTC90291C9B",
        "serial": "HWTC90291C9B",
        "queue": "Plan_161905_30183_WispHub",
        "interface": "VLAN244_PALMAREAL",
        "created_at": "2024-08-16T21:47:09.438584",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3326,
      "client_name": "DEEREM LUIS FINOL GONZALEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04247192437",
      "client_email": "ESPELLCASTER2323@GMAIL.COM",
      "address": "URB MATA CABALLO CALLE 7 TETRA NRO 549D TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V18701707",
      "nap_box_name": "CTO-00073",
      "created_at": "2024-04-11T16:51:20.316014",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3327,
      "client_name": "HILARIO ALBERTO CASTILLO HERNANDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Valle Verde",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124674959",
      "client_email": "HILARIOCASTILLO5408O@GMAIL.COM",
      "address": "CALLE ALBERTO CASTILLO CASA NRO 85-5 SECTOR VALLE VERDE ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V7228540",
      "nap_box_name": "CTO-0490",
      "created_at": "2024-04-11T16:51:20.721037",
      "service_detail": {
        "id": 3423,
        "ip": "172.26.167.2",
        "mac": "HWTC4656FF9B",
        "serial": "HWTC4656FF9B",
        "queue": "Plan_161905_30183_WispHub",
        "interface": "VLAN253_VALLE_VERDE",
        "created_at": "2024-07-03T16:00:01.648732",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3328,
      "client_name": "IRMA FLORES DE BLANCO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Macarena",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243444817",
      "client_email": "EMILIS1508@HOTMAIL.COM",
      "address": "CALLE 6 CASA NRO 20 LA MACARENA EL MACARO TURMERO",
      "client_identification": "V8733594",
      "nap_box_name": "246",
      "created_at": "2024-04-11T16:51:39.863960",
      "service_detail": {
        "id": 4225,
        "ip": "172.22.128.2",
        "mac": "TPLGF4EFBCF1",
        "serial": "TPLGF4EFBCF1",
        "queue": "Plan_127744_1574_WispHub",
        "interface": "VLAN112_LA_MACARENA",
        "created_at": "2024-08-07T11:18:37.273091",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3329,
      "client_name": "JOSE LUIS SPIRITTU FLORES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243703729",
      "client_email": "JOSELUISSPIRITTU@GMAIL.COM",
      "address": "CALLE 3 CASA NRO 149 SECTOR MATA CABALLO ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V15962959",
      "nap_box_name": "CTO-00094",
      "created_at": "2024-04-11T16:55:25.950172",
      "service_detail": {
        "id": 9624,
        "ip": "172.25.219.2",
        "mac": "VSOL00481779",
        "serial": "VSOL00481779",
        "queue": null,
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2025-10-16T22:28:30.019297",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3330,
      "client_name": "BELKIS ANDREINA MORA CONTRERAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero I",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128909917",
      "client_email": "MORABELKIS688@GMAIL.COM",
      "address": "CALLE 12 CASA NRO 21 SECTOR SAMAN TARAZONERO 1 TURMERO",
      "client_identification": "V19277723",
      "nap_box_name": "90",
      "created_at": "2024-04-11T16:55:35.449062",
      "service_detail": {
        "id": 3842,
        "ip": "172.21.79.2",
        "mac": "TPLGB954F6FA",
        "serial": "TPLGB954F6FA",
        "queue": "Plan_127983_1574_WispHub",
        "interface": "VLAN140_SMT1",
        "created_at": "2024-07-16T13:11:58.457911",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3331,
      "client_name": "BLANCA NUBIA CAMPOS MEDINA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04127451278",
      "client_email": "BLANCANUBIACAMPOS@GMAIL.COM",
      "address": "SAMAN TARAZONERO 2 MANZANA C 11#4 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V7184065",
      "nap_box_name": "64",
      "created_at": "2024-04-11T16:58:41.729534",
      "service_detail": {
        "id": 12445,
        "ip": "172.25.220.2",
        "mac": "TPLGF9CD3CB0",
        "serial": "TPLGF9CD3CB0",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2026-05-02T11:00:22.181445",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3332,
      "client_name": "MIGUEL ANGEL BELTRAN DIAZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villa De San Jose",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04167394556",
      "client_email": "BELTRANMIGUEL2013@GMAIL.COM",
      "address": "CALLE PRINCIPAL CASA NRO 04-06 CONJUNTO RESIDENCIAL VILLAS DE SAN JOSE TURMERO ARAGUA ZONA",
      "client_identification": "V10759031",
      "nap_box_name": "396",
      "created_at": "2024-04-11T17:04:12.216696",
      "service_detail": {
        "id": 3496,
        "ip": "172.26.204.2",
        "mac": "HWTC9057219B",
        "serial": "HWTC9057219B",
        "queue": "Plan_127996_1574_WispHub",
        "interface": "VLAN134_VILLAS_DSJ",
        "created_at": "2024-07-08T09:27:42.087200",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3333,
      "client_name": "LORETH AJAMI DRIKHA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243266575",
      "client_email": "SALOMONAJAMI44@GMAIL.COM",
      "address": "AV BOLIVAR EDIF CORAZON DE JESUS PISO 2 APTO 5 SECTOR CENTRO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V13906321",
      "nap_box_name": "CTO-00194 DOS",
      "created_at": "2024-04-11T17:06:57.803740",
      "service_detail": {
        "id": 9730,
        "ip": "172.25.221.2",
        "mac": "TPLGF9CD460D",
        "serial": "TPLGF9CD460D",
        "queue": null,
        "interface": "VLAN200_OLTs",
        "created_at": "2025-11-10T11:19:37.724728",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3334,
      "client_name": "NATALIA SIANIRA FRANCIA MALUENGA SANTANA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04125381855",
      "client_email": "YRISBAQUERO@GMAIL.COM",
      "address": "CALLE 8 CASA NRO 46-A URB LA CASONA I TURMERO LA JULIA ZONA POSTAL 2115",
      "client_identification": "V28045659",
      "nap_box_name": "450",
      "created_at": "2024-04-11T17:10:05.705712",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3335,
      "client_name": "JESUS DANIEL REYES BLANCO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04168440957",
      "client_email": "JESUSREYESBLANCO16@GMAIL.COM",
      "address": "Calle 8 Casa Nro 5 Sector La Casona I Turmero Aragua Zona Postal 2115",
      "client_identification": "V28267830",
      "nap_box_name": "115",
      "created_at": "2024-04-11T17:12:52.075019",
      "service_detail": {
        "id": 3996,
        "ip": "172.25.195.2",
        "mac": "VSOL00140639",
        "serial": "VSOL00140639",
        "queue": "Plan_137942_24341_WispHub",
        "interface": "VLAN109_CASONA_1",
        "created_at": "2024-07-17T17:31:05.928819",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3336,
      "client_name": "DIEGO JAVIER CASTRO ARENAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Salto Angel",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04127769829",
      "client_email": "castrodiego1915@gmail.com",
      "address": "URB SALTO ANGEL MANZANA 5 CALLE LOS PINOS CASA #18 TURMERO ESTADO ARAGUA",
      "client_identification": "V30956798",
      "nap_box_name": "39",
      "created_at": "2024-04-11T17:16:08.036804",
      "service_detail": {
        "id": 11246,
        "ip": "172.25.224.2",
        "mac": "TPLGF9CD3D5E",
        "serial": "TPLGF9CD3D5E",
        "queue": null,
        "interface": "VLAN121_S_ANGEL",
        "created_at": "2026-01-20T17:42:36.632432",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3337,
      "client_name": "OCDAGLIS RAMONA PINANGO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04125035734",
      "client_email": "OCDAGLISPINANGO@GMAIL.COM",
      "address": "URBANIZACION MATA CABALLO CALLE 9 TETRA 599-B TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V16863215",
      "nap_box_name": "160",
      "created_at": "2024-04-11T17:19:27.024802",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3338,
      "client_name": "YOSIMAR ANDREINA CALZADILLA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243019640",
      "client_email": "YOSIANDRE91@GMAIL.COM",
      "address": "AV PRINCIPAL 1 CASA NRO 679-B MATA CABALLO ROSARIO DE PAYA ZONA POSTAL 2115",
      "client_identification": "V19246814",
      "nap_box_name": "CTO-00215",
      "created_at": "2024-04-11T17:22:51.701064",
      "service_detail": {
        "id": 4124,
        "ip": "172.25.215.2",
        "mac": "TPLGF9CD459D",
        "serial": "TPLGF9CD459D",
        "queue": "Plan_161905_30183_WispHub",
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2024-07-30T14:44:01.744320",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3339,
      "client_name": "ALEJANDRA GABRIELA CERVANTES MONTILLA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144861144",
      "client_email": "gabriela27369562@GMAIL.COM",
      "address": "CALLE CARREÑO EDIF 9 PISO 1 APT 1-3 URB EL NISPERO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V27369562",
      "nap_box_name": "CTO-00387",
      "created_at": "2024-04-11T17:31:16.315930",
      "service_detail": {
        "id": 12412,
        "ip": "172.25.207.2",
        "mac": "TPLGF9CD412D",
        "serial": "TPLGF9CD412D",
        "queue": null,
        "interface": "VLAN209_ZAMORA_OLT1",
        "created_at": "2026-04-25T12:32:12.190145",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3340,
      "client_name": "JENNIFER ANDREA ROJAS CORREA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144432237",
      "client_email": "JENNIFERANDREA2801@GMAIL.COM",
      "address": "PARADA LA CASONA II, AVENIDA INTERCOMUNAL SANTIAGO MARIÑO, TURMERO, ARAGUA",
      "client_identification": "V18913484",
      "nap_box_name": "449",
      "created_at": "2024-04-12T08:07:27.803523",
      "service_detail": {
        "id": 3300,
        "ip": "172.26.155.2",
        "mac": "HWTCC154539C",
        "serial": "HWTCC154539C",
        "queue": "Plan_137942_24341_WispHub",
        "interface": "VLAN109_CASONA_1",
        "created_at": "2024-07-01T15:28:00.665221",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3341,
      "client_name": "BRAHIANNY NAZARETH FLORES MARTINEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144890254",
      "client_email": "BRAHIANNYNAZARETF@GMAIL.COM",
      "address": "AV DESARROLLO HABITACIONAL LOS NISPEROS AV PROLONGACION CALLE CARREÑO ANTUGUA HACIENDA LOS NISPEROPS EDIF TIORA PB 00-06 LOS NISPEROS TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V32154472",
      "nap_box_name": "CTO-00296",
      "created_at": "2024-04-12T08:12:15.503671",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3342,
      "client_name": "ANGEL CUSTODIO MARRERO LORCA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Isaac Oliveira",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04248301404",
      "client_email": "ANGELSKY2808@GMAIL.COM",
      "address": "CALLE 3 CASA NRO 130 URB ISAAC OLIVEIRA TURMERO",
      "client_identification": "V9439471",
      "nap_box_name": "134",
      "created_at": "2024-04-12T08:14:27.725017",
      "service_detail": {
        "id": 12317,
        "ip": "172.24.90.2",
        "mac": "TPLGB444A959",
        "serial": "TPLGB444A959",
        "queue": null,
        "interface": "VLAN107_ISAAC_O",
        "created_at": "2026-04-16T10:41:28.144378",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3344,
      "client_name": "THALIZ PRISCILLA MARQUEZ SALAZAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Bicentenario",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124673195",
      "client_email": "PRISCIVZLA@GMAIL.COM",
      "address": "CALLE ARAGUANEY CRUCE CON HENRY PITTIER CASA NRO 2 SECTOR MANZANA C BICENTENARIO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V15473324",
      "nap_box_name": "385",
      "created_at": "2024-04-12T08:23:07.367883",
      "service_detail": {
        "id": 4128,
        "ip": "10.12.62.2",
        "mac": "TPLGF9CD453F",
        "serial": "TPLGF9CD453F",
        "queue": "Plan_161895_30183_WispHub",
        "interface": "VLAN243_BICENTENARIO",
        "created_at": "2024-07-30T15:27:33.345541",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3345,
      "client_name": "ROSALBA GUERRERO CEGARRA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman de Guere",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243085127",
      "client_email": "ROSALBAVGUERRERO5@GMAIL.COM",
      "address": "CALLE LOS SAUCES MANZANA 12# CASA 23 SALTO ANGEL TURMERO 2115",
      "client_identification": "V10154852",
      "nap_box_name": "72",
      "created_at": "2024-04-12T08:24:04.512870",
      "service_detail": {
        "id": 5541,
        "ip": "172.27.180.2",
        "mac": "HWTC9096329B",
        "serial": "HWTC9096329B",
        "queue": "queue1",
        "interface": "VLAN121_S_ANGEL",
        "created_at": "2024-08-16T21:49:28.761492",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3346,
      "client_name": "RUTH ELIZABETH FOFE COLINA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04142976152",
      "client_email": "ruthjuan32@gmail.com",
      "address": "CALLE 6-B CASA NRO 35 URB HACIENDA PANTIN TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V16996650",
      "nap_box_name": "CTO-00138",
      "created_at": "2024-04-12T08:31:48.285366",
      "service_detail": {
        "id": 5545,
        "ip": "172.27.212.2",
        "mac": "HWTCD6475D9C",
        "serial": "HWTCD6475D9C",
        "queue": "queue1",
        "interface": "VLAN229_PANTIN",
        "created_at": "2024-08-16T22:04:42.221226",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3347,
      "client_name": "ROBERTH JOSE BRITO HIDALGO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121484539",
      "client_email": "BBRITOYEPEZ@GMAIL.COM",
      "address": "CALLE 8 CASA NRO 581 D URB MATA CABALLO ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V18851825",
      "nap_box_name": "CTO-00130",
      "created_at": "2024-04-12T08:39:06.364740",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3348,
      "client_name": "GEORGES DARIEH KAYSO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144626657",
      "client_email": "GEORGESDAHRIEH58@GMAIL.COM",
      "address": "CALLE MIRANDA CON PETION EDIF LA VENEZOLANA III PISO 2 APTO 8 SECTOR CENTRO TURMERO EDO ARAGUA",
      "client_identification": "V9439250",
      "nap_box_name": "CTO-00072",
      "created_at": "2024-04-12T08:44:50.091321",
      "service_detail": {
        "id": 6630,
        "ip": "172.27.156.2",
        "mac": "HWTCD16C509A",
        "serial": "HWTCD16C509A",
        "queue": "Plan_147201_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-09-17T12:10:18.223733",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3349,
      "client_name": "DIANA STELLIA GALLEGO ARAQUE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144330449",
      "client_email": "SAIMEDIANASAIME@GMAIL.COM",
      "address": "CALLE 18-A CASA NRO 01 URB PANTIN ROSARIO DE PAYA EDO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V12553123",
      "nap_box_name": "CTO-00434",
      "created_at": "2024-04-12T08:58:26.746547",
      "service_detail": {
        "id": 3831,
        "ip": "172.27.153.2",
        "mac": "HWTC4676489B",
        "serial": "HWTC4676489B",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN229_PANTIN",
        "created_at": "2024-07-16T09:42:14.606551",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3350,
      "client_name": "ALBERTO RAFAEL SUAREZ GIL",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Bicentenario",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243244578",
      "client_email": "111283ALBERTO@GMAIL.COM",
      "address": "CALLE AVES DEL PARAISO CASA NRO 36 SECTOR FUNDA BARRIO ROSARIO DE PAYA TURMERO ARAGUA ZONA",
      "client_identification": "V16618760",
      "nap_box_name": "CTO-00302",
      "created_at": "2024-04-12T09:04:01.192778",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3351,
      "client_name": "JHONNY ALEXANDER TOVAR QUINTERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04228150410",
      "client_email": "JHONTOV1@GMAIL.COM",
      "address": "AV INTERCOMUNAL MARACAY TURMERO EDIF 12 PISO 2 APTO 02-047 URB LA CASONA II TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V20108096",
      "nap_box_name": "CE - 279",
      "created_at": "2024-04-12T09:05:41.240232",
      "service_detail": {
        "id": 4129,
        "ip": "172.25.174.2",
        "mac": "TPLGF9CD4726",
        "serial": "TPLGF9CD4726",
        "queue": "queue1",
        "interface": "VLAN110_CASONA_2",
        "created_at": "2024-07-30T15:30:26.886157",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3352,
      "client_name": "KHEIBER JESUS COLMENARES ZERPA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Bicentenario",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124324400",
      "client_email": "CKEIBHER@GMAIL.COM",
      "address": "CALLE ARAGUANEY CASA NRO 5 SECTOR BICENTENARIO ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V30147571",
      "nap_box_name": "CTO-00446",
      "created_at": "2024-04-12T09:08:14.734015",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3353,
      "client_name": "ANA YAMILETH BANDRES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Concepcion",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04141445879",
      "client_email": "ANA.BANDRES.27@GMAIL.COM",
      "address": "CALLE 2 CASA NRO 33 URB LA CONCEPCION LA JULIA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V13907271",
      "nap_box_name": "109",
      "created_at": "2024-04-12T09:09:40.139502",
      "service_detail": {
        "id": 5554,
        "ip": "172.27.151.2",
        "mac": "TPLGF9CD4762",
        "serial": "TPLGF9CD4762",
        "queue": "Plan_131338_24341_WispHub",
        "interface": "VLAN111_CONCEPCION",
        "created_at": "2024-08-16T22:40:08.982827",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3354,
      "client_name": "JEIRUSKA DE LOS ANGELES SUAREZ YDROGO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Esperanza",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04129191271",
      "client_email": "JEIRUSKASUAREZ26@GMAIL.COM",
      "address": "CALLE 7 CASA NRO 10 URB LA ESPERANZA SECTOR EL MACARO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V21202658",
      "nap_box_name": "CE - 451",
      "created_at": "2024-04-12T09:10:01.493302",
      "service_detail": {
        "id": 12977,
        "ip": "172.27.174.2",
        "mac": "HW:TC:54:93:57:A3",
        "serial": "HWTC549357A3",
        "queue": null,
        "interface": "VLAN137_LA_ESPERANZA_OLT_ZTE",
        "created_at": "2026-09-04T10:13:18.679239",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3355,
      "client_name": "ANGEL DANIEL CESPEDES RAMIREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Concepcion III",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04244720046",
      "client_email": "DANIELCESPEDES1995@GMAIL.COM",
      "address": "CALLE GUERITO CASA SECTOR LA CONCEPCIÓN TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V25522443",
      "nap_box_name": "CTO-00456",
      "created_at": "2024-04-12T09:10:17.855093",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3356,
      "client_name": "JULIA FLORISMAR CARRASQUEL",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villa De San Jose",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144520581",
      "client_email": "FLORISMARGONZALEZ2002@GMAIL.COM",
      "address": "CALLE PRINCIPAL CASA NRO 01-03 URB VILLA DE SAN JOSE TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V13152891",
      "nap_box_name": "CTO-00080",
      "created_at": "2024-04-12T09:12:50.464355",
      "service_detail": {
        "id": 3299,
        "ip": "172.25.152.2",
        "mac": "TPLGF9CD44AF",
        "serial": "TPLGF9CD44AF",
        "queue": "Plan_129887_1574_WispHub",
        "interface": "VLAN134_VILLAS_DSJ",
        "created_at": "2024-07-01T15:25:51.255748",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3357,
      "client_name": "CANDIDA ROSA PALACIOS HENRIQUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Bicentenario",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243470438",
      "client_email": "CANDIDAPALACIOS88@GMAIL.COM",
      "address": "CALLE LOS ROBLES MANZANA 10 CASA PLANTA ALTA NRO 14 URB DESARROLLO URBANISTICO ROSARIO",
      "client_identification": "V4544196",
      "nap_box_name": "CTO-00445",
      "created_at": "2024-04-12T09:15:01.852425",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3358,
      "client_name": "MIGUEL ANGEL ALBARRAN SULBARAN",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "PAUSADO_RESIDENCIAL",
      "status_name": "Pausado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman de Guere",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243411057",
      "client_email": "YURAIMAALBARRAN@GMAIL.COM",
      "address": "AV INTERCOMUNAL SAMAN DE GUERE CASA NRO 4 B1",
      "client_identification": "V3373538",
      "nap_box_name": "11",
      "created_at": "2024-04-12T09:19:09.078441",
      "service_detail": {
        "id": 3829,
        "ip": "172.20.113.2",
        "mac": "TPLGF5CB0916",
        "serial": "TPLGF5CB0916",
        "queue": "Plan_131647_24341_WispHub",
        "interface": "VLAN122_SAMAN_GUERE",
        "created_at": "2024-07-16T09:19:45.696177",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3360,
      "client_name": "OSWALDO ANTONIO NIEVES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Arboleda",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121481358",
      "client_email": "NIEVESOSWALDO9@GMAIL.COM",
      "address": "CALLE LOS MANGOS CASA NRO 22 BARRIO LA ARBOLEDA ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V13181853",
      "nap_box_name": "CTO-0485",
      "created_at": "2024-04-12T09:20:40.618479",
      "service_detail": {
        "id": 6631,
        "ip": "172.26.65.2",
        "mac": "TPLGF9CD4371",
        "serial": "TPLGF9CD4371",
        "queue": "Plan_161874_30181_WispHub",
        "interface": "VLAN257_ARBOLEDA",
        "created_at": "2024-09-17T12:15:14.981283",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3361,
      "client_name": "YOHANA DEL CARMEN DUARTE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Esperanza",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144585498",
      "client_email": "YOHANADUARTEVALERA@GMAIL.COM",
      "address": "CALLE 07 CASA NRO 20 URB LA EZPERANZA EL MACARO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V16266809",
      "nap_box_name": "CE - 451",
      "created_at": "2024-04-12T09:21:34.530953",
      "service_detail": {
        "id": 5557,
        "ip": "172.25.159.2",
        "mac": "TPLGF9CD3CE6",
        "serial": "TPLGF9CD3CE6",
        "queue": "Plan_129887_1574_WispHub",
        "interface": "VLAN137_LA_ESPERANZA_OLT_ZTE",
        "created_at": "2024-08-16T22:47:01.769046",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3362,
      "client_name": "ARNOLDO JOSE CONTRERAS RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243601679",
      "client_email": "ARNOLDOCONTRERAS8989@GMAIL.COM",
      "address": "CALLE 7-A CASA N7 PANTIN ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V19004296",
      "nap_box_name": "CTO-00139",
      "created_at": "2024-04-12T09:24:47.124764",
      "service_detail": {
        "id": 3535,
        "ip": "172.26.165.2",
        "mac": "HWTC54559DA3",
        "serial": "HWTC54559DA3",
        "queue": "Plan_161905_30183_WispHub",
        "interface": "VLAN229_PANTIN",
        "created_at": "2024-07-08T17:01:20.367544",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3363,
      "client_name": "ISABEL APONTE CATARI",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Terrazas de Paya",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243146387",
      "client_email": "ISABELAPONTECATARI78@GMAIL.COM",
      "address": "CALLE 1 CASA NRO 21 SECTOR TERRAZAS DE PAYA ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V11090365",
      "nap_box_name": "594",
      "created_at": "2024-04-12T09:25:18.970799",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3364,
      "client_name": "KLEYDIS CAROLINA ASCANIO PEÑA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Palmeras II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128826498",
      "client_email": "ASCANIOCAROLINA8@GMAIL.COM",
      "address": "CALLE 9 CASA NRO 147 URB LAS PALMERAS 2 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V19792009",
      "nap_box_name": "287",
      "created_at": "2024-04-12T09:27:17.185048",
      "service_detail": {
        "id": 5558,
        "ip": "172.26.36.2",
        "mac": "TPLGF9CD3D60",
        "serial": "TPLGF9CD3D60",
        "queue": "Plan_131337_24341_WispHub",
        "interface": "VLAN119_PALMERAS_2",
        "created_at": "2024-08-16T22:48:51.512940",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3365,
      "client_name": "CARLA TEODOLINDA RANGEL RANGEL",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04122079407",
      "client_email": "CARLAT3020@GMAIL.COM",
      "address": "SECTOR RIO SECO CALLE  29 CASA NRO 09 ROSARIO DE PAYA ZONA POSTAL 2115",
      "client_identification": "V14627312",
      "nap_box_name": "CTO-00253 DOS",
      "created_at": "2024-04-12T09:30:18.498251",
      "service_detail": {
        "id": 10253,
        "ip": "172.30.49.2",
        "mac": "HWTC4616CB9B",
        "serial": "HWTC4616CB9B",
        "queue": null,
        "interface": "VLAN251_RIO_SECO",
        "created_at": "2025-11-22T15:08:15.684594",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3366,
      "client_name": "REIDSON DANIEL CASADIEGO HERNANDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Canaima",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04145430783",
      "client_email": "RCASADIEGO3@GMAIL.COM",
      "address": "CALLE 06, TURMERO, ARAGUA",
      "client_identification": "V22949123",
      "nap_box_name": "356",
      "created_at": "2024-04-12T09:30:45.249259",
      "service_detail": {
        "id": 5561,
        "ip": "172.27.196.2",
        "mac": "HWTC90820A9B",
        "serial": "HWTC90820A9B",
        "queue": "queue1",
        "interface": "VLAN237_CANAIMA",
        "created_at": "2024-08-16T22:55:28.576356",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3367,
      "client_name": "JONATHAN ANTONIO PALMERA JALILIE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243273964",
      "client_email": "JPALMERA_15@HOTMAIL.COM",
      "address": "CALLE 04 CASA NRO 05 BARRIO PRADOS DE PAYA LL TURMERO EDO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V15992893",
      "nap_box_name": "CTO-00100",
      "created_at": "2024-04-12T09:33:04.321664",
      "service_detail": {
        "id": 3846,
        "ip": "172.26.194.2",
        "mac": "HWTCD10FAA9A",
        "serial": "HWTCD10FAA9A",
        "queue": "queue1",
        "interface": "VLAN242_PRADOS2",
        "created_at": "2024-07-16T13:26:05.254522",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3368,
      "client_name": "MARIA JOSE DE JESUS DELGADO FAJARDO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243141284",
      "client_email": "MARIJO806@GMAIL.COM",
      "address": "CALLE 18 CASA NRO 03 URB LA CASONA 2 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V17198325",
      "nap_box_name": "CTO-00086",
      "created_at": "2024-04-12T09:33:30.304104",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3369,
      "client_name": "MARIA LUCINDA GUTIERREZ DE NUÑEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04128840474",
      "client_email": "NUJHONATTAN@GMAIL.COM",
      "address": "CALLE MANZANA B-10 CASA NRO 4 URB SAMAN TARAZONERO II TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V12230903",
      "nap_box_name": "281",
      "created_at": "2024-04-12T09:34:00.970692",
      "service_detail": {
        "id": 5565,
        "ip": "172.27.198.2",
        "mac": "HWTC547582A3",
        "serial": "HWTC547582A3",
        "queue": "Plan_127996_1574_WispHub",
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2024-08-17T08:20:06.614581",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3370,
      "client_name": "ROSMARY JOSE SILVA OJEDA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Durpa",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04149461609",
      "client_email": "GILMINDA479@GMAIL.COM",
      "address": "MANZANA 20 CASA NRO 04 URB DESARROLLO URBANISTICO SECTOR DURPA",
      "client_identification": "V25955201",
      "nap_box_name": "390",
      "created_at": "2024-04-12T09:35:41.137061",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3371,
      "client_name": "YEILI FAIANLY ALVARADO LUGO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128878103",
      "client_email": "MAYEALV06@GMAIL.COM",
      "address": "CALLE MANZANA B8 CASA NRO 8 URB SAMAN TARAZONERO II TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V26535791",
      "nap_box_name": "186",
      "created_at": "2024-04-12T09:38:10.839480",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3372,
      "client_name": "SILVIA TERESA LANDAETA GONZALEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 19,
        "name": "RECURRENTE RESIDENCIAL PLAN 1GB",
        "cost": "74.70",
        "code": "FOR1GB",
        "profile": "1000M/1000M"
      },
      "client_mobile": "04243517989",
      "client_email": "SILVIALANDAETA0401@GMAIL.COM",
      "address": "AV PRINCIPAL DE PAYA CASA PARCELA 8 NRO 1 SECTOR ANTIGUA HACIENDA PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V7237608",
      "nap_box_name": "CTO-00131",
      "created_at": "2024-04-12T09:39:10.942478",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3373,
      "client_name": "JOHANA VIRGINIA ORTIZ RIVAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Magdalena",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04127768449",
      "client_email": "RIVASJOHANA752@GMAIL.COM",
      "address": "CALLE 01 CASA NRO 03 URB LA MAGDALENA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V27286546",
      "nap_box_name": "CTO-00472 DOS",
      "created_at": "2024-04-12T09:41:14.477711",
      "service_detail": {
        "id": 3256,
        "ip": "172.27.250.2",
        "mac": "TPLGF9CD44D4",
        "serial": "TPLGF9CD44D4",
        "queue": "Plan_137942_24341_WispHub",
        "interface": "VLAN114_MAGDALENA",
        "created_at": "2024-07-01T08:22:21.621292",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3374,
      "client_name": "LUISA VIRGINIA SALAZAR HERRERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Valle Paraiso",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243457565",
      "client_email": "LUISAVIR05@GMAIL.COM",
      "address": "URB VALLE PARAISO MANZANA 2 CASA 7 TURMERO ESTADO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V14430843",
      "nap_box_name": "CTO-0642",
      "created_at": "2024-04-12T09:44:13.669256",
      "service_detail": {
        "id": 13127,
        "ip": "172.25.165.2",
        "mac": "TP:LG:F9:CD:40:3D",
        "serial": "TPLGF9CD403D",
        "queue": null,
        "interface": "VLAN227_V_PARAISO_OLT1",
        "created_at": "2026-10-06T14:55:11.882806",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3375,
      "client_name": "AGUEDA JOSEFINA TORO ABREU",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128900934",
      "client_email": "AGUEDATOROABREU@GMAIL.COM",
      "address": "CALLE 1 PRINCIPAL CASA NRO 29 SECTOR PRADO I ROSARIO DE PAYA",
      "client_identification": "V6853164",
      "nap_box_name": "CTO-00304",
      "created_at": "2024-04-12T09:45:09.560933",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3376,
      "client_name": "ANTONIA DEL CARMEN BARAZARTE CONTRERAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04127908765",
      "client_email": "MORALESKAREN826@GMAIL.COM",
      "address": "CALLE 9 CASA NRO 17 BARRIO PRADOS 1 DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V10051716",
      "nap_box_name": "417",
      "created_at": "2024-04-12T09:46:38.239477",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3378,
      "client_name": "ALEXANDER RAFAEL GOMEZ LAMONT",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Haras de San Pablo",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04140507731",
      "client_email": "ALEXGOMEZL1004@GMAIL.COM",
      "address": "AV 4TA CRUCE CON CALLE HICELES MANZANA 08 CASA NRO 24-1 URB HARAS DE SAN PABLO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V10759486",
      "nap_box_name": "CTO-00161",
      "created_at": "2024-04-12T09:49:28.194893",
      "service_detail": {
        "id": 5579,
        "ip": "172.25.173.2",
        "mac": "TPLGF9CD4315",
        "serial": "TPLGF9CD4315",
        "queue": "Plan_140304_15811_WispHub",
        "interface": "VLAN210_HSP_OLT1",
        "created_at": "2024-08-17T08:58:44.269398",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3379,
      "client_name": "ANTONI JESUS BORGES BRITO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Santa Eduviges",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04122078875",
      "client_email": "ANTONIO19BORGES@GMAIL.COM",
      "address": "VDA 5 CASA NUMERO 16 SECTOR SANTA EDUVIGES TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V19604256",
      "nap_box_name": "87 DOS",
      "created_at": "2024-04-12T09:52:15.340147",
      "service_detail": {
        "id": 5581,
        "ip": "172.25.194.2",
        "mac": "TPLGF9CD3D5B",
        "serial": "TPLGF9CD3D5B",
        "queue": "Plan_138775_1574_WispHub",
        "interface": "VLAN127_SANTA_EDUVIGES",
        "created_at": "2024-08-17T09:00:48.837506",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3380,
      "client_name": "YADIRA DEL CARMEN LOZANO LOVERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Jabillar",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04123980969",
      "client_email": "YACAR72@GMAIL.COM",
      "address": "CALLE EL CARDON CASA NRO 16-08 URB JABILLAR TOWN COUNTRY TURMERO ARAGUA",
      "client_identification": "V12310093",
      "nap_box_name": "CTO-00004",
      "created_at": "2024-04-12T09:52:31.803060",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3381,
      "client_name": "LILIA VERONICA MONTENEGRO JIMENEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243063837",
      "client_email": "LIVE3333@HOTMAIL.COM",
      "address": "CALLE URDANETA QTA NRO 74 SECTOR CENTRO DE TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V11093895",
      "nap_box_name": "25",
      "created_at": "2024-04-12T09:55:09.441304",
      "service_detail": {
        "id": 5583,
        "ip": "172.25.191.2",
        "mac": "TPLGF9CD4556",
        "serial": "TPLGF9CD4556",
        "queue": "Plan_143066_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-08-17T09:05:53.617728",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3382,
      "client_name": "ALEXIS JAVIER BLANCO FERNANDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124625157",
      "client_email": "ALEXPOWER2525@GMAIL.COM",
      "address": "CALLE PRINCIPAL MANZANA J-4 CASA NRO 3 SECTOR SAMAN TARAZONERO II TURMERO ARAGUA",
      "client_identification": "V11843627",
      "nap_box_name": "278",
      "created_at": "2024-04-12T09:55:39.362292",
      "service_detail": {
        "id": 5584,
        "ip": "172.26.169.2",
        "mac": "HWTC4612599B",
        "serial": "HWTC4612599B",
        "queue": "Plan_129887_1574_WispHub",
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2024-08-17T09:12:21.863027",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3383,
      "client_name": "RICARDO JESUS GONZALEZ TERAN",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados III",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04144934798",
      "client_email": "DEISYMARILYNMONCADA@GMAIL.COM",
      "address": "CALLE 6 CASA NRO 11 SECTOR PRADOS III ROSARIO DE PAYA TURMERO ARAGUA ZONA 2115",
      "client_identification": "V22948989",
      "nap_box_name": "395",
      "created_at": "2024-04-12T10:01:06.963187",
      "service_detail": {
        "id": 5585,
        "ip": "172.25.172.2",
        "mac": "TPLGF9CD463B",
        "serial": "TPLGF9CD463B",
        "queue": "Plan_161895_30183_WispHub",
        "interface": "VLAN236_PRADOS3",
        "created_at": "2024-08-17T09:14:49.077240",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3384,
      "client_name": "NASVIHILLE EYSEL ACOSTA MARTINEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Floresta",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04123609856",
      "client_email": "NASEYSEL@GMAIL.COM",
      "address": "CALLE NEGRO PRIMERO QTA NARDI-NASVIHILE CALLE 3 NRO H-07 URB LA FLORESTA",
      "client_identification": "V25620844",
      "nap_box_name": "10",
      "created_at": "2024-04-12T10:02:02.483487",
      "service_detail": {
        "id": 9053,
        "ip": "172.29.41.2",
        "mac": "TPLGF9CD3DE2",
        "serial": "TPLGF9CD3DE2",
        "queue": "queue1",
        "interface": "VLAN212_FLORESTA_OLT1",
        "created_at": "2025-06-23T13:42:40.615233",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3385,
      "client_name": "LEIRY DAYANN BLANCO ORELLANA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243313207",
      "client_email": "LEIRYBLANCO2@GMAIL.COM",
      "address": "AV 02 CASA Nº 518B SECTOR LAS TETRAS, MATACABALLO ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V25813613",
      "nap_box_name": "CTO-00131",
      "created_at": "2024-04-12T10:04:05.879777",
      "service_detail": {
        "id": 4095,
        "ip": "172.25.198.2",
        "mac": "TPLGF9CD3D49",
        "serial": "TPLGF9CD3D49",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2024-07-23T08:59:55.999744",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3386,
      "client_name": "ERIKA JOSEFINA PLANCHEZ RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Tibisay Guevara",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04243082136",
      "client_email": "ROBERTGAMBOA999@GMAIL.COM",
      "address": "CALLE 2 CASA NRO 50 BARRIO TIBISAY GUEVARA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V13553897",
      "nap_box_name": "CTO-00055",
      "created_at": "2024-04-12T10:05:01.983262",
      "service_detail": {
        "id": 9661,
        "ip": "172.25.120.2",
        "mac": "TPLGF9CD3C6E",
        "serial": "TPLGF9CD3C6E",
        "queue": null,
        "interface": "VLAN248_TIBISAY_OLT2",
        "created_at": "2025-10-30T10:48:24.248990",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3387,
      "client_name": "GENIMAR SANCHEZ ROJAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243094701",
      "client_email": "JENIMARSANCHEZ81@GMAIL.COM",
      "address": "RÍO SECO, PRINCIPAL, TURMERO, ARAGUA",
      "client_identification": "V12171817",
      "nap_box_name": "472",
      "created_at": "2024-04-12T10:05:03.873186",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3389,
      "client_name": "ANNY LEIDY CASTILLO ALFONZO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Terrazas de Turmero",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128486856",
      "client_email": "YNNAOLLITSAC@GMAIL.COM",
      "address": "CALLE 2 CASA NRO6 URB TERRAZAS DE TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V16850945",
      "nap_box_name": "118",
      "created_at": "2024-04-12T10:08:30.729298",
      "service_detail": {
        "id": 6378,
        "ip": "172.26.201.2",
        "mac": "HWTCC18F729C",
        "serial": "HWTCC18F729C",
        "queue": "Plan_143066_15811_WispHub",
        "interface": "VLAN225_TERRAZAS_TURMERO_OLT1",
        "created_at": "2024-08-27T13:07:32.045820",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3391,
      "client_name": "NAIM ALBERTO MONRROY CARRILLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Floresta",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04123692735",
      "client_email": "NAIM7579@GMAIL.COM",
      "address": "CALLE CAMILO TORRES CASA CALLE 1 CASA NRO B-7 URB LA FLORESTA TURMERO ARAGUA",
      "client_identification": "V29772640",
      "nap_box_name": "34 DOS",
      "created_at": "2024-04-12T10:15:06.112867",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3393,
      "client_name": "CESAR ANTONIO MEDINA PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados III",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128997908",
      "client_email": "MOISEBI.14.18@GMAIL.COM",
      "address": "AV PRINCIPAL 1 MANZANA B CASA NRO 02 SECTOR PRADO DE PAYA 3 ROSARIO DE PAYA",
      "client_identification": "V18692991",
      "nap_box_name": "580 DOS",
      "created_at": "2024-04-12T10:43:08.927166",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3394,
      "client_name": "LINO VICENTE CHACON MENDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Concepcion",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243087270",
      "client_email": "LINO.CHACONTI@GMAIL.COM",
      "address": "CALLE 3 CASA NRO 19 URB LA CONCEPCION SECTOR LA CASONA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V31030813",
      "nap_box_name": "108",
      "created_at": "2024-04-12T10:50:35.740765",
      "service_detail": {
        "id": 5591,
        "ip": "172.26.127.2",
        "mac": "HWTCD664CF9C",
        "serial": "HWTCD664CF9C",
        "queue": "Plan_148293_24341_WispHub",
        "interface": "VLAN111_CONCEPCION",
        "created_at": "2024-08-17T09:28:11.922705",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3395,
      "client_name": "OSCARY ALEJANDRA PEREZ BERNAEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Isaac Oliveira",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04140510051",
      "client_email": "OSCARY_A@HOTMAIL.COM",
      "address": "URB ISAAC OLIVEIRA I CALLE 2 74 SAMAN DE GUERE",
      "client_identification": "V19032006",
      "nap_box_name": "CTO-00262",
      "created_at": "2024-04-12T10:55:35.150091",
      "service_detail": {
        "id": 11828,
        "ip": "172.24.139.2",
        "mac": "TPLGF4B1D877",
        "serial": "TPLGF4B1D877",
        "queue": null,
        "interface": "VLAN107_ISAAC_O",
        "created_at": "2026-02-27T11:48:55.465427",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3396,
      "client_name": "ARELYS JOSEFINA RUIZ CORTEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villas Del Sur",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128480949",
      "client_email": "ARELIS.RUIZ.CORTEZ73@GMAIL.COM",
      "address": "CALLE TEREPAIMA CASA NRO 18 BARRIO VILLA DEL SUR TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V10272327",
      "nap_box_name": "632",
      "created_at": "2024-04-12T11:03:35.387441",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3397,
      "client_name": "YINELIA BRUNILDA MEJIAS ZACARIAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Los Hornos",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04124821277",
      "client_email": "YINEILAMEJIAS075@GMAIL.COM",
      "address": "CALLE 7 CASA NRO 14 SECTOR LOS HORNOS DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V16864280",
      "nap_box_name": "CTO-00288",
      "created_at": "2024-04-12T11:08:18.100976",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3399,
      "client_name": "ALANS ENRIQUE ASCANIO MEJIAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04249523202",
      "client_email": "PAOLAKAGRAZ2310@GMAIL.COM",
      "address": "CALLE 11 CASA NRO 657-C SECTOR LAS TETRAS ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL L2115",
      "client_identification": "V10759281",
      "nap_box_name": "CTO-00213",
      "created_at": "2024-04-12T11:33:21.800902",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3401,
      "client_name": "DORELYS ADRIANA ARQUIZONES LUNA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Brisas de Paya",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124326418",
      "client_email": "DORELYSARGUINZONES1@GMAIL.COM",
      "address": "CALLE TRANSVERSAL CLL - 2 CASA NRO 1 ZONA BRISAS DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V17575728",
      "nap_box_name": "371",
      "created_at": "2024-04-12T11:52:03.436678",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3402,
      "client_name": "CARMEN MILAGROS ROJAS AVILA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Las Rurales",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243229879",
      "client_email": "GLEIDCAR@GMAIL.COM",
      "address": "ROSARIO DE PAYA CALLE CRUCE CASA S/N LAS RURALES  ( LADO IZQUIERDO DE LA IGLESIA)",
      "client_identification": "V14182001",
      "nap_box_name": "CTO-00361",
      "created_at": "2024-04-12T11:58:11.041290",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3403,
      "client_name": "ESMERALDA DEL VALLE BARRIOS PERDOMO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villeguita",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04143953115",
      "client_email": "ESMERALDADVBARRIOSP1301@GMAIL.COM",
      "address": "CALLE RAUL LEONI CASA NRO 13 SECTOR VILLEGUITA 1 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V11087497",
      "nap_box_name": "498",
      "created_at": "2024-04-12T13:09:28.086126",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3404,
      "client_name": "ERIKA MAILETT PARRA GUEDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243117730",
      "client_email": "YOSLEDY.2021@GMAIL.COM",
      "address": "CALLE 9 CASA NRO 49 URB PANTIN ROSARIO DE PAYA TURMERO CODIGO POSTAL 2115",
      "client_identification": "V12567096",
      "nap_box_name": "CTO-00122",
      "created_at": "2024-04-12T13:13:46.226441",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3405,
      "client_name": "YURIANIT DEL VALLE HERNANDEZ DE CEDEÑO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Terrazas de Paya",
      "plan": {
        "id": 101,
        "name": "RECURRENTE RESIDENCIAL PLAN 200M",
        "cost": "19.00",
        "code": "FOR200MB",
        "profile": "200Mbps/200Mbps"
      },
      "client_mobile": "04125233125",
      "client_email": "YURIANIT@HOTMAIL.COM",
      "address": "CALLE 4 MANZANA CASA 18 TERRAZAS DE PAYA ROSARIO DE PAYA ZONA POSTAL 2115",
      "client_identification": "V15864993",
      "nap_box_name": "421",
      "created_at": "2024-04-12T13:18:26.182360",
      "service_detail": {
        "id": 11392,
        "ip": "172.26.113.2",
        "mac": "HWTCD1419D9A",
        "serial": "HWTCD1419D9A",
        "queue": null,
        "interface": "VLAN243_BICENTENARIO",
        "created_at": "2026-01-26T15:47:13.560923",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3406,
      "client_name": "ALEXANDRA MIRILEXIS PERDOMO SANCHEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Concepcion",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128369389",
      "client_email": "ALEXANDRAPERDOMOSANCHEZ@GMAIL.COM",
      "address": "AV INTERCOMUNAL EDIF 7 PISO 3 APTO 4 URB LA CONCEPCION TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V23587996",
      "nap_box_name": "623",
      "created_at": "2024-04-12T13:27:22.611942",
      "service_detail": {
        "id": 5599,
        "ip": "172.25.14.2",
        "mac": "TPLGF9CD46F7",
        "serial": "TPLGF9CD46F7",
        "queue": "Plan_148293_24341_WispHub",
        "interface": "VLAN111_CONCEPCION",
        "created_at": "2024-08-17T09:58:11.416603",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3407,
      "client_name": "ANGELICA MINERVA WINDERVOXCHEL HERRERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villeguita",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243093030",
      "client_email": "RIKKU.ALESSO@GMAIL.COM",
      "address": "CALLE PARAISO CASA NRO 24 SECTOR LAS PALMAS VILLEGUITA",
      "client_identification": "V24171523",
      "nap_box_name": "445",
      "created_at": "2024-04-12T13:27:26.752817",
      "service_detail": {
        "id": 3278,
        "ip": "172.21.25.2",
        "mac": "TPLGF4EFC44A",
        "serial": "TPLGF4EFC44A",
        "queue": "Plan_137942_24341_WispHub",
        "interface": "VLAN141_PLAZA_JARDIN",
        "created_at": "2024-07-01T11:38:17.442479",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3408,
      "client_name": "ELYS EDUARDO BOLIVAR CARMONA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman de Guere",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128968929",
      "client_email": "LISSETHBRITO.2502@GMAIL.COM",
      "address": "CALLE LA LLANERA CASA NRO 05 BARRIO SAMAN DE GUERE TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V10758427",
      "nap_box_name": "465",
      "created_at": "2024-04-12T13:29:50.130410",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3409,
      "client_name": "LUIS LEONEL ARMAS PULIDO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04127875689",
      "client_email": "LEONEL17STARK@GMAIL.COM",
      "address": "CALLE 12-B CASA NRO 31 A URB LOS PANTIN ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V25527515",
      "nap_box_name": "CTO-00166",
      "created_at": "2024-04-12T13:32:57.057883",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3410,
      "client_name": "TAMARA LISSETH VILLARROEL TALABERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Callejon Lim",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04166426481",
      "client_email": "VILLARROA77@GMAIL.COM",
      "address": "AV LIN EDIF MAGNOLIA PISO P/B APTO 02 URB VILLAS DE TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V13133207",
      "nap_box_name": "CTO-0563",
      "created_at": "2024-04-12T13:35:38.379268",
      "service_detail": {
        "id": 12496,
        "ip": "172.25.142.2",
        "mac": "TP:LG:F9:CD:45:3D",
        "serial": "TPLGF9CD453D",
        "queue": null,
        "interface": "VLAN250_LIM_OLT2",
        "created_at": "2026-05-15T11:33:12.013317",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3411,
      "client_name": "ERIKA ELIZABETH JIMENEZ ALVES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero I",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04262362524",
      "client_email": "EJ7648393@GMAIL.COM",
      "address": "CALLE 3 CASA 8 SECTOR SAMAN TARAZONERO I TURMERO ARAGUA",
      "client_identification": "V23801986",
      "nap_box_name": "291",
      "created_at": "2024-04-12T13:38:03.779618",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3412,
      "client_name": "TOWFIQUR RAHAMAN ABDOEL",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Antigua Hacienda De Paya",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04143454007",
      "client_email": "SECRETARIA@IPT.COM.VE",
      "address": "CALLE DOMINGO DE TOVAR CASA LOS RAHAMAN NRO 28-03 PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V6205371",
      "nap_box_name": "100 DOS",
      "created_at": "2024-04-12T13:38:26.164947",
      "service_detail": {
        "id": 13110,
        "ip": "172.25.148.2",
        "mac": "JM:KG:C3:B8:EF:D5",
        "serial": "JMKGC3B8EFD5",
        "queue": null,
        "interface": "VLAN202_AHP_OLT1",
        "created_at": "2026-10-03T11:57:03.844730",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3413,
      "client_name": "GRIS MERIS GALINDEZ SUAREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144492276",
      "client_email": "GRISMERISGALINDEZ@GMAIL.COM",
      "address": "CALLE 12 CASA NRO 698 A SECTOR MATA CABALLO ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V20770389",
      "nap_box_name": "CTO-00020",
      "created_at": "2024-04-12T13:40:29.177684",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3414,
      "client_name": "MAGNELYS DEL CARMEN PEREZ PERDOMO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Simon Bolivar",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04140477645",
      "client_email": "MAGNELYSPEREZ@GMAIL.COM",
      "address": "CALLE 12 NRO SIMON BOLIVAR EL MACARO TURMERO",
      "client_identification": "V9693521",
      "nap_box_name": "CTO-00036",
      "created_at": "2024-04-12T13:42:19.440084",
      "service_detail": {
        "id": 4156,
        "ip": "172.21.73.2",
        "mac": "TPLGB954E8FD",
        "serial": "TPLGB954E8FD",
        "queue": "Plan_127996_1574_WispHub",
        "interface": "VLAN128_SIMON_BOLIVAR_ZTE",
        "created_at": "2024-08-01T11:51:31.936852",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3415,
      "client_name": "YACKENA YOSELIN MEDINA BLANCO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Macaro",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243262420",
      "client_email": "YACKENAMEDINA1483@GMAIL.COM",
      "address": "CALLE PARCELA 24 CASA NR01 SECTOR EL MACARO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V20334692",
      "nap_box_name": "500",
      "created_at": "2024-04-12T13:43:02.821206",
      "service_detail": {
        "id": 12252,
        "ip": "172.28.35.2",
        "mac": "TPLGF9CD3CAE",
        "serial": "TPLGF9CD3CAE",
        "queue": null,
        "interface": "VLAN104_EL_MACARO_OLT_ZTE",
        "created_at": "2026-04-05T11:53:49.934828",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3416,
      "client_name": "ELIZABETH PAREDES RUIZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Canaima",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128495527",
      "client_email": "ELIZABETH44.EP@GMAIL.COM",
      "address": "CALLE 6 CASA NRO 33 URB CANAIMA ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V9675005",
      "nap_box_name": "356",
      "created_at": "2024-04-12T13:48:17.405681",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3418,
      "client_name": "ASDRUBAL ANTONIO DIAZ CASAÑA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vallecito",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04140260796",
      "client_email": "LATINOLATINO.LATIN1@GMAIL.COM",
      "address": "CALLE ARAGUANEY CASA NRO 26 SECTOR COLINAS DE VALLECITO ROSARIO DE PAYA PARROQUIA AREVALO",
      "client_identification": "V15302161",
      "nap_box_name": "CTO-0479",
      "created_at": "2024-04-12T13:57:41.292374",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3419,
      "client_name": "EUCLIDES JOSE LAVERDE BOLIVAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04129824554",
      "client_email": "EUCLIDESLAVERDE28@GMAIL.COM",
      "address": "CALLE 14-B CASA NRO 43 URB PANTIN ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V13945836",
      "nap_box_name": "CTO-00052",
      "created_at": "2024-04-12T14:03:50.650792",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3421,
      "client_name": "YARITZA YERLYS HERNANDEZ NIÑO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04149457945",
      "client_email": "YERLISHERNANDEZ2010@HOTMAIL.COM",
      "address": "CALLE 10-B CASA NRO 23 URB HACIENDA PANTIN ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V17575231",
      "nap_box_name": "CTO-00141",
      "created_at": "2024-04-12T14:11:35.820454",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3422,
      "client_name": "JOSE REINALDO DELGADO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121492780",
      "client_email": "JD7635458@GMAIL.COM",
      "address": "NRO-13 MANZANA B-1 TRANSVERSAL 2, UBICADA EN EL DESARROLLO URBANISTICO SAMAN TARAZONERO II MUNICIPIO SANTIAGO MARIÑO ZONA POSTAL 2115",
      "client_identification": "V17986579",
      "nap_box_name": "185",
      "created_at": "2024-04-12T14:13:36.502676",
      "service_detail": {
        "id": 6260,
        "ip": "172.24.117.2",
        "mac": "TPLGB446EE8F",
        "serial": "TPLGB446EE8F",
        "queue": "Plan_137413_1574_WispHub",
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2024-08-23T15:12:12.549323",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3423,
      "client_name": "CIRO ARELLANO URBINA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Simon Bolivar",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243785203",
      "client_email": "CRODA03@GMAIL.COM",
      "address": "CALLE 3 CASA NRO 48 URB SIMON BOLIVAR SECTOR EL MACARO",
      "client_identification": "V13173117",
      "nap_box_name": "CTO-00046",
      "created_at": "2024-04-12T14:16:58.188426",
      "service_detail": {
        "id": 10055,
        "ip": "172.22.143.2",
        "mac": "TPLGBA6874AD",
        "serial": "TPLGBA6874AD",
        "queue": null,
        "interface": "VLAN100_OLTs",
        "created_at": "2025-11-12T09:33:15.576069",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3424,
      "client_name": "RICHARD JOSE MARCANO URBANO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04249140175",
      "client_email": "RICHARD.13.274@GMAIL.COM",
      "address": "AV BOLIVAR RESIDENCIAS EL PARAISO APTO 6-4 PISO 6 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V13075594",
      "nap_box_name": "CTO-0645",
      "created_at": "2024-04-12T14:25:29.224136",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3425,
      "client_name": "DARIANA CRUZELYS TOVAR BLANCO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Durpa",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04125972297",
      "client_email": "DANOANABLANCA89@GMAIL.COM",
      "address": "CALLE LIBERTAD MANZANA 14 CASA NRO 25 SECTOR DESARROLLO URBANISTICO",
      "client_identification": "V19032891",
      "nap_box_name": "377",
      "created_at": "2024-04-12T14:27:02.222529",
      "service_detail": {
        "id": 13195,
        "ip": "172.18.81.2",
        "mac": "VS:OL:00:52:2C:F9",
        "serial": "VSOL00522CF9",
        "queue": null,
        "interface": "VLAN240_DURPA",
        "created_at": "2026-10-19T11:12:14.079275",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3426,
      "client_name": "YORDANO JAVIER CONTRERAS PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04121484694",
      "client_email": "YORDANOJCP@GMAIL.COM",
      "address": "CALLE 6-A CASA NRO 2 SECTOR PANTIN ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V18175133",
      "nap_box_name": "CTO-0013B",
      "created_at": "2024-04-12T14:28:06.934295",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3427,
      "client_name": "FELIX JESUS USECHE RIVERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Callejon Lim",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04244166969",
      "client_email": "USECHERIVERO@GMAIL.COM",
      "address": "URBANISMO VILLA DE TURMERO TORRE MAGNOLIA PISO 3 APTO 14 TUMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V19553661",
      "nap_box_name": "CTO-0563",
      "created_at": "2024-04-12T14:38:28.185124",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3428,
      "client_name": "TULIO ANDRES LOPEZ MENDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04125155391",
      "client_email": "TULIOLOPEZ935@GMAIL.COM",
      "address": "CALLE 4 CASA NRO 1 SAMAN TARAZONERO I",
      "client_identification": "V23920073",
      "nap_box_name": "291",
      "created_at": "2024-04-12T14:38:39.137280",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3429,
      "client_name": "RAMONA PATRICIA MENDOZA RUIZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Durpa",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124613405",
      "client_email": "EDUYNPATRI@GMAIL.COM",
      "address": "CALLE LEALTAD MANZANA 21 CASA NRO 17 SECTOR DESARROLLO URBANISTICO ROSARIO DE PAYA TURMERO",
      "client_identification": "V9658062",
      "nap_box_name": "CTO-00320",
      "created_at": "2024-04-12T14:41:29.722583",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3430,
      "client_name": "CARLOS EDUARDO HERNANDEZ RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04129682958",
      "client_email": "2012CARLOS3A@GMAIL.COM",
      "address": "VDA MANZANA J2 CASA NRO 10 SAMAN TARAZONERO II TURMERO",
      "client_identification": "V19277173",
      "nap_box_name": "278",
      "created_at": "2024-04-12T14:46:24.823175",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3431,
      "client_name": "YONATHAN ENRIQUE RINCON GODOY",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados III",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121487688",
      "client_email": "RYONATHAN176@GMAIL.COM",
      "address": "CALLE 05 CASA NRO 14 SECTOR PRADOS DE PAYA III",
      "client_identification": "V20757199",
      "nap_box_name": "CTO-00305",
      "created_at": "2024-04-12T14:47:50.761182",
      "service_detail": {
        "id": 6437,
        "ip": "172.25.128.2",
        "mac": "TPLGF9CD4735",
        "serial": "TPLGF9CD4735",
        "queue": "Plan_161904_30183_WispHub",
        "interface": "VLAN236_PRADOS3",
        "created_at": "2024-08-28T16:57:18.223916",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3432,
      "client_name": "EDMARY STEFFANIA GOMEZ CARAPAI",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Palma Real",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243239882",
      "client_email": "EDMARYGOMEZ74@GMAIL.COM",
      "address": "CALLE 5 CASA NRO 100 SECTOR PALMA REAL ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2103",
      "client_identification": "V30211452",
      "nap_box_name": "404",
      "created_at": "2024-04-12T14:49:02.860546",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3433,
      "client_name": "NERYS YRAIDA CAMBERO JIMENEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121999442",
      "client_email": "URBINAWISNEIDY@GMAIL.COM",
      "address": "CALLE 4 CASA NRO 24 SECTOR PRADOS DE PAYA II TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V10707754",
      "nap_box_name": "CTO-00100",
      "created_at": "2024-04-12T14:52:03.024278",
      "service_detail": {
        "id": 6438,
        "ip": "172.25.132.2",
        "mac": "TPLGF9CD46E0",
        "serial": "TPLGF9CD46E0",
        "queue": "Plan_161904_30183_WispHub",
        "interface": "VLAN242_PRADOS2",
        "created_at": "2024-08-28T16:59:16.740303",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3434,
      "client_name": "MICHAEL ANTONIO MATUTE ACOSTA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04142971433",
      "client_email": "RINAM5561@GMAIL.COM",
      "address": "MATACABALLO CASA NRO 552 CALLE 7",
      "client_identification": "V17577599",
      "nap_box_name": "CTO-00310",
      "created_at": "2024-04-12T14:52:46.760603",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3435,
      "client_name": "JUAN CARLO FLORES AREVALO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121488321",
      "client_email": "JUANCARLOFLORES116@GMAIL.COM",
      "address": "ROSARIO DE PAYA SECTOR PANTIN CALLE 14B CASA NRO 50 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V10455342",
      "nap_box_name": "CTO-00052",
      "created_at": "2024-04-12T14:54:03.261198",
      "service_detail": {
        "id": 8377,
        "ip": "172.27.227.2",
        "mac": "TPLGF908C27C",
        "serial": "TPLGF908C27C",
        "queue": "queue1",
        "interface": "VLAN229_PANTIN",
        "created_at": "2025-04-26T09:07:29.213048",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3436,
      "client_name": "ESTHER MARTINEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados III",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04127684071",
      "client_email": "ESTHER2014675@GMAIL.COM",
      "address": "CALLE 02 CASA NRO 02 SECTOR PRADOS III",
      "client_identification": "V8797957",
      "nap_box_name": "CTO-00284 DOS",
      "created_at": "2024-04-12T14:54:32.138810",
      "service_detail": {
        "id": 6289,
        "ip": "172.30.77.2",
        "mac": "TPLGF9CD3CB5",
        "serial": "TPLGF9CD3CB5",
        "queue": "Plan_161904_30183_WispHub",
        "interface": "VLAN236_PRADOS3",
        "created_at": "2024-08-23T16:51:35.274230",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3437,
      "client_name": "GEOVANIS AREVALO VELASCO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Aduana",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124165245",
      "client_email": "GEOVANIS.AREVALO@GMAIL.COM",
      "address": "CALLE BERMUDEZ CASA NRO 64-SECTOR LA ADUANA TURMERO",
      "client_identification": "V22421171",
      "nap_box_name": "CTO-00097",
      "created_at": "2024-04-12T14:56:32.443298",
      "service_detail": {
        "id": 3434,
        "ip": "172.22.92.2",
        "mac": "TPLGBA688232",
        "serial": "TPLGBA688232",
        "queue": "queue1",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-07-04T08:07:41.806196",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3438,
      "client_name": "LUIS ERNESTO PARADA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Julia",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243516393",
      "client_email": "LPARADA753@GMAIL.COM",
      "address": "CALLE HAYDEE MARQUEZ CASA NRO URB COLECTIVO LA NUEVA JULIA",
      "client_identification": "V13491087",
      "nap_box_name": "628",
      "created_at": "2024-04-12T14:56:58.907293",
      "service_detail": {
        "id": 3298,
        "ip": "172.25.114.2",
        "mac": "TPLGF9CD4653",
        "serial": "TPLGF9CD4653",
        "queue": "Plan_131647_24341_WispHub",
        "interface": "VLAN138_LAJULIA",
        "created_at": "2024-07-01T15:23:31.599898",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3439,
      "client_name": "RAQUEL ELIANI RUIZ GARCIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124485538",
      "client_email": "RAQUELGYM.RR@GMAIL.COM",
      "address": "CALLE 17 CASA NRO 44 SECTOR RIO SECO ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V30644172",
      "nap_box_name": "CTO-00070",
      "created_at": "2024-04-12T14:58:19.403590",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3440,
      "client_name": "MARTA MARIA ALVAREZ DE RUJANO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Durpa",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04122982667",
      "client_email": "JOSERUJANO584@GMAIL.COM",
      "address": "CALLE LOS CAOBOS MANZANA 18 NRO 1 DESARROLLO URBANISTICO DURPA",
      "client_identification": "V6163838",
      "nap_box_name": "392",
      "created_at": "2024-04-12T15:05:55.130538",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3441,
      "client_name": "FRANK RAUL CARMONA SOUQUET",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados de Cafetal",
      "plan": {
        "id": 43,
        "name": "RECURRENTE RESIDENCIAL PLAN 650M",
        "cost": "46.00",
        "code": "FOR650M",
        "profile": "650M/650M"
      },
      "client_mobile": "04244654026",
      "client_email": "FERREINOX.C.A@HOTMAIL.COM",
      "address": "CALLE 2 CASA NRO 7-1 URB PRADO DEL CAFETAL TURMERO",
      "client_identification": "V9957959",
      "nap_box_name": "85",
      "created_at": "2024-04-12T15:10:42.594229",
      "service_detail": {
        "id": 6188,
        "ip": "172.19.151.2",
        "mac": "TPLGB954EEE9",
        "serial": "TPLGB954EEE9",
        "queue": "Plan_143067_15811_WispHub",
        "interface": "VLAN221_CAFETAL_OLT1",
        "created_at": "2024-08-22T18:24:59.029689",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3442,
      "client_name": "LETICIA DEL CARMEN ROMERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04127768821",
      "client_email": "RLETY0716@GMAIL.COM",
      "address": "CALLE 17A CASA NRO 7 URB PANTIN ROSARIO DE PAYA",
      "client_identification": "V17396000",
      "nap_box_name": "CTO-00101",
      "created_at": "2024-04-12T15:10:53.381343",
      "service_detail": {
        "id": 6186,
        "ip": "172.22.158.2",
        "mac": "TPLGBA68837B",
        "serial": "TPLGBA68837B",
        "queue": "Plan_161901_30183_WispHub",
        "interface": "VLAN229_PANTIN",
        "created_at": "2024-08-22T18:23:08.897352",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3443,
      "client_name": "OMAR ALEJANDRO SANABRIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Guanarito",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04145915076",
      "client_email": "OMAR1SANABRIA@GMAIL.COM",
      "address": "CALLE MENARDO CORONADO CASA NRO 22 SECTOR GUANARITO TURMERO",
      "client_identification": "V25698626",
      "nap_box_name": "CTO-00214",
      "created_at": "2024-04-12T15:13:15.061259",
      "service_detail": {
        "id": 7451,
        "ip": "172.23.224.2",
        "mac": "VSOL0013B1F9",
        "serial": "VSOL0013B1F9",
        "queue": "Plan_92194_15811_WispHub",
        "interface": "VLAN232_GUANARITO_OLT2",
        "created_at": "2024-12-16T15:55:25.940224",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3444,
      "client_name": "VALERIA DANIELA PENA DELGADO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128571566",
      "client_email": "VALERIADPD.28@GMAIL.COM",
      "address": "CALLE 7B CASA NRO 46 URB PANTIN ROSARIO DE PAYA",
      "client_identification": "V29581616",
      "nap_box_name": "CTO-00140",
      "created_at": "2024-04-12T15:20:43.007183",
      "service_detail": {
        "id": 6182,
        "ip": "172.22.155.2",
        "mac": "TPLGBA68771E",
        "serial": "TPLGBA68771E",
        "queue": "Plan_161906_30183_WispHub",
        "interface": "VLAN229_PANTIN",
        "created_at": "2024-08-22T18:19:20.425300",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3446,
      "client_name": "BRENDA PAOLA GIL TRILLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243468271",
      "client_email": "BGILTRILLO@GMAIL.COM",
      "address": "AVENIDA PRINCIPAL CALLE 17B CASA NRO 53 SECTOR PANTIN",
      "client_identification": "V26935797",
      "nap_box_name": "CTO-00048",
      "created_at": "2024-04-12T15:26:24.721677",
      "service_detail": {
        "id": 8962,
        "ip": "172.17.186.2",
        "mac": "VSOL0012A079",
        "serial": "VSOL0012A079",
        "queue": "queue1",
        "interface": "VLAN229_PANTIN",
        "created_at": "2025-06-17T10:02:46.781131",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3447,
      "client_name": "ADRIAN JOSE PADILLA BRIZUELA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128863677",
      "client_email": "ADRIAN_123P@OUTLOOK.COM",
      "address": "CALLE 18A CASA NRO 25 URB PANTIN ROSARIO DE PAYA",
      "client_identification": "V20023613",
      "nap_box_name": "CTO-00434",
      "created_at": "2024-04-12T15:30:57.547239",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3448,
      "client_name": "YANETTE CLARITZA MAGDALENO MARIN",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Magdalena",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121477986",
      "client_email": "yanetmagdaleno522@gmail.com",
      "address": "AV PRINCIPAL 1 CALLE 13 CASA NRO 6 URB LA MAGDALENA TURMERO ARAGUA",
      "client_identification": "V9680335",
      "nap_box_name": "428",
      "created_at": "2024-04-12T15:53:50.928773",
      "service_detail": {
        "id": 9979,
        "ip": "172.27.108.2",
        "mac": "TPLGF4EFC22D",
        "serial": "TPLGF4EFC22D",
        "queue": null,
        "interface": "VLAN114_MAGDALENA",
        "created_at": "2025-11-11T12:33:05.657813",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3449,
      "client_name": "JOSE DE JESUS ALVAREZ MONTILLA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero I",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128988259",
      "client_email": "JOSEJ.ALVAREZ78@GMAIL.COM",
      "address": "CALLE 3 CASA NRO 154 URB LAS PALMERAS I SECTOR LA JULIA TURMERO ARAGUA",
      "client_identification": "V13454747",
      "nap_box_name": "669",
      "created_at": "2024-04-12T16:00:56.651360",
      "service_detail": {
        "id": 3341,
        "ip": "172.30.73.2",
        "mac": "TPLG2ABDC68C",
        "serial": "TPLG2ABDC68C",
        "queue": "queue1",
        "interface": "VLAN118_PALMERAS_1",
        "created_at": "2024-07-02T15:52:58.627315",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3450,
      "client_name": "CARMEN PAQUITA FLORES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Antigua Hacienda De Paya",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04145878754",
      "client_email": "PACA_27_29@HOTMAIL.COM",
      "address": "CALLE CALLEJON 15 SAN JOSE ANTIGUA HACIENDA DE PAYA ROSARIO DE PAYA NRO 14",
      "client_identification": "V4916719",
      "nap_box_name": "CTO-00183",
      "created_at": "2024-04-12T16:01:11.894884",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3451,
      "client_name": "LUIS ALFREDO ROJAS MARCHAN",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243365446",
      "client_email": "LUISROJAS113@HOTMAIL.COM",
      "address": "CASONA II CALLE 14 CASA NRO 70",
      "client_identification": "V22343469",
      "nap_box_name": "CTO-00120",
      "created_at": "2024-04-12T16:04:58.251570",
      "service_detail": {
        "id": 9774,
        "ip": "172.23.241.2",
        "mac": "VSOL0013B4E9",
        "serial": "VSOL0013B4E9",
        "queue": null,
        "interface": "VLAN110_CASONA_2",
        "created_at": "2025-11-10T12:40:50.631111",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3452,
      "client_name": "MARIA FERNANDA BLANCO TOVAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Concepcion",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04125987241",
      "client_email": "BLANCOTOVARMARIAFERNANDA@GMAIL.COM",
      "address": "TORRE 9 PISO 3 APARTAMENTO 8 LA CONCEPCION TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V25880252",
      "nap_box_name": "0325 DOS",
      "created_at": "2024-04-12T16:05:09.979691",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3453,
      "client_name": "CARMEN JOSEFINA BERNAEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Concepcion",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243225002",
      "client_email": "CARMENBERNAEZ81@GMAIL.COM",
      "address": "CALLE PRINCIPAL CASA NRO 04 URB LA CONCEPCION TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V9696311",
      "nap_box_name": "108",
      "created_at": "2024-04-12T16:07:33.827499",
      "service_detail": {
        "id": 6179,
        "ip": "172.25.129.2",
        "mac": "TPLGF9CD465D",
        "serial": "TPLGF9CD465D",
        "queue": "queue1",
        "interface": "VLAN111_CONCEPCION",
        "created_at": "2024-08-22T18:15:16.861165",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3454,
      "client_name": "XAVIER JOSE MACHADO OLIVEROS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Guanarito",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144770562",
      "client_email": "XAVIERMACHADO7@GMAIL.COM",
      "address": "CALLE LA ESTRELLA CASA NRO 9 SECTOR GUANARITO TURMERO",
      "client_identification": "V28023758",
      "nap_box_name": "231",
      "created_at": "2024-04-12T16:10:33.704574",
      "service_detail": {
        "id": 9054,
        "ip": "172.24.106.2",
        "mac": "TPLGB444B4CB",
        "serial": "TPLGB444B4CB",
        "queue": "queue1",
        "interface": "VLAN232_GUANARITO_OLT2",
        "created_at": "2025-06-23T13:49:15.520817",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3455,
      "client_name": "AURA TERESA CARVAJAL BERROTERAN",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04120438557",
      "client_email": "AURACARVAJAL2020@GMAIL.COM",
      "address": "CALLE 16-A CASA NRO 12 SECTOR PANTIN ROSARIO DE PAYA TURMERO",
      "client_identification": "V8155160",
      "nap_box_name": "CTO-00195",
      "created_at": "2024-04-12T16:11:58.334168",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3456,
      "client_name": "VICTOR MANUEL CONTRERAS VARELA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Valle Paraiso",
      "plan": {
        "id": 16,
        "name": "RECURRENTE RESIDENCIAL PLAN 800M",
        "cost": "55.00",
        "code": "FOR800",
        "profile": "800M/800M"
      },
      "client_mobile": "04121486870",
      "client_email": "VMCONTRERASH@GMAIL.COM",
      "address": "CALLE SAN PABLO CASA NRO 6URB VALLE PARAISO TURMERO",
      "client_identification": "V23792452",
      "nap_box_name": "CTO-0643",
      "created_at": "2024-04-12T16:14:54.258993",
      "service_detail": {
        "id": 4939,
        "ip": "172.21.182.2",
        "mac": "TPLGB68B4E01",
        "serial": "TPLGB68B4E01",
        "queue": "Plan_128610_15811_WispHub",
        "interface": "VLAN227_V_PARAISO_OLT1",
        "created_at": "2024-08-13T13:24:26.398199",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3458,
      "client_name": "KELLYS MARIA ROJAS UBAN",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128841252",
      "client_email": "LEYDYSMARTINEZ16@GMAIL.COM",
      "address": "VDA MANZANA C14 CASA 14 SAMAN TARAZONERO II TURMERO ARAGUA",
      "client_identification": "V18638761",
      "nap_box_name": "CTO-00064",
      "created_at": "2024-04-12T16:16:09.698350",
      "service_detail": {
        "id": 5623,
        "ip": "172.27.40.2",
        "mac": "GPON0097AC26",
        "serial": "GPON0097AC26",
        "queue": "Plan_127744_1574_WispHub",
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2024-08-17T11:02:01.522405",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3459,
      "client_name": "ALEJANDRO BRIZUELA GARRIDO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villa De San Jose",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04149470909",
      "client_email": "BRIZUELAALE@HOTMAIL.COM",
      "address": "CALLE NEGRO PRIMERO CASA NRO 35 SECTOR PUEBLO NUEVO TURMERO",
      "client_identification": "V7444556",
      "nap_box_name": "14",
      "created_at": "2024-04-12T16:17:11.347659",
      "service_detail": {
        "id": 4021,
        "ip": "172.17.251.2",
        "mac": "VSOL0051E499",
        "serial": "VSOL0051E499",
        "queue": "Plan_137413_1574_WispHub",
        "interface": "VLAN134_VILLAS_DSJ",
        "created_at": "2024-07-18T15:28:19.510037",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3460,
      "client_name": "MARCELO MORAGUES CARDOZO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados III",
      "plan": {
        "id": 16,
        "name": "RECURRENTE RESIDENCIAL PLAN 800M",
        "cost": "55.00",
        "code": "FOR800",
        "profile": "800M/800M"
      },
      "client_mobile": "04243483842",
      "client_email": "MARC6629@GMAIL.COM",
      "address": "CALLE 5 CASA NRO 28 SECTOR 3 PRADOS DE PAYA TURMERO",
      "client_identification": "V24801303",
      "nap_box_name": "CTO-00305",
      "created_at": "2024-04-12T16:19:16.176999",
      "service_detail": {
        "id": 6328,
        "ip": "172.24.25.2",
        "mac": "VSOL001396A9",
        "serial": "VSOL001396A9",
        "queue": "Plan_161871_30181_WispHub",
        "interface": "VLAN236_PRADOS3",
        "created_at": "2024-08-24T08:13:36.495774",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3461,
      "client_name": "BEATRIZ JOSEFINA MONTENEGRO CARREÑO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona II Edificios",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243023298",
      "client_email": "BMONTENEGRO.ARTERION@GMAIL.COM",
      "address": "AV INTERCOMUNAL SANTIAGO MARIÑO EDIF G PISO PB ALA SUR APTO 4 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V22944415",
      "nap_box_name": "CTO-0540",
      "created_at": "2024-04-12T16:20:49.620175",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3462,
      "client_name": "YURIMA ODALIS ALCANTARA PALMA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04127560655",
      "client_email": "APARICIOJRH@GMAIL.COM",
      "address": "CALLE 4 CASA NRO 249 SECTOR MATA CABALLO TURMERO",
      "client_identification": "V18109438",
      "nap_box_name": "CTO-00265",
      "created_at": "2024-04-12T16:21:32.431660",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3463,
      "client_name": "HAYDEE MARBELLA PERNIA GONZALEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Canaima",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128862429",
      "client_email": "YESSEP251@GMAIL.COM",
      "address": "CALLE 1 CON CALLE A CASA NRO 1 URB DESARROLLO HABITACIONAL CANAIMA",
      "client_identification": "V10785769",
      "nap_box_name": "CTO-00172 ",
      "created_at": "2024-04-12T16:23:29.548511",
      "service_detail": {
        "id": 3749,
        "ip": "172.18.65.2",
        "mac": "TPLGF4B1D3FB",
        "serial": "TPLGF4B1D3FB",
        "queue": "queue1",
        "interface": "VLAN237_CANAIMA",
        "created_at": "2024-07-12T17:06:06.680294",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3464,
      "client_name": "LILIANA JAQUELINE HERNANDEZ GONZALEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados I",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128902358",
      "client_email": "HERNANDEZGONZALEZL139@GMAIL.COM",
      "address": "CALLE 13 CASA NRO 34 SECTOR PRADOS I ROSARIO DE PAYA",
      "client_identification": "V12610616",
      "nap_box_name": "CTO-0589",
      "created_at": "2024-04-12T16:23:39.975593",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3465,
      "client_name": "BELKYS YAJAIRA VIVAS SANCHEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Taguapire",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04140483626",
      "client_email": "BELKYSVIVAS@HOTMAIL.COM",
      "address": "CTRA NACIONAL TURMERO MARACAY EDIF MODULO 13 PISO PB APT 122 URB TAGUAPIRE SECTOR EL MACARO",
      "client_identification": "V12137689",
      "nap_box_name": "CTO-00386",
      "created_at": "2024-04-12T16:25:45.783497",
      "service_detail": {
        "id": 10539,
        "ip": "172.19.204.2",
        "mac": "TPLGB954FA56",
        "serial": "TPLGB954FA56",
        "queue": null,
        "interface": "VLAN129_TAGUAPIRE_ZTE",
        "created_at": "2025-12-03T13:28:18.709168",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3466,
      "client_name": "JAVIER JESUS MIRANDA BETANCOURT",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243206823",
      "client_email": "DJJAVIER71@GMAIL.COM",
      "address": "CALLE 7B CASA NRO 41 URB PANTIN",
      "client_identification": "V29744780",
      "nap_box_name": "CTO-00140",
      "created_at": "2024-04-12T16:28:17.635740",
      "service_detail": {
        "id": 5616,
        "ip": "172.20.16.2",
        "mac": "VSOL00521419",
        "serial": "VSOL00521419",
        "queue": "queue1",
        "interface": "VLAN229_PANTIN",
        "created_at": "2024-08-17T10:52:08.951182",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3468,
      "client_name": "HELEN VICTORIA PEREZ GUEDES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Paya Abajo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04145989819",
      "client_email": "HELENVICTORIA2403@GMAIL.COM",
      "address": "CALLE LA CAPILLA CASA NRO 28-1 SECTOR PAYA ABAJO ROSARIO DE PAYA",
      "client_identification": "V16131554",
      "nap_box_name": "254",
      "created_at": "2024-04-12T16:29:55.327821",
      "service_detail": {
        "id": 8158,
        "ip": "10.13.40.2",
        "mac": "TPLGF4B1D66E",
        "serial": "TPLGF4B1D66E",
        "queue": "Plan_107915_30181_WispHub",
        "interface": "VLAN231_PAYABAJO",
        "created_at": "2025-04-06T21:03:34.715437",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3469,
      "client_name": "NIEVES MARIA MATA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Macarena",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243765800",
      "client_email": "DENISSMT95@GMAIL.COM",
      "address": "CALLE 3 CASA NRO 13 URB LA MACARENA 02 TURMERO",
      "client_identification": "V10220821",
      "nap_box_name": "444",
      "created_at": "2024-04-12T16:32:55.549672",
      "service_detail": {
        "id": 6450,
        "ip": "172.24.176.2",
        "mac": "TPLGB446F53D",
        "serial": "TPLGB446F53D",
        "queue": "queue1",
        "interface": "VLAN112_LA_MACARENA_ZTE",
        "created_at": "2024-08-29T08:52:56.443633",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3470,
      "client_name": "ELIO JESUS RIVAS GUEVARA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Jabillar",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128859207",
      "client_email": "elri82@yahoo.com",
      "address": "CALLE LOS CAOBOS CASA 03-15 CONJUNTO RESIDENCIAL JABILLAR TURMERO ARAGUA",
      "client_identification": "V16098096",
      "nap_box_name": "CTO-0552",
      "created_at": "2024-04-12T16:33:50.724326",
      "service_detail": {
        "id": 10726,
        "ip": "172.17.154.2",
        "mac": "TPLG1BB36420",
        "serial": "TPLG1BB36420",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2025-12-15T11:57:58.675491",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3471,
      "client_name": "ALEXANDER DANIEL VILLAMIZAR LINARES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124573816",
      "client_email": "ADVL2798@GMAIL.COM",
      "address": "CALLE PRINCIPAL MANZANA D-12 CASA NRO 17 SECTOR SAMAN TARAZONERO II TURMERO ARAGUA",
      "client_identification": "V26320323",
      "nap_box_name": "265",
      "created_at": "2024-04-12T16:36:53.297590",
      "service_detail": {
        "id": 5282,
        "ip": "172.19.41.2",
        "mac": "TPLGF5CB02ED",
        "serial": "TPLGF5CB02ED",
        "queue": "Plan_92223_1574_WispHub",
        "interface": "VLAN100_OLTs",
        "created_at": "2024-08-15T17:24:10.435307",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3472,
      "client_name": "YULEYDIS MARIAN FIGUEROA MORENO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Brisas de Paya",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121476099",
      "client_email": "SOLEDAMARIA187@GMAIL.COM",
      "address": "CALLE 3 CASA NRO 8 SECTOR BRISAS DE PAYA",
      "client_identification": "V17477380",
      "nap_box_name": "366",
      "created_at": "2024-04-12T16:39:29.022503",
      "service_detail": {
        "id": 5604,
        "ip": "172.22.49.2",
        "mac": "TPLGF4EFC509",
        "serial": "TPLGF4EFC509",
        "queue": "Plan_107915_30181_WispHub",
        "interface": "VLAN241_BRISAS",
        "created_at": "2024-08-17T10:20:01.799044",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3473,
      "client_name": "SARAI BETSAIDA MEJIAS ROA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128654114",
      "client_email": "SARAMEJIAS237@GMAIL.COM",
      "address": "CALLE 8 CASA NRO 13 URB SAMAN TARAZONERO I EL MACARO",
      "client_identification": "V23790915",
      "nap_box_name": "37",
      "created_at": "2024-04-12T16:41:53.660785",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3474,
      "client_name": "ANA FRANCHESKA CHAVEN SANTANA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Canaima",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121494237",
      "client_email": "ANA_FRANCHEKA@HOTMAIL.COM",
      "address": "CALLE 1 CASA NRO 33 URBANIZACIÓN CANAIMA",
      "client_identification": "V26535624",
      "nap_box_name": "CTO-00172 ",
      "created_at": "2024-04-12T16:42:26.892192",
      "service_detail": {
        "id": 6047,
        "ip": "172.20.67.2",
        "mac": "TPLGF4EFC089",
        "serial": "TPLGF4EFC089",
        "queue": "Plan_161903_30183_WispHub",
        "interface": "VLAN237_CANAIMA",
        "created_at": "2024-08-22T12:06:15.108823",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3475,
      "client_name": "NANCY EMPERATRIZ TORRES VIERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Plaza Jardin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04140354186",
      "client_email": "EMPELUIS@GMAIL.COM",
      "address": "CALLE PARAISO CASA NRO 5 URB PLAZA JARDIN",
      "client_identification": "V12138701",
      "nap_box_name": "439",
      "created_at": "2024-04-12T16:44:40.386352",
      "service_detail": {
        "id": 3391,
        "ip": "172.18.49.2",
        "mac": "VSOL00125409",
        "serial": "VSOL00125409",
        "queue": "Plan_137942_24341_WispHub",
        "interface": "VLAN141_PLAZA_JARDIN",
        "created_at": "2024-07-03T08:24:08.316105",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3476,
      "client_name": "OFELIA NICOLASA PEREZ PERRONE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128564411",
      "client_email": "OFELIAPERRONI.03@GMAIL.COM",
      "address": "CALLE CARREÑO NRO 84 SECTOR TURMERO NORTE TURMERO",
      "client_identification": "V3849732",
      "nap_box_name": "649",
      "created_at": "2024-04-12T16:45:32.407342",
      "service_detail": {
        "id": 4276,
        "ip": "172.22.90.2",
        "mac": "TPLGBA6876D5",
        "serial": "TPLGBA6876D5",
        "queue": "Plan_153953_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-08-08T14:34:01.487486",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3477,
      "client_name": "DEIVINSO JONAS JIMENEZ GONZALEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04160420763",
      "client_email": "DEIVINSOJ@GMAIL.COM",
      "address": "CALLE MANZANA C-15 CASA NRO 02 BARRIO SAMAN TARAZONERO II TURMERO",
      "client_identification": "V25067742",
      "nap_box_name": "CTO-00064",
      "created_at": "2024-04-12T16:47:36.891216",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3479,
      "client_name": "ENRIQUE ALEXANDER LUGO BARRIENTOS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Santa Eduviges",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04125073257",
      "client_email": "LUGO7377@GMAIL.COM",
      "address": "CALLE HENRY PITIER CASA NRO 06 URB SANTA EDUVIGES EL MACARO TURMERO",
      "client_identification": "V20758454",
      "nap_box_name": "173",
      "created_at": "2024-04-12T16:54:27.884648",
      "service_detail": {
        "id": 6472,
        "ip": "172.20.126.2",
        "mac": "VSOL0048D5C9",
        "serial": "VSOL0048D5C9",
        "queue": "Plan_127744_1574_WispHub",
        "interface": "VLAN127_SANTA_EDUVIGES",
        "created_at": "2024-08-29T12:07:35.349267",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3480,
      "client_name": "EDUARDO ENRIQUE ROMERO RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Santa Eduviges",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04261966266",
      "client_email": "EDUARORO@GMAIL.COM",
      "address": "VEREDA 1 CASA NRO 9 URB SANTA EDUVIGES EL MACARO",
      "client_identification": "V23498275",
      "nap_box_name": "87 DOS",
      "created_at": "2024-04-12T16:56:25.532605",
      "service_detail": {
        "id": 6049,
        "ip": "172.21.47.2",
        "mac": "VSOL00523A39",
        "serial": "VSOL00523A39",
        "queue": "Plan_138775_1574_WispHub",
        "interface": "VLAN127_SANTA_EDUVIGES",
        "created_at": "2024-08-22T12:10:21.217552",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3481,
      "client_name": "ARIANNA GABRIELA SALAZAR BANDRES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144889675",
      "client_email": "ARIANNASALAZAR064@GMAIL.COM",
      "address": "CALLE PRINCIPAL EDIF TORRE 6 PISO 3 APTO 3 URB LOS NISPEROS",
      "client_identification": "V25880856",
      "nap_box_name": "CTO-00032",
      "created_at": "2024-04-12T16:56:33.831973",
      "service_detail": {
        "id": 3560,
        "ip": "172.24.118.2",
        "mac": "TPLGB444B2CE",
        "serial": "TPLGB444B2CE",
        "queue": "Plan_128612_15811_WispHub",
        "interface": "VLAN209_ZAMORA_OLT1",
        "created_at": "2024-07-09T09:50:21.640165",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3482,
      "client_name": "CARMEN MARGARITA CORREA ALFONZO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Santa Eduviges",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128894117",
      "client_email": "1959CARMENCORREA@GMAIL.COM",
      "address": "VEREDA 5 NRO 15 SECTOR SANATA EDUVIGES EL MACARO",
      "client_identification": "V6429580",
      "nap_box_name": "173",
      "created_at": "2024-04-12T16:59:40.290588",
      "service_detail": {
        "id": 6050,
        "ip": "172.18.20.2",
        "mac": "VSOL004977E1",
        "serial": "VSOL004977E1",
        "queue": "Plan_127744_1574_WispHub",
        "interface": "VLAN127_SANTA_EDUVIGES",
        "created_at": "2024-08-22T12:12:17.458199",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3483,
      "client_name": "IRAIMA COROMOTO SUMOZA ALVAREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04127893205",
      "client_email": "WILVERV1996@GMAIL.COM",
      "address": "CARRETERA EL MACARO SAMAN TARAZONERO II MANZANA I-9 CASA N-20",
      "client_identification": "V7273450",
      "nap_box_name": "38",
      "created_at": "2024-04-12T17:01:42.754800",
      "service_detail": {
        "id": 4364,
        "ip": "172.27.143.2",
        "mac": "TPLG2ABDC6D5",
        "serial": "TPLG2ABDC6D5",
        "queue": "Plan_137413_1574_WispHub",
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2024-08-09T15:32:41.159656",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3484,
      "client_name": "ANGELA KARINA RAMIREZ VARGAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Santa Eduviges",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128926061",
      "client_email": "ANGELARAMIREZ19.AR@GMAIL.COM",
      "address": "CALLE NEGRO FELIPE CASA NRO 07 SANTA EDUVIGES",
      "client_identification": "V23783620",
      "nap_box_name": "CE - 523",
      "created_at": "2024-04-12T17:02:23.807695",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3485,
      "client_name": "BERTILDA BOLIVAR VALDELAMAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Magdalena",
      "plan": {
        "id": 16,
        "name": "RECURRENTE RESIDENCIAL PLAN 800M",
        "cost": "55.00",
        "code": "FOR800",
        "profile": "800M/800M"
      },
      "client_mobile": "04243765284",
      "client_email": "BERTILDA1333@GMAIL.COM",
      "address": "CALLE 3 CASA NRO 1 URB LA MAGDALENA SECTOR LA JULIA TURMERO",
      "client_identification": "V9656460",
      "nap_box_name": "108",
      "created_at": "2024-04-12T17:06:01.406112",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3486,
      "client_name": "FERNANDO RUIZ ANGARITA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Antigua Hacienda De Paya",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04123982823",
      "client_email": "MARCOSCAIRUZ@GMAIL.COM",
      "address": "CALLE 17C CASA NRO 02 PARCELA 23B URBANIZACIÓN ANTIGUA HACIENDA DE PAYA",
      "client_identification": "V24343976",
      "nap_box_name": "CTO-00183",
      "created_at": "2024-04-12T17:07:57.243646",
      "service_detail": {
        "id": 6054,
        "ip": "172.20.59.2",
        "mac": "TPLGF4EFBCEE",
        "serial": "TPLGF4EFBCEE",
        "queue": "Plan_128612_15811_WispHub",
        "interface": "VLAN202_AHP_OLT1",
        "created_at": "2024-08-22T12:32:15.862673",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3487,
      "client_name": "MARIA DEL VALLE GARCIA PARGA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Santa Eduviges",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04128954584",
      "client_email": "MARIAGARCIAP.33@GMAIL.COM",
      "address": "VDA 5 CASA NRO 17 BARRIO SANTA EDUVIGES TURMERO",
      "client_identification": "V18854890",
      "nap_box_name": "87 DOS",
      "created_at": "2024-04-12T17:09:34.382451",
      "service_detail": {
        "id": 3305,
        "ip": "172.17.33.2",
        "mac": "VSOL0013BE79",
        "serial": "VSOL0013BE79",
        "queue": "queue1",
        "interface": "VLAN127_SANTA_EDUVIGES",
        "created_at": "2024-07-01T15:54:54.952871",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3488,
      "client_name": "EDITH YAMILETH RODRIGUEZ FLORES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04126988730",
      "client_email": "EDITH03YE@GMAIL.COM",
      "address": "CALLE 04 CASA NRO 30 SECTOR PRADOS DE PAYA II ROSARIO DE PAYA",
      "client_identification": "V19132675",
      "nap_box_name": "CTO-00100",
      "created_at": "2024-04-12T17:10:01.851997",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3489,
      "client_name": "DIOGENES JOSE COLMENAREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04122983064",
      "client_email": "MARLINDUNDECOLMENAREZ@GMAIL.COM",
      "address": "SECTOR MATA CABALLO C/3 CASA #164 ARAGUA ZONA POSTAL 2115 ARAGUA ZONA POSTAL 2115",
      "client_identification": "V163284550",
      "nap_box_name": "CTO-00309",
      "created_at": "2024-04-12T17:12:21.343097",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3490,
      "client_name": "GERSON MIGUEL ACUNA RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Santa Eduviges",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04126915541",
      "client_email": "GMACUNA02@GMAIL.COM",
      "address": "CALLE SANTA INES CASA NRO 11 BARRIO SANTA EDUVIGES TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V15547902",
      "nap_box_name": "CE - 523",
      "created_at": "2024-04-12T17:16:40.203568",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3491,
      "client_name": "KEIVIMAR RIVER MAILET VASQUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados III",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243065896",
      "client_email": "KRMAILET26@GMAIL.COM",
      "address": "PRADOS DE PAYA III AV PRINCIPAL 2 CASA NRO 66 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V297114928",
      "nap_box_name": "580 DOS",
      "created_at": "2024-04-12T17:20:28.046986",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3492,
      "client_name": "MARCOS TRINO JIMENEZ VARGAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados II",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04121491647",
      "client_email": "MARCOSJIMENEZ05@GMAIL.COM",
      "address": "CALLE 1 PRIMERA CASA NRO 19 SECTOR PRADOS DE PAYA II TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V16708603",
      "nap_box_name": "CTO-00118 DOS",
      "created_at": "2024-04-12T17:22:44.785379",
      "service_detail": {
        "id": 6057,
        "ip": "172.26.39.2",
        "mac": "VSOL00D0F09F",
        "serial": "VSOL00D0F09F",
        "queue": "Plan_161895_30183_WispHub",
        "interface": "VLAN242_PRADOS2",
        "created_at": "2024-08-22T12:40:50.674060",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3493,
      "client_name": "EURIBEL SIOLIBET ROSAL GUZMAN",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Magdalena",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124359160",
      "client_email": "EURIBELROSAL@GMAIL.COM",
      "address": "CALLE 03 CASA NRO 05 URB LA MAGDALENA TURMERO",
      "client_identification": "V19276214",
      "nap_box_name": "CTO-00472",
      "created_at": "2024-04-12T17:27:54.441456",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3494,
      "client_name": "JOHAN GUILLERMO FUNG GALLARDO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Durpa",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04262339078",
      "client_email": "NAVASLISBETH16@GMAIL.COM",
      "address": "CALLE SIMON RODRIGUEZ CASA NRO 3 SECTOR MANZANA 15 DURPA",
      "client_identification": "V11986807",
      "nap_box_name": "382",
      "created_at": "2024-04-12T17:30:46.232203",
      "service_detail": {
        "id": 6457,
        "ip": "172.27.154.2",
        "mac": "TPLGB446ECEA",
        "serial": "TPLGB446ECEA",
        "queue": "Plan_161872_30181_WispHub",
        "interface": "VLAN240_DURPA",
        "created_at": "2024-08-29T09:28:37.781222",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3496,
      "client_name": "MARY CARMEN VASQUEZ MORENO DE GUTIERREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128863775",
      "client_email": "GNESISCHENNY@GMAIL.COM",
      "address": "CALLE 9A CASA NRO 2 URB PANTIN ROSARIO DE PAYA",
      "client_identification": "V6792431",
      "nap_box_name": "CTO-00142",
      "created_at": "2024-04-12T17:35:53.024178",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3497,
      "client_name": "YASELIZ ANDREINA LINARES HERNANDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Taguapire",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243728893",
      "client_email": "YASELIZANDREINALINARES@GMAIL.COM",
      "address": "CALLE 02 EDIF MÓDULO 04 PISO 01 APT 36 URB TAGUAPIRE TURMERO ARAGUA",
      "client_identification": "V15963837",
      "nap_box_name": "CTO-00388",
      "created_at": "2024-04-15T08:09:25.511236",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3498,
      "client_name": "JHANDRY YAMARA MASIAS MUÑOZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 43,
        "name": "RECURRENTE RESIDENCIAL PLAN 650M",
        "cost": "46.00",
        "code": "FOR650M",
        "profile": "650M/650M"
      },
      "client_mobile": "04243491560",
      "client_email": "HIJOSYALVIS@GMAIL.COM",
      "address": "CALLE 5B CASA NRO 55 URB PANTIN TURMERO",
      "client_identification": "V16686241",
      "nap_box_name": "CTO-00136",
      "created_at": "2024-04-15T08:14:52.577828",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3499,
      "client_name": "ALBERTO ARGENIS HEREDIA HEREDIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Durpa",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04228152669",
      "client_email": "LUGOZULIMAR77@GMAIL.COM",
      "address": "CALLE MANZANA 19 CASA NRO 08 URB ROSARIO DE PAYA SECTOR FUNDA BARRIOS ROSARIO DE PAYA",
      "client_identification": "V27453474",
      "nap_box_name": "352",
      "created_at": "2024-04-15T08:21:00.781831",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3500,
      "client_name": "ANDERZON FRANCISCO FALCON VALLADARES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Paraiso",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128908004",
      "client_email": "valladaresanderzon@gmail.com",
      "address": "CALLE UNION CASA NRO 124 URB EL PARAISO TURMERO",
      "client_identification": "V27864656",
      "nap_box_name": "345",
      "created_at": "2024-04-15T08:29:15.954991",
      "service_detail": {
        "id": 12283,
        "ip": "172.21.84.2",
        "mac": "TPLGB954EFF6",
        "serial": "TPLGB954EFF6",
        "queue": null,
        "interface": "VLAN105_EL_PARAISO_OLT_ZTE",
        "created_at": "2026-04-10T10:12:59.293258",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3501,
      "client_name": "YELITZA CAROLINA SALAS SANCHEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121584081",
      "client_email": "SALASYELITZA1@GMAIL.COM",
      "address": "CALLE 12 CASA NRO 690-C URB MATACABALLO",
      "client_identification": "V19793713",
      "nap_box_name": "CTO-00210",
      "created_at": "2024-04-15T08:33:57.252471",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3503,
      "client_name": "MARIA COROMOTO ARRAIZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Simon Bolivar",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04168431108",
      "client_email": "AMATISTAROT7@GMAIL.COM",
      "address": "CALLE 10 CASA NRO 41 URB SIMON BOLIVAR EL MACARO 19 DE ABRIL ARAGUA",
      "client_identification": "V9672550",
      "nap_box_name": "CTO-00034",
      "created_at": "2024-04-15T08:45:12.653264",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3504,
      "client_name": "PABLO JULIO MACIAS UBARNES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144864258",
      "client_email": "ARIANNIMACIAS75@GMAIL.COM",
      "address": "CALLE 3 CASA NRO 53 URB LA CASONA I TURMERO EDO. ARAGUA",
      "client_identification": "V15735400",
      "nap_box_name": "44",
      "created_at": "2024-04-15T08:48:24.568585",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3505,
      "client_name": "FLORALYS RAQUEL GAMBOA NIEVES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144757968",
      "client_email": "GFLORALYS260@GMAIL.COM",
      "address": "CALLE 03 CASA NRO 133 URB MATA CABALLO ROSARIO DE PAYA",
      "client_identification": "V19515754",
      "nap_box_name": "CTO-00094",
      "created_at": "2024-04-15T08:53:44.403235",
      "service_detail": {
        "id": 6086,
        "ip": "172.24.59.2",
        "mac": "VSOL001410F9",
        "serial": "VSOL001410F9",
        "queue": "Plan_161900_30183_WispHub",
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2024-08-22T14:15:07.440535",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3506,
      "client_name": "DANIEL ALEJANDRO BARRIENTOS GARCIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Las Rurales",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243122233",
      "client_email": "DANNAYASHLY05@GMAIL.COM",
      "address": "CALLE 107 CASA NRO 78 SECTOR LAS RURALES ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V24929349",
      "nap_box_name": "492",
      "created_at": "2024-04-15T08:57:36.109421",
      "service_detail": {
        "id": 6087,
        "ip": "172.28.20.2",
        "mac": "ZICGCDE5D44D",
        "serial": "ZICGCDE5D44D",
        "queue": "Plan_161903_30183_WispHub",
        "interface": "VLAN252_RURALES_PAYA",
        "created_at": "2024-08-22T14:17:16.520925",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3507,
      "client_name": "BRYAN REYES",
      "client_type_name": "INTERCAMBIO",
      "client_subdivision": "CANCELADO_INTERCAMBIO",
      "status_name": "Cancelado",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 83,
        "name": "RECURRENTE INSTITUCIONAL 80M",
        "cost": "0.00",
        "code": "FO-R80",
        "profile": "80M/80M"
      },
      "client_mobile": "04245627898",
      "client_email": "HAJA@GMAIL.COM",
      "address": "CALLE MARIÑO CC PASEO MARIÑO NIVEL P1 -08 LOCAL 08 SECTOR TURMERO",
      "client_identification": "V19545411",
      "nap_box_name": "CTO-00256",
      "created_at": "2024-04-15T09:09:44.386086",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3509,
      "client_name": "FLOR ELIANA GARCIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124208323",
      "client_email": "GARCIAFLORELIANA@GMAIL.COM",
      "address": "VDA 4 MANZANA E CASA NRO 11 SECTOR SAMAN TARAZONERO II TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V12341848",
      "nap_box_name": "161 DOS",
      "created_at": "2024-04-15T09:53:43.754922",
      "service_detail": {
        "id": 13112,
        "ip": "172.26.74.2",
        "mac": "HW:TC:90:88:68:9B",
        "serial": "HWTC9088689B",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2026-10-03T17:14:28.858242",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3510,
      "client_name": "MARCELINO RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Los Hornos",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04160401621",
      "client_email": "MARCELINORODRIGUEZ936@GMAIL.COM",
      "address": "CALLE 8 CASA NRO 28 SECTOR LOS HORNOS 2 ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V15243663",
      "nap_box_name": "CTO-00288",
      "created_at": "2024-04-15T10:01:01.330233",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3512,
      "client_name": "SAMUEL ANDRES PAEZ TREVE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Durpa",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04120418741",
      "client_email": "JOHANICAROLINA1980@GMAIL.COM",
      "address": "MANZANA 19 CASA NRO 16 CALLE LOS ALPES SECTOR DESARROLLO URBANISTICO DURPA",
      "client_identification": "V6096243",
      "nap_box_name": "390",
      "created_at": "2024-04-15T10:28:53.666165",
      "service_detail": {
        "id": 4935,
        "ip": "172.18.165.2",
        "mac": "VSOL001278C1",
        "serial": "VSOL001278C1",
        "queue": "Plan_161905_30183_WispHub",
        "interface": "VLAN240_DURPA",
        "created_at": "2024-08-13T13:07:05.724766",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3513,
      "client_name": "DEGLIS ALEXANDER VELAZQUEZ ACUÑA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Los Hornos",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243401857",
      "client_email": "deglisvelazque8@gmail.com",
      "address": "CALLE LOS MANGOS CASA NRO 03 SECTOR LOS HORNOS TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V16851302",
      "nap_box_name": "437",
      "created_at": "2024-04-15T10:40:52.879345",
      "service_detail": {
        "id": 3405,
        "ip": "172.28.65.2",
        "mac": "ZICGCD81726E",
        "serial": "ZICGCD81726E",
        "queue": "Plan_161903_30183_WispHub",
        "interface": "VLAN247_HORNOS",
        "created_at": "2024-07-03T10:59:19.709561",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3514,
      "client_name": "JETZANDRA DANIELA RODRIGUEZ MORENO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243279022",
      "client_email": "JETZANDRA00RODRIGUEZ@GMAIL.COM",
      "address": "CALLE PASAJE BERMUDEZ CASA NRO 80 SECTOR LA ADUANA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V29574018",
      "nap_box_name": "282",
      "created_at": "2024-04-15T10:48:03.760351",
      "service_detail": {
        "id": 6621,
        "ip": "172.28.62.2",
        "mac": "ZICGCBB02610",
        "serial": "ZICGCBB02610",
        "queue": "Plan_107915_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-09-13T19:30:07.657165",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3515,
      "client_name": "MEGANN VALENTINA LOMBANO SANTANA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados I",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243107678",
      "client_email": "MEGANNVALENTINA2005@GMAIL.COM",
      "address": "CALLE 15 CASA NRO 17 SECTOR LOS PRADOS I ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V31595092",
      "nap_box_name": "590 DOS",
      "created_at": "2024-04-15T11:02:36.797692",
      "service_detail": {
        "id": 6315,
        "ip": "172.27.137.2",
        "mac": "HWTCD67F969C",
        "serial": "HWTCD67F969C",
        "queue": "queue1",
        "interface": "VLAN239_PRADOS1",
        "created_at": "2024-08-23T17:53:01.676574",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3516,
      "client_name": "ROYNER ALEXANDER HERNANDEZ ESPINOZA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04128877408",
      "client_email": "roynerhernandez83@gmail.com",
      "address": "CALLE 7 CASA NRO 539-A BARRIO MATA CABALLO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V30292364",
      "nap_box_name": "CTO-00073",
      "created_at": "2024-04-15T11:12:04.305563",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3517,
      "client_name": "KARLA ESTEFANIA BARRIOS SANDOVAL",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Naranjal",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243546620",
      "client_email": "ORLANDOBARRIOS118@GMAIL.COM",
      "address": "CALLE PRINCIPAL CASA NRO 11 SECTOR GRANJA EL NARANJAL TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V20336433",
      "nap_box_name": "597",
      "created_at": "2024-04-15T11:17:57.796869",
      "service_detail": {
        "id": 6094,
        "ip": "172.26.152.2",
        "mac": "TPLGF9CD3F91",
        "serial": "TPLGF9CD3F91",
        "queue": "queue1",
        "interface": "VLAN246_NARANJAL",
        "created_at": "2024-08-22T14:39:50.194594",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3518,
      "client_name": "RAMIRO ANTONIO SERRANO CASTILLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Canaima",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04125790448",
      "client_email": "RAMIROSERRANO2603@GMAIL.COM",
      "address": "RAMIRO ANTONIO SERRANO CASTILLO",
      "client_identification": "V11184996",
      "nap_box_name": "CTO-00107 ",
      "created_at": "2024-04-15T11:21:18.725568",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3519,
      "client_name": "MARIA NELLY DUQUE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243577365",
      "client_email": "CAROL16DUQUE@GMAIL.COM",
      "address": "CALLE 15 CASA NRO 46 SECTOR RIO SECO ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V12857007",
      "nap_box_name": "487",
      "created_at": "2024-04-15T11:25:49.874283",
      "service_detail": {
        "id": 6620,
        "ip": "172.28.50.2",
        "mac": "ZICGCDE46BAD",
        "serial": "ZICGCDE46BAD",
        "queue": "Plan_161903_30183_WispHub",
        "interface": "VLAN251_RIO_SECO",
        "created_at": "2024-09-13T19:27:39.257460",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3520,
      "client_name": "IVONNE CAROLINA DUARTE GIMENEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Los Hornos",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04127925037",
      "client_email": "IVONNEA_1983@HOTMAIL.COM",
      "address": "CALLE LOS MANGOS CASA NRO 06 BARRIO LOS HORNOS ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL",
      "client_identification": "V15962795",
      "nap_box_name": "437",
      "created_at": "2024-04-15T11:29:41.664047",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3521,
      "client_name": "HERMELINDA CAROLINA PIZZANO DE CRESPO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243477450",
      "client_email": "PIZZANOHERMELINDA@GMAIL.COM",
      "address": "CALLE 16 CASA NRO 42 SECTOR PANTIN ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V12343749",
      "nap_box_name": "CTO-00026",
      "created_at": "2024-04-15T11:32:43.116321",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3523,
      "client_name": "DEIVIS JHOAN OJEDA PInERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Paya Abajo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121341293",
      "client_email": "OJEDA.DEIVIS@GMAIL.COM",
      "address": "CALLE SAN ANTONIO CASA  NRO 1 SECTOR PAYA ABAJO ROSARIO DE PAYA",
      "client_identification": "V16761844",
      "nap_box_name": "272",
      "created_at": "2024-04-15T11:38:39.684625",
      "service_detail": {
        "id": 10662,
        "ip": "172.23.86.2",
        "mac": "TPLGBA687B0F",
        "serial": "TPLGBA687B0F",
        "queue": null,
        "interface": "VLAN231_PAYABAJO",
        "created_at": "2025-12-11T15:00:04.735193",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3524,
      "client_name": "YUSMARY YOLIMAR TOVAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243291339",
      "client_email": "YUSMARYTOVAR75@GMAIL.COM",
      "address": "CALLE 11 CASA NRO 36 SECTOR RIO SECO ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V12170021",
      "nap_box_name": "487",
      "created_at": "2024-04-15T11:42:10.952349",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3525,
      "client_name": "JEVIARCA RUTH ESCOBAR AZOCAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Floresta",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243458453",
      "client_email": "ANGELICA.LIK.76@GMAIL.COM",
      "address": "CALLE 4 CASA NRO G-11 URB LA FLORESTA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V24929725",
      "nap_box_name": "10",
      "created_at": "2024-04-15T11:44:32.069259",
      "service_detail": {
        "id": 6175,
        "ip": "172.27.186.2",
        "mac": "HWTCD63AA69C",
        "serial": "HWTCD63AA69C",
        "queue": "Plan_147201_15811_WispHub",
        "interface": "VLAN212_FLORESTA_OLT1",
        "created_at": "2024-08-22T18:10:25.158603",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3526,
      "client_name": "JESUS EDUARDO HERRERA CORDERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Terrazas de Paya",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128871400",
      "client_email": "JESUS_HERRERA_5@YAHOO.ES",
      "address": "CALLE 3 CASA NRO 12 URB TERRAZAS DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V19833982",
      "nap_box_name": "421",
      "created_at": "2024-04-15T11:49:33.986713",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3527,
      "client_name": "DAVID DANIEL PEREZ QUIÑONEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04123467238",
      "client_email": "DDPEREZ2118@GMAIL.COM",
      "address": "CALLE 15 CASA NUMERO 14 URBANIZACIÓN SAMAN TARAZONERO II TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V20118246",
      "nap_box_name": "278",
      "created_at": "2024-04-15T11:51:53.230063",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3528,
      "client_name": "NEYBER HAYDEES VIANA BOQUILLON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Palma Real",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04145888334",
      "client_email": "NEYBERVIANA@GMAIL.COM",
      "address": "CALLE 1 CASA NRO 40 URB PALMA REAL ROSARIO DE PAYA",
      "client_identification": "V13018749",
      "nap_box_name": "CTO-00209",
      "created_at": "2024-04-15T11:54:44.195487",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3529,
      "client_name": "YULIA ROSANGELA BALADI CORRALES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villa Los Tamarindos",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121490681",
      "client_email": "ROSANGELABALADI@GMAIL.COM",
      "address": "CALLE 7 CASA NRO 4 URB VILLA LOS TAMARINDOS TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V17576386",
      "nap_box_name": "CTO-00593",
      "created_at": "2024-04-15T11:54:59.285186",
      "service_detail": {
        "id": 6642,
        "ip": "172.24.221.2",
        "mac": "TPLGF9CD3F89",
        "serial": "TPLGF9CD3F89",
        "queue": "Plan_137413_1574_WispHub",
        "interface": "VLAN133_VILLA_TAMARINDOS",
        "created_at": "2024-09-17T13:41:55.307627",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3530,
      "client_name": "RAMONA COROMOTO HERNANDEZ PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados III",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243246405",
      "client_email": "CORO.R.HERNANDZ1@GMAIL.COM",
      "address": "CALLE 3 CASA NRO 3 SECTOR PRADO III ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V8620427",
      "nap_box_name": "CTO-00299",
      "created_at": "2024-04-15T11:57:37.155309",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3531,
      "client_name": "YARIALIX ANTONIETA CAMACHO VILLAZANA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Canaima",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04128905849",
      "client_email": "YARIALIXCAMACHO@GMAIL.COM",
      "address": "CALLE 3 CASA NRO 13 CANAIMA SECTOR ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V30772356",
      "nap_box_name": "355",
      "created_at": "2024-04-15T12:00:45.251392",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3532,
      "client_name": "NELSON RAMON GUTIERREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04120367788",
      "client_email": "NELSONRAMONGUTIERREZ70@GMAIL.COM",
      "address": "CALLE 7 CASA NRO 32 ZONA ROSARIO DE PAYA RIO SECO TURMERO ESTADO ARAGUA ZONA POSTAL",
      "client_identification": "V12363367",
      "nap_box_name": "474",
      "created_at": "2024-04-15T12:02:48.196890",
      "service_detail": {
        "id": 3753,
        "ip": "172.26.183.2",
        "mac": "HWTCD6AFF39C",
        "serial": "HWTCD6AFF39C",
        "queue": "Plan_107915_30181_WispHub",
        "interface": "VLAN251_RIO_SECO",
        "created_at": "2024-07-12T17:14:34.040795",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3533,
      "client_name": "ANGELO JOSE OCA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Guanarito",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243176002",
      "client_email": "ANGELOJOSE-35@HOTMAIL.COM",
      "address": "CALLE JOSE CARUSO CASA NRO 14 SECTOR GUANARITO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V24930120",
      "nap_box_name": "CTO-00214",
      "created_at": "2024-04-15T12:04:26.247976",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3534,
      "client_name": "SOL ANGELA MEJIAS GALLARDO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados I",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121588170",
      "client_email": "espia20651557@gmail.com",
      "address": "CALLE 03 CASA NRO 24 SECTOR PRADO DE PAYA I ROSARIO DE PAYA",
      "client_identification": "V10356233",
      "nap_box_name": "CTO-00298",
      "created_at": "2024-04-15T12:05:26.603740",
      "service_detail": {
        "id": 6162,
        "ip": "172.24.175.2",
        "mac": "TPLGB446F57B",
        "serial": "TPLGB446F57B",
        "queue": "Plan_161903_30183_WispHub",
        "interface": "VLAN239_PRADOS1",
        "created_at": "2024-08-22T17:54:29.016702",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3535,
      "client_name": "KATIANA ANDREINA ROJAS ALVARADO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04120759245",
      "client_email": "KATIANAROJAS.SGF@GMAIL.COM",
      "address": "CALLE 16 CASA NRO 18 SECTOR LA CASONA II TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V27520563",
      "nap_box_name": "CTO-00086",
      "created_at": "2024-04-15T12:08:39.779902",
      "service_detail": {
        "id": 3892,
        "ip": "172.26.171.2",
        "mac": "HWTCD134FB9A",
        "serial": "HWTCD134FB9A",
        "queue": "queue1",
        "interface": "VLAN110_CASONA_2",
        "created_at": "2024-07-16T18:14:40.165402",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3536,
      "client_name": "VIVIANA CARMENCITA GONZALEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04146428011",
      "client_email": "VG7648769@GMAIL.COM",
      "address": "CALLE 8 CASA NRO 20 URB PANTIN ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V18542617",
      "nap_box_name": "CTO-00114",
      "created_at": "2024-04-15T13:06:16.241902",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3537,
      "client_name": "CARLOS ENRIQUE BLANCO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Canaima",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04140477520",
      "client_email": "CARLOSEBB41@GMAIL.COM",
      "address": "CALLE 3 CASA NRO 20 URB CANAIMA ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V10503288",
      "nap_box_name": "355",
      "created_at": "2024-04-15T13:17:22.905045",
      "service_detail": {
        "id": 6646,
        "ip": "172.26.207.2",
        "mac": "TPLGF9CD40E3",
        "serial": "TPLGF9CD40E3",
        "queue": "Plan_161904_30183_WispHub",
        "interface": "VLAN237_CANAIMA",
        "created_at": "2024-09-17T13:52:04.598128",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3538,
      "client_name": "YRAIDA DEL VALLE RODRIGUEZ PINTO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Jabillar",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121483501",
      "client_email": "IRAYDAS10@GMAIL.COM",
      "address": "CALLE 4 CASA NRO 05 JABILLAR SECTOR EL MACARO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V9436648",
      "nap_box_name": "CTO-00006 C/4 JABILLAR",
      "created_at": "2024-04-15T13:20:54.093023",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3539,
      "client_name": "ZAIDA DEL ROSARIO ACEVEDO MARQUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04125023316",
      "client_email": "ZAIDAACEVEDO372@GMAIL.COM",
      "address": "CALLE MANZANA F-1 CASA NRO 12 BARRIO SAMAN TARAZONERO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V7218435",
      "nap_box_name": "162",
      "created_at": "2024-04-15T13:27:56.360425",
      "service_detail": {
        "id": 5867,
        "ip": "172.26.46.2",
        "mac": "HWTC908FE49B",
        "serial": "HWTC908FE49B",
        "queue": "Plan_137413_1574_WispHub",
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2024-08-20T16:41:42.424708",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3540,
      "client_name": "DAISY ROSEILYS COLMENARES APONTE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04149448223",
      "client_email": "COLMENARESDAISY40@GMAIL.COM",
      "address": "CALLE 7 CASA NRO 43 SECTOR RIO SECO TURMERO ROSARIO DE PAYA 2115",
      "client_identification": "V18702827",
      "nap_box_name": "474",
      "created_at": "2024-04-15T13:35:18.923426",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3541,
      "client_name": "ALAN DAVID TOVAR GARCIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04228871749",
      "client_email": "yulitzagarcia32@gmail.com",
      "address": "URB. PANTIN CALLE 22 CASA #5 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V29837588",
      "nap_box_name": "CTO-00105",
      "created_at": "2024-04-15T13:40:57.792672",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3542,
      "client_name": "YOEL MIGUEL HERNANDEZ ALFIN",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Durpa",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121996788",
      "client_email": "YOELALFIN80TY@GMAIL.COM",
      "address": "CALLE LEALTAD  MANZANA 22 CASA NRO 11 SECTOR FUNDABARRIO ROSARIO DE PAYA",
      "client_identification": "V16262729",
      "nap_box_name": "CTO-00320",
      "created_at": "2024-04-15T13:43:30.347492",
      "service_detail": {
        "id": 6158,
        "ip": "172.23.117.2",
        "mac": "TPLGF4B1D3FD",
        "serial": "TPLGF4B1D3FD",
        "queue": "Plan_161903_30183_WispHub",
        "interface": "VLAN240_DURPA",
        "created_at": "2024-08-22T17:48:30.439349",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3543,
      "client_name": "YONNY JOSE VARGAS GIL",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "SUSPENDIDO_RESIDENCIAL",
      "status_name": "Suspendido",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villeguita",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04140396781",
      "client_email": "YONNYJOSEVARGAS@GMAIL.COM",
      "address": "CALLEJON LOS MANGOS CASA NRO 12-1 SECTOR VILLEGUITA 1 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V13770707",
      "nap_box_name": "498",
      "created_at": "2024-04-15T13:46:44.180059",
      "service_detail": {
        "id": 10956,
        "ip": "172.26.124.2",
        "mac": "HWTCC171609C",
        "serial": "HWTCC171609C",
        "queue": null,
        "interface": "VLAN238_VILLEGUITA",
        "created_at": "2025-12-26T13:09:17.398115",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3544,
      "client_name": "MIRIAN ANTONIA CARRASQUEL HIDALGO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Las Rurales",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243424842",
      "client_email": "RAFAELGRATEROL067@GMAIL.COM",
      "address": "CALLE BOLIVAR CASA NRO 13-1 SECTOR LAS RURALES ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL",
      "client_identification": "V8731279",
      "nap_box_name": "614",
      "created_at": "2024-04-15T13:47:47.690302",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3545,
      "client_name": "JACKSON ALEJANDRO MORFFE LIZCANIO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243451989",
      "client_email": "MEKANICK000@GMAIL.COM",
      "address": "CALLE 9 CASA NRO 599-A URB MATA CABALLO ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V18266090",
      "nap_box_name": "CE - 567",
      "created_at": "2024-04-15T13:52:26.450201",
      "service_detail": {
        "id": 10095,
        "ip": "172.27.173.2",
        "mac": "HWTC54B315A3",
        "serial": "HWTC54B315A3",
        "queue": null,
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2025-11-13T14:04:21.394201",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3546,
      "client_name": "YERRIKA ALESSANDRA GUZMAN RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Santa Eduviges",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124581419",
      "client_email": "YERRIKAGUZMAN@GMAIL.COM",
      "address": "CALLE HENRY PITTIER VEREDA 9 CASA NRO 1 SECTOR SANTA EDUVIGES EL MACARO",
      "client_identification": "V27646322",
      "nap_box_name": "122",
      "created_at": "2024-04-15T13:52:48.515058",
      "service_detail": {
        "id": 3782,
        "ip": "172.17.75.2",
        "mac": "VSOL0013EE81",
        "serial": "VSOL0013EE81",
        "queue": "Plan_92034_1574_WispHub",
        "interface": "VLAN127_SANTA_EDUVIGES",
        "created_at": "2024-07-13T16:44:05.148833",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3547,
      "client_name": "YANET DEL VALLE MONTANEZ DE ALVAREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Antonio Jose de Sucre",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04129673463",
      "client_email": "ROSAMARINAGARRIDO@GMAIL.COM",
      "address": "CALLE PRINCIPAL CASA NRO 39 BARRIO ANTONIO JOSE DE SUCRE EL MACARO",
      "client_identification": "V4401874",
      "nap_box_name": "122",
      "created_at": "2024-04-15T13:54:43.978063",
      "service_detail": {
        "id": 3896,
        "ip": "172.24.129.2",
        "mac": "TPLGB446F4B1",
        "serial": "TPLGB446F4B1",
        "queue": "Plan_92034_1574_WispHub",
        "interface": "VLAN101_AJS",
        "created_at": "2024-07-16T18:23:31.070284",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3548,
      "client_name": "ALONZO MARCELINO URQUIOLA CASTRO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Santa Eduviges",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124548610",
      "client_email": "ALONZOURQUIOLA83@GMAIL.COM",
      "address": "VDA 3 CASA NRO 2 URB SANTA EDUVIGES EL MACARO TURMERO",
      "client_identification": "V16684874",
      "nap_box_name": "86 DOS",
      "created_at": "2024-04-15T13:55:27.682201",
      "service_detail": {
        "id": 8633,
        "ip": "172.24.6.2",
        "mac": "VSOL00139329",
        "serial": "VSOL00139329",
        "queue": "queue1",
        "interface": "VLAN127_SANTA_EDUVIGES",
        "created_at": "2025-05-15T10:19:06.638309",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3549,
      "client_name": "LILIA KAREN CARVAJAL RONDON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04122595856",
      "client_email": "KARENCARVAJALCARACAS@GMAIL.COM",
      "address": "CALLE 21 CASA NRO 22 SECTOR RIO SECO ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V20335577",
      "nap_box_name": "603",
      "created_at": "2024-04-15T13:58:12.088994",
      "service_detail": {
        "id": 3898,
        "ip": "172.26.203.2",
        "mac": "HWTC4633F29B",
        "serial": "HWTC4633F29B",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN251_RIO_SECO",
        "created_at": "2024-07-16T18:27:25.450922",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3550,
      "client_name": "JHONY SALAVERRIA ARRIENS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Brisas de Paya",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04243032766",
      "client_email": "JHONYSALAVERRIA070254@GMAIL.COM",
      "address": "Calle 1 Casa Nro 22 Urb Brisas De Paya Turmero Zona Postal 2115",
      "client_identification": "V4357799",
      "nap_box_name": "369",
      "created_at": "2024-04-15T14:03:38.082666",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3551,
      "client_name": "ROXELIS SARAHI VALERA RANGEL",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Santa Eduviges",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04228152420",
      "client_email": "ROXELISVALERA14@GMAIL.COM",
      "address": "VDA 10 CASA NRO 11 BARRIO SANTA EDUVIGES TURMERO",
      "client_identification": "V25501476",
      "nap_box_name": "173",
      "created_at": "2024-04-15T14:06:12.183810",
      "service_detail": {
        "id": 11669,
        "ip": "172.23.176.2",
        "mac": "VSOL0012EAD9",
        "serial": "VSOL0012EAD9",
        "queue": null,
        "interface": "VLAN127_SANTA_EDUVIGES",
        "created_at": "2026-02-18T14:53:11.913223",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3552,
      "client_name": "LISBETH JOSEFINA ALVARADO SALAZAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Canaima",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04144507283",
      "client_email": "LISBETH_ALVARADO11@HOTMAIL.COM",
      "address": "CALLE 4 CASA NRO 32 URBANIZACIÓN CANAIMA",
      "client_identification": "V19947141",
      "nap_box_name": "CTO-00315 ",
      "created_at": "2024-04-15T14:08:02.551600",
      "service_detail": {
        "id": 3828,
        "ip": "172.20.68.2",
        "mac": "TPLGF4B1DBE5",
        "serial": "TPLGF4B1DBE5",
        "queue": "Plan_161901_30183_WispHub",
        "interface": "VLAN237_CANAIMA",
        "created_at": "2024-07-16T09:10:35.107223",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3553,
      "client_name": "ZUGEIRIKA NATHALIE BOLIVAR TOVAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Santa Eduviges",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243741227",
      "client_email": "ZBNATHALIE79@GMAIL.COM",
      "address": "VDA 5 CASA NRO 5 BARRIOS SANTA EDUVIGES TURMERO",
      "client_identification": "V13907458",
      "nap_box_name": "173",
      "created_at": "2024-04-15T14:08:21.700103",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3554,
      "client_name": "YELITZA JOSEFINA FAGUNDEZ ALADEJO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04144891726",
      "client_email": "YELITZAFAGUNDEZ66@GMAIL.COM",
      "address": "AV2 CASA NRO 527-A URB MATA CABALLO ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V12378784",
      "nap_box_name": "CTO-00222",
      "created_at": "2024-04-15T14:08:25.947024",
      "service_detail": {
        "id": 5937,
        "ip": "172.28.82.2",
        "mac": "ZICGCD06C9BD",
        "serial": "ZICGCD06C9BD",
        "queue": "Plan_161895_30183_WispHub",
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2024-08-21T13:32:58.977891",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3555,
      "client_name": "YOSWEN RICARDO MUJICA CORREDOR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Santa Eduviges",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124852537",
      "client_email": "YOSWENXD@GMAIL.COM",
      "address": "CALLE PRINCIPAL CASA NRO 23 SECTOR SANTA EDUVIGES EL MACARO",
      "client_identification": "V29650323",
      "nap_box_name": "87 DOS",
      "created_at": "2024-04-15T14:10:21.403185",
      "service_detail": {
        "id": 3843,
        "ip": "172.23.39.2",
        "mac": "TPLGBA687C22",
        "serial": "TPLGBA687C22",
        "queue": "Plan_129887_1574_WispHub",
        "interface": "VLAN127_SANTA_EDUVIGES",
        "created_at": "2024-07-16T13:13:47.611834",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3556,
      "client_name": "KARIANA BEZABETH ROMERO SANCHEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Tibisay Guevara",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243084002",
      "client_email": "JORDANISRODRIGUEZ61@GMAIL.COM",
      "address": "TIBISAY GUEVARA CALLE 1 N12 SECTOR EL MACARO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V25527217",
      "nap_box_name": "CTO-00054",
      "created_at": "2024-04-15T14:11:09.787546",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3557,
      "client_name": "WINNER DAVID MARTINEZ LUGO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Santa Eduviges",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04141382316",
      "client_email": "WINNERMARTINEZ217@GMAIL.COM",
      "address": "CALLE SANTA EDUVIGES CASA NRO 6 SECTOR EL MACARO TURMERO",
      "client_identification": "V29581548",
      "nap_box_name": "173",
      "created_at": "2024-04-15T14:12:01.949055",
      "service_detail": {
        "id": 3545,
        "ip": "172.22.8.2",
        "mac": "TPLGB68B50EE",
        "serial": "TPLGB68B50EE",
        "queue": "Plan_138775_1574_WispHub",
        "interface": "VLAN127_SANTA_EDUVIGES",
        "created_at": "2024-07-08T17:46:19.840863",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3558,
      "client_name": "SOL MARIA CASTILLO DE BRAZON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121570339",
      "client_email": "SOLBRAZON860@GMAIL.COM",
      "address": "CALLE 3 CASA NRO 31 URB SAMAN TARAZONERO 1 TURMERO ARAGUA",
      "client_identification": "V6296389",
      "nap_box_name": "32",
      "created_at": "2024-04-15T14:13:17.527010",
      "service_detail": {
        "id": 9215,
        "ip": "172.19.77.2",
        "mac": "TPLGB765639E",
        "serial": "TPLGB765639E",
        "queue": "queue1",
        "interface": "VLAN140_SMT1_ZTE",
        "created_at": "2025-07-16T17:55:25.869335",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3560,
      "client_name": "CRISLEIDY KATHERINE DIAZ LEON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Macarena",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04263347049",
      "client_email": "CRISLEIDYDIAZ60@GMAIL.COM",
      "address": "CALLE 6 CASA NRO 6 SECTOR LA MACARENA",
      "client_identification": "V19418071",
      "nap_box_name": "246",
      "created_at": "2024-04-15T14:15:01.140123",
      "service_detail": {
        "id": 3360,
        "ip": "172.18.104.2",
        "mac": "VSOL0051FDF1",
        "serial": "VSOL0051FDF1",
        "queue": "Plan_92034_1574_WispHub",
        "interface": "VLAN112_LA_MACARENA",
        "created_at": "2024-07-02T16:44:40.549701",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3561,
      "client_name": "CARMEN TERESA DURAN DE SILVA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Macarena",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121485959",
      "client_email": "DURANCARMEN801@GMAIL.COM",
      "address": "AV PRINCIPAL CASA NRO 3 SECTOR EL MACARO TURMERO",
      "client_identification": "V3794672",
      "nap_box_name": "300",
      "created_at": "2024-04-15T14:18:32.759632",
      "service_detail": {
        "id": 3907,
        "ip": "172.20.168.2",
        "mac": "TPLGF4EFC33F",
        "serial": "TPLGF4EFC33F",
        "queue": "Plan_92034_1574_WispHub",
        "interface": "VLAN113_LA_MACARENIA",
        "created_at": "2024-07-16T18:49:12.528097",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3562,
      "client_name": "EMILY MAITTE DIAZ CAPO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Macarena",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04122293399",
      "client_email": "MAITTELAMORENA5@GMAIL.COM",
      "address": "CALLE 6 CASA NRO 16 SECTOR LA MACARENA",
      "client_identification": "V16128574",
      "nap_box_name": "246",
      "created_at": "2024-04-15T14:19:22.765934",
      "service_detail": {
        "id": 6141,
        "ip": "172.18.161.2",
        "mac": "VSOL0011D6B1",
        "serial": "VSOL0011D6B1",
        "queue": "Plan_127744_1574_WispHub",
        "interface": "VLAN112_LA_MACARENA",
        "created_at": "2024-08-22T17:17:45.596907",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3563,
      "client_name": "ROSA ELVIA MOVILIO HERNANDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "La Macarena",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04127765178",
      "client_email": "ROSJHO.121994@GMAIL.COM",
      "address": "CALLE 04 CASA NRO 10 BARRIO LA MACARENA SECTOR EL MACARO",
      "client_identification": "V6189613",
      "nap_box_name": "33",
      "created_at": "2024-04-15T14:22:38.895232",
      "service_detail": {
        "id": 3847,
        "ip": "172.24.58.2",
        "mac": "GPON0097DBE6",
        "serial": "GPON0097DBE6",
        "queue": "queue1",
        "interface": "VLAN112_LA_MACARENA_ZTE",
        "created_at": "2024-07-16T13:27:56.792354",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3564,
      "client_name": "RAHUNYM JOSE MANTILLA GODOY",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados de Cafetal",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04149474118",
      "client_email": "RAHUNYM@GMAIL.COM",
      "address": "CALLE TRANSCERSAL CASA NRO B-1 PRADOS DE CAFETAL TURMERO",
      "client_identification": "V19277981",
      "nap_box_name": "545",
      "created_at": "2024-04-15T14:24:01.503700",
      "service_detail": {
        "id": 4278,
        "ip": "10.10.151.2",
        "mac": "TPLGB954EC9C",
        "serial": "TPLGB954EC9C",
        "queue": "Plan_140304_15811_WispHub",
        "interface": "VLAN221_CAFETAL_OLT1",
        "created_at": "2024-08-08T14:48:53.346118",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3565,
      "client_name": "CARMEN BONIFACIA HERRERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Macarena",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04125338789",
      "client_email": "HERRERACARMENB1125@GMAIL.COM",
      "address": "CALLE 9 CASA NRO 11 URB LA MACARENA EL MACARO",
      "client_identification": "V11756225",
      "nap_box_name": "667",
      "created_at": "2024-04-15T14:25:45.904768",
      "service_detail": {
        "id": 3850,
        "ip": "172.23.232.2",
        "mac": "VSOL0013B281",
        "serial": "VSOL0013B281",
        "queue": "Plan_92034_1574_WispHub",
        "interface": "VLAN100_OLTs",
        "created_at": "2024-07-16T13:31:52.889304",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3566,
      "client_name": "LINA ROSA CONTRERAS PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Los Hornos",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128365377",
      "client_email": "CONTRERASPEREZLINAROSA@GMAIL.COM",
      "address": "CALLE LOS MANGOS CASA NRO 24 SECTOR LOS HORNOS",
      "client_identification": "V5347945",
      "nap_box_name": "437",
      "created_at": "2024-04-15T14:26:07.473696",
      "service_detail": {
        "id": 3949,
        "ip": "172.18.130.2",
        "mac": "TPLGF4EFBF4B",
        "serial": "TPLGF4EFBF4B",
        "queue": "Plan_161903_30183_WispHub",
        "interface": "VLAN247_HORNOS",
        "created_at": "2024-07-17T15:01:50.158985",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3567,
      "client_name": "ALIBE DEL VALLE REINA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero I",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04224430582",
      "client_email": "ALIBERODRIGUEZ69@GMAIL.COM",
      "address": "CALLE MANZANA I CASA NRO 14 CACERIO SAMAN TARAZONERO II TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V10495184",
      "nap_box_name": "504",
      "created_at": "2024-04-15T14:28:31.615248",
      "service_detail": {
        "id": 3950,
        "ip": "172.26.172.2",
        "mac": "HWTC46575F9B",
        "serial": "HWTC46575F9B",
        "queue": "Plan_92034_1574_WispHub",
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2024-07-17T15:03:56.448241",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3568,
      "client_name": "MARVIS YOHANA PAREJO ALAYON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Macarena",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04141442518",
      "client_email": "PAREJOMARVIS@GMAIL.COM",
      "address": "CALLE 8 CASA NRO 14 SECTOR LA MACARENA TURMERO",
      "client_identification": "V17511607",
      "nap_box_name": "668",
      "created_at": "2024-04-15T14:28:45.426895",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3569,
      "client_name": "GUSTAVO ADOLFO PARABACUTO RAMIREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Macarena",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04128607949",
      "client_email": "GUSTAVOPARABACUTO@GMAIL.COM",
      "address": "CALLE 9 CASA NRO 16 SECTOR LA MACARENA TURMERO",
      "client_identification": "V18331002",
      "nap_box_name": "667",
      "created_at": "2024-04-15T14:31:06.526964",
      "service_detail": {
        "id": 3839,
        "ip": "172.23.161.2",
        "mac": "GPON 0097A806",
        "serial": "GPON0097A806",
        "queue": "Plan_161895_1574_WispHub",
        "interface": "VLAN100_OLTs",
        "created_at": "2024-07-16T12:53:08.123430",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3570,
      "client_name": "YOSELYS AMARILYS ALVAREZ ALVAREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121574564",
      "client_email": "YOSE.ALVAREZ.02@GMAIL.COM",
      "address": "CALLE MANZANA B-5 CASA NRO 19 SECTOR SAMAN TARAZONERO II",
      "client_identification": "V27048069",
      "nap_box_name": "CTO-00511",
      "created_at": "2024-04-15T14:31:37.055158",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3571,
      "client_name": "VICTOR MANUEL MIRABAL CASTILLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Macarena",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04145995255",
      "client_email": "V.M.TRANSPORTE.MIRABAL@OUTLOOK.COM",
      "address": "LA MACARENA 2 CALLE 5 CASA NRO 10 EL MACARO",
      "client_identification": "V10455903",
      "nap_box_name": "33",
      "created_at": "2024-04-15T14:34:02.157474",
      "service_detail": {
        "id": 3274,
        "ip": "172.23.127.2",
        "mac": "GPON0097C0B6",
        "serial": "GPON0097C0B6",
        "queue": "Plan_92034_1574_WispHub",
        "interface": "VLAN112_LA_MACARENA",
        "created_at": "2024-07-01T11:25:15.226599",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3572,
      "client_name": "BLANCA CRISTINA AREVALO FLORES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Durpa",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243180851",
      "client_email": "AREVALOBLANCA239@GMAIL.COM",
      "address": "CALLE LOS CAOBOS MANZANA 16 CASA NRO 31 SECTOR DESARROLLO URBANISTICO DURPA",
      "client_identification": "V14691618",
      "nap_box_name": "348",
      "created_at": "2024-04-15T14:35:15.609204",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3573,
      "client_name": "XIOMARA LEONOR GONZALEZ PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Durpa",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144579167",
      "client_email": "CIROM384@GMAIL.COM",
      "address": "CALLE ESPERANZA MANZANA 20 CASA NRO 15 SECTOR DESARROLLO URBANISTICO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V8586699",
      "nap_box_name": "376",
      "created_at": "2024-04-15T14:36:55.887933",
      "service_detail": {
        "id": 5753,
        "ip": "172.28.69.2",
        "mac": "ZICGCB640E99",
        "serial": "ZICGCB640E99",
        "queue": "Plan_161905_30183_WispHub",
        "interface": "VLAN240_DURPA",
        "created_at": "2024-08-19T15:01:33.864433",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3574,
      "client_name": "ANDRES ARTURO BRACHO FIGUEROA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Santa Eduviges",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04128970995",
      "client_email": "THELIONSANDREW27@GMAIL.COM",
      "address": "CALLE 5 CASA NRO 9 SECTOR LA MACARENA EL MACARO TURMERO",
      "client_identification": "V19608827",
      "nap_box_name": "33",
      "created_at": "2024-04-15T14:37:44.919818",
      "service_detail": {
        "id": 3855,
        "ip": "172.23.74.2",
        "mac": "VSOL0013E781",
        "serial": "VSOL0013E781",
        "queue": "Plan_138775_1574_WispHub",
        "interface": "VLAN100_OLTs",
        "created_at": "2024-07-16T13:41:26.739883",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3577,
      "client_name": "MARIA FIGUEROA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04143656986",
      "client_email": "FIGUEROAM930@GMAIL.COM",
      "address": "CALLE 11 CASA 37 SECTOR RIO SECO ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V25639170",
      "nap_box_name": "487",
      "created_at": "2024-04-15T14:41:26.396137",
      "service_detail": {
        "id": 3981,
        "ip": "172.26.185.2",
        "mac": "OEMT3C622942",
        "serial": "OEMT3C622942",
        "queue": "Plan_107915_30181_WispHub",
        "interface": "VLAN251_RIO_SECO",
        "created_at": "2024-07-17T16:29:19.640998",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3578,
      "client_name": "LISMARY ADRIANA CARVAJAL RONDON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04126475467",
      "client_email": "LISRONDON92@GMAIL.COM",
      "address": "CALLE 21 CASA NRO 25 RIO SECO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V22948762",
      "nap_box_name": "603",
      "created_at": "2024-04-15T14:44:30.719460",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3579,
      "client_name": "MARTHA BELMIRA PINTO CARPIO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124651395",
      "client_email": "MARTHABELMIRAPINTO@GMAIL.COM",
      "address": "SECTOR RIO SECO CALLE 7 CASA #52 ROSARIO DE PAYA TURMERO ARAGUA 2115",
      "client_identification": "V24169270",
      "nap_box_name": "474",
      "created_at": "2024-04-15T14:46:20.951327",
      "service_detail": {
        "id": 13089,
        "ip": "172.26.157.2",
        "mac": "HW:TC:46:A4:69:9B",
        "serial": "HWTC46A4699B",
        "queue": null,
        "interface": "VLAN251_RIO_SECO",
        "created_at": "2026-09-28T15:54:36.360930",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3580,
      "client_name": "MARIO ALBERTO GAMBOA CARDENAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04140489863",
      "client_email": "GAMBOAALEXANDER178@GMAIL.COM",
      "address": "CALLE 2 CASA NRO 70 SECTOR MATA CABALLO ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V15962797",
      "nap_box_name": "CTO-00565 DOS",
      "created_at": "2024-04-15T14:48:11.287157",
      "service_detail": {
        "id": 11653,
        "ip": "172.26.76.2",
        "mac": "HWTCD6B2859C",
        "serial": "HWTCD6B2859C",
        "queue": null,
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2026-02-17T19:42:21.633933",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3581,
      "client_name": "WILFREDO JOSE MAITIN ACACIO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124537178",
      "client_email": "MAITINYOJANCY@GMAIL.COM",
      "address": "CALLE MANZANA I-8 CASA NRO 09 SECTOR SAMAN TARAZONERO 2 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V28367816",
      "nap_box_name": "119",
      "created_at": "2024-04-15T14:49:50.308729",
      "service_detail": {
        "id": 6135,
        "ip": "172.30.157.2",
        "mac": "HWTCA6047425",
        "serial": "HWTCA6047425",
        "queue": "Plan_129887_1574_WispHub",
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2024-08-22T17:08:50.418605",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3582,
      "client_name": "MARIA FERNANDA MELONE CAMPOS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04228150736",
      "client_email": "GIOMELONE2106@GMAIL.COM",
      "address": "CALLE 1 CASA NRO 22 SAMAN TARAZONERO I TURMERO",
      "client_identification": "V23783876",
      "nap_box_name": "669",
      "created_at": "2024-04-15T14:53:19.759967",
      "service_detail": {
        "id": 9153,
        "ip": "172.23.146.2",
        "mac": "GPON00980BA6",
        "serial": "GPON00980BA6",
        "queue": "queue1",
        "interface": "VLAN140_SMT1_ZTE",
        "created_at": "2025-07-08T11:02:07.121676",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3583,
      "client_name": "LUIS ALBERTO CARRILLO GONZALEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144480559",
      "client_email": "CARRILLO.LUIS576@GMAIL.COM",
      "address": "CALLE B2 CASA NRO 42 URB PANTIN ROSARIO DE PAYA",
      "client_identification": "V8734109",
      "nap_box_name": "CTO-00126",
      "created_at": "2024-04-15T14:58:44.585340",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3584,
      "client_name": "WILLMER ANTONIO BOADA BARILLAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Lascenio Guerrero",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121344200",
      "client_email": "WILLMERBOADA@GMAIL.COM",
      "address": "CALLE 13 CASA NRO 441 URB LASCENIO GUERRERO, FUNDO EL MACARO TURMERO ARAGUA",
      "client_identification": "V10156927",
      "nap_box_name": "432",
      "created_at": "2024-04-15T15:00:12.302832",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3585,
      "client_name": "JESUS ALBERTO TORRES ARGUINZONEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04144769065",
      "client_email": "JEALTOAR@GMAIL.COM",
      "address": "CALLE 11 CASA NRO 27 URB RIO SECO ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V13200452",
      "nap_box_name": "608",
      "created_at": "2024-04-15T15:12:28.233505",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3586,
      "client_name": "CARMEN LUISA JARAMILLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243678097",
      "client_email": "CARMENJARAMILLO1969@GMAIL.COM",
      "address": "CALLE 2 CASA NRO 58 SECTOR MATA CABALLO ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V8684521",
      "nap_box_name": "CTO-435",
      "created_at": "2024-04-15T15:13:42.010502",
      "service_detail": {
        "id": 3985,
        "ip": "172.26.140.2",
        "mac": "HWTCD19AD79A",
        "serial": "HWTCD19AD79A",
        "queue": "Plan_161870_30183_WispHub",
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2024-07-17T16:38:34.212973",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3587,
      "client_name": "JESUS GABRIEL SANCHEZ CARABALLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04122578306",
      "client_email": "GODSHZ49@GMAIL.COM",
      "address": "SAMAN TARAZONERO II CASA MANZANA B 16 NRO 10 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V29581368",
      "nap_box_name": "508",
      "created_at": "2024-04-15T15:27:51.888022",
      "service_detail": {
        "id": 3315,
        "ip": "172.26.230.2",
        "mac": "VSOL00D0DA7B",
        "serial": "VSOL00D0DA7B",
        "queue": "Plan_138775_1574_WispHub",
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2024-07-02T08:07:09.994608",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3588,
      "client_name": "SCARLET YURIBE QUINTERO BRACAMONTE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Brisas de Paya",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128558574",
      "client_email": "SCARLETQUINTERO14@GMAIL.COM",
      "address": "CALLE 1 CASA NRO 13 SECTOR BRISAS DE PAYA ROSARIO DE PAYA",
      "client_identification": "V19655989",
      "nap_box_name": "367",
      "created_at": "2024-04-15T15:31:54.961952",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3589,
      "client_name": "MARGARET NAIROBY ACACIO ROMERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04123984793",
      "client_email": "MARGARETHA0916@GMAIL.COM",
      "address": "CALLE 2 MANZANA B-8 CASA NRO 14 URB SAMAN TARAZONERO II TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V16131816",
      "nap_box_name": "186",
      "created_at": "2024-04-15T15:32:25.537705",
      "service_detail": {
        "id": 12785,
        "ip": "172.30.46.2",
        "mac": "B4:64:15:72:26:70",
        "serial": "GPON00722670",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2026-08-02T19:25:38.630854",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3590,
      "client_name": "ADRIANA DUGLEISYS MARTINEZ URBINA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121489708",
      "client_email": "ADRIANATHIAGO54@GMAIL.COM",
      "address": "CALLE 7 CASA NRO 30 URB LA CASONA I TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V27146498",
      "nap_box_name": "411",
      "created_at": "2024-04-15T15:34:44.318206",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3591,
      "client_name": "JOSE FRANCISCO GONZALEZ LOROÑO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Simon Bolivar",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04123985448",
      "client_email": "FRNCSCLORONO@GMAIL.COM",
      "address": "CALLE 4 CASA NRO 7 URB SIMON BOLIVAR EL MACARO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V14740310",
      "nap_box_name": "CTO-00044",
      "created_at": "2024-04-15T15:49:43.436664",
      "service_detail": {
        "id": 3636,
        "ip": "172.26.117.2",
        "mac": "HWTC46A3089B",
        "serial": "HWTC46A3089B",
        "queue": "Plan_127996_1574_WispHub",
        "interface": "VLAN128_SIMON_BOLIVAR_ZTE",
        "created_at": "2024-07-11T15:02:48.769969",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3592,
      "client_name": "ROGER ALEXIS GEDLER HENRIQUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Valle del Rosario",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04261353840",
      "client_email": "ODIROSO.IFA26@GMAIL.COM",
      "address": "CALLE ARAGUA CASA NRO 05 URB VALLE DEL ROSARIO SECTOR EL MACARO TURMERO ARAGUA",
      "client_identification": "V10632305",
      "nap_box_name": "31",
      "created_at": "2024-04-15T15:51:18.410166",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3593,
      "client_name": "LUIS YHONNEL CACERES CONTRERAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04121472600",
      "client_email": "LUISYHONNELCACERES1605@GMAIL.COM",
      "address": "CALLE 13 CASA NRO 14 SECTOR RIO SECO ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V16851381",
      "nap_box_name": "CTO-00423",
      "created_at": "2024-04-15T15:52:02.581160",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3594,
      "client_name": "ADRIAN ARTURO OLMEDO FUENTES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Concepcion",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144886476",
      "client_email": "ADRIANOLMEDO.VE@GMAIL.COM",
      "address": "CALLE 1 CASA NRO 12 LA CONCEPCION TURMERO LA JULIA ESTADO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V21336925",
      "nap_box_name": "0326 DOS",
      "created_at": "2024-04-15T15:55:57.869249",
      "service_detail": {
        "id": 6125,
        "ip": "172.26.243.2",
        "mac": "VSOL00D106A7",
        "serial": "VSOL00D106A7",
        "queue": "Plan_131337_24341_WispHub",
        "interface": "VLAN111_CONCEPCION",
        "created_at": "2024-08-22T16:43:08.580149",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3595,
      "client_name": "ELWIMAR JESSIBEL MARTINEZ AVILA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04125972977",
      "client_email": "SEBISGM2006@GMAIL.COM",
      "address": "CALLE 2B CASA NRO 52 ROSARIO DE PAYA PANTIN TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V26791173",
      "nap_box_name": "CTO-00126",
      "created_at": "2024-04-15T15:56:11.263355",
      "service_detail": {
        "id": 3554,
        "ip": "172.26.190.2",
        "mac": "ADCGCCA009F3",
        "serial": "ADCGCCA009F3",
        "queue": "Plan_161905_30183_WispHub",
        "interface": "VLAN229_PANTIN",
        "created_at": "2024-07-09T08:04:58.281857",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3596,
      "client_name": "LUZ MARINA BUELVAS TERAN",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Palmeras II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243680235",
      "client_email": "LUZMARINABUELVAS1997@GMAIL.COM",
      "address": "CALLE 03 CASA NRO 5-C URB LAS PALMERAS II TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V26379285",
      "nap_box_name": "336",
      "created_at": "2024-04-15T15:58:49.007594",
      "service_detail": {
        "id": 6387,
        "ip": "172.26.12.2",
        "mac": "VSOL00D110FB",
        "serial": "VSOL00D110FB",
        "queue": "Plan_131337_24341_WispHub",
        "interface": "VLAN119_PALMERAS_2",
        "created_at": "2024-08-27T14:19:32.573151",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3597,
      "client_name": "ORIANA CAROLINA PAIVA FLORES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128775517",
      "client_email": "ORIANACPF.19@GMAIL.COM",
      "address": "CALLE 11 CASA NRO 33 SECTOR RIO SECO ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V19516945",
      "nap_box_name": "487",
      "created_at": "2024-04-15T16:01:26.792633",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3598,
      "client_name": "NOMAR ALEJANDRO SANCHEZ ORAMAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Palmeras II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128921869",
      "client_email": "NOMARSO1@GMAIL.COM",
      "address": "CALLE ÑALLE PRINCIPAL TERRAZAS C LOCAL NRO 06 URB LAS PALMERAS II TURMERO",
      "client_identification": "V22954504",
      "nap_box_name": "336",
      "created_at": "2024-04-15T16:04:05.650379",
      "service_detail": {
        "id": 6650,
        "ip": "172.19.212.2",
        "mac": "TPLGB446F956",
        "serial": "TPLGB446F956",
        "queue": "Plan_131337_24341_WispHub",
        "interface": "VLAN119_PALMERAS_2",
        "created_at": "2024-09-17T14:04:25.737937",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3599,
      "client_name": "ROSANA ANAIS AMADOR AMADOR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144437326",
      "client_email": "PEDRAERICK806@GMAIL.COM",
      "address": "CALLE PRINCIPAL CASA NRO 686 URB MATA CABALLO",
      "client_identification": "V20988506",
      "nap_box_name": "CTO-00210",
      "created_at": "2024-04-15T16:04:21.825046",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3600,
      "client_name": "JONATHAN ELEAZAR VARGAS  MANCHECO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Simon Bolivar",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243081030",
      "client_email": "JONAVARGAS5480@GMAIL.COM",
      "address": "CALLE 10 CASA NRO 15 URB SIMON BOLIVAR TURMERO",
      "client_identification": "V18490288",
      "nap_box_name": "CTO-00036",
      "created_at": "2024-04-15T16:08:20.551051",
      "service_detail": {
        "id": 3567,
        "ip": "172.23.106.2",
        "mac": "VSOL0012EAE9",
        "serial": "VSOL0012EAE9",
        "queue": "Plan_137413_1574_WispHub",
        "interface": "VLAN128_SIMON_BOLIVAR_ZTE",
        "created_at": "2024-07-09T10:13:06.828301",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3601,
      "client_name": "RICHARD ENRIQUE CARRANZA SILVA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villeguita",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04164465344",
      "client_email": "RICHARD21CRISTIANO@GMAIL.COM",
      "address": "CALLE EL COLEGIO CALLE PRINCIPAL CASA NRO 88 SECTOR VILLEGUITA I TURMERO ESTADO ARAGUA",
      "client_identification": "V11564456",
      "nap_box_name": "212",
      "created_at": "2024-04-15T16:11:02.568827",
      "service_detail": {
        "id": 5365,
        "ip": "172.30.53.2",
        "mac": "VSOL004983A9",
        "serial": "VSOL004983A9",
        "queue": "Plan_128612_15811_WispHub",
        "interface": "VLAN238_VILLEGUITA",
        "created_at": "2024-08-16T11:36:03.876372",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3602,
      "client_name": "EVELYN JHOSMELY RAHAMUT PIETER",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Simon Bolivar",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128902038",
      "client_email": "JORGEAB.HOPE@GMAIL.COM",
      "address": "CALLE 3 CASA NRO 34 URB SIMÓN BOLÍVAR TURMERO ARAGUA",
      "client_identification": "V7223721",
      "nap_box_name": "CTO-00046",
      "created_at": "2024-04-15T16:15:40.898542",
      "service_detail": {
        "id": 4313,
        "ip": "172.29.32.2",
        "mac": "TPLGB76563B4",
        "serial": "TPLGB76563B4",
        "queue": "Plan_137413_1574_WispHub",
        "interface": "VLAN128_SIMON_BOLIVAR_ZTE",
        "created_at": "2024-08-09T09:02:11.937294",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3603,
      "client_name": "FRANCYS DARIANNYS COLINA GUERRA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Concepcion",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243694664",
      "client_email": "beicker2611@gmail.com",
      "address": "CALLE 01 CASA NRO 8 URB LA CONCEPCION",
      "client_identification": "V20110385",
      "nap_box_name": "0326 DOS",
      "created_at": "2024-04-15T16:16:01.151624",
      "service_detail": {
        "id": 6651,
        "ip": "172.19.244.2",
        "mac": "TPLGF5CB0814",
        "serial": "TPLGF5CB0814",
        "queue": "Plan_131341_24341_WispHub",
        "interface": "VLAN111_CONCEPCION",
        "created_at": "2024-09-17T14:17:59.147721",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3604,
      "client_name": "MARIA YULEYMA GONZALEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Magdalena",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04143908380",
      "client_email": "GONZALEZYULE12@GMAIL.COM",
      "address": "LA JULIA URBANISMO LA MAGADALENA CALLE 07 CASA NRO 38 AV 02 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V8998706",
      "nap_box_name": "627",
      "created_at": "2024-04-15T16:16:45.594835",
      "service_detail": {
        "id": 12500,
        "ip": "172.26.253.2",
        "mac": "1c:ef:03:d0:ea:b3",
        "serial": "VSOL00D0EAB3",
        "queue": null,
        "interface": "VLAN114_MAGDALENA",
        "created_at": "2026-05-15T15:03:17.224584",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3605,
      "client_name": "YAITZA MARGARITA BARRETO AGREDA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Simon Bolivar",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243085411",
      "client_email": "BARRETOMA.57@GMAIL.COM",
      "address": "CALLE 9 CASA NRO 15 URB SIMON BOLIVAR EL MACARO TURMERO",
      "client_identification": "V5263600",
      "nap_box_name": "CTO-00040",
      "created_at": "2024-04-15T16:18:10.467503",
      "service_detail": {
        "id": 5366,
        "ip": "172.27.89.2",
        "mac": "TPLGB954FA0F",
        "serial": "TPLGB954FA0F",
        "queue": "Plan_127996_1574_WispHub",
        "interface": "VLAN128_SIMON_BOLIVAR_ZTE",
        "created_at": "2024-08-16T11:38:02.620388",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3606,
      "client_name": "JEANNETE MARGARITA MORENO GOTO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Magdalena",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243097662",
      "client_email": "LACONEJA560@GMAIL.COM",
      "address": "AV2 CALLE 05 CASA 25 LA MAGDALENA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V7273115",
      "nap_box_name": "483",
      "created_at": "2024-04-15T16:19:59.716497",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3607,
      "client_name": "MARISABEL MAAL DE RIVAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Callejon Cañaveral",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144907752",
      "client_email": "MMAALG@GMAIL.COM",
      "address": "CALLE CAÑAVERAL CASA NRO 4 APT-1 PAYA ROSARIO DE PAYA",
      "client_identification": "V5274974",
      "nap_box_name": "97",
      "created_at": "2024-04-15T16:23:52.118392",
      "service_detail": {
        "id": 4942,
        "ip": "172.21.14.2",
        "mac": "TPLGF5CB068A",
        "serial": "TPLGF5CB068A",
        "queue": "Plan_153953_15811_WispHub",
        "interface": "VLAN204_CANAVERAL_OLT2",
        "created_at": "2024-08-13T14:45:34.109007",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3608,
      "client_name": "CELINA ISABEL LOPEZ CARTAYA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04127768424",
      "client_email": "CELINALOPEZ2986@GMAIL.COM",
      "address": "CALLE MANZANA C-6 CASA NRO 2 URB SAMAN TARAZONERO II EL MACARO TURMERO",
      "client_identification": "V17197726",
      "nap_box_name": "505",
      "created_at": "2024-04-15T16:26:34.502222",
      "service_detail": {
        "id": 13066,
        "ip": "172.19.76.2",
        "mac": "TP:LG:B9:55:01:E9",
        "serial": "TPLGB95501E9",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2026-09-22T18:24:57.212800",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3609,
      "client_name": "YURIZ MALLERLIN DUQUE VILLANUEVA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128909671",
      "client_email": "MALLERLIN2018@GMAIL.COM",
      "address": "CALLE 04 CASA NRO 14 BARRIO PRADOS DE PAYA 2 ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V17253599",
      "nap_box_name": "CTO-00100",
      "created_at": "2024-04-15T16:28:05.180726",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3610,
      "client_name": "NOEL DE JESUS RONDON JIMENEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Arturo Luis Berti",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124628254",
      "client_email": "NRONDON1973@GMAIL.COM",
      "address": "CALLE PRIMERA CASA NRO 369 URB ARTURO LUIS BERTI EL MACARO",
      "client_identification": "V11088880",
      "nap_box_name": "29",
      "created_at": "2024-04-15T16:31:14.992904",
      "service_detail": {
        "id": 5369,
        "ip": "172.24.99.2",
        "mac": "TPLGF4EFC50B",
        "serial": "TPLGF4EFC50B",
        "queue": "Plan_137413_1574_WispHub",
        "interface": "VLAN102_ARTURO_BERTI",
        "created_at": "2024-08-16T11:46:53.976824",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3611,
      "client_name": "FRANCISCO JOSE MACHADO UTRERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Los Caobos",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243145362",
      "client_email": "FRANCISCOUTRERA58@GMAIL.COM",
      "address": "CALLE PARAISO CASA NRO 21 URB NUEVA VILLEGAS TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V5115325",
      "nap_box_name": "439",
      "created_at": "2024-04-15T16:32:35.544723",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3612,
      "client_name": "VIVIANA NATHALY OROZCO HERNANDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados I",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04122994603",
      "client_email": "OROZCOHERVIVIANANATHALY@GMAIL.COM",
      "address": "CALLE 03 CASA NRO 18 SECTOR PRADOS I TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V18852142",
      "nap_box_name": "CTO-00061",
      "created_at": "2024-04-15T16:33:38.679190",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3613,
      "client_name": "JEANNETE ESPERANZA GONZALEZ LOPEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04141494804",
      "client_email": "JANETESPERANZA.3@GMAIL.COM",
      "address": "AV2 CASA NRO 524-A URB MATA CABALLO ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V10759403",
      "nap_box_name": "CTO-00222",
      "created_at": "2024-04-15T16:35:52.902427",
      "service_detail": {
        "id": 6122,
        "ip": "172.26.247.2",
        "mac": "VSOL00D0E7AF",
        "serial": "VSOL00D0E7AF",
        "queue": "Plan_161905_30183_WispHub",
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2024-08-22T16:39:12.998489",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3614,
      "client_name": "PAULETTE ANDREINA NIEVES DIAZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Terrazas de Turmero",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243643785",
      "client_email": "GUTIERREZJANNY6@GMAIL.COM",
      "address": "CALLE PRINCIPAL RIVAS CALLE 2 CASA NRO B-29 URB TERRAZAS DE TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V27326352",
      "nap_box_name": "118",
      "created_at": "2024-04-15T16:36:27.489083",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3616,
      "client_name": "HECTOR DANIEL PERDOMO RICO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados I",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243262001",
      "client_email": "DANIELPERDOMO564@GMAIL.COM",
      "address": "CALLE 9 CASA NRO 2 SECTOR PRADOS DE PAYA I TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V19245012",
      "nap_box_name": "417",
      "created_at": "2024-04-15T16:40:44.765898",
      "service_detail": {
        "id": 6394,
        "ip": "172.26.254.2",
        "mac": "VSOL00D0F1DF",
        "serial": "VSOL00D0F1DF",
        "queue": "queue1",
        "interface": "VLAN239_PRADOS1",
        "created_at": "2024-08-27T15:04:40.616209",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3617,
      "client_name": "LILIANA LOPEZ APONTE DE PARRA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Valle Verde",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243704617",
      "client_email": "PROFASCARLIBOLIVAR@GMAIL.COM",
      "address": "AV PRINCIPAL CASA ROSARIO DE PAYA NRO 63-1 SECTOR VALLE VERDE ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V10750503",
      "nap_box_name": "482",
      "created_at": "2024-04-15T16:46:25.142521",
      "service_detail": {
        "id": 6103,
        "ip": "172.26.23.2",
        "mac": "VSOL00D10B9B",
        "serial": "VSOL00D10B9B",
        "queue": "Plan_161905_30183_WispHub",
        "interface": "VLAN246_NARANJAL",
        "created_at": "2024-08-22T15:06:46.156578",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3618,
      "client_name": "MARYORI TIRRE ALONZO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243102793",
      "client_email": "MARYORITIRRE10@GMAIL.COM",
      "address": "CALLE PRINCIPAL NRO 227 MATA CABALLO",
      "client_identification": "V13699817",
      "nap_box_name": "CTO-00265",
      "created_at": "2024-04-15T16:50:50.489287",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3619,
      "client_name": "NANCY EGLES ROJAS MUÑOZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243570079",
      "client_email": "EGLESPRINCESA@GMAIL.COM",
      "address": "URB MATA CABALLO CALLE 4 CASA 266 ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V13201740",
      "nap_box_name": "CTO-00028",
      "created_at": "2024-04-15T16:55:21.320483",
      "service_detail": {
        "id": 6102,
        "ip": "172.26.252.2",
        "mac": "VSOL00D0F1A3",
        "serial": "VSOL00D0F1A3",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2024-08-22T15:04:27.337055",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3620,
      "client_name": "JUAN CARLOS RONDON PINTO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04123491271",
      "client_email": "JUANRONDON495@GMAIL.COM",
      "address": "CALLE 12-A CASA NRO 27 SECTOR URBANIZACION PANTI VIA ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V12569919",
      "nap_box_name": "CTO-00165",
      "created_at": "2024-04-15T16:57:50.000566",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3622,
      "client_name": "OBDULA MERCEDES DIAZ POLEO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121487652",
      "client_email": "OBDULADIAZ2650@GMAIL.COM",
      "address": "CALLE LOS JABILLOS CASA NRO 14 SECTOR EL SAMAN PRADOS I ROSARIO DE PAYA TURMERO ARAGUA",
      "client_identification": "V12929741",
      "nap_box_name": "585",
      "created_at": "2024-04-16T08:37:59.678485",
      "service_detail": {
        "id": 2881,
        "ip": "172.28.41.2",
        "mac": "ZICGCB6413FC",
        "serial": "ZICGCB6413FC",
        "queue": "Plan_161903_30183_WispHub",
        "interface": "VLAN239_PRADOS1",
        "created_at": "2024-06-18T18:02:48.891684",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3623,
      "client_name": "GYOVANNA NATHALY COELLO SALAZAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04126034729",
      "client_email": "JENNYSAVEHY@GMAIL.COM",
      "address": "CALLE 8 CASA NRO 4 URB HACIENDA PATÍN TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V30461774",
      "nap_box_name": "CTO-00121",
      "created_at": "2024-04-16T08:45:53.873959",
      "service_detail": {
        "id": 5997,
        "ip": "172.28.85.2",
        "mac": "ZICGCEB28C79",
        "serial": "ZICGCEB28C79",
        "queue": "Plan_161903_30183_WispHub",
        "interface": "VLAN229_PANTIN",
        "created_at": "2024-08-22T08:02:30.553821",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3624,
      "client_name": "JOE EZZARD LIMA CARPIO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04129675209",
      "client_email": "LIMAJOE341@GMAIL.COM",
      "address": "CALLE 1 CASA NRO 12 SECTOR RIO SECO ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V15129053",
      "nap_box_name": "472",
      "created_at": "2024-04-16T08:48:20.773470",
      "service_detail": {
        "id": 6095,
        "ip": "172.28.45.2",
        "mac": "ZICGCA63DC01",
        "serial": "ZICGCA63DC01",
        "queue": "Plan_161903_30183_WispHub",
        "interface": "VLAN251_RIO_SECO",
        "created_at": "2024-08-22T14:42:00.045210",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3625,
      "client_name": "MIGUEL ANGEL ZAPATA SOSA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04126828539",
      "client_email": "MUCUTUIZAPATA@GMAIL.COM",
      "address": "CALLE MANZANA E-8 CASA NRO 03 URB SAMAN TARAZONERO II TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V17470054",
      "nap_box_name": "161 DOS",
      "created_at": "2024-04-16T08:50:34.239042",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3626,
      "client_name": "RICHARD ELIAS CORTEZ ANDRADE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243793674",
      "client_email": "ADRERODRI.23@GMAIL.COM",
      "address": "MATA CABALLO CALLE 4 CASA N 195 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V25066443",
      "nap_box_name": "CTO-00274",
      "created_at": "2024-04-16T08:52:49.366335",
      "service_detail": {
        "id": 12150,
        "ip": "172.28.51.2",
        "mac": "ZICGCD04179E",
        "serial": "ZICGCD04179E",
        "queue": null,
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2026-03-21T12:44:12.061867",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3627,
      "client_name": "FRANCISCO JAVIER MALAVE RIVERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04122982628",
      "client_email": "ISCOJAVIEROVE9@GMAIL.COM",
      "address": "CALLE 1 CASA NRO 37 PRADOS 2 ROSARIO DE PAYA",
      "client_identification": "V18645502",
      "nap_box_name": "CTO-00118 DOS",
      "created_at": "2024-04-16T09:04:06.200182",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3628,
      "client_name": "ALBERTO JOSE CARDOZO TORRES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144903766",
      "client_email": "LEIDYSCARDOZOURBINA@GMAIL.COM",
      "address": "VIA EL MACARO NRO 2 SECTOR SAMAN TARAZONERO 2 TURMERO",
      "client_identification": "V6531356",
      "nap_box_name": "128",
      "created_at": "2024-04-16T09:06:38.213533",
      "service_detail": {
        "id": 6030,
        "ip": "172.21.98.2",
        "mac": "TPLGB954FC8B",
        "serial": "TPLGB954FC8B",
        "queue": "Plan_161852_1574_WispHub",
        "interface": "VLAN100_OLTs",
        "created_at": "2024-08-22T09:42:42.490994",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3629,
      "client_name": "MARCELO MOYA PERAZA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124818631",
      "client_email": "MARCELOMOYA1989@GMAIL.COM",
      "address": "CALLE 12-B CASA NRO 33 URB HACIENDA PANTI TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V20757446",
      "nap_box_name": "CTO-00166",
      "created_at": "2024-04-16T09:09:29.586112",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3630,
      "client_name": "YERSIKA MARIA LOYO CARRASQUEL",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Las Rurales",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124075137",
      "client_email": "VALESKAGRANADILLO17@GMAIL.COM",
      "address": "CALLE BOLIVAR CASA NRO 13 SECTOR LAS RURALES ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTA",
      "client_identification": "V15129096",
      "nap_box_name": "614",
      "created_at": "2024-04-16T09:12:56.855425",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3631,
      "client_name": "MARIA SOLEDAD AMADOR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Paya Abajo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144679867",
      "client_email": "AMADORMARIASOLEDAD6@GMAIL.COM",
      "address": "VIA PRINCIPAL ROSARIO DE PAYA SECTOR PAYA ABAJO CASA NRO 07 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V14319131",
      "nap_box_name": "272",
      "created_at": "2024-04-16T09:16:31.888097",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3632,
      "client_name": "ARELYS YOLIMAR CASTILLO HERNANDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados III",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04269458534",
      "client_email": "ISIMAR.0611@GMAIL.COM",
      "address": "AV2 MANZANA B CASA NRO 17 SECTOR PRADOS DE PAYA 3 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V12137960",
      "nap_box_name": "580 DOS",
      "created_at": "2024-04-16T09:25:18.403358",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3633,
      "client_name": "YARIT GABRIELA CAMACHO MARTINEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Palmeras II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124608205",
      "client_email": "GABY_011190@HOTMAIL.COM",
      "address": "INTERCOMUNAL TURMERO CONJUNTO RESIDENCIAL LAS PALMERAS 2 CALLE 3 CASA 35 EDO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V20244895",
      "nap_box_name": "336",
      "created_at": "2024-04-16T09:28:48.204417",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3634,
      "client_name": "LUIS ALBERTO GARCIA JIMENEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Taguapire",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04122989292",
      "client_email": "CARRILLODAYANA40@GMAIL.COM",
      "address": "AV LOS MANGOS CASA NRO 5 SECTOR LOS HORNOS ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V16436705",
      "nap_box_name": "548",
      "created_at": "2024-04-16T09:31:56.942964",
      "service_detail": {
        "id": 9214,
        "ip": "172.28.56.2",
        "mac": "ZICGCE62EE71",
        "serial": "ZICGCE62EE71",
        "queue": "queue1",
        "interface": "VLAN247_HORNOS",
        "created_at": "2025-07-16T16:58:47.994087",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3635,
      "client_name": "WENDY JOSEFINA RAMIREZ DE VALLADARES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04265193479",
      "client_email": "VALENTINA79R@GMAIL.COM",
      "address": "CALLE 17 C CASA 23 NRO URB ANTIGUA HACIENDA DE PAYA TURMERO",
      "client_identification": "V14453647",
      "nap_box_name": "CTO-00183",
      "created_at": "2024-04-16T09:43:53.485636",
      "service_detail": {
        "id": 6653,
        "ip": "172.22.114.2",
        "mac": "TPLGBA68781B",
        "serial": "TPLGBA68781B",
        "queue": "Plan_140304_15811_WispHub",
        "interface": "VLAN203_C17_OLT2",
        "created_at": "2024-09-17T14:37:20.363981",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3636,
      "client_name": "ARIAN ORIANA VASQUEZ MORACHINI",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Paya Abajo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04123819867",
      "client_email": "ARIANVASQUEZ.1989@GMAIL.COM",
      "address": "CALLE CAMPO ELIAS CASA NRO 8 SECTOR PAYA ABAJO ROSARIO DE PAYA",
      "client_identification": "V20677254",
      "nap_box_name": "CTO-0252",
      "created_at": "2024-04-16T09:49:19.141720",
      "service_detail": {
        "id": 11608,
        "ip": "172.22.216.2",
        "mac": "TPLGF4EFC436",
        "serial": "TPLGF4EFC436",
        "queue": null,
        "interface": "VLAN231_PAYABAJO",
        "created_at": "2026-02-13T21:02:07.938298",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3637,
      "client_name": "HENXY TERESA MAGDALENO QUINCHOA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243034691",
      "client_email": "HENXYMAGDALENO@GMAIL.COM",
      "address": "CALLE 27 CASA NRO 48 SECTOR RIO SECO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V19605278",
      "nap_box_name": "CTO-00432 DOS",
      "created_at": "2024-04-16T10:08:22.478275",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3638,
      "client_name": "JOSE GREGORIO FERNANDEZ MATA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "San Pablo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144902991",
      "client_email": "SOULIDVANIAFGAMES@GMAIL.COM",
      "address": "CALLE BERMUDEZ EDIF TORRE APOLO PISO 9 APT 91 ZONA CENTRO TURMERO EDO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V22290959",
      "nap_box_name": "CTO-0637",
      "created_at": "2024-04-16T10:14:30.714779",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3639,
      "client_name": "TANIA YESENIA GONZALEZ LADERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243557862",
      "client_email": "TANIAYESENIA1212@GMAIL.COM",
      "address": "CALLE 15 CASA NRO 7 URB PATIN SECTOR PAYA ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V17710911",
      "nap_box_name": "CTO-00201",
      "created_at": "2024-04-16T10:16:42.415138",
      "service_detail": {
        "id": 5996,
        "ip": "172.28.98.2",
        "mac": "ZICGCB817119",
        "serial": "ZICGCB817119",
        "queue": "Plan_161905_30183_WispHub",
        "interface": "VLAN229_PANTIN",
        "created_at": "2024-08-22T07:59:27.822621",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3640,
      "client_name": "ROXANA DEL CARMEN MENDEZ PULIDO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Esperanza",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04125234307",
      "client_email": "ROXANAMP2014@GMAIL.COM",
      "address": "EL MACARO LA ESPERANZA CALLE 07 CASA N-04 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V20693102",
      "nap_box_name": "CE - 451",
      "created_at": "2024-04-16T10:30:46.685428",
      "service_detail": {
        "id": 12771,
        "ip": "172.27.224.2",
        "mac": "ZX:IC:CD:8C:3B:FC",
        "serial": "ZXICCD8C3BFC",
        "queue": null,
        "interface": "VLAN137_LA_ESPERANZA_OLT_ZTE",
        "created_at": "2026-07-25T10:32:05.940914",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3641,
      "client_name": "LEVYS SAMUEL VENERO MARTINEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona I",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128473971",
      "client_email": "DAMARYSVENERO@GMAIL.COM",
      "address": "AV INTERCOMUNAL LA CASONA I CALLE 9 CASA 54 ARAGUA ZONA POSTAL 2115",
      "client_identification": "V16128774",
      "nap_box_name": "408",
      "created_at": "2024-04-16T10:33:04.014182",
      "service_detail": {
        "id": 6017,
        "ip": "172.27.205.2",
        "mac": "HWTC546D96A3",
        "serial": "HWTC546D96A3",
        "queue": "Plan_132787_24341_WispHub",
        "interface": "VLAN109_CASONA_1",
        "created_at": "2024-08-22T09:14:33.167270",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3643,
      "client_name": "JOSE EDUARDO PEREIRA MOLINA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Simon Bolivar",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04126903298",
      "client_email": "MARILYACOSTA307@GMAIL.COM",
      "address": "CALLE 2 CASA NRO 56 SIMON BOLIVAR EL MACARO TURMERO",
      "client_identification": "V7234677",
      "nap_box_name": "CTO-00043",
      "created_at": "2024-04-16T10:41:46.790625",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3644,
      "client_name": "ALFREDO DIONICIO NIEVES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144920978",
      "client_email": "NIEVESANGI14@GMAIL.COM",
      "address": "CALLE I CASA 01 SECTOR PRADOS II ROSARIO DE PAYA",
      "client_identification": "V8732607",
      "nap_box_name": "CTO-00118 DOS",
      "created_at": "2024-04-16T10:43:52.609861",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3645,
      "client_name": "EGLYS ALBERTO LAGUNA TORRES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero I",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04127761042",
      "client_email": "LAGUNAALBERTO70@GMAIL.COM",
      "address": "SECTOR SAMAN TARAZONERO I CALLE 11 CASA NRO25 TURMERO VIA EL MACARO TURMERO",
      "client_identification": "V15364909",
      "nap_box_name": "90",
      "created_at": "2024-04-16T10:46:11.964439",
      "service_detail": {
        "id": 10009,
        "ip": "172.19.164.2",
        "mac": "TPLGB954F97A",
        "serial": "TPLGB954F97A",
        "queue": null,
        "interface": "VLAN140_SMT1_ZTE",
        "created_at": "2025-11-11T14:34:34.825132",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3647,
      "client_name": "ARTURO ENRIQUE ARAUJO MENDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Arturo Luis Berti",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04120798702",
      "client_email": "AEAM1994@GMAIL.COM",
      "address": "CALLE 4 CASA NRO 425URB ARTURO LUIS BERTI TURMERO ARAGUA",
      "client_identification": "V24445104",
      "nap_box_name": "65",
      "created_at": "2024-04-16T10:50:16.499647",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3648,
      "client_name": "MARIA LOURDES RAMIREZ DE COLMENARES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04125971829",
      "client_email": "MARIALOURDESRAMI552@GMAIL.COM",
      "address": "CALLE 4 CASA NRO 32 SECTOR PRADOS DE PAYA II ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V3061454",
      "nap_box_name": "CTO-00100",
      "created_at": "2024-04-16T10:59:03.505945",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3649,
      "client_name": "YENIREE SUSANA PENA ACEVEDO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Paya Abajo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144641163",
      "client_email": "YENIREEPENA5@GMAIL.COM",
      "address": "CALLE LA CAPILLA CASA NRO 13 SECTOR PAYA  ABAJO  ROSARIO DE PAYA",
      "client_identification": "V25501204",
      "nap_box_name": "254",
      "created_at": "2024-04-16T11:05:06.528402",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3651,
      "client_name": "GREYMER JOSE SEQUERA ESCOBAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Callejon Los Mamones",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243100585",
      "client_email": "GREYMERSEQUERA@GMAIL.COM",
      "address": "CALLEJON LOS MAMONES CASA NRO 2 SECTOR VALLE VERDE TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V20693387",
      "nap_box_name": "CTO-00187",
      "created_at": "2024-04-16T11:12:20.250507",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3652,
      "client_name": "DALIA GUILLERMINA PARTIDAS LUQUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Santa Eduviges",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04123982621",
      "client_email": "RIGANMADRID123@GMAIL.COM",
      "address": "CALLE PRINCIPAL CASA NRO 8 URB SANTA EDUVIGES EL MACARO TURMERO ARAGUA ZONA POSTAL 115",
      "client_identification": "V7998033",
      "nap_box_name": "CE - 523",
      "created_at": "2024-04-16T11:15:06.885122",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3653,
      "client_name": "YONATHAN ARGENIS BRITO PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Taguapire",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124459090",
      "client_email": "YONATHANVZLA2004@GMAIL.COM",
      "address": "URB. TAGUAIPIRE CALLE 3 CASA 69 EL MACARO",
      "client_identification": "V18610018",
      "nap_box_name": "CTO-00386",
      "created_at": "2024-04-16T11:16:53.243522",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3654,
      "client_name": "LUIS ENRIQUE HIDALGO GOMEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04243142000",
      "client_email": "LEHGMAL@GMAIL.COM",
      "address": "CALLLE 7B CASA NRO 44 URB PANTIN ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V12609920",
      "nap_box_name": "CTO-00140",
      "created_at": "2024-04-16T11:21:59.030106",
      "service_detail": {
        "id": 6010,
        "ip": "172.26.136.2",
        "mac": "HWTCC195969C",
        "serial": "HWTCC195969C",
        "queue": "Plan_161901_30183_WispHub",
        "interface": "VLAN229_PANTIN",
        "created_at": "2024-08-22T09:04:04.356381",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3655,
      "client_name": "ANA ALICIA DURAN PAZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04141462265",
      "client_email": "ANADURAN4557@GMAIL.COM",
      "address": "CALLE 5 CASA NRO 354 URB MATACABALLO",
      "client_identification": "V12144557",
      "nap_box_name": "CTO-00179",
      "created_at": "2024-04-16T11:23:13.299141",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3656,
      "client_name": "MIKE NELSON MUINO MENDOZA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04162922146",
      "client_email": "MIKEMUINOPOLIARAGUA@GMAIL.COM",
      "address": "CALLE 09 CASA NRO 03 SECTOR RIO SECO ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V6226357",
      "nap_box_name": "CTO-0610",
      "created_at": "2024-04-16T11:24:15.095912",
      "service_detail": {
        "id": 3161,
        "ip": "172.26.241.2",
        "mac": "HWTC46886C9B",
        "serial": "HWTC46886C9B",
        "queue": "Plan_161905_30183_WispHub",
        "interface": "VLAN251_RIO_SECO",
        "created_at": "2024-06-27T14:15:02.489214",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3657,
      "client_name": "JAVIER ENRRIQUE MENDOZA FERNANDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Valle del Rosario",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04124007647",
      "client_email": "JAVIMEN19@HOTMAIL.COM",
      "address": "CALLE CASANOVA GODOY CASA NRO 5 VALLE DEL ROSARIO",
      "client_identification": "V15497883",
      "nap_box_name": "299",
      "created_at": "2024-04-16T11:25:22.675401",
      "service_detail": {
        "id": 3756,
        "ip": "172.20.224.2",
        "mac": "TPLGB954F790",
        "serial": "TPLGB954F790",
        "queue": "Plan_127996_1574_WispHub",
        "interface": "VLAN100_OLTs",
        "created_at": "2024-07-12T17:20:21.030425",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3658,
      "client_name": "LILIBETH NAZARET PADRINO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Durpa",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04127768678",
      "client_email": "CEFFJB@GMAIL.COM",
      "address": "CALLE MANZANA 16 CASA NRO 7 SECTOR ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V15818054",
      "nap_box_name": "377",
      "created_at": "2024-04-16T11:26:49.494683",
      "service_detail": {
        "id": 5385,
        "ip": "172.26.180.2",
        "mac": "HWTC46670F9B",
        "serial": "HWTC46670F9B",
        "queue": "Plan_161903_30183_WispHub",
        "interface": "VLAN240_DURPA",
        "created_at": "2024-08-16T13:40:53.640196",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3659,
      "client_name": "CARLOS ENRIQUE NIEVES OSTOS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Arturo Luis Berti",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124820295",
      "client_email": "NIEVESCARLOS030@GMAIL.COM",
      "address": "CALLE 1 CASA NRO 359 URB ARTURO LUIS BERTI EL MACARO",
      "client_identification": "V3848330",
      "nap_box_name": "29",
      "created_at": "2024-04-16T11:28:13.620532",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3660,
      "client_name": "OSMALY JOSEFINA FIGUEROA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04163464400",
      "client_email": "LIKEDAVID830@GMAIL.COM",
      "address": "VDA II MANZANA C-11 CASA NRO 8 SAMAN TARAZONERO II TURMERO",
      "client_identification": "V9873265",
      "nap_box_name": "64",
      "created_at": "2024-04-16T11:30:30.280594",
      "service_detail": {
        "id": 5387,
        "ip": "172.20.226.2",
        "mac": "TPLGB954FCF8",
        "serial": "TPLGB954FCF8",
        "queue": "Plan_137413_1574_WispHub",
        "interface": "VLAN100_OLTs",
        "created_at": "2024-08-16T14:23:04.477192",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3661,
      "client_name": "MOISES ALEJANDRO CORDERO GARCIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados III",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128867197",
      "client_email": "MOICORGARCIA@GMAIL.COM",
      "address": "AV PRINCIPAL CASA NRO 6 BARRIO PRADO III ROSARIO DE PAYA",
      "client_identification": "V30972109",
      "nap_box_name": "579 DOS",
      "created_at": "2024-04-16T11:34:23.086824",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3662,
      "client_name": "NURXY DAMELY RODRIGUEZ OROPEZA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243045606",
      "client_email": "SIMONNR03@GMAIL.COM",
      "address": "CALLE 17-B CASA NRO 49 SECTOR PANTIN ROSARIO DE PAYA",
      "client_identification": "V10615394",
      "nap_box_name": "CTO-00048",
      "created_at": "2024-04-16T11:36:18.219378",
      "service_detail": {
        "id": 5392,
        "ip": "172.24.48.2",
        "mac": "VSOL0013CCA1",
        "serial": "VSOL0013CCA1",
        "queue": "queue1",
        "interface": "VLAN229_PANTIN",
        "created_at": "2024-08-16T14:44:54.017813",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3663,
      "client_name": "GERIANNY YAMILETH PEREZ OLMOS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243174797",
      "client_email": "PEREZGERIANNY51@GMAIL.COM",
      "address": "CALLE 6 CASA NRO 9 SECTOR PRADOS 1 ROSARIO DE PAYA",
      "client_identification": "V25527943",
      "nap_box_name": "CTO-00298",
      "created_at": "2024-04-16T11:38:37.904549",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3664,
      "client_name": "ANIRETH DEL VALLE GONZALEZ JIMENEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144430589",
      "client_email": "ANIRETH21@GMAIL.COM",
      "address": "CALLE MANZANA E-11 CASA NRO 19 SECTOR SAMAN TARAZONERO II",
      "client_identification": "V14671616",
      "nap_box_name": "277",
      "created_at": "2024-04-16T11:42:22.805743",
      "service_detail": {
        "id": 3588,
        "ip": "172.17.174.2",
        "mac": "VSOL00124221",
        "serial": "VSOL00124221",
        "queue": "Plan_137413_1574_WispHub",
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2024-07-09T16:30:09.494715",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3665,
      "client_name": "VIRGINIA MARISOL SANCHEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero I",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04243277724",
      "client_email": "MS8756923@GMAIL.COM",
      "address": "CALLE 10 CASA NRO 43 URB SAMAN TARAZONERO I EL MACARO",
      "client_identification": "V9679031",
      "nap_box_name": "671",
      "created_at": "2024-04-16T11:44:37.379922",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3666,
      "client_name": "VICTOR MANUEL RODRIGUEZ LINARES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 43,
        "name": "RECURRENTE RESIDENCIAL PLAN 650M",
        "cost": "46.00",
        "code": "FOR650M",
        "profile": "650M/650M"
      },
      "client_mobile": "04125256928",
      "client_email": "VICOSY.53BG@GMAIL.COM",
      "address": "RIO SECO PAYA CALLE 5 CASA N 33 CODIGO POSTAL 2115",
      "client_identification": "V9436537",
      "nap_box_name": "611",
      "created_at": "2024-04-16T11:47:16.070624",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3667,
      "client_name": "GABRIEL EDUARDO GUERRERO NOVOA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04129845624",
      "client_email": "GENESSYSIVIRA2@GMAIL.COM",
      "address": "CALLE 17 CASA 26 SECTOR RIO SECO ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V17275225",
      "nap_box_name": "CTO-0606",
      "created_at": "2024-04-16T11:51:41.142794",
      "service_detail": {
        "id": 6369,
        "ip": "172.26.114.2",
        "mac": "HWTCD68D689C",
        "serial": "HWTCD68D689C",
        "queue": "Plan_107915_30181_WispHub",
        "interface": "VLAN251_RIO_SECO",
        "created_at": "2024-08-26T17:19:29.747982",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3669,
      "client_name": "MARIANDRY ADRIANA PINA GONZALEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243012751",
      "client_email": "MARIANDRY1991@GMAIL.COM",
      "address": "AV2 CASA NRO 523 B SECTOR MATA CABALLO  TURMERO",
      "client_identification": "V20107587",
      "nap_box_name": "CTO-00222",
      "created_at": "2024-04-16T11:54:09.291912",
      "service_detail": {
        "id": 6462,
        "ip": "172.21.184.2",
        "mac": "TPLGF4EFBCBE",
        "serial": "TPLGF4EFBCBE",
        "queue": "Plan_161872_30181_WispHub",
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2024-08-29T10:24:19.141833",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3670,
      "client_name": "JOSEFINA ESPERANZA ROMERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Durpa",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04145881700",
      "client_email": "ESPERANZAROMERO65@GMAIL.COM",
      "address": "CALLE LIBERTAD CASA NRO 16 SECTOR DESARROLLO URBANISTICO ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V7244238",
      "nap_box_name": "258",
      "created_at": "2024-04-16T11:56:22.348637",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3671,
      "client_name": "VERONICA DE JESUS SANCHEZ RAMIREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Simon Bolivar",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128496508",
      "client_email": "ELARQUITECTO.EEZ@GMAIL.COM",
      "address": "URB SIMON BOLIVAR CALLE 06 CASA NRO 45 ARAGUA ZONA POSTAL 2115",
      "client_identification": "V30971909",
      "nap_box_name": "CTO-00023",
      "created_at": "2024-04-16T11:58:52.747155",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3672,
      "client_name": "MARIA VIDALINA PERDOMO GUTIERREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vista Hermosa",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243110609",
      "client_email": "SANDOVALWILLA77@GMAIL.COM",
      "address": "VIA LOS PRADOS DE PAYA SECTOR VISTA HERMOSA CASA NRO 84 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V10757172",
      "nap_box_name": "CTO-00059",
      "created_at": "2024-04-16T12:00:56.386201",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3673,
      "client_name": "ANA YSABEL GOYO PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero I",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04123240529",
      "client_email": "anagoyo819@gmail.com",
      "address": "CALLE 3 CASA NRO 48 SECTOR SAMAN TARAZONERO I TURMERO",
      "client_identification": "V11090099",
      "nap_box_name": "32",
      "created_at": "2024-04-16T13:11:52.905225",
      "service_detail": {
        "id": 6660,
        "ip": "172.19.218.2",
        "mac": "TPLGB954F94A",
        "serial": "TPLGB954F94A",
        "queue": "Plan_138775_1574_WispHub",
        "interface": "VLAN100_OLTs",
        "created_at": "2024-09-17T16:15:32.783221",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3675,
      "client_name": "MARIOXY CAROLINA ABARCA GUEDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Paya Abajo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04120438483",
      "client_email": "GUEDEZCAROLINA279@GMAIL.COM",
      "address": "BRISAS DE PAYA CALLE 3 CASA NUMERO 02 ROSARIO DE PAYA ARAGUA 2115",
      "client_identification": "V19948976",
      "nap_box_name": "366",
      "created_at": "2024-04-16T13:29:13.958879",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3676,
      "client_name": "DENITZE KARIN VILLEGAS GUTIERREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Paya Abajo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128482835",
      "client_email": "VILLEGASDENITZE745@GMAIL.COM",
      "address": "AV PRINCIPAL PAYA ABAJO CASA 25-1 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V17954852",
      "nap_box_name": "406",
      "created_at": "2024-04-16T13:29:51.696672",
      "service_detail": {
        "id": 7464,
        "ip": "172.27.47.2",
        "mac": "HWTC9079419B",
        "serial": "HWTC9079419B",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN231_PAYABAJO",
        "created_at": "2024-12-17T10:10:14.967753",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3677,
      "client_name": "JOHANA CAROLINA GUTIERREZ ROJAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Concepcion",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243423707",
      "client_email": "GUTIERREZJOHANA249@GMAIL.COM",
      "address": "LA CONCEPCIÓN CALLE PRINCIPAL CASA NRO 55 SECTOR LA JULIA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V19530257",
      "nap_box_name": "503",
      "created_at": "2024-04-16T13:33:02.625601",
      "service_detail": {
        "id": 9277,
        "ip": "172.27.128.2",
        "mac": "HWTC46B1239B",
        "serial": "HWTC46B1239B",
        "queue": "queue1",
        "interface": "VLAN111_CONCEPCION",
        "created_at": "2025-07-31T09:18:29.098791",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3678,
      "client_name": "AXEL RAMON CONTRERAZ PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero I",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04128952700",
      "client_email": "AXELCONTRERAZ22@GMAIL.COM",
      "address": "CALLE 1 CASA NRO 26 SECTOR SAMAN TARAZONERO I TURMERO",
      "client_identification": "V19724450",
      "nap_box_name": "669",
      "created_at": "2024-04-16T13:33:37.954275",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3679,
      "client_name": "RAINER JOAN DIAZ CAPOTE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Las Rurales",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121491357",
      "client_email": "RAINERCAPOTE116@GMAIL.COM",
      "address": "CALLE 107 CASA NUMERO 77 SECTOR LAS RURALES ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V26320739",
      "nap_box_name": "492",
      "created_at": "2024-04-16T13:35:43.191727",
      "service_detail": {
        "id": 6101,
        "ip": "172.26.119.2",
        "mac": "HWTC4677C59B",
        "serial": "HWTC4677C59B",
        "queue": "Plan_161905_30183_WispHub",
        "interface": "VLAN252_RURALES_PAYA",
        "created_at": "2024-08-22T15:03:11.818461",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3680,
      "client_name": "JOSE RAFAEL ALVAREZ GUILLEN",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero I",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04243590595",
      "client_email": "JOSERAFAELMEVEN@GMAIL.COM",
      "address": "CALLE 1 CASA NRO 39 SECTOR SAMAN TARAZONERO I TURMERO",
      "client_identification": "V21336232",
      "nap_box_name": "669",
      "created_at": "2024-04-16T13:36:55.931393",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3681,
      "client_name": "YANETH EVELIN GONZALEZ MEDINA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04127991704",
      "client_email": "YANETHGONZALEZ23790@GMAIL.COM",
      "address": "VDA 3 MANZANA H CASA NRO 5 URB SAMAN TARAZONERO II TURMERO",
      "client_identification": "V18163463",
      "nap_box_name": "185",
      "created_at": "2024-04-16T13:39:34.746829",
      "service_detail": {
        "id": 5953,
        "ip": "172.24.23.2",
        "mac": "TPLGF4EFC30C",
        "serial": "TPLGF4EFC30C",
        "queue": "Plan_138775_1574_WispHub",
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2024-08-21T14:00:05.219215",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3682,
      "client_name": "MARY ANYI BETANCOURT RUIZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Paya Abajo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04125987696",
      "client_email": "BETANCOURTMARY266@GMAIL.COM",
      "address": "CALLE CAMPO ELIAS CASA #10-1 SECTOR PAYA ABAJO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V31081097",
      "nap_box_name": "CTO-0252",
      "created_at": "2024-04-16T13:39:44.232313",
      "service_detail": {
        "id": 7465,
        "ip": "172.27.116.2",
        "mac": "TPLGBA687841",
        "serial": "TPLGBA687841",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN231_PAYABAJO",
        "created_at": "2024-12-17T10:13:35.577082",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3683,
      "client_name": "SOR YASMIN NATERA OLMEDO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Jabillar",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04144623517",
      "client_email": "SORNATERA@HOTMAIL.COM",
      "address": "CRTA NACIONAL TURMERO CASA SAN JUDAS NRO 13 JABILLAR TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V12139489",
      "nap_box_name": "CTO-00005",
      "created_at": "2024-04-16T13:43:27.871594",
      "service_detail": {
        "id": 10783,
        "ip": "172.28.78.2",
        "mac": "ZICGCD86AA5D",
        "serial": "ZICGCD86AA5D",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2025-12-17T16:39:12.083131",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3684,
      "client_name": "YARITZA DEL VALLE GUEVARA HERRERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243361564",
      "client_email": "YARITZAGUEVARA32@GMAIL.COM",
      "address": "CALLE PPL MANZANA C-1 CASA NRO 04 URB SAMAN TARAZONERO II TURMERO ARAGUA ZONA POSTAL",
      "client_identification": "V14527943",
      "nap_box_name": "502",
      "created_at": "2024-04-16T13:44:35.999419",
      "service_detail": {
        "id": 5811,
        "ip": "172.27.101.2",
        "mac": "HWTCD62C7F9C",
        "serial": "HWTCD62C7F9C",
        "queue": "Plan_137413_1574_WispHub",
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2024-08-20T09:30:34.547345",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3685,
      "client_name": "MONICA MICAELA PEREZ PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04242755991",
      "client_email": "MICAELA.SUYIN31@GMAIL.COM",
      "address": "CALLE 15 B CASA NRO 40 SECTOR PANTIN ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V12336586",
      "nap_box_name": "CTO-00311",
      "created_at": "2024-04-16T13:45:57.045526",
      "service_detail": {
        "id": 5725,
        "ip": "172.28.18.2",
        "mac": "TPLGB86284CC",
        "serial": "TPLGB86284CC",
        "queue": "Plan_161905_30183_WispHub",
        "interface": "VLAN229_PANTIN",
        "created_at": "2024-08-19T11:45:23.241176",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3686,
      "client_name": "MARIA NEYDA MARTINEZ DE RICO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Las Rurales",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121370513",
      "client_email": "ARANZHA2014@GMAIL.COM",
      "address": "CALLE 107 MANZANA D CASA 83 SECTOR LAS RURALES ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V13906277",
      "nap_box_name": "492",
      "created_at": "2024-04-16T13:49:41.788881",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3687,
      "client_name": "ANAIS ALFONZO APONTE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Palma Real",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04125976400",
      "client_email": "ANAISALFONZO65@GMAIL.COM",
      "address": "CALLE MIRANDA CASA NRO 124 PARCELAMIENTO NRO 6 SECTOR PALMA REAL TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V20267097",
      "nap_box_name": "CTO-00209",
      "created_at": "2024-04-16T14:03:24.745443",
      "service_detail": {
        "id": 2999,
        "ip": "172.27.210.2",
        "mac": "TPLGF9CD47D1",
        "serial": "TPLGF9CD47D1",
        "queue": "Plan_161870_30183_WispHub",
        "interface": "VLAN244_PALMAREAL",
        "created_at": "2024-06-21T14:48:14.106504",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3689,
      "client_name": "MORAIMA DEL CARMEN ALBORNOZ DAVILA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Macarena",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128966279",
      "client_email": "ALBORNOZMORAIMA.2309@GMAIL.COM",
      "address": "CALLE 6 CASA NRO 12 URB LA MACARENA II SECTOR EL MACARO TURMERO EDO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V7141111",
      "nap_box_name": "246",
      "created_at": "2024-04-16T14:17:45.817713",
      "service_detail": {
        "id": 5957,
        "ip": "172.21.227.2",
        "mac": "TPLGB68B4E39",
        "serial": "TPLGB68B4E39",
        "queue": "Plan_137413_1574_WispHub",
        "interface": "VLAN100_OLTs",
        "created_at": "2024-08-21T14:21:44.697727",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3690,
      "client_name": "GLORIA MERCEDES BUYON BRAVO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128909274",
      "client_email": "OSMELBUYON@GMAIL.COM",
      "address": "CALLE 3 MANZANA J-1 CASA NRO 25 SECTOR SAMAN TARAZONERO II TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V8566078",
      "nap_box_name": "119",
      "created_at": "2024-04-16T14:20:12.345554",
      "service_detail": {
        "id": 6370,
        "ip": "172.26.83.2",
        "mac": "HWTC90A18E9B",
        "serial": "HWTC90A18E9B",
        "queue": "Plan_137413_1574_WispHub",
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2024-08-26T17:21:51.938388",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3691,
      "client_name": "JENNY ALEJANDRA PRATO COLMENARES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Valle del Rosario",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144545946",
      "client_email": "JENNYPRATO3086@GMAIL.COM",
      "address": "CALLE LIBERTADOR CASA NRO URB VALLE ROSARIO EL MACARO",
      "client_identification": "V18068707",
      "nap_box_name": "91",
      "created_at": "2024-04-16T14:22:22.121546",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3692,
      "client_name": "ALEX SSCCOTHSS PEREZ ARIAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Esperanza",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243200785",
      "client_email": "SSCCOTHSSP@GMAIL.COM",
      "address": "CALLE 19 CASA NRO 5 URB LA ESPERANZA EL MACARO",
      "client_identification": "V19790189",
      "nap_box_name": "555",
      "created_at": "2024-04-16T14:28:01.289725",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3693,
      "client_name": "MARIA VALENTINA MENDOZA ANDRADE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243156863",
      "client_email": "ARYMENDOZA6948@GMAIL.COM",
      "address": "CALLE URDANETA CASA NRO 22 URB LOS NISPEROS TURMERO EDO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V18601578",
      "nap_box_name": "CTO-00246",
      "created_at": "2024-04-16T14:29:57.349015",
      "service_detail": {
        "id": 4070,
        "ip": "172.27.121.2",
        "mac": "HWTC907B989B",
        "serial": "HWTC907B989B",
        "queue": "Plan_92194_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-07-20T14:59:21.935108",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3694,
      "client_name": "ARACELYS DEL CARMEN VARGAS DE MEJIAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Jabillar",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04163420791",
      "client_email": "ara190456@gmail.com",
      "address": "CALLE SAUCE CASA NRO 10-08 URB JABILLAR TOWN COUNTRY TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V4364357",
      "nap_box_name": "CTO-00007",
      "created_at": "2024-04-16T14:45:02.158663",
      "service_detail": {
        "id": 11106,
        "ip": "172.26.99.2",
        "mac": "HWTC469C269B",
        "serial": "HWTC469C269B",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2026-01-12T10:25:37.365760",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3695,
      "client_name": "ANGEL DAMIAN LANDAETA NARVAEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero I",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04142009522",
      "client_email": "ALANDAETA8@GMAIL.COM",
      "address": "CALLE 9 CASA NRO 5 URB SAMAN TARAZONERO I TURMERO",
      "client_identification": "V16663171",
      "nap_box_name": "CTO-0672",
      "created_at": "2024-04-16T14:47:03.979829",
      "service_detail": {
        "id": 3398,
        "ip": "172.21.213.2",
        "mac": "TPLGB68B583C",
        "serial": "TPLGB68B583C",
        "queue": "Plan_127983_1574_WispHub",
        "interface": "VLAN100_OLTs",
        "created_at": "2024-07-03T10:02:47.634924",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3696,
      "client_name": "ESTEFANI ALEJANDRA TORREALBA PARRA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243200242",
      "client_email": "ESTEFANYTORREALBA87@GMAIL.COM",
      "address": "CALLE 4 CASA NRO 255 SECTOR MATA CABALLO TURMERO EDO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V31161166",
      "nap_box_name": "CTO-00265",
      "created_at": "2024-04-16T14:49:07.012156",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3697,
      "client_name": "ANA TERESA ARCINIEGAS SALCEDO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Floresta",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04144527043",
      "client_email": "ANAARCINIEGAS16@GMAIL.COM",
      "address": "CALLE NEGRO PRIMERO QTA MI REFUGIO NRO E-10 URB LA FLORESTA TURMERO",
      "client_identification": "V16544600",
      "nap_box_name": "32 DOS",
      "created_at": "2024-04-16T14:49:32.085795",
      "service_detail": {
        "id": 5962,
        "ip": "172.18.221.2",
        "mac": "TPLGB954EB89",
        "serial": "TPLGB954EB89",
        "queue": "Plan_139897_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-08-21T14:30:42.124254",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3698,
      "client_name": "ANZOLY RIMAR RODRIGUEZ ARELLANO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04120981279",
      "client_email": "ANZOLYRODRIGUEZ@GMAIL.COM",
      "address": "CALLE 18B CASA NUMERO 51 URBANIZACION LOS PANTI ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V18487064",
      "nap_box_name": "CTO-00321",
      "created_at": "2024-04-16T14:52:37.943068",
      "service_detail": {
        "id": 5984,
        "ip": "172.27.93.2",
        "mac": "HWTCD1680D9A",
        "serial": "HWTCD1680D9A",
        "queue": "Plan_161895_30183_WispHub",
        "interface": "VLAN229_PANTIN",
        "created_at": "2024-08-21T16:29:08.311124",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3699,
      "client_name": "EYPRILL LISSET NOGUERA NOGUERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Arturo Luis Berti",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243127039",
      "client_email": "EYPRILLNOGUERA@GMAIL.COM",
      "address": "CALLE 01 CASA EL MACARO NRO 374 URB ARTURO LUIS BERTI TURMERO",
      "client_identification": "V18266280",
      "nap_box_name": "29",
      "created_at": "2024-04-16T14:53:23.619583",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3700,
      "client_name": "EMILY ANDREINA ROJAS GONZALEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243171937",
      "client_email": "ROJASEMILY1625@GMAIL.COM",
      "address": "CALLE 4 CASA N 247 SECTOR MATA ACABALLO ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V25880092",
      "nap_box_name": "CTO-00265",
      "created_at": "2024-04-16T14:54:58.054717",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3701,
      "client_name": "OSCAR ENRIQUE GUZMAN LANDAETA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121310449",
      "client_email": "GUZMANOOSCAR29@GMAIL.COM",
      "address": "CTRA NACIONAL EL MACARO  CASA NRO 18 BARRIO SAMAN TARAZONERO I TURMERO",
      "client_identification": "V27048339",
      "nap_box_name": "270",
      "created_at": "2024-04-16T14:57:40.955024",
      "service_detail": {
        "id": 9672,
        "ip": "10.10.13.2",
        "mac": "OEMT3C620DAA",
        "serial": "OEMT3C620DAA",
        "queue": null,
        "interface": "VLAN140_SMT1_ZTE",
        "created_at": "2025-11-03T13:10:31.563135",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3702,
      "client_name": "ERNESTO DAVILA CASTRO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero I",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121486315",
      "client_email": "E_DAVILA_04@HOTMAIL.COM",
      "address": "CALLE 4 CASA NRO 16 SECTOR EL MACARO SAMAN TARAZONERO I",
      "client_identification": "V15865181",
      "nap_box_name": "262",
      "created_at": "2024-04-16T14:59:19.632677",
      "service_detail": {
        "id": 4343,
        "ip": "172.21.162.2",
        "mac": "TPLGB68B5A99",
        "serial": "TPLGB68B5A99",
        "queue": "queue1",
        "interface": "VLAN100_OLTs",
        "created_at": "2024-08-09T13:59:39.323223",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3703,
      "client_name": "ISAMARA DEL CARMEN CASTILLO SALAZAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04124645992",
      "client_email": "ISAMARACASTILLO205@GMAIL.COM",
      "address": "CALLE 9 CASA NRO 597-A DESARROLLO HABITACIONAL MATA CABALLO SECTOR LAS TETRAS TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V20521003",
      "nap_box_name": "160",
      "created_at": "2024-04-16T15:52:05.415331",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3704,
      "client_name": "YAKLY CAROLINA BOLIVAR CHAVEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Arturo Luis Berti",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04120358859",
      "client_email": "YAKLYBO@GMAIL.COM",
      "address": "CALLE 1 CASA NRO 377 URB ARTURO LUIS BERTI TURMERO EDO ARAGUA",
      "client_identification": "V13350792",
      "nap_box_name": "29",
      "created_at": "2024-04-16T15:57:49.639155",
      "service_detail": {
        "id": 5954,
        "ip": "172.17.82.2",
        "mac": "TPLG2ABDC7F6",
        "serial": "TPLG2ABDC7F6",
        "queue": "Plan_137413_1574_WispHub",
        "interface": "VLAN102_ARTURO_BERTI",
        "created_at": "2024-08-21T14:03:04.044269",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3705,
      "client_name": "DANIEL ADOLFO MORILLO APONTE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04247263673",
      "client_email": "HERMANONEGRO@GMAIL.COM",
      "address": "CALLE 20 QTA NRO 28 URB HACIENDA PANTIN ROSARIO DE PAYA TURMERO EDO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V12864112",
      "nap_box_name": "CTO-00435",
      "created_at": "2024-04-16T15:58:03.383015",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3706,
      "client_name": "ANYELI ANAIS PONCE MONTILLA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128903824",
      "client_email": "anyelyanais3@gmail.com",
      "address": "CALLE 5 CASA 24 SECTOR RIO SECO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V26140395",
      "nap_box_name": "472",
      "created_at": "2024-04-16T16:00:47.290517",
      "service_detail": {
        "id": 6300,
        "ip": "172.27.91.2",
        "mac": "HWTC54A9F0A3",
        "serial": "HWTC54A9F0A3",
        "queue": "queue1",
        "interface": "VLAN251_RIO_SECO",
        "created_at": "2024-08-23T17:22:18.198831",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3707,
      "client_name": "TULIO ENRIQUE GONZALEZ TORREALBA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villa De San Jose",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128905743",
      "client_email": "TULIOENRIQUE79@GMAIL.COM",
      "address": "CALLE PRINCIPAL MANZANA 1 CASA NRO 16 URB VILLAS SAN JOSE",
      "client_identification": "V14430705",
      "nap_box_name": "396",
      "created_at": "2024-04-16T16:03:20.123708",
      "service_detail": {
        "id": 5952,
        "ip": "172.27.96.2",
        "mac": "HWTC90B2D49B",
        "serial": "HWTC90B2D49B",
        "queue": "Plan_137413_1574_WispHub",
        "interface": "VLAN134_VILLAS_DSJ_OLT_ZTE",
        "created_at": "2024-08-21T13:59:21.408690",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3708,
      "client_name": "AMALICIA MELLADO HERNANDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Arturo Luis Berti",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04142977242",
      "client_email": "AMALICIAMELLADO1@GMAIL.COM",
      "address": "CALLE 01 CASA 380 URB ARTURO LUIS BERTI SECTOR EL MACARO TURMERO ARAGUA",
      "client_identification": "V8583049",
      "nap_box_name": "29",
      "created_at": "2024-04-16T16:05:19.355533",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3709,
      "client_name": "LISBETH CAROLINA NEIRA LOBO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144863388",
      "client_email": "NEIRACAROLINA93@GMAIL.COM",
      "address": "CALLE 4-A CASA NRO 24 URB PANTI ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V20818648",
      "nap_box_name": "CTO-00076 DOS",
      "created_at": "2024-04-16T16:05:41.928726",
      "service_detail": {
        "id": 3262,
        "ip": "172.27.109.2",
        "mac": "HWTCD13FCB9A",
        "serial": "HWTCD13FCB9A",
        "queue": "Plan_161905_30183_WispHub",
        "interface": "VLAN229_PANTIN",
        "created_at": "2024-07-01T08:38:04.665085",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3710,
      "client_name": "VICENTA MARITZA MORA ZAMBRANO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243401736",
      "client_email": "AILINRIOS19@GMAIL.COM",
      "address": "CALLE 27 CASA NRO 55 SECTOR RIO SECO ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V6252217",
      "nap_box_name": "CTO-00432 DOS",
      "created_at": "2024-04-16T16:08:39.438964",
      "service_detail": {
        "id": 6297,
        "ip": "172.26.88.2",
        "mac": "HWTC46B98C9B",
        "serial": "HWTC46B98C9B",
        "queue": "Plan_161895_30183_WispHub",
        "interface": "VLAN251_RIO_SECO",
        "created_at": "2024-08-23T17:17:07.505728",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3711,
      "client_name": "DILIBERT JOSEFINA LOBO MARTINEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Valle del Rosario",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04129111684",
      "client_email": "JOSMARTI231169@GMAIL.COM",
      "address": "URB VALLE DEL ROSARIO CALLE CASANOVA GODOY CASA NRO 1 EL MACARO",
      "client_identification": "V10379421",
      "nap_box_name": "299",
      "created_at": "2024-04-16T16:15:29.135991",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3712,
      "client_name": "MARIA TERESITA PEREZ PALMA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "SUSPENDIDO_RESIDENCIAL",
      "status_name": "Suspendido",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villa Caribe",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243406945",
      "client_email": "TERE25PP@GMAIL.COM",
      "address": "CALLE GRADISCCO NRO 37 URB VILLA CARIBE SECTOR SAN PABLO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V9432924",
      "nap_box_name": "57",
      "created_at": "2024-04-16T16:17:05.659123",
      "service_detail": {
        "id": 2995,
        "ip": "172.27.127.2",
        "mac": "HWTCD15F169A",
        "serial": "HWTCD15F169A",
        "queue": "Plan_153953_15811_WispHub",
        "interface": "VLAN228_V_CARIBE_OLT1",
        "created_at": "2024-06-21T14:41:50.345821",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3713,
      "client_name": "WILLOY JOSE BLANCO APONTE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04123985694",
      "client_email": "LEONELBLANCOHK27@GMAIL.COM",
      "address": "CALLE 19 CASA NO 42 SECTOR RIO SECO ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V25066539",
      "nap_box_name": "CTO-00018",
      "created_at": "2024-04-16T16:28:42.093328",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3714,
      "client_name": "OSCAR MACHADO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Valle del Rosario",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124764915",
      "client_email": "LUGOJOSEFINA60@GMAIL.COM",
      "address": "CALLE 2 EDIF 6 PISO PB APTO 52 URB TAGUAPIRE SECTOR MACARO TURMERO",
      "client_identification": "V5270401",
      "nap_box_name": "299",
      "created_at": "2024-04-17T08:12:06.553179",
      "service_detail": {
        "id": 10461,
        "ip": "172.20.99.2",
        "mac": "TPLGB954F65D",
        "serial": "TPLGB954F65D",
        "queue": null,
        "interface": "VLAN129_TAGUAPIRE_ZTE",
        "created_at": "2025-12-02T12:02:30.673787",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3715,
      "client_name": "NINO LIBNIG CARRILLO RAMOS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Arturo Luis Berti",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144878154",
      "client_email": "NINOLIBNIG@GMAIL.COM",
      "address": "CALLE TERCERA CASA NRO 404 URB ARTURO LUIS BERTI TURMERO ARAGUA",
      "client_identification": "V15737261",
      "nap_box_name": "65",
      "created_at": "2024-04-17T08:27:43.580160",
      "service_detail": {
        "id": 5945,
        "ip": "172.17.78.2",
        "mac": "TPLGB76566A3",
        "serial": "TPLGB76566A3",
        "queue": "Plan_137413_1574_WispHub",
        "interface": "VLAN102_ARTURO_BERTI",
        "created_at": "2024-08-21T13:47:09.502014",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3716,
      "client_name": "PAULO CESAR ESPEJO SANCHEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Valle del Rosario",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04143450522",
      "client_email": "PAULOESPEJO1@GMAIL.COM",
      "address": "CALLE MARIÑO CASA NRO 11 URB VALLE DEL ROSARIO TURMERO ARAGUA",
      "client_identification": "V14060928",
      "nap_box_name": "30",
      "created_at": "2024-04-17T08:30:01.022804",
      "service_detail": {
        "id": 3313,
        "ip": "172.21.13.2",
        "mac": "TPLGB777B3C4",
        "serial": "TPLGB777B3C4",
        "queue": "Plan_157310_1574_WispHub",
        "interface": "VLAN132_VALLE_ROSARIO",
        "created_at": "2024-07-02T07:58:42.509947",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3717,
      "client_name": "OSCAR JOSE PINANGO CORRALES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144598270",
      "client_email": "OSCARCATIRE06@GMAIL.COM",
      "address": "CALLE 9 CASA NRO 31 SECTOR SAMAN TARAZONERO I TURMERO ARAGUA",
      "client_identification": "V21269229",
      "nap_box_name": "671",
      "created_at": "2024-04-17T08:35:29.726052",
      "service_detail": {
        "id": 5941,
        "ip": "172.19.153.2",
        "mac": "TPLGB954F6EF",
        "serial": "TPLGB954F6EF",
        "queue": "Plan_157310_1574_WispHub",
        "interface": "VLAN100_OLTs",
        "created_at": "2024-08-21T13:42:48.586968",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3718,
      "client_name": "MARIA DE LOS ANGELES MEDINA OLLARVES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Canaima",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04145898636",
      "client_email": "MORILLOALEXA000@GMAIL.COM",
      "address": "CANAIMA CALLE 3 CASA 11 ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V32217255",
      "nap_box_name": "355",
      "created_at": "2024-04-17T08:41:35.411092",
      "service_detail": {
        "id": 5939,
        "ip": "172.26.9.2",
        "mac": "VSOL00D0EC4F",
        "serial": "VSOL00D0EC4F",
        "queue": "Plan_161903_30183_WispHub",
        "interface": "VLAN237_CANAIMA",
        "created_at": "2024-08-21T13:39:48.993370",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3719,
      "client_name": "GREGORY EZEQUIEL SALGADO CAMEJO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Paya Abajo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243204154",
      "client_email": "ELGRANTATY@GMAIL.COM",
      "address": "CALLE CENTRO CASA NRO 8 SECTOR PAYA ABAJO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V17577623",
      "nap_box_name": "CTO-00319",
      "created_at": "2024-04-17T08:47:20.551561",
      "service_detail": {
        "id": 7466,
        "ip": "172.27.114.2",
        "mac": "HWTCD149D99A",
        "serial": "HWTCD149D99A",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN231_PAYABAJO",
        "created_at": "2024-12-17T10:18:53.592521",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3720,
      "client_name": "EHIMAR BETANIA SERGI GONZALEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados I",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04128906488",
      "client_email": "EHISERGI31@GMAIL.COM",
      "address": "CALLE 13 CASA NRO 11 SECTOR PRADOS DE PAYA ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V29659148",
      "nap_box_name": "CTO-0370",
      "created_at": "2024-04-17T08:50:39.909263",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3721,
      "client_name": "JENNY COROMOTO PENA MORENO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados III",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124461605",
      "client_email": "JENNY2022.18@GMAIL.COM",
      "address": "ROSARIO DE PAYA PRADOS III CALLLE 3 CASA NRO 03 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V13528222",
      "nap_box_name": "579 DOS",
      "created_at": "2024-04-17T08:51:48.036295",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3722,
      "client_name": "ESTEFANY ALEXANDRA PIRES VIELMA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04125230250",
      "client_email": "ESTEFANYPIRES096@GMAIL.COM",
      "address": "Av principal de Prados casa #29 Rosario de paya",
      "client_identification": "V28431503",
      "nap_box_name": "CTO-00193",
      "created_at": "2024-04-17T08:56:43.365262",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3724,
      "client_name": "JOSE MIGUEL REQUENA CARRILLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243771087",
      "client_email": "GENESIS.GG37@GMAIL.COM",
      "address": "MATA CABALLO CALLE NRO 2 CASA 61 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V25880882",
      "nap_box_name": "CTO-435",
      "created_at": "2024-04-17T09:08:53.162288",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3725,
      "client_name": "GUSMARIN ABIGAIL FRAGOZA LOPEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Terrazas de Paya",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121994004",
      "client_email": "GUSMARILOPEZ9@GMAIL.COM",
      "address": "CALLE PRINCIPAL DE TERRAZAS CASA NRO 02 SECTOR LUZ Y VIDA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V23784039",
      "nap_box_name": "CTO-00163",
      "created_at": "2024-04-17T09:10:09.534422",
      "service_detail": {
        "id": 11490,
        "ip": "172.28.87.2",
        "mac": "ZICGCD90DA04",
        "serial": "ZICGCD90DA04",
        "queue": null,
        "interface": "VLAN243_BICENTENARIO",
        "created_at": "2026-02-05T09:39:02.424336",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3726,
      "client_name": "JAIRO JONATHAN MOLINA DIAZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Magdalena",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144633936",
      "client_email": "JONATHANMOLINA0607@GMAIL.COM",
      "address": "CALLE 15 CASA NRO 15 LA MAGDALENA",
      "client_identification": "V16690419",
      "nap_box_name": "394",
      "created_at": "2024-04-17T09:12:27.114783",
      "service_detail": {
        "id": 9833,
        "ip": "172.30.215.2",
        "mac": "TPLGF4EFC13D",
        "serial": "TPLGF4EFC13D",
        "queue": null,
        "interface": "VLAN114_MAGDALENA",
        "created_at": "2025-11-10T17:32:32.909713",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3727,
      "client_name": "LISAURA CAROLINA DIAZ GOMEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Tibisay Guevara",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243439247",
      "client_email": "LILIANAGOMEZ35@HOTMAIL.COM",
      "address": "CALLE 1 CASA NRO 01 BARRIO TIBISAY GUEVARA",
      "client_identification": "V30428002",
      "nap_box_name": "CTO-00054",
      "created_at": "2024-04-17T09:14:54.180013",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3728,
      "client_name": "RONALDO RAFAEL MANRIQUE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Tibisay Guevara",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243243352",
      "client_email": "RONALTACUPAI@GMAIL.COM",
      "address": "AV PRINCIPAL EL MACARO CASA NRO 02 SECTOR TIBISAY GUEVARA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V25314005",
      "nap_box_name": "CTO-00054",
      "created_at": "2024-04-17T09:16:52.742643",
      "service_detail": {
        "id": 5901,
        "ip": "172.27.78.2",
        "mac": "HWTC909D3D9B",
        "serial": "HWTC909D3D9B",
        "queue": "Plan_147201_15811_WispHub",
        "interface": "VLAN248_TIBISAY_OLT2",
        "created_at": "2024-08-21T11:15:13.080320",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3729,
      "client_name": "LESLY YUDITH MIRANDA DE ANDUEZA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128876512",
      "client_email": "OSHUNFUNKE15@GMAIL.COM",
      "address": "CALLE 6-B CASA NRO 50 URB HACIENDA PANTY ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V6313058",
      "nap_box_name": "CTO-00138",
      "created_at": "2024-04-17T09:17:37.380736",
      "service_detail": {
        "id": 3704,
        "ip": "172.26.35.2",
        "mac": "VSOL00D0F02F",
        "serial": "VSOL00D0F02F",
        "queue": "Plan_161905_30183_WispHub",
        "interface": "VLAN229_PANTIN",
        "created_at": "2024-07-11T21:19:47.137610",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3730,
      "client_name": "JULIA TRINIDAD GARCIA REPILLOSA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Paraiso",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144622685",
      "client_email": "GARCIAJULIA0512@GMAIL.COM",
      "address": "URB EL PARAISO CALLLE LA FE NRO 24 EL MACARO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V9884085",
      "nap_box_name": "346",
      "created_at": "2024-04-17T09:17:56.261356",
      "service_detail": {
        "id": 5896,
        "ip": "172.26.42.2",
        "mac": "HWTC46635E9B",
        "serial": "HWTC46635E9B",
        "queue": "Plan_127744_1574_WispHub",
        "interface": "VLAN105_EL_PARAISO",
        "created_at": "2024-08-21T10:23:15.760018",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3731,
      "client_name": "JHONATTAN ANTONIO UZTARIZ PLANCHEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128878780",
      "client_email": "JHONATTANUZTARIZ@GMAIL.COM",
      "address": "CALLE 1-A CASA NRO 8 SECTOR HACIENDA PANTIN TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V11979377",
      "nap_box_name": "CTO-00128",
      "created_at": "2024-04-17T09:22:59.722016",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3732,
      "client_name": "RAIZA ABIGAIL NIEVES CARUCCI",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243242266",
      "client_email": "RAIZANIEVES15@GMAIL.COM",
      "address": "PRADOS 1 CALLE 13 CASA # 35 ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V22949099",
      "nap_box_name": "CTO-0370",
      "created_at": "2024-04-17T09:24:59.534779",
      "service_detail": {
        "id": 9373,
        "ip": "172.26.29.2",
        "mac": "VSOL00D0F863",
        "serial": "VSOL00D0F863",
        "queue": "queue1",
        "interface": "VLAN230_VISTA_HERMOSA",
        "created_at": "2025-08-16T10:06:13.993986",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3733,
      "client_name": "ANGELICA ANTONIA CEDENO LUNA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243708498",
      "client_email": "BARBARITANGELICA@GMAIL.COM",
      "address": "CALLE 3 CASA NRO 147 URB MATA CABALLO ROSARIO DE PAYA",
      "client_identification": "V8798323",
      "nap_box_name": "CTO-00094",
      "created_at": "2024-04-17T09:27:05.269855",
      "service_detail": {
        "id": 3527,
        "ip": "172.23.18.2",
        "mac": "TPLGBA687C15",
        "serial": "TPLGBA687C15",
        "queue": "queue1",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-07-08T16:43:27.429460",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3734,
      "client_name": "MARIA APOLONIA FLOREZ DE CASTILLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04127768056",
      "client_email": "MARIAPULIDO2323@GMAIL.COM",
      "address": "CALLE 1 CASA NRO 5 SECTOR SAMAN TARAZONERO I TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V24433487",
      "nap_box_name": "444",
      "created_at": "2024-04-17T09:31:00.582082",
      "service_detail": {
        "id": 3316,
        "ip": "172.30.43.2",
        "mac": "VSOL00D0DC03",
        "serial": "VSOL00D0DC03",
        "queue": "Plan_137413_1574_WispHub",
        "interface": "VLAN100_OLTs",
        "created_at": "2024-07-02T08:10:27.025815",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3735,
      "client_name": "EVELIS SUGEIL SANCHEZ DE HENRIQUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Canaima",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124239846",
      "client_email": "EVELIS91011@GMAIL.COM",
      "address": "CALLE 02 CASA NRO 9 SECTOR CANAIMA",
      "client_identification": "V9693011",
      "nap_box_name": "CTO-00107 ",
      "created_at": "2024-04-17T09:33:31.505098",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3736,
      "client_name": "MOISES RAFAEL OROPEZA RONDON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243442715",
      "client_email": "MOISESOROPEZA.13@GMAIL.COM",
      "address": "CALLE 2 CASA NRO 77 URB MATA CABALLO ROSARIO DE PAYA",
      "client_identification": "V30211676",
      "nap_box_name": "455",
      "created_at": "2024-04-17T10:02:22.168421",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3738,
      "client_name": "CLARICIA ALFONZO TOVAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Valle del Rosario",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04127764863",
      "client_email": "alayonguillermo92@gmail.com",
      "address": "CALLE MARIÑO CASA NRO 07 URB VALLE DEL ROSARIO SAMAN DE GUERE TURMERO ARAGUA",
      "client_identification": "V2518920",
      "nap_box_name": "30",
      "created_at": "2024-04-17T10:05:54.446323",
      "service_detail": {
        "id": 5892,
        "ip": "172.30.75.2",
        "mac": "TPLGB76564F8",
        "serial": "TPLGB76564F8",
        "queue": "queue1",
        "interface": "VLAN132_VALLE_ROSARIO",
        "created_at": "2024-08-21T10:17:37.447314",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3741,
      "client_name": "ANGEL DANIEL MORENO HIDALGO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243487233",
      "client_email": "MORENOANGEL1030@GMAIL.COM",
      "address": "CALLE MANZANA C10 CASA NRO 6 SECTOR SAMAN TARAZONERO II TURMERO",
      "client_identification": "V20896116",
      "nap_box_name": "286",
      "created_at": "2024-04-17T10:11:46.498629",
      "service_detail": {
        "id": 5889,
        "ip": "172.23.147.2",
        "mac": "GPON0097B346",
        "serial": "GPON0097B346",
        "queue": "Plan_137413_1574_WispHub",
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2024-08-21T10:12:59.821057",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3742,
      "client_name": "ARACELIS BEJAS YASMIRA SEIJAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243108400",
      "client_email": "SOFIACANO071@GMAIL.COM",
      "address": "CALLE 12 CASA NRO 666 URB MATA CABALLO ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V14342610",
      "nap_box_name": "CTO-00433",
      "created_at": "2024-04-17T10:12:14.026360",
      "service_detail": {
        "id": 10071,
        "ip": "172.25.245.2",
        "mac": "VSOL00D0E2FB",
        "serial": "VSOL00D0E2FB",
        "queue": null,
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2025-11-12T14:03:40.539913",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3743,
      "client_name": "MERCEDES ELENA ARRIOJA QUINTANA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04243372523",
      "client_email": "MERCEDESELENAARRIOJAQUINTANA@GMAIL.COM",
      "address": "CALLE 12 A CASA H21 URB HACIENDA PANTIN TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V8736598",
      "nap_box_name": "CTO-00165",
      "created_at": "2024-04-17T10:13:10.443814",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3745,
      "client_name": "TIBISAY DEL CARMEN ARRIECHE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Naranjal",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243090555",
      "client_email": "ARRIECHETIBISAY9@GMAIL.COM",
      "address": "CALLE 2 CASA NRO 02 SECTOR ANTIGUA HACIENDA EL NARANJAL TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V13685515",
      "nap_box_name": "CTO-00303",
      "created_at": "2024-04-17T10:16:36.026603",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3746,
      "client_name": "JESUS ANTONIO RAMIREZ RUJANO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Valle del Rosario",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243797242",
      "client_email": "JESUSA_00@HOTMAIL.COM",
      "address": "CALLE LIBERTADOR CASA NRO 6 URB CALLE DEL ROSARIO TURMERO",
      "client_identification": "V16435295",
      "nap_box_name": "91",
      "created_at": "2024-04-17T10:16:43.808318",
      "service_detail": {
        "id": 5963,
        "ip": "172.19.182.2",
        "mac": "TPLGB954E902",
        "serial": "TPLGB954E902",
        "queue": "Plan_127996_1574_WispHub",
        "interface": "VLAN100_OLTs",
        "created_at": "2024-08-21T14:44:21.835884",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3747,
      "client_name": "CARMEN  MERCEDES GONZALEZ GONZALEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero I",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121482984",
      "client_email": "EDIXSONSEVILLA911@GMAIL.COM",
      "address": "CALLE 03 CASA NRO 18 URB SAMAN TARAZONERO I TURMERO",
      "client_identification": "V6267651",
      "nap_box_name": "291",
      "created_at": "2024-04-17T10:19:13.686464",
      "service_detail": {
        "id": 3279,
        "ip": "172.23.137.2",
        "mac": "VSOL00980DB6",
        "serial": "VSOL00980DB6",
        "queue": "queue1",
        "interface": "VLAN100_OLTs",
        "created_at": "2024-07-01T11:40:25.769488",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3748,
      "client_name": "ROTCELY YOSMAR ALMEIDA PADILLA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero I",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04128855935",
      "client_email": "ROTCELY8@GMAIL.COM",
      "address": "CALLE 8 CASA NRO 16 SECTOR SAMAN TARAZONERO I TURMERO",
      "client_identification": "V26320659",
      "nap_box_name": "37",
      "created_at": "2024-04-17T10:22:39.567748",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3749,
      "client_name": "JOSE VICENTE LARA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Terrazas de Paya",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121358408",
      "client_email": "carolinaamador953@gmail.com",
      "address": "CALLE PRINCIPAL CASA NRO 201 SECTOR LUZ Y VIDA URB TERRAZAS DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V18909044",
      "nap_box_name": "CTO-00348",
      "created_at": "2024-04-17T10:23:39.975940",
      "service_detail": {
        "id": 11380,
        "ip": "172.26.87.2",
        "mac": "HWTC5471D3A3",
        "serial": "HWTC5471D3A3",
        "queue": null,
        "interface": "VLAN243_BICENTENARIO",
        "created_at": "2026-01-26T09:58:17.334144",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3750,
      "client_name": "BELCI YSABEL PELAEZ CADENAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04122982742",
      "client_email": "BELCIYSABELPELAEZ74@GMAIL.COM",
      "address": "VDA 10 CASA NRO URB SAMAN TARAZONERO I TURMERO",
      "client_identification": "V12854538",
      "nap_box_name": "93",
      "created_at": "2024-04-17T10:24:47.286802",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3751,
      "client_name": "VANESSA ALEJANDRA CASTILLO MARTINEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243755192",
      "client_email": "VACM2806@GMAIL.COM",
      "address": "SECTOR MATA CABALLO C/6 #463 ARAGUA ZONA POSTAL 2115",
      "client_identification": "V16763946",
      "nap_box_name": "CTO-00178",
      "created_at": "2024-04-17T10:25:42.969907",
      "service_detail": {
        "id": 5873,
        "ip": "172.26.25.2",
        "mac": "VSOL00D0DC63",
        "serial": "VSOL00D0DC63",
        "queue": "Plan_161905_30183_WispHub",
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2024-08-20T16:59:24.220815",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3752,
      "client_name": "UBALDA ANGELINE VERA FUENMAYOR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Macaro",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04127458692",
      "client_email": "angelinefuenmayorvera@gmail.com",
      "address": "CALLE ARAGUA CASA NRO 12 URB VALLE DEL ROSARIO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V16507936",
      "nap_box_name": "500",
      "created_at": "2024-04-17T10:25:57.600978",
      "service_detail": {
        "id": 4062,
        "ip": "172.27.69.2",
        "mac": "HWTCD168819A",
        "serial": "HWTCD168819A",
        "queue": "Plan_137413_1574_WispHub",
        "interface": "VLAN132_VALLE_ROSARIO",
        "created_at": "2024-07-20T12:56:26.099837",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3753,
      "client_name": "JOSE ALEJANDRO CARRILLO GARCIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243725195",
      "client_email": "MILHOJASJOSE@GMAIL.COM",
      "address": "CALLE 6 CASA NRO 379 SECTOR MATA CABALLO ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V11093432",
      "nap_box_name": "CTO-00178",
      "created_at": "2024-04-17T10:28:42.694446",
      "service_detail": {
        "id": 8879,
        "ip": "172.26.20.2",
        "mac": "VSOL00D0E7F7",
        "serial": "VSOL00D0E7F7",
        "queue": "queue1",
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2025-06-09T11:12:59.995175",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3754,
      "client_name": "JANETH JUSTINA ANEZ RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero I",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04120380065",
      "client_email": "JANETHANEZ95@GMAIL.COM",
      "address": "CALLE 4 CASA NRO 7 SAMAN TARAZONERO I EL MACARO",
      "client_identification": "V7261190",
      "nap_box_name": "262",
      "created_at": "2024-04-17T10:29:36.495348",
      "service_detail": {
        "id": 5872,
        "ip": "172.23.142.2",
        "mac": "GPON0097C6B6",
        "serial": "GPON0097C6B6",
        "queue": "queue1",
        "interface": "VLAN100_OLTs",
        "created_at": "2024-08-20T16:56:44.903172",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3755,
      "client_name": "ISKEYMAR ALEJANDRA DA SILVA POZZO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121991664",
      "client_email": "YSKEIMARDASILVA@GMAIL.COM",
      "address": "CALLE RIVAS EDIF TIORA PISO 2 APT 1 URB HACIENDA LOS NISPEROS TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V22286582",
      "nap_box_name": "CTO-00296",
      "created_at": "2024-04-17T10:29:37.359854",
      "service_detail": {
        "id": 12092,
        "ip": "172.27.73.2",
        "mac": "HWTCD638E19C",
        "serial": "HWTCD638E19C",
        "queue": null,
        "interface": "VLAN209_ZAMORA_OLT1",
        "created_at": "2026-03-16T11:52:30.474344",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3756,
      "client_name": "JUANA CRISTINA APONTE FALCON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Las Rurales",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04125232580",
      "client_email": "APONTEJUANA575@GMAIL.COM",
      "address": "CALLE SUCRE CASA NRO 9-A SECTOR LAS RURALES DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V9432222",
      "nap_box_name": "614",
      "created_at": "2024-04-17T10:32:30.273675",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3757,
      "client_name": "LUCAS ALEXYS PEREZ BARRIOS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero I",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04262466403",
      "client_email": "PASTORLUCASMACARO@HOTMAIL.COM",
      "address": "CALLE 10 CASA NRO 40 SECTOR SAMAN TARAZONERO 1",
      "client_identification": "V7233947",
      "nap_box_name": "CTO-0036",
      "created_at": "2024-04-17T10:34:44.267709",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3758,
      "client_name": "ANTONI JOSE RODRIGUEZ GONZALEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Durpa",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243157730",
      "client_email": "IRIANAINFANTE2002@GMAIL.COM",
      "address": "CALLE LOS ROBLES CASA NRO 15 SECTOR FUNDA BARRIO ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V26215829",
      "nap_box_name": "CTO-00445",
      "created_at": "2024-04-17T10:35:20.149307",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3760,
      "client_name": "ISRAEL JOSE ROMERO MARTINEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Arboleda",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144764874",
      "client_email": "YESENIAMORALESF@GMAIL.COM",
      "address": "CALLE LOS MANGOS CASA NRO 35 SECTOR LA ARBOLEDA ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V19276881",
      "nap_box_name": "CTO-0485",
      "created_at": "2024-04-17T10:40:36.816760",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3761,
      "client_name": "FRANCIS COROMOTO DIAZ AREVALO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124022465",
      "client_email": "FRANCISDIAZA@GMAIL.COM",
      "address": "CALLE PRINCIPAL EDIF TORRE 27 PISO 1 APT 3 URB LOS NISPEROS TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V11977075",
      "nap_box_name": "CTO-00207 DOS",
      "created_at": "2024-04-17T10:40:46.385545",
      "service_detail": {
        "id": 6399,
        "ip": "172.25.253.2",
        "mac": "VSOL00D0F19F",
        "serial": "VSOL00D0F19F",
        "queue": "Plan_143066_15811_WispHub",
        "interface": "VLAN209_ZAMORA_OLT1",
        "created_at": "2024-08-27T15:16:58.600157",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3762,
      "client_name": "GABRIEL ALEXANDRO MORGADO CARDONA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121484508",
      "client_email": "GABRIELMORGADO727@GMAIL.COM",
      "address": "CALLE 13 CASA NRO 20 URB PANTI ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V30972566",
      "nap_box_name": "CTO-00170",
      "created_at": "2024-04-17T10:44:12.737237",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3763,
      "client_name": "MARIA ASUNCION BERMUDEZ DE RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Brisas de Paya",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243481979",
      "client_email": "MARIAB.130969@GMAIL.COM",
      "address": "CALLE 02 CASA NRO 32 SECTOR BRISAS DE PAYA ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V9659461",
      "nap_box_name": "371",
      "created_at": "2024-04-17T10:46:24.386057",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3764,
      "client_name": "YGNACIO PORFIRIO CORONA PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 43,
        "name": "RECURRENTE RESIDENCIAL PLAN 650M",
        "cost": "46.00",
        "code": "FOR650M",
        "profile": "650M/650M"
      },
      "client_mobile": "04127592811",
      "client_email": "PORFICORONA10@GMAIL.COM",
      "address": "PANTIN CALLE 5A CASA NRO 2 ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V8632868",
      "nap_box_name": "CTO-00135",
      "created_at": "2024-04-17T10:49:05.244485",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3765,
      "client_name": "JESUS ALEJANDRO TRUJILLO MENDOZA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Valle del Rosario",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128868417",
      "client_email": "JATM00@GMAIL.COM",
      "address": "CALLE JOSE CASANOVA GODOY CASA NRO 4 SECTOR VALLE DEL ROSARIO MACARO TURMERO",
      "client_identification": "V17014984",
      "nap_box_name": "299",
      "created_at": "2024-04-17T10:51:34.065058",
      "service_detail": {
        "id": 3751,
        "ip": "172.29.45.2",
        "mac": "TPLGB7656934",
        "serial": "TPLGB7656934",
        "queue": "Plan_138775_1574_WispHub",
        "interface": "VLAN100_OLTs",
        "created_at": "2024-07-12T17:10:51.466651",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3766,
      "client_name": "SARAI ALEJANDRA CACERES LUCENA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Isaac Oliveira",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04140482778",
      "client_email": "SARAIACACERES@GMAIL.COM",
      "address": "CALLE 1 CASA NRO 34 URB ISAAC OLIVEIRA TURMERO",
      "client_identification": "V27863057",
      "nap_box_name": "CTO-00258",
      "created_at": "2024-04-17T10:54:10.842474",
      "service_detail": {
        "id": 11820,
        "ip": "172.23.34.2",
        "mac": "TPLGBA687C4C",
        "serial": "TPLGBA687C4C",
        "queue": null,
        "interface": "VLAN100_OLTs",
        "created_at": "2026-02-27T11:46:33.532503",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3767,
      "client_name": "MARIALYS SHIRLEY GONZALEZ MONTILVA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Durpa",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243496079",
      "client_email": "DARWINTLOMELLI@GMAIL.COM",
      "address": "CALLE LOS ALPES CON INDEPENDENCIA MANZANA 19 CASA NRO 21 SECTOR DESARROLLO URBANISTICO ROSARIO DE PAYA",
      "client_identification": "V21204889",
      "nap_box_name": "390",
      "created_at": "2024-04-17T10:56:35.549783",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3768,
      "client_name": "SUHAIL COROMOTO CRESPO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243661878",
      "client_email": "SUHAILCRESPO4013@GMAIL.COM",
      "address": "CALLE 7A CASA NRO 541 MATA CABALLO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V12339602",
      "nap_box_name": "CTO-00167 DOS",
      "created_at": "2024-04-17T10:58:37.146064",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3769,
      "client_name": "CAROLINA COROMOTO RATTIA DE RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados II",
      "plan": {
        "id": 16,
        "name": "RECURRENTE RESIDENCIAL PLAN 800M",
        "cost": "55.00",
        "code": "FOR800",
        "profile": "800M/800M"
      },
      "client_mobile": "04128728325",
      "client_email": "CAROLINAMADRID046@GMAIL.COM",
      "address": "CALLE 1 CASA NRO 27 SECTOR PRADOS DE PAYA 2 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V12928987",
      "nap_box_name": "CTO-00205",
      "created_at": "2024-04-17T10:58:43.649780",
      "service_detail": {
        "id": 12084,
        "ip": "172.26.56.2",
        "mac": "HWTC4644089B",
        "serial": "HWTC4644089B",
        "queue": null,
        "interface": "VLAN242_PRADOS2",
        "created_at": "2026-03-15T19:13:03.500407",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3770,
      "client_name": "STHEFANY GISSELLE RANGEL UTRERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121388295",
      "client_email": "STHEFANYGRU98@GMAIL.COM",
      "address": "AV PRINCIPAL ROSARIO DE PAYA EDIF #28 APT 04 URB LOS NISPEROS TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V27289438",
      "nap_box_name": "CTO-00207 DOS",
      "created_at": "2024-04-17T11:06:34.165672",
      "service_detail": {
        "id": 6603,
        "ip": "172.28.172.2",
        "mac": "HWTC1A4478A1",
        "serial": "HWTC1A4478A1",
        "queue": "Plan_107915_15811_WispHub",
        "interface": "VLAN209_ZAMORA_OLT1",
        "created_at": "2024-09-11T20:47:16.541855",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3771,
      "client_name": "ISLEIDYS YONAIRA ROCCA HUISI",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona I Edificios",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04125950384",
      "client_email": "ISLEIDYROCCA82@GMAIL.COM",
      "address": "AV. INTERCOMUNAL MARACAY TURMERO LA CASONA I EDF TORRE E PISO 1 APT 2 CONJUNTO RESIDENCIAL LOS JARDINES",
      "client_identification": "V15963339",
      "nap_box_name": "CTO-0532",
      "created_at": "2024-04-17T11:19:48.889270",
      "service_detail": {
        "id": 5001,
        "ip": "172.23.114.2",
        "mac": "VSOL0013E069",
        "serial": "VSOL0013E069",
        "queue": "Plan_131647_24341_WispHub",
        "interface": "VLAN109_CASONA_1",
        "created_at": "2024-08-13T16:51:14.872571",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3772,
      "client_name": "CARLOS RAFAEL GARCIA VIDAO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Palma Real",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144911110",
      "client_email": "MISLESTHAIZ@GMAIL.COM",
      "address": "AV MANZANA 1 CASA 38 SECTOR ROSARIO DE PAYA URB PALMA REAL ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V11051715",
      "nap_box_name": "CTO-00209",
      "created_at": "2024-04-17T11:20:28.859939",
      "service_detail": {
        "id": 9401,
        "ip": "172.26.54.2",
        "mac": "HWTC46169B9B",
        "serial": "HWTC46169B9B",
        "queue": "queue1",
        "interface": "VLAN244_PALMAREAL",
        "created_at": "2025-08-21T09:20:31.616712",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3773,
      "client_name": "ANA LUISA MOTA GONZALEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Bicentenario",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04145872560",
      "client_email": "LUISAMOTA1266@GMAIL.COM",
      "address": "CALLE LOS ROBLES MANZANA 12 CASA PLANTA ALTA NRO 03 SECTOR DESARROLLO URBANISTICO ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V9673113",
      "nap_box_name": "CTO-00445",
      "created_at": "2024-04-17T11:23:40.156247",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3774,
      "client_name": "MARUHANTA SARAI MONTILLA CHIRIVELLA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Callejon Lim",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121482347",
      "client_email": "MARUHANTAMONTILLA881@GMAIL.COM",
      "address": "AV PRINCIPAL CALLEJON LIM EDIF AZUCENA PISO 2 APT 9 URB. VILLAS DE TURMERO ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V23783228",
      "nap_box_name": "TORRE AZUCENA",
      "created_at": "2024-04-17T11:25:37.740098",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3775,
      "client_name": "LUCIA MARITZA GUZMAN DE VELASQUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04140471878",
      "client_email": "LUCIAMARITZA64@GMAIL.COM",
      "address": "CALLE PROLONGACIÓN CARREÑO EDIF CAYCAPE TERRAZA UNO PISO 03 APT 03-06 URB DESARROLLO HABITACIONAL LOS NISPEROS TURMERO",
      "client_identification": "V8575264",
      "nap_box_name": "130",
      "created_at": "2024-04-17T11:28:14.083036",
      "service_detail": {
        "id": 4923,
        "ip": "172.21.148.2",
        "mac": "TPLGB68B5A9E",
        "serial": "TPLGB68B5A9E",
        "queue": "Plan_139897_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-08-13T11:31:39.294948",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3776,
      "client_name": "IGNAIR JOSELIN NIEVES TORREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243220083",
      "client_email": "JOHANELISARISMENDI@GMAIL.COM",
      "address": "CALLE 15 CASA NRO 8 SECTOR PRADOS DE PAYA I ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V20265837",
      "nap_box_name": "590 DOS",
      "created_at": "2024-04-17T11:29:36.754661",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3777,
      "client_name": "ADRIANA CAROLINA GONZALEZ DIAZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Laguna Plaza",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04127410201",
      "client_email": "ROSADIAZ20182019@GMAIL.COM",
      "address": "CALLE NEGRO PRIMERO EDIF 10 PISO PB APT 4 CONJUNTO RESIDENCIAL LAGUNA PLAZA TURMERO",
      "client_identification": "V22942528",
      "nap_box_name": "2",
      "created_at": "2024-04-17T11:33:56.047406",
      "service_detail": {
        "id": 3864,
        "ip": "172.24.148.2",
        "mac": "TPLGF4EFBF6E",
        "serial": "TPLGF4EFBF6E",
        "queue": "Plan_128612_15811_WispHub",
        "interface": "VLAN216_LAGUNA_PLAZA_OLT1",
        "created_at": "2024-07-16T14:44:01.148652",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3778,
      "client_name": "MARIA ALEJANDRA FONSECA RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona II Edificios",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243366590",
      "client_email": "MARISFONSECA135@GMAIL.COM",
      "address": "LA CASONA 2 EDIFICIO N10 APARTAMENTO 5 PISO 3 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V16435412",
      "nap_box_name": "CTO-0537",
      "created_at": "2024-04-17T11:36:34.954566",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3779,
      "client_name": "JORGELIS DEL  CARMEN VILLASMIL ROJAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04123422333",
      "client_email": "JORGELIS_VILLASMIL@HOTMAIL.COM",
      "address": "CALLE 4 NRO 284 MATA CABALLO ROSARIO DE PAYA",
      "client_identification": "V25662285",
      "nap_box_name": "CTO-00180",
      "created_at": "2024-04-17T12:00:23.197659",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3780,
      "client_name": "MELIDA MARGARITA CHIRINO BELLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243590630",
      "client_email": "MELIDACHIRINO75@GMAIL.COM",
      "address": "CALLE PROLONGACION CARREÑO EDIF 6 PISO PB APT 2 CONJUNTO RESIDENCIAL HACIENDA LOS NISPEROS TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V9656312",
      "nap_box_name": "CTO-00032",
      "created_at": "2024-04-17T12:22:01.979169",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3781,
      "client_name": "MIRIAM ELENA REIDTLER DE BASTIDAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona I Edificios",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243590263",
      "client_email": "NORMANJBASTIDAS@GMAIL.COM",
      "address": "AV INTERCOMUNAL TURMERO EDIF G PISO 3 APTO 4 LA CASONA I TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V10756549",
      "nap_box_name": "CTO-0534",
      "created_at": "2024-04-17T12:27:10.616261",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3782,
      "client_name": "ALESKA DEL CARMEN RIVAS MORILLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124311065",
      "client_email": "VALEZKAAD14@GMAIL.COM",
      "address": "CALLE CARREÑO EDIF 9 PISO 1 URB HACIENDA LOS NISPEROS TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V20336056",
      "nap_box_name": "CTO-00387",
      "created_at": "2024-04-17T12:53:03.300399",
      "service_detail": {
        "id": 5853,
        "ip": "172.28.64.2",
        "mac": "ZICGCD90F6D3",
        "serial": "ZICGCD90F6D3",
        "queue": "Plan_147201_15811_WispHub",
        "interface": "VLAN209_ZAMORA_OLT1",
        "created_at": "2024-08-20T15:09:55.159927",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3783,
      "client_name": "GILMAND DANIEL GONZALEZ SILVA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona II Edificios",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124869530",
      "client_email": "GGILMAND@GMAIL.COM",
      "address": "AV INTERCOMUNAL LA CASONA 2 EDIF 8-A APTO 4 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V19791664",
      "nap_box_name": "CTO-0535",
      "created_at": "2024-04-17T12:56:43.400256",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3784,
      "client_name": "NAIRIM LIZZETT CORDERO MARTINEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144491686",
      "client_email": "JNCORDERRAFAEL@GMAIL.COM",
      "address": "CALLE RIVAS EDIF TIORA PISO 1 APT 2 URB LOS NISPEROS TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V17739071",
      "nap_box_name": "CTO-00296",
      "created_at": "2024-04-17T15:40:45.358141",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3785,
      "client_name": "NORKYS ADRIANA OREA PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Paya Abajo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04267271358",
      "client_email": "NOHELITUAREZ@GMAIL.COM",
      "address": "CALLE CAMPO ELIAS CASA NRO PAYA ABAJO ROSARIO DE PAYA ZONA POSTAL 2115",
      "client_identification": "V29556784",
      "nap_box_name": "CTO-0252",
      "created_at": "2024-04-17T15:56:11.133835",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3786,
      "client_name": "YAJAIRA JACQUELINE SANCHEZ RIVAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Terrazas de Juan Pablo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04143922835",
      "client_email": "YAJAIRASANCHEZ6@GMAIL.COM",
      "address": "CALLE LA LLANERA APT B-03 PB URBANIZACION TERRAZAS DE JUAN PABLO TURMERO ARAGUA ZONA POSTAL",
      "client_identification": "V14576795",
      "nap_box_name": "13",
      "created_at": "2024-04-18T10:55:15.182203",
      "service_detail": {
        "id": 11158,
        "ip": "172.26.240.2",
        "mac": "HWTC48220033",
        "serial": "HWTC48220033",
        "queue": null,
        "interface": "VLAN130_TERRAZAS_JP",
        "created_at": "2026-01-15T08:55:14.968710",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3788,
      "client_name": "YRNEH MARIA ESPINOZA HURTADO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona I",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04127762019",
      "client_email": "YRNEHURTADO@GMAIL.COM",
      "address": "CALLE 9 CASA NRO 107 URB LA CASONA I TURMERO ARAGUA",
      "client_identification": "V12210355",
      "nap_box_name": "CE - 393",
      "created_at": "2024-04-18T11:07:32.406685",
      "service_detail": {
        "id": 11785,
        "ip": "172.25.73.2",
        "mac": "TPLGB765693A",
        "serial": "TPLGB765693A",
        "queue": null,
        "interface": "VLAN109_CASONA_1",
        "created_at": "2026-02-27T11:12:40.828765",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3789,
      "client_name": "EVERTH ANTONIO MATOS MURGA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Narayola II",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04123137405",
      "client_email": "EMATOS@EMPRESASPMC.COM",
      "address": "AV INTERCOMUNAL TURMERO MARACAY EDIF 3 PISO 3 APT 3-B NARAYOLA II TURMERO ARAGUA",
      "client_identification": "V11180657",
      "nap_box_name": "CTO-0523",
      "created_at": "2024-04-18T11:11:24.072175",
      "service_detail": {
        "id": 12636,
        "ip": "172.25.108.2",
        "mac": "TP:LG:1B:B3:63:E5",
        "serial": "TPLG1BB363E5",
        "queue": null,
        "interface": "VLAN117_NARAYOLA",
        "created_at": "2026-06-25T18:28:09.756485",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3790,
      "client_name": "REINALDO ANTONIO PLAZA RIVERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Luz y Vida",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243537500",
      "client_email": "REINALDOANTONIOPLAZA@GMAIL.COM",
      "address": "CALLE 2 CASA NRO 96 SECTOR LUZ Y VIDA ROSARIO DE PAYA ZONA POSTAL 2115",
      "client_identification": "V20989735",
      "nap_box_name": "359",
      "created_at": "2024-04-18T11:11:46.165294",
      "service_detail": {
        "id": 9811,
        "ip": "172.27.95.2",
        "mac": "HWTCC15A919C",
        "serial": "HWTCC15A919C",
        "queue": null,
        "interface": "VLAN237_CANAIMA",
        "created_at": "2025-11-10T16:23:03.730820",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3792,
      "client_name": "KARLA VANESSA ALVAREZ CELIS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Brisas de Paya",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128879083",
      "client_email": "VANESAACELIS@GMAIL.COM",
      "address": "CALLE 02 CASA NRO 9-1 SECTOR BRISAS DE PAYA",
      "client_identification": "V17740656",
      "nap_box_name": "CTO-00117",
      "created_at": "2024-04-18T11:16:13.406676",
      "service_detail": {
        "id": 12563,
        "ip": "172.20.26.2",
        "mac": "OE:MT:3C:62:09:EA",
        "serial": "OEMT3C6209EA",
        "queue": null,
        "interface": "VLAN241_BRISAS",
        "created_at": "2026-06-01T14:11:02.219208",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3793,
      "client_name": "BELKIS COROMOTO MARTINEZ MELENDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Guanarito",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243437784",
      "client_email": "BCMARTINEZ229@GMAIL.COM",
      "address": "CALLE NEGRO I CASA NRO 14 GUANARITO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V14183961",
      "nap_box_name": "499",
      "created_at": "2024-04-18T11:19:17.489277",
      "service_detail": {
        "id": 5886,
        "ip": "172.26.98.2",
        "mac": "HWTCD672799C",
        "serial": "HWTCD672799C",
        "queue": "Plan_153953_15811_WispHub",
        "interface": "VLAN232_GUANARITO_OLT2",
        "created_at": "2024-08-21T10:07:28.852620",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3794,
      "client_name": "MAGALY YAMILE GARCIA SANCHEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243488800",
      "client_email": "YAMIGARCIA6460@GMAIL.COM",
      "address": "CALLE 4 CASA NRO 250 URB MATA CABALLO ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V16132054",
      "nap_box_name": "CTO-00265",
      "created_at": "2024-04-18T11:20:10.505470",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3795,
      "client_name": "CAROLINA DEL VALLE ROJAS MENDOZA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Valle Verde",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04243215152",
      "client_email": "YARALUZ13@GMAIL.COM",
      "address": "CALLE RIO SECO CASA NRO 02 SECTOR VALLE VERDE ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V13530135",
      "nap_box_name": "CTO-0613",
      "created_at": "2024-04-18T11:24:50.127585",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3796,
      "client_name": "MARIAM GLADELY BOLIVAR SALCEDO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Concepcion",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144454635",
      "client_email": "MARIAMBOLIVAR@HOTMAIL.COM",
      "address": "AV INTERCOMUNAL EDIF 9 PISO 3 APT 1 URB LA CONCEPCION TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V16131312",
      "nap_box_name": "0325 DOS",
      "created_at": "2024-04-18T11:26:49.782068",
      "service_detail": {
        "id": 5833,
        "ip": "172.26.188.2",
        "mac": "HWTCD676A59C",
        "serial": "HWTCD676A59C",
        "queue": "Plan_131337_24341_WispHub",
        "interface": "VLAN111_CONCEPCION",
        "created_at": "2024-08-20T13:25:36.158396",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3797,
      "client_name": "FREILER JESUS CARRERO CASTILLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Palma Real",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04127593932",
      "client_email": "FREILERCARRERO3@GMAIL.COM",
      "address": "CALLE 3 CASA NRO 69 SECTOR PALMA REAL ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V29772557",
      "nap_box_name": "CTO-00391",
      "created_at": "2024-04-18T11:28:24.235244",
      "service_detail": {
        "id": 5831,
        "ip": "172.26.78.2",
        "mac": "HWTC908A659B",
        "serial": "HWTC908A659B",
        "queue": "Plan_161870_30181_WispHub",
        "interface": "VLAN244_PALMAREAL",
        "created_at": "2024-08-20T13:06:09.518615",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3799,
      "client_name": "JOSE LUIS SANCHEZ GONZALEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Las Rurales",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124433859",
      "client_email": "1993CATALINO@GMAIL.COM",
      "address": "PARROQUIA VIRGEN NIÑA PEDRO ARÉVALO APONTE CASA PARROQUIAL LAS RURALES TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V21260839",
      "nap_box_name": "CTO-00361",
      "created_at": "2024-04-18T11:39:02.243935",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3800,
      "client_name": "JOHANA ALEJANDRA CARRASCO RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona II Edificios",
      "plan": {
        "id": 43,
        "name": "RECURRENTE RESIDENCIAL PLAN 650M",
        "cost": "46.00",
        "code": "FOR650M",
        "profile": "650M/650M"
      },
      "client_mobile": "04244029813",
      "client_email": "JOHANACARRASCO1983@GMAIL.COM",
      "address": "AV INTERCOMUNAL TURMERO MARACAY EDIF 15 PISO APTO 01 URB LA CASONA 2 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V18264071",
      "nap_box_name": "CTO-0541",
      "created_at": "2024-04-18T11:40:48.059321",
      "service_detail": {
        "id": 11770,
        "ip": "172.26.11.2",
        "mac": "TPLGF9CD4663",
        "serial": "TPLGF9CD4663",
        "queue": null,
        "interface": "VLAN110_CASONA_2",
        "created_at": "2026-02-27T10:43:59.553698",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3801,
      "client_name": "IVONNE BETILDE LUCENA DE GUTIERREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Residencias Candys",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128907485",
      "client_email": "IVONNEBLUCENA@GMAIL.COM",
      "address": "CALLE RIVAS EDIF RESIDENCIAS CANDY 1 PISO 6 APTO 6-1 SECTOR CENTRO TURMERO ARAGUA ZONA POSTAL 211",
      "client_identification": "V9063382",
      "nap_box_name": "CTO-0516",
      "created_at": "2024-04-18T11:42:02.647088",
      "service_detail": {
        "id": 6671,
        "ip": "172.27.202.2",
        "mac": "HWTCD122BD9A",
        "serial": "HWTCD122BD9A",
        "queue": "Plan_161906_15811_WispHub",
        "interface": "VLAN254_CANDYS_OLT1",
        "created_at": "2024-09-17T17:28:49.719950",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3802,
      "client_name": "XAVIER ALEJANDRO CAMPECHANO SUAREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124058371",
      "client_email": "ALEJANDROSUAREZ242@GMAIL.COM",
      "address": "AV INTERCOMUNAL SANTIAGO MARIÑO EDIF 12 PISO PB APT 4 LA CASONA 2 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V20109613",
      "nap_box_name": "CE - 279",
      "created_at": "2024-04-18T11:47:07.859999",
      "service_detail": {
        "id": 5822,
        "ip": "172.25.168.2",
        "mac": "TPLGF9CD473A",
        "serial": "TPLGF9CD473A",
        "queue": "Plan_131337_24341_WispHub",
        "interface": "VLAN110_CASONA_2",
        "created_at": "2024-08-20T10:07:26.205417",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3804,
      "client_name": "MARIANA MERCEDES RENDON GONZALEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Callejon Lim",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243358617",
      "client_email": "MARIANAR.ADMON@GMAIL.COM",
      "address": "AV CALLEJON LYM EDIF TORRE MAGNOLIA PISO 2 APT 10 URB VILLAS DE TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V20695327",
      "nap_box_name": "CTO-0563",
      "created_at": "2024-04-18T11:53:02.825948",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3805,
      "client_name": "STARLYNG WILLIE GRILLO DIAZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243196809",
      "client_email": "WILLIE1DIAZ@GMAIL.COM",
      "address": "CALLE CARREÑO EDIF 23 PISO 1 APT 2URB ANTIGUA HACIENDA EL NISPERO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V30659361",
      "nap_box_name": "CTO-00207 DOS",
      "created_at": "2024-04-18T11:56:10.267194",
      "service_detail": {
        "id": 12447,
        "ip": "172.25.231.2",
        "mac": "TPLGF9CD4317",
        "serial": "TPLGF9CD4317",
        "queue": null,
        "interface": "VLAN209_ZAMORA_OLT1",
        "created_at": "2026-05-02T11:32:45.505137",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3806,
      "client_name": "GLENDY ARELIS FLORES RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Bicentenario",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04125970670",
      "client_email": "GLENDYFLORES2000@GMAIL.COM",
      "address": "CALLE FUNDA BARRIO CASA NRO 04 ZONA AREVALO APONTE ROSARIO DE PAYA SECTOR BICENTENARIO",
      "client_identification": "V27687652",
      "nap_box_name": "CTO-00302",
      "created_at": "2024-04-18T11:58:25.301426",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3807,
      "client_name": "NORKELYS YOHANA VALDERRAMA SANABRIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Concepcion",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04244692762",
      "client_email": "norkelysvalderrama5@gmail.com",
      "address": "CALLE LA JULIA  EDIF TORRE 14 PISO 1 APTO 1 URB NUESTRA SEÑORA DE LA CONCEPCION TURMERO",
      "client_identification": "V25314275",
      "nap_box_name": "TORRE 14 LA CONCEPCION",
      "created_at": "2024-04-18T11:58:45.588832",
      "service_detail": {
        "id": 5798,
        "ip": "172.27.158.2",
        "mac": "TPLGB444B148",
        "serial": "TPLGB444B148",
        "queue": "Plan_92034_24341_WispHub",
        "interface": "VLAN111_CONCEPCION",
        "created_at": "2024-08-19T17:16:37.142149",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3808,
      "client_name": "ELIEZER JOSE GONZALEZ GARRIDO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Concepcion",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243405280",
      "client_email": "ELIEZERJ9@GMAIL.COM",
      "address": "CALLE 2 EDIF 11 PISO 1 APT 4 CONJUNTO RESIDENCIAL LA CONCEPCION TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V19554332",
      "nap_box_name": "0326 DOS",
      "created_at": "2024-04-18T12:00:28.288033",
      "service_detail": {
        "id": 6386,
        "ip": "172.26.228.2",
        "mac": "VSOL00D0D737",
        "serial": "VSOL00D0D737",
        "queue": "Plan_131337_24341_WispHub",
        "interface": "VLAN111_CONCEPCION",
        "created_at": "2024-08-27T14:05:59.767802",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3810,
      "client_name": "RICARDO GONZALEZ RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243428636",
      "client_email": "GOLIATHRG@GMAIL.COM",
      "address": "CALLE RIBAS EDIF TIORA PISO 2 APT 4 URB LOS NISPEROS TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V14740852",
      "nap_box_name": "CTO-00296",
      "created_at": "2024-04-18T12:07:52.311457",
      "service_detail": {
        "id": 5776,
        "ip": "172.26.226.2",
        "mac": "HWTCC114079C",
        "serial": "HWTCC114079C",
        "queue": "Plan_143066_15811_WispHub",
        "interface": "VLAN209_ZAMORA_OLT1",
        "created_at": "2024-08-19T16:01:38.095067",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3811,
      "client_name": "JOAN ALEXANDER MARTINEZ SALAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Taguapire",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121493605",
      "client_email": "JOANMARTINEZ1011@GMAIL.COM",
      "address": "AV TURMERO EL MACARO EDIF MODULO 01 PISO 1 APTO 07 URB TAGUAPIRE TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V17985098",
      "nap_box_name": "548",
      "created_at": "2024-04-18T12:10:46.832628",
      "service_detail": {
        "id": 10414,
        "ip": "172.28.16.2",
        "mac": "HWTC577a5471",
        "serial": "HWTC577a5471",
        "queue": null,
        "interface": "VLAN129_TAGUAPIRE_ZTE",
        "created_at": "2025-12-01T10:16:26.095960",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3812,
      "client_name": "GEMINIS CAROLINA SANTANA GARCIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04247661533",
      "client_email": "GEMINISSANTANA4@GMAIL.COM",
      "address": "CALLE 13 CASA NRO 13 SECTOR RIO SECO ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V21271490",
      "nap_box_name": "CTO-00423",
      "created_at": "2024-04-18T12:17:05.861800",
      "service_detail": {
        "id": 11437,
        "ip": "172.28.13.2",
        "mac": "TPLGF9CD3C4C",
        "serial": "TPLGF9CD3C4C",
        "queue": null,
        "interface": "VLAN251_RIO_SECO",
        "created_at": "2026-01-31T19:26:22.499105",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3813,
      "client_name": "KEITER ERNESTO DIAZ PANTOJA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados I",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243189397",
      "client_email": "KEITERERNESTO@GMAIL.COM",
      "address": "CALLE 2 CASA NRO 19 PRADOS DE PAYA I ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V17365833",
      "nap_box_name": "CTO-00300",
      "created_at": "2024-04-18T12:18:23.103230",
      "service_detail": {
        "id": 6443,
        "ip": "172.28.81.2",
        "mac": "ZICGCD84286B",
        "serial": "ZICGCD84286B",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN239_PRADOS1",
        "created_at": "2024-08-28T17:16:44.019111",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3814,
      "client_name": "YAIRU JOSYBEL APOLINARES LEZAMA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04265302825",
      "client_email": "YAPOLINARES26@GMAIL.COM",
      "address": "CALLE CARREÑO EDIF 08-E01 PISO 1 APT 04 URB DESARROLLO HABITACIONAL LOS NISPEROS TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V242098516",
      "nap_box_name": "CTO-00513",
      "created_at": "2024-04-18T12:23:52.762263",
      "service_detail": {
        "id": 5774,
        "ip": "172.26.225.2",
        "mac": "HWTC90BAAE9B",
        "serial": "HWTC90BAAE9B",
        "queue": "Plan_147201_15811_WispHub",
        "interface": "VLAN209_ZAMORA_OLT1",
        "created_at": "2024-08-19T15:57:27.523096",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3815,
      "client_name": "KEITER ERNESTO DIAZ PANTOJA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04120433280",
      "client_email": "KEITER_22_22@HOTMAIL.COM",
      "address": "CALLE CAMILO TORRES CASA NRO S/N LOS NISPEROS TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V173658334",
      "nap_box_name": "CE - 140",
      "created_at": "2024-04-18T12:24:41.054319",
      "service_detail": {
        "id": 6442,
        "ip": "172.25.111.2",
        "mac": "TPLGF9CD3D00",
        "serial": "TPLGF9CD3D00",
        "queue": "Plan_107915_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-08-28T17:14:48.762605",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3816,
      "client_name": "EDIXON JOSE SANDREA SANDREA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Durpa",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243242889",
      "client_email": "EDIXONSAN25@GMAIL.COM",
      "address": "CALLE MANZANA 14 CASA NRO 17 SECTOR FUNDA BARRIO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V24815632",
      "nap_box_name": "CTO-00453",
      "created_at": "2024-04-18T12:28:47.097444",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3817,
      "client_name": "GONZALO EZEQUIEL LANDAETA CARRILLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243380126",
      "client_email": "GOLANCA6@GMAIL.COM",
      "address": "calle bolivar Res. Paraiso piso 6 apto 3",
      "client_identification": "V7287727",
      "nap_box_name": "CTO-0645",
      "created_at": "2024-04-18T12:34:21.352700",
      "service_detail": {
        "id": 4320,
        "ip": "172.25.69.2",
        "mac": "TPLGF9CD4459",
        "serial": "TPLGF9CD4459",
        "queue": "Plan_153953_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-08-09T09:29:41.692009",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3818,
      "client_name": "JOSE GREGORIO FRIAS SALAZAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Laguna Plaza",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04243273803",
      "client_email": "JOSEGRAUC@HOTMAIL.COM",
      "address": "CALLE NEGRO PRIMERO CC CAMILO TORRES EDIF 07 APTO PB-4 URB LAGUNA PLAZA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V15206429",
      "nap_box_name": "1",
      "created_at": "2024-04-18T12:37:18.469999",
      "service_detail": {
        "id": 4324,
        "ip": "172.27.157.2",
        "mac": "TPLGF9CD43B0",
        "serial": "TPLGF9CD43B0",
        "queue": "Plan_140304_15811_WispHub",
        "interface": "VLAN216_LAGUNA_PLAZA_OLT1",
        "created_at": "2024-08-09T09:41:50.230221",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3819,
      "client_name": "VISNEIDYS NAZARETH OCHOA SOSA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243344353",
      "client_email": "OCHOAVISNEIDYS@GMAIL.COM",
      "address": "CALLE EZEQUIEL ZAMORA EDIF 3 PISO 1 APTO 2 URB LOS NISPEROS ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V24173200",
      "nap_box_name": "130",
      "created_at": "2024-04-18T12:40:28.446271",
      "service_detail": {
        "id": 5750,
        "ip": "172.25.35.2",
        "mac": "TPLGF9CD3C92",
        "serial": "TPLGF9CD3C92",
        "queue": "Plan_143066_15811_WispHub",
        "interface": "VLAN209_ZAMORA_OLT1",
        "created_at": "2024-08-19T14:52:51.892185",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3820,
      "client_name": "CATALINA SERRANO DE GODOY",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Concepcion",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243549643",
      "client_email": "MARIANGELVPG158@GMAIL.COM",
      "address": "AV INTERCOMUNAL DE TURMERO EDIF 11 PISO PB APT 04 URB NUESTRA SEÑORA DE LA CONCEPCION TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V3935790",
      "nap_box_name": "0326 DOS",
      "created_at": "2024-04-18T12:41:43.871037",
      "service_detail": {
        "id": 5749,
        "ip": "172.26.202.2",
        "mac": "HWTCD60D749C",
        "serial": "HWTCD60D749C",
        "queue": "Plan_148293_24341_WispHub",
        "interface": "VLAN111_CONCEPCION",
        "created_at": "2024-08-19T14:50:29.249340",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3821,
      "client_name": "FRANLYS ALBANI MATOS HERNANDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Concepcion",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121632632",
      "client_email": "ALBANIM2111.UNI@GMAIL.COM",
      "address": "FRANLYS ALBANI MATOS HERNANDEZ",
      "client_identification": "V260956112",
      "nap_box_name": "0325 DOS",
      "created_at": "2024-04-18T12:42:03.351643",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3822,
      "client_name": "BRANDON JOSUE CORDOVEZ BORGES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona II Edificios",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243524011",
      "client_email": "BRAYANCASTEBOR@GMAIL.COM",
      "address": "AV INTERCOMUNAL TURMERO LA CASONA 2 TORRE 9B PB APT 5 ZONA POSTAL 2115",
      "client_identification": "V28267874",
      "nap_box_name": "CTO-0536",
      "created_at": "2024-04-18T12:44:38.328550",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3823,
      "client_name": "FELICIA DEL VALLE RUMBOL LIZCANO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona II Edificios",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144611999",
      "client_email": "DILANYSANETH@GMAIL.COM",
      "address": "AV INTERCOMUNAL TURMERO LA CASONA 2 TORRE 9B PISO 3 APTO 4 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V12340408",
      "nap_box_name": "CTO-0536",
      "created_at": "2024-04-18T12:46:19.611593",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3824,
      "client_name": "LUISA YURINEN UZCATEGUI VARGAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona II Edificios",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121752401",
      "client_email": "UZCATEGUILUISA2@GMAIL.COM",
      "address": "AV INTERCOMUNAL TURMERO LA CASONA 2 EDIF 8A PISO 3 APTO 1 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V12608531",
      "nap_box_name": "CTO-0535",
      "created_at": "2024-04-18T12:48:07.401866",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3825,
      "client_name": "ELIZABETH AVILA GONZALEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona I Edificios",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144921201",
      "client_email": "ELIZABETHAVILA1955@GMAIL.COM",
      "address": "CALLE PRINCIPAL LOS JARDINES CASONA I EDIFICIO D PISO PB APT 4",
      "client_identification": "V4467765",
      "nap_box_name": "CTO-0531",
      "created_at": "2024-04-18T12:48:56.427956",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3826,
      "client_name": "BRANDON LEE TORRES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona I Edificios",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124367185",
      "client_email": "BRANDOPYM@GMAIL.COM",
      "address": "AV INTERCOMUNAL TURMERO EDIFICIO D APTO 1 PB",
      "client_identification": "V26526393",
      "nap_box_name": "CTO-0531",
      "created_at": "2024-04-18T12:50:59.699180",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3827,
      "client_name": "RAUL PASTOR ROJAS SANCHEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Concepcion",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04145981840",
      "client_email": "Ja8687251@gmail.com",
      "address": "URB. NUESTRA SEÑORA DE LA CONCEPCION TORRE 14 PISO 2 APARTAMENTO 02-03",
      "client_identification": "V6336722",
      "nap_box_name": "TORRE 14 LA CONCEPCION",
      "created_at": "2024-04-18T12:53:42.903865",
      "service_detail": {
        "id": 3570,
        "ip": "172.30.28.2",
        "mac": "TPLGF9CD4419",
        "serial": "TPLGF9CD4419",
        "queue": "Plan_132787_24341_WispHub",
        "interface": "VLAN111_CONCEPCION",
        "created_at": "2024-07-09T10:28:29.522229",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3828,
      "client_name": "BLANCA ELENA ALFONZO DE PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Jabillar",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04267346835",
      "client_email": "BALFONZO8@GMAIL.COM",
      "address": "CALLE BUCARE 2 CASA NRO 02-09 CONJUNTO RESIDENCIAL JABILLAR TURMERO ARAGUA",
      "client_identification": "V8581050",
      "nap_box_name": "CTO-0063",
      "created_at": "2024-04-18T12:54:01.985011",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3829,
      "client_name": "ELIZABETH ANA MARIA MARTINEZ MAZA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona I Edificios",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04147610722",
      "client_email": "ELIZABETHMARTINEZ37@HOTMAIL.COM",
      "address": "EDIFICIO 06 PISO 1 APT 3 LA CASONA I TUREMRO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V8980021",
      "nap_box_name": "CTO-0529",
      "created_at": "2024-04-18T12:57:50.287007",
      "service_detail": {
        "id": 3566,
        "ip": "172.30.31.2",
        "mac": "TPLGF9CD451F",
        "serial": "TPLGF9CD451F",
        "queue": "Plan_132787_24341_WispHub",
        "interface": "VLAN109_CASONA_1",
        "created_at": "2024-07-09T10:10:41.348734",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3830,
      "client_name": "GENESIS COROMOTO MUNOZ LARA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villas El Carmen",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128869769",
      "client_email": "GE.ALE0503@GMAIL.COM",
      "address": "CALLE 8 CASA NRO 10 URB VILLAS EL CARMEN TURMERO",
      "client_identification": "V20336276",
      "nap_box_name": "41",
      "created_at": "2024-04-18T13:03:13.948218",
      "service_detail": {
        "id": 13085,
        "ip": "172.17.1.82",
        "mac": "68:9F:F0:2A:CF:8F",
        "serial": "ZXICCD9AC07F",
        "queue": null,
        "interface": "VLAN135_VILLAS_CARMEN_OLT_ZTE",
        "created_at": "2026-09-27T18:18:13.307686",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3831,
      "client_name": "PEDRO JOSE AREVALO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villas El Carmen",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144533641",
      "client_email": "PEDROAREVALO259@GMAIL.COM",
      "address": "AV. PRINCIPAL LOS CHAGUARAMOS CARRT. NAC. MACARO TURMERO ,  EDIF. TORRE BARBASCO  PISO PB APT 4  URB. VILLAS EL CARMEN ZONA POSTAL 2115",
      "client_identification": "V9685478",
      "nap_box_name": "58 DOS",
      "created_at": "2024-04-18T13:06:28.436085",
      "service_detail": {
        "id": 2919,
        "ip": "172.21.3.2",
        "mac": "TPLGB954FB5B",
        "serial": "TPLGB954FB5B",
        "queue": "Plan_127996_1574_WispHub",
        "interface": "VLAN135_VILLAS_CARMEN",
        "created_at": "2024-06-19T17:45:28.222331",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3832,
      "client_name": "KATIUSKA ARACELIS ORTEGA BLANCO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villas El Carmen",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04129676186",
      "client_email": "KATYORTEGA100@GMAIL.COM",
      "address": "CALLE 11 CASA NRO 18 VILLAS EL CARMEN TURMERO. ARAGUA ZONA POSTAL 2115",
      "client_identification": "V9682742",
      "nap_box_name": "40",
      "created_at": "2024-04-18T13:09:03.399156",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3833,
      "client_name": "ANGELICA CAROLINA VEGAS MEDINA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero I",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243733875",
      "client_email": "ANGELICAVEGAS94@GMAIL.COM",
      "address": "CALLE 1 CASA NRO 23 SAMAN TARAZONERO 1 NRO 23 BARRIO EL MACARO TURMERO",
      "client_identification": "V25827444",
      "nap_box_name": "669",
      "created_at": "2024-04-18T13:09:40.375120",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3834,
      "client_name": "JOSE ANDRES GUACARAN RIVERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villas El Carmen",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04269314038",
      "client_email": "GUACARANDRES1299@GMAIL.COM",
      "address": "AV PRINCIPAL LOS CHAGUARAMOS EDIF BARBOSCO PISO PB APT 2 URB VILLAS EL CARMEN SECTOR EL MACARO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V27434565",
      "nap_box_name": "50",
      "created_at": "2024-04-18T13:12:31.725739",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3836,
      "client_name": "MAYORIE JOSEFINA PEREZ MORALES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villas El Carmen",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04128878523",
      "client_email": "MAYORIEPEREZ66@GMAIL.COM",
      "address": "AV PRINCIPAL EDF BARBASCO PISO 3 APT 14 URB VILLAS EL CARMEN SECTOR EL MACARO LA ARBOLEDA TURMERO EDO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V8742814",
      "nap_box_name": "58 DOS",
      "created_at": "2024-04-18T13:21:39.871892",
      "service_detail": {
        "id": 3707,
        "ip": "172.19.184.2",
        "mac": "TPLGB954EBD2",
        "serial": "TPLGB954EBD2",
        "queue": "Plan_127996_1574_WispHub",
        "interface": "VLAN135_VILLAS_CARMEN",
        "created_at": "2024-07-11T21:26:18.907749",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3837,
      "client_name": "ANDERSON BRAYAN BONAN CORONEL",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Taguapire",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243020231",
      "client_email": "ANDERSONBONAN2@GMAIL.COM",
      "address": "CALLE 2 CASA MODULO 6 NRO 51 URB TAGUAPIRE TURMERO ARAGUA",
      "client_identification": "V18443273",
      "nap_box_name": "CTO-00388",
      "created_at": "2024-04-18T13:23:03.111130",
      "service_detail": {
        "id": 12539,
        "ip": "172.17.140.2",
        "mac": "TP:LG:C3:C6:BB:AC",
        "serial": "TPLGC3C6BBAC",
        "queue": null,
        "interface": "VLAN232_GUANARITO_OLT2",
        "created_at": "2026-05-21T16:28:44.762508",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3838,
      "client_name": "ALBERT DANIEL MARIN SANCHEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villas El Carmen",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04123490269",
      "client_email": "ALBERTDANIEL393@GMAIL.COM",
      "address": "CALLE 5 EDIF BARBASCO PISO 1 APT 6 URB VILLAS EL CARMEN TURMERO",
      "client_identification": "V28102196",
      "nap_box_name": "58 DOS",
      "created_at": "2024-04-18T13:23:43.515046",
      "service_detail": {
        "id": 12323,
        "ip": "172.19.116.2",
        "mac": "TPLGB954FC01",
        "serial": "TPLGB954FC01",
        "queue": null,
        "interface": "VLAN135_VILLAS_CARMEN_OLT_ZTE",
        "created_at": "2026-04-16T12:11:09.053312",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3839,
      "client_name": "MARIA DEL CARMEN CARRENO LAREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Taguapire",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243719560",
      "client_email": "MIGREYMAR2015@GMAIL.COM",
      "address": "AV PRINCIPAL DEL MACARO EDIF TAGUAPIRE PISO 1 APT CASA 32 URB TAGUAPIRE TURMERO ESTADO ARAGUA",
      "client_identification": "V17732165",
      "nap_box_name": "CTO-00388",
      "created_at": "2024-04-18T13:26:10.554560",
      "service_detail": {
        "id": 10481,
        "ip": "172.17.138.2",
        "mac": "HWTCDC99F69A",
        "serial": "HWTCDC99F69A",
        "queue": null,
        "interface": "VLAN129_TAGUAPIRE_ZTE",
        "created_at": "2025-12-02T14:49:56.317225",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3840,
      "client_name": "KERYINS ROSMERLIN SAAVEDRA DELGADO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados III",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04126497874",
      "client_email": "SAAVEDRAKERYINS@GMAIL.COM",
      "address": "CALLE 6 CASA NRO 13 SECTOR PRADOS DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V25662287",
      "nap_box_name": "395",
      "created_at": "2024-04-18T13:29:28.791638",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3841,
      "client_name": "ALBERTO JOSE ZANARDI GOMEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Taguapire",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04124111582",
      "client_email": "ALBERT23059@HOTMAIL.COM",
      "address": "CALLE 2 MÓDULO PISO 2 APTO 47 URB TAGUAPIRE TURMERO ESTADO ARAGUA",
      "client_identification": "V18851419",
      "nap_box_name": "549",
      "created_at": "2024-04-18T13:30:39.112120",
      "service_detail": {
        "id": 10435,
        "ip": "172.30.59.2",
        "mac": "TPLGB8628493",
        "serial": "TPLGB8628493",
        "queue": null,
        "interface": "VLAN129_TAGUAPIRE_ZTE",
        "created_at": "2025-12-01T15:38:26.784005",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3842,
      "client_name": "BREHILYS MERCEDES ROSARIO MARTINEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Taguapire",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124950330",
      "client_email": "WILLIAMCBW6@GMAIL.COM",
      "address": "CALLE NRO 2 CASA NRO 23 URB TAGUAPIRE TURMERO ARAGUA",
      "client_identification": "V17703977",
      "nap_box_name": "549",
      "created_at": "2024-04-18T13:32:23.390772",
      "service_detail": {
        "id": 10505,
        "ip": "10.16.199.2",
        "mac": "TPLGC3CCB7E7",
        "serial": "TPLGC3CCB7E7",
        "queue": null,
        "interface": "VLAN129_TAGUAPIRE_ZTE",
        "created_at": "2025-12-02T19:29:40.657997",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3843,
      "client_name": "ROSBERLIC COROMOTO RODRIGUEZ REVERON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Taguapire",
      "plan": {
        "id": 2,
        "name": "RECURRENTE RESIDENCIAL PLAN 30M",
        "cost": "20.00",
        "code": "FOR30",
        "profile": "30M/30M"
      },
      "client_mobile": "04125974063",
      "client_email": "ISAAFER_@HOTMAIL.COM",
      "address": "CALLE 2 CASA NRO 21 URB TAGUAPIRE EL MACARO TURMERO ARAGUA",
      "client_identification": "V21098733",
      "nap_box_name": "549",
      "created_at": "2024-04-18T13:34:30.125727",
      "service_detail": {
        "id": 10433,
        "ip": "172.25.9.2",
        "mac": "TPLGC3CCB7FB",
        "serial": "TPLGC3CCB7FB",
        "queue": null,
        "interface": "VLAN129_TAGUAPIRE_ZTE",
        "created_at": "2025-12-01T15:24:01.949771",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3844,
      "client_name": "BRAYAN ALEXANDER ZAMBRANO MOLINA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villas El Carmen",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243833566",
      "client_email": "BZAMBRANO113@GMAIL.COM",
      "address": "CALLE 10 CASA NRO 4 URB VILLAS EL CARMEN SECTOR EL MACARO TURMERO",
      "client_identification": "V28456439",
      "nap_box_name": "41",
      "created_at": "2024-04-18T13:36:58.957170",
      "service_detail": {
        "id": 2917,
        "ip": "172.19.82.2",
        "mac": "TPLGB954FBBE",
        "serial": "TPLGB954FBBE",
        "queue": "Plan_157310_1574_WispHub",
        "interface": "VLAN135_VILLAS_CARMEN",
        "created_at": "2024-06-19T17:34:26.700905",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3845,
      "client_name": "ADAN JOSE SANCHEZ GIL",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villas El Carmen",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04128870485",
      "client_email": "PABLOJOSESANCHEZ79@GMAIL.COM",
      "address": "CALLE 1 CASA NRO 3 UEB VILLAS EL CARMEN TURMERO",
      "client_identification": "V3537273",
      "nap_box_name": "50",
      "created_at": "2024-04-18T13:47:19.585141",
      "service_detail": {
        "id": 2916,
        "ip": "172.19.17.2",
        "mac": "TPLGB954FCFC",
        "serial": "TPLGB954FCFC",
        "queue": "Plan_161852_1574_WispHub",
        "interface": "VLAN135_VILLAS_CARMEN",
        "created_at": "2024-06-19T17:24:37.225419",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3846,
      "client_name": "ALIDA NATIVIDAD PENA LOPEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Taguapire",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243667787",
      "client_email": "ALIDANPL@GMAIL.COM",
      "address": "AV PRINCIPAL EL MÁCARO EDIF MÓDULO 3 PISO 1 APT 27 URB TAGUAPIRE TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V16732305",
      "nap_box_name": "549",
      "created_at": "2024-04-18T13:49:59.645341",
      "service_detail": {
        "id": 10436,
        "ip": "172.28.122.2",
        "mac": "TPLGC3CCB7E9",
        "serial": "TPLGC3CCB7E9",
        "queue": null,
        "interface": "VLAN129_TAGUAPIRE_ZTE",
        "created_at": "2025-12-01T15:41:12.834530",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3847,
      "client_name": "REINA CAROLINA RIVAS LOPEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Taguapire",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128892933",
      "client_email": "REINACRIVAS@OUTLOOK.COM",
      "address": "CTRA NACIONAL EL MACARO TURMERO EDIF 6 PISO 1 APT 59 URB TAGUAPIRE TURMERO ARAGUA",
      "client_identification": "V15123985",
      "nap_box_name": "CTO-00388",
      "created_at": "2024-04-18T13:51:43.050655",
      "service_detail": {
        "id": 12243,
        "ip": "172.17.129.2",
        "mac": "TPLGB7656D34",
        "serial": "TPLGB7656D34",
        "queue": null,
        "interface": "VLAN129_TAGUAPIRE_ZTE",
        "created_at": "2026-04-02T09:57:10.642324",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3848,
      "client_name": "JESUS MANUEL RIVERA DELGADO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Plaza Jardin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04129767809",
      "client_email": "IRENRIVE25@GMAIL.COM",
      "address": "CALLE PARAISO URBANIZACION PLAZA JARDIN CASA NRO 60 ARAGUA ZONA POSTAL 2115",
      "client_identification": "V2867880",
      "nap_box_name": "439",
      "created_at": "2024-04-18T13:51:43.532161",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3849,
      "client_name": "JOSE GREGORIO AGUERO SEQUERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villas El Carmen",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124441008",
      "client_email": "AGUEROJG09@GMAIL.COM",
      "address": "CALLE 3 CASA NRO 15 URB VILLAS EL CARMEN TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V6652907",
      "nap_box_name": "49",
      "created_at": "2024-04-18T13:51:59.241767",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3850,
      "client_name": "JOSE MANUEL CHIRIQUEZ FERMIN",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villas El Carmen",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04148280836",
      "client_email": "AZJCHIRIQUEZ@GMAIL.COM",
      "address": "EDIF CUCHIBAN APTO 5-C CALLE 6 RESIDENCIAS VILLAS EL CARMEN",
      "client_identification": "V13936455",
      "nap_box_name": "58 DOS",
      "created_at": "2024-04-18T13:58:42.836438",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3851,
      "client_name": "BARBARA ESTHER GRANDA MATHEUS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Taguapire",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128957868",
      "client_email": "BARBARAGRANDHA@GMAIL.COM",
      "address": "CALLE CARRETERA NACIONAL TURMERO-MACARO CALLE 3 EDIF MÓDULO 10 PISO 1 APT 96 CONJUNTO RESIDENCIAL TAGUAPIRE TURMERO ARAGUA",
      "client_identification": "V18489242",
      "nap_box_name": "CTO-00386",
      "created_at": "2024-04-18T14:00:06.224497",
      "service_detail": {
        "id": 10549,
        "ip": "172.30.82.2",
        "mac": "TPLGB86283B3",
        "serial": "TPLGB86283B3",
        "queue": null,
        "interface": "VLAN129_TAGUAPIRE_ZTE",
        "created_at": "2025-12-03T14:25:34.644097",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3852,
      "client_name": "CARMEN JOSELIN ZAMBRANO DE NEGRON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243294999",
      "client_email": "CARMENJZAMBRANO@HOTMAIL.COM",
      "address": "CALLE CARREÑO EDIF 29 PISO 3 APT 4 URB DESARROLLO HABITACIONAL LOS NISPEROS TURMERO",
      "client_identification": "V9413790",
      "nap_box_name": "CTO-00207 DOS",
      "created_at": "2024-04-18T14:00:08.276725",
      "service_detail": {
        "id": 3903,
        "ip": "172.26.70.2",
        "mac": "HWTCD1AEA99A",
        "serial": "HWTCD1AEA99A",
        "queue": "Plan_143066_15811_WispHub",
        "interface": "VLAN209_ZAMORA_OLT1",
        "created_at": "2024-07-16T18:38:54.697132",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3853,
      "client_name": "JORGE JESUS FERNANDEZ SILVA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona II Edificios",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128953337",
      "client_email": "JESUS.SILVA.250871@GMAIL.COM",
      "address": "AV INTERCOMUNAL EDIF 9 PISO PB APTO 2 URB. LA CASONA 2 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V11178150",
      "nap_box_name": "CTO-0536",
      "created_at": "2024-04-18T14:02:50.775082",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3854,
      "client_name": "DEISY CAROLINA RUIZ NAVAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Concepcion",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04127791182",
      "client_email": "RUIZDEISY771@GMAIL.COM",
      "address": "CALLE 3 CASA NRO 12 URBANIZACION LA CONCEPCION",
      "client_identification": "V20068976",
      "nap_box_name": "108",
      "created_at": "2024-04-18T14:05:51.351448",
      "service_detail": {
        "id": 3477,
        "ip": "172.17.182.2",
        "mac": "VSOL0051FDC9",
        "serial": "VSOL0051FDC9",
        "queue": "Plan_132787_24341_WispHub",
        "interface": "VLAN111_CONCEPCION",
        "created_at": "2024-07-05T08:55:00.463624",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3855,
      "client_name": "STARSKY ALEXANDER YEDRA GRANADA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villas El Carmen",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04263311040",
      "client_email": "edmaly1982@GMAIL.COM",
      "address": "AV PRINCIPAL  EL MACARO EDIF TORRE CUCHIBAN  PISO APTO 12 C URB VILLAS EL CARMEN TURMERO",
      "client_identification": "V12718971",
      "nap_box_name": "58 DOS",
      "created_at": "2024-04-18T14:08:53.510630",
      "service_detail": {
        "id": 3960,
        "ip": "172.18.213.2",
        "mac": "TPLGB954FD69",
        "serial": "TPLGB954FD69",
        "queue": "Plan_127996_1574_WispHub",
        "interface": "VLAN135_VILLAS_CARMEN",
        "created_at": "2024-07-17T15:24:56.986653",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3856,
      "client_name": "NANCY COROMOTO RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villas El Carmen",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04127424917",
      "client_email": "GABYLESPE19@GMAIL.COM",
      "address": "CALLE LOS CHAGUARAMOS EDIF TORRE CUBILLAN PISO 3 APTO 13 CURB VILLAS EL CARMEN EL MACARO",
      "client_identification": "V12171191",
      "nap_box_name": "58 DOS",
      "created_at": "2024-04-18T14:13:10.594982",
      "service_detail": {
        "id": 2912,
        "ip": "172.18.214.2",
        "mac": "TPLGB954E8A3",
        "serial": "TPLGB954E8A3",
        "queue": "Plan_127996_1574_WispHub",
        "interface": "VLAN135_VILLAS_CARMEN",
        "created_at": "2024-06-19T17:19:55.142084",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3857,
      "client_name": "FLOR MARITZA GUEVARA GOMEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Taguapire",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128965634",
      "client_email": "NOVEDADESBELFIORE2018@GMAIL.COM",
      "address": "CALLE 3 CASA NRO 66 URB TAGUAPIRE TURMERO ARAGUA",
      "client_identification": "V16762184",
      "nap_box_name": "CTO-00386",
      "created_at": "2024-04-18T14:14:11.384249",
      "service_detail": {
        "id": 10498,
        "ip": "172.30.41.2",
        "mac": "TPLGC3CCB7EE",
        "serial": "TPLGC3CCB7EE",
        "queue": null,
        "interface": "VLAN129_TAGUAPIRE_ZTE",
        "created_at": "2025-12-02T17:19:59.119350",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3858,
      "client_name": "JULIO DANIEL PALMA CARRILLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villas El Carmen",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04145979023",
      "client_email": "JULIOPALMA06@GMAIL.COM",
      "address": "CALLE 3 CASA NRO 11 URB VILLAS EL CARMEN TURMERO ARAGUA",
      "client_identification": "V16551771",
      "nap_box_name": "49",
      "created_at": "2024-04-18T14:16:12.854720",
      "service_detail": {
        "id": 6304,
        "ip": "172.18.199.2",
        "mac": "TPLGB954FA58",
        "serial": "TPLGB954FA58",
        "queue": "Plan_107915_1574_WispHub",
        "interface": "VLAN135_VILLAS_CARMEN_OLT_ZTE",
        "created_at": "2024-08-23T17:27:14.501389",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3859,
      "client_name": "GILDA MERCEDES MORILLO BOLIVAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villas El Carmen",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04127768476",
      "client_email": "GILDAMORILLO24@GMAIL.COM",
      "address": "CALLE 11 CASA NRO 3 URB VILLAS EL CARMEN TURMERO ARAGUA",
      "client_identification": "V11090193",
      "nap_box_name": "40",
      "created_at": "2024-04-18T14:19:14.895170",
      "service_detail": {
        "id": 2910,
        "ip": "172.18.185.2",
        "mac": "TPLG2ABDC676",
        "serial": "TPLG2ABDC676",
        "queue": "Plan_137413_1574_WispHub",
        "interface": "VLAN135_VILLAS_CARMEN",
        "created_at": "2024-06-19T17:01:40.458833",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3860,
      "client_name": "LUCIA MARGARITA LOPEZ TOVAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villas El Carmen",
      "plan": {
        "id": 16,
        "name": "RECURRENTE RESIDENCIAL PLAN 800M",
        "cost": "55.00",
        "code": "FOR800",
        "profile": "800M/800M"
      },
      "client_mobile": "04144358630",
      "client_email": "DANIELANTONIO1996@HOTMAIL.COM",
      "address": "CALLE 3ERA CASA NRO 16 URB VILLAS EL CARMEN TURMERO MARACAY ARAGUA",
      "client_identification": "V4549265",
      "nap_box_name": "49",
      "created_at": "2024-04-18T14:23:49.820644",
      "service_detail": {
        "id": 2905,
        "ip": "172.28.6.2",
        "mac": "TPLGB76562ED",
        "serial": "TPLGB76562ED",
        "queue": "Plan_127983_1574_WispHub",
        "interface": "VLAN135_VILLAS_CARMEN",
        "created_at": "2024-06-19T16:41:39.439391",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3861,
      "client_name": "JOSE GREGORIO MORENO LARA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villas El Carmen",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121480530",
      "client_email": "JOSEMORENO1932@GMAIL.COM",
      "address": "CALLE 7. CASA NRO 10, URB VILLAS EL CARMEN, SECTOR, EL MACARO. TURMERO EDO ARAGUA, POSTAL 2115",
      "client_identification": "V24817019",
      "nap_box_name": "41",
      "created_at": "2024-04-18T14:31:58.410285",
      "service_detail": {
        "id": 3366,
        "ip": "172.28.7.2",
        "mac": "TPLG2ABDC7FD",
        "serial": "TPLG2ABDC7FD",
        "queue": "Plan_157310_1574_WispHub",
        "interface": "VLAN135_VILLAS_CARMEN_OLT_ZTE",
        "created_at": "2024-07-02T17:04:30.789807",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3862,
      "client_name": "JOSE GREGORIO COA AREINAMO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villas El Carmen",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243120767",
      "client_email": "SCORPION_JOSE@HOTMAIL.COM",
      "address": "CTRA EL MACARO EDIF ATELEYA PISO 2 APT 10-A URB VILLAS EL CARMEN TURMERO ARAGUA",
      "client_identification": "V11087417",
      "nap_box_name": "43",
      "created_at": "2024-04-18T14:36:24.946149",
      "service_detail": {
        "id": 2911,
        "ip": "172.30.39.2",
        "mac": "TPLGB7656466",
        "serial": "TPLGB7656466",
        "queue": "Plan_137413_1574_WispHub",
        "interface": "VLAN135_VILLAS_CARMEN",
        "created_at": "2024-06-19T17:05:11.226835",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3863,
      "client_name": "JESULAY JACQUELINE GARCIA DE MENDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243035491",
      "client_email": "JESUGARCIA310382@GMAIL.COM",
      "address": "CALLE PROLONGACION CARREÑO EDIF 19 PISO 3 APTO 03 URB HACIENDA EL NISPERO TURMERO",
      "client_identification": "V15610251",
      "nap_box_name": "CTO-00464 DOS",
      "created_at": "2024-04-18T14:39:18.065362",
      "service_detail": {
        "id": 10998,
        "ip": "172.23.16.2",
        "mac": "OEMT3C620A56",
        "serial": "OEMT3C620A56",
        "queue": null,
        "interface": "VLAN209_ZAMORA_OLT1",
        "created_at": "2025-12-31T17:52:12.524357",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3864,
      "client_name": "TIRSA ALEJANDRA RIVERO PERALES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Paya Abajo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04140534300",
      "client_email": "TIRSA_RIVERO@HOTMAIL.COM",
      "address": "CALLE CAMPO ELIAS CASA NRO 14 SECTOR PAYA ABAJO TURMERO",
      "client_identification": "V19032450",
      "nap_box_name": "CTO-0252",
      "created_at": "2024-04-18T14:40:34.817974",
      "service_detail": {
        "id": 7471,
        "ip": "172.23.103.2",
        "mac": "VSOL0012E5B1",
        "serial": "VSOL0012E5B1",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN231_PAYABAJO",
        "created_at": "2024-12-17T10:30:35.734700",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3865,
      "client_name": "LUISNEY HELENA ARIAS FERNANDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona II Edificios",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04149450782",
      "client_email": "LUISNEYARIAS@GMAIL.COM",
      "address": "AV INTERCOMUNAL EDIF H-15 PISO 1 APTO 2 URB LA CASONA II TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V25677813",
      "nap_box_name": "CTO-0541",
      "created_at": "2024-04-18T14:41:04.331179",
      "service_detail": {
        "id": 11784,
        "ip": "172.26.135.2",
        "mac": "HWTCD661829C",
        "serial": "HWTCD661829C",
        "queue": null,
        "interface": "VLAN110_CASONA_2",
        "created_at": "2026-02-27T11:03:48.421310",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3866,
      "client_name": "MARTHA FELIDA GONZALEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villas El Carmen",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243662488",
      "client_email": "MARTHAGON42@GMAIL.COM",
      "address": "CALLE 5 CASA NRO 4 URB VILLAS DEL CARMEN SECTOR EL MACARO TURMERO ESTADO ARAGUA",
      "client_identification": "V8716777",
      "nap_box_name": "CTO VILLAS DEL CARMEN",
      "created_at": "2024-04-18T14:41:50.658039",
      "service_detail": {
        "id": 2908,
        "ip": "172.30.100.2",
        "mac": "TPLGC3C6BBC9",
        "serial": "TPLGC3C6BBC9",
        "queue": "Plan_129887_1574_WispHub",
        "interface": "VLAN135_VILLAS_CARMEN",
        "created_at": "2024-06-19T16:53:35.379460",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3868,
      "client_name": "JUANA JOSEFINA HERNANDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124520536",
      "client_email": "GOCHOSANCHEZ2011@GMAIL.COM",
      "address": "CALLE CARREÑO EDIF CAYCAPE PISO 01 APTO 01 EZEQUIEL ZAMORA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V7183616",
      "nap_box_name": "130",
      "created_at": "2024-04-18T14:46:09.981342",
      "service_detail": {
        "id": 6295,
        "ip": "172.27.254.2",
        "mac": "TPLGF9CD3E42",
        "serial": "TPLGF9CD3E42",
        "queue": "Plan_147201_15811_WispHub",
        "interface": "VLAN209_ZAMORA_OLT1",
        "created_at": "2024-08-23T17:11:43.843418",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3869,
      "client_name": "ALEZKA JOHANNY LIENDO LEON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Residencias Mariño",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243210801",
      "client_email": "ALLEZKALIENDO@GMAIL.COM",
      "address": "CALLE MARIÑO EDIF TORRE B PISO 9 APT 92 SECTOR EL CASCO CENTRAL TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V27036218",
      "nap_box_name": "CTO-0519",
      "created_at": "2024-04-18T14:46:22.644959",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3870,
      "client_name": "SOL MARIA SUAREZ CALA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04125971201",
      "client_email": "SOLSOLECITO031@GMAIL.COM",
      "address": "CALE CARREÑO EDIF TORRE 21 PISO 02 APT 01 URB HACIENDA EL NISPERO EZEQUIEL ZAMORA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V14360138",
      "nap_box_name": "CTO-00207 DOS",
      "created_at": "2024-04-18T14:48:57.233511",
      "service_detail": {
        "id": 3388,
        "ip": "172.26.100.2",
        "mac": "TPLGB954FC2B",
        "serial": "TPLGB954FC2B",
        "queue": "queue1",
        "interface": "VLAN209_ZAMORA_OLT1",
        "created_at": "2024-07-03T08:12:47.723223",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3871,
      "client_name": "JOHANA CAROLINA ROJAS JAUREGUI",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Taguapire",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04146912589",
      "client_email": "Joha_jauregui@hotmail.com",
      "address": "CALLE 3 EDIF MÓDULO 7 PISO 1 APT 65 URB TAGUAPIRE TURMERO ARAGUA",
      "client_identification": "V14665889",
      "nap_box_name": "CTO-00386",
      "created_at": "2024-04-18T14:54:29.687802",
      "service_detail": {
        "id": 10499,
        "ip": "172.25.170.2",
        "mac": "TPLGC3C6BBC5",
        "serial": "TPLGC3C6BBC5",
        "queue": null,
        "interface": "VLAN129_TAGUAPIRE_ZTE",
        "created_at": "2025-12-02T17:22:52.083273",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3873,
      "client_name": "ENRIQUE JOSE MACIAS AGUIAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villas El Carmen",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121486296",
      "client_email": "demb1209@gmail.com",
      "address": "CALLE 4 CASA NRO 18 URB EL MACARO VILLAS EL CARMEN TURMERO ARAGUA",
      "client_identification": "V28249473",
      "nap_box_name": "CTO VILLAS DEL CARMEN",
      "created_at": "2024-04-18T15:02:21.453443",
      "service_detail": {
        "id": 2906,
        "ip": "172.25.184.2",
        "mac": "TPLGB76568B9",
        "serial": "TPLGB76568B9",
        "queue": "Plan_161852_1574_WispHub",
        "interface": "VLAN135_VILLAS_CARMEN",
        "created_at": "2024-06-19T16:47:29.161758",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3875,
      "client_name": "ALEJANDRO JOSE ALBARRAN ALARCON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Taguapire",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04129885934",
      "client_email": "ALEJOSEALBARRAN@GMAIL.COM",
      "address": "AV PPAL EL MACARO EDIF MODULO 08 PISO 0 APTO 70 URB TAGUAIPIRE",
      "client_identification": "V17340886",
      "nap_box_name": "CTO-00386",
      "created_at": "2024-04-18T15:06:37.809392",
      "service_detail": {
        "id": 11900,
        "ip": "172.19.35.2",
        "mac": "TPLGB954FAC3",
        "serial": "TPLGB954FAC3",
        "queue": null,
        "interface": "VLAN129_TAGUAPIRE_ZTE",
        "created_at": "2026-03-02T11:29:35.035244",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3876,
      "client_name": "ESTEBAN ROBERTO LOPEZ MENDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villas El Carmen",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243470059",
      "client_email": "GUILLERMO29581@GMAIL.COM",
      "address": "CALLE 1 CASA NRO S/N URB VILLAS DEL CARMEN VIA EL MACARO TURMERO",
      "client_identification": "V7250870",
      "nap_box_name": "50",
      "created_at": "2024-04-18T15:09:44.965002",
      "service_detail": {
        "id": 3961,
        "ip": "172.17.9.2",
        "mac": "TPLG2ABDC757",
        "serial": "TPLG2ABDC757",
        "queue": "Plan_129887_1574_WispHub",
        "interface": "VLAN135_VILLAS_CARMEN",
        "created_at": "2024-07-17T15:36:00.611650",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3877,
      "client_name": "EDAYMAR ISABEL NAVAS DE CAROLIS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Taguapire",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243557933",
      "client_email": "ISABEL.26PROFC@GMAIL.COM",
      "address": "URB TAGUAPIRE CALLE 4 MODILO 11 APARTAMENTO 102 PLANTA BAJA TURMERO",
      "client_identification": "V16765316",
      "nap_box_name": "CTO-00386",
      "created_at": "2024-04-18T15:10:54.549925",
      "service_detail": {
        "id": 10545,
        "ip": "172.19.73.2",
        "mac": "TPLGB9550186",
        "serial": "TPLGB9550186",
        "queue": null,
        "interface": "VLAN129_TAGUAPIRE_ZTE",
        "created_at": "2025-12-03T14:07:04.832294",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3879,
      "client_name": "MILDRED NAZARET GARCIA PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Taguapire",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04129564036",
      "client_email": "DVIVAS13@GMAIL.COM",
      "address": "CALLE 3 NRO 64 URB TAGUAPIRE MACARO TURMERO",
      "client_identification": "V16131078",
      "nap_box_name": "CTO-00386",
      "created_at": "2024-04-18T15:12:33.200588",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3880,
      "client_name": "ARLENY COROMOTO DIAZ BOLÍVAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villas El Carmen",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243700828",
      "client_email": "ARLENY2014.AD@GMAIL.COM",
      "address": "CALLE 02 Nº 13 URB VILLAS EL CARMEN SECTOR EL MACARO, TURMERO ESTADO ARAGUA",
      "client_identification": "V12141931",
      "nap_box_name": "50",
      "created_at": "2024-04-18T15:13:18.266765",
      "service_detail": {
        "id": 2909,
        "ip": "172.17.10.2",
        "mac": "TPLGB777B463",
        "serial": "TPLGB777B463",
        "queue": "Plan_137413_1574_WispHub",
        "interface": "VLAN135_VILLAS_CARMEN",
        "created_at": "2024-06-19T16:54:38.131267",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3881,
      "client_name": "ZEINEL  VERONICA SOLANO OROPEZA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Taguapire",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04144615356",
      "client_email": "ADOLFO27MORIN@GMAIL.COM",
      "address": "URB TAGUAPIRE CALLE NRO 3 MODULO 7 APT 61 PLANTA BAJA TURMERO",
      "client_identification": "V207696877",
      "nap_box_name": "CTO-00386",
      "created_at": "2024-04-18T15:14:48.464262",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3882,
      "client_name": "ANA MARIA ARAUJO RENGIFO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04145999276",
      "client_email": "LAESTRELLAMARIANNY23@GMAIL.COM",
      "address": "CALLLE RIVAS EDIF TORRE 8 ESCALERA 2 PISO PB APT 1 URB EZEQUIEL ZAMORA TURMERO ARAGUA ZONA POSTAL 2115E",
      "client_identification": "V11093226",
      "nap_box_name": "CTO-00513",
      "created_at": "2024-04-18T15:16:03.903993",
      "service_detail": {
        "id": 6290,
        "ip": "172.26.96.2",
        "mac": "HWTCD161B19A",
        "serial": "HWTCD161B19A",
        "queue": "Plan_128612_15811_WispHub",
        "interface": "VLAN209_ZAMORA_OLT1",
        "created_at": "2024-08-23T16:53:25.770535",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3883,
      "client_name": "ZOILA IRAFRE ESCOBAR QUINTO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Taguapire",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04128204470",
      "client_email": "ambarlorems088@gmail.com",
      "address": "TAGUAIPIRE C/NRO 2 MODULO 5 APTO 43 PLANTA BAJA EL MACARO",
      "client_identification": "V15954446",
      "nap_box_name": "549",
      "created_at": "2024-04-18T15:16:28.902412",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3885,
      "client_name": "TATIANA ALEXANDRA LEMOS PALMA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Terrazas de Juan Pablo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04147938194",
      "client_email": "VICTORIATRAVELS306@GMAIL.COM",
      "address": "CALLE LA LLANERA EDIF MODULO D PISO ALTA APT D15 URB TERRAZAS DE JUAN PABLO TURMERO ARAGUA",
      "client_identification": "V14583736",
      "nap_box_name": "12",
      "created_at": "2024-04-18T15:17:53.371035",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3886,
      "client_name": "JAIME EMILIODEL ESPIRITU SANTO DE ABREU CORONEL",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villas El Carmen",
      "plan": {
        "id": 16,
        "name": "RECURRENTE RESIDENCIAL PLAN 800M",
        "cost": "55.00",
        "code": "FOR800",
        "profile": "800M/800M"
      },
      "client_mobile": "04124598496",
      "client_email": "JAIMERIKCASERAUTO@GMAIL.COM",
      "address": "CALLE 11 Nº 10 URB VILLAS EL CARMEN SECTOR EL MACARO, TURMERO ESTADO ARAGUA",
      "client_identification": "V7186709",
      "nap_box_name": "40",
      "created_at": "2024-04-18T15:18:17.563184",
      "service_detail": {
        "id": 3962,
        "ip": "172.17.11.2",
        "mac": "TPLG2ABDC7F5",
        "serial": "TPLG2ABDC7F5",
        "queue": "Plan_127983_1574_WispHub",
        "interface": "VLAN135_VILLAS_CARMEN",
        "created_at": "2024-07-17T15:51:08.175862",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3887,
      "client_name": "MARYURY MARGARITA SAEZ SOSA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Taguapire",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121415583",
      "client_email": "SAEZMARYURY24@GMAIL.COM",
      "address": "CALLE MARIÑO CASA NRO 48 URB TAGUAPIRE EL MACARO",
      "client_identification": "V16100574",
      "nap_box_name": "549",
      "created_at": "2024-04-18T15:18:24.537481",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3888,
      "client_name": "NAHEN RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villas El Carmen",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04164665555",
      "client_email": "NAHEN14RODRIGUEZ@GMAIL.COM",
      "address": "CALLE 11 Nº 06 URB VILLAS EL CARMEN SECTOR EL MACARO, TURMERO ESTADO ARAGUA",
      "client_identification": "V10758350",
      "nap_box_name": "40",
      "created_at": "2024-04-18T15:21:08.207343",
      "service_detail": {
        "id": 3990,
        "ip": "172.25.110.2",
        "mac": "TPLG2ABDC792",
        "serial": "TPLG2ABDC792",
        "queue": "Plan_129887_1574_WispHub",
        "interface": "VLAN135_VILLAS_CARMEN",
        "created_at": "2024-07-17T16:49:26.949041",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3889,
      "client_name": "KARELIS ANDREINA CALDERA SUMOZA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Taguapire",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243434978",
      "client_email": "KARECALDER@GMAIL.COM",
      "address": "CALLE 3 APTO 71 PB TAGUAPIRE EL MACARO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V20758184",
      "nap_box_name": "CTO-00386",
      "created_at": "2024-04-18T15:21:51.078646",
      "service_detail": {
        "id": 10537,
        "ip": "172.24.183.2",
        "mac": "TPLGB446E8F1",
        "serial": "TPLGB446E8F1",
        "queue": null,
        "interface": "VLAN129_TAGUAPIRE_ZTE",
        "created_at": "2025-12-03T13:22:29.696068",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3890,
      "client_name": "NAZARET DE JESUS CABRERA VILLEGAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona I Edificios",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243638737",
      "client_email": "NAZARESITHA894@GMAIL.COM",
      "address": "AV INTERCOMUNAL EDIF E PISO PB APT 1 URB LA CASONA I TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V28045107",
      "nap_box_name": "CTO-0532",
      "created_at": "2024-04-18T15:22:35.403280",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3891,
      "client_name": "RAFAEL ALBERTO VERGARA VIAFARA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villa De San Jose",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128839955",
      "client_email": "RAF4VERGARA@HOTMAIL.COM",
      "address": "CALLE 2 CASA NRO 0302 URB VILLAS DE SAN JOSE TURMERO ARAGUA",
      "client_identification": "V14060433",
      "nap_box_name": "14",
      "created_at": "2024-04-18T15:28:15.324101",
      "service_detail": {
        "id": 10981,
        "ip": "172.17.53.2",
        "mac": "TPLGC3CCB7E8",
        "serial": "TPLGC3CCB7E8",
        "queue": null,
        "interface": "VLAN134_VILLAS_DSJ_OLT_ZTE",
        "created_at": "2025-12-28T16:34:06.938074",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3892,
      "client_name": "JESUS ALBERTO ARAUJO CASTELLANOS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villas El Carmen",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04143437603",
      "client_email": "JESUSALBERTOARAUJOCASTELLANOS@GMAIL.COM",
      "address": "CALLE 11 Nº 01 URB VILLAS EL CARMEN SECTOR EL MACARO, TURMERO ESTADO ARAGUA",
      "client_identification": "V13133076",
      "nap_box_name": "40",
      "created_at": "2024-04-18T15:29:55.447839",
      "service_detail": {
        "id": 2921,
        "ip": "172.17.13.2",
        "mac": "TPLGB777B26D",
        "serial": "TPLGB777B26D",
        "queue": "Plan_129887_1574_WispHub",
        "interface": "VLAN135_VILLAS_CARMEN",
        "created_at": "2024-06-19T17:52:27.948497",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3893,
      "client_name": "YOLANDA JOSEFINA MENDEZ DE FERRER",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villa De San Jose",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243746078",
      "client_email": "MENDEZDEFERRER@HOTMAIL.COM",
      "address": "CALLE TRANSVERSAL CASA NRO 04-23 URB VILLAS DE SAN JOSE TURMERO ARAGUA",
      "client_identification": "V10504858",
      "nap_box_name": "CTO-00191",
      "created_at": "2024-04-18T15:31:11.508110",
      "service_detail": {
        "id": 12110,
        "ip": "172.28.99.2",
        "mac": "TPLGC3CCB7DB",
        "serial": "TPLGC3CCB7DB",
        "queue": null,
        "interface": "VLAN134_VILLAS_DSJ_OLT_ZTE",
        "created_at": "2026-03-17T17:22:50.437603",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3894,
      "client_name": "HENYERMIN YUSSETT BENITEZ MARTINEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villas El Carmen",
      "plan": {
        "id": 2,
        "name": "RECURRENTE RESIDENCIAL PLAN 30M",
        "cost": "20.00",
        "code": "FOR30",
        "profile": "30M/30M"
      },
      "client_mobile": "04125316658",
      "client_email": "HENYERMINBENITEZ@GMAIL.COM",
      "address": "CALLE 9 CASA NRO 16 URB VILLAS EL CARMEN TURMERO EDO ARAGUA",
      "client_identification": "V20245910",
      "nap_box_name": "41",
      "created_at": "2024-04-18T15:34:54.813958",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3895,
      "client_name": "DENNIS JOHAN APONTE CASTRO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villa De San Jose",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144449067",
      "client_email": "JOHANAPONTECASTRO@HOTMAIL.COM",
      "address": "CALLE 2 CASA NRO 0417 URB VILLAS DE SAN JOSE TURMERO ARAGUA",
      "client_identification": "V12341447",
      "nap_box_name": "14",
      "created_at": "2024-04-18T15:36:06.462292",
      "service_detail": {
        "id": 4134,
        "ip": "172.25.7.2",
        "mac": "TPLGB7656BAD",
        "serial": "TPLGB7656BAD",
        "queue": "Plan_127740_1574_WispHub",
        "interface": "VLAN134_VILLAS_DSJ",
        "created_at": "2024-07-31T10:49:59.821813",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3896,
      "client_name": "RUSBELL JULLIETH LOPEZ RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villas El Carmen",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04121462401",
      "client_email": "RUSBELLJLR@GMAIL.COM",
      "address": "CALLE 03 Nº 10 URB VILLAS EL CARMEN SECTOR EL MACARO, TURMERO ESTADO ARAGUA",
      "client_identification": "V25527363",
      "nap_box_name": "49",
      "created_at": "2024-04-18T15:40:20.739861",
      "service_detail": {
        "id": 3991,
        "ip": "172.17.15.2",
        "mac": "TPLGB7656930",
        "serial": "TPLGB7656930",
        "queue": "Plan_127988_1574_WispHub",
        "interface": "VLAN135_VILLAS_CARMEN",
        "created_at": "2024-07-17T16:51:41.926467",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3897,
      "client_name": "SOLUCIONES INDUSTRIALES FULROMAX CA",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Villas El Carmen",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04243541005",
      "client_email": "ALEJANDRACC2024@GMAIL.COM",
      "address": "CALLE 10 CASA NRO 13 URB VILLAS EL CARMEN SECTOR EL MACARO TURMERO ESTADO ARAGUA",
      "client_identification": "J408626020",
      "nap_box_name": "41",
      "created_at": "2024-04-18T15:43:34.433658",
      "service_detail": {
        "id": 2926,
        "ip": "172.17.16.2",
        "mac": "TPLG2ABDC6F1",
        "serial": "TPLG2ABDC6F1",
        "queue": "queue1",
        "interface": "VLAN135_VILLAS_CARMEN_OLT_ZTE",
        "created_at": "2024-06-19T18:07:13.363880",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3898,
      "client_name": "ALI JOSE VILLEGAS RUIZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villas El Carmen",
      "plan": {
        "id": 16,
        "name": "RECURRENTE RESIDENCIAL PLAN 800M",
        "cost": "55.00",
        "code": "FOR800",
        "profile": "800M/800M"
      },
      "client_mobile": "04121308484",
      "client_email": "ALIVILLEGASRU@GMAIL.COM",
      "address": "CALLE 09 CASA NRO 09 VILLAS EL CARMEN TURMERO ARAGUA",
      "client_identification": "V7228549",
      "nap_box_name": "41",
      "created_at": "2024-04-18T15:46:12.814591",
      "service_detail": {
        "id": 6273,
        "ip": "172.17.17.2",
        "mac": "TPLGB777B326",
        "serial": "TPLGB777B326",
        "queue": "Plan_127983_1574_WispHub",
        "interface": "VLAN135_VILLAS_CARMEN_OLT_ZTE",
        "created_at": "2024-08-23T15:51:24.938229",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3900,
      "client_name": "PAUL ESTEBAN GUZMAN GONZALEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Palma Real",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04241679702",
      "client_email": "PAULGUZMANGONZALEZ@GMAIL.COM",
      "address": "PALMA REAL CALLE 5 CASA 72 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V25879035",
      "nap_box_name": "404",
      "created_at": "2024-04-18T17:31:02.905451",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3902,
      "client_name": "YENNYS YAJAIRA PEREZ AMARISCUAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04243034085",
      "client_email": "YENNYPEREZAMARISCUA@GMAIL.COM",
      "address": "CALLE 12 CASA NRO 669-C URB URBANIZMO MATACABALLO ROSARIO DE PAYA ARAGUA",
      "client_identification": "V10265611",
      "nap_box_name": "CTO-00433",
      "created_at": "2024-04-18T18:10:13.446507",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3903,
      "client_name": "FRANCISCO JOSE LOPEZ CASTILLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243152329",
      "client_email": "alfredolopez0108@gmail.com",
      "address": "AV URDANETA CASA NRO 94 SECTOR CENTRO DE TURMERO EDO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V8732197",
      "nap_box_name": "CTO-00403",
      "created_at": "2024-04-18T18:16:18.820232",
      "service_detail": {
        "id": 6254,
        "ip": "172.27.135.2",
        "mac": "HWTC9016BC9B",
        "serial": "HWTC9016BC9B",
        "queue": "Plan_139897_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-08-23T14:34:17.160812",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3904,
      "client_name": "JOHANNA MILAGRO SILVA PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04128905987",
      "client_email": "SILVAJOHANNA34@GMAIL.COM",
      "address": "CALLE 3-A CASA NRO 5 URB PANTIN ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V16131102",
      "nap_box_name": "CTO-00127 DOS",
      "created_at": "2024-04-18T21:30:03.285176",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3906,
      "client_name": "YURIMAR RAMOS OJEDA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04127533942",
      "client_email": "YURIMARRAMOSCFSTURISMO@GMAIL.COM",
      "address": "CALLE 1 CASA NRO 12 URB PANTIN ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V13518101",
      "nap_box_name": "CTO-00128",
      "created_at": "2024-04-18T23:09:14.573885",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3907,
      "client_name": "PETRA RAMONA RAMOS CAMPOS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04125972293",
      "client_email": "PETRA.09.RAMOS@GMAIL.COM",
      "address": "PRADOS II CALLE 1 CASA NRO 18 ARAGUA ZONA POSTAL 2115",
      "client_identification": "V9664849",
      "nap_box_name": "CTO-00118",
      "created_at": "2024-04-18T23:12:07.351302",
      "service_detail": {
        "id": 3204,
        "ip": "172.27.168.2",
        "mac": "HWTCC19C549C",
        "serial": "HWTCC19C549C",
        "queue": "Plan_161905_30183_WispHub",
        "interface": "VLAN242_PRADOS2",
        "created_at": "2024-06-27T18:17:05.527616",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3908,
      "client_name": "WILMER ANTONIO LA CRUZ ESCALANTE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "SUSPENDIDO_RESIDENCIAL",
      "status_name": "Suspendido",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04125378508",
      "client_email": "WLACRUZ@ALFONZORIVAS.COM",
      "address": "CALLE MANZANA E9 CASA  NRO 28  URB SAMAN TARAZONERO II TURMERO ARAGUA",
      "client_identification": "V17575682",
      "nap_box_name": "277",
      "created_at": "2024-04-18T23:16:47.238033",
      "service_detail": {
        "id": 12476,
        "ip": "172.27.34.2",
        "mac": "aa:aa:aa:aa:aa:aa",
        "serial": "GPON0097F3A6",
        "queue": null,
        "interface": "VLAN100_OLTs",
        "created_at": "2026-05-07T20:57:19.490635",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3909,
      "client_name": "RICARDO ANTONIO ZABALA CONTRERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Las Rurales",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243621052",
      "client_email": "MARLENJOSEF2015@GMAIL.COM",
      "address": "CALLE 105 CASA NRO 86 SECTOR LAS RURALES DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V10459360",
      "nap_box_name": "CTO-00200",
      "created_at": "2024-04-18T23:30:10.103844",
      "service_detail": {
        "id": 6228,
        "ip": "172.27.117.2",
        "mac": "HWTCD66E839C",
        "serial": "HWTCD66E839C",
        "queue": "Plan_161905_30183_WispHub",
        "interface": "VLAN252_RURALES_PAYA",
        "created_at": "2024-08-23T11:28:55.037179",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3910,
      "client_name": "LISSETH CAROLINA VASQUEZ OJEDA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Taguapire",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04149438387",
      "client_email": "ESTHELISSETHCHA@GMAIL.COM",
      "address": "CALLE 3 EDIF MODULO 9 PISO PB APTO 94 URB TAGUAPIRE TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V18475060",
      "nap_box_name": "CTO-00386",
      "created_at": "2024-04-18T23:33:11.964837",
      "service_detail": {
        "id": 12482,
        "ip": "172.26.61.2",
        "mac": "JM:KG:CF:EC:A0:7D",
        "serial": "JMKGCFECA07D",
        "queue": null,
        "interface": "VLAN129_TAGUAPIRE_ZTE",
        "created_at": "2026-05-10T09:53:52.967176",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3911,
      "client_name": "EVELIN CAROLINA COLMENARES AZUAJE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 43,
        "name": "RECURRENTE RESIDENCIAL PLAN 650M",
        "cost": "46.00",
        "code": "FOR650M",
        "profile": "650M/650M"
      },
      "client_mobile": "04129683978",
      "client_email": "COLMENARESEVELIN037@GMAIL.COM",
      "address": "CALLE 23 CASA NRO 20 SECTOR RIO SECO ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V28432784",
      "nap_box_name": "602",
      "created_at": "2024-04-18T23:35:57.122367",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3912,
      "client_name": "RAFAEL ANTONIO RODRIGUEZ GONZALEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Concepcion III",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243075641",
      "client_email": "RAFAANTONIORODRIGUEZ7@GMAIL.COM",
      "address": "CALLE TERCERA CALLE CASA NRO 76 URB LA CONCEPCION III TURMERO ARAGUA ZONA POSTAL 2107",
      "client_identification": "V12853157",
      "nap_box_name": "CTO-00456",
      "created_at": "2024-04-18T23:39:23.888945",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3913,
      "client_name": "HAROLD RAMON AQUINO ROJAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124634986",
      "client_email": "HAROLD.AQUINOROJAS@GMAIL.COM",
      "address": "CALLE 05 CASA NRO 50 SECTOR SAMAN TARAZONERO I TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V14944285",
      "nap_box_name": "269",
      "created_at": "2024-04-18T23:45:06.351732",
      "service_detail": {
        "id": 6220,
        "ip": "172.26.163.2",
        "mac": "HWTC465E539B",
        "serial": "HWTC465E539B",
        "queue": "Plan_137413_1574_WispHub",
        "interface": "VLAN140_SMT1",
        "created_at": "2024-08-23T10:48:57.712252",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3914,
      "client_name": "ROSA ANGELA ARIZA RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121488612",
      "client_email": "ROSI37687@GMAIL.COM",
      "address": "URB PANTIN CALLE 11-B CASA NRO 29 TURMWERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V27520903",
      "nap_box_name": "CTO-00168",
      "created_at": "2024-04-18T23:48:11.548394",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3915,
      "client_name": "JAVIER RAMIRO PURO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04123980604",
      "client_email": "JAVIERPURO834@GMAIL.COM",
      "address": "CALLE 13-B CASA NRO 35 URB HACIENDA PANTIN ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V9915303",
      "nap_box_name": "CTO-00171",
      "created_at": "2024-04-18T23:50:52.511164",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3916,
      "client_name": "JOSE ALEXANDER VILLANUEVA MONTILLA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "SUSPENDIDO_RESIDENCIAL",
      "status_name": "Suspendido",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Laguna Plaza",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243545110",
      "client_email": "JAVM1417@GMAIL.COM",
      "address": "CALLE NEGRO PRIMERO CAMPO ELIAS  EDIF 6 PISO  PB 2 APT 2 URB  LAGUNA PLAZA TURMERO",
      "client_identification": "V28456875",
      "nap_box_name": "1",
      "created_at": "2024-04-19T00:10:36.239482",
      "service_detail": {
        "id": 12568,
        "ip": "172.23.164.2",
        "mac": "VS:OL:00:12:BC:69",
        "serial": "VSOL0012BC69",
        "queue": null,
        "interface": "VLAN216_LAGUNA_PLAZA_OLT1",
        "created_at": "2026-06-02T14:16:32.391244",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3917,
      "client_name": "JESUS ALBERTO YEGRES BENSHIMOL",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04125755004",
      "client_email": "luisana.haiskel23@gmail.com",
      "address": "CALLE 12 CASA NRO 47 URB LA CASONA II TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V11641638",
      "nap_box_name": "CTO-00093",
      "created_at": "2024-04-19T00:13:06.171529",
      "service_detail": {
        "id": 6210,
        "ip": "172.26.66.2",
        "mac": "HWTCD1A94A9A",
        "serial": "HWTCD1A94A9A",
        "queue": "Plan_131647_24341_WispHub",
        "interface": "VLAN110_CASONA_2",
        "created_at": "2024-08-23T10:20:59.997135",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3918,
      "client_name": "MARBELYS CAROLINA GONZALEZ OROPEZA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243185882",
      "client_email": "GONZALEZMARBELYS1@GMAIL.COM",
      "address": "CALLE CARREÑO EDIF TORRES OCHO ESCALERA UNO PISO PLANTA BAJA APT 001 URB EZEQUIEL ZAMORA HACIENDA LOS NISPEROS TURMERO ARAGUA ZONA POSTAL 2112",
      "client_identification": "V28277954",
      "nap_box_name": "CTO-00513",
      "created_at": "2024-04-19T00:15:15.331889",
      "service_detail": {
        "id": 6208,
        "ip": "172.27.165.2",
        "mac": "HWTCD63A5E9C",
        "serial": "HWTCD63A5E9C",
        "queue": "Plan_92306_15811_WispHub",
        "interface": "VLAN209_ZAMORA_OLT1",
        "created_at": "2024-08-23T10:16:57.873995",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3919,
      "client_name": "ADRIANA YAMILET HERMOSO GUERRERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243360303",
      "client_email": "ADRIANAYLUILLLY@GMAIL.COM",
      "address": "CALLE 09 #609 - A SECTOR MATA CABALLO ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V20896721",
      "nap_box_name": "CE - 566",
      "created_at": "2024-04-19T00:17:50.245718",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3920,
      "client_name": "ERNESTO FRANCISCO LIENDO NIEVES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04127761395",
      "client_email": "NIEVESLIENDO24@GMAIL.COM",
      "address": "SAMAN TARAZONERO II MANZANA I VEREDA 7 CASA NRO 17 EDO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V7239229",
      "nap_box_name": "504",
      "created_at": "2024-04-19T00:21:03.757901",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3921,
      "client_name": "IVAN DARIO GUERRERO CEGARRA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Salto Angel",
      "plan": {
        "id": 43,
        "name": "RECURRENTE RESIDENCIAL PLAN 650M",
        "cost": "46.00",
        "code": "FOR650M",
        "profile": "650M/650M"
      },
      "client_mobile": "04144778011",
      "client_email": "IVANGUERRERO1974@GMAIL.COM",
      "address": "CALLE EL SAMAN CASA NRO 29 MANZANA 9 URB SALTO ANGEL TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V12227927",
      "nap_box_name": "324",
      "created_at": "2024-04-19T00:25:43.515099",
      "service_detail": {
        "id": 6205,
        "ip": "172.27.130.2",
        "mac": "VSOL00871091",
        "serial": "VSOL00871091",
        "queue": "Plan_142626_24341_WispHub",
        "interface": "VLAN121_S_ANGEL",
        "created_at": "2024-08-23T08:24:22.914770",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3922,
      "client_name": "ADRIANA CATHERINE GOMEZ HIGUERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Paya Abajo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243141568",
      "client_email": "GOMEZ.ADRI5693@GMAIL.COM",
      "address": "CALLE LA CAPILLA CASA NRO 3-D BARRIO PAYA ABAJO ROSARIO DE PAYA",
      "client_identification": "V22948617",
      "nap_box_name": "CTO-00307",
      "created_at": "2024-04-19T00:35:45.178148",
      "service_detail": {
        "id": 12142,
        "ip": "172.23.90.2",
        "mac": "689FF00ADB1F",
        "serial": "ZXICCD1FC874",
        "queue": null,
        "interface": "VLAN231_PAYABAJO",
        "created_at": "2026-03-20T18:03:03.742846",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3923,
      "client_name": "JENNIFER NANCY STEPAS RIVERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Floresta",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243248049",
      "client_email": "JENNIFER.STEPAS@GMAIL.COM",
      "address": "CALLE 1 CASA NRO 12 URB LA FLORESTA TURMERO EDO ARAGUA",
      "client_identification": "V15846779",
      "nap_box_name": "CE - 140",
      "created_at": "2024-04-19T00:39:02.076133",
      "service_detail": {
        "id": 12548,
        "ip": "172.20.79.2",
        "mac": "TP:LG:B8:62:83:DE",
        "serial": "TPLGB86283DE",
        "queue": null,
        "interface": "VLAN212_FLORESTA_OLT1",
        "created_at": "2026-05-27T08:30:55.854748",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3924,
      "client_name": "WILLSON GABRIEL GONZALEZ BOADA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128362949",
      "client_email": "WILLSON1803@GMAIL.COM",
      "address": "CALLE 8 CASA NRO 572D URB MATA CABALLO ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V16764824",
      "nap_box_name": "CTO-00215",
      "created_at": "2024-04-19T00:43:28.619828",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3925,
      "client_name": "JOSE SANTANA PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villa De San Jose",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04145279001",
      "client_email": "JSPEREZ7316@GMAIL.COM",
      "address": "CALLE 2 CASA NRO 03-09 URB VILLAS SAN JOSÉ TURMERO ARAGUA",
      "client_identification": "V7451833",
      "nap_box_name": "CTO-00191",
      "created_at": "2024-04-19T10:49:37.807841",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3926,
      "client_name": "RONALD REGGIO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villa De San Jose",
      "plan": {
        "id": 2,
        "name": "RECURRENTE RESIDENCIAL PLAN 30M",
        "cost": "20.00",
        "code": "FOR30",
        "profile": "30M/30M"
      },
      "client_mobile": "04121480713",
      "client_email": "RONALDREGGIO@GMAIL.COM",
      "address": "CALLE PRINCIPAL CASA NRO 0412 URB VILLAS DE SAN JOSE TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V10759614",
      "nap_box_name": "396",
      "created_at": "2024-04-19T10:52:00.865753",
      "service_detail": {
        "id": 3708,
        "ip": "172.30.90.2",
        "mac": "TPLGC3CCB7DA",
        "serial": "TPLGC3CCB7DA",
        "queue": "Plan_92139_1574_WispHub",
        "interface": "VLAN134_VILLAS_DSJ",
        "created_at": "2024-07-11T21:28:52.831355",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3927,
      "client_name": "FRANK MANUEL JIMENEZ BARRIOS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villa De San Jose",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04125311633",
      "client_email": "BOOMLUGO@GMAIL.COM",
      "address": "CALLE 11 CASA NRO 22 URB LAS MERCEDES, SECTOR 3, LA VISTORIA, EDO. ARAGUA LAS MERCEDES ( LA MORA) ARAGUA  ZONA POSTAL 2121",
      "client_identification": "V14958548",
      "nap_box_name": "CTO-00080",
      "created_at": "2024-04-19T10:56:31.476437",
      "service_detail": {
        "id": 3363,
        "ip": "172.31.40.2",
        "mac": "TPLGB7656E02",
        "serial": "TPLGB7656E02",
        "queue": "Plan_137413_1574_WispHub",
        "interface": "VLAN134_VILLAS_DSJ",
        "created_at": "2024-07-02T16:51:02.008576",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3928,
      "client_name": "ALEXANDER JOEL ROMERO VELASQUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villa De San Jose",
      "plan": {
        "id": 2,
        "name": "RECURRENTE RESIDENCIAL PLAN 30M",
        "cost": "20.00",
        "code": "FOR30",
        "profile": "30M/30M"
      },
      "client_mobile": "04243193197",
      "client_email": "ALEXANDEROMERO81@GMAIL.COM",
      "address": "CTRA NACIONAL MARACAY TURMERO CASA NRO 0305 CONJUNTO RESIDENCIAL VILLA SAN JOSE TURMERO ARAGUA",
      "client_identification": "V14664046",
      "nap_box_name": "14",
      "created_at": "2024-04-19T10:59:19.312751",
      "service_detail": {
        "id": 4282,
        "ip": "172.25.117.2",
        "mac": "TPLGC3C6BBCF",
        "serial": "TPLGC3C6BBCF",
        "queue": "Plan_127740_1574_WispHub",
        "interface": "VLAN134_VILLAS_DSJ",
        "created_at": "2024-08-08T15:25:53.815673",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3929,
      "client_name": "MARIA NELDY DE AGUIAR GOMES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villa De San Jose",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124894944",
      "client_email": "MARIANELDY1977@GMAIL.COM",
      "address": "CALLE PRINCIPAL CASA NRO 0403 URB VILLAS SAN JOSE TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V14830749",
      "nap_box_name": "CTO-00080",
      "created_at": "2024-04-19T11:02:07.498880",
      "service_detail": {
        "id": 3350,
        "ip": "172.29.42.2",
        "mac": "TPLG2ABDC67E",
        "serial": "TPLG2ABDC67E",
        "queue": "Plan_137413_1574_WispHub",
        "interface": "VLAN134_VILLAS_DSJ",
        "created_at": "2024-07-02T16:19:15.015783",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3930,
      "client_name": "YANASKY ALEJANDRA ORTIZ MORENO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villa De San Jose",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04123120456",
      "client_email": "YANASKY2810@GMAIL.COM",
      "address": "CALLE 4 CASA NRO 04-01 CONJUNTO RESIDENCIAL VILLAS DE SAN JOSÉ TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V12995382",
      "nap_box_name": "CTO-00080",
      "created_at": "2024-04-19T11:07:38.849587",
      "service_detail": {
        "id": 3361,
        "ip": "172.30.87.2",
        "mac": "TPLGB765655A",
        "serial": "TPLGB765655A",
        "queue": "Plan_137413_1574_WispHub",
        "interface": "VLAN134_VILLAS_DSJ",
        "created_at": "2024-07-02T16:46:36.290884",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3931,
      "client_name": "ANA KARINA MARQUEZ MEZONES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villa De San Jose",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04126829668",
      "client_email": "keylaw.kmm@gmail.com",
      "address": "AV PRINCIPAL MACARO CASA NRO 0121 URB VILLAS SAN JOSÉ TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V29931484",
      "nap_box_name": "396",
      "created_at": "2024-04-19T11:11:33.962675",
      "service_detail": {
        "id": 4092,
        "ip": "172.25.41.2",
        "mac": "TPLGB76561DA",
        "serial": "TPLGB76561DA",
        "queue": "Plan_138775_1574_WispHub",
        "interface": "VLAN134_VILLAS_DSJ",
        "created_at": "2024-07-22T16:08:17.256607",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3933,
      "client_name": "PEDRO ELIAS GOMEZ GUTIERREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villa De San Jose",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04128903146",
      "client_email": "COLAVITACRISTIAN@GMAIL.COM",
      "address": "CALLE MANZANA 1 CASA NRO 03-01 URB VILLAS DE SAN JOSÉ SECTOR EL MÁCARO TURMERO ARAGUA",
      "client_identification": "V15080676",
      "nap_box_name": "14",
      "created_at": "2024-04-19T11:17:55.270913",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3934,
      "client_name": "JOSE ANDRES RUIZ ESCORIHUELA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villa De San Jose",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04127820200",
      "client_email": "JOSERUIZ2204.AE@GMAIL.COM",
      "address": "CALLE PRINCIPAL CASA NRO 04-22 URB VILLA SAN JOSE TURMERO",
      "client_identification": "V29808720",
      "nap_box_name": "CTO-00191",
      "created_at": "2024-04-19T11:23:29.290056",
      "service_detail": {
        "id": 6248,
        "ip": "172.24.55.2",
        "mac": "VSOL001402F9",
        "serial": "VSOL001402F9",
        "queue": "Plan_138775_1574_WispHub",
        "interface": "VLAN134_VILLAS_DSJ_OLT_ZTE",
        "created_at": "2024-08-23T14:08:58.589626",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3935,
      "client_name": "MARIA MANUELA EUNICE TINEDO SANCHEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villa De San Jose",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04144673727",
      "client_email": "TINEDOEUNICE@GMAIL.COM",
      "address": "CARRETERA PRINCIPAL EL MACARO CASA NRO 0506 URB VILLAS DE SAN JOSE TURMERO ARAGUA ZONA POSTAL 2107",
      "client_identification": "V23789994",
      "nap_box_name": "CTO-00080",
      "created_at": "2024-04-19T11:26:43.957916",
      "service_detail": {
        "id": 4034,
        "ip": "172.17.112.2",
        "mac": "VSOL00493B11",
        "serial": "VSOL00493B11",
        "queue": "Plan_138775_1574_WispHub",
        "interface": "VLAN134_VILLAS_DSJ",
        "created_at": "2024-07-19T09:27:43.023402",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3936,
      "client_name": "SILVIA COROMOTO AGUERO POMPA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villa De San Jose",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04145862386",
      "client_email": "RUBENCARDOZO1@HOTMAIL.COM",
      "address": "CALLE PRINCIPAL CASA NRO 05-05 URB VILLA SAN JOSE TURMERO",
      "client_identification": "V4738556",
      "nap_box_name": "CTO-00080",
      "created_at": "2024-04-19T11:32:19.225909",
      "service_detail": {
        "id": 4027,
        "ip": "172.17.163.2",
        "mac": "VSOL00124751",
        "serial": "VSOL00124751",
        "queue": "Plan_138775_1574_WispHub",
        "interface": "VLAN134_VILLAS_DSJ",
        "created_at": "2024-07-18T17:01:58.879083",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3937,
      "client_name": "JIMMY CONTRERAS MONTAÑEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villa De San Jose",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04162785038",
      "client_email": "SAMARDUQUE2@GMAIL.COM",
      "address": "CONJUNTO RESIDENCIAL VILLAS DE SAN JOSE CASA NRO 01-05",
      "client_identification": "V18570202",
      "nap_box_name": "CTO-00080",
      "created_at": "2024-04-19T11:35:28.521257",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3938,
      "client_name": "ALEJANDRO BRIZUELA RIVEIRO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villa De San Jose",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128907568",
      "client_email": "ALEBRIZUELA14@GMAIL.COM",
      "address": "AV PRINCIPAL EL MACARO CASA NRO 0208 URB VILLA DE SAN JOSE",
      "client_identification": "V22948511",
      "nap_box_name": "14",
      "created_at": "2024-04-19T11:37:43.618056",
      "service_detail": {
        "id": 4020,
        "ip": "172.18.74.2",
        "mac": "VSOL0051E9F9",
        "serial": "VSOL0051E9F9",
        "queue": "Plan_137413_1574_WispHub",
        "interface": "VLAN134_VILLAS_DSJ",
        "created_at": "2024-07-18T15:20:50.017436",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3939,
      "client_name": "YUDIRMA JOSEFINA VAZQUEZ NUÑEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villa De San Jose",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04143953243",
      "client_email": "YUDIRMAVAZQUEZ@HOTMAIL.COM",
      "address": "CALLE PRINCIPAL CASA NRO 01-19 URB VILLAS DE SAN JOSE",
      "client_identification": "V12990264",
      "nap_box_name": "396",
      "created_at": "2024-04-19T11:39:51.744342",
      "service_detail": {
        "id": 4016,
        "ip": "172.18.158.2",
        "mac": "VSOL00498601",
        "serial": "VSOL00498601",
        "queue": "Plan_137413_1574_WispHub",
        "interface": "VLAN134_VILLAS_DSJ",
        "created_at": "2024-07-18T14:32:11.279319",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3940,
      "client_name": "RAMON ANTONIO HERRERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villa De San Jose",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128997979",
      "client_email": "NORKISCHAVEZ@GMAIL.COM",
      "address": "CALLE PRINCIPAL MANZANA 1 CASA NRO 01-10 CONJUNTO RESIDENCIAL VILLAS DE SAN JOSETURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V14238884",
      "nap_box_name": "CTO-00080",
      "created_at": "2024-04-19T11:57:59.765483",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3941,
      "client_name": "ANAIS VANESA BRICENO NAVARRO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villa De San Jose",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04160202000",
      "client_email": "ABRICENO.PROFITPLUS@GMAIL.COM",
      "address": "CALLE TRANSVERSAL 1 CASA NRO 0204 URB VILLAS DE SAN JOSE",
      "client_identification": "V214587935",
      "nap_box_name": "396",
      "created_at": "2024-04-19T12:00:11.464791",
      "service_detail": {
        "id": 4014,
        "ip": "172.25.34.2",
        "mac": "TPLGF9CD457D",
        "serial": "TPLGF9CD457D",
        "queue": "Plan_138775_1574_WispHub",
        "interface": "VLAN134_VILLAS_DSJ",
        "created_at": "2024-07-18T14:27:17.855610",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3942,
      "client_name": "MARIA EUGENIA DELGADO DE REBOLLEDO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Durpa",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121485248",
      "client_email": "EUGENIABUENO.777@GMAIL.COM",
      "address": "CALLE SIMON RODRIGUEZ MANZANA 14 CASA  NRO 20 SECTOR  DESARROLLO URBANISTICO  ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V11982826",
      "nap_box_name": "CTO-00453",
      "created_at": "2024-04-19T12:04:14.786181",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3943,
      "client_name": "LOURDES MARIA FREITAS FLORENCIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Nispero",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144638601",
      "client_email": "LOURDES652009@HOTMAIL.COM",
      "address": "CALLE PRINCIPAL C/C 3 CASA NRO 68 URB EL NISPERO II TURMERO",
      "client_identification": "V8732895",
      "nap_box_name": "20",
      "created_at": "2024-04-19T12:06:37.207649",
      "service_detail": {
        "id": 9044,
        "ip": "10.15.92.2",
        "mac": "VSOL005235B9",
        "serial": "VSOL005235B9",
        "queue": "queue1",
        "interface": "VLAN208_NISPERO_OLT1",
        "created_at": "2025-06-22T17:35:52.890956",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3944,
      "client_name": "DENISSE MARIE ORELLANA VASQUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona I Edificios",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124829240",
      "client_email": "ORELLANAGABRIELA3097@GMAIL.COM",
      "address": "AV. INTERCOMUNAL LA CASONA I EDIF D PISO 2 APTO 1 CONJUNTO RESIDENCIAL LOS JARDINES TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V149582157",
      "nap_box_name": "CTO-0531",
      "created_at": "2024-04-19T12:12:06.715612",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3945,
      "client_name": "KEILA JOSEFINA LUGO NATERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona I Edificios",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243477535",
      "client_email": "KEILALUGO1611@GMAIL.COM",
      "address": "AV INTERCOMUNAL TURMERO MARACAY EDIF 6-B PISO 1 APTO 4 SECTOR LA CASONA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V18084073",
      "nap_box_name": "CTO-0529",
      "created_at": "2024-04-19T12:14:29.858503",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3946,
      "client_name": "YULEMMARI DUBRASKA PAEZ HERNANDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona I Edificios",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04140506289",
      "client_email": "YULEMMARI28@GMAIL.COM",
      "address": "AV INTERCOMUNAL TURMERO, EDIF 6-B PISO 2 APTO 5 LA CASONA I TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V22941059",
      "nap_box_name": "CTO-0529",
      "created_at": "2024-04-19T12:16:42.446588",
      "service_detail": {
        "id": 3989,
        "ip": "172.24.237.2",
        "mac": "TPLGB446FA02",
        "serial": "TPLGB446FA02",
        "queue": "Plan_131647_24341_WispHub",
        "interface": "VLAN109_CASONA_1",
        "created_at": "2024-07-17T16:47:08.220789",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3947,
      "client_name": "GEORGINA CAROLINA NIEVES ROBERTIS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona I Edificios",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121348767",
      "client_email": "GEORGINANIEVES196@GMAIL.COM",
      "address": "AV INTERCOMUNAL EDIF E PISO 02 APTO 06 CONJUNTO RESIDENCIAL LOS JARDINES TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V20453657",
      "nap_box_name": "CTO-0532",
      "created_at": "2024-04-19T12:18:24.728361",
      "service_detail": {
        "id": 3988,
        "ip": "172.24.218.2",
        "mac": "TPLGF9CD3D26",
        "serial": "TPLGF9CD3D26",
        "queue": "Plan_131647_24341_WispHub",
        "interface": "VLAN109_CASONA_1",
        "created_at": "2024-07-17T16:45:07.324185",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3948,
      "client_name": "JOSE MANUEL TREJO CARPAVIRE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona I Edificios",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243731817",
      "client_email": "MT5750105@GMAIL.COM",
      "address": "AV INTERCOMUNAL TURMERO MARACAY EDIF F PISO P/B APTO 1 SECTOR LA CASONA I TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V27048068",
      "nap_box_name": "CTO-0533",
      "created_at": "2024-04-19T12:20:22.497514",
      "service_detail": {
        "id": 3956,
        "ip": "172.24.212.2",
        "mac": "TPLGF9CD475A",
        "serial": "TPLGF9CD475A",
        "queue": "Plan_131337_24341_WispHub",
        "interface": "VLAN109_CASONA_1",
        "created_at": "2024-07-17T15:12:56.096816",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3949,
      "client_name": "VICTOR ALFONSO CONTRERAS ORTIZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243192128",
      "client_email": "PSICOVIC19@GMAIL.COM",
      "address": "CALLE 18 CASA NRO 20 ZONA LA CASONA II TURMERO ARAGUA ZONA POSTAL 2107",
      "client_identification": "V17016840",
      "nap_box_name": "CTO-00086",
      "created_at": "2024-04-19T12:31:12.681710",
      "service_detail": {
        "id": 6247,
        "ip": "172.24.228.2",
        "mac": "TPLGF9CD478E",
        "serial": "TPLGF9CD478E",
        "queue": "Plan_131337_24341_WispHub",
        "interface": "VLAN110_CASONA_2",
        "created_at": "2024-08-23T14:02:54.057974",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3950,
      "client_name": "LAURA MARGARITA SANCHEZ CASTELLANO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04226354271",
      "client_email": "Nacarisan@gmail.com",
      "address": "CALLE 7B NRO 44 LA CASONA 1 AV INTERCOMUNAL TURMERO ZONA POSTAL 2115",
      "client_identification": "V12826980",
      "nap_box_name": "411",
      "created_at": "2024-04-19T12:34:07.930794",
      "service_detail": {
        "id": 3955,
        "ip": "172.24.249.2",
        "mac": "TPLGF9CD4624",
        "serial": "TPLGF9CD4624",
        "queue": "Plan_131647_24341_WispHub",
        "interface": "VLAN109_CASONA_1",
        "created_at": "2024-07-17T15:10:53.067285",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3951,
      "client_name": "MIRALDY RAMONA YEPEZ BETANCOURT",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona II Edificios",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243286796",
      "client_email": "MIRALDYYEPEZ1234@GMAIL.COM",
      "address": "AV INTERCOMUNAL TURMERO EDIF 9 PISO 1 APTO 6 LA CASONA II TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V10120793",
      "nap_box_name": "CTO-0536",
      "created_at": "2024-04-19T12:35:41.902397",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3952,
      "client_name": "ROBERTO LINO JIMENEZ PAREDES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04125371296",
      "client_email": "ROBERTOLINOJIMENEZ@GMAIL.COM",
      "address": "CALLE 7 CASA 23 URB LA CASONA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V9644111",
      "nap_box_name": "410",
      "created_at": "2024-04-19T12:38:58.541734",
      "service_detail": {
        "id": 3951,
        "ip": "172.24.242.2",
        "mac": "TPLGF9CD41D9",
        "serial": "TPLGF9CD41D9",
        "queue": "Plan_131337_24341_WispHub",
        "interface": "VLAN109_CASONA_1",
        "created_at": "2024-07-17T15:06:25.440828",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3953,
      "client_name": "JOSE EDUARDO MARQUEZ BUSTAMANTE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128560506",
      "client_email": "AUBERNAL3089@GMAIL.COM",
      "address": "CALLE PRINCIPAL 5-A CASA NRO 01 PANTIN ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V16317350",
      "nap_box_name": "CTO-00135",
      "created_at": "2024-04-19T12:41:20.153236",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3954,
      "client_name": "ESTEFANY MARIBEL BARRIENTOS CHUELLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243742510",
      "client_email": "ESTEFANYBARRIENTOS.2407@GMAIL.COM",
      "address": "AV PRINCIPAL DE PAYA NRO 52 SECTOR PRADOS 1 ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V20989066",
      "nap_box_name": "CTO-00211 DOS",
      "created_at": "2024-04-19T12:46:51.239232",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3955,
      "client_name": "YEINI LUCIA APONTE MARQUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124513349",
      "client_email": "YEINIAPONTE@GMAIL.COM",
      "address": "CALLE CARREÑO EDIF TIORA PISO PB APTO 05 URB HACIENDA EL NISPERO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V13953381",
      "nap_box_name": "CTO-00296",
      "created_at": "2024-04-19T12:48:57.472034",
      "service_detail": {
        "id": 3947,
        "ip": "172.24.236.2",
        "mac": "TPLGF9CD3FDF",
        "serial": "TPLGF9CD3FDF",
        "queue": "Plan_129889_15811_WispHub",
        "interface": "VLAN209_ZAMORA_OLT1",
        "created_at": "2024-07-17T14:27:34.490616",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3956,
      "client_name": "GUSTAVO JOSE ARMAS ZANOTTY",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243107719",
      "client_email": "GJOSEZANOTTY10@GMAIL.COM",
      "address": "CALLE 07 CASA NRO 535-D SECTOR MATA CABALLO ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V20334360",
      "nap_box_name": "CTO-00130",
      "created_at": "2024-04-19T12:51:28.084656",
      "service_detail": {
        "id": 3358,
        "ip": "172.24.241.2",
        "mac": "TPLGF9CD3F4A",
        "serial": "TPLGF9CD3F4A",
        "queue": "Plan_161905_30183_WispHub",
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2024-07-02T16:39:58.884877",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3957,
      "client_name": "ORLANDO JOSE GUEVARA RUBIO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243163266",
      "client_email": "ORLANDOGUEVARA1406@GMAIL.COM",
      "address": "CALLE 5 A CASA NRO 4 URB LOS PANTIN ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V26320974",
      "nap_box_name": "CTO-00135",
      "created_at": "2024-04-19T12:55:03.692372",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3958,
      "client_name": "FRANCESCA SCATA DE SAAD",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Antigua Hacienda De Paya",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04141466891",
      "client_email": "FRANCASCATA@HOTMAIL.COM",
      "address": "CALLE LOS PINOS CASA NRO 1 URB ANTIGUA HACIENDA DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V13860151",
      "nap_box_name": "100 DOS",
      "created_at": "2024-04-19T12:57:59.654521",
      "service_detail": {
        "id": 3862,
        "ip": "172.24.247.2",
        "mac": "TPLGF9CD3D3A",
        "serial": "TPLGF9CD3D3A",
        "queue": "Plan_129889_15811_WispHub",
        "interface": "VLAN202_AHP_OLT1",
        "created_at": "2024-07-16T14:34:09.805471",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3959,
      "client_name": "YURMARI ANAHI TABLANTE HERNANDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Bicentenario",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121998944",
      "client_email": "LUNAYURI2015@GMAIL.COM",
      "address": "CALLE AVES DEL PARAISO CON MANZANA C CASA NRO 02 SECTOR FUNDA BARRIO ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V14871829",
      "nap_box_name": "384",
      "created_at": "2024-04-19T13:00:14.482466",
      "service_detail": {
        "id": 3945,
        "ip": "172.24.246.2",
        "mac": "OEMT3C6247D6",
        "serial": "OEMT3C6247D6",
        "queue": "Plan_161904_30183_WispHub",
        "interface": "VLAN243_BICENTENARIO",
        "created_at": "2024-07-17T14:12:14.453384",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3960,
      "client_name": "JOHAN ALEXANDER GUZMAN MORILLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona I Edificios",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04127764942",
      "client_email": "SOFIAGUZMAN1004@GMAIL.COM",
      "address": "CALLE PRINCIPAL EDIF G PISO PB APTO 4 CONJUNTO RESIDENCIAL LOS JARDINES TURMERO ARAGUA ZONA 2115",
      "client_identification": "V30866302",
      "nap_box_name": "CTO-0534",
      "created_at": "2024-04-19T13:18:39.673314",
      "service_detail": {
        "id": 3941,
        "ip": "172.24.252.2",
        "mac": "TPLGF9CD473B",
        "serial": "TPLGF9CD473B",
        "queue": "Plan_131337_24341_WispHub",
        "interface": "VLAN109_CASONA_1",
        "created_at": "2024-07-17T13:09:25.011073",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3961,
      "client_name": "ERICKA ANGELLY CASTILLO JIMENEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Concepcion",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243492595",
      "client_email": "ERICKA.ACASTILLOJ25@GMAIL.COM",
      "address": "CALLE 3 CASA NRO 14 URB LA CONCEPCION TURMERO AAGUA ZONA POSTAL 2115",
      "client_identification": "V31381588",
      "nap_box_name": "108",
      "created_at": "2024-04-19T13:23:06.007259",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3962,
      "client_name": "ANA GRACIELA SILVA FLORES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona I Edificios",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144882751",
      "client_email": "GRACHISILFLOR@GMAIL.COM",
      "address": "ANA GRACIELA SILVA FLORES",
      "client_identification": "V8626691",
      "nap_box_name": "CTO-0531",
      "created_at": "2024-04-19T13:25:26.990654",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3963,
      "client_name": "BARBARA SARYZELL LARA GARCIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128969877",
      "client_email": "BARBIEONLINE2021@GMAIL.COM",
      "address": "CASONA II, CALLE 14 CASA NRO 92 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V30073009",
      "nap_box_name": "CTO-00120 DOS",
      "created_at": "2024-04-19T13:27:59.820585",
      "service_detail": {
        "id": 8804,
        "ip": "172.24.239.2",
        "mac": "TPLGF9CD4257",
        "serial": "TPLGF9CD4257",
        "queue": "queue1",
        "interface": "VLAN110_CASONA_2",
        "created_at": "2025-06-02T10:03:05.134076",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3964,
      "client_name": "EFRAIN JOSE LORONO CARRASQUEL",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Santa Eduviges",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04124458860",
      "client_email": "FRANCISCARRASQUEL880@GMAIL.COM",
      "address": "CALLE PRINCIPAL CASA NRO 11 URB SANTA EDUVIGES TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V16851851",
      "nap_box_name": "87",
      "created_at": "2024-04-19T13:30:12.668554",
      "service_detail": {
        "id": 3889,
        "ip": "172.24.235.2",
        "mac": "TPLGF9CD47D3",
        "serial": "TPLGF9CD47D3",
        "queue": "Plan_127996_1574_WispHub",
        "interface": "VLAN127_SANTA_EDUVIGES",
        "created_at": "2024-07-16T17:53:32.624394",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3965,
      "client_name": "ANA LUISA GUZMAN PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona II Edificios",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243385384",
      "client_email": "ANAPRIMERA78@GMAIL.COM",
      "address": "AV INTERCOMUNAL TURMERO, LA CASONA 2 TORRE 11 PB APT 1 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V14087283",
      "nap_box_name": "CTO-0538",
      "created_at": "2024-04-19T13:34:08.726692",
      "service_detail": {
        "id": 3888,
        "ip": "172.25.25.2",
        "mac": "TPLGF9CD4650",
        "serial": "TPLGF9CD4650",
        "queue": "Plan_131647_24341_WispHub",
        "interface": "VLAN110_CASONA_2",
        "created_at": "2024-07-16T17:51:29.078367",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3966,
      "client_name": "ONEYDA LISETTE VARGAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Brisas de Paya",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124529471",
      "client_email": "ONEYDAVARGAS65@GMAIL.COM",
      "address": "CALLE 3 CASA NUMERO 20 SECTOR BRISA DE PAYA",
      "client_identification": "V12568329",
      "nap_box_name": "366",
      "created_at": "2024-04-19T13:36:17.416541",
      "service_detail": {
        "id": 4179,
        "ip": "172.25.26.2",
        "mac": "TPLGF9CD402D",
        "serial": "TPLGF9CD402D",
        "queue": "Plan_161904_30183_WispHub",
        "interface": "VLAN241_BRISAS",
        "created_at": "2024-08-03T08:59:15.479501",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3967,
      "client_name": "MERLYNG ANAMARIA QUERALES GARCIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona II Edificios",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124358225",
      "client_email": "MERLYNGAQG05@GMAIL.COM",
      "address": "AV INTERCOMUNAL TURMERO LA CASONA 2 TORRE 11 PB APT 6 ZONA POSTAL 2115",
      "client_identification": "V31080604",
      "nap_box_name": "CTO-0538",
      "created_at": "2024-04-19T13:38:21.933248",
      "service_detail": {
        "id": 3886,
        "ip": "172.25.22.2",
        "mac": "TPLGF9CD3CE5",
        "serial": "TPLGF9CD3CE5",
        "queue": "Plan_131337_24341_WispHub",
        "interface": "VLAN110_CASONA_2",
        "created_at": "2024-07-16T17:42:44.887548",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3968,
      "client_name": "MAYRA ALEJANDRA LOPEZ MEDINA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Antonio Jose de Sucre",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144763470",
      "client_email": "MAYRALEJANDRA22@GMAIL.COM",
      "address": "CALLE 25 DE AGOSTO, CASA NRO 13 URB ANTONIO JOSE DE SUCRE TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V14740962",
      "nap_box_name": "123",
      "created_at": "2024-04-19T13:40:51.900093",
      "service_detail": {
        "id": 3884,
        "ip": "172.18.179.2",
        "mac": "TPLGF4B1D5A0",
        "serial": "TPLGF4B1D5A0",
        "queue": "Plan_127988_1574_WispHub",
        "interface": "VLAN101_AJS",
        "created_at": "2024-07-16T17:24:02.143442",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3969,
      "client_name": "CANDIDA ROSA ALVAREZ PINTO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Santa Eduviges",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121308840",
      "client_email": "CANDIDAROSAALVAREZPINTO258@GMAIL.COM",
      "address": "CALLE NRO 2 CASA NRO 41 SECTOR SANTA EDUVIGES TURMERO ARAGUA ZONA POSTAL 2103",
      "client_identification": "V7268115",
      "nap_box_name": "CE - 523",
      "created_at": "2024-04-19T13:43:14.271799",
      "service_detail": {
        "id": 3344,
        "ip": "172.24.22.2",
        "mac": "TPLGB446ED6D",
        "serial": "TPLGB446ED6D",
        "queue": "Plan_138775_1574_WispHub",
        "interface": "VLAN127_SANTA_EDUVIGES",
        "created_at": "2024-07-02T16:03:06.259368",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3970,
      "client_name": "CARLOS EDUARDO DIAZ VILLANUEVA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Haras de San Pablo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243158178",
      "client_email": "CARLOS.DIAZVILLANUEVA@GMAIL.COM",
      "address": "CALLE SANCHEZ CARRERO EDIF LA PALMITA PISO 7 APT 7- B SECTOR CENTRO MARACAY ARAGUA ZONA POSTAL 2101",
      "client_identification": "V17570341",
      "nap_box_name": "248",
      "created_at": "2024-04-19T13:46:11.952754",
      "service_detail": {
        "id": 6246,
        "ip": "172.24.79.2",
        "mac": "TPLGB446F113",
        "serial": "TPLGB446F113",
        "queue": "Plan_129889_15811_WispHub",
        "interface": "VLAN210_HSP_OLT1",
        "created_at": "2024-08-23T13:14:01.715181",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3971,
      "client_name": "RICARDO ANTONIO RAMIREZ PARRA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Esperanza",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04123985907",
      "client_email": "ricardo.vico.09@gmail.com",
      "address": "CALLE 11 CASA NRO 13 URB LA ESPERANZA- EL MACARO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V19834606",
      "nap_box_name": "RESERVA 3 TRONCAL LA ESPERANZA",
      "created_at": "2024-04-19T13:49:30.013474",
      "service_detail": {
        "id": 3883,
        "ip": "172.24.84.2",
        "mac": "TPLGB446E8C1",
        "serial": "TPLGB446E8C1",
        "queue": "Plan_92034_1574_WispHub",
        "interface": "VLAN137_LA_ESPERANZA_OLT_ZTE",
        "created_at": "2024-07-16T17:21:39.516681",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3972,
      "client_name": "SIMON ANTONIO GUITE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona I Edificios",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04127098012",
      "client_email": "ALBENISGUITESP16@GMAIL.COM",
      "address": "CALLE PRINCIPAL EDIF D PISO 2 APT 4 LA CASONA 1",
      "client_identification": "V7539848",
      "nap_box_name": "CTO-0531",
      "created_at": "2024-04-19T13:51:12.256428",
      "service_detail": {
        "id": 3882,
        "ip": "172.24.89.2",
        "mac": "TPLGB446ECEB",
        "serial": "TPLGB446ECEB",
        "queue": "Plan_131647_24341_WispHub",
        "interface": "VLAN109_CASONA_1",
        "created_at": "2024-07-16T17:19:40.225556",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3973,
      "client_name": "NAIRETH JOSELIN ACOSTA RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Terrazas de Juan Pablo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243166584",
      "client_email": "NAY-10-NJAR@HOTMAIL.COM",
      "address": "CALLE LA LLANERA EDIF C PISO 02 APT C 02 URB TERRAZAS DE JUAN PABLO TURMERO ZONA POSTAL 2115",
      "client_identification": "V25464944",
      "nap_box_name": "12",
      "created_at": "2024-04-19T13:57:04.561844",
      "service_detail": {
        "id": 3881,
        "ip": "172.24.114.2",
        "mac": "TPLGF9620F83",
        "serial": "TPLGF9620F83",
        "queue": "Plan_131647_24341_WispHub",
        "interface": "VLAN130_TERRAZAS_JP",
        "created_at": "2024-07-16T17:17:49.627710",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3974,
      "client_name": "JOSETH EDUARDO ANGRIZONES SOLORZANO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128990251",
      "client_email": "Akiraangrinzones@gmail.com",
      "address": "EZEQUIEL ZAMORA TORRE 18 PISO 3 APTO 2",
      "client_identification": "V22287109",
      "nap_box_name": "CTO-00464 DOS",
      "created_at": "2024-04-19T14:05:25.384550",
      "service_detail": {
        "id": 9185,
        "ip": "172.24.124.2",
        "mac": "TPLGB444B5CA",
        "serial": "TPLGB444B5CA",
        "queue": "queue1",
        "interface": "VLAN209_ZAMORA_OLT1",
        "created_at": "2025-07-14T13:53:25.409013",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3975,
      "client_name": "LEYLA EVA NAVAS DE CALDERAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Plaza Jardin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144681935",
      "client_email": "ANERPINA80@GMAIL.COM",
      "address": "CALLE PARAISO CASA NRO 20 SECTOR LAS PALMAS TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V3846106",
      "nap_box_name": "445",
      "created_at": "2024-04-19T14:08:32.060508",
      "service_detail": {
        "id": 3879,
        "ip": "172.24.126.2",
        "mac": "TPLGB444B2C5",
        "serial": "TPLGB444B2C5",
        "queue": "Plan_131337_24341_WispHub",
        "interface": "VLAN141_PLAZA_JARDIN",
        "created_at": "2024-07-16T17:13:18.222390",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3976,
      "client_name": "KELYN JOHANA VALDERRAMA SANABRIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Concepcion",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128860154",
      "client_email": "KELYNVALDERRAMA316@GMAIL.COM",
      "address": "CALLE LA JULIA  EDIF 1 PISO 1 APT 4 URB NUESTRA SEÑORA DE LA CONCEPCION TURMERO ARAGUA ZONA POSTAL 2122",
      "client_identification": "V25314276",
      "nap_box_name": "623",
      "created_at": "2024-04-19T14:16:03.992903",
      "service_detail": {
        "id": 3878,
        "ip": "172.24.133.2",
        "mac": "TPLGB444B2C3",
        "serial": "TPLGB444B2C3",
        "queue": "queue1",
        "interface": "VLAN111_CONCEPCION",
        "created_at": "2024-07-16T17:09:48.227178",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3977,
      "client_name": "YRIAN JOSE LOPEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vista Hermosa",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243783837",
      "client_email": "YJOSELOPEZPSUV@GMAIL.COM",
      "address": "CALLE EL ROSARIO CASA NRO 51-A  SECTOR VISTA HERMOSA ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V20056626",
      "nap_box_name": "CTO-00058",
      "created_at": "2024-04-19T14:18:26.248630",
      "service_detail": {
        "id": 11981,
        "ip": "172.24.137.2",
        "mac": "TPLGB446F711",
        "serial": "TPLGB446F711",
        "queue": null,
        "interface": "VLAN230_VISTA_HERMOSA",
        "created_at": "2026-03-06T12:05:19.902297",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3978,
      "client_name": "ELVIS ALBERTO LUCENA MELENDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04125972232",
      "client_email": "ELVISLUCENA2021@GMAIL.COM",
      "address": "AV EL NISPERO EDIF TORRE19 PISO 1 APTO 4 URB EL NISPERO",
      "client_identification": "V170523276",
      "nap_box_name": "CTO-00464 DOS",
      "created_at": "2024-04-19T14:20:45.682366",
      "service_detail": {
        "id": 9986,
        "ip": "172.24.138.2",
        "mac": "TPLGB444A65C",
        "serial": "TPLGB444A65C",
        "queue": null,
        "interface": "VLAN209_ZAMORA_OLT1",
        "created_at": "2025-11-11T13:08:14.581945",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3979,
      "client_name": "PAOLA EVELYN SALAZAR DIAZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona II Edificios",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243521207",
      "client_email": "PAOLADANS04@GMAIL.COM",
      "address": "AV INTERCOMUNAL DE TURMERO EDIF TORRE 13 PISO 01 APT 02 SECTOR LA CASONA II TURMERO",
      "client_identification": "V19792861",
      "nap_box_name": "CTO-0539",
      "created_at": "2024-04-19T14:22:30.081836",
      "service_detail": {
        "id": 11776,
        "ip": "172.24.141.2",
        "mac": "TPLGB446E885",
        "serial": "TPLGB446E885",
        "queue": null,
        "interface": "VLAN110_CASONA_2",
        "created_at": "2026-02-27T10:45:47.536142",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3981,
      "client_name": "ARACELIS KARINA ARENAS RODRIGUE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Paya Abajo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243185096",
      "client_email": "INVERSIONESARG2019@GMAIL.COM",
      "address": "CALLE CAMPO ELIAS CASA NRO 06 SECTOR PAYA ABAJO ROSARIO DE PAYA ZONA POSTAL 2115",
      "client_identification": "V14944060",
      "nap_box_name": "CTO-00307",
      "created_at": "2024-04-19T14:30:29.891278",
      "service_detail": {
        "id": 7474,
        "ip": "172.24.145.2",
        "mac": "TPLGB446F57A",
        "serial": "TPLGB446F57A",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN231_PAYABAJO",
        "created_at": "2024-12-17T10:36:39.698653",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3982,
      "client_name": "MANUEL ENRIQUE LUGO ALECIO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124623967",
      "client_email": "MANUEL.LUGO.ALECIO@GMAIL.COM",
      "address": "CALLE 14 CASA NRO 72 URB LA CASONA II TURMERO ARAGUA  ZONA POSTAL 2115",
      "client_identification": "V25620592",
      "nap_box_name": "CTO-00120",
      "created_at": "2024-04-19T14:33:15.587575",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3983,
      "client_name": "HECTOR JOSE SANCHEZ SALAZAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Durpa",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243172324",
      "client_email": "HECTORHESZANCHEZ@GMAIL.COM",
      "address": "CALLE SIMON RODRIGUEZ MANZANA 15 CASA NRO 5 URB FUNDABARRIO ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V15991740",
      "nap_box_name": "382",
      "created_at": "2024-04-19T14:36:00.879429",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3984,
      "client_name": "JHONLERY JOSE COLORADO ESTRADA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ciudad Bendita",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144760146",
      "client_email": "JHONLERYHOMMY@GMAIL.COM",
      "address": "CALLE 1 CASA 15 BARRIO CIUDAD BENDITA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V25464727",
      "nap_box_name": "CE-00014",
      "created_at": "2024-04-19T14:40:53.186963",
      "service_detail": {
        "id": 3871,
        "ip": "172.24.158.2",
        "mac": "TPLGB446E95F",
        "serial": "TPLGB446E95F",
        "queue": "Plan_128612_15811_WispHub",
        "interface": "VLAN249_CBENDITA_OLT2",
        "created_at": "2024-07-16T15:22:00.410055",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3985,
      "client_name": "YOMIKA DEL VALLE APONTE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Los Hornos",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04129233475",
      "client_email": "YAPONTE272@GMAIL.COM",
      "address": "CALLE LOS MANGOS CASA NRO 8 SECTOR LOS HORNOS DE PAYA ROSARIO DE PAYA  ARAGUA ZONA POSTAL 2115",
      "client_identification": "V15819719",
      "nap_box_name": "437",
      "created_at": "2024-04-19T14:43:11.196284",
      "service_detail": {
        "id": 8674,
        "ip": "172.24.159.2",
        "mac": "TPLGB446EA8A",
        "serial": "TPLGB446EA8A",
        "queue": "queue1",
        "interface": "VLAN247_HORNOS",
        "created_at": "2025-05-16T17:57:28.645085",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3986,
      "client_name": "ANGIS JOSEFINA DURAN REVOLLEDO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Esperanza",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128457747",
      "client_email": "HARYANGI@HOTMAIL.COM",
      "address": "CALLE NRO 19 CASA NRO 30 URB LA ESPERANZA EL MACARO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V13575970",
      "nap_box_name": "555",
      "created_at": "2024-04-19T14:45:30.176746",
      "service_detail": {
        "id": 9898,
        "ip": "172.24.160.2",
        "mac": "TPLGB446E8EE",
        "serial": "TPLGB446E8EE",
        "queue": null,
        "interface": "VLAN137_LA_ESPERANZA_OLT_ZTE",
        "created_at": "2025-11-10T22:09:25.482037",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3987,
      "client_name": "MARIA GABRIELA CASTILLO  ARRAIZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04241323438",
      "client_email": "MARIACASTILLO666717@GMAIL.COM",
      "address": "CALLE 9 CASA NRO 606  URB MATA CABALLO ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V30956236",
      "nap_box_name": "222",
      "created_at": "2024-04-19T14:48:34.487624",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3988,
      "client_name": "CARMEN SOCORRO FERNANDEZ LEON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128842866",
      "client_email": "LUIS41061@GMAIL.COM",
      "address": "VDA 5-E MANZANA  F1 CASA NRO 9 SECTOR SAMAN TARAZONERO I EL MACARO TURMERO EDO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V12767346",
      "nap_box_name": "112",
      "created_at": "2024-04-19T14:52:06.375384",
      "service_detail": {
        "id": 3440,
        "ip": "172.17.137.2",
        "mac": "TPLGB444B237",
        "serial": "TPLGB444B237",
        "queue": "Plan_92034_1574_WispHub",
        "interface": "VLAN100_OLTs",
        "created_at": "2024-07-04T13:38:55.262705",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3989,
      "client_name": "ARMANDO GREGORIO DE CAMPOS MEDINA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Concepcion",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04165168329",
      "client_email": "ELPROFEFISICA@HOTMAIL.COM",
      "address": "AV PRINCIPAL EDIF 03 PISO 1 APT 0105 URB LA CONCEPCION 19 DE ABRIL ARAGUA ZONA POSTAL 2115",
      "client_identification": "V7215066",
      "nap_box_name": "623",
      "created_at": "2024-04-19T14:53:57.578374",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3990,
      "client_name": "VERONICA MERCEDES GARCIA REYES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Arturo Luis Berti",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243718452",
      "client_email": "mercedeslacuerpa@gmail.com",
      "address": "CALLE 03 CASA NRO 401 URB ARTURO LUIS BERTI EL MACARO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V9526487",
      "nap_box_name": "65",
      "created_at": "2024-04-20T08:11:24.589162",
      "service_detail": {
        "id": 3401,
        "ip": "172.24.171.2",
        "mac": "TPLGB444B5C6",
        "serial": "TPLGB444B5C6",
        "queue": "Plan_92034_1574_WispHub",
        "interface": "VLAN102_ARTURO_BERTI",
        "created_at": "2024-07-03T10:11:24.925158",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3991,
      "client_name": "ANGEL RAMON RIOS GONZALEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Durpa",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243189577",
      "client_email": "RIOSA5462@GMAIL.COM",
      "address": "CALLE LOS CAOBOS CASA 03 MANZANA 18 SECTOR DESARROLLO URBANISTICO ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V28456193",
      "nap_box_name": "392",
      "created_at": "2024-04-20T08:14:08.964447",
      "service_detail": {
        "id": 3805,
        "ip": "172.24.173.2",
        "mac": "TPLGB444B49B",
        "serial": "TPLGB444B49B",
        "queue": "Plan_161903_30183_WispHub",
        "interface": "VLAN240_DURPA",
        "created_at": "2024-07-15T16:18:14.028509",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3992,
      "client_name": "DEISIS YELISMAR MANRIQUE PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona II Edificios",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04120603132",
      "client_email": "DEISISYMANRIQUET@GMAIL.COM",
      "address": "CALLE PRINCIPAL EDIF PRIMAVERA  B9 PISO 3 APTO 01 SECTOR CASONA II TURMERO",
      "client_identification": "V14565335",
      "nap_box_name": "CTO-0536",
      "created_at": "2024-04-20T08:16:27.605218",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3993,
      "client_name": "ODALIS DEL CARMEN BENAVIDES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Magdalena",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243114009",
      "client_email": "odalisjaon@GMAIL.COM",
      "address": "La Magdalena Calle 23 Casa Nro 13 Turmero",
      "client_identification": "V12635608",
      "nap_box_name": "CAJA NAP CLIENTES C/23 LA MAGDALENA",
      "created_at": "2024-04-20T08:23:53.336640",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3994,
      "client_name": "JENNY MILAGROS DEL CARMEN RODRIGUEZ VILLASMIL",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243276255",
      "client_email": "YMRV.RVYM@GMAIL.COM",
      "address": "CALLE 06 CASA NRO 464 SECTOR MATA CABALLO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V18778594",
      "nap_box_name": "CTO-00178",
      "created_at": "2024-04-20T08:26:19.747234",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3995,
      "client_name": "FREIDDER JHOSUE LANDA AVILA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124001695",
      "client_email": "FREIDDERLANDA09@GMAIL.COM",
      "address": "CALLE PRINCIPAL MANZANA I-1 CASA NRO 12 URB SAMAN TARAZONERO II TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V30045608",
      "nap_box_name": "511",
      "created_at": "2024-04-20T08:28:48.897947",
      "service_detail": {
        "id": 3804,
        "ip": "172.24.181.2",
        "mac": "TPLGF4B1D5CE",
        "serial": "TPLGF4B1D5CE",
        "queue": "Plan_137413_1574_WispHub",
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2024-07-15T16:09:54.711461",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3996,
      "client_name": "MARIA JOSE MORA MENDOZA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "San Pablo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243298394",
      "client_email": "MORJOSE.0211@GMAIL.COM",
      "address": "AV NRO3 CASA 16 MANZANA NRO 1 URB SAN PABLO TURMERO EDO. ARAGUA ZONA POSTAL 2115",
      "client_identification": "V26213260",
      "nap_box_name": "CTO-0637",
      "created_at": "2024-04-20T08:35:38.003761",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 3997,
      "client_name": "LUIS DANIEL VERENZUELA ASCANIO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Isaac Oliveira",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243385906",
      "client_email": "LOISVE20@HOTMAIL.COM",
      "address": "CALLE 02 CASA NRO 79 URB ISAAC OLIVERA SECTOR LA JULIA TURMERO EDO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V8195802",
      "nap_box_name": "CTO-00262",
      "created_at": "2024-04-20T08:37:31.190973",
      "service_detail": {
        "id": 11818,
        "ip": "172.17.127.2",
        "mac": "TPLGB444B5C9",
        "serial": "TPLGB444B5C9",
        "queue": null,
        "interface": "VLAN107_ISAAC_O",
        "created_at": "2026-02-27T11:46:01.498174",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3998,
      "client_name": "LUIS ENRIQUE RIVERO TIRRE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243081386",
      "client_email": "LUISENRI132@GMAIL.COM",
      "address": "CALLE 05 CASA NRO357 SECTOR MATA CABALLO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V18164125",
      "nap_box_name": "CTO-00179",
      "created_at": "2024-04-20T08:42:18.117119",
      "service_detail": {
        "id": 3419,
        "ip": "172.24.182.2",
        "mac": "TPLGB444B2AD",
        "serial": "TPLGB444B2AD",
        "queue": "Plan_161903_30183_WispHub",
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2024-07-03T14:10:53.764917",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 3999,
      "client_name": "VERONICA ALEJANDRA GARCIA VIVAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Palma Real",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243222048",
      "client_email": "LEONASSS.VGAR.2903@GMAIL.COM",
      "address": "AV PRINCIPAL CASA NRO 53 SECTOR PALMA REAL ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V17569888",
      "nap_box_name": "CTO-00208",
      "created_at": "2024-04-20T08:44:26.285783",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4000,
      "client_name": "CARLOS GABRIEL LANZA LIENDO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Santa Eduviges",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04123983437",
      "client_email": "CARMENLIENDO74@GMAIL.COM",
      "address": "CALLLE PRINCIPAL CASA NRO 33 SECTOR SANTA EDUVIGES TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V29502813",
      "nap_box_name": "CE - 523",
      "created_at": "2024-04-20T08:48:24.600172",
      "service_detail": {
        "id": 3473,
        "ip": "172.19.89.2",
        "mac": "TPLGB444AA15",
        "serial": "TPLGB444AA15",
        "queue": "Plan_129887_1574_WispHub",
        "interface": "VLAN127_SANTA_EDUVIGES",
        "created_at": "2024-07-04T18:07:18.856747",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4001,
      "client_name": "JAVIER ANTONIO ALFARO DELGADO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144509028",
      "client_email": "FRAMKMAD@GMAIL.COM",
      "address": "AV2 CASA NRO 498 URB MATA CABALLO ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V27286587",
      "nap_box_name": "CTO-00457",
      "created_at": "2024-04-20T08:51:30.428851",
      "service_detail": {
        "id": 3795,
        "ip": "172.27.253.2",
        "mac": "TPLGB446EE0B",
        "serial": "TPLGB446EE0B",
        "queue": "Plan_161903_30183_WispHub",
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2024-07-15T13:46:19.162852",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4002,
      "client_name": "JHONDER JOEL GONZALEZ ZAPATA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Guanarito",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121485293",
      "client_email": "JHONDERJOELGONZALEZ@GMAIL.COM",
      "address": "CALLE LOS NARANJOS CASA NRO 7 SECTOR GUANARITO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V26791875",
      "nap_box_name": "CTO-00214",
      "created_at": "2024-04-20T08:53:54.687309",
      "service_detail": {
        "id": 3359,
        "ip": "172.20.66.2",
        "mac": "TPLGB444A692",
        "serial": "TPLGB444A692",
        "queue": "Plan_92306_15811_WispHub",
        "interface": "VLAN232_GUANARITO_OLT2",
        "created_at": "2024-07-02T16:41:56.058862",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4003,
      "client_name": "NAIRYCH ALEJANDRA LEON HEREDIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128896239",
      "client_email": "NAIRYCHHEREDIA@GMAIL.COM",
      "address": "CALLE 1-B CASA NRO 34 URB PANTIN ROSARIO DE PAYA",
      "client_identification": "V25895150",
      "nap_box_name": "CTO-00127",
      "created_at": "2024-04-20T08:56:08.031470",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4004,
      "client_name": "ADIM ARMANDO MENDEZ PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128661646",
      "client_email": "ARMANDOMENDEZ_12@HOTMAIL.COM",
      "address": "CALLE CALLEJON 5 CASA NRO PARCELA 13 SECTOR PRADOS DE PAYA II ARAGUA ZONA POSTAL 2115",
      "client_identification": "V26535726",
      "nap_box_name": "CTO-00205",
      "created_at": "2024-04-20T08:58:45.604560",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4005,
      "client_name": "JOSE ANDRES GARCIA LOBO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124520936",
      "client_email": "BARRETOSORANGEL664@GMAIL.COM",
      "address": "VDA MANZANA F 2 CASA NRO 9 SECTOR SAMAN TARAZONERO 2 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V18490171",
      "nap_box_name": "162",
      "created_at": "2024-04-20T09:00:50.044796",
      "service_detail": {
        "id": 3459,
        "ip": "172.20.255.2",
        "mac": "TPLGB446F05D",
        "serial": "TPLGB446F05D",
        "queue": "Plan_127744_1574_WispHub",
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2024-07-04T17:07:11.114268",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4007,
      "client_name": "YMELDA MARGARITA LORCAS LA ROSA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04264322136",
      "client_email": "YMELDALORCAS.64@GMAIL.COM",
      "address": "CALLE CAMILO TORRES EDIF EDIFICIO 4 PISO 3 APT NO. 16 CONJUNTO RESIDENCIAL RESIDENCIAS TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V87305712",
      "nap_box_name": "CTO-0647",
      "created_at": "2024-04-20T09:06:47.320424",
      "service_detail": {
        "id": 6241,
        "ip": "172.27.228.2",
        "mac": "TPLGB444AF8D",
        "serial": "TPLGB444AF8D",
        "queue": "Plan_129889_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-08-23T12:30:16.392405",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4008,
      "client_name": "JESUS SALVADOR VARGAS DUARTE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Terrazas de Juan Pablo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144879381",
      "client_email": "JESUSCPA14@GMAIL.COM",
      "address": "CALLE LA LLANERA URB TERRAZAS DE JUAN PABLO APTO A-11 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V30161667",
      "nap_box_name": "13",
      "created_at": "2024-04-20T09:08:47.632771",
      "service_detail": {
        "id": 6706,
        "ip": "172.24.184.2",
        "mac": "TPLGB444B5D1",
        "serial": "TPLGB444B5D1",
        "queue": "Plan_131337_24341_WispHub",
        "interface": "VLAN130_TERRAZAS_JP",
        "created_at": "2024-09-18T16:10:19.383371",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4009,
      "client_name": "KELY TERESA FERNANDEZ FEO GUARDIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243360279",
      "client_email": "KELYFERNANDEZ15@GMAIL.COM",
      "address": "CALLE D CASA NRO A-2 URB SAN PABLO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V27520096",
      "nap_box_name": "282",
      "created_at": "2024-04-20T09:12:22.848953",
      "service_detail": {
        "id": 6240,
        "ip": "172.24.185.2",
        "mac": "TPLGB446EB83",
        "serial": "TPLGB446EB83",
        "queue": "Plan_128612_15811_WispHub",
        "interface": "VLAN223_SAN_CARLOS_OLT1",
        "created_at": "2024-08-23T12:27:40.148543",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4010,
      "client_name": "JOSSELINE VERONICA LINARES RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "San Carlos",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243382450",
      "client_email": "SALAZAR.CARLOSARTURO@GMAIL.COM",
      "address": "CALLE CEDEÑO QTA LA ESTANCIA URB SAN CARLOS TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V16436797",
      "nap_box_name": "CTO-0441",
      "created_at": "2024-04-20T09:29:26.220391",
      "service_detail": {
        "id": 3703,
        "ip": "172.24.186.2",
        "mac": "TPLGB444B4CD",
        "serial": "TPLGB444B4CD",
        "queue": "Plan_129889_15811_WispHub",
        "interface": "VLAN223_SAN_CARLOS_OLT1",
        "created_at": "2024-07-11T21:17:37.033198",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4011,
      "client_name": "WILMARA EVERLYN MACHADO DIAZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124153864",
      "client_email": "WILMARAMACHADO75@GMAIL.COM",
      "address": "CALLE 06 CAS NRO 422-B MATA CABALLO ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V12338495",
      "nap_box_name": "CTO-00031",
      "created_at": "2024-04-20T09:32:49.242089",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4012,
      "client_name": "DILIA PASTORA RIVERO ROJAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144503077",
      "client_email": "RIVEROARIBETH@GMAIL.COM",
      "address": "CALLE 11 CASA NRO 18 URB PRADOS DE PAYA I TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V7323924",
      "nap_box_name": "CTO-00204 DOS",
      "created_at": "2024-04-20T09:34:54.285625",
      "service_detail": {
        "id": 3172,
        "ip": "172.24.189.2",
        "mac": "TPLGB446E969",
        "serial": "TPLGB446E969",
        "queue": "Plan_161903_30183_WispHub",
        "interface": "VLAN239_PRADOS1",
        "created_at": "2024-06-27T16:37:43.967944",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4013,
      "client_name": "VICTOR MANUEL DIAZ ALONZO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Magdalena",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04269319142",
      "client_email": "VICTORDIAZALONZO@GMAIL.COM",
      "address": "CALLE 19 CASA NRO 21 URB LA MAGDALENA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V19123573",
      "nap_box_name": "394",
      "created_at": "2024-04-20T09:37:25.936157",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4014,
      "client_name": "LUZ MARIA FERNANDA RODRIGUEZ VÁSQUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Macaro",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124571142",
      "client_email": "LUZMARIAFERNANDA81@GMAIL.COM",
      "address": "CALLE 03 Nº 18 URB VILLAS  EL CARMEN SECTOR EL MACARO, TURMERO ESTADO ARAGUA",
      "client_identification": "V19469472",
      "nap_box_name": "49",
      "created_at": "2024-04-20T09:42:19.915394",
      "service_detail": {
        "id": 2932,
        "ip": "172.17.18.2",
        "mac": "TPLGB954EB06",
        "serial": "TPLGB954EB06",
        "queue": "Plan_92139_1574_WispHub",
        "interface": "VLAN135_VILLAS_CARMEN",
        "created_at": "2024-06-19T18:49:23.440983",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4015,
      "client_name": "MARIA ELENA GIBBS AMAIZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villas El Carmen",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04168460003",
      "client_email": "MARIANDRES08@HOTMAIL.COM",
      "address": "URBANIZACIÓN VILLAS EL CARMEN CALLE 3 NRO 14 SECTOR EL MACARO TURMERO ESTADO  ARAGUA",
      "client_identification": "V7164040",
      "nap_box_name": "50",
      "created_at": "2024-04-20T09:46:51.984985",
      "service_detail": {
        "id": 3362,
        "ip": "172.17.20.2",
        "mac": "TPLG2ABDC646",
        "serial": "TPLG2ABDC646",
        "queue": "Plan_141349_1574_WispHub",
        "interface": "VLAN135_VILLAS_CARMEN_OLT_ZTE",
        "created_at": "2024-07-02T16:48:55.699681",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4016,
      "client_name": "MARIANNYS JOSE ROMERO RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Concepcion",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121462702",
      "client_email": "MARIANNYSZZ.MR@GMAIL.COM",
      "address": "URBANISMO NUESTRA SEÑORA DE LA CONCEPCION TORRE 9 PISO 03 APARTAMENTO 07 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V23789585",
      "nap_box_name": "0325 DOS",
      "created_at": "2024-04-20T09:47:24.592650",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4017,
      "client_name": "MARIA EULOGIA TORRES SIMANCAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Bicentenario",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04145980450",
      "client_email": "SIMANCAS60MARIA@GMAIL.COM",
      "address": "CALLE LOS ROBLES CASA MANZANA 10 NRO 13 PB URB DESARROLLO URBANISTICO ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V9322799",
      "nap_box_name": "CTO-00445",
      "created_at": "2024-04-20T09:49:39.364572",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4018,
      "client_name": "DALIA MARILI IBANEZ TERAN",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Paraiso",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121401628",
      "client_email": "DALIAIT@HOTMAIL.COM",
      "address": "CALLE LA FE CALLE 1 CASA NRO 17 URB EL PARAISO SECTOR EL MACARO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V14087451",
      "nap_box_name": "346",
      "created_at": "2024-04-20T09:51:44.934940",
      "service_detail": {
        "id": 6236,
        "ip": "172.24.196.2",
        "mac": "TPLGB446F082",
        "serial": "TPLGB446F082",
        "queue": "Plan_137413_1574_WispHub",
        "interface": "VLAN105_EL_PARAISO",
        "created_at": "2024-08-23T12:14:46.201424",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4019,
      "client_name": "DANIEL GREGORIO CHINEA GONZALEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villas El Carmen",
      "plan": {
        "id": 16,
        "name": "RECURRENTE RESIDENCIAL PLAN 800M",
        "cost": "55.00",
        "code": "FOR800",
        "profile": "800M/800M"
      },
      "client_mobile": "04127989587",
      "client_email": "CHINEAHERNAN@GMAIL.COM",
      "address": "CALLLE 03 Nº 07 URB VILLAS EL CARMEN SECTOR EL MACARO, TURMERO ESTADO ARAGUA",
      "client_identification": "V8743938",
      "nap_box_name": "49",
      "created_at": "2024-04-20T09:51:50.936734",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4021,
      "client_name": "MIGUEL ANTONIO LOPEZ PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243115768",
      "client_email": "MILOGAMA.90@GMAIL.COM",
      "address": "CALLE EL CENTRO CASA NRO 22 SECTOR PUEBLO NUEVO, TURMERO EDO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V16268811",
      "nap_box_name": "CTO-0172",
      "created_at": "2024-04-20T09:56:09.861576",
      "service_detail": {
        "id": 3579,
        "ip": "172.24.198.2",
        "mac": "TPLGB446F91C",
        "serial": "TPLGB446F91C",
        "queue": "Plan_129889_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-07-09T14:08:40.659040",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4022,
      "client_name": "DIANA RAQUEL VARELA CONTRERAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Salto Angel",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243172211",
      "client_email": "DIANAVARELA3056@GMAIL.COM",
      "address": "CALLE LOS PINOS MANZANA 4 CASA NRO 38 URB SALTO ANGEL TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V18419285",
      "nap_box_name": "256",
      "created_at": "2024-04-20T09:59:44.741812",
      "service_detail": {
        "id": 6235,
        "ip": "172.24.199.2",
        "mac": "TPLGB446F09B",
        "serial": "TPLGB446F09B",
        "queue": "Plan_131337_24341_WispHub",
        "interface": "VLAN121_S_ANGEL",
        "created_at": "2024-08-23T12:11:55.513524",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4023,
      "client_name": "JOEL ALBERTO MARTINEZ PERERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Los Hornos",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121460907",
      "client_email": "YOELM3398@GMAIL.COM",
      "address": "CALLE LOS MANGOS CASA 17 SECTOR LOS HORNOS DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V15818382",
      "nap_box_name": "437",
      "created_at": "2024-04-20T10:01:54.481768",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4024,
      "client_name": "OLGA LIDIA ALVAREZ SARMIENTO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Arturo Luis Berti",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04127773291",
      "client_email": "LIDIAYOSELINPENA@GMAIL.COM",
      "address": "CALLE MORALES CASA NRO 383 URB ARTURO LUIS BERTI EL MACARO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V5279777",
      "nap_box_name": "543",
      "created_at": "2024-04-20T10:03:48.091894",
      "service_detail": {
        "id": 4310,
        "ip": "172.24.201.2",
        "mac": "TPLGB446F935",
        "serial": "TPLGB446F935",
        "queue": "Plan_137413_1574_WispHub",
        "interface": "VLAN102_ARTURO_BERTI",
        "created_at": "2024-08-09T08:39:17.247528",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4025,
      "client_name": "ALICIA CRISTINA SANCHEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Bicentenario",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243188139",
      "client_email": "7244ALICIA@GMAIL.COM",
      "address": "CALLE FRANCISCO DE MIRANDA CASA NRO 27 URB DESARROLLO URBANISTICO ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V7244059",
      "nap_box_name": "389",
      "created_at": "2024-04-20T10:06:24.630060",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4026,
      "client_name": "JOSE EGLICELIO MATOS PACHECO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Guanarito",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121591733",
      "client_email": "JOSEEGLICELIO@GMAIL.COM",
      "address": "CALLE PEÑALVER CASA NRO 64 SECTOR GUANARITO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V11976744",
      "nap_box_name": "447",
      "created_at": "2024-04-20T10:10:01.478084",
      "service_detail": {
        "id": 6233,
        "ip": "172.24.204.2",
        "mac": "TPLGB446F91D",
        "serial": "TPLGB446F91D",
        "queue": "Plan_153953_15811_WispHub",
        "interface": "VLAN232_GUANARITO_OLT2",
        "created_at": "2024-08-23T12:02:23.755612",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4027,
      "client_name": "MARIA ISABEL YEPEZ MONTILLA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Palma Real",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121492439",
      "client_email": "MYEPEZMONTILLA@GMAIL.COM",
      "address": "CALLE 2 CASA NRO 16 SECTOR PALMA REAL ROSARIO DE PAYA TURMERO ZONA POSTAL 2115",
      "client_identification": "V18490366",
      "nap_box_name": "CTO-00318",
      "created_at": "2024-04-20T10:12:08.303000",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4028,
      "client_name": "GLENDA CAROLINA CHIRINOS MOLINA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villas El Carmen",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243314564",
      "client_email": "GLENDAYCC@HOTMAIL.COM",
      "address": "CALLE 10 Nº 12 URB VILLAS EL CARMEN SECTOR EL MACARO, TURMERO ESTADO ARAGUA",
      "client_identification": "V13262807",
      "nap_box_name": "41",
      "created_at": "2024-04-20T10:13:02.445204",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4029,
      "client_name": "ISMERLY LUISANA CARMONA CARTE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "SUSPENDIDO_RESIDENCIAL",
      "status_name": "Suspendido",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Palma Real",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04129673181",
      "client_email": "ISMERLYCARMONA66@GMAIL.COM",
      "address": "CALLE LOS PORTUGUESES CASA NRO 3 SECTOR LA CABALLERIZA ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V25443366",
      "nap_box_name": "CE - 535",
      "created_at": "2024-04-20T10:27:52.917717",
      "service_detail": {
        "id": 6251,
        "ip": "172.24.207.2",
        "mac": "TPLGB446F911",
        "serial": "TPLGB446F911",
        "queue": "Plan_161873_30181_WispHub",
        "interface": "VLAN244_PALMAREAL",
        "created_at": "2024-08-23T14:23:22.434384",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4030,
      "client_name": "DIEGO ORLANDO PERNIA OJEDA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128905781",
      "client_email": "AIDNISKEVINJATNIEL@GMAIL.COM",
      "address": "VDA SAMAN TARAZONERO II CASA NRO 9 URB EL MACARO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V22298301",
      "nap_box_name": "163",
      "created_at": "2024-04-20T10:30:53.094029",
      "service_detail": {
        "id": 11555,
        "ip": "172.24.208.2",
        "mac": "TPLGB446E96C",
        "serial": "TPLGB446E96C",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2026-02-09T09:32:46.867117",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4031,
      "client_name": "FABIOLA NUNEZ MEJIAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Palma Real",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04127013714",
      "client_email": "FABIOLANMEJIAS@GMAIL.COM",
      "address": "CALLE PRINCIPAL CASA NRO 55 URB PALMA REAL II ROSARIO DE PÄYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V30906320",
      "nap_box_name": "CTO-00391",
      "created_at": "2024-04-20T10:33:12.078092",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4032,
      "client_name": "JUSMELY NOHELLY RODRIGUEZ CORDERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Canaima",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144494791",
      "client_email": "JUSMELY0702@GMAIL.COM",
      "address": "CALLE 1 CASA NRO 7 URB CANAIMA ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V23524502",
      "nap_box_name": "CTO-00172 ",
      "created_at": "2024-04-20T10:35:41.297265",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4033,
      "client_name": "ROSA ANDREINA OCHOA MOYETON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04140484881",
      "client_email": "ANDREINAHT@HOTMAIL.COM",
      "address": "CALLE CARREÑO CASA NRO 51 SECTOR CENTRO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V19004769",
      "nap_box_name": "184 DOS",
      "created_at": "2024-04-20T10:40:52.345267",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4034,
      "client_name": "ISIDRO JOSE ACEVEDO ACOSTA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Paya Abajo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04127761974",
      "client_email": "ISIDROACEVEDO13@GMAIL.COM",
      "address": "CALLE SAN ANTONIO CASA NRO 15 SECTOR PAYA ABAJO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V13200733",
      "nap_box_name": "271",
      "created_at": "2024-04-20T10:44:05.724098",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4035,
      "client_name": "BALBINA RAMONA CORTEZ HERRERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04120487740",
      "client_email": "BALBYCORTEZZZ123@GMAIL.COM",
      "address": "CALLE 1 CASA NRO 70 SECTOR PRADOS DE PAYA II TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V11180389",
      "nap_box_name": "584",
      "created_at": "2024-04-20T10:46:33.226338",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4036,
      "client_name": "NOIRA NACARID APONTE LOMBANO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04143371227",
      "client_email": "APONTENAKARY34@GMAIL.COM",
      "address": "CALLE 7, CASA NRO 09 SECTOR LA CASONA I SAMAN DE GUERE TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V13115921",
      "nap_box_name": "410",
      "created_at": "2024-04-20T10:49:49.162951",
      "service_detail": {
        "id": 6227,
        "ip": "172.24.216.2",
        "mac": "TPLGB446F342",
        "serial": "TPLGB446F342",
        "queue": "Plan_131337_24341_WispHub",
        "interface": "VLAN109_CASONA_1",
        "created_at": "2024-08-23T11:28:41.067704",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4037,
      "client_name": "LILIA MARIA SOLORZANO DE CONTRERAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243294066",
      "client_email": "LILIAMARIADECONTRERAS@GMAIL.COM",
      "address": "CALLE 9 CASA TETRA NRO 592 C URB MATA CABALLO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V3513546",
      "nap_box_name": "CE - 566",
      "created_at": "2024-04-20T10:52:35.420358",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4038,
      "client_name": "GENOVA YETZABEL HERNANDEZ SUAREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128497098",
      "client_email": "GENOVAHERNANDEZ5@GMAIL.COM",
      "address": "CALLE 1 CASA NRO 34 SECTOR PRADO II TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V25841473",
      "nap_box_name": "CTO-00118 DOS",
      "created_at": "2024-04-20T10:55:40.073080",
      "service_detail": {
        "id": 6226,
        "ip": "172.30.74.2",
        "mac": "TPLGB446F929",
        "serial": "TPLGB446F929",
        "queue": "Plan_161904_30183_WispHub",
        "interface": "VLAN242_PRADOS2",
        "created_at": "2024-08-23T11:26:23.019909",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4039,
      "client_name": "FENG CHAOQUIANG",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "San Pablo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243432156",
      "client_email": "DISOFILEZ@GMAIL.COM",
      "address": "CALLE PRINCIPAL MANZANA 9 CASA NRO 19 URB SAN PABLO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V16776107",
      "nap_box_name": "141",
      "created_at": "2024-04-20T10:58:05.193208",
      "service_detail": {
        "id": 5326,
        "ip": "172.24.222.2",
        "mac": "TPLGB446E90F",
        "serial": "TPLGB446E90F",
        "queue": "Plan_147201_15811_WispHub",
        "interface": "VLAN224_SAN_PABLO_OLT1",
        "created_at": "2024-08-16T09:19:03.782933",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4040,
      "client_name": "DOUGLAS JOSE PENALVER BERBESI",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona I Edificios",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243687382",
      "client_email": "DOUGLAS-PENALVER@HOTMAIL.COM",
      "address": "AV INTERCOMUNAL TURMERO EDIF C-5 PISO PLANTA BAJA APTO 2 CONJUNTO RESIDENCIAL CASONA I TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V19949012",
      "nap_box_name": "CTO-0530",
      "created_at": "2024-04-20T11:06:06.885508",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4042,
      "client_name": "JOSE ANGEL NATERA MONTESINOS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona I Edificios",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124611422",
      "client_email": "JOSEANGELNATERA@HOTMAIL.COM",
      "address": "AV. INTERCOMUNAL TURMERO MARACAY EDIF NORTE TORRE 6-B APTO 3 LA CASONA I TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V16436507",
      "nap_box_name": "CTO-0529",
      "created_at": "2024-04-20T11:13:48.266464",
      "service_detail": {
        "id": 6213,
        "ip": "172.24.227.2",
        "mac": "TPLGB446EC68",
        "serial": "TPLGB446EC68",
        "queue": "Plan_131337_24341_WispHub",
        "interface": "VLAN109_CASONA_1",
        "created_at": "2024-08-23T10:28:45.939926",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4043,
      "client_name": "GIL AUGUSTO GUZMAN BARRIOS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04125986968",
      "client_email": "FLORCOROMOTOHERNANDEZCASTILLO@GMAIL.COM",
      "address": "CALLE 06 CASA NRO 17 SECTOR PRADOS DE PAYA 1 ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V7221332",
      "nap_box_name": "CTO-00298",
      "created_at": "2024-04-20T11:16:19.803270",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4044,
      "client_name": "YENDER DURAN CHACON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Jabillar",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144558867",
      "client_email": "YENDERD@HOTMAIL.COM",
      "address": "CALLE CHAGUARAMOS CASA NRO 09-16 URB JABILLAR TURMEOR ARAGUA",
      "client_identification": "V12568362",
      "nap_box_name": "CTO-00005",
      "created_at": "2024-04-20T11:19:43.244771",
      "service_detail": {
        "id": 10798,
        "ip": "172.17.194.2",
        "mac": "TPLG1BB36369",
        "serial": "TPLG1BB36369",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2025-12-18T10:23:25.665847",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4045,
      "client_name": "MARINA ISABEL BARROSO VERDE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "SUSPENDIDO_RESIDENCIAL",
      "status_name": "Suspendido",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Jabillar",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04122935135",
      "client_email": "MARINABARROSO1965@GMAIL.COM",
      "address": "CALLE LOS CHAGUARAMOS CASA NRO 09-04 URB JABILLAR TOW COUNTRIS CONDOMINIO 09 TURMERO ARAGUA",
      "client_identification": "V6928403",
      "nap_box_name": "CTO-00005",
      "created_at": "2024-04-20T11:21:43.067173",
      "service_detail": {
        "id": 10779,
        "ip": "172.25.88.2",
        "mac": "TPLG1BB3649F",
        "serial": "TPLG1BB3649F",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2025-12-17T15:54:37.395949",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4046,
      "client_name": "MARISABEL RODRIGUEZ PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Jabillar",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128873096",
      "client_email": "RMARISABEL40@GMAIL.COM",
      "address": "CALLE APAMATES CASA NRO 01-16 URB. JABILLAR TOWN COUNTRY TURMERO ARAGUA",
      "client_identification": "V7294765",
      "nap_box_name": "CTO-0071",
      "created_at": "2024-04-20T11:25:51.173440",
      "service_detail": {
        "id": 6040,
        "ip": "172.17.191.2",
        "mac": "TPLG1BB36395",
        "serial": "TPLG1BB36395",
        "queue": "Plan_127744_1574_WispHub",
        "interface": "VLAN108_JABILLAR_OLT_ZTE",
        "created_at": "2024-08-22T11:48:35.725025",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4047,
      "client_name": "JHONNY BREYKER CORDOBA CHACIN",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Jabillar",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04142908636",
      "client_email": "JHONNY.CORDOBA@GMAIL.COM",
      "address": "CALLE PALO SANTO NRO 17 CASA 17-09 URBANIZACIÓN JABILLAR TURMERO",
      "client_identification": "V63405414",
      "nap_box_name": "CTO-00015",
      "created_at": "2024-04-20T11:29:12.767117",
      "service_detail": {
        "id": 10869,
        "ip": "10.15.139.2",
        "mac": "TPLG1BB364F9",
        "serial": "TPLG1BB364F9",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2025-12-22T15:36:07.877476",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4049,
      "client_name": "VICTOR JULIO MATOS ACIEGO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Jabillar",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04164479740",
      "client_email": "ANGELAPLATA2810@gmail.com",
      "address": "CALLE 2 CASA NRO 2 URB CONJUNTO RESIDENCIAL JABILLAR EL MACARO TURMERO EDO ARAGUA",
      "client_identification": "V9437687",
      "nap_box_name": "CTO-0063",
      "created_at": "2024-04-20T11:37:21.748515",
      "service_detail": {
        "id": 10752,
        "ip": "172.28.54.2",
        "mac": "TPLGC3CCB7E6",
        "serial": "TPLGC3CCB7E6",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2025-12-16T16:10:12.893421",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4050,
      "client_name": "JUAN JOSE RIZO NEGRIN",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Jabillar",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128661260",
      "client_email": "MILENAADZIA43@GMAIL.COM",
      "address": "AV EL CARDON CASA NRO 13 CONJUNTO RESIDENCIAL JABILLAR TURMERO ARAGUA",
      "client_identification": "V7193625",
      "nap_box_name": "CTO-00004",
      "created_at": "2024-04-20T11:38:33.257427",
      "service_detail": {
        "id": 10664,
        "ip": "172.25.89.2",
        "mac": "TPLG1BB364AC",
        "serial": "TPLG1BB364AC",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2025-12-11T17:02:42.410873",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4052,
      "client_name": "FRANKLIN JOSE BOYER ESTRADA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Jabillar",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144875672",
      "client_email": "NIULKACORREDOR3@GMAIL.COM",
      "address": "CALLE CARDON CASA NRO 07 SECTOR JABILLAR EL MACARO TURMERO ESTADO ARAGUA",
      "client_identification": "V13199572",
      "nap_box_name": "CTO-00004",
      "created_at": "2024-04-20T11:44:13.190458",
      "service_detail": {
        "id": 11164,
        "ip": "172.17.184.2",
        "mac": "TPLG1BB36365",
        "serial": "TPLG1BB36365",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2026-01-15T11:50:59.932200",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4054,
      "client_name": "LUISA YVETT VERA HERNANDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Jabillar",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243164818",
      "client_email": "MARYVETT05@GMAIL.COM",
      "address": "CTRA NACIONAL TURMERO MACARO CASA NRO 01-14 URB JABILLAR COUNTRY EL MACARO EDO ARAGUA",
      "client_identification": "V11242045",
      "nap_box_name": "CTO-0071",
      "created_at": "2024-04-20T11:52:18.373266",
      "service_detail": {
        "id": 10794,
        "ip": "172.29.15.2",
        "mac": "TPLGB76561E1",
        "serial": "TPLGB76561E1",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2025-12-18T09:24:46.293051",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4055,
      "client_name": "DARLING ENELLYS BLANCO JIMENEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Jabillar",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124816527",
      "client_email": "DARLINGBLA9@GMAIL.COM",
      "address": "ESQ NACIONAL TURMERO MARACAY SECTOR EL MÁCARP CASA NRO 05-18 URB EL JABILLAR TURMERO ARAGUA",
      "client_identification": "V12993065",
      "nap_box_name": "CTO-00017 C/5 JABILLAR",
      "created_at": "2024-04-20T12:00:15.764240",
      "service_detail": {
        "id": 10655,
        "ip": "172.25.87.2",
        "mac": "TPLG2ABDC6AB",
        "serial": "TPLG2ABDC6AB",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2025-12-11T10:40:07.059618",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4057,
      "client_name": "MAGCE DEL VALLE BONILLA CORDERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Jabillar",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144540876",
      "client_email": "MAGCEBONILLA843@GMAIL.COM",
      "address": "CALLE EL CARDON CASA NRO 16-01 URB JABILLAR TURMERO ESTADO ARAGUA",
      "client_identification": "V12761567",
      "nap_box_name": "CTO-00004",
      "created_at": "2024-04-20T12:02:26.517095",
      "service_detail": {
        "id": 11183,
        "ip": "172.31.5.2",
        "mac": "TPLG1BB36451",
        "serial": "TPLG1BB36451",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2026-01-15T15:59:40.377443",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4058,
      "client_name": "MAYRA ALEJANDRA ZAMORA MARTINEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Jabillar",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124221272",
      "client_email": "MAZM0708@GMAIL.COM",
      "address": "AV EL MACARO CASA CALLE ALGARROBOS NRO 04-03 URB JABILLAR TOWN COUNTRY TURMERO ARAGUA",
      "client_identification": "V20693536",
      "nap_box_name": "CTO-00006 C/4 JABILLAR",
      "created_at": "2024-04-20T12:04:12.199383",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4059,
      "client_name": "STEED RUST VELIZ VELASQUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Jabillar",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04144775741",
      "client_email": "STEEDRV@GMAIL.COM",
      "address": "CALLE 4 CASA NRO 4-19 CONJUNTO RESIDENCIAL JABILLAR TURMERO ARAGUA",
      "client_identification": "V15609606",
      "nap_box_name": "CTO-00006 C/4 JABILLAR",
      "created_at": "2024-04-20T12:05:35.466245",
      "service_detail": {
        "id": 11201,
        "ip": "172.25.196.2",
        "mac": "TPLG2ABDC7E6",
        "serial": "TPLG2ABDC7E6",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2026-01-16T13:26:12.581887",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4060,
      "client_name": "HENJER JOSUE OLIVO FALCON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Jabillar",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124853029",
      "client_email": "henjerolivo@gmail.com",
      "address": "CALLE ALGARROBOS CASA NRO 04-06 CONJUNTO RESIDENCIAL JABILLAR SECTOR EL MACARO TURMERO ARAGUA",
      "client_identification": "V14430817",
      "nap_box_name": "CTO-00006 C/4 JABILLAR",
      "created_at": "2024-04-20T12:06:23.839002",
      "service_detail": {
        "id": 3146,
        "ip": "172.27.200.2",
        "mac": "TPLG1BB36458",
        "serial": "TPLG1BB36458",
        "queue": "Plan_92034_1574_WispHub",
        "interface": "VLAN108_JABILLAR",
        "created_at": "2024-06-27T10:28:11.432342",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4061,
      "client_name": "LEIDYS JOHANNA LUGO TORRES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Jabillar",
      "plan": {
        "id": 2,
        "name": "RECURRENTE RESIDENCIAL PLAN 30M",
        "cost": "20.00",
        "code": "FOR30",
        "profile": "30M/30M"
      },
      "client_mobile": "04120330969",
      "client_email": "LEILUGO2812@GMAIL.COM",
      "address": "CALLE ALGARROBOS CASA NRO 04-06 CONJUNTO RESIDENCIAL JABILLAR SECTOR EL MACARO TURMERO ARAGUA",
      "client_identification": "V15532061",
      "nap_box_name": "CTO-00006 C/4 JABILLAR",
      "created_at": "2024-04-20T12:08:21.699826",
      "service_detail": {
        "id": 11229,
        "ip": "172.17.178.2",
        "mac": "TPLG1BB36481",
        "serial": "TPLG1BB36481",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2026-01-20T10:26:43.632982",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4062,
      "client_name": "NIURKA JOSEFINA SANCHEZ VILLEGAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Jabillar",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128866491",
      "client_email": "SANCHEZNIURKA28@GMAIL.COM",
      "address": "ALLE 05 LOS PINOS CASA NRO 10 URB JABILLAR TOWN COUNTRY TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V10754705",
      "nap_box_name": "CTO-00017 C/5 JABILLAR",
      "created_at": "2024-04-20T12:10:18.536996",
      "service_detail": {
        "id": 10657,
        "ip": "172.17.177.2",
        "mac": "TPLG1BB36419",
        "serial": "TPLG1BB36419",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2025-12-11T13:02:40.593249",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4063,
      "client_name": "INTI REIMI ALVAREZ PESTANA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Jabillar",
      "plan": {
        "id": 2,
        "name": "RECURRENTE RESIDENCIAL PLAN 30M",
        "cost": "20.00",
        "code": "FOR30",
        "profile": "30M/30M"
      },
      "client_mobile": "04144550201",
      "client_email": "SERVICIOSCASA0409@GMAIL.COM",
      "address": "CALLE LOS ALGARROBOS CASA NRO 04 URB JABILLAR TURMERO ARAGUA",
      "client_identification": "V13553711",
      "nap_box_name": "CTO-00006 C/4 JABILLAR",
      "created_at": "2024-04-20T12:15:23.776259",
      "service_detail": {
        "id": 6217,
        "ip": "172.17.152.2",
        "mac": "TPLG2ABDC787",
        "serial": "TPLG2ABDC787",
        "queue": "Plan_127740_1574_WispHub",
        "interface": "VLAN108_JABILLAR_OLT_ZTE",
        "created_at": "2024-08-23T10:36:07.492672",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4064,
      "client_name": "SARA MARIA PERDOMO ESTANISLAO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Jabillar",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144473482",
      "client_email": "SARAPERDOMO77@GMAIL.COM",
      "address": "CALLE CARDON CASA NRO 16-10 URB JABILLAR TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V27866093",
      "nap_box_name": "CTO-00004",
      "created_at": "2024-04-20T12:18:12.996506",
      "service_detail": {
        "id": 6216,
        "ip": "172.30.51.2",
        "mac": "TPLG1BB363E4",
        "serial": "TPLG1BB363E4",
        "queue": "Plan_127744_1574_WispHub",
        "interface": "VLAN108_JABILLAR_OLT_ZTE",
        "created_at": "2024-08-23T10:33:09.122325",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4065,
      "client_name": "EDUARDO ARIAS LOPEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Jabillar",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243088236",
      "client_email": "ARLOEDUARDOGM@GMAIL.COM",
      "address": "CTRA TURMERO- MARACAY CASA NRO 10-07 CONJUNTO RESIDENCIAL JABILLAR TOWN COUNTRY TURMERO EDO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V9689259",
      "nap_box_name": "CTO-00007",
      "created_at": "2024-04-20T12:20:43.358239",
      "service_detail": {
        "id": 11122,
        "ip": "172.25.85.2",
        "mac": "TPLG1BB3646B",
        "serial": "TPLG1BB3646B",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2026-01-13T12:20:56.835624",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4066,
      "client_name": "LUISA MATILDE HERNANDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Jabillar",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04140501552",
      "client_email": "MARYVETT05@GMAIL.COM",
      "address": "CALLE 4 CASA 4-12 CONJUNTO RESIDENCIAL JABILLAR TOWN COUNTRY TURMERO EDO ARAGUA",
      "client_identification": "V4138174",
      "nap_box_name": "CTO-00006 C/4 JABILLAR",
      "created_at": "2024-04-20T12:23:17.332176",
      "service_detail": {
        "id": 10718,
        "ip": "172.17.147.2",
        "mac": "TPLG2ABDC69E",
        "serial": "TPLG2ABDC69E",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2025-12-15T10:27:16.151447",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4067,
      "client_name": "FRANKLIN YOEL ARROYO LUCENA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Jabillar",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128940054",
      "client_email": "FRANKLINARROYO2021@HOTMAIL.COM",
      "address": "CALLE LOS CHAGUARAMOS CASA NRO 9-5 URB JABILLAR TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V16760138",
      "nap_box_name": "CTO-00005",
      "created_at": "2024-04-20T12:24:36.498341",
      "service_detail": {
        "id": 6203,
        "ip": "172.17.173.2",
        "mac": "TPLG1BB36411",
        "serial": "TPLG1BB36411",
        "queue": "Plan_127744_1574_WispHub",
        "interface": "VLAN100_OLTs",
        "created_at": "2024-08-23T08:22:27.349856",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4068,
      "client_name": "PEDRO ANTONIO MOLINA MARVAL",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Jabillar",
      "plan": {
        "id": 2,
        "name": "RECURRENTE RESIDENCIAL PLAN 30M",
        "cost": "20.00",
        "code": "FOR30",
        "profile": "30M/30M"
      },
      "client_mobile": "04246992736",
      "client_email": "YVANOVA77@HOTMAIL.COM",
      "address": "CALLE ARAGUANEY CASA NRO 801 URB EL JABILLAR TURMERO ARAGUA",
      "client_identification": "V13355537",
      "nap_box_name": "CTO-0078",
      "created_at": "2024-04-20T12:26:33.472838",
      "service_detail": {
        "id": 12514,
        "ip": "172.18.233.2",
        "mac": "e4:c3:2a:bd:c6:45",
        "serial": "TPLG2ABDC645",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2026-05-16T17:25:46.771763",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4070,
      "client_name": "ZEUS JOSE MUJICA PERERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Jabillar",
      "plan": {
        "id": 2,
        "name": "RECURRENTE RESIDENCIAL PLAN 30M",
        "cost": "20.00",
        "code": "FOR30",
        "profile": "30M/30M"
      },
      "client_mobile": "04143262881",
      "client_email": "ZEUSMUJICA2017@GMAIL.COM",
      "address": "CALLE LOS GUASIMOS CASA 11-08 URB. JABILLAR TURMERO ARAGUA",
      "client_identification": "V7131014",
      "nap_box_name": "CTO-00008",
      "created_at": "2024-04-20T12:33:07.352996",
      "service_detail": {
        "id": 11148,
        "ip": "172.17.157.2",
        "mac": "TPLGB8628352",
        "serial": "TPLGB8628352",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2026-01-14T10:52:17.348852",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4071,
      "client_name": "ESPERANZA COROMOTO LLOVERA MONTILLA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Jabillar",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04142664207",
      "client_email": "ESPERANZALLOVERA@GMAIL.COM",
      "address": "CALLE LOS PINOS CASA NRO 05-04 URB EL JABILLAR TOWN COUNTRY TURMERO ARAGUA",
      "client_identification": "V7276690",
      "nap_box_name": "CTO-00017 C/5 JABILLAR",
      "created_at": "2024-04-20T12:47:50.814655",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4072,
      "client_name": "ADRIANA ELISA MONTOYA SILVA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villas El Carmen",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144514798",
      "client_email": "ADRIM-26@HOTMAIL.COM",
      "address": "CALLE 10 Nº 06 NRO 07 URB VILLAS EL CARMEN SECTOR EL MACARO, TURMERO ESTADO ARAGUA",
      "client_identification": "V15181221",
      "nap_box_name": "41",
      "created_at": "2024-04-20T12:47:53.315027",
      "service_detail": {
        "id": 12137,
        "ip": "172.30.55.2",
        "mac": "HWTC902CEA9B",
        "serial": "HWTC902CEA9B",
        "queue": null,
        "interface": "VLAN135_VILLAS_CARMEN_OLT_ZTE",
        "created_at": "2026-03-20T08:55:13.734386",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4073,
      "client_name": "YULI SUHAIL SEIJAS BRICEÑO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Jabillar",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128856438",
      "client_email": "YULISEIJAS04@GMAIL.COM",
      "address": "AV EL MACARO CASA NRO 0609 URB JABILLAR TURMERO ARAGUA ZONA POSTAL 2110",
      "client_identification": "V12339919",
      "nap_box_name": "CTO-0554",
      "created_at": "2024-04-20T12:50:09.862102",
      "service_detail": {
        "id": 3127,
        "ip": "172.17.171.2",
        "mac": "TPLG1BB3646C",
        "serial": "TPLG1BB3646C",
        "queue": "Plan_92034_1574_WispHub",
        "interface": "VLAN108_JABILLAR",
        "created_at": "2024-06-26T16:37:29.480244",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4074,
      "client_name": "NILDA DEL VALLE CHACON SANOJA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Jabillar",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243026513",
      "client_email": "NILDACHACONS@GMAIL.COM",
      "address": "CALLE 16 CONDOMINIO EL CARDON CASA NRO 16-03 URB DESARROLLO HABITACIONAL EL JABILLAR TURMERO ARAGUA",
      "client_identification": "V7175646",
      "nap_box_name": "CTO-00004",
      "created_at": "2024-04-20T13:01:31.455457",
      "service_detail": {
        "id": 11179,
        "ip": "172.17.158.2",
        "mac": "TPLGF4B1D3FC",
        "serial": "TPLGF4B1D3FC",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2026-01-15T14:45:30.586978",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4075,
      "client_name": "DANIS EMILIO ROJAS PARACO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Jabillar",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04242114280",
      "client_email": "DOUGLASBENITES1@HOTMAIL.COM",
      "address": "CALLE 16 CONDOMINIO EL CARDON CASA NRO 16-03 URB DESARROLLO HABITACIONAL EL JABILLAR TURMERO ARAGUA",
      "client_identification": "V11979898",
      "nap_box_name": "CTO-0553",
      "created_at": "2024-04-20T13:04:23.435615",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4076,
      "client_name": "NICOLASA MONTILLA AGRINZONES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Jabillar",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04142664207",
      "client_email": "LUIS@LLOVERA.COM",
      "address": "CALLE LOS CAOBOS CASA N 03-20 SECTOR EL MACARO URB JABILLAR COUTRY TURMERO ARAGUA",
      "client_identification": "V4441741",
      "nap_box_name": "CTO-0552",
      "created_at": "2024-04-20T13:04:48.973993",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4077,
      "client_name": "IVAN ENRIQUE LABRADOR CONTRERAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Jabillar",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04143765200",
      "client_email": "ADRY380@HOTMAIL.COM",
      "address": "CALLE LOS GUASIMOS CASA NRO 11-02 CONJUNTO RESIDENCIAL JABILLAR TOWN COUNTRY TURMERO EDO ARAGUA TURMERO",
      "client_identification": "V2853341",
      "nap_box_name": "CTO-00008",
      "created_at": "2024-04-20T13:11:13.264387",
      "service_detail": {
        "id": 11147,
        "ip": "172.17.161.2",
        "mac": "TPLG1BB363D3",
        "serial": "TPLG1BB363D3",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2026-01-14T10:29:06.393374",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4078,
      "client_name": "SULEYMA MARGARITA MILLIER CARRILLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Jabillar",
      "plan": {
        "id": 2,
        "name": "RECURRENTE RESIDENCIAL PLAN 30M",
        "cost": "20.00",
        "code": "FOR30",
        "profile": "30M/30M"
      },
      "client_mobile": "04145987655",
      "client_email": "SULEYMAMILLIER17@GMAIL.COM",
      "address": "CALLE 11 CASA NRO 7 URB JABILLAR TURMERO EL MACARO TURMERO ARAGUA",
      "client_identification": "V9660627",
      "nap_box_name": "CTO-00008",
      "created_at": "2024-04-20T13:13:19.847767",
      "service_detail": {
        "id": 11136,
        "ip": "172.25.155.2",
        "mac": "TPLG1BB36474",
        "serial": "TPLG1BB36474",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2026-01-13T16:08:54.528038",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4079,
      "client_name": "JOENLI LISSET DIAZ TOVAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Jabillar",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124626424",
      "client_email": "DIAZJOENLI@GMAIL.COM",
      "address": "CALLE ARAGUANEY CASA 8-7 URB. JABILLAR TURMERO EDO ARAGUA",
      "client_identification": "V15863726",
      "nap_box_name": "CTO-0553",
      "created_at": "2024-04-20T13:13:20.949731",
      "service_detail": {
        "id": 10820,
        "ip": "172.25.150.2",
        "mac": "TPLG1BB364EB",
        "serial": "TPLG1BB364EB",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2025-12-19T12:34:49.041959",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4080,
      "client_name": "ELDIS JOSEFINA CAMPOS VERDE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Jabillar",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04123397640",
      "client_email": "ELDYS9@HOTMAIL.COM",
      "address": "CALLE ARAGUANEY CONDOMINIO 8 CASA 8-09 URB JABILLAR TURMERO ARAGUA",
      "client_identification": "V11984285",
      "nap_box_name": "CTO-0553",
      "created_at": "2024-04-20T13:16:24.810889",
      "service_detail": {
        "id": 10819,
        "ip": "172.17.168.2",
        "mac": "TPLG1BB3646A",
        "serial": "TPLG1BB3646A",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2025-12-19T11:17:08.698709",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4081,
      "client_name": "OMAR EUCLIDES MORALEZ MACHADO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Jabillar",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04147995889",
      "client_email": "OMAR94MORALEZ@GMAIL.COM",
      "address": "CALLE 1 CASA NRO 01-09 CONJUNTO RESIDENCIAL JABILLAR EL MACARO TURMERO ARAGUA",
      "client_identification": "V9436577",
      "nap_box_name": "CTO-0071",
      "created_at": "2024-04-20T13:19:12.093091",
      "service_detail": {
        "id": 10808,
        "ip": "172.29.17.2",
        "mac": "TPLG1BB363E9",
        "serial": "TPLG1BB363E9",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2025-12-18T12:32:57.549650",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4082,
      "client_name": "ALI GABRIEL SANCHEZ NOGUERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Taguapire",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04144945681",
      "client_email": "ALI.SANCHEZ27@GMAIL.COM",
      "address": "CALLE MARIÑO EDIF TAGUAPIRE PISO PB APT CALLE 2 APTO- 34  CONJUNTO RESIDENCIAL TAGUAPIRE TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V14692327",
      "nap_box_name": "CTO-00388",
      "created_at": "2024-04-20T13:35:52.374968",
      "service_detail": {
        "id": 10482,
        "ip": "172.25.167.2",
        "mac": "TPLGB8628419",
        "serial": "TPLGB8628419",
        "queue": null,
        "interface": "VLAN129_TAGUAPIRE_ZTE",
        "created_at": "2025-12-02T15:04:00.335139",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4083,
      "client_name": "JORGE ALEXANDER TORRES SAAVEDRA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Los Mangos",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04244642419",
      "client_email": "JATSCA@GMAIL.COM",
      "address": "CALLE NEGRO PRIMERO RESIDENCIAS LOS MANGOS APT B1-4 EDIFICIO B",
      "client_identification": "V13732698",
      "nap_box_name": "CTO-0653",
      "created_at": "2024-04-20T13:39:12.787960",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4085,
      "client_name": "ALESSANDRA NOREIDYS GARCIA DELGADO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "SUSPENDIDO_RESIDENCIAL",
      "status_name": "Suspendido",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Concepcion",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243366591",
      "client_email": "YOSMARHENRY2018@GMAIL.COM",
      "address": "AV INTERCOMUNAL EDIF TORRE 1 PISO PB APARTAMENTO 06 URB LA CONCEPCIÓN TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V24685741",
      "nap_box_name": "623",
      "created_at": "2024-04-20T13:45:01.505356",
      "service_detail": {
        "id": 3809,
        "ip": "172.26.196.2",
        "mac": "HWTC9042849B",
        "serial": "HWTC9042849B",
        "queue": "queue1",
        "interface": "VLAN111_CONCEPCION",
        "created_at": "2024-07-15T17:06:24.184413",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4086,
      "client_name": "LUIS ALEJANDRO BRAVO PRATO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Residencias Mariño",
      "plan": {
        "id": 43,
        "name": "RECURRENTE RESIDENCIAL PLAN 650M",
        "cost": "46.00",
        "code": "FOR650M",
        "profile": "650M/650M"
      },
      "client_mobile": "04243154466",
      "client_email": "MACCNO@GMAIL.COM",
      "address": "CALLE MARIÑO EDIF CONJUNTO RESIDENCIAL MARIÑO PISO 3 APT 34-A SECTOR CASCO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V16429229",
      "nap_box_name": "CTO-0518",
      "created_at": "2024-04-20T13:48:22.883692",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4087,
      "client_name": "MARIO ENXING ZHENG ZHENG",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Residencias Mariño",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124752188",
      "client_email": "MARIOFENG123456798@GMAIL.COM",
      "address": "CALLE MARIÑO EDIF. RESIDENCIAS MARIÑO PISO 8 APT C-84 CENTRO TURMERO",
      "client_identification": "V26080250",
      "nap_box_name": "CTO-0520",
      "created_at": "2024-04-20T13:50:23.055364",
      "service_detail": {
        "id": 3851,
        "ip": "172.22.58.2",
        "mac": "TPLGB68B504F",
        "serial": "TPLGB68B504F",
        "queue": "Plan_140304_15811_WispHub",
        "interface": "VLAN100_OLTs",
        "created_at": "2024-07-16T13:33:48.424110",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4088,
      "client_name": "YULIET LOURDES BALADI DI GERONIMO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243405587",
      "client_email": "YULIET.BALADI23@GMAIL.COM",
      "address": "CALLE PETION EDIF LA LINDA PISO 3 APTO 2 SECTOR CENTRO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V19032091",
      "nap_box_name": "CTO-00194 DOS",
      "created_at": "2024-04-20T13:54:47.051844",
      "service_detail": {
        "id": 3897,
        "ip": "172.26.90.2",
        "mac": "HWTC9014369B",
        "serial": "HWTC9014369B",
        "queue": "Plan_143066_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-07-16T18:25:26.953329",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4089,
      "client_name": "KEVIN WILLIAMS GARCIA ALVAREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona I Edificios",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121308840",
      "client_email": "KEVINGARCIAUNEFA@GMAIL.COM",
      "address": "AV INTERCOMUNAL MARACAY TURMERO EDF E SECTOR B PISO 2 APT 2 URB LA CASONA 2",
      "client_identification": "V18855634",
      "nap_box_name": "CTO-0532",
      "created_at": "2024-04-20T13:56:24.089098",
      "service_detail": {
        "id": 3303,
        "ip": "172.23.215.2",
        "mac": "VSOL0013BA39",
        "serial": "VSOL0013BA39",
        "queue": "queue1",
        "interface": "VLAN110_CASONA_2",
        "created_at": "2024-07-01T15:49:32.055582",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4091,
      "client_name": "JUAN CARLOS CURE MEDINA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona I Edificios",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124613611",
      "client_email": "JUANCARLOS251611@GMAIL.COM",
      "address": "AV INTERCOMUNAL MARACAY TURMERO EDIF E ALA NORTE PISO 02 APT 03 LA CASONA II ARAGUA ZONA POSTAL 2107",
      "client_identification": "V21443902",
      "nap_box_name": "CTO-0532",
      "created_at": "2024-04-20T14:09:14.145616",
      "service_detail": {
        "id": 3177,
        "ip": "172.27.88.2",
        "mac": "HWTC469A6D9B",
        "serial": "HWTC469A6D9B",
        "queue": "Plan_137942_24341_WispHub",
        "interface": "VLAN110_CASONA_2",
        "created_at": "2024-06-27T16:54:38.373181",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4092,
      "client_name": "ERNESTO DE JESUS PENA ROJAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Jabillar",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124270758",
      "client_email": "EGLYSRINCONES63@GMAIL.COM",
      "address": "CALLE BOLIVAR CASA NRO 57-2 SECTOR 19 DE ABRIL TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V11032997",
      "nap_box_name": "CTO-00004",
      "created_at": "2024-04-20T14:09:54.304079",
      "service_detail": {
        "id": 11162,
        "ip": "172.30.64.2",
        "mac": "TPLG1BB36392",
        "serial": "TPLG1BB36392",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2026-01-15T11:09:26.808836",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4093,
      "client_name": "LIGIA MARIA MENDOZA  MOSQUERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Jabillar",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121998928",
      "client_email": "AM.HEBERT.1995@GMAIL.COM",
      "address": "CTRA VIA EL MACARO CASA NRO 11-03 CONJUNTO RESIDENCIAL JABILLAR TOWN COUNTRY II ETAPA, EL MACARO EDO ARAGUA TURMERO ARAGUA",
      "client_identification": "V11548230",
      "nap_box_name": "CTO-00008",
      "created_at": "2024-04-20T14:11:53.434962",
      "service_detail": {
        "id": 11145,
        "ip": "172.30.88.2",
        "mac": "TPLG1BB36148",
        "serial": "TPLG1BB36148",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2026-01-14T09:31:12.033989",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4094,
      "client_name": "JOSE MIGUEL CEBALLOS VELASCO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Jabillar",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04120392471",
      "client_email": "JMCEBALLOS15@GMAIL.COM",
      "address": "CALLE LOS CAOBOS CASA NRO 03-06 URB EL JABILLAR TURMERO EDO ARAGUA",
      "client_identification": "V22504315",
      "nap_box_name": "CTO-0552",
      "created_at": "2024-04-20T14:16:00.415804",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4095,
      "client_name": "ELIOTH EDGARDO SANCHEZ PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Concepcion",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124326004",
      "client_email": "LORENAJPEREZH@GMAIL.COM",
      "address": "CALLE 3 CASA NRO 16 URB LA CONCEPCION TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V22954398",
      "nap_box_name": "108",
      "created_at": "2024-04-20T14:18:17.727252",
      "service_detail": {
        "id": 6145,
        "ip": "172.26.82.2",
        "mac": "HWTCC171A39C",
        "serial": "HWTCC171A39C",
        "queue": "Plan_148293_24341_WispHub",
        "interface": "VLAN111_CONCEPCION",
        "created_at": "2024-08-22T17:22:53.600883",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4096,
      "client_name": "JENNIFER LISBETH HENRIQUEZ BOLIVAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128907242",
      "client_email": "HENRIQUEZJENNIFFER11@GMAIL.COM",
      "address": "SAMAN TARAZONERO 2 MANZANA C-11 CASA #13 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V16552494",
      "nap_box_name": "286",
      "created_at": "2024-04-20T14:22:29.112208",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4097,
      "client_name": "EVELIN MERCEDES SANCHEZ CAMEJO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Terrazas de Paya",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04127760945",
      "client_email": "EVELINSANCH.14@GMAIL.COM",
      "address": "CALLE 7 CASA NRO 8 URB TERRAZAS DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V23783887",
      "nap_box_name": "CTO-00348",
      "created_at": "2024-04-20T14:31:04.703187",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4099,
      "client_name": "KHATERINE DE LOS ANGELES SOLORZANO ESCALONA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Terrazas de Paya",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243096981",
      "client_email": "SOLORZANOKATHERINE987@GMAIL.COM",
      "address": "CALLE 7 CASA NRO 12 BARRIO TERRAZASROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V20693579",
      "nap_box_name": "CTO-00348",
      "created_at": "2024-04-20T14:44:10.631838",
      "service_detail": {
        "id": 11558,
        "ip": "172.26.103.2",
        "mac": "HWTC4622689B",
        "serial": "HWTC4622689B",
        "queue": null,
        "interface": "VLAN243_BICENTENARIO",
        "created_at": "2026-02-09T11:46:38.215995",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4101,
      "client_name": "MAGGY SURAYA GHANAM CELIS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04125791809",
      "client_email": "MAGGYGHANAM95@GMAIL.COM",
      "address": "MANZANA  C-02 CASA NRO 14 SECTOR SAMAN  TARAZONERO II",
      "client_identification": "V25067048",
      "nap_box_name": "502",
      "created_at": "2024-04-20T15:03:09.178319",
      "service_detail": {
        "id": 9860,
        "ip": "172.23.155.2",
        "mac": "GPON0097B186",
        "serial": "GPON0097B186",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2025-11-10T18:37:05.944169",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4102,
      "client_name": "GILBERTO ALEXANDER NAVAS HERNANDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Taguapire",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04140397012",
      "client_email": "ALEXANDERNH85@GMAIL.COM",
      "address": "CALLE 3 EDIF MÓDULO 8 PISO PB APT 73 SECTOR EL MÁCARO TURMERO ARAGUA",
      "client_identification": "V19277965",
      "nap_box_name": "CTO-00386",
      "created_at": "2024-04-20T15:09:41.850003",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4103,
      "client_name": "RUBERTH SMITH ALVARES TORRES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados III",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04129176968",
      "client_email": "ALVARESS001@GMAIL.COM",
      "address": "CALLE 05 CASA NRO 36 PRADOS III ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V26791386",
      "nap_box_name": "580 DOS",
      "created_at": "2024-04-20T15:18:30.039704",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4104,
      "client_name": "DEANGELYS RACHEL TREJO COLINA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243201938",
      "client_email": "TREJODEAN@GMAIL.COM",
      "address": "CALLE 17-B CASA NRO 30 SECTOR PANTIN ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V21444447",
      "nap_box_name": "CTO-00048",
      "created_at": "2024-04-20T15:21:25.449719",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4105,
      "client_name": "LISETH VARELA CONTRERAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243314630",
      "client_email": "LAGUGUBELLA14@GMAIL.COM",
      "address": "CALLE 8 CASA NRO 5 SECTOR PRADOS I ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V18912027",
      "nap_box_name": "CTO-0370",
      "created_at": "2024-04-20T15:26:36.681842",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4106,
      "client_name": "YAZURI ANDRINA RIOS CHAVEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04129858055",
      "client_email": "YAZURIRIOS1389@HOTMAIL.COM",
      "address": "PAYA RIO SECO CALLE 27 CASA 14",
      "client_identification": "V13894166",
      "nap_box_name": "468",
      "created_at": "2024-04-20T15:29:03.831840",
      "service_detail": {
        "id": 6132,
        "ip": "172.27.187.2",
        "mac": "HWTC96916288",
        "serial": "HWTC96916288",
        "queue": "Plan_161904_30183_WispHub",
        "interface": "VLAN251_RIO_SECO",
        "created_at": "2024-08-22T17:05:10.552027",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4107,
      "client_name": "RONEL EDUARDO GONZALEZ VASQUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04160411515",
      "client_email": "RONELEDGAR02@GMAIL.COM",
      "address": "CALLE MANZANA B 12 CASA NRO 09 URB SAMAN TARAZONERO II TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V15610416",
      "nap_box_name": "281",
      "created_at": "2024-04-20T15:34:25.134381",
      "service_detail": {
        "id": 6341,
        "ip": "172.28.46.2",
        "mac": "ZICGD014216A",
        "serial": "ZICGD014216A",
        "queue": "Plan_138775_1574_WispHub",
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2024-08-25T21:23:29.196506",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4109,
      "client_name": "JACKSON DENILSON NIEVES COLINA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Concepcion",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04241565764",
      "client_email": "Jacksonnieves35@gmail.com",
      "address": "CALLE 2 CASA NRO 03 URB LA CONCEPCION CASA TURMERO",
      "client_identification": "V29620748",
      "nap_box_name": "109",
      "created_at": "2024-04-20T15:58:31.852881",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4110,
      "client_name": "JACKSON DENILSON NIEVES COLINA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "SUSPENDIDO_RESIDENCIAL",
      "status_name": "Suspendido",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Concepcion",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04241565764",
      "client_email": "Jacksonnieves35@gmail.com",
      "address": "CALLE 3 CASA NRO 4 URB  LA CONCEPCION TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V29620748",
      "nap_box_name": "108",
      "created_at": "2024-04-20T16:00:16.460353",
      "service_detail": {
        "id": 6126,
        "ip": "172.26.239.2",
        "mac": "VSOL00D0D83F",
        "serial": "VSOL00D0D83F",
        "queue": "Plan_131337_24341_WispHub",
        "interface": "VLAN111_CONCEPCION",
        "created_at": "2024-08-22T16:48:33.092232",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4111,
      "client_name": "NORE YOLLESI MARTINEZ CORONEL",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villas El Carmen",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144925225",
      "client_email": "NORE.MARTINEZ@GMAIL.COM",
      "address": "CALLE 11 NRO 14 URB VILLAS EL CARMEN SECTOR EL MACARO, TURMERO ESTADO ARAGUA",
      "client_identification": "V12337700",
      "nap_box_name": "40",
      "created_at": "2024-04-20T16:18:40.585059",
      "service_detail": {
        "id": 6119,
        "ip": "172.17.24.2",
        "mac": "TPLGB777B43D",
        "serial": "TPLGB777B43D",
        "queue": "Plan_129887_1574_WispHub",
        "interface": "VLAN135_VILLAS_CARMEN_OLT_ZTE",
        "created_at": "2024-08-22T16:32:58.230409",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4112,
      "client_name": "YESSICA YAMILDRETH RODRIGUEZ MORALES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villas El Carmen",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04120463227",
      "client_email": "BARBARACASTELLANOS607@GMAIL.COM",
      "address": "CALLE 08 Nº 14 URB VILLAS  EL CARMEN SECTOR EL MACARO, TURMERO ESTADO ARAGUA",
      "client_identification": "V16430348",
      "nap_box_name": "41",
      "created_at": "2024-04-20T16:22:24.602678",
      "service_detail": {
        "id": 2948,
        "ip": "172.30.35.2",
        "mac": "TPLG2ABDC689",
        "serial": "TPLG2ABDC689",
        "queue": "Plan_129887_1574_WispHub",
        "interface": "VLAN135_VILLAS_CARMEN",
        "created_at": "2024-06-20T09:30:00.100959",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4113,
      "client_name": "YAIDIN LICELOTH YEPEZ PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villas El Carmen",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243403013",
      "client_email": "yaidinliceloth@gmail.com",
      "address": "AV PPAL DEL MACARO EDIF CHIRIMOYA PISO 1 APTO 8 URB VILLAS EL CARMEN TURMERO ESTADO ARAGUA",
      "client_identification": "V13241710",
      "nap_box_name": "43",
      "created_at": "2024-04-20T16:28:19.313261",
      "service_detail": {
        "id": 13136,
        "ip": "172.17.26.2",
        "mac": "TP:LG:2A:BD:C6:59",
        "serial": "TPLG2ABDC659",
        "queue": null,
        "interface": "VLAN100_OLTs",
        "created_at": "2026-10-08T14:17:21.166628",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4114,
      "client_name": "ANA GABRIELA RAMIREZ MORENO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villas El Carmen",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04128997811",
      "client_email": "GABICITAELF@GMAIL.COM",
      "address": "CALLE 02 CASA NRO 05 URB VILLAS EL CARMEN TURMERO ESTADO ARAGUA",
      "client_identification": "V20770149",
      "nap_box_name": "50",
      "created_at": "2024-04-20T16:31:37.941785",
      "service_detail": {
        "id": 2949,
        "ip": "172.17.27.2",
        "mac": "TPLG2ABDC77E",
        "serial": "TPLG2ABDC77E",
        "queue": "Plan_127996_1574_WispHub",
        "interface": "VLAN135_VILLAS_CARMEN",
        "created_at": "2024-06-20T10:02:07.656928",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4116,
      "client_name": "CESAR AUGUSTO SOLORZANO BARRETO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villas El Carmen",
      "plan": {
        "id": 2,
        "name": "RECURRENTE RESIDENCIAL PLAN 30M",
        "cost": "20.00",
        "code": "FOR30",
        "profile": "30M/30M"
      },
      "client_mobile": "04122358618",
      "client_email": "CESAR.SOLORZANOIQ@GMAIL.COM",
      "address": "CALLE 2 CASA NRO 11 URB VILLAS EL CARMEN SECTOR EL MACARO TURMERO ESTADO ARAGUA",
      "client_identification": "V18644471",
      "nap_box_name": "50",
      "created_at": "2024-04-20T16:53:33.291814",
      "service_detail": {
        "id": 6344,
        "ip": "172.19.79.2",
        "mac": "TPLGB955018A",
        "serial": "TPLGB955018A",
        "queue": "Plan_127740_1574_WispHub",
        "interface": "VLAN135_VILLAS_CARMEN_OLT_ZTE",
        "created_at": "2024-08-25T21:38:09.953609",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4117,
      "client_name": "ADRIANA SOLIRIS TERAN GUERRA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Jabillar",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121453479",
      "client_email": "CAPYSOL2018@GMAIL.COM",
      "address": "CALLE 4 ALGARROBOS NRO 13 URB JABILLAR TOWN COUNTRY SECTOR EL MACARO  TURMERO ARAGUA",
      "client_identification": "V9694940",
      "nap_box_name": "CTO-00006 C/4 JABILLAR",
      "created_at": "2024-04-20T17:06:10.351102",
      "service_detail": {
        "id": 10709,
        "ip": "172.27.142.2",
        "mac": "TPLG2ABDC68A",
        "serial": "TPLG2ABDC68A",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2025-12-15T09:47:51.446334",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4118,
      "client_name": "BETANIA JACQUELINE JERONIMO BARRIOS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Jabillar",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04140532967",
      "client_email": "JOSEBETAJERO@GMAIL.COM",
      "address": "CONJUNTO RESIDENCIAL RESIDENCIAS NARAYOLA II EDIFICIO 5 PISO 1 APTO 1-6 TURMERO ESTADO ARAGUA",
      "client_identification": "V195164637",
      "nap_box_name": "CTO-00008",
      "created_at": "2024-04-20T17:30:15.682608",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4119,
      "client_name": "ARTURO DE LAS MERCEDES ARAUJO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Jabillar",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04149461199",
      "client_email": "ARAUJOARTURO72@GMAIL.COM",
      "address": "CALLE 03 LOS CAOBOS CASA NRO 4 URB JABILLAR SECTOR EL MACARO",
      "client_identification": "V12143544",
      "nap_box_name": "CTO-0552",
      "created_at": "2024-04-20T17:32:41.051418",
      "service_detail": {
        "id": 10730,
        "ip": "172.18.168.2",
        "mac": "TPLGB777B2AE",
        "serial": "TPLGB777B2AE",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2025-12-15T13:17:08.159980",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4120,
      "client_name": "BRIAN ALBERTO CANELON SALAZAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Jabillar",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243450944",
      "client_email": "BRIANCANELON01@GMAIL.COM",
      "address": "CALLE MAGUEY CASA NRO 15-02 URB JABILLAR TURMERO ARAGUA",
      "client_identification": "V20988062",
      "nap_box_name": "CTO-00003",
      "created_at": "2024-04-20T17:35:14.119198",
      "service_detail": {
        "id": 11202,
        "ip": "172.18.170.2",
        "mac": "TPLG2ABDC6F4",
        "serial": "TPLG2ABDC6F4",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2026-01-16T14:19:19.211892",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4121,
      "client_name": "MIGDALIA COROMOTO GUZMAN NUÑEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Jabillar",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04144557453",
      "client_email": "BETELCA20@GMAIL.COM",
      "address": "CALLE 10 CASA NRO 11 URB JABILLAR TURMERO ARAGUA",
      "client_identification": "V12598664",
      "nap_box_name": "CTO-00007",
      "created_at": "2024-04-20T17:42:26.887662",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4122,
      "client_name": "GREGORIO ADILEX DE GOUVEIA DIAZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Jabillar",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121794637",
      "client_email": "DEGOUVEIAPEREZGREGORIOADILEX@GMAIL.COM",
      "address": "CALLE LOS SAUCES CASA NRO 12 CONJUNTO RESIDENCIAL JABILLAR TOWN COUNTRY TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V31871119",
      "nap_box_name": "CTO-00007",
      "created_at": "2024-04-20T17:45:35.348771",
      "service_detail": {
        "id": 11640,
        "ip": "172.18.248.2",
        "mac": "TPLGB954EC9F",
        "serial": "TPLGB954EC9F",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2026-02-16T16:52:47.044674",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4123,
      "client_name": "SOLANGEL DEL VALLE MARCANO ALIENDRES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villas El Carmen",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243835075",
      "client_email": "CUBILLANJ@HOTMAIL.COM",
      "address": "CALLE 10 CASA NRO 05 URB VILLAS DEL CARMEN TURMERO ARAGUA",
      "client_identification": "V10096224",
      "nap_box_name": "40",
      "created_at": "2024-04-20T17:46:14.054175",
      "service_detail": {
        "id": 2950,
        "ip": "172.18.173.2",
        "mac": "TPLGB777B450",
        "serial": "TPLGB777B450",
        "queue": "Plan_127983_1574_WispHub",
        "interface": "VLAN135_VILLAS_CARMEN",
        "created_at": "2024-06-20T10:11:14.484575",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4124,
      "client_name": "LUIS ALEXANDER MIJARES REVILLA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Jabillar",
      "plan": {
        "id": 16,
        "name": "RECURRENTE RESIDENCIAL PLAN 800M",
        "cost": "55.00",
        "code": "FOR800",
        "profile": "800M/800M"
      },
      "client_mobile": "04248392947",
      "client_email": "MADIANDREFILTROSCA@HOTMAIL.COM",
      "address": "CALLE LOS CHAGUARAMOS QTA  LA MILAGROSA NRO 0909 CONJUNTO RESIDENCIAL JABILLAR TOWN COUNTRY TURMERO",
      "client_identification": "V5579796",
      "nap_box_name": "CTO-00005",
      "created_at": "2024-04-20T17:48:06.142327",
      "service_detail": {
        "id": 10800,
        "ip": "172.19.36.2",
        "mac": "TPLGF5CB001B",
        "serial": "TPLGF5CB001B",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2025-12-18T11:14:11.063737",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4126,
      "client_name": "YENNY MARIBEL GOMES DA SILVA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Jabillar",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04128953106",
      "client_email": "YENNYGOMES1987@GMAIL.COM",
      "address": "CALLE MAGUEY CASA NRO 15/12 URB JABILLAR EL MACARO",
      "client_identification": "V17513753",
      "nap_box_name": "CTO-00003",
      "created_at": "2024-04-20T17:50:18.765881",
      "service_detail": {
        "id": 11196,
        "ip": "172.19.51.2",
        "mac": "TPLGB954E8A9",
        "serial": "TPLGB954E8A9",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2026-01-16T10:40:53.676293",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4127,
      "client_name": "YRIS MARBELLA GARCIA ORTEGA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Jabillar",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04147787138",
      "client_email": "ORTEGAYRIS38@GMAIL.COM",
      "address": "CALLE 4 CASA NRO 0402 URB JABILLAR TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V14238296",
      "nap_box_name": "CTO-00006 C/4 JABILLAR",
      "created_at": "2024-04-20T17:58:44.271044",
      "service_detail": {
        "id": 10672,
        "ip": "172.19.80.2",
        "mac": "TPLGB95501EA",
        "serial": "TPLGB95501EA",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2025-12-12T13:46:20.095432",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4128,
      "client_name": "ORLANDO CELESTINO SALAZAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villas El Carmen",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04262379376",
      "client_email": "YOXZARISMONTILLA@GMAIL.COM",
      "address": "CALLE 08 CASA NRO 18 URB VILLAS EL CARMEN, TURMERO ESTADO ARAGUA",
      "client_identification": "V11085093",
      "nap_box_name": "41",
      "created_at": "2024-04-20T18:01:27.324014",
      "service_detail": {
        "id": 6104,
        "ip": "172.17.32.2",
        "mac": "TPLGB777B3AE",
        "serial": "TPLGB777B3AE",
        "queue": "Plan_127996_1574_WispHub",
        "interface": "VLAN135_VILLAS_CARMEN_OLT_ZTE",
        "created_at": "2024-08-22T15:21:16.275526",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4129,
      "client_name": "ABRAHAM MOISES GONZALEZ MENDOZA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Jabillar",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04124276888",
      "client_email": "SURTIREPUESTO@GMAIL.COM",
      "address": "CALLE EL MAGUEY CASA NRO 15 CONJUNTO RESIDENCIAL JABILLAR TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V13721881",
      "nap_box_name": "CTO-00003",
      "created_at": "2024-04-20T18:05:06.363825",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4130,
      "client_name": "GEORYETH EDRIANIS REYES BALLESTEROS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Jabillar",
      "plan": {
        "id": 19,
        "name": "RECURRENTE RESIDENCIAL PLAN 1GB",
        "cost": "74.70",
        "code": "FOR1GB",
        "profile": "1000M/1000M"
      },
      "client_mobile": "04243430637",
      "client_email": "LEYDIGIANNA30@GMAIL.COM",
      "address": "CALLE 8 CASA NRO 13 URB JABILLAR TURMERO ARAGUA ZPNA POSTAL 2103",
      "client_identification": "V28456337",
      "nap_box_name": "CTO-0078",
      "created_at": "2024-04-20T18:07:53.387385",
      "service_detail": {
        "id": 10812,
        "ip": "172.19.120.2",
        "mac": "TPLGB954FB20",
        "serial": "TPLGB954FB20",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2025-12-18T15:57:53.035543",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4131,
      "client_name": "JOSE RAMON LA ROSA LUNA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Jabillar",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04168476875",
      "client_email": "JRLRLJOSE@GMAIL.COM",
      "address": "CALLE EL SAMAN PARCELA NRO 06 -04 URB CONJUNTO RESIDENCIAL JABILLAR TOWN CONTRY, COND 6 TURMERO, EDO ARAGUA TURMERO ZONA POSTAL 2115",
      "client_identification": "V12096451",
      "nap_box_name": "CTO-0554",
      "created_at": "2024-04-20T18:10:38.433416",
      "service_detail": {
        "id": 11206,
        "ip": "172.19.121.2",
        "mac": "TPLGB954EA13",
        "serial": "TPLGB954EA13",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2026-01-16T16:12:40.158643",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4132,
      "client_name": "ANGEL EDUARDO SUAREZ DURAN",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Jabillar",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04122356362",
      "client_email": "AFXX123455@GMAIL.COM",
      "address": "CALLE BUCARE VIA EL MACARO CASA NRO 02-17 URB JABILLAR TURMERO",
      "client_identification": "V29846684",
      "nap_box_name": "CTO-0063",
      "created_at": "2024-04-20T18:21:22.982122",
      "service_detail": {
        "id": 10748,
        "ip": "172.20.100.2",
        "mac": "TPLGF5CB086C",
        "serial": "TPLGF5CB086C",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2025-12-16T13:57:06.954686",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4135,
      "client_name": "FABIAN EDUARDO MATA TOLEDO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Callejon Los Jabillos",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128847166",
      "client_email": "FABIANMATA47@GMAIL.COM",
      "address": "CALLE JABILLOS CASA NRO 7 HACIENDA DE PAYA",
      "client_identification": "V26850290",
      "nap_box_name": "138",
      "created_at": "2024-04-20T18:39:56.945297",
      "service_detail": {
        "id": 6089,
        "ip": "172.21.56.2",
        "mac": "TPLGB954FC1C",
        "serial": "TPLGB954FC1C",
        "queue": "Plan_139897_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-08-22T14:18:58.076973",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4136,
      "client_name": "MARISABEL DANUISA GARCIA HERNANDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Jabillar",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243032349",
      "client_email": "DANUISA.GH33@GMAIL.COM",
      "address": "CTRA TURMERO MARACAY CASA 04-20 CINJUNTO RESIDENCIAL JABILLAR TOWN COUNTRY EL MACARO",
      "client_identification": "V13806533",
      "nap_box_name": "CTO-00006 C/4 JABILLAR",
      "created_at": "2024-04-20T18:42:22.402021",
      "service_detail": {
        "id": 10670,
        "ip": "172.21.216.2",
        "mac": "TPLGB68B4DB4",
        "serial": "TPLGB68B4DB4",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2025-12-12T11:50:51.607389",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4137,
      "client_name": "ESMERALDA COROMOTO ZAMORA FLORES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villas El Carmen",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243732714",
      "client_email": "ESMERALDAZ11ZAMORA@GMAIL.COM",
      "address": "CALLE 02 CASA Nº 07 URB VILLAS EL CARMEN SECTOR EL MACARO, TURMERO ESTADO ARAGUA",
      "client_identification": "V12310079",
      "nap_box_name": "50",
      "created_at": "2024-04-20T18:43:40.929687",
      "service_detail": {
        "id": 6078,
        "ip": "172.18.197.2",
        "mac": "HWTC9010BE9B",
        "serial": "HWTC9010BE9B",
        "queue": "Plan_137413_1574_WispHub",
        "interface": "VLAN135_VILLAS_CARMEN_OLT_ZTE",
        "created_at": "2024-08-22T14:03:04.202219",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4138,
      "client_name": "JUAN JOSE GUDINO GIL",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Jabillar",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243371880",
      "client_email": "JUANGUDINO.A1984@GMAIL.COM",
      "address": "CALLE 2 CASA NRO  02-03 URB JABILLAR TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V16129704",
      "nap_box_name": "CTO-0063",
      "created_at": "2024-04-20T18:56:24.042789",
      "service_detail": {
        "id": 10749,
        "ip": "172.22.56.2",
        "mac": "TPLGB68B4E15",
        "serial": "TPLGB68B4E15",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2025-12-16T14:26:59.682999",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4139,
      "client_name": "DARWIN JOSSUEE OVALLES PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Jabillar",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04145254684",
      "client_email": "DARWIN.OVALLES@HOTMAIL.COM",
      "address": "CALLE BRION CASA NRO 31 BARRIO EL CARMEN  MARACAY ARAGUA ZONA POSTAL 2115",
      "client_identification": "V16206509",
      "nap_box_name": "CTO-00007",
      "created_at": "2024-04-20T18:58:46.953144",
      "service_detail": {
        "id": 2984,
        "ip": "172.23.56.2",
        "mac": "TPLGBA687605",
        "serial": "TPLGBA687605",
        "queue": "Plan_138775_1574_WispHub",
        "interface": "VLAN108_JABILLAR",
        "created_at": "2024-06-21T09:52:20.808771",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4140,
      "client_name": "FREDDY JOSE BALDOVINO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Jabillar",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128848352",
      "client_email": "F.BALDOVINO1971@HOTMAIL.COM",
      "address": "CALLE LOS GUASIMOS CASA NRO 11-14 CONJUNTO RESIDENCIAL JABILLAR TOWN COUNTRY, TURMERO EDO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V11089972",
      "nap_box_name": "CTO-00008",
      "created_at": "2024-04-20T19:00:51.558163",
      "service_detail": {
        "id": 12740,
        "ip": "172.23.243.2",
        "mac": "1c:ef:03:12:4e:49",
        "serial": "VSOL00124E49",
        "queue": null,
        "interface": "VLAN108_JABILLAR_OLT_ZTE",
        "created_at": "2026-07-15T13:21:08.009681",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4141,
      "client_name": "INDIRA ANDREINA MARTINEZ APONTE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Jabillar",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04127795427",
      "client_email": "ODINDIRAMARTINEZ@GMAIL.COM",
      "address": "CALLE BUCARE CASA NRO 02-12 URB JABILLAR TURMERO",
      "client_identification": "V17051041",
      "nap_box_name": "CTO-0063",
      "created_at": "2024-04-20T19:03:01.047340",
      "service_detail": {
        "id": 10756,
        "ip": "172.23.1.2",
        "mac": "VSOL00137D81",
        "serial": "VSOL00137D81",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2025-12-16T16:40:40.151752",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4142,
      "client_name": "LUIS ALBERTO ZAMORA FLORES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Jabillar",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04129686095",
      "client_email": "METALMECANICAZAMORA@HOTMAIL.COM",
      "address": "CALLE  BUCARE CASA NRO 02-20 URB JABILLAR  TOWN- COUNTRY EL MACARO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V10341679",
      "nap_box_name": "CTO-0063",
      "created_at": "2024-04-20T19:05:22.020278",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4143,
      "client_name": "FRANKLIN ALBERTO ZAMORA MARTINEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Jabillar",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243138545",
      "client_email": "FRANKLIMZAMORAS@GMAIL.COM",
      "address": "AV. INTERCOMUNAL TURMERO MARACAY CASA NRO 14 BARRIO BICENTENARIO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V20693528",
      "nap_box_name": "CTO-00006 C/4 JABILLAR",
      "created_at": "2024-04-20T19:07:32.306213",
      "service_detail": {
        "id": 10669,
        "ip": "172.24.63.2",
        "mac": "VSOL00139871",
        "serial": "VSOL00139871",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2025-12-12T10:33:50.109368",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4144,
      "client_name": "JOSE RICARDO QUEVEDO ESCALONA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Jabillar",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243496974",
      "client_email": "JOSERICARDO74@HOTMAIL.COM",
      "address": "CALLE 11 CASA NRO 10 URB EL JABILLAR SECTOR EL MACARO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V12169791",
      "nap_box_name": "CTO-00008",
      "created_at": "2024-04-20T19:10:30.485798",
      "service_detail": {
        "id": 11151,
        "ip": "172.18.45.2",
        "mac": "VSOL00521439",
        "serial": "VSOL00521439",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2026-01-14T12:20:34.827382",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4145,
      "client_name": "JEXI CAROLINA URRUTIA GONZALEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Jabillar",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243345058",
      "client_email": "URRUTIAJEXI@GMAIL.COM",
      "address": "CALLE  LOS PINOS NUMERO 5 CASA NRO 16 URB JABILLAR TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V21100151",
      "nap_box_name": "CTO-00017 C/5 JABILLAR",
      "created_at": "2024-04-20T19:15:26.489587",
      "service_detail": {
        "id": 12404,
        "ip": "172.17.237.2",
        "mac": "VSOL004987D1",
        "serial": "VSOL004987D1",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2026-04-24T13:23:46.020060",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4146,
      "client_name": "JINNETH DEL CARMEN MARTINEZ ROBLES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villas El Carmen",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04166152940",
      "client_email": "JINETHMARTINEZ7@GMAIL.COM",
      "address": "CALLE 10 CASA NRO 07 URB VILLAS EL CARMEN SECTOR EL MACARO, TURMERO ESTADO ARAGUA",
      "client_identification": "V9808999",
      "nap_box_name": "40",
      "created_at": "2024-04-20T20:22:27.120390",
      "service_detail": {
        "id": 6039,
        "ip": "172.25.106.2",
        "mac": "TPLGB777B409",
        "serial": "TPLGB777B409",
        "queue": "Plan_129887_1574_WispHub",
        "interface": "VLAN135_VILLAS_CARMEN_OLT_ZTE",
        "created_at": "2024-08-22T11:39:59.286162",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4147,
      "client_name": "YSIDRO ANTONIO FUENTES VIELMA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villas El Carmen",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128971111",
      "client_email": "LUISDFM05016@GMAIL.COM",
      "address": "CALLE 02 Nº 02 URB VILLAS EL CARMEN SECTOR EL MACARO, TURMERO ESTADO ARAGUA",
      "client_identification": "V11817445",
      "nap_box_name": "50",
      "created_at": "2024-04-20T20:24:49.429654",
      "service_detail": {
        "id": 2951,
        "ip": "172.18.191.2",
        "mac": "TPLG2ABDC7BB",
        "serial": "TPLG2ABDC7BB",
        "queue": "Plan_129887_1574_WispHub",
        "interface": "VLAN135_VILLAS_CARMEN",
        "created_at": "2024-06-20T10:19:05.477498",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4148,
      "client_name": "DIANA ARACNE TOVAR GOMEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villas El Carmen",
      "plan": {
        "id": 2,
        "name": "RECURRENTE RESIDENCIAL PLAN 30M",
        "cost": "20.00",
        "code": "FOR30",
        "profile": "30M/30M"
      },
      "client_mobile": "04128822609",
      "client_email": "DIANAARACNET@GMAIL.COM",
      "address": "CALLE 09 Nº 13 URB VILLAS EL CARMEN SECTOR EL MACARO, TURMERO ESTADO ARAGUA",
      "client_identification": "V12995306",
      "nap_box_name": "41",
      "created_at": "2024-04-20T20:26:51.160538",
      "service_detail": {
        "id": 2952,
        "ip": "172.17.36.2",
        "mac": "TPLGF9CD3CB1",
        "serial": "TPLGF9CD3CB1",
        "queue": "Plan_127740_1574_WispHub",
        "interface": "VLAN135_VILLAS_CARMEN",
        "created_at": "2024-06-20T10:50:55.619374",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4149,
      "client_name": "GILBERTO MAXIMILIANO VELAZQUEZ GONZALEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villas El Carmen",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243726079",
      "client_email": "MAXI_GIL560@HOTMAIL.COM",
      "address": "CALLE 04 Nº 07 URB VILLAS EL CARMEN SECTOR EL MACARO, TURMERO ESTADO ARAGUA",
      "client_identification": "V24445869",
      "nap_box_name": "CTO VILLAS DEL CARMEN",
      "created_at": "2024-04-20T20:28:52.690583",
      "service_detail": {
        "id": 2955,
        "ip": "172.17.37.2",
        "mac": "TPLGB777B329",
        "serial": "TPLGB777B329",
        "queue": "Plan_129887_1574_WispHub",
        "interface": "VLAN135_VILLAS_CARMEN",
        "created_at": "2024-06-20T11:04:18.307816",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4150,
      "client_name": "MARYORIE COROMOTO DIAZ MATERAN",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Jabillar",
      "plan": {
        "id": 19,
        "name": "RECURRENTE RESIDENCIAL PLAN 1GB",
        "cost": "74.70",
        "code": "FOR1GB",
        "profile": "1000M/1000M"
      },
      "client_mobile": "04122411668",
      "client_email": "RICARDO.VICO.09@GMAIL.COM",
      "address": "CALLE 10 CONDOMINIO LOS SAUCES JABILLAR",
      "client_identification": "V15737248",
      "nap_box_name": "CTO-00007",
      "created_at": "2024-04-20T20:32:21.933616",
      "service_detail": {
        "id": 6031,
        "ip": "172.25.76.2",
        "mac": "TPLGF9CD46FB",
        "serial": "TPLGF9CD46FB",
        "queue": "Plan_138775_1574_WispHub",
        "interface": "VLAN108_JABILLAR_OLT_ZTE",
        "created_at": "2024-08-22T09:44:43.601753",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4151,
      "client_name": "YHONNAL ALBERTO HERNANDEZ CANALES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Jabillar",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04125200145",
      "client_email": "YHONNALK2@GMAIL.COM",
      "address": "CALLE1 CASA MIS NIÑOS NRO 17 URB JABILLAR TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V17602933",
      "nap_box_name": "CTO-0071",
      "created_at": "2024-04-20T20:34:21.196955",
      "service_detail": {
        "id": 10759,
        "ip": "172.24.192.2",
        "mac": "TPLGB41633DA",
        "serial": "TPLGB41633DA",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2025-12-17T10:12:42.156828",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4152,
      "client_name": "JEIKARY LIANGYS GOATACHE VELOZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Jabillar",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121975796",
      "client_email": "GJEIKARY@GMAIL.COM",
      "address": "CTRA SANTIAGO MARIÑO CALLE BUCARE 2 CASA NRO 02-14 URB JABILLAR COUNTRY EL MACARO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V29786734",
      "nap_box_name": "CTO-0063",
      "created_at": "2024-04-20T20:36:07.400438",
      "service_detail": {
        "id": 11684,
        "ip": "172.24.205.2",
        "mac": "TPLGB41633DB",
        "serial": "TPLGB41633DB",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2026-02-20T10:44:33.955447",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4153,
      "client_name": "MARILYN YSABEL TORIN NADAL",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Jabillar",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124305165",
      "client_email": "MTORINNADAL@GMAIL.COM",
      "address": "CALLE PALO SANTO CASA NRO 17-04 URBANIZACION JABILLAR TURMERO",
      "client_identification": "V10750637",
      "nap_box_name": "CTO-00015",
      "created_at": "2024-04-20T20:38:10.642381",
      "service_detail": {
        "id": 12489,
        "ip": "172.24.151.2",
        "mac": "54:50:4c:47:b4:46",
        "serial": "TPLGB446F4AE",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2026-05-14T11:26:58.318150",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4154,
      "client_name": "JUAN JESUS GRATEROL ESAA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Jabillar",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04267348038",
      "client_email": "GRATEROLJJ@GMAIL.COM",
      "address": "CALLE BUCARE NRO 02-18 URB CONJUNTO RESIDENCIAL JABILLAR TOWN COUNTRY TURMERO",
      "client_identification": "V13770010",
      "nap_box_name": "CTO-0063",
      "created_at": "2024-04-20T20:40:02.526545",
      "service_detail": {
        "id": 10755,
        "ip": "172.24.161.2",
        "mac": "TPLGB444B238",
        "serial": "TPLGB444B238",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2025-12-16T16:32:32.120767",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4155,
      "client_name": "JOAO MANUEL BAPTISTA HERNANDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04141449323",
      "client_email": "BARAKAAGRO14@GMAIL.COM",
      "address": "CALLE GADISCO CASA NRO 40 URB VILLA CARIBE TURMERO ARAGUA",
      "client_identification": "V14627596",
      "nap_box_name": "CE-00009",
      "created_at": "2024-05-02T11:10:06.779128",
      "service_detail": {
        "id": 6011,
        "ip": "172.18.211.2",
        "mac": "TPLGB954F058",
        "serial": "TPLGB954F058",
        "queue": "queue1",
        "interface": "VLAN228_V_CARIBE_OLT1",
        "created_at": "2024-08-22T09:05:50.302514",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4157,
      "client_name": "FUNDACION NUESTRA SEÑORA DE CANDELARIA",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04145883024",
      "client_email": "UEPAPEP.LACANDELARIA@GMAIL.COM",
      "address": "CALLE RIVAS CASA NRO 18 SECTOR CENTRO TURMERO ARAGUA",
      "client_identification": "J400263948",
      "nap_box_name": "CE-00009",
      "created_at": "2024-05-06T10:42:41.569683",
      "service_detail": {
        "id": 3467,
        "ip": "172.20.21.2",
        "mac": "TPLGB7656525",
        "serial": "TPLGB7656525",
        "queue": "Plan_92036_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-07-04T17:46:33.613225",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4158,
      "client_name": "ASOC CIVIL CONSULT MED DIOC PRESB JOSE MANUEL PAN LAGO",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04145883024",
      "client_email": "MIRTACURRUNCU.64@GMAIL.COM",
      "address": "CALLE MARIÑO LOCAL NRO 38 SECTOR CENTRO TURMERO EDO ARAGUA",
      "client_identification": "J315689782",
      "nap_box_name": "CE-00009",
      "created_at": "2024-05-06T13:33:43.811014",
      "service_detail": {
        "id": 6346,
        "ip": "172.20.20.2",
        "mac": "TPLGB7656285",
        "serial": "TPLGB7656285",
        "queue": "Plan_92036_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-08-26T09:53:34.085514",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4159,
      "client_name": "DISTRIBUIDORA SUPER POLLO CABALLETE CA",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 103,
        "name": "RECURRENTE PYME PLAN 400M",
        "cost": "51.74",
        "code": "FOP400M",
        "profile": "400Mbps/400Mbps"
      },
      "client_mobile": "04243056483",
      "client_email": "DISTCABALLETE2021@GMAIL.COM",
      "address": "CALLE CEDEÑO LOCAL NRO 33 SECTOR CENTRO TURMERO ARAGUA",
      "client_identification": "J412222384",
      "nap_box_name": "649",
      "created_at": "2024-05-06T13:38:57.405123",
      "service_detail": {
        "id": 9719,
        "ip": "172.20.9.2",
        "mac": "TPLGB7656244",
        "serial": "TPLGB7656244",
        "queue": null,
        "interface": "VLAN200_OLTs",
        "created_at": "2025-11-10T11:02:31.583735",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4160,
      "client_name": "INSTALACIONES ALBATEN CA",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "San Pablo",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04123475301",
      "client_email": "ALBATENCA2@GMAIL.COM",
      "address": "AV, INDUSTRIAL CC SAN  PABLO NIVEL PB LOCAL  24 ZONA INDUSTRIAL SAN PABLO  TURMERO",
      "client_identification": "J502806547",
      "nap_box_name": "CTO-00322",
      "created_at": "2024-05-06T13:43:28.059400",
      "service_detail": {
        "id": 9720,
        "ip": "172.20.4.2",
        "mac": "TPLGB765640E",
        "serial": "TPLGB765640E",
        "queue": null,
        "interface": "VLAN200_OLTs",
        "created_at": "2025-11-10T11:03:06.064713",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4161,
      "client_name": "FESTEJOS DAYANA CA",
      "client_type_name": "PYME",
      "client_subdivision": "CANCELADO_PYME",
      "status_name": "Cancelado",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04149183129",
      "client_email": "FESTEJOSDAYANA@HOTMAIL.COM",
      "address": "CALLE PASAJE URDANETA LOCAL PB NRO 1-1 SECTOR TURMERO ARAGUA",
      "client_identification": "J307661810",
      "nap_box_name": "25",
      "created_at": "2024-05-06T13:57:48.892619",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4162,
      "client_name": "FESTEJOS DAYANA CA",
      "client_type_name": "PYME",
      "client_subdivision": "CANCELADO_PYME",
      "status_name": "Cancelado",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04149183129",
      "client_email": "FESTEJOSDAYANA@HOTMAIL.COM",
      "address": "CALLE PASAJE URDANETA LOCAL PB NRO 1-1 SECTOR TURMERO ARAGUA",
      "client_identification": "J307661810",
      "nap_box_name": "25",
      "created_at": "2024-05-06T14:00:28.630833",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4163,
      "client_name": "BENETTI Y ASOCIADOS CA",
      "client_type_name": "PYME",
      "client_subdivision": "CANCELADO_PYME",
      "status_name": "Cancelado",
      "cycle": 10,
      "migrate": true,
      "sector_name": "El Macaro",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04144492949",
      "client_email": "BENETTI_ASOCIADOSCA@HOTMAIL.COM",
      "address": "CARRETERA NACIONAL TURMERO EL MACARO LOCAL S/N SECTOR LA MACAREÑA, TURMERO ESTADO ARAGUA",
      "client_identification": "J306938559",
      "nap_box_name": "30",
      "created_at": "2024-05-06T14:19:29.541234",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4164,
      "client_name": "DISTRICHART CA",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 102,
        "name": "RECURRENTE PYME PLAN 150M",
        "cost": "27.60",
        "code": "FOP150M",
        "profile": "150Mbps/150Mbps"
      },
      "client_mobile": "04128866837",
      "client_email": "abreurodrigueznelsonavelino77@gmail.com",
      "address": "CALLE URDANETA LOCAL NRO 76-B SECTOR CENTRO DE TURMERO",
      "client_identification": "J411364282",
      "nap_box_name": "25",
      "created_at": "2024-05-06T14:23:46.591362",
      "service_detail": {
        "id": 9777,
        "ip": "172.20.53.2",
        "mac": "TPLG2ABDC754",
        "serial": "TPLG2ABDC754",
        "queue": null,
        "interface": "VLAN200_OLTs",
        "created_at": "2025-11-10T12:45:02.981495",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4165,
      "client_name": "LUB SUPPLY CA",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "El Macaro",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04144900905",
      "client_email": "JCQUEROM1990@GMAIL.COM",
      "address": "CR NACIONAL TURMERO MARACAY LOTE 2 LOCAL PARCELA 29 SECTOR PARCELAMIENTO EL MACARO TURMERO ARAGUA",
      "client_identification": "J309179802",
      "nap_box_name": "CTO-0022",
      "created_at": "2024-05-07T09:36:03.321950",
      "service_detail": {
        "id": 9782,
        "ip": "172.18.140.2",
        "mac": "TPLG2ABDC738",
        "serial": "TPLG2ABDC738",
        "queue": null,
        "interface": "VLAN104_EL_MACARO_OLT_ZTE",
        "created_at": "2025-11-10T12:52:55.621867",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4166,
      "client_name": "AUTO REPUESTOS EL MACARO CA",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "El Macaro",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04121591505",
      "client_email": "ELMACARO.COORDINACIONADM@GMAIL.COM",
      "address": "CTRA TURMERO MARACAY LOCAL PARCELA NRO 26 SECTOR EL MACARO TURMERO ESTADO ARAGUA",
      "client_identification": "J075429907",
      "nap_box_name": "CTO-0022",
      "created_at": "2024-05-07T09:40:05.391287",
      "service_detail": {
        "id": 3630,
        "ip": "172.25.79.2",
        "mac": "TPLG2ABDC6CE",
        "serial": "TPLG2ABDC6CE",
        "queue": "Plan_92033_1574_WispHub",
        "interface": "VLAN104_EL_MACARO_OLT_ZTE",
        "created_at": "2024-07-11T12:18:14.462552",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4167,
      "client_name": "TORNOS Y TURBINAS PEREIRA CA",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "La Julia",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04144573545",
      "client_email": "TORNOSYTURBINAS@HOTMAIL.COM",
      "address": "CALLE LA LINEA LOCAL GALPON NRO 42 SECTOR LA JULIA TURMERO EDO ARAGUA TURMERO",
      "client_identification": "J315809397",
      "nap_box_name": "27",
      "created_at": "2024-05-07T09:47:02.106089",
      "service_detail": {
        "id": 3677,
        "ip": "172.26.27.2",
        "mac": "TPLGB76568F4",
        "serial": "TPLGB76568F4",
        "queue": "Plan_133131_24341_WispHub",
        "interface": "VLAN138_LAJULIA",
        "created_at": "2024-07-11T20:04:15.799483",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4168,
      "client_name": "MAS QUE TRAGOS CA",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "El Macaro",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04243417004",
      "client_email": "ADM.MASQUETRAGOS@GMAIL.COM",
      "address": "CTRA NACIONAL,  CONJUNTO RESIDENCIAL VILLA SAN JOSE PARCELA 13-B LOCAL NRO LC-B-02 Y LC-B-03 SECTOR EL MACARO TURMERO ARAGUA",
      "client_identification": "J501748322",
      "nap_box_name": "CTO-0245",
      "created_at": "2024-05-07T09:49:35.897229",
      "service_detail": {
        "id": 10398,
        "ip": "172.17.29.2",
        "mac": "TPLGB777B414",
        "serial": "TPLGB777B414",
        "queue": null,
        "interface": "VLAN104_EL_MACARO_OLT_ZTE",
        "created_at": "2025-11-28T20:45:22.422175",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4169,
      "client_name": "GRUPO INDUSTRIAL MANUFACTURERO CALTEX T2 CA",
      "client_type_name": "PYME",
      "client_subdivision": "CANCELADO_PYME",
      "status_name": "Cancelado",
      "cycle": 10,
      "migrate": true,
      "sector_name": "El Macaro",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04124468491",
      "client_email": "DIST.YAKEIR.TURMERO@HOTMAIL.COM",
      "address": "AV PRINCIPAL EL MACARO LOCAL GALPON NRO 27-C ZONA INDUSTRIAL EL MACARO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "J404130438",
      "nap_box_name": "CTO-0022",
      "created_at": "2024-05-07T09:56:35.116475",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4170,
      "client_name": "SERVICIOS MICROCOMP CA",
      "client_type_name": "PYME",
      "client_subdivision": "CANCELADO_PYME",
      "status_name": "Cancelado",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 36,
        "name": "RECURRENTE PYME PLAN 650M",
        "cost": "70.18",
        "code": "FOP650M",
        "profile": "650M/650M"
      },
      "client_mobile": "04269310709",
      "client_email": "SMICROCOMP@GMAIL.COM",
      "address": "CALLE URDANETA CASA NRO 64-02 SECTOR CENTRO DE TURMERO. TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "J500167032",
      "nap_box_name": "25",
      "created_at": "2024-05-07T09:59:32.638071",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4172,
      "client_name": "FABRICA DE VELAS SANTA TERESA CA",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "San Pablo",
      "plan": {
        "id": 36,
        "name": "RECURRENTE PYME PLAN 650M",
        "cost": "70.18",
        "code": "FOP650M",
        "profile": "650M/650M"
      },
      "client_mobile": "04129200927",
      "client_email": "INFO@VELASTERESA.COM",
      "address": "AV. INDUSTRIAL SUR LOCAL PARCELAS 9 Y 10 ZONA INDUSTRIAL SAN PABLO  TURMERO ARAGUA",
      "client_identification": "J075125630",
      "nap_box_name": "56",
      "created_at": "2024-05-07T10:09:32.298291",
      "service_detail": {
        "id": 9561,
        "ip": "10.16.69.2",
        "mac": "TPLGB926DF01",
        "serial": "TPLGB926DF01",
        "queue": "queue1",
        "interface": "VLAN224_SAN_PABLO_OLT1",
        "created_at": "2025-09-25T15:36:37.394626",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4173,
      "client_name": "RM MATERIALES ELECTRICOS CA",
      "client_type_name": "PYME",
      "client_subdivision": "CANCELADO_PYME",
      "status_name": "Cancelado",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 36,
        "name": "RECURRENTE PYME PLAN 650M",
        "cost": "70.18",
        "code": "FOP650M",
        "profile": "650M/650M"
      },
      "client_mobile": "04124582937",
      "client_email": "GERENCIA.RMINGENIERIA@GMAIL.COM",
      "address": "CALLE MIRANDA NUMERO 34 LOCAL NRO 01 SECTOR CENTRO TURMERO ARAGUA",
      "client_identification": "J312523654",
      "nap_box_name": "CTO-00037",
      "created_at": "2024-05-07T10:36:52.125641",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4174,
      "client_name": "INDUSTRIA PROCESADORA CA",
      "client_type_name": "PYME",
      "client_subdivision": "CANCELADO_PYME",
      "status_name": "Cancelado",
      "cycle": 10,
      "migrate": true,
      "sector_name": "San Pablo",
      "plan": {
        "id": 38,
        "name": "RECURRENTE PYME PLAN 800M",
        "cost": "110.40",
        "code": "FOP800M",
        "profile": "800M/800M"
      },
      "client_mobile": "04243644503",
      "client_email": "INDUPROCA@HOTMAIL.COM",
      "address": "AV PPAL LOCAL GALPON NRO  55 ZONA INDUSTRIAL SAN PABLO TURMERO EDO ARAGUA",
      "client_identification": "J303931766",
      "nap_box_name": "56",
      "created_at": "2024-05-07T10:51:37.473504",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4175,
      "client_name": "CORPORACION BOAVITA CA",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "El Macaro",
      "plan": {
        "id": 36,
        "name": "RECURRENTE PYME PLAN 650M",
        "cost": "70.18",
        "code": "FOP650M",
        "profile": "650M/650M"
      },
      "client_mobile": "04144744817",
      "client_email": "CORPBOAVITA2009@HOTMAIL.COM",
      "address": "CTRA NACIONAL TURMERO CASA PARCELA LOTE NRO 24 SECTOR EL MACARO TURMERO ARAGUA",
      "client_identification": "J298228245",
      "nap_box_name": "500",
      "created_at": "2024-05-07T11:44:57.441057",
      "service_detail": {
        "id": 3694,
        "ip": "172.18.250.2",
        "mac": "TPLGB446F2F8",
        "serial": "TPLGB446F2F8",
        "queue": "Plan_92034_1574_WispHub",
        "interface": "VLAN138_LAJULIA",
        "created_at": "2024-07-11T20:46:48.834391",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4176,
      "client_name": "PANADERIA Y PASTELERIA LA MANSION DEL MACARO, C.A.",
      "client_type_name": "PYME",
      "client_subdivision": "CANCELADO_PYME",
      "status_name": "Cancelado",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Villas El Carmen",
      "plan": {
        "id": 36,
        "name": "RECURRENTE PYME PLAN 650M",
        "cost": "70.18",
        "code": "FOP650M",
        "profile": "650M/650M"
      },
      "client_mobile": "04125010623",
      "client_email": "JR6563994@GMAIL.COM",
      "address": "CTRA VIEJA TURMERO CC VILLAS  EL CARMEN NIVEL PB LOCAL 4 SECTOR EL MACARO TURMERO",
      "client_identification": "J311508716",
      "nap_box_name": "86 DOS",
      "created_at": "2024-05-07T11:49:39.626286",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4177,
      "client_name": "MI DULCE REFUGIO 2002 CA",
      "client_type_name": "PYME",
      "client_subdivision": "CANCELADO_PYME",
      "status_name": "Cancelado",
      "cycle": 10,
      "migrate": true,
      "sector_name": "El Macaro",
      "plan": {
        "id": 36,
        "name": "RECURRENTE PYME PLAN 650M",
        "cost": "70.18",
        "code": "FOP650M",
        "profile": "650M/650M"
      },
      "client_mobile": "04145875052",
      "client_email": "AGALIPOLE@HOTMAIL.COM",
      "address": "CTRA TURMERO MARACAY CASA PARCELA NRO 23 SECTOR EL MACARO TURMERO EDO ARAGUA",
      "client_identification": "J501019452",
      "nap_box_name": "CTO-00255",
      "created_at": "2024-05-07T11:53:22.690403",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4178,
      "client_name": "MOTO EXTREME ARAGUA CA",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "El Macaro",
      "plan": {
        "id": 36,
        "name": "RECURRENTE PYME PLAN 650M",
        "cost": "70.18",
        "code": "FOP650M",
        "profile": "650M/650M"
      },
      "client_mobile": "04144606254",
      "client_email": "MOTOXARAGUA@GMAIL.COM",
      "address": "CTRA NACIONAL TURMERO MARACAY LOCAL PARCELA NRO 27 SECTOR EL MACARO TURMERO ARAGUA",
      "client_identification": "J400083842",
      "nap_box_name": "83",
      "created_at": "2024-05-07T11:56:16.539518",
      "service_detail": {
        "id": 9735,
        "ip": "172.18.235.2",
        "mac": "TPLGF5CB02CE",
        "serial": "TPLGF5CB02CE",
        "queue": null,
        "interface": "VLAN100_OLTs",
        "created_at": "2025-11-10T11:24:37.562320",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4179,
      "client_name": "PANADERIA Y PASTELERIA VENEPAN DE TURMERO C.A",
      "client_type_name": "PYME",
      "client_subdivision": "CANCELADO_PYME",
      "status_name": "Cancelado",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 36,
        "name": "RECURRENTE PYME PLAN 650M",
        "cost": "70.18",
        "code": "FOP650M",
        "profile": "650M/650M"
      },
      "client_mobile": "04243198173",
      "client_email": "VENEPANTURMERO@HOTMAIL.COM",
      "address": "AV MARIÑO EDIF MARIÑÑO PISO PB LOCAL 1 Y 2 ZONA CENTRO TURMERO",
      "client_identification": "J075275659",
      "nap_box_name": "69",
      "created_at": "2024-05-07T11:59:00.808746",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4181,
      "client_name": "CARNICERIA MI SENOR 3000 CA",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Villas El Carmen",
      "plan": {
        "id": 36,
        "name": "RECURRENTE PYME PLAN 650M",
        "cost": "70.18",
        "code": "FOP650M",
        "profile": "650M/650M"
      },
      "client_mobile": "04128982955",
      "client_email": "JESUSMIGUEL187@HOTMAIL.COM",
      "address": "CTRA NACIONAL  MARACAY TURMERO CC VILLAS EL CARMEN NIVEL PB-LOCAL L-06 C2, L-07 SECTOR EL MACARO",
      "client_identification": "J312865083",
      "nap_box_name": "50",
      "created_at": "2024-05-07T12:06:41.789820",
      "service_detail": {
        "id": 4096,
        "ip": "172.19.18.2",
        "mac": "TPLGF5CB02D9",
        "serial": "TPLGF5CB02D9",
        "queue": "Plan_92034_1574_WispHub",
        "interface": "VLAN135_VILLAS_CARMEN",
        "created_at": "2024-07-23T10:04:18.724033",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4182,
      "client_name": "MOTORES SAN MARCOS XXI C.A",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "El Macaro",
      "plan": {
        "id": 102,
        "name": "RECURRENTE PYME PLAN 150M",
        "cost": "27.60",
        "code": "FOP150M",
        "profile": "150Mbps/150Mbps"
      },
      "client_mobile": "04140507731",
      "client_email": "CATERINGSERVICESGG@GMAIL.COM",
      "address": "CTRA TURMERO SAMAN DE GUERE LOCAL PARCELA 27 LOTE C-1 SECTOR EL MACARO TURMERO ARAGUA",
      "client_identification": "J502103449",
      "nap_box_name": "83",
      "created_at": "2024-05-07T12:08:52.990557",
      "service_detail": {
        "id": 13026,
        "ip": "172.19.117.2",
        "mac": "TP:LG:B9:54:FB:35",
        "serial": "TPLGB954FB35",
        "queue": null,
        "interface": "VLAN100_OLTs",
        "created_at": "2026-09-16T10:37:59.530858",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4183,
      "client_name": "INVERSIONES J ZABALA EFEIE CA",
      "client_type_name": "PYME",
      "client_subdivision": "CANCELADO_PYME",
      "status_name": "Cancelado",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 102,
        "name": "RECURRENTE PYME PLAN 150M",
        "cost": "27.60",
        "code": "FOP150M",
        "profile": "150Mbps/150Mbps"
      },
      "client_mobile": "04124616195",
      "client_email": "JAVIERZABALA255@GMAIL.COM",
      "address": "CALLE PETION C.C CENTRO COMERCIAL MERCEDES TOVAR NIVEL PB LOCAL 015 CASCO DE TURMERO",
      "client_identification": "J409774546",
      "nap_box_name": "CTO-00256",
      "created_at": "2024-05-07T12:12:34.011668",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4184,
      "client_name": "Q CARNES CA",
      "client_type_name": "PYME",
      "client_subdivision": "CANCELADO_PYME",
      "status_name": "Cancelado",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Calle Peñalver",
      "plan": {
        "id": 38,
        "name": "RECURRENTE PYME PLAN 800M",
        "cost": "110.40",
        "code": "FOP800M",
        "profile": "800M/800M"
      },
      "client_mobile": "04122921330",
      "client_email": "COMPRAS@QCARNES.COM",
      "address": "CALLE PEÑALVER LOCAL NRO 32-1 SECTOR GUANARITO TURMERO",
      "client_identification": "J312369043",
      "nap_box_name": "CTO-00476",
      "created_at": "2024-05-07T13:44:39.575869",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4185,
      "client_name": "DISTRIBUIDORA DE BELLEZA GUADA CA",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Villas El Carmen",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04144543063",
      "client_email": "FRANCISGONCALVES76@GMAIL.COM",
      "address": "CALLE VIA INTERCOMUNAL LOCAL CENTRO COMERCIAL VILLAS EL CARMEN NRO 1 SECTOR EL MACARO TURMERO ARAGUA",
      "client_identification": "J412406850",
      "nap_box_name": "50",
      "created_at": "2024-05-07T13:47:52.278228",
      "service_detail": {
        "id": 13021,
        "ip": "172.19.78.2",
        "mac": "TP:LG:F5:CB:03:A1",
        "serial": "TPLGF5CB03A1",
        "queue": null,
        "interface": "VLAN135_VILLAS_CARMEN_OLT_ZTE",
        "created_at": "2026-09-15T15:36:54.059481",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4186,
      "client_name": "JOAO MANUEL BAPTISTA HERNANDEZ",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "San Pablo",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04141449323",
      "client_email": "BARAKAAGRO14@GMAIL.COM",
      "address": "ZONA INDUSTRIAL SAN PABLO CALLE NRO 2 GALPON NRO 24",
      "client_identification": "V14627596",
      "nap_box_name": "102",
      "created_at": "2024-05-07T13:52:14.273787",
      "service_detail": {
        "id": 10050,
        "ip": "172.19.203.2",
        "mac": "TPLGB954F9E3",
        "serial": "TPLGB954F9E3",
        "queue": null,
        "interface": "VLAN224_SAN_PABLO_OLT1",
        "created_at": "2025-11-12T08:31:42.625555",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4187,
      "client_name": "ESTUDIO UNISEX PRINCESA  C.A",
      "client_type_name": "PYME",
      "client_subdivision": "CANCELADO_PYME",
      "status_name": "Cancelado",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 36,
        "name": "RECURRENTE PYME PLAN 650M",
        "cost": "70.18",
        "code": "FOP650M",
        "profile": "650M/650M"
      },
      "client_mobile": "04243498329",
      "client_email": "MEIBYS18T@GMAIL.COM",
      "address": "CALLE MARIÑO A NRO 50 CASCO TURMERO",
      "client_identification": "J075231082",
      "nap_box_name": "CTO-00256",
      "created_at": "2024-05-07T13:58:36.845429",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4188,
      "client_name": "RESTAURANT LA FLOR DE TURMERO CA",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "San Pablo",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04128901105",
      "client_email": "KOUEFATY@GMAIL.COM",
      "address": "CTRA NAC TURMERO LA ENCRUCIJADA CC SAN PABLO NIVEL PB LOCAL 15 URB SAN PABLO TURMERO",
      "client_identification": "J293523079",
      "nap_box_name": "636",
      "created_at": "2024-05-07T16:16:22.203925",
      "service_detail": {
        "id": 3673,
        "ip": "172.19.138.2",
        "mac": "TPLGB954F75A",
        "serial": "TPLGB954F75A",
        "queue": "Plan_92036_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-07-11T19:52:50.921611",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4189,
      "client_name": "SISTEMAS DE ENERGIA SA",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04265332099",
      "client_email": "ADMONSESA@GMAIL.COM",
      "address": "CALLE PAEZ NRO 2-1 TURMERO",
      "client_identification": "J303898793",
      "nap_box_name": "103",
      "created_at": "2024-05-07T16:19:12.031688",
      "service_detail": {
        "id": 9717,
        "ip": "172.24.78.2",
        "mac": "TPLGF4EFBF5E",
        "serial": "TPLGF4EFBF5E",
        "queue": null,
        "interface": "VLAN200_OLTs",
        "created_at": "2025-11-10T10:59:42.789822",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4190,
      "client_name": "LUBRI FILTROS CA",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 103,
        "name": "RECURRENTE PYME PLAN 400M",
        "cost": "51.74",
        "code": "FOP400M",
        "profile": "400Mbps/400Mbps"
      },
      "client_mobile": "04243652848",
      "client_email": "LUBRIFILTROSARAGUA@GMAIL.COM",
      "address": "CALLE URDANETA LOCAL NRO 78-C SECTOR CENTRO TURMERO",
      "client_identification": "J308078220",
      "nap_box_name": "25",
      "created_at": "2024-05-07T16:21:47.042669",
      "service_detail": {
        "id": 9779,
        "ip": "172.19.216.2",
        "mac": "TPLGB954EADC",
        "serial": "TPLGB954EADC",
        "queue": null,
        "interface": "VLAN200_OLTs",
        "created_at": "2025-11-10T12:49:41.986511",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4191,
      "client_name": "AMERICAN DISTRIBUTION DE VENEZUELA CA",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "San Pablo",
      "plan": {
        "id": 36,
        "name": "RECURRENTE PYME PLAN 650M",
        "cost": "70.18",
        "code": "FOP650M",
        "profile": "650M/650M"
      },
      "client_mobile": "04243384027",
      "client_email": "PEDIDOSADVTUR@GMAIL.COM",
      "address": "AV INDUSTRIAL SUR ZONA INDUSTRIAL SAN PABLO GALPON 5",
      "client_identification": "J000591849",
      "nap_box_name": "55",
      "created_at": "2024-05-07T16:42:08.308122",
      "service_detail": {
        "id": 3683,
        "ip": "172.21.60.2",
        "mac": "TPLGB954F6FC",
        "serial": "TPLGB954F6FC",
        "queue": "Plan_92037_15811_WispHub",
        "interface": "VLAN224_SAN_PABLO_OLT1",
        "created_at": "2024-07-11T20:17:18.346278",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4192,
      "client_name": "INTERSERCA CA",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 36,
        "name": "RECURRENTE PYME PLAN 650M",
        "cost": "70.18",
        "code": "FOP650M",
        "profile": "650M/650M"
      },
      "client_mobile": "04143458780",
      "client_email": "INTERSERCA@HOTMAIL.COM",
      "address": "CALLE PASAJE CAÑAFISTOLA NRO 2B LOCAL 2-B BARRIO VILLA CASTIN TURMERO",
      "client_identification": "J311842179",
      "nap_box_name": "228",
      "created_at": "2024-05-07T16:47:15.500980",
      "service_detail": {
        "id": 11602,
        "ip": "172.20.199.2",
        "mac": "TPLGF5CB033F",
        "serial": "TPLGF5CB033F",
        "queue": null,
        "interface": "VLAN100_OLTs",
        "created_at": "2026-02-13T09:23:47.764543",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4193,
      "client_name": "RENOVACION DE BATERIAS AUTOMO TRICES LOS TRES JUANES CA",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "El Macaro",
      "plan": {
        "id": 103,
        "name": "RECURRENTE PYME PLAN 400M",
        "cost": "51.74",
        "code": "FOP400M",
        "profile": "400Mbps/400Mbps"
      },
      "client_mobile": "04143844477",
      "client_email": "FORTESMARTINJUANJESUS@GMAIL.COM",
      "address": "CTRA NACIONAL TURMERO MARACAY LOCAL NRO PARCELA 29 SECTOR EL MACARO TURMERO",
      "client_identification": "J302043727",
      "nap_box_name": "CTO-0022",
      "created_at": "2024-05-07T16:50:02.999243",
      "service_detail": {
        "id": 9750,
        "ip": "172.20.193.2",
        "mac": "TPLGF5CB0792",
        "serial": "TPLGF5CB0792",
        "queue": null,
        "interface": "VLAN104_EL_MACARO_OLT_ZTE",
        "created_at": "2025-11-10T11:56:52.187606",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4194,
      "client_name": "FRIGORIFICO Q´CARNES TURMERO C.A.",
      "client_type_name": "PYME",
      "client_subdivision": "CANCELADO_PYME",
      "status_name": "Cancelado",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 36,
        "name": "RECURRENTE PYME PLAN 650M",
        "cost": "70.18",
        "code": "FOP650M",
        "profile": "650M/650M"
      },
      "client_mobile": "04128908461",
      "client_email": "EUCLIDESNUNESHECTOR@GMAIL.COM",
      "address": "CALLE PETION CRUCE  CON MARIÑO EDF CENTRO COMERCIAL JARDIN PISO PB LOCAL 3-A  TURMERO",
      "client_identification": "J407381202",
      "nap_box_name": "CTO-00256",
      "created_at": "2024-05-07T16:52:25.991807",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4195,
      "client_name": "TECNIC JATS CA",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Callejon Cañaveral",
      "plan": {
        "id": 36,
        "name": "RECURRENTE PYME PLAN 650M",
        "cost": "70.18",
        "code": "FOP650M",
        "profile": "650M/650M"
      },
      "client_mobile": "04243587421",
      "client_email": "TECNIC.ADM13@GMAIL.COM",
      "address": "CALLE CESAR GIRON CASA NRO 24 URB POPULAR EL SOCORRO VALENCIA CARABOBO ZONA POSTAL 2001",
      "client_identification": "J296168695",
      "nap_box_name": "471",
      "created_at": "2024-05-07T16:55:41.836970",
      "service_detail": {
        "id": 9718,
        "ip": "172.21.190.2",
        "mac": "TPLGB68B5498",
        "serial": "TPLGB68B5498",
        "queue": null,
        "interface": "VLAN200_OLTs",
        "created_at": "2025-11-10T11:01:04.621651",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4197,
      "client_name": "DISTRIBUIDORA DELIPOR CA",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "San Pablo",
      "plan": {
        "id": 36,
        "name": "RECURRENTE PYME PLAN 650M",
        "cost": "70.18",
        "code": "FOP650M",
        "profile": "650M/650M"
      },
      "client_mobile": "04143452204",
      "client_email": "DISTRIBUIDORADELIPOR@GMAIL.COM",
      "address": "AV SUR PARCELA  48 LOCAL GALPON NRO 6-A ZONA INDUSTRIAL SAN PABLO TURMERO",
      "client_identification": "J314171291",
      "nap_box_name": "102",
      "created_at": "2024-05-08T10:36:20.843269",
      "service_detail": {
        "id": 12892,
        "ip": "172.21.147.2",
        "mac": "ZX:IC:CD:BB:0C:97",
        "serial": "ZXICCDBB0C97",
        "queue": null,
        "interface": "VLAN224_SAN_PABLO_OLT1",
        "created_at": "2026-08-20T14:55:52.175960",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4198,
      "client_name": "RONALDO MANUEL PENA LEON CICPC",
      "client_type_name": "PYME",
      "client_subdivision": "CANCELADO_PYME",
      "status_name": "Cancelado",
      "cycle": 25,
      "migrate": false,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04148685485",
      "client_email": "VEHICULOSTURMERO2025@GMAIL.COM",
      "address": "TURMERO, CALLE PETIÓN, EDIF CICPC TURMERO, FRENTE AL CONCEJO MUNICIPAL",
      "client_identification": "V25069135",
      "nap_box_name": "CTO-00037",
      "created_at": "2024-05-08T10:38:50.621626",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4199,
      "client_name": "FRIMAC CA",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "El Macaro",
      "plan": {
        "id": 36,
        "name": "RECURRENTE PYME PLAN 650M",
        "cost": "70.18",
        "code": "FOP650M",
        "profile": "650M/650M"
      },
      "client_mobile": "04140534097",
      "client_email": "FRIMACA@GMAIL.COM",
      "address": "CTRA NACIONAL TURMERO MARACAY PARCELA  NRO 27 SECTOR EL MACARO",
      "client_identification": "J303596410",
      "nap_box_name": "83",
      "created_at": "2024-05-08T10:42:44.980532",
      "service_detail": {
        "id": 3451,
        "ip": "172.22.83.2",
        "mac": "TPLGBA688336",
        "serial": "TPLGBA688336",
        "queue": "Plan_92034_1574_WispHub",
        "interface": "VLAN104_EL_MACARO_OLT_ZTE",
        "created_at": "2024-07-04T16:42:45.035738",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4200,
      "client_name": "INVERSIONES AGUSTIN HURTADO FP",
      "client_type_name": "PYME",
      "client_subdivision": "CANCELADO_PYME",
      "status_name": "Cancelado",
      "cycle": 10,
      "migrate": true,
      "sector_name": "La Montaña",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04144627529",
      "client_email": "AGUSTINHURTADOJR@GMAIL.COM",
      "address": "URB LA MONTAÑA C.A NEGRO PRIMERO CENTRO COMERCIAL C.C LA COLONIA S/N LOCAL 15",
      "client_identification": "V119781325",
      "nap_box_name": "68 DOS",
      "created_at": "2024-05-08T10:50:53.574406",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4202,
      "client_name": "ALCIDES TORREALBA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vista Hermosa",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144608411",
      "client_email": "CYBERPRADOSDEPAYA@GMAIL.COM",
      "address": "AV PRINCIPAL  LOCAL NRO 5 SECTOR VIS PRINCIPAL  LOS PRADOS SECTOR VISTA  HERMOSA  ROSARIO DE PAYA",
      "client_identification": "V10572653",
      "nap_box_name": "237",
      "created_at": "2024-05-08T10:59:45.293685",
      "service_detail": {
        "id": 3656,
        "ip": "172.22.190.2",
        "mac": "TPLGBA687A66",
        "serial": "TPLGBA687A66",
        "queue": "queue1",
        "interface": "VLAN230_VISTA_HERMOSA",
        "created_at": "2024-07-11T18:13:10.547969",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4204,
      "client_name": "CARNICERIA LOS DOS PORTU CA",
      "client_type_name": "PYME",
      "client_subdivision": "CANCELADO_PYME",
      "status_name": "Cancelado",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Guerito",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04243158752",
      "client_email": "DENISALEJANDRASALAS@GMAIL.COM",
      "address": "CALLE PRINCIPAL GUERITO VIRGEN DEL VALLE LOCAL NRO 04 SECTOR GUERITO TURMERO ARAGUA ZONA POSTAL 2107",
      "client_identification": "J411038628",
      "nap_box_name": "CE - 254",
      "created_at": "2024-05-08T12:16:08.005570",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4205,
      "client_name": "FERRETERIA NUEVA ALIANZA, C.A.",
      "client_type_name": "PYME",
      "client_subdivision": "CANCELADO_PYME",
      "status_name": "Cancelado",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Las Rurales",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04127571636",
      "client_email": "LORENZOANDRADE1957@GMAIL.COM",
      "address": "CALLE 103 LOCAL NRO 19-1 URB RURALES DE PAYA ROSARIO DE PAYA EDO ARAGUA ZONA POSTAL 2115",
      "client_identification": "J402330600",
      "nap_box_name": "CTO-0490",
      "created_at": "2024-05-08T12:26:52.973832",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4206,
      "client_name": "MULTISOLUCIONES PVC CA",
      "client_type_name": "PYME",
      "client_subdivision": "CANCELADO_PYME",
      "status_name": "Cancelado",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Saman de Guere",
      "plan": {
        "id": 36,
        "name": "RECURRENTE PYME PLAN 650M",
        "cost": "70.18",
        "code": "FOP650M",
        "profile": "650M/650M"
      },
      "client_mobile": "04243442897",
      "client_email": "MULTIPVC2022@GMAIL.COM",
      "address": "AV INTERCOMUNAL DE TURMERO PARCELA N 4 CASA N 4 SECTOR SAMAN  DE GUERE TURMERO ARAGUA",
      "client_identification": "J501987637",
      "nap_box_name": "11",
      "created_at": "2024-05-09T08:53:19.374570",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4207,
      "client_name": "ANTONIO LORENZO DI CESARE MOLINA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "San Pablo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04141449053",
      "client_email": "DICESAREANTONIO@HOTMAIL.COM",
      "address": "QTA AVENIDA URB SAN PABLO CASA 23 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V11181242",
      "nap_box_name": "CTO-0637",
      "created_at": "2024-05-09T11:15:17.095787",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4208,
      "client_name": "MASA BISTRO CA",
      "client_type_name": "PYME",
      "client_subdivision": "CANCELADO_PYME",
      "status_name": "Cancelado",
      "cycle": 10,
      "migrate": true,
      "sector_name": "El Naranjal",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04141070158",
      "client_email": "TORREALBAYASOCIADOS.CP@GMAIL.COM",
      "address": "AV PRINCIPAL ROSARIO DE PAYA ANTIGUA HACIENDA EL NARANJAL LOTE 1-2 LOCAL NUMERO 3",
      "client_identification": "J410961740",
      "nap_box_name": "CTO-00303",
      "created_at": "2024-05-09T11:31:57.146360",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4209,
      "client_name": "KERVIN YNDOMAR SALAS LIENDO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Laguna II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128902796",
      "client_email": "SALASKERVIN97@GMAIL.COM",
      "address": "AV PRINCIPAL DE SAN PABLO EDIF 10PISO PB APT 1 CONJUNTO RESIDENCIAL LA LAGUNA 2 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V25501053",
      "nap_box_name": "641",
      "created_at": "2024-05-09T12:01:53.563191",
      "service_detail": {
        "id": 5986,
        "ip": "172.28.232.2",
        "mac": "HWTC218FA0A1",
        "serial": "HWTC218FA0A1",
        "queue": "queue1",
        "interface": "VLAN215_LAGUNA_2_OLT1",
        "created_at": "2024-08-21T16:50:49.782500",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4210,
      "client_name": "LEYDI GEORGINA ALMAO HERRERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Terrazas de Paya",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04122990719",
      "client_email": "LEYDIALMAO46@GMAIL.COM",
      "address": "CALLE 6 CASA NRO 19 SECTOR TERRAZAS DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V30005512",
      "nap_box_name": "CTO-0417",
      "created_at": "2024-05-10T08:21:29.404914",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4211,
      "client_name": "ANGIBELL CAROLINA INFANTE BASABE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Canaima",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04143455935",
      "client_email": "INFANTECAROLINA1989@GMAIL.COM",
      "address": "CALLE 3 CASA NRO 14 URB CANAIMA ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V18702619",
      "nap_box_name": "355",
      "created_at": "2024-05-10T08:27:40.093790",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4212,
      "client_name": "YAMILET BRICENO OLIVO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Canaima",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243339609",
      "client_email": "BRICENOOLIVOYAMILET@GMAIL.COM",
      "address": "CALLE 1 PARCELA 75 SECTOR CANAIMA ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V20958543",
      "nap_box_name": "CTO-00172 ",
      "created_at": "2024-05-10T08:35:49.874933",
      "service_detail": {
        "id": 5983,
        "ip": "172.28.237.2",
        "mac": "HWTC33795AA1",
        "serial": "HWTC33795AA1",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN237_CANAIMA",
        "created_at": "2024-08-21T16:17:38.569114",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4213,
      "client_name": "JOSE LUIS LOPEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Naranjal",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04125989250",
      "client_email": "QUINTAVILLA69@GMAIL.COM",
      "address": "CALLE UNICA CASA PARCELA NRO 9 SECTOR VILLA LAURA ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V10291060",
      "nap_box_name": "596",
      "created_at": "2024-05-10T08:40:57.578623",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4214,
      "client_name": "DARLING CELEN HERNANDEZ DE ESPINOZA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04167222593",
      "client_email": "DARLINGHERNANDEZ552@GMAIL.COM",
      "address": "CALLE 1 CASA NRO 6 URB MATA CABALLO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V17303597",
      "nap_box_name": "CTO-00131",
      "created_at": "2024-05-10T08:45:02.024072",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4215,
      "client_name": "YUDITH COROMOTO HERRERA MIERES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04244261991",
      "client_email": "HERRERASFRANK56@GMAIL.COM",
      "address": "URB SAMAN TARAZONERO II MANZANA F2, CASA 34",
      "client_identification": "V7113557",
      "nap_box_name": "93",
      "created_at": "2024-05-10T08:50:52.708511",
      "service_detail": {
        "id": 5980,
        "ip": "172.28.243.2",
        "mac": "HWTC3BE4A8A1",
        "serial": "HWTC3BE4A8A1",
        "queue": "queue1",
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2024-08-21T16:01:26.399282",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4216,
      "client_name": "NEIDDY ROSELEN QUINTERO DELGADO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados III",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04122052504",
      "client_email": "NEIDDYQUINTERO@GMAIL.COM",
      "address": "CALLE 7 CASA NRO 10 SECTOR PRADOS III TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V16407968",
      "nap_box_name": "580 DOS",
      "created_at": "2024-05-10T09:00:18.836693",
      "service_detail": {
        "id": 10604,
        "ip": "172.28.244.2",
        "mac": "HWTC1056F7A1",
        "serial": "HWTC1056F7A1",
        "queue": null,
        "interface": "VLAN236_PRADOS3",
        "created_at": "2025-12-05T18:31:10.248789",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4217,
      "client_name": "YORGELIS DE JESUS HERNANDEZ SALAZAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vallecito",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04125276748",
      "client_email": "HYORGELIS29@GMAIL.COM",
      "address": "CALLE MORICHE CASA NRO 08 SECTOR VALLECITO ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V26151075",
      "nap_box_name": "CTO - 110",
      "created_at": "2024-05-10T09:17:11.767160",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4218,
      "client_name": "KARINA MILAGROS MARTINEZ DELGADO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04122993414",
      "client_email": "RICA1998VALEN@GMAIL.COM",
      "address": "CALLE SAN ANTONIO CASA PARCELA 25 SECTOR PAYA ABAJO ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V23793267",
      "nap_box_name": "CTO-00434",
      "created_at": "2024-05-10T09:28:39.128540",
      "service_detail": {
        "id": 5732,
        "ip": "172.28.238.2",
        "mac": "HWTC0C7668A1",
        "serial": "HWTC0C7668A1",
        "queue": "Plan_161900_30183_WispHub",
        "interface": "VLAN229_PANTIN",
        "created_at": "2024-08-19T12:04:44.962971",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4219,
      "client_name": "MARIBEL PEREZ ARMAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04143842167",
      "client_email": "MARIBELPEREZARMAS@GMAIL.COM",
      "address": "CALLE 7 CASA NRO 82 URB LA CASONA I TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V8691180",
      "nap_box_name": "CE - 401",
      "created_at": "2024-05-10T09:31:57.874807",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4220,
      "client_name": "MAYBE NAZARET ECHENIQUE BLANCO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Jabillar",
      "plan": {
        "id": 43,
        "name": "RECURRENTE RESIDENCIAL PLAN 650M",
        "cost": "46.00",
        "code": "FOR650M",
        "profile": "650M/650M"
      },
      "client_mobile": "04128953621",
      "client_email": "ECHENIQUEMAYBE@GMAIL.COM",
      "address": "CALLE EL ARAGUANEY CASA NRO 08-02 TOWN COUNTRY JABILLAR EL MACARO TURMERO ZONA POSTAL 2115",
      "client_identification": "V22286590",
      "nap_box_name": "CTO-0078",
      "created_at": "2024-05-10T09:40:15.187723",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4221,
      "client_name": "JULIO SAMUEL RODRIGUEZ VELASQUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Jabillar",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128940577",
      "client_email": "JULIO.SRV97@GMAIL.COM",
      "address": "CALLE 06 CASA NRO 06-1 JABILLAR TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V26664734",
      "nap_box_name": "CTO-0554",
      "created_at": "2024-05-10T09:49:57.823950",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4222,
      "client_name": "YORGELIZ NAYARI PEREZ WALDROP",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121481146",
      "client_email": "YORGELYSPW@GMAIL.COM",
      "address": "AV PRINCIPAL ROSARIO DE PAYA CALLE 13B CASA NRO 47 URB PANTIN TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V27204307",
      "nap_box_name": "CTO-00171",
      "created_at": "2024-05-10T09:55:35.739663",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4223,
      "client_name": "ARGENIS DANIEL FIGUEROA HENRIQUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Naranjal",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144732015",
      "client_email": "ARGENIS27518087@GMAIL.COM",
      "address": "AV PRINCIPAL ROSARIO DE PAYA CC VALLES DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V27518087",
      "nap_box_name": "482",
      "created_at": "2024-05-10T10:08:42.335780",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4224,
      "client_name": "AURELIO ANTONIO MACHADO VALDERRAMA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vallecito",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243273926",
      "client_email": "AURELIOMACHADOV@GMAIL.COM",
      "address": "CALLE LAS PALMAS CASA NRO 44 BARRIO COLINAS DE VALLECITO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V30596662",
      "nap_box_name": "CTO-00067",
      "created_at": "2024-05-10T10:16:03.252220",
      "service_detail": {
        "id": 12250,
        "ip": "172.28.251.2",
        "mac": "HWTC455778A1",
        "serial": "HWTC455778A1",
        "queue": null,
        "interface": "VLAN258_VALLECITO",
        "created_at": "2026-04-04T10:58:50.484215",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4225,
      "client_name": "YARELIS ESNEIDA CELIS VERGEL",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Naranjal",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243361933",
      "client_email": "Ycelis704@gmail.com",
      "address": "CALLE LAS PALMAS CASA NRO 44 BARRIO COLINAS DE VALLECITO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V13816272",
      "nap_box_name": "CE - 681",
      "created_at": "2024-05-10T10:23:23.691944",
      "service_detail": {
        "id": 11565,
        "ip": "172.28.235.2",
        "mac": "HWTC409015A1",
        "serial": "HWTC409015A1",
        "queue": null,
        "interface": "VLAN246_NARANJAL",
        "created_at": "2026-02-09T17:06:01.171283",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4226,
      "client_name": "LUIS HUMBERTO GUAITA LISCANO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Palmeras II",
      "plan": {
        "id": 43,
        "name": "RECURRENTE RESIDENCIAL PLAN 650M",
        "cost": "46.00",
        "code": "FOR650M",
        "profile": "650M/650M"
      },
      "client_mobile": "04243387332",
      "client_email": "LUISHUMBERTO.GUAITALISCANO@GMAIL.COM",
      "address": "AV2 CASA MANZANA E NRO 11 URB PALMERAS II TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V14294321",
      "nap_box_name": "288",
      "created_at": "2024-05-10T10:30:36.329171",
      "service_detail": {
        "id": 3201,
        "ip": "172.28.250.2",
        "mac": "HWTC4A3804A1",
        "serial": "HWTC4A3804A1",
        "queue": "Plan_138996_24341_WispHub",
        "interface": "VLAN119_PALMERAS_2",
        "created_at": "2024-06-27T18:01:01.855842",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4227,
      "client_name": "MEGA LICORES TURMERO SA",
      "client_type_name": "PYME",
      "client_subdivision": "CANCELADO_PYME",
      "status_name": "Cancelado",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Vallecito",
      "plan": {
        "id": 36,
        "name": "RECURRENTE PYME PLAN 650M",
        "cost": "70.18",
        "code": "FOP650M",
        "profile": "650M/650M"
      },
      "client_mobile": "04124819159",
      "client_email": "FAUSTODELGADO6969@GMAIL.COM",
      "address": "AV PRINCIPAL ROSARIO DE PAYA LOCAL 101 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "J300972461",
      "nap_box_name": "CTO-0479",
      "created_at": "2024-05-10T11:03:36.625102",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4228,
      "client_name": "LESTER ANTONIO SEQUERA GALINDO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Palma Real",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04242664899",
      "client_email": "SEQUERALESTER@GMAIL.COM",
      "address": "MANZANA 5 NRO 82 PALMA REAL ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V14407895",
      "nap_box_name": "403",
      "created_at": "2024-05-10T11:14:33.717446",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4229,
      "client_name": "EDUIN ANTONIO SEMPRUN CHOURIO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04263490229",
      "client_email": "EDUINSEMPRUN807@GMAIL.COM",
      "address": "CALLE 9 CASA NRO B592 SECTOR MATACABALLO ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V14237908",
      "nap_box_name": "160",
      "created_at": "2024-05-10T11:19:33.432233",
      "service_detail": {
        "id": 10096,
        "ip": "172.28.169.2",
        "mac": "HWTC2A21D9A1",
        "serial": "HWTC2A21D9A1",
        "queue": null,
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2025-11-13T14:08:10.516830",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4230,
      "client_name": "JORGE LUIS ZARE MEJIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121483673",
      "client_email": "JORGELUISZARE@GMAIL.COM",
      "address": "CALLE 5 CASA NUMERO 15 URBANIZACIÓN LOS PANTI ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V23790342",
      "nap_box_name": "CTO-00135",
      "created_at": "2024-05-10T11:24:51.143001",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4231,
      "client_name": "RUBEN VICENTE TELLECHEA DUVETT",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04124852269",
      "client_email": "RBTELLECHEA@HOTMAIL.COM",
      "address": "SECTOR RIO SECO CALLE 27 CASA #15 ROSARIO DE PAYA ARAGUA TURMERO 2115",
      "client_identification": "V4459194",
      "nap_box_name": "CTO-00039",
      "created_at": "2024-05-10T11:29:11.688096",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4232,
      "client_name": "MARY IBELICE AULAR DE BARRIOS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 101,
        "name": "RECURRENTE RESIDENCIAL PLAN 200M",
        "cost": "19.00",
        "code": "FOR200MB",
        "profile": "200Mbps/200Mbps"
      },
      "client_mobile": "04243599653",
      "client_email": "MARIAULAR95@GMAIL.COM",
      "address": "CALLE 12 CASA NRO 668-B SECTOR MATA CABALLO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V5332402",
      "nap_box_name": "CTO-00433",
      "created_at": "2024-05-10T11:35:03.362775",
      "service_detail": {
        "id": 5878,
        "ip": "172.28.197.2",
        "mac": "HWTC38B749A1",
        "serial": "HWTC38B749A1",
        "queue": "queue1",
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2024-08-20T19:16:19.919408",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4233,
      "client_name": "MOTO RACING CAGUA CA",
      "client_type_name": "PYME",
      "client_subdivision": "CANCELADO_PYME",
      "status_name": "Cancelado",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04243204154",
      "client_email": "MOTORACINGCAGUA@GMAIL.COM",
      "address": "CALLE SUCRE CON CAIGAL Y  MARIÑO LOCAL 11B-01-04 CASA NRO 118-01-04 SECTOR CAGUA ARAGUA ZONA POSTAL 2122",
      "client_identification": "J502058958",
      "nap_box_name": "CTO-00134",
      "created_at": "2024-05-10T11:35:35.190277",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4234,
      "client_name": "TOMAS ALBERTO CHANG MUNOZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Paya Abajo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243644302",
      "client_email": "TOMASCHANG111@GMAIL.COM",
      "address": "CALLE EL CENTRO CASA NRO 3-1 SECTOR PAYA ABAJO TURMERO",
      "client_identification": "V16871730",
      "nap_box_name": "CTO-00307",
      "created_at": "2024-05-10T11:38:56.668160",
      "service_detail": {
        "id": 12143,
        "ip": "172.23.81.2",
        "mac": "ZXICCDBF36F6",
        "serial": "ZXICCD8F36F6",
        "queue": null,
        "interface": "VLAN231_PAYABAJO",
        "created_at": "2026-03-20T18:23:48.000854",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4235,
      "client_name": "LORENA YASMIR MAGDALENO OLIVEROS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Narayola II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04143953552",
      "client_email": "YASLORE@GMAIL.COM",
      "address": "URB. NARAYOLA II TORRE 6 PB 4",
      "client_identification": "V16339195",
      "nap_box_name": "CTO-0526",
      "created_at": "2024-05-10T11:42:46.469659",
      "service_detail": {
        "id": 3427,
        "ip": "172.26.193.2",
        "mac": "HWTCD6261E9C",
        "serial": "HWTCD6261E9C",
        "queue": "Plan_137942_24341_WispHub",
        "interface": "VLAN117_NARAYOLA",
        "created_at": "2024-07-03T16:44:31.289598",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4236,
      "client_name": "FRANKLIN DAVID GUERRERO RAMIREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144921106",
      "client_email": "FRANKGR2019@GMAIL.COM",
      "address": "CALLE PETION CC EL RANDAZO NIVEL PLANTA BAJA OF 23 SECTOR TURMERO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V26140761",
      "nap_box_name": "CTO-0650",
      "created_at": "2024-05-10T11:45:10.423725",
      "service_detail": {
        "id": 3465,
        "ip": "172.26.107.2",
        "mac": "HWTCC186069C",
        "serial": "HWTCC186069C",
        "queue": "Plan_92036_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-07-04T17:39:44.049218",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4237,
      "client_name": "TANIA ISABEL DAVID CHIRINOS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona II",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04128881972",
      "client_email": "TANIA415@GMAIL.COM",
      "address": "CALLE 12 CASA NRO 45 LA CASONA II TURMERO",
      "client_identification": "V6671415",
      "nap_box_name": "CTO-00093",
      "created_at": "2024-05-10T11:46:36.192845",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4238,
      "client_name": "MARLIN YANETH DUN DE COLMENAREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128859750",
      "client_email": "MARLINDECOLMENAREZ19@GMAIL.COM",
      "address": "CALLE16-A CASA NRO 2 SECTOR PANTIN ROSARIO DE PAYA TURMERO EDO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V19982089",
      "nap_box_name": "CTO-00195",
      "created_at": "2024-05-10T11:52:48.965324",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4239,
      "client_name": "ADRIANA DEL CARMEN CASTRO MENDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Marina Caribe",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243531773",
      "client_email": "ADRIANACCM161329@GMAIL.COM",
      "address": "CALLE A CASA NRO 4 CONJUNTO RESIDENCIAL MARINA CARIBE TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V13473919",
      "nap_box_name": "CTO-00078",
      "created_at": "2024-05-10T12:06:22.187200",
      "service_detail": {
        "id": 13170,
        "ip": "172.28.177.2",
        "mac": "ZX:IC:CD:BE:67:56",
        "serial": "ZXICCDBE6756",
        "queue": null,
        "interface": "VLAN259_LA_ORQUIDEA",
        "created_at": "2026-10-14T15:57:57.034938",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4240,
      "client_name": "INVERSIONES YENYS NORIEGA FP",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Guerito",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04143950226",
      "client_email": "YENYSNEGRA@GMAIL.COM",
      "address": "CALLE PIAR CASA NRO 137 BARRIO SAN MIGUEL TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V131020100",
      "nap_box_name": "CE-00099",
      "created_at": "2024-05-10T13:32:48.561623",
      "service_detail": {
        "id": 11834,
        "ip": "172.26.109.2",
        "mac": "MONU00DB9A31",
        "serial": "MONU00DB9A31",
        "queue": null,
        "interface": "VLAN139_GUERITO",
        "created_at": "2026-02-27T12:04:11.550993",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4241,
      "client_name": "YANNI SOPHIA BRUN GARCIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Macaro",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04129150209",
      "client_email": "YANNINEGOCIOS@GMAIL.COM",
      "address": "CALLE 8 CASA NRO 12 BARRIO ALDEA UNIVERSITARIA EL MACARO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V21094909",
      "nap_box_name": "493",
      "created_at": "2024-05-10T13:59:21.314414",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4242,
      "client_name": "DISTRIBUIDORA HCA CA",
      "client_type_name": "PYME",
      "client_subdivision": "PAUSADO_PYME",
      "status_name": "Pausado",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04124358629",
      "client_email": "HCAVENTAS1@GMAIL.COM",
      "address": "TURMERO CALLE MIRANDA EDIF JARAMA PB CODIGO POSTAL 2115",
      "client_identification": "J306897631",
      "nap_box_name": "101",
      "created_at": "2024-05-10T14:04:17.192476",
      "service_detail": {
        "id": 9786,
        "ip": "172.26.130.2",
        "mac": "HWTCD6202A9C",
        "serial": "HWTCD6202A9C",
        "queue": null,
        "interface": "VLAN200_OLTs",
        "created_at": "2025-11-10T13:21:05.167989",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4243,
      "client_name": "CICPC OFICINA BRIGADA CONTRA ROBOS",
      "client_type_name": "PYME",
      "client_subdivision": "CANCELADO_PYME",
      "status_name": "Cancelado",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 36,
        "name": "RECURRENTE PYME PLAN 650M",
        "cost": "70.18",
        "code": "FOP650M",
        "profile": "650M/650M"
      },
      "client_mobile": "04128992231",
      "client_email": "CHARLEEPTJ@HOTMAIL.COM",
      "address": "CALLE JOSE FELIX RIVAS CASA NRO 8 BARRIO BRISAS DEL LAGO ESTADO ARAGUA  MINICIPIO GIRARDOT MARACAY ZONA POSTAL 2104",
      "client_identification": "V201095359",
      "nap_box_name": "CTO-00037",
      "created_at": "2024-05-10T14:21:26.337115",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4244,
      "client_name": "EDIGITALCELL CA",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 102,
        "name": "RECURRENTE PYME PLAN 150M",
        "cost": "27.60",
        "code": "FOP150M",
        "profile": "150Mbps/150Mbps"
      },
      "client_mobile": "04144656784",
      "client_email": "EDIGITALCELL@GMAIL.COM",
      "address": "CALLE PETION CC ARMANDO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "J500832532",
      "nap_box_name": "CTO-00072",
      "created_at": "2024-05-10T14:43:03.052777",
      "service_detail": {
        "id": 9743,
        "ip": "172.26.146.2",
        "mac": "HWTCD123FE9A",
        "serial": "HWTCD123FE9A",
        "queue": null,
        "interface": "VLAN200_OLTs",
        "created_at": "2025-11-10T11:45:28.655125",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4245,
      "client_name": "INVERSIONES MINIABASTOS ISMARY CA",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04164335786",
      "client_email": "INSMARY1990@GMAIL.COM",
      "address": "CALLE VILLA CASTIN LOCAL NRO 30 SECTOR MUNICIPIO SANTIAGO MARIÑO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "J406950955",
      "nap_box_name": "228",
      "created_at": "2024-05-10T16:02:21.610035",
      "service_detail": {
        "id": 3322,
        "ip": "172.26.150.2",
        "mac": "HWTCC16F2D9C",
        "serial": "HWTCC16F2D9C",
        "queue": "Plan_92036_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-07-02T12:36:02.027291",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4246,
      "client_name": "INVERSIONES A Y M 02 CA",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04125830268",
      "client_email": "YOSEMM1927@GMAIL.COM",
      "address": "SECTOR RIO SECO CALLE 29 LOCAL 1 Y 2 ROSARIO DE PAYA TURMERO ARAGUA 2115",
      "client_identification": "J406936383",
      "nap_box_name": "598",
      "created_at": "2024-05-10T16:12:57.975525",
      "service_detail": {
        "id": 3659,
        "ip": "172.26.166.2",
        "mac": "HWTC468F5F9B",
        "serial": "HWTC468F5F9B",
        "queue": "Plan_161886_30183_WispHub",
        "interface": "VLAN251_RIO_SECO",
        "created_at": "2024-07-11T18:21:34.967784",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4247,
      "client_name": "360 GSM TECHNOLOGY CA",
      "client_type_name": "PYME",
      "client_subdivision": "CANCELADO_PYME",
      "status_name": "Cancelado",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04129672963",
      "client_email": "MIGUEL.ROCK.96.MR@GMAIL.COM",
      "address": "CALLE PETION CC MERCEDEZ TOVAR PASILLO 1 NIVEL PB LOCAL 18 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "J503409355",
      "nap_box_name": "CTO-00194",
      "created_at": "2024-05-10T16:34:52.030815",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4248,
      "client_name": "FARMAHEALTH CA",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04243517954",
      "client_email": "LICDAFANNYGARCIA1@GMAIL.COM",
      "address": "TURMERO, CALLE PETION, FRENTE AL CONCEJO MUNICIPAL ARAGUA ZONA POSTAL 2115",
      "client_identification": "J503238500",
      "nap_box_name": "CTO-00037",
      "created_at": "2024-05-10T16:39:56.489200",
      "service_detail": {
        "id": 3491,
        "ip": "172.26.176.2",
        "mac": "VSOL00D0D473",
        "serial": "VSOL00D0D473",
        "queue": "Plan_92036_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-07-05T17:07:10.411635",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4249,
      "client_name": "EMPRENDIMIENTO YATZI TORRES",
      "client_type_name": "PYME",
      "client_subdivision": "CANCELADO_PYME",
      "status_name": "Cancelado",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04144648743",
      "client_email": "YATZITORNILLERIA@GMAIL.COM",
      "address": "CALLE CAMPO ELIAS CON CALLE RIVAS N12 LOCAL 01 ESTADO ARAGUA ZONA POSTAL 2115",
      "client_identification": "J503042532",
      "nap_box_name": "CTO-00066",
      "created_at": "2024-05-10T16:50:44.441761",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4250,
      "client_name": "EL REY DEL VENTILADOR CA",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04243644867",
      "client_email": "ELREYDELVENTILADOR2023@GMAIL.COM",
      "address": "CALLE CEDEÑO EDIF PEDRO JOSE \"A\" PISO PB LOCAL 6-8 SECTOR CENTRO DE TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "J504372099",
      "nap_box_name": "CTO-00266",
      "created_at": "2024-05-10T16:54:22.833275",
      "service_detail": {
        "id": 3742,
        "ip": "172.30.60.2",
        "mac": "HWTCD6449F9C",
        "serial": "HWTCD6449F9C",
        "queue": "Plan_92036_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-07-12T16:30:33.074627",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4251,
      "client_name": "FRIGOCARNE ROSARIO DE PAYA CA",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "El Naranjal",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04144552500",
      "client_email": "YKTROMPIZ0307@GMAIL.COM",
      "address": "CALLE LOTE E GRANJA EL NARANJAL CASA NRO 03 SECTOR VALLE DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "J503538023",
      "nap_box_name": "482",
      "created_at": "2024-05-10T17:01:00.875307",
      "service_detail": {
        "id": 9179,
        "ip": "172.26.220.2",
        "mac": "QXTLCB171789",
        "serial": "QXTLCB171789",
        "queue": "queue1",
        "interface": "VLAN246_NARANJAL",
        "created_at": "2025-07-11T14:41:04.350907",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4252,
      "client_name": "FARMACIA EL SABER CA",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Santa Eduviges",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04148250000",
      "client_email": "FARMACIAELSABER@GMAIL.COM",
      "address": "AV PRINCIPAL DE EL MACARO CC CENTRO COMERCIAL SANTA EDUVIGES NIVEL PB LOCAL 1 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "J503867906",
      "nap_box_name": "86 DOS",
      "created_at": "2024-05-10T17:10:46.102824",
      "service_detail": {
        "id": 3625,
        "ip": "172.26.248.2",
        "mac": "TPLGBA687A45",
        "serial": "TPLGBA687A45",
        "queue": "Plan_92033_1574_WispHub",
        "interface": "VLAN127_SANTA_EDUVIGES",
        "created_at": "2024-07-11T11:57:47.394314",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4253,
      "client_name": "NATHALIE CAROLINA LEON CASTELLANOS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243379644",
      "client_email": "RICARDOAVELOZC@GMAIL.COM",
      "address": "CALLE 4 CASA NRO 253 MATA CABALLO ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V18552373",
      "nap_box_name": "CTO-00265",
      "created_at": "2024-05-13T15:30:35.379434",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4255,
      "client_name": "CARLYS RAQUEL CAMEJO SALGADO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Arturo Luis Berti",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04149442110",
      "client_email": "CARLYSCAMEJO@HOTMAIL.COM",
      "address": "CALLE 1 CASA NRO 366 URB ARTURO LUIS BERTI EL MACARO TURMERO EDO ARAGUA",
      "client_identification": "V7298018",
      "nap_box_name": "29",
      "created_at": "2024-05-13T15:41:30.109493",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4256,
      "client_name": "MAYANIN DE LAS ROSAS OJEDA AYALA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128971897",
      "client_email": "YASSANDRAPEROZO@GMAIL.COM",
      "address": "CALLE 16-B CASA NRO 49 SECTOR PANTIN ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V9669216",
      "nap_box_name": "CTO-00026",
      "created_at": "2024-05-14T08:29:50.244204",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4258,
      "client_name": "JESUS JOSE RIOS FARIÑAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124622270",
      "client_email": "INFO.JFFILMSART@GMAIL.COM",
      "address": "CALLE 6 CASA NRO 49 SECTOR  SAMAN  TARAZONERO I",
      "client_identification": "V16435197",
      "nap_box_name": "270",
      "created_at": "2024-05-14T08:55:36.921031",
      "service_detail": {
        "id": 12282,
        "ip": "172.24.11.2",
        "mac": "TPLGF4B1D685",
        "serial": "TPLGF4B1D685",
        "queue": null,
        "interface": "VLAN100_OLTs",
        "created_at": "2026-04-10T10:04:19.674742",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4259,
      "client_name": "FRANKLIN JOSE AMAYA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121490747",
      "client_email": "SANHY2910@GMAIL.COM",
      "address": "CALLE 6 NRO 10 BARRIO PRADOS DE PAYA ROSARIO DE PAYA",
      "client_identification": "V9982710",
      "nap_box_name": "CTO-00298",
      "created_at": "2024-05-14T08:59:38.986702",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4260,
      "client_name": "ROBERT AUGUSTO DIAZ SOZAYA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Concepcion",
      "plan": {
        "id": 43,
        "name": "RECURRENTE RESIDENCIAL PLAN 650M",
        "cost": "46.00",
        "code": "FOR650M",
        "profile": "650M/650M"
      },
      "client_mobile": "04243738489",
      "client_email": "MAGOROBERTDIAZ@GMAIL.COM",
      "address": "CALLE LOS CHAGUARAMOS CASA NRO 01 URB LA CONCEPCION TURMERO",
      "client_identification": "V17275049",
      "nap_box_name": "108",
      "created_at": "2024-05-14T09:02:46.936808",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4261,
      "client_name": "SILMARI DEL CARMEN ANGULO VASQUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04127111290",
      "client_email": "SILMARIANGULO@GMAIL.COM",
      "address": "CALLE MANZANA  E8 CASA  NRO 5 BARRIO SAMAN  TARAZONERO II 19 DE ABRIL",
      "client_identification": "V22289367",
      "nap_box_name": "161 DOS",
      "created_at": "2024-05-14T09:08:31.666351",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4262,
      "client_name": "ARMANDO JOSE LINARES RIVERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero I",
      "plan": {
        "id": 16,
        "name": "RECURRENTE RESIDENCIAL PLAN 800M",
        "cost": "55.00",
        "code": "FOR800",
        "profile": "800M/800M"
      },
      "client_mobile": "04243360302",
      "client_email": "ALINARES91@GMAIL.COM",
      "address": "CALLE 6 CASA NRO 27 SECTOR SAMAN TARAZONERO I EL MACARO TURMERO",
      "client_identification": "V20056593",
      "nap_box_name": "270",
      "created_at": "2024-05-14T09:13:56.144387",
      "service_detail": {
        "id": 6006,
        "ip": "172.20.183.2",
        "mac": "TPLGF5CB02D2",
        "serial": "TPLGF5CB02D2",
        "queue": "Plan_127983_1574_WispHub",
        "interface": "VLAN100_OLTs",
        "created_at": "2024-08-22T08:58:04.249773",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4264,
      "client_name": "TRINA MARELLY HERNANDEZ DE CEDEÑO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Esperanza",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121487517",
      "client_email": "MARINEGOCIOS201516@GMAIL.COM",
      "address": "CALLE 7 CASA NRO 18 URB LA ESPERANZA TURMERO",
      "client_identification": "V6015719",
      "nap_box_name": "CE - 451",
      "created_at": "2024-05-14T09:58:11.648685",
      "service_detail": {
        "id": 12338,
        "ip": "172.23.249.2",
        "mac": "VSOL001412E9",
        "serial": "VSOL001412E9",
        "queue": null,
        "interface": "VLAN137_LA_ESPERANZA_OLT_ZTE",
        "created_at": "2026-04-16T20:34:11.006318",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4265,
      "client_name": "ORIETTA JOSEFINA ROJAS GARCIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128866246",
      "client_email": "ORIETTAROJAS2024@GMAIL.COM",
      "address": "CALLE 12 CASA NRO 39 URB LA CASONA II TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V9999028",
      "nap_box_name": "CTO-00093",
      "created_at": "2024-05-14T11:42:49.135575",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4266,
      "client_name": "HECTOR JOSE MATHEUS CASADIEGO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero I",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04140496102",
      "client_email": "HECTORMATHEUS30@GMAIL.COM",
      "address": "CALLE 2 CASA NRO 16 SECTOR EL MACARO SAMAN TARAZONERO I",
      "client_identification": "V16130062",
      "nap_box_name": "670",
      "created_at": "2024-05-14T12:16:36.729247",
      "service_detail": {
        "id": 10036,
        "ip": "172.19.46.2",
        "mac": "TPLGF5CB0013",
        "serial": "TPLGF5CB0013",
        "queue": null,
        "interface": "VLAN140_SMT1_ZTE",
        "created_at": "2025-11-11T17:18:52.150895",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4267,
      "client_name": "JENNY YUSIMAR SEGOVIA PIRELA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04140481637",
      "client_email": "JENNYSEGOVIAM2A@GMAIL.COM",
      "address": "AV PROLONGACIÓN CALLE CARREÑO ANTIGUA HACIENDA LOS NÍSPEROS EDIF TIORA PISO 3 APT 02 URB DESARROLLO HABITACIONAL LOS NÍSPEROS TURMERO EDO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V17820008",
      "nap_box_name": "CTO-00296",
      "created_at": "2024-05-14T12:26:15.229608",
      "service_detail": {
        "id": 6003,
        "ip": "172.28.108.2",
        "mac": "ZICGD72B5700",
        "serial": "ZICGD72B5700",
        "queue": "Plan_153953_15811_WispHub",
        "interface": "VLAN209_ZAMORA_OLT1",
        "created_at": "2024-08-22T08:53:19.742267",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4268,
      "client_name": "CARMEN CECILIA DAZA RANGEL",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128921628",
      "client_email": "CARMENDAZA1965@GMAIL.COM",
      "address": "CALLE 15A CASA NRO 18 URB HACIENDA PANTIN TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V7393544",
      "nap_box_name": "CTO-00201",
      "created_at": "2024-05-14T13:43:18.146153",
      "service_detail": {
        "id": 3723,
        "ip": "172.28.75.2",
        "mac": "ZICGCB838826",
        "serial": "ZICGCB838826",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN229_PANTIN",
        "created_at": "2024-07-11T22:24:44.351907",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4269,
      "client_name": "CARLOS EDUARDO ROMAN MORALES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Tibisay Guevara",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04144861719",
      "client_email": "CRM23122@GMAIL.COM",
      "address": "EL MACARO TIBISAY GUEVARA CALLE 1 CASA 9 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V17285403",
      "nap_box_name": "CTO-00054",
      "created_at": "2024-05-14T13:46:53.099985",
      "service_detail": {
        "id": 3196,
        "ip": "172.28.30.2",
        "mac": "ZICGCD8353D6",
        "serial": "ZICGCD8353D6",
        "queue": "Plan_140304_15811_WispHub",
        "interface": "VLAN248_TIBISAY_OLT2",
        "created_at": "2024-06-27T17:47:51.232204",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4270,
      "client_name": "JEREMY JESUS SILVA GOTA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Arboleda",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128905966",
      "client_email": "SILVAJEREMYJ@GMAIL.COM",
      "address": "CALLE LOS MANGOS CASA NRO 18 BARRIO LA ARBOLEDA 1 ROSARIO DE PAYA TURMERO ARAGUA ZONA",
      "client_identification": "V27864794",
      "nap_box_name": "CTO-0485",
      "created_at": "2024-05-17T10:12:33.122610",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4271,
      "client_name": "JOSE LUIS CENTENO ALAYON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144580487",
      "client_email": "JOSECENTENO894@GMAIL.COM",
      "address": "CALLE EL CENTRO CASA NRO 9-2 SECTOR TURMERO NORTE TURMERO ARAGUA",
      "client_identification": "V24929941",
      "nap_box_name": "211",
      "created_at": "2024-05-17T10:16:04.876625",
      "service_detail": {
        "id": 3865,
        "ip": "172.30.117.2",
        "mac": "TPLGB7656286",
        "serial": "TPLGB7656286",
        "queue": "Plan_153953_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-07-16T14:46:03.470719",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4272,
      "client_name": "EDGAR ALEXANDER ESPIDEA RIVERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04122459559",
      "client_email": "EDGARESPIDEA124@GMAIL.COM",
      "address": "CALLE 5 CASA #30 SECTOR RIO SECO ROSARIO DE PAYA TURMERO ARAGUA 2115",
      "client_identification": "V17577302",
      "nap_box_name": "611",
      "created_at": "2024-05-17T10:25:06.564894",
      "service_detail": {
        "id": 10291,
        "ip": "172.26.116.2",
        "mac": "HWTC4651E39B",
        "serial": "HWTC4651E39B",
        "queue": null,
        "interface": "VLAN251_RIO_SECO",
        "created_at": "2025-11-24T14:18:06.642848",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4273,
      "client_name": "JORGE ALBERTO CORNIELES MENDOZA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04122995447",
      "client_email": "JORGECORNIELES18@GMAIL.COM",
      "address": "CALLE NRO 6 CASA NRO 38 SECTOR SAMAN TARAZONERO I TURMERO",
      "client_identification": "V21101096",
      "nap_box_name": "270",
      "created_at": "2024-05-17T10:28:56.032870",
      "service_detail": {
        "id": 5850,
        "ip": "172.20.237.2",
        "mac": "TPLGB954E92D",
        "serial": "TPLGB954E92D",
        "queue": "Plan_127983_1574_WispHub",
        "interface": "VLAN100_OLTs",
        "created_at": "2024-08-20T14:12:27.572254",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4274,
      "client_name": "OSMEL ENRIQUE MIRATRIAS RAMOS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243056197",
      "client_email": "OSMELMIRATRIASR@GMAIL.COM",
      "address": "CALLE PRINCIPAL CASA MANZANA D11 NRO 04 SECTOR SAMAN TARAZONERO II TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V25953744",
      "nap_box_name": "265",
      "created_at": "2024-05-17T10:34:32.960769",
      "service_detail": {
        "id": 12534,
        "ip": "172.28.126.2",
        "mac": "HW:TC:0F:D9:A5:A1",
        "serial": "HWTC0FD9A5A1",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2026-05-20T13:26:38.920991",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4275,
      "client_name": "ISABEL CRISTINA DUPUY OROZCO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04123986640",
      "client_email": "ISABELDUPUY15@GMAIL.COM",
      "address": "CALLE 10 CASA NRO 611 A URB MATA CABALLO ROSARIO DE PAYA TURMERO ZONA POSTAL 2115",
      "client_identification": "V15601727",
      "nap_box_name": "CTO-00431",
      "created_at": "2024-05-17T10:51:04.760793",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4278,
      "client_name": "RUBERT RICARDO RICAURTE YEPEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243136849",
      "client_email": "RUBERTRICAURTERICARDO@GMAIL.COM",
      "address": "CALLE 14-A CASA NRO 15 SECTOR PANTIN",
      "client_identification": "V23784706",
      "nap_box_name": "CTO-00169",
      "created_at": "2024-05-17T11:31:30.514480",
      "service_detail": {
        "id": 5843,
        "ip": "172.17.188.2",
        "mac": "VSOL00124EF9",
        "serial": "VSOL00124EF9",
        "queue": "Plan_161906_30183_WispHub",
        "interface": "VLAN229_PANTIN",
        "created_at": "2024-08-20T13:41:53.951741",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4279,
      "client_name": "RICARDO RAFAEL PEREZ FIGUEREDO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04129733909",
      "client_email": "RICARDOLOMEJORE@GMAIL.COM",
      "address": "CALLE CEDEÑO CASA NRO 19 SECTOR CASCO CENTRAL TURMERO",
      "client_identification": "V24860597",
      "nap_box_name": "84",
      "created_at": "2024-05-17T11:42:44.290261",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4280,
      "client_name": "YOSELLA ADAISIS VALDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados de Cafetal",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243783595",
      "client_email": "YOSELLAV@GMAIL.COM",
      "address": "CALLE 2 CASA NRO A-1 URB PRADOS DE CAFETAL TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V9694834",
      "nap_box_name": "545",
      "created_at": "2024-05-17T11:48:58.164076",
      "service_detail": {
        "id": 10827,
        "ip": "172.27.225.2",
        "mac": "QXTLCBCE80F4",
        "serial": "QXTLCBCE80F4",
        "queue": null,
        "interface": "VLAN221_CAFETAL_OLT1",
        "created_at": "2025-12-20T12:58:59.293487",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4281,
      "client_name": "MARIA LIONETE DOS REIS DE NUNES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Jabillar",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243674171",
      "client_email": "LEONETIDOSREIS65@GMAIL.COM",
      "address": "JABILLAR CALLE 8 CASA NRO 15 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V11093360",
      "nap_box_name": "CTO-0078",
      "created_at": "2024-05-17T13:34:12.283468",
      "service_detail": {
        "id": 10813,
        "ip": "172.27.230.2",
        "mac": "TPLGF9CD4792",
        "serial": "TPLGF9CD4792",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2025-12-18T16:13:13.066030",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4282,
      "client_name": "JESSICA COROMOTO RODRIGUEZ VERENZUELA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128871364",
      "client_email": "RJEI3010@GMAIL.COM",
      "address": "AV PRINCIPAL TETRA 683-D MATA CABALLO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V20097214",
      "nap_box_name": "CTO-00143",
      "created_at": "2024-05-17T14:11:11.960928",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4283,
      "client_name": "AMILCAR RAFAEL JIMENEZ MORALES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Magdalena",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243520131",
      "client_email": "AMILCARLJIMENEZ@GMAIL.COM",
      "address": "CALLE 7 CASA NRO 5 SECTOR LA MAGDALENA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V33877163",
      "nap_box_name": "CTO - 67",
      "created_at": "2024-05-17T14:31:58.652455",
      "service_detail": {
        "id": 9915,
        "ip": "172.28.137.2",
        "mac": "HWTC02987AA1",
        "serial": "HWTC02987AA1",
        "queue": null,
        "interface": "VLAN114_MAGDALENA",
        "created_at": "2025-11-10T23:46:55.861512",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4284,
      "client_name": "CESAR ANTONIO OLMOS REQUENA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243703614",
      "client_email": "CESAROLMOS09101986@GMAIL.COM",
      "address": "CALLE PRINCIPAL EDIF TORRE 20 PISO 02 APTO 04 CONJUTNO RESIDENCIAL ANTIGUA HACIENDA EL NISPERO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V17954225",
      "nap_box_name": "CTO-00464 DOS",
      "created_at": "2024-05-17T15:23:50.665534",
      "service_detail": {
        "id": 5839,
        "ip": "172.28.204.2",
        "mac": "HWTC31A01EA1",
        "serial": "HWTC31A01EA1",
        "queue": "Plan_143067_15811_WispHub",
        "interface": "VLAN209_ZAMORA_OLT1",
        "created_at": "2024-08-20T13:36:13.881688",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4285,
      "client_name": "SILENNE ESTHER GALINDEZ MORALES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Macaro",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243494402",
      "client_email": "SILENNEGALINDEZ21@GMAIL.COM",
      "address": "Calle 04 Casa Nro 50 Sector Saman Tarazonero I El Macaro Turmero",
      "client_identification": "V11092485",
      "nap_box_name": "262",
      "created_at": "2024-05-17T15:28:48.434061",
      "service_detail": {
        "id": 12647,
        "ip": "172.21.138.2",
        "mac": "TP:LG:32:68:0C:A2",
        "serial": "TPLG32680CA2",
        "queue": null,
        "interface": "VLAN100_OLTs",
        "created_at": "2026-06-30T11:32:37.170717",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4286,
      "client_name": "JOEL LUIS PEREZ RIVERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243693582",
      "client_email": "JOELPEREZ1232JSPI@GMAIL.COM",
      "address": "CALLE 22 CASA NRO 19 SECTOR PANTIN ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V12927802",
      "nap_box_name": "CTO-00105",
      "created_at": "2024-05-17T15:38:43.327013",
      "service_detail": {
        "id": 4072,
        "ip": "172.28.49.2",
        "mac": "ZICGCEE6D882",
        "serial": "ZICGCEE6D882",
        "queue": "Plan_161905_30183_WispHub",
        "interface": "VLAN229_PANTIN",
        "created_at": "2024-07-20T15:09:17.045872",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4287,
      "client_name": "GREGORIO JAVIER PEREZ TORRES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Paraiso",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144531130",
      "client_email": "GREGORYPT8225@GMAIL.COM",
      "address": "CALLE LA UNION UBR EL PARAISO CASA NRO 112 SECTOR EL MACARO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V15601400",
      "nap_box_name": "345",
      "created_at": "2024-05-17T15:45:26.615545",
      "service_detail": {
        "id": 3615,
        "ip": "172.28.213.2",
        "mac": "HWTC241960A1",
        "serial": "HWTC241960A1",
        "queue": "Plan_157310_1574_WispHub",
        "interface": "VLAN105_EL_PARAISO",
        "created_at": "2024-07-10T15:28:09.298701",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4288,
      "client_name": "DIANA CAROLINA BARRETO DE BERNAL",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Guerito",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128648833",
      "client_email": "BARRETODIANA1212@GMAIL.COM",
      "address": "CALLE 1 CASA NRO 27 BARRIO 18 DE SEPTIEMBRE CACHIPO NORTE TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V16738870",
      "nap_box_name": "CE - 771",
      "created_at": "2024-05-17T16:04:08.544902",
      "service_detail": {
        "id": 13114,
        "ip": "172.28.55.2",
        "mac": "ZI:CG:CE:36:E4:D0",
        "serial": "ZICGCE36E4D0",
        "queue": null,
        "interface": "VLAN139_GUERITO",
        "created_at": "2026-10-04T15:25:51.289456",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4289,
      "client_name": "JUSBELY JOSEFINA ROMERO RIVERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Las Rurales",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128902568",
      "client_email": "JUSBELY.1987@GMAIL.COM",
      "address": "CALLE 104 CASA NRO 45 SECTOR LAS RURALES ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V17879297",
      "nap_box_name": "492",
      "created_at": "2024-05-21T10:57:52.269142",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4290,
      "client_name": "CARLOS AUGUSTO WEFFER JAIMES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121771076",
      "client_email": "WEFFERCARLOS1@GMAIL.COM",
      "address": "CALLE 01 CASA NRO 95 BARRIO PRADOS DE PAYA DOS ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V16436819",
      "nap_box_name": "584",
      "created_at": "2024-05-21T11:55:38.670422",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4291,
      "client_name": "YINGRI JOSSEANDRY RATTIA LAYA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124801202",
      "client_email": "JOSEANDRILAYA@GMAIL.COM",
      "address": "PRADOS DE PAYA PRADOS 2 CALLE 1 CASA NRO 23 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V30046282",
      "nap_box_name": "CTO-00118 DOS",
      "created_at": "2024-05-21T11:59:15.213243",
      "service_detail": {
        "id": 5828,
        "ip": "172.24.167.2",
        "mac": "TPLGF9CD4264",
        "serial": "TPLGF9CD4264",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN242_PRADOS2",
        "created_at": "2024-08-20T10:21:38.135344",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4293,
      "client_name": "ROSA ANGELINA JIMENEZ DE PAREDES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Las Rurales",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243572800",
      "client_email": "rositadeparedes1508@gmail.com",
      "address": "CALLE 106 CASA NRO 61 SECTOR LAS RURALES TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V15490989",
      "nap_box_name": "CTO-00200",
      "created_at": "2024-05-21T14:07:25.670883",
      "service_detail": {
        "id": 2938,
        "ip": "172.27.234.2",
        "mac": "TPLGF9CD44D7",
        "serial": "TPLGF9CD44D7",
        "queue": "Plan_161900_30183_WispHub",
        "interface": "VLAN252_RURALES_PAYA",
        "created_at": "2024-06-20T08:02:29.964603",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4294,
      "client_name": "EDUARDO RAMON MARRERO SANCHEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121486711",
      "client_email": "EDUARDOMARRERO1235@GMAIL.COM",
      "address": "CALLE 02 CASA NRO 42 SECTOR MATA CABALLO ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V16011113",
      "nap_box_name": "CTO-00565",
      "created_at": "2024-05-21T15:39:10.057581",
      "service_detail": {
        "id": 3925,
        "ip": "172.28.95.2",
        "mac": "ZICGD1764C8C",
        "serial": "ZICGD1764C8C",
        "queue": "Plan_161906_30183_WispHub",
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2024-07-17T10:07:46.664789",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4295,
      "client_name": "GABRIEL ENRIQUE MATUTE MEDINA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124539912",
      "client_email": "XXGABRIELZORXX4@GMAIL.COM",
      "address": "CALLE 4 CASA NRO 258 SECTOR MATA CABALLO ROSARIO DE PAYA",
      "client_identification": "V22948588",
      "nap_box_name": "CTO-00028",
      "created_at": "2024-05-21T15:42:48.086056",
      "service_detail": {
        "id": 12487,
        "ip": "172.22.40.2",
        "mac": "68:9F:FO:OA:C4:CF",
        "serial": "ZXICCDCAD66B",
        "queue": null,
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2026-05-13T15:39:41.904450",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4296,
      "client_name": "IRMA BEATRIZ MORENO ARAUJO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Jabillar",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243596987",
      "client_email": "IRMABEATRIZMORENOARAUJO835@GMAIL.COM",
      "address": "CALLE LOS PINOS CASA NRO 05-02 URB EL JABILLAR TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V12335697",
      "nap_box_name": "CTO-00017 C/5 JABILLAR",
      "created_at": "2024-05-21T16:34:14.331149",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4297,
      "client_name": "YNGRID JOSEFINA TREMONT CARIEL",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04145868982",
      "client_email": "TREMONTYNGRID@GMAIL.COM",
      "address": "CALLE 17-B CASA NRO 39 URB PANTIN ROSARIO DE PAYA EDO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V9671441",
      "nap_box_name": "CTO-00048",
      "created_at": "2024-05-21T16:36:55.170432",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4298,
      "client_name": "NAIROBIS MICHELL BLANCO PARRA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Bicentenario",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243681829",
      "client_email": "MICHELLNAIROBI07@GMAIL.COM",
      "address": "CALLE MANZANA B CASA NRO 7 SECTOR BICENTENARIO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V25464740",
      "nap_box_name": "CTO-00446",
      "created_at": "2024-05-21T16:44:19.895828",
      "service_detail": {
        "id": 3157,
        "ip": "172.28.97.2",
        "mac": "ZICGCD9551B9",
        "serial": "ZICGCD9551B9",
        "queue": "Plan_161895_30183_WispHub",
        "interface": "VLAN243_BICENTENARIO",
        "created_at": "2024-06-27T13:40:48.114520",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4299,
      "client_name": "MARY ZARINA HERNANDEZ GUZMAN",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243317742",
      "client_email": "MARYHERNANDEZ8658@GMAIL.COM",
      "address": "CALLE CARREÑO FINAL EDIF TORRE 5 PISO 1 APTO 2 URBANISMO HACIENDA EL NISPERO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V7179745",
      "nap_box_name": "CTO-00032 DOS",
      "created_at": "2024-05-21T17:03:34.640259",
      "service_detail": {
        "id": 5802,
        "ip": "172.28.179.2",
        "mac": "HWTC47426EA1",
        "serial": "HWTC47426EA1",
        "queue": "Plan_153953_15811_WispHub",
        "interface": "VLAN209_ZAMORA_OLT1",
        "created_at": "2024-08-19T19:31:03.301320",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4300,
      "client_name": "HECTOR JOSE PULIDO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Las Rurales",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243547822",
      "client_email": "PULIDOH414@GMAIL.COM",
      "address": "CALLE MIRANDA CASA NRO 04 BARRIO ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V15736625",
      "nap_box_name": "CTO-0485",
      "created_at": "2024-05-21T17:07:23.374629",
      "service_detail": {
        "id": 5801,
        "ip": "172.28.200.2",
        "mac": "HWTC06A433A1",
        "serial": "HWTC06A433A1",
        "queue": "queue1",
        "interface": "VLAN252_RURALES_PAYA",
        "created_at": "2024-08-19T19:26:56.159428",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4301,
      "client_name": "Sisprot Taurus",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Macaro",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124006962",
      "client_email": "breyesve@gmail.com",
      "address": "VÍA EL MACARO",
      "client_identification": "J297241175",
      "nap_box_name": "32",
      "created_at": "2024-05-22T11:12:49.706266",
      "service_detail": {
        "id": 13054,
        "ip": "172.17.2.22",
        "mac": "ZT:EG:DC:EF:63:3A",
        "serial": "ZTEGDCEF633A",
        "queue": null,
        "interface": "VLAN200_OLTs",
        "created_at": "2026-09-21T11:37:08.367821",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4302,
      "client_name": "ALIRIO JOSE MONTIEL SEVILLA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "San Sebastian",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243268721",
      "client_email": "SULEIMARJMONTIELN@GMAIL.COM",
      "address": "URB SAN SEBASTIAN CALLE 7 CASA NRO 14 SECTOR EL MACARO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V16205128",
      "nap_box_name": "75",
      "created_at": "2024-05-22T13:53:41.297986",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4304,
      "client_name": "JULIO CESAR DELGADO ALVAREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243441243",
      "client_email": "JULIOCDA1962@GMAIL.COM",
      "address": "CALLE 17 B CASA NRO 47 URB PANTIN TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V7236865",
      "nap_box_name": "CTO-00048",
      "created_at": "2024-05-23T08:07:44.937272",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4305,
      "client_name": "YURMI ROJAS PACHECO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Paraiso",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144912584",
      "client_email": "YURMIRRR@GMAIL.COM",
      "address": "CALLE LA ESPERANZA CASA NRO 28 URB EL PARAISO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V11977989",
      "nap_box_name": "346",
      "created_at": "2024-05-23T08:11:04.859531",
      "service_detail": {
        "id": 3860,
        "ip": "172.28.127.2",
        "mac": "HWTC391D79A1",
        "serial": "HWTC391D79A1",
        "queue": "Plan_157310_1574_WispHub",
        "interface": "VLAN105_EL_PARAISO",
        "created_at": "2024-07-16T14:26:47.642065",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4306,
      "client_name": "ALEXANDER JOSE DAVILA GARCIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Magdalena",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243259065",
      "client_email": "ALEXANDERDAVILA29@GMAIL.COM",
      "address": "CALLE 9 CASA NRO 50 URB LA MAGDALENA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V9771620",
      "nap_box_name": "CTO-00185",
      "created_at": "2024-05-23T08:38:39.280186",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4309,
      "client_name": "ANAIRIM KARINA MARCANO HIDALGO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128660610",
      "client_email": "ANAIRINMARC22@GMAIL.COM",
      "address": "CALLE 7 CASA NRO 72 URB LA CASONA I",
      "client_identification": "V24929940",
      "nap_box_name": "CE - 401",
      "created_at": "2024-05-27T08:38:07.064385",
      "service_detail": {
        "id": 2928,
        "ip": "172.30.72.2",
        "mac": "HWTCC144129C",
        "serial": "HWTCC144129C",
        "queue": "Plan_137942_24341_WispHub",
        "interface": "VLAN109_CASONA_1",
        "created_at": "2024-06-19T18:31:37.408528",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4312,
      "client_name": "INVERSIONES FRANCISCO GUEDEZ FP",
      "client_type_name": "PYME",
      "client_subdivision": "CANCELADO_PYME",
      "status_name": "Cancelado",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Las Rurales",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04121484128",
      "client_email": "FGUEDEZ04@GMAIL.COM",
      "address": "LAS RURALES CALLE BOLIVAR NRO 19 ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V261407422",
      "nap_box_name": "614",
      "created_at": "2024-06-06T17:06:15.003822",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4313,
      "client_name": "AGUSTIN ALEXANDER HURTADO CASTILLO F.P.",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04144627529",
      "client_email": "AGUSTINHURTADOJR@GMAIL.COM",
      "address": "CALLE RIVAS ENTRE NEGRO PRIMERO Y CAMPO ELÍAS LOCAL NRO 48 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V11978135",
      "nap_box_name": "CTO-00066",
      "created_at": "2024-06-06T17:14:53.303116",
      "service_detail": {
        "id": 3059,
        "ip": "172.28.166.2",
        "mac": "HWTC25B9BDA1",
        "serial": "HWTC25B9BDA1",
        "queue": "Plan_92036_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-06-22T10:08:27.962436",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4314,
      "client_name": "AUTO ACCESORIOS 4X4 GAMARRA",
      "client_type_name": "PYME",
      "client_subdivision": "CANCELADO_PYME",
      "status_name": "Cancelado",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Prados III",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04127774510",
      "client_email": "AUTOACCESORIOS4X4WDR@GMAIL.COM",
      "address": "AV PRINCIPAL PRADOS III LOCAL NRO 1 ROSARIO DE PAYA TURMERO EDO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V194181953",
      "nap_box_name": "CTO-00021",
      "created_at": "2024-06-07T08:14:32.873122",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4315,
      "client_name": "PANADERIA JONATAN MARTINEZ FP",
      "client_type_name": "PYME",
      "client_subdivision": "CANCELADO_PYME",
      "status_name": "Cancelado",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04128899112",
      "client_email": "JM8024743@GMAIL.COM",
      "address": "PATÍN CALLE 3B LOCAL NRO 55 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V22949016",
      "nap_box_name": "CE-00043",
      "created_at": "2024-06-07T08:18:23.898045",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4317,
      "client_name": "OLGA AYARIS ARAUJO MELENDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Terrazas de Paya",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144614864",
      "client_email": "JEISYLOPE77@GMAIL.COM",
      "address": "CALLE 8 CASA NRO 2 URB PANTIN ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V14578840",
      "nap_box_name": "595",
      "created_at": "2024-06-07T08:31:31.016103",
      "service_detail": {
        "id": 3029,
        "ip": "172.28.14.2",
        "mac": "TPLGF9CD3E5F",
        "serial": "TPLGF9CD3E5F",
        "queue": "queue1",
        "interface": "VLAN229_PANTIN",
        "created_at": "2024-06-22T09:23:19.776671",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4318,
      "client_name": "INVERSIONES ISABEL MEDINA FP",
      "client_type_name": "PYME",
      "client_subdivision": "CANCELADO_PYME",
      "status_name": "Cancelado",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Las Rurales",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04121484452",
      "client_email": "MEDINAISABEL024@GMAIL.COM",
      "address": "CALLE SUCRE CRUCE CON BOLIVAR CASA 19/3 TURMERO CODIGO POSTAL 2115",
      "client_identification": "V96121691",
      "nap_box_name": "614",
      "created_at": "2024-06-07T08:35:17.216868",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4319,
      "client_name": "ALBA MARINA PORTILLO SANCHEZ",
      "client_type_name": "PYME",
      "client_subdivision": "CANCELADO_PYME",
      "status_name": "Cancelado",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04243585704",
      "client_email": "ROSMEPS2001@GMAIL.COM",
      "address": "PB NRO 18 CC RANDAZZO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V201077954",
      "nap_box_name": "CTO-0650",
      "created_at": "2024-06-07T08:58:22.097600",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4320,
      "client_name": "INVERSIONES DON HARRY FIGUEROA FP",
      "client_type_name": "PYME",
      "client_subdivision": "CANCELADO_PYME",
      "status_name": "Cancelado",
      "cycle": 10,
      "migrate": true,
      "sector_name": "El Naranjal",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04128908757",
      "client_email": "FATIMADANIELA2508@GMAIL.COM",
      "address": "CC VALLE DE PAYA LOCAL NRO 1 AV PRINCIPAL ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V261612344",
      "nap_box_name": "482",
      "created_at": "2024-06-07T09:26:15.309016",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4321,
      "client_name": "FARMACIA POPULAR DE PAYA CA",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "El Naranjal",
      "plan": {
        "id": 36,
        "name": "RECURRENTE PYME PLAN 650M",
        "cost": "70.18",
        "code": "FOP650M",
        "profile": "650M/650M"
      },
      "client_mobile": "04243791788",
      "client_email": "FARMPAYA@HOTMAIL.COM",
      "address": "SECTOR GRANJA EL NARANJAL TURMERO EDO ARAGUA ROSARIO DE PAYA 2115",
      "client_identification": "J311984224",
      "nap_box_name": "482",
      "created_at": "2024-06-07T12:32:47.316046",
      "service_detail": {
        "id": 3684,
        "ip": "172.25.223.2",
        "mac": "VSOL00D0E41F",
        "serial": "VSOL00D0E41F",
        "queue": "Plan_162002_30183_WispHub",
        "interface": "VLAN246_NARANJAL",
        "created_at": "2024-07-11T20:19:59.600604",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4322,
      "client_name": "DEISY MARYLIN GUZMAN GARCIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 19,
        "name": "RECURRENTE RESIDENCIAL PLAN 1GB",
        "cost": "74.70",
        "code": "FOR1GB",
        "profile": "1000M/1000M"
      },
      "client_mobile": "04144773428",
      "client_email": "DEYMARG16@GMAIL.COM",
      "address": "SECTOR VALLE LINDO AV PRINCIPAL ALCALDIA MUNICIPIO SANTIAGO MARIÑO DIRECCION DE TRIBUTOS INTERNOS TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V9961272",
      "nap_box_name": "110",
      "created_at": "2024-06-07T13:03:55.803390",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4323,
      "client_name": "TERES SHOP FP",
      "client_type_name": "PYME",
      "client_subdivision": "CANCELADO_PYME",
      "status_name": "Cancelado",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04128903502",
      "client_email": "TERESSHOP@GMAIL.COM",
      "address": "CALLE MARIÑO CC PASEO MARIÑO NIVEL PB LOCAL 11-5 SECTOR CENTRO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V229483087",
      "nap_box_name": "CTO-00256",
      "created_at": "2024-06-07T13:18:24.721362",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4324,
      "client_name": "KELVIN JOSE SANCHEZ CERVEN",
      "client_type_name": "PYME",
      "client_subdivision": "CANCELADO_PYME",
      "status_name": "Cancelado",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Simon Bolivar",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04243343398",
      "client_email": "KELVINSAN1991@GMAIL.COM",
      "address": "URB SIMON BOLIVAR AV PRINCIPAL LOCAL 29-A 29-B SECTOR EL MACARO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V21202604",
      "nap_box_name": "CTO-00043",
      "created_at": "2024-06-07T13:22:09.405562",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4325,
      "client_name": "DANITH ESCOBAR DE RODRIGUEZ",
      "client_type_name": "PYME",
      "client_subdivision": "CANCELADO_PYME",
      "status_name": "Cancelado",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04166284483",
      "client_email": "ROGER@GMAIL.COM",
      "address": "CALLE RIVAS CC RANDAZZO NIVEL PLANTA BAJA LOCAL 53 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V15508838",
      "nap_box_name": "CTO-0650",
      "created_at": "2024-06-07T13:24:30.814467",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4326,
      "client_name": "JONATHAN RAFAEL GOMEZ RIVAS",
      "client_type_name": "PYME",
      "client_subdivision": "CANCELADO_PYME",
      "status_name": "Cancelado",
      "cycle": 10,
      "migrate": true,
      "sector_name": "La Casona II",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04143436190",
      "client_email": "GOMEZ0511@HOTMAIL.COM",
      "address": "CALLE 12 CASA NRO 4-A LA CASONA II",
      "client_identification": "V14786393",
      "nap_box_name": "322",
      "created_at": "2024-06-07T13:27:11.539740",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4327,
      "client_name": "BELLEZA STORE FIGUEROA FP",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04122612738",
      "client_email": "MARIALCISDVALLE15@GMAIL.COM",
      "address": "CALLE MARIÑO  CC JARDIN NIVEL PB LOCAL 1 SECTOR CENTRO TURMERO",
      "client_identification": "V180821232",
      "nap_box_name": "CTO-00256",
      "created_at": "2024-06-07T13:29:24.350654",
      "service_detail": {
        "id": 3652,
        "ip": "172.23.14.2",
        "mac": "HWTC155869A1",
        "serial": "HWTC155869A1",
        "queue": "Plan_92036_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-07-11T18:01:30.357496",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4328,
      "client_name": "JESUS ENRIQUE PEREZ PRESILIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "SUSPENDIDO_RESIDENCIAL",
      "status_name": "Suspendido",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121346243",
      "client_email": "jesusperez994@gmail.com",
      "address": "CALLE CEDEÑO CON CALLE MIRANDA EDIF CENTRO PROFESIONAL LOS CHAGUARAMOS PISO 1 OF 1 SECTOR CENTRO TURMERO ARAGUA",
      "client_identification": "V14500740",
      "nap_box_name": "279",
      "created_at": "2024-06-07T13:32:47.827691",
      "service_detail": {
        "id": 13134,
        "ip": "172.27.33.2",
        "mac": "TP:LG:F9:CD:46:7F",
        "serial": "TPLGF9CD467F",
        "queue": null,
        "interface": "VLAN200_OLTs",
        "created_at": "2026-10-07T15:23:03.802708",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4330,
      "client_name": "ONANGIE GRISEL CORREA HERRERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144862561",
      "client_email": "ONANGIEC@GMAIL.COM",
      "address": "CALLE 05 CASA NRO 350 SECTOR MATA CABALLO ROSARIO DE PAYA",
      "client_identification": "V14944128",
      "nap_box_name": "CTO-00182",
      "created_at": "2024-06-07T13:59:31.375105",
      "service_detail": {
        "id": 5797,
        "ip": "172.24.86.2",
        "mac": "TPLGF4B1D49A",
        "serial": "TPLGF4B1D49A",
        "queue": "Plan_161903_30183_WispHub",
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2024-08-19T17:10:56.823364",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4331,
      "client_name": "FELIX ISMALDO PALACIOS VASQUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "San Carlos",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121630708",
      "client_email": "PROYECTORODIMA@GMAIL.COM",
      "address": "AV B CASA NRO B-35 URB SAN CARLOS TURMERO",
      "client_identification": "V3156910",
      "nap_box_name": "136",
      "created_at": "2024-06-07T14:06:00.876691",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4332,
      "client_name": "ADRIANA YEGSIMAR QUINTANA CABALLERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero I",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243084907",
      "client_email": "ADRIANAQUINTANA300@GMAIL.COM",
      "address": "CALLE  DE SERVICIO  LOCAL NRO 3 SAMAN  TARAZONERO I EL MACARO",
      "client_identification": "V138125366",
      "nap_box_name": "128",
      "created_at": "2024-06-07T14:10:08.398496",
      "service_detail": {
        "id": 3648,
        "ip": "172.23.140.2",
        "mac": "VSOL0012BC39",
        "serial": "VSOL0012BC39",
        "queue": "queue1",
        "interface": "VLAN112_LA_MACARENA_ZTE",
        "created_at": "2024-07-11T17:51:35.213147",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4333,
      "client_name": "JOSEFA MONTANO HURTADO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243386204",
      "client_email": "JOSEFAM190478@GMAIL.COM",
      "address": "CALLE 9 CASA NRO 595-A URB MATA CABALLO",
      "client_identification": "E83958010",
      "nap_box_name": "160",
      "created_at": "2024-06-07T14:10:31.231161",
      "service_detail": {
        "id": 10094,
        "ip": "172.23.238.2",
        "mac": "TPLGF4B1D9D2",
        "serial": "TPLGF4B1D9D2",
        "queue": null,
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2025-11-13T13:49:30.152849",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4334,
      "client_name": "GIGIBET SAEZ LINARES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243759512",
      "client_email": "GIGISAEZ1@GMAIL.COM",
      "address": "CALLE 12 CASA NRO 697-C MATA CABALLO ROSARIO DE PAYA",
      "client_identification": "V14491284",
      "nap_box_name": "CTO-00433",
      "created_at": "2024-06-07T14:13:33.254201",
      "service_detail": {
        "id": 5795,
        "ip": "172.23.143.2",
        "mac": "TPLGF4EFC439",
        "serial": "TPLGF4EFC439",
        "queue": "Plan_161903_30183_WispHub",
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2024-08-19T17:06:31.039462",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4336,
      "client_name": "BELKIS DEL CARMEN BOLIVAR MARTINEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243758136",
      "client_email": "BELKISBOLIVAR1972@GMAIL.COM",
      "address": "MANZANA B-2 CASA NRO 5 SAMAN TARAZONERO II TURMERO",
      "client_identification": "V10269788",
      "nap_box_name": "128",
      "created_at": "2024-06-07T14:17:59.640271",
      "service_detail": {
        "id": 5794,
        "ip": "172.31.3.2",
        "mac": "TPLGF4B1D3F2",
        "serial": "TPLGF4B1D3F2",
        "queue": "Plan_127744_1574_WispHub",
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2024-08-19T17:04:20.161823",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4337,
      "client_name": "JESENIA BEATRIZ ZARRAMERA FREITES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243199536",
      "client_email": "JESENIAZARRAMERA34@GMAIL.COM",
      "address": "CALLE PRINCIPAL MANZANA B9 NRO 17 SAMAN TARAZONERO II",
      "client_identification": "V15077794",
      "nap_box_name": "185",
      "created_at": "2024-06-07T14:25:32.514993",
      "service_detail": {
        "id": 3492,
        "ip": "172.24.107.2",
        "mac": "TPLGF4B1D878",
        "serial": "TPLGF4B1D878",
        "queue": "Plan_92034_1574_WispHub",
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2024-07-05T17:10:07.680731",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4338,
      "client_name": "YENZO ENRIQUE ESAA APONTE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144570454",
      "client_email": "YENZOESAA18@GMAIL.COM",
      "address": "CALLE PRINCIPAL MANZANA H CASA NRO 19 SAMAN TARAZONERO II",
      "client_identification": "V18473136",
      "nap_box_name": "510 DOS",
      "created_at": "2024-06-07T14:29:08.315530",
      "service_detail": {
        "id": 5793,
        "ip": "172.24.75.2",
        "mac": "TPLGF4EFC0F8",
        "serial": "TPLGF4EFC0F8",
        "queue": "Plan_137413_1574_WispHub",
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2024-08-19T17:01:57.274604",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4339,
      "client_name": "IRENES MARIA CABEZA LEAL",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04147791005",
      "client_email": "MIS4TSOROS@GMAIL.COM",
      "address": "Prado 1 calle 6 casa #60",
      "client_identification": "V19515555",
      "nap_box_name": "CTO-00311",
      "created_at": "2024-06-07T14:34:14.753341",
      "service_detail": {
        "id": 4256,
        "ip": "172.31.4.2",
        "mac": "TPLGF4B1D5DD",
        "serial": "TPLGF4B1D5DD",
        "queue": "Plan_161901_30183_WispHub",
        "interface": "VLAN239_PRADOS1",
        "created_at": "2024-08-07T18:58:49.646999",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4340,
      "client_name": "SERVICIO Y CONSULTORIA DELIRA CA",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04243072952",
      "client_email": "SOMOSDELIRA@GMAIL.COM",
      "address": "CALLE MIRANDA EDF GIUROS NIVEL 3 OF 31 SECTOR CENTRO TURMERO",
      "client_identification": "J410206411",
      "nap_box_name": "CTO-00038",
      "created_at": "2024-06-07T14:40:27.109728",
      "service_detail": {
        "id": 3053,
        "ip": "172.30.24.2",
        "mac": "OEMT3C625FEE",
        "serial": "OEMT3C625FEE",
        "queue": "Plan_92036_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-06-22T09:52:05.790196",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4341,
      "client_name": "AURA LISETTE CARRASQUEL RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128700685",
      "client_email": "CARRASQUELLISETTE@GMAIL.COM",
      "address": "VDA SAMAN TARAZONERO II MANZANA E10 CASA NRO 24 TURMERO",
      "client_identification": "V9676573",
      "nap_box_name": "95",
      "created_at": "2024-06-07T14:42:27.838793",
      "service_detail": {
        "id": 3559,
        "ip": "172.24.76.2",
        "mac": "TPLGF4EFBDC6",
        "serial": "TPLGF4EFBDC6",
        "queue": "Plan_92034_1574_WispHub",
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2024-07-09T09:47:13.200351",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4342,
      "client_name": "ABASTOS Y CHARCUTERIA SAN MIGUEL ARCANGEL CA",
      "client_type_name": "PYME",
      "client_subdivision": "CANCELADO_PYME",
      "status_name": "Cancelado",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04124520153",
      "client_email": "DAYANALISBETHGE@HOTMAIL.COM",
      "address": "CALLE PETION CON RIVAS CASA PARCELA NRO2-B1 SECTOR TURMERO",
      "client_identification": "J502809198",
      "nap_box_name": "CE - 758",
      "created_at": "2024-06-07T14:43:27.062171",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4343,
      "client_name": "NEXICA YENIRETH COLMENARES BLANCA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243773383",
      "client_email": "NEXICACOLMENARES@HOTMAIL.COM",
      "address": "PANTIN CALLE 3A NRO 29",
      "client_identification": "V20757770",
      "nap_box_name": "CTO-00127 DOS",
      "created_at": "2024-06-07T14:47:08.812536",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4344,
      "client_name": "AMERICA DEL CARMEN LINARES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243348064",
      "client_email": "GASL692@GMAIL.COM",
      "address": "CALLE 3B CASA NRO 37 URB PANTIN ROSARIO DE PAYA TURMERO",
      "client_identification": "V7228665",
      "nap_box_name": "CE-00043",
      "created_at": "2024-06-07T14:52:03.649907",
      "service_detail": {
        "id": 5791,
        "ip": "172.24.93.2",
        "mac": "TPLGF4EFC538",
        "serial": "TPLGF4EFC538",
        "queue": "Plan_161903_30183_WispHub",
        "interface": "VLAN229_PANTIN",
        "created_at": "2024-08-19T16:53:31.162600",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4345,
      "client_name": "DARIANYITT VIRGINIA APONTE TOVAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Guanarito",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04129694488",
      "client_email": "ROMIANNYL@GMAIL.COM",
      "address": "CALLE LOS NARANJOS VEREDA RUIZ PINEDA CASA NRO 14 SECTOR GUANARITO",
      "client_identification": "V20056394",
      "nap_box_name": "CTO-00214",
      "created_at": "2024-06-07T14:57:00.633473",
      "service_detail": {
        "id": 5790,
        "ip": "172.19.1.2",
        "mac": "TPLGF4EFBC37",
        "serial": "TPLGF4EFBC37",
        "queue": "Plan_128612_15811_WispHub",
        "interface": "VLAN232_GUANARITO_OLT2",
        "created_at": "2024-08-19T16:50:48.918002",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4346,
      "client_name": "JOSE EUGENIO LOBO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Guanarito",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04263490357",
      "client_email": "JOSEEUGENIOLOBO@GMAIL.COM",
      "address": "CALLE ARAGUANEY CASA NRO 18 SECTOR GUANARITO TURMERO",
      "client_identification": "V11319726",
      "nap_box_name": "434",
      "created_at": "2024-06-07T15:03:23.378222",
      "service_detail": {
        "id": 5789,
        "ip": "172.22.188.2",
        "mac": "TPLGF4B1DB91",
        "serial": "TPLGF4B1DB91",
        "queue": "Plan_128612_15811_WispHub",
        "interface": "VLAN232_GUANARITO_OLT2",
        "created_at": "2024-08-19T16:48:16.245784",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4347,
      "client_name": "FRANKLIN JOSE SALAS VENEGAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04226322346",
      "client_email": "FRANVE2711@GMAIL.COM",
      "address": "CALLE 1 EDIF URQUIA PISO 1 APT 3 URB HACIENDA EL NISPERO TURMERO",
      "client_identification": "V24498118",
      "nap_box_name": "CTO-00296",
      "created_at": "2024-06-07T15:08:15.268050",
      "service_detail": {
        "id": 8107,
        "ip": "172.23.6.2",
        "mac": "TPLGF4EFC1AB",
        "serial": "TPLGF4EFC1AB",
        "queue": "Plan_107915_15811_WispHub",
        "interface": "VLAN218_NISPEROS_OLT1",
        "created_at": "2025-04-03T09:32:06.736640",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4349,
      "client_name": "MAYERKY ANYURY GARCIA ESPIDEA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Paya Abajo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121492340",
      "client_email": "GMAYERKI@GMAIL.COM",
      "address": "CALLE DEL CENTRO CASA NRO 10 SECTOR PAYA ABAJO ROSARIO DE PAYA",
      "client_identification": "V19131181",
      "nap_box_name": "271",
      "created_at": "2024-06-07T15:18:49.540535",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4350,
      "client_name": "SENOR TEQUEÑOS CA",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 102,
        "name": "RECURRENTE PYME PLAN 150M",
        "cost": "27.60",
        "code": "FOP150M",
        "profile": "150Mbps/150Mbps"
      },
      "client_mobile": "04127707438",
      "client_email": "LARRYAVILA2019@GMAIL.COM",
      "address": "CALLE RIVAS CON MADARIAGA NRO 11 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "J502758240",
      "nap_box_name": "CTO-00066",
      "created_at": "2024-06-07T15:21:03.526883",
      "service_detail": {
        "id": 9035,
        "ip": "10.15.91.2",
        "mac": "OEMT3C6258CA",
        "serial": "OEMT3C6258CA",
        "queue": "queue1",
        "interface": "VLAN200_OLTs",
        "created_at": "2025-06-21T17:46:47.857526",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4351,
      "client_name": "SANDRA ENCARNACION BLANCO BRICEÑO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Bicentenario",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128811764",
      "client_email": "PAYATURMERO@GMAIL.COM",
      "address": "CALLE FRANCISCO DE MIRANDA MANZANA A CASA NRO 23 SECTOR DESARROLLO URBANISTICO",
      "client_identification": "V12143791",
      "nap_box_name": "388",
      "created_at": "2024-06-07T15:24:45.301099",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4352,
      "client_name": "GEOIN CA",
      "client_type_name": "PYME",
      "client_subdivision": "CANCELADO_PYME",
      "status_name": "Cancelado",
      "cycle": 10,
      "migrate": true,
      "sector_name": "San Pablo",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04144940683",
      "client_email": "SERVICIOS.GEOIN@GMAIL.COM",
      "address": "AV PRINCIPAL CC VALLE LINDO NIVEL PB LOCAL N09 URB VALLE LINDO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "J312678968",
      "nap_box_name": "CTO-0637",
      "created_at": "2024-06-07T15:24:55.427198",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4353,
      "client_name": "INDUSTRIAS CASA TURMERO CA",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "San Pablo",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04128704372",
      "client_email": "CHINFUAM168@GMAIL.COM",
      "address": "AV PRINCIPAL LOCAL GALPÓN NRO 31-A ZONA INDUSTRIAL SAN PABLO TURMERO ARAGUA ZONA POSTAL 211",
      "client_identification": "J310561370",
      "nap_box_name": "CTO-00322",
      "created_at": "2024-06-07T15:27:32.783025",
      "service_detail": {
        "id": 9732,
        "ip": "172.28.207.2",
        "mac": "HWTC2A13B5A1",
        "serial": "HWTC2A13B5A1",
        "queue": null,
        "interface": "VLAN224_SAN_PABLO_OLT1",
        "created_at": "2025-11-10T11:21:04.936917",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4354,
      "client_name": "AURA ARRIECHI GLOBAL FIBER",
      "client_type_name": "INTERCAMBIO",
      "client_subdivision": "ACTIVO_INTERCAMBIO",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "El Macaro",
      "plan": {
        "id": 83,
        "name": "RECURRENTE INSTITUCIONAL 80M",
        "cost": "0.00",
        "code": "FO-R80",
        "profile": "80M/80M"
      },
      "client_mobile": "04243170748",
      "client_email": "aurayaziraarriechi@gmail.com",
      "address": "CALLE 3 NRO 43 SAMAN TARAZONERO I  SECTOR EL MACARO  TURMERO ESTADO ARAGUA",
      "client_identification": "V11091939",
      "nap_box_name": "32",
      "created_at": "2024-06-07T15:28:46.008757",
      "service_detail": {
        "id": 11853,
        "ip": "172.18.107.2",
        "mac": "HWTC318A35A1",
        "serial": "HWTC318A35A1",
        "queue": null,
        "interface": "VLAN140_SMT1_ZTE",
        "created_at": "2026-02-27T12:45:39.672669",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4355,
      "client_name": "YARITZA YAMILET CONCEPCION VEGAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124157021",
      "client_email": "YAMYVEGAS16@GMAIL.COM",
      "address": "CALLE PRINCIPAL EDIF TORRES 19 PISO 4 APT 4 URB HACIENDA LOS NISPEROS TURMERO",
      "client_identification": "V13908345",
      "nap_box_name": "CTO-00464 DOS",
      "created_at": "2024-06-07T15:48:15.703784",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4357,
      "client_name": "YIZET JENIREE COELLO HURTADO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04141524788",
      "client_email": "YCOELLO24@GMAIL.COM",
      "address": "CALLE 05 CASA NRO 318 URB MATA CABALLO ROSARIO DE PAYA",
      "client_identification": "V20334786",
      "nap_box_name": "CTO-00182",
      "created_at": "2024-06-08T08:20:36.994014",
      "service_detail": {
        "id": 5785,
        "ip": "172.21.48.2",
        "mac": "TPLGF4EFBF61",
        "serial": "TPLGF4EFBF61",
        "queue": "Plan_161870_30181_WispHub",
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2024-08-19T16:35:21.136786",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4358,
      "client_name": "YADIXI NATHALIE ACERO NAVAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128498640",
      "client_email": "yxavi4020@gmail.com",
      "address": "CALLE PRINCIPAL MANZANA H CASA NRO 8-14 SAMAN TARAZONERO II",
      "client_identification": "V16902614",
      "nap_box_name": "510 DOS",
      "created_at": "2024-06-08T08:26:40.974490",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4359,
      "client_name": "CENTRO DE APUESTAS LOTTO FORTUNA CA",
      "client_type_name": "PYME",
      "client_subdivision": "CANCELADO_PYME",
      "status_name": "Cancelado",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04243493450",
      "client_email": "LOTTOFORTUNALL@GMAIL.COM",
      "address": "CALLE RIVAS CC CANDY NIVEL PB LOCAL 73 Y 74 SECTOR CENTRO DE TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "J503015365",
      "nap_box_name": "CE - 758",
      "created_at": "2024-06-08T08:33:51.183971",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4360,
      "client_name": "ROSANNA VASQUEZ VASQUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Bicentenario",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243300021",
      "client_email": "ROSANNAVASQUEZ48@GMAIL.COM",
      "address": "CALLE SIMON RODRIGUEZ MANZANA 13 CASA NRO 11 URB DESARROLLO URBANISTICO ROSARIO DE PAYA",
      "client_identification": "V9644981",
      "nap_box_name": "382",
      "created_at": "2024-06-08T08:36:53.234803",
      "service_detail": {
        "id": 5783,
        "ip": "172.21.49.2",
        "mac": "TPLGF4EFC244",
        "serial": "TPLGF4EFC244",
        "queue": "Plan_161900_30183_WispHub",
        "interface": "VLAN243_BICENTENARIO",
        "created_at": "2024-08-19T16:27:57.400075",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4361,
      "client_name": "FERREMAT PAYA CA",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Paya Abajo",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04143925487",
      "client_email": "pferremat@gmail.com",
      "address": "AV PPAL PAYA LOCAL NRO S/N SECTOR PAYA ABAJO ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "J297333096",
      "nap_box_name": "CE - 773",
      "created_at": "2024-06-08T08:37:50.157827",
      "service_detail": {
        "id": 7481,
        "ip": "172.28.74.2",
        "mac": "ZICGCBB6AD83",
        "serial": "ZICGCBB6AD83",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN231_PAYABAJO",
        "created_at": "2024-12-17T10:48:23.670329",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4362,
      "client_name": "CONFECCIONES SAILU CA",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Valle Verde",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04127766524",
      "client_email": "CONFECCIONESSAILU@GMAIL.COM",
      "address": "CALLE RIOS CASA NRO 6-1 SECTOR VALLE VERDE ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "J404534539",
      "nap_box_name": "CTO-0613",
      "created_at": "2024-06-08T08:40:18.262613",
      "service_detail": {
        "id": 12122,
        "ip": "172.28.12.2",
        "mac": "HWTC467FA19B",
        "serial": "HWTC467FA19B",
        "queue": null,
        "interface": "VLAN253_VALLE_VERDE",
        "created_at": "2026-03-18T15:24:09.109309",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4363,
      "client_name": "BRAYHAN JOSE PAEZ MAGALLANES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados I",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124406259",
      "client_email": "NIOIN55555@GMAIL.COM",
      "address": "AV 1 CASA NRO 06 SECTOR PRADOS 1 TURMERO",
      "client_identification": "V20989201",
      "nap_box_name": "CTO-00304",
      "created_at": "2024-06-08T08:41:05.988720",
      "service_detail": {
        "id": 5781,
        "ip": "172.20.252.2",
        "mac": "TPLGF4B1D3F5",
        "serial": "TPLGF4B1D3F5",
        "queue": "Plan_161903_30183_WispHub",
        "interface": "VLAN239_PRADOS1",
        "created_at": "2024-08-19T16:11:37.542396",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4364,
      "client_name": "OASIS 23 CA",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04243645148",
      "client_email": "VCTORIIAG@GMAIL.COM",
      "address": "CALLE RICAURTE LOCAL NRO 111 LOCAL 111 SECTOR TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "J503338032",
      "nap_box_name": "CTO-00403",
      "created_at": "2024-06-08T08:43:41.616880",
      "service_detail": {
        "id": 3058,
        "ip": "172.26.195.2",
        "mac": "TPLGF9CD463C",
        "serial": "TPLGF9CD463C",
        "queue": "Plan_92036_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-06-22T10:06:11.597680",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4365,
      "client_name": "REBECA FERNANDEZ LUGO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Durpa",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243466388",
      "client_email": "REBEFERLU1968@GMAIL.COM",
      "address": "CALLE LIBERTAD MANZANA  14 CASA NRO 23 URB ROSARIO DE PAYA",
      "client_identification": "V8690652",
      "nap_box_name": "377",
      "created_at": "2024-06-08T08:45:29.969181",
      "service_detail": {
        "id": 9804,
        "ip": "172.22.55.2",
        "mac": "TPLGF4B1D9C7",
        "serial": "TPLGF4B1D9C7",
        "queue": null,
        "interface": "VLAN240_DURPA",
        "created_at": "2025-11-10T15:39:53.335156",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4366,
      "client_name": "INVERSIONES ABRAHAN 2015 CA",
      "client_type_name": "PYME",
      "client_subdivision": "CANCELADO_PYME",
      "status_name": "Cancelado",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04125313522",
      "client_email": "ANTONIOABRAHAMOCHOA@HOTMAIL.COM",
      "address": "CALLE RIVAS LOCAL NRO 31-A SECTOR CENTRO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "J406484580",
      "nap_box_name": "CTO-00502",
      "created_at": "2024-06-08T08:49:43.575412",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4367,
      "client_name": "LISBYNETH MARGARITA BARRETO SILVA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Durpa",
      "plan": {
        "id": 101,
        "name": "RECURRENTE RESIDENCIAL PLAN 200M",
        "cost": "19.00",
        "code": "FOR200MB",
        "profile": "200Mbps/200Mbps"
      },
      "client_mobile": "04128461126",
      "client_email": "BARRETOLISBYONET130@GMAIL.COM",
      "address": "CALLE LOS CAOBOS  MANZANA  16 CASA NRO 23 URB DESARROLLO URBANISTICO PAYA",
      "client_identification": "V18692393",
      "nap_box_name": "392",
      "created_at": "2024-06-08T08:51:52.424923",
      "service_detail": {
        "id": 11021,
        "ip": "172.31.1.2",
        "mac": "TPLGF4EFC138",
        "serial": "TPLGF4EFC138",
        "queue": null,
        "interface": "VLAN240_DURPA",
        "created_at": "2026-01-06T14:32:58.330917",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4368,
      "client_name": "DISTRIBUIDORA JAQUE MARKET CA",
      "client_type_name": "PYME",
      "client_subdivision": "CANCELADO_PYME",
      "status_name": "Cancelado",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Antigua Hacienda De Paya",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04243445527",
      "client_email": "cca93384@GMAIL.COM",
      "address": "CRTA TURMERO PAYA CALLE ANPHILOQUIO LOCAL PARCELA P-2 NRO 1 SECTOR SANTIAGO MARIÑO MARACAY ARAGUA",
      "client_identification": "J504704792",
      "nap_box_name": "98",
      "created_at": "2024-06-08T08:52:06.921954",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4369,
      "client_name": "INVERSIONES DOBLE TT 2021 CA",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "El Macaro",
      "plan": {
        "id": 102,
        "name": "RECURRENTE PYME PLAN 150M",
        "cost": "27.60",
        "code": "FOP150M",
        "profile": "150Mbps/150Mbps"
      },
      "client_mobile": "04144779742",
      "client_email": "INVERSIONESDOBLETT@GMAIL.COM",
      "address": "CRTA VIA MACARO PARCELA #13 LOCAL NRO 03 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "J501774013",
      "nap_box_name": "CTO-0245",
      "created_at": "2024-06-08T08:54:58.565298",
      "service_detail": {
        "id": 3068,
        "ip": "172.27.161.2",
        "mac": "HWTCD148EE9A",
        "serial": "HWTCD148EE9A",
        "queue": "Plan_92033_1574_WispHub",
        "interface": "VLAN104_EL_MACARO_OLT_ZTE",
        "created_at": "2024-06-22T10:48:36.591832",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4370,
      "client_name": "ANDRY KARINA RAMIREZ ALVAREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04125065330",
      "client_email": "ANDRYKARINA3@GMAIL.COM",
      "address": "CALLE 6 CASA NRO 34 SECTOR SAMAN TARAZONERO I",
      "client_identification": "V11119009",
      "nap_box_name": "270",
      "created_at": "2024-06-08T08:56:23.207296",
      "service_detail": {
        "id": 10021,
        "ip": "172.24.101.2",
        "mac": "TPLGF4EFC30B",
        "serial": "TPLGF4EFC30B",
        "queue": null,
        "interface": "VLAN140_SMT1_ZTE",
        "created_at": "2025-11-11T15:25:02.780603",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4371,
      "client_name": "INVERSIONES GOLDEN 3 CA",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 102,
        "name": "RECURRENTE PYME PLAN 150M",
        "cost": "27.60",
        "code": "FOP150M",
        "profile": "150Mbps/150Mbps"
      },
      "client_mobile": "04144905577",
      "client_email": "CAROLINADEBETANCOURT@GMAIL.COM",
      "address": "CALLE 18 - B CASA NRO 45 URB PANTIN ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "J501908885",
      "nap_box_name": "CTO-00321",
      "created_at": "2024-06-08T08:57:04.902595",
      "service_detail": {
        "id": 7765,
        "ip": "172.27.195.2",
        "mac": "OEMT3C624472",
        "serial": "OEMT3C624472",
        "queue": "Plan_161872_30181_WispHub",
        "interface": "VLAN229_PANTIN",
        "created_at": "2025-02-22T17:48:44.856782",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4372,
      "client_name": "LA BARBA DI DAVINCI CA",
      "client_type_name": "PYME",
      "client_subdivision": "CANCELADO_PYME",
      "status_name": "Cancelado",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04144650002",
      "client_email": "AGUILARPELAYOJA@GMAIL.COM",
      "address": "CALLE MIRANDA LOCAL NRO 44-1 SECTOR CENTRO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "J502973559",
      "nap_box_name": "CTO-00038",
      "created_at": "2024-06-08T08:59:27.274984",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4373,
      "client_name": "EL CORDERO DE DIOS CA",
      "client_type_name": "PYME",
      "client_subdivision": "CANCELADO_PYME",
      "status_name": "Cancelado",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Prados III",
      "plan": {
        "id": 102,
        "name": "RECURRENTE PYME PLAN 150M",
        "cost": "27.60",
        "code": "FOP150M",
        "profile": "150Mbps/150Mbps"
      },
      "client_mobile": "04120381677",
      "client_email": "LUISANGELARODRIGUEZ217@GMAIL.COM",
      "address": "CALLE 6 CASA NRO 60 SECTOR PRADOS DE PAYA III ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "J407786318",
      "nap_box_name": "395",
      "created_at": "2024-06-08T09:01:54.993653",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4374,
      "client_name": "JOHNAIFA MAITHE RODRIGUEZ ALVAREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243313889",
      "client_email": "JOHNAIFARG@GMAIL.COM",
      "address": "CALLE 9 CASA 589-B URB MATA CABALLO TURMERO ARAGUA",
      "client_identification": "V15601172",
      "nap_box_name": "CE - 566",
      "created_at": "2024-06-08T09:03:48.696497",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4375,
      "client_name": "MAXI LIMPIO DE TURMERO CA",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04147165654",
      "client_email": "LUIS.MIERYTERAN16@GMAIL.COM",
      "address": "CALLE PETION CC DON LOREÑO NIVEL PB LOCAL 5-1 SECTOR CENTRO DE TURMERO 2115",
      "client_identification": "J411637963",
      "nap_box_name": "CTO-00030",
      "created_at": "2024-06-08T09:04:59.835237",
      "service_detail": {
        "id": 3022,
        "ip": "172.27.118.2",
        "mac": "HWTC90B9AF9B",
        "serial": "HWTC90B9AF9B",
        "queue": "Plan_92036_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-06-21T18:58:42.655359",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4376,
      "client_name": "KELLY GERALDINE INFANTE MIRELES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Esperanza",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121487078",
      "client_email": "KELLY26095548@GMAIL.COM",
      "address": "CALLE 19 CASA  NRO 10 SECTOR EL MACARO",
      "client_identification": "V26095548",
      "nap_box_name": "555",
      "created_at": "2024-06-08T09:07:59.634795",
      "service_detail": {
        "id": 5769,
        "ip": "172.20.128.2",
        "mac": "TPLGF4B1D3FA",
        "serial": "TPLGF4B1D3FA",
        "queue": "Plan_127744_1574_WispHub",
        "interface": "VLAN137_LA_ESPERANZA_OLT_ZTE",
        "created_at": "2024-08-19T15:40:36.946637",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4377,
      "client_name": "DISTRIBUCIONES VIRGEN DE BELEN CA",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04144682674",
      "client_email": "JESUSBERMEJO93D@GMAIL.COM",
      "address": "CALLE SANTO NIÑO DE ATOCHA LOCAL NRO 3-2 SECTOR CENTRO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "J413179660",
      "nap_box_name": "CTO - 857",
      "created_at": "2024-06-08T09:08:41.102957",
      "service_detail": {
        "id": 3924,
        "ip": "172.26.57.2",
        "mac": "HWTC54A577A3",
        "serial": "HWTC54A577A3",
        "queue": "Plan_92036_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-07-17T10:04:29.836654",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4378,
      "client_name": "BODEGON QUIEN DIJO MIEDO CA",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Paya Abajo",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04244357344",
      "client_email": "JOSEGARCIA9630@GMAIL.COM",
      "address": "AV PRINCIPAL ROSARIO DE PAYA LOCAL NRO 9-B SECTOR LA ARENERA POTREROS ABAJO ZONA POSTAL 2115",
      "client_identification": "J501323720",
      "nap_box_name": "CE - 773",
      "created_at": "2024-06-08T09:10:57.860102",
      "service_detail": {
        "id": 9275,
        "ip": "172.27.115.2",
        "mac": "HWTC466F479B",
        "serial": "HWTC466F479B",
        "queue": "queue1",
        "interface": "VLAN231_PAYABAJO",
        "created_at": "2025-07-31T08:59:05.525800",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4379,
      "client_name": "INVERSIONES SABA 2015 CA",
      "client_type_name": "PYME",
      "client_subdivision": "CANCELADO_PYME",
      "status_name": "Cancelado",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Prados III",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04128901123",
      "client_email": "YOMIL-241@HOTMAIL.COM",
      "address": "CALLE 06 CASA 09 SECTOR PRADOS DE PAYA III ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "J408955733",
      "nap_box_name": "395",
      "created_at": "2024-06-08T09:12:58.841364",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4380,
      "client_name": "CENTRO EDUCATIVO INICIAL SALTO ANGEL",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Villa Caribe",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04243610418",
      "client_email": "SOYSALTOANGEL@GMAIL.COM",
      "address": "CALLE URDANETA CC GRADISCO URB LOS NISPEROS TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "J313267902",
      "nap_box_name": "CTO-0639",
      "created_at": "2024-06-08T09:15:00.564008",
      "service_detail": {
        "id": 4143,
        "ip": "172.30.71.2",
        "mac": "HWTC5466DEA3",
        "serial": "HWTC5466DEA3",
        "queue": "Plan_92036_15811_WispHub",
        "interface": "VLAN228_V_CARIBE_OLT1",
        "created_at": "2024-07-31T11:40:05.799242",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4381,
      "client_name": "SUPERMERCADO BODEGON LA CHINA 2018 CA",
      "client_type_name": "PYME",
      "client_subdivision": "CANCELADO_PYME",
      "status_name": "Cancelado",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Prados III",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04127445830",
      "client_email": "YUSELYSBOLIVAR@GMAIL.COM",
      "address": "CALLE PRADOS CASA PARCELA NRO 105 SECTOR LOS HORNOS ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "J411829838",
      "nap_box_name": "CTO-00284 DOS",
      "created_at": "2024-06-08T09:23:34.902797",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4382,
      "client_name": "DE NOBREGA MARKET CA",
      "client_type_name": "PYME",
      "client_subdivision": "CANCELADO_PYME",
      "status_name": "Cancelado",
      "cycle": 10,
      "migrate": true,
      "sector_name": "El Naranjal",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04128498684",
      "client_email": "WILISKAGIL@GMAIL.COM",
      "address": "AV PRINCIPAL ROSARIO DE PAYA CC VALLE PAYA NIVEL PB LOCAL 6 Y 7 SECTOR RIO SECO ARAGUA ZONA POSTAL 2115",
      "client_identification": "J310480613",
      "nap_box_name": "482",
      "created_at": "2024-06-08T09:26:20.381918",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4383,
      "client_name": "YEREMY GIOVANNY RODRIGUEZ SALGADO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Paya Abajo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243419631",
      "client_email": "YEREMYSLAGADO@GMAIL.COM",
      "address": "CALLE SAN ANTONIO  CASA 5-11 NRO 5-11 SECTOR PAYA ABAJO ROSARIO DE PAYA",
      "client_identification": "V30211412",
      "nap_box_name": "272",
      "created_at": "2024-06-08T09:28:33.817110",
      "service_detail": {
        "id": 7485,
        "ip": "172.23.205.2",
        "mac": "TPLGF4B1D9C1",
        "serial": "TPLGF4B1D9C1",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN231_PAYABAJO",
        "created_at": "2024-12-17T10:52:33.743552",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4384,
      "client_name": "INVERSIONES SANDIVA CA",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Guanarito",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04128837771",
      "client_email": "MCARVAJAL84@GMAIL.COM",
      "address": "CALLE NEGRO PRIMERO CASA NRO 14 SECTOR GUANARITO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "J411216208",
      "nap_box_name": "231",
      "created_at": "2024-06-08T09:32:12.436797",
      "service_detail": {
        "id": 12587,
        "ip": "172.26.18.2",
        "mac": "VS:OL:00:D0:D7:2B",
        "serial": "VSOL00D0D72B",
        "queue": null,
        "interface": "VLAN232_GUANARITO_OLT2",
        "created_at": "2026-06-06T11:15:25.435331",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4385,
      "client_name": "INVERSIONES LA DIVINA MISERI CORDIA INDIMI FAGORAM CA",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04128900125",
      "client_email": "INDIMIFAGORAM@GMAIL.COM",
      "address": "PASAJE URDANETA LOCAL 06 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "J501187401",
      "nap_box_name": "CE - 616",
      "created_at": "2024-06-08T09:35:07.940596",
      "service_detail": {
        "id": 3739,
        "ip": "172.25.244.2",
        "mac": "VSOL00D0EBEB",
        "serial": "VSOL00D0EBEB",
        "queue": "Plan_92036_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-07-12T16:22:19.856231",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4386,
      "client_name": "GIMNASIO GET PHISYCAL CA",
      "client_type_name": "PYME",
      "client_subdivision": "CANCELADO_PYME",
      "status_name": "Cancelado",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04243121195",
      "client_email": "JOSESPANA2019@GMAIL.COM",
      "address": "CALLE RIVAS CC RANDAZZO NIVEL 3 LOCAL 17 Y 18 SECTOR CENTRO DE TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "J502851267",
      "nap_box_name": "CAJA NAP BICENTENARIO",
      "created_at": "2024-06-08T09:36:56.320646",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4387,
      "client_name": "COMERCIAL VENAR 1607 CA",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04242403812",
      "client_email": "NOVEDADESTURMERO@GMAIL.COM",
      "address": "CALLE MARIÑO CC PASEO MARIÑO NIVEL P2 LOCAL 2-06 SECTOR CENTRO DE TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "J400951380",
      "nap_box_name": "CTO-00038",
      "created_at": "2024-06-08T09:41:20.783831",
      "service_detail": {
        "id": 3655,
        "ip": "172.25.163.2",
        "mac": "TPLGF9CD3C75",
        "serial": "TPLGF9CD3C75",
        "queue": "Plan_92036_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-07-11T18:10:52.604858",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4388,
      "client_name": "MENTA 24 CA",
      "client_type_name": "PYME",
      "client_subdivision": "CANCELADO_PYME",
      "status_name": "Cancelado",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04144920700",
      "client_email": "MARIELYSTUTORIALS@GMAIL.COM",
      "address": "AV RICAUTE CRUCE CON CALLE MARIÑO LOCAL NRO4 SECTOR CASCO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "J506029154",
      "nap_box_name": "CE - 765",
      "created_at": "2024-06-08T09:43:17.160903",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4389,
      "client_name": "ANGIE NACARI VARGAS CHACON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144645934",
      "client_email": "ANGIEVARGAS1403@GMAIL.COM",
      "address": "CALLE 10 EDIF TETRA PISO 1 APT 631-C URB MATA CABALLO TURMERO",
      "client_identification": "V15993188",
      "nap_box_name": "CTO-00569 DOS",
      "created_at": "2024-06-08T09:45:33.575218",
      "service_detail": {
        "id": 5465,
        "ip": "172.20.189.2",
        "mac": "TPLGF4EFC44C",
        "serial": "TPLGF4EFC44C",
        "queue": "Plan_161906_30181_WispHub",
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2024-08-16T17:05:39.537527",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4390,
      "client_name": "INVERSIONES HERMANO 2023 CA",
      "client_type_name": "PYME",
      "client_subdivision": "CANCELADO_PYME",
      "status_name": "Cancelado",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 36,
        "name": "RECURRENTE PYME PLAN 650M",
        "cost": "70.18",
        "code": "FOP650M",
        "profile": "650M/650M"
      },
      "client_mobile": "04140725619",
      "client_email": "HENRYZHOUZOU.4@GMAIL.COM",
      "address": "CALLE PETION CRUCE CON CALLE URDANETA CC TURMERO NIVEL PLANTA BAJA LOCAL NRO 5,6 Y 7 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "J503771496",
      "nap_box_name": "CTO-00072",
      "created_at": "2024-06-08T09:45:42.833602",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4391,
      "client_name": "DISTRIBUIDORA COD23 CA",
      "client_type_name": "PYME",
      "client_subdivision": "CANCELADO_PYME",
      "status_name": "Cancelado",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Guanarito",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04144512529",
      "client_email": "DISTRIBUIDORACOD23@GMAIL.COM",
      "address": "CALLE PEÑALVER LOCAL NRO 1 SECTOR GUANARITO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "J411139297",
      "nap_box_name": "447",
      "created_at": "2024-06-08T09:48:13.629003",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4392,
      "client_name": "GREGORIA ERMINIA SANDIA GUERRERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Los Hornos",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243347885",
      "client_email": "GREGORIASANDIA@GMAIL.COM",
      "address": "CALLE PRINCIPAL CASA NRO 01 SECTOR LOS HORNOS",
      "client_identification": "V11304473",
      "nap_box_name": "CE-00048",
      "created_at": "2024-06-08T09:48:23.809091",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4393,
      "client_name": "INVERSIONES ENFOQUE CA",
      "client_type_name": "PYME",
      "client_subdivision": "SUSPENDIDO_PYME",
      "status_name": "Suspendido",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04243038615",
      "client_email": "MENFIS.NAGAI@GMAIL.COM",
      "address": "CALLE URDANETA LOCAL NRO 3 SECTOR CENTRO TURMERO ARAGUA ZONA POSTAL 211",
      "client_identification": "J410192526",
      "nap_box_name": "CE - 616",
      "created_at": "2024-06-08T09:54:36.013910",
      "service_detail": {
        "id": 3668,
        "ip": "172.21.254.2",
        "mac": "TPLGB446F82E",
        "serial": "TPLGB446F82E",
        "queue": "Plan_92036_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-07-11T19:38:58.712875",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4394,
      "client_name": "EDUVIGES ANTONIO SEGOVIA YNFANTE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados de Cafetal",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243703814",
      "client_email": "OROPEZAZULEIMA74@GMAIL.COM",
      "address": "CALLE 1 TRANSVERSAL CASA NRO 4 SECTOR PRADOS DE CAFETAL",
      "client_identification": "V8739566",
      "nap_box_name": "CTO-0076",
      "created_at": "2024-06-08T09:57:24.771975",
      "service_detail": {
        "id": 5767,
        "ip": "172.18.175.2",
        "mac": "TPLGF440FAE0",
        "serial": "TPLGF440FAE0",
        "queue": "Plan_128612_15811_WispHub",
        "interface": "VLAN221_CAFETAL_OLT1",
        "created_at": "2024-08-19T15:31:34.447116",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4395,
      "client_name": "INVERSIONES JHORKER 2015 CA",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 25,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 102,
        "name": "RECURRENTE PYME PLAN 150M",
        "cost": "27.60",
        "code": "FOP150M",
        "profile": "150Mbps/150Mbps"
      },
      "client_mobile": "04243772930",
      "client_email": "JHORKER7@GMAIL.COM",
      "address": "CENTRO COMERCIAL LAS MERCEDES TOVAR CALLE PETION LOCAL NRO 02 TURMERO",
      "client_identification": "J407312391",
      "nap_box_name": "CTO-00194",
      "created_at": "2024-06-08T09:57:33.549075",
      "service_detail": {
        "id": 3476,
        "ip": "172.24.177.2",
        "mac": "OEMT3C62055A",
        "serial": "OEMT3C62055A",
        "queue": "Plan_92036_15811_WispHub",
        "interface": "VLAN276_COMUNA_OLT1",
        "created_at": "2024-07-05T08:49:55.314904",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4396,
      "client_name": "ANGELO CERVANTES MONTILLA FP",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04121598463",
      "client_email": "CENTRODEIMPRESIONESTURMERO@GMAIL.COM",
      "address": "CALLE MARIÑO NRO 03 SECTOR TURMERO CC PASEO MARIÑO PB TURMERO ARAGUA",
      "client_identification": "V235288946",
      "nap_box_name": "CTO-00038",
      "created_at": "2024-06-08T10:00:04.513691",
      "service_detail": {
        "id": 3495,
        "ip": "172.20.35.2",
        "mac": "TPLG2ABDC7F1",
        "serial": "TPLG2ABDC7F1",
        "queue": "Plan_92036_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-07-08T09:11:48.798099",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4397,
      "client_name": "JULIO CESAR RUIZ PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villeguita",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243298863",
      "client_email": "JULIOELCOMPA2@GMAIL.COM",
      "address": "CALLE PARAISO CASA NRO 14 SECTOR VILLEGUITA 1 TURMERO",
      "client_identification": "V19515608",
      "nap_box_name": "445",
      "created_at": "2024-06-08T10:00:27.107011",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4399,
      "client_name": "ROXI CA",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04143446582",
      "client_email": "ADMPAPELERIAROXI@GMAIL.COM",
      "address": "CALLE URDANETA EDIF ROXI PISO PB APT 71 SECTOR CENTRO TURMERO",
      "client_identification": "J075799577",
      "nap_box_name": "CTO-00072",
      "created_at": "2024-06-08T10:05:49.570103",
      "service_detail": {
        "id": 9752,
        "ip": "172.24.165.2",
        "mac": "TPLGB444B2C4",
        "serial": "TPLGB444B2C4",
        "queue": null,
        "interface": "VLAN200_OLTs",
        "created_at": "2025-11-10T11:59:00.732960",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4400,
      "client_name": "MARIA FERNANDA LAYA AREVALO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Esperanza",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121481132",
      "client_email": "MARIALAYA426@GMAIL.COM",
      "address": "CALLE 3 CASA NRO 5 URB LA ESPERANZA",
      "client_identification": "V22286426",
      "nap_box_name": "CTO-00462",
      "created_at": "2024-06-08T10:06:43.395707",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4401,
      "client_name": "NVE 24 CA",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04141248637",
      "client_email": "FINANCE@IMAGENCIES.COM",
      "address": "CALLE URDANETA EDIF SIN NOMBRE PISO 1 LOCAL S/N NIVEL MZZ TURMERO",
      "client_identification": "J407047116",
      "nap_box_name": "CTO-00246",
      "created_at": "2024-06-08T10:10:14.834286",
      "service_detail": {
        "id": 9744,
        "ip": "172.24.123.2",
        "mac": "TPLGF4EFC2C1",
        "serial": "TPLGF4EFC2C1",
        "queue": null,
        "interface": "VLAN200_OLTs",
        "created_at": "2025-11-10T11:47:39.606332",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4402,
      "client_name": "AVICOLA TECNICA AVITECNICA CA",
      "client_type_name": "PYME",
      "client_subdivision": "SUSPENDIDO_PYME",
      "status_name": "Suspendido",
      "cycle": 10,
      "migrate": true,
      "sector_name": "San Pablo",
      "plan": {
        "id": 104,
        "name": "RECURRENTE PYME PLAN 1GB",
        "cost": "161.00",
        "code": "FOP1GB",
        "profile": "1000Mbps/1000Mbps"
      },
      "client_mobile": "04124851552",
      "client_email": "compras@avitecnica.net.ve",
      "address": "CALLE NORTE LOCAL NRO 41-B ZONA INDUSTRIAL SAN PABLO TURMERO",
      "client_identification": "J304166761",
      "nap_box_name": "CTO-00322",
      "created_at": "2024-06-08T10:13:39.043140",
      "service_detail": {
        "id": 3455,
        "ip": "172.24.132.2",
        "mac": "TPLGF4EFBCD0",
        "serial": "TPLGF4EFBCD0",
        "queue": "queue1",
        "interface": "VLAN224_SAN_PABLO_OLT1",
        "created_at": "2024-07-04T16:54:09.620010",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4403,
      "client_name": "NOVEDADES BEL FIORE 2018 CA",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "El Macaro",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04128965634",
      "client_email": "NOVEDADESBELFIORE2018@GMAIL.COM",
      "address": "CTRA NACIONAL TURMERO EDIF ANALEONOR PISO PB LOCAL NRO 05 SECTOR EL MACARO",
      "client_identification": "J411697770",
      "nap_box_name": "87 DOS",
      "created_at": "2024-06-08T10:16:28.104618",
      "service_detail": {
        "id": 3665,
        "ip": "172.24.109.2",
        "mac": "TPLGF4EFC275",
        "serial": "TPLGF4EFC275",
        "queue": "Plan_92033_1574_WispHub",
        "interface": "VLAN104_EL_MACARO_OLT_ZTE",
        "created_at": "2024-07-11T19:31:02.888874",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4404,
      "client_name": "INVERSIONES TW CA",
      "client_type_name": "PYME",
      "client_subdivision": "CANCELADO_PYME",
      "status_name": "Cancelado",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 36,
        "name": "RECURRENTE PYME PLAN 650M",
        "cost": "70.18",
        "code": "FOP650M",
        "profile": "650M/650M"
      },
      "client_mobile": "04242851403",
      "client_email": "INVERSIONESBETS2021@GMAIL.COM",
      "address": "LOCAL NRO 3-B PLANTA BAJA EDIFICIO COMERCIAL JARDIN CALLE PETION CRUCE  CON CALLE MARIÑO CAS CE DE TURMERO",
      "client_identification": "J500886551",
      "nap_box_name": "CTO-00256",
      "created_at": "2024-06-08T10:21:34.303261",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4405,
      "client_name": "YUGLENYS MARIELA MONASTERIO SUAREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243046846",
      "client_email": "MONASTERIOYUGLENYS@GMAIL.COM",
      "address": "AV PRINCIPAL CASA NRO 39 SECTOR PRADOS DE PAYA I",
      "client_identification": "V16207418",
      "nap_box_name": "CTO-00304",
      "created_at": "2024-06-08T10:22:26.022388",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4406,
      "client_name": "WORLD SKRUT NET C.A",
      "client_type_name": "PYME",
      "client_subdivision": "CANCELADO_PYME",
      "status_name": "Cancelado",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04124672093",
      "client_email": "SKRUTVIDEO@GMAIL.COM",
      "address": "CALLE MARIÑO CC PASEO MARIÑO NIVEL 1 LOCAL 1 SECTOR CASCO DE TURMERO",
      "client_identification": "J501060916",
      "nap_box_name": "CTO-00256",
      "created_at": "2024-06-08T10:23:16.609171",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4407,
      "client_name": "LABORATORIO PRODUCTOS MILENIUMS JN",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04144494933",
      "client_email": "PRODMILENIUMS@HOTMAIL.COM",
      "address": "CALLE LA HACIENDITA PASAJE URDANETA LOCAL EDIF TERRANOVA PB NRO 03 SECTOR VALLE LINDO",
      "client_identification": "J313236837",
      "nap_box_name": "CE - 286",
      "created_at": "2024-06-08T10:26:43.775124",
      "service_detail": {
        "id": 3678,
        "ip": "172.17.121.2",
        "mac": "VSOL0047CC21",
        "serial": "VSOL0047CC21",
        "queue": "Plan_92036_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-07-11T20:05:59.242179",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4408,
      "client_name": "CARLA MODAS CA",
      "client_type_name": "PYME",
      "client_subdivision": "CANCELADO_PYME",
      "status_name": "Cancelado",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 102,
        "name": "RECURRENTE PYME PLAN 150M",
        "cost": "27.60",
        "code": "FOP150M",
        "profile": "150Mbps/150Mbps"
      },
      "client_mobile": "04144920282",
      "client_email": "CARLAYENITZA@GMAIL.COM",
      "address": "CALLE PETION CC COMUNA MERCEDES TOVAR NIVEL PB LOCAL 01 SECTOR CENTRO DE TURMERO",
      "client_identification": "J407334875",
      "nap_box_name": "CTO-00194",
      "created_at": "2024-06-08T10:28:51.020648",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4409,
      "client_name": "INVERSIONES Y TRANSPORTE CARREN 2023 CA",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04144482547",
      "client_email": "CARLOSANGARITA23@HOTMAIL.COM",
      "address": "MATACABALLO HACIENDA DE CAFE PAYA",
      "client_identification": "J503829338",
      "nap_box_name": "CTO-00068",
      "created_at": "2024-06-08T10:31:12.546978",
      "service_detail": {
        "id": 3736,
        "ip": "172.17.98.2",
        "mac": "VSOL0013BB51",
        "serial": "VSOL0013BB51",
        "queue": "Plan_92036_15811_WispHub",
        "interface": "VLAN202_AHP_OLT1",
        "created_at": "2024-07-12T16:15:45.775128",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4410,
      "client_name": "INVERSIONES PEGOPLUS R Y R CA",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Guerito",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04128867729",
      "client_email": "VENTAS.PEGOPLUS@GMAIL.COM",
      "address": "CALLE GUERITO SECTOR SAMAN DE GUERE PARCELA N 59 MUNICIPIO SANTIAGO MARIÑO",
      "client_identification": "J502001115",
      "nap_box_name": "CTO-0657",
      "created_at": "2024-06-08T10:33:44.803679",
      "service_detail": {
        "id": 9665,
        "ip": "172.17.122.2",
        "mac": "VSOL00491F59",
        "serial": "VSOL00491F59",
        "queue": null,
        "interface": "VLAN139_GUERITO",
        "created_at": "2025-10-31T13:40:42.020121",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4411,
      "client_name": "CENTRO DE APUESTAS LOS 3 HERMANOS CA",
      "client_type_name": "PYME",
      "client_subdivision": "CANCELADO_PYME",
      "status_name": "Cancelado",
      "cycle": 10,
      "migrate": true,
      "sector_name": "El Macaro",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04125987241",
      "client_email": "BLANCOTOVARMARIAFERNANDA@GMAIL.COM",
      "address": "CENTRO COMERCIAL ANALEONOR LOCAL N#8 CARRETERA NACIONAL EL MACARO TURMERO",
      "client_identification": "J400451256",
      "nap_box_name": "86 DOS",
      "created_at": "2024-06-08T10:36:02.020737",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4412,
      "client_name": "VENETRAN TURMERO SA",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "El Macaro",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04143441864",
      "client_email": "VINICIO@VENETRANSA.COM",
      "address": "CARRETERA NACIONAL TURMERO  MARACAY  LOCAL PARCELA NRO 30 SECTOR EL MACARO",
      "client_identification": "J302983118",
      "nap_box_name": "CTO-0022",
      "created_at": "2024-06-08T10:38:02.151266",
      "service_detail": {
        "id": 9969,
        "ip": "10.16.10.2",
        "mac": "VSOL0013E5F1",
        "serial": "VSOL0013E5F1",
        "queue": null,
        "interface": "VLAN104_EL_MACARO_OLT_ZTE",
        "created_at": "2025-11-11T11:36:37.511250",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4413,
      "client_name": "CORPORACION LOTOLITO C.A",
      "client_type_name": "PYME",
      "client_subdivision": "CANCELADO_PYME",
      "status_name": "Cancelado",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04127551485",
      "client_email": "LOTOLITO2022@GMAIL.COM",
      "address": "CALLE MARIÑO LOCAL NRO 77 CENTRO DE TURMERO",
      "client_identification": "J503177535",
      "nap_box_name": "69",
      "created_at": "2024-06-08T10:40:20.463367",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4414,
      "client_name": "ARCOTI 2011 CA",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04124899741",
      "client_email": "ARCOTI2011@GMAIL.COM",
      "address": "LOCAL 11  EDIFICIO COMERCIAL CENTRO COMERCIAL CALLE MIRANDA CRUCE  CON CALLE  CEDEÑO  NRO 50 TURMERO",
      "client_identification": "J312549459",
      "nap_box_name": "279",
      "created_at": "2024-06-08T10:42:41.378366",
      "service_detail": {
        "id": 3369,
        "ip": "172.23.171.2",
        "mac": "GPON0097B4E6",
        "serial": "GPON0097B4E6",
        "queue": "Plan_92036_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-07-02T17:15:18.036278",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4415,
      "client_name": "EDUWIN JESUS BANDES PLAZA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243043406",
      "client_email": "EDUINBANDEZ@GMAIL.COM",
      "address": "CALLE 15-B CASA NRO 46 URB LOS PANTI ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V19608621",
      "nap_box_name": "CTO-00311",
      "created_at": "2024-06-08T10:44:37.028668",
      "service_detail": {
        "id": 5680,
        "ip": "172.21.30.2",
        "mac": "TPLGF4B1D9C0",
        "serial": "TPLGF4B1D9C0",
        "queue": "Plan_161905_30183_WispHub",
        "interface": "VLAN229_PANTIN",
        "created_at": "2024-08-17T14:44:03.346531",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4416,
      "client_name": "INVERSIONES J Y J 1000 CA",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04129950904",
      "client_email": "freddycarrillo1912@gmail.com",
      "address": "CALLE MARIÑO EDIF RESIDENCIAS MARIÑO PISO P-B LOCAL G-3 TURMERO",
      "client_identification": "J317404904",
      "nap_box_name": "69",
      "created_at": "2024-06-08T10:44:44.472676",
      "service_detail": {
        "id": 13024,
        "ip": "172.23.132.2",
        "mac": "GP:ON:00:97:EE:46",
        "serial": "GPON0097EE46",
        "queue": null,
        "interface": "VLAN200_OLTs",
        "created_at": "2026-09-16T08:53:47.820765",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4417,
      "client_name": "CENTER MARKET 2019 CA",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04128988528",
      "client_email": "HAOHUAWU1388@GMAIL.COM",
      "address": "CALLE MARIÑO  LOCAL NRO 55-1 SECTOR CENTRO",
      "client_identification": "J413123681",
      "nap_box_name": "CTO-00256",
      "created_at": "2024-06-08T10:46:53.576265",
      "service_detail": {
        "id": 5367,
        "ip": "172.23.172.2",
        "mac": "GPON0097BE86",
        "serial": "GPON0097BE86",
        "queue": "Plan_92036_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-08-16T11:38:15.488910",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4418,
      "client_name": "COMERCIALIZADORA CAMPO GRANDE CA",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 38,
        "name": "RECURRENTE PYME PLAN 800M",
        "cost": "110.40",
        "code": "FOP800M",
        "profile": "800M/800M"
      },
      "client_mobile": "04243727916",
      "client_email": "CAMPOGRANDETURMERO@GMAIL.COM",
      "address": "CALLE PETION LOCAL NRO 2-A SECTOR TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "J408028107",
      "nap_box_name": "255",
      "created_at": "2024-06-08T10:48:59.608332",
      "service_detail": {
        "id": 11244,
        "ip": "172.23.47.2",
        "mac": "TPLGF9CD3D30",
        "serial": "TPLGF9CD3D30",
        "queue": null,
        "interface": "VLAN200_OLTs",
        "created_at": "2026-01-20T17:08:21.844699",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4419,
      "client_name": "ALWAYS FIRM CA",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04122982809",
      "client_email": "ALWAYSFIRMOFICIAL1@GMAIL.COM",
      "address": "CALLE PETION CENTRO COMERCIAL ARMANDO LOCAL NRO 4 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "J501996091",
      "nap_box_name": "CTO-00072",
      "created_at": "2024-06-08T10:51:33.488319",
      "service_detail": {
        "id": 3826,
        "ip": "10.12.175.2",
        "mac": "OEMT3C626136",
        "serial": "OEMT3C626136",
        "queue": "Plan_92036_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-07-16T08:10:48.571724",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4420,
      "client_name": "INVERSIONES EL TRES DE TREBOL",
      "client_type_name": "PYME",
      "client_subdivision": "CANCELADO_PYME",
      "status_name": "Cancelado",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 36,
        "name": "RECURRENTE PYME PLAN 650M",
        "cost": "70.18",
        "code": "FOP650M",
        "profile": "650M/650M"
      },
      "client_mobile": "04243225156",
      "client_email": "MENDEZYESENIA955@GMAIL.COM",
      "address": "AV PRINCIPAL DE PAYA LOCAL NRO S/N URB MATA CABALLO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "J504745200",
      "nap_box_name": "CTO-00068",
      "created_at": "2024-06-08T10:53:52.396598",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4422,
      "client_name": "CAÑITAS Y MILHOJAS CA",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 36,
        "name": "RECURRENTE PYME PLAN 650M",
        "cost": "70.18",
        "code": "FOP650M",
        "profile": "650M/650M"
      },
      "client_mobile": "04123985568",
      "client_email": "ADMINISTRACION@PASTELERIATDK.COM",
      "address": "CALLE MIRANDA EDIF RESIDENCIAS SAN GIOVANNI PISO PB TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "J502144706",
      "nap_box_name": "CTO-00038",
      "created_at": "2024-06-08T10:57:58.025903",
      "service_detail": {
        "id": 6337,
        "ip": "172.28.135.2",
        "mac": "OEMT3C6253DA",
        "serial": "OEMT3C6253DA",
        "queue": "Plan_92037_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-08-25T21:07:11.976402",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4423,
      "client_name": "LUIS ALEXANDER SOLORZANO RIOS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Paya Abajo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128994252",
      "client_email": "MARGARITARIOSCAMPOS57@GMAIL.COM",
      "address": "CALLE CAMPO ELÍAS CASA NRO 18-A SECTOR PAYA ABAJO",
      "client_identification": "V21203956",
      "nap_box_name": "CTO-0252",
      "created_at": "2024-06-08T10:59:10.959084",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4424,
      "client_name": "ESTACION DE SERVICIOS EL TRIANGULO SRL",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04243238460",
      "client_email": "ESTACIONDESERVICIOELTRIANGULO@GMAIL.COM",
      "address": "CALLE RIBAS LOCAL NRO 1 URB VALLE LINDO III TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "J075712048",
      "nap_box_name": "CTO-00030",
      "created_at": "2024-06-08T10:59:52.761911",
      "service_detail": {
        "id": 12811,
        "ip": "172.28.184.2",
        "mac": "HW:TC:3A:91:4A:A1",
        "serial": "HWTC3A914AA1",
        "queue": null,
        "interface": "VLAN200_OLTs",
        "created_at": "2026-08-08T17:28:23.857476",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4426,
      "client_name": "INVERSIONES TURMERO CENTER CA",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04121341293",
      "client_email": "TURMEROCENTER@GMAIL.COM",
      "address": "CALLE PETION C C COMUNA  MERCEDES TOVAR NIVEL PB LOCAL 29 TURMERO",
      "client_identification": "J402019122",
      "nap_box_name": "CTO-00194",
      "created_at": "2024-06-08T11:03:57.716882",
      "service_detail": {
        "id": 6340,
        "ip": "172.23.169.2",
        "mac": "GPON00981106",
        "serial": "GPON00981106",
        "queue": "Plan_92036_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-08-25T21:19:18.200549",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4427,
      "client_name": "NABIL JUNIOR SAAD SCATA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Antigua Hacienda De Paya II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04145862891",
      "client_email": "NABILJR.SAAD.81@HOTMAIL.COM",
      "address": "CALLE MOLINA ESTE  NRO 19 PARCELA 19 ANTIGUA HACIENDA DE PAYA",
      "client_identification": "V15819043",
      "nap_box_name": "223",
      "created_at": "2024-06-08T11:04:38.360614",
      "service_detail": {
        "id": 3589,
        "ip": "172.21.46.2",
        "mac": "TPLGF4EFC107",
        "serial": "TPLGF4EFC107",
        "queue": "Plan_128612_15811_WispHub",
        "interface": "VLAN201_AHP2_OLT1",
        "created_at": "2024-07-09T16:32:57.906628",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4428,
      "client_name": "INGRID JOSEFINA HEREDIA MEDINA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144732996",
      "client_email": "INGRIDHEREDIA1975@GMAIL.COM",
      "address": "CALLE 12 CASA NRO 665-B URB MATA CABALLO, ROSARIO DE PAYA TURMERO ARAGUA",
      "client_identification": "V14740454",
      "nap_box_name": "CTO-00433",
      "created_at": "2024-06-08T11:11:17.857409",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4429,
      "client_name": "WILMARY ANDREINA ROJAS SANDIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Palma Real",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243233278",
      "client_email": "ANDREINASANDIA4@GMAIL.COM",
      "address": "CALLE LOS PORTUGUESES CASA ROSARIO DE PAYA NRO 26 PARCELAMIENTO 6 ROSARIO DE PAYA",
      "client_identification": "V19579770",
      "nap_box_name": "CE - 535",
      "created_at": "2024-06-08T11:23:07.323469",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4430,
      "client_name": "RUBEN ELIAS GONZALEZ RIVAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Canaima",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128905813",
      "client_email": "REGR2445@GMAIL.COM",
      "address": "CALLE 3 CASA NRO 23 SECTOR CANAIMA",
      "client_identification": "V24930883",
      "nap_box_name": "355",
      "created_at": "2024-06-08T11:29:03.154113",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4431,
      "client_name": "ALEXIS OSWALDO TORRES AVILA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124833079",
      "client_email": "CAPONTECARIO@GMAIL.COM",
      "address": "CALLE 15 CASA NRO  48 SECTOR RIO SECO TURMERO ARAGUA",
      "client_identification": "V6030834",
      "nap_box_name": "CTO-00155",
      "created_at": "2024-06-08T11:29:14.886211",
      "service_detail": {
        "id": 5756,
        "ip": "172.29.243.2",
        "mac": "OEMT3C6261F2",
        "serial": "OEMT3C6261F2",
        "queue": "queue1",
        "interface": "VLAN251_RIO_SECO",
        "created_at": "2024-08-19T15:09:35.038558",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4432,
      "client_name": "LEIDYS JACKELINE YROBA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243795796",
      "client_email": "SOPHIAGORRIN14@GMAIL.COM",
      "address": "CALLE 10 CASA NRO 628-C SECTOR MATA CABALLO ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V16129736",
      "nap_box_name": "CTO-00569",
      "created_at": "2024-06-08T11:32:00.756301",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4433,
      "client_name": "DAYANA CAROLINA MEJIA PADILLA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Macarena",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124576002",
      "client_email": "DAYANAMEJIA240@GMAIL.COM",
      "address": "CALLE 7 CASA 7 URB LA MACARENA II",
      "client_identification": "V19364714",
      "nap_box_name": "246",
      "created_at": "2024-06-08T11:34:27.366365",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4434,
      "client_name": "ALNERIS GABRIELA CHOURIO SOTO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados III",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128909951",
      "client_email": "ALNERIS18@GMAIL.COM",
      "address": "CALLE 2 CASA NRO 27 SECTOR PRADOS III",
      "client_identification": "V25880068",
      "nap_box_name": "CTO-00284 DOS",
      "created_at": "2024-06-08T11:36:47.896242",
      "service_detail": {
        "id": 6318,
        "ip": "172.18.155.2",
        "mac": "TPLGF4EFBCCC",
        "serial": "TPLGF4EFBCCC",
        "queue": "Plan_161903_30183_WispHub",
        "interface": "VLAN236_PRADOS3",
        "created_at": "2024-08-23T18:01:01.559060",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4435,
      "client_name": "MAYRA ALEJANDRA RUIZ GOMEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Naranjal",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04127591167",
      "client_email": "RUIZMAIRA397@GMAIL.COM",
      "address": "CALLE PRINCIPAL PARCELA 7 Y 8 CASA NRO 13 SECTOR GRANJA EL NARANJAL ROSARIO DE PAYA TURNERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V16131684",
      "nap_box_name": "596",
      "created_at": "2024-06-08T11:38:20.309743",
      "service_detail": {
        "id": 5718,
        "ip": "172.28.132.2",
        "mac": "HWTC218F0DA1",
        "serial": "HWTC218F0DA1",
        "queue": "Plan_161905_30183_WispHub",
        "interface": "VLAN246_NARANJAL",
        "created_at": "2024-08-19T10:01:11.017828",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4436,
      "client_name": "YUCDALYS JOSEFINA CAMPOS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Magdalena",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243035991",
      "client_email": "YUCDALYSC@GMAIL.COM",
      "address": "CALLE 13 CASA NRO 04 SECTOR LA MAGDALENA LA JULIA",
      "client_identification": "V11438348",
      "nap_box_name": "428",
      "created_at": "2024-06-08T11:41:00.990846",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4437,
      "client_name": "JUAN CARLOS LA CRUZ RAGA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Arturo Luis Berti",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121799532",
      "client_email": "LACRUZJUANCARLOS0@GMAIL.COM",
      "address": "URB ARTURO LUIS BERTI CALLE 3 CASA NRO 417 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V30498975",
      "nap_box_name": "65",
      "created_at": "2024-06-08T11:42:57.455711",
      "service_detail": {
        "id": 12751,
        "ip": "172.28.133.2",
        "mac": "ZX:IC:CD:0B:80:91",
        "serial": "ZXICCD0B8091",
        "queue": null,
        "interface": "VLAN102_ARTURO_BERTI",
        "created_at": "2026-07-18T10:22:09.587009",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4439,
      "client_name": "FRANCI DEL VALLE PEREZ ACOSTA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04262368375",
      "client_email": "FRANCIPEREZ534@GMAIL.COM",
      "address": "CALLE 4 CASA NRO 75 SECTOR PRADOS DE PAYA 2",
      "client_identification": "V20694208",
      "nap_box_name": "CTO-00449",
      "created_at": "2024-06-08T11:56:49.986362",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4440,
      "client_name": "MARIA EUGENIA AMADOR ESPINOZA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Brisas de Paya",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243517805",
      "client_email": "MARIA04AMADOR@GMAIL.COM",
      "address": "CALLE 01 MANZANA D CASA NRO 39 SECTOR BRISAS DE PAYA ROSARIO DE PAYA TURMERO EDO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V14182781",
      "nap_box_name": "369",
      "created_at": "2024-06-08T11:58:01.792267",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4441,
      "client_name": "CARLOS EFRAIN MORILLO GUZMAN",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121489572",
      "client_email": "MORILLO19CARLOS@GMAIL.COM",
      "address": "CALLE 02 CASA NRO 03 SECTOR PRADOS II",
      "client_identification": "V24930894",
      "nap_box_name": "CTO-00205 DOS",
      "created_at": "2024-06-08T11:59:23.972466",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4443,
      "client_name": "ROSA MARIA ALVARADO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero I",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128931956",
      "client_email": "alejandroavile06@gmail.com",
      "address": "SAMAN TARAZONERO I CALLE 4 CASA 15",
      "client_identification": "V3401265",
      "nap_box_name": "262",
      "created_at": "2024-06-08T12:03:15.959051",
      "service_detail": {
        "id": 11085,
        "ip": "172.21.40.2",
        "mac": "TPLGF4B1D883",
        "serial": "TPLGF4B1D883",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2026-01-10T11:03:34.284326",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4444,
      "client_name": "CARMEN ALICIA BASABE VALERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243056004",
      "client_email": "ANABELZIB@GMAIL.COM",
      "address": "CALLE 03 CASA NRO 2 SECTOR PRADOS DE PAYA I ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V9772156",
      "nap_box_name": "CE - 288",
      "created_at": "2024-06-08T12:05:02.023290",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4445,
      "client_name": "ISBELIA JOSEFINA BAENA GUAIRA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Durpa",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243786780",
      "client_email": "BAENAISBELIA207@GMAIL.COM",
      "address": "CALLE LIBERTAD CASA NRO 36  BARRIO DURPA ROSARIO DE PAYA",
      "client_identification": "V11051718",
      "nap_box_name": "258",
      "created_at": "2024-06-08T12:06:09.464756",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4446,
      "client_name": "ALEJANDRO JOSE ADARME PENA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04149470736",
      "client_email": "ALEJANDROADARME119@GMAIL.COM",
      "address": "CALLE 09 CASA NRO 6-05-A URB MATA CABALLO TURMERO EDO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V30924050",
      "nap_box_name": "160",
      "created_at": "2024-06-08T12:10:46.771851",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4448,
      "client_name": "MORAIMA JOSEFINA SUAREZ TORO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243301107",
      "client_email": "MORAIMASUAREZ75@GMAIL.COM",
      "address": "CALLE 7 CASA NRO 542D URB MATA CABALLO ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V12568602",
      "nap_box_name": "CTO-00167 DOS",
      "created_at": "2024-06-08T12:13:35.554448",
      "service_detail": {
        "id": 5809,
        "ip": "172.28.131.2",
        "mac": "HWTC151D1FA1",
        "serial": "HWTC151D1FA1",
        "queue": "Plan_107915_30181_WispHub",
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2024-08-20T09:07:53.165417",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4449,
      "client_name": "JENNY JOSEFINA SANCHEZ ACEVEDO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "5237764638",
      "client_email": "JENNYSANCHEZ8888@GMAIL.COM",
      "address": "CALLE 16 CASA NRO 34 URB PANTIN TURMERO EDO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V10751869",
      "nap_box_name": "CTO-00026",
      "created_at": "2024-06-08T12:17:07.705642",
      "service_detail": {
        "id": 3233,
        "ip": "172.29.37.2",
        "mac": "HWTC21E378A1",
        "serial": "HWTC21E378A1",
        "queue": "Plan_161900_30183_WispHub",
        "interface": "VLAN229_PANTIN",
        "created_at": "2024-06-28T12:40:34.638193",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4450,
      "client_name": "MANUEL ALEJANDRO CARRENO DIAZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Valle Paraiso",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243779658",
      "client_email": "MIRIAMGS86@GMAIL.COM",
      "address": "VALLE PARAISO MANZANA 2 CASA NRO 17 SECTOR SAN PABLO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V18702099",
      "nap_box_name": "CTO-0642",
      "created_at": "2024-06-08T12:20:26.327433",
      "service_detail": {
        "id": 6311,
        "ip": "172.28.128.2",
        "mac": "HWTCC04F8C9D",
        "serial": "HWTCC04F8C9D",
        "queue": "Plan_139897_15811_WispHub",
        "interface": "VLAN227_V_PARAISO_OLT1",
        "created_at": "2024-08-23T17:44:52.268917",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4452,
      "client_name": "MADELEYNIS HEYDILIZ MILLAN RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128904440",
      "client_email": "MADELEY13MIL@GMAIL.COM",
      "address": "CALLE 2 CASA 24 URB PRADOS I",
      "client_identification": "V21465579",
      "nap_box_name": "CTO-00300",
      "created_at": "2024-06-08T12:29:50.558243",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4453,
      "client_name": "JOEL ANGEL CARDOZO MORA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Residencias Mariño",
      "plan": {
        "id": 43,
        "name": "RECURRENTE RESIDENCIAL PLAN 650M",
        "cost": "46.00",
        "code": "FOR650M",
        "profile": "650M/650M"
      },
      "client_mobile": "04127769635",
      "client_email": "INGJOELCARDOZO22@GMAIL.COM",
      "address": "CALLE MARIÑO EDIF RESIDENCIAS MARIÑO TORRE A PISO 11 APTO 113 CONJUNTO RESIDENCIAL MARIÑO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V20118663",
      "nap_box_name": "CTO-0518",
      "created_at": "2024-06-08T12:31:19.048048",
      "service_detail": {
        "id": 6309,
        "ip": "172.28.117.2",
        "mac": "HWTCC027FE9D",
        "serial": "HWTCC027FE9D",
        "queue": "Plan_143067_15811_WispHub",
        "interface": "VLAN234_R_MARINO_OLT2",
        "created_at": "2024-08-23T17:40:05.108148",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4454,
      "client_name": "MARTHA CRISTINA RODRIGUEZ SANTANA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243121688",
      "client_email": "KRISTINA545K@GMAIL.COM",
      "address": "LA CASONA II CALLE 14 CASA NRO 74 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V19654128",
      "nap_box_name": "CTO-00120",
      "created_at": "2024-06-08T12:34:12.073216",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4456,
      "client_name": "JOSELYN YDAISI AREVALO MORENO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Simon Bolivar",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04127769179",
      "client_email": "JONIESLYDELVALLE@GMAIL.COM",
      "address": "AV EL MACARO CALLE 2 CASA NRO 10 URB SIMON BOLIVAR TURMERO ARAGUA",
      "client_identification": "V12994306",
      "nap_box_name": "CTO-00042",
      "created_at": "2024-06-08T12:47:56.263907",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4458,
      "client_name": "JOSE JEAN CARLOS CHIRINOS RAMIREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Valle Verde",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04143843701",
      "client_email": "JOSEYEANCARLOACHIRINORAMIREZ@GMAIL.COM",
      "address": "CALLE RIO SECO CASA NRO 14 SECTOR VALLE VERDE",
      "client_identification": "V15130441",
      "nap_box_name": "CTO-0613",
      "created_at": "2024-06-08T13:58:52.268681",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4459,
      "client_name": "YSAMAR KATERINE QUIROZ MENDOZA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243096566",
      "client_email": "YSAMARQUIROZ66@GMAIL.COM",
      "address": "CALLE 8 CASA NRO 583-B URBANISMO MATA CABALLO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V20989952",
      "nap_box_name": "CTO-00130",
      "created_at": "2024-06-08T14:01:04.722834",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4460,
      "client_name": "RAMON ESTEBAN SANDOVAL GUEVARA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04140475694",
      "client_email": "GUEVARA.RAMON.E@GMAIL.COM",
      "address": "CALLE VILLA CASTIN CASA NRO 8 SECTOR CENTRO TURMERO",
      "client_identification": "V20055540",
      "nap_box_name": "CTO - 857",
      "created_at": "2024-06-08T14:02:55.239484",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4461,
      "client_name": "SANDRA NINOSKA QUINTERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vallecito",
      "plan": {
        "id": 101,
        "name": "RECURRENTE RESIDENCIAL PLAN 200M",
        "cost": "19.00",
        "code": "FOR200MB",
        "profile": "200Mbps/200Mbps"
      },
      "client_mobile": "04261369873",
      "client_email": "12SANDRA1@GMAIL.COM",
      "address": "CALLE EL CUJI CASA NRO 29 SECTOR VALLECITO ROSARIO DE PAYA TURMERO",
      "client_identification": "V12927152",
      "nap_box_name": "CTO-00081",
      "created_at": "2024-06-08T14:06:43.611653",
      "service_detail": {
        "id": 6307,
        "ip": "172.30.4.2",
        "mac": "OEMT3C625F52",
        "serial": "OEMT3C625F52",
        "queue": "Plan_161906_30183_WispHub",
        "interface": "VLAN258_VALLECITO",
        "created_at": "2024-08-23T17:35:20.756588",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4462,
      "client_name": "YOANNYBET MAILET GARCIA ARIAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Canaima",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243650200",
      "client_email": "YOANNYBETGRACIAS@GMAIL.COM",
      "address": "CALLE 1 CASA NRO 17 SECTOR CANAIMA ROSARIO DE PAYA",
      "client_identification": "V16644795",
      "nap_box_name": "CTO-00172 ",
      "created_at": "2024-06-08T14:08:45.936803",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4463,
      "client_name": "OLGA JOSEFINA SUAREZ SANDOVAL",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04128904723",
      "client_email": "OLGA0863SUAREZ@GMAIL.COM",
      "address": "CALLE 9 CASA NRO 12 SECTOR RIO SECO ROSARIO DE PAYA EDO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V9641697",
      "nap_box_name": "CTO-0610",
      "created_at": "2024-06-08T14:19:22.969736",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4464,
      "client_name": "MARIA DEL CARMEN OCHOA BORGES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124587031",
      "client_email": "MDC198018@GMAIL.COM",
      "address": "URB LA CASONA II C/14 CASA 90 LA JULIA TURMERO",
      "client_identification": "V30923845",
      "nap_box_name": "CTO-00120 DOS",
      "created_at": "2024-06-08T14:25:11.233191",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4465,
      "client_name": "YURMI MIRAIDA CHACOA SALAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona II Edificios",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243512259",
      "client_email": "YURMI1516@GMAIL.COM",
      "address": "SECTOR LA CASONA 2 EDIF 10-C PISO 2 APTO 2-06 CALLE COMUNAL LA PRIMAVERA",
      "client_identification": "V14294270",
      "nap_box_name": "CTO-0537",
      "created_at": "2024-06-08T14:28:33.460265",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4466,
      "client_name": "YOSELIN MARIA SAMBRANO PEÑA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121413803",
      "client_email": "YOSI.SAMBRANO24@GMAIL.COM",
      "address": "CALLE 4 CASA NRO 87 URB PRADOS DE PAYA LL TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V19821532",
      "nap_box_name": "CTO-00449",
      "created_at": "2024-06-08T14:30:55.252790",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4467,
      "client_name": "ADRIANA YOSELIN CABRERA CELIS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "SUSPENDIDO_RESIDENCIAL",
      "status_name": "Suspendido",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121486858",
      "client_email": "ADRIANAJHOS1234@GMAIL.COM",
      "address": "CALLE 12-B CASA NRO 38 URB HACIENDA PANTIN ROSARIO DE PAYA",
      "client_identification": "V22956228",
      "nap_box_name": "CTO-00166",
      "created_at": "2024-06-08T14:33:27.064872",
      "service_detail": {
        "id": 6327,
        "ip": "172.29.244.2",
        "mac": "OEMT3C625E56",
        "serial": "OEMT3C625E56",
        "queue": "Plan_161905_30183_WispHub",
        "interface": "VLAN229_PANTIN",
        "created_at": "2024-08-24T08:07:21.950265",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4468,
      "client_name": "JORGE LUIS ARTEAGA ROJAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04125975223",
      "client_email": "JORGEARTEAGA6899@GMAIL.COM",
      "address": "CALLE 15-A CASA NRO 16 SECTOR PANTIN ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V9918617",
      "nap_box_name": "CTO-00201",
      "created_at": "2024-06-08T14:49:12.775322",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4469,
      "client_name": "ARGELYS ANDREINA PINTO URBAEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04243345408",
      "client_email": "ARGELYS.PINTO@GMAIL.COM",
      "address": "CALLE RIVAS CON PETION CASA NRO 2B1 SECTOR TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V15819723",
      "nap_box_name": "CE - 758",
      "created_at": "2024-06-08T14:50:36.880090",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4470,
      "client_name": "YEIBER ALEJANDRO RIVAS AZUAJE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Las Rurales",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04125974527",
      "client_email": "YEIBERRIVAS47@GMAIL.COM",
      "address": "CALLE 107 CASA NRO 73 SECTOR LAS RURALES ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V30147828",
      "nap_box_name": "492",
      "created_at": "2024-06-08T14:55:01.527802",
      "service_detail": {
        "id": 6296,
        "ip": "172.28.109.2",
        "mac": "ZICGCD93A781",
        "serial": "ZICGCD93A781",
        "queue": "Plan_161906_30183_WispHub",
        "interface": "VLAN252_RURALES_PAYA",
        "created_at": "2024-08-23T17:15:10.440018",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4471,
      "client_name": "DESIREE DEL VALLE PEREZ GIL",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vallecito",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128900359",
      "client_email": "JOHENNYHENASSYS29@HOTMAIL.COM",
      "address": "CALLE EL ROBLE CASA NRO 9 SECTOR VALLECITO ROSARIO DE PAYA ZONA POSTAL 2115",
      "client_identification": "V17714587",
      "nap_box_name": "CTO-00175",
      "created_at": "2024-06-08T14:55:07.468112",
      "service_detail": {
        "id": 9457,
        "ip": "172.29.234.2",
        "mac": "OEMT3C62609E",
        "serial": "OEMT3C62609E",
        "queue": "queue1",
        "interface": "VLAN258_VALLECITO",
        "created_at": "2025-09-02T09:42:52.422260",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4472,
      "client_name": "LISANNI YASMIN GAMBOA NIEVES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243128960",
      "client_email": "JOELVIVAS65@HOTMAIL.COM",
      "address": "SECTOR MATA CABALLO CALLE NRO 03 CASA NRO 161 ROSARIO DE PAYA",
      "client_identification": "V24930662",
      "nap_box_name": "CTO-00094",
      "created_at": "2024-06-08T14:58:33.860516",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4473,
      "client_name": "MARISELA RIOS BLANCO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados III",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144430254",
      "client_email": "RIOSMARISELA533@GMAIL.COM",
      "address": "CALLE PRINCIPAL LL CASA NRO 16 BARIO PRADO LLL ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V9678310",
      "nap_box_name": "579",
      "created_at": "2024-06-08T15:00:10.964830",
      "service_detail": {
        "id": 3192,
        "ip": "172.28.112.2",
        "mac": "ZICGCD92ADE9",
        "serial": "ZICGCD92ADE9",
        "queue": "Plan_161906_30183_WispHub",
        "interface": "VLAN236_PRADOS3",
        "created_at": "2024-06-27T17:34:48.625926",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4474,
      "client_name": "DARIANYS DANIELA BANDEZ CORTEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Haras de San Pablo",
      "plan": {
        "id": 43,
        "name": "RECURRENTE RESIDENCIAL PLAN 650M",
        "cost": "46.00",
        "code": "FOR650M",
        "profile": "650M/650M"
      },
      "client_mobile": "04243269176",
      "client_email": "DARIANYS.BANDEZ@GMAIL.COM",
      "address": "AV. CIRCUNVALACIÓN, CASA MANZANA C, LOTE D NRO. 90 URB. HARAS DE SAN PABLO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V19002277",
      "nap_box_name": "248",
      "created_at": "2024-06-08T15:04:49.091914",
      "service_detail": {
        "id": 6283,
        "ip": "172.28.104.2",
        "mac": "ZICGCB629147",
        "serial": "ZICGCB629147",
        "queue": "Plan_143067_15811_WispHub",
        "interface": "VLAN210_HSP_OLT1",
        "created_at": "2024-08-23T16:24:19.550390",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4475,
      "client_name": "EUGELIN ADRIANA RANGEL PEÑA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144763576",
      "client_email": "EUGELIN1985@GMAIL.COM",
      "address": "AV 2 EDIF 29 PISO 4 APT 4 URB HACIENDA EL NÍSPERO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V19032288",
      "nap_box_name": "CTO-00274",
      "created_at": "2024-06-08T15:05:05.952664",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4476,
      "client_name": "JORGE JULIO CESAR SCHMIDT HURTADO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Macaro",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04145635658",
      "client_email": "JJCSCHMIDT666@GMAIL.COM",
      "address": "AV PRINCIPAL CASA NRO 8 SECTOR EL MACARO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V12571666",
      "nap_box_name": "CTO-00174",
      "created_at": "2024-06-08T15:08:49.364990",
      "service_detail": {
        "id": 3141,
        "ip": "172.29.223.2",
        "mac": "OEMT3C626182",
        "serial": "OEMT3C626182",
        "queue": "Plan_147201_15811_WispHub",
        "interface": "VLAN248_TIBISAY_OLT2",
        "created_at": "2024-06-27T09:43:12.358105",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4477,
      "client_name": "NAIROBIZ ANDREINA ALVARADO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados III",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04125987815",
      "client_email": "NAIROBIZA42@GMAIL.COM",
      "address": "AV PRINCIPAL I MANZANA A CASA NRO 32 SECTOR PRADOS DE PAYA III TURMERO EDO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V20068855",
      "nap_box_name": "395",
      "created_at": "2024-06-08T15:10:30.168255",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4478,
      "client_name": "KEVIN JHONSUHE COLMENARES MACHADO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Guanarito",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04144488053",
      "client_email": "KEVINCOLMENARE1@GMAIL.COM",
      "address": "CALLE FLORES CASA NRO 28 BARRIO PEDRO VILLA CASTIN TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V27646071",
      "nap_box_name": "CTO-00476",
      "created_at": "2024-06-08T15:11:23.576765",
      "service_detail": {
        "id": 3390,
        "ip": "172.29.238.2",
        "mac": "OEMT3C62624E",
        "serial": "OEMT3C62624E",
        "queue": "Plan_153953_15811_WispHub",
        "interface": "VLAN232_GUANARITO_OLT2",
        "created_at": "2024-07-03T08:20:38.878304",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4479,
      "client_name": "ANA DOMINGA MARINO DIAZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "SUSPENDIDO_RESIDENCIAL",
      "status_name": "Suspendido",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados III",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243077342",
      "client_email": "ANA2017MARINO@GMAIL.COM",
      "address": "CALLE 4 CASA NRO 9 SECTOR III PRADOS DE PAYA ROSARIO DE PAYA EDO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V13592233",
      "nap_box_name": "CTO-00299",
      "created_at": "2024-06-08T15:13:26.416116",
      "service_detail": {
        "id": 12856,
        "ip": "172.29.235.2",
        "mac": "QX:TL:CB:9E:78:1F",
        "serial": "QXTLCB9E781F",
        "queue": null,
        "interface": "VLAN236_PRADOS3",
        "created_at": "2026-08-17T11:09:09.090889",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4480,
      "client_name": "FREINER ANDRES NARANJO COLON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vallecito",
      "plan": {
        "id": 43,
        "name": "RECURRENTE RESIDENCIAL PLAN 650M",
        "cost": "46.00",
        "code": "FOR650M",
        "profile": "650M/650M"
      },
      "client_mobile": "04121480989",
      "client_email": "FREEDMAX825@GMAIL.COM",
      "address": "CALLE PICOLINO VALLECITO CASA NRO. 01 SECTOR PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V29728289",
      "nap_box_name": "CTO-0479",
      "created_at": "2024-06-08T15:13:29.089432",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4481,
      "client_name": "YUSMELY ANDREINA RICO GARCIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124587515",
      "client_email": "YUSMELYRIOS19@GMAIL.COM",
      "address": "CALLE 9 CASA NRO 07 SECTOR RIO SECO ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V19111807",
      "nap_box_name": "CTO-0610",
      "created_at": "2024-06-08T15:16:06.489187",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4482,
      "client_name": "LILIANA DE JESUS HERRERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128449580",
      "client_email": "JOHANARIVERA28@GMAIL.COM",
      "address": "CALLE 18 A CASA NRO 15 URB PANTIN SECTOR ROSARIO DE PAYA  TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V9689719",
      "nap_box_name": "CTO-00434",
      "created_at": "2024-06-08T15:17:10.359308",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4483,
      "client_name": "JESUS EDUARDO CARDONA UZCANGA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04128848428",
      "client_email": "CARDONAJESUS1608@GMAIL.COM",
      "address": "CALLE 7-A CASA NRO 22 URB PANTIN ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V7247160",
      "nap_box_name": "CTO-00139",
      "created_at": "2024-06-08T15:20:21.337799",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4484,
      "client_name": "JONATHAN HARRYS TORCATES MUÑOZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vallecito",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04125987204",
      "client_email": "JTMH.1101@GMAIL.COM",
      "address": "CALLE EL CUJI CASA NRO 21 SECTOR COLINAS DE VALLECITO ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V26535353",
      "nap_box_name": "CTO - 97",
      "created_at": "2024-06-08T15:24:41.996859",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4485,
      "client_name": "MAYERLING ELENA REYES RAMOS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados I",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04123488362",
      "client_email": "RUSBELJOSE11@GMAIL.COM",
      "address": "CALLE 1 CASA NRO 11 SECTOR PRADOS 1 ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V12140857",
      "nap_box_name": "585 DOS",
      "created_at": "2024-06-08T15:32:37.932104",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4486,
      "client_name": "ANGEL GABRIEL CEDENO MORILLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Canaima",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121119749",
      "client_email": "ANGELXEDE@GMAIL.COM",
      "address": "CALLE 7 CASA NRO 10 URB CANAIMA ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V28045351",
      "nap_box_name": "418",
      "created_at": "2024-06-08T15:34:35.274863",
      "service_detail": {
        "id": 3209,
        "ip": "172.29.237.2",
        "mac": "OEMT3C626172",
        "serial": "OEMT3C626172",
        "queue": "Plan_161906_30183_WispHub",
        "interface": "VLAN237_CANAIMA",
        "created_at": "2024-06-27T18:29:09.144198",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4487,
      "client_name": "JHOANA MARICELIS LIENDO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Santa Eduviges",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243689813",
      "client_email": "CACHARUCOMICHELLANAILEC@GMAIL.COM",
      "address": "CALLE PRINCIPAL CASA NRO 31 SECTOR SANTA EDUVIGES EL MACARO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V15818530",
      "nap_box_name": "CE - 523",
      "created_at": "2024-06-08T15:35:35.360405",
      "service_detail": {
        "id": 2875,
        "ip": "172.28.88.2",
        "mac": "ZICGCD959450",
        "serial": "ZICGCD959450",
        "queue": "Plan_137413_1574_WispHub",
        "interface": "VLAN127_SANTA_EDUVIGES",
        "created_at": "2024-06-18T17:09:38.095721",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4488,
      "client_name": "YURI MILEIDY AGUILAR NAVARRO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vallecito",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04129408206",
      "client_email": "YURIAGUILAR841@GMAIL.COM",
      "address": "CALLE LA CEIBA CASA NRO 23 SECTOR VALLECITO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V20336730",
      "nap_box_name": "CTO-00081",
      "created_at": "2024-06-08T15:36:38.923258",
      "service_detail": {
        "id": 6265,
        "ip": "172.29.228.2",
        "mac": "OEMT3C626152",
        "serial": "OEMT3C626152",
        "queue": "queue1",
        "interface": "VLAN258_VALLECITO",
        "created_at": "2024-08-23T15:31:32.164468",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4489,
      "client_name": "MARISOL VALERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243377310",
      "client_email": "MARISOLVALERO774@GMAIL.COM",
      "address": "CALLE 01 CASA NRO 15 SECTOR MATA CABALLO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V11319511",
      "nap_box_name": "CTO-00131",
      "created_at": "2024-06-08T15:39:50.751361",
      "service_detail": {
        "id": 9872,
        "ip": "172.29.226.2",
        "mac": "OEMT3C62614E",
        "serial": "OEMT3C62614E",
        "queue": null,
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2025-11-10T19:02:23.464642",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4490,
      "client_name": "GREY JOSEFINA GARCIA LEDEZMA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Los Mangos",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04127672020",
      "client_email": "GREYJGARCIA@GMAIL.COM",
      "address": "APARTAMENTO B-23 PISO 2 DE LA TORRE B RESIDENCIAS LOS MANGOS TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V20067404",
      "nap_box_name": "CTO-0653",
      "created_at": "2024-06-08T15:41:46.788952",
      "service_detail": {
        "id": 3986,
        "ip": "172.29.231.2",
        "mac": "OEMT3C626106",
        "serial": "OEMT3C626106",
        "queue": "Plan_153953_15811_WispHub",
        "interface": "VLAN217_MANGOS_OLT1",
        "created_at": "2024-07-17T16:40:36.519396",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4491,
      "client_name": "JERRY GAISE YANES YANES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243495502",
      "client_email": "YANEZJERRY3@GMAIL.COM",
      "address": "CALLE 10 APARTAMENTO 615D URBANIZACION MATA CABALLO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V11567577",
      "nap_box_name": "CTO-00569",
      "created_at": "2024-06-08T15:45:14.394185",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4492,
      "client_name": "BARBARA VISLEIDY CEBALLOS RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04143923865",
      "client_email": "RODRIGUEZBARBARA815@GMAIL.COM",
      "address": "ENTRE CALLE CAMILO TORRES Y NEGRO PRIMERO ESQUINA CASA NUMERO 1 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V31023586",
      "nap_box_name": "53",
      "created_at": "2024-06-08T15:45:47.902968",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4493,
      "client_name": "RAMON ANTONIO SOTO MEDINA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128307976",
      "client_email": "RAMONSOTO3332@GMAIL.COM",
      "address": "CALLE 06 CASA NRO 11 SECTOR PRADO I ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V7173967",
      "nap_box_name": "CTO-00298",
      "created_at": "2024-06-08T15:51:56.930577",
      "service_detail": {
        "id": 6262,
        "ip": "172.29.225.2",
        "mac": "OEMT3C6260A6",
        "serial": "OEMT3C6260A6",
        "queue": "Plan_161906_30183_WispHub",
        "interface": "VLAN239_PRADOS1",
        "created_at": "2024-08-23T15:18:13.833112",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4494,
      "client_name": "DAIRY YONLIS ALVAREZ ALVAREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Arboleda",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243014054",
      "client_email": "DAIRYALVAREZ86@GMAIL.COM",
      "address": "CALLE LOS MANGOS CASA NRO 29 SECTOR LA ARBOLEDA ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V19417443",
      "nap_box_name": "CTO-0485",
      "created_at": "2024-06-08T15:52:37.227574",
      "service_detail": {
        "id": 3861,
        "ip": "172.28.86.2",
        "mac": "ZICGCEB5794E",
        "serial": "ZICGCEB5794E",
        "queue": "Plan_161903_30183_WispHub",
        "interface": "VLAN257_ARBOLEDA",
        "created_at": "2024-07-16T14:30:28.579093",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4495,
      "client_name": "WILLEIDY ANDREA RODRIGUEZ BLANCO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona II",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243072712",
      "client_email": "PADILLALUIS1002@GMAIL.COM",
      "address": "CALLE 13 CASA NRO 121 URB LA CASONA II TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V21097237",
      "nap_box_name": "CTO-00091",
      "created_at": "2024-06-08T15:55:52.948551",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4496,
      "client_name": "DIANA ROXELY VERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Luz y Vida",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128927757",
      "client_email": "DIANAVERA7451@GMAIL.COM",
      "address": "CALLE 01 CASA NRO 05 SECTOR LUZ Y VIDA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V16692077",
      "nap_box_name": "CTO-00303",
      "created_at": "2024-06-08T16:05:52.972262",
      "service_detail": {
        "id": 12648,
        "ip": "172.28.63.2",
        "mac": "ZI:CG:CB:80:0F:EE",
        "serial": "ZICGCB800FEE",
        "queue": null,
        "interface": "VLAN246_NARANJAL",
        "created_at": "2026-07-01T16:20:54.799139",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4497,
      "client_name": "JOSE FRANCISCO DIAZ BAEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Paya Abajo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243121393",
      "client_email": "JOSEFRANCISCOBAEZ5673@GMAIL.COM",
      "address": "CALLE CAMPO ELIAS CASA NRO 15 SECTOR PAYA ABAJO ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V25662293",
      "nap_box_name": "CTO-0252",
      "created_at": "2024-06-08T16:07:36.697874",
      "service_detail": {
        "id": 7490,
        "ip": "172.29.221.2",
        "mac": "OEMT3C6262AE",
        "serial": "OEMT3C6262AE",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN231_PAYABAJO",
        "created_at": "2024-12-17T11:25:18.948879",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4498,
      "client_name": "EBER JOSE LINARES MANZANILLA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243681540",
      "client_email": "LINARESGONZALEZLAURAESTELA@GMAIL.COM",
      "address": "CALLE 14-A CASA NRO 20 URB PANTI TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V3848777",
      "nap_box_name": "CTO-00166",
      "created_at": "2024-06-08T16:11:06.596248",
      "service_detail": {
        "id": 6171,
        "ip": "172.29.217.2",
        "mac": "OEMT3C6261A6",
        "serial": "OEMT3C6261A6",
        "queue": "Plan_161895_30183_WispHub",
        "interface": "VLAN229_PANTIN",
        "created_at": "2024-08-22T18:06:07.181970",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4499,
      "client_name": "IRIS ARELIS INFANTE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Taguapire",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128373298",
      "client_email": "INFANTEIRIS629@GMAIL.COM",
      "address": "AV PRINCIPAL DEL MACARO CASA APARTAMENTO NRO 42 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V15393348",
      "nap_box_name": "549",
      "created_at": "2024-06-08T16:11:15.355409",
      "service_detail": {
        "id": 12641,
        "ip": "172.28.80.2",
        "mac": "CI:OT:09:6B:C3:24",
        "serial": "CIOT096BC324",
        "queue": null,
        "interface": "VLAN129_TAGUAPIRE_ZTE",
        "created_at": "2026-06-27T19:00:47.968557",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4500,
      "client_name": "LUCRECIA DEL CARMEN ARTIGAS DE ROJAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vallecito",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243723830",
      "client_email": "LUCRECI_CARMEN@HOTMAIL.COM",
      "address": "CALLE ARAGUANEY CASA NRO 24 SECTOR COLINAS DE VALLECITO ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V8684985",
      "nap_box_name": "CTO-00115",
      "created_at": "2024-06-08T16:14:24.975237",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4501,
      "client_name": "ROSSELYN GABRIELA SOLIS BERMUDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128488706",
      "client_email": "ROSSELYN999SOLIS@GMAIL.COM",
      "address": "CALLE 2 CASA NRO 23-A URB PANTIN ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V22949156",
      "nap_box_name": "CTO-00110",
      "created_at": "2024-06-08T16:17:10.084207",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4503,
      "client_name": "YELITZA JOSEFINA RAMOS DE YANEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04125971786",
      "client_email": "YR381478@GMAIL.COM",
      "address": "CALLE 22 CASA NRO 11 SECTOR PANTIN TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V11165310",
      "nap_box_name": "CTO-00105",
      "created_at": "2024-06-08T16:21:54.108957",
      "service_detail": {
        "id": 6153,
        "ip": "172.29.216.2",
        "mac": "OEMT3C62612A",
        "serial": "OEMT3C62612A",
        "queue": "Plan_161895_30183_WispHub",
        "interface": "VLAN229_PANTIN",
        "created_at": "2024-08-22T17:36:59.069378",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4504,
      "client_name": "MARLON ENRIQUE MOTTA OJEDA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04125995005",
      "client_email": "MARLOONEMOTTA@GMAIL.COM",
      "address": "CALLE 8 CASA NRO 11 URB PANTIN ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V27370195",
      "nap_box_name": "CTO-00114",
      "created_at": "2024-06-08T16:24:48.218580",
      "service_detail": {
        "id": 2940,
        "ip": "172.29.218.2",
        "mac": "OEMT3C625CB2",
        "serial": "OEMT3C625CB2",
        "queue": "Plan_161906_30183_WispHub",
        "interface": "VLAN229_PANTIN",
        "created_at": "2024-06-20T08:13:45.454962",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4505,
      "client_name": "SIPNNA CLAUDIA FIGUEROA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Macaro",
      "plan": {
        "id": 16,
        "name": "RECURRENTE RESIDENCIAL PLAN 800M",
        "cost": "55.00",
        "code": "FOR800",
        "profile": "800M/800M"
      },
      "client_mobile": "04144696136",
      "client_email": "SIPNNA2022@GMAIL.COM",
      "address": "ALDEA BOLIVARIANA COMUNAL EL MACARO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V12638353",
      "nap_box_name": "493",
      "created_at": "2024-06-08T16:34:11.209017",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4506,
      "client_name": "GIOVANNI EMILIO QUIROZ MENDOZA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243110161",
      "client_email": "GIOVANNIEMILIOQUIROZ@GMAIL.COM",
      "address": "CALLE 6 CASA NRO 443 SECTOR MATA CABALLO ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V29659195",
      "nap_box_name": "CTO-00063",
      "created_at": "2024-06-08T16:37:23.118175",
      "service_detail": {
        "id": 6151,
        "ip": "172.29.210.2",
        "mac": "OEMT3C625CB6",
        "serial": "OEMT3C625CB6",
        "queue": "Plan_107915_30181_WispHub",
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2024-08-22T17:34:25.554594",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4507,
      "client_name": "MIGUEL ALEJANDRO CASTELLANO MARIN",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villa Caribe",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04126902454",
      "client_email": "MIGUEL64483@GMAIL.COM",
      "address": "CALLE GRADISCO CASA NRO 2 CONJUNTO RESIDENCIAL VILLA CARIBE TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V21026326",
      "nap_box_name": "57",
      "created_at": "2024-06-08T16:39:27.902543",
      "service_detail": {
        "id": 6034,
        "ip": "172.29.212.2",
        "mac": "OEMT3C62610A",
        "serial": "OEMT3C62610A",
        "queue": "Plan_129889_15811_WispHub",
        "interface": "VLAN228_V_CARIBE_OLT1",
        "created_at": "2024-08-22T10:47:01.298185",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4508,
      "client_name": "SAURELIS ANGELI GUERRA FARIAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04143352620",
      "client_email": "SAURELIS2000@GMAIL.COM",
      "address": "CALLE PRINCIPAL EDIF TORRE 28 PISO 2 APT 3 CONJUNTO RESIDENCIAL LOS NISPEROS TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V27086151",
      "nap_box_name": "CTO-00207 DOS",
      "created_at": "2024-06-08T16:43:17.381086",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4509,
      "client_name": "GERARDO JOSE BETANCOURT LINARES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04144622730",
      "client_email": "JP0493887@GMAIL.COM",
      "address": "CALLE 2 CASA NRO 01 URBANIZACION PANTIN ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V17016518",
      "nap_box_name": "CTO-00110",
      "created_at": "2024-06-08T16:46:12.666158",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4510,
      "client_name": "SUYHIN ELGEIDA MARCANO ALVAREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243068259",
      "client_email": "SUYHINMARCANO@GMAIL.COM",
      "address": "CALLE 14A CASA NRO 07 SECTOR PANTIN TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V14665623",
      "nap_box_name": "CTO-00169",
      "created_at": "2024-06-08T16:49:00.001385",
      "service_detail": {
        "id": 6148,
        "ip": "172.29.207.2",
        "mac": "OEMT3C625BA2",
        "serial": "OEMT3C625BA2",
        "queue": "Plan_161900_30183_WispHub",
        "interface": "VLAN229_PANTIN",
        "created_at": "2024-08-22T17:25:48.605350",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4511,
      "client_name": "RAIZA JOSEFINA LOYO BRAVO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243364966",
      "client_email": "RAIZAREPOSTERA.LB@GMAIL.COM",
      "address": "CALLE 7 CASA TETRA NRO 549-A URB MATA CABALLO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V16128885",
      "nap_box_name": "CTO-00073",
      "created_at": "2024-06-08T16:51:15.073501",
      "service_detail": {
        "id": 6146,
        "ip": "172.29.208.2",
        "mac": "OEMT3C626272",
        "serial": "OEMT3C626272",
        "queue": "queue1",
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2024-08-22T17:23:49.322440",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4512,
      "client_name": "GEANCARLO RODRIGUEZ JUAREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vallecito",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04127769459",
      "client_email": "GEANCARLORJ260499@GMAIL.COM",
      "address": "CALLE LOS NARANJOS CASA NRO 21 SECTOR COLINAS DE VALLECITO ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V26791917",
      "nap_box_name": "CTO-00082",
      "created_at": "2024-06-08T16:56:40.663855",
      "service_detail": {
        "id": 3197,
        "ip": "172.29.97.2",
        "mac": "OEMT3C625BBE",
        "serial": "OEMT3C625BBE",
        "queue": "Plan_161895_30183_WispHub",
        "interface": "VLAN258_VALLECITO",
        "created_at": "2024-06-27T17:50:32.930858",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4513,
      "client_name": "YUSMARY MARGARETH PALMA DE ZAMBRANO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Simon Bolivar",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04143449308",
      "client_email": "ZAMBRANO13@GMAIL.COM",
      "address": "CALLE 2 CASA NRO 5 SECTOR SIMON BOLIVAR",
      "client_identification": "V17577117",
      "nap_box_name": "CTO-00042",
      "created_at": "2024-06-08T17:11:52.410344",
      "service_detail": {
        "id": 6144,
        "ip": "172.17.162.2",
        "mac": "VSOL001194C9",
        "serial": "VSOL001194C9",
        "queue": "Plan_137413_1574_WispHub",
        "interface": "VLAN128_SIMON_BOLIVAR_ZTE",
        "created_at": "2024-08-22T17:21:36.561058",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4514,
      "client_name": "MAUYURI MAURA HERNANDEZ BOLIVAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados III",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144445955",
      "client_email": "MAUYU06@GMAIL.COM",
      "address": "CALLE 5 CASA NRO 34 SECTOR PRADOS III ROSARIO DE PAYA",
      "client_identification": "V17145354",
      "nap_box_name": "CTO-00305",
      "created_at": "2024-06-08T17:23:37.094853",
      "service_detail": {
        "id": 6142,
        "ip": "172.18.3.2",
        "mac": "VSOL0051F1E1",
        "serial": "VSOL0051F1E1",
        "queue": "Plan_161870_30181_WispHub",
        "interface": "VLAN236_PRADOS3",
        "created_at": "2024-08-22T17:19:49.761280",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4515,
      "client_name": "JHONNY RAFAEL PERFECTO RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04142253682",
      "client_email": "JHONNYPERFECTO@GMAIL.COM",
      "address": "CALLE 1 CASA NRO 6 SECTOR PRADO I ROSARIO DE PAYA ARAGUA",
      "client_identification": "V8777427",
      "nap_box_name": "CTO-00193",
      "created_at": "2024-06-08T17:26:37.400617",
      "service_detail": {
        "id": 6480,
        "ip": "172.17.136.2",
        "mac": "OEMT3C626226",
        "serial": "OEMT3C626226",
        "queue": "Plan_161906_30183_WispHub",
        "interface": "VLAN239_PRADOS1",
        "created_at": "2024-08-31T12:57:00.497092",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4516,
      "client_name": "BETSY CAROLINA ZAMBRANO SALAZAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vista Hermosa",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128995156",
      "client_email": "ZAMBABET30@GMAIL.COM",
      "address": "CALLE LAS MANDARINAS CASA NRO 73 SECTOR VISTA HERMOSA",
      "client_identification": "V18552230",
      "nap_box_name": "CTO-00059",
      "created_at": "2024-06-08T17:32:11.151877",
      "service_detail": {
        "id": 12017,
        "ip": "172.17.243.2",
        "mac": "VSOL001246A1",
        "serial": "VSOL001246A1",
        "queue": null,
        "interface": "VLAN230_VISTA_HERMOSA",
        "created_at": "2026-03-09T14:20:12.858853",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4517,
      "client_name": "MARIA DULCE LEDEZMA GUTIERREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Isaac Oliveira",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243219707",
      "client_email": "AURIRODRIGUEZ246@GMAIL.COM",
      "address": "CALLE 1 CASA NRO 54 URB ISAAC OLIVEIRA TURMERO ARAGUA",
      "client_identification": "V10976217",
      "nap_box_name": "CTO-00258",
      "created_at": "2024-06-08T17:35:35.211761",
      "service_detail": {
        "id": 11811,
        "ip": "172.17.153.2",
        "mac": "VSOL00139179",
        "serial": "VSOL00139179",
        "queue": null,
        "interface": "VLAN107_ISAAC_O",
        "created_at": "2026-02-27T11:43:26.626146",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4518,
      "client_name": "MARIA EUGENIA ARAUJO RIVERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Isaac Oliveira",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04165147074",
      "client_email": "AMARTE0FICIAL0102@GMAIL.COM",
      "address": "CALLE 03 MANZANA 6 3ERA ETAPA CASA NRO 120 SECTOR ISAAC OLIVEIRA",
      "client_identification": "V7211883",
      "nap_box_name": "134",
      "created_at": "2024-06-08T17:47:42.480254",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4519,
      "client_name": "LUIS EDUARDO LUNA COLMENARES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Simon Bolivar",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144779155",
      "client_email": "LUEDLUCOL452@GMAIL.COM",
      "address": "URB SIMON BOLIVAR EL MACARO CALLE 1 NRO 46",
      "client_identification": "V20990452",
      "nap_box_name": "CTO-00041",
      "created_at": "2024-06-08T17:50:40.462542",
      "service_detail": {
        "id": 6067,
        "ip": "172.17.52.2",
        "mac": "OEMT3C620D96",
        "serial": "OEMT3C620D96",
        "queue": "Plan_137413_1574_WispHub",
        "interface": "VLAN128_SIMON_BOLIVAR_ZTE",
        "created_at": "2024-08-22T13:31:21.844339",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4520,
      "client_name": "MELISSA LISBETH MEJIAS NAVAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144501023",
      "client_email": "LISBETHMEJIAS1520@GMAIL.COM",
      "address": "SECTOR MATA CABALLO CALLE 7 APTO 555A",
      "client_identification": "V17245963",
      "nap_box_name": "CTO-00310",
      "created_at": "2024-06-08T17:53:49.635770",
      "service_detail": {
        "id": 6066,
        "ip": "172.24.41.2",
        "mac": "VSOL00140F89",
        "serial": "VSOL00140F89",
        "queue": "Plan_161903_30183_WispHub",
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2024-08-22T13:29:34.835878",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4521,
      "client_name": "EMILY MAR MADRID DE SANCHEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144751397",
      "client_email": "GABRIELCONEJE32@HOTMAIL.COM",
      "address": "CALLE 14 CASA NRO 54 SECTOR LA CASONA II  TURMERO",
      "client_identification": "V12609642",
      "nap_box_name": "CTO-00088 DOS",
      "created_at": "2024-06-08T17:59:39.411804",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4522,
      "client_name": "FERNANDO JOSE IRIARTE IZQUIEL",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Simon Bolivar",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04121491420",
      "client_email": "FERNANDO311275@GMAIL.COM",
      "address": "SIMON BOLIVAR CALLE NRO 03 CASA NRO 38 TURMERO",
      "client_identification": "V12569236",
      "nap_box_name": "CTO-00046",
      "created_at": "2024-06-08T18:08:52.223895",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4523,
      "client_name": "JORGE JOSE MILANO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04143446589",
      "client_email": "JORGEJOSEMILANO434@GMAIL.COM",
      "address": "CALLE 13 CASA NRO 2 URB LA  CASONA II TURMERO",
      "client_identification": "V10119191",
      "nap_box_name": "CTO-00090",
      "created_at": "2024-06-08T18:12:47.853239",
      "service_detail": {
        "id": 3529,
        "ip": "172.24.8.2",
        "mac": "VSOL0013C559",
        "serial": "VSOL0013C559",
        "queue": "Plan_131647_24341_WispHub",
        "interface": "VLAN110_CASONA_2",
        "created_at": "2024-07-08T16:46:24.576794",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4524,
      "client_name": "URISMARY YOLEIDY TORTOLERO NAVAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vallecito",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128862696",
      "client_email": "URISMARYYOLEIDY@GMAIL.COM",
      "address": "CALLE LA CEIBA CASA NRO 6 SECTOR VALLECITO ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V10459736",
      "nap_box_name": "CTO-00081",
      "created_at": "2024-06-09T08:22:28.092400",
      "service_detail": {
        "id": 6063,
        "ip": "172.29.73.2",
        "mac": "OEMT3C625EC6",
        "serial": "OEMT3C625EC6",
        "queue": "queue1",
        "interface": "VLAN258_VALLECITO",
        "created_at": "2024-08-22T13:23:39.886764",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4525,
      "client_name": "NOHEMI DEL VALLE PEREZ CORRALES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04127787241",
      "client_email": "PEREZNOHEMY846@GMAIL.COM",
      "address": "CALLE 23 CASA NRO 36 SECTOR RIO SECO ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V9670581",
      "nap_box_name": "CTO-00077",
      "created_at": "2024-06-09T08:25:31.836550",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4526,
      "client_name": "JORGE ALEJANDRO DELGADO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Marina Caribe",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04127405041",
      "client_email": "JORALDEL@GMAIL.COM",
      "address": "CALLE PRINCIPAL, SECTOR 6, RES. MARINA CARIBE CASA NRO 1 URB SAN PABLO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V8624825",
      "nap_box_name": "CTO-00078",
      "created_at": "2024-06-09T08:27:50.557668",
      "service_detail": {
        "id": 2943,
        "ip": "172.29.79.2",
        "mac": "OEMT3C62575E",
        "serial": "OEMT3C62575E",
        "queue": "Plan_153953_15811_WispHub",
        "interface": "VLAN259_LA_ORQUIDEA",
        "created_at": "2024-06-20T08:25:20.037370",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4527,
      "client_name": "LUISA ALEXANDRA BORGES LUCERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vallecito",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121418213",
      "client_email": "LUISABORGESLUCERO53@GMAIL.COM",
      "address": "VALLECITO CALLE EL CUJI CASA NRO 24 ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V13769142",
      "nap_box_name": "CTO-00081",
      "created_at": "2024-06-09T08:29:57.934905",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4528,
      "client_name": "FREDERID ABEL SALGADO PEÑA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Valle Verde",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04143584364",
      "client_email": "SALGADOFREDERID03@GMAIL.COM",
      "address": "CALLE LOS MAMONES CASA NRO 08 SECTOR VALLE VERDE ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V29786951",
      "nap_box_name": "CTO-00187",
      "created_at": "2024-06-09T08:31:41.796154",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4529,
      "client_name": "MARIA JOSEFINA MONTES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vallecito",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128874537",
      "client_email": "MARI_MONTES1@HOTMAIL.COM",
      "address": "CALLE EL ROBLE CASA NRO 11 SECTOR VALLECITO ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V9438539",
      "nap_box_name": "CTO-00175",
      "created_at": "2024-06-09T08:34:20.205064",
      "service_detail": {
        "id": 4094,
        "ip": "172.29.82.2",
        "mac": "OEMT3C625B72",
        "serial": "OEMT3C625B72",
        "queue": "queue1",
        "interface": "VLAN258_VALLECITO",
        "created_at": "2024-07-23T08:41:07.061736",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4530,
      "client_name": "GENESIS YAMILETH FREITES ALVORNOZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vallecito",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04125972195",
      "client_email": "DARWINZFREITES@GMAIL.COM",
      "address": "CALLE LOS MANGOS CASA NRO 36 BARRIO VALLECITO ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V19468873",
      "nap_box_name": "CTO-00074",
      "created_at": "2024-06-09T08:39:13.454075",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4531,
      "client_name": "MARIANLLYS YELITZA QUERO ANTEQUERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243473593",
      "client_email": "MARIANLLYSQUERO88@GMAIL.COM",
      "address": "CALLE 4-A CASA NRO 15 URB PANTIN ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V20452966",
      "nap_box_name": "CTO-00076 DOS",
      "created_at": "2024-06-09T08:41:31.524029",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4532,
      "client_name": "WUILIAM ARMANDO BAYERA LOPEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vallecito",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04140528706",
      "client_email": "WUILIAMBAYERA17@GMAIL.COM",
      "address": "CALLE LOS MANGOS C/C LAS PALMAS CASA NRO 24 SECTOR COLINAS DE VALLECITO TURMERO ARAGUA",
      "client_identification": "V15600195",
      "nap_box_name": "CTO-00074",
      "created_at": "2024-06-09T08:43:13.978909",
      "service_detail": {
        "id": 12337,
        "ip": "172.29.80.2",
        "mac": "OEMT3C625BAE",
        "serial": "OEMT3C625BAE",
        "queue": null,
        "interface": "VLAN258_VALLECITO",
        "created_at": "2026-04-16T20:18:28.700595",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4533,
      "client_name": "YEISON NEHOMAR RISSO SANCHEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243798296",
      "client_email": "YEISONRISSO99@GMAIL.COM",
      "address": "AV 2 CASA NRO 471 SECTOR MATA CABLLO, ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V27048070",
      "nap_box_name": "CTO-00222",
      "created_at": "2024-06-09T08:45:18.258337",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4534,
      "client_name": "FANNY VIRGUEZ PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121481177",
      "client_email": "FANNYVIRGUEZPEREZ@GMAIL.COM",
      "address": "CALLE 10 CASA NRO 38 URB LA CASONA 1 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V12337232",
      "nap_box_name": "CTO-00071",
      "created_at": "2024-06-09T08:48:25.523142",
      "service_detail": {
        "id": 5838,
        "ip": "172.29.78.2",
        "mac": "OEMT3C62572A",
        "serial": "OEMT3C62572A",
        "queue": "Plan_131647_24341_WispHub",
        "interface": "VLAN109_CASONA_1",
        "created_at": "2024-08-20T13:35:29.356981",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4535,
      "client_name": "MARIA DE LOS ANGELES BUENO ROJAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vallecito",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243403290",
      "client_email": "M.BUENOROJAS@GMAIL.COM",
      "address": "CALLE ARAGUANEY CASA NRO 52 SECTOR COLINAS DE VALLECITO ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V21259747",
      "nap_box_name": "CTO-00062",
      "created_at": "2024-06-09T08:51:21.742398",
      "service_detail": {
        "id": 6061,
        "ip": "172.29.74.2",
        "mac": "HWTC572B8D71",
        "serial": "HWTC572B8D71",
        "queue": "Plan_161906_30183_WispHub",
        "interface": "VLAN258_VALLECITO",
        "created_at": "2024-08-22T12:50:04.933985",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4536,
      "client_name": "INGRID COROMOTO RUIZ MATUTE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Brisas de Paya",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124006778",
      "client_email": "VELOZJULIO1983@GMAIL.COM",
      "address": "CALLE 3 CASA NRO 1 SECTOR BRISAS DE PAYA ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V16734731",
      "nap_box_name": "366",
      "created_at": "2024-06-09T08:53:41.652513",
      "service_detail": {
        "id": 6060,
        "ip": "172.29.98.2",
        "mac": "OEMT3C625EC2",
        "serial": "OEMT3C625EC2",
        "queue": "Plan_161906_30183_WispHub",
        "interface": "VLAN241_BRISAS",
        "created_at": "2024-08-22T12:47:20.448720",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4537,
      "client_name": "ENDIS MANUEL GODOY GUARAMO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04127767087",
      "client_email": "ENDISGODOY29@GMAIL.COM",
      "address": "CALLE 7-A CASA NRO 18 URB PANTIN ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V24173857",
      "nap_box_name": "CTO-00139",
      "created_at": "2024-06-09T08:57:20.402631",
      "service_detail": {
        "id": 10879,
        "ip": "172.29.96.2",
        "mac": "OEMT3C6261CE",
        "serial": "OEMT3C6261CE",
        "queue": null,
        "interface": "VLAN229_PANTIN",
        "created_at": "2025-12-23T08:20:57.464002",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4538,
      "client_name": "YOLEIDA MILAGROS PANTOJA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Bicentenario",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243668236",
      "client_email": "PANTOYOLEI04@GMAIL.COM",
      "address": "CALLE ARAGUANEY MANZANA 10 CASA NRO 11 DESARROLLO URBANÍSTICO ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V16765279",
      "nap_box_name": "592",
      "created_at": "2024-06-09T08:58:54.802960",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4539,
      "client_name": "JHONAIKER JOSELUIS URBINA GONZALEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04163097354",
      "client_email": "JHONAIKERURBINA44@GMAIL.COM",
      "address": "CALLE 7 CASA NRO 551-C SECTOR MATA CABALLO ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V31209686",
      "nap_box_name": "CTO-00073",
      "created_at": "2024-06-09T09:00:40.523596",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4540,
      "client_name": "JOSE GREGORIO GONZALEZ MUÑOZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Bicentenario",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04163475661",
      "client_email": "3LTOWNY@GMAIL.COM",
      "address": "CALLE MANZANA 11 CASA NRO 4 SECTOR FUNDABARRIO ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V25501230",
      "nap_box_name": "385",
      "created_at": "2024-06-09T09:04:03.589172",
      "service_detail": {
        "id": 3373,
        "ip": "172.29.99.2",
        "mac": "OEMT3C62616A",
        "serial": "OEMT3C62616A",
        "queue": "Plan_161900_30183_WispHub",
        "interface": "VLAN243_BICENTENARIO",
        "created_at": "2024-07-02T17:27:26.338493",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4541,
      "client_name": "RONNY YOMAR MORILLO HERRERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04243618548",
      "client_email": "ENOCYYO@GMAIL.COM",
      "address": "URBANISMO PALMA REAL 2 CALLE PRINCIPAL N 50 ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V9698097",
      "nap_box_name": "CTO-00208",
      "created_at": "2024-06-09T09:08:42.513354",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4542,
      "client_name": "PAOLA NAZARETH CABELLO TORREALBA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Guanarito",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04127764601",
      "client_email": "KARLEIDYSHERMOSO90@GMAIL.COM",
      "address": "COMUNIDAD LEONARDO RUIZ PINEDA CALLE MARGARITA RIVERO CASA NRO 18 SECTOR GUANARITO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V26735621",
      "nap_box_name": "216",
      "created_at": "2024-06-09T09:11:12.290028",
      "service_detail": {
        "id": 4616,
        "ip": "172.29.76.2",
        "mac": "OEMT3C6260B2",
        "serial": "OEMT3C6260B2",
        "queue": "Plan_153953_15811_WispHub",
        "interface": "VLAN232_GUANARITO_OLT2",
        "created_at": "2024-08-11T20:56:34.239324",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4543,
      "client_name": "EGLEE CLORINDA MARTINEZ DE MARTINEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Laguna Plaza",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243783980",
      "client_email": "EGLEEMARTINEZ@HOTMAIL.COM",
      "address": "CALLE NEGRO PRIMERO C/C CAMILO TORRES EDIF 16 PISO PB URB LAGUNA PLAZA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V4546351",
      "nap_box_name": "3",
      "created_at": "2024-06-09T09:13:18.824667",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4544,
      "client_name": "YUDIMIR BARRAZA ACUÑA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243287220",
      "client_email": "YUDIMIRBARRAZA@GMAIL.COM",
      "address": "AV PRINCIPAL CASA NRO 25 PRADOS DE PAYA I ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V24445659",
      "nap_box_name": "CTO-00304",
      "created_at": "2024-06-09T09:15:40.373370",
      "service_detail": {
        "id": 3174,
        "ip": "172.29.90.2",
        "mac": "OEMT3C6261EE",
        "serial": "OEMT3C6261EE",
        "queue": "Plan_161903_30183_WispHub",
        "interface": "VLAN239_PRADOS1",
        "created_at": "2024-06-27T16:47:53.539208",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4545,
      "client_name": "JOELYS DEL CARMEN RODRIGUEZ RUZA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04126139354",
      "client_email": "JOEELYS091@GMAIL.COM",
      "address": "CALLE PRINCIPAL CASA NRO 5 SECTOR SAMAN TARAZONERO II TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V29786880",
      "nap_box_name": "115",
      "created_at": "2024-06-09T09:23:13.101079",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4546,
      "client_name": "JOSE RAFAEL MONTES GONZALEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Residencias Candys",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128961162",
      "client_email": "JOXMAL123@GMAIL.COM",
      "address": "CALLE RIVAS EDIF CANDY 1 PISO 9 APT 91 CONJUNTO RESIDENCIAL RESIDENCIAS CANDYS TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V28045702",
      "nap_box_name": "CTO-0516",
      "created_at": "2024-06-09T09:24:49.153574",
      "service_detail": {
        "id": 5808,
        "ip": "172.29.84.2",
        "mac": "OEMT3C626016",
        "serial": "OEMT3C626016",
        "queue": "Plan_153953_15811_WispHub",
        "interface": "VLAN254_CANDYS_OLT1",
        "created_at": "2024-08-20T09:02:32.574645",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4547,
      "client_name": "GREGORI ALEXANDER PEREZ ALBORNOZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243768159",
      "client_email": "PEREZGREGORI363@GMAIL.COM",
      "address": "CALLE 8 CASA NRO 570-D URB MATACABALLO ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V15611528",
      "nap_box_name": "CTO-00215",
      "created_at": "2024-06-09T09:27:05.266407",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4548,
      "client_name": "ANA MARIA ARAQUE SANCHEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04243583599",
      "client_email": "ANAARAQUE499@GMAIL.COM",
      "address": "AV 2 CASA NRO 4-68 SECTOR MATACABALLO ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V30755007",
      "nap_box_name": "CTO-00222",
      "created_at": "2024-06-09T09:29:06.717925",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4549,
      "client_name": "WLADIMIR JOSE MORILLO CALDERON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Tibisay Guevara",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04127762439",
      "client_email": "DIEGOMMR5@GMAIL.COM",
      "address": "CALLE MACARO CASA PARCELA NRO 33 SECTOR TIBISAY GUEVARA LA UNION ARAGUA ZONA POSTAL 2115",
      "client_identification": "V21269572",
      "nap_box_name": "CE-00014",
      "created_at": "2024-06-09T09:32:16.106691",
      "service_detail": {
        "id": 3076,
        "ip": "172.29.86.2",
        "mac": "HWTC3A6E9BA1",
        "serial": "HWTC3A6E9BA1",
        "queue": "Plan_153953_15811_WispHub",
        "interface": "VLAN248_TIBISAY_OLT2",
        "created_at": "2024-06-22T11:50:45.679333",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4550,
      "client_name": "YOSILE ABERLIN MARTINEZ PADOVANY",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04129683809",
      "client_email": "YOSILE15@HOTMAIL.COM",
      "address": "CALLE 5 CASA NRO 332 URB MATA CABALLO ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V22343487",
      "nap_box_name": "CTO-00069",
      "created_at": "2024-06-09T09:40:13.264967",
      "service_detail": {
        "id": 13143,
        "ip": "172.29.70.2",
        "mac": "HW:TC:05:8A:AB:A1",
        "serial": "HWTC058AABA1",
        "queue": null,
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2026-10-10T13:54:12.525232",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4551,
      "client_name": "MARIA DE LOS ANGELES CAICEDO DE GARCIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Santa Eduviges",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04125987301",
      "client_email": "CAICEDOMARIA838@GMAIL.COM",
      "address": "CALLE PRINCIPAL CASA NRO 47 A URBANIZACION SANTA EDUVIGES LA JULIA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V16851798",
      "nap_box_name": "503",
      "created_at": "2024-06-09T09:42:47.114053",
      "service_detail": {
        "id": 6201,
        "ip": "172.29.88.2",
        "mac": "HWTC46D35CA1",
        "serial": "HWTC46D35CA1",
        "queue": "Plan_131341_24341_WispHub",
        "interface": "VLAN143_STAEDUVIGES2",
        "created_at": "2024-08-23T08:17:22.786787",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4553,
      "client_name": "ENMANUEL ENRIQUE MUJICA SANCHEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04262347023",
      "client_email": "MUJICACHRISTOPHER709@GMAIL.COM",
      "address": "CALLE 4 CASA NRO 8 URB PRADOS DE PAYA I TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V26095497",
      "nap_box_name": "CTO-00061",
      "created_at": "2024-06-09T09:46:43.468072",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4554,
      "client_name": "YOHANA YELIBETH ESCALONA RANGEL",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Canaima",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124869128",
      "client_email": "escalonarangely@gmail.com",
      "address": "CALLE 3 CASA NRO 15 SECTOR CANAIMA ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V22342376",
      "nap_box_name": "355",
      "created_at": "2024-06-09T09:49:01.731961",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4555,
      "client_name": "MAIKEL ANIBAL PACHECO GOMEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243039221",
      "client_email": "MAIKELAPG97@GMAIL.COM",
      "address": "A\t CALLE 17 CASA NRO 37 SECTOR RIO SECO ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V26935349",
      "nap_box_name": "CTO-00070",
      "created_at": "2024-06-09T09:50:57.944052",
      "service_detail": {
        "id": 12714,
        "ip": "172.29.56.2",
        "mac": "HW:TC:88:4A:E4:85",
        "serial": "HWTC884AE485",
        "queue": null,
        "interface": "VLAN251_RIO_SECO",
        "created_at": "2026-07-09T15:02:42.073786",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4556,
      "client_name": "VICTOR RAFAEL BOLIVAR CANELA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Naranjal",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04126705349",
      "client_email": "VICTORBOLIVAR772@GMAIL.COM",
      "address": "CARRETERA PRINCIPAL ROSARIO DE PAYA NB-03 SECTOR EL NARANJAL TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V19003005",
      "nap_box_name": "CE - 681",
      "created_at": "2024-06-09T10:01:09.628584",
      "service_detail": {
        "id": 6388,
        "ip": "172.29.68.2",
        "mac": "HWTC462BBFA1",
        "serial": "HWTC462BBFA1",
        "queue": "Plan_161906_30183_WispHub",
        "interface": "VLAN246_NARANJAL",
        "created_at": "2024-08-27T14:51:54.521062",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4557,
      "client_name": "JOSE GREGORIO HERNANDEZ ORTIZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243078199",
      "client_email": "AMOADIOS2929@GMAIL.COM",
      "address": "CALLE 2 CASA NRO 27 SECTOR PRADOS I ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V8556950",
      "nap_box_name": "CTO-00300",
      "created_at": "2024-06-09T10:03:01.629061",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4558,
      "client_name": "MAURA JOSEFINA MORONTA VILLEGAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Paya Abajo",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04125971488",
      "client_email": "CATHERINL521@GMAIL.COM",
      "address": "CALLE SAN MIGUEL CASA NRO 31 SECTOR PAYA ABAJO ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V14060007",
      "nap_box_name": "340",
      "created_at": "2024-06-09T10:05:00.917863",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4559,
      "client_name": "JOELIS DEL MAR HERNANDEZ HERNANDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vallecito",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121493795",
      "client_email": "HERNANDEZHERNANDEZJOELIS@GMAIL.COM",
      "address": "CALLE LAS PALMAS CRUCE CON BUCARE CASA NRO 01 SECTOR VALLECITO ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V26961988",
      "nap_box_name": "CTO-00067",
      "created_at": "2024-06-09T10:11:51.361966",
      "service_detail": {
        "id": 6154,
        "ip": "172.29.62.2",
        "mac": "OEMT3C6250E2",
        "serial": "OEMT3C6250E2",
        "queue": "queue1",
        "interface": "VLAN258_VALLECITO",
        "created_at": "2024-08-22T17:38:38.405446",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4560,
      "client_name": "EVELIN YULIVET PADRON PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04125370688",
      "client_email": "EVELINPADRON78@GMAIL.COM",
      "address": "CALLE NRO 4 CASA NRO 12 URB PRADOS II TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V14429439",
      "nap_box_name": "CTO-00100",
      "created_at": "2024-06-09T10:14:56.107313",
      "service_detail": {
        "id": 9217,
        "ip": "172.29.77.2",
        "mac": "HWTC48D22CA1",
        "serial": "HWTC48D22CA1",
        "queue": "queue1",
        "interface": "VLAN242_PRADOS2",
        "created_at": "2025-07-17T08:33:00.742574",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4561,
      "client_name": "ANDREA EMPERATRIZ RODRIGUEZ GONZALEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Bicentenario",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04127123515",
      "client_email": "EMPERATRIZ.8858TAU@GMAIL.COM",
      "address": "CALLE BICENTENARIO CASA NRO 14 PB SECTOR MANZANA 10 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V19554249",
      "nap_box_name": "592",
      "created_at": "2024-06-09T10:50:48.397007",
      "service_detail": {
        "id": 11472,
        "ip": "172.29.65.2",
        "mac": "HWTC053CC7A1",
        "serial": "HWTC053CC7A1",
        "queue": null,
        "interface": "VLAN243_BICENTENARIO",
        "created_at": "2026-02-04T13:25:13.609150",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4562,
      "client_name": "CARMEN RENE ORONO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04140521748",
      "client_email": "CARMENORONO3@GMAIL.COM",
      "address": "CALLE RIVAS EDIF BLOQUE 27 PISO APTO 03 URB LOS NISPEROS TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V4669914",
      "nap_box_name": "CTO-00207 DOS",
      "created_at": "2024-06-09T10:52:15.191200",
      "service_detail": {
        "id": 6140,
        "ip": "172.29.64.2",
        "mac": "HWTC3899BDA1",
        "serial": "HWTC3899BDA1",
        "queue": "Plan_153953_15811_WispHub",
        "interface": "VLAN209_ZAMORA_OLT1",
        "created_at": "2024-08-22T17:17:10.538530",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4563,
      "client_name": "LIZBETH COROMOTO GONZALEZ SALCEDO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243208125",
      "client_email": "GONZALEZLISBET950@GMAIL.COM",
      "address": "AV PRINCIPAL CASA NRO 56 SECTOR PRADOS DE PAYA I ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V12855740",
      "nap_box_name": "CTO-00211 DOS",
      "created_at": "2024-06-09T10:53:53.348667",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4564,
      "client_name": "OLGA XIOMARA ARAGUREN IBARRA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Jabillar",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128751640",
      "client_email": "OLGACRIS2000@GMAIL.COM",
      "address": "CALLE 15 CASA NRO 10 SECTOR EL MACARO URBANIZACION JABILLAR TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V4433524",
      "nap_box_name": "CTO-00003",
      "created_at": "2024-06-09T10:56:35.948850",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4565,
      "client_name": "LOBELIA MARGARITA GAMEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados I",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128972503",
      "client_email": "LOBELIA_GAMEZ@HOTMAIL.COM",
      "address": "CALLE 13 CASA NRO 30 SECTOR ROSARIO DE PAYA PRADOS I TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V11758120",
      "nap_box_name": "CTO-0370",
      "created_at": "2024-06-09T10:58:15.422327",
      "service_detail": {
        "id": 6138,
        "ip": "172.29.63.2",
        "mac": "HWTC020B75A1",
        "serial": "HWTC020B75A1",
        "queue": "Plan_161906_30181_WispHub",
        "interface": "VLAN239_PRADOS1",
        "created_at": "2024-08-22T17:12:36.116304",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4566,
      "client_name": "MARWIN JOSE PARRA GONZALEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Las Rurales",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121492799",
      "client_email": "MJPARRA2002@GMAIL.COM",
      "address": "CALLE MIGUEL POLEO CASA NRO 5 LAS RURALES TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V30211941",
      "nap_box_name": "CTO-00200",
      "created_at": "2024-06-09T11:00:23.756714",
      "service_detail": {
        "id": 8249,
        "ip": "172.29.59.2",
        "mac": "HWTC4906B6A1",
        "serial": "HWTC4906B6A1",
        "queue": "Plan_107915_30181_WispHub",
        "interface": "VLAN252_RURALES_PAYA",
        "created_at": "2025-04-14T17:11:23.450353",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4567,
      "client_name": "NELSON ENRIQUE SEBASTIANI MORALES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144122361",
      "client_email": "NELSONESM@HOTMAIL.COM",
      "address": "CALLE NEGRO PRIMERO RESIDENCIAS FASAN NRO 18 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V13199721",
      "nap_box_name": "CTO-00065",
      "created_at": "2024-06-09T11:03:26.869123",
      "service_detail": {
        "id": 3392,
        "ip": "172.28.254.2",
        "mac": "HWTC04226EA1",
        "serial": "HWTC04226EA1",
        "queue": "Plan_153953_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-07-03T08:27:28.803650",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4568,
      "client_name": "YELVIMAR MILAGROS CAMPOS MOSQUEDA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121437241",
      "client_email": "YELVIMARCAMPOS8@GMAIL.COM",
      "address": "CALLE 2 CASA NRO 82 URB MATA CABALLO ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V19363315",
      "nap_box_name": "CTO-00102",
      "created_at": "2024-06-09T11:18:25.350634",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4569,
      "client_name": "ALONDRA LEIDIMAR GAZCON GUTIERREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121491899",
      "client_email": "LEIDYGUTI288@GMAIL.COM",
      "address": "CALLE 10-A CASA NRO 20 URB PANTI ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V26679366",
      "nap_box_name": "CTO-00121",
      "created_at": "2024-06-09T11:20:49.088735",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4570,
      "client_name": "DEISY JASMIN ROJAS AVILA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144041583",
      "client_email": "DEIROJASAVILA1@GMAIL.COM",
      "address": "CALLE 6 CASA NRO 422 URB MATA CABALLO ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V13553918",
      "nap_box_name": "CTO-00031",
      "created_at": "2024-06-09T11:23:23.140006",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4571,
      "client_name": "ADANSON ALFREDO BARRIOS NIEVES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243724689",
      "client_email": "GNIEVES1988@GMAIL.COM",
      "address": "CALLE 3 CASA NRO 187 SECTOR MATA CABALLO ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V30658552",
      "nap_box_name": "CTO-00156",
      "created_at": "2024-06-09T11:43:56.800932",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4572,
      "client_name": "EVELYN MARYSABALBA BARCELO PARRA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243565824",
      "client_email": "MERCEDESYOVERA.EB@GMAIL.COM",
      "address": "CALLE 8 CASA NRO 578-D SECTOR MATA CABALLO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V11273953",
      "nap_box_name": "CTO-00130",
      "created_at": "2024-06-09T11:47:13.898197",
      "service_detail": {
        "id": 10295,
        "ip": "172.29.57.2",
        "mac": "HWTC3AD089A1",
        "serial": "HWTC3AD089A1",
        "queue": null,
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2025-11-24T15:39:24.861136",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4573,
      "client_name": "JOSE ALEXANDER APARICIO RAMONES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vista Hermosa",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04145733505",
      "client_email": "ENEIDA75HB@GMAIL.COM",
      "address": "CALLE LAS MANDARINAS CASA NRO 85 SECTOR VISTA HERMOSA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V11405110",
      "nap_box_name": "CTO-00060 DOS",
      "created_at": "2024-06-09T11:49:05.772160",
      "service_detail": {
        "id": 12013,
        "ip": "172.29.50.2",
        "mac": "HWTC32B845A1",
        "serial": "HWTC32B845A1",
        "queue": null,
        "interface": "VLAN230_VISTA_HERMOSA",
        "created_at": "2026-03-09T12:51:47.933080",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4574,
      "client_name": "EDUAR JOSE TORO ZAMBRANO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04129687067",
      "client_email": "ZAMBRANOEDUAR78@GMAIL.COM",
      "address": "CALLE 7 CASA NRO 14 SECTOR PRADOS DE PAYA I ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V24236618",
      "nap_box_name": "CTO-00061",
      "created_at": "2024-06-09T11:51:06.741895",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4575,
      "client_name": "DEISY CAROLAIS SANCHEZ CORDOBA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vista Hermosa",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124595438",
      "client_email": "CHIKISANCHEZ661@GMAIL.COM",
      "address": "CALLE VÍA PRINCIPAL DE PAYA CASA NRO 01 URB VISTA HERMOSA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V25841174",
      "nap_box_name": "CTO-00057",
      "created_at": "2024-06-09T11:52:40.222542",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4577,
      "client_name": "ODALYS ANTONIA LUCENA VIEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04122085268",
      "client_email": "ODALYSCE24@GMAIL.COM",
      "address": "CALLE 3 CASA NRO 25 SECTOR PRADOS DE PAYA II ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V19607856",
      "nap_box_name": "CE - 288",
      "created_at": "2024-06-09T11:56:25.985251",
      "service_detail": {
        "id": 11402,
        "ip": "172.29.48.2",
        "mac": "HWTC332D2EA1",
        "serial": "HWTC332D2EA1",
        "queue": null,
        "interface": "VLAN242_PRADOS2",
        "created_at": "2026-01-27T17:03:27.581296",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4578,
      "client_name": "PEDRO MANUEL VALLADOLID AGUINAGA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona II",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04122376043",
      "client_email": "VALLADOLIDP48@GMAIL.COM",
      "address": "CALLE 12 CASA NRO 15 SECTOR CASONA 2 TURMERO",
      "client_identification": "V15611879",
      "nap_box_name": "322",
      "created_at": "2024-06-09T12:32:32.205353",
      "service_detail": {
        "id": 4347,
        "ip": "172.23.250.2",
        "mac": "VSOL001411F1",
        "serial": "VSOL001411F1",
        "queue": "Plan_131648_24341_WispHub",
        "interface": "VLAN110_CASONA_2",
        "created_at": "2024-08-09T14:08:19.764689",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4579,
      "client_name": "LUIS MANUEL TRUJILLO GONZALEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Terrazas de Juan Pablo",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04243495948",
      "client_email": "DESOUSAANGELA30@GMAIL.COM",
      "address": "CALLE  LA LLANERA PARCELA NRO 15 EDIF MODULO PISO PRIMERO  APT-A-10 CONJUNTO RESIDENCIAL  TERRAZAS DE JUAN PABLO",
      "client_identification": "V16205031",
      "nap_box_name": "13",
      "created_at": "2024-06-09T12:38:35.798644",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4580,
      "client_name": "NAIROLG DEL VALLE DIAZ CANELON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero I",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04125969844",
      "client_email": "NAIROLGDIAZ19@GMAIL.COM",
      "address": "CALLE 03 CASA NRO 24 SECTOR SAMAN TARAZONERO I TURMERO",
      "client_identification": "V19949696",
      "nap_box_name": "291",
      "created_at": "2024-06-09T12:41:34.346825",
      "service_detail": {
        "id": 6120,
        "ip": "172.23.210.2",
        "mac": "VSOL0013EE19",
        "serial": "VSOL0013EE19",
        "queue": "Plan_157310_1574_WispHub",
        "interface": "VLAN100_OLTs",
        "created_at": "2024-08-22T16:35:35.320305",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4581,
      "client_name": "GUIDO RIGOBERTO MORENO AMADOR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Arturo Luis Berti",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04129686406",
      "client_email": "GUIDOMORENO777@GMAIL.COM",
      "address": "CALLE 3 CASA NRO 416 SECTOR ARTURO LUIS BERTI SAMAN DE GUERE",
      "client_identification": "V18083778",
      "nap_box_name": "65",
      "created_at": "2024-06-09T12:50:42.779798",
      "service_detail": {
        "id": 6111,
        "ip": "172.23.159.2",
        "mac": "GPON0097E126",
        "serial": "GPON0097E126",
        "queue": "queue1",
        "interface": "VLAN102_ARTURO_BERTI",
        "created_at": "2024-08-22T15:53:40.664977",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4582,
      "client_name": "YUSTIN RAFAEL SEQUEDA AGUILAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04221802559",
      "client_email": "YUSTINSEQUEDA1@GMAIL.COM",
      "address": "CALLE 3 CASA NRO 21 SECTOR 2 SAMAN TARAZONERO TURMERO ARAGUA",
      "client_identification": "V17985729",
      "nap_box_name": "64",
      "created_at": "2024-06-09T12:56:44.951085",
      "service_detail": {
        "id": 6107,
        "ip": "172.27.58.2",
        "mac": "GPON00980046",
        "serial": "GPON00980046",
        "queue": "Plan_129887_1574_WispHub",
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2024-08-22T15:26:33.864372",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4583,
      "client_name": "DENY YOSELIN ARISTIGUETA DELGADO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04142960211",
      "client_email": "DENYYOSELINARISTIGUETA@GMAIL.COM",
      "address": "CALLE 2 CASA NRO 12 URB  SAMAN  TARAZONERO II TURMERO",
      "client_identification": "V16865385",
      "nap_box_name": "115",
      "created_at": "2024-06-09T13:06:47.649165",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4585,
      "client_name": "ANGELICA ANDREINA PADRON VARGAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero I",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04243666364",
      "client_email": "ANYEWIN.CA@GMAIL.COM",
      "address": "CALLE 5 CASA NRO 45 BARRIO EL MACARO SAMAN TARAZONERO",
      "client_identification": "V20451337",
      "nap_box_name": "269",
      "created_at": "2024-06-09T13:14:51.050526",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4586,
      "client_name": "EDUARDO RAFAEL TORO MARTINEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128540345",
      "client_email": "YULEIMAMARTINEZ301@GMAIL.COM",
      "address": "SAMAN TARAZONERO  II EDO ARAGUA MANNZA B13 CASA NRO 12",
      "client_identification": "V19175131",
      "nap_box_name": "185",
      "created_at": "2024-06-09T13:18:29.818680",
      "service_detail": {
        "id": 6081,
        "ip": "172.27.55.2",
        "mac": "GPON0097D156",
        "serial": "GPON0097D156",
        "queue": "Plan_127744_1574_WispHub",
        "interface": "VLAN100_OLTs",
        "created_at": "2024-08-22T14:05:38.156757",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4587,
      "client_name": "EMILIO SEGOVIA ESCOBAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Simon Bolivar",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04121327800",
      "client_email": "GP928930@GMAIL.COM",
      "address": "CALLE 2 CASA NRO 15 URB  SIMON BOLIVAR ESTE  TURMERO",
      "client_identification": "V8059742",
      "nap_box_name": "CTO-00042",
      "created_at": "2024-06-09T13:21:58.046054",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4588,
      "client_name": "OMAIRA JOSEFINA GONZALEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Macarena",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243814674",
      "client_email": "OMAIRAGONZALEZ8896@GMAIL.COM",
      "address": "CALLE PRINCIPAL CASA NRO 10 URB LA MACARENA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V9460324",
      "nap_box_name": "300",
      "created_at": "2024-06-09T13:24:41.096376",
      "service_detail": {
        "id": 11159,
        "ip": "10.12.174.2",
        "mac": "QXTLCBF8EC60",
        "serial": "QXTLCBF8EC60",
        "queue": null,
        "interface": "VLAN113_LA_MACARENIA",
        "created_at": "2026-01-15T10:35:39.699496",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4589,
      "client_name": "FANNY ARACELIS VARGAS DE REYES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124160443",
      "client_email": "FANVARGAS488@GMAIL.COM",
      "address": "CALLE  PPAL  MANZANA C5 CASA NRO 03 URB SAMAN  TARAZONERO II  TURMERO",
      "client_identification": "V10754250",
      "nap_box_name": "502",
      "created_at": "2024-06-09T13:24:46.175152",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4590,
      "client_name": "JESUS ARNALDO FLORES FLORES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Paraiso",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243754960",
      "client_email": "JESUSARNALDOFLORES@GMAIL.COM",
      "address": "CALLE LA LIBERTAD CASA NRO 38 URB EL PARAISO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V13769054",
      "nap_box_name": "344",
      "created_at": "2024-06-09T13:28:09.748176",
      "service_detail": {
        "id": 6038,
        "ip": "172.28.228.2",
        "mac": "HWTC2517C0A1",
        "serial": "HWTC2517C0A1",
        "queue": "Plan_137413_1574_WispHub",
        "interface": "VLAN105_EL_PARAISO",
        "created_at": "2024-08-22T11:30:59.999886",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4591,
      "client_name": "YESSIKA COROMOTO GAMARRA HERNANDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04125970732",
      "client_email": "YESSIKAGAMARRA91@GMAIL.COM",
      "address": "CALLE PPAL MANZANA D5 CASA 20 SECTOR SAMAN TARAZONERO II EL MACARO TURMERO ARAGUA",
      "client_identification": "V19363453",
      "nap_box_name": "161",
      "created_at": "2024-06-09T13:29:00.110683",
      "service_detail": {
        "id": 6037,
        "ip": "172.27.27.2",
        "mac": "GPON0097DEB6",
        "serial": "GPON0097DEB6",
        "queue": "queue1",
        "interface": "VLAN100_OLTs",
        "created_at": "2024-08-22T11:25:19.227312",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4592,
      "client_name": "EDUARDO JOSE LEON APONTE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Paya Abajo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243180532",
      "client_email": "ILUSTRACIONES.LEON@GMAIL.COM",
      "address": "CALLE SAN MIGUEL N-31 SECTOR PAYA ABAJO ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V24930774",
      "nap_box_name": "CTO-00024",
      "created_at": "2024-06-09T13:30:02.363037",
      "service_detail": {
        "id": 7499,
        "ip": "172.28.220.2",
        "mac": "HWTC1D747DA1",
        "serial": "HWTC1D747DA1",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN231_PAYABAJO",
        "created_at": "2024-12-17T11:56:47.650499",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4593,
      "client_name": "OSWEL FERNANDO SALAZAR MARTINEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04122057934",
      "client_email": "OSWEL0100@GMAIL.COM",
      "address": "CALLE 01 CASA NRO 61 SECTOR  SAMAN TARAZONERO I TURMERO",
      "client_identification": "V30555435",
      "nap_box_name": "669",
      "created_at": "2024-06-09T13:32:02.311913",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4594,
      "client_name": "YEISON JESUS FERNANDEZ MORALES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Las Rurales",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243042520",
      "client_email": "YEISONFERNANDEZ92@GMAIL.COM",
      "address": "CALLE 106 CASA NRO 102 SECTOR LAS RURALES ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V20676030",
      "nap_box_name": "CTO-00200",
      "created_at": "2024-06-09T13:32:18.559884",
      "service_detail": {
        "id": 6026,
        "ip": "172.28.227.2",
        "mac": "OEMT3C625B12",
        "serial": "OEMT3C625B12",
        "queue": "Plan_161900_30183_WispHub",
        "interface": "VLAN252_RURALES_PAYA",
        "created_at": "2024-08-22T09:37:44.700578",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4595,
      "client_name": "ERWIN ALONSO ROSALES MARQUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Paya Abajo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04125972189",
      "client_email": "MOTOREPUESTOSWAWI@GMAIL.COM",
      "address": "AV PRINCIPAL ROSARIO DE PAYA, PAYA ABAJO, TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V18814239",
      "nap_box_name": "CE - 773",
      "created_at": "2024-06-09T13:34:40.027265",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4596,
      "client_name": "ROIMARLIN JENNILI MOGOLLON RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Simon Bolivar",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243438958",
      "client_email": "ROIMARLIN174@GMAIL.COM",
      "address": "CALLE 07 CASA NRO 38 SECTOR EL MACARO TURMERO",
      "client_identification": "V19174737",
      "nap_box_name": "CTO-00025",
      "created_at": "2024-06-09T13:35:57.945714",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4597,
      "client_name": "CARMEN MIGDALIA HERNANDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121480152",
      "client_email": "MIGDALIACOM5@GMAIL.COM",
      "address": "CALLE 9A CASA NRO 20 SECTOR PANTIN TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V9270012",
      "nap_box_name": "CTO-00142",
      "created_at": "2024-06-09T13:37:13.968250",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4598,
      "client_name": "AURORA ROSA ALVAREZ MEDINA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128480618",
      "client_email": "MEJIABRAYHAN2@GMAIL.COM",
      "address": "AV 05 CASA NRO 04 URB SAMAN TARAZONERO 3 TURMERO EDO ARAGUA",
      "client_identification": "V5053355",
      "nap_box_name": "93",
      "created_at": "2024-06-09T13:39:00.761119",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4599,
      "client_name": "MAIVEL NOELIA CORREA ROJAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243472064",
      "client_email": "MAIVELCORRE427@GMAIL.COM",
      "address": "CALLE 6 CASA NRO 452 URB MATA CABALLO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V15818411",
      "nap_box_name": "CTO-00178",
      "created_at": "2024-06-09T13:39:18.370086",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4600,
      "client_name": "LURBY BETSENY MONASTERIO ROSALES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 43,
        "name": "RECURRENTE RESIDENCIAL PLAN 650M",
        "cost": "46.00",
        "code": "FOR650M",
        "profile": "650M/650M"
      },
      "client_mobile": "04243654308",
      "client_email": "LURBYMONASTERIO@GMAIL.COM",
      "address": "CALLE 7 CASA NRO 543-C URB MATA CABALLO ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V12991539",
      "nap_box_name": "CTO-00310",
      "created_at": "2024-06-09T13:41:09.705234",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4601,
      "client_name": "MARIA GEORGINA BOLIVAR DE SANTIAGO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04145692449",
      "client_email": "MGBOLIVAR27@GMAIL.COM",
      "address": "CALLE 11 CASA 33 SECTOR PRADOS I ROSARIO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V19561220",
      "nap_box_name": "CTO-00204 DOS",
      "created_at": "2024-06-09T13:43:54.046544",
      "service_detail": {
        "id": 3092,
        "ip": "172.18.120.2",
        "mac": "HWTC30FDECA1",
        "serial": "HWTC30FDECA1",
        "queue": "Plan_161906_30183_WispHub",
        "interface": "VLAN239_PRADOS1",
        "created_at": "2024-06-23T08:20:39.939747",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4602,
      "client_name": "JESSICA JOHANI CARRASCO ALVAREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados I",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243274403",
      "client_email": "CARRASCOJESSICA.73@GMAIL.COM",
      "address": "CALLE 4 CASA NRO 14 SECTOR PRADOS DE PAYA I ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V17199408",
      "nap_box_name": "CTO-00061",
      "created_at": "2024-06-09T13:45:50.809851",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4603,
      "client_name": "ERIKA MARIA LOPEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128957343",
      "client_email": "ERIKAMARIALOPEZ847@GMAIL.COM",
      "address": "VDA MANZANA I I-2 CASA NRO 9 URB SAMAN TARAZONERO II EL MACARO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V11086318",
      "nap_box_name": "119",
      "created_at": "2024-06-09T13:50:08.929918",
      "service_detail": {
        "id": 5988,
        "ip": "172.28.223.2",
        "mac": "HWTC2ECC6BA1",
        "serial": "HWTC2ECC6BA1",
        "queue": "Plan_157310_1574_WispHub",
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2024-08-21T17:02:22.812148",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4604,
      "client_name": "SAMUEL EDUARDO OLIVERO TOVAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243252495",
      "client_email": "SAMUELJOP@GMAIL.COM",
      "address": "CALLE PROLONOGACION CARREÑO EDIF TORRE 24 PISO 3  APT 4 DESARROLLO HABITACIONAL LOS NISPEROS TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V13594006",
      "nap_box_name": "CTO-00207 DOS",
      "created_at": "2024-06-09T13:51:49.873050",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4605,
      "client_name": "ROSA MARIA REYES RINCON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243524313",
      "client_email": "ALVARO.WGR@GMAIL.COM",
      "address": "CALLE 17B CASA NRO 29 SECTOR PANTIN ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V24172698",
      "nap_box_name": "CTO-00048",
      "created_at": "2024-06-09T13:53:35.117891",
      "service_detail": {
        "id": 3210,
        "ip": "172.28.218.2",
        "mac": "HWTC14F6ADA1",
        "serial": "HWTC14F6ADA1",
        "queue": "Plan_161895_30183_WispHub",
        "interface": "VLAN229_PANTIN",
        "created_at": "2024-06-27T18:31:17.373322",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4606,
      "client_name": "CRISMARY ANYIRILUZ ZURITA TEJADA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243151427",
      "client_email": "ZURITACRISMARY@GMAIL.COM",
      "address": "CALLE 7 CASA NRO 546-D URB MATA CABALLO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V26491050",
      "nap_box_name": "CTO-00215",
      "created_at": "2024-06-09T13:55:14.593986",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4607,
      "client_name": "DAYLIMAR KATERINE HERRERA PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04128871278",
      "client_email": "DAYLIMARHERRERA@GMAIL.COM",
      "address": "CALLE 5 CASA NRO 286 SECTOR MATA CABALLO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V29786552",
      "nap_box_name": "CTO-00180",
      "created_at": "2024-06-09T13:59:18.660995",
      "service_detail": {
        "id": 2945,
        "ip": "172.28.215.2",
        "mac": "HWTC451E8FA1",
        "serial": "HWTC451E8FA1",
        "queue": "Plan_161895_30183_WispHub",
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2024-06-20T08:33:08.303257",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4608,
      "client_name": "KARLA JORGELYS FLORES RIVERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Tibisay Guevara",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04264742069",
      "client_email": "KF4196430@GMAIL.COM",
      "address": "CALLE 2 CASA NRO 53 TIBISAY GUEVARA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V29542286",
      "nap_box_name": "CTO-00053",
      "created_at": "2024-06-09T14:01:53.287626",
      "service_detail": {
        "id": 9549,
        "ip": "172.28.214.2",
        "mac": "HWTC208153A1",
        "serial": "HWTC208153A1",
        "queue": "queue1",
        "interface": "VLAN248_TIBISAY_OLT2",
        "created_at": "2025-09-23T16:27:52.809899",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4609,
      "client_name": "LUIS ALFREDO VIELMA OROPEZA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04128466891",
      "client_email": "LUISVIELMA236@GMAIL.COM",
      "address": "CALLE 14-B CASA NRO 37 ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V7225520",
      "nap_box_name": "CTO-00052",
      "created_at": "2024-06-09T14:04:19.018513",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4610,
      "client_name": "MILANGELA CAROLINA GOMEZ SILVA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243046192",
      "client_email": "MILANGELAGOMEZSILVA@GMAIL.COM",
      "address": "CALLE 10 CASA NRO 632-B URB MATA CABALLO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V326147970",
      "nap_box_name": "CTO-00569",
      "created_at": "2024-06-09T14:06:52.522009",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4611,
      "client_name": "WILMIRLA AISKEL GONZALEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243566819",
      "client_email": "WILMIRLAGONZALEZ10@GMAIL.COM",
      "address": "CALLE 11 CASA NRO 638-C URB MATA CABALLO ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V20590600",
      "nap_box_name": "CTO-0337",
      "created_at": "2024-06-09T14:08:49.300256",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4612,
      "client_name": "ANGELO ALFREDO ESPIDEA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243770646",
      "client_email": "ANGELOESPIDEA21@GMAIL.COM",
      "address": "CALLE 2 CASA NRO 69 SECTOR MATA CABALLO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V18976016",
      "nap_box_name": "CTO-00565 DOS",
      "created_at": "2024-06-09T14:10:32.257117",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4613,
      "client_name": "MARIA DEL CARMEN PEREZ PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Paya Abajo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04140494049",
      "client_email": "MARISOLUZCATEGUI05@GMAIL.COM",
      "address": "CALLE SAN ANTONIO CASA 42 SECTOR PAYA ABAJO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V8085269",
      "nap_box_name": "271",
      "created_at": "2024-06-09T14:14:14.193925",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4614,
      "client_name": "FRANCISCO FERNANDO GONZALEZ VASQUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Los Nisperos",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04122482550",
      "client_email": "GUREPOSTA@GMAIL.COM",
      "address": "ESQ LOS NARANJOS CON CALLE GRADISCO QTA AYEZA NRO 08 URB LOS NISPEROS TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V14390101",
      "nap_box_name": "CTO-0639",
      "created_at": "2024-06-09T14:16:08.757008",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4615,
      "client_name": "ALVARO ANDRES MARCANO MARCANO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121395922",
      "client_email": "YOLANDATHIBI61@GMAIL.COM",
      "address": "CALLE MANZANA N1 SAMAN TARAZONERO II TURMERO ARAGUA",
      "client_identification": "V30211900",
      "nap_box_name": "278",
      "created_at": "2024-06-09T14:16:19.340682",
      "service_detail": {
        "id": 4171,
        "ip": "172.27.20.2",
        "mac": "OEMT3C624C82",
        "serial": "OEMT3C624C82",
        "queue": "Plan_137413_1574_WispHub",
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2024-08-02T15:57:47.220423",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4616,
      "client_name": "NOREGLYS EGLEE CHIRINOS MUÑOZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144675855",
      "client_email": "NOREGLYSCHIRINOS@GMAIL.COM",
      "address": "CALLE 4B CASA NRO 38 PANTIN ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V13769699",
      "nap_box_name": "CTO-00134",
      "created_at": "2024-06-09T14:17:51.135735",
      "service_detail": {
        "id": 5671,
        "ip": "172.28.206.2",
        "mac": "HWTC25FC91A1",
        "serial": "HWTC25FC91A1",
        "queue": "Plan_161906_30183_WispHub",
        "interface": "VLAN229_PANTIN",
        "created_at": "2024-08-17T13:56:47.025239",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4617,
      "client_name": "ROSA GARDENIA FARIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243088751",
      "client_email": "ROSAGARDENIAFARIA@GMAIL.COM",
      "address": "CALLE MANZANA E5 NRO 6 SECTOR SAMAN TARAZONERO II, TURMERO EDO ARAGUA",
      "client_identification": "V8797604",
      "nap_box_name": "273",
      "created_at": "2024-06-09T14:18:33.054178",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4618,
      "client_name": "DAYSI JOSEFINA MENDOZA MENDOZA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04145997597",
      "client_email": "DAYSIJMM1967@GMAIL.COM",
      "address": "CALLE 17 CASA NRO 01 SECTOR RIO SECO TURMERO EDO ARAGUA ROSARIO DE PAYA",
      "client_identification": "V9652247",
      "nap_box_name": "CTO-0606",
      "created_at": "2024-06-09T14:20:27.955112",
      "service_detail": {
        "id": 5672,
        "ip": "172.28.203.2",
        "mac": "HWTC122416A1",
        "serial": "HWTC122416A1",
        "queue": "Plan_161895_30183_WispHub",
        "interface": "VLAN251_RIO_SECO",
        "created_at": "2024-08-17T13:58:44.662946",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4619,
      "client_name": "ISAURA DEL VALLE LA CRUZ DE RIVERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243652445",
      "client_email": "ISAURAUBV@GMAIL.COM",
      "address": "CALLE MANZANA D-04 CASA NRO 14 URB SAMAN  TARAZONERO II",
      "client_identification": "V15736770",
      "nap_box_name": "268",
      "created_at": "2024-06-09T14:20:31.365186",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4620,
      "client_name": "ELIAS DAVID TORREALBA PULIDO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243094735",
      "client_email": "JYYEDTP@HOTMAIL.COM",
      "address": "TURMERO SECTOR MATA CABALLO CALLE 12 CASA 693-D ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V14628301",
      "nap_box_name": "CTO-00433",
      "created_at": "2024-06-09T14:22:39.780088",
      "service_detail": {
        "id": 5668,
        "ip": "172.28.201.2",
        "mac": "HWTC237593A1",
        "serial": "HWTC237593A1",
        "queue": "Plan_161868_30181_WispHub",
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2024-08-17T13:50:00.465224",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4621,
      "client_name": "DENINSON ANDRES ASCANIO VALERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04125059656",
      "client_email": "DENINSONAAV@GMAIL.COM",
      "address": "MANZANA D11 CASA NRO 2BARRIO SAMAN TARAZONERO II TURMERO ARAGUA",
      "client_identification": "V27520389",
      "nap_box_name": "265",
      "created_at": "2024-06-09T14:23:25.641924",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4623,
      "client_name": "JACQUELINE CENOVIA AREVALO RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144444387",
      "client_email": "JACQUELINEAREVALO218@GMAIL.COM",
      "address": "CALLE MANZANA E-7 CASA NRO 13 URB SAMAN TARAZONERO II TURMERO",
      "client_identification": "V14959329",
      "nap_box_name": "95",
      "created_at": "2024-06-09T14:25:48.916836",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4624,
      "client_name": "FRANCO JOSE LOPEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243738646",
      "client_email": "FRANCOLOPEZ4@GMAIL.COM",
      "address": "CALLE CEDEÑO CON CALLE MIRANDA LOCAL NRO 37-1 ZONA CENTRO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V4798700",
      "nap_box_name": "279",
      "created_at": "2024-06-09T14:26:31.231323",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4625,
      "client_name": "YALISKA CECILIA MAYORA SANCHEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Simon Bolivar",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04120415056",
      "client_email": "YALISKA14@GMAIL.COM",
      "address": "CALLE 9 CASA YARI NRO 2 BARROP  SIMON BOLIVAR TURMERO",
      "client_identification": "V13826763",
      "nap_box_name": "CTO-00040",
      "created_at": "2024-06-09T14:27:54.648567",
      "service_detail": {
        "id": 5667,
        "ip": "172.23.45.2",
        "mac": "TPLGBA6874DF",
        "serial": "TPLGBA6874DF",
        "queue": "Plan_137413_1574_WispHub",
        "interface": "VLAN128_SIMON_BOLIVAR_ZTE",
        "created_at": "2024-08-17T13:45:41.601926",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4626,
      "client_name": "MIGUEL ANGEL CASTRO CHIREL",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Arturo Luis Berti",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128902258",
      "client_email": "S4DOPPELGANGER@GMAIL.COM",
      "address": "CALLE 4 CASA NRO 420 URB ARTURO LUIS BERTI TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V23784896",
      "nap_box_name": "65",
      "created_at": "2024-06-09T14:29:03.772152",
      "service_detail": {
        "id": 4103,
        "ip": "172.28.199.2",
        "mac": "HWTC32A2A4A1",
        "serial": "HWTC32A2A4A1",
        "queue": "Plan_157310_1574_WispHub",
        "interface": "VLAN102_ARTURO_BERTI",
        "created_at": "2024-07-25T11:56:18.759066",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4627,
      "client_name": "ALISON GABRIEL CASTILLO ORTIZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Simon Bolivar",
      "plan": {
        "id": 16,
        "name": "RECURRENTE RESIDENCIAL PLAN 800M",
        "cost": "55.00",
        "code": "FOR800",
        "profile": "800M/800M"
      },
      "client_mobile": "04124153785",
      "client_email": "ALLISONCATIRE5@GMAIL.COM",
      "address": "AV 01 NRO 38 URB SIMON BOLIVAR SAMAN DE GUERE TURMERO",
      "client_identification": "V19949054",
      "nap_box_name": "CTO-00041",
      "created_at": "2024-06-09T14:30:13.370885",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4628,
      "client_name": "YULYANNYS ALEXANDRA MARCANO PAREJO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144785054",
      "client_email": "YULYANNYSMARCANO@GMAIL.COM",
      "address": "CALLE CARREÑO EDIF TIORA PISO 1 APT 5 URB EL NISPERO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V20536030",
      "nap_box_name": "CTO-00296",
      "created_at": "2024-06-09T14:31:05.007083",
      "service_detail": {
        "id": 5665,
        "ip": "172.28.202.2",
        "mac": "HWTC06872AA1",
        "serial": "HWTC06872AA1",
        "queue": "Plan_153953_15811_WispHub",
        "interface": "VLAN209_ZAMORA_OLT1",
        "created_at": "2024-08-17T13:41:49.684263",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4629,
      "client_name": "WILBER WILFREDO COLMENARES RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Valle Verde",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243566536",
      "client_email": "WACD77@GMAIL.COM",
      "address": "AV PRINCIPAL PAYA CRUCE CON PASAJE BOLIVAR PARCELA NRO 18 VALLE VERDE TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V28432482",
      "nap_box_name": "CTO-0490",
      "created_at": "2024-06-09T14:33:34.208958",
      "service_detail": {
        "id": 5664,
        "ip": "172.28.194.2",
        "mac": "HWTC477175A1",
        "serial": "HWTC477175A1",
        "queue": "Plan_161906_30183_WispHub",
        "interface": "VLAN253_VALLE_VERDE",
        "created_at": "2024-08-17T13:40:00.486601",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4630,
      "client_name": "NOHENDYS DEL CARMEN PIMENTEL BLANCO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Esperanza",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04127761679",
      "client_email": "NOHENDYSPIM@GMAIL.COM",
      "address": "CALLE 11 CASA NRO 1 URB  LA ESPERANZA  EL MACARO TURMERO",
      "client_identification": "V25066034",
      "nap_box_name": "RESERVA 3 TRONCAL LA ESPERANZA",
      "created_at": "2024-06-09T14:34:12.971795",
      "service_detail": {
        "id": 9918,
        "ip": "172.23.54.2",
        "mac": "TPLGBA687B17",
        "serial": "TPLGBA687B17",
        "queue": null,
        "interface": "VLAN137_LA_ESPERANZA_OLT_ZTE",
        "created_at": "2025-11-10T23:55:32.017603",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4632,
      "client_name": "YUDAIRYS ALEJANDRA VIVAS AMARIS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Simon Bolivar",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128908085",
      "client_email": "vivasalejandra91@gmail.com",
      "address": "CALLE 7 CASA NRO 57 URB SIMON BOLIVAR TURMERO",
      "client_identification": "V25066232",
      "nap_box_name": "CTO-00025",
      "created_at": "2024-06-09T14:39:05.288353",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4633,
      "client_name": "ELIANA ISABEL FLORES GOMEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados II",
      "plan": {
        "id": 43,
        "name": "RECURRENTE RESIDENCIAL PLAN 650M",
        "cost": "46.00",
        "code": "FOR650M",
        "profile": "650M/650M"
      },
      "client_mobile": "04141572760",
      "client_email": "NOVOFLEXNOVOCEL@GMAIL.COM",
      "address": "PRADOS DE PAYA II CALLE 04 CASA NRO 06 ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V16416966",
      "nap_box_name": "CTO-00100",
      "created_at": "2024-06-09T14:39:11.981389",
      "service_detail": {
        "id": 2944,
        "ip": "172.28.198.2",
        "mac": "TPLGF9CD3DCC",
        "serial": "TPLGF9CD3DCC",
        "queue": "Plan_161900_30183_WispHub",
        "interface": "VLAN242_PRADOS2",
        "created_at": "2024-06-20T08:30:52.716789",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4634,
      "client_name": "ANNA KARINA CASTILLO CAMPOS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados III",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04125994828",
      "client_email": "ANNAKARINACASTILLO10@GMAIL.COM",
      "address": "CALLE 2 CASA NRO 31 SECTOR PRADOS III ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V29715474",
      "nap_box_name": "CTO-00284 DOS",
      "created_at": "2024-06-09T14:42:23.997073",
      "service_detail": {
        "id": 5661,
        "ip": "172.28.192.2",
        "mac": "HWTC45B9B5A1",
        "serial": "HWTC45B9B5A1",
        "queue": "Plan_161906_30183_WispHub",
        "interface": "VLAN236_PRADOS3",
        "created_at": "2024-08-17T13:33:54.170417",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4635,
      "client_name": "JORGE ORLANDO SILVA TREJO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128908900",
      "client_email": "JORKATY2@GMAIL.COM",
      "address": "CALLE 27 CASA 11 RIO SECO ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V15255365",
      "nap_box_name": "CTO-00039",
      "created_at": "2024-06-09T14:44:06.778932",
      "service_detail": {
        "id": 5660,
        "ip": "172.28.186.2",
        "mac": "HWTC076868A1",
        "serial": "HWTC076868A1",
        "queue": "Plan_161895_30183_WispHub",
        "interface": "VLAN251_RIO_SECO",
        "created_at": "2024-08-17T13:31:57.589171",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4636,
      "client_name": "ANDRES ALEXANDER RIVAS VALENCIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04122869884",
      "client_email": "ALEXANDERVALENCIARIVAS@GMAIL.COM",
      "address": "CALLE 12 CASA NRO 111 URB LA  CASONA 2 TURMERO",
      "client_identification": "V27520748",
      "nap_box_name": "CTO-00092",
      "created_at": "2024-06-09T14:44:46.910882",
      "service_detail": {
        "id": 5334,
        "ip": "172.23.24.2",
        "mac": "TPLGBA687682",
        "serial": "TPLGBA687682",
        "queue": "Plan_131337_24341_WispHub",
        "interface": "VLAN110_CASONA_2",
        "created_at": "2024-08-16T09:30:07.981861",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4637,
      "client_name": "YNES MARITZA ROMERO CEDEÑO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243014815",
      "client_email": "YNESROMERO44@GMAIL.COM",
      "address": "CALLE 16B CASA 37  URB  PANTIN  ROSARIO DE PAYA",
      "client_identification": "V9643594",
      "nap_box_name": "CTO-00026",
      "created_at": "2024-06-09T14:47:16.342551",
      "service_detail": {
        "id": 5658,
        "ip": "172.22.162.2",
        "mac": "TPLGBA687B9A",
        "serial": "TPLGBA687B9A",
        "queue": "Plan_161906_30183_WispHub",
        "interface": "VLAN229_PANTIN",
        "created_at": "2024-08-17T13:30:07.011452",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4638,
      "client_name": "HERMOGENES JESUS CAMPOS TORREALBA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04124429187",
      "client_email": "JESUS10HERMOGENES@GMAIL.COM",
      "address": "CALLE 8 CASA NRO 566-B MATA CABALLO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V24686391",
      "nap_box_name": "CTO-00130",
      "created_at": "2024-06-09T14:50:37.888104",
      "service_detail": {
        "id": 10314,
        "ip": "172.28.191.2",
        "mac": "HWTC386B2CA1",
        "serial": "HWTC386B2CA1",
        "queue": null,
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2025-11-24T17:53:47.065128",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4639,
      "client_name": "NOLMAIRA ALEJANDRA ARAGUREN MARTINEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Bicentenario",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243564742",
      "client_email": "ARANJOSEMEDINA2103@GMAIL.COM",
      "address": "CALLE LOS ROBLES MANZANA 11 CASA NRO 9/8 - PA  SECTOR FUNDA BARRIOS ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V13722018",
      "nap_box_name": "381",
      "created_at": "2024-06-09T14:52:10.146492",
      "service_detail": {
        "id": 5656,
        "ip": "172.28.193.2",
        "mac": "HWTC2227CBA1",
        "serial": "HWTC2227CBA1",
        "queue": "Plan_161906_30183_WispHub",
        "interface": "VLAN243_BICENTENARIO",
        "created_at": "2024-08-17T13:23:31.535137",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4640,
      "client_name": "FRANKLIN RAUL HEREDIA DIAZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Callejon Lim",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243208444",
      "client_email": "FRAMKLINH1968@GMAIL.COM",
      "address": "CALLE CALLEJON LIM 6 EDIF NRO VIOLETA PISO 3 APT 15 URB VILLAS DE TURMERO EDO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V7991223",
      "nap_box_name": "CTO-0562",
      "created_at": "2024-06-09T14:53:35.303790",
      "service_detail": {
        "id": 9273,
        "ip": "172.28.190.2",
        "mac": "HWTC27EAFBA1",
        "serial": "HWTC27EAFBA1",
        "queue": "queue1",
        "interface": "VLAN250_LIM_OLT2",
        "created_at": "2025-07-29T16:08:07.160706",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4641,
      "client_name": "MERY YESZURYNS RODRIGUEZ LIENDO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Brisas de Paya",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128909458",
      "client_email": "MERYRODRIGUEZ12010@GMAIL.COM",
      "address": "CALLE 02 CASA NRO 25 SECTOR BRISAS DE PAYA ROSARIO DE PAYA ZONA POSTAL 2115",
      "client_identification": "V13564897",
      "nap_box_name": "369",
      "created_at": "2024-06-09T14:55:26.129823",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4642,
      "client_name": "KARETZY ALEXANDRA MARQUINA BASTIDAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243665398",
      "client_email": "KARETZYMARQUINA2@GMAIL.COM",
      "address": "CALLE 23 CASA NRO 47 SECTOR RIO SECO ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V31381439",
      "nap_box_name": "CTO-00033",
      "created_at": "2024-06-09T14:57:04.351396",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4643,
      "client_name": "CARLOS HUMBERTO PIMENTEL RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero I",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04128907020",
      "client_email": "CARLOSPIMENTEL488@GMAIL.COM",
      "address": "SAMAN TARAZONERO I  CALLE 6 NRO  VIA EL MACARO",
      "client_identification": "V9437811",
      "nap_box_name": "270",
      "created_at": "2024-06-09T14:58:42.854184",
      "service_detail": {
        "id": 9866,
        "ip": "172.23.21.2",
        "mac": "TPLGBA687A93",
        "serial": "TPLGBA687A93",
        "queue": null,
        "interface": "VLAN140_SMT1_ZTE",
        "created_at": "2025-11-10T18:48:36.527248",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4644,
      "client_name": "MARIA BACILIA PEREZ MENDOZA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados III",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128651196",
      "client_email": "YM456.CANAIMA@GMAIL.COM",
      "address": "CALLE 3 CASA NRO 26 SECTOR PRADO DE PAYA III TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V24930882",
      "nap_box_name": "579",
      "created_at": "2024-06-09T14:59:06.905220",
      "service_detail": {
        "id": 2981,
        "ip": "172.28.183.2",
        "mac": "HWTC22703CA1",
        "serial": "HWTC22703CA1",
        "queue": "Plan_161903_30183_WispHub",
        "interface": "VLAN236_PRADOS3",
        "created_at": "2024-06-21T09:44:48.102210",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4645,
      "client_name": "LUIS ALBERTO GARRIDO SUESCUN",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04125986927",
      "client_email": "GARRIDOSUESCUNL@GMAIL.COM",
      "address": "CALLE 6A CASA NRO 26 URB PANTIN ROSARIO DE PAYA",
      "client_identification": "V3914908",
      "nap_box_name": "CTO-0013B",
      "created_at": "2024-06-09T15:02:53.806442",
      "service_detail": {
        "id": 3410,
        "ip": "172.22.177.2",
        "mac": "TPLGBA687A36",
        "serial": "TPLGBA687A36",
        "queue": "Plan_161906_30183_WispHub",
        "interface": "VLAN229_PANTIN",
        "created_at": "2024-07-03T13:46:36.168235",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4646,
      "client_name": "MARIA ISABEL AGRELA HURTADO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121492108",
      "client_email": "AGRELAMARIAISABEL@GMAIL.COM",
      "address": "CALLE NRO 6 CASA NRO 419 URB MATA CABALLO ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V27646543",
      "nap_box_name": "CTO-00031",
      "created_at": "2024-06-09T15:04:10.584668",
      "service_detail": {
        "id": 5652,
        "ip": "172.28.180.2",
        "mac": "ZICGCA2B2231",
        "serial": "ZICGCA2B2231",
        "queue": "Plan_161906_30183_WispHub",
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2024-08-17T13:07:30.672520",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4647,
      "client_name": "ODALYS MERCEDES CORDERO MONSALVE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121588638",
      "client_email": "CORDEROODALYS32@GMAIL.COM",
      "address": "CALLE 12-B CASA NRO 37 URB PANTIN ROSARIO DE PAYA",
      "client_identification": "V19912991",
      "nap_box_name": "CTO-00166",
      "created_at": "2024-06-09T15:05:45.255459",
      "service_detail": {
        "id": 5651,
        "ip": "172.22.253.2",
        "mac": "TPLGBA688327",
        "serial": "TPLGBA688327",
        "queue": "Plan_161906_30183_WispHub",
        "interface": "VLAN229_PANTIN",
        "created_at": "2024-08-17T13:05:34.527207",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4648,
      "client_name": "DULCE LEONOR MARTINEZ CAMACHO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Las Rurales",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04120479461",
      "client_email": "DULCELEONORMARTINEZCAMACHO536@GMAIL.COM",
      "address": "CALLE 107 CASA NRO 70 LAS RURALES SECTOR ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V16686165",
      "nap_box_name": "CE - 667",
      "created_at": "2024-06-09T15:06:02.941865",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4649,
      "client_name": "CRUZ MARINA MORILLO HERRERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243304995",
      "client_email": "CRUZMOL1408@GMAIL.COM",
      "address": "CALLE 13 CASA NRO 14-A SECTOR PRADOS L ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V10356842",
      "nap_box_name": "CTO-0589",
      "created_at": "2024-06-09T15:08:16.589067",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4650,
      "client_name": "YARELIS YALISBE SANTANA MUÑOZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04127477487",
      "client_email": "YARELIS.SANTANA27@GMAIL.COM",
      "address": "CALLE 10B CASA NRO 43 URB PANTIN ROSARIO DE PAYA",
      "client_identification": "V14882013",
      "nap_box_name": "CTO-00141",
      "created_at": "2024-06-09T15:08:18.914588",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4651,
      "client_name": "YELADYS MAHLY JIMENEZ BERMUDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Taguapire",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04143952223",
      "client_email": "YELADYS123@GMAIL.COM",
      "address": "CALLE 3 EDIF MODULO 8 PISO PLANTA BAJA APT 83 URB TAGUAPIRE",
      "client_identification": "V26535383",
      "nap_box_name": "CTO-00386",
      "created_at": "2024-06-09T15:11:09.565963",
      "service_detail": {
        "id": 12639,
        "ip": "172.22.242.2",
        "mac": "TP:LG:BA:68:7C:50",
        "serial": "TPLGBA687C50",
        "queue": null,
        "interface": "VLAN129_TAGUAPIRE_ZTE",
        "created_at": "2026-06-27T10:23:09.502298",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4652,
      "client_name": "VICTOR JESUS ALFONZO LUCENA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados III",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144651490",
      "client_email": "ALFONZOVICTOR74@GMAIL.COM",
      "address": "CALLE PRINCIPAL CASA NRO 42 URB PRADOS III ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V30556031",
      "nap_box_name": "579 DOS",
      "created_at": "2024-06-09T15:13:01.428860",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4653,
      "client_name": "LEANRY DEL VALLE RUBIO DE BRICEÑO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Floresta",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121483714",
      "client_email": "LEANRYR@GMAIL.COM",
      "address": "URB LA FLORESTA CASCO DE TURMERO  CALLE 1 MANZANA B PARCELA N 12 TURMERO",
      "client_identification": "V13610842",
      "nap_box_name": "34 DOS",
      "created_at": "2024-06-09T15:13:17.274143",
      "service_detail": {
        "id": 5649,
        "ip": "172.22.229.2",
        "mac": "TPLGBA687B37",
        "serial": "TPLGBA687B37",
        "queue": "Plan_147201_15811_WispHub",
        "interface": "VLAN212_FLORESTA_OLT1",
        "created_at": "2024-08-17T13:01:22.981554",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4654,
      "client_name": "LANDY RAFAEL VILLAZANA RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados I",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128855426",
      "client_email": "LANDYVI@GMAIL.COM",
      "address": "CALLE 13 CASA NRO 10 SECTOR PRADOS I ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V15738746",
      "nap_box_name": "CTO-0589",
      "created_at": "2024-06-09T15:15:12.888308",
      "service_detail": {
        "id": 3777,
        "ip": "172.28.168.2",
        "mac": "HWTC365F89A1",
        "serial": "HWTC365F89A1",
        "queue": "Plan_161905_30183_WispHub",
        "interface": "VLAN239_PRADOS1",
        "created_at": "2024-07-13T12:08:13.387321",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4655,
      "client_name": "MARYURI ALICIA BARROS SARMIENTO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero I",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128981852",
      "client_email": "MARYURISBARROS18@GMAIL.COM",
      "address": "CALLE 03 CASA NRO 28 SECTOR SAMAN TARAZONERO I EL MACARO TURMERO",
      "client_identification": "V18975390",
      "nap_box_name": "32",
      "created_at": "2024-06-09T15:15:53.321433",
      "service_detail": {
        "id": 8566,
        "ip": "172.22.227.2",
        "mac": "TPLGBA687BA6",
        "serial": "TPLGBA687BA6",
        "queue": "queue1",
        "interface": "VLAN100_OLTs",
        "created_at": "2025-05-11T12:04:20.854702",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4656,
      "client_name": "BRAYAN ALMEDARIS DIAZ ALVAREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Paya Abajo",
      "plan": {
        "id": 2,
        "name": "RECURRENTE RESIDENCIAL PLAN 30M",
        "cost": "20.00",
        "code": "FOR30",
        "profile": "30M/30M"
      },
      "client_mobile": "04121486776",
      "client_email": "BRAYANDWONHILL@GMAIL.COM",
      "address": "CALLE CAMPO ELIAS CASA NRO 15 SECTOR PAYA ABAJO ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V25067341",
      "nap_box_name": "CTO-0252",
      "created_at": "2024-06-09T15:17:11.848824",
      "service_detail": {
        "id": 7507,
        "ip": "172.28.167.2",
        "mac": "OEMT3C62283E",
        "serial": "OEMT3C62283E",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN231_PAYABAJO",
        "created_at": "2024-12-17T12:13:42.649729",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4657,
      "client_name": "ISIDRA BAUTISTA CARRENO DE COSME",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Arturo Luis Berti",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243645618",
      "client_email": "ISIDRABAUTISTA362@GMAIL.COM",
      "address": "CALLE 1 CASA NRO 362 URB ARTURO LUIS BERTI TURMERO",
      "client_identification": "V5232377",
      "nap_box_name": "29",
      "created_at": "2024-06-09T15:18:19.971324",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4658,
      "client_name": "KATTY ELIZABETH MILLAN SANCHEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124576102",
      "client_email": "KATTY17701658@GMAIL.COM",
      "address": "CALLE 7 EDIF CENTRA PISO 1 APT 530-D MATA CABALLO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V17701658",
      "nap_box_name": "CTO-00310",
      "created_at": "2024-06-09T15:19:23.234943",
      "service_detail": {
        "id": 3188,
        "ip": "172.28.162.2",
        "mac": "TPLGB68B5BC7",
        "serial": "TPLGB68B5BC7",
        "queue": "Plan_161905_30183_WispHub",
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2024-06-27T17:24:40.169841",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4659,
      "client_name": "BIANCA LORENA PINTO TURTULICI",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "San Pablo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121480749",
      "client_email": "BIANCALPINTOT@GMAIL.COM",
      "address": "AV PRINCIPAL SAN PABLO CASA NRO 15 URB SAN PABLO TURMERO EDO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V26535326",
      "nap_box_name": "CTO-0637",
      "created_at": "2024-06-09T15:21:23.657153",
      "service_detail": {
        "id": 5647,
        "ip": "172.28.164.2",
        "mac": "HWTC213BA9A1",
        "serial": "HWTC213BA9A1",
        "queue": "Plan_153953_15811_WispHub",
        "interface": "VLAN224_SAN_PABLO_OLT1",
        "created_at": "2024-08-17T12:57:26.248694",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4660,
      "client_name": "MARCO ANDRES GIL PUENTES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Taguapire",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04247057737",
      "client_email": "MANDRESGP102@GMAIL.COM",
      "address": "ETAPA I TAGUAPIRE CALLE NRO 01 APARTAMENTO 08 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V20200102",
      "nap_box_name": "548",
      "created_at": "2024-06-09T15:23:32.492955",
      "service_detail": {
        "id": 10576,
        "ip": "172.28.163.2",
        "mac": "HWTC18D519A1",
        "serial": "HWTC18D519A1",
        "queue": null,
        "interface": "VLAN129_TAGUAPIRE_ZTE",
        "created_at": "2025-12-04T09:08:45.869880",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4661,
      "client_name": "LISMAR MILEIDI NAVARRO GUZMAN",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124197540",
      "client_email": "EUDYMARALTUVE@GMAIL.COM",
      "address": "CALLE 16-A CASA NRO 15 URB PANTIN ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V12611508",
      "nap_box_name": "CTO-00195",
      "created_at": "2024-06-09T15:25:34.803445",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4662,
      "client_name": "MARIA DE JESUS MIJARES SEIJAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Paya Abajo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124656651",
      "client_email": "MARISOPHI13@GMAIL.COM",
      "address": "CALLE SAN MIGUEL CASA NRO 31 SECTOR ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V19947581",
      "nap_box_name": "CTO-00024",
      "created_at": "2024-06-09T15:28:00.889050",
      "service_detail": {
        "id": 7508,
        "ip": "172.28.158.2",
        "mac": "HWTC386A01A1",
        "serial": "HWTC386A01A1",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN231_PAYABAJO",
        "created_at": "2024-12-17T12:21:46.968012",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4663,
      "client_name": "ADRIAN ALEXANDER ARREAZA BARRETO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Durpa",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04262376737",
      "client_email": "ALEXANDERARREAZA.AA@GMAIL.COM",
      "address": "CALLE 14 CASA NRO 06 URB DESARROLLO URBANISTICO ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V17078605",
      "nap_box_name": "379",
      "created_at": "2024-06-09T15:31:13.387570",
      "service_detail": {
        "id": 5642,
        "ip": "172.28.157.2",
        "mac": "HWTC229A54A1",
        "serial": "HWTC229A54A1",
        "queue": "Plan_161906_30183_WispHub",
        "interface": "VLAN240_DURPA",
        "created_at": "2024-08-17T12:08:53.789254",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4664,
      "client_name": "MILAGROS DEL VALLE VALOR VALOR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243491282",
      "client_email": "MISMOROCHOS67@GMAIL.COM",
      "address": "CALLE 11 CASA NRO 649-A URB MATA CABALLO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V15472250",
      "nap_box_name": "CTO-00022",
      "created_at": "2024-06-09T15:33:42.326038",
      "service_detail": {
        "id": 3217,
        "ip": "172.28.159.2",
        "mac": "HWTC18EB2FA1",
        "serial": "HWTC18EB2FA1",
        "queue": "Plan_161906_30183_WispHub",
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2024-06-28T09:17:07.493917",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4665,
      "client_name": "EMILUZ ANDREINA LARA PUERTA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Salto Angel",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144503496",
      "client_email": "EMILUZLARA@GMAIL.COM",
      "address": "CALLE EL SAMAN MANZANA 10 CASA NRO 39 URB SALTO ANGEL TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V18488514",
      "nap_box_name": "324",
      "created_at": "2024-06-09T15:35:32.353452",
      "service_detail": {
        "id": 3317,
        "ip": "172.28.155.2",
        "mac": "HWTC018693A1",
        "serial": "HWTC018693A1",
        "queue": "Plan_137942_24341_WispHub",
        "interface": "VLAN121_S_ANGEL",
        "created_at": "2024-07-02T08:12:19.376041",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4666,
      "client_name": "JOHANA CAROLINA ARNONE BORSEGUI",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ciudad Bendita",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243208556",
      "client_email": "JOHANAARNONE045@GMAIL.COM",
      "address": "AV. PRINCIPAL CASA NRO. 34 SECTOR EL MACARO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V18975170",
      "nap_box_name": "CTO-00174",
      "created_at": "2024-06-09T15:39:13.654897",
      "service_detail": {
        "id": 5639,
        "ip": "172.28.154.2",
        "mac": "HWTC2D0B59A1",
        "serial": "HWTC2D0B59A1",
        "queue": "Plan_139897_15811_WispHub",
        "interface": "VLAN249_CBENDITA_OLT2",
        "created_at": "2024-08-17T11:37:38.605658",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4667,
      "client_name": "EVELIN DEL VALLE ESCALONA DE YANEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ppal Paya",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04243012540",
      "client_email": "EVELINESCALONA@GMAIL.COM",
      "address": "CALLE PAYA  CASA COLONIAL  NRO 19SECTOR  ROSARIO DE PAYA CALLE 10 ANTIGUA",
      "client_identification": "V4589848",
      "nap_box_name": "117",
      "created_at": "2024-06-09T15:40:44.004405",
      "service_detail": {
        "id": 11675,
        "ip": "172.22.121.2",
        "mac": "TPLGBA68798A",
        "serial": "TPLGBA68798A",
        "queue": null,
        "interface": "VLAN201_AHP2_OLT1",
        "created_at": "2026-02-19T12:09:41.831269",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4668,
      "client_name": "ALEXANDRA YENNILEXTH SARRAMERA GUTIERREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243668301",
      "client_email": "ALEXASARRAMERAGUTIERREZ@GMAIL.COM",
      "address": "URB PANTIN CALLE 13-B CASA NRO 31 ROSARIO DE PAYA",
      "client_identification": "V30452571",
      "nap_box_name": "CTO-00171",
      "created_at": "2024-06-09T15:41:22.357081",
      "service_detail": {
        "id": 5636,
        "ip": "172.28.150.2",
        "mac": "HWTC36AB2DA1",
        "serial": "HWTC36AB2DA1",
        "queue": "queue1",
        "interface": "VLAN229_PANTIN",
        "created_at": "2024-08-17T11:32:15.497481",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4669,
      "client_name": "CEINNE PALMERA JALILE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero I",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04145438244",
      "client_email": "PALMERAACE23@GMAIL.COM",
      "address": "CALLE 3 CASA NRO 11 SECTOR SAMAN TARAZONERO I  EL MACARO TURMERO",
      "client_identification": "V23792907",
      "nap_box_name": "291",
      "created_at": "2024-06-09T15:43:13.478446",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4670,
      "client_name": "ISIDRO ANTONIO RICO CARRILLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243983365",
      "client_email": "ISIDRO242R@GMAIL.COM",
      "address": "SECTOR RIO SECO CALLE 29 PARCELA 4-1 ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V18380771",
      "nap_box_name": "598",
      "created_at": "2024-06-09T15:43:20.593638",
      "service_detail": {
        "id": 3203,
        "ip": "172.28.149.2",
        "mac": "HWTC103364A1",
        "serial": "HWTC103364A1",
        "queue": "Plan_161900_30183_WispHub",
        "interface": "VLAN251_RIO_SECO",
        "created_at": "2024-06-27T18:12:27.755218",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4671,
      "client_name": "LUIS JUAN BRITO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121484552",
      "client_email": "YAMILETHBRITO67@GMAIL.COM",
      "address": "CALLE 19 CASA NRO 41 SECTOR RIO SECO ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V4335981",
      "nap_box_name": "CTO-00018",
      "created_at": "2024-06-09T15:45:15.684654",
      "service_detail": {
        "id": 5634,
        "ip": "172.28.146.2",
        "mac": "HWTC48411DA1",
        "serial": "HWTC48411DA1",
        "queue": "queue1",
        "interface": "VLAN251_RIO_SECO",
        "created_at": "2024-08-17T11:22:34.696680",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4672,
      "client_name": "ENMANUEL LIZANDRY VELASQUEZ CALDERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Simon Bolivar",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04127987229",
      "client_email": "ENMANUELVELASQUEZ816@GMAIL.COM",
      "address": "CALLE 02 CASA NRO 31 URB SIMON  BOLIVAR EL MACARO TURMERO",
      "client_identification": "V19276801",
      "nap_box_name": "CTO-00043",
      "created_at": "2024-06-09T15:45:35.430467",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4673,
      "client_name": "ANGIE ESTEFANIA DURAN LEON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121140429",
      "client_email": "ANGIEDURAN.LEON@GMAIL.COM",
      "address": "AV 2 CASA NRO 513B URB DESARROLLO URBANISTICO MATA CABALLO ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V20098901",
      "nap_box_name": "CTO-00016",
      "created_at": "2024-06-09T15:47:13.622004",
      "service_detail": {
        "id": 13095,
        "ip": "172.28.144.2",
        "mac": "OE:MT:3C:62:09:0E",
        "serial": "OEMT3C62090E",
        "queue": null,
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2026-10-01T15:26:33.287216",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4674,
      "client_name": "MARIAN CELESTE LANDAETA BETHELMY",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128862391",
      "client_email": "MARIANLANDAETA260@GMAIL.COM",
      "address": "CALLE 12 CASA NRO 698-C URBANISMO MATA CABALLO TURMERO EDO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V15511824",
      "nap_box_name": "CTO-00020",
      "created_at": "2024-06-09T15:49:17.023639",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4675,
      "client_name": "JOAQUIN JOSE MEJIAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243562177",
      "client_email": "MEJIASJJ123@GMAIL.COM",
      "address": "CALLE 4 NRO 207 SECTOR MATA CABALLO ROSARIO DE PAYA",
      "client_identification": "V27313332",
      "nap_box_name": "CTO-00274",
      "created_at": "2024-06-09T15:49:23.082386",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4676,
      "client_name": "JANNYN CLARET PEREZ MELENDRES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243204577",
      "client_email": "LEYKERGOMEZPEREZ@GMAIL.COM",
      "address": "CALLE 06 CASA NRO 389 SECTOR MATA CABALLO ROSARIO DE PAYA TURMERO ARAGUA 2115",
      "client_identification": "V16268139",
      "nap_box_name": "CTO-00178",
      "created_at": "2024-06-09T15:51:16.515307",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4677,
      "client_name": "WILMER EDUARDO BRICENO TALES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124381161",
      "client_email": "WILMERDINHO10@GMAIL.COM",
      "address": "CALLE MANZANA D 9 CASA NRO 22 SECTOR SAMÁN TARAZONERO II TURMERO EDO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V22943145",
      "nap_box_name": "CTO-0262",
      "created_at": "2024-06-09T15:53:28.315166",
      "service_detail": {
        "id": 3717,
        "ip": "172.28.145.2",
        "mac": "HWTC2B33DEA1",
        "serial": "HWTC2B33DEA1",
        "queue": "Plan_157310_1574_WispHub",
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2024-07-11T22:10:47.450886",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4678,
      "client_name": "DARLING ORIANNA CHIRINOS SERRANO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Simon Bolivar",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04122051994",
      "client_email": "ORIANAJM58@GMAIL.COM",
      "address": "CALLE 04 CASA NRO 53 URB SIMÓN BOLÍVAR TURMERO EDO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V25066516",
      "nap_box_name": "CTO-00047",
      "created_at": "2024-06-09T15:55:15.140001",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4679,
      "client_name": "JESSICA CAROLINA GONZALEZ BRITO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121493822",
      "client_email": "CAROLINAGONZALEZ0304@GMAIL.COM",
      "address": "CALLE 13 B CASA NRO 41 SECTOR PANTIN ROSARIO DE PAYA TURMERO EDO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V22667975",
      "nap_box_name": "CTO-00171",
      "created_at": "2024-06-09T15:58:54.527086",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4680,
      "client_name": "YESENIA MARIA BOLIVAR REYES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Valle Verde",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243094052",
      "client_email": "YENKA902@GMAIL.COM",
      "address": "CALLE CALLEJÓN LOS MAMONES CASA NRO 06 SECTOR VALLE VERDE ROSARIO DE PAYA TURMERO EDO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V15819798",
      "nap_box_name": "CTO-00187",
      "created_at": "2024-06-09T16:00:47.973854",
      "service_detail": {
        "id": 5627,
        "ip": "172.28.140.2",
        "mac": "HWTC0DA75885",
        "serial": "HWTC0DA75885",
        "queue": "Plan_161906_30183_WispHub",
        "interface": "VLAN251_RIO_SECO",
        "created_at": "2024-08-17T11:09:21.954136",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4681,
      "client_name": "JUNIOR CESAR GUTIERREZ TORRES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Paya Abajo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04123986952",
      "client_email": "JUNIORTORRES25066758@GMAIL.COM",
      "address": "AV PRINCIPAL ROSARIO DE PAYA LOCAL NRO 01 SECTOR LA ARENERA PAYA ABAJO TURMERO EDO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V25066758",
      "nap_box_name": "CE - 773",
      "created_at": "2024-06-09T16:02:46.423095",
      "service_detail": {
        "id": 10699,
        "ip": "172.28.138.2",
        "mac": "HWTC43BFE4A1",
        "serial": "HWTC43BFE4A1",
        "queue": null,
        "interface": "VLAN231_PAYABAJO",
        "created_at": "2025-12-14T14:09:22.842164",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4682,
      "client_name": "AUDIMAR DE LA CARIDAD MONSALVE RIVAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124316537",
      "client_email": "AUDIMARMR@GMAIL.COM",
      "address": "CALLE MIRANDA EDIF MARINARO PISO 1 APT 03 SECTOR EL CENTRO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V20819141",
      "nap_box_name": "CTO-00038",
      "created_at": "2024-06-09T16:03:57.125502",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4683,
      "client_name": "ERDA MERCEDES PEREZ RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero I",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128845750",
      "client_email": "ELDA9438865@GMAIL.COM",
      "address": "CALLE 06 CASA NRO 40 SECTOR SAMAN TARAZONERO I TURMERO EDO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V9438865",
      "nap_box_name": "270",
      "created_at": "2024-06-09T16:06:17.808476",
      "service_detail": {
        "id": 3719,
        "ip": "172.28.118.2",
        "mac": "HWTCD61DE79C",
        "serial": "HWTCD61DE79C",
        "queue": "queue1",
        "interface": "VLAN112_LA_MACARENA_ZTE",
        "created_at": "2024-07-11T22:15:35.899071",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4684,
      "client_name": "DIANA ELVIRA ESCALONA DE DELGADO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados I",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04126772149",
      "client_email": "ECHENIQUESARA666@GMAIL.COM",
      "address": "CALLE 8 CASA NRO 01 SECTOR PRADOS DE PAYA ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V9640600",
      "nap_box_name": "CTO-0370",
      "created_at": "2024-06-09T16:08:13.706344",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4685,
      "client_name": "VIANNEY MARGARITA FLORES APONTE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128501035",
      "client_email": "VIANNEYFLORES78@GMAIL.COM",
      "address": "Calle 19 Casa Nro 37 Sector Rio Seco Rosario De Paya Turmero Aragua Zona Postal 2115",
      "client_identification": "V13553810",
      "nap_box_name": "CTO-00018",
      "created_at": "2024-06-09T16:09:17.014405",
      "service_detail": {
        "id": 11646,
        "ip": "172.28.130.2",
        "mac": "HWTC02B546A1",
        "serial": "HWTC02B546A1",
        "queue": null,
        "interface": "VLAN251_RIO_SECO",
        "created_at": "2026-02-17T15:48:36.249746",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4686,
      "client_name": "YALIMAR ELIZA BURGOS LOPEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243213480",
      "client_email": "YALIMAR.BURGOSL@GMAIL.COM",
      "address": "CALLE 11 CASA NRO 645-A URB MATA CABALLO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V26511461",
      "nap_box_name": "CTO-00213",
      "created_at": "2024-06-09T16:36:47.747640",
      "service_detail": {
        "id": 5615,
        "ip": "172.28.53.2",
        "mac": "ZICGCC80A893",
        "serial": "ZICGCC80A893",
        "queue": "Plan_161903_30183_WispHub",
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2024-08-17T10:49:58.500591",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4687,
      "client_name": "LINDA LISMARY REYES REYES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243228308",
      "client_email": "LINDALISMARYREYES@GMAIL.COM",
      "address": "CALLE CARREÑO TORRE 18 PISO 1 APT 2 URB HACIENDA EL NISPERO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V19131038",
      "nap_box_name": "CTO-00464 DOS",
      "created_at": "2024-06-09T17:02:25.397571",
      "service_detail": {
        "id": 2983,
        "ip": "172.28.47.2",
        "mac": "ZICGCEB6AD69",
        "serial": "ZICGCEB6AD69",
        "queue": "Plan_92306_15811_WispHub",
        "interface": "VLAN209_ZAMORA_OLT1",
        "created_at": "2024-06-21T09:50:10.093265",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4688,
      "client_name": "LUISA JEANNETTE OCHOA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04125313522",
      "client_email": "OCHOAJANET62@GMAIL.COM",
      "address": "CALLE BOLIVAR EDIF MEDINA APARTAMENTO 3 PISO 2 CENTRO DE TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V8738462",
      "nap_box_name": "CTO-00194",
      "created_at": "2024-06-09T17:13:44.097697",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4689,
      "client_name": "YUSLEIMA YSABEL FUENTES BARRIOS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128828190",
      "client_email": "YUSLEIMAFUENTESYB@GMAIL.COM",
      "address": "URB CASONA I CALLE 7-B CASA NRO 58 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V16551661",
      "nap_box_name": "411",
      "created_at": "2024-06-09T17:16:23.166123",
      "service_detail": {
        "id": 12930,
        "ip": "172.17.1.78",
        "mac": "ZX:IC:CD:5A:6E:9C",
        "serial": "ZXICCD5A6E9C",
        "queue": null,
        "interface": "VLAN109_CASONA_1",
        "created_at": "2026-08-30T09:15:08.619401",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4690,
      "client_name": "NEIKER JOSUE DE JESUS REDONDO VERDE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Bicentenario",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243624932",
      "client_email": "NAIKERJOSUEREDONDO@GMAIL.COM",
      "address": "CALLE MANZANA 11 CASA NRO 3 BARRIO FUNDA BARRIO ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V26679251",
      "nap_box_name": "385",
      "created_at": "2024-06-09T17:23:16.208038",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4691,
      "client_name": "AILEC ROCIO PERDOMO CONTRERAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124763341",
      "client_email": "KEYLLY1234@GMAIL.COM",
      "address": "CALLE 4 CASA NRO 11 SECTOR CANAIMA ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V18853000",
      "nap_box_name": "CTO-00061",
      "created_at": "2024-06-09T17:26:30.630576",
      "service_detail": {
        "id": 5592,
        "ip": "172.28.59.2",
        "mac": "ZICGCB85CB5E",
        "serial": "ZICGCB85CB5E",
        "queue": "Plan_161903_30183_WispHub",
        "interface": "VLAN239_PRADOS1",
        "created_at": "2024-08-17T09:39:34.331994",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4692,
      "client_name": "LUISA DARYEELNG AGUILAR LOZADA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Naranjal",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04221013601",
      "client_email": "dayeerling25091991mnsh@gmail.com",
      "address": "CALLE PRINCIPAL LA ESPERANZA CASA NRO 15 GRANJA EL NARANJAL TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V22870140",
      "nap_box_name": "CE - 681",
      "created_at": "2024-06-09T17:30:39.784223",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4693,
      "client_name": "GUSTAVO JESUS CHIRINOS RAMIREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04145983979",
      "client_email": "GUSTAVOJESUS08@GMAIL.COM",
      "address": "CALLE SALIAS CASA NRO 40 SECTOR PUEBLO NUEVO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V27712739",
      "nap_box_name": "77",
      "created_at": "2024-06-09T17:36:51.820000",
      "service_detail": {
        "id": 3160,
        "ip": "172.28.33.2",
        "mac": "ZICGCA63FF1A",
        "serial": "ZICGCA63FF1A",
        "queue": "queue1",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-06-27T14:10:38.665710",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4694,
      "client_name": "SIMON JOSE DIAZ APONTE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Las Rurales",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04123988258",
      "client_email": "DIAZAPONTEJOSE16@GMAIL.COM",
      "address": "CALLE 105 CASA NRO 90 SECTOR ROSARIO DE PAYA LAS RURALES TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V18855092",
      "nap_box_name": "CTO-00200",
      "created_at": "2024-06-09T17:46:46.887028",
      "service_detail": {
        "id": 3859,
        "ip": "172.28.44.2",
        "mac": "HWTC9A2A1558",
        "serial": "HWTC9A2A1558",
        "queue": "Plan_161905_30183_WispHub",
        "interface": "VLAN252_RURALES_PAYA",
        "created_at": "2024-07-16T14:23:33.964374",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4695,
      "client_name": "MARIO JOSE BRACHO MENDOZA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona II Edificios",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04161486147",
      "client_email": "BRACHOMENDOZAMARIOJOSE@GMAIL.COM",
      "address": "AV INTERCOMUNAL EDIF H15 PISO PB APT 06 URB LA CASONA II TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V21368995",
      "nap_box_name": "CTO-0541",
      "created_at": "2024-06-09T17:50:12.837456",
      "service_detail": {
        "id": 11774,
        "ip": "172.24.164.2",
        "mac": "TPLGF9CD3F8F",
        "serial": "TPLGF9CD3F8F",
        "queue": null,
        "interface": "VLAN110_CASONA_2",
        "created_at": "2026-02-27T10:44:58.496741",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4696,
      "client_name": "DANIELLA ALEXANDRA ARGUINZONES ROMERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Guanarito",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124591907",
      "client_email": "ANGELOJOSE73@GMAIL.COM",
      "address": "CALLE LEONARDO RUIZ PINEDA CASA NRO 13 SECTOR GUANARITO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V30081709",
      "nap_box_name": "CTO-00214",
      "created_at": "2024-06-09T19:07:00.694375",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4697,
      "client_name": "EMILI ZORALI SOLER CARAPAICA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Guanarito",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144560254",
      "client_email": "EMILYSOLER1403@GMAIL.COM",
      "address": "CALLE MEDINA ANGARITA CASA NRO 10 TURMERO",
      "client_identification": "V24420076",
      "nap_box_name": "235",
      "created_at": "2024-06-09T19:09:28.747876",
      "service_detail": {
        "id": 9964,
        "ip": "172.22.91.2",
        "mac": "TPLGBA687816",
        "serial": "TPLGBA687816",
        "queue": null,
        "interface": "VLAN232_GUANARITO_OLT2",
        "created_at": "2025-11-11T11:16:09.564936",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4698,
      "client_name": "PEDRO EULOGIO ACOSTA MONSALVE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Valle Paraiso",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144556317",
      "client_email": "ACOSTA.PEDRO@GMAIL.COM",
      "address": "URB VALLE PARAISO RESIDENCIAS JUAN PABLO II MANZANA 10 CASA NRO 03",
      "client_identification": "V16206435",
      "nap_box_name": "CE-00254",
      "created_at": "2024-06-09T19:12:03.952218",
      "service_detail": {
        "id": 3845,
        "ip": "172.22.93.2",
        "mac": "TPLGB68B4EB4",
        "serial": "TPLGB68B4EB4",
        "queue": "Plan_92194_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-07-16T13:24:20.449995",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4699,
      "client_name": "ONIX YOMELIS HURTADO CARRASQUEL",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243322936",
      "client_email": "ONIXHURTADO06@GMAIL.COM",
      "address": "CALLE 8 CASA NRO APTO 575A URB MATA CABALLO ROSARIO DE PAYA",
      "client_identification": "V15196036",
      "nap_box_name": "CTO-00215",
      "created_at": "2024-06-09T19:14:44.911495",
      "service_detail": {
        "id": 10333,
        "ip": "172.22.38.2",
        "mac": "OEMT3C6232C6",
        "serial": "OEMT3C6232C6",
        "queue": null,
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2025-11-25T14:35:03.757346",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4700,
      "client_name": "ROSA ROSAURA PEREZ MONTILLA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Concepcion",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243748869",
      "client_email": "LUISDCONTRERASCASTILLO@GMAIL.COM",
      "address": "AV VIA LA JULIA EDIF BLOQUE 11 PISO PB APT 7 URB LA CONCEPCION TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V13041088",
      "nap_box_name": "0326 DOS",
      "created_at": "2024-06-09T19:35:49.648000",
      "service_detail": {
        "id": 2929,
        "ip": "172.26.222.2",
        "mac": "TPLGF9CD3C4B",
        "serial": "TPLGF9CD3C4B",
        "queue": "Plan_148293_24341_WispHub",
        "interface": "VLAN111_CONCEPCION",
        "created_at": "2024-06-19T18:36:14.107204",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4701,
      "client_name": "VICTOR ALFONSO BELLO ALONZO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243054630",
      "client_email": "VICTORCHINOENANO@GMAIL.COM",
      "address": "CALLE 8 CASA AZUL NRO 577A URB MATA CABALLO ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V27369425",
      "nap_box_name": "CTO-00130",
      "created_at": "2024-06-09T19:38:04.519404",
      "service_detail": {
        "id": 12960,
        "ip": "172.28.1.2",
        "mac": "TP:LG:F9:CD:3F:DD",
        "serial": "TPLGF9CD3FDD",
        "queue": null,
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2026-09-03T10:15:39.430216",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4702,
      "client_name": "WUENDY ALEXANDRA MARTINEZ DE QUIROZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Brisas de Paya",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128967071",
      "client_email": "ALEXANDRAMARTINEZ1976.08@GMAIL.COM",
      "address": "CALLE 2 CASA NRO 12 SECTOR BRISAS DE PAYA ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V12609361",
      "nap_box_name": "CTO-00117",
      "created_at": "2024-06-09T19:42:15.213541",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4703,
      "client_name": "LETICIA JOSEFINA DIAZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128900572",
      "client_email": "LETICIA196931@GMAIL.COM",
      "address": "AV 05 MANZANA H-4 CASA NRO 4 SECTOR SAMAN TARAZONERO II TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V11091459",
      "nap_box_name": "508",
      "created_at": "2024-06-09T19:50:19.534559",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4704,
      "client_name": "YAHEN JOSE PEREZ PEROZO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121492881",
      "client_email": "YAHENLILIAN.26@GMAIL.COM",
      "address": "PRADOS DE PAYA I CALLE 13 CASA NRO 19 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V9687127",
      "nap_box_name": "579 DOS",
      "created_at": "2024-06-09T19:53:16.952597",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4705,
      "client_name": "HECTOR RAFAEL YBIMA DIAZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124681784",
      "client_email": "YBIMAHECTOR7@GMAIL.COM",
      "address": "CALLE 2 CASA NRO 1 BARRIO PRADOS DE PAYA II ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V8215228",
      "nap_box_name": "CTO-00205 DOS",
      "created_at": "2024-06-09T20:01:04.796461",
      "service_detail": {
        "id": 5582,
        "ip": "172.26.206.2",
        "mac": "TPLGF9CD47CF",
        "serial": "TPLGF9CD47CF",
        "queue": "Plan_161904_30183_WispHub",
        "interface": "VLAN242_PRADOS2",
        "created_at": "2024-08-17T09:02:46.488639",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4706,
      "client_name": "YANELLY DEL VALLE AZUAJE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04145982225",
      "client_email": "ARIANNYMOREAN10@GMAIL.COM",
      "address": "CALLE PROLONGACION CARREÑO EDIF TIORA PISO 03 APT 03 DESARROLLO HABITACIONAL LOS NISPEROS TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V10276997",
      "nap_box_name": "CTO-00296",
      "created_at": "2024-06-09T20:04:39.001012",
      "service_detail": {
        "id": 13087,
        "ip": "172.27.239.2",
        "mac": "JM:KG:C7:6E:6E:74",
        "serial": "JMKGC76E6E74",
        "queue": null,
        "interface": "VLAN209_ZAMORA_OLT1",
        "created_at": "2026-09-28T11:45:32.622715",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4707,
      "client_name": "MARGERIS DEL VALLE RAMOS ALFONZO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144936033",
      "client_email": "MARGERISRAMOSC@GMAIL.COM",
      "address": "CALLE 7 NRO 543D SECTOR MATA CABALLO",
      "client_identification": "V12664694",
      "nap_box_name": "CTO-00167 DOS",
      "created_at": "2024-06-09T20:05:18.146875",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4708,
      "client_name": "FELINYER JEURIMAR PLATA FELIZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243047563",
      "client_email": "FELINYERP@GMAIL.COM",
      "address": "CALLE 11 CASA NRO 653-A URB MATA CABALLO ROSARIO DE PAYA",
      "client_identification": "V27262869",
      "nap_box_name": "CTO-00213",
      "created_at": "2024-06-09T20:11:23.653929",
      "service_detail": {
        "id": 5572,
        "ip": "172.22.53.2",
        "mac": "TPLGB68B4E29",
        "serial": "TPLGB68B4E29",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-08-17T08:42:26.492799",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4709,
      "client_name": "BARBARA YANETSI GUDINO ROJAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Paya Abajo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04142961184",
      "client_email": "DORAJOSEFINAROJAS.1955@GMAIL.COM",
      "address": "CALLE CAMPO ELIAS CASA NRO 1 SECTOR PAYA ABAJO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V25841734",
      "nap_box_name": "406",
      "created_at": "2024-06-09T20:13:58.037939",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4711,
      "client_name": "YUSMILA YSMENIA SANCHEZ PANTOJA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243504179",
      "client_email": "YUSMILASANCHEZ28@GMAIL.COM",
      "address": "AV CASA NRO 501 SECTOR MATA CABALLO ROSARIO DE PAYA",
      "client_identification": "V11977673",
      "nap_box_name": "CTO-00457",
      "created_at": "2024-06-09T20:20:25.561520",
      "service_detail": {
        "id": 5568,
        "ip": "172.21.250.2",
        "mac": "TPLGB68B4DCF",
        "serial": "TPLGB68B4DCF",
        "queue": "Plan_161906_30183_WispHub",
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2024-08-17T08:34:26.696105",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4712,
      "client_name": "DENISSE MARYORIT BARRIOS AULAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 101,
        "name": "RECURRENTE RESIDENCIAL PLAN 200M",
        "cost": "19.00",
        "code": "FOR200MB",
        "profile": "200Mbps/200Mbps"
      },
      "client_mobile": "04161485520",
      "client_email": "DENISSEBA01@GMAIL.COM",
      "address": "CALLE 12 CASA NRO 670-A URB MATACA CABALLO ROSARIO DE PAYA",
      "client_identification": "V16407172",
      "nap_box_name": "CTO-0167",
      "created_at": "2024-06-09T20:22:51.389146",
      "service_detail": {
        "id": 9819,
        "ip": "172.21.203.2",
        "mac": "TPLGB68B4DB9",
        "serial": "TPLGB68B4DB9",
        "queue": null,
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2025-11-10T17:06:58.005182",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4713,
      "client_name": "NAILET ALEXANDRA BOLIVAR ECHENIQUE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243334836",
      "client_email": "NAYBOLI244@GMAIL.COM",
      "address": "CALLE 04 CASA NRO 212 URB MATA CABALLO ROSARIO DE PAYA",
      "client_identification": "V27864394",
      "nap_box_name": "CTO-00028",
      "created_at": "2024-06-09T20:24:57.697215",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4714,
      "client_name": "HERSAY YAJAIRA GARCIA PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Jabillar",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04125969658",
      "client_email": "GARCIAHERSAY@GMAIL.COM",
      "address": "CALLE 5 CASA NRO URB JABILLAR TURMERO",
      "client_identification": "V20108998",
      "nap_box_name": "CTO-00017 C/5 JABILLAR",
      "created_at": "2024-06-09T20:27:47.213392",
      "service_detail": {
        "id": 10656,
        "ip": "172.21.165.2",
        "mac": "TPLGB68B59F3",
        "serial": "TPLGB68B59F3",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2025-12-11T11:06:36.589588",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4715,
      "client_name": "PIERINA JOVANA URIBE ROSALES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243786155",
      "client_email": "PIERINAURIBE46@GMAIL.COM",
      "address": "AV 1 CASA NRO 676 URB MATA CABALLO ROSARIO DE PAYA TURMERO",
      "client_identification": "V12134146",
      "nap_box_name": "CTO-00215",
      "created_at": "2024-06-09T20:30:00.284767",
      "service_detail": {
        "id": 12806,
        "ip": "172.21.166.2",
        "mac": "TP:LG:B6:8B:58:AA",
        "serial": "TPLGB68B58AA",
        "queue": null,
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2026-08-07T16:56:11.062299",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4716,
      "client_name": "CHARLYS ENRIQUE MARIN PALMA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128866993",
      "client_email": "CHEMARIN_P@HOTMAIL.COM",
      "address": "CALLE 04 CASA NRO 125 SECTOR MATA CABALLO ROSARIO DE PAYA",
      "client_identification": "V14086638",
      "nap_box_name": "CTO-00392",
      "created_at": "2024-06-09T20:32:21.060741",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4717,
      "client_name": "FRANCYS LISBETH GUZMAN OLAVARRIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero I",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04129686518",
      "client_email": "NIERESLISMAR4@GMAIL.COM",
      "address": "CALLE 3 CASA NRO 6 BARRIO SAMAN TARAZONERO I TURMERO",
      "client_identification": "V9698619",
      "nap_box_name": "291",
      "created_at": "2024-06-09T20:34:38.952012",
      "service_detail": {
        "id": 13086,
        "ip": "172.17.2.34",
        "mac": "30:86:f6:81:59:ea",
        "serial": "JMKGF68159EA",
        "queue": null,
        "interface": "VLAN140_SMT1_ZTE",
        "created_at": "2026-09-27T18:38:04.261674",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4718,
      "client_name": "YOSWEL ANDREI LIENDO LLOVERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243529433",
      "client_email": "YOSLLOVERA18@GMAIL.COM",
      "address": "CALLE 9 CASA NRO 30 URB SAMAN TARAZONERO I TURMERO",
      "client_identification": "V27048881",
      "nap_box_name": "671",
      "created_at": "2024-06-09T20:36:50.678604",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4719,
      "client_name": "JOSE OMAR FLORES MATO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243366015",
      "client_email": "FLORESMATOSJ@GMAIL.COM",
      "address": "CALLE 4 CASA NRO 277 URB MATA CABALLO ROSARIO DE PAYA",
      "client_identification": "V21466056",
      "nap_box_name": "CTO-00274",
      "created_at": "2024-06-09T20:43:24.555998",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4720,
      "client_name": "CARLOS ALBERTO ALFARO LOPEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04143386593",
      "client_email": "CARLOSALBERTOALFARO20@GMAIL.COM",
      "address": "CALLE 04 CASA NRO 240 URB MATA CABALLO ROSARIO DE PAYA",
      "client_identification": "V15932610",
      "nap_box_name": "CTO-00265",
      "created_at": "2024-06-09T20:45:32.688274",
      "service_detail": {
        "id": 11460,
        "ip": "172.29.30.2",
        "mac": "TPLGB68B56EB",
        "serial": "TPLGB68B56EB",
        "queue": null,
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2026-02-04T08:59:53.023985",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4721,
      "client_name": "ZULEIMA YAMIRA RODRIGUEZ MONTEZUMA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Simon Bolivar",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04127764789",
      "client_email": "ZULEIMARODRIGUEZ641@GMAIL.COM",
      "address": "CALLE EL MACARO CALLE 6 CASA NRO 48 SIMON BOLIVAR TURMERO",
      "client_identification": "V9697743",
      "nap_box_name": "CTO-00023",
      "created_at": "2024-06-09T20:48:58.221659",
      "service_detail": {
        "id": 13092,
        "ip": "172.21.129.2",
        "mac": "TP:LG:B9:54:FC:AC",
        "serial": "TPLGB954FCAC",
        "queue": null,
        "interface": "VLAN128_SIMON_BOLIVAR_ZTE",
        "created_at": "2026-10-01T09:23:08.362126",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4722,
      "client_name": "CESAR ANTONIO GOYO MORILLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman de Guere",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128449507",
      "client_email": "CESARGOYO12@GMAIL.COM",
      "address": "AV INTERCOMUNAL TURMERO MARACAY  CALLE LA LLANERA  CASA NRO 1-2 SECTOR SAMAN DE GUERE",
      "client_identification": "V25841402",
      "nap_box_name": "CTO-00115",
      "created_at": "2024-06-09T20:51:26.757435",
      "service_detail": {
        "id": 5547,
        "ip": "172.21.107.2",
        "mac": "TPLG1BB363C2",
        "serial": "TPLG1BB363C2",
        "queue": "Plan_131338_24341_WispHub",
        "interface": "VLAN100_OLTs",
        "created_at": "2024-08-16T22:09:39.400396",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4724,
      "client_name": "YUDECCY XIOMARA HERNANDEZ LOPEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Arboleda",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144695261",
      "client_email": "XIOMA3839@GMAIL.COM",
      "address": "CALLE LOS MANGOS CASA NRO 37 SECTOR LA ARBOLEDA ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V12617670",
      "nap_box_name": "CTO-0485",
      "created_at": "2024-06-09T20:55:53.483797",
      "service_detail": {
        "id": 3082,
        "ip": "172.27.233.2",
        "mac": "VSOL00493DE1",
        "serial": "VSOL00493DE1",
        "queue": "Plan_161900_30183_WispHub",
        "interface": "VLAN257_ARBOLEDA",
        "created_at": "2024-06-22T12:03:24.652863",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4725,
      "client_name": "JAVIER ALEJANDRO CASTELLANOS CHAPARDI",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Valle Paraiso",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243277266",
      "client_email": "JAVIERCASTELLANOS1995@GMAIL.COM",
      "address": "URBANIZACION SAN PABLO SECTOR VALLE PARAISO MANZANA 5 CASA 17",
      "client_identification": "V24173142",
      "nap_box_name": "644",
      "created_at": "2024-06-09T21:03:30.549406",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4726,
      "client_name": "SAMIR SELIN CARDINALE VERASTEGUI",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144471890",
      "client_email": "MONICADAVILA1968@GMAIL.COM",
      "address": "CALLE 1 CASA NRO 24 BARRIO SAMAN TARAZONERO I EL MACARO",
      "client_identification": "V13742676",
      "nap_box_name": "444",
      "created_at": "2024-06-09T21:12:14.174288",
      "service_detail": {
        "id": 11477,
        "ip": "172.21.99.2",
        "mac": "TPLGB954E977",
        "serial": "TPLGB954E977",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2026-02-04T15:29:17.861887",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4727,
      "client_name": "JONATHAN DANIEL SANCHEZ SABINO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Palmeras I",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04122086977",
      "client_email": "JONATHANSABINO063@GMAIL.COM",
      "address": "CALLE PRINCIPAL CASA NRO 57 CONJUNTO RESIDENCIAL LAS PALMERAS I TURMERO",
      "client_identification": "V22287063",
      "nap_box_name": "CTO-00226",
      "created_at": "2024-06-09T21:14:54.223595",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4728,
      "client_name": "LUIS ALBERTO GONZALEZ PENA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04145798706",
      "client_email": "MAXTER3000X@GMAIL.COM",
      "address": "CALLE PEÑALVER CASA NRO 23-A ZONA INDUSTRIAL GUANARITO TURMERO",
      "client_identification": "V25620037",
      "nap_box_name": "126",
      "created_at": "2024-06-09T21:18:06.960195",
      "service_detail": {
        "id": 5542,
        "ip": "172.21.66.2",
        "mac": "TPLGB954EFB1",
        "serial": "TPLGB954EFB1",
        "queue": "Plan_153953_15811_WispHub",
        "interface": "VLAN100_OLTs",
        "created_at": "2024-08-16T21:51:53.462092",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4729,
      "client_name": "SANDRA ELIZABETH ORTEGA DE DELGADO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128929883",
      "client_email": "ORTEGASANDRA039@GMAIL.COM",
      "address": "CALLE PRINCIPAL C-9 CASA NRO 4 URB SAMAN  TARAZONERO II TURMERO",
      "client_identification": "V12991119",
      "nap_box_name": "286",
      "created_at": "2024-06-09T21:20:00.030935",
      "service_detail": {
        "id": 9929,
        "ip": "172.21.67.2",
        "mac": "TPLGB9550071",
        "serial": "TPLGB9550071",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2025-11-11T08:38:50.088199",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4731,
      "client_name": "JOHAN ALEXANDER NIEVES BARCOS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124611427",
      "client_email": "ADANKRISB@GMAIL.COM",
      "address": "CALLE 9 CASA NRO 33 SECTOR SAMAN TARAZONERO I",
      "client_identification": "V30102887",
      "nap_box_name": "671",
      "created_at": "2024-06-09T21:35:16.560021",
      "service_detail": {
        "id": 5522,
        "ip": "172.20.236.2",
        "mac": "TPLGB954E7FA",
        "serial": "TPLGB954E7FA",
        "queue": "Plan_127744_1574_WispHub",
        "interface": "VLAN100_OLTs",
        "created_at": "2024-08-16T20:50:35.040408",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4732,
      "client_name": "WILLIAN CASTELLANOS CARRILLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04149463950",
      "client_email": "CASTELLANOSWILLAN129@GMAIL.COM",
      "address": "CALLE 2 CRUCE CON CALLE 6 CASA 6 CASA II MANZANA I1 URB SAMAN TARAZONERO I TURMERO",
      "client_identification": "V10132741",
      "nap_box_name": "511",
      "created_at": "2024-06-09T21:37:04.830694",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4733,
      "client_name": "JANETH COROMOTO GAVIDIA FREITES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villas El Carmen",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04124827033",
      "client_email": "JANETHGG23@GMAIL.COM",
      "address": "CALLE 10 CASA NRO 11 VILLAS EL CARMEN TURMERO",
      "client_identification": "V6438434",
      "nap_box_name": "40 DOS",
      "created_at": "2024-06-09T21:40:03.592648",
      "service_detail": {
        "id": 2907,
        "ip": "172.20.225.2",
        "mac": "TPLGB954ECD4",
        "serial": "TPLGB954ECD4",
        "queue": "Plan_127996_1574_WispHub",
        "interface": "VLAN135_VILLAS_CARMEN",
        "created_at": "2024-06-19T16:50:39.236664",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4734,
      "client_name": "YORGELYS NATHALY ALVARADO POLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243337457",
      "client_email": "YORGENATHY@GMAIL.COM",
      "address": "CALLE 11 NRO 35 SAMAN TARAZONERO I TURMERO",
      "client_identification": "V26320969",
      "nap_box_name": "90",
      "created_at": "2024-06-09T21:42:22.288030",
      "service_detail": {
        "id": 5518,
        "ip": "172.29.5.2",
        "mac": "TPLGB954FB29",
        "serial": "TPLGB954FB29",
        "queue": "Plan_127996_1574_WispHub",
        "interface": "VLAN100_OLTs",
        "created_at": "2024-08-16T20:42:24.958078",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4735,
      "client_name": "YELITZA YUBISAY HERNANDEZ RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero I",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243035901",
      "client_email": "YYELITZAH@GMAIL.COM",
      "address": "CALLE PRINCIPAL CASA NRO 11 URB SAMAN TARAZONERO I TURMERO",
      "client_identification": "V14691048",
      "nap_box_name": "128",
      "created_at": "2024-06-09T21:44:41.476092",
      "service_detail": {
        "id": 5516,
        "ip": "172.21.81.2",
        "mac": "TPLGF5CB0A34",
        "serial": "TPLGF5CB0A34",
        "queue": "Plan_127996_1574_WispHub",
        "interface": "VLAN100_OLTs",
        "created_at": "2024-08-16T20:38:39.459789",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4736,
      "client_name": "PEDRO JOSE BOLIVAR BLANCA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Simon Bolivar",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04124104515",
      "client_email": "HEIDISREMOLINA97@GMAIL.COM",
      "address": "CALLE 8 CASA NRO 45 URB SIMON BOLIVAR EL MACARO",
      "client_identification": "V16269874",
      "nap_box_name": "CTO-00027",
      "created_at": "2024-06-09T21:46:52.670542",
      "service_detail": {
        "id": 5507,
        "ip": "172.21.6.2",
        "mac": "TPLGB954FCE9",
        "serial": "TPLGB954FCE9",
        "queue": "Plan_127996_1574_WispHub",
        "interface": "VLAN128_SIMON_BOLIVAR_ZTE",
        "created_at": "2024-08-16T20:19:10.675964",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4737,
      "client_name": "JOUBERT JOSE LUIS PEREIRA GOMEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Simon Bolivar",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04123984181",
      "client_email": "JOUBERTPEREIRA26@GMAIL.COM",
      "address": "CALLE 8 CASA NRO 35 SIMON BOLIVAR EL MACARO",
      "client_identification": "V23528342",
      "nap_box_name": "CTO-00027",
      "created_at": "2024-06-09T21:49:29.674563",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4738,
      "client_name": "JUNIOR JOSE HERNANDEZ PINEDA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero I",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04121598922",
      "client_email": "JUNIORHERNANDEZ2021@GMAIL.COM",
      "address": "CALLE 6 C/C PPAL OESTE CASA NRO 01 URB SAMAN TARAZONERO I TURMERO",
      "client_identification": "V19132139",
      "nap_box_name": "270",
      "created_at": "2024-06-09T21:51:58.472930",
      "service_detail": {
        "id": 8299,
        "ip": "172.20.251.2",
        "mac": "TPLGB954F80E",
        "serial": "TPLGB954F80E",
        "queue": "Plan_127996_1574_WispHub",
        "interface": "VLAN140_SMT1_ZTE",
        "created_at": "2025-04-18T15:51:47.864398",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4739,
      "client_name": "MIGUEL ANTONIO ORTEGA MATOS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Antigua Hacienda De Paya",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04122255138",
      "client_email": "migortega@gmail.com",
      "address": "CALLE DOMINGO TOVAR CASA NRO 4 URB ANTIGUA HACIENDA ROSARIO DE PAYA",
      "client_identification": "V6845530",
      "nap_box_name": "125",
      "created_at": "2024-06-10T10:34:56.758533",
      "service_detail": {
        "id": 5503,
        "ip": "172.31.50.2",
        "mac": "TPLGB954F9ED",
        "serial": "TPLGB954F9ED",
        "queue": "Plan_147201_15811_WispHub",
        "interface": "VLAN202_AHP_OLT1",
        "created_at": "2024-08-16T20:10:45.571451",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4740,
      "client_name": "JOHANA LAURENS ACOSTA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Antigua Hacienda De Paya",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04145906082",
      "client_email": "johalaurens@gmail.com",
      "address": "ANTIGUA HACIENDA DE PAYA CALLEJON ARAGUANEY PARCELA 31",
      "client_identification": "V14183618",
      "nap_box_name": "100 DOS",
      "created_at": "2024-06-10T10:37:49.596550",
      "service_detail": {
        "id": 5500,
        "ip": "172.20.167.2",
        "mac": "TPLGB954FC4A",
        "serial": "TPLGB954FC4A",
        "queue": "Plan_139897_15811_WispHub",
        "interface": "VLAN202_AHP_OLT1",
        "created_at": "2024-08-16T18:25:25.475462",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4741,
      "client_name": "GERSON EDUARDO PEREZ CARRILLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Residencias Mariño",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04128879547",
      "client_email": "GERSONPEREZ2001@GMAIL.COM",
      "address": "RESIDENCIAS MARIÑO TORRE B PISO 7 APTO 74-B",
      "client_identification": "V12608366",
      "nap_box_name": "CTO-0519",
      "created_at": "2024-06-10T10:39:46.754533",
      "service_detail": {
        "id": 10078,
        "ip": "172.20.180.2",
        "mac": "TPLGB954F6A5",
        "serial": "TPLGB954F6A5",
        "queue": null,
        "interface": "VLAN234_R_MARINO_OLT2",
        "created_at": "2025-11-12T16:06:48.783800",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4743,
      "client_name": "FRANCIS COROMOTO FLORES SILVA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Simon Bolivar",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243728953",
      "client_email": "PROFRANCIS13@GMAIL.COM",
      "address": "CALLE 1 CASA NRO 16 SIMON BOLIVAR TURMERO",
      "client_identification": "V13455018",
      "nap_box_name": "CTO-00041",
      "created_at": "2024-06-10T10:45:47.250071",
      "service_detail": {
        "id": 5482,
        "ip": "172.19.253.2",
        "mac": "TPLGB954E7BB",
        "serial": "TPLGB954E7BB",
        "queue": "Plan_137413_1574_WispHub",
        "interface": "VLAN128_SIMON_BOLIVAR_ZTE",
        "created_at": "2024-08-16T17:40:15.909386",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4744,
      "client_name": "JESUS GREGORIO PANTOJA NUÑEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Simon Bolivar",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121985625",
      "client_email": "JESUSPANTOJAN@GMAIL.COM",
      "address": "SIMON BOLIVAR CALLE 4 CASA NRO 23",
      "client_identification": "V22948621",
      "nap_box_name": "CTO-00044",
      "created_at": "2024-06-10T11:06:34.895958",
      "service_detail": {
        "id": 12861,
        "ip": "172.20.96.2",
        "mac": "HW:TC:91:1C:95:87",
        "serial": "HWTC911C9587",
        "queue": null,
        "interface": "VLAN128_SIMON_BOLIVAR_ZTE",
        "created_at": "2026-08-17T15:18:20.653065",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4746,
      "client_name": "LETSY MAIRIM MANZANILLA MARTINEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04149455033",
      "client_email": "YINMELILOZA@GMAIL.COM",
      "address": "CALLE 3 NRO 21 BARRIO SAMAN TARAZONERO I",
      "client_identification": "V24387236",
      "nap_box_name": "32",
      "created_at": "2024-06-10T11:15:30.173853",
      "service_detail": {
        "id": 5475,
        "ip": "172.19.219.2",
        "mac": "TPLGB954F5C1",
        "serial": "TPLGB954F5C1",
        "queue": "Plan_157310_1574_WispHub",
        "interface": "VLAN100_OLTs",
        "created_at": "2024-08-16T17:23:37.045413",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4748,
      "client_name": "YULIET DELYS GONZALEZ GONZALEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Simon Bolivar",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04142960084",
      "client_email": "DELYS.G.3001@GMAIL.COM",
      "address": "CALLE 8 NRO 38B URB SIMON BOLIVAR TURMERO",
      "client_identification": "V21025824",
      "nap_box_name": "CTO-00027",
      "created_at": "2024-06-10T15:10:06.997038",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4749,
      "client_name": "JOSE JOHAN GOTTO URBANO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero I",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04221789527",
      "client_email": "JOSEGOTTO1994@GMAIL.COM",
      "address": "CALLE 11 CASA NRO 18 URB SAMAN TARAZONERO I TURMERO",
      "client_identification": "V23790894",
      "nap_box_name": "90",
      "created_at": "2024-06-10T15:12:44.232497",
      "service_detail": {
        "id": 3292,
        "ip": "172.19.162.2",
        "mac": "TPLGB954FBBA",
        "serial": "TPLGB954FBBA",
        "queue": "Plan_127996_1574_WispHub",
        "interface": "VLAN112_LA_MACARENA",
        "created_at": "2024-07-01T12:50:32.909449",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4750,
      "client_name": "MARIA XIOMARA BRITO GUTIERREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128907960",
      "client_email": "INV.CYBERCAFE@GMAIL.COM",
      "address": "CALLE 1 CASA NRO 39 URB PRADOS II ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V9433207",
      "nap_box_name": "CTO-00301",
      "created_at": "2024-06-10T15:15:43.317224",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4751,
      "client_name": "NEIL RODRIGUEZ CASTILLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124661853",
      "client_email": "NEIL.RODRIGUEZ@EMPRESAS-POLAR.COM",
      "address": "CALLE 11 CASA NRO 15 SECTOR PRADOS DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V6330811",
      "nap_box_name": "CTO-00204 DOS",
      "created_at": "2024-06-10T15:21:51.901709",
      "service_detail": {
        "id": 5456,
        "ip": "172.27.247.2",
        "mac": "TPLGF9CD426B",
        "serial": "TPLGF9CD426B",
        "queue": "Plan_161904_30183_WispHub",
        "interface": "VLAN239_PRADOS1",
        "created_at": "2024-08-16T16:45:12.461678",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4752,
      "client_name": "PABLO JOSE APONTE CISNERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero I",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04143474063",
      "client_email": "PABLOJOSEAPONTE@GMAIL.COM",
      "address": "CALLE 11 CASA NRO 23 SECTOR SAMAN TARAZONERO I TURMERO",
      "client_identification": "V16074366",
      "nap_box_name": "90",
      "created_at": "2024-06-10T15:24:12.079630",
      "service_detail": {
        "id": 3478,
        "ip": "172.19.163.2",
        "mac": "TPLGB954FA48",
        "serial": "TPLGB954FA48",
        "queue": "Plan_127996_1574_WispHub",
        "interface": "VLAN100_OLTs",
        "created_at": "2024-07-05T08:57:00.762906",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4753,
      "client_name": "HEIMI OLGA CALZADILLA MARCHAN",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Concepcion",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04128949095",
      "client_email": "GUATAKSONG@GMAIL.COM",
      "address": "CALLE  PARROQUIA SAMAN DE GUEREN CASA FUNDO LA CONCEPCION NRO 32 SECTOR LA CONCEPCION CALLE 1 TURMERO",
      "client_identification": "V14221331",
      "nap_box_name": "0325",
      "created_at": "2024-06-10T15:29:52.117837",
      "service_detail": {
        "id": 9362,
        "ip": "172.19.159.2",
        "mac": "TPLGB954EC3C",
        "serial": "TPLGB954EC3C",
        "queue": "queue1",
        "interface": "VLAN111_CONCEPCION",
        "created_at": "2025-08-13T13:20:03.713780",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4754,
      "client_name": "NILYA DEL VALLE GONZALEZ RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "SUSPENDIDO_RESIDENCIAL",
      "status_name": "Suspendido",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121485300",
      "client_email": "ANDRESGRATEROL2011@GMAIL.COM",
      "address": "CALLE 3 CASA NRO 20 SECTOR SAMAN TARAZONERO I EL MACARO TURMERO",
      "client_identification": "V5279316",
      "nap_box_name": "291",
      "created_at": "2024-06-10T15:40:38.324214",
      "service_detail": {
        "id": 10041,
        "ip": "172.19.137.2",
        "mac": "TPLGB954EBFF",
        "serial": "TPLGB954EBFF",
        "queue": null,
        "interface": "VLAN140_SMT1_ZTE",
        "created_at": "2025-11-11T18:43:11.240269",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4755,
      "client_name": "JHONSON JESUS REANEZ MONTEROLA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Simon Bolivar",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04123981669",
      "client_email": "JOHNSONREANEZ@GMAIL.COM",
      "address": "CALLE 2 CASA NRO 28 BARRIO SIMON BOLIVAR SECTOR EL MACARO TURMERO",
      "client_identification": "V28432412",
      "nap_box_name": "CTO-00042",
      "created_at": "2024-06-10T15:54:04.055387",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4756,
      "client_name": "WILLIAMS ENRIQUE YSQUIEL SEVILLA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144439181",
      "client_email": "YSQUIEL16099390@GMAIL.COM",
      "address": "CALLE 11 CASA NRO 648-C SECTOR MATA CABALLO ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V16099390",
      "nap_box_name": "CTO-00022",
      "created_at": "2024-06-10T15:54:05.466543",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4757,
      "client_name": "GLIKMAN RAMON GONZALEZ CAMPOS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Simon Bolivar",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04127766814",
      "client_email": "GLIKSMANFEST@GMAIL.COM",
      "address": "CALLE 5 CASA NRO 36 URB SIMON BOLIBAR EL MACARO ARAGUA",
      "client_identification": "V19174683",
      "nap_box_name": "CTO-00001",
      "created_at": "2024-06-10T15:56:12.056123",
      "service_detail": {
        "id": 5435,
        "ip": "172.19.134.2",
        "mac": "TPLGB954FC0A",
        "serial": "TPLGB954FC0A",
        "queue": "queue1",
        "interface": "VLAN128_SIMON_BOLIVAR_ZTE",
        "created_at": "2024-08-16T16:10:33.884630",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4758,
      "client_name": "RITCHER ABIGAIL ANTUNEZ GONZALEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villas El Carmen",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04141465668",
      "client_email": "ritcher2007@gmail.com",
      "address": "CALLE 06 NRO 13 VILLAS EL CARMEN EL MACARO TURMERO",
      "client_identification": "V7176348",
      "nap_box_name": "58",
      "created_at": "2024-06-10T16:23:30.319391",
      "service_detail": {
        "id": 2918,
        "ip": "172.19.97.2",
        "mac": "TPLGB954EC25",
        "serial": "TPLGB954EC25",
        "queue": "Plan_127996_1574_WispHub",
        "interface": "VLAN135_VILLAS_CARMEN",
        "created_at": "2024-06-19T17:37:03.870224",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4759,
      "client_name": "JOSE ANTONIO HERNADEZ BLANCO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero I",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04126760351",
      "client_email": "ARIANNYHERNANDEZ14@GMAIL.COM",
      "address": "CALLE 9 NRO 32 SECTOR SAMAN TARAZONERO I EL MACARO TURMERO",
      "client_identification": "V10458238",
      "nap_box_name": "671",
      "created_at": "2024-06-10T16:27:36.460723",
      "service_detail": {
        "id": 5433,
        "ip": "172.21.69.2",
        "mac": "TPLGF5CB0247",
        "serial": "TPLGF5CB0247",
        "queue": "Plan_127996_1574_WispHub",
        "interface": "VLAN100_OLTs",
        "created_at": "2024-08-16T16:06:30.257976",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4760,
      "client_name": "PEDRO NEL ZAMBRANO GARCIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Lascenio Guerrero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124052830",
      "client_email": "TERYNEL2009@GMAIL.COM",
      "address": "URB LACENIO GUERRERO LAS PALMAS NRO 414 TURMERO",
      "client_identification": "V24344123",
      "nap_box_name": "475",
      "created_at": "2024-06-10T16:29:27.709887",
      "service_detail": {
        "id": 11422,
        "ip": "172.19.71.2",
        "mac": "TPLGB954FDC2",
        "serial": "TPLGB954FDC2",
        "queue": null,
        "interface": "VLAN115_LG",
        "created_at": "2026-01-29T17:37:00.401103",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4761,
      "client_name": "JEAN CARLOS ROMERO CASTILLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Simon Bolivar",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243137059",
      "client_email": "jeanfcinter1908@gmail.com",
      "address": "CALLE 3 NRO 6 URBANISMO SIMON BOLIVAR EL MACARO TURMERO",
      "client_identification": "V15122390",
      "nap_box_name": "CTO-00045",
      "created_at": "2024-06-10T16:31:22.305092",
      "service_detail": {
        "id": 5432,
        "ip": "172.19.70.2",
        "mac": "TPLGB954F10A",
        "serial": "TPLGB954F10A",
        "queue": "Plan_127996_1574_WispHub",
        "interface": "VLAN100_OLTs",
        "created_at": "2024-08-16T16:04:25.415614",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4762,
      "client_name": "MIGUEL ANTONIO GUAURA GARCIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Simon Bolivar",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04128348326",
      "client_email": "ANAMIGGUAURA@GMAIL.COM",
      "address": "CALLE 03 CASA NRO 18 SECTOR SIMON BOLIVAR EL MACARP TURMERO",
      "client_identification": "V10459085",
      "nap_box_name": "CTO-00045",
      "created_at": "2024-06-10T16:35:13.044723",
      "service_detail": {
        "id": 3632,
        "ip": "172.19.69.2",
        "mac": "TPLGB954EF3C",
        "serial": "TPLGB954EF3C",
        "queue": "Plan_127996_1574_WispHub",
        "interface": "VLAN100_OLTs",
        "created_at": "2024-07-11T13:09:34.201513",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4763,
      "client_name": "LUIS ALEJANDRO  HIDALGO FLORES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Simon Bolivar",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128150454",
      "client_email": "luishflores2609@gmail.com",
      "address": "CALLE 10 CASA NRO 62 BARRIO SIMON BOLIVAR TURMERO",
      "client_identification": "V30148131",
      "nap_box_name": "CTO-00034",
      "created_at": "2024-06-10T16:38:14.085984",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4764,
      "client_name": "JOAQUIN ANTONIO CORREIA GONCALVES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Montañita",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144513541",
      "client_email": "JOAQUINCORREIA1964@GMAIL.COM",
      "address": "CALLE MANZANA 2 CASA NRO 22 URB LA MONTAÑITA",
      "client_identification": "V7268053",
      "nap_box_name": "67",
      "created_at": "2024-06-10T16:53:00.166749",
      "service_detail": {
        "id": 5418,
        "ip": "172.19.16.2",
        "mac": "TPLGF5CB0375",
        "serial": "TPLGF5CB0375",
        "queue": "Plan_153953_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-08-16T15:41:58.237122",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4765,
      "client_name": "HECTOR ARGENIS URBINA RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243041280",
      "client_email": "URBINAROGRIGUEZHECTORARGENIS@GMAIL.COM",
      "address": "CALLE GIRARDOT CASA NRO 5 URB MARIÑO TURMERO",
      "client_identification": "V15473340",
      "nap_box_name": "53",
      "created_at": "2024-06-10T16:54:53.127126",
      "service_detail": {
        "id": 4279,
        "ip": "172.19.7.2",
        "mac": "TPLGF5CB0383",
        "serial": "TPLGF5CB0383",
        "queue": "queue1",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-08-08T14:56:26.898497",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4766,
      "client_name": "CARLOS RAFAEL GILMOND GARCIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Simon Bolivar",
      "plan": {
        "id": 16,
        "name": "RECURRENTE RESIDENCIAL PLAN 800M",
        "cost": "55.00",
        "code": "FOR800",
        "profile": "800M/800M"
      },
      "client_mobile": "04129403099",
      "client_email": "CARLOSGILMON05@GMAIL.COM",
      "address": "CALLE 2 NRO 50 URB SIMON BOLIVAR TURMERO",
      "client_identification": "V7218033",
      "nap_box_name": "CTO-00043",
      "created_at": "2024-06-10T16:56:56.466201",
      "service_detail": {
        "id": 5417,
        "ip": "172.18.249.2",
        "mac": "TPLGB954FEC8",
        "serial": "TPLGB954FEC8",
        "queue": "Plan_127983_1574_WispHub",
        "interface": "VLAN100_OLTs",
        "created_at": "2024-08-16T15:39:38.454417",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4767,
      "client_name": "WILLIS DANIEL COSS BLANCO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Simon Bolivar",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243163395",
      "client_email": "DOCUHECTOR@HOTMAIL.COM",
      "address": "CALLE 8 CASA NRO 16 SECTOR SIMON BOLIVAR SECTOR EL MACARO",
      "client_identification": "V15274069",
      "nap_box_name": "CTO-00035",
      "created_at": "2024-06-10T16:59:24.164812",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4768,
      "client_name": "LEIDY JOHANA QUINTERO RINCON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Simon Bolivar",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243191595",
      "client_email": "LEIDYJQR.22@GMAIL.COM",
      "address": "CALLE 8 CASA NRO 22 URB SIMON BOLIVAR ESTE, TURMERO ESTADO ARAGUA",
      "client_identification": "V22942599",
      "nap_box_name": "CTO-00035",
      "created_at": "2024-06-10T17:06:35.132383",
      "service_detail": {
        "id": 5413,
        "ip": "172.18.196.2",
        "mac": "TPLGB954EC6B",
        "serial": "TPLGB954EC6B",
        "queue": "Plan_127996_1574_WispHub",
        "interface": "VLAN128_SIMON_BOLIVAR_ZTE",
        "created_at": "2024-08-16T15:33:20.370413",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4769,
      "client_name": "HENRY ALEXANDER MEDINA BLANCO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Simon Bolivar",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243786886",
      "client_email": "HM8335393@GMAIL.COM",
      "address": "CALLE 10  CASA NRO 29 URB SIMON BOLIVAR TURMERO  ARAGUA",
      "client_identification": "V15472960",
      "nap_box_name": "CTO-00036",
      "created_at": "2024-06-10T17:15:04.644267",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4770,
      "client_name": "KEVIN EUDOMAR CARRASQUEL ANGARITA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vallecito",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128656883",
      "client_email": "KEVINEUDOMAR20@GMAIL.COM",
      "address": "VALLECITO, CALLE LA CEIBA, CASA NRO 16 ROSARIO DE PAYA",
      "client_identification": "V25841595",
      "nap_box_name": "CTO - 84",
      "created_at": "2024-06-10T17:16:03.336471",
      "service_detail": {
        "id": 8218,
        "ip": "172.29.169.2",
        "mac": "HWTCCC83F238",
        "serial": "HWTCCC83F238",
        "queue": "Plan_161900_30183_WispHub",
        "interface": "VLAN258_VALLECITO",
        "created_at": "2025-04-13T18:38:58.791862",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4771,
      "client_name": "ANTHONY KLEIBER TEJADA ALVAREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Taguapire",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04243650923",
      "client_email": "ANTHOONYY@GMAIL.COM",
      "address": "CALLE 3 EDIF 1 PISO 1 APT 68 URB TAGUAPIRE TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V0",
      "nap_box_name": "548",
      "created_at": "2024-06-10T17:18:43.705816",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4772,
      "client_name": "YADIRA ELENA RODRIGUEZ GARCIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados de Cafetal",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144922281",
      "client_email": "YADIRARODRIGUEZ_30@HOTMAIL.COM",
      "address": "CRTA VIA PAYA CALLE B CASA NRO 09-01 SECTOR PARCELAMIENTO PRADOS DE CAFETAL TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V6113512",
      "nap_box_name": "545",
      "created_at": "2024-06-10T17:20:17.869417",
      "service_detail": {
        "id": 10896,
        "ip": "172.27.229.2",
        "mac": "TPLGF9CD3CF1",
        "serial": "TPLGF9CD3CF1",
        "queue": null,
        "interface": "VLAN221_CAFETAL_OLT1",
        "created_at": "2025-12-23T12:45:20.149017",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4773,
      "client_name": "YANARYS DESIRE PADILLA LUQUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04145904552",
      "client_email": "YANARYSPADILLA@GMAIL.COM",
      "address": "CALLE 12 CASA NRO 695 C SECTOR MATA CABALLO ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V16435664",
      "nap_box_name": "CTO-00020",
      "created_at": "2024-06-10T17:22:39.467088",
      "service_detail": {
        "id": 5187,
        "ip": "172.27.249.2",
        "mac": "TPLGF9CD4682",
        "serial": "TPLGF9CD4682",
        "queue": "Plan_161904_30183_WispHub",
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2024-08-15T11:36:29.871422",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4775,
      "client_name": "LUISA ELUIS CARRILLO BUYON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Lascenio Guerrero",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04128981086",
      "client_email": "ELUCARRILLO15@GMAIL.COM",
      "address": "AV 101 CASA NRO 409 SECTOR LACENIO GUERRERO TURMERO EDO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V28050066",
      "nap_box_name": "475",
      "created_at": "2024-06-10T17:28:41.993053",
      "service_detail": {
        "id": 5383,
        "ip": "172.18.169.2",
        "mac": "TPLG2ABDC72C",
        "serial": "TPLG2ABDC72C",
        "queue": "Plan_127996_1574_WispHub",
        "interface": "VLAN100_OLTs",
        "created_at": "2024-08-16T13:30:47.576727",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4776,
      "client_name": "JOSE ORLANDO GUILLEN MORA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Luz y Vida",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04124663001",
      "client_email": "JOSEORLANDOGUILLEN12@GMAIL.COM",
      "address": "CALLE PRIMERO DIOS, CASA NRO. 29 SECTOR LUZ Y VIDA CALLE 1 ROSARIO DE PAYA",
      "client_identification": "V14771986",
      "nap_box_name": "CTO-00315 ",
      "created_at": "2024-06-10T17:36:01.724716",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4779,
      "client_name": "NAIROBIS MAGDALENA FIGUERA NIEVES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128666390",
      "client_email": "JOSEFPENA.A@GMAIL.COM",
      "address": "CALLE 03 CASA NRO 51 URB SAMAN TARAZONERO I SECTOR EL MACARO TURMERO EDO ARAGUA",
      "client_identification": "V10756843",
      "nap_box_name": "32",
      "created_at": "2024-06-11T08:08:44.475939",
      "service_detail": {
        "id": 12669,
        "ip": "172.10.196.2",
        "mac": "TP:LG:B7:65:69:2B",
        "serial": "TPLGB765692B",
        "queue": null,
        "interface": "VLAN140_SMT1_ZTE",
        "created_at": "2026-07-04T10:25:28.481124",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4780,
      "client_name": "RONNY JOSE ROJAS GONZALEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Arturo Luis Berti",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243203230",
      "client_email": "ROJASRONNY79@GMAIL.COM",
      "address": "CALLE 1 CASA NRO 372 URB ARTURO LUIS BERTI TURMERO ARAGUA",
      "client_identification": "V25066047",
      "nap_box_name": "29",
      "created_at": "2024-06-11T08:15:02.945478",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4781,
      "client_name": "LUIS GONZALO GUTIERREZ GAVIRIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Arturo Luis Berti",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04169444996",
      "client_email": "GONZOTRES@GMAIL.COM",
      "address": "CALLE 2 CASA NRO 384 URB ARTURO LUIS BERTI SAMAN DE GUERE SANTIAGO MARIÑO ARAGUA",
      "client_identification": "V24344141",
      "nap_box_name": "543",
      "created_at": "2024-06-11T08:16:51.096756",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4782,
      "client_name": "NELLEYCER MAHOLY CAPOTE ROMERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Arturo Luis Berti",
      "plan": {
        "id": 2,
        "name": "RECURRENTE RESIDENCIAL PLAN 30M",
        "cost": "20.00",
        "code": "FOR30",
        "profile": "30M/30M"
      },
      "client_mobile": "04243134695",
      "client_email": "NELLEYCER@GMAIL.COM",
      "address": "AV 100 CASA KARINA NRO 370 URB ARTURO LUIS BERTI TURMERO ARAGUA",
      "client_identification": "V26095312",
      "nap_box_name": "29",
      "created_at": "2024-06-11T08:31:07.008195",
      "service_detail": {
        "id": 5321,
        "ip": "172.17.84.2",
        "mac": "TPLGB7656537",
        "serial": "TPLGB7656537",
        "queue": "Plan_127740_1574_WispHub",
        "interface": "VLAN102_ARTURO_BERTI",
        "created_at": "2024-08-16T09:15:21.424679",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4783,
      "client_name": "YANETT JOSEFINA ALVAREZ MARTINEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Arturo Luis Berti",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243560124",
      "client_email": "YANETTALVAREZ091@GMAIL.COM",
      "address": "CALLE 1ERA CASA NRO 375 URB ARTURO LUIS BERTI TURMERO ARAGUA",
      "client_identification": "V7271970",
      "nap_box_name": "29",
      "created_at": "2024-06-11T08:32:51.895562",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4784,
      "client_name": "GINO GABRIEL JIMENEZ GIULIANELLI",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Arturo Luis Berti",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128902798",
      "client_email": "GINOJIMENEZ26@GMAIL.COM",
      "address": "CALLE 100 CASA NRO 363 URB ARTURO LUIS BERTI TURMERO ARAGUA",
      "client_identification": "V26935321",
      "nap_box_name": "29",
      "created_at": "2024-06-11T08:34:53.886686",
      "service_detail": {
        "id": 5302,
        "ip": "172.17.87.2",
        "mac": "TPLG2ABDC7D3",
        "serial": "TPLG2ABDC7D3",
        "queue": "Plan_157310_1574_WispHub",
        "interface": "VLAN102_ARTURO_BERTI",
        "created_at": "2024-08-15T18:40:10.651316",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4785,
      "client_name": "VICTOR ANDRES LANDI NIÑO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Simon Bolivar",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04125379589",
      "client_email": "LANDIVICTOR22@GMAIL.COM",
      "address": "CALLE 3 CASA NRO 31 URB SIMON BOLIVAR TURMERO ARAGUA",
      "client_identification": "V27712560",
      "nap_box_name": "CTO-00045",
      "created_at": "2024-06-11T08:37:44.222341",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4786,
      "client_name": "FRANCYS GLAUDENYS SANCHEZ ESPINOZA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04124571853",
      "client_email": "GLAUDENY14@GMAIL.COM",
      "address": "AV 06 CALLE 08 MANZANA I CASA NRO 8-1 SECTOR SAMAN TARAZONERO LA JULIA EDO ARAGUA",
      "client_identification": "V16684050",
      "nap_box_name": "119",
      "created_at": "2024-06-11T08:40:34.085847",
      "service_detail": {
        "id": 9942,
        "ip": "172.17.94.2",
        "mac": "TPLGB76564FD",
        "serial": "TPLGB76564FD",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2025-11-11T09:56:21.880357",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4787,
      "client_name": "CARLOS ALBERTO GARRIDO MACHADO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Nispero",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04127765911",
      "client_email": "GARRIDOCONTRERAS4@GMAIL.COM",
      "address": "CALLE FINAL DE LA CALLE 4 2DA ETAPA CASA NRO 75 URB EL NISPERO TURMERO ESTADO ARAGUA",
      "client_identification": "V8742706",
      "nap_box_name": "20",
      "created_at": "2024-06-11T08:42:20.504888",
      "service_detail": {
        "id": 5299,
        "ip": "172.20.28.2",
        "mac": "TPLGB76562FF",
        "serial": "TPLGB76562FF",
        "queue": "Plan_147201_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-08-15T18:34:39.938632",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4788,
      "client_name": "YRIS MARGARITA PULGAR DE GOMES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Nispero",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144905798",
      "client_email": "YRISMARGARITA94@GMAIL.COM",
      "address": "CALLE PRINCIPAL CASA NRO 76 URB EL NISPERO II ETAPA TURMERO ARAGUA",
      "client_identification": "V11184319",
      "nap_box_name": "20",
      "created_at": "2024-06-11T08:44:00.442561",
      "service_detail": {
        "id": 5298,
        "ip": "172.20.64.2",
        "mac": "TPLG2ABDC6B4",
        "serial": "TPLG2ABDC6B4",
        "queue": "queue1",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-08-15T18:29:44.615914",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4789,
      "client_name": "SUSANA ANGELINA RODRIGUEZ FERNANDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Saman Tarazonero I",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128900234",
      "client_email": "SRANYELA023@GMAIL.COM",
      "address": "CALLE 02 CASA NRO 55 SECTOR SAMAN TARAZONERO I TURMERO ARAGUA",
      "client_identification": "V11936551",
      "nap_box_name": "33",
      "created_at": "2024-06-11T08:46:48.153593",
      "service_detail": {
        "id": 9938,
        "ip": "172.17.105.2",
        "mac": "TPLGF5CB0321",
        "serial": "TPLGF5CB0321",
        "queue": null,
        "interface": "VLAN140_SMT1_ZTE",
        "created_at": "2025-11-11T09:33:29.304227",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4790,
      "client_name": "YANETH ALEXANDRA TORO RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124579963",
      "client_email": "IN.GAGROINDUSTRIAL@HOTMAIL.COM",
      "address": "VDA 1 CASA NRO 16 URB SAMAN TARAZONERO TURMERO ARAGUA",
      "client_identification": "V21464419",
      "nap_box_name": "444",
      "created_at": "2024-06-11T08:48:52.655560",
      "service_detail": {
        "id": 5296,
        "ip": "172.29.6.2",
        "mac": "TPLG2ABDC816",
        "serial": "TPLG2ABDC816",
        "queue": "Plan_157310_1574_WispHub",
        "interface": "VLAN100_OLTs",
        "created_at": "2024-08-15T18:26:13.431733",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4791,
      "client_name": "ZULEIDA JOSEFINA ARRIOJAS GUTIERREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Taguapire",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124309464",
      "client_email": "ARRIOJASZULEIDA@GMAIL.COM",
      "address": "URB. TAGUAPIRE CALLE 3 APTO 81 SECTOR EL MACARO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V7236095",
      "nap_box_name": "CTO-00386",
      "created_at": "2024-06-11T08:52:28.139898",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4792,
      "client_name": "RODOLFO ANTONIO RAMIREZ PARRA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Simon Bolivar",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243716947",
      "client_email": "MEINKAMPF2021@GMAIL.COM",
      "address": "CALLE 02 CASA NRO 53 SECTOR EL MACARO TURMERO EDO ARAGUA",
      "client_identification": "V17247899",
      "nap_box_name": "CTO-00043",
      "created_at": "2024-06-11T08:54:46.442518",
      "service_detail": {
        "id": 5295,
        "ip": "172.17.118.2",
        "mac": "TPLG1BB3648B",
        "serial": "TPLG1BB3648B",
        "queue": "Plan_137413_1574_WispHub",
        "interface": "VLAN100_OLTs",
        "created_at": "2024-08-15T18:24:19.756818",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4793,
      "client_name": "YEILA YULEIZI MENDEZ NIÑO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Simon Bolivar",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243289583",
      "client_email": "yeilamendez016@gmail.com",
      "address": "EL MACARO URB SIMON BOLIVAR CALLE 10 CASA NRO 50 TURMERO ESTADO ARAGUA",
      "client_identification": "V22289115",
      "nap_box_name": "CTO-00034",
      "created_at": "2024-06-11T08:56:36.380004",
      "service_detail": {
        "id": 5294,
        "ip": "172.17.119.2",
        "mac": "TPLGB954FF0A",
        "serial": "TPLGB954FF0A",
        "queue": "Plan_153953_1574_WispHub",
        "interface": "VLAN128_SIMON_BOLIVAR_ZTE",
        "created_at": "2024-08-15T18:22:32.641323",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4794,
      "client_name": "ALESKA GABRIELA LOPEZ COLMENARES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243161111",
      "client_email": "ALESKALOPEZ@HOTMAIL.COM",
      "address": "SAMAN TARAZONERO I CALLE 8 CASA NRO 10",
      "client_identification": "V23528555",
      "nap_box_name": "37",
      "created_at": "2024-06-11T08:58:55.221107",
      "service_detail": {
        "id": 10001,
        "ip": "172.17.100.2",
        "mac": "TPLGB954FBF6",
        "serial": "TPLGB954FBF6",
        "queue": null,
        "interface": "VLAN140_SMT1_ZTE",
        "created_at": "2025-11-11T14:03:48.040322",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4795,
      "client_name": "JORGE LUIS GONCALVES RODRIGUES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Narayola II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04143450837",
      "client_email": "JORGELUISGONCALVES2014@GMAIL.COM",
      "address": "CTRA INTERCOMUNAL SANTIAGO MARIÑO EDIF TORRE 2 PISO 1 APTO 1-5 URB NARAYOLA II TURMERO ESTADO",
      "client_identification": "V20334582",
      "nap_box_name": "CTO-0522",
      "created_at": "2024-06-11T09:02:03.098624",
      "service_detail": {
        "id": 9737,
        "ip": "172.17.247.2",
        "mac": "TPLGF5CB00CA",
        "serial": "TPLGF5CB00CA",
        "queue": null,
        "interface": "VLAN100_OLTs",
        "created_at": "2025-11-10T11:25:29.799961",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4796,
      "client_name": "JOSE GREGORIO LEON QUINTERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Narayola II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144577189",
      "client_email": "graficasleonfp@gmail.com",
      "address": "AV INTERCOMUNAL TURMERO EDIF TORRE 3 PISO 1 APTO 1-6 URB NARAYOLA II TURMERO ESTADO ARAGUA",
      "client_identification": "V8693720",
      "nap_box_name": "CTO-0523",
      "created_at": "2024-06-11T09:18:01.585657",
      "service_detail": {
        "id": 11084,
        "ip": "172.30.96.2",
        "mac": "TPLG2ABDC7E5",
        "serial": "TPLG2ABDC7E5",
        "queue": null,
        "interface": "VLAN117_NARAYOLA",
        "created_at": "2026-01-10T10:43:00.023389",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4797,
      "client_name": "LIBIA MARTINEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Narayola II",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04142980213",
      "client_email": "LIBIARELISMARTINEZ72@GMAIL.COM",
      "address": "URBANIZACION NARAYOLA 2, TORRE 2 PISO 3 APTO 3-2",
      "client_identification": "V11061523",
      "nap_box_name": "CTO-0522",
      "created_at": "2024-06-11T09:19:32.956872",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4798,
      "client_name": "LIASNEY MARINE MAITYN CALANCHE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128427317",
      "client_email": "ANGELOSANTAELLA@GMAIL.COM",
      "address": "CALLE 8 CASA NRO 3 URB SAMAN TARAZONERO I EL MACARO TURMERO ESTADO ARAGUA",
      "client_identification": "V17800682",
      "nap_box_name": "37",
      "created_at": "2024-06-11T09:21:33.978168",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4799,
      "client_name": "DANIEL ANTONIO DIAZ ANGULO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Macarena",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128907586",
      "client_email": "DANIEL88873@GMAIL.COM",
      "address": "LA MACARENA CALLE 5 CASA NRO 8",
      "client_identification": "V123389065",
      "nap_box_name": "33",
      "created_at": "2024-06-11T09:23:41.429475",
      "service_detail": {
        "id": 9889,
        "ip": "172.22.64.2",
        "mac": "TPLGB68B4E3C",
        "serial": "TPLGB68B4E3C",
        "queue": null,
        "interface": "VLAN112_LA_MACARENA_ZTE",
        "created_at": "2025-11-10T21:43:09.747938",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4800,
      "client_name": "JUAN PAREJO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04125002412",
      "client_email": "ANTHONIPAREJO@GMAIL.COM",
      "address": "CALLE 10 CASA NRO 10 SAMAN TARAZONERO I",
      "client_identification": "V4279510",
      "nap_box_name": "CTO-0672",
      "created_at": "2024-06-11T09:25:49.016111",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4801,
      "client_name": "MILLER EZEQUIEL RUIZ VARGAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243467219",
      "client_email": "MILLEREZEQUIELRUIZ@GMAIL.COM",
      "address": "CALLE 10 CASA NRO 6424-A URB MATA CABALLO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V25841840",
      "nap_box_name": "CTO-00143",
      "created_at": "2024-06-11T09:28:42.498264",
      "service_detail": {
        "id": 9566,
        "ip": "172.29.227.2",
        "mac": "OEMT3C6261FA",
        "serial": "OEMT3C6261FA",
        "queue": "queue1",
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2025-09-26T13:02:18.569313",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4802,
      "client_name": "GUILLERMO JAVIER MARCHAN",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128310155",
      "client_email": "MARCHANJAVIER217@GMAIL.COM",
      "address": "CALLE 7 CASA NRO 46 SECTOR EL MACARO SAMAN TARAZONERO I TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V12691086",
      "nap_box_name": "671",
      "created_at": "2024-06-11T09:43:43.375882",
      "service_detail": {
        "id": 5276,
        "ip": "172.29.81.2",
        "mac": "OEMT3C6262C6",
        "serial": "OEMT3C6262C6",
        "queue": "Plan_157310_1574_WispHub",
        "interface": "VLAN140_SMT1",
        "created_at": "2024-08-15T17:11:26.352693",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4803,
      "client_name": "MARILUZ BOLIVAR REYES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04267343963",
      "client_email": "MARILUZBOLIVAR83@GMAIL.COM",
      "address": "Calle 4-A Casa Nro. 7 Urbanización Pantin Rosario De Paya",
      "client_identification": "V10784127",
      "nap_box_name": "CTO-00076 DOS",
      "created_at": "2024-06-11T09:49:40.074071",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4804,
      "client_name": "LILIANA AMINTA NINO GRANADILLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243562463",
      "client_email": "NINOLILIANA451@GMAIL.COM",
      "address": "CALLE 2-A CASA NRO 9 SECTOR PANTIN ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V15302241",
      "nap_box_name": "CTO-00110",
      "created_at": "2024-06-11T11:26:01.960117",
      "service_detail": {
        "id": 12775,
        "ip": "172.29.51.2",
        "mac": "00:11:41:2e:d4:08",
        "serial": "HWTC2ED407A1",
        "queue": null,
        "interface": "VLAN229_PANTIN",
        "created_at": "2026-07-28T09:07:02.491905",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4805,
      "client_name": "ODALIS VIRGINIA FORNOZA ZAMBRANO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Terrazas de Paya",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121096836",
      "client_email": "WILKING0514@GMAIL.COM",
      "address": "CALLE MANZANA 9 CASA NRO 6 URB TERRAZA DE PAYA ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V9648702",
      "nap_box_name": "CTO-00249",
      "created_at": "2024-06-11T11:31:58.346310",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4806,
      "client_name": "MAIRA ALEXANDRA SILVA PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04269404349",
      "client_email": "HECTORALEJANDRODIAZSILVA00@GMAIL.COM",
      "address": "CALLE CARREÑO EDIF 9 PISO PB APTO 2 URB HACIENDA LOS NISPEROS TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V15650983",
      "nap_box_name": "CTO-00387",
      "created_at": "2024-06-11T11:33:30.762877",
      "service_detail": {
        "id": 8325,
        "ip": "172.24.223.2",
        "mac": "TPLGF9CD4207",
        "serial": "TPLGF9CD4207",
        "queue": "Plan_92300_15811_WispHub",
        "interface": "VLAN209_ZAMORA_OLT1",
        "created_at": "2025-04-22T11:30:25.666387",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4807,
      "client_name": "YELITZA COROMOTO FLORES PRIETO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Dios Es Mi Refugio",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243332620",
      "client_email": "YEREMIBOLIVAR68@GMAIL.COM",
      "address": "AV ROSARIO DE PAYA CASA 14 MANZANA 6 SECTOR COMUNIDAD DIOS ES MI REFUGIO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V20119050",
      "nap_box_name": "CTO-0656",
      "created_at": "2024-06-11T11:35:31.891088",
      "service_detail": {
        "id": 9764,
        "ip": "172.27.204.2",
        "mac": "HWTCD659539C",
        "serial": "HWTCD659539C",
        "queue": null,
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2025-11-10T12:23:48.525014",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4808,
      "client_name": "YOLERKIS ELIMAR VALERO LOPEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Canaima",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243656405",
      "client_email": "YOLERKISVALERO07@GMAIL.COM",
      "address": "CALLE 3 CASA NRO 2 URBANIZACION CANAIMA ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V27864980",
      "nap_box_name": "355",
      "created_at": "2024-06-11T11:37:51.788102",
      "service_detail": {
        "id": 12408,
        "ip": "172.27.193.2",
        "mac": "HWTC466C3D9B",
        "serial": "HWTC466C3D9B",
        "queue": null,
        "interface": "VLAN270_VALLE_FRESCO_OLT3",
        "created_at": "2026-04-24T15:20:52.546183",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4810,
      "client_name": "MARIOCCI LISBETH CORZO GARCIAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Magdalena",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243332119",
      "client_email": "MARIOCCYCORZO@GMAIL.COM",
      "address": "CALLE 11 CASA NRO 48 LA MAGDALENA",
      "client_identification": "V16734379",
      "nap_box_name": "357",
      "created_at": "2024-06-11T11:52:47.029786",
      "service_detail": {
        "id": 10909,
        "ip": "172.20.120.2",
        "mac": "VSOL00126791",
        "serial": "VSOL00126791",
        "queue": null,
        "interface": "VLAN114_MAGDALENA",
        "created_at": "2025-12-23T13:15:25.154718",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4811,
      "client_name": "CARMELO DAVID AREVALO LUGO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124367049",
      "client_email": "CARMELOARE55@GMAIL.COM",
      "address": "CALLE 16A CASA NRO 29 URB HACIENDA PANTYN ROSARIO DE PAYA ARAGUA",
      "client_identification": "V25620700",
      "nap_box_name": "CTO-00195",
      "created_at": "2024-06-11T11:55:35.287343",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4812,
      "client_name": "FRANCISCO JAVIER MALDONADO REQUENA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Nispero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128909386",
      "client_email": "THEFYLOMBANO2@GMAIL.COM",
      "address": "CALLE 2 CASA NRO 58 URB EL NISPERO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V29502778",
      "nap_box_name": "20",
      "created_at": "2024-06-11T11:57:48.999337",
      "service_detail": {
        "id": 10013,
        "ip": "172.29.209.2",
        "mac": "OEMT3C625CC2",
        "serial": "OEMT3C625CC2",
        "queue": null,
        "interface": "VLAN208_NISPERO_OLT1",
        "created_at": "2025-11-11T14:55:19.114875",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4814,
      "client_name": "EDGAR ALEXANDER OROPEZA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Jabillar",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243308734",
      "client_email": "OROPEZAEDGAR65@GMAIL.COM",
      "address": "CALLE EL ARAGUANEY CASA NRO 8-14 URB JABILLAR TOWN COUNTRY TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V12568095",
      "nap_box_name": "CTO-0078",
      "created_at": "2024-06-11T12:15:09.029313",
      "service_detail": {
        "id": 5243,
        "ip": "172.28.160.2",
        "mac": "HWTC3D5080A1",
        "serial": "HWTC3D5080A1",
        "queue": "Plan_157310_1574_WispHub",
        "interface": "VLAN108_JABILLAR",
        "created_at": "2024-08-15T15:25:55.056774",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4815,
      "client_name": "EVELYN MARIBEL DIAZ ALVAREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "PAUSADO_RESIDENCIAL",
      "status_name": "Pausado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243251511",
      "client_email": "CABALLOTA810@GMAIL.COM",
      "address": "CALLE 7, VIA INTERCOMUNAL TURMERO MARACAY CASA NRO 40 URB LA CASONA I TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V13454260",
      "nap_box_name": "411",
      "created_at": "2024-06-11T12:18:34.987433",
      "service_detail": {
        "id": 10279,
        "ip": "172.24.215.2",
        "mac": "TPLGF9CD4258",
        "serial": "TPLGF9CD4258",
        "queue": null,
        "interface": "VLAN109_CASONA_1",
        "created_at": "2025-11-23T18:57:40.191479",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4816,
      "client_name": "DIEGO JOSE GUARAN  CACERES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243337032",
      "client_email": "DIGOGUARAN@GMAIL.COM",
      "address": "CALLE 1-B CASA NRO 23 URB PANTIN ROSARIO DE PAYA",
      "client_identification": "V14182697",
      "nap_box_name": "CTO-00127",
      "created_at": "2024-06-11T12:20:50.934365",
      "service_detail": {
        "id": 5238,
        "ip": "172.17.42.2",
        "mac": "VSOL0047D581",
        "serial": "VSOL0047D581",
        "queue": "Plan_161906_30183_WispHub",
        "interface": "VLAN229_PANTIN",
        "created_at": "2024-08-15T15:03:33.496632",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4817,
      "client_name": "ANDERSON ANDRES ROJAS SALAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121486670",
      "client_email": "AR5.ANDERSONROJAS@GMAIL.COM",
      "address": "CALLE 18 A CASA NRO 16 URB PANTIN ROSARIO DE PAYA",
      "client_identification": "V29598094",
      "nap_box_name": "CTO-00434",
      "created_at": "2024-06-11T12:23:13.536233",
      "service_detail": {
        "id": 5235,
        "ip": "172.23.223.2",
        "mac": "VSOL00128891",
        "serial": "VSOL00128891",
        "queue": "queue1",
        "interface": "VLAN229_PANTIN",
        "created_at": "2024-08-15T15:00:02.978473",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4818,
      "client_name": "ADRIANA JOANY BUSCEMA HERRERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124631573",
      "client_email": "ADRIANA.BUSCEMA.19@GMAIL.COM",
      "address": "CALLE 4 CASA NRO 42 BARRIO SAMAN TARAZONERO I EL MACARO",
      "client_identification": "V21272036",
      "nap_box_name": "262",
      "created_at": "2024-06-11T12:25:27.647985",
      "service_detail": {
        "id": 9946,
        "ip": "172.23.69.2",
        "mac": "TPLGBA688025",
        "serial": "TPLGBA688025",
        "queue": null,
        "interface": "VLAN140_SMT1_ZTE",
        "created_at": "2025-11-11T10:23:55.278839",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4820,
      "client_name": "ERAIKA JOSEFINA HERNANDEZ HERNANDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero I",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04144611071",
      "client_email": "ERAIKAHERNANDEZ1@GMAIL.COM",
      "address": "VDA 6E PRINCIPAL ESTE AVENIDA PRINCIPAL OESTE CASA NRO 17 SAMAN TARAZONERO I TURMERO",
      "client_identification": "V19652319",
      "nap_box_name": "270",
      "created_at": "2024-06-11T12:27:59.150534",
      "service_detail": {
        "id": 9976,
        "ip": "172.21.97.2",
        "mac": "TPLGB954FBC4",
        "serial": "TPLGB954FBC4",
        "queue": null,
        "interface": "VLAN140_SMT1_ZTE",
        "created_at": "2025-11-11T12:25:28.033556",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4821,
      "client_name": "YEUDYS ABIGAIL BARRIENTOS GUTIERREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "SUSPENDIDO_RESIDENCIAL",
      "status_name": "Suspendido",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Huerta Los Pajaros",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243766877",
      "client_email": "Coconutwao9@GMAIL.COM",
      "address": "AV PRINCIPAL ETA AVE PARAISO NRO 13-A HUERTA LOS PAJAROS",
      "client_identification": "V4585505",
      "nap_box_name": "96",
      "created_at": "2024-06-11T12:30:15.092206",
      "service_detail": {
        "id": 11605,
        "ip": "172.20.132.2",
        "mac": "TPLGF5CB02D1",
        "serial": "TPLGF5CB02D1",
        "queue": null,
        "interface": "VLAN211_HLP_OLT2",
        "created_at": "2026-02-13T16:16:50.295347",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4822,
      "client_name": "EMILY SILVANA BLANCO SANTANA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Macarena",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04140575973",
      "client_email": "EMILYSILVANA@GMAIL.COM",
      "address": "CALLE 11, CASA NRO 6 LA MACARENA II EL MACARO TURMERO",
      "client_identification": "V18646703",
      "nap_box_name": "80",
      "created_at": "2024-06-11T12:32:41.311018",
      "service_detail": {
        "id": 5228,
        "ip": "172.19.107.2",
        "mac": "TPLGB954EB1B",
        "serial": "TPLGB954EB1B",
        "queue": "Plan_127996_1574_WispHub",
        "interface": "VLAN112_LA_MACARENA",
        "created_at": "2024-08-15T14:39:56.275258",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4823,
      "client_name": "JAIME AMADOR RIVAS RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero I",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04120380437",
      "client_email": "KINFIJAIME@GMAIL.COM",
      "address": "CALLE NRO 9 CASA NRO 35 SAMAN TARAZONERO I",
      "client_identification": "V10459577",
      "nap_box_name": "671",
      "created_at": "2024-06-11T12:50:55.376889",
      "service_detail": {
        "id": 5227,
        "ip": "172.19.94.2",
        "mac": "TPLGB9550107",
        "serial": "TPLGB9550107",
        "queue": "queue1",
        "interface": "VLAN100_OLTs",
        "created_at": "2024-08-15T14:37:06.968847",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4824,
      "client_name": "EVERTH ALEXANDER AGUILAR PERNIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villas El Carmen",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04121782737",
      "client_email": "EVERTH.AGUILAR.009@GMAIL.COM",
      "address": "CALLE 11 CASA NRO 08 SECTOR VILLAS EL CARMEN TURMERO ARAGUA",
      "client_identification": "V19792981",
      "nap_box_name": "40",
      "created_at": "2024-06-11T12:53:58.755321",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4825,
      "client_name": "SORENIA SOLEYDA RODRIGUEZ VERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Jabillar",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04127520039",
      "client_email": "soleydarodriguez3@gmail.com",
      "address": "CALLE LOS CHAGUARAMOS CASA LA CASITA NRO 09-11 CONJUNTO RESIDENCIAL JABILLAR TONW COUNTRY TURMERO ARAGUA",
      "client_identification": "V18638021",
      "nap_box_name": "CTO-00005",
      "created_at": "2024-06-11T12:58:18.899745",
      "service_detail": {
        "id": 10799,
        "ip": "172.30.101.2",
        "mac": "TPLG1BB3641C",
        "serial": "TPLG1BB3641C",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2025-12-18T10:27:25.091401",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4826,
      "client_name": "ELIZABETH MARGARITA MALUENGA PORTE",
      "client_type_name": "EMPLEADO",
      "client_subdivision": "CANCELADO_EMPLEADO",
      "status_name": "Cancelado",
      "cycle": 25,
      "migrate": false,
      "sector_name": "Saman Tarazonero I",
      "plan": {
        "id": 78,
        "name": "Plan empleado 80MB",
        "cost": "0.00",
        "code": "FO-80M",
        "profile": "80M/80M"
      },
      "client_mobile": "04128997041",
      "client_email": "JAVIERGONZALEZ17012000@GMAIL.COM",
      "address": "CALLE 3 CASA NRO BARRIO SAMAN TARAZONERO I TURMERO",
      "client_identification": "V7217731",
      "nap_box_name": "32",
      "created_at": "2024-06-11T14:00:47.406859",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4827,
      "client_name": "COMANDO POLICIA EL MACARO",
      "client_type_name": "INTERCAMBIO",
      "client_subdivision": "ACTIVO_INTERCAMBIO",
      "status_name": "Activo",
      "cycle": 25,
      "migrate": false,
      "sector_name": "Simon Bolivar",
      "plan": {
        "id": 83,
        "name": "RECURRENTE INSTITUCIONAL 80M",
        "cost": "0.00",
        "code": "FO-R80",
        "profile": "80M/80M"
      },
      "client_mobile": "04128470503",
      "client_email": "C.C.P.MARINOINPOARAGUA@GMAIL.COM",
      "address": "EL MACARO CTRA MARACAY TURMERO SIMON BOLIVAR",
      "client_identification": "V13779800",
      "nap_box_name": "52",
      "created_at": "2024-06-11T14:08:00.141280",
      "service_detail": {
        "id": 9770,
        "ip": "172.18.105.2",
        "mac": "GPON0097EBE6",
        "serial": "GPON0097EBE6",
        "queue": null,
        "interface": "VLAN104_EL_MACARO_OLT_ZTE",
        "created_at": "2025-11-10T12:32:50.717735",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4828,
      "client_name": "JOANA NORELIS SANCHEZ",
      "client_type_name": "GRATIS",
      "client_subdivision": "ACTIVO_GRATIS",
      "status_name": "Activo",
      "cycle": 25,
      "migrate": false,
      "sector_name": "Terrazas de Juan Pablo",
      "plan": {
        "id": 86,
        "name": "PLAN RECURRENTE 80M GRATIS",
        "cost": "0.00",
        "code": "FO-G80",
        "profile": "80M/80M"
      },
      "client_mobile": "04121422868",
      "client_email": "CG.SISPROTGF@GMAIL.COM",
      "address": "CALLE LA LLANERA EDIF TERRAZAS DE SAN PABLO PISO 1 APT D10 SECTOR SAMAN DE GUERE TURMERO ARAGUA",
      "client_identification": "V19032380",
      "nap_box_name": "12",
      "created_at": "2024-06-11T14:18:05.493074",
      "service_detail": {
        "id": 9771,
        "ip": "172.25.180.2",
        "mac": "TPLGB7656E06",
        "serial": "TPLGB7656E06",
        "queue": null,
        "interface": "VLAN130_TERRAZAS_JP",
        "created_at": "2025-11-10T12:37:17.293843",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4829,
      "client_name": "EBE CRISTINA BAPTISTA",
      "client_type_name": "INTERCAMBIO",
      "client_subdivision": "ACTIVO_INTERCAMBIO",
      "status_name": "Activo",
      "cycle": 25,
      "migrate": false,
      "sector_name": "Simon Bolivar",
      "plan": {
        "id": 83,
        "name": "RECURRENTE INSTITUCIONAL 80M",
        "cost": "0.00",
        "code": "FO-R80",
        "profile": "80M/80M"
      },
      "client_mobile": "04243527279",
      "client_email": "LANUEVACRISTINA@GMAIL.COM",
      "address": "CALLE 1 SIMON  BOLIVAR  S/N",
      "client_identification": "J403297924",
      "nap_box_name": "CTO-00041",
      "created_at": "2024-06-11T16:11:27.917089",
      "service_detail": {
        "id": 9773,
        "ip": "172.30.44.2",
        "mac": "TPLGB765615F",
        "serial": "TPLGB765615F",
        "queue": null,
        "interface": "VLAN128_SIMON_BOLIVAR_ZTE",
        "created_at": "2025-11-10T12:40:18.493119",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4830,
      "client_name": "COLEGIO ARGELIA LAYA",
      "client_type_name": "INTERCAMBIO",
      "client_subdivision": "ACTIVO_INTERCAMBIO",
      "status_name": "Activo",
      "cycle": 25,
      "migrate": false,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 83,
        "name": "RECURRENTE INSTITUCIONAL 80M",
        "cost": "0.00",
        "code": "FO-R80",
        "profile": "80M/80M"
      },
      "client_mobile": "04162413601",
      "client_email": "PROFARGELIALAYA@GMAIL.COM",
      "address": "SAMAN TARAZONERO  II, TURMERO",
      "client_identification": "V87374340",
      "nap_box_name": "38",
      "created_at": "2024-06-11T16:33:18.186314",
      "service_detail": {
        "id": 4284,
        "ip": "172.25.58.2",
        "mac": "TPLGB765643D",
        "serial": "TPLGB765643D",
        "queue": "Plan_14173_1574_WispHub",
        "interface": "VLAN100_OLTs",
        "created_at": "2024-08-08T15:39:16.586977",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4832,
      "client_name": "UEN JOSE RAFAEL REVENGA",
      "client_type_name": "INTERCAMBIO",
      "client_subdivision": "ACTIVO_INTERCAMBIO",
      "status_name": "Activo",
      "cycle": 25,
      "migrate": false,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 83,
        "name": "RECURRENTE INSTITUCIONAL 80M",
        "cost": "0.00",
        "code": "FO-R80",
        "profile": "80M/80M"
      },
      "client_mobile": "04120465192",
      "client_email": "DEULYSM74@GMAIL.COM",
      "address": "CALLE URDANETA  CON CALLE 4 CASCO DE TURMERO",
      "client_identification": "G200028203",
      "nap_box_name": "25",
      "created_at": "2024-06-11T17:17:15.290349",
      "service_detail": {
        "id": 9775,
        "ip": "172.22.178.2",
        "mac": "TPLGBA687D5A",
        "serial": "TPLGBA687D5A",
        "queue": null,
        "interface": "VLAN200_OLTs",
        "created_at": "2025-11-10T12:41:44.579557",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4833,
      "client_name": "MY MOTO RT CA",
      "client_type_name": "PYME",
      "client_subdivision": "CANCELADO_PYME",
      "status_name": "Cancelado",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04129382445",
      "client_email": "LUZMARINAQUINTEROTOVAR@GMAIL.COM",
      "address": "CALLE URDANETA LOCAL PARCELA NRO 61 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "J504961795",
      "nap_box_name": "CTO-00072",
      "created_at": "2024-06-12T10:28:17.346713",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4834,
      "client_name": "CINTHIA MARIA ROSA DE LOS SANTOS MEZA CEDENO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Narayola II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04143937957",
      "client_email": "CINTHIAMARIAROSAMEZA@GMAIL.COM",
      "address": "NARAYOLA 2 TORRE 5 APARTAMENTO N14 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V16484388",
      "nap_box_name": "CTO-0525",
      "created_at": "2024-06-12T16:58:14.792692",
      "service_detail": {
        "id": 9997,
        "ip": "172.29.113.2",
        "mac": "OEMT3C6262B6",
        "serial": "OEMT3C6262B6",
        "queue": null,
        "interface": "VLAN117_NARAYOLA",
        "created_at": "2025-11-11T13:49:06.353466",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4835,
      "client_name": "JASMIN REYES ALEMAN",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121998911",
      "client_email": "JGONCALVES56@HOTMAIL.COM",
      "address": "CALLE 107 CASA NRO 68 SECTOR LAS RURALES ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V14740014",
      "nap_box_name": "603 DOS",
      "created_at": "2024-06-12T17:35:08.646991",
      "service_detail": {
        "id": 5207,
        "ip": "172.26.186.2",
        "mac": "HWTCC173179C",
        "serial": "HWTCC173179C",
        "queue": "Plan_161905_30183_WispHub",
        "interface": "VLAN252_RURALES_PAYA",
        "created_at": "2024-08-15T13:34:23.621716",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4836,
      "client_name": "LUIS ALEJANDRO CHAVERO RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243253003",
      "client_email": "MOROCHIMARU1@GMAIL.COM",
      "address": "CALLE 23 CASA NRO 61 SECTOR RIO SECO ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V25066384",
      "nap_box_name": "CTO-00033",
      "created_at": "2024-06-12T17:37:15.465321",
      "service_detail": {
        "id": 3418,
        "ip": "172.26.245.2",
        "mac": "HWTC545343A3",
        "serial": "HWTC545343A3",
        "queue": "Plan_161900_30183_WispHub",
        "interface": "VLAN251_RIO_SECO",
        "created_at": "2024-07-03T14:08:41.778524",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4837,
      "client_name": "GUSMARIN ABIGAIL FRAGOZA LOPEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04149457668",
      "client_email": "GUSMARIFRAGOZA@GMAIL.COM",
      "address": "CALLE 11-B CASA NRO 30 SECTOR PANTIN ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V237840395",
      "nap_box_name": "CTO-00168",
      "created_at": "2024-06-12T17:40:02.080909",
      "service_detail": {
        "id": 9838,
        "ip": "172.26.30.2",
        "mac": "VSOL00D0DF9F",
        "serial": "VSOL00D0DF9F",
        "queue": null,
        "interface": "VLAN229_PANTIN",
        "created_at": "2025-11-10T17:40:33.429232",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4838,
      "client_name": "ALCENIA JOSEFINA ACOSTA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "SUSPENDIDO_RESIDENCIAL",
      "status_name": "Suspendido",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243101189",
      "client_email": "ALCENIAACOSTA@GMAIL.COM",
      "address": "CALLE 9 CASA NRO 79 URB LA CASONA I TURMERO ARAGUA ZONA POSTAL 2105",
      "client_identification": "V4234107",
      "nap_box_name": "449",
      "created_at": "2024-06-12T17:47:02.350473",
      "service_detail": {
        "id": 5205,
        "ip": "172.26.33.2",
        "mac": "VSOL00D0FCD7",
        "serial": "VSOL00D0FCD7",
        "queue": "Plan_131337_24341_WispHub",
        "interface": "VLAN109_CASONA_1",
        "created_at": "2024-08-15T13:29:19.068916",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4839,
      "client_name": "ELIMAR GONZALEZ CONTRERAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243221632",
      "client_email": "GONZALEZELISMAR@GMAIL.COM",
      "address": "CALLE 09 CASA NRO 600-A URB MATACABALLO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V16494587",
      "nap_box_name": "160",
      "created_at": "2024-06-13T08:19:56.915082",
      "service_detail": {
        "id": 10099,
        "ip": "172.29.117.2",
        "mac": "OEMT3C625ECA",
        "serial": "OEMT3C625ECA",
        "queue": null,
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2025-11-13T14:29:59.867331",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4840,
      "client_name": "LEIDY ADRIANA VILLEGAS CALDERON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados de Cafetal",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243550402",
      "client_email": "VILLEGASHILLMAT0630@GMAIL.COM",
      "address": "URBANIZACIÓN PRADOS DEL CAFETAL CALLE NRO. 02 SEGUNDA TRANSVERSAL CASA NRO. 82 TURMERO",
      "client_identification": "V15819604",
      "nap_box_name": "561",
      "created_at": "2024-06-13T08:24:28.404911",
      "service_detail": {
        "id": 10899,
        "ip": "172.29.112.2",
        "mac": "OEMT3C626192",
        "serial": "OEMT3C626192",
        "queue": null,
        "interface": "VLAN221_CAFETAL_OLT1",
        "created_at": "2025-12-23T12:55:24.833098",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4842,
      "client_name": "ROSY YAMILET SANCHEZ DE CASTRO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vallecito",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128909764",
      "client_email": "JCCLEANERCA@HOTMAIL.COM",
      "address": "VALLECITO CALLE MORICHE CASA NRO. 04 PAYA",
      "client_identification": "V12342135",
      "nap_box_name": "CTO - 80",
      "created_at": "2024-06-13T08:39:36.626200",
      "service_detail": {
        "id": 3163,
        "ip": "172.29.114.2",
        "mac": "2012231218006904",
        "serial": "OEMT3C625BC6",
        "queue": "Plan_161903_30183_WispHub",
        "interface": "VLAN258_VALLECITO",
        "created_at": "2024-06-27T14:46:05.620085",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4845,
      "client_name": "ANGELICA MARIA MONTERO CASTILLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144568244",
      "client_email": "angelica30montero@gmail.com",
      "address": "CALLE 5 CASA NRO 327 SECTOR MATA CABALLO ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V17954334",
      "nap_box_name": "CTO-00069",
      "created_at": "2024-06-13T08:46:32.050399",
      "service_detail": {
        "id": 2859,
        "ip": "172.27.241.2",
        "mac": "TPLGF9CD4279",
        "serial": "TPLGF9CD4279",
        "queue": "Plan_161904_30183_WispHub",
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2024-06-18T14:45:32.010359",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4846,
      "client_name": "JOSE RAMON BELISARIO GARCIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04124827854",
      "client_email": "MARILENSANDIA@GMAIL.COM",
      "address": "CALLE 2 CASA NRO 62 SECTOR MATA CABALLO ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V13701444",
      "nap_box_name": "CTO-00565",
      "created_at": "2024-06-13T08:52:21.137572",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4847,
      "client_name": "ELIESER DAVID CAMARGO VELANDRIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Palma Real",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243670832",
      "client_email": "ELIESER793@GMAIL.COM",
      "address": "CALLE PRINCIPAL CASA NRO. 48 SECTOR PALMA REAL, ROSARIO DE PAYA",
      "client_identification": "V19131639",
      "nap_box_name": "CTO-00208",
      "created_at": "2024-06-13T08:53:52.068431",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4848,
      "client_name": "JORGE ANDRES ZEGHEN BARRIOS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Residencias Candys",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04244296940",
      "client_email": "JORGEZEGHEN2612@GMAIL.COM",
      "address": "CALLE RIVAS TURMERO RESIDENCIAS CANDYS EDIFICIO I PB-4 CÓDIGO POSTAL 2115",
      "client_identification": "V30005887",
      "nap_box_name": "CTO-0516",
      "created_at": "2024-06-13T08:55:13.225781",
      "service_detail": {
        "id": 12782,
        "ip": "172.27.209.2",
        "mac": "HW:TC:54:B1:2D:A3",
        "serial": "HWTC54B12DA3",
        "queue": null,
        "interface": "VLAN254_CANDYS_OLT1",
        "created_at": "2026-08-01T14:57:23.429378",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4849,
      "client_name": "LENNY JOSE AZUAJES PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Betania",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04122051950",
      "client_email": "LENNIAZUAJE2@GMAIL.COM",
      "address": "CALLE 5 CASA NRO 10 SECTOR COMUNIDAD BETANIA ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V17577232",
      "nap_box_name": "596",
      "created_at": "2024-06-13T09:15:23.366080",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4850,
      "client_name": "BELKYS DEL CARMEN RODRIGUEZ RUIZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04123137530",
      "client_email": "BELLATEAMO728@GMAIL.COM",
      "address": "CALLE 1 CASA NRO 38 SECTOR PRADOS II PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V9262055",
      "nap_box_name": "CTO-00118 DOS",
      "created_at": "2024-06-13T10:05:36.419055",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4851,
      "client_name": "YOLIMAR CAROLINA AGUILAR NAVARRO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vallecito",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124696164",
      "client_email": "YAGUILARNAVARRO3@GMAIL.COM",
      "address": "CALLE LA CEIBA CASA NRO. 04 URBANIZACIÓN COLINAS DE VALLECITO ROSARIO DE PAYA",
      "client_identification": "V19032439",
      "nap_box_name": "CTO - 84",
      "created_at": "2024-06-13T10:29:03.203787",
      "service_detail": {
        "id": 6592,
        "ip": "172.29.106.2",
        "mac": "HWTC117C8D85",
        "serial": "HWTC117C8D85",
        "queue": "Plan_161903_30183_WispHub",
        "interface": "VLAN258_VALLECITO",
        "created_at": "2024-09-10T10:33:56.678435",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4852,
      "client_name": "LUIS RAMON VILLAMIZAR RAMOS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04128902602",
      "client_email": "LUISVIRAMON@GMAIL.COM",
      "address": "CALLE 20 CASA NRO 11 URB PANTIN ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V7297575",
      "nap_box_name": "CTO-00435",
      "created_at": "2024-06-13T10:29:24.124309",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4853,
      "client_name": "JUNEIKIS ISAMAR LOPEZ TORRE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243579393",
      "client_email": "JUNEIKISLOPEZ@GMAIL.COM",
      "address": "CALLE 8 CASA 565-D URB MATA CABALLO ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V25527748",
      "nap_box_name": "CTO-00130",
      "created_at": "2024-06-13T10:39:39.576403",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4854,
      "client_name": "GLENDA NAILET CUERVO DIAZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243382841",
      "client_email": "NAILETCUERVO54@GMAIL.COM",
      "address": "CALLE 4 CASA NRO. 33 PRADO II",
      "client_identification": "V7247595",
      "nap_box_name": "CTO-00100",
      "created_at": "2024-06-13T11:09:03.099123",
      "service_detail": {
        "id": 2833,
        "ip": "172.29.111.2",
        "mac": "OEMT3C62601E",
        "serial": "OEMT3C62601E",
        "queue": "queue1",
        "interface": "VLAN242_PRADOS2",
        "created_at": "2024-06-13T12:04:52.405684",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4856,
      "client_name": "MARIA CELINA RODRIGUES VIEIRA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Las Rurales",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124618065",
      "client_email": "MAROCELY19@GMAIL.COM",
      "address": "LAS RURALES CALLE 104 CASA NRO. 36 PAYA",
      "client_identification": "V10280343",
      "nap_box_name": "492",
      "created_at": "2024-06-13T12:52:45.299128",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4857,
      "client_name": "RAFAEL ANTONIO PLAZA UZCATEGUI",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243200467",
      "client_email": "JENIMOISES18@GMAIL.COM",
      "address": "CALLE 3 CASA NRO 153 SECTOR PARCELAMIENTO 2 LUZ Y VIDA ROSARIO DE PAYA ARAGUA 2115",
      "client_identification": "V11637573",
      "nap_box_name": "CTO-00032",
      "created_at": "2024-06-13T13:39:23.894997",
      "service_detail": {
        "id": 11303,
        "ip": "172.27.169.2",
        "mac": "HWTC545F7FA3",
        "serial": "HWTC545F7FA3",
        "queue": null,
        "interface": "VLAN255_TERRAZAS_PAYA",
        "created_at": "2026-01-22T13:25:59.761901",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4858,
      "client_name": "MIGUEL DAVID ALBARRAN CARDENAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "PAUSADO_RESIDENCIAL",
      "status_name": "Pausado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Salto Angel",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04243411057",
      "client_email": "MIGUELDAVID636@GMAIL.COM",
      "address": "CALLE LOS ROBLES CASA NRO 15 URB SALTO ANGEL TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V14908636",
      "nap_box_name": "478",
      "created_at": "2024-06-13T13:54:00.640761",
      "service_detail": {
        "id": 5135,
        "ip": "172.25.176.2",
        "mac": "TPLGF9CD41D5",
        "serial": "TPLGF9CD41D5",
        "queue": "Plan_131338_24341_WispHub",
        "interface": "VLAN121_S_ANGEL",
        "created_at": "2024-08-14T17:49:47.202920",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4860,
      "client_name": "SHALOM ADONAI WR CA",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Laguna Plaza",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04144456521",
      "client_email": "SHALOMADONAIWR1311@GMAIL.COM",
      "address": "CALLE NEGRO PRIMERO EDIF 10 PISO 1 APT PH 2 URB LAGUNA PLAZA TURMERO ARAGUA ZONA POSTAL 2112",
      "client_identification": "J410741953",
      "nap_box_name": "CE - 140",
      "created_at": "2024-06-13T13:58:58.659884",
      "service_detail": {
        "id": 5773,
        "ip": "172.27.152.2",
        "mac": "HWTCC1796A9C",
        "serial": "HWTCC1796A9C",
        "queue": "Plan_147201_15811_WispHub",
        "interface": "VLAN216_LAGUNA_PLAZA_OLT1",
        "created_at": "2024-08-19T15:55:11.922512",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4861,
      "client_name": "DANNY JOSEFINA MACHADO CARRILLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243681556",
      "client_email": "DANNYMACHADO2309@GMAIL.COM",
      "address": "CALLE 4 CASA NRO 229 URB MATA CABALLO ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V15130892",
      "nap_box_name": "CTO-00265",
      "created_at": "2024-06-13T14:00:42.869244",
      "service_detail": {
        "id": 2942,
        "ip": "172.27.71.2",
        "mac": "HWTCC1999C9C",
        "serial": "HWTCC1999C9C",
        "queue": "Plan_161905_30183_WispHub",
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2024-06-20T08:20:51.724884",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4862,
      "client_name": "DANIEL ALEXANDER OLIVO OLIVO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Paya Abajo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243006880",
      "client_email": "DANIELALEXANDEROLIVO556@GMAIL.COM",
      "address": "CALLE PRINCIPAL CASA NRO S/N SECTOR PAYA ABAJO ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V29728897",
      "nap_box_name": "406",
      "created_at": "2024-06-13T14:01:25.621546",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4863,
      "client_name": "GENESSIS YAMALITH OROPEZA REQUENA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243767141",
      "client_email": "G3N3SS1S19@GMAIL.COM",
      "address": "VDA MANZANA 17 CASA # 19 SAMAN TARAZONERO 2 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V19834085",
      "nap_box_name": "504",
      "created_at": "2024-06-13T14:01:36.066343",
      "service_detail": {
        "id": 9778,
        "ip": "172.26.16.2",
        "mac": "TPLGF9CD4299",
        "serial": "TPLGF9CD4299",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2025-11-10T12:49:06.115236",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4864,
      "client_name": "ROSSELLA PATRICIA TURTULICI BOSCAN",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Marina Caribe",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04149478799",
      "client_email": "ROSSANALTB@GMAIL.COM",
      "address": "CALLE C CASA NRO23 URB MARINA CARIBE TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V12170596",
      "nap_box_name": "CTO-00029",
      "created_at": "2024-06-13T14:05:18.984041",
      "service_detail": {
        "id": 9781,
        "ip": "172.26.91.2",
        "mac": "HWTC4645799B",
        "serial": "HWTC4645799B",
        "queue": null,
        "interface": "VLAN200_OLTs",
        "created_at": "2025-11-10T12:51:40.959160",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4865,
      "client_name": "ROSA AMELIA PEDROZA NIEVES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Las Rurales",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128903359",
      "client_email": "XAVIERSALCEDO019@GMAIL.COM",
      "address": "CALLE 106 CASA NUMERO 86 A SECTOR LAS RURALES ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V12609160",
      "nap_box_name": "CTO-00200",
      "created_at": "2024-06-13T14:06:01.035781",
      "service_detail": {
        "id": 8849,
        "ip": "172.27.133.2",
        "mac": "HWTC9025039B",
        "serial": "HWTC9025039B",
        "queue": "queue1",
        "interface": "VLAN252_RURALES_PAYA",
        "created_at": "2025-06-05T12:14:26.491214",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4866,
      "client_name": "EMELY ZORIBETH MILANO GOMEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Palmeras I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144460854",
      "client_email": "MEMELY325@GMAIL.COM",
      "address": "AV1 CASA NRO 70 URB LAS PALMERAS LA JULIA EDO ARAGUA",
      "client_identification": "V23783205",
      "nap_box_name": "CTO-00226",
      "created_at": "2024-06-13T14:06:35.028092",
      "service_detail": {
        "id": 3346,
        "ip": "172.25.107.2",
        "mac": "TPLGF9CD3C34",
        "serial": "TPLGF9CD3C34",
        "queue": "Plan_131647_24341_WispHub",
        "interface": "VLAN118_PALMERAS_1",
        "created_at": "2024-07-02T16:07:48.977749",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4867,
      "client_name": "ELISABETH DEL VALLE POLANCO ROSALEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Terrazas de Paya",
      "plan": {
        "id": 43,
        "name": "RECURRENTE RESIDENCIAL PLAN 650M",
        "cost": "46.00",
        "code": "FOR650M",
        "profile": "650M/650M"
      },
      "client_mobile": "04169410068",
      "client_email": "ELISAPOLANCO08@GMAIL.COM",
      "address": "CALLE MANZANA 5 CASA NRO 02 URB TERRAZAS DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V7874237",
      "nap_box_name": "CTO-0417",
      "created_at": "2024-06-13T14:08:18.865563",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4868,
      "client_name": "YRAMA DEL VALLE RIVERO DE PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04123982116",
      "client_email": "AYMARABASTIDAS@GMAIL.COM",
      "address": "CALLE 4-A CASA NRO 10 SECTOR PANTIN ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V6083168",
      "nap_box_name": "CTO-00076 DOS",
      "created_at": "2024-06-13T14:08:57.816636",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4869,
      "client_name": "ZULAY TERESA CASTRO DE VAZQUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04140478660",
      "client_email": "ZULAYCASTRODEVAZQUEZ@GMAIL.COM",
      "address": "CALLE 9 CASA NRO 22 URB LA CASONA 1",
      "client_identification": "V13844645",
      "nap_box_name": "407",
      "created_at": "2024-06-13T14:09:17.565501",
      "service_detail": {
        "id": 9263,
        "ip": "172.25.68.2",
        "mac": "HWTC49200812",
        "serial": "HWTC49200812",
        "queue": "queue1",
        "interface": "VLAN109_CASONA_1",
        "created_at": "2025-07-26T10:06:06.912392",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4870,
      "client_name": "ONEIDA MARIA CASTILLO PARRA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Terrazas de Paya",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04125054161",
      "client_email": "ANDREINADLC19@GMAIL.COM",
      "address": "CALLE MANZANA 5 CASA NRO 11 SECTOR TERRAZAS DE PAYA ROSARIO DE PAYA ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V11273027",
      "nap_box_name": "CTO-0417",
      "created_at": "2024-06-13T14:10:53.579649",
      "service_detail": {
        "id": 11407,
        "ip": "172.27.68.2",
        "mac": "HWTCD142B09A",
        "serial": "HWTCD142B09A",
        "queue": null,
        "interface": "VLAN243_BICENTENARIO",
        "created_at": "2026-01-28T14:21:05.106533",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4871,
      "client_name": "SARAID DAYANA DIAZ LOZADA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243520613",
      "client_email": "LOZADADAYANA33@GMAIL.COM",
      "address": "AV 2 CASA NRO 513-C MATA CABALLO ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V16434901",
      "nap_box_name": "CTO-00016",
      "created_at": "2024-06-13T14:11:02.135763",
      "service_detail": {
        "id": 2936,
        "ip": "172.27.136.2",
        "mac": "HWTC901F8D9B",
        "serial": "HWTC901F8D9B",
        "queue": "Plan_161906_30183_WispHub",
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2024-06-20T07:57:10.523443",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4872,
      "client_name": "GUSTAVO NATERA GUZMAN",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona II Edificios",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243595120",
      "client_email": "NATERA.GUSTAVO@GMAIL.COM",
      "address": "URB LA CASONA 2 EDIF NRO 09 PISO 2 APTO 5 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V8819096",
      "nap_box_name": "CTO-0536",
      "created_at": "2024-06-13T14:11:48.706680",
      "service_detail": {
        "id": 5112,
        "ip": "172.25.19.2",
        "mac": "TPLGF9CD43DE",
        "serial": "TPLGF9CD43DE",
        "queue": "Plan_148293_24341_WispHub",
        "interface": "VLAN110_CASONA_2",
        "created_at": "2024-08-14T15:42:45.666818",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4873,
      "client_name": "CARLOS ALEXANDER SEQUERA APONTE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Betania",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04125230562",
      "client_email": "ALEXANDERERICK2754@GMAIL.COM",
      "address": "PARCELA 7 Y 8 GRANJA EL NARANJAL CASA #15 ROSARIO DE PAYA",
      "client_identification": "V16863531",
      "nap_box_name": "596",
      "created_at": "2024-06-13T14:12:48.189569",
      "service_detail": {
        "id": 3635,
        "ip": "172.27.141.2",
        "mac": "HWTCD6920B9C",
        "serial": "HWTCD6920B9C",
        "queue": "Plan_161905_30183_WispHub",
        "interface": "VLAN246_NARANJAL",
        "created_at": "2024-07-11T14:43:17.127834",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4874,
      "client_name": "DIEGO ARMANDO PARRA MENDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Valle Paraiso",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243228539",
      "client_email": "DIEGOEMPRESAS123@GMAIL.COM",
      "address": "APARTAMENTO NRO 5 PLANTA ALTA ALTOS DE JUAN PABLO CALLE CENTRAL VALLE PARAISO TURMERO EDO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V18662422",
      "nap_box_name": "CTO-00603",
      "created_at": "2024-06-13T14:14:28.821424",
      "service_detail": {
        "id": 5094,
        "ip": "172.27.120.2",
        "mac": "HWTCC19CBA9C",
        "serial": "HWTCC19CBA9C",
        "queue": "Plan_147201_15811_WispHub",
        "interface": "VLAN227_V_PARAISO_OLT1",
        "created_at": "2024-08-14T13:08:07.008212",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4875,
      "client_name": "EDGAR ENRIQUE MARTINEZ URBINA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121492264",
      "client_email": "EDGAR265359635@GMAIL.COM",
      "address": "CALLE URDANETA EDIF YOUSEFF PISO 1 APT 02 SECTOR CENTRO DE TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V26535963",
      "nap_box_name": "101",
      "created_at": "2024-06-13T14:15:17.379159",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4876,
      "client_name": "YOSMARI YOSPSY CISNEROS IBARRA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villa Los Tamarindos",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124981025",
      "client_email": "YOSMACISNEROS12@GMAIL.COM",
      "address": "CALLE 6 CASA 7 URB VILLA LOS TAMARINDOS TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V22942275",
      "nap_box_name": "105",
      "created_at": "2024-06-13T14:15:33.385471",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4877,
      "client_name": "ANABEL YSSAIBISS MORENO TORREALBA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villa Los Tamarindos",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243165114",
      "client_email": "ANABELMORENO360@GMAIL.COM",
      "address": "CALLE 1 CASA 12 URB. VILLA LOS TAMARINDOS EL MACARO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V13575933",
      "nap_box_name": "107",
      "created_at": "2024-06-13T14:17:56.958150",
      "service_detail": {
        "id": 5087,
        "ip": "172.27.92.2",
        "mac": "TPLGB446E896",
        "serial": "TPLGB446E896",
        "queue": "Plan_137413_1574_WispHub",
        "interface": "VLAN133_VILLA_TAMARINDOS",
        "created_at": "2024-08-14T12:41:36.646128",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4879,
      "client_name": "EXALIA YBONE MACHADO DE PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04127876776",
      "client_email": "ANDREAPEREZLKJ4@GMAIL.COM",
      "address": "CALLE 2 CASA NRO 07 URB SAMAN TARAZONERO 2 MANZANA H-8",
      "client_identification": "V17229474",
      "nap_box_name": "510 DOS",
      "created_at": "2024-06-13T14:21:09.314858",
      "service_detail": {
        "id": 11259,
        "ip": "172.24.197.2",
        "mac": "TPLGB444AD0C",
        "serial": "TPLGB444AD0C",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2026-01-20T20:58:46.575647",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4880,
      "client_name": "JOSE LUIS VIVAS ARTEAGA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villa Los Tamarindos",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128012777",
      "client_email": "JOSELUISVIVAS420@GMAIL.COM",
      "address": "CALLE 2 CASA NRO 06 URB VILLA LOS TAMARINDOS TURMERO",
      "client_identification": "V27646492",
      "nap_box_name": "556",
      "created_at": "2024-06-13T14:23:52.200019",
      "service_detail": {
        "id": 3348,
        "ip": "172.24.174.2",
        "mac": "TPLGB444B1F1",
        "serial": "TPLGB444B1F1",
        "queue": "Plan_137413_1574_WispHub",
        "interface": "VLAN133_VILLA_TAMARINDOS",
        "created_at": "2024-07-02T16:13:33.201740",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4881,
      "client_name": "INGRID YAJAIRA COROMOTO FLORES OLLALBA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121988452",
      "client_email": "rosapalmaflores@gmail.com",
      "address": "CALLE 11 CASA NRO 25 URB RIO SECO SECTOR ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V9680420",
      "nap_box_name": "608",
      "created_at": "2024-06-13T14:24:43.100680",
      "service_detail": {
        "id": 5082,
        "ip": "172.27.106.2",
        "mac": "HWTC46458B9B",
        "serial": "HWTC46458B9B",
        "queue": "Plan_161905_30183_WispHub",
        "interface": "VLAN251_RIO_SECO",
        "created_at": "2024-08-14T12:31:04.728469",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4882,
      "client_name": "YOSNEIDY SINAI LEON HERNANDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Magdalena",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243262294",
      "client_email": "YOSNEIDYLEON@GMAIL.COM",
      "address": "AV 2 CALLE 7 CASA NRO 31 BARRIO LA MAGDALENA",
      "client_identification": "V28267751",
      "nap_box_name": "627 DOS",
      "created_at": "2024-06-13T14:33:34.974159",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4883,
      "client_name": "WILFREDO JOSE BETHELMI GRATEROL",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Residencias Candys",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128649619",
      "client_email": "WJBETHELMI@GMAIL.COM",
      "address": "CALLE RIVAS EDIF DON JORGE PISO 2 APT 2 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V28430772",
      "nap_box_name": "CTO-00129 DOS",
      "created_at": "2024-06-13T14:35:41.810606",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4884,
      "client_name": "HECTOR RAFAEL POLEO GARCIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Los Hornos",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04145622244",
      "client_email": "HECTORRAFAELPOLEOGARCIA@GMAIL.COM",
      "address": "CALLE 7 CASA NRO 13 SECTOR LOS HORNOS DE PAYA ZONA POSTAL 2115",
      "client_identification": "V10270770",
      "nap_box_name": "CTO-00288",
      "created_at": "2024-06-13T14:39:39.240689",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4885,
      "client_name": "YELITZA CAROLINA RUIZ MATUTE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243644156",
      "client_email": "YELITZARUIZ394@GMAIL.COM",
      "address": "CALLE 13 CASA NRO 32 URB MATA CABALLO SECTOR PRADOS DE PAYA I TURMERO",
      "client_identification": "V16734720",
      "nap_box_name": "CTO-0370",
      "created_at": "2024-06-13T14:42:34.213456",
      "service_detail": {
        "id": 13146,
        "ip": "172.18.77.2",
        "mac": "TP:LG:B4:46:E8:A9",
        "serial": "TPLGB446E8A9",
        "queue": null,
        "interface": "VLAN239_PRADOS1",
        "created_at": "2026-10-11T12:39:41.653719",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4886,
      "client_name": "ALEXANDER ENRIQUE SANOJA BOLIVAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243038220",
      "client_email": "SSANOJA30@GMAIL.COM",
      "address": "CALLE 6 CASA NRO 386 URB MATA CABALLO ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V17986120",
      "nap_box_name": "CTO-00178",
      "created_at": "2024-06-13T14:43:13.227008",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4887,
      "client_name": "ARIANNY DARIZMAR BRACAMONTE COLMENARES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243838357",
      "client_email": "ARIANNY.BRACAMONTE3110@GMAIL.COM",
      "address": "SECTOR RIO SECO CALLE 27 CASA NRO 51 ROSARIO DE PAYA CODIGO POSTAL 2115",
      "client_identification": "V30972547",
      "nap_box_name": "CTO-00432 DOS",
      "created_at": "2024-06-13T14:43:19.871507",
      "service_detail": {
        "id": 3273,
        "ip": "172.26.110.2",
        "mac": "HWTC46309D9B",
        "serial": "HWTC46309D9B",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN251_RIO_SECO",
        "created_at": "2024-07-01T11:22:37.296506",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4888,
      "client_name": "ROXANA NAZARETH GONZALEZ RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128907284",
      "client_email": "NAZARETH27864266@GMAIL.COM",
      "address": "CALLE 2B CASA NUMERO 52 URBANISMO PANTIN ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V27864266",
      "nap_box_name": "CTO-00126",
      "created_at": "2024-06-13T14:47:22.553425",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4889,
      "client_name": "MARYURI COROMOTO CARRASCO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121776857",
      "client_email": "MARYURICARR@GMAIL.COM",
      "address": "CALLE 16-B CASA NRO 40 URB HACIENDA PANTIN ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V13575531",
      "nap_box_name": "CTO-00026",
      "created_at": "2024-06-13T14:51:58.041667",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4890,
      "client_name": "JOHANNA MARILYN CAMACHO MOROS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04143458571",
      "client_email": "JCAMACHO179@YAHOO.ES",
      "address": "CALLE CARREÑO EDIF 7 ESC-2 PISO 02 APT M03 SECTOR LOS NISPEROS",
      "client_identification": "V13907951",
      "nap_box_name": "CTO-00513",
      "created_at": "2024-06-13T14:52:39.763978",
      "service_detail": {
        "id": 5074,
        "ip": "172.24.98.2",
        "mac": "TPLGB446EB98",
        "serial": "TPLGB446EB98",
        "queue": "Plan_128612_15811_WispHub",
        "interface": "VLAN209_ZAMORA_OLT1",
        "created_at": "2024-08-14T12:15:11.245014",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4891,
      "client_name": "CANDIDA ROSA VELOZ BLANCO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128527115",
      "client_email": "CANDIDAVELOZ19@GMAIL.COM",
      "address": "CALLE 03 CASA NRO 07 SECTOR PRADOS DE PAYA I ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V7206296",
      "nap_box_name": "CTO-00061",
      "created_at": "2024-06-13T14:52:54.786960",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4893,
      "client_name": "JOSE DANIEL ALCANTARA BURGOS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Valle Verde",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243388208",
      "client_email": "ALCANTARADANYBURGOS21@GMAIL.COM",
      "address": "CALLE LOS PORTUGUESES NRO 7-A SECTOR VALLE VERDE ROSARIO DE PAYA",
      "client_identification": "V29581747",
      "nap_box_name": "597",
      "created_at": "2024-06-13T14:56:06.288539",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4894,
      "client_name": "MARIA GABRIELA VITAS PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128860128",
      "client_email": "MARIGABY1225@GMAIL.COM",
      "address": "CALLE 6 CASA 25 SECTOR LA CASONA I TURMERO",
      "client_identification": "V26192037",
      "nap_box_name": "139",
      "created_at": "2024-06-13T14:58:11.728143",
      "service_detail": {
        "id": 11789,
        "ip": "172.24.100.2",
        "mac": "TPLGB446ECEC",
        "serial": "TPLGB446ECEC",
        "queue": null,
        "interface": "VLAN109_CASONA_1",
        "created_at": "2026-02-27T11:13:39.444910",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4895,
      "client_name": "ANTONIO MARIA HENRIQUEZ SILVA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vallecito",
      "plan": {
        "id": 43,
        "name": "RECURRENTE RESIDENCIAL PLAN 650M",
        "cost": "46.00",
        "code": "FOR650M",
        "profile": "650M/650M"
      },
      "client_mobile": "04243820463",
      "client_email": "HENRIQUEZANTONIO1973@GMAIL.COM",
      "address": "ANTONIO MARIA HENRIQUEZ SILVA",
      "client_identification": "V12168940",
      "nap_box_name": "CTO-0479",
      "created_at": "2024-06-13T14:58:47.913245",
      "service_detail": {
        "id": 5037,
        "ip": "172.27.107.2",
        "mac": "HWTC906FFC9B",
        "serial": "HWTC906FFC9B",
        "queue": "Plan_161869_30181_WispHub",
        "interface": "VLAN253_VALLE_VERDE",
        "created_at": "2024-08-13T18:11:26.438148",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4896,
      "client_name": "MARTHA GRACIELA DIAZ LOPEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04145861877",
      "client_email": "MARTHAGDIAZL@GMAIL.COM",
      "address": "CALLE 14 CASA NRO 28 SECTOR LA CASONA II TURMERO",
      "client_identification": "V15805107",
      "nap_box_name": "CTO-00088",
      "created_at": "2024-06-13T15:01:07.689947",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4897,
      "client_name": "JOHNNY DEL VALLE ACOSTA MOYA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Bicentenario",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243054048",
      "client_email": "JOHNNYACOSTAMOYA@GMAIL.COM",
      "address": "ROSARIO DE PAYA CASA NRO 19 FUNDABARRIOS MANZANA 12 BICENTENARIO",
      "client_identification": "V11196330",
      "nap_box_name": "CTO-00453",
      "created_at": "2024-06-13T15:04:03.219485",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4898,
      "client_name": "ELIOVANY JOSE TORREALBA TORRES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Palmeras II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243752426",
      "client_email": "ELIOVANYTORRES.2333@GMAIL.COM",
      "address": "CALLE 02 CASA NRO 24 URB LAS PALMERAS II",
      "client_identification": "V30499296",
      "nap_box_name": "630",
      "created_at": "2024-06-13T15:06:10.668073",
      "service_detail": {
        "id": 5032,
        "ip": "172.24.130.2",
        "mac": "TPLGB444AA19",
        "serial": "TPLGB444AA19",
        "queue": "Plan_131337_24341_WispHub",
        "interface": "VLAN119_PALMERAS_2",
        "created_at": "2024-08-13T18:01:18.215663",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4899,
      "client_name": "ANGEL DE JESUS BLANCO BERMUDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243098968",
      "client_email": "CBIYANETBERMUDEZ@GMAIL.COM",
      "address": "CALLE 15 B CASA NRO 47 URB PANTIN ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V30658523",
      "nap_box_name": "CTO-00311",
      "created_at": "2024-06-13T15:06:32.586684",
      "service_detail": {
        "id": 5031,
        "ip": "172.27.119.2",
        "mac": "HWTC90ADD29B",
        "serial": "HWTC90ADD29B",
        "queue": "Plan_161903_30183_WispHub",
        "interface": "VLAN229_PANTIN",
        "created_at": "2024-08-13T17:59:29.636991",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4900,
      "client_name": "MERCEDES ELENA MARQUEZ AREVALO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Palmeras I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04125039063",
      "client_email": "MERCEDESMARQUEZ@GMAIL.COM",
      "address": "CALLE 3 CASA NRO 158 URB CONJUNTO RESIDENCIAL LAS PALMERAS I TURMERO",
      "client_identification": "V4853865",
      "nap_box_name": "440",
      "created_at": "2024-06-13T15:10:44.071307",
      "service_detail": {
        "id": 10977,
        "ip": "172.24.122.2",
        "mac": "TPLGB444A65D",
        "serial": "TPLGB444A65D",
        "queue": null,
        "interface": "VLAN118_PALMERAS_1",
        "created_at": "2025-12-27T18:30:22.943425",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4901,
      "client_name": "PEGGY ORIANA LUQUE PEDRA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243305361",
      "client_email": "ORISTUDIOJJLUQUE@GMAIL.COM",
      "address": "CALLE 2 CASA NRO 38 SECTOR PRADOS I TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V18646647",
      "nap_box_name": "CTO-00300",
      "created_at": "2024-06-13T15:11:01.899600",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4902,
      "client_name": "JOSE ALBERTO GARCIA BENAVIDES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Palma Real",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128489735",
      "client_email": "BGARCIA_JOSE@HOTMAIL.COM",
      "address": "CALLE 4 CASA 87 SECTOR PALMA REAL ROSARIO DE PAYA",
      "client_identification": "V12375674",
      "nap_box_name": "CTO-00318",
      "created_at": "2024-06-13T15:13:40.383433",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4903,
      "client_name": "LEONARDO JOSE BUSTAMANTE BRETO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124623488",
      "client_email": "ODRANOELB1998@GMAIL.COM",
      "address": "CALLE MANZANA F-1 CASA NRO 36 SECTOR SAMAN TARAZONERO II TURMERO",
      "client_identification": "V26095838",
      "nap_box_name": "162",
      "created_at": "2024-06-13T15:17:44.034128",
      "service_detail": {
        "id": 9812,
        "ip": "172.24.143.2",
        "mac": "TPLGF4EFC072",
        "serial": "TPLGF4EFC072",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2025-11-10T16:28:55.836161",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4904,
      "client_name": "NELSIRE DANIELA CASTILLO ARIAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Plaza Jardin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243465601",
      "client_email": "NELSICASTILLOARIAS@GMAIL.COM",
      "address": "CALLE LOS MANGOS CASA NRO 12-A BARRIO VILLEGUITA I TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V30327754",
      "nap_box_name": "498",
      "created_at": "2024-06-13T15:18:52.878835",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4905,
      "client_name": "KARINA MARGARITA ACOSTA MOGOLLON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Naranjal",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124425590",
      "client_email": "KARINAMARGARITA752@GMAIL.COM",
      "address": "CALLE PARCELA 7 Y 8 CASA NRO 12 SECTOR GRANJA EL NARANJAL ROSARIO DE PAYA",
      "client_identification": "V17717186",
      "nap_box_name": "596",
      "created_at": "2024-06-13T15:21:03.855743",
      "service_detail": {
        "id": 4242,
        "ip": "172.26.122.2",
        "mac": "HWTC9066E29B",
        "serial": "HWTC9066E29B",
        "queue": "Plan_161904_30183_WispHub",
        "interface": "VLAN246_NARANJAL",
        "created_at": "2024-08-07T15:06:11.318595",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4906,
      "client_name": "NEIGGEN DESIREE CONTRERAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243296458",
      "client_email": "NEIGGENC@GMAIL.COM",
      "address": "CALLE MANZANA E8 CASA NRO 05 SECTOR SAMAN TARAZONERO II TURMERO",
      "client_identification": "V12538147",
      "nap_box_name": "161 DOS",
      "created_at": "2024-06-13T15:24:07.719793",
      "service_detail": {
        "id": 5024,
        "ip": "172.24.144.2",
        "mac": "TPLGF4EFC449",
        "serial": "TPLGF4EFC449",
        "queue": "Plan_107915_1574_WispHub",
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2024-08-13T17:44:52.023533",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4907,
      "client_name": "MARYORY MILEIDY MORALES BLANCO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Paya Abajo",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04127873509",
      "client_email": "MORALESMARYORY315@GMAIL.COM",
      "address": "CALLE SAN MIGUEL CASA NRO 9 SECTOR PAYA ABAJO ZONA POSTAL 2115",
      "client_identification": "V18975315",
      "nap_box_name": "CTO-00319",
      "created_at": "2024-06-13T15:25:07.399153",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4908,
      "client_name": "FRANCISCO JAVIER LEAL MONCADA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Magdalena",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243592868",
      "client_email": "FJAVIER_LEAL@HOTMAIL.COM",
      "address": "CALLE PRIMERA TRANSVERSAL NRO 17 CASA NRO 22 URB LA MAGDALENA TURMERO",
      "client_identification": "V13320367",
      "nap_box_name": "394",
      "created_at": "2024-06-13T15:26:58.456125",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4909,
      "client_name": "COROMOTO DEL VALLE MORILLO BORGES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Terrazas de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124422024",
      "client_email": "BORGESDELVALLE28@GMAIL.COM",
      "address": "CRTA VIA PAYA CASA NRO 32-B URB TERRAZAS DE TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V11976605",
      "nap_box_name": "118",
      "created_at": "2024-06-13T15:27:10.847550",
      "service_detail": {
        "id": 5013,
        "ip": "172.26.143.2",
        "mac": "HWTCC1B0AB9C",
        "serial": "HWTCC1B0AB9C",
        "queue": "Plan_143067_15811_WispHub",
        "interface": "VLAN225_TERRAZAS_TURMERO_OLT1",
        "created_at": "2024-08-13T17:10:35.829465",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4910,
      "client_name": "ISAAC JESUS GOMES BRACAMONTE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Las Rurales",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243669845",
      "client_email": "CARRIZALESABBI@GMAIL.COM",
      "address": "CALLE SUCRE CASA NRO 43 SECTOR ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V19554348",
      "nap_box_name": "CTO-00361",
      "created_at": "2024-06-13T15:27:34.023084",
      "service_detail": {
        "id": 12626,
        "ip": "172.26.51.2",
        "mac": "HW:TC:C1:AC:F5:9C",
        "serial": "HWTCC1ACF59C",
        "queue": null,
        "interface": "VLAN252_RURALES_PAYA",
        "created_at": "2026-06-21T10:08:08.873643",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4911,
      "client_name": "OMAR MOISES OROPEZA BOLIVAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243502251",
      "client_email": "OMARMOISES1209@GMAIL.COM",
      "address": "CALLE 10-B CASA NRO 27-1 URB PANTIN ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V29728466",
      "nap_box_name": "CTO-00141",
      "created_at": "2024-06-13T15:37:00.937959",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4912,
      "client_name": "LUIGIA DAYANA GUITIERREZ CARRILLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Terrazas de Juan Pablo",
      "plan": {
        "id": 43,
        "name": "RECURRENTE RESIDENCIAL PLAN 650M",
        "cost": "46.00",
        "code": "FOR650M",
        "profile": "650M/650M"
      },
      "client_mobile": "04144742857",
      "client_email": "LUIGIAGUTIERREZ@HOTMAIL.COM",
      "address": "CALLE LA LLANERA CASA PARCELA NRO 15 CONJUNTO RESIDENCIAL TERRAZAS DE JUAN PABLO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V13355439",
      "nap_box_name": "12",
      "created_at": "2024-06-13T15:40:02.159498",
      "service_detail": {
        "id": 3982,
        "ip": "172.26.200.2",
        "mac": "HWTCD1165A9A",
        "serial": "HWTCD1165A9A",
        "queue": "Plan_142626_24341_WispHub",
        "interface": "VLAN130_TERRAZAS_JP",
        "created_at": "2024-07-17T16:31:37.653243",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4915,
      "client_name": "RAFAEL ANTONIO VEGAS MONASTERIO",
      "client_type_name": "GRATIS",
      "client_subdivision": "ACTIVO_GRATIS",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Prados I",
      "plan": {
        "id": 86,
        "name": "PLAN RECURRENTE 80M GRATIS",
        "cost": "0.00",
        "code": "FO-G80",
        "profile": "80M/80M"
      },
      "client_mobile": "04121483515",
      "client_email": "ANTONIOMONASTERIOS20@GMAIL.COM",
      "address": "AV PRINCIPAL ROSARIO DE PAYA ENTRADA LOS PRADOS JUNTA PARROQUIAL OFICINA PSUV TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V11414037",
      "nap_box_name": "237",
      "created_at": "2024-06-13T16:11:23.396711",
      "service_detail": {
        "id": 4719,
        "ip": "172.28.253.2",
        "mac": "ZICGD3E33708",
        "serial": "ZICGD3E33708",
        "queue": "Plan_162000_30183_WispHub",
        "interface": "VLAN239_PRADOS1",
        "created_at": "2024-08-12T13:04:01.469038",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4920,
      "client_name": "ALIDA YADISMIR MUJICA",
      "client_type_name": "GRATIS",
      "client_subdivision": "ACTIVO_GRATIS",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Guerito",
      "plan": {
        "id": 86,
        "name": "PLAN RECURRENTE 80M GRATIS",
        "cost": "0.00",
        "code": "FO-G80",
        "profile": "80M/80M"
      },
      "client_mobile": "04144875185",
      "client_email": "MUJICALIDA20@GMAIL.COM",
      "address": "AV INTERCOMUNAL CACHIPO NORTE CASA NRO 26 SECTOR 18 DE SEPTIEMBRE GUERITO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V13477405",
      "nap_box_name": "CE - 771",
      "created_at": "2024-06-13T17:16:15.167733",
      "service_detail": {
        "id": 11862,
        "ip": "172.26.174.2",
        "mac": "VSOL00493B01",
        "serial": "VSOL00493B01",
        "queue": null,
        "interface": "VLAN139_GUERITO",
        "created_at": "2026-02-27T20:54:13.181735",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4922,
      "client_name": "RAIZA GISELA MATOS REYES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243287099",
      "client_email": "RAIZAMATOS1966@GMAIL.COM",
      "address": "CALLE 12 EDIF TETRA PISO P/B APT 666-B MATACABALLO ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V8488555",
      "nap_box_name": "CTO-00020",
      "created_at": "2024-06-13T20:13:44.941961",
      "service_detail": {
        "id": 9647,
        "ip": "172.29.122.2",
        "mac": "OEMT3C62626E",
        "serial": "OEMT3C62626E",
        "queue": null,
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2025-10-23T10:25:18.641375",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4923,
      "client_name": "ALCALDIA DEL MUNICIPIO SANTIAGO MARIÑO",
      "client_type_name": "GRATIS",
      "client_subdivision": "ACTIVO_GRATIS",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "La Julia",
      "plan": {
        "id": 86,
        "name": "PLAN RECURRENTE 80M GRATIS",
        "cost": "0.00",
        "code": "FO-G80",
        "profile": "80M/80M"
      },
      "client_mobile": "04120296278",
      "client_email": "ADMON.ALCALDIAMARINO@GMAIL.COM",
      "address": "C. RIVAS, TURMERO 2115, ARAGUA, VENEZUELA",
      "client_identification": "G200036826",
      "nap_box_name": "Corazon de mariño",
      "created_at": "2024-06-14T08:56:34.021226",
      "service_detail": {
        "id": 4727,
        "ip": "172.30.193.2",
        "mac": "TPLGB444B0D1",
        "serial": "TPLGB444B0D1",
        "queue": "Plan_132970_24341_WispHub",
        "interface": "VLAN116_CAOBOS",
        "created_at": "2024-08-12T13:38:32.663828",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4924,
      "client_name": "ALBERTO JOSE JIMENEZ HERRERA",
      "client_type_name": "EMPLEADO",
      "client_subdivision": "CANCELADO_EMPLEADO",
      "status_name": "Cancelado",
      "cycle": 10,
      "migrate": false,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 78,
        "name": "Plan empleado 80MB",
        "cost": "0.00",
        "code": "FO-80M",
        "profile": "80M/80M"
      },
      "client_mobile": "04243529871",
      "client_email": "UNEFAALBERT91@GMAIL.COM",
      "address": "CALLE EL CENTRO CASA NRO 15 SECTOR PUEBLO NUEVO TURMERO ESTADO ARAGUA",
      "client_identification": "V18778847",
      "nap_box_name": "211",
      "created_at": "2024-06-14T08:59:58.774937",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4925,
      "client_name": "SIMONCITO GOTITAS DE AMOR",
      "client_type_name": "INTERCAMBIO",
      "client_subdivision": "ACTIVO_INTERCAMBIO",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Canaima",
      "plan": {
        "id": 83,
        "name": "RECURRENTE INSTITUCIONAL 80M",
        "cost": "0.00",
        "code": "FO-R80",
        "profile": "80M/80M"
      },
      "client_mobile": "04125987937",
      "client_email": "BRERIVAS@HOTMAIL.COM",
      "address": "URBANISMO CANAIMA CALLE 1 S/N",
      "client_identification": "V13355981",
      "nap_box_name": "CTO-00172 ",
      "created_at": "2024-06-14T09:42:36.625067",
      "service_detail": {
        "id": 6709,
        "ip": "172.29.241.2",
        "mac": "OEMT3C6261E6",
        "serial": "OEMT3C6261E6",
        "queue": "Plan_132970_30183_WispHub",
        "interface": "VLAN237_CANAIMA",
        "created_at": "2024-09-18T17:40:24.280043",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4927,
      "client_name": "CEI LUISA CACERES ARISMENDI",
      "client_type_name": "INTERCAMBIO",
      "client_subdivision": "ACTIVO_INTERCAMBIO",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 83,
        "name": "RECURRENTE INSTITUCIONAL 80M",
        "cost": "0.00",
        "code": "FO-R80",
        "profile": "80M/80M"
      },
      "client_mobile": "04121370513",
      "client_email": "CEIELUISACACERES2023@GMAIL.COM",
      "address": "CALLE 11 SECTOR RIO SECO ROSARIO DE PAYA",
      "client_identification": "J405942819",
      "nap_box_name": "608",
      "created_at": "2024-06-14T09:50:55.427164",
      "service_detail": {
        "id": 4729,
        "ip": "172.28.23.2",
        "mac": "GPON0097D796",
        "serial": "GPON0097D796",
        "queue": "Plan_162000_30183_WispHub",
        "interface": "VLAN251_RIO_SECO",
        "created_at": "2024-08-12T13:49:18.953709",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4928,
      "client_name": "EBE DR RAFAEL SEIJAS",
      "client_type_name": "INTERCAMBIO",
      "client_subdivision": "ACTIVO_INTERCAMBIO",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Las Rurales",
      "plan": {
        "id": 83,
        "name": "RECURRENTE INSTITUCIONAL 80M",
        "cost": "0.00",
        "code": "FO-R80",
        "profile": "80M/80M"
      },
      "client_mobile": "04243261720",
      "client_email": "NAIBETHCAROLINALIENDO@GMAIL.COM",
      "address": "ROSARIO DE PAYA SECFTOR LAS RURALES CALLE BOLIVAR CRUCE CON SUCRE NRO 1",
      "client_identification": "G10670511",
      "nap_box_name": "614",
      "created_at": "2024-06-14T09:53:13.524120",
      "service_detail": {
        "id": 4730,
        "ip": "172.28.21.2",
        "mac": "GPON0097CBC6",
        "serial": "GPON0097CBC6",
        "queue": "Plan_132970_30183_WispHub",
        "interface": "VLAN252_RURALES_PAYA",
        "created_at": "2024-08-12T13:52:54.479467",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4929,
      "client_name": "ELISAUL REYES",
      "client_type_name": "EMPLEADO",
      "client_subdivision": "ACTIVO_EMPLEADO",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Valle Paraiso",
      "plan": {
        "id": 78,
        "name": "Plan empleado 80MB",
        "cost": "0.00",
        "code": "FO-80M",
        "profile": "80M/80M"
      },
      "client_mobile": "04140390506",
      "client_email": "ELIREYESVE@GMAIL.COM",
      "address": "URB. VALLE PARAÍSO MANZANA 2 CASA NUMERO 2",
      "client_identification": "V12339072",
      "nap_box_name": "CTO-0642",
      "created_at": "2024-06-14T10:05:42.012056",
      "service_detail": {
        "id": 13123,
        "ip": "172.25.160.2",
        "mac": "QX:TL:CB:66:A9:EC",
        "serial": "QXTLCB66A9EC",
        "queue": null,
        "interface": "VLAN227_V_PARAISO_OLT1",
        "created_at": "2026-10-05T16:36:50.349862",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4930,
      "client_name": "ORLANY INMACULADA DOMINGUEZ QUINTANA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona II Edificios",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04244552013",
      "client_email": "ORLANYCONTABILIDAD@GMAIL.COM",
      "address": "CALLE PRINCIPAL EDIF 8 PISO 5-2 PISO 1",
      "client_identification": "V13971167",
      "nap_box_name": "CTO-0535",
      "created_at": "2024-06-14T14:55:13.063364",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4931,
      "client_name": "YOSNAN JOSE CORNIELES SEQUERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona II Edificios",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243440232",
      "client_email": "YOSNANCORNIELES13455@GMAIL.COM",
      "address": "AV INTERCOMUNAL TURMERO EDIF 15 PISO 2 APT 03 LA CASONA II",
      "client_identification": "V13455083",
      "nap_box_name": "CTO-0541",
      "created_at": "2024-06-14T14:57:00.866642",
      "service_detail": {
        "id": 11779,
        "ip": "172.22.2.2",
        "mac": "TPLGB444B17A",
        "serial": "TPLGB444B17A",
        "queue": null,
        "interface": "VLAN110_CASONA_2",
        "created_at": "2026-02-27T10:47:21.589056",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4932,
      "client_name": "SCARLET MARGARITA BLANCO RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Canaima",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04164376095",
      "client_email": "BLANCOSCARLET261@GMAIL.COM",
      "address": "CALLE 7 CASA NRO 14 URB CANAIMA ROSARIO DE PAYA",
      "client_identification": "V7248888",
      "nap_box_name": "418",
      "created_at": "2024-06-14T15:07:55.229968",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4933,
      "client_name": "ELVIRA JOSEFINA GUTIERREZ BOLIVAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Simon Bolivar",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04123353233",
      "client_email": "ELVIRAGUTIERREZ251@GMAIL.COM",
      "address": "CALLE 1 CASA NRO 14 URB SIMON BOLIVAR TURMERO",
      "client_identification": "V7231706",
      "nap_box_name": "CTO-00041",
      "created_at": "2024-06-14T15:10:04.285567",
      "service_detail": {
        "id": 9823,
        "ip": "172.23.199.2",
        "mac": "TPLGB446F579",
        "serial": "TPLGB446F579",
        "queue": null,
        "interface": "VLAN128_SIMON_BOLIVAR_ZTE",
        "created_at": "2025-11-10T17:11:42.798081",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4934,
      "client_name": "ROSALBA MALDONADO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04241632629",
      "client_email": "ROSALBAMALDONADO18@GMAIL.COM",
      "address": "AVENIDA 2 CASA NRO 518-D URB MATA CABALLO ROSARIO DE PAYA",
      "client_identification": "V14438025",
      "nap_box_name": "CTO-00457",
      "created_at": "2024-06-14T15:13:24.243382",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4935,
      "client_name": "TERESA DE JESUS DE ANDRADE VIEIRA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "SUSPENDIDO_RESIDENCIAL",
      "status_name": "Suspendido",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04140398976",
      "client_email": "TERESA.DEDEANDRADEVIEIRA@GMAIL.COM",
      "address": "CALLE 5 CASA NRO 367 URB MATA CABALLO ROSARIO DE PAYA TURMERO",
      "client_identification": "V13907028",
      "nap_box_name": "CTO-00180",
      "created_at": "2024-06-14T15:15:52.017743",
      "service_detail": {
        "id": 3781,
        "ip": "172.24.150.2",
        "mac": "TPLGF4B1DBB3",
        "serial": "TPLGF4B1DBB3",
        "queue": "Plan_161905_30183_WispHub",
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2024-07-13T16:35:37.977326",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4936,
      "client_name": "KEILIS ELIZABETH CRISTANCHO GODOY",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04127768955",
      "client_email": "KEILISCRISTANCHO18@GMAIL.COM",
      "address": "CALLE 10 CASA NRO 16 URB PANTIN ROSARIO DE PAYA TURMERO",
      "client_identification": "V25880884",
      "nap_box_name": "CTO-00141",
      "created_at": "2024-06-14T15:21:00.318616",
      "service_detail": {
        "id": 4980,
        "ip": "172.24.157.2",
        "mac": "TPLGB444A83D",
        "serial": "TPLGB444A83D",
        "queue": "Plan_161903_30183_WispHub",
        "interface": "VLAN229_PANTIN",
        "created_at": "2024-08-13T16:06:23.063771",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4937,
      "client_name": "MELITZA DEL CARMEN CARRENO REYES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243672653",
      "client_email": "MDCCRCRISTAL@GMAIL.COM",
      "address": "CALLE 17B CASA NRO 34 PANTIN ROSARIO DE PAYA",
      "client_identification": "V16256792",
      "nap_box_name": "CTO-00048",
      "created_at": "2024-06-14T15:24:08.602944",
      "service_detail": {
        "id": 4978,
        "ip": "172.24.135.2",
        "mac": "TPLGB444A930",
        "serial": "TPLGB444A930",
        "queue": "queue1",
        "interface": "VLAN229_PANTIN",
        "created_at": "2024-08-13T16:00:09.554783",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4938,
      "client_name": "BETHSABETH DARIANA USECHE TORRES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Santa Eduviges",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04127671632",
      "client_email": "DARIANAUSECHE@GMAIL.COM",
      "address": "CALLE HENRI PITTIER CASA NRO 22 SECTOR EL MACARO SANTA EDUVIGES",
      "client_identification": "V19552777",
      "nap_box_name": "173",
      "created_at": "2024-06-14T15:35:06.197275",
      "service_detail": {
        "id": 4977,
        "ip": "172.24.102.2",
        "mac": "TPLGF440F936",
        "serial": "TPLGF440F936",
        "queue": "Plan_129887_1574_WispHub",
        "interface": "VLAN127_SANTA_EDUVIGES",
        "created_at": "2024-08-13T15:56:09.693749",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4939,
      "client_name": "ZOA CAROLINA LEAL TORREYA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04120463076",
      "client_email": "ZOALEAL295@GMAIL.COM",
      "address": "SAMAN TARAZONERO II MANZANA F3 CASA NRO 7 EL MACARO",
      "client_identification": "V17253636",
      "nap_box_name": "CE - 227",
      "created_at": "2024-06-14T15:40:15.140790",
      "service_detail": {
        "id": 4973,
        "ip": "172.24.131.2",
        "mac": "TPLGB446E95D",
        "serial": "TPLGB446E95D",
        "queue": "Plan_127744_1574_WispHub",
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2024-08-13T15:48:42.045351",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4940,
      "client_name": "YESSICA JOSEFINA ESPINOZA MEZA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121486961",
      "client_email": "YESICAMEZA1213@GMAIL.COM",
      "address": "CALLE 2 CASA NRO 26 SECTOR PRADOS III ROSARIO DE PAYA",
      "client_identification": "V18851722",
      "nap_box_name": "CTO-00205 DOS",
      "created_at": "2024-06-14T15:43:01.648906",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4941,
      "client_name": "SANDRA LISBETH GARCIA BRICEÑO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Concepcion",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243666862",
      "client_email": "EJHG0714@GMAIL.COM",
      "address": "CALLE LAS PALMAS  CASA NRO 01 SECTOR LA CONCEPCION  TURMERO",
      "client_identification": "V11977762",
      "nap_box_name": "108",
      "created_at": "2024-06-14T15:51:35.172299",
      "service_detail": {
        "id": 4967,
        "ip": "172.25.24.2",
        "mac": "TPLGF4EFBFAE",
        "serial": "TPLGF4EFBFAE",
        "queue": "Plan_131338_24341_WispHub",
        "interface": "VLAN111_CONCEPCION",
        "created_at": "2024-08-13T15:30:54.023558",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4942,
      "client_name": "UEN LA CASONA II",
      "client_type_name": "INTERCAMBIO",
      "client_subdivision": "ACTIVO_INTERCAMBIO",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "La Casona II",
      "plan": {
        "id": 83,
        "name": "RECURRENTE INSTITUCIONAL 80M",
        "cost": "0.00",
        "code": "FO-R80",
        "profile": "80M/80M"
      },
      "client_mobile": "04122989240",
      "client_email": "NACAOR01@HOTMAIL.COM",
      "address": "CALLE 17 URB LA CASONA II TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "J405785764",
      "nap_box_name": "CTO-00084 DOS",
      "created_at": "2024-06-14T15:54:52.676329",
      "service_detail": {
        "id": 9829,
        "ip": "172.28.195.2",
        "mac": "HWTC07B746A1",
        "serial": "HWTC07B746A1",
        "queue": null,
        "interface": "VLAN110_CASONA_2",
        "created_at": "2025-11-10T17:24:24.910207",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4943,
      "client_name": "MARISOL GARCIA DIAZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Concepcion",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243330578",
      "client_email": "MARABI_7@HOTMAIL.COM",
      "address": "CALLE 3 CASA NRO 24 URB LA CONCEPCION TURMERO",
      "client_identification": "V9658714",
      "nap_box_name": "108",
      "created_at": "2024-06-14T15:56:28.688876",
      "service_detail": {
        "id": 4963,
        "ip": "172.24.155.2",
        "mac": "TPLGF4EFBCBF",
        "serial": "TPLGF4EFBCBF",
        "queue": "Plan_131337_24341_WispHub",
        "interface": "VLAN111_CONCEPCION",
        "created_at": "2024-08-13T15:16:09.230977",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4944,
      "client_name": "GEORGINA MARIA BALADI DI GERONIMO",
      "client_type_name": "EMPLEADO",
      "client_subdivision": "ACTIVO_EMPLEADO",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 78,
        "name": "Plan empleado 80MB",
        "cost": "0.00",
        "code": "FO-80M",
        "profile": "80M/80M"
      },
      "client_mobile": "04243585191",
      "client_email": "MARIA-DIGERONIMO@GMAIL.COM",
      "address": "CALLE RICAURTE ENTRE NEGRO PRIMERO Y CAMPO ELIAS CASA NRO 54-1 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V237874907",
      "nap_box_name": "CTO-00065",
      "created_at": "2024-06-14T16:01:22.581032",
      "service_detail": {
        "id": 12664,
        "ip": "172.28.25.2",
        "mac": "HW:TC:42:DB:D2:9E",
        "serial": "HWTC42DBD29E",
        "queue": null,
        "interface": "VLAN210_HSP_OLT1",
        "created_at": "2026-07-03T11:44:35.658095",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4946,
      "client_name": "MAICKOLL JONMIR GUERRERO DIAZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Palma Real",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243167024",
      "client_email": "MAICKOLLPOLAR@GMAIL.COM",
      "address": "URBANIZACION PALMA REAL CALLE 5 CASA NRO 76",
      "client_identification": "V28045236",
      "nap_box_name": "404",
      "created_at": "2024-06-14T16:06:49.662766",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4947,
      "client_name": "EVELIN CAROLINA INFANTE JIMENEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman de Guere",
      "plan": {
        "id": 101,
        "name": "RECURRENTE RESIDENCIAL PLAN 200M",
        "cost": "19.00",
        "code": "FOR200MB",
        "profile": "200Mbps/200Mbps"
      },
      "client_mobile": "04261365263",
      "client_email": "EVELINCIJ@GMAIL.COM",
      "address": "CALLE ALBERTO CARNIVALLI CASA NRO 88-9 BARRIO 19 DE ABRIL TURMERO LA JULIA",
      "client_identification": "V15473145",
      "nap_box_name": "464",
      "created_at": "2024-06-14T16:10:25.649651",
      "service_detail": {
        "id": 11544,
        "ip": "10.17.10.2",
        "mac": "TPLGF9CD4554",
        "serial": "TPLGF9CD4554",
        "queue": null,
        "interface": "VLAN122_SAMAN_GUERE",
        "created_at": "2026-02-07T21:54:21.367576",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4948,
      "client_name": "WILMER ALEXIS MORA PRADA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Isaac Oliveira",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04140489115",
      "client_email": "WILMORA3491@GMAIL.COM",
      "address": "CALLE 2 CASA NRO 76 URB ISAAC OLIVEIRA TURMERO",
      "client_identification": "V19777134",
      "nap_box_name": "CTO-00262",
      "created_at": "2024-06-14T16:10:40.773760",
      "service_detail": {
        "id": 11831,
        "ip": "172.24.83.2",
        "mac": "TPLGB446EE06",
        "serial": "TPLGB446EE06",
        "queue": null,
        "interface": "VLAN107_ISAAC_O",
        "created_at": "2026-02-27T11:50:20.335623",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4949,
      "client_name": "UEN HENRI PITTIER",
      "client_type_name": "INTERCAMBIO",
      "client_subdivision": "ACTIVO_INTERCAMBIO",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Canaima",
      "plan": {
        "id": 83,
        "name": "RECURRENTE INSTITUCIONAL 80M",
        "cost": "0.00",
        "code": "FO-R80",
        "profile": "80M/80M"
      },
      "client_mobile": "04128475302",
      "client_email": "HICHYTORRES11@GMAIL.COM",
      "address": "URBANISMO CANAIMA CALLE 1 S/N PARROQUIA PEDRO AREVALO APONTE",
      "client_identification": "V8732343",
      "nap_box_name": "CTO-00172 ",
      "created_at": "2024-06-14T16:12:30.642059",
      "service_detail": {
        "id": 4716,
        "ip": "10.16.93.2",
        "mac": "OEMT3C626262",
        "serial": "OEMT3C626262",
        "queue": "Plan_162000_30183_WispHub",
        "interface": "VLAN237_CANAIMA",
        "created_at": "2024-08-12T12:56:35.573065",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4950,
      "client_name": "ANTHONY JOSE DEL VALLE VILLEGAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128832766",
      "client_email": "ANTHONY07DELVALLE@GMAIL.COM",
      "address": "CALLE 15 CASA NRO 27 URB PANTIN ROSARIO DE PAYA",
      "client_identification": "V27425444",
      "nap_box_name": "CTO-00201",
      "created_at": "2024-06-14T16:13:45.921451",
      "service_detail": {
        "id": 4955,
        "ip": "172.24.105.2",
        "mac": "TPLGF4B1D8F5",
        "serial": "TPLGF4B1D8F5",
        "queue": "Plan_161903_30183_WispHub",
        "interface": "VLAN229_PANTIN",
        "created_at": "2024-08-13T15:07:24.826265",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4951,
      "client_name": "CLPP CONSEJO MUNICIPAL",
      "client_type_name": "INTERCAMBIO",
      "client_subdivision": "CANCELADO_INTERCAMBIO",
      "status_name": "Cancelado",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 83,
        "name": "RECURRENTE INSTITUCIONAL 80M",
        "cost": "0.00",
        "code": "FO-R80",
        "profile": "80M/80M"
      },
      "client_mobile": "04143475304",
      "client_email": "CMOMH@SISPROT-GLOBAL-FIBER.COM",
      "address": "CALLE MIRANDA CASCO DE TURMERO",
      "client_identification": "V144118398",
      "nap_box_name": "CAJA NAP BICENTENARIO",
      "created_at": "2024-06-14T16:14:17.841233",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4952,
      "client_name": "GRECIA JOHANA AGUILAR BRITO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04122092268",
      "client_email": "GUILLERMOANTONIOCELIS292@GMAIL.COM",
      "address": "CALLE 4-A CASA NRO 19 SECTOR PANTIN TURMERO",
      "client_identification": "V20335986",
      "nap_box_name": "CTO-00076 DOS",
      "created_at": "2024-06-14T16:15:46.079607",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4953,
      "client_name": "FREDDY JHOUSES FIDEL SOSA COLMENARES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04145891616",
      "client_email": "FREDDY_SOSA_18@HOTMAIL.COM",
      "address": "CALLE 1A CASA NRO 6 URB PANTIN ROSARIO DE PAYA",
      "client_identification": "V18646807",
      "nap_box_name": "CTO-00128",
      "created_at": "2024-06-14T16:18:26.283053",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4954,
      "client_name": "TRANSITO SAMAN DE GUERE",
      "client_type_name": "INTERCAMBIO",
      "client_subdivision": "ACTIVO_INTERCAMBIO",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 83,
        "name": "RECURRENTE INSTITUCIONAL 80M",
        "cost": "0.00",
        "code": "FO-R80",
        "profile": "80M/80M"
      },
      "client_mobile": "04243308806",
      "client_email": "CUEVASTRANSITO01@GMAIL.COM",
      "address": "AV INTERCOMUNAL SECTOR AMAN DE GUERE TURMERO",
      "client_identification": "V123456789",
      "nap_box_name": "660",
      "created_at": "2024-06-14T16:31:32.337263",
      "service_detail": {
        "id": 4731,
        "ip": "172.28.24.2",
        "mac": "HWTCD16DDC9A",
        "serial": "HWTCD16DDC9A",
        "queue": "Plan_14173_1574_WispHub",
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2024-08-12T13:56:38.057080",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4955,
      "client_name": "LUIS ELEAZAR MATUTE LUZON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Bicentenario",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243209123",
      "client_email": "CABEZADETIBURON58@GMAIL.COM",
      "address": "CALLE AVES DEL PARAISO CASA NRO 9 URB ROSARIO DE PAYA",
      "client_identification": "V3988685",
      "nap_box_name": "384",
      "created_at": "2024-06-14T16:37:17.957962",
      "service_detail": {
        "id": 4945,
        "ip": "172.24.91.2",
        "mac": "TPLGB444AC79",
        "serial": "TPLGB444AC79",
        "queue": "Plan_161903_30183_WispHub",
        "interface": "VLAN243_BICENTENARIO",
        "created_at": "2024-08-13T14:55:25.928202",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4956,
      "client_name": "FREYSSA HEVELY COROMOTO MARIN MONTEZUMA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04247556737",
      "client_email": "FREYSSAM@GMAIL.COM",
      "address": "CALLE 16 CASA NRO 33 URB LA CASONA TURMERO",
      "client_identification": "V12002678",
      "nap_box_name": "CTO-00083 DOS",
      "created_at": "2024-06-14T16:40:20.588128",
      "service_detail": {
        "id": 4929,
        "ip": "172.24.113.2",
        "mac": "TPLGB446EA8B",
        "serial": "TPLGB446EA8B",
        "queue": "Plan_131337_24341_WispHub",
        "interface": "VLAN110_CASONA_2",
        "created_at": "2024-08-13T12:14:04.382631",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4957,
      "client_name": "JONATHAN WILLIAM CARTA RIVAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Antonio Jose de Sucre",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128990907",
      "client_email": "CARTAJONATHAN1690@GMAIL.COM",
      "address": "CALLE HENRY PITTIER CASA NRO 21 URB ANTONIO JOSE DE SUCRE",
      "client_identification": "V14628655",
      "nap_box_name": "173",
      "created_at": "2024-06-14T16:48:15.897757",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4958,
      "client_name": "ILBRAIN DAVID OJEDA SANCHEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Macarena",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243033277",
      "client_email": "HEDELL94OJEDA@GMAIL.COM",
      "address": "CALLE 18B, CASA NRO 49, SECTOR URB PANTIN, TURMERO ARAGUA, ZONA POSTAL 2115",
      "client_identification": "V20758992",
      "nap_box_name": "667",
      "created_at": "2024-06-14T16:52:18.291640",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4959,
      "client_name": "JUAN JOSE GREGORIO CARVALLO YOVERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "San Sebastian",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04127779327",
      "client_email": "JUANJOSEGREGORIO20@GMAIL.COM",
      "address": "CALLE PRIMERA TRANSVERSAL CASA NRO 10 URB SAN SEBASTIAN TURMERO",
      "client_identification": "V25620144",
      "nap_box_name": "61",
      "created_at": "2024-06-14T16:59:48.622752",
      "service_detail": {
        "id": 4907,
        "ip": "172.22.205.2",
        "mac": "TPLGF4EFBDE3",
        "serial": "TPLGF4EFBDE3",
        "queue": "Plan_137413_1574_WispHub",
        "interface": "VLAN125_SAN_SEBASTIAN_ZTE",
        "created_at": "2024-08-13T10:17:53.410812",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4960,
      "client_name": "YOSET DANIEL TORREALBA TOVAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Guanarito",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128908349",
      "client_email": "XROSS0510@GMAIL.COM",
      "address": "CALLE MARGARITA RIVERO CASA NRO 02 BARRIO GUANARITO TURMERO",
      "client_identification": "V22287091",
      "nap_box_name": "216",
      "created_at": "2024-06-14T17:03:33.993931",
      "service_detail": {
        "id": 5925,
        "ip": "172.23.64.2",
        "mac": "TPLGF4EFC097",
        "serial": "TPLGF4EFC097",
        "queue": "Plan_153953_15811_WispHub",
        "interface": "VLAN232_GUANARITO_OLT2",
        "created_at": "2024-08-21T12:01:46.357174",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4961,
      "client_name": "VICTOR RAUL VARGAS CHAUSTRE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124459766",
      "client_email": "VVARGASCHAUSTRE60@GMAIL.COM",
      "address": "CALLE 16A NRO 19 PANTIN ROSARIO DE PAYA",
      "client_identification": "V6060692",
      "nap_box_name": "CTO-00195",
      "created_at": "2024-06-14T17:05:49.890851",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4962,
      "client_name": "GRIFELIN CAROLINA MILLA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Macarena",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128903607",
      "client_email": "MILLACAROLINA60@GMAIL.COM",
      "address": "CALLE 9 CASA NRO 3 LA MACARENA II SAMAN DE GUERE TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V20068034",
      "nap_box_name": "667",
      "created_at": "2024-06-14T19:19:26.394327",
      "service_detail": {
        "id": 12133,
        "ip": "172.29.129.2",
        "mac": "OEMT3C625D6A",
        "serial": "OEMT3C625D6A",
        "queue": null,
        "interface": "VLAN112_LA_MACARENA_ZTE",
        "created_at": "2026-03-18T19:05:42.770605",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4963,
      "client_name": "MARLENI JOSEFINA LOPEZ CASTILLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados III",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04263326790",
      "client_email": "RUSANYELYLOPEZ100@GMAIL.COM",
      "address": "CALLE 3 CASA NRO 15 SECTOR PRADOS III ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V12725753",
      "nap_box_name": "579 DOS",
      "created_at": "2024-06-17T08:08:16.349196",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4964,
      "client_name": "JUAN JOSE ROJAS APONTE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Payita",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04242426660",
      "client_email": "JJROJASAPONTE1@GMAIL.COM",
      "address": "PAYITA CALLE PRINCIPAL CASA NRO 4 ROSARIO DE PAYA",
      "client_identification": "V9430900",
      "nap_box_name": "Payita",
      "created_at": "2024-06-17T08:25:59.668160",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4965,
      "client_name": "YULAIMA VALENZUELA GUEVARA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243692294",
      "client_email": "YULAIMAGUEVARA@GMAIL.COM",
      "address": "CALLE 3, CASA NRO. 128 URBANIZACIÓN MATA CABALLO PAYA",
      "client_identification": "V15082303",
      "nap_box_name": "CTO-00094",
      "created_at": "2024-06-17T10:06:55.555944",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4966,
      "client_name": "SORYS ESTHER VERENZUELA  GIL",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128725283",
      "client_email": "SORYSVERENZUELA709@GMAIL.COM",
      "address": "CALLE 17-A CASA Nº 21 SECTOR PANTIN ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V9691526",
      "nap_box_name": "CTO-00101",
      "created_at": "2024-06-17T10:17:54.104254",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4967,
      "client_name": "OTILIA BEATRIZ GALLEGO CAMACHO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04166157943",
      "client_email": "OTILIAGALLEGOC@GMAIL.COM",
      "address": "CALLE MARIÑO Nº22 CASA Nº25 SECTOR EL REBOTE,CASCO CENTRAL QUINTA MI NEGRA",
      "client_identification": "V10752673",
      "nap_box_name": "CE-00009",
      "created_at": "2024-06-17T10:32:33.809437",
      "service_detail": {
        "id": 2845,
        "ip": "172.29.133.2",
        "mac": "OEMT3C625DE2",
        "serial": "OEMT3C625DE2",
        "queue": "Plan_129889_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-06-17T10:34:07.262638",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4968,
      "client_name": "INVERSIONES Y REVESTIMIENTOS BLACK & WHITE CA",
      "client_type_name": "PYME",
      "client_subdivision": "CANCELADO_PYME",
      "status_name": "Cancelado",
      "cycle": 10,
      "migrate": true,
      "sector_name": "1ro de Mayo Norte",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04140480963",
      "client_email": "EJMC0188@GMAIL.COM",
      "address": "CALLEJON MANAURE CASA NRO 24 PRIMERO DE MAYO NORTE SECTOR ROSARIO DE PAYA",
      "client_identification": "J502603727",
      "nap_box_name": "CE - 846",
      "created_at": "2024-06-17T10:42:16.738796",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4969,
      "client_name": "YORETSY SAHARAIS BLANCO MORENO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243529727",
      "client_email": "YORETSYSAHARAIS@HOTMAIL.COM",
      "address": "CALLE 2 CASA NRO. 79 MATACABALLO PAYA",
      "client_identification": "V12609637",
      "nap_box_name": "CTO-00102 DOS",
      "created_at": "2024-06-17T11:21:02.590704",
      "service_detail": {
        "id": 11671,
        "ip": "172.29.119.2",
        "mac": "OEMT3C625C7E",
        "serial": "OEMT3C625C7E",
        "queue": null,
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2026-02-18T16:18:59.990584",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4970,
      "client_name": "FRANYELIN ALEJANDRA GONZALEZ GIL",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Las Palmas",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128863515",
      "client_email": "FRANGILGO@HOTMAIL.COM",
      "address": "CALLE RAUL LEONIS CASA 07 SECTOR LAS PALMAS ROSARIO DE PAYA",
      "client_identification": "V25066771",
      "nap_box_name": "CE - 850",
      "created_at": "2024-06-17T11:33:46.599744",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4972,
      "client_name": "MARIA COROMOTO GOMEZ ROSALES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243787395",
      "client_email": "25COROMOTO25@GMAIL.COM",
      "address": "CALLE CAREÑO CON CALLE GIRALDO RESIDENCIAS GUADALUPE APT 5 TURMERO",
      "client_identification": "V13763357",
      "nap_box_name": "CTO-00590",
      "created_at": "2024-06-17T11:48:19.080523",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4974,
      "client_name": "ERICK DANIEL BLANCA GIL",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128659358",
      "client_email": "ERICKBLANCA351@GMAIL.COM",
      "address": "CALLE PRINCIPAL CASA NRO 36 SECTOR PRADOS I ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V25066294",
      "nap_box_name": "CTO-00304",
      "created_at": "2024-06-17T12:30:57.768365",
      "service_detail": {
        "id": 2852,
        "ip": "172.29.120.2",
        "mac": "OEMT3C625D62",
        "serial": "OEMT3C625D62",
        "queue": "Plan_161906_30183_WispHub",
        "interface": "VLAN239_PRADOS1",
        "created_at": "2024-06-17T12:33:05.530606",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4975,
      "client_name": "MONICA DEL CARMEN PRATO PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "1ro de Mayo Norte",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04125970669",
      "client_email": "MONICAPRATO58@GMAIL.COM",
      "address": "CALLE GUAICAIPURO CASA NRO 12 SECTOR PRIMERO DE MAYO NORTE ROSARIO DE PAYA",
      "client_identification": "V12336639",
      "nap_box_name": "CTO - 900",
      "created_at": "2024-06-17T13:14:20.315098",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4976,
      "client_name": "REINALDO JOSE GUZMAN GRANADILLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Brisas de Paya",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243106203",
      "client_email": "REYNALDOGUZMAN0809@GMAIL.COM",
      "address": "CALLE 2 CASA NRO38 SECTOR BRISAS DE PAYA",
      "client_identification": "V21252752",
      "nap_box_name": "371",
      "created_at": "2024-06-17T14:05:29.650321",
      "service_detail": {
        "id": 3078,
        "ip": "172.29.140.2",
        "mac": "OEMT3C625DD6",
        "serial": "OEMT3C625DD6",
        "queue": "Plan_161905_30183_WispHub",
        "interface": "VLAN241_BRISAS",
        "created_at": "2024-06-22T11:53:13.850708",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4978,
      "client_name": "MARIA DEL CARMEN VERA CALDERON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124479764",
      "client_email": "JOSMARYSALOME@GMAIL.COM",
      "address": "CALLE 4 CASA Nº 8 SECTOR PRADOS DE PAYA ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V17491070",
      "nap_box_name": "CTO-00100",
      "created_at": "2024-06-17T14:29:33.909983",
      "service_detail": {
        "id": 2854,
        "ip": "172.29.134.2",
        "mac": "OEMT3C626242",
        "serial": "OEMT3C626242",
        "queue": "Plan_161904_30183_WispHub",
        "interface": "VLAN242_PRADOS2",
        "created_at": "2024-06-17T16:44:49.402518",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4980,
      "client_name": "MARWIN RAFAEL BORGES SAEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243183971",
      "client_email": "BORGESMMAR@GMAIL.COM",
      "address": "MATA CABALLO C/4 #272 PAYA",
      "client_identification": "V131447210",
      "nap_box_name": "CTO-00422",
      "created_at": "2024-06-17T15:12:14.068535",
      "service_detail": {
        "id": 2891,
        "ip": "172.29.139.2",
        "mac": "OEMT3C62610E",
        "serial": "OEMT3C62610E",
        "queue": "Plan_161892_30183_WispHub",
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2024-06-19T12:03:03.995787",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4982,
      "client_name": "YELITZA MARIA ROJO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Paya Abajo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04127441297",
      "client_email": "CARLOS83MORONTA@GMAIL.COM",
      "address": "CALLE SAN MIGUEL CASA NRO 26 SECTOR PAYA ABAJO ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V17051307",
      "nap_box_name": "CTO-00024",
      "created_at": "2024-06-17T16:34:25.395634",
      "service_detail": {
        "id": 9456,
        "ip": "172.29.144.2",
        "mac": "HWTC42B80FA4",
        "serial": "HWTC42B80FA4",
        "queue": "queue1",
        "interface": "VLAN231_PAYABAJO",
        "created_at": "2025-09-01T11:57:08.651781",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4983,
      "client_name": "ANGELA DINORA PACHECO DE GUALTERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243167441",
      "client_email": "ANGELADINOPACHEHER620@GMAIL.COM",
      "address": "CALLE 6 CASA NRO 378 URB MATA CABALLO ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V14241620",
      "nap_box_name": "CTO-00178",
      "created_at": "2024-06-17T16:50:14.682898",
      "service_detail": {
        "id": 3131,
        "ip": "172.29.145.2",
        "mac": "OEMT3C6262BE",
        "serial": "OEMT3C6262BE",
        "queue": "Plan_161893_30183_WispHub",
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2024-06-27T08:44:47.374514",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4984,
      "client_name": "EDGAR ALFREDO SEPULVEDA RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villa De San Jose",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128445578",
      "client_email": "EDGOFFICIAL77@GMAIL.COM",
      "address": "CTRA NACIONAL EL MACARO CASA NRO 02-10 CONJUNTO RESIDENCIAL VILLA SAN JOSE TURMERO",
      "client_identification": "V12567592",
      "nap_box_name": "14",
      "created_at": "2024-06-17T16:50:39.389057",
      "service_detail": {
        "id": 2855,
        "ip": "172.29.124.2",
        "mac": "OEMT3C62608E",
        "serial": "OEMT3C62608E",
        "queue": "Plan_157310_1574_WispHub",
        "interface": "VLAN134_VILLAS_DSJ",
        "created_at": "2024-06-17T16:54:06.539503",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4985,
      "client_name": "YIMI JOSE DELGADO MARTÍNEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243403694",
      "client_email": "YIMIJOSEDELGADOMARTINEZ424@GMAIL.COM",
      "address": "CALLE 20 CASA NRO 24 URB PANTIN ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V16850514",
      "nap_box_name": "CTO-00435",
      "created_at": "2024-06-17T16:59:03.945221",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4986,
      "client_name": "JOSWAR ENRIQUE GUEVARA PALMA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Canaima",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128901913",
      "client_email": "JOSWARGUEVARA@GMAIL.COM",
      "address": "CALLE 6 CASA NRO 18 URB CANAIMA ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V21464034",
      "nap_box_name": "356",
      "created_at": "2024-06-17T17:34:07.070650",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4987,
      "client_name": "MIRELISTH ELIZABETH VILLEGAS RIVAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04242089183",
      "client_email": "MIRELISTH@GMAIL.COM",
      "address": "CALLE NRO. 1 CASA NRO. 08 SECTOR PRADOS, ROSARIO DE PAYA ARAGUA",
      "client_identification": "V22949163",
      "nap_box_name": "585",
      "created_at": "2024-06-18T08:11:05.508261",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4988,
      "client_name": "YENNI JOHANA ZAMORA CARUCI",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243105504",
      "client_email": "ZAMORAYENNI2@GMAIL.COM",
      "address": "AV EZEQUIEL ZAMORA # 163 SECTOR SAN MATEO",
      "client_identification": "V17727975",
      "nap_box_name": "CTO-00121",
      "created_at": "2024-06-18T10:07:49.807478",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4989,
      "client_name": "CARMEN MARIA YEPEZ VARGAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "1ro de Mayo Norte",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04127764164",
      "client_email": "YEPEZCARMEN25@GMAIL.COM",
      "address": "CALLE CHACAO, CASA NRO. 13 PRIMERO DE MAYO NORTE, PAYA",
      "client_identification": "V14296878",
      "nap_box_name": "CTO - 900",
      "created_at": "2024-06-18T11:06:31.727365",
      "service_detail": {
        "id": 2857,
        "ip": "172.29.108.2",
        "mac": "OEMT3C626176",
        "serial": "OEMT3C626176",
        "queue": "Plan_161906_30183_WispHub",
        "interface": "VLAN261_1ERO_MAYO",
        "created_at": "2024-06-18T11:14:12.380154",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4994,
      "client_name": "NELSON ROBERTO JIMENEZ AZUAJE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243603761",
      "client_email": "NELSONROBERTOJIMENEZAZUAJE@GMAIL.COM",
      "address": "CALLE 6 CASA NRO416 URB MATA CABALLO ROSARIO DE PAYA",
      "client_identification": "V15533093",
      "nap_box_name": "CTO-00031",
      "created_at": "2024-06-18T12:04:09.537051",
      "service_detail": {
        "id": 2880,
        "ip": "172.21.210.2",
        "mac": "TPLGB68B50EF",
        "serial": "TPLGB68B50EF",
        "queue": "Plan_161895_30183_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-06-18T17:57:19.077156",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4995,
      "client_name": "ALCADIA MODESTA BRICENO PARRA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Cambur",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04162010405",
      "client_email": "YENNYAVILA96@GMAIL.COM",
      "address": "EL CAMBUR, AVENIDA PRINCIPAL, CALLE LOS TRINITARIOS CASA NRO 3 ARAGUA",
      "client_identification": "V13473642",
      "nap_box_name": "CTO - 883",
      "created_at": "2024-06-18T12:20:52.905991",
      "service_detail": {
        "id": 12441,
        "ip": "172.26.50.2",
        "mac": "OEMT3C626196",
        "serial": "OEMT3C626196",
        "queue": null,
        "interface": "VLAN263_EL_CAMBUR",
        "created_at": "2026-05-01T10:10:28.557127",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4996,
      "client_name": "ABASTO MARCO GUERRERO FP",
      "client_type_name": "PYME",
      "client_subdivision": "CANCELADO_PYME",
      "status_name": "Cancelado",
      "cycle": 10,
      "migrate": true,
      "sector_name": "El Cambur",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04243649731",
      "client_email": "GARCIANORELIS33@GMAIL.COM",
      "address": "CALLE PRINCIPAL EL CAMBUR PARCELA NRO. 51 PAYA ARAGUA",
      "client_identification": "V195949308",
      "nap_box_name": "CE-00033",
      "created_at": "2024-06-18T12:28:42.462166",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4997,
      "client_name": "ROSA MARIA AGUILERA MORANTE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Cambur",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04122083793",
      "client_email": "MARIAMORANTE64@GMAIL.COM",
      "address": "CALLE LAS PALMAS SECTOR LOS APAMATES CASA NRO 6 ROSARIO DE PAYA",
      "client_identification": "V12169239",
      "nap_box_name": "CTO - 911",
      "created_at": "2024-06-18T12:57:49.309465",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 4998,
      "client_name": "DILCIA COROMOTO PIMENTEL CARRILLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Cambur",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04164296997",
      "client_email": "DILCIAPIMENTEL0412@GMAIL.COM",
      "address": "ROSARIO DE PAYA VIA PRINCIPAL LAS PALMAS SOL APAMATES CASA NRO 8",
      "client_identification": "V15962105",
      "nap_box_name": "CTO - 911",
      "created_at": "2024-06-18T13:05:42.521284",
      "service_detail": {
        "id": 2900,
        "ip": "172.19.100.2",
        "mac": "OEMT3C6260E6",
        "serial": "OEMT3C6260E6",
        "queue": "Plan_161906_30183_WispHub",
        "interface": "VLAN263_EL_CAMBUR",
        "created_at": "2024-06-19T16:10:01.194030",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 4999,
      "client_name": "ELIZABET MORALES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "1ro de Mayo Sur",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128848579",
      "client_email": "ELIOLIVO2373@GMAIL.COM",
      "address": "CALLE SAN MIGUEL CASA NRO 16  PRIMERO DE MAYO SUR",
      "client_identification": "V12608935",
      "nap_box_name": "CTO - 914",
      "created_at": "2024-06-18T13:06:00.958832",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5000,
      "client_name": "CECE MODAS CA",
      "client_type_name": "PYME",
      "client_subdivision": "CANCELADO_PYME",
      "status_name": "Cancelado",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04243313561",
      "client_email": "ELVISRAMIREZ@GMAIL.COM",
      "address": "CALLE BOLIVAR CRUCE CON CALLE PETION CC LOS MATUTES NIVEL PB LOCAL 21-02 SECTOR TURMERO",
      "client_identification": "J401235875",
      "nap_box_name": "CTO-00194",
      "created_at": "2024-06-18T13:55:40.636732",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5001,
      "client_name": "LOLA MARIA BENCOMO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados III",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128909119",
      "client_email": "LOLABENCOMO@GMAIL.COM",
      "address": "CALLE 3 CASA NRO 7 PRADOS DE PAYA III ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V10496568",
      "nap_box_name": "579",
      "created_at": "2024-06-18T14:26:54.125861",
      "service_detail": {
        "id": 3080,
        "ip": "172.29.23.2",
        "mac": "OEMT3C6256FE",
        "serial": "OEMT3C6256FE",
        "queue": "Plan_161905_30183_WispHub",
        "interface": "VLAN236_PRADOS3",
        "created_at": "2024-06-22T12:00:46.339077",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5002,
      "client_name": "BRENDA YARLIN MARIN LUCENA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Orquidea",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04165288124",
      "client_email": "BRENDAMARIN833@GMAIL.COM",
      "address": "CALLE PANCHO PEPE CROQUER CASA NRO 2F SECTOR VILLEGUITA PRADO DE PAYA LA ORQUIDEA",
      "client_identification": "V26791871",
      "nap_box_name": "CTO - 918",
      "created_at": "2024-06-18T15:15:37.498446",
      "service_detail": {
        "id": 11930,
        "ip": "172.29.151.2",
        "mac": "2012231218006554",
        "serial": "OEMT3C62564E",
        "queue": null,
        "interface": "VLAN259_LA_ORQUIDEA",
        "created_at": "2026-03-03T19:58:48.910633",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5003,
      "client_name": "LUIS DANIEL GUERRA BRITO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados III",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243755042",
      "client_email": "INDRAYGUERRAGARCIA@GMAIL.COM",
      "address": "CALLE 2 CASA NRO 14 SECTOR PRADO III ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V13482453",
      "nap_box_name": "CTO-00284 DOS",
      "created_at": "2024-06-18T15:55:35.784312",
      "service_detail": {
        "id": 2874,
        "ip": "172.29.49.2",
        "mac": "HWTC145CB6A1",
        "serial": "HWTC145CB6A1",
        "queue": "Plan_161906_30183_WispHub",
        "interface": "VLAN236_PRADOS3",
        "created_at": "2024-06-18T17:04:55.924361",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5004,
      "client_name": "INVERSIONES ROSALBA MEDINA FP",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Las Palmas",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04261392180",
      "client_email": "ROSALBAMEDINA1983@GMAIL.COM",
      "address": "CALLE JESUS MARIA REQUENA CASA NRO 32 BARRIO SAGRADO CORAZON DED JESUS ROSARIO DE PAYA ARAGUA",
      "client_identification": "V175765960",
      "nap_box_name": "CTO-00098",
      "created_at": "2024-06-18T16:26:31.370157",
      "service_detail": {
        "id": 2869,
        "ip": "172.30.68.2",
        "mac": "OEMT3C62562A",
        "serial": "OEMT3C62562A",
        "queue": "Plan_161886_30183_WispHub",
        "interface": "VLAN262_LAS_PALMAS",
        "created_at": "2024-06-18T16:42:32.917482",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5006,
      "client_name": "TAHIRA MARNIN GARCIA CASTILLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124305105",
      "client_email": "TAHIRAGARCIA@GMAIL.COM",
      "address": "CALLE 7 CASA Nº549-B URB MATA CABALLO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V15122792",
      "nap_box_name": "CTO-00073",
      "created_at": "2024-06-18T16:31:02.849653",
      "service_detail": {
        "id": 3056,
        "ip": "172.29.127.2",
        "mac": "OEMT3C625C62",
        "serial": "OEMT3C625C62",
        "queue": "Plan_161900_30183_WispHub",
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2024-06-22T10:01:40.018507",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5007,
      "client_name": "VICTOR ALEXANDER HERNANDEZ JUAREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04127760715",
      "client_email": "VICTORALEXANDERHERNANDEZ@GMAIL.COM",
      "address": "CALLE 13 CASA NRO 35 SECTOR PRADOS I DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V21443096",
      "nap_box_name": "CTO-0370",
      "created_at": "2024-06-18T16:46:32.572783",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5008,
      "client_name": "DIEGO JESUS ESPINOZA CORONA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Sector los Mangos",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243042027",
      "client_email": "DIEGOESPINOZACORONA1983@GMAIL.COM",
      "address": "CALLE SANTA EDUVIGES CASA NRO. 69 URBANIZACION VILLAS DEL SUR, TURMERO EDO. ARAGUA",
      "client_identification": "V12169234",
      "nap_box_name": "437",
      "created_at": "2024-06-18T17:36:16.427118",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5009,
      "client_name": "VICTOR MARGARITO PARRA MAY",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Cambur",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04122065771",
      "client_email": "VICTOR3108MANU@GMAIL.COM",
      "address": "CALLE PRINCIPAL CASA NRO 52 SECTOR EL CAMBUR, ROSARIO DE PAYA ARAGUA",
      "client_identification": "V14492501",
      "nap_box_name": "CTO-00150",
      "created_at": "2024-06-19T08:08:45.810610",
      "service_detail": {
        "id": 12213,
        "ip": "172.28.226.2",
        "mac": "OEMT3C62614A",
        "serial": "OEMT3C62614A",
        "queue": null,
        "interface": "VLAN263_EL_CAMBUR",
        "created_at": "2026-03-30T15:32:47.730261",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5010,
      "client_name": "ADRIANA COROMOTO PEREIRA MEJIAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Cambur",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121988578",
      "client_email": "ADRIANAPEREIRANN3@GMAIL.COM",
      "address": "CALLE PRINCIPAL CASA NRO 62 SECTOR EL CAMBUR ROSARIO DE MAYO TURMERO ARAGUA",
      "client_identification": "V20695210",
      "nap_box_name": "CTO-00150",
      "created_at": "2024-06-19T08:44:47.055686",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5011,
      "client_name": "YOLANDA REYES BOGADO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vallecito",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04149471797",
      "client_email": "MIPITOOSITO@GMAIL.COM",
      "address": "CALLE ARAGUANEY CASA NRO SECTOR COLINAS DE VALLECITO ROSARIO DE PAYA",
      "client_identification": "V8739427",
      "nap_box_name": "CTO-00115",
      "created_at": "2024-06-19T10:01:56.980812",
      "service_detail": {
        "id": 11415,
        "ip": "172.29.141.2",
        "mac": "OEMT3C625D12",
        "serial": "OEMT3C625D12",
        "queue": null,
        "interface": "VLAN258_VALLECITO",
        "created_at": "2026-01-28T20:01:48.830119",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5012,
      "client_name": "DARWIN ILDEMARO FLORES RAMOS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "1ro de Mayo Norte",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04125987110",
      "client_email": "ILDEMARORAMOS006@GMAIL.COM",
      "address": "CALLE PRINCIPAL CASA NRO 7 SECTOR VISTA ALEGRE 1ER DE MAYO NORTE ROSARIO DE PAYA",
      "client_identification": "V15364900",
      "nap_box_name": "CTO - 919",
      "created_at": "2024-06-19T13:46:48.463366",
      "service_detail": {
        "id": 3134,
        "ip": "172.29.188.2",
        "mac": "2012231218006890",
        "serial": "OEMT3C625B8E",
        "queue": "Plan_161895_30183_WispHub",
        "interface": "VLAN261_1ERO_MAYO",
        "created_at": "2024-06-27T08:56:29.217139",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5013,
      "client_name": "JOSE LUIS PINA SOLIS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vallecito",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04125970376",
      "client_email": "WORLDPIN500@GMAIL.COM",
      "address": "VALLECITO CALLE EL CUJI CASA NRO 4 ROSARIO DE PAYA",
      "client_identification": "V30499500",
      "nap_box_name": "CTO - 108",
      "created_at": "2024-06-19T14:35:18.010896",
      "service_detail": {
        "id": 3411,
        "ip": "172.30.91.2",
        "mac": "2012231218007340",
        "serial": "OEMT3C626296",
        "queue": "Plan_161905_30183_WispHub",
        "interface": "VLAN258_VALLECITO",
        "created_at": "2024-07-03T13:48:14.092292",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5014,
      "client_name": "HERICA LILIBETH VARGAS AGRAEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vallecito",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121494543",
      "client_email": "INDIANAV1104@GMAIL.COM",
      "address": "AVENIDA ROSARIO DE PAYA CASA NRO. 218 SECTOR BETANIA, ROSARIO DE PAYA ARAGUA",
      "client_identification": "V17575193",
      "nap_box_name": "CTO - 80",
      "created_at": "2024-06-19T14:50:21.845026",
      "service_detail": {
        "id": 3050,
        "ip": "172.29.148.2",
        "mac": "OEMT3C625F46",
        "serial": "OEMT3C625F46",
        "queue": "Plan_161905_30183_WispHub",
        "interface": "VLAN258_VALLECITO",
        "created_at": "2024-06-22T09:47:52.895133",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5015,
      "client_name": "FLOR MARIA RODRIGUEZ BERMUDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Terrazas de Paya",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243161337",
      "client_email": "RFLORMARIA052@GMAIL.COM",
      "address": "CALLE 02 CASA NRO. 91 SECTOR DESARROOLLO URBANISTICO LUZ Y VIDA ROSARIO DE PAYA ARAGUA",
      "client_identification": "V18702393",
      "nap_box_name": "CTO-00348",
      "created_at": "2024-06-19T15:01:09.845349",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5016,
      "client_name": "LEOMEL JUNIOR VIDAL JIMENEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Paya Abajo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04127761461",
      "client_email": "LEONEL.VIDAL.89@GMAIL.COM",
      "address": "CALLEJON SAN MIGUEL NRO 11 SECTOR PAYA ABAJO ROSARIO DE PAYA",
      "client_identification": "V19986808",
      "nap_box_name": "CTO-00024",
      "created_at": "2024-06-19T15:02:09.355253",
      "service_detail": {
        "id": 11504,
        "ip": "172.29.143.2",
        "mac": "OEMT3C625C12",
        "serial": "OEMT3C625C12",
        "queue": null,
        "interface": "VLAN229_PANTIN",
        "created_at": "2026-02-05T15:52:50.372523",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5017,
      "client_name": "CARLOS ENRIQUE FLORES GONZALEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Las Palmas",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04168225404",
      "client_email": "ZALEZFLORES54@GMAIL.COM",
      "address": "CALLE LOS APAMATES  CASA NRO 16 SECTOR LAS PALMAS",
      "client_identification": "V21464172",
      "nap_box_name": "CTO - 911",
      "created_at": "2024-06-19T15:17:27.394072",
      "service_detail": {
        "id": 3047,
        "ip": "172.29.149.2",
        "mac": "OEMT3C625C1E",
        "serial": "OEMT3C625C1E",
        "queue": "Plan_161905_30183_WispHub",
        "interface": "VLAN262_LAS_PALMAS",
        "created_at": "2024-06-22T09:44:05.378458",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5018,
      "client_name": "ALEXIS ENRIQUE TOVAR GUEVARA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "1ro de Mayo Norte",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124513896",
      "client_email": "VILLAMIZARKIMVIRLE@GMAIL.COM",
      "address": "CALLE INTERCOMUNAL CASA NRO 18 SECTOR PRIMERO DE MAYO NORTE ROSARIO DE PAYA",
      "client_identification": "V18975176",
      "nap_box_name": "CTO - 920",
      "created_at": "2024-06-19T15:36:03.055549",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5020,
      "client_name": "MIGUEL ANGEL ALONZO LARA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Brisas de Paya",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04248322199",
      "client_email": "ALONZOLARAMIGUELANGEL@GMAIL.COM",
      "address": "CALLE C-J-7 URB LOS OVEROS TURMERO ARAGUA",
      "client_identification": "V26660482",
      "nap_box_name": "370",
      "created_at": "2024-06-19T15:38:39.669955",
      "service_detail": {
        "id": 3045,
        "ip": "172.29.153.2",
        "mac": "2012231218006585",
        "serial": "OEMT3C6256CA",
        "queue": "Plan_161905_30183_WispHub",
        "interface": "VLAN241_BRISAS",
        "created_at": "2024-06-22T09:41:49.207649",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5021,
      "client_name": "LENY DAYIN GOMEZ GARCIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124227077",
      "client_email": "ALEXRUBENRODRIG12@GMAIL.COM",
      "address": "CALLE 25 CASA NRO. 23 URB HACIENDA, PANTIN ROSARIO DE PAYA ARAGUA",
      "client_identification": "V13626820",
      "nap_box_name": "CTO-00201",
      "created_at": "2024-06-19T16:04:29.240982",
      "service_detail": {
        "id": 11098,
        "ip": "172.29.154.2",
        "mac": "2012231218007196",
        "serial": "OEMT3C626056",
        "queue": null,
        "interface": "VLAN229_PANTIN",
        "created_at": "2026-01-11T16:22:55.407016",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5022,
      "client_name": "CARLOS EDUARDO YANEZ FAJARDO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243727769",
      "client_email": "YANEZCARLOS2002@GMAIL.COM",
      "address": "CALLE 5-B CASA NRO. 41 SECTOR PANTIN ROSARIO DE PAYA, ARAGUA",
      "client_identification": "V30082023",
      "nap_box_name": "CTO-00136",
      "created_at": "2024-06-19T16:21:06.155210",
      "service_detail": {
        "id": 3042,
        "ip": "172.29.155.2",
        "mac": "2012231218006560",
        "serial": "OEMT3C625666",
        "queue": "Plan_161905_30183_WispHub",
        "interface": "VLAN229_PANTIN",
        "created_at": "2024-06-22T09:39:36.602133",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5023,
      "client_name": "STEPHANY DANIELA APONCIO HERRERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "1ro de Mayo Norte",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243242122",
      "client_email": "STHEFANIAPONCIO@GMAIL.COM",
      "address": "CALLE INTERCOMUNAL S/N PRIMERO DE MAYO NORTE PAYA",
      "client_identification": "V27369806",
      "nap_box_name": "CTO - 920",
      "created_at": "2024-06-19T16:22:22.595075",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5024,
      "client_name": "ARIACNY CAROLINA ALVARADO HIDALGO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Arboleda",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121494360",
      "client_email": "ARIACNYALVARADO04@GMAIL.COM",
      "address": "CALLE LOS COCOS CASA SUR PARCELA 53 OESTE SECTOR LA ARBOLEDA ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V30498848",
      "nap_box_name": "CTO-00154",
      "created_at": "2024-06-19T17:19:59.814492",
      "service_detail": {
        "id": 2914,
        "ip": "172.29.36.2",
        "mac": "OEMT3C625DCE",
        "serial": "OEMT3C625DCE",
        "queue": "Plan_161906_30183_WispHub",
        "interface": "VLAN257_ARBOLEDA",
        "created_at": "2024-06-19T17:21:27.366107",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5026,
      "client_name": "ISABEL JESUS AFRICANO DEL VALLE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Aduana",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243553404",
      "client_email": "ISABEL_AFRICANO@HOTMAIL.COM",
      "address": "CALLE CARREÑO EDIF. CC ROSITA PISO PB LOCAL 5 SECTOR LA ADUANA, TURMERO ARAGUA",
      "client_identification": "V14547750",
      "nap_box_name": "CTO-00590",
      "created_at": "2024-06-20T09:23:30.085260",
      "service_detail": {
        "id": 12624,
        "ip": "172.29.132.2",
        "mac": "OE:MT:3C:62:60:72",
        "serial": "OEMT3C626072",
        "queue": null,
        "interface": "VLAN200_OLTs",
        "created_at": "2026-06-20T08:14:01.200672",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5027,
      "client_name": "DIEGO CERVANTES MONTILLA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243060096",
      "client_email": "DIEGOMONTILLAC11@GMAIL.COM",
      "address": "CALLE CARREÑO EDIF 8 ESCALERA 02 PISO 1 APT 3 URB LOS NISPEROS TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V27369561",
      "nap_box_name": "CTO-00513",
      "created_at": "2024-06-20T09:35:26.442032",
      "service_detail": {
        "id": 3098,
        "ip": "172.29.156.2",
        "mac": "2012231218007255",
        "serial": "OEMT3C626142",
        "queue": "queue1",
        "interface": "VLAN209_ZAMORA_OLT1",
        "created_at": "2024-06-25T12:33:37.436046",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5028,
      "client_name": "MARIA MERCEDES GUTIERREZ SOSA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Palma Real",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243504087",
      "client_email": "MARIHENLLER18@GMAIL.COM",
      "address": "CALLE MANZANA 3 CASA NRO. 04 URBANIZACION PALMA REAL ROSARIO DE PAYA ARAGUA",
      "client_identification": "V15649643",
      "nap_box_name": "CTO-00391",
      "created_at": "2024-06-20T09:50:25.473662",
      "service_detail": {
        "id": 3041,
        "ip": "172.29.157.2",
        "mac": "OEMT3C62570E",
        "serial": "OEMT3C62570E",
        "queue": "Plan_161905_30183_WispHub",
        "interface": "VLAN244_PALMAREAL",
        "created_at": "2024-06-22T09:37:22.624918",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5029,
      "client_name": "JUANA LEYDA ROMERO FLORES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Las Palmas",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121484726",
      "client_email": "ROMEROLEYDA782@GMAIL.COM",
      "address": "CALLE CALLEJON LOS APAMATES CASA NRO. 20 SECTOR LAS PALMAS, ROSARIO DE PAYA",
      "client_identification": "V13201289",
      "nap_box_name": "CTO - 916",
      "created_at": "2024-06-20T10:20:16.176378",
      "service_detail": {
        "id": 10897,
        "ip": "172.29.158.2",
        "mac": "2012231218007351",
        "serial": "OEMT3C6262C2",
        "queue": null,
        "interface": "VLAN262_LAS_PALMAS_ZTE",
        "created_at": "2025-12-23T12:48:27.475062",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5030,
      "client_name": "ALVARO LUIS CORREA TIRRE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "1ro de Mayo Sur",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124586814",
      "client_email": "ALVAROTIRRE1803@GMAIL.COM",
      "address": "CALLE 01 CASA NRO. 13 SECTOR PRIMERO DE MAYO SUR ARAGUA",
      "client_identification": "V17247285",
      "nap_box_name": "CTO-00285",
      "created_at": "2024-06-20T10:46:16.430372",
      "service_detail": {
        "id": 3097,
        "ip": "172.29.173.2",
        "mac": "2012231218007197",
        "serial": "OEMT3C62605A",
        "queue": "Plan_161905_30183_WispHub",
        "interface": "VLAN261_1ERO_MAYO",
        "created_at": "2024-06-25T12:29:34.203408",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5031,
      "client_name": "VELITZE KARINA VILLEGAS GUTIERREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Paya Abajo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121492332",
      "client_email": "VILLEGASVELITZEKARINA@GMAIL.COM",
      "address": "AV PRINCIPAL PAYA ABAJO CASA NRO. 25-1 SECTOR PAYA ROSARIO DE PAYA",
      "client_identification": "V21465544",
      "nap_box_name": "CE - 773",
      "created_at": "2024-06-20T14:48:13.040365",
      "service_detail": {
        "id": 11500,
        "ip": "172.29.168.2",
        "mac": "OEMT3C62604A",
        "serial": "OEMT3C62604A",
        "queue": null,
        "interface": "VLAN231_PAYABAJO",
        "created_at": "2026-02-05T12:22:36.822593",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5032,
      "client_name": "ISAMAR ALEXANDRA SUAREZ BRAVO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Luz y Vida",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04141472905",
      "client_email": "ISAMARSUAREZ.1@GMAIL.COM",
      "address": "CALLE 2 CASA NRO 67 BARRIO LUZ Y VIDA PAYA",
      "client_identification": "V22348095",
      "nap_box_name": "CTO-00303",
      "created_at": "2024-06-20T15:26:02.689461",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5033,
      "client_name": "JEANKARI ROJAS NIÑO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Orquidea",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04129966174",
      "client_email": "ROJASJEANKARI9@GMAIL.COM",
      "address": "CALLE 04 CASA NRO 47 SECTOR LA ORQUIDEA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V26809182",
      "nap_box_name": "CTO - 918",
      "created_at": "2024-06-20T15:56:28.724428",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5034,
      "client_name": "DAYSI DAYARI BRITO GUEVARA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Las Palmas",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "4121482832",
      "client_email": "DAYSIBRITODAYARIYAFI.1483@GMAIL.COM",
      "address": "SECTOR LAS PALMAS, CALLE CALLENA CASA NRO 28",
      "client_identification": "V16435030",
      "nap_box_name": "CTO-00098",
      "created_at": "2024-06-20T16:08:16.511543",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5035,
      "client_name": "OFELIA VALCARCEL RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Valle Fresco",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121479287",
      "client_email": "OFELIAVALCARCEL1@GMAIL.COM",
      "address": "CALLE MANZANA 2 CASA NRO 2-6 URB VALLE FRESCO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V9234746",
      "nap_box_name": "CTO - 924",
      "created_at": "2024-06-20T16:57:16.902283",
      "service_detail": {
        "id": 2971,
        "ip": "172.21.18.2",
        "mac": "OEMT3C6256C2",
        "serial": "OEMT3C6256C2",
        "queue": "Plan_92194_15811_WispHub",
        "interface": "VLAN270_VALLE_FRESCO_OLT3",
        "created_at": "2024-06-20T16:59:01.687468",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5036,
      "client_name": "MILAGROS COROMOTO MAYORCA DE DIAZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Montañita",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04149476065",
      "client_email": "CONSTRULUPAED5@GMAIL.COM",
      "address": "CALLE NEGRO PRIMERO CASA Nº38 RESIDENCIA LA MONTAÑITA TURMERO ESTADO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V7184975",
      "nap_box_name": "67",
      "created_at": "2024-06-20T16:57:23.566907",
      "service_detail": {
        "id": 3849,
        "ip": "172.30.219.2",
        "mac": "2012231218007106",
        "serial": "OEMT3C625EEE",
        "queue": "Plan_139897_15811_WispHub",
        "interface": "VLAN214_MONTANITA_OLT1",
        "created_at": "2024-07-16T13:30:08.703343",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5037,
      "client_name": "ALICIA DEL CARMEN LABASTIDAS CALLES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243425792",
      "client_email": "ALICIALA698@GMAIL.COM",
      "address": "CALLE Nº 02 CASA Nº 43 URB MATA CABALLO ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V12995698",
      "nap_box_name": "CTO-00565",
      "created_at": "2024-06-20T17:37:52.849606",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5038,
      "client_name": "AURIMAR RATTIS PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "1ro de Mayo Sur",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124565175",
      "client_email": "AURIMARRATTIS25@GMAIL.COM",
      "address": "CALLE MIGUEL RODRIGUEZ CASA NRO 21-SECTOR 1ERO DE MAYO SUR",
      "client_identification": "V18702860",
      "nap_box_name": "CTO-00285",
      "created_at": "2024-06-21T10:24:42.960843",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5039,
      "client_name": "RONALD JESUS FLORES BORGES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Paya Abajo",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243057197",
      "client_email": "RJFB32@GMAIL.COM",
      "address": "CALLE EL CENTRO CASA NRO 12 SECTOR PAYA ABAJO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V17954470",
      "nap_box_name": "271",
      "created_at": "2024-06-21T10:31:57.376031",
      "service_detail": {
        "id": 11495,
        "ip": "172.29.167.2",
        "mac": "OEMT3C625B46",
        "serial": "OEMT3C625B46",
        "queue": null,
        "interface": "VLAN229_PANTIN",
        "created_at": "2026-02-05T11:54:53.928840",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5040,
      "client_name": "ALEXANDRA YULAY SOSA CALVETE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "SUSPENDIDO_RESIDENCIAL",
      "status_name": "Suspendido",
      "cycle": 1,
      "migrate": true,
      "sector_name": "1ro de Mayo Norte",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04127292831",
      "client_email": "ZCALVETI2@GMAIL.COM",
      "address": "1ERO DE MAYO NORTE SECTOR LOS JABILLOS VEREDA N#01CASA N# B. ROSARIO DE PAYA",
      "client_identification": "V32008009",
      "nap_box_name": "CTO - 900",
      "created_at": "2024-06-21T11:19:08.248828",
      "service_detail": {
        "id": 9431,
        "ip": "172.29.186.2",
        "mac": "HWTC1A48FE88",
        "serial": "HWTC1A48FE88",
        "queue": "queue1",
        "interface": "VLAN261_1ERO_MAYO_ZTE",
        "created_at": "2025-08-26T19:58:23.149598",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5041,
      "client_name": "STEFANI YAIMAR OVALLES RIVAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "1ro de Mayo Norte",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04228155319",
      "client_email": "CAMPOSNATALIA653@GMAIL.COM",
      "address": "CALLE PRINCIPAL NRO. 3 CASA PARCELA NRO. 27 URBANIZACION URIMARE, ROSARIO DE PAYA ARAGUA",
      "client_identification": "V27286086",
      "nap_box_name": "CTO - 878",
      "created_at": "2024-06-21T11:26:26.576849",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5043,
      "client_name": "MARIA TAHIDIS LEOTA FLORES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vallecito",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04129790276",
      "client_email": "MARIALEOTAFLORES@GMAIL.COM",
      "address": "CALLE EL SAMAN CON CALLE PASAJE BAMBU CASA NRO. 3 SECTOR VALLECITO ROSARIO DE PAYA ARAGUA",
      "client_identification": "V17043570",
      "nap_box_name": "CTO - 106",
      "created_at": "2024-06-21T13:18:09.574528",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5044,
      "client_name": "GABRIEL EDUARDO RONDON REGGIO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04127612620",
      "client_email": "GABRIELEDUARDORONDONREGGIO@GMAIL.COM",
      "address": "CALLE MARIÑO NRO. 48 EDIF PLANTA ALTA PISO 1 OFICINA 2 Y 3 SECTOR CENTRO DE TURMERO ARAGUA",
      "client_identification": "V15039858",
      "nap_box_name": "CTO-00256",
      "created_at": "2024-06-21T13:36:37.538324",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5045,
      "client_name": "DANIELA ANGELICA ARRILLAGAS DEL TORO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243565092",
      "client_email": "GARCIAZOLORZANO123@GMAIL.COM",
      "address": "CALLE 1, CASA NRO. 18 URBANIZACION MATACABALLO, ROSARIO DE PAYA ARAGUA",
      "client_identification": "V23621437",
      "nap_box_name": "CTO-00131",
      "created_at": "2024-06-21T14:07:28.230197",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5046,
      "client_name": "YOLISMAR PARABABI MARTINEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "1ro de Mayo Sur",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243156731",
      "client_email": "YOLISMARPARABABI@GMAIL.COM",
      "address": "CALLE 4 CASA NRO. 3 SECTOR PRIMERO DE MAYO SUR",
      "client_identification": "V13908284",
      "nap_box_name": "CTO-00157",
      "created_at": "2024-06-21T16:58:59.571198",
      "service_detail": {
        "id": 3014,
        "ip": "172.29.104.2",
        "mac": "OEMT3C6224AE",
        "serial": "OEMT3C6224AE",
        "queue": "Plan_161906_30183_WispHub",
        "interface": "VLAN261_1ERO_MAYO",
        "created_at": "2024-06-21T17:01:06.164229",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5047,
      "client_name": "EL MANAO SPORT BAR CA",
      "client_type_name": "PYME",
      "client_subdivision": "CANCELADO_PYME",
      "status_name": "Cancelado",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 36,
        "name": "RECURRENTE PYME PLAN 650M",
        "cost": "70.18",
        "code": "FOP650M",
        "profile": "650M/650M"
      },
      "client_mobile": "04243719881",
      "client_email": "ELMANAOSPORTBAR@GMAIL.COM",
      "address": "CALLE RIVAS LOCAL SECTOR CENTRO DE TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "J504711063",
      "nap_box_name": "CTO-00129",
      "created_at": "2024-06-21T19:15:12.976162",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5048,
      "client_name": "ALIRIO DEL CARMEN MONTILLA VILLARREAL",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Terrazas de Paya",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04123491568",
      "client_email": "MONTILLAALIRIO1005@GMAIL.COM",
      "address": "CALLE 8 MANZANA 7 CASA NRO 05 SECTOR TERRAZAS DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V12550680",
      "nap_box_name": "595",
      "created_at": "2024-06-21T19:18:17.904145",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5049,
      "client_name": "UNIDAD PRODUCTIVA FAMILIAR LAS TRES A",
      "client_type_name": "PYME",
      "client_subdivision": "CANCELADO_PYME",
      "status_name": "Cancelado",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Terrazas de Paya",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04161489690",
      "client_email": "PANIFICADORASLASFLORES@GMAIL.COM",
      "address": "CALLE PPL MANZANA 3 CASA NRO 01 URBANIZACION TERRAZAS DE PAYA ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "J410532114",
      "nap_box_name": "421",
      "created_at": "2024-06-21T19:20:29.360624",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5050,
      "client_name": "GLENDA DAYANA VILLANUEVA GARCIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243571327",
      "client_email": "GARCIAVILLANUEVAGLENDADAYANA@GMAIL.COM",
      "address": "CALLE 3 CASA NUMERO 18 RIO SECO, ESTADO ARAGUA",
      "client_identification": "V130700620",
      "nap_box_name": "CTO-00385",
      "created_at": "2024-06-22T15:27:44.797088",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5052,
      "client_name": "FRANK ALEXANDER DIAZ LUNA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243512968",
      "client_email": "FD05.FD.FD@GMAIL.COM",
      "address": "CALLE CAMPO ELIAS CASA NRO 07 SECTOR CENTRO DE TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V14491270",
      "nap_box_name": "CTO-00066",
      "created_at": "2024-06-25T10:41:07.031632",
      "service_detail": {
        "id": 9725,
        "ip": "172.29.178.2",
        "mac": "OEMT3C626076",
        "serial": "OEMT3C626076",
        "queue": null,
        "interface": "VLAN200_OLTs",
        "created_at": "2025-11-10T11:11:20.076885",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5053,
      "client_name": "VIRGINIA MENDOZA GUERRA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Simon Bolivar",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04267453223",
      "client_email": "VIRGINIA110467@GMAIL.COM",
      "address": "EL MACARO, URBANISMO SIMÓN BOLÍVAR, CALLE 7 CASA #60",
      "client_identification": "V4555293",
      "nap_box_name": "CTO-00025",
      "created_at": "2024-06-25T13:44:11.040879",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5054,
      "client_name": "EDGAR ROBERTO BOLIVAR MATUTE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "1ro de Mayo Sur",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04123487931",
      "client_email": "ROBERTBOLIVAR1@GMAIL.COM",
      "address": "CALLE 05 CASA NRO. 04 URBANIZACIÓN PRIMERO DE MAYO SUR PAYA",
      "client_identification": "V13907858",
      "nap_box_name": "CTO - 867",
      "created_at": "2024-06-25T14:33:26.018093",
      "service_detail": {
        "id": 3397,
        "ip": "172.30.137.2",
        "mac": "2012231218007237",
        "serial": "OEMT3C6260FA",
        "queue": "Plan_161905_30183_WispHub",
        "interface": "VLAN261_1ERO_MAYO",
        "created_at": "2024-07-03T09:59:52.116709",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5055,
      "client_name": "JHONATHAN DAVID LEON YTURBE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villeguita",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04141461183",
      "client_email": "JHONATHANOSHUN@GMAIL.COM",
      "address": "URB. SANTIAGO MARINO, CALLE JOSE VICENTE GONZALEZ CON CALLE JOSE GREGORIO HERNANDEZ, CASA SIN NRO., SECTOR FONDO VILLEGAS, VILLEGUITA, SANTIAGO MARINO, TURMERO",
      "client_identification": "V18601963",
      "nap_box_name": "CTO - 923",
      "created_at": "2024-06-25T14:45:01.648412",
      "service_detail": {
        "id": 11624,
        "ip": "172.22.87.2",
        "mac": "GPON0097B616",
        "serial": "GPON0097B616",
        "queue": null,
        "interface": "VLAN238_VILLEGUITA",
        "created_at": "2026-02-15T15:37:54.301879",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5057,
      "client_name": "ESMERALDA TORO DE TORO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124471538",
      "client_email": "ESME08TORO@GMAIL.COM",
      "address": "CALLE 21 CASA 60, SECTOR RIO SECO PAYA",
      "client_identification": "V4384634",
      "nap_box_name": "CTO-00033",
      "created_at": "2024-06-25T16:11:22.347414",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5058,
      "client_name": "MARIA NILBELYS PINERO PENA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Paya Abajo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124244541",
      "client_email": "NILBELYSPINERO@GMAIL.COM",
      "address": "AV VÍA PRINCIPAL CASA NRO 11 SECTOR PAYA ABAJO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V20695483",
      "nap_box_name": "CE - 773",
      "created_at": "2024-06-25T16:13:05.043998",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5059,
      "client_name": "ELCER ENRIQUE PEREZ MONTANO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Luz y Vida",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121941999",
      "client_email": "ELCERPEREZ16@GMAIL.COM",
      "address": "CALLE PRINCIPAL CASA # S/N SECTOR INVASION DE LA PUENTE MATURIN MONAGAS ZONA POSTAL 6201",
      "client_identification": "V30410774",
      "nap_box_name": "CTO-0417",
      "created_at": "2024-06-25T16:22:42.658686",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5060,
      "client_name": "MARIA JOSE GARCIA VELASQUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04248270047",
      "client_email": "MARIAJOSEGARCIAVELASQUEZ02@GMAIL.COM",
      "address": "PANTIN CALLE N#3-B CASA #25",
      "client_identification": "V29931410",
      "nap_box_name": "CTO-00127",
      "created_at": "2024-06-25T16:25:04.732221",
      "service_detail": {
        "id": 3103,
        "ip": "172.29.174.2",
        "mac": "2012231218007239",
        "serial": "OEMT3C626102",
        "queue": "Plan_161905_30183_WispHub",
        "interface": "VLAN229_PANTIN",
        "created_at": "2024-06-25T17:50:33.952486",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5061,
      "client_name": "JOSE MANUEL CAMPOS IZQUIEL",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Durpa",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124347513",
      "client_email": "JOSSEDJ2@GMAIL.COM",
      "address": "CALLE 10 CASA NRO 22 URB DURPA ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V24446865",
      "nap_box_name": "CTO-00192",
      "created_at": "2024-06-25T16:37:47.639260",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5062,
      "client_name": "DEIBIS RAFAEL PEREZ SILVA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243622367",
      "client_email": "DEIBIS442@GMAIL.COM",
      "address": "PANTIN CALLE /5 CASA N#43",
      "client_identification": "V11979074",
      "nap_box_name": "CTO-00136",
      "created_at": "2024-06-25T16:39:52.379598",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5063,
      "client_name": "LOURDES NORELYS LA ROSA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04123349099",
      "client_email": "NORELISLOURDES@GMAIL.COM",
      "address": "MATACABALLO CALLE 3 N# 167",
      "client_identification": "V14052616",
      "nap_box_name": "CTO-00309",
      "created_at": "2024-06-25T16:43:51.454124",
      "service_detail": {
        "id": 3107,
        "ip": "172.29.176.2",
        "mac": "2012231218006885",
        "serial": "OEMT3C625B7A",
        "queue": "Plan_161905_30183_WispHub",
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2024-06-25T18:44:50.772046",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5064,
      "client_name": "AUTOMERCADO CASA TURMERO CA",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04141540050",
      "client_email": "ISKIA71@GMAIL.COM",
      "address": "CALLE URDANETA EDIF AUTOMERCADO CASA TURMERO PISO PB LOCAL 89 SECTOR CENTRO DE TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "J302363497",
      "nap_box_name": "25",
      "created_at": "2024-06-25T16:45:54.519278",
      "service_detail": {
        "id": 9729,
        "ip": "172.29.175.2",
        "mac": "2012231218006613",
        "serial": "OEMT3C62573A",
        "queue": null,
        "interface": "VLAN200_OLTs",
        "created_at": "2025-11-10T11:18:18.437316",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5065,
      "client_name": "YULEINY ROSARIO SANDOVAL COLMENAREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04141498398",
      "client_email": "YULESVL75@GMAIL.COM",
      "address": "MATACABALLO C/7 CASA#534D",
      "client_identification": "V19594928",
      "nap_box_name": "CTO-00310",
      "created_at": "2024-06-25T16:48:54.407378",
      "service_detail": {
        "id": 10388,
        "ip": "172.29.179.2",
        "mac": "2012231218007291",
        "serial": "OEMT3C6261D2",
        "queue": null,
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2025-11-28T15:00:11.550623",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5066,
      "client_name": "JORMARY CAROLINA BARRUETA FAGUNDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04149583380",
      "client_email": "JORMARYBARRUETA@GMAIL.COM",
      "address": "AV 2 CASA Nº 484 URB MATA CABALLO ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V17044769",
      "nap_box_name": "CTO-00222",
      "created_at": "2024-06-25T16:52:17.947824",
      "service_detail": {
        "id": 10467,
        "ip": "172.29.177.2",
        "mac": "2012231218006977",
        "serial": "OEMT3C625CEA",
        "queue": null,
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2025-12-02T12:40:10.186521",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5067,
      "client_name": "EMBAJADOR DE ORIENTE CA",
      "client_type_name": "PYME",
      "client_subdivision": "SUSPENDIDO_PYME",
      "status_name": "Suspendido",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04124655640",
      "client_email": "YULITZAGARCIA32@GMAIL.COM",
      "address": "CALLE CEDENO EDIFICIO PETRILLO LOCAL 3 SECTOR CENTRO DE TURMERO",
      "client_identification": "J315126915",
      "nap_box_name": "CTO-00203",
      "created_at": "2024-06-25T17:18:53.239840",
      "service_detail": {
        "id": 3106,
        "ip": "172.29.172.2",
        "mac": "2012231218007231",
        "serial": "OEMT3C6260E2",
        "queue": "Plan_92036_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-06-25T18:02:16.163258",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5068,
      "client_name": "VANESKY AUXILIADORA LEON MANZANILLA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "SUSPENDIDO_RESIDENCIAL",
      "status_name": "Suspendido",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Betania",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04125014591",
      "client_email": "LEONVANESKY@GMAIL.COM",
      "address": "CALLE TRANSVERSAL CASA NRO. 401 SECTOR BETANIA ROSARIO DE PAYA.",
      "client_identification": "V25880575",
      "nap_box_name": "CTO-00249",
      "created_at": "2024-06-25T17:54:17.583471",
      "service_detail": {
        "id": 12814,
        "ip": "172.29.116.2",
        "mac": "OE:MT:3C:62:57:52",
        "serial": "OEMT3C625752",
        "queue": null,
        "interface": "VLAN260_BETANIA",
        "created_at": "2026-08-09T18:12:18.157756",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5069,
      "client_name": "JEYKERT JOSE GONZALEZ GOMEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vista Hermosa",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04123418201",
      "client_email": "JEYKERTGONZALEZ@GMAIL.COM",
      "address": "CALLE ROSARIO CASA NRO. 45 BARRIO VISTA HERMOSA ROSARIO DE PAYA ARAGUA.",
      "client_identification": "V25067186",
      "nap_box_name": "CTO-00058",
      "created_at": "2024-06-26T11:17:51.406550",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5070,
      "client_name": "ROSA ELENA BRITO CASTRO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04129154984",
      "client_email": "ROSIBRI80@GMAIL.COM",
      "address": "CALLE 2 CASA NRO. 43 SECTOR PALMA REAL, ROSARIO DE PAYA, TURMERO ARAGUA.",
      "client_identification": "V28097449",
      "nap_box_name": "CTO-00180",
      "created_at": "2024-06-26T11:25:00.935140",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5071,
      "client_name": "ANETT MARIA RAMOS VERGARA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243308965",
      "client_email": "ANEIDYS25R@GMAIL.COM",
      "address": "MATACABALLO CALLE NRO. CASA 10 NRO. 629-C SECTOR ROSARIO DE PAYA.",
      "client_identification": "V14052162",
      "nap_box_name": "CTO-00143",
      "created_at": "2024-06-26T11:33:34.766476",
      "service_detail": {
        "id": 12700,
        "ip": "172.29.181.2",
        "mac": "OE:MT:3C:62:60:0E",
        "serial": "OEMT3C62600E",
        "queue": null,
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2026-07-07T13:05:28.781223",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5072,
      "client_name": "GERMAI OMAR MONTILLA CATAMO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Brisas de Paya",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04126721347",
      "client_email": "MGERMAI@YAHOO.ES",
      "address": "CALLE 3 CASA NRO. 23 SECROR LA NUEVA JULIA TURMERO ARAGUA.",
      "client_identification": "V13701200",
      "nap_box_name": "369",
      "created_at": "2024-06-26T11:41:40.909471",
      "service_detail": {
        "id": 3738,
        "ip": "172.30.114.2",
        "mac": "OEMT3C62253E",
        "serial": "OEMT3C62253E",
        "queue": "Plan_161903_30183_WispHub",
        "interface": "VLAN241_BRISAS",
        "created_at": "2024-07-12T16:22:06.297351",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5074,
      "client_name": "MARIA ANTONIETA PAGLIA MELO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "1ro de Mayo Sur",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124006253",
      "client_email": "ANTONIETA6275@GMAIL.COM",
      "address": "AV PRINCIPAL ROSARIO DE PAYA CASA NRO. 5 SECTOR PRIMERO DE MAYO SUR ARAGUA",
      "client_identification": "V15962220",
      "nap_box_name": "CE-00064",
      "created_at": "2024-06-26T12:58:42.857355",
      "service_detail": {
        "id": 3619,
        "ip": "172.29.245.2",
        "mac": "2012231218006543",
        "serial": "OEMT3C625622",
        "queue": "Plan_161905_30183_WispHub",
        "interface": "VLAN261_1ERO_MAYO",
        "created_at": "2024-07-10T17:10:22.546874",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5075,
      "client_name": "BORIS MIGUEL BRAMBLE MEJIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243145472",
      "client_email": "BORISBRAMBLE3@GMAIL.COM",
      "address": "CALLE 2, CASA NRO. 74 SECTOR MATACABALLO, ROSARIO DE PAYA",
      "client_identification": "V16538443",
      "nap_box_name": "CTO-00392",
      "created_at": "2024-06-26T13:27:05.001190",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5076,
      "client_name": "YADIRKA SINAI ACOSTA RUIZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04127312538",
      "client_email": "GARCIALEANDRO565@GMAIL.COM",
      "address": "C/16-A NRO 10 URB PANTIN",
      "client_identification": "V24173432",
      "nap_box_name": "CTO-00136",
      "created_at": "2024-06-26T15:44:50.306921",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5078,
      "client_name": "EDGAR ISAAC BOLIVAR BLANCO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Canaima",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243852844",
      "client_email": "ISAACBOLIVAR0429@GMAIL.COM",
      "address": "CANAIMA CALLE 1 CASA # 29",
      "client_identification": "V21202698",
      "nap_box_name": "CTO-00172 ",
      "created_at": "2024-06-27T08:24:04.751535",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5079,
      "client_name": "ZAIDA MAHIN RAMIREZ CHACON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Durpa",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121558023",
      "client_email": "ZAIDAMAHIN295@GMAIL.COM",
      "address": "CALLE LA ESPERANZA MANZANA 20 CASA NRO 14 DESARROLLO URBANÍSTICO ROSARIO DE PAYA TURMERO ARGUA ZONA POSTAL 2115",
      "client_identification": "V12570778",
      "nap_box_name": "376",
      "created_at": "2024-06-27T09:02:06.947277",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5080,
      "client_name": "LEOBALDO JOSE PALACIO ALVARADO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Bicentenario",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04261531401",
      "client_email": "SANDRELYALVARADO@GMAIL.COM",
      "address": "CALLE LAS AVES DEL PARAISO CASA NRO 01 SECTOR FUNDA BARRIO",
      "client_identification": "V24930900",
      "nap_box_name": "384",
      "created_at": "2024-06-27T09:09:11.498125",
      "service_detail": {
        "id": 3136,
        "ip": "172.20.243.2",
        "mac": "VSOL004914E9",
        "serial": "VSOL004914E9",
        "queue": "Plan_161891_30183_WispHub",
        "interface": "VLAN243_BICENTENARIO",
        "created_at": "2024-06-27T09:10:30.133565",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5081,
      "client_name": "APOLINAR JESUS AGUILERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "1ro de Mayo Norte",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121489656",
      "client_email": "MATILDEMILAGROS73@GMAIL.COM",
      "address": "CALLE INTERCOMUNAL CASA NRO. 61 SECTOR EL ESFUERZO ROSARIO DE PAYA ARAGUA.",
      "client_identification": "V6954974",
      "nap_box_name": "CTO - 920",
      "created_at": "2024-06-27T09:27:04.043385",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5082,
      "client_name": "MARTHA ELIZABETH COHEN IZAGUIRRE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Magdalena",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04125265648",
      "client_email": "MARTHACOHEN1302@GMAIL.COM",
      "address": "LA MAGDALENA, AV2 CALLE 9 # 52",
      "client_identification": "V5576774",
      "nap_box_name": "CTO-00185",
      "created_at": "2024-06-27T09:29:20.381722",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5083,
      "client_name": "HENRY ALBERTO DIAZ PENA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Betania",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121483246",
      "client_email": "PROFHENRYDIAZ2@GMAIL.COM",
      "address": "CALLE 02 CASA NRO 124 SECTOR OCV BETANIA ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V15302694",
      "nap_box_name": "597",
      "created_at": "2024-06-27T10:09:54.914597",
      "service_detail": {
        "id": 10129,
        "ip": "172.29.199.2",
        "mac": "OEMT3C625B56",
        "serial": "OEMT3C625B56",
        "queue": null,
        "interface": "VLAN260_BETANIA",
        "created_at": "2025-11-14T12:07:48.478611",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5084,
      "client_name": "JOSEP ALEXANDER CONTRERAS GALLEGO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121597989",
      "client_email": "JCONTRERASGALLEGO@GMAIL.COM",
      "address": "CALLE 11 CASA NRO 654-A URB MATACABALLO ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V27646386",
      "nap_box_name": "CTO-00213",
      "created_at": "2024-06-27T10:49:10.119354",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5085,
      "client_name": "MAIRA ALEJANDRA AZUAJE PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Betania",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243817332",
      "client_email": "MAYRAZUAJE39@GMAIL.COM",
      "address": "CALLE 1 CASA NRO. 1 SECTOR COMUNIDAD BETANIA ROSARIO DE PAYA.",
      "client_identification": "V18702539",
      "nap_box_name": "597",
      "created_at": "2024-06-27T10:53:59.450567",
      "service_detail": {
        "id": 10763,
        "ip": "172.29.197.2",
        "mac": "OEMT3C62622A",
        "serial": "OEMT3C62622A",
        "queue": null,
        "interface": "VLAN260_BETANIA",
        "created_at": "2025-12-17T11:02:25.458243",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5086,
      "client_name": "DALSIRETH CAROLINA PEREZ GIL",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243127842",
      "client_email": "tomasyday.22@gmail.com",
      "address": "CALLE EL ROBLE CASA NRO 09 SECTOR VALLECITO ROSARIO DE PAYA ARAGUA.",
      "client_identification": "V20056564",
      "nap_box_name": "CTO-00101",
      "created_at": "2024-06-27T11:13:07.317829",
      "service_detail": {
        "id": 12984,
        "ip": "172.29.182.2",
        "mac": "OE:MT:3C:62:5C:DA",
        "serial": "OEMT3C625CDA",
        "queue": null,
        "interface": "VLAN229_PANTIN",
        "created_at": "2026-09-05T11:47:13.554979",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5087,
      "client_name": "COMERCIAL SUPER BELLO CA",
      "client_type_name": "PYME",
      "client_subdivision": "CANCELADO_PYME",
      "status_name": "Cancelado",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04124752188",
      "client_email": "FENGMARIO219@GMAIL.COM",
      "address": "CALLE MARIÑO EDIF VIERA PISO 1 LOCAL 63-A SECTOR CENTRO TURMERO",
      "client_identification": "J310750149",
      "nap_box_name": "CTO-00256",
      "created_at": "2024-06-27T11:26:58.955512",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5088,
      "client_name": "FERNANDO JOSE HERNANDEZ PRADA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04243793198",
      "client_email": "FERNANDO.HERNANDEZ1502@GMAIL.COM",
      "address": "CALLE CAMILO TORRES EDIF LOS VIEJOS PISO 3 PH 3 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V19004685",
      "nap_box_name": "CE-00009",
      "created_at": "2024-06-27T12:38:47.155683",
      "service_detail": {
        "id": 3153,
        "ip": "172.25.177.2",
        "mac": "OEMT3C625DB2",
        "serial": "OEMT3C625DB2",
        "queue": "Plan_140304_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-06-27T12:41:09.016016",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5089,
      "client_name": "ENDER ALBERTO PEREZ RAMIREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04125798635",
      "client_email": "ENDERR258@GMAIL.COM",
      "address": "CALLE SUCRE C CALLE BOLIVAR NRO 9-A VALLE VERDE",
      "client_identification": "V27864123",
      "nap_box_name": "CTO-00408",
      "created_at": "2024-06-27T12:50:11.227083",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5090,
      "client_name": "DIEGO ALEJANDRO HERNANDEZ REQUENA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243390209",
      "client_email": "DIEGOHERNANDEZR1941@GMAIL.COM",
      "address": "CALLE NRO 15 CASA NRO 15 URBANIZACION SAMAN TARAZONERO 1 TURMERO ARAGUA",
      "client_identification": "V30264205",
      "nap_box_name": "674",
      "created_at": "2024-06-27T12:56:29.309178",
      "service_detail": {
        "id": 10700,
        "ip": "172.29.9.2",
        "mac": "OEMT3C6256FA",
        "serial": "OEMT3C6256FA",
        "queue": null,
        "interface": "VLAN140_SMT1_ZTE",
        "created_at": "2025-12-14T16:45:05.578192",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5091,
      "client_name": "MARIA MILAGROS SUAREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243397547",
      "client_email": "EGLIMAR.21100647@GMAIL.COM",
      "address": "URBANIZACION MATA CABALLO, CASA NRO 617D CALLE 10, ROSARIO DE PAYA",
      "client_identification": "V21100647",
      "nap_box_name": "CTO-00569 DOS",
      "created_at": "2024-06-27T13:02:10.701242",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5092,
      "client_name": "JOEL LIRA FARIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121408703",
      "client_email": "EXUS_GSM@HOTMAIL.COM",
      "address": "CALLE PETION, EDIFICIO LOZANO PISO 3 APTO. 5 CENTRO DE TURMERO ARAGUA.",
      "client_identification": "V14240582",
      "nap_box_name": "CTO-00194",
      "created_at": "2024-06-27T13:51:37.860557",
      "service_detail": {
        "id": 3242,
        "ip": "172.29.246.2",
        "mac": "2012231218006979",
        "serial": "OEMT3C625CF2",
        "queue": "Plan_153953_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-06-28T13:57:20.405673",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5093,
      "client_name": "ELISANGELA FAJARDO APONTE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Naranjal",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04123980936",
      "client_email": "ELISANGELAFAJARDO962@GMAIL.COM",
      "address": "CALLE GONZALEZ CASA NRO. 1 SECTOR GRANJA EL NARANJAL, ROSARIO DE PAYA ARAGUA.",
      "client_identification": "V19370255",
      "nap_box_name": "CE - 681",
      "created_at": "2024-06-27T14:12:28.919361",
      "service_detail": {
        "id": 3222,
        "ip": "172.29.194.2",
        "mac": "2012231218006576",
        "serial": "OEMT3C6256A6",
        "queue": "queue1",
        "interface": "VLAN246_NARANJAL",
        "created_at": "2024-06-28T11:19:03.531129",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5094,
      "client_name": "ANNEL FABIANA BOLIVAR PARRA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villa De San Jose",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144580149",
      "client_email": "AFABIANABOLIVARP@GMAIL.COM",
      "address": "CARRETERA NACIONAL MARACAY TURMERO URB VILLAS DE SAN JOSE CASA NRP04-11 ARAGUA ZONA POSTAL 2115",
      "client_identification": "V16128396",
      "nap_box_name": "396",
      "created_at": "2024-06-27T14:33:48.020755",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5095,
      "client_name": "MIRIAN NOHEMY RANGEL DE SEPULVEDA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Paya Abajo",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243185614",
      "client_email": "JLSD1980@GMAIL.COM",
      "address": "CALLE PRINCIPAL DE COROPO, CALLE PEDRO LEON, CASA NRO. 08 SECTOR COROPO LA MORITA, SANTA RITA ARAGUA ZONA POSTAL 2117.",
      "client_identification": "V14318277",
      "nap_box_name": "CE - 773",
      "created_at": "2024-06-27T14:56:21.596842",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5096,
      "client_name": "YORMAN INOCENCIO PEREZ RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243502398",
      "client_email": "YONYONSOU1979@GMAIL.COM",
      "address": "AVENIDA PRINCIPAL MATA CABALLO CASA NRO 679 D ROSARIO DE PAYA",
      "client_identification": "V14830652",
      "nap_box_name": "CTO-00215",
      "created_at": "2024-06-27T15:05:51.242787",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5097,
      "client_name": "ADRIANA YETSIBEL MENDOZA GUANARES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Orquidea",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04125310558",
      "client_email": "ADRIANAYMENDOZAG@GMAIL.COM",
      "address": "CALLE 1 CASA NRO 10 SECTOR LA ORQUIDEA PRADOS DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V26679774",
      "nap_box_name": "CTO-00019",
      "created_at": "2024-06-27T15:18:42.917108",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5099,
      "client_name": "ELIZABETH ALEJANDRA GOMEZ BLANDIN",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Magdalena",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121462510",
      "client_email": "ALELI7305@HOTMAIL.COM",
      "address": "CALLE 09 CASA Nº 37 SECTOR LA MAGDALENA TURMERO ESTADO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V18640012",
      "nap_box_name": "CTO-00185",
      "created_at": "2024-06-28T09:47:03.648568",
      "service_detail": {
        "id": 3307,
        "ip": "172.30.107.2",
        "mac": "OEMT3C62629A",
        "serial": "OEMT3C62629A",
        "queue": "Plan_131647_24341_WispHub",
        "interface": "VLAN114_MAGDALENA",
        "created_at": "2024-07-01T16:57:00.034253",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5100,
      "client_name": "SNAIDER ARNALDO LOMBANO ARIAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04123985539",
      "client_email": "SNAIDERLOM@GMAIL.COM",
      "address": "CALLE Nº 23 CASA Nº 34 SECTOR RIO SECO ROSARIO DE PAYA ARAGUA ZONA POSTAL 2120",
      "client_identification": "V23783498",
      "nap_box_name": "CTO-00077",
      "created_at": "2024-06-28T10:49:40.666262",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5102,
      "client_name": "YESENIA RAFAELA BRICENO MAYOR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Paya Abajo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128823478",
      "client_email": "YESI_B_M@HOTMAIL.COM",
      "address": "SECTOR PAYA ABAJO CALLE SAN ANTONIO CASA NRO. 18 ROSARIO DE PAYA ARAGUA",
      "client_identification": "V12995020",
      "nap_box_name": "271",
      "created_at": "2024-06-28T13:13:05.977718",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5103,
      "client_name": "JEANNELLYS JOHANA SIVIRA FREITEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Valle Verde",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121487994",
      "client_email": "JEANNELLYSK71SIVIRA@GMAIL.COM",
      "address": "CALLE 29 CASA NRO. 20 SECTOR RIO SECO, ROSARIO DE PAYA TURMERO ARAGUA.",
      "client_identification": "V20896377",
      "nap_box_name": "CE - 704",
      "created_at": "2024-06-28T13:27:16.531499",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5104,
      "client_name": "JESUS ALEJANDRO MARTINEZ SILVA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121598327",
      "client_email": "JAMS231296@GMAIL.COM",
      "address": "CALLE TRASOLINNI CASA NRO. 03 SECTOR CENTRO TURMERO ARAGUA.",
      "client_identification": "V26140348",
      "nap_box_name": "CTO-00147",
      "created_at": "2024-06-28T13:51:16.289283",
      "service_detail": {
        "id": 3449,
        "ip": "172.30.113.2",
        "mac": "2012231218006762",
        "serial": "OEMT3C62598E",
        "queue": "Plan_161905_30183_WispHub",
        "interface": "VLAN251_RIO_SECO",
        "created_at": "2024-07-04T16:30:17.291552",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5112,
      "client_name": "EDGLIMAR YANETH ZAPATA RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121781534",
      "client_email": "EDGLIMARZAPATA@GMAIL.COM",
      "address": "CALLE 13 CASA NRO 29 URB LA CASONA II ARAGUA ZONA POSTAL 2115",
      "client_identification": "V23432219",
      "nap_box_name": "CTO-00090",
      "created_at": "2024-06-28T16:08:24.793822",
      "service_detail": {
        "id": 12356,
        "ip": "172.19.5.2",
        "mac": "TPLGB954F79F",
        "serial": "TPLGB954F79F",
        "queue": null,
        "interface": "VLAN110_CASONA_2",
        "created_at": "2026-04-18T13:41:21.447046",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5113,
      "client_name": "MIGUEL ERNESTO MARTINEZ CEBALLOS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "4128967698",
      "client_email": "MARTINEZGABRIEL343@GMAIL.COM",
      "address": "CALLE 13 A CASA NUMERO 24 URB LOS PANTIN ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V7189982",
      "nap_box_name": "CTO-00165",
      "created_at": "2024-06-29T09:58:25.805837",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5115,
      "client_name": "EDUARDO DAVID FUENTES BARRIOS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243069830",
      "client_email": "EDFB1977@GMAIL.COM",
      "address": "CALLE CARREÑO ENTRE CALLE MARIÑO Y BOLIVAR CASA S/N TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V13115541",
      "nap_box_name": "CTO-00203",
      "created_at": "2024-06-29T14:05:08.091084",
      "service_detail": {
        "id": 12565,
        "ip": "172.25.182.2",
        "mac": "68:9f:f0:0a:f3:2f",
        "serial": "ZXICCD17FC70",
        "queue": null,
        "interface": "VLAN200_OLTs",
        "created_at": "2026-06-02T09:23:52.653728",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5116,
      "client_name": "YAMILET DEL VALLE MENDEZ OSORIO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona II Edificios",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04122074176",
      "client_email": "YAMILETMENDEZ902@GMAIL.COM",
      "address": "CALLE PRINCIPAL EDIFICIO 8 PISO 2 APT 5 URB LA CASONA II ARAGUA ZONA POSTAL 2115",
      "client_identification": "V12340519",
      "nap_box_name": "CTO-0535",
      "created_at": "2024-06-29T14:20:06.055715",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5118,
      "client_name": "DIXON JOSE HURTADO TORRES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121490670",
      "client_email": "DIXONHURTA@GMAIL.COM",
      "address": "CALLE 1 CASA NRO 8 SECTOR RIO SECO ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V18083767",
      "nap_box_name": "CTO-00385",
      "created_at": "2024-06-29T15:55:30.834513",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5119,
      "client_name": "JOSE ISAEL MARTINEZ PANTOJA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Canaima",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124614506",
      "client_email": "MARTINEZJOSE927@GMAIL.COM",
      "address": "CALLE 03, CASA NRO. 21 URBANIZACION CANAIMA ROSARIO DE PAYA ARAGUA",
      "client_identification": "V13646009",
      "nap_box_name": "CTO-00315 ",
      "created_at": "2024-07-01T08:54:49.846191",
      "service_detail": {
        "id": 3320,
        "ip": "172.30.118.2",
        "mac": "2012231218007234",
        "serial": "OEMT3C6260EE",
        "queue": "Plan_161903_30183_WispHub",
        "interface": "VLAN237_CANAIMA",
        "created_at": "2024-07-02T11:52:36.219101",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5120,
      "client_name": "YSMAEL JOSE GOMEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243210099",
      "client_email": "ANNYMG219@GMAIL.COM",
      "address": "MATACABALLO, CALLE NRO. 2 CASA NRO. 99 ROSARIO DE PAYA ARAGUA",
      "client_identification": "V15906958",
      "nap_box_name": "CTO-00102",
      "created_at": "2024-07-01T09:59:39.863152",
      "service_detail": {
        "id": 3430,
        "ip": "172.30.119.2",
        "mac": "2012231218006540",
        "serial": "OEMT3C625616",
        "queue": "Plan_161895_30183_WispHub",
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2024-07-03T17:30:43.585903",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5121,
      "client_name": "DIANA CAROLINA SILVA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243389958",
      "client_email": "GOMEMILANGELA@GMAIL.COM",
      "address": "CALLE 10 CASA NRO 633-D URB MATA CABALLO ROSARIO DE PAYA",
      "client_identification": "V23785606",
      "nap_box_name": "CTO-00431",
      "created_at": "2024-07-01T10:05:23.991852",
      "service_detail": {
        "id": 9859,
        "ip": "172.23.209.2",
        "mac": "VSOL0013B071",
        "serial": "VSOL0013B071",
        "queue": null,
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2025-11-10T18:31:17.378811",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5122,
      "client_name": "JOSE GREGORIO HIDALGO MARIN",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Durpa",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04127056143",
      "client_email": "JOSE90HIDALGO@GMAIL.COM",
      "address": "\"DURPA, MANZANA NRO. 14 CASA NRO. 16 ROSARIO DE PAYA ARAGUA",
      "client_identification": "V19277127",
      "nap_box_name": "CTO-00453",
      "created_at": "2024-07-01T10:21:50.061103",
      "service_detail": {
        "id": 12794,
        "ip": "172.30.122.2",
        "mac": "OE:MT:3C:62:56:E6",
        "serial": "OEMT3C6256E6",
        "queue": null,
        "interface": "VLAN240_DURPA",
        "created_at": "2026-08-06T11:14:17.680625",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5123,
      "client_name": "ANGEL EMILIO DIAZ DE LOS SANTOS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Dios Es Mi Refugio",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04127600305",
      "client_email": "ANGELDIAZ4028@GMAIL.COM",
      "address": "CALLE RAUL LEONI CASA NRO. 104 SECTOR LAS PALMAS ROSARIO DE PAYA ARAGUA.",
      "client_identification": "V18177755",
      "nap_box_name": "CTO-0656",
      "created_at": "2024-07-01T10:41:02.234772",
      "service_detail": {
        "id": 3755,
        "ip": "172.30.126.2",
        "mac": "OEMT3C62552E",
        "serial": "OEMT3C62552E",
        "queue": "Plan_139897_15811_WispHub",
        "interface": "VLAN271_DIOS_ES_MI_REFUGIO_OLT1",
        "created_at": "2024-07-12T17:18:41.217044",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5124,
      "client_name": "CARLOS LUIVEL TOVAR GUEVARA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "1ro de Mayo Norte",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128905479",
      "client_email": "CARLOSLUIVEL.TG@GMAIL.COM",
      "address": "CALLE PARAMACONI CASA NRO. 11 SECTOR PRIMERO DE MAYO NORTE ROSARIO DE PAYA ARAGUA",
      "client_identification": "V20334992",
      "nap_box_name": "CTO-00383",
      "created_at": "2024-07-01T10:51:25.303573",
      "service_detail": {
        "id": 11736,
        "ip": "172.30.127.2",
        "mac": "VSOL0048E539",
        "serial": "VSOL0048E539",
        "queue": null,
        "interface": "VLAN261_1ERO_MAYO_ZTE",
        "created_at": "2026-02-24T18:28:22.132902",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5125,
      "client_name": "ROSA ENEIDA TORREALBA LINARES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona II",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243272939",
      "client_email": "GG3245762@GMAIL.COM",
      "address": "CALLE 6-A CASA NRO. 8 URB LOS PANTIN ROSARIO DE PAYA ARAGUA.",
      "client_identification": "V9434615",
      "nap_box_name": "CTO-00089",
      "created_at": "2024-07-01T11:17:31.821761",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5126,
      "client_name": "ANDRES FELIPE PERDOMO CONTRERAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Los Hornos",
      "plan": {
        "id": 43,
        "name": "RECURRENTE RESIDENCIAL PLAN 650M",
        "cost": "46.00",
        "code": "FOR650M",
        "profile": "650M/650M"
      },
      "client_mobile": "04120475466",
      "client_email": "CELIACONTRERAS2710@GMAIL.COM",
      "address": "CALLE 06 CASA NRO. 12 SECTOR PRADOS DE PAYA ROSARIO DE PAYA ARAGUA.",
      "client_identification": "V21466485",
      "nap_box_name": "CE-00048",
      "created_at": "2024-07-01T11:38:48.376229",
      "service_detail": {
        "id": 12117,
        "ip": "172.30.120.2",
        "mac": "2012231218007277",
        "serial": "OEMT3C62619A",
        "queue": null,
        "interface": "VLAN247_HORNOS",
        "created_at": "2026-03-18T10:24:42.425034",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5127,
      "client_name": "YESICA YONASKI RIVAS SILVA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "SUSPENDIDO_RESIDENCIAL",
      "status_name": "Suspendido",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vallecito",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04127760807",
      "client_email": "YESICARIVASSILVA3@GMAIL.COM",
      "address": "CALLE ARAGUANEY CALLEJON LAS PIÑAS CASA NRO 6 SECTOR VALLECITO ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V25067348",
      "nap_box_name": "CTO - 110",
      "created_at": "2024-07-01T11:47:12.355693",
      "service_detail": {
        "id": 11245,
        "ip": "172.30.128.2",
        "mac": "HWTCFA248A48",
        "serial": "HWTCFA248A48",
        "queue": null,
        "interface": "VLAN258_VALLECITO",
        "created_at": "2026-01-20T17:34:20.915430",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5128,
      "client_name": "JEAN KEILER GOMEZ FERNANDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04247837919",
      "client_email": "JEANKEILERGREGORIO@GMAIL.COM",
      "address": "CALLE 27 CASA NRO. 21 SECTOR RIO SECO ROSARIO DE PAYA ARAGUA",
      "client_identification": "V26535113",
      "nap_box_name": "472",
      "created_at": "2024-07-01T11:54:59.395810",
      "service_detail": {
        "id": 3621,
        "ip": "172.30.129.2",
        "mac": "HWTC22B64286",
        "serial": "HWTC22B64286",
        "queue": "Plan_161905_30183_WispHub",
        "interface": "VLAN251_RIO_SECO",
        "created_at": "2024-07-10T18:48:25.538376",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5129,
      "client_name": "RONNY RENE GARCIA REYES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Valle del Rosario",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128861359",
      "client_email": "GRACIARONNY404@GMAIL.COM",
      "address": "CALLE CASANOVA GODOY CASA NRO 21 URB VALLE DEL ROSARIO",
      "client_identification": "V29921722",
      "nap_box_name": "299",
      "created_at": "2024-07-01T15:41:18.956621",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5130,
      "client_name": "EMBOTELLADORA EL SAMAN CA",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Saman de Guere",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04144567507",
      "client_email": "VENTASAGUAELSAMAN@GMAIL.COM",
      "address": "CALLE  LOS NARANJOS C/C CAYENAS  CASA PARCELA NRO 10  SECTOR  SAMAN DE GUERE TURMERO",
      "client_identification": "J075388690",
      "nap_box_name": "290",
      "created_at": "2024-07-02T08:28:32.816173",
      "service_detail": {
        "id": 4091,
        "ip": "172.19.133.2",
        "mac": "TPLG1BB3646F",
        "serial": "TPLG1BB3646F",
        "queue": "Plan_133131_24341_WispHub",
        "interface": "VLAN500_PUBLICAS_CLIENTES",
        "created_at": "2024-07-22T16:05:52.735878",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5131,
      "client_name": "FRANCIA EMPERATRIZ PEREZ CHIRINOS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "1ro de Mayo Sur",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04125989249",
      "client_email": "FRANCIAPEREZCH29@GMAIL.COM",
      "address": "CALLE LA ORQUIDEA CASA NRO 136 SECTOR PRIMERO DE MAYO SUR ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V18702871",
      "nap_box_name": "CTO - 914",
      "created_at": "2024-07-02T10:30:39.327003",
      "service_detail": {
        "id": 3633,
        "ip": "172.30.130.2",
        "mac": "2012231218006729",
        "serial": "OEMT3C62590A",
        "queue": "Plan_161905_30183_WispHub",
        "interface": "VLAN261_1ERO_MAYO",
        "created_at": "2024-07-11T13:20:13.772776",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5132,
      "client_name": "LAURA CECILIA YANES ESCALONA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Antigua Hacienda De Paya",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04144294640",
      "client_email": "YANESLAURA@GMAIL.COM",
      "address": "CALLE LOS CEDROS CASA NRO 10 URB ANTIGUA HACIENDA DE PAYA",
      "client_identification": "V18176405",
      "nap_box_name": "CTO-00218 ",
      "created_at": "2024-07-02T13:17:51.271703",
      "service_detail": {
        "id": 9412,
        "ip": "172.22.123.2",
        "mac": "TPLGBA68774B",
        "serial": "TPLGBA68774B",
        "queue": "queue1",
        "interface": "VLAN201_AHP2_OLT1",
        "created_at": "2025-08-22T09:01:42.827632",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5133,
      "client_name": "OSLEIDE DEL VALLE ZAMORA DE ACOSTA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vista Hermosa",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04248491517",
      "client_email": "OSLEIDE.0403@GMAIL.COM",
      "address": "CALLE LAS MANDARINAS, CASA 87 VISTA HERMOSA, ROSARIO DE PAYA AARAGUA",
      "client_identification": "V12557380",
      "nap_box_name": "CTO-00060 DOS",
      "created_at": "2024-07-02T13:48:14.601969",
      "service_detail": {
        "id": 12186,
        "ip": "172.30.131.2",
        "mac": "OEMT3C6259AA",
        "serial": "OEMT3C6259AA",
        "queue": null,
        "interface": "VLAN230_VISTA_HERMOSA",
        "created_at": "2026-03-26T09:33:00.849878",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5134,
      "client_name": "ESPECIALIDADES MEDICAS TURMERO CA",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 36,
        "name": "RECURRENTE PYME PLAN 650M",
        "cost": "70.18",
        "code": "FOP650M",
        "profile": "650M/650M"
      },
      "client_mobile": "04164280052",
      "client_email": "EMTDIGNA2511@GMAIL.COM",
      "address": "CALLE CEDEÑO  CASA NRO 20 SECTOR CENTRO TURMERO EDO ARAGUA",
      "client_identification": "J310617112",
      "nap_box_name": "84",
      "created_at": "2024-07-02T14:34:58.785990",
      "service_detail": {
        "id": 3448,
        "ip": "172.20.36.2",
        "mac": "TPLGB68B4E38",
        "serial": "TPLGB68B4E38",
        "queue": "Plan_92037_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-07-04T15:24:25.341450",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5135,
      "client_name": "YONNY ANTONIO AZUAJE ORELLANA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Durpa",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04241591397",
      "client_email": "AZUAJEYONNY54@GMAIL.COM",
      "address": "DURPA, MANZANA NRO. 19 CASA NRO. 18 ROSARIO DE PAYA ARAGUA",
      "client_identification": "V14628381",
      "nap_box_name": "390",
      "created_at": "2024-07-02T14:36:13.246357",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5136,
      "client_name": "FRANCISCO ALBERTO BUSTAMANTE URREA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04141036103",
      "client_email": "NICOLEBUSTAMANTE2510@GMAIL.COM",
      "address": "CALLE 14 EDIF. ESEQUIBO PISO 5 APTO. 5-02 URB. LOS JARDINESDEL VALLE CARACAS DTTO. CAPITAL.",
      "client_identification": "V8080766",
      "nap_box_name": "CTO-00139",
      "created_at": "2024-07-02T14:56:06.342426",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5137,
      "client_name": "SISTEMAS DE ENERGIA SA",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 36,
        "name": "RECURRENTE PYME PLAN 650M",
        "cost": "70.18",
        "code": "FOP650M",
        "profile": "650M/650M"
      },
      "client_mobile": "04265332099",
      "client_email": "ADMONSESA@GMAIL.COM",
      "address": "AV MIRANDA EDF GIUROS PISO 2 22 SECTOR CENTRO DE TURMERO",
      "client_identification": "J303898793",
      "nap_box_name": "CTO-00038",
      "created_at": "2024-07-02T15:02:49.452510",
      "service_detail": {
        "id": 9716,
        "ip": "172.19.140.2",
        "mac": "TPLGB954ECF0",
        "serial": "TPLGB954ECF0",
        "queue": null,
        "interface": "VLAN200_OLTs",
        "created_at": "2025-11-10T10:58:15.605284",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5138,
      "client_name": "BRAYAN ALFONSO TIRADO GUTIERREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124050545",
      "client_email": "BATGZ1999@GMAIL.COM",
      "address": "CALLE 13 B CASA Nº 29 SECTOR PANTIN ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V27204275",
      "nap_box_name": "CTO-00170",
      "created_at": "2024-07-02T15:19:27.942797",
      "service_detail": {
        "id": 10781,
        "ip": "172.30.134.2",
        "mac": "2012231218006767",
        "serial": "OEMT3C6259A2",
        "queue": null,
        "interface": "VLAN229_PANTIN",
        "created_at": "2025-12-17T16:08:00.482932",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5139,
      "client_name": "GLYMAR DEL VALLE PIMENTEL MENDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Valle Verde",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128868765",
      "client_email": "JAMARDIS578@GMAIL.COM",
      "address": "CALLE RIO SECO Nº 10-1 URB VALLE VERDE ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V15301485",
      "nap_box_name": "CTO-0613",
      "created_at": "2024-07-02T15:44:46.890497",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5140,
      "client_name": "YOANA KARINA TARAZONA GONZALEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "1ro de Mayo Norte",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04125970339",
      "client_email": "KG563241@GMAIL.COM",
      "address": "CALLEJON BOLIVAR CASA NRO 3 SECTOR PRIMERO DE MAYO NORTE ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V25067183",
      "nap_box_name": "CTO - 919",
      "created_at": "2024-07-02T16:07:35.923049",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5141,
      "client_name": "TERESITA DE JESUS CARRASQUEL DE CABRERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144686443",
      "client_email": "CARRASQUELTERESITA@GMAIL.COM",
      "address": "CALLE RIVAS EDIF MARIÑO PISO 1 APT SECTOR CENTRO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V7195449",
      "nap_box_name": "CTO-00502",
      "created_at": "2024-07-02T16:39:56.131842",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5142,
      "client_name": "KATIUSKA  ELENA JAIMES BRICEÑO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Valle Paraiso",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04144445781",
      "client_email": "KECBLEBR7005@GMAIL.COM",
      "address": "CALLE PRINCIPAL EDIF ALTOS DE JUAN PABLO PB APT NRO 9 URB VALLE PARAISO SECTOR SAN PABLO TURMERO",
      "client_identification": "V9665411",
      "nap_box_name": "CTO-00603",
      "created_at": "2024-07-02T16:49:15.623896",
      "service_detail": {
        "id": 3568,
        "ip": "172.22.47.2",
        "mac": "TPLGB68B4F0E",
        "serial": "TPLGB68B4F0E",
        "queue": "Plan_128609_15811_WispHub",
        "interface": "VLAN227_V_PARAISO_OLT1",
        "created_at": "2024-07-09T10:19:21.003373",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5145,
      "client_name": "ELADIA LOMELLI",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villas El Carmen",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128674597",
      "client_email": "JONAS.CARRASQUEL17@GMAIL.COM",
      "address": "CALLE 06 EDIFICIO CUCHIBAN PISO 2 APTO 10 URB VILLAS EL CARMEN",
      "client_identification": "V5768127",
      "nap_box_name": "58",
      "created_at": "2024-07-03T09:01:06.711336",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5146,
      "client_name": "NESTOR RAFAEL RODRIGUEZ LOPEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Nispero",
      "plan": {
        "id": 19,
        "name": "RECURRENTE RESIDENCIAL PLAN 1GB",
        "cost": "74.70",
        "code": "FOR1GB",
        "profile": "1000M/1000M"
      },
      "client_mobile": "04243723518",
      "client_email": "NESTOR7980@GMAIL.COM",
      "address": "CALLE LOS NISPEROS CASA NRO 4 URB LOS NISPEROS TURMERO ARAGUA",
      "client_identification": "V15364218",
      "nap_box_name": "209",
      "created_at": "2024-07-03T09:07:24.898774",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5147,
      "client_name": "ANGEL JONAR MARTINEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vallecito",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243711815",
      "client_email": "MARTINEZJONAR.90@GMAIL.COM",
      "address": "CALLE LAS PALMAS CASA NRO 42 SECTOR VALLECITO ROSARIO DE PAYA ARAGUA",
      "client_identification": "V16436812",
      "nap_box_name": "CTO-00067",
      "created_at": "2024-07-03T12:10:08.924952",
      "service_detail": {
        "id": 3438,
        "ip": "172.30.140.2",
        "mac": "OEMT3C625AE6",
        "serial": "OEMT3C625AE6",
        "queue": "Plan_161905_30183_WispHub",
        "interface": "VLAN258_VALLECITO",
        "created_at": "2024-07-04T13:18:03.907692",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5148,
      "client_name": "LEVIS GEOVANNY BARCO BLANCO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Las Rurales",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04125614039",
      "client_email": "LEVISBARCOBLANCO@GMAIL.COM",
      "address": "LAS RURALES CALLE NRO. 103 CASA NRO. 28 ROSARIO DE PAYA ARAGUA",
      "client_identification": "V20559170",
      "nap_box_name": "CE - 667",
      "created_at": "2024-07-03T12:33:57.112703",
      "service_detail": {
        "id": 3602,
        "ip": "172.30.141.2",
        "mac": "ADCGCCA23756",
        "serial": "ADCGCCA23756",
        "queue": "Plan_161905_30183_WispHub",
        "interface": "VLAN252_RURALES_PAYA",
        "created_at": "2024-07-09T22:01:22.873209",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5150,
      "client_name": "ANYILIS MARIA GALINDEZ SUAREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 43,
        "name": "RECURRENTE RESIDENCIAL PLAN 650M",
        "cost": "46.00",
        "code": "FOR650M",
        "profile": "650M/650M"
      },
      "client_mobile": "4243586039",
      "client_email": "ANGELISGALINDEZ86@GMAIL.COM",
      "address": "CALLE 4 CASA 193 URB MATA CABALLO",
      "client_identification": "V20590216",
      "nap_box_name": "CTO-00272",
      "created_at": "2024-07-03T13:18:24.601354",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5151,
      "client_name": "CARYELIS MARIA NAVA MORA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Durpa",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "4129618634",
      "client_email": "CARYELISNAVA223@GMAIL.COM",
      "address": "DURPA, FUNDABARRIO MANZANA 17, CALLE LOS CAOBOS, CASA NRO 23 ROSARIO DE PAYA",
      "client_identification": "V25538936",
      "nap_box_name": "CTO-00297",
      "created_at": "2024-07-03T13:50:33.827202",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5152,
      "client_name": "GLAIBER NEIDEMAR PEREZ CABRERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243665936",
      "client_email": "GLAIBERPEREZ@GMAIL.COM",
      "address": "CALLE 2 CASA NRO. 76 SECTOR MATACABALLO ROSARIO DE PAYA ARAGUA",
      "client_identification": "V223449600",
      "nap_box_name": "455",
      "created_at": "2024-07-03T14:24:25.331257",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5153,
      "client_name": "NATIVIDAD CRISTINA SANCHEZ VILLALOBOS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Valle del Rosario",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04123983839",
      "client_email": "CRISTINATISANCHEZ@GMAIL.COM",
      "address": "CALLE ARAGUA CASA 11 URB VALLE DEL ROSARIO SECTOR EL MACARO TURMERO",
      "client_identification": "V7294433",
      "nap_box_name": "31",
      "created_at": "2024-07-03T16:30:25.000738",
      "service_detail": {
        "id": 10049,
        "ip": "172.21.215.2",
        "mac": "TPLGB68B4E3B",
        "serial": "TPLGB68B4E3B",
        "queue": null,
        "interface": "VLAN132_VALLE_ROSARIO",
        "created_at": "2025-11-11T21:31:29.628603",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5155,
      "client_name": "TAIMAR MARIOXYS ROSALES MIRLE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "1ro de Mayo Norte",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128907031",
      "client_email": "THAIMARMISLE@GMAIL.COM",
      "address": "CALLE MARA CASA NRO. 12, SECTOR !ERO DE MAYO NORTE  ROSARIO DE PAYA ARAGUA",
      "client_identification": "V23783266",
      "nap_box_name": "CTO-00458",
      "created_at": "2024-07-04T11:16:23.050095",
      "service_detail": {
        "id": 3623,
        "ip": "172.30.154.2",
        "mac": "HWTC8886A285",
        "serial": "HWTC8886A285",
        "queue": "Plan_161905_30183_WispHub",
        "interface": "VLAN261_1ERO_MAYO",
        "created_at": "2024-07-11T10:40:53.441683",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5156,
      "client_name": "YAMILETH OLIMAR GONZALEZ TORRES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Palma Real",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04141462050",
      "client_email": "YALITAGONZALEZE@GMAIL.COM",
      "address": "CALLE MANZANA 5 CASA NRO. 107 URB. PALMA REAL ROSARIO DE PAYA ARAGUA",
      "client_identification": "V10099338",
      "nap_box_name": "404",
      "created_at": "2024-07-04T13:57:22.051820",
      "service_detail": {
        "id": 3479,
        "ip": "172.30.147.2",
        "mac": "2012231218007077",
        "serial": "OEMT3C625E7A",
        "queue": "Plan_161895_30183_WispHub",
        "interface": "VLAN244_PALMAREAL",
        "created_at": "2024-07-05T09:48:28.554508",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5157,
      "client_name": "JUAN CARLOS LEON CASTILLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "1ro de Mayo Norte",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04120926256",
      "client_email": "JUANCARLOSLEONCASTILLO6@GMAIL.COM",
      "address": "CALLE CHACAO CASA 12-A  SECTOR 1 DE MAYO NORTE ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V13845354",
      "nap_box_name": "CTO - 900",
      "created_at": "2024-07-04T14:07:46.657742",
      "service_detail": {
        "id": 10877,
        "ip": "172.30.155.2",
        "mac": "ADCGCCA4C267",
        "serial": "ADCGCCA4C267",
        "queue": null,
        "interface": "VLAN261_1ERO_MAYO_ZTE",
        "created_at": "2025-12-22T18:59:06.324134",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5159,
      "client_name": "GLADYS MARIA ESPINOZA GOMEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Bosque",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128205405",
      "client_email": "71GLADYS@GMAIL.COM",
      "address": "CALLE JOSE ANTONIO PAEZ CASA N A-8 SECTOR EL BOSQUE, ROSARIO DE PAYA",
      "client_identification": "V16247668",
      "nap_box_name": "CE - 851",
      "created_at": "2024-07-04T14:51:32.658809",
      "service_detail": {
        "id": 3724,
        "ip": "172.30.177.2",
        "mac": "2012231218006678",
        "serial": "OEMT3C62583E",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN266_EL_BOSQUE_ZTE",
        "created_at": "2024-07-11T22:32:19.537268",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5161,
      "client_name": "NORMA MAGALI RAMIREZ SALAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124493138",
      "client_email": "NORMA455RAMIREZ@GMAIL.COM",
      "address": "CALLE 1-B CASA NRO. 40 URB. HACIENDA PANTIN ROSARIO DE PAYA ARAGUA",
      "client_identification": "V6841829",
      "nap_box_name": "CTO-00127",
      "created_at": "2024-07-04T14:51:55.632833",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5162,
      "client_name": "YOEL ADAN RIVAS NAVAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "1ro de Mayo Norte",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04122990403",
      "client_email": "YOELNAVAS77@GMAIL.COM",
      "address": "PRIMERO DE MAYO NORTE CALLE TAMANACO CASA NRO. 11 ROSARIO DE PAYA ARAGUA",
      "client_identification": "V13239620",
      "nap_box_name": "CTO - 919",
      "created_at": "2024-07-04T15:45:56.240553",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5163,
      "client_name": "GENESIS EDGALINA BETANCOURT LUQUE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Bicentenario",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124321149",
      "client_email": "LUQUEGENESIS33@GMAIL.COM",
      "address": "CALLE 1-B CASA NRO. 40 URB. HACIENDA PANTIN ROSARIO DE PAYA ARAGUA.",
      "client_identification": "V25538379",
      "nap_box_name": "CTO-00192",
      "created_at": "2024-07-04T16:34:57.429429",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5164,
      "client_name": "FARMAHEALTH CA",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04243517954",
      "client_email": "LICDAFANNYGARCIA1@GMAIL.COM",
      "address": "CALLE LOS PRÓCERES CASA NRO. 10 LOCAL A SECTOR LA MORITA 1, COMUNIDAD BOLÍVAR LIBERTADOR TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "J503238500",
      "nap_box_name": "CTO-00128",
      "created_at": "2024-07-04T17:07:51.327671",
      "service_detail": {
        "id": 3827,
        "ip": "172.25.204.2",
        "mac": "TPLGF9CD467D",
        "serial": "TPLGF9CD467D",
        "queue": "Plan_161886_30183_WispHub",
        "interface": "VLAN229_PANTIN",
        "created_at": "2024-07-16T08:23:01.419214",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5165,
      "client_name": "VIVALDESIGNERS CA",
      "client_type_name": "PYME",
      "client_subdivision": "CANCELADO_PYME",
      "status_name": "Cancelado",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04243151422",
      "client_email": "VIVALDESIGNERS@GMAIL.COM",
      "address": "CALLE RIVAS Y CALLE PETION CC MINICENTRO COMERCIAL RANDAZZO NIVEL 37 LOCAL 37 SECTOR TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "J502825177",
      "nap_box_name": "CE - 758",
      "created_at": "2024-07-04T17:25:25.346531",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5166,
      "client_name": "VIVALDESIGNERS CA",
      "client_type_name": "PYME",
      "client_subdivision": "CANCELADO_PYME",
      "status_name": "Cancelado",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 102,
        "name": "RECURRENTE PYME PLAN 150M",
        "cost": "27.60",
        "code": "FOP150M",
        "profile": "150Mbps/150Mbps"
      },
      "client_mobile": "04243151422",
      "client_email": "VIVALDESIGNERS@GMAIL.COM",
      "address": "CALLE RIVAS Y CALLE PETION CC MINICENTRO COMERCIAL RANDAZZO NIVEL 37 LOCAL 37 SECTOR TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "J502825177",
      "nap_box_name": "CTO-0650",
      "created_at": "2024-07-04T17:27:35.314296",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5168,
      "client_name": "JOSNEYWILL ANTONIO GUERRA SOTO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Canaima",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04123488124",
      "client_email": "JOSNE1997@GMAIL.COM",
      "address": "CALLE 2 CASA NRO. 34 CONJUNTO RESIDENCIAL PRADOS DE PAYA ROSARIO DE PAYA ARAGUA",
      "client_identification": "V25880707",
      "nap_box_name": "CTO-00107 ",
      "created_at": "2024-07-05T14:24:10.831972",
      "service_detail": {
        "id": 3494,
        "ip": "172.23.111.2",
        "mac": "2012231218006946",
        "serial": "OEMT3C625C6E",
        "queue": "Plan_161905_30183_WispHub",
        "interface": "VLAN237_CANAIMA",
        "created_at": "2024-07-05T20:47:01.481012",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5169,
      "client_name": "FRANCIS MORELBA GUTIERREZ CONTRERAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Arboleda",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04129676030",
      "client_email": "GUTIERREZFRANCIS97@GMAIL.COM",
      "address": "CALLE EL CUJI, CASA NRO. 140 SECTOR LA ARBOLEDA, ROSARIO DE PAYA, ARAGUA.",
      "client_identification": "V13044330",
      "nap_box_name": "CE - 851",
      "created_at": "2024-07-05T15:13:09.610814",
      "service_detail": {
        "id": 3609,
        "ip": "172.30.153.2",
        "mac": "2012231218006688",
        "serial": "OEMT3C625866",
        "queue": "queue1",
        "interface": "VLAN257_ARBOLEDA",
        "created_at": "2024-07-10T13:05:31.718667",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5170,
      "client_name": "BETZY ZORANI REBOLLEDO JASPE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Valle del Rosario",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04144439963",
      "client_email": "BETZYREZO2312@GMAIL.COM",
      "address": "CALLE ARAGUA CASA NRO 6 SECTOR VALLE DEL ROSARIO TURMERO ARAGUA",
      "client_identification": "V14741761",
      "nap_box_name": "31",
      "created_at": "2024-07-05T16:54:15.509426",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5171,
      "client_name": "LENYN DE JESUS COLON AREVALO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Valle Verde",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128855861",
      "client_email": "LENYN80COLON@GMAIL.COM",
      "address": "CALLE LA TANQUILLA CASA NRO. 7 SECTOR VALLE VERDE ROSARIO DE PAYA ARAGUA",
      "client_identification": "V14741983",
      "nap_box_name": "CTO-00187",
      "created_at": "2024-07-08T09:54:20.421037",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5174,
      "client_name": "ABRAHAN JOSE SALAS ESPINOZA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124361171",
      "client_email": "ABRAHANSALAS_28@HOTMAIL.COM",
      "address": "CALLE 2 CASA NRO 38 SECTOR PRADOS 2 ROSARIO DE PAYA ARAGUA",
      "client_identification": "V17273724",
      "nap_box_name": "CTO-00205 DOS",
      "created_at": "2024-07-08T10:27:49.875737",
      "service_detail": {
        "id": 3526,
        "ip": "172.30.170.2",
        "mac": "2012231218007211",
        "serial": "OEMT3C626092",
        "queue": "Plan_161905_30183_WispHub",
        "interface": "VLAN242_PRADOS2",
        "created_at": "2024-07-08T16:21:37.787690",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5175,
      "client_name": "ASHLY ALEXANDRA MINGUELIS MENDOZA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Canaima",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04123453455",
      "client_email": "Suyerli30@gmail.com",
      "address": "CALLE 5 CASA NRO. 11 SECTOR CANAIMA ROSARIO DE PAYA ARAGUA",
      "client_identification": "V31357943",
      "nap_box_name": "359",
      "created_at": "2024-07-08T11:01:24.537799",
      "service_detail": {
        "id": 10776,
        "ip": "172.30.162.2",
        "mac": "2012231218007343",
        "serial": "OEMT3C6262A2",
        "queue": null,
        "interface": "VLAN237_CANAIMA",
        "created_at": "2025-12-17T14:46:45.481898",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5176,
      "client_name": "JORGE ASDRUBAL SIERRA RUIZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villa De San Jose",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04129027486",
      "client_email": "SIERRAJA2007@GMAIL.COM",
      "address": "CTRA EL MACARO CASA Nº 0311 URB VILLA SAN JOSE TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V8998935",
      "nap_box_name": "CTO-00191",
      "created_at": "2024-07-08T11:24:12.817724",
      "service_detail": {
        "id": 3573,
        "ip": "172.30.163.2",
        "mac": "2012231218006533",
        "serial": "OEMT3C6255FA",
        "queue": "Plan_92034_1574_WispHub",
        "interface": "VLAN134_VILLAS_DSJ",
        "created_at": "2024-07-09T13:00:31.422325",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5178,
      "client_name": "LEIDI VANESSA SANCHEZ GOMEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Bicentenario",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04129666495",
      "client_email": "SANLEIDI4@GMAIL.COM",
      "address": "CALLE SIMON RODRIGUEZ, MANZANA 14 CSA NRO. 3 SECTOR FUNDA BARRIO BICENTENARIO ROSARIO DE PAYA, ARAGUA",
      "client_identification": "V19245236",
      "nap_box_name": "388",
      "created_at": "2024-07-08T11:38:30.009434",
      "service_detail": {
        "id": 3576,
        "ip": "172.30.165.2",
        "mac": "OEMT3C620572",
        "serial": "OEMT3C620572",
        "queue": "Plan_161905_30183_WispHub",
        "interface": "VLAN243_BICENTENARIO",
        "created_at": "2024-07-09T13:27:20.471841",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5179,
      "client_name": "GLEISMAR ROCIO TOVAR BARRETO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Bicentenario",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243183283",
      "client_email": "GLEISMARTOVAR9@GMAIL.COM",
      "address": "CALLE 7 CASA NRO. 5 SECTOR PRADOS I PAYA TURMERO, ARAGUA.",
      "client_identification": "V20695553",
      "nap_box_name": "CTO-00202",
      "created_at": "2024-07-08T11:44:02.789924",
      "service_detail": {
        "id": 11921,
        "ip": "172.30.166.2",
        "mac": "2012231218007358",
        "serial": "OEMT3C6262DE",
        "queue": null,
        "interface": "VLAN243_BICENTENARIO",
        "created_at": "2026-03-03T10:59:12.997577",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5180,
      "client_name": "YESSI LISBETH GARCIA ALVAREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "1ro de Mayo Norte",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04124573966",
      "client_email": "KENNEDYLEDEZMA958@GMAIL.COM",
      "address": "VEREDA 2, QUINTA NRO. 4 BARRIO EL ESFUERZO PRIMERO DE MAYO NORTE TURMERO, ROSARIO DE PAYA, ARAGUA",
      "client_identification": "V19654104",
      "nap_box_name": "CTO- 908",
      "created_at": "2024-07-08T12:08:01.505137",
      "service_detail": {
        "id": 3641,
        "ip": "172.30.167.2",
        "mac": "2012231218007282",
        "serial": "OEMT3C6261AE",
        "queue": "Plan_161895_30183_WispHub",
        "interface": "VLAN261_1ERO_MAYO",
        "created_at": "2024-07-11T17:01:18.371604",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5182,
      "client_name": "GABRIEL ENRIQUE MATUTE MEDINA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124539912",
      "client_email": "XXGABRIELZORXX4@GMAIL.COM",
      "address": "CALLE PRINCPAL EDIF. TORRE 24 PISO 1, APTO 2",
      "client_identification": "V22948588",
      "nap_box_name": "CTO-00207",
      "created_at": "2024-07-08T12:50:35.523037",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5183,
      "client_name": "JUAN JOSE GUAITA CARPIO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "1ro de Mayo Norte",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243351457",
      "client_email": "JUANJOSEGUAITA1963@GMAIL.COM",
      "address": "CALLE INTERCOMUNAL CASA NRO 07 SECTOR EL ESFUERZO ROSARIO DE PAYA",
      "client_identification": "V10981457",
      "nap_box_name": "CTO- 908",
      "created_at": "2024-07-08T14:15:22.032325",
      "service_detail": {
        "id": 3637,
        "ip": "172.30.164.2",
        "mac": "2012231218006524",
        "serial": "OEMT3C6255D6",
        "queue": "queue1",
        "interface": "VLAN261_1ERO_MAYO_ZTE",
        "created_at": "2024-07-11T15:04:07.084969",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5184,
      "client_name": "LEIDYS HORTENCIA PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128970762",
      "client_email": "LEIDYSORTENCIAPEREZ@GMAIL.COM",
      "address": "CALLE 1 CASA NRO 89 PRADOS II ROSARIO DE PAYA",
      "client_identification": "V9688464",
      "nap_box_name": "584 DOS",
      "created_at": "2024-07-08T14:16:13.523741",
      "service_detail": {
        "id": 3600,
        "ip": "172.30.161.2",
        "mac": "2012231218007310",
        "serial": "OEMT3C62621E",
        "queue": "Plan_161905_30183_WispHub",
        "interface": "VLAN242_PRADOS2",
        "created_at": "2024-07-09T21:50:14.509344",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5185,
      "client_name": "CHIQUINQUIRA DEL CARMEN VELASQUEZ DIAZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Las Rurales",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04162364536",
      "client_email": "VCHIQUINQUIRA91@GMAIL.COM",
      "address": "CALLE 105 CASA NRO 90 SECTOR LAS RURALES CAGUA ARAGUA ZONA POSTAL 2122",
      "client_identification": "V30658395",
      "nap_box_name": "CTO-00200",
      "created_at": "2024-07-08T14:36:52.069576",
      "service_detail": {
        "id": 11435,
        "ip": "172.30.168.2",
        "mac": "OEMT3C6255FE",
        "serial": "OEMT3C6255FE",
        "queue": null,
        "interface": "VLAN252_RURALES_PAYA",
        "created_at": "2026-01-31T18:03:44.031632",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5186,
      "client_name": "CATHERINE GABRIELA GARCIA CAMPOS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04122929424",
      "client_email": "CATEGC2312@GMAIL.COM",
      "address": "CALLE 9 CASA NRO 606-A URB MATA CABALLO ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V24686295",
      "nap_box_name": "CE - 566",
      "created_at": "2024-07-08T16:07:30.335662",
      "service_detail": {
        "id": 12907,
        "ip": "172.24.253.2",
        "mac": "TP:LG:F9:CD:47:C4",
        "serial": "TPLGF9CD47C4",
        "queue": null,
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2026-08-26T11:30:26.277345",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5187,
      "client_name": "KENDER JAVIER USTARIZ RIVERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vista Hermosa",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04127707667",
      "client_email": "KENDERUSTARIZ01@GMAIL.COM",
      "address": "CALLE 1, CASA NRO. 15 SECTOR LAS PALMAS TURMERO, ARAGUA",
      "client_identification": "V23528916",
      "nap_box_name": "CTO-00059",
      "created_at": "2024-07-08T16:24:25.705359",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5188,
      "client_name": "HENYERBER JOSE ARRIECHE SUAREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Leocolbo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121394529",
      "client_email": "HENYELBERTH.A@GMAIL.COM",
      "address": "CALLE A CASA NRO 61 CASERIO LEOCOLBO 19 DE ABRIL ARAGUA ZONA POSTAL 2115",
      "client_identification": "V24446560",
      "nap_box_name": "CE - 623",
      "created_at": "2024-07-08T16:56:42.871179",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5189,
      "client_name": "ALI EDUARDO MENDOZA JIMENEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243362330",
      "client_email": "AEMJNEGOCIOS@GMAIL.COM",
      "address": "CALLE EL CENTRO CASA NRO. 18 SECTOR TURMERO NORTE PUEBLO NUEVO ARAGUA.",
      "client_identification": "V10113115",
      "nap_box_name": "CTO-0172",
      "created_at": "2024-07-09T09:32:22.782346",
      "service_detail": {
        "id": 10292,
        "ip": "172.30.171.2",
        "mac": "2012231218007076",
        "serial": "OEMT3C625E76",
        "queue": null,
        "interface": "VLAN200_OLTs",
        "created_at": "2025-11-24T15:02:35.040214",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5190,
      "client_name": "ENEYDA YOLANDA GOMEZ DE REYES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Canaima",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04125257964",
      "client_email": "VICTORDRG2024@GMAIL.COM",
      "address": "CALLE 5, CASA NRO. 13 URB. CANAIMA SECTOR PRADOS DE PAYA, ROSARIO DE PAYA, ARAGUA",
      "client_identification": "V9682638",
      "nap_box_name": "CTO-00315 ",
      "created_at": "2024-07-09T10:31:23.243692",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5191,
      "client_name": "AUTOMERCADO CENTRAL MARINO",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 36,
        "name": "RECURRENTE PYME PLAN 650M",
        "cost": "70.18",
        "code": "FOP650M",
        "profile": "650M/650M"
      },
      "client_mobile": "04120880201",
      "client_email": "SHAPHYKRYA@GMAIL.COM",
      "address": "AV BOLIVAR CASA NRO. 30 SECTOR CENTRO DE TURMERO, TURMERO, ARAGUA",
      "client_identification": "J294738222",
      "nap_box_name": "CTO-00194",
      "created_at": "2024-07-09T12:33:20.937030",
      "service_detail": {
        "id": 3942,
        "ip": "172.30.179.2",
        "mac": "2012231218006766",
        "serial": "OEMT3C62599E",
        "queue": "Plan_161877_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-07-17T13:41:38.777397",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5192,
      "client_name": "ELVIA ROSA VILLEGAS MONTILLA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243157292",
      "client_email": "ELVIASVILLEGAS62@GMAIL.COM",
      "address": "CALLE 12 CASA NRO 672-A URBANISMO MATA CABALLO",
      "client_identification": "V7252227",
      "nap_box_name": "CTO-0167",
      "created_at": "2024-07-09T15:30:50.412179",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5193,
      "client_name": "RAFAEL ADRIAN ROJAS ALVARADO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128870399",
      "client_email": "R.ROJAS1987@GMAIL.COM",
      "address": "CALLE 1 CASA NRO 55 CONJUNTO RESIDENCIAL SAMAN TARAZONERO I TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V18554759",
      "nap_box_name": "93",
      "created_at": "2024-07-09T15:52:14.423333",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5194,
      "client_name": "JONATHAN HUMBERTO FLORES TOVAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Valle del Rosario",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243347778",
      "client_email": "FLORES06JONATHAN@GMAIL.COM",
      "address": "CALLE BODOY CASA NRO 25 URB VALLE EL ROSARIO",
      "client_identification": "V18163473",
      "nap_box_name": "299",
      "created_at": "2024-07-09T16:19:52.462185",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5195,
      "client_name": "JOSE NELSON CARDOZA VIVAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "SUSPENDIDO_RESIDENCIAL",
      "status_name": "Suspendido",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Palmeras II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243649541",
      "client_email": "JONECAVI@GMAIL.COM",
      "address": "CALLE 5 CASA NRO 82 URB LAS PALMERAS II TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V10159747",
      "nap_box_name": "288",
      "created_at": "2024-07-09T16:40:10.956504",
      "service_detail": {
        "id": 8828,
        "ip": "172.30.182.2",
        "mac": "2012231218007287",
        "serial": "OEMT3C6261C2",
        "queue": "queue1",
        "interface": "VLAN119_PALMERAS_2",
        "created_at": "2025-06-03T15:26:12.870491",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5196,
      "client_name": "JESUS ARMANDO ROMERO TORRES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Taguapire",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128838375",
      "client_email": "ARTAHONAODALIS19999@GMAIL.COM",
      "address": "CALLE 03CASA NRO 27 URB LA ESPERANZA 19 DE ABRIL ARAGUA ZONA POSTAL 2115",
      "client_identification": "V16291878",
      "nap_box_name": "CTO-00388 DOS",
      "created_at": "2024-07-09T16:43:04.448048",
      "service_detail": {
        "id": 10502,
        "ip": "172.25.178.2",
        "mac": "ZTEGCF545585",
        "serial": "ZTEGCF545585",
        "queue": null,
        "interface": "VLAN129_TAGUAPIRE_ZTE",
        "created_at": "2025-12-02T17:46:20.565704",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5197,
      "client_name": "IRENE JOSELYN LUCES VEROES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona I",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04264344039",
      "client_email": "IRENEAFRG07@GMAIL.COM",
      "address": "CALLE 9 CASA Nº 07 URBA LA CASONA 19 DE ABRIL TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V17016310",
      "nap_box_name": "407",
      "created_at": "2024-07-10T09:18:06.165954",
      "service_detail": {
        "id": 4032,
        "ip": "172.30.238.2",
        "mac": "TPLGB68B4E6E",
        "serial": "TPLGB68B4E6E",
        "queue": "Plan_132787_24341_WispHub",
        "interface": "VLAN109_CASONA_1",
        "created_at": "2024-07-19T08:17:59.536562",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5198,
      "client_name": "ADELA TIBISAY DUARTE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243801814",
      "client_email": "ADELADUARTE0405@GMAIL.COM",
      "address": "CALLE B 16, CASA NRO. 51 SECTOR PANTIN ROSARIO DE PAYA, ARAGUA.",
      "client_identification": "V9960592",
      "nap_box_name": "CTO-00140",
      "created_at": "2024-07-10T13:50:02.882588",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5199,
      "client_name": "YANETH MENDOZA PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243690105",
      "client_email": "GISELLORIANGEL@GMAIL.COM",
      "address": "EZEQUIEL ZAMORA BLOQUE 02 EDIFICIO TURQUIA SEGUNDO PISO APTO Nº 04 TURMERO ESTADO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V15600750",
      "nap_box_name": "CTO-00296",
      "created_at": "2024-07-10T14:58:36.129656",
      "service_detail": {
        "id": 4000,
        "ip": "10.16.12.2",
        "mac": "HWTC5D15DD91",
        "serial": "HWTC5D15DD91",
        "queue": "queue1",
        "interface": "VLAN209_ZAMORA_OLT1",
        "created_at": "2024-07-18T10:50:07.906122",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5201,
      "client_name": "PASTOR MANUEL DELGADO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Terrazas de Paya",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128988023",
      "client_email": "PASTORM241281@GMAIL.COM",
      "address": "URB TERRAZAS DE PAYA, MANZANA 4, CASA NRO. 15 ROSARIO DE PAYA",
      "client_identification": "V16735651",
      "nap_box_name": "421",
      "created_at": "2024-07-10T15:14:01.892659",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5202,
      "client_name": "FRANYERLI LILIANA VILLALOBOS MATEUS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Betania",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243490349",
      "client_email": "FRANYERLILILIANA1949@GMAIL.COM",
      "address": "CALLE 2 CASA NRO. 127, SECTOR BETANIA ROSARIO DE PAYA ARAGUA",
      "client_identification": "V22886455",
      "nap_box_name": "CTO-00376",
      "created_at": "2024-07-10T15:41:39.570591",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5203,
      "client_name": "TECNIC JATS CA",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "La Julia",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04243587421",
      "client_email": "TECNIC.ADM13@GMAIL.COM",
      "address": "CALLE CESAR GIRON CASA NRO 24 URB POPULAR EL SOCORRO VALENCIA CARABOBO ZONA POSTAL 2001",
      "client_identification": "J296168695",
      "nap_box_name": "CE - 148",
      "created_at": "2024-07-11T09:57:48.709159",
      "service_detail": {
        "id": 11781,
        "ip": "172.28.208.2",
        "mac": "HWTC0C1E97A1",
        "serial": "HWTC0C1E97A1",
        "queue": null,
        "interface": "VLAN116_CAOBOS",
        "created_at": "2026-02-27T10:49:30.656488",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5204,
      "client_name": "INVERSIONES HAWAY CA",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "San Pablo",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04243189779",
      "client_email": "INVERSIONESHAWAYVNZLA@GMAIL.COM",
      "address": "AV TERCERA ETAPA LOCAL NRO  44 ZONA INDUSTRIAL II SAN PABLO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "J311891021",
      "nap_box_name": "102 DOS",
      "created_at": "2024-07-11T10:19:15.412373",
      "service_detail": {
        "id": 5362,
        "ip": "172.17.126.2",
        "mac": "VSOL00140369",
        "serial": "VSOL00140369",
        "queue": "Plan_92036_15811_WispHub",
        "interface": "VLAN224_SAN_PABLO_OLT1",
        "created_at": "2024-08-16T11:26:20.086341",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5205,
      "client_name": "MARCELO MORAGUES CARDOZO",
      "client_type_name": "PYME",
      "client_subdivision": "CANCELADO_PYME",
      "status_name": "Cancelado",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Vista Hermosa",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04243483842",
      "client_email": "MARC6629@GMAIL.COM",
      "address": "CALLE 5 CASA NRO 28 SECTOR 3 PRADOS DE PAYA TURMERO",
      "client_identification": "V24801303",
      "nap_box_name": "237",
      "created_at": "2024-07-11T10:24:37.353405",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5207,
      "client_name": "MICHEEL MILAGRO SEQUERA REBOLLEDO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villa Los Tamarindos",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121481566",
      "client_email": "SEQUERA.REBOLLEDO.Z1123@GMAIL.COM",
      "address": "CALLE A , CASA N 14 , URB VILLA LOS TAMARINDOS, TURMERO, ARAGUA",
      "client_identification": "V28097226",
      "nap_box_name": "107",
      "created_at": "2024-07-11T11:17:57.501717",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5208,
      "client_name": "YULEIXYS EMPERATIZ MORENO SALAZAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados I",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243643870",
      "client_email": "YULEIXYSMORENO2012@GMAIL.COM",
      "address": "CALLE 13, CASA 34, SECTOR PRADO DE PAYA, TURMERO, ARAGUA",
      "client_identification": "V20110120",
      "nap_box_name": "CTO-00204",
      "created_at": "2024-07-11T12:07:14.056878",
      "service_detail": {
        "id": 3791,
        "ip": "172.30.189.2",
        "mac": "OEMT3C62553A",
        "serial": "OEMT3C62553A",
        "queue": "Plan_161905_30183_WispHub",
        "interface": "VLAN239_PRADOS1",
        "created_at": "2024-07-14T15:11:15.809558",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5212,
      "client_name": "YEXITH REINALDO VILLAMIZAR PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243661009",
      "client_email": "YEXITHV@GMAIL.COM",
      "address": "AV2 CASA NRO 526-C SECTOR MATA CABALLO ROSARIO DE PAYA",
      "client_identification": "V18552825",
      "nap_box_name": "CTO-00310",
      "created_at": "2024-07-11T16:24:06.198671",
      "service_detail": {
        "id": 3834,
        "ip": "172.31.195.2",
        "mac": "OEMT3C62266A",
        "serial": "OEMT3C62266A",
        "queue": "Plan_161905_30183_WispHub",
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2024-07-16T11:51:40.215362",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5213,
      "client_name": "ALIMENTOS INTERNACIONALES SM Y SL",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "San Pablo",
      "plan": {
        "id": 36,
        "name": "RECURRENTE PYME PLAN 650M",
        "cost": "70.18",
        "code": "FOP650M",
        "profile": "650M/650M"
      },
      "client_mobile": "04243649599",
      "client_email": "JUAN.GARCIA@ALIMENTOSVE.COM",
      "address": "ZONA INDUSTRIAL SAN PABLO AV.47 Y 48 N 7 Y 8 TURMERO",
      "client_identification": "J001306935",
      "nap_box_name": "102 DOS",
      "created_at": "2024-07-11T19:16:15.344626",
      "service_detail": {
        "id": 3700,
        "ip": "172.23.235.2",
        "mac": "VSOL00128801",
        "serial": "VSOL00128801",
        "queue": "Plan_92037_15811_WispHub",
        "interface": "VLAN224_SAN_PABLO_OLT1",
        "created_at": "2024-07-11T21:05:03.152209",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5214,
      "client_name": "LIRIMAR DEL CARMEN MALPA INOJOSA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243048421",
      "client_email": "LIRIMAR355@GMAIL.COM",
      "address": "CALLE 11 CASA NRO 10 SECTOR PRADOS DE PAYA I ROSARIO DE PAYA",
      "client_identification": "V18265872",
      "nap_box_name": "CTO-00204 DOS",
      "created_at": "2024-07-12T09:54:17.193953",
      "service_detail": {
        "id": 4232,
        "ip": "172.21.32.2",
        "mac": "TPLGF4B1D66D",
        "serial": "TPLGF4B1D66D",
        "queue": "Plan_161905_30183_WispHub",
        "interface": "VLAN239_PRADOS1",
        "created_at": "2024-08-07T13:28:41.039403",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5215,
      "client_name": "ASDRUBAL JUNIOR VASQUEZ CASTRO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Prados I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243757971",
      "client_email": "ASDRUBALVASQUEZ15@GMAIL.COM",
      "address": "CALLE 11 CASA NRO 19 SECTOR PRADOS I ROSARIO DE PAYA",
      "client_identification": "V28316934",
      "nap_box_name": "CTO-00204 DOS",
      "created_at": "2024-07-12T10:15:00.677425",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5216,
      "client_name": "YLMER GERMAN MONASTERIO SUAREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Prados I",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04128934941",
      "client_email": "YLMER40MONASTERIO@GMAIL.COM",
      "address": "CALLE PRINCIPAL CASA NRO 1 SECTOR PRADOS I",
      "client_identification": "V19469796",
      "nap_box_name": "CTO-00206",
      "created_at": "2024-07-12T10:18:06.074323",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5217,
      "client_name": "JOSEFINA GREGORIA TOVAR BLANCO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Bicentenario",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04129115175",
      "client_email": "JOSEFINATOVARBLANCO@GMAIL.COM",
      "address": "CALLE LOS ROBLES MANZANA 13 CASA PLANTA ALTA NRO 1 SECTOR DESARROLLO URBANISTICO",
      "client_identification": "V8739392",
      "nap_box_name": "381",
      "created_at": "2024-07-12T10:20:24.096055",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5218,
      "client_name": "PEDRO JOSE RIVAS MUÑOZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Arboleda",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04163142236",
      "client_email": "PR6857741@GMAIL.COM",
      "address": "CALLE LOS NARANJOS, CASA NRO. 103 SECTOR LA ARBOLEDA, ROSARIO DE PAYA.",
      "client_identification": "V11051842",
      "nap_box_name": "CTO-00154",
      "created_at": "2024-07-12T10:48:33.345885",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5219,
      "client_name": "VIRGINIA DEL VALLE AYALA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243052023",
      "client_email": "TRANSPORTEDORVIR@GMAIL.COM",
      "address": "CALLE NRO. 2 CASA NRO. 59 SECTOR MATA CABALLO, ROSARIO DE PAYA, ARAGUA",
      "client_identification": "V11090431",
      "nap_box_name": "CTO-435",
      "created_at": "2024-07-12T11:11:29.830951",
      "service_detail": {
        "id": 3787,
        "ip": "172.30.195.2",
        "mac": "OEMT3C625562",
        "serial": "OEMT3C625562",
        "queue": "Plan_161905_30183_WispHub",
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2024-07-13T21:40:56.179094",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5220,
      "client_name": "YUBISAY YAINEZ SUAREZ ARRIECHE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243000993",
      "client_email": "YUBISUAREZ270@GMAIL.COM",
      "address": "CALLE 1 NRO 7 SECTOR PRADOS ROSARIO DE PAYA",
      "client_identification": "V13270345",
      "nap_box_name": "585 DOS",
      "created_at": "2024-07-12T11:25:47.492269",
      "service_detail": {
        "id": 4428,
        "ip": "172.30.111.2",
        "mac": "TPLGF4EFC280",
        "serial": "TPLGF4EFC280",
        "queue": "Plan_161892_30183_WispHub",
        "interface": "VLAN239_PRADOS1",
        "created_at": "2024-08-09T21:27:13.086504",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5221,
      "client_name": "RODOLFO JESUS SILVA GARCIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Valle Verde",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04123984681",
      "client_email": "SGRJ41@GMAIL.COM",
      "address": "AV PRINCIPAL CASA NRO. 81 SECTOR VALLE VERDE, ROSARIO DE PAYA, ARAGUA",
      "client_identification": "V25841227",
      "nap_box_name": "CE - 704",
      "created_at": "2024-07-12T11:37:22.015451",
      "service_detail": {
        "id": 4085,
        "ip": "172.30.196.2",
        "mac": "OEMT3C6205F2",
        "serial": "OEMT3C6205F2",
        "queue": "queue1",
        "interface": "VLAN253_VALLE_VERDE",
        "created_at": "2024-07-22T13:55:27.346896",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5222,
      "client_name": "LUIS ENRIQUE REYES GONZALEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Bicentenario",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128743947",
      "client_email": "LR2551724@GMAIL.COM",
      "address": "MANZANA 12, NRO. 14 PLANTA ALTA SECTOR FUNDA BARRIOS BICENTENARIO ROSARIO DE PAYA, ARAGUA",
      "client_identification": "V9671675",
      "nap_box_name": "379",
      "created_at": "2024-07-12T12:02:15.593833",
      "service_detail": {
        "id": 3807,
        "ip": "172.30.197.2",
        "mac": "OEMT3C62271A",
        "serial": "OEMT3C62271A",
        "queue": "Plan_161903_30183_WispHub",
        "interface": "VLAN243_BICENTENARIO",
        "created_at": "2024-07-15T16:56:05.227813",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5223,
      "client_name": "PEDRO JOSE DIAZ COLMENARES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Betania",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128649138",
      "client_email": "PDRODIAZ@HOTMAIL.COM",
      "address": "AV MANZANA 14 CASA NRO 10 URB FUNDA BARRIOS",
      "client_identification": "V8827529",
      "nap_box_name": "CTO-00453",
      "created_at": "2024-07-12T12:05:42.160302",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5224,
      "client_name": "ANAKARY BETXIBEL GUTIERREZ TENIAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243790844",
      "client_email": "ANAKARYGUTIERREZ06@GMAIL.COM",
      "address": "CALLE 5 NRO 373 SECTOR MATA CABALLO ROSARIO DE PAYA",
      "client_identification": "V13070417",
      "nap_box_name": "CTO-00180",
      "created_at": "2024-07-12T14:39:27.768079",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5225,
      "client_name": "FRIGORIFICO SAN JORGE TURMERO CA",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04124507537",
      "client_email": "DCAIRESARTURO@GMAIL.COM",
      "address": "CALLE PETION NRO 21-1 LOCAL NRO 1 CONJUNTO RESIDENCIAS MARIÑO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "J505631640",
      "nap_box_name": "CTO-00194",
      "created_at": "2024-07-12T14:45:06.168848",
      "service_detail": {
        "id": 3927,
        "ip": "172.30.211.2",
        "mac": "OEMT3C6222BE",
        "serial": "OEMT3C6222BE",
        "queue": "Plan_92036_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-07-17T10:26:17.663729",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5226,
      "client_name": "MILAGROS DE JESUS GARCIA GUEVARA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04125127863",
      "client_email": "MILIGARCIA2030@GMAIL.COM",
      "address": "VDA 5 MANZANA C-14 SECTOR SAMAN TARAZONERO II EL MACARO",
      "client_identification": "V9677361",
      "nap_box_name": "CTO-00064",
      "created_at": "2024-07-12T14:59:19.307423",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5227,
      "client_name": "JOSE LUIS CROQUER ROJAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 43,
        "name": "RECURRENTE RESIDENCIAL PLAN 650M",
        "cost": "46.00",
        "code": "FOR650M",
        "profile": "650M/650M"
      },
      "client_mobile": "04243007597",
      "client_email": "1976050976JOSELUIS@GMAIL.COM",
      "address": "CALLE 10A, CASA N°24, URB PANTIN, ROSARIO DE PAYA, ARAGUA",
      "client_identification": "V9436479",
      "nap_box_name": "CTO-00121",
      "created_at": "2024-07-12T16:08:55.283442",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5228,
      "client_name": "CORINA DEL CARMEN VAZQUEZ PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243279055",
      "client_email": "VASQUEZCORINA25@GMAIL.COM",
      "address": "CALLE 15A, CASA N 12, URB HACIENDA PANTIN, ROSARIO DE PAYA, ARAGUA",
      "client_identification": "V8821929",
      "nap_box_name": "CTO-00201",
      "created_at": "2024-07-12T16:35:30.791526",
      "service_detail": {
        "id": 4067,
        "ip": "172.30.199.2",
        "mac": "OEMT3C62262E",
        "serial": "OEMT3C62262E",
        "queue": "Plan_161895_30183_WispHub",
        "interface": "VLAN229_PANTIN",
        "created_at": "2024-07-20T14:00:50.013772",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5229,
      "client_name": "MARK LOUIS TOVAR MILLAN",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villas El Carmen",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243696429",
      "client_email": "MARKTOVAR468@GMAIL.COM",
      "address": "CALLE 9 CASA NRO 11 URB VILLAS DEL CARMEN TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V275971029",
      "nap_box_name": "41",
      "created_at": "2024-07-12T16:39:21.048969",
      "service_detail": {
        "id": 13100,
        "ip": "172.30.200.2",
        "mac": "OE:MT:3C:62:2B:3E",
        "serial": "OEMT3C622B3E",
        "queue": null,
        "interface": "VLAN135_VILLAS_CARMEN_OLT_ZTE",
        "created_at": "2026-10-01T16:57:43.833507",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5230,
      "client_name": "OSMAYERLING DEL ROSARIO AGUILAR ALVARADO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Naranjal",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04128028499",
      "client_email": "OSMIYAYSHA@GMAIL.COM",
      "address": "CALLE LA ESPERANZA, CASA NRO 10, SECTOR GRANJA EL NARANJAL, ROSARIO DE PAYA, ARAGUA",
      "client_identification": "V26681229",
      "nap_box_name": "CE - 681",
      "created_at": "2024-07-12T16:50:36.511658",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5231,
      "client_name": "ANTONIETA DE JESUS GUTIERREZ MAYORGA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona II Edificios",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04120435524",
      "client_email": "ANTONIETADEJESUS99@GMAIL.COM",
      "address": "LA CASONA 2 EDIFICIO 09 PISO 02 APT 06 AV INTERCOMUNAL TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V4164284",
      "nap_box_name": "CTO-0536",
      "created_at": "2024-07-12T16:53:03.840110",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5232,
      "client_name": "ALICE VILORIA PACHECO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Callejon Lim",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04143452574",
      "client_email": "ALICE24VP@GMAIL.COM",
      "address": "EDIF MAGNOLIA PISO 02 CALLEJON LIM ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V20695183",
      "nap_box_name": "CTO-0563",
      "created_at": "2024-07-12T16:59:21.708318",
      "service_detail": {
        "id": 3790,
        "ip": "172.30.203.2",
        "mac": "OEMT3C625B76",
        "serial": "OEMT3C625B76",
        "queue": "Plan_153953_15811_WispHub",
        "interface": "VLAN250_LIM_OLT2",
        "created_at": "2024-07-14T13:50:36.865411",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5233,
      "client_name": "YUSMERY SUGIL SIVIRA AREVALO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04143820108",
      "client_email": "YUSME.01YS@GMAIL.COM",
      "address": "CALLE Nº09 CASA Nº 63 SECTOR RIO SECO ROSARIO DE PAYA  TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V9696724",
      "nap_box_name": "CTO-0609",
      "created_at": "2024-07-12T17:03:06.170672",
      "service_detail": {
        "id": 9995,
        "ip": "172.30.204.2",
        "mac": "OEMT3C622C96",
        "serial": "OEMT3C622C96",
        "queue": null,
        "interface": "VLAN251_RIO_SECO",
        "created_at": "2025-11-11T13:43:40.599496",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5234,
      "client_name": "JOJANIS MANUEL RAMIREZ FARFAN",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243452797",
      "client_email": "MANUELRAMIREZ1682@GMAIL.COM",
      "address": "CALLE 10 CASA NRO 630C SECTOR MATA CABALLO",
      "client_identification": "V16339041",
      "nap_box_name": "CTO-00569",
      "created_at": "2024-07-12T17:10:39.500809",
      "service_detail": {
        "id": 3788,
        "ip": "172.30.205.2",
        "mac": "OEMT3C6255BA",
        "serial": "OEMT3C6255BA",
        "queue": "Plan_161905_30183_WispHub",
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2024-07-13T22:46:00.674388",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5235,
      "client_name": "MARIA DE LAS VERONICA CARUSO APONTE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Paya Abajo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243546611",
      "client_email": "DELASVERONICACARUSO@GMAIL.COM",
      "address": "CALLE SAN MIGUEL CASA Nº 24 SECTOR PAYA ABAJO , ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V20056209",
      "nap_box_name": "CTO-00024",
      "created_at": "2024-07-12T17:22:07.259258",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5236,
      "client_name": "LISAIDA YAJAIRA OSIO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Cambur",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04129113291",
      "client_email": "YAJAIRAOSIO1973@GMAIL.COM",
      "address": "CALLE PRINCIPAL, CASA PARCELA NRO 27, URB INDIA CACIQUE, URIMARE, ROSARIO DE PAYA, ARAGUA",
      "client_identification": "V11931839",
      "nap_box_name": "CTO-00244",
      "created_at": "2024-07-12T17:23:15.417419",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5237,
      "client_name": "MIRLAYS ARIANA ESTANGA MONTEZUMA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Terrazas de Paya",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04123981737",
      "client_email": "MIRLAYS20@GMAIL.COM",
      "address": "CALLE PRINCIPAL CASA NRO 16, SECTOR LUZ Y VIDA, ROSARIO DE PAYA, ARAGUA",
      "client_identification": "V20650246",
      "nap_box_name": "CTO-00163",
      "created_at": "2024-07-12T17:46:20.841842",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5238,
      "client_name": "MARIA FERNANDA FEBLES ROJAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Paya Abajo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243414931",
      "client_email": "FERFEBLES2505@GMAIL.COM",
      "address": "CALLE CAMPO ELIAS, CASA NRO 3, BARRIO PAYA ABAJO, ROSARIO DE PAYA, ARAGUA",
      "client_identification": "V27646737",
      "nap_box_name": "CTO-00307",
      "created_at": "2024-07-12T17:58:40.406139",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5239,
      "client_name": "JONADAD ENRIQUE OVALLES ARCILA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vallecito",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04128806559",
      "client_email": "JONADAD.ENRIQUE@GMAIL.COM",
      "address": "AV PRINCIPAL, CASA NRO 117, SECTOR LOS MANGOS, ROSARIO DE PAYA, ARAGUA",
      "client_identification": "V16331466",
      "nap_box_name": "CTO - 80",
      "created_at": "2024-07-12T18:13:47.421717",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5240,
      "client_name": "DANNY MARIA PINTO ALVIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Brisas de Paya",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124615806",
      "client_email": "DANNYPINTO232@GMAIL.COM",
      "address": "AV 3 CASA NRO 17 SECTOR BRISAS DE PAYA ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V14871903",
      "nap_box_name": "366",
      "created_at": "2024-07-13T10:09:31.758545",
      "service_detail": {
        "id": 3785,
        "ip": "172.30.216.2",
        "mac": "OEMT3C622D3E",
        "serial": "OEMT3C622D3E",
        "queue": "Plan_161905_30183_WispHub",
        "interface": "VLAN241_BRISAS",
        "created_at": "2024-07-13T19:02:03.917561",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5241,
      "client_name": "ANDREINA DEL VALLE FIGUEREDO HERNANDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Bicentenario",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243661249",
      "client_email": "ANDREINAFIGUEREDO19@GMAIL.COM",
      "address": "CALLE FRANCISCO DE MIRANDA CASA NRO 25 SECTOR BICENTENARIO ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V19364112",
      "nap_box_name": "389",
      "created_at": "2024-07-13T11:06:53.090172",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5242,
      "client_name": "JOSE DANIEL SOSA RAMIREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243987662",
      "client_email": "sosacarla379@gmail.com",
      "address": "CALLE 2 CASA NRO 75 MATA CABALLO ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V30658804",
      "nap_box_name": "455",
      "created_at": "2024-07-13T14:09:19.461061",
      "service_detail": {
        "id": 3784,
        "ip": "172.30.218.2",
        "mac": "OEMT3C625542",
        "serial": "OEMT3C625542",
        "queue": "Plan_161905_30183_WispHub",
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2024-07-13T18:16:42.448183",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5243,
      "client_name": "NANCY COROMOTO CONTRERAS MOLINA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados III",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243172125",
      "client_email": "NANCYCONTRERASMOLINA74@GMAIL.COM",
      "address": "CALLE 2 CASA NRO 30 SECTOR PRADOS III ROSARIO DE PAYA",
      "client_identification": "V12143474",
      "nap_box_name": "CTO-00284 DOS",
      "created_at": "2024-07-15T08:39:48.653438",
      "service_detail": {
        "id": 5942,
        "ip": "172.24.70.2",
        "mac": "VSOL0013F311",
        "serial": "VSOL0013F311",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN236_PRADOS3",
        "created_at": "2024-08-21T13:43:48.503053",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5244,
      "client_name": "LILIANA MARGARITA RAMIREZ QUINTERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Prados III",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243374885",
      "client_email": "HAILYN0212@GMAIL.COM",
      "address": "CALLE 02 CASA 07 URB PRADOS III ROSARIO DE PAYA",
      "client_identification": "V15123132",
      "nap_box_name": "CTO-00284 DOS",
      "created_at": "2024-07-15T08:43:20.573013",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5245,
      "client_name": "DOUGLAS RAMON CELIS TORO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128488193",
      "client_email": "DOUGLASCELIS2@GMAIL.COM",
      "address": "CALLE 20 CASA NRO 29 URB PANTIN ROSARIO DE PAYA",
      "client_identification": "V11979752",
      "nap_box_name": "CTO-00435",
      "created_at": "2024-07-15T08:46:58.697082",
      "service_detail": {
        "id": 5075,
        "ip": "172.17.3.2",
        "mac": "VSOL0047DB49",
        "serial": "VSOL0047DB49",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN229_PANTIN",
        "created_at": "2024-08-14T12:17:31.167461",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5246,
      "client_name": "ALI EDUARDO COUSIN",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144485079",
      "client_email": "COUSINALIEDUARDO@GMAIL.COM",
      "address": "CALLE 13 CASA NRO 42 URB PANTIN TURMERO",
      "client_identification": "V23569233",
      "nap_box_name": "CTO-00171",
      "created_at": "2024-07-15T08:53:49.135631",
      "service_detail": {
        "id": 4931,
        "ip": "172.24.65.2",
        "mac": "VSOL00139E09",
        "serial": "VSOL00139E09",
        "queue": "queue1",
        "interface": "VLAN229_PANTIN",
        "created_at": "2024-08-13T12:18:11.201545",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5247,
      "client_name": "SADIRA DEL VALLE BERMUDEZ RIVERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 16,
        "name": "RECURRENTE RESIDENCIAL PLAN 800M",
        "cost": "55.00",
        "code": "FOR800",
        "profile": "800M/800M"
      },
      "client_mobile": "04144774025",
      "client_email": "BENJAMINGARCIA201515@GMAIL.COM",
      "address": "CALLE 12-A CASA NRO 02 SECTOR ROSARIO DE PAYA PANTIN",
      "client_identification": "V15476127",
      "nap_box_name": "CTO-00165",
      "created_at": "2024-07-15T09:01:18.569148",
      "service_detail": {
        "id": 4932,
        "ip": "172.24.61.2",
        "mac": "VSOL0013A4D9",
        "serial": "VSOL0013A4D9",
        "queue": "Plan_161885_30183_WispHub",
        "interface": "VLAN229_PANTIN",
        "created_at": "2024-08-13T12:20:05.561407",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5248,
      "client_name": "LILIBETH IRAIZ MEDINA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Durpa",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04127767887",
      "client_email": "LILIBETHMEDINA126@GMAIL.COM",
      "address": "CALLE PARAISO MANZANA 22 CASA NRO 18 URB DESARROLLO URBANISTICO ROSARIO DE PAYA",
      "client_identification": "V14319376",
      "nap_box_name": "CTO-00209",
      "created_at": "2024-07-15T10:55:24.786682",
      "service_detail": {
        "id": 4259,
        "ip": "172.23.7.2",
        "mac": "TPLGF4B1DBEA",
        "serial": "TPLGF4B1DBEA",
        "queue": "Plan_161905_30183_WispHub",
        "interface": "VLAN240_DURPA",
        "created_at": "2024-08-08T09:15:30.545894",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5249,
      "client_name": "FLOR ELIA PEREZ DE VILLAMIZAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04125009212",
      "client_email": "FLORELIAPEREZ.1967@GMAIL.COM",
      "address": "CALLE II CASA NRO 17 SECTOR PRADO I ROSARIO DE PAYA",
      "client_identification": "V15489993",
      "nap_box_name": "CTO-00204 DOS",
      "created_at": "2024-07-15T11:25:19.853049",
      "service_detail": {
        "id": 5009,
        "ip": "172.21.35.2",
        "mac": "TPLGF4EFC3B4",
        "serial": "TPLGF4EFC3B4",
        "queue": "Plan_161892_30183_WispHub",
        "interface": "VLAN239_PRADOS1",
        "created_at": "2024-08-13T17:01:53.002394",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5250,
      "client_name": "JESUS MARIA GONZALES RIOS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144454155",
      "client_email": "JOHAD03@GMAIL.COM",
      "address": "CALLE 2, CASA NRO 61, URB MATACABALLO, PAYA",
      "client_identification": "V12171966",
      "nap_box_name": "CTO-435",
      "created_at": "2024-07-15T12:54:14.036922",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5251,
      "client_name": "RABDIEL ANTONIO LINARES QUINTERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Brisas de Paya",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04145889802",
      "client_email": "LINARESRABDIRA@GMAIL.COM",
      "address": "CALLE 2 CASA NRO 17 SECTOR BRISAS DE PAYA",
      "client_identification": "V21466627",
      "nap_box_name": "CTO-00117",
      "created_at": "2024-07-15T13:29:44.432099",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5252,
      "client_name": "EDWAR JOSE MORENO VALERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Durpa",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04125016740",
      "client_email": "ABG.EDWARDMORENO@GMAIL.COM",
      "address": "CALLE MANZANA 16 CASA NRO 25 FUNDA BARRIO ROSARIO DE PAYA",
      "client_identification": "V9660498",
      "nap_box_name": "392",
      "created_at": "2024-07-15T13:46:45.440537",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5253,
      "client_name": "ERIKA LOISINETH MORALES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04145863759",
      "client_email": "ERIKALOISINETH@GMAIL.COM",
      "address": "CALLE 9 CASA NRO 610-C SECTOR MATACABALLO",
      "client_identification": "V15076354",
      "nap_box_name": "CE - 566",
      "created_at": "2024-07-15T14:48:32.749004",
      "service_detail": {
        "id": 12913,
        "ip": "172.17.1.66",
        "mac": "ZX:IC:CD:09:35:64",
        "serial": "ZXICCD093564",
        "queue": null,
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2026-08-26T16:22:42.458292",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5254,
      "client_name": "LISBETH JOSEFINA ROJAS PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243843061",
      "client_email": "YESICA42R@GMAIL.COM",
      "address": "CALLE 08 CASA NRO 579-C SECTOR MATACABALLO",
      "client_identification": "V11122146",
      "nap_box_name": "CTO-00130",
      "created_at": "2024-07-15T14:55:26.266842",
      "service_detail": {
        "id": 13118,
        "ip": "172.20.107.2",
        "mac": "VS:OL:00:52:3A:59",
        "serial": "VSOL00523A59",
        "queue": null,
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2026-10-05T12:30:17.650001",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5255,
      "client_name": "DAVIUSKA DAYMAR HERRERA ROJAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121490518",
      "client_email": "DAVIUSKA96@GMAIL.COM",
      "address": "CALLE 7 CASA NRO 70 URB LA CASONA 1 TURMERO",
      "client_identification": "V25501241",
      "nap_box_name": "45",
      "created_at": "2024-07-15T15:24:39.193300",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5256,
      "client_name": "IVIS THAIS SOTO DE AGUIRRE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "1ro de Mayo Sur",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04127769073",
      "client_email": "DECORACIONES-LUIS@HOTMAIL.COM",
      "address": "SECTOR PRIMERO DE MAYO SUR, CALLE EL CUJI, CASA 9, PRINCIPAL ROSARIO DE PAYA",
      "client_identification": "V10634890",
      "nap_box_name": "CTO-00470",
      "created_at": "2024-07-15T15:26:49.407470",
      "service_detail": {
        "id": 4198,
        "ip": "172.30.222.2",
        "mac": "OEMT3C6232EE",
        "serial": "OEMT3C6232EE",
        "queue": "queue1",
        "interface": "VLAN261_1ERO_MAYO_ZTE",
        "created_at": "2024-08-05T15:50:14.568861",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5257,
      "client_name": "NILDA LUCIA QUERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04262384237",
      "client_email": "NLUCIAQUERO@GMAIL.COM",
      "address": "CALLE 7 CASA NRO 2 URB LA CASONA I TURMERO ARAGUA",
      "client_identification": "V5924952",
      "nap_box_name": "410",
      "created_at": "2024-07-15T15:36:05.159970",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5258,
      "client_name": "JOSEFINA DEL VALLE ESPINOZA CORONA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Los Hornos",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243221308",
      "client_email": "EMIESPINOZA22949057@GMAIL.COM",
      "address": "CALLE LOS MANGOS, CASA 22, SECTOR LOS HORNOS, ROSARIO DE PAYA, ARAGUA",
      "client_identification": "V22949057",
      "nap_box_name": "437",
      "created_at": "2024-07-15T15:37:04.267749",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5259,
      "client_name": "ODALIS MAGALIS SOLIS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144436248",
      "client_email": "ODALISSOLIS201@GMAIL.COM",
      "address": "CALLE 11, CASA 649-D, MATACABALLO, PAYA, ARAGUA",
      "client_identification": "V17603614",
      "nap_box_name": "CTO-00022",
      "created_at": "2024-07-15T16:08:44.024633",
      "service_detail": {
        "id": 3995,
        "ip": "172.30.224.2",
        "mac": "OEMT3C622E1E",
        "serial": "OEMT3C622E1E",
        "queue": "Plan_161905_30183_WispHub",
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2024-07-17T17:27:20.166364",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5260,
      "client_name": "LUIS JOSE MENDOZA CASTRO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04125987919",
      "client_email": "MARTINEZMARTINEZANAROSA57@GMAIL.COM",
      "address": "CALLE AV 1, CASA NRO 49, BARRIO PRADOS DE PAYA I, ROSARIO DE PAYA, ARAGUA",
      "client_identification": "V8735254",
      "nap_box_name": "CTO-00304 DOS",
      "created_at": "2024-07-15T16:17:51.488307",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5261,
      "client_name": "GENESIS KARINA MAZZILLI HERNANDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Arboleda",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128988085",
      "client_email": "GENESISMAZILLI@GMAIL.COM",
      "address": "VDA 3RA CASA #1, URB JULIO MARTIN, MARACAY, ARAGUA",
      "client_identification": "V19173390",
      "nap_box_name": "CTO-00236",
      "created_at": "2024-07-15T16:55:53.913921",
      "service_detail": {
        "id": 12670,
        "ip": "172.30.226.2",
        "mac": "OE:MT:3C:62:55:5A",
        "serial": "OEMT3C62555A",
        "queue": null,
        "interface": "VLAN257_ARBOLEDA",
        "created_at": "2026-07-04T11:34:15.991082",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5262,
      "client_name": "JOHANDER MANUEL CASTRO PEDREAÑEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04126808998",
      "client_email": "AURIMAR.PEDREANEZ16@GMAIL.COM",
      "address": "AV EL MACARO CASA NRO 22 URB SAMAN  TARAZONERO II TURMERO",
      "client_identification": "V30956306",
      "nap_box_name": "95",
      "created_at": "2024-07-15T16:59:10.380237",
      "service_detail": {
        "id": 5928,
        "ip": "172.22.199.2",
        "mac": "TPLGBA687BC7",
        "serial": "TPLGBA687BC7",
        "queue": "Plan_107915_1574_WispHub",
        "interface": "VLAN100_OLTs",
        "created_at": "2024-08-21T12:05:45.741971",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5263,
      "client_name": "MABEL DEYANIRA GARCIA ADARME",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04143477388",
      "client_email": "MABELGARCIA780@GMAIL.COM",
      "address": "CALLE 9 CASA TETRA NRO 604-B SECTOR MATACABALLO",
      "client_identification": "V14521383",
      "nap_box_name": "222",
      "created_at": "2024-07-16T08:29:48.655452",
      "service_detail": {
        "id": 10098,
        "ip": "172.20.115.2",
        "mac": "VSOL00497AA9",
        "serial": "VSOL00497AA9",
        "queue": null,
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2025-11-13T14:20:53.905362",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5264,
      "client_name": "RICHARD RAFAEL PEREZ CASTRO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona I",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243716415",
      "client_email": "RICHARDRAFAEL03@GMAIL.COM",
      "address": "CALLE 7 CASA NRO 18 URB LA CASONA I TURMERO",
      "client_identification": "V25447894",
      "nap_box_name": "410",
      "created_at": "2024-07-16T08:33:54.843374",
      "service_detail": {
        "id": 9754,
        "ip": "172.21.100.2",
        "mac": "TPLGF4EFC174",
        "serial": "TPLGF4EFC174",
        "queue": null,
        "interface": "VLAN109_CASONA_1",
        "created_at": "2025-11-10T12:02:45.742945",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5265,
      "client_name": "DARWIN JOSE PARRA ACEVEDO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Paya Abajo",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04143442290",
      "client_email": "DARWINJOSEPARRAACEVEDO@GMAIL.COM",
      "address": "CALLE SAN MIGUEL CASA NRO 14 SECTOR PAYA ABAJO ROSARIO DE PAYA",
      "client_identification": "V18975168",
      "nap_box_name": "340",
      "created_at": "2024-07-16T08:52:11.139353",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5266,
      "client_name": "CESAR AUGUSTO RODRIGUEZ PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04125790318",
      "client_email": "CESAR220716@GMAIL.COM",
      "address": "CALLE 5-B CASA NRO 51 SECTOR PANTIN ROSARIO DE PAYA",
      "client_identification": "V25066708",
      "nap_box_name": "CTO-00136",
      "created_at": "2024-07-16T08:52:37.744130",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5267,
      "client_name": "CLEIDYS CAROLINA HEREDIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243584001",
      "client_email": "CLEIDYS241@GMAIL.COM",
      "address": "CALLE 12 CASA NRO 671-A URBANIZACIÓN MATA CABALLO",
      "client_identification": "V21101327",
      "nap_box_name": "CTO-0167",
      "created_at": "2024-07-16T08:55:05.468630",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5269,
      "client_name": "ANGIE ZULAY ROJAS RUEDA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243177781",
      "client_email": "ANGIEZROJASR48@GMAIL.COM",
      "address": "CALLE 9A CASA 9 URB TURMERO HACIENDA PANTIN ROSARIO DE PAYA",
      "client_identification": "V12857500",
      "nap_box_name": "CTO-00142",
      "created_at": "2024-07-16T09:00:10.766614",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5271,
      "client_name": "JOSE GREGORIO VENERO MORENO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Isaac Oliveira",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144658361",
      "client_email": "JOSEVENERO28@GMAIL.COM",
      "address": "SAMAN DE GUERE URB ISAAC OLIVEIRA CALLE 3 CASA NRO 109",
      "client_identification": "V18725209",
      "nap_box_name": "134",
      "created_at": "2024-07-16T09:38:38.553417",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5272,
      "client_name": "EDIMAR FRANKLIN BLANCO PARADA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04140437500",
      "client_email": "EDIMAR.BLANCO7@GMAIL.COM",
      "address": "CALLE 12 CASA NRO 667-C TETRA SECTOR MATACABALLO",
      "client_identification": "V16773546",
      "nap_box_name": "CTO-00433",
      "created_at": "2024-07-16T09:44:55.601986",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5273,
      "client_name": "MILEIDY GREGORIA APONTE ALVAREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04121446899",
      "client_email": "LESBIALVAREZALVIA@GMAIL.COM",
      "address": "CALLE MANZANA D14 CASA NRO 14 URB SAMAN TARAZONERO TURMERO ARAGUA",
      "client_identification": "V18972951",
      "nap_box_name": "278",
      "created_at": "2024-07-16T10:14:31.741545",
      "service_detail": {
        "id": 3885,
        "ip": "172.27.44.2",
        "mac": "GPON0097BCA6",
        "serial": "GPON0097BCA6",
        "queue": "Plan_127996_1574_WispHub",
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2024-07-16T17:39:55.485737",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5274,
      "client_name": "EMMAR NEYZMARIZ SUMOZA JUAREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Paya Abajo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243530742",
      "client_email": "EMMARSUMOZA1992@GMAIL.COM",
      "address": "CALLE CENTRO PAYA ABAJO CASA NRO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V21426901",
      "nap_box_name": "CTO-00319",
      "created_at": "2024-07-16T10:20:17.926086",
      "service_detail": {
        "id": 12844,
        "ip": "172.26.148.2",
        "mac": "HW:TC:90:69:33:9B",
        "serial": "HWTC9069339B",
        "queue": null,
        "interface": "VLAN231_PAYABAJO",
        "created_at": "2026-08-15T14:17:16.995875",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5275,
      "client_name": "CECILIO GABRIEL DELGADO IRAHOLA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 43,
        "name": "RECURRENTE RESIDENCIAL PLAN 650M",
        "cost": "46.00",
        "code": "FOR650M",
        "profile": "650M/650M"
      },
      "client_mobile": "04243072952",
      "client_email": "LICECILIODELIRA@GMAIL.COM",
      "address": "CALLE MARIÑO, RESIDENCIAS MARIÑO, TORRE C, PISO 8, APTO. 82 TURMERO, ARAGUA.",
      "client_identification": "V16765578",
      "nap_box_name": "69",
      "created_at": "2024-07-16T10:25:05.405409",
      "service_detail": {
        "id": 9055,
        "ip": "172.30.227.2",
        "mac": "OEMT3C6255E2",
        "serial": "OEMT3C6255E2",
        "queue": "queue1",
        "interface": "VLAN234_R_MARINO_OLT2",
        "created_at": "2025-06-23T13:52:50.853273",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5276,
      "client_name": "EWUAR JOSE RAMIREZ FAJARDO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128981432",
      "client_email": "EWUAR9@GMAIL.COM",
      "address": "CALLE 15 CASA NRO. 22 SECTOR RIO SECO, ROSARIO DE PAYA ARAGUA",
      "client_identification": "V23783392",
      "nap_box_name": "CTO-00147",
      "created_at": "2024-07-16T10:38:59.785690",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5277,
      "client_name": "ESTEFANY MAYERLING TOVAR GIL",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243427414",
      "client_email": "MAYERLINGT168@GMAIL.COM",
      "address": "CALLE 18A, CASA NRO. 10 SECTOR PANTIN, ROSARIO DE PAYA, ARAGUA.",
      "client_identification": "V25880073",
      "nap_box_name": "CTO-00434",
      "created_at": "2024-07-16T10:50:09.350425",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5278,
      "client_name": "SALIM RAHAMAN RAHAMAN",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Antigua Hacienda De Paya",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04144920757",
      "client_email": "IPTRAHAMAN@GMAIL.COM",
      "address": "CALLE DOMINGO DE TOVAR CASA NRO 28-3 URB ANTIGUA HACIENDA DE PAYA TURMERO EDO ARAGUA ROSARIO DE PAYA ARGUA ZONA POSTAL 2115",
      "client_identification": "V15489805",
      "nap_box_name": "CTO-antigua hacienda",
      "created_at": "2024-07-16T12:55:39.584850",
      "service_detail": {
        "id": 3887,
        "ip": "172.30.230.2",
        "mac": "OEMT3C622EEA",
        "serial": "OEMT3C622EEA",
        "queue": "Plan_128609_15811_WispHub",
        "interface": "VLAN202_AHP_OLT1",
        "created_at": "2024-07-16T17:45:10.817982",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5279,
      "client_name": "ANDERSON CHANDEY VERA MARQUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04126316221",
      "client_email": "MARQUEZANDERSON953@GMAIL.COM",
      "address": "CALLE 15-A CASA NRO 9 URB PANTIN ROSARIO DE PAYA",
      "client_identification": "V29637987",
      "nap_box_name": "CTO-00201",
      "created_at": "2024-07-16T13:30:03.440063",
      "service_detail": {
        "id": 5016,
        "ip": "172.23.8.2",
        "mac": "VSOL00523A21",
        "serial": "VSOL00523A21",
        "queue": "Plan_161891_30183_WispHub",
        "interface": "VLAN229_PANTIN",
        "created_at": "2024-08-13T17:15:27.472424",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5280,
      "client_name": "RONALD JOSE SANCHEZ ARREAZA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Guanarito",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243240776",
      "client_email": "RONALDSANCHEZ_24@HOTMAIL.COM",
      "address": "CALLE GERMAN REQUENA CASA GUANARITO NRO 12 SECTOR LEONARDO RUIZ PINEDA TURMERO ARAGUA",
      "client_identification": "V19003861",
      "nap_box_name": "216",
      "created_at": "2024-07-16T14:17:07.632306",
      "service_detail": {
        "id": 4105,
        "ip": "172.17.226.2",
        "mac": "TPLGF4B1D63A",
        "serial": "TPLGF4B1D63A",
        "queue": "Plan_153953_15811_WispHub",
        "interface": "VLAN232_GUANARITO_OLT2",
        "created_at": "2024-07-25T15:33:28.504908",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5281,
      "client_name": "CARLOS JOSE HERNANDEZ LEON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04123558059",
      "client_email": "CARLUCHOHL@GMAIL.COM",
      "address": "CALLE 14 A CASA NRO 5 PANTIN ROSARIO DE PAYA",
      "client_identification": "V21260882",
      "nap_box_name": "CTO-00169",
      "created_at": "2024-07-16T14:42:59.229106",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5282,
      "client_name": "ARITZA YSABEL GALLARDO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Antigua Hacienda De Paya II",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04243684242",
      "client_email": "KELLY2742@GMAIL.COM",
      "address": "URB ANTIGUA  HACIENDA DE PAYA C/DOMINGO CASA NRO 6 PAYA",
      "client_identification": "V9614001",
      "nap_box_name": "CTO-00218 ",
      "created_at": "2024-07-16T14:43:32.424950",
      "service_detail": {
        "id": 5930,
        "ip": "172.22.124.2",
        "mac": "TPLGBA6876D4",
        "serial": "TPLGBA6876D4",
        "queue": "Plan_89281_15811_WispHub",
        "interface": "VLAN201_AHP2_OLT1",
        "created_at": "2024-08-21T12:07:40.694690",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5283,
      "client_name": "ANA MIREYA GUERRERO ROA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04122925515",
      "client_email": "ROAMIREYAG04@GMAIL.COM",
      "address": "CALLE 7-B CASA NRO 43 URB ROSARIO DE PAYA SECTOR PANTIN TURMERO",
      "client_identification": "V10194767",
      "nap_box_name": "CTO-00140",
      "created_at": "2024-07-16T15:09:41.205864",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5284,
      "client_name": "NABIL JUNIOR SAAD SCATA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Antigua Hacienda De Paya II",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04145862891",
      "client_email": "NABILJR.SAAD.81@HOTMAIL.COM",
      "address": "CALLE EL BOSQUE CASA 02 URB ANTIGUA HACIENDA DE PAYA",
      "client_identification": "V15819043",
      "nap_box_name": "220",
      "created_at": "2024-07-16T15:54:58.042621",
      "service_detail": {
        "id": 5912,
        "ip": "172.22.122.2",
        "mac": "TPLGBA6876DF",
        "serial": "TPLGBA6876DF",
        "queue": "Plan_140304_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-08-21T11:34:47.860114",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5285,
      "client_name": "CARLOS JAVIER LOPEZ RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Laguna Plaza",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128879310",
      "client_email": "CACASOSA18@GMAIL.COM",
      "address": "CALLE NEGRO PRIMERO C.C. CAMILO TORRES EDIF 15 PISO 1 APT PH2 TURMERO",
      "client_identification": "V12927398",
      "nap_box_name": "3",
      "created_at": "2024-07-16T15:59:26.122551",
      "service_detail": {
        "id": 5848,
        "ip": "172.22.109.2",
        "mac": "TPLGB68B4DBB",
        "serial": "TPLGB68B4DBB",
        "queue": "Plan_140304_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-08-20T13:58:44.765250",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5286,
      "client_name": "ALEXANDER OLIVO ARAQUE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04141294614",
      "client_email": "OLIVOSEGURIDAD@GMAIL.COM",
      "address": "CALLE 9 CASA NRO 589 D MATACABALLO ROSARIO DE PAYA",
      "client_identification": "V11501679",
      "nap_box_name": "CE - 566",
      "created_at": "2024-07-16T16:06:04.346160",
      "service_detail": {
        "id": 10198,
        "ip": "172.22.115.2",
        "mac": "TPLGBA687766",
        "serial": "TPLGBA687766",
        "queue": null,
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2025-11-19T17:41:52.246439",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5287,
      "client_name": "SALVATORE MARINARO PARRAVANO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04144542202",
      "client_email": "SALVATOREMARINARO@HOTMAIL.COM",
      "address": "CALLEJON  LA HACIENDITA EDIF TERRANOVA PISO 2 APT 2-B VALLE LINDO",
      "client_identification": "V11978014",
      "nap_box_name": "CE - 286",
      "created_at": "2024-07-16T16:09:29.562948",
      "service_detail": {
        "id": 5846,
        "ip": "172.22.99.2",
        "mac": "TPLGBA687767",
        "serial": "TPLGBA687767",
        "queue": "Plan_140304_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-08-20T13:50:51.069601",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5288,
      "client_name": "EDWARD ALEXANDER BARROSO WERBEZAHN",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ppal Paya",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04143258528",
      "client_email": "ALEXANDER.BARROSO@GMAIL.COM",
      "address": "CALLE LAS MOLINAS  ESTE CASA NRO L-2 URB ANTIGUA HACIENDA PAYA",
      "client_identification": "V21639354",
      "nap_box_name": "223",
      "created_at": "2024-07-16T16:15:18.223782",
      "service_detail": {
        "id": 10914,
        "ip": "172.22.120.2",
        "mac": "TPLGBA6875E2",
        "serial": "TPLGBA6875E2",
        "queue": null,
        "interface": "VLAN200_OLTs",
        "created_at": "2025-12-23T13:31:36.773157",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5289,
      "client_name": "EDDY SANTIAGO GONZALEZ MIJARES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128901447",
      "client_email": "EDDYTHIAGO123@GMAIL.COM",
      "address": "CALLE 13 CASA NRO 19 IRB LA CASONA II TURMERO",
      "client_identification": "V25620548",
      "nap_box_name": "CTO-00090",
      "created_at": "2024-07-16T16:20:42.240799",
      "service_detail": {
        "id": 4126,
        "ip": "172.22.107.2",
        "mac": "TPLGBA6876D2",
        "serial": "TPLGBA6876D2",
        "queue": "queue1",
        "interface": "VLAN110_CASONA_2",
        "created_at": "2024-07-30T14:56:53.205153",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5290,
      "client_name": "MARIA GABRIELA AYALA DE PANTIN",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ppal Paya",
      "plan": {
        "id": 19,
        "name": "RECURRENTE RESIDENCIAL PLAN 1GB",
        "cost": "74.70",
        "code": "FOR1GB",
        "profile": "1000M/1000M"
      },
      "client_mobile": "04243376782",
      "client_email": "MURRUNAPANTIN@GMAIL.COM",
      "address": "AV PRINCIPAL DE PAYA, CASA NRO 13 (AL LADO DEL ZOOLOGICO DE PANTIN)",
      "client_identification": "V11312136",
      "nap_box_name": "471",
      "created_at": "2024-07-16T16:31:00.908267",
      "service_detail": {
        "id": 5842,
        "ip": "172.22.105.2",
        "mac": "TPLGBA688276",
        "serial": "TPLGBA688276",
        "queue": "Plan_128611_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-08-20T13:40:32.472218",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5292,
      "client_name": "KATIUSCA NAZARETH VILLAZANA GARCIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "San Sebastian",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04127769175",
      "client_email": "KATIUSCAVILLAZANA@GMAIL.COM",
      "address": "CALLE 7 CASA NRO 26 SECTOR EL MACARO TURMERO",
      "client_identification": "V23783825",
      "nap_box_name": "75",
      "created_at": "2024-07-16T16:50:34.090248",
      "service_detail": {
        "id": 12451,
        "ip": "172.22.96.2",
        "mac": "TPLGBA68774E",
        "serial": "TPLGBA68774E",
        "queue": null,
        "interface": "VLAN125_SAN_SEBASTIAN_ZTE",
        "created_at": "2026-05-04T10:05:43.986564",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5293,
      "client_name": "YAMILET DEL VALLE HERNANDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados II",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04121471421",
      "client_email": "JESUSPLAZA1220@GMAIL.COM",
      "address": "CALLE 1 CASA NRO 9 SECTOR PRADOS II ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V13271319",
      "nap_box_name": "CTO-00118 DOS",
      "created_at": "2024-07-16T16:57:26.086929",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5294,
      "client_name": "JICSEL NAIROBE GUERRERO GUERRERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Arboleda",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243057554",
      "client_email": "JICSELGUERRERO@GMAIL.COM",
      "address": "CALLE LOS COCOS CASA NRO 83 SECTOR LA ARBOLEDA ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V25066413",
      "nap_box_name": "CTO-00236",
      "created_at": "2024-07-16T17:12:54.356616",
      "service_detail": {
        "id": 10993,
        "ip": "172.30.232.2",
        "mac": "OEMT3C622E1A",
        "serial": "OEMT3C622E1A",
        "queue": null,
        "interface": "VLAN257_ARBOLEDA",
        "created_at": "2025-12-30T11:56:30.154630",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5295,
      "client_name": "JOHAN ALEXANDER PEREZ VILLEGAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Nispero",
      "plan": {
        "id": 43,
        "name": "RECURRENTE RESIDENCIAL PLAN 650M",
        "cost": "46.00",
        "code": "FOR650M",
        "profile": "650M/650M"
      },
      "client_mobile": "04243553987",
      "client_email": "JAPV0292@GMAIL.COM",
      "address": "CALLE EL NISPERO ETAPA II CASA NRO 28-A SECTOR DOMINADO EL NISPERO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V18745290",
      "nap_box_name": "20",
      "created_at": "2024-07-16T17:18:23.518603",
      "service_detail": {
        "id": 12908,
        "ip": "172.30.233.2",
        "mac": "ZX:IC:CD:90:6A:BD",
        "serial": "ZXICCD906ABD",
        "queue": null,
        "interface": "VLAN208_NISPERO_OLT1",
        "created_at": "2026-08-26T14:27:18.589278",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5296,
      "client_name": "LUNA LUCIANA GOMEZ GRATEROL",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Lascenio Guerrero",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128150948",
      "client_email": "LUNAGOMEZ239@GMAIL.COM",
      "address": "EL MACARO URB LASCENIO GUERRERO CALLE LOS PINOS S/N NRO CASA 446",
      "client_identification": "V28010256",
      "nap_box_name": "431",
      "created_at": "2024-07-17T09:19:44.747313",
      "service_detail": {
        "id": 13176,
        "ip": "172.22.201.2",
        "mac": "TP:LG:BA:68:7C:87",
        "serial": "TPLGBA687C87",
        "queue": null,
        "interface": "VLAN115_LG",
        "created_at": "2026-10-15T16:19:44.974518",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5297,
      "client_name": "MARYS NALLIVE CORDERO RIETA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144937591",
      "client_email": "CORDEROMARY776@GMAIL.COM",
      "address": "CALLE 01 CASO NRO 81 SECTOR PRADOS DE PAYA II ROSARIO DE PAYA ARAGUA",
      "client_identification": "V10751405",
      "nap_box_name": "584 DOS",
      "created_at": "2024-07-17T09:24:50.156041",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5298,
      "client_name": "RODSSAN INES MONTESINO AVILEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona II Edificios",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04144747155",
      "client_email": "RODSSAN.MONTESINOS@GMAIL.COM",
      "address": "AV INTERCOMUNAL MARACAY EDF II PISO 3 APTO URB LA  CASONA II TURMERO",
      "client_identification": "V21444950",
      "nap_box_name": "CTO-0538",
      "created_at": "2024-07-17T09:30:41.251614",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5299,
      "client_name": "JOSE GREGORIO MIRABAL VELAZQUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona II Edificios",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04143953036",
      "client_email": "MIRA25VEL@GMAIL.COM",
      "address": "AV INTERCOMUNAL TURMERO EDIF 13 PISO 01 APTO 05 URB LA CASONA II TURMERO",
      "client_identification": "V25538007",
      "nap_box_name": "CTO-0539",
      "created_at": "2024-07-17T09:34:27.231760",
      "service_detail": {
        "id": 11775,
        "ip": "172.24.66.2",
        "mac": "VSOL001280C1",
        "serial": "VSOL001280C1",
        "queue": null,
        "interface": "VLAN110_CASONA_2",
        "created_at": "2026-02-27T10:45:11.697934",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5300,
      "client_name": "INVERSIONES COLBOX VEN CA",
      "client_type_name": "PYME",
      "client_subdivision": "PAUSADO_PYME",
      "status_name": "Pausado",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Guerito",
      "plan": {
        "id": 36,
        "name": "RECURRENTE PYME PLAN 650M",
        "cost": "70.18",
        "code": "FOP650M",
        "profile": "650M/650M"
      },
      "client_mobile": "04121998554",
      "client_email": "INVERSIONESCOLBOXVEN@GMAIL.COM",
      "address": "AV INTERCOMUNAL TURMERO MARACAY LOCAL NRO 4-B SECTOR SAMAN DE GUERE GALPON 1",
      "client_identification": "J500445270",
      "nap_box_name": "542",
      "created_at": "2024-07-17T09:35:31.502143",
      "service_detail": {
        "id": 10372,
        "ip": "10.16.200.2",
        "mac": "VSOL00140221",
        "serial": "VSOL00140221",
        "queue": null,
        "interface": "VLAN139_GUERITO",
        "created_at": "2025-11-28T09:50:02.527967",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5301,
      "client_name": "INVERSIONES COLBOX VEN CA",
      "client_type_name": "PYME",
      "client_subdivision": "PAUSADO_PYME",
      "status_name": "Pausado",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Guerito",
      "plan": {
        "id": 36,
        "name": "RECURRENTE PYME PLAN 650M",
        "cost": "70.18",
        "code": "FOP650M",
        "profile": "650M/650M"
      },
      "client_mobile": "04121998554",
      "client_email": "INVERSIONESCOLBOXVEN@GMAIL.COM",
      "address": "AV INTERCOMUNAL TURMERO MARACAY LOCAL NRO 4-B SECTOR SAMAN DE GUERE GALPON 2",
      "client_identification": "J500445270",
      "nap_box_name": "CTO-0657",
      "created_at": "2024-07-17T09:40:02.703203",
      "service_detail": {
        "id": 12490,
        "ip": "172.17.48.2",
        "mac": "VS:OL:00:13:D4:21",
        "serial": "VSOL0013D421",
        "queue": null,
        "interface": "VLAN139_GUERITO",
        "created_at": "2026-05-14T12:51:47.068244",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5302,
      "client_name": "INVERSIONES COLBOX VEN CA",
      "client_type_name": "PYME",
      "client_subdivision": "PAUSADO_PYME",
      "status_name": "Pausado",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Guerito",
      "plan": {
        "id": 36,
        "name": "RECURRENTE PYME PLAN 650M",
        "cost": "70.18",
        "code": "FOP650M",
        "profile": "650M/650M"
      },
      "client_mobile": "04121998554",
      "client_email": "INVERSIONESCOLBOXVEN@GMAIL.COM",
      "address": "AV INTERCOMUNAL TURMERO MARACAY LOCAL NRO 4-B SECTOR SAMAN DE GUERE GALPON 3",
      "client_identification": "J500445270",
      "nap_box_name": "542",
      "created_at": "2024-07-17T09:45:46.679900",
      "service_detail": {
        "id": 4139,
        "ip": "172.27.110.2",
        "mac": "TPLGF9CD4616",
        "serial": "TPLGF9CD4616",
        "queue": "Plan_137589_24341_WispHub",
        "interface": "VLAN139_GUERITO",
        "created_at": "2024-07-31T11:24:15.554375",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5303,
      "client_name": "OMAR GREGORIO INOJOSA TORREALBA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "1ro de Mayo Norte",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121302589",
      "client_email": "OMARINOJOSA54@GMAIL.COM",
      "address": "CALLE PARAMACONI, CASA NRO. 18, SECTOR 1RO DE MAYO NORTE, ROSARIO DE PAYA.",
      "client_identification": "V20266665",
      "nap_box_name": "CTO-00235",
      "created_at": "2024-07-17T10:15:35.889702",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5304,
      "client_name": "CHARLEET NATHALY CASTELLANOS PERDOMO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Naranjal",
      "plan": {
        "id": 101,
        "name": "RECURRENTE RESIDENCIAL PLAN 200M",
        "cost": "19.00",
        "code": "FOR200MB",
        "profile": "200Mbps/200Mbps"
      },
      "client_mobile": "04123989525",
      "client_email": "CHARLEET10@GMAIL.COM",
      "address": "CALLE LA ESPERANZA CASA NRO 9 SECTOR GRANJA EL NARANJAL",
      "client_identification": "V26148605",
      "nap_box_name": "CE - 681",
      "created_at": "2024-07-17T10:41:00.482544",
      "service_detail": {
        "id": 4044,
        "ip": "172.30.235.2",
        "mac": "2012231218006544",
        "serial": "OEMT3C625626",
        "queue": "Plan_161905_30183_WispHub",
        "interface": "VLAN246_NARANJAL",
        "created_at": "2024-07-19T15:29:33.040175",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5305,
      "client_name": "YEIKKER JAIHRAN JIMENEZ PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villas El Carmen",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128727894",
      "client_email": "YEIKKERJIMENEZ@GMAIL.COM",
      "address": "CALLE CARREÑO CASA NRO 84 SECTOR CENTRO TURMERO EDO. ARAGUA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V20334139",
      "nap_box_name": "43",
      "created_at": "2024-07-17T11:21:38.924109",
      "service_detail": {
        "id": 4063,
        "ip": "172.30.236.2",
        "mac": "OEMT3C625B9A",
        "serial": "OEMT3C625B9A",
        "queue": "Plan_137413_1574_WispHub",
        "interface": "VLAN135_VILLAS_CARMEN",
        "created_at": "2024-07-20T13:00:45.998964",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5306,
      "client_name": "AURA MERCEDES MACHADO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vallecito",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04126548026",
      "client_email": "AURAMERCEDES8@GMAIL.COM",
      "address": "CALLE EL ROBLE, CASA NRO. 29 SECTOR VALLECITO, ROSARIO DE PAYA ARAGUA",
      "client_identification": "V3432299",
      "nap_box_name": "CTO - 94",
      "created_at": "2024-07-17T11:21:58.183518",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5307,
      "client_name": "FELIX GERMAN MONTENEGRO TORRES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Las Rurales",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121487088",
      "client_email": "FELIXGMT@GMAIL.COM",
      "address": "CALLE INTERCOMUNAL SUR NRO 05 SECTOR LAS RURALES, ROSARIO DE PAYA",
      "client_identification": "V4545017",
      "nap_box_name": "CTO-00154",
      "created_at": "2024-07-17T11:40:36.837501",
      "service_detail": {
        "id": 9949,
        "ip": "172.17.113.2",
        "mac": "OEMT3C62572E",
        "serial": "OEMT3C62572E",
        "queue": null,
        "interface": "VLAN252_RURALES_PAYA",
        "created_at": "2025-11-11T10:34:10.199262",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5308,
      "client_name": "DENEISI NEWBRASKA CONTRERAS SILVA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Las Rurales",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04120293283",
      "client_email": "NEBRASKACONTRERAS10@GMAIL.COM",
      "address": "CALLE CIEGA 105, CASA NRO. S/N SECTOR LAS RURALES ROSARIO DE PAYA, ARAGUA.",
      "client_identification": "V13067089",
      "nap_box_name": "CTO-00200",
      "created_at": "2024-07-17T11:44:30.378154",
      "service_detail": {
        "id": 4041,
        "ip": "172.30.240.2",
        "mac": "OEMT3C622EE2",
        "serial": "OEMT3C622EE2",
        "queue": "Plan_161905_30183_WispHub",
        "interface": "VLAN252_RURALES_PAYA",
        "created_at": "2024-07-19T12:47:12.868346",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5309,
      "client_name": "NAIL YALITZA PENA MEJIAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Magdalena",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243073264",
      "client_email": "MEDANYAL1.2@GMAIL.COM",
      "address": "CALLE 9 CASA NRO 12 SECTOR SAMAN DE GUERE TURMERO",
      "client_identification": "V15610883",
      "nap_box_name": "CTO-00185",
      "created_at": "2024-07-17T11:52:28.616467",
      "service_detail": {
        "id": 5527,
        "ip": "172.24.47.2",
        "mac": "VSOL0013EE39",
        "serial": "VSOL0013EE39",
        "queue": "queue1",
        "interface": "VLAN114_MAGDALENA",
        "created_at": "2024-08-16T21:05:53.504333",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5310,
      "client_name": "YUSNERY DAYANA GUERRERO  DIAZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124565432",
      "client_email": "DIAZYUSNERI@GMAIL.COM",
      "address": "AV ROSARIO DE PAYA CASA NRO 43 URB PANTIN",
      "client_identification": "V25662295",
      "nap_box_name": "CTO-00138",
      "created_at": "2024-07-17T12:07:08.918096",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5311,
      "client_name": "YOLMER ANDREY ARELLANO BELTRAN",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04147383233",
      "client_email": "BELTRANANDREY753@GMAIL.COM",
      "address": "CALLE 15B CASA NRO 37 URB PANTIN ROSARIO DE PAYA",
      "client_identification": "V15565050",
      "nap_box_name": "CTO-00311",
      "created_at": "2024-07-17T12:12:18.316596",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5313,
      "client_name": "LUIS VALENTIN PEREIRA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "1ro de Mayo Norte",
      "plan": {
        "id": 19,
        "name": "RECURRENTE RESIDENCIAL PLAN 1GB",
        "cost": "74.70",
        "code": "FOR1GB",
        "profile": "1000M/1000M"
      },
      "client_mobile": "04121485451",
      "client_email": "LUIS.PEREIRA8817RP@GMAIL.COM",
      "address": "CALLE CALLEJÓN LOS PEREIRA, CASA NRO. 42 SECTOR 1ERO DE MAYO NORTE, LA INTERCOMUNAL ROSARIO DE PAYA, ARAGUA.",
      "client_identification": "V8817258",
      "nap_box_name": "CTO-00538",
      "created_at": "2024-07-17T12:47:51.542799",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5314,
      "client_name": "MARYURI SOLANGEL ESPANA RAMIREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128849564",
      "client_email": "MAYSPEIN@GMAIL.COM",
      "address": "VDA B-6 CASA NRO 05 SAMAN TARAZONERO II TURMERO",
      "client_identification": "V13132624",
      "nap_box_name": "CTO-00511",
      "created_at": "2024-07-17T12:50:43.923359",
      "service_detail": {
        "id": 4976,
        "ip": "172.17.7.2",
        "mac": "VSOL00140271",
        "serial": "VSOL00140271",
        "queue": "queue1",
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2024-08-13T15:53:50.464523",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5315,
      "client_name": "ISMAYBELTH ELIZABETH ROJAS SEGOVIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144924248",
      "client_email": "ISMAYBELTHROJAS@GMAIL.COM",
      "address": "VDA C7 CASA NRO 8 SECTOR SAMAN  TARAZONERO 2 TURMERO",
      "client_identification": "V29772015",
      "nap_box_name": "64",
      "created_at": "2024-07-17T12:55:24.394544",
      "service_detail": {
        "id": 4979,
        "ip": "172.24.69.2",
        "mac": "VSOL00124E59",
        "serial": "VSOL00124E59",
        "queue": "queue1",
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2024-08-13T16:02:27.020052",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5316,
      "client_name": "KATHERINE MIRYALES BETANCOURT HERNANDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144586702",
      "client_email": "KBETANCOURT944@GMAIL.COM",
      "address": "CALLE 12 CASA NRO 23 SECTOR LA CASONA II TURMERO",
      "client_identification": "V22343492",
      "nap_box_name": "CTO-00092",
      "created_at": "2024-07-17T12:58:38.744520",
      "service_detail": {
        "id": 4983,
        "ip": "172.24.51.2",
        "mac": "VSOL00140FA1",
        "serial": "VSOL00140FA1",
        "queue": "Plan_131647_24341_WispHub",
        "interface": "VLAN110_CASONA_2",
        "created_at": "2024-08-13T16:15:37.646062",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5317,
      "client_name": "CARLOS ENRIQUE GONZALEZ RIVAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Brisas de Paya",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04123989372",
      "client_email": "JEYLENXYZ@GMAIL.COM",
      "address": "CALLE 2 CASA NRO 3 SECTOR BRISAS DE PAYA ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V6171170",
      "nap_box_name": "CTO-00117",
      "created_at": "2024-07-17T13:00:25.858653",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5318,
      "client_name": "EMMA TERESA MONTILLA DE HERRERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Laguna Plaza",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243554506",
      "client_email": "EMMAMONTILLA46@GMAIL.COM",
      "address": "CALLE NEGRO PRIMERA EDIF NRO 16 PISO APT PH-3116 LAGUNA PLAZA",
      "client_identification": "V4678263",
      "nap_box_name": "3 DOS",
      "created_at": "2024-07-17T13:03:11.798829",
      "service_detail": {
        "id": 4986,
        "ip": "172.24.52.2",
        "mac": "VSOL0013D301",
        "serial": "VSOL0013D301",
        "queue": "Plan_92306_15811_WispHub",
        "interface": "VLAN216_LAGUNA_PLAZA_OLT1",
        "created_at": "2024-08-13T16:25:55.989961",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5319,
      "client_name": "JOSE LUIS VIEIRA PIRES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121421285",
      "client_email": "LUISJV.2512@GMAIL.COM",
      "address": "CALLE RIVAS C/C SUAREZ EDIF MARIÑO PISO 1 APT 4 CASCOTURMERO",
      "client_identification": "E81629310",
      "nap_box_name": "CTO-00502",
      "created_at": "2024-07-17T13:54:11.834350",
      "service_detail": {
        "id": 9140,
        "ip": "172.19.237.2",
        "mac": "TPLGB954E865",
        "serial": "TPLGB954E865",
        "queue": "queue1",
        "interface": "VLAN200_OLTs",
        "created_at": "2025-07-03T13:16:21.262511",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5320,
      "client_name": "GLEIMYS MASSIEL FRANCO RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243099207",
      "client_email": "GLEIMISFR@GMAIL.COM",
      "address": "CALLE 1 CASA NRO 20 URB MATA CABALLO ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V15037005",
      "nap_box_name": "CTO-00131",
      "created_at": "2024-07-17T14:14:07.002397",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5322,
      "client_name": "VALERIA ISABELA PUENTE CASTRO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243298072",
      "client_email": "VALERIAPUENTE397@GMAIL.COM",
      "address": "CALLE PRINCIPAL VIA PAYA EDIF 29 PISO 2 APT 2 URB ANTIGUA HACIENDA EL NÍSPERO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V31303951",
      "nap_box_name": "CTO-00207 DOS",
      "created_at": "2024-07-17T15:10:13.561460",
      "service_detail": {
        "id": 4007,
        "ip": "172.30.243.2",
        "mac": "OEMT3C6225EA",
        "serial": "OEMT3C6225EA",
        "queue": "Plan_153953_15811_WispHub",
        "interface": "VLAN209_ZAMORA_OLT1",
        "created_at": "2024-07-18T13:05:33.415272",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5323,
      "client_name": "DEIVY DENIS PEREZ PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04243764367",
      "client_email": "ELECTRONICACARPIO@GMAIL.COM",
      "address": "CALLE MIRANDA CASA NRO 93-A SECTOR TURMERO",
      "client_identification": "V11092733",
      "nap_box_name": "101",
      "created_at": "2024-07-17T15:29:49.712683",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5325,
      "client_name": "GABRIELA DEL CARMEN MARTINEZ FERRUCCI",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04143470093",
      "client_email": "EIZAGM220@GMAIL.COM",
      "address": "CALLE MANZANA 3 CASA NRO 12 SAMAN TARAZONERO II",
      "client_identification": "V17245388",
      "nap_box_name": "510 DOS",
      "created_at": "2024-07-17T15:58:58.857414",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5326,
      "client_name": "PABLID MAIGUALIDA FERRER RIVAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Palmeras I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128918181",
      "client_email": "PABLID.00FERRER@GMAIL.COM",
      "address": "CALLE 2 CASA NRO 105 CONJUNTO RESIDENCIAL LAS PALMERAS I TURMERO",
      "client_identification": "V9664139",
      "nap_box_name": "CTO-00065",
      "created_at": "2024-07-17T16:06:41.355968",
      "service_detail": {
        "id": 5821,
        "ip": "172.19.225.2",
        "mac": "TPLGB954FA59",
        "serial": "TPLGB954FA59",
        "queue": "Plan_131337_24341_WispHub",
        "interface": "VLAN118_PALMERAS_1",
        "created_at": "2024-08-20T09:56:22.877508",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5327,
      "client_name": "CARMEN JANNARELIS RODRIGUEZ GAMARRA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04145880937",
      "client_email": "JANNARELIZRODRIGUEZ@GMAIL.COM",
      "address": "CALLE 7, CASA PARCELA 18 SECTOR RIO SECO, ROSARIO DE PALLA ARAGUA",
      "client_identification": "V18702828",
      "nap_box_name": "CTO-00408",
      "created_at": "2024-07-17T16:08:19.688383",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5328,
      "client_name": "KATTY DE JESUS PAEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Palmeras II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243459839",
      "client_email": "KATTYPAEZ27@GMAIL.COM",
      "address": "AV FERNANDO PEÑALVER CALLE 10 CASA NRO 8 URB PALMERAS II TURMERO",
      "client_identification": "V9438803",
      "nap_box_name": "287",
      "created_at": "2024-07-17T16:10:36.036701",
      "service_detail": {
        "id": 5393,
        "ip": "172.19.224.2",
        "mac": "TPLGB954ECE1",
        "serial": "TPLGB954ECE1",
        "queue": "Plan_132787_24341_WispHub",
        "interface": "VLAN119_PALMERAS_2",
        "created_at": "2024-08-16T14:46:10.568225",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5329,
      "client_name": "YOHANA ANABEL GIMENEZ RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04144620604",
      "client_email": "SUP.ARAGUA.DANIELTORO@GMAIL.COM",
      "address": "CALLE MANZANA D-9 CASA NRO 1 SECTOR SAMAN TARAZONERO II TURMERO",
      "client_identification": "V19530516",
      "nap_box_name": "485",
      "created_at": "2024-07-17T16:16:24.726013",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5330,
      "client_name": "KEINER JAVIER RAMIREZ ESCALANTE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "SUSPENDIDO_RESIDENCIAL",
      "status_name": "Suspendido",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243179087",
      "client_email": "YOLYESCALANTETORRES@GMAIL.COM",
      "address": "CALLE 3 MANZANA C-12 CASA NRO 2 SAMAN  TARAZONERO  II TURMERO",
      "client_identification": "V25880041",
      "nap_box_name": "485",
      "created_at": "2024-07-17T16:44:11.469948",
      "service_detail": {
        "id": 5818,
        "ip": "172.19.229.2",
        "mac": "TPLGB954EC05",
        "serial": "TPLGB954EC05",
        "queue": "Plan_137413_1574_WispHub",
        "interface": "VLAN100_OLTs",
        "created_at": "2024-08-20T09:51:03.025907",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5331,
      "client_name": "YUSMARY TERESA DE LOS SANTOS ARAUJO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121490883",
      "client_email": "DELOSSANTOSYUSMARY@GMAIL.COM",
      "address": "CALLE MANZANA B-6 CASA NRO 13 SAMAN TARAZONERO II TURMERO",
      "client_identification": "V10727269",
      "nap_box_name": "281",
      "created_at": "2024-07-17T16:50:39.425780",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5332,
      "client_name": "AMERICA BELFON LONGA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128010796",
      "client_email": "BELFONAMERICA@GMAIL.COM",
      "address": "VDA MANZANA E10 CASA NRO 26 BARRIO SAMAN TARAZONERO II TURMERO",
      "client_identification": "V3718872",
      "nap_box_name": "277",
      "created_at": "2024-07-17T16:55:35.165542",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5333,
      "client_name": "NEUDYS CELENYS GONZALEZ DE ACOSTA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Sector los Mangos",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121587045",
      "client_email": "KARLOTAACOSTA70307@GMAIL.COM",
      "address": "CALLE 2DA CASA Nº 5 SECTOR LOS MANGOS ROSARIO DE PAYA TURMERO ESTADO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V14627173",
      "nap_box_name": "CTO-00470",
      "created_at": "2024-07-17T17:07:33.392504",
      "service_detail": {
        "id": 4197,
        "ip": "172.30.245.2",
        "mac": "OEMT3C62307E",
        "serial": "OEMT3C62307E",
        "queue": "Plan_161905_30183_WispHub",
        "interface": "VLAN261_1ERO_MAYO_ZTE",
        "created_at": "2024-08-05T15:48:54.951687",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5334,
      "client_name": "CLARA ALVARADO RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04125969146",
      "client_email": "claritzaborges@gmail.com",
      "address": "CALLE CAMILO TORRES EDIF 2 PISO 3 APT 16 URB CONJUNTO RESIDENCIAL",
      "client_identification": "V4367135",
      "nap_box_name": "CTO-0647",
      "created_at": "2024-07-18T08:07:23.555301",
      "service_detail": {
        "id": 4990,
        "ip": "172.24.31.2",
        "mac": "VSOL00124689",
        "serial": "VSOL00124689",
        "queue": "Plan_114480_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-08-13T16:30:16.398201",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5335,
      "client_name": "SOMAIRA JOSEFINA COOLI ROSALES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Callejon Rosales",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04243238460",
      "client_email": "SIOCO1964@GMAIL.COM",
      "address": "CALLE LOS ROSALES CASA NRO 5-A SECTOR ANTIGUA HACIENDA DE PAYA TURMERO",
      "client_identification": "V8734411",
      "nap_box_name": "319",
      "created_at": "2024-07-18T08:10:53.697873",
      "service_detail": {
        "id": 4994,
        "ip": "172.24.18.2",
        "mac": "VSOL0012E5B9",
        "serial": "VSOL0012E5B9",
        "queue": "Plan_92312_15811_WispHub",
        "interface": "VLAN206_ROSALES_OLT2",
        "created_at": "2024-08-13T16:40:00.319117",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5336,
      "client_name": "EUCLIDES RAMON LUCENA ULLOA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144617204",
      "client_email": "ERLUCENA@GMAIL.COM",
      "address": "CALLE 12-A CASA NRO 18 SECTOR PANTIN ROSARIO DE PAYA",
      "client_identification": "V7274437",
      "nap_box_name": "CTO-00165",
      "created_at": "2024-07-18T08:13:08.475048",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5337,
      "client_name": "KELLY ROSIBBEL MORALES CASTRO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243529094",
      "client_email": "KELLYMORALES3114@GMAIL.COM",
      "address": "PANTIN CALLE 5B CASA 33 ROSARIO DE PAYA",
      "client_identification": "V28024526",
      "nap_box_name": "CTO-00136",
      "created_at": "2024-07-18T08:26:02.223195",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5338,
      "client_name": "ELEAZAR JORGE HERRERA YANES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04123984129",
      "client_email": "RUTHHERRERA279@GMAIL.COM",
      "address": "CALLE 2 CASA NRO 88 URB MATA CABALLO ROSARIO DE PAYA",
      "client_identification": "V16132650",
      "nap_box_name": "CTO-00102",
      "created_at": "2024-07-18T08:38:06.582061",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5339,
      "client_name": "LEONARDO JOSE BARRIOS DIAZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Magdalena",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243047539",
      "client_email": "BARRIOSYULETZY41@GMAIL.COM",
      "address": "AV  CACHIPO CASA NRO 2 URB LA MAGDALENA LA JULIA",
      "client_identification": "V9698177",
      "nap_box_name": "CTO-00472 DOS",
      "created_at": "2024-07-18T08:43:32.198794",
      "service_detail": {
        "id": 11377,
        "ip": "172.24.39.2",
        "mac": "VSOL00124DA9",
        "serial": "VSOL00124DA9",
        "queue": null,
        "interface": "VLAN114_MAGDALENA",
        "created_at": "2026-01-25T19:57:30.790248",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5340,
      "client_name": "AMANDA LISETH MILLAN VIELMA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04128995208",
      "client_email": "ELIAMNIS212@GMAIL.COM",
      "address": "CALLE PRINCIPAL MANZANA C8 CASA NRO 17 URB SAMAN TARAZONERO 2 TURMERO",
      "client_identification": "V15609730",
      "nap_box_name": "64",
      "created_at": "2024-07-18T09:00:04.993761",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5341,
      "client_name": "CARMEN BEATRIZ BASTARDO ZAPATA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243597803",
      "client_email": "BASTARDOC36@GMAIL.COM",
      "address": "URB. MATA CABALLO, CALLE 10, CASA NRO 632-D, ROSARIO DE PAYA, ARAGUA",
      "client_identification": "V13869717",
      "nap_box_name": "CTO-00569 DOS",
      "created_at": "2024-07-18T09:16:05.378524",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5342,
      "client_name": "YOSMAN ORANGEL ROSENDO PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128904979",
      "client_email": "YOSMANORANGEL@GMAIL.COM",
      "address": "CALLE AVES DEL PARAISO, CASA NRO 31, BARRIO PRADOS DE PAYA, TURMERO, ARAGUA",
      "client_identification": "V22290962",
      "nap_box_name": "CTO-00202",
      "created_at": "2024-07-18T10:17:38.202497",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5343,
      "client_name": "NIVIA CORALIA SUAREZ MARTINEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243799503",
      "client_email": "NIVIA05SUAREZ@GMAIL.COM",
      "address": "CALLE 4 CASA NRO 84 SECTOR PRADOS II ROSARIO DE PAYA",
      "client_identification": "V11188605",
      "nap_box_name": "CTO-00449",
      "created_at": "2024-07-18T10:34:38.051898",
      "service_detail": {
        "id": 4437,
        "ip": "172.19.10.2",
        "mac": "TPLGF4EFC119",
        "serial": "TPLGF4EFC119",
        "queue": "Plan_161892_30183_WispHub",
        "interface": "VLAN242_PRADOS2",
        "created_at": "2024-08-09T21:41:02.711557",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5344,
      "client_name": "LUISA ELENA ALVARADO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04127651685",
      "client_email": "LUIALDO67@GMAIL.COM",
      "address": "CALLE 1 CASA NRO 93 SECTOR PRADOS DE PAYA II",
      "client_identification": "V9594218",
      "nap_box_name": "584 DOS",
      "created_at": "2024-07-18T10:55:56.859173",
      "service_detail": {
        "id": 4447,
        "ip": "172.18.98.2",
        "mac": "TPLGF4EFC114",
        "serial": "TPLGF4EFC114",
        "queue": "Plan_161893_30183_WispHub",
        "interface": "VLAN242_PRADOS2",
        "created_at": "2024-08-09T21:57:28.393751",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5345,
      "client_name": "YENDER ALEXANDER MORA BUENDIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman de Guere",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04123987103",
      "client_email": "YENDERMORA270@GMAIL.COM",
      "address": "CALLE TRINIDAD, CASA 29, PRINCIPAL DE PANTANAL, EL PROGRESO DE SAMAN DE GUERE",
      "client_identification": "V25501254",
      "nap_box_name": "CTO-00239",
      "created_at": "2024-07-18T11:00:36.780244",
      "service_detail": {
        "id": 4166,
        "ip": "172.30.244.2",
        "mac": "OEMT3C626266",
        "serial": "OEMT3C626266",
        "queue": "Plan_132787_24341_WispHub",
        "interface": "VLAN122_SAMAN_GUERE",
        "created_at": "2024-08-02T12:00:30.148902",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5346,
      "client_name": "DORTY ILIANA RODRIGUEZ SARMIENTO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04122202743",
      "client_email": "DORTYILIANA@GMAIL.COM",
      "address": "CALLE 4 CASA NRO 40 BARRIO PRADOS DE PAYA 2 ROSARIO DE PAYA",
      "client_identification": "V19699588",
      "nap_box_name": "CTO-00100",
      "created_at": "2024-07-18T11:15:08.992072",
      "service_detail": {
        "id": 12449,
        "ip": "172.20.136.2",
        "mac": "TPLGF4EFC35D",
        "serial": "TPLGF4EFC35D",
        "queue": null,
        "interface": "VLAN242_PRADOS2",
        "created_at": "2026-05-02T17:13:35.882837",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5347,
      "client_name": "GRISELI COROMOTO PEDRA MENDOZA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Las Rurales",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243796282",
      "client_email": "SIRKIMORA01@GMAIL.COM",
      "address": "CALLE POLEO, CASA NRO 10, SECTOR LAS RURALES, ROSARIO DE PAYA",
      "client_identification": "V16131212",
      "nap_box_name": "CE - 650",
      "created_at": "2024-07-18T11:38:46.086577",
      "service_detail": {
        "id": 4046,
        "ip": "172.30.246.2",
        "mac": "OEMT3C6226CA",
        "serial": "OEMT3C6226CA",
        "queue": "Plan_161905_30183_WispHub",
        "interface": "VLAN252_RURALES_PAYA",
        "created_at": "2024-07-19T15:54:30.965895",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5348,
      "client_name": "ANGEL JHOEL DIAZ LUCENA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Guanarito",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243764578",
      "client_email": "JHOEL782@GMAIL.COM",
      "address": "CALLE MARGARITA RIVERO CASA NRO 21 SECTOR GUANARITO TURMERO",
      "client_identification": "V24419972",
      "nap_box_name": "216",
      "created_at": "2024-07-18T11:44:37.519503",
      "service_detail": {
        "id": 5931,
        "ip": "172.22.102.2",
        "mac": "TPLGB68B4E54",
        "serial": "TPLGB68B4E54",
        "queue": "Plan_92189_15811_WispHub",
        "interface": "VLAN100_OLTs",
        "created_at": "2024-08-21T12:16:18.949143",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5349,
      "client_name": "PEDRO JOSE TORRES ARMELLA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04263498722",
      "client_email": "PEDROARMELLA1966@GMAIL.COM",
      "address": "CALLE ARAGUANEY CASA NRO 8 SECTOR BICENTENARIO ROSARIO DE PAYA",
      "client_identification": "V6112815",
      "nap_box_name": "CTO-00301",
      "created_at": "2024-07-18T13:51:03.048003",
      "service_detail": {
        "id": 12064,
        "ip": "172.18.17.2",
        "mac": "TPLGF4EFC27A",
        "serial": "TPLGF4EFC27A",
        "queue": null,
        "interface": "VLAN243_BICENTENARIO",
        "created_at": "2026-03-14T19:51:09.571049",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5350,
      "client_name": "RAYMI ARISTEL PENA MARTINEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Guanarito",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04128905125",
      "client_email": "RAYMI.PENA1@GMAIL.COM",
      "address": "CALLE MARGARITA RIVERO CASA NRO 12 SECTOR  GUANARITO TURMERO",
      "client_identification": "V13517795",
      "nap_box_name": "216",
      "created_at": "2024-07-18T14:01:06.064756",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5351,
      "client_name": "ANGEL LUIS LORA PHILLIPS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Guanarito",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128578209",
      "client_email": "PHILLIPS010203@GMAIL.COM",
      "address": "CALLE  LA ESTRELLA  CASA NRO 1-1 BARRIO GUANARITO TURMERO",
      "client_identification": "E84501500",
      "nap_box_name": "231",
      "created_at": "2024-07-18T14:06:41.644300",
      "service_detail": {
        "id": 5932,
        "ip": "172.22.86.2",
        "mac": "TPLGB68B5043",
        "serial": "TPLGB68B5043",
        "queue": "Plan_107916_15811_WispHub",
        "interface": "VLAN100_OLTs",
        "created_at": "2024-08-21T12:18:30.915544",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5352,
      "client_name": "CESAR GREGORIO ROJAS HERNANDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Terrazas de Paya",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243778202",
      "client_email": "GREGORIO.GREGORIO1@HOTMAIL.COM",
      "address": "TERRAZAS DE PAYA MANZANA 9 CASA NRO 21",
      "client_identification": "V15267160",
      "nap_box_name": "CTO-00163",
      "created_at": "2024-07-18T14:19:08.086514",
      "service_detail": {
        "id": 11475,
        "ip": "172.17.132.2",
        "mac": "OEMT3C625D8E",
        "serial": "OEMT3C625D8E",
        "queue": null,
        "interface": "VLAN243_BICENTENARIO",
        "created_at": "2026-02-04T14:45:11.655471",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5354,
      "client_name": "SILVIA ALEJANDRA CAPO LANDAETA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04243522763",
      "client_email": "SILVIACAPO38@GMAIL.COM",
      "address": "AV PRINCIPAL DE PAYA CASA PARCELA 8 NRO 2 SECTOR ANTIGUA  HACIENDA DE PAYA  ROSARIO DE PAYA",
      "client_identification": "V18702325",
      "nap_box_name": "CTO-00131",
      "created_at": "2024-07-18T14:33:13.031002",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5355,
      "client_name": "WILLIAMS ARMANDO LUGO RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124651910",
      "client_email": "lugowilliams1012@gmail.com",
      "address": "CALLE 6 CASA NRO 384 URB MATA CABALLO ROSARIO DE PAYA",
      "client_identification": "V29581955",
      "nap_box_name": "CTO-00178",
      "created_at": "2024-07-18T14:35:51.943969",
      "service_detail": {
        "id": 5810,
        "ip": "172.22.73.2",
        "mac": "TPLGB68B4F23",
        "serial": "TPLGB68B4F23",
        "queue": "Plan_161905_30183_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-08-20T09:29:26.631969",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5357,
      "client_name": "DAISY CELINA GUZMAN ALVAREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Magdalena",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124773183",
      "client_email": "DAINA29G@GMAIL.COM",
      "address": "CALLE 1 CASA NRO 07 SECTOR LA  MAGDALENA TURMERO",
      "client_identification": "V9673760",
      "nap_box_name": "CTO-00472 DOS",
      "created_at": "2024-07-18T14:49:13.508236",
      "service_detail": {
        "id": 5805,
        "ip": "172.22.77.2",
        "mac": "TPLGB68B4E62",
        "serial": "TPLGB68B4E62",
        "queue": "Plan_131337_24341_WispHub",
        "interface": "VLAN100_OLTs",
        "created_at": "2024-08-20T08:39:36.355118",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5358,
      "client_name": "RICHARD ALEXANDER MORONTA LUNA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243109412",
      "client_email": "RIDESDDS234@GMAIL.COM",
      "address": "CALLE 2 CASA NRO 2 SECTOR PRADOS II",
      "client_identification": "V15600693",
      "nap_box_name": "CTO-00205",
      "created_at": "2024-07-18T14:51:29.509186",
      "service_detail": {
        "id": 4442,
        "ip": "172.18.108.2",
        "mac": "TPLGF4EFC11F",
        "serial": "TPLGF4EFC11F",
        "queue": "Plan_161892_30183_WispHub",
        "interface": "VLAN242_PRADOS2",
        "created_at": "2024-08-09T21:49:02.048167",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5359,
      "client_name": "MARGIA GIOVANNA ANNUNZIATO BARRIOS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Magdalena",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144471691",
      "client_email": "MARYABARRIOS@HOTMAIL.COM",
      "address": "CALLE CACHIPO CASA NRO 8 URB LA MAGDALENA TURMERO",
      "client_identification": "V17043967",
      "nap_box_name": "CTO-00472 DOS",
      "created_at": "2024-07-18T14:52:19.752591",
      "service_detail": {
        "id": 5782,
        "ip": "172.22.75.2",
        "mac": "TPLGB68B5641",
        "serial": "TPLGB68B5641",
        "queue": "Plan_131337_24341_WispHub",
        "interface": "VLAN100_OLTs",
        "created_at": "2024-08-19T16:12:41.594220",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5360,
      "client_name": "ALEXIS DE JESUS MARTINEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243415810",
      "client_email": "M25046632@GMAIL.COM",
      "address": "CALLE 1 CASA NRO 85 SECTOR PRADOS DE PAYA II",
      "client_identification": "V9884629",
      "nap_box_name": "584 DOS",
      "created_at": "2024-07-18T14:55:40.975108",
      "service_detail": {
        "id": 4444,
        "ip": "172.18.40.2",
        "mac": "TPLGF4EFC309",
        "serial": "TPLGF4EFC309",
        "queue": "Plan_161891_30183_WispHub",
        "interface": "VLAN242_PRADOS2",
        "created_at": "2024-08-09T21:51:46.135141",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5361,
      "client_name": "ADRIANA CAROLINA GONZALEZ DIAZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Laguna Plaza",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04127410201",
      "client_email": "ROSADIAZ20182019@GMAIL.COM",
      "address": "CALLE NEGRO PRIMERO EDIF 10 PISO PB APT 4 CONJUNTO RESIDENCIAL LAGUNA  PLAZA  TURMERO",
      "client_identification": "V22942528",
      "nap_box_name": "2 DOS",
      "created_at": "2024-07-18T15:14:07.867691",
      "service_detail": {
        "id": 5780,
        "ip": "172.22.69.2",
        "mac": "TPLGB68B5057",
        "serial": "TPLGB68B5057",
        "queue": "Plan_153953_15811_WispHub",
        "interface": "VLAN216_LAGUNA_PLAZA_OLT1",
        "created_at": "2024-08-19T16:07:32.024228",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5362,
      "client_name": "MARKOS ALBERTO PEREZ ROBLES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04121523731",
      "client_email": "MARKOSA.PEREZR@GMAIL.COM",
      "address": "AV  D 16 CASA NRO 5 SECTOR SAMAN  TARAZONERO II TURMERO",
      "client_identification": "V20451583",
      "nap_box_name": "278",
      "created_at": "2024-07-18T15:34:22.793377",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5363,
      "client_name": "BARBARA VALENTINA MONTENEGRO  ACOSTA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121340813",
      "client_email": "BARBARAMONTENEGRO18@GMAIL.COM",
      "address": "VEREDA B CASA 1 SECTOR SAMAN TARAZONERO II  EL MACARO",
      "client_identification": "V21370759",
      "nap_box_name": "128",
      "created_at": "2024-07-18T15:44:23.241973",
      "service_detail": {
        "id": 5398,
        "ip": "172.19.226.2",
        "mac": "TPLGB954FB3B",
        "serial": "TPLGB954FB3B",
        "queue": "Plan_107915_1574_WispHub",
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2024-08-16T15:05:52.096854",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5365,
      "client_name": "HECTOR JOSE LINARES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124852125",
      "client_email": "erikaygonzalezh@gmail.com",
      "address": "CALLE 01 MANZANA B-1 CASA NRO 09 URB SAMAN TARAZONERO II SECTOR EL MACARO TURMERO ARAGUA",
      "client_identification": "V16635435",
      "nap_box_name": "506",
      "created_at": "2024-07-18T15:54:29.088687",
      "service_detail": {
        "id": 10458,
        "ip": "10.15.45.2",
        "mac": "OEMT3C620FE6",
        "serial": "OEMT3C620FE6",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2025-12-02T10:58:10.684915",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5366,
      "client_name": "LUIS ANTONIO QUINTERO QUINTERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Residencias Mariño",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04122471527",
      "client_email": "LUISQUI21@GMAIL.COM",
      "address": "CALLE MARIÑO EDIF. RESIDENCIAS MARIÑO PISO 9 APT 92-A CENTRO TURMERO CODIGO POSTAL 2115",
      "client_identification": "V9318971",
      "nap_box_name": "CTO-0518",
      "created_at": "2024-07-18T15:56:53.951403",
      "service_detail": {
        "id": 5775,
        "ip": "172.22.59.2",
        "mac": "TPLGB68B4E91",
        "serial": "TPLGB68B4E91",
        "queue": "Plan_153953_15811_WispHub",
        "interface": "VLAN100_OLTs",
        "created_at": "2024-08-19T15:59:22.025897",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5367,
      "client_name": "ROSMARY CAROLINA ROJAS TORRES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04122078914",
      "client_email": "ROSMARYR26@GMAIL.COM",
      "address": "CALLE 3 CASA NRO C 8-6 SAMAN TARAZONERO II TURMERO",
      "client_identification": "V20758770",
      "nap_box_name": "115",
      "created_at": "2024-07-18T15:59:18.175163",
      "service_detail": {
        "id": 5182,
        "ip": "172.19.96.2",
        "mac": "TPLGB954F205",
        "serial": "TPLGB954F205",
        "queue": "Plan_92223_1574_WispHub",
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2024-08-15T10:52:44.608753",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5368,
      "client_name": "SHALOM ADONAI WR CA",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 25,
      "migrate": true,
      "sector_name": "Laguna Plaza",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04144456521",
      "client_email": "SHALOMADONAIWR1311@GMAIL.COM",
      "address": "CALLE NEGRO PRIMERO EDF 10 PISO 1 APT PH 2 URB LAGUNA PLAZA TURMERO",
      "client_identification": "J410741953",
      "nap_box_name": "2",
      "created_at": "2024-07-18T16:04:57.802001",
      "service_detail": {
        "id": 9420,
        "ip": "172.22.72.2",
        "mac": "TPLGB68B4E06",
        "serial": "TPLGB68B4E06",
        "queue": "queue1",
        "interface": "VLAN216_LAGUNA_PLAZA_OLT1",
        "created_at": "2025-08-25T11:51:12.794820",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5369,
      "client_name": "NELSON ALBERTO DELGADO JARAMILLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243624391",
      "client_email": "NELSONDELGADO203@GMAIL.COM",
      "address": "AV C-9 CASA NRO 6 CONJUNTO RESIDENCIAL SAMAN TARAZONERO II TURMERO",
      "client_identification": "V12141314",
      "nap_box_name": "CTO-00461",
      "created_at": "2024-07-18T16:09:34.620318",
      "service_detail": {
        "id": 5185,
        "ip": "172.19.91.2",
        "mac": "TPLGB954FA35",
        "serial": "TPLGB954FA35",
        "queue": "Plan_137413_1574_WispHub",
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2024-08-15T11:30:33.801403",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5370,
      "client_name": "ADRIANA YOLIMAR BARCENAS RONDON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128995793",
      "client_email": "ADRIANAYBONIER1@GMAIL.COM",
      "address": "CALLE 2 MANZANA C CASA NUMERO 5-13 URB SAMAN TARAZONERO II TURMERO",
      "client_identification": "V26095081",
      "nap_box_name": "186",
      "created_at": "2024-07-18T16:20:57.683120",
      "service_detail": {
        "id": 5771,
        "ip": "172.22.61.2",
        "mac": "TPLGBA68833D",
        "serial": "TPLGBA68833D",
        "queue": "queue1",
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2024-08-19T15:52:10.294299",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5371,
      "client_name": "LEONARDO BLANCO APONTE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04125834809",
      "client_email": "LEOBLANCO993@GMAIL.COM",
      "address": "CALLE MANZANA C-12 CASA NRO 10 SECTOR SAMAN TARAZONERO 2 TURMERO",
      "client_identification": "V16011597",
      "nap_box_name": "485",
      "created_at": "2024-07-18T16:40:31.539321",
      "service_detail": {
        "id": 5186,
        "ip": "172.19.92.2",
        "mac": "TPLGB954FD78",
        "serial": "TPLGB954FD78",
        "queue": "Plan_92223_1574_WispHub",
        "interface": "VLAN100_OLTs",
        "created_at": "2024-08-15T11:33:36.191674",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5372,
      "client_name": "GENESSIS DANIELA BURIEL MORONTA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados de Cafetal",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243586343",
      "client_email": "MORONTAMARIAELENA78@GMAIL.COM",
      "address": "CALLE UNO  CASA SANTA EDUVIGES NRO 3 URB PRADOS DE CAFETAL  TURMERO",
      "client_identification": "V21204129",
      "nap_box_name": "85",
      "created_at": "2024-07-18T16:41:00.863369",
      "service_detail": {
        "id": 5768,
        "ip": "172.21.240.2",
        "mac": "TPLGBA68821D",
        "serial": "TPLGBA68821D",
        "queue": "queue1",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-08-19T15:33:44.024687",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5373,
      "client_name": "CARLOS ALBERTO FERNANDEZ FARIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243010456",
      "client_email": "FERNANDEZCARLO844@GMAIL.COM",
      "address": "CALLE MANZANA C-9 CASA NRO 5 SECTOR SAMAN TARAZONERO II TURMERO",
      "client_identification": "V11977043",
      "nap_box_name": "CTO-00461",
      "created_at": "2024-07-18T16:45:28.044210",
      "service_detail": {
        "id": 5275,
        "ip": "172.19.43.2",
        "mac": "TPLGB955025F",
        "serial": "TPLGB955025F",
        "queue": "Plan_92223_1574_WispHub",
        "interface": "VLAN100_OLTs",
        "created_at": "2024-08-15T17:08:52.313122",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5374,
      "client_name": "JOSE RAUL HERRERA NUÑEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "1ro de Mayo Sur",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121116691",
      "client_email": "AURORACIRILOLUCIO@GMAIL.COM",
      "address": "CALLE 3ERA CASA Nº 08 SECTOR 1RO DE MAYO SUR ROSARIO DE PAYA  TURMERO ESTADO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V15129157",
      "nap_box_name": "CTO-00237",
      "created_at": "2024-07-18T16:49:06.325084",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5376,
      "client_name": "PEDRO FINNO CARRY",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243694924",
      "client_email": "ELLILO12345@GMAIL.COM",
      "address": "CALLE NEGRO PRIMERO CASA 1-1 CASCO DE TURMEROTURMERO",
      "client_identification": "V11976468",
      "nap_box_name": "53",
      "created_at": "2024-07-18T17:08:36.326187",
      "service_detail": {
        "id": 5764,
        "ip": "172.22.66.2",
        "mac": "TPLGBA6876EB",
        "serial": "TPLGBA6876EB",
        "queue": "queue1",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-08-19T15:22:45.089943",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5377,
      "client_name": "ALI RAFAEL SEGOVIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Concepcion",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04241210504",
      "client_email": "ALISEGOVIA012@GMAIL.COM",
      "address": "URBANIZACION NUESTRA SEÑORA DE LA CONCEPCION EDIF 14, PISO 01, APTO  1-4 TURMERO ESTADO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V9886817",
      "nap_box_name": "TORRE 14 LA CONCEPCION",
      "created_at": "2024-07-18T17:14:47.427966",
      "service_detail": {
        "id": 4048,
        "ip": "172.30.250.2",
        "mac": "OEMT3C622AA6",
        "serial": "OEMT3C622AA6",
        "queue": "Plan_131647_24341_WispHub",
        "interface": "VLAN111_CONCEPCION",
        "created_at": "2024-07-19T16:57:39.417129",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5378,
      "client_name": "JORGELIS ALEJANDRA CARRILLO OROPEZA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243695225",
      "client_email": "EVALEON2805@GMAIL.COM",
      "address": "AV 2 CASA NRO 492 URB MATA CABALLO ROSARIO DE PAYA",
      "client_identification": "V26869556",
      "nap_box_name": "CTO-00567 DOS",
      "created_at": "2024-07-19T08:25:11.137834",
      "service_detail": {
        "id": 5010,
        "ip": "172.24.12.2",
        "mac": "VSOL0013B851",
        "serial": "VSOL0013B851",
        "queue": "Plan_161860_30181_WispHub",
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2024-08-13T17:03:45.966504",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5379,
      "client_name": "MIGUEL ANGEL ROMERO URIBE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121799606",
      "client_email": "ANGELURIBE789@GMAIL.COM",
      "address": "CALLE 12 CASA NRO 03 URB PANTIN ROSARIO DE PAYA",
      "client_identification": "V16983103",
      "nap_box_name": "CTO-00165",
      "created_at": "2024-07-19T08:29:00.560424",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5380,
      "client_name": "ACCELL ESTIBERS MEJIAS GALINDO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144933328",
      "client_email": "miriamsenaida1954@gmail.com",
      "address": "PANTIN CALLE 14B CASA NRO 44",
      "client_identification": "V26095933",
      "nap_box_name": "CTO-00048",
      "created_at": "2024-07-19T08:31:53.141042",
      "service_detail": {
        "id": 13017,
        "ip": "172.24.35.2",
        "mac": "ZX:IC:CD:1B:60:FA",
        "serial": "ZXICCD1B60FA",
        "queue": null,
        "interface": "VLAN229_PANTIN",
        "created_at": "2026-09-15T10:54:54.170167",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5381,
      "client_name": "LUIS ANGEL GRUESO HURTADO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados III",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04128305623",
      "client_email": "LUIS_GRUESO@HOTMAIL.COM",
      "address": "CALLE NRO 5 CASA NRO 36 URB PRADOS DE PAYA 3 ROSARIO DE PAYA",
      "client_identification": "V21794186",
      "nap_box_name": "CTO-00305",
      "created_at": "2024-07-19T09:03:19.004420",
      "service_detail": {
        "id": 5021,
        "ip": "172.24.29.2",
        "mac": "VSOL00124089",
        "serial": "VSOL00124089",
        "queue": "queue1",
        "interface": "VLAN236_PRADOS3",
        "created_at": "2024-08-13T17:30:20.829783",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5382,
      "client_name": "DANNY JOSEFINA REQUENA PINTO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados III",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04128369794",
      "client_email": "ROINERXD@GMAIL.COM",
      "address": "CALLE 5 CASA NRO 30 URB PRADOS DE PAYA SECTOR 3 TURMERO",
      "client_identification": "V9917666",
      "nap_box_name": "CTO-00305",
      "created_at": "2024-07-19T09:06:20.596485",
      "service_detail": {
        "id": 5022,
        "ip": "172.24.27.2",
        "mac": "VSOL0013D339",
        "serial": "VSOL0013D339",
        "queue": "Plan_161889_30183_WispHub",
        "interface": "VLAN236_PRADOS3",
        "created_at": "2024-08-13T17:39:49.571874",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5383,
      "client_name": "DAIROBY MILAGROS MARTINEZ CARDOZA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04269303664",
      "client_email": "DAIROBYMARTINEZC@GMAIL.COM",
      "address": "CALLE 1 CASA NRO 47 SECTOR PRADOS DE PAYA II",
      "client_identification": "V27520849",
      "nap_box_name": "CTO-00301",
      "created_at": "2024-07-19T09:29:15.930966",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5384,
      "client_name": "LUIS ESTEBAN RAMOS HERNANDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Prados III",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128999408",
      "client_email": "LUISESTEBANLUISESTEBAN333@GMAIL.COM",
      "address": "CALLE 4 NRO 15 SECTOR PRADOS TURMERO ROSARIO DE PAYA",
      "client_identification": "V22949075",
      "nap_box_name": "CTO-00299",
      "created_at": "2024-07-19T09:31:11.105722",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5385,
      "client_name": "MAIGUALINDA VIVAS BRETO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Laguna Plaza",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04120434404",
      "client_email": "MAIGUALINDAING@GMAIL.COM",
      "address": "AV NEGRO PRIMERO EDIF 12 PISO 1 APT PH-4 CONJUNTO RESIDENCIAL LAGUNA PLAZA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V12566817",
      "nap_box_name": "CTO-00239",
      "created_at": "2024-07-19T09:35:48.418144",
      "service_detail": {
        "id": 4201,
        "ip": "172.30.252.2",
        "mac": "OEMT3C62308E",
        "serial": "OEMT3C62308E",
        "queue": "queue1",
        "interface": "VLAN216_LAGUNA_PLAZA_OLT1",
        "created_at": "2024-08-05T18:24:49.789499",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5386,
      "client_name": "MILECNI DE CHIQUINQUIRA CUETO BELLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados III",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121980870",
      "client_email": "milecnibello@gmail.com",
      "address": "CALLE 4 CASA 18 SECTOR  PRADOS DE PAYA ROSARIO DE PAYA",
      "client_identification": "V18859433",
      "nap_box_name": "CTO-00299",
      "created_at": "2024-07-19T10:04:33.434548",
      "service_detail": {
        "id": 4244,
        "ip": "172.24.21.2",
        "mac": "VSOL001386F9",
        "serial": "VSOL001386F9",
        "queue": "Plan_161870_30183_WispHub",
        "interface": "VLAN236_PRADOS3",
        "created_at": "2024-08-07T15:12:49.138668",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5387,
      "client_name": "WIANEY COROMOTO SEVILLANO IBAÑEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados III",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128381988",
      "client_email": "WIANYELIT@GMAIL.COM",
      "address": "CALLE 4 CASA NRO 30 SECTOR LOS PRADOS III ROSARIO DE PAYA TURMERO",
      "client_identification": "V14039552",
      "nap_box_name": "CTO-00299",
      "created_at": "2024-07-19T10:25:11.542965",
      "service_detail": {
        "id": 5026,
        "ip": "172.24.20.2",
        "mac": "VSOL0013FBB9",
        "serial": "VSOL0013FBB9",
        "queue": "Plan_161889_30183_WispHub",
        "interface": "VLAN236_PRADOS3",
        "created_at": "2024-08-13T17:49:03.075747",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5388,
      "client_name": "KEILY DEL CARMEN RODRIGUEZ SANCHEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Simon Bolivar",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04125205382",
      "client_email": "KEILYDELCARMEN90@GMAIL.COM",
      "address": "CALLE PRINCIPAL C/PARCELA NRO 7 SECTOR EL MACARO",
      "client_identification": "V24928007",
      "nap_box_name": "52",
      "created_at": "2024-07-19T10:25:29.333081",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5389,
      "client_name": "ESTEPHANIE SOLEIL ESCOBAR VIEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128956123",
      "client_email": "ESTEPHANIEE13@GMAIL.COM",
      "address": "CALLE 2 CASA NRO 15 SECTOR PRADOS DE PAYA II",
      "client_identification": "V18702581",
      "nap_box_name": "CTO-00205",
      "created_at": "2024-07-19T10:27:56.577231",
      "service_detail": {
        "id": 12280,
        "ip": "172.18.150.2",
        "mac": "TPLGF4B1D586",
        "serial": "TPLGF4B1D586",
        "queue": null,
        "interface": "VLAN242_PRADOS2",
        "created_at": "2026-04-10T09:57:37.003882",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5390,
      "client_name": "VICTOR JESUS CONTRERAS BARRIOS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados II",
      "plan": {
        "id": 16,
        "name": "RECURRENTE RESIDENCIAL PLAN 800M",
        "cost": "55.00",
        "code": "FOR800",
        "profile": "800M/800M"
      },
      "client_mobile": "04124008686",
      "client_email": "VJCONTROL@HOTMAIL.ES",
      "address": "CALLE 2 CASA NRO 34 PRADOS II",
      "client_identification": "V17954904",
      "nap_box_name": "CTO-00205 DOS",
      "created_at": "2024-07-19T10:29:25.487271",
      "service_detail": {
        "id": 5019,
        "ip": "172.18.54.2",
        "mac": "TPLGF4B1D597",
        "serial": "TPLGF4B1D597",
        "queue": "Plan_161890_30183_WispHub",
        "interface": "VLAN242_PRADOS2",
        "created_at": "2024-08-13T17:21:47.668498",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5391,
      "client_name": "YUBETZA YURIBETH PACHECO PERDOMO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04141463207",
      "client_email": "YUBETZAPACHECO@GMAIL.COM",
      "address": "CALLE 01 CASA NRO 10 SECTOR PRADOS DE PAYA II",
      "client_identification": "V20990662",
      "nap_box_name": "CTO-00118 DOS",
      "created_at": "2024-07-19T10:30:42.112632",
      "service_detail": {
        "id": 4466,
        "ip": "172.20.60.2",
        "mac": "TPLGF4B1D682",
        "serial": "TPLGF4B1D682",
        "queue": "Plan_161893_30183_WispHub",
        "interface": "VLAN242_PRADOS2",
        "created_at": "2024-08-09T22:44:13.403651",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5392,
      "client_name": "YENNY JOSEFINA VARGAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Prados I",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04141478926",
      "client_email": "YORKLEYSANCHEZ@GMAIL.COM",
      "address": "CALLE 17 CASA NRO 1 SECTOR PRADOS DE PAYA 1",
      "client_identification": "V13779064",
      "nap_box_name": "CTO-00211 DOS",
      "created_at": "2024-07-19T10:32:04.799746",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5393,
      "client_name": "ANA IRIS TORRES SANCHEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Prados III",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04143688701",
      "client_email": "KATTITORRES.281@GMAIL.COM",
      "address": "AV PRINCIPAL 2 CASA NRO 22 SECTOR PRADOS III DE PAYA ROSARIO DE PAYA",
      "client_identification": "V7918175",
      "nap_box_name": "579 DOS",
      "created_at": "2024-07-19T10:32:34.308341",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5394,
      "client_name": "BETZABEH ZULAY RIVERO REAL",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Bicentenario",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124528330",
      "client_email": "CHRISTIANIBRAHIMACOSTAFLORES@GMAIL.COM",
      "address": "CALLE FRANCISCO DE MIRANDA CASA NRO 26 URB DESARROLLO URBANÍSTICO ROSARIO DE PAYA ARAGUA",
      "client_identification": "V6904526",
      "nap_box_name": "389",
      "created_at": "2024-07-19T10:35:52.318059",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5395,
      "client_name": "LEONEL ALEXANDER SULBARAN PEÑA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Haras de San Pablo",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243207763",
      "client_email": "LEONELALEXSULBARAN@GMAIL.COM",
      "address": "AV 1 MANZANA A CASA NRO. 9 CONJUNTO RESIDENCIAL HARAS DE SAN PABLO TURMERO, ARAGUA",
      "client_identification": "V26140581",
      "nap_box_name": "641",
      "created_at": "2024-07-19T10:47:55.073824",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5396,
      "client_name": "GREGORY JOSUE VALECILLOS KING",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Isaac Oliveira",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243619880",
      "client_email": "JOSUEDAVIDKING27@GMAIL.COM",
      "address": "CALLE 01 CASA NRO 57 URBANIZACION ISAAC OLIVERA",
      "client_identification": "V20893500",
      "nap_box_name": "CTO-00258",
      "created_at": "2024-07-19T10:55:09.950656",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5398,
      "client_name": "ANGEL DANIEL PARIS MORENO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144545285",
      "client_email": "PARISANGEL0711@GMAIL.COM",
      "address": "CALLE 12 CASA NRO 75 SECTOR LA CASONA II TURMERO",
      "client_identification": "V25527898",
      "nap_box_name": "CTO-00092",
      "created_at": "2024-07-19T10:59:31.928109",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5400,
      "client_name": "JERSON JOSE ALVARADO COLON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados III",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243155033",
      "client_email": "JERSSONALV@GMAIL.COM",
      "address": "PRADOS DE PAYA III AVENIDA 2 MANZANA B CASA NRO 20",
      "client_identification": "V19515987",
      "nap_box_name": "580 DOS",
      "created_at": "2024-07-19T11:05:57.759076",
      "service_detail": {
        "id": 4290,
        "ip": "172.28.94.2",
        "mac": "VSOL0013EE09",
        "serial": "VSOL0013EE09",
        "queue": "Plan_161891_30183_WispHub",
        "interface": "VLAN236_PRADOS3",
        "created_at": "2024-08-08T19:20:34.353672",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5401,
      "client_name": "ROSALINDA PABON  SALAZAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Concepcion III",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04122929633",
      "client_email": "ROSALINDAPABON169@GMAIL.COM",
      "address": "CALLE GUERITO NRO 80 URB LA CONCEPCION 3 TURMERO",
      "client_identification": "V11111514",
      "nap_box_name": "CTO-00456",
      "created_at": "2024-07-19T11:08:16.287857",
      "service_detail": {
        "id": 4292,
        "ip": "172.24.15.2",
        "mac": "VSOL0013E6B1",
        "serial": "VSOL0013E6B1",
        "queue": "Plan_131648_24341_WispHub",
        "interface": "VLAN136_CONCEPCION_3",
        "created_at": "2024-08-08T19:25:26.092429",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5402,
      "client_name": "CESAR AUGUSTO MAGO NARANJO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Concepcion III",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04265197335",
      "client_email": "CESAR_MAGO24@HOTMAIL.COM",
      "address": "AV PRINCIPAL GUERITO CASA NRO 138 URB LA CONCEPCION III CALLE PRINCIPAL TURMERO",
      "client_identification": "V15489808",
      "nap_box_name": "CTO-00456",
      "created_at": "2024-07-19T11:39:21.909935",
      "service_detail": {
        "id": 9329,
        "ip": "172.24.45.2",
        "mac": "VSOL00139E01",
        "serial": "VSOL00139E01",
        "queue": "queue1",
        "interface": "VLAN136_CONCEPCION_3",
        "created_at": "2025-08-07T10:24:28.096737",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5403,
      "client_name": "RICHARD JOSE FERNANDES PEREIRA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villeguita",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04123987633",
      "client_email": "RICHARDPEREIR0087@GMAIL.COM",
      "address": "CALLE MEDINA ANGARITA CASA 06 SECTOR GUANARITO TURMERO",
      "client_identification": "V19834373",
      "nap_box_name": "235",
      "created_at": "2024-07-19T11:41:59.397146",
      "service_detail": {
        "id": 11949,
        "ip": "172.23.234.2",
        "mac": "VSOL00138E69",
        "serial": "VSOL00138E69",
        "queue": null,
        "interface": "VLAN232_GUANARITO_OLT2",
        "created_at": "2026-03-04T12:04:52.405000",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5404,
      "client_name": "BELITZA QUIJADA CASTRO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144536447",
      "client_email": "ANYELINA24PEREZ@GMAIL.COM",
      "address": "CALLE 17 CASA NRO 16 SECTOR LA CASONA II TURMERO",
      "client_identification": "V11091274",
      "nap_box_name": "CTO-00084 DOS",
      "created_at": "2024-07-19T11:44:28.837054",
      "service_detail": {
        "id": 11452,
        "ip": "172.23.239.2",
        "mac": "VSOL0013B0A9",
        "serial": "VSOL0013B0A9",
        "queue": null,
        "interface": "VLAN110_CASONA_2",
        "created_at": "2026-02-03T15:00:37.475344",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5405,
      "client_name": "YOFER ISAAC RODRIGUEZ BRICEÑO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04127650826",
      "client_email": "ARE.BRIC15@GMAIL.COM",
      "address": "CALLE 15 CASA NRO 20 SECTOR PRADO I",
      "client_identification": "V28432556",
      "nap_box_name": "590 DOS",
      "created_at": "2024-07-19T11:50:06.385809",
      "service_detail": {
        "id": 4472,
        "ip": "172.17.95.2",
        "mac": "TPLGF4B1DB93",
        "serial": "TPLGF4B1DB93",
        "queue": "Plan_161892_30183_WispHub",
        "interface": "VLAN239_PRADOS1",
        "created_at": "2024-08-09T22:52:25.343076",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5406,
      "client_name": "NAUDI ANTONIO ALTUVE OJEDA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144540480",
      "client_email": "NAUDI.ANTONIO@GMAIL.COM",
      "address": "CALLE 17 CASA NRO 13 URB LA CASONA II TURMERO",
      "client_identification": "V22285195",
      "nap_box_name": "CTO-00084 DOS",
      "created_at": "2024-07-19T11:50:36.176531",
      "service_detail": {
        "id": 4296,
        "ip": "172.23.248.2",
        "mac": "VSOL00124D99",
        "serial": "VSOL00124D99",
        "queue": "Plan_148293_24341_WispHub",
        "interface": "VLAN110_CASONA_2",
        "created_at": "2024-08-08T19:35:39.877517",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5408,
      "client_name": "MANUEL JESUS LLOVERA ARAUJO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128434384",
      "client_email": "MICKELMANUELJ@GMAIL.COM",
      "address": "CALLE 14 CASA NRO 83 LA CASONA II TURMERO",
      "client_identification": "V14959237",
      "nap_box_name": "CTO-00120",
      "created_at": "2024-07-19T12:35:11.862425",
      "service_detail": {
        "id": 4297,
        "ip": "172.23.237.2",
        "mac": "VSOL0013ADA1",
        "serial": "VSOL0013ADA1",
        "queue": "Plan_131647_24341_WispHub",
        "interface": "VLAN110_CASONA_2",
        "created_at": "2024-08-08T19:38:36.954044",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5409,
      "client_name": "FERMIN ANTONIO BOLIVAR GONZALEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04129937943",
      "client_email": "FBOLIVAR39@GMAIL.COM",
      "address": "CALLE 14 CASA NRO 04 CASONA II TURMERO",
      "client_identification": "V6660858",
      "nap_box_name": "CTO-00088",
      "created_at": "2024-07-19T12:38:20.753602",
      "service_detail": {
        "id": 11100,
        "ip": "172.23.246.2",
        "mac": "VSOL0013E9B1",
        "serial": "VSOL0013E9B1",
        "queue": null,
        "interface": "VLAN110_CASONA_2",
        "created_at": "2026-01-11T17:38:34.823151",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5410,
      "client_name": "JULIO JOSE ANGULO MAYORA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Concepcion",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243287156",
      "client_email": "JULIO.ANGULO2019@GMAIL.COM",
      "address": "CALLE LA CANAL CASA NRO 5-7 SECTOR LA CONCEPCION TURMERO",
      "client_identification": "V15819259",
      "nap_box_name": "503",
      "created_at": "2024-07-19T12:43:32.976120",
      "service_detail": {
        "id": 4417,
        "ip": "172.23.213.2",
        "mac": "VSOL0013B261",
        "serial": "VSOL0013B261",
        "queue": "Plan_137942_24341_WispHub",
        "interface": "VLAN100_OLTs",
        "created_at": "2024-08-09T20:59:11.491834",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5411,
      "client_name": "NAILA ROSAIZI PERAZA MENDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Las Palmas",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04167141065",
      "client_email": "NPERAZA041@GMAIL.COM",
      "address": "CALLE RUIZ PINEDA CASA NRO 10 SECTOR LAS PALMAS ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V18702302",
      "nap_box_name": "CE - 850",
      "created_at": "2024-07-19T12:44:15.073494",
      "service_detail": {
        "id": 4194,
        "ip": "172.31.9.2",
        "mac": "OEMT3C622B6E",
        "serial": "OEMT3C622B6E",
        "queue": "queue1",
        "interface": "VLAN262_LAS_PALMAS_ZTE",
        "created_at": "2024-08-05T13:57:42.129285",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5413,
      "client_name": "ODIN JOSE GERARDI MARTINEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Callejon Rosales",
      "plan": {
        "id": 19,
        "name": "RECURRENTE RESIDENCIAL PLAN 1GB",
        "cost": "74.70",
        "code": "FOR1GB",
        "profile": "1000M/1000M"
      },
      "client_mobile": "04243769668",
      "client_email": "ODINJGERARDIM@GMAIL.COM",
      "address": "CALLEJON LOS ROSALES SECTOR VALLE DE PAYA CASA 6-4 PARCELA 8",
      "client_identification": "V16094437",
      "nap_box_name": "319",
      "created_at": "2024-07-19T13:19:43.792580",
      "service_detail": {
        "id": 5762,
        "ip": "172.22.62.2",
        "mac": "TPLGBA6876D7",
        "serial": "TPLGBA6876D7",
        "queue": "Plan_128611_15811_WispHub",
        "interface": "VLAN206_ROSALES_OLT2",
        "created_at": "2024-08-19T15:19:44.886268",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5414,
      "client_name": "JHONAIKER DENYER CHARDY CARRASCO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "La Casona I",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04124584158",
      "client_email": "DECRISTO887@GMAIL.COM",
      "address": "CALLE 2 CASA NRO 46 CASONA I",
      "client_identification": "V28544466",
      "nap_box_name": "44",
      "created_at": "2024-07-19T13:20:17.693280",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5415,
      "client_name": "CELINA DEL VALLE TABLANTE SALAZAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Concepcion",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243714967",
      "client_email": "CELINAZALAR@GMAIL.COM",
      "address": "CALLE PRINCIPAL  EDIF 9 PISO PB APT URB  SRA DE LA CONCEPCION TURMERO",
      "client_identification": "V11122888",
      "nap_box_name": "0325 DOS",
      "created_at": "2024-07-19T13:24:38.466781",
      "service_detail": {
        "id": 9363,
        "ip": "172.22.76.2",
        "mac": "TPLGBA6877F3",
        "serial": "TPLGBA6877F3",
        "queue": "queue1",
        "interface": "VLAN111_CONCEPCION",
        "created_at": "2025-08-13T14:14:46.213842",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5416,
      "client_name": "JENNY ROSEMERY HERNANDEZ ZAPATA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243529356",
      "client_email": "JH7164959@GMAIL.COM",
      "address": "CALLE 15 CASA NRO 21 URB LA CASONA II TURMERO",
      "client_identification": "V16091669",
      "nap_box_name": "CTO-00087",
      "created_at": "2024-07-19T13:25:10.043729",
      "service_detail": {
        "id": 5759,
        "ip": "172.19.196.2",
        "mac": "TPLGB954FC15",
        "serial": "TPLGB954FC15",
        "queue": "Plan_131647_24341_WispHub",
        "interface": "VLAN110_CASONA_2",
        "created_at": "2024-08-19T15:15:43.860511",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5417,
      "client_name": "ALVARO ENRIQUE PORTILLO MORA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243617110",
      "client_email": "ALVAROEDUARDO2222@GMAIL.COM",
      "address": "CALLE 14 CASA NRO 51 URB LA CASONA II TURMERO",
      "client_identification": "V6295912",
      "nap_box_name": "CTO-00088",
      "created_at": "2024-07-19T13:31:20.411234",
      "service_detail": {
        "id": 5679,
        "ip": "172.18.37.2",
        "mac": "TPLGB954FBAE",
        "serial": "TPLGB954FBAE",
        "queue": "Plan_148293_24341_WispHub",
        "interface": "VLAN110_CASONA_2",
        "created_at": "2024-08-17T14:33:58.545995",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5418,
      "client_name": "AIDA CAROLINA CARIACO DIAZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 43,
        "name": "RECURRENTE RESIDENCIAL PLAN 650M",
        "cost": "46.00",
        "code": "FOR650M",
        "profile": "650M/650M"
      },
      "client_mobile": "04127764514",
      "client_email": "AIDACARIACO697@HOTMAIL.COM",
      "address": "CALLE 3 CASA NRO 181 SECTOR MATA CABALLO TURMERO",
      "client_identification": "V20603960",
      "nap_box_name": "CTO-00422",
      "created_at": "2024-07-19T13:44:25.322522",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5420,
      "client_name": "ALBERTO ALCIDES BOLIVAR ALVAREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04129114169",
      "client_email": "albertobolivar15@gmail.com",
      "address": "CALLE CEDEÑO CASA NRO B-7 SAN CARLOS  TURMERO",
      "client_identification": "V13199577",
      "nap_box_name": "CTO-0441",
      "created_at": "2024-07-19T13:49:38.605213",
      "service_detail": {
        "id": 5751,
        "ip": "172.22.46.2",
        "mac": "TPLGBA6882BB",
        "serial": "TPLGBA6882BB",
        "queue": "Plan_147201_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-08-19T14:53:05.726063",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5421,
      "client_name": "WILMER ALFREDO RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Isaac Oliveira",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243012108",
      "client_email": "RWHISNEIKY@GMAIL.COM",
      "address": "CALLE 1 CASA NRO 27 URB ISAAC OLIVEIRA 1 LA JULIA",
      "client_identification": "V13237466",
      "nap_box_name": "CTO-00257",
      "created_at": "2024-07-19T13:51:15.192942",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5422,
      "client_name": "LUIS ALEJANDRO BRAVO MENDOZA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04127097735",
      "client_email": "ALEJANDROBRAVO232012@GMAIL.COM",
      "address": "CALLE 1B CASA NRO 30 URB PANTIN ROSARIO DE PAYA",
      "client_identification": "V19175029",
      "nap_box_name": "CTO-00127",
      "created_at": "2024-07-19T13:53:50.484309",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5423,
      "client_name": "OMAIRA ACOSTA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Paya Abajo",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243438215",
      "client_email": "MIJARESG580@GMAIL.COM",
      "address": "CALLE PAYA ABAJO C/C SAN ANTONIO CASA NRO 06 SECTOR TURMERO",
      "client_identification": "V13473579",
      "nap_box_name": "272",
      "created_at": "2024-07-19T13:55:45.544331",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5424,
      "client_name": "HUMBERTO JOSE SANCHEZ NIEVES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Guanarito",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121492488",
      "client_email": "HJSANCHEZ123@GMAIL.COM",
      "address": "CALLE LIBERTADOR CASA NRO 2 SECTOR GUANARITO TURMERO",
      "client_identification": "V16435303",
      "nap_box_name": "CTO-00214",
      "created_at": "2024-07-19T13:58:40.814484",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5425,
      "client_name": "CARLOS ALBERTO NUNEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados de Cafetal",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04245555001",
      "client_email": "NUNESCARLOS142@GMAIL.COM",
      "address": "CALLE 1 CASA NRO 2 URB PRADOS DE CAFETAL TURMERO",
      "client_identification": "V11917940",
      "nap_box_name": "544",
      "created_at": "2024-07-19T13:59:24.985937",
      "service_detail": {
        "id": 5716,
        "ip": "172.19.179.2",
        "mac": "TPLGB954FA63",
        "serial": "TPLGB954FA63",
        "queue": "Plan_140304_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-08-18T18:07:46.292442",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5426,
      "client_name": "EXILDA BEATRIS GONZALEZ ROJAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Villeguita",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243069015",
      "client_email": "MARIAFERNANDAVILLEGASGONZALEZ@GMAIL.COM",
      "address": "VILLEGUITA NRO 1 CALLE  RUIZ PINEDA CASA NRO 1",
      "client_identification": "V12726651",
      "nap_box_name": "347",
      "created_at": "2024-07-19T14:03:26.038012",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5427,
      "client_name": "MARYORIS KAUDARI HERNANDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Bicentenario",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128903315",
      "client_email": "KAUDARIS02@GMAIL.COM",
      "address": "CALLE FRANCISCO DE MIRANDA CASA NRO 38 URB DESARROLLO URBANISTICO ROSARIO DE PAYA ARAGUA",
      "client_identification": "V12840000",
      "nap_box_name": "388",
      "created_at": "2024-07-19T14:12:32.127669",
      "service_detail": {
        "id": 4475,
        "ip": "172.20.38.2",
        "mac": "VSOL0048E5C1",
        "serial": "VSOL0048E5C1",
        "queue": "Plan_161892_30183_WispHub",
        "interface": "VLAN243_BICENTENARIO",
        "created_at": "2024-08-09T23:00:05.728784",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5428,
      "client_name": "ECCYS TERESA GARCIA REYES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Palma Real",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144617055",
      "client_email": "ECCYS125@GMAIL.COM",
      "address": "CALLE 5 CASA NRO 96SECTOR PALMA REAL ROSARIO DE PAYA",
      "client_identification": "V17575649",
      "nap_box_name": "403",
      "created_at": "2024-07-19T14:37:29.052004",
      "service_detail": {
        "id": 5042,
        "ip": "172.18.15.2",
        "mac": "VSOL004983B9",
        "serial": "VSOL004983B9",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN244_PALMAREAL",
        "created_at": "2024-08-14T08:52:29.380392",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5429,
      "client_name": "RILSKY DANIEL HERNANDEZ TOVAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Haras de San Pablo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04265169340",
      "client_email": "RIKITY2@GMAIL.COM",
      "address": "CALLE PRINCIPAL HARAS DE SAN PABLO CASA N1 TURMERO EDO. ARAGUA ZONA POSTAL 2115",
      "client_identification": "V10753014",
      "nap_box_name": "248",
      "created_at": "2024-07-19T14:38:14.252501",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5430,
      "client_name": "KEILA ISANDRA LOVERA ROSAL",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128996473",
      "client_email": "FERNANDOSEP10@GMAIL.COM",
      "address": "MANZANA B-8 CASA 4 SECTOR SAMAN  TARAZONERO II EL MACARO TURMERO",
      "client_identification": "V16132300",
      "nap_box_name": "186",
      "created_at": "2024-07-19T14:40:25.519244",
      "service_detail": {
        "id": 5714,
        "ip": "172.22.57.2",
        "mac": "TPLGBA6875CB",
        "serial": "TPLGBA6875CB",
        "queue": "Plan_138775_1574_WispHub",
        "interface": "VLAN100_OLTs",
        "created_at": "2024-08-18T18:00:25.372334",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5431,
      "client_name": "ARLYN ESTEPHANYERLY DIAZ CARTAYA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04125971660",
      "client_email": "ARLYN295@GMAIL.COM",
      "address": "CALLE 2 MANZANA C1 CASA NRO 7 SECTOR SAMAN TARAZONERO II TURMERO",
      "client_identification": "V20818722",
      "nap_box_name": "186",
      "created_at": "2024-07-19T14:43:45.482023",
      "service_detail": {
        "id": 5713,
        "ip": "172.29.31.2",
        "mac": "TPLGBA688285",
        "serial": "TPLGBA688285",
        "queue": "Plan_137413_1574_WispHub",
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2024-08-18T17:58:11.956065",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5432,
      "client_name": "YOLANDA MARGARITA MARTINEZ DE SANCHEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Palma Real",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128650993",
      "client_email": "YOLANDA202363@GMAIL.COM",
      "address": "CALLE 2 CASA NRO 19 URB PALMA REAL II",
      "client_identification": "V6162794",
      "nap_box_name": "CTO-00318",
      "created_at": "2024-07-19T14:48:37.753882",
      "service_detail": {
        "id": 4594,
        "ip": "172.18.55.2",
        "mac": "VSOL005234D1",
        "serial": "VSOL005234D1",
        "queue": "queue1",
        "interface": "VLAN244_PALMAREAL",
        "created_at": "2024-08-11T19:17:39.409242",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5433,
      "client_name": "ROSAURA YAMILETH OLLARVIRES NIEVES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243592860",
      "client_email": "OLLARVIRES01@GMAIL.COM",
      "address": "CALLE MANZANA B2 CASA NRO 13 URB  SAMAN  TARAZONERO II",
      "client_identification": "V22289813",
      "nap_box_name": "128",
      "created_at": "2024-07-19T14:50:21.285300",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5434,
      "client_name": "WILMER JOSE RAMIREZ PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04143439967",
      "client_email": "stivengomes56@gmail.com",
      "address": "AV 01 NRO 687 D SECTOR  MATA CABALLO  ROSARIO DE PAYA",
      "client_identification": "V10344218",
      "nap_box_name": "CTO-00210",
      "created_at": "2024-07-19T14:59:19.955575",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5437,
      "client_name": "YUSMERY ALEJANDRA ROJAS BANDES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Paya Abajo",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04243437144",
      "client_email": "JHERBYS@HOTMAIL.COM",
      "address": "CALLE SAN ANTONIO  CASA NRO 25 SECTOR PAYA ABAJO ROSARIO DE PAYA",
      "client_identification": "V16131305",
      "nap_box_name": "271",
      "created_at": "2024-07-19T15:10:38.071886",
      "service_detail": {
        "id": 7524,
        "ip": "172.23.202.2",
        "mac": "VSOL0012EEA1",
        "serial": "VSOL0012EEA1",
        "queue": "Plan_161862_30181_WispHub",
        "interface": "VLAN231_PAYABAJO",
        "created_at": "2024-12-17T13:23:00.806708",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5438,
      "client_name": "MARIA LILIA FRANCISCO RIBEIRO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128990888",
      "client_email": "FRANCISCOJUANAURELIO@GMAIL.COM",
      "address": "CALLE 6 CASA NRO 410 URB MATA CABALLO ROSARIO DE PAYA",
      "client_identification": "V30498925",
      "nap_box_name": "CTO-00312",
      "created_at": "2024-07-19T15:13:22.986532",
      "service_detail": {
        "id": 9953,
        "ip": "172.22.60.2",
        "mac": "TPLGBA6875CE",
        "serial": "TPLGBA6875CE",
        "queue": null,
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2025-11-11T11:00:10.580539",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5439,
      "client_name": "KATHERINE YELITZA HERNANDEZ SANDOVAL",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121776730",
      "client_email": "KARELYZH@GMAIL.COM",
      "address": "CALLE 16 B CASA NRO 32 URB PANTIN ROSARIO DE PAYA",
      "client_identification": "V19791529",
      "nap_box_name": "CTO-00026",
      "created_at": "2024-07-19T15:13:34.029716",
      "service_detail": {
        "id": 4430,
        "ip": "172.23.221.2",
        "mac": "VSOL00129FB9",
        "serial": "VSOL00129FB9",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN229_PANTIN",
        "created_at": "2024-08-09T21:31:09.479011",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5440,
      "client_name": "LEONEL HILARION FRAGOZA LOPEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04120399223",
      "client_email": "LOPEZHILARION3@GMAIL.COM",
      "address": "CALLE 9A CASA NRO 04 URB PANTIN ROSARIO DE PAYA",
      "client_identification": "V20452535",
      "nap_box_name": "CTO-00142",
      "created_at": "2024-07-19T15:16:09.148445",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5441,
      "client_name": "EDUARDO JOSE RIVERO MARTINEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Palma Real",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128711780",
      "client_email": "EDUJRIVERO12@GMAIL.COM",
      "address": "ROSARIO DE PAYA PALMA REAL CALLE PRINCIPAL CASA NRO 51",
      "client_identification": "V15365761",
      "nap_box_name": "CTO-00208",
      "created_at": "2024-07-19T15:18:01.783707",
      "service_detail": {
        "id": 4595,
        "ip": "172.18.19.2",
        "mac": "VSOL0047CE01",
        "serial": "VSOL0047CE01",
        "queue": "Plan_161891_30183_WispHub",
        "interface": "VLAN244_PALMAREAL",
        "created_at": "2024-08-11T19:20:07.920967",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5442,
      "client_name": "ANDREA ROXANA PERDOMO CONTRERAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144893532",
      "client_email": "ANDREAPERDOMO1621@GMAIL.COM",
      "address": "CALLE 4-A CASA NRO 5 URB PANTIN ROSARIO DE PAYA",
      "client_identification": "V21466488",
      "nap_box_name": "CTO-00110",
      "created_at": "2024-07-19T15:23:18.180513",
      "service_detail": {
        "id": 11549,
        "ip": "172.23.217.2",
        "mac": "VSOL0013E8A1",
        "serial": "VSOL0013E8A1",
        "queue": null,
        "interface": "VLAN229_PANTIN",
        "created_at": "2026-02-08T14:26:13.912874",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5443,
      "client_name": "EVER EDUARDO CASTRO CORDERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121481707",
      "client_email": "EVER8995@GMAIL.COM",
      "address": "CALLE NRO 4-A CASA NRO 32 PANTIN ROSARIO DE PAYA",
      "client_identification": "V24419192",
      "nap_box_name": "CTO-00134",
      "created_at": "2024-07-19T15:33:16.678942",
      "service_detail": {
        "id": 4438,
        "ip": "172.23.219.2",
        "mac": "OEMT3C626276",
        "serial": "OEMT3C626276",
        "queue": "queue1",
        "interface": "VLAN229_PANTIN",
        "created_at": "2024-08-09T21:42:55.981580",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5444,
      "client_name": "JHON FLAVIANO ZAMBRANO PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243772930",
      "client_email": "jhorker7@gmail.com",
      "address": "CALLE 12 CASA B NRO 43 URB HACIENDA PANTIN TURMERO",
      "client_identification": "V14680121",
      "nap_box_name": "CTO-00166",
      "created_at": "2024-07-19T15:45:55.594969",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5445,
      "client_name": "ALCALDIA DEL MUNICIPIO SANTIAGO MARIÑO",
      "client_type_name": "INTERCAMBIO",
      "client_subdivision": "ACTIVO_INTERCAMBIO",
      "status_name": "Activo",
      "cycle": 25,
      "migrate": false,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 83,
        "name": "RECURRENTE INSTITUCIONAL 80M",
        "cost": "0.00",
        "code": "FO-R80",
        "profile": "80M/80M"
      },
      "client_mobile": "04120296278",
      "client_email": "ADMON.ALCALDIAMARINO@GMAIL.COM",
      "address": "AV PRINCIPAL DE VALLE LINDO ,URB VALLE LINDO EDIFICIO DE LA ALCALDÍA/TURMERO",
      "client_identification": "G200036826",
      "nap_box_name": "110",
      "created_at": "2024-07-19T16:02:53.955697",
      "service_detail": {
        "id": 10118,
        "ip": "172.30.251.2",
        "mac": "OEMT3C622BEE",
        "serial": "OEMT3C622BEE",
        "queue": null,
        "interface": "VLAN200_OLTs",
        "created_at": "2025-11-14T08:47:18.730900",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5446,
      "client_name": "GRECIA EYERLIN OROPEZA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243153218",
      "client_email": "GRECIAEYERLIN@GMAIL.COM",
      "address": "CALLE 5 NRO 330 B  SECTOR MATA CABALLO ROSARIO DE PAYA",
      "client_identification": "V27996566",
      "nap_box_name": "CTO-00069",
      "created_at": "2024-07-19T16:07:03.470362",
      "service_detail": {
        "id": 5709,
        "ip": "172.22.35.2",
        "mac": "TPLGB68B53CA",
        "serial": "TPLGB68B53CA",
        "queue": "queue1",
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2024-08-18T17:43:49.253734",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5447,
      "client_name": "DULCE YESENIA PRADA TADINO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04143462158",
      "client_email": "ALIPRADA@HOTMAIL.COM",
      "address": "CALLE 6 CASA NRO 436 URB  MATA CABALLO ROSARIO DE PAYA",
      "client_identification": "V5568093",
      "nap_box_name": "CTO-00312",
      "created_at": "2024-07-19T16:09:14.944453",
      "service_detail": {
        "id": 5708,
        "ip": "172.22.37.2",
        "mac": "TPLGB68B5C63",
        "serial": "TPLGB68B5C63",
        "queue": "Plan_161889_30183_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-08-18T17:40:57.260170",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5448,
      "client_name": "JOSY ANAIS ROSALES CORREDOR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04243522720",
      "client_email": "JOSYROSALESCORREDOR@GMAIL.COM",
      "address": "AV. 2 CASA NRO. 508 URB. MATACABALLO ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V19864055",
      "nap_box_name": "CTO-00238",
      "created_at": "2024-07-19T16:12:20.078131",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5449,
      "client_name": "MANUEL ANTONIO MARTINEZ TORREALBA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Palma Real",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04144563429",
      "client_email": "TORREALBAMANUEL1004@GMAIL.COM",
      "address": "CALLE 2 NRO 21 PALMA REAL ROSARIO DE PAYA",
      "client_identification": "V18352558",
      "nap_box_name": "400",
      "created_at": "2024-07-19T16:13:54.676873",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5450,
      "client_name": "YOLETTY COROMOTO MONTENEGRO GALINDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04124614435",
      "client_email": "YOLETTYMONTENEGRO18@GMAIL.COM",
      "address": "CALLE 6 CASA NRO 383 URB MATA CABALLO TURMERO",
      "client_identification": "V9675400",
      "nap_box_name": "CTO-00178",
      "created_at": "2024-07-19T16:14:43.399954",
      "service_detail": {
        "id": 12945,
        "ip": "172.17.1.90",
        "mac": "TP:LG:B6:8B:58:30",
        "serial": "TPLGB68B5830",
        "queue": null,
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2026-09-01T12:11:50.782884",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5451,
      "client_name": "OCTAVIO AUGUSTO MONTILLA SOTO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Magdalena",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128660733",
      "client_email": "OCTAVIOMONTILLA9436935@GMAIL.COM",
      "address": "CALLE 11 CASA NRO 42 LA MAGDALENA AV INTERCOMUNAL",
      "client_identification": "V9436935",
      "nap_box_name": "357",
      "created_at": "2024-07-19T16:15:58.307716",
      "service_detail": {
        "id": 10030,
        "ip": "172.23.2.2",
        "mac": "VSOL00481569",
        "serial": "VSOL00481569",
        "queue": null,
        "interface": "VLAN114_MAGDALENA",
        "created_at": "2025-11-11T16:18:21.869149",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5452,
      "client_name": "YOSLENYS DANIELA OLIVO UTRERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243566280",
      "client_email": "YOLIVOUTRERA@GMAIL.COM",
      "address": "CALLE 6 CASA NRO 380 SECTOR  MATA CABALLO  SECTOR LAS CASAS  ROSARIO DE PAYA",
      "client_identification": "V29659158",
      "nap_box_name": "CTO-00178",
      "created_at": "2024-07-19T16:17:06.311450",
      "service_detail": {
        "id": 5706,
        "ip": "172.22.34.2",
        "mac": "TPLGB68B54EC",
        "serial": "TPLGB68B54EC",
        "queue": "Plan_161905_30183_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-08-18T17:36:30.508499",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5453,
      "client_name": "MARIANGEL CASTRO GARCIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243772146",
      "client_email": "MARIANGELCASTRO25@GMAIL.COM",
      "address": "AV INTERCOMUNAL TURMERO MARACAY MANZANA F 2 CASA NRO 22 URB SAMAN TARAZONERO II TURMERO",
      "client_identification": "V25527343",
      "nap_box_name": "CE - 227",
      "created_at": "2024-07-19T16:18:17.183783",
      "service_detail": {
        "id": 11208,
        "ip": "172.21.20.2",
        "mac": "VSOL00522D81",
        "serial": "VSOL00522D81",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2026-01-16T17:59:56.832555",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5454,
      "client_name": "FRANCISCO JAVIER LOPEZ MERMEJO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243091501",
      "client_email": "JAVIER5SG38@GMAIL.COM",
      "address": "CALLE 12 CASA NRO. 672-A URB. MATACABALLO ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V13779746",
      "nap_box_name": "CTO-00210",
      "created_at": "2024-07-19T16:19:11.317717",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5455,
      "client_name": "ALEJANDRO JESUS ALBARRAN MOYETON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121798005",
      "client_email": "ALBARRANALEJANDRO1414@GMAIL.COM",
      "address": "CALLE NUMERO 5 CASA NRO 11 URB SAMAN TARAZONERO 1 TURMERO ARAGUA",
      "client_identification": "V28154610",
      "nap_box_name": "269",
      "created_at": "2024-07-19T16:21:32.929239",
      "service_detail": {
        "id": 9967,
        "ip": "172.20.42.2",
        "mac": "VSOL004914F1",
        "serial": "VSOL004914F1",
        "queue": null,
        "interface": "VLAN140_SMT1_ZTE",
        "created_at": "2025-11-11T11:23:24.493021",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5456,
      "client_name": "WILSON ANTONIO BETANCOURT HERNANDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04149352506",
      "client_email": "WILBET4268@GMAIL.COM",
      "address": "CALLE 15 -A CASA NRO 20 URB PANTIN ROSARIO DE PAYA",
      "client_identification": "V13199588",
      "nap_box_name": "CTO-00201",
      "created_at": "2024-07-19T16:30:45.540932",
      "service_detail": {
        "id": 4443,
        "ip": "172.23.218.2",
        "mac": "VSOL0012EE61",
        "serial": "VSOL0012EE61",
        "queue": "Plan_161891_30183_WispHub",
        "interface": "VLAN229_PANTIN",
        "created_at": "2024-08-09T21:49:40.391891",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5457,
      "client_name": "ROSA MARLENE RIOS HERRERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04243682681",
      "client_email": "RIOSORIANA49@GMAIL.COM",
      "address": "AV 2 CASA NRO 475 MATA CABALLO ROSARIO DE PAYA",
      "client_identification": "V12335564",
      "nap_box_name": "CTO-00222",
      "created_at": "2024-07-19T16:36:13.663949",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5458,
      "client_name": "YISCEL YASMIN GARCIA VILLEGAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124864835",
      "client_email": "YISCELGARCIA@GMAIL.COM",
      "address": "CALLE 1 CASA NRO. 26 SECTOR MATACABALLO, TURMERO EDO. ARAGUA ROSARIO DE PAYA ZONA POSTAL 2115",
      "client_identification": "V16552955",
      "nap_box_name": "CTO-00131",
      "created_at": "2024-07-19T16:38:45.684214",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5459,
      "client_name": "DEGENBERTH JOSE PENA HERNANDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243286087",
      "client_email": "DENGERBERT1983@GMAIL.COM",
      "address": "AV 2 CASA NRO 525-B SECTOR MATA CABALLO TURMERO",
      "client_identification": "V17245883",
      "nap_box_name": "CTO-00222",
      "created_at": "2024-07-19T16:42:54.011949",
      "service_detail": {
        "id": 5701,
        "ip": "172.22.21.2",
        "mac": "TPLGB68B5218",
        "serial": "TPLGB68B5218",
        "queue": "Plan_161889_30183_WispHub",
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2024-08-18T17:21:53.173420",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5460,
      "client_name": "MARIA DE LOS ANGELES VIEIRA DE YAJURE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04143584290",
      "client_email": "MARIAVIEIRA.C@HOTMAIL.COM",
      "address": "CALLE 4 CASA 282 URB MATA CABALLO ROSARIO DE PAYA",
      "client_identification": "V15601887",
      "nap_box_name": "CTO-00272",
      "created_at": "2024-07-19T16:45:14.988802",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5461,
      "client_name": "LOURDES JULIETA SIONCHEZ MENDOZA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Palma Real",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04123616016",
      "client_email": "LOURDESSIONCHEZ@GMAIL.COM",
      "address": "CALLE PRINCIPAL VEREDA 2 CASA NRO 43 SECTOR PALMA REAL",
      "client_identification": "V9957155",
      "nap_box_name": "CTO-00209",
      "created_at": "2024-07-19T16:45:35.724445",
      "service_detail": {
        "id": 10584,
        "ip": "172.18.188.2",
        "mac": "VSOL0047DBC1",
        "serial": "VSOL0047DBC1",
        "queue": null,
        "interface": "VLAN244_PALMAREAL",
        "created_at": "2025-12-04T13:05:13.018486",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5462,
      "client_name": "FANNY COROMOTO GARCIA ARRIECHE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243732800",
      "client_email": "GARCIAFANNY0508@GMAIL.COM",
      "address": "CALLE 8 CASA NRO 585-A MATA CABALLO ROSARIO DE PAYA",
      "client_identification": "V17985392",
      "nap_box_name": "CTO-00130",
      "created_at": "2024-07-19T16:48:16.009034",
      "service_detail": {
        "id": 10293,
        "ip": "172.22.22.2",
        "mac": "TPLGB68B595C",
        "serial": "TPLGB68B595C",
        "queue": null,
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2025-11-24T15:30:28.469475",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5463,
      "client_name": "ALEJANDRO JOSE TINEDO SANCHEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Terrazas de Juan Pablo",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04121482584",
      "client_email": "TINEDOEUNICE@GMAIL.COM",
      "address": "CALLE LA LLANERA EDIFICIO PISO PB APTO A-2 PARCELA 15 CONJUNTO RESIDENCIAL TERRAZAS DE TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V14786104",
      "nap_box_name": "13",
      "created_at": "2024-07-19T17:21:04.928090",
      "service_detail": {
        "id": 4086,
        "ip": "172.31.12.2",
        "mac": "OEMT3C622B32",
        "serial": "OEMT3C622B32",
        "queue": "Plan_132787_24341_WispHub",
        "interface": "VLAN130_TERRAZAS_JP",
        "created_at": "2024-07-22T14:40:03.088602",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5464,
      "client_name": "GULIECCEL ANDREINA MUNOZ HIGUERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "1ro de Mayo Norte",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04120286712",
      "client_email": "PEREZJANECCEL@GMAIL.COM",
      "address": "PRIMERO DE MAYO NORTE CASA #13 CALLE GUAICAIPURO CON TIUNA",
      "client_identification": "V32759701",
      "nap_box_name": "CTO - 919",
      "created_at": "2024-07-20T10:03:41.694950",
      "service_detail": {
        "id": 4080,
        "ip": "172.31.13.2",
        "mac": "OEMT3C6225F6",
        "serial": "OEMT3C6225F6",
        "queue": "Plan_161903_30183_WispHub",
        "interface": "VLAN261_1ERO_MAYO",
        "created_at": "2024-07-22T10:01:21.076109",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5465,
      "client_name": "JHASLY BRITTANY ROJAS MALDONADO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados III",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124179644",
      "client_email": "JHASLY05ROJAS@GMAIL.COM",
      "address": "CALLE 1 CASA NRO 19 URB PRADOS DE PAYA III TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V29581807",
      "nap_box_name": "CTO-00021",
      "created_at": "2024-07-20T12:34:43.118879",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5466,
      "client_name": "LUIS ANTONIO JAJOY QUINCHOA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124324313",
      "client_email": "ANTONIOQUINCHOA54@GMAIL.COM",
      "address": "CALLE 11-B CASA NRO 45 URB PANTIN TURMERO EDO. ARAGUA",
      "client_identification": "V19515475",
      "nap_box_name": "CTO-00168",
      "created_at": "2024-07-20T14:22:57.747355",
      "service_detail": {
        "id": 4068,
        "ip": "172.17.242.2",
        "mac": "OEMT3C625D82",
        "serial": "OEMT3C625D82",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN229_PANTIN",
        "created_at": "2024-07-20T14:29:47.521460",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5467,
      "client_name": "MILEIDY ADRIANA ZAMBRANO GODOY",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04267923409",
      "client_email": "MILEIDYADRIANA@GMAIL.COM",
      "address": "CALLE 11B CASA NRO 34 URB PANTIN TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V18331622",
      "nap_box_name": "CTO-00168",
      "created_at": "2024-07-20T14:51:27.291282",
      "service_detail": {
        "id": 4071,
        "ip": "172.25.151.2",
        "mac": "OEMT3C625DDE",
        "serial": "OEMT3C625DDE",
        "queue": "queue1",
        "interface": "VLAN229_PANTIN",
        "created_at": "2024-07-20T15:05:45.580794",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5469,
      "client_name": "GUSTAVO ALEJANDRO DUQUE BLANCO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Durpa",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128931454",
      "client_email": "GUSTAVOADB16@GMAIL.COM",
      "address": "CALLE MANZANA 11 CASA NRO 5 URB FUNDA BARRIO ROSARIO DE PAYA",
      "client_identification": "V27048555",
      "nap_box_name": "385",
      "created_at": "2024-07-22T08:16:24.326850",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5471,
      "client_name": "CARLOS JOSUE SUAREZ RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04123985073",
      "client_email": "EJSG0912@GMAIL.COM",
      "address": "VEREDA F2-31 CASA NRO 31 SECTOR SAMAN TARAZONERO II",
      "client_identification": "V18326397",
      "nap_box_name": "93",
      "created_at": "2024-07-22T08:29:08.006191",
      "service_detail": {
        "id": 4603,
        "ip": "172.20.46.2",
        "mac": "VSOL0048E429",
        "serial": "VSOL0048E429",
        "queue": "Plan_107915_1574_WispHub",
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2024-08-11T20:05:04.250879",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5472,
      "client_name": "EINY JOSMAR GRANADILLO GONZALEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124620035",
      "client_email": "EINYJ25@GMAIL.COM",
      "address": "CALLE MANZANA C-16 CASA NRO 1 SECTOR SAMAN TARAZONERO II TURMERO ARAGUA",
      "client_identification": "V30972481",
      "nap_box_name": "485",
      "created_at": "2024-07-22T08:31:13.784841",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5473,
      "client_name": "MARBELIS SOLEICYS NINO DIAZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04160662344",
      "client_email": "MARBELIS643@GMAIL.COM",
      "address": "CALLE CARREÑO EDIF 22 PISO 3 APT 4 URB HACIENDA EL NISPERO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V15130152",
      "nap_box_name": "CTO-00207",
      "created_at": "2024-07-22T09:31:27.544385",
      "service_detail": {
        "id": 4218,
        "ip": "172.31.30.2",
        "mac": "HWTCD6B32A91",
        "serial": "HWTCD6B32A91",
        "queue": "Plan_153953_15811_WispHub",
        "interface": "VLAN209_ZAMORA_OLT1",
        "created_at": "2024-08-07T08:12:05.988965",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5474,
      "client_name": "EMPRENDIMIENTO CESAR BECERRA 5",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04128907734",
      "client_email": "FINANCE@IMAGENCIES.COM",
      "address": "CALLE URDANETA CASA NRO 24 SECTOR CENTRO DE TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "J504515140",
      "nap_box_name": "CTO-00246",
      "created_at": "2024-07-22T09:48:06.540080",
      "service_detail": {
        "id": 9766,
        "ip": "172.31.16.2",
        "mac": "OEMT3C6226D6",
        "serial": "OEMT3C6226D6",
        "queue": null,
        "interface": "VLAN200_OLTs",
        "created_at": "2025-11-10T12:28:28.810314",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5475,
      "client_name": "MARIANNA ABACHE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Canaima",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124672462",
      "client_email": "marianaabache@gmail.com",
      "address": "CALLE 4 CASA NRO 02 URB CANAIMA ROSARIO DE PAYA ARAGUA",
      "client_identification": "V12738802",
      "nap_box_name": "CTO-00315 ",
      "created_at": "2024-07-22T10:13:05.844132",
      "service_detail": {
        "id": 4605,
        "ip": "172.17.144.2",
        "mac": "VSOL004987D9",
        "serial": "VSOL004987D9",
        "queue": "Plan_161864_30181_WispHub",
        "interface": "VLAN237_CANAIMA",
        "created_at": "2024-08-11T20:20:30.065744",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5476,
      "client_name": "EZEQUIEL DAVID GUTIERREZ DELGADO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Canaima",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04122036011",
      "client_email": "EGUTIERREZ2401@GMAIL.COM",
      "address": "CALLE 7 CASA NRO 6 SECTOR CANAIMA",
      "client_identification": "V20336845",
      "nap_box_name": "418",
      "created_at": "2024-07-22T10:18:18.586354",
      "service_detail": {
        "id": 9684,
        "ip": "172.18.103.2",
        "mac": "OEMT3C6201CA",
        "serial": "OEMT3C6201CA",
        "queue": null,
        "interface": "VLAN237_CANAIMA",
        "created_at": "2025-11-04T10:36:15.388535",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5477,
      "client_name": "YOLIMAR DEL VALLE VALECILLOS TREJO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Bicentenario",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124610357",
      "client_email": "YOLIMARVALECILLOS345@GMAIL.COM",
      "address": "CALLE AVES DEL PARAISO MANZANA B CASA NRO 23 URB DESARROLLO URBANISTICO ROSARIO DE PAYA",
      "client_identification": "V15043453",
      "nap_box_name": "CTO-00302",
      "created_at": "2024-07-22T10:51:01.361622",
      "service_detail": {
        "id": 5055,
        "ip": "172.19.86.2",
        "mac": "VSOL00497D39",
        "serial": "VSOL00497D39",
        "queue": "Plan_161891_30183_WispHub",
        "interface": "VLAN243_BICENTENARIO",
        "created_at": "2024-08-14T10:07:53.720691",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5478,
      "client_name": "YULIANI VICTORIA SANDOVAL CASTILLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128365855",
      "client_email": "julia01casti@gmail.com",
      "address": "CALLE MANZANA B-12 CASA NRO 12 SECTOR SAMAN TARAZONERO II",
      "client_identification": "V27863129",
      "nap_box_name": "CTO-00461",
      "created_at": "2024-07-22T10:55:56.265298",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5479,
      "client_name": "HUMBERTO ANTONIO REYES ALVAREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Las Rurales",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04149436447",
      "client_email": "CANELABETICO@GMAIL.COM",
      "address": "CALLE 106 CASA NRO 58 ROSARIO DE PAYA SECTOR LAS RURALES",
      "client_identification": "V19207009",
      "nap_box_name": "CTO-00200",
      "created_at": "2024-07-22T15:23:07.271281",
      "service_detail": {
        "id": 4097,
        "ip": "172.31.18.2",
        "mac": "OEMT3C622B86",
        "serial": "OEMT3C622B86",
        "queue": "Plan_161905_30183_WispHub",
        "interface": "VLAN252_RURALES_PAYA",
        "created_at": "2024-07-23T11:21:45.861485",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5480,
      "client_name": "CELIMAR ANILEC PACHECO VELASQUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Bicentenario",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243102739",
      "client_email": "CELIMARPACHECO@GMAIL.COM",
      "address": "CALLE AVES DEL PARAISO MANZANA B CASA NRO 23 URB DESARROLLO URBANISTICO SECTOR BICENTENARIO",
      "client_identification": "V18163680",
      "nap_box_name": "CTO-00202",
      "created_at": "2024-07-22T15:55:39.961513",
      "service_detail": {
        "id": 4607,
        "ip": "172.20.27.2",
        "mac": "VSOL00128859",
        "serial": "VSOL00128859",
        "queue": "Plan_161893_30183_WispHub",
        "interface": "VLAN243_BICENTENARIO",
        "created_at": "2024-08-11T20:25:57.966923",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5481,
      "client_name": "FEDERICO OLINTO SALAS  SEQUERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Bicentenario",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128874885",
      "client_email": "FED.53SALM@GMAIL.COM",
      "address": "CALLE AVES DEL PARAISO MANZANA C CASA NRO 11 URB BICENTENARIO ROSARIO DE PAYA",
      "client_identification": "V17061029",
      "nap_box_name": "384",
      "created_at": "2024-07-22T16:12:15.716835",
      "service_detail": {
        "id": 4608,
        "ip": "172.20.166.2",
        "mac": "VSOL001259D1",
        "serial": "VSOL001259D1",
        "queue": "Plan_161892_30183_WispHub",
        "interface": "VLAN243_BICENTENARIO",
        "created_at": "2024-08-11T20:29:04.828130",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5482,
      "client_name": "JENNY ZULEIMA SILVA DE SILVESTRE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Bicentenario",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04127571708",
      "client_email": "JEZULE-500@HOTMAIL.COM",
      "address": "CALLE AVES DEL PARAISO MANZANA C CASA NRO 5 SECTOR DESARROLLO URBANISTICO BICENTENARIO",
      "client_identification": "V12165842",
      "nap_box_name": "384",
      "created_at": "2024-07-22T16:19:41.799413",
      "service_detail": {
        "id": 4609,
        "ip": "172.18.146.2",
        "mac": "VSOL0051E5F9",
        "serial": "VSOL0051E5F9",
        "queue": "Plan_161893_30183_WispHub",
        "interface": "VLAN243_BICENTENARIO",
        "created_at": "2024-08-11T20:32:19.725316",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5483,
      "client_name": "THALIA TAIBET QUINTERO UZCATEGUI",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128861965",
      "client_email": "ABRAHANMILLAN6@GMAIL.COM",
      "address": "CALLE MANZANA J-1 CASA NRO 15 URB SAMAN TARAZONERO II",
      "client_identification": "V27520695",
      "nap_box_name": "119",
      "created_at": "2024-07-22T16:28:09.477717",
      "service_detail": {
        "id": 5057,
        "ip": "172.19.191.2",
        "mac": "VSOL00523B59",
        "serial": "VSOL00523B59",
        "queue": "Plan_107915_1574_WispHub",
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2024-08-14T10:17:18.936827",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5484,
      "client_name": "HAIZEN YSOLINA DALAL PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Terrazas de Juan Pablo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04120436106",
      "client_email": "HAIZENDALAL@GMAIL.COM",
      "address": "CALLE LA LLANERA EDIFICIO C PISO 1 APTO 11 URBANIZACIÓN TERRAZAS DE JUAN PABLO",
      "client_identification": "V18886953",
      "nap_box_name": "289",
      "created_at": "2024-07-23T08:32:20.729898",
      "service_detail": {
        "id": 5104,
        "ip": "172.20.81.2",
        "mac": "VSOL00498641",
        "serial": "VSOL00498641",
        "queue": "Plan_148293_24341_WispHub",
        "interface": "VLAN130_TERRAZAS_JP",
        "created_at": "2024-08-14T15:05:01.348311",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5485,
      "client_name": "ANYURITH KARINA SUAREZ ALAÑA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Canaima",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04262416761",
      "client_email": "ANYURITHKARINA@GMAIL.COM",
      "address": "CALLE 2 CASA NRO 32 SECTOR CANAIMA",
      "client_identification": "V17199398",
      "nap_box_name": "CTO-00107 ",
      "created_at": "2024-07-23T08:35:23.180280",
      "service_detail": {
        "id": 4610,
        "ip": "10.16.91.2",
        "mac": "VSOL001267D1",
        "serial": "VSOL001267D1",
        "queue": "Plan_161892_30183_WispHub",
        "interface": "VLAN237_CANAIMA",
        "created_at": "2024-08-11T20:34:36.124400",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5486,
      "client_name": "SOL AURIS MAR ESPINOZA ESCORCHA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Canaima",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243143549",
      "client_email": "SOLESPINOZA78@HOTMAIL.COM",
      "address": "CALLE 5 CASA NRO 15 SECTOR URBANIZACION CANAIMA",
      "client_identification": "V13579429",
      "nap_box_name": "359",
      "created_at": "2024-07-23T08:41:54.079586",
      "service_detail": {
        "id": 9816,
        "ip": "172.18.85.2",
        "mac": "VSOL005232B9",
        "serial": "VSOL005232B9",
        "queue": null,
        "interface": "VLAN237_CANAIMA",
        "created_at": "2025-11-10T16:57:56.344520",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5487,
      "client_name": "LINERVIS MARVELIS ROA FLORES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121598168",
      "client_email": "INGLMRF@GMAIL.COM",
      "address": "CALLE 2 CASA  NRO 5 MANZANA I 1 URB SAMAN  TARAZONERO 2 SECTOR",
      "client_identification": "V17578246",
      "nap_box_name": "510",
      "created_at": "2024-07-23T08:50:44.033878",
      "service_detail": {
        "id": 4445,
        "ip": "172.23.200.2",
        "mac": "VSOL00137DA1",
        "serial": "VSOL00137DA1",
        "queue": "Plan_107915_1574_WispHub",
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2024-08-09T21:52:22.509561",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5488,
      "client_name": "RUBIMAR DAILYN ARTIGAS CASTILLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243569971",
      "client_email": "RDAC.ARTIGAS@GMAIL.COM",
      "address": "VEREDA MANZANA H 02 CASA NRO 10 SAMAN TARAZONERO II TURMERO",
      "client_identification": "V21204984",
      "nap_box_name": "510 DOS",
      "created_at": "2024-07-23T09:00:52.265742",
      "service_detail": {
        "id": 4448,
        "ip": "172.23.201.2",
        "mac": "VSOL0012E5C1",
        "serial": "VSOL0012E5C1",
        "queue": "Plan_137413_1574_WispHub",
        "interface": "VLAN100_OLTs",
        "created_at": "2024-08-09T22:04:06.888384",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5489,
      "client_name": "JOSE LUIS NOGUERA GUACARAN",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128671260",
      "client_email": "JLN3525@GMAIL.COM",
      "address": "CALLE 17 CASA NRO 3 URB PANTIN ROSARIO DE PAYA",
      "client_identification": "V11980403",
      "nap_box_name": "CTO-00101",
      "created_at": "2024-07-23T09:03:58.712649",
      "service_detail": {
        "id": 4452,
        "ip": "172.23.158.2",
        "mac": "VSOL0012BC59",
        "serial": "VSOL0012BC59",
        "queue": "Plan_161891_30183_WispHub",
        "interface": "VLAN229_PANTIN",
        "created_at": "2024-08-09T22:11:27.415296",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5490,
      "client_name": "RONY GABRIEL OLLARVES GRAZIANO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243763489",
      "client_email": "OLLARVESRONG@GMAIL.COM",
      "address": "CALLE 06 CASA NRO 17 URB LA CASONA II TURMERO",
      "client_identification": "V30415709",
      "nap_box_name": "CTO-00083",
      "created_at": "2024-07-23T09:06:37.465599",
      "service_detail": {
        "id": 11590,
        "ip": "172.23.187.2",
        "mac": "VSOL00137D91",
        "serial": "VSOL00137D91",
        "queue": null,
        "interface": "VLAN110_CASONA_2",
        "created_at": "2026-02-10T20:03:04.319957",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5491,
      "client_name": "MARIA ELOINA ALBORNOZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243470557",
      "client_email": "MARIAELOINAALBORNOZ@GMAIL.COM",
      "address": "CALLE RIVAS EDIF TORRE 05-E 01 PISO PB APT 01",
      "client_identification": "V9163045",
      "nap_box_name": "CTO-00032 DOS",
      "created_at": "2024-07-23T09:08:23.096254",
      "service_detail": {
        "id": 4454,
        "ip": "172.25.6.2",
        "mac": "GPON0097E106",
        "serial": "GPON0097E106",
        "queue": "Plan_112654_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-08-09T22:16:07.504975",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5493,
      "client_name": "EVELISE ALFONSINA CALDERON ZURITA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Valle Paraiso",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243414326",
      "client_email": "EVEACALDERONZ@GMAIL.COM",
      "address": "AV PRINCIPAL DE SAN PABLO EDF ALTOS DE JUAN PABLO II PISO 1 APT 4 VALLE PARAISO",
      "client_identification": "V18854780",
      "nap_box_name": "CTO-00603",
      "created_at": "2024-07-23T11:35:17.325867",
      "service_detail": {
        "id": 4455,
        "ip": "172.23.196.2",
        "mac": "VSOL0012BE31",
        "serial": "VSOL0012BE31",
        "queue": "Plan_112654_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-08-09T22:19:21.765041",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5494,
      "client_name": "YHONNER ANEXIS VELASQUEZ PEÑA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Guanarito",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04121489381",
      "client_email": "FABIANALEXANDERYEPEZPENA@GMAIL.COM",
      "address": "CALLE PEÑALVER CASA NRO 60 BARRIO GUANARITO TURMERO",
      "client_identification": "V25620889",
      "nap_box_name": "447",
      "created_at": "2024-07-23T11:37:40.196281",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5495,
      "client_name": "DAYANA CAROLINA GIL BEJARANO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados de Cafetal",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243043936",
      "client_email": "GBMMAGDALENA@GMAIL.COM",
      "address": "CTRA TURMERO VIA PAYA CASA NRO 6 URB PRADOS DE CAFETAL TURMERO",
      "client_identification": "V14959674",
      "nap_box_name": "85",
      "created_at": "2024-07-23T11:53:22.993443",
      "service_detail": {
        "id": 5698,
        "ip": "172.19.174.2",
        "mac": "TPLGB954EC4C",
        "serial": "TPLGB954EC4C",
        "queue": "Plan_139897_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-08-18T16:31:13.819180",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5496,
      "client_name": "KELLY KARINA MEDINA TORRES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Prados de Cafetal",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04167472120",
      "client_email": "KEILYS0236@GMAIL.COM",
      "address": "AV TRANSVERSAL C/CALLEJON INTERNO CASA PARCELA 6-2 NRO 2 SECTOR PRADOS DE CAFETAL ROSARIO DE PAYA",
      "client_identification": "V16115431",
      "nap_box_name": "545",
      "created_at": "2024-07-23T12:01:01.099547",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5497,
      "client_name": "MARIA TERESA LUIS CIFUENTES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "SUSPENDIDO_RESIDENCIAL",
      "status_name": "Suspendido",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados de Cafetal",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243385092",
      "client_email": "MARITELC060494@GMAIL.COM",
      "address": "CALLE 2 CASA NRO 4 URB PRADOS DE CAFETAL ROSARIO DE PAYA",
      "client_identification": "V23410337",
      "nap_box_name": "545",
      "created_at": "2024-07-23T12:06:10.555240",
      "service_detail": {
        "id": 13040,
        "ip": "172.19.171.2",
        "mac": "TP:LG:B9:54:FB:FC",
        "serial": "TPLGB954FBFC",
        "queue": null,
        "interface": "VLAN221_CAFETAL_OLT1",
        "created_at": "2026-09-18T15:52:14.624795",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5498,
      "client_name": "OLTEO ENRIQUE FALCIATORE GIGLIO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados de Cafetal",
      "plan": {
        "id": 16,
        "name": "RECURRENTE RESIDENCIAL PLAN 800M",
        "cost": "55.00",
        "code": "FOR800",
        "profile": "800M/800M"
      },
      "client_mobile": "04126742901",
      "client_email": "OLTEOFALCIATORE@GMAIL.COM",
      "address": "AV 2DA QTA NRO 9-3 URB PRADOS DE CAFETAL ROSARIO DE PAYA",
      "client_identification": "V11978713",
      "nap_box_name": "561",
      "created_at": "2024-07-23T12:09:54.495057",
      "service_detail": {
        "id": 12973,
        "ip": "172.19.169.2",
        "mac": "TP:LG:B9:54:FA:44",
        "serial": "TPLGB954FA44",
        "queue": null,
        "interface": "VLAN221_CAFETAL_OLT1",
        "created_at": "2026-09-03T14:54:46.536110",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5499,
      "client_name": "OMAR ENRIQUE LORCA ARANA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243381219",
      "client_email": "marielasequerasilva06@gmail.com",
      "address": "VDA  MANZANA  16 CASA 1 SECTOR  SAMAN TARAZONERO II EL MACARO TURMERO",
      "client_identification": "V13493291",
      "nap_box_name": "265",
      "created_at": "2024-07-23T12:13:47.196362",
      "service_detail": {
        "id": 8678,
        "ip": "172.22.26.2",
        "mac": "HWTC28515CA2",
        "serial": "HWTC28515CA2",
        "queue": "queue1",
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2025-05-17T18:07:30.618798",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5500,
      "client_name": "JOSE ERNESTO RODRIGUEZ GARCIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados de Cafetal",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243011205",
      "client_email": "JOSEERNESTO8@HOTMAIL.COM",
      "address": "CALLE 2 CASA NRO 9 PRADOS DE CAFETAL TURMERO",
      "client_identification": "V6862390",
      "nap_box_name": "545",
      "created_at": "2024-07-23T12:19:32.015054",
      "service_detail": {
        "id": 5138,
        "ip": "172.19.167.2",
        "mac": "TPLGB954F8AB",
        "serial": "TPLGB954F8AB",
        "queue": "Plan_92284_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-08-14T17:57:34.840680",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5501,
      "client_name": "JUAN CARVALLO APONTE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados de Cafetal",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04125856361",
      "client_email": "BRAYANCARVALLO5@GMAIL.COM",
      "address": "CALLE 2 CASA 6-1 SECTOR PRADOS DE CAFETAL ROSARIO DE PAYA",
      "client_identification": "V3205714",
      "nap_box_name": "545",
      "created_at": "2024-07-23T12:24:10.578591",
      "service_detail": {
        "id": 9601,
        "ip": "172.19.166.2",
        "mac": "TPLGB954F93F",
        "serial": "TPLGB954F93F",
        "queue": null,
        "interface": "VLAN200_OLTs",
        "created_at": "2025-10-10T17:12:07.472504",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5502,
      "client_name": "SERGIO SEBASTIAN MONTILLA COLMENARES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados de Cafetal",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04122079008",
      "client_email": "SEBASTIANMC1314@GMAIL.COM",
      "address": "CALLE 2, CASA NRO URB PRADOS DE CAFETAL TURMERO",
      "client_identification": "V30852514",
      "nap_box_name": "85",
      "created_at": "2024-07-23T12:28:31.694541",
      "service_detail": {
        "id": 5152,
        "ip": "172.19.147.2",
        "mac": "TPLGB954EC07",
        "serial": "TPLGB954EC07",
        "queue": "Plan_124568_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-08-15T09:45:50.651170",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5503,
      "client_name": "LISBETH CARLILY RAMIREZ VARGAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados de Cafetal",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243055448",
      "client_email": "CARLILY@HOTMAIL.COM",
      "address": "AVENIDA SEGUNDA CASA 9-5 URB PRADOS DE CAFETAL ROSARIO DE PAYA",
      "client_identification": "V10511793",
      "nap_box_name": "561",
      "created_at": "2024-07-23T12:34:02.054235",
      "service_detail": {
        "id": 5156,
        "ip": "172.19.139.2",
        "mac": "TPLGB954E9B1",
        "serial": "TPLGB954E9B1",
        "queue": "Plan_124568_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-08-15T10:03:06.076234",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5504,
      "client_name": "SORANYI YENIREE FLORES LINERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados de Cafetal",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243378690",
      "client_email": "SORANYIFLORESLINERO@GMAIL.COM",
      "address": "CALLE 2 CON CRUCE VIA INTERNA CASA LOTE 5-6-2-A SECTOR ROSARIO DE PAYA PRADOS DE CAFETAL",
      "client_identification": "V24419700",
      "nap_box_name": "85",
      "created_at": "2024-07-23T12:39:09.517356",
      "service_detail": {
        "id": 11211,
        "ip": "172.19.145.2",
        "mac": "TPLGB954FC12",
        "serial": "TPLGB954FC12",
        "queue": null,
        "interface": "VLAN200_OLTs",
        "created_at": "2026-01-16T18:55:40.675355",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5505,
      "client_name": "SERVANDO JOSE MARTINEZ ZAMBRANO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243826931",
      "client_email": "MSERVANDO20@GMAIL.COM",
      "address": "CALLE MANZANA B-6 CASA NRO 14 SECTOR SAMAN TARAZONERO II TURMERO",
      "client_identification": "V30073239",
      "nap_box_name": "CTO-00511",
      "created_at": "2024-07-23T12:39:26.039263",
      "service_detail": {
        "id": 5694,
        "ip": "172.22.11.2",
        "mac": "TPLGB68B5A53",
        "serial": "TPLGB68B5A53",
        "queue": "Plan_138775_1574_WispHub",
        "interface": "VLAN100_OLTs",
        "created_at": "2024-08-18T16:19:04.854326",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5506,
      "client_name": "CARLOS HUMBERTO RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados de Cafetal",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243541412",
      "client_email": "CARLOSRODRIGUEZ_H@HOTMAIL.COM",
      "address": "CALLE 2 CASA NRO 5-1 URB PRADOS DE CAFETAL ROSARIO DE PAYA",
      "client_identification": "V8151341",
      "nap_box_name": "561",
      "created_at": "2024-07-23T12:43:31.945360",
      "service_detail": {
        "id": 7957,
        "ip": "172.19.141.2",
        "mac": "TPLGB954FC1B",
        "serial": "TPLGB954FC1B",
        "queue": "Plan_107915_15811_WispHub",
        "interface": "VLAN221_CAFETAL_OLT1",
        "created_at": "2025-03-20T12:40:54.504132",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5507,
      "client_name": "JHANNY EGLICETH LOYO BRAVO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243756451",
      "client_email": "NANYEGLICETH@HOTMAIL.COM",
      "address": "CALLE 9 CASA NRO 603-B CONJUNTO RESIDENCIAL MATA CABALLO ROSARIO DE PAYA",
      "client_identification": "V14429962",
      "nap_box_name": "160",
      "created_at": "2024-07-23T16:33:28.129562",
      "service_detail": {
        "id": 10146,
        "ip": "172.22.41.2",
        "mac": "TPLGB68B5160",
        "serial": "TPLGB68B5160",
        "queue": null,
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2025-11-14T17:26:49.524708",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5508,
      "client_name": "FADIANGEL JOSEFINA BRAVO MACHADO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243619061",
      "client_email": "FADIANGELB@GMAIL.COM",
      "address": "CALLE PRINCIPAL CASA NRO 68-3-B URB MATA CABALLO SECTOR PAYA ABAJO ROSARIO DE PAYA",
      "client_identification": "V14394393",
      "nap_box_name": "CTO-00143",
      "created_at": "2024-07-23T16:39:03.329221",
      "service_detail": {
        "id": 11971,
        "ip": "172.22.9.2",
        "mac": "TPLGB68B4E48",
        "serial": "TPLGB68B4E48",
        "queue": null,
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2026-03-05T16:27:55.894772",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5509,
      "client_name": "BELKYS MARGARITA LOPEZ NAVAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124603983",
      "client_email": "JOSEPHSALINAS_9@HOTMAIL.COM",
      "address": "CALLE 5 MANZANA E-8 NRO22 URB SAMAN TARAZONERO II TURMERO",
      "client_identification": "V4405130",
      "nap_box_name": "93",
      "created_at": "2024-07-23T16:41:33.813540",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5510,
      "client_name": "OMAIRELYS JOSE GOMEZ RAMIREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243772369",
      "client_email": "OMAIRELYSGOMEZ1997@GMAIL.COM",
      "address": "CALLE 9 EDIF 591 PISO 1 APT 591-A URB MATA CABALLO",
      "client_identification": "V27168491",
      "nap_box_name": "222",
      "created_at": "2024-07-23T16:53:46.381058",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5511,
      "client_name": "JESUS ENRIQUE SALAS PEREIRA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 43,
        "name": "RECURRENTE RESIDENCIAL PLAN 650M",
        "cost": "46.00",
        "code": "FOR650M",
        "profile": "650M/650M"
      },
      "client_mobile": "04243790266",
      "client_email": "JESUSESALAS.95@GMAIL.COM",
      "address": "CALLE 6 CASA NRO. 391 URB. MATACABALLO, ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V23783475",
      "nap_box_name": "CTO-00178",
      "created_at": "2024-07-23T16:59:10.509711",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5512,
      "client_name": "ADELAIDA SILVA MORENO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vallecito",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128957844",
      "client_email": "LEANNYCAMARGOSILVA@GMAIL.COM",
      "address": "CALLE LAS PIÑAS CASA NRO 4 SECTOR ROSARIO DE PAYA VALLECITO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V13769020",
      "nap_box_name": "CTO - 110",
      "created_at": "2024-07-23T16:59:23.102002",
      "service_detail": {
        "id": 4200,
        "ip": "172.31.31.2",
        "mac": "HWTC5DB35B91",
        "serial": "HWTC5DB35B91",
        "queue": "Plan_161906_30183_WispHub",
        "interface": "VLAN258_VALLECITO",
        "created_at": "2024-08-05T16:48:12.554983",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5513,
      "client_name": "YASNEIRIS YSABEL BASTIDAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243141329",
      "client_email": "YASNEIRISBASTIDAS79@GMAIL.COM",
      "address": "CALLE 2 VASA NRO 96 URB MATA CABALLO TURMERO",
      "client_identification": "V14243046",
      "nap_box_name": "CTO-00102 DOS",
      "created_at": "2024-07-23T17:01:11.262845",
      "service_detail": {
        "id": 5685,
        "ip": "172.22.5.2",
        "mac": "TPLGB68B5108",
        "serial": "TPLGB68B5108",
        "queue": "Plan_161903_30183_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-08-17T16:32:49.357816",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5514,
      "client_name": "LUIS ARTURO CUEVAS MEDINA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "El Naranjal",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124692252",
      "client_email": "LICLUISCUEVAS@HOTMAIL.COM",
      "address": "CALLE 3 CASA 5-5A ANTIGUA HACIENDA EL NARANJAL",
      "client_identification": "V14046029",
      "nap_box_name": "CTO-00303",
      "created_at": "2024-07-23T17:02:40.402439",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5515,
      "client_name": "ARTURO ABRAHAN MORILLO ESPIDEA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Paya Abajo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121487295",
      "client_email": "MORILLOARTURO600@GMAIL.COM",
      "address": "CALLE SAN ANTONIO CASA NRO 30 PAYA ABAJO",
      "client_identification": "V30852438",
      "nap_box_name": "271",
      "created_at": "2024-07-23T17:06:00.567280",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5516,
      "client_name": "JOSEFINA FABIANA LORETO HERNANDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 101,
        "name": "RECURRENTE RESIDENCIAL PLAN 200M",
        "cost": "19.00",
        "code": "FOR200MB",
        "profile": "200Mbps/200Mbps"
      },
      "client_mobile": "04144890735",
      "client_email": "JOSEFINADEHERNANDEZ2015@GMAIL.COM",
      "address": "CALLE 4 CASA 200 SECTOR MATA CABALLO ROSARIO DE PAYA",
      "client_identification": "V4818385",
      "nap_box_name": "CTO-00274",
      "created_at": "2024-07-23T17:07:18.045244",
      "service_detail": {
        "id": 5683,
        "ip": "172.22.13.2",
        "mac": "TPLGB68B4F3E",
        "serial": "TPLGB68B4F3E",
        "queue": "queue1",
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2024-08-17T15:27:14.770128",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5517,
      "client_name": "MARIA JOSEFINA URBINA RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Canaima",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121448769",
      "client_email": "MISTESOROS111809@GMAIL.COM",
      "address": "CALLE 03 CASA NRO 01 SECTOR CANAIMA",
      "client_identification": "V15703405",
      "nap_box_name": "355",
      "created_at": "2024-07-23T17:07:36.995708",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5518,
      "client_name": "MARIA DESIREE GONZALEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128911929",
      "client_email": "DESIREEVILLA25@HOTMAIL.COM",
      "address": "CALLE 15-A CASA NRO 21 SECTOR PANTIN ROSARIO DE PAYA",
      "client_identification": "V12478826",
      "nap_box_name": "CTO-00201",
      "created_at": "2024-07-23T17:08:21.327585",
      "service_detail": {
        "id": 4458,
        "ip": "172.25.5.2",
        "mac": "VSOL0013EE61",
        "serial": "VSOL0013EE61",
        "queue": "Plan_161893_30183_WispHub",
        "interface": "VLAN229_PANTIN",
        "created_at": "2024-08-09T22:27:21.540697",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5519,
      "client_name": "VIRGILIO JOSE BRITO SALAZAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Residencias Mariño",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04160445151",
      "client_email": "ALEJANDROBRITO27@GMAIL.COM",
      "address": "CALLE MARIÑO EDIF RESIDENCIAS MARIÑO PISO 2 APT 22-A SECTOR CENTRO TURMERO",
      "client_identification": "V5477988",
      "nap_box_name": "CTO-0518",
      "created_at": "2024-07-23T17:09:57.808924",
      "service_detail": {
        "id": 4459,
        "ip": "172.23.129.2",
        "mac": "GPON0097CEB6",
        "serial": "GPON0097CEB6",
        "queue": "Plan_112654_15811_WispHub",
        "interface": "VLAN100_OLTs",
        "created_at": "2024-08-09T22:30:05.000806",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5520,
      "client_name": "GENESIS JHOANNA SALINAS BARRETO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243479917",
      "client_email": "GENESALINAS19@GMAIL.COM",
      "address": "CALLE 11 CASA NRO 639-A URB MATA CABALLO TOSARIO DE PAYA",
      "client_identification": "V24433783",
      "nap_box_name": "CTO-0337",
      "created_at": "2024-07-23T17:11:07.526136",
      "service_detail": {
        "id": 5682,
        "ip": "172.22.4.2",
        "mac": "GPON0097C246",
        "serial": "GPON0097C246",
        "queue": "Plan_161903_30183_WispHub",
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2024-08-17T15:20:27.257221",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5521,
      "client_name": "JULIA MENDOZA DE CARRERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128663886",
      "client_email": "JULIAMENDOZA397@GMAIL.COM",
      "address": "CALLE 22 CASA NRO 9 URB PANTIN ROSARIO DE PAYA TURMERO",
      "client_identification": "V8729821",
      "nap_box_name": "CTO-00105",
      "created_at": "2024-07-23T17:11:49.647017",
      "service_detail": {
        "id": 12591,
        "ip": "172.23.166.2",
        "mac": "VS:OL:00:13:ED:79",
        "serial": "VSOL0013ED79",
        "queue": null,
        "interface": "VLAN229_PANTIN",
        "created_at": "2026-06-06T18:49:07.671054",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5522,
      "client_name": "MILEIDY ESTEFANIA TORREALBA CAMACHO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Canaima",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04120959665",
      "client_email": "IDEILYM.22@GMAIL.COM",
      "address": "CALLE 3 CASA NRO 26 SECTOR CANAIMA",
      "client_identification": "V26791167",
      "nap_box_name": "355",
      "created_at": "2024-07-23T17:12:39.021364",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5523,
      "client_name": "LERIS BELEN PULIDO DE CABALLERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Antonio Jose de Sucre",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124544842",
      "client_email": "ROSBELY83@GMAIL.COM",
      "address": "CALLE 25 DE AGOSTO CASA NRO 25 URB ANTONIO JOSE DE SUCRE TURMERO",
      "client_identification": "V8580176",
      "nap_box_name": "123",
      "created_at": "2024-07-23T17:14:02.911587",
      "service_detail": {
        "id": 5640,
        "ip": "172.21.239.2",
        "mac": "TPLGB68B4E36",
        "serial": "TPLGB68B4E36",
        "queue": "queue1",
        "interface": "VLAN101_AJS",
        "created_at": "2024-08-17T11:53:34.003609",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5524,
      "client_name": "OSCAR RAFAEL MARCANO ORTEGA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144734303",
      "client_email": "RAFAELMARCANO295@GMAIL.COM",
      "address": "CALLE 14A CASA NRO 2 URB HACIENDA PANTIN ROSARIO DE PAYA",
      "client_identification": "V27289612",
      "nap_box_name": "CTO-00169",
      "created_at": "2024-07-23T17:14:06.864284",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5525,
      "client_name": "YULEISI ALEJANDRA REBOLLEDO AVILA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Canaima",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04122194417",
      "client_email": "ALEJANDRA0203AVILA@GMAIL.COM",
      "address": "CALLE 6 CASA NRO 21 URB CANAIMA",
      "client_identification": "V23528860",
      "nap_box_name": "356",
      "created_at": "2024-07-23T17:14:32.581465",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5526,
      "client_name": "YERLIN CAROLINA FRANQUIZ JIMENEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Narayola II",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04141440957",
      "client_email": "FRANQUIZY14@GMAIL.COM",
      "address": "AV INTERCOMUNAL  EDIF 3 PISO PB APT 01 URB COMPLEJO  RESIDENCIAL NARAYOLA UU TURMERO",
      "client_identification": "V19605684",
      "nap_box_name": "CTO-0523",
      "created_at": "2024-07-23T17:15:47.853835",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5527,
      "client_name": "SISALTINA LIBORIA SOUSA VIEIRA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Narayola II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243130525",
      "client_email": "SISAL1968@GMAIL.COM",
      "address": "AV INTERCOMUNAL PARCELA 22-4A EDOF 6 PISO 2 APT 2-2 NARAYOLA II",
      "client_identification": "V9644925",
      "nap_box_name": "CTO-0526",
      "created_at": "2024-07-23T17:17:19.769561",
      "service_detail": {
        "id": 4463,
        "ip": "172.23.165.2",
        "mac": "VSOL0013E519",
        "serial": "VSOL0013E519",
        "queue": "Plan_131647_24341_WispHub",
        "interface": "VLAN100_OLTs",
        "created_at": "2024-08-09T22:37:28.669929",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5528,
      "client_name": "GREGORY JESUS SANCHEZ MOFFI",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04120345917",
      "client_email": "GREGORYMOFFI444@GMAIL.COM",
      "address": "CALLE E MANZANA E-12 CASA NRO 2 SECTOR SAMAN  TARAZONERO II TURMERO",
      "client_identification": "V26425653",
      "nap_box_name": "93",
      "created_at": "2024-07-23T17:17:37.667538",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5529,
      "client_name": "PAOLA NAZARETH CABELLO TORREALBA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Guanarito",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04127764601",
      "client_email": "KARLEIDYSHERMOSO90@GMAIL.COM",
      "address": "VDA MARQUES APONTE CASA NRO 63 SECTOR GUANARITO",
      "client_identification": "V26735621",
      "nap_box_name": "216",
      "created_at": "2024-07-23T17:19:08.979642",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5530,
      "client_name": "GENESIS REBECA REVERON  MORILLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04141472649",
      "client_email": "ROBERREV@GMAIL.COM",
      "address": "CALLE 9 EDIF TETRA PISO 1 APT 605-D URB MATA CABALLO ROSARIO DE PAYA",
      "client_identification": "V27289456",
      "nap_box_name": "160",
      "created_at": "2024-07-23T17:22:39.058023",
      "service_detail": {
        "id": 10091,
        "ip": "172.21.232.2",
        "mac": "TPLGB68B4DE0",
        "serial": "TPLGB68B4DE0",
        "queue": null,
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2025-11-13T12:34:01.710904",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5531,
      "client_name": "LISBETH MARIA ALFONZO VEITIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Canaima",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04144432230",
      "client_email": "ALFONZOLISBETH67@GMAIL.COM",
      "address": "CALLE 6 CASA NRO 39 URB CANAIMA SECTOR PRADO DE PAYA ROSARIO DE PAYA ARAGUA",
      "client_identification": "V6321360",
      "nap_box_name": "356",
      "created_at": "2024-07-23T17:24:26.826962",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5532,
      "client_name": "FRANKLIN JOSE RANGEL ROA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04264546390",
      "client_email": "ABDIAS050@GMAIL.COM",
      "address": "CALLE 9 CASA NRO 595-B BARRIO MATA CABALLO ROSARIO DE PAYA",
      "client_identification": "V13211207",
      "nap_box_name": "160",
      "created_at": "2024-07-23T17:26:37.879904",
      "service_detail": {
        "id": 12965,
        "ip": "172.21.253.2",
        "mac": "TP:LG:B6:8B:4F:C4",
        "serial": "TPLGB68B4FC4",
        "queue": null,
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2026-09-03T11:19:34.672202",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5533,
      "client_name": "LEYDI YORLET DIAZ ZERPA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243661333",
      "client_email": "KENNYMORILLO55@GMAIL.COM",
      "address": "CALLE 5, CASA NRO 45, SECTOR PRADO IIII, ROSARIO DE PAYA, ARAGUA",
      "client_identification": "V27864628",
      "nap_box_name": "CTO-00301",
      "created_at": "2024-07-23T17:51:39.062894",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5534,
      "client_name": "FRANCISCO JAVIER PEREZ RIERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "San Carlos",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124354843",
      "client_email": "FRANCOPEREZRIERA@GMAIL.COM",
      "address": "CALLE A CASA NÚMERO 25 URBANIZACIÓN SAN CARLOS",
      "client_identification": "V18266357",
      "nap_box_name": "92 DOS",
      "created_at": "2024-07-25T08:26:49.368717",
      "service_detail": {
        "id": 5617,
        "ip": "172.21.1.2",
        "mac": "VSOL00523B39",
        "serial": "VSOL00523B39",
        "queue": "Plan_143066_15811_WispHub",
        "interface": "VLAN223_SAN_CARLOS_OLT1",
        "created_at": "2024-08-17T10:52:54.980114",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5535,
      "client_name": "ALEXANDER JOSE ZARRAGA BURGOS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144635720",
      "client_email": "ZARRAGAALEXANDRA5@GMAIL.COM",
      "address": "CALLE 9B CASA NRO 43 SECTOR PANTIN ROSARIO DE PAYA",
      "client_identification": "V11141692",
      "nap_box_name": "CTO-00122",
      "created_at": "2024-07-25T08:29:49.338910",
      "service_detail": {
        "id": 4618,
        "ip": "172.21.115.2",
        "mac": "VSOL001288A9",
        "serial": "VSOL001288A9",
        "queue": "Plan_107915_30181_WispHub",
        "interface": "VLAN229_PANTIN",
        "created_at": "2024-08-11T21:03:18.713083",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5536,
      "client_name": "LILIAN DAYANA LOPEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Bicentenario",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124011470",
      "client_email": "LILIDAY1213@GMAIL.COM",
      "address": "CALLE LOS ROBLES MANZANA 11 CASA NRO 09 P-A SECTOR DESARROLLO URBANISTICO",
      "client_identification": "V13199310",
      "nap_box_name": "381",
      "created_at": "2024-07-25T08:31:30.041093",
      "service_detail": {
        "id": 4619,
        "ip": "172.18.79.2",
        "mac": "VSOL001194E1",
        "serial": "VSOL001194E1",
        "queue": "Plan_161892_30183_WispHub",
        "interface": "VLAN240_DURPA",
        "created_at": "2024-08-11T21:05:59.401241",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5537,
      "client_name": "YASANDRA YEXIBET ALCALA PACHECO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Bicentenario",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144884291",
      "client_email": "OJONES47003514@GMAIL.COM",
      "address": "CALLE LOS ROBLES MANZANA 11 CASA NRO 11 SECTOR DESARROLLO URBANISTICO",
      "client_identification": "V16923314",
      "nap_box_name": "381",
      "created_at": "2024-07-25T08:34:23.682773",
      "service_detail": {
        "id": 12979,
        "ip": "172.18.51.2",
        "mac": "VS:OL:00:12:78:C9",
        "serial": "VSOL001278C9",
        "queue": null,
        "interface": "VLAN240_DURPA",
        "created_at": "2026-09-04T11:03:33.977567",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5538,
      "client_name": "RAMON IGNACIO LOPERA ARRIETA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Palma Real",
      "plan": {
        "id": 19,
        "name": "RECURRENTE RESIDENCIAL PLAN 1GB",
        "cost": "74.70",
        "code": "FOR1GB",
        "profile": "1000M/1000M"
      },
      "client_mobile": "04243297946",
      "client_email": "monicaher2003@gmail.com",
      "address": "CALLE 1 CASA NRO 44 URB PALMA REAL",
      "client_identification": "E82269204",
      "nap_box_name": "CTO-00209",
      "created_at": "2024-07-25T08:36:22.602894",
      "service_detail": {
        "id": 11589,
        "ip": "172.18.119.2",
        "mac": "VSOL004978D1",
        "serial": "VSOL004978D1",
        "queue": null,
        "interface": "VLAN240_DURPA",
        "created_at": "2026-02-10T20:00:29.317448",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5540,
      "client_name": "MIRIAM JOHNELIZ LIMA CARPIO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Concepcion",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04262925322",
      "client_email": "LIMAJOHNELIZ@GMAIL.COM",
      "address": "CALLE PRINCIPAL EDIF TORRE 8 PISO 1 APT 4 SECTOR LA CONCEPCION TURMERO",
      "client_identification": "V17247191",
      "nap_box_name": "0325 DOS",
      "created_at": "2024-07-25T09:42:34.809198",
      "service_detail": {
        "id": 5614,
        "ip": "172.22.16.2",
        "mac": "TPLGB68B4E2A",
        "serial": "TPLGB68B4E2A",
        "queue": "Plan_131337_24341_WispHub",
        "interface": "VLAN111_CONCEPCION",
        "created_at": "2024-08-17T10:49:20.554013",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5541,
      "client_name": "ALEXANDRA BRACCHIERI MIRABELLA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04243245999",
      "client_email": "LORENAMIRABELLA126@GMAIL.COM",
      "address": "CALLE CAREÑO NRO 82 SECTOR CASCO TURMERO",
      "client_identification": "V28224537",
      "nap_box_name": "649",
      "created_at": "2024-07-25T09:45:55.952352",
      "service_detail": {
        "id": 5612,
        "ip": "172.21.228.2",
        "mac": "TPLGB68B4F94",
        "serial": "TPLGB68B4F94",
        "queue": "Plan_128609_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-08-17T10:47:42.412671",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5542,
      "client_name": "JHOAN LUIS SILVA RUBINO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Bosque",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04127790740",
      "client_email": "JHOANSILVA89@GMAIL.COM",
      "address": "CALLE LUISA CACERES DE ARISMENDI, CASA NRO. 011 URBANIZACIÓN EL BOSQUE, ROSARIO DE PAYA, ARAGUA.",
      "client_identification": "V20552095",
      "nap_box_name": "CE - 851",
      "created_at": "2024-07-25T10:07:55.416696",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5543,
      "client_name": "OSCAR JOSE BLANCO GOMEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243380319",
      "client_email": "yulimare79@gmail.com",
      "address": "CALLE 3 CASA NRO 153 URB MATA CABALLO ROSARIO DE PAYA",
      "client_identification": "V15532816",
      "nap_box_name": "CTO-00094",
      "created_at": "2024-07-25T10:18:40.197436",
      "service_detail": {
        "id": 5608,
        "ip": "172.30.81.2",
        "mac": "TPLGB68B4E33",
        "serial": "TPLGB68B4E33",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2024-08-17T10:38:20.005913",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5544,
      "client_name": "ARACELIS RAMONA ACOSTA CASTRO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144524195",
      "client_email": "ARACOSTA3000@GMAIL.COM",
      "address": "CALLE 12 CASA NRO 692 D SECTOR MATA CABALLO ROSARIO DE PAYA",
      "client_identification": "V12689834",
      "nap_box_name": "CTO-00130",
      "created_at": "2024-07-25T10:28:06.191951",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5545,
      "client_name": "YULEIMA LISABETH HIDALGO GOMEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Sector los Mangos",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04128264813",
      "client_email": "LISBETHYULEIMA@GMAIL.COM",
      "address": "CALLE SUCRE, CASA 19 5, SECTOR LAS RULARES, ROSARIO DE PAYA, TURMERO, ARAGUA",
      "client_identification": "V12611282",
      "nap_box_name": "CE-00080",
      "created_at": "2024-07-25T10:33:24.221934",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5546,
      "client_name": "HELEN CAROLINA GIRON MENDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04242501390",
      "client_email": "GIRONH.72@GMAIL.COM",
      "address": "AV2 CASA NRO 487 SECTOR  MATA CABALLO TURMERO",
      "client_identification": "V11133373",
      "nap_box_name": "CTO-00567",
      "created_at": "2024-07-25T10:33:46.152966",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5547,
      "client_name": "KARELYS COROMOTO FALCON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144885544",
      "client_email": "KARELISF50@GMAIL.COM",
      "address": "CALLE 3 CASA NRO 140 URB MATA CABALLO ROSARIO DE PAYA",
      "client_identification": "V19002445",
      "nap_box_name": "CTO-00094",
      "created_at": "2024-07-25T10:36:05.085721",
      "service_detail": {
        "id": 9977,
        "ip": "172.21.243.2",
        "mac": "TPLGB68B514A",
        "serial": "TPLGB68B514A",
        "queue": null,
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2025-11-11T12:27:44.183636",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5548,
      "client_name": "YARELIS ODALISCA MARCANO PANTOJA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243123677",
      "client_email": "JORGEMARTINEZNINO1@GMAIL.COM",
      "address": "CALLE 3 CASA NRO118 URB MATA  CABALLO ROSARIO DE PAYA",
      "client_identification": "V15649416",
      "nap_box_name": "CTO-00309",
      "created_at": "2024-07-25T10:38:25.940779",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5549,
      "client_name": "KATERINE FRANCHESKA MORA PANTOJA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144708779",
      "client_email": "KATERINE_ING.CIVIL@HOTMAIL.COM",
      "address": "AV DOS CASA NRO 490 URB MATA CABALLO",
      "client_identification": "V18264351",
      "nap_box_name": "CTO-00567 DOS",
      "created_at": "2024-07-25T10:49:29.686573",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5550,
      "client_name": "DAMELI GREYMAR PEREZ HIDALGO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04143441505",
      "client_email": "DAMELI.PEREZ@GMAIL.COM",
      "address": "CALLE 10 CASA NRO 618-B SECTOR MATA CABALLO",
      "client_identification": "V27562562",
      "nap_box_name": "CTO-00569",
      "created_at": "2024-07-25T10:56:36.233958",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5551,
      "client_name": "MILDREY RAQUEL MISLE DE RAMIREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Isaac Oliveira",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128271544",
      "client_email": "MILDREYRQ23@HOTMAIL.COM",
      "address": "AV 02 CASA NRO 73 URB ISAAC OLIVEIRA TURMERO",
      "client_identification": "V14182225",
      "nap_box_name": "CTO-00262",
      "created_at": "2024-07-25T10:59:22.365008",
      "service_detail": {
        "id": 11807,
        "ip": "172.23.130.2",
        "mac": "VSOL0013ECF1",
        "serial": "VSOL0013ECF1",
        "queue": null,
        "interface": "VLAN107_ISAAC_O",
        "created_at": "2026-02-27T11:41:23.593369",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5552,
      "client_name": "ANGELA KAREN ARMAS TERAN",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128947600",
      "client_email": "ANGELAARMAS02@GMAIL.COM",
      "address": "CALLE 11 CASA TETRA NRO 647-C URB MATA CABALLO TURMERO",
      "client_identification": "V26828136",
      "nap_box_name": "CTO-00213",
      "created_at": "2024-07-25T11:04:36.748352",
      "service_detail": {
        "id": 4339,
        "ip": "172.21.220.2",
        "mac": "TPLGB68B4EFC",
        "serial": "TPLGB68B4EFC",
        "queue": "Plan_161892_30183_WispHub",
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2024-08-09T11:27:39.428583",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5554,
      "client_name": "YAJAIRA MARIBY LOPEZ REQUENA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04140597640",
      "client_email": "YAJAIRAL.REQUENA@GMAIL.COM",
      "address": "CALLE 5 CASA NRO 317 URB MATA CABALLO ROSARIO DE PAYA",
      "client_identification": "V13502341",
      "nap_box_name": "CTO-00182",
      "created_at": "2024-07-25T11:08:41.119137",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5555,
      "client_name": "ANGELICA SARAHI DELGADO MEJIAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman de Guere",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121759736",
      "client_email": "ANGELICA1807LOL@HOTMAIL.COM",
      "address": "CALLE LA LLANERA CASA NRO 7 SECTOR SAMAN DE GUERE 19 DE ABRIL",
      "client_identification": "V24930840",
      "nap_box_name": "290",
      "created_at": "2024-07-25T11:09:48.423345",
      "service_detail": {
        "id": 12679,
        "ip": "172.23.167.2",
        "mac": "68:9f:f0:2a:73:9f",
        "serial": "ZXICCD162C23",
        "queue": null,
        "interface": "VLAN122_SAMAN_GUERE",
        "created_at": "2026-07-05T10:39:57.619057",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5556,
      "client_name": "SANDRA DEL CARMEN GARCIA COLON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Palma Real",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243156880",
      "client_email": "SG327239@GMAIL.COM",
      "address": "AV 2 NRO 502 URB MATA CABALLO ROSARIO DE PAYA",
      "client_identification": "V14240163",
      "nap_box_name": "CTO-00238 DOS",
      "created_at": "2024-07-25T11:12:29.787806",
      "service_detail": {
        "id": 4360,
        "ip": "172.21.244.2",
        "mac": "TPLGB68B50C3",
        "serial": "TPLGB68B50C3",
        "queue": "queue1",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-08-09T15:12:36.040824",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5557,
      "client_name": "ANGI ELENA BELISARIO JIMENEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Durpa",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124856037",
      "client_email": "ANGIELENA.AB@GMAIL.COM",
      "address": "CALLE PARAISO MANZANA 22 CASA NRO 24 URB DESARROLLO URBANISTICO SECTOR DURPA",
      "client_identification": "V18473273",
      "nap_box_name": "CTO-00209",
      "created_at": "2024-07-25T11:15:29.303978",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5558,
      "client_name": "NESTOR ALONSO NARVAEZ CABRERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Narayola II",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04148165767",
      "client_email": "NESTORNARVAEZ1600@GMAIL.COM",
      "address": "CONJUNTO RESIDENCIAL NARAYOLA II EDF 5 PISO 3 NRO 3-1 TURMERO",
      "client_identification": "V16000232",
      "nap_box_name": "CTO-0525",
      "created_at": "2024-07-25T11:23:24.740227",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5559,
      "client_name": "JOSE LUIS CARRASCO TOVAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243621531",
      "client_email": "JOSEMCY22@GMAIL.COM",
      "address": "AV 2 CASA NRO 489 URB MATA CABALLO ROSARIO DE PAYA",
      "client_identification": "V17014528",
      "nap_box_name": "CTO-00567",
      "created_at": "2024-07-25T11:23:28.722327",
      "service_detail": {
        "id": 4361,
        "ip": "172.22.36.2",
        "mac": "TPLGB68B5113",
        "serial": "TPLGB68B5113",
        "queue": "Plan_161892_30183_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-08-09T15:18:13.016497",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5560,
      "client_name": "RAIMUNDO ANTONIO HERNANDEZ CHIRINOS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Bicentenario",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04144893200",
      "client_email": "RAYMUNDOGAHE@GMAIL.COM",
      "address": "CALLE LOS ROBLES MANZANA 10 CASA PLANTA ALTA NRO 21 URB DESARROLLO URBANISTICO",
      "client_identification": "V18780853",
      "nap_box_name": "CTO-00192",
      "created_at": "2024-07-25T11:24:52.375282",
      "service_detail": {
        "id": 4654,
        "ip": "172.18.48.2",
        "mac": "VSOL00120A31",
        "serial": "VSOL00120A31",
        "queue": "Plan_161890_30183_WispHub",
        "interface": "VLAN244_PALMAREAL",
        "created_at": "2024-08-12T10:08:43.082715",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5561,
      "client_name": "ERICK JOSEEFT JAIME RIVAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04129022403",
      "client_email": "ERICKRIVAS292719@GMAIL.COM",
      "address": "CALLE MANZANA C11 CASA NRO 7 SECTOR SAMAN TARAZONERO II EL MACARO",
      "client_identification": "V22960262",
      "nap_box_name": "286",
      "created_at": "2024-07-25T11:26:30.775680",
      "service_detail": {
        "id": 4485,
        "ip": "172.23.150.2",
        "mac": "GPON00980446",
        "serial": "GPON00980446",
        "queue": "queue1",
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2024-08-10T08:36:17.560014",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5562,
      "client_name": "DIGDIANA ALEIDY MALPICA HERNANDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04127780747",
      "client_email": "ALEIDYMALPICA055@GMAIL.COM",
      "address": "AV7 MANZANA E CASA N1 URB SAMAN TARAZONERO II TURMERO EDO ARAGUA",
      "client_identification": "V12573980",
      "nap_box_name": "273",
      "created_at": "2024-07-25T11:28:43.971921",
      "service_detail": {
        "id": 8851,
        "ip": "172.27.53.2",
        "mac": "GPON009820C6",
        "serial": "GPON009820C6",
        "queue": "queue1",
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2025-06-05T13:30:51.456860",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5563,
      "client_name": "JULYMAR NAVARRO VELASQUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04127159407",
      "client_email": "julymarnavarrov@gmail.com",
      "address": "CALLE MANZANA D8 CASA NRO 9 URB SAMAN TARAZONERO II TURMERO ARAGUA",
      "client_identification": "V10929485",
      "nap_box_name": "268",
      "created_at": "2024-07-25T11:30:51.279346",
      "service_detail": {
        "id": 7706,
        "ip": "172.27.35.2",
        "mac": "GPON00980936",
        "serial": "GPON00980936",
        "queue": "Plan_137413_1574_WispHub",
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2025-02-07T08:39:24.463997",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5564,
      "client_name": "EDUIN JOSE URDANETA  FERNANDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Terrazas de Turmero",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243675530",
      "client_email": "URDANETACONTACTO@GMAIL.COM",
      "address": "CALLE 3 CASA NRO E13 URB TERRAZAS DE TURMERO",
      "client_identification": "V13082744",
      "nap_box_name": "118",
      "created_at": "2024-07-25T11:33:22.131929",
      "service_detail": {
        "id": 4374,
        "ip": "172.21.208.2",
        "mac": "TPLGB68B4E2D",
        "serial": "TPLGB68B4E2D",
        "queue": "Plan_157815_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-08-09T16:03:07.405853",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5565,
      "client_name": "YENE GREGORIA CUICAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04127760028",
      "client_email": "ANIBALJS66@GMAIL.COM",
      "address": "VDA I-6 MANZANA I CASA 15 URB SAMAN TARAZONERO II TURMERO",
      "client_identification": "V10088235",
      "nap_box_name": "284",
      "created_at": "2024-07-25T11:35:47.004081",
      "service_detail": {
        "id": 4488,
        "ip": "172.23.124.2",
        "mac": "GPON009819A6",
        "serial": "GPON009819A6",
        "queue": "Plan_107915_1574_WispHub",
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2024-08-10T08:44:49.526467",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5566,
      "client_name": "YOLIMAR COROMOTO TORRES VARGAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Salto Angel",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144883543",
      "client_email": "TYOLIMAR85@GMAIL.COM",
      "address": "CALLE LOS PINOS CASA NRO 1 URB SALTO ANGEL TURMERO",
      "client_identification": "V17954262",
      "nap_box_name": "39",
      "created_at": "2024-07-25T11:38:03.519630",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5567,
      "client_name": "CARMEN EDILIA CALDEVILA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Durpa",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124771534",
      "client_email": "CARMENCALDEVILLA78@GMAIL.COM",
      "address": "CALLE PARAISO MANZANA 22 CASA NRO 17 SECTOR DESARROLLO URBANISTICO ROSARIO DE PAYA",
      "client_identification": "V13571380",
      "nap_box_name": "CTO-00209",
      "created_at": "2024-07-25T11:39:26.984645",
      "service_detail": {
        "id": 4656,
        "ip": "172.21.36.2",
        "mac": "VSOL004987B1",
        "serial": "VSOL004987B1",
        "queue": "Plan_161893_30183_WispHub",
        "interface": "VLAN240_DURPA",
        "created_at": "2024-08-12T10:13:17.875482",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5568,
      "client_name": "YURY EUNICE NAVAS CAMPELO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Salto Angel",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144509102",
      "client_email": "NAVASYURY@GMAIL.COM",
      "address": "CALLE  LOS GIRASOLES S/N PISO MZ 0207 URB  SALTO ANGEL",
      "client_identification": "V14943154",
      "nap_box_name": "CTO - 68",
      "created_at": "2024-07-25T11:39:55.847055",
      "service_detail": {
        "id": 5571,
        "ip": "172.23.108.2",
        "mac": "VSOL0013E9C1",
        "serial": "VSOL0013E9C1",
        "queue": "Plan_131338_24341_WispHub",
        "interface": "VLAN121_S_ANGEL",
        "created_at": "2024-08-17T08:39:46.030094",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5569,
      "client_name": "YRAIDA MAGALLY GARCIA COLMENARES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Durpa",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243472604",
      "client_email": "GELENVSOSAG@GMAIL.COM",
      "address": "CALLE LEALTAD MANZANA 22 CASA NRO 13 SECTOR DESARROLLO URBANISTICO DURPA",
      "client_identification": "V10752681",
      "nap_box_name": "CTO-00320",
      "created_at": "2024-07-25T11:41:38.254697",
      "service_detail": {
        "id": 4660,
        "ip": "172.20.117.2",
        "mac": "VSOL001215E9",
        "serial": "VSOL001215E9",
        "queue": "Plan_161891_30183_WispHub",
        "interface": "VLAN240_DURPA",
        "created_at": "2024-08-12T10:16:20.461804",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5570,
      "client_name": "KARLA  MAGDA HURTADO RAMOS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121369581",
      "client_email": "KARLAMHRTD609.KH1@GMAIL.COM",
      "address": "AV  2 CASA 513-A SECTOR MATA CABALLO ROSARIO DE PAYA TURMERO",
      "client_identification": "V16012204",
      "nap_box_name": "CTO-00016",
      "created_at": "2024-07-25T11:45:48.767327",
      "service_detail": {
        "id": 4386,
        "ip": "172.22.18.2",
        "mac": "TPLGB68B4F45",
        "serial": "TPLGB68B4F45",
        "queue": "Plan_161889_30183_WispHub",
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2024-08-09T17:14:32.133410",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5571,
      "client_name": "ZULAY VIRGINIA SALVA TIERRA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128839824",
      "client_email": "ZULAYJOSI@GMAIL.COM",
      "address": "CALLE MANZANA B-1 CASA NRO 4 URB SAMAN TARAZONERO II TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V7238350",
      "nap_box_name": "286",
      "created_at": "2024-07-25T11:46:18.211142",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5572,
      "client_name": "DEIVI JORGE BLANCO ANDRADE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243444604",
      "client_email": "DEIVIBLANCO82@GMAIL.COM",
      "address": "AV 2 EDIF TETRA PISO 1 APT 520-B URB MATA CABALLO ROSARIO DE PAYA",
      "client_identification": "V15864095",
      "nap_box_name": "CTO-00567",
      "created_at": "2024-07-25T11:48:48.954655",
      "service_detail": {
        "id": 4492,
        "ip": "172.21.218.2",
        "mac": "TPLGB68B4E41",
        "serial": "TPLGB68B4E41",
        "queue": "Plan_161887_30183_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-08-10T09:29:14.495914",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5573,
      "client_name": "MAGYARI MILAGROS PALMERA PERALTA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04128315713",
      "client_email": "MAGYARIS.PALMERA.PERALTA@GMAIL.COM",
      "address": "CALLE 10 CASA 29 SECTOR SAMAN TARAZONERO II EL MACARO TURMERO ARAGUA",
      "client_identification": "V29924318",
      "nap_box_name": "266",
      "created_at": "2024-07-25T11:48:59.453055",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5574,
      "client_name": "RONA IBETH SIONCHEZ NUÑEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Palma Real",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04125480056",
      "client_email": "RONAIBETH@GMAIL.COM",
      "address": "CALLE 01 CASA NRO 32 SECTOR PALMA REAL",
      "client_identification": "V14286112",
      "nap_box_name": "CTO-00209",
      "created_at": "2024-07-25T11:50:37.667310",
      "service_detail": {
        "id": 5060,
        "ip": "172.20.34.2",
        "mac": "VSOL00128119",
        "serial": "VSOL00128119",
        "queue": "Plan_161891_30183_WispHub",
        "interface": "VLAN240_DURPA",
        "created_at": "2024-08-14T10:30:19.901684",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5575,
      "client_name": "MAURY CARINA ALVES IBAÑEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ppal Paya",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243436531",
      "client_email": "ALVESMAURY25@GMAIL.COM",
      "address": "AV PRINCIPAL  CASA NRO 6-4 SECTOR VALLE PAYA",
      "client_identification": "V16880543",
      "nap_box_name": "471",
      "created_at": "2024-07-25T11:51:21.490364",
      "service_detail": {
        "id": 12536,
        "ip": "172.21.192.2",
        "mac": "5c:e9:31:c8:1e:2e",
        "serial": "TPLGB68B4FD2",
        "queue": null,
        "interface": "VLAN200_OLTs",
        "created_at": "2026-05-20T19:17:27.520491",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5576,
      "client_name": "MIRIALYS PEREZ MEDINA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04125202823",
      "client_email": "MIRIALYS2002P@GMAIL.COM",
      "address": "PRADOS DE PAYA CALLE 6 CASA NRO16 SECTOR",
      "client_identification": "V12338713",
      "nap_box_name": "CTO-00298",
      "created_at": "2024-07-25T11:52:09.413202",
      "service_detail": {
        "id": 9455,
        "ip": "172.21.34.2",
        "mac": "VSOL00498599",
        "serial": "VSOL00498599",
        "queue": "queue1",
        "interface": "VLAN239_PRADOS1",
        "created_at": "2025-09-01T10:33:05.282366",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5577,
      "client_name": "EMERIS GRACIELA BARAZARTE PAEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124820415",
      "client_email": "DAVIDPEROZO0403@GMAIL.COM",
      "address": "CALLE 8 CASA NRO 578-B URB MATA CABALLO ROSARIO DE PAYA",
      "client_identification": "V19516044",
      "nap_box_name": "CTO-00130",
      "created_at": "2024-07-25T11:54:01.373080",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5578,
      "client_name": "ANGELICA NAZARETH ESCOBAR ESCOBAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Durpa",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04129661124",
      "client_email": "ANGELICA.ESCOBAR147@GMAIL.COM",
      "address": "CALLE LEALTAD MANZANA 21 CASA NRO 13 URB DESARROLLO URBANISTICO DURPA",
      "client_identification": "V19605079",
      "nap_box_name": "CTO-00320",
      "created_at": "2024-07-25T11:56:13.850640",
      "service_detail": {
        "id": 4672,
        "ip": "172.18.148.2",
        "mac": "VSOL0047CD69",
        "serial": "VSOL0047CD69",
        "queue": "Plan_161891_30183_WispHub",
        "interface": "VLAN240_DURPA",
        "created_at": "2024-08-12T10:40:39.770415",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5579,
      "client_name": "EDWIN RAFAEL DIAZ VASQUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04143831339",
      "client_email": "EDWINRAFAEL50@HOTMAIL.COM",
      "address": "CALLE 8 CASA NRO 583C URB MATA CABALLO ROSARIO DE PAYA",
      "client_identification": "V20109063",
      "nap_box_name": "CTO-00130",
      "created_at": "2024-07-25T12:00:55.141453",
      "service_detail": {
        "id": 10298,
        "ip": "172.22.19.2",
        "mac": "TPLGB68B4E2E",
        "serial": "TPLGB68B4E2E",
        "queue": null,
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2025-11-24T15:59:21.881693",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5580,
      "client_name": "YULIENNE DEL VALLE JASPE CETRANGOLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Durpa",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04129384555",
      "client_email": "YULIENNE.JC@GMAIL.COM",
      "address": "CALLE LOS CAOBOS CASA NRO 27 SECTOR DURPA",
      "client_identification": "V18645559",
      "nap_box_name": "392",
      "created_at": "2024-07-25T12:05:19.835120",
      "service_detail": {
        "id": 4673,
        "ip": "172.18.82.2",
        "mac": "VSOL00522AB9",
        "serial": "VSOL00522AB9",
        "queue": "Plan_161891_30183_WispHub",
        "interface": "VLAN240_DURPA",
        "created_at": "2024-08-12T10:46:44.603614",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5581,
      "client_name": "ANGELICA MARIA ALVAREZ MEDINA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Guanarito",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128907635",
      "client_email": "ANGELICAMARIA290280@GMAIL.COM",
      "address": "CALLE LOS NARANJOS CASA NRO 20 SECTOR GUANARITO TURMERO",
      "client_identification": "V14182650",
      "nap_box_name": "231",
      "created_at": "2024-07-25T12:55:51.180354",
      "service_detail": {
        "id": 4491,
        "ip": "172.23.76.2",
        "mac": "VSOL0013EDC1",
        "serial": "VSOL0013EDC1",
        "queue": "Plan_112654_15811_WispHub",
        "interface": "VLAN100_OLTs",
        "created_at": "2024-08-10T08:56:15.970066",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5582,
      "client_name": "DARLIN LOREDANA PEREIRA ORTIZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144913624",
      "client_email": "DARLINLOREDANAPEREIRAORTIZ@GMAIL.COM",
      "address": "VDA 8 MANZANA D11 CASA NRO 11 SECTOR SAMAN TARAZONERO II TURMERO ARAGUA",
      "client_identification": "V15161472",
      "nap_box_name": "264",
      "created_at": "2024-07-25T12:58:20.512724",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5583,
      "client_name": "DARWING JOSE ACEVEDO LAREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04123493229",
      "client_email": "R3M1XDARWING@GMAIL.COM",
      "address": "CALLE MANZANA H-4 CASA NRO 12 URB SAMAN  TARAZONERO II TURMERO",
      "client_identification": "V26448896",
      "nap_box_name": "510 DOS",
      "created_at": "2024-07-25T13:00:42.477235",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5584,
      "client_name": "YUBRAN JOSE REYES VILLAHERMOSA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124826444",
      "client_email": "YUBRANREYES12@GMAIL.COM",
      "address": "PANTIN CALLE 12 B CASA NRO 42 ROSARIO DE PAYA",
      "client_identification": "V20334761",
      "nap_box_name": "CTO-00166",
      "created_at": "2024-07-25T13:07:15.599717",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5585,
      "client_name": "MARY EUGENIA MATHISON AZUAJE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128870615",
      "client_email": "MARYMATHISON20@HOTMAIL.COM",
      "address": "CALLE MANZANA H-3 CASA NRO 7 SECTOR SAMAN TARAZONERO II EL MACARO TURMERO ARAGUA",
      "client_identification": "V16129227",
      "nap_box_name": "185",
      "created_at": "2024-07-25T13:11:01.743608",
      "service_detail": {
        "id": 4645,
        "ip": "172.27.46.2",
        "mac": "GPON0097D486",
        "serial": "GPON0097D486",
        "queue": "Plan_137413_1574_WispHub",
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2024-08-12T09:48:08.567019",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5586,
      "client_name": "YOELVIS JOSE OLIVAR ALBARRAN",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124661205",
      "client_email": "OLIVARYOELVIS@GMAIL.COM",
      "address": "CALLE 15 A CASA NRO 8 PANTIN",
      "client_identification": "V18468951",
      "nap_box_name": "CTO-00201",
      "created_at": "2024-07-25T13:13:15.711793",
      "service_detail": {
        "id": 4646,
        "ip": "172.25.2.2",
        "mac": "VSOL0013ECD9",
        "serial": "VSOL0013ECD9",
        "queue": "Plan_161892_30183_WispHub",
        "interface": "VLAN229_PANTIN",
        "created_at": "2024-08-12T09:49:51.102815",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5587,
      "client_name": "LUIS ALBERTO CEDENO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128974321",
      "client_email": "GARCIAZULEIKA4@GMAIL.COM",
      "address": "VDA MANZANA B7 CASA NRO 12 URB SAMAN TARAZONERO II TURMERO ARAGUA",
      "client_identification": "V10764228",
      "nap_box_name": "280",
      "created_at": "2024-07-25T13:15:05.684028",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5588,
      "client_name": "ELVIA JOSEFINA RONDON DE LEON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243059840",
      "client_email": "RONDONELVIA21@GMAIL.COM",
      "address": "CALLE PRINCIPAL MANZANA B-7 CASA 14 URB SAMAN TARAZONERO II EL MACARO TURMERO ESO ARAGUA",
      "client_identification": "V10494737",
      "nap_box_name": "280",
      "created_at": "2024-07-25T13:18:19.933779",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5589,
      "client_name": "JANETT ALICIA GONCALVES RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "San Pablo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04244052626",
      "client_email": "JANETTGONCALVES37@GMAIL.COM",
      "address": "2DA AVENIDA ESTE CASA NRO 15-B URB SAN PABLO TURMERO",
      "client_identification": "V13530264",
      "nap_box_name": "140",
      "created_at": "2024-07-25T13:20:48.910969",
      "service_detail": {
        "id": 4650,
        "ip": "172.28.3.2",
        "mac": "VSOL0013E879",
        "serial": "VSOL0013E879",
        "queue": "Plan_92194_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-08-12T10:01:13.382322",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5590,
      "client_name": "MATILDE ROSARIO BELLO DE BETANCOURT",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona II",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04147512905",
      "client_email": "BMATILDE07@GMAIL.COM",
      "address": "AV 6 CASA NRO 18 URB LA CASONA 2 TURMERO",
      "client_identification": "V9684430",
      "nap_box_name": "CTO-00083",
      "created_at": "2024-07-25T13:32:55.813560",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5591,
      "client_name": "BEATRIZ ELENA LARRAZABAL REYES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Haras de San Pablo",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04144660492",
      "client_email": "BELENATRIX1986@GMAIL.COM",
      "address": "CALLE PRINCIPAL CASA NRO 34 URB HARAS DE SAN PABLO MANZANA B TURMERO",
      "client_identification": "V18164786",
      "nap_box_name": "247",
      "created_at": "2024-07-25T13:35:57.677643",
      "service_detail": {
        "id": 9854,
        "ip": "10.15.120.2",
        "mac": "VSOL0013E739",
        "serial": "VSOL0013E739",
        "queue": null,
        "interface": "VLAN210_HSP_OLT1",
        "created_at": "2025-11-10T18:11:31.644221",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5592,
      "client_name": "WILMERIS DESIREE ABREU RIVAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243029089",
      "client_email": "WILDESIREEABREU88@GMAIL.COM",
      "address": "CALLE CASA NRO 600B URB MATA CABALLO ROSARIO DE PAYA",
      "client_identification": "V19608900",
      "nap_box_name": "160",
      "created_at": "2024-07-25T13:39:37.269775",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5593,
      "client_name": "IRENE ANGELINA REINA OVIEDO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124561379",
      "client_email": "IREANGREOVI@GMAIL.COM",
      "address": "SAMAN TARAZONERO II MANZANA C-04 CASA NRO 12 SECTOR EL MACARO",
      "client_identification": "V17798889",
      "nap_box_name": "115",
      "created_at": "2024-07-25T13:41:43.830259",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5594,
      "client_name": "WENDY MARIA SEIJAS GONZALEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243607623",
      "client_email": "WD271828@GMAIL.COM",
      "address": "CALLE 2, CASA NRO. 16 SECTOR PARDOS II, ROSARIO DE PAYA, ARAGUA",
      "client_identification": "V26834022",
      "nap_box_name": "CTO-00100",
      "created_at": "2024-07-25T13:41:46.495987",
      "service_detail": {
        "id": 4178,
        "ip": "172.31.23.2",
        "mac": "OEMT3C62324E",
        "serial": "OEMT3C62324E",
        "queue": "Plan_161905_30183_WispHub",
        "interface": "VLAN242_PRADOS2",
        "created_at": "2024-08-02T17:10:28.481158",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5595,
      "client_name": "WENDY ANAIS SILVA RAMIREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243301738",
      "client_email": "WENDYSILVA.RZ@GMAIL.COM",
      "address": "CALLE PPAL SECTOR SAMAN TARAZONERO II EL MACARO TURMERO",
      "client_identification": "V20893887",
      "nap_box_name": "286",
      "created_at": "2024-07-25T13:44:23.402641",
      "service_detail": {
        "id": 4662,
        "ip": "172.23.149.2",
        "mac": "GPON0097BDC6",
        "serial": "GPON0097BDC6",
        "queue": "Plan_107915_1574_WispHub",
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2024-08-12T10:21:30.943643",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5596,
      "client_name": "BLANCA OMAIRA DUARTE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04127702451",
      "client_email": "BLANCADUARTEOMAIRA@GMAIL.COM",
      "address": "URB SAMAN TARAZONERO II MANZANA C7 CASA NRO 2 SECTOR EL MACARO TURMERO ARAGUA",
      "client_identification": "V13116243",
      "nap_box_name": "263",
      "created_at": "2024-07-25T13:51:10.698689",
      "service_detail": {
        "id": 4664,
        "ip": "172.27.60.2",
        "mac": "GPON00981716",
        "serial": "GPON00981716",
        "queue": "Plan_137413_1574_WispHub",
        "interface": "VLAN100_OLTs",
        "created_at": "2024-08-12T10:23:54.145020",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5597,
      "client_name": "NATALIE ALEJANDRA JIMENEZ MEDINA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 16,
        "name": "RECURRENTE RESIDENCIAL PLAN 800M",
        "cost": "55.00",
        "code": "FOR800",
        "profile": "800M/800M"
      },
      "client_mobile": "04243069320",
      "client_email": "NATALIE44054@GMAIL.COM",
      "address": "CALLE MANZANA D-5 CASA NRO 18 SECTOR SAMAN TARAZONERO II TURMERO",
      "client_identification": "V18552873",
      "nap_box_name": "161",
      "created_at": "2024-07-25T13:54:16.514892",
      "service_detail": {
        "id": 4666,
        "ip": "172.23.151.2",
        "mac": "GPON009809F6",
        "serial": "GPON009809F6",
        "queue": "Plan_92324_1574_WispHub",
        "interface": "VLAN100_OLTs",
        "created_at": "2024-08-12T10:30:40.964718",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5598,
      "client_name": "NOLASCA ALBINA GUERRERO VALERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128926481",
      "client_email": "ALBAROMERO16061963@GMAIL.COM",
      "address": "SAMAN TARAZONERO II VDA 04 CASA 06-09 SECTOR EL MACARO",
      "client_identification": "V5726663",
      "nap_box_name": "505",
      "created_at": "2024-07-25T13:57:01.950518",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5599,
      "client_name": "HELIANA NINOSKA CONTRERAS ULLOA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Cambur",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04123986473",
      "client_email": "HELIANAN.CONTRERAS@GMAIL.COM",
      "address": "CALLE PRINCIPAL DE PAYA CASA ANEXO NRO. 47 SECTOR EL CAMBUR, ROSARIO DE PAYA, ARAGUA.",
      "client_identification": "V20706828",
      "nap_box_name": "CTO-00244",
      "created_at": "2024-07-25T14:17:38.224320",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5600,
      "client_name": "CLAUDIA DE LOURDES RAMOS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124589385",
      "client_email": "RAMOSCLAUDIA0602@GMAIL.COM",
      "address": "VDA 6-7 CASA NRO B1 SECTOR SAMAN TARAZONERO II TURMERO EDO ARAGUA",
      "client_identification": "V14191841",
      "nap_box_name": "128",
      "created_at": "2024-07-25T15:23:01.418239",
      "service_detail": {
        "id": 4669,
        "ip": "172.27.37.2",
        "mac": "GPON0097D5F6",
        "serial": "GPON0097D5F6",
        "queue": "Plan_107915_1574_WispHub",
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2024-08-12T10:35:45.419360",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5601,
      "client_name": "GREGORIO ANTONIO CRESPO CAMACHO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04128980570",
      "client_email": "CARLOSEDUARDO20028515435@GMAIL.COM",
      "address": "AV PPAL CASA MANZANA C-2 NRO 3 SECTOR SAMAN TARAZONERO II TURMERO ARAGUA",
      "client_identification": "V8515435",
      "nap_box_name": "502",
      "created_at": "2024-07-25T15:24:59.670980",
      "service_detail": {
        "id": 4670,
        "ip": "172.27.45.2",
        "mac": "OEMT3C623172",
        "serial": "OEMT3C623172",
        "queue": "Plan_89392_1574_WispHub",
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2024-08-12T10:37:48.404665",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5602,
      "client_name": "ANGEL EDUARDO VASQUEZ RISSO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Paya Abajo",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04124610376",
      "client_email": "AEVRISSO@GMAIL.COM",
      "address": "CALLE SAN MIGUEL CASA NRO 58 SECTOR PAYA ABAJO ROSARIO DE PAYA",
      "client_identification": "V23919992",
      "nap_box_name": "CTO-00002",
      "created_at": "2024-07-25T15:27:15.562098",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5603,
      "client_name": "JOSE ALEJANDRO ACOSTA VILLEGAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Paya Abajo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243547752",
      "client_email": "JAVA2022@HOTMAIL.COM",
      "address": "CALLE SAN MIGUEL CASA NRO 34 SECTOR PAYA ABAJO ROSARIO DE PAYA",
      "client_identification": "V13200734",
      "nap_box_name": "CTO-00002",
      "created_at": "2024-07-25T16:32:36.168891",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5604,
      "client_name": "WILLIAM ALEJANDRO LEVITAN ABDELNOUR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "San Pablo",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04243227916",
      "client_email": "LEVITANW@GMAIL.COM",
      "address": "AV. PRIMERA AVENIDA ESTE CASA NRO 16 URB SAN PABLO TURMERO",
      "client_identification": "V24930477",
      "nap_box_name": "140",
      "created_at": "2024-07-25T16:35:33.314133",
      "service_detail": {
        "id": 10033,
        "ip": "172.23.77.2",
        "mac": "VSOL0013EDA9",
        "serial": "VSOL0013EDA9",
        "queue": null,
        "interface": "VLAN224_SAN_PABLO_OLT1",
        "created_at": "2025-11-11T16:40:39.074897",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5605,
      "client_name": "GEIDER EDUARDO BARROSO GONZALEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128920349",
      "client_email": "GERALDOBARROSO349@GMAIL.COM",
      "address": "VDA 2 MANZANA CASA 19 SAMAN TARAZONERO II TURMERO ARAGUA",
      "client_identification": "V29981065",
      "nap_box_name": "119",
      "created_at": "2024-07-25T16:40:15.624436",
      "service_detail": {
        "id": 4708,
        "ip": "172.27.28.2",
        "mac": "GPON00980986",
        "serial": "GPON00980986",
        "queue": "Plan_137413_1574_WispHub",
        "interface": "VLAN100_OLTs",
        "created_at": "2024-08-12T11:55:34.760849",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5606,
      "client_name": "SULEIDY COROMOTO NAVAS POLANCO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243734902",
      "client_email": "NAVASSULEIDY13@GMAIL.COM",
      "address": "VDA 2 MANZANA 2 CASA 14 SECTOR SAMAN TARAZONERO II TURMERO EDO ARAGUA",
      "client_identification": "V9646590",
      "nap_box_name": "CE - 227",
      "created_at": "2024-07-25T16:44:43.554147",
      "service_detail": {
        "id": 13109,
        "ip": "172.27.38.2",
        "mac": "GP:ON:00:98:1B:96",
        "serial": "GPON00981B96",
        "queue": null,
        "interface": "VLAN100_OLTs",
        "created_at": "2026-10-03T09:03:22.970615",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5607,
      "client_name": "LUIS ALFONSO ANDRADE AMADOR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Paya Abajo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04140474522",
      "client_email": "LUALFAN@HOTMAIL.COM",
      "address": "CALLE SAN ANTONIO CASA NRO S/N 15 BARRIO PAYA ABAJO ROSARIO DE PAYA",
      "client_identification": "V12928829",
      "nap_box_name": "CTO-00307",
      "created_at": "2024-07-25T16:46:37.125725",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5608,
      "client_name": "DAMELYS MERCEDES RIVERO PIÑERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Paya Abajo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243398031",
      "client_email": "DAMELYSMERCEDES1979@GMAIL.COM",
      "address": "CALLE SAN ANTONIO CASA NRO 23-B SECTOR PAYA ABAJO ROSARIO DE PAYA",
      "client_identification": "V15129026",
      "nap_box_name": "271",
      "created_at": "2024-07-25T16:48:57.300835",
      "service_detail": {
        "id": 11503,
        "ip": "172.23.102.2",
        "mac": "VSOL0012E6C9",
        "serial": "VSOL0012E6C9",
        "queue": null,
        "interface": "VLAN229_PANTIN",
        "created_at": "2026-02-05T13:02:20.797636",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5609,
      "client_name": "MIRIAN JOSEFINA BORGES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Paya Abajo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144639052",
      "client_email": "SINAYAVILA@GMAIL.COM",
      "address": "CALLE SAN ANTONIO  CASA NRO 12 SECTOR  PAYA  ABAJO ROSARIO DE PAYA",
      "client_identification": "V12481571",
      "nap_box_name": "271",
      "created_at": "2024-07-25T16:54:46.351219",
      "service_detail": {
        "id": 11483,
        "ip": "172.23.96.2",
        "mac": "VSOL0012E651",
        "serial": "VSOL0012E651",
        "queue": null,
        "interface": "VLAN229_PANTIN",
        "created_at": "2026-02-04T16:17:32.477581",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5610,
      "client_name": "NALDA LISBETH VILLEGAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Paya Abajo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144533022",
      "client_email": "NALDALIS09@GMAIL.COM",
      "address": "CALLE  SAN ANTONIO LOCAL NRO 16 SECTOR  PAYA TURMERO",
      "client_identification": "V12478354",
      "nap_box_name": "271",
      "created_at": "2024-07-25T16:56:38.441762",
      "service_detail": {
        "id": 11484,
        "ip": "172.23.99.2",
        "mac": "VSOL0012E3D1",
        "serial": "VSOL0012E3D1",
        "queue": null,
        "interface": "VLAN229_PANTIN",
        "created_at": "2026-02-04T16:34:17.159065",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5613,
      "client_name": "DAVID JAVIER PAEZ CORDERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128015848",
      "client_email": "DJPAEZC@GMAIL.COM",
      "address": "CALLE PRINCIPAL CASA MANZANA E4 NRO3 URB SAMAN TARAZONERO II TURMERO ARAGUA",
      "client_identification": "V17273283",
      "nap_box_name": "112",
      "created_at": "2024-07-25T17:02:38.835361",
      "service_detail": {
        "id": 4722,
        "ip": "172.27.63.2",
        "mac": "GPON0097B8A6",
        "serial": "GPON0097B8A6",
        "queue": "queue1",
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2024-08-12T13:09:41.013745",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5614,
      "client_name": "HECTOR JOSE RODRIGUEZ BRAVO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124390041",
      "client_email": "HJOSERODRIGUEZB@GMAIL.COM",
      "address": "MANZANA E 2 CASA NRO 8 SAMAN TARAZONERO II TUURMERO ARAGUA",
      "client_identification": "V13134158",
      "nap_box_name": "161 DOS",
      "created_at": "2024-07-26T08:01:44.044193",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5615,
      "client_name": "HAIRELYS ESTEFANY GODOY ROMAN",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Paya Abajo",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04128864817",
      "client_email": "HAROLDGODOY394@GMAIL.COM",
      "address": "CALLE SAN MIGUEL CASA NRO 19 SECTOR PAYA ABAJO",
      "client_identification": "V30923532",
      "nap_box_name": "CTO-00319",
      "created_at": "2024-07-26T08:04:39.572014",
      "service_detail": {
        "id": 7513,
        "ip": "172.23.83.2",
        "mac": "TPLGBA687486",
        "serial": "TPLGBA687486",
        "queue": "Plan_161870_30181_WispHub",
        "interface": "VLAN231_PAYABAJO",
        "created_at": "2024-12-17T13:05:42.831557",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5616,
      "client_name": "ORITZA DEL VALLE CARPINTERO SUAREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Paya Abajo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121481854",
      "client_email": "ORITZASUAREZ578@GMAIL.COM",
      "address": "CALLE CENTRO CASA NRO 18 SECTOR PAYA ABAJO ROSARIO DE PAYA",
      "client_identification": "V29786847",
      "nap_box_name": "CTO-00319",
      "created_at": "2024-07-26T08:06:34.576914",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5617,
      "client_name": "JOSE LUIS AYALA VILLEGAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Paya Abajo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04120460057",
      "client_email": "AYALAPITY17@GMAIL.COM",
      "address": "CALLE SAN MIGUEL CASA NRO 22 SECTOR PAYA ABAJO ROSARIO DE PAYA",
      "client_identification": "V26679926",
      "nap_box_name": "CTO-00319",
      "created_at": "2024-07-26T08:08:29.089624",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5618,
      "client_name": "ESTHEFANNY JUSBELYS MARQUEZ SALAZAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Bicentenario",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04120485115",
      "client_email": "ESTHEFANNYMAR21.44@GMAIL.COM",
      "address": "CALLE ROBLES MANZANA 12 CASA NRO 07 PB SECTOR DESARROLLO URBANISTICO ROSARIO DE PAYA",
      "client_identification": "V21442989",
      "nap_box_name": "CTO-00192",
      "created_at": "2024-07-26T08:21:17.454877",
      "service_detail": {
        "id": 4675,
        "ip": "172.21.31.2",
        "mac": "VSOL0011F7E9",
        "serial": "VSOL0011F7E9",
        "queue": "Plan_161893_30183_WispHub",
        "interface": "VLAN240_DURPA",
        "created_at": "2024-08-12T10:49:41.045932",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5619,
      "client_name": "NORELYS JOSEFINA TOVAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Paya Abajo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04127769785",
      "client_email": "JUANCARLOSTOVAR045@GMAIL.COM",
      "address": "CALLE CAMPO ELIAS CASA NRO 18 SECTOR PAYA ABAJO ROSARIO DE PAYA",
      "client_identification": "V10756334",
      "nap_box_name": "CTO-0252",
      "created_at": "2024-07-26T08:24:09.644366",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5620,
      "client_name": "MANUEL SERAFIN MACEDO DE ANDRADE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128224102",
      "client_email": "AANDRADESERAFIN541@GMAIL.COM",
      "address": "CALLE DEL CENTRO CASA NRO 01 SECTOR TURMERO",
      "client_identification": "V81176584",
      "nap_box_name": "649",
      "created_at": "2024-07-26T08:24:37.873498",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5621,
      "client_name": "TRIANA DEL VALLE ACOSTA SANCHEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Durpa",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243241214",
      "client_email": "TRIANAACOS83@GMAIL.COM",
      "address": "CALLE SIMON RODRIGUEZ CASA NRO 7 SECTOR DURPA",
      "client_identification": "V16553848",
      "nap_box_name": "382",
      "created_at": "2024-07-26T08:27:59.582264",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5622,
      "client_name": "YELITZA DEL VALLE SANCHEZ OROPEZA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Prados I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04143583754",
      "client_email": "YELITZASANCHEZ362@GMAIL.COM",
      "address": "CALLE 02 CASA NRO 33 SECTOR PRADOS I",
      "client_identification": "V9663245",
      "nap_box_name": "CTO-00300",
      "created_at": "2024-07-26T08:33:29.751064",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5623,
      "client_name": "RIGOBERTO FLORES DIAZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Paya Abajo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144789903",
      "client_email": "NANOSSS18@GMAIL.COM",
      "address": "CALLE CAMPO ELIAS CASA NRO 14-2 SECTOR PAYA ABAJO ROSARIO DE PAYA",
      "client_identification": "V16691731",
      "nap_box_name": "CTO-0252",
      "created_at": "2024-07-26T08:34:18.535980",
      "service_detail": {
        "id": 7502,
        "ip": "172.23.80.2",
        "mac": "TPLGBA687A91",
        "serial": "TPLGBA687A91",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN231_PAYABAJO",
        "created_at": "2024-12-17T12:06:53.917785",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5624,
      "client_name": "ELIDA MARGARITA HIDALGO GOMEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Paya Abajo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121792014",
      "client_email": "KEVINDAVID1116@GMAIL.COM",
      "address": "CALLE CAMPO ELIAS CASA NRO 12-A BARRIO PAYA ABAJO ROSARIO DE PAYA",
      "client_identification": "V10757459",
      "nap_box_name": "CTO-0252",
      "created_at": "2024-07-26T08:36:16.712539",
      "service_detail": {
        "id": 7501,
        "ip": "172.23.101.2",
        "mac": "VSOL0012E4D1",
        "serial": "VSOL0012E4D1",
        "queue": "Plan_161889_30183_WispHub",
        "interface": "VLAN231_PAYABAJO",
        "created_at": "2024-12-17T12:00:22.305910",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5625,
      "client_name": "XIOMARA JOSEFINA JULIO TERAN",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Paya Abajo",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04241501184",
      "client_email": "XIOMARATERAN26@GMAIL.COM",
      "address": "CALLE CAMPO ELIAS NRO 13 SECTOR PAYA ABAJO ROSARIO DE PAYA",
      "client_identification": "V17140944",
      "nap_box_name": "CTO-0252",
      "created_at": "2024-07-26T08:38:23.258942",
      "service_detail": {
        "id": 7500,
        "ip": "172.23.94.2",
        "mac": "VSOL0012E5C9",
        "serial": "VSOL0012E5C9",
        "queue": "Plan_161889_30183_WispHub",
        "interface": "VLAN231_PAYABAJO",
        "created_at": "2024-12-17T11:57:47.299342",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5626,
      "client_name": "CARLOS JUNIOR PEREZ ARREDONDO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Paya Abajo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128903445",
      "client_email": "JUNIORPEREZCARLOS5@GMAIL.COM",
      "address": "CALLE LA CAPILLA CASA NRO 3 SECTOR PAYA ABAJO ROSARIO DE PAYA",
      "client_identification": "V17245079",
      "nap_box_name": "254",
      "created_at": "2024-07-26T08:41:19.772532",
      "service_detail": {
        "id": 11470,
        "ip": "172.23.85.2",
        "mac": "TPLGBA687CA9",
        "serial": "TPLGBA687CA9",
        "queue": null,
        "interface": "VLAN229_PANTIN",
        "created_at": "2026-02-04T12:10:30.414257",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5627,
      "client_name": "ALEXIS RAMON MENDOZA DIAZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124292877",
      "client_email": "ANYELA29121990@GMAIL.COM",
      "address": "CALLE PRINCIPAL CASA NRO 11 MANZANA B-9 SAMAN TARAZONERO II EL MACARO",
      "client_identification": "V19032879",
      "nap_box_name": "CTO-00511",
      "created_at": "2024-07-26T08:44:19.206699",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5628,
      "client_name": "AMERICA SULAY AMADOR BORGUES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Paya Abajo",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04121349128",
      "client_email": "AMERICABORGES2608@GMAIL.COM",
      "address": "CALLE LA CAPILLA CASA NRO 05-I BARRIO PAYA ABAJO ROSARIO DE PAYA",
      "client_identification": "V14943308",
      "nap_box_name": "254",
      "created_at": "2024-07-26T08:46:09.412111",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5629,
      "client_name": "LUIS LEONARDO DIAZ GOMEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Paya Abajo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04247327178",
      "client_email": "leandro.1595.a@gmail.com",
      "address": "CALLE PRINCIPAL CASA PARCELA NRO 4 SECTOR PAYA ABAJO ROSARIO DE PAYA",
      "client_identification": "V20817444",
      "nap_box_name": "CTO-00307",
      "created_at": "2024-07-26T08:47:52.420840",
      "service_detail": {
        "id": 11471,
        "ip": "172.23.91.2",
        "mac": "VSOL0012E099",
        "serial": "VSOL0012E099",
        "queue": null,
        "interface": "VLAN229_PANTIN",
        "created_at": "2026-02-04T12:56:16.547773",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5630,
      "client_name": "JESUS  DANIEL FARIAS AMADOR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Paya Abajo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121485513",
      "client_email": "DANFARI022@GMAIL.COM",
      "address": "CALLE CAPILLA CASA NRO 16-2 SECTOR PAYA ABAJO ROSARIO DE PAYA",
      "client_identification": "V27520146",
      "nap_box_name": "254",
      "created_at": "2024-07-26T08:55:20.741328",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5631,
      "client_name": "JOSE FERMIN SALAMANCA PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Paya Abajo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04149442195",
      "client_email": "SALAMANCAJOSE07@GMAIL.COM",
      "address": "SECTOR PAYA ABAJO CALLE EL CENTRO CASA NRO 3 ROSARIO DE PAYA",
      "client_identification": "V17954330",
      "nap_box_name": "CTO-00307",
      "created_at": "2024-07-26T08:58:29.790056",
      "service_detail": {
        "id": 10639,
        "ip": "172.23.88.2",
        "mac": "VSOL0012E5A1",
        "serial": "VSOL0012E5A1",
        "queue": null,
        "interface": "VLAN231_PAYABAJO",
        "created_at": "2025-12-09T08:46:42.397663",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5632,
      "client_name": "WILSON ALEXANDER LEAL PIÑERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243206845",
      "client_email": "WILSONLEAL534@GMAIL.COM",
      "address": "CALLE NUMERO 5 CASA 41 BARRIO  SAMAN TARAZONERO II TURMERO",
      "client_identification": "V25620933",
      "nap_box_name": "93",
      "created_at": "2024-07-26T09:07:46.274354",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5633,
      "client_name": "DAVID RAFAEL CASTRO MANZANILLA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243275472",
      "client_email": "DAVIDDARC7@GMAIL.COM",
      "address": "CALLE 18-B CASA NRO 59 URB PANTIN",
      "client_identification": "V13426716",
      "nap_box_name": "CTO-00321",
      "created_at": "2024-07-26T09:38:42.576383",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5634,
      "client_name": "ALFREDO JOSE AZUAJE MALDONADO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "San Sebastian",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243422105",
      "client_email": "AZUAJEJOSEALFREDO1994@GMAIL.COM",
      "address": "CALLE 7 CASA NRO 30 SAN SEBASTIAN EL MACARO",
      "client_identification": "V22876505",
      "nap_box_name": "75",
      "created_at": "2024-07-26T09:44:50.147644",
      "service_detail": {
        "id": 5429,
        "ip": "172.23.73.2",
        "mac": "VSOL0013E961",
        "serial": "VSOL0013E961",
        "queue": "Plan_137413_1574_WispHub",
        "interface": "VLAN125_SAN_SEBASTIAN_ZTE",
        "created_at": "2024-08-16T15:59:26.830106",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5635,
      "client_name": "YELIANNY LEUDIMAR SERGI LIENDO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128480973",
      "client_email": "AARONNAVEDA50@GMAIL.COM",
      "address": "CALLE MANZANA C5 CASA N 17 URB SAMAN TARAZONERO II TURMERO ARAGUA",
      "client_identification": "V27646959",
      "nap_box_name": "186",
      "created_at": "2024-07-26T09:52:10.218007",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5636,
      "client_name": "DOUGLAS JESUS OLLARVES HERNANDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121992133",
      "client_email": "ZORELISNAVAS67@GMAIL.COM",
      "address": "VDA 10 MANZANA E CASA N11 URB SAMAN TARAZONERO II TURMERO ARAGUA",
      "client_identification": "V9513953",
      "nap_box_name": "95",
      "created_at": "2024-07-26T09:54:31.804688",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5637,
      "client_name": "SUSANA BERNANDITA RODRIGUEZ DE QUIARO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04243340221",
      "client_email": "QUIAROSUSANA@GMAIL.COM",
      "address": "CALLE 6 CASA NRO 456 URB MATA CABALLO ROSARIO DE PAYA",
      "client_identification": "V8191461",
      "nap_box_name": "CTO-00178",
      "created_at": "2024-07-26T09:56:55.968855",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5638,
      "client_name": "ANDRES FELIPE PERDOMO CONTRERAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04120475466",
      "client_email": "CELIACONTRERAS2710@GMAIL.COM",
      "address": "CALLE 06 CASA NRO 12 SECTOR PRADOS I",
      "client_identification": "V21466485",
      "nap_box_name": "CTO-00298",
      "created_at": "2024-07-26T09:59:12.063570",
      "service_detail": {
        "id": 5427,
        "ip": "172.18.166.2",
        "mac": "VSOL0011F809",
        "serial": "VSOL0011F809",
        "queue": "Plan_161905_30183_WispHub",
        "interface": "VLAN239_PRADOS1",
        "created_at": "2024-08-16T15:56:17.551908",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5639,
      "client_name": "YUSMELY COROMOTO MIILANO QUINTANA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128926465",
      "client_email": "MILANOYUSMELY@GMAIL.COM",
      "address": "CALLE 5 MANZANA F1 CASA 21 URB SAMAN TARAZONERO 2 TURMERO ARAGUA",
      "client_identification": "V16865208",
      "nap_box_name": "161 DOS",
      "created_at": "2024-07-26T09:59:38.151816",
      "service_detail": {
        "id": 9955,
        "ip": "10.16.108.2",
        "mac": "GPON0097D876",
        "serial": "GPON0097D876",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2025-11-11T11:02:36.324514",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5641,
      "client_name": "SAIDA JOSEFINA MECIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04125324488",
      "client_email": "JOSEFMEC9@GMAIL.COM",
      "address": "CALLE 18-B CASA NRO 57 URB PANTIN ROSARIO DE PAYA",
      "client_identification": "V9668425",
      "nap_box_name": "CTO-00321",
      "created_at": "2024-07-26T10:01:08.345403",
      "service_detail": {
        "id": 4681,
        "ip": "172.20.214.2",
        "mac": "VSOL004985F1",
        "serial": "VSOL004985F1",
        "queue": "Plan_161891_30183_WispHub",
        "interface": "VLAN229_PANTIN",
        "created_at": "2024-08-12T11:04:56.255113",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5642,
      "client_name": "GENESIS CAROLINA VILLEGAS TORRES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128906715",
      "client_email": "GENE.VILLEGAS90T@GMAIL.COM",
      "address": "CALLE 16 CASA MANZANA E 10 NRO 16 SECTOR SAMAN TARAZONERO II TURMERO ARAGUA",
      "client_identification": "V19793908",
      "nap_box_name": "95",
      "created_at": "2024-07-26T10:01:53.107849",
      "service_detail": {
        "id": 4799,
        "ip": "172.27.2.2",
        "mac": "GPON0097E006",
        "serial": "GPON0097E006",
        "queue": "queue1",
        "interface": "VLAN100_OLTs",
        "created_at": "2024-08-12T16:37:06.062077",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5643,
      "client_name": "DANELIS IDRIANIS BLANCO DE GONZALEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04243455184",
      "client_email": "SILENAD2009@GMAIL.COM",
      "address": "CALLE 2 CASA NRO 67 SECTOR MATA CABALLO TURMERO",
      "client_identification": "V16851390",
      "nap_box_name": "CTO-00565 DOS",
      "created_at": "2024-07-26T10:02:16.972159",
      "service_detail": {
        "id": 4497,
        "ip": "172.21.221.2",
        "mac": "TPLGB68B4E27",
        "serial": "TPLGB68B4E27",
        "queue": "Plan_161890_30183_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-08-10T09:50:47.928271",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5644,
      "client_name": "FERNANDO JOSE NIEVES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243098327",
      "client_email": "FERNANDONIEVESJOSE18@GMAIL.COM",
      "address": "CALLE 02 CASA NRO 14 SECTOR PRADOS I ROSARIO DE PAYA",
      "client_identification": "V16383056",
      "nap_box_name": "587 DOS",
      "created_at": "2024-07-26T10:03:03.839532",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5645,
      "client_name": "ELSA ANDREINA SOLIS MEDINA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04144896968",
      "client_email": "SOLISMEDINA.MASTERS@GMAIL.COM",
      "address": "CALLE 7 CASA NRO 547-C URB MATA CABALLO ROSARIO DE PAYA TURMERO",
      "client_identification": "V19515869",
      "nap_box_name": "CTO-00073",
      "created_at": "2024-07-26T10:03:59.132448",
      "service_detail": {
        "id": 4498,
        "ip": "172.31.20.2",
        "mac": "TPLGB68B5141",
        "serial": "TPLGB68B5141",
        "queue": "Plan_161887_30183_WispHub",
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2024-08-10T09:53:52.720465",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5646,
      "client_name": "HEYDI COROMOTO ORTEGA BLANCO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243022399",
      "client_email": "HORTEGA576.HO@GMAIL.COM",
      "address": "CALLE 02 CASA NRO 07 SECTOR PRADOS I",
      "client_identification": "V13780823",
      "nap_box_name": "587 DOS",
      "created_at": "2024-07-26T10:04:27.658695",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5647,
      "client_name": "MARILYN OTILIA ALAMO DE AMADOR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243042265",
      "client_email": "ALAMOMARILYN326@GMAIL.COM",
      "address": "CALLE 7 CASA TETRA NRO 533D URB MATA CABALLO ROSARIO DE PAYA",
      "client_identification": "V16269834",
      "nap_box_name": "CTO-00310",
      "created_at": "2024-07-26T10:05:42.212588",
      "service_detail": {
        "id": 4499,
        "ip": "172.21.251.2",
        "mac": "TPLG608B4E7A",
        "serial": "TPLG608B4E7A",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2024-08-10T11:06:28.068855",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5648,
      "client_name": "MARY YELITZA HIDALGO BORCEGUI",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Prados I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124354443",
      "client_email": "HIDALGOMARI2017@GMAIL.COM",
      "address": "CALLE 6 CASA NRO 25 SECTOR PRADOS I",
      "client_identification": "V11090556",
      "nap_box_name": "417",
      "created_at": "2024-07-26T10:05:51.956431",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5649,
      "client_name": "MERY APONTE CATARI",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243141269",
      "client_email": "LAMEDAHER.EDUARDOS68@GMAIL.COM",
      "address": "CALLE 2 CASA NRO 28 SECTOR PRADOS I",
      "client_identification": "V10459129",
      "nap_box_name": "CTO-00300",
      "created_at": "2024-07-26T10:08:01.065937",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5650,
      "client_name": "YURAIMA ISABEL PUENTE GONZALEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243791262",
      "client_email": "CHIQUIPUENTE.1@GMAIL.COM",
      "address": "CALLE 2 CASA NRO 28 SECTOR PRADOS I",
      "client_identification": "V11239717",
      "nap_box_name": "CTO-00300",
      "created_at": "2024-07-26T10:13:50.411202",
      "service_detail": {
        "id": 4700,
        "ip": "172.18.153.2",
        "mac": "VSOL0047DA81",
        "serial": "VSOL0047DA81",
        "queue": "Plan_161865_30181_WispHub",
        "interface": "VLAN239_PRADOS1",
        "created_at": "2024-08-12T11:45:27.690278",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5651,
      "client_name": "JOSE ALEJANDRO HERNANDEZ MARQUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243556128",
      "client_email": "KARENMANZANILLA06@GMAIL.COM",
      "address": "CALLE 6 CASA NRO 417 URB MATA CABALLO ROSARIO DE PAYA",
      "client_identification": "V18552643",
      "nap_box_name": "CTO-00031",
      "created_at": "2024-07-26T10:16:59.642972",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5652,
      "client_name": "JOSE LUIS VARGAS LUCENA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04241732885",
      "client_email": "INFANTEEDIMAR@GMAIL.COM",
      "address": "CALLE 6 CASA NRO 408 URB MATA CABALLO ROSARIO DE PAYA",
      "client_identification": "V14067245",
      "nap_box_name": "CTO-00312",
      "created_at": "2024-07-26T10:22:12.448622",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5654,
      "client_name": "OSMEL DANIEL VILORIA FLORES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04243607613",
      "client_email": "OSMELVILORIA1@GMAIL.COM",
      "address": "CALLE 7 EDIF BLOQUE PISO 541-C APT URB MATA CABALLO TURMERO",
      "client_identification": "V17016965",
      "nap_box_name": "CTO-00167 DOS",
      "created_at": "2024-07-26T10:25:19.082921",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5655,
      "client_name": "RUDER ANDRES FLORES AREBALO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Pantin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124611911",
      "client_email": "ANACELISMM55@GMAIL.COM",
      "address": "CALLE 20 CASA NRO 30 URB PANTIN ROSARIO DE PAYA",
      "client_identification": "V20988528",
      "nap_box_name": "CTO-00435",
      "created_at": "2024-07-26T10:26:54.317309",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5656,
      "client_name": "MARY JULY GONZALEZ AYALA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243961954",
      "client_email": "MARY04243961954@GMAIL.COM",
      "address": "CALLE 07 EDIF TETRA PB APT 544-A URB MATA  CABALLO ROSARIO DE PAYA",
      "client_identification": "V13454956",
      "nap_box_name": "CTO-00167 DOS",
      "created_at": "2024-07-26T10:27:27.514790",
      "service_detail": {
        "id": 4507,
        "ip": "172.21.193.2",
        "mac": "TPLGB68B5112",
        "serial": "TPLGB68B5112",
        "queue": "Plan_161887_30183_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-08-10T13:22:32.570550",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5657,
      "client_name": "JOSE GREGORIO COLMENARES PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124458932",
      "client_email": "JOSEGCOLMENARES20@GMAIL.COM",
      "address": "CALLE 05-A CASA NRO 14 PANTIN ROSARIO DE PAYA",
      "client_identification": "V9658039",
      "nap_box_name": "CTO-00135",
      "created_at": "2024-07-26T10:29:38.305932",
      "service_detail": {
        "id": 11327,
        "ip": "172.20.143.2",
        "mac": "VSOL004966F1",
        "serial": "VSOL004966F1",
        "queue": null,
        "interface": "VLAN229_PANTIN",
        "created_at": "2026-01-23T09:30:38.090562",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5658,
      "client_name": "YOSBER JOSUE PEREZ PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243060074",
      "client_email": "YOSBERPEREZZ@GMAIL.COM",
      "address": "CALLE 7 CASA NRO 542 A URB MATA CABALLO ROSARIO DE PAYA",
      "client_identification": "V27703129",
      "nap_box_name": "CTO-00167 DOS",
      "created_at": "2024-07-26T10:30:31.877310",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5659,
      "client_name": "ALICIA GARCIA VELASQUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144775122",
      "client_email": "ALICIAGAR085@GMAIL.COM",
      "address": "CALLE 11B CASA NRO 26 URB HACIENDA PANTIN",
      "client_identification": "V7218117",
      "nap_box_name": "CTO-00168",
      "created_at": "2024-07-26T10:31:56.463782",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5660,
      "client_name": "JOSE GREGORIO DE PONTE RUIZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128366322",
      "client_email": "jgdr75@gmail.com",
      "address": "CALLE 6 CASA NRO 376 URB MATA CABALLO ROSARIO DE PAYA",
      "client_identification": "V11093866",
      "nap_box_name": "CTO-00178",
      "created_at": "2024-07-26T10:33:19.566894",
      "service_detail": {
        "id": 5153,
        "ip": "172.21.222.2",
        "mac": "TPLGB68B514B",
        "serial": "TPLGB68B514B",
        "queue": "Plan_161893_30183_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-08-15T09:50:59.916412",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5661,
      "client_name": "MOISES DE JESUS MARQUINA VIDES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243825478",
      "client_email": "MMARQUINAV.60@GMAIL.COM",
      "address": "CTRA ROSARIO DE PAYA  CASA NRO 06 NRO 444 URB MATA CABALLO",
      "client_identification": "V7206559",
      "nap_box_name": "CTO-00063",
      "created_at": "2024-07-26T10:36:10.635376",
      "service_detail": {
        "id": 4513,
        "ip": "172.21.235.2",
        "mac": "TPLGB68B4E34",
        "serial": "TPLGB68B4E34",
        "queue": "Plan_161893_30183_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-08-10T18:31:19.346175",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5662,
      "client_name": "LEONEL ALEXANDER ASTUDILLO CORDERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144502244",
      "client_email": "LEONELALEXANDER93@GMAIL.COM",
      "address": "CALLE CARREÑO EDIFICIO CAYCAPE PISO 2 APTO NRO 1 URB LOS NISPEROS",
      "client_identification": "V21273649",
      "nap_box_name": "118",
      "created_at": "2024-07-26T10:36:54.363389",
      "service_detail": {
        "id": 4728,
        "ip": "172.19.190.2",
        "mac": "VSOL00128551",
        "serial": "VSOL00128551",
        "queue": "Plan_114480_15811_WispHub",
        "interface": "VLAN218_NISPEROS_OLT1",
        "created_at": "2024-08-12T13:43:46.289873",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5663,
      "client_name": "JAIR ALBERTO GAVIRIA JOYA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243366540",
      "client_email": "GAVIRIAJAIR95@GMAIL.COM",
      "address": "CALLE 6 CASA NRO 448 URB MATA CABALLO ROSARIO DE PAYA",
      "client_identification": "V25858214",
      "nap_box_name": "CTO-00063",
      "created_at": "2024-07-26T10:39:23.087590",
      "service_detail": {
        "id": 4514,
        "ip": "172.21.219.2",
        "mac": "TPLGB68B5155",
        "serial": "TPLGB68B5155",
        "queue": "Plan_161887_30183_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-08-10T18:35:21.338011",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5664,
      "client_name": "ALEXANDRA RAMONA GIL CASTILLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Guanarito",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04125387018",
      "client_email": "ALEXAGIL1685@GMAIL.COM",
      "address": "CALLE PEÑALVER CASA NRO 44 SECTOR GUANARITO TURMERO",
      "client_identification": "V16765029",
      "nap_box_name": "447",
      "created_at": "2024-07-26T10:44:44.119594",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5665,
      "client_name": "ANA KARINA TORRES LANZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Salto Angel",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04143844768",
      "client_email": "ANAKARINALANZ@GMAIL.COM",
      "address": "CALLE EL SAMAN CASA MANZANA 11 NRO 42 URB SALTO ANGEL TURMERO",
      "client_identification": "V16220546",
      "nap_box_name": "324",
      "created_at": "2024-07-26T10:48:52.700487",
      "service_detail": {
        "id": 4516,
        "ip": "172.21.191.2",
        "mac": "TPLGB68B5166",
        "serial": "TPLGB68B5166",
        "queue": "queue1",
        "interface": "VLAN121_S_ANGEL",
        "created_at": "2024-08-10T18:41:51.702929",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5666,
      "client_name": "JOSUE GABRIEL CORREA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04125874857",
      "client_email": "JCJOSUEPEREZ@GMAIL.COM",
      "address": "CALLE 16-A SECTOR 01 CASA NRO 28 URB HACIENDA PANTIN TURMERO",
      "client_identification": "V27520850",
      "nap_box_name": "CTO-00195",
      "created_at": "2024-07-26T10:49:03.735448",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5667,
      "client_name": "SCARLETH KATHERINE FUMERO HURTADO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "San Pablo",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243501109",
      "client_email": "FUMEROSCARLETH@GMAIL.COM",
      "address": "CALLE HICELE CASA NRO 08 URB SAN PABLO TURMERO",
      "client_identification": "V17974233",
      "nap_box_name": "26",
      "created_at": "2024-07-26T10:52:45.776675",
      "service_detail": {
        "id": 4520,
        "ip": "172.21.195.2",
        "mac": "TPLGB68B50F7",
        "serial": "TPLGB68B50F7",
        "queue": "Plan_92284_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-08-10T19:15:06.297546",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5668,
      "client_name": "CECILIA TRINIDAD LOPEZ AVILA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128903783",
      "client_email": "CECILOA62@GMAIL.COM",
      "address": "CALLE 17B CASA NRO 38 SECTOR PANTIN",
      "client_identification": "V7218473",
      "nap_box_name": "CTO-00048",
      "created_at": "2024-07-26T10:53:26.732439",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5669,
      "client_name": "YOHANCY TIBISAY ROSADO PERTUZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243307185",
      "client_email": "YOHAPINKY@GMAIL.COM",
      "address": "CALLE 16-B CASA NRO 38 URB PANTIN",
      "client_identification": "V20245788",
      "nap_box_name": "CTO-00026",
      "created_at": "2024-07-26T10:56:29.298602",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5670,
      "client_name": "SOLANGE ARMINDA MONTILLA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04120432245",
      "client_email": "MONTILLASOLANGE39@GMAIL.COM",
      "address": "CALLE 03-A CASA NRO 23 URB PANTIN",
      "client_identification": "V14627166",
      "nap_box_name": "CTO-00127 DOS",
      "created_at": "2024-07-26T11:00:15.301304",
      "service_detail": {
        "id": 11217,
        "ip": "172.18.68.2",
        "mac": "VSOL00521B49",
        "serial": "VSOL00521B49",
        "queue": null,
        "interface": "VLAN229_PANTIN",
        "created_at": "2026-01-17T17:46:36.256149",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5671,
      "client_name": "EGLEE MARIBELL FLORES DE MARTINEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Calle Peñalver",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04127767448",
      "client_email": "egleemaribellmartinezflores@GMAIL.COM",
      "address": "CALLE PEÑALVER CASA NRO 17 SECTOR GUANARITO TURMERO",
      "client_identification": "V8729843",
      "nap_box_name": "126",
      "created_at": "2024-07-26T11:02:30.340061",
      "service_detail": {
        "id": 4521,
        "ip": "172.21.163.2",
        "mac": "TPLGB68B50F0",
        "serial": "TPLGB68B50F0",
        "queue": "Plan_139897_15811_WispHub",
        "interface": "VLAN232_GUANARITO_OLT2",
        "created_at": "2024-08-10T21:28:09.015530",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5672,
      "client_name": "MARIA GABRIELA HIDALGO LIRA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04122071667",
      "client_email": "MARIAGABRIELAHIDALGOLIRA@GMAIL.COM",
      "address": "CALLE 9A CASA NRO 9 SECTOR ANTIGUA HACIENDA PANTIN",
      "client_identification": "V27425460",
      "nap_box_name": "CTO-00142",
      "created_at": "2024-07-26T11:02:56.448053",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5673,
      "client_name": "JHOSELINE MHITCHELL RONDON LOMELLI",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121457844",
      "client_email": "JHOSELINERONDON9@GMAIL.COM",
      "address": "CALLE 2B CASA NRO 47 SECTOR PANTIN",
      "client_identification": "V25066800",
      "nap_box_name": "CTO-00126",
      "created_at": "2024-07-26T11:07:56.603304",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5674,
      "client_name": "RICHAR EDUARDO RIVAS ESPINOZA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Isaac Oliveira",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04128920271",
      "client_email": "RICHARDCPV1127@GMAIL.COM",
      "address": "AV 3 MANZANA 6 CASA NRO 136CONJUNTO RESIDENCIAL ISAAC OLIVEIRA TURMERO",
      "client_identification": "V9654001",
      "nap_box_name": "CTO-00259",
      "created_at": "2024-07-26T11:57:09.936089",
      "service_detail": {
        "id": 11822,
        "ip": "172.21.161.2",
        "mac": "TPLGB68B5AA0",
        "serial": "TPLGB68B5AA0",
        "queue": null,
        "interface": "VLAN100_OLTs",
        "created_at": "2026-02-27T11:47:06.052048",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5675,
      "client_name": "GLENDA EMPERATRIZ NAVAS PIÑERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona II",
      "plan": {
        "id": 101,
        "name": "RECURRENTE RESIDENCIAL PLAN 200M",
        "cost": "19.00",
        "code": "FOR200MB",
        "profile": "200Mbps/200Mbps"
      },
      "client_mobile": "04144447637",
      "client_email": "GLENDANAVAS1610@GMAIL.COM",
      "address": "CALLE 13 CASA NRO 91 LA CASONA 2 TURMERO",
      "client_identification": "V4366428",
      "nap_box_name": "CTO-00091",
      "created_at": "2024-07-26T12:48:41.892734",
      "service_detail": {
        "id": 4525,
        "ip": "172.21.170.2",
        "mac": "TPLGB68B59C7",
        "serial": "TPLGB68B59C7",
        "queue": "Plan_131337_24341_WispHub",
        "interface": "VLAN110_CASONA_2",
        "created_at": "2024-08-10T23:03:05.828997",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5676,
      "client_name": "WILKER YONAYKER CARACAS  SAEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243449476",
      "client_email": "WILKERYONAIKER14@GMAIL.COM",
      "address": "AV 2 CASA NRO 516-D URB MATA CABALLO ROSARIO DE PAYA",
      "client_identification": "V30524418",
      "nap_box_name": "CTO-00457",
      "created_at": "2024-07-26T12:50:46.437954",
      "service_detail": {
        "id": 4526,
        "ip": "172.21.209.2",
        "mac": "TPLGB68B5725",
        "serial": "TPLGB68B5725",
        "queue": "Plan_161887_30183_WispHub",
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2024-08-10T23:06:23.432114",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5677,
      "client_name": "JOTHSDEISY NICOR NARANJO GONZALEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243218335",
      "client_email": "NG532493@GMAIL.COM",
      "address": "AV 2 CASA NRO 524-C SECTOR MATA CABALLO ROSARIO DE PAYA",
      "client_identification": "V30026356",
      "nap_box_name": "CTO-00222",
      "created_at": "2024-07-26T13:18:46.306317",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5678,
      "client_name": "EDUARDO JOSE OCHOA MOYETON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121457844",
      "client_email": "EDUARDOOCHOA970@GMAIL.COM",
      "address": "CALLE 3B CASA NRO 42 URB PANTIN",
      "client_identification": "V25620936",
      "nap_box_name": "CE-00043",
      "created_at": "2024-07-26T13:19:40.598348",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5679,
      "client_name": "MARBELIS JACQUELIN VELIZ  TESORERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04264475925",
      "client_email": "JORGELISJIMENEZVELIZ@GMAIL.COM",
      "address": "CALLE 4 CASA NRO 236 URB MATA CABALLO",
      "client_identification": "V17790681",
      "nap_box_name": "CTO-00265",
      "created_at": "2024-07-26T13:21:37.750178",
      "service_detail": {
        "id": 4540,
        "ip": "172.21.199.2",
        "mac": "TPLGB68B4EFE",
        "serial": "TPLGB68B4EFE",
        "queue": "Plan_161887_30183_WispHub",
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2024-08-11T12:52:20.987138",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5680,
      "client_name": "JOSE EMIRO OLIVO CHACON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04142747478",
      "client_email": "TECNISERVICIOS1402@GMAIL.COM",
      "address": "CALLE 11 CASA NRO 654-B SECTOR MATA CABALLO  ROSARIO DE PAYA",
      "client_identification": "V15990176",
      "nap_box_name": "CTO-00213",
      "created_at": "2024-07-26T13:24:51.301443",
      "service_detail": {
        "id": 11692,
        "ip": "172.21.168.2",
        "mac": "TPLGBA687A8D",
        "serial": "TPLGBA687A8D",
        "queue": null,
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2026-02-20T14:26:47.058350",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5681,
      "client_name": "MARCO JAVIER GUERRERO DIAZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243649731",
      "client_email": "MARCO.JGD@GMAIL.COM",
      "address": "CALLE 5B CASA NRO 48 URB HACIENDA PANTIN",
      "client_identification": "V19594930",
      "nap_box_name": "CTO-00136",
      "created_at": "2024-07-26T13:29:24.019539",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5682,
      "client_name": "MARIBEL SANCHEZ DE BOLIVAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243617143",
      "client_email": "MARIBELSANCHEZJB41@GMAIL.COM",
      "address": "CALLE 14B CASA NRO 51 URB PANTIN ROSARIO DE PAYA",
      "client_identification": "V10751083",
      "nap_box_name": "CTO-00052",
      "created_at": "2024-07-26T13:35:03.763130",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5683,
      "client_name": "MARIA DEL VALLE ALVAREZ SUAREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243240384",
      "client_email": "MARIAALVAREZ.150165@GMAIL.COM",
      "address": "AV 1 CASA NRO 687-B SECTOR MATA CABALLO ROSARIO DE PAYA",
      "client_identification": "V9655943",
      "nap_box_name": "CTO-00210",
      "created_at": "2024-07-26T13:36:36.335173",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5684,
      "client_name": "ALIMENTOS INTERNACIONALES SM Y SL",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "San Pablo",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04243649599",
      "client_email": "JUAN.GARCIA@ALIMENTOSVE.COM",
      "address": "AVENIDA INDUSTRIAL SUR 8 ENTRANDO POR CALLE RIVAS ZONA INDUSTRIAL SAN PABLO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "J001306935",
      "nap_box_name": "56",
      "created_at": "2024-07-26T13:41:16.614521",
      "service_detail": {
        "id": 4111,
        "ip": "172.28.9.2",
        "mac": "TPLGF9CD3E67",
        "serial": "TPLGF9CD3E67",
        "queue": "Plan_161877_15811_WispHub",
        "interface": "VLAN224_SAN_PABLO_OLT1",
        "created_at": "2024-07-26T16:28:07.593875",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5685,
      "client_name": "EDGAR JOSE FLORES MENDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243225156",
      "client_email": "EDGAREF1404@GMAIL.COM",
      "address": "AV 2 CASA NRO 481 URB MATA CABALLO ROSARIO DE PAYA",
      "client_identification": "V17801722",
      "nap_box_name": "CTO-00222",
      "created_at": "2024-07-26T13:42:06.918899",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5686,
      "client_name": "YITCY SUGEY RODRIGUEZ OSORIO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 16,
        "name": "RECURRENTE RESIDENCIAL PLAN 800M",
        "cost": "55.00",
        "code": "FOR800",
        "profile": "800M/800M"
      },
      "client_mobile": "04243020276",
      "client_email": "YITCYRODRIGUEZ1709@GMAIL.COM",
      "address": "CALLE 9 CASA NRO 587-B  URB MATA CABALLO  ROSARIO DE PAYA",
      "client_identification": "V14959974",
      "nap_box_name": "CE - 566",
      "created_at": "2024-07-26T13:58:03.301300",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5687,
      "client_name": "PEDRO PABLO RODRIGUEZ MATOS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Durpa",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243312719",
      "client_email": "LUISRMXP@GMAIL.COM",
      "address": "CALLE PPL MANZANA 22 CASA NRO 14 SECTOR DURPA",
      "client_identification": "V9699137",
      "nap_box_name": "CTO-00320",
      "created_at": "2024-07-26T13:58:28.700468",
      "service_detail": {
        "id": 11749,
        "ip": "172.18.67.2",
        "mac": "VSOL0051FDB1",
        "serial": "VSOL0051FDB1",
        "queue": null,
        "interface": "VLAN240_DURPA",
        "created_at": "2026-02-26T08:44:18.624691",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5688,
      "client_name": "VALERIA STEFANIA CORZO RIVERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Durpa",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121486987",
      "client_email": "CORZOVALERIA80@GMAIL.COM",
      "address": "CALLE LEALTAD MANZANA 22 CASA NRO 02 URB DESARROLLO URBANISTICO ROSARIO DE PAYA",
      "client_identification": "V27646717",
      "nap_box_name": "CTO-00320",
      "created_at": "2024-07-26T14:01:44.252752",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5689,
      "client_name": "JOSE JOSE CASTILLO BARRIOS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144618540",
      "client_email": "JCJJCASTILLOB@GMAIL.COM",
      "address": "CALLE P EDIF 5961 APT 596-D MATA CABALLO TURMERO",
      "client_identification": "V14061596",
      "nap_box_name": "160",
      "created_at": "2024-07-26T14:02:59.214323",
      "service_detail": {
        "id": 10115,
        "ip": "172.21.171.2",
        "mac": "TPLGB68B5AA3",
        "serial": "TPLGB68B5AA3",
        "queue": null,
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2025-11-13T17:52:15.208031",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5690,
      "client_name": "AUXILIADORA SANCHEZ DE VARGAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Durpa",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243075006",
      "client_email": "AUXILIADORASANCHEZ298@GMAIL.COM",
      "address": "CALLE LAS COLINAS MANZANA 18 CASA NRO 22 SECTOR DESARROLLO URBANISTICO",
      "client_identification": "V8681710",
      "nap_box_name": "352",
      "created_at": "2024-07-26T14:03:37.812039",
      "service_detail": {
        "id": 4795,
        "ip": "172.18.71.2",
        "mac": "VSOL0048D7A9",
        "serial": "VSOL0048D7A9",
        "queue": "Plan_161872_30181_WispHub",
        "interface": "VLAN240_DURPA",
        "created_at": "2024-08-12T16:26:54.924504",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5691,
      "client_name": "EGLEE YAMILETH OLIVO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Durpa",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04164433247",
      "client_email": "EGLEEOLIVO2011@GMAIL.COM",
      "address": "CALLE MANZANA 21 CALLE ESPERANZA CASA NRO 9 URB DESARROLLO URBANISTICO ROSARIO DE PAYA TURMERO",
      "client_identification": "V13954219",
      "nap_box_name": "CTO-00320",
      "created_at": "2024-07-26T14:12:54.185859",
      "service_detail": {
        "id": 4807,
        "ip": "172.19.37.2",
        "mac": "VSOL00521C89",
        "serial": "VSOL00521C89",
        "queue": "queue1",
        "interface": "VLAN240_DURPA",
        "created_at": "2024-08-12T16:54:25.255821",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5692,
      "client_name": "LEORYINA DYSMAR COLMENARES HIDALGO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04127768474",
      "client_email": "LEORYINACOLMENARES@GMAIL.COM",
      "address": "CALLE 9 CASA NRO 593 D URB MATA CABALLO TURMERO",
      "client_identification": "V27262871",
      "nap_box_name": "160",
      "created_at": "2024-07-26T14:20:31.963888",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5693,
      "client_name": "YHORGEISETH CAROLINA CARRASQUEL ROJA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04143463410",
      "client_email": "YHORGELINA@GMAIL.COM",
      "address": "CALLE 4 CASA NRO 252 SECTOR MATA CABALLO ROSARIO DE PAYA",
      "client_identification": "V26535057",
      "nap_box_name": "CTO-00265",
      "created_at": "2024-07-26T14:29:13.494261",
      "service_detail": {
        "id": 9961,
        "ip": "172.21.200.2",
        "mac": "TPLGB68B4E1F",
        "serial": "TPLGB68B4E1F",
        "queue": null,
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2025-11-11T11:12:23.853936",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5694,
      "client_name": "CARMEN LUCIA MONTILVA MORENO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Durpa",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04120395172",
      "client_email": "CARMENMONTILVA1211@GMAIL.COM",
      "address": "MANZANA 20 CASA NRO 22 SECTOR DESARROLLO URBANISTICO DURPA",
      "client_identification": "V11091956",
      "nap_box_name": "376",
      "created_at": "2024-07-26T14:29:49.183553",
      "service_detail": {
        "id": 6099,
        "ip": "172.17.212.2",
        "mac": "VSOL0047D259",
        "serial": "VSOL0047D259",
        "queue": "Plan_161905_30183_WispHub",
        "interface": "VLAN240_DURPA",
        "created_at": "2024-08-22T14:59:17.795622",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5696,
      "client_name": "YULEYDIS MARIBEL LARA FERNANDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243325003",
      "client_email": "DOCENTEYULEYDIS@GMAIL.COM",
      "address": "CALLE MANZANA I-6 CASA NRO 20 URB SAMAN TARAZONERO II TURMERO",
      "client_identification": "V9664686",
      "nap_box_name": "504",
      "created_at": "2024-07-26T14:32:08.680934",
      "service_detail": {
        "id": 4548,
        "ip": "172.21.179.2",
        "mac": "TPLGB68B5A96",
        "serial": "TPLGB68B5A96",
        "queue": "Plan_92223_1574_WispHub",
        "interface": "VLAN100_OLTs",
        "created_at": "2024-08-11T13:17:22.976960",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5697,
      "client_name": "ANA CAROLINA RODAS BERRO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Durpa",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124609253",
      "client_email": "ANA_RODAS95@HOTMAIL.COM",
      "address": "CALLE LA ESPERANZA CASA NRO 8 URB DURPA ROSARIO DE PAYA",
      "client_identification": "V25620156",
      "nap_box_name": "376",
      "created_at": "2024-07-26T14:33:18.619113",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5698,
      "client_name": "JAVIER JOSE CABRERA SUMOZA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Antonio Jose de Sucre",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04140390307",
      "client_email": "JAVIERCABRERA158@GMAIL.COM",
      "address": "CALLE AV PRINCIPAL CASA NRO 62 URB ANTONIO JOSE DE SUCRE TURMERO",
      "client_identification": "V28482835",
      "nap_box_name": "122",
      "created_at": "2024-07-26T14:34:27.938457",
      "service_detail": {
        "id": 9256,
        "ip": "172.21.149.2",
        "mac": "TPLGB68B5627",
        "serial": "TPLGB68B5627",
        "queue": "queue1",
        "interface": "VLAN101_AJS",
        "created_at": "2025-07-25T08:40:45.694535",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5699,
      "client_name": "ROSA ALEJANDRA ARRAIZ OSORIO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Durpa",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243591981",
      "client_email": "ELSAROSORIO@GMAIL.COM",
      "address": "CALLE LEALTAD CASA NRO 09 SECTOR FUNDA BARRIO",
      "client_identification": "V13454335",
      "nap_box_name": "CTO-00320",
      "created_at": "2024-07-26T14:34:41.987528",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5700,
      "client_name": "LILIAM MISTALIA RIVERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Durpa",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04127321091",
      "client_email": "RIVEROLILIAN051@GMAIL.COM",
      "address": "CALLE 22 CASA NRO 06 SECTOR DURPA",
      "client_identification": "V9873415",
      "nap_box_name": "CTO-00320",
      "created_at": "2024-07-26T14:36:41.843587",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5701,
      "client_name": "KARELIS ANDREINA IZQUIERDO PACHECO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Antonio Jose de Sucre",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121589459",
      "client_email": "KARE.JOSE2@GMAIL.COM",
      "address": "CALLE 25 DE AGOSTO CASA NRO 53 SECTOR ANTONIO JOSE DE SUCRE TURMERO",
      "client_identification": "V17578712",
      "nap_box_name": "122",
      "created_at": "2024-07-26T14:38:05.419728",
      "service_detail": {
        "id": 4549,
        "ip": "172.21.183.2",
        "mac": "TPLGB68B50F5",
        "serial": "TPLGB68B50F5",
        "queue": "Plan_107915_1574_WispHub",
        "interface": "VLAN101_AJS",
        "created_at": "2024-08-11T13:25:59.983673",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5702,
      "client_name": "ADONAIS ANTONIO CHACON HERNANDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Durpa",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128704212",
      "client_email": "ADONAISANTONIOCHACONHERMANDEZ@GMAIL.COM",
      "address": "1era transversal los MANGOS #27",
      "client_identification": "V16692596",
      "nap_box_name": "390",
      "created_at": "2024-07-26T14:38:28.047093",
      "service_detail": {
        "id": 12852,
        "ip": "172.17.210.2",
        "mac": "QX:TL:CB:89:3A:57",
        "serial": "QXTLCB893A57",
        "queue": null,
        "interface": "VLAN267_LOS_MANGOS_ZTE",
        "created_at": "2026-08-15T20:10:24.143213",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5703,
      "client_name": "NELCY COROMOTO AGUIRRE GONZALEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Durpa",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04120347503",
      "client_email": "NELSY13024@GMAIL.COM",
      "address": "CALLE ESPERANZA MANZANA 20 CASA NRO 13 SECTOR DESARROLLO URBANISTICO",
      "client_identification": "V13270010",
      "nap_box_name": "376",
      "created_at": "2024-07-26T14:40:32.737435",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5704,
      "client_name": "GERMAN ALONSO CARDONA CASTANO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243364736",
      "client_email": "ESTRADACAROLAY93@GMAIL.COM",
      "address": "CTRA MANZANA  B5 CASA NRO 8 URB SAMAN  TARAZONERO II TURMERO",
      "client_identification": "V10192477",
      "nap_box_name": "128",
      "created_at": "2024-07-26T14:40:38.040125",
      "service_detail": {
        "id": 9809,
        "ip": "172.21.150.2",
        "mac": "TPLGB68B56ED",
        "serial": "TPLGB68B56ED",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2025-11-10T16:15:07.209719",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5705,
      "client_name": "FRANCELIS YELITZA HERNANDEZ LOPEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Durpa",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144442652",
      "client_email": "FRANCELIS53YT@GMAIL.COM",
      "address": "CALLE LA COLINA MANZANA 19 CASA NRO 04 SECTOR DESARROLLO URBANISTICO DURPA",
      "client_identification": "V15180791",
      "nap_box_name": "352",
      "created_at": "2024-07-26T14:42:59.354815",
      "service_detail": {
        "id": 4886,
        "ip": "172.17.215.2",
        "mac": "VSOL004987A1",
        "serial": "VSOL004987A1",
        "queue": "Plan_161891_30183_WispHub",
        "interface": "VLAN240_DURPA",
        "created_at": "2024-08-13T08:44:16.200793",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5706,
      "client_name": "ANTONIO JOSE SOLORZANO ESCALONA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121437241",
      "client_email": "YELVIMARCAMPOS8@GMAIL.COM",
      "address": "AV MANZANA C-6 CASA NRO 10 BARRIO SAMAN TARAZONERO II TURMERO",
      "client_identification": "V20693580",
      "nap_box_name": "263",
      "created_at": "2024-07-26T14:49:20.456817",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5707,
      "client_name": "EGLEE REGINA PLAZA GARCIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04142962516",
      "client_email": "ERPG.19@GMAIL.COM",
      "address": "VDA 03 CASA MANZANA E NRO 13 URB SAMAN TARAZONERO II",
      "client_identification": "V16551097",
      "nap_box_name": "161 DOS",
      "created_at": "2024-07-26T14:55:33.642117",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5708,
      "client_name": "EDWIS ANTONIO CASTELLANO SUAREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Durpa",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124059662",
      "client_email": "TRUETON2000@HOTMAIL.COM",
      "address": "CALLE LAS COLINAS MANZANA 18 CASA 18 DURPA",
      "client_identification": "V6841859",
      "nap_box_name": "352",
      "created_at": "2024-07-26T15:11:58.674186",
      "service_detail": {
        "id": 6093,
        "ip": "172.21.33.2",
        "mac": "VSOL0011E9C9",
        "serial": "VSOL0011E9C9",
        "queue": "Plan_161905_30183_WispHub",
        "interface": "VLAN240_DURPA",
        "created_at": "2024-08-22T14:38:38.899647",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5709,
      "client_name": "KATIUSKA JOSEFINA PINERO ORTEGA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Durpa",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124367617",
      "client_email": "KATIUSKAP678@GMAIL.COM",
      "address": "CALLE LA COLINA MANZANA 18 CASA NRO 21 SECTOR DESARROLLO URBANISTICO DURPA",
      "client_identification": "V11181747",
      "nap_box_name": "352",
      "created_at": "2024-07-26T15:16:58.109856",
      "service_detail": {
        "id": 4916,
        "ip": "172.17.208.2",
        "mac": "VSOL00127A39",
        "serial": "VSOL00127A39",
        "queue": "Plan_161865_30181_WispHub",
        "interface": "VLAN240_DURPA",
        "created_at": "2024-08-13T11:14:16.239389",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5710,
      "client_name": "JOHANA JOSE VILLAZANA GONZALEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Floresta",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04144543361",
      "client_email": "VILLAJOH_23@HOTMAIL.COM",
      "address": "CALLE 1 CASA NRO D-10 URB LA FLORESTA TURMERO",
      "client_identification": "V14039722",
      "nap_box_name": "34 DOS",
      "created_at": "2024-07-26T15:20:39.989837",
      "service_detail": {
        "id": 4553,
        "ip": "172.21.152.2",
        "mac": "TPLGB68B4F54",
        "serial": "TPLGB68B4F54",
        "queue": "Plan_92291_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-08-11T13:39:16.662151",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5711,
      "client_name": "ADA MABEL CASTELLANOS DE IBANEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Durpa",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144696019",
      "client_email": "FABIOLA1YEPEZ@GMAIL.COM",
      "address": "CALLE LA COLINA MANZANA 18 CASA NRO 17 SECTOR DESARROLLO URBANISTICO ROSARIO DE PAYA",
      "client_identification": "V6841852",
      "nap_box_name": "352",
      "created_at": "2024-07-26T15:23:23.942786",
      "service_detail": {
        "id": 4918,
        "ip": "172.20.125.2",
        "mac": "VSOL001288C1",
        "serial": "VSOL001288C1",
        "queue": "Plan_161892_30183_WispHub",
        "interface": "VLAN240_DURPA",
        "created_at": "2024-08-13T11:20:27.932066",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5712,
      "client_name": "NEIVIS DEL VALLE RONDON BRICEÑO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "SUSPENDIDO_RESIDENCIAL",
      "status_name": "Suspendido",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144586828",
      "client_email": "NEIVISRONDON@GMAIL.COM",
      "address": "CALLE PPL MANZANA E-3 CASA NRO 7 URB SAMAN TARAZONERO II TURMERO",
      "client_identification": "V12905001",
      "nap_box_name": "161 DOS",
      "created_at": "2024-07-26T15:24:03.894668",
      "service_detail": {
        "id": 4554,
        "ip": "172.21.145.2",
        "mac": "TPLGB68B56A0",
        "serial": "TPLGB68B56A0",
        "queue": "Plan_107915_1574_WispHub",
        "interface": "VLAN100_OLTs",
        "created_at": "2024-08-11T13:42:00.676974",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5713,
      "client_name": "YOHAN JOSE ROJAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04265305170",
      "client_email": "CONCEJALYOHANROJAS@GMAIL.COM",
      "address": "AV AVENIDA 2 CASA NRO 506 URB MATA CABALLO  ROSARIO DE PAYA",
      "client_identification": "V14741485",
      "nap_box_name": "CTO-00238",
      "created_at": "2024-07-26T15:30:09.609548",
      "service_detail": {
        "id": 4555,
        "ip": "172.21.202.2",
        "mac": "TPLGB68B560D",
        "serial": "TPLGB68B560D",
        "queue": "Plan_161860_30181_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-08-11T13:46:21.035727",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5714,
      "client_name": "GLADYS MAURA ZAMBRANO GONZALEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243191849",
      "client_email": "ZAMBRANOGLADYS269@GMAIL.COM",
      "address": "AV 2 CASA 495 URB MATA CABALLOS ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V4229463",
      "nap_box_name": "CTO-00567 DOS",
      "created_at": "2024-07-26T15:34:53.884017",
      "service_detail": {
        "id": 4556,
        "ip": "172.21.169.2",
        "mac": "TPLGB68B549F",
        "serial": "TPLGB68B549F",
        "queue": "queue1",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-08-11T13:49:41.257151",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5715,
      "client_name": "EIDA LUISA MALDONADO PABON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243313000",
      "client_email": "EIDALUISAM@GMAIL.COM",
      "address": "CALLE MANZANA D-4 CASA NRO 4 SECTOR EL MACARO TURMERO",
      "client_identification": "V11503302",
      "nap_box_name": "163",
      "created_at": "2024-07-26T15:37:52.860423",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5717,
      "client_name": "MARLLELI CATIUSCA VALLENILLA GONZALEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243594029",
      "client_email": "CATIUSCAVALLENILLA@GMAIL.COM",
      "address": "CALLE PRINCIPAL CASA NRO 34 SECTOR PRADOS I",
      "client_identification": "V19276515",
      "nap_box_name": "CTO-00304",
      "created_at": "2024-07-26T15:39:06.740358",
      "service_detail": {
        "id": 6088,
        "ip": "172.17.92.2",
        "mac": "VSOL0051E651",
        "serial": "VSOL0051E651",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN239_PRADOS1",
        "created_at": "2024-08-22T14:17:47.645510",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5718,
      "client_name": "LEONARDO JOSE RODRIGUEZ TOVAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144660748",
      "client_email": "LEONARDORODRIGUEZ308@GMAIL.COM",
      "address": "CALLE 4 CASA NRO 195 SECTOR MATA CABALLO ROSARIO DE PAYA",
      "client_identification": "V20057584",
      "nap_box_name": "CTO-00422",
      "created_at": "2024-07-26T15:40:04.250900",
      "service_detail": {
        "id": 4575,
        "ip": "172.21.187.2",
        "mac": "TPLGB68B56F1",
        "serial": "TPLGB68B56F1",
        "queue": "queue1",
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2024-08-11T17:00:36.321818",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5719,
      "client_name": "ANDREA ELISA PALMA ABRAHAM",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Paya Abajo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243472621",
      "client_email": "ANDREAELISAPALMA5@GMAIL.COM",
      "address": "AV PRINCIPAL PAYA CASA NRO 19 SECTOR PAYA ABAJO",
      "client_identification": "V25620931",
      "nap_box_name": "406",
      "created_at": "2024-07-26T15:40:47.663438",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5720,
      "client_name": "RICHAR JOSE REAL",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128708329",
      "client_email": "RICHARREAL@GMAIL.COM",
      "address": "AV 1 CASA NRO 35 SECTOR PRADOS 1",
      "client_identification": "V16789305",
      "nap_box_name": "CTO-00304",
      "created_at": "2024-07-26T15:42:45.046621",
      "service_detail": {
        "id": 4951,
        "ip": "172.18.75.2",
        "mac": "VSOL0051E4B9",
        "serial": "VSOL0051E4B9",
        "queue": "Plan_161891_30183_WispHub",
        "interface": "VLAN239_PRADOS1",
        "created_at": "2024-08-13T15:03:29.566615",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5722,
      "client_name": "YAJAIRA DEL CARMEN QUEVEDO DE CHACON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados I",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128863205",
      "client_email": "RISITA.BELLA@HOTMAIL.COM",
      "address": "AV 1 PRINCIPAL CASA NRO 40 SCTORT PRADO DE PAYA 1 ROSARIO DE PAYA",
      "client_identification": "V12939633",
      "nap_box_name": "CTO-00304",
      "created_at": "2024-07-26T15:44:27.705450",
      "service_detail": {
        "id": 5260,
        "ip": "172.18.2.2",
        "mac": "VSOL00498629",
        "serial": "VSOL00498629",
        "queue": "queue1",
        "interface": "VLAN239_PRADOS1",
        "created_at": "2024-08-15T16:38:46.004494",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5723,
      "client_name": "MARYURI DEL VALLE RIVERO FAGUNDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243831769",
      "client_email": "MARYURIRIVERO341@GMAIL.COM",
      "address": "CALLE 6 CASA NRO 392 URB MATA CABALLO  ROSARIO DE PAYA",
      "client_identification": "V27520152",
      "nap_box_name": "CTO-00063",
      "created_at": "2024-07-26T15:44:32.777036",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5724,
      "client_name": "IVAN RAMIREZ RUJANO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04144431896",
      "client_email": "IVANRAMIREZRUJANO79@GMAIL.COM",
      "address": "CALLE 4 CASA NRO 243 URB MATA  CABALLO",
      "client_identification": "V14183136",
      "nap_box_name": "CTO-00265",
      "created_at": "2024-07-26T15:45:59.652393",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5725,
      "client_name": "JOSE MANUEL DE GOUVEIA JARDIN",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Vista Hermosa",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124673409",
      "client_email": "TIBYMENDOZA1@GMAIL.COM",
      "address": "CALLE ROSARIO CRUCE CON HACIENDA CASA NRO 44 SECTOR VISTA HERMOSA ROSARIO DE PAYA",
      "client_identification": "V7273456",
      "nap_box_name": "CTO-00058",
      "created_at": "2024-07-26T15:46:08.437286",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5726,
      "client_name": "MARIA FERNANDA PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados I",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243663845",
      "client_email": "MP285449@GMAIL.COM",
      "address": "CALLE 11, CASA NRO. 24 SECTOR PRADO I, ROSARIO DE PAYA, ARAGUA.",
      "client_identification": "V17936855",
      "nap_box_name": "CTO-00204 DOS",
      "created_at": "2024-07-26T16:13:06.253723",
      "service_detail": {
        "id": 4165,
        "ip": "172.31.25.2",
        "mac": "OEMT3C6231FE",
        "serial": "OEMT3C6231FE",
        "queue": "Plan_161905_30183_WispHub",
        "interface": "VLAN239_PRADOS1",
        "created_at": "2024-08-02T10:17:12.335846",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5727,
      "client_name": "FRANCIA COROMOTO ACOSTA PEÑA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128909268",
      "client_email": "CINDYPEREZSANT@GMAIL.COM",
      "address": "CALLE PRINCIPAL CASA NRO 38 SECTOR PRADOS I",
      "client_identification": "V10976878",
      "nap_box_name": "CTO-00304",
      "created_at": "2024-07-26T16:34:45.030773",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5728,
      "client_name": "ARIANA ALEXANDRA MATAMOROS DIAZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villas El Carmen",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121330453",
      "client_email": "ARIANA.ALEXANDRA.MATAMOROS.DIAZ@GMAIL.COM",
      "address": "CTRA EL MACARO CALLE 8 CASA NRO 16 URB VILLAS EL  CARMEN  TURMERO ARAGUA",
      "client_identification": "V20757228",
      "nap_box_name": "41",
      "created_at": "2024-07-26T16:37:12.423841",
      "service_detail": {
        "id": 4117,
        "ip": "172.17.19.2",
        "mac": "TPLGB954FAF9",
        "serial": "TPLGB954FAF9",
        "queue": "Plan_137413_1574_WispHub",
        "interface": "VLAN135_VILLAS_CARMEN",
        "created_at": "2024-07-26T22:04:05.093572",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5729,
      "client_name": "AURELIS VALENTINA PEDREANEZ MENDOZA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128369320",
      "client_email": "AURELISVALENPED@GMAIL.COM",
      "address": "VDA MANZANA  E-6 CASA NRO 12 URB SAMAN  TARAZONERO II TURMERO",
      "client_identification": "V19112553",
      "nap_box_name": "95",
      "created_at": "2024-07-26T16:59:32.590436",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5730,
      "client_name": "JOHANA ISABEL ARIAS HERRERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04127193579",
      "client_email": "JOHANAARIAS037@GMAIL.COM",
      "address": "SAMAN TARAZONERO 2 MANZANA D15 CASA 12 TURMERO ARAGUA",
      "client_identification": "V15733703",
      "nap_box_name": "278",
      "created_at": "2024-07-26T17:10:38.506595",
      "service_detail": {
        "id": 4805,
        "ip": "172.27.64.2",
        "mac": "GPON0097F606",
        "serial": "GPON0097F606",
        "queue": "queue1",
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2024-08-12T16:51:09.608868",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5731,
      "client_name": "VICMAR DEL CARMEN SILVA ALVAREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "SUSPENDIDO_RESIDENCIAL",
      "status_name": "Suspendido",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04128902537",
      "client_email": "VICMARSILVA@GMAIL.COM",
      "address": "CALLE MANZANA D16 CASA NRO 09 URB SAMAN TARAZONERO II TURMERO EDO ARAGUA",
      "client_identification": "V16074279",
      "nap_box_name": "278",
      "created_at": "2024-07-26T17:21:32.040985",
      "service_detail": {
        "id": 12340,
        "ip": "172.27.39.2",
        "mac": "GPON0097B1B6",
        "serial": "GPON0097B1B6",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2026-04-16T21:06:14.525297",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5732,
      "client_name": "YDELMAN JOSE CAMACHO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04122348863",
      "client_email": "CARIKTURAS67@GMAIL.COM",
      "address": "CALLE MANZANA J3 CASA N3 CASERIO SAMAN TARAZONERO II SECTOR EL MACARO TURMERO ARAGUA",
      "client_identification": "V8474629",
      "nap_box_name": "278",
      "created_at": "2024-07-26T17:24:12.822011",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5733,
      "client_name": "HUGO ALEJANDRO FLORES MATOS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04167397912",
      "client_email": "MATOSFLORES1971@GMAIL.COM",
      "address": "CALLE 4 MANZANA E CASA N 0107 URB SAMAN TARAZONERO II TURMERO ARAGUA",
      "client_identification": "V9680755",
      "nap_box_name": "268",
      "created_at": "2024-07-26T17:26:19.851724",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5735,
      "client_name": "CARMEN ROSA BLANCO ANDRADE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124577938",
      "client_email": "CARMENBLANCO0809@GMAIL.COM",
      "address": "VDA MANZANA E1 CASA 09 ZONA SAMAN TARAZONERO TURMERO ARAGUA",
      "client_identification": "V9677824",
      "nap_box_name": "268",
      "created_at": "2024-07-26T17:30:59.077392",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5737,
      "client_name": "BIANCA MARIANGELY GOMEZ BECERRA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243254159",
      "client_email": "BIANCA301083@GMAIL.COM",
      "address": "VDA MD8CASA 21 URB SAMAN TRAZONERO II TURMERO ARAGUA",
      "client_identification": "V16691608",
      "nap_box_name": "266",
      "created_at": "2024-07-26T17:37:08.787243",
      "service_detail": {
        "id": 4826,
        "ip": "172.27.22.2",
        "mac": "GPON0097BC36",
        "serial": "GPON0097BC36",
        "queue": "Plan_107915_1574_WispHub",
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2024-08-12T17:26:58.898168",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5738,
      "client_name": "JESSIKA GERALDINE LA CRUZ ESCALANTE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243094124",
      "client_email": "JESSIKALACRUZ14@GMAIL.COM",
      "address": "CALLE MANZANA D11 N12 URB SAMAN TARAZONERO 2 TURMERO ARAGUA",
      "client_identification": "V18884538",
      "nap_box_name": "264",
      "created_at": "2024-07-26T17:39:16.290190",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5739,
      "client_name": "JHAN CARLOS MENDEZ CABALLERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Naranjal",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04149351927",
      "client_email": "JHAN.MENDEZ@EMPRESASPOLAR.COM",
      "address": "CALLE 3 CASA NRO 2-D EL NARANJAL ROSARIO DE PAYA",
      "client_identification": "V16123228",
      "nap_box_name": "CTO-00303",
      "created_at": "2024-07-26T17:42:38.459022",
      "service_detail": {
        "id": 11322,
        "ip": "172.23.68.2",
        "mac": "TPLGBA687C80",
        "serial": "TPLGBA687C80",
        "queue": null,
        "interface": "VLAN230_VISTA_HERMOSA",
        "created_at": "2026-01-22T16:05:36.270920",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5740,
      "client_name": "YANISKA DEL VALLE GARCIA MILLAN",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04243218472",
      "client_email": "JCDD14@GMAIL.COM",
      "address": "CALLE BERMUDEZ EDIF TORRE APOLO PISO 7 APT 72 SECTOR CENTRO TURMERO",
      "client_identification": "V18609275",
      "nap_box_name": "CTO-0517",
      "created_at": "2024-07-26T17:45:32.571117",
      "service_detail": {
        "id": 4828,
        "ip": "172.23.59.2",
        "mac": "TPLGBA687BE8",
        "serial": "TPLGBA687BE8",
        "queue": "Plan_89281_15811_WispHub",
        "interface": "VLAN260_BETANIA",
        "created_at": "2024-08-12T17:31:32.559543",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5741,
      "client_name": "GUSTAVO ADOLFO GUZMAN ANGULO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04125986689",
      "client_email": "YOSELIN0606@HOTMAIL.COM",
      "address": "CALLE BERMUDEZ EDIF TORRE APOLO PISO 2 APT 24 TURMERO",
      "client_identification": "V25066552",
      "nap_box_name": "CTO-0517",
      "created_at": "2024-07-26T17:47:07.091932",
      "service_detail": {
        "id": 4829,
        "ip": "172.23.48.2",
        "mac": "TPLGBA687C56",
        "serial": "TPLGBA687C56",
        "queue": "Plan_112654_15811_WispHub",
        "interface": "VLAN260_BETANIA",
        "created_at": "2024-08-12T17:33:55.259708",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5742,
      "client_name": "AYARIS MILAGROS OROPEZA LAYA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Naranjal",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128925114",
      "client_email": "AYARISTEXTIL@GMAIL.COM",
      "address": "CALLE LOS LIRIOS CASA Nº 20 SECTOR EL NARANJAL ROSARIO DE PAYA  ARAGUA ZONA POSTAL 2115",
      "client_identification": "V14086552",
      "nap_box_name": "CTO - 97",
      "created_at": "2024-07-27T10:13:55.081720",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5743,
      "client_name": "JENNIFER CAROLINA TRASOLINI",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Concepcion",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243431985",
      "client_email": "TRASOLINIJENNIFER@GMAIL.COM",
      "address": "CALLE 2 CASA NRO 27 URB LA CONCEPCIONTURMERO",
      "client_identification": "V15130660",
      "nap_box_name": "109",
      "created_at": "2024-07-29T09:44:07.827444",
      "service_detail": {
        "id": 5378,
        "ip": "172.20.90.2",
        "mac": "TPLGB954FA9C",
        "serial": "TPLGB954FA9C",
        "queue": "Plan_132787_24341_WispHub",
        "interface": "VLAN100_OLTs",
        "created_at": "2024-08-16T12:02:42.829582",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5744,
      "client_name": "HEIBEL JOSE CENTENO PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Salto Angel",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04125556702",
      "client_email": "HEIBELCENTENO.08.06@GMAIL.COM",
      "address": "CALLE LOS PINOS CASA NRO 42 SALTO ANGEL MANZANA 4",
      "client_identification": "V27240435",
      "nap_box_name": "256",
      "created_at": "2024-07-29T09:50:20.036769",
      "service_detail": {
        "id": 5377,
        "ip": "172.19.249.2",
        "mac": "TPLGF5CB075F",
        "serial": "TPLGF5CB075F",
        "queue": "Plan_131647_24341_WispHub",
        "interface": "VLAN100_OLTs",
        "created_at": "2024-08-16T12:00:28.538076",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5745,
      "client_name": "MANUEL EDUARDO PEREIRA ACOSTA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "La Concepcion",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04128994546",
      "client_email": "MANU84PEREIRA@GMAIL.COM",
      "address": "CALLE LA CONCEPCION 2 EDIF TORRE A PISO PB APT 8",
      "client_identification": "V16407556",
      "nap_box_name": "0325 DOS",
      "created_at": "2024-07-29T10:02:22.152871",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5746,
      "client_name": "JUAN PABLO GONCALVES LOBO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Concepcion",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144874185",
      "client_email": "GONCACRACK@GMAIL.COM",
      "address": "CALLE 3 CASA NRO 7 URB LA CONCEPCION TURMERO",
      "client_identification": "V26935614",
      "nap_box_name": "108",
      "created_at": "2024-07-29T10:06:22.466925",
      "service_detail": {
        "id": 5376,
        "ip": "172.20.91.2",
        "mac": "TPLGF5CB0032",
        "serial": "TPLGF5CB0032",
        "queue": "queue1",
        "interface": "VLAN111_CONCEPCION",
        "created_at": "2024-08-16T11:57:50.542549",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5747,
      "client_name": "ODALIS YESENIA CASTILLO BRITO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243376522",
      "client_email": "ODYECASBRI1971@GMAIL.COM",
      "address": "SAMAN TARAZONERO II MANZANA F-1 NRO 37 EL MACAROTURMERO",
      "client_identification": "V10759290",
      "nap_box_name": "93",
      "created_at": "2024-07-29T10:09:23.647811",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5748,
      "client_name": "VICTORIA JOSE LOPEZ MEDINA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Antonio Jose de Sucre",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04123987513",
      "client_email": "LOPEZMVICK@GMAIL.COM",
      "address": "CALLE  25 DE AGOSTO CASA NRO 42 ANTONIOJOSE DE SUCRE TURMERO",
      "client_identification": "V19699858",
      "nap_box_name": "122",
      "created_at": "2024-07-29T10:23:52.694089",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5749,
      "client_name": "CARINA CONSUELO ROMERO CASTILLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 43,
        "name": "RECURRENTE RESIDENCIAL PLAN 650M",
        "cost": "46.00",
        "code": "FOR650M",
        "profile": "650M/650M"
      },
      "client_mobile": "04125023171",
      "client_email": "JANNYROMERO723@GMAIL.COM",
      "address": "CALLE MANZANA F-2 CASA NRO 17 SECTOR SAMAN TARAZONERO II EL MACARO",
      "client_identification": "V9653021",
      "nap_box_name": "162",
      "created_at": "2024-07-29T10:31:47.207916",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5750,
      "client_name": "JUAN DE JESUS URBINA BARBARESCO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121411802",
      "client_email": "URBINAJUANDEJESUS@GMAIL.COM",
      "address": "CALLE MANZANA D-13 CASA NRO 14 URB SAMAN TARAZONERO II TURMERO",
      "client_identification": "V14274115",
      "nap_box_name": "CTO-00064",
      "created_at": "2024-07-29T10:33:52.097373",
      "service_detail": {
        "id": 5372,
        "ip": "172.20.123.2",
        "mac": "TPLGB954E87E",
        "serial": "TPLGB954E87E",
        "queue": "Plan_107915_1574_WispHub",
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2024-08-16T11:50:15.974928",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5751,
      "client_name": "BARBARA VIVIANA PEREZ DE FRANCISCO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Terrazas de Turmero",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243229892",
      "client_email": "BARBARAPEREZ.24@GMAIL.COM",
      "address": "CALLE 2  CASA NRO 27-B URB TERRAZAS DE TURMERO",
      "client_identification": "V20267446",
      "nap_box_name": "118",
      "created_at": "2024-07-29T10:55:56.194810",
      "service_detail": {
        "id": 5370,
        "ip": "172.19.239.2",
        "mac": "TPLGB68B4F15",
        "serial": "TPLGB68B4F15",
        "queue": "Plan_92291_15811_WispHub",
        "interface": "VLAN225_TERRAZAS_TURMERO_OLT1",
        "created_at": "2024-08-16T11:46:54.461111",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5752,
      "client_name": "ISABEL CRISTINA RUIZ DE BRICEÑO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Valle Paraiso",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04123148916",
      "client_email": "YELITZAB25@GMAIL.COM",
      "address": "CALLE 6 CASA NRO 07-10 URB VALLE PARAISO TURMERO",
      "client_identification": "V3284184",
      "nap_box_name": "CE-00254",
      "created_at": "2024-07-29T11:00:29.192309",
      "service_detail": {
        "id": 11948,
        "ip": "172.19.234.2",
        "mac": "TPLGF5CB0A4A",
        "serial": "TPLGF5CB0A4A",
        "queue": null,
        "interface": "VLAN200_OLTs",
        "created_at": "2026-03-04T12:04:52.405000",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5753,
      "client_name": "FERNANDO ROTONDO TEMPORE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "San Pablo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128903645",
      "client_email": "ROTONDOF@GMAIL.COM",
      "address": "AV 3 CASA NRO 17 SAN PABLOTURMERO",
      "client_identification": "V3156771",
      "nap_box_name": "CTO-0637",
      "created_at": "2024-07-29T11:03:00.962381",
      "service_detail": {
        "id": 4623,
        "ip": "172.19.236.2",
        "mac": "TPLGB954FB22",
        "serial": "TPLGB954FB22",
        "queue": "Plan_116775_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-08-11T21:15:20.687763",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5754,
      "client_name": "OMAYCI BEATRIZ PIRELA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04149472726",
      "client_email": "OMAYCIP27@GMAIL.COM",
      "address": "VDA MANZANA 1-6CASA NRO 19 SAMAN TARAZONERO II TURMERO",
      "client_identification": "V13722329",
      "nap_box_name": "284",
      "created_at": "2024-07-29T11:06:58.214819",
      "service_detail": {
        "id": 4503,
        "ip": "172.20.86.2",
        "mac": "TPLGF5CB0691",
        "serial": "TPLGF5CB0691",
        "queue": "Plan_107915_1574_WispHub",
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2024-08-10T11:47:13.762036",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5755,
      "client_name": "AURELYS ADRIANA PEREZ GEROMES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04128758113",
      "client_email": "ADRIANAPEREZ1408@GMAIL.COM",
      "address": "AV INTERCOMUNAL EL MACARO CASA MANZANA B-7 NRO 3 URB SAMAN TARAZONERO II",
      "client_identification": "V20693039",
      "nap_box_name": "280",
      "created_at": "2024-07-29T11:08:33.974116",
      "service_detail": {
        "id": 11554,
        "ip": "172.20.92.2",
        "mac": "TPLGF5CB03C2",
        "serial": "TPLGF5CB03C2",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2026-02-08T19:01:14.230004",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5756,
      "client_name": "LUIS ALBERTO BLANCO RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04141250378",
      "client_email": "LUISADOLFO.MORELLO@GMAIL.COM",
      "address": "CALLE GIRARDOT CASA NRO 8 URB MARIÑO TURMERO",
      "client_identification": "V1738642",
      "nap_box_name": "53",
      "created_at": "2024-07-29T22:18:25.187547",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5757,
      "client_name": "ERNESTO JOSE ARANA ESQUEDA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121385294",
      "client_email": "ERNESTONISSI73@GMAIL.COM",
      "address": "CALLE 13 CASA NRO 50 URB LA CASONA II",
      "client_identification": "V14665867",
      "nap_box_name": "CTO-00075 DOS",
      "created_at": "2024-07-29T22:21:47.531966",
      "service_detail": {
        "id": 4583,
        "ip": "172.20.97.2",
        "mac": "TPLGF5CB09F5",
        "serial": "TPLGF5CB09F5",
        "queue": "Plan_131647_24341_WispHub",
        "interface": "VLAN110_CASONA_2",
        "created_at": "2024-08-11T17:28:00.529128",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5758,
      "client_name": "BRAYAN JOSE JAIME ALBORNOZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04129449057",
      "client_email": "BRAYANJAIME80@GMAIL.COM",
      "address": "VDA 1-5 CASA NRO 10 SECTOR SAMAN TARAZONERO II TURMERO",
      "client_identification": "V30211821",
      "nap_box_name": "284",
      "created_at": "2024-07-29T22:38:32.095035",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5759,
      "client_name": "FRANCISCO JAVIER PARRA PALACIOS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124778137",
      "client_email": "FRANCISCOPARRA0910@GMAIL.COM",
      "address": "CALLE FUNDO DESARROLLO NRO 4 SECTOR SAMAN TARAZONERO II TRANSVERSAL 5",
      "client_identification": "V20110592",
      "nap_box_name": "508",
      "created_at": "2024-07-29T22:49:13.842107",
      "service_detail": {
        "id": 11566,
        "ip": "172.20.109.2",
        "mac": "TPLGF5CB0871",
        "serial": "TPLGF5CB0871",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2026-02-09T18:17:54.709503",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5760,
      "client_name": "SHANT KASSAJIAN KAMAIAN",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04127407030",
      "client_email": "KASSAJIANSHANT32@GMAIL.COM",
      "address": "CALLE URDANETA EDIF NELLY PISO 5 APTO 25 TURMERO",
      "client_identification": "V15912961",
      "nap_box_name": "CTO-00194",
      "created_at": "2024-07-29T22:58:17.610001",
      "service_detail": {
        "id": 4581,
        "ip": "172.21.76.2",
        "mac": "TPLGB954ECA9",
        "serial": "TPLGB954ECA9",
        "queue": "Plan_92284_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-08-11T17:20:16.112930",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5761,
      "client_name": "ESNEIDER JOLIFFE OLIVERO DURAN",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Guanarito",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124859775",
      "client_email": "ESNEIDEROLIVERO05@GMAIL.COM",
      "address": "CALLE LA ESTRELLA CASA NRO 9 SECTOR GUANARITO ROSARIO DE PAYA",
      "client_identification": "V14943104",
      "nap_box_name": "231",
      "created_at": "2024-07-30T08:46:56.121672",
      "service_detail": {
        "id": 9991,
        "ip": "172.23.41.2",
        "mac": "TPLGBA687C26",
        "serial": "TPLGBA687C26",
        "queue": null,
        "interface": "VLAN232_GUANARITO_OLT2",
        "created_at": "2025-11-11T13:34:27.117060",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5762,
      "client_name": "ANA GABRIELA HERAZO ORTEGOZA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243305222",
      "client_email": "UNIMAXB22@GMAIL.COM",
      "address": "CALLE 7 CASA NRO 548-A URB MATA CABALLO TURMERO",
      "client_identification": "V26320887",
      "nap_box_name": "CTO-00073",
      "created_at": "2024-07-30T08:49:06.204785",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5763,
      "client_name": "NEYLA NOEMI GONZALEZ PENZO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04127062063",
      "client_email": "GDIAZADCRESPO@GMAIL.COM",
      "address": "AV 1 CASA NRO 678B SECTOR MATA CABALLO ROSARIO DE PAYA",
      "client_identification": "V14389621",
      "nap_box_name": "CTO-00215",
      "created_at": "2024-07-30T08:51:08.647471",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5764,
      "client_name": "JOSE GREGORIO VIVAS CASANOVA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04247572131",
      "client_email": "ABOG.VIVAS87@GMAIL.COM",
      "address": "CALLE 16 CASA NRO 09 URB PANTIN ROSARIO DE PAYA",
      "client_identification": "V18779516",
      "nap_box_name": "CTO-00195",
      "created_at": "2024-07-30T08:53:53.452125",
      "service_detail": {
        "id": 4840,
        "ip": "172.22.247.2",
        "mac": "TPLGBA6878AC",
        "serial": "TPLGBA6878AC",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN229_PANTIN",
        "created_at": "2024-08-12T17:58:51.484156",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5765,
      "client_name": "AMADA JOSEFINA RIVERA LAGUNA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Pantin",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04247322659",
      "client_email": "AMADARIVERA0109@GMAIL.COM",
      "address": "CALLE 16A CASA NRO 04 URB PANTIN ROSARIO DE PAYA",
      "client_identification": "V5757865",
      "nap_box_name": "CTO-00195",
      "created_at": "2024-07-30T09:12:37.430804",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5766,
      "client_name": "IVAN GABRIEL GUILLERMO SANCHEZ COHEN",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04141440324",
      "client_email": "ISANCHEZ73123@GMAIL.COM",
      "address": "CALLE 16A CASA NRO 3 URB PANTIN ROSARIO DE PAYA",
      "client_identification": "V26791791",
      "nap_box_name": "CTO-00195",
      "created_at": "2024-07-30T09:16:22.535402",
      "service_detail": {
        "id": 4844,
        "ip": "172.22.164.2",
        "mac": "TPLGBA6874BE",
        "serial": "TPLGBA6874BE",
        "queue": "Plan_161889_30183_WispHub",
        "interface": "VLAN229_PANTIN",
        "created_at": "2024-08-12T18:08:47.525747",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5767,
      "client_name": "IVONNE ALEJANDRA VARGAS  SALAZAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121333559",
      "client_email": "IVONNEVS1603@GMAIL.COM",
      "address": "CALLE 18A CASA NRO 12 URB PANTIN TURMERO",
      "client_identification": "V26596777",
      "nap_box_name": "CTO-00434",
      "created_at": "2024-07-30T09:21:28.410344",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5768,
      "client_name": "RUDYMAR CAMPOS RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04120334009",
      "client_email": "RUDYARREGUI23@GMAIL.COM",
      "address": "CALLE 20 N21 URB PANTIN ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V13375135",
      "nap_box_name": "CTO-00435",
      "created_at": "2024-07-30T09:29:59.074890",
      "service_detail": {
        "id": 4847,
        "ip": "172.23.46.2",
        "mac": "TPLGBA687C0E",
        "serial": "TPLGBA687C0E",
        "queue": "Plan_161889_30183_WispHub",
        "interface": "VLAN229_PANTIN",
        "created_at": "2024-08-12T18:14:12.140832",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5769,
      "client_name": "SANTA GRICELIS TOVAR MILANO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "San Pablo",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04145978889",
      "client_email": "GREICILYS@GMAIL.COM",
      "address": "AV PRINCIPAL SAN PABLO NRO-16",
      "client_identification": "V16383430",
      "nap_box_name": "CTO-0637",
      "created_at": "2024-07-30T09:35:31.140099",
      "service_detail": {
        "id": 4849,
        "ip": "172.23.26.2",
        "mac": "TPLGBA687C12",
        "serial": "TPLGBA687C12",
        "queue": "Plan_112654_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-08-12T18:18:29.388804",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5770,
      "client_name": "GEOVANA FRANCHESCA PLATANIA GIL",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04249069327",
      "client_email": "GEOBANAPLATANIA07@GMAIL.COM",
      "address": "CALLE 17 A CASA NRO 13 URB PANTIN ROSARIO DE PAYA",
      "client_identification": "V31785232",
      "nap_box_name": "CTO-00101",
      "created_at": "2024-07-30T09:38:49.796572",
      "service_detail": {
        "id": 12179,
        "ip": "172.22.173.2",
        "mac": "TPLGBA687AAE",
        "serial": "TPLGBA687AAE",
        "queue": null,
        "interface": "VLAN229_PANTIN",
        "created_at": "2026-03-25T16:28:41.539965",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5771,
      "client_name": "ISABEL CAROLINA ACOSTA GUZMAN",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243144722",
      "client_email": "CAROLACOST45@GMAIL.COM",
      "address": "CALLE 10-A CASA NRO 15 URB PANTIN ROSARIO DE PAYA",
      "client_identification": "V13426691",
      "nap_box_name": "CTO-00121",
      "created_at": "2024-07-30T09:44:06.218789",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5772,
      "client_name": "JAIKER SAMUEL GONZALEZ LINARES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04245082971",
      "client_email": "GJAIKER@GMAIL.COM",
      "address": "CALLE 10-A CASA NRO 10 URN HACIENDA PANTIN ROSARIO DE PAYA",
      "client_identification": "V27204298",
      "nap_box_name": "CTO-00121",
      "created_at": "2024-07-30T09:46:28.347767",
      "service_detail": {
        "id": 4853,
        "ip": "172.22.213.2",
        "mac": "TPLGBA687C42",
        "serial": "TPLGBA687C42",
        "queue": "Plan_161889_30183_WispHub",
        "interface": "VLAN229_PANTIN",
        "created_at": "2024-08-12T18:26:29.909651",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5773,
      "client_name": "ENEDINA ESMERALDA BRAVO ALVAREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128494034",
      "client_email": "ESMERALDABRAV@GMAIL.COM",
      "address": "CALLE 10 CASA NRO 6 URB PANTIN ROSARIO DE PAYA",
      "client_identification": "V12738526",
      "nap_box_name": "CTO-00121",
      "created_at": "2024-07-30T09:48:54.250377",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5774,
      "client_name": "MARINEL KARINA GUTIERREZ PULIDO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04149473233",
      "client_email": "GUTIERREZMK18@GMAIL.COM",
      "address": "CALLE 10A CASA NRO 03 URB PANTIN ROSARIO DE PAYA",
      "client_identification": "V18447915",
      "nap_box_name": "CTO-00121",
      "created_at": "2024-07-30T09:53:39.555869",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5775,
      "client_name": "FABIO JOSUE AGREDO TEJADA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Pantin",
      "plan": {
        "id": 43,
        "name": "RECURRENTE RESIDENCIAL PLAN 650M",
        "cost": "46.00",
        "code": "FOR650M",
        "profile": "650M/650M"
      },
      "client_mobile": "04123104204",
      "client_email": "AGREDO.FABIO@GMAIL.COM",
      "address": "CALLE 10A CASA NRO 22 URB PANTIN ROSARIO DE PAYA",
      "client_identification": "V19948767",
      "nap_box_name": "CTO-00121",
      "created_at": "2024-07-30T09:55:01.984570",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5776,
      "client_name": "GUSTAVO ENRIQUE CASTILLO GARCIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243330001",
      "client_email": "CASTILLOTAVOGUS@GMAIL.COM",
      "address": "CALLE 14-A CASA NRO 03 URB PANTIN ROSARIO DE PAYA",
      "client_identification": "V13199062",
      "nap_box_name": "CTO-00169",
      "created_at": "2024-07-30T10:17:18.103305",
      "service_detail": {
        "id": 4859,
        "ip": "172.22.181.2",
        "mac": "TPLGBA687A3C",
        "serial": "TPLGBA687A3C",
        "queue": "Plan_161891_30183_WispHub",
        "interface": "VLAN229_PANTIN",
        "created_at": "2024-08-13T07:25:32.114828",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5777,
      "client_name": "JUAN JOSE HIDALGO ROJAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04120162392",
      "client_email": "JUANCHOJHR1997@GMAIL.COM",
      "address": "CALLE 14-A URB PANTIN  CASA NRO 24 ROSARIO DE PAYA",
      "client_identification": "V25841023",
      "nap_box_name": "CTO-00169",
      "created_at": "2024-07-30T10:19:52.173447",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5778,
      "client_name": "DANIEL ENRIQUE MONTCOURT SANCHEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04128872096",
      "client_email": "DANIEL.MONTCOURT@GMAIL.COM",
      "address": "CALLE 14-B CASA NRO 30 URB PANTIN ROSARIO DE PAYA",
      "client_identification": "V19364617",
      "nap_box_name": "CTO-00052",
      "created_at": "2024-07-30T10:22:38.732478",
      "service_detail": {
        "id": 4862,
        "ip": "172.22.232.2",
        "mac": "TPLGBA687828",
        "serial": "TPLGBA687828",
        "queue": "Plan_161860_30181_WispHub",
        "interface": "VLAN229_PANTIN",
        "created_at": "2024-08-13T07:31:39.544005",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5779,
      "client_name": "KLEISON EDUARDO GARCIA CABEZA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128850719",
      "client_email": "KLEISONG4@GMAIL.COM",
      "address": "CALLE 14-B CASA NRO 42 URB PANTIN ROSARIO DE PAYA",
      "client_identification": "V26095562",
      "nap_box_name": "CTO-00052",
      "created_at": "2024-07-30T10:24:44.118672",
      "service_detail": {
        "id": 4863,
        "ip": "172.23.35.2",
        "mac": "TPLGBA687923",
        "serial": "TPLGBA687923",
        "queue": "Plan_161889_30183_WispHub",
        "interface": "VLAN229_PANTIN",
        "created_at": "2024-08-13T07:33:28.677407",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5780,
      "client_name": "JINEIBY ANDREINA VARGAS MORILLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04120449500",
      "client_email": "JINEIBYVARGAS197@GMAIL.COM",
      "address": "CALLE 6-A CASA 10 BARRIO ROSARIO DE PAYA PANTIN",
      "client_identification": "V28187279",
      "nap_box_name": "CTO-0013B",
      "created_at": "2024-07-30T10:31:09.473618",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5781,
      "client_name": "DELMAR JACQUELINE VIVAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04162445660",
      "client_email": "ADRIYDALLE31@GMAIL.COM",
      "address": "CALLE 11A CASA NRO 15 URB PANTIN ROSARIO DE PAYA",
      "client_identification": "V12139893",
      "nap_box_name": "CTO-00167",
      "created_at": "2024-07-30T10:50:03.400683",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5782,
      "client_name": "MARY MERCEDES RODRIGUEZ BLANCO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128910911",
      "client_email": "MARIANNYNAZARETHBR@GMAIL.COM",
      "address": "CALLE 11 A CASA NRO 16 URB PANTIN ROSARIO DE PAYA",
      "client_identification": "V9677918",
      "nap_box_name": "CTO-00167",
      "created_at": "2024-07-30T10:56:44.595348",
      "service_detail": {
        "id": 12450,
        "ip": "172.22.176.2",
        "mac": "TPLGBA687847",
        "serial": "TPLGBA687847",
        "queue": null,
        "interface": "VLAN229_PANTIN",
        "created_at": "2026-05-03T09:44:09.428188",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5783,
      "client_name": "ISAAC LEONARDO LEAL CASTILLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Pantin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04123980618",
      "client_email": "ISAACLEAL05@GMAIL.COM",
      "address": "CALLE 12A CASA NRO 13 URB PANTIN  ROSARIO DE PAYA",
      "client_identification": "V28187148",
      "nap_box_name": "CTO-00165",
      "created_at": "2024-07-30T11:01:45.645211",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5784,
      "client_name": "AYARIT LEONOR CLARO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243060223",
      "client_email": "TATIANARENAULT5@GMAIL.COM",
      "address": "CALLE 3B CASA NRO 42 URB HACIENDA DE PANTIN ROSARIO DE PAYA",
      "client_identification": "V10497204",
      "nap_box_name": "CE-00043",
      "created_at": "2024-07-30T11:03:39.044029",
      "service_detail": {
        "id": 4872,
        "ip": "172.22.246.2",
        "mac": "TPLGBA68799D",
        "serial": "TPLGBA68799D",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN229_PANTIN",
        "created_at": "2024-08-13T07:50:33.718260",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5785,
      "client_name": "YUSMAR ELENA TORREALBA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121595314",
      "client_email": "YUSMAR774@GMAIL.COM",
      "address": "CALLE 13B CASA NRO 37 URB PANTIN ROSARIO DE PAYA",
      "client_identification": "V13875335",
      "nap_box_name": "CTO-00171",
      "created_at": "2024-07-30T11:06:19.382209",
      "service_detail": {
        "id": 13142,
        "ip": "172.16.5.2",
        "mac": "TP:LG:B6:8B:50:7D",
        "serial": "TPLGB68B507D",
        "queue": null,
        "interface": "VLAN229_PANTIN",
        "created_at": "2026-10-10T11:54:43.415444",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5786,
      "client_name": "YARIVIS ALEXANDRA RENGIFO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128447160",
      "client_email": "YARIVIS1985@GMAIL.COM",
      "address": "CALLE 10 CASA NRO 40 URB. PANTIN ROSARIO DE PAYA",
      "client_identification": "V17575442",
      "nap_box_name": "CTO-00141",
      "created_at": "2024-07-30T11:10:23.088664",
      "service_detail": {
        "id": 8747,
        "ip": "172.22.186.2",
        "mac": "TPLGBA687AC8",
        "serial": "TPLGBA687AC8",
        "queue": "queue1",
        "interface": "VLAN229_PANTIN",
        "created_at": "2025-05-27T12:00:04.279837",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5787,
      "client_name": "BURIDAN EMILIO PAEZ PRADO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128993363",
      "client_email": "BURIDANEMILIOP157@GMAIL.COM",
      "address": "CALLE 10B CASA NRO 46  IRN PANTIN ROSARIO DE PAYA",
      "client_identification": "V4850600",
      "nap_box_name": "CTO-00141",
      "created_at": "2024-07-30T11:12:31.071090",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5788,
      "client_name": "NAYRA DAYANA BARRIOS DE GARCIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121593287",
      "client_email": "NAYRABARRIOS15@GMAIL.COM",
      "address": "CALLE 17 CASA NRO 11 URB PANTIN  ROSARIO DE PAYA",
      "client_identification": "V15708089",
      "nap_box_name": "CTO-00101",
      "created_at": "2024-07-30T11:18:37.066270",
      "service_detail": {
        "id": 4637,
        "ip": "172.22.152.2",
        "mac": "TPLGBA687A6E",
        "serial": "TPLGBA687A6E",
        "queue": "Plan_161889_30183_WispHub",
        "interface": "VLAN229_PANTIN",
        "created_at": "2024-08-12T09:12:25.611591",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5789,
      "client_name": "ARGENIS JOSE MOLLETON CARRASQUEL",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Pantin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04120246755",
      "client_email": "ARGENIS_JOSEMOLLETON@HOTMAIL.COM",
      "address": "CALLE 13A CASA NRO 18 SECTOR PANTIN ROSARIO DE PAYA",
      "client_identification": "V13530482",
      "nap_box_name": "CTO-00170",
      "created_at": "2024-07-30T11:20:35.201635",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5790,
      "client_name": "DAYARLIS YARINET BRICENO HERRERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144680730",
      "client_email": "DAYARLIS.B@GMAIL.COM",
      "address": "CALLE 13B  CASA NRO 30 URB PANTIN ROSARIO DE PAYA",
      "client_identification": "V17247059",
      "nap_box_name": "CTO-00171",
      "created_at": "2024-07-30T11:24:13.283319",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5791,
      "client_name": "PEDRO FLORES ALVAREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04140514870",
      "client_email": "FLORESALVAREZPEDRO34@GMAIL.COM",
      "address": "CALLE 17A CASA NRO 10 URB PANTIN ROSARIO DE PAYA",
      "client_identification": "V6350080",
      "nap_box_name": "CTO-00101",
      "created_at": "2024-07-30T11:26:19.391038",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5792,
      "client_name": "FRANCISCO DEL VALLE PEREZ BARRIOS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04127672020",
      "client_email": "FDVPBA@GMAIL.COM",
      "address": "CALLE 13 CASA NRO 11 URB  PANTIN ROSARIO DE PAYA",
      "client_identification": "V12168625",
      "nap_box_name": "CTO-00170",
      "created_at": "2024-07-30T11:40:48.740178",
      "service_detail": {
        "id": 5998,
        "ip": "172.22.145.2",
        "mac": "TPLGBA687B98",
        "serial": "TPLGBA687B98",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN229_PANTIN",
        "created_at": "2024-08-22T08:05:04.206192",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5793,
      "client_name": "YEILY DEL CARMEN LAYA MORALES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04128909955",
      "client_email": "YEILYLAYA93@GMAIL.COM",
      "address": "CALLE 10B CASA NRO 51 URB PANTIN  ROSARIO DE PAYA",
      "client_identification": "V24818894",
      "nap_box_name": "CTO-00141",
      "created_at": "2024-07-30T11:42:55.400015",
      "service_detail": {
        "id": 4640,
        "ip": "172.22.144.2",
        "mac": "TPLGBA687499",
        "serial": "TPLGBA687499",
        "queue": "Plan_161890_30183_WispHub",
        "interface": "VLAN229_PANTIN",
        "created_at": "2024-08-12T09:30:33.396202",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5794,
      "client_name": "ARZULIS CARRASCO GOMEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04148849647",
      "client_email": "ARZULISC@GMAIL.COM",
      "address": "CALLE 10B  CASA NRO 38 URB PANTIN ROSARIO DE PAYA",
      "client_identification": "V6184038",
      "nap_box_name": "CTO-00141",
      "created_at": "2024-07-30T11:44:46.292658",
      "service_detail": {
        "id": 4642,
        "ip": "172.22.183.2",
        "mac": "TPLGBA687827",
        "serial": "TPLGBA687827",
        "queue": "Plan_161905_30183_WispHub",
        "interface": "VLAN229_PANTIN",
        "created_at": "2024-08-12T09:35:16.055132",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5795,
      "client_name": "JEFFERSON ENRIQUE ARCILA REVERON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04122084552",
      "client_email": "JEFFERSONARCILA612@GMAIL.COM",
      "address": "CALLE 10B  CASA NRO 38 URB PANTIN ROSARIO DE PAYA",
      "client_identification": "V25841619",
      "nap_box_name": "CTO-00141",
      "created_at": "2024-07-30T11:47:11.638473",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5796,
      "client_name": "AMARILIS FLORES AREVALO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04241236068",
      "client_email": "Amarilis12608323@gmail.com",
      "address": "CALLE 13B CASA NRO 43 URB PANTIN ROSARIO DE PAYA",
      "client_identification": "V12608323",
      "nap_box_name": "CTO-00171",
      "created_at": "2024-07-30T11:58:21.516423",
      "service_detail": {
        "id": 9257,
        "ip": "172.22.180.2",
        "mac": "TPLGBA687446",
        "serial": "TPLGBA687446",
        "queue": "queue1",
        "interface": "VLAN229_PANTIN",
        "created_at": "2025-07-25T08:49:49.396900",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5797,
      "client_name": "ORIANA PAOLA PARIS HERNANDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04122921001",
      "client_email": "PARISORIANA2000@GMAIL.COM",
      "address": "CALLE 1-A CASA NRO 2 URB LOS PANTIN ROSARIO DE PAYA",
      "client_identification": "V29728516",
      "nap_box_name": "CTO-00128",
      "created_at": "2024-07-30T12:00:20.559861",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5798,
      "client_name": "JANETH JOSEFINA SANCHEZ DE BRAVO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04246638685",
      "client_email": "janethsanche71@gmail.com",
      "address": "AV 13B CASA NRO 45 SECTOR HACIENDA PANTIN ROSARIO DE PAYA",
      "client_identification": "V10894141",
      "nap_box_name": "CTO-00171",
      "created_at": "2024-07-30T12:02:42.317517",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5799,
      "client_name": "MARGARETH DANIELA GAZCON GUTIERREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128904882",
      "client_email": "ronyacevedo1989@gmail.com",
      "address": "CALLE 10B CASA NRO 36 URB PANTIN ROSARIO DE PAYA",
      "client_identification": "V25620213",
      "nap_box_name": "CTO-00141",
      "created_at": "2024-07-30T12:04:58.927395",
      "service_detail": {
        "id": 5399,
        "ip": "172.22.172.2",
        "mac": "TPLGBA68799C",
        "serial": "TPLGBA68799C",
        "queue": "queue1",
        "interface": "VLAN229_PANTIN",
        "created_at": "2024-08-16T15:12:33.062434",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5800,
      "client_name": "ANA MIRIAM SILVA RAMIREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Pantin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128831749",
      "client_email": "ANABELLACHARLOTTE12345@GMAIL.COM",
      "address": "CALLE 7A CASA NRO 12 URB PANTIN ROSARIO DE PAYA",
      "client_identification": "V9244199",
      "nap_box_name": "CTO-00139",
      "created_at": "2024-07-30T12:07:27.138586",
      "service_detail": {
        "id": 5403,
        "ip": "172.22.215.2",
        "mac": "TPLGBA687AED",
        "serial": "TPLGBA687AED",
        "queue": "Plan_107915_30181_WispHub",
        "interface": "VLAN229_PANTIN",
        "created_at": "2024-08-16T15:17:15.216068",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5801,
      "client_name": "RAFAEL ANTONIO SANCHEZ AGUIAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144889473",
      "client_email": "RAFAELSANAGU@GMAIL.COM",
      "address": "CALLE 9 NRO 29 URB PANTIN ROSARIO DE PAYA",
      "client_identification": "V22948926",
      "nap_box_name": "CTO-00122",
      "created_at": "2024-07-30T12:09:34.972052",
      "service_detail": {
        "id": 5407,
        "ip": "172.23.36.2",
        "mac": "TPLGBA687C85",
        "serial": "TPLGBA687C85",
        "queue": "Plan_161903_30183_WispHub",
        "interface": "VLAN229_PANTIN",
        "created_at": "2024-08-16T15:24:42.252866",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5802,
      "client_name": "ZULEMA TORTOLERO FLORES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121487894",
      "client_email": "010609ZU@GMAIL.COM",
      "address": "CALLE 9B CASA NRO 46 URB PANTIN ROSARIO DE PAYA",
      "client_identification": "V6236345",
      "nap_box_name": "CTO-00122",
      "created_at": "2024-07-30T12:11:41.140472",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5803,
      "client_name": "ARGELIA JOSEFINA TORREALBA TORRES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243362955",
      "client_email": "ARGELIAJOSEFINATORREAL70@GMAIL.COM",
      "address": "CALLE 9B CASA 47 URB PANTIN ROSARIO DE PAYA",
      "client_identification": "V9435587",
      "nap_box_name": "CTO-00122",
      "created_at": "2024-07-30T13:40:09.219200",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5804,
      "client_name": "DEISY JOSE DE JESUS OROPEZA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243062841",
      "client_email": "DEISYDEJESUS848@GMAIL.COM",
      "address": "CALLE 9 CASA NRO 55 URB PANTIN ROSARIO DE PAYA",
      "client_identification": "V15713989",
      "nap_box_name": "CTO-00122",
      "created_at": "2024-07-30T13:42:28.510194",
      "service_detail": {
        "id": 5416,
        "ip": "172.23.37.2",
        "mac": "TPLGBA6874BD",
        "serial": "TPLGBA6874BD",
        "queue": "queue1",
        "interface": "VLAN229_PANTIN",
        "created_at": "2024-08-16T15:38:05.729405",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5805,
      "client_name": "DUBRASKA MARIA ARAUJO GUZMAN",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04228150453",
      "client_email": "DUBRASKAARAUJO040780@GMAIL.COM",
      "address": "CALLE 7B CASA  NRO 36 URB  PANTIN ROSARIO DE PAYA",
      "client_identification": "V14787518",
      "nap_box_name": "CTO-00140",
      "created_at": "2024-07-30T13:44:47.088147",
      "service_detail": {
        "id": 6015,
        "ip": "172.22.244.2",
        "mac": "TPLGBA6874FD",
        "serial": "TPLGBA6874FD",
        "queue": "Plan_161889_30183_WispHub",
        "interface": "VLAN229_PANTIN",
        "created_at": "2024-08-22T09:11:19.440212",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5807,
      "client_name": "YOLEIDY RAYBETH OCHOA DE POL",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04127766363",
      "client_email": "ALEXEYPOLL@GMAIL.COM",
      "address": "CALLE 6-A CASA NRO 11 URB LOS PANTIN ROSARIO DE PAYA",
      "client_identification": "V18177462",
      "nap_box_name": "CTO-0013B",
      "created_at": "2024-07-30T14:04:39.749039",
      "service_detail": {
        "id": 5947,
        "ip": "172.22.159.2",
        "mac": "TPLGBA687725",
        "serial": "TPLGBA687725",
        "queue": "queue1",
        "interface": "VLAN229_PANTIN",
        "created_at": "2024-08-21T13:49:34.174399",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5808,
      "client_name": "GREGORY MARIA RENGIFO DE PEREIRA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243455955",
      "client_email": "GREGORYMARIA70@GMAIL.COM",
      "address": "CALLE 7B CASA NRO 49 URB PANTIN ROSARIO DE PAYA",
      "client_identification": "V10750342",
      "nap_box_name": "CTO-00140",
      "created_at": "2024-07-30T14:06:46.764481",
      "service_detail": {
        "id": 5421,
        "ip": "172.22.146.2",
        "mac": "TPLGBA68772A",
        "serial": "TPLGBA68772A",
        "queue": "Plan_161870_30181_WispHub",
        "interface": "VLAN229_PANTIN",
        "created_at": "2024-08-16T15:45:51.401614",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5809,
      "client_name": "SILEIDI COSMELINA FREITES VELASQUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243596852",
      "client_email": "SILEIDI2021@GMAIL.COM",
      "address": "CALLE 7A CASA NRO 14 URB PANTIN ROSARIO DE PAYA",
      "client_identification": "V18586799",
      "nap_box_name": "CTO-00139",
      "created_at": "2024-07-30T14:08:41.813125",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5810,
      "client_name": "NITIKA YULISSA COHEN CAMEJO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128825827",
      "client_email": "CAMEJOJUANAMARIA@HOTMAIL.COM",
      "address": "CALLE 6A NRO 14 URB  PANTIN ROSARIO DE PAYA",
      "client_identification": "V12340498",
      "nap_box_name": "CTO-0013B",
      "created_at": "2024-07-30T14:11:39.185069",
      "service_detail": {
        "id": 5431,
        "ip": "172.22.151.2",
        "mac": "TPLGBA687A35",
        "serial": "TPLGBA687A35",
        "queue": "Plan_161903_30183_WispHub",
        "interface": "VLAN229_PANTIN",
        "created_at": "2024-08-16T16:03:28.593463",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5811,
      "client_name": "JADER JOSE GOLINDANO VASQUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121480073",
      "client_email": "GOLINDANO.JADER@GMAIL.COM",
      "address": "CALLE MANZANA H-8 CASA NRO 5 SECTOR  SAMAN TARAZONERO II TURMERO",
      "client_identification": "V20758871",
      "nap_box_name": "510 DOS",
      "created_at": "2024-07-30T14:21:12.024577",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5813,
      "client_name": "CLEIVER JAVIER CONTRERAS RAMOS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04122982826",
      "client_email": "CLEIVERC95@GMAIL.COM",
      "address": "CALLE 1-B CASA NRO 36 URB PANTIN ROSARIO DE PAYA",
      "client_identification": "V24930696",
      "nap_box_name": "CTO-00127",
      "created_at": "2024-07-30T14:26:13.697296",
      "service_detail": {
        "id": 5438,
        "ip": "172.22.163.2",
        "mac": "TPLGBA687B34",
        "serial": "TPLGBA687B34",
        "queue": "queue1",
        "interface": "VLAN229_PANTIN",
        "created_at": "2024-08-16T16:15:15.866189",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5814,
      "client_name": "CARMEN MARIA CARRILLO ROMERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Pantin",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04121459760",
      "client_email": "KARMENCARRILLO20@GMAIL.COM",
      "address": "CALLE 5A CASA NRO 23 URB PANTIN ROSARIO DE PAYA",
      "client_identification": "V12610110",
      "nap_box_name": "CTO-00135",
      "created_at": "2024-07-30T14:28:03.868743",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5815,
      "client_name": "ZAIDA MARGARITA MENDOZA CARBALLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128873261",
      "client_email": "ZAIDAMARMENDOZA@GMAIL.COM",
      "address": "CALLE MANZANA E11 CASA NRO 16 URB SAMAN  TARAZONERO II TURMERO",
      "client_identification": "V7234714",
      "nap_box_name": "93",
      "created_at": "2024-07-30T14:34:54.874985",
      "service_detail": {
        "id": 4574,
        "ip": "172.20.119.2",
        "mac": "TPLGB68B563F",
        "serial": "TPLGB68B563F",
        "queue": "Plan_107915_1574_WispHub",
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2024-08-11T16:57:48.575539",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5816,
      "client_name": "FRANKLIN ADOLFO ARAUJO VILLEGAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04120377330",
      "client_email": "FRANK137418@GMAIL.COM",
      "address": "CALLE 1B  CASA  NRO 15 URB  HACIENDA PANTIN ROSARIO DE PAYA",
      "client_identification": "V12452935",
      "nap_box_name": "CTO-00127",
      "created_at": "2024-07-30T14:36:22.525773",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5817,
      "client_name": "YSABEL CRISTINA CORREA SARMIENTO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04120349986",
      "client_email": "YSABELCORREA7@GMAIL.COM",
      "address": "CALLE 4B CASA NRO 30 CONJUNTO RESIDENCIAL PANTIN ROSARIO DE PAYA",
      "client_identification": "V19791462",
      "nap_box_name": "CTO-00134",
      "created_at": "2024-07-30T14:38:13.718871",
      "service_detail": {
        "id": 9269,
        "ip": "172.22.233.2",
        "mac": "TPLGBA687922",
        "serial": "TPLGBA687922",
        "queue": "queue1",
        "interface": "VLAN229_PANTIN",
        "created_at": "2025-07-26T16:08:40.630995",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5818,
      "client_name": "JESUS HUMBERTO ITURBE MARQUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124827343",
      "client_email": "JESUSHUMBERTO5380@GMAIL.COM",
      "address": "CALLE PRINCIPAL CASA NRO 14 BARRIO SAMAN TARAZONERO II MANZANA E TURMERO",
      "client_identification": "V6318834",
      "nap_box_name": "93",
      "created_at": "2024-07-30T14:39:18.555297",
      "service_detail": {
        "id": 4573,
        "ip": "172.20.122.2",
        "mac": "TPLGF5CB0701",
        "serial": "TPLGF5CB0701",
        "queue": "Plan_107915_1574_WispHub",
        "interface": "VLAN100_OLTs",
        "created_at": "2024-08-11T16:55:18.876705",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5819,
      "client_name": "JOSE ANTONIO BAETA DOMINGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04128913227",
      "client_email": "JOSEABAETA21@GMAIL.COM",
      "address": "CALLE MANZANA C2 CASA NRO 10 SECTOR SAMAN TARAZONERO II TURMERO",
      "client_identification": "V21445192",
      "nap_box_name": "115",
      "created_at": "2024-07-30T14:45:44.658606",
      "service_detail": {
        "id": 4572,
        "ip": "172.20.102.2",
        "mac": "TPLGF5CB0A12",
        "serial": "TPLGF5CB0A12",
        "queue": "Plan_92192_1574_WispHub",
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2024-08-11T16:51:05.425320",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5820,
      "client_name": "ANGEL DANIEL ASCANIO PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04125840007",
      "client_email": "2802376@GMAIL.COM",
      "address": "CALLE 5A CASA NRO20 URB PANTIN ROSARIO DE PAYA",
      "client_identification": "V28023768",
      "nap_box_name": "CTO-00135",
      "created_at": "2024-07-30T14:51:54.042847",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5821,
      "client_name": "EDINSON WILKER ARCILA REVERON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128903053",
      "client_email": "EDINSONARCILA5@GMAIL.COM",
      "address": "CALLE 5A CASA NRO 10 URB PANTIN ROSARIO DE PAYA",
      "client_identification": "V28432458",
      "nap_box_name": "CTO-00135",
      "created_at": "2024-07-30T14:53:50.835302",
      "service_detail": {
        "id": 6009,
        "ip": "172.22.218.2",
        "mac": "TPLGBA6874B9",
        "serial": "TPLGBA6874B9",
        "queue": "Plan_161905_30183_WispHub",
        "interface": "VLAN229_PANTIN",
        "created_at": "2024-08-22T09:03:33.630355",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5822,
      "client_name": "REMIGIO ANTONIO FIGUERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Los Caobos",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243004535",
      "client_email": "REMIGIOFIGUERA70@GMAIL.COM",
      "address": "CALLE 1 NRO14 SECTOR LOS CAOBOS TURMERO",
      "client_identification": "V4813840",
      "nap_box_name": "CTO-0225",
      "created_at": "2024-07-30T14:57:25.821826",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5823,
      "client_name": "AMANDA  VICTORIA SORIANO GONZALEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Valle Paraiso",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243077416",
      "client_email": "YURAIMAG1970@GMAIL.COM",
      "address": "AV PRINCIPAL DE SAN PABLO EDIF MILAN  PLAZA  PISO APT 07 VALLE PARAISO TURMERO",
      "client_identification": "V28317053",
      "nap_box_name": "144",
      "created_at": "2024-07-30T15:03:07.346566",
      "service_detail": {
        "id": 4523,
        "ip": "172.20.110.2",
        "mac": "TPLGF5CB0700",
        "serial": "TPLGF5CB0700",
        "queue": "Plan_92291_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-08-10T22:55:37.672340",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5824,
      "client_name": "PEDRO ALEJANDRO BARRIOS CASTILLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144911198",
      "client_email": "PEDROALE_B@HOTMAIL.COM",
      "address": "CALLE 3A CASA NRO 4 URB PANTIN ROSARIO DE PAYA",
      "client_identification": "V21272776",
      "nap_box_name": "CTO-00127 DOS",
      "created_at": "2024-07-30T15:18:27.922912",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5826,
      "client_name": "YOSMAR YOSELIN HERNANDEZ GARCIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Guanarito",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124501190",
      "client_email": "AYHERNANDEZG@GMAIL.COM",
      "address": "CALLE LA ESTRELLA  CASA NRO 19  BARRIO GUANARITO TURMERO",
      "client_identification": "V13625210",
      "nap_box_name": "231",
      "created_at": "2024-07-30T15:20:37.376005",
      "service_detail": {
        "id": 6005,
        "ip": "172.23.15.2",
        "mac": "TPLGBA6874B3",
        "serial": "TPLGBA6874B3",
        "queue": "Plan_92194_15811_WispHub",
        "interface": "VLAN232_GUANARITO_OLT2",
        "created_at": "2024-08-22T08:57:44.942618",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5827,
      "client_name": "NAZARETH JULIANNERS SANCHEZ SANCHEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243342983",
      "client_email": "NAJULIANNE@GMAIL.COM",
      "address": "CALLE 4 CASA NRO 37 SECTOR LA CASONA I TURMERO",
      "client_identification": "V26350502",
      "nap_box_name": "44",
      "created_at": "2024-07-30T15:21:38.214038",
      "service_detail": {
        "id": 11792,
        "ip": "172.20.137.2",
        "mac": "TPLGF5CB0AE5",
        "serial": "TPLGF5CB0AE5",
        "queue": null,
        "interface": "VLAN109_CASONA_1",
        "created_at": "2026-02-27T11:14:38.221439",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5828,
      "client_name": "ISABEL LILIANA LUQUE LOMELLI",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04149455588",
      "client_email": "ALEXKAGRA@HOTMAIL.COM",
      "address": "CALLE 2B CASA NRO 56 URB PANTIN ROSARIO DE PAYA",
      "client_identification": "V14780571",
      "nap_box_name": "CTO-00126",
      "created_at": "2024-07-30T15:22:51.818165",
      "service_detail": {
        "id": 6001,
        "ip": "172.22.148.2",
        "mac": "TPLGBA687AE5",
        "serial": "TPLGBA687AE5",
        "queue": "Plan_161889_30183_WispHub",
        "interface": "VLAN229_PANTIN",
        "created_at": "2024-08-22T08:36:06.427385",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5829,
      "client_name": "OMAR JESUS TORREALBA REYNA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Narayola II",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04166464723",
      "client_email": "OMARJETOR@GMAIL.COM",
      "address": "AV INTERCOMUNAL TURMEROEDIF 2 PISO 3 APT 3 NARAYOLA II",
      "client_identification": "V12335610",
      "nap_box_name": "CTO-0522",
      "created_at": "2024-07-30T15:23:15.488344",
      "service_detail": {
        "id": 13057,
        "ip": "172.21.12.2",
        "mac": "TP:LG:B9:54:F7:27",
        "serial": "TPLGB954F727",
        "queue": null,
        "interface": "VLAN117_NARAYOLA",
        "created_at": "2026-09-21T15:37:24.938449",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5830,
      "client_name": "NEIDA RAMONA RUIZ GARCES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243090098",
      "client_email": "RUIZNEIDA.31@GMAIL.COM",
      "address": "CALLE 3A CASA NRO 25 PANTIN TURMERO",
      "client_identification": "V14813232",
      "nap_box_name": "CTO-00127 DOS",
      "created_at": "2024-07-30T15:25:04.070515",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5831,
      "client_name": "JOSE LUIS JUNIOR GAZZOTTI TORRES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04145873458",
      "client_email": "JOSEGAZZOTTI@HOTMAIL.COM",
      "address": "VDA 8 MANZANA I CASA NRO 17 URB SAMAN TARAZONERO II",
      "client_identification": "V18164990",
      "nap_box_name": "119",
      "created_at": "2024-07-30T15:25:22.351324",
      "service_detail": {
        "id": 11536,
        "ip": "172.21.19.2",
        "mac": "TPLGF5CB09EC",
        "serial": "TPLGF5CB09EC",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2026-02-07T12:05:18.952123",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5832,
      "client_name": "SCHEMELINY IRLANDA OLIVEROS NARANJO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243660214",
      "client_email": "LORENMAR2007@GMAIL.COM",
      "address": "CALLE 3B CASA NRO 9 NURB HACIENDA PANTIN ROSARIO DE PAYA",
      "client_identification": "V9690869",
      "nap_box_name": "CTO-00127 DOS",
      "created_at": "2024-07-30T15:34:01.528438",
      "service_detail": {
        "id": 5999,
        "ip": "172.22.249.2",
        "mac": "TPLGBA687B99",
        "serial": "TPLGBA687B99",
        "queue": "Plan_161900_30183_WispHub",
        "interface": "VLAN229_PANTIN",
        "created_at": "2024-08-22T08:30:20.770195",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5833,
      "client_name": "RITZY ROZALYNN GALINDO CASTRO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144555856",
      "client_email": "wavirogi21@gmail.com",
      "address": "CALLE 2A CADA NRO 17 URB  PANTIN  ROSARIO DE PAYA",
      "client_identification": "V14577933",
      "nap_box_name": "CTO-00110",
      "created_at": "2024-07-30T15:47:43.024484",
      "service_detail": {
        "id": 13023,
        "ip": "172.17.1.250",
        "mac": "TP:LG:BA:68:75:A1",
        "serial": "TPLGBA6875A1",
        "queue": null,
        "interface": "VLAN229_PANTIN",
        "created_at": "2026-09-15T20:07:10.534543",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5834,
      "client_name": "LURBY BETSENY MONASTERIO ROSALES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Callejon 17",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243654308",
      "client_email": "LURBYMONASTERIO@GMAIL.COM",
      "address": "CALLE 17, CASA #23 ANTIGUA HACIENDA PAYA TURMERO - ARAGUA 2115",
      "client_identification": "V12991539",
      "nap_box_name": "CTO-00183",
      "created_at": "2024-07-30T15:51:39.648347",
      "service_detail": {
        "id": 10109,
        "ip": "172.22.240.2",
        "mac": "TPLGBA687A8A",
        "serial": "TPLGBA687A8A",
        "queue": null,
        "interface": "VLAN201_AHP2_OLT1",
        "created_at": "2025-11-13T17:30:52.313860",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5835,
      "client_name": "ORLANDO NICOLAS TURMERO VILLEGAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Marina Caribe",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04144608977",
      "client_email": "OTURMERO@GMAIL.COM",
      "address": "CALLE C NRO 27 MARINA CARIBE CASCO TURMERO",
      "client_identification": "V12310752",
      "nap_box_name": "CTO-0639",
      "created_at": "2024-07-30T15:54:05.994496",
      "service_detail": {
        "id": 5897,
        "ip": "172.28.17.2",
        "mac": "TPLGBA6878B1",
        "serial": "TPLGBA6878B1",
        "queue": "Plan_112654_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-08-21T10:23:17.723367",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5836,
      "client_name": "JOSE FRANCISCO BAUZA QUEZADA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vista Hermosa",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04128909707",
      "client_email": "BAUZAQUEZADA@HOTMAIL.COM",
      "address": "AV PRINCIPAL DE ROSARIO DE PAYA QTA NRO 67 URB VISTA HERMOSA  TURMERO",
      "client_identification": "V8588190",
      "nap_box_name": "237",
      "created_at": "2024-07-30T15:57:05.731313",
      "service_detail": {
        "id": 5895,
        "ip": "172.22.132.2",
        "mac": "TPLGBA687B70",
        "serial": "TPLGBA687B70",
        "queue": "Plan_161889_30183_WispHub",
        "interface": "VLAN230_VISTA_HERMOSA",
        "created_at": "2024-08-21T10:21:07.576644",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5837,
      "client_name": "JOSE GUILLERMO TOVAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vista Hermosa",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04125123891",
      "client_email": "JOSETOVAR117@HOTMAIL.COM",
      "address": "CALLE EL ROSARIO CASA NRO 20 SECTOR VISTA HERMOSA",
      "client_identification": "V11754084",
      "nap_box_name": "CTO-00058 DOS",
      "created_at": "2024-07-30T16:00:46.125838",
      "service_detail": {
        "id": 11985,
        "ip": "172.22.133.2",
        "mac": "TPLGBA687BD2",
        "serial": "TPLGBA687BD2",
        "queue": null,
        "interface": "VLAN230_VISTA_HERMOSA",
        "created_at": "2026-03-06T12:51:02.114152",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5838,
      "client_name": "ELIAS DANIEL NORIEGA  CORTES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vista Hermosa",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04140500380",
      "client_email": "DANIELNORIEGA185@GMAIL.COM",
      "address": "CALLE EL ROSARIO CASA NRO 10 SECTOR  VISTA HERMOSA ROSARIO DE PAYA",
      "client_identification": "V13859839",
      "nap_box_name": "CTO-00057 DOS",
      "created_at": "2024-07-30T16:17:34.753750",
      "service_detail": {
        "id": 11990,
        "ip": "172.22.191.2",
        "mac": "TPLGBA687B89",
        "serial": "TPLGBA687B89",
        "queue": null,
        "interface": "VLAN230_VISTA_HERMOSA",
        "created_at": "2026-03-06T12:58:48.162919",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5839,
      "client_name": "MISLEYDA COROMOTO COLMENARES CORDERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vista Hermosa",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124358629",
      "client_email": "MISLEYDA.COLMENARES@GMAIL.COM",
      "address": "CALLE EL ROSARIO CASA NRO 47 SECTOR  VISTA HERMOSA ROSARIO DE PAYA TURMERO",
      "client_identification": "V15129331",
      "nap_box_name": "CTO-00058",
      "created_at": "2024-07-30T16:19:53.287832",
      "service_detail": {
        "id": 13090,
        "ip": "172.22.129.2",
        "mac": "JM:KG:C9:C1:4D:DA",
        "serial": "JMKGC9C14DDA",
        "queue": null,
        "interface": "VLAN230_VISTA_HERMOSA",
        "created_at": "2026-09-28T17:00:47.454681",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5840,
      "client_name": "MARIA ELENA MOSQUEDA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04243378377",
      "client_email": "JOSEAHIDALGO63@GMAIL.COM",
      "address": "CALLE 02 CASA NRO 66 URB MATA CABALLO  ROSARIO DE PAYA",
      "client_identification": "V15308322",
      "nap_box_name": "CTO-00565 DOS",
      "created_at": "2024-07-30T16:23:59.153402",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5841,
      "client_name": "KEYDIANA PAOLA FRANCO ROMAN",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04125988093",
      "client_email": "KEYDIANAFRANCO24@GMAIL.COM",
      "address": "VDA 5 CASA  MANZANA E NRO 12 URB  SAMAN  TARAZONERO II EL MACARO",
      "client_identification": "V25349578",
      "nap_box_name": "273",
      "created_at": "2024-07-30T16:27:49.210441",
      "service_detail": {
        "id": 9941,
        "ip": "172.22.234.2",
        "mac": "TPLGBA687691",
        "serial": "TPLGBA687691",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2025-11-11T09:55:13.609043",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5842,
      "client_name": "DILEYDYS DAYERLIN MARTINEZ PONCE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vista Hermosa",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144658585",
      "client_email": "MARTINEZPD.15@GMAIL.COM",
      "address": "CALLE LAS MANDARINAS CASA NRO 59 SECTOR VISTA HERMOSA ROSARIO DE PAYA",
      "client_identification": "V21534442",
      "nap_box_name": "CTO-00060 DOS",
      "created_at": "2024-07-30T16:34:31.293737",
      "service_detail": {
        "id": 12014,
        "ip": "172.22.137.2",
        "mac": "TPLGBA687B80",
        "serial": "TPLGBA687B80",
        "queue": null,
        "interface": "VLAN230_VISTA_HERMOSA",
        "created_at": "2026-03-09T12:53:22.463117",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5843,
      "client_name": "MARIA NELLY WANDURRAGA CORREDOR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vista Hermosa",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124669542",
      "client_email": "MWANDURRAGACORREDOR@GMAIL.COM",
      "address": "CALLE LAS MANDARINAS CASA NRO 56 SECTOR  VISTA  HERMOSA ROSARIO DE PAYA",
      "client_identification": "V9640630",
      "nap_box_name": "CTO-00057 DOS",
      "created_at": "2024-07-30T16:37:35.321897",
      "service_detail": {
        "id": 12012,
        "ip": "172.22.134.2",
        "mac": "TPLGBA687BA8",
        "serial": "TPLGBA687BA8",
        "queue": null,
        "interface": "VLAN230_VISTA_HERMOSA",
        "created_at": "2026-03-09T12:47:59.145251",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5844,
      "client_name": "MARIELYS CAROLINA HERNANDEZ GONZALEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vista Hermosa",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243157163",
      "client_email": "MARIELYSHERNANDEZ0905@GMAIL.COM",
      "address": "CALLE  LAS MANDARINAS CASA NRO 54 URB VISTA HERMOSA ROSARIO DE PAYA",
      "client_identification": "V15993527",
      "nap_box_name": "CTO-00060 DOS",
      "created_at": "2024-07-30T16:40:18.280922",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5845,
      "client_name": "JESUS ALBERTO GARCES MENDOZA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vista Hermosa",
      "plan": {
        "id": 19,
        "name": "RECURRENTE RESIDENCIAL PLAN 1GB",
        "cost": "74.70",
        "code": "FOR1GB",
        "profile": "1000M/1000M"
      },
      "client_mobile": "04144597429",
      "client_email": "JESUSGARCES54@HOTMAIL.COM",
      "address": "CALLE EL ROSARIO CASA NRO 29 URB VISTA HERMOSA ROSARIO DE PAYA",
      "client_identification": "V9683402",
      "nap_box_name": "CTO-00057 DOS",
      "created_at": "2024-07-30T16:44:28.231362",
      "service_detail": {
        "id": 11986,
        "ip": "172.22.130.2",
        "mac": "TPLGBA687678",
        "serial": "TPLGBA687678",
        "queue": null,
        "interface": "VLAN230_VISTA_HERMOSA",
        "created_at": "2026-03-06T12:52:45.516360",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5846,
      "client_name": "AUDIS CELIS VERGEL",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vista Hermosa",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128958361",
      "client_email": "AUDISCELIS@HOTMAIL.COM",
      "address": "CALLE LAS MANDARINAS CASA NRO 67-A SECTOR  VISTA HERMOSA ROSARIO DE PAYA",
      "client_identification": "V24419041",
      "nap_box_name": "CTO-00059",
      "created_at": "2024-07-30T16:46:30.633686",
      "service_detail": {
        "id": 12016,
        "ip": "172.22.135.2",
        "mac": "TPLGBA687B88",
        "serial": "TPLGBA687B88",
        "queue": null,
        "interface": "VLAN230_VISTA_HERMOSA",
        "created_at": "2026-03-09T14:16:39.076372",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5847,
      "client_name": "RAFAEL ELOY MORONTA OSORIO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vista Hermosa",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04127766617",
      "client_email": "REMORONTA24@GMAIL.COM",
      "address": "CALLE EL ROSARIO CASA NRO 8-9 SECTOR VISTA HERMOSA ROSARIO DE PAYA",
      "client_identification": "V27654867",
      "nap_box_name": "CTO-00057 DOS",
      "created_at": "2024-07-30T16:48:24.364940",
      "service_detail": {
        "id": 11987,
        "ip": "172.22.138.2",
        "mac": "TPLGBA687B2D",
        "serial": "TPLGBA687B2D",
        "queue": null,
        "interface": "VLAN230_VISTA_HERMOSA",
        "created_at": "2026-03-06T12:54:41.999896",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5848,
      "client_name": "ESTEFFANY PAOLA ACEVEDO ROMERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vista Hermosa",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04126583892",
      "client_email": "ESTEFFANY.ACEVEDOROMERO@GMAIL.COM",
      "address": "CALLE EL ROSARIO CASA NRO 12 SECTOR VISTA HERMOSA  ROSARIO DE PAYA",
      "client_identification": "V26679613",
      "nap_box_name": "CTO-00057",
      "created_at": "2024-07-30T16:50:37.152629",
      "service_detail": {
        "id": 11991,
        "ip": "172.22.139.2",
        "mac": "TPLGBA6878B7",
        "serial": "TPLGBA6878B7",
        "queue": null,
        "interface": "VLAN230_VISTA_HERMOSA",
        "created_at": "2026-03-06T13:02:09.187905",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5849,
      "client_name": "JORGE ARMANDO YONUSG",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vista Hermosa",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04128952618",
      "client_email": "JORGEYONUSG@GMAIL.COM",
      "address": "CALLE EL ROSARIO CASA NRO 36 URB  VISTA HERMOSA ROSARIO DE PAYA",
      "client_identification": "V15962124",
      "nap_box_name": "CTO-00057 DOS",
      "created_at": "2024-07-30T16:52:30.588813",
      "service_detail": {
        "id": 11979,
        "ip": "172.22.141.2",
        "mac": "TPLGBA687B86",
        "serial": "TPLGBA687B86",
        "queue": null,
        "interface": "VLAN230_VISTA_HERMOSA",
        "created_at": "2026-03-06T12:02:21.195775",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5850,
      "client_name": "RAQUEL ANGELINA NIEVES CARUCCI",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vista Hermosa",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124004551",
      "client_email": "RAQUEL-N2525@HOTMAIL.COM",
      "address": "CALLE LAS MANDARINAS CASA NRO 80 SECTOR VISTA HERMOSA ROSARIO DE PAYA",
      "client_identification": "V14664830",
      "nap_box_name": "CTO-00059",
      "created_at": "2024-07-30T16:54:23.387670",
      "service_detail": {
        "id": 12015,
        "ip": "172.22.131.2",
        "mac": "TPLGBA687BC8",
        "serial": "TPLGBA687BC8",
        "queue": null,
        "interface": "VLAN230_VISTA_HERMOSA",
        "created_at": "2026-03-09T14:14:00.600807",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5851,
      "client_name": "AILECSIS RAMONA PALACIOS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121488521",
      "client_email": "EDWAILLGDOSS0613@HOTMAIL.COM",
      "address": "CALLE RIVAS EDIF TORRE 19 PISO 3 APT 4 URB EL NISPERO TURMERO",
      "client_identification": "V16849386",
      "nap_box_name": "CTO-00464 DOS",
      "created_at": "2024-07-30T16:57:19.134600",
      "service_detail": {
        "id": 5911,
        "ip": "172.23.19.2",
        "mac": "TPLGBA687AC7",
        "serial": "TPLGBA687AC7",
        "queue": "Plan_112654_15811_WispHub",
        "interface": "VLAN209_ZAMORA_OLT1",
        "created_at": "2024-08-21T11:34:20.607155",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5852,
      "client_name": "BRENDA YULIBETH TORRES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Concepcion",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144496233",
      "client_email": "APARTAMENTOBRENDA59@GMAIL.COM",
      "address": "CONCEPCION EDIFICIO TORRE 12 PISO 2 APT 01 TURMERO",
      "client_identification": "V16765523",
      "nap_box_name": "0326 DOS",
      "created_at": "2024-07-30T17:00:35.901287",
      "service_detail": {
        "id": 9364,
        "ip": "172.22.224.2",
        "mac": "TPLGBA687B9C",
        "serial": "TPLGBA687B9C",
        "queue": "queue1",
        "interface": "VLAN111_CONCEPCION",
        "created_at": "2025-08-13T14:44:38.579182",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5853,
      "client_name": "GENESIS MARIANA MONTILLA GARCIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Laguna Plaza",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04241419004",
      "client_email": "MARIA1961MONTILLA@HOTMAIL.COM",
      "address": "CALLE NEGRO PRIMERO EDIF 16 PISO 2 PH APT 16-01 URB LAGUNA PLAZA TURMERO",
      "client_identification": "V18609548",
      "nap_box_name": "CTO-00239",
      "created_at": "2024-07-31T09:38:57.427249",
      "service_detail": {
        "id": 6680,
        "ip": "172.22.230.2",
        "mac": "TPLGBA687A58",
        "serial": "TPLGBA687A58",
        "queue": "Plan_92306_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-09-18T08:43:57.594958",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5854,
      "client_name": "EMIL YNMACULADA CONTRERAS MELLADO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villeguita",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04145653288",
      "client_email": "EMILCONTRERAS1965@GMAIL.COM",
      "address": "CALLE PEÑALVER CASA NRO 46 SECTOR GUANARITO TURMERO",
      "client_identification": "V8732160",
      "nap_box_name": "235",
      "created_at": "2024-07-31T09:41:36.293662",
      "service_detail": {
        "id": 5914,
        "ip": "172.22.231.2",
        "mac": "TPLGBA687B9B",
        "serial": "TPLGBA687B9B",
        "queue": "Plan_107916_15811_WispHub",
        "interface": "VLAN100_OLTs",
        "created_at": "2024-08-21T11:38:35.032264",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5855,
      "client_name": "EMILE YOHANA MONTIEL MARTINEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Antonio Jose de Sucre",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121484084",
      "client_email": "EMILEYOHANA@GMAIL.COM",
      "address": "CALLE 25 DE AGOSTO NRO 27 ANTONIO JOSE DE SUCRE EL MACARO TURMERO",
      "client_identification": "V19132464",
      "nap_box_name": "123",
      "created_at": "2024-07-31T10:01:05.794136",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5856,
      "client_name": "SONERY ALEJANDRA DIAZ BASTIDAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villeguita",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124927320",
      "client_email": "JAIMELEON62043@GMAIL.COM",
      "address": "CALLE MEDINA  ANGARITA  CASA  NRO 04 SECTOR  GUANARITO",
      "client_identification": "V12994537",
      "nap_box_name": "235",
      "created_at": "2024-07-31T10:02:46.408401",
      "service_detail": {
        "id": 5915,
        "ip": "172.22.219.2",
        "mac": "TPLGBA687823",
        "serial": "TPLGBA687823",
        "queue": "Plan_107915_15811_WispHub",
        "interface": "VLAN100_OLTs",
        "created_at": "2024-08-21T11:40:20.689778",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5857,
      "client_name": "YOLANDA GABRIELA MARTINEZ CUENCA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Antonio Jose de Sucre",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04123868633",
      "client_email": "YMARTINEZCUENCA@GMAIL.COM",
      "address": "CALLE 25 DE AGOSTO CASA NRO 48 SECTOR ANTONIO JOSE DE SUCRE  EL MACARO",
      "client_identification": "V18898346",
      "nap_box_name": "122",
      "created_at": "2024-07-31T10:05:06.633142",
      "service_detail": {
        "id": 5916,
        "ip": "172.22.236.2",
        "mac": "TPLGBA687C21",
        "serial": "TPLGBA687C21",
        "queue": "Plan_92306_1574_WispHub",
        "interface": "VLAN101_AJS",
        "created_at": "2024-08-21T11:42:13.263361",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5858,
      "client_name": "JAVIER ARCANGEL MORALES MACHADO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villeguita",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243504379",
      "client_email": "MORALESJAVIER25.10@GMAIL.COM",
      "address": "CALLE PPL C/C DEMOCRACIA CASA NRO 5-1 SECTOR  VILLEGUITA TURMERO",
      "client_identification": "V9436576",
      "nap_box_name": "212",
      "created_at": "2024-07-31T10:07:18.054059",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5859,
      "client_name": "ABASTO Y LICORERIA SANTIAGO 2018 CA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Antonio Jose de Sucre",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243248835",
      "client_email": "SANDOVAL@GMAIL.COM",
      "address": "CTRA  TURMERO MARACAY  CALLE HENRY PITIER LOCAL NRO 4 SECTOR EL MACARO  ANTONIO JOSE DE SUCRE",
      "client_identification": "J412057057",
      "nap_box_name": "86 DOS",
      "created_at": "2024-07-31T10:09:26.354916",
      "service_detail": {
        "id": 6330,
        "ip": "172.23.27.2",
        "mac": "TPLGBA68758A",
        "serial": "TPLGBA68758A",
        "queue": "Plan_127996_1574_WispHub",
        "interface": "VLAN101_AJS",
        "created_at": "2024-08-24T09:29:25.013142",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5860,
      "client_name": "MOISES ABRAHAM BELLORIN FLORES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Concepcion",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243631234",
      "client_email": "MOISESBELLORIN80@GMAIL.COM",
      "address": "AV PRINCIPAL EDIF  LA CONCEPCION TORRE 13 PISO 2 APT 1 TURMERO",
      "client_identification": "V30865878",
      "nap_box_name": "0326 DOS",
      "created_at": "2024-07-31T10:11:19.179026",
      "service_detail": {
        "id": 5971,
        "ip": "172.22.197.2",
        "mac": "TPLGBA6878F2",
        "serial": "TPLGBA6878F2",
        "queue": "queue1",
        "interface": "VLAN111_CONCEPCION",
        "created_at": "2024-08-21T15:30:53.259036",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5862,
      "client_name": "STIVEN SANTIAGO VELA LOPEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villeguita",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04129107973",
      "client_email": "VELASSSTIVEN@GMAIL.COM",
      "address": "CALLE PRINCIPAL CASA NRO 23-D URB VILLEGUITA TURMERO",
      "client_identification": "V27646570",
      "nap_box_name": "212",
      "created_at": "2024-07-31T10:16:26.051306",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5863,
      "client_name": "ANGELICA MARIA MALDONADO RIVERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04243535279",
      "client_email": "ANGELICAMARIAMALDONADO1@GMAIL.COM",
      "address": "Calle 20 de agosto casa 59 urb antonio jose de sucre TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V20336989",
      "nap_box_name": "CTO-00064",
      "created_at": "2024-07-31T10:18:53.720753",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5864,
      "client_name": "ROSALINDA DEL CARMEN QUERALEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04127760290",
      "client_email": "ROSQUERALEZ70@GMAIL.COM",
      "address": "CALLE MANZANA B-9 CASA NRO 06 SECTOR SAMAN TARAZONERO II",
      "client_identification": "V11699816",
      "nap_box_name": "281",
      "created_at": "2024-07-31T10:20:32.964129",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5865,
      "client_name": "DIANA CAROLINA SEIJAS MARTINEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04129219644",
      "client_email": "DIANASEIJAS@HOTMAIL.ES",
      "address": "CALLE MANZANA B-9 CASA NRO 06 SECTOR SAMAN TARAZONERO II",
      "client_identification": "V20893868",
      "nap_box_name": "510 DOS",
      "created_at": "2024-07-31T10:23:13.761271",
      "service_detail": {
        "id": 5922,
        "ip": "172.22.196.2",
        "mac": "TPLGBA687A6C",
        "serial": "TPLGBA687A6C",
        "queue": "Plan_92306_1574_WispHub",
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2024-08-21T11:55:41.912249",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5866,
      "client_name": "MISAEL SIMON PENA RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Guanarito",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243404384",
      "client_email": "ARELYS.LEON.A@HOTMAIL.COM",
      "address": "CALLE LA ESTRELLA  CASA NRO 15 SECTOR  GUANARITO TURMERO",
      "client_identification": "V8586988",
      "nap_box_name": "231",
      "created_at": "2024-07-31T10:24:54.057028",
      "service_detail": {
        "id": 5923,
        "ip": "172.22.171.2",
        "mac": "TPLGBA687787",
        "serial": "TPLGBA687787",
        "queue": "Plan_92194_15811_WispHub",
        "interface": "VLAN232_GUANARITO_OLT2",
        "created_at": "2024-08-21T11:57:42.160427",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5867,
      "client_name": "ELIVAN YAJAIRA CAMPOS MAYORA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04244457204",
      "client_email": "ELIVANCAMPOS76@GMAIL.COM",
      "address": "CALLE MIRANDA EDIFICIO LA VENEZOLANA PISO 1 APARTAMENTO NRO 2 TURMERO",
      "client_identification": "V13200459",
      "nap_box_name": "CTO-00072",
      "created_at": "2024-07-31T10:26:20.376999",
      "service_detail": {
        "id": 9724,
        "ip": "172.22.168.2",
        "mac": "TPLGBA687BED",
        "serial": "TPLGBA687BED",
        "queue": null,
        "interface": "VLAN200_OLTs",
        "created_at": "2025-11-10T11:09:54.212376",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5868,
      "client_name": "FRANCISMAR CAROLINA ROJAS DE SILVA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Valle Paraiso",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04169616410",
      "client_email": "FRANCISMARCROJAS10@GMAIL.COM",
      "address": "CALLE E CASA NRO 14 URB VALLE PARAISO",
      "client_identification": "V27646784",
      "nap_box_name": "644",
      "created_at": "2024-07-31T10:28:40.924409",
      "service_detail": {
        "id": 5951,
        "ip": "172.22.185.2",
        "mac": "TPLGBA687FDF",
        "serial": "TPLGBA687FDF",
        "queue": "Plan_92312_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-08-21T13:57:46.396960",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5869,
      "client_name": "INVERSIONES CRISTIAN LOPEZ FP",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04128902343",
      "client_email": "CRISTIANLOPEZ7777@HOTMAIL.COM",
      "address": "CASCO DE TURMERO CALLE MARIÑO  COMUNA 13 DE ENERO LOCAL NRO 1",
      "client_identification": "V212038780",
      "nap_box_name": "CTO-00256",
      "created_at": "2024-07-31T10:43:30.782174",
      "service_detail": {
        "id": 13164,
        "ip": "172.23.184.2",
        "mac": "GP:ON:00:97:B5:56",
        "serial": "GPON0097B556",
        "queue": null,
        "interface": "VLAN200_OLTs",
        "created_at": "2026-10-14T12:00:53.093652",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5870,
      "client_name": "JOSE GABRIEL MUNOZ BUSTOS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 43,
        "name": "RECURRENTE RESIDENCIAL PLAN 650M",
        "cost": "46.00",
        "code": "FOR650M",
        "profile": "650M/650M"
      },
      "client_mobile": "04243284125",
      "client_email": "JOSEGABRIELBUSTOS64@GMAIL.COM",
      "address": "CALLE 09 CASA NRO 602-A URB MATA CABALLO ROSARIO DE PAYA",
      "client_identification": "V25880220",
      "nap_box_name": "160",
      "created_at": "2024-07-31T11:01:17.846479",
      "service_detail": {
        "id": 10089,
        "ip": "172.22.170.2",
        "mac": "TPLGB68B504E",
        "serial": "TPLGB68B504E",
        "queue": null,
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2025-11-13T11:22:35.701462",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5871,
      "client_name": "REYNALDO JOSE PEDROSO PINTO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Valle Paraiso",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04122929275",
      "client_email": "TRAFICREX@GMAIL.COM",
      "address": "CALLE PRINCIPAL CASA NRO 10 URB VALLE PARAISO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V25527559",
      "nap_box_name": "CTO-0643",
      "created_at": "2024-07-31T11:06:12.402426",
      "service_detail": {
        "id": 4137,
        "ip": "172.27.183.2",
        "mac": "HWTCD1A2ED9A",
        "serial": "HWTCD1A2ED9A",
        "queue": "Plan_153953_15811_WispHub",
        "interface": "VLAN227_V_PARAISO_OLT1",
        "created_at": "2024-07-31T11:08:45.794962",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5872,
      "client_name": "LILIANA MUNOZ LOPEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04122094064",
      "client_email": "LOPEZ0310MUOZ@GMAIL.COM",
      "address": "CALLE 3 CASA NRO 33 URB PANTIN ROSARIO DE PAYA TURMERO",
      "client_identification": "V15457044",
      "nap_box_name": "CE-00043",
      "created_at": "2024-07-31T11:14:22.398093",
      "service_detail": {
        "id": 11541,
        "ip": "172.22.208.2",
        "mac": "TPLGBA68764A",
        "serial": "TPLGBA68764A",
        "queue": null,
        "interface": "VLAN229_PANTIN",
        "created_at": "2026-02-07T13:03:20.161776",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5873,
      "client_name": "VICTOR HUGO GARCIA IGUARO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Callejon 17",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04243182421",
      "client_email": "VICTORGAR26@GMAIL.COM",
      "address": "CALLE DOMINGO DE TOVAR CASA PARCELA NRO 29 URB ANTIGUA HACIENDA DE PAYA",
      "client_identification": "V18778223",
      "nap_box_name": "CTO-00183",
      "created_at": "2024-07-31T11:17:29.971131",
      "service_detail": {
        "id": 9983,
        "ip": "172.22.113.2",
        "mac": "TPLGBA6873E8",
        "serial": "TPLGBA6873E8",
        "queue": null,
        "interface": "VLAN203_C17_OLT2",
        "created_at": "2025-11-11T12:51:05.157714",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5874,
      "client_name": "ARTURO JOSE FELIPE OCHOA CONDE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona I",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128912026",
      "client_email": "OCHOAARTURO2021@GMAIL.COM",
      "address": "CALLE 8 CASA NRO 17 URB LA CASONA I TURMERO",
      "client_identification": "V28393947",
      "nap_box_name": "139",
      "created_at": "2024-07-31T12:52:32.936863",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5875,
      "client_name": "JOEL ALEXANDER CARRILLO SILVA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Los Caobos",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04129671650",
      "client_email": "DALLACAROLINA5@GMAIL.COM",
      "address": "CALLE PRINCIPAL CASA NRO 6 SECTOR LOS CAOBOS LA  JULIA TURMERO",
      "client_identification": "V27864700",
      "nap_box_name": "CTO-0225",
      "created_at": "2024-07-31T13:06:16.592532",
      "service_detail": {
        "id": 4509,
        "ip": "172.20.145.2",
        "mac": "TPLGF5CB0A41",
        "serial": "TPLGF5CB0A41",
        "queue": "Plan_132787_24341_WispHub",
        "interface": "VLAN100_OLTs",
        "created_at": "2024-08-10T13:28:33.708495",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5876,
      "client_name": "GENESIS CAROLINA DOMINGUEZ SIFONTES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "SUSPENDIDO_RESIDENCIAL",
      "status_name": "Suspendido",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Laguna Plaza",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04120827102",
      "client_email": "DGENESIS264@GMAIL.COM",
      "address": "CALLE NEGRO PRIMERO EDIF 11 PISO 1 APT PH1 LAGUNA PLAZA TURMERO",
      "client_identification": "V23538870",
      "nap_box_name": "3",
      "created_at": "2024-07-31T13:16:08.754666",
      "service_detail": {
        "id": 12205,
        "ip": "172.30.36.2",
        "mac": "TPLGF5CB06D1",
        "serial": "TPLGF5CB06D1",
        "queue": null,
        "interface": "VLAN216_LAGUNA_PLAZA_OLT1",
        "created_at": "2026-03-30T10:39:49.370556",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5877,
      "client_name": "ANA LUISA RODRIGUEZ VERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04243757011",
      "client_email": "LUISARODV@HOTMAIL.COM",
      "address": "VDA 2 MANZANA F-01 CASA NRO 40 URB SAMAN TARAZONERO II TURMERO",
      "client_identification": "V10685749",
      "nap_box_name": "93",
      "created_at": "2024-07-31T13:18:19.130266",
      "service_detail": {
        "id": 9863,
        "ip": "172.20.141.2",
        "mac": "TPLGF5CB02B2",
        "serial": "TPLGF5CB02B2",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2025-11-10T18:40:52.382608",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5878,
      "client_name": "ARTURO JOSE BORGO PADRON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Huerta Los Pajaros",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04243000221",
      "client_email": "ARTUROBORGO@GMAIL.COM",
      "address": "CALLE PRINCIPAL CASA NRO 1 HUERTA  LOS PAJAROS. PAYA",
      "client_identification": "V11179690",
      "nap_box_name": "96",
      "created_at": "2024-07-31T13:37:27.499386",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5879,
      "client_name": "ENCARNACION OJEDA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Huerta Los Pajaros",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243129774",
      "client_email": "ENCARNACIONOJEDA25@GMAIL.COM",
      "address": "CTRA VIA PAYA CASA NRO 11-A SECTOR HUERTA LOS PAJAROS ROSARIO DE PAYA",
      "client_identification": "V7188487",
      "nap_box_name": "96",
      "created_at": "2024-07-31T13:39:01.383405",
      "service_detail": {
        "id": 4379,
        "ip": "172.20.131.2",
        "mac": "TPLGF5CB04AB",
        "serial": "TPLGF5CB04AB",
        "queue": "Plan_114480_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-08-09T16:23:39.062537",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5880,
      "client_name": "JOHN WILSON ORRIBO OCHOA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Huerta Los Pajaros",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243498951",
      "client_email": "JORRIBO68@GMAIL.COM",
      "address": "VALLE DE PAYA SECTOR HUERTA  LOS PAJAROS CALLEJON HUERTA  LOS PAJAROS PARCELA NRO 2",
      "client_identification": "V18219528",
      "nap_box_name": "96",
      "created_at": "2024-07-31T13:48:35.980728",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5881,
      "client_name": "ALI JOSE PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Callejon Cañaveral",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243037489",
      "client_email": "ALISP8312@GMAIL.COM",
      "address": "AV CAÑAVERAL CASA NRO 5 URB VALLES DE PAYA ROSARIO DE PAYA",
      "client_identification": "V8733355",
      "nap_box_name": "97",
      "created_at": "2024-07-31T13:50:09.884631",
      "service_detail": {
        "id": 9270,
        "ip": "172.23.65.2",
        "mac": "TPLGF5CB068B",
        "serial": "TPLGF5CB068B",
        "queue": "queue1",
        "interface": "VLAN204_CANAVERAL_OLT2",
        "created_at": "2025-07-28T10:01:10.745842",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5883,
      "client_name": "ARELITZE EDITH TERAN DE MARTINEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Callejon Cañaveral",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04120413300",
      "client_email": "ARELITZETR@GMAIL.COM",
      "address": "CALLE CAÑAVERAL CASA NRO 622 A 1 SECTOR ANTIGUA HACIENDA DE PAYA TURMERO",
      "client_identification": "V11196935",
      "nap_box_name": "97",
      "created_at": "2024-07-31T14:03:35.893518",
      "service_detail": {
        "id": 9458,
        "ip": "172.20.204.2",
        "mac": "TPLGF5CB0788",
        "serial": "TPLGF5CB0788",
        "queue": "queue1",
        "interface": "VLAN204_CANAVERAL_OLT2",
        "created_at": "2025-09-02T09:56:27.084562",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5884,
      "client_name": "DIANA KATERIN FLORES PASTRAN",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Prados I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124492135",
      "client_email": "FLORESDIANA261@GMAIL.COM",
      "address": "CALLE 3 CASA NRO 14 SECTOR PRADOS DE PAYA I",
      "client_identification": "V20452641",
      "nap_box_name": "CTO-00061",
      "created_at": "2024-07-31T14:05:03.243684",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5885,
      "client_name": "JONY JOSE FERNANDES ROJAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04123983138",
      "client_email": "JONYFERNANDESROJAS@GMAIL.COM",
      "address": "CALLE PPL MANZANA B-14 CASA NRO 12 URB SAMAN TARAZONERO II TURMERO",
      "client_identification": "V27864626",
      "nap_box_name": "185",
      "created_at": "2024-07-31T14:05:21.987939",
      "service_detail": {
        "id": 12227,
        "ip": "172.20.232.2",
        "mac": "TPLGB954FCFF",
        "serial": "TPLGB954FCFF",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2026-03-30T23:50:58.961171",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5886,
      "client_name": "YRIS YANE YSTURIZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Brisas de Paya",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04145936740",
      "client_email": "YRISYSTURIZ@GMAIL.COM",
      "address": "CALLE 2 MANZANA D CASA NRO 42 SECTOR BRISAS DE PAYA",
      "client_identification": "V6839240",
      "nap_box_name": "371",
      "created_at": "2024-07-31T14:07:09.917412",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5887,
      "client_name": "ADELINA DEL CARMEN MEDINA FLORES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Brisas de Paya",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128962718",
      "client_email": "FLORESDELCARMEN58@GMAIL.COM",
      "address": "CALLE 2 CASA NRO 2 SECTOR BRISAS DE PAYA",
      "client_identification": "V5946776",
      "nap_box_name": "CTO-00117",
      "created_at": "2024-07-31T14:09:12.245900",
      "service_detail": {
        "id": 4971,
        "ip": "172.18.50.2",
        "mac": "VSOL0048D829",
        "serial": "VSOL0048D829",
        "queue": "Plan_161864_30181_WispHub",
        "interface": "VLAN241_BRISAS",
        "created_at": "2024-08-13T15:40:46.807927",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5889,
      "client_name": "MARIA ISABEL GONZALEZ COLMENARES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Bicentenario",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124552792",
      "client_email": "MG4219336@GMAIL.COM",
      "address": "CALLE SIMON RODRIGUEZ MANZANA 12 CASA PLANTA BAJA NRO 14 SECTOR DESARROLLO URBANISTICO BICENTENARIO",
      "client_identification": "V12169584",
      "nap_box_name": "379",
      "created_at": "2024-07-31T14:16:21.872658",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5890,
      "client_name": "MICHELLE NATALY OLIVO MARRUFO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Palmeras II",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04125005483",
      "client_email": "MICHIOLIVO21@GMAIL.COM",
      "address": "CALLE 1 MANZANA F CASA NRO 111 URB PALMERAS II TURMERO",
      "client_identification": "V27400370",
      "nap_box_name": "629 DOS",
      "created_at": "2024-07-31T14:19:24.123386",
      "service_detail": {
        "id": 4362,
        "ip": "172.27.185.2",
        "mac": "TPLGF5CB0A3A",
        "serial": "TPLGF5CB0A3A",
        "queue": "Plan_132787_24341_WispHub",
        "interface": "VLAN119_PALMERAS_2",
        "created_at": "2024-08-09T15:26:11.227135",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5891,
      "client_name": "YESTEL ANDREINA MOLINA FLORES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Brisas de Paya",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04125989447",
      "client_email": "YESTELMOLINA@GMAIL.COM",
      "address": "CALLE PRINCIPAL CASA NRO 5 SECTOR BRISAS DE PAYA",
      "client_identification": "V20243951",
      "nap_box_name": "CTO-00206",
      "created_at": "2024-07-31T14:19:31.083756",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5892,
      "client_name": "JHONN MANUEL OJEDA LEON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados de Cafetal",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04144536756",
      "client_email": "ELECTRICOSBURATE@GMAIL.COM",
      "address": "CALLE 2 CASA LOTE 5-2-4 PRADOS DE CAFETAL TURMERO",
      "client_identification": "V19669742",
      "nap_box_name": "561",
      "created_at": "2024-07-31T14:22:02.277874",
      "service_detail": {
        "id": 5274,
        "ip": "172.20.140.2",
        "mac": "TPLGF5CB04F8",
        "serial": "TPLGF5CB04F8",
        "queue": "Plan_92284_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-08-15T17:08:28.293468",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5893,
      "client_name": "NAYRUBI MARGARITA COMBITA PIRELA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Durpa",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243203292",
      "client_email": "NAYPIRELA.NP@GMAIL.COM",
      "address": "CALLE LIBERTAD MANZANA 15 CASA NRO 24 SECTOR DURPA ROSARIO DE PAYA",
      "client_identification": "V19175825",
      "nap_box_name": "CTO-00297",
      "created_at": "2024-07-31T14:23:42.437286",
      "service_detail": {
        "id": 4969,
        "ip": "172.18.16.2",
        "mac": "VSOL001285A9",
        "serial": "VSOL001285A9",
        "queue": "Plan_161891_30183_WispHub",
        "interface": "VLAN240_DURPA",
        "created_at": "2024-08-13T15:36:53.780851",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5894,
      "client_name": "NIKOL YAMILET SOLITARIO RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados de Cafetal",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243178677",
      "client_email": "NIKOLSOLITARIO08@GMAIL.COM",
      "address": "CALLE 1 CASA PARCELA NRO 7 CASA NRO 6 URB PRADOS DE CAFETAL TURMERO ROSARIO DE PAYA",
      "client_identification": "V10625338",
      "nap_box_name": "545",
      "created_at": "2024-07-31T14:24:17.455664",
      "service_detail": {
        "id": 5269,
        "ip": "172.20.148.2",
        "mac": "TPLGB954F773",
        "serial": "TPLGB954F773",
        "queue": "queue1",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-08-15T16:56:27.237519",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5895,
      "client_name": "THAILIS CARELL HERNANDEZ LOYO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Brisas de Paya",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124478775",
      "client_email": "THAILISHERNANDEZ75@GMAIL.COM",
      "address": "CALLE 1 MANZANA A CASA NRO 16 SECTOR BRISAS DE PAYA",
      "client_identification": "V13199825",
      "nap_box_name": "367",
      "created_at": "2024-07-31T14:25:55.483047",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5896,
      "client_name": "OMAHIR VERNINI PIRELA SALAZAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128829762",
      "client_email": "OMAHIRP@GMAIL.COM",
      "address": "CALLE MANZANA D 11 CASA NRO 03 SECTOR SAMAN TARAZONERO II",
      "client_identification": "V9696393",
      "nap_box_name": "264",
      "created_at": "2024-07-31T14:26:08.052109",
      "service_detail": {
        "id": 5266,
        "ip": "172.20.222.2",
        "mac": "TPLGB954FBA7",
        "serial": "TPLGB954FBA7",
        "queue": "Plan_92665_1574_WispHub",
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2024-08-15T16:53:37.765541",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5897,
      "client_name": "NOHELIA ESTHER ESCALONA ALMERON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121493199",
      "client_email": "LUISALEJANDROR964@GMAIL.COM",
      "address": "CALLE MANZANA D 11 CASA NRO 06 URB SAMAN TARAZONERO II TURMERO",
      "client_identification": "V10756023",
      "nap_box_name": "265",
      "created_at": "2024-07-31T14:42:37.560216",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5898,
      "client_name": "RAFAEL ERNESTO MATHEUZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04125643082",
      "client_email": "GENESISMATHEUZ@GMAIL.COM",
      "address": "CALLE MANZANA D 11 CASA NRO 14 SAMAN TARAZONERO II EL MACARO",
      "client_identification": "V11896593",
      "nap_box_name": "265",
      "created_at": "2024-07-31T14:46:29.650134",
      "service_detail": {
        "id": 5261,
        "ip": "172.20.218.2",
        "mac": "TPLGF5CB0A48",
        "serial": "TPLGF5CB0A48",
        "queue": "Plan_92194_1574_WispHub",
        "interface": "VLAN100_OLTs",
        "created_at": "2024-08-15T16:42:22.663930",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5899,
      "client_name": "DEYANIRA DEL VALLE FIGUEROA RAMIREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04144634394",
      "client_email": "IRLAINOSKY@GMAIL.COM",
      "address": "VDA D 711 CASA NRO 11 SECTOR SAMAN TARAZONERO II TURMERO",
      "client_identification": "V11852187",
      "nap_box_name": "161",
      "created_at": "2024-07-31T14:50:05.279686",
      "service_detail": {
        "id": 5257,
        "ip": "172.20.219.2",
        "mac": "TPLGB954F9FB",
        "serial": "TPLGB954F9FB",
        "queue": "Plan_92194_1574_WispHub",
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2024-08-15T16:27:51.717496",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5900,
      "client_name": "JONAS GREGORIO PUERTA VALECILLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04123412109",
      "client_email": "jonaspuerta70@gmail.com",
      "address": "CALLE MANZANA D-12 CASA NRO 11 SAMANA TARAZONERO II TURMERO",
      "client_identification": "V9656382",
      "nap_box_name": "265",
      "created_at": "2024-07-31T15:26:38.459531",
      "service_detail": {
        "id": 5256,
        "ip": "172.20.240.2",
        "mac": "TPLGB954F67F",
        "serial": "TPLGB954F67F",
        "queue": "Plan_92194_1574_WispHub",
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2024-08-15T16:18:40.626276",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5901,
      "client_name": "WILMER ALEXANDER CARVAJAL TELLES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Callejon Cañaveral",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243432156",
      "client_email": "SOFIWILMARI@GMAIL.COM",
      "address": "CTRA PRINCIPAL CASA NRO 43-1-1 SECTOR HACIENDA PAYA",
      "client_identification": "V11938607",
      "nap_box_name": "99",
      "created_at": "2024-07-31T16:01:13.095460",
      "service_detail": {
        "id": 5253,
        "ip": "172.21.17.2",
        "mac": "TPLGB954F756",
        "serial": "TPLGB954F756",
        "queue": "Plan_114480_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-08-15T16:10:20.547749",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5902,
      "client_name": "JOSE MANUEL MEDINA SANCHEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Salto Angel",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243146652",
      "client_email": "JOSEMEDINASANCHEZ58@GMAIL.COM",
      "address": "CALLE LOS PINOS CASA MANZANA 1 NRO 4 URB SALTO ANGEL  TURMERO",
      "client_identification": "V5824776",
      "nap_box_name": "39",
      "created_at": "2024-07-31T16:07:33.254602",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5903,
      "client_name": "WALTER ALEJANDRO LEVITAN",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Valle Paraiso",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04144946349",
      "client_email": "WALTERLEVITAN@GMAIL.COM",
      "address": "AV 1 CASA NRO 12 URB VALLE PARAISO TURMERO",
      "client_identification": "V23784625",
      "nap_box_name": "CTO-0643",
      "created_at": "2024-07-31T16:14:16.107989",
      "service_detail": {
        "id": 5249,
        "ip": "172.20.138.2",
        "mac": "TPLGB954F785",
        "serial": "TPLGB954F785",
        "queue": "Plan_92284_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-08-15T15:50:47.875407",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5904,
      "client_name": "ROBERTO CARLOS TOVAR LANDAETA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124341608",
      "client_email": "TEAMOPAPA004@GMAIL.COM",
      "address": "CALLE MANZANA D 7 CASA NRO 14 SECTOR SAMAN TARAZONERO II TURMERO",
      "client_identification": "V26140434",
      "nap_box_name": "265",
      "created_at": "2024-07-31T16:17:05.194301",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5905,
      "client_name": "DARIANA JOSEFINA TABORDA BRICEÑO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Antonio Jose de Sucre",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04124608025",
      "client_email": "DARIANATAB_20@HOTMAIL.COM",
      "address": "CALLE PRINCIPAL CASA NRO 55 ANTONIO JOSE DE SUCRE TURMERO",
      "client_identification": "V21465380",
      "nap_box_name": "122",
      "created_at": "2024-07-31T16:23:23.256896",
      "service_detail": {
        "id": 5241,
        "ip": "172.20.147.2",
        "mac": "TPLGB954EBE5",
        "serial": "TPLGB954EBE5",
        "queue": "Plan_92223_1574_WispHub",
        "interface": "VLAN101_AJS",
        "created_at": "2024-08-15T15:14:49.965869",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5906,
      "client_name": "INGRID TIBISAY ZAPATA PAREDES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128963537",
      "client_email": "INGRIDTIBISAYZA0911@GMAIL.COM",
      "address": "CALLE MANZANA D 10 CASA NRO 14 SAMAN TARAZONERO II TURMERO",
      "client_identification": "V7219918",
      "nap_box_name": "264",
      "created_at": "2024-07-31T16:26:05.382184",
      "service_detail": {
        "id": 5239,
        "ip": "172.20.209.2",
        "mac": "TPLGB954E8F1",
        "serial": "TPLGB954E8F1",
        "queue": "Plan_107915_1574_WispHub",
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2024-08-15T15:04:17.083895",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5907,
      "client_name": "JENNY ALEXANDRA VILLASMIL GARCIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Brisas de Paya",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04269383397",
      "client_email": "JENNYVILLASMIL.08@GMAIL.COM",
      "address": "CALLE 3 CASA 17 SECTOR BRISAS DE PAYA",
      "client_identification": "V13562522",
      "nap_box_name": "370",
      "created_at": "2024-07-31T16:27:56.185889",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5908,
      "client_name": "YOLEYDA TIBISAY GUILLEN CASTILLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Durpa",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04140481015",
      "client_email": "YOLEGUILLEN1302@GMAIL.COM",
      "address": "CALLE LIBERTAD CASA MANZANA 17 NRO 08 SECTOR DESARROLLO URBANISTICO ROSARIO DE PAYA",
      "client_identification": "V14664798",
      "nap_box_name": "CTO-00297",
      "created_at": "2024-07-31T16:30:15.720747",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5909,
      "client_name": "MATILDE COROMOTO CHIRINOS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Bicentenario",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04127695248",
      "client_email": "MATILDE.0253@GMAIL.COM",
      "address": "CALLE SIMON RODRIGUEZ MANZANA 12 CASA PLANTA BAJA NRO 13 SECTOR DESARROLLO URBANISTICO BICENTENARIO",
      "client_identification": "V5365447",
      "nap_box_name": "379",
      "created_at": "2024-07-31T16:32:11.317237",
      "service_detail": {
        "id": 4299,
        "ip": "172.18.34.2",
        "mac": "VSOL004814D9",
        "serial": "VSOL004814D9",
        "queue": "Plan_161890_30183_WispHub",
        "interface": "VLAN243_BICENTENARIO",
        "created_at": "2024-08-08T19:44:41.620800",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5910,
      "client_name": "CARMEN JOSEFINA LIMA MORENO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Brisas de Paya",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243744137",
      "client_email": "CAREDUMORENO22@GMAIL.COM",
      "address": "CALLE 1 CASA NRO 13 SECTOR BRISAS DE PAYA",
      "client_identification": "V16384850",
      "nap_box_name": "367",
      "created_at": "2024-07-31T16:34:57.315100",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5911,
      "client_name": "LUISA ANGELICA RODRIGUEZ DE BOCARRIDO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Brisas de Paya",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04160458191",
      "client_email": "LUISAANGELICABOCARRIDO123@GMAIL.COM",
      "address": "CALLE MANZANA C CASA 1-1 SECTOR BRISAS DE PAYA TURMERO",
      "client_identification": "V7967617",
      "nap_box_name": "CTO-00117",
      "created_at": "2024-07-31T16:36:46.997068",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5912,
      "client_name": "GERONIMO ELIAS BLANCO ONTIVERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Durpa",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243014409",
      "client_email": "GERBLANCO51@GMAIL.COM",
      "address": "CALLE LIBERTAD MANZANA 15 CASA NRO 19 URB DESARROLLO URBANISTICO",
      "client_identification": "V4566134",
      "nap_box_name": "CTO-00297",
      "created_at": "2024-07-31T16:38:43.284605",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5913,
      "client_name": "ANTHONY JOSE GRUESO GRUESO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Brisas de Paya",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243182374",
      "client_email": "GRUESO634@GMAIL.COM",
      "address": "CALLE 2 CASA NRO 11 SECTOR BRISAS DE PAYA",
      "client_identification": "V24818095",
      "nap_box_name": "CTO-00117",
      "created_at": "2024-07-31T16:43:30.996167",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5914,
      "client_name": "YESENIA SOLANYE SILVA BERRO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Durpa",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124333677",
      "client_email": "SOLANYES1973@GMAIL.COM",
      "address": "CALLE LIBERTAD MANZANA 17 CASA NRO 12 SECTOR DESARROLLO URBANISTICO DURPA",
      "client_identification": "V12165843",
      "nap_box_name": "CTO-00297",
      "created_at": "2024-07-31T16:44:55.452025",
      "service_detail": {
        "id": 4303,
        "ip": "172.18.145.2",
        "mac": "VSOL00521E61",
        "serial": "VSOL00521E61",
        "queue": "Plan_161892_30183_WispHub",
        "interface": "VLAN240_DURPA",
        "created_at": "2024-08-08T19:58:04.835939",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5915,
      "client_name": "ESVEINA JOSEFINA LUGO SALAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Durpa",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04264484716",
      "client_email": "ESVEINALUGO@GMAIL.COM",
      "address": "CALLE LIBERTAD MANZANA 16 CASA NRO 17 SECTOR DESARROLLO URBANISTICO DURPA",
      "client_identification": "V20453032",
      "nap_box_name": "258",
      "created_at": "2024-07-31T16:46:46.702917",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5916,
      "client_name": "ANTONY RODRIGO VIZCAINO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "SUSPENDIDO_RESIDENCIAL",
      "status_name": "Suspendido",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Brisas de Paya",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04163450345",
      "client_email": "ANTONYVIZCAINO28@GMAIL.COM",
      "address": "CALLE 3 MANZANA F CASA NRO 16 SECTOR BRISAS DE PAYA",
      "client_identification": "V19999220",
      "nap_box_name": "370",
      "created_at": "2024-07-31T16:49:53.944536",
      "service_detail": {
        "id": 4388,
        "ip": "172.18.86.2",
        "mac": "VSOL00128279",
        "serial": "VSOL00128279",
        "queue": "Plan_161903_30183_WispHub",
        "interface": "VLAN241_BRISAS",
        "created_at": "2024-08-09T19:33:06.921825",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5917,
      "client_name": "ANGEL ENRIQUE OLIVARES SERRANO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Durpa",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243583766",
      "client_email": "ABG.ANGELOLIVARES@GMAIL.COM",
      "address": "CALLE LIBERTAD MANZANA 17 CASA NRO 06 SECTOR DESARROLLO URBANISTICO ROSARIO DE PAYA",
      "client_identification": "V9659939",
      "nap_box_name": "CTO-00297",
      "created_at": "2024-07-31T16:51:21.481124",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5918,
      "client_name": "MARGARITA ROSA MARTINEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Durpa",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04244526941",
      "client_email": "MARGARETRM.1957@GMAIL.COM",
      "address": "CALLE LIBERTAD MANZANA 16 CASA NRO 20 SECTOR DESARROLLO URBANISTICO",
      "client_identification": "V23213355",
      "nap_box_name": "258",
      "created_at": "2024-07-31T16:55:57.458040",
      "service_detail": {
        "id": 12181,
        "ip": "172.18.72.2",
        "mac": "VSOL00122591",
        "serial": "VSOL00122591",
        "queue": null,
        "interface": "VLAN240_DURPA",
        "created_at": "2026-03-25T18:10:41.321562",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5919,
      "client_name": "LUIS GERARDO PERDOMO PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Brisas de Paya",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128903748",
      "client_email": "proferluper2@gmail.com",
      "address": "CALLE 1 CASA NRO 09 SECTOR BRISAS DE PAYA",
      "client_identification": "V28335257",
      "nap_box_name": "367",
      "created_at": "2024-07-31T16:57:43.191171",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5920,
      "client_name": "JOSE DANIEL SANTANA SOTO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Brisas de Paya",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243407572",
      "client_email": "JOSEDAN271@GMAIL.COM",
      "address": "CALLE 3 MANZANA F CASA NRO 11 SECTOR BRISAS DE PAYA ROSARIO DE PAYA",
      "client_identification": "V19949747",
      "nap_box_name": "370",
      "created_at": "2024-07-31T16:59:15.328046",
      "service_detail": {
        "id": 4392,
        "ip": "172.18.27.2",
        "mac": "VSOL00128949",
        "serial": "VSOL00128949",
        "queue": "Plan_161903_30183_WispHub",
        "interface": "VLAN241_BRISAS",
        "created_at": "2024-08-09T19:44:37.459264",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5921,
      "client_name": "YENILETT DEL CARMEN PERDOMO RIVAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Durpa",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04123465885",
      "client_email": "YENILETTPERDOMO@GMAIL.COM",
      "address": "CALLE LOS CAOBOS MANZANA 16 CASA NRO 40 SECTOR DESARROLLO URBANISTICO",
      "client_identification": "V8693864",
      "nap_box_name": "348",
      "created_at": "2024-07-31T17:00:31.410539",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5922,
      "client_name": "JOSE ALEXANDER TOVAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Paya Abajo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144753826",
      "client_email": "JOSEALEXANDERTOVAR9@GMAIL.COM",
      "address": "CALLE CAMPO ELIAS CASA Nº 12-1 SECTOR PAYA ABAJO ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V18489180",
      "nap_box_name": "271",
      "created_at": "2024-08-01T08:00:59.568313",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5923,
      "client_name": "JOSE MANUEL LANDROVE VELASQUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "SUSPENDIDO_RESIDENCIAL",
      "status_name": "Suspendido",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144574761",
      "client_email": "NISELYB93@GMAIL.COM",
      "address": "CALLE 3-B CASA NRO 49 URB PANTIN ROSARIO DE PAYA",
      "client_identification": "V19554809",
      "nap_box_name": "CE-00043",
      "created_at": "2024-08-01T11:01:10.480288",
      "service_detail": {
        "id": 12024,
        "ip": "172.22.252.2",
        "mac": "TPLGBA686E93",
        "serial": "TPLGBA686E93",
        "queue": null,
        "interface": "VLAN229_PANTIN",
        "created_at": "2026-03-10T13:47:30.322401",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5924,
      "client_name": "YAMILEX DE LOS SANTOS MENDEZ LUNA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04163094210",
      "client_email": "MENDEZ.YAMILEX49@GMAIL.COM",
      "address": "AV PRINCIPAL PRADOS DE PAYA 1 CASA Nº 1 SECTOR EL SAMAN ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V15918567",
      "nap_box_name": "CTO-00206",
      "created_at": "2024-08-01T11:21:11.372202",
      "service_detail": {
        "id": 4185,
        "ip": "172.31.28.2",
        "mac": "OEMT3C62304A",
        "serial": "OEMT3C62304A",
        "queue": "Plan_161905_30183_WispHub",
        "interface": "VLAN239_PRADOS1",
        "created_at": "2024-08-03T18:16:11.629695",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5925,
      "client_name": "MATEO ALEJANDRO BETHENCOURT PIMENTEL",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Valle Paraiso",
      "plan": {
        "id": 16,
        "name": "RECURRENTE RESIDENCIAL PLAN 800M",
        "cost": "55.00",
        "code": "FOR800",
        "profile": "800M/800M"
      },
      "client_mobile": "04140535378",
      "client_email": "MATEOABP@GMAIL.COM",
      "address": "CALLE MANZANA 11 CASA NRO 7B SECTOR VALLE PARAISO SAN PABLO TURMERO EDO ARAGUA",
      "client_identification": "V14628323",
      "nap_box_name": "CE-00254",
      "created_at": "2024-08-01T13:35:19.801342",
      "service_detail": {
        "id": 11943,
        "ip": "172.20.17.2",
        "mac": "TPLGB765643F",
        "serial": "TPLGB765643F",
        "queue": null,
        "interface": "VLAN227_V_PARAISO_OLT1",
        "created_at": "2026-03-04T14:57:39.854554",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5926,
      "client_name": "CARLOS DANIEL CLEMENTE FRAGOSO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Valle Paraiso",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04127761214",
      "client_email": "CARLOSCLEMENTE@HOTMAIL.COM",
      "address": "AV MANZANA 3 CASA NRO 20 URB VALLE PARAISO TURMERO ARAGUA",
      "client_identification": "V20119375",
      "nap_box_name": "644",
      "created_at": "2024-08-01T13:37:20.486424",
      "service_detail": {
        "id": 8976,
        "ip": "10.15.88.2",
        "mac": "TPLGB765623F",
        "serial": "TPLGB765623F",
        "queue": "queue1",
        "interface": "VLAN224_SAN_PABLO_OLT1",
        "created_at": "2025-06-18T12:59:55.265003",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5927,
      "client_name": "YURVIS YANETH ALAGARES RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Palmeras II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243336797",
      "client_email": "AITORMANU3@GMAIL.COM",
      "address": "AV INTERCOMUNAL TURMERO MARACAY CASA NRO 148 URB LAS PALMERAS 2 TURMERO ARAGUA",
      "client_identification": "V11793551",
      "nap_box_name": "287",
      "created_at": "2024-08-01T13:39:15.827154",
      "service_detail": {
        "id": 4677,
        "ip": "172.10.35.2",
        "mac": "TPLG2ABDC743",
        "serial": "TPLG2ABDC743",
        "queue": "Plan_131647_24341_WispHub",
        "interface": "VLAN119_PALMERAS_2",
        "created_at": "2024-08-12T10:55:16.683250",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5928,
      "client_name": "NICOLAS DE JESUS RAMOS PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Palmeras II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04145906423",
      "client_email": "NICOLASRAMOSP@GMAIL.COM",
      "address": "AV 4 2DA ESTAPA CONJ RESD LAS PALMERAS II CASA NRO 39 SECTOR TURMERO EDO ARAGUA TURMERO",
      "client_identification": "V12608966",
      "nap_box_name": "337",
      "created_at": "2024-08-01T13:41:35.953345",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5929,
      "client_name": "PABLO VICENTE GONZALEZ GUTIERREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "San Pablo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144546540",
      "client_email": "PABLOVICENTE_23@HOTMAIL.COM",
      "address": "CALLE FERGUIS EDIF CAMELOT SUITES I PISO 2 APT C-6 URB SAN PABLO TURMERO ARAGUA",
      "client_identification": "V14959089",
      "nap_box_name": "CTO-00413",
      "created_at": "2024-08-01T13:43:40.665605",
      "service_detail": {
        "id": 4683,
        "ip": "172.20.11.2",
        "mac": "TPLG2ABDC81D",
        "serial": "TPLG2ABDC81D",
        "queue": "Plan_153953_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-08-12T11:06:34.382661",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5930,
      "client_name": "LUIS JOSE RODRIGUEZ GARCIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "San Pablo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04127768888",
      "client_email": "LUISJO1994@HOTMAIL.COM",
      "address": "AV 3ERA AV CASA NRO 2-A URB SAN PABLO TURMERO ARAGUA",
      "client_identification": "V24816573",
      "nap_box_name": "CTO-0637",
      "created_at": "2024-08-01T13:45:22.002451",
      "service_detail": {
        "id": 4686,
        "ip": "172.20.8.2",
        "mac": "TPLG2ABDC663",
        "serial": "TPLG2ABDC663",
        "queue": "queue1",
        "interface": "VLAN224_SAN_PABLO_OLT1",
        "created_at": "2024-08-12T11:09:46.781734",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5931,
      "client_name": "JOSE GABRIEL MEDINA RIVERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243791574",
      "client_email": "SHADOW519@GMAIL.COM",
      "address": "CALLE NEGRO PRIMERO CASA NRO 1-A SECTOR CENTRO DE TURMERO EDO ARAGUA",
      "client_identification": "V18163946",
      "nap_box_name": "53",
      "created_at": "2024-08-01T13:47:30.589918",
      "service_detail": {
        "id": 4690,
        "ip": "172.20.5.2",
        "mac": "TPLGB7656533",
        "serial": "TPLGB7656533",
        "queue": "Plan_89283_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-08-12T11:13:42.276837",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5932,
      "client_name": "VICKLER RAMON DELGADO GUDIÑO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Valle Paraiso",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04124379501",
      "client_email": "VICKLERD@GMAIL.COM",
      "address": "AV AVENIDA PRINCIPAL MANZANA 4 CASA NRO 18 URB VALLE PARAISO TURMERO ARAGUA",
      "client_identification": "V16435954",
      "nap_box_name": "143",
      "created_at": "2024-08-01T13:49:21.519876",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5936,
      "client_name": "JUAN CARLOS GONCALVES LUQUE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Terrazas de Juan Pablo",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04144777498",
      "client_email": "JUANGONCALVES2000@HOTMAIL.COM",
      "address": "CALLE LA LLANERA EDIF S/N PISO 1 APT B-10 URB TERRAZAS DE JUAN PABLO TURMERO ARAGUA",
      "client_identification": "V9687673",
      "nap_box_name": "13",
      "created_at": "2024-08-01T14:08:22.170718",
      "service_detail": {
        "id": 4734,
        "ip": "172.18.183.2",
        "mac": "TPLGB7656356",
        "serial": "TPLGB7656356",
        "queue": "Plan_131648_24341_WispHub",
        "interface": "VLAN100_OLTs",
        "created_at": "2024-08-12T14:07:14.153473",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5937,
      "client_name": "CARMEN SHIRLEY MOLINA FONSECA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman de Guere",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04126978527",
      "client_email": "LEONELAFONSECA1@GMAIL.COM",
      "address": "AV INTERCOMUNAL TURMERO-MARACAY C/ PRINCIPAL Y C/ LAS CAYENAS CASA NRO 02 SECTOR SAMAN DE GUERE TURMERO ARAGUA",
      "client_identification": "V9648746",
      "nap_box_name": "CTO-00115",
      "created_at": "2024-08-01T14:11:23.148131",
      "service_detail": {
        "id": 4736,
        "ip": "172.25.21.2",
        "mac": "TPLG2ABDC7D6",
        "serial": "TPLG2ABDC7D6",
        "queue": "Plan_131647_24341_WispHub",
        "interface": "VLAN122_SAMAN_GUERE",
        "created_at": "2024-08-12T14:21:57.989006",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5938,
      "client_name": "WILFREDDY ALEXANDER VILLEGAS PONCE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Palmeras II",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04144485009",
      "client_email": "WILFREDDY.V@GMAIL.COM",
      "address": "CALLE 4 CASA NRO 75 URB LAS PALMERAS II TURMERO ARAGUA",
      "client_identification": "V13132238",
      "nap_box_name": "337",
      "created_at": "2024-08-01T14:14:11.211204",
      "service_detail": {
        "id": 4737,
        "ip": "172.10.23.2",
        "mac": "TPLG2ABDC66D",
        "serial": "TPLG2ABDC66D",
        "queue": "Plan_131648_24341_WispHub",
        "interface": "VLAN100_OLTs",
        "created_at": "2024-08-12T14:26:40.756090",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5939,
      "client_name": "WILMER ALBERT CORZO GUZMAN",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Palmeras II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04261396992",
      "client_email": "WILMERCORZO@YAHOO.COM",
      "address": "CALLE 4 CASA NRO 77 URB LAS ¨PALMERAS 2 TURMERO ARAGUA",
      "client_identification": "V12857216",
      "nap_box_name": "337",
      "created_at": "2024-08-01T14:15:56.176577",
      "service_detail": {
        "id": 4739,
        "ip": "172.25.20.2",
        "mac": "TPLG2ABDC6DD",
        "serial": "TPLG2ABDC6DD",
        "queue": "Plan_131647_24341_WispHub",
        "interface": "VLAN119_PALMERAS_2",
        "created_at": "2024-08-12T14:31:35.792016",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5940,
      "client_name": "JESUS ARCIDES PENA MACERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Palmeras II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04129332660",
      "client_email": "ENRIQUEANTONIOROMEROGOMEZ@GMAIL.COM",
      "address": "CTRA INTERCOMUNAL CASA CONJUNTO RESIDENCIAL LAS PALMERAS 2 NRO 13 SECTOR LA JULIA TURMERO ARAGUA",
      "client_identification": "V6868795",
      "nap_box_name": "630 DOS",
      "created_at": "2024-08-01T14:22:12.111076",
      "service_detail": {
        "id": 4745,
        "ip": "172.30.94.2",
        "mac": "TPLG2ABDC69D",
        "serial": "TPLG2ABDC69D",
        "queue": "Plan_131647_24341_WispHub",
        "interface": "VLAN119_PALMERAS_2",
        "created_at": "2024-08-12T14:39:49.503589",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5941,
      "client_name": "LEYDIS MARBELLA PEREZ LOZADA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Palmeras II",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04126787268",
      "client_email": "LEYMAR10@GMAIL.COM",
      "address": "CALLE PRINCIPAL CASA NRO C-07 URB LAS PALMERAS II TURMERO ARAGUA",
      "client_identification": "V10268912",
      "nap_box_name": "336",
      "created_at": "2024-08-01T14:28:47.114895",
      "service_detail": {
        "id": 4751,
        "ip": "172.18.44.2",
        "mac": "TPLG2ABDC7D1",
        "serial": "TPLG2ABDC7D1",
        "queue": "Plan_131648_24341_WispHub",
        "interface": "VLAN100_OLTs",
        "created_at": "2024-08-12T14:54:58.375752",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5942,
      "client_name": "MARIO ALFREDO CENTENO PEÑA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Palmeras II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243014592",
      "client_email": "ALEIFRE2010@HOTMAIL.COM",
      "address": "CALLE B CASA NRO 27 URB LAS PALMERAS II TURMERO ARAGUA",
      "client_identification": "V27434398",
      "nap_box_name": "630",
      "created_at": "2024-08-01T14:31:01.626437",
      "service_detail": {
        "id": 4757,
        "ip": "172.30.23.2",
        "mac": "TPLG2ABDC7F4",
        "serial": "TPLG2ABDC7F4",
        "queue": "Plan_131647_24341_WispHub",
        "interface": "VLAN119_PALMERAS_2",
        "created_at": "2024-08-12T15:01:58.081272",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5943,
      "client_name": "MANUEL RICARDO MEZA ROMERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Palmeras II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243006515",
      "client_email": "MANUELMEZA288@GMAIL.COM",
      "address": "CALLE PEÑALVER CASA SEGUNDATERRAZA NRO 8-B URB LAS PALMERAS 2 TURMERO ARAGUA",
      "client_identification": "V26448047",
      "nap_box_name": "630 DOS",
      "created_at": "2024-08-01T14:33:09.133963",
      "service_detail": {
        "id": 4762,
        "ip": "172.18.46.2",
        "mac": "TPLG2ABDC820",
        "serial": "TPLG2ABDC820",
        "queue": "Plan_131647_24341_WispHub",
        "interface": "VLAN119_PALMERAS_2",
        "created_at": "2024-08-12T15:08:44.980464",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5944,
      "client_name": "MICHAEL EDUARDO PINERO LUNA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Palmeras II",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04128903858",
      "client_email": "MICHAELPINEROLUNA@GMAIL.COM",
      "address": "CALLE TERRAZA A CASA NRO 9-A URB LAS PALMERAS II LA JULIA TURMERO EDO ARAGUA",
      "client_identification": "V26535076",
      "nap_box_name": "629 DOS",
      "created_at": "2024-08-01T14:34:39.743244",
      "service_detail": {
        "id": 4769,
        "ip": "172.18.47.2",
        "mac": "TPLG2ABDC805",
        "serial": "TPLG2ABDC805",
        "queue": "Plan_131341_24341_WispHub",
        "interface": "VLAN119_PALMERAS_2",
        "created_at": "2024-08-12T15:21:36.688157",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5945,
      "client_name": "HERMINIA LISBETH GOMEZ LINARES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "SUSPENDIDO_RESIDENCIAL",
      "status_name": "Suspendido",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Palmeras II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243708243",
      "client_email": "HERMINIA_LISBETH@HOTMAIL.COM",
      "address": "AV INTERCOMUNAL CALLE 1 CASA NRO 6 URB PALMERAS II TURMERO ARAGUA",
      "client_identification": "V10754609",
      "nap_box_name": "629 DOS",
      "created_at": "2024-08-01T14:37:38.388117",
      "service_detail": {
        "id": 10073,
        "ip": "172.10.14.2",
        "mac": "TPLG2ABDC819",
        "serial": "TPLG2ABDC819",
        "queue": null,
        "interface": "VLAN119_PALMERAS_2",
        "created_at": "2025-11-12T14:12:07.276598",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5946,
      "client_name": "JOSE FERNANDO MARTINEZ DIAZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Durpa",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121493617",
      "client_email": "josefmartinez95@gmail.com",
      "address": "CALLE CAOBOS MANZANA 16 CASA NRO 34 SECTOR DURPA",
      "client_identification": "V12929318",
      "nap_box_name": "348",
      "created_at": "2024-08-01T14:42:22.856961",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5947,
      "client_name": "YELITZA MARIA AFONSO DE LINARES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Palmeras II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04143452578",
      "client_email": "YELITZAFONSO@GMAIL.COM",
      "address": "CALLE MANZANA A CALLE 1 CASA NRO 5-A URB LAS PALMERAS II TURMERO ARAGUA",
      "client_identification": "V12170382",
      "nap_box_name": "629",
      "created_at": "2024-08-01T14:42:44.817556",
      "service_detail": {
        "id": 9768,
        "ip": "172.25.16.2",
        "mac": "TPLG2ABDC669",
        "serial": "TPLG2ABDC669",
        "queue": null,
        "interface": "VLAN119_PALMERAS_2",
        "created_at": "2025-11-10T12:30:04.030421",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5948,
      "client_name": "DOUGLAS BELEN REYES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Palmeras II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243169856",
      "client_email": "GREGORYPARADAS72@GMAIL.COM",
      "address": "AV 6 CASA NRO 04 CONJUNTO RESIDENCIAL PALMERAS II TURMERO ARAGUA",
      "client_identification": "V5263353",
      "nap_box_name": "629",
      "created_at": "2024-08-01T14:44:16.792988",
      "service_detail": {
        "id": 4777,
        "ip": "172.10.15.2",
        "mac": "TPLG2ABDC7B2",
        "serial": "TPLG2ABDC7B2",
        "queue": "queue1",
        "interface": "VLAN100_OLTs",
        "created_at": "2024-08-12T15:39:20.902282",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5949,
      "client_name": "SUHELEN NAHOMY AGUILAR LOPEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Durpa",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04140394894",
      "client_email": "OMEGA0214@HOTMAIL.COM",
      "address": "CALLE PASEO LIBERTADOR CON CALLE LOS CAOBOS MANZANA 16 CASA NRO 24 SECTOR DESARROLLO URBANISTICO DURPA",
      "client_identification": "V16339073",
      "nap_box_name": "392",
      "created_at": "2024-08-01T14:45:59.726640",
      "service_detail": {
        "id": 4394,
        "ip": "172.17.200.2",
        "mac": "VSOL0011E6F9",
        "serial": "VSOL0011E6F9",
        "queue": "Plan_161904_30183_WispHub",
        "interface": "VLAN240_DURPA",
        "created_at": "2024-08-09T19:48:41.179257",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5950,
      "client_name": "TIBISAY MARIA SIFONTES DE DAMAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Palmeras II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04142952484",
      "client_email": "ANYELINA23S@GMAIL.COM",
      "address": "VDA A CASA NRO 10-A CONJUNTO RESIDENCIAL LAS PALMERAS TURMERO ARAGUA",
      "client_identification": "V9916548",
      "nap_box_name": "629 DOS",
      "created_at": "2024-08-01T14:47:42.206925",
      "service_detail": {
        "id": 4785,
        "ip": "172.30.76.2",
        "mac": "TPLG2ABDC818",
        "serial": "TPLG2ABDC818",
        "queue": "Plan_131647_24341_WispHub",
        "interface": "VLAN119_PALMERAS_2",
        "created_at": "2024-08-12T16:04:04.806797",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5951,
      "client_name": "MARYURI SUYIN PEREZ PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Palmeras II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243126071",
      "client_email": "NELBLA18@GMAIL.COM",
      "address": "CALLE 1 MANZANA A CASA NRO 8-A URB LAS PALMERAS II -TURMERO ARAGUA",
      "client_identification": "V11086683",
      "nap_box_name": "629 DOS",
      "created_at": "2024-08-01T14:49:36.413271",
      "service_detail": {
        "id": 4882,
        "ip": "172.27.182.2",
        "mac": "TPLG2ABDC802",
        "serial": "TPLG2ABDC802",
        "queue": "Plan_131647_24341_WispHub",
        "interface": "VLAN119_PALMERAS_2",
        "created_at": "2024-08-13T08:09:19.997662",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5952,
      "client_name": "LEIRYS DEISYUSELIN SALAZAR SALAZAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Durpa",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243783592",
      "client_email": "EQ98150@GMAIL.COM",
      "address": "CALLE LOS CAOBOS MANZANA 16 CASA NRO 32 SECTOR DESARROLLO URBANISTICO DURPA",
      "client_identification": "V15490931",
      "nap_box_name": "348",
      "created_at": "2024-08-01T14:51:01.418594",
      "service_detail": {
        "id": 12433,
        "ip": "172.17.206.2",
        "mac": "VSOL00522EC9",
        "serial": "VSOL00522EC9",
        "queue": null,
        "interface": "VLAN240_DURPA",
        "created_at": "2026-04-30T09:24:13.699897",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5953,
      "client_name": "SOLANYER MARIA RODRIGUEZ ENRIQUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Durpa",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243028367",
      "client_email": "SOLANYERMARIA@GMAIL.COM",
      "address": "CALLE LOS CAOBOS CASA NRO 07 SECTOR LOS CHALET",
      "client_identification": "V17044858",
      "nap_box_name": "392",
      "created_at": "2024-08-01T14:54:17.659126",
      "service_detail": {
        "id": 10156,
        "ip": "172.31.149.2",
        "mac": "VSOL00522C09",
        "serial": "VSOL00522C09",
        "queue": null,
        "interface": "VLAN240_DURPA",
        "created_at": "2025-11-16T08:50:24.362342",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5954,
      "client_name": "ROSMARDY KATHERINE HERNANDEZ RUIZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "SUSPENDIDO_RESIDENCIAL",
      "status_name": "Suspendido",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243493910",
      "client_email": "ROSMARDYHERNANDEZ28@GMAIL.COM",
      "address": "VDA MANZANA E-2 CASA NRO 10 URB SAMAN TARAZONERO II",
      "client_identification": "V24445735",
      "nap_box_name": "161 DOS",
      "created_at": "2024-08-01T15:03:50.201350",
      "service_detail": {
        "id": 13012,
        "ip": "172.18.149.2",
        "mac": "VS:OL:00:12:16:81",
        "serial": "VSOL00121681",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2026-09-12T19:33:41.177865",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5955,
      "client_name": "ANGELICA MARIA CASTILLO ZAMBRANO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "La Concepcion",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243365343",
      "client_email": "ANGELIKZAMBRANO44@GMAIL.COM",
      "address": "CALLE LAS PALMA CASA NRO 13 LA CONCEPCION",
      "client_identification": "V18645299",
      "nap_box_name": "108",
      "created_at": "2024-08-01T15:12:07.451215",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5956,
      "client_name": "CELIA JOSEFINA VELIZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Durpa",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243126121",
      "client_email": "CELIAVELIZ422@GMAIL.COM",
      "address": "CALLE LIBERTAD MANZANA 16 CASA NRO 16 SECTOR DESARROLLO URBANISTICO DURPA",
      "client_identification": "V7268387",
      "nap_box_name": "258",
      "created_at": "2024-08-01T15:17:27.680345",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5957,
      "client_name": "ANA MARIA PEREZ MENDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Antigua Hacienda De Paya",
      "plan": {
        "id": 19,
        "name": "RECURRENTE RESIDENCIAL PLAN 1GB",
        "cost": "74.70",
        "code": "FOR1GB",
        "profile": "1000M/1000M"
      },
      "client_mobile": "04144579421",
      "client_email": "ANAMPEREZMENDEZ@GMAIL.COM",
      "address": "CALLE DOMINGO DE TOVAR CASA NRO 21 SECTOR ANTIGUA HACIENDA DE PAYA TURMERO",
      "client_identification": "V6093492",
      "nap_box_name": "100 DOS",
      "created_at": "2024-08-01T15:20:03.667638",
      "service_detail": {
        "id": 8142,
        "ip": "10.13.31.2",
        "mac": "TPLGB954FC88",
        "serial": "TPLGB954FC88",
        "queue": "Plan_92194_15811_WispHub",
        "interface": "VLAN202_AHP_OLT1",
        "created_at": "2025-04-05T13:22:44.286909",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5958,
      "client_name": "ROSA YURAIME ANGEL DE MONZON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Durpa",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04125379473",
      "client_email": "ROSAANGELL67@GMAIL.COM",
      "address": "CALLE LOS CAOBOS MANZANA 16 CASA NRO 29 URB DESARROLLO URBANISTICO DURPA",
      "client_identification": "V9436321",
      "nap_box_name": "392",
      "created_at": "2024-08-01T15:22:20.483804",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5959,
      "client_name": "BETSY CAROLINA RUIZ SANCHEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Durpa",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04261346176",
      "client_email": "BETSYRUIZ714@GMAIL.COM",
      "address": "CALLE LOS CAOBOS MANZANA 16 CASA NRO 28 SECTOR DESARROLLO URBANISTICO DURPA",
      "client_identification": "V11976142",
      "nap_box_name": "392",
      "created_at": "2024-08-01T15:24:12.448107",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5960,
      "client_name": "RAQUEL MARIA BARRETO VILLEGAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Antigua Hacienda De Paya",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04166433319",
      "client_email": "R.BARRETO@ESESA.COM",
      "address": "CALLE DOMINGO DE TOVAR CASA NRO 14 URB ANTIGUA HACIENDA PAYA ROSARIO DE PAYA",
      "client_identification": "V6642641",
      "nap_box_name": "100",
      "created_at": "2024-08-01T15:26:00.544087",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5961,
      "client_name": "YONDER RAFAEL GONZALEZ MORENO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados III",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121486049",
      "client_email": "GYONDER123@GMAIL.COM",
      "address": "CALLE 3 CASA NRO 21 SECTOR PRADOS DE PAYA III TURMERO EDO ARAGUA",
      "client_identification": "V21204623",
      "nap_box_name": "579 DOS",
      "created_at": "2024-08-01T15:27:57.731424",
      "service_detail": {
        "id": 4411,
        "ip": "172.17.143.2",
        "mac": "VSOL00521281",
        "serial": "VSOL00521281",
        "queue": "Plan_161892_30183_WispHub",
        "interface": "VLAN236_PRADOS3",
        "created_at": "2024-08-09T20:42:01.197634",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5962,
      "client_name": "FRANCISCO EDUARDO RAMIREZ RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Antigua Hacienda De Paya",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243556305",
      "client_email": "R.AMRO.D@HOTMAIL.COM",
      "address": "CALLE PPAL CASA VIERGEN DEL VALLE NRO 5 URB. ANTIGUA HACIENDA DE PAYA ROSARIO DE PAYA",
      "client_identification": "V26535977",
      "nap_box_name": "125",
      "created_at": "2024-08-01T15:42:56.610512",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5963,
      "client_name": "NATALY JOSEFINA CORRALES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Durpa",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121491725",
      "client_email": "NATALYCORRALES15@GMAIL.COM",
      "address": "CALLE LIBERTAD MANZANA 16 CASA NRO 08 SECTOR DESARROLLO URBANISTICO DURPA",
      "client_identification": "V17954440",
      "nap_box_name": "377",
      "created_at": "2024-08-01T15:44:37.973350",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5964,
      "client_name": "RAFAEL ANGEL ARDILA PEREZ F.P",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "San Pablo",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04143455757",
      "client_email": "RARDILAP@GMAIL.COM",
      "address": "CALLE HICELE QUINTA CLARA NRO 24 URB SAN PABLO.",
      "client_identification": "V633472",
      "nap_box_name": "CTO-00049",
      "created_at": "2024-08-01T15:47:11.525879",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5965,
      "client_name": "ALBERTINO ARTURO DE CAIRES FERNANDES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Valle Paraiso",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124507537",
      "client_email": "DCAIRESARTURO@GMAIL.COM",
      "address": "URB VALLE PARAISO MANZANA 4 CASA NRO 19 TURMERO ESTADO ARAGUA",
      "client_identification": "V12119925",
      "nap_box_name": "143",
      "created_at": "2024-08-01T15:54:39.111079",
      "service_detail": {
        "id": 4883,
        "ip": "172.17.64.2",
        "mac": "TPLG2ABDC80E",
        "serial": "TPLG2ABDC80E",
        "queue": "Plan_153953_15811_WispHub",
        "interface": "VLAN227_V_PARAISO_OLT1",
        "created_at": "2024-08-13T08:13:20.637811",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5966,
      "client_name": "CARLOS ENRIQUE CLEMENTE FRAGOSO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Valle Paraiso",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128906729",
      "client_email": "CECF247@GMAIL.COM",
      "address": "CALLE MANZANA 4 CASA NRO 13 URB VALLE PARAISO TURMERO ARAGUA",
      "client_identification": "V24930012",
      "nap_box_name": "143",
      "created_at": "2024-08-01T15:56:54.550301",
      "service_detail": {
        "id": 4884,
        "ip": "172.17.61.2",
        "mac": "TPLG2ABDC7FB",
        "serial": "TPLG2ABDC7FB",
        "queue": "Plan_153953_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-08-13T08:15:44.291964",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5967,
      "client_name": "SONIA MARIA AUXILIADORA HURTADO DE BRITO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villa Caribe",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04145887737",
      "client_email": "BRITOHURTADOSONIA@HOTMAIL.COM",
      "address": "CALLE URDANETA QTA LOS REMEDIOS NRO S/N URB LOS NISPEROS TURMERO EDO. ARAGUA TURMERO EDO. ARAGUA",
      "client_identification": "V2966706",
      "nap_box_name": "CTO-0639",
      "created_at": "2024-08-01T15:58:40.030665",
      "service_detail": {
        "id": 4885,
        "ip": "172.30.79.2",
        "mac": "TPLG2ABDC6EE",
        "serial": "TPLG2ABDC6EE",
        "queue": "Plan_153953_15811_WispHub",
        "interface": "VLAN224_SAN_PABLO_OLT1",
        "created_at": "2024-08-13T08:17:44.192258",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5968,
      "client_name": "LUIS MIGUEL FERREIRO HERNANDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "SUSPENDIDO_RESIDENCIAL",
      "status_name": "Suspendido",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Valle Paraiso",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124423393",
      "client_email": "LFERREIROH@GMAIL.COM",
      "address": "CALLE PRINCIPAL MANZANA 4 CASA NRO 14 URB VALLE PARAISO TURMERO ARAGUA",
      "client_identification": "V10341211",
      "nap_box_name": "143",
      "created_at": "2024-08-01T16:00:49.669912",
      "service_detail": {
        "id": 4887,
        "ip": "172.20.50.2",
        "mac": "TPLG2ABDC683",
        "serial": "TPLG2ABDC683",
        "queue": "Plan_153953_15811_WispHub",
        "interface": "VLAN224_SAN_PABLO_OLT1",
        "created_at": "2024-08-13T08:46:19.309490",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5969,
      "client_name": "BRIZEIDA JOSEFINA GIL BRAZON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Laguna Plaza",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04149443455",
      "client_email": "BRIZEIDAGIL@GMAIL.COM",
      "address": "CALLE CAMILO TORRES EDIF 10 PISO PH APT PH 4 URB LAGUNA PLAZA SECTOR 4 TURMERO EDO ARAGUA",
      "client_identification": "V10222094",
      "nap_box_name": "2",
      "created_at": "2024-08-01T16:02:47.797411",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5971,
      "client_name": "DANIEL ALEJANDRO MORENO CARDOZO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Valle Paraiso",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124439014",
      "client_email": "juanjmorenoe@GMAIL.COM",
      "address": "CALLE D MANZANA 13 CASA NRO 2 URB VALLE PARAISO TURMERO ARAGUA",
      "client_identification": "V23784665",
      "nap_box_name": "143",
      "created_at": "2024-08-01T16:07:10.539264",
      "service_detail": {
        "id": 4924,
        "ip": "172.19.90.2",
        "mac": "TPLG2ABDC7E4",
        "serial": "TPLG2ABDC7E4",
        "queue": "Plan_153953_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-08-13T11:33:26.085438",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5972,
      "client_name": "KAYLA DINORA OROPEZA DIAZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Valle Paraiso",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243590844",
      "client_email": "CASATURMERO@HOTMAIL.COM",
      "address": "CALLE MANZANA 12 CASA NRO 8 URB VALLE PARAISO TURMERO ARAGUA",
      "client_identification": "V10456613",
      "nap_box_name": "644",
      "created_at": "2024-08-01T16:08:48.686606",
      "service_detail": {
        "id": 10029,
        "ip": "172.17.68.2",
        "mac": "TPLG2ABDC65A",
        "serial": "TPLG2ABDC65A",
        "queue": null,
        "interface": "VLAN200_OLTs",
        "created_at": "2025-11-11T15:53:36.125772",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5973,
      "client_name": "OFELIA INES ZAMBRANO PEÑA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Palmeras I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144515357",
      "client_email": "CASTILLOVICTOR2461@GMAIL.COM",
      "address": "CALLE 1 CASA NRO 19 CONJUNTO RESIDENCIAL LAS PALMERAS I TURMERO ARAGUA",
      "client_identification": "V11222269",
      "nap_box_name": "CTO-00053",
      "created_at": "2024-08-01T16:10:45.904111",
      "service_detail": {
        "id": 4940,
        "ip": "172.18.194.2",
        "mac": "TPLG2ABDC7DE",
        "serial": "TPLG2ABDC7DE",
        "queue": "Plan_131647_24341_WispHub",
        "interface": "VLAN118_PALMERAS_1",
        "created_at": "2024-08-13T13:29:06.458999",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5974,
      "client_name": "VICTOR DANIEL RODRIGUEZ VIELMA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Palmeras I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04141475543",
      "client_email": "DANIELVIELMA1982@GMAIL.COM",
      "address": "CALLE AVENIDA 1 CASA NRO 37 CONJUNTO RESIDENCIAL LAS PALMERAS I PARCELA 16 SECTOR VILLEGAS TURMERO ARAGUA",
      "client_identification": "V16131814",
      "nap_box_name": "CTO-00071",
      "created_at": "2024-08-01T16:12:41.475393",
      "service_detail": {
        "id": 4943,
        "ip": "172.18.24.2",
        "mac": "TPLG2ABDC6A9",
        "serial": "TPLG2ABDC6A9",
        "queue": "Plan_131647_24341_WispHub",
        "interface": "VLAN118_PALMERAS_1",
        "created_at": "2024-08-13T14:47:20.578393",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5975,
      "client_name": "DOLORES AMELIA FREITES BLANCO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Palmeras I",
      "plan": {
        "id": 2,
        "name": "RECURRENTE RESIDENCIAL PLAN 30M",
        "cost": "20.00",
        "code": "FOR30",
        "profile": "30M/30M"
      },
      "client_mobile": "04128745333",
      "client_email": "AMELIA.FREITES@GMAIL.COM",
      "address": "CALLE PPAL CASA NRO 28 URB LAS PALMERAS SECTOR LA JULIA TURMERO ARAGUA",
      "client_identification": "V4549236",
      "nap_box_name": "CTO-00053",
      "created_at": "2024-08-01T16:14:22.180926",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5976,
      "client_name": "IDALIA MIREYA PARRA DE PORTE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Palmeras I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121428211",
      "client_email": "AMPORTEPARRA@GMAIL.COM",
      "address": "CALLE PRINCIPAL CASA NRO 18 LAS PALMERAS I SECTOR VILLEGAS TURMERO ARAGUA",
      "client_identification": "V8553645",
      "nap_box_name": "CTO-00053",
      "created_at": "2024-08-01T16:15:56.985810",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5977,
      "client_name": "JUAN CARLOS SUAREZ TOVAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Palmeras I",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124578221",
      "client_email": "JSUAREZTOVAR485@GMAIL.COM",
      "address": "CALLE 1 CASA NRO 22 URB LAS PALMERAS LA JULIA ARAGUA TURMERO",
      "client_identification": "V11977752",
      "nap_box_name": "CTO-00053",
      "created_at": "2024-08-01T16:22:05.105992",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5978,
      "client_name": "CESAR AGUSTIN ALVARADO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Palmeras I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04265311172",
      "client_email": "CEAGUS11@GMAIL.COM",
      "address": "CALLE PRINCIPAL CASA NRO 13 URB LAS PALMERAS I TURMERO ARAGUA",
      "client_identification": "V10759397",
      "nap_box_name": "CTO-00053",
      "created_at": "2024-08-01T16:23:42.675928",
      "service_detail": {
        "id": 4962,
        "ip": "172.18.30.2",
        "mac": "TPLGC3CCB7F8",
        "serial": "TPLGC3CCB7F8",
        "queue": "Plan_131647_24341_WispHub",
        "interface": "VLAN100_OLTs",
        "created_at": "2024-08-13T15:13:07.566800",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5979,
      "client_name": "NELSON ENRIQUE ZAMBRANO BERNAL",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243580070",
      "client_email": "ZAMBRANONELSON239@GMAIL.COM",
      "address": "CALLE SAMAN TARAZONERO II MANZANA D-13 CASA NRO 03",
      "client_identification": "V9234558",
      "nap_box_name": "CTO-0262",
      "created_at": "2024-08-01T16:24:53.690085",
      "service_detail": {
        "id": 5223,
        "ip": "172.20.249.2",
        "mac": "TPLGF5CB04C8",
        "serial": "TPLGF5CB04C8",
        "queue": "Plan_92223_1574_WispHub",
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2024-08-15T14:25:17.816200",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5980,
      "client_name": "LILIA MORALES DE MANZANO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Palmeras I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04143127803",
      "client_email": "RDMM1975@GMAIL.COM",
      "address": "CALLE 1 CASA NRO 27 CONJUNTO RESIDENCIAL LAS PALMERAS TURMERO ARAGUA",
      "client_identification": "V23516819",
      "nap_box_name": "CTO-00053",
      "created_at": "2024-08-01T16:25:23.208164",
      "service_detail": {
        "id": 10874,
        "ip": "172.18.31.2",
        "mac": "TPLGC3C6BBB6",
        "serial": "TPLGC3C6BBB6",
        "queue": null,
        "interface": "VLAN118_PALMERAS_1",
        "created_at": "2025-12-22T16:36:34.355875",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5981,
      "client_name": "SANDRA CAROLINA RIVERO RINCON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Palmeras I",
      "plan": {
        "id": 2,
        "name": "RECURRENTE RESIDENCIAL PLAN 30M",
        "cost": "20.00",
        "code": "FOR30",
        "profile": "30M/30M"
      },
      "client_mobile": "04121759890",
      "client_email": "PROFASANDRARV@GMAIL.COM",
      "address": "CALLE 1 CASA NRO 52 URB LAS PALMERAS TURMERO ARAGUA",
      "client_identification": "V14104356",
      "nap_box_name": "CTO-00071",
      "created_at": "2024-08-01T16:29:00.872231",
      "service_detail": {
        "id": 4982,
        "ip": "172.25.197.2",
        "mac": "TPLG2ABDC821",
        "serial": "TPLG2ABDC821",
        "queue": "Plan_137522_24341_WispHub",
        "interface": "VLAN118_PALMERAS_1",
        "created_at": "2024-08-13T16:14:11.126784",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5982,
      "client_name": "YUSBELI JOSEFINA CASTILLO BERMAN",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Palmeras I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124770091",
      "client_email": "YUSBELC22@GMAIL.COM",
      "address": "CALLE PARCELA 16 ASENTAMIENTO CAMPESINO VILLEGAS CASA NRO 106 CONJUNTO RESIDENCIAL LAS PALMERAS I TURMERO ARAGUA",
      "client_identification": "V15181269",
      "nap_box_name": "CTO-00065",
      "created_at": "2024-08-01T16:30:48.794864",
      "service_detail": {
        "id": 4987,
        "ip": "172.19.58.2",
        "mac": "TPLGC3CCB7E3",
        "serial": "TPLGC3CCB7E3",
        "queue": "Plan_131647_24341_WispHub",
        "interface": "VLAN100_OLTs",
        "created_at": "2024-08-13T16:26:30.771632",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5983,
      "client_name": "LUISA DEL CARMEN CALDERON MUJICA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04128862917",
      "client_email": "ANGELLUISACOSTACALDERON33@GMAIL.COM",
      "address": "VDA 9 CASA NRO 12 SECTOR SAMAN TARAZONERO II TURMERO",
      "client_identification": "V10614543",
      "nap_box_name": "CTO-0262",
      "created_at": "2024-08-01T16:30:59.161483",
      "service_detail": {
        "id": 5221,
        "ip": "172.20.227.2",
        "mac": "TPLGB954E92C",
        "serial": "TPLGB954E92C",
        "queue": "Plan_92223_1574_WispHub",
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2024-08-15T14:18:47.797859",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5984,
      "client_name": "RAFAEL EDUARDO MATUTE IZARRA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Palmeras I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128849400",
      "client_email": "RMMATUTEV@GMAIL.COM",
      "address": "CALLE 2DA CASA NRO 120 URB LAS PALMERAS SECTOR LA JULIA TURMERO EDO ARAGUA",
      "client_identification": "V5762840",
      "nap_box_name": "CTO-00082",
      "created_at": "2024-08-01T16:33:47.652422",
      "service_detail": {
        "id": 4992,
        "ip": "172.10.31.2",
        "mac": "TPLG2ABDC6B9",
        "serial": "TPLG2ABDC6B9",
        "queue": "Plan_131647_24341_WispHub",
        "interface": "VLAN100_OLTs",
        "created_at": "2024-08-13T16:33:06.634399",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5985,
      "client_name": "LARRY JOSE FERNANDEZ MARIN",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Palmeras I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04120401807",
      "client_email": "LARRYSON14@GMAIL.COM",
      "address": "CALLE 1 CASA NRO 20 URB LAS PALMERAS SECTOR VILLEGUITA TURMERO ARAGUA",
      "client_identification": "V9678458",
      "nap_box_name": "CTO-00053",
      "created_at": "2024-08-01T16:36:13.145345",
      "service_detail": {
        "id": 9726,
        "ip": "172.25.190.2",
        "mac": "TPLGB7656CE0",
        "serial": "TPLGB7656CE0",
        "queue": null,
        "interface": "VLAN118_PALMERAS_1",
        "created_at": "2025-11-10T11:11:38.991532",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5986,
      "client_name": "ARCENIO JOSE GONZALEZ BARRETO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Palmeras I",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243605078",
      "client_email": "Barbaragonzalez0415@gmail.com",
      "address": "AV I CASA NRO 15 CONJUNTO RESIDENCIAL LAS PALMERAS I PARCELA 16 SECTOR VILLEGAS ASENTAMIENTO CAMPESINO TURMERO ARAGUA",
      "client_identification": "V9641254",
      "nap_box_name": "CTO-00053",
      "created_at": "2024-08-01T16:37:46.932907",
      "service_detail": {
        "id": 5041,
        "ip": "172.25.71.2",
        "mac": "TPLG2ABDC667",
        "serial": "TPLG2ABDC667",
        "queue": "Plan_137522_24341_WispHub",
        "interface": "VLAN118_PALMERAS_1",
        "created_at": "2024-08-14T08:20:11.197115",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5987,
      "client_name": "DOMARIS MERCEDES ROJAS PARACO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Julia",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128840887",
      "client_email": "DOMARISROJAS0512@GMAIL.COM",
      "address": "CALLE HAYDEE MÁRQUEZ CASA 9 URB LA NUEVA JULIA TURMERO ARAGUA",
      "client_identification": "V18176207",
      "nap_box_name": "628",
      "created_at": "2024-08-01T16:39:38.266413",
      "service_detail": {
        "id": 5047,
        "ip": "172.17.229.2",
        "mac": "TPLG2ABDC7CC",
        "serial": "TPLG2ABDC7CC",
        "queue": "Plan_131647_24341_WispHub",
        "interface": "VLAN138_LAJULIA",
        "created_at": "2024-08-14T09:36:29.360170",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5988,
      "client_name": "EDDA MARIA ECHEVERRIA ALVARADO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04124980838",
      "client_email": "ECHEVERRIAEDDA@GMAIL.COM",
      "address": "SAMAN TARAZONERO II CALLE MANZANA E9 CASA NRO 1 TURMERO",
      "client_identification": "V7246728",
      "nap_box_name": "266",
      "created_at": "2024-08-01T16:40:13.395026",
      "service_detail": {
        "id": 5219,
        "ip": "172.24.2.2",
        "mac": "TPLGB954F719",
        "serial": "TPLGB954F719",
        "queue": "Plan_92194_1574_WispHub",
        "interface": "VLAN100_OLTs",
        "created_at": "2024-08-15T14:03:43.686193",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5989,
      "client_name": "CRISTINA MATEOS  BARCON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "San Pablo",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04140391462",
      "client_email": "MATEOSCRIS@GMAIL.COM",
      "address": "CALLE PPAL MANZANA 17 CAA PARCELA NRO F URB RESIDENCIAS SAN PABLO TURMERO",
      "client_identification": "V8730001",
      "nap_box_name": "CTO-00049",
      "created_at": "2024-08-01T16:42:18.457261",
      "service_detail": {
        "id": 5218,
        "ip": "172.20.229.2",
        "mac": "TPLGB954F728",
        "serial": "TPLGB954F728",
        "queue": "Plan_92284_15811_WispHub",
        "interface": "VLAN224_SAN_PABLO_OLT1",
        "created_at": "2024-08-15T14:01:16.902957",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5992,
      "client_name": "INODELVIA BRITO ZAPATA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Floresta",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128677680",
      "client_email": "JOMORT17@GMAIL.COM",
      "address": "CALLE 4 CASA NRO G NRO 15 URB LA FLORESTA TURMERO ARAGUA",
      "client_identification": "V5160632",
      "nap_box_name": "CTO-00107 ",
      "created_at": "2024-08-01T16:49:29.304141",
      "service_detail": {
        "id": 5052,
        "ip": "172.20.83.2",
        "mac": "TPLGB86283F1",
        "serial": "TPLGB86283F1",
        "queue": "Plan_153953_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-08-14T10:00:00.120884",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5993,
      "client_name": "YARITZA MARGOT VIVAS AMARIS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "San Sebastian",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04267324728",
      "client_email": "YARITZAVIVASFP@GMAIL.COM",
      "address": "CALLE 6 LOCAL NRO 35 SECTIR  EL MACARO SAN SEBASTIAN TURMERO",
      "client_identification": "V16884322",
      "nap_box_name": "127",
      "created_at": "2024-08-01T16:50:02.178231",
      "service_detail": {
        "id": 11587,
        "ip": "172.21.77.2",
        "mac": "TPLGB954FA4D",
        "serial": "TPLGB954FA4D",
        "queue": null,
        "interface": "VLAN125_SAN_SEBASTIAN_ZTE",
        "created_at": "2026-02-10T19:07:13.640564",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5994,
      "client_name": "ANA LUISA SANDOVAL SOTO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04120698260",
      "client_email": "ANASANDOVAL0873@GMAIL.COM",
      "address": "VDA MANZANA B-8 CASA NRO 10 URB SAMAN TARAZONERO II SECTOR EL MÁCARO TURMERO ARAGUA",
      "client_identification": "V12583180",
      "nap_box_name": "186",
      "created_at": "2024-08-01T16:51:06.650494",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5995,
      "client_name": "DANIELA DANILSA BALAUSTREN BALOA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Narayola II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04149584429",
      "client_email": "DDBB3379@GMAIL.COM",
      "address": "AV VIA INTERCOMUNAL TURMERO EDIF 4 PISO 3 APT 3-1 URB NARAYOLA II TURMERO EDO ARAGUA",
      "client_identification": "V14469252",
      "nap_box_name": "CTO-0524",
      "created_at": "2024-08-01T16:52:25.475074",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 5996,
      "client_name": "LEONARDO PONTE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "San Pablo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144923781",
      "client_email": "LEONARDOPONTEGDLV@GMAIL.COM",
      "address": "SECTOR SAN PABLO CENTRO COMERCIAL  MILAN PLAZA  APTO 03. TURMERO ESTADO ARAGUA",
      "client_identification": "V15302959",
      "nap_box_name": "144",
      "created_at": "2024-08-01T16:54:29.287670",
      "service_detail": {
        "id": 7912,
        "ip": "10.10.17.2",
        "mac": "TPLGB76564A2",
        "serial": "TPLGB76564A2",
        "queue": "Plan_92194_15811_WispHub",
        "interface": "VLAN227_V_PARAISO_OLT1",
        "created_at": "2025-03-17T10:20:28.171911",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5997,
      "client_name": "DONALD RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona I Edificios",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04127554333",
      "client_email": "DONALDJRB@GMAIL.COM",
      "address": "EDIFICION D , PISO 3, APARTAMENTO 5",
      "client_identification": "V11983390",
      "nap_box_name": "CTO-0531",
      "created_at": "2024-08-01T16:57:24.795556",
      "service_detail": {
        "id": 5096,
        "ip": "172.17.201.2",
        "mac": "TPLGC3CCB7EF",
        "serial": "TPLGC3CCB7EF",
        "queue": "Plan_131647_24341_WispHub",
        "interface": "VLAN100_OLTs",
        "created_at": "2024-08-14T14:41:28.745808",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 5998,
      "client_name": "HEINYLUZ DAMARIS PABON CRESPO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Floresta",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04129566532",
      "client_email": "HDAMARIS.PABON@GMAIL.COM",
      "address": "CALLE NEGRO PRIMERO CASA NRO C-5 CONJUNTO RESIDENCIAL LA FLORESTA TURMERO ARAGUA",
      "client_identification": "V30406532",
      "nap_box_name": "CTO-00098",
      "created_at": "2024-08-01T17:02:11.259956",
      "service_detail": {
        "id": 5103,
        "ip": "172.25.140.2",
        "mac": "TPLGC3CCB7F7",
        "serial": "TPLGC3CCB7F7",
        "queue": "Plan_153953_15811_WispHub",
        "interface": "VLAN212_FLORESTA_OLT1",
        "created_at": "2024-08-14T15:03:11.975349",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6000,
      "client_name": "DOMINGO  AUGUSTO SANCHEZ DIAZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "San Carlos",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04143458780",
      "client_email": "DOMINGOAUGUSTOS@GMAIL.COM",
      "address": "CALLE F CASA NRO B 23  SAN CARLOS TURMERO",
      "client_identification": "V3285676",
      "nap_box_name": "659",
      "created_at": "2024-08-01T17:11:22.129189",
      "service_detail": {
        "id": 5210,
        "ip": "172.20.200.2",
        "mac": "TPLGB954F986",
        "serial": "TPLGB954F986",
        "queue": "Plan_92284_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-08-15T13:42:33.627659",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6001,
      "client_name": "KEYLA CELINA PENA BARRERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona II",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243641159",
      "client_email": "REYESMANUEL98@YAHOO.COM",
      "address": "CALLE 12 CASA NRO 97 LA CASONA II TURMERO",
      "client_identification": "V17134211",
      "nap_box_name": "CTO-00089",
      "created_at": "2024-08-01T17:28:08.008553",
      "service_detail": {
        "id": 5208,
        "ip": "172.20.190.2",
        "mac": "TPLGB954F6F8",
        "serial": "TPLGB954F6F8",
        "queue": "Plan_132787_24341_WispHub",
        "interface": "VLAN110_CASONA_2",
        "created_at": "2024-08-15T13:38:51.439262",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6002,
      "client_name": "LUIS ALEJANDRO GIL SALAZAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Salto Angel",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243026427",
      "client_email": "LUISALEJANDROSALAZAR347@GMAIL.COM",
      "address": "CALLE EL SAMAN CASA NRO 7 SALTO ANGEL TURMERO",
      "client_identification": "V15123701",
      "nap_box_name": "72",
      "created_at": "2024-08-01T17:30:21.259619",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6003,
      "client_name": "CECILIA EDUVIGIS JIMENEZ RENGIFO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Laguna Plaza",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243105802",
      "client_email": "JIMENEZCECILIA1962@GMAIL.COM",
      "address": "CALLE NEGRO PRIMERO CON CAMILO TORRES EDIF 03 PISO 01 APT PH 04 LAGUNA PLAZA",
      "client_identification": "V8727359",
      "nap_box_name": "1",
      "created_at": "2024-08-01T17:32:45.355500",
      "service_detail": {
        "id": 11613,
        "ip": "172.20.195.2",
        "mac": "TPLGB954FBA8",
        "serial": "TPLGB954FBA8",
        "queue": null,
        "interface": "VLAN216_LAGUNA_PLAZA_OLT1",
        "created_at": "2026-02-14T13:31:48.711749",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6005,
      "client_name": "CARMEN DEL VALLE CAGUAMO DE APONTE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Isaac Oliveira",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04149344467",
      "client_email": "CARMENCAGUAMO62@GMAIL.COM",
      "address": "CALLE 01 CASA NRO 18 SECTOR ISAAC OLIVEIRA LA CONCEPCION TURMERO",
      "client_identification": "V5899127",
      "nap_box_name": "CTO-00257",
      "created_at": "2024-08-01T17:39:07.159318",
      "service_detail": {
        "id": 11858,
        "ip": "172.21.88.2",
        "mac": "TPLGB954F62B",
        "serial": "TPLGB954F62B",
        "queue": null,
        "interface": "VLAN107_ISAAC_O",
        "created_at": "2026-02-27T16:34:46.778953",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6006,
      "client_name": "TOMAS JOSE GONZALEZ BOLIVAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Isaac Oliveira",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243489863",
      "client_email": "GONZALEZBOLIVAR66@GMAIL.COM",
      "address": "CALLE 3 CASA NRO 143 CONJUNTO RESIDENCIAL ISAAC OLIVEIRA TURMERO",
      "client_identification": "V8805785",
      "nap_box_name": "CTO-00259",
      "created_at": "2024-08-01T17:42:01.913518",
      "service_detail": {
        "id": 11809,
        "ip": "172.20.157.2",
        "mac": "TPLGB954E8AB",
        "serial": "TPLGB954E8AB",
        "queue": null,
        "interface": "VLAN107_ISAAC_O",
        "created_at": "2026-02-27T11:42:40.137079",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6007,
      "client_name": "EVELIO ANTONIO MIRANDA CEDRES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Isaac Oliveira",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04143463124",
      "client_email": "E_MIRANDA_1@HOTMAIL.COM",
      "address": "CALLE 2 CASA NRO 75 ISAAC OLIVEIRA TURMERO",
      "client_identification": "V8730419",
      "nap_box_name": "CTO-00262",
      "created_at": "2024-08-01T17:53:02.360605",
      "service_detail": {
        "id": 11813,
        "ip": "172.20.155.2",
        "mac": "TPLGB954FB6E",
        "serial": "TPLGB954FB6E",
        "queue": null,
        "interface": "VLAN107_ISAAC_O",
        "created_at": "2026-02-27T11:44:18.616921",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6008,
      "client_name": "RAFAEL EDUARDO RIVAS SALAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Isaac Oliveira",
      "plan": {
        "id": 16,
        "name": "RECURRENTE RESIDENCIAL PLAN 800M",
        "cost": "55.00",
        "code": "FOR800",
        "profile": "800M/800M"
      },
      "client_mobile": "04121331302",
      "client_email": "REACXD@GMAIL.COM",
      "address": "CALLE 2 CASA NRO 40 IRB ISAAC OLIVEIRA TURMERO",
      "client_identification": "V20068992",
      "nap_box_name": "CTO-00262",
      "created_at": "2024-08-01T17:54:57.402266",
      "service_detail": {
        "id": 11832,
        "ip": "172.20.177.2",
        "mac": "TPLGB954FCF9",
        "serial": "TPLGB954FCF9",
        "queue": null,
        "interface": "VLAN100_OLTs",
        "created_at": "2026-02-27T11:50:31.699022",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6009,
      "client_name": "MARIELA MENDEZ SALOM",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Isaac Oliveira",
      "plan": {
        "id": 43,
        "name": "RECURRENTE RESIDENCIAL PLAN 650M",
        "cost": "46.00",
        "code": "FOR650M",
        "profile": "650M/650M"
      },
      "client_mobile": "04243132697",
      "client_email": "MMENDEZSALOM@GMAIL.COM",
      "address": "CALLE 2 CASA NRO 46 URB ISAAC OLIVEIRA SAMAN DE GUERE ARAGUA",
      "client_identification": "V5887506",
      "nap_box_name": "CTO-00262",
      "created_at": "2024-08-01T17:57:42.341426",
      "service_detail": {
        "id": 11823,
        "ip": "172.20.179.2",
        "mac": "TPLGB954F79A",
        "serial": "TPLGB954F79A",
        "queue": null,
        "interface": "VLAN107_ISAAC_O",
        "created_at": "2026-02-27T11:47:24.146179",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6010,
      "client_name": "GESLY JACKELINE HERRERA FRAGOZA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04142295558",
      "client_email": "GESHERRER@GMAIL.COM",
      "address": "CALLE RIVAS EDIF CAYCAPE PISO 1 APT 3-1 ANTIGUA HACIENDA EL NISPERO TURMERO",
      "client_identification": "V21466655",
      "nap_box_name": "130",
      "created_at": "2024-08-01T17:59:20.571531",
      "service_detail": {
        "id": 5173,
        "ip": "172.20.165.2",
        "mac": "TPLGB954FECD",
        "serial": "TPLGB954FECD",
        "queue": "Plan_92284_15811_WispHub",
        "interface": "VLAN209_ZAMORA_OLT1",
        "created_at": "2024-08-15T10:40:31.706128",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6011,
      "client_name": "HILMAR COROMOTO APONTE ROA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243440712",
      "client_email": "Brakooo90@gmail.com",
      "address": "CALLE 10 CASA NRO A26 PB URB MATACABALLO 4142285985",
      "client_identification": "V17643716",
      "nap_box_name": "CTO-00569 DOS",
      "created_at": "2024-08-01T18:26:08.049216",
      "service_detail": {
        "id": 4414,
        "ip": "172.17.189.2",
        "mac": "VSOL00520BA1",
        "serial": "VSOL00520BA1",
        "queue": "Plan_161892_30183_WispHub",
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2024-08-09T20:51:13.639109",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6012,
      "client_name": "YUNEIDY SARAI SUAREZ ROJAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Durpa",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04123988388",
      "client_email": "ACDANAYSUAREZ@GMAIL.COM",
      "address": "CALLE LIBERTAD CASA NRO 37 URB DESARROLLO URBANISITICO SECTOR DURPA",
      "client_identification": "V22696875",
      "nap_box_name": "258",
      "created_at": "2024-08-01T18:27:47.343652",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6013,
      "client_name": "DESIREE LIZMARY GARCIA PARGA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Durpa",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243045732",
      "client_email": "GARCIADESIREE8@GMAIL.COM",
      "address": "CALLE LIBERTAD MANZANA 16 CASA NRO 18 SECTOR DESARROLLO URBANISTICO DURPA",
      "client_identification": "V15601953",
      "nap_box_name": "258",
      "created_at": "2024-08-01T18:29:42.001732",
      "service_detail": {
        "id": 4465,
        "ip": "172.17.211.2",
        "mac": "VSOL00522C81",
        "serial": "VSOL00522C81",
        "queue": "Plan_161892_30183_WispHub",
        "interface": "VLAN240_DURPA",
        "created_at": "2024-08-09T22:42:10.633697",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6014,
      "client_name": "ENRIQUETA ANTONIA RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Durpa",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144699944",
      "client_email": "ENRIQUETARODRI13@GMAIL.COM",
      "address": "CALLE LIBERTAD MANZANA 14 CASA NRO 22 SECTOR DESARROLLO URBANISTICO DURPA",
      "client_identification": "V8625286",
      "nap_box_name": "377",
      "created_at": "2024-08-01T18:32:15.869718",
      "service_detail": {
        "id": 4467,
        "ip": "172.17.216.2",
        "mac": "VSOL00521299",
        "serial": "VSOL00521299",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN240_DURPA",
        "created_at": "2024-08-09T22:44:47.462566",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6015,
      "client_name": "SARA VIASNEY RAMIREZ BOLIVAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Durpa",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124338724",
      "client_email": "SVRB1973@GMAIL.COM",
      "address": "CALLE LIBERTAD MANZANA 16 CASA NRO 01 SECTOR DESARROLLO URBANISTICO",
      "client_identification": "V11785200",
      "nap_box_name": "377",
      "created_at": "2024-08-01T18:33:38.549254",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6016,
      "client_name": "MERLY JOSEFINA GIL",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Durpa",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128989666",
      "client_email": "MERLYGIL024@GMAIL.COM",
      "address": "CALLE LIBERTAD QTA MANZANA 14 CASA NRO 29 SECTOR DESARROLLO URBANISTICO DURPA",
      "client_identification": "V12337057",
      "nap_box_name": "377",
      "created_at": "2024-08-01T18:34:59.008938",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6017,
      "client_name": "KATIUSKA DEL VALLE TORO DE GUTIERREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Durpa",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04123987619",
      "client_email": "EMPKATIUSKATORO2010@GMAIL.COM",
      "address": "CALLE LIBERTAD QTA MANZAZNA 16 NRO 10 SECTOR DESARROLLO URBANISTICO DURPA",
      "client_identification": "V16435132",
      "nap_box_name": "377",
      "created_at": "2024-08-01T18:36:54.709440",
      "service_detail": {
        "id": 4473,
        "ip": "172.17.204.2",
        "mac": "VSOL00522EA9",
        "serial": "VSOL00522EA9",
        "queue": "Plan_161893_30183_WispHub",
        "interface": "VLAN240_DURPA",
        "created_at": "2024-08-09T22:53:37.531975",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6018,
      "client_name": "TANIA JEANNETTE BLANCO DE PADILLA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Durpa",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121485470",
      "client_email": "TJBP1234@GMAIL.COM",
      "address": "AV PASEO LIBERTADOR CON CALLE LIBERTAD MANZANA 14 CASA NRO 21 SECTOR DESARROLLO URBANISTICO DURPA",
      "client_identification": "V10753844",
      "nap_box_name": "377",
      "created_at": "2024-08-01T18:40:14.774947",
      "service_detail": {
        "id": 12226,
        "ip": "172.17.214.2",
        "mac": "VSOL00521F51",
        "serial": "VSOL00521F51",
        "queue": null,
        "interface": "VLAN240_DURPA",
        "created_at": "2026-03-30T20:51:14.469356",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6019,
      "client_name": "MARELIA TIBISAY RAMOS DAVILA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121346132",
      "client_email": "MARELI.TR39@GMAIL.COM",
      "address": "CALLE 1 CASA NRO 17 BARRIO PRADOS DE PAYA 1",
      "client_identification": "V13454946",
      "nap_box_name": "585 DOS",
      "created_at": "2024-08-01T18:42:53.448874",
      "service_detail": {
        "id": 4477,
        "ip": "172.17.115.2",
        "mac": "VSOL00522C99",
        "serial": "VSOL00522C99",
        "queue": "Plan_161892_30183_WispHub",
        "interface": "VLAN239_PRADOS1",
        "created_at": "2024-08-10T08:12:11.958369",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6020,
      "client_name": "ABRAHAM JESUS SANDOVAL SANDOVAL",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04143473885",
      "client_email": "ABRAHAMJESUSSANSAN@GMAIL.COM",
      "address": "CALLE 4B CASA NRO 27 URB PANTIN ROSARIO DE PAYA",
      "client_identification": "V18644109",
      "nap_box_name": "CTO-00134",
      "created_at": "2024-08-01T18:46:37.947177",
      "service_detail": {
        "id": 4478,
        "ip": "172.18.7.2",
        "mac": "VSOL0012E0B1",
        "serial": "VSOL0012E0B1",
        "queue": "Plan_161891_30183_WispHub",
        "interface": "VLAN229_PANTIN",
        "created_at": "2024-08-10T08:15:04.739146",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6021,
      "client_name": "JOSE MIGUEL VALLARIO ECHENIQUE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Huerta Los Pajaros",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04140510855",
      "client_email": "TREVALL8485@HOTMAIL.COM",
      "address": "CALLE PRINCIPAL CASA NRO 12 URB HUERTA LOS PARAJOS ROSARIO DE PAYA ARAGUA",
      "client_identification": "V16434091",
      "nap_box_name": "96",
      "created_at": "2024-08-01T18:48:52.052433",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6022,
      "client_name": "MAGGLYN LEONOR ZERPA AGUILAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Antonio Jose de Sucre",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124001563",
      "client_email": "MAGGLYNZERPA@GMAIL.COM",
      "address": "CALLE HENRY PITTIER CASA NRO 35 BARRIO ANTONIO JOSE DE SUCRE",
      "client_identification": "V9671875",
      "nap_box_name": "173",
      "created_at": "2024-08-01T18:51:06.337323",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6023,
      "client_name": "VERONICA VALENTINA ALVAREZ VALERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144463481",
      "client_email": "VAVV0822V@GMAIL.COM",
      "address": "CALLE RIVAS EDIF 5 PISO 3 APT 3-4 CONJUNTO RESIDENCIAL EL NISPERO TURMERO",
      "client_identification": "V19790101",
      "nap_box_name": "CTO-00032 DOS",
      "created_at": "2024-08-01T19:13:14.240387",
      "service_detail": {
        "id": 6332,
        "ip": "172.20.163.2",
        "mac": "TPLGB954EF48",
        "serial": "TPLGB954EF48",
        "queue": "queue1",
        "interface": "VLAN209_ZAMORA_OLT1",
        "created_at": "2024-08-25T20:40:39.768831",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6024,
      "client_name": "JESUS FELIPE MARIN VIZCAYA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04144773950",
      "client_email": "MARINJ1422@GMAIL.COM",
      "address": "CALLE PRINCIPAL EDIF URQUIA TORRE 2 PISO 1 APT 01 HACIENDA EL NISPERO TURMERO",
      "client_identification": "V15473100",
      "nap_box_name": "CTO-00296",
      "created_at": "2024-08-01T19:15:08.340529",
      "service_detail": {
        "id": 8662,
        "ip": "172.20.162.2",
        "mac": "TPLGB954FC9F",
        "serial": "TPLGB954FC9F",
        "queue": "Plan_107915_15811_WispHub",
        "interface": "VLAN209_ZAMORA_OLT1",
        "created_at": "2025-05-16T15:49:35.886665",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6025,
      "client_name": "LENNIS RAFAEL HERRERA FRAGOZA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04142942077",
      "client_email": "LENNISRAFAELHF@GMAIL.COM",
      "address": "CALLE CARREÑO  EDIF CAYCAPE PISO 3 APT 3-1 URB ANTIGUA HACIENDA EL NISPERO TURMERO",
      "client_identification": "V25527409",
      "nap_box_name": "130",
      "created_at": "2024-08-01T19:17:43.334332",
      "service_detail": {
        "id": 5170,
        "ip": "172.20.234.2",
        "mac": "TPLGB954F988",
        "serial": "TPLGB954F988",
        "queue": "Plan_92284_15811_WispHub",
        "interface": "VLAN209_ZAMORA_OLT1",
        "created_at": "2024-08-15T10:36:00.252299",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6026,
      "client_name": "TRINY MARIHECT APOSTOL HERNANDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243651307",
      "client_email": "TRINYAPOSTOL@GMAIL.COM",
      "address": "CALLE 1 EDF CAYCAPE PISO 1 APT 06 ANTIGUA HACIENDA  EL NISPERO TURMERO",
      "client_identification": "V30923755",
      "nap_box_name": "130",
      "created_at": "2024-08-01T19:20:14.150620",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6027,
      "client_name": "JEYSI CAROLINA ARAUJO ROSO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Concepcion",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121598614",
      "client_email": "LADDEOKE@GMAIL.COM",
      "address": "CALLE LOS CHAGUARAMOS CASA NRO 18 SECTOR LA CONCEPCION TURMERO",
      "client_identification": "V9960893",
      "nap_box_name": "108",
      "created_at": "2024-08-01T19:24:13.849636",
      "service_detail": {
        "id": 5167,
        "ip": "172.21.4.2",
        "mac": "TPLGB954F774",
        "serial": "TPLGB954F774",
        "queue": "Plan_131647_24341_WispHub",
        "interface": "VLAN111_CONCEPCION",
        "created_at": "2024-08-15T10:30:50.870135",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6028,
      "client_name": "DAYANA MAIGUALIDA MELENDEZ MANZANO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "San Carlos",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243168813",
      "client_email": "DAYANAFLAK@HOTMAIL.COM",
      "address": "CALLE C CASA NRO D-6 SAN CARLOS TURMERO",
      "client_identification": "V13454217",
      "nap_box_name": "136",
      "created_at": "2024-08-01T19:30:17.093309",
      "service_detail": {
        "id": 5166,
        "ip": "172.20.198.2",
        "mac": "TPLGB954EFEF",
        "serial": "TPLGB954EFEF",
        "queue": "Plan_92284_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-08-15T10:28:28.827688",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6029,
      "client_name": "IRENE GERARDINE TORRES FUENTES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Residencias Mariño",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243517770",
      "client_email": "IREGTF27@GMAIL.COM",
      "address": "AV MARIÑO EDIF TORRE B PISO 12 APTO B-121 CONJUNTO RESIDENCIAL MARIÑO TURMERO",
      "client_identification": "V20119392",
      "nap_box_name": "CTO-0519",
      "created_at": "2024-08-01T19:32:52.433924",
      "service_detail": {
        "id": 5165,
        "ip": "172.20.223.2",
        "mac": "TPLGB954E844",
        "serial": "TPLGB954E844",
        "queue": "Plan_92284_15811_WispHub",
        "interface": "VLAN100_OLTs",
        "created_at": "2024-08-15T10:25:06.600819",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6030,
      "client_name": "MILAGRO YAKARY ROJAS PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Antonio Jose de Sucre",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128867413",
      "client_email": "MILAGROSRP.26@GMAIL.COM",
      "address": "CALLE 25 DE AGOSTO CASA NRO 8 URB ANTONIO JOSE DE SUCRE SECTOR EL MACARO TURMERO",
      "client_identification": "V24173176",
      "nap_box_name": "173",
      "created_at": "2024-08-02T09:20:53.043700",
      "service_detail": {
        "id": 5110,
        "ip": "172.25.169.2",
        "mac": "TPLGC3C6BBC1",
        "serial": "TPLGC3C6BBC1",
        "queue": "Plan_137413_1574_WispHub",
        "interface": "VLAN101_AJS",
        "created_at": "2024-08-14T15:39:15.903737",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6031,
      "client_name": "RONALD JOSE BOLIVAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Antonio Jose de Sucre",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128743278",
      "client_email": "ADRIANATIMPERIFURINO@GMAIL.COM",
      "address": "CALLE 25 DE AGOSTO AV EL MACARO CASA NRO 5 URB ANTONIO JOSE DE SUCRE TURMERO ARAGUA",
      "client_identification": "V13907454",
      "nap_box_name": "123",
      "created_at": "2024-08-02T09:26:21.024124",
      "service_detail": {
        "id": 12182,
        "ip": "172.17.91.2",
        "mac": "TPLGC3CCB7D8",
        "serial": "TPLGC3CCB7D8",
        "queue": null,
        "interface": "VLAN101_AJS",
        "created_at": "2026-03-25T19:33:16.024718",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6032,
      "client_name": "CARMEN VICTORIA PALACIOS CARPIO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Floresta",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243599441",
      "client_email": "PALACIOSVICTORIA77@GMAIL.COM",
      "address": "MANZANA F CASA NRO 13 URB LA FLORESTA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V10671525",
      "nap_box_name": "CTO-00107 ",
      "created_at": "2024-08-02T09:28:25.380422",
      "service_detail": {
        "id": 5149,
        "ip": "172.20.72.2",
        "mac": "TPLGB8628426",
        "serial": "TPLGB8628426",
        "queue": "Plan_153953_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-08-15T09:32:48.882970",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6033,
      "client_name": "JOHAN JESUS GONZALEZ ZORRILLA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Magdalena",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128883635",
      "client_email": "JOHANF12@GMAIL.COM",
      "address": "CALLE 17 NRO 9 URB LA MAGDALENA",
      "client_identification": "V20108631",
      "nap_box_name": "394",
      "created_at": "2024-08-02T09:30:37.727055",
      "service_detail": {
        "id": 4482,
        "ip": "172.17.104.2",
        "mac": "VSOL00521609",
        "serial": "VSOL00521609",
        "queue": "Plan_131648_24341_WispHub",
        "interface": "VLAN114_MAGDALENA",
        "created_at": "2024-08-10T08:28:00.482654",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6034,
      "client_name": "EDEL RYA JAGOO BAHADOOR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Floresta",
      "plan": {
        "id": 16,
        "name": "RECURRENTE RESIDENCIAL PLAN 800M",
        "cost": "55.00",
        "code": "FOR800",
        "profile": "800M/800M"
      },
      "client_mobile": "04145981968",
      "client_email": "JAGOOEDEL79@GMAIL.COM",
      "address": "CALLE 2 CASA NRO F-5 URB PARQUE RESIDENCIAL LA FLORESTA TURMERO ARAGUA",
      "client_identification": "E81959564",
      "nap_box_name": "32 DOS",
      "created_at": "2024-08-02T09:31:07.792032",
      "service_detail": {
        "id": 9824,
        "ip": "172.20.76.2",
        "mac": "TPLGB862836C",
        "serial": "TPLGB862836C",
        "queue": null,
        "interface": "VLAN212_FLORESTA_OLT1",
        "created_at": "2025-11-10T17:11:57.644950",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6035,
      "client_name": "ESTEFANIA DE ABREU CARRIZO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Floresta",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04140393490",
      "client_email": "DEABREUESTEFANIA@GMAIL.COM",
      "address": "CALLE NEGRO PRIMERO CASA NRO D16 URB LA FLORESTA TURMERO ARAGUA",
      "client_identification": "V27520658",
      "nap_box_name": "32 DOS",
      "created_at": "2024-08-02T09:32:53.307538",
      "service_detail": {
        "id": 5184,
        "ip": "172.20.84.2",
        "mac": "TPLGB86280DF",
        "serial": "TPLGB86280DF",
        "queue": "Plan_153953_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-08-15T11:29:31.304583",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6036,
      "client_name": "MERLY YAMILET SANCHEZ CASADIEGO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04124390174",
      "client_email": "MERLYNEGRA@GMAIL.COM",
      "address": "CALLE MANZANA D 8 CASA NRO 14 URB SAMAN TARAZONERO II TURMERO",
      "client_identification": "V13578554",
      "nap_box_name": "268",
      "created_at": "2024-08-02T09:33:35.415361",
      "service_detail": {
        "id": 10916,
        "ip": "172.20.228.2",
        "mac": "TPLGB954FBF9",
        "serial": "TPLGB954FBF9",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2025-12-23T15:06:30.803036",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6037,
      "client_name": "WIRLEY BEJARANO BRAVO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04127660768",
      "client_email": "MERARI.1714@GMAIL.COM",
      "address": "CALLE CALLE 3 CASA PÁRASELA NRO 179 SECTOR LUZ Y VIDA ROSARIO DE PAYA ARAGUA",
      "client_identification": "V19552558",
      "nap_box_name": "CTO-00118 DOS",
      "created_at": "2024-08-02T09:34:31.804561",
      "service_detail": {
        "id": 11096,
        "ip": "172.31.34.2",
        "mac": "OEMT3C625546",
        "serial": "OEMT3C625546",
        "queue": null,
        "interface": "VLAN242_PRADOS2",
        "created_at": "2026-01-11T15:56:55.325259",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6038,
      "client_name": "SHALON DANIELA VILORIA MENDOZA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Magdalena",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128373937",
      "client_email": "SHALONVILORIA13@GMAIL.COM",
      "address": "CALLE 3 CASA NRO 13 SECTOR LA MAGDALENA",
      "client_identification": "V29650894",
      "nap_box_name": "CTO-00472 DOS",
      "created_at": "2024-08-02T09:34:47.700897",
      "service_detail": {
        "id": 9897,
        "ip": "172.17.223.2",
        "mac": "VSOL00521429",
        "serial": "VSOL00521429",
        "queue": null,
        "interface": "VLAN114_MAGDALENA",
        "created_at": "2025-11-10T22:06:05.665743",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6039,
      "client_name": "ANIBAL JOSE SALAZAR NADALES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Floresta",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243083600",
      "client_email": "JUANSAL233@GMAIL.COM",
      "address": "CALLE 1 CASA NRO 1-B URB LA FLORESTA TURMERO ESTADO ARAGUA",
      "client_identification": "V13012393",
      "nap_box_name": "34 DOS",
      "created_at": "2024-08-02T09:37:32.187615",
      "service_detail": {
        "id": 12443,
        "ip": "172.20.78.2",
        "mac": "TPLGB86283EB",
        "serial": "TPLGB86283EB",
        "queue": null,
        "interface": "VLAN212_FLORESTA_OLT1",
        "created_at": "2026-05-01T12:25:58.788389",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6041,
      "client_name": "JERDROIS CAROLINA GALLARDO PEÑA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Isaac Oliveira",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121575882",
      "client_email": "CAROLAGALLARDO2603@GMAIL.COM",
      "address": "CALLE 3 CASA NRO 134 SECTOR ISAAC OLIVEIRA",
      "client_identification": "V22029445",
      "nap_box_name": "CTO-00259",
      "created_at": "2024-08-02T09:45:41.364227",
      "service_detail": {
        "id": 11830,
        "ip": "172.18.70.2",
        "mac": "VSOL00522DE9",
        "serial": "VSOL00522DE9",
        "queue": null,
        "interface": "VLAN107_ISAAC_O",
        "created_at": "2026-02-27T11:49:23.342790",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6042,
      "client_name": "VIRGINIA VICTORIA ARTEAGA  MENDOZA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona II Edificios",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04128730196",
      "client_email": "VIVIARMEN25@GMAIL.COM",
      "address": "AV SANTIAGO MARIÑO EDIF 14 PISO 2 APTO 02 LA CASONA II TURMERO",
      "client_identification": "V17174771",
      "nap_box_name": "CTO-0540",
      "created_at": "2024-08-02T09:46:15.502686",
      "service_detail": {
        "id": 11795,
        "ip": "172.20.239.2",
        "mac": "TPLGF5CB04F3",
        "serial": "TPLGF5CB04F3",
        "queue": null,
        "interface": "VLAN110_CASONA_2",
        "created_at": "2026-02-27T11:22:52.458748",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6043,
      "client_name": "GLEIVIC ISAMAR TOVAR BARRETO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243847828",
      "client_email": "GLEIVICTOVAR@GMAIL.COM",
      "address": "PRADOS I, CALLE 7, CASA 5, PAYA, ARAGUA",
      "client_identification": "V25607584",
      "nap_box_name": "CTO-00162",
      "created_at": "2024-08-02T09:47:05.951199",
      "service_detail": {
        "id": 4183,
        "ip": "172.31.35.2",
        "mac": "OEMT3C6232CA",
        "serial": "OEMT3C6232CA",
        "queue": "Plan_161895_30183_WispHub",
        "interface": "VLAN239_PRADOS1",
        "created_at": "2024-08-03T13:59:17.935540",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6044,
      "client_name": "ZULEMA GRAFF ROSILLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Isaac Oliveira",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04140394866",
      "client_email": "GRZULEMA330@GMAIL.COM",
      "address": "CALLE 2 CASA NRO 43 URB ISAAC OLIVEIRA",
      "client_identification": "V5272366",
      "nap_box_name": "CTO-00262",
      "created_at": "2024-08-02T09:48:29.775351",
      "service_detail": {
        "id": 11826,
        "ip": "172.17.220.2",
        "mac": "VSOL00521459",
        "serial": "VSOL00521459",
        "queue": null,
        "interface": "VLAN107_ISAAC_O",
        "created_at": "2026-02-27T11:48:08.135501",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6046,
      "client_name": "YILDA TIBISAY TOVAR ABREU",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04127406576",
      "client_email": "YILDATOVAR4@GMAIL.COM",
      "address": "CALLE MANZANA C3 VIA  EL MACARO  CASA NRO 04 SAMAN TARAZONERO II",
      "client_identification": "V7264060",
      "nap_box_name": "115",
      "created_at": "2024-08-02T09:51:15.141634",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6047,
      "client_name": "DAMARIS DANIELA ROJAS MOTA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243124151",
      "client_email": "DAMARISR010819@GMAIL.COM",
      "address": "CALLE 9 CASA NRO 607-B URB MATACABALLO",
      "client_identification": "V27168301",
      "nap_box_name": "CE - 566",
      "created_at": "2024-08-02T09:54:24.090253",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6048,
      "client_name": "YUSBELY FRANCISCA GUYON PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121768446",
      "client_email": "YUSBELYGUYON@GMAIL.COM",
      "address": "CALLE 14 CASA NRO 15 LA CASONA II TURMERO",
      "client_identification": "V15100191",
      "nap_box_name": "CTO-00088",
      "created_at": "2024-08-02T09:59:13.411666",
      "service_detail": {
        "id": 5158,
        "ip": "172.21.53.2",
        "mac": "TPLGF5CB0686",
        "serial": "TPLGF5CB0686",
        "queue": "Plan_132787_24341_WispHub",
        "interface": "VLAN100_OLTs",
        "created_at": "2024-08-15T10:07:47.954776",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6049,
      "client_name": "GABRIEL SHARIFF RODRIGUEZ ALI",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona II Edificios",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243016599",
      "client_email": "GSHARIFF02@HOTMAIL.COM",
      "address": "AV INTERCOMUNAL EDF 14 PISO 2 APT 3 CONJUNTO RESIDENCIAL LA CASONA II TURMERO",
      "client_identification": "V22952537",
      "nap_box_name": "CTO-0540",
      "created_at": "2024-08-02T10:01:36.327386",
      "service_detail": {
        "id": 11772,
        "ip": "172.21.59.2",
        "mac": "TPLGB954FCAA",
        "serial": "TPLGB954FCAA",
        "queue": null,
        "interface": "VLAN110_CASONA_2",
        "created_at": "2026-02-27T10:44:15.669002",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6050,
      "client_name": "IVET YUSELYS SARMIENTO CASTILLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243543257",
      "client_email": "IVETSARMIENTO69@GMAIL.COM",
      "address": "AV 09 CASA NRO 585-C SECTOR MATACABALLO",
      "client_identification": "V16863518",
      "nap_box_name": "CE - 566",
      "created_at": "2024-08-02T10:05:07.328727",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6051,
      "client_name": "JUAN ANTONIO SANTANA HERNANDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243037543",
      "client_email": "JUANTONIOSANTANA@GMAIL.COM",
      "address": "CALLE 12 CASA NRO 688-D URB MATACABALLO",
      "client_identification": "V16760867",
      "nap_box_name": "CTO-00210",
      "created_at": "2024-08-02T10:13:24.234243",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6052,
      "client_name": "LILIA MERCEDES TORRES NOGUERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243220513",
      "client_email": "ISAMARPALACIOS.145@GMAIL.COM",
      "address": "VDA D-3 CASA NRO 1 SAMAN TARAZONERO II TURMERO",
      "client_identification": "V7195336",
      "nap_box_name": "163",
      "created_at": "2024-08-02T10:13:55.470633",
      "service_detail": {
        "id": 11645,
        "ip": "172.20.205.2",
        "mac": "TPLGB954E814",
        "serial": "TPLGB954E814",
        "queue": null,
        "interface": "VLAN100_OLTs",
        "created_at": "2026-02-17T15:32:45.855634",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6053,
      "client_name": "FRANCY JOSELI MORALES CARMONA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243286316",
      "client_email": "FRANCYMORALES666@GMAIL.COM",
      "address": "CALLE 9 CASA NRO 601-A SECTOR MATACABALLO",
      "client_identification": "V14787962",
      "nap_box_name": "CE - 567",
      "created_at": "2024-08-02T10:20:28.870927",
      "service_detail": {
        "id": 10103,
        "ip": "172.18.73.2",
        "mac": "VSOL00520A79",
        "serial": "VSOL00520A79",
        "queue": null,
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2025-11-13T14:55:46.621894",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6054,
      "client_name": "FREDDY JOSE MORENO DIAZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04145989749",
      "client_email": "FJMD489@GMAIL.COM",
      "address": "CALLE 7 CASA NRO 554-B MATACABALLO",
      "client_identification": "V12929300",
      "nap_box_name": "CTO-00310",
      "created_at": "2024-08-02T10:26:42.264828",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6055,
      "client_name": "ELIAS JESUS IDILBI ABRIHAM",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128906289",
      "client_email": "ELIASIDILBI2120@GMAIL.COM",
      "address": "MATACABALLO CALLE 10 CASA NRO 623-C",
      "client_identification": "V21202718",
      "nap_box_name": "CTO-00143",
      "created_at": "2024-08-02T10:33:58.691753",
      "service_detail": {
        "id": 4724,
        "ip": "172.17.164.2",
        "mac": "VSOL00520B39",
        "serial": "VSOL00520B39",
        "queue": "Plan_161865_30181_WispHub",
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2024-08-12T13:16:35.264563",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6056,
      "client_name": "LUISA ELENA BLANCO GARCIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243061222",
      "client_email": "BLACOLUISA8@GMAIL.COM",
      "address": "CALLE 7 CASA NRO 555B SECTOR MATACABALLO",
      "client_identification": "V10751354",
      "nap_box_name": "CTO-00310",
      "created_at": "2024-08-02T10:37:39.972512",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6057,
      "client_name": "ZAIDA LISBETH NIEVES URQUIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04127669312",
      "client_email": "KATHERINNEARELLANO@GMAIL.COM",
      "address": "CALLE E-1 CASA NRO 8  SAMAN TARAZONERO II SECTOR EL MACARO",
      "client_identification": "V10756655",
      "nap_box_name": "112",
      "created_at": "2024-08-02T10:38:24.928230",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6058,
      "client_name": "MIGUEL ALFONSO BLANCO TORRES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243539356",
      "client_email": "OBA8MORO8@GMAIL.COM",
      "address": "AV CASA NRO 500 URB MATACABALLO ROSARIO DE PAYA ARAGUA",
      "client_identification": "V27286580",
      "nap_box_name": "CTO-00457",
      "created_at": "2024-08-02T10:39:23.202798",
      "service_detail": {
        "id": 4747,
        "ip": "172.17.139.2",
        "mac": "VSOL00520811",
        "serial": "VSOL00520811",
        "queue": "Plan_161892_30183_WispHub",
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2024-08-12T14:46:10.542081",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6059,
      "client_name": "ELBINIA YOSELIN MARTINEZ RIVERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Valle Paraiso",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04127491656",
      "client_email": "YOSEMAR@GMAIL.COM",
      "address": "CALLE PRINCIPAL VALLE PARAISO CASA MANZANA 3 NRO 15 TURMERO",
      "client_identification": "V18640276",
      "nap_box_name": "CTO-0643",
      "created_at": "2024-08-02T10:40:35.584302",
      "service_detail": {
        "id": 9853,
        "ip": "172.21.103.2",
        "mac": "TPLGB954E8FC",
        "serial": "TPLGB954E8FC",
        "queue": null,
        "interface": "VLAN227_V_PARAISO_OLT1",
        "created_at": "2025-11-10T18:10:55.493197",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6060,
      "client_name": "MERCEDES CECILIA GUZMAN AGUIRRE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Los Nisperos",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144922093",
      "client_email": "ACECIGUZMAN@GMAIL.COM",
      "address": "URB  LOS NISPEROS CALLE LOS NISPEROS NRO 36",
      "client_identification": "V4405574",
      "nap_box_name": "210",
      "created_at": "2024-08-02T10:42:32.878470",
      "service_detail": {
        "id": 5209,
        "ip": "172.22.104.2",
        "mac": "TPLGB68B4E03",
        "serial": "TPLGB68B4E03",
        "queue": "Plan_153953_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-08-15T13:40:09.051233",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6061,
      "client_name": "MAYERLING YNES AVILA HERNANDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Isaac Oliveira",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144780900",
      "client_email": "MAYERLINGYNES@GMAIL.COM",
      "address": "CALLE 1 CASA NRO 23 URB ISAAC OLIVEIRA",
      "client_identification": "V9657340",
      "nap_box_name": "CTO-00257",
      "created_at": "2024-08-02T10:42:33.520177",
      "service_detail": {
        "id": 11812,
        "ip": "172.26.32.2",
        "mac": "VSOL00521601",
        "serial": "VSOL00521601",
        "queue": null,
        "interface": "VLAN107_ISAAC_O",
        "created_at": "2026-02-27T11:43:54.595638",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6062,
      "client_name": "LUZ MARILYN ZAMBRANO AMADOR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Valle Paraiso",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243537539",
      "client_email": "MARYHOPE95M@GMAIL.COM",
      "address": "CALLE 11 NRO 15-16 URB  VALLE PARAISO TURMERO",
      "client_identification": "V25620492",
      "nap_box_name": "CE-00254",
      "created_at": "2024-08-02T10:45:05.528063",
      "service_detail": {
        "id": 5144,
        "ip": "172.21.65.2",
        "mac": "TPLGB954E789",
        "serial": "TPLGB954E789",
        "queue": "Plan_92284_15811_WispHub",
        "interface": "VLAN227_V_PARAISO_OLT1",
        "created_at": "2024-08-15T09:17:25.827037",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6063,
      "client_name": "CARMEN ROMELIA MENDEZ DE SANCTIS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Los Nisperos",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243378305",
      "client_email": "ROMYSALVA59@GMAIL.COM",
      "address": "CALLE LOS NISPEROS. URB LOS NISPEROS FRENTE AL COLEGIO DE MONJAS MARIA INMACULADA.",
      "client_identification": "V4407169",
      "nap_box_name": "210",
      "created_at": "2024-08-02T10:45:26.530225",
      "service_detail": {
        "id": 13125,
        "ip": "172.19.40.2",
        "mac": "TP:LG:B9:55:02:64",
        "serial": "TPLGB9550264",
        "queue": null,
        "interface": "VLAN200_OLTs",
        "created_at": "2026-10-06T08:36:33.025979",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6064,
      "client_name": "FERNANDO ANTONIO CAMACHO PRATO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04127763142",
      "client_email": "FERCAM3112@GMAIL.COM",
      "address": "CALLE 6 CASA NRO 54 URB HACIENDA PANTIN",
      "client_identification": "V7189148",
      "nap_box_name": "CTO-00138",
      "created_at": "2024-08-02T10:45:51.414262",
      "service_detail": {
        "id": 10754,
        "ip": "172.17.231.2",
        "mac": "QXTLCB5C4BCE",
        "serial": "QXTLCB5C4BCE",
        "queue": null,
        "interface": "VLAN229_PANTIN",
        "created_at": "2025-12-16T16:30:48.295203",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6065,
      "client_name": "JOSE HILARIO GONCALVES DOS REIS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Laguna Plaza",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128447702",
      "client_email": "YOSELINPESTANA@GMAIL.COM",
      "address": "CALLE NEGRO PRIMERO C/C CAMILO TORRES EDIF 3 PISO PB APTO PB-2 CONJUNTO RESIDENCIAL LAGUNA PLAZA, TURMERO ESTADO ARAGUA",
      "client_identification": "V11979445",
      "nap_box_name": "1",
      "created_at": "2024-08-02T10:46:53.047508",
      "service_detail": {
        "id": 5213,
        "ip": "172.18.116.2",
        "mac": "TPLGB8628435",
        "serial": "TPLGB8628435",
        "queue": "Plan_153953_15811_WispHub",
        "interface": "VLAN216_LAGUNA_PLAZA_OLT1",
        "created_at": "2024-08-15T13:45:53.899184",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6066,
      "client_name": "JANETH DEL CARMEN CONTRERAS DE GOMEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04120375393",
      "client_email": "eurostylevnzl@gmail.com",
      "address": "CALLE 12A CASA NRO 7 URB PANTIN ROSARIO DE PAYA",
      "client_identification": "V13132498",
      "nap_box_name": "CTO-00165",
      "created_at": "2024-08-02T10:49:19.579293",
      "service_detail": {
        "id": 9603,
        "ip": "172.17.254.2",
        "mac": "VSOL0013EAB1",
        "serial": "VSOL0013EAB1",
        "queue": null,
        "interface": "VLAN229_PANTIN",
        "created_at": "2025-10-10T17:14:35.592591",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6067,
      "client_name": "RICHARD JOSE CEDENO MOYA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04243647648",
      "client_email": "RICHARDJOSEMOYA@GMAIL.COM",
      "address": "CALLE VILLA CASTIN  CASA NRO 10-1 SECTOR CENTRO  TURMERO",
      "client_identification": "V11535975",
      "nap_box_name": "CTO-0248",
      "created_at": "2024-08-02T10:51:29.541056",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6068,
      "client_name": "KENEDIS ANTONIO GOMEZ CAMPELO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "San Sebastian",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04128538321",
      "client_email": "BOOTNPC0304@GMAIL.COM",
      "address": "CALLE 7 CASA NRO 1 BARRIO SAN SEBASTIAN TURMERO",
      "client_identification": "V28290485",
      "nap_box_name": "127",
      "created_at": "2024-08-02T10:55:30.356775",
      "service_detail": {
        "id": 5116,
        "ip": "172.21.86.2",
        "mac": "TPLGB954E78A",
        "serial": "TPLGB954E78A",
        "queue": "Plan_112655_1574_WispHub",
        "interface": "VLAN125_SAN_SEBASTIAN_ZTE",
        "created_at": "2024-08-14T15:49:48.460192",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6069,
      "client_name": "LINA EMILIA SUNIAGA RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "San Sebastian",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124628207",
      "client_email": "LINAEMILIA.1212@GMAIL.COM",
      "address": "CALLE 1 CASA NRO 23 URB SAN SEBASTIAN SECTOR EL MACARO TURMERO",
      "client_identification": "V9668292",
      "nap_box_name": "61",
      "created_at": "2024-08-02T10:58:00.970427",
      "service_detail": {
        "id": 8526,
        "ip": "172.21.74.2",
        "mac": "TPLGB954EA27",
        "serial": "TPLGB954EA27",
        "queue": "queue1",
        "interface": "VLAN125_SAN_SEBASTIAN_ZTE",
        "created_at": "2025-05-09T11:49:04.187762",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6070,
      "client_name": "ALBANI DE LOS ANGELES CASTILLO CARDOZO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04145878864",
      "client_email": "ALBANICASTILLO8@GMAIL.COM",
      "address": "CALLE PRINCIPAL CASA NRO 56 BARRIO ANTONIO JOSE DE SUCRE MACARO TURMERO",
      "client_identification": "V29744321",
      "nap_box_name": "128",
      "created_at": "2024-08-02T11:02:56.194078",
      "service_detail": {
        "id": 10040,
        "ip": "172.21.110.2",
        "mac": "TPLGB954FCBD",
        "serial": "TPLGB954FCBD",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2025-11-11T17:47:48.113369",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6071,
      "client_name": "CARLOS ENRRIQUE CASTILLO GAMARRA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "San Sebastian",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04243377247",
      "client_email": "CARLITOSTARS1@GMAIL.COM",
      "address": "VDA DOS VEREDA 1 CASA NRO 26 SECTOR EL MACARO SAN SEBASTIAN",
      "client_identification": "V19247749",
      "nap_box_name": "CTO-00023",
      "created_at": "2024-08-02T11:08:03.899641",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6072,
      "client_name": "YAITZA LISNEY YUSTIS CASTELLANO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Laguna Plaza",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243782986",
      "client_email": "YAITZAYUSTIS@GMAIL.COM",
      "address": "CALLE NEGRO PRIMERO EDIF 09 PISO PB 04 CONJUNTO RESIDENCIAL LAGUNA PLAZA TURMERO EDO ARAGUA",
      "client_identification": "V12144297",
      "nap_box_name": "2",
      "created_at": "2024-08-02T11:11:31.137913",
      "service_detail": {
        "id": 5220,
        "ip": "172.25.138.2",
        "mac": "TPLGB86283EA",
        "serial": "TPLGB86283EA",
        "queue": "Plan_153953_15811_WispHub",
        "interface": "VLAN216_LAGUNA_PLAZA_OLT1",
        "created_at": "2024-08-15T14:13:45.056865",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6073,
      "client_name": "LERMARY JOSEHP SALAS CAMPOS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243120810",
      "client_email": "LERMARYSALAS20@GMAIL.COM",
      "address": "CALLE 14 CASA NRO 42 ZONA CASONA 2 TURMERO",
      "client_identification": "V25074515",
      "nap_box_name": "CTO-00088",
      "created_at": "2024-08-02T11:14:40.507955",
      "service_detail": {
        "id": 12203,
        "ip": "172.21.114.2",
        "mac": "TPLGB954FAE5",
        "serial": "TPLGB954FAE5",
        "queue": null,
        "interface": "VLAN100_OLTs",
        "created_at": "2026-03-30T09:26:47.881858",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6074,
      "client_name": "GEHYSLEM RASCHEL SOLORZANO ARJONA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128471441",
      "client_email": "GEHYS1505@GMAIL.COM",
      "address": "CALLE 14 CASA NRO 35 LA CASONA II",
      "client_identification": "V26570821",
      "nap_box_name": "CTO-00088",
      "created_at": "2024-08-02T11:19:44.991649",
      "service_detail": {
        "id": 6334,
        "ip": "172.19.230.2",
        "mac": "TPLGB954FA96",
        "serial": "TPLGB954FA96",
        "queue": "Plan_132787_24341_WispHub",
        "interface": "VLAN110_CASONA_2",
        "created_at": "2024-08-25T20:53:43.720135",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6075,
      "client_name": "HAYBERT DAYLET MONTENEGRO TORREALBA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Laguna Plaza",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243130634",
      "client_email": "HAYBERTORREALBA@GMAIL.COM",
      "address": "CALLE NEGRO PRIMERO EDIF 7 PISO B APT 3 URB LAGUNA PLAZA TURMERO ARAGUA",
      "client_identification": "V25708846",
      "nap_box_name": "1",
      "created_at": "2024-08-02T11:20:07.014688",
      "service_detail": {
        "id": 11004,
        "ip": "172.18.118.2",
        "mac": "TPLGB8627FC0",
        "serial": "TPLGB8627FC0",
        "queue": null,
        "interface": "VLAN216_LAGUNA_PLAZA_OLT1",
        "created_at": "2026-01-06T12:04:19.743487",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6076,
      "client_name": "EDGARDO ALEXANDER SEIJAS LEON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Laguna Plaza",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128667994",
      "client_email": "EDGARDOSEIJAS@HOTMAIL.COM",
      "address": "CALLE NEGRO PRIMERO EDIF 9 APTO 2 CONJUNTO RESIDENCIAL LAGUNA PLAZA TURMERO ARAGUA",
      "client_identification": "V13199708",
      "nap_box_name": "2",
      "created_at": "2024-08-02T11:23:29.586110",
      "service_detail": {
        "id": 5246,
        "ip": "10.16.97.2",
        "mac": "TPLG1BB36457",
        "serial": "TPLG1BB36457",
        "queue": "Plan_143066_15811_WispHub",
        "interface": "VLAN216_LAGUNA_PLAZA_OLT1",
        "created_at": "2024-08-15T15:38:03.693892",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6077,
      "client_name": "GENARA JOSEFINA CASTILLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243784236",
      "client_email": "GENARAJCASTILLO@GMAIL.COM",
      "address": "CALLE 14 CASA NRO 33 URB  LA CASONA II TURMERO",
      "client_identification": "V4555873",
      "nap_box_name": "CTO-00088",
      "created_at": "2024-08-02T11:24:02.094596",
      "service_detail": {
        "id": 5107,
        "ip": "172.21.112.2",
        "mac": "TPLGB954FD9C",
        "serial": "TPLGB954FD9C",
        "queue": "Plan_131647_24341_WispHub",
        "interface": "VLAN110_CASONA_2",
        "created_at": "2024-08-14T15:31:04.595654",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6078,
      "client_name": "JUNIOR DE JESUS UTRERA ZAMBRANO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados III",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124668809",
      "client_email": "TOUSHIROU4668809@GMAIL.COM",
      "address": "CALLE 6 CASA NRO 57 URB PRADOS DE PAYA III",
      "client_identification": "V22291023",
      "nap_box_name": "395",
      "created_at": "2024-08-02T11:24:48.512105",
      "service_detail": {
        "id": 4768,
        "ip": "172.18.36.2",
        "mac": "VSOL0051EA79",
        "serial": "VSOL0051EA79",
        "queue": "Plan_161890_30183_WispHub",
        "interface": "VLAN236_PRADOS3",
        "created_at": "2024-08-12T15:19:53.879242",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6079,
      "client_name": "ALESIA JOSEFINA RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144625509",
      "client_email": "ALESIAR19@HOTMAIL.COM",
      "address": "CALLE 15 CASA NRO 7 URB LA CASONA II TURMERO",
      "client_identification": "V7227495",
      "nap_box_name": "CTO-00087",
      "created_at": "2024-08-02T11:28:11.828631",
      "service_detail": {
        "id": 5396,
        "ip": "172.19.227.2",
        "mac": "TPLGB954FB24",
        "serial": "TPLGB954FB24",
        "queue": "Plan_131647_24341_WispHub",
        "interface": "VLAN110_CASONA_2",
        "created_at": "2024-08-16T15:01:47.545990",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6080,
      "client_name": "CARLOS PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Laguna Plaza",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04127768701",
      "client_email": "CDARIOPEREZL@GMAIL.COM",
      "address": "CALLE NEGRO PRIMERO C/C CAMILO TORRES EDIF 9  ENTRADA PISO PH APTO PH-3 CONJUNTO RESIDENCIAL LAGUNA PLAZA",
      "client_identification": "V8996478",
      "nap_box_name": "2",
      "created_at": "2024-08-02T11:33:00.723211",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6081,
      "client_name": "KEILIMAR ADRIANA PARADA MIRABAL",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Pantin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243435055",
      "client_email": "KEILIMARPARADA@GMAIL.COM",
      "address": "CALLE 11B CASA NRO 44 SECTOR PANTIN ROSARIO DE PAYA",
      "client_identification": "V27687778",
      "nap_box_name": "CTO-00168",
      "created_at": "2024-08-02T11:33:37.450371",
      "service_detail": {
        "id": 4770,
        "ip": "172.18.9.2",
        "mac": "VSOL0012A7B1",
        "serial": "VSOL0012A7B1",
        "queue": "Plan_161891_30183_WispHub",
        "interface": "VLAN229_PANTIN",
        "created_at": "2024-08-12T15:22:31.152086",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6082,
      "client_name": "JOSE ALEXANDER TIRADO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Laguna Plaza",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04140509452",
      "client_email": "JOSEATIRADO@GMAIL.COM",
      "address": "CALLE NEGRO PRIMERO C/C CAMILO TORRES EDIF 18 PISO 1 URB LAGUNA PLAZA TURMERO ESTADO ARAGUA",
      "client_identification": "V13874889",
      "nap_box_name": "2",
      "created_at": "2024-08-02T11:35:07.988936",
      "service_detail": {
        "id": 5265,
        "ip": "184.168.5.2",
        "mac": "TPLG1BB363D8",
        "serial": "TPLG1BB363D8",
        "queue": "Plan_153953_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-08-15T16:53:04.889631",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6083,
      "client_name": "MARIA ESMERALDA GOLDCHEITH VARGAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Laguna Plaza",
      "plan": {
        "id": 16,
        "name": "RECURRENTE RESIDENCIAL PLAN 800M",
        "cost": "55.00",
        "code": "FOR800",
        "profile": "800M/800M"
      },
      "client_mobile": "04143344334",
      "client_email": "MARIAGOLDCHEIDT@HOTMAIL.COM",
      "address": "CALLE NEIGRO PRIMERO EDIF 11 PISO PB APT 2 CONJUNTO RESIDENCIAL LAGUNA PLAZA TURMERO EDO ARAGUA",
      "client_identification": "V14492065",
      "nap_box_name": "3",
      "created_at": "2024-08-02T11:36:17.882832",
      "service_detail": {
        "id": 5237,
        "ip": "172.18.123.2",
        "mac": "TPLG1BB364A1",
        "serial": "TPLG1BB364A1",
        "queue": "Plan_89283_15811_WispHub",
        "interface": "VLAN216_LAGUNA_PLAZA_OLT1",
        "created_at": "2024-08-15T15:02:50.452830",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6084,
      "client_name": "HEBERLYN ADRIANA MENDOZA TANCO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Laguna Plaza",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04120436311",
      "client_email": "SHARONGAMBOA322@GMAIL.COM",
      "address": "CALLE NEGRO PRIMERO EDIF 11 PISO 1 APTO PH-2 CONJUNTO RESIDENCIAL LAGUNA PLAZA TURMERO ESTADO ARAGUA",
      "client_identification": "V24685937",
      "nap_box_name": "3",
      "created_at": "2024-08-02T11:38:39.042030",
      "service_detail": {
        "id": 9909,
        "ip": "10.16.106.2",
        "mac": "TPLG1BB3633B",
        "serial": "TPLG1BB3633B",
        "queue": null,
        "interface": "VLAN216_LAGUNA_PLAZA_OLT1",
        "created_at": "2025-11-10T23:18:22.463524",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6085,
      "client_name": "NELLY MERCEDES MORENO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Terrazas de Turmero",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04144637609",
      "client_email": "MARYNELLYFASENDO@GMAIL.COM",
      "address": "CALLE 2 CASA NRO 10 URB TERRAZAS DE TURMERO",
      "client_identification": "V5471115",
      "nap_box_name": "118",
      "created_at": "2024-08-02T11:40:18.384319",
      "service_detail": {
        "id": 11947,
        "ip": "172.21.68.2",
        "mac": "TPLGB954EFFC",
        "serial": "TPLGB954EFFC",
        "queue": null,
        "interface": "VLAN225_TERRAZAS_TURMERO_OLT1",
        "created_at": "2026-03-04T12:04:52.405000",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6086,
      "client_name": "JOSE RAFAEL QUINTELA PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Laguna Plaza",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04145431086",
      "client_email": "RAFAELQUINTELASK8@GMAIL.COM",
      "address": "CALLE NEGRO PRIMERO EDIF 17 PISO PB APTO PB-3 URB LAGUNA PLAZA TURMERO ESTADO ARAGUA",
      "client_identification": "V25501429",
      "nap_box_name": "3",
      "created_at": "2024-08-02T11:40:29.477290",
      "service_detail": {
        "id": 5313,
        "ip": "172.17.232.2",
        "mac": "TPLG1BB3618F",
        "serial": "TPLG1BB3618F",
        "queue": "Plan_153953_15811_WispHub",
        "interface": "VLAN216_LAGUNA_PLAZA_OLT1",
        "created_at": "2024-08-16T09:05:21.805751",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6087,
      "client_name": "MAGDA ELENA SZABADICS KOHANEC",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243735181",
      "client_email": "MAGDAZSABADICS123@GMAIL.COM",
      "address": "CALLE MANZANA I-10 CASA NRO 13 URB SAMAN TARAZONERO 2 TURMERO ARAGUA",
      "client_identification": "V14103575",
      "nap_box_name": "38",
      "created_at": "2024-08-02T11:43:16.110352",
      "service_detail": {
        "id": 5311,
        "ip": "172.28.22.2",
        "mac": "TPLGF5CB0082",
        "serial": "TPLGF5CB0082",
        "queue": "Plan_137413_1574_WispHub",
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2024-08-16T08:55:24.004709",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6088,
      "client_name": "DAVID CASTRO CORTEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Prados III",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128820804",
      "client_email": "JOHALBISDAVIDCASTRO@GMAIL.COM",
      "address": "CALLE 2 CASA NRO 24 URB PRADOS DE PAYA III",
      "client_identification": "V22298418",
      "nap_box_name": "CTO-00284 DOS",
      "created_at": "2024-08-02T11:43:17.063442",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6089,
      "client_name": "NELSI VANESSA VASQUEZ QUINTERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124579245",
      "client_email": "VASQUEZNELSI@GMAIL.COM",
      "address": "VDA SEGUNDA I 9-10 CASA NRO 14 URB SAMAN TARAZONERO TURMERO ARAGUA",
      "client_identification": "V19363520",
      "nap_box_name": "38",
      "created_at": "2024-08-02T11:45:06.161053",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6090,
      "client_name": "MARIO ANTONIO IBELLI VANGI",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243372575",
      "client_email": "IBELLIMARXBOX@GMAIL.COM",
      "address": "CALLE PASAJE CAMILO TORRES CASA NRO 14 SECTOR CENTRO TURMERO",
      "client_identification": "V29931485",
      "nap_box_name": "CE-00009",
      "created_at": "2024-08-02T11:45:44.169212",
      "service_detail": {
        "id": 5444,
        "ip": "172.19.200.2",
        "mac": "TPLGB954F869",
        "serial": "TPLGB954F869",
        "queue": "queue1",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-08-16T16:26:12.912361",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6091,
      "client_name": "DEYANIRA ESPARRAGOZA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Narayola II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144599445",
      "client_email": "DEYANIRAESPARRAGOZA59@GMAIL.COM",
      "address": "AV INTERCOMUNAL LA JULIA EDIF 4 PISO PB APT PB-04 CONJUNTO RESIDENCIAL NARAYOLA II TURMERO ARAGUA",
      "client_identification": "V12570806",
      "nap_box_name": "CTO-0524",
      "created_at": "2024-08-02T11:46:29.374898",
      "service_detail": {
        "id": 5308,
        "ip": "172.17.240.2",
        "mac": "TPLGB954F874",
        "serial": "TPLGB954F874",
        "queue": "queue1",
        "interface": "VLAN117_NARAYOLA",
        "created_at": "2024-08-16T08:17:29.337096",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6092,
      "client_name": "CHARLY JUNUEL FARFAN LOPEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Salto Angel",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04129435453",
      "client_email": "CHARLY.FARFAN@GMAIL.COM",
      "address": "CALLE LOS ROBLES MANZANA 6 CASA NRO 9 URB SALTO ANGEL LA JULIA TURMERO",
      "client_identification": "V16344620",
      "nap_box_name": "478",
      "created_at": "2024-08-02T11:47:18.063684",
      "service_detail": {
        "id": 5105,
        "ip": "172.21.119.2",
        "mac": "TPLGB954EC68",
        "serial": "TPLGB954EC68",
        "queue": "Plan_131648_24341_WispHub",
        "interface": "VLAN121_S_ANGEL",
        "created_at": "2024-08-14T15:13:13.640940",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6093,
      "client_name": "ROMELIA VICTORIA PEREIRA ORAA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "El Macaro",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243852679",
      "client_email": "PEREIRA.ORAA@HOTMAIL.COM",
      "address": "TURMERO MARACAY CASA NRO 4 SECTOR EL MACARO TURMERO ARAGUA",
      "client_identification": "V25501646",
      "nap_box_name": "500",
      "created_at": "2024-08-02T11:52:08.561065",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6094,
      "client_name": "FRANSIAHELYN MARGARITA QUINTERO COTUA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04160403662",
      "client_email": "FRANSIAHELYNQUINTERO@GMAIL.COM",
      "address": "VDA 4 MANZANA I CASA 07 URB SAMAN  TARAZONERO II TURMERO",
      "client_identification": "V27286881",
      "nap_box_name": "CTO-00064",
      "created_at": "2024-08-02T11:57:01.704607",
      "service_detail": {
        "id": 5102,
        "ip": "172.21.85.2",
        "mac": "TPLGB9550070",
        "serial": "TPLGB9550070",
        "queue": "Plan_92223_1574_WispHub",
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2024-08-14T15:01:10.580788",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6095,
      "client_name": "MARIA MIGDALYS GASCON DE HERES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "La Casona I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128858277",
      "client_email": "JOSEHERES155@GMAIL.COM",
      "address": "CALLE 5 CASA NRO 20 URBANIZACION LA CASONA I",
      "client_identification": "V8925832",
      "nap_box_name": "44",
      "created_at": "2024-08-02T11:58:12.402826",
      "service_detail": {
        "id": 11759,
        "ip": "172.17.156.2",
        "mac": "VSOL0051EB71",
        "serial": "VSOL0051EB71",
        "queue": null,
        "interface": "VLAN109_CASONA_1",
        "created_at": "2026-02-27T09:41:36.333488",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6096,
      "client_name": "AIDA JOSEFINA FRANCO MONTILLA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Prados de Cafetal",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04147383233",
      "client_email": "BELTRANANDREY753@GMAIL.COM",
      "address": "CALLE 1 CASA NRO 10 PRADOS DE CAFETAL ROSARIO DE PAYA",
      "client_identification": "V7553637",
      "nap_box_name": "CTO-0076",
      "created_at": "2024-08-02T11:58:55.473275",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6097,
      "client_name": "DIOLYS NOELIA GIMENEZ MARINO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "La Montaña",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144866530",
      "client_email": "Diolysnoelia@gmail.com",
      "address": "CALLE NEGRO PRIMERO EDIF PICO EL COBRE PISO 2 APTO 2 URB RESIDENCIAS LA MONTAÑA TURMERO ESTADO ARAGUA",
      "client_identification": "V12609294",
      "nap_box_name": "68 DOS",
      "created_at": "2024-08-02T13:10:55.615518",
      "service_detail": {
        "id": 5319,
        "ip": "172.18.112.2",
        "mac": "VSOL00522C91",
        "serial": "VSOL00522C91",
        "queue": "Plan_89283_15811_WispHub",
        "interface": "VLAN213_MONTANA_OLT1",
        "created_at": "2024-08-16T09:13:08.084578",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6098,
      "client_name": "FREDDY RAFAEL DI DAMASO YEPEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "SUSPENDIDO_RESIDENCIAL",
      "status_name": "Suspendido",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Narayola II",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04128824146",
      "client_email": "DIDAMASOF@GMAIL.COM",
      "address": "AV INTERCOMUNAL TURMERO MARACAY EDIF 5 PISO 2APT 2-3 URB NARAYOLA II 19 DE ABRIL",
      "client_identification": "V21445005",
      "nap_box_name": "CTO-0525",
      "created_at": "2024-08-02T13:12:58.428807",
      "service_detail": {
        "id": 5323,
        "ip": "172.17.244.2",
        "mac": "TPLGB954F1DB",
        "serial": "TPLGB954F1DB",
        "queue": "Plan_131338_24341_WispHub",
        "interface": "VLAN117_NARAYOLA",
        "created_at": "2024-08-16T09:16:28.871289",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6099,
      "client_name": "ELYMAR PAOLA MORGADO RUIZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Narayola II",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04144947595",
      "client_email": "ELYMARP85@GMAIL.COM",
      "address": "AV INTERCOMUNAL TURMERO MARACAY EDIF TORRE 3 PISO 1 APTO 3 URB NARAYOLA II TURMERO ESTADO ARAGUA",
      "client_identification": "V16101598",
      "nap_box_name": "CTO-0523",
      "created_at": "2024-08-02T13:17:04.860490",
      "service_detail": {
        "id": 5325,
        "ip": "172.19.6.2",
        "mac": "TPLGB954FDC8",
        "serial": "TPLGB954FDC8",
        "queue": "Plan_132787_24341_WispHub",
        "interface": "VLAN100_OLTs",
        "created_at": "2024-08-16T09:18:20.843985",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6100,
      "client_name": "BETHSABE DE LOS ANGELES RODDY FRANCO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04144441928",
      "client_email": "BETHSABERF@GMAIL.COM",
      "address": "CALLE GIRARDOT CASA NRO 19 SECTOR CENTRO TURMERO",
      "client_identification": "V9432962",
      "nap_box_name": "CTO-00440",
      "created_at": "2024-08-02T13:22:53.969815",
      "service_detail": {
        "id": 5735,
        "ip": "172.19.150.2",
        "mac": "TPLGB954EEC6",
        "serial": "TPLGB954EEC6",
        "queue": "Plan_92284_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-08-19T13:39:46.574877",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6102,
      "client_name": "JOSE LUIS BLANCO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04126786366",
      "client_email": "JOSEBLANCOCHELI22@GMAIL.COM",
      "address": "CALLE MARIÑO NRO 43-1 SECTOR CENTRO TURMERO",
      "client_identification": "V15302266",
      "nap_box_name": "CE-00009",
      "created_at": "2024-08-02T13:26:55.481046",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6103,
      "client_name": "RAZZUK ZEGHEN HADDAD",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 16,
        "name": "RECURRENTE RESIDENCIAL PLAN 800M",
        "cost": "55.00",
        "code": "FOR800",
        "profile": "800M/800M"
      },
      "client_mobile": "04243277977",
      "client_email": "RAZZE71@HOTMAIL.COM",
      "address": "CALLE BOLÍVAR EDIF MAR JORGE PISO 1 APTO 02 SECTOR TURMERO CENTRO TURMERO ESTADO ARAGUA",
      "client_identification": "V10456519",
      "nap_box_name": "103",
      "created_at": "2024-08-02T13:27:49.193430",
      "service_detail": {
        "id": 9950,
        "ip": "172.20.149.2",
        "mac": "TPLGB954F7A6",
        "serial": "TPLGB954F7A6",
        "queue": null,
        "interface": "VLAN200_OLTs",
        "created_at": "2025-11-11T10:42:42.821384",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6104,
      "client_name": "GUSTAVO ARMANDO CORTEZ ESPINOZA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Narayola II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04143473140",
      "client_email": "GUSTAVOCORTEZ282@GMAIL.COM",
      "address": "AV INTERCOMUNAL TURMERO EDIF 4 PISO 3-6 URB NARAYOLA II TURMERO ESTADO ARAGUA",
      "client_identification": "V16406935",
      "nap_box_name": "CTO-0524",
      "created_at": "2024-08-02T13:29:55.062641",
      "service_detail": {
        "id": 5331,
        "ip": "172.17.248.2",
        "mac": "TPLGB954F6CC",
        "serial": "TPLGB954F6CC",
        "queue": "queue1",
        "interface": "VLAN117_NARAYOLA",
        "created_at": "2024-08-16T09:23:22.209162",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6105,
      "client_name": "MARIANGELA LANDER GARAYCOA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Narayola II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124444494",
      "client_email": "MARIANGELA.LANDER@GMAIL.COM",
      "address": "AV INTERCOMUNAL TURMERO, PARCELA NRO 22-A EDIF 2 PISO 2 APTO 2-6 URB. NARAYOLA II TURMERO ESTADO ARAGUA",
      "client_identification": "V16551628",
      "nap_box_name": "CTO-0522",
      "created_at": "2024-08-02T13:31:23.143466",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6106,
      "client_name": "MARIA GUADALUPE GHALI BELTRAN",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243070410",
      "client_email": "MARIAGHALI17@GMAIL.COM",
      "address": "CALLE BOLIVAR CRUCE CON CALLE CEDEÑO EDF CORAZON DE JESUS PISO 3 APT 7 ZONA CENTROTURMERO",
      "client_identification": "V25620884",
      "nap_box_name": "CTO-00266",
      "created_at": "2024-08-02T13:31:53.276639",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6107,
      "client_name": "BISLEIBY ANDREINA DE ABREU VILLEGAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Narayola II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121431970",
      "client_email": "ANDREIINADAV@GMAIL.COM",
      "address": "AV INTERCOMUNAL EDIF 5 PISO 2 APTO 2-6 URB NARAYOLA II TURMERO ESTADO ARAGUA",
      "client_identification": "V25976075",
      "nap_box_name": "CTO-0525",
      "created_at": "2024-08-02T13:32:52.274578",
      "service_detail": {
        "id": 9965,
        "ip": "172.19.39.2",
        "mac": "TPLGB954F022",
        "serial": "TPLGB954F022",
        "queue": null,
        "interface": "VLAN117_NARAYOLA",
        "created_at": "2025-11-11T11:17:00.060984",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6108,
      "client_name": "YUBISAY GUILLEN REVILLA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Narayola II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243570485",
      "client_email": "YUGUIRE15@GMAIL.COM",
      "address": "AV INTERCOMUNAL EDIF 1 PISO 3 APT 3-1 URB NARAYOLA II TURMERO EDO ARAGUA",
      "client_identification": "V12811135",
      "nap_box_name": "CTO-0521",
      "created_at": "2024-08-02T13:34:21.192831",
      "service_detail": {
        "id": 5336,
        "ip": "172.21.75.2",
        "mac": "TPLGB954E8DE",
        "serial": "TPLGB954E8DE",
        "queue": "Plan_131647_24341_WispHub",
        "interface": "VLAN117_NARAYOLA",
        "created_at": "2024-08-16T09:32:07.649330",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6109,
      "client_name": "BEICKER ALEXANDER TORRES RAMOS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "La Concepcion",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243694664",
      "client_email": "BEICKERALEXANDERTORRESRAMOS@GMAIL.COM",
      "address": "CALLE 1 CASA NRO 15 URB LA CONCEPCION TURMERO",
      "client_identification": "V27286550",
      "nap_box_name": "0325",
      "created_at": "2024-08-02T13:34:59.849836",
      "service_detail": {
        "id": 9902,
        "ip": "172.19.158.2",
        "mac": "TPLGB954FAD8",
        "serial": "TPLGB954FAD8",
        "queue": null,
        "interface": "VLAN111_CONCEPCION",
        "created_at": "2025-11-10T22:37:28.877440",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6110,
      "client_name": "WILLIAM CARMELO MELLADO LOZANO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "La Concepcion",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243083343",
      "client_email": "MELLADO9999@GMAIL.COM",
      "address": "CALLE 1 CASA NRO 6 URB LA CONCEPCION TURMERO ARAGUA",
      "client_identification": "V12481117",
      "nap_box_name": "0326",
      "created_at": "2024-08-02T13:46:37.245526",
      "service_detail": {
        "id": 5148,
        "ip": "172.19.160.2",
        "mac": "TPLGB954F78D",
        "serial": "TPLGB954F78D",
        "queue": "Plan_131647_24341_WispHub",
        "interface": "VLAN100_OLTs",
        "created_at": "2024-08-15T09:31:51.696701",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6111,
      "client_name": "REINA MARGARITA SANCHEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243170155",
      "client_email": "MAGISTER.0403Z@GMAIL.COM",
      "address": "CALLE 18 CASA NRO 09 SECTOR LA CASONA II",
      "client_identification": "V12925630",
      "nap_box_name": "CTO-00086",
      "created_at": "2024-08-02T13:58:58.515165",
      "service_detail": {
        "id": 4778,
        "ip": "172.17.165.2",
        "mac": "VSOL0051EBE1",
        "serial": "VSOL0051EBE1",
        "queue": "Plan_131647_24341_WispHub",
        "interface": "VLAN110_CASONA_2",
        "created_at": "2024-08-12T15:40:13.409244",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6112,
      "client_name": "KRISSLEYMAR BELLAPAULLY COLMENARES MEJIAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Narayola II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124088856",
      "client_email": "KRISSBELLA.COLMENARES@GMAIL.COM",
      "address": "CTRA INTERCOMUNAL TURMERO MARACAY  EDIF TORRE 7 PISO 2 APT 2-4 URB NARAYOLA II",
      "client_identification": "V14191716",
      "nap_box_name": "CTO-0527",
      "created_at": "2024-08-02T13:59:09.858914",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6113,
      "client_name": "LUCIA IBIS ECHENIQUE CORDOVA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Narayola II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243592766",
      "client_email": "LUCIAIBIS@HOTMAIL.COM",
      "address": "AV. INTERCOMUNAL TURMERO EDIF 4 PISO 3 APTO 3-3 URB NARAYOLA II TURMERO ESTADO ARAGUA",
      "client_identification": "V12618098",
      "nap_box_name": "CTO-0524",
      "created_at": "2024-08-02T14:00:38.777050",
      "service_detail": {
        "id": 12460,
        "ip": "172.18.1.2",
        "mac": "TPLGB954F7E8",
        "serial": "TPLGB954F7E8",
        "queue": null,
        "interface": "VLAN100_OLTs",
        "created_at": "2026-05-05T15:37:08.172195",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6114,
      "client_name": "JOSE ANTONIO PAPA MORA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Narayola II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04265330314",
      "client_email": "JOSEPAPAMORA1@HOTMAIL.COM",
      "address": "AV INTERCOMUNAL TURMERO EDIF 2 PISO 1 APT 1-1 URB NARAYOLA II TURMERO ARAGUA",
      "client_identification": "V12853396",
      "nap_box_name": "CTO-0522",
      "created_at": "2024-08-02T14:02:10.483023",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6115,
      "client_name": "MICHEL TAIN DOPAZO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Laguna Plaza",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121793236",
      "client_email": "eduardotain@GMAIL.COM",
      "address": "CALLE NEGRO PRIMERO EDIF 5 PISO PH APT PH2 URB LAGUNA PLAZA TURMERO ESTADO ARAGUA",
      "client_identification": "V14765135",
      "nap_box_name": "1",
      "created_at": "2024-08-02T14:03:20.746874",
      "service_detail": {
        "id": 5345,
        "ip": "10.16.98.2",
        "mac": "TPLG1BB364C1",
        "serial": "TPLG1BB364C1",
        "queue": "Plan_153953_15811_WispHub",
        "interface": "VLAN216_LAGUNA_PLAZA_OLT1",
        "created_at": "2024-08-16T09:47:45.125074",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6116,
      "client_name": "MARY FRANCIS DIAZ LIRA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Narayola II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04242308558",
      "client_email": "D.MARY.F@GMAIL.COM",
      "address": "AV INTER TURMERO MARACAY PARC 22-A ASENTAMIENTO VILLEGAS EDIF 1 PISO 1 APT 1-1 URB NARAYOLA II, TURMERO ARAGUA",
      "client_identification": "V13050641",
      "nap_box_name": "CTO-0521",
      "created_at": "2024-08-02T14:06:05.820652",
      "service_detail": {
        "id": 10912,
        "ip": "172.18.5.2",
        "mac": "TPLGB954F51C",
        "serial": "TPLGB954F51C",
        "queue": null,
        "interface": "VLAN117_NARAYOLA",
        "created_at": "2025-12-23T13:20:51.842545",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6117,
      "client_name": "AGUSTIN ALBERTO GONCALVES RODRIGUES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Narayola II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243583672",
      "client_email": "GONCALVESA_@HOTMAIL.COM",
      "address": "AV INTERCOMUNAL TURMERO URB NARAYOLA II EDIF 4 PISO 1 APTO 1-6 TURMERO ESTADO ARAGUA",
      "client_identification": "V18616377",
      "nap_box_name": "CTO-0524",
      "created_at": "2024-08-02T14:07:17.208215",
      "service_detail": {
        "id": 6335,
        "ip": "172.25.115.2",
        "mac": "TPLG1BB363F3",
        "serial": "TPLG1BB363F3",
        "queue": "Plan_131647_24341_WispHub",
        "interface": "VLAN117_NARAYOLA",
        "created_at": "2024-08-25T20:58:43.427463",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6119,
      "client_name": "TERESA MARCELA GONCALVES RODRIGUES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Narayola II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04141444724",
      "client_email": "TERESAMARCELA_1003@HOTMAIL.COM",
      "address": "AV. INTERCOMUNAL NARAYOLA II TORRE 6",
      "client_identification": "V12609958",
      "nap_box_name": "CTO-0526",
      "created_at": "2024-08-02T14:10:38.418677",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6120,
      "client_name": "HECTOR DE LOS ANGELES PEREZ PETIT",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Narayola II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243099525",
      "client_email": "PEREZPETIT@HOTMAIL.COM",
      "address": "AV. INTERCOMUNAL TURMERO MARACAY EDIF 3 PISO 2 APT 2-8 URB NARAYOLA II TURMERO EDO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V7208626",
      "nap_box_name": "CTO-0523",
      "created_at": "2024-08-02T14:11:55.466221",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6121,
      "client_name": "MIRNA JOSEFINA HERNANDEZ BELLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Narayola II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124520741",
      "client_email": "CAROLINADEFLORES08@GMAIL.COM",
      "address": "CTRA INTERCOMUNAL TURMERO EDIF TORRE 6 PISO 2 APT 6 URB NARAYOLA TURMERO ARAGUA",
      "client_identification": "V7248312",
      "nap_box_name": "CTO-0526",
      "created_at": "2024-08-02T14:13:08.771406",
      "service_detail": {
        "id": 5352,
        "ip": "172.18.12.2",
        "mac": "TPLGB954F1A2",
        "serial": "TPLGB954F1A2",
        "queue": "Plan_131647_24341_WispHub",
        "interface": "VLAN100_OLTs",
        "created_at": "2024-08-16T10:44:25.195788",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6122,
      "client_name": "ZUGREY DEL CARMEN PERALTA MARRUFO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "San Sebastian",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04147094906",
      "client_email": "LACAGASTES100@GMAIL.COM",
      "address": "CALLE 2 CASA NRO 23, SECTOR SAN SEBASTIAN, EL MÁCARO, TURMERO, ESTADO ARAGUA",
      "client_identification": "V20759564",
      "nap_box_name": "61",
      "created_at": "2024-08-02T14:14:50.702071",
      "service_detail": {
        "id": 5353,
        "ip": "172.29.44.2",
        "mac": "TPLG2ABDC75A",
        "serial": "TPLG2ABDC75A",
        "queue": "Plan_137413_1574_WispHub",
        "interface": "VLAN125_SAN_SEBASTIAN_ZTE",
        "created_at": "2024-08-16T10:46:50.787586",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6123,
      "client_name": "ADLIH NOHELY CHACON CASTELLANO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144868574",
      "client_email": "RV1234R@GMAIL.COM",
      "address": "CALLE MANZANA B CASA NRO 13 SECTOR SAMAN TARAZONERO II EL MACARO TURMERO ESTADO ARAGUA",
      "client_identification": "V20336686",
      "nap_box_name": "509",
      "created_at": "2024-08-02T14:16:41.280960",
      "service_detail": {
        "id": 4954,
        "ip": "172.28.90.2",
        "mac": "TPLG1BB364E1",
        "serial": "TPLG1BB364E1",
        "queue": "Plan_137413_1574_WispHub",
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2024-08-13T15:06:29.584299",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6124,
      "client_name": "ELIMAR SHARAI CHACON OSORIO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Palmeras II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243801236",
      "client_email": "ELIMARSHARAI@GMAIL.COM",
      "address": "CALLE C CASA MANZANA G NRO 140-G URB LAS PALMERAS II TURMERO ARAGUA",
      "client_identification": "V28023365",
      "nap_box_name": "287",
      "created_at": "2024-08-02T14:18:44.141920",
      "service_detail": {
        "id": 5938,
        "ip": "172.18.53.2",
        "mac": "TPLGB954EEED",
        "serial": "TPLGB954EEED",
        "queue": "Plan_131647_24341_WispHub",
        "interface": "VLAN119_PALMERAS_2",
        "created_at": "2024-08-21T13:39:10.506524",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6125,
      "client_name": "GONZALO EZEQUIEL LANDAETA CARRILLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Los Caobos",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243380126",
      "client_email": "GOLANCA6@GMAIL.COM",
      "address": "CALLE NORTE 1 CASA NRO 39 URB NUEVA VILLEGAS TURMERO ESTADO ARAGUA",
      "client_identification": "V7287727",
      "nap_box_name": "CE - 617",
      "created_at": "2024-08-02T14:21:59.771436",
      "service_detail": {
        "id": 4321,
        "ip": "172.18.129.2",
        "mac": "TPLGF5CB04AC",
        "serial": "TPLGF5CB04AC",
        "queue": "Plan_131647_24341_WispHub",
        "interface": "VLAN100_OLTs",
        "created_at": "2024-08-09T09:31:49.421302",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6126,
      "client_name": "LENIN LEVI AGRAZ ZAMBRANO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "El Macaro",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04122921562",
      "client_email": "LENINAGRAZ@GMAIL.COM",
      "address": "CALLE PRINCIPAL 25 DE AGOSTO CASA NRO 11 SECTOR EL MACARO ANTONIO JOSE DE SUCRE",
      "client_identification": "V20109922",
      "nap_box_name": "86 DOS",
      "created_at": "2024-08-02T14:26:22.632691",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6127,
      "client_name": "JESUS RAFAEL MONTENEGRO FLORES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Paya Abajo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243766872",
      "client_email": "JM4514506@GMAIL.COM",
      "address": "CALLE CAMPO ELIAS CASA NRO 08 SECTOR PAYA ABAJO",
      "client_identification": "V16850584",
      "nap_box_name": "CTO-00307",
      "created_at": "2024-08-02T14:31:27.554726",
      "service_detail": {
        "id": 7491,
        "ip": "172.17.125.2",
        "mac": "VSOL00522E79",
        "serial": "VSOL00522E79",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN231_PAYABAJO",
        "created_at": "2024-12-17T11:26:05.310544",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6128,
      "client_name": "YRAIMA JOSEFINA PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04128500770",
      "client_email": "dubreyguillen@gmail.com",
      "address": "CALLE URDANETA CASA PARCELA NRO 73 ZONA PARCELAMIENTO LOS NÍSPEROS TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V12248772",
      "nap_box_name": "CTO-00049",
      "created_at": "2024-08-02T14:37:51.529284",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6129,
      "client_name": "LOURYS DUBOIS FORDS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Brisas de Paya",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124360479",
      "client_email": "LOURYSFORDS.10@GMAIL.COM",
      "address": "AV PRINCIPAL DE LAS BRISAS CASA NRO 2 SECTOR PRADOS DE PAYA",
      "client_identification": "V12611654",
      "nap_box_name": "CTO-00206",
      "created_at": "2024-08-02T14:39:32.061895",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6130,
      "client_name": "JAVIER ALEJANDRO NAVAS CHACON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Palmeras I",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243770944",
      "client_email": "ZOIRET.CHACON@GMAIL.COM",
      "address": "CALLE 3ERA CASA NRO 169 PALMERAS I TURMERO",
      "client_identification": "V28024233",
      "nap_box_name": "440",
      "created_at": "2024-08-02T14:42:13.759111",
      "service_detail": {
        "id": 5159,
        "ip": "172.19.127.2",
        "mac": "TPLGB954F6F0",
        "serial": "TPLGB954F6F0",
        "queue": "Plan_131647_24341_WispHub",
        "interface": "VLAN118_PALMERAS_1",
        "created_at": "2024-08-15T10:09:02.198630",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6131,
      "client_name": "DAIBETH NOHELY SOLORZANO GONZALEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124797560",
      "client_email": "NEREYDAGONZALEZR11@GMAIL.COM",
      "address": "CALLE MANZANA E-6 CASA NRO 6 SECTOR SAMAN TARAZONERO II TURMERO",
      "client_identification": "V26868596",
      "nap_box_name": "95",
      "created_at": "2024-08-02T14:42:55.827583",
      "service_detail": {
        "id": 5101,
        "ip": "172.21.125.2",
        "mac": "TPLGB954ED5A",
        "serial": "TPLGB954ED5A",
        "queue": "Plan_107915_1574_WispHub",
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2024-08-14T14:56:53.723261",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6132,
      "client_name": "YORIKA LISBETH BLANCO  ESCALONA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Palmeras II",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04241388478",
      "client_email": "YORIKABLANCO.YB@GMAIL.COM",
      "address": "AV.  INTERCOMUNAL  TURMERO ASENTAMIENTO  VILLEGAS CALLE 9  MANZANA  G  CASA N 135  URB LAS PALMERAS II",
      "client_identification": "V13357906",
      "nap_box_name": "287",
      "created_at": "2024-08-02T14:46:59.223930",
      "service_detail": {
        "id": 5067,
        "ip": "172.21.92.2",
        "mac": "TPLGB954ED59",
        "serial": "TPLGB954ED59",
        "queue": "Plan_132787_24341_WispHub",
        "interface": "VLAN100_OLTs",
        "created_at": "2024-08-14T11:31:25.883363",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6133,
      "client_name": "JORGE LUIS JARAMILLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Paya Abajo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04127534575",
      "client_email": "SANCHEZTERESA225@GMAIL.COM",
      "address": "CALLE 1 CASA NRO 8 URB PRADOS DE PAYA",
      "client_identification": "V10982563",
      "nap_box_name": "CTO-00193",
      "created_at": "2024-08-02T14:49:07.045610",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6134,
      "client_name": "YARLEY BRAVO LEDEZMA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128898066",
      "client_email": "RODRIGUEZANGIE157@GMAIL.COM",
      "address": "CALLE MANZANA  E 12 CASA NRO SAMAN TARAZONERO II TURMERO",
      "client_identification": "V11797578",
      "nap_box_name": "93",
      "created_at": "2024-08-02T14:49:56.667870",
      "service_detail": {
        "id": 5063,
        "ip": "172.21.87.2",
        "mac": "TPLGB954FB2F",
        "serial": "TPLGB954FB2F",
        "queue": "Plan_92223_1574_WispHub",
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2024-08-14T11:25:44.529265",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6135,
      "client_name": "LETTISBETH DE JESUS ZERPA HIGUERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados III",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243296779",
      "client_email": "LETTISBETH041985@GMAIL.COM",
      "address": "CALLE Nº 06 CASA Nº53 SECTOR PRADOS DE PAYA III ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V17367732",
      "nap_box_name": "395",
      "created_at": "2024-08-02T14:51:16.629497",
      "service_detail": {
        "id": 4175,
        "ip": "172.31.33.2",
        "mac": "OEMT3C6229B6",
        "serial": "OEMT3C6229B6",
        "queue": "queue1",
        "interface": "VLAN236_PRADOS3",
        "created_at": "2024-08-02T16:11:56.091112",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6137,
      "client_name": "VANESSA MARGARITA CARTA RIVAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Antonio Jose de Sucre",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04127984370",
      "client_email": "CARTAQUIM31@GMAIL.COM",
      "address": "CALLE HENRY PITTIER CASA NRO 29 BARRIO ANTONIO JOSE DE SUCRE  TURMERO",
      "client_identification": "V17247006",
      "nap_box_name": "86 DOS",
      "created_at": "2024-08-02T14:55:03.103043",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6138,
      "client_name": "ANGEL RUILOBA PEÑA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Palmeras I",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243546629",
      "client_email": "RUILOBAANGEL@GMAIL.COM",
      "address": "CALLE 3 CASA NRO 149 URB LAS PALMERAS 1 TURMERO",
      "client_identification": "V7671831",
      "nap_box_name": "440",
      "created_at": "2024-08-02T14:59:09.563814",
      "service_detail": {
        "id": 5161,
        "ip": "172.19.126.2",
        "mac": "TPLGB954FB1B",
        "serial": "TPLGB954FB1B",
        "queue": "Plan_132787_24341_WispHub",
        "interface": "VLAN100_OLTs",
        "created_at": "2024-08-15T10:11:39.693003",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6139,
      "client_name": "KEILA ZUNELVA SANTANA SOTO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Prados I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144686407",
      "client_email": "KEILAZUNELVASANTANASOTO32@GMAIL.COM",
      "address": "AV LA LAGUNITA CASA NRO 10-A SECTOR PRADOS I ROSARIO DE PAYA",
      "client_identification": "V19949748",
      "nap_box_name": "CTO-00193",
      "created_at": "2024-08-02T15:03:50.984400",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6140,
      "client_name": "GREGORIA  CELESTE BLANCO SOLORZANO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "La Casona II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04241778636",
      "client_email": "GCBLANQUET@GMAIL.COM",
      "address": "CALLE 14 NRO 82 CASONA",
      "client_identification": "V14197656",
      "nap_box_name": "CTO-00120",
      "created_at": "2024-08-02T15:03:52.505824",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6141,
      "client_name": "DESIREE ANAIS RODRIGUEZ VILLEGAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "San Carlos",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243559426",
      "client_email": "DESIREERODRIGUEZ73@HOTMAIL.COM",
      "address": "CALLE RICAURTE CASA LA RODRIGUERA NRO E-1 URB SAN CARLOS TURMERO",
      "client_identification": "V16692822",
      "nap_box_name": "136",
      "created_at": "2024-08-02T15:10:25.643465",
      "service_detail": {
        "id": 5053,
        "ip": "172.21.102.2",
        "mac": "TPLGB954ED5D",
        "serial": "TPLGB954ED5D",
        "queue": "Plan_92284_15811_WispHub",
        "interface": "VLAN223_SAN_CARLOS_OLT1",
        "created_at": "2024-08-14T10:03:57.898413",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6142,
      "client_name": "RICHARD EDUARDO MARRERO BLANCO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "La Casona II",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04123454333",
      "client_email": "yanuriceciliabm.54@gmail.com",
      "address": "CALLE 15 CASA NRO 19 URB LA CASONA II TURMERO",
      "client_identification": "V27707844",
      "nap_box_name": "CTO-00087",
      "created_at": "2024-08-02T15:12:54.557382",
      "service_detail": {
        "id": 5177,
        "ip": "172.19.99.2",
        "mac": "TPLGB954E9F3",
        "serial": "TPLGB954E9F3",
        "queue": "Plan_132787_24341_WispHub",
        "interface": "VLAN110_CASONA_2",
        "created_at": "2024-08-15T10:46:05.912067",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6143,
      "client_name": "FERNANDO JAVIER CORDOVA AGUILAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Prados I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121980884",
      "client_email": "VAIREJ95@GMAIL.COM",
      "address": "CALLE 1 CASA NRO BARRIO PRADOS DE PAYA I",
      "client_identification": "V26095306",
      "nap_box_name": "CTO-00193",
      "created_at": "2024-08-02T15:13:50.824965",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6144,
      "client_name": "RAFAEL AUGUSTO COVA GUTIERREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Isaac Oliveira",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243540078",
      "client_email": "rafaelcova24@gmail.com",
      "address": "CALLE PRIMERA CASA NRO 45 URB  ISAAC OLIVEIRA TURMERO",
      "client_identification": "V14578500",
      "nap_box_name": "CTO-00262",
      "created_at": "2024-08-02T15:17:15.931779",
      "service_detail": {
        "id": 11824,
        "ip": "172.21.91.2",
        "mac": "TPLGB954FAE7",
        "serial": "TPLGB954FAE7",
        "queue": null,
        "interface": "VLAN100_OLTs",
        "created_at": "2026-02-27T11:47:37.517400",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6145,
      "client_name": "MADELEINGNE ISABEL BLANCO TORREALBA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04120470235",
      "client_email": "MADEBLANCO71@GMAIL.COM",
      "address": "AV MANZANA I-10 CASA NRO 2 SAMAN TARAZONERO II TURMERO",
      "client_identification": "V11118570",
      "nap_box_name": "504",
      "created_at": "2024-08-02T15:22:24.084984",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6146,
      "client_name": "EZEQUIEL DAVID GARCIA DIAZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "La Floresta",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243442303",
      "client_email": "SOLDADO_MAX_15@HOTMAIL.COM",
      "address": "CALLE 2 CASA NRO C-20 URB LA FLORESTA TURMERO",
      "client_identification": "V22286945",
      "nap_box_name": "32 DOS",
      "created_at": "2024-08-02T15:25:35.293905",
      "service_detail": {
        "id": 5049,
        "ip": "172.21.122.2",
        "mac": "TPLGB954FD49",
        "serial": "TPLGB954FD49",
        "queue": "Plan_124568_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-08-14T09:50:18.628628",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6147,
      "client_name": "OSNEYLA JOSEFINA RUIZ YBARRA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243538058",
      "client_email": "OSNEYLA31@GMAIL.COM",
      "address": "CALLE PROLONGACION CALLE CARREÑO EDIF 03 PISO 3 APTO 04 URB DESARROLLO HABITACIONAL LOS NISPEROS  TURMERO",
      "client_identification": "V16268109",
      "nap_box_name": "130",
      "created_at": "2024-08-02T15:30:20.962051",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6148,
      "client_name": "YEISON ALBERTO CRIOLLO BRICEÑO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04123558334",
      "client_email": "YEISONKIDD36@GMAIL.COM",
      "address": "CALLE BOLIVAR EDIF ABBUD PISO 2 APT 3 ZONA CASCO CENTRAL TURMERO.",
      "client_identification": "V14627866",
      "nap_box_name": "CAJA NAP EDIFICIO ABUUT",
      "created_at": "2024-08-02T15:34:17.007796",
      "service_detail": {
        "id": 10191,
        "ip": "172.19.98.2",
        "mac": "TPLGB954EA65",
        "serial": "TPLGB954EA65",
        "queue": null,
        "interface": "VLAN200_OLTs",
        "created_at": "2025-11-19T14:17:59.599428",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6149,
      "client_name": "CAROLL YANET LUNA MENDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Laguna Plaza",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04164389475",
      "client_email": "CAROLLLUNALUNA@GMAIL.COM",
      "address": "CALLE NEGRO PRIMERO EDIF LAGUNA PLAZA PISO 6-3 APTO 6 URB CONJUNTO RESIDENCIAL LAGUNA PLAZA",
      "client_identification": "V13769448",
      "nap_box_name": "CE - 140",
      "created_at": "2024-08-02T15:37:24.401074",
      "service_detail": {
        "id": 5188,
        "ip": "172.19.87.2",
        "mac": "TPLGB954FB6A",
        "serial": "TPLGB954FB6A",
        "queue": "Plan_92291_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-08-15T11:38:41.482230",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6150,
      "client_name": "JORGE LUIS VIANA CAMACHO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Antonio Jose de Sucre",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128151062",
      "client_email": "JORGLUISVIANA@GMAIL.COM",
      "address": "CALLE PRINCIPAL CASA NRO 56 CARRIO ANTONIO JOSE DE SUCRE MACARO TURMERO",
      "client_identification": "V28432134",
      "nap_box_name": "122",
      "created_at": "2024-08-02T15:41:33.491734",
      "service_detail": {
        "id": 11006,
        "ip": "172.21.109.2",
        "mac": "TPLGB954EE1B",
        "serial": "TPLGB954EE1B",
        "queue": null,
        "interface": "VLAN101_AJS",
        "created_at": "2026-01-06T13:43:39.536717",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6151,
      "client_name": "LUIS ARTURO TOVAR BEROES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "San Sebastian",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04120255433",
      "client_email": "LUISTOVAR227163@GMAIL.COM",
      "address": "CALLE 7 CASA NRO 25 URB SAN SEBASTIAN SECTOR EL MACARO TURMERO",
      "client_identification": "V30612026",
      "nap_box_name": "75",
      "created_at": "2024-08-02T15:42:38.604248",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6152,
      "client_name": "EYLIN YUSBETH IBARRA GIL",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "San Sebastian",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04128859420",
      "client_email": "EYLINGIL140779@GMAIL.COM",
      "address": "CALLE 7 NRO 22 URB. SAN SEBASTIAN SECTOR EL MACARO TURMERO",
      "client_identification": "V14577819",
      "nap_box_name": "75",
      "created_at": "2024-08-02T15:46:32.320502",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6153,
      "client_name": "BIANETT JOSEFINA AGUILAR DE GONZALEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Prados I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124372266",
      "client_email": "BIANETTDEGONZALEZ@GMAIL.COM",
      "address": "CALLE 1 CASA NRO 14 BARRIO PRADOS DE PAYA I",
      "client_identification": "V9438598",
      "nap_box_name": "CTO-00193",
      "created_at": "2024-08-02T15:56:35.768786",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6154,
      "client_name": "JUAN PABLO DIAZ MAYORCA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "La Montañita",
      "plan": {
        "id": 16,
        "name": "RECURRENTE RESIDENCIAL PLAN 800M",
        "cost": "55.00",
        "code": "FOR800",
        "profile": "800M/800M"
      },
      "client_mobile": "04125952577",
      "client_email": "PAPO_87_7@HOTMAIL.COM",
      "address": "CALLE 7 NRO 22 URB. SAN SEBASTIAN SECTOR EL MACARO TURMERO",
      "client_identification": "V19132538",
      "nap_box_name": "67",
      "created_at": "2024-08-02T15:57:56.628251",
      "service_detail": {
        "id": 5490,
        "ip": "172.19.65.2",
        "mac": "TPLGB954FDCA",
        "serial": "TPLGB954FDCA",
        "queue": "Plan_89283_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-08-16T18:02:24.782799",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6155,
      "client_name": "JAKELINE VIANA GUILLEN",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Antonio Jose de Sucre",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04120332534",
      "client_email": "ARIADNISSUAREZ75@GMAIL.COM",
      "address": "CALLE PRINCIPAL CASA NRO 32 SECTOR ANTONIO JOSE DE SUCRE EL MACARO TURMERO",
      "client_identification": "V10341024",
      "nap_box_name": "123",
      "created_at": "2024-08-02T16:01:15.725817",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6156,
      "client_name": "JUAN CARLOS FREITES REYES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "La Concepcion",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144651681",
      "client_email": "CARLOSFREITES51@GMAIL.COM",
      "address": "AV INTERCOMUNAL EDIF TORRE 11 PISO PB APT PB/01 URB LA CONCEPCION TURMERO",
      "client_identification": "V17311877",
      "nap_box_name": "0326 DOS",
      "created_at": "2024-08-02T16:07:37.138840",
      "service_detail": {
        "id": 4593,
        "ip": "172.21.130.2",
        "mac": "TPLGB954ED65",
        "serial": "TPLGB954ED65",
        "queue": "queue1",
        "interface": "VLAN111_CONCEPCION",
        "created_at": "2024-08-11T19:14:40.880642",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6157,
      "client_name": "MERLYNG IVETTHE PAEZ PAEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Guanarito",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243596883",
      "client_email": "MERLINPAEZ49@GMAIL.COM",
      "address": "CALLE LA ESTRELLA CASA NRO 04 SECTOR GUANARITO",
      "client_identification": "V13357894",
      "nap_box_name": "231",
      "created_at": "2024-08-02T16:10:00.763603",
      "service_detail": {
        "id": 4818,
        "ip": "172.17.97.2",
        "mac": "VSOL00493B51",
        "serial": "VSOL00493B51",
        "queue": "Plan_114480_15811_WispHub",
        "interface": "VLAN232_GUANARITO_OLT2",
        "created_at": "2024-08-12T17:10:04.342295",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6158,
      "client_name": "ANGGI JOSELIN MACHADO CASTRO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "La Concepcion",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04120802791",
      "client_email": "MERY100160@GMAIL.COM",
      "address": "URB LA CONCEPCION  CALLE 2 CASA 40 TURMERO",
      "client_identification": "V18610198",
      "nap_box_name": "109",
      "created_at": "2024-08-02T16:10:48.207231",
      "service_detail": {
        "id": 4592,
        "ip": "172.21.117.2",
        "mac": "TPLGB954FD48",
        "serial": "TPLGB954FD48",
        "queue": "Plan_132787_24341_WispHub",
        "interface": "VLAN111_CONCEPCION",
        "created_at": "2024-08-11T19:11:26.571161",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6159,
      "client_name": "GLEYDIS MARIANGELYS FLORES SUAREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Las Rurales",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243525739",
      "client_email": "GLEI0623@GMAIL.COM",
      "address": "CALLE LA INTERCOMUNAL CASA NRO 3 SECTOR LAS RURALES ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V20056092",
      "nap_box_name": "492",
      "created_at": "2024-08-02T16:13:41.960320",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6160,
      "client_name": "GRUDES AUYULES JUNIOR VERA BLANCO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124775156",
      "client_email": "SOTOLUISCRS@GMAIL.COM",
      "address": "VDA MANZANA E VEREDA 9 CASA NRO 9 SECTOR SAMAN TARAZONERO II TURMERO",
      "client_identification": "V20897625",
      "nap_box_name": "266",
      "created_at": "2024-08-02T16:15:52.669755",
      "service_detail": {
        "id": 4822,
        "ip": "172.19.32.2",
        "mac": "VSOL0012A791",
        "serial": "VSOL0012A791",
        "queue": "Plan_112655_1574_WispHub",
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2024-08-12T17:18:53.736759",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6161,
      "client_name": "SANDY CHETRAM ADNARINE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04145907631",
      "client_email": "SANDYADNARINE@GMAIL.COM",
      "address": "CALLE MANZANA D 12 CASA NRO 06 SECTOR SAMAN TARAZONERO II TURMERO",
      "client_identification": "V25953952",
      "nap_box_name": "266",
      "created_at": "2024-08-02T16:17:40.375679",
      "service_detail": {
        "id": 4590,
        "ip": "172.21.127.2",
        "mac": "TPLGB954FD4B",
        "serial": "TPLGB954FD4B",
        "queue": "Plan_92223_1574_WispHub",
        "interface": "VLAN100_OLTs",
        "created_at": "2024-08-11T18:07:36.209216",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6162,
      "client_name": "CARLOS ALBERTO GUZMAN",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Palmeras I",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04124337053",
      "client_email": "CARLOS10GUZMAN@HOTMAIL.COM",
      "address": "AV PROLONGACION PEÑALVER CASA PARCELA 16 NRO 49 CONJUNTO RESIDENCIAL LAS PALMERAS I SECTOR",
      "client_identification": "V6445334",
      "nap_box_name": "CTO-00071",
      "created_at": "2024-08-02T16:18:45.900921",
      "service_detail": {
        "id": 5192,
        "ip": "172.19.64.2",
        "mac": "TPLGB954F06A",
        "serial": "TPLGB954F06A",
        "queue": "Plan_132787_24341_WispHub",
        "interface": "VLAN118_PALMERAS_1",
        "created_at": "2024-08-15T11:58:24.395419",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6163,
      "client_name": "NESTOR JOSE PINA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Brisas de Paya",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243005332",
      "client_email": "AVISAMETICA19@GMAIL.COM",
      "address": "CALLE 1 CASA NRO 41 SECTOR BRISAS DE PAYA",
      "client_identification": "V13907889",
      "nap_box_name": "369",
      "created_at": "2024-08-02T16:20:13.958948",
      "service_detail": {
        "id": 4823,
        "ip": "172.17.133.2",
        "mac": "VSOL00123EB9",
        "serial": "VSOL00123EB9",
        "queue": "Plan_161892_30183_WispHub",
        "interface": "VLAN241_BRISAS",
        "created_at": "2024-08-12T17:21:02.690334",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6164,
      "client_name": "YANETH RIVERA CABALLERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Brisas de Paya",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243164942",
      "client_email": "GCARRERO.2002@GMAIL.COM",
      "address": "CALLE 1 CASA PARCELA NRO 11 Y 12 SECTOR BRISAS DE PAYA",
      "client_identification": "V12252294",
      "nap_box_name": "367",
      "created_at": "2024-08-02T16:24:10.954355",
      "service_detail": {
        "id": 4825,
        "ip": "172.17.93.2",
        "mac": "VSOL00124321",
        "serial": "VSOL00124321",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN241_BRISAS",
        "created_at": "2024-08-12T17:24:47.224840",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6165,
      "client_name": "KARINA PAOLA ALVAREZ TUIRAN",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Palmeras I",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243398730",
      "client_email": "ALVAREZ.KARI85@GMAIL.COM",
      "address": "CALLE 3 CASA NRO 165 URB LAS PALMERAS I TURMERO",
      "client_identification": "V16684764",
      "nap_box_name": "440",
      "created_at": "2024-08-02T16:24:54.995873",
      "service_detail": {
        "id": 5193,
        "ip": "172.19.66.2",
        "mac": "TPLGB954FB1D",
        "serial": "TPLGB954FB1D",
        "queue": "Plan_132787_24341_WispHub",
        "interface": "VLAN118_PALMERAS_1",
        "created_at": "2024-08-15T12:00:15.104400",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6166,
      "client_name": "NESTOR JAVIER PINA ARAUJO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Brisas de Paya",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243444578",
      "client_email": "ORIANAIPA.315@GMAIL.COM",
      "address": "CALLE 3 CASA NRO 15 SECTOR BRISAS DE PAYA",
      "client_identification": "V27520804",
      "nap_box_name": "366",
      "created_at": "2024-08-02T16:27:47.872650",
      "service_detail": {
        "id": 12519,
        "ip": "172.17.131.2",
        "mac": "1c:ef:03:12:43:91",
        "serial": "VSOL00124391",
        "queue": null,
        "interface": "VLAN241_BRISAS",
        "created_at": "2026-05-17T14:33:49.382295",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6167,
      "client_name": "YOHANDRY ALIMAR CARRENO  AGUILAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Palmeras I",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04128906565",
      "client_email": "CARRENOYOHA@GMAIL.COM",
      "address": "CALLE PRINCIPAL CASA NRO 69 URB PALMERAS I TURMERO",
      "client_identification": "V28432563",
      "nap_box_name": "CTO-00071",
      "created_at": "2024-08-02T16:33:59.026843",
      "service_detail": {
        "id": 5200,
        "ip": "172.19.63.2",
        "mac": "TPLGB954EB64",
        "serial": "TPLGB954EB64",
        "queue": "Plan_132787_24341_WispHub",
        "interface": "VLAN100_OLTs",
        "created_at": "2024-08-15T13:12:12.980194",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6168,
      "client_name": "MARYELIS BEATRIZ PERAZA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "La Casona I",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04245690764",
      "client_email": "MARYELISPE64@GMAIL.COM",
      "address": "CALLE 8 CASA NRO 10 URB CASONA 1 TURMERO",
      "client_identification": "V14292348",
      "nap_box_name": "139",
      "created_at": "2024-08-02T16:34:07.545614",
      "service_detail": {
        "id": 11788,
        "ip": "172.21.126.2",
        "mac": "TPLGB954E8C2",
        "serial": "TPLGB954E8C2",
        "queue": null,
        "interface": "VLAN109_CASONA_1",
        "created_at": "2026-02-27T11:13:37.993715",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6169,
      "client_name": "MIGDALY YAMILE SOLARTE CHOURIO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243267249",
      "client_email": "SOLARTEYAMILE57@GMAIL.COM",
      "address": "CALLE 7 CASA Nº 536C URB MATACABALLO ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V16936755",
      "nap_box_name": "CTO-00238 DOS",
      "created_at": "2024-08-02T16:40:44.685054",
      "service_detail": {
        "id": 4182,
        "ip": "172.31.37.2",
        "mac": "OEMT3C623232",
        "serial": "OEMT3C623232",
        "queue": "Plan_161905_30183_WispHub",
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2024-08-03T13:49:16.626786",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6170,
      "client_name": "YUDIMAR LOURDES POLANCO RUIZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "La Concepcion",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04126039964",
      "client_email": "YUDIMAR0310@GMAIL.COM",
      "address": "AV PRINCIPAL LA CONCEPCION EDIF 9 APT 6 CONJUNTO RESIDENCIAL TURMERO",
      "client_identification": "V25068669",
      "nap_box_name": "0325 DOS",
      "created_at": "2024-08-02T16:40:53.223066",
      "service_detail": {
        "id": 4588,
        "ip": "172.21.132.2",
        "mac": "TPLGB954FD57",
        "serial": "TPLGB954FD57",
        "queue": "Plan_131337_24341_WispHub",
        "interface": "VLAN111_CONCEPCION",
        "created_at": "2024-08-11T18:02:49.036060",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6171,
      "client_name": "LILIBETH BETZABETH PEREZ LEON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Saman de Guere",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04125323140",
      "client_email": "BETZABETHPEREZ228@GMAIL.COM",
      "address": "CALLE PPAL EL SAMAN CASA NRO 06 URB SALTO ANGEL TURMERO",
      "client_identification": "V17571815",
      "nap_box_name": "72",
      "created_at": "2024-08-02T16:40:59.317466",
      "service_detail": {
        "id": 5201,
        "ip": "172.19.62.2",
        "mac": "TPLGB954EF27",
        "serial": "TPLGB954EF27",
        "queue": "Plan_132787_24341_WispHub",
        "interface": "VLAN121_S_ANGEL",
        "created_at": "2024-08-15T13:14:39.189145",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6172,
      "client_name": "IRENE YULIBETH RIVERA MEJIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Salto Angel",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04127761301",
      "client_email": "RIVERALEURYS@GMAIL.COM",
      "address": "CALLE EL SAMAN CASA NRO20 MANZANA 13 SALTO ANGEL",
      "client_identification": "V11982318",
      "nap_box_name": "72",
      "created_at": "2024-08-02T16:49:05.091630",
      "service_detail": {
        "id": 5202,
        "ip": "172.19.61.2",
        "mac": "TPLGB955012A",
        "serial": "TPLGB955012A",
        "queue": "Plan_132787_24341_WispHub",
        "interface": "VLAN100_OLTs",
        "created_at": "2024-08-15T13:16:47.659418",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6173,
      "client_name": "DAYANA ALEXANDRA ARIAS CORONEL",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144479631",
      "client_email": "DAAC2225@GMAIL.COM",
      "address": "CALLE MANZANA C-6 CASA NRO 8 URB SAMAN  TARAZONERO II",
      "client_identification": "V15180570",
      "nap_box_name": "263",
      "created_at": "2024-08-02T16:51:53.853236",
      "service_detail": {
        "id": 4587,
        "ip": "172.21.141.2",
        "mac": "TPLG1BB364B9",
        "serial": "TPLG1BB364B9",
        "queue": "Plan_92223_1574_WispHub",
        "interface": "VLAN100_OLTs",
        "created_at": "2024-08-11T18:00:06.305171",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6174,
      "client_name": "CARLOS ALBERTO GUTIERREZ APONTE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Salto Angel",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128918074",
      "client_email": "COMPUSISA23@GMAIL.COM",
      "address": "CALLE LOS PINOS MANZANA E CASA NRO 02 URB SALTO ANGEL",
      "client_identification": "V5265519",
      "nap_box_name": "39",
      "created_at": "2024-08-02T16:52:02.713395",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6175,
      "client_name": "LAURA CRISTINA DE LA INMACULAD FRANCO DE GOMEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Valle Paraiso",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04144502781",
      "client_email": "LAURAFRANCO07@GMAIL.COM",
      "address": "CALLE PRINCIPAL CASA NRO 20 URB VALLE PARAISO TURMERO",
      "client_identification": "V6364056",
      "nap_box_name": "CTO-0642",
      "created_at": "2024-08-02T16:56:20.887057",
      "service_detail": {
        "id": 4586,
        "ip": "172.21.134.2",
        "mac": "TPLGB68B55B1",
        "serial": "TPLGB68B55B1",
        "queue": "Plan_157815_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-08-11T17:37:59.906569",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6176,
      "client_name": "LEIDA JOSEFINA PRADO SALAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Julia",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04128908294",
      "client_email": "LEIDAPRADO57@GMAIL.COM",
      "address": "CALLE CARIDAD DEL COBRE CASA NRO 17 SECTOR COLECTIVO LA NUEVA JULIA.",
      "client_identification": "V14183417",
      "nap_box_name": "628",
      "created_at": "2024-08-02T16:57:57.342082",
      "service_detail": {
        "id": 5240,
        "ip": "172.19.57.2",
        "mac": "TPLGF5CB0246",
        "serial": "TPLGF5CB0246",
        "queue": "Plan_132787_24341_WispHub",
        "interface": "VLAN138_LAJULIA",
        "created_at": "2024-08-15T15:10:17.793022",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6177,
      "client_name": "NATHALIA CENAIR OLIVIERI UTRERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "La Casona I",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04169583335",
      "client_email": "JUANLEALGPP@GMAIL.COM",
      "address": "CALLE 8 CASA NRO 91 URB LA CASONA I TURMERO",
      "client_identification": "V19833148",
      "nap_box_name": "45",
      "created_at": "2024-08-02T17:02:12.040863",
      "service_detail": {
        "id": 11786,
        "ip": "172.19.56.2",
        "mac": "TPLGF5CB01E0",
        "serial": "TPLGF5CB01E0",
        "queue": null,
        "interface": "VLAN109_CASONA_1",
        "created_at": "2026-02-27T11:12:54.049301",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6178,
      "client_name": "HENRY JOHAN IBARRA HIDALGO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "La Casona I",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04128867532",
      "client_email": "HENRYIBARRA3021@GMAIL.COM",
      "address": "CALLE 5 CASA NRO 36 SECTOR TARAZONERO ISUR SAN DE GUERE TURMERO ARAGUA 2115 (CASONAI)",
      "client_identification": "V13066029",
      "nap_box_name": "45",
      "created_at": "2024-08-02T17:10:03.049830",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6179,
      "client_name": "JESUS DANIEL GAMEZ HERNANDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Laguna Plaza",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04149446995",
      "client_email": "JESUSDGAME1@HOTMAIL.COM",
      "address": "CALLE NEGRO PRIMERO EDIFICICIO 1 PB-4 URBANIZACION LAGUNA PLAZA TURMERO ESTADO ARAGUA",
      "client_identification": "V18645013",
      "nap_box_name": "4",
      "created_at": "2024-08-03T11:28:40.567833",
      "service_detail": {
        "id": 5317,
        "ip": "172.18.126.2",
        "mac": "TPLGB8628475",
        "serial": "TPLGB8628475",
        "queue": "Plan_153953_15811_WispHub",
        "interface": "VLAN216_LAGUNA_PLAZA_OLT1",
        "created_at": "2024-08-16T09:09:44.132067",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6181,
      "client_name": "CESAR ENRIQUE LOPEZ SANCHEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04122387146",
      "client_email": "ANAELIXQA@GMAIL.COM",
      "address": "CALLE 16 B CASA NRO 48 URB PANTI TURMERO EDO ARAGUA ROSARIO DE PAYA ARAGUA",
      "client_identification": "V9913319",
      "nap_box_name": "CTO-00026",
      "created_at": "2024-08-03T17:11:17.340427",
      "service_detail": {
        "id": 4843,
        "ip": "172.17.149.2",
        "mac": "VSOL0012A051",
        "serial": "VSOL0012A051",
        "queue": "Plan_161890_30183_WispHub",
        "interface": "VLAN229_PANTIN",
        "created_at": "2024-08-12T18:06:52.276356",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6182,
      "client_name": "JESUSLEY KATHERINE VILLANUEVA PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243298004",
      "client_email": "VJESUSLEY@GMAIL.COM",
      "address": "CALLE 14-B CASA NRO 33 URB PANTI ROSARIO DE PAYA ARAGUA",
      "client_identification": "V22290007",
      "nap_box_name": "CTO-00052",
      "created_at": "2024-08-03T17:13:07.338010",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6183,
      "client_name": "RICHARD ALFREDO MELLADO CASTILLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Pantin",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04243803786",
      "client_email": "RICHARDMELLADO75@GMAIL.COM",
      "address": "CALLE 2-B CASA NRO 46 URB PANTIN TURMERO ARAGUA",
      "client_identification": "V12881421",
      "nap_box_name": "CTO-00126",
      "created_at": "2024-08-03T17:50:44.959208",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6184,
      "client_name": "MARIA MILAGRO FARFAN CAMPOS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Guanarito",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243661994",
      "client_email": "MARIAMILAGROS1774@GMAIL.COM",
      "address": "CALLE PEÑALVER CASA NRO 46 SECTOR GUANARITO",
      "client_identification": "V11976726",
      "nap_box_name": "447",
      "created_at": "2024-08-03T17:53:22.098557",
      "service_detail": {
        "id": 4848,
        "ip": "172.17.114.2",
        "mac": "VSOL004839A1",
        "serial": "VSOL004839A1",
        "queue": "Plan_114480_15811_WispHub",
        "interface": "VLAN232_GUANARITO_OLT2",
        "created_at": "2024-08-12T18:16:34.705387",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6185,
      "client_name": "YANETTE JOSEFINA GUZMAN RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121489818",
      "client_email": "MATHIASYSABRINA2014@GMAIL.COM",
      "address": "CALLE 7B CASA NRO 33 URB PANTIN",
      "client_identification": "V9438840",
      "nap_box_name": "CTO-00140",
      "created_at": "2024-08-03T17:55:01.879801",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6186,
      "client_name": "ROSSANA SULIMAR VASQUEZ SALAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128979907",
      "client_email": "SULIMARVASQUEZ1982@GMAIL.COM",
      "address": "CALLE 20 CASA NRO 18 URB PANTIN",
      "client_identification": "V16407051",
      "nap_box_name": "CTO-00435",
      "created_at": "2024-08-03T17:56:50.398974",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6187,
      "client_name": "MARIANA LISSETTHE MARACARA ORELLANA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Vista Hermosa",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04123495322",
      "client_email": "MARIANAMARACARA40@GMAIL.COM",
      "address": "CALLE EL ROSARIO CASA NRO 19 SECTOR VISTA HERMOSA",
      "client_identification": "V14038779",
      "nap_box_name": "CTO-00058",
      "created_at": "2024-08-03T18:01:40.215977",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6188,
      "client_name": "YAN HENRY OLIVARES BRICEÑO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Vista Hermosa",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128556385",
      "client_email": "YANHENRYOB_85@HOTMAIL.COM",
      "address": "CALLE EL ROSARIO CASA NRO 39 VISTA HERMOSA ROSARIO DE PAYA",
      "client_identification": "V16763378",
      "nap_box_name": "CTO-00057",
      "created_at": "2024-08-03T18:03:27.120850",
      "service_detail": {
        "id": 11984,
        "ip": "172.17.70.2",
        "mac": "VSOL001246A9",
        "serial": "VSOL001246A9",
        "queue": null,
        "interface": "VLAN230_VISTA_HERMOSA",
        "created_at": "2026-03-06T12:47:04.562358",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6189,
      "client_name": "ANYI COROMOTO MORALES BASTIDAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Santa Eduviges",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243330582",
      "client_email": "ANGIEMORALESCB@GMAIL.COM",
      "address": "CARRETERA NACIONAL TURMERO MARACAY EDIFICIO ANA LEONOR PISO 2 APTO A EL MACARO",
      "client_identification": "V19790660",
      "nap_box_name": "86 DOS",
      "created_at": "2024-08-03T18:05:13.283814",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6190,
      "client_name": "EMIGDIO JOSE ROCHA HERNANDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "El Macaro",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04126652782",
      "client_email": "LIZBELENH@GMAIL.COM",
      "address": "AV INTERCOMUNAL TURMERO MARACAY CASA NRO 25 SECTOR EL MACARO TURMERO",
      "client_identification": "V9407880",
      "nap_box_name": "500",
      "created_at": "2024-08-03T18:09:17.990084",
      "service_detail": {
        "id": 4866,
        "ip": "172.17.74.2",
        "mac": "VSOL004936B1",
        "serial": "VSOL004936B1",
        "queue": "Plan_107915_1574_WispHub",
        "interface": "VLAN104_EL_MACARO_OLT_ZTE",
        "created_at": "2024-08-13T07:39:19.484833",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6191,
      "client_name": "JOSE GREGORIO ASCANIO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Pantin",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04141210312",
      "client_email": "J09197147@GMAIL.COM",
      "address": "PANTIN CALLE 13B NRO 28 ROSARIO DE PAYA",
      "client_identification": "V6960392",
      "nap_box_name": "CTO-00171",
      "created_at": "2024-08-03T18:11:42.344854",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6192,
      "client_name": "HENRRY JOSE TORRES BASTIDAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04127767958",
      "client_email": "CAR1973.MCY@GMAIL.COM",
      "address": "CALLE 13 CASA NRO 51 URB HACIENDA PANTIN",
      "client_identification": "V13130567",
      "nap_box_name": "CTO-00171",
      "created_at": "2024-08-03T18:16:08.821434",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6193,
      "client_name": "ROSA ELENA AMADOR TOVAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Paya Abajo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04123492556",
      "client_email": "ANYERLIN.845@GMAIL.COM",
      "address": "CALLE LA CAPILLA CASA NRO 14 SECTOR PAYA ABAJO ROSARIO DE PAYA EDO ARAGUA TURMERO ARAGUA",
      "client_identification": "V16849476",
      "nap_box_name": "254",
      "created_at": "2024-08-03T18:19:11.156567",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6194,
      "client_name": "TONNY ARFILIO SILVA CONTRERAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Palmeras I",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04140524367",
      "client_email": "SILVATONNY@GMAIL.COM",
      "address": "CALLE PPAL NRO 63 PALMERAS I TURMERO",
      "client_identification": "V5673310",
      "nap_box_name": "CTO-00226",
      "created_at": "2024-08-04T11:30:02.191726",
      "service_detail": {
        "id": 10621,
        "ip": "172.19.29.2",
        "mac": "TPLGB954F835",
        "serial": "TPLGB954F835",
        "queue": null,
        "interface": "VLAN118_PALMERAS_1",
        "created_at": "2025-12-06T19:23:54.672299",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6195,
      "client_name": "HENYERBE GOTTO CHIRINOS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Palmeras II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144897364",
      "client_email": "GOTTOCHIRINOS1@HOTMAIL.COM",
      "address": "CALLE C MANZANA G CASA NRO 141-G CONJUNTO RESIDENCIAL LAS PALMERAS II",
      "client_identification": "V15123733",
      "nap_box_name": "287",
      "created_at": "2024-08-04T11:34:15.973681",
      "service_detail": {
        "id": 5283,
        "ip": "172.19.30.2",
        "mac": "TPLGF5CB012F",
        "serial": "TPLGF5CB012F",
        "queue": "Plan_132787_24341_WispHub",
        "interface": "VLAN100_OLTs",
        "created_at": "2024-08-15T17:28:13.204798",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6196,
      "client_name": "YRIS JOSEFINA ALVARADO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Palmeras I",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04142861790",
      "client_email": "YRISJOSEAL@GMAIL.COM",
      "address": "CALLE PRINCIPAL CASA NRO 73 URB LAS PALMERAS I",
      "client_identification": "V9642545",
      "nap_box_name": "CTO-00226",
      "created_at": "2024-08-04T11:40:42.267733",
      "service_detail": {
        "id": 5285,
        "ip": "172.19.28.2",
        "mac": "TPLGF5CB0208",
        "serial": "TPLGF5CB0208",
        "queue": "Plan_132787_24341_WispHub",
        "interface": "VLAN118_PALMERAS_1",
        "created_at": "2024-08-15T17:31:59.113332",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6197,
      "client_name": "MAIRET YOSELIN SALAZAR IGLESIAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "La Floresta",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243452626",
      "client_email": "SALAZARMAIRET@GMAIL.COM",
      "address": "CALLE NRO 3 CASA NRO 17 URB PARQUE RESIDENCIAL LA FLORESTA TURMERO",
      "client_identification": "V22942682",
      "nap_box_name": "32 DOS",
      "created_at": "2024-08-04T11:44:11.304014",
      "service_detail": {
        "id": 10002,
        "ip": "172.19.27.2",
        "mac": "OEMT3C62511E",
        "serial": "OEMT3C62511E",
        "queue": null,
        "interface": "VLAN212_FLORESTA_OLT1",
        "created_at": "2025-11-11T14:04:21.743455",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6198,
      "client_name": "YVETTE RITA COLMENARES SAMUEL",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "La Casona II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04127790835",
      "client_email": "AUGUSTOOCHOA2000@GMAIL.COM",
      "address": "CALLE 13 CASA NRO 87 URB LA CASONA II TURMERO",
      "client_identification": "V9670078",
      "nap_box_name": "CTO-00089",
      "created_at": "2024-08-04T11:47:33.744179",
      "service_detail": {
        "id": 5287,
        "ip": "172.19.24.2",
        "mac": "TPLGB954EC85",
        "serial": "TPLGB954EC85",
        "queue": "queue1",
        "interface": "VLAN100_OLTs",
        "created_at": "2024-08-15T18:05:53.962503",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6199,
      "client_name": "WALESKA MARIA VILLARREAL ANDRADE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Palmeras II",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243790633",
      "client_email": "WALESKAMARIA27@GMAIL.COM",
      "address": "CALLE MANZANA E CASA NRO 2 URB LAS PALMERAS II",
      "client_identification": "V26021651",
      "nap_box_name": "287",
      "created_at": "2024-08-04T11:51:11.873097",
      "service_detail": {
        "id": 9905,
        "ip": "172.19.23.2",
        "mac": "TPLGF5CB0389",
        "serial": "TPLGF5CB0389",
        "queue": null,
        "interface": "VLAN119_PALMERAS_2",
        "created_at": "2025-11-10T22:50:14.023599",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6200,
      "client_name": "ROLANDO DE JESUS MONTILLA VALERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Palmeras II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04127543202",
      "client_email": "RMONTILLA979@HOTMAIL.COM",
      "address": "AV PROLONGACION PEÑALVER CASA NRO 96 URB LAS PALMERAS II",
      "client_identification": "V14183575",
      "nap_box_name": "288",
      "created_at": "2024-08-04T11:54:32.171873",
      "service_detail": {
        "id": 5289,
        "ip": "172.19.22.2",
        "mac": "TPLGF5CB0094",
        "serial": "TPLGF5CB0094",
        "queue": "Plan_132968_24341_WispHub",
        "interface": "VLAN119_PALMERAS_2",
        "created_at": "2024-08-15T18:12:51.696905",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6201,
      "client_name": "YOBEIDA MARIA CAMACARO DE MAMBEL",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "San Sebastian",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128902023",
      "client_email": "YOBEIDA46@GMAIL.COM",
      "address": "CALLE PRIMERA TRNSVERSAL CASA NRO 13 URB SAN SEBASTIAN",
      "client_identification": "V11086065",
      "nap_box_name": "61",
      "created_at": "2024-08-04T11:57:56.293460",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6202,
      "client_name": "EDGAR ENRIQUE HURTADO DIAZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Isaac Oliveira",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243017870",
      "client_email": "EDGAREHD233@GMAIL.COM",
      "address": "AV PRINCIPAL CASA NRO 26 URB ISAAC OLIVEIRA",
      "client_identification": "V27894660",
      "nap_box_name": "CTO-00257",
      "created_at": "2024-08-04T14:30:33.454435",
      "service_detail": {
        "id": 11833,
        "ip": "172.17.102.2",
        "mac": "VSOL00491CD9",
        "serial": "VSOL00491CD9",
        "queue": null,
        "interface": "VLAN107_ISAAC_O",
        "created_at": "2026-02-27T11:50:51.963602",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6203,
      "client_name": "LEONARDO JOSE MEDINA RICO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Isaac Oliveira",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04141465611",
      "client_email": "LEONARDOJMEDINA@OUTLOOK.ES",
      "address": "CALLE ISAAC OLIVERA CALLE 3 NRO 91 URB ISAAC OLIVERA",
      "client_identification": "V26734121",
      "nap_box_name": "134",
      "created_at": "2024-08-04T14:34:00.175587",
      "service_detail": {
        "id": 11827,
        "ip": "172.17.101.2",
        "mac": "VSOL00493AA9",
        "serial": "VSOL00493AA9",
        "queue": null,
        "interface": "VLAN107_ISAAC_O",
        "created_at": "2026-02-27T11:48:32.664231",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6204,
      "client_name": "RAUL ALBERTO APARICIO AGUILERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Isaac Oliveira",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243564342",
      "client_email": "RAULAPARICIO10@GMAIL.COM",
      "address": "CALLE 3 CASA NRO 115 URB ISAAC OLIVERA",
      "client_identification": "V26425308",
      "nap_box_name": "CTO-00259",
      "created_at": "2024-08-04T14:35:38.572920",
      "service_detail": {
        "id": 11856,
        "ip": "10.10.131.2",
        "mac": "VSOL00493B29",
        "serial": "VSOL00493B29",
        "queue": null,
        "interface": "VLAN107_ISAAC_O",
        "created_at": "2026-02-27T14:40:39.624576",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6205,
      "client_name": "RICHARD DANIEL NAVAS PEREIRA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Prados III",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121577183",
      "client_email": "DANIELNAVAS0309@GMAIL.COM",
      "address": "CALLE 4 CASA NRO 1 SECTOR PRADOS III",
      "client_identification": "V17472792",
      "nap_box_name": "CTO-00299",
      "created_at": "2024-08-04T14:39:33.363818",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6206,
      "client_name": "YUSMEIGLY JOSEFINA LOPEZ MENDOZA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Villeguita",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04143478918",
      "client_email": "YUSMEIGLY@GMAIL.COM",
      "address": "CALLE PAEZ CASA NRO 23 SECTOR VILLEGUITA TURMERO",
      "client_identification": "V24420054",
      "nap_box_name": "347",
      "created_at": "2024-08-04T15:25:48.264745",
      "service_detail": {
        "id": 4880,
        "ip": "172.17.62.2",
        "mac": "VSOL00129FB1",
        "serial": "VSOL00129FB1",
        "queue": "Plan_92300_15811_WispHub",
        "interface": "VLAN238_VILLEGUITA",
        "created_at": "2024-08-13T08:06:51.307741",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6207,
      "client_name": "JHON FREDDY OCHOA ORDOÑEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Pantin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121392434",
      "client_email": "NANCYOCHOA010925@GMAIL.COM",
      "address": "CALLE 11 CASA NRO 20 PANTIN ROSARIO DE PAYA",
      "client_identification": "V13761025",
      "nap_box_name": "CTO-00167",
      "created_at": "2024-08-04T15:27:28.187092",
      "service_detail": {
        "id": 4881,
        "ip": "172.17.66.2",
        "mac": "VSOL001399B9",
        "serial": "VSOL001399B9",
        "queue": "Plan_161891_30183_WispHub",
        "interface": "VLAN229_PANTIN",
        "created_at": "2024-08-13T08:08:37.177215",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6208,
      "client_name": "ALEXANDER RAMON MEDINA ROSSI",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04127768630",
      "client_email": "m4ri4martinez1234@GMAIL.COM",
      "address": "CALLE 11-A A CASA NRO 21 PANTIN ROSARIO DE PAYA",
      "client_identification": "V11173684",
      "nap_box_name": "CTO-00167",
      "created_at": "2024-08-04T15:29:03.375975",
      "service_detail": {
        "id": 5525,
        "ip": "172.17.69.2",
        "mac": "VSOL0013EB71",
        "serial": "VSOL0013EB71",
        "queue": "Plan_161891_30183_WispHub",
        "interface": "VLAN229_PANTIN",
        "created_at": "2024-08-16T21:01:18.085035",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6209,
      "client_name": "YUSGLEIDY ADRIANA LOPEZ MENDOZA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04125975771",
      "client_email": "YUSGLEIDYLOPEZ@ICLOUD.COM",
      "address": "CALLE GRANADA CASA PARCELA 67-3 URB SAN PABLO TURMERO",
      "client_identification": "V19793820",
      "nap_box_name": "CTO-0639",
      "created_at": "2024-08-04T15:30:43.797460",
      "service_detail": {
        "id": 13055,
        "ip": "172.17.63.2",
        "mac": "VS:OL:00:13:B5:39",
        "serial": "VSOL0013B539",
        "queue": null,
        "interface": "VLAN224_SAN_PABLO_OLT1",
        "created_at": "2026-09-21T12:25:44.039675",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6210,
      "client_name": "YOLICA CAROLINA RAMOS HERNANDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Prados III",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04228151395",
      "client_email": "YAYAROJASYOLI@GMAIL.COM",
      "address": "AV 2 CASA NRO 18 PRADOS III ROSARIO DE PAYA",
      "client_identification": "V19208905",
      "nap_box_name": "580 DOS",
      "created_at": "2024-08-04T15:33:40.150572",
      "service_detail": {
        "id": 4890,
        "ip": "172.17.60.2",
        "mac": "VSOL0013E9C9",
        "serial": "VSOL0013E9C9",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN236_PRADOS3",
        "created_at": "2024-08-13T09:14:39.950370",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6211,
      "client_name": "AIDA JOSEFINA FRAGACHAN DE VARELA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243235173",
      "client_email": "2017JUANNIEVES@GMAIL.COM",
      "address": "CALLE 6 CASA NRO 405 URB MATA CABALLO ROSARIO DE PAYA",
      "client_identification": "V12159747",
      "nap_box_name": "CTO-00312",
      "created_at": "2024-08-04T15:38:28.078967",
      "service_detail": {
        "id": 4891,
        "ip": "172.17.44.2",
        "mac": "VSOL00493A71",
        "serial": "VSOL00493A71",
        "queue": "Plan_161891_30183_WispHub",
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2024-08-13T09:16:48.841088",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6212,
      "client_name": "SIMON ALBERTO PAEZ GUEVARA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Guanarito",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121481533",
      "client_email": "MAMUALBRITO@GMAIL.COM",
      "address": "CALLE ARAGUANEY CASA NRO 9 GUANARITO TURMERO",
      "client_identification": "V4546879",
      "nap_box_name": "434",
      "created_at": "2024-08-04T15:46:09.672485",
      "service_detail": {
        "id": 4892,
        "ip": "172.17.58.2",
        "mac": "VSOL0013D9D1",
        "serial": "VSOL0013D9D1",
        "queue": "Plan_114480_15811_WispHub",
        "interface": "VLAN232_GUANARITO_OLT2",
        "created_at": "2024-08-13T09:21:30.888403",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6213,
      "client_name": "JONATHAN JOSE LINARES DELGADO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "La Casona II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124570279",
      "client_email": "JOTAJOTAL1997@GMAIL.COM",
      "address": "AV INTERCOMUNAL TURMERO EDIF 12 PISO 2 APTO 05 LA CASONA II",
      "client_identification": "V26055751",
      "nap_box_name": "CTO-00086",
      "created_at": "2024-08-04T15:48:29.818322",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6214,
      "client_name": "FRANLENYS AYSKEL MENDOZA MATOS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04266346343",
      "client_email": "FRANLENYSMENDOZA@GMAIL.COM",
      "address": "VDA MANZANA B-10 CASA NRO 9 URB SAMAN TARAZONERO II TURMERO",
      "client_identification": "V21099671",
      "nap_box_name": "281",
      "created_at": "2024-08-04T15:49:46.456917",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6215,
      "client_name": "MARIA DEL CARMEN RODRIGUEZ ISTURIZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04241352007",
      "client_email": "CATIRESSS222@GMAIL.COM",
      "address": "CALLE 04 CASA NRO 278 SECTOR MATA CABALLO ROSARIO DE PAYA",
      "client_identification": "V15440181",
      "nap_box_name": "CTO-00272",
      "created_at": "2024-08-04T15:53:17.154186",
      "service_detail": {
        "id": 4896,
        "ip": "172.17.50.2",
        "mac": "VSOL00139E19",
        "serial": "VSOL00139E19",
        "queue": "Plan_161893_30183_WispHub",
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2024-08-13T09:36:30.395839",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6216,
      "client_name": "MELDENSON ALBERTO RAMIREZ TORTOLERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04243187544",
      "client_email": "SEQUERAWANDA46@GMAIL.COM",
      "address": "CALLE 11 CASA NRO 638-B URB MATA CABALLO TURMERO",
      "client_identification": "V19594782",
      "nap_box_name": "CTO-0337",
      "created_at": "2024-08-04T15:54:54.262570",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6217,
      "client_name": "JULIBETH CAROLINA OCHOA VIELMA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124063749",
      "client_email": "JULIBETHOCHOA1408@GMAIL.COM",
      "address": "VDA PRINCIPAL 1 MANZANA C1 NRO 06 URB SAMAN TARAZONERO II TURMERO",
      "client_identification": "V18977140",
      "nap_box_name": "263",
      "created_at": "2024-08-04T15:56:20.795612",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6218,
      "client_name": "HERLIN MARINES COBOS ARAUJO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124574187",
      "client_email": "HERLYN2076@GMAIL.COM",
      "address": "CALLE MANZANA D16 CASA SAMAN TARAZONERO II EL MACARO",
      "client_identification": "V12564097",
      "nap_box_name": "278",
      "created_at": "2024-08-04T15:58:11.781039",
      "service_detail": {
        "id": 4898,
        "ip": "172.17.55.2",
        "mac": "VSOL00140299",
        "serial": "VSOL00140299",
        "queue": "Plan_107915_1574_WispHub",
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2024-08-13T09:41:28.535551",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6219,
      "client_name": "ALEXANDRA JOSEFINA PEDRA GONZALEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128907622",
      "client_email": "FINAPEDRA1@GMAIL.COM",
      "address": "CALLE 2 CASA NRO 90 URB MATA CABALLO ROSARIO DE PAYA",
      "client_identification": "V30212064",
      "nap_box_name": "CTO-00102",
      "created_at": "2024-08-04T15:59:37.108122",
      "service_detail": {
        "id": 4900,
        "ip": "172.17.46.2",
        "mac": "VSOL00140119",
        "serial": "VSOL00140119",
        "queue": "Plan_161893_30183_WispHub",
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2024-08-13T09:45:14.399035",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6220,
      "client_name": "HOWMERD JOSE MORALES ROMERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Laguna II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128912672",
      "client_email": "MHOWMERD@GMAIL.COM",
      "address": "AV INTERCOMUNAL SUR EDIF TORRE 12 PISO 1 APT LAGUNA 2",
      "client_identification": "V24686079",
      "nap_box_name": "CTO-0489",
      "created_at": "2024-08-04T16:01:18.024260",
      "service_detail": {
        "id": 7860,
        "ip": "172.17.6.2",
        "mac": "VSOL0013F271",
        "serial": "VSOL0013F271",
        "queue": "Plan_92194_15811_WispHub",
        "interface": "VLAN215_LAGUNA_2_OLT1",
        "created_at": "2025-03-07T08:41:36.023438",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6221,
      "client_name": "JOSLAYDEE SOLANGEL ESPINOZA GARCIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Antonio Jose de Sucre",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04128981063",
      "client_email": "SOLYGEREMY@GMAIL.COM",
      "address": "AV ANTONIO JOSE DE SUCRE CASA NRO 40 EL MACARO",
      "client_identification": "V21272820",
      "nap_box_name": "122",
      "created_at": "2024-08-04T16:03:20.912104",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6222,
      "client_name": "YOSELIN NOHELY PACHECO GOMEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Durpa",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121491332",
      "client_email": "YOSEGOMEZJB@GMAIL.COM",
      "address": "MANZANA 19 CASA NRO 05 SECTOR DESARROLLO URBANISTICO DURPA",
      "client_identification": "V21097137",
      "nap_box_name": "352",
      "created_at": "2024-08-04T16:04:43.961036",
      "service_detail": {
        "id": 5079,
        "ip": "172.17.207.2",
        "mac": "VSOL0051E579",
        "serial": "VSOL0051E579",
        "queue": "queue1",
        "interface": "VLAN240_DURPA",
        "created_at": "2024-08-14T12:25:01.647640",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6223,
      "client_name": "VERONICA MARIA MONTIEL MARTINEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Salto Angel",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128908565",
      "client_email": "VERONICAMONTIEL0404@GMAIL.COM",
      "address": "CALLE LOS GIRASOLES NRO 15 URB SALTO ANGEL",
      "client_identification": "V23919547",
      "nap_box_name": "CTO - 68",
      "created_at": "2024-08-04T16:07:42.665688",
      "service_detail": {
        "id": 4903,
        "ip": "172.24.68.2",
        "mac": "VSOL0013C451",
        "serial": "VSOL0013C451",
        "queue": "Plan_131647_24341_WispHub",
        "interface": "VLAN121_S_ANGEL",
        "created_at": "2024-08-13T10:06:36.976187",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6224,
      "client_name": "JOSE ANGEL SAEZ CAMPOS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "La Casona I",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128907498",
      "client_email": "JOSESAEZ0110@GMAIL.COM",
      "address": "LA CASONA I CALLE 6 CASA NRO 44 TURMERO",
      "client_identification": "V9671785",
      "nap_box_name": "45",
      "created_at": "2024-08-04T16:09:46.454773",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6225,
      "client_name": "ANA VICTORIA CONTRERAS MOLINA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Prados III",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04143909978",
      "client_email": "VICTORIACONTRERAS2013@GMAIL.COM",
      "address": "CALLE 1 CASA NRO 41 BARRIO PRADOS DE PAYA 3 TURMERO",
      "client_identification": "V12143475",
      "nap_box_name": "579 DOS",
      "created_at": "2024-08-04T16:11:22.715178",
      "service_detail": {
        "id": 4909,
        "ip": "172.17.12.2",
        "mac": "VSOL00138EB1",
        "serial": "VSOL00138EB1",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN236_PRADOS3",
        "created_at": "2024-08-13T10:20:16.020518",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6226,
      "client_name": "VIVIANA HADDAD FAKS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04123988591",
      "client_email": "MOUCHATAHABIB85@GMAIL.COM",
      "address": "CALLE RIBAS EDIF DON JORGE PISO 2 APTO 2-1 SECTOR CENTRO TURMERO",
      "client_identification": "V14183593",
      "nap_box_name": "CTO-00129",
      "created_at": "2024-08-04T16:49:18.798522",
      "service_detail": {
        "id": 5290,
        "ip": "172.19.19.2",
        "mac": "TPLGB954FECA",
        "serial": "TPLGB954FECA",
        "queue": "Plan_92291_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-08-15T18:14:45.514233",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6227,
      "client_name": "YEREMI JOSE MORENO JIMENEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243035554",
      "client_email": "YEREMIG1214@GMAIL.COM",
      "address": "MANZANA 9 CASA NRO5 SECTOR SAMAN TARAZONERO II TURMERO",
      "client_identification": "V31382244",
      "nap_box_name": "485",
      "created_at": "2024-08-04T16:59:53.314312",
      "service_detail": {
        "id": 5303,
        "ip": "172.19.14.2",
        "mac": "TPLGB954FD26",
        "serial": "TPLGB954FD26",
        "queue": "Plan_92223_1574_WispHub",
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2024-08-16T08:06:33.891597",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6228,
      "client_name": "LISBETH DEL CARMEN AURE ORTEGA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121316891",
      "client_email": "LISBETHAUREORTEGA@GMAIL.COM",
      "address": "SAMAN TARAZONERO II MANZANA C, CASA N3 TURMERO EDO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V19652517",
      "nap_box_name": "263",
      "created_at": "2024-08-04T17:02:41.649270",
      "service_detail": {
        "id": 11071,
        "ip": "172.19.13.2",
        "mac": "TPLGB954EC86",
        "serial": "TPLGB954EC86",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2026-01-09T15:37:22.377885",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6229,
      "client_name": "JORGE BALADI BAYLANE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04143441112",
      "client_email": "BALADIGIL@GMAIL.COM",
      "address": "CALLE C-5 CASA NRO 22 URB SAMAN TARAZONERO II TURMERO",
      "client_identification": "V8813039",
      "nap_box_name": "64",
      "created_at": "2024-08-04T17:08:44.554209",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6230,
      "client_name": "DAYNUVER AURORA ACOSTA ACOSTA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Santa Barbara",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243174283",
      "client_email": "DAYNUVERACOSTA2016@GMAIL.COM",
      "address": "CALLE 03 CASA NRO 02 SECTOR SANTA BARBARA TURMERO ARAGUA",
      "client_identification": "V12853154",
      "nap_box_name": "40",
      "created_at": "2024-08-04T17:19:46.448803",
      "service_detail": {
        "id": 5306,
        "ip": "172.19.9.2",
        "mac": "TPLGF5CB0260",
        "serial": "TPLGF5CB0260",
        "queue": "Plan_107915_1574_WispHub",
        "interface": "VLAN100_OLTs",
        "created_at": "2024-08-16T08:13:25.821978",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6231,
      "client_name": "JAIMEN ENRIQUE URBINA DIAZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "La Casona II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04245588749",
      "client_email": "JAIMENURBINA@GMAIL.COM",
      "address": "CALLE 12 CASA NRO 93 URB LA CASONA II, TURMERO",
      "client_identification": "V14664271",
      "nap_box_name": "CTO-00089",
      "created_at": "2024-08-04T17:23:21.959286",
      "service_detail": {
        "id": 5309,
        "ip": "172.19.4.2",
        "mac": "TPLGF5CB02F0",
        "serial": "TPLGF5CB02F0",
        "queue": "Plan_132787_24341_WispHub",
        "interface": "VLAN110_CASONA_2",
        "created_at": "2024-08-16T08:19:28.022366",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6232,
      "client_name": "YOLIMAR DEL CARMEN ROJAS MOYETONES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "La Casona II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128860659",
      "client_email": "YOLIROJAS1815@GMAIL.COM",
      "address": "CALLE 13 CASA NRO 119 CASERIO LA  CASONA II TURMERO",
      "client_identification": "V27520216",
      "nap_box_name": "CTO-00091 DOS",
      "created_at": "2024-08-04T17:29:37.514261",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6233,
      "client_name": "JOSE TRINIDAD CORDERO SANTANDER",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona II",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243115870",
      "client_email": "TRINIDADSANTANDER369@GMAIL.COM",
      "address": "CALLE 13 CASA NRO 112 URB LA CASONA II TURMERO",
      "client_identification": "V9699464",
      "nap_box_name": "CTO-00091 DOS",
      "created_at": "2024-08-04T17:45:04.341141",
      "service_detail": {
        "id": 5437,
        "ip": "172.19.2.2",
        "mac": "TPLGF5CB032F",
        "serial": "TPLGF5CB032F",
        "queue": "Plan_131648_24341_WispHub",
        "interface": "VLAN110_CASONA_2",
        "created_at": "2024-08-16T16:14:36.798973",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6234,
      "client_name": "FLOR DE MARIA HERRERA QUIJADA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "San Pablo",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04125989075",
      "client_email": "MARCELRENE66@GMAIL.COM",
      "address": "CALLE HICELE MANZANA 7 CASA NRO 6 URB SAN PABLO TURMERO",
      "client_identification": "V632632",
      "nap_box_name": "26",
      "created_at": "2024-08-04T17:47:41.896310",
      "service_detail": {
        "id": 11596,
        "ip": "172.18.252.2",
        "mac": "TPLGF5CB0374",
        "serial": "TPLGF5CB0374",
        "queue": null,
        "interface": "VLAN224_SAN_PABLO_OLT1",
        "created_at": "2026-02-11T18:54:04.469827",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6235,
      "client_name": "DIEGO ANTONIO PEREZ SANCHEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "San Pablo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144889038",
      "client_email": "DIEGOPREZ19@GMAIL.COM",
      "address": "CALLE HICELE EDIF LAGUNA CARIBE PISO 1 APT PH4 URB SAN PABLO",
      "client_identification": "V18475719",
      "nap_box_name": "26",
      "created_at": "2024-08-04T17:50:21.385108",
      "service_detail": {
        "id": 5493,
        "ip": "172.18.251.2",
        "mac": "TPLGF5CB02D0",
        "serial": "TPLGF5CB02D0",
        "queue": "Plan_92291_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-08-16T18:08:30.516191",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6236,
      "client_name": "VICENTE CARBALLO PEREIRA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "San Pablo",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04144922281",
      "client_email": "REFRIMAVI@GMAIL.COM",
      "address": "AV 4TA MANZANA 9 CASA NRO 6 URB SAN PABLO TURMERO ARAGUA",
      "client_identification": "V6450059",
      "nap_box_name": "CTO-0637",
      "created_at": "2024-08-04T18:10:49.424414",
      "service_detail": {
        "id": 9840,
        "ip": "172.18.231.2",
        "mac": "TPLGB954F023",
        "serial": "TPLGB954F023",
        "queue": null,
        "interface": "VLAN200_OLTs",
        "created_at": "2025-11-10T17:44:53.485894",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6237,
      "client_name": "YULY LISERTH ACIEGO TORREALBA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "San Pablo",
      "plan": {
        "id": 16,
        "name": "RECURRENTE RESIDENCIAL PLAN 800M",
        "cost": "55.00",
        "code": "FOR800",
        "profile": "800M/800M"
      },
      "client_mobile": "04144865930",
      "client_email": "YULYACIEGO79@HOTMAIL.COM",
      "address": "CALLE 3 CASA NRO F-11 URB LA FLORESTA TURMERO",
      "client_identification": "V15123703",
      "nap_box_name": "CTO-00107 ",
      "created_at": "2024-08-04T18:17:35.947709",
      "service_detail": {
        "id": 5441,
        "ip": "172.18.230.2",
        "mac": "TPLGB955008B",
        "serial": "TPLGB955008B",
        "queue": "Plan_89283_15811_WispHub",
        "interface": "VLAN212_FLORESTA_OLT1",
        "created_at": "2024-08-16T16:21:53.499995",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6238,
      "client_name": "ARLES ROSALEN DE RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "La Floresta",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04144902855",
      "client_email": "ARLES138@HOTMAIL.COM",
      "address": "CALLE 3 CASA H NRO 5 URB. PARQUE RESIDENCIAL LA FLORESTA DE TURMERO",
      "client_identification": "V9687118",
      "nap_box_name": "CTO-00107 ",
      "created_at": "2024-08-04T18:25:49.718090",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6239,
      "client_name": "WILLY VICENTE MARTINEZ LINARES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "San Sebastian",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04249743334",
      "client_email": "WILLYVICENTEMARTINEZ@GMAIL.COM",
      "address": "CALLE 5 NRO 9 BARRIO SAN SEBASTIAN TURMERO",
      "client_identification": "V10755250",
      "nap_box_name": "137",
      "created_at": "2024-08-04T18:31:33.140647",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6240,
      "client_name": "NATHALIA ALEXANDRA RAMIREZ SILVA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "La Floresta",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144920249",
      "client_email": "SILVABOLIVARMARIATERESA63@GMAIL.COM",
      "address": "CALLE 4 CASA NRO G-12 URB. LA FLORESTA TURMERO",
      "client_identification": "V26791330",
      "nap_box_name": "CTO-00107 ",
      "created_at": "2024-08-04T18:35:17.939353",
      "service_detail": {
        "id": 9821,
        "ip": "172.18.219.2",
        "mac": "TPLGB954F130",
        "serial": "TPLGB954F130",
        "queue": null,
        "interface": "VLAN212_FLORESTA_OLT1",
        "created_at": "2025-11-10T17:09:42.266531",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6241,
      "client_name": "ANTONIO LORENZO DI CESARE MOLINA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villa Caribe",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04141449053",
      "client_email": "DICESAREANTONIO@HOTMAIL.COM",
      "address": "URBANIZACION VILLA CARIBE, CASA L6. TURMERO EDO ARAGUA",
      "client_identification": "V11181242",
      "nap_box_name": "59",
      "created_at": "2024-08-04T18:41:01.377399",
      "service_detail": {
        "id": 6002,
        "ip": "172.18.216.2",
        "mac": "TPLGB954F00E",
        "serial": "TPLGB954F00E",
        "queue": "Plan_92194_15811_WispHub",
        "interface": "VLAN228_V_CARIBE_OLT1",
        "created_at": "2024-08-22T08:51:27.687605",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6242,
      "client_name": "ELSIS TERESA DE LA PAZ RIVERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Villa Caribe",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04168439856",
      "client_email": "ELSISDLP@GMAIL.COM",
      "address": "URB. VILLA CARIBE C/2 NRO 38",
      "client_identification": "V11994676",
      "nap_box_name": "57",
      "created_at": "2024-08-04T18:48:22.694037",
      "service_detail": {
        "id": 5510,
        "ip": "172.18.217.2",
        "mac": "TPLGB954F1DF",
        "serial": "TPLGB954F1DF",
        "queue": "Plan_114480_15811_WispHub",
        "interface": "VLAN228_V_CARIBE_OLT1",
        "created_at": "2024-08-16T20:26:10.176492",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6243,
      "client_name": "LAURA CONSTANZA VINCI DE PANTIN",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "San Pablo",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04140475365",
      "client_email": "LAURA_VINCI@HOTMAIL.COM",
      "address": "AV 2DA CASA NRO 21 SAN PABLO TURMERO EDO ARAGUA",
      "client_identification": "V8744795",
      "nap_box_name": "CTO-0637",
      "created_at": "2024-08-04T18:54:06.277439",
      "service_detail": {
        "id": 5511,
        "ip": "172.18.210.2",
        "mac": "TPLGB954E9A1",
        "serial": "TPLGB954E9A1",
        "queue": "Plan_112654_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-08-16T20:28:18.668698",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6244,
      "client_name": "JHOLBER ALEXANDER ROMERO CEGARRA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "San Sebastian",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144415296",
      "client_email": "JARC.JTH@GMAIL.COM",
      "address": "CALLE 4 CASA NRO 10 SECTOR SAN SEBASTIAN TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V22290996",
      "nap_box_name": "61",
      "created_at": "2024-08-04T19:06:22.878648",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6245,
      "client_name": "FERNANDO MANUEL DA SILVA VIERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Los Nisperos",
      "plan": {
        "id": 16,
        "name": "RECURRENTE RESIDENCIAL PLAN 800M",
        "cost": "55.00",
        "code": "FOR800",
        "profile": "800M/800M"
      },
      "client_mobile": "04144940221",
      "client_email": "FERNANDODSV27@GMAIL.COM",
      "address": "CALLE GIRARDOT CASA NRO 7 URB MARIÑO TURMERO ARAGUA",
      "client_identification": "V26535482",
      "nap_box_name": "53",
      "created_at": "2024-08-04T19:10:09.884622",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6246,
      "client_name": "JHONATHAN ENRIQUE LANDAETA MIRABAL",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Palmeras II",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04128863928",
      "client_email": "JHONATHAN.LANDAETAM@GMAIL.COM",
      "address": "AV INTERCOMUNAL LA JULIA MARACAY CASA CALLE 8 NRO 04 URB LAS PALMERAS II TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V12747629",
      "nap_box_name": "287",
      "created_at": "2024-08-04T19:13:40.310380",
      "service_detail": {
        "id": 4511,
        "ip": "172.18.182.2",
        "mac": "TPLG2ABDC67B",
        "serial": "TPLG2ABDC67B",
        "queue": "Plan_131341_24341_WispHub",
        "interface": "VLAN119_PALMERAS_2",
        "created_at": "2024-08-10T16:30:11.181183",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6247,
      "client_name": "MARIO ANGEL CARMONA MORALES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Laguna II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243475921",
      "client_email": "MARCAR2874@GMAIL.COM",
      "address": "AV. PRINCIPAL SAN PABLO EDIF N15 PISO PTA BAJA APTO 2-15 URB RESIDENCIAS LA LAGUNA II TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V12142484",
      "nap_box_name": "641",
      "created_at": "2024-08-04T19:18:14.449897",
      "service_detail": {
        "id": 4359,
        "ip": "172.18.180.2",
        "mac": "TPLGB954FAE9",
        "serial": "TPLGB954FAE9",
        "queue": "Plan_147201_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-08-09T15:11:51.740199",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6250,
      "client_name": "JORGE ALEXANDER GALVIS MAIZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "San Pablo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04145986454",
      "client_email": "JAGALVISM@GMAIL.COM",
      "address": "VDA MANZANA C CASA NRO 85 URB HARAS DE SAN PABLO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V14740884",
      "nap_box_name": "248",
      "created_at": "2024-08-04T21:15:06.625922",
      "service_detail": {
        "id": 9956,
        "ip": "172.20.65.2",
        "mac": "TPLG2ABDC656",
        "serial": "TPLG2ABDC656",
        "queue": null,
        "interface": "VLAN200_OLTs",
        "created_at": "2025-11-11T11:04:04.503198",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6251,
      "client_name": "DEIVIMAR ANAIS FUENTES SOTO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "La Casona I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124605524",
      "client_email": "DEIVIMARANAIS99@GMAIL.COM",
      "address": "CALLE 7 CASA NRO 94 URB LA CASONA 1 TURMERO ARAGUA",
      "client_identification": "V26570696",
      "nap_box_name": "CE - 401",
      "created_at": "2024-08-04T21:22:24.799066",
      "service_detail": {
        "id": 11897,
        "ip": "10.16.169.2",
        "mac": "TPLGB777B496",
        "serial": "TPLGB777B496",
        "queue": null,
        "interface": "VLAN109_CASONA_1",
        "created_at": "2026-03-02T10:27:48.679397",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6252,
      "client_name": "HECTOR RAFAEL GUZMAN MEDINA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Laguna Plaza",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04263495878",
      "client_email": "HECMAN1857@GMAIL.COM",
      "address": "CALLE NEGRO PRIMERO EDIF 18 PISO PB APT 2 CONJUNTO RESIDENCIAL LAGUNA PLAZA TURMERO ARAGUA",
      "client_identification": "V15487524",
      "nap_box_name": "0326",
      "created_at": "2024-08-04T21:33:23.677140",
      "service_detail": {
        "id": 4366,
        "ip": "172.20.57.2",
        "mac": "TPLG2ABDC652",
        "serial": "TPLG2ABDC652",
        "queue": "Plan_153953_15811_WispHub",
        "interface": "VLAN216_LAGUNA_PLAZA_OLT1",
        "created_at": "2024-08-09T15:41:30.507300",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6253,
      "client_name": "YULI YSABEL GOMES FERNANDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243328602",
      "client_email": "YULIG2@GMAIL.COM",
      "address": "CALLE GIRARDOT CASA NRO 11 URB MARIÑO TURMERO",
      "client_identification": "V15600835",
      "nap_box_name": "53",
      "created_at": "2024-08-04T21:37:19.811613",
      "service_detail": {
        "id": 4368,
        "ip": "172.20.58.2",
        "mac": "TPLGB76568F0",
        "serial": "TPLGB76568F0",
        "queue": "Plan_153953_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-08-09T15:48:53.261993",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6255,
      "client_name": "MIGUELE JOSE INCRISTI QUARTARARO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Valle Paraiso",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04145935162",
      "client_email": "ANGELOIN02@HOTMAIL.COM",
      "address": "CALLE MANZANA NRO 5 CASA NRO 11 URB VALLE PARAISO TURMERO ARAGUA",
      "client_identification": "V13271671",
      "nap_box_name": "143",
      "created_at": "2024-08-04T21:48:35.840447",
      "service_detail": {
        "id": 4373,
        "ip": "172.20.54.2",
        "mac": "TPLG2ABDC6A8",
        "serial": "TPLG2ABDC6A8",
        "queue": "Plan_89283_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-08-09T15:57:48.550506",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6256,
      "client_name": "RUBEN DARIO FUENTES VILLARROEL",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona I",
      "plan": {
        "id": 16,
        "name": "RECURRENTE RESIDENCIAL PLAN 800M",
        "cost": "55.00",
        "code": "FOR800",
        "profile": "800M/800M"
      },
      "client_mobile": "04126847301",
      "client_email": "RDFUENTES2502@GMAIL.COM",
      "address": "CTRA INTERCOMUNAL TURMERO MARACAY CASA NRO 22 URB LA CASONA I TURMERO EDO ARAGUA",
      "client_identification": "V7169016",
      "nap_box_name": "410",
      "created_at": "2024-08-04T21:54:27.963182",
      "service_detail": {
        "id": 4668,
        "ip": "172.17.196.2",
        "mac": "TPLG2ABDC7DA",
        "serial": "TPLG2ABDC7DA",
        "queue": "Plan_131648_24341_WispHub",
        "interface": "VLAN109_CASONA_1",
        "created_at": "2024-08-12T10:34:31.187397",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6257,
      "client_name": "JOSE MANUEL GONZALEZ CAMACHO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Terrazas de Juan Pablo",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243044335",
      "client_email": "JOSEMANU067@GMAIL.COM",
      "address": "CALLE LA LLANERA PARCELA 15 BARRIO SAMAN DE GUERE EDIF TERRAZAS DE JUAN PABLO PISO PLANTA B",
      "client_identification": "V15532334",
      "nap_box_name": "CTO-00087",
      "created_at": "2024-08-04T22:01:25.532046",
      "service_detail": {
        "id": 4558,
        "ip": "172.27.244.2",
        "mac": "TPLGB765690F",
        "serial": "TPLGB765690F",
        "queue": "Plan_131648_24341_WispHub",
        "interface": "VLAN130_TERRAZAS_JP",
        "created_at": "2024-08-11T15:14:13.044120",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6258,
      "client_name": "CARLOS EDUARDO APARICIO ROJAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "PAUSADO_RESIDENCIAL",
      "status_name": "Pausado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Salto Angel",
      "plan": {
        "id": 19,
        "name": "RECURRENTE RESIDENCIAL PLAN 1GB",
        "cost": "74.70",
        "code": "FOR1GB",
        "profile": "1000M/1000M"
      },
      "client_mobile": "04141208791",
      "client_email": "CAPARICIO1971@HOTMAIL.COM",
      "address": "CALLE LOS PINOS MANZANA 5 CASA NRO 24 URB SALTO ANGEL SECTOR LA JULIA TURMERO ARAGUA",
      "client_identification": "V10617635",
      "nap_box_name": "39",
      "created_at": "2024-08-04T22:05:47.740014",
      "service_detail": {
        "id": 12507,
        "ip": "172.27.100.2",
        "mac": "9c:a2:f4:0a:7a:5c",
        "serial": "TPLG2ABDC807",
        "queue": null,
        "interface": "VLAN121_S_ANGEL",
        "created_at": "2026-05-16T15:26:04.451383",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6259,
      "client_name": "ARTURO DAVID SAEZ TORRELAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Palmeras I",
      "plan": {
        "id": 101,
        "name": "RECURRENTE RESIDENCIAL PLAN 200M",
        "cost": "19.00",
        "code": "FOR200MB",
        "profile": "200Mbps/200Mbps"
      },
      "client_mobile": "04126462692",
      "client_email": "ARTUROSAEZ2@GMAIL.COM",
      "address": "CALLE 01 CASA NRO 29 URB LAS PALMERAS 1 TURMERO ARAGUA",
      "client_identification": "V26192277",
      "nap_box_name": "CTO-00053",
      "created_at": "2024-08-04T22:08:34.613429",
      "service_detail": {
        "id": 4559,
        "ip": "172.25.74.2",
        "mac": "TPLGB76562EC",
        "serial": "TPLGB76562EC",
        "queue": "queue1",
        "interface": "VLAN118_PALMERAS_1",
        "created_at": "2024-08-11T15:20:12.282901",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6260,
      "client_name": "LORENIS VANESSA GIL DEL ROSARIO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Guanarito",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124658697",
      "client_email": "LORENISVGIL91@GMAIL.COM",
      "address": "CALLE JOSE CARUSO CASA NRO 1 SECTOR GUANARITO TURMERO ARAGUA",
      "client_identification": "V21443628",
      "nap_box_name": "CTO-00214",
      "created_at": "2024-08-05T08:11:04.600067",
      "service_detail": {
        "id": 4267,
        "ip": "172.19.93.2",
        "mac": "TPLGF4B1D4F4",
        "serial": "TPLGF4B1D4F4",
        "queue": "Plan_153953_15811_WispHub",
        "interface": "VLAN232_GUANARITO_OLT2",
        "created_at": "2024-08-08T10:14:15.949431",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6261,
      "client_name": "LUIS JOSE ROJAS AGUIRRE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "San Pablo",
      "plan": {
        "id": 16,
        "name": "RECURRENTE RESIDENCIAL PLAN 800M",
        "cost": "55.00",
        "code": "FOR800",
        "profile": "800M/800M"
      },
      "client_mobile": "04144491155",
      "client_email": "LUISROJAS3090@GMAIL.COM",
      "address": "CALLE FERGUS EDIF CONJUNTO RESIDENCIAL CAMELOT SUITE MODULO A PISO 1 APTO 4 URB SAN PABLO",
      "client_identification": "V20335429",
      "nap_box_name": "CTO-00413",
      "created_at": "2024-08-05T08:13:38.783108",
      "service_detail": {
        "id": 4585,
        "ip": "172.21.120.2",
        "mac": "TPLGB68B59CB",
        "serial": "TPLGB68B59CB",
        "queue": "Plan_89283_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-08-11T17:35:36.684583",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6262,
      "client_name": "WISTON ISRAEL GARCIA BRICEÑO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243578850",
      "client_email": "ISRAEL24669992@HOTMAIL.COM",
      "address": "CALLE 2 CASA NRO 36 URB MATA CABALLO ROSARIO DE PAYA TURMERO",
      "client_identification": "V24669992",
      "nap_box_name": "455",
      "created_at": "2024-08-05T08:16:00.786335",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6263,
      "client_name": "MARIA YSAURA TAPIAS MEZA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243356762",
      "client_email": "MARIA.YSAURA25@GMAIL.COM",
      "address": "CALLE 1 VIA PAYA CASA NRO 3 URB MATA CABALLO TURMERO",
      "client_identification": "V19516871",
      "nap_box_name": "CTO-00131",
      "created_at": "2024-08-05T08:21:25.392719",
      "service_detail": {
        "id": 4579,
        "ip": "172.21.173.2",
        "mac": "TPLGB68B5A98",
        "serial": "TPLGB68B5A98",
        "queue": "Plan_161887_30183_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-08-11T17:13:57.775858",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6264,
      "client_name": "LEIDY FELICIA MALUENGA PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243373707",
      "client_email": "MALUENGALEIDY@GMAIL.COM",
      "address": "CALLE 03 CASA NRO 142 MATA  CABALLO ROSARIO  DE PAYA",
      "client_identification": "V10758541",
      "nap_box_name": "CTO-00094",
      "created_at": "2024-08-05T08:24:07.985433",
      "service_detail": {
        "id": 4920,
        "ip": "172.21.175.2",
        "mac": "TPLGB68B574F",
        "serial": "TPLGB68B574F",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2024-08-13T11:27:09.767096",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6265,
      "client_name": "JHONNY JAVIER ALVAREZ ROSALES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04122994524",
      "client_email": "JJHONNYY1705@GMAIL.COM",
      "address": "CALLE 3 CASA NRO 5155 SECTOR MATA CABALLO ROSARIO DE PAYA",
      "client_identification": "V17057768",
      "nap_box_name": "CTO-00094",
      "created_at": "2024-08-05T08:28:11.736427",
      "service_detail": {
        "id": 4578,
        "ip": "172.21.177.2",
        "mac": "TPLGB68B56E7",
        "serial": "TPLGB68B56E7",
        "queue": "Plan_161887_30183_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-08-11T17:10:26.795916",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6266,
      "client_name": "MARYURI ISABEL FARIAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04120373763",
      "client_email": "FARIASMARYURI86@GMAIL.COM",
      "address": "CALLE 5B, CASA NRO. 36 SECTOR PANTIN, ROSARIO DE PAYA, ARAGUA",
      "client_identification": "V18407452",
      "nap_box_name": "CTO-00136",
      "created_at": "2024-08-05T09:56:35.329935",
      "service_detail": {
        "id": 4215,
        "ip": "172.31.48.2",
        "mac": "OEMT3C622FAA",
        "serial": "OEMT3C622FAA",
        "queue": "Plan_161895_30183_WispHub",
        "interface": "VLAN229_PANTIN",
        "created_at": "2024-08-06T16:26:06.268427",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6267,
      "client_name": "ANA MIREYA LANDAETA FLORES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Macaro",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04123210291",
      "client_email": "ANITABRIT834@GMAIL.COM",
      "address": "URB. ARTURO LUIS BERTI, CALLE 20 CASA NRO. 426, EL MACARO, ARAGUA",
      "client_identification": "V16763844",
      "nap_box_name": "543",
      "created_at": "2024-08-05T10:05:16.555158",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6268,
      "client_name": "YAMILE JOSEFINA FOOZ TORRES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Paya Abajo",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04120411970",
      "client_email": "YAMILETHFOOZ23@GMAIL.COM",
      "address": "CALLE SAN ANTONIO CASA NRO. 29, SECTOR PAYA ABAJO ROSARIO DE PAYA, ARAGUA",
      "client_identification": "V18702545",
      "nap_box_name": "CTO-0252",
      "created_at": "2024-08-05T10:21:55.325976",
      "service_detail": {
        "id": 7487,
        "ip": "172.31.41.2",
        "mac": "OEMT3C62302A",
        "serial": "OEMT3C62302A",
        "queue": "Plan_161900_30183_WispHub",
        "interface": "VLAN231_PAYABAJO",
        "created_at": "2024-12-17T11:05:45.765188",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6269,
      "client_name": "MARIELVIS ESMERALDA MEJIAS BARRIOS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Palma Real",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04127068027",
      "client_email": "MARIELVISMEJIAS26@GMAIL.COM",
      "address": "AV. PRINCIPAL CASA NRO. 54 URB. PALMA REAL ROSARIO DE PAYA, ARAGUA",
      "client_identification": "V31127965",
      "nap_box_name": "CTO-00208",
      "created_at": "2024-08-05T10:43:08.760719",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6270,
      "client_name": "FRANCIS ALEJANDRA ACACIO SARRAMERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "1ro de Mayo Sur",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243462796",
      "client_email": "FRANCISACACIO503@GMAIL.COM",
      "address": "AV. PRINCIPAL CALLE 4 CASA NRO. 8 SECTOR PRIMERO DE MAYO SUR, ROSARIO DE PAYA",
      "client_identification": "V25102500",
      "nap_box_name": "CTO-00157",
      "created_at": "2024-08-05T10:57:31.012827",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6271,
      "client_name": "YULEINIS BRIMER LEON LUNA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Palma Real",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124870624",
      "client_email": "DOCTORALUNNA@GMAIL.COM",
      "address": "CALLE BOLIVAR CASA NRO. 40 SECTOR LAS RURALES ROSARIO DE PAYA, ARAGUA",
      "client_identification": "V18975194",
      "nap_box_name": "CTO-00209",
      "created_at": "2024-08-05T11:07:01.431110",
      "service_detail": {
        "id": 4227,
        "ip": "172.31.44.2",
        "mac": "OEMT3C6230A6",
        "serial": "OEMT3C6230A6",
        "queue": "Plan_161905_30183_WispHub",
        "interface": "VLAN244_PALMAREAL",
        "created_at": "2024-08-07T11:58:36.752010",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6272,
      "client_name": "JOEL ANTONIO TOVAR HERNANDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04128933284",
      "client_email": "JOELANTONIOTOVAR1@GMAIL.COM",
      "address": "CLLE NRO. 17 CASA NRO. 04 SECTOR RIO SECO ROSARIO DE PAYA, ARAGUA",
      "client_identification": "V11985170",
      "nap_box_name": "CTO-0606",
      "created_at": "2024-08-05T14:25:38.440021",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6273,
      "client_name": "LEANDRO JESUS IZARRA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Valle del Rosario",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04263323705",
      "client_email": "LEANDROIZARRA40@GMAIL.COM",
      "address": "CALLE ARAGUA CASA NRO 10 IRB VALLE DEL ROSARIO TURMERO",
      "client_identification": "V14469635",
      "nap_box_name": "31",
      "created_at": "2024-08-05T14:48:59.019154",
      "service_detail": {
        "id": 4196,
        "ip": "172.22.45.2",
        "mac": "TPLGBA688271",
        "serial": "TPLGBA688271",
        "queue": "Plan_157310_1574_WispHub",
        "interface": "VLAN100_OLTs",
        "created_at": "2024-08-05T14:51:04.729612",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6274,
      "client_name": "MAYRA DE JESUS ARAGORT RON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Canaima",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243003080",
      "client_email": "ENSINTONIACONLAOSA@GMAIL.COM",
      "address": "CALLE 5 CASA NRO 23 URB CANAIMA",
      "client_identification": "V15489277",
      "nap_box_name": "359",
      "created_at": "2024-08-05T16:35:11.855187",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6275,
      "client_name": "YULIANYELI ALEJANDRA SALCEDO REIMIS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados I",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243603074",
      "client_email": "YULIREIMIS@GMAIL.COM",
      "address": "CALLE 1 CASA NRO 19 SECTOR PRADO 1 TURMERO",
      "client_identification": "V19530793",
      "nap_box_name": "585 DOS",
      "created_at": "2024-08-06T09:51:51.389555",
      "service_detail": {
        "id": 4205,
        "ip": "172.23.61.2",
        "mac": "TPLGF4EFC0EB",
        "serial": "TPLGF4EFC0EB",
        "queue": "Plan_161905_30183_WispHub",
        "interface": "VLAN239_PRADOS1",
        "created_at": "2024-08-06T11:15:42.263515",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6276,
      "client_name": "ROSANGEL XIMENA GARCIA VELASQUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Jabillar",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124790472",
      "client_email": "WENDYMVB@HOTMAIL.COM",
      "address": "AV. AEROPÙERTO CASA NRO S/N SECTOR GONZALEZ HERRERA PUERTO AYACUCHO AMAZONA ZONA POSTAL 7101",
      "client_identification": "V24678786",
      "nap_box_name": "CTO-0553",
      "created_at": "2024-08-06T10:17:24.441025",
      "service_detail": {
        "id": 12671,
        "ip": "172.29.183.2",
        "mac": "TP:LG:2A:BD:C7:59",
        "serial": "TPLG2ABDC759",
        "queue": null,
        "interface": "VLAN108_JABILLAR_OLT_ZTE",
        "created_at": "2026-07-04T11:34:18.929709",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6277,
      "client_name": "EDGAR SILVESTRE ZAMBRANO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Leocolbo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04268321604",
      "client_email": "EDGARZAMBRANO663@GMAIL.COM",
      "address": "CALLE B NRO 50 BARRIO VALLES DE LEO COLVO TURMERO",
      "client_identification": "V12170772",
      "nap_box_name": "CE - 623",
      "created_at": "2024-08-06T12:25:56.350501",
      "service_detail": {
        "id": 11796,
        "ip": "172.31.46.2",
        "mac": "OEMT3C6232A2",
        "serial": "OEMT3C6232A2",
        "queue": null,
        "interface": "VLAN144_LEOCOLBO",
        "created_at": "2026-02-27T11:29:15.447599",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6278,
      "client_name": "JONAS CARACIOLO LOPEZ HERNANDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128822171",
      "client_email": "CARACIOLOLOPEZ112@GMAIL.COM",
      "address": "CALLE PRINCIPAL CASA NRO 41 URB ANTONIO JOSE DE SUCRE TURMERO",
      "client_identification": "V13201371",
      "nap_box_name": "511",
      "created_at": "2024-08-06T12:54:35.203914",
      "service_detail": {
        "id": 4222,
        "ip": "172.31.47.2",
        "mac": "OEMT3C622906",
        "serial": "OEMT3C622906",
        "queue": "Plan_129887_1574_WispHub",
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2024-08-07T10:38:08.099075",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6279,
      "client_name": "XIOMARA JOSEFINA MORILLO PAREDES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04127821641",
      "client_email": "MORILLOXIOMI61@GMAIL.COM",
      "address": "CALLE 3 CASA NRO 30 SECTOR PRADOS DE PAYA I TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V9163599",
      "nap_box_name": "CTO-00061",
      "created_at": "2024-08-06T15:09:54.903946",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6280,
      "client_name": "CAROLINA MERCEDES PEREZ LOPEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243017187",
      "client_email": "NENECARCAROLINA@HOTMAIL.COM",
      "address": "CALLE 12 CASA TETRA NRO 690B CONJUNTO RESIDENCIAL MATA CABALLO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V6293459",
      "nap_box_name": "CTO-00020",
      "created_at": "2024-08-06T16:14:03.039952",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6281,
      "client_name": "FRANCIS YOLOFI LOPEZ PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "SUSPENDIDO_RESIDENCIAL",
      "status_name": "Suspendido",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Arturo Luis Berti",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04122624337",
      "client_email": "Francisyolofilopezp@gmail.com",
      "address": "CRTA VIA TURMERO EL MACARO CASA NRO 391 URB ARTURO LUIS BERTI TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V17513588",
      "nap_box_name": "543",
      "created_at": "2024-08-06T16:26:29.427859",
      "service_detail": {
        "id": 9645,
        "ip": "172.31.49.2",
        "mac": "OEMT3C622FAE",
        "serial": "OEMT3C622FAE",
        "queue": null,
        "interface": "VLAN102_ARTURO_BERTI",
        "created_at": "2025-10-22T18:16:27.968761",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6283,
      "client_name": "COMERCIALIZADORA ROMAN 2024 CA",
      "client_type_name": "PYME",
      "client_subdivision": "CANCELADO_PYME",
      "status_name": "Cancelado",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 102,
        "name": "RECURRENTE PYME PLAN 150M",
        "cost": "27.60",
        "code": "FOP150M",
        "profile": "150Mbps/150Mbps"
      },
      "client_mobile": "04127569043",
      "client_email": "RBARRIOS7180@GMAIL.COM",
      "address": "CALLE BOLIVAR AMBULATORIO DE TURMERO KISOCO AZUL",
      "client_identification": "J505464639",
      "nap_box_name": "88",
      "created_at": "2024-08-07T09:37:46.117157",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6284,
      "client_name": "GABRIEL JOSE MENDEZ FLOREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Macaro",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128676919",
      "client_email": "ELGABYMENDEZ1981@GMAIL.COM",
      "address": "URB VILLAS SAN JOSE SECTOR EL MACARO CASA Nº 0416 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V15601228",
      "nap_box_name": "CTO-00147",
      "created_at": "2024-08-07T11:26:03.636457",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6285,
      "client_name": "NELLYS YANNETTE PEDRA ESCOBAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243333471",
      "client_email": "ESCOBARY612@GMAIL.COM",
      "address": "CALLE 2 CASA NRO 98 SECTOR MATACABALLO",
      "client_identification": "V12608135",
      "nap_box_name": "CTO-00102",
      "created_at": "2024-08-07T13:52:08.671794",
      "service_detail": {
        "id": 11439,
        "ip": "172.17.221.2",
        "mac": "VSOL005207E1",
        "serial": "VSOL005207E1",
        "queue": null,
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2026-02-02T09:34:17.389049",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6286,
      "client_name": "DENIS JHAN CARLOS QUINTERO LOVERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124471059",
      "client_email": "GILTAHYNNA@GMAIL.COM",
      "address": "CALLE RIVAS EDIFICIO MARIÑO P-2 APART. 16",
      "client_identification": "V13646002",
      "nap_box_name": "CTO-00502",
      "created_at": "2024-08-07T14:34:03.938562",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6287,
      "client_name": "GEOIN CA",
      "client_type_name": "PYME",
      "client_subdivision": "CANCELADO_PYME",
      "status_name": "Cancelado",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04144940683",
      "client_email": "SERVICIOS.GEOIN@GMAIL.COM",
      "address": "C.C VALLE LINDO NIVEL PB. LOCAL 9 URB VALLE LINDO",
      "client_identification": "J312678968",
      "nap_box_name": "CC VALLE LINDO",
      "created_at": "2024-08-07T14:43:31.366799",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6288,
      "client_name": "FRANCY DEL CARMEN TAGLIAFICO OROPEZA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Narayola II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04143444329",
      "client_email": "FRANCYTAGLIAFICO@GMAIL.COM",
      "address": "AV VIA INTERCOMUNAL EDIF 6 PISO PLANTA BAJA APT 3 CONJUNTO RESIDENCIAL NARAYOLA II",
      "client_identification": "V8683136",
      "nap_box_name": "CTO-0526",
      "created_at": "2024-08-07T14:51:56.876624",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6290,
      "client_name": "ALFREDO VINCENZO SQUILLARO TOCUYO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Valle Paraiso",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144542386",
      "client_email": "SQUILLAROALFREDO@HOTMAIL.COM",
      "address": "CALLE MANZANA 5 CASA NRO 10 URB VALLE PARAISO TURMERO ARAGUA",
      "client_identification": "V9816443",
      "nap_box_name": "644",
      "created_at": "2024-08-07T15:09:35.697910",
      "service_detail": {
        "id": 10638,
        "ip": "172.20.32.2",
        "mac": "TPLGB7656305",
        "serial": "TPLGB7656305",
        "queue": null,
        "interface": "VLAN227_V_PARAISO_OLT1",
        "created_at": "2025-12-08T18:36:42.553688",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6291,
      "client_name": "ALVARO JOSE CARABALLO ORTEGA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Palmeras I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04143119573",
      "client_email": "ALVAROCARABALLO73@GMAIL.COM",
      "address": "CALLE PROLONGACIÓN PEÑALVER CASA NRO 132 URB LAS PALMERAS 2 MANZANA G TURMERO ESTADO ARAGUA",
      "client_identification": "V11969193",
      "nap_box_name": "287",
      "created_at": "2024-08-07T15:19:30.485970",
      "service_detail": {
        "id": 10572,
        "ip": "172.25.42.2",
        "mac": "TPLGB7656383",
        "serial": "TPLGB7656383",
        "queue": null,
        "interface": "VLAN119_PALMERAS_2",
        "created_at": "2025-12-03T18:24:59.014436",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6292,
      "client_name": "TIBISAY YAJAIRA PEREZ RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Palmeras II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128873267",
      "client_email": "GARCIAHERSAY@GMAIL.COM",
      "address": "CALLE 25 DE AGOSTO CASA HERSAY NRO 47 BARRIO ANTONIO JOSE DE SUCRE TURMERO ARAGUA",
      "client_identification": "V8199827",
      "nap_box_name": "122",
      "created_at": "2024-08-07T15:40:20.648214",
      "service_detail": {
        "id": 4626,
        "ip": "172.25.39.2",
        "mac": "TPLGB7656406",
        "serial": "TPLGB7656406",
        "queue": "Plan_137413_1574_WispHub",
        "interface": "VLAN101_AJS",
        "created_at": "2024-08-12T08:05:48.885887",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6294,
      "client_name": "JONAY JOSUE MEDINA SOLER",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Salto Angel",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04127762489",
      "client_email": "JONAYJOSUE@GMAIL.COM",
      "address": "CALLE EL SAMAN CASA MANZANA #8 NRO 15 URB VILLEGUITA SALTO ANGEL TURMERO",
      "client_identification": "V18202805",
      "nap_box_name": "72",
      "created_at": "2024-08-07T15:57:29.654703",
      "service_detail": {
        "id": 4628,
        "ip": "172.18.57.2",
        "mac": "TPLGB7656330",
        "serial": "TPLGB7656330",
        "queue": "Plan_131338_24341_WispHub",
        "interface": "VLAN121_S_ANGEL",
        "created_at": "2024-08-12T08:13:10.057018",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6295,
      "client_name": "MAURA MARIA PADILLA MORENO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "SUSPENDIDO_RESIDENCIAL",
      "status_name": "Suspendido",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Palmeras I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04161068286",
      "client_email": "CVGP2006@GMAIL.COM",
      "address": "CALLE PRINCIPAL CASA NRO 46 URB LAS PALMERAS I TURMERO ARAGUA",
      "client_identification": "V9439635",
      "nap_box_name": "CTO-00071",
      "created_at": "2024-08-07T16:00:22.904171",
      "service_detail": {
        "id": 4629,
        "ip": "172.18.18.2",
        "mac": "TPLGB7656355",
        "serial": "TPLGB7656355",
        "queue": "Plan_131647_24341_WispHub",
        "interface": "VLAN118_PALMERAS_1",
        "created_at": "2024-08-12T08:31:06.923816",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6296,
      "client_name": "ANA GABRIELA SANTIAGO ALARCON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Valle Paraiso",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04147411862",
      "client_email": "SANTIAGOALARCONANAGABRIELA@GMAIL.COM",
      "address": "APARTAMENTO NRO 4 CENTRO COMERCIAL Y RESIDENCIAL MILAN PLAZA AV SAN PABLO URB VALLE PARAISO",
      "client_identification": "V25066567",
      "nap_box_name": "144",
      "created_at": "2024-08-07T16:05:54.299268",
      "service_detail": {
        "id": 4630,
        "ip": "172.20.24.2",
        "mac": "TPLGB7656318",
        "serial": "TPLGB7656318",
        "queue": "Plan_153953_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-08-12T08:35:09.166167",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6297,
      "client_name": "ALEXANDER ANTONIO MARTIN GIRON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04125030195",
      "client_email": "ALEX17647@HOTMAIL.COM",
      "address": "CALLE EL CENTRO CASA 07 SECTOR TURMERO ARAGUA",
      "client_identification": "V19277193",
      "nap_box_name": "211",
      "created_at": "2024-08-07T16:09:21.194309",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6298,
      "client_name": "AURISTELA DE LOURDES CARRENO DE SILVA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "San Pablo",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04144943800",
      "client_email": "LAURAMSICA93@GMAIL.COM",
      "address": "CALLE HICELES CASA NRO 9 URB SAN PABLO TURMERO ESTADO ARAGUA",
      "client_identification": "V7178042",
      "nap_box_name": "26",
      "created_at": "2024-08-07T16:16:22.533053",
      "service_detail": {
        "id": 4632,
        "ip": "172.20.39.2",
        "mac": "TPLGB7656440",
        "serial": "TPLGB7656440",
        "queue": "Plan_140304_15811_WispHub",
        "interface": "VLAN224_SAN_PABLO_OLT1",
        "created_at": "2024-08-12T08:41:32.981818",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6299,
      "client_name": "MARIA JOSE FERNANDEZ FRAIZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "San Pablo",
      "plan": {
        "id": 16,
        "name": "RECURRENTE RESIDENCIAL PLAN 800M",
        "cost": "55.00",
        "code": "FOR800",
        "profile": "800M/800M"
      },
      "client_mobile": "04243414392",
      "client_email": "MARIA_JOSE108@HOTMAIL.COM",
      "address": "AV PRINCIPAL CASA NRO 5 URB SAN PABLO TURMERO ARAGUA",
      "client_identification": "V14318633",
      "nap_box_name": "CTO-0637",
      "created_at": "2024-08-07T16:22:54.930274",
      "service_detail": {
        "id": 4633,
        "ip": "172.20.22.2",
        "mac": "TPLG2ABDC7E1",
        "serial": "TPLG2ABDC7E1",
        "queue": "Plan_89283_15811_WispHub",
        "interface": "VLAN224_SAN_PABLO_OLT1",
        "created_at": "2024-08-12T08:56:27.710500",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6300,
      "client_name": "ALEXANDER VLADIMIR BARRIENTOS CASTRO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124449038",
      "client_email": "SUSEJAVRIL@GMAIL.COM",
      "address": "CALLE CEDEÑO CASA NRO 40-1 SECTOR PUEBLO NUEVO, TURMERO EDO ARAGUA",
      "client_identification": "V14991896",
      "nap_box_name": "CTO-00590",
      "created_at": "2024-08-07T16:27:07.206395",
      "service_detail": {
        "id": 4634,
        "ip": "172.20.19.2",
        "mac": "TPLGB7656287",
        "serial": "TPLGB7656287",
        "queue": "Plan_153953_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-08-12T08:59:13.291300",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6301,
      "client_name": "GLAMARLYS MARIA PERNALETE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Los Mangos",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04245803638",
      "client_email": "MARIAPERP@GMAIL.COM",
      "address": "CALLE NEGRO PRIMERO EDIF LOS MANGOS PISO 3 APT TORRE B URB LOS MANGOS TURMERO ARAGUA",
      "client_identification": "V16732089",
      "nap_box_name": "18",
      "created_at": "2024-08-07T16:30:16.419127",
      "service_detail": {
        "id": 4635,
        "ip": "172.20.18.2",
        "mac": "TPLGB765631B",
        "serial": "TPLGB765631B",
        "queue": "Plan_153953_15811_WispHub",
        "interface": "VLAN217_MANGOS_OLT1",
        "created_at": "2024-08-12T09:02:00.806497",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6302,
      "client_name": "NADESCA YASBILEX BENAVIDES TORRES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Taguapire",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144509484",
      "client_email": "YASNABET11@GMAIL.COM",
      "address": "CALLE 1 APARTAMENTO 12 TAGUAPIRE EL MACARO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V16528406",
      "nap_box_name": "548",
      "created_at": "2024-08-07T16:38:41.612124",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6303,
      "client_name": "OSMARLING TERESA SECO RAMOS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04127769135",
      "client_email": "OSMARLINGSECO@GMAIL.COM",
      "address": "CALLE 6 CASA NRO 382 URB MATA CABALLO ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V13199902",
      "nap_box_name": "CTO-00178",
      "created_at": "2024-08-07T16:45:50.918697",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6304,
      "client_name": "ANDREA DENYMAR RUIZ HERRERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243017366",
      "client_email": "ANDREADENYMAR89@GMAIL.COM",
      "address": "CALLE 06 MATA CABALLO CASA 459 ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V19375226",
      "nap_box_name": "CTO-00178",
      "created_at": "2024-08-07T16:50:47.699502",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6305,
      "client_name": "ZAIDA LORENA SANCHEZ SIERRA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Terrazas de Juan Pablo",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04145900394",
      "client_email": "LORENZSTUDIO2022@GMAIL.COM",
      "address": "TERRAZAS DE JUAN PABLO APARTOSUITES UBICADO CALLE LLANERA PARCELA NRO 15 SAMAN DE GUERE ESTADO ARAGUA",
      "client_identification": "V14389078",
      "nap_box_name": "12",
      "created_at": "2024-08-07T16:54:46.019947",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6306,
      "client_name": "MARIELA DEL VALLE PADRON CASTILLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Narayola II",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243055723",
      "client_email": "MARIPADDELVALLE16@GMAIL.COM",
      "address": "AV INTERCOMUNAL TURMERO EDIF 1 PISO PB-1 CONJUNTO RESIDENCIAL NARAYOLA II TURMERO ARAGUA 2115",
      "client_identification": "V11054133",
      "nap_box_name": "CTO-0521",
      "created_at": "2024-08-07T17:08:43.534552",
      "service_detail": {
        "id": 4363,
        "ip": "172.18.172.2",
        "mac": "TPLGB777B91C",
        "serial": "TPLGB777B91C",
        "queue": "Plan_132787_24341_WispHub",
        "interface": "VLAN100_OLTs",
        "created_at": "2024-08-09T15:29:10.560345",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6307,
      "client_name": "DANIELSY ZULEIKA NAVAS VIEIRA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Paya Abajo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124614643",
      "client_email": "NAVASDANIELSY@GMAIL.COM",
      "address": "CALLE CALLEJON SAN MIGUEL CASA NRO 27 SECTOR PAYA ABAJO ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V20990379",
      "nap_box_name": "CTO-00178",
      "created_at": "2024-08-07T17:12:03.466847",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6308,
      "client_name": "HILDA ESPERANZA MEDINA CASTRO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Narayola II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04163430492",
      "client_email": "HILDAMEDINA266@GMAIL.COM",
      "address": "AV INTERCOMUNAL MARACAY TURMERO EDIF NRO 2 PISO PB  APT PB3 NARAYOLA II",
      "client_identification": "V3769905",
      "nap_box_name": "CTO-0522",
      "created_at": "2024-08-07T17:15:52.275319",
      "service_detail": {
        "id": 10026,
        "ip": "172.19.223.2",
        "mac": "TPLGB954F8C0",
        "serial": "TPLGB954F8C0",
        "queue": null,
        "interface": "VLAN117_NARAYOLA",
        "created_at": "2025-11-11T15:45:57.619015",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6309,
      "client_name": "MARIANA TORRENS ARAUJO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Narayola II",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04144449808",
      "client_email": "MARIANAT10@HOTMAIL.COM",
      "address": "AV PRINCIPAL INTERCOMUNAL TURMERO NARAYOLA II TORRE 4 PISO 1 APT 4",
      "client_identification": "V15609545",
      "nap_box_name": "CTO-0524",
      "created_at": "2024-08-07T17:17:14.604803",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6310,
      "client_name": "JESUS NICOLAS SUE RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Narayola II",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243371385",
      "client_email": "NICOLASSUE@YAHOO.COM",
      "address": "AV INTERCOMUNAL SANTIAGO MARIÑO EDIF 4 PISO 1APTO 2-4 NARAYOLA II",
      "client_identification": "V13189187",
      "nap_box_name": "CTO-0524",
      "created_at": "2024-08-07T17:18:38.677238",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6311,
      "client_name": "MARJORIE VANESSA GALAVIS TIBERIO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Narayola II",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04145888588",
      "client_email": "MAYU03@HOTMAIL.COM",
      "address": "CALLE INTERCOMUNAL TURMERO EDF 5 PISO 1 APTO 1-5 NARAYOLA II",
      "client_identification": "V18488705",
      "nap_box_name": "CTO-0525",
      "created_at": "2024-08-07T17:20:04.495448",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6312,
      "client_name": "CLARA MARIA VASQUEZ FRANCO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Laguna Plaza",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04243493727",
      "client_email": "CVASQUEZF.CMVF@GMAIL.COM",
      "address": "CR LAGUNA PLAZA SECTOR 2 EDIF 8 PH 1 TURMERO",
      "client_identification": "V10979517",
      "nap_box_name": "1",
      "created_at": "2024-08-07T17:24:18.395774",
      "service_detail": {
        "id": 5410,
        "ip": "172.19.202.2",
        "mac": "TPLGB954EAED",
        "serial": "TPLGB954EAED",
        "queue": "Plan_92312_15811_WispHub",
        "interface": "VLAN216_LAGUNA_PLAZA_OLT1",
        "created_at": "2024-08-16T15:30:41.084931",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6313,
      "client_name": "EUNICE LIDUBINA TEJERA LADERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "La Casona I Edificios",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04120451340",
      "client_email": "LIDUBINAEUNICE80@GMAIL.COM",
      "address": "AV INTERCOMUNAL TURMERO MARACAY EDIF 7-A PISO 2 APT 3 URB LA CASONA I TURMERO ARAGUA",
      "client_identification": "V15738931",
      "nap_box_name": "CTO-0528",
      "created_at": "2024-08-07T17:26:50.581200",
      "service_detail": {
        "id": 5455,
        "ip": "172.19.198.2",
        "mac": "TPLGB954EADB",
        "serial": "TPLGB954EADB",
        "queue": "Plan_132787_24341_WispHub",
        "interface": "VLAN109_CASONA_1",
        "created_at": "2024-08-16T16:43:39.451899",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6314,
      "client_name": "YONALD EDUARDO RAMIREZ CAMPOS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Narayola II",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04242769981",
      "client_email": "YONALD.RAMIREZ@GMAIL.COM",
      "address": "AV. INTERCOMUNAL EDIF. TORRE 1 PISO PB APTTO 5 URB NARAYOLA II  TURMERO",
      "client_identification": "V14574500",
      "nap_box_name": "CTO-0521",
      "created_at": "2024-08-07T17:28:10.823923",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6315,
      "client_name": "ADRIANA CAROLINA GARCIA DEL VALLE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Laguna Plaza",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243070245",
      "client_email": "ADRIANAG189@HOTMAIL.COM",
      "address": "LAGUNA PLAZA CALLE NEGRO PRIMERO CON CAMILO TORRES EDIF 17 PISO 1",
      "client_identification": "V18475877",
      "nap_box_name": "3",
      "created_at": "2024-08-07T17:29:51.346193",
      "service_detail": {
        "id": 5215,
        "ip": "172.19.50.2",
        "mac": "OEMT3C6227C6",
        "serial": "OEMT3C6227C6",
        "queue": "queue1",
        "interface": "VLAN216_LAGUNA_PLAZA_OLT1",
        "created_at": "2024-08-15T13:48:20.171721",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6316,
      "client_name": "SHIRLEY MONTES HERRERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Laguna Plaza",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04265332617",
      "client_email": "Samueldeaguiar1997@gmail.com",
      "address": "CALLE NEGRO PRIMERO EDIF 18 APTO 3 URB LAGUNA PLAZA TURMERO",
      "client_identification": "V12624672",
      "nap_box_name": "2",
      "created_at": "2024-08-07T17:31:49.966296",
      "service_detail": {
        "id": 5248,
        "ip": "172.19.48.2",
        "mac": "TPLGF5CB00C6",
        "serial": "TPLGF5CB00C6",
        "queue": "Plan_89283_15811_WispHub",
        "interface": "VLAN216_LAGUNA_PLAZA_OLT1",
        "created_at": "2024-08-15T15:41:51.642953",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6317,
      "client_name": "BLANCA COROMOTO GALEA MANZANARES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Narayola II",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04144576127",
      "client_email": "INVERSIONESASYBLACA@GMAIL.COM",
      "address": "RESIDENCIAS NARAYOLA II TORRE II PISO 3-3-5 TURMERO",
      "client_identification": "V10352012",
      "nap_box_name": "CTO-0522",
      "created_at": "2024-08-07T17:33:09.621327",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6318,
      "client_name": "SORANGEL JOSEFINA RODRIGUEZ ALAYON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Narayola II",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04123010586",
      "client_email": "SORANGELROD5@GMAIL.COM",
      "address": "NARAYOLA II TORRE 7  PISO APTTO 2-2 TURMERO",
      "client_identification": "V12853805",
      "nap_box_name": "CTO-0527",
      "created_at": "2024-08-07T17:34:42.743609",
      "service_detail": {
        "id": 5495,
        "ip": "172.18.236.2",
        "mac": "TPLGF5CB0379",
        "serial": "TPLGF5CB0379",
        "queue": "Plan_132787_24341_WispHub",
        "interface": "VLAN117_NARAYOLA",
        "created_at": "2024-08-16T18:12:44.494209",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6319,
      "client_name": "OMAYRA JOSEFINA ROJAS MUÑOZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Laguna Plaza",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124209925",
      "client_email": "ANIUSCELIS@GMAIL.COM",
      "address": "CALLE NEGRO PRIMERO CC CAMILO TORRES EDIF 1 PISO 1 APT PH-2-1 URB LAGUNA PLAZA",
      "client_identification": "V10459015",
      "nap_box_name": "4",
      "created_at": "2024-08-07T17:36:35.741962",
      "service_detail": {
        "id": 5449,
        "ip": "172.18.224.2",
        "mac": "TPLGB954F1A3",
        "serial": "TPLGB954F1A3",
        "queue": "queue1",
        "interface": "VLAN216_LAGUNA_PLAZA_OLT1",
        "created_at": "2024-08-16T16:33:58.993595",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6320,
      "client_name": "ADRIANA SOFIA MORENO SANCHEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona II Edificios",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121422868",
      "client_email": "SANCHEZADRIANA181996@GMAIL.COM",
      "address": "CALLE PRINCIPAL EDIF H-15 PISO PB APT 6 URB LA CASONA II",
      "client_identification": "V25813326",
      "nap_box_name": "CTO-0541",
      "created_at": "2024-08-07T17:37:35.802724",
      "service_detail": {
        "id": 11780,
        "ip": "172.18.212.2",
        "mac": "TPLGB954EB99",
        "serial": "TPLGB954EB99",
        "queue": null,
        "interface": "VLAN100_OLTs",
        "created_at": "2026-02-27T10:47:24.201751",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6321,
      "client_name": "MARIA DE LOS ANGELES BADRA D'AMORE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Narayola II",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243269947",
      "client_email": "ANGELES_BADRA@HOTMAIL.COM",
      "address": "AV INTERCOMUNAL TURMERO MARACAY EDIF 3 PISO PB APTO 6 URB NARAYOLA II",
      "client_identification": "V14318372",
      "nap_box_name": "CTO-0523",
      "created_at": "2024-08-07T17:38:57.243329",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6322,
      "client_name": "JUAN LUIS RUIZ MONCADA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Terrazas de Juan Pablo",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04144587068",
      "client_email": "corogonzalez2023@gmail.com",
      "address": "CALLE LA LLANERA CASA NRO PB D 1 URB TERRAZA DE JUAN PABLO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V14344185",
      "nap_box_name": "CTO-0531",
      "created_at": "2024-08-07T17:40:28.858293",
      "service_detail": {
        "id": 4354,
        "ip": "172.18.192.2",
        "mac": "TPLGB954EBA8",
        "serial": "TPLGB954EBA8",
        "queue": "Plan_132787_24341_WispHub",
        "interface": "VLAN130_TERRAZAS_JP",
        "created_at": "2024-08-09T14:33:08.733440",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6323,
      "client_name": "YESSICA ODALIS SILVA VIERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados III",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128978446",
      "client_email": "YESSICAODALISSILVAVIERA@GMAIL.COM",
      "address": "SECTOR PRADOS III CALLE 4 CASA N16 ROSARIO DE PAYA",
      "client_identification": "V22949018",
      "nap_box_name": "CTO-00299",
      "created_at": "2024-08-08T08:10:58.746365",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6324,
      "client_name": "REINA KAZNONI ALVAREZ ALFONZO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "La Casona II Edificios",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243188469",
      "client_email": "ROROCONO2021@GMAIL.COM",
      "address": "CALLE INTERCOMUNAL TURMERO MARACAY EDIF G-14 PISO 1 APT 1 URB LA CASONA II TURMERO ARAGUA",
      "client_identification": "V22287489",
      "nap_box_name": "CTO-0540",
      "created_at": "2024-08-08T10:09:05.969361",
      "service_detail": {
        "id": 11769,
        "ip": "172.25.78.2",
        "mac": "TPLGB76566D2",
        "serial": "TPLGB76566D2",
        "queue": null,
        "interface": "VLAN110_CASONA_2",
        "created_at": "2026-02-27T10:43:38.234160",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6325,
      "client_name": "EDGARDO JOSE BORGES DIAZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Narayola II",
      "plan": {
        "id": 16,
        "name": "RECURRENTE RESIDENCIAL PLAN 800M",
        "cost": "55.00",
        "code": "FOR800",
        "profile": "800M/800M"
      },
      "client_mobile": "04124411939",
      "client_email": "EDJOBODI@GMAIL.COM",
      "address": "AV INTERCOMUNAL TURMERO MARACAY EDIF 4 PISO 2 APTO 2-6 URB NARAYOLA II TURMERO ARAGUA",
      "client_identification": "V15733359",
      "nap_box_name": "CTO-0524",
      "created_at": "2024-08-08T10:11:42.007456",
      "service_detail": {
        "id": 11586,
        "ip": "172.17.234.2",
        "mac": "TPLGB765662A",
        "serial": "TPLGB765662A",
        "queue": null,
        "interface": "VLAN117_NARAYOLA",
        "created_at": "2026-02-10T18:48:10.069756",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6326,
      "client_name": "ANAMARIA DE LOS ANGELES GONZALEZ RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Narayola II",
      "plan": {
        "id": 16,
        "name": "RECURRENTE RESIDENCIAL PLAN 800M",
        "cost": "55.00",
        "code": "FOR800",
        "profile": "800M/800M"
      },
      "client_mobile": "04243409866",
      "client_email": "FCO-VASQUEZ@HOTMAIL.COM",
      "address": "AV INTERCOMUNAL URB NARAYOLA II TORRE 2 APT 1-2 TURMERO EDO ARAGUA",
      "client_identification": "V16344820",
      "nap_box_name": "CTO-0522",
      "created_at": "2024-08-08T10:19:35.831158",
      "service_detail": {
        "id": 4377,
        "ip": "172.28.116.2",
        "mac": "TPLGB7656937",
        "serial": "TPLGB7656937",
        "queue": "Plan_132968_24341_WispHub",
        "interface": "VLAN117_NARAYOLA",
        "created_at": "2024-08-09T16:16:43.494094",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6327,
      "client_name": "LEONARDO ALBERTO CARRENO HERNANDEZ",
      "client_type_name": "INTERCAMBIO",
      "client_subdivision": "ACTIVO_INTERCAMBIO",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Villas El Carmen",
      "plan": {
        "id": 83,
        "name": "RECURRENTE INSTITUCIONAL 80M",
        "cost": "0.00",
        "code": "FO-R80",
        "profile": "80M/80M"
      },
      "client_mobile": "04141336457",
      "client_email": "CARRESAIME2018@GMAIL.COM",
      "address": "CALLE 4 CASA 02 URB VILLAS EL CARMEN SECTOR EL MACARO TURMERO ARAGUA",
      "client_identification": "V7272623",
      "nap_box_name": "CTO VILLAS DEL CARMEN",
      "created_at": "2024-08-08T10:25:29.864925",
      "service_detail": {
        "id": 4280,
        "ip": "172.18.110.2",
        "mac": "TPLGB777B43C",
        "serial": "TPLGB777B43C",
        "queue": "Plan_14173_1574_WispHub",
        "interface": "VLAN135_VILLAS_CARMEN",
        "created_at": "2024-08-08T14:58:12.877609",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6329,
      "client_name": "GLADIS MARITZA MACHADO TABLERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "La Casona II Edificios",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243148748",
      "client_email": "GLADISMACHADO2509@GMAIL.COM",
      "address": "AV INTERCOMUNAL TURMERO MARACAY EDIF H PISO 3 APT 3-01 URB LA CASONA II TURMERO ARAGUA",
      "client_identification": "V9434950",
      "nap_box_name": "CTO-0541",
      "created_at": "2024-08-08T10:44:00.570917",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6330,
      "client_name": "TRINO RAFAEL GUERRA MANRIQUE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "La Casona I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128857156",
      "client_email": "TRINO_1967@HOTMAIL.COM",
      "address": "CALLE PRINCIPAL C/C SERVICIO CASA NRO 16 SECTOR LA CASONA TURMERO ARAGUA",
      "client_identification": "V7248792",
      "nap_box_name": "451",
      "created_at": "2024-08-08T10:48:52.751193",
      "service_detail": {
        "id": 11983,
        "ip": "172.30.45.2",
        "mac": "TPLGB765693F",
        "serial": "TPLGB765693F",
        "queue": null,
        "interface": "VLAN109_CASONA_1",
        "created_at": "2026-03-06T12:29:01.889904",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6331,
      "client_name": "NAIDELY COROMOTO MIJARES PÉREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Palmeras I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243397830",
      "client_email": "NAIDELYMIJARES74@GMAIL.COM",
      "address": "CALLE PROLONGACIÓN CASA NRO 16 SECTOR GUANARITO TURMERO ARAGUA",
      "client_identification": "V9661892",
      "nap_box_name": "CTO-00053",
      "created_at": "2024-08-08T10:52:37.020403",
      "service_detail": {
        "id": 4561,
        "ip": "172.25.72.2",
        "mac": "TPLGC3CCB7F0",
        "serial": "TPLGC3CCB7F0",
        "queue": "Plan_131647_24341_WispHub",
        "interface": "VLAN118_PALMERAS_1",
        "created_at": "2024-08-11T15:28:50.903473",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6332,
      "client_name": "CICPC TURMERO",
      "client_type_name": "INTERCAMBIO",
      "client_subdivision": "ACTIVO_INTERCAMBIO",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 83,
        "name": "RECURRENTE INSTITUCIONAL 80M",
        "cost": "0.00",
        "code": "FO-R80",
        "profile": "80M/80M"
      },
      "client_mobile": "04144903699",
      "client_email": "BLANCOGUZMANEDUINJOSE@GMAIL.COM",
      "address": "TURMERO, CALLE PETIÓN, EDIF CICPC TURMERO, FRENTE AL CONCEJO MUNICIPAL",
      "client_identification": "G200010320",
      "nap_box_name": "CAJA NAP BICENTENARIO",
      "created_at": "2024-08-08T10:56:47.943260",
      "service_detail": {
        "id": 4403,
        "ip": "172.20.56.2",
        "mac": "TPLGC3C6BBC4",
        "serial": "TPLGC3C6BBC4",
        "queue": "Plan_121695_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-08-09T20:21:23.300276",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6333,
      "client_name": "MARIA VERONICA SANCHEZ PALMA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04144489302",
      "client_email": "SUPERPLANTULAS1@GMAIL.COM",
      "address": "CALLE URDANETA CASA 72 SECTOR CENTRO DE TURMERO EDO ARAGUA",
      "client_identification": "V18473965",
      "nap_box_name": "25",
      "created_at": "2024-08-08T10:58:49.835276",
      "service_detail": {
        "id": 4562,
        "ip": "172.20.48.2",
        "mac": "TPLGB76564A6",
        "serial": "TPLGB76564A6",
        "queue": "Plan_139897_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-08-11T15:31:34.101241",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6334,
      "client_name": "DALLARKIS NORELIS ZAPATA PEDRA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Cambur",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04129170950",
      "client_email": "ZAPATADALLARKI@GMAIL.COM",
      "address": "PRINCIPAL EL CAMBUR, CASA 58-2, PAYA, ARAGUA",
      "client_identification": "V18473706",
      "nap_box_name": "CTO-00150",
      "created_at": "2024-08-08T11:05:01.869601",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6335,
      "client_name": "RUDDY MARIELA FERNANDEZ CIPRIANI",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "La Casona II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121774570",
      "client_email": "MARIELA.CIPRIANI@GMAIL.COM",
      "address": "CALLE 14 CASA NRO 44 URB LA CASONA II TURMERO ARAGUA",
      "client_identification": "V17044172",
      "nap_box_name": "CTO-00088",
      "created_at": "2024-08-08T11:18:51.011816",
      "service_detail": {
        "id": 4563,
        "ip": "172.30.70.2",
        "mac": "TPLG2ABDC78E",
        "serial": "TPLG2ABDC78E",
        "queue": "Plan_131647_24341_WispHub",
        "interface": "VLAN110_CASONA_2",
        "created_at": "2024-08-11T15:34:50.174662",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6336,
      "client_name": "YELITZA ALEJANDRA SIERRA HERNANDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "La Casona II",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04129762413",
      "client_email": "YASH13614196@GMAIL.COM",
      "address": "CALLE 14 CASA NRO 58 SECTOR LA CASONA II TURMERO ARAGUA",
      "client_identification": "V13614196",
      "nap_box_name": "CTO-00088",
      "created_at": "2024-08-08T11:41:16.126318",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6337,
      "client_name": "WILLIAMS JOSÉ RUMBO MARTINEZ",
      "client_type_name": "INTERCAMBIO",
      "client_subdivision": "ACTIVO_INTERCAMBIO",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "La Casona I",
      "plan": {
        "id": 83,
        "name": "RECURRENTE INSTITUCIONAL 80M",
        "cost": "0.00",
        "code": "FO-R80",
        "profile": "80M/80M"
      },
      "client_mobile": "04243485972",
      "client_email": "WILLIAMSRUMBO85@GMAIL.COM",
      "address": "AV INTERCOMUNAL MARACAY TURMERO CALLE 1 CASA NRO 73 SECTOR CASONA I TURMERO ARAGUA",
      "client_identification": "V11087410",
      "nap_box_name": "CTO CASONA",
      "created_at": "2024-08-08T11:41:59.483589",
      "service_detail": {
        "id": 4285,
        "ip": "172.19.110.2",
        "mac": "TPLGB7656362",
        "serial": "TPLGB7656362",
        "queue": "Plan_132970_24341_WispHub",
        "interface": "VLAN100_OLTs",
        "created_at": "2024-08-08T15:43:41.780245",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6338,
      "client_name": "CATTY JOSELIN BIGOTT BETANCOURT",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "La Casona II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144476632",
      "client_email": "CATBIGBET@GMAIL.COM",
      "address": "CALLE 14 CASA NRO 29 URB LA CASONA II TURMERO EDO ARAGUA",
      "client_identification": "V6453959",
      "nap_box_name": "CTO-00088",
      "created_at": "2024-08-08T11:45:37.009730",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6339,
      "client_name": "LEONARDO JESUS PEREZ RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Salto Angel",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144430773",
      "client_email": "LEONARDOJPR91@GMAIL.COM",
      "address": "CALLE LOS PINOS CASA MANZANA 1 NRO 1 URB SALTO ANGEL TURMERO ARAGUA",
      "client_identification": "V19949388",
      "nap_box_name": "39",
      "created_at": "2024-08-08T11:50:30.853761",
      "service_detail": {
        "id": 4566,
        "ip": "172.25.51.2",
        "mac": "TPLG2ABDC80C",
        "serial": "TPLG2ABDC80C",
        "queue": "Plan_131647_24341_WispHub",
        "interface": "VLAN121_S_ANGEL",
        "created_at": "2024-08-11T15:44:59.963875",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6340,
      "client_name": "YELITZA MARBERLLI PINEDA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Salto Angel",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243591143",
      "client_email": "MARBELLIPINEDA.1978@GMAIL.COM",
      "address": "CALLE LOS PINOS MANZANA 05 CASA NRO 22 URB SALTO ANGEL TURMERO ARAGUA",
      "client_identification": "V14368918",
      "nap_box_name": "39",
      "created_at": "2024-08-08T11:53:32.713492",
      "service_detail": {
        "id": 10606,
        "ip": "172.25.52.2",
        "mac": "TPLG2ABDC7D5",
        "serial": "TPLG2ABDC7D5",
        "queue": null,
        "interface": "VLAN121_S_ANGEL",
        "created_at": "2025-12-06T10:05:25.398683",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6341,
      "client_name": "KELLY ONEYCER PETIT NUÑEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "La Casona II Edificios",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243696098",
      "client_email": "KISSMETIT@HOTMAIL.COM",
      "address": "AV INTERCOMUNAL TURMERO EDOF 11 PISO 2 APT 4 CONJUNTO RESIDENCIAL LA CASONA 2 TURMERO ARAGUA",
      "client_identification": "V14470457",
      "nap_box_name": "CTO-0538",
      "created_at": "2024-08-08T13:49:42.970501",
      "service_detail": {
        "id": 11218,
        "ip": "172.25.50.2",
        "mac": "TPLG7ABDC803",
        "serial": "TPLG7ABDC803",
        "queue": null,
        "interface": "VLAN110_CASONA_2",
        "created_at": "2026-01-17T19:04:28.414122",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6342,
      "client_name": "ANGELO ADRIAN FASAN LARA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "San Pablo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243248630",
      "client_email": "ANGELOFASANLARA37@GMAIL.COM",
      "address": "AV PRINCIPAL MANZANA 11 CASA NRO 23 URB SAN PABLO TURMERO EDO ARAGUA",
      "client_identification": "V27654904",
      "nap_box_name": "CTO-00192",
      "created_at": "2024-08-08T13:51:36.745948",
      "service_detail": {
        "id": 4570,
        "ip": "172.20.45.2",
        "mac": "TPLG2ABDC80D",
        "serial": "TPLG2ABDC80D",
        "queue": "Plan_153953_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-08-11T15:54:46.769761",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6345,
      "client_name": "ZONA EDUCATIVA MARINO",
      "client_type_name": "INTERCAMBIO",
      "client_subdivision": "ACTIVO_INTERCAMBIO",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 83,
        "name": "RECURRENTE INSTITUCIONAL 80M",
        "cost": "0.00",
        "code": "FO-R80",
        "profile": "80M/80M"
      },
      "client_mobile": "04121487107",
      "client_email": "UENVAHTURMERO@GMAIL.COM",
      "address": "CALLE NEGRO PRIMERO  NORTE CRUCE CON CAMILO TORRES FRENTE A  LA URB LA MONTAÑA TURMERO",
      "client_identification": "J407626051",
      "nap_box_name": "68",
      "created_at": "2024-08-08T14:17:11.796308",
      "service_detail": {
        "id": 4327,
        "ip": "172.19.34.2",
        "mac": "TPLGB954FC62",
        "serial": "TPLGB954FC62",
        "queue": "Plan_121695_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-08-09T10:38:27.273070",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6346,
      "client_name": "JOSE MANUEL OSPINO BELMONTE",
      "client_type_name": "INTERCAMBIO",
      "client_subdivision": "ACTIVO_INTERCAMBIO",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "El Macaro",
      "plan": {
        "id": 83,
        "name": "RECURRENTE INSTITUCIONAL 80M",
        "cost": "0.00",
        "code": "FO-R80",
        "profile": "80M/80M"
      },
      "client_mobile": "04129112723",
      "client_email": "JOSEMANUELPINO15@GMAIL.COM",
      "address": "AV PRINCIPAL EL MACARO LOCAL PARCELA NRO 07 SECTOR EL MACARO TURMERO",
      "client_identification": "V27204987",
      "nap_box_name": "52",
      "created_at": "2024-08-08T14:24:26.903272",
      "service_detail": {
        "id": 4328,
        "ip": "172.19.161.2",
        "mac": "TPLGB954FB49",
        "serial": "TPLGB954FB49",
        "queue": "Plan_14173_1574_WispHub",
        "interface": "VLAN128_SIMON_BOLIVAR_ZTE",
        "created_at": "2024-08-09T10:41:23.279953",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6347,
      "client_name": "CDI VALLE LINDO",
      "client_type_name": "INTERCAMBIO",
      "client_subdivision": "ACTIVO_INTERCAMBIO",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 83,
        "name": "RECURRENTE INSTITUCIONAL 80M",
        "cost": "0.00",
        "code": "FO-R80",
        "profile": "80M/80M"
      },
      "client_mobile": "04128490252",
      "client_email": "SUSHAYLE@GMAIL.COM",
      "address": "VALLE LINDO TURMERO ARAGUA",
      "client_identification": "V16692372",
      "nap_box_name": "110",
      "created_at": "2024-08-08T14:31:41.668530",
      "service_detail": {
        "id": 4329,
        "ip": "172.22.10.2",
        "mac": "TPLGB68B4F87",
        "serial": "TPLGB68B4F87",
        "queue": "Plan_121695_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-08-09T10:50:47.054813",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6348,
      "client_name": "UNIDAD EDUCATIVA NACIONAL RAMON BASTIDAS",
      "client_type_name": "INTERCAMBIO",
      "client_subdivision": "ACTIVO_INTERCAMBIO",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 83,
        "name": "RECURRENTE INSTITUCIONAL 80M",
        "cost": "0.00",
        "code": "FO-R80",
        "profile": "80M/80M"
      },
      "client_mobile": "04128950810",
      "client_email": "RAMONBASTIDAS2011@GMAIL.COM",
      "address": "CALLE RIBAS SECTOR PUEBLO NUEVO TURMERO",
      "client_identification": "J405851775",
      "nap_box_name": "20",
      "created_at": "2024-08-08T14:38:39.349551",
      "service_detail": {
        "id": 4330,
        "ip": "172.22.111.2",
        "mac": "TPLGBA688284",
        "serial": "TPLGBA688284",
        "queue": "Plan_121695_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-08-09T10:58:22.153885",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6349,
      "client_name": "LEDYS ROSSY MENESES ROJAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04125325032",
      "client_email": "LEDYSMENESES2024@GMAIL.COM",
      "address": "CALLE 12, CASA NRO 77, SECTOR SAMAN TARAZONERO SUR, TURMERO, ARAGUA",
      "client_identification": "V16011806",
      "nap_box_name": "CTO-00092",
      "created_at": "2024-08-08T15:05:07.894613",
      "service_detail": {
        "id": 4317,
        "ip": "172.31.62.2",
        "mac": "OEMT3C622EA2",
        "serial": "OEMT3C622EA2",
        "queue": "Plan_131337_24341_WispHub",
        "interface": "VLAN110_CASONA_2",
        "created_at": "2024-08-09T09:11:39.781777",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6350,
      "client_name": "ANA LUISA SANDOVAL SOTO",
      "client_type_name": "INTERCAMBIO",
      "client_subdivision": "ACTIVO_INTERCAMBIO",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "El Macaro",
      "plan": {
        "id": 83,
        "name": "RECURRENTE INSTITUCIONAL 80M",
        "cost": "0.00",
        "code": "FO-R80",
        "profile": "80M/80M"
      },
      "client_mobile": "04120698260",
      "client_email": "ANASANDOVAL0873@GMAIL.COM",
      "address": "CARRETERA NACIONAL TURMERO  MARACAY",
      "client_identification": "V12583180",
      "nap_box_name": "493",
      "created_at": "2024-08-08T15:46:14.557943",
      "service_detail": {
        "id": 4333,
        "ip": "172.23.204.2",
        "mac": "VSOL0012EAD1",
        "serial": "VSOL0012EAD1",
        "queue": "Plan_14173_1574_WispHub",
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2024-08-09T11:07:39.652274",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6351,
      "client_name": "ALDEA UNIVERSITARIA COMUNAL SAMAN DE GUERE",
      "client_type_name": "INTERCAMBIO",
      "client_subdivision": "ACTIVO_INTERCAMBIO",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "El Macaro",
      "plan": {
        "id": 83,
        "name": "RECURRENTE INSTITUCIONAL 80M",
        "cost": "0.00",
        "code": "FO-R80",
        "profile": "80M/80M"
      },
      "client_mobile": "04124775156",
      "client_email": "ALDEASMARINO.4@GMAIL.COM",
      "address": "CARRETERA NACIONAL TURMERO MARACAY EL MACARO",
      "client_identification": "G200038713",
      "nap_box_name": "493",
      "created_at": "2024-08-08T16:15:59.789149",
      "service_detail": {
        "id": 4335,
        "ip": "172.24.120.2",
        "mac": "TPLGF4B1DB92",
        "serial": "TPLGF4B1DB92",
        "queue": "Plan_14173_1574_WispHub",
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2024-08-09T11:10:59.725307",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6352,
      "client_name": "YHONATTAN ALBERTO HURTADO PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados I",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04122295591",
      "client_email": "YHONATTANHURTADO2201@GMAIL.COM",
      "address": "CALLE PRINCIPAL CASA NRO 54 SECTOR PRADOS I ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V205913072",
      "nap_box_name": "CTO-00211",
      "created_at": "2024-08-08T16:38:35.229553",
      "service_detail": {
        "id": 4311,
        "ip": "172.31.61.2",
        "mac": "OEMT3C623036",
        "serial": "OEMT3C623036",
        "queue": "Plan_161906_30183_WispHub",
        "interface": "VLAN239_PRADOS1",
        "created_at": "2024-08-09T08:57:02.968027",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6353,
      "client_name": "WILLIAMS ALFREDO ARIAS GARCIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Guerito",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04163430003",
      "client_email": "ARIASWILLIAMS@GMAIL.COM",
      "address": "CALLE GUERITO, EDIF TERRAZA 5, PISO 2 APT 6B, CONJUNTO RE",
      "client_identification": "V13356521",
      "nap_box_name": "CE (Proyecto)",
      "created_at": "2024-08-08T16:41:37.153834",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6354,
      "client_name": "BILKA LISSETTE JIMENEZ DE BARRADA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "La Casona II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243129435",
      "client_email": "BILMARBARRADA2710@GMAIL.COM",
      "address": "CALLE 14 CASA NRO 84 URB LA CASONA II TURMERO",
      "client_identification": "V9697762",
      "nap_box_name": "CTO-00120",
      "created_at": "2024-08-08T16:50:37.062413",
      "service_detail": {
        "id": 4298,
        "ip": "172.24.32.2",
        "mac": "VSOL001246E9",
        "serial": "VSOL001246E9",
        "queue": "Plan_92034_24341_WispHub",
        "interface": "VLAN110_CASONA_2",
        "created_at": "2024-08-08T19:41:03.911003",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6355,
      "client_name": "ISBEYDIX NAZARETH MALDONADO GARCIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Terrazas de Paya",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128971585",
      "client_email": "ISBEYDIX@GMAIL.COM",
      "address": "CALLE MANZANA 5, CASA NRO 18, TERRAZA DE PAYA",
      "client_identification": "V30322978",
      "nap_box_name": "CTO-00426",
      "created_at": "2024-08-08T16:59:06.529002",
      "service_detail": {
        "id": 12677,
        "ip": "172.31.58.2",
        "mac": "OE:MT:3C:62:31:12",
        "serial": "OEMT3C623112",
        "queue": null,
        "interface": "VLAN243_BICENTENARIO",
        "created_at": "2026-07-05T09:04:44.363556",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6356,
      "client_name": "JERSON JOSE ALVARADO COLON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243155033",
      "client_email": "JERSSONALV@GMAIL.COM",
      "address": "CALLE 12 CASA NRO 665-C SECTOR MATA CABALLO",
      "client_identification": "V19515987",
      "nap_box_name": "CTO-00020",
      "created_at": "2024-08-08T17:22:36.206978",
      "service_detail": {
        "id": 4291,
        "ip": "172.17.167.2",
        "mac": "VSOL00520891",
        "serial": "VSOL00520891",
        "queue": "Plan_161892_30183_WispHub",
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2024-08-08T19:23:01.499058",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6358,
      "client_name": "CLINICA POPULAR DE TURMERO",
      "client_type_name": "INTERCAMBIO",
      "client_subdivision": "ACTIVO_INTERCAMBIO",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 83,
        "name": "RECURRENTE INSTITUCIONAL 80M",
        "cost": "0.00",
        "code": "FO-R80",
        "profile": "80M/80M"
      },
      "client_mobile": "04121388704",
      "client_email": "INFORMATICA.CPTURMERO@GMAIL.COM",
      "address": "CALLE PROLONGACIÓN AV BOLIVAR SECTOR CENTRO TURMERO ARAGUA",
      "client_identification": "G200027860",
      "nap_box_name": "88",
      "created_at": "2024-08-09T10:05:58.240030",
      "service_detail": {
        "id": 4397,
        "ip": "172.24.121.2",
        "mac": "TPLGF4EFC272",
        "serial": "TPLGF4EFC272",
        "queue": "Plan_121695_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-08-09T19:58:22.245351",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6359,
      "client_name": "REYMING ESTEBAN MACHADO MARTINEZ",
      "client_type_name": "INTERCAMBIO",
      "client_subdivision": "ACTIVO_INTERCAMBIO",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "El Nispero",
      "plan": {
        "id": 83,
        "name": "RECURRENTE INSTITUCIONAL 80M",
        "cost": "0.00",
        "code": "FO-R80",
        "profile": "80M/80M"
      },
      "client_mobile": "04265305151",
      "client_email": "REYDPET@GMAIL.COM",
      "address": "CALLE 2 CASA NRO 61 URB EL NISPERO TURMERO ARAGUA",
      "client_identification": "V20336303",
      "nap_box_name": "20",
      "created_at": "2024-08-09T10:15:38.923088",
      "service_detail": {
        "id": 10184,
        "ip": "172.20.29.2",
        "mac": "TPLGB765631A",
        "serial": "TPLGB765631A",
        "queue": null,
        "interface": "VLAN218_NISPEROS_OLT1",
        "created_at": "2025-11-18T19:18:50.067768",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6361,
      "client_name": "CICPC TURMERO",
      "client_type_name": "INTERCAMBIO",
      "client_subdivision": "ACTIVO_INTERCAMBIO",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "San Pablo",
      "plan": {
        "id": 83,
        "name": "RECURRENTE INSTITUCIONAL 80M",
        "cost": "0.00",
        "code": "FO-R80",
        "profile": "80M/80M"
      },
      "client_mobile": "04144903699",
      "client_email": "BLANCOGUZMANEDUINJOSE@GMAIL.COM",
      "address": "ZONA INDUSTRIAL SAN PABLO SEDE DE HOMICIDIOS CICPC TURMERO",
      "client_identification": "G200010320",
      "nap_box_name": "55",
      "created_at": "2024-08-09T10:38:01.073341",
      "service_detail": {
        "id": 12388,
        "ip": "172.18.205.2",
        "mac": "TPLGB954FCED",
        "serial": "TPLGB954FCED",
        "queue": null,
        "interface": "VLAN224_SAN_PABLO_OLT1",
        "created_at": "2026-04-21T12:47:45.609465",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6362,
      "client_name": "BOMBEROS DE TURMERO",
      "client_type_name": "INTERCAMBIO",
      "client_subdivision": "ACTIVO_INTERCAMBIO",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "San Pablo",
      "plan": {
        "id": 83,
        "name": "RECURRENTE INSTITUCIONAL 80M",
        "cost": "0.00",
        "code": "FO-R80",
        "profile": "80M/80M"
      },
      "client_mobile": "04123794574",
      "client_email": "BOMBEROSDEARAGUA.CBA@GMAIL.COM",
      "address": "ZONA INDUSTRIAL SAN PABLO CALLE INDUSTRIAL.TURMERO ARAGUA.",
      "client_identification": "V7244648",
      "nap_box_name": "55",
      "created_at": "2024-08-09T10:54:24.660329",
      "service_detail": {
        "id": 4409,
        "ip": "172.18.206.2",
        "mac": "TPLGB95502C9",
        "serial": "TPLGB95502C9",
        "queue": "Plan_121695_15811_WispHub",
        "interface": "VLAN224_SAN_PABLO_OLT1",
        "created_at": "2024-08-09T20:35:27.592129",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6363,
      "client_name": "PNB TRANSITO ARC INSPECTOR BRACHO",
      "client_type_name": "INTERCAMBIO",
      "client_subdivision": "ACTIVO_INTERCAMBIO",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "San Pablo",
      "plan": {
        "id": 83,
        "name": "RECURRENTE INSTITUCIONAL 80M",
        "cost": "0.00",
        "code": "FO-R80",
        "profile": "80M/80M"
      },
      "client_mobile": "04267415025",
      "client_email": "RRHHSTARC@GMAIL.COM",
      "address": "ZONA INDUSTRIAL SAN PABLO CALLE INDUSTRIAL.TURMERO ARAGUA.",
      "client_identification": "G200093277",
      "nap_box_name": "55",
      "created_at": "2024-08-09T10:59:14.564913",
      "service_detail": {
        "id": 4413,
        "ip": "172.18.207.2",
        "mac": "TPLGB95500B6",
        "serial": "TPLGB95500B6",
        "queue": "Plan_121695_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-08-09T20:47:02.568121",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6365,
      "client_name": "JOHAN ARGENIS NORATO LIENDO",
      "client_type_name": "GRATIS",
      "client_subdivision": "ACTIVO_GRATIS",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "La Macarena",
      "plan": {
        "id": 86,
        "name": "PLAN RECURRENTE 80M GRATIS",
        "cost": "0.00",
        "code": "FO-G80",
        "profile": "80M/80M"
      },
      "client_mobile": "04122411610",
      "client_email": "JNORATOJ@GMAIL.COM",
      "address": "CALLE 06 CASA NRO 19 LA MACARENA EL MACARO TURMERO",
      "client_identification": "V20693815",
      "nap_box_name": "246",
      "created_at": "2024-08-09T13:57:36.360761",
      "service_detail": {
        "id": 4424,
        "ip": "172.19.185.2",
        "mac": "TPLGB954EA84",
        "serial": "TPLGB954EA84",
        "queue": "Plan_14173_1574_WispHub",
        "interface": "VLAN112_LA_MACARENA",
        "created_at": "2024-08-09T21:20:00.101244",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6367,
      "client_name": "RADIO APLAUSO FM &TV, C.A",
      "client_type_name": "INTERCAMBIO",
      "client_subdivision": "CANCELADO_INTERCAMBIO",
      "status_name": "Cancelado",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 83,
        "name": "RECURRENTE INSTITUCIONAL 80M",
        "cost": "0.00",
        "code": "FO-R80",
        "profile": "80M/80M"
      },
      "client_mobile": "04126973330",
      "client_email": "APLAUSOTV2020@GMAIL.COM",
      "address": "CALLE MIRANDA C.C NONO  LORENZO NIVEL PB LOCAL 05 ZON CASCO DE TURMERO",
      "client_identification": "J500536836",
      "nap_box_name": "CTO-00072",
      "created_at": "2024-08-09T14:17:52.071887",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6369,
      "client_name": "CDI SAMAN DE GUERE",
      "client_type_name": "INTERCAMBIO",
      "client_subdivision": "ACTIVO_INTERCAMBIO",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Saman de Guere",
      "plan": {
        "id": 83,
        "name": "RECURRENTE INSTITUCIONAL 80M",
        "cost": "0.00",
        "code": "FO-R80",
        "profile": "80M/80M"
      },
      "client_mobile": "04123982125",
      "client_email": "LENNYSSAJAJU1980@GMAIL.COM",
      "address": "CALLE VICTORIA ENTRE CALLE  CAYENAS Y CALLE LA LLANERA SAMAN DE GUERE",
      "client_identification": "V2588611",
      "nap_box_name": "289",
      "created_at": "2024-08-09T14:35:50.626932",
      "service_detail": {
        "id": 9311,
        "ip": "172.23.33.2",
        "mac": "TPLGBA6874BB",
        "serial": "TPLGBA6874BB",
        "queue": "queue1",
        "interface": "VLAN122_SAMAN_GUERE",
        "created_at": "2025-08-05T11:18:47.296091",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6370,
      "client_name": "CDI LA CASONA SAMAN",
      "client_type_name": "INTERCAMBIO",
      "client_subdivision": "ACTIVO_INTERCAMBIO",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "La Casona II",
      "plan": {
        "id": 83,
        "name": "RECURRENTE INSTITUCIONAL 80M",
        "cost": "0.00",
        "code": "FO-R80",
        "profile": "80M/80M"
      },
      "client_mobile": "04127773076",
      "client_email": "GARRIDOADAY@GMAIL.COM",
      "address": "LA CASONA 2 CALLE 13 PRINCIPAL SAMAN DE GUERE AL LADO DE LA NEGRA HIPOLITA",
      "client_identification": "V7267188",
      "nap_box_name": "CTO-00091 DOS",
      "created_at": "2024-08-09T14:41:58.791163",
      "service_detail": {
        "id": 4451,
        "ip": "172.22.42.2",
        "mac": "TPLGBA68824E",
        "serial": "TPLGBA68824E",
        "queue": "Plan_132970_24341_WispHub",
        "interface": "VLAN110_CASONA_2",
        "created_at": "2024-08-09T22:08:39.930202",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6371,
      "client_name": "SANTOS GERARDO MEDINA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04149444004",
      "client_email": "MEDINASANTOSGERARDO@GMAIL.COM",
      "address": "CALLE 7A, CASA NRO 6, URB PANTIN, ROSARIO DE PAYA, TURMERO, ARAGUA",
      "client_identification": "V10471777",
      "nap_box_name": "CTO-00139",
      "created_at": "2024-08-09T16:13:51.453530",
      "service_detail": {
        "id": 4804,
        "ip": "172.31.65.2",
        "mac": "OEMT3C62314A",
        "serial": "OEMT3C62314A",
        "queue": "Plan_161903_30183_WispHub",
        "interface": "VLAN229_PANTIN",
        "created_at": "2024-08-12T16:50:18.959191",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6372,
      "client_name": "IBSEN JOSE JIMENEZ CASTILLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124316702",
      "client_email": "IBSENJIMENEZ@GMAIL.COM",
      "address": "CALLE 1 MANZANA 1 CASA NRO 8 BARRIO SAN TARAZONERO II TURMERO",
      "client_identification": "V23784808",
      "nap_box_name": "119",
      "created_at": "2024-08-09T16:53:08.186844",
      "service_detail": {
        "id": 10986,
        "ip": "172.20.146.2",
        "mac": "TPLGF5CB03E2",
        "serial": "TPLGF5CB03E2",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2025-12-29T10:40:22.468106",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6373,
      "client_name": "TAMARA GROSSO MATHEUS",
      "client_type_name": "INTERCAMBIO",
      "client_subdivision": "ACTIVO_INTERCAMBIO",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "San Pablo",
      "plan": {
        "id": 83,
        "name": "RECURRENTE INSTITUCIONAL 80M",
        "cost": "0.00",
        "code": "FO-R80",
        "profile": "80M/80M"
      },
      "client_mobile": "04140472128",
      "client_email": "TAMAGM18@GMAIL.COM",
      "address": "AV 5TA CASA NRO 1 URB  SAN PABLO TURMERO",
      "client_identification": "V12612654",
      "nap_box_name": "635",
      "created_at": "2024-08-10T10:49:36.447554",
      "service_detail": {
        "id": 4527,
        "ip": "172.22.203.2",
        "mac": "TPLGBA687853",
        "serial": "TPLGBA687853",
        "queue": "Plan_121695_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-08-11T08:30:42.374906",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6374,
      "client_name": "UEER BALBINO BLANCO SANCHEZ",
      "client_type_name": "INTERCAMBIO",
      "client_subdivision": "ACTIVO_INTERCAMBIO",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 83,
        "name": "RECURRENTE INSTITUCIONAL 80M",
        "cost": "0.00",
        "code": "FO-R80",
        "profile": "80M/80M"
      },
      "client_mobile": "04243408606",
      "client_email": "MARIANOPICONSALAS21@GMAIL.COM",
      "address": "AV PRINCIPAL URB PANTIN ROSARIO DE PAYA",
      "client_identification": "J404572210",
      "nap_box_name": "CTO-00105",
      "created_at": "2024-08-10T10:57:35.139596",
      "service_detail": {
        "id": 4528,
        "ip": "172.23.32.2",
        "mac": "GPON0097E096",
        "serial": "GPON0097E096",
        "queue": "Plan_132970_30183_WispHub",
        "interface": "VLAN229_PANTIN",
        "created_at": "2024-08-11T08:32:54.000970",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6375,
      "client_name": "COMISARIA PANTIN MARINO III",
      "client_type_name": "INTERCAMBIO",
      "client_subdivision": "ACTIVO_INTERCAMBIO",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 83,
        "name": "RECURRENTE INSTITUCIONAL 80M",
        "cost": "0.00",
        "code": "FO-R80",
        "profile": "80M/80M"
      },
      "client_mobile": "04128434040",
      "client_email": "estacionrosariodepaya3@gmail.com",
      "address": "CARRETERA NACIONAL  ROSARIO DE PAYA CON CALLE PRINCIPAL DE URBANIZACION PANTIN NRO 01",
      "client_identification": "V13721106",
      "nap_box_name": "CTO-00128",
      "created_at": "2024-08-10T11:04:52.428752",
      "service_detail": {
        "id": 4529,
        "ip": "172.23.51.2",
        "mac": "VSOL00138561",
        "serial": "VSOL00138561",
        "queue": "Plan_162000_30183_WispHub",
        "interface": "VLAN229_PANTIN",
        "created_at": "2024-08-11T08:34:52.599587",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6376,
      "client_name": "CEIE SANTIAGO MARINO",
      "client_type_name": "INTERCAMBIO",
      "client_subdivision": "ACTIVO_INTERCAMBIO",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 83,
        "name": "RECURRENTE INSTITUCIONAL 80M",
        "cost": "0.00",
        "code": "FO-R80",
        "profile": "80M/80M"
      },
      "client_mobile": "04243714967",
      "client_email": "SANTIAGOMARINO@GMAIL.COM",
      "address": "CALLE NEGRO PRIMERO  CASCO DE TURMERO SANTIAGO MARIÑO",
      "client_identification": "V111228880",
      "nap_box_name": "18",
      "created_at": "2024-08-10T11:13:59.792288",
      "service_detail": {
        "id": 4530,
        "ip": "172.31.6.2",
        "mac": "TPLGBA687C23",
        "serial": "TPLGBA687C23",
        "queue": "Plan_121695_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-08-11T08:36:56.992268",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6377,
      "client_name": "RUFO JEAN PAUL MORALES TERAN",
      "client_type_name": "EMPLEADO",
      "client_subdivision": "ACTIVO_EMPLEADO",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "La Magdalena",
      "plan": {
        "id": 78,
        "name": "Plan empleado 80MB",
        "cost": "0.00",
        "code": "FO-80M",
        "profile": "80M/80M"
      },
      "client_mobile": "04125989734",
      "client_email": "RUFOMORALESA@IRTLOK.ES",
      "address": "CALLE 11 CASA NRO 39 SECTOR  LA MAGDALENA TURMERO",
      "client_identification": "V21270403",
      "nap_box_name": "357",
      "created_at": "2024-08-10T11:36:45.099223",
      "service_detail": {
        "id": 13016,
        "ip": "172.23.185.2",
        "mac": "GP:ON:00:97:E1:66",
        "serial": "GPON0097E166",
        "queue": null,
        "interface": "VLAN251_RIO_SECO",
        "created_at": "2026-09-14T18:09:04.379148",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6378,
      "client_name": "CDI PRADOS DE PAYA",
      "client_type_name": "INTERCAMBIO",
      "client_subdivision": "ACTIVO_INTERCAMBIO",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Prados III",
      "plan": {
        "id": 83,
        "name": "RECURRENTE INSTITUCIONAL 80M",
        "cost": "0.00",
        "code": "FO-R80",
        "profile": "80M/80M"
      },
      "client_mobile": "04124147672",
      "client_email": "DANYDIAZ14470669@GMAIL.COM",
      "address": "SECTOR PRADOS DE PAYA  FRENTE EL ESTADIO ROSARIO DE PAYA",
      "client_identification": "V14470669",
      "nap_box_name": "CTO-00021",
      "created_at": "2024-08-10T11:42:54.899074",
      "service_detail": {
        "id": 4532,
        "ip": "172.21.22.2",
        "mac": "VSOL0012E611",
        "serial": "VSOL0012E611",
        "queue": "Plan_162000_30183_WispHub",
        "interface": "VLAN236_PRADOS3",
        "created_at": "2024-08-11T08:41:12.884886",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6379,
      "client_name": "PREFECTURA PANTIN",
      "client_type_name": "INTERCAMBIO",
      "client_subdivision": "ACTIVO_INTERCAMBIO",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 83,
        "name": "RECURRENTE INSTITUCIONAL 80M",
        "cost": "0.00",
        "code": "FO-R80",
        "profile": "80M/80M"
      },
      "client_mobile": "0412509577",
      "client_email": "PREFECTURAPAYA@GMAIL.COM",
      "address": "URBANIZACION PANTIN CALLE 8  CASA NRO 01 TURMERO",
      "client_identification": "V107560230",
      "nap_box_name": "CTO-00114",
      "created_at": "2024-08-10T11:50:57.986509",
      "service_detail": {
        "id": 12576,
        "ip": "172.23.192.2",
        "mac": "68:9F:FO:OA:97:AF",
        "serial": "ZXICCDEC399A",
        "queue": null,
        "interface": "VLAN229_PANTIN",
        "created_at": "2026-06-03T11:03:36.045212",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6380,
      "client_name": "GRISEL CAROLINA ULLOA DIAZ",
      "client_type_name": "EMPLEADO",
      "client_subdivision": "CANCELADO_EMPLEADO",
      "status_name": "Cancelado",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Prados III",
      "plan": {
        "id": 78,
        "name": "Plan empleado 80MB",
        "cost": "0.00",
        "code": "FO-80M",
        "profile": "80M/80M"
      },
      "client_mobile": "4120330559",
      "client_email": "RMARLYS108@GMAIL.COM",
      "address": "CALLE 06 CASA NRO 54 SECTOR PRADOS III ROSARIO DE PAYA",
      "client_identification": "V16765895",
      "nap_box_name": "395",
      "created_at": "2024-08-10T12:02:25.343497",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6381,
      "client_name": "INSTITUCION NEGRA HIPOLITA",
      "client_type_name": "INTERCAMBIO",
      "client_subdivision": "ACTIVO_INTERCAMBIO",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "La Casona II",
      "plan": {
        "id": 83,
        "name": "RECURRENTE INSTITUCIONAL 80M",
        "cost": "0.00",
        "code": "FO-R80",
        "profile": "80M/80M"
      },
      "client_mobile": "04127789783",
      "client_email": "LIMAROJAS33@GMAIL.COM",
      "address": "CALLE 13 CASA 20 SECTOR CASONA II TURMERO",
      "client_identification": "G299445681",
      "nap_box_name": "CTO-00091 DOS",
      "created_at": "2024-08-10T12:42:17.995491",
      "service_detail": {
        "id": 4535,
        "ip": "172.24.40.2",
        "mac": "VSOL00138EB9",
        "serial": "VSOL00138EB9",
        "queue": "Plan_132970_24341_WispHub",
        "interface": "VLAN110_CASONA_2",
        "created_at": "2024-08-11T08:47:37.714335",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6382,
      "client_name": "GUARDIA DEL PUEBLO SAMAN TARAZONERO II",
      "client_type_name": "INTERCAMBIO",
      "client_subdivision": "ACTIVO_INTERCAMBIO",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "El Macaro",
      "plan": {
        "id": 83,
        "name": "RECURRENTE INSTITUCIONAL 80M",
        "cost": "0.00",
        "code": "FO-R80",
        "profile": "80M/80M"
      },
      "client_mobile": "04244338384",
      "client_email": "ROGERRG694@GMAIL.COM",
      "address": "CARRETERA NACIONAL TURMERO MARACAY",
      "client_identification": "V18660941",
      "nap_box_name": "493",
      "created_at": "2024-08-10T12:49:06.958379",
      "service_detail": {
        "id": 4536,
        "ip": "172.23.236.2",
        "mac": "TPLGBA687A7A",
        "serial": "TPLGBA687A7A",
        "queue": "Plan_14173_1574_WispHub",
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2024-08-11T08:50:30.118435",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6383,
      "client_name": "ANA LUISA GONZALEZ FIGUEREDO",
      "client_type_name": "GRATIS",
      "client_subdivision": "CANCELADO_GRATIS",
      "status_name": "Cancelado",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Saman Tarazonero I",
      "plan": {
        "id": 86,
        "name": "PLAN RECURRENTE 80M GRATIS",
        "cost": "0.00",
        "code": "FO-G80",
        "profile": "80M/80M"
      },
      "client_mobile": "04144536624",
      "client_email": "ZAMORAJUANJOSE1948@GMAIL.COM",
      "address": "AV PRINCIPAL CALLE 3 CASA NRO 35 SECTOR  SAMAN TARAZONERO I TURMERO",
      "client_identification": "V9663983",
      "nap_box_name": "32",
      "created_at": "2024-08-10T12:54:36.641534",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6384,
      "client_name": "ESTEFANY YOCELIN SOUTO VIERAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 16,
        "name": "RECURRENTE RESIDENCIAL PLAN 800M",
        "cost": "55.00",
        "code": "FOR800",
        "profile": "800M/800M"
      },
      "client_mobile": "04123485402",
      "client_email": "LUISSOUTO94@GMAIL.COM",
      "address": "VDA I-10 BARRIO SAMÁN TARAZONERO II TURMERO ARAGUA",
      "client_identification": "V21100851",
      "nap_box_name": "504",
      "created_at": "2024-08-12T08:09:53.151410",
      "service_detail": {
        "id": 4627,
        "ip": "172.18.181.2",
        "mac": "TPLG2ABDC7DB",
        "serial": "TPLG2ABDC7DB",
        "queue": "Plan_127983_1574_WispHub",
        "interface": "VLAN100_OLTs",
        "created_at": "2024-08-12T08:11:11.028617",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6385,
      "client_name": "FREDDY RAMON PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243243488",
      "client_email": "FREDDY.FP6@GMAIL.COM",
      "address": "CALLE 21, CASA NRO 68, SECTOR RIO SECO, ROSARIO DE PAYA, ARAGUA",
      "client_identification": "V5160586",
      "nap_box_name": "CTO-00253 DOS",
      "created_at": "2024-08-12T09:22:33.796522",
      "service_detail": {
        "id": 6325,
        "ip": "172.31.79.2",
        "mac": "OEMT3C622682",
        "serial": "OEMT3C622682",
        "queue": "Plan_161868_30181_WispHub",
        "interface": "VLAN251_RIO_SECO",
        "created_at": "2024-08-23T19:43:21.962996",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6386,
      "client_name": "EILYN JOSEHANNY OVALLES GARCIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Las Rurales",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121597969",
      "client_email": "EILYNOVALLES03@GMAIL.COM",
      "address": "CALLE 104, CASA NRO 53, BARRIO LAS RULARES, ROSARIO DE PAYA, ARAGUA",
      "client_identification": "V29581531",
      "nap_box_name": "492",
      "created_at": "2024-08-12T09:48:58.805460",
      "service_detail": {
        "id": 4838,
        "ip": "172.31.67.2",
        "mac": "HWTC91218D87",
        "serial": "HWTC91218D87",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN252_RURALES_PAYA",
        "created_at": "2024-08-12T17:53:07.501184",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6387,
      "client_name": "DC MARKET CA",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Antonio Jose de Sucre",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04121486315",
      "client_email": "DCMARKETCA@GMAIL.COM",
      "address": "CTRA MARACAY TURMERO, CASA NRO PCLA NRO 2, SECTOR ANTONIO JOSE DE SUCRE. FUNDO EL MACARO, TURMERO, ARAGUA",
      "client_identification": "J501569100",
      "nap_box_name": "86 DOS",
      "created_at": "2024-08-12T10:59:01.348757",
      "service_detail": {
        "id": 4750,
        "ip": "172.31.69.2",
        "mac": "MONU003C3001",
        "serial": "MONU003C3001",
        "queue": "Plan_92033_1574_WispHub",
        "interface": "VLAN101_AJS",
        "created_at": "2024-08-12T14:52:14.680659",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6388,
      "client_name": "ALFREDO ALEJANDRO VEGAS ALBORNOZ",
      "client_type_name": "EMPLEADO",
      "client_subdivision": "CANCELADO_EMPLEADO",
      "status_name": "Cancelado",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Los Caobos",
      "plan": {
        "id": 78,
        "name": "Plan empleado 80MB",
        "cost": "0.00",
        "code": "FO-80M",
        "profile": "80M/80M"
      },
      "client_mobile": "04122928992",
      "client_email": "ALFREDOVEGAS1808@GMAIL.COM",
      "address": "CALLE LOS TULIPANES CASA NRO 22 SECTOR LOS CAOBOS II TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V27712684",
      "nap_box_name": "633",
      "created_at": "2024-08-12T11:29:03.849508",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6389,
      "client_name": "ANGEL MANUEL CHANDUVI ARAQUE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243520269",
      "client_email": "SHESPIRELY@GMAIL.COM",
      "address": "CALLE 3 CASA NRO 177 URB MATA CABALLO ROSARIO DE PAYA",
      "client_identification": "V25066596",
      "nap_box_name": "CTO-00422",
      "created_at": "2024-08-12T11:37:40.246156",
      "service_detail": {
        "id": 5035,
        "ip": "172.17.249.2",
        "mac": "VSOL00520BF1",
        "serial": "VSOL00520BF1",
        "queue": "Plan_161892_30183_WispHub",
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2024-08-13T18:07:12.375815",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6391,
      "client_name": "UEN HENRI PITTIER",
      "client_type_name": "INTERCAMBIO",
      "client_subdivision": "ACTIVO_INTERCAMBIO",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Canaima",
      "plan": {
        "id": 83,
        "name": "RECURRENTE INSTITUCIONAL 80M",
        "cost": "0.00",
        "code": "FO-R80",
        "profile": "80M/80M"
      },
      "client_mobile": "04128475302",
      "client_email": "HICHYTORRES11@GMAIL.COM",
      "address": "URBANISMO CANAIMA CALLE 1 S/N PARROQUIA PEDRO AREVALO APONTE",
      "client_identification": "V8732343",
      "nap_box_name": "CTO-00172 ",
      "created_at": "2024-08-12T11:45:42.773668",
      "service_detail": {
        "id": 6708,
        "ip": "172.30.2.2",
        "mac": "OEMT3C625FF6",
        "serial": "OEMT3C625FF6",
        "queue": "Plan_132970_30183_WispHub",
        "interface": "VLAN237_CANAIMA",
        "created_at": "2024-09-18T17:25:08.412340",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6392,
      "client_name": "CEI SIMON RODRIGUEZ",
      "client_type_name": "INTERCAMBIO",
      "client_subdivision": "ACTIVO_INTERCAMBIO",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Bicentenario",
      "plan": {
        "id": 83,
        "name": "RECURRENTE INSTITUCIONAL 80M",
        "cost": "0.00",
        "code": "FO-R80",
        "profile": "80M/80M"
      },
      "client_mobile": "02446613141",
      "client_email": "CEINSIMONRODRIGUEZ@GMAIL.COM",
      "address": "BICENTANERIO CALLE HENRY PITIER  FINAL M/13 ROSARIO DE PAYA",
      "client_identification": "J405974702",
      "nap_box_name": "382",
      "created_at": "2024-08-12T12:25:37.608508",
      "service_detail": {
        "id": 4741,
        "ip": "172.30.27.2",
        "mac": "GPON0097C886",
        "serial": "GPON0097C886",
        "queue": "Plan_162000_30183_WispHub",
        "interface": "VLAN243_BICENTENARIO",
        "created_at": "2024-08-12T14:34:14.964966",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6393,
      "client_name": "STEPHANY DUGLEYS SEGOVIA ARIAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04129977991",
      "client_email": "VICTORMOISES05@HOTMAIL.COM",
      "address": "VDA PRINCIPAL DEL MACARO CASA NRO C4 URB  SAMAN TARAZONERO II TURMERO",
      "client_identification": "V27820865",
      "nap_box_name": "115",
      "created_at": "2024-08-12T12:59:28.327569",
      "service_detail": {
        "id": 12361,
        "ip": "172.23.157.2",
        "mac": "GPON0097CA76",
        "serial": "GPON0097CA76",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2026-04-19T10:55:37.568378",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6394,
      "client_name": "DAVID LLAMIL DIAZ VELEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121492697",
      "client_email": "davidllamil35@gmail.com",
      "address": "CALLE A, CASA NRO 11, URB VIRGEN DE COROMOTO, GUANARE, PORTUGUESA",
      "client_identification": "V16563841",
      "nap_box_name": "CTO - 939",
      "created_at": "2024-08-12T14:32:17.314135",
      "service_detail": {
        "id": 10131,
        "ip": "172.31.73.2",
        "mac": "HWTC1F8F78A1",
        "serial": "HWTC1F8F78A1",
        "queue": null,
        "interface": "VLAN200_OLTs",
        "created_at": "2025-11-14T13:30:03.763923",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6395,
      "client_name": "CEIE LA MACARENA",
      "client_type_name": "INTERCAMBIO",
      "client_subdivision": "ACTIVO_INTERCAMBIO",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "La Macarena",
      "plan": {
        "id": 83,
        "name": "RECURRENTE INSTITUCIONAL 80M",
        "cost": "0.00",
        "code": "FO-R80",
        "profile": "80M/80M"
      },
      "client_mobile": "04243281233",
      "client_email": "C.I.E.LAMACARENA2805@GMAIL.COM",
      "address": "URB LA MACARENA C/2",
      "client_identification": "V7225451",
      "nap_box_name": "444",
      "created_at": "2024-08-12T14:34:54.263973",
      "service_detail": {
        "id": 10053,
        "ip": "172.30.10.2",
        "mac": "GPON0097BD96",
        "serial": "GPON0097BD96",
        "queue": null,
        "interface": "VLAN112_LA_MACARENA_ZTE",
        "created_at": "2025-11-12T08:55:16.093195",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6396,
      "client_name": "PARROQUIA NUESTRA SEÑORA DE LA CANDELARIA",
      "client_type_name": "INTERCAMBIO",
      "client_subdivision": "ACTIVO_INTERCAMBIO",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 83,
        "name": "RECURRENTE INSTITUCIONAL 80M",
        "cost": "0.00",
        "code": "FO-R80",
        "profile": "80M/80M"
      },
      "client_mobile": "04128909515",
      "client_email": "PJOSEBRACAMONTE@HOTMAIL.COM",
      "address": "CALLE RIVAS CASA NRO 18 SECTOR CENTRO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "J075821165",
      "nap_box_name": "103",
      "created_at": "2024-08-12T14:46:08.775151",
      "service_detail": {
        "id": 4819,
        "ip": "172.25.86.2",
        "mac": "VSOL00124619",
        "serial": "VSOL00124619",
        "queue": "Plan_121695_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-08-12T17:12:10.379528",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6397,
      "client_name": "SAMUEL ABRAHAM MONTOYA MARQUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124581775",
      "client_email": "SAMUELMONTOYAM1529@GMAIL.COM",
      "address": "SAMAN TARAZONERO 2 MANZANA B-8 CASA NRO 12 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V30073055",
      "nap_box_name": "186",
      "created_at": "2024-08-12T15:00:42.527661",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6398,
      "client_name": "REGISTRO CIVIL SEDE DEL PSUV",
      "client_type_name": "INTERCAMBIO",
      "client_subdivision": "ACTIVO_INTERCAMBIO",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Prados III",
      "plan": {
        "id": 83,
        "name": "RECURRENTE INSTITUCIONAL 80M",
        "cost": "0.00",
        "code": "FO-R80",
        "profile": "80M/80M"
      },
      "client_mobile": "04168429418",
      "client_email": "NARDYMARTINEZCONCEJALA@GMAIL.COM",
      "address": "AVENIDA PRINCIPAL DE PRADO. ROSARIO DE PAYA",
      "client_identification": "V19200488",
      "nap_box_name": "237",
      "created_at": "2024-08-12T15:17:21.158763",
      "service_detail": {
        "id": 4837,
        "ip": "172.23.252.2",
        "mac": "VSOL0013B279",
        "serial": "VSOL0013B279",
        "queue": "Plan_162000_30183_WispHub",
        "interface": "VLAN230_VISTA_HERMOSA",
        "created_at": "2024-08-12T17:51:31.114702",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6399,
      "client_name": "LUIS ALEXANDER PEREZ GUZMAN",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Prados I",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128988886",
      "client_email": "LUISALEXANDERPEREZ79@GMAIL.COM",
      "address": "CALLE LOS JABILLOS CASA NRO 12 SECTOR EL SAMAN PRADOS DE PAYA",
      "client_identification": "V14104468",
      "nap_box_name": "CTO-00193",
      "created_at": "2024-08-12T16:23:54.278891",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6400,
      "client_name": "LINDA EVANS SIERRA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Las Rurales",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243764291",
      "client_email": "LINDASIERRA9765@GMAIL.COM",
      "address": "CALLE MARIÑO, EDIF 10, PISO PB, APT 01, SECTOR CENTRO, TURMERO, ARAGUA",
      "client_identification": "V20107880",
      "nap_box_name": "492",
      "created_at": "2024-08-13T08:34:38.505115",
      "service_detail": {
        "id": 4946,
        "ip": "172.31.71.2",
        "mac": "OEMT3C6226C2",
        "serial": "OEMT3C6226C2",
        "queue": "Plan_161905_30183_WispHub",
        "interface": "VLAN252_RURALES_PAYA",
        "created_at": "2024-08-13T14:57:40.241559",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6401,
      "client_name": "MANUEL ADELINO DE SOUSA ACEVEDO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243620382",
      "client_email": "YUSME070286@GMAIL.COM",
      "address": "CALLE RIBAS EDIF TORRE 2 PISO 5 APT, 82, CONJUNTO RESIDENCIAL CANDY, TURMERO, ARAGUA",
      "client_identification": "V18262584",
      "nap_box_name": "CTO-00094",
      "created_at": "2024-08-13T08:42:52.074031",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6402,
      "client_name": "CARLOS ALBERTO APARICIO PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04142963379",
      "client_email": "BIELIZPETENYI@GMAIL.COM",
      "address": "AV 7, CASA NRO 676-D, SECTOR MATA CABALLO, ROSARIO DE PAYA, ARAGUA",
      "client_identification": "V31895449",
      "nap_box_name": "CTO-00215",
      "created_at": "2024-08-13T08:53:56.091109",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6403,
      "client_name": "ORIANNYS GERAMEEL DE CASTRO BRITO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Arboleda",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04228157463",
      "client_email": "Oriannysbrito421@gmail.com",
      "address": "CALLE PRINCIPAL, CASA NRO SN CASERIO GUACUY, SECTOR MOROS VIEJO, ARAURE, ARARURE PORTUGUESA",
      "client_identification": "V31001253",
      "nap_box_name": "CTO-00236",
      "created_at": "2024-08-13T10:37:19.391947",
      "service_detail": {
        "id": 12066,
        "ip": "172.31.74.2",
        "mac": "HWTC30237493",
        "serial": "HWTC30237493",
        "queue": null,
        "interface": "VLAN257_ARBOLEDA",
        "created_at": "2026-03-15T11:02:32.924131",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6404,
      "client_name": "DEISY MARIANA DUGARTE CATAMO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04140385629",
      "client_email": "DANIELPA939@GMAIL.COM",
      "address": "AV 02, CASA NRO 469, SECTOR MATA CABALLO, ROSARIO DE PAYA, TURMERO, ARAGUA",
      "client_identification": "V18474753",
      "nap_box_name": "CTO-00222",
      "created_at": "2024-08-13T14:42:22.839402",
      "service_detail": {
        "id": 8935,
        "ip": "172.31.75.2",
        "mac": "OEMT3C622876",
        "serial": "OEMT3C622876",
        "queue": "queue1",
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2025-06-14T09:12:22.343265",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6405,
      "client_name": "UEE PROFESOR RAFAEL TAYLHARDAT SOTILLO",
      "client_type_name": "INTERCAMBIO",
      "client_subdivision": "ACTIVO_INTERCAMBIO",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Prados III",
      "plan": {
        "id": 83,
        "name": "RECURRENTE INSTITUCIONAL 80M",
        "cost": "0.00",
        "code": "FO-R80",
        "profile": "80M/80M"
      },
      "client_mobile": "04128381288",
      "client_email": "WIANEY11178@GMAIL.COM",
      "address": "CALLE 1 CRUCE CON CALLE 3 SECTOR PRADOS DE PAYA II",
      "client_identification": "J405096918",
      "nap_box_name": "CTO-00118 DOS",
      "created_at": "2024-08-13T14:52:24.361169",
      "service_detail": {
        "id": 4959,
        "ip": "172.30.26.2",
        "mac": "GPON0097C3A6",
        "serial": "GPON0097C3A6",
        "queue": "Plan_162000_30183_WispHub",
        "interface": "VLAN242_PRADOS2",
        "created_at": "2024-08-13T15:10:55.953336",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6406,
      "client_name": "EBE MARIANO PICÓN SALAS",
      "client_type_name": "INTERCAMBIO",
      "client_subdivision": "ACTIVO_INTERCAMBIO",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "La Julia",
      "plan": {
        "id": 83,
        "name": "RECURRENTE INSTITUCIONAL 80M",
        "cost": "0.00",
        "code": "FO-R80",
        "profile": "80M/80M"
      },
      "client_mobile": "04128556868",
      "client_email": "KENNAEGLEEVARGASBANDEZ@GMAIL.COM",
      "address": "CALLE 13 DE FEBRERO CRUCE CON EZEQUIEL ZAMORA SECTOR LA JULIA",
      "client_identification": "J409364143",
      "nap_box_name": "470",
      "created_at": "2024-08-13T15:01:19.420954",
      "service_detail": {
        "id": 4966,
        "ip": "172.30.18.2",
        "mac": "GPON0097D8E6",
        "serial": "GPON0097D8E6",
        "queue": "Plan_132970_24341_WispHub",
        "interface": "VLAN138_LAJULIA",
        "created_at": "2024-08-13T15:18:27.621083",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6407,
      "client_name": "EBE MARIANO PICÓN SALAS",
      "client_type_name": "INTERCAMBIO",
      "client_subdivision": "ACTIVO_INTERCAMBIO",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "La Julia",
      "plan": {
        "id": 83,
        "name": "RECURRENTE INSTITUCIONAL 80M",
        "cost": "0.00",
        "code": "FO-R80",
        "profile": "80M/80M"
      },
      "client_mobile": "04128556868",
      "client_email": "KENNAEGLEEVARGASBANDEZ@GMAIL.COM",
      "address": "CALLE 13 DE FEBRERO CRUCE CON EZEQUIEL ZAMORA SECTOR LA JULIA",
      "client_identification": "J409364143",
      "nap_box_name": "470",
      "created_at": "2024-08-13T15:05:08.295596",
      "service_detail": {
        "id": 4970,
        "ip": "172.30.19.2",
        "mac": "GPON0097D626",
        "serial": "GPON0097D626",
        "queue": "Plan_132970_24341_WispHub",
        "interface": "VLAN138_LAJULIA",
        "created_at": "2024-08-13T15:38:32.293572",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6408,
      "client_name": "ESLENDA RAMONA SULBARAN MORALES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243256885",
      "client_email": "ESLENDASULBARAN7@GMAIL.COM",
      "address": "MATA CABALLO, CALLE 5, CASA 355, PAYA",
      "client_identification": "V14740813",
      "nap_box_name": "CTO-00179",
      "created_at": "2024-08-13T15:06:39.835470",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6409,
      "client_name": "PEE MARIANO PICÓN SALAS",
      "client_type_name": "INTERCAMBIO",
      "client_subdivision": "ACTIVO_INTERCAMBIO",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "La Julia",
      "plan": {
        "id": 83,
        "name": "RECURRENTE INSTITUCIONAL 80M",
        "cost": "0.00",
        "code": "FO-R80",
        "profile": "80M/80M"
      },
      "client_mobile": "04127328235",
      "client_email": "TANAJUCAM0503@GMAIL.COM",
      "address": "CALLE 13 DE FEBRERO CRUCE CON EZEQUIEL ZAMORA SECTOR LA JULIA",
      "client_identification": "J307777303",
      "nap_box_name": "470",
      "created_at": "2024-08-13T15:45:37.983748",
      "service_detail": {
        "id": 4993,
        "ip": "172.30.17.2",
        "mac": "GPON0097B226",
        "serial": "GPON0097B226",
        "queue": "Plan_132970_24341_WispHub",
        "interface": "VLAN138_LAJULIA",
        "created_at": "2024-08-13T16:34:34.822323",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6410,
      "client_name": "CEINB NIÑO SIMON",
      "client_type_name": "INTERCAMBIO",
      "client_subdivision": "ACTIVO_INTERCAMBIO",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Los Caobos",
      "plan": {
        "id": 83,
        "name": "RECURRENTE INSTITUCIONAL 80M",
        "cost": "0.00",
        "code": "FO-R80",
        "profile": "80M/80M"
      },
      "client_mobile": "04121484082",
      "client_email": "MISMAESTRASNS@GMAIL.COM",
      "address": "CALLE BICENTENARIO LOCAL NRO S/N SECTOR LOS CAOBOS TURMERO",
      "client_identification": "G2000560",
      "nap_box_name": "633",
      "created_at": "2024-08-13T15:53:31.720018",
      "service_detail": {
        "id": 5004,
        "ip": "172.30.20.2",
        "mac": "GPON0097AAE6",
        "serial": "GPON0097AAE6",
        "queue": "Plan_132970_24341_WispHub",
        "interface": "VLAN116_CAOBOS",
        "created_at": "2024-08-13T16:55:29.408199",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6411,
      "client_name": "LBN ROSARIO DE PAYA",
      "client_type_name": "INTERCAMBIO",
      "client_subdivision": "ACTIVO_INTERCAMBIO",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Canaima",
      "plan": {
        "id": 83,
        "name": "RECURRENTE INSTITUCIONAL 80M",
        "cost": "0.00",
        "code": "FO-R80",
        "profile": "80M/80M"
      },
      "client_mobile": "04125369012",
      "client_email": "VALERIAVSLENTINA18@GMAIL.COM",
      "address": "CANAIMA CALLE 7 S/N ROSARIO DE PAYA",
      "client_identification": "V172531780",
      "nap_box_name": "389",
      "created_at": "2024-08-13T15:59:14.011675",
      "service_detail": {
        "id": 5007,
        "ip": "172.30.25.2",
        "mac": "GPON0097B076",
        "serial": "GPON0097B076",
        "queue": "Plan_162000_30183_WispHub",
        "interface": "VLAN243_BICENTENARIO",
        "created_at": "2024-08-13T16:59:06.202667",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6412,
      "client_name": "IEE ROSARIO DE PAYA",
      "client_type_name": "INTERCAMBIO",
      "client_subdivision": "ACTIVO_INTERCAMBIO",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Paya Abajo",
      "plan": {
        "id": 83,
        "name": "RECURRENTE INSTITUCIONAL 80M",
        "cost": "0.00",
        "code": "FO-R80",
        "profile": "80M/80M"
      },
      "client_mobile": "04128908269",
      "client_email": "IEEROSARIODEPAYA@GMAIL.COM",
      "address": "CALLE PRINCIPAL LOCAL S/N SECTOR ROSARIO DE PAYA",
      "client_identification": "G200058994",
      "nap_box_name": "406",
      "created_at": "2024-08-13T16:06:54.815962",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6413,
      "client_name": "KATHERINE SOLEDAD NIETO MELLADO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04122092481",
      "client_email": "Nietokatherine97@gmail.com",
      "address": "VDA1-10 CASA NRO 10 BARRIO SAMAN TARAZONERO II",
      "client_identification": "V24175107",
      "nap_box_name": "504",
      "created_at": "2024-08-14T09:15:33.424746",
      "service_detail": {
        "id": 11194,
        "ip": "172.21.26.2",
        "mac": "VSOL004989D9",
        "serial": "VSOL004989D9",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2026-01-16T09:20:07.299844",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6414,
      "client_name": "ZULAY JOSEFINA MOSQUEDA GUERRERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Betania",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124866931",
      "client_email": "GABRIELAMENDOZA321123@GMAIL.COM",
      "address": "AV PRINCIPAL CASA NRO 144 SECTOR COMUNIDAD BETANIA ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V6672036",
      "nap_box_name": "CTO-00376",
      "created_at": "2024-08-14T10:35:48.395555",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6415,
      "client_name": "FIDEL ANTONIO LASTRA ORTIZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Paya Abajo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243073817",
      "client_email": "F3ALASTRA17@GMAIL.COM",
      "address": "BARRIO PINTO SALINA, VEREDA 3, CASA 9, EL RECREO, ZONA POSTAL 1050",
      "client_identification": "V13441909",
      "nap_box_name": "272",
      "created_at": "2024-08-14T11:25:12.866450",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6416,
      "client_name": "HECTOR JOSE MARTINEZ VASQUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Valle Fresco",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121384660",
      "client_email": "HECTORJOSEMARTINEZVASQUEZ7@GMAIL.COM",
      "address": "CALLE MANZANA 1, CASA NRO 17, URB VALLE FRESCO, TURMERO",
      "client_identification": "V14319426",
      "nap_box_name": "CTO VALLE FRESCO",
      "created_at": "2024-08-14T11:39:10.750638",
      "service_detail": {
        "id": 13148,
        "ip": "172.31.81.2",
        "mac": "OE:MT:3C:62:28:62",
        "serial": "OEMT3C622862",
        "queue": null,
        "interface": "VLAN270_VALLE_FRESCO_OLT3",
        "created_at": "2026-10-11T14:00:05.163225",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6417,
      "client_name": "MARIBEL COROMOTO FLORES QUINTERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados I",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243540635",
      "client_email": "MARIBEL.36.FLORES@GMAIL.COM",
      "address": "CALLE 11, CASA 9, PRADOS DE PAYA I, PARCELA 11 Y 12, ROSARIO DE PAYA, ARAGUA",
      "client_identification": "V13749080",
      "nap_box_name": "CTO-00204 DOS",
      "created_at": "2024-08-14T11:48:57.230833",
      "service_detail": {
        "id": 5255,
        "ip": "172.31.82.2",
        "mac": "OEMT3C622806",
        "serial": "OEMT3C622806",
        "queue": "Plan_161903_30183_WispHub",
        "interface": "VLAN239_PRADOS1",
        "created_at": "2024-08-15T16:15:53.575485",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6418,
      "client_name": "JIHAN EXIOLI PEREZ ZALINAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Durpa",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243194085",
      "client_email": "MARYBIKETURMERO@GMAIL.COM",
      "address": "CALLE LIBERTAD, MANZANA 16, CASA NR 19, SECTOR DESARROLLO URBNISTICO, ROSARIO PAYA",
      "client_identification": "V32085318",
      "nap_box_name": "258",
      "created_at": "2024-08-14T11:55:59.452105",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6419,
      "client_name": "JOSE GREGORIO MOTA HERNANDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Las Rurales",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128412551",
      "client_email": "MOTAHERNANDE0@GMAIL.COM",
      "address": "CALLE MIRANDA, CASA NRO 1, SECTOR LAS RULARES, ROSARIO DE PAYA, ARAGUA, ZONA POSTAL 2115",
      "client_identification": "V20057692",
      "nap_box_name": "CE - 650",
      "created_at": "2024-08-14T12:02:38.837394",
      "service_detail": {
        "id": 10830,
        "ip": "172.31.84.2",
        "mac": "OEMT3C62267A",
        "serial": "OEMT3C62267A",
        "queue": null,
        "interface": "VLAN252_RURALES_PAYA",
        "created_at": "2025-12-20T17:01:39.618103",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6420,
      "client_name": "MARIA EUGENIA SOLIS PEDRA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Magdalena",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128813523",
      "client_email": "CV4420394@GMAIL.COM",
      "address": "CALLE 13 CASA NRO 22 URB LA MAGDALENA",
      "client_identification": "V13625614",
      "nap_box_name": "414",
      "created_at": "2024-08-14T12:45:09.728335",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6421,
      "client_name": "UE  GUSTAVO MORALES",
      "client_type_name": "INTERCAMBIO",
      "client_subdivision": "ACTIVO_INTERCAMBIO",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Paya Abajo",
      "plan": {
        "id": 83,
        "name": "RECURRENTE INSTITUCIONAL 80M",
        "cost": "0.00",
        "code": "FO-R80",
        "profile": "80M/80M"
      },
      "client_mobile": "04120450990",
      "client_email": "MIGUELAMORYPAZ@GMAIL.COM",
      "address": "CALLE PRINCIPAL LOCAL S/N SECTOR ROSARIO DE PAYA",
      "client_identification": "V10110897",
      "nap_box_name": "406",
      "created_at": "2024-08-14T14:35:10.368274",
      "service_detail": {
        "id": 7482,
        "ip": "172.30.21.2",
        "mac": "GPON0097FF66",
        "serial": "GPON0097FF66",
        "queue": "Plan_162000_30183_WispHub",
        "interface": "VLAN231_PAYABAJO",
        "created_at": "2024-12-17T10:49:09.439858",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6422,
      "client_name": "CEIN NEGRO PRIMERO PRIMERO",
      "client_type_name": "INTERCAMBIO",
      "client_subdivision": "ACTIVO_INTERCAMBIO",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 83,
        "name": "RECURRENTE INSTITUCIONAL 80M",
        "cost": "0.00",
        "code": "FO-R80",
        "profile": "80M/80M"
      },
      "client_mobile": "04243232063",
      "client_email": "ANAMAR140180@GMAIL.COM",
      "address": "CALLE CEDEÑO NUMERO 12 CASCO DE TURMERO",
      "client_identification": "V146650224",
      "nap_box_name": "CTO-00266",
      "created_at": "2024-08-14T14:46:17.746418",
      "service_detail": {
        "id": 5128,
        "ip": "172.30.12.2",
        "mac": "GPON0097F1B6",
        "serial": "GPON0097F1B6",
        "queue": "Plan_121695_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-08-14T17:33:18.384335",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6423,
      "client_name": "TELN TURMERO TURMERO",
      "client_type_name": "INTERCAMBIO",
      "client_subdivision": "ACTIVO_INTERCAMBIO",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 83,
        "name": "RECURRENTE INSTITUCIONAL 80M",
        "cost": "0.00",
        "code": "FO-R80",
        "profile": "80M/80M"
      },
      "client_mobile": "04144909758",
      "client_email": "ALEIDYSPEREZ05@GMAIL.COM",
      "address": "CALLE NEGRO PRIMERO SECTOR LA MONTAÑA TURMERO",
      "client_identification": "J405839147",
      "nap_box_name": "212",
      "created_at": "2024-08-14T15:03:27.160418",
      "service_detail": {
        "id": 10023,
        "ip": "172.30.13.2",
        "mac": "GPON0097BAE6",
        "serial": "GPON0097BAE6",
        "queue": null,
        "interface": "VLAN213_MONTANA_OLT1",
        "created_at": "2025-11-11T15:43:01.645628",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6424,
      "client_name": "CCA ARTURO SARCO VILLENA",
      "client_type_name": "INTERCAMBIO",
      "client_subdivision": "ACTIVO_INTERCAMBIO",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 83,
        "name": "RECURRENTE INSTITUCIONAL 80M",
        "cost": "0.00",
        "code": "FO-R80",
        "profile": "80M/80M"
      },
      "client_mobile": "02446610009",
      "client_email": "YURAIMABELLO91@GMAIL.COM",
      "address": "CALLE CAMILO TORRES CRUCE CON CALLE NEGRO PRIMERO CASCO DE TURMERO",
      "client_identification": "J412076493",
      "nap_box_name": "647",
      "created_at": "2024-08-14T15:11:05.248231",
      "service_detail": {
        "id": 5130,
        "ip": "172.30.14.2",
        "mac": "GPON0097BD56",
        "serial": "GPON0097BD56",
        "queue": "Plan_121695_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-08-14T17:36:25.000959",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6425,
      "client_name": "CAIDV MARIÑO IEE DEFICIENCIAS VISUALES",
      "client_type_name": "INTERCAMBIO",
      "client_subdivision": "ACTIVO_INTERCAMBIO",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 83,
        "name": "RECURRENTE INSTITUCIONAL 80M",
        "cost": "0.00",
        "code": "FO-R80",
        "profile": "80M/80M"
      },
      "client_mobile": "04243778600",
      "client_email": "CAIDNSM.17@GMAIL.COM",
      "address": "CALLE URDANETA CON PASAJE URDANTEA CASCO DE TURMERO",
      "client_identification": "G200026898",
      "nap_box_name": "25",
      "created_at": "2024-08-14T15:16:14.455231",
      "service_detail": {
        "id": 5131,
        "ip": "172.30.11.2",
        "mac": "GPON009800B6",
        "serial": "GPON009800B6",
        "queue": "Plan_121695_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-08-14T17:39:05.569000",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6426,
      "client_name": "UEE ESTADO MIRANDA MIRANDA",
      "client_type_name": "INTERCAMBIO",
      "client_subdivision": "ACTIVO_INTERCAMBIO",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 83,
        "name": "RECURRENTE INSTITUCIONAL 80M",
        "cost": "0.00",
        "code": "FO-R80",
        "profile": "80M/80M"
      },
      "client_mobile": "04125376563",
      "client_email": "YUBMARMARYUB@GMAIIL.COM",
      "address": "CALLE CARREÑO NORTE STR TURMERO SN",
      "client_identification": "J405958375",
      "nap_box_name": "649",
      "created_at": "2024-08-14T15:20:43.057422",
      "service_detail": {
        "id": 5132,
        "ip": "172.30.16.2",
        "mac": "GPON0097B2D6",
        "serial": "GPON0097B2D6",
        "queue": "Plan_121695_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-08-14T17:40:42.606479",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6427,
      "client_name": "OSCAR FRANCESCO PROSPERI CURZI",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144904352",
      "client_email": "OSCARPROSPERI@GMAIL.COM",
      "address": "CALLE MARIÑO RESIDENCIA SAGITARIO 94 PISO 5 APARTAMENTO 5A",
      "client_identification": "V8742339",
      "nap_box_name": "CTO-0560",
      "created_at": "2024-08-14T15:31:34.792003",
      "service_detail": {
        "id": 5829,
        "ip": "172.31.100.2",
        "mac": "OEMT3C6224EA",
        "serial": "OEMT3C6224EA",
        "queue": "Plan_153953_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-08-20T11:17:42.844974",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6428,
      "client_name": "LICEO NACIONAL ESTADO MIRANDA",
      "client_type_name": "INTERCAMBIO",
      "client_subdivision": "ACTIVO_INTERCAMBIO",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 83,
        "name": "RECURRENTE INSTITUCIONAL 80M",
        "cost": "0.00",
        "code": "FO-R80",
        "profile": "80M/80M"
      },
      "client_mobile": "04124452576",
      "client_email": "LICEONESTADOMIRANDA@GMAIL.COM",
      "address": "CALLE CARREÑO NORTE STR TURMERO SN",
      "client_identification": "J406059960",
      "nap_box_name": "649",
      "created_at": "2024-08-14T15:40:30.737874",
      "service_detail": {
        "id": 5133,
        "ip": "172.30.15.2",
        "mac": "GPON0097FC16",
        "serial": "GPON0097FC16",
        "queue": "Plan_121695_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-08-14T17:42:11.591498",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6429,
      "client_name": "HENYERBER JOSE ARRIECHE SUAREZ",
      "client_type_name": "EMPLEADO",
      "client_subdivision": "CANCELADO_EMPLEADO",
      "status_name": "Cancelado",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 78,
        "name": "Plan empleado 80MB",
        "cost": "0.00",
        "code": "FO-80M",
        "profile": "80M/80M"
      },
      "client_mobile": "04121394529",
      "client_email": "HENYELBERTH.A@GMAIL.COM",
      "address": "CALLE MANZANA 13 CASA NRO URB SAMAN TARAZONERO 2 TURMERO ARAGUA ZONA POSTAL 2107",
      "client_identification": "V24446560",
      "nap_box_name": "CTO-00064",
      "created_at": "2024-08-14T15:46:57.423015",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6430,
      "client_name": "ANGELO CERVANTES MONTILLA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121598463",
      "client_email": "CENTRODEIMPRESIONESTURMERO@GMAIL.COM",
      "address": "EDIFICIO: TORRE 6 EZEQUIEL ZAMORA, PISO: 2 , DEPARTAMENTO: 2-3",
      "client_identification": "V23528894",
      "nap_box_name": "CTO-00032",
      "created_at": "2024-08-15T10:52:18.535166",
      "service_detail": {
        "id": 5350,
        "ip": "172.31.85.2",
        "mac": "OEMT3C622C7A",
        "serial": "OEMT3C622C7A",
        "queue": "Plan_153953_15811_WispHub",
        "interface": "VLAN209_ZAMORA_OLT1",
        "created_at": "2024-08-16T10:34:10.057943",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6431,
      "client_name": "ANGEL CRISTOBAL GARCIA MAGALLANES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "1ro de Mayo Norte",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121461721",
      "client_email": "GARCIAYAIRETH1204@GMAIL.COM",
      "address": "1ERO DE MAYO NORTE CALLE GUAICAPURO N8 PAYA",
      "client_identification": "V12139275",
      "nap_box_name": "CTO-00383",
      "created_at": "2024-08-15T11:28:17.176166",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6432,
      "client_name": "MYRIAN MIREYA PANZA MARQUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Marina Caribe",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04242192263",
      "client_email": "MYRABBY0301@GMAIL.COM",
      "address": "CALLE SANTOS MICHELENA EDIF VENARAGUA TORRE 3 PISO 3 APT 1-D URB CENTRO MARACAY EDO ARAGUA ZONA POSTAL 2101",
      "client_identification": "V5735717",
      "nap_box_name": "CTO-00285",
      "created_at": "2024-08-15T11:40:40.591962",
      "service_detail": {
        "id": 5989,
        "ip": "172.31.86.2",
        "mac": "OEMT3C6223EA",
        "serial": "OEMT3C6223EA",
        "queue": "Plan_153953_15811_WispHub",
        "interface": "VLAN259_LA_ORQUIDEA",
        "created_at": "2024-08-21T17:06:20.624519",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6434,
      "client_name": "LENYN DE JESUS COLON AREVALO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Callejon Los Mamones",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128855861",
      "client_email": "LENYN80COLON@GMAIL.COM",
      "address": "AV PRINCIPAL CRUCE CALLEJON LOS MAMONES TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V14741983",
      "nap_box_name": "CTO-00187",
      "created_at": "2024-08-15T15:32:23.978607",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6435,
      "client_name": "ESTHER JOSEFINA PONCE DE TEJADA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "SUSPENDIDO_RESIDENCIAL",
      "status_name": "Suspendido",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Durpa",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04224201099",
      "client_email": "ESTHERPONCEDURPA@GMAIL.COM",
      "address": "CALLE LEALTAD MANZANA 21 CASA NRO 16 SECTOR DESARROLLO URBANISTICO DURPA",
      "client_identification": "V12139757",
      "nap_box_name": "CTO-00320",
      "created_at": "2024-08-15T17:12:42.312551",
      "service_detail": {
        "id": 5278,
        "ip": "172.17.213.2",
        "mac": "VSOL00523D29",
        "serial": "VSOL00523D29",
        "queue": "Plan_161891_30183_WispHub",
        "interface": "VLAN240_DURPA",
        "created_at": "2024-08-15T17:14:39.888557",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6436,
      "client_name": "JOSE ANTONIO PAPA MORA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Narayola II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04265330314",
      "client_email": "JOSEPAPAMORA1@HOTMAIL.COM",
      "address": "NARAYOLA II",
      "client_identification": "V12853396",
      "nap_box_name": "629",
      "created_at": "2024-08-16T10:05:39.484495",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6437,
      "client_name": "ANNERYS DE LOS ANGELES CUBILLAN BRITO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "1ro de Mayo Norte",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121486736",
      "client_email": "ANNERYSDEGRANADILLO05@GMAIL.COM",
      "address": "CALLE TIUNA, CASA N° 14, SECTOR PRIMERO DE MAYO NORTE, PAYA",
      "client_identification": "V24930434",
      "nap_box_name": "CTO - 919",
      "created_at": "2024-08-16T10:13:05.199007",
      "service_detail": {
        "id": 6557,
        "ip": "172.31.89.2",
        "mac": "HWTC22B92B86",
        "serial": "HWTC22B92B86",
        "queue": "Plan_161905_30183_WispHub",
        "interface": "VLAN261_1ERO_MAYO_ZTE",
        "created_at": "2024-09-05T15:30:37.998864",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6439,
      "client_name": "MARIELA CELESTINA FLORES VALOR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Sector los Mangos",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04129286100",
      "client_email": "MARIELAFVALOR4@GMAIL.COM",
      "address": "CALLE LAS TUNAS, CASA NRO 1, SECTOR LOS MANGOS, PAYA",
      "client_identification": "V12679992",
      "nap_box_name": "614",
      "created_at": "2024-08-16T10:40:25.853814",
      "service_detail": {
        "id": 10825,
        "ip": "172.31.90.2",
        "mac": "OEMT3C623202",
        "serial": "OEMT3C623202",
        "queue": null,
        "interface": "VLAN267_LOS_MANGOS_ZTE",
        "created_at": "2025-12-20T10:17:39.245813",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6440,
      "client_name": "HERIKA DE JESUS ZERPA HIGUERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados III",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04244261881",
      "client_email": "HERIKAZERPA16@GMAIL.COM",
      "address": "PRADO DE PAYA 3, CALLE 4, CASA NRO 32, PAYA",
      "client_identification": "V19175187",
      "nap_box_name": "CTO-00299",
      "created_at": "2024-08-16T10:46:52.977610",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6441,
      "client_name": "FRANYELIS DEL VALLE MARCANO VILLARROEL",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Julia",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243283365",
      "client_email": "FRANYELISMARCANO7@GMAIL.COM",
      "address": "AV 101, CASA 01, SECTOR LA JULIA, TURMERO",
      "client_identification": "V20537519",
      "nap_box_name": "cto la julia",
      "created_at": "2024-08-16T10:57:01.170538",
      "service_detail": {
        "id": 11647,
        "ip": "172.31.92.2",
        "mac": "OEMT3C622A52",
        "serial": "OEMT3C622A52",
        "queue": null,
        "interface": "VLAN138_LAJULIA",
        "created_at": "2026-02-17T16:21:29.949397",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6442,
      "client_name": "MARIA YUSMAIRA CORDOVA LARA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados III",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128153186",
      "client_email": "YMCL0102@GMAIL.COM",
      "address": "CALLE 3, CASA N° 25, PRADO 3, PAYA",
      "client_identification": "V19834670",
      "nap_box_name": "579",
      "created_at": "2024-08-16T11:53:56.219320",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6443,
      "client_name": "JUAN LUIS QUIROZ GOITIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero I",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124525583",
      "client_email": "JUANQUIROZ1991@GMAIL.COM",
      "address": "CALLE NUMERO 6 CASA NRO 05 BARRIO SAMAN TARAZONERO I TURMERO",
      "client_identification": "V20818058",
      "nap_box_name": "270",
      "created_at": "2024-08-16T14:24:06.816544",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6444,
      "client_name": "EDIXON JOSE MARTINEZ ARAUJO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243785559",
      "client_email": "CLIVERGUEVARA50@GMAIL.COM",
      "address": "MATA CABALLO CALLE 9 585-A",
      "client_identification": "V26557187",
      "nap_box_name": "CE - 566",
      "created_at": "2024-08-16T15:21:34.323959",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6446,
      "client_name": "FRANCISCO FERNANDO GONZALEZ VASQUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "San Pablo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04122482550",
      "client_email": "GUREPOSTA@GMAIL.COM",
      "address": "AV. PRINCIPAL, CASA NRO. 14, SAN PABLO, TURMERO",
      "client_identification": "V14390101",
      "nap_box_name": "CTO-0637",
      "created_at": "2024-08-17T09:25:53.334606",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6447,
      "client_name": "DIURKA DEL CARMEN RODRIGUEZ SANCHEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Bicentenario",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243618457",
      "client_email": "RODRIGUEZDIURKA1@GMAIL.COM",
      "address": "CALLE LOS ROBLES, MANZANA N#12, CASA N#9, PLANTA BAJA, SECTOR BICENTENARIO, FUNDA BARRIOS, ROSARIO DE PAYA",
      "client_identification": "V18552638",
      "nap_box_name": "CTO-00453",
      "created_at": "2024-08-17T09:53:25.838572",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6448,
      "client_name": "DANIS JOSE HERRERA MARIN",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04125974053",
      "client_email": "DANISHERRERA53@GMAIL.COM",
      "address": "CALLE CARREÑO EDIF 6 PISO 3 APT 2 URB LOS NISPEROS TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V25501507",
      "nap_box_name": "CTO-00464",
      "created_at": "2024-08-17T09:55:58.834456",
      "service_detail": {
        "id": 5601,
        "ip": "172.27.171.2",
        "mac": "HWTCC1B9B39C",
        "serial": "HWTCC1B9B39C",
        "queue": "Plan_143066_15811_WispHub",
        "interface": "VLAN209_ZAMORA_OLT1",
        "created_at": "2024-08-17T10:03:05.087998",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6449,
      "client_name": "RICHARD JOSE BARRIOS PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04265112723",
      "client_email": "RBARRIOS7180@GMAIL.COM",
      "address": "CASCO DE TURMERO, CALLE BERMÚDEZ, CASA 64-A, SECTOR LA ADUANA TURMERO ARAGUA, ZONA POSTAL 2115",
      "client_identification": "V13769490",
      "nap_box_name": "CTO - 939",
      "created_at": "2024-08-17T10:18:59.017466",
      "service_detail": {
        "id": 12421,
        "ip": "172.23.22.2",
        "mac": "OEMT3C625A06",
        "serial": "OEMT3C625A06",
        "queue": null,
        "interface": "VLAN200_OLTs",
        "created_at": "2026-04-27T16:45:54.778570",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6450,
      "client_name": "ABIGAIL ESTEFANIA MONTENEGRO ROJAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04122051839",
      "client_email": "YOUSEPTM@GMAIL.COM",
      "address": "CALLE 12 CASA 672 SECTOR ROSARIO DE PAYA TURMERO",
      "client_identification": "V29930562",
      "nap_box_name": "CTO-0167",
      "created_at": "2024-08-17T11:21:13.410366",
      "service_detail": {
        "id": 12403,
        "ip": "172.29.14.2",
        "mac": "OEMT3C625636",
        "serial": "OEMT3C625636",
        "queue": null,
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2026-04-23T18:22:08.058615",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6451,
      "client_name": "LLINES MARGARITA RAMIREZ ULLOA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Canaima",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243207828",
      "client_email": "YINETHSRAMIREZ@GMAIL.COM",
      "address": "CALLE 3 CASA NRO 33 SECTOR CANAIMA ROSARIO DE PAYA",
      "client_identification": "V12929998",
      "nap_box_name": "355",
      "created_at": "2024-08-17T13:19:58.637783",
      "service_detail": {
        "id": 5826,
        "ip": "172.31.102.2",
        "mac": "OEMT3C62254E",
        "serial": "OEMT3C62254E",
        "queue": "Plan_161905_30183_WispHub",
        "interface": "VLAN237_CANAIMA",
        "created_at": "2024-08-20T10:18:02.169274",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6452,
      "client_name": "NOEMIA DE GOUVEIA DE SOUSA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04243153690",
      "client_email": "NOEMIADEGOUVEIA@GMAIL.COM",
      "address": "CALLE RIVAS EDIF MARIÑO PISO 2 APT 10 SECTOR CENTRO TURMERO",
      "client_identification": "V12167371",
      "nap_box_name": "CTO-00502",
      "created_at": "2024-08-17T14:29:13.580170",
      "service_detail": {
        "id": 5678,
        "ip": "172.19.235.2",
        "mac": "TPLGBA687487",
        "serial": "TPLGBA687487",
        "queue": "Plan_112654_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-08-17T14:31:09.272808",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6453,
      "client_name": "FLOR MARIA LOPEZ AGUIRRE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Arboleda",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128992573",
      "client_email": "FLORMARIALOPEZ123456@GMAIL.COM",
      "address": "CALLE VÍA PRINCIPAL CASA NRO 53-1 SECTOR LA ARBOLEDA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V10459326",
      "nap_box_name": "CTO-00154",
      "created_at": "2024-08-17T17:57:48.010900",
      "service_detail": {
        "id": 5690,
        "ip": "172.17.159.2",
        "mac": "HWTC116E4385",
        "serial": "HWTC116E4385",
        "queue": "Plan_161905_30183_WispHub",
        "interface": "VLAN257_ARBOLEDA",
        "created_at": "2024-08-17T19:24:35.182597",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6454,
      "client_name": "YENNIFER ELIZABETH GONZALEZ SANCHEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04248364212",
      "client_email": "YENNIFERELIZABETHGONZALEZSANCH@GMAIL.COM",
      "address": "CALLE 3 CASA NRO 09 ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V24297344",
      "nap_box_name": "CTO-00385",
      "created_at": "2024-08-19T09:13:13.922722",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6455,
      "client_name": "EDIMAR JOSEFA INFANTE MEDINA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "1ro de Mayo Norte",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04241732885",
      "client_email": "INFANTEEDIMAR@GMAIL.COM",
      "address": "PAYA 1ERO DE MAYO NORTE CALLE PARAMACONI NRO 39 CALLE 6 MATA CABALLO ROSARIO DE PAYA",
      "client_identification": "V18509015",
      "nap_box_name": "CTO-00235",
      "created_at": "2024-08-19T10:05:45.048047",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6456,
      "client_name": "ROSANGELA PEREZ MONTERREY",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vista Hermosa",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04125099848",
      "client_email": "GIOLI280@HOTMAIL.COM",
      "address": "SECTOR VISTA HERMOSA, AV LAS MANDARINAS, CASA #90, TURMERO, PAYA",
      "client_identification": "V14851280",
      "nap_box_name": "CTO-00060 DOS",
      "created_at": "2024-08-19T10:07:45.155681",
      "service_detail": {
        "id": 11581,
        "ip": "172.31.104.2",
        "mac": "OEMT3C62240E",
        "serial": "OEMT3C62240E",
        "queue": null,
        "interface": "VLAN230_VISTA_HERMOSA",
        "created_at": "2026-02-10T15:56:58.888056",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6457,
      "client_name": "BARBARA DE LOS ANGELES SANCHEZ ROMERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Durpa",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243150432",
      "client_email": "DORKA1BARBARA@GMAIL.COM",
      "address": "CALLE SIMON RODRIGUEZ, CASA N 11 SECTOR DURPA",
      "client_identification": "V31284091",
      "nap_box_name": "CTO-00453",
      "created_at": "2024-08-19T10:11:25.066482",
      "service_detail": {
        "id": 5804,
        "ip": "172.31.99.2",
        "mac": "OEMT3C62254A",
        "serial": "OEMT3C62254A",
        "queue": "Plan_161905_30183_WispHub",
        "interface": "VLAN240_DURPA",
        "created_at": "2024-08-19T21:09:05.758473",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6458,
      "client_name": "YARITZA REYES ALEMAN",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Valle Verde",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04127763485",
      "client_email": "YARITZAREYESALEMAN@GMAIL.COM",
      "address": "CALLE LOS MANGOS, PARCELA NRO 7-3, SECTOR VALLE VERDE, ROSARIO DE PAYA",
      "client_identification": "V14319170",
      "nap_box_name": "CTO-00187",
      "created_at": "2024-08-19T10:16:16.983204",
      "service_detail": {
        "id": 12136,
        "ip": "172.31.113.2",
        "mac": "HWTC48080015",
        "serial": "HWTC48080015",
        "queue": null,
        "interface": "VLAN243_BICENTENARIO",
        "created_at": "2026-03-18T20:12:48.236678",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6459,
      "client_name": "MIRIAN GREGORIA BRAVO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243551183",
      "client_email": "MIRIANBRAVO18@GMAIL.COM",
      "address": "CALLE 9, CASA NRO 596-C, URB MATA CABALLO, PAYA",
      "client_identification": "V12927792",
      "nap_box_name": "160",
      "created_at": "2024-08-19T10:30:13.851297",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6460,
      "client_name": "SHINDERLY ORVERLIS REYES RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04127228918",
      "client_email": "LISSANGIESINAIS285@GMAIL.COM",
      "address": "CALLE 17-A, CASA NRO 12, SECTOR PANTIN, ROSARIO DE PAYA, ARAGUA",
      "client_identification": "V25066154",
      "nap_box_name": "CTO-00101",
      "created_at": "2024-08-19T10:46:22.063707",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6461,
      "client_name": "YELITZA TIBISAY MARTINEZ MARTINEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 43,
        "name": "RECURRENTE RESIDENCIAL PLAN 650M",
        "cost": "46.00",
        "code": "FOR650M",
        "profile": "650M/650M"
      },
      "client_mobile": "04243026686",
      "client_email": "YELIED88@GMAIL.COM",
      "address": "CALLE 7, CASA NRO 546-B, URB MATA CABALLO, PAYA",
      "client_identification": "V15129152",
      "nap_box_name": "CTO-00215",
      "created_at": "2024-08-19T10:52:52.277908",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6462,
      "client_name": "FRANCISCO FERNANDO GONZALEZ VASQUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "San Pablo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04122482550",
      "client_email": "GUREPOSTA@GMAIL.COM",
      "address": "1RA. AV. ESTE NRO. 16-A. SAN PABLO. TURMERO",
      "client_identification": "V14390101",
      "nap_box_name": "CTO-00577 DOS",
      "created_at": "2024-08-19T11:14:42.502258",
      "service_detail": {
        "id": 13138,
        "ip": "172.31.94.2",
        "mac": "OE:MT:3C:62:23:02",
        "serial": "OEMT3C622302",
        "queue": null,
        "interface": "VLAN224_SAN_PABLO_OLT1",
        "created_at": "2026-10-08T16:27:03.825935",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6463,
      "client_name": "MARIA MAGDALENA BEJARANO DE GIL",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados de Cafetal",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04160457024",
      "client_email": "GBMMAGDALENA@GMAIL.COM",
      "address": "CALLE 1 CASA NRO 3 SECTOR PRADOS DE CAFETAL TURMERO",
      "client_identification": "V12145679",
      "nap_box_name": "544",
      "created_at": "2024-08-19T13:59:22.606397",
      "service_detail": {
        "id": 5738,
        "ip": "172.19.175.2",
        "mac": "TPLGB954FD81",
        "serial": "TPLGB954FD81",
        "queue": "Plan_116775_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-08-19T14:00:56.264217",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6464,
      "client_name": "RAYMARI JOSEFINA PENA MARTINEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Valle lindo",
      "plan": {
        "id": 16,
        "name": "RECURRENTE RESIDENCIAL PLAN 800M",
        "cost": "55.00",
        "code": "FOR800",
        "profile": "800M/800M"
      },
      "client_mobile": "04243751079",
      "client_email": "RAYMARI.PENA@HOTMAIL.COM",
      "address": "CALLE 4 CASA NRO 16 URB VALLE LINDO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V16269190",
      "nap_box_name": "110",
      "created_at": "2024-08-19T16:54:26.488640",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6466,
      "client_name": "IVONNE ELIZABETH MERCHAN SORIN",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04163509820",
      "client_email": "IVONNEMERCHAN777@GMAIL.COM",
      "address": "CALLE RIVAS EDIFICIO MARIÑO PB - CONSERJERIA - TURMERO",
      "client_identification": "V29846761",
      "nap_box_name": "CTO-00502",
      "created_at": "2024-08-20T08:31:28.552423",
      "service_detail": {
        "id": 6160,
        "ip": "172.31.106.2",
        "mac": "OEMT3C62285A",
        "serial": "OEMT3C62285A",
        "queue": "Plan_139897_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-08-22T17:50:46.739414",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6467,
      "client_name": "FRANCIS COROMOTO PAREDES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04142163584",
      "client_email": "Franpar527@gmail.com",
      "address": "CALLE 13 CASA NRO 216 URB LA CASONA II TURMERO ARAGUA",
      "client_identification": "V10819819",
      "nap_box_name": "CTO-00091",
      "created_at": "2024-08-20T15:14:24.232419",
      "service_detail": {
        "id": 6934,
        "ip": "172.25.75.2",
        "mac": "TPLGB76566CF",
        "serial": "TPLGB76566CF",
        "queue": "Plan_148293_24341_WispHub",
        "interface": "VLAN110_CASONA_2",
        "created_at": "2024-10-30T09:52:14.556196",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6468,
      "client_name": "LUIS ALVARADO MALDONADO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121486889",
      "client_email": "YOGLENNYMILANO@GMAIL.COM",
      "address": "RIO SECO CALLE 3 CASA # 30",
      "client_identification": "V18702885",
      "nap_box_name": "CE - 610",
      "created_at": "2024-08-20T15:19:56.577474",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6469,
      "client_name": "JOSE ROGELIO AYALA VALERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Brisas de Paya",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121485373",
      "client_email": "JOXYMILAGROSRODRIGUEZBRACAMONT@GMAIL.COM",
      "address": "BRISAS DE PAYA CALLE 1 CASA NRO 30, ROSARIO DE PAYA",
      "client_identification": "V15865469",
      "nap_box_name": "369",
      "created_at": "2024-08-20T15:46:54.650702",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6470,
      "client_name": "JAKELINE CRISTINA ROSALES OCANDO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "SUSPENDIDO_RESIDENCIAL",
      "status_name": "Suspendido",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Arturo Luis Berti",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04127573545",
      "client_email": "JAKELINROSA@HOTMAIL.COM",
      "address": "CALLE 3 CASA # 414 URB ARTURO LUIS BERTI TURMERO ESTADO ARAGUA",
      "client_identification": "V5591667",
      "nap_box_name": "65",
      "created_at": "2024-08-20T15:49:21.082248",
      "service_detail": {
        "id": 12322,
        "ip": "172.31.108.2",
        "mac": "OEMT3C6222EA",
        "serial": "OEMT3C6222EA",
        "queue": null,
        "interface": "VLAN102_ARTURO_BERTI",
        "created_at": "2026-04-16T11:12:39.520145",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6471,
      "client_name": "WILLIAM GABRIEL SUAREZ MONTES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04122996971",
      "client_email": "GABOWSM@GMAIL.COM",
      "address": "MANZANA F1 CASA # 8 BARRIO SAMAN TARAZONERO 2 TURMERO ESTADO ARAGUA",
      "client_identification": "V20244506",
      "nap_box_name": "162",
      "created_at": "2024-08-20T16:02:00.773418",
      "service_detail": {
        "id": 6032,
        "ip": "172.31.109.2",
        "mac": "OEMT3C622F6E",
        "serial": "OEMT3C622F6E",
        "queue": "Plan_137413_1574_WispHub",
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2024-08-22T10:01:27.480375",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6472,
      "client_name": "YEISI YOJANI VASQUEZ CASTILLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Durpa",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04123498745",
      "client_email": "YEISIYOHANIVASQUEZCASTILLO@GMAIL.COM",
      "address": "CALLE LOS ROBLES MANZANA 12 CASA # 4 FUNDA BARRIO ROSARIO DE PAYA",
      "client_identification": "V26535908",
      "nap_box_name": "CTO-00445",
      "created_at": "2024-08-20T16:08:36.342008",
      "service_detail": {
        "id": 12306,
        "ip": "172.31.110.2",
        "mac": "OEMT3C6228E6",
        "serial": "OEMT3C6228E6",
        "queue": null,
        "interface": "VLAN240_DURPA",
        "created_at": "2026-04-11T19:41:46.950135",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6473,
      "client_name": "JENNY ELIZABETH BORGES MORENO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243634977",
      "client_email": "JENNY41MORENO@GMAIL.COM",
      "address": "CALLE 3 CASA # 175 SECTOR MATACABALLO ROSARIO DE PAYA TURMERO ESTADO ARAGUA",
      "client_identification": "V14730132",
      "nap_box_name": "CTO-00422",
      "created_at": "2024-08-20T16:14:26.897630",
      "service_detail": {
        "id": 6323,
        "ip": "172.31.111.2",
        "mac": "OEMT3C62255A",
        "serial": "OEMT3C62255A",
        "queue": "Plan_161905_30183_WispHub",
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2024-08-23T19:36:57.913437",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6474,
      "client_name": "KAREN ANDREINA APARICIO MEDINA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04125129356",
      "client_email": "NUEVOCRISTIANO2009@GMAIL.COM",
      "address": "CALLE 6 CASA NRO 32 URB SAMAN TARAZONERO SUR TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V20684470",
      "nap_box_name": "45",
      "created_at": "2024-08-20T16:24:51.531240",
      "service_detail": {
        "id": 6392,
        "ip": "172.29.2.2",
        "mac": "VSOL0012D201",
        "serial": "VSOL0012D201",
        "queue": "Plan_148293_24341_WispHub",
        "interface": "VLAN109_CASONA_1",
        "created_at": "2024-08-27T14:59:42.936580",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6476,
      "client_name": "GENESIS YELIANA PACHECO SOLANO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero I",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124165068",
      "client_email": "GENESISP231@GMAIL.COM",
      "address": "CALLE 3 CASA # 39 BARRIO SAMAN TARAZONERO 1 TURMERO ESTADO ARAGUA",
      "client_identification": "V22285169",
      "nap_box_name": "32",
      "created_at": "2024-08-20T16:32:01.227658",
      "service_detail": {
        "id": 5866,
        "ip": "172.30.109.2",
        "mac": "HWTC331E0FA1",
        "serial": "HWTC331E0FA1",
        "queue": "Plan_137413_1574_WispHub",
        "interface": "VLAN140_SMT1",
        "created_at": "2024-08-20T16:36:08.167073",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6477,
      "client_name": "EVA DEL CARMEN BRACAMONTE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121459735",
      "client_email": "EVABRACAMONTE9@GMAIL.COM",
      "address": "CALLE 01 CASA NRO 04 SECTOR PRADOS II ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V5793773",
      "nap_box_name": "CTO-00118 DOS",
      "created_at": "2024-08-20T16:54:51.712849",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6478,
      "client_name": "MARIA ENCARNACION GONZALEZ RIVAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vallecito",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121790436",
      "client_email": "FEMARNELLY@GMAIL.COM",
      "address": "CALLE LAS PALMAS CASA NRO 2 SECTOR VALLECITO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V15129924",
      "nap_box_name": "CTO - 106",
      "created_at": "2024-08-21T09:59:45.660557",
      "service_detail": {
        "id": 5885,
        "ip": "172.17.99.2",
        "mac": "OEMT3C625D7E",
        "serial": "OEMT3C625D7E",
        "queue": "Plan_161895_30183_WispHub",
        "interface": "VLAN258_VALLECITO",
        "created_at": "2024-08-21T10:00:55.486486",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6479,
      "client_name": "IRIS DEL ROSARIO GONZALEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados III",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124574852",
      "client_email": "IRISG8706@GMAIL.COM",
      "address": "CALLE NEGRO PRIMERO CASA NRO 181 BARRIO 23 DE ENERO MARACAY ARAGUA",
      "client_identification": "V7215137",
      "nap_box_name": "CTO-00299",
      "created_at": "2024-08-21T10:06:47.990899",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6481,
      "client_name": "MANUEL ADELINO DE SOUSA ACEVEDO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243620382",
      "client_email": "YUSME070286@GMAIL.COM",
      "address": "CALLE RIVAS EDF TORRE 2 PISO 8 APT 82 CONJUNTO RESIDENCIAL CANDY TURMERO",
      "client_identification": "V18262584",
      "nap_box_name": "CTO-00215",
      "created_at": "2024-08-21T11:05:38.755647",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6482,
      "client_name": "YELITZA NORALYS RAMOS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243670134",
      "client_email": "RAMOSYELITZA403@GMAIL.COM",
      "address": "CALLE N#11 CASA NRO 641-D MATA CABALLO, PAYA",
      "client_identification": "V15532393",
      "nap_box_name": "CTO-00213",
      "created_at": "2024-08-21T12:06:27.729483",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6483,
      "client_name": "HENRY JOSE GONZALEZ DAVILA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243333856",
      "client_email": "HDAVILA1968@GMAIL.COM",
      "address": "CALLE 15, CASA 10, SECTOR RIO SECO, PAYA",
      "client_identification": "V9655147",
      "nap_box_name": "CTO-00147",
      "created_at": "2024-08-21T14:12:45.307680",
      "service_detail": {
        "id": 5995,
        "ip": "172.31.60.2",
        "mac": "OEMT3C622FA2",
        "serial": "OEMT3C622FA2",
        "queue": "Plan_161905_30183_WispHub",
        "interface": "VLAN251_RIO_SECO",
        "created_at": "2024-08-22T07:53:25.196873",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6484,
      "client_name": "YASNELIS COSMELINA VELASQUEZ LEZAMA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Durpa",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243376561",
      "client_email": "YASNELISVELASQUEZ@GMAIL.COM",
      "address": "CALLE 01 CASA NRO 01 URB PRADOS DE PAYA I ROSARIO DE PAYA ARAGUA",
      "client_identification": "V12556266",
      "nap_box_name": "585",
      "created_at": "2024-08-21T15:22:40.781868",
      "service_detail": {
        "id": 8823,
        "ip": "172.17.148.2",
        "mac": "VSOL00521411",
        "serial": "VSOL00521411",
        "queue": "queue1",
        "interface": "VLAN239_PRADOS1",
        "created_at": "2025-06-03T12:03:29.026682",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6485,
      "client_name": "LEILA COROMOTO EL ATRACHE NAVAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Laguna Plaza",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04144520163",
      "client_email": "CATA01706@GMAIL.COM",
      "address": "CALLE NEGRO PRIMERO EDIF 1 PISO PB APT PB-02 CONJUNTO RESIDENCIAL LAGUNA PLAZA",
      "client_identification": "V8632417",
      "nap_box_name": "4",
      "created_at": "2024-08-21T16:12:57.749310",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6486,
      "client_name": "JOAO MANUEL BAPTISTA HERNANDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "SUSPENDIDO_RESIDENCIAL",
      "status_name": "Suspendido",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04141449323",
      "client_email": "BARAKAAGRO14@GMAIL.COM",
      "address": "CALLE BOLIVAR CON CAMILO TORRES",
      "client_identification": "V14627596",
      "nap_box_name": "CE-00009",
      "created_at": "2024-08-22T09:15:00.596792",
      "service_detail": {
        "id": 6021,
        "ip": "172.24.166.2",
        "mac": "TPLGB446E884",
        "serial": "TPLGB446E884",
        "queue": "queue1",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-08-22T09:21:00.102057",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6487,
      "client_name": "YEFERSON YOSUE SIERRA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04129628925",
      "client_email": "EGLY00249@GMAIL.COM",
      "address": "CALLE 11 CASA NRO 15 BARRIO SAMAN TARAZONERO 1 TURMERO ARAGUA",
      "client_identification": "V21269616",
      "nap_box_name": "CTO-00147",
      "created_at": "2024-08-22T10:24:00.854883",
      "service_detail": {
        "id": 6231,
        "ip": "172.31.117.2",
        "mac": "OEMT3C62277A",
        "serial": "OEMT3C62277A",
        "queue": "Plan_161905_30183_WispHub",
        "interface": "VLAN251_RIO_SECO",
        "created_at": "2024-08-23T11:46:48.433344",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6489,
      "client_name": "DAISI FRABCELYS VILLEGAS AGUILAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "1ro de Mayo Norte",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04267422664",
      "client_email": "DAISI86VILLEGA19@GMAIL.COM",
      "address": "1ERO DE MAYO NORTE, CALLE CHACAO, CASA #08, PAYA",
      "client_identification": "V19181825",
      "nap_box_name": "CTO - 900",
      "created_at": "2024-08-22T13:14:58.613242",
      "service_detail": {
        "id": 6244,
        "ip": "172.31.119.2",
        "mac": "OEMT3C62105E",
        "serial": "OEMT3C62105E",
        "queue": "Plan_161895_30183_WispHub",
        "interface": "VLAN261_1ERO_MAYO_ZTE",
        "created_at": "2024-08-23T13:01:09.525285",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6491,
      "client_name": "KATIUSKA JACQUELINE RIVERA VARGAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Luz y Vida",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121474773",
      "client_email": "JACQUELINEVARGAS019@GMAIL.COM",
      "address": "LUZ Y VIDA CALLE 2 CASA N 90 PAYA",
      "client_identification": "V16405662",
      "nap_box_name": "CE - 745",
      "created_at": "2024-08-22T14:08:03.902578",
      "service_detail": {
        "id": 9831,
        "ip": "172.31.160.2",
        "mac": "OEMT3C6244BA",
        "serial": "OEMT3C6244BA",
        "queue": null,
        "interface": "VLAN237_CANAIMA",
        "created_at": "2025-11-10T17:24:34.900112",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6492,
      "client_name": "INGRID JOANA CARDENAS MORENO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Callejon Lim",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144757282",
      "client_email": "INGRIDJCARDENASM@GMAIL.COM",
      "address": "AV PPAL ROSARIO DE PAYA CALLEJON LIM URB VILLAS DE TURMERO TORRE VIOLETA PISO 2 APTTO 10 TURMERO ARAGUA ZONA POSTAL",
      "client_identification": "V14830399",
      "nap_box_name": "CTO-0562",
      "created_at": "2024-08-22T14:20:16.935287",
      "service_detail": {
        "id": 8846,
        "ip": "172.25.98.2",
        "mac": "GPON0097CFF6",
        "serial": "GPON0097CFF6",
        "queue": "queue1",
        "interface": "VLAN250_LIM_OLT2",
        "created_at": "2025-06-05T10:52:15.189074",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6493,
      "client_name": "NUCLEO DE ATENCION PRIMARIA",
      "client_type_name": "INTERCAMBIO",
      "client_subdivision": "ACTIVO_INTERCAMBIO",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 83,
        "name": "RECURRENTE INSTITUCIONAL 80M",
        "cost": "0.00",
        "code": "FO-R80",
        "profile": "80M/80M"
      },
      "client_mobile": "04243446040",
      "client_email": "LILIAMONTES246@GMAIL.COM",
      "address": "CALLE NRO 2 MATACABALLO",
      "client_identification": "V7176915",
      "nap_box_name": "455",
      "created_at": "2024-08-22T14:25:57.733439",
      "service_detail": {
        "id": 6198,
        "ip": "172.21.9.2",
        "mac": "TPLGB446F321",
        "serial": "TPLGB446F321",
        "queue": "Plan_162000_30183_WispHub",
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2024-08-23T08:14:09.470600",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6494,
      "client_name": "CDI ADUANA DR GILBERTO RODRIGUEZ OCHOA",
      "client_type_name": "INTERCAMBIO",
      "client_subdivision": "ACTIVO_INTERCAMBIO",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 83,
        "name": "RECURRENTE INSTITUCIONAL 80M",
        "cost": "0.00",
        "code": "FO-R80",
        "profile": "80M/80M"
      },
      "client_mobile": "04128920758",
      "client_email": "ERIKADELVALLE.2025@GMAIL.COM",
      "address": "C. BERMÚDEZ, TURMERO",
      "client_identification": "V13769119",
      "nap_box_name": "282",
      "created_at": "2024-08-22T14:34:41.944138",
      "service_detail": {
        "id": 6200,
        "ip": "172.24.80.2",
        "mac": "GPON0097A836",
        "serial": "GPON0097A836",
        "queue": "Plan_121695_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-08-23T08:16:41.401373",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6495,
      "client_name": "JOSE MANUEL HERNANDEZ GUEVARA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243791678",
      "client_email": "JOSE18HERNANDEZ79@GMAIL.COM",
      "address": "CALLE RIVAS CASA NRO 58 ZONA TURMERO NORTE TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V13685860",
      "nap_box_name": "649",
      "created_at": "2024-08-22T17:59:25.882916",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6496,
      "client_name": "MARCELINO ALEXIS GRANADILLO REBOLLEDO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243494110",
      "client_email": "GLAFEGA0906@GMAIL.COM",
      "address": "CALLE 5 CASA NRO 319 URB MATA CABALLO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V10750361",
      "nap_box_name": "CTO-00182",
      "created_at": "2024-08-23T10:51:21.443592",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6497,
      "client_name": "JHOAN ALBERTO MEDINA MARTINEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados III",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124462045",
      "client_email": "JHOANMEDINA22.JM@GMAIL.COM",
      "address": "CALLE 3 CASA NRO 23 SECTOR PRADOS DE PAYA III ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V20988376",
      "nap_box_name": "579 DOS",
      "created_at": "2024-08-23T11:09:43.122645",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6499,
      "client_name": "BELKIS BEATRIZ JIMENEZ MUÑOZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Paya Abajo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144623327",
      "client_email": "BELKISJ913@GMAIL.COM",
      "address": "SAN ANTONIO, TURMERO, ARAGUA CASA N 3 SECTOR PAYA ABAJO",
      "client_identification": "V7105078",
      "nap_box_name": "272",
      "created_at": "2024-08-23T15:13:58.727691",
      "service_detail": {
        "id": 7435,
        "ip": "172.31.124.2",
        "mac": "OEMT3C62272A",
        "serial": "OEMT3C62272A",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN231_PAYABAJO",
        "created_at": "2024-12-12T17:29:20.862791",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6501,
      "client_name": "ROBERTO FIGUEROA PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "San Pablo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144561330",
      "client_email": "DISLEY2024@GMAIL.COM",
      "address": "5TA OESTE N 17 MANZANA 6 URB SAN PABLO",
      "client_identification": "V5301749",
      "nap_box_name": "CTO-0637",
      "created_at": "2024-08-23T15:35:07.110216",
      "service_detail": {
        "id": 6516,
        "ip": "172.31.126.2",
        "mac": "152",
        "serial": "OEMT3C622EF6",
        "queue": "Plan_153953_15811_WispHub",
        "interface": "VLAN224_SAN_PABLO_OLT1",
        "created_at": "2024-09-02T09:44:50.162264",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6502,
      "client_name": "EUDY JESUS BRICENO MALDONADO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04241664761",
      "client_email": "EUDYBRICENO9@GMAIL.COM",
      "address": "CALLE 3 CASA # 16 BARRIO PRADOS 1 DE PAYA",
      "client_identification": "V28091933",
      "nap_box_name": "CTO-00061",
      "created_at": "2024-08-23T15:42:50.088289",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6503,
      "client_name": "ALEXANDRA VALENTINA MALPICA MAYORA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Terrazas de Paya",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243415166",
      "client_email": "ALEXANDRAMALPICA@GMAIL.COM",
      "address": "TERRAZAS DE PAYA CALLE 4 CASA N 8 MANZANA 3",
      "client_identification": "V26140587",
      "nap_box_name": "421",
      "created_at": "2024-08-23T15:49:59.693994",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6504,
      "client_name": "CLAUDIMAR CAROLINA LINARES RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121480267",
      "client_email": "CLAUDIMARLINARES1@GMAIL.COM",
      "address": "CALLE SUCRE CASA NRO 55 BARRIO BOLIVAR CAGUA ARAGUA",
      "client_identification": "V20057537",
      "nap_box_name": "CTO-00162",
      "created_at": "2024-08-23T16:24:26.498851",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6505,
      "client_name": "YIMBERLY YANEXI APONTE BOLET",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "1ro de Mayo Norte",
      "plan": {
        "id": 43,
        "name": "RECURRENTE RESIDENCIAL PLAN 650M",
        "cost": "46.00",
        "code": "FOR650M",
        "profile": "650M/650M"
      },
      "client_mobile": "04125232206",
      "client_email": "ENDERSONLANDAEZ01@GMAIL.COM",
      "address": "1ERO DE MAYO NORTE C/INTERCOMUNAL#34 PAYA",
      "client_identification": "V24171121",
      "nap_box_name": "CTO-00538",
      "created_at": "2024-08-23T16:26:35.428914",
      "service_detail": {
        "id": 6539,
        "ip": "172.31.125.2",
        "mac": "HWTC22385386",
        "serial": "HWTC22385386",
        "queue": "Plan_161900_30183_WispHub",
        "interface": "VLAN261_1ERO_MAYO_ZTE",
        "created_at": "2024-09-03T15:01:42.584385",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6506,
      "client_name": "WILLEIDY ANDREA RODRIGUEZ BLANCO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "La Casona II",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243072712",
      "client_email": "PADILLALUIS1002@GMAIL.COM",
      "address": "CALLE 13 CASA NRO  118 LA CASONA II TURMERO",
      "client_identification": "V21097237",
      "nap_box_name": "CTO-00091",
      "created_at": "2024-08-25T21:53:04.180540",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6507,
      "client_name": "BENIGNA COROMOTO VASQUEZ MENDOZA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121471377",
      "client_email": "VASQUEZCOROMOTO938@GMAIL.COM",
      "address": "CALLE 12 CASA NRO 693-A URBANIZACIÓN MATACABALLO ROSARIO DE PAYA TURMERO EDO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V9439523",
      "nap_box_name": "CTO-00433",
      "created_at": "2024-08-26T11:30:17.743087",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6508,
      "client_name": "EDDY MARTINEZ MIRANDA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243177033",
      "client_email": "EMARTINEZ@EMPRESASPMC.COM",
      "address": "AV 5 MANZANA 6 CASA NRO 17 URB SAN PABLO TURMERO EDO. ARAGUA TURMERO ARAGUA",
      "client_identification": "E82363195",
      "nap_box_name": "CTO-00207 DOS",
      "created_at": "2024-08-26T12:07:12.473050",
      "service_detail": {
        "id": 6477,
        "ip": "172.31.128.2",
        "mac": "OEMT3C622666",
        "serial": "OEMT3C622666",
        "queue": "Plan_92284_15811_WispHub",
        "interface": "VLAN209_ZAMORA_OLT1",
        "created_at": "2024-08-31T11:00:35.223145",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6509,
      "client_name": "RUBEN ENRIQUE VILLEGAS MARTINEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04123980689",
      "client_email": "RUBENVILLEGAS2665@GMAIL.COM",
      "address": "CALLE 2B, CASA NRO 39, URB PANTIN, PAYA, ARAGUA",
      "client_identification": "V18552665",
      "nap_box_name": "CTO-00126",
      "created_at": "2024-08-26T13:19:19.073279",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6510,
      "client_name": "JOSE ORLANDO SALAZAR MONASTERIO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243261283",
      "client_email": "JOSEORLANDOSALAZAR80@GMAIL.COM",
      "address": "CALLE 11, CASA 658-A, SECTOR MATACABALLO, TURMERO",
      "client_identification": "V10273872",
      "nap_box_name": "CTO-0337",
      "created_at": "2024-08-26T13:52:18.429417",
      "service_detail": {
        "id": 6417,
        "ip": "172.31.132.2",
        "mac": "OEMT3C6228E2",
        "serial": "OEMT3C6228E2",
        "queue": "Plan_161905_30183_WispHub",
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2024-08-27T22:02:24.094170",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6511,
      "client_name": "ESTEFANI ALESANDRA FAJARDO RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "1ro de Mayo Sur",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04122982927",
      "client_email": "FAJARDOESTEFANI125@GMAIL.COM",
      "address": "ROSARIO DE PAYA, SECTOR PRIMERO DE MAYO CALLE 4 CASA NRO. 16",
      "client_identification": "V27864145",
      "nap_box_name": "CTO-00157",
      "created_at": "2024-08-26T14:32:20.724733",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6512,
      "client_name": "SOLEDAD CASTILLO DE TEQUIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "1ro de Mayo Sur",
      "plan": {
        "id": 43,
        "name": "RECURRENTE RESIDENCIAL PLAN 650M",
        "cost": "46.00",
        "code": "FOR650M",
        "profile": "650M/650M"
      },
      "client_mobile": "04127383666",
      "client_email": "COMERCIALMTM2000@GMAIL.COM",
      "address": "AVENIDA PRINCIPAL, NRO 15-16 PRIMERO DE MAYO SUR ROSARIO DE PAYA ARAGUA",
      "client_identification": "V11925991",
      "nap_box_name": "CTO-00149",
      "created_at": "2024-08-26T14:38:02.468898",
      "service_detail": {
        "id": 6357,
        "ip": "172.28.119.2",
        "mac": "OEMT3C62615E",
        "serial": "OEMT3C62615E",
        "queue": "Plan_161900_30183_WispHub",
        "interface": "VLAN261_1ERO_MAYO_ZTE",
        "created_at": "2024-08-26T16:28:27.124008",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6513,
      "client_name": "MAIRA ALEJANDRA RODRIGUEZ CASTILLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "1ro de Mayo Sur",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04125987004",
      "client_email": "RONALDELGATO100@GMAIL.COM",
      "address": "CALLE PEÑALVER, CASA NRO. 1 SECTOR, VILLA CASTIN, TURMERO EDO. ARAGUA, ZONA POSTAL 2115",
      "client_identification": "V20745635",
      "nap_box_name": "CTO-00149",
      "created_at": "2024-08-26T14:40:08.519282",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6514,
      "client_name": "YENIFER MARIA GUILLEN RAMIREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128323947",
      "client_email": "RAMIREZYENMARIA9@GMAIL.COM",
      "address": "CALLE 2 MANZANA B-8-3 CASA NRO 3 SAMÁN TARAZONERO II SECTOR EL MACARO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V16850059",
      "nap_box_name": "186",
      "created_at": "2024-08-26T14:43:13.071951",
      "service_detail": {
        "id": 6359,
        "ip": "172.29.101.2",
        "mac": "OEMT3C625632",
        "serial": "OEMT3C625632",
        "queue": "Plan_137413_1574_WispHub",
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2024-08-26T16:34:36.561754",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6515,
      "client_name": "JOHAN DE JESUS HERRADE PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04125206873",
      "client_email": "CYOHAN29@GMAIL.COM",
      "address": "CALLE 3 CASA NRO 42 SECTOR PRADOS DE PAYA II ROSARIO DE PAYA ARAGUA",
      "client_identification": "V18852397",
      "nap_box_name": "CE - 288",
      "created_at": "2024-08-26T14:45:00.647803",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6516,
      "client_name": "MIGUEL ANGEL MEDINA CHACON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121591320",
      "client_email": "DARIELIZDOMINGUEZ3@GMAIL.COM",
      "address": "CALLE 2-B CASA NRO 33 URB HACIENDA PANTIN ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V17707506",
      "nap_box_name": "CTO-00126",
      "created_at": "2024-08-26T14:46:41.366705",
      "service_detail": {
        "id": 6361,
        "ip": "172.29.107.2",
        "mac": "OEMT3C62577A",
        "serial": "OEMT3C62577A",
        "queue": "Plan_161906_30183_WispHub",
        "interface": "VLAN229_PANTIN",
        "created_at": "2024-08-26T16:40:29.541079",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6517,
      "client_name": "MODAS CARYEL CA",
      "client_type_name": "PYME",
      "client_subdivision": "CANCELADO_PYME",
      "status_name": "Cancelado",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 102,
        "name": "RECURRENTE PYME PLAN 150M",
        "cost": "27.60",
        "code": "FOP150M",
        "profile": "150Mbps/150Mbps"
      },
      "client_mobile": "04128909640",
      "client_email": "CARLOSDAVID2005CR6@GMAIL.COM",
      "address": "CALLE CARREÑO EDIF LA TRINIDAD PB LOCAL 6 CENTRO DE TURMERO",
      "client_identification": "J316043851",
      "nap_box_name": "CTO-00235",
      "created_at": "2024-08-26T15:08:43.976027",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6518,
      "client_name": "EDINSON ISMAEL BLANCO RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Bicentenario",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124050004",
      "client_email": "EDINSON18M@GMAIL.COM",
      "address": "CALLE B CASA NRO 04 SECTOR  FUNDA BARRIO SECTOR BICENTENARIO ROSARIO DE PAYA",
      "client_identification": "V25880767",
      "nap_box_name": "377",
      "created_at": "2024-08-26T15:27:32.019564",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6519,
      "client_name": "RUSMELY ADRIANA BRICENO PERDOMO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Laguna Plaza",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243028931",
      "client_email": "RUSMELYBRICENO886@GMAIL.COM",
      "address": "CALLE NEGRO PRIMERO EDIF 2 PISO 2 APT P/H 4-2 SECTOR RESIDENCIA LAGUNA PLAZA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V28430265",
      "nap_box_name": "4",
      "created_at": "2024-08-26T15:34:06.697972",
      "service_detail": {
        "id": 6362,
        "ip": "172.29.40.2",
        "mac": "OEMT3C6260F2",
        "serial": "OEMT3C6260F2",
        "queue": "Plan_153953_15811_WispHub",
        "interface": "VLAN216_LAGUNA_PLAZA_OLT1",
        "created_at": "2024-08-26T16:43:51.486254",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6520,
      "client_name": "KARINA YUBISAY CARRASQUEL ASCANIO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243603398",
      "client_email": "KCARRASQUELASCANIO@GMAIL.COM",
      "address": "CALLE 5 CASA 302 URB MATA CABALLO ROSARIO DE PAYA",
      "client_identification": "V17373270",
      "nap_box_name": "CTO-00180",
      "created_at": "2024-08-26T15:36:10.135370",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6521,
      "client_name": "AMARILIS COROMOTO MARTINEZ RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Terrazas de Paya",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04120415387",
      "client_email": "AMARILIS121270@GMAIL.COM",
      "address": "CALLE 04 MANZANA 04 CASA NRO 26 URB TERARRAZAS DE PAYA ROSARIO DE PAYA ARAGUA",
      "client_identification": "V10458365",
      "nap_box_name": "421",
      "created_at": "2024-08-26T15:38:21.571572",
      "service_detail": {
        "id": 11391,
        "ip": "172.31.133.2",
        "mac": "OEMT3C622462",
        "serial": "OEMT3C622462",
        "queue": null,
        "interface": "VLAN243_BICENTENARIO",
        "created_at": "2026-01-26T15:03:07.354997",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6522,
      "client_name": "NEUDYS JOSEFINA FIGUEROA FIGUERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Aduana",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04144751689",
      "client_email": "neudys80@gmail.com",
      "address": "AV PETION CASA NRO 60 SECTOR LA ADUANA TURMERO",
      "client_identification": "V14741787",
      "nap_box_name": "282",
      "created_at": "2024-08-26T15:38:28.156528",
      "service_detail": {
        "id": 6364,
        "ip": "172.29.27.2",
        "mac": "TPLGBA687C57",
        "serial": "TPLGBA687C57",
        "queue": "Plan_139897_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-08-26T16:55:59.415853",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6523,
      "client_name": "BRAIANA MARIELL LANDAETA DIAZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04127761945",
      "client_email": "BRAIANAMARIELLL@GMAIL.COM",
      "address": "URB PANTIN CALLE 11A CASA NRO 14 ROSARIO DE PAYA",
      "client_identification": "V26140813",
      "nap_box_name": "CTO-00167",
      "created_at": "2024-08-26T15:40:45.723114",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6524,
      "client_name": "ANA MARIA ROJAS FARIAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Arboleda",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124655080",
      "client_email": "DIANALAURIMAR18@GMAIL.COM",
      "address": "CALLEJON  LOS AGUACATES LA ARBOLEDA PAYA",
      "client_identification": "V17372809",
      "nap_box_name": "CE - 646",
      "created_at": "2024-08-26T15:45:44.637195",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6525,
      "client_name": "ZHARAY DIANA RAMIREZ TRUJILLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Las Palmas",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04129606715",
      "client_email": "ZHARAY.RAMIREZ1997@GMAIL.COM",
      "address": "CALLE LAS CAYENAS CASA NRO 07 SECTOR LAS PALMAS ROSARIO DE PAYA",
      "client_identification": "V26095594",
      "nap_box_name": "CTO-00098",
      "created_at": "2024-08-26T15:47:48.804259",
      "service_detail": {
        "id": 9825,
        "ip": "172.29.12.2",
        "mac": "OEMT3C625742",
        "serial": "OEMT3C625742",
        "queue": null,
        "interface": "VLAN262_LAS_PALMAS_ZTE",
        "created_at": "2025-11-10T17:16:46.790329",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6526,
      "client_name": "ANA KARINA FARFAN GARCIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "1ro de Mayo Norte",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243199590",
      "client_email": "JAVIVALE1629@GMAIL.COM",
      "address": "CALLE PARCELA EL NARANJAL, CASA # F2B 1ERO DE MAYO NORTE.",
      "client_identification": "V15302089",
      "nap_box_name": "CTO - 878",
      "created_at": "2024-08-26T15:50:17.197473",
      "service_detail": {
        "id": 6368,
        "ip": "172.22.195.2",
        "mac": "OEMT3C625F9A",
        "serial": "OEMT3C625F9A",
        "queue": "Plan_161904_30183_WispHub",
        "interface": "VLAN261_1ERO_MAYO_ZTE",
        "created_at": "2024-08-26T17:15:53.857649",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6527,
      "client_name": "NUVIA MARITZA CHAVEZ CHIRINOS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04129689759",
      "client_email": "MIPRIMERHIJOISAAC@GMAIL.COM",
      "address": "CALLE 02 CASA SECTOR PRADO DE PAYA II",
      "client_identification": "V23796093",
      "nap_box_name": "CE - 288",
      "created_at": "2024-08-26T15:53:06.519071",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6528,
      "client_name": "MAIKEL OMAR OSAL MEDINA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243646160",
      "client_email": "MAIKELOSAL60@GMAIL.COM",
      "address": "CALLE 3 CASA # 185 URB MATACABALLO ROSARIO DE PAYA ARAGUA ZONA POSTAL 215",
      "client_identification": "V25066344",
      "nap_box_name": "CTO-00156",
      "created_at": "2024-08-26T15:58:45.335296",
      "service_detail": {
        "id": 6418,
        "ip": "172.31.134.2",
        "mac": "OEMT3C622686",
        "serial": "OEMT3C622686",
        "queue": "Plan_161895_30183_WispHub",
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2024-08-27T22:10:41.370424",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6529,
      "client_name": "SORELIS JIMENEZ FALCON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Palma Real",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04243265304",
      "client_email": "SORELIS230@GMAIL.COM",
      "address": "CALLE 02 CASA NRO 14 SECTOR PALMA REAL ROSARIO DE PAYA",
      "client_identification": "V11976230",
      "nap_box_name": "CTO-00318",
      "created_at": "2024-08-26T16:05:52.380661",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6530,
      "client_name": "SIRA MAGALY SALAZAR GARCIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "1ro de Mayo Sur",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04162305301",
      "client_email": "YAIRISPACHECO00@GMAIL.COM",
      "address": "CALLE PRINCIPAL CASA # 1 SECTOR 1RO DE MAYO",
      "client_identification": "V5612432",
      "nap_box_name": "CE-00064",
      "created_at": "2024-08-26T16:11:51.773370",
      "service_detail": {
        "id": 6540,
        "ip": "172.31.135.2",
        "mac": "OEMT3C6227FA",
        "serial": "OEMT3C6227FA",
        "queue": "Plan_161895_30183_WispHub",
        "interface": "VLAN261_1ERO_MAYO_ZTE",
        "created_at": "2024-09-03T15:28:30.287898",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6532,
      "client_name": "ANA BEATRIZ CARDENAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Tibisay Guevara",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243547926",
      "client_email": "ANACARDENAS2965@GMAIL.COM",
      "address": "CALLE 1 CASA PARCELA  N° 33 N° 31 SECTOR TIBISAY GUEVARA VIA MACARO TURMERO",
      "client_identification": "V8986594",
      "nap_box_name": "CTO-00053",
      "created_at": "2024-08-26T16:23:09.695838",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6533,
      "client_name": "YURAIMA DEL VALLE MAITA SALMERON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04126814819",
      "client_email": "PITERHERRERA980@GMAIL.COM",
      "address": "INTERCOMUNAL TURMERO MARACAY, SECTOR LA CASONA 2, CALLE 12 CASA NRO 125",
      "client_identification": "V8693187",
      "nap_box_name": "CTO-00159",
      "created_at": "2024-08-26T16:29:23.280112",
      "service_detail": {
        "id": 6397,
        "ip": "172.25.217.2",
        "mac": "OEMT3C625DE6",
        "serial": "OEMT3C625DE6",
        "queue": "Plan_148293_24341_WispHub",
        "interface": "VLAN110_CASONA_2",
        "created_at": "2024-08-27T15:10:14.298252",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6534,
      "client_name": "YOLY DEL CARMEN PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243766884",
      "client_email": "YOLIPEREZ2777@GMAIL.COM",
      "address": "URB PANTIN, CALLE 15, CASA NRO 24 ROSARIO DE PAYA",
      "client_identification": "V14347124",
      "nap_box_name": "CTO-00135",
      "created_at": "2024-08-26T16:32:11.763254",
      "service_detail": {
        "id": 6398,
        "ip": "172.27.14.2",
        "mac": "OEMT3C625862",
        "serial": "OEMT3C625862",
        "queue": "Plan_161906_30183_WispHub",
        "interface": "VLAN229_PANTIN",
        "created_at": "2024-08-27T15:12:33.655554",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6535,
      "client_name": "IRAIMA ENIT SOSA MENDIBLE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Valle Paraiso",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04122465150",
      "client_email": "MARIANDREAPINEDA2603@GMAIL.COM",
      "address": "CALLE 2 CASA NRO 04 URB VALLE PARAISO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V7232435",
      "nap_box_name": "CTO-0642",
      "created_at": "2024-08-26T16:34:19.295755",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6536,
      "client_name": "DANIEL ALEJANDRO MORA GARCIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "SUSPENDIDO_RESIDENCIAL",
      "status_name": "Suspendido",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04248189017",
      "client_email": "ALEDMG2003@GMAIL.COM",
      "address": "CALLE 18 A CASA NRO 02  URB HACIENDA PANTIN ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V30148473",
      "nap_box_name": "CTO-00434",
      "created_at": "2024-08-26T16:38:01.289279",
      "service_detail": {
        "id": 6489,
        "ip": "172.27.164.2",
        "mac": "OEMT3C625A86",
        "serial": "OEMT3C625A86",
        "queue": "Plan_161906_30183_WispHub",
        "interface": "VLAN229_PANTIN",
        "created_at": "2024-08-31T14:17:33.769541",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6537,
      "client_name": "SANDRA ESCARLET MENGELLE DE CARRIZALES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Palma Real",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243461192",
      "client_email": "HIJOSCT@GMAIL.COM",
      "address": "CALLE MANZANA 01 CASA NRO 33 URBANIZACION PALMA REAL ROSARIO DE PAYA",
      "client_identification": "V8819778",
      "nap_box_name": "CTO-00318",
      "created_at": "2024-08-26T16:42:41.656056",
      "service_detail": {
        "id": 6490,
        "ip": "172.27.134.2",
        "mac": "OEMT3C625DFA",
        "serial": "OEMT3C625DFA",
        "queue": "queue1",
        "interface": "VLAN244_PALMAREAL",
        "created_at": "2024-08-31T14:19:37.902694",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6538,
      "client_name": "GREYSLI JOSE GUEVARA APONTE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Esperanza",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128151824",
      "client_email": "GREYSLIGUEVARA84@GMAIL.COM",
      "address": "URB LA ESPERANZA CALLE 21 CASA 21 EL MACARO",
      "client_identification": "V16850838",
      "nap_box_name": "555",
      "created_at": "2024-08-26T16:44:59.802692",
      "service_detail": {
        "id": 6527,
        "ip": "172.20.230.2",
        "mac": "HWTCCAA403EA",
        "serial": "HWTCCAA403EA",
        "queue": "Plan_127996_1574_WispHub",
        "interface": "VLAN137_LA_ESPERANZA_OLT_ZTE",
        "created_at": "2024-09-02T18:58:33.513011",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6539,
      "client_name": "KAREN ALEXANDER COLMENARES MORA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Orquidea",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124676669",
      "client_email": "GABRIELALEJANDRORINCON02@GMAIL.COM",
      "address": "CALLE 4 CASA NRO 87 BARRIO LA ORQUIDEA ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V19277990",
      "nap_box_name": "CTO-00048",
      "created_at": "2024-08-26T16:47:24.612153",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6540,
      "client_name": "JAIDY AMELIA MANCERA TORRES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Callejon Lim",
      "plan": {
        "id": 19,
        "name": "RECURRENTE RESIDENCIAL PLAN 1GB",
        "cost": "74.70",
        "code": "FOR1GB",
        "profile": "1000M/1000M"
      },
      "client_mobile": "04243689927",
      "client_email": "JAIDY66@HOTMAIL.COM",
      "address": "CALLE CARREÑO EDIF VIOLETA PISO 2 APTO 12 URB VILLAS DE TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V9652736",
      "nap_box_name": "CTO-0562",
      "created_at": "2024-08-26T17:00:47.700125",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6541,
      "client_name": "MARIBEL LINARES PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Magdalena",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243547946",
      "client_email": "MARILIMPER@GMAIL.COM",
      "address": "CALLE 9 CASA NRO 45 URB LA MAGDALENA SECTOR LA JULIA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V12377256",
      "nap_box_name": "CTO-00185",
      "created_at": "2024-08-26T17:02:40.607168",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6542,
      "client_name": "YENNIFFER VANESSA GONZALEZ MARTINEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Naranjal",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04145982709",
      "client_email": "YENNIFFERGONZALEZ51@GMAIL.COM",
      "address": "CALLE PRINCIPAL CASA NRO 18 SECTOR EL NARANJAL ROSARIO DE PAYA ARAGUA ZONA POSTAL 2118",
      "client_identification": "V19398020",
      "nap_box_name": "596",
      "created_at": "2024-08-26T17:04:51.930573",
      "service_detail": {
        "id": 12546,
        "ip": "172.23.49.2",
        "mac": "a8:bf:3c:62:5d:ff",
        "serial": "OEMT3C625DFE",
        "queue": null,
        "interface": "VLAN246_NARANJAL",
        "created_at": "2026-05-26T16:05:21.270116",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6543,
      "client_name": "KEYLA YOJANCI BALLESTEROS MARCANO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124691151",
      "client_email": "KEYBALLESTERO41@GMAIL.COM",
      "address": "CALLE 16B CASA NRO 52 SECTOR PANTIN ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V14390698",
      "nap_box_name": "CTO-00026",
      "created_at": "2024-08-26T17:06:58.220055",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6544,
      "client_name": "YOERLINE STARDAYANA MATOS VILLALOBOS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243491118",
      "client_email": "GOMEZYOE2@GMAIL.COM",
      "address": "CALLE 15 NRO 07 SECTOR RIO SECO ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V20760586",
      "nap_box_name": "CTO-00147",
      "created_at": "2024-08-26T17:09:05.195650",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6545,
      "client_name": "SARAIS PEREZ SILVA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243087233",
      "client_email": "CUCHITOSARA138@GMAIL.COM",
      "address": "CALLE MARIÑO CRUCE CON CEDEÑO EDF EBELLI PB 62 TURMERO",
      "client_identification": "V20068143",
      "nap_box_name": "CTO-00266",
      "created_at": "2024-08-26T17:13:43.539102",
      "service_detail": {
        "id": 9081,
        "ip": "172.29.251.2",
        "mac": "OEMT3C62589E",
        "serial": "OEMT3C62589E",
        "queue": "queue1",
        "interface": "VLAN200_OLTs",
        "created_at": "2025-06-26T14:04:34.185710",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6546,
      "client_name": "ZULIA DEL ROSARIO FLORES OLIVIER",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243459129",
      "client_email": "RUSSEMORENO08@GMAIL.COM",
      "address": "CALLE 6-B NRO 41 URB PANTIN, ROSARIO DE PAYA",
      "client_identification": "V9533878",
      "nap_box_name": "CTO-00138",
      "created_at": "2024-08-26T17:25:45.707962",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6547,
      "client_name": "JOSE GREGORIO VIEIRA SILVA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Canaima",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243087877",
      "client_email": "BELLOHABERLYN08@GMAIL.COM",
      "address": "CALLE PRINCIPAL CASA PARCELA 13 SECTOR PAYITA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V31023241",
      "nap_box_name": "CTO-00107 ",
      "created_at": "2024-08-26T17:30:02.186769",
      "service_detail": {
        "id": 6498,
        "ip": "172.24.5.2",
        "mac": "OEMT3C621016",
        "serial": "OEMT3C621016",
        "queue": "Plan_161906_30183_WispHub",
        "interface": "VLAN237_CANAIMA",
        "created_at": "2024-08-31T15:37:26.009424",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6548,
      "client_name": "CARMEN ZULAY GONZALEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados I",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04245929159",
      "client_email": "CARMENZULAYGONZALEZ5@GMAIL.COM",
      "address": "PRADOS DE PAYA I CALLE 9 NRO 12 ROSARIO DE PAYA",
      "client_identification": "V9243133",
      "nap_box_name": "CTO-00162",
      "created_at": "2024-08-26T17:31:53.006630",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6549,
      "client_name": "YOHANA CLAUDIMAR LIENDO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243173792",
      "client_email": "YOHANACLAUDIMARLIENDO@GMAIL.COM",
      "address": "MATA CABALLO  CALLE 3 NRO 100 ROSARIO DE PAYA",
      "client_identification": "V14469793",
      "nap_box_name": "CTO-00156",
      "created_at": "2024-08-26T17:34:26.554980",
      "service_detail": {
        "id": 6499,
        "ip": "172.20.247.2",
        "mac": "OEMT3C625D8A",
        "serial": "OEMT3C625D8A",
        "queue": "Plan_161906_30183_WispHub",
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2024-08-31T15:40:08.392390",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6550,
      "client_name": "JUAN CARLOS TORRES DOMINGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Palma Real",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243318397",
      "client_email": "juancarlostorresdominguez7@gmail.com",
      "address": "CALLE MANZANA 5 CASA NRO 106 URB PALMA REAL ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V14141344",
      "nap_box_name": "CTO-00391",
      "created_at": "2024-08-26T17:37:04.604939",
      "service_detail": {
        "id": 12069,
        "ip": "172.30.136.2",
        "mac": "VSOL004987C1",
        "serial": "VSOL004987C1",
        "queue": null,
        "interface": "VLAN244_PALMAREAL",
        "created_at": "2026-03-15T13:54:32.969322",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6551,
      "client_name": "NELSON LUIS ALVAREZ AVILA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243032250",
      "client_email": "PANTRO352@GMAIL.COM",
      "address": "CALLE 2 CASA NRO 23 BARRIO PRADOS DE PAYA II",
      "client_identification": "V18702552",
      "nap_box_name": "CTO-00100",
      "created_at": "2024-08-26T17:38:47.608467",
      "service_detail": {
        "id": 6501,
        "ip": "172.22.17.2",
        "mac": "OEMT3C625D72",
        "serial": "OEMT3C625D72",
        "queue": "Plan_161906_30183_WispHub",
        "interface": "VLAN242_PRADOS2",
        "created_at": "2024-08-31T15:48:21.119319",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6552,
      "client_name": "ALEJANDRO ALFONSO PELAEZ MENDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Paya Abajo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04127761902",
      "client_email": "ALEJANDROPELAEZ10101@GMAIL.COM",
      "address": "CALLE SAN ANTONIO CASA NRO 04 SECTOR PAYA ABAJO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V13721037",
      "nap_box_name": "480",
      "created_at": "2024-08-26T17:40:32.144162",
      "service_detail": {
        "id": 7479,
        "ip": "172.29.232.2",
        "mac": "OEMT3C625F1A",
        "serial": "OEMT3C625F1A",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN231_PAYABAJO",
        "created_at": "2024-12-17T10:43:57.649107",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6553,
      "client_name": "MARIANYELI ANAIS SANCHEZ ROMERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados III",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243254069",
      "client_email": "MARS.MARI4321@GMAIL.COM",
      "address": "PRADO III CALLE 2 CASA NRO 08",
      "client_identification": "V25066721",
      "nap_box_name": "CTO-00284 DOS",
      "created_at": "2024-08-26T17:43:25.981407",
      "service_detail": {
        "id": 11567,
        "ip": "172.17.110.2",
        "mac": "OEMT3C625FAA",
        "serial": "OEMT3C625FAA",
        "queue": null,
        "interface": "VLAN236_PRADOS3",
        "created_at": "2026-02-09T18:22:17.769801",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6554,
      "client_name": "GENESIS DANIELA ESAA CARMONA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243042079",
      "client_email": "ODGENESISESAA@GMAIL.COM",
      "address": "CALLE MIRANDA CASA NRO 14 SECTOR TURMERO CENTRO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V19699738",
      "nap_box_name": "CTO-00038",
      "created_at": "2024-08-26T17:45:12.797840",
      "service_detail": {
        "id": 6530,
        "ip": "172.30.7.2",
        "mac": "OEMT3C625AFE",
        "serial": "OEMT3C625AFE",
        "queue": "Plan_153953_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-09-02T19:05:48.992428",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6555,
      "client_name": "CRISTHIAN AARON MORA TOVAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Las Rurales",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128908039",
      "client_email": "FICRISTHIANMORAFI@GMAIL.COM",
      "address": "CALLE 106 CASA NRO 60 SECTOR LAS RURALES ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V29846036",
      "nap_box_name": "CTO-00200",
      "created_at": "2024-08-26T17:47:35.739415",
      "service_detail": {
        "id": 6525,
        "ip": "172.17.71.2",
        "mac": "OEMT3C625B0E",
        "serial": "OEMT3C625B0E",
        "queue": "queue1",
        "interface": "VLAN252_RURALES_PAYA",
        "created_at": "2024-09-02T18:53:18.831146",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6556,
      "client_name": "YONNATTAN JOSE GIL ADARME",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Orquidea",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124361343",
      "client_email": "YONNATTANGIL6@GMAIL.COM",
      "address": "LA ORQUIDEA CALLE 2 CASA NRO 35 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V18083741",
      "nap_box_name": "CTO-00019",
      "created_at": "2024-08-26T17:49:03.684058",
      "service_detail": {
        "id": 6543,
        "ip": "172.28.136.2",
        "mac": "TPLGB76566A6",
        "serial": "TPLGB76566A6",
        "queue": "Plan_161868_30181_WispHub",
        "interface": "VLAN259_LA_ORQUIDEA",
        "created_at": "2024-09-03T16:37:49.249890",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6557,
      "client_name": "ERIKA LISBETH SEIJAS RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Orquidea",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04127764887",
      "client_email": "ERIKASEIJAS18@GMAIL.COM",
      "address": "LA ORQUIDEA PRADOS DE PAYA CALLE 1 CASA NRO 03 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V13907251",
      "nap_box_name": "CTO-00019",
      "created_at": "2024-08-26T17:51:02.296872",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6558,
      "client_name": "JOSE GONCALVES DE SOUSA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Callejon Los Mamones",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128869617",
      "client_email": "JGONCALVES56@HOTMAIL.COM",
      "address": "CALLEJON LOS MAMONES PARCELA 7-4 SECTOR VALLE VERDE ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V13356184",
      "nap_box_name": "CTO-00187",
      "created_at": "2024-08-26T17:52:52.430050",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6559,
      "client_name": "KAIRIN MAYERLING MARTINEZ DIAZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04129380805",
      "client_email": "KAIRINMARTINEZ20@GMAIL.COM",
      "address": "EZEQUIEL ZAMORA TORRE 5",
      "client_identification": "V28023152",
      "nap_box_name": "CTO-00032 DOS",
      "created_at": "2024-08-26T17:54:26.473646",
      "service_detail": {
        "id": 9388,
        "ip": "172.26.22.2",
        "mac": "VSOL00D0DF97",
        "serial": "VSOL00D0DF97",
        "queue": "queue1",
        "interface": "VLAN209_ZAMORA_OLT1",
        "created_at": "2025-08-18T10:08:10.237895",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6560,
      "client_name": "JENNY ALEXANDRA VILLASMIL GARCIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04269383397",
      "client_email": "JENNYVILLASMIL.08@GMAIL.COM",
      "address": "CALLE 3 CASA 17 BARRIO BRISAS DE PAYA SECTOR LOS PRADOS ROSARIO DE PAYA ARAGUA",
      "client_identification": "V13562522",
      "nap_box_name": "CTO-00304",
      "created_at": "2024-08-27T08:29:03.018967",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6562,
      "client_name": "JESUS RAMON CASTRO OCHOA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona II Edificios",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04125012164",
      "client_email": "ENDER.EJCL99@GMAIL.COM",
      "address": "AV INTERCOMUNAL TURMERO EDIF 11 PISO 1 APT 2 URB LA CASONA II TURMERO ARAGUA",
      "client_identification": "V10759208",
      "nap_box_name": "CTO-0538",
      "created_at": "2024-08-27T09:35:22.261442",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6563,
      "client_name": "ALVIC MARTIN PRADO MATA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Valle del Rosario",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04143352137",
      "client_email": "ALVICPRADO1994@GMAIL.COM",
      "address": "CALLE LIBERTADOR CASA NRO 8 URB VALLE DEL ROSARIO TURMERO ARAGUA",
      "client_identification": "V24929771",
      "nap_box_name": "91",
      "created_at": "2024-08-27T10:21:02.379621",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6564,
      "client_name": "MARIA ELBA DE PONTE RAPISARDA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243680089",
      "client_email": "MARIDPR13@GMAIL.COM",
      "address": "CALLE BERMUDEZ EDIF TORRE APOLO PISO 4 APT 44 ZONA CENTRO TURMERO",
      "client_identification": "V20893461",
      "nap_box_name": "CTO-0517",
      "created_at": "2024-08-27T10:26:06.711839",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6565,
      "client_name": "BRYAN ALEXANDER LAMAS MARTINEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Valle del Rosario",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04124980084",
      "client_email": "BRYANLAMASS@GMAIL.COM",
      "address": "CALLE MARIÑO CASA NRO 3 URB VALLE DEL ROSARIO TURMERO ARAGUA",
      "client_identification": "V25841405",
      "nap_box_name": "30",
      "created_at": "2024-08-27T10:28:45.148841",
      "service_detail": {
        "id": 6692,
        "ip": "172.30.65.2",
        "mac": "TPLGB765693C",
        "serial": "TPLGB765693C",
        "queue": "Plan_138775_1574_WispHub",
        "interface": "VLAN132_VALLE_ROSARIO",
        "created_at": "2024-09-18T10:01:26.116637",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6566,
      "client_name": "MERVIN CAROLINA LUNA RAMIREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Valle del Rosario",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128875038",
      "client_email": "MERVINYY218@GMAIL.COM",
      "address": "CALLE MARIÑO CASA NRO 1 URB VALLE DEL ROSARIO SECTOR EL MACARO TURMERO ARAGUA",
      "client_identification": "V17578083",
      "nap_box_name": "30",
      "created_at": "2024-08-27T10:30:31.808365",
      "service_detail": {
        "id": 10088,
        "ip": "172.26.45.2",
        "mac": "VSOL00C7D0C8",
        "serial": "VSOL00C7D0C8",
        "queue": null,
        "interface": "VLAN100_OLTs",
        "created_at": "2025-11-13T08:53:48.414458",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6567,
      "client_name": "ESLY BETHZAIDA RONDON CASTILLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04140506574",
      "client_email": "DULIANJIMENEZ@HOTMAIL.COM",
      "address": "CALLE MANZANA I-10 CASA NRO 6 URB SAMAN TARAZONERO II 19 DE ABRIL ARAGUA",
      "client_identification": "V12339409",
      "nap_box_name": "38",
      "created_at": "2024-08-27T10:32:33.846502",
      "service_detail": {
        "id": 6566,
        "ip": "172.19.21.2",
        "mac": "TPLGB76565DA",
        "serial": "TPLGB76565DA",
        "queue": "Plan_157310_1574_WispHub",
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2024-09-06T15:59:07.313461",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6568,
      "client_name": "GRUZUET SAELY TABLANTE MARTINEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Palmeras II",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04128954594",
      "client_email": "GRUZUET.22@GMAIL.COM",
      "address": "CALLE 8 CASA NRO 133 URB LAS PALMERAS II TURMERO",
      "client_identification": "V26038158",
      "nap_box_name": "287",
      "created_at": "2024-08-27T10:36:15.471461",
      "service_detail": {
        "id": 9847,
        "ip": "172.19.248.2",
        "mac": "TPLGB954FB01",
        "serial": "TPLGB954FB01",
        "queue": null,
        "interface": "VLAN119_PALMERAS_2",
        "created_at": "2025-11-10T18:01:59.956371",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6569,
      "client_name": "RAUDIS ENRIQUE ARRIOJAS CAMPOS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Valle del Rosario",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128909359",
      "client_email": "THENOISE210@GMAIL.COM",
      "address": "CALLE LIBERTADOR CASA NRO 9 URB VALLE DEL ROSARIO TURMERO",
      "client_identification": "V15962516",
      "nap_box_name": "91",
      "created_at": "2024-08-27T10:41:56.625147",
      "service_detail": {
        "id": 9861,
        "ip": "172.20.114.2",
        "mac": "TPLGB954F94D",
        "serial": "TPLGB954F94D",
        "queue": null,
        "interface": "VLAN132_VALLE_ROSARIO",
        "created_at": "2025-11-10T18:39:50.662829",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6570,
      "client_name": "YNGINIO DECIDERIO MARCANO FRONTADO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128485870",
      "client_email": "MARLENEATERIS2411@GMAIL.COM",
      "address": "CALLE N#20, CASA N#14, SECTOR PANTIN, ROSARIO DE PAYA",
      "client_identification": "V6280856",
      "nap_box_name": "CTO-00435",
      "created_at": "2024-08-27T10:43:55.222706",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6571,
      "client_name": "YENIFER MARGARET GRATEROL SOLIS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Valle del Rosario",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04140518707",
      "client_email": "YENIFERGRATEROL5@GMAIL.COM",
      "address": "CALLE CASANOVA GODOY CASA NRO 14 URB VALLE ROSARIO EL MACARO TURMERO",
      "client_identification": "V17374805",
      "nap_box_name": "299",
      "created_at": "2024-08-27T10:44:04.928931",
      "service_detail": {
        "id": 12627,
        "ip": "172.20.87.2",
        "mac": "TP:LG:F5:CB:05:9F",
        "serial": "TPLGF5CB059F",
        "queue": null,
        "interface": "VLAN100_OLTs",
        "created_at": "2026-06-21T13:33:49.806520",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6572,
      "client_name": "DAMELYS COROMOTO MARTINEZ MEJIAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04127553577",
      "client_email": "DAMELYS14319466@GMAIL.COM",
      "address": "VDA 9 CASA MANZANA NRO 3 SECTOR EL MACARO SAMAN TARAZONERO II TURMERO",
      "client_identification": "V14319466",
      "nap_box_name": "CTO-0262",
      "created_at": "2024-08-27T10:49:52.348019",
      "service_detail": {
        "id": 6697,
        "ip": "172.20.212.2",
        "mac": "TPLGB954F833",
        "serial": "TPLGB954F833",
        "queue": "Plan_92194_1574_WispHub",
        "interface": "VLAN100_OLTs",
        "created_at": "2024-09-18T13:28:21.902518",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6573,
      "client_name": "ABEL ANDRES ARIAS ARIAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Simon Bolivar",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128844333",
      "client_email": "ariasabel975@gmail.com",
      "address": "CALLE 6 CASA NRO 40 BARRIO SIMON BOLIVAR SECTOR EL MACARO",
      "client_identification": "V29958953",
      "nap_box_name": "CTO-00023",
      "created_at": "2024-08-27T11:33:56.869862",
      "service_detail": {
        "id": 6698,
        "ip": "172.20.216.2",
        "mac": "TPLGB954ED58",
        "serial": "TPLGB954ED58",
        "queue": "Plan_127744_1574_WispHub",
        "interface": "VLAN128_SIMON_BOLIVAR_ZTE",
        "created_at": "2024-09-18T13:30:23.396690",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6574,
      "client_name": "YEFERLIN GABRIELA LOPEZ MARTINEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243072323",
      "client_email": "YEFERLINLOPEZ64@GMAIL.COM",
      "address": "AV. PRINCIPAL CASA # 680-A URB MATACABALLO ROSARIO DE PAYA",
      "client_identification": "V30555861",
      "nap_box_name": "CTO-00143",
      "created_at": "2024-08-27T11:40:58.346706",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6575,
      "client_name": "KATHERINE MICHELL RAMOS FLORES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Las Palmas",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04165265493",
      "client_email": "KATHERAMOS1998@GMAIL.COM",
      "address": "CALLE CALLEJON LOS APAMATES CASA NRO 12 SECTOR EL CAMBUR ROSARIO DE PAYA",
      "client_identification": "V26140096",
      "nap_box_name": "CTO - 889",
      "created_at": "2024-08-27T11:57:59.436868",
      "service_detail": {
        "id": 10272,
        "ip": "172.31.137.2",
        "mac": "OEMT3C622776",
        "serial": "OEMT3C622776",
        "queue": null,
        "interface": "VLAN262_LAS_PALMAS_ZTE",
        "created_at": "2025-11-23T09:22:45.102909",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6576,
      "client_name": "TERESA DE JESUS VASQUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Valle del Rosario",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04163170310",
      "client_email": "KARINA79PACHECO@GMAIL.COM",
      "address": "CALLE LIBERTADOR CASA NRO 2 URB VALLE ROSARIO TURMERO",
      "client_identification": "V3950488",
      "nap_box_name": "91",
      "created_at": "2024-08-27T12:05:26.816095",
      "service_detail": {
        "id": 10617,
        "ip": "172.21.133.2",
        "mac": "TPLGB954EFF3",
        "serial": "TPLGB954EFF3",
        "queue": null,
        "interface": "VLAN132_VALLE_ROSARIO",
        "created_at": "2025-12-06T18:18:32.132021",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6577,
      "client_name": "NELLY PRETEL",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Valle del Rosario",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128979652",
      "client_email": "NELLYPRETEL41@GMAIL.COM",
      "address": "CALLE MARIÑO CASA NRO  19 URB VALLE DEL ROSARIO",
      "client_identification": "V13538875",
      "nap_box_name": "30",
      "created_at": "2024-08-27T12:47:48.141816",
      "service_detail": {
        "id": 6441,
        "ip": "172.21.246.2",
        "mac": "TPLGB68B5070",
        "serial": "TPLGB68B5070",
        "queue": "Plan_157777_1574_WispHub",
        "interface": "VLAN100_OLTs",
        "created_at": "2024-08-28T17:07:48.910153",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6578,
      "client_name": "JOSE GREGORIO GUARAMAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Valle del Rosario",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04124608571",
      "client_email": "ERIKACARRASQUEL2903@GMAIL.COM",
      "address": "CALLE MARIÑO CASA NRO 15 URB VALLE DEL ROSARIO TURMERO",
      "client_identification": "V12610717",
      "nap_box_name": "30",
      "created_at": "2024-08-27T13:17:11.744927",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6579,
      "client_name": "ORIANNI ISABEL ALVAREZ PINEDA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "La Casona II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243279135",
      "client_email": "ORISABELL2@GMAIL.COM",
      "address": "CALLE 15 CASA NRO 81 SECTOR CASONA II TURMERO",
      "client_identification": "V24353443",
      "nap_box_name": "CTO-00087",
      "created_at": "2024-08-27T13:21:21.519248",
      "service_detail": {
        "id": 6701,
        "ip": "172.22.192.2",
        "mac": "TPLGBA68804D",
        "serial": "TPLGBA68804D",
        "queue": "Plan_148293_24341_WispHub",
        "interface": "VLAN110_CASONA_2",
        "created_at": "2024-09-18T13:37:40.920694",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6580,
      "client_name": "UNIDAD EDUCATIVA NACIONAL TURMERO",
      "client_type_name": "INTERCAMBIO",
      "client_subdivision": "ACTIVO_INTERCAMBIO",
      "status_name": "Activo",
      "cycle": 25,
      "migrate": false,
      "sector_name": "Villeguita",
      "plan": {
        "id": 83,
        "name": "RECURRENTE INSTITUCIONAL 80M",
        "cost": "0.00",
        "code": "FO-R80",
        "profile": "80M/80M"
      },
      "client_mobile": "04142709266",
      "client_email": "UENTURMERO@GMAIL.COM",
      "address": "CALLE PEÑALVER C/C CALLE COLEGIO NRO 65 TURMERO",
      "client_identification": "V200059079",
      "nap_box_name": "212",
      "created_at": "2024-08-27T13:25:12.941925",
      "service_detail": {
        "id": 6379,
        "ip": "172.22.110.2",
        "mac": "TPLGBA68828B",
        "serial": "TPLGBA68828B",
        "queue": "Plan_121695_15811_WispHub",
        "interface": "VLAN100_OLTs",
        "created_at": "2024-08-27T13:26:47.186302",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6581,
      "client_name": "JOSEFINA CANDELARIA PRATO CORRALES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Valle del Rosario",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04143927562",
      "client_email": "CANDYCORRALE29@GMAIL.COM",
      "address": "CALLE LIBERTADOR CASA NRO 39 URB VALLE ROSARIO TURMERO",
      "client_identification": "V15963256",
      "nap_box_name": "91",
      "created_at": "2024-08-27T13:35:27.027132",
      "service_detail": {
        "id": 6702,
        "ip": "172.23.50.2",
        "mac": "TPLGBA68736D",
        "serial": "TPLGBA68736D",
        "queue": "Plan_157310_1574_WispHub",
        "interface": "VLAN132_VALLE_ROSARIO",
        "created_at": "2024-09-18T13:39:24.941101",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6583,
      "client_name": "JESUS RAFAEL VASQUEZ RAMIREZ",
      "client_type_name": "EMPLEADO",
      "client_subdivision": "CANCELADO_EMPLEADO",
      "status_name": "Cancelado",
      "cycle": 25,
      "migrate": false,
      "sector_name": "Pantin",
      "plan": {
        "id": 78,
        "name": "Plan empleado 80MB",
        "cost": "0.00",
        "code": "FO-80M",
        "profile": "80M/80M"
      },
      "client_mobile": "04144735431",
      "client_email": "INVERSIONESDIGITALES@HOTMAIL.ES",
      "address": "CALLE 8 CASA NRO 14 PANTIN ROSARIO DE PAYA",
      "client_identification": "V19793831",
      "nap_box_name": "CTO-00114",
      "created_at": "2024-08-27T13:42:25.458223",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6584,
      "client_name": "JOHANNA YAMILE PAEZ RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Bicentenario",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128153855",
      "client_email": "JOA.PAEZ.99@GMAIL.COM",
      "address": "SECTOR URBANISTICO ROSARIO DE PAYA MANZANA A ASA NRO 8 DE TURMERO",
      "client_identification": "V20056969",
      "nap_box_name": "388",
      "created_at": "2024-08-27T13:53:23.162559",
      "service_detail": {
        "id": 6468,
        "ip": "172.18.32.2",
        "mac": "TPLGF4B1D887",
        "serial": "TPLGF4B1D887",
        "queue": "Plan_161891_30183_WispHub",
        "interface": "VLAN243_BICENTENARIO",
        "created_at": "2024-08-29T11:33:52.687433",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6585,
      "client_name": "LUIS ARMANDO LUGO RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243560747",
      "client_email": "LUISLUGO2202@GMAIL.COM",
      "address": "SECTOR URBANISTICO ROSARIO DE PAYA MANZANA A ASA NRO 8 DE TURMERO",
      "client_identification": "V24685579",
      "nap_box_name": "222",
      "created_at": "2024-08-27T13:57:09.938484",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6586,
      "client_name": "JOSE FREDDY GRUESO GRUESO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados III",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243719830",
      "client_email": "JOSEFREDDY306@GMAIL.COM",
      "address": "CALLE 5, CASA NRO 7, URB PRADOS DE PAYA 3, PAYA",
      "client_identification": "V18645819",
      "nap_box_name": "CTO-00305",
      "created_at": "2024-08-27T14:03:18.687686",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6588,
      "client_name": "DANNY ALBERTO GRANADILLO FIOL",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04123126552",
      "client_email": "FIOLALBERTO02@GMAIL.COM",
      "address": "CALLE 7 CASA NRO 551-A SECTOR MATA CABALLO",
      "client_identification": "V15600726",
      "nap_box_name": "CTO-00310",
      "created_at": "2024-08-27T14:11:46.160037",
      "service_detail": {
        "id": 6465,
        "ip": "172.20.69.2",
        "mac": "VSOL00498409",
        "serial": "VSOL00498409",
        "queue": "queue1",
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2024-08-29T10:42:24.512364",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6589,
      "client_name": "JHEANDRY NAZARED RON RUIZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144757872",
      "client_email": "JHEANDRYRON@GMAIL.COM",
      "address": "CALLE 8 CASA NRO 580A URB MATA CABALLO TURMERO",
      "client_identification": "V30223289",
      "nap_box_name": "CTO-00130",
      "created_at": "2024-08-27T14:27:27.833815",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6591,
      "client_name": "OSCAR ENRIQUE LOPEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04163359125",
      "client_email": "OSCAR.OL723@GMAIL.COM",
      "address": "CALLE 13 CASA NRO 31 SECTOR RIO SECO ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V9657992",
      "nap_box_name": "487",
      "created_at": "2024-08-27T14:35:44.209174",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6592,
      "client_name": "BEATRIZ MARIA DIAZ CARIAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Durpa",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04128902861",
      "client_email": "VICTORIACARIAS1988@GMAIL.COM",
      "address": "CALLE NRO 18, CASA NRO 6, SECTOR FUNDABARRIO, PAYA",
      "client_identification": "V18855850",
      "nap_box_name": "392",
      "created_at": "2024-08-27T15:02:27.118401",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6593,
      "client_name": "GAUDY NICOLE ANTIBEROS GONALEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Bosque",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04123988783",
      "client_email": "GAUDYANTIBERO2003@GMAIL.COM",
      "address": "CALLE LUISA CACERES DE ARISMENDI CASA NRO 33 SECTOR EL BOSQUE ROSARIO DE PAYA TURMERO EDO ARAGUA",
      "client_identification": "V30459129",
      "nap_box_name": "CE - 851",
      "created_at": "2024-08-27T15:39:30.455419",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6594,
      "client_name": "DEISY ANDREINA GUERRERO DIAZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144787212",
      "client_email": "DAGD4301@GMAIL.COM",
      "address": "AV ROSARIO DE PAYA CALLE 16 CASA NRO 63 URB PANTIN",
      "client_identification": "V18163687",
      "nap_box_name": "CTO-00026",
      "created_at": "2024-08-27T16:14:50.083821",
      "service_detail": {
        "id": 6463,
        "ip": "172.18.121.2",
        "mac": "TPLGF4EFC249",
        "serial": "TPLGF4EFC249",
        "queue": "Plan_161892_30183_WispHub",
        "interface": "VLAN229_PANTIN",
        "created_at": "2024-08-29T10:26:53.813561",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6595,
      "client_name": "CEIN ARAGUANEY",
      "client_type_name": "INTERCAMBIO",
      "client_subdivision": "ACTIVO_INTERCAMBIO",
      "status_name": "Activo",
      "cycle": 25,
      "migrate": false,
      "sector_name": "Prados III",
      "plan": {
        "id": 83,
        "name": "RECURRENTE INSTITUCIONAL 80M",
        "cost": "0.00",
        "code": "FO-R80",
        "profile": "80M/80M"
      },
      "client_mobile": "04243481534",
      "client_email": "DILIAMONTILLA706@GMAIL.COM",
      "address": "CALLE PRINCIPAL CASA PARCELA NRO 17 SECTOR PRADOS III",
      "client_identification": "V403871280",
      "nap_box_name": "395",
      "created_at": "2024-08-27T16:20:30.497374",
      "service_detail": {
        "id": 10093,
        "ip": "172.19.81.2",
        "mac": "VSOL00521679",
        "serial": "VSOL00521679",
        "queue": null,
        "interface": "VLAN236_PRADOS3",
        "created_at": "2025-11-13T13:17:53.427137",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6597,
      "client_name": "X Y GRANADILLO FP",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 102,
        "name": "RECURRENTE PYME PLAN 150M",
        "cost": "27.60",
        "code": "FOP150M",
        "profile": "150Mbps/150Mbps"
      },
      "client_mobile": "04121755098",
      "client_email": "X.YSTOR3@GMAIL.COM",
      "address": "CALLE MARIÑO, LOCAL COMUNA 13 DE ENERO NRO 81, SECTOR CASCO CENTRAL, ARAGUA",
      "client_identification": "J237840824",
      "nap_box_name": "CTO-00256",
      "created_at": "2024-08-28T08:58:43.804436",
      "service_detail": {
        "id": 6588,
        "ip": "172.31.142.2",
        "mac": "OEMT3C62279E",
        "serial": "OEMT3C62279E",
        "queue": "Plan_92036_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-09-09T18:05:25.693668",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6598,
      "client_name": "DEYSI ODALIS CASTILLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04123412551",
      "client_email": "CASTILLODEYSIODALIS@GMAIL.COM",
      "address": "CALLE 13, CASA 37, SECTOR RIO SECO, ROSARIO DE PAYA",
      "client_identification": "V10356799",
      "nap_box_name": "CE - 588",
      "created_at": "2024-08-28T09:56:49.315915",
      "service_detail": {
        "id": 6506,
        "ip": "172.31.143.2",
        "mac": "OEMT3C622C8A",
        "serial": "OEMT3C622C8A",
        "queue": "queue1",
        "interface": "VLAN251_RIO_SECO",
        "created_at": "2024-09-01T10:20:33.081176",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6599,
      "client_name": "FIZTGERALD RELVA CHACON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Narayola II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04141441843",
      "client_email": "DELTAAIRS@GMAIL.COM",
      "address": "AV INTERCOMUNAL EDIF 5 PISO PB APT 05 CONJUNTO RESIDENCIAL NARAYOLA II TURMERO ARAGUA",
      "client_identification": "V20055167",
      "nap_box_name": "CTO-0525",
      "created_at": "2024-08-28T10:52:39.949516",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6600,
      "client_name": "ROCKDIN HEYAN TEICEIRA SCORTINO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "San Pablo",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04128907702",
      "client_email": "ROCKDIN2023@GMAIL.COM",
      "address": "CALLE EL MILAGRO CASA NRO 19 SECTOR VILLEGUITA II SECTOR LAS PALMAS TURMERO EDO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V18443476",
      "nap_box_name": "CTO-00246",
      "created_at": "2024-08-28T11:58:26.005888",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6601,
      "client_name": "UE LA MAGDALENA",
      "client_type_name": "INTERCAMBIO",
      "client_subdivision": "ACTIVO_INTERCAMBIO",
      "status_name": "Activo",
      "cycle": 25,
      "migrate": false,
      "sector_name": "La Magdalena",
      "plan": {
        "id": 83,
        "name": "RECURRENTE INSTITUCIONAL 80M",
        "cost": "0.00",
        "code": "FO-R80",
        "profile": "80M/80M"
      },
      "client_mobile": "04144518298",
      "client_email": "IRISMORILLO44@GMAIL.COM",
      "address": "LA MAGDALENA AV2 CALLE 17 TURMERO",
      "client_identification": "J405412054",
      "nap_box_name": "CTO-00085",
      "created_at": "2024-08-28T14:18:30.723911",
      "service_detail": {
        "id": 6429,
        "ip": "172.24.33.2",
        "mac": "VSOL0013F4F9",
        "serial": "VSOL0013F4F9",
        "queue": "Plan_132970_24341_WispHub",
        "interface": "VLAN110_CASONA_2",
        "created_at": "2024-08-28T14:30:04.447332",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6602,
      "client_name": "ASOCIACION CIVIL MISION CARISMATICA INTERNACIONAL DE TURMERO",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "San Pablo",
      "plan": {
        "id": 36,
        "name": "RECURRENTE PYME PLAN 650M",
        "cost": "70.18",
        "code": "FOP650M",
        "profile": "650M/650M"
      },
      "client_mobile": "04243390273",
      "client_email": "ADMISIONCARISMATICATURMERO@GMAIL.COM",
      "address": "AV PRINCIPAL SUR LOCAL GALPÓN NRO 56 ZONA INDUSTRIAL SAN PABLO TURMERO - ARAGUA",
      "client_identification": "J297625739",
      "nap_box_name": "56",
      "created_at": "2024-08-28T14:23:10.978423",
      "service_detail": {
        "id": 12389,
        "ip": "172.31.146.2",
        "mac": "OEMT3C622976",
        "serial": "OEMT3C622976",
        "queue": null,
        "interface": "VLAN224_SAN_PABLO_OLT1",
        "created_at": "2026-04-21T12:50:28.968110",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6603,
      "client_name": "UE LA MAGDALENA",
      "client_type_name": "INTERCAMBIO",
      "client_subdivision": "ACTIVO_INTERCAMBIO",
      "status_name": "Activo",
      "cycle": 25,
      "migrate": false,
      "sector_name": "La Magdalena",
      "plan": {
        "id": 83,
        "name": "RECURRENTE INSTITUCIONAL 80M",
        "cost": "0.00",
        "code": "FO-R80",
        "profile": "80M/80M"
      },
      "client_mobile": "04144518298",
      "client_email": "IRISMORILLO44@GMAIL.COM",
      "address": "LA MAGDALENA AV2 CALLE 17 TURMERO",
      "client_identification": "J405412054",
      "nap_box_name": "414",
      "created_at": "2024-08-28T14:33:29.208638",
      "service_detail": {
        "id": 9923,
        "ip": "172.30.33.2",
        "mac": "GPON0097C276",
        "serial": "GPON0097C276",
        "queue": null,
        "interface": "VLAN114_MAGDALENA",
        "created_at": "2025-11-11T08:25:03.784180",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6605,
      "client_name": "TERESA DE JESUS PINEDA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04122056498",
      "client_email": "TERESAPINADA@GMAIL.COM",
      "address": "CALLE N#15 CASA NRO 50 SECTOR RIO SECO ROSARIO DE PAYA",
      "client_identification": "V10456856",
      "nap_box_name": "CTO-00155",
      "created_at": "2024-08-28T15:16:45.423022",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6606,
      "client_name": "CONSULTORIO BARRIO ADENTRO DURPA",
      "client_type_name": "INTERCAMBIO",
      "client_subdivision": "ACTIVO_INTERCAMBIO",
      "status_name": "Activo",
      "cycle": 25,
      "migrate": false,
      "sector_name": "Durpa",
      "plan": {
        "id": 83,
        "name": "RECURRENTE INSTITUCIONAL 80M",
        "cost": "0.00",
        "code": "FO-R80",
        "profile": "80M/80M"
      },
      "client_mobile": "04264345656",
      "client_email": "KAUDARIS_02@HOMAIL.COM",
      "address": "CALLE LOS CEDROS CRUCE CON AVES DEL PARAISO, S/N DURPA",
      "client_identification": "V128400000",
      "nap_box_name": "384",
      "created_at": "2024-08-29T09:49:34.626763",
      "service_detail": {
        "id": 6460,
        "ip": "172.23.25.2",
        "mac": "TPLGF4B1D876",
        "serial": "TPLGF4B1D876",
        "queue": "Plan_162000_30183_WispHub",
        "interface": "VLAN240_DURPA",
        "created_at": "2024-08-29T10:07:28.487318",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6607,
      "client_name": "ESCUELA BASICA NACIONAL BELEN SANJUAN",
      "client_type_name": "INTERCAMBIO",
      "client_subdivision": "ACTIVO_INTERCAMBIO",
      "status_name": "Activo",
      "cycle": 25,
      "migrate": false,
      "sector_name": "Durpa",
      "plan": {
        "id": 83,
        "name": "RECURRENTE INSTITUCIONAL 80M",
        "cost": "0.00",
        "code": "FO-R80",
        "profile": "80M/80M"
      },
      "client_mobile": "04123471333",
      "client_email": "RGPB1234@GMAIL.COM",
      "address": "DURPA AL FINAL DE LA CALLE SIMON RODRIGUEZ S/N",
      "client_identification": "V407387065",
      "nap_box_name": "382",
      "created_at": "2024-08-29T10:18:23.443649",
      "service_detail": {
        "id": 6461,
        "ip": "172.23.60.2",
        "mac": "HWTC727CBDA5",
        "serial": "HWTC727CBDA5",
        "queue": "Plan_161876_30181_WispHub",
        "interface": "VLAN240_DURPA",
        "created_at": "2024-08-29T10:20:19.395117",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6608,
      "client_name": "JANET JOSEFINA CEDENO MORILLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Narayola II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04248135806",
      "client_email": "TROPELSMEDIA@GMAIL.COM",
      "address": "AV INTERCOMUNAL TORRE 3, PISO 1 APT 1-5 URB NARAYOLA II TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V8444163",
      "nap_box_name": "CTO-0523",
      "created_at": "2024-08-29T13:12:04.945255",
      "service_detail": {
        "id": 6677,
        "ip": "172.18.186.2",
        "mac": "TPLGB954EC6D",
        "serial": "TPLGB954EC6D",
        "queue": "Plan_148293_24341_WispHub",
        "interface": "VLAN100_OLTs",
        "created_at": "2024-09-17T17:53:49.290324",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6609,
      "client_name": "CRISTIAN DAVID RAMOS PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "1ro de Mayo Norte",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121484676",
      "client_email": "CRIISTIANDAVID8@GMAIL.COM",
      "address": "CALLE SOROCAIMA, CASA NRO 2, BARRIO 1 DE MAYO NORTE, ROSARIO DE PAYA",
      "client_identification": "V28316789",
      "nap_box_name": "CTO-00229",
      "created_at": "2024-08-29T13:31:56.096370",
      "service_detail": {
        "id": 6509,
        "ip": "172.31.147.2",
        "mac": "159",
        "serial": "OEMT3C622CF2",
        "queue": "Plan_161895_30183_WispHub",
        "interface": "VLAN261_1ERO_MAYO_ZTE",
        "created_at": "2024-09-02T09:07:38.764832",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6610,
      "client_name": "IGNEIS JOSBELVIT NIEVES TORREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Los Hornos",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04267346935",
      "client_email": "IGNEISNIEVES462@GMAIL.COM",
      "address": "CALLE 9, CASA N° 40, SECTOR LOS HORNOS, ROSARIO DE PAYA, ARAGUA",
      "client_identification": "V21369315",
      "nap_box_name": "CTO-00288",
      "created_at": "2024-08-29T15:12:18.200065",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6611,
      "client_name": "MARCELA DEL CARMEN MORILLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Brisas de Paya",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04129206456",
      "client_email": "JM1135060@GMAIL.COM",
      "address": "BRISAS DE PAYA, CALLE 2, CASA #17, PAYA",
      "client_identification": "V4921823",
      "nap_box_name": "370",
      "created_at": "2024-08-29T15:56:54.465027",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6612,
      "client_name": "LISETH DAYANA MONCADA ROJAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Terrazas de Paya",
      "plan": {
        "id": 43,
        "name": "RECURRENTE RESIDENCIAL PLAN 650M",
        "cost": "46.00",
        "code": "FOR650M",
        "profile": "650M/650M"
      },
      "client_mobile": "04243366574",
      "client_email": "LUISDANLEWIS78@GMAIL.COM",
      "address": "CALLE LAS PALMAS, CASA NRO 50, SECTOR VALLECITO, ROSARIO DE PAYA, ARAGUA",
      "client_identification": "V16690184",
      "nap_box_name": "0165",
      "created_at": "2024-08-31T10:25:47.526866",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6613,
      "client_name": "LUIS ALFREDO HERNANDEZ PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04127781668",
      "client_email": "HLUISMUSIC@GMAIL.COM",
      "address": "CALLE 29, CASA 04, SECTOR RIO SECO, ROSARIO DE PAYA, ARAGUA",
      "client_identification": "V21204461",
      "nap_box_name": "CTO-00253",
      "created_at": "2024-08-31T12:23:20.958607",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6614,
      "client_name": "SCARLET JOSEFINA GOMEZ GOMEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "1ro de Mayo Norte",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04128908269",
      "client_email": "scarjos25l@gmail.com",
      "address": "SECTOR 1ERO DE MAYO NORTE, AV PRINCIPAL, CASA NRO 182B, PAYA",
      "client_identification": "V10797032",
      "nap_box_name": "CTO-00225",
      "created_at": "2024-08-31T13:05:17.406094",
      "service_detail": {
        "id": 12303,
        "ip": "172.31.153.2",
        "mac": "OEMT3C622C0A",
        "serial": "OEMT3C622C0A",
        "queue": null,
        "interface": "VLAN261_1ERO_MAYO_ZTE",
        "created_at": "2026-04-11T18:30:36.834631",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6615,
      "client_name": "YOLIAGNIS YELICETH LANDAETA NIEVES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121588726",
      "client_email": "yoliagnislandaeta6@gmail.com",
      "address": "RIO SECO, CALLE 9, CASA N55, ROSARIO DE PAYA, ARAGUA",
      "client_identification": "V27048675",
      "nap_box_name": "CTO-0609",
      "created_at": "2024-08-31T13:18:00.335144",
      "service_detail": {
        "id": 12237,
        "ip": "172.31.154.2",
        "mac": "OEMT3C6248BE",
        "serial": "OEMT3C6248BE",
        "queue": null,
        "interface": "VLAN251_RIO_SECO",
        "created_at": "2026-04-01T14:53:33.355307",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6616,
      "client_name": "JOSE ALEJANDRO GONZALEZ MOTA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "La Casona II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243010001",
      "client_email": "ENIGMAHATER@GMAIL.COM",
      "address": "CALLE 15 CASA NRO 10 URB LA CASONA 2 TURMERO ARAGUA",
      "client_identification": "V27463708",
      "nap_box_name": "CTO-00087",
      "created_at": "2024-09-01T10:02:00.517556",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6617,
      "client_name": "NICOLE VALENTINA MORENO CARDOZO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados III",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04121458150",
      "client_email": "MILLYVALENTINA.05@GMAIL.COM",
      "address": "PRADO III, CALLE PRINCIPAL 2, CASA 56, ROSARIO DE PAYA",
      "client_identification": "V31585736",
      "nap_box_name": "580 DOS",
      "created_at": "2024-09-02T08:57:16.185744",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6618,
      "client_name": "NESTOR ENRIQUE ALVAREZ HERRERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Terrazas de Paya",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243633668",
      "client_email": "NA2909615@GMAIL.COM",
      "address": "CALLE 04 CASA N° 22 SECTOR TERRAZAS DE PAYA ROSARIO DE PAYA  ARAGUA ZONA POSTAL 2115",
      "client_identification": "V19131366",
      "nap_box_name": "421",
      "created_at": "2024-09-02T13:33:07.637565",
      "service_detail": {
        "id": 11397,
        "ip": "172.31.157.2",
        "mac": "OEMT3C62577E",
        "serial": "OEMT3C62577E",
        "queue": null,
        "interface": "VLAN243_BICENTENARIO",
        "created_at": "2026-01-27T08:17:16.430659",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6619,
      "client_name": "CARLA VALENTINA VILLEGAS NIÑO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121790403",
      "client_email": "CARLAVILLE2802@GMAIL.COM",
      "address": "AV CARREÑO EDIFICIO TORRE 22 PISO 03 APARTAMENTO 4 URBANZACION COMPLEJO HABITACIONAL EL NISPERO",
      "client_identification": "V31381741",
      "nap_box_name": "CTO-00207 DOS",
      "created_at": "2024-09-02T14:40:26.245086",
      "service_detail": {
        "id": 6585,
        "ip": "172.31.159.2",
        "mac": "OEMT3C622766",
        "serial": "OEMT3C622766",
        "queue": "Plan_153953_15811_WispHub",
        "interface": "VLAN209_ZAMORA_OLT1",
        "created_at": "2024-09-09T17:58:35.441170",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6620,
      "client_name": "INVERSIONES BEYROUTY 1 CA",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04225323575",
      "client_email": "SAIDCRAFT45@GMAIL.COM",
      "address": "CALLE MARIÑO CC COMUNA 13 DE ENERO NIVEL PB LOCAL 45 SECTOR CENTRO DE TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "J505627490",
      "nap_box_name": "CTO-00256",
      "created_at": "2024-09-02T16:35:37.958983",
      "service_detail": {
        "id": 12640,
        "ip": "172.31.158.2",
        "mac": "GP:ON:00:97:C7:E6",
        "serial": "GPON0097C7E6",
        "queue": null,
        "interface": "VLAN200_OLTs",
        "created_at": "2026-06-27T12:12:44.844669",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6621,
      "client_name": "JOAO MANUEL BAPTISTA HERNANDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "SUSPENDIDO_RESIDENCIAL",
      "status_name": "Suspendido",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04141449323",
      "client_email": "BARAKAAGRO14@GMAIL.COM",
      "address": "CALLE BERMUDEZ NRO 51 TURMERO",
      "client_identification": "V14627596",
      "nap_box_name": "77",
      "created_at": "2024-09-03T12:03:01.465597",
      "service_detail": {
        "id": 12530,
        "ip": "172.17.135.2",
        "mac": "VS:OL:00:47:D0:19",
        "serial": "VSOL0047D019",
        "queue": null,
        "interface": "VLAN200_OLTs",
        "created_at": "2026-05-19T11:51:02.471273",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6622,
      "client_name": "YSVET YARITZA MARVAL GARCIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243113361",
      "client_email": "ISVETMARVAK@GMAIL.COM",
      "address": "CALLE 14 CASA NRO 59 URB LA CASONA II TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V14838162",
      "nap_box_name": "CTO-00088 DOS",
      "created_at": "2024-09-03T12:41:47.816436",
      "service_detail": {
        "id": 6535,
        "ip": "172.28.255.2",
        "mac": "OEMT3C625FCE",
        "serial": "OEMT3C625FCE",
        "queue": "Plan_131337_24341_WispHub",
        "interface": "VLAN110_CASONA_2",
        "created_at": "2024-09-03T12:44:37.149706",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6623,
      "client_name": "BARBARA ESTHEFANY SALINAS PLAZA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "1ro de Mayo Sur",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121486683",
      "client_email": "BKSPSALINAS30@GMAIL.COM",
      "address": "CALLE 3 CASA NRO. 8 PRIMERO DE MAYO SUR ROSARIO DE PAYA ARAGUA",
      "client_identification": "V31081292",
      "nap_box_name": "CTO-00237",
      "created_at": "2024-09-03T12:51:02.419717",
      "service_detail": {
        "id": 12225,
        "ip": "172.30.99.2",
        "mac": "2012231218007184",
        "serial": "OEMT3C626026",
        "queue": null,
        "interface": "VLAN261_1ERO_MAYO_ZTE",
        "created_at": "2026-03-30T20:45:54.607867",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6624,
      "client_name": "HERIKA JULIANNY SILVA BOLIVAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "1ro de Mayo Norte",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128994271",
      "client_email": "HERIKASILVA075@GMAIL.COM",
      "address": "CALLE SOROCAIMA CASA NRO 15 PRIMERO DE MAYO NORTE ROSARIO DE PAYA",
      "client_identification": "V26140010",
      "nap_box_name": "CTO-00229",
      "created_at": "2024-09-03T13:10:52.388525",
      "service_detail": {
        "id": 11568,
        "ip": "172.30.110.2",
        "mac": "HWTC0D872E85",
        "serial": "HWTC0D872E85",
        "queue": null,
        "interface": "VLAN261_1ERO_MAYO_ZTE",
        "created_at": "2026-02-09T19:17:42.679897",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6626,
      "client_name": "HECTOR NEHOMAR RISSO ORTEGOSA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144605479",
      "client_email": "RISSOHECTOR76@GMAIL.COM",
      "address": "CALLE 5 CASA NRO 289 URB MATA CABALLO ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V12608042",
      "nap_box_name": "CTO-00180",
      "created_at": "2024-09-04T14:17:11.353338",
      "service_detail": {
        "id": 6549,
        "ip": "172.31.161.2",
        "mac": "OEMT3C624D1A",
        "serial": "OEMT3C624D1A",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2024-09-05T08:25:23.932638",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6627,
      "client_name": "GENESIS YERARDIN BAEZ GOMEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04149582185",
      "client_email": "BAEZYERA356@GMAIL.COM",
      "address": "MATACABALLO CALLE 5 CASA N 291 PAYA",
      "client_identification": "V24173201",
      "nap_box_name": "CTO-00180",
      "created_at": "2024-09-04T16:11:29.646022",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6628,
      "client_name": "JESUS ABRAHAN GOMEZ MONZON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Terrazas de Paya",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04242762262",
      "client_email": "JESUSABRAHAMGOMEZ0@GMAIL.COM",
      "address": "TERRAZAS DE PAYA, MANZANA · 9 CASA 10",
      "client_identification": "V26523602",
      "nap_box_name": "CTO-00249",
      "created_at": "2024-09-04T16:17:55.345150",
      "service_detail": {
        "id": 11480,
        "ip": "172.31.163.2",
        "mac": "OEMT3C624CEA",
        "serial": "OEMT3C624CEA",
        "queue": null,
        "interface": "VLAN243_BICENTENARIO",
        "created_at": "2026-02-04T15:53:06.172975",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6629,
      "client_name": "LUIS ALEXANDER PEREZ GUZMAN",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Bicentenario",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128988886",
      "client_email": "LUISALEXANDERPEREZ79@GMAIL.COM",
      "address": "URB BICENTENARIO MANZANA 12",
      "client_identification": "V14104468",
      "nap_box_name": "379",
      "created_at": "2024-09-04T16:25:00.675692",
      "service_detail": {
        "id": 6552,
        "ip": "172.31.164.2",
        "mac": "OEMT3C62528A",
        "serial": "OEMT3C62528A",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN243_BICENTENARIO",
        "created_at": "2024-09-05T09:14:28.763042",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6630,
      "client_name": "AURA MARINA LANDAETA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Bosque",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04123988413",
      "client_email": "AURAMARINALANDAETA@GMAIL.COM",
      "address": "CALLE ANTONIO JOSE DE SUCRE CASA N 14 SECTOR EL BOSQUE ROSARIO DE PAYA",
      "client_identification": "V17175546",
      "nap_box_name": "CE - 851",
      "created_at": "2024-09-04T16:40:22.770828",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6631,
      "client_name": "JOELSCHOES Y MUCHO MAS CA",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04120334570",
      "client_email": "GUS21TAVO@HOTMAIL.COM",
      "address": "CALLE MARIÑO COMUNA 13 DE ENERO PASILLO 1 LOCAL N 18 TURMERO",
      "client_identification": "J502475320",
      "nap_box_name": "CTO-00256",
      "created_at": "2024-09-04T16:59:06.309591",
      "service_detail": {
        "id": 6618,
        "ip": "172.31.167.2",
        "mac": "OEMT3C622972",
        "serial": "OEMT3C622972",
        "queue": "Plan_92036_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-09-12T17:08:09.522677",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6632,
      "client_name": "MARIANNY DANIELA ZAPATA SANCHEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Luz y Vida",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04127768773",
      "client_email": "MARIANNYSZ2311@GMAIL.COM",
      "address": "CALLE 03 LA CANDELARIA CASA N 164 SECTOR LUZ Y VIDA",
      "client_identification": "V21071241",
      "nap_box_name": "CTO-00249",
      "created_at": "2024-09-04T17:07:12.628779",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6633,
      "client_name": "ANGEL RAFAEL SAVATTERI GARCIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Valle Verde",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04127427650",
      "client_email": "ANEELSAVATTIERI@GMAIL.COM",
      "address": "CALLE BOLIVAR CASA N 23 VALLE VERDE PAYA",
      "client_identification": "V13907063",
      "nap_box_name": "CTO-0613",
      "created_at": "2024-09-04T17:36:23.225195",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6634,
      "client_name": "RICARDO ANTONIO GARBOZA VILLALOBOS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04149465441",
      "client_email": "RIKARDO23121994@GMAIL.COM",
      "address": "CALLE BERMUDEZ, CALLEJON BERMUDEZ, CASA NRO 10B, SECTOR CASCO CENTRAL TURMERO",
      "client_identification": "V23919510",
      "nap_box_name": "CTO - 942",
      "created_at": "2024-09-05T15:39:33.128488",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6635,
      "client_name": "FABIOLA RODRIGUEZ CARMONA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Paya Abajo",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243317755",
      "client_email": "VICTORAMADOR0116@GMAIL.COM",
      "address": "CALLE PRINCIPAL CASA NRO 2 SECTOR PAYA ABAJO ROSARIO DE PAYA ARAGUA",
      "client_identification": "V15490667",
      "nap_box_name": "CE - 773",
      "created_at": "2024-09-05T16:23:46.085952",
      "service_detail": {
        "id": 10734,
        "ip": "172.31.170.2",
        "mac": "OEMT3C6251DA",
        "serial": "OEMT3C6251DA",
        "queue": null,
        "interface": "VLAN231_PAYABAJO",
        "created_at": "2025-12-15T14:47:14.297213",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6636,
      "client_name": "MICHELL YHAINILIN VELASQUEZ MARINO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128918928",
      "client_email": "MICHELYHAINILINMARINOVELASQUES@GMAIL.COM",
      "address": "AV PPAL URBANISMO PANTIN CALLE 2-A CASA NRO 2 ROSARIO DE PAYA TURMERO EDO ARAGUA",
      "client_identification": "V28187407",
      "nap_box_name": "CTO-00110",
      "created_at": "2024-09-06T14:12:13.863590",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6637,
      "client_name": "NAIROBIS DAYANA RODRIGUEZ CASTILLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "1ro de Mayo Sur",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128445251",
      "client_email": "NAIROROD@GMAIL.COM",
      "address": "CALLE 02, CASA NRO 09, SECTOR ROSARIO DE PAYA, 1RO DE MAYO SUR, ARAGUA",
      "client_identification": "V20694502",
      "nap_box_name": "CTO-00157",
      "created_at": "2024-09-06T14:55:30.705575",
      "service_detail": {
        "id": 6565,
        "ip": "172.31.172.2",
        "mac": "OEMT3C62531E",
        "serial": "OEMT3C62531E",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN261_1ERO_MAYO_ZTE",
        "created_at": "2024-09-06T15:14:06.536217",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6638,
      "client_name": "FRANCIS COROMOTO GONZALEZ DE LIRA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04123973016",
      "client_email": "Kiritokirigaya1234fhg@gmail.com",
      "address": "CALLE 11-B, CASA NRO 33, SECTOR PANTY, ROSARIO DE PAYA, ARAGUA",
      "client_identification": "V16524608",
      "nap_box_name": "CTO-00170",
      "created_at": "2024-09-06T15:32:16.710959",
      "service_detail": {
        "id": 11908,
        "ip": "172.31.173.2",
        "mac": "OEMT3C624CE2",
        "serial": "OEMT3C624CE2",
        "queue": null,
        "interface": "VLAN229_PANTIN",
        "created_at": "2026-03-02T18:20:28.752921",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6639,
      "client_name": "YECENIA INES GUDINO MORA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04247667345",
      "client_email": "YECENIAGUDINO92@GMAIL.COM",
      "address": "CALLE MATOS CASA NRO 5 SECTOR LOS MANGOS ROSARIO DE PAYA ARAGUA",
      "client_identification": "V13241522",
      "nap_box_name": "222",
      "created_at": "2024-09-06T15:50:46.077251",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6640,
      "client_name": "MARLENE DEL CARMEN PEREZ REAL",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vallecito",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04125975797",
      "client_email": "MP3198847@GMAIL.COM",
      "address": "CALLE LAS FLORES, NRO 8, COLINAS DE VALLECITO, ROSARIO DE PAYA",
      "client_identification": "V12608183",
      "nap_box_name": "CTO-00263",
      "created_at": "2024-09-06T16:07:51.201033",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6641,
      "client_name": "BERNARDA AGUILERA MATOS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Las Rurales",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04125208898",
      "client_email": "AGUILERABERNARDA888@GMAIL.COM",
      "address": "CALLE BOLIVAR, CASA NRO 12, SECTOR LOS RURALES, ROSARIO DE PAYA",
      "client_identification": "V10759559",
      "nap_box_name": "CE - 769",
      "created_at": "2024-09-06T16:23:35.408210",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6642,
      "client_name": "YOANA ELIZABETH MONTERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Durpa",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128835953",
      "client_email": "YOANAMONTERO02@GMAIL.COM",
      "address": "CALLE LIBERTAD MANZANA 16 CASA NRO 2 SECTOR DESARROLLO URBANISTICO DURPA",
      "client_identification": "V18232909",
      "nap_box_name": "377",
      "created_at": "2024-09-07T08:10:48.906209",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6643,
      "client_name": "JESUS ELIAS SALAS FIGUEREDO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 43,
        "name": "RECURRENTE RESIDENCIAL PLAN 650M",
        "cost": "46.00",
        "code": "FOR650M",
        "profile": "650M/650M"
      },
      "client_mobile": "04243047979",
      "client_email": "SALASJESUS512@GMAIL.COM",
      "address": "CALLE 2 CASA # 72 URB MATACABALLO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V19132953",
      "nap_box_name": "CTO-00215",
      "created_at": "2024-09-07T09:28:21.579495",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6644,
      "client_name": "ROMELIA SERRANO RAMIREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128907659",
      "client_email": "JOHANASANTOS643@GMAIL.COM",
      "address": "CALLE NRO 2 SECTOR SAMAN TARAZONERO I",
      "client_identification": "V16677869",
      "nap_box_name": "291",
      "created_at": "2024-09-07T11:38:15.222938",
      "service_detail": {
        "id": 10786,
        "ip": "172.23.144.2",
        "mac": "HWTC48080281",
        "serial": "HWTC48080281",
        "queue": null,
        "interface": "VLAN140_SMT1_ZTE",
        "created_at": "2025-12-17T18:23:40.582654",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6645,
      "client_name": "REINA ISABEL TORREALBA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128872882",
      "client_email": "REINAISATORREALBA@GMAIL.COM",
      "address": "CALLE 3 CASA NRO 120 URB MATA CABALLO ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V8822717",
      "nap_box_name": "CTO-00309",
      "created_at": "2024-09-07T11:58:25.837230",
      "service_detail": {
        "id": 6577,
        "ip": "172.31.177.2",
        "mac": "",
        "serial": "OEMT3C6252D6",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2024-09-09T10:44:07.599692",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6646,
      "client_name": "JULIO ADOLFO GONZALEZ RIOS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243564235",
      "client_email": "JULIOGONZALESRIOS456@GMAIL.COM",
      "address": "CALLE 10 CASA # 619C URB MATACABALLO ROSARIO DE PAYA ZONA POSTAL 2115",
      "client_identification": "V15601073",
      "nap_box_name": "CTO-00569",
      "created_at": "2024-09-07T12:37:22.096029",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6647,
      "client_name": "MEYBER ENGLIS MENDEZ MECIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Guanarito",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04140530541",
      "client_email": "PERALTAMAYBE42@GMAIL.COM",
      "address": "VDA RUIZ PINEDA CASA # 16 SECTOR GUANARITO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V25651113",
      "nap_box_name": "CTO-00214",
      "created_at": "2024-09-07T12:47:39.870548",
      "service_detail": {
        "id": 12923,
        "ip": "172.31.179.2",
        "mac": "68:9F:F0:2A:89:1F",
        "serial": "ZXICCDB301B9",
        "queue": null,
        "interface": "VLAN232_GUANARITO_OLT2",
        "created_at": "2026-08-29T09:54:44.546718",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6648,
      "client_name": "LAURA AURISTELA AVILAN MANZO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04260341263",
      "client_email": "AVILANLAURA@GMAIL.COM",
      "address": "CALLE 11, CASA NRO 653-C, URB MATACABALLO, ROSARIO DE PAYA, ARAGUA",
      "client_identification": "V12158671",
      "nap_box_name": "CTO-00022",
      "created_at": "2024-09-09T10:20:59.704482",
      "service_detail": {
        "id": 6580,
        "ip": "172.31.180.2",
        "mac": "",
        "serial": "OEMT3C6251AA",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2024-09-09T10:49:09.190444",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6649,
      "client_name": "OASIS 28 CA",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04140495878",
      "client_email": "REIDY151095@GMAIL.COM",
      "address": "AV RICAURTE CRUCE CON CALLE MARIÑO LOCAL NRO 4 SECTOR CASCO TURMERO",
      "client_identification": "J500220847",
      "nap_box_name": "CTO-00266",
      "created_at": "2024-09-09T13:48:06.833129",
      "service_detail": {
        "id": 6601,
        "ip": "172.31.182.2",
        "mac": "OEMT3C624B0A",
        "serial": "OEMT3C624B0A",
        "queue": "Plan_92036_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-09-11T17:10:47.964096",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6650,
      "client_name": "YELIVIC MARIA RODRIGUEZ ZAMBRANO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04145903864",
      "client_email": "YELMAROZAM@GMAIL.COM",
      "address": "CALLE 3, CASA 150, MATA CABALLO, ROSARIO DE PAYA, TURMERO",
      "client_identification": "V16436392",
      "nap_box_name": "CTO-00094",
      "created_at": "2024-09-09T14:05:02.564912",
      "service_detail": {
        "id": 6582,
        "ip": "172.31.181.2",
        "mac": "",
        "serial": "OEMT3C622CA6",
        "queue": "Plan_161905_30183_WispHub",
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2024-09-09T15:11:08.668570",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6651,
      "client_name": "ALEXANDER GREGORIO RODRIGUEZ QUINTANA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados de Cafetal",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04122988360",
      "client_email": "RODRIGUEZQUIMTANA@GMAIL.COM",
      "address": "CALLE 1 PARCELA NRO 6 CASA NRO 7 PRADOS EL CAFETAL ROSARIO DE PAYA",
      "client_identification": "V15129679",
      "nap_box_name": "544",
      "created_at": "2024-09-09T16:12:21.123639",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6652,
      "client_name": "ARGELIA SHUGEIL CAMPO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243286182",
      "client_email": "ARGELIACAMPO74@GMAIL.COM",
      "address": "CALLE 11, CASA NRO 642-A, MATACABALLO, ARAGUA",
      "client_identification": "V12926967",
      "nap_box_name": "CTO-00213",
      "created_at": "2024-09-10T12:27:23.677780",
      "service_detail": {
        "id": 10490,
        "ip": "172.31.184.2",
        "mac": "OEMT3C624D9E",
        "serial": "OEMT3C624D9E",
        "queue": null,
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2025-12-02T15:59:40.540203",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6653,
      "client_name": "CARLOS HUGO VOLCAN BADILLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Antigua Hacienda De Paya",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04143457066",
      "client_email": "CARLOSHVOLCANB@GMAIL.COM",
      "address": "CALLE LOS CEDROS Nº 8 CASA Nº 8 URB ANTIGUA HACIENDA PAYA ROSARIO DE PAYA ARAGUA",
      "client_identification": "V5642873",
      "nap_box_name": "CTO-00218 ",
      "created_at": "2024-09-10T16:49:37.328514",
      "service_detail": {
        "id": 6595,
        "ip": "172.31.185.2",
        "mac": "OEMT3C622446",
        "serial": "OEMT3C622446",
        "queue": "Plan_92194_15811_WispHub",
        "interface": "VLAN202_AHP_OLT1",
        "created_at": "2024-09-11T09:23:18.097499",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6654,
      "client_name": "OSCAR ENRIQUE PERDOMO NIEVES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Residencias Mariño",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144430076",
      "client_email": "OEPN1567@GMAIL.COM",
      "address": "CALLE MARIÑO, EDIF RESD MARIÑO TORRE B PISO 13 APT 113 ZONA CASCO CENTRAL TURMERO ARAGUA",
      "client_identification": "V13770803",
      "nap_box_name": "CTO-0519",
      "created_at": "2024-09-11T13:16:52.310212",
      "service_detail": {
        "id": 6597,
        "ip": "172.31.186.2",
        "mac": "OEMT3C624D7A",
        "serial": "OEMT3C624D7A",
        "queue": "Plan_127996_15811_WispHub",
        "interface": "VLAN234_R_MARINO_OLT2",
        "created_at": "2024-09-11T15:10:30.974316",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6655,
      "client_name": "MIRIAM ANGELINA CASTILLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Las Rurales",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04125313469",
      "client_email": "MIRIANCASTILLO788@GMAIL.COM",
      "address": "LAS RURALES, CALLE 105, CASA NRO 95, CALLE CIEGA, ROSARIO DE PAYA",
      "client_identification": "V4232788",
      "nap_box_name": "CTO-00200",
      "created_at": "2024-09-11T13:31:01.342997",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6656,
      "client_name": "NELSON JR CAMPOS HERNANDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128670392",
      "client_email": "CAMPOSJRNELSON@GMAIL.COM",
      "address": "URB. MATA CABALLO CALLE 6 CASA 424, ROSARIO DE PAYA, ARAGUA",
      "client_identification": "V27520205",
      "nap_box_name": "417",
      "created_at": "2024-09-11T13:53:56.000030",
      "service_detail": {
        "id": 6599,
        "ip": "172.31.188.2",
        "mac": "OEMT3C625192",
        "serial": "OEMT3C625192",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2024-09-11T15:17:19.233736",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6657,
      "client_name": "ENDER ALBERTO PEREZ RAMIREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Valle Verde",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04125798635",
      "client_email": "ENDERR258@GMAIL.COM",
      "address": "CALLE SUCRE CON BOLIVAR CASA NRO 9-A BARRIO VALLE VERDE ROSARIO DE PAYA ARAGUA",
      "client_identification": "V27864123",
      "nap_box_name": "CE - 691",
      "created_at": "2024-09-11T15:32:20.431544",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6658,
      "client_name": "YULESKI COROMOTO SANCHEZ SILVERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Bosque",
      "plan": {
        "id": 43,
        "name": "RECURRENTE RESIDENCIAL PLAN 650M",
        "cost": "46.00",
        "code": "FOR650M",
        "profile": "650M/650M"
      },
      "client_mobile": "04128900375",
      "client_email": "YULESKISANCHEZ1@GMAIL.COM",
      "address": "CALLE INTERCOMUNAL C-C FCO DE MIRANDA CRUCE CON PAEZ CASA NRO B-15 SECTOR ROSARIO DE PAYA ARAGUA",
      "client_identification": "V17245600",
      "nap_box_name": "CTO-00241",
      "created_at": "2024-09-11T15:54:20.516096",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6659,
      "client_name": "OSGLENNY FRANYELI DAVILA JUAREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04122921739",
      "client_email": "OSGLENNYDAVILA@GMAIL.COM",
      "address": "CALLE 2 CASA NRO 38 BARRIO VIRGEN DE LA COROMOTO GUANARITO TURMERO ARAGUA",
      "client_identification": "V26935386",
      "nap_box_name": "CTO-00118 DOS",
      "created_at": "2024-09-11T16:09:35.157877",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6660,
      "client_name": "LIZETH SILENIA OJEDA MONSALVE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124778649",
      "client_email": "LSOM2503@GMAIL.COM",
      "address": "CALLE 16-A CASA NRO 31 URB PANTIN TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V13049703",
      "nap_box_name": "CTO-00195",
      "created_at": "2024-09-11T20:58:02.073662",
      "service_detail": {
        "id": 6606,
        "ip": "172.28.216.2",
        "mac": "HWTC2A5F52A1",
        "serial": "HWTC2A5F52A1",
        "queue": "Plan_161906_30183_WispHub",
        "interface": "VLAN229_PANTIN",
        "created_at": "2024-09-11T21:03:26.562577",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6661,
      "client_name": "LIZETH SILENIA OJEDA MONSALVE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Simon Bolivar",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124778649",
      "client_email": "LSOM2503@GMAIL.COM",
      "address": "CALLE 3 CASA NRO 28 BARRIO SIMON BOLIVAR TURMERO ARAGUA",
      "client_identification": "V13049703",
      "nap_box_name": "CTO-00045",
      "created_at": "2024-09-11T20:59:43.671051",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6662,
      "client_name": "CRISTIAN GIOVANNI LOPEZ ALFONZO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Terrazas de Paya",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243215042",
      "client_email": "CRISTIAN21203878@GMAIL.COM",
      "address": "TERRAZAS DE PAYA CALLE 3 CASA 3 ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V21203878",
      "nap_box_name": "0165",
      "created_at": "2024-09-11T21:08:44.012773",
      "service_detail": {
        "id": 12359,
        "ip": "172.28.93.2",
        "mac": "ZICGD3E36A66",
        "serial": "ZICGD3E36A66",
        "queue": null,
        "interface": "VLAN255_TERRAZAS_PAYA",
        "created_at": "2026-04-18T18:41:13.346431",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6663,
      "client_name": "ESTEFANI ALEJANDRA TORREALBA PARRA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Residencias Mariño",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243200242",
      "client_email": "ESTEFANYTORREALBA87@GMAIL.COM",
      "address": "CALLE MARIÑO EDIF TORRE C PLANTA TIPO PISO 2 APT 23-C CONJUNTO RESIDENCIAL MARIÑO TURMERO ARAGUA",
      "client_identification": "V31161166",
      "nap_box_name": "CTO-0520",
      "created_at": "2024-09-12T14:24:29.185015",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6664,
      "client_name": "INSTITUTO MUNICIPAL DE ATENCION INTEGRAL A LA MUJER",
      "client_type_name": "PYME",
      "client_subdivision": "CANCELADO_PYME",
      "status_name": "Cancelado",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 36,
        "name": "RECURRENTE PYME PLAN 650M",
        "cost": "70.18",
        "code": "FOP650M",
        "profile": "650M/650M"
      },
      "client_mobile": "04129693208",
      "client_email": "COMPRASINSTITUTOMUJER@GMAIL.COM",
      "address": "CALLE MARIÑO CASA NRO 39 ZONA CENTRO DE TURMERO ARAGUA",
      "client_identification": "G200130067",
      "nap_box_name": "CE-00009",
      "created_at": "2024-09-12T14:56:02.558026",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6665,
      "client_name": "MIRIELY ROSSANA LLOVERA CORTEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vallecito",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121480481",
      "client_email": "MIRIELYLL02@GMAIL.COM",
      "address": "CALLE EL SAMAN CASA NRO 02 SECTOR VALLECITO ROSARIO DE PAYA ARAGUA",
      "client_identification": "V17576303",
      "nap_box_name": "CTO-0479",
      "created_at": "2024-09-12T15:50:51.605033",
      "service_detail": {
        "id": 6617,
        "ip": "172.31.194.2",
        "mac": "OEMT3C6252EE",
        "serial": "OEMT3C6252EE",
        "queue": "queue1",
        "interface": "VLAN258_VALLECITO",
        "created_at": "2024-09-12T16:41:41.930680",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6666,
      "client_name": "MERY YEN PALENCIA LEON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Santa Eduviges",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243741378",
      "client_email": "PALENCIALEONMERYYEN@GMAIL.COM",
      "address": "CALLE SANTA INES N 3 SANTA EDUVIGES",
      "client_identification": "V11090304",
      "nap_box_name": "87 DOS",
      "created_at": "2024-09-12T21:56:56.233974",
      "service_detail": {
        "id": 11428,
        "ip": "10.13.80.2",
        "mac": "MONU00368339",
        "serial": "MONU00368339",
        "queue": null,
        "interface": "VLAN127_SANTA_EDUVIGES",
        "created_at": "2026-01-30T18:39:41.525813",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6667,
      "client_name": "LEANRY DEL VALLE RUBIO DE BRICEÑO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Simon Bolivar",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121483714",
      "client_email": "LEANRYR@GMAIL.COM",
      "address": "CALLE 5 CASA NRO 41 URB SIMON BOLIVAR TURMERO",
      "client_identification": "V13610842",
      "nap_box_name": "CTO-00001",
      "created_at": "2024-09-16T10:43:30.552907",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6668,
      "client_name": "CARLOS ALEXANDER SEQUERA GONZALEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Palma Real",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124193308",
      "client_email": "SEQUERACARLOS36@GMAIL.COM",
      "address": "CALLE 2 CASA NRO 26 PALMA REAL TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V30705792",
      "nap_box_name": "400",
      "created_at": "2024-09-17T12:44:43.076496",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6669,
      "client_name": "YORLING CAROLINA PEREZ GONZALEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Palmeras II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128901261",
      "client_email": "YORLINGPEREZ574@GMAIL.COM",
      "address": "CALLE MANZANA D-15 CASA NRO 14 URB SAMAN TARAZONERO II TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V25880890",
      "nap_box_name": "336",
      "created_at": "2024-09-17T14:00:04.368154",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6670,
      "client_name": "SAMUEL ABRAHAM MONTOYA MARQUEZ",
      "client_type_name": "EMPLEADO",
      "client_subdivision": "ACTIVO_EMPLEADO",
      "status_name": "Activo",
      "cycle": 25,
      "migrate": false,
      "sector_name": "La Magdalena",
      "plan": {
        "id": 78,
        "name": "Plan empleado 80MB",
        "cost": "0.00",
        "code": "FO-80M",
        "profile": "80M/80M"
      },
      "client_mobile": "04124581775",
      "client_email": "SAMUELMONTOYAM1529@GMAIL.COM",
      "address": "SAMAN TARAZONERO 2 MANZANA B-8 CASA NRO 12 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V30073055",
      "nap_box_name": "CTO - 946",
      "created_at": "2024-09-17T14:23:33.805244",
      "service_detail": {
        "id": 12897,
        "ip": "172.31.17.2",
        "mac": "OE:MT:3C:62:26:62",
        "serial": "OEMT3C622662",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2026-08-21T19:36:02.782516",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6671,
      "client_name": "MICHAELA ALESSANDRA RANDAZZO LOMBARDO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243405245",
      "client_email": "MICHARADIO@GMAIL.COM",
      "address": "CALLE URDANETA CASA NRO 41 URB LOS NISPEROS TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V13954718",
      "nap_box_name": "CTO-00246",
      "created_at": "2024-09-17T14:35:00.046410",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6672,
      "client_name": "SERGIO FERNANDO ESPINOZA PEÑA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 43,
        "name": "RECURRENTE RESIDENCIAL PLAN 650M",
        "cost": "46.00",
        "code": "FOR650M",
        "profile": "650M/650M"
      },
      "client_mobile": "04124326901",
      "client_email": "SERGIOESPINOZA1527@GMAIL.COM",
      "address": "CALLE PANTIN A CASA NRO 20 URB. PANTIN TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V19515977",
      "nap_box_name": "CTO-00126",
      "created_at": "2024-09-17T15:44:37.040929",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6673,
      "client_name": "MERVIDA COROMOTO LAREZ CONTRERAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243304527",
      "client_email": "LAREZMERVI@GMAIL.COM",
      "address": "CALLE 27 CASA NRO 27 SECTOR RIO SECO ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V14741842",
      "nap_box_name": "CTO-00321",
      "created_at": "2024-09-17T16:12:23.024993",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6674,
      "client_name": "CARLYS VALERIA GARCIA CASTRO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243008662",
      "client_email": "VALERIA142CASTRO@GMAIL.COM",
      "address": "PRADOS I CALLE7 CASA #1",
      "client_identification": "V29786822",
      "nap_box_name": "CTO-00449",
      "created_at": "2024-09-17T16:13:50.399168",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6675,
      "client_name": "HILDA JOSEFINA RAMOS MUÑOZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Cambur",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243661490",
      "client_email": "HILDARAMOSISAAC4@GMAIL.COM",
      "address": "CALLE PRINCI.CALLEJON VARGAS, CASA NRO 8 SECTOR EL CAMBUR ROSARIO DE PAYA, TURMERO ESTADO ARAGUA ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V9891656",
      "nap_box_name": "CE-00033",
      "created_at": "2024-09-17T16:14:17.445275",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6676,
      "client_name": "ORIANA ESMERITA ANGARITA MARTINEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Durpa",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04142515833",
      "client_email": "ORIANA17ANGARITA@GMAIL.COM",
      "address": "CALLE LOS CAOBOS MANZANA 18 CASA N 9 DESARROLLO URBANÍSTICO",
      "client_identification": "V21596867",
      "nap_box_name": "392",
      "created_at": "2024-09-17T16:21:55.824501",
      "service_detail": {
        "id": 11869,
        "ip": "172.31.204.2",
        "mac": "OEMT3C62449A",
        "serial": "OEMT3C62449A",
        "queue": null,
        "interface": "VLAN240_DURPA",
        "created_at": "2026-02-28T19:31:55.898607",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6677,
      "client_name": "MARIA TIBISAY CADENAS AGUIRRE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Antigua Hacienda De Paya",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243287866",
      "client_email": "TIBISAYRIVERO277@GMAIL.COM",
      "address": "CALLE LOS CEDROS CASA NRO 9 SECTOR LA ANTIGUA HACIENDA ROSARIO DE PAYA ARAGUA ZONA POSTAL 215",
      "client_identification": "V9647031",
      "nap_box_name": "CTO-00218 ",
      "created_at": "2024-09-17T16:26:58.987112",
      "service_detail": {
        "id": 6685,
        "ip": "172.31.200.2",
        "mac": "OEMT3C6245DE",
        "serial": "OEMT3C6245DE",
        "queue": "Plan_92194_15811_WispHub",
        "interface": "VLAN202_AHP_OLT1",
        "created_at": "2024-09-18T09:21:44.226024",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6678,
      "client_name": "ARIELBA ISAMAR RAMOS MUÑOZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Cambur",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128728687",
      "client_email": "ISAJAVIISAAC@GMAIL.COM",
      "address": "AV PRINCIPAL LAS MERCEDES CASA NRO 114-1 SECTOR EL CAMBUR ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V19605641",
      "nap_box_name": "CTO-00244",
      "created_at": "2024-09-17T16:41:00.961505",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6679,
      "client_name": "NANCY JOSEFINA ROMERO POLANCO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243597106",
      "client_email": "nanrom888@gmail.com",
      "address": "SAMAN TARAZONERO II CASA 11 MANZANA B9",
      "client_identification": "V6312888",
      "nap_box_name": "CTO-00511",
      "created_at": "2024-09-18T16:09:52.320645",
      "service_detail": {
        "id": 12876,
        "ip": "172.31.205.2",
        "mac": "OE:MT:3C:62:4A:96",
        "serial": "OEMT3C624A96",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2026-08-18T15:30:56.296107",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6680,
      "client_name": "GABRIELVIS ENMANUELI MATOS RUI",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243766000",
      "client_email": "GABRIELVISMATOS515@GMAIL.COM",
      "address": "CALLE NRO 6 CASA NRO 402 URB MATACABALLO ROSARIO DE PAYA",
      "client_identification": "V26791043",
      "nap_box_name": "CTO-00567 DOS",
      "created_at": "2024-09-18T16:12:14.131044",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6681,
      "client_name": "JAISON ALBERTO PACHECO ACOSTA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Las Rurales",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04122746882",
      "client_email": "ALBERTOJAIP07@GMAIL.COM",
      "address": "CALLE MIGUEL POLEO CASA N17 SECTOR LAS RURALES ROSARIO DE PAYA",
      "client_identification": "V27048648",
      "nap_box_name": "CE - 650",
      "created_at": "2024-09-18T16:18:41.807704",
      "service_detail": {
        "id": 6720,
        "ip": "172.31.207.2",
        "mac": "OEMT3C6244B6",
        "serial": "OEMT3C6244B6",
        "queue": "Plan_161869_30181_WispHub",
        "interface": "VLAN252_RURALES_PAYA",
        "created_at": "2024-09-19T10:17:38.992868",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6682,
      "client_name": "EDEN ANTONIO MENDOZA CORDERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Terrazas de Paya",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121491414",
      "client_email": "EDEN20684@GMAIL.COM",
      "address": "URB TERRAZAS DE PAYA  MANZANA 3 CASA NRO 09 ROSARIO DE PAYA",
      "client_identification": "V16434347",
      "nap_box_name": "421",
      "created_at": "2024-09-18T16:23:31.733015",
      "service_detail": {
        "id": 11655,
        "ip": "172.31.211.2",
        "mac": "OEMT3C624902",
        "serial": "OEMT3C624902",
        "queue": null,
        "interface": "VLAN243_BICENTENARIO",
        "created_at": "2026-02-18T09:08:38.644969",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6683,
      "client_name": "ELIZABETH UGUETO MARTINEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04248125536",
      "client_email": "ELIUGUETMAR@GMAIL.COM",
      "address": "EZEQUIEL ZAMORA TORRE CAYEAPE*3 PISO 2 APART 5",
      "client_identification": "V5116462",
      "nap_box_name": "130",
      "created_at": "2024-09-18T16:26:52.952118",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6684,
      "client_name": "NORVELLY MARBELL HENRIQUEZ ACOSTA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Durpa",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121483895",
      "client_email": "HENRIQUEZNORVELLYS@GMAIL.COM",
      "address": "URB FUNDA BARRIOS CALLE FRANCISCO DE MIRANDA MANZANA A CASA 37 PAYA",
      "client_identification": "V12338428",
      "nap_box_name": "389",
      "created_at": "2024-09-18T17:15:17.435730",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6685,
      "client_name": "ALCALDIA DEL MUNICIPIO SANTIAGO MARIÑO",
      "client_type_name": "INTERCAMBIO",
      "client_subdivision": "ACTIVO_INTERCAMBIO",
      "status_name": "Activo",
      "cycle": 25,
      "migrate": false,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 83,
        "name": "RECURRENTE INSTITUCIONAL 80M",
        "cost": "0.00",
        "code": "FO-R80",
        "profile": "80M/80M"
      },
      "client_mobile": "04120296278",
      "client_email": "ADMON.ALCALDIAMARINO@GMAIL.COM",
      "address": "AV PRINCIPAL EDIF ALCALDIA PISO PB OF ALCALDIA URB VALLE LINDO TURMERO",
      "client_identification": "G200036826",
      "nap_box_name": "110",
      "created_at": "2024-09-19T08:07:29.488452",
      "service_detail": {
        "id": 9968,
        "ip": "172.20.150.2",
        "mac": "TPLG2ABDC7AD",
        "serial": "TPLG2ABDC7AD",
        "queue": null,
        "interface": "VLAN277_ALCALDIA",
        "created_at": "2025-11-11T11:27:13.432716",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6686,
      "client_name": "POLICIA MUNICIPAL SANTIAGO MARINO",
      "client_type_name": "INTERCAMBIO",
      "client_subdivision": "ACTIVO_INTERCAMBIO",
      "status_name": "Activo",
      "cycle": 25,
      "migrate": false,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 83,
        "name": "RECURRENTE INSTITUCIONAL 80M",
        "cost": "0.00",
        "code": "FO-R80",
        "profile": "80M/80M"
      },
      "client_mobile": "04128472680",
      "client_email": "NE7@NE.COM",
      "address": "CALLE PROLONGACIÓN AV BOLIVAR  SECTOR CENTRO TURMERO ARAGUA",
      "client_identification": "G200051337",
      "nap_box_name": "88",
      "created_at": "2024-09-19T08:19:43.680029",
      "service_detail": {
        "id": 6711,
        "ip": "172.19.149.2",
        "mac": "GPON0097B596",
        "serial": "GPON0097B596",
        "queue": "Plan_121695_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-09-19T08:20:56.803048",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6687,
      "client_name": "ANA JAQUELIN GUAITA AVILA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "1ro de Mayo Norte",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04129681664",
      "client_email": "ANAGUAITA2015@GMAIL.COM",
      "address": "1ERO DE MAYO NORTE CALLE PARAMACONI CASA N 36 ROSARIO DE PAYA",
      "client_identification": "V16268592",
      "nap_box_name": "CTO-00235",
      "created_at": "2024-09-19T08:20:38.708301",
      "service_detail": {
        "id": 13135,
        "ip": "172.31.208.2",
        "mac": "OE:MT:3C:62:53:EE",
        "serial": "OEMT3C6253EE",
        "queue": null,
        "interface": "VLAN261_1ERO_MAYO_ZTE",
        "created_at": "2026-10-07T16:51:32.624461",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6688,
      "client_name": "PNB TRANSITO ARC INSPECTOR BRACHO",
      "client_type_name": "INTERCAMBIO",
      "client_subdivision": "ACTIVO_INTERCAMBIO",
      "status_name": "Activo",
      "cycle": 25,
      "migrate": false,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 83,
        "name": "RECURRENTE INSTITUCIONAL 80M",
        "cost": "0.00",
        "code": "FO-R80",
        "profile": "80M/80M"
      },
      "client_mobile": "04267415025",
      "client_email": "RRHHSTARC@GMAIL.COM",
      "address": "COMISARÍA SAMÁN DE GÜERE INTERCOMUNAL TURMERO - MARACAY",
      "client_identification": "G200093277",
      "nap_box_name": "660",
      "created_at": "2024-09-19T08:25:31.381416",
      "service_detail": {
        "id": 6712,
        "ip": "172.20.194.2",
        "mac": "GPON0097C486",
        "serial": "GPON0097C486",
        "queue": "Plan_14173_1574_WispHub",
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2024-09-19T08:29:23.913778",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6689,
      "client_name": "JESUS ANTONIO FRANCO  GINFRIDDO",
      "client_type_name": "INTERCAMBIO",
      "client_subdivision": "ACTIVO_INTERCAMBIO",
      "status_name": "Activo",
      "cycle": 25,
      "migrate": false,
      "sector_name": "La Aduana",
      "plan": {
        "id": 83,
        "name": "RECURRENTE INSTITUCIONAL 80M",
        "cost": "0.00",
        "code": "FO-R80",
        "profile": "80M/80M"
      },
      "client_mobile": "04144436993",
      "client_email": "FRANCOGINFRIDDO@GMAIL.COM",
      "address": "PROLONGACION CALLE BERMUDEZ NEO 84  AL LADO DEL CDI LA  ADUANA TURMERO",
      "client_identification": "V14882813",
      "nap_box_name": "ROSETA PROTECCION CIVIL",
      "created_at": "2024-09-19T08:52:38.700893",
      "service_detail": {
        "id": 10003,
        "ip": "172.22.51.2",
        "mac": "TPLGB68B538E",
        "serial": "TPLGB68B538E",
        "queue": null,
        "interface": "VLAN200_OLTs",
        "created_at": "2025-11-11T14:20:16.848868",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6690,
      "client_name": "COMANDO POLICIA TURMERO",
      "client_type_name": "INTERCAMBIO",
      "client_subdivision": "ACTIVO_INTERCAMBIO",
      "status_name": "Activo",
      "cycle": 25,
      "migrate": false,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 83,
        "name": "RECURRENTE INSTITUCIONAL 80M",
        "cost": "0.00",
        "code": "FO-R80",
        "profile": "80M/80M"
      },
      "client_mobile": "04243490505",
      "client_email": "MAIGLEYOLIMAR@GMAIL.COM",
      "address": "TURMERO, CALLE PETIÓN, EDIF CICPC TURMERO, FRENTE AL CONCEJO MUNICIPA",
      "client_identification": "G200005246",
      "nap_box_name": "CTO-00037",
      "created_at": "2024-09-19T09:31:28.190851",
      "service_detail": {
        "id": 6716,
        "ip": "172.20.49.2",
        "mac": "TPLGB8628369",
        "serial": "TPLGB8628369",
        "queue": "Plan_121695_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-09-19T09:32:44.741993",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6691,
      "client_name": "RHONNY ENRIQUE HERNANDEZ BRICEÑO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Taguapire",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04143453330",
      "client_email": "HERNANDEZRHONNY17@GMAIL.COM",
      "address": "AV TURMERO EL MACARO EDIF MODULO 07 APTO 63 URB TAGUAPIRE TURMERO ARAGUA ZONA POSTAL 215",
      "client_identification": "V15859922",
      "nap_box_name": "CTO-00386",
      "created_at": "2024-09-19T14:21:20.268110",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6693,
      "client_name": "GLADYS GISELA ROSALES TABARES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04121378279",
      "client_email": "GISELQROSALES@GMAIL.COM",
      "address": "RIO SECO CALLE 19 CASA 52 PAYA",
      "client_identification": "V7226844",
      "nap_box_name": "CTO-00018",
      "created_at": "2024-09-19T16:18:29.246841",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6694,
      "client_name": "JESUS SALVADOR VARGAS DUARTE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Terrazas de Juan Pablo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144879381",
      "client_email": "JESUSCPA14@GMAIL.COM",
      "address": "CALLE LA LLANERA EDF. D PISO PB APT 6 CONJUNTO RESIDENCIAL TERRAZAS DE JUAN PABLO",
      "client_identification": "V30161667",
      "nap_box_name": "12",
      "created_at": "2024-09-22T17:33:35.087935",
      "service_detail": {
        "id": 6731,
        "ip": "172.19.47.2",
        "mac": "TPLGF5CB0245",
        "serial": "TPLGF5CB0245",
        "queue": "Plan_131337_24341_WispHub",
        "interface": "VLAN100_OLTs",
        "created_at": "2024-09-22T18:11:55.178446",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6695,
      "client_name": "OJAIRA ADONIS HERNANDEZ CANALES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04125802638",
      "client_email": "OJAIRAAHC@GMAIL.COM",
      "address": "CALLE 1 CASA NRO 5 URB TAGUAPIRE EL MACARO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V18908028",
      "nap_box_name": "CTO-931",
      "created_at": "2024-09-23T14:52:55.968239",
      "service_detail": {
        "id": 6733,
        "ip": "172.31.215.2",
        "mac": "OEMT3C624F76",
        "serial": "OEMT3C624F76",
        "queue": "Plan_127996_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-09-24T08:25:45.679804",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6696,
      "client_name": "DEIVID ENRIQUE SALAZAR ALVAREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Sector los Mangos",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04124631565",
      "client_email": "Deividsalazar16@gmail.com",
      "address": "CALLE LOS JABILLOS CASA N°13 URBANIZACION VALLECITO TURMERO",
      "client_identification": "V26535386",
      "nap_box_name": "CTO-00223",
      "created_at": "2024-09-24T11:01:14.470448",
      "service_detail": {
        "id": 6734,
        "ip": "172.31.216.2",
        "mac": "ADCGCCA4FC6B",
        "serial": "ADCGCCA4FC6B",
        "queue": "Plan_161900_30183_WispHub",
        "interface": "VLAN267_LOS_MANGOS_ZTE",
        "created_at": "2024-09-24T16:07:22.763492",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6697,
      "client_name": "JULIO CESAR PALMA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Las Rurales",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243632700",
      "client_email": "EUNICESLESNY@GMAIL.COM",
      "address": "CALLE AFINLOQUIO CASA N -P3 SECTOR VALLE DE PAYA ROSARIO DE PAYA",
      "client_identification": "V10457577",
      "nap_box_name": "CE - 664",
      "created_at": "2024-09-24T15:09:17.857421",
      "service_detail": {
        "id": 6735,
        "ip": "172.31.217.2",
        "mac": "",
        "serial": "OEMT3C624AA2",
        "queue": "Plan_107915_30181_WispHub",
        "interface": "VLAN252_RURALES_PAYA",
        "created_at": "2024-09-24T16:09:04.671868",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6698,
      "client_name": "LUIS ALBERTO DA SILVA POZZO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128227628",
      "client_email": "eileenabreu126@gmail.com",
      "address": "EZEQUIEL ZAMORA TORRE 29 PISO 4 APARTAMENTO 1",
      "client_identification": "V18855497",
      "nap_box_name": "CTO-00207 DOS",
      "created_at": "2024-09-24T16:22:39.204320",
      "service_detail": {
        "id": 6736,
        "ip": "172.31.218.2",
        "mac": "OEMT3C624A52",
        "serial": "OEMT3C624A52",
        "queue": "Plan_92306_15811_WispHub",
        "interface": "VLAN209_ZAMORA_OLT1",
        "created_at": "2024-09-24T17:11:27.819496",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6699,
      "client_name": "ANDREA CAROLINA BARONE FIGUEREDO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona I",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124320864",
      "client_email": "CAROLINABFIGUEREDO@GMAIL.COM",
      "address": "URBANIZACION LA CASONA 1 CALLE 7 CASA N 17 INTERCOMUNAL TURMERO",
      "client_identification": "V20894001",
      "nap_box_name": "410",
      "created_at": "2024-09-24T16:27:16.479365",
      "service_detail": {
        "id": 6737,
        "ip": "172.31.219.2",
        "mac": "OEMT3C622E22",
        "serial": "OEMT3C622E22",
        "queue": "Plan_131337_24341_WispHub",
        "interface": "VLAN109_CASONA_1",
        "created_at": "2024-09-24T17:16:14.307731",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6700,
      "client_name": "ALIDA VICTORIA PRADO HERRERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vallecito",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243588479",
      "client_email": "PRADOHVICTORIA@GMAIL.COM",
      "address": "SECTOR VALLECITO CALLE LA CEIBA CASA18-A",
      "client_identification": "V14943637",
      "nap_box_name": "CTO-00263",
      "created_at": "2024-09-25T10:19:26.298677",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6701,
      "client_name": "CEILA BETSUR HERRERA GOMEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144574934",
      "client_email": "CEILAHERRERA1780@GMAIL.COM",
      "address": "CALLE 7 EDIF TETRAS PISO APT 556-D URB MATACABALLO ROSARIO DE PAYA ZONA POSTAL 21-15",
      "client_identification": "V15037986",
      "nap_box_name": "CTO-00310",
      "created_at": "2024-09-25T10:40:44.809473",
      "service_detail": {
        "id": 10421,
        "ip": "172.31.225.2",
        "mac": "OEMT3C62297A",
        "serial": "OEMT3C62297A",
        "queue": null,
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2025-12-01T13:32:30.484563",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6702,
      "client_name": "JACKSON ENRIQUE LARA SILVA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04145434154",
      "client_email": "YOLIMAR18473@GMAIL.COM",
      "address": "CALLE 7 EDIF TETRA PISO 01 APT 542-D URB MATACABALLO ROSARIO DE PAYA ZONA POSTAL 2115",
      "client_identification": "V15275219",
      "nap_box_name": "CE - 566",
      "created_at": "2024-09-25T10:57:21.826226",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6703,
      "client_name": "DAYCI ARYENAIL BERMUDEZ VILLANUEVA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243034970",
      "client_email": "TYLERYETHAN2018@GMAIL.COM",
      "address": "AV PRINCIPAL EDIF MODULO 12 PISO 1 APT 677-D URB MATACABALLO ROSARIO DE PAYA ZONA POSTAL 2115",
      "client_identification": "V19760482",
      "nap_box_name": "CTO-00215",
      "created_at": "2024-09-25T11:14:29.380143",
      "service_detail": {
        "id": 12498,
        "ip": "172.31.224.2",
        "mac": "a8:bf:3c:62:2d:be",
        "serial": "OEMT3C622DBE",
        "queue": null,
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2026-05-15T13:49:52.594925",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6704,
      "client_name": "YENNIFER MARIANA AVILES RIVERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243383775",
      "client_email": "YENNIFERAVILES33@GMAIL.COM",
      "address": "MATACABALLO CALLE 4 CASA N 241",
      "client_identification": "V17578134",
      "nap_box_name": "CTO-00265",
      "created_at": "2024-09-25T11:27:14.534767",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6705,
      "client_name": "LILIANA KARINA CARRILLO MARIÑO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243158008",
      "client_email": "LILIANA299CARRO@GMAIL.COM",
      "address": "CALLE 5 CASA Nª 377 B ARRIO COMUNIAD BETANIA ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V22954830",
      "nap_box_name": "CTO-00127",
      "created_at": "2024-09-25T11:30:50.349475",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6706,
      "client_name": "GISSEL ANDREINA MENDOZA LOPEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243562429",
      "client_email": "GISSELMENDOZA42@GMAIL.COM",
      "address": "MATACABALLO CALLE 11 CASA 652-C PAYA",
      "client_identification": "V27168624",
      "nap_box_name": "CTO-00022",
      "created_at": "2024-09-25T11:44:22.176333",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6707,
      "client_name": "AMARILIS MAYLEN RIVAS DIAZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243191573",
      "client_email": "RIVASDIAZ86@GMAIL.COM",
      "address": "CALLE 5 A CASA N 8 PANTIN",
      "client_identification": "V19245549",
      "nap_box_name": "CTO-00135",
      "created_at": "2024-09-25T12:27:09.755838",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6708,
      "client_name": "MARIA ELENA OSTO LINARES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 43,
        "name": "RECURRENTE RESIDENCIAL PLAN 650M",
        "cost": "46.00",
        "code": "FOR650M",
        "profile": "650M/650M"
      },
      "client_mobile": "04243044500",
      "client_email": "OSTOLINARES@GMAIL.COM",
      "address": "MATACABALLO CALLE 9 CASA 586",
      "client_identification": "V17247806",
      "nap_box_name": "CE - 566",
      "created_at": "2024-09-25T15:01:47.745279",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6709,
      "client_name": "MARYELIN DESIREE COLMENAREZ RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Taguapire",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124394837",
      "client_email": "MARYELINC@GMAIL.COM",
      "address": "AV PRINCIPAL EL MACARO EDIFI MODULO 8 PB APART 79 TAGUAIPIRE",
      "client_identification": "V18778790",
      "nap_box_name": "CTO-00388 DOS",
      "created_at": "2024-09-25T15:25:41.451435",
      "service_detail": {
        "id": 10497,
        "ip": "172.31.232.2",
        "mac": "OEMT3C62275A",
        "serial": "OEMT3C62275A",
        "queue": null,
        "interface": "VLAN129_TAGUAPIRE_ZTE",
        "created_at": "2025-12-02T17:17:18.215712",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6711,
      "client_name": "DAMASA EIDIDA JIMENEZ DIAZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Terrazas de Paya",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04140397436",
      "client_email": "DAMASAJIMENEZ09@GMAIL.COM",
      "address": "CALLE 2 CASA N 1 SECTOR TERRAZAS DE PAYA",
      "client_identification": "V6204678",
      "nap_box_name": "594",
      "created_at": "2024-09-26T13:04:24.681275",
      "service_detail": {
        "id": 12293,
        "ip": "172.31.233.2",
        "mac": "OEMT3C62282A",
        "serial": "OEMT3C62282A",
        "queue": null,
        "interface": "VLAN255_TERRAZAS_PAYA",
        "created_at": "2026-04-11T10:21:09.693031",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6712,
      "client_name": "JOSE RUBY PEREZ URBINA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144651242",
      "client_email": "JOSE88RUBIPEREZ@GMAIL.COM",
      "address": "CALLE 2 B #54 URB HACIENDA PANTIN",
      "client_identification": "V20287045",
      "nap_box_name": "CTO-00126",
      "created_at": "2024-09-26T13:37:25.442300",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6713,
      "client_name": "WISMAR YORIANA BARRERA HIDALGO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243087515",
      "client_email": "HIDALGOJOANA51@GMAIL.COM",
      "address": "CALLE CEDEÑO TURMERO CASA N 76",
      "client_identification": "V24930155",
      "nap_box_name": "116",
      "created_at": "2024-09-26T15:44:23.023744",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6714,
      "client_name": "PAOLA ISABELLA VIZCAYA CORREA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04122251892",
      "client_email": "PAOISABELLA26@GMAIL.COM",
      "address": "LA CASONA 2 CALLE 13 CASA N 117 INTERCOMUNAL TURMERO",
      "client_identification": "V27864691",
      "nap_box_name": "CTO-00091",
      "created_at": "2024-09-27T15:28:39.440245",
      "service_detail": {
        "id": 9738,
        "ip": "172.31.235.2",
        "mac": "OEMT3C622E7E",
        "serial": "OEMT3C622E7E",
        "queue": null,
        "interface": "VLAN110_CASONA_2",
        "created_at": "2025-11-10T11:30:37.622159",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6715,
      "client_name": "KLEYDER ELIN HERMOSO VITAL",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04125462822",
      "client_email": "KLEYDERELINV@GMAIL.COM",
      "address": "CALLE BOLIVAR CASA # 15 SECTOR LAS MERCEDES DE PAYA ROSARIO DE PAYA ARAGUA",
      "client_identification": "V30971790",
      "nap_box_name": "CTO-435",
      "created_at": "2024-09-28T09:38:56.609858",
      "service_detail": {
        "id": 6757,
        "ip": "172.31.236.2",
        "mac": "OEMT3C622822",
        "serial": "OEMT3C622822",
        "queue": "queue1",
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2024-09-30T09:43:15.144223",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6716,
      "client_name": "ANA KARINA CARREIRA JARDIM",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Vista Hermosa",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144681191",
      "client_email": "ANAKARINACARREIRA14.89@GMAIL.COM",
      "address": "CALLE ROSARIO CASA NRO 30 URB. VISTA HERMOSA ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V19516318",
      "nap_box_name": "CTO-00057 DOS",
      "created_at": "2024-09-28T11:24:12.794972",
      "service_detail": {
        "id": 10246,
        "ip": "172.31.237.2",
        "mac": "OEMT3C62278A",
        "serial": "OEMT3C62278A",
        "queue": null,
        "interface": "VLAN230_VISTA_HERMOSA",
        "created_at": "2025-11-22T10:01:07.425650",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6717,
      "client_name": "YULITZA COROMOTO GUERRERO MONCADA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 101,
        "name": "RECURRENTE RESIDENCIAL PLAN 200M",
        "cost": "19.00",
        "code": "FOR200MB",
        "profile": "200Mbps/200Mbps"
      },
      "client_mobile": "04243114110",
      "client_email": "YULITZACOROMOTO05@GMAIL.COM",
      "address": "MATA CABALLO CALLE 12 CASA 671-B",
      "client_identification": "V15431044",
      "nap_box_name": "CTO-0167",
      "created_at": "2024-09-30T11:11:15.134137",
      "service_detail": {
        "id": 12538,
        "ip": "172.31.238.2",
        "mac": "OE:MT:3C:62:28:26",
        "serial": "OEMT3C622826",
        "queue": null,
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2026-05-20T20:56:09.204986",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6718,
      "client_name": "JOSE FELIX OROZCO VASQUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Sector los Mangos",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243577934",
      "client_email": "OROZCOSHELEZO16@GMAIL.COM",
      "address": "CALLE LOS MANGOS PARCELA 6#",
      "client_identification": "V18443226",
      "nap_box_name": "CTO-00271",
      "created_at": "2024-09-30T12:22:26.477006",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6719,
      "client_name": "NELSON MANUEL AMADOR TOVAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243392464",
      "client_email": "YENIREEPENA5@GMAIL.COM",
      "address": "CALLE 3 CASA N 204 MATACABALLO",
      "client_identification": "V19698325",
      "nap_box_name": "CTO-00274",
      "created_at": "2024-09-30T14:36:51.568131",
      "service_detail": {
        "id": 12502,
        "ip": "172.31.240.2",
        "mac": "OE:MT:3C:62:30:06",
        "serial": "OEMT3C623006",
        "queue": null,
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2026-05-15T16:30:40.063287",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6721,
      "client_name": "MIRIANGEL GONZALEZ  PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Palma Real",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243721061",
      "client_email": "ANDRYJOSUE1308@GMAIL.COM",
      "address": "CALLE PRINCIPAL CASA Nª 30 MANZANA 1 BARRIO CABALLERIZA ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V22954997",
      "nap_box_name": "CTO-00208",
      "created_at": "2024-09-30T16:56:55.384553",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6722,
      "client_name": "MIGDALIA COROMOTO VIVAS DE RUJANO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Sector los Mangos",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128907403",
      "client_email": "VIVASFUENTESMIGDALIACOROMOTO8@GMAIL.COM",
      "address": "CALLEJON LOS MANGOS CASA 47 SECTOR LA ARBOLEDA",
      "client_identification": "V11366164",
      "nap_box_name": "CTO-0485",
      "created_at": "2024-10-01T08:39:42.896092",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6723,
      "client_name": "CARMEN YARITZA HERNANDEZ ESPIDEA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243392782",
      "client_email": "GARKGALA@GMAIL.COM",
      "address": "CALLE 11 CASA Nª 13 SECTOR RIO SECO ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V10457013",
      "nap_box_name": "608",
      "created_at": "2024-10-01T08:40:50.309465",
      "service_detail": {
        "id": 6764,
        "ip": "172.31.244.2",
        "mac": "OEMT3C62299E",
        "serial": "OEMT3C62299E",
        "queue": "Plan_161889_30183_WispHub",
        "interface": "VLAN251_RIO_SECO",
        "created_at": "2024-10-01T10:01:29.442806",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6724,
      "client_name": "ESTEBAN JOSE CHIRINOS COLINA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 43,
        "name": "RECURRENTE RESIDENCIAL PLAN 650M",
        "cost": "46.00",
        "code": "FOR650M",
        "profile": "650M/650M"
      },
      "client_mobile": "04144439298",
      "client_email": "ESTEBANCHIRINO1340@GMAIL.COM",
      "address": "CALLE 11 CASA 656-D URB MATACABALLO",
      "client_identification": "V9686361",
      "nap_box_name": "CTO-00435",
      "created_at": "2024-10-01T11:30:05.953103",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6725,
      "client_name": "JOSE GREGORIO DE PONTE RUIZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128366322",
      "client_email": "jgdr75@gmail.com",
      "address": "CALLE PETION CASA NRO11 ZONA CENTRO TURMERO",
      "client_identification": "V11093866",
      "nap_box_name": "CTO-00037",
      "created_at": "2024-10-01T11:56:38.460913",
      "service_detail": {
        "id": 6765,
        "ip": "172.19.152.2",
        "mac": "TPLGB954EEC3",
        "serial": "TPLGB954EEC3",
        "queue": "Plan_147201_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-10-01T11:58:40.687662",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6726,
      "client_name": "JOSE GREGORIO GOTA GUADARISMO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Paya Abajo",
      "plan": {
        "id": 19,
        "name": "RECURRENTE RESIDENCIAL PLAN 1GB",
        "cost": "74.70",
        "code": "FOR1GB",
        "profile": "1000M/1000M"
      },
      "client_mobile": "04128715807",
      "client_email": "JGOTAGUADARISMO@GMAIL.COM",
      "address": "CALLE CARREÑO EDIFIC 28 PISO 4 APART 1 URB DESARROLLO HABITACIONAL LOS NISPEROS",
      "client_identification": "V15737969",
      "nap_box_name": "CTO-00307",
      "created_at": "2024-10-01T14:28:01.331763",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6727,
      "client_name": "LOREANNYS ANGELES FONT PADRON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados III",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04124612764",
      "client_email": "FLOREANNYS@GMAIL.COM",
      "address": "PRADOS 1 CALLEJON EL SAMAN  CASA 13",
      "client_identification": "V29581837",
      "nap_box_name": "CTO-00254",
      "created_at": "2024-10-01T15:14:00.302147",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6728,
      "client_name": "OMAR ENRIQUE QUINTERO ESCALANTE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243616819",
      "client_email": "GABYPATRICIA.LOPEZ@GMAIL.COM",
      "address": "CALLE 01, CASA N 11 MATACABALLO",
      "client_identification": "V29786286",
      "nap_box_name": "CTO-00131",
      "created_at": "2024-10-02T12:21:21.157187",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6729,
      "client_name": "MOISES ALEXANDER BELLO ALONZO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243832027",
      "client_email": "celeydismarcano@gmail.com",
      "address": "MATACABALLO CALLE 11 CASA 644B",
      "client_identification": "V25477751",
      "nap_box_name": "CTO-00213",
      "created_at": "2024-10-02T13:36:11.226919",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6730,
      "client_name": "SERGIA YELIT ROMERO SEQUERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144784895",
      "client_email": "ANASANCHEZ3280.CARO@GMAIL.COM",
      "address": "PANTI CALLE 1-B CASA 19 PAYA",
      "client_identification": "V11273334",
      "nap_box_name": "CTO-00127",
      "created_at": "2024-10-02T15:48:02.547315",
      "service_detail": {
        "id": 12674,
        "ip": "172.31.250.2",
        "mac": "OE:MT:3C:62:32:0E",
        "serial": "OEMT3C62320E",
        "queue": null,
        "interface": "VLAN229_PANTIN",
        "created_at": "2026-07-04T14:57:03.358707",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6731,
      "client_name": "ANGELICA MARIA YBARRA CONTRERAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Valle Verde",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04123982934",
      "client_email": "ANGELICACONTRERA808@GMAIL.COM",
      "address": "CALLE CALLEJON CASA NRO SIN NUMERO SECTOR VALLE VERDE ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V22948406",
      "nap_box_name": "CTO-00187",
      "created_at": "2024-10-03T11:31:06.147768",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6732,
      "client_name": "FRANCISCO JAVIER MORENO ALVAREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243142751",
      "client_email": "FM210375@GMAIL.COM",
      "address": "CALLE 3 CASA NRO 135 URB MATACABALLO",
      "client_identification": "V12170830",
      "nap_box_name": "CTO-00094",
      "created_at": "2024-10-03T13:42:36.913162",
      "service_detail": {
        "id": 6775,
        "ip": "172.30.160.2",
        "mac": "",
        "serial": "OEMT3C6226E6",
        "queue": "Plan_107915_30181_WispHub",
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2024-10-03T14:02:00.063645",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6733,
      "client_name": "VICTOR JULIO MEDINAS TORRES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "SUSPENDIDO_RESIDENCIAL",
      "status_name": "Suspendido",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04125201415",
      "client_email": "ALCHURUT@GMAIL.COM",
      "address": "CALLE 8 CASA 585-B URB MATA CABALLO ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V10050447",
      "nap_box_name": "CTO-00130",
      "created_at": "2024-10-03T16:24:55.033884",
      "service_detail": {
        "id": 12100,
        "ip": "172.31.251.2",
        "mac": "OEMT3C62316A",
        "serial": "OEMT3C62316A",
        "queue": null,
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2026-03-17T10:55:16.185747",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6735,
      "client_name": "DEIBYS DAVID AYALA GUTIERREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados I",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243520241",
      "client_email": "PBORREROMARRIAGA@GMAIL.COM",
      "address": "AV PRINCIPAL DE PRADOS 1 CASA N 9",
      "client_identification": "V14230675",
      "nap_box_name": "CTO-00299",
      "created_at": "2024-10-04T11:41:52.129481",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6736,
      "client_name": "FELICIA COBOS BOGADO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Las Rurales",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144867724",
      "client_email": "FELICIACOBO28@GMAIL.COM",
      "address": "CALLE SUCRE CASA N 99-01LAS RURALES",
      "client_identification": "V19276503",
      "nap_box_name": "CE-00080",
      "created_at": "2024-10-04T11:50:17.574815",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6737,
      "client_name": "WILMAN MANUEL CONTRERAS BERMEJO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Paya Abajo",
      "plan": {
        "id": 43,
        "name": "RECURRENTE RESIDENCIAL PLAN 650M",
        "cost": "46.00",
        "code": "FOR650M",
        "profile": "650M/650M"
      },
      "client_mobile": "04144630442",
      "client_email": "INVERSIONESMARIALHAN01@GMAIL.COM",
      "address": "SECTOR PAYA ABAJO  AVENIDA PRINCIPAL 1-2",
      "client_identification": "V12334523",
      "nap_box_name": "272",
      "created_at": "2024-10-04T11:56:12.119771",
      "service_detail": {
        "id": 11499,
        "ip": "172.31.239.2",
        "mac": "OEMT3C622616",
        "serial": "OEMT3C622616",
        "queue": null,
        "interface": "VLAN231_PAYABAJO",
        "created_at": "2026-02-05T12:18:24.068114",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6738,
      "client_name": "OMAR JESUS SILVESTRE CORONA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04129688437",
      "client_email": "SANONOFRECORO@GMAIL.COM",
      "address": "PRADOS DE PAYA 2 CALLE 2 CASA N 06",
      "client_identification": "V11989865",
      "nap_box_name": "CTO-00118",
      "created_at": "2024-10-04T12:02:58.117341",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6739,
      "client_name": "SARAI DE LOS ANGELES ORTEGA ORTEGA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Bosque",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04125971250",
      "client_email": "SARAIORTEGAECUADOR1@GMAIL.COM",
      "address": "SECTOR DEL BOSQUE CALLE FRANCISCO DE MIRANDA CASA A-4 PAYA",
      "client_identification": "V23787483",
      "nap_box_name": "CTO-00241",
      "created_at": "2024-10-04T12:16:41.312290",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6740,
      "client_name": "ORLANDO JOSE COLMENARES HERNANDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04121633944",
      "client_email": "OCOLMENARES493@GMAIL.COM",
      "address": "CALLE 29 CASA N 25 SECTRO RIO SECO",
      "client_identification": "V11089928",
      "nap_box_name": "CTO-00432 DOS",
      "created_at": "2024-10-04T13:22:10.400544",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6741,
      "client_name": "ELINORA GARCIA DE PEÑA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vallecito",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243353774",
      "client_email": "YENNIFERIBARRA1702@GMAIL.COM",
      "address": "VALLECITO CALLE CUJI CASA N 11 PAYA",
      "client_identification": "V17969776",
      "nap_box_name": "CTO - 108",
      "created_at": "2024-10-04T14:21:12.332725",
      "service_detail": {
        "id": 6784,
        "ip": "172.24.172.2",
        "mac": "OEMT3C622592",
        "serial": "OEMT3C622592",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN258_VALLECITO",
        "created_at": "2024-10-04T16:49:31.323848",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6742,
      "client_name": "KARLA MARIA PEREZ MELO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Palma Real",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243237442",
      "client_email": "JOSERAFAELBECERRA@HOTMAIL.COM",
      "address": "PALMA REAL MZ 5 CASA 109 PAYA",
      "client_identification": "V19004120",
      "nap_box_name": "404",
      "created_at": "2024-10-04T15:44:45.243081",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6743,
      "client_name": "PAOLA VALENTINA GUANIPA BEJAS",
      "client_type_name": "EMPLEADO",
      "client_subdivision": "CANCELADO_EMPLEADO",
      "status_name": "Cancelado",
      "cycle": 25,
      "migrate": false,
      "sector_name": "Villas El Carmen",
      "plan": {
        "id": 78,
        "name": "Plan empleado 80MB",
        "cost": "0.00",
        "code": "FO-80M",
        "profile": "80M/80M"
      },
      "client_mobile": "04243831915",
      "client_email": "DIEGOARRICHI47@GMAIL.COM",
      "address": "CALLE 04 Nº 03 URB VILLAS EL CARMEN SECTOR EL MACARO, TURMERO ESTADO ARAGUA",
      "client_identification": "V30800722",
      "nap_box_name": "49",
      "created_at": "2024-10-07T12:52:38.734632",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6744,
      "client_name": "EDUWIN JESUS BANDES PLAZA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243043406",
      "client_email": "EDUINBANDEZ@GMAIL.COM",
      "address": "CALLE 3 CASA NRO 13 BARRIO BRISAS DE PAYA ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V19608621",
      "nap_box_name": "CTO-00194",
      "created_at": "2024-10-07T13:34:54.538581",
      "service_detail": {
        "id": 12440,
        "ip": "172.27.75.2",
        "mac": "HWTCC16EF79C",
        "serial": "HWTCC16EF79C",
        "queue": null,
        "interface": "VLAN200_OLTs",
        "created_at": "2026-05-01T09:58:58.827973",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6745,
      "client_name": "ISBET NARANJO DE MAGO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04164215363",
      "client_email": "NARANJOISBET@GMAIL.COM",
      "address": "CALLE CEDEÑO CRUCE CON MELLAO CASA Nª 45 CASCO CENTRAL TURMERO",
      "client_identification": "V5397710",
      "nap_box_name": "CTO-00440",
      "created_at": "2024-10-08T08:45:21.417334",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6746,
      "client_name": "VICTOR ALEJANDRO HADDAD MANJOUD",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128867279",
      "client_email": "VICTORHADDAD2000@GMAIL.COM",
      "address": "CALLE URDANETA CASA NRO 40 URB. SAN PABLO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V27434950",
      "nap_box_name": "CTO-00246",
      "created_at": "2024-10-08T09:35:18.044326",
      "service_detail": {
        "id": 6797,
        "ip": "10.10.8.2",
        "mac": "OEMT3C62258E",
        "serial": "OEMT3C62258E",
        "queue": "Plan_92194_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-10-09T10:42:45.131513",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6747,
      "client_name": "MAITE SOFIA GARCIA MEDINA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243038975",
      "client_email": "MAITTESOFIA931@GMAIL.COM",
      "address": "CALLE 20 CASA Nª 17 URB. PATIN ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V6447043",
      "nap_box_name": "CTO-00435",
      "created_at": "2024-10-08T11:00:10.022341",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6748,
      "client_name": "JONNY ANTONIO MEJIAS SARMIENTO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04260374949",
      "client_email": "JENIFER_SAR@HOTMAIL.COM",
      "address": "PANTIN CALLE 20 CASA NUMERO 33",
      "client_identification": "V12720520",
      "nap_box_name": "CTO-00435",
      "created_at": "2024-10-08T14:48:21.499739",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6749,
      "client_name": "CARY MICHELL JIMENEZ LOPEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "SUSPENDIDO_RESIDENCIAL",
      "status_name": "Suspendido",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04129130399",
      "client_email": "JIMENEZCARY5@GMAIL.COM",
      "address": "URB PANTY CALLE 4-A CASA NÚMERO 4",
      "client_identification": "V22948360",
      "nap_box_name": "CTO-00076 DOS",
      "created_at": "2024-10-08T14:55:41.902982",
      "service_detail": {
        "id": 12850,
        "ip": "10.10.5.2",
        "mac": "OE:MT:3C:62:26:EE",
        "serial": "OEMT3C6226EE",
        "queue": null,
        "interface": "VLAN229_PANTIN",
        "created_at": "2026-08-15T18:22:21.289774",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6750,
      "client_name": "ERIC DANIEL GRANADILLO YANEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144515217",
      "client_email": "ERICDGRANADILLOY@GMAIL.COM",
      "address": "LA CASONA 2 CALLE 17 CASA 11",
      "client_identification": "V7235695",
      "nap_box_name": "CTO-00084 DOS",
      "created_at": "2024-10-08T15:32:37.561885",
      "service_detail": {
        "id": 6791,
        "ip": "10.10.4.2",
        "mac": "OEMT3C622752",
        "serial": "OEMT3C622752",
        "queue": "Plan_131337_24341_WispHub",
        "interface": "VLAN110_CASONA_2",
        "created_at": "2024-10-09T09:08:46.017989",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6751,
      "client_name": "JANSEL JOSEFINA MOLINA FLORES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Terrazas de Paya",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124324592",
      "client_email": "JANSELMOLINA2@GMAIL.COM",
      "address": "TERRAZAS DE PAYA CALLE 6 CASA 28",
      "client_identification": "V16524203",
      "nap_box_name": "CTO-0417",
      "created_at": "2024-10-08T15:42:09.820631",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6752,
      "client_name": "HEMILIANGEL OREANA RIVERO LÓPEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 43,
        "name": "RECURRENTE RESIDENCIAL PLAN 650M",
        "cost": "46.00",
        "code": "FOR650M",
        "profile": "650M/650M"
      },
      "client_mobile": "04145862360",
      "client_email": "HEMILIRIVERO17@GMAIL.COM",
      "address": "CC MARIÑO CENTER PLANTA BAJA LOCAL 14 TURMERO",
      "client_identification": "V27712802",
      "nap_box_name": "CTO-0560",
      "created_at": "2024-10-08T15:55:33.753791",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6753,
      "client_name": "MIGUEL EDUARDO ANDARA OLIVARES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243560389",
      "client_email": "AGROMUNDO.RA@GMAIL.COM",
      "address": "CALLE DEL CENTRO CASA NRO 2 SECTOR CASCO DE TURMERO",
      "client_identification": "V19561961",
      "nap_box_name": "211",
      "created_at": "2024-10-08T20:12:15.393737",
      "service_detail": {
        "id": 6795,
        "ip": "172.31.230.2",
        "mac": "TPLGF5CB09C3",
        "serial": "TPLGF5CB09C3",
        "queue": "Plan_161875_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-10-09T09:55:23.105615",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6754,
      "client_name": "KARIBEL  YOELINA PAEZ MAGALLANES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Prados II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128865140",
      "client_email": "KARIBELJUSKARIHILARY@GMAIL.COM",
      "address": "CALLE 01 CASA Nª 74 PRADO II ROSARIO DE PAYA TURMERO",
      "client_identification": "V23919496",
      "nap_box_name": "584",
      "created_at": "2024-10-09T09:20:38.893786",
      "service_detail": {
        "id": 6801,
        "ip": "10.10.12.2",
        "mac": "OEMT3C622BFA",
        "serial": "OEMT3C622BFA",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN242_PRADOS2",
        "created_at": "2024-10-09T12:15:53.533367",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6755,
      "client_name": "LEONARD ALFONZO RANGEL HERRERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Durpa",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04123985978",
      "client_email": "LEITORANGEL6@GMAIL.COM",
      "address": "CALLE LIBERTAD CASA N 12 SECTOR DESARROLLO URBANÍSTICO ROSARIO DE PAYA",
      "client_identification": "V31644106",
      "nap_box_name": "258",
      "created_at": "2024-10-09T10:56:23.726334",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6756,
      "client_name": "CRUZ MARITZA PEREIRA PEÑA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243791210",
      "client_email": "MARITZAPEREIRAP20@GMAIL.COM",
      "address": "PRADOS I CALLE 6 CASA 18",
      "client_identification": "V7197429",
      "nap_box_name": "CTO-00298",
      "created_at": "2024-10-09T11:02:02.200723",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6757,
      "client_name": "KATIUSKA CAROLINA TORO DI LAURO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Terrazas de Paya",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04126822112",
      "client_email": "KATIUSKATORO@GMAIL.COM",
      "address": "CALLE PRINCIPAL MANZANA 08 CASA NRO 14-URB TERRAZA DE PAYA ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V14155208",
      "nap_box_name": "CTO-00163",
      "created_at": "2024-10-09T13:58:25.332170",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6758,
      "client_name": "MARYLIN EKATHERINE SANDOVAL GOMEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243109718",
      "client_email": "KATGOMEZ2991@GMAIL.COM",
      "address": "CALLE CARREÑO CASA 51 CASCO CENTRAL",
      "client_identification": "V21204931",
      "nap_box_name": "184",
      "created_at": "2024-10-09T14:42:40.584580",
      "service_detail": {
        "id": 9958,
        "ip": "172.31.59.2",
        "mac": "OEMT3C62279A",
        "serial": "OEMT3C62279A",
        "queue": null,
        "interface": "VLAN200_OLTs",
        "created_at": "2025-11-11T11:07:17.775092",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6759,
      "client_name": "CESAR ALBERTO FLOREZ VELASCO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Valle Fresco",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243600383",
      "client_email": "FLORES_CESAR_N@HOTMAIL.COM",
      "address": "MANZANA A CASA 17 TURMERO EDO ARAGUA",
      "client_identification": "V10148656",
      "nap_box_name": "CE - 70",
      "created_at": "2024-10-10T09:01:55.962015",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6760,
      "client_name": "NARCY ELIANTA LEGON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados III",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128970601",
      "client_email": "NEUDYSBLANCO35@GMAIL.COM",
      "address": "PRADOS 3 CALLE 5 CASA N 36",
      "client_identification": "V14251786",
      "nap_box_name": "CTO-00305",
      "created_at": "2024-10-11T10:50:04.949225",
      "service_detail": {
        "id": 10684,
        "ip": "172.31.14.2",
        "mac": "OEMT3C622AF6",
        "serial": "OEMT3C622AF6",
        "queue": null,
        "interface": "VLAN236_PRADOS3",
        "created_at": "2025-12-13T12:20:28.721386",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6761,
      "client_name": "YESICA GABRIELA HERNANDEZ RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "1ro de Mayo Norte",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243663096",
      "client_email": "YESI1314GABY@GMAIL.COM",
      "address": "1ERO DE MAYO NORTE PARCELA 26-13 CALLE EL CHACAO",
      "client_identification": "V21204752",
      "nap_box_name": "CTO - 900",
      "created_at": "2024-10-11T14:16:32.370378",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6762,
      "client_name": "SILENNIS YNES FREITES VELASQUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Canaima",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243263270",
      "client_email": "FREITESVSILENNIS@GMAIL.COM",
      "address": "CANAIMA CALLE 2 CASA NRO 18 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V21287535",
      "nap_box_name": "CTO-00107 ",
      "created_at": "2024-10-11T14:32:59.790404",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6763,
      "client_name": "JEHONAS JOSE SALAZAR MOSQUEDA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04121493571",
      "client_email": "SALAZARJEHONAS@GMAIL.COM",
      "address": "RIOSECO CALLE 21 CASA 09",
      "client_identification": "V22948367",
      "nap_box_name": "603",
      "created_at": "2024-10-11T16:23:05.417067",
      "service_detail": {
        "id": 6818,
        "ip": "172.30.254.2",
        "mac": "HWTCFA526448",
        "serial": "HWTCFA526448",
        "queue": "Plan_161900_30183_WispHub",
        "interface": "VLAN251_RIO_SECO",
        "created_at": "2024-10-15T09:43:52.583097",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6764,
      "client_name": "YENIFER JANET LOPEZ MARTINEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona I Edificios",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121487462",
      "client_email": "RAIBELISLOPEZ89@GMAIL.COM",
      "address": "AV INTERCOMUNAL TURMERO MARACAY EDIF B PISO 3 APTO 3 URB LA CASONA I TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V25858048",
      "nap_box_name": "CTO-0529",
      "created_at": "2024-10-14T07:59:22.209490",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6765,
      "client_name": "LUIS ALBERTO GARCIA LOPEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Los Nisperos",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243256108",
      "client_email": "LUIS_2597@HOTMAIL.COM",
      "address": "LOS NISPEROS CALLE 3 CASA 65",
      "client_identification": "V20591152",
      "nap_box_name": "20",
      "created_at": "2024-10-14T11:15:21.345232",
      "service_detail": {
        "id": 6816,
        "ip": "172.30.214.2",
        "mac": "OEMT3C622A72",
        "serial": "OEMT3C622A72",
        "queue": "Plan_127996_15811_WispHub",
        "interface": "VLAN208_NISPERO_OLT1",
        "created_at": "2024-10-14T17:20:36.435252",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6766,
      "client_name": "FIDELA DEL CARMEN RIVAS PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Orquidea",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04140398286",
      "client_email": "FIDERIVAS06@GMAIL.COM",
      "address": "LA ORQUIDEA CALLE 4 CASA 97",
      "client_identification": "V19791643",
      "nap_box_name": "CTO - 918",
      "created_at": "2024-10-14T11:54:36.230755",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6767,
      "client_name": "AGUSTIN ALEXANDER HURTADO CASTILLO F.P.",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "San Carlos",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144627529",
      "client_email": "AGUSTINHURTADOJR@GMAIL.COM",
      "address": "CALLE PRINCIPAL LOCAL NRO 2 ZONA INDUSTRIAL SANTA ROSALIA CAGUA ZONA POSTAL 2122",
      "client_identification": "V11978135",
      "nap_box_name": "659",
      "created_at": "2024-10-14T14:01:29.808695",
      "service_detail": {
        "id": 6814,
        "ip": "172.30.220.2",
        "mac": "OEMT3C622986",
        "serial": "OEMT3C622986",
        "queue": "Plan_92194_15811_WispHub",
        "interface": "VLAN223_SAN_CARLOS_OLT1",
        "created_at": "2024-10-14T17:12:35.028153",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6768,
      "client_name": "JAVIER ENRIQUE MORALES ALVARADO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Narayola II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04165438923",
      "client_email": "JAVIEREMORALESA@GMAIL.COM",
      "address": "NARAYOLA II TORRE 7 APARTAMENTO 23 INTERCOMUNAL.",
      "client_identification": "V18230511",
      "nap_box_name": "CTO-0527",
      "created_at": "2024-10-14T17:07:19.184022",
      "service_detail": {
        "id": 8826,
        "ip": "172.30.69.2",
        "mac": "VSOL0013CAF9",
        "serial": "VSOL0013CAF9",
        "queue": "queue1",
        "interface": "VLAN117_NARAYOLA",
        "created_at": "2025-06-03T14:30:41.670234",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6770,
      "client_name": "FRANCISCO JESUS AVILA ASCANIO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Callejon Lim",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121490713",
      "client_email": "FRANCISCOAVILA201780@GMAIL.COM",
      "address": "PAYA CALLEJON LIN TORRE VIOLETA PISO 1 APART 8",
      "client_identification": "V15301516",
      "nap_box_name": "CTO-0449",
      "created_at": "2024-10-15T17:55:17.826089",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6771,
      "client_name": "LUIS ALBERTO RODRIGUEZ ROMERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04126289702",
      "client_email": "LUISALBERTORODRIGUEZROMERO953@GMAIL.COM",
      "address": "CALLE 5 NRO 11 BARRIO PRADO DE PAYA I ROSARIO DE PAYA",
      "client_identification": "V14469593",
      "nap_box_name": "CTO-00061",
      "created_at": "2024-10-16T08:17:07.938718",
      "service_detail": {
        "id": 6821,
        "ip": "172.30.191.2",
        "mac": "OEMT3C6229CA",
        "serial": "OEMT3C6229CA",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN239_PRADOS1",
        "created_at": "2024-10-16T12:57:48.449053",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6772,
      "client_name": "ELILUS GABRIELA SILVA IRIARTE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Valle Fresco",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04127765753",
      "client_email": "ELILUZS78@GMAIL.COM",
      "address": "VALLE FRESCO MANZANA 17 CASA N 8",
      "client_identification": "V14665249",
      "nap_box_name": "CTO - 981",
      "created_at": "2024-10-16T09:05:37.704041",
      "service_detail": {
        "id": 12373,
        "ip": "172.30.190.2",
        "mac": "OEMT3C622AEA",
        "serial": "OEMT3C622AEA",
        "queue": null,
        "interface": "VLAN270_VALLE_FRESCO_OLT3",
        "created_at": "2026-04-20T11:47:22.233556",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6773,
      "client_name": "DANIEL WILFREDO ROZO GUAVITA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Durpa",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121992455",
      "client_email": "DROZOGUAVITA@GMAIL.COM",
      "address": "FUNDA BARRIOS MANZANA 12 PLANTA ALTA N 16",
      "client_identification": "V18083797",
      "nap_box_name": "CTO-00192",
      "created_at": "2024-10-16T15:31:38.491263",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6774,
      "client_name": "YULIA ROSANGELA BALADI CORRALES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121490681",
      "client_email": "ROSANGELABALADI@GMAIL.COM",
      "address": "EZEQUIEL ZAMORA TORRE 5 PB 4",
      "client_identification": "V17576386",
      "nap_box_name": "CTO-00032 DOS",
      "created_at": "2024-10-16T16:08:57.254873",
      "service_detail": {
        "id": 6826,
        "ip": "172.30.181.2",
        "mac": "OEMT3C6224BE",
        "serial": "OEMT3C6224BE",
        "queue": "queue1",
        "interface": "VLAN209_ZAMORA_OLT1",
        "created_at": "2024-10-18T15:31:07.424208",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6775,
      "client_name": "SHIRLEY YOLICCY GONZALEZ DE GALAN",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Residencias Mariño",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04269325280",
      "client_email": "SHIRLEYGONZALEZ1234@GMAIL.COM",
      "address": "CALLE MARIÑO EDIF. MARIÑO PISO 8 PAT 81-B SECTOR TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V9473790",
      "nap_box_name": "CTO-0519",
      "created_at": "2024-10-17T10:17:19.623594",
      "service_detail": {
        "id": 6824,
        "ip": "172.30.22.2",
        "mac": "OEMT3C622AE2",
        "serial": "OEMT3C622AE2",
        "queue": "Plan_107916_15811_WispHub",
        "interface": "VLAN234_R_MARINO_OLT2",
        "created_at": "2024-10-17T10:47:06.321597",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6776,
      "client_name": "BRYAN RAFAEL ARIAS GIMENEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121483672",
      "client_email": "BRYANARIAS379@GMAIL.COM",
      "address": "VDA F-03 CASA NRO 02 BARRIO SAMAN TARAZONERO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V30477677",
      "nap_box_name": "CE - 227",
      "created_at": "2024-10-17T15:01:54.311835",
      "service_detail": {
        "id": 10688,
        "ip": "172.30.173.2",
        "mac": "OEMT3C622316",
        "serial": "OEMT3C622316",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2025-12-13T13:38:30.014082",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6777,
      "client_name": "EDUARDO JOSE GONZALEZ SANCHEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243768380",
      "client_email": "EDUARDO_GONZALEZ_2015@HOTMAIL.COM",
      "address": "CALLE 6 CASA NRO 466 MATACABALLO",
      "client_identification": "V29574431",
      "nap_box_name": "CAJA NAP CALLE 6 D MATACABALLO",
      "created_at": "2024-10-17T15:45:16.177534",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6778,
      "client_name": "DANIELA LESYURAI LOPEZ LOPEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "La Casona I",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04121486092",
      "client_email": "DANIELALOPEZ.021209@GMAIL.COM",
      "address": "CASONA 1 CALLE 10 N 58",
      "client_identification": "V20693089",
      "nap_box_name": "CTO-00071",
      "created_at": "2024-10-18T08:53:17.783228",
      "service_detail": {
        "id": 11429,
        "ip": "172.29.131.2",
        "mac": "OEMT3C624BCE",
        "serial": "OEMT3C624BCE",
        "queue": null,
        "interface": "VLAN109_CASONA_1",
        "created_at": "2026-01-31T12:59:27.317304",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6779,
      "client_name": "PEDRO RAMON MEDERO TEJADA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243008725",
      "client_email": "MEDEROTEJADAPEDRORAMON@GMAIL.COM",
      "address": "URB PANTIN CALLE 4B CASA NRO 50",
      "client_identification": "V12854688",
      "nap_box_name": "CTO-00134",
      "created_at": "2024-10-18T08:54:00.286305",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6780,
      "client_name": "ANDYSMAR NAZARIANNY SOSA SALAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128900229",
      "client_email": "ANDYSMARSOSA20@GMAIL.COM",
      "address": "MATACABALLO CALLE 3 CASA 159",
      "client_identification": "V27286609",
      "nap_box_name": "CTO-00094",
      "created_at": "2024-10-18T09:03:07.343005",
      "service_detail": {
        "id": 6830,
        "ip": "172.30.146.2",
        "mac": "OEMT3C624C2A",
        "serial": "OEMT3C624C2A",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2024-10-18T15:45:32.565264",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6781,
      "client_name": "GLENDA MARIA HERNANDEZ DELGADO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04142953821",
      "client_email": "glendamhernandezd2@gmail.com",
      "address": "SAMAN TARAZONERO 2 MANZANA F3 CASA 3 DETRAS TRANSITO",
      "client_identification": "V9652292",
      "nap_box_name": "CE - 227",
      "created_at": "2024-10-18T09:11:32.803144",
      "service_detail": {
        "id": 10815,
        "ip": "172.30.143.2",
        "mac": "OEMT3C62492E",
        "serial": "OEMT3C62492E",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2025-12-18T16:52:22.366592",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6782,
      "client_name": "GLENDER MERLYK LANDAETA CACERES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144754607",
      "client_email": "LANDAETAGLENDER@GMAIL.COM",
      "address": "MATACABALLO CALLE 8 CASA 578-A",
      "client_identification": "V12339872",
      "nap_box_name": "CTO-00130",
      "created_at": "2024-10-18T09:25:20.539745",
      "service_detail": {
        "id": 10324,
        "ip": "172.30.125.2",
        "mac": "HWTC45B13279",
        "serial": "HWTC45B13279",
        "queue": null,
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2025-11-25T13:05:38.930908",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6784,
      "client_name": "YUSSENIA YSABEL VALOR ROJAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Valle Verde",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04126812528",
      "client_email": "VALORYUSSENIA@GMAIL.COM",
      "address": "VALLE VERDE CALLE BOLIVAR CASA N 18",
      "client_identification": "V14943866",
      "nap_box_name": "CTO-0613",
      "created_at": "2024-10-18T09:43:26.689017",
      "service_detail": {
        "id": 6863,
        "ip": "172.30.97.2",
        "mac": "HWTC45B13239",
        "serial": "HWTC45B13239",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN253_VALLE_VERDE",
        "created_at": "2024-10-23T12:35:16.556944",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6785,
      "client_name": "SERVICIOS RKS 40 CA",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04123499261",
      "client_email": "serviciorks40@GMAIL.COM",
      "address": "AV PRINCIPAL ROSARIO DE PAYA SECTOR MATA CABALLO PARCELA 04 TURMERO ARAGUA",
      "client_identification": "J500305265",
      "nap_box_name": "CTO-0656",
      "created_at": "2024-10-18T09:58:20.663760",
      "service_detail": {
        "id": 6825,
        "ip": "172.26.7.2",
        "mac": "VSOL00D1056F",
        "serial": "VSOL00D1056F",
        "queue": "queue1",
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2024-10-18T10:42:35.800447",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6787,
      "client_name": "JESUS SALVADOR MARIN PALACIOS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04145793686",
      "client_email": "jmarinp2000@gmail.com",
      "address": "LOS NISPEROS TORRE D APART 14",
      "client_identification": "V8819787",
      "nap_box_name": "TORRE D EDIF LOS NISPEROS",
      "created_at": "2024-10-18T10:18:18.904985",
      "service_detail": {
        "id": 10411,
        "ip": "172.30.95.2",
        "mac": "OEMT3C622326",
        "serial": "OEMT3C622326",
        "queue": null,
        "interface": "VLAN272_EDIF_NISPEROS_OLT3",
        "created_at": "2025-11-30T15:14:02.591794",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6788,
      "client_name": "DANIEL ALEJANDRO GUERRERO SALAZAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04241329013",
      "client_email": "DANIELALEGUE1996@GMAIL.COM",
      "address": "PANTY CALLE 18B CASA 55",
      "client_identification": "V24930925",
      "nap_box_name": "CTO-00321",
      "created_at": "2024-10-18T10:23:51.678582",
      "service_detail": {
        "id": 11896,
        "ip": "172.30.50.2",
        "mac": "OEMT3C624FD2",
        "serial": "OEMT3C624FD2",
        "queue": null,
        "interface": "VLAN229_PANTIN",
        "created_at": "2026-03-02T10:22:07.380135",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6789,
      "client_name": "MARIA VICTORIA PEDRA TRUJILLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Durpa",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04127769585",
      "client_email": "ASISMARI19951111@GMAIL.COM",
      "address": "CALLE LOS CAOBOS MANZANA 18 CASA N 5 TERRAZA DE PAYA SECTOR FUNDABARRIO",
      "client_identification": "V25066275",
      "nap_box_name": "392",
      "created_at": "2024-10-18T10:28:27.797239",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6791,
      "client_name": "KEILA MARIANA FIGUEREDO LINARES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04149445134",
      "client_email": "KEILAMARIANAFL@GMAIL.COM",
      "address": "MATACABALLO CALLE 5 CASA N 296",
      "client_identification": "V17985349",
      "nap_box_name": "CTO-00180",
      "created_at": "2024-10-18T11:09:02.238329",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6792,
      "client_name": "ANGELICA JOSEFINA BORGES INFANTE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Terrazas de Paya",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243554526",
      "client_email": "YORMILEIDYS17@GMAIL.COM",
      "address": "TERRAZAS DE PAYA MANZANA 8 CASA 8",
      "client_identification": "V17578491",
      "nap_box_name": "CTO-00163",
      "created_at": "2024-10-18T13:19:50.047974",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6793,
      "client_name": "BODEGON GAEL LE CA",
      "client_type_name": "PYME",
      "client_subdivision": "CANCELADO_PYME",
      "status_name": "Cancelado",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04123366031",
      "client_email": "CARRILLOGELYMAR71@GMAIL.COM",
      "address": "CALLE PENTION CC LA CANDELARIA BODEGON DON RAFAEL",
      "client_identification": "V505787462",
      "nap_box_name": "CTO-00066",
      "created_at": "2024-10-18T13:44:48.959608",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6794,
      "client_name": "MARIA ESTHER RIVAS GARBOZA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "1ro de Mayo Norte",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121483231",
      "client_email": "MR8280188@GMAIL.COM",
      "address": "URB URIMARE CALLE 1 MODULO 1 SECTOR PRIMERO DE MAYO NORTE.",
      "client_identification": "V16691858",
      "nap_box_name": "CTO - 878",
      "created_at": "2024-10-18T13:56:45.169868",
      "service_detail": {
        "id": 6841,
        "ip": "172.29.196.2",
        "mac": "OEMT3C624C32",
        "serial": "OEMT3C624C32",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN261_1ERO_MAYO_ZTE",
        "created_at": "2024-10-18T16:46:50.395033",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6796,
      "client_name": "AISKEL MARILIN RODRIGUEZ HERNANDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Narayola II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04127229591",
      "client_email": "AISKEL.RODRIGUEZ.HERNANDEZ@GMAIL.COM",
      "address": "NARAYOLA 2 TORRE 5 APARTAMENTO1-1 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V19028971",
      "nap_box_name": "CTO-0525",
      "created_at": "2024-10-19T20:34:31.187402",
      "service_detail": {
        "id": 12217,
        "ip": "10.10.14.2",
        "mac": "OEMT3C62478E",
        "serial": "OEMT3C62478E",
        "queue": null,
        "interface": "VLAN117_NARAYOLA",
        "created_at": "2026-03-30T18:58:59.540334",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6797,
      "client_name": "HEIDI COROMOTO MELENDEZ SALAZAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "El Paraiso",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04129329166",
      "client_email": "YEIKERFRANCO9@GMAIL.COM",
      "address": "URB. EL PARAISO CALLE LA UNION CASA Nª 81 EL MACARO",
      "client_identification": "V14470026",
      "nap_box_name": "345",
      "created_at": "2024-10-21T16:23:33.794505",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6798,
      "client_name": "MARINA DEL CARMEN CONTRERAS PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Prados I",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128903945",
      "client_email": "MARINAYRAMON7@GMAIL.COM",
      "address": "CALLE 9 CASA NRO 10 SECTOR PRADOS DE PAYA TURMERO ARAGUA ZONA POSTAL 215",
      "client_identification": "V17577707",
      "nap_box_name": "CTO-00162",
      "created_at": "2024-10-21T16:52:25.049559",
      "service_detail": {
        "id": 12147,
        "ip": "172.27.216.2",
        "mac": "OEMT3C624952",
        "serial": "OEMT3C624952",
        "queue": null,
        "interface": "VLAN239_PRADOS1",
        "created_at": "2026-03-20T23:19:07.928035",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6799,
      "client_name": "GREICY NAILETH CASTRO BERROTERAN",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Antigua Hacienda De Paya",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128803252",
      "client_email": "GREICYC999@GMAIL.COM",
      "address": "CASA 02 NRO 24 SECTOR PRADOS DE PAYA III ROSARIO DE PAYA",
      "client_identification": "V18693630",
      "nap_box_name": "CTO-00302",
      "created_at": "2024-10-21T17:44:26.727691",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6800,
      "client_name": "ANA ROSA CASTILLO PERDOMO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243195787",
      "client_email": "CASTILLO20495507@GMAIL.COM",
      "address": "CALLE 05 CASA NRO 10 SECTOR RIO SECO ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V20495507",
      "nap_box_name": "CTO-0606",
      "created_at": "2024-10-21T18:14:13.627119",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6801,
      "client_name": "ISAIAS ISMAEL DELGADO PERDOMO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "La Orquidea",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04122999705",
      "client_email": "DELGADOISAIAS82@GMAIL.COM",
      "address": "LA ORQUIDEA CALLE 2 NRO 24",
      "client_identification": "V15485111",
      "nap_box_name": "CTO-00282",
      "created_at": "2024-10-21T18:17:01.476347",
      "service_detail": {
        "id": 12167,
        "ip": "172.29.147.2",
        "mac": "OEMT3C624B7E",
        "serial": "OEMT3C624B7E",
        "queue": null,
        "interface": "VLAN259_LA_ORQUIDEA",
        "created_at": "2026-03-23T15:22:38.949577",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6802,
      "client_name": "IZAURA DE ABREU DE MERCADO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Las Rurales",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04125987769",
      "client_email": "DEMACEDOIZAURA@GMAIL.COM",
      "address": "CALLE SUCRE CASA NRO2 SECTOR LAS RURALES ROSARIO DE PAYA ZONA POSTAL 2115",
      "client_identification": "V15735812",
      "nap_box_name": "CTO-00361",
      "created_at": "2024-10-22T09:34:44.755027",
      "service_detail": {
        "id": 6858,
        "ip": "172.29.115.2",
        "mac": "OEMT3C6254B2",
        "serial": "OEMT3C6254B2",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN252_RURALES_PAYA",
        "created_at": "2024-10-22T16:16:18.486262",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6803,
      "client_name": "ALEJANDRA DESIREE SILVA BOLIVAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04125712615",
      "client_email": "ALESILVA0320@GMAIL.COM",
      "address": "URB MATA CABALLO CALLE 4 CASA 227",
      "client_identification": "V27487321",
      "nap_box_name": "CTO-00265",
      "created_at": "2024-10-22T11:01:05.491769",
      "service_detail": {
        "id": 6856,
        "ip": "172.29.105.2",
        "mac": "OEMT3C62481A",
        "serial": "OEMT3C62481A",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2024-10-22T15:25:42.065892",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6804,
      "client_name": "ALEXANDER RAFAEL ROJAS CHACON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "La Orquidea",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243774818",
      "client_email": "ggguaital@gmail.com",
      "address": "CALLE 2 CASA PRADOS DE PAYA NRO 31 SECTOR LA ORQUIDEA  ROSARIO DE PAYA ZONA POSTA 2115",
      "client_identification": "V21115131",
      "nap_box_name": "CTO-00282",
      "created_at": "2024-10-22T11:34:41.329198",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6805,
      "client_name": "CARMEN VIOLETA OROPEZA TONA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Prados III",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243120052",
      "client_email": "VIOLETAOROPEZA780@GMAIL.COM",
      "address": "URB.PRADO III CALLE 2 NRO 28",
      "client_identification": "V7367450",
      "nap_box_name": "CTO-00284 DOS",
      "created_at": "2024-10-22T13:49:48.587996",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6806,
      "client_name": "REIRANI JOSEFINA GUEVARA RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "1ro de Mayo Sur",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121786556",
      "client_email": "SOYREIRANIGUEVARA@GMAIL.COM",
      "address": "CALLE 1 CASA NRO 9 SECTOR LOS TAMARINDOS TURMERO ARAGUA ZONA POSTAL 2123",
      "client_identification": "V16551882",
      "nap_box_name": "CTO - 867",
      "created_at": "2024-10-22T14:11:08.144284",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6807,
      "client_name": "GIRBERLYS GUEHYLER MATTEY CHACON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Luz y Vida",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243817690",
      "client_email": "GGM03@HOTMAIL.COM",
      "address": "COMUNIDAD LUZ Y VIDA CALLE 2 CASA NRO 94 PAYA",
      "client_identification": "V21368054",
      "nap_box_name": "CE - 745",
      "created_at": "2024-10-22T14:27:36.478929",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6808,
      "client_name": "YESSICA ALEXANDRA OSAL ESPINOSA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243385768",
      "client_email": "JUANPABLIN29502694@GMAIL.COM",
      "address": "CALLE 3 CASA NRO 103 SECTOR MATA CABALLO ROSARIO DE PAYA ZONA POSTAL 2115",
      "client_identification": "V16345176",
      "nap_box_name": "CTO-00156",
      "created_at": "2024-10-22T14:30:04.706601",
      "service_detail": {
        "id": 11871,
        "ip": "172.28.205.2",
        "mac": "HWTC45B13509",
        "serial": "HWTC45B13509",
        "queue": null,
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2026-02-28T20:13:50.881764",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6809,
      "client_name": "MARIA ALEJANDRA RAMIREZ HERRERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Antigua Hacienda De Paya",
      "plan": {
        "id": 43,
        "name": "RECURRENTE RESIDENCIAL PLAN 650M",
        "cost": "46.00",
        "code": "FOR650M",
        "profile": "650M/650M"
      },
      "client_mobile": "04144450581",
      "client_email": "MR4625817@GMAIL.COM",
      "address": "AV PRINCIPAL ANTIGUA HACIENDA PAYA CASA NRO 3",
      "client_identification": "V15956441",
      "nap_box_name": "CTO-00068",
      "created_at": "2024-10-22T14:50:58.681148",
      "service_detail": {
        "id": 6898,
        "ip": "172.25.251.2",
        "mac": "HWTC45A06467",
        "serial": "HWTC45A06467",
        "queue": "Plan_112654_15811_WispHub",
        "interface": "VLAN202_AHP_OLT1",
        "created_at": "2024-10-25T20:29:50.518608",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6810,
      "client_name": "GRISELDA LISETH MARTINEZ COLMENAREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04129801032",
      "client_email": "GRISELMAR14@GMAIL.COM",
      "address": "URB PANTIN CALLE 14B NRO 57",
      "client_identification": "V13560131",
      "nap_box_name": "CTO-00052",
      "created_at": "2024-10-22T16:14:00.792008",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6811,
      "client_name": "FLOR ELENA QUINONES DELGADO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243134041",
      "client_email": "FLORQ8864@GMAIL.COM",
      "address": "EZEQUIEL ZAMORA TORRE URQUIA PISO 3 APTO 3",
      "client_identification": "V10456324",
      "nap_box_name": "CTO-00296",
      "created_at": "2024-10-22T16:57:28.139627",
      "service_detail": {
        "id": 6899,
        "ip": "172.25.164.2",
        "mac": "HWTC45B13289",
        "serial": "HWTC45B13289",
        "queue": "Plan_143067_15811_WispHub",
        "interface": "VLAN209_ZAMORA_OLT1",
        "created_at": "2024-10-25T20:31:57.539224",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6813,
      "client_name": "SADOUL ALEXANDER TOVAR CASTELLANOS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "San Carlos",
      "plan": {
        "id": 43,
        "name": "RECURRENTE RESIDENCIAL PLAN 650M",
        "cost": "46.00",
        "code": "FOR650M",
        "profile": "650M/650M"
      },
      "client_mobile": "04122478754",
      "client_email": "SIMBOLO2069@GMAIL.COM",
      "address": "CALLE ELSITA N 32 URB SAN CARLOS",
      "client_identification": "V9670714",
      "nap_box_name": "116",
      "created_at": "2024-10-22T17:27:11.046097",
      "service_detail": {
        "id": 6862,
        "ip": "172.28.36.2",
        "mac": "HWTC45A06477",
        "serial": "HWTC45A06477",
        "queue": "Plan_112654_15811_WispHub",
        "interface": "VLAN223_SAN_CARLOS_OLT1",
        "created_at": "2024-10-22T17:34:37.532147",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6814,
      "client_name": "MIGUEL ENRIQUE ESPINOZA GONZALEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Haras de San Pablo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128599833",
      "client_email": "MIGUELEG95@GMAIL.COM",
      "address": "AV. MILAGRO NORTE EDIF RESIDENCIAS DON GERARDO PISO 1-C APT DON GERARDO URB LAGO MAR BEACH MARACAIBO ZULIA ZONA POSTAL 4004",
      "client_identification": "V23740641",
      "nap_box_name": "247",
      "created_at": "2024-10-23T09:32:06.012335",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6815,
      "client_name": "DISTRIBUIDORA FT 0214 C.A",
      "client_type_name": "PYME",
      "client_subdivision": "CANCELADO_PYME",
      "status_name": "Cancelado",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Guanarito",
      "plan": {
        "id": 36,
        "name": "RECURRENTE PYME PLAN 650M",
        "cost": "70.18",
        "code": "FOP650M",
        "profile": "650M/650M"
      },
      "client_mobile": "04243740715",
      "client_email": "OFICINATODOPOLLO@GMAIL.COM",
      "address": "AV. UNIVERSIDAD CRUCE CALLE GUAICAIPURO CASA NRO 2 SECTOR EL PROCESO EL LIMON ARAGUA ZONA POSTAL 2105",
      "client_identification": "J402331363",
      "nap_box_name": "CTO-00476",
      "created_at": "2024-10-23T09:48:37.978854",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6816,
      "client_name": "MERCY YUBISAY GIL CRESPO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04143925167",
      "client_email": "GILMERCY096@GMAIL.COM",
      "address": "CALLE 9 EDIF TETRA PISO PB APT 598-B URB MATACABALLO ROSARIO DE PAYA ZONA POSTAL 2102",
      "client_identification": "V13276683",
      "nap_box_name": "CTO-00143",
      "created_at": "2024-10-23T10:18:23.134818",
      "service_detail": {
        "id": 10121,
        "ip": "172.25.162.2",
        "mac": "HWTC45A02867",
        "serial": "HWTC45A02867",
        "queue": null,
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2025-11-14T11:07:10.201961",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6817,
      "client_name": "GISELL ALEJANDRA CAMPOS SANDOVAL",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128900784",
      "client_email": "GISELLALEJANDRACAMPOSS@GMAIL.COM",
      "address": "CALLE MANZNA C5 CASA NRO 21 URB SAMAN TARAZONERO II TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V27400137",
      "nap_box_name": "186",
      "created_at": "2024-10-23T10:22:57.692368",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6818,
      "client_name": "SIXTO ABELINO MANZO DE LUNA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Valle Verde",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04264270069",
      "client_email": "YORGELISANUEL14@GMAIL.COM",
      "address": "CALLE PRINCIPAL CASA NRO 63-3 SECTOR ROSARIO DE PAYA ZONA POSTAL 2115",
      "client_identification": "V27286915",
      "nap_box_name": "CTO-00187",
      "created_at": "2024-10-23T11:02:58.871407",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6819,
      "client_name": "JOSE LUIS RODRIGUES DA SILVA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Sector los Mangos",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121663594",
      "client_email": "MARGARITAMEJIAUZCATEGUI@GMAIL.COM",
      "address": "CALLE PRINCIPAL ROSARIO DE PAYA CASA S/N SECTOR LOS MANGOS AL FRENTE DE LA IGLESIA ASAMBLEA DE DIOS DE VENEZUELA",
      "client_identification": "V16284297",
      "nap_box_name": "CE-00111",
      "created_at": "2024-10-23T11:16:31.882240",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6820,
      "client_name": "ADRIAN ELIAS MORGADO OSORIO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Callejon Lim",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04123984051",
      "client_email": "ADRIANMORGADO2010@GMAIL.COM",
      "address": "AV PRINCIPAL DE PAYA CALLEJON LIM TORRE VIOLETA PISO 2 APARTAMENTO 7",
      "client_identification": "V17954494",
      "nap_box_name": "CTO-0562",
      "created_at": "2024-10-23T14:01:36.543885",
      "service_detail": {
        "id": 6984,
        "ip": "172.25.149.2",
        "mac": "HWTC45A04427",
        "serial": "HWTC45A04427",
        "queue": "Plan_143067_15811_WispHub",
        "interface": "VLAN250_LIM_OLT2",
        "created_at": "2024-11-04T16:26:36.609911",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6821,
      "client_name": "CARLOS EDUARDO TORREALBA TOVAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Paya Abajo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04125971757",
      "client_email": "CARLITOSET@HOTMAIL.COM",
      "address": "CALLE CAMPO ELIAS CASA NRO 19 SECTOR PAYA ABAJO ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V18701451",
      "nap_box_name": "CTO-0252",
      "created_at": "2024-10-23T14:35:58.173525",
      "service_detail": {
        "id": 12452,
        "ip": "172.27.84.2",
        "mac": "OEMT3C624BE6",
        "serial": "OEMT3C624BE6",
        "queue": null,
        "interface": "VLAN231_PAYABAJO",
        "created_at": "2026-05-04T11:37:44.370950",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6822,
      "client_name": "UVENCIA DEL CARMEN BRICENO HERNANDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124768895",
      "client_email": "BRICENOCARMEN581@GMAIL.COM",
      "address": "CALLE ROSARIO DE PAYA CALLE 21 NRO 31 SECTOR RIO SECO ZONA POSTAL 2115",
      "client_identification": "V10728618",
      "nap_box_name": "CTO-00276",
      "created_at": "2024-10-23T14:46:41.170844",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6823,
      "client_name": "LUIS ALBERTO MONTERO RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Betania",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121489342",
      "client_email": "LUISMONT301@GMAIL.COM",
      "address": "ROSARIO DE PAYA COMUNIDAD BETANIA CALLE 04 CASA 113 TURMERO ESTADO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V11697738",
      "nap_box_name": "CTO-00376",
      "created_at": "2024-10-23T14:51:10.128387",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6824,
      "client_name": "MAYERLIN CAROLINA VALERO SILVA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Callejon Rosales",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243461417",
      "client_email": "VALEROMAYI3@GMAIL.COM",
      "address": "SECTOR CAÑABERAL CALLE Nª11 ROSALES PARCELA 6-4",
      "client_identification": "V16865080",
      "nap_box_name": "319",
      "created_at": "2024-10-23T15:01:46.551114",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6825,
      "client_name": "NOVEDADES Y VIDEOS YAMIL CA",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04243782986",
      "client_email": "KATTOUCHE1976@HOTMAIL.COM",
      "address": "CALLE RIVAS EDIF SAN PABLO LOCAL NRO 1-A SECTOR TURMERO EDO ARAGUA ZONA POSTAL 2115",
      "client_identification": "J401369219",
      "nap_box_name": "CTO-00129",
      "created_at": "2024-10-23T15:30:00.796971",
      "service_detail": {
        "id": 6912,
        "ip": "172.24.37.2",
        "mac": "HWTC45A04477",
        "serial": "HWTC45A04477",
        "queue": "Plan_114480_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-10-28T13:15:27.554280",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6826,
      "client_name": "JOSE LUIS FIGUEROA VELEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Paya Abajo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04244318347",
      "client_email": "JOSE_LUIS_FIGUEROA@HOTMAIL.COM",
      "address": "CALLE SAN PABLO EDIF LA LAGUNA PISO 1 APT 1B CONJUNTO RESIDENCIAL LA LAGUNA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V13557781",
      "nap_box_name": "CTO-0252",
      "created_at": "2024-10-23T15:46:52.777148",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6828,
      "client_name": "WENDY YERHIBER RONDON MENDOZA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Pantin",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04125681632",
      "client_email": "YWENDYRONDON20@GMAIL.COM",
      "address": "CALLE CALLE 08-A CASA NRO 10 SECTOR URBANIZACION PANTIN ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V16028673",
      "nap_box_name": "CTO-00311",
      "created_at": "2024-10-23T16:53:40.466966",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6829,
      "client_name": "RUSMARY NATIVIDAD GALICIA VEGAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Pantin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121076972",
      "client_email": "RUSMARYNATIVIDADGALICIAVEGAS@GMAIL.COM",
      "address": "CALLE 22 CASA NRO 13 URB. PANTY ROSARIO DE PAYA  ARAGUA ZONA POSTAL 2115",
      "client_identification": "V14665686",
      "nap_box_name": "CTO-00105",
      "created_at": "2024-10-23T17:05:56.911898",
      "service_detail": {
        "id": 6872,
        "ip": "172.27.61.2",
        "mac": "OEMT3C625092",
        "serial": "OEMT3C625092",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN229_PANTIN",
        "created_at": "2024-10-24T15:57:19.982626",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6830,
      "client_name": "TERESA DE JESUS BRUZCO GONZALEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Jabillar",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04147609632",
      "client_email": "TERETEREBRUZCO@GMAIL.COM",
      "address": "CALLE ALGARROBO CASA NRO 0405 URB JABILLAR TURMERO EDO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V8918614",
      "nap_box_name": "CTO-00006 C/4 JABILLAR",
      "created_at": "2024-10-24T08:19:02.619087",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6831,
      "client_name": "JESUS ENRIQUE MONTERO ANTEAGA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Prados de Cafetal",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124384167",
      "client_email": "JEMONART@GMAIL.COM",
      "address": "VDA 3ERA CASA MARACAY EDO ARAGUA NRO URB JULIO MARTI 2DA ETAPA MARACAY ARAGUA ZONA POSTAL 2102",
      "client_identification": "V12565167",
      "nap_box_name": "545",
      "created_at": "2024-10-24T08:42:43.635684",
      "service_detail": {
        "id": 6873,
        "ip": "172.27.57.2",
        "mac": "OEMT3C624F96",
        "serial": "OEMT3C624F96",
        "queue": "Plan_114480_15811_WispHub",
        "interface": "VLAN221_CAFETAL_OLT1",
        "created_at": "2024-10-24T16:08:00.039233",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6832,
      "client_name": "JUANA RAMONA LARA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Prados I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04123496474",
      "client_email": "RAMONA53LARA@GMAIL.COM",
      "address": "CALLE 1 CASA NRO 12 SECTOR PRADO DE PAYA I ROSARIO DE PAYA ZONA POSTAL 2115",
      "client_identification": "V10756681",
      "nap_box_name": "585",
      "created_at": "2024-10-24T09:19:14.954432",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6833,
      "client_name": "JAMILETH CANDELARIA TORO NAVA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Leocolbo",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04122288183",
      "client_email": "CANDELARIATORO87@GMAIL.COM",
      "address": "CALLE C VEREDA 5 CASA NRO 37 BARRIO VALLES DE LEO COLVO TURMERO ARAGUA ZONA POSTAL 2107",
      "client_identification": "V11766439",
      "nap_box_name": "CTO-00371",
      "created_at": "2024-10-24T09:38:57.635141",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6835,
      "client_name": "BIENVENIDO PEREZ RINCON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144613784",
      "client_email": "ELIZABETHPETENYI@GMAIL.COM",
      "address": "CALLE 03 CASA NRO 162 URB MATACABALLO TURMERO EDO ARAGUA ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V9193127",
      "nap_box_name": "CTO-00094",
      "created_at": "2024-10-24T10:58:02.349511",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6836,
      "client_name": "ANGELBER JULIO ALBERTO ANDRADE RAVELO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "La Casona II",
      "plan": {
        "id": 43,
        "name": "RECURRENTE RESIDENCIAL PLAN 650M",
        "cost": "46.00",
        "code": "FOR650M",
        "profile": "650M/650M"
      },
      "client_mobile": "04243191345",
      "client_email": "SABORBRASILDISCO23@GMAIL.COM",
      "address": "CASONA 2 CALLE 13 CASA N 33",
      "client_identification": "V26961211",
      "nap_box_name": "CTO-00075 DOS",
      "created_at": "2024-10-24T10:59:51.949630",
      "service_detail": {
        "id": 6918,
        "ip": "172.23.254.2",
        "mac": "HWTC45A04237",
        "serial": "HWTC45A04237",
        "queue": "Plan_131338_24341_WispHub",
        "interface": "VLAN110_CASONA_2",
        "created_at": "2024-10-28T14:53:16.987574",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6837,
      "client_name": "AURELIS BLANCO PIMENTEL",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Las Rurales",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128952914",
      "client_email": "AURELISBLANCO203@GMAIL.COM",
      "address": "CALLE 105 SECTOR LAS RURALES CASA 110 PAYA",
      "client_identification": "V15129231",
      "nap_box_name": "CTO-00200",
      "created_at": "2024-10-24T11:05:38.348640",
      "service_detail": {
        "id": 6889,
        "ip": "172.26.141.2",
        "mac": "OEMT3C624C6A",
        "serial": "OEMT3C624C6A",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN252_RURALES_PAYA",
        "created_at": "2024-10-24T22:43:40.691116",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6838,
      "client_name": "FRANCIS JOSEFINA PEREZ PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04262486632",
      "client_email": "ENRIQUEROMERO22949252@GMAIL.COM",
      "address": "CALLE LOS PORTUGUESE CASA NRO 15 SECTOR PARCELAMIENTO 6 ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V24173305",
      "nap_box_name": "CTO-00271",
      "created_at": "2024-10-24T11:17:05.227162",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6839,
      "client_name": "NANCY PARADA DE CARDOZO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "SUSPENDIDO_RESIDENCIAL",
      "status_name": "Suspendido",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128475229",
      "client_email": "NANCYPISO15@GMAIL.COM",
      "address": "CALLE 12 CASA VNRO 109 URB. LA CASONA 2 TURMERO  ARAGUA ZONA POSTAL 2115",
      "client_identification": "V10147013",
      "nap_box_name": "CTO-00159",
      "created_at": "2024-10-24T11:21:46.259230",
      "service_detail": {
        "id": 6892,
        "ip": "172.26.79.2",
        "mac": "MONU003CDE95",
        "serial": "MONU003CDE95",
        "queue": "Plan_131337_24341_WispHub",
        "interface": "VLAN110_CASONA_2",
        "created_at": "2024-10-24T22:57:40.740110",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6840,
      "client_name": "LISBETH ANDREINA PACHECO SUSPERREGUI",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04120483226",
      "client_email": "LISBETHPACHECO854@GMAIL.COM",
      "address": "pantin CALLE 14B CASA 61 TURMERO EDO ARAGUA",
      "client_identification": "V10480352",
      "nap_box_name": "CTO-00195",
      "created_at": "2024-10-24T11:21:52.511114",
      "service_detail": {
        "id": 6894,
        "ip": "172.26.62.2",
        "mac": "OEMT3C624E1A",
        "serial": "OEMT3C624E1A",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN229_PANTIN",
        "created_at": "2024-10-25T10:23:39.019980",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6841,
      "client_name": "LUIS MIGUEL RODRIGUEZ PAEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Saman Tarazonero I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128151275",
      "client_email": "alexgrodriguezp@gmail.com",
      "address": "SAMAN TARAZONERO 1 CALLE 3 CASA 50",
      "client_identification": "V26095105",
      "nap_box_name": "32",
      "created_at": "2024-10-24T12:14:31.634279",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6844,
      "client_name": "DANIEL AARON MORENO MIERES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "1ro de Mayo Norte",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124111324",
      "client_email": "DMM15122657@GMAIL.COM",
      "address": "CALLE GUAICAPURO CASA NUMERO 10 SECTOR 1ERO DE MAYO NORTE ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V15122657",
      "nap_box_name": "CTO-00383",
      "created_at": "2024-10-24T12:36:33.761577",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6845,
      "client_name": "SONIA RAFAELA LIENDO BORGES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Valle Verde",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243564851",
      "client_email": "SONIARAFAELALIENDO@GMAIL.COM",
      "address": "CALLE SUCRE NRO 26 SECTOR VALLE VERDE ROSARIO DE PAYA",
      "client_identification": "V10759449",
      "nap_box_name": "CE - 691",
      "created_at": "2024-10-24T12:50:24.599004",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6846,
      "client_name": "OFELIA COROMOTO CHIRINOS DIAZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04120433318",
      "client_email": "OFELIACHIRINOS28@GMAIL.COM",
      "address": "calle 22 casa 01 urb pantin rosario de paya",
      "client_identification": "V7209983",
      "nap_box_name": "CTO-00105",
      "created_at": "2024-10-24T14:10:26.684463",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6847,
      "client_name": "DELGREY YLLINOYS RIVERO ALCINA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243604838",
      "client_email": "YLLINOYS@GMAIL.COM",
      "address": "CALLE MANZANA F2 CASA 7 BARRIO SAMAN TARAZONERO II",
      "client_identification": "V23627330",
      "nap_box_name": "162",
      "created_at": "2024-10-24T14:26:43.707829",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6851,
      "client_name": "ALBERTO RAFAEL SILVA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "SUSPENDIDO_RESIDENCIAL",
      "status_name": "Suspendido",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Durpa",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128733430",
      "client_email": "PASTORALBER870@GMAIL.COM",
      "address": "CALLE ESPERANZA MANZANA 21 CASA 12 DESAROLLO URBANISTICO ROSARIO DE PAYA",
      "client_identification": "V4557867",
      "nap_box_name": "376",
      "created_at": "2024-10-24T15:30:23.432702",
      "service_detail": {
        "id": 12570,
        "ip": "172.27.6.2",
        "mac": "a8:bf:3c:62:50:4a",
        "serial": "OEMT3C62504A",
        "queue": null,
        "interface": "VLAN240_DURPA",
        "created_at": "2026-06-02T15:50:56.174705",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6852,
      "client_name": "ENRIQUETA DEL CARMEN PICHARDO MONSALVE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243377878",
      "client_email": "BETTYPICHARDO47@GMAIL.COM",
      "address": "PAYA RIO SECO CALLE 9 CASA Nª 8",
      "client_identification": "V11093473",
      "nap_box_name": "CTO-0610",
      "created_at": "2024-10-24T15:36:51.191916",
      "service_detail": {
        "id": 6910,
        "ip": "172.25.10.2",
        "mac": "OEMT3C624876",
        "serial": "OEMT3C624876",
        "queue": "Plan_161900_30183_WispHub",
        "interface": "VLAN251_RIO_SECO",
        "created_at": "2024-10-25T21:38:09.715053",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6853,
      "client_name": "PABLO WILFREDO ORNELAS D GREGORIO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "San Pablo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128909589",
      "client_email": "PABLOORNELAS213@GMAIL.COM",
      "address": "CALLE PETION EDIF CASTEL I PISO 4 APTO 4-A URB VALLE LINDO III",
      "client_identification": "V16850275",
      "nap_box_name": "CTO-00413",
      "created_at": "2024-10-24T15:41:04.944732",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6854,
      "client_name": "ROBINSON ELOY HERNANDEZ PINTO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144734392",
      "client_email": "ROBINSON.ELOY1993@GMAIL.COM",
      "address": "CALLE CARREÑO CASA NRO 5 SECTOR TURMERO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V21025804",
      "nap_box_name": "CTO-00403",
      "created_at": "2024-10-24T15:55:05.739263",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6855,
      "client_name": "MARLON JOSUE CHOURIO PIRELA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Durpa",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04144573397",
      "client_email": "MARLONPIR456@GMAIL.COM",
      "address": "URB FUNDABARRIO MANZANA 15 NRO ROSARIO DE PAYA",
      "client_identification": "V31304329",
      "nap_box_name": "CTO-00297",
      "created_at": "2024-10-24T16:37:12.770823",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6856,
      "client_name": "ANABEL DEL CARMEN RODRIGUEZ REYES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "El Naranjal",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243481064",
      "client_email": "ANABELRODRIGUEZ882@GMAIL.COM",
      "address": "CALLE PRINCIPAL CASA NRO 3 URB VILLA LAURA ROSARIO DE PAYA ARAGUA POSTAL 2115",
      "client_identification": "V22287032",
      "nap_box_name": "CE - 793",
      "created_at": "2024-10-24T16:53:50.915148",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6857,
      "client_name": "ANGIE MARIA NAVAS DIAZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04165114332",
      "client_email": "NAVASANGIE888@GMAIL.COM",
      "address": "SAMAN TARAZONERO II MANZANA C5 #3",
      "client_identification": "V20521332",
      "nap_box_name": "502",
      "created_at": "2024-10-24T17:04:22.297377",
      "service_detail": {
        "id": 6909,
        "ip": "172.25.18.2",
        "mac": "GPON0097D166",
        "serial": "GPON0097D166",
        "queue": "Plan_137413_1574_WispHub",
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2024-10-25T21:31:22.372324",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6858,
      "client_name": "RICKI EMANUEL ROCHA CASTRO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121480871",
      "client_email": "RICKYROCHA08@GMAIL.COM",
      "address": "AV PRINCIPAL DE PANTIN FRENTE AL COMANDO POLICIAL CALLE 1",
      "client_identification": "V26935802",
      "nap_box_name": "CTO-00110",
      "created_at": "2024-10-24T17:38:01.731474",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6859,
      "client_name": "FRANCISCO JOSE PADRON SUAREZ",
      "client_type_name": "EMPLEADO",
      "client_subdivision": "CANCELADO_EMPLEADO",
      "status_name": "Cancelado",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Los Caobos",
      "plan": {
        "id": 78,
        "name": "Plan empleado 80MB",
        "cost": "0.00",
        "code": "FO-80M",
        "profile": "80M/80M"
      },
      "client_mobile": "04121493567",
      "client_email": "FP13412296@GMAIL.COM",
      "address": "CALLE LOS TULIPANES # 10 SECTOR LOS CAOBOS TURMERO ESTADO ARAGUA",
      "client_identification": "V13412296",
      "nap_box_name": "633",
      "created_at": "2024-10-25T17:18:47.872870",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6861,
      "client_name": "JOSE GARRIDO VICENTE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243170289",
      "client_email": "TELEGARTV@GMAIL.COM",
      "address": "MATACABALLO AL FINAL DE LA CALLE 10 CASA 612B",
      "client_identification": "V4541355",
      "nap_box_name": "CTO-0337",
      "created_at": "2024-10-26T09:12:32.709205",
      "service_detail": {
        "id": 10480,
        "ip": "172.23.216.2",
        "mac": "OEMT3C6253AE",
        "serial": "OEMT3C6253AE",
        "queue": null,
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2025-12-02T14:43:33.534319",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6863,
      "client_name": "WHITMY DANIELA TELLERIA BANDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Palma Real",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128671742",
      "client_email": "WHITMYTELLERIA@GMAIL.COM",
      "address": "CALLE 2 CASA 18 PALMA REAL PAYA",
      "client_identification": "V26535148",
      "nap_box_name": "400",
      "created_at": "2024-10-26T09:29:01.108820",
      "service_detail": {
        "id": 6914,
        "ip": "172.24.232.2",
        "mac": "HWTC45A04337",
        "serial": "HWTC45A04337",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN244_PALMAREAL",
        "created_at": "2024-10-28T13:30:17.003198",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6864,
      "client_name": "ANGEL EDUARDO AMADOR ANDRADE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243691549",
      "client_email": "EDUANDRADE562@GMAIL.COM",
      "address": "CALLE#5 CASA#348 URBANISMO MATACABALLO , PARROQUIA PEDRO AREVALO APONTE , TURMERO  ESTADO ARAGUA",
      "client_identification": "V28317298",
      "nap_box_name": "CTO-00179",
      "created_at": "2024-10-26T11:22:44.429610",
      "service_detail": {
        "id": 13161,
        "ip": "172.24.10.2",
        "mac": "JM:KG:C2:B4:EA:C5",
        "serial": "JMKGC2B4EAC5",
        "queue": null,
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2026-10-13T13:18:42.953203",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6867,
      "client_name": "EDIMAR ALEJANDRA MAYO LARA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Dios Es Mi Refugio",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128900855",
      "client_email": "EDILARA624@GMAIL.COM",
      "address": "AV PRINCIPAL PAYA CASA MANZANA #10 NRO # 10 BARRIO DIOS ES MI REFUGIO ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V25066478",
      "nap_box_name": "CTO-0656",
      "created_at": "2024-10-28T13:05:36.107089",
      "service_detail": {
        "id": 6924,
        "ip": "172.23.189.2",
        "mac": "OEMT3C6253F6",
        "serial": "OEMT3C6253F6",
        "queue": "Plan_92300_15811_WispHub",
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2024-10-28T22:03:26.456861",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6868,
      "client_name": "XIOMARA MARGARITA BOCARANDA MUNOZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Pantin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243720415",
      "client_email": "XIOMARABOCARANDA55@GMAIL.COM",
      "address": "CALLE 13 A CASA NRO 17 SECTOR PANTI ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V4438587",
      "nap_box_name": "CTO-00170",
      "created_at": "2024-10-28T13:20:52.974688",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6869,
      "client_name": "REINA CECILIA RODRIGUEZ DE COLMENARES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Bicentenario",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121492920",
      "client_email": "REICECILIA72@GMAIL.COM",
      "address": "CALLE FRANCISCO DE MIRANDA MANZANA A CASA NRO 21 SECTOR DESARROLLO URBANISTICO ROSARIO DE PAYA ZONA POSTAL 2115",
      "client_identification": "V3748639",
      "nap_box_name": "389",
      "created_at": "2024-10-28T13:35:01.553142",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6870,
      "client_name": "JULIO RAMON TORRES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "1ro de Mayo Norte",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04127093860",
      "client_email": "JULIORAMONTORRES00@GMAIL.COM",
      "address": "CALLE CALLEJON LOS JABILLOS CASA 07 SECTOR ROSARIO DE PAYA",
      "client_identification": "V8730331",
      "nap_box_name": "CTO-00438",
      "created_at": "2024-10-28T13:43:37.645421",
      "service_detail": {
        "id": 6927,
        "ip": "172.23.170.2",
        "mac": "OEMT3C6245C2",
        "serial": "OEMT3C6245C2",
        "queue": "Plan_161900_30183_WispHub",
        "interface": "VLAN261_1ERO_MAYO_ZTE",
        "created_at": "2024-10-28T22:10:29.185972",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6871,
      "client_name": "IRIS DAYANA CARAPAICA SOLIS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04246534849",
      "client_email": "ORTEGAANTONY617@GMAIL.COM",
      "address": "CALLE PPAL CASA NRO 26 URB FRANCISCO DUARTE TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V12609007",
      "nap_box_name": "CE-00043",
      "created_at": "2024-10-28T13:45:54.750166",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6872,
      "client_name": "DORANGEL AIMEE BLANCO PALMAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "La Casona II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243039517",
      "client_email": "BLANCODORANGEL@GMAIL.COM",
      "address": "LA CASONA II CALLE 14 NRO 98",
      "client_identification": "V30326883",
      "nap_box_name": "CTO-00120 DOS",
      "created_at": "2024-10-28T13:55:39.278489",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6874,
      "client_name": "CARLOS EDUARDO SANTIAGO VENEGAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "La Casona I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243428353",
      "client_email": "CESV1411@GMAIL.COM",
      "address": "CALLE LOS CEDROS CASA NRO 23-17 URB FUNDACION MENDOZA MARACAY MARACAY ARAGUA ZONA POSTAL 2104",
      "client_identification": "V23793262",
      "nap_box_name": "CE - 408",
      "created_at": "2024-10-28T13:59:49.615594",
      "service_detail": {
        "id": 11791,
        "ip": "172.23.121.2",
        "mac": "OEMT3C6245AA",
        "serial": "OEMT3C6245AA",
        "queue": null,
        "interface": "VLAN109_CASONA_1",
        "created_at": "2026-02-27T11:14:08.655700",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6875,
      "client_name": "OLGA JOSEFINA BELLORIN",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "La Orquidea",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124009766",
      "client_email": "DELGADOBELLORIN@GMAIL.COM",
      "address": "CALLE 2 CASA 34 LA ORQUIDEA",
      "client_identification": "V7210343",
      "nap_box_name": "CTO-00019",
      "created_at": "2024-10-28T14:50:46.197461",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6876,
      "client_name": "JESUS RAFAEL CASADIEGO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Canaima",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04123983419",
      "client_email": "JESUSCASADIEGO24@GMAIL.COM",
      "address": "CANAIMA CALLE 3 CASA N 30",
      "client_identification": "V5746390",
      "nap_box_name": "355",
      "created_at": "2024-10-28T14:55:42.752478",
      "service_detail": {
        "id": 11551,
        "ip": "172.23.115.2",
        "mac": "OEMT3C6253B2",
        "serial": "OEMT3C6253B2",
        "queue": null,
        "interface": "VLAN237_CANAIMA",
        "created_at": "2026-02-08T18:00:15.367452",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6877,
      "client_name": "MERVIN EDWIN LINARES ONTIVEROS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243006814",
      "client_email": "FLORMARINAROASANDA@GMAIL.COM",
      "address": "URB MATA CABALLO CALLE 7 APARATAMENTO 534-B",
      "client_identification": "V14844879",
      "nap_box_name": "CTO-00310",
      "created_at": "2024-10-28T15:20:31.352970",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6878,
      "client_name": "GLENDA MILAGROS DUARTE PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243584961",
      "client_email": "FLORENCIOAGC@GMAIL.COM",
      "address": "RIO SECO CALLE 21 CASA 13 PAYA",
      "client_identification": "V15600420",
      "nap_box_name": "603",
      "created_at": "2024-10-28T15:26:57.986337",
      "service_detail": {
        "id": 10012,
        "ip": "172.23.58.2",
        "mac": "OEMT3C6253C6",
        "serial": "OEMT3C6253C6",
        "queue": null,
        "interface": "VLAN251_RIO_SECO",
        "created_at": "2025-11-11T14:53:58.007391",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6879,
      "client_name": "RUBEN MIGUEL HIDALGO GONZALEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Valle Verde",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128905722",
      "client_email": "FABIANYSCOLMENARES87@GMAIL.COM",
      "address": "CALLE SUCRE CASA NRO 12BARRIO ROSARIO DE PAYA ROSARIO DE PAYA ZONA POSTAL 2115",
      "client_identification": "V29883080",
      "nap_box_name": "CE - 691",
      "created_at": "2024-10-28T15:35:30.142192",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6880,
      "client_name": "YEIXON FRANCISCO MENDOZA MONTILLA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Narayola II",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04143840837",
      "client_email": "YEIMM07@GMAIL.COM",
      "address": "CALLE CORREA NORTE CASA NRO 11 LOS RAUSEOS EL LIMON ZONA POSTAL 2105",
      "client_identification": "V24169189",
      "nap_box_name": "CTO-0527",
      "created_at": "2024-10-28T15:44:40.592641",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6882,
      "client_name": "ZOE EUDELIS MONTANEZ GAMEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243143832",
      "client_email": "ZOEMONTANEZ61@GMAIL.COM",
      "address": "CALLE BOLIVAR EDIF LOS NISPERO TORRE A PISO 5 APT 52 CENTRO TURMERO ZONA POSTAL 215",
      "client_identification": "V5894882",
      "nap_box_name": "TORRE A EDIF LOS NISPEROS",
      "created_at": "2024-10-28T17:02:08.415750",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6883,
      "client_name": "JUSBELY COROMOTO ARROYO FLORES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "El Bosque",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04228150128",
      "client_email": "JUSBELYARROYO@GMAIL.COM",
      "address": "EL BOSQUE C/LUISA CACERES DE ARISMENDI CASA D-9",
      "client_identification": "V20335842",
      "nap_box_name": "CTO-00290",
      "created_at": "2024-10-28T17:04:25.937736",
      "service_detail": {
        "id": 6945,
        "ip": "172.23.11.2",
        "mac": "HWTC45A04397",
        "serial": "HWTC45A04397",
        "queue": "Plan_161900_30183_WispHub",
        "interface": "VLAN266_EL_BOSQUE_ZTE",
        "created_at": "2024-10-31T15:16:03.582437",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6884,
      "client_name": "MARIA BALENTINA HENRIQUEZ ALVAREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128909475",
      "client_email": "VALENTINSHENRIQUEZ@GMAIL.COM",
      "address": "CALLE MANZANA C-15 CASA NRO 12 BARRIO SAMAN TARAZONERO II TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V30611739",
      "nap_box_name": "CTO-00064",
      "created_at": "2024-10-29T08:31:13.665418",
      "service_detail": {
        "id": 12346,
        "ip": "172.23.10.2",
        "mac": "OEMT3C62547A",
        "serial": "OEMT3C62547A",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2026-04-17T18:54:58.847206",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6886,
      "client_name": "JELLYMAR DALIBETH DUGARTE VILLASMIL",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "El Macaro",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04120472710",
      "client_email": "JELLYDALI@GMAIL.COM",
      "address": "AV. COSTA CARLES EDIF TORRE A PISO 7 APT PH -2 URB LOS ROSALES SAN JUAN DE LOS MORROS GUARICO ZONA POSTAL 2301",
      "client_identification": "V15031487",
      "nap_box_name": "CTO-00080",
      "created_at": "2024-10-29T10:19:15.456217",
      "service_detail": {
        "id": 11882,
        "ip": "172.22.193.2",
        "mac": "HWTC45B13469",
        "serial": "HWTC45B13469",
        "queue": null,
        "interface": "VLAN134_VILLAS_DSJ_OLT_ZTE",
        "created_at": "2026-03-01T14:37:18.441478",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6888,
      "client_name": "JAIRA DEL VALLE MORALES MARTINEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243482408",
      "client_email": "JAIRAMORALES12@GMAIL.COM",
      "address": "CALLE 12 A CASA 16 SECTOR 01 URB PANTIN II TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V8999982",
      "nap_box_name": "CTO-00165",
      "created_at": "2024-10-29T11:14:12.850909",
      "service_detail": {
        "id": 10903,
        "ip": "172.22.166.2",
        "mac": "HWTC45A04297",
        "serial": "HWTC45A04297",
        "queue": null,
        "interface": "VLAN229_PANTIN",
        "created_at": "2025-12-23T13:00:11.026072",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6889,
      "client_name": "WIRLEY BEJARANO BRAVO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Luz y Vida",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04127660768",
      "client_email": "MERARI.1714@GMAIL.COM",
      "address": "prados II calle 1 casa 27 ROSARIO DE PAYA ARAGUA ZONA POSTAL 2112",
      "client_identification": "V19552558",
      "nap_box_name": "CTO-00308",
      "created_at": "2024-10-29T11:49:30.190095",
      "service_detail": {
        "id": 11093,
        "ip": "172.22.156.2",
        "mac": "HWTC45A04327",
        "serial": "HWTC45A04327",
        "queue": null,
        "interface": "VLAN264_LUZYVIDA_ZTE",
        "created_at": "2026-01-11T14:48:34.850151",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6890,
      "client_name": "JUAN ERNESTO MORLA MARVAL",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04141636753",
      "client_email": "JUANMORLA83@HOTMAIL.COM",
      "address": "CALLE BOLIVAR CONJUNTO RESIDENCIAL LOS NISPERO TORRE A, PISO 9 APTO 96",
      "client_identification": "V15758946",
      "nap_box_name": "TORRE A EDIF LOS NISPEROS",
      "created_at": "2024-10-29T18:34:29.987944",
      "service_detail": {
        "id": 12849,
        "ip": "10.10.15.2",
        "mac": "HW:TC:45:A0:44:07",
        "serial": "HWTC45A04407",
        "queue": null,
        "interface": "VLAN272_EDIF_NISPEROS_OLT3",
        "created_at": "2026-08-15T18:03:01.078780",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6891,
      "client_name": "ALVARO LUIS LOPEZ MARINO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124451568",
      "client_email": "ALVAROLOPEZVIVAX@GMAIL.COM",
      "address": "CALLE BOLIVAR CONJUNTO RESIDENCIAL LOS NISPEROS TORRE A PISO 2 APTO 26 TURMERO",
      "client_identification": "V6276582",
      "nap_box_name": "TORRE A EDIF LOS NISPEROS",
      "created_at": "2024-10-29T18:36:50.129242",
      "service_detail": {
        "id": 6933,
        "ip": "10.10.16.2",
        "mac": "HWTC45A04377",
        "serial": "HWTC45A04377",
        "queue": "Plan_107915_15811_WispHub",
        "interface": "VLAN272_EDIF_NISPEROS_OLT3",
        "created_at": "2024-10-29T18:55:08.264353",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6892,
      "client_name": "CARLA YULIANA GRANADOS PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Bicentenario",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04123982285",
      "client_email": "GRANADOCARLA07@GMAIL.COM",
      "address": "FUNDA BARRIO AVES DE PARAISO CASA 17",
      "client_identification": "V25632625",
      "nap_box_name": "CTO-00202",
      "created_at": "2024-10-30T07:40:54.281380",
      "service_detail": {
        "id": 9418,
        "ip": "172.22.103.2",
        "mac": "HWTC45A04387",
        "serial": "HWTC45A04387",
        "queue": "queue1",
        "interface": "VLAN243_BICENTENARIO",
        "created_at": "2025-08-25T11:29:43.215062",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6893,
      "client_name": "MAYERLING YURIMAR LEDEZMA GARCIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121301677",
      "client_email": "MAYERLINGLEDEZ@GMAIL.COM",
      "address": "CALLE 12 B CASA 36 URB PANTIN ROSARIO DE PAYA",
      "client_identification": "V12569898",
      "nap_box_name": "CTO-00169",
      "created_at": "2024-10-30T07:55:18.789975",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6894,
      "client_name": "YULEIDY ALEXANDRA APALMO CAMACHO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Prados I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128651405",
      "client_email": "YULEIDYALENXANDRA123@GMAIL.COM",
      "address": "Calle el Saman Casa # 5 Sector Prados I de Paya",
      "client_identification": "V28432175",
      "nap_box_name": "CTO-00206",
      "created_at": "2024-10-30T08:21:22.835549",
      "service_detail": {
        "id": 9268,
        "ip": "172.22.82.2",
        "mac": "OEMT3C6245FE",
        "serial": "OEMT3C6245FE",
        "queue": "queue1",
        "interface": "VLAN239_PRADOS1",
        "created_at": "2025-07-26T15:09:42.344744",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6895,
      "client_name": "JOSE LUIS ARTIGAS FERNANDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144649579",
      "client_email": "JOSELUISARTIGAS67@GMAIL.COM",
      "address": "TORRE D PISO 3 APTO 32 LOS NISPEROS",
      "client_identification": "V9486443",
      "nap_box_name": "TORRE D EDIF LOS NISPEROS",
      "created_at": "2024-10-30T08:41:59.983565",
      "service_detail": {
        "id": 7108,
        "ip": "172.17.185.2",
        "mac": "OEMT3C6248A6",
        "serial": "OEMT3C6248A6",
        "queue": "Plan_92194_15811_WispHub",
        "interface": "VLAN272_EDIF_NISPEROS_OLT3",
        "created_at": "2024-11-21T09:02:14.593113",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6896,
      "client_name": "BELINDA DEL CARMEN ESPANOL GUTIERREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Paya Abajo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243390130",
      "client_email": "ESPANOLBELINDA512@GMAIL.COM",
      "address": "GUERREROS DE CHAVEZ CASA 26",
      "client_identification": "V27086839",
      "nap_box_name": "406",
      "created_at": "2024-10-30T09:02:14.225120",
      "service_detail": {
        "id": 12542,
        "ip": "172.22.118.2",
        "mac": "4C:AB:FC:E9:9D:F7",
        "serial": "JMKGC2248334",
        "queue": null,
        "interface": "VLAN231_PAYABAJO",
        "created_at": "2026-05-25T10:09:17.024560",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6897,
      "client_name": "ZORAYA JOSEFINA PEREZ PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Palma Real",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04127933887",
      "client_email": "ANNE23MORA@GMAIL.COM",
      "address": "CALLE APURE CALLE SN SECTOR MORICHALITO BOLIVAR ZONA POSTAL 8007",
      "client_identification": "V11843379",
      "nap_box_name": "CTO-00209",
      "created_at": "2024-10-30T09:04:23.457318",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6898,
      "client_name": "LEOMAR JOSE CHIRINOS PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "1ro de Mayo Norte",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243395889",
      "client_email": "ZEYTWORD.JC10@GMAIL.COM",
      "address": "CALLE 2 CASA NRO F-4D SECTOR 1 DE MAYO NORTE ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V31182321",
      "nap_box_name": "CTO - 878",
      "created_at": "2024-10-30T09:16:07.081692",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6900,
      "client_name": "ERIKA JOSEFINA TORRES MARCANO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243498329",
      "client_email": "MEIBYS18T@GMAIL.COM",
      "address": "CALLE 9 CASA NRO 5 SECTOR RIO SECO , ROSARIO DE PAYA TURMERO EDO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V14183025",
      "nap_box_name": "CTO-0610",
      "created_at": "2024-10-30T12:56:03.501512",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6901,
      "client_name": "PARROQUIA SANTIAGO APOSTOL EL MENOR",
      "client_type_name": "INTERCAMBIO",
      "client_subdivision": "ACTIVO_INTERCAMBIO",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "La Casona I",
      "plan": {
        "id": 83,
        "name": "RECURRENTE INSTITUCIONAL 80M",
        "cost": "0.00",
        "code": "FO-R80",
        "profile": "80M/80M"
      },
      "client_mobile": "04243549293",
      "client_email": "UTRERASEMINARIO@GMAIL.COM",
      "address": "CALLE 10 CASA 1 # 56 URB LA CASONA 1 TURMERO ESTADO ARAGUA",
      "client_identification": "J403511004",
      "nap_box_name": "CE - 393",
      "created_at": "2024-10-30T15:23:40.745177",
      "service_detail": {
        "id": 6954,
        "ip": "172.22.116.2",
        "mac": "HWTC45A04417",
        "serial": "HWTC45A04417",
        "queue": "Plan_14173_24341_WispHub",
        "interface": "VLAN109_CASONA_1",
        "created_at": "2024-10-31T16:24:06.893845",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6902,
      "client_name": "JESMIR YERELIT CASADIEGO HERNANDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Prados I",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243356965",
      "client_email": "YERELITCAS.H@GMAIL.COM",
      "address": "PRADO I DE PAYA CALLE 6 CASA Nª14",
      "client_identification": "V20895373",
      "nap_box_name": "CTO-00298",
      "created_at": "2024-10-30T15:44:27.994705",
      "service_detail": {
        "id": 11560,
        "ip": "172.21.51.2",
        "mac": "OEMT3C62542E",
        "serial": "OEMT3C62542E",
        "queue": null,
        "interface": "VLAN239_PRADOS1",
        "created_at": "2026-02-09T14:50:21.910563",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6903,
      "client_name": "CARLA LEXAIDA GUTIERREZ NORGELLES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "1ro de Mayo Sur",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243447641",
      "client_email": "CARLAGUTIERREZ198807@GMAIL.COM",
      "address": "1 ERO DE MAYO SUR CALLE 1 NUMERO 7 PAYA",
      "client_identification": "V19467262",
      "nap_box_name": "CTO-00285",
      "created_at": "2024-10-30T16:27:15.710026",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6904,
      "client_name": "ALICE AUGUSTA PEDROSA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144571426",
      "client_email": "ALICEPEDROSA1980@GMAIL.COM",
      "address": "URB. MATA CABALLO CALLE 6 CASA 435",
      "client_identification": "V81672232",
      "nap_box_name": "CTO-00312",
      "created_at": "2024-10-31T11:14:24.900499",
      "service_detail": {
        "id": 10356,
        "ip": "172.21.104.2",
        "mac": "OEMT3C624AD6",
        "serial": "OEMT3C624AD6",
        "queue": null,
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2025-11-26T16:39:17.905645",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6905,
      "client_name": "DORIS MARIA LARA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Prados III",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04123990702",
      "client_email": "DORISLARA2023@GMAIL.COM",
      "address": "CALLE 4 CASA NRO 25 SECTOR PRADOS III ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V13237233",
      "nap_box_name": "CTO-00299",
      "created_at": "2024-10-31T13:50:07.931648",
      "service_detail": {
        "id": 7029,
        "ip": "172.21.106.2",
        "mac": "OEMT3C625432",
        "serial": "OEMT3C625432",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN236_PRADOS3",
        "created_at": "2024-11-08T08:19:01.299547",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6906,
      "client_name": "FELIX ANTONIO SUMOZA ZAPATA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124068041",
      "client_email": "SUMOZAFELIX73@GMAIL.COM",
      "address": "CALLE 2 CASA NRO 36 SECTOR PRADOS 1 ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V11089648",
      "nap_box_name": "CTO-00300",
      "created_at": "2024-11-01T08:31:21.071737",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6907,
      "client_name": "JOSE ENRIQUE COLINA PINERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Las Rurales",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128659948",
      "client_email": "JOSEENCOP@GMAIL.COM",
      "address": "CALLE 3 CASA NRO 04-326 URB LA FRAN VICTORIA BACHAQUERO ZULIA ZONA POSTAL 4014",
      "client_identification": "V22170538",
      "nap_box_name": "CE - 650",
      "created_at": "2024-11-01T08:44:00.660171",
      "service_detail": {
        "id": 10535,
        "ip": "172.21.180.2",
        "mac": "HWTC22B92986",
        "serial": "HWTC22B92986",
        "queue": null,
        "interface": "VLAN252_RURALES_PAYA",
        "created_at": "2025-12-03T12:29:31.556185",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6908,
      "client_name": "KARLYS ANDREINA FIGUEROA ZERPA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243744099",
      "client_email": "FIGUEROAKARLYS2015@GMAIL.COM",
      "address": "CALLE 8 CASA 578-C URB MATACABALLO ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V26369177",
      "nap_box_name": "CTO-00130",
      "created_at": "2024-11-01T08:59:25.518470",
      "service_detail": {
        "id": 10311,
        "ip": "172.21.146.2",
        "mac": "HWTC45A04317",
        "serial": "HWTC45A04317",
        "queue": null,
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2025-11-24T17:28:26.036652",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6909,
      "client_name": "EDIMAR PULIDO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Pantin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243559908",
      "client_email": "PERSONA.NUMERO.77@GMAIL.COM",
      "address": "CALLE 11-A CASA NRO 7 URB PANTIN ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V14104812",
      "nap_box_name": "CTO-00167",
      "created_at": "2024-11-01T09:11:45.953694",
      "service_detail": {
        "id": 6966,
        "ip": "172.21.135.2",
        "mac": "HWTC45A04447",
        "serial": "HWTC45A04447",
        "queue": "Plan_161900_30183_WispHub",
        "interface": "VLAN229_PANTIN",
        "created_at": "2024-11-01T15:49:16.957749",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6910,
      "client_name": "ALBERT DAVID MANZANILLA RAMIREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados I",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04122052101",
      "client_email": "ALBERTMANZANILLA3@GMAIL.COM",
      "address": "CALLE 2 CASA 37 BARRIO ROSARIO DE PAYA SECTOR PRADO I ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V23795797",
      "nap_box_name": "CTO-00300",
      "created_at": "2024-11-01T09:26:53.047615",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6911,
      "client_name": "MARIBEL BAZORA RIERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04127162762",
      "client_email": "MARIBELBAZORA@GMAIL.COM",
      "address": "PANTIN CALLE 6 B CASA 25",
      "client_identification": "V10250989",
      "nap_box_name": "CTO-00138",
      "created_at": "2024-11-01T09:33:46.067079",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6912,
      "client_name": "SANDRA MAYELA MORALES DE SALAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04144947096",
      "client_email": "MAYELAMORA9983@GMAIL.COM",
      "address": "CALLE 17 CASA 14 BARRIO RIO SECO ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V16130334",
      "nap_box_name": "CTO-0606",
      "created_at": "2024-11-01T09:36:49.380237",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6913,
      "client_name": "BELTRAN ISAAC MALAVER",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Pantin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04164330059",
      "client_email": "BELTRANS039@GMAIL.COM",
      "address": "CALLE 11-B CASA NRO 29 URB. PANTIN TURMERO ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V3826956",
      "nap_box_name": "CTO-00168",
      "created_at": "2024-11-01T09:50:52.734236",
      "service_detail": {
        "id": 6970,
        "ip": "172.21.111.2",
        "mac": "OEMT3C625416",
        "serial": "OEMT3C625416",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN229_PANTIN",
        "created_at": "2024-11-01T16:25:55.467556",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6914,
      "client_name": "JOHANA COROMOTO MILANES DE VENEGAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04129169449",
      "client_email": "DEVENEGASJOHANA@GMAIL.COM",
      "address": "CALLE LOS TAMARINDO CASA NRO 02 SECTOR HUMBERTO CHELI MARIARA CARABOBO ZONA POSTAL 2016",
      "client_identification": "V18530480",
      "nap_box_name": "647",
      "created_at": "2024-11-01T09:56:39.133637",
      "service_detail": {
        "id": 6983,
        "ip": "172.21.105.2",
        "mac": "HWTC45A04267",
        "serial": "HWTC45A04267",
        "queue": "Plan_127996_15811_WispHub",
        "interface": "VLAN273_RES_TURMERO_OLT2",
        "created_at": "2024-11-04T14:11:13.745527",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6915,
      "client_name": "BETTY JOSEFINA TORO DE RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04163018347",
      "client_email": "TOROBB0908@GMAIL.COM",
      "address": "CALLE LOS PORTUGUESES CASA 12 SECTOR PARCELA 6 ROSARIO DE PAYA",
      "client_identification": "V6860617",
      "nap_box_name": "CE - 535",
      "created_at": "2024-11-01T10:02:17.389419",
      "service_detail": {
        "id": 7041,
        "ip": "172.21.101.2",
        "mac": "HWTC45A04227",
        "serial": "HWTC45A04227",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN246_NARANJAL",
        "created_at": "2024-11-09T16:43:51.083821",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6916,
      "client_name": "OSCAR DANIEL DIAZ PIZARRO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Canaima",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04244377231",
      "client_email": "DANIELPIZARO03@GMAIL.COM",
      "address": "CALLE 4 CASA NRO 20 SECTOR ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V31232330",
      "nap_box_name": "CTO-00315 ",
      "created_at": "2024-11-01T10:10:15.119144",
      "service_detail": {
        "id": 10886,
        "ip": "172.21.94.2",
        "mac": "OEMT3C6245BE",
        "serial": "OEMT3C6245BE",
        "queue": null,
        "interface": "VLAN237_CANAIMA",
        "created_at": "2025-12-23T08:46:57.102555",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6917,
      "client_name": "JOSE ALEJANDRO RANGEL ARAQUE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "San Pablo",
      "plan": {
        "id": 43,
        "name": "RECURRENTE RESIDENCIAL PLAN 650M",
        "cost": "46.00",
        "code": "FOR650M",
        "profile": "650M/650M"
      },
      "client_mobile": "04126917701",
      "client_email": "JOSEALJANDRO1978@GMAIL.COM",
      "address": "CALLE VENEZUELA CASA 3-35 SECTOR LAS RURALES MERIDA",
      "client_identification": "V13803676",
      "nap_box_name": "CTO-00322",
      "created_at": "2024-11-01T10:28:44.136811",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6918,
      "client_name": "NEIROVIS JOSEFINA FERNANDEZ VARGAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Bicentenario",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128741640",
      "client_email": "GJL121212@GMAIL.COM",
      "address": "CALLE MANZANA ACASA NRO 07 URB ROSARIO DE PAYA ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V17274732",
      "nap_box_name": "CTO-00302",
      "created_at": "2024-11-01T10:30:53.188701",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6919,
      "client_name": "ADOLFO DE JESUS ROJAS PARRA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Vallecito",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243088922",
      "client_email": "ADOLFOROJASPARRA1988@GMAIL.COM",
      "address": "CALLE EL MIRADOR CASA NRO 13 SECTOR COLINAS DE VALLECITO ROSARIO DE PAYA TURMERO ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V18230883",
      "nap_box_name": "CTO-00067",
      "created_at": "2024-11-01T10:47:55.317848",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6920,
      "client_name": "ANA KATHERIN TORRES DUARTE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Ciudad Bendita",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04127760312",
      "client_email": "TORRESANAKATHERIN@GMAIL.COM",
      "address": "CALLE 8 CASA NRO 185 URB. CIUDAD BENDITA EL MACARO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V21097477",
      "nap_box_name": "CE-00014",
      "created_at": "2024-11-01T10:54:36.997070",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6923,
      "client_name": "GERSUN ALFONSO HERNANDEZ ORTIZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "1ro de Mayo Norte",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04127984390",
      "client_email": "GERSUNORTIZ@GMAIL.COM",
      "address": "CALLE LA ORQUIDEA CASA NRO 03 SECTOR PRIMERO DE MAYO ROSARIO DE PAYA",
      "client_identification": "V10487097",
      "nap_box_name": "CTO - 906",
      "created_at": "2024-11-01T12:39:23.990104",
      "service_detail": {
        "id": 6990,
        "ip": "172.21.39.2",
        "mac": "HWTC46C06277",
        "serial": "HWTC46C06277",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN261_1ERO_MAYO_ZTE",
        "created_at": "2024-11-06T09:33:18.007551",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6924,
      "client_name": "ENEIDA ROSA AREVALO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "El Naranjal",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124614450",
      "client_email": "DANEI75R@GMAIL.COM",
      "address": "CALLE 103 LAS RURALES CASA # 40 SECTOR LAS RURALES ROSARIO DE PAYA ZONA POSTAL 2115",
      "client_identification": "V12439148",
      "nap_box_name": "CE - 535",
      "created_at": "2024-11-01T15:02:54.187858",
      "service_detail": {
        "id": 11680,
        "ip": "172.21.23.2",
        "mac": "HWTC8F200561",
        "serial": "HWTC8F200561",
        "queue": null,
        "interface": "VLAN246_NARANJAL",
        "created_at": "2026-02-20T09:13:03.595878",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6925,
      "client_name": "JOSE GREGORIO NIEVES CASTELLANOS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Valle Verde",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04168459289",
      "client_email": "JOSEG1987.JN@GMAIL.COM",
      "address": "CALLE BOLIVAR CASA NRO 13 SECTOR VALLE VERDE ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V9485744",
      "nap_box_name": "CTO-0613",
      "created_at": "2024-11-02T12:24:33.098537",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6926,
      "client_name": "DANIELA ADRIANA DIAZ SANDOVAL",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Prados III",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04127987540",
      "client_email": "DANIELAADRIANADIAZSANDOVAL@GMAIL.COM",
      "address": "PAYA VIA PRINCIPAL PRADOS DE PAYA SECTOR VISTA HERMOSA CASA 111-1",
      "client_identification": "V20055026",
      "nap_box_name": "CTO-00305",
      "created_at": "2024-11-04T10:00:42.151180",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6928,
      "client_name": "YACLINS SOHESMI RODRIGUEZ MONSALVE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04124446561",
      "client_email": "YACLINSS16@GMAIL.COM",
      "address": "AV PRINCIPAL EDIF JOBO PISO 2 APT 10-24 URB MATA REDONDA MARACAY ARAGUA ZONA POSTAL 2104",
      "client_identification": "V26961946",
      "nap_box_name": "CE - 600",
      "created_at": "2024-11-05T09:09:50.566469",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6929,
      "client_name": "KRISBELY ANDREINA RIVERO LIENDO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243225002",
      "client_email": "CARMENBERNAEZ26@GMAIL.COM",
      "address": "CALLE PPAL CASA NO 4 SECTOR CONCEPCION VIA LA JULIA TURMERO",
      "client_identification": "V31409282",
      "nap_box_name": "CTO-00225",
      "created_at": "2024-11-05T09:37:18.574019",
      "service_detail": {
        "id": 6996,
        "ip": "172.21.8.2",
        "mac": "HWTC45B13389",
        "serial": "HWTC45B13389",
        "queue": "Plan_127996_15811_WispHub",
        "interface": "VLAN209_ZAMORA_OLT1",
        "created_at": "2024-11-06T10:36:11.745535",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6930,
      "client_name": "WILLIAMS YASTRENKY CONTRERAS PERNALETE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "1ro de Mayo Sur",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04120380126",
      "client_email": "CCONTRERASWILIAM@GMAIL.COM",
      "address": "CALLE INTERCOMUNAL CASA NRO 57 URB. 1 DE MAYO ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V19948568",
      "nap_box_name": "CTO-00538",
      "created_at": "2024-11-05T09:41:41.998976",
      "service_detail": {
        "id": 10608,
        "ip": "172.20.220.2",
        "mac": "HWTC46C06237",
        "serial": "HWTC46C06237",
        "queue": null,
        "interface": "VLAN261_1ERO_MAYO_ZTE",
        "created_at": "2025-12-06T11:33:06.624062",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6931,
      "client_name": "ZAILEHT DEL CARMEN APONCIO BRACHO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "La Orquidea",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128651071",
      "client_email": "ZAIAPONCIO@GMAIL.COM",
      "address": "CALLE 4 CASA NRO 91 SECTOR LA ORQUIDEA ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V21369488",
      "nap_box_name": "CTO - 918",
      "created_at": "2024-11-05T10:01:33.261043",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6933,
      "client_name": "ROSMARY ROSELYN RODRIGUEZ SILVA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "El Nispero",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04125989410",
      "client_email": "KR9720300@GMAIL.COM",
      "address": "CALLE CARREÑO NO EDIF URQUIA PISO 2 URB LOS NISPEROS TURMERO",
      "client_identification": "V18701323",
      "nap_box_name": "CTO-00225",
      "created_at": "2024-11-05T10:31:19.516199",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6934,
      "client_name": "ESTEFANI ALEXANDRA MIRANDA BELLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Pantin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04142940498",
      "client_email": "MIRANDAESTEFANI27@GMAIL.COM",
      "address": "CALLE 15-B CASA NO 31",
      "client_identification": "V23787461",
      "nap_box_name": "CTO-00311",
      "created_at": "2024-11-05T10:45:37.428375",
      "service_detail": {
        "id": 13080,
        "ip": "172.20.106.2",
        "mac": "OE:MT:3C:62:53:CA",
        "serial": "OEMT3C6253CA",
        "queue": null,
        "interface": "VLAN229_PANTIN",
        "created_at": "2026-09-26T16:42:17.804693",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6935,
      "client_name": "JHOJANA CAROLINA PERDOMO ROJAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "La Orquidea",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04127769567",
      "client_email": "jhohana408@gmail.com",
      "address": "LA ORQUIDEA CALLE 2 CASA 28",
      "client_identification": "V17470478",
      "nap_box_name": "CTO-00282",
      "created_at": "2024-11-05T10:50:15.044396",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6937,
      "client_name": "CARLOS EDUARDO CENTENO VIVAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Valle Fresco",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04125793859",
      "client_email": "C.CENTENO0211@GMAIL.COM",
      "address": "MANZANA N24 URB. VALLE FRESCO TURMERO CASAN.24-2",
      "client_identification": "V6170631",
      "nap_box_name": "CTO - 981",
      "created_at": "2024-11-05T10:51:39.070045",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6938,
      "client_name": "EDWIN DEL VALLE MAESTRE MALAVE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "La Casona II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04145880698",
      "client_email": "EDWINMAESTRE08@GMAIL.COM",
      "address": "CASONA 2 CALLE 14 CASA NRO 65",
      "client_identification": "V15845524",
      "nap_box_name": "CTO-00120",
      "created_at": "2024-11-05T11:00:45.517360",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6939,
      "client_name": "JIMMY ANTON ANTUNEZ CLEMAN",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Pantin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128964544",
      "client_email": "JIMMYNTUNEZ10@GMAIL.COM",
      "address": "CALLE 7-B CASA 28 SECTOR PANTI PAYA",
      "client_identification": "V10457316",
      "nap_box_name": "CTO-00140",
      "created_at": "2024-11-05T11:05:53.991685",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6940,
      "client_name": "GUSTAVO JOSE MONSALVE GUERRA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Paya Abajo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124143534",
      "client_email": "GUSTA2.MONSALVE@GMAIL.COM",
      "address": "CALLE SAN MIGUEL CASA NRO 08 SECTOR PAYA ABAJO ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V13701891",
      "nap_box_name": "CTO-00319",
      "created_at": "2024-11-05T11:08:03.683241",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6941,
      "client_name": "LYSANDER ERNESTO DIAZ VIELMA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "SUSPENDIDO_RESIDENCIAL",
      "status_name": "Suspendido",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Durpa",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128926924",
      "client_email": "TOLEDOANDREINA04@GMAIL.COM",
      "address": "CALLE PETION CASA NRO 48 SECTOR TURMERO CENTRO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V12167302",
      "nap_box_name": "CTO-00209",
      "created_at": "2024-11-05T11:26:55.752404",
      "service_detail": {
        "id": 12559,
        "ip": "172.20.192.2",
        "mac": "OE:MT:3C:62:4F:1A",
        "serial": "OEMT3C624F1A",
        "queue": null,
        "interface": "VLAN240_DURPA",
        "created_at": "2026-06-01T11:03:03.133692",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6942,
      "client_name": "EMISLEYDI YSABEL RAMIREZ SOLEDAD",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243037251",
      "client_email": "EMISLEYSABEL26@GMAIL.COM",
      "address": "CALLE LOS JABILLOS CASA 44 SECTOR LOS JABILLOS BELLA VISTA ARAGUA ZONA POSTAL 2122",
      "client_identification": "V28023173",
      "nap_box_name": "CTO-00215",
      "created_at": "2024-11-05T12:30:02.438586",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6943,
      "client_name": "NILSON DAVID MORALES COLINA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Prados II",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243455852",
      "client_email": "DAVIDMORALES3991@GMAIL.COM",
      "address": "PRADOS DE PAYA II CALLE 1 NRO 43",
      "client_identification": "V21202374",
      "nap_box_name": "CTO-00301 DOS",
      "created_at": "2024-11-05T13:16:42.400298",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6944,
      "client_name": "MARIA JOSE SALAZAR SALAZAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243396594",
      "client_email": "MARIASALAZAR100895@GMAIL.COM",
      "address": "CALLE CEDEÑO EDIF IBELLI PISO 01 APT 02 SECTOR CASCO CENTRAL DE TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V23621363",
      "nap_box_name": "CTO-00235",
      "created_at": "2024-11-05T13:51:26.253803",
      "service_detail": {
        "id": 9780,
        "ip": "172.20.104.2",
        "mac": "OEMT3C62546E",
        "serial": "OEMT3C62546E",
        "queue": null,
        "interface": "VLAN200_OLTs",
        "created_at": "2025-11-10T12:50:24.624838",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6945,
      "client_name": "SUNEDY YOELYN MARQUEZ GARCIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243602583",
      "client_email": "nemraconan@gmail.com",
      "address": "CALLE 17 RIO SECO NRO 12 SECTOR RIO SECO ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V15301150",
      "nap_box_name": "CTO-0606",
      "created_at": "2024-11-06T09:27:45.601367",
      "service_detail": {
        "id": 7010,
        "ip": "172.20.142.2",
        "mac": "OEMT3C624A76",
        "serial": "OEMT3C624A76",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN251_RIO_SECO",
        "created_at": "2024-11-06T13:50:46.138230",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6947,
      "client_name": "MARIANELA SANDOVAL RUIZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Durpa",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243417326",
      "client_email": "MARISANDO11089@GMAIL.COM",
      "address": "CALLE LIBERTAD MANZANA 15 CASA NRO 20 SECTOR DESARROLLO URBANISTICO ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V11089470",
      "nap_box_name": "CTO-00297",
      "created_at": "2024-11-06T11:03:28.478870",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6948,
      "client_name": "NELLYBE SURABHI MONCADA PEREIRA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Saman de Guere",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243122642",
      "client_email": "NELLYBEMONCADA315@GMAIL.COM",
      "address": "URB VALLE ROSARIO CALLE CASANOVA GODOY CASA Nº 1-B SECTOR EL MACARO SAMAN DE GUERE ARAGUA ZONA POSTAL 2115",
      "client_identification": "V12167959",
      "nap_box_name": "299",
      "created_at": "2024-11-06T11:23:10.292039",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6949,
      "client_name": "MAGALI CRISEL BASTARDO REQUENA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243173775",
      "client_email": "MAGALI19MARZO@GMAIL.COM",
      "address": "ROSARIO DE PAYA SECTOR PANTIN CALLE 18B NRO 67",
      "client_identification": "V11052908",
      "nap_box_name": "CTO-00321",
      "created_at": "2024-11-06T11:24:45.711866",
      "service_detail": {
        "id": 7018,
        "ip": "172.20.94.2",
        "mac": "OEMT3C624B26",
        "serial": "OEMT3C624B26",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN229_PANTIN",
        "created_at": "2024-11-07T14:16:21.469742",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6950,
      "client_name": "GLADYS YESCENIA CARRASQUEL DIAZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "1ro de Mayo Sur",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128903267",
      "client_email": "carrasquelyescenia28@gmail.com",
      "address": "CALLE EL LIMON CASA NRO 02 SECTOR PRIMERO DE MAYO SUR ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V19833511",
      "nap_box_name": "CTO-00470",
      "created_at": "2024-11-06T11:54:43.210112",
      "service_detail": {
        "id": 7020,
        "ip": "172.20.89.2",
        "mac": "OEMT3C624966",
        "serial": "OEMT3C624966",
        "queue": "Plan_161900_30183_WispHub",
        "interface": "VLAN261_1ERO_MAYO_ZTE",
        "created_at": "2024-11-07T15:46:11.488863",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6952,
      "client_name": "YESSICA MILAGRO REQUENA LOPEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "El Cambur",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124902291",
      "client_email": "YESSICAREQUENA33@GMAIL.COM",
      "address": "CALLE PASAJE RICAURTE CASA NO. 6 SECTOR TURMERO NORTE TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V16435545",
      "nap_box_name": "CTO-00244",
      "created_at": "2024-11-06T13:32:00.212323",
      "service_detail": {
        "id": 9678,
        "ip": "172.20.51.2",
        "mac": "HWTC48080112",
        "serial": "HWTC48080112",
        "queue": null,
        "interface": "VLAN263_EL_CAMBUR",
        "created_at": "2025-11-04T08:32:48.998975",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6953,
      "client_name": "ANGELY GABRIELA ALVAREZ VALECILLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Valle Verde",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124608523",
      "client_email": "VALECILLOGABRIELA5@GMAIL.COM",
      "address": "ROSARIO DE PAYA VALLE VERDE CALLE SUCRE CASA 21",
      "client_identification": "V30211826",
      "nap_box_name": "CE - 691",
      "created_at": "2024-11-06T13:41:14.786893",
      "service_detail": {
        "id": 7023,
        "ip": "172.20.47.2",
        "mac": "HWTC918CC087",
        "serial": "HWTC918CC087",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN253_VALLE_VERDE",
        "created_at": "2024-11-07T16:52:00.342163",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6954,
      "client_name": "ROSMARY DAYANA ALVAREZ SAMUEL",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124027845",
      "client_email": "ROSMAALVAREZS@GMAIL.COM",
      "address": "SAMAN TARAZONERO 2 MANZANA J  CASA 1 EL MACARO",
      "client_identification": "V18488875",
      "nap_box_name": "CTO-00064",
      "created_at": "2024-11-06T13:49:41.368557",
      "service_detail": {
        "id": 7011,
        "ip": "172.20.135.2",
        "mac": "HWTC46C06217",
        "serial": "HWTC46C06217",
        "queue": "Plan_137413_1574_WispHub",
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2024-11-06T13:54:05.020648",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6955,
      "client_name": "NESTOR ALEJANDRO AVENDANO FLORES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Valle Fresco",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04127670605",
      "client_email": "NESTORA1897@GMAIL.COM",
      "address": "URB. VALLE FRESCO CALLE 1-A MANZANA 6 CASA Nº 13 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V19131389",
      "nap_box_name": "CE - 934",
      "created_at": "2024-11-06T15:34:02.745978",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6957,
      "client_name": "MARLIN IDANIA AULAR TOVAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243309794",
      "client_email": "MAULARTOVAR@GMAIL.COM",
      "address": "CALLE 7 CASA NRO 553-A URB MATA CABALLO ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V14052119",
      "nap_box_name": "CTO-00310",
      "created_at": "2024-11-07T09:30:02.702866",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6958,
      "client_name": "YUSMAIRA DEL VALLE MARTINEZ MARTINEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243334278",
      "client_email": "YUSMAIRAMARTINEZ03@GMAIL.COM",
      "address": "CALLE 5 CASA NRO 360 URB MATA CABALLO ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V13553912",
      "nap_box_name": "CTO-00180",
      "created_at": "2024-11-07T09:40:38.731344",
      "service_detail": {
        "id": 10352,
        "ip": "172.19.254.2",
        "mac": "HWTC46C06227",
        "serial": "HWTC46C06227",
        "queue": null,
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2025-11-26T14:43:09.957722",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6959,
      "client_name": "ARTURO ENRIQUE ARAUJO MENDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04120798702",
      "client_email": "AEAMMIGRACION@GMAIL.COM",
      "address": "CALLE 4 CASA NRO 425 URB URB ARTURO LUIS BERTI TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V22445104",
      "nap_box_name": "CTO-00194",
      "created_at": "2024-11-07T09:51:26.065663",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6960,
      "client_name": "ARTURO DE LAS MERCEDES ARAUJO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04149461199",
      "client_email": "ARAUJOARTURO72@GMAIL.COM",
      "address": "CALLE 20 CASA NRO 425 URB ARTURO LUIS BERTI EL MACARO TURMERO EDO ARAGUA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V12143544",
      "nap_box_name": "CTO-00194",
      "created_at": "2024-11-07T10:08:33.014526",
      "service_detail": {
        "id": 7605,
        "ip": "10.10.30.2",
        "mac": "OEMT3C6224DA",
        "serial": "OEMT3C6224DA",
        "queue": "Plan_116775_15811_WispHub",
        "interface": "VLAN276_COMUNA_OLT1",
        "created_at": "2025-01-08T08:24:37.200794",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6962,
      "client_name": "RICARDO PAIVA LOPES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Paya Abajo",
      "plan": {
        "id": 43,
        "name": "RECURRENTE RESIDENCIAL PLAN 650M",
        "cost": "46.00",
        "code": "FOR650M",
        "profile": "650M/650M"
      },
      "client_mobile": "04243425034",
      "client_email": "RICARDOPAIVA1990.RP@GMAIL.COM",
      "address": "CALLE BERMUDEZ CASA NRO 51 SECTOR CENTRO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V19553988",
      "nap_box_name": "CTO-00307",
      "created_at": "2024-11-07T10:38:07.515144",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6963,
      "client_name": "FLAVIELIS BETZABETH DE SOUSA RONDON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04125440024",
      "client_email": "FLAWVERLISRIVASDESOUSA@GMAIL.COM",
      "address": "CALLE 11-B CASA NRO 33 SECTOR PANTIN ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V24279145",
      "nap_box_name": "CTO-00168",
      "created_at": "2024-11-07T15:58:24.573150",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6965,
      "client_name": "DAYANA DESIREE ESPINOZA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04126909344",
      "client_email": "DAYANAESPINOZAM@GMAIL.COM",
      "address": "MATA CABALLO CALLE 7 CASA 538B",
      "client_identification": "V13750307",
      "nap_box_name": "CTO-00310",
      "created_at": "2024-11-07T16:10:15.751847",
      "service_detail": {
        "id": 10399,
        "ip": "172.19.205.2",
        "mac": "OEMT3C622322",
        "serial": "OEMT3C622322",
        "queue": null,
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2025-11-29T08:25:29.585089",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6966,
      "client_name": "ANIBAL JOSE RODRIGUEZ ORTEGA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "La Julia",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243387509",
      "client_email": "JANUBOR1997@GMAIL.COM",
      "address": "CALLE CAPARO NORTE CASA H67 URB CORINSA CAGUA ARAGUA ZONA POSTAL 2114",
      "client_identification": "V26166789",
      "nap_box_name": "CTO-00259",
      "created_at": "2024-11-07T16:25:25.239857",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6967,
      "client_name": "DARLINS DAYANA MORILLO CASTILLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243322089",
      "client_email": "MORILLODARLINS@GMAIL.COM",
      "address": "CALLE PETION ENTRE MARIÑO Y MIRANDA EDIFICIO GUBERMENTAL",
      "client_identification": "V27589820",
      "nap_box_name": "CTO-00072",
      "created_at": "2024-11-07T16:28:56.134973",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6968,
      "client_name": "ABRIL JOCERLYS MARIA CARRILLO CABRERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04140527051",
      "client_email": "CARRILLOCABRERALOLYS@GMAIL.COM",
      "address": "CALLE MANZANA B11 CASA 12 URB SAMAN TARAZONERO II TURMERO EDO ARAGUA",
      "client_identification": "V29620395",
      "nap_box_name": "509",
      "created_at": "2024-11-08T07:57:29.671291",
      "service_detail": {
        "id": 12212,
        "ip": "10.10.22.2",
        "mac": "GPON0097CBA6",
        "serial": "GPON0097CBA6",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2026-03-30T14:13:24.599942",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6969,
      "client_name": "MIGDALIA VERONICA NIEVES FIGUERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Brisas de Paya",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121487191",
      "client_email": "MIGDANIEVES212@GMAIL.COM",
      "address": "CALLE PRINCIPAL MANZANA A CASA NRO 3 SECTOR BRISAS DE PAYA",
      "client_identification": "V11986212",
      "nap_box_name": "CTO-00193",
      "created_at": "2024-11-08T09:56:26.619560",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6971,
      "client_name": "LILIAN COROMOTO PACHECO BELLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Prados III",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144904461",
      "client_email": "BELLOCOROMOTO775@GMAIL.COM",
      "address": "CALLE 2 CASA NRO 03 SECTOR PRADO DE PAYA III ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V9665199",
      "nap_box_name": "CTO - 1012",
      "created_at": "2024-11-08T15:30:31.514675",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6973,
      "client_name": "RUBEN JOSE GONZALEZ NAVARRO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04143820251",
      "client_email": "JOSE7MCR@GMAIL.COM",
      "address": "PANTY CALLE 15 A #13-A",
      "client_identification": "V14566980",
      "nap_box_name": "CTO-00201",
      "created_at": "2024-11-08T15:33:42.147147",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6974,
      "client_name": "FERNANDO RAUL RANGEL DELGADO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Canaima",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04126745824",
      "client_email": "RANGEL.LOGISTICAINDUSTRIAL@GMAIL.COM",
      "address": "CALLE 7 CASA NRO 22 SECTOR CANAIMA ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V16131955",
      "nap_box_name": "418",
      "created_at": "2024-11-08T15:36:13.308693",
      "service_detail": {
        "id": 7038,
        "ip": "172.19.194.2",
        "mac": "OEMT3C62306E",
        "serial": "OEMT3C62306E",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN237_CANAIMA",
        "created_at": "2024-11-08T18:01:50.443871",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6975,
      "client_name": "CARMEN JULIA GIRO OCHOA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04141449860",
      "client_email": "ECGLUIS13@GMAIL.COM",
      "address": "RIO SECO CALLE 21 CASA 51",
      "client_identification": "V19206149",
      "nap_box_name": "CTO-00276",
      "created_at": "2024-11-08T16:09:56.056402",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6976,
      "client_name": "MIGUEL ANGEL BOLIVAR GONZALEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Pantin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04127768181",
      "client_email": "MIGUEL010668MB@GMAIL.COM",
      "address": "PANTIN CALLE 14B CASA 53 PAYA",
      "client_identification": "V9678947",
      "nap_box_name": "CTO-00052",
      "created_at": "2024-11-09T10:23:45.448795",
      "service_detail": {
        "id": 12263,
        "ip": "172.19.178.2",
        "mac": "OEMT3C6224AA",
        "serial": "OEMT3C6224AA",
        "queue": null,
        "interface": "VLAN229_PANTIN",
        "created_at": "2026-04-06T11:33:14.921541",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6977,
      "client_name": "DAYANA MILEIDI PEREZ TORO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Prados I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128658085",
      "client_email": "DAYANAMILEI1984@GMAIL.COM",
      "address": "CALLE 02 CASA NRO 34 SECTOR PRADOS 1 ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V16850387",
      "nap_box_name": "CTO-00300",
      "created_at": "2024-11-09T10:37:26.401903",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6978,
      "client_name": "JONATHAN ENRIQUE PACHECO CHAPELLIN",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243347079",
      "client_email": "WENDYCAMPOS6@GMAIL.COM",
      "address": "CALLE 10 CASA NRO 616-A URB MATACABALLO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V17571071",
      "nap_box_name": "CTO-00569",
      "created_at": "2024-11-09T11:23:21.504844",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6979,
      "client_name": "RAKOCZY SAINT NIEVES MATUTE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04127572115",
      "client_email": "rakoczymatute@gmail.com",
      "address": "LOS NISPEROS TORRE A APARTAMENTO PB 1 TURMERO",
      "client_identification": "V14425770",
      "nap_box_name": "TORRE A EDIF LOS NISPEROS",
      "created_at": "2024-11-11T09:49:59.576661",
      "service_detail": {
        "id": 7054,
        "ip": "172.19.108.2",
        "mac": "OEMT3C624936",
        "serial": "OEMT3C624936",
        "queue": "Plan_147201_15811_WispHub",
        "interface": "VLAN272_EDIF_NISPEROS_OLT3",
        "created_at": "2024-11-12T17:09:34.150945",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6981,
      "client_name": "YNGRID ELENA RIVAS BLANCO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "La Montañita",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128961481",
      "client_email": "YLENARBLA@GMAIL.COM",
      "address": "CALLE ESTE CRUCE CON CALLE NORTE CASA 30 URB LA MONTAÑITA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V12609710",
      "nap_box_name": "67",
      "created_at": "2024-11-11T10:13:05.541188",
      "service_detail": {
        "id": 11412,
        "ip": "10.16.95.2",
        "mac": "OEMT3C62075E",
        "serial": "OEMT3C62075E",
        "queue": null,
        "interface": "VLAN214_MONTANITA_OLT1",
        "created_at": "2026-01-28T18:47:00.544392",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6982,
      "client_name": "YELITZA MARIA ALMERA CASTRO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Prados III",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128679576",
      "client_email": "NESTORELCONEJO49@GMAIL.COM",
      "address": "AV.PRINCIPAL 2 CASA NRO 32 PRADOS III",
      "client_identification": "V11088317",
      "nap_box_name": "579 DOS",
      "created_at": "2024-11-11T10:17:00.419523",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6983,
      "client_name": "JENNIFER EVELYN ZAMBRANO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Saman de Guere",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04247097035",
      "client_email": "JEVELIN58@GMAIL.COM",
      "address": "CALLE 2 TRANSVERSAL MANZANA J CASA NRO 1 SECTOR SAMAN TARAZONERO, TURMERO, ARAGUA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V14970455",
      "nap_box_name": "CTO - 1013",
      "created_at": "2024-11-11T10:29:42.523051",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6984,
      "client_name": "ZULLY YENIREE LIZARZABAL MEDRANO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Prados II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243717598",
      "client_email": "LIZARZABALZULLY@GMAIL.COM",
      "address": "PRADO DE PAYA 2 CALLE 4 CASA #42",
      "client_identification": "V19472489",
      "nap_box_name": "CTO-00100",
      "created_at": "2024-11-11T10:41:21.964947",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6985,
      "client_name": "ZUED GERARDYNNE FLORES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vallecito",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144594322",
      "client_email": "TOVARJONATHAN61@GMAIL.COM",
      "address": "CALLE PRINCIPAL CASA NRO 6 SECTOR EL NARANJAL VALLECITO ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V10759551",
      "nap_box_name": "CTO - 97",
      "created_at": "2024-11-11T10:49:17.457617",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6986,
      "client_name": "JEAN CARLOS OBISPO RENGEL",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Dios Es Mi Refugio",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243542064",
      "client_email": "JAVIERLUCENA926@GMAIL.COM",
      "address": "CALLE MANZANA 02 CASA NRO 02 BARRIO DIOS ES MI REFUGIO ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V20245254",
      "nap_box_name": "CTO-0656",
      "created_at": "2024-11-11T10:59:58.622359",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6987,
      "client_name": "GREISY DEL CARMEN GUZMAN LIENDO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Betania",
      "plan": {
        "id": 101,
        "name": "RECURRENTE RESIDENCIAL PLAN 200M",
        "cost": "19.00",
        "code": "FOR200MB",
        "profile": "200Mbps/200Mbps"
      },
      "client_mobile": "04269339004",
      "client_email": "GUZMANGREISY940@GMAIL.COM",
      "address": "CALLE 02 CASA NRO 168 SECTOR COMUNIDAD BETANIA ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V12608748",
      "nap_box_name": "CTO-00376",
      "created_at": "2024-11-11T11:15:32.403526",
      "service_detail": {
        "id": 10197,
        "ip": "172.19.75.2",
        "mac": "HWTC48080519",
        "serial": "HWTC48080519",
        "queue": null,
        "interface": "VLAN260_BETANIA",
        "created_at": "2025-11-19T17:33:03.676416",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6988,
      "client_name": "ESTEFANI YELITZA CUEVAS GONZALEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04149475467",
      "client_email": "ESTEFANICUEVAS24@GMAIL.COM",
      "address": "CALLE 9 EDIF PISO P/B APT 593B URB MATA CABALLO ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V20335539",
      "nap_box_name": "CTO-00213",
      "created_at": "2024-11-11T11:17:20.367168",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6989,
      "client_name": "SOIRELIS MARLENES APONCIO SANCHEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Prados I",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04125972132",
      "client_email": "APONCIOSOIRELIS@GMAIL.COM",
      "address": "CALLE 6 CASA NRO 31A SECTOR PRADOS I ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V28432505",
      "nap_box_name": "CTO-0370",
      "created_at": "2024-11-11T11:56:10.424229",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6990,
      "client_name": "YEISY DESIREE ANDRADE AREVALO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128488817",
      "client_email": "YEISYANDRADE733@GMAIL.COM",
      "address": "PANTIN CALLE 10A CASA NRO 46 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V19530727",
      "nap_box_name": "CTO-00121",
      "created_at": "2024-11-11T11:57:32.355641",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6991,
      "client_name": "MAXIMO ALEXANDER ARROYO RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villeguita",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243198035",
      "client_email": "MAXIMOARROYO542@GMAIL.COM",
      "address": "CALLE EL MILAGRO CASA NRO 35B SECTOR ALI PRIMERA CAGUA ARAGUA ZONA POSTAL 2122",
      "client_identification": "V11976207",
      "nap_box_name": "CE - 949",
      "created_at": "2024-11-11T12:24:35.661016",
      "service_detail": {
        "id": 12592,
        "ip": "172.16.223.2",
        "mac": "HW:TC:48:08:03:22",
        "serial": "HWTC48080322",
        "queue": null,
        "interface": "VLAN116_CAOBOS",
        "created_at": "2026-06-06T18:55:53.770913",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6992,
      "client_name": "ABRAHAN MANUEL RONDON VELIZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Bosque",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144500366",
      "client_email": "RONDONABRAHAN59@GMAIL.COM",
      "address": "CALLE JOSE ANTONIO PAEZ CRUCE CON CALLEJON BOLIVAR CASA NRO 6-A SECTOR EL BOSQUE ROSARIO DE PAYA ZONA POSTAL 2115",
      "client_identification": "V10753125",
      "nap_box_name": "CTO-00241",
      "created_at": "2024-11-11T13:53:08.992842",
      "service_detail": {
        "id": 12052,
        "ip": "172.19.55.2",
        "mac": "HWTC48080530",
        "serial": "HWTC48080530",
        "queue": null,
        "interface": "VLAN266_EL_BOSQUE_ZTE",
        "created_at": "2026-03-14T13:32:51.723008",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6993,
      "client_name": "LADYS MIROSLAVA SANCHEZ FALCON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Bicentenario",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04123988950",
      "client_email": "LADYSSANCHEZ967@GMAIL.COM",
      "address": "CALLE AVES DEL PARAISO MANZANA A NRO 20 BICENTENARIO",
      "client_identification": "V7785031",
      "nap_box_name": "CTO-00202",
      "created_at": "2024-11-11T14:14:02.261730",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6994,
      "client_name": "YESICA YURAIMA AGUILAR AGUIRRE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Bicentenario",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128656404",
      "client_email": "ALBERTORAFAEL2024@GMAIL.COM",
      "address": "FUNDA BARRIO MANZANA A CASA NRO 19",
      "client_identification": "V15076992",
      "nap_box_name": "CTO-00202",
      "created_at": "2024-11-11T14:33:27.578502",
      "service_detail": {
        "id": 7065,
        "ip": "172.19.38.2",
        "mac": "OEMT3C624C86",
        "serial": "OEMT3C624C86",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN243_BICENTENARIO",
        "created_at": "2024-11-12T18:15:36.034178",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6995,
      "client_name": "JAVIER ANDRES MARTINEZ FLORES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243351862",
      "client_email": "JAVIERAMF0305@GMAIL.COM",
      "address": "CALLE 17 CASA NRO 16 SECTOR PANTIN ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V23920978",
      "nap_box_name": "CTO-00434",
      "created_at": "2024-11-11T14:41:04.088799",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 6996,
      "client_name": "CRUZ ANTONIO PEREIRA CAMPELO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "1ro de Mayo Norte",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128642175",
      "client_email": "MARIAPEDRA939@GMAIL.COM",
      "address": "URB. 1ERO DE MAYO NORTE CALLE CHACAO CASA Nª 30",
      "client_identification": "V19833338",
      "nap_box_name": "CTO - 900",
      "created_at": "2024-11-11T15:44:46.841303",
      "service_detail": {
        "id": 12210,
        "ip": "172.18.245.2",
        "mac": "OEMT3C624A0E",
        "serial": "OEMT3C624A0E",
        "queue": null,
        "interface": "VLAN261_1ERO_MAYO_ZTE",
        "created_at": "2026-03-30T14:07:04.708332",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 6997,
      "client_name": "CARMEN YAMILE LOZADA YSTURIZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Durpa",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243344842",
      "client_email": "CARMENYAMILET1269@GMAIL.COM",
      "address": "CALLE LOS CAOBOS MANZANA 17 CASA NRO 24 SECTOR DESARROLLO URBANISMO ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V10699257",
      "nap_box_name": "CTO-00297",
      "created_at": "2024-11-11T16:07:58.033936",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7000,
      "client_name": "LUIS GABRIEL RODRIGUEZ CASTILLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vallecito",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144169869",
      "client_email": "MARIELYSGRATEROL59@GMAIL.COM",
      "address": "CALLE MARA CASA NRO 18 SECTOR ROSARIO DE PAYA MUN. MARIÑO EDO ARAGUA ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V25527765",
      "nap_box_name": "CTO - 106",
      "created_at": "2024-11-12T14:11:45.195969",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7001,
      "client_name": "JOSE EDUARDO CHACON RUIZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Valle lindo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04265308643",
      "client_email": "JECHACONRUIZ@GMAIL.COM",
      "address": "CALLE 6 CASA NRO 03 URB VALLE LINDO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V13241664",
      "nap_box_name": "CE - 952",
      "created_at": "2024-11-12T15:01:23.443403",
      "service_detail": {
        "id": 12386,
        "ip": "172.18.229.2",
        "mac": "OEMT3C6247DA",
        "serial": "OEMT3C6247DA",
        "queue": null,
        "interface": "VLAN274_VALLELINDO",
        "created_at": "2026-04-21T09:36:36.649966",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7002,
      "client_name": "JULIMAR COROMOTO VERASTEGUI SANCHEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243084694",
      "client_email": "DISCPLAYWINNER@GMAIL.COM",
      "address": "AV 2 CASA NRO 517-A URB MATA CABALLO, TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V16592754",
      "nap_box_name": "CTO-00457",
      "created_at": "2024-11-12T15:02:48.957065",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7003,
      "client_name": "DOUGLAS ENRIQUE HIDALGO MAVAREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124583281",
      "client_email": "douglasshow40@gmail.com",
      "address": "CALLE PROLONGACION BOLIVAR EDIF TORRE D PISO 5 APT 53 CONJUNTO RESIDENCIAL LOS NISPEROS TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V3454742",
      "nap_box_name": "TORRE D EDIF LOS NISPEROS",
      "created_at": "2024-11-12T15:13:28.352669",
      "service_detail": {
        "id": 7077,
        "ip": "172.18.201.2",
        "mac": "OEMT3C62452E",
        "serial": "OEMT3C62452E",
        "queue": "Plan_127996_15811_WispHub",
        "interface": "VLAN272_EDIF_NISPEROS_OLT3",
        "created_at": "2024-11-13T16:11:27.119019",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7004,
      "client_name": "CLAUDIA RAMONA RODRIGUEZ OROPEZA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Paya Abajo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121482329",
      "client_email": "LIOROPEZAR@GMAIL.COM",
      "address": "CALLE CAMPO ELIAS CASA NRO 27 SECTOR PAYA ABAJO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V12927298",
      "nap_box_name": "CTO-0252",
      "created_at": "2024-11-12T15:18:12.392774",
      "service_detail": {
        "id": 7076,
        "ip": "172.18.218.2",
        "mac": "HWTC48080537",
        "serial": "HWTC48080537",
        "queue": "Plan_161900_30183_WispHub",
        "interface": "VLAN231_PAYABAJO",
        "created_at": "2024-11-13T15:30:55.853547",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7005,
      "client_name": "RAMON CARLOS GAMEZ ROMAN",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Narayola II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04123102971",
      "client_email": "MESINEO@HOTMAIL.COM",
      "address": "AV PARCELA 22-A EDIF 2 PISO PB APT PB-6 URB NARAYOLA (MORITA I) TURMERO ARAGUA ZONA POSTAL 2107",
      "client_identification": "V7111980",
      "nap_box_name": "CTO-0522",
      "created_at": "2024-11-12T16:56:21.416011",
      "service_detail": {
        "id": 7078,
        "ip": "172.18.187.2",
        "mac": "OEMT3C6247F2",
        "serial": "OEMT3C6247F2",
        "queue": "Plan_131337_24341_WispHub",
        "interface": "VLAN117_NARAYOLA",
        "created_at": "2024-11-13T16:17:47.849797",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7006,
      "client_name": "ALEJANDRO JAVIER VELASCO TORO",
      "client_type_name": "EMPLEADO",
      "client_subdivision": "CANCELADO_EMPLEADO",
      "status_name": "Cancelado",
      "cycle": 25,
      "migrate": false,
      "sector_name": "Pantin",
      "plan": {
        "id": 78,
        "name": "Plan empleado 80MB",
        "cost": "0.00",
        "code": "FO-80M",
        "profile": "80M/80M"
      },
      "client_mobile": "04128859782",
      "client_email": "ALEVELASCOT@GMAIL.COM",
      "address": "CALLE DON HUMBERTO MANZANA 24 CASA NRO 11 URB LA MANTUANA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V27536771",
      "nap_box_name": "CTO-00166",
      "created_at": "2024-11-13T11:20:59.565124",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7007,
      "client_name": "YULLIS MAHOLY RUJANO RUJANO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "1ro de Mayo Sur",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04125970109",
      "client_email": "YULLISRUJANO@GMAIL.COM",
      "address": "CALLE 2 CASA NRO 10 SECTOR ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V18163138",
      "nap_box_name": "CTO - 00398",
      "created_at": "2024-11-13T11:21:49.484723",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7008,
      "client_name": "PABLO ALEJANDRO PEREZ VIEIRA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Palma Real",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04125971516",
      "client_email": "PABLO2006APEREZ@GMAIL.COM",
      "address": "VDA. 6 CASA NRO 86 SECTOR LA CABALLERIZA ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V31855481",
      "nap_box_name": "CTO-00318",
      "created_at": "2024-11-13T11:34:30.649837",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7009,
      "client_name": "LISSETH MARILIN CARMONA DE MONTERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Durpa",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243367666",
      "client_email": "MMABERLING@GMAIL.COM",
      "address": "CALLE LEALTADE MANZANA 22 NRO 07 SECTOR DESARROLLO URBANISMO ROSARIO DE PAYA ZONA POSTAL 2115",
      "client_identification": "V17015741",
      "nap_box_name": "CTO-00320",
      "created_at": "2024-11-13T11:36:03.282540",
      "service_detail": {
        "id": 7082,
        "ip": "172.18.147.2",
        "mac": "HWTC48080512",
        "serial": "HWTC48080512",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN240_DURPA",
        "created_at": "2024-11-13T17:34:30.650569",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7010,
      "client_name": "KAREN DAYAN MUNOZ RUIZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 43,
        "name": "RECURRENTE RESIDENCIAL PLAN 650M",
        "cost": "46.00",
        "code": "FOR650M",
        "profile": "650M/650M"
      },
      "client_mobile": "04124657246",
      "client_email": "ADSOFICINA.2020@GMAIL.COM",
      "address": "CALLE GIRARDOT EDIF GUADALUPE PISO 2 APT 4 SECTOR CENTRO DE TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V17442714",
      "nap_box_name": "CTO-00590",
      "created_at": "2024-11-13T11:53:02.647668",
      "service_detail": {
        "id": 7083,
        "ip": "172.18.144.2",
        "mac": "HWTC48080515",
        "serial": "HWTC48080515",
        "queue": "Plan_128609_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-11-13T17:40:57.082673",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7011,
      "client_name": "YENAILI DEL CARMEN MONASTERIO ARGUINZONES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243814289",
      "client_email": "YENAILIMONASTERIO@GMAIL.COM",
      "address": "CALLE 01 LA BENDICION DE DIOS CASA NRO 69 SECTOR LUZ Y VIDA ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V21258648",
      "nap_box_name": "584 DOS",
      "created_at": "2024-11-13T11:53:33.790132",
      "service_detail": {
        "id": 7084,
        "ip": "172.18.137.2",
        "mac": "OEMT3C6247E2",
        "serial": "OEMT3C6247E2",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN239_PRADOS1",
        "created_at": "2024-11-13T17:44:09.705946",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7014,
      "client_name": "DIEGO JOSE AGUILAR TOVAR",
      "client_type_name": "EMPLEADO",
      "client_subdivision": "CANCELADO_EMPLEADO",
      "status_name": "Cancelado",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 78,
        "name": "Plan empleado 80MB",
        "cost": "0.00",
        "code": "FO-80M",
        "profile": "80M/80M"
      },
      "client_mobile": "04124311908",
      "client_email": "SAMUELMONTOYAM1529@GMAIL.COM",
      "address": "CALLE H CASA NRO 3 SECTOR SAMAN TARAZONERO I TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V254475412",
      "nap_box_name": "CTO-00064",
      "created_at": "2024-11-13T15:03:46.958057",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7015,
      "client_name": "ALBA ROSA GRUESO GARCES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados III",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04123983217",
      "client_email": "GRUESOANAMILETH@GMAIL.COM",
      "address": "AV 02 CASA NRO 64 SECTOR PRADO III ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V22944119",
      "nap_box_name": "580 DOS",
      "created_at": "2024-11-13T16:01:43.743684",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7016,
      "client_name": "YURIMA YOSELIN ASCANIO CORTEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "1ro de Mayo Norte",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124569049",
      "client_email": "ENYERBJESUS19@GMAIL.COM",
      "address": "PRIMERO DE MAYO  NORTE SECTOR  LOS JABILLOS EN EL CONSULTORIO MEDICO POPULAR",
      "client_identification": "V21203543",
      "nap_box_name": "CTO-00438",
      "created_at": "2024-11-14T11:59:05.317889",
      "service_detail": {
        "id": 12745,
        "ip": "172.18.136.2",
        "mac": "HW:TC:48:08:05:14",
        "serial": "HWTC48080514",
        "queue": null,
        "interface": "VLAN261_1ERO_MAYO_ZTE",
        "created_at": "2026-07-16T15:43:36.443973",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7017,
      "client_name": "ALFONZO DANIEL LEON PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Terrazas de Paya",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04122478835",
      "client_email": "ALFONZOLEON0707@GMAIL.COM",
      "address": "URB TERRAZAS DE PAYA MANZANA NRO 5, CASA NRO 1 - CALLE PRINCIPAL TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V27864400",
      "nap_box_name": "CTO-0417",
      "created_at": "2024-11-14T15:08:51.727427",
      "service_detail": {
        "id": 11326,
        "ip": "172.18.96.2",
        "mac": "HWTC48080511",
        "serial": "HWTC48080511",
        "queue": null,
        "interface": "VLAN255_TERRAZAS_PAYA",
        "created_at": "2026-01-22T20:22:15.081955",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7018,
      "client_name": "DERIAN ERNESTO LOPEZ CASANOVA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vista Hermosa",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243549692",
      "client_email": "DERIANLOPEZBAE@GMAIL.COM",
      "address": "URB VISTA HERMOSA CALLE EL ROSARIO CASA #23",
      "client_identification": "V26320699",
      "nap_box_name": "CTO-00058",
      "created_at": "2024-11-14T15:52:43.068949",
      "service_detail": {
        "id": 13103,
        "ip": "172.21.5.2",
        "mac": "HW:TC:45:B1:34:19",
        "serial": "HWTC45B13419",
        "queue": null,
        "interface": "VLAN230_VISTA_HERMOSA",
        "created_at": "2026-10-02T10:57:41.093683",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7019,
      "client_name": "NORELIS JACKELINE AGRINZONES LOGGIODICE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Canaima",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04261373536",
      "client_email": "NORELISAGRINZONES03@GMAIL.COM",
      "address": "CANAIMA CALLE 4 CASA N 17",
      "client_identification": "V18702462",
      "nap_box_name": "CTO-00315 ",
      "created_at": "2024-11-15T16:46:04.590052",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7020,
      "client_name": "ARTURO ENRIQUE ARAUJO MENDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04120798702",
      "client_email": "AEAM1994@GMAIL.COM",
      "address": "CALLE 4 CASA 425 URB ARTURO LUIS BERTI TURMERO",
      "client_identification": "V24445104",
      "nap_box_name": "CTO-00194",
      "created_at": "2024-11-16T14:57:45.510421",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7021,
      "client_name": "MIREYA COROMOTO UZCATEGUI",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243459327",
      "client_email": "MIREYACOROMOTO66@GMAIL.COM",
      "address": "CALLE RICAURTE CASA # 35 SECTOR PUEBLO NUEVO TURMERO ESTADO ARAGUA ZONA POSTAL 215",
      "client_identification": "V8038902",
      "nap_box_name": "CTO-00065",
      "created_at": "2024-11-18T09:23:46.598588",
      "service_detail": {
        "id": 7094,
        "ip": "172.18.21.2",
        "mac": "HWTC48080538",
        "serial": "HWTC48080538",
        "queue": "Plan_127996_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-11-19T08:55:05.539413",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7022,
      "client_name": "HOMERO ANTONIO TALY NAVARRO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados de Cafetal",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243087987",
      "client_email": "HOMEROTALY069@GMAIL.COM",
      "address": "PRADOS DEL CAFETAL 1 CASA PASAJE 3-3 N8",
      "client_identification": "V9650763",
      "nap_box_name": "CTO-0076",
      "created_at": "2024-11-18T11:42:30.630706",
      "service_detail": {
        "id": 7095,
        "ip": "172.18.23.2",
        "mac": "OEMT3C624896",
        "serial": "OEMT3C624896",
        "queue": "Plan_161877_15811_WispHub",
        "interface": "VLAN221_CAFETAL_OLT1",
        "created_at": "2024-11-19T10:19:16.801714",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7023,
      "client_name": "LUIS ALEXANDER ROZO GUAVITA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados III",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04127761884",
      "client_email": "ROZOLUIS310@GMAIL.COM",
      "address": "PRADOS 3 CALLE 5 CASA #18",
      "client_identification": "V13780500",
      "nap_box_name": "CTO-00305",
      "created_at": "2024-11-18T13:34:44.106799",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7024,
      "client_name": "ZULEYMA MERCEDES REBOLLEDO EMPERADOR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vista Hermosa",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04144619577",
      "client_email": "ZULEREBO@GMAIL.COM",
      "address": "CALLE LAS MANDARINAS CASA NRO 68 URB VISTA HERMOSA TURMERO EDO ARAGUA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V9660584",
      "nap_box_name": "CTO-00059",
      "created_at": "2024-11-18T13:42:25.414611",
      "service_detail": {
        "id": 12018,
        "ip": "172.18.11.2",
        "mac": "HWTC48080517",
        "serial": "HWTC48080517",
        "queue": null,
        "interface": "VLAN230_VISTA_HERMOSA",
        "created_at": "2026-03-09T14:22:03.888799",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7025,
      "client_name": "FRANCISCO JOSE JELAMBI ROLON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados de Cafetal",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243769743",
      "client_email": "JELAMBIFRANCISCO8@GMAIL.COM",
      "address": "PRADOS DEL CAFETAL CALLE 1 AL FINAL DE LA CALLE",
      "client_identification": "V5281687",
      "nap_box_name": "CTO-0076",
      "created_at": "2024-11-18T14:32:49.825920",
      "service_detail": {
        "id": 12561,
        "ip": "172.18.10.2",
        "mac": "HW:TC:36:FB:67:A1",
        "serial": "HWTC36FB67A1",
        "queue": null,
        "interface": "VLAN221_CAFETAL_OLT1",
        "created_at": "2026-06-01T12:18:35.118347",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7026,
      "client_name": "ANGEL ANTONIO ESPINOZA MEZA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados I",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04241855865",
      "client_email": "ANGELMEZA03ESPINOZA@GMAIL.COM",
      "address": "CALLE 13 CASA NRO 23 SECTOR PRADOS DE PAYA TURMERO EDO. ARAGUA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V20760690",
      "nap_box_name": "CTO-00204",
      "created_at": "2024-11-18T14:34:50.099026",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7027,
      "client_name": "CONCEPCION PEREIRA DE CARBALLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Naranjal",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04144922281",
      "client_email": "YADIRARODRIGUEZ_30@HOTMAIL.COM",
      "address": "AV. PRINCIPAL CASA NRO 34 BARRIO EL NARANJAL ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V6450896",
      "nap_box_name": "CTO-00303",
      "created_at": "2024-11-18T15:41:39.803566",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7029,
      "client_name": "JESUS RAMON MEDINA NIEVES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Valle Fresco",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128922627",
      "client_email": "JMEDINA@DIGITALMINDS.CL",
      "address": "URB. VALLE FRESCO MANZANA A CASA 16",
      "client_identification": "V29503462",
      "nap_box_name": "CTO-00603",
      "created_at": "2024-11-18T16:26:32.874263",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7030,
      "client_name": "MARLES LUCIA ALFONZO BRETO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144651737",
      "client_email": "MARLESAL2023@GMAIL.COM",
      "address": "CALLE 03 CASA NRO 06 SECTOR PRADO DE PAYA ROSARIO DE PAYA ZONA POSTAL 2115",
      "client_identification": "V22286655",
      "nap_box_name": "CTO-00304",
      "created_at": "2024-11-18T16:39:44.184568",
      "service_detail": {
        "id": 10682,
        "ip": "172.17.49.2",
        "mac": "OEMT3C624A1E",
        "serial": "OEMT3C624A1E",
        "queue": null,
        "interface": "VLAN239_PRADOS1",
        "created_at": "2025-12-13T11:57:45.314430",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7031,
      "client_name": "IVAN ENRIQUE ARANGO BORGES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243029332",
      "client_email": "IVANARANGOB1997@GMAIL.COM",
      "address": "SAMAN TARAZONERO II MANZANA F1 #10 SEGUNDA VEREDA",
      "client_identification": "V14060409",
      "nap_box_name": "162",
      "created_at": "2024-11-18T16:50:48.556122",
      "service_detail": {
        "id": 7151,
        "ip": "172.17.2.2",
        "mac": "HWTC20FD77A1",
        "serial": "HWTC20FD77A1",
        "queue": "queue1",
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2024-11-22T10:44:38.866076",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7032,
      "client_name": "MARCOS ESPEDITO ROJAS URBINA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "El Macaro",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144440312",
      "client_email": "ARAUJOROJAS315@GMAIL.COM",
      "address": "AV PROLONGACION AVENIDA BOLIVAR EDIF TORRE H PISO 7 APT 76 CONJUNTO RESIDENCIAL LOS NISPEROS TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V10760040",
      "nap_box_name": "CE-00141",
      "created_at": "2024-11-18T17:11:52.311360",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7033,
      "client_name": "YULIET ALEXANDRA NIEVES TERAN",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados III",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128901099",
      "client_email": "INSTAJOSE9@GMAIL.COM",
      "address": "CALLE 6 CASA NRO 52 BARRIO PRADO 3 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V30971748",
      "nap_box_name": "580 DOS",
      "created_at": "2024-11-18T17:36:11.473174",
      "service_detail": {
        "id": 12314,
        "ip": "172.16.253.2",
        "mac": "OEMT3C624726",
        "serial": "OEMT3C624726",
        "queue": null,
        "interface": "VLAN236_PRADOS3",
        "created_at": "2026-04-15T19:29:02.169102",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7035,
      "client_name": "MAURO RAFAEL MEDINA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Luz y Vida",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04127771622",
      "client_email": "MAUROMEDINA1975@GMAIL.COM",
      "address": "CALLE LA BENDICION DE DIOS CASA NRO 43 CASERIO LUZ Y VIDA ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V12927657",
      "nap_box_name": "CE - 745",
      "created_at": "2024-11-18T17:54:51.715434",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7036,
      "client_name": "NATHACHA JOSEFINA ALFONZO BARRIOS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Residencias Mariño",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04242945312",
      "client_email": "RICARDOSOLORZANO1985@GMAIL.COM",
      "address": "CALLE MARIÑO RESID. MARIÑO TORRE B PISO 2 APT 22",
      "client_identification": "V13769967",
      "nap_box_name": "CTO-0519",
      "created_at": "2024-11-18T18:05:07.054015",
      "service_detail": {
        "id": 7123,
        "ip": "172.16.249.2",
        "mac": "HWTC48080316",
        "serial": "HWTC48080316",
        "queue": "Plan_127996_15811_WispHub",
        "interface": "VLAN234_R_MARINO_OLT2",
        "created_at": "2024-11-21T12:32:25.980877",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7037,
      "client_name": "JENNIFER YUJAIRA HURTADO MADRIZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Orquidea",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04261391444",
      "client_email": "YUJAIRAMJE01@GMAIL.COM",
      "address": "CALLE 8 CASA NRO 156 SECTOR LA ORQUIDEA ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V18691927",
      "nap_box_name": "CTO - 918",
      "created_at": "2024-11-18T18:07:43.175297",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7038,
      "client_name": "TANIA COROMOTO TABLANTE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Brisas de Paya",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243133938",
      "client_email": "JEANBELISA01@GMAIL.COM",
      "address": "CALLE 1 CASA NRO 42 SECTOR BRISAS DE PAYA ROSARIO DE PAYA",
      "client_identification": "V17577480",
      "nap_box_name": "369",
      "created_at": "2024-11-18T18:13:03.137942",
      "service_detail": {
        "id": 7125,
        "ip": "172.16.247.2",
        "mac": "HWTC48080319",
        "serial": "HWTC48080319",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN241_BRISAS",
        "created_at": "2024-11-21T12:49:32.365078",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7039,
      "client_name": "GERALDINE ALEXANDRA TANCO MISLE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "1ro de Mayo Norte",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128842953",
      "client_email": "GERITATANCO2001@GMAIL.COM",
      "address": "CALLE MANZANA 5 CASA NRO 85 SECTOR PALMA REAL ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V27864882",
      "nap_box_name": "CTO-00458",
      "created_at": "2024-11-18T18:17:20.086899",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7041,
      "client_name": "HECTOR RAUL MUJICA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04127762629",
      "client_email": "Michelmelende@GMAIL.COM",
      "address": "AV SEGUNDA QTA LA YAGUARA NRO 5 URB BERMUDEZ MARACAY ARAGUA ZONA POSTAL 2102",
      "client_identification": "V5459700",
      "nap_box_name": "TORRE B EDIF LOS NISPEROS",
      "created_at": "2024-11-18T18:24:04.557024",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7043,
      "client_name": "ANILEC JOSEFINA CARRIZALES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Durpa",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243103478",
      "client_email": "anileccarrizales@gmail.com",
      "address": "CALLE LAS COLINAS MANZANA 18 CASA 20 SECTOR DESARROLLO URBANISTICO ROSARIO DE PAYA",
      "client_identification": "V6968773",
      "nap_box_name": "352",
      "created_at": "2024-11-18T18:26:26.512600",
      "service_detail": {
        "id": 7157,
        "ip": "172.16.244.2",
        "mac": "OEMT3C62548A",
        "serial": "OEMT3C62548A",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN240_DURPA",
        "created_at": "2024-11-23T15:37:24.477531",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7044,
      "client_name": "RICHARD JOSE ACOSTA CHIRINOS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados III",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04126422835",
      "client_email": "ACOSTARICHARD2302@GMAIL.COM",
      "address": "PRADOS III, CALLE 04, CASA NRO 26, ROSARIO DE PAYA, TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V13699274",
      "nap_box_name": "CTO-00299",
      "created_at": "2024-11-18T18:33:45.945677",
      "service_detail": {
        "id": 7102,
        "ip": "172.17.241.2",
        "mac": "HWTC48080521",
        "serial": "HWTC48080521",
        "queue": "Plan_107915_30181_WispHub",
        "interface": "VLAN236_PRADOS3",
        "created_at": "2024-11-20T09:43:54.317364",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7045,
      "client_name": "LUISA BETZABETH NATERA SANCHEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Tibisay Guevara",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243200935",
      "client_email": "DANESKACORDERO678@GMAIL.COM",
      "address": "CALLE 1 CASA NRO 5 URB TIBISAY GUEVARA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V11092070",
      "nap_box_name": "CTO-00054",
      "created_at": "2024-11-19T08:17:48.555403",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7046,
      "client_name": "NECSAY ROSMARY TORO LOPEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "SUSPENDIDO_RESIDENCIAL",
      "status_name": "Suspendido",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121489770",
      "client_email": "TNECSAY@GMAIL.COM",
      "address": "CALLE 6 CASA NRO NRO 13 SECTOR PRADOS DE PAYA 1 ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V22949206",
      "nap_box_name": "CTO-0370",
      "created_at": "2024-11-19T08:30:57.966025",
      "service_detail": {
        "id": 7130,
        "ip": "172.16.242.2",
        "mac": "OEMT3C6249CA",
        "serial": "OEMT3C6249CA",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN239_PRADOS1",
        "created_at": "2024-11-21T13:29:15.348978",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7048,
      "client_name": "JONEIXY DARIANNY ROJAS RAMIREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Prados I",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128912928",
      "client_email": "DARIANNYROJAS729@GMAIL.COM",
      "address": "CALLE 1 CASA NRO 37 BARRIO PRADO I ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V31304340",
      "nap_box_name": "CTO-00304",
      "created_at": "2024-11-19T09:09:13.560329",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7049,
      "client_name": "NIDIA YAJAIRA CARRASQUEL DE HERRERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Durpa",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243226664",
      "client_email": "NIDIACARRASQUEL17@GMAIL.COM",
      "address": "CALLE 2 MANZANA 18 CASA NRO 2 SECTOR FUNDA BARRIO ROSARIO DE PAYA EDO. ARAGUA ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V11092688",
      "nap_box_name": "392",
      "created_at": "2024-11-19T09:20:13.069468",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7050,
      "client_name": "NAYRUBI MARGARITA COMBITA PIRELA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Durpa",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243203292",
      "client_email": "NAYPIRELA.NP@GMAIL.COM",
      "address": "CALLE LIBERTAD MANZANA 15 CASA NRO 24 SECTOR DURPA ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V19175825",
      "nap_box_name": "CTO-00320",
      "created_at": "2024-11-19T09:44:01.544966",
      "service_detail": {
        "id": 7106,
        "ip": "172.17.190.2",
        "mac": "HWTC48080516",
        "serial": "HWTC48080516",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN240_DURPA",
        "created_at": "2024-11-20T11:15:31.791311",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7051,
      "client_name": "MARILYN BRILLY NOGUERA RAMOS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados III",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243219019",
      "client_email": "MARILYNNOGUERA60@GMAIL.COM",
      "address": "CALLE 02 CASA NRO 20 SECTOR PRADOS III ROSARIO DE PAYA ZONA POSTAL 2115",
      "client_identification": "V20108197",
      "nap_box_name": "CTO-00284 DOS",
      "created_at": "2024-11-19T13:50:32.365532",
      "service_detail": {
        "id": 7132,
        "ip": "172.16.240.2",
        "mac": "OEMT3C6246E2",
        "serial": "OEMT3C6246E2",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN236_PRADOS3",
        "created_at": "2024-11-21T13:38:27.480562",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7052,
      "client_name": "VIANEY JOSEFINA PINTO PRIETO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243446512",
      "client_email": "PINTOVIANEY8@GMAIL.COM",
      "address": "CALLE 6 B CASA NRO 39 SECTOR PANTIN, TURMERO, EDO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V9654244",
      "nap_box_name": "CTO-00138",
      "created_at": "2024-11-19T14:04:08.112324",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7053,
      "client_name": "EDGAR EUCLIDES ESCALANTE GONZALEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Aduana",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04124916840",
      "client_email": "KIMBERLYN04.ESCALANTE@GMAIL.COM",
      "address": "CALLE BERMUDEZ CASA NRO 105 SECTOR LA ADUANA",
      "client_identification": "V11678725",
      "nap_box_name": "282",
      "created_at": "2024-11-19T14:50:53.599774",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7054,
      "client_name": "ALFREDO EDGAR GALLARDO VELIZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243153104",
      "client_email": "PANADERIAALFREDO0750@GMAIL.COM",
      "address": "CALLE CARREÑO NRO 12 TURMERO Edo Aragua zona postal 2115",
      "client_identification": "V4669356",
      "nap_box_name": "279",
      "created_at": "2024-11-20T08:14:12.660982",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7055,
      "client_name": "CEIN ELADIO LOPEZ",
      "client_type_name": "INTERCAMBIO",
      "client_subdivision": "ACTIVO_INTERCAMBIO",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Las Rurales",
      "plan": {
        "id": 83,
        "name": "RECURRENTE INSTITUCIONAL 80M",
        "cost": "0.00",
        "code": "FO-R80",
        "profile": "80M/80M"
      },
      "client_mobile": "04143446715",
      "client_email": "RUTSAYNAIDELIVASQUEZ@HOTMAIL.COM",
      "address": "CALLE MIRANDA SECTOR LAS RURALES ROSARIO DE PAYA",
      "client_identification": "J405836482",
      "nap_box_name": "CE - 658",
      "created_at": "2024-11-20T10:34:09.329884",
      "service_detail": {
        "id": 7136,
        "ip": "172.16.236.2",
        "mac": "OEMT3C624732",
        "serial": "OEMT3C624732",
        "queue": "Plan_161876_30181_WispHub",
        "interface": "VLAN252_RURALES_PAYA",
        "created_at": "2024-11-21T14:01:15.929749",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7056,
      "client_name": "MICHELL VALOYS ZADCKIELT GUZMAN TOVAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Terrazas de Paya",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04122052962",
      "client_email": "MICHELLGUZMAN83@GMAIL.COM",
      "address": "CALLE TERRAZA DE PAYA, MANZANA 02 CASA NRO 03 SECTOR TURMERO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V31022926",
      "nap_box_name": "CTO-0502",
      "created_at": "2024-11-20T11:10:50.487321",
      "service_detail": {
        "id": 11388,
        "ip": "10.11.27.2",
        "mac": "OEMT3C625202",
        "serial": "OEMT3C625202",
        "queue": null,
        "interface": "VLAN243_BICENTENARIO",
        "created_at": "2026-01-26T13:54:27.267640",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7057,
      "client_name": "MIGUEL QUELLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados I",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124458025",
      "client_email": "MIGUELQUELLO53@GMAIL.COM",
      "address": "PRADOS 1 CALLE 6 #58",
      "client_identification": "V4542711",
      "nap_box_name": "CE - 946",
      "created_at": "2024-11-20T13:59:58.002378",
      "service_detail": {
        "id": 10964,
        "ip": "172.16.235.2",
        "mac": "HWTC48080326",
        "serial": "HWTC48080326",
        "queue": null,
        "interface": "VLAN239_PRADOS1",
        "created_at": "2025-12-26T15:08:39.658470",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7058,
      "client_name": "MARIGLORIA TRUJILLO DE ANDRADE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Valle Fresco",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04166984811",
      "client_email": "MARICT3107@GMAIL.COM",
      "address": "CALLE 2-B CASA NRO 5 URB VALLE FRESCO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V15076386",
      "nap_box_name": "MANGA 5",
      "created_at": "2024-11-20T14:25:14.681805",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7059,
      "client_name": "LILIANA ROCIO ROJAS CASTILLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243074952",
      "client_email": "JEREMIASALEXANDER2420@GMAIL.COM",
      "address": "MATA CABALLO CALLE 3  CASA #111",
      "client_identification": "V21368993",
      "nap_box_name": "CTO-00422",
      "created_at": "2024-11-21T10:35:06.968911",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7060,
      "client_name": "DERBYS  YUMERSY LEON LUNA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243235168",
      "client_email": "DERBYSLEON@GMAIL.COM",
      "address": "CALLE BOLIVAR CASA NRO A SECTOR ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V18975154",
      "nap_box_name": "CE - 655",
      "created_at": "2024-11-21T11:03:50.104933",
      "service_detail": {
        "id": 11895,
        "ip": "172.16.231.2",
        "mac": "OEMT3C624FAA",
        "serial": "OEMT3C624FAA",
        "queue": null,
        "interface": "VLAN251_RIO_SECO",
        "created_at": "2026-03-02T10:16:13.889014",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7062,
      "client_name": "MICHELLE NATHALY CASTILLO GUZMAN",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "SUSPENDIDO_RESIDENCIAL",
      "status_name": "Suspendido",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Prados I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128908364",
      "client_email": "MICHELLENCG.7@GMAIL.COM",
      "address": "CALLE 15 CASA NRO 11 SECTOR PRADOS DE PAYA 1 ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V22942692",
      "nap_box_name": "CTO-00304",
      "created_at": "2024-11-21T11:30:42.279119",
      "service_detail": {
        "id": 11992,
        "ip": "172.16.228.2",
        "mac": "HWTC48080320",
        "serial": "HWTC48080320",
        "queue": null,
        "interface": "VLAN239_PRADOS1",
        "created_at": "2026-03-06T17:49:16.228978",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7064,
      "client_name": "NANCY JOSEFINA MARTINEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124555863",
      "client_email": "NANCYJMARTINEZ14@GMAIL.COM",
      "address": "CALLE 1 CASA NRO 12 SECTOR PRADOS DE PAYA II TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V5993349",
      "nap_box_name": "CTO-00118 DOS",
      "created_at": "2024-11-21T12:59:12.174812",
      "service_detail": {
        "id": 11631,
        "ip": "10.11.13.2",
        "mac": "HWTC48080306",
        "serial": "HWTC48080306",
        "queue": null,
        "interface": "VLAN242_PRADOS2",
        "created_at": "2026-02-15T20:30:27.428987",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7066,
      "client_name": "YNES BEATRIZ HERRERA MENDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124326665",
      "client_email": "YNESHERRERA4@GMAIL.COM",
      "address": "CALLE 1 CASA NRO 03 SECTOR PRADOS DE PAYA II ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V9645191",
      "nap_box_name": "CTO-00118 DOS",
      "created_at": "2024-11-21T13:20:14.259051",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7067,
      "client_name": "WILSON JOSE SALAZAR MENDOZA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vallecito",
      "plan": {
        "id": 43,
        "name": "RECURRENTE RESIDENCIAL PLAN 650M",
        "cost": "46.00",
        "code": "FOR650M",
        "profile": "650M/650M"
      },
      "client_mobile": "04223647459",
      "client_email": "WSALAZAR2121@GMAIL.COM",
      "address": "CALLE LOS MANGOS CASA NRO 8 URB VALLECITO TURMERO EDO ARAGUA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V22948835",
      "nap_box_name": "CE-00080",
      "created_at": "2024-11-21T13:25:57.619807",
      "service_detail": {
        "id": 7144,
        "ip": "172.16.226.2",
        "mac": "OEMT3C6254A2",
        "serial": "OEMT3C6254A2",
        "queue": "Plan_161870_30181_WispHub",
        "interface": "VLAN267_LOS_MANGOS_ZTE",
        "created_at": "2024-11-21T15:38:47.492880",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7068,
      "client_name": "JONATHAN MOISES RODRIGUEZ MARTINEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Residencias Candys",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243669000",
      "client_email": "RODRIGUEZJMM@HOTMAIL.COM",
      "address": "CALLE VILLA DE CURA CASA NRO 10-10 URB FRANCISCO DE MIRANDA, FUNDACAGUA CAGUA ARAGUA ZONA POSTAL 2122",
      "client_identification": "V15831786",
      "nap_box_name": "CTO-0515",
      "created_at": "2024-11-21T13:33:17.816006",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7069,
      "client_name": "EDGARDO JOSE VILLEGAS AMAYA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villeguita",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243664734",
      "client_email": "EJVAMAYA@GMAIL.COM",
      "address": "CALLE PRINCIPAL CASA NRO 5 BARRIO VILLEGUITA I TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V27048848",
      "nap_box_name": "347",
      "created_at": "2024-11-21T13:49:25.211872",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7070,
      "client_name": "EDUARDO ALFONZO MACHADO TESORERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados III",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04226381752",
      "client_email": "MACHADOTESOREROEDUARDO@GMAIL.COM",
      "address": "PRADOS 3 CALLE 3 CASA NRO 8",
      "client_identification": "V17575434",
      "nap_box_name": "CTO-00254",
      "created_at": "2024-11-21T13:55:42.721408",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7071,
      "client_name": "YENZY HEGNY BELLO MANSO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Luz y Vida",
      "plan": {
        "id": 43,
        "name": "RECURRENTE RESIDENCIAL PLAN 650M",
        "cost": "46.00",
        "code": "FOR650M",
        "profile": "650M/650M"
      },
      "client_mobile": "04125988018",
      "client_email": "YENZYBELLO123@GMAIL.COM",
      "address": "CALLE 3 CASA NRO 165 SECTOR LUZ Y VIDA ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V16692535",
      "nap_box_name": "CTO-00308",
      "created_at": "2024-11-21T14:57:14.458171",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7072,
      "client_name": "DARWIN ALEJANDRO AMADOR ANDRADE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Betania",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243088855",
      "client_email": "AMADORANDRADES2003@GMAIL.COM",
      "address": "CALLE LA CAPILLA CASA NRO 13 SECTOR BETANIA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V30406267",
      "nap_box_name": "CTO-00233",
      "created_at": "2024-11-21T15:11:53.263533",
      "service_detail": {
        "id": 10762,
        "ip": "10.11.2.2",
        "mac": "OEMT3C624B7A",
        "serial": "OEMT3C624B7A",
        "queue": null,
        "interface": "VLAN260_BETANIA",
        "created_at": "2025-12-17T11:00:26.361699",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7073,
      "client_name": "ABRAHAM IZOGED SALAZAR RAMIREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona II Edificios",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124396279",
      "client_email": "SALAZARABRAHAM257@GMAIL.COM",
      "address": "AV INTERCOMUNAL MARACAY-TURMERO EDIF LA CASONA II EDIF 13 PISO 2 APT 2-6 LA CASONA II TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V27864618",
      "nap_box_name": "CTO-0539",
      "created_at": "2024-11-21T15:36:11.718662",
      "service_detail": {
        "id": 11777,
        "ip": "10.12.170.2",
        "mac": "HWTC48080328",
        "serial": "HWTC48080328",
        "queue": null,
        "interface": "VLAN110_CASONA_2",
        "created_at": "2026-02-27T10:46:17.222134",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7074,
      "client_name": "CALZADOS INTER MODA SRL",
      "client_type_name": "PYME",
      "client_subdivision": "CANCELADO_PYME",
      "status_name": "Cancelado",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04125971351",
      "client_email": "YAYITHA0990@GMAIL.COM",
      "address": "CALLE BOLIVAR C/C PETION EDIF MEDINA PISO PB LOCAL 01 SECTOR CENTRO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "J308334405",
      "nap_box_name": "CTO-00194",
      "created_at": "2024-11-21T15:53:43.017925",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7077,
      "client_name": "ANGEL DAVID MOLINA UTRERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128672316",
      "client_email": "ANGELDAVID86@HOTMAIL.COM",
      "address": "CALLE 13 CASA NRO 73 URB LA CASONA II TURMERO EDO ARAGUA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V17905286",
      "nap_box_name": "CTO-0606",
      "created_at": "2024-11-21T17:01:27.925475",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7078,
      "client_name": "GLEISYS YENIREE LOPEZ GONZALEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Polvorin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243461229",
      "client_email": "GLEISYSLOPEZ1986@GMAIL.COM",
      "address": "CALLE SANTA EDUVIDES SENDERO CHUAO CASA NRO 2 SECTOR POLVORIN TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V18163455",
      "nap_box_name": "CTO - 992",
      "created_at": "2024-11-22T16:07:14.626398",
      "service_detail": {
        "id": 11290,
        "ip": "10.11.86.2",
        "mac": "OEMT3C624E6A",
        "serial": "OEMT3C624E6A",
        "queue": null,
        "interface": "VLAN280_POLVORIN",
        "created_at": "2026-01-21T19:05:21.289094",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7079,
      "client_name": "JHOERICAR MARIEDID NAZARETH CORRO MERIÑO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Polvorin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04125797612",
      "client_email": "JOERICARCORRO@GMAIL.COM",
      "address": "CALLE PRINCIPAL CASA PARCELA NRO 14 SECTOR POLVORIN TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V31000651",
      "nap_box_name": "CTO - 987",
      "created_at": "2024-11-22T16:14:10.523541",
      "service_detail": {
        "id": 7153,
        "ip": "10.11.4.2",
        "mac": "HWTC48080096",
        "serial": "HWTC48080096",
        "queue": "Plan_161889_30183_WispHub",
        "interface": "VLAN280_POLVORIN",
        "created_at": "2024-11-22T17:24:29.469279",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7080,
      "client_name": "LUIS ANGEL TARAZONA ARMAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Polvorin",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04128900917",
      "client_email": "ARMASDILAN916@GMAIL.COM",
      "address": "CALLE LOS MANGOS #23 POLVORIN",
      "client_identification": "V20055848",
      "nap_box_name": "CTO-00369",
      "created_at": "2024-11-22T16:14:45.923016",
      "service_detail": {
        "id": 10616,
        "ip": "10.11.87.2",
        "mac": "OEMT3C624586",
        "serial": "OEMT3C624586",
        "queue": null,
        "interface": "VLAN280_POLVORIN",
        "created_at": "2025-12-06T15:59:29.981875",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7081,
      "client_name": "NESTOR JOSE HUNG MORA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Polvorin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04125259470",
      "client_email": "NESTORJOSEH27@GMAIL.COM",
      "address": "CALLE EL SAMAN CASA NRO 3 ZONA AGRARIA GUAYABITA SECTOR POLVORIN TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V28387665",
      "nap_box_name": "CTO - 994",
      "created_at": "2024-11-22T16:16:29.322713",
      "service_detail": {
        "id": 7184,
        "ip": "10.11.20.2",
        "mac": "HWTC48220045",
        "serial": "HWTC48220045",
        "queue": "Plan_161900_30183_WispHub",
        "interface": "VLAN280_POLVORIN",
        "created_at": "2024-11-26T09:11:50.520976",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7082,
      "client_name": "YENIFER AURIMAR MARTINEZ RIVAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Polvorin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04264516091",
      "client_email": "AGOSTO26DEL2000@GMAIL.COM",
      "address": "CALLE PRINCIPAL #11 POLVORIN",
      "client_identification": "V27520858",
      "nap_box_name": "CTO - 988",
      "created_at": "2024-11-22T16:23:08.787820",
      "service_detail": {
        "id": 13137,
        "ip": "10.10.44.2",
        "mac": "HW:TC:48:08:00:93",
        "serial": "HWTC48080093",
        "queue": null,
        "interface": "VLAN280_POLVORIN",
        "created_at": "2026-10-08T15:19:09.768567",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7083,
      "client_name": "YEIMY LISETH ALAMO GONZALEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Polvorin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04129680622",
      "client_email": "LISBEIDYMONTILLA@GMAIL.COM",
      "address": "CALLE 3 DE MAYO CASA 29 SECTOR POLVORIN TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V13201616",
      "nap_box_name": "CTO - 992",
      "created_at": "2024-11-22T16:25:22.779896",
      "service_detail": {
        "id": 7268,
        "ip": "10.11.88.2",
        "mac": "OEMT3C62525A",
        "serial": "OEMT3C62525A",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN280_POLVORIN",
        "created_at": "2024-12-01T10:38:49.774454",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7084,
      "client_name": "YUSMAR ANDREINA LIZARAZO JAIMES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Polvorin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144735851",
      "client_email": "YUSMARLIZARAZOJ3@GMAIL.COM",
      "address": "CALLE MIRADOR CASA NRO 23 SECTOR POLVORIN TURMERO EDO ARAGUA ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V19032876",
      "nap_box_name": "CTO - 996",
      "created_at": "2024-11-22T16:28:17.274055",
      "service_detail": {
        "id": 7275,
        "ip": "10.11.89.2",
        "mac": "HWTC48220041",
        "serial": "HWTC48220041",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN280_POLVORIN",
        "created_at": "2024-12-02T07:33:53.053071",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7085,
      "client_name": "YENNIFER DEL CARMEN SANDOVAL SANDOVAL",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Polvorin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121485089",
      "client_email": "YENNIFER.SANDOVAL.1751@GMAIL.COM",
      "address": "POLVORIN CALLE 3 DE MAYO PARCELA Nª27-1",
      "client_identification": "V17513414",
      "nap_box_name": "CTO - 991",
      "created_at": "2024-11-22T16:30:10.982618",
      "service_detail": {
        "id": 7162,
        "ip": "10.10.46.2",
        "mac": "HWTC48220050",
        "serial": "HWTC48220050",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN280_POLVORIN",
        "created_at": "2024-11-24T20:54:01.910902",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7087,
      "client_name": "NELSON GABRIEL CARRILLO LOPEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Polvorin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04228157853",
      "client_email": "NELSONGCARRILLOL@GMAIL.COM",
      "address": "CALLE CALLEJON LOS MANGOS CASA NRO 3 SECTOR GUAYABITA POLVORIN TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V29837346",
      "nap_box_name": "CTO-00353",
      "created_at": "2024-11-22T16:38:37.802241",
      "service_detail": {
        "id": 7155,
        "ip": "10.11.6.2",
        "mac": "HWTC48220039",
        "serial": "HWTC48220039",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN280_POLVORIN",
        "created_at": "2024-11-22T17:46:53.271088",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7088,
      "client_name": "OSWALDO DE LA CRUZ ARMAS BORGES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Polvorin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243158895",
      "client_email": "OSWALDOARMAS53@GMAIL.COM",
      "address": "CALLE PRINCIPAL 3 DE MAYO CASA NRO 27 SECTOR POLVORIN TURMERO EDO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V10358690",
      "nap_box_name": "CTO - 987",
      "created_at": "2024-11-22T16:44:32.559012",
      "service_detail": {
        "id": 7152,
        "ip": "10.11.3.2",
        "mac": "HWTC48220043",
        "serial": "HWTC48220043",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN280_POLVORIN",
        "created_at": "2024-11-22T17:20:05.774663",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7089,
      "client_name": "VLADIMIR JOSE MATOS CORDOBA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Polvorin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04123983126",
      "client_email": "VLADIMIRJOSEMATOSCORDOVA@GMAIL.COM",
      "address": "CALLE 3 DE MAYO CASA NRO 11 BARRIO POLVORIN LA BODEGUITA LA BODEGUITA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V8727032",
      "nap_box_name": "CTO - 991",
      "created_at": "2024-11-22T16:45:02.965801",
      "service_detail": {
        "id": 7161,
        "ip": "10.10.45.2",
        "mac": "HWTC48080092",
        "serial": "HWTC48080092",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN280_POLVORIN",
        "created_at": "2024-11-24T20:49:53.369056",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7090,
      "client_name": "ELIZABETH ALFONZO LOPEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Polvorin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04125855585",
      "client_email": "ALFONZOELIZABETH179@GMAIL.COM",
      "address": "CALLE LAS TROJAS CASA NRO 27 SECTOR POLVORIN TURMERO EDO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V21464003",
      "nap_box_name": "CTO - 1004",
      "created_at": "2024-11-22T16:46:29.559347",
      "service_detail": {
        "id": 12462,
        "ip": "10.11.10.2",
        "mac": "HWTC48220040",
        "serial": "HWTC48220040",
        "queue": null,
        "interface": "VLAN280_POLVORIN",
        "created_at": "2026-05-05T19:55:44.773109",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7091,
      "client_name": "JESUS ENRIQUE CEBALLOS LOPEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Polvorin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04141448112",
      "client_email": "DEISYCEBALLOS751@GMAIL.COM",
      "address": "CALLE PRINCIPAL CASA NRO 41 SECTOR POLVORIN TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V21464046",
      "nap_box_name": "CTO - 1004",
      "created_at": "2024-11-22T16:53:24.439473",
      "service_detail": {
        "id": 13130,
        "ip": "10.11.12.2",
        "mac": "HW:TC:48:22:00:49",
        "serial": "HWTC48220049",
        "queue": null,
        "interface": "VLAN280_POLVORIN",
        "created_at": "2026-10-07T11:37:25.986815",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7092,
      "client_name": "NESTOR ALBERTO ESPINOZA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Polvorin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243037237",
      "client_email": "DAMARY16849276@GMAIL.COM",
      "address": "CALLE PRINCIPAL CASA NRO 40 SECTOR PAYITA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V13520390",
      "nap_box_name": "CTO - 1001",
      "created_at": "2024-11-22T16:57:49.958037",
      "service_detail": {
        "id": 7180,
        "ip": "10.11.11.2",
        "mac": "HWTC48220032",
        "serial": "HWTC48220032",
        "queue": "queue1",
        "interface": "VLAN280_POLVORIN",
        "created_at": "2024-11-25T17:36:58.346609",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7093,
      "client_name": "JUAN MANUEL GRANADILLO MENESES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Polvorin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243601987",
      "client_email": "JUANARBITRO1107@GMAIL.COM",
      "address": "POLVORIN CALLE PRINCIPAL CALLE 3 DE MAYO 25-A",
      "client_identification": "V17513699",
      "nap_box_name": "CTO - 987",
      "created_at": "2024-11-22T17:11:11.624510",
      "service_detail": {
        "id": 7154,
        "ip": "10.11.5.2",
        "mac": "HWTC48220037",
        "serial": "HWTC48220037",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN280_POLVORIN",
        "created_at": "2024-11-22T17:33:18.410923",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7094,
      "client_name": "RAFAEL ALEJANDRO GARCIA CORRO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Polvorin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243120308",
      "client_email": "OZZOHVAN@GMAIL.COM",
      "address": "CALLE 3 DE MAYO CASA NRO 2-1 SECTOR GUAYABITA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V21204986",
      "nap_box_name": "CTO-00353",
      "created_at": "2024-11-22T17:16:15.942809",
      "service_detail": {
        "id": 7164,
        "ip": "10.11.8.2",
        "mac": "OEMT3C624982",
        "serial": "OEMT3C624982",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN280_POLVORIN",
        "created_at": "2024-11-25T09:24:36.300582",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7095,
      "client_name": "FRANKLIN EDUARDO GARCIA HERRERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Polvorin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243361207",
      "client_email": "NILEUREYES@GMAIL.COM",
      "address": "CALLE PRINCIPAL CASA NRO NRO 44-2 BARRIO TORREJON TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V19605636",
      "nap_box_name": "CTO-00354",
      "created_at": "2024-11-22T17:20:31.095696",
      "service_detail": {
        "id": 7163,
        "ip": "10.11.7.2",
        "mac": "HWTC48220036",
        "serial": "HWTC48220036",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN280_POLVORIN",
        "created_at": "2024-11-25T09:01:29.257914",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7096,
      "client_name": "CELIA MARGARITA ARMAS ALMENAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Polvorin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04123981526",
      "client_email": "ANGELO27048@GMAIL.COM",
      "address": "CALLE SANTA EDUVIGES CASA NRO 11 SECTOR POLVORIN, GUAYABITA ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V11817370",
      "nap_box_name": "CTO - 996",
      "created_at": "2024-11-22T17:27:55.282781",
      "service_detail": {
        "id": 7277,
        "ip": "10.11.90.2",
        "mac": "HWTC48220035",
        "serial": "HWTC48220035",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN280_POLVORIN",
        "created_at": "2024-12-02T07:41:39.392954",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7097,
      "client_name": "JORGE LUIS TOVAR GONZALEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Polvorin",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04162613992",
      "client_email": "JLTOVAR1109@GMAIL.COM",
      "address": "CALLE PRINCIPAL CASA NRO 25 SECTOR GUAYABITA POLVORIN TURMERO ESTADO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V14628944",
      "nap_box_name": "CTO - 987",
      "created_at": "2024-11-22T17:32:16.652673",
      "service_detail": {
        "id": 7158,
        "ip": "10.10.43.2",
        "mac": "HWTC48080540",
        "serial": "HWTC48080540",
        "queue": "Plan_107915_30181_WispHub",
        "interface": "VLAN280_POLVORIN",
        "created_at": "2024-11-24T20:18:27.990573",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7098,
      "client_name": "NOHELIS JOSEFINA VASQUEZ MEDINA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "SUSPENDIDO_RESIDENCIAL",
      "status_name": "Suspendido",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Bicentenario",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04123490516",
      "client_email": "NOHELISVASQUEZ.2018@GMAIL.COM",
      "address": "CALLE SIMON RODRIGUEZ CASA NRO 07 SECTOR BICENTENARIO",
      "client_identification": "V13769812",
      "nap_box_name": "382",
      "created_at": "2024-11-23T10:34:37.432838",
      "service_detail": {
        "id": 10010,
        "ip": "10.11.9.2",
        "mac": "VSOL00481AF1",
        "serial": "VSOL00481AF1",
        "queue": null,
        "interface": "VLAN243_BICENTENARIO",
        "created_at": "2025-11-11T14:49:03.446202",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7099,
      "client_name": "ROSA MATILDE CASTILLO ALVAREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04147944675",
      "client_email": "ROSAMATILDE1979@GMAIL.COM",
      "address": "AV. 02 CASA NRO 485 URB.  MATA CABALLO",
      "client_identification": "V15062544",
      "nap_box_name": "CTO-00222",
      "created_at": "2024-11-23T12:45:49.347692",
      "service_detail": {
        "id": 10470,
        "ip": "10.10.26.2",
        "mac": "OEMT3C625452",
        "serial": "OEMT3C625452",
        "queue": null,
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2025-12-02T12:48:56.416581",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7100,
      "client_name": "ODALIS ALEXANDRA CABEZA MUÑOZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124401407",
      "client_email": "ODALISALEX1846@GMAIL.COM",
      "address": "CALLE 23 NRO 12 SECTOR RIO SECO ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V30852477",
      "nap_box_name": "602",
      "created_at": "2024-11-23T13:20:42.123284",
      "service_detail": {
        "id": 7189,
        "ip": "10.11.25.2",
        "mac": "OEMT3C624CF6",
        "serial": "OEMT3C624CF6",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN251_RIO_SECO",
        "created_at": "2024-11-26T10:05:52.574250",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7101,
      "client_name": "ANGELY ANTONIETA GALENO CANCINE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vallecito",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04129560842",
      "client_email": "ANGYGACINE@GMAIL.COM",
      "address": "CALLE LOS MANGOS CASA NRO 19 SECTOR  ROSARIO DE PAYA",
      "client_identification": "V30754792",
      "nap_box_name": "CTO-00074",
      "created_at": "2024-11-23T13:23:41.073396",
      "service_detail": {
        "id": 10374,
        "ip": "10.11.26.2",
        "mac": "OEMT3C624CEE",
        "serial": "OEMT3C624CEE",
        "queue": null,
        "interface": "VLAN258_VALLECITO",
        "created_at": "2025-11-28T09:52:13.475878",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7102,
      "client_name": "VICTOR LUIS VINA REVERON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Polvorin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04120160343",
      "client_email": "VICTORVINA102@GMAIL.COM",
      "address": "CALLE PRINCIPAL CASA # 54 SECTOR POLVORIN TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V20336262",
      "nap_box_name": "CTO - 987",
      "created_at": "2024-11-24T20:28:16.452276",
      "service_detail": {
        "id": 12214,
        "ip": "10.10.41.2",
        "mac": "HWTC48080094",
        "serial": "HWTC48080094",
        "queue": null,
        "interface": "VLAN280_POLVORIN",
        "created_at": "2026-03-30T16:19:34.244856",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7103,
      "client_name": "YOHAN ALEXANDER LOPEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Polvorin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124615265",
      "client_email": "LOUALE.6288@GMAIL.COM",
      "address": "CALLE PRINCIPAL POLVORIN CASA NRO 19",
      "client_identification": "V21204956",
      "nap_box_name": "CTO - 987",
      "created_at": "2024-11-25T13:35:46.756208",
      "service_detail": {
        "id": 12230,
        "ip": "10.11.24.2",
        "mac": "HWTC48220034",
        "serial": "HWTC48220034",
        "queue": null,
        "interface": "VLAN280_POLVORIN",
        "created_at": "2026-03-31T10:51:10.905748",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7105,
      "client_name": "ANTONIO JOSE SANCHEZ ESCALONA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Guayabita",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04120453168",
      "client_email": "SANCHEZCACHICAMO@GMAIL.COM",
      "address": "CALLE SANTA ANA CASA NRO 05 SECTOR VALLE DEL RIO",
      "client_identification": "V7469844",
      "nap_box_name": "CTO-00407",
      "created_at": "2024-11-25T14:10:27.919843",
      "service_detail": {
        "id": 11534,
        "ip": "10.11.183.2",
        "mac": "OEMT3C62102A",
        "serial": "OEMT3C62102A",
        "queue": null,
        "interface": "VLAN286_LA_GUZMAN",
        "created_at": "2026-02-07T11:49:15.867332",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7108,
      "client_name": "HEYSEL RAFAEL ORTEGANA ALVARADO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243024857",
      "client_email": "ORTEGANA1522@GMAIL.COM",
      "address": "RIO SECO CALLE 29 NRO 1",
      "client_identification": "V24445107",
      "nap_box_name": "CTO-00253 DOS",
      "created_at": "2024-11-26T10:19:52.494517",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7109,
      "client_name": "HENRY HERNANDEZ MATA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Guayabita",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128895264",
      "client_email": "HERNANDEZMATAHENRY@GMAIL.COM",
      "address": "CTRA PRINCIPAL LOCAL PARCELA NRO 10 SECTOR LOS ICACOS GUAYABITA TURMERO ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V8732224",
      "nap_box_name": "CTO-1111",
      "created_at": "2024-11-26T10:25:47.461363",
      "service_detail": {
        "id": 11999,
        "ip": "10.11.185.2",
        "mac": "OEMT3C6252DA",
        "serial": "OEMT3C6252DA",
        "queue": null,
        "interface": "VLAN282_ZONA_AGRARIA",
        "created_at": "2026-03-07T12:42:16.768948",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7110,
      "client_name": "KIMBERLY JOHANNA MEDINA MATEUS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243228468",
      "client_email": "KIMBERLYMISHIJOS@GMAIL.COM",
      "address": "CALLE 12 A CASA NRO 01 SECTOR PANTIN",
      "client_identification": "V21022267",
      "nap_box_name": "CTO-00165",
      "created_at": "2024-11-26T11:09:30.691782",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7112,
      "client_name": "NELSON JOSE LA ROSA HERRERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Brisas de Paya",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04149474445",
      "client_email": "Yuz19784@GMAIL.COM",
      "address": "CALLE 1 CASA NRO 35 BARRIO BRISAS DE PAYA ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V22948468",
      "nap_box_name": "369",
      "created_at": "2024-11-26T12:55:51.552327",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7113,
      "client_name": "JOSE LUIS VIANA ROJAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Narayola II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04123084133",
      "client_email": "VIANAJOSEJOSE@GMAIL.COM",
      "address": "CALLE PEÑA ALTA QTA AVILUZ URB EL FARO SAN ANTONIO DE LOS ALTOS MIRANDA ZONA POSTAL 1204",
      "client_identification": "V11198456",
      "nap_box_name": "CTO-0526",
      "created_at": "2024-11-26T13:18:31.488927",
      "service_detail": {
        "id": 7200,
        "ip": "10.10.28.2",
        "mac": "HWTC48080116",
        "serial": "HWTC48080116",
        "queue": "Plan_131337_24341_WispHub",
        "interface": "VLAN117_NARAYOLA",
        "created_at": "2024-11-26T14:42:29.651111",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7114,
      "client_name": "ARNELIA NOGUERA HERNANDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados III",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128927789",
      "client_email": "NOGUERAARNELIA@GMAIL.COM",
      "address": "CALLE 3 CASA # 17  PRADO 3",
      "client_identification": "V7051289",
      "nap_box_name": "CTO-00254",
      "created_at": "2024-11-26T13:57:12.809872",
      "service_detail": {
        "id": 7201,
        "ip": "10.10.29.2",
        "mac": "HWTC48080110",
        "serial": "HWTC48080110",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN236_PRADOS3",
        "created_at": "2024-11-26T14:58:56.496766",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7116,
      "client_name": "BIANETT JOSEFINA AGUILAR DE GONZALEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Prados I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124372266",
      "client_email": "BIANETTDEGONZALEZ@GMAIL.COM",
      "address": "PRADOS DE PAYA I CALLE I CASA NRO 05",
      "client_identification": "V9438598",
      "nap_box_name": "585 DOS",
      "created_at": "2024-11-26T14:10:51.193849",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7117,
      "client_name": "JENNIFER DEL CARMEN RENGEL HERRERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04268334920",
      "client_email": "zara28yose@gmail.com",
      "address": "CALLE JORGE GOMEZ CASA # 41 BARRIO LA DEMOCRACIA, CAGUA EDO ARAGUA",
      "client_identification": "V21464579",
      "nap_box_name": "CTO-00016",
      "created_at": "2024-11-26T14:20:01.602414",
      "service_detail": {
        "id": 10445,
        "ip": "10.10.27.2",
        "mac": "HWTC48080103",
        "serial": "HWTC48080103",
        "queue": null,
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2025-12-01T19:10:37.479953",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7118,
      "client_name": "LAURA KARINA IBARRA SANDOVAL",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vista Hermosa",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04125970383",
      "client_email": "IBARRALAUKI@GMAIL.COM",
      "address": "PRADOS III CALLE PRINCIPAL CASA S/N",
      "client_identification": "V18609693",
      "nap_box_name": "237",
      "created_at": "2024-11-26T14:27:32.762498",
      "service_detail": {
        "id": 7203,
        "ip": "10.10.32.2",
        "mac": "HWTC48080102",
        "serial": "HWTC48080102",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN230_VISTA_HERMOSA",
        "created_at": "2024-11-26T15:14:03.524329",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7119,
      "client_name": "OMAIRA SANCHEZ  DE MORALES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243427283",
      "client_email": "LUNALANDA21@GMAIL.COM",
      "address": "PRADOS DE PAYA I CALLE 4 PARCELA 12",
      "client_identification": "V9656521",
      "nap_box_name": "CTO-00283",
      "created_at": "2024-11-26T14:47:42.325718",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7120,
      "client_name": "JANETH IZTURIZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243037132",
      "client_email": "ISTURIZYANETH237@GMAIL.COM",
      "address": "CALLE 1 CASA NRO 32 SECTOR MATA CABALLO ROSARIO DE PAYA PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V12667610",
      "nap_box_name": "CTO-00131",
      "created_at": "2024-11-26T14:59:35.163043",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7121,
      "client_name": "WENDYS ISBEL LUGO PUERTO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Sector los Mangos",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124293353",
      "client_email": "WENDYLUGO813@GMAIL.COM",
      "address": "CALLE PRIMERA TRANSVERSAL CASA NRO 26 SECTOR LOS MANGOS ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V23950756",
      "nap_box_name": "CTO - 1112",
      "created_at": "2024-11-26T15:01:24.078015",
      "service_detail": {
        "id": 7223,
        "ip": "10.11.48.2",
        "mac": "OEMT3C624C72",
        "serial": "OEMT3C624C72",
        "queue": "Plan_107915_30181_WispHub",
        "interface": "VLAN267_LOS_MANGOS_ZTE",
        "created_at": "2024-11-28T13:00:15.376125",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7122,
      "client_name": "GRISELDA MARIA CISNEROS BRAVO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243427912",
      "client_email": "EMPRENDERGRISELDA@GMAIL.COM",
      "address": "URB. HACIENDA PANTIN CALLE 16-A NRO 23",
      "client_identification": "V13115693",
      "nap_box_name": "CTO-00195",
      "created_at": "2024-11-26T15:10:35.106821",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7123,
      "client_name": "CARMEN LUISA VALDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Bicentenario",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04122079693",
      "client_email": "LANZ16.LM@GMAIL.COM",
      "address": "CALLE SIMON RODRIGUEZ MANZANA 13 CASA #9 PLANTA ALTA SECTOR BICENTENARIO, ROSARIO DE PAYA, TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V7214511",
      "nap_box_name": "382",
      "created_at": "2024-11-26T15:18:56.007313",
      "service_detail": {
        "id": 10731,
        "ip": "10.11.38.2",
        "mac": "OEMT3C624CA2",
        "serial": "OEMT3C624CA2",
        "queue": null,
        "interface": "VLAN243_BICENTENARIO",
        "created_at": "2025-12-15T13:17:34.543946",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7124,
      "client_name": "ROSMERYS ANDREINA RAMOS CHOPITE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados III",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04127768582",
      "client_email": "KEYLAR258@GMAIL.COM",
      "address": "PRADOS DE PAYA III CALLE 3 CASA NRO 16 ROSARIO DE PAYA ZONA POSTAL 2115",
      "client_identification": "V25074899",
      "nap_box_name": "CTO-00254",
      "created_at": "2024-11-26T15:19:45.113430",
      "service_detail": {
        "id": 9556,
        "ip": "10.10.35.2",
        "mac": "HWTC48080095",
        "serial": "HWTC48080095",
        "queue": "queue1",
        "interface": "VLAN236_PRADOS3",
        "created_at": "2025-09-24T16:53:39.071487",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7126,
      "client_name": "ANJHELY DAJHANA TOVAR TOVAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243347339",
      "client_email": "ANJHELYTOVAR347@GMAIL.COM",
      "address": "MATA CABALLO CALLE 11 CASA NRO 653 B",
      "client_identification": "V22949189",
      "nap_box_name": "CTO-00022",
      "created_at": "2024-11-26T15:44:06.172351",
      "service_detail": {
        "id": 10494,
        "ip": "10.11.39.2",
        "mac": "OEMT3C624CFE",
        "serial": "OEMT3C624CFE",
        "queue": null,
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2025-12-02T16:34:54.987443",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7127,
      "client_name": "CARLOS ALBERTO CHIRINO MORILLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Sector los Mangos",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121480344",
      "client_email": "MECANICOLOCOELGORDO@GMAIL.COM",
      "address": "AV. PRINCIPAL  CASA NRO S/N SECTOR LOS MANGOS ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V17175825",
      "nap_box_name": "CE - 789",
      "created_at": "2024-11-26T15:50:32.368345",
      "service_detail": {
        "id": 11264,
        "ip": "10.10.157.2",
        "mac": "HWTC48080286",
        "serial": "HWTC48080286",
        "queue": null,
        "interface": "VLAN267_LOS_MANGOS_ZTE",
        "created_at": "2026-01-21T09:59:36.719399",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7128,
      "client_name": "RONNY ALEXANDER FERRER CHOURIO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados I",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243350337",
      "client_email": "FERRERALEXAN@GMAIL.COM",
      "address": "PRADOS DE PAYA I CALLE PRINCIPAL CASA NRO 52",
      "client_identification": "V26535207",
      "nap_box_name": "CTO-00304",
      "created_at": "2024-11-26T15:55:26.637517",
      "service_detail": {
        "id": 12578,
        "ip": "10.11.40.2",
        "mac": "80:d4:a5:a1:d0:51",
        "serial": "HWTC48080109",
        "queue": null,
        "interface": "VLAN239_PRADOS1",
        "created_at": "2026-06-03T16:27:27.844591",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7129,
      "client_name": "ALEXIS WLADIMIR MARTINEZ HEREDIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243755064",
      "client_email": "AWMH.7271@GMAIL.COM",
      "address": "CALLE 5 NRO 285 MATA CABALLO",
      "client_identification": "V20450602",
      "nap_box_name": "CTO-00180",
      "created_at": "2024-11-26T16:04:18.442795",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7131,
      "client_name": "ELIZABETH ANTONIA CHIRINOS ROMANO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Jabillar",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04129212866",
      "client_email": "ELIZABELLA140277@GMAIL.COM",
      "address": "CALLE LOS CAOBOS CASA NRO 03-10 URB EL JABILLAR EL MACARO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V15256858",
      "nap_box_name": "CTO-0552",
      "created_at": "2024-11-26T16:22:50.833467",
      "service_detail": {
        "id": 11203,
        "ip": "10.11.41.2",
        "mac": "HWTC48080107",
        "serial": "HWTC48080107",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2026-01-16T14:42:45.171525",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7132,
      "client_name": "DORELYS DEL VALLE FRIAS PERALES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Sector los Mangos",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04126066376",
      "client_email": "AVRILYDORE33@GMAIL.COM",
      "address": "SECTOR LOS MANGOS CALLEJON LAS TUNAS CASA NRO. 8",
      "client_identification": "V20266718",
      "nap_box_name": "CTO - 953",
      "created_at": "2024-11-26T16:34:17.932937",
      "service_detail": {
        "id": 7216,
        "ip": "10.11.43.2",
        "mac": "HWTCFA51DA48",
        "serial": "HWTCFA51DA48",
        "queue": "Plan_161900_30183_WispHub",
        "interface": "VLAN267_LOS_MANGOS_ZTE",
        "created_at": "2024-11-27T15:16:40.277167",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7133,
      "client_name": "NEDDY  EGLISERIZ PEREZ LEON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121992077",
      "client_email": "NEDDYPEREZ9@GMAIL.COM",
      "address": "CALLE 14 -A NRO 26 SECTOR PANTIN II , ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V9596709",
      "nap_box_name": "CTO-00169",
      "created_at": "2024-11-26T16:49:31.485554",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7134,
      "client_name": "DORYS ALEXANDRA ROA CHIRINOS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Leocolbo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04125970902",
      "client_email": "DORYSROA19@GMAIL.COM",
      "address": "VALLES DE LEOCOLBO CALLE C VEREDA 7 CASA 47",
      "client_identification": "V15963205",
      "nap_box_name": "CTO-00371",
      "created_at": "2024-11-26T17:00:50.158003",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7135,
      "client_name": "KEILA JOSEFINA MEDINA OLIVO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "1ro de Mayo Sur",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243800866",
      "client_email": "JASPEPRIMERA@GMAIL.COM",
      "address": "CALLE CALLEJON LOS PEREIRA CASA # 54 SECTOR PRIMERO DE MAYO SUR ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V16346365",
      "nap_box_name": "CTO-00538",
      "created_at": "2024-11-26T17:10:13.799635",
      "service_detail": {
        "id": 7219,
        "ip": "10.11.46.2",
        "mac": "HWTC48080108",
        "serial": "HWTC48080108",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN261_1ERO_MAYO_ZTE",
        "created_at": "2024-11-28T09:32:05.349342",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7136,
      "client_name": "FELIX JAVIER FLORES GONZALEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04143463480",
      "client_email": "FLORESFELIXJAVIER@GMAIL.COM",
      "address": "CALLE RIVAS CASA NRO 44 URB EL NISPERO 2 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V15490826",
      "nap_box_name": "CTO-00590",
      "created_at": "2024-11-26T17:17:05.663157",
      "service_detail": {
        "id": 7234,
        "ip": "10.11.57.2",
        "mac": "OEMT3C624EEE",
        "serial": "OEMT3C624EEE",
        "queue": "Plan_92300_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-11-28T17:53:28.053969",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7137,
      "client_name": "YENNI ROSALIA SILVA MARTINEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Terrazas de Paya",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121578810",
      "client_email": "DIANAGONZALEZ26CAROLINA@GMAIL.COM",
      "address": "CALLE C CASA NRO 27 URB TERRAZAS DE PAYA, TURMERO EDO. ARAGUA. ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V13907791",
      "nap_box_name": "CTO-00348",
      "created_at": "2024-11-28T09:41:34.636050",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7138,
      "client_name": "LUIS GABRIEL MIJARES ACOSTA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04123982231",
      "client_email": "GABITO98ACOSTA@GMAIL.COM",
      "address": "CALLE SAN ANTONIO CASA NRO 06 SECTOR PAYA ABAJO ROSARIO DE PAYA ZONA POSTAL 2115",
      "client_identification": "V26320535",
      "nap_box_name": "CTO-00134",
      "created_at": "2024-11-28T09:42:56.676947",
      "service_detail": {
        "id": 10130,
        "ip": "10.11.51.2",
        "mac": "OEMT3C624CE6",
        "serial": "OEMT3C624CE6",
        "queue": null,
        "interface": "VLAN229_PANTIN",
        "created_at": "2025-11-14T13:08:28.743420",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7139,
      "client_name": "MARIA VALENTINA SEVILLA GUZMAN",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Betania",
      "plan": {
        "id": 101,
        "name": "RECURRENTE RESIDENCIAL PLAN 200M",
        "cost": "19.00",
        "code": "FOR200MB",
        "profile": "200Mbps/200Mbps"
      },
      "client_mobile": "04125057429",
      "client_email": "mvalentina030197@gmail.com",
      "address": "CALLE PRINCIPAL CASA NRO 52 URB PALMA REAL II ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V25066676",
      "nap_box_name": "CTO - 1007",
      "created_at": "2024-11-28T09:46:26.373200",
      "service_detail": {
        "id": 11939,
        "ip": "10.11.58.2",
        "mac": "OEMT3C6252FE",
        "serial": "OEMT3C6252FE",
        "queue": null,
        "interface": "VLAN260_BETANIA",
        "created_at": "2026-03-04T11:32:52.682773",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7140,
      "client_name": "OSWAYDA ALEJANDRA GARBOZA FARFAN",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ppal Paya",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243164391",
      "client_email": "GARBOZAALEJANDRA06@GMAIL.COM",
      "address": "AV PRINCIPAL CASA PARCELA 28 NRO 171 SECTOR ROSARIO DE PAYA ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V16131266",
      "nap_box_name": "CTO-00098",
      "created_at": "2024-11-28T09:53:02.505831",
      "service_detail": {
        "id": 7242,
        "ip": "10.11.65.2",
        "mac": "HWTC48080009",
        "serial": "HWTC48080009",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN261_1ERO_MAYO_ZTE",
        "created_at": "2024-11-28T18:35:34.880028",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7141,
      "client_name": "FREDDY ASDRUBAL PINANGO ACOSTA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vallecito",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243754553",
      "client_email": "PINANGOF8@GMAIL.COM",
      "address": "SECTOR VALLECITO CALLE ARAGUANEY CASA NRO 02 ROSARIO DE PAYA",
      "client_identification": "V8810990",
      "nap_box_name": "CTO-0479",
      "created_at": "2024-11-28T09:57:37.694452",
      "service_detail": {
        "id": 7222,
        "ip": "10.11.47.2",
        "mac": "HWTC48080324",
        "serial": "HWTC48080324",
        "queue": "Plan_107915_30181_WispHub",
        "interface": "VLAN258_VALLECITO",
        "created_at": "2024-11-28T11:54:32.658231",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7142,
      "client_name": "CELIA SILVA ABILA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04124440758",
      "client_email": "ACENTORCD31@GMAIL.COM",
      "address": "CALLE 9 CASA NRO 36 URB. PANTIN ROSARIO DE PAYA ARAGUA ZONA  POSTAL 2115",
      "client_identification": "V12001188",
      "nap_box_name": "CTO-00122",
      "created_at": "2024-11-28T09:57:54.371808",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7143,
      "client_name": "ENDIMAR DAYELIS MORILLO OBREGON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona I Edificios",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243360523",
      "client_email": "ENDIMORILLO23@GMAIL.COM",
      "address": "AV INTERCOMUNAL TURMERO EDIF 5 PISO 3 APT 4 SECTOR LA CASONA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V25464176",
      "nap_box_name": "CTO-0532",
      "created_at": "2024-11-28T09:58:27.721242",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7144,
      "client_name": "JACQUELIN CASTILLO MARQUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04123436798",
      "client_email": "DEFORMOST@HOTMAIL.COM",
      "address": "RIO SECO CALLE 5 NRO. 26",
      "client_identification": "V9659454",
      "nap_box_name": "611",
      "created_at": "2024-11-28T10:06:23.576779",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7145,
      "client_name": "JANETTE  JOSEFINA HERNANDEZ PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Simon Bolivar",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243482098",
      "client_email": "JH5903236@GMAIL.COM",
      "address": "EL MACARO URB. SIMON BOLIVAR CALLE 6 CASA # 23",
      "client_identification": "V6187787",
      "nap_box_name": "CTO - 75",
      "created_at": "2024-11-28T10:14:09.976217",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7147,
      "client_name": "BARBARA AISEL GONZALEZ URBINA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243772016",
      "client_email": "BARBARAGONZALEZ1992@GMAIL.COM",
      "address": "COMUNA MERCEDES TOVAR LOCAL 123 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V24420291",
      "nap_box_name": "CTO-00194",
      "created_at": "2024-11-28T10:24:32.398369",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7148,
      "client_name": "YONAIKER JOSE CHACON COLMENARES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Simon Bolivar",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04128990127",
      "client_email": "YONAIKERJCHACON@GMAIL.COM",
      "address": "CALLE 9 CASA NRO 29 URB. SIMON BOLIVAR TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V25349160",
      "nap_box_name": "CTO-00040",
      "created_at": "2024-11-28T10:26:50.454772",
      "service_detail": {
        "id": 11286,
        "ip": "10.11.60.2",
        "mac": "OEMT3C6250E6",
        "serial": "OEMT3C6250E6",
        "queue": null,
        "interface": "VLAN128_SIMON_BOLIVAR_ZTE",
        "created_at": "2026-01-21T18:23:10.827047",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7149,
      "client_name": "STEFANY GABRIELA JASPE SERRANO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Orquidea",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04125856500",
      "client_email": "STEFANYJASPE7@GMAIL.COM",
      "address": "CALLE NEGRA MATEA CASA NRO 08 SECTOR SOROCAIMA 2 19 DE ABRIL ARAGUA ZONA POSTAL 2104",
      "client_identification": "V29890973",
      "nap_box_name": "CTO-00306",
      "created_at": "2024-11-28T10:32:43.063256",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7150,
      "client_name": "PAULA MERCEDES BRICENO DE MIJARES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04128864322",
      "client_email": "GUILPAO0412@GMAIL.COM",
      "address": "CALLE LOS NISPEROS CASA NRO 10 SECTOR MIRANDA TURMERO EDO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V11977182",
      "nap_box_name": "69",
      "created_at": "2024-11-28T10:36:46.143620",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7151,
      "client_name": "RUTH REBECA CRESPO MORALES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Dios Es Mi Refugio",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121485319",
      "client_email": "RUTHREBECACRESPO@GMAIL.COM",
      "address": "DIOS ES MI REFUGIO MANZANA 9 CASA NRO 10",
      "client_identification": "V21252431",
      "nap_box_name": "CE - 941",
      "created_at": "2024-11-28T10:50:07.707134",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7152,
      "client_name": "MARIAM BETZABET GONZALEZ HERNANDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Las Rurales",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124762472",
      "client_email": "HERNANDEZMARIAM189@GMAIL.COM",
      "address": "CALLE 105 CASA NRO 98 SECTOR LAS RURALES ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V23783017",
      "nap_box_name": "CTO-00200",
      "created_at": "2024-11-28T11:34:25.581138",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7153,
      "client_name": "BEDO CARMEN URBANO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Huerta Los Pajaros",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04241430739",
      "client_email": "URBANOBEDO2705@GMAIL.COM",
      "address": "AV PRINCIPAL ROSARIO DE PAYA HUERTA LOS PAJAROS PARCELA Nº16",
      "client_identification": "V3013270",
      "nap_box_name": "96",
      "created_at": "2024-11-28T11:42:59.533265",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7154,
      "client_name": "YANEIBY YAMILETH AGUIRRE LOPEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Polvorin",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04123986793",
      "client_email": "YANEIBYAGUIRRE1@GMAIL.COM",
      "address": "CALLE LOS MANGOS CASA NRO 14 BARRIO POLVORIN TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V28284953",
      "nap_box_name": "CTO-00353",
      "created_at": "2024-11-28T11:49:46.862723",
      "service_detail": {
        "id": 7272,
        "ip": "10.11.92.2",
        "mac": "HWTC48080027",
        "serial": "HWTC48080027",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN280_POLVORIN",
        "created_at": "2024-12-01T11:19:50.834597",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7156,
      "client_name": "KENIA CAROLINA HIDALGO RONDON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Polvorin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243058197",
      "client_email": "KENIACAROLINAHIDALGORONDON@GMAIL.COM",
      "address": "CALLE CARREÑO CASA NRO 54 SECTOR SANTIAGO MARIÑO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V21202217",
      "nap_box_name": "CTO - 999",
      "created_at": "2024-11-28T12:24:13.718464",
      "service_detail": {
        "id": 9121,
        "ip": "10.11.34.2",
        "mac": "HWTC45B13349",
        "serial": "HWTC45B13349",
        "queue": "queue1",
        "interface": "VLAN280_POLVORIN",
        "created_at": "2025-07-01T16:15:15.280566",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7159,
      "client_name": "RICARDO JOSE OZAL ROMERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Guayabita",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243767659",
      "client_email": "ALEXOZAL079@GMAIL.COM",
      "address": "CALLE ANDRES BELLO CASA NRO 1-1 SECTOR LA GUZMAN GUAYABITA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V18164518",
      "nap_box_name": "CTO - 1070",
      "created_at": "2024-11-28T14:08:23.289685",
      "service_detail": {
        "id": 12292,
        "ip": "10.11.180.2",
        "mac": "HWTC48080115",
        "serial": "HWTC48080115",
        "queue": null,
        "interface": "VLAN286_LA_GUZMAN",
        "created_at": "2026-04-11T09:19:16.332766",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7160,
      "client_name": "DULCE MARIA GUTIERREZ MORA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Polvorin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04241496769",
      "client_email": "DULCEGUTI68@GMAIL.COM",
      "address": "CALLE EL SAMAN CASA NRO 7 SECTOR GUAYABITA POLVORIN ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V9339353",
      "nap_box_name": "CTO - 994",
      "created_at": "2024-11-28T14:18:44.068458",
      "service_detail": {
        "id": 7274,
        "ip": "10.11.94.2",
        "mac": "OEMT3C624E12",
        "serial": "OEMT3C624E12",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN280_POLVORIN",
        "created_at": "2024-12-01T11:59:24.999401",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7161,
      "client_name": "FLORENCIO ANTONIO FERNANDEZ PEÑALVER",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Marcelota",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04120148651",
      "client_email": "FERNANDEZPENALVER@GMAIL.COM",
      "address": "LA MARCELOTA CALLEJON BOLIVAR # 12-4",
      "client_identification": "V12610723",
      "nap_box_name": "CTO - 1058",
      "created_at": "2024-11-28T14:33:01.139590",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7162,
      "client_name": "CARMEN DEL VALLE GUZMAN",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Polvorin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04262329463",
      "client_email": "CARMENDELVALLEGUZMAN1974@GMAIL.COM",
      "address": "CALLE PRINCIPAL EL RIO CASA NRO 24 SECTOR POLVORIN TURMERO EDO ARAGUA ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V13153271",
      "nap_box_name": "CTO - 1001",
      "created_at": "2024-11-28T14:37:14.053155",
      "service_detail": {
        "id": 12051,
        "ip": "10.11.97.2",
        "mac": "HWTC48220042",
        "serial": "HWTC48220042",
        "queue": null,
        "interface": "VLAN280_POLVORIN",
        "created_at": "2026-03-14T10:48:36.306453",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7163,
      "client_name": "RICHARD HUMBERTO CAGUANA SANCHEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Marcelota",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04143476743",
      "client_email": "RICHARDCAGUANASANCHEZ@GMAIL.COM",
      "address": "LA MARCELOTA CALLEJON BOLIVAR #12-D",
      "client_identification": "V6174597",
      "nap_box_name": "CTO - 1057",
      "created_at": "2024-11-28T14:42:17.325281",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7164,
      "client_name": "ROSA ADELFINA JAIMES CASTRO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Polvorin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144863242",
      "client_email": "JAIMESR859@GMAIL.COM",
      "address": "POLVORIN CALLE EL MIRADOR NRO 23",
      "client_identification": "V9148105",
      "nap_box_name": "CTO - 996",
      "created_at": "2024-11-28T14:43:55.435198",
      "service_detail": {
        "id": 7280,
        "ip": "10.11.98.2",
        "mac": "HWTC48220048",
        "serial": "HWTC48220048",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN280_POLVORIN",
        "created_at": "2024-12-02T07:55:17.392347",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7165,
      "client_name": "MANUEL FELIPE CAMERO MENDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Marcelota",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04140515356",
      "client_email": "1968CAMERO1968@GMAIL.COM",
      "address": "LA MARCELOTA CALLE PRINCIPAL #22",
      "client_identification": "V10455475",
      "nap_box_name": "CTO - 1059",
      "created_at": "2024-11-28T14:49:46.206247",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7167,
      "client_name": "DINA MARIA RODRIGUEZ GAMBOA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Marcelota",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243004602",
      "client_email": "DINMARI1991@GMAIL.COM",
      "address": "C/ PINTO SALINA #16-1 BARRIO LA MARCELOTA -AREVALO APONTE",
      "client_identification": "V20517468",
      "nap_box_name": "CTO - 1057",
      "created_at": "2024-11-28T14:58:50.623282",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7168,
      "client_name": "JULIO CESAR GARCIA VALERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Payita",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243682821",
      "client_email": "DILANCESAR666@GMAIL.COM",
      "address": "CALLE PRINCIPAL  CASA NRO 39-1 SECTOR PAYITA ROSARIO DE PAYA ZONA POSTAL 2115",
      "client_identification": "V10455761",
      "nap_box_name": "CTO - 1023",
      "created_at": "2024-11-28T15:06:26.488020",
      "service_detail": {
        "id": 10597,
        "ip": "10.11.170.2",
        "mac": "OEMT3C624652",
        "serial": "OEMT3C624652",
        "queue": null,
        "interface": "VLAN284_PAYITA",
        "created_at": "2025-12-04T18:04:15.694050",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7169,
      "client_name": "MANUEL ANTONIO ALFONZO SILVA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Polvorin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124607273",
      "client_email": "XDM47010@GMAIL.COM",
      "address": "CALLE PRINCIPAL CASA NRO 36 SECTOR MANIRITO, GUAYABITA ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V9435716",
      "nap_box_name": "CTO - 1092",
      "created_at": "2024-11-28T15:06:44.173989",
      "service_detail": {
        "id": 13091,
        "ip": "10.11.173.2",
        "mac": "HW:TC:48:22:00:51",
        "serial": "HWTC48220051",
        "queue": null,
        "interface": "VLAN285_MANIRITO",
        "created_at": "2026-10-01T09:15:39.642418",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7170,
      "client_name": "JEAN GABRIEL YEPEZ GRANADILLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Marcelota",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243801860",
      "client_email": "JEANFGABRIEL06@GMAIL.COM",
      "address": "CALLE LA LAGUNITA CASA NRO 15-1 SECTOR LA MARCELOTA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V18163429",
      "nap_box_name": "CTO - 1061",
      "created_at": "2024-11-28T15:09:14.313580",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7171,
      "client_name": "JESUS ALBERTO ALFONZO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Polvorin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04145901939",
      "client_email": "JALBERTOALFONZO@GMAIL.COM",
      "address": "CALLE PRINCIPAL CASA NRO 13-5 SECTOR MANIRITO GUAYABITA TURMERO EDO. ARAGUA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V10751616",
      "nap_box_name": "CTO - 1089",
      "created_at": "2024-11-28T15:13:24.354858",
      "service_detail": {
        "id": 7358,
        "ip": "10.11.175.2",
        "mac": "HWTC45A02947",
        "serial": "HWTC45A02947",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN285_MANIRITO",
        "created_at": "2024-12-05T18:00:18.760273",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7173,
      "client_name": "ZHORENI YAHIR VIELMA MOLINA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04141449739",
      "client_email": "VMYAHIR06@GMAIL.COM",
      "address": "RESIDENCIAS EL PARAISO PISO 5 APTO 5-1",
      "client_identification": "V13199043",
      "nap_box_name": "CTO-0645",
      "created_at": "2024-11-28T16:11:16.534908",
      "service_detail": {
        "id": 9575,
        "ip": "10.11.200.2",
        "mac": "OEMT3C6253D6",
        "serial": "OEMT3C6253D6",
        "queue": null,
        "interface": "VLAN200_OLTs",
        "created_at": "2025-09-30T15:59:00.749782",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7174,
      "client_name": "ALBA MARINA LOPEZ CASTRO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121479191",
      "client_email": "alba.99.castro@gmail.com",
      "address": "CALLE FINAL CALLE CARREÑO NORTE EDIF TORRE 29 PISO PB APT 2 CONJUNTO RESIDENCIAL URBANISMO EL NISPERO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V26807571",
      "nap_box_name": "CTO-00207 DOS",
      "created_at": "2024-11-28T16:12:12.600418",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7175,
      "client_name": "ENSLER GLADIELIZ FRANCO LOPEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vallecito",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04125236276",
      "client_email": "LELIFRANCO.12@GMAIL.COM",
      "address": "CALLE LA CEIBA CASA NRO 44 SECTOR ROSARIO DE PAYA ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V31984097",
      "nap_box_name": "CTO - 84",
      "created_at": "2024-11-28T16:14:35.406333",
      "service_detail": {
        "id": 7246,
        "ip": "10.11.69.2",
        "mac": "OEMT3C6247BE",
        "serial": "OEMT3C6247BE",
        "queue": "Plan_161900_30183_WispHub",
        "interface": "VLAN258_VALLECITO",
        "created_at": "2024-11-29T07:38:29.732346",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7176,
      "client_name": "TONY JOSE MAYORA ACOSTA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Polvorin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04141465797",
      "client_email": "CHINIGRAPHICS15OFICIAL@GMAIL.COM",
      "address": "CALLE EL MIRADOR CASA NRO S/N SECTOR POLVORIN GUAYABITA  TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V12341567",
      "nap_box_name": "CTO - 996",
      "created_at": "2024-11-28T16:41:24.610218",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7177,
      "client_name": "JEAN SNEIDHER PEREZ GUARACO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Brisas de Paya",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04129650692",
      "client_email": "MARIELAAZUAJE9@GMAIL.COM",
      "address": "CALLE 1 CASA NRO 9 SECTOR BRISAS DE PAYA ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V26935085",
      "nap_box_name": "367",
      "created_at": "2024-11-29T09:38:19.188970",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7178,
      "client_name": "ANDELEXMAR NAZARETH SOLORZANO HERRERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Polvorin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144657752",
      "client_email": "ANDELEXMAR@GMAIL.COM",
      "address": "CALLE 3 DE MAYO CASA PARCELA # 4 SECTOR POLVORIN TURMERO ARAGUA ZONA POSTAL 215",
      "client_identification": "V30148443",
      "nap_box_name": "CTO - 1001",
      "created_at": "2024-11-29T10:11:02.044101",
      "service_detail": {
        "id": 12942,
        "ip": "10.11.35.2",
        "mac": "HW:TC:48:22:00:31",
        "serial": "HWTC48220031",
        "queue": null,
        "interface": "VLAN280_POLVORIN",
        "created_at": "2026-09-01T10:00:58.263499",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7179,
      "client_name": "MILAGROS COROMOTO COLINA DE ESCUDERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04162083456",
      "client_email": "ESCUDEROCOLINA@GMAIL.COM",
      "address": "URB. HACIENDA PANTIN CALLE 6-B CASA NRO 34",
      "client_identification": "V9655612",
      "nap_box_name": "CTO-0013B",
      "created_at": "2024-11-29T10:26:43.868395",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7180,
      "client_name": "JEFRESON YOSSUNE MEJIAS PINEDA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Macaro",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04126841811",
      "client_email": "JEFRESONMEJIAS1985@GMAIL.COM",
      "address": "CALLE HENRRY PITTIER CASA NRO 10 URB SANTA EDUVIGES EL MACARO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V17986009",
      "nap_box_name": "31",
      "created_at": "2024-11-29T10:34:53.987257",
      "service_detail": {
        "id": 10686,
        "ip": "10.11.74.2",
        "mac": "OEMT3C62475E",
        "serial": "OEMT3C62475E",
        "queue": null,
        "interface": "VLAN132_VALLE_ROSARIO",
        "created_at": "2025-12-13T13:26:09.661809",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7181,
      "client_name": "NELIDA JOSEFINA GRATEROL RIVAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04146576642",
      "client_email": "NELIDA19650@GMAIL.COM",
      "address": "URB. HACIENDA PANTIN CALLE 14B NRO. 41",
      "client_identification": "V7970815",
      "nap_box_name": "CTO-00195",
      "created_at": "2024-11-29T10:39:28.891885",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7182,
      "client_name": "AIDA DEL CARMEN MOLINA MOLINA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Polvorin",
      "plan": {
        "id": 43,
        "name": "RECURRENTE RESIDENCIAL PLAN 650M",
        "cost": "46.00",
        "code": "FOR650M",
        "profile": "650M/650M"
      },
      "client_mobile": "04143953233",
      "client_email": "MOLINADELCARMEN.21@GMAIL.COM",
      "address": "CALLE PRINCIPAL EL RIO CASA NRO S/N SECTOR POLVORIN TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V12856529",
      "nap_box_name": "CTO - 1000",
      "created_at": "2024-11-29T10:44:56.706195",
      "service_detail": {
        "id": 12178,
        "ip": "10.11.100.2",
        "mac": "HWTC48080014",
        "serial": "HWTC48080014",
        "queue": null,
        "interface": "VLAN280_POLVORIN",
        "created_at": "2026-03-25T08:14:42.638352",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7183,
      "client_name": "BEATRIZ ELENA RONDON DE RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121598115",
      "client_email": "BEATRIZROND29@GMAIL.COM",
      "address": "CALLE 27 CASA NRO 08 URB RIO SECO ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V4168800",
      "nap_box_name": "598 DOS",
      "created_at": "2024-11-29T10:49:49.830972",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7184,
      "client_name": "NEUDI LISNEYDI FLORES AVILA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Sector los Mangos",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04167056579",
      "client_email": "NEUDIFLISNEYDI@GMAIL.COM",
      "address": "AV. PRINCIPAL SECTOR LOS MANGOS CASA NRO.15",
      "client_identification": "V16434483",
      "nap_box_name": "CE-00111",
      "created_at": "2024-11-29T10:53:45.291637",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7185,
      "client_name": "GEIVYS ALFONSO PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144664065",
      "client_email": "PGEIVYS@GMAIL.COM",
      "address": "SECTOR LA CASONA 2, CALLE 13, CASA #26, TURMERO, ARAGUA, ZONA POSTAL 2115",
      "client_identification": "V12832707",
      "nap_box_name": "CTO-00090",
      "created_at": "2024-11-29T11:19:36.092521",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7186,
      "client_name": "MARIA EUGENIA MARQUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04128901678",
      "client_email": "GARCIAROLANDOJOSE87@GMAIL.COM",
      "address": "CALLE 23 CASA NRO 23 SECTOR RIO SECO ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V15760832",
      "nap_box_name": "602",
      "created_at": "2024-11-29T11:35:42.876548",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7187,
      "client_name": "MARIA ZENAIDA LUNA DE ROJAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vallecito",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04125977675",
      "client_email": "LUNAMARCELUZ08@GMAIL.COM",
      "address": "CALLE LOS NARANJOS CASA NRO 27 SECTOR VALLECITO ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V8732189",
      "nap_box_name": "CTO-00082",
      "created_at": "2024-11-29T11:39:47.296973",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7188,
      "client_name": "PEDRO REINALDO LEAL SANCHEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Naranjal",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04122441585",
      "client_email": "PEDROLEALSANCHEZ1234@GMAIL.COM",
      "address": "CALLE LA ESPERANZA CASA CASA NRO 8 SECTOR EL NARANJAL ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V25662378",
      "nap_box_name": "CE - 681",
      "created_at": "2024-11-29T11:43:31.661382",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7189,
      "client_name": "FRANKLIN DE JESUS HERNANDEZ BLANCO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "SUSPENDIDO_RESIDENCIAL",
      "status_name": "Suspendido",
      "cycle": 1,
      "migrate": true,
      "sector_name": "1ro de Mayo Norte",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124470794",
      "client_email": "FRANKLINHERNANDEZBLANCO@GMAIL.COM",
      "address": "CALLE CALLEJON LOS JABILLOS CASA NRO 12 SECTOR PRIMERO DE MAYO NORTE ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V16891386",
      "nap_box_name": "CTO-00438",
      "created_at": "2024-11-29T11:49:17.227050",
      "service_detail": {
        "id": 12793,
        "ip": "10.11.82.2",
        "mac": "OE:MT:3C:62:4E:62",
        "serial": "OEMT3C624E62",
        "queue": null,
        "interface": "VLAN261_1ERO_MAYO_ZTE",
        "created_at": "2026-08-06T09:33:55.493842",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7190,
      "client_name": "YEIDIMAR ALEXANDRA PALMA YANEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "1ro de Mayo Norte",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121591350",
      "client_email": "YEIDIPALMA98@GMAIL.COM",
      "address": "CALLE 1 CASA NRO 1 SECTOR PRIMERO DE MAYO SUR ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V28004791",
      "nap_box_name": "CTO - 878",
      "created_at": "2024-11-29T11:53:22.250398",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7191,
      "client_name": "MIRIAN JOSEFINA LOPEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Luz y Vida",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04149351445",
      "client_email": "LOPEZ220494@GMAIL.COM",
      "address": "CALLE 23 CASA NRO 23 SECTOR RIO SECO ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V12170758",
      "nap_box_name": "CE - 745",
      "created_at": "2024-11-29T11:57:44.003144",
      "service_detail": {
        "id": 7602,
        "ip": "10.11.84.2",
        "mac": "OEMT3C62508E",
        "serial": "OEMT3C62508E",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN264_LUZYVIDA_ZTE",
        "created_at": "2025-01-06T15:16:19.994586",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7192,
      "client_name": "YENNIFER CAROLINA CORDERO CEBALLOS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Polvorin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04228157568",
      "client_email": "YENNIFERCAROLINACORDEROCEBALLO@GMAIL.COM",
      "address": "SECTOR POLVORIN, CALLE SANTA EDUVIGES, CASA S/N, DETRAS DE LA CANCHA, TURMERO, ARAGUA ZONA POSTAL 2115",
      "client_identification": "V16436958",
      "nap_box_name": "CTO - 992",
      "created_at": "2024-11-29T14:06:15.308490",
      "service_detail": {
        "id": 9660,
        "ip": "10.11.101.2",
        "mac": "HWTC48080018",
        "serial": "HWTC48080018",
        "queue": null,
        "interface": "VLAN280_POLVORIN",
        "created_at": "2025-10-30T09:02:28.569109",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7193,
      "client_name": "MARIA DEL VALLE RONDON ESPIDEA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Marcelota",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243781067",
      "client_email": "MARIARONDON5AMORES@GMAIL.COM",
      "address": "AV DOCTOR MONTOYA SECTOR LA MORITA CASA NRO 89 URB VILLAS CARIBE CA PRINCIPAL TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V20694095",
      "nap_box_name": "CTO - 1061",
      "created_at": "2024-11-29T14:20:51.585372",
      "service_detail": {
        "id": 12355,
        "ip": "10.11.106.2",
        "mac": "OEMT3C62529A",
        "serial": "OEMT3C62529A",
        "queue": null,
        "interface": "VLAN281_MARCELOTA",
        "created_at": "2026-04-18T12:48:33.339352",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7194,
      "client_name": "LUIS ENRIQUE MARTINEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Marcelota",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04141476808",
      "client_email": "WILLIMARTINEZ181278@GMAIL.COM",
      "address": "SECTOR LA MARCELOTA, CALLE VICTOR MANUEL PATIÑO, CASA S/N, TURMERO, ARAGUA, ZONA POSTAL 2115",
      "client_identification": "V14060303",
      "nap_box_name": "CTO - 1064",
      "created_at": "2024-11-29T14:32:56.591723",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7195,
      "client_name": "IRIS MARGARITA SALAS SANCHEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Polvorin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243771812",
      "client_email": "SALASIRIS0101@GMAIL.COM",
      "address": "CALLEJON LOS MANGOS  CASA 5/1 POLVORIN",
      "client_identification": "V13313844",
      "nap_box_name": "CTO - 1000",
      "created_at": "2024-11-29T14:34:42.842023",
      "service_detail": {
        "id": 7276,
        "ip": "10.11.95.2",
        "mac": "HWTC48080099",
        "serial": "HWTC48080099",
        "queue": "Plan_107915_30181_WispHub",
        "interface": "VLAN280_POLVORIN",
        "created_at": "2024-12-02T07:38:27.153092",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7196,
      "client_name": "JHOALFRE ELI RODRIGUEZ RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Guayabita",
      "plan": {
        "id": 97,
        "name": "RECURRENTE RESIDENCIAL PLAN 10M",
        "cost": "18.00",
        "code": "[FOR10]",
        "profile": "10Mbps/10Mbps"
      },
      "client_mobile": "04124569864",
      "client_email": "JHOALFRIRODRIGUEZ@GMAIL.COM",
      "address": "CALLE DE TIERRA HACIA ZORRITO PARCELA TEJA CASA NRO S/N SECTOR   COLONIA DE GUAYABITA TURMERO EDO ARAGUA ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V21203997",
      "nap_box_name": "CE - 983",
      "created_at": "2024-11-29T14:53:01.952534",
      "service_detail": {
        "id": 10627,
        "ip": "10.11.187.2",
        "mac": "HWTC47310525",
        "serial": "HWTC47310525",
        "queue": null,
        "interface": "VLAN282_ZONA_AGRARIA",
        "created_at": "2025-12-07T15:13:29.170740",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7197,
      "client_name": "ALFREDO JOSE ALEJANDRO VELIZ PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Canaima",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04242051328",
      "client_email": "ALFREDO_MADRID_95@HOTMAIL.COM",
      "address": "CANAIMA CALLE 4 CASA NRO 15",
      "client_identification": "V25501520",
      "nap_box_name": "CTO-00315 ",
      "created_at": "2024-12-02T14:53:09.276653",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7198,
      "client_name": "ORIANA JENIREE CARRILLO GARCIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Valle Verde",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04123983360",
      "client_email": "ORIANACARRILLO2024@GMAIL.COM",
      "address": "SECTOR VALLE VERDE C7 SUCRE CASA NRO 26 ROSARIO DE PAYA ZONA POSTAL 2115",
      "client_identification": "V21368185",
      "nap_box_name": "CE - 691",
      "created_at": "2024-12-02T15:00:45.726340",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7199,
      "client_name": "HOMER ANTONIO RAMIREZ CELIS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "1ro de Mayo Norte",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121067463",
      "client_email": "RAMIREZHOMER47@GMAIL.COM",
      "address": "AV PRINCIPAL DE PAYA 1ERO DE MAYO NORTE CASA NRO 3 (AL FRENTE DE LA CAUCHERA) ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V10342259",
      "nap_box_name": "CTO-00225",
      "created_at": "2024-12-03T10:25:11.685558",
      "service_detail": {
        "id": 7293,
        "ip": "10.11.115.2",
        "mac": "OEMT3C624E4E",
        "serial": "OEMT3C624E4E",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN261_1ERO_MAYO_ZTE",
        "created_at": "2024-12-03T10:33:04.054946",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7200,
      "client_name": "ALEYDA JOSEFINA CISNEROS DE CALDERON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Polvorin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243179844",
      "client_email": "ALEYDACISNEROS00@GMAIL.COM",
      "address": "CALLE SANTA EDUVIGES CASA NRO 14 SECTOR POLVORIN TURMERO EDO ARAGUA ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V8742902",
      "nap_box_name": "CTO - 992",
      "created_at": "2024-12-03T10:33:19.070639",
      "service_detail": {
        "id": 7300,
        "ip": "10.11.112.2",
        "mac": "OEMT3C62535A",
        "serial": "OEMT3C62535A",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN280_POLVORIN",
        "created_at": "2024-12-03T18:55:39.591263",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7201,
      "client_name": "DAVID EDUARDO RISSO MARTINEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Marcelota",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04144764099",
      "client_email": "DAVIDRISSO2020@GMAIL.COM",
      "address": "CALLE PRINCIPAL CASA NRO 17 URB LA MARCELOTA ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V22948474",
      "nap_box_name": "CTO - 1060",
      "created_at": "2024-12-03T10:57:59.350722",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7202,
      "client_name": "MAURA LEONIDES RODRIGUEZ OROPEZA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "1ro de Mayo Norte",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128905685",
      "client_email": "RODRIGUEZLEONIDES192@GMAIL.COM",
      "address": "CALLE CHORONI CASA NRO 18 SECTOR 1RO DE MAYO ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V13426564",
      "nap_box_name": "CTO - 914",
      "created_at": "2024-12-03T14:59:19.640942",
      "service_detail": {
        "id": 12961,
        "ip": "10.11.120.2",
        "mac": "OE:MT:3C:62:4E:0A",
        "serial": "OEMT3C624E0A",
        "queue": null,
        "interface": "VLAN261_1ERO_MAYO_ZTE",
        "created_at": "2026-09-03T10:43:45.317856",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7203,
      "client_name": "YESICA YESENIA CASTRO MORENO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Marcelota",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243228432",
      "client_email": "CAILER1616@GMAIL.COM",
      "address": "CALLE LA BOMBA CASA NRO 42 SECTOR LA MARCELOTA ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V17511377",
      "nap_box_name": "CTO - 1060",
      "created_at": "2024-12-03T15:08:01.667861",
      "service_detail": {
        "id": 13129,
        "ip": "10.11.117.2",
        "mac": "HW:TC:48:08:01:19",
        "serial": "HWTC48080119",
        "queue": null,
        "interface": "VLAN281_MARCELOTA",
        "created_at": "2026-10-07T10:15:16.929916",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7204,
      "client_name": "YANET ARELYS VILLEGAS FERNANDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Marcelota",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04144469256",
      "client_email": "YAVIFER2018@GMAIL.COM",
      "address": "CALLE MONTILLA CASA NRO 11 SECTOR LA MARCELOTA TURMERO EDO ARAGUA ROSARIO DE PAYA ZONA POSTAL 2115",
      "client_identification": "V13530216",
      "nap_box_name": "CTO - 1061",
      "created_at": "2024-12-03T17:33:12.422443",
      "service_detail": {
        "id": 7297,
        "ip": "10.11.119.2",
        "mac": "OEMT3C62063E",
        "serial": "OEMT3C62063E",
        "queue": "Plan_161900_30183_WispHub",
        "interface": "VLAN281_MARCELOTA",
        "created_at": "2024-12-03T18:00:19.644782",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7205,
      "client_name": "GUSTAVO ALBERTO MARINO CABELLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Marcelota",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04242941316",
      "client_email": "GAMC3049@GMAIL.COM",
      "address": "AV. LA LAGUNITA CASA NRO 5 SECTOR LA MARCELOTA ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V4423049",
      "nap_box_name": "CTO - 1061",
      "created_at": "2024-12-03T17:40:34.435188",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7206,
      "client_name": "YULI YANIBEL BERNAL REYES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128908317",
      "client_email": "YULIYANIBEL18052@GMAIL.COM",
      "address": "CALLE Nº 16-A CASA NRO 13 SECTOR PANTIN II ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V15600358",
      "nap_box_name": "CTO-00195",
      "created_at": "2024-12-03T17:57:45.435846",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7207,
      "client_name": "NELY JOSEFINA ARZOLA DE STRAUSS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243205382",
      "client_email": "NELLYSTRAUSS2019@GMAIL.COM",
      "address": "PRADOS DE PAYA I CALLE 6 #62",
      "client_identification": "V4568221",
      "nap_box_name": "417",
      "created_at": "2024-12-04T08:07:55.804396",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7208,
      "client_name": "FELIX FERNANDO CABRERA CORTEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04125971159",
      "client_email": "FFCE.600@GMAIL.COM",
      "address": "URB.HACIENDA PANTIN CALLE 12-A #22A",
      "client_identification": "V23783232",
      "nap_box_name": "CTO-00165",
      "created_at": "2024-12-04T08:21:44.368664",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7209,
      "client_name": "LISSETH CAROLINA GAMBOA NIEVES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243784638",
      "client_email": "LISSGAM28@GMAIL.COM",
      "address": "CALLE 3 CASA NRO 129 ZONA SECTOR MATA CABALLO ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V19515756",
      "nap_box_name": "CTO-00392",
      "created_at": "2024-12-04T08:40:23.863681",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7210,
      "client_name": "MIRIAN JOSEFINA OSAL",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Guzman",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243534407",
      "client_email": "JOSEFINAMIRIAN@GMAIL.COM",
      "address": "CALLE ANDRES BELLO CASA NRO 1 SECTOR LA GUZMAN GUAYABITA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V8739758",
      "nap_box_name": "CTO - 1070",
      "created_at": "2024-12-04T08:45:17.279682",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7211,
      "client_name": "BALBINA YSABEL ROSALES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Bicentenario",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04125994851",
      "client_email": "BALBINAROSALES910@GMAIL.COM",
      "address": "MANZANA 10 CASA NRO 17 URB. FUNDABARRIO ROSARIO DE PAYA ZONA POSTAL 2115",
      "client_identification": "V6967077",
      "nap_box_name": "CTO-00192",
      "created_at": "2024-12-04T08:52:25.453544",
      "service_detail": {
        "id": 9429,
        "ip": "10.11.142.2",
        "mac": "HWTC48080007",
        "serial": "HWTC48080007",
        "queue": "queue1",
        "interface": "VLAN243_BICENTENARIO",
        "created_at": "2025-08-26T16:06:14.589723",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7212,
      "client_name": "DALILA COROMOTO CHACON RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Canaima",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243237776",
      "client_email": "DALILACHACON746@GMAIL.COM",
      "address": "CALLE 07 CASA NRO 36 SECTOR CANAIMA ROSARIO DE PAYA ZONA POSTAL 2115",
      "client_identification": "V11977942",
      "nap_box_name": "418",
      "created_at": "2024-12-04T09:09:26.545908",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7213,
      "client_name": "RUSMARY YUSLIET BLANCO LUNA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Marcelota",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243228503",
      "client_email": "BLANCORUSMARY@GMAIL.COM",
      "address": "CALLE PRINCIPAL CASA NRO 15 BARRIO LA MARCELOTA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V19003261",
      "nap_box_name": "CTO - 1058",
      "created_at": "2024-12-04T09:10:38.728072",
      "service_detail": {
        "id": 12716,
        "ip": "10.11.122.2",
        "mac": "OE:MT:3C:62:4D:16",
        "serial": "OEMT3C624D16",
        "queue": null,
        "interface": "VLAN281_MARCELOTA",
        "created_at": "2026-07-10T08:37:01.738802",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7214,
      "client_name": "GABRIELA VALENTINA CABALLERO PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Marcelota",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243129756",
      "client_email": "GVCPJPMG2017@GMAIL.COM",
      "address": "SECTOR LA MARCELOTA, CALLE MONTILLA, CASA NRO 13, LA MARCELOTA, ARAGUA ZONA POSTAL 2115",
      "client_identification": "V26935291",
      "nap_box_name": "CTO - 1061",
      "created_at": "2024-12-04T09:19:02.881872",
      "service_detail": {
        "id": 7302,
        "ip": "10.11.123.2",
        "mac": "HWTC48080021",
        "serial": "HWTC48080021",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN281_MARCELOTA",
        "created_at": "2024-12-04T09:39:16.196623",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7215,
      "client_name": "HENRY RAFAEL BLANCO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Marcelota",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243773497",
      "client_email": "HENRYTURMERO30@GMAIL.COM",
      "address": "CALLE PRINCIPAL CASA NRO 15 SECTOR LA MARCELOTA ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V8727971",
      "nap_box_name": "CTO - 1060",
      "created_at": "2024-12-04T09:21:48.251021",
      "service_detail": {
        "id": 7303,
        "ip": "10.11.124.2",
        "mac": "OEMT3C624CD2",
        "serial": "OEMT3C624CD2",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN281_MARCELOTA",
        "created_at": "2024-12-04T09:45:07.936906",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7216,
      "client_name": "NELSON ALBERTO MARTINEZ RODIL",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Polvorin",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04129681543",
      "client_email": "NM20AGOSTO1976@GMAIL.COM",
      "address": "SECTOR POLVORIN CALLE PRINCIPAL CASA NRO 26-A ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V13043888",
      "nap_box_name": "CTO-00353",
      "created_at": "2024-12-04T09:33:49.315088",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7217,
      "client_name": "ELIZABETH CAROLINA FERRINI ARRIECHE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04125234794",
      "client_email": "CARLOSJESUSFLORES11@GMAIL.COM",
      "address": "URB. HACIENDA PANTIN CALLE 5-B #26",
      "client_identification": "V17577431",
      "nap_box_name": "CTO-00136",
      "created_at": "2024-12-04T09:38:49.664584",
      "service_detail": {
        "id": 11863,
        "ip": "10.11.128.2",
        "mac": "HWTC48080001",
        "serial": "HWTC48080001",
        "queue": null,
        "interface": "VLAN229_PANTIN",
        "created_at": "2026-02-28T09:10:14.843252",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7218,
      "client_name": "CALEIXIS MARIELENA LOPEZ GARCIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Paya Abajo",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04121490648",
      "client_email": "LOPEZCALEIXIS@GMAIL.COM",
      "address": "CALLE SAN MIGUEL CASA NRO 36 SECTOR PAYA ABAJO ROSARIO DE PAYA  ABAJO ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V25880067",
      "nap_box_name": "CTO - 949",
      "created_at": "2024-12-04T09:51:36.242005",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7219,
      "client_name": "WILLIAMS JOSE MEDINA TANCO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Bicentenario",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04164441927",
      "client_email": "WILLIAMSMEDINA00@GMAIL.COM",
      "address": "CALLE LOS ROBLES MANZANA 12 CASA NRO 2 PLANTA ALTA PAYA BICENTENARIO TERRAZA DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V18702445",
      "nap_box_name": "CTO-00445",
      "created_at": "2024-12-04T10:02:48.135368",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7220,
      "client_name": "JULENNY DEL CARMEN CHIRINOS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Polvorin",
      "plan": {
        "id": 97,
        "name": "RECURRENTE RESIDENCIAL PLAN 10M",
        "cost": "18.00",
        "code": "[FOR10]",
        "profile": "10Mbps/10Mbps"
      },
      "client_mobile": "04266397982",
      "client_email": "JULENNY111@GMAIL.COM",
      "address": "CALLE ESCALONA CASA NRO 21 SECTOR PARAGUATAN GUAYABITA TURMERO EDO ARAGUA ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V11089531",
      "nap_box_name": "CTO-00397",
      "created_at": "2024-12-04T10:18:06.215479",
      "service_detail": {
        "id": 7362,
        "ip": "10.11.140.2",
        "mac": "HWTC48080003",
        "serial": "HWTC48080003",
        "queue": "Plan_161864_30181_WispHub",
        "interface": "VLAN283_PARAGUATAN",
        "created_at": "2024-12-05T18:18:55.489278",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7221,
      "client_name": "MAYELIN THAYS GONZALEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Durpa",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243147467",
      "client_email": "MAYELINGONZALES1980@GMAIL.COM",
      "address": "URB. DURPA CALLE LOS ALPES MANZANA 20 CASA NRO 07",
      "client_identification": "V14627876",
      "nap_box_name": "390",
      "created_at": "2024-12-04T10:22:04.576151",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7222,
      "client_name": "BEATRIZ ROSALBA FLORES BELLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243077881",
      "client_email": "ROSALBAFLORES18@GMAIL.COM",
      "address": "CALLE 11 CASA NRO 33 SECTOR RIO SECO ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V18644113",
      "nap_box_name": "608",
      "created_at": "2024-12-04T10:34:11.551081",
      "service_detail": {
        "id": 7311,
        "ip": "10.11.132.2",
        "mac": "HWTC48080012",
        "serial": "HWTC48080012",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN251_RIO_SECO",
        "created_at": "2024-12-04T12:15:34.111759",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7223,
      "client_name": "NORELIS CAROLINA LUCERO MARTINEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "1ro de Mayo Sur",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04123987003",
      "client_email": "NORELISLUCERO13@GMAIL.COM",
      "address": "CALLE 05 CASA NRO 07 SECTOR 1 ERO DE MAYO SUR ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V20990489",
      "nap_box_name": "CTO - 867",
      "created_at": "2024-12-04T10:40:23.060008",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7224,
      "client_name": "RAMON EDUARDO SOTELDO LOPEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Guanarito",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243633803",
      "client_email": "RAMONSOTELDO49@GMAIL.COM",
      "address": "CALLE CARABOBO GUANARITO  8-A TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V12140793",
      "nap_box_name": "447",
      "created_at": "2024-12-04T10:41:32.705352",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7225,
      "client_name": "GLEIDY CAROLINA FLORES PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04226377040",
      "client_email": "GLEIDYRAN3112@GMAIL.COM",
      "address": "CALLE 4B CASA NRO 44 URB. PANTIN TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V26535270",
      "nap_box_name": "CTO-00134",
      "created_at": "2024-12-04T10:42:36.033857",
      "service_detail": {
        "id": 9590,
        "ip": "10.11.134.2",
        "mac": "OEMT3C625142",
        "serial": "OEMT3C625142",
        "queue": null,
        "interface": "VLAN229_PANTIN",
        "created_at": "2025-10-08T11:18:45.884317",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7226,
      "client_name": "FERNANDO GODOY GONZALEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vallecito",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128909966",
      "client_email": "YELISSERAMOS@GMAIL.COM",
      "address": "CALLE LAS PALMAS CASA NRO 12 SECTOR VALLECITO ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V19284764",
      "nap_box_name": "CTO - 00395",
      "created_at": "2024-12-04T11:13:38.143537",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7227,
      "client_name": "NORA JOSEFINA PICHARDO MONSALVE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04264648857",
      "client_email": "PICHARDONORA26@GMAIL.COM",
      "address": "CALLE 3 CASA NRO 1 SECTOR RIO SECO ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V10672243",
      "nap_box_name": "CTO-00385",
      "created_at": "2024-12-04T11:20:43.735979",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7228,
      "client_name": "ROSA MARIA FIGUEREDO ARTEAGA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128993350",
      "client_email": "ROSAFIGUEREDO1972@GMAIL.COM",
      "address": "CALLE 14-B CASA NRO 25 URB. PANTIN ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V10999617",
      "nap_box_name": "CTO-00052",
      "created_at": "2024-12-04T11:25:29.227858",
      "service_detail": {
        "id": 12732,
        "ip": "10.11.137.2",
        "mac": "OE:MT:3C:62:4D:0E",
        "serial": "OEMT3C624D0E",
        "queue": null,
        "interface": "VLAN229_PANTIN",
        "created_at": "2026-07-13T11:19:37.108753",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7229,
      "client_name": "VANESSA CAROLINA CEDENO MENDOZA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Taguapire",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04129607662",
      "client_email": "KARELISLAURACEDENO@GMAIL.COM",
      "address": "EL MACARO URB. TAGUAPIRE CALLE 2 APT. 52 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V16132612",
      "nap_box_name": "CTO-00388 DOS",
      "created_at": "2024-12-04T11:58:46.621031",
      "service_detail": {
        "id": 10510,
        "ip": "10.11.203.2",
        "mac": "OEMT3C624A5E",
        "serial": "OEMT3C624A5E",
        "queue": null,
        "interface": "VLAN129_TAGUAPIRE_ZTE",
        "created_at": "2025-12-03T10:01:46.451094",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7230,
      "client_name": "MARIBEL PIMENTEL MARTINEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Polvorin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243364765",
      "client_email": "PIMENTELMARIBEL792@GMAIL.COM",
      "address": "CALLE VIA CHUAO # 59 POLVORIN",
      "client_identification": "V14627946",
      "nap_box_name": "CTO - 996",
      "created_at": "2024-12-04T13:22:17.294197",
      "service_detail": {
        "id": 7321,
        "ip": "10.11.113.2",
        "mac": "OEMT3C624ACA",
        "serial": "OEMT3C624ACA",
        "queue": "Plan_107915_30181_WispHub",
        "interface": "VLAN280_POLVORIN",
        "created_at": "2024-12-04T13:36:32.975486",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7231,
      "client_name": "ENMY CARELYS CASTILLO MORALES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "0412 063099",
      "client_email": "enmycastillo370@gmail.com",
      "address": "CALLE #6 CASA NRO 421-B SECTOR MATA CABALLO ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V27189138",
      "nap_box_name": "CTO-00031",
      "created_at": "2024-12-04T13:45:09.118048",
      "service_detail": {
        "id": 10354,
        "ip": "10.11.204.2",
        "mac": "A8BF3C6253F9",
        "serial": "OEMT3C6253FA",
        "queue": null,
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2025-11-26T15:42:18.255535",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7232,
      "client_name": "DENNIS ANTONIO HERRERA GUZMAN",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04127482039",
      "client_email": "DENNISHERRERA21285@GMAIL.COM",
      "address": "CALLE PETION COMUNA FRENTE DE LA PLAZA DE TURMERO LOCAL  C-33",
      "client_identification": "V17246747",
      "nap_box_name": "CTO-00194",
      "created_at": "2024-12-04T14:04:07.500434",
      "service_detail": {
        "id": 7326,
        "ip": "10.11.144.2",
        "mac": "HWTC48080008",
        "serial": "HWTC48080008",
        "queue": "Plan_161875_15811_WispHub",
        "interface": "VLAN276_COMUNA_OLT1",
        "created_at": "2024-12-05T10:29:32.186495",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7233,
      "client_name": "VICTOR SEGUNDO MENDEZ PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Naranjal",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124815270",
      "client_email": "VICTORSEGUNDOMP@GMAIL.COM",
      "address": "CALLE 3 CASA NRO 3-A SECTOR HACIENDA EL NARANJAL ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V25845240",
      "nap_box_name": "CTO-00303",
      "created_at": "2024-12-04T14:07:04.528468",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7234,
      "client_name": "DANIELA SOFIA RODRIGUEZ ALFONZO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Manirito",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124324800",
      "client_email": "DANIELASOFIARODRIGUEZALFONZO@GMAIL.COM",
      "address": "CTRRA VIA GUAYABITA CASA NRO.11 SECTOR MARINITO TURMERO-ARAGUA ZONA POSTAL 2115",
      "client_identification": "V31478530",
      "nap_box_name": "CTO - 1089",
      "created_at": "2024-12-04T14:18:30.407538",
      "service_detail": {
        "id": 11295,
        "ip": "10.11.176.2",
        "mac": "HWTC48080113",
        "serial": "HWTC48080113",
        "queue": null,
        "interface": "VLAN285_MANIRITO",
        "created_at": "2026-01-22T09:36:05.965315",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7235,
      "client_name": "YUMILETH SINAI COLON TORRES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "SUSPENDIDO_RESIDENCIAL",
      "status_name": "Suspendido",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128152928",
      "client_email": "YUMILETHCOLON2@GMAIL.COM",
      "address": "SECTOR RIO SECO CALLE 29 CASA NRO 29 ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V27520345",
      "nap_box_name": "CTO-00253 DOS",
      "created_at": "2024-12-04T14:21:16.932647",
      "service_detail": {
        "id": 12854,
        "ip": "10.11.145.2",
        "mac": "68:9F:f0:2a:6c:5f",
        "serial": "ZXICCDA09119",
        "queue": null,
        "interface": "VLAN251_RIO_SECO",
        "created_at": "2026-08-16T18:17:58.026927",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7236,
      "client_name": "YASMELYS NAKARY GARCIA BELLORIN",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243370507",
      "client_email": "ALGAEDYAS@GMAIL.COM",
      "address": "CALLE RIVAS C.C RANDAZZO PISO 1 LOCAL 8-A TURMERO",
      "client_identification": "V15428999",
      "nap_box_name": "CAJA NAP BICENTENARIO",
      "created_at": "2024-12-04T14:29:18.439344",
      "service_detail": {
        "id": 7397,
        "ip": "10.11.205.2",
        "mac": "A8BF3C624575",
        "serial": "OEMT3C624576",
        "queue": "Plan_127996_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-12-11T11:58:04.053512",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7237,
      "client_name": "MICHELLE ALEJANDRA MELENDEZ RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Valle Fresco",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04127762629",
      "client_email": "MICHELMELENDE@GMAIL.COM",
      "address": "URB. VALLE FRESCO MANZANA I NRO 03 TURMERO EDO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V14362782",
      "nap_box_name": "CTO - 981",
      "created_at": "2024-12-04T14:58:35.476448",
      "service_detail": {
        "id": 12379,
        "ip": "10.11.148.2",
        "mac": "HWTC48080317",
        "serial": "HWTC48080317",
        "queue": null,
        "interface": "VLAN270_VALLE_FRESCO_OLT3",
        "created_at": "2026-04-20T13:03:47.795953",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7238,
      "client_name": "FRANK ANIBAL ALAMO GONZALEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Guayabita",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144637647",
      "client_email": "FRANKALAMO21@GMAIL.COM",
      "address": "GUAYABITA, PARCELA #42 LAS TRES CRUCES",
      "client_identification": "V14943445",
      "nap_box_name": "CTO - 1117",
      "created_at": "2024-12-04T15:18:04.584834",
      "service_detail": {
        "id": 7340,
        "ip": "10.11.159.2",
        "mac": "HWTC48220053",
        "serial": "HWTC48220053",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN282_ZONA_AGRARIA",
        "created_at": "2024-12-05T15:03:28.828281",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7239,
      "client_name": "CARMEN ALICIA PERDOMO GUTIERREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "1ro de Mayo Sur",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121487974",
      "client_email": "JC7944928@GMAIL.COM",
      "address": "CALLE 2 CASA NRO 17 SECTOR PRIMERO DE MAYO SUR ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V13858340",
      "nap_box_name": "CTO - 00398",
      "created_at": "2024-12-04T15:24:54.074545",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7240,
      "client_name": "ANGELINA ROSA PACHECO LOPEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Paraguatan",
      "plan": {
        "id": 101,
        "name": "RECURRENTE RESIDENCIAL PLAN 200M",
        "cost": "19.00",
        "code": "FOR200MB",
        "profile": "200Mbps/200Mbps"
      },
      "client_mobile": "04243754807",
      "client_email": "PACHECOAN2024@GMAIL.COM",
      "address": "CALLE PARAGUATAN CASA NRO 31 BARRIO PARAGUATAN TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V10459172",
      "nap_box_name": "CTO - 1118",
      "created_at": "2024-12-04T15:31:28.921530",
      "service_detail": {
        "id": 7389,
        "ip": "10.11.178.2",
        "mac": "HWTC47310538",
        "serial": "HWTC47310538",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN283_PARAGUATAN",
        "created_at": "2024-12-11T08:37:42.449568",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7241,
      "client_name": "DIANA OLIMAR LAYA MARQUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243220506",
      "client_email": "LAYADIANA892@GMAIL.COM",
      "address": "CALLE NEGRO PRIMERO CASA NRO 26 SECTOR TURMERO NORTE TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V18163298",
      "nap_box_name": "CTO-00065",
      "created_at": "2024-12-04T15:38:57.068449",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7242,
      "client_name": "CRISTIAN VALERIO RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243414102",
      "client_email": "CRISTIANVALERIORODRIGUEZLOPEZ@GMAIL.COM",
      "address": "CALLE LAS COROCORAS CASA 68 URB LAS AVES",
      "client_identification": "V12142089",
      "nap_box_name": "CTO-00256",
      "created_at": "2024-12-04T15:42:05.122967",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7243,
      "client_name": "MANUEL ANTONIO TESORERO NAVARRO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Guayabita",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04141574894",
      "client_email": "MANUEL19TESORERO@GMAIL.COM",
      "address": "PARCELA 44/A AVENIDA PRINCIPAL LAS 3 CRUCES GUAYABITA",
      "client_identification": "V21442938",
      "nap_box_name": "CTO - 1117",
      "created_at": "2024-12-04T15:44:52.546045",
      "service_detail": {
        "id": 8089,
        "ip": "10.11.158.2",
        "mac": "HWTC48080310",
        "serial": "HWTC48080310",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN282_ZONA_AGRARIA",
        "created_at": "2025-04-01T09:25:28.316960",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7244,
      "client_name": "JAIRO ARNEDO ROMERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Guayabita",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124662820",
      "client_email": "JARNEDO08@GMAIL.COM",
      "address": "GUAYABITA SECTOR LAS TRES CRUCES ENTRADA DE LA GUZMAN LAS AVESTRUCES",
      "client_identification": "V22770576",
      "nap_box_name": "CE - 991",
      "created_at": "2024-12-04T16:35:34.589528",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7245,
      "client_name": "CARLOS JESUS GOMEZ BLANCO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Guzman",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04160402057",
      "client_email": "CARLOSJGB1955@GMAIL.COM",
      "address": "CALLE 3 CASA NRO 15 SECTOR LA GUZMAN TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V4273125",
      "nap_box_name": "CTO - 1075",
      "created_at": "2024-12-04T16:36:09.222296",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7246,
      "client_name": "YONNY RAMON PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Polvorin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243673898",
      "client_email": "PEREZYONNY13RAMON@GMAIL.COM",
      "address": "CALLE PRINCIPAL CASA NRO 12 SECTOR POLVORIN TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V13880766",
      "nap_box_name": "CE-00164",
      "created_at": "2024-12-04T16:50:22.979886",
      "service_detail": {
        "id": 11997,
        "ip": "10.11.184.2",
        "mac": "HWTC48080114",
        "serial": "HWTC48080114",
        "queue": null,
        "interface": "VLAN282_ZONA_AGRARIA",
        "created_at": "2026-03-07T09:52:35.535754",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7247,
      "client_name": "GUSTAVO ENRIQUE CONTRERAS ULLOA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "1ro de Mayo Norte",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121225753",
      "client_email": "GUSTAVOE0306@GMAIL.COM",
      "address": "1ERO DE MAYO NORTE CALLE GUAICAIPURO CASA NRO.2",
      "client_identification": "V20706829",
      "nap_box_name": "CTO-00235",
      "created_at": "2024-12-04T16:53:11.159120",
      "service_detail": {
        "id": 11102,
        "ip": "10.11.208.2",
        "mac": "A8BF3C624509",
        "serial": "OEMT3C62450A",
        "queue": null,
        "interface": "VLAN261_1ERO_MAYO_ZTE",
        "created_at": "2026-01-11T18:33:08.525453",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7248,
      "client_name": "JOHELY DEL CARMEN GARCIA COLMENAREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Guayabita",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144454574",
      "client_email": "JOHELYG51@GMAIL.COM",
      "address": "CALLE PASO REAL CASA NRO 05 SECTOR GUAYABITA ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V19466423",
      "nap_box_name": "CE - 924",
      "created_at": "2024-12-04T16:57:29.552600",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7250,
      "client_name": "AMERICO KALINHOFF DIAZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Guayabita",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243597758",
      "client_email": "KALINHOFF.VE@GMAIL.COM",
      "address": "CTRA GUAYABITA CASA NRO 35 SECTOR LA GUAYABITA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V2995723",
      "nap_box_name": "CE - 956",
      "created_at": "2024-12-04T17:10:47.465614",
      "service_detail": {
        "id": 13107,
        "ip": "10.11.191.2",
        "mac": "OE:MT:3C:62:4A:B2",
        "serial": "OEMT3C624AB2",
        "queue": null,
        "interface": "VLAN282_ZONA_AGRARIA",
        "created_at": "2026-10-02T14:05:53.769563",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7251,
      "client_name": "ANDRU ISAI CALDERON RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Valle Fresco",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243322449",
      "client_email": "ANDRU52872@GMAIL.COM",
      "address": "URB.VALLE FRESCO MANZANA 11 CASA # 11",
      "client_identification": "V26140048",
      "nap_box_name": "CE - 932",
      "created_at": "2024-12-04T17:20:03.514413",
      "service_detail": {
        "id": 7329,
        "ip": "10.11.147.2",
        "mac": "OEMT3C624B72",
        "serial": "OEMT3C624B72",
        "queue": "Plan_92194_15811_WispHub",
        "interface": "VLAN270_VALLE_FRESCO_OLT3",
        "created_at": "2024-12-05T11:20:45.939707",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7252,
      "client_name": "JOSE ANTONIO TESORERO NAVARRO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Guayabita",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144506643",
      "client_email": "JOSEMAQUINARIAS123@hotmail.com",
      "address": "AV PRINCIPAL CASA PÀRCELA NRO 44 SECTOR LAS 3 CRUCES LA CRUZ ARAGUA ZONA POSTAL 2115",
      "client_identification": "V18231377",
      "nap_box_name": "CTO - 1117",
      "created_at": "2024-12-04T17:21:29.339937",
      "service_detail": {
        "id": 11222,
        "ip": "10.10.95.2",
        "mac": "HWTC48080314",
        "serial": "HWTC48080314",
        "queue": null,
        "interface": "VLAN282_ZONA_AGRARIA",
        "created_at": "2026-01-18T16:01:39.905818",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7253,
      "client_name": "YENNIBE COROMOTO PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Polvorin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04123982753",
      "client_email": "YENNIBEP@GMAIL.COM",
      "address": "CALLE EL RINCON CASA S/N SECTOR PARAGUATAN POLVORIN ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V20130477",
      "nap_box_name": "CTO - 1118",
      "created_at": "2024-12-04T17:26:31.610939",
      "service_detail": {
        "id": 12036,
        "ip": "10.11.177.2",
        "mac": "HWTC48080120",
        "serial": "HWTC48080120",
        "queue": null,
        "interface": "VLAN283_PARAGUATAN",
        "created_at": "2026-03-11T16:28:13.365912",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7255,
      "client_name": "LEOANGELYS EMIBEL SEIJAS MORENO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Payita",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144475233",
      "client_email": "LEOANGELYSSEIJAS24@GMAIL.COM",
      "address": "CALLE LA CROQUERA CASA NRO 26 SECTOR PAYITA ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V25620940",
      "nap_box_name": "CTO - 1039",
      "created_at": "2024-12-05T08:39:00.207164",
      "service_detail": {
        "id": 12620,
        "ip": "10.11.169.2",
        "mac": "OE:MT:3C:62:46:72",
        "serial": "OEMT3C624672",
        "queue": null,
        "interface": "VLAN284_PAYITA",
        "created_at": "2026-06-16T16:43:43.141017",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7256,
      "client_name": "ALVARO AMEIJENDA SANTANA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Guayabita",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04245708975",
      "client_email": "BERNAEZPALMAEYMMYJONEISY@GMAIL.COM",
      "address": "CALLEJON MANIRITO CASA NRO 42, GUAYABITA, ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V11085442",
      "nap_box_name": "CTO - 1090",
      "created_at": "2024-12-05T11:26:29.095604",
      "service_detail": {
        "id": 9374,
        "ip": "10.11.172.2",
        "mac": "HWTC47310540",
        "serial": "HWTC47310540",
        "queue": "queue1",
        "interface": "VLAN285_MANIRITO",
        "created_at": "2025-08-16T12:38:30.253767",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7257,
      "client_name": "MARIA EMILIA MOY CARABALLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Durpa",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243839777",
      "client_email": "MARIAMOY348@GMAIL.COM",
      "address": "CALLE AVE DEL PARAISO CASA NRO 05 ZONA ROSARIO DE PAYA TURMERO EDO ARAGUA ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V9653971",
      "nap_box_name": "CTO-00302",
      "created_at": "2024-12-05T11:48:23.511062",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7258,
      "client_name": "HERACLIO JOSE RAMON MARTINEZ ACOSTA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Polvorin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243138830",
      "client_email": "MARTINEZHERACLIO804@GMAIL.COM",
      "address": "CALLE LOS MANGOS CASA NUMERO 3 POLVORIN",
      "client_identification": "V17984468",
      "nap_box_name": "CTO - 999",
      "created_at": "2024-12-05T12:25:17.379730",
      "service_detail": {
        "id": 10268,
        "ip": "10.11.156.2",
        "mac": "HWTC48080304",
        "serial": "HWTC48080304",
        "queue": null,
        "interface": "VLAN280_POLVORIN",
        "created_at": "2025-11-22T19:52:33.426456",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7259,
      "client_name": "BELITZA MADELEY BORGES PALACIOS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243209106",
      "client_email": "BELITZABORGES05@GMAIL.COM",
      "address": "PANTIN CALLE 9-B  CASA NRO 15",
      "client_identification": "V26320544",
      "nap_box_name": "CTO-00142",
      "created_at": "2024-12-05T13:35:25.008785",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7260,
      "client_name": "JULIO CESAR PENA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vallecito",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04129389013",
      "client_email": "JULIOCESARPENA231@GMAIL.COM",
      "address": "CALLE CUJI CASA NRO 26 SECTOR VALLECITO",
      "client_identification": "V16851112",
      "nap_box_name": "CTO - 81",
      "created_at": "2024-12-05T13:45:34.452437",
      "service_detail": {
        "id": 7335,
        "ip": "10.11.155.2",
        "mac": "HWTC47310535",
        "serial": "HWTC47310535",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN258_VALLECITO",
        "created_at": "2024-12-05T13:53:35.847981",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7261,
      "client_name": "JOSE ALEJANDRO REA CASTILLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04263327064",
      "client_email": "JOSEALEJANDROREACASTILLO@GMAIL.COM",
      "address": "CALLE RIO SECO Nª13 CASA NRO 14 SECTOR ROSARIO DE PAYA ROSARIO DE PAYA ARAGUA ZONA POSTA 2115",
      "client_identification": "V20241008",
      "nap_box_name": "CE - 578",
      "created_at": "2024-12-05T14:12:59.911449",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7262,
      "client_name": "ZULAY COROMOTO AVILA AULAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Polvorin",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243518829",
      "client_email": "ZULAYAVILA97@GMAIL.COM",
      "address": "CALLE EL MIRADOR CASA NRO 22 SECTOR GUAYABITA POLVORIN ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V4585846",
      "nap_box_name": "CTO - 997",
      "created_at": "2024-12-05T14:48:46.634007",
      "service_detail": {
        "id": 7414,
        "ip": "10.11.212.2",
        "mac": "A8BF3C624529",
        "serial": "OEMT3C62452A",
        "queue": "Plan_161900_30183_WispHub",
        "interface": "VLAN280_POLVORIN",
        "created_at": "2024-12-11T13:58:23.047005",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7263,
      "client_name": "ROSA COROMOTO TARAZONA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Polvorin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243654061",
      "client_email": "ROSACT14@GMAIL.COM",
      "address": "CALLE EL MIRADOR # 11 POLVORIN",
      "client_identification": "V11977154",
      "nap_box_name": "CTO - 997",
      "created_at": "2024-12-05T14:51:02.569923",
      "service_detail": {
        "id": 7348,
        "ip": "10.11.167.2",
        "mac": "OEMT3C624F62",
        "serial": "OEMT3C624F62",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN280_POLVORIN",
        "created_at": "2024-12-05T16:10:40.023866",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7264,
      "client_name": "MARTHA CAROLINA ESTRADA TABLANTE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128952737",
      "client_email": "MARTHACESTRADAT04@GMAIL.COM",
      "address": "CALLE PROLONGACION C/CARREÑO EDIF. TORRE 23 PISO PB APT 01 URB. HACIENDA EL NISPERO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V15498462",
      "nap_box_name": "CTO-00207 DOS",
      "created_at": "2024-12-05T14:58:38.197263",
      "service_detail": {
        "id": 12405,
        "ip": "10.11.213.2",
        "mac": "OEMT3C62472A",
        "serial": "OEMT3C62472A",
        "queue": null,
        "interface": "VLAN209_ZAMORA_OLT1",
        "created_at": "2026-04-24T14:21:18.625924",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7265,
      "client_name": "YERKIS GREGORIA MELENDEZ CORREA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Guayabita",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243739139",
      "client_email": "YERKISGREGORIAM@GMAIL.COM",
      "address": "CTRA PRINCIPAL GUAYABITA CASA PARCELA NRO 44-A SECTOR LAS TRES CRUCES ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V14538998",
      "nap_box_name": "CTO - 1117",
      "created_at": "2024-12-05T15:01:44.758512",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7266,
      "client_name": "CARMEN ADELINA RAMOS UGARTE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Payita",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04144479135",
      "client_email": "RAMOCARMEN3@GMAIL.COM",
      "address": "CALLE PRINCIPAL CASA NRO. 10 SECTOR PAYITA TURMERO EDO. ARAGUA ROSARIO DE PAYA ZONA POSTAL 2115",
      "client_identification": "V13908477",
      "nap_box_name": "CE - 861",
      "created_at": "2024-12-05T15:08:36.345010",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7267,
      "client_name": "JULEXI BETSABE REYES PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Las Rurales",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243024857",
      "client_email": "REYESJULE7@GMAIL.COM",
      "address": "CALLE N# 107 CASA N#69 SECTOR LAS RURALES MANZANA B ROSARIO DE PAYA",
      "client_identification": "V18852981",
      "nap_box_name": "CE - 667",
      "created_at": "2024-12-05T15:20:05.820733",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7268,
      "client_name": "CARMEN TERESA DIAZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados III",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121486070",
      "client_email": "TORRESKLERIANNY32@GMAIL.COM",
      "address": "CALLE 3 CASA NRO. 12 PRADOS DE PAYA III",
      "client_identification": "V9875389",
      "nap_box_name": "CTO-00254",
      "created_at": "2024-12-05T15:20:26.194217",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7269,
      "client_name": "YONDIS ALEXANDER CABRERA LARA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Guayabita",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04267113285",
      "client_email": "YONDYSA.C112@GMAIL.COM",
      "address": "CALLE EL MIRADOR CASA NRO 40 SECTOR PARAGUATAN LA UNION ARAGUA ZONA POSTAL 2115",
      "client_identification": "V31645378",
      "nap_box_name": "CE - 924",
      "created_at": "2024-12-05T15:21:53.225770",
      "service_detail": {
        "id": 7342,
        "ip": "10.11.161.2",
        "mac": "OEMT3C62459A",
        "serial": "OEMT3C62459A",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN283_PARAGUATAN",
        "created_at": "2024-12-05T15:38:25.992674",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7270,
      "client_name": "JUAN ANTONIO ESPINOZA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Polvorin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243468366",
      "client_email": "JUANANTONIOJA5827800@GMAIL.COM",
      "address": "CALLE EL RINCON CASA NRO 19 SECTOR PARAGUATAN TURMERO EDO ARAGUA ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V14389203",
      "nap_box_name": "CE - 924",
      "created_at": "2024-12-05T15:32:58.475741",
      "service_detail": {
        "id": 7344,
        "ip": "10.11.163.2",
        "mac": "HWTC47310523",
        "serial": "HWTC47310523",
        "queue": "queue1",
        "interface": "VLAN283_PARAGUATAN",
        "created_at": "2024-12-05T15:42:24.484892",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7271,
      "client_name": "JHON ERICK CORRO BRICEÑO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Polvorin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243614884",
      "client_email": "JHONCORRO46@GMAIL.COM",
      "address": "POLVORIN CALLE PRINCIPAL VIA AL RIO CASA NRO 39 ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V13200879",
      "nap_box_name": "CTO - 1001",
      "created_at": "2024-12-05T15:39:29.234289",
      "service_detail": {
        "id": 7347,
        "ip": "10.11.166.2",
        "mac": "HWTC48080312",
        "serial": "HWTC48080312",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN280_POLVORIN",
        "created_at": "2024-12-05T16:02:46.691202",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7272,
      "client_name": "JUAN MANUEL CORRO QUINTERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "1ro de Mayo Norte",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04123019708",
      "client_email": "JUANMANUELCORRO318@GMAIL.COM",
      "address": "PRIMERO DE MAYO NORTE CALLE MARA CASA NRO 1 ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V30026595",
      "nap_box_name": "CTO - 906",
      "created_at": "2024-12-05T15:50:52.133967",
      "service_detail": {
        "id": 7386,
        "ip": "10.11.196.2",
        "mac": "HWTC48080313",
        "serial": "HWTC48080313",
        "queue": "Plan_161900_30183_WispHub",
        "interface": "VLAN261_1ERO_MAYO_ZTE",
        "created_at": "2024-12-10T10:34:49.145865",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7273,
      "client_name": "JHON RAFAEL CRISTOBAL CONTRERAS LOVERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Bosque",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128991092",
      "client_email": "JHONCONTRERAS346@GMAIL.COM",
      "address": "SECTOR EL BOSQUE C/LUISA CACERES DE ARISMENDI CASA S/N",
      "client_identification": "V19628849",
      "nap_box_name": "CTO-00290",
      "created_at": "2024-12-05T16:05:27.519967",
      "service_detail": {
        "id": 7387,
        "ip": "10.11.197.2",
        "mac": "HWTC48080013",
        "serial": "HWTC48080013",
        "queue": "Plan_161900_30183_WispHub",
        "interface": "VLAN266_EL_BOSQUE_ZTE",
        "created_at": "2024-12-10T10:44:37.958469",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7274,
      "client_name": "JONNY RIVIER SAAVEDRA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Los Hornos",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124421736",
      "client_email": "YONNYSAAVEDRA69@GMAIL.COM",
      "address": "CALLE 8 CASA NRO 31 SECTOR LOS HORNOS ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V16733808",
      "nap_box_name": "CTO-00288",
      "created_at": "2024-12-05T16:18:07.149431",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7276,
      "client_name": "CESAR ENRIQUE LINARES URBINA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Brisas de Paya",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144514915",
      "client_email": "LINARES-SEGUROS@HOTMAIL.COM",
      "address": "URB. BRISAS DE PAYA CALLE 7 NRO. 06",
      "client_identification": "V16099609",
      "nap_box_name": "CTO-00117",
      "created_at": "2024-12-05T16:48:54.946586",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7277,
      "client_name": "KATHERINE DEL AMPARO PAEZ HERNANDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados I",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243060029",
      "client_email": "LUISBE.KAIRY@GMAIL.COM",
      "address": "SECTOR PRADOS 1 CALLE 9 CASA NRO 15 ROSARIO DE PAYA ARAGUA ZONA PÒSTAL 2115",
      "client_identification": "V18612494",
      "nap_box_name": "CTO-00162",
      "created_at": "2024-12-05T17:25:14.222498",
      "service_detail": {
        "id": 7459,
        "ip": "10.11.217.2",
        "mac": "A8BF3C624479",
        "serial": "OEMT3C62447A",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN239_PRADOS1",
        "created_at": "2024-12-17T07:49:35.443170",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7278,
      "client_name": "YARGELIS JOSEFINA CHOURIO BETANCOURT",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados III",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243221876",
      "client_email": "CHOURIOYARGELYS@GMAIL.COM",
      "address": "CALLE 2 CASA NRO 32 SECTOR PRADOS III ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V26095694",
      "nap_box_name": "CTO-00205",
      "created_at": "2024-12-05T17:33:43.859436",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7279,
      "client_name": "LEANDRO JOSE PEREZ CASTILLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04145987923",
      "client_email": "LEANDROJPEREZC532@GMAIL.COM",
      "address": "CALLE 23 CASA NRO 13 SECTOR RIO SECO ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V27048669",
      "nap_box_name": "602",
      "created_at": "2024-12-05T17:44:56.635234",
      "service_detail": {
        "id": 7417,
        "ip": "10.11.215.2",
        "mac": "A8BF3C624565",
        "serial": "OEMT3C624566",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN251_RIO_SECO",
        "created_at": "2024-12-11T14:24:09.490842",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7280,
      "client_name": "YERALDIN CAROLINA MEJIAS RANGEL",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Palma Real",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243974448",
      "client_email": "YERAMEJIAS@GMAIL.COM",
      "address": "URB PALMA REAL CALLE 4 CASA NRO 3 ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V18175274",
      "nap_box_name": "CTO-00391",
      "created_at": "2024-12-05T17:52:46.099431",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7281,
      "client_name": "JESUS ALBERTO DANELLO BRUCE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vallecito",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128923440",
      "client_email": "JADBYOSP_27@HOTMAIL.COM",
      "address": "ROSARIO DE PAYA SECTOR VALLECITO CALLE LAS PALMAS CASA #32",
      "client_identification": "V18975193",
      "nap_box_name": "CTO-00074",
      "created_at": "2024-12-06T10:11:07.490840",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7282,
      "client_name": "YUSENKI MAYERLIN MEDINA LUBO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Payita",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243820766",
      "client_email": "LUISOSCARRODRIGUEZ570@GMAIL.COM",
      "address": "CALLE PRNCIPAL PAYITA CASA 50-A",
      "client_identification": "V16876851",
      "nap_box_name": "CTO - 1028",
      "created_at": "2024-12-06T11:53:48.582079",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7283,
      "client_name": "GUZMAN ENRIQUE ACOSTA BARRIOS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128952422",
      "client_email": "GUZMANENRIQUEACOSTA@GMAIL.COM",
      "address": "CALLE BOLIVAR RESIDENCIAS LOS NISPEROS TORRE A PISO 7 APT.77",
      "client_identification": "V8585769",
      "nap_box_name": "TORRE A EDIF LOS NISPEROS",
      "created_at": "2024-12-06T13:38:02.177891",
      "service_detail": {
        "id": 7438,
        "ip": "10.11.219.2",
        "mac": "A8BF3C624515",
        "serial": "OEMT3C624516",
        "queue": "Plan_92194_15811_WispHub",
        "interface": "VLAN272_EDIF_NISPEROS_OLT3",
        "created_at": "2024-12-14T10:17:27.123092",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7284,
      "client_name": "HILDA JAMILET SALAZAR BELTRAN",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144532645",
      "client_email": "JAMIHIL65@GMAIL.COM",
      "address": "LA CASONA II CALLE 8 CASA #6",
      "client_identification": "V9436001",
      "nap_box_name": "CTO-00086",
      "created_at": "2024-12-06T13:51:47.331541",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7285,
      "client_name": "SANTIAGO ALBERTO CASTRO SALAZAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Marcelota",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243387850",
      "client_email": "SANTIAGOCASTROYLOSMOROCHOS920@GMAIL.COM",
      "address": "LA MARCELOTA CALLE PRINCIPAL CASA NRO 41 LA BOMBA",
      "client_identification": "V28317429",
      "nap_box_name": "CTO - 1060",
      "created_at": "2024-12-06T15:14:42.600361",
      "service_detail": {
        "id": 12155,
        "ip": "10.11.192.2",
        "mac": "HWTC240FD090",
        "serial": "HWTC240FD090",
        "queue": null,
        "interface": "VLAN281_MARCELOTA",
        "created_at": "2026-03-22T12:53:07.116474",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7286,
      "client_name": "EUDES JESUS RENGIFO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04145901550",
      "client_email": "BUBALUR1337@GMAIL.COM",
      "address": "HACIENDA EL NISPERO EZEQUIEL ZAMORA EDIFICIO 29 PISO 1-A",
      "client_identification": "V12608794",
      "nap_box_name": "CTO-00207 DOS",
      "created_at": "2024-12-06T15:32:28.467958",
      "service_detail": {
        "id": 7423,
        "ip": "10.11.221.2",
        "mac": "A8BF3C6244A9",
        "serial": "OEMT3C6244AA",
        "queue": "Plan_127996_15811_WispHub",
        "interface": "VLAN209_ZAMORA_OLT1",
        "created_at": "2024-12-11T15:08:29.434103",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7287,
      "client_name": "YESENIA YELISBETH LANDAETA NIEVES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vallecito",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243729969",
      "client_email": "YESENIALANDAETA353@GMAIL.COM",
      "address": "CALLE LAS PALMAS CASA NRO 40 SECTOR VALLECITO  PAYA",
      "client_identification": "V25620920",
      "nap_box_name": "CTO-00082",
      "created_at": "2024-12-06T16:26:29.320025",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7288,
      "client_name": "LOURDES DEL ROSARIO MARTINEZ DE COLMENARES",
      "client_type_name": "GRATIS",
      "client_subdivision": "ACTIVO_GRATIS",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": false,
      "sector_name": "Valle lindo",
      "plan": {
        "id": 86,
        "name": "PLAN RECURRENTE 80M GRATIS",
        "cost": "0.00",
        "code": "FO-G80",
        "profile": "80M/80M"
      },
      "client_mobile": "04144631515",
      "client_email": "RUFAMARTINEZ24@GMAIL.COM",
      "address": "SECTOR 3 CALLE 1 CASA N° 1 URBANIZACIÓN VALLE LINDO",
      "client_identification": "V4271145",
      "nap_box_name": "CTO - 1010",
      "created_at": "2024-12-08T19:04:12.526890",
      "service_detail": {
        "id": 12385,
        "ip": "172.19.113.2",
        "mac": "HWTC48080321",
        "serial": "HWTC48080321",
        "queue": null,
        "interface": "VLAN274_VALLELINDO",
        "created_at": "2026-04-21T09:35:30.270411",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7289,
      "client_name": "ANTONIO JOSE PARRA AGUIRRE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Valle Verde",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144652610",
      "client_email": "GLISBERSORIA77@GMAIL.COM",
      "address": "CALLEJON LOS MAMONES CASA NRO 6-7 SECTOR VALLE VERDE ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V16099544",
      "nap_box_name": "CTO-00187",
      "created_at": "2024-12-09T12:45:12.115494",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7290,
      "client_name": "LEIVIS JOSEFINA HERNANDEZ HIDALGO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Paraguatan",
      "plan": {
        "id": 101,
        "name": "RECURRENTE RESIDENCIAL PLAN 200M",
        "cost": "19.00",
        "code": "FOR200MB",
        "profile": "200Mbps/200Mbps"
      },
      "client_mobile": "04243693227",
      "client_email": "HIDALGOLEIVIS523@GMAIL.COM",
      "address": "CALLE PRINCIPAL CASA NRO 1 SECTOR PARAGUATAN EL RINCON GUAYABITA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V14183740",
      "nap_box_name": "CTO - 1118",
      "created_at": "2024-12-09T13:16:12.154709",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7291,
      "client_name": "YENNI CAROLINA FLORES PEROZO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144949479",
      "client_email": "YTELIS35@GMAIL.COM",
      "address": "URB. MATA CABALLO C/8 NRO. 577C",
      "client_identification": "V16435224",
      "nap_box_name": "CTO-00130",
      "created_at": "2024-12-09T13:38:04.416078",
      "service_detail": {
        "id": 10313,
        "ip": "10.11.223.2",
        "mac": "OEMT3C6249C2",
        "serial": "OEMT3C6249C2",
        "queue": null,
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2025-11-24T17:51:47.025544",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7292,
      "client_name": "DULCE KARINA MUNEZ ORELLANA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Luz y Vida",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243537699",
      "client_email": "KARINANUNEZORELLANA@GMAIL.COM",
      "address": "LUZ Y VIDA CALLE 3 CASA NRO 167 ROSARIO DE PAYA",
      "client_identification": "V18608636",
      "nap_box_name": "CTO-00308",
      "created_at": "2024-12-09T15:40:36.483858",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7293,
      "client_name": "RICHARD IVAN GUTIERREZ ZAMBRANO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04247742038",
      "client_email": "GUTIERREZRICHARD.AUTOBUS03@GMAIL.COM",
      "address": "VDA 27 CASA NRO 27-A SECTOR RIO SECO ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V10548073",
      "nap_box_name": "468",
      "created_at": "2024-12-10T08:48:43.406915",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7294,
      "client_name": "SATURNINA YUBISNARDA MARQUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04125207783",
      "client_email": "YUDIT8938@GMAIL.COM",
      "address": "CALLE 21 CASA NRO 37 SECTOR RIO SECO TURMERO EDO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V6933525",
      "nap_box_name": "CTO-00276",
      "created_at": "2024-12-10T08:59:48.453761",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7295,
      "client_name": "CARLOS ALBERTO SORIA ROCHE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243434724",
      "client_email": "CARLITOSORIA@GMAIL.COM",
      "address": "CALLE 05 CASA NRO 37 SECTOR RIO SECO ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V25841149",
      "nap_box_name": "611",
      "created_at": "2024-12-10T09:12:32.748172",
      "service_detail": {
        "id": 12951,
        "ip": "10.10.48.2",
        "mac": "HW:TC:49:20:01:33",
        "serial": "HWTC49200133",
        "queue": null,
        "interface": "VLAN251_RIO_SECO",
        "created_at": "2026-09-02T10:33:38.019756",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7296,
      "client_name": "RICARDO SUAREZ JIMENEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Simon Bolivar",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04125130822",
      "client_email": "RICARDO010390@GMAIL.COM",
      "address": "CALLE 6 CASA NRO 22 URB SIMON BOLIVAR EL MACARO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V9641374",
      "nap_box_name": "CTO - 1075",
      "created_at": "2024-12-10T09:31:35.915989",
      "service_detail": {
        "id": 7404,
        "ip": "10.10.49.2",
        "mac": "HWTC46C06307",
        "serial": "HWTC46C06307",
        "queue": "Plan_137413_1574_WispHub",
        "interface": "VLAN128_SIMON_BOLIVAR_ZTE",
        "created_at": "2024-12-11T12:42:31.748647",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7297,
      "client_name": "YENIFER VICTORIA MONTIEL TIRRE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243227852",
      "client_email": "YENIFERMONTIEL927@GMAIL.COM",
      "address": "CALLE ESPINAL, 35-A SECTOR LA ARBOLEDA RIO SECO ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V25527118",
      "nap_box_name": "CTO-00385",
      "created_at": "2024-12-10T09:54:03.958969",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7298,
      "client_name": "MERCEDES CAROLINA CARABALLO IZQUIER",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Taguapire",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124758530",
      "client_email": "MERCEDESCARABALLO038@GMAIL.COM",
      "address": "URB TAGUAPIRE CALLE 3 NIVEL PB APT 84 SECTOR EL MACARO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V9888766",
      "nap_box_name": "549 DOS",
      "created_at": "2024-12-10T10:14:22.963819",
      "service_detail": {
        "id": 10563,
        "ip": "10.10.52.2",
        "mac": "HWTC46C06267",
        "serial": "HWTC46C06267",
        "queue": null,
        "interface": "VLAN129_TAGUAPIRE_ZTE",
        "created_at": "2025-12-03T16:28:33.842337",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7299,
      "client_name": "LILIANA DEL CARMEN GUERRERO CEGARRA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Palma Real",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04123985975",
      "client_email": "LILIANAGUERR94@GMAIL.COM",
      "address": "CALLE PRINCIPAL MANZANA 3 CASA NRO 12 URB PALMA REAL TURMERO EDO ARAGUA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V9679756",
      "nap_box_name": "CTO-00391",
      "created_at": "2024-12-10T10:45:39.937395",
      "service_detail": {
        "id": 7427,
        "ip": "10.11.225.2",
        "mac": "A8BF3C625261",
        "serial": "OEMT3C625262",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN244_PALMAREAL",
        "created_at": "2024-12-11T15:54:34.983637",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7300,
      "client_name": "JOHANDER ALEXIS DUARTE VILLAMIZAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Las Rurales",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04122075367",
      "client_email": "JOHANDERALEXIS@GMAIL.COM",
      "address": "CALLE SUCRE CASA NRO.03 BARRIO LAS RURALES. ROSARIO DE PAYA ARAGUA  ZONA POSTAL 2115",
      "client_identification": "V27286901",
      "nap_box_name": "CE-00080",
      "created_at": "2024-12-10T14:25:56.967472",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7301,
      "client_name": "JUAN CARLOS BRICENO MORENO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Canaima",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04228158805",
      "client_email": "JUANCARLOSBRICENOMORENO@GMAIL.COM",
      "address": "SECTOR CANAIMA CALLE 2 CASA NRO 30 ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V15130277",
      "nap_box_name": "CTO-00107 ",
      "created_at": "2024-12-10T16:30:03.680576",
      "service_detail": {
        "id": 7407,
        "ip": "10.10.53.2",
        "mac": "HWTC47310534",
        "serial": "HWTC47310534",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN237_CANAIMA",
        "created_at": "2024-12-11T12:56:40.399606",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7302,
      "client_name": "CARLOS ALFREDO CARRERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Naranjal",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128675650",
      "client_email": "CARLOSCARRERO2702@GMAIL.COM",
      "address": "CALLE MIRADOR CASA NRO 7 SECTOR EL NARANJAL ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V20077852",
      "nap_box_name": "596",
      "created_at": "2024-12-10T16:39:28.348255",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7303,
      "client_name": "FREDDY EMILIO OROPEZA REYES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Paraguatan",
      "plan": {
        "id": 43,
        "name": "RECURRENTE RESIDENCIAL PLAN 650M",
        "cost": "46.00",
        "code": "FOR650M",
        "profile": "650M/650M"
      },
      "client_mobile": "04160305096",
      "client_email": "OROPEZAREYESFREDDYEMILIO@GMAIL.COM",
      "address": "CALLE ESCALONA CASA NRO 1 SECTOR PARAGUATAN GUAYABITA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V9432250",
      "nap_box_name": "CTO-00397",
      "created_at": "2024-12-11T08:50:39.555169",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7304,
      "client_name": "MARIBEL MARGARITA CARMONA TOVAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243758172",
      "client_email": "LUZMARYTOVAR2005@GMAIL.COM",
      "address": "CALLE 21 CASA NRO 04 SECTOR RIO SECO TURMERO EDO. ARAGUA ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V9438054",
      "nap_box_name": "603",
      "created_at": "2024-12-11T10:38:22.537186",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7305,
      "client_name": "YOKSELIN KARINA VASQUEZ REYES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Guayabita",
      "plan": {
        "id": 101,
        "name": "RECURRENTE RESIDENCIAL PLAN 200M",
        "cost": "19.00",
        "code": "FOR200MB",
        "profile": "200Mbps/200Mbps"
      },
      "client_mobile": "04122051569",
      "client_email": "YURVIN1984@GMAIL.COM",
      "address": "CALLE ESCALONA CASA NRO 14-1 SECTOR LOS REYES PARAGUATAN  TURMERO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V18780086",
      "nap_box_name": "CTO - 1123",
      "created_at": "2024-12-11T12:45:35.296031",
      "service_detail": {
        "id": 11619,
        "ip": "10.10.59.2",
        "mac": "OEMT3C624D66",
        "serial": "OEMT3C624D66",
        "queue": null,
        "interface": "VLAN283_PARAGUATAN",
        "created_at": "2026-02-15T10:30:51.338461",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7306,
      "client_name": "ROSBEL DEL VALLE JIMENEZ MORA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243544779",
      "client_email": "ROSBELJIMENEZ659@GMAIL.COM",
      "address": "CALLE 7 CASA NRO 553-C URB MATA CABALLO ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V16692779",
      "nap_box_name": "CTO-00310",
      "created_at": "2024-12-13T08:18:40.095975",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7307,
      "client_name": "YOSEANNELIE ARIANA ZAMBRANO MORILLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04123464398",
      "client_email": "YOSEANNELIEZAMBRANO@GMAIL.COM",
      "address": "CALLE CALLEJON MERIDA CASA NRO 5 SECTOR LOS MANGOS ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V31056079",
      "nap_box_name": "CE-00080",
      "created_at": "2024-12-13T08:38:49.272921",
      "service_detail": {
        "id": 7527,
        "ip": "10.10.63.2",
        "mac": "OEMT3C624592",
        "serial": "OEMT3C624592",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN267_LOS_MANGOS_ZTE",
        "created_at": "2024-12-17T15:18:23.480539",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7308,
      "client_name": "JOSE JAIME DE LOS SANTOS DELGADO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "1ro de Mayo Sur",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04122052960",
      "client_email": "JJTHESAINTDAMARIS15212019@GMAIL.COM",
      "address": "CALLE LA PAZ CASA NRO 4 SECTOR PRIMERO DE MAYO SUR ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V9649699",
      "nap_box_name": "CTO-00149",
      "created_at": "2024-12-13T09:05:11.061509",
      "service_detail": {
        "id": 10652,
        "ip": "10.10.55.2",
        "mac": "80D4A5A303A0",
        "serial": "HWTC48220058",
        "queue": null,
        "interface": "VLAN261_1ERO_MAYO_ZTE",
        "created_at": "2025-12-10T19:53:00.016325",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7309,
      "client_name": "CRISTINA LIZMAR GUEVARA SALAZAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Valle Fresco",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243045550",
      "client_email": "CRISTIGUEVARA159@HOTMAIL.COM",
      "address": "CALLE MANZANA 19 CASA NRO 16 URB VALLE FRESCO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V27646786",
      "nap_box_name": "CTO - 1105",
      "created_at": "2024-12-13T09:14:01.792476",
      "service_detail": {
        "id": 12372,
        "ip": "10.10.68.2",
        "mac": "OEMT3C6254B6",
        "serial": "OEMT3C6254B6",
        "queue": null,
        "interface": "VLAN270_VALLE_FRESCO_OLT3",
        "created_at": "2026-04-20T11:38:02.236784",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7310,
      "client_name": "AURELIO NICANOR HAYA AJA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Polvorin",
      "plan": {
        "id": 97,
        "name": "RECURRENTE RESIDENCIAL PLAN 10M",
        "cost": "18.00",
        "code": "[FOR10]",
        "profile": "10Mbps/10Mbps"
      },
      "client_mobile": "04144624848",
      "client_email": "VICTORJOSESANCHEZ1956@GMAIL.COM",
      "address": "CALLE MARIÑO CASA NRO 12 SECTOR CENTRO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V8576800",
      "nap_box_name": "CTO - 988",
      "created_at": "2024-12-13T09:23:57.745849",
      "service_detail": {
        "id": 7441,
        "ip": "10.10.56.2",
        "mac": "80D4A5A1DC50",
        "serial": "HWTC48080301",
        "queue": "Plan_157777_30183_WispHub",
        "interface": "VLAN280_POLVORIN",
        "created_at": "2024-12-15T17:46:41.772044",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7311,
      "client_name": "MEURY BRENNY RIVERO RICO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243293132",
      "client_email": "ALEXME2082@GMAIL.COM",
      "address": "CALLE 9 CASA NRO 588-D URB MATA CABALLO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V16338800",
      "nap_box_name": "CE - 566",
      "created_at": "2024-12-13T12:34:10.363071",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7312,
      "client_name": "LUZ MARBELIA DA ROCHA ACOSTA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Callejon Los Jabillos",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243279116",
      "client_email": "MARBELIADAROCHA434@GMAIL.COM",
      "address": "C/LOS JABILLOS CASA NRO. 1-10 SECTOR ANTIGUA HACIENDA PAYA ROSARIO DE PAYA ZONA POSTAL 2115",
      "client_identification": "V9434208",
      "nap_box_name": "99",
      "created_at": "2024-12-13T13:41:10.471359",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7314,
      "client_name": "FELIPE ANTONIO GIMENEZ SEQUERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Durpa",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243143526",
      "client_email": "FELOGIM@GMAIL.COM",
      "address": "CALLE  LA COLINA CASA NRO 03 ROSARIO DE PAYA DURPA",
      "client_identification": "V7367084",
      "nap_box_name": "352",
      "created_at": "2024-12-16T12:39:40.105185",
      "service_detail": {
        "id": 12653,
        "ip": "10.10.58.2",
        "mac": "HW:TC:48:08:00:20",
        "serial": "HWTC48080020",
        "queue": null,
        "interface": "VLAN240_DURPA",
        "created_at": "2026-07-02T10:56:36.872770",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7315,
      "client_name": "ALBERTA FIDENCIA GOMEZ DE MARIN",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243033365",
      "client_email": "FIDELINAGOMEZ751@GMAIL.COM",
      "address": "URB. HACIENDA PANTIN CALLE 18B CASA 56",
      "client_identification": "V4974139",
      "nap_box_name": "CTO-00435",
      "created_at": "2024-12-16T13:47:37.106854",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7316,
      "client_name": "YULITZA DEL CARMEN VALLERA QUINTERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04123986506",
      "client_email": "YULITZAVALLERA41@GMAIL.COM",
      "address": "RIO SECO CALLE 23 NRO. 06 ROSARIO DE PAYA . TURMERO ZONA POSTAL 2115",
      "client_identification": "V25066754",
      "nap_box_name": "602",
      "created_at": "2024-12-16T14:13:45.739516",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7317,
      "client_name": "GABRIELA SARAY LINARES YROBA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Palmeras II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04123865467",
      "client_email": "JAIDELISRR@GMAIL.COM",
      "address": "PALMERAS II CALLE 8 CASA NRO 122 SAMAN DE GUERE  TURMERO ZONA POSTAL 2115",
      "client_identification": "V26717340",
      "nap_box_name": "287",
      "created_at": "2024-12-16T14:19:55.185703",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7318,
      "client_name": "AUSENCIO HUMBERTO LUIS PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Polvorin",
      "plan": {
        "id": 97,
        "name": "RECURRENTE RESIDENCIAL PLAN 10M",
        "cost": "18.00",
        "code": "[FOR10]",
        "profile": "10Mbps/10Mbps"
      },
      "client_mobile": "04244026696",
      "client_email": "AHLUISPEREZ994@GMAIL.COM",
      "address": "CALLE PRINCIPAL NRO.13 POLVORIN. TURMERO ZONA POSTAL 2115",
      "client_identification": "V3518323",
      "nap_box_name": "CTO - 988",
      "created_at": "2024-12-16T14:20:14.278789",
      "service_detail": {
        "id": 7462,
        "ip": "10.10.60.2",
        "mac": "HWTC48080024",
        "serial": "HWTC48080024",
        "queue": "Plan_161864_30181_WispHub",
        "interface": "VLAN280_POLVORIN",
        "created_at": "2024-12-17T09:36:42.641904",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7319,
      "client_name": "REYMING ESTEBAN MACHADO MARTINEZ",
      "client_type_name": "EMPLEADO",
      "client_subdivision": "CANCELADO_EMPLEADO",
      "status_name": "Cancelado",
      "cycle": 10,
      "migrate": false,
      "sector_name": "Palmeras II",
      "plan": {
        "id": 78,
        "name": "Plan empleado 80MB",
        "cost": "0.00",
        "code": "FO-80M",
        "profile": "80M/80M"
      },
      "client_mobile": "04265305151",
      "client_email": "REYDPET@GMAIL.COM",
      "address": "CALLE 2 CASA # 61 URBANIZACION EL NISPERO TURMERO ESTADO ARAGUA",
      "client_identification": "V20336303",
      "nap_box_name": "287",
      "created_at": "2024-12-16T14:58:43.447974",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7320,
      "client_name": "ELIANI JACKELINE LOPEZ MORALES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Palma Real",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04224438106",
      "client_email": "ELIANIJACKELINELOPEZMORALES@GMAIL.COM",
      "address": "PARCELAMIENTO 6 CALLE  LOS MANGOS CASA 51",
      "client_identification": "V23200672",
      "nap_box_name": "CE - 535",
      "created_at": "2024-12-16T15:38:48.962723",
      "service_detail": {
        "id": 7540,
        "ip": "10.10.75.2",
        "mac": "OEMT3C62499A",
        "serial": "OEMT3C62499A",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN244_PALMAREAL",
        "created_at": "2024-12-17T16:16:05.877414",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7321,
      "client_name": "JULIO RAFAEL LEONES SILVA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Durpa",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121397644",
      "client_email": "LEONESJ1981@GMAIL.COM",
      "address": "CALLE SIMON RODRIGUEZ CASA NRO 13 SECTOR FUNDABARRIO",
      "client_identification": "V14664235",
      "nap_box_name": "CTO-00453",
      "created_at": "2024-12-16T16:01:19.176649",
      "service_detail": {
        "id": 7454,
        "ip": "172.17.217.2",
        "mac": "VSOL00498531",
        "serial": "VSOL00498531",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN240_DURPA",
        "created_at": "2024-12-16T16:16:16.111514",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7323,
      "client_name": "JHON WILSON BETANCOURT TOLEDO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243232757",
      "client_email": "JHON_WIL_B@HOTMAIL.COM",
      "address": "CALLE SANTA EDUVIGES CASA NRO 39 URB VILLA MARIA TURMERO ARAGUA ZONA POSTAL 2107",
      "client_identification": "V20452616",
      "nap_box_name": "TORRE A EDIF LOS NISPEROS",
      "created_at": "2024-12-16T17:19:03.433428",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7324,
      "client_name": "MARIA ARGELYS CARRILLO MECIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124850062",
      "client_email": "MECIAARGELYS@GMAIL.COM",
      "address": "SECTOR MATA CABALLO, CALLE 1 CASA NRO 34 ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V27646160",
      "nap_box_name": "455",
      "created_at": "2024-12-16T17:26:28.208032",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7325,
      "client_name": "YORMAN JOHAN MOSQUEDA FAJARDO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243803444",
      "client_email": "YORMANJMOSQUEDAF@GMAIL.COM",
      "address": "C/AV. 2 CASA NRO. 53D URB. MATA CABALLO",
      "client_identification": "V14665474",
      "nap_box_name": "CTO-00222",
      "created_at": "2024-12-17T09:54:21.091746",
      "service_detail": {
        "id": 10910,
        "ip": "10.10.81.2",
        "mac": "OEMT3C62499E",
        "serial": "OEMT3C62499E",
        "queue": null,
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2025-12-23T13:17:49.383836",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7326,
      "client_name": "HENRY GARCIA JARAMILLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04247617542",
      "client_email": "JEHOYNER@GMAIL.COM",
      "address": "LOS NUEVOS NISPEROS TORRE 9 PISO 2 APTO 3",
      "client_identification": "V12929447",
      "nap_box_name": "CTO-00387",
      "created_at": "2024-12-17T11:47:12.149042",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7327,
      "client_name": "LAURIANA YERALDINE OJEDA CENTENO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Callejon Lim",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243030972",
      "client_email": "LAURIANA19516134@GMAIL.COM",
      "address": "CALLE PRINCIPAL EDIF ASUNCENA PISO 3 APTO 15 URB. VILLAS DE TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V19516134",
      "nap_box_name": "TORRE AZUCENA",
      "created_at": "2024-12-17T14:13:22.143246",
      "service_detail": {
        "id": 11091,
        "ip": "10.10.84.2",
        "mac": "OEMT3C6245EA",
        "serial": "OEMT3C6245EA",
        "queue": null,
        "interface": "VLAN250_LIM_OLT2",
        "created_at": "2026-01-11T14:12:45.001268",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7328,
      "client_name": "WILMAR  YECENIA PALACIOS ARENA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Las Rurales",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04127989397",
      "client_email": "WILMARPALACIOS75@GMAIL.COM",
      "address": "LAS RURALES CALLE 103 CASA # 44-1 SECTOR LAS RURALES DE PAYA ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V11687064",
      "nap_box_name": "CTO-0613",
      "created_at": "2024-12-17T14:36:10.918852",
      "service_detail": {
        "id": 12520,
        "ip": "10.10.80.2",
        "mac": "80:d4:a5:a1:aa:f1",
        "serial": "HWTC47310531",
        "queue": null,
        "interface": "VLAN252_RURALES_PAYA",
        "created_at": "2026-05-17T19:08:31.204119",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7329,
      "client_name": "ESTEFANI DANIELA FERNANDEZ  POVEDA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Guzman",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243177290",
      "client_email": "DAYANAF630@GMAIL.COM",
      "address": "CALLE SANTA ANA CASA NRO 06 SECTOR GUAYABITA",
      "client_identification": "V26336166",
      "nap_box_name": "CTO-00407",
      "created_at": "2024-12-17T14:40:23.265249",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7330,
      "client_name": "JACKSON ANDRES GONZALEZ AVENDAÑO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04244636854",
      "client_email": "AVENDANO7406@GMAIL.COM",
      "address": "LOS NISPEROS EDIF. TORRE A PISO 7 APT  74",
      "client_identification": "V11939694",
      "nap_box_name": "TORRE A EDIF LOS NISPEROS",
      "created_at": "2024-12-17T14:50:11.736641",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7331,
      "client_name": "BARBARA YAQUELIN AREVALO FARFAN",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04228158786",
      "client_email": "KIMBARBY13KV@GMAIL.COM",
      "address": "SAMAN TARAZONERO I CALLE 9 NRO.21 EL MACARO , TURMERO ZONA POSTAL 2115",
      "client_identification": "V30406407",
      "nap_box_name": "671",
      "created_at": "2024-12-17T15:26:10.369633",
      "service_detail": {
        "id": 11876,
        "ip": "10.10.79.2",
        "mac": "OEMT3C62498E",
        "serial": "OEMT3C62498E",
        "queue": null,
        "interface": "VLAN140_SMT1_ZTE",
        "created_at": "2026-03-01T11:59:58.300005",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7332,
      "client_name": "CHRISTIAN NAILIBETH MAIRUVITH RAIVELKS CASTILLO PARRA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Pantin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128151539",
      "client_email": "JOSERVELIK@GMAIL.COM",
      "address": "URB. HACIENDA PANTIN CA10B NRO. 47",
      "client_identification": "V25973912",
      "nap_box_name": "CTO-00141",
      "created_at": "2024-12-17T15:40:14.742571",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7333,
      "client_name": "ANGEL GABRIEL ALVARES SIVIRA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121987765",
      "client_email": "ALVARESSIVIRAANGEL@GMAIL.COM",
      "address": "AVENIDA 02 CASA NRO 517 SECTOR MATA CABALLO ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V30555764",
      "nap_box_name": "CTO-00073",
      "created_at": "2024-12-17T15:55:58.302442",
      "service_detail": {
        "id": 10805,
        "ip": "10.10.76.2",
        "mac": "OEMT3C6248BA",
        "serial": "OEMT3C6248BA",
        "queue": null,
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2025-12-18T12:13:48.317861",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7334,
      "client_name": "TERESA DE JESUS SEQUERA MENDOZA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Las Rurales",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04123986939",
      "client_email": "TERE.REICITO2610@GMAIL.COM",
      "address": "CALLE BOLIVAR CASA NRO.76 SECTOR LAS RURALES ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V12167590",
      "nap_box_name": "492",
      "created_at": "2024-12-17T15:57:21.791565",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7335,
      "client_name": "GENESIS ANDREINA GARCIA MURGUEZA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243325633",
      "client_email": "ANDREINAMACHADO25067@GMAIL.COM",
      "address": "CALLE 7 NRO 535-B URB MATA CABALLO PEDRO AREVALO APONTE",
      "client_identification": "V25067225",
      "nap_box_name": "CTO-00310",
      "created_at": "2024-12-17T16:28:27.356078",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7336,
      "client_name": "SILOET MARIA TOVAR PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "1ro de Mayo Norte",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04145891612",
      "client_email": "MT7196295@GMAIL.COM",
      "address": "INTERCOMUNAL SECTOR SIMON BOLIVAR CASA NRO. 24 1ERO DE MAYO NORTE PAYA",
      "client_identification": "V12036670",
      "nap_box_name": "CTO-00538",
      "created_at": "2024-12-17T16:31:21.996050",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7337,
      "client_name": "YELISMAR DEL VALLE VIRGUEZ MELENDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243662695",
      "client_email": "JUNIORJOSETOVARROJAS41@GMAIL.COM",
      "address": "CALLE 07 CASA NRO 11 SECTOR RIO SECO ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V26935807",
      "nap_box_name": "CTO-00408",
      "created_at": "2024-12-17T16:43:25.948991",
      "service_detail": {
        "id": 12063,
        "ip": "10.10.86.2",
        "mac": "HWTC45A04487",
        "serial": "HWTC45A04487",
        "queue": null,
        "interface": "VLAN251_RIO_SECO",
        "created_at": "2026-03-14T19:39:53.077776",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7338,
      "client_name": "MOISES ALEJANDRO GONZALEZ NAVAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128988527",
      "client_email": "MOISESG0701@GMAIL.COM",
      "address": "URB. MATA CABALLO CALLE 8 CASA 581-B",
      "client_identification": "V31616362",
      "nap_box_name": "CTO-00130",
      "created_at": "2024-12-17T16:55:08.489312",
      "service_detail": {
        "id": 12588,
        "ip": "10.10.87.2",
        "mac": "OE:MT:3C:62:4A:B6",
        "serial": "OEMT3C624AB6",
        "queue": null,
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2026-06-06T11:39:20.413319",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7339,
      "client_name": "JOSE DIONICIO RIVAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04164273982",
      "client_email": "JR.DIONICIO12@GMAIL.COM",
      "address": "ROSARIO DE PAYA, LA ARBOLERA CALLE EL ESPIRAL CASA #24",
      "client_identification": "V9170375",
      "nap_box_name": "CE - 772",
      "created_at": "2024-12-17T17:16:29.470788",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7340,
      "client_name": "YESENIA MARGARITA HERRERA LOPEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Paraguatan",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04124422583",
      "client_email": "LA_FLACA0308@HOTMAIL.COM",
      "address": "SECTOR PARAGUATAN CALLE ESCALONA CASA NRO 11 ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V18854329",
      "nap_box_name": "CTO - 1123",
      "created_at": "2024-12-18T08:36:58.483058",
      "service_detail": {
        "id": 7566,
        "ip": "10.10.90.2",
        "mac": "OEMT3C6248AE",
        "serial": "OEMT3C6248AE",
        "queue": "Plan_161900_30183_WispHub",
        "interface": "VLAN283_PARAGUATAN",
        "created_at": "2024-12-18T09:34:47.535736",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7341,
      "client_name": "ANAIS ANDREINA EUGENIO SANCHEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "El Naranjal",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04128900438",
      "client_email": "ANAISEUGENIO5@GMAIL.COM",
      "address": "SECTOR EL NARANJAL CALLE LIBERTAD CASA NRO 30 ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V22954637",
      "nap_box_name": "CE - 681",
      "created_at": "2024-12-18T09:06:07.096905",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7342,
      "client_name": "DEILY YSMENIA MEDINA LINARES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243223231",
      "client_email": "DEILYMEDINA23@GMAIL.COM",
      "address": "CALLE 4 CASA NRO 17 SECTOR PRADOS DE PAYA II TURMERO EDO. ARAGUA ZONA POSTAL 2115",
      "client_identification": "V10752020",
      "nap_box_name": "CTO-00100",
      "created_at": "2024-12-18T09:58:36.578595",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7343,
      "client_name": "EVELIN DAMARIS JIMENEZ MORENO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04127769871",
      "client_email": "JEREBRYMORENO@GMAIL.COM",
      "address": "CALLE CARREÑO EDIF. URQUIA PISO 3 APTO 2 CONJUNTO RESIDENCIAL HACIENDA EL NISPERO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V15290954",
      "nap_box_name": "CTO-00296",
      "created_at": "2024-12-18T14:33:44.999590",
      "service_detail": {
        "id": 11929,
        "ip": "10.10.92.2",
        "mac": "OEMT3C624A0A",
        "serial": "OEMT3C624A0A",
        "queue": null,
        "interface": "VLAN209_ZAMORA_OLT1",
        "created_at": "2026-03-03T18:39:54.877350",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7344,
      "client_name": "ANGELA MARIA SUAREZ CALDERON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Durpa",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243799559",
      "client_email": "SUAREZANGELA209@GMAIL.COM",
      "address": "CALLE AVE DEL PARAISO MANZANA A CASA NRO 10 SECTOR ROSARIO DE PAYA ROSARIO DE PAYA ARAGUA ZONA POSTAL2115",
      "client_identification": "V11182129",
      "nap_box_name": "CTO-00302",
      "created_at": "2024-12-18T14:35:05.471078",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7345,
      "client_name": "JOSELINE YINSAUMMYY RIVAS LOBO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Valle Fresco",
      "plan": {
        "id": 43,
        "name": "RECURRENTE RESIDENCIAL PLAN 650M",
        "cost": "46.00",
        "code": "FOR650M",
        "profile": "650M/650M"
      },
      "client_mobile": "04144932930",
      "client_email": "JYRL0207@GMAIL.COM",
      "address": "VALLE FRESCO MANZANA 23 CALLE 10 TURMERO EDO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V16226032",
      "nap_box_name": "CTO - 981",
      "created_at": "2024-12-18T14:46:55.072066",
      "service_detail": {
        "id": 12370,
        "ip": "10.10.94.2",
        "mac": "HWTC48220060",
        "serial": "HWTC48220060",
        "queue": null,
        "interface": "VLAN270_VALLE_FRESCO_OLT3",
        "created_at": "2026-04-20T11:34:45.832361",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7346,
      "client_name": "ANA ESTHER BECERRA ROMERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Prados I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04141029878",
      "client_email": "ANABECERRAROMERO277@GMAIL.COM",
      "address": "PRADO 1 CALLE 13 CASA 15 ROSARIO DE PAYA",
      "client_identification": "V10515113",
      "nap_box_name": "CTO-0589",
      "created_at": "2024-12-18T15:02:24.175992",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7347,
      "client_name": "ANNY BISKEY YANEZ RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Luz y Vida",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243432935",
      "client_email": "BISKEYANNY@GMAIL.COM",
      "address": "SECTOR LUZ Y VIDA CALLE 3 NRO 169 ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V18163821",
      "nap_box_name": "CTO-00308",
      "created_at": "2024-12-18T15:43:49.815934",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7349,
      "client_name": "ODALYS ANTONIETA TOVAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121486917",
      "client_email": "CARRILLOLUISANA450@GMAIL.COM",
      "address": "RIO SECO CALLE 21 NRO. 59 ROSARIO DE PAYA  TURMERO EDO. ARAGUA ZONA POSTAL 2115",
      "client_identification": "V6671416",
      "nap_box_name": "CTO-00276",
      "created_at": "2024-12-18T16:24:19.163113",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7350,
      "client_name": "VICKY ALEXANDRA BRITO ALFONZO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "El Cambur",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04162189571",
      "client_email": "BRITOVICTORIA521@GMAIL.COM",
      "address": "CALLE PRINCIPAL LAS PALMAS CASA NRO. 28 SECTOR EL CAMBUR ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V22948022",
      "nap_box_name": "CTO-00150",
      "created_at": "2024-12-18T16:34:45.736737",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7351,
      "client_name": "KLEBERSON ARQUIMEDES MEDINA ZAPATA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04122079049",
      "client_email": "KLEBERSONMZAPATA@GMAIL.COM",
      "address": "CALLE 4B CASA NRO. 54 URB. PANTIN. ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V29744635",
      "nap_box_name": "CTO-00134",
      "created_at": "2024-12-18T16:46:14.470289",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7352,
      "client_name": "JHONNY OSWALDO PERNIA GONZALEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Bicentenario",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128863101",
      "client_email": "JHONNYPERNIA1970@GMAIL.COM",
      "address": "FUNDA BARRIOS MANZA B CALLE ARAGUANEY CASA 10",
      "client_identification": "V10509271",
      "nap_box_name": "592",
      "created_at": "2024-12-18T16:57:04.288161",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7353,
      "client_name": "JESSICA ANDREINA HENRIQUEZ MORIN",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04125058089",
      "client_email": "JESSICAHENRIQUEZ1981@GMAIL.COM",
      "address": "TURMERO CALLE SUCRE CASA NRO. 14",
      "client_identification": "V16128568",
      "nap_box_name": "CTO-00266",
      "created_at": "2024-12-18T17:07:31.755374",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7354,
      "client_name": "YUBELIS JOSEFINA MENDOZA OLIVAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Durpa",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128651603",
      "client_email": "MENDOZAYUBERLIS940@GMAIL.COM",
      "address": "SECTOR FUNDA BARRIO MANZANA 20 CASA NRO 17 ROSARIO DE PAYA",
      "client_identification": "V13625231",
      "nap_box_name": "376",
      "created_at": "2024-12-18T17:18:45.495971",
      "service_detail": {
        "id": 7587,
        "ip": "10.10.118.2",
        "mac": "HWTC48080290",
        "serial": "HWTC48080290",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN240_DURPA",
        "created_at": "2024-12-20T09:52:38.577507",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7355,
      "client_name": "OMAR ALEXANDER REQUENA OLMOS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243096753",
      "client_email": "REQUENAOLMOS04@GMAIL.COM",
      "address": "CALLE CEDEÑO CASA 16-2 TURMERO",
      "client_identification": "V18884482",
      "nap_box_name": "84",
      "created_at": "2024-12-18T17:25:39.453914",
      "service_detail": {
        "id": 9485,
        "ip": "10.10.101.2",
        "mac": "HWTC5D5ADC91",
        "serial": "HWTC5D5ADC91",
        "queue": "queue1",
        "interface": "VLAN200_OLTs",
        "created_at": "2025-09-07T10:30:22.583085",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7356,
      "client_name": "RAFAEL JOSE THEIS CONTRERAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "San Pablo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243529638",
      "client_email": "RTHEISC@GMAIL.COM",
      "address": "AV 2DA QTA NRO 8 URB SAN PABLO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V18646732",
      "nap_box_name": "CTO-00413",
      "created_at": "2024-12-18T17:41:38.601128",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7357,
      "client_name": "FERNANDO SIMON ALVAREZ VILLAMIZAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Canaima",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04123136690",
      "client_email": "IMUVIHSANTIAGOMARINO@GMAIL.COM",
      "address": "CALLE 2 # 11 URBANISMO CANAIMA SECTOR PRADOS DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V21465394",
      "nap_box_name": "356",
      "created_at": "2024-12-18T18:15:17.890662",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7359,
      "client_name": "ESTHEFANY ROSMARY ESPINOZA ROSADO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243139788",
      "client_email": "ESTHEFANY25ESPINO@GMAIL.COM",
      "address": "PANTIN CALLE 11 B #38",
      "client_identification": "V25850411",
      "nap_box_name": "CTO-00166",
      "created_at": "2024-12-19T11:49:48.842943",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7360,
      "client_name": "JESUS DANIEL ALBARRAN CARDENAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Villa De San Jose",
      "plan": {
        "id": 43,
        "name": "RECURRENTE RESIDENCIAL PLAN 650M",
        "cost": "46.00",
        "code": "FOR650M",
        "profile": "650M/650M"
      },
      "client_mobile": "04121998554",
      "client_email": "DANIELALBARRANVENTAS@GMAIL.COM",
      "address": "URBANIZACION VILLAS DE SAN JOSE SECTOR EL MACARO CASA # 404",
      "client_identification": "V15316959",
      "nap_box_name": "CTO-00080",
      "created_at": "2024-12-19T14:04:10.212764",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7361,
      "client_name": "MILANYER NATACHA ALFONZO ALFONZO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Manirito",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04264366061",
      "client_email": "KARLAALFONZO994@GMAIL.COM",
      "address": "CALLE MANIRITO CASA # 19 BARRIO MANIRITO SECTOR GUAYABITA TURMERO ESTADO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V25841347",
      "nap_box_name": "CTO - 1092",
      "created_at": "2024-12-19T15:54:59.110510",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7362,
      "client_name": "INSTITUTO DE VIVIENDA Y HABITAT",
      "client_type_name": "INTERCAMBIO",
      "client_subdivision": "ACTIVO_INTERCAMBIO",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": false,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 83,
        "name": "RECURRENTE INSTITUCIONAL 80M",
        "cost": "0.00",
        "code": "FO-R80",
        "profile": "80M/80M"
      },
      "client_mobile": "04123136690",
      "client_email": "IMUVIHSANTIAGOMARINO@GMAIL.COM",
      "address": "CALLE PROLONGACIÓN AV BOLIVAR SECTOR CENTRO TURMERO ARAGUA",
      "client_identification": "J21465394",
      "nap_box_name": "88",
      "created_at": "2024-12-21T13:39:35.751219",
      "service_detail": {
        "id": 7590,
        "ip": "172.21.27.2",
        "mac": "VSOL004977F1",
        "serial": "VSOL004977F1",
        "queue": "Plan_107916_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2024-12-21T13:41:32.358548",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7363,
      "client_name": "Freddy Carrillo",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "SUSPENDIDO_RESIDENCIAL",
      "status_name": "Suspendido",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Sabana Grande",
      "plan": {
        "id": 97,
        "name": "RECURRENTE RESIDENCIAL PLAN 10M",
        "cost": "18.00",
        "code": "[FOR10]",
        "profile": "10Mbps/10Mbps"
      },
      "client_mobile": "04129950904",
      "client_email": "freddycarrillo1912@gmail.com",
      "address": "Avenida Casanova, Centro Comercial El Recreo, Torre Norte, Piso 8, Oficina 812, Sabana Grande, Parroquia El Recreo, Municipio Libertador, Caracas 1050.",
      "client_identification": "V28458411",
      "nap_box_name": "CTO-00283",
      "created_at": "2024-12-21T15:50:10.480107",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7364,
      "client_name": "FILADELFO JAVIER CARRUYO CHACIN",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Marina Caribe",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04144936882",
      "client_email": "FILAJCARRUYO@GMAIL.COM",
      "address": "URB. MARINA CARIBE CALLE G CASA 52 TURMERO EDO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V15301202",
      "nap_box_name": "CTO - 940",
      "created_at": "2024-12-23T10:34:51.311681",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7365,
      "client_name": "EVELYN JOSEFINA GARCIA REYES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados de Cafetal",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04265306192",
      "client_email": "GARCIAEVE0879@GMAIL.COM",
      "address": "PRADOS DE CAFETAL CALLE 1 ARAGUA ZONA POSTAL 2115",
      "client_identification": "V13908740",
      "nap_box_name": "CTO-0076",
      "created_at": "2024-12-23T11:47:42.567968",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7366,
      "client_name": "ANDRISMAR ANDREINA OCHOA ESCORCHA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "El Cambur",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243204577",
      "client_email": "LEYKERGOMEZPEREZ@GMAIL.COM",
      "address": "CALLE 05 CASA # 389 SECTOR MATACABALLO ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V33083465",
      "nap_box_name": "CTO-00150",
      "created_at": "2024-12-23T11:56:17.940665",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7367,
      "client_name": "MERY COROMOTO PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Macarena",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04261393798",
      "client_email": "MERYCOROMOTO79@GMAIL.COM",
      "address": "LA MACARENA II CALLE 6 NRO. 24 TURMERO EDO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V7179579",
      "nap_box_name": "246",
      "created_at": "2024-12-27T14:08:14.230798",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7368,
      "client_name": "EGILDA RAMONA CERMENO DE VEGAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "1ro de Mayo Norte",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04125987978",
      "client_email": "MAYRAYBARBARA21@GMAIL.COM",
      "address": "CALLE SOROCAIMA CASA NRO 8 SECTOR 1RO DE MAYO NORTE PAYA EDO ARAGUA",
      "client_identification": "V8584382",
      "nap_box_name": "CE - 846",
      "created_at": "2024-12-30T14:54:48.493924",
      "service_detail": {
        "id": 7620,
        "ip": "10.10.127.2",
        "mac": "HWTC48080279",
        "serial": "HWTC48080279",
        "queue": "Plan_161870_30181_WispHub",
        "interface": "VLAN261_1ERO_MAYO_ZTE",
        "created_at": "2025-01-15T10:21:01.022764",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7369,
      "client_name": "KERINYER DAYERLIN SANCHEZ FANEITE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04161723344",
      "client_email": "SANCHEZKERINYERDAYERLIN@GMAIL.COM",
      "address": "URB. HACIENDA PANTIN CALLE 18 A NRO. 7",
      "client_identification": "V22949040",
      "nap_box_name": "CTO-00434",
      "created_at": "2025-01-02T14:25:58.007478",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7370,
      "client_name": "MANOLO ALEXANDER CORREA HERNANDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Durpa",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128923497",
      "client_email": "LISMARYPERDOMO@GMAIL.COM",
      "address": "CALLE LIBERTAD MANZANA 15 NUMERO 14 DURPA",
      "client_identification": "V12143713",
      "nap_box_name": "CTO-00297",
      "created_at": "2025-01-06T15:06:49.477943",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7371,
      "client_name": "HECTOR ANTONIO GUZMAN ACHE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Callejon Los Jabillos",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243498951",
      "client_email": "JORRIBO68@GMAIL.COM",
      "address": "FINAL CALLE LOS JABILLOS CASA S/N SECTOR PRADOS DEL CAFETAL TURMERO ARAGUA ZONA 2115",
      "client_identification": "V3742167",
      "nap_box_name": "138",
      "created_at": "2025-01-08T14:53:43.148306",
      "service_detail": {
        "id": 12781,
        "ip": "10.10.130.2",
        "mac": "TP:LG:F5:CB:0A:C9",
        "serial": "TPLGF5CB0AC9",
        "queue": null,
        "interface": "VLAN205_JABILLOS_OLT2",
        "created_at": "2026-08-01T13:54:26.154670",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7372,
      "client_name": "MIGUELINA GARCIA DE JASPE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04163146111",
      "client_email": "LIC.MIGUELINAGARCIA@GMAIL.COM",
      "address": "CALLE 12 CASA NRO 693-C URB MATACABALLO ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V5452673",
      "nap_box_name": "CTO-00433",
      "created_at": "2025-01-08T17:07:00.942716",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7373,
      "client_name": "DANIELA ALICIA PEREZ SEGOVIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04228152739",
      "client_email": "DANIELAALICIAPEREZSEGOVIA@GMAIL.COM",
      "address": "AV. 2 CASA 491 URB. MATA CABALLO",
      "client_identification": "V24930592",
      "nap_box_name": "CTO-00567 DOS",
      "created_at": "2025-01-09T11:54:52.240966",
      "service_detail": {
        "id": 10441,
        "ip": "10.10.132.2",
        "mac": "OEMT3C624C3E",
        "serial": "OEMT3C624C3E",
        "queue": null,
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2025-12-01T16:20:42.165066",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7374,
      "client_name": "RUFO JEAN PAUL MORALES TERAN",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Magdalena",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04125989734",
      "client_email": "RUFOMORALESA@IRTLOK.ES",
      "address": "CALLE 11 CASA NRO 39 SECTOR LA MAGDALENA TURMERO",
      "client_identification": "V21270403",
      "nap_box_name": "357",
      "created_at": "2025-01-09T14:30:08.092151",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7377,
      "client_name": "LUISA HERNANDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124541007",
      "client_email": "LUISAEHA@GMAIL.COM",
      "address": "MATA CABALLO CALLE 3 CASA # 148",
      "client_identification": "V7594346",
      "nap_box_name": "CE - 504",
      "created_at": "2025-01-11T14:02:21.317297",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7390,
      "client_name": "YOSELAY GABRIELA YEPEZ PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Palmeras II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243849016",
      "client_email": "YEPEZG163@GMAIL.COM",
      "address": "CALLE 3 CASA Nª 8 URB. LAS PALMERAS  II MANANZA C TURMERO ARAGUA",
      "client_identification": "V20590361",
      "nap_box_name": "336",
      "created_at": "2025-01-13T16:05:07.362992",
      "service_detail": {
        "id": 12816,
        "ip": "10.10.134.2",
        "mac": "HW:TC:48:08:02:80",
        "serial": "HWTC48080280",
        "queue": null,
        "interface": "VLAN119_PALMERAS_2",
        "created_at": "2026-08-10T15:53:55.080913",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7391,
      "client_name": "YUDILMA JOSEFINA VILLEGAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Paya Abajo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243278607",
      "client_email": "VILLEGASYUDILMA7@GMAIL.COM",
      "address": "CALLE CAMPO ELIAS CASA NRO.07 PAYA ABAJO",
      "client_identification": "V12171489",
      "nap_box_name": "CTO-00307",
      "created_at": "2025-01-13T16:55:34.326518",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7392,
      "client_name": "KETHERINE ESTHEFANNY ORTIZ LOPEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Guayabita",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04125021921",
      "client_email": "JEYDEN.JEREMY@GMAIL.COM",
      "address": "CALLE 3 DE MAYO CASA 30 SECTOR GUAYABITA POLVORIN",
      "client_identification": "V25841009",
      "nap_box_name": "CTO - 991",
      "created_at": "2025-01-13T20:28:03.720218",
      "service_detail": {
        "id": 11946,
        "ip": "10.10.136.2",
        "mac": "HWTC48080309",
        "serial": "HWTC48080309",
        "queue": "queue1",
        "interface": "VLAN280_POLVORIN",
        "created_at": "2026-03-04T12:04:52.405000",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7393,
      "client_name": "WILKER DANIEL ORTEGANO FAJARDO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Palmeras I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121479482",
      "client_email": "WILKERORTEGANO@GMAIL.COM",
      "address": "URBANIZACION LAS PALMERAS I AV. 2 CASA NRO. 78 TURMERO ESTADO ARAGUA",
      "client_identification": "V29931491",
      "nap_box_name": "CTO-00065",
      "created_at": "2025-01-14T14:00:44.029653",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7394,
      "client_name": "NORELIS JOSEFINA GONZALEZ PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Prados",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128494901",
      "client_email": "GNORELISJOSEFINA@GMAIL.COM",
      "address": "AV.PRINCIPAL CASA NRO.38 URB. PRADO DE PAYA ROSARIO DE PAYA ZONA POSTAL 2115",
      "client_identification": "V10935903",
      "nap_box_name": "579",
      "created_at": "2025-01-15T09:16:02.766805",
      "service_detail": {
        "id": 7622,
        "ip": "10.10.138.2",
        "mac": "HWTC48080278",
        "serial": "HWTC48080278",
        "queue": "Plan_161900_30183_WispHub",
        "interface": "VLAN236_PRADOS3",
        "created_at": "2025-01-15T10:39:38.023056",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7395,
      "client_name": "ANGELUZ MARIA CARVAJAL CASTELLANO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Prados I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04244426576",
      "client_email": "ANGELUZCARVAJAL28.Z@GMAIL.COM",
      "address": "AV. PRINCIPAL BRISAS DE PAYA CASA NRO. 03 PRADOS",
      "client_identification": "V29882071",
      "nap_box_name": "CTO-00193",
      "created_at": "2025-01-15T09:36:29.737836",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7396,
      "client_name": "DIANA ISABEL DIAZ LEON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "1ro de Mayo Sur",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04129685442",
      "client_email": "DIAZDIANA2704@GMAIL.COM",
      "address": "ROSARIO DE PAYA PRIMERO DE MAYO SUR CALLE LA ORQUIDEA CASA NRO. 3",
      "client_identification": "V27048499",
      "nap_box_name": "CTO - 914",
      "created_at": "2025-01-15T10:40:43.139581",
      "service_detail": {
        "id": 7624,
        "ip": "10.10.140.2",
        "mac": "HWTC48080274",
        "serial": "HWTC48080274",
        "queue": "Plan_161900_30183_WispHub",
        "interface": "VLAN261_1ERO_MAYO_ZTE",
        "created_at": "2025-01-15T10:46:13.173922",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7397,
      "client_name": "ANABEL GONZALEZ PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Luz y Vida",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04122992698",
      "client_email": "SHADAYGONZALEZ566@GMAIL.COM",
      "address": "CALLE 3 CASA NRO. 177 SECTOR LUZ Y VIDA",
      "client_identification": "V22291093",
      "nap_box_name": "CTO-00308",
      "created_at": "2025-01-15T13:38:43.516057",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7398,
      "client_name": "MERCERIA EL DEDAL DE ORO",
      "client_type_name": "PYME",
      "client_subdivision": "CANCELADO_PYME",
      "status_name": "Cancelado",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04121783455",
      "client_email": "BETTY_LAGATA@HOTMAIL.COM",
      "address": "CALLE RIVAS EDIF. MARIÑO PISO PB LOCAL B SECTOR CENTRO DE TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "J075434439",
      "nap_box_name": "CTO-00502",
      "created_at": "2025-01-15T14:18:48.572933",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7399,
      "client_name": "MAIKOL JOANY CAICEDO NUNES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04125901882",
      "client_email": "TORRESADRIANRORIMAR@GMAIL.COM",
      "address": "LA JULIA LA CASONA I CALLE 9 CASA NRO. 8",
      "client_identification": "V28277990",
      "nap_box_name": "407",
      "created_at": "2025-01-15T16:37:31.241112",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7400,
      "client_name": "MINISTERIO DEL PODER POPULAR PARA LA EDUCACION",
      "client_type_name": null,
      "client_subdivision": "ACTIVO_SIN_TIPO",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 99,
        "name": "PLAN RECURRENTE PROYECTO DE CONECTIVIDAD",
        "cost": "464.00",
        "code": "FOP-1GB",
        "profile": "1280Mbps/1280Mbps"
      },
      "client_mobile": "04243595993",
      "client_email": "THAISBEJAS@GMAIL.COM",
      "address": "ESQUINA DE SALAS A CAJA DE AGUA EDIFICIO SEDE DEL MPPE PARROQUIA ALTA GRACIA",
      "client_identification": "G200000090",
      "nap_box_name": "649",
      "created_at": "2025-01-15T16:41:26.954304",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7401,
      "client_name": "MARIA CAROLINA ARAY",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243422041",
      "client_email": "MARIACAROLINAARAY213@GMAIL.COM",
      "address": "URB. MATA CABALLO CALLE 9 APTO 590A",
      "client_identification": "V12169869",
      "nap_box_name": "222",
      "created_at": "2025-01-16T09:27:22.101441",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7402,
      "client_name": "LOURDES GODOY CASTRO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Leocolbo",
      "plan": {
        "id": 101,
        "name": "RECURRENTE RESIDENCIAL PLAN 200M",
        "cost": "19.00",
        "code": "FOR200MB",
        "profile": "200Mbps/200Mbps"
      },
      "client_mobile": "04144627265",
      "client_email": "LULUGODOY885@GMAIL.COM",
      "address": "CALLE A CASA NRO 48 BARRIO  VALLES DE LEO COLVO TURMERO ARAGUA ZONA POSTAL 2107",
      "client_identification": "V7231164",
      "nap_box_name": "CE - 623",
      "created_at": "2025-01-16T12:38:18.807913",
      "service_detail": {
        "id": 11802,
        "ip": "10.10.142.2",
        "mac": "HWTC48080282",
        "serial": "HWTC48080282",
        "queue": null,
        "interface": "VLAN144_LEOCOLBO",
        "created_at": "2026-02-27T11:31:36.867527",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7404,
      "client_name": "LINDA EVANS SIERRA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243764291",
      "client_email": "LINDASIERRA9765@GMAIL.COM",
      "address": "CALLE MARIÑO EDIF 10 PISO PB APT 01 SECTOR CENTRO TURMERO EDO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V20107880",
      "nap_box_name": "CTO-00256",
      "created_at": "2025-01-16T13:43:49.405237",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7405,
      "client_name": "RILSKY DANIEL HERNANDEZ TOVAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04265169340",
      "client_email": "RIKITY2@GMAIL.COM",
      "address": "CALLE CAMILO TORRES NRO. 9-1 CASCO CENTRAL",
      "client_identification": "V10753014",
      "nap_box_name": "CE-00009",
      "created_at": "2025-01-16T16:09:47.912375",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7406,
      "client_name": "ANGELA DE LOS ANGELES SULBARAN AREVALO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Prados I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128902188",
      "client_email": "ASDRUBALVASQUEZ15@GMAIL.COM",
      "address": "PRADOS DE PAYA I CALLE 11 CASA # 06 ROSARIO DE PAYA ZONA POSTAL 2115",
      "client_identification": "V12167852",
      "nap_box_name": "CTO-00204 DOS",
      "created_at": "2025-01-17T08:31:09.317730",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7407,
      "client_name": "KARELIS CAROLINA ESCALONA CARMONA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Las Rurales",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04127568039",
      "client_email": "KARELIS1950@GMAIL.COM",
      "address": "ROSARIO DE PAYA CALLE NRO.106 CASA NRO. 04 CALLEJON LAS CARMONAS",
      "client_identification": "V20649997",
      "nap_box_name": "CTO-0490",
      "created_at": "2025-01-17T11:25:22.989368",
      "service_detail": {
        "id": 12176,
        "ip": "10.10.168.2",
        "mac": "HWTC49200811",
        "serial": "HWTC49200811",
        "queue": null,
        "interface": "VLAN252_RURALES_PAYA",
        "created_at": "2026-03-24T20:03:06.841682",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7408,
      "client_name": "AMINTA MELINA ALVARADO DE NIEVES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Vista Hermosa",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04142787508",
      "client_email": "AMINTAALVARADO5@GMAIL.COM",
      "address": "AV. PRINCIPAL ROSARIO DE PAYA SECTOR VISTA HERMOSA CASA NRO. 85",
      "client_identification": "V11922688",
      "nap_box_name": "CTO-00060 DOS",
      "created_at": "2025-01-17T16:22:08.513879",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7409,
      "client_name": "YULIANA NAZARETH MIJARES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Payita",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243511105",
      "client_email": "YOXAIDERP@GMAIL.COM",
      "address": "CALLE PRINCIPAL CASA #70 PAYITA",
      "client_identification": "V17578005",
      "nap_box_name": "CTO-1045",
      "created_at": "2025-01-20T13:56:08.818744",
      "service_detail": {
        "id": 7642,
        "ip": "10.10.158.2",
        "mac": "OEMT3C624DB6",
        "serial": "OEMT3C624DB6",
        "queue": "Plan_107915_30181_WispHub",
        "interface": "VLAN284_PAYITA",
        "created_at": "2025-01-24T16:44:07.237555",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7410,
      "client_name": "JOSE MIGUEL AGUILERA DIAZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Valle Verde",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04120372212",
      "client_email": "ALEJANDROWILLIAM2002@GMAIL.COM",
      "address": "CALLE SUCRE CASA 30 SECTOR VALLE VERDE ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V26679691",
      "nap_box_name": "CE - 691",
      "created_at": "2025-01-20T15:12:41.963423",
      "service_detail": {
        "id": 7643,
        "ip": "10.10.159.2",
        "mac": "OEMT3C624E92",
        "serial": "OEMT3C624E92",
        "queue": "Plan_161900_30183_WispHub",
        "interface": "VLAN253_VALLE_VERDE",
        "created_at": "2025-01-24T16:49:41.413102",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7411,
      "client_name": "FANNY NEREIDI MORENO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04141465691",
      "client_email": "MONTILLATORRESCARLOS788@GMAIL.COM",
      "address": "CALLE 17#52 SECTOR RIO SECO ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V16210124",
      "nap_box_name": "CTO-00070",
      "created_at": "2025-01-20T15:30:34.890491",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7412,
      "client_name": "ARAMI FRANCIA VIZCAINO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Durpa",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124350639",
      "client_email": "ARAMIDETEJADA@GMAIL.COM",
      "address": "CALLE MANZANA 11 CASA#13 SECTOR PAYA COMUNIDAD DIOS ES MI REFUGIO ROSARIO DE PAYA ZONA POSTAL 2104",
      "client_identification": "V18330779",
      "nap_box_name": "379",
      "created_at": "2025-01-20T15:41:15.231753",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7413,
      "client_name": "DINOSKA YSABEL TORRES TORREALBA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243424229",
      "client_email": "DINOSKAYTORRES@GMAIL.COM",
      "address": "CALLE 1 CASA 2 URB MATA CABALLO ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V20760563",
      "nap_box_name": "CTO-00131",
      "created_at": "2025-01-20T15:47:44.474057",
      "service_detail": {
        "id": 13139,
        "ip": "10.10.162.2",
        "mac": "ZX:IC:CD:EB:D3:8B",
        "serial": "ZXICCDEBD38B",
        "queue": null,
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2026-10-09T12:19:35.053536",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7414,
      "client_name": "LUBRICANTES Y SERVICIOS LS CA",
      "client_type_name": "PYME",
      "client_subdivision": "CANCELADO_PYME",
      "status_name": "Cancelado",
      "cycle": 10,
      "migrate": true,
      "sector_name": "El Macaro",
      "plan": {
        "id": 102,
        "name": "RECURRENTE PYME PLAN 150M",
        "cost": "27.60",
        "code": "FOP150M",
        "profile": "150Mbps/150Mbps"
      },
      "client_mobile": "04124115396",
      "client_email": "LUBRICANTESLS@GMAIL.COM",
      "address": "CTRA EL MACARO LOCAL PARCELA NRO 1-1 SECTOR EL MACARO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "J407720716",
      "nap_box_name": "CE-00141",
      "created_at": "2025-01-20T15:55:43.374543",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7415,
      "client_name": "CARMEN MARIA CAMPOS NIÑO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Las Rurales",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128976917",
      "client_email": "NEGRAMARIA1211@GMAIL.COM",
      "address": "AV. PRINCIPAL CASA NRO 68 SECTOR LAS RURALES ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V9436616",
      "nap_box_name": "CE-00080",
      "created_at": "2025-01-21T07:56:42.361621",
      "service_detail": {
        "id": 7647,
        "ip": "10.10.163.2",
        "mac": "OEMT3C624DB2",
        "serial": "OEMT3C624DB2",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN252_RURALES_PAYA",
        "created_at": "2025-01-27T08:13:51.510014",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7416,
      "client_name": "YESENIA TERESA ARCINIEGAS HERNANDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243373036",
      "client_email": "YESETAHYES@GMAIL.COM",
      "address": "AV BOLIVAR EDIF TORRE D PISO 5 APTO 55 CONJUNTO RESIDENCIAL LOS NISPEROS",
      "client_identification": "V14060292",
      "nap_box_name": "88",
      "created_at": "2025-01-21T10:14:11.552580",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7417,
      "client_name": "KARLA ANDREINA REVERON RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243360871",
      "client_email": "WILLYCURAPIACA01@GMAIL.COM",
      "address": "CALLE 09 CASA NRO. 21 SECTOR RIO SECO",
      "client_identification": "V19834101",
      "nap_box_name": "CE - 600",
      "created_at": "2025-01-21T11:31:22.459784",
      "service_detail": {
        "id": 7648,
        "ip": "10.10.164.2",
        "mac": "HWTC49200817",
        "serial": "HWTC49200817",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN251_RIO_SECO",
        "created_at": "2025-01-27T08:17:19.390840",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7418,
      "client_name": "LUIS DE FREITES DA SILVA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Durpa",
      "plan": {
        "id": 43,
        "name": "RECURRENTE RESIDENCIAL PLAN 650M",
        "cost": "46.00",
        "code": "FOR650M",
        "profile": "650M/650M"
      },
      "client_mobile": "04243186175",
      "client_email": "LUISDEFTREITAS741@GMAIL.COM",
      "address": "CALLE LEALTAD MANZANA 22 CASA NRO 05 DURPA",
      "client_identification": "V12569227",
      "nap_box_name": "CTO-00320",
      "created_at": "2025-01-21T12:35:06.090023",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7419,
      "client_name": "MARIANGELA GABRIELA RODRIGUEZ POLANCO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128360568",
      "client_email": "JOSEGREGORIODOMINGUEZ474@GMAIL.COM",
      "address": "URB. HACIENDA PANTIN CALLE 4 B  # 46",
      "client_identification": "V26095046",
      "nap_box_name": "CTO-00134",
      "created_at": "2025-01-21T14:26:05.950250",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7420,
      "client_name": "LISETH ANTONIA FERNANDEZ PEÑALVER",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243040433",
      "client_email": "LISETHFERNANDEZ1988@GMAIL.COM",
      "address": "URB. MATA CABALLO CALLE 7 APTO 537C TURMERO",
      "client_identification": "V19699951",
      "nap_box_name": "CTO-00073",
      "created_at": "2025-01-22T08:53:19.220457",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7421,
      "client_name": "KARINA YAMILET MATUTE BELISARIO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04125260954",
      "client_email": "MATUTEKARINA284@GMAIL.COM",
      "address": "SECTOR RIO SECO CALLE 21 CASA NRO.62",
      "client_identification": "V19067979",
      "nap_box_name": "CTO-00276",
      "created_at": "2025-01-22T13:18:47.387715",
      "service_detail": {
        "id": 7653,
        "ip": "10.10.169.2",
        "mac": "HWTC49200838",
        "serial": "HWTC49200838",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN251_RIO_SECO",
        "created_at": "2025-01-27T09:56:28.700906",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7422,
      "client_name": "RODOLFO JOSE GAMARRA VALCARCEL",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Las Rurales",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121482914",
      "client_email": "GAMARRA.RDOF@GMAIL.COM",
      "address": "CALLE BOLIVAR C/C RIO SECO CASA #66 SECTOR LAS RURALES ROSARIO DE PAYA",
      "client_identification": "V19418195",
      "nap_box_name": "CE-660",
      "created_at": "2025-01-23T09:53:17.357143",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7424,
      "client_name": "UNIDAD DE IMAGENES SANTIAGO MARIÑO C.A",
      "client_type_name": "PYME",
      "client_subdivision": "CANCELADO_PYME",
      "status_name": "Cancelado",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04263320906",
      "client_email": "UDISMT@GMAIL.COM",
      "address": "CALLE MARIÑO CRUCE CON PEÑALVER CC. MARIÑO PLAZA PB LOCAL 13",
      "client_identification": "J406066486",
      "nap_box_name": "CTO - 857",
      "created_at": "2025-01-23T14:49:44.488718",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7425,
      "client_name": "BEATRIZ ADRIANA GRANADILLO RIVAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Las Palmas",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04145943821",
      "client_email": "GRANADILLOBEATRIZ1993@GMAIL.COM",
      "address": "ROSARIO DE PAYA SECTOR LAS PALMAS C/RAUL LEONIS #9",
      "client_identification": "V22948417",
      "nap_box_name": "CE - 850",
      "created_at": "2025-01-23T15:02:15.276794",
      "service_detail": {
        "id": 7655,
        "ip": "10.10.171.2",
        "mac": "OEMT3C62467E",
        "serial": "OEMT3C62467E",
        "queue": "Plan_161900_30183_WispHub",
        "interface": "VLAN262_LAS_PALMAS_ZTE",
        "created_at": "2025-01-27T10:45:11.484429",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7426,
      "client_name": "SORELY DE JESUS GUADAMO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vallecito",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04127540128",
      "client_email": "GUADAMOSORELY@GMAIL.COM",
      "address": "SECTOR VALLECITO CALLE LOS MANGOS CASA S/N ROSARIO DE PAYA",
      "client_identification": "V26193294",
      "nap_box_name": "CTO-00074",
      "created_at": "2025-01-23T15:08:31.416765",
      "service_detail": {
        "id": 7672,
        "ip": "10.10.172.2",
        "mac": "HWTC49200370",
        "serial": "HWTC49200370",
        "queue": "queue1",
        "interface": "VLAN258_VALLECITO",
        "created_at": "2025-01-30T11:25:46.596031",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7427,
      "client_name": "MIREYA MORA RONDON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vista Hermosa",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04264288389",
      "client_email": "MIREYAMORA568@GMAIL.COM",
      "address": "CASA 49 BARRIO VISTA HERMOSA PAYA",
      "client_identification": "V10902358",
      "nap_box_name": "CTO-00058",
      "created_at": "2025-01-23T15:12:19.673921",
      "service_detail": {
        "id": 9597,
        "ip": "10.10.173.2",
        "mac": "HWTC49200815",
        "serial": "HWTC49200815",
        "queue": null,
        "interface": "VLAN230_VISTA_HERMOSA",
        "created_at": "2025-10-10T16:32:58.849713",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7428,
      "client_name": "ELVIS YESMIL ROMERO TARAZONA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados I",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04121469884",
      "client_email": "vanessartarazona14@gmail.com",
      "address": "PRADOS DE PAYA I CALLE 3 #32 ROSARIO DE PAYA",
      "client_identification": "V16406487",
      "nap_box_name": "CTO-00061",
      "created_at": "2025-01-23T16:29:09.971574",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7429,
      "client_name": "PEDRO EULOGIO ACOSTA MONSALVE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Laguna Plaza",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144556317",
      "client_email": "ACOSTA.PEDRO@GMAIL.COM",
      "address": "RESIDENCIAS LAGUNA PLAZA, CALLE FROILÁN CORREA C/C CALLE CAMILO TORRES, EDIF 1, PH3, TURMERO, ARAGUA.",
      "client_identification": "V16206435",
      "nap_box_name": "4 DOS",
      "created_at": "2025-01-23T16:39:36.095818",
      "service_detail": {
        "id": 7641,
        "ip": "172.20.52.2",
        "mac": "TPLG1BB3635D",
        "serial": "TPLG1BB3635D",
        "queue": "Plan_92194_15811_WispHub",
        "interface": "VLAN216_LAGUNA_PLAZA_OLT1",
        "created_at": "2025-01-24T10:24:51.594375",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7430,
      "client_name": "EVANY SARETH MORILLO CEDRES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Valle Verde",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128896771",
      "client_email": "EVANYMORILLO2018@GMAIL.COM",
      "address": "AV. PRINCIPAL CASA NRO.21 SECTOR VALLE VERDE, ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V24930971",
      "nap_box_name": "CTO-00253 DOS",
      "created_at": "2025-01-24T09:38:09.341397",
      "service_detail": {
        "id": 7659,
        "ip": "10.10.175.2",
        "mac": "HWTC49200828",
        "serial": "HWTC49200828",
        "queue": "queue1",
        "interface": "VLAN253_VALLE_VERDE",
        "created_at": "2025-01-27T11:05:10.270414",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7431,
      "client_name": "ANTHONY JOSE REALES ZARATE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Brisas de Paya",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121490888",
      "client_email": "ANTHONYREALES25@GMAIL.COM",
      "address": "BRISAS DE PRADO CALLE #2 CASA #38 ROSARIO DE PAYA",
      "client_identification": "V22286481",
      "nap_box_name": "371",
      "created_at": "2025-01-24T09:59:43.713386",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7432,
      "client_name": "GRANJA LOS MOLINOS CA",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Polvorin",
      "plan": {
        "id": 36,
        "name": "RECURRENTE PYME PLAN 650M",
        "cost": "70.18",
        "code": "FOP650M",
        "profile": "650M/650M"
      },
      "client_mobile": "04243374154",
      "client_email": "CUENTASPORPAGARMOLINOS@GMAIL.COM",
      "address": "CALLE PRINCIPAL LOCAL PARCELA NRO.01 SECTOR POLVORIN GUAYABITA LA CRUZ ARAGUA ZONA POSTAL 2115",
      "client_identification": "J310314861",
      "nap_box_name": "CE-00164",
      "created_at": "2025-01-27T08:58:15.841447",
      "service_detail": {
        "id": 12759,
        "ip": "10.15.1.2",
        "mac": "ZX:IC:CD:80:9E:18",
        "serial": "ZXICCD809E18",
        "queue": null,
        "interface": "VLAN282_ZONA_AGRARIA",
        "created_at": "2026-07-20T17:38:52.632375",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7433,
      "client_name": "KEYSLER ALBERTO ROJAS RONDON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Orquidea",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128152075",
      "client_email": "KEYSLERR2005@GMAIL.COM",
      "address": "LA ORQUIDEA CALLE NRO.05 CASA NRO.109",
      "client_identification": "V31081059",
      "nap_box_name": "CTO-00306",
      "created_at": "2025-01-27T09:35:48.852371",
      "service_detail": {
        "id": 13145,
        "ip": "10.10.178.2",
        "mac": "HW:TC:49:20:08:27",
        "serial": "HWTC49200827",
        "queue": null,
        "interface": "VLAN259_LA_ORQUIDEA",
        "created_at": "2026-10-10T18:33:10.195269",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7434,
      "client_name": "MILAGROS CAROLINA ESAA DE ANDRADES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Brisas de Paya",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04120360027",
      "client_email": "MILAGROSESAA335@GMAIL.COM",
      "address": "CALLE 02 CASA NRO 06 SECTOR BRISA DE PAYA ROSARIO DE PAYA ARAGUA ZONA PPOSTAL 2115",
      "client_identification": "V15739297",
      "nap_box_name": "367",
      "created_at": "2025-01-27T14:10:27.971168",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7435,
      "client_name": "YERALDINE  DESIREHT LOPEZ BOLIVAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Bicentenario",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243494673",
      "client_email": "YERALDINELOPEZ22@GMAIL.COM",
      "address": "CALLE LOS ROBLE MANZANA 12 SECTOR BICENTENARIO NRO 08 BARRIO ROSARIO DE PAYA",
      "client_identification": "V22940951",
      "nap_box_name": "CTO-00453",
      "created_at": "2025-01-27T15:00:51.017304",
      "service_detail": {
        "id": 7670,
        "ip": "10.10.187.2",
        "mac": "HWTC49200388",
        "serial": "HWTC49200388",
        "queue": "Plan_161900_30183_WispHub",
        "interface": "VLAN243_BICENTENARIO",
        "created_at": "2025-01-30T11:11:26.305613",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7436,
      "client_name": "GABRIELA  CAROLINA CARRILLO GARCIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Las Palmas",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243335335",
      "client_email": "GABRIELAVZLA2024@GMAIL.COM",
      "address": "PAYA EL CAMBUR SECTOR LAS PALMAS ABAJO # 06",
      "client_identification": "V21368187",
      "nap_box_name": "CE - 850",
      "created_at": "2025-01-27T16:26:16.359981",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7458,
      "client_name": "GERMAN RAMON PERALES OJEDA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman de Guere",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243179667",
      "client_email": "GERMANRAPPI1@GMAIL.COM",
      "address": "SAMAN DE GUERE CALLE LA LINEA CASA Nª 5 MUNICIPIO SANTIAGO MARIÑO",
      "client_identification": "V15818241",
      "nap_box_name": "303",
      "created_at": "2025-01-29T10:14:01.831436",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7459,
      "client_name": "DUBRASKA SORENCYS CISNEROS SALCEDO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "San Pablo",
      "plan": {
        "id": 16,
        "name": "RECURRENTE RESIDENCIAL PLAN 800M",
        "cost": "55.00",
        "code": "FOR800",
        "profile": "800M/800M"
      },
      "client_mobile": "04243111428",
      "client_email": "DUBRASKACISNERO2012@GMAIL.COM",
      "address": "CALLE ISABEL CASA N# 48 RESIDENCIAS MARINA CARIBE URB. SAN PABLO",
      "client_identification": "V16436368",
      "nap_box_name": "CTO - 940",
      "created_at": "2025-01-29T10:31:56.696030",
      "service_detail": {
        "id": 7667,
        "ip": "10.10.183.2",
        "mac": "OEMT3C6250A6",
        "serial": "OEMT3C6250A6",
        "queue": "Plan_140304_15811_WispHub",
        "interface": "VLAN259_LA_ORQUIDEA",
        "created_at": "2025-01-29T16:23:59.552828",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7460,
      "client_name": "HECTOR RAUL MUJICA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04127762629",
      "client_email": "Michelmelende@GMAIL.COM",
      "address": "CALLE RIVAS PASILLO B LOCAL N# 67,68 CENTRO COMERCIAL CANDYS",
      "client_identification": "V5459700",
      "nap_box_name": "CTO-00129",
      "created_at": "2025-01-29T10:42:25.472166",
      "service_detail": {
        "id": 7922,
        "ip": "10.10.189.2",
        "mac": "HWTC48080006",
        "serial": "HWTC48080006",
        "queue": "Plan_92194_15811_WispHub",
        "interface": "VLAN254_CANDYS_OLT1",
        "created_at": "2025-03-18T15:20:27.590471",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7461,
      "client_name": "AXEEL RICARDO RUIZ LOPEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243716463",
      "client_email": "AXEELRUIZ@HOTMAIL.COM",
      "address": "CALLE RIVAS N# 51-3 TURMERO MUNICIPIO SANTIAGO MARIÑO",
      "client_identification": "V16762326",
      "nap_box_name": "CTO-00590",
      "created_at": "2025-01-29T11:35:02.763626",
      "service_detail": {
        "id": 7678,
        "ip": "10.10.193.2",
        "mac": "HWTC49200384",
        "serial": "HWTC49200384",
        "queue": "Plan_139897_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2025-02-03T09:41:28.328479",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7462,
      "client_name": "LUZ DE LOS ANGELES PAISANO ESCALONA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Polvorin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243140938",
      "client_email": "ARQLUZAPAISANO@GMAIL.COM",
      "address": "AV. PRINCIPAL DE POLVORIN CASA NRO 36 SECTOR GUAYABITA ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V13473527",
      "nap_box_name": "CTO - 1004",
      "created_at": "2025-01-29T12:06:14.324538",
      "service_detail": {
        "id": 7676,
        "ip": "10.10.184.2",
        "mac": "OEMT3C62463E",
        "serial": "OEMT3C62463E",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN280_POLVORIN",
        "created_at": "2025-01-31T10:03:51.392235",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7463,
      "client_name": "EMILIYS MARIA ALEJO LOAIZA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04266331999",
      "client_email": "EMILYSMARIA16@GMAIL.COM",
      "address": "CALLE 12 CASA NRO 695 URB MATA CABALLO TURMERO ARAGUA ZONA POSTAL 2107",
      "client_identification": "V18977229",
      "nap_box_name": "CTO-00020",
      "created_at": "2025-01-29T13:31:44.385299",
      "service_detail": {
        "id": 7669,
        "ip": "10.10.185.2",
        "mac": "OEMT3C6247B6",
        "serial": "OEMT3C6247B6",
        "queue": "Plan_161900_30183_WispHub",
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2025-01-29T16:41:21.898493",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7464,
      "client_name": "HECTOR CELESTINO TREJO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Orquidea",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04262880859",
      "client_email": "HECTORTREJO7022@GMAIL.COM",
      "address": "CALLE  6 CASA NRO 67 SECTOR LA ORQUIDEA , PRADO",
      "client_identification": "V10977022",
      "nap_box_name": "CTO - 918",
      "created_at": "2025-01-29T14:40:51.721066",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7466,
      "client_name": "KEINNER ANTONIO MARTINEZ CASTILLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Paya Abajo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04166030241",
      "client_email": "KEINNERJOSE28@GMAIL.COM",
      "address": "PAYA CAPILLA BARRIO GUERRERO DE CHAVEZ SEGUNDA CALLE 10",
      "client_identification": "V28322822",
      "nap_box_name": "ce-968",
      "created_at": "2025-01-29T15:52:04.743789",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7467,
      "client_name": "WILFREDO ENRIQUE LEON BARBOZA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Paya Abajo",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04128904028",
      "client_email": "WLEONDJ7@GMAIL.COM",
      "address": "ROSARIO DE PAYA SECTOR PAYA ABAJO CALLE SAN MIGUEL N# 1 ROSARIO DE PAYA",
      "client_identification": "V16131090",
      "nap_box_name": "CTO - 949",
      "created_at": "2025-01-29T16:24:17.045363",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7468,
      "client_name": "ZAIDA MARIA GARCIA MORALES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "SUSPENDIDO_RESIDENCIAL",
      "status_name": "Suspendido",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243256803",
      "client_email": "GARCIAZAIDA558@GMAIL.COM",
      "address": "CALLE 08 CASA Nª575 B  MATA CABALLO",
      "client_identification": "V12656901",
      "nap_box_name": "160",
      "created_at": "2025-02-03T16:55:12.621240",
      "service_detail": {
        "id": 10323,
        "ip": "10.10.195.2",
        "mac": "OEMT3C6246FA",
        "serial": "OEMT3C6246FA",
        "queue": null,
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2025-11-25T13:04:03.884814",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7469,
      "client_name": "TAIMARY TERAN TOVAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243535903",
      "client_email": "TAIMARYTERAN202020@GMAIL.COM",
      "address": "AV2 CASA 2ª 519C MATA CABALLO",
      "client_identification": "V17739565",
      "nap_box_name": "CTO-00567 DOS",
      "created_at": "2025-02-04T09:34:42.845027",
      "service_detail": {
        "id": 7684,
        "ip": "10.10.196.2",
        "mac": "HWTC49200373",
        "serial": "HWTC49200373",
        "queue": "queue1",
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2025-02-04T16:15:43.073705",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7470,
      "client_name": "DEXI MERCEDES LOPEZ AGUIRRE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Arboleda",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243166042",
      "client_email": "DEXILOPEZ79@GMAIL.COM",
      "address": "CALLE INTERCOMUNAL CASA NRO. 36 SECTOR LA ARBOLEDA ROSARIO DE PAYA",
      "client_identification": "V10459325",
      "nap_box_name": "CTO-0610",
      "created_at": "2025-02-04T10:14:34.837163",
      "service_detail": {
        "id": 7683,
        "ip": "10.10.197.2",
        "mac": "HWTC49200367",
        "serial": "HWTC49200367",
        "queue": "Plan_161895_30183_WispHub",
        "interface": "VLAN251_RIO_SECO",
        "created_at": "2025-02-04T16:10:24.436848",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7471,
      "client_name": "MARIAN ALEXANDRA PENA JIMENEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243706553",
      "client_email": "ABBAKADOSH223@GMAIL.COM",
      "address": "MATA CABALLO CALLE 8 NRO.563-A  TURMERO ZONA POSTAL 2115",
      "client_identification": "V31811597",
      "nap_box_name": "CTO-00130",
      "created_at": "2025-02-04T10:34:28.536105",
      "service_detail": {
        "id": 10296,
        "ip": "10.10.198.2",
        "mac": "HWTC49200368",
        "serial": "HWTC49200368",
        "queue": null,
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2025-11-24T15:42:14.559878",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7472,
      "client_name": "GABRIEL JOSE MONTILLA CASTILLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128908378",
      "client_email": "GABOMONTILLART@GMAIL.COM",
      "address": "CALLE CARREÑO EDIF. TORRE 4 PISO 1 APT. 1",
      "client_identification": "V22948625",
      "nap_box_name": "CTO-00032 DOS",
      "created_at": "2025-02-04T10:53:09.186381",
      "service_detail": {
        "id": 13063,
        "ip": "10.10.211.2",
        "mac": "HW:TC:49:20:03:69",
        "serial": "HWTC49200369",
        "queue": null,
        "interface": "VLAN208_NISPERO_OLT1",
        "created_at": "2026-09-22T15:52:12.872985",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7473,
      "client_name": "CLEIDYMAR KAROLINA BORGES TORRES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Palma Real",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243107702",
      "client_email": "CLEIDYMARBORGES15@GMAIL.COM",
      "address": "VIA ROSARIO DE PAYA CALLE 02 CASA 50 LA CABALLERIZA",
      "client_identification": "V30102775",
      "nap_box_name": "CTO-00208",
      "created_at": "2025-02-04T11:38:04.290910",
      "service_detail": {
        "id": 7699,
        "ip": "10.10.213.2",
        "mac": "OEMT3C624636",
        "serial": "OEMT3C624636",
        "queue": "Plan_161895_30183_WispHub",
        "interface": "VLAN244_PALMAREAL",
        "created_at": "2025-02-05T16:46:57.550337",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7474,
      "client_name": "NESTOR SIMON ABDULLAH PERDOMO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Betania",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04127765049",
      "client_email": "NESTORABDULLAH@GMAIL.COM",
      "address": "CALLE 6 CASA NRO.231 BETANIA",
      "client_identification": "V18610567",
      "nap_box_name": "CTO-00426",
      "created_at": "2025-02-04T11:59:54.312594",
      "service_detail": {
        "id": 11315,
        "ip": "10.10.200.2",
        "mac": "HWTC49200374",
        "serial": "HWTC49200374",
        "queue": null,
        "interface": "VLAN255_TERRAZAS_PAYA",
        "created_at": "2026-01-22T15:49:32.156914",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7475,
      "client_name": "WILLIAMS JOSE AZUAJE ROA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04143488301",
      "client_email": "AZUAJEW280@GMAIL.COM",
      "address": "CALLE RICAURTE EDIF. DE GAVI PLANTA BAJA LOCAL 3. Y 4",
      "client_identification": "V6129458",
      "nap_box_name": "CTO-00403",
      "created_at": "2025-02-04T13:27:24.901446",
      "service_detail": {
        "id": 7687,
        "ip": "10.10.201.2",
        "mac": "OEMT3C625106",
        "serial": "OEMT3C625106",
        "queue": "Plan_129889_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2025-02-04T19:30:27.092997",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7476,
      "client_name": "YULEIMA MONTILLA CATAMO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Brisas de Paya",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144790652",
      "client_email": "MONTILLACATAMO@GMAIL.COM",
      "address": "AV. PRINCIPAL BRISAS DE PAYA NRO.8",
      "client_identification": "V16436354",
      "nap_box_name": "CTO-00206",
      "created_at": "2025-02-04T14:01:15.719635",
      "service_detail": {
        "id": 7688,
        "ip": "10.10.202.2",
        "mac": "HWTC49200361",
        "serial": "HWTC49200361",
        "queue": "Plan_161895_30183_WispHub",
        "interface": "VLAN241_BRISAS",
        "created_at": "2025-02-04T19:38:10.257916",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7477,
      "client_name": "NEYMAR ALEXANDRA GRANADILLO AREVALO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Marcelota",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144903603",
      "client_email": "FABYANNAYEDUARDO@GMAIL.COM",
      "address": "CALLE PRINCIPAL CASA NRO.24 LA MARCELOTA",
      "client_identification": "V25501349",
      "nap_box_name": "CTO - 1059",
      "created_at": "2025-02-04T14:30:57.153905",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7478,
      "client_name": "DULBY YUSMARI GONZALEZ FREITES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Canaima",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121471540",
      "client_email": "DULBYGONZALEZFREITES@GMAIL.COM",
      "address": "CALLE NRO. 05 CASA NRO 30 CANAIMA ROSARIO DE PAYA",
      "client_identification": "V18084004",
      "nap_box_name": "359",
      "created_at": "2025-02-04T15:18:49.670116",
      "service_detail": {
        "id": 7690,
        "ip": "10.10.204.2",
        "mac": "HWTC49200363",
        "serial": "HWTC49200363",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN237_CANAIMA",
        "created_at": "2025-02-04T19:48:51.381281",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7479,
      "client_name": "GENESIS EMILIA RANGEL LOPEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Polvorin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04145860178",
      "client_email": "EMILIARANGEL92@GMAIL.COM",
      "address": "CALLE 3 DE MAYO CASA NRO. 19  POLVORIN",
      "client_identification": "V22338208",
      "nap_box_name": "CTO - 991",
      "created_at": "2025-02-04T15:32:39.121437",
      "service_detail": {
        "id": 7691,
        "ip": "10.10.205.2",
        "mac": "HWTC49200371",
        "serial": "HWTC49200371",
        "queue": "Plan_161895_30183_WispHub",
        "interface": "VLAN280_POLVORIN",
        "created_at": "2025-02-04T20:05:04.677092",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7480,
      "client_name": "AMILCAR LEANDRO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Los Nisperos",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04123470186",
      "client_email": "AMILCARLEANDRO12@GMAIL.COM",
      "address": "URB. LOS NISPEROS CALLE LOS MANGOS NRO.9",
      "client_identification": "V30005454",
      "nap_box_name": "CTO-00049",
      "created_at": "2025-02-04T15:51:23.451671",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7481,
      "client_name": "MARIA MORELBA CAMEJO DE CAMEJO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Valle Verde",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04122087918",
      "client_email": "MARIAMORELBA09@GMAIL.COM",
      "address": "CALLE BOLIVAR CASA NRO.33 VALLE VERDE",
      "client_identification": "V6842778",
      "nap_box_name": "CTO - 1061",
      "created_at": "2025-02-04T16:10:57.653066",
      "service_detail": {
        "id": 7693,
        "ip": "10.10.207.2",
        "mac": "HWTC49200366",
        "serial": "HWTC49200366",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN253_VALLE_VERDE",
        "created_at": "2025-02-04T20:22:28.976770",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7482,
      "client_name": "MARISOL DEL CARMEN BURGUILLO ASTUDILLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128706966",
      "client_email": "MARIDUGLECHRIS1@GMAIL.COM",
      "address": "TERRAZAS 2 EDIF. 8 ESCALERA 1 PISO 2",
      "client_identification": "V6181109",
      "nap_box_name": "CTO-00513",
      "created_at": "2025-02-04T16:26:58.303252",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7483,
      "client_name": "RAFAEL ENRIQUE CAZOLA LEON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Cambur",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04249468590",
      "client_email": "JANQUEILIS@GMAIL.COM",
      "address": "CALLE VEGA GRANDE SECTOR EL CAMBUR CASA NRO.47 ROSARIO DE PAYA",
      "client_identification": "V17050087",
      "nap_box_name": "CE-00033",
      "created_at": "2025-02-05T09:54:09.165843",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7484,
      "client_name": "JORGE DANIEL BRICENO GAMEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Jabillar",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128489986",
      "client_email": "JORGEDBG1987@GMAIL.COM",
      "address": "CALLE MARIÑO CASA NRO.0311 URB. JABILLAR TURMERO ZONA POSTAL 2115",
      "client_identification": "V17969363",
      "nap_box_name": "CTO-0552",
      "created_at": "2025-02-05T12:00:53.732854",
      "service_detail": {
        "id": 10728,
        "ip": "10.10.210.2",
        "mac": "HWTC49200380",
        "serial": "HWTC49200380",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2025-12-15T12:30:34.416811",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7485,
      "client_name": "YANDER ALEXANDER NIEVES TOVAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Canaima",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243803388",
      "client_email": "YANDERNIEVES18@GMAIL.COM",
      "address": "CANAIMA CALLE 6 CASA NRO.35 ROSARIO DE PAYA",
      "client_identification": "V24929730",
      "nap_box_name": "356",
      "created_at": "2025-02-05T14:00:51.411021",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7486,
      "client_name": "IRVANI YASILDRY NIZAMA ZAMBRANO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04249617582",
      "client_email": "NIZAMAIRVANI@GMAIL.COM",
      "address": "CONJUNTO RESIDENCIAL LOS CACIQUES EDIF. MEREGOTE APT.3-4",
      "client_identification": "V25901061",
      "nap_box_name": "CTO-0559",
      "created_at": "2025-02-05T15:15:10.538334",
      "service_detail": {
        "id": 13150,
        "ip": "10.10.214.2",
        "mac": "HW:TC:49:20:03:90",
        "serial": "HWTC49200390",
        "queue": null,
        "interface": "VLAN256_CACIQUES_OLT2",
        "created_at": "2026-10-11T20:02:16.767353",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7487,
      "client_name": "MARITZA DE JESUS RESTREPO USMA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Los Hornos",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04228150273",
      "client_email": "RESTREPOMARITZA123@GMAIL.COM",
      "address": "CALLEJON LOS MANGOS CASA NRO.1-2 LOS HORNOS DE PAYA TURMERO ZONA POSTAL 2115",
      "client_identification": "V14241775",
      "nap_box_name": "437",
      "created_at": "2025-02-05T15:35:44.689230",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7488,
      "client_name": "ALEXIS JOSE EREU",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vallecito",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124783653",
      "client_email": "EREUJOSE0206@GMAIL.COM",
      "address": "CALLE ARAGUANEY CASA NRO 40 CALLEJON LAS PIÑAS VALLECITO ROSARIO DE PAYA",
      "client_identification": "V15130019",
      "nap_box_name": "CTO-00062",
      "created_at": "2025-02-05T15:59:43.156691",
      "service_detail": {
        "id": 7702,
        "ip": "10.10.216.2",
        "mac": "OEMT3C6248B2",
        "serial": "OEMT3C6248B2",
        "queue": "Plan_161895_30183_WispHub",
        "interface": "VLAN258_VALLECITO",
        "created_at": "2025-02-05T17:41:50.034932",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7489,
      "client_name": "INVERSIONES CERAMIPEGO CA",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "El Bosque",
      "plan": {
        "id": 38,
        "name": "RECURRENTE PYME PLAN 800M",
        "cost": "110.40",
        "code": "FOP800M",
        "profile": "800M/800M"
      },
      "client_mobile": "04128907125",
      "client_email": "ADMONCERAMIPEGO@GMAIL.COM",
      "address": "AVENIDA INTERCOMUAL LOCAL LOTE E LOCAL NRO 35 CONJUNTO RESIDENCIAL EL BOSQUE LAS RURALES DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "J295598599",
      "nap_box_name": "CE - 851",
      "created_at": "2025-02-05T16:28:34.940280",
      "service_detail": {
        "id": 7703,
        "ip": "10.10.217.2",
        "mac": "OEMT3C6246EA",
        "serial": "OEMT3C6246EA",
        "queue": "Plan_161858_30181_WispHub",
        "interface": "VLAN266_EL_BOSQUE_ZTE",
        "created_at": "2025-02-05T17:44:16.100311",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7490,
      "client_name": "WENDY DELCARMEN LOPEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "1ro de Mayo Sur",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124538498",
      "client_email": "WENDYCLOPEZ2016@GMAIL.COM",
      "address": "PAYA AVENIDA PRINCIPAL PRIMERO DE MAYO SUR CASA S/N",
      "client_identification": "V12171452",
      "nap_box_name": "CTO-00157",
      "created_at": "2025-02-05T16:41:47.540836",
      "service_detail": {
        "id": 7704,
        "ip": "10.10.218.2",
        "mac": "OEMT3C624A1A",
        "serial": "OEMT3C624A1A",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN261_1ERO_MAYO_ZTE",
        "created_at": "2025-02-05T18:08:19.384906",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7491,
      "client_name": "KEILA ENEIDA CASTILLO HERNANDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Durpa",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128050620",
      "client_email": "KEILAENEIDA27CH@GMAIL.COM",
      "address": "FUNDA BARRIO, MANZANA 14, CALLE LIBERTAD  CASA N°31.",
      "client_identification": "V27316996",
      "nap_box_name": "392",
      "created_at": "2025-02-06T14:56:34.049004",
      "service_detail": {
        "id": 7705,
        "ip": "10.10.219.2",
        "mac": "HWTC49200365",
        "serial": "HWTC49200365",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN240_DURPA",
        "created_at": "2025-02-06T15:13:58.360894",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7492,
      "client_name": "REINALDO DAVID LEON VASQUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Valle Verde",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04125692010",
      "client_email": "REINALDOBASQUEZ96@GMAIL.COM",
      "address": "CALLE RICAUTER CASA NRO 90 SECTOR CENTRO DE TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V26791780",
      "nap_box_name": "CE - 691",
      "created_at": "2025-02-07T12:44:25.450516",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7493,
      "client_name": "EDUARDO JAVIER VARGAS TOVAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vallecito",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121483450",
      "client_email": "EDUARDOVARGAS.10.91@GMAIL.COM",
      "address": "CALLE 6 CASA 406 URB MATA CABALLO  ROSARIO DE PAYA",
      "client_identification": "V26791931",
      "nap_box_name": "CTO-00067",
      "created_at": "2025-02-07T13:40:50.124450",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7494,
      "client_name": "ROSARIO SALOME OCHOA AVILES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vallecito",
      "plan": {
        "id": 101,
        "name": "RECURRENTE RESIDENCIAL PLAN 200M",
        "cost": "19.00",
        "code": "FOR200MB",
        "profile": "200Mbps/200Mbps"
      },
      "client_mobile": "04243183003",
      "client_email": "SALOMEOCHOA2020@GMAIL.COM",
      "address": "CALLE LAS PALMAS CASA COLINAS DE VALLECITO NRO 19 URB. ROSARIO DE PAYA ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V10499947",
      "nap_box_name": "CTO - 00395",
      "created_at": "2025-02-07T13:51:44.887962",
      "service_detail": {
        "id": 7712,
        "ip": "10.10.222.2",
        "mac": "OEMT3C62489E",
        "serial": "OEMT3C62489E",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN258_VALLECITO",
        "created_at": "2025-02-07T17:32:10.254974",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7495,
      "client_name": "JOSE MANUEL BRACAMONTE GONZALEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243503454",
      "client_email": "JOSEBRACAMONTE2995@GMAIL.COM",
      "address": "ROSARIO DE PAYA SECTOR RIO SECO CALLE 27 NRO 44",
      "client_identification": "V29676295",
      "nap_box_name": "CTO-00432 DOS",
      "created_at": "2025-02-07T16:02:46.614644",
      "service_detail": {
        "id": 7710,
        "ip": "10.10.223.2",
        "mac": "HWTC49200387",
        "serial": "HWTC49200387",
        "queue": "Plan_161895_30183_WispHub",
        "interface": "VLAN251_RIO_SECO",
        "created_at": "2025-02-07T16:29:58.300838",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7496,
      "client_name": "CARMEN DOLORES CASTILLO BOGADO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Valle Verde",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124614171",
      "client_email": "DANIELAOROPEZA58@GMAIL.COM",
      "address": "AVENIDA PRINCIPAL ROSARIO DE PAYA VALLE VERDE NRO 79",
      "client_identification": "V15129550",
      "nap_box_name": "CE - 704",
      "created_at": "2025-02-07T17:08:17.708271",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7497,
      "client_name": "JEAN CARLOS PEREZ BLANCO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "SUSPENDIDO_RESIDENCIAL",
      "status_name": "Suspendido",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vallecito",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04127766268",
      "client_email": "JEANPEREZ1245@GMAIL.COM",
      "address": "CALLE LA CEIBA CASA NRO 7 VALLECITO ROSARIO DE PAYA",
      "client_identification": "V31997135",
      "nap_box_name": "CTO - 1090",
      "created_at": "2025-02-10T10:56:13.476156",
      "service_detail": {
        "id": 7713,
        "ip": "10.10.225.2",
        "mac": "HWTC48080287",
        "serial": "HWTC48080287",
        "queue": "Plan_161895_30183_WispHub",
        "interface": "VLAN258_VALLECITO",
        "created_at": "2025-02-10T11:43:01.944085",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7498,
      "client_name": "ADONIS JOSE AVILA BRICEÑO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "1ro de Mayo Sur",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04129130093",
      "client_email": "SUNCHINE223@GMAIL.COM",
      "address": "PRIMERO DE MAYO SUR CASA NRO 24 ROARIO DE PAYA",
      "client_identification": "V25662294",
      "nap_box_name": "CE-00064",
      "created_at": "2025-02-10T11:27:04.573367",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7499,
      "client_name": "WUILLIAMS RAMON BETANCOURT BUSCARUIDO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04244537633",
      "client_email": "WILLIAMSB2021@GMAIL.COM",
      "address": "CALLE RIVA EDIF SAN JOSE PISO NRO 2 TURMERO",
      "client_identification": "V10988637",
      "nap_box_name": "CTO-00256",
      "created_at": "2025-02-10T12:06:17.230552",
      "service_detail": {
        "id": 7715,
        "ip": "10.10.227.2",
        "mac": "OEMT3C624696",
        "serial": "OEMT3C624696",
        "queue": "Plan_139897_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2025-02-10T16:01:08.471500",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7500,
      "client_name": "GERMANY ALEJANDRA OVALLES PALENCIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04129808419",
      "client_email": "GERMANYOVALLES@GMAIL.COM",
      "address": "CALLE BOLIVAR CRUCE CON CAMILO TORRES CASA NRO 4 TURMERO",
      "client_identification": "V30211147",
      "nap_box_name": "CE-00009",
      "created_at": "2025-02-10T13:47:04.927544",
      "service_detail": {
        "id": 7716,
        "ip": "10.10.228.2",
        "mac": "OEMT3C624A22",
        "serial": "OEMT3C624A22",
        "queue": "Plan_139897_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2025-02-10T16:11:23.858053",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7501,
      "client_name": "ROSARIO JOSE CARUSO PEÑA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04126478733",
      "client_email": "ROSARIOJOSECARUSOPENA@GMAIL.COM",
      "address": "CALLEJON TRASOLINI NRO4 CALLE CAMILO TORRES TURMERO",
      "client_identification": "V8738743",
      "nap_box_name": "CTO-",
      "created_at": "2025-02-10T15:32:16.217305",
      "service_detail": {
        "id": 7717,
        "ip": "10.10.229.2",
        "mac": "HWTC48080804",
        "serial": "HWTC48080804",
        "queue": "Plan_139897_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2025-02-10T16:14:38.951302",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7502,
      "client_name": "KIMBERLY MORELBYS FERNANDEZ GRANADILO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144453451",
      "client_email": "ORIANYSSILVA506@GMAIL.COM",
      "address": "ROSARIO DE PAYA LOS PRADO 1 CASA NRO 79",
      "client_identification": "V20769147",
      "nap_box_name": "CTO-00211",
      "created_at": "2025-02-10T15:44:43.813286",
      "service_detail": {
        "id": 8490,
        "ip": "10.10.230.2",
        "mac": "HWTC48080790",
        "serial": "HWTC48080790",
        "queue": "queue1",
        "interface": "VLAN239_PRADOS1",
        "created_at": "2025-05-06T14:30:49.133184",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7503,
      "client_name": "RAFAEL ANGEL PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villeguita",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04267425985",
      "client_email": "R63146706@GMAIL.COM",
      "address": "CALLE PARAISO CASA NRO32 UB PLAZA JARDIN VILLEGUITA",
      "client_identification": "V4223226",
      "nap_box_name": "439",
      "created_at": "2025-02-11T14:51:10.505959",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7504,
      "client_name": "FRANYERLI STHEPANY SANDOVAL SANDOVAL",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Canaima",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243093277",
      "client_email": "FRANYERLISTEPHANY25@GMAIL.COM",
      "address": "CALLE 6 NRO 38 URB CANAIMA ROSARIO DE PAYA",
      "client_identification": "V24930111",
      "nap_box_name": "356",
      "created_at": "2025-02-11T15:49:12.739481",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7505,
      "client_name": "ERNESTO ENRIQUE LUCAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Macaro",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04146689119",
      "client_email": "LUKAS784@GMAIL.COM",
      "address": "URB VILLAS EL MACARO CALLE 2 NRO 14 MACARO",
      "client_identification": "V11801719",
      "nap_box_name": "CTO-0X0X0",
      "created_at": "2025-02-12T10:35:09.918673",
      "service_detail": {
        "id": 7724,
        "ip": "10.10.233.2",
        "mac": "HWTC48080291",
        "serial": "HWTC48080291",
        "queue": "Plan_127996_1574_WispHub",
        "interface": "VLAN104_EL_MACARO_OLT_ZTE",
        "created_at": "2025-02-12T13:03:28.939933",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7506,
      "client_name": "EMPRENDIMIENTO YELXA HERNANDEZ",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 102,
        "name": "RECURRENTE PYME PLAN 150M",
        "cost": "27.60",
        "code": "FOP150M",
        "profile": "150Mbps/150Mbps"
      },
      "client_mobile": "04144484933",
      "client_email": "YELXAHERNANDEZJHNAILS@GMAIL.COM",
      "address": "CALLE MIRANDA LOCAL NRO 20-1 CENTRO CASCO CENTRAL TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "J506481693",
      "nap_box_name": "CAJA NAP BICENTENARIO",
      "created_at": "2025-02-12T10:56:16.767351",
      "service_detail": {
        "id": 12497,
        "ip": "172.23.162.2",
        "mac": "80:07:1b:98:0e:6f",
        "serial": "GPON00980E66",
        "queue": null,
        "interface": "VLAN200_OLTs",
        "created_at": "2026-05-15T13:48:40.100990",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7507,
      "client_name": "YULMIRA LISBETH LOPEZ AGUIRRE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Palma Real",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04124792586",
      "client_email": "YULMIRALOPEZ.1975@GMAIL.COM",
      "address": "CALLE 5 CASA NRO 98 PALMA REAL ROSARIO DE PAYA",
      "client_identification": "V13200318",
      "nap_box_name": "403",
      "created_at": "2025-02-12T11:33:58.982170",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7508,
      "client_name": "JAVIER OCTAVIO FREITES URIBE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Macaro",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124618013",
      "client_email": "JFREITES999@GMAIL.COM",
      "address": "CALLE NRO 21 CASA NRO 22 LA ESPRANZA EL MACARO",
      "client_identification": "V15076952",
      "nap_box_name": "555",
      "created_at": "2025-02-12T14:29:42.908326",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7509,
      "client_name": "MARGELYS ALEXANDRA PENALOZA BAYAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Valle Verde",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128945788",
      "client_email": "ENYERVERLP@GMAIL.COM",
      "address": "CALLE BOLIVAR CASA NRO 03 VALLE  VERDE ROSARIO DE PAYA",
      "client_identification": "V15301708",
      "nap_box_name": "CTO-9696",
      "created_at": "2025-02-12T14:57:22.877845",
      "service_detail": {
        "id": 8843,
        "ip": "10.10.237.2",
        "mac": "HWTC48080805",
        "serial": "HWTC48080805",
        "queue": "queue1",
        "interface": "VLAN253_VALLE_VERDE",
        "created_at": "2025-06-04T18:30:13.667513",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7510,
      "client_name": "ARMANDO JAVIER GARCIA GRAFFE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243343940",
      "client_email": "ARMANDOJAVIER2010@GMAIL.COM",
      "address": "PANTIN CALLE  4A CASA NRO 28 ROSARIO DE PAYA",
      "client_identification": "V14060710",
      "nap_box_name": "CTO-00076 DOS",
      "created_at": "2025-02-12T15:42:26.146913",
      "service_detail": {
        "id": 11689,
        "ip": "10.10.238.2",
        "mac": "OEMT3C624706",
        "serial": "OEMT3C624706",
        "queue": null,
        "interface": "VLAN229_PANTIN",
        "created_at": "2026-02-20T11:24:18.692674",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7511,
      "client_name": "UEER ROSALIANO BLANCO SANCHEZ",
      "client_type_name": "INTERCAMBIO",
      "client_subdivision": "ACTIVO_INTERCAMBIO",
      "status_name": "Activo",
      "cycle": 25,
      "migrate": true,
      "sector_name": "Polvorin",
      "plan": {
        "id": 83,
        "name": "RECURRENTE INSTITUCIONAL 80M",
        "cost": "0.00",
        "code": "FO-R80",
        "profile": "80M/80M"
      },
      "client_mobile": "04243179844",
      "client_email": "ALEYDACISNEROS00@GMAIL.COM",
      "address": "CALLE 3 DE MAYO CASA S/N SECTOR POLVORIN TURMERO EDO ARAGUA",
      "client_identification": "G200082554",
      "nap_box_name": "CTO-00354",
      "created_at": "2025-02-12T16:22:07.842859",
      "service_detail": {
        "id": 7732,
        "ip": "10.10.236.2",
        "mac": "HWTC45A04287",
        "serial": "HWTC45A04287",
        "queue": "Plan_162000_30183_WispHub",
        "interface": "VLAN280_POLVORIN",
        "created_at": "2025-02-13T11:36:02.385616",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7512,
      "client_name": "JUNIOR DAGOBERTO RODRIGUEZ HERNANDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "SUSPENDIDO_RESIDENCIAL",
      "status_name": "Suspendido",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243675994",
      "client_email": "RODRIGUEZJHY@GMAIL.COM",
      "address": "SAMAN TARAZONERO II MANZANA B6 NRO 14",
      "client_identification": "V17986544",
      "nap_box_name": "CTO-00511",
      "created_at": "2025-02-12T17:07:17.839675",
      "service_detail": {
        "id": 7735,
        "ip": "10.10.239.2",
        "mac": "HWTC48080294",
        "serial": "HWTC48080294",
        "queue": "Plan_137413_1574_WispHub",
        "interface": "VLAN100_OLTs",
        "created_at": "2025-02-14T08:44:56.117018",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7513,
      "client_name": "AHOSMARY MARLY FONSECA SARRIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "SUSPENDIDO_RESIDENCIAL",
      "status_name": "Suspendido",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121379092",
      "client_email": "AHOSMARYMARY@GMAIL.COM",
      "address": "ROSARIO DE PAYA SECTOR PANTIN CALLE 14 NRO 5 TURMERO EDO ARAGUA",
      "client_identification": "V16764088",
      "nap_box_name": "CTO-00169",
      "created_at": "2025-02-13T13:58:37.845429",
      "service_detail": {
        "id": 7736,
        "ip": "10.10.240.2",
        "mac": "HWTC48080295",
        "serial": "HWTC48080295",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN229_PANTIN",
        "created_at": "2025-02-14T08:48:34.018494",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7514,
      "client_name": "VICENTA MARIA RIVERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243198742",
      "client_email": "DM7212403@GMAIL.COM",
      "address": "CALLE 29 CASA NRO 14 SECTOR RIO SECO",
      "client_identification": "V17742548",
      "nap_box_name": "CTO-00253 DOS",
      "created_at": "2025-02-13T14:05:01.432674",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7520,
      "client_name": "CELESTE DEL CARMEN MARRERO FRANCO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "1ro de Mayo Norte",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128992324",
      "client_email": "CELEMARRERO@GMAIL.COM",
      "address": "CALLE CHACAO CASA NRO 18B SECTOR 1ERO DE MAYO NORTE ROSARIO DE PAYA",
      "client_identification": "V14830875",
      "nap_box_name": "CTO - 900",
      "created_at": "2025-02-14T09:39:21.004185",
      "service_detail": {
        "id": 7739,
        "ip": "10.10.242.2",
        "mac": "ADCGCCA20C5F",
        "serial": "ADCGCCA20C5F",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN261_1ERO_MAYO_ZTE",
        "created_at": "2025-02-14T12:15:20.082916",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7521,
      "client_name": "LAURIANGELA GABRIELA SANCHEZ SARAVIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243336889",
      "client_email": "LAURIANGELASANCHEZ@GMAIL.COM",
      "address": "URB PANTIN CALLE 3B CASA NRO53 ROSARIO DE PAYA",
      "client_identification": "V31000687",
      "nap_box_name": "CE-00043",
      "created_at": "2025-02-14T14:30:21.421949",
      "service_detail": {
        "id": 7740,
        "ip": "10.10.243.2",
        "mac": "OEMT3C62488E",
        "serial": "OEMT3C62488E",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN229_PANTIN",
        "created_at": "2025-02-15T08:07:38.063996",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7522,
      "client_name": "JOVINZON JOSE SILVA CASTILLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Macaro",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121994205",
      "client_email": "PC.SISTEMAS2011@GMAIL.COM",
      "address": "EL MACARO SAMAN TARAZONERO 2 MANZANA B-12 CASA NRO 2",
      "client_identification": "V16504580",
      "nap_box_name": "CTO-00461",
      "created_at": "2025-02-15T13:00:59.622778",
      "service_detail": {
        "id": 10938,
        "ip": "10.10.244.2",
        "mac": "HWTC48080297",
        "serial": "HWTC48080297",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2025-12-25T17:34:50.628496",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7524,
      "client_name": "UENN VALLE VERDE",
      "client_type_name": "INTERCAMBIO",
      "client_subdivision": "ACTIVO_INTERCAMBIO",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Valle Verde",
      "plan": {
        "id": 83,
        "name": "RECURRENTE INSTITUCIONAL 80M",
        "cost": "0.00",
        "code": "FO-R80",
        "profile": "80M/80M"
      },
      "client_mobile": "04126725701",
      "client_email": "VALLEVERDMG2017@GMAIL.COM",
      "address": "CALLE 1 LOCAL NRO S/N SECTOR VALLE VERDE ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "G200036842",
      "nap_box_name": "CTO-9696",
      "created_at": "2025-02-17T15:08:55.228061",
      "service_detail": {
        "id": 7786,
        "ip": "10.12.7.2",
        "mac": "HWTC48220038",
        "serial": "HWTC48220038",
        "queue": "Plan_162000_30183_WispHub",
        "interface": "VLAN253_VALLE_VERDE",
        "created_at": "2025-02-24T14:19:06.638371",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7525,
      "client_name": "JOSE RAMSES SARRIA CABALLERO",
      "client_type_name": "EMPLEADO",
      "client_subdivision": "CANCELADO_EMPLEADO",
      "status_name": "Cancelado",
      "cycle": 25,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 78,
        "name": "Plan empleado 80MB",
        "cost": "0.00",
        "code": "FO-80M",
        "profile": "80M/80M"
      },
      "client_mobile": "04123980076",
      "client_email": "JRSARRIA15@GMAIL.COM",
      "address": "CALLE 3-A CASA NRO 16 URB PANTIN ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V24930113",
      "nap_box_name": "CTO-00127 DOS",
      "created_at": "2025-02-17T17:59:25.322841",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7534,
      "client_name": "WILFREDO ALEJANDRO TOVAR REYES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vallecito",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121798322",
      "client_email": "WILTOREYES456@GMAIL.COM",
      "address": "SECTOR VALLECITO EL MIRADOR CASA 27-1",
      "client_identification": "V27048996",
      "nap_box_name": "Cto-92",
      "created_at": "2025-02-18T08:53:43.928338",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7535,
      "client_name": "MARCO ANTONIO MARTINEZ CALZADILLA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Taguapire",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243206245",
      "client_email": "GT41068@GMAIL.COM",
      "address": "CALLE MARIÑO CASA CALLE 3 NRO 92 URB TAGUAIPIRE TURMERO",
      "client_identification": "V25662901",
      "nap_box_name": "CTO-00386",
      "created_at": "2025-02-18T08:55:35.659729",
      "service_detail": {
        "id": 10501,
        "ip": "10.10.246.2",
        "mac": "ZICGC48614A5",
        "serial": "ZICGC48614A5",
        "queue": null,
        "interface": "VLAN129_TAGUAPIRE_ZTE",
        "created_at": "2025-12-02T17:33:54.273808",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7536,
      "client_name": "CARMEN JULIA SALAZAR CAMPOS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vallecito",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128650203",
      "client_email": "CS.MISHIJOS@GMAIL.COM",
      "address": "VALLECITO CALLE EL ROBLE, CASA NO. 24",
      "client_identification": "V24980168",
      "nap_box_name": "CTO - 84",
      "created_at": "2025-02-18T09:49:34.018522",
      "service_detail": {
        "id": 10135,
        "ip": "10.10.37.2",
        "mac": "HWTC49200383",
        "serial": "HWTC49200383",
        "queue": null,
        "interface": "VLAN258_VALLECITO",
        "created_at": "2025-11-14T14:59:17.973926",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7537,
      "client_name": "CARLOS SIMON GUARATE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Valle Verde",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04261390242",
      "client_email": "DRAMANOCCS@GMAIL.COM",
      "address": "CALLE BOLIVAR CASA NRO 08 VALLE VERDE ROSARIO DE PAYA",
      "client_identification": "V7197777",
      "nap_box_name": "CTO-9696",
      "created_at": "2025-02-18T10:03:43.841820",
      "service_detail": {
        "id": 7752,
        "ip": "10.10.250.2",
        "mac": "ADCGCA8462F3",
        "serial": "ADCGCA8462F3",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN253_VALLE_VERDE",
        "created_at": "2025-02-18T16:49:59.181862",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7538,
      "client_name": "ADOLFO CARLOS BAZAN HERRERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Las Palmas",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121484523",
      "client_email": "BAZANADOLFO454@GMAIL.COM",
      "address": "AV PRINCIPAL ROSARIO DE PAYA CALLE LAS PALMAS CASA NRO 5",
      "client_identification": "V30524725",
      "nap_box_name": "CTO-00098",
      "created_at": "2025-02-18T10:21:41.903654",
      "service_detail": {
        "id": 12209,
        "ip": "10.10.251.2",
        "mac": "OEMT3C624892",
        "serial": "OEMT3C624892",
        "queue": null,
        "interface": "VLAN262_LAS_PALMAS_ZTE",
        "created_at": "2026-03-30T12:08:27.807728",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7539,
      "client_name": "DEIVIS JOSE PENA RAMOS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Naranjal",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243278697",
      "client_email": "PENADEIVIS517@GMAIL.COM",
      "address": "AV PRINCIPAL ROSARIO DE PAYA LA ANTENA CASA NRO 02 GRANJA EL NARANJAL",
      "client_identification": "V13992269",
      "nap_box_name": "cto-00254445",
      "created_at": "2025-02-18T10:39:29.926257",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7540,
      "client_name": "DONALDO ALBERTO LOPEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Antigua Hacienda De Paya",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04149472203",
      "client_email": "DONALDOALBERTO11@GMAIL.COM",
      "address": "ANTIGUA HACIENDA DE PAYA PARCELA",
      "client_identification": "V4996396",
      "nap_box_name": "CTO-00183",
      "created_at": "2025-02-18T11:01:23.738891",
      "service_detail": {
        "id": 7751,
        "ip": "10.10.245.2",
        "mac": "HWTC48080786",
        "serial": "HWTC48080786",
        "queue": "Plan_107915_15811_WispHub",
        "interface": "VLAN202_AHP_OLT1",
        "created_at": "2025-02-18T16:09:35.330310",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7543,
      "client_name": "YUSBEIDE CAROLINA GUERRERO CAMACHO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Las Rurales",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04262375627",
      "client_email": "YUBE.07NO@GMAIL.COM",
      "address": "CALLE NRO 106 CASA NRO 27 LAS RURALES ROSARIO DE PAYA",
      "client_identification": "V18975287",
      "nap_box_name": "CE-660",
      "created_at": "2025-02-19T12:18:30.992870",
      "service_detail": {
        "id": 7775,
        "ip": "10.12.21.2",
        "mac": "HWTC49200614",
        "serial": "HWTC49200614",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN252_RURALES_PAYA",
        "created_at": "2025-02-24T09:05:46.823275",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7544,
      "client_name": "YUBISAY CAROLINA FERNANDEZ GOMEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124611680",
      "client_email": "YUBISAYCAROLINAFERNANDEZGOMEZ@GMAIL.COM",
      "address": "CALLE NRO 1 CASA NRO 21 PRADOS II ROSARIO DE PAYA",
      "client_identification": "V15611342",
      "nap_box_name": "CTO-00118 DOS",
      "created_at": "2025-02-19T13:30:09.254958",
      "service_detail": {
        "id": 12622,
        "ip": "10.10.252.2",
        "mac": "OE:MT:3C:62:46:E6",
        "serial": "OEMT3C6246E6",
        "queue": null,
        "interface": "VLAN242_PRADOS2",
        "created_at": "2026-06-19T12:09:40.542440",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7546,
      "client_name": "MARIA BELEN HERRERA BUSTAMANTE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124617278",
      "client_email": "ADRIANAJOSEFINAPEREZHERRERA@GMAIL.COM",
      "address": "CALLE MANZANA D11 CASA NRO 1 URB SAMAN TARAZONERO II TURMERO",
      "client_identification": "V10269882",
      "nap_box_name": "264",
      "created_at": "2025-02-19T17:12:47.924332",
      "service_detail": {
        "id": 10262,
        "ip": "10.10.253.2",
        "mac": "TPLGB954F708",
        "serial": "TPLGB954F708",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2025-11-22T19:05:30.137948",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7547,
      "client_name": "ANGEL EDUARDO SANTANA HERNANDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243546807",
      "client_email": "EDUARDOANGELSANTANAHERNANDEZ7@GMAIL.COM",
      "address": "MATACABALLO CALLE 5 NRO 309 ROSARIO DE PAYA",
      "client_identification": "V30499231",
      "nap_box_name": "CTO-00179",
      "created_at": "2025-02-20T10:59:07.683823",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7548,
      "client_name": "COMERCIALIZADORA DELICIAS DEL CIELO C.A",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04243294904",
      "client_email": "MARIANTONIETAGIL07@GMAIL.COM",
      "address": "CALLE CRUCES DE LAS CALLES SALIAS Y PETION CASA NRO 31 LOCAL A SECTOR CENTRO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "J502731717",
      "nap_box_name": "CTO-00907",
      "created_at": "2025-02-20T11:32:18.329116",
      "service_detail": {
        "id": 7761,
        "ip": "10.12.5.2",
        "mac": "OEMT3C624692",
        "serial": "OEMT3C624692",
        "queue": "Plan_92292_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2025-02-21T08:43:04.447729",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7549,
      "client_name": "JHONNATA ALFREDO MORALES CANIZALES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vallecito",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121489287",
      "client_email": "jhonnatanm394@gmail.com",
      "address": "ROSARIO DE PAYA SECTOR VALECITO CALLE ARAGUANEY CASA NRO 15",
      "client_identification": "V15863042",
      "nap_box_name": "CTO - 1061",
      "created_at": "2025-02-20T13:04:16.026948",
      "service_detail": {
        "id": 7776,
        "ip": "10.12.11.2",
        "mac": "HWTC49200621",
        "serial": "HWTC49200621",
        "queue": "Plan_161900_30183_WispHub",
        "interface": "VLAN258_VALLECITO",
        "created_at": "2025-02-24T09:07:57.587520",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7550,
      "client_name": "ENGELY GENIRETH SEQUERA ESCOBAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Valle Verde",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243045367",
      "client_email": "ENGELYSSEQUERA@GMAIL.COM",
      "address": "CALLE SUCRE CRUCE CON CALLE BOLIVAR CASA NRO 08 VALLE VERDE ROSARIO DE PAYA",
      "client_identification": "V23783354",
      "nap_box_name": "CTO-9696",
      "created_at": "2025-02-20T13:43:10.747033",
      "service_detail": {
        "id": 7777,
        "ip": "10.12.12.2",
        "mac": "HWTC49200605",
        "serial": "HWTC49200605",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN253_VALLE_VERDE",
        "created_at": "2025-02-24T09:10:58.837010",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7551,
      "client_name": "ZORELYS YENIREETT ARAUJO GRATEROL",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vallecito",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128875801",
      "client_email": "ARAUJOZORELYS@GMAIL.COM",
      "address": "CALLE LA CEIBA CASA NRO 28 VALECITO ROSARIO DE PAYA",
      "client_identification": "V18852928",
      "nap_box_name": "CTO-00081",
      "created_at": "2025-02-20T14:15:28.611024",
      "service_detail": {
        "id": 7778,
        "ip": "10.12.13.2",
        "mac": "HWTC49200604",
        "serial": "HWTC49200604",
        "queue": "Plan_161900_30183_WispHub",
        "interface": "VLAN258_VALLECITO",
        "created_at": "2025-02-24T09:13:37.712213",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7559,
      "client_name": "GISELA MATILDE COBOS BOGADO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Naranjal",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243001447",
      "client_email": "GISELABOGADO123@GMAIL.COM",
      "address": "CALLE LA ESPERANZA CASA NRO 3 GRANJA EL NARANJAL ROSARIO DE PAYA",
      "client_identification": "V15601950",
      "nap_box_name": "597",
      "created_at": "2025-02-21T10:35:15.024536",
      "service_detail": {
        "id": 7779,
        "ip": "10.12.26.2",
        "mac": "HWTC49200628",
        "serial": "HWTC49200628",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN246_NARANJAL",
        "created_at": "2025-02-24T09:20:04.761156",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7560,
      "client_name": "GLEIMAR GEOVANINA ALBARRAN BELISARIO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vallecito",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121481075",
      "client_email": "BELISARIOGLEIMAR3@GMAIL.COM",
      "address": "CALLE LOS NARANJOS CASA NRO21 VALLECCITO ROSARIO DE PAYA",
      "client_identification": "V25501460",
      "nap_box_name": "CTO-00082",
      "created_at": "2025-02-21T11:03:52.812950",
      "service_detail": {
        "id": 7763,
        "ip": "10.12.4.2",
        "mac": "HWTC88831985",
        "serial": "HWTC88831985",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN258_VALLECITO",
        "created_at": "2025-02-21T13:57:29.597041",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7561,
      "client_name": "SAMUEL ADONIRAN GARCIA GILLARTE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Valle Fresco",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04126814067",
      "client_email": "PROFESORSAMUELFISICA@GMAIL.COM",
      "address": "URB VALLE FRESCO MANZANA D NRO 24 TURMERO EDO ARAGUA",
      "client_identification": "V12853810",
      "nap_box_name": "CTO - 1105",
      "created_at": "2025-02-21T16:11:05.845848",
      "service_detail": {
        "id": 7780,
        "ip": "10.12.14.2",
        "mac": "HWTC49200617",
        "serial": "HWTC49200617",
        "queue": "queue1",
        "interface": "VLAN270_VALLE_FRESCO_OLT3",
        "created_at": "2025-02-24T09:40:07.899093",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7562,
      "client_name": "MICHEL CAROLAY BENAVENTE GARBOZA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04145983549",
      "client_email": "ESNEIDABENAVENTE42@GMAIL.COM",
      "address": "URB MATACABALLO CALLE 6 NRO 426 ROSARIO DE PAYA",
      "client_identification": "V29808983",
      "nap_box_name": "CTO-00031",
      "created_at": "2025-02-21T16:31:55.039988",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7563,
      "client_name": "WILLIAMS ALBERTO CHIRINOS MEJIAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vallecito",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128867543",
      "client_email": "NAYBELIS-1994@HOTMAIL.COM",
      "address": "VALLECITO CALLE EL SAMAN CRUCE CON EL SAMAN NRO 03 ROSARIO DE PAYA",
      "client_identification": "V24445218",
      "nap_box_name": "CTO - 1061",
      "created_at": "2025-02-21T16:43:28.585161",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7564,
      "client_name": "GENESIS CATHERINE ZERPA GARCIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Valle lindo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04120251556",
      "client_email": "GARCIA.CATHERINE2708@GMAIL.COM",
      "address": "SECTOR 3 CALLE NRO 13 CASA NRO  VALLE LINDO TURMERO",
      "client_identification": "V27544166",
      "nap_box_name": "CTO-VL",
      "created_at": "2025-02-21T17:09:16.865196",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7565,
      "client_name": "YANIRI DEL VALLE CARDONA BOLIVAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Arboleda",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04123989533",
      "client_email": "CARDONAYANIRA43@GMAIL.COM",
      "address": "CALLE LOS COCOS CASA NRO 50 ARBOLEDA ROSARIO DE PAYA",
      "client_identification": "V22948862",
      "nap_box_name": "CTO-00236",
      "created_at": "2025-02-21T17:22:45.552457",
      "service_detail": {
        "id": 7783,
        "ip": "10.12.17.2",
        "mac": "OEMT3C62462A",
        "serial": "OEMT3C62462A",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN257_ARBOLEDA",
        "created_at": "2025-02-24T10:08:22.197959",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7566,
      "client_name": "VICENTDEIBYS JOSE ALVAREZ ROJAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "SUSPENDIDO_RESIDENCIAL",
      "status_name": "Suspendido",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04247637654",
      "client_email": "HAYEKESPINA@GMAIL.COM",
      "address": "CALLE 3A CASA # 22 PANTIN",
      "client_identification": "V26904527",
      "nap_box_name": "CTO-00127 DOS",
      "created_at": "2025-02-23T11:36:02.821144",
      "service_detail": {
        "id": 13049,
        "ip": "10.12.22.2",
        "mac": "JM:KG:F3:94:80:CD",
        "serial": "JMKGF39480CD",
        "queue": null,
        "interface": "VLAN229_PANTIN",
        "created_at": "2026-09-20T12:07:14.227610",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7567,
      "client_name": "YELISMAR DANIUSKA LANDAETA BRITO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Luz y Vida",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04126059589",
      "client_email": "luisalbertoortizherrera6@gmail.com",
      "address": "CALLE 3 CASA # 181 SECTOR LUZ Y VIDA",
      "client_identification": "V24446764",
      "nap_box_name": "CTO-00308",
      "created_at": "2025-02-23T12:07:10.774612",
      "service_detail": {
        "id": 11310,
        "ip": "10.11.231.2",
        "mac": "OEMT3C624622",
        "serial": "OEMT3C624622",
        "queue": null,
        "interface": "VLAN264_LUZYVIDA_ZTE",
        "created_at": "2026-01-22T13:37:12.216043",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7568,
      "client_name": "ONARVIS COROMOTO BLANCO LOZADA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04125972273",
      "client_email": "BLANCOALEXA792@GMAIL.COM",
      "address": "CALLE 13A # 15 PANTIN",
      "client_identification": "V129670300",
      "nap_box_name": "CTO-00170",
      "created_at": "2025-02-23T12:52:44.610783",
      "service_detail": {
        "id": 7768,
        "ip": "10.12.23.2",
        "mac": "HWTC49200601",
        "serial": "HWTC49200601",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN229_PANTIN",
        "created_at": "2025-02-23T12:54:09.827670",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7569,
      "client_name": "JOHANA YULIBETH FERNANDEZ VAZQUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04242878063",
      "client_email": "CAROLINEYMILAGROS18@GMAIL.COM",
      "address": "CALLE 13A CASA NUMERO 4 PANTIN",
      "client_identification": "V18270774",
      "nap_box_name": "CTO-00170",
      "created_at": "2025-02-23T13:06:33.836559",
      "service_detail": {
        "id": 7772,
        "ip": "10.12.25.2",
        "mac": "HWTC49200630",
        "serial": "HWTC49200630",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN229_PANTIN",
        "created_at": "2025-02-23T14:29:19.647930",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7570,
      "client_name": "MIRIAM DEL CARMEN RODRIGUEZ VALLADARES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Canaima",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124019901",
      "client_email": "COSITAMIDIOS69@GMAIL.COM",
      "address": "SECTOR CANAIMA PRADOS CALLE 4 # 16",
      "client_identification": "V9671600",
      "nap_box_name": "CTO-00315 ",
      "created_at": "2025-02-23T13:17:46.822492",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7571,
      "client_name": "RONNY JOSE PEREZ RUIZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Terrazas de Paya",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04122996474",
      "client_email": "JARDINERIARONNY@GMAIL.COM",
      "address": "MANZANA 3 CASA # 1 SECTOR TERRAZAS DE PAYA",
      "client_identification": "V24815528",
      "nap_box_name": "0165",
      "created_at": "2025-02-23T13:26:08.281138",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7572,
      "client_name": "RUTHSIRYS YASMIN FERNANDEZ BRICEÑO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04143585081",
      "client_email": "RUTHSIRYSFERNANDEZ@GMAIL.COM",
      "address": "CALLE 15B CASA S/N PANTIN",
      "client_identification": "V20127763",
      "nap_box_name": "CTO-00201",
      "created_at": "2025-02-23T13:38:08.543335",
      "service_detail": {
        "id": 7771,
        "ip": "10.12.20.2",
        "mac": "HWTC48080288",
        "serial": "HWTC48080288",
        "queue": "Plan_107915_30181_WispHub",
        "interface": "VLAN229_PANTIN",
        "created_at": "2025-02-23T13:39:09.247742",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7574,
      "client_name": "CARLOS JAVIER DUQUE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Guerito",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04121478591",
      "client_email": "CARLOSDUQUE890@GMAIL.COM",
      "address": "CALLE 03 CASA NRO 75 LA CONCEPCION 3 TURMERO",
      "client_identification": "V9674012",
      "nap_box_name": "CTO-00456",
      "created_at": "2025-02-24T10:35:55.594645",
      "service_detail": {
        "id": 7784,
        "ip": "10.12.8.2",
        "mac": "OEMT3C62494E",
        "serial": "OEMT3C62494E",
        "queue": "Plan_148293_24341_WispHub",
        "interface": "VLAN136_CONCEPCION_3",
        "created_at": "2025-02-24T11:25:06.904196",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7575,
      "client_name": "GABRIEL EDUARDO TOMAS ORELLANA LINARES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Antigua Hacienda De Paya",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128151572",
      "client_email": "ORELLANAGABRIEL7385@GMAIL.COM",
      "address": "AVENIDA PRINCIPAL DE PAYA CASA NRO A1 ANTIGUA HACIENDA DE PAYA",
      "client_identification": "V16301092",
      "nap_box_name": "CTO-00218 ",
      "created_at": "2025-02-24T10:49:30.128701",
      "service_detail": {
        "id": 12305,
        "ip": "10.12.9.2",
        "mac": "OEMT3C624B4A",
        "serial": "OEMT3C624B4A",
        "queue": null,
        "interface": "VLAN201_AHP2_OLT1",
        "created_at": "2026-04-11T18:56:03.236925",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7577,
      "client_name": "FRANCIA ELIZABETH GONZALEZ CASTILLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04120280186",
      "client_email": "diolexygonzalez@gmail.com",
      "address": "PANTIN CALLE 13A CASA NRO 6 ROSARIO DE PAYA",
      "client_identification": "V9691088",
      "nap_box_name": "CTO-00170",
      "created_at": "2025-02-24T11:48:56.864242",
      "service_detail": {
        "id": 7788,
        "ip": "10.12.24.2",
        "mac": "HWTC4C3496AF",
        "serial": "HWTC4C3496AF",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN229_PANTIN",
        "created_at": "2025-02-24T16:32:33.262395",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7578,
      "client_name": "ANDRIANY GABRIELA MUSCARA MALAVE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121479806",
      "client_email": "MUSCARALIBETT2015@GMAIL.COM",
      "address": "ROSARIO DE PAYA PANTIN CALLE 2B CASA NRO44",
      "client_identification": "V28432850",
      "nap_box_name": "CTO-00126",
      "created_at": "2025-02-24T14:44:53.992138",
      "service_detail": {
        "id": 7787,
        "ip": "10.12.19.2",
        "mac": "HWTC49200623",
        "serial": "HWTC49200623",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN229_PANTIN",
        "created_at": "2025-02-24T15:16:35.596962",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7579,
      "client_name": "CHAQUIRA COROMOTO LOPEZ HERNANDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "1ro de Mayo Norte",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04168643237",
      "client_email": "CHAQUIRALOPEZ123@GMAIL.COM",
      "address": "AV VISTA ALEGRE CASA NRO 10 SECTOR PRIMERO DE MAYO NORTE ROSARIO DE PAYA",
      "client_identification": "V27911099",
      "nap_box_name": "CTO-00225",
      "created_at": "2025-02-24T16:40:40.626049",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7580,
      "client_name": "CONSEJO EDUCATIVO UEER ALFONZO RIVAS",
      "client_type_name": "INTERCAMBIO",
      "client_subdivision": "ACTIVO_INTERCAMBIO",
      "status_name": "Activo",
      "cycle": 25,
      "migrate": true,
      "sector_name": "Vallecito",
      "plan": {
        "id": 83,
        "name": "RECURRENTE INSTITUCIONAL 80M",
        "cost": "0.00",
        "code": "FO-R80",
        "profile": "80M/80M"
      },
      "client_mobile": "04267332724",
      "client_email": "nidia49zambrano@gmail.com",
      "address": "CALLE ARAGUANEY ROSARIO DE PAYA CASERIO COLINAS DE VALLECITO ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "J409726517",
      "nap_box_name": "CTO-00062",
      "created_at": "2025-02-24T17:22:07.713132",
      "service_detail": {
        "id": 7790,
        "ip": "10.12.28.2",
        "mac": "HWTC49200624",
        "serial": "HWTC49200624",
        "queue": "Plan_162000_30183_WispHub",
        "interface": "VLAN258_VALLECITO",
        "created_at": "2025-02-25T08:08:21.547710",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7583,
      "client_name": "ORINNY ALEXANDRA PENA BLANCO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04267648024",
      "client_email": "ROMEROERUIN90@GMAIL.COM",
      "address": "PANTIN CALLE 13A CASA NRO25 ROSARIO DE PAYA",
      "client_identification": "V27425456",
      "nap_box_name": "CTO-00170",
      "created_at": "2025-02-25T10:40:14.374274",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7584,
      "client_name": "EMMA JOSEFINA MOTA GONZALEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "SUSPENDIDO_RESIDENCIAL",
      "status_name": "Suspendido",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128999424",
      "client_email": "EMMAMOTA474@GMAIL.COM",
      "address": "ROSARIO DE PAYA SECTOR RIO SECO CALLE 23 CASA NRO 59",
      "client_identification": "V10788748",
      "nap_box_name": "CTO-00033",
      "created_at": "2025-02-25T11:19:15.474003",
      "service_detail": {
        "id": 7794,
        "ip": "10.12.34.2",
        "mac": "A8BF3C62473D",
        "serial": "OEMT3C62473E",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN251_RIO_SECO",
        "created_at": "2025-02-25T12:20:31.498401",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7585,
      "client_name": "IRIS COROMOTO TREJO DE GONZALEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Valle Verde",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243386282",
      "client_email": "SANTIAGOMAGALLANEZ677@GMAIL.COM",
      "address": "CALLE BOLIVAR CASA NRO 04 VALLE VERDE ROSARIO DE PAYA",
      "client_identification": "V8816763",
      "nap_box_name": "CTO-9696",
      "created_at": "2025-02-25T12:29:34.787406",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7586,
      "client_name": "JOSE ALFREDO CASTELLANOS CARVAJAL",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Valle Fresco",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04127592871",
      "client_email": "ALFREDCASTELLANOS@HOTMAIL.COM",
      "address": "URBA VALLE FRESCO MANZANA NRO 11 TURMERO",
      "client_identification": "V5425879",
      "nap_box_name": "CTO-VA",
      "created_at": "2025-02-26T09:05:25.290216",
      "service_detail": {
        "id": 12380,
        "ip": "10.12.37.2",
        "mac": "HWTC49200618",
        "serial": "HWTC49200618",
        "queue": null,
        "interface": "VLAN270_VALLE_FRESCO_OLT3",
        "created_at": "2026-04-20T13:06:55.565852",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7587,
      "client_name": "DALMARYS CAROLINA TORREALBA GARCIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124699348",
      "client_email": "KAROLTORRE90@GMAIL.COM",
      "address": "AV PRINCIPAL ALCALDIA PISO PLANTA BAJA TESORERIA",
      "client_identification": "V20118834",
      "nap_box_name": "110",
      "created_at": "2025-02-26T10:35:29.800281",
      "service_detail": {
        "id": 13128,
        "ip": "10.12.38.2",
        "mac": "OE:MT:3C:62:54:76",
        "serial": "OEMT3C625476",
        "queue": null,
        "interface": "VLAN200_OLTs",
        "created_at": "2026-10-07T08:44:02.926538",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7588,
      "client_name": "MARIELA DEL VALLE AZUAJE HERNANDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Laguna Plaza",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243359391",
      "client_email": "MARIELAAZUAJE9@GMAIL.COM",
      "address": "LAGUNA PLAZA 1 EDIFICIO 10 TURMERO EDO ARAGUA",
      "client_identification": "V15601214",
      "nap_box_name": "4",
      "created_at": "2025-02-26T16:17:01.685867",
      "service_detail": {
        "id": 7858,
        "ip": "10.12.39.2",
        "mac": "OEMT3C624BDE",
        "serial": "OEMT3C624BDE",
        "queue": "Plan_92194_15811_WispHub",
        "interface": "VLAN216_LAGUNA_PLAZA_OLT1",
        "created_at": "2025-03-06T17:36:21.681394",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7589,
      "client_name": "JOSE LUIS LUNA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Guayabita",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243033007",
      "client_email": "ARACELISANDRADE791@GMAIL.COM",
      "address": "GUAYABITA PARCELA NRO 06 LOS HICACOS",
      "client_identification": "V4542994",
      "nap_box_name": "CE - 818",
      "created_at": "2025-02-26T16:27:36.470544",
      "service_detail": {
        "id": 8501,
        "ip": "10.12.40.2",
        "mac": "CDTC1D437557",
        "serial": "CDTC1D437557",
        "queue": "queue1",
        "interface": "VLAN282_ZONA_AGRARIA",
        "created_at": "2025-05-06T20:20:02.912811",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7590,
      "client_name": "NIDIA SOFIA ZAMBRANO PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04267332724",
      "client_email": "NIDIA49ZAMBRANO@GMAIL.COM",
      "address": "ROSARIO DE PAYA SECTOR RIO SECO CALLE 7 NRO 18",
      "client_identification": "V7270682",
      "nap_box_name": "CTO-0610",
      "created_at": "2025-02-27T09:38:57.660730",
      "service_detail": {
        "id": 7801,
        "ip": "10.12.36.2",
        "mac": "HWTC572FFA71",
        "serial": "HWTC572FFA71",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN251_RIO_SECO",
        "created_at": "2025-02-27T10:19:53.616582",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7591,
      "client_name": "CANDY BERTH ROSARIO MARTINEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vallecito",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128673104",
      "client_email": "CANROSARI22@GMAIL.COM",
      "address": "ROSARIO DE PAYA SECTOR VALLECITO CALLE LA ACASIA CASA NRO 06",
      "client_identification": "V25349817",
      "nap_box_name": "CTO-00VALLEC",
      "created_at": "2025-02-27T10:40:10.184162",
      "service_detail": {
        "id": 9676,
        "ip": "10.12.42.2",
        "mac": "OEMT3C62485A",
        "serial": "OEMT3C62485A",
        "queue": null,
        "interface": "VLAN258_VALLECITO",
        "created_at": "2025-11-04T08:16:36.438903",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7592,
      "client_name": "ROSAURA MARGARITA GALARRAGA RAMOS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "1ro de Mayo Sur",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04143724577",
      "client_email": "ROSAURAGALARRAGA@HOTMAIL.COM",
      "address": "AV PRINCIPAL ROSARIO DE PAYA CASA NRO 28",
      "client_identification": "V11559294",
      "nap_box_name": "CTO-00098",
      "created_at": "2025-02-27T12:03:58.428802",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7593,
      "client_name": "CRUZ DEL VALLE MARTINEZ BELLADARE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vallecito",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04125204666",
      "client_email": "CRUMAR9@GMAIL.COM",
      "address": "VALLECITO CALLE EL CUJI CASA NRO 22 ROSARIO DE PAYA",
      "client_identification": "V5892244",
      "nap_box_name": "CTO-00081",
      "created_at": "2025-02-27T12:24:01.524633",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7594,
      "client_name": "EDULIN SUSANA GONZALEZ VALLADARES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vallecito",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04263345340",
      "client_email": "EDULINGV@GMAIL.COM",
      "address": "VALLECITO CALLE LA SEIBA CASA NRO 25 ROSARIO DE PAYA",
      "client_identification": "V18165642",
      "nap_box_name": "CTO-00081",
      "created_at": "2025-02-27T12:42:15.709754",
      "service_detail": {
        "id": 12746,
        "ip": "10.12.44.2",
        "mac": "68:9f:f0:2a:95:7f",
        "serial": "ZXICCDDC3339",
        "queue": null,
        "interface": "VLAN258_VALLECITO",
        "created_at": "2026-07-17T11:47:39.655674",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7595,
      "client_name": "MELVIN JOSE FLORES TORREALBA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vallecito",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04160721294",
      "client_email": "VERONICAALEMR@GMAIL.COM",
      "address": "VALLECITO CALLE EL CUJI CASA NRO 17-3 ROSARIO DE PAYA",
      "client_identification": "V25527605",
      "nap_box_name": "CTO - 81",
      "created_at": "2025-02-27T13:06:51.843996",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7596,
      "client_name": "ELVIA DAMARYS FLORES TORREALBA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vallecito",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04129374458",
      "client_email": "OSMEILYOSCARINAFUNEZ1994@GMAIL.COM",
      "address": "ROSARIO DE PAYA SECTOR VALLECITO CALLE EL BAMBU CASA NRO 17",
      "client_identification": "V22948366",
      "nap_box_name": "ct0-00vall",
      "created_at": "2025-02-27T13:23:54.405221",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7597,
      "client_name": "OMAIRA ROMANA MAGALLANES DE MORA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Luz y Vida",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04122052811",
      "client_email": "VICTORIACARINETMORA@GMAIL.COM",
      "address": "AV PRINCIPAL ROSARIO DE PAYA CASA NRO 14 SECTOR LUZ Y VIDA",
      "client_identification": "V6251440",
      "nap_box_name": "CTO-00057 DOS",
      "created_at": "2025-02-27T13:42:46.913905",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7598,
      "client_name": "GILBERTO ABRAHAM RIERA SILVA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243454730",
      "client_email": "GILBERTORIERA7@GMAIL.COM",
      "address": "CALLE NRO 09 CASA NRO 24 RIO SECO ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V17984268",
      "nap_box_name": "CE - 600",
      "created_at": "2025-02-28T16:18:55.344587",
      "service_detail": {
        "id": 11612,
        "ip": "10.12.50.2",
        "mac": "OEMT3C6250DE",
        "serial": "OEMT3C6250DE",
        "queue": null,
        "interface": "VLAN251_RIO_SECO",
        "created_at": "2026-02-14T13:23:06.566348",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7599,
      "client_name": "BETZABETH MARRERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "1ro de Mayo Sur",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04125830080",
      "client_email": "BETSABEDESEGOVIA@GMAIL.COM",
      "address": "PRIMERO DE MAYO SUR, CALLE SAN MIGUEL NO 13",
      "client_identification": "V10870013",
      "nap_box_name": "CTO - 906",
      "created_at": "2025-02-28T16:37:34.984901",
      "service_detail": {
        "id": 7857,
        "ip": "10.12.60.2",
        "mac": "HWTC24A9E190",
        "serial": "HWTC24A9E190",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN261_1ERO_MAYO_ZTE",
        "created_at": "2025-03-06T16:05:44.990964",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7600,
      "client_name": "FELIX RAMON HERNANDEZ ARTEAGA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Durpa",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124314098",
      "client_email": "JASON06.NEILL@GMAIL.COM",
      "address": "CALLE ARAGUANEY CASA 3 PB",
      "client_identification": "V9652489",
      "nap_box_name": "CTO-00446",
      "created_at": "2025-02-28T17:42:52.273745",
      "service_detail": {
        "id": 7815,
        "ip": "10.12.52.2",
        "mac": "HWTC49200346",
        "serial": "HWTC49200346",
        "queue": "Plan_107915_30181_WispHub",
        "interface": "VLAN240_DURPA",
        "created_at": "2025-02-28T20:13:05.847235",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7601,
      "client_name": "KARINA YESENIA GUZMAN GUTIERREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Bicentenario",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04142959908",
      "client_email": "KKARINAGUZ790@GMAIL.COM",
      "address": "BICENTENARIO CALLE SIMON RODRIGUEZ CASA PA 17  ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V16434790",
      "nap_box_name": "CTO-00297",
      "created_at": "2025-02-28T18:19:43.568772",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7602,
      "client_name": "CARMEN AMERICA ESCOBAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Bicentenario",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128871485",
      "client_email": "C.ESCOBAR1801@GMAIL.COM",
      "address": "MANZANA 12 PLANTA BAJA 1 CALLE LOS ROBLES BICENTENARIO  ZONA POSTAL 2115",
      "client_identification": "V6937377",
      "nap_box_name": "381",
      "created_at": "2025-02-28T18:30:09.769708",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7603,
      "client_name": "JORGE LUIS CHIRINOS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Canaima",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243156276",
      "client_email": "CHIRINOSJORGE685@GMAIL.COM",
      "address": "CANAIMA CALLE 04 CASA NRO 30 ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V9430772",
      "nap_box_name": "CTO-00315 ",
      "created_at": "2025-02-28T18:58:35.169400",
      "service_detail": {
        "id": 7817,
        "ip": "10.12.48.2",
        "mac": "HWTC5D59FA91",
        "serial": "HWTC5D59FA91",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN237_CANAIMA",
        "created_at": "2025-03-01T08:52:49.054279",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7604,
      "client_name": "BRIAN RAMIREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vallecito",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04127424430",
      "client_email": "JESUSBIGOTE.18@GMAIL.COM",
      "address": "ROSARIO DE PAYA SECTOR VALLECITO CALLE LAS ACACIAS CASA NRO 21",
      "client_identification": "V30658863",
      "nap_box_name": "CTO - 99",
      "created_at": "2025-03-01T10:40:58.962025",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7605,
      "client_name": "MERCEDES MARIELA LEDEZMA BARRIOS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Canaima",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243799088",
      "client_email": "MECHEMARIELA1986@GMAIL.COM",
      "address": "CALLE NRO CASA  SECTOR CANAIMA ROSARIO DE PAYA",
      "client_identification": "V17272607",
      "nap_box_name": "CTO-00315 ",
      "created_at": "2025-03-01T12:11:37.150887",
      "service_detail": {
        "id": 7828,
        "ip": "10.12.67.2",
        "mac": "HWTCFAABC348",
        "serial": "HWTCFAABC348",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN237_CANAIMA",
        "created_at": "2025-03-02T19:33:31.352974",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7607,
      "client_name": "ASAL AMINADA JIMENEZ HERNANDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Bicentenario",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243439608",
      "client_email": "ASALJIMENEZ6@GMAIL.COM",
      "address": "CALLE ARAGUANEY MANZANA C CASA # 16",
      "client_identification": "V17849118",
      "nap_box_name": "CTO-00446",
      "created_at": "2025-03-01T12:47:16.985244",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7609,
      "client_name": "MARCEL BENEDICTO BLANCO BARRIO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "1ro de Mayo Sur",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04122998937",
      "client_email": "BLANCOMARCEL97@GMAIL.COM",
      "address": "PRIMERO DE MAYO SUR CALLE 1 CASA NRO 13 ROSARIO DE PAYA",
      "client_identification": "V15712194",
      "nap_box_name": "CTO - 00398",
      "created_at": "2025-03-01T13:00:03.152807",
      "service_detail": {
        "id": 7831,
        "ip": "10.12.59.2",
        "mac": "OEMT3C624B96",
        "serial": "OEMT3C624B96",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN261_1ERO_MAYO_ZTE",
        "created_at": "2025-03-05T08:39:57.929647",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7610,
      "client_name": "MARITZA YANET BONILLA RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121952835",
      "client_email": "BONILLAMARITZA848@GMAIL.COM",
      "address": "ROSARIO DE PAYA PANTIN CALLE 7B CASA NRO 31",
      "client_identification": "V6170659",
      "nap_box_name": "CTO-00140",
      "created_at": "2025-03-01T13:09:39.510089",
      "service_detail": {
        "id": 7829,
        "ip": "10.12.68.2",
        "mac": "OEMT3C624BD2",
        "serial": "OEMT3C624BD2",
        "queue": "Plan_107915_30181_WispHub",
        "interface": "VLAN229_PANTIN",
        "created_at": "2025-03-03T11:24:55.854586",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7611,
      "client_name": "ZULVIMAR VALENTINA REQUENA GOMEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Bicentenario",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04125973262",
      "client_email": "ZULVIMARIP22024@GMAIL.COM",
      "address": "BICENTENARIO CALLE SIMON RODRIGUEZ CASA PB16",
      "client_identification": "V30705285",
      "nap_box_name": "379",
      "created_at": "2025-03-01T13:24:24.805057",
      "service_detail": {
        "id": 10936,
        "ip": "10.12.53.2",
        "mac": "HWTC49200619",
        "serial": "HWTC49200619",
        "queue": null,
        "interface": "VLAN243_BICENTENARIO",
        "created_at": "2025-12-25T15:00:48.816490",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7612,
      "client_name": "JACQUELINE FLORES GONZALEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144634672",
      "client_email": "YAKELINFLORES40@GMAIL.COM",
      "address": "ROSARIO DE PAYA SECTOR RIO SECO CALLE 13 NRO 21",
      "client_identification": "V10752591",
      "nap_box_name": "CTO-00423",
      "created_at": "2025-03-01T13:42:24.594680",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7613,
      "client_name": "BEATRIZ RINCON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Durpa",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243262626",
      "client_email": "RINCONBEATRIZ0982@GMAIL.COM",
      "address": "DURPA CALLE LOS ROBLES MANZANA 10 NRO 16 ROSARIO DE PAYA",
      "client_identification": "V15533316",
      "nap_box_name": "CTO-00445",
      "created_at": "2025-03-01T13:51:18.045969",
      "service_detail": {
        "id": 9681,
        "ip": "10.12.65.2",
        "mac": "HWTC49200150",
        "serial": "HWTC49200150",
        "queue": null,
        "interface": "VLAN243_BICENTENARIO",
        "created_at": "2025-11-04T10:14:50.326201",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7614,
      "client_name": "ANDRES ANTONIO RODRIGUEZ AGUACHE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Durpa",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04163141931",
      "client_email": "ANDRESRODRIGUES484@GMAIL.COM",
      "address": "DURPA CALLE LOS ROBLES PB NRO 005 ROSARIO DE PAYA",
      "client_identification": "V9641957",
      "nap_box_name": "CTO-00445",
      "created_at": "2025-03-01T13:58:41.568005",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7616,
      "client_name": "DORIS MARIA FIGUEROA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "1ro de Mayo Norte",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121404197",
      "client_email": "FIGUEROADORIS750@GMAIL.COM",
      "address": "PRIMERO DE MAYO NORTE CALLE LARA NRO 31 ROSARIO DE PAYA",
      "client_identification": "V11437177",
      "nap_box_name": "CTO-00458",
      "created_at": "2025-03-05T10:12:02.328878",
      "service_detail": {
        "id": 7832,
        "ip": "10.12.58.2",
        "mac": "OEMT3C6249D6",
        "serial": "OEMT3C6249D6",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN261_1ERO_MAYO_ZTE",
        "created_at": "2025-03-05T10:47:48.046821",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7617,
      "client_name": "YENIFER ANTONIETA GARCIA FERNANDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Arboleda",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128979963",
      "client_email": "GYENIFERGARCIA225@GMAIL.COM",
      "address": "CALLE LA INTERCOMUNAL CASA NRO 116 ROSARIO DE PAYA SECTOR LA ARBOLEDA",
      "client_identification": "V28051233",
      "nap_box_name": "CE - 646",
      "created_at": "2025-03-05T12:27:48.807400",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7618,
      "client_name": "VILMARIS JENLUISMAR MOTA GONZALEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Bicentenario",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04120410711",
      "client_email": "MVILMARISJENLUISMAR06@GMAIL.COM",
      "address": "BICENTENARIO CALLE ARAGUANEY MANZANA 10 PA CASA NRO4 ROSARIO DE PAYA",
      "client_identification": "V25620306",
      "nap_box_name": "CTO-00446",
      "created_at": "2025-03-05T14:30:34.864272",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7619,
      "client_name": "ENYELI  CLAUDIMAR RAMIREZ GONZALEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Bicentenario",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04127455174",
      "client_email": "HEIDERCHACON72@GMAIL.COM",
      "address": "BICENTENARIO CALLE LOS ROBLES CASA NRO12 ROSARIO DE PAYA",
      "client_identification": "V25620711",
      "nap_box_name": "CTO-00445",
      "created_at": "2025-03-05T14:54:17.948937",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7620,
      "client_name": "ADRIANA MARGARITA URBANO COLON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vallecito",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04125200944",
      "client_email": "ADRIANAMARGARITA428@GMAIL.COM",
      "address": "VALLECITO CALLE CUJI CASA NRO 21 ROSARIO DE PAYA",
      "client_identification": "V20649965",
      "nap_box_name": "CTO-00081",
      "created_at": "2025-03-05T15:08:36.247953",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7621,
      "client_name": "WRAYAN MIXAEL ROA GIRO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Las Rurales",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243780958",
      "client_email": "WRAYANROA1999@GMAIL.COM",
      "address": "LAS RURALES CALLE SUCRE CASA NRO17 ROSARIO DE PAYA",
      "client_identification": "V26935165",
      "nap_box_name": "CE - 646",
      "created_at": "2025-03-05T15:34:18.651602",
      "service_detail": {
        "id": 7838,
        "ip": "10.12.71.2",
        "mac": "OEMT3C6250CE",
        "serial": "OEMT3C6250CE",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN252_RURALES_PAYA",
        "created_at": "2025-03-05T16:03:26.142825",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7622,
      "client_name": "YHOSIBEL KARILLIN LOVERA MEDINA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Durpa",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121482014",
      "client_email": "LOVERAYHOSIBEL@GMAIL.COM",
      "address": "PARCELAMIENTO 6 CALLE LOS MANGOS CASA NRO 87 ROSARO DE PAYA",
      "client_identification": "V20988462",
      "nap_box_name": "CE - 535",
      "created_at": "2025-03-05T15:52:02.826674",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7623,
      "client_name": "GEMINIS SALAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona II",
      "plan": {
        "id": 101,
        "name": "RECURRENTE RESIDENCIAL PLAN 200M",
        "cost": "19.00",
        "code": "FOR200MB",
        "profile": "200Mbps/200Mbps"
      },
      "client_mobile": "04243201862",
      "client_email": "SALAS13.9.13@GMAIL.COM",
      "address": "CALLE NRO 15 CASA NRO 02 CASONA II",
      "client_identification": "V26834151",
      "nap_box_name": "CTO-00087",
      "created_at": "2025-03-05T15:52:03.543927",
      "service_detail": {
        "id": 10086,
        "ip": "10.12.73.2",
        "mac": "MONU004595A9",
        "serial": "MONU004595A9",
        "queue": null,
        "interface": "VLAN110_CASONA_2",
        "created_at": "2025-11-13T08:38:30.730901",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7624,
      "client_name": "ALEXIS IBAÑEZ BESONIAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Durpa",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121470512",
      "client_email": "ALEXISIBANEZBESONIAS@GMAIL.COM",
      "address": "DURPA CALLE LIBERTDAD MANZANA 15 CASA NRO 15 ROSARIO DE PAYA",
      "client_identification": "V10360281",
      "nap_box_name": "CTO-00297",
      "created_at": "2025-03-05T16:06:26.044802",
      "service_detail": {
        "id": 7844,
        "ip": "10.12.70.2",
        "mac": "ZTEGC97DA794",
        "serial": "ZTEGC97DA794",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN240_DURPA",
        "created_at": "2025-03-05T17:05:44.874521",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7625,
      "client_name": "JEAN CARLOS INOJOSA ESPIDEA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Sector los Mangos",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04125970609",
      "client_email": "JEANCAINOJOSA@GMAIL.COM",
      "address": "CALLE LOS MANGOS CASA NRO 6 ROSARIO DE PAYA",
      "client_identification": "V25349152",
      "nap_box_name": "CE - 789",
      "created_at": "2025-03-05T16:14:08.849132",
      "service_detail": {
        "id": 7843,
        "ip": "10.12.75.2",
        "mac": "OEMT3C625002",
        "serial": "OEMT3C625002",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN267_LOS_MANGOS_ZTE",
        "created_at": "2025-03-05T16:56:40.054943",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7626,
      "client_name": "ARGENIS MIGUEL VILLEGAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Luz y Vida",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04142974558",
      "client_email": "ARGE.18VI@GMAIL.COM",
      "address": "LUZ Y VIDA CALLE 1 CASA 41 ROSARIO DE PAYA",
      "client_identification": "V14389880",
      "nap_box_name": "CTO-00058",
      "created_at": "2025-03-06T08:24:15.865709",
      "service_detail": {
        "id": 7846,
        "ip": "10.12.78.2",
        "mac": "OEMT3C624BAA",
        "serial": "OEMT3C624BAA",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN264_LUZYVIDA_ZTE",
        "created_at": "2025-03-06T09:20:02.897988",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7627,
      "client_name": "LUIS MARIÑO DIAZ MORILLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados III",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144649551",
      "client_email": "LUIZDIAZMORILLO848@GMAIL.COM",
      "address": "PRDOS 3 CALLE 2 CASA NRO 45  ROSARIO DE PAYA",
      "client_identification": "V8999848",
      "nap_box_name": "579 DOS",
      "created_at": "2025-03-06T08:32:48.562572",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7628,
      "client_name": "NIUMAR ARGENIS GRANADILLO AREVALO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Marcelota",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243424802",
      "client_email": "ALBERTOBERROTERAN49@GMAIL.COM",
      "address": "CALLE MARCELLERCI LA MARCELOTA CASA S/N",
      "client_identification": "V24445349",
      "nap_box_name": "CTO-00MAR",
      "created_at": "2025-03-06T08:33:33.038515",
      "service_detail": {
        "id": 12978,
        "ip": "10.12.81.2",
        "mac": "b8:3a:08:cb:83:b0",
        "serial": "TPLGB444B221",
        "queue": null,
        "interface": "VLAN281_MARCELOTA",
        "created_at": "2026-09-04T10:44:28.233054",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7629,
      "client_name": "GARY JUENAL RIVAS CARRERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04125206794",
      "client_email": "GARYRIVAS224@GMAIL.COM",
      "address": "ROSARIO DE PAYA SECTOR RIO SECO CALLE 13 NRO 05",
      "client_identification": "V17789961",
      "nap_box_name": "CTO-00423",
      "created_at": "2025-03-06T08:52:31.598886",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7630,
      "client_name": "ANARELIS MARIA RIVAS PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Durpa",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04123984790",
      "client_email": "ANARELISRIVAS185@GMAIL.COM",
      "address": "CALLE SIMON RODRIGUEZ MANZANA 14 SECTOR FUNDABARRIOS",
      "client_identification": "V19791649",
      "nap_box_name": "CTO-00453",
      "created_at": "2025-03-06T08:57:30.043408",
      "service_detail": {
        "id": 11116,
        "ip": "10.12.82.2",
        "mac": "HWTC48080806",
        "serial": "HWTC48080806",
        "queue": null,
        "interface": "VLAN240_DURPA",
        "created_at": "2026-01-12T18:36:57.400310",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7631,
      "client_name": "HECTOR DANIEL CARVAJAL LOPEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Las Rurales",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243411836",
      "client_email": "YISCARVA11@GMAIL.COM",
      "address": "LAS RURALES CALLE MIRANDA CASA NRO 07-1 ROSARIO DE PAYA",
      "client_identification": "V25066829",
      "nap_box_name": "CE - 658",
      "created_at": "2025-03-06T09:33:06.607062",
      "service_detail": {
        "id": 7851,
        "ip": "10.12.83.2",
        "mac": "HWTC48080272",
        "serial": "HWTC48080272",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN252_RURALES_PAYA",
        "created_at": "2025-03-06T11:01:28.097705",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7632,
      "client_name": "VIVIANA MORENO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados I",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128151669",
      "client_email": "MORENOGARCIAV222@GMAIL.COM",
      "address": "AV PRINCIPAL PRADOS DE PAYA CASA NRO 11",
      "client_identification": "V20245757",
      "nap_box_name": "CTO-00304",
      "created_at": "2025-03-06T09:41:01.970774",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7633,
      "client_name": "JOSE FELIX RIVAS DAVID",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Terrazas de Paya",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04167392788",
      "client_email": "JOSEFELIXBENDECIDO@GMAIL.COM",
      "address": "AV PRINCIPAL TERRAZA DE PAYA CASA NRO 218",
      "client_identification": "V13454935",
      "nap_box_name": "CTO-00308",
      "created_at": "2025-03-06T09:58:14.223299",
      "service_detail": {
        "id": 11275,
        "ip": "10.12.85.2",
        "mac": "HWTC48080292",
        "serial": "HWTC48080292",
        "queue": null,
        "interface": "VLAN255_TERRAZAS_PAYA",
        "created_at": "2026-01-21T13:28:06.070769",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7634,
      "client_name": "YEINKINSON ESCALONA MARTINEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vallecito",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04128150791",
      "client_email": "YEIKINSONESCALONA@GMAIL.COM",
      "address": "CALLE LOS CAOBOS CASA NRO 28 VALLECITO TURMERO ARAGUA",
      "client_identification": "V31233080",
      "nap_box_name": "CTO-00067",
      "created_at": "2025-03-06T10:13:31.607597",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7635,
      "client_name": "GENERIS JIREH AGUILAR BERNAL",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Bicentenario",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128152102",
      "client_email": "ANAISAGUILAR033@GMAIL.COM",
      "address": "CALLE LOS CEDROS CASA 7 BICENTENARIO ROSARIO DE PAYA",
      "client_identification": "V26935033",
      "nap_box_name": "384",
      "created_at": "2025-03-06T10:39:30.123126",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7636,
      "client_name": "ANDREINA JOSE RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04123984588",
      "client_email": "ANDREINAJRODRI@GMAIL.COM",
      "address": "ROSARIO DE PAYA SECTOR RIO SECO CALLE 13 NRO 9",
      "client_identification": "V23792218",
      "nap_box_name": "CTO-00423",
      "created_at": "2025-03-06T13:26:01.349731",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7637,
      "client_name": "ANUBIS ALEJANDRA LEDEZMA CAMPOS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Sector los Mangos",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128151223",
      "client_email": "CAMPOSANUBIS81@GMAIL.COM",
      "address": "SEGUNDA TRANSVERSAL LOS MANGOS CASA NRO 24 ROSARIO PAYA",
      "client_identification": "V32231338",
      "nap_box_name": "CTO-00MAN",
      "created_at": "2025-03-06T17:08:08.953602",
      "service_detail": {
        "id": 7859,
        "ip": "10.12.89.2",
        "mac": "HWTC49200616",
        "serial": "HWTC49200616",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN267_LOS_MANGOS_ZTE",
        "created_at": "2025-03-07T08:05:52.109784",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7638,
      "client_name": "JOSE CARLOS FERNANDES DE ABREU",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Antigua Hacienda De Paya",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124682690",
      "client_email": "CARLOSFERNANDES2950@GMAIL.COM",
      "address": "CALLE LOS CEDROS CASA NRO 07 URB ANTIGUA HACIENDA PAYA",
      "client_identification": "E81375117",
      "nap_box_name": "CTO-00218 ",
      "created_at": "2025-03-07T08:37:00.957824",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7639,
      "client_name": "YUSDENNYS MARIA LAYA DUQUE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Luz y Vida",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04125970783",
      "client_email": "ROBERTHIGUERA551@GMAIL.COM",
      "address": "ROSARIO DE PAYA SECTOR LUZ Y VIDA CALLE 1 NRO12",
      "client_identification": "V19515618",
      "nap_box_name": "CTO-00057 DOS",
      "created_at": "2025-03-07T09:02:30.145150",
      "service_detail": {
        "id": 11975,
        "ip": "10.12.92.2",
        "mac": "OEMT3C624BD6",
        "serial": "OEMT3C624BD6",
        "queue": null,
        "interface": "VLAN264_LUZYVIDA_ZTE",
        "created_at": "2026-03-05T17:28:00.019952",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7640,
      "client_name": "GLENNYS DEL CARMEN GUZMAN MARQUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128151244",
      "client_email": "GLENNYSGM20@GMAIL.COM",
      "address": "MATA CABALLO, CALLE 10 APARTAMENTO 632A, ROSARIO DE PAYA",
      "client_identification": "V20758952",
      "nap_box_name": "CTO-00569 DOS",
      "created_at": "2025-03-07T09:35:04.229568",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7641,
      "client_name": "MARIHEN ANDREINA LOPEZ GOMEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "SUSPENDIDO_RESIDENCIAL",
      "status_name": "Suspendido",
      "cycle": 1,
      "migrate": true,
      "sector_name": "1ro de Mayo Sur",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04149466746",
      "client_email": "GOMEZANDREINA939@GMAIL.COM",
      "address": "PRIMERO DE MAYO SUR, CALLE SERA, CASA NRO 09, ROSARIO DE PAYA",
      "client_identification": "V19131387",
      "nap_box_name": "CTO-00237",
      "created_at": "2025-03-07T10:05:46.104190",
      "service_detail": {
        "id": 7864,
        "ip": "10.12.94.2",
        "mac": "HWTC48080299",
        "serial": "HWTC48080299",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN261_1ERO_MAYO_ZTE",
        "created_at": "2025-03-07T11:05:57.569930",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7642,
      "client_name": "LABORATORIO FONTI PHARMACEUTICAL CA",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Villeguita",
      "plan": {
        "id": 104,
        "name": "RECURRENTE PYME PLAN 1GB",
        "cost": "161.00",
        "code": "FOP1GB",
        "profile": "1000Mbps/1000Mbps"
      },
      "client_mobile": "04122988744",
      "client_email": "YOULINLOBOS@GRUPOFONTI.COM",
      "address": "CALLE PAEZ LOCAL NRO 17 VILLEGUITA TURMERO",
      "client_identification": "J500370962",
      "nap_box_name": "347",
      "created_at": "2025-03-07T14:09:13.364582",
      "service_detail": {
        "id": 9742,
        "ip": "10.12.77.2",
        "mac": "HWTC49200531",
        "serial": "HWTC49200531",
        "queue": null,
        "interface": "VLAN238_VILLEGUITA",
        "created_at": "2025-11-10T11:44:08.360261",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7643,
      "client_name": "ANA MERCEDES VALLES PRIMERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Manirito",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243105566",
      "client_email": "ANAVALLES1984@GMAIL.COM",
      "address": "CALLE PRINCIPAL SECTOR MANIRITO TURMERO ARAGUA",
      "client_identification": "V17351390",
      "nap_box_name": "CTO-00411",
      "created_at": "2025-03-07T15:57:57.311379",
      "service_detail": {
        "id": 7866,
        "ip": "10.12.98.2",
        "mac": "HWTC49200539",
        "serial": "HWTC49200539",
        "queue": "Plan_161900_30183_WispHub",
        "interface": "VLAN285_MANIRITO",
        "created_at": "2025-03-10T08:13:43.452222",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7644,
      "client_name": "INVERSIONES ARRIVISTE 1122 CA",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04243582828",
      "client_email": "INV.ARRIVISTE1122@GMAIL.COM",
      "address": "CASCO DE TURMERO, CALLE CEDEÑO CRUCE CON CALLE MARIÑO EDIFICIO HERANDEZ TURMERO",
      "client_identification": "J504702048",
      "nap_box_name": "CTO-00233",
      "created_at": "2025-03-07T17:08:46.958703",
      "service_detail": {
        "id": 12862,
        "ip": "10.16.220.2",
        "mac": "QX:TL:CB:B1:0D:D7",
        "serial": "QXTLCBB10DD7",
        "queue": null,
        "interface": "VLAN200_OLTs",
        "created_at": "2026-08-17T17:00:53.367075",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7645,
      "client_name": "ILBRAIN DAVID OJEDA SANCHEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243033277",
      "client_email": "HEDELL94OJEDA@GMAIL.COM",
      "address": "CALLE 18B, CASA NRO 49, SECTOR URB PANTIN, TURMERO ARAGUA, ZONA POSTAL 2115",
      "client_identification": "V20758992",
      "nap_box_name": "CTO-00321",
      "created_at": "2025-03-10T09:02:11.542222",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7646,
      "client_name": "EULICES ORLANDO NIEVES MEJIAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Bosque",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121487282",
      "client_email": "MEULICES206@GMAIL.COM",
      "address": "ROSARIO DE PAYA SECTOR EL BOSQUE CALLE JOSE ANTONIO PAEZ CASA NRO 09",
      "client_identification": "V29581026",
      "nap_box_name": "CTO-00470",
      "created_at": "2025-03-10T11:14:25.450461",
      "service_detail": {
        "id": 7869,
        "ip": "10.12.100.2",
        "mac": "OEMT3C6247C6",
        "serial": "OEMT3C6247C6",
        "queue": "Plan_161900_30183_WispHub",
        "interface": "VLAN266_EL_BOSQUE_ZTE",
        "created_at": "2025-03-10T12:52:05.907374",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7647,
      "client_name": "ANA KARINA MARQUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243796562",
      "client_email": "KM3573485@GMAIL.COM",
      "address": "CALLE PCPAL EDIF 09 E01 PISO 1 APTO 02 SECTOR LOS NISPEROS TERRAZA 2",
      "client_identification": "V14660874",
      "nap_box_name": "CTO-00387",
      "created_at": "2025-03-10T13:34:12.210941",
      "service_detail": {
        "id": 10000,
        "ip": "10.12.101.2",
        "mac": "HWTC49200527",
        "serial": "HWTC49200527",
        "queue": null,
        "interface": "VLAN209_ZAMORA_OLT1",
        "created_at": "2025-11-11T13:59:52.427559",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7648,
      "client_name": "JOHAGNI GABRIELA GIRO ALVAREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "1ro de Mayo Norte",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128990675",
      "client_email": "GABRIELAGIRO01@GMAIL.COM",
      "address": "ROSARIO DE PAYA SECTOR LA ARBOLEDA CALLE SUCRE CASA NRO 117",
      "client_identification": "V28432430",
      "nap_box_name": "CE - 646",
      "created_at": "2025-03-10T13:48:51.418101",
      "service_detail": {
        "id": 7872,
        "ip": "10.12.102.2",
        "mac": "OEMT3C624BE2",
        "serial": "OEMT3C624BE2",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN257_ARBOLEDA",
        "created_at": "2025-03-11T10:51:49.763120",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7649,
      "client_name": "LUISA YURINEN UZCATEGUI VARGAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Residencias Candys",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121752401",
      "client_email": "UZCATEGUILUISA2@GMAIL.COM",
      "address": "CALLE RIVAS EDIF LOS CANSYS 2 PLNATA BAJA APARTAMENTO NRO4",
      "client_identification": "V12608531",
      "nap_box_name": "CTO-0515",
      "created_at": "2025-03-10T13:58:20.681438",
      "service_detail": {
        "id": 7873,
        "ip": "10.12.103.2",
        "mac": "TPLGF9CD3E61",
        "serial": "TPLGF9CD3E61",
        "queue": "Plan_92306_15811_WispHub",
        "interface": "VLAN254_CANDYS_OLT1",
        "created_at": "2025-03-11T10:55:48.962672",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7650,
      "client_name": "LUIS DANIEL GOMEZ FLORES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados III",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144782190",
      "client_email": "LGOMEZMAVAN@GMAIL.COM",
      "address": "PRADOS III, CALLE NRO 4 CASA NRO 23, ROSARIO DE PAYA",
      "client_identification": "V17888964",
      "nap_box_name": "CTO-00299",
      "created_at": "2025-03-10T14:23:18.482676",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7651,
      "client_name": "DAYRIN ROXANA COLMENARES APONTE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Las Rurales",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243141370",
      "client_email": "COLMENARESDAYRIN@GMAIL.COM",
      "address": "ROSARIO DE PAYA SECTOR LAS RURALES CALLE BOLIVAR CASA NRO 9",
      "client_identification": "V26535607",
      "nap_box_name": "CE - 769",
      "created_at": "2025-03-10T14:46:31.184713",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7652,
      "client_name": "LEIDY PAOLA VALECILLO GRUESO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados III",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243044833",
      "client_email": "LEYDISVALECILLO@GMAIL.COM",
      "address": "ROSARIO DE PAYA SECTOR RIO SECO CALLE 1 CASA NRO 13",
      "client_identification": "V16098635",
      "nap_box_name": "CTO-00021",
      "created_at": "2025-03-10T14:56:19.654464",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7654,
      "client_name": "ZANOAD AIHONOAND TORRES VARGAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Durpa",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04123981986",
      "client_email": "TORRESZANOAD002@GMAIL.COM",
      "address": "ROSARIO DE PAYA PARCELAMIENTO 6 CALLE LOS MIRADORES CASA 101",
      "client_identification": "V18950579",
      "nap_box_name": "CTO-00271",
      "created_at": "2025-03-10T15:47:47.815624",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7655,
      "client_name": "JUANA YSIDORA TOVAR DE VIERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04169417151",
      "client_email": "JUANA10TOVAR04@GMAIL.COM",
      "address": "EDIFICIO 18 EZEQUIEL ZAMORA TURMERO",
      "client_identification": "V10266131",
      "nap_box_name": "CTO-00464 DOS",
      "created_at": "2025-03-10T16:12:49.619275",
      "service_detail": {
        "id": 7883,
        "ip": "10.12.109.2",
        "mac": "HWTC49200518",
        "serial": "HWTC49200518",
        "queue": "Plan_92194_15811_WispHub",
        "interface": "VLAN209_ZAMORA_OLT1",
        "created_at": "2025-03-12T09:27:14.517412",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7656,
      "client_name": "RAY DAVID JIMENEZ MUÑOZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Valle Verde",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128477429",
      "client_email": "RAYDJM12@GMAIL.COM",
      "address": "ROSARIO DE PAYA SECTOR VALLE VERDE CALLE PRINCIPAL CASA NRO 93",
      "client_identification": "V31855538",
      "nap_box_name": "CTO-0490",
      "created_at": "2025-03-10T16:26:47.431410",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7657,
      "client_name": "YEISON NEHOMAR RISSO SANCHEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Aduana",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243798296",
      "client_email": "YEISONRISSO99@GMAIL.COM",
      "address": "URB SAN CARLOS CASA NRO 43 LA ADUANA TURMERO",
      "client_identification": "V27048070",
      "nap_box_name": "136",
      "created_at": "2025-03-10T16:34:37.111282",
      "service_detail": {
        "id": 7916,
        "ip": "172.29.200.2",
        "mac": "OEMT3C625ED2",
        "serial": "OEMT3C625ED2",
        "queue": "Plan_107915_15811_WispHub",
        "interface": "VLAN223_SAN_CARLOS_OLT1",
        "created_at": "2025-03-17T17:12:06.836146",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7658,
      "client_name": "CAROLINA JOSEFINA PENA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "San Pablo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128660145",
      "client_email": "CAROLINAP2812@GMAIL.COM",
      "address": "URB VALLE PARAISO MANZANA 02 CASA 04 SAN PABLO",
      "client_identification": "V14211841",
      "nap_box_name": "CTO-0643",
      "created_at": "2025-03-10T17:12:55.225850",
      "service_detail": {
        "id": 7881,
        "ip": "10.12.111.2",
        "mac": "OEMT3C6247B2",
        "serial": "OEMT3C6247B2",
        "queue": "Plan_107915_15811_WispHub",
        "interface": "VLAN227_V_PARAISO_OLT1",
        "created_at": "2025-03-12T08:21:27.849988",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7659,
      "client_name": "MARIOXY NOHEMY PARADA FERNANDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados I",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04264684182",
      "client_email": "KLEBERSONMZAPATA@GMAIL.COM",
      "address": "PRADO I, CALLE 6, CASA NRO 27",
      "client_identification": "V32650116",
      "nap_box_name": "417",
      "created_at": "2025-03-10T17:13:53.655599",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7687,
      "client_name": "MIRIAN JOSEFINA MARTINEZ OROPEZA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128864806",
      "client_email": "CHIRAKOBLACK@GMAIL.COM",
      "address": "EZEQUIEL ZAMORA, EDIF. TIORA PISO PB, APTO. 03",
      "client_identification": "V9919403",
      "nap_box_name": "CTO-00296",
      "created_at": "2025-03-13T08:39:31.955156",
      "service_detail": {
        "id": 7961,
        "ip": "10.12.113.2",
        "mac": "OEMT3C62451E",
        "serial": "OEMT3C62451E",
        "queue": "Plan_107915_15811_WispHub",
        "interface": "VLAN209_ZAMORA_OLT1",
        "created_at": "2025-03-20T14:19:16.382031",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7688,
      "client_name": "YENIFER VICTORIA MONTIEL TIRRE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "1ro de Mayo Norte",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243227852",
      "client_email": "YENIFERMONTIEL927@GMAIL.COM",
      "address": "PRIMERO DE MAYO NORTE VEREDA 16 NOVIEMBRE CASA NRO 12",
      "client_identification": "V25527118",
      "nap_box_name": "CTO - 919",
      "created_at": "2025-03-13T08:40:45.484558",
      "service_detail": {
        "id": 10011,
        "ip": "10.12.114.2",
        "mac": "OEMT3C624E66",
        "serial": "OEMT3C624E66",
        "queue": null,
        "interface": "VLAN261_1ERO_MAYO_ZTE",
        "created_at": "2025-11-11T14:50:10.714249",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7689,
      "client_name": "RICHARD OBRYAN QUIVERA ZAPATA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04127834415",
      "client_email": "OBRYANQUIVERA95@GMAIL.COM",
      "address": "CALLE PRINCIPAL CASA NRO   01-07 URB VILLA DE SAN JOSE",
      "client_identification": "V23793309",
      "nap_box_name": "CTO-00080",
      "created_at": "2025-03-13T09:20:26.636056",
      "service_detail": {
        "id": 9904,
        "ip": "10.12.115.2",
        "mac": "HWTC49200536",
        "serial": "HWTC49200536",
        "queue": null,
        "interface": "VLAN134_VILLAS_DSJ_OLT_ZTE",
        "created_at": "2025-11-10T22:48:28.135686",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7690,
      "client_name": "EDUAR JOSE SOTILLO HERMANDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144656784",
      "client_email": "EDUARSOTILLO@GMAIL.COM",
      "address": "TURMERO CALLE PEÑALVER CRUCE CON CANDELARIA CASA NRO 91-A TURMERO",
      "client_identification": "V21465760",
      "nap_box_name": "CTO-00256",
      "created_at": "2025-03-13T09:20:44.244358",
      "service_detail": {
        "id": 7888,
        "ip": "10.12.105.2",
        "mac": "OEMT3C6248D2",
        "serial": "OEMT3C6248D2",
        "queue": "Plan_92194_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2025-03-13T10:05:13.311921",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7691,
      "client_name": "JOSE ANTONIO ALVES FAJARDO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Guayabita",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243265195",
      "client_email": "JOSEANTONIOALVESFAJARDO@GMAIL.COM",
      "address": "CALLE VIA POLVORIN CASA 17-B GUAYABITA",
      "client_identification": "V8732146",
      "nap_box_name": "CE - 954",
      "created_at": "2025-03-13T09:41:48.457945",
      "service_detail": {
        "id": 7887,
        "ip": "10.13.234.2",
        "mac": "HWTC49200540",
        "serial": "HWTC49200540",
        "queue": "Plan_107915_30181_WispHub",
        "interface": "VLAN282_ZONA_AGRARIA",
        "created_at": "2025-03-13T09:54:22.134937",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7692,
      "client_name": "VICTORIA SOFIA MOLINA GONZALEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Esperanza",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124621381",
      "client_email": "VICTORYSOFIA412@GMAIL.COM",
      "address": "EL MACARO, LA ESPERANZA, CALLE 3, CASA 19, TURMERO",
      "client_identification": "V28187268",
      "nap_box_name": "CTO-0245",
      "created_at": "2025-03-13T10:19:20.766702",
      "service_detail": {
        "id": 8101,
        "ip": "10.12.116.2",
        "mac": "OEMT3C6249FE",
        "serial": "OEMT3C6249FE",
        "queue": "Plan_137413_1574_WispHub",
        "interface": "VLAN137_LA_ESPERANZA_OLT_ZTE",
        "created_at": "2025-04-02T11:01:33.959819",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7693,
      "client_name": "TONY RAFAEL GAMEZ ALAMO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04143953649",
      "client_email": "GAMEZTONY355@GMAIL.COM",
      "address": "MATA CABALLO, CALLE 5, CASA 341, TURMERO",
      "client_identification": "V13646208",
      "nap_box_name": "CTO-00182",
      "created_at": "2025-03-13T10:36:55.342858",
      "service_detail": {
        "id": 7891,
        "ip": "10.12.119.2",
        "mac": "OEMT3C624806",
        "serial": "OEMT3C624806",
        "queue": "Plan_107915_30181_WispHub",
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2025-03-13T13:58:40.906889",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7694,
      "client_name": "RONELIS YELITZA AVILA REQUENA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vallecito",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04241462049",
      "client_email": "AVILARONELIS3@GMAIL.COM",
      "address": "ROSARIO DE PAYA SECTOR VALLECITO CALLE ARAGUANEI CASA NRO 6",
      "client_identification": "V14830359",
      "nap_box_name": "CTO - 1061",
      "created_at": "2025-03-13T10:39:03.665708",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7695,
      "client_name": "MARIA DEL CARMEN CAICEDO GONZALEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "1ro de Mayo Sur",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128246896",
      "client_email": "jeremy211605@gmail.com",
      "address": "PRIMERO DE MAYO SUR CALLE LIMON CASA 5",
      "client_identification": "V22342280",
      "nap_box_name": "CTO-00470",
      "created_at": "2025-03-13T10:57:54.124380",
      "service_detail": {
        "id": 9643,
        "ip": "10.12.118.2",
        "mac": "HWTC49200342",
        "serial": "HWTC49200342",
        "queue": null,
        "interface": "VLAN261_1ERO_MAYO_ZTE",
        "created_at": "2025-10-22T12:48:02.204677",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7696,
      "client_name": "ALICIA MARQUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Guanarito",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04149439493",
      "client_email": "JOANCARIMER@GMAIL.COM",
      "address": "GUANARITO CALLE PEÑALVER CASA NRO 45",
      "client_identification": "V4402982",
      "nap_box_name": "CTO-00476",
      "created_at": "2025-03-13T11:02:20.307985",
      "service_detail": {
        "id": 7905,
        "ip": "10.12.121.2",
        "mac": "OEMT3C625352",
        "serial": "OEMT3C625352",
        "queue": "Plan_92194_15811_WispHub",
        "interface": "VLAN233_PENALVER_OLT2",
        "created_at": "2025-03-14T15:42:23.462629",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7697,
      "client_name": "ANGEL FRANCISCO GALLARDO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Betania",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243637010",
      "client_email": "GALLARDOANGELF19@GMAIL.COM",
      "address": "TURMERO BETANIA CALLE 4 CASA S/N",
      "client_identification": "V15038034",
      "nap_box_name": "CTO - 1007",
      "created_at": "2025-03-13T12:52:10.114569",
      "service_detail": {
        "id": 7896,
        "ip": "10.12.112.2",
        "mac": "HWTC49200379",
        "serial": "HWTC49200379",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN260_BETANIA",
        "created_at": "2025-03-13T14:27:02.919673",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7698,
      "client_name": "MAIKER ABRAHAM VILLANUEVA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Betania",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144776898",
      "client_email": "VARGASHERICA1757@GMAIL.COM",
      "address": "Rosario de paya sector Betania calle número 1 casa 218",
      "client_identification": "V32016709",
      "nap_box_name": "CTO-00376",
      "created_at": "2025-03-13T13:18:00.394511",
      "service_detail": {
        "id": 10760,
        "ip": "10.12.151.2",
        "mac": "HWTC49200130",
        "serial": "HWTC49200130",
        "queue": null,
        "interface": "VLAN260_BETANIA",
        "created_at": "2025-12-17T10:58:28.223593",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7699,
      "client_name": "BARBARA ALEJANDRA GONZALEZ ROSALES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vallecito",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04241221561",
      "client_email": "BARBYGONZA310@GMAIL.COM",
      "address": "TURMERO VALLECITO CALLE EL CUJI CASA 21 B",
      "client_identification": "V31054441",
      "nap_box_name": "CTO-00081",
      "created_at": "2025-03-13T14:15:49.184045",
      "service_detail": {
        "id": 7920,
        "ip": "10.12.123.2",
        "mac": "HWTC49200516",
        "serial": "HWTC49200516",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN258_VALLECITO",
        "created_at": "2025-03-18T08:32:08.704217",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7700,
      "client_name": "AGUSTIN GABRIEL MOLINA PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vallecito",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04242395841",
      "client_email": "BRUNOPIAMONTE8@GMAIL.COM",
      "address": "VALLECITO CALLE LA ACASIA CASA NRO. 10",
      "client_identification": "V30065414",
      "nap_box_name": "CTO-00062",
      "created_at": "2025-03-13T14:46:07.236996",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7701,
      "client_name": "ANGEL SIMON MUJICA HERRERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Macaro",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243005443",
      "client_email": "ANGELMUJICA698@GMAIL.COM",
      "address": "EL MACARO, URB. LUIS BERTI, CALLE 3, CASA 413. TURMERO",
      "client_identification": "V22697403",
      "nap_box_name": "65",
      "created_at": "2025-03-13T14:55:05.998491",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7702,
      "client_name": "BETZABETH VELASQUEZ DIAZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "SUSPENDIDO_RESIDENCIAL",
      "status_name": "Suspendido",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Nispero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144932957",
      "client_email": "BETZADIAZ0922@GMAIL.COM",
      "address": "EZEQUIEL ZAMORA LOS NISPEROS TORRE 21 PISO 2 AP 2",
      "client_identification": "V19654908",
      "nap_box_name": "CTO-00225",
      "created_at": "2025-03-13T17:23:50.282928",
      "service_detail": {
        "id": 7923,
        "ip": "10.12.131.2",
        "mac": "OEMT3C620CA6",
        "serial": "OEMT3C620CA6",
        "queue": "Plan_92194_15811_WispHub",
        "interface": "VLAN209_ZAMORA_OLT1",
        "created_at": "2025-03-18T15:45:23.854176",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7703,
      "client_name": "EDGAR ISAAC BOLIVAR BLANCO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Terrazas de Paya",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243852844",
      "client_email": "ISAACBOLIVAR0429@GMAIL.COM",
      "address": "TERRAZAS DE PAYA, MANZANA 4, CASA NRO 08, ROSARIO DE PAYA, ARAGUA, ZONA POSTAL 2115",
      "client_identification": "V21202698",
      "nap_box_name": "CTO-0417",
      "created_at": "2025-03-13T18:50:09.057766",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7706,
      "client_name": "KAIRINA GABRIELA INFANTE BLANCO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Macaro",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243411060",
      "client_email": "SOPEKA2610@GMAIL.COM",
      "address": "EL MACARO URB JABILLAR CALLE 8 CASA 02 EL MACARO",
      "client_identification": "V19466153",
      "nap_box_name": "CTO-0553",
      "created_at": "2025-03-14T08:50:03.360846",
      "service_detail": {
        "id": 7909,
        "ip": "10.12.125.2",
        "mac": "OEMT3C6244DA",
        "serial": "OEMT3C6244DA",
        "queue": "Plan_138775_1574_WispHub",
        "interface": "VLAN108_JABILLAR_OLT_ZTE",
        "created_at": "2025-03-14T16:31:39.297562",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7707,
      "client_name": "ALEXANDRA VANESSA MONTOYA PINEDA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243147038",
      "client_email": "ALEXANDRAMONTOYA1987@GMAIL.COM",
      "address": "AV 2 CASA NRO 493 MATA CABALLO",
      "client_identification": "V18692952",
      "nap_box_name": "CTO-00567 DOS",
      "created_at": "2025-03-14T09:18:52.220109",
      "service_detail": {
        "id": 9679,
        "ip": "10.12.124.2",
        "mac": "OEMT3C624986",
        "serial": "OEMT3C624986",
        "queue": null,
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2025-11-04T09:51:19.599831",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7708,
      "client_name": "CHARLYS ENRIQUE MARIN PALMA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Las Rurales",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128866993",
      "client_email": "CHEMARIN_P@HOTMAIL.COM",
      "address": "AV PRINCIPAL CALLEJON SAN FRANCISCO LOCAL 111 ROSARIO DE PAYA LAS RURALES",
      "client_identification": "V14086638",
      "nap_box_name": "CE - 789",
      "created_at": "2025-03-14T16:21:22.104834",
      "service_detail": {
        "id": 7908,
        "ip": "172.21.194.2",
        "mac": "TPLGB68B4F92",
        "serial": "TPLGB68B4F92",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN252_RURALES_PAYA",
        "created_at": "2025-03-14T16:28:29.619472",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7709,
      "client_name": "YURIMAR RAMOS OJEDA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Aduana",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04127533942",
      "client_email": "YURIMARRAMOSCFSTURISMO@GMAIL.COM",
      "address": "URBANIZACION SAN CARLOS AVENIDA B CASA B-28. TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V13518101",
      "nap_box_name": "136",
      "created_at": "2025-03-14T22:19:42.157509",
      "service_detail": {
        "id": 7921,
        "ip": "10.12.130.2",
        "mac": "HWTC9022B89B",
        "serial": "HWTC9022B89B",
        "queue": "Plan_92300_15811_WispHub",
        "interface": "VLAN223_SAN_CARLOS_OLT1",
        "created_at": "2025-03-18T08:38:10.050991",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7711,
      "client_name": "JENNIFER JOSELINE RAMIREZ RIOS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121572537",
      "client_email": "JENIRAMIREZ1017@GMAIL.COM",
      "address": "ROSARIO DE PAYA SECTOR RIO SECO CALLE 25 NRO 8",
      "client_identification": "V17954404",
      "nap_box_name": "CE - 681",
      "created_at": "2025-03-15T11:55:55.381587",
      "service_detail": {
        "id": 7924,
        "ip": "10.12.132.2",
        "mac": "HWTC49200143",
        "serial": "HWTC49200143",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN251_RIO_SECO",
        "created_at": "2025-03-18T15:51:19.061628",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7712,
      "client_name": "NORMA MICHEL FALCON PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Arboleda",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04125798167",
      "client_email": "FALCONNORMA815@GMAIL.COM",
      "address": "ROSARIO DE PAYA SECTOR LA ARBOLEDA CALLE EL RIO NRO 120",
      "client_identification": "V18975266",
      "nap_box_name": "CTO-00154",
      "created_at": "2025-03-17T13:14:42.390192",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7713,
      "client_name": "CRUZ RAMONA MORALES OLIVO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "1ro de Mayo Norte",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124959128",
      "client_email": "OLIVOBUCHI@GMAIL.COM",
      "address": "CALLE TIUNA CASA NRO3 URB PRIMERO DE MAYO NORTE ROSARIO DE PAYA",
      "client_identification": "V12608934",
      "nap_box_name": "CTO - 919",
      "created_at": "2025-03-17T13:21:09.724926",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7714,
      "client_name": "WILLIAMS BORREGO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128902316",
      "client_email": "DEYSIBORREGO10@GMAIL.COM",
      "address": "ROSARIO DE PAYA SECTOR RIO SECO CALLE 27 NRO 57",
      "client_identification": "V7214603",
      "nap_box_name": "CTO-00033",
      "created_at": "2025-03-17T13:30:57.185579",
      "service_detail": {
        "id": 7918,
        "ip": "10.12.128.2",
        "mac": "HWTC529CCF87",
        "serial": "HWTC529CCF87",
        "queue": "Plan_107915_30181_WispHub",
        "interface": "VLAN251_RIO_SECO",
        "created_at": "2025-03-18T08:25:01.497692",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7715,
      "client_name": "EDGAR JOSE FLORES MENDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 19,
        "name": "RECURRENTE RESIDENCIAL PLAN 1GB",
        "cost": "74.70",
        "code": "FOR1GB",
        "profile": "1000M/1000M"
      },
      "client_mobile": "04243225156",
      "client_email": "EDGAREF1404@GMAIL.COM",
      "address": "AV PRINCIPAL DE PAYA LOCAL NRO S/N URB MATA CABALLO",
      "client_identification": "V17801722",
      "nap_box_name": "CTO-00068",
      "created_at": "2025-03-17T14:03:05.973178",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7716,
      "client_name": "JOSE ALEJANDRO PINTO ESCORCHE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128002234",
      "client_email": "ALEX18GUITARRISTA@GMAIL.COM",
      "address": "COMUNA 13 DE ENERO LOCAL NRO 19 TURMERO",
      "client_identification": "V21465138",
      "nap_box_name": "CTO-00256",
      "created_at": "2025-03-17T14:24:03.325142",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7717,
      "client_name": "FULVIA ELENA MENDOZA LONDOÑO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243345512",
      "client_email": "FULVIAELENAMENDOZA@GMAIL.COM",
      "address": "ROSARIO DE PAYA SECTOR RIO SECO CALLE27 NRO3",
      "client_identification": "V14318975",
      "nap_box_name": "CTO-00039",
      "created_at": "2025-03-17T14:30:36.302941",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7718,
      "client_name": "SALA POLITICA ALDEA UNIVERSITARIA",
      "client_type_name": "GRATIS",
      "client_subdivision": "ACTIVO_GRATIS",
      "status_name": "Activo",
      "cycle": 25,
      "migrate": true,
      "sector_name": "El Macaro",
      "plan": {
        "id": 86,
        "name": "PLAN RECURRENTE 80M GRATIS",
        "cost": "0.00",
        "code": "FO-G80",
        "profile": "80M/80M"
      },
      "client_mobile": "04123339418",
      "client_email": "ANASANDOVAL0873@GMAIL.COM",
      "address": "CARRETERA NACIONAL TURMERO MARACAY EL MACARO",
      "client_identification": "C500230532",
      "nap_box_name": "493",
      "created_at": "2025-03-17T14:53:37.924807",
      "service_detail": {
        "id": 7914,
        "ip": "10.12.106.2",
        "mac": "HWTC49200534",
        "serial": "HWTC49200534",
        "queue": "Plan_137413_1574_WispHub",
        "interface": "VLAN104_EL_MACARO_OLT_ZTE",
        "created_at": "2025-03-17T14:59:20.807906",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7719,
      "client_name": "OLIVER JESUS GONZALEZ HURTADO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04143352434",
      "client_email": "OLUVER-99-HGONZALEZ@GMAIL.COM",
      "address": "MATA CABALLO CALLE #6 CASA #422",
      "client_identification": "V31660616",
      "nap_box_name": "CTO-00031",
      "created_at": "2025-03-17T15:09:17.422967",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7720,
      "client_name": "ALEXANDER RONDON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121486237",
      "client_email": "RONDON.ALEXANDER.M@GMAIL.COM",
      "address": "PAYA RIO SECO CALLE 27 CASA 23",
      "client_identification": "V24445193",
      "nap_box_name": "468",
      "created_at": "2025-03-17T15:14:50.302954",
      "service_detail": {
        "id": 12330,
        "ip": "10.12.138.2",
        "mac": "OEMT3C6203D2",
        "serial": "OEMT3C6203D2",
        "queue": null,
        "interface": "VLAN251_RIO_SECO",
        "created_at": "2026-04-16T16:52:35.917956",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7721,
      "client_name": "YONATAN ALFREDO RAMIREZ MORENO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "1ro de Mayo Norte",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128655059",
      "client_email": "RAMIREZYONATAN726@GMAIL.COM",
      "address": "CALLE PRINCIPAL CASA S/N PRIMERO DE MAYO NORTE ROSARIO DE PAYA",
      "client_identification": "V23916837",
      "nap_box_name": "CTO - 919",
      "created_at": "2025-03-17T15:50:20.048373",
      "service_detail": {
        "id": 7927,
        "ip": "10.12.135.2",
        "mac": "OEMT3C620F0E",
        "serial": "OEMT3C620F0E",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN261_1ERO_MAYO_ZTE",
        "created_at": "2025-03-18T16:22:44.757702",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7722,
      "client_name": "YENNY CAROLINA LUGO DE DUQUE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121623426",
      "client_email": "MIANGEL0567@GMAIL.COM",
      "address": "PAYA RIO SECO CALLE 27 CASA 17",
      "client_identification": "V16692557",
      "nap_box_name": "CTO-00077",
      "created_at": "2025-03-18T08:22:38.877834",
      "service_detail": {
        "id": 7932,
        "ip": "10.12.139.2",
        "mac": "HWTC49200127",
        "serial": "HWTC49200127",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN251_RIO_SECO",
        "created_at": "2025-03-18T19:22:36.648313",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7723,
      "client_name": "JENNIBETH MARIA ANDREINA CABRERA SOLORZANO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243524367",
      "client_email": "JENNIBETHC100@GMAIL.COM",
      "address": "CASCO DE TURMERO, CC EL RANDAZO, LOCAL NRO 03, PLANTA BAJA",
      "client_identification": "V28249323",
      "nap_box_name": "CTO-00072",
      "created_at": "2025-03-18T09:16:15.978832",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7724,
      "client_name": "RUBEN HEBER HIDALGO NIETO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Valle Verde",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128901928",
      "client_email": "GRATCHYGONZALEZ@GMAIL.COM",
      "address": "CALLE EL BOSQUE PAYA CASA # 20",
      "client_identification": "V10059881",
      "nap_box_name": "CTO-9696",
      "created_at": "2025-03-18T09:36:07.870944",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7725,
      "client_name": "MIGDALIA JOSEFINA PERDOMO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Marcelota",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243409695",
      "client_email": "BOLILUIS69@GMAIL.COM",
      "address": "LA MARCELOTA CALLE LA LAGUNITA CASA NRO 07",
      "client_identification": "V9669819",
      "nap_box_name": "CTO - 1061",
      "created_at": "2025-03-18T10:02:38.550293",
      "service_detail": {
        "id": 7937,
        "ip": "10.12.145.2",
        "mac": "OEMT3C620E3E",
        "serial": "OEMT3C620E3E",
        "queue": "Plan_107915_30181_WispHub",
        "interface": "VLAN281_MARCELOTA",
        "created_at": "2025-03-18T19:43:58.910989",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7726,
      "client_name": "DURLEY ALEXANDER JIMENEZ PINEDA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04125016696",
      "client_email": "CRISABRI30@HOTMAIL.COM",
      "address": "LA COMUNA 13 DE ENERO LOCAL NRO 04 TIENDA NATURISTA",
      "client_identification": "V22205122",
      "nap_box_name": "CTO-00256",
      "created_at": "2025-03-18T10:07:42.046280",
      "service_detail": {
        "id": 7938,
        "ip": "10.12.146.2",
        "mac": "OEMT3C620852",
        "serial": "OEMT3C620852",
        "queue": "Plan_107915_15811_WispHub",
        "interface": "VLAN276_COMUNA_OLT1",
        "created_at": "2025-03-18T19:46:05.066922",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7727,
      "client_name": "YORGELIS REBECA MONTILLA GARCIAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243213218",
      "client_email": "MONTILLAYORGELIS04@GMAIL.COM",
      "address": "CALLE 27 CASA NRO 38 RIO SECO",
      "client_identification": "V26535138",
      "nap_box_name": "CTO-00432 DOS",
      "created_at": "2025-03-18T10:09:13.200289",
      "service_detail": {
        "id": 7994,
        "ip": "10.12.147.2",
        "mac": "HWTC2453C490",
        "serial": "HWTC2453C490",
        "queue": "Plan_107915_30181_WispHub",
        "interface": "VLAN251_RIO_SECO",
        "created_at": "2025-03-24T13:27:39.984771",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7728,
      "client_name": "ANA CECILIA SILVA GUZMAN",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128903458",
      "client_email": "CARLAJOELIS07@GMAIL.COM",
      "address": "CALLE 7 CASA NRO 10 RIO SECO",
      "client_identification": "V16131115",
      "nap_box_name": "CTO-0610",
      "created_at": "2025-03-18T10:42:10.624408",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7729,
      "client_name": "MEIGLIN DEL CARMEN FERNANDEZ GOMEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128997364",
      "client_email": "GERMARIFERNANDEZ994@GMAIL.COM",
      "address": "ROSARIO DE PAYA SECTOR RIO SECO CALLE 27 NRO 21",
      "client_identification": "V13853251",
      "nap_box_name": "468",
      "created_at": "2025-03-18T11:21:06.311404",
      "service_detail": {
        "id": 7936,
        "ip": "10.12.144.2",
        "mac": "HWTC49200128",
        "serial": "HWTC49200128",
        "queue": "Plan_107915_30181_WispHub",
        "interface": "VLAN251_RIO_SECO",
        "created_at": "2025-03-18T19:41:05.804764",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7730,
      "client_name": "MARYELYN JOHANA PALACIOS FIGUEROA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vallecito",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124347032",
      "client_email": "MAYERDEBLANCO@GMAIL.COM",
      "address": "ROSARIO DE PAYA C/ LOS NARANJOS CASA #02 VALLECITO",
      "client_identification": "V15077348",
      "nap_box_name": "CTO-0012345",
      "created_at": "2025-03-18T11:23:14.049406",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7731,
      "client_name": "STEFANY GABRIELA JASPE SERRANO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Betania",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04125856500",
      "client_email": "STEFANYJASPE7@GMAIL.COM",
      "address": "ROSARIO DE PAYA SECTOR COMUNIDAD BETANIA CALLE 4 NRO 216",
      "client_identification": "V29890973",
      "nap_box_name": "CTO-00306",
      "created_at": "2025-03-18T11:38:42.903008",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7732,
      "client_name": "YELITZA CAROLINA GUAICARA DE MALAVE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Macaro",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243518328",
      "client_email": "CAROLYELA2011@HOTMAIL.COM",
      "address": "SAMAN TARAZONERO 2 MANZANA B1 CASA NRO 1",
      "client_identification": "V21443582",
      "nap_box_name": "128",
      "created_at": "2025-03-18T11:51:24.644364",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7733,
      "client_name": "EDGAR ISAAC BOLIVAR BLANCO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243852844",
      "client_email": "ISAACBOLIVAR0429@GMAIL.COM",
      "address": "SECTOR MATACABALLO, AVENIDA 1, CASA NRO 678-B, ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V21202698",
      "nap_box_name": "CTO-00215",
      "created_at": "2025-03-18T16:50:09.932705",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7734,
      "client_name": "LUIS SEBASTIAN HERNANDEZ SUAREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Callejon Lim",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04126792391",
      "client_email": "SHEVYPLAN@GMAIL.COM",
      "address": "EDIFICIO TORRE AZUCENA CALLEJON LIM, PISO: 3 , APTO 14",
      "client_identification": "V16384647",
      "nap_box_name": "TORRE AZUCENA",
      "created_at": "2025-03-18T16:52:39.019866",
      "service_detail": {
        "id": 12830,
        "ip": "10.12.140.2",
        "mac": "OE:MT:3C:62:00:CA",
        "serial": "OEMT3C6200CA",
        "queue": null,
        "interface": "VLAN250_LIM_OLT2",
        "created_at": "2026-08-13T12:17:19.589419",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7735,
      "client_name": "ANIUSCAR AGUILERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "1ro de Mayo Norte",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128150113",
      "client_email": "AGUILERAANIUSCAR@GMAIL.COM",
      "address": "PRIMERO DE MAYO NORTE, AV 2, EDIF. 2, NIVEL 1 PISO 1",
      "client_identification": "V22948431",
      "nap_box_name": "CTO- 908",
      "created_at": "2025-03-18T17:10:05.367140",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7736,
      "client_name": "ROSBESLIS MERCEDES CEDRES LOPEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Valle Verde",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04125247114",
      "client_email": "ROSBELISCEDRES376@GMAIL.COM",
      "address": "ROSARIO DE PAYA SECTOR VALLE VERDE CALLE PRINCIPAL CASA NRO 21",
      "client_identification": "V23783406",
      "nap_box_name": "CTO-00253 DOS",
      "created_at": "2025-03-19T09:56:24.867055",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7737,
      "client_name": "JESUS ANTONIO BOCANEY TOVAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243414872",
      "client_email": "ANTONIOJESUSBBTT@GMAIL.COM",
      "address": "TURMERO COMUNA 13 ENERO LOCAL 15",
      "client_identification": "V14937124",
      "nap_box_name": "CTO-00256",
      "created_at": "2025-03-19T15:48:13.525867",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7738,
      "client_name": "PAOLA DESIREE MUNOZ ROCA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Magdalena",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243070964",
      "client_email": "PAOLADMRDESIREE1518@GMAIL.COM",
      "address": "LA MAGDALENA CALLE NRO 1 CASA NRO 2",
      "client_identification": "V28097866",
      "nap_box_name": "CTO-00472",
      "created_at": "2025-03-19T15:58:03.986430",
      "service_detail": {
        "id": 9876,
        "ip": "10.12.154.2",
        "mac": "OEMT3C620AF6",
        "serial": "OEMT3C620AF6",
        "queue": null,
        "interface": "VLAN114_MAGDALENA",
        "created_at": "2025-11-10T19:11:41.173858",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7739,
      "client_name": "LUISANA DEL CARMEN MEJIAS AYALA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Palmeras I",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128928023",
      "client_email": "MEJIASAYALA69@GMAIL.COM",
      "address": "LAS PALMERAS 1 CALLE 1 CASA NRO 67",
      "client_identification": "V29900195",
      "nap_box_name": "CTO-00226",
      "created_at": "2025-03-19T16:07:43.957828",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7740,
      "client_name": "GUSTAVO ADOLFO GONZALEZ ORTIZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Guerito",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124747125",
      "client_email": "GUSTAVO.BRAYAN169@GMAIL.COM",
      "address": "GUERTO PRINCIPAL DE GUERITO GALPON SERAVIAN",
      "client_identification": "V26507481",
      "nap_box_name": "CTO-00472 DOS",
      "created_at": "2025-03-19T16:13:57.277823",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7741,
      "client_name": "SONIA MANRIQUEZ DURAN",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04128467957",
      "client_email": "SONIAMANRIQUEZDURAN0407@GMAIL.COM",
      "address": "ROSARIO DE PAYA SECTOR RIO SECO CALLE 1 CASA NRO 9",
      "client_identification": "V13284372",
      "nap_box_name": "CE - 772",
      "created_at": "2025-03-19T16:19:08.152043",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7742,
      "client_name": "RAFAEL ANTONIO VEGAS MONASTERIO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "PAUSADO_RESIDENCIAL",
      "status_name": "Pausado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Betania",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121483515",
      "client_email": "ANTONIOMONASTERIOS20@GMAIL.COM",
      "address": "CALLE 5 CASA Nº 185 SECTOR COMUNIDAD BETANIA ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V11414037",
      "nap_box_name": "CTO-00426",
      "created_at": "2025-03-19T16:19:16.409306",
      "service_detail": {
        "id": 11314,
        "ip": "10.12.158.2",
        "mac": "HWTC49200146",
        "serial": "HWTC49200146",
        "queue": null,
        "interface": "VLAN260_BETANIA",
        "created_at": "2026-01-22T15:47:17.841146",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7743,
      "client_name": "MARIANNY YUSLEIDIMAR MELENDEZ SEQUERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "1ro de Mayo Norte",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128999248",
      "client_email": "SEQUERAGLORIA39@GMAIL.COM",
      "address": "PRIMERO DE MAYO NORTE VEREDA 16 DE NOVIEMBRE CASA #9",
      "client_identification": "V22344184",
      "nap_box_name": "CTO - 919",
      "created_at": "2025-03-19T17:01:40.282308",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7744,
      "client_name": "MIRIAM JOSEFINA RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados I",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144744379",
      "client_email": "garceslucena@gmail.com",
      "address": "PRADO 1 AV PRINCIPAL CASA 04",
      "client_identification": "V7221986",
      "nap_box_name": "CTO-00206",
      "created_at": "2025-03-19T17:17:25.811655",
      "service_detail": {
        "id": 12941,
        "ip": "10.12.160.2",
        "mac": "TP:LG:B7:65:62:80",
        "serial": "TPLGB7656280",
        "queue": null,
        "interface": "VLAN239_PRADOS1",
        "created_at": "2026-09-01T09:22:14.560376",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7745,
      "client_name": "YUSMARY DEL CARMEN GONZALEZ GONZALEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vallecito",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121481499",
      "client_email": "YOSELINNIEVES978@GMAIL.COM",
      "address": "VALLECITO CALLE EL BAMBU CASA #1",
      "client_identification": "V20056711",
      "nap_box_name": "CTO - 1061",
      "created_at": "2025-03-19T17:29:22.802325",
      "service_detail": {
        "id": 7954,
        "ip": "10.12.157.2",
        "mac": "OEMT3C620E16",
        "serial": "OEMT3C620E16",
        "queue": "Plan_107915_30181_WispHub",
        "interface": "VLAN258_VALLECITO",
        "created_at": "2025-03-20T08:05:07.761166",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7747,
      "client_name": "EDJONNAIS GUEVARA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vallecito",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04129100707",
      "client_email": "ANGELUKAINNARA@GMAIL.COM",
      "address": "ROSARIO DE PAYA SECTOR VALLECITO CALLE LAS PALMERA CASA S/N",
      "client_identification": "V19515755",
      "nap_box_name": "CTO - 1061",
      "created_at": "2025-03-20T12:13:25.641506",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7749,
      "client_name": "LUIS CASTRILLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villeguita",
      "plan": {
        "id": 43,
        "name": "RECURRENTE RESIDENCIAL PLAN 650M",
        "cost": "46.00",
        "code": "FOR650M",
        "profile": "650M/650M"
      },
      "client_mobile": "04243358074",
      "client_email": "CASTRILLOLUISNAZARET25@GMAIL.COM",
      "address": "VILLEGUITA N2 CASA NRO 10-1 C/JOSE V. GONZALEZ",
      "client_identification": "V13908993",
      "nap_box_name": "CTO - 923",
      "created_at": "2025-03-20T12:33:04.530615",
      "service_detail": {
        "id": 12144,
        "ip": "10.12.167.2",
        "mac": "OEMT3C620DCA",
        "serial": "OEMT3C620DCA",
        "queue": null,
        "interface": "VLAN238_VILLEGUITA",
        "created_at": "2026-03-20T19:25:57.600491",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7750,
      "client_name": "ROSAURA MARGARITA GALARRAGA RAMOS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Payita",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04143724577",
      "client_email": "ROSAURAGALARRAGA@HOTMAIL.COM",
      "address": "SECTOR PAYITA CALLEJON LA CROQUERA CASA 14 PARROQUIA PEDRO AREVALO APONTE",
      "client_identification": "V11559294",
      "nap_box_name": "CTO - 1039",
      "created_at": "2025-03-20T12:53:11.191646",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7751,
      "client_name": "RUBEN HEBER HIDALGO NIETO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Bosque",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128901928",
      "client_email": "GRATCHYGONZALEZ@GMAIL.COM",
      "address": "CALLE EL BOSQUE PAYA CASA NRO 20",
      "client_identification": "V10059881",
      "nap_box_name": "CTO-00290",
      "created_at": "2025-03-20T13:06:48.372250",
      "service_detail": {
        "id": 7960,
        "ip": "10.12.163.2",
        "mac": "HWTC49200147",
        "serial": "HWTC49200147",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN266_EL_BOSQUE_ZTE",
        "created_at": "2025-03-20T13:17:52.069867",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7752,
      "client_name": "DAYANA CAROLINA TORRES PALMA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Arboleda",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243783370",
      "client_email": "DAYANACAROLINATORRESPALMA36@GMAIL.COM",
      "address": "ROSARIO DE PAYA SECTOR LA ARBOLEDA CASA NRO 115 ROSARIO DE PAYA",
      "client_identification": "V19531657",
      "nap_box_name": "CTO-00154",
      "created_at": "2025-03-20T13:32:13.158455",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7753,
      "client_name": "YELITZA FALCON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Naranjal",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243347789",
      "client_email": "FALCONYBEBE@GMAIL.COM",
      "address": "ROSARIO DE PAYA CALLE LA ESPERANZA NRO 04 EL NARANJAL",
      "client_identification": "V15490335",
      "nap_box_name": "CE - 681",
      "created_at": "2025-03-20T13:42:29.735001",
      "service_detail": {
        "id": 11331,
        "ip": "10.12.165.2",
        "mac": "ZTEGD1D05F01",
        "serial": "ZTEGD1D05F01",
        "queue": null,
        "interface": "VLAN246_NARANJAL",
        "created_at": "2026-01-23T13:51:44.415419",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7755,
      "client_name": "MARIBEL MORALES CHACON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Valle Verde",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04169476994",
      "client_email": "PARRAMORALESVAL2008@GMAIL.COM",
      "address": "VALLE VERDE AVENIDA PRINCIPAL C7/7 ROSARIO DE PAYA",
      "client_identification": "V7132401",
      "nap_box_name": "CTO-00187",
      "created_at": "2025-03-21T08:29:40.105407",
      "service_detail": {
        "id": 7971,
        "ip": "10.12.179.2",
        "mac": "HWTCD69B769C",
        "serial": "HWTCD69B769C",
        "queue": "Plan_107915_30181_WispHub",
        "interface": "VLAN251_RIO_SECO",
        "created_at": "2025-03-21T13:54:04.126422",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7756,
      "client_name": "ANNA JOSELIN GUANARES AVILA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Orquidea",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04123403393",
      "client_email": "GUANARESANNA@GMAIL.COM",
      "address": "LA ORQUIDIA PRADO DE PAYA CALL 2 CASA 37",
      "client_identification": "V12171351",
      "nap_box_name": "CTO-00019",
      "created_at": "2025-03-21T08:40:47.419666",
      "service_detail": {
        "id": 7986,
        "ip": "10.12.191.2",
        "mac": "HWTC49200148",
        "serial": "HWTC49200148",
        "queue": "Plan_107915_30181_WispHub",
        "interface": "VLAN259_LA_ORQUIDEA",
        "created_at": "2025-03-21T15:46:05.553429",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7757,
      "client_name": "YOERLINE STARDAYANA MATOS VILLALOBOS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Aduana",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243491118",
      "client_email": "GOMEZYOE2@GMAIL.COM",
      "address": "TURMERO LA ADUANA CASA NRO 07 CALLEMELLAO",
      "client_identification": "V20760586",
      "nap_box_name": "CTO-00440",
      "created_at": "2025-03-21T09:01:22.381819",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7758,
      "client_name": "JEHOVANA SERRANO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Los Hornos",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04122999766",
      "client_email": "JEHOVANASERRANO22@GMAIL.COM",
      "address": "LOS HORNOS ROSARIO DE PAYA CALLE LOS MANGOS NRO13",
      "client_identification": "V27204313",
      "nap_box_name": "437",
      "created_at": "2025-03-21T09:31:37.490272",
      "service_detail": {
        "id": 7977,
        "ip": "10.12.180.2",
        "mac": "OEMT3C620B86",
        "serial": "OEMT3C620B86",
        "queue": "Plan_107915_30181_WispHub",
        "interface": "VLAN247_HORNOS",
        "created_at": "2025-03-21T14:38:00.285665",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7759,
      "client_name": "ABIGAIL RIVERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04143129074",
      "client_email": "ABIGAILRIVERA.27B@GMAIL.COM",
      "address": "PRADO 2 CALLE 2 CASA NRO 30  ROSARIO DE PAYA",
      "client_identification": "V26728707",
      "nap_box_name": "CTO-00205 DOS",
      "created_at": "2025-03-21T09:39:01.370689",
      "service_detail": {
        "id": 12276,
        "ip": "10.12.181.2",
        "mac": "OEMT3C620E32",
        "serial": "OEMT3C620E32",
        "queue": null,
        "interface": "VLAN242_PRADOS2",
        "created_at": "2026-04-09T21:35:11.732527",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7760,
      "client_name": "THAIS KARINA GRANADILLO RIVAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Cambur",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128893242",
      "client_email": "THAISGRANADILLO75@GMAIL.COM",
      "address": "EL CAMBUR CALLE LOS APAMATES CASA NRO 2A ROSARIO DE PAYA",
      "client_identification": "V13200346",
      "nap_box_name": "CTO - 912",
      "created_at": "2025-03-21T10:04:02.798121",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7761,
      "client_name": "UBEURI ROYMAR HERNANDEZ HERRERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "1ro de Mayo Norte",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128650095",
      "client_email": "UB3UR1@GMAIL.COM",
      "address": "PRIMERO DE MAYO SUR CALLE 3 CASA NRO 8 ROSARIO DE PAYA",
      "client_identification": "V31719820",
      "nap_box_name": "CTO-00237",
      "created_at": "2025-03-21T10:37:35.935262",
      "service_detail": {
        "id": 7980,
        "ip": "10.12.183.2",
        "mac": "OEMT3C62031A",
        "serial": "OEMT3C62031A",
        "queue": "Plan_107915_30181_WispHub",
        "interface": "VLAN261_1ERO_MAYO_ZTE",
        "created_at": "2025-03-21T14:43:46.712687",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7762,
      "client_name": "NESTOR ENRRIQUE AGUIRRE CAICEDO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "1ro de Mayo Sur",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04123156556",
      "client_email": "EDUARDPEREZED95@GMAIL.COM",
      "address": "PRIMERO DE MAYO SUR CALLE EL LIMON CASA NRO 01 ROSARIO DE PAYA",
      "client_identification": "V19834628",
      "nap_box_name": "CTO-00470",
      "created_at": "2025-03-21T10:45:04.606015",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7763,
      "client_name": "DANIELA  YORGELYS PENA DUGARTE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243389958",
      "client_email": "PENADUGARTEDANIELAYORGELIS@GMAIL.COM",
      "address": "MATA CABALLO CALLE 9 APTO. PB 586A ROSARIO DE PAYA",
      "client_identification": "V31357971",
      "nap_box_name": "CTO-00431",
      "created_at": "2025-03-21T11:21:24.184906",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7764,
      "client_name": "ANA MARIA ACOSTA FLORES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Naranjal",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144947705",
      "client_email": "ANACOSTA080166@GMAIL.COM",
      "address": "EL NARANJAL PARCELAMIENTO 6 CALLE LOS MIRADORES CASA 127",
      "client_identification": "V6259313",
      "nap_box_name": "597",
      "created_at": "2025-03-21T11:31:59.055496",
      "service_detail": {
        "id": 7982,
        "ip": "10.12.185.2",
        "mac": "OEMT3C6202BE",
        "serial": "OEMT3C6202BE",
        "queue": "Plan_107915_30181_WispHub",
        "interface": "VLAN246_NARANJAL",
        "created_at": "2025-03-21T14:50:07.898781",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7765,
      "client_name": "ARACELYS JOSEFINA TOVAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128204701",
      "client_email": "TARACELYS462@GMAIL.COM",
      "address": "EZEQUIEL ZAMORA CALLE PRINCIPAL EDIFICIO 17 PISO 3 APT 3",
      "client_identification": "V20523929",
      "nap_box_name": "CTO-00225",
      "created_at": "2025-03-21T12:15:46.419578",
      "service_detail": {
        "id": 7983,
        "ip": "10.12.186.2",
        "mac": "OEMT3C620C8A",
        "serial": "OEMT3C620C8A",
        "queue": "Plan_107915_15811_WispHub",
        "interface": "VLAN209_ZAMORA_OLT1",
        "created_at": "2025-03-21T15:01:14.185503",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7766,
      "client_name": "BELGICA ANGELICA NUNEZ PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Cambur",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04120478158",
      "client_email": "BELGICAN207@GMAIL.COM",
      "address": "ROSARIO DE PAYA CORAZON DE JESUS PARCELAMIENTO EL CAMBUR",
      "client_identification": "V31466433",
      "nap_box_name": "CTO-004444",
      "created_at": "2025-03-21T13:03:24.074954",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7767,
      "client_name": "YOLIEXIS YEIMAR ORTEGA RIOS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Guzman",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243384251",
      "client_email": "YOLIANNYRIERA@GMAIL.COM",
      "address": "CALLE NEGRO PRIMERO CASA NR 8 LA GUZMAN",
      "client_identification": "V30852846",
      "nap_box_name": "CTO - 1075",
      "created_at": "2025-03-21T13:40:17.926529",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7769,
      "client_name": "LUDIMAR RODRIGUEZ VARGAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04140111007",
      "client_email": "MCRODRIGUEZV@GMAIL.COM",
      "address": "MATA CABALLO CALLE 3 CASA NRO 156 ROSARIO DE PAYA",
      "client_identification": "V17176678",
      "nap_box_name": "CTO-00094",
      "created_at": "2025-03-21T14:07:54.461057",
      "service_detail": {
        "id": 7989,
        "ip": "10.12.194.2",
        "mac": "OEMT3C620346",
        "serial": "OEMT3C620346",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2025-03-21T16:09:59.691487",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7770,
      "client_name": "ROGER JAVIER VALENCIA IZQUIERDO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04166284483",
      "client_email": "ROGER18243345@GMAIL.COM",
      "address": "CASCO DE TURMERO, CC RANDAZO, PB LOCAL 53. TURMERO EDO ARAGUA",
      "client_identification": "V18243345",
      "nap_box_name": "CAJA NAP BICENTENARIO",
      "created_at": "2025-03-24T13:35:26.947389",
      "service_detail": {
        "id": 7995,
        "ip": "10.12.195.2",
        "mac": "OEMT3C620CB6",
        "serial": "OEMT3C620CB6",
        "queue": "Plan_107915_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2025-03-24T13:43:31.358336",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7771,
      "client_name": "DENCI JOSE SALAZAR LUCERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vallecito",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04260341871",
      "client_email": "ALEXLUCER30@GMAIL.COM",
      "address": "CALLE EL BAMBU CASA NRO 5  SECTOR VALLECITO ROSARIO DE PAYA",
      "client_identification": "V20694599",
      "nap_box_name": "CTO - 00395",
      "created_at": "2025-03-24T15:38:25.421154",
      "service_detail": {
        "id": 7998,
        "ip": "10.12.196.2",
        "mac": "OEMT3C620E46",
        "serial": "OEMT3C620E46",
        "queue": "Plan_107915_30181_WispHub",
        "interface": "VLAN258_VALLECITO",
        "created_at": "2025-03-24T16:51:07.174276",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7772,
      "client_name": "ABRAHAN JOSE CABRICES MENDOZA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vallecito",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04122891262",
      "client_email": "ICABRICES2@GMAIL.COM",
      "address": "CALLE ARAGUANEY CASA NRO 60 SECTOR VALLECITO ROSARIO DE PAYA",
      "client_identification": "V31903608",
      "nap_box_name": "CTO-00062",
      "created_at": "2025-03-24T16:00:07.117582",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7773,
      "client_name": "EDUARD JOSE LUGO YEGUES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vallecito",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04125200069",
      "client_email": "EDUARDLUGO1804@GMAIL.COM",
      "address": "CALLE LAS PALMAS CASA NRO 03 VALLECITO",
      "client_identification": "V12399132",
      "nap_box_name": "CTO - 00395",
      "created_at": "2025-03-24T16:53:48.355037",
      "service_detail": {
        "id": 8000,
        "ip": "10.12.198.2",
        "mac": "OEMT3C620B92",
        "serial": "OEMT3C620B92",
        "queue": "Plan_107915_30181_WispHub",
        "interface": "VLAN258_VALLECITO",
        "created_at": "2025-03-24T17:12:59.123494",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7774,
      "client_name": "JOHNNABEL BLANCO NIEVES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vallecito",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128150180",
      "client_email": "JOHNNABELL2010@GMAIL.COM",
      "address": "CALLE EL SAMAN NRO 9 SECTOR VALLECITO ROSARIO DE PAYA",
      "client_identification": "V12171252",
      "nap_box_name": "CTO - 00395",
      "created_at": "2025-03-25T08:56:54.090084",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7775,
      "client_name": "ZAIDA MATILDE TOVAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vallecito",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243367736",
      "client_email": "ROSMERYPEREZ4698@GMAIL.COM",
      "address": "CALLE ARAGUANEY CASA NRO 66 VALLECITO ROSARIO DE PAYA",
      "client_identification": "V7219137",
      "nap_box_name": "CTO-00062",
      "created_at": "2025-03-25T09:52:48.425411",
      "service_detail": {
        "id": 8002,
        "ip": "10.12.200.2",
        "mac": "HWTC49200137",
        "serial": "HWTC49200137",
        "queue": "Plan_161901_30183_WispHub",
        "interface": "VLAN258_VALLECITO",
        "created_at": "2025-03-25T10:28:26.933851",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7776,
      "client_name": "AIVERSON JHAIR FUENMAYOR GONZALEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vallecito",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04164060193",
      "client_email": "JHAIRGONZALEZ95@GMAIL.COM",
      "address": "CALLE BAMBU CASA NRO 5 VALLECITO",
      "client_identification": "V27286031",
      "nap_box_name": "ct0-00vall",
      "created_at": "2025-03-25T10:17:29.095104",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7777,
      "client_name": "MARCELYS ANDREINA LUGO RAMIREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243116328",
      "client_email": "MARCELYSLUGO949@GMAIL.COM",
      "address": "MATA CABALLO CALLE 12 APTO. 698-D PISO 1",
      "client_identification": "V24929782",
      "nap_box_name": "CTO-00020",
      "created_at": "2025-03-25T11:04:09.494070",
      "service_detail": {
        "id": 8023,
        "ip": "10.12.202.2",
        "mac": "ZICGC4866C6A",
        "serial": "ZICGC4866C6A",
        "queue": "Plan_107915_30181_WispHub",
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2025-03-26T12:24:40.777392",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7778,
      "client_name": "FERNANDO DAVID MORALES CARABALLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona II",
      "plan": {
        "id": 101,
        "name": "RECURRENTE RESIDENCIAL PLAN 200M",
        "cost": "19.00",
        "code": "FOR200MB",
        "profile": "200Mbps/200Mbps"
      },
      "client_mobile": "04243231154",
      "client_email": "FERNANDOMORALESFER@GMAIL.COM",
      "address": "CALLE 13 CASA NRO 88 LA CASONA 2",
      "client_identification": "V30956315",
      "nap_box_name": "CTO-00089",
      "created_at": "2025-03-25T11:07:27.372579",
      "service_detail": {
        "id": 9668,
        "ip": "10.12.203.2",
        "mac": "OEMT3C620E6E",
        "serial": "OEMT3C620E6E",
        "queue": null,
        "interface": "VLAN109_CASONA_1",
        "created_at": "2025-11-03T10:04:38.399948",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7779,
      "client_name": "Eliany Juleisi López Delgado",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Arboleda",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04122983193",
      "client_email": "elianylopez797@gmail.com",
      "address": "LA ARBOLEDA CALLE INTERCOMUNAL CASA NRO 137 ROSARIO DE PAYA",
      "client_identification": "V13568057",
      "nap_box_name": "CE - 646",
      "created_at": "2025-03-25T11:20:03.899983",
      "service_detail": {
        "id": 8007,
        "ip": "10.12.204.2",
        "mac": "OEMT3C62074A",
        "serial": "OEMT3C62074A",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN257_ARBOLEDA",
        "created_at": "2025-03-25T11:37:09.020659",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7780,
      "client_name": "LEONEL ALFONSO VILLEGAS DELGADO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Macaro",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243562059",
      "client_email": "DELGADODENIS952@GMAIL.COM",
      "address": "SAMAN TARAZONERO II MANZANA B1 CASA #5",
      "client_identification": "V25620050",
      "nap_box_name": "128",
      "created_at": "2025-03-25T12:50:19.642009",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7781,
      "client_name": "BREDDY LAURA LUGO RAMIREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Luz y Vida",
      "plan": {
        "id": 2,
        "name": "RECURRENTE RESIDENCIAL PLAN 30M",
        "cost": "20.00",
        "code": "FOR30",
        "profile": "30M/30M"
      },
      "client_mobile": "04121486721",
      "client_email": "BREDDYLUGO04@GMAIL.COM",
      "address": "TURMERO  LUZ Y VIDA CALLE 01 CASA #58",
      "client_identification": "V14470438",
      "nap_box_name": "CTO-00057 DOS",
      "created_at": "2025-03-25T13:18:30.014236",
      "service_detail": {
        "id": 11317,
        "ip": "10.12.206.2",
        "mac": "ADCGCCA2EDCD",
        "serial": "ADCGCCA2EDCD",
        "queue": null,
        "interface": "VLAN264_LUZYVIDA_ZTE",
        "created_at": "2026-01-22T15:54:35.278572",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7782,
      "client_name": "RAYNNER ARMANDO GOMEZ LARA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "1ro de Mayo Sur",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04122599705",
      "client_email": "RAYNNERGOMEZ8@GMAIL.COM",
      "address": "PRIMERO DE MAYO SUR CASA NRO 03 CALLE 02 ROSARIO DE PAYA",
      "client_identification": "V30005220",
      "nap_box_name": "CTO - 00398",
      "created_at": "2025-03-25T14:50:25.865998",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7783,
      "client_name": "ELIO TOMAS FLORES FANEITE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vallecito",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128672101",
      "client_email": "SAULALTUNA@GMAIL.COM",
      "address": "VALLECITO CALLE LOS MANGOS CASA #29",
      "client_identification": "V5268968",
      "nap_box_name": "CTO-00074",
      "created_at": "2025-03-26T08:51:54.405832",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7784,
      "client_name": "GREGORY ALEXANDER RODRIGUEZ SANCHEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Marcelota",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243800218",
      "client_email": "JOSEALEXGRE.2508@GMAIL.COM",
      "address": "LA MARCELOTA CALLE LAGUNITA CASA NRO25",
      "client_identification": "V15489258",
      "nap_box_name": "CTO - 1061",
      "created_at": "2025-03-26T10:07:06.746670",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7785,
      "client_name": "JHOANNYS JAKELLIN ROJAS MEDINA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243284749",
      "client_email": "ALINR7791@GMAIL.COM",
      "address": "TURMERO EZEQUIEL ZAMORA TORRE18 PISO 1 APARTAMENTO 4",
      "client_identification": "V18884106",
      "nap_box_name": "CTO-00225",
      "created_at": "2025-03-26T10:38:40.693403",
      "service_detail": {
        "id": 8020,
        "ip": "10.12.209.2",
        "mac": "OEMT3C6205E6",
        "serial": "OEMT3C6205E6",
        "queue": "Plan_92300_15811_WispHub",
        "interface": "VLAN209_ZAMORA_OLT1",
        "created_at": "2025-03-26T11:35:22.069640",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7786,
      "client_name": "ODALIS ROSALIA HIDALGO PEÑALVER",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04246610838",
      "client_email": "WINDERSARMIENTO26@GMAIL.COM",
      "address": "CALLE RICAURTE CASA NRO 65 SECTOR PUEBLO NUEVO ZONA POSTAL 2115 TURMERO",
      "client_identification": "V15489642",
      "nap_box_name": "CTO-00440",
      "created_at": "2025-03-26T11:04:57.895565",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7787,
      "client_name": "JOHN HARRY MALDONADO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Sector los Mangos",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04164952879",
      "client_email": "JHONHARRYMALDONADO@GMAIL.COM",
      "address": "CALLE LAS BRISAS CASA NRO 25 LOS MANGOS ROSARIO DE PAYA",
      "client_identification": "V14708865",
      "nap_box_name": "CTO-00483",
      "created_at": "2025-03-26T11:32:58.785583",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7788,
      "client_name": "VILMA JULIO DE BEYUELO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128935338",
      "client_email": "VILMAJULIO828@GMAIL.COM",
      "address": "CASCO DE TURMERO CALLE SUCRE EDIF MONTE FALCONES PISO3 APT.A",
      "client_identification": "V25067495",
      "nap_box_name": "CTO-00266",
      "created_at": "2025-03-26T12:56:28.404944",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7789,
      "client_name": "GILBERTO ANTONIO CAMACHO ACOSTA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243407123",
      "client_email": "GILBERTOCAMACHO221280@GMAIL.COM",
      "address": "EL NISPERO CALLE BOLIVAR EDIF TORRES A PISO 8 APTO 83",
      "client_identification": "V15109399",
      "nap_box_name": "TORRE A EDIF LOS NISPEROS",
      "created_at": "2025-03-26T14:37:49.938345",
      "service_detail": {
        "id": 8046,
        "ip": "10.12.213.2",
        "mac": "HWTC49200149",
        "serial": "HWTC49200149",
        "queue": "Plan_107915_15811_WispHub",
        "interface": "VLAN272_EDIF_NISPEROS_OLT3",
        "created_at": "2025-03-27T17:25:43.679552",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7790,
      "client_name": "AGENCIA SAN PABLO",
      "client_type_name": "GRATIS",
      "client_subdivision": "ACTIVO_GRATIS",
      "status_name": "Activo",
      "cycle": 25,
      "migrate": true,
      "sector_name": "Valle lindo",
      "plan": {
        "id": 86,
        "name": "PLAN RECURRENTE 80M GRATIS",
        "cost": "0.00",
        "code": "FO-G80",
        "profile": "80M/80M"
      },
      "client_mobile": "04140390506",
      "client_email": "ELIREYES_VE@YAHOO.ES",
      "address": "URB. VALLE PARAÍSO MANZANA 2 CASA NUMERO 2",
      "client_identification": "V123390720",
      "nap_box_name": "54",
      "created_at": "2025-03-26T15:11:57.642745",
      "service_detail": {
        "id": 12742,
        "ip": "10.12.214.2",
        "mac": "OE:MT:3C:62:09:EE",
        "serial": "OEMT3C6209EE",
        "queue": null,
        "interface": "VLAN200_OLTs",
        "created_at": "2026-07-16T10:29:10.029639",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7791,
      "client_name": "LUIS ALBERTO MARTINEZ AROCHA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vallecito",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124191286",
      "client_email": "LUISELECTRICO96@GMAIL.COM",
      "address": "CALLE ARAGUANEY AV PP VALLECITO CASA NRO 22",
      "client_identification": "V6162795",
      "nap_box_name": "CTO - 1105",
      "created_at": "2025-03-26T15:32:15.311210",
      "service_detail": {
        "id": 8028,
        "ip": "10.12.215.2",
        "mac": "OEMT3C620326",
        "serial": "OEMT3C620326",
        "queue": "Plan_107915_30181_WispHub",
        "interface": "VLAN258_VALLECITO",
        "created_at": "2025-03-26T15:54:13.517222",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7792,
      "client_name": "ARTUR YON RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Valle Paraiso",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243519039",
      "client_email": "RODRIARTUR40@GMAIL.COM",
      "address": "URBANIZACION VALLE DEL PARAISO APARTAMENTO 8 PLANTA BAJA TURMERO",
      "client_identification": "V15600850",
      "nap_box_name": "CTO-00603",
      "created_at": "2025-03-26T16:32:50.324195",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7793,
      "client_name": "MARIA FERNANDA URBINA MORILLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144764092",
      "client_email": "MAFERUM.06@GMAIL.COM",
      "address": "CASCO DE TURMERO, CALLE MELLAO CASA NRO 3",
      "client_identification": "V27520032",
      "nap_box_name": "111",
      "created_at": "2025-03-26T16:37:56.430951",
      "service_detail": {
        "id": 8030,
        "ip": "10.12.218.2",
        "mac": "OEMT3C62095E",
        "serial": "OEMT3C62095E",
        "queue": "Plan_107915_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2025-03-26T17:11:53.465475",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7794,
      "client_name": "JOSELIN ELIANA PEREZ PIEDRA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04242710765",
      "client_email": "JOSELIN_PEREZ18@HOTMAIL.COM",
      "address": "CASCO DE TURMERO CALLE VILLA CASTIN CASA NRO 16",
      "client_identification": "V17974769",
      "nap_box_name": "CTO-0248",
      "created_at": "2025-03-26T16:43:51.396970",
      "service_detail": {
        "id": 8060,
        "ip": "10.12.219.2",
        "mac": "OEMT3C620B82",
        "serial": "OEMT3C620B82",
        "queue": "Plan_143066_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2025-03-28T20:44:49.103463",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7795,
      "client_name": "WILFREDO ROSARIO LARA HERNANDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "1ro de Mayo Norte",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04125038388",
      "client_email": "WLARA410@GMAIL.COM",
      "address": "PRIMERO DE MAYO NORTE CALLE LOS JABILLOS CASA #15",
      "client_identification": "V15601290",
      "nap_box_name": "CTO- 908",
      "created_at": "2025-03-27T11:56:57.536748",
      "service_detail": {
        "id": 8036,
        "ip": "10.12.220.2",
        "mac": "OEMT3C620B66",
        "serial": "OEMT3C620B66",
        "queue": "Plan_107915_30181_WispHub",
        "interface": "VLAN261_1ERO_MAYO_ZTE",
        "created_at": "2025-03-27T14:28:48.856457",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7796,
      "client_name": "CARLOS JAVIER OVALLES PIÑANGO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Macaro",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04122900379",
      "client_email": "CARLOSJOP9@GMAIL.COM",
      "address": "EL MACARO SAN SEBASTIAN CALLE 2 CASA 24",
      "client_identification": "V32046620",
      "nap_box_name": "CTO-SEB",
      "created_at": "2025-03-27T12:26:57.961099",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7798,
      "client_name": "JOSE MERCEDES CHAPARRO BUSTAMANTE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "San Pablo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04142030968",
      "client_email": "INGCHAPARRO61@GMAIL.COM",
      "address": "HARAS DE SAN PABLO, AV 2 MANZANA C CASA 54",
      "client_identification": "V9226767",
      "nap_box_name": "247",
      "created_at": "2025-03-27T13:57:44.612661",
      "service_detail": {
        "id": 8039,
        "ip": "10.12.222.2",
        "mac": "OEMT3C6204EA",
        "serial": "OEMT3C6204EA",
        "queue": "Plan_107915_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2025-03-27T14:58:20.308688",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7799,
      "client_name": "YAJAIRA CAROLINA NIEVES PEÑA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vallecito",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243391128",
      "client_email": "NIEVESYAJAIRA450@GMAIL.COM",
      "address": "ROSARIO DE PAYA VALLECITO CALLE ALMIRADOR CASA # 5",
      "client_identification": "V25071679",
      "nap_box_name": "Cto-92",
      "created_at": "2025-03-27T14:11:03.744191",
      "service_detail": {
        "id": 12906,
        "ip": "10.12.223.2",
        "mac": "ZX:IC:CD:D8:B3:E2",
        "serial": "ZXICCDD8B3E2",
        "queue": null,
        "interface": "VLAN258_VALLECITO",
        "created_at": "2026-08-25T13:31:26.371967",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7802,
      "client_name": "DARIANNYS VICTORIA BRITO HERNANDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Durpa",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243206700",
      "client_email": "DARIANNYSBRITO01@GMAIL.COM",
      "address": "FUNDA BARRIO (DURPA) CALLE LIBERTAD, MANZANA 16 CASA 15",
      "client_identification": "V302113242",
      "nap_box_name": "258",
      "created_at": "2025-03-27T15:14:10.563139",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7803,
      "client_name": "YUSETH MARIELENA JUNCO ROMERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04129909248",
      "client_email": "YUSETHJUNCO@GMAIL.COM",
      "address": "TORRE B EDIF LOS NISPEROS PISO 8 APT #81",
      "client_identification": "V23801042",
      "nap_box_name": "TORRE B EDIF LOS NISPEROS",
      "created_at": "2025-03-27T15:36:04.029270",
      "service_detail": {
        "id": 8043,
        "ip": "10.12.225.2",
        "mac": "OEMT3C62018E",
        "serial": "OEMT3C62018E",
        "queue": "Plan_107915_15811_WispHub",
        "interface": "VLAN272_EDIF_NISPEROS_OLT3",
        "created_at": "2025-03-27T15:51:46.754655",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7804,
      "client_name": "AGENCIA PAYA",
      "client_type_name": "GRATIS",
      "client_subdivision": "ACTIVO_GRATIS",
      "status_name": "Activo",
      "cycle": 25,
      "migrate": true,
      "sector_name": "Vista Hermosa",
      "plan": {
        "id": 86,
        "name": "PLAN RECURRENTE 80M GRATIS",
        "cost": "0.00",
        "code": "FO-G80",
        "profile": "80M/80M"
      },
      "client_mobile": "04243249019",
      "client_email": "SISPROT@SISPROTGF.COM",
      "address": "AV PRINCIPAL DE ROSARIO DE PAYA VISTA HERMOSA",
      "client_identification": "V110919390",
      "nap_box_name": "237",
      "created_at": "2025-03-27T15:42:42.739650",
      "service_detail": {
        "id": 8044,
        "ip": "172.31.22.2",
        "mac": "OEMT3C622996",
        "serial": "OEMT3C622996",
        "queue": "Plan_107915_30181_WispHub",
        "interface": "VLAN230_VISTA_HERMOSA",
        "created_at": "2025-03-27T15:59:29.337539",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7805,
      "client_name": "CARLOS ALBERTO GUTIERREZ MARTINEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243361254",
      "client_email": "CARLOSALBERTOGUTI75@GMAIL.COM",
      "address": "EZEQUIEL ZAMORA, EDIFICIO 28, PISO PB, APTO. 04",
      "client_identification": "V12339634",
      "nap_box_name": "CTO-00207 DOS",
      "created_at": "2025-03-28T10:46:39.949565",
      "service_detail": {
        "id": 8063,
        "ip": "10.12.226.2",
        "mac": "OEMT3C620C66",
        "serial": "OEMT3C620C66",
        "queue": "Plan_161875_15811_WispHub",
        "interface": "VLAN209_ZAMORA_OLT1",
        "created_at": "2025-03-29T18:34:49.036195",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7806,
      "client_name": "FELIPE NERIO VILLEGAS NIEVES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Julia",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121589673",
      "client_email": "FELIPEVILLEGAS2605@GMAIL.COM",
      "address": "LA JULIA AV 100 CASA #17",
      "client_identification": "V7176515",
      "nap_box_name": "cto la julia",
      "created_at": "2025-03-28T10:59:03.756601",
      "service_detail": {
        "id": 8096,
        "ip": "10.12.188.2",
        "mac": "HWTC49200530",
        "serial": "HWTC49200530",
        "queue": "Plan_131341_24341_WispHub",
        "interface": "VLAN138_LAJULIA",
        "created_at": "2025-04-01T14:53:01.337930",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7807,
      "client_name": "ELENA MERCEDES VEGAS MONTENEGRO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04140530697",
      "client_email": "VEGASELENA622@GMAIL.COM",
      "address": "LA CASONA 2 CALLE 14 CASA # 80",
      "client_identification": "V9695724",
      "nap_box_name": "CTO-00120",
      "created_at": "2025-03-28T11:34:54.310991",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7808,
      "client_name": "LUIS JAVIER ROJAS AREVALO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vallecito",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04167152975",
      "client_email": "JAVI3130LUIS@GMAIL.COM",
      "address": "VALLECITO CALLE LOS JABILLOS CASA#1",
      "client_identification": "V18975156",
      "nap_box_name": "CTO - 99",
      "created_at": "2025-03-28T11:44:57.836167",
      "service_detail": {
        "id": 8052,
        "ip": "10.12.228.2",
        "mac": "OEMT3C6203CA",
        "serial": "OEMT3C6203CA",
        "queue": "Plan_107915_30181_WispHub",
        "interface": "VLAN258_VALLECITO",
        "created_at": "2025-03-28T12:09:30.233242",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7809,
      "client_name": "PAOLA STEPHANIA SEGOVIA ARIAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124341608",
      "client_email": "CT2303129@GMAIL.COM",
      "address": "SAMAN TARAZONERO II CALLE MANZANA D7 CASA 14",
      "client_identification": "V27820864",
      "nap_box_name": "95",
      "created_at": "2025-03-28T11:55:31.534459",
      "service_detail": {
        "id": 10547,
        "ip": "10.12.229.2",
        "mac": "OEMT3C620186",
        "serial": "OEMT3C620186",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2025-12-03T14:19:45.920069",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7810,
      "client_name": "DELIA JOSEFINA GOMEZ OJEDA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Paya Abajo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243558423",
      "client_email": "GOMEZDELIA206@GMAIL.COM",
      "address": "PAYA ABAJO CALLE EL CENTRO CASA #3-1",
      "client_identification": "V10792020",
      "nap_box_name": "CTO-00307",
      "created_at": "2025-03-28T13:05:38.053401",
      "service_detail": {
        "id": 11468,
        "ip": "10.12.227.2",
        "mac": "OEMT3C6206DE",
        "serial": "OEMT3C6206DE",
        "queue": null,
        "interface": "VLAN229_PANTIN",
        "created_at": "2026-02-04T11:37:05.984448",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7811,
      "client_name": "LUDY ONEIDA LOPEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Las Rurales",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128926319",
      "client_email": "ludyl6824@gmail.com",
      "address": "LAS RURALES CALLE SUCRE CASA#11-2",
      "client_identification": "V15123846",
      "nap_box_name": "614",
      "created_at": "2025-03-28T13:16:17.387443",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7812,
      "client_name": "JESUS ANTONIO VILLANUEVA SALCEDO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124954573",
      "client_email": "JV427513@GMAIL.COM",
      "address": "URB.HACIENDA PANTIN  CALLE 14B NRO.33 TURMERO ZONA POSTAL  ZONA POSTAL 2115",
      "client_identification": "V7281311",
      "nap_box_name": "CTO-00195",
      "created_at": "2025-03-29T12:09:07.884875",
      "service_detail": {
        "id": 8070,
        "ip": "10.12.231.2",
        "mac": "OEMT3C620FCA",
        "serial": "OEMT3C620FCA",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN229_PANTIN",
        "created_at": "2025-03-31T08:32:36.943779",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7813,
      "client_name": "JESSICA LISBETH CARPIO GUEDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vallecito",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04142966824",
      "client_email": "LISBETHGUEDEZ84@GMAIL.COM",
      "address": "VALLECITO CALLE ARAGUANEY CASA #28",
      "client_identification": "V16131194",
      "nap_box_name": "CTO - 1105",
      "created_at": "2025-03-29T12:42:32.255293",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7814,
      "client_name": "ALFREDO JOSE MORENO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128907750",
      "client_email": "CHELO300351@GMAIL.COM",
      "address": "CALLE 17 CASA 21 RIO SECO ROSARIO DE PAYA",
      "client_identification": "V3935575",
      "nap_box_name": "CTO-0606",
      "created_at": "2025-03-30T11:50:55.689227",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7815,
      "client_name": "YUSBELIS MARIA ARAUJO GRATEROL",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "1ro de Mayo Norte",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121407400",
      "client_email": "ARAUJOZORELYS@GMAIL.COM",
      "address": "CALLE CHACAO CASA 28 1RO DE MAYO NORTE ROSARIO DE PAYA",
      "client_identification": "V15600638",
      "nap_box_name": "CTO - 900",
      "created_at": "2025-03-30T15:33:36.559421",
      "service_detail": {
        "id": 8069,
        "ip": "10.12.234.2",
        "mac": "OEMT3C620F4E",
        "serial": "OEMT3C620F4E",
        "queue": "Plan_107915_30181_WispHub",
        "interface": "VLAN261_1ERO_MAYO_ZTE",
        "created_at": "2025-03-31T08:26:02.255819",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7816,
      "client_name": "BELKIS MAGALY ABREU SOLANO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144614072",
      "client_email": "BELKISMAGALYABREU@GMAIL.COM",
      "address": "CALLE 8 CASA 21 PANTI ROSARIO DE PAYA",
      "client_identification": "V11796681",
      "nap_box_name": "CTO-00114",
      "created_at": "2025-03-30T15:48:24.479137",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7817,
      "client_name": "YAINERK CAMILO GUERRERO PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Las Rurales",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243580365",
      "client_email": "DANIELALEOTA91@GMAIL.COM",
      "address": "LAS RURALES CALLE 106 CASA # 01",
      "client_identification": "V32136430",
      "nap_box_name": "492",
      "created_at": "2025-03-31T11:55:46.912568",
      "service_detail": {
        "id": 8073,
        "ip": "10.12.237.2",
        "mac": "OEMT3C620582",
        "serial": "OEMT3C620582",
        "queue": "Plan_107915_30181_WispHub",
        "interface": "VLAN252_RURALES_PAYA",
        "created_at": "2025-03-31T16:04:48.932971",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7818,
      "client_name": "BRINER ALEXANDER OSORIO MARTOS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "SUSPENDIDO_RESIDENCIAL",
      "status_name": "Suspendido",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Paraiso",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04125029650",
      "client_email": "BRINEOSORIO82@GMAIL.COM",
      "address": "URB. EL PARAISO CALLE LA ESPERANZA CASA #85",
      "client_identification": "V12853455",
      "nap_box_name": "345",
      "created_at": "2025-03-31T12:05:18.666923",
      "service_detail": {
        "id": 8078,
        "ip": "10.12.236.2",
        "mac": "OEMT3C6210BA",
        "serial": "OEMT3C6210BA",
        "queue": "Plan_137413_1574_WispHub",
        "interface": "VLAN105_EL_PARAISO_OLT_ZTE",
        "created_at": "2025-03-31T17:04:30.479458",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7819,
      "client_name": "ALIDA COROMOTO LOPEZ AGUIRRE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Valle Verde",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128651293",
      "client_email": "LOPEZ317@GMAIL.COM",
      "address": "CALLE LOS MAMONES CASA NRO 7-2 SECTOR VALLE VERDE ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V13200319",
      "nap_box_name": "CTO-00187",
      "created_at": "2025-03-31T13:26:29.846157",
      "service_detail": {
        "id": 8074,
        "ip": "10.12.238.2",
        "mac": "OEMT3C620E5E",
        "serial": "OEMT3C620E5E",
        "queue": "Plan_107915_30181_WispHub",
        "interface": "VLAN253_VALLE_VERDE",
        "created_at": "2025-03-31T16:06:56.085627",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7820,
      "client_name": "YULETXI ALEXANDRA TABERA PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243433097",
      "client_email": "YULETXIALEXANDRATABERAPEREZ@GMAIL.COM",
      "address": "PARADA LA CASONA II, AVENIDA INTERCOMUNAL SANTIAGO MARIÑO, TURMERO, ARAGUA",
      "client_identification": "V19834130",
      "nap_box_name": "CTO-00089",
      "created_at": "2025-03-31T13:40:05.397012",
      "service_detail": {
        "id": 8075,
        "ip": "10.12.239.2",
        "mac": "OEMT3C62117A",
        "serial": "OEMT3C62117A",
        "queue": "Plan_131341_24341_WispHub",
        "interface": "VLAN109_CASONA_1",
        "created_at": "2025-03-31T16:10:30.043659",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7821,
      "client_name": "LUIS RAFAEL CAPOTE LOPEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Las Rurales",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04125973234",
      "client_email": "CAPOTELUIS2016@GMAIL.COM",
      "address": "LAS RURALES CALLE BOLIVAR CASA 15",
      "client_identification": "V9439082",
      "nap_box_name": "CE - 769",
      "created_at": "2025-03-31T13:46:36.843788",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7822,
      "client_name": "NESTOR EDUARDO AVENDANO EDUARDO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Valle Fresco",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124569169",
      "client_email": "GAMELOTE@GMAIL.COM",
      "address": "VALLE FRESCO MANZANA 25 CASA #14",
      "client_identification": "V15818614",
      "nap_box_name": "CTO - 981",
      "created_at": "2025-03-31T13:55:54.783027",
      "service_detail": {
        "id": 12368,
        "ip": "10.12.245.2",
        "mac": "OEMT3C6207EE",
        "serial": "OEMT3C6207EE",
        "queue": null,
        "interface": "VLAN270_VALLE_FRESCO_OLT3",
        "created_at": "2026-04-20T11:29:59.342652",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7823,
      "client_name": "YOSSEPHGRILL TUPURO CUBEROS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243214561",
      "client_email": "YOSSETUPURO@GMAIL.COM",
      "address": "EZEQUIEL ZAMORA EDIFICIO TIORA PISO 1 APTO 6",
      "client_identification": "V15472395",
      "nap_box_name": "CTO-00464",
      "created_at": "2025-03-31T13:58:40.029321",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7824,
      "client_name": "YULIMAR TERESA RIVAS  LARA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Sector los Mangos",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121790316",
      "client_email": "2NEGROCELIS@GMAIL.COM",
      "address": "CALLE 02  CASA 02 LOS MANGOS ROSARIO DE PAYA",
      "client_identification": "V9972032",
      "nap_box_name": "CTO-00411",
      "created_at": "2025-03-31T15:59:29.176254",
      "service_detail": {
        "id": 8077,
        "ip": "10.12.241.2",
        "mac": "OEMT3C620166",
        "serial": "OEMT3C620166",
        "queue": "Plan_161891_30183_WispHub",
        "interface": "VLAN267_LOS_MANGOS_ZTE",
        "created_at": "2025-03-31T16:16:48.818170",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7825,
      "client_name": "LUIS DANIEL CORAO GONZALEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "1ro de Mayo Sur",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04125974124",
      "client_email": "CORAODANIEL80@GMAIL.COM",
      "address": "CALLE EL CUJI CASA NRO 02 PRIMERO DE MAYO SUR ROSARIO DE PAYA",
      "client_identification": "V28023627",
      "nap_box_name": "CTO-00470",
      "created_at": "2025-03-31T16:29:55.322007",
      "service_detail": {
        "id": 10014,
        "ip": "10.12.242.2",
        "mac": "OEMT3C624E66",
        "serial": "OEMT3C6206E6",
        "queue": null,
        "interface": "VLAN261_1ERO_MAYO_ZTE",
        "created_at": "2025-11-11T14:55:28.876061",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7826,
      "client_name": "ZONA EDUCATIVA MARINO",
      "client_type_name": "GRATIS",
      "client_subdivision": "ACTIVO_GRATIS",
      "status_name": "Activo",
      "cycle": 25,
      "migrate": true,
      "sector_name": "La Montaña",
      "plan": {
        "id": 86,
        "name": "PLAN RECURRENTE 80M GRATIS",
        "cost": "0.00",
        "code": "FO-G80",
        "profile": "80M/80M"
      },
      "client_mobile": "04121487107",
      "client_email": "UENVAHTURMERO@GMAIL.COM",
      "address": "CALLE NEGRO PRIMERO SECTOR LA MONTAÑA DIAGONAL AL OVALO DE TURMERO ESTADO ARAGUA ZONA POSTAL 2115",
      "client_identification": "J407626051",
      "nap_box_name": "ce-968",
      "created_at": "2025-03-31T16:39:03.195668",
      "service_detail": {
        "id": 8080,
        "ip": "10.12.243.2",
        "mac": "OEMT3C6253E2",
        "serial": "OEMT3C6253E2",
        "queue": "Plan_92300_15811_WispHub",
        "interface": "VLAN213_MONTANA_OLT1",
        "created_at": "2025-03-31T17:24:56.166305",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7827,
      "client_name": "YSAMAR RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124828719",
      "client_email": "YSAMARRODRIGUEZ2022@GMAIL.COM",
      "address": "EDIFICIO 28 EZEQUIEL ZAMORA",
      "client_identification": "V17324735",
      "nap_box_name": "CTO-00207 DOS",
      "created_at": "2025-03-31T16:47:23.269375",
      "service_detail": {
        "id": 9855,
        "ip": "10.12.244.2",
        "mac": "OEMT3C62023A",
        "serial": "OEMT3C62023A",
        "queue": null,
        "interface": "VLAN209_ZAMORA_OLT1",
        "created_at": "2025-11-10T18:18:09.683403",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7828,
      "client_name": "FRANCISCO JAVIER ALVARADO REYES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Las Rurales",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04120711503",
      "client_email": "FRANCISCOALVARADOREYES1990@GMAIL.COM",
      "address": "LAS RURALES CALLE POLEO CASA NRO 5 ROSARIO DE PAYA",
      "client_identification": "V20990181",
      "nap_box_name": "CE - 650",
      "created_at": "2025-04-01T08:24:55.894229",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7829,
      "client_name": "MARIAN YOSELIN MORENO CASTILLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "1ro de Mayo Norte",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04129681537",
      "client_email": "YENNIGABRIELACAPOTE@GMAIL.COM",
      "address": "PRIMERO DE MAYO NORTE LOS JABILLOS CASA NRO 04 ROSARIO DE PAYA",
      "client_identification": "V31512401",
      "nap_box_name": "CTO-00438",
      "created_at": "2025-04-01T08:35:31.485353",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7830,
      "client_name": "KATHERINE ADRIANA ALVARADO REYES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "1ro de Mayo Norte",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124867685",
      "client_email": "LACATE1515@GMAIL.COM",
      "address": "PRIMERO DE MAYO NORTE CALLE SOROCAIMA CASA NRO 05 ROSARIO DE PAYA",
      "client_identification": "V20990182",
      "nap_box_name": "CTO-00229",
      "created_at": "2025-04-01T08:41:30.593399",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7831,
      "client_name": "KATHERY ANAIS ARAUJO CASTRO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Sector los Mangos",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04167435424",
      "client_email": "CASTROKATHERY447@GMAIL.COM",
      "address": "LOS MANGOS  CALLE LAS BRISAS CASA NRO 26 ROSARIO DE PAYA",
      "client_identification": "V20989509",
      "nap_box_name": "CTO-00483",
      "created_at": "2025-04-01T08:52:29.828473",
      "service_detail": {
        "id": 11308,
        "ip": "10.12.250.2",
        "mac": "OEMT3C62065A",
        "serial": "OEMT3C62065A",
        "queue": null,
        "interface": "VLAN267_LOS_MANGOS_ZTE",
        "created_at": "2026-01-22T13:32:51.916222",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7832,
      "client_name": "NORELIS JOSEFINA NUNEZ MELENDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243061873",
      "client_email": "NNUNEZMELENDEZ@GMAIL.COM",
      "address": "EZEQUIEL ZAMORA TORRES 4 PISO 1 APTO 4",
      "client_identification": "V12767020",
      "nap_box_name": "118",
      "created_at": "2025-04-01T09:54:18.645334",
      "service_detail": {
        "id": 8109,
        "ip": "10.12.251.2",
        "mac": "HWTC49200134",
        "serial": "HWTC49200134",
        "queue": "Plan_92194_15811_WispHub",
        "interface": "VLAN209_ZAMORA_OLT1",
        "created_at": "2025-04-03T11:09:15.367688",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7833,
      "client_name": "JOHNNY GABRIEL COLMENARES AYALA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero I",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121485218",
      "client_email": "GABRIEL3127AYALA@GMAIL.COM",
      "address": "CALLE 3 CASA NRO 42 SECTOR SAMAN TARAZONERO I TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V20245849",
      "nap_box_name": "32",
      "created_at": "2025-04-01T11:07:34.037557",
      "service_detail": {
        "id": 12688,
        "ip": "10.12.126.2",
        "mac": "AD:CG:CC:A6:5F:90",
        "serial": "ADCGCCA65F90",
        "queue": null,
        "interface": "VLAN140_SMT1_ZTE",
        "created_at": "2026-07-06T10:36:23.962669",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7834,
      "client_name": "DARIA YSABEL SILVA VARGAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "1ro de Mayo Norte",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04125872708",
      "client_email": "DARIAYSAVELSILVA20@GMAIL.COM",
      "address": "CASA F3A SECTOR PRIMERO DE MAYO NORTE  EL NARANJAL ROSARIO DE PAYA",
      "client_identification": "V11122530",
      "nap_box_name": "CTO - 878",
      "created_at": "2025-04-01T11:07:44.542570",
      "service_detail": {
        "id": 8093,
        "ip": "10.12.252.2",
        "mac": "OEMT3C620E26",
        "serial": "OEMT3C620E26",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN261_1ERO_MAYO_ZTE",
        "created_at": "2025-04-01T11:20:55.719296",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7835,
      "client_name": "DIANIRA ALEXANDRA CRUZ BRAVO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128914486",
      "client_email": "RAULSANTIAGOSILVATOVAR@GMAIL.COM",
      "address": "EZEQUIEL ZAMORA TORRES 18 PISO 2 APTO 1",
      "client_identification": "V29598472",
      "nap_box_name": "118",
      "created_at": "2025-04-01T11:32:10.735914",
      "service_detail": {
        "id": 8144,
        "ip": "10.13.4.2",
        "mac": "HWTCE539169B",
        "serial": "HWTCE539169B",
        "queue": "Plan_92300_15811_WispHub",
        "interface": "VLAN209_ZAMORA_OLT1",
        "created_at": "2025-04-05T14:59:37.147115",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7836,
      "client_name": "CARLOS MANUEL DA COSTA SILVA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128150552",
      "client_email": "DACOSTAC979@GMAIL.COM",
      "address": "CASCO DE TURMERO, CALLE RICAURTE, CASA 12",
      "client_identification": "V31758681",
      "nap_box_name": "CTO-00403",
      "created_at": "2025-04-01T11:56:28.417804",
      "service_detail": {
        "id": 9444,
        "ip": "10.13.12.2",
        "mac": "OEMT3C620316",
        "serial": "OEMT3C620316",
        "queue": "queue1",
        "interface": "VLAN200_OLTs",
        "created_at": "2025-08-30T08:49:17.714025",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7837,
      "client_name": "RAMON CELESTINO PIRIZUELA HERNANDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Arboleda",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04163482928",
      "client_email": "RPIRIZUE62@GMAIL.COM",
      "address": "LA ARBOLEDA CALLE LOS NARANJOS CASA NRO 72 ROSARIO DE PAYA",
      "client_identification": "V7593746",
      "nap_box_name": "CTO-00154",
      "created_at": "2025-04-01T13:26:03.031755",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7838,
      "client_name": "JOSNIEL JESUS RIVAS CARRILLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vallecito",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144905936",
      "client_email": "JOSNIEL.JESUS345@GMAIL.COM",
      "address": "CALLE EL SAMAN N#38",
      "client_identification": "V31529400",
      "nap_box_name": "CTO-00074",
      "created_at": "2025-04-01T13:53:06.457637",
      "service_detail": {
        "id": 8112,
        "ip": "10.13.5.2",
        "mac": "OEMT3C620E12",
        "serial": "OEMT3C620E12",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN258_VALLECITO",
        "created_at": "2025-04-03T16:56:56.737074",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7839,
      "client_name": "XIOMARA TERESA ARAUJO MUÑOZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121332100",
      "client_email": "XIOMARA031060@GMAIL.COM",
      "address": "LA CASONA 2 CALLE 12 CASA #83",
      "client_identification": "V5281179",
      "nap_box_name": "CTO-00092",
      "created_at": "2025-04-01T14:49:57.033903",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7840,
      "client_name": "FELIX ALFREDO PIMENTEL RODRIGUEZ",
      "client_type_name": "EMPLEADO",
      "client_subdivision": "CANCELADO_EMPLEADO",
      "status_name": "Cancelado",
      "cycle": 25,
      "migrate": true,
      "sector_name": "Los Caobos",
      "plan": {
        "id": 78,
        "name": "Plan empleado 80MB",
        "cost": "0.00",
        "code": "FO-80M",
        "profile": "80M/80M"
      },
      "client_mobile": "04128861339",
      "client_email": "FALFREDO006@GMAIL.COM",
      "address": "AV INTERCOMUNAL TURMERO CASA NRO 32 SECTOR LOS CAOBOS, TURMERO EDO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V11977606",
      "nap_box_name": "633",
      "created_at": "2025-04-01T14:52:46.719946",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7841,
      "client_name": "YORGELYS NAZARETH TORRES AVILA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243163227",
      "client_email": "YORGELYSTRRS@GMAIL.COM",
      "address": "MATA CABALLO CALLE 4 CASA NRO 275 ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V26791308",
      "nap_box_name": "CTO-00265",
      "created_at": "2025-04-01T15:10:15.643058",
      "service_detail": {
        "id": 8105,
        "ip": "10.13.2.2",
        "mac": "HWTCCCF152CC",
        "serial": "HWTCCCF152CC",
        "queue": "queue1",
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2025-04-02T18:36:56.624741",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7842,
      "client_name": "COROMOTO DANIELA VINCI TRASOLINI",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04140482477",
      "client_email": "CDVT23@HOTMAIL.COM",
      "address": "CASCO DE TURMERO, CALLE PETION EDIFICIO DON LORENZO PISO 1 APTO 1",
      "client_identification": "V14060862",
      "nap_box_name": "CTO-00030",
      "created_at": "2025-04-01T15:22:13.860101",
      "service_detail": {
        "id": 8099,
        "ip": "10.13.1.2",
        "mac": "HWTC49200124",
        "serial": "HWTC49200124",
        "queue": "Plan_92194_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2025-04-02T09:10:05.941009",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7843,
      "client_name": "JOSE GREGORIO PORRAS PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Haras de San Pablo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124890175",
      "client_email": "JPSGREGORY7@GMAIL.COM",
      "address": "HARAS SAN PABLO, MANZANA C, CASA 62",
      "client_identification": "V21442315",
      "nap_box_name": "247",
      "created_at": "2025-04-01T15:33:13.082355",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7844,
      "client_name": "BELKYS YUSMARY BERBERCIA GUEVARA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vallecito",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04248538140",
      "client_email": "BERBECIA61@GMAIL.COM",
      "address": "VALLECITO, CALLE EL BUCARE CASA N#9",
      "client_identification": "V13701696",
      "nap_box_name": "CTO - 94",
      "created_at": "2025-04-01T15:50:42.116151",
      "service_detail": {
        "id": 8122,
        "ip": "10.13.14.2",
        "mac": "OEMT3C6205C6",
        "serial": "OEMT3C6205C6",
        "queue": "Plan_107915_30181_WispHub",
        "interface": "VLAN258_VALLECITO",
        "created_at": "2025-04-04T09:42:21.557442",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7847,
      "client_name": "ANAMILEX MARILEX PAEZ ORTIZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Betania",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04247677590",
      "client_email": "ANIXPAEZ32@GMAIL.COM",
      "address": "BETANIA, CALLE N#4 CASA N#42",
      "client_identification": "V22286451",
      "nap_box_name": "CE - 793",
      "created_at": "2025-04-01T18:58:02.465292",
      "service_detail": {
        "id": 12145,
        "ip": "10.13.16.2",
        "mac": "OEMT3C6205B6",
        "serial": "OEMT3C6205B6",
        "queue": null,
        "interface": "VLAN260_BETANIA",
        "created_at": "2026-03-20T19:38:49.929550",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7848,
      "client_name": "FRANCHEKA ALEJANDRA RODRIGUEZ RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Concepcion",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128970982",
      "client_email": "RODRIGUEZFRANCHESKA334@GMAIL.COM",
      "address": "LA CONCEPCIÓN APARTAMENTO 3 PLATA BAJA",
      "client_identification": "V30555492",
      "nap_box_name": "15",
      "created_at": "2025-04-02T10:39:26.036076",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7849,
      "client_name": "RAY ALEJANDRO CAPOTE PEREIRA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Cambur",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04127768738",
      "client_email": "RAYFPEREIRA.0303@GMAIL.COM",
      "address": "CALLE PRINCIPAL EL CAMBUR CASA N#5",
      "client_identification": "V17575707",
      "nap_box_name": "CTO-00244",
      "created_at": "2025-04-02T11:15:40.133859",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7850,
      "client_name": "ENMARY JOSE ESTANGA PALACIOS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243471711",
      "client_email": "EMMAESTANGA45@GMAIL.COM",
      "address": "PRADOS, CALLE N#4 CASA N#48 ROSARIO DE PAYA",
      "client_identification": "V32168931",
      "nap_box_name": "CTO-00301 DOS",
      "created_at": "2025-04-02T12:28:14.947663",
      "service_detail": {
        "id": 8118,
        "ip": "10.13.9.2",
        "mac": "OEMT3C62059A",
        "serial": "OEMT3C62059A",
        "queue": "Plan_107915_30181_WispHub",
        "interface": "VLAN242_PRADOS2",
        "created_at": "2025-04-04T09:13:39.312182",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7852,
      "client_name": "YRIANNY LUISANA PEREIRA PEÑA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "1ro de Mayo Norte",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04127760680",
      "client_email": "PEREIYRIANNY@GMAIL.COM",
      "address": "PRIMERO DE MAYO NORTE, PARCELA N#32 CALLE INTERCOMUNAL",
      "client_identification": "V17575047",
      "nap_box_name": "CTO-00538",
      "created_at": "2025-04-02T17:06:02.686870",
      "service_detail": {
        "id": 8137,
        "ip": "10.13.27.2",
        "mac": "OEMT3C62031E",
        "serial": "OEMT3C62031E",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN261_1ERO_MAYO_ZTE",
        "created_at": "2025-04-04T16:09:51.316426",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7853,
      "client_name": "JESUS GIOVANNI MORALES OCHOA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Macaro",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04120347002",
      "client_email": "GIONEXGIONEX@GMAIL.COM",
      "address": "MANZANA C- 3 CASA #13 SAMAN TARAZONERO II",
      "client_identification": "V17297715",
      "nap_box_name": "502",
      "created_at": "2025-04-02T17:50:50.726215",
      "service_detail": {
        "id": 8365,
        "ip": "10.13.7.2",
        "mac": "OEMT3C6209DA",
        "serial": "OEMT3C6209DA",
        "queue": "Plan_137413_1574_WispHub",
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2025-04-25T09:27:01.417943",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7855,
      "client_name": "ROSSINE DEL CARMEN ACEVEDO GONZALES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "1ro de Mayo Norte",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04122920915",
      "client_email": "ROSSINEDELCARMENA@GMAIL.COM",
      "address": "CALLE GUAICAIPURO CASA N#2",
      "client_identification": "V14973587",
      "nap_box_name": "CTO - 919",
      "created_at": "2025-04-03T10:42:06.006910",
      "service_detail": {
        "id": 9432,
        "ip": "10.13.17.2",
        "mac": "OEMT3C621042",
        "serial": "OEMT3C621042",
        "queue": "queue1",
        "interface": "VLAN261_1ERO_MAYO_ZTE",
        "created_at": "2025-08-27T10:20:51.302089",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7857,
      "client_name": "BRISLEIDA CASTILLO QUINTANA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243155771",
      "client_email": "CASTILLOBRISLEIDA@GMAIL.COM",
      "address": "RIO SECO, CALLE N#27 CASA N#16",
      "client_identification": "V13143868",
      "nap_box_name": "CTO-00077",
      "created_at": "2025-04-03T11:35:38.689540",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7858,
      "client_name": "LUIS MIGUEL RODRIGUEZ PAEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Saman Tarazonero I",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128151275",
      "client_email": "alexgrodriguezp@gmail.com",
      "address": "SAMAN TARAZONERO 1 CALLE 3 CASA 50",
      "client_identification": "V26095105",
      "nap_box_name": "32",
      "created_at": "2025-04-04T08:00:34.247097",
      "service_detail": {
        "id": 8115,
        "ip": "172.27.43.2",
        "mac": "OEMT3C3B6818",
        "serial": "OEMT3C3B6818",
        "queue": "queue1",
        "interface": "VLAN140_SMT1_ZTE",
        "created_at": "2025-04-04T08:03:34.155271",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7859,
      "client_name": "MARLENE BERENICE MAICAN URIEPERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04147412329",
      "client_email": "MARLENEMAICAN@GMAIL.COM",
      "address": "LA CASONA II CALLE 13 CASA NÚMERO 18",
      "client_identification": "V14454719",
      "nap_box_name": "CTO-00093",
      "created_at": "2025-04-04T09:28:09.327975",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7860,
      "client_name": "RICARDO ANTONIO GIANNASTASIO ANDRADE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04140396988",
      "client_email": "MATASUTES2@GMAIL.COM",
      "address": "RIO SECO, CALLE N#7 PARCELA N#3",
      "client_identification": "V19297390",
      "nap_box_name": "CTO-0610",
      "created_at": "2025-04-04T09:28:11.390826",
      "service_detail": {
        "id": 8133,
        "ip": "10.13.24.2",
        "mac": "OEMT3C621082",
        "serial": "OEMT3C621082",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN251_RIO_SECO",
        "created_at": "2025-04-04T15:38:26.239004",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7861,
      "client_name": "CRISELYS WHITNEEY CHACON SANCHEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero I",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04123986577",
      "client_email": "CRISELYSCHACON1993@GMAIL.COM",
      "address": "CALLE 3 CASA NUMERO 16, SECTOR SAMAN TARAZONERO 1, TURMERO ESTADO ARAGUA",
      "client_identification": "V25651512",
      "nap_box_name": "291",
      "created_at": "2025-04-04T09:32:25.322124",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7862,
      "client_name": "ANDRY KARY MORENO TIRADO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Guzman",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243800987",
      "client_email": "MORENOYUANDRY@GMAIL.COM",
      "address": "LA GUZMAN, CALLE PRINCIPAL, CASA N$7-2",
      "client_identification": "V18163444",
      "nap_box_name": "CTO - 1070",
      "created_at": "2025-04-04T09:44:12.515869",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7863,
      "client_name": "MINELLIS CAROLINA MORENO GAMARRA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vallecito",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124063771",
      "client_email": "MINELLYSMORENO7@GMAIL.COM",
      "address": "VALLECITO, CALLE ARAGUANEY, CASA N#8",
      "client_identification": "V20055782",
      "nap_box_name": "CTO-0479",
      "created_at": "2025-04-04T10:47:51.700186",
      "service_detail": {
        "id": 8134,
        "ip": "10.13.26.2",
        "mac": "OEMT3C62045E",
        "serial": "OEMT3C62045E",
        "queue": "Plan_161900_30183_WispHub",
        "interface": "VLAN258_VALLECITO",
        "created_at": "2025-04-04T15:49:00.757930",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7864,
      "client_name": "INGRID COROMOTO PADRON SUAREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Los Caobos",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243738782",
      "client_email": "INGRIDPADRON486@GMAIL.COM",
      "address": "CALLE 2 CASA 28 BARRIO LOS CAOBOS",
      "client_identification": "V11977387",
      "nap_box_name": "633",
      "created_at": "2025-04-04T16:04:21.123765",
      "service_detail": {
        "id": 8148,
        "ip": "10.13.20.2",
        "mac": "OEMT3C620E8E",
        "serial": "OEMT3C620E8E",
        "queue": "Plan_131337_24341_WispHub",
        "interface": "VLAN116_CAOBOS",
        "created_at": "2025-04-06T09:57:54.955430",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7865,
      "client_name": "NAYIBE DEL VALLE BRICENO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04127761187",
      "client_email": "NAYIBEBRICENO8@GMAIL.COM",
      "address": "CALLE 13 N° 77 LA CASONA II",
      "client_identification": "V9432901",
      "nap_box_name": "CTO-00088",
      "created_at": "2025-04-04T16:27:14.693760",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7866,
      "client_name": "ESKEYLA CEILIA RASQUIDES DIAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "18 de Septiembre",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04123985535",
      "client_email": "ESKEYLARASQUIDES05@GMAIL.COM",
      "address": "SAMAN DE GUERE 18 DE SEPTIEMBRE CALLE 3 CASA 121",
      "client_identification": "V6816738",
      "nap_box_name": "CE - 771",
      "created_at": "2025-04-05T10:07:12.091259",
      "service_detail": {
        "id": 11840,
        "ip": "10.13.32.2",
        "mac": "HWTC49200386",
        "serial": "HWTC49200386",
        "queue": null,
        "interface": "VLAN139_GUERITO",
        "created_at": "2026-02-27T12:07:26.419285",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7867,
      "client_name": "MARIANNY NOHEMY SALCEDO TOLEDO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "18 de Septiembre",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124583001",
      "client_email": "TOLEDOMAI61@GMAIL.COM",
      "address": "SAMAN DE GUERE 18 DE SEPTIEMBRE CALLE 3 CASA 121A",
      "client_identification": "V26095530",
      "nap_box_name": "CE - 771",
      "created_at": "2025-04-05T10:18:15.856862",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7868,
      "client_name": "NICOLAY KUDRIN REPRINZEW",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Paya Abajo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04122059525",
      "client_email": "KUDRINNICOLAY@GMAIL.COM",
      "address": "CALLE EL CENTRO CASA # 7 SECTOR PAYA ABAJO TURMERO ESTADO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V7216241",
      "nap_box_name": "CTO-00307",
      "created_at": "2025-04-05T11:09:37.230419",
      "service_detail": {
        "id": 8141,
        "ip": "10.13.30.2",
        "mac": "OEMT3C620F7E",
        "serial": "OEMT3C620F7E",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN231_PAYABAJO",
        "created_at": "2025-04-05T11:39:26.705484",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7869,
      "client_name": "VICTOR MIGUEL MENDEZ YEGRES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados de Cafetal",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04123514550",
      "client_email": "VICTORMIGUELMENDEZYEGRES@GMAIL.COM",
      "address": "ANTIGUA HACIENDA PAYA SECTOR VALLE DE PALLA CALLEJÓN LYNCON CONJUNTO RESIDENCIAL VILLAS DE TURMERO PARCELA A EDIFICIO GLADIOLA N#8",
      "client_identification": "V23867409",
      "nap_box_name": "CTO-0449",
      "created_at": "2025-04-05T12:54:34.926109",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7870,
      "client_name": "SAILIS CAROLINA RAMOS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman de Guere",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04161231622",
      "client_email": "REIMERODREMAN34@GMAIL.COM",
      "address": "SAMAN DE GUERE NORTE CALLE LA LLANERA CASA 270",
      "client_identification": "V24930996",
      "nap_box_name": "290",
      "created_at": "2025-04-05T13:23:08.967603",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7871,
      "client_name": "HECTOR JOSE DIAZ GAMERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Macaro",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04126265625",
      "client_email": "ANDRESDIAZSAEZ1010@GMAIL.COM",
      "address": "URBANIZACIÓN VILLA SAN JOSÉ CASA 0118",
      "client_identification": "V13870554",
      "nap_box_name": "14",
      "created_at": "2025-04-05T14:21:12.588069",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7873,
      "client_name": "MISTER DENT STUDIO CA",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04124561285",
      "client_email": "STEVEN.APONTE.SUAREZ@GMAIL.COM",
      "address": "TURMERO CALLE MIRANDA CC LORENZO OFICINA 3",
      "client_identification": "J506755815",
      "nap_box_name": "CAJA NAP BICENTENARIO",
      "created_at": "2025-04-05T16:29:00.470491",
      "service_detail": {
        "id": 8180,
        "ip": "10.13.36.2",
        "mac": "HWTC49200375",
        "serial": "HWTC49200375",
        "queue": "Plan_92194_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2025-04-08T15:22:29.394513",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7874,
      "client_name": "DIANA MILENA LOPEZ DURAN",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ppal Paya",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121988656",
      "client_email": "DIANALOPEZ100185@GMAIL.COM",
      "address": "PRIMERO DE MAYO SUR CALLE EL LIMÓN CASA # 9",
      "client_identification": "V17724386",
      "nap_box_name": "CTO-00149",
      "created_at": "2025-04-05T21:10:56.743292",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7875,
      "client_name": "JEISMAR SARAI OROPEZA BLANCO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Santa Eduviges",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243133655",
      "client_email": "JSARAIBLANCO@GMAIL.COM",
      "address": "SANTA EDUVIGES CALLE PRINCIPAL CASA NÚMERO 50",
      "client_identification": "V31970270",
      "nap_box_name": "CTO-00262",
      "created_at": "2025-04-06T15:25:43.273002",
      "service_detail": {
        "id": 13094,
        "ip": "10.13.38.2",
        "mac": "HW:TC:49:20:01:21",
        "serial": "HWTC49200121",
        "queue": null,
        "interface": "VLAN143_STAEDUVIGES2",
        "created_at": "2026-10-01T12:08:41.571316",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7876,
      "client_name": "ROSIRIS DEL CARMEN VELASQUEZ MARTINEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243394698",
      "client_email": "ROSIRISVELASQUEZ.50@GMAIL.COM",
      "address": "LA CASONA 2 CALLE 14 CASA 1",
      "client_identification": "V11435006",
      "nap_box_name": "CTO-00087",
      "created_at": "2025-04-06T16:46:43.855531",
      "service_detail": {
        "id": 8164,
        "ip": "10.13.39.2",
        "mac": "HWTC49200125",
        "serial": "HWTC49200125",
        "queue": "Plan_148293_24341_WispHub",
        "interface": "VLAN110_CASONA_2",
        "created_at": "2025-04-07T15:37:18.321676",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7877,
      "client_name": "FAY WU WU",
      "client_type_name": "PYME",
      "client_subdivision": "CANCELADO_PYME",
      "status_name": "Cancelado",
      "cycle": 10,
      "migrate": true,
      "sector_name": "El Macaro",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04248919591",
      "client_email": "DANIELUNDA060@GMAIL.COM",
      "address": "AV PRINCIPAL EL MACARO GALPÓN 1 turmero zona postal 2115",
      "client_identification": "V25287997",
      "nap_box_name": "CE-00141",
      "created_at": "2025-04-07T12:20:44.609566",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7878,
      "client_name": "MILAGROS DEL VALLE TABLANTE RENGIFO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Leocolbo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04143841131",
      "client_email": "ISABELLATABLANTES@GMAIL.COM",
      "address": "VALLES DE LEOCOLBO CALLE A #39",
      "client_identification": "V9695045",
      "nap_box_name": "49",
      "created_at": "2025-04-07T12:33:19.195420",
      "service_detail": {
        "id": 12068,
        "ip": "10.13.41.2",
        "mac": "OEMT3C6209FA",
        "serial": "OEMT3C6209FA",
        "queue": null,
        "interface": "VLAN144_LEOCOLBO",
        "created_at": "2026-03-15T13:03:36.387837",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7879,
      "client_name": "JAVIER JESUS IZQUIERDO PACHECO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villas El Carmen",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243093959",
      "client_email": "JAVIERJESUS756@GMAIL.COM",
      "address": "TURMERO URBANIZACIÓN VILLAS DEL CARMEN",
      "client_identification": "V23801915",
      "nap_box_name": "49",
      "created_at": "2025-04-07T14:18:30.333240",
      "service_detail": {
        "id": 8163,
        "ip": "10.13.42.2",
        "mac": "OEMT3C620AAE",
        "serial": "OEMT3C620AAE",
        "queue": "Plan_127996_1574_WispHub",
        "interface": "VLAN135_VILLAS_CARMEN_OLT_ZTE",
        "created_at": "2025-04-07T15:31:10.025960",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7881,
      "client_name": "JESUS ALBERTO DA CAMARA ROJAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Arboleda",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128944666",
      "client_email": "JESUSDACAMARA533@GMAIL.COM",
      "address": "LA ARBOLEDA, CALLE EL RÍO, #111",
      "client_identification": "V30005037",
      "nap_box_name": "CTO-00154",
      "created_at": "2025-04-07T17:53:44.497898",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7882,
      "client_name": "MARIA OSMARA GOMEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144516719",
      "client_email": "OSMARAGOMEZ0514@GMAIL.COM",
      "address": "TORRE 8 ESCALERA 1 PLANTA BAJA APTO 2 ANTIGUA HACIENDA EL NÍSPERO",
      "client_identification": "V10752965",
      "nap_box_name": "118",
      "created_at": "2025-04-07T18:47:55.308540",
      "service_detail": {
        "id": 8172,
        "ip": "10.13.46.2",
        "mac": "OEMT3C620682",
        "serial": "OEMT3C620682",
        "queue": "Plan_107915_15811_WispHub",
        "interface": "VLAN209_ZAMORA_OLT1",
        "created_at": "2025-04-08T10:05:29.122826",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7883,
      "client_name": "YULI JOSEFINA MENDEZ FLORES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Concepcion III",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04123693531",
      "client_email": "YJMF76@GMAIL.COM",
      "address": "URBANIZACIÓN CONCEPCIÓN 3 CALLE 3 CASA 45",
      "client_identification": "V13283513",
      "nap_box_name": "CTO-00456",
      "created_at": "2025-04-07T19:26:46.340534",
      "service_detail": {
        "id": 11293,
        "ip": "10.13.47.2",
        "mac": "OEMT3C62545E",
        "serial": "OEMT3C62545E",
        "queue": null,
        "interface": "VLAN111_CONCEPCION",
        "created_at": "2026-01-21T23:34:49.813931",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7884,
      "client_name": "KATLEYA  JOSEFINA MORONTA ESPAÑA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Dios Es Mi Refugio",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04123982226",
      "client_email": "MORONTAKATLEYA@GMAIL.COM",
      "address": "DIOS ES MI REFUGIO, MANZANA 1, # 11",
      "client_identification": "V12610787",
      "nap_box_name": "CTO-0656",
      "created_at": "2025-04-07T22:01:10.123777",
      "service_detail": {
        "id": 8209,
        "ip": "10.13.48.2",
        "mac": "OEMT3C620F56",
        "serial": "OEMT3C620F56",
        "queue": "Plan_92306_15811_WispHub",
        "interface": "VLAN271_DIOS_ES_MI_REFUGIO_OLT1",
        "created_at": "2025-04-10T17:23:35.342826",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7885,
      "client_name": "WUILMAN EDITH GOMEZ GUERRA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Jabillar",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243295132",
      "client_email": "WUILED2@GMAIL.COM",
      "address": "CALLE LOS CAOBOS #0305 EL MACARO",
      "client_identification": "V8809712",
      "nap_box_name": "CTO-00006 C/4 JABILLAR",
      "created_at": "2025-04-08T10:16:15.825020",
      "service_detail": {
        "id": 8175,
        "ip": "10.13.49.2",
        "mac": "OEMT3C6202A6",
        "serial": "OEMT3C6202A6",
        "queue": "Plan_127996_1574_WispHub",
        "interface": "VLAN108_JABILLAR_OLT_ZTE",
        "created_at": "2025-04-08T11:11:46.606540",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7887,
      "client_name": "RICHAR JUNIOR GOMEZ LUGO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Durpa",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243641530",
      "client_email": "RICHARGMZ@GMAIL.COM",
      "address": "DURPA, CALLE SIMÓN RODRÍGUEZ, MANZANA15, CASA# 6",
      "client_identification": "V25880181",
      "nap_box_name": "382",
      "created_at": "2025-04-08T11:59:13.645597",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7888,
      "client_name": "GENESIS YORLEY HERNANDEZ HERNANDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243168430",
      "client_email": "GENEHERNANDEZ0604@GMAIL.COM",
      "address": "EZEQUIEL ZAMORA TORRE 18 PISO 4 APARTAMENTO 2",
      "client_identification": "V22942994",
      "nap_box_name": "CTO-00464",
      "created_at": "2025-04-08T14:28:04.547629",
      "service_detail": {
        "id": 8179,
        "ip": "10.13.51.2",
        "mac": "OEMT3C62104A",
        "serial": "OEMT3C62104A",
        "queue": "Plan_107915_15811_WispHub",
        "interface": "VLAN209_ZAMORA_OLT1",
        "created_at": "2025-04-08T14:34:36.458170",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7889,
      "client_name": "NELLY ESPERANZA BONILLA USECHE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "18 de Septiembre",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04122124940",
      "client_email": "ALIDAALVARES35@GMAIL.COM",
      "address": "SAMAN DE GUERE, 18 DE SEPTIEMBRE CALLE 2 CASA 58",
      "client_identification": "V5643364",
      "nap_box_name": "CE - 771",
      "created_at": "2025-04-08T15:29:57.240400",
      "service_detail": {
        "id": 11835,
        "ip": "10.13.52.2",
        "mac": "HWTC49200382",
        "serial": "HWTC49200382",
        "queue": null,
        "interface": "VLAN139_GUERITO",
        "created_at": "2026-02-27T12:04:38.475722",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7891,
      "client_name": "ROSANA MARILIN GOMEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "SUSPENDIDO_RESIDENCIAL",
      "status_name": "Suspendido",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ppal Paya",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04125971928",
      "client_email": "ARAUJODANILE974@GMAIL.COM",
      "address": "CALLE LAS BRISAS SECTOR LOS MANGOS CASA #29",
      "client_identification": "V28045225",
      "nap_box_name": "CTO-00483",
      "created_at": "2025-04-08T15:57:46.255312",
      "service_detail": {
        "id": 11709,
        "ip": "10.13.56.2",
        "mac": "OEMT3C62104E",
        "serial": "OEMT3C62104E",
        "queue": null,
        "interface": "VLAN267_LOS_MANGOS_ZTE",
        "created_at": "2026-02-22T12:18:27.770058",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7893,
      "client_name": "ELISA MERCEDES MORENO DE OJEDA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "18 de Septiembre",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124873019",
      "client_email": "ELISAMERCEDESMORENO@GMAIL.COM",
      "address": "SAMAN DE GUERE, 18 DE SEPTIEMBRE CALLE 2 CASA 4",
      "client_identification": "V10455537",
      "nap_box_name": "CE - 771",
      "created_at": "2025-04-08T17:05:05.986392",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7894,
      "client_name": "YUSMARY JAQUELINE LUNA BORGES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Payita",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04169473089",
      "client_email": "YUSMARYLUNA10@GMAIL.COM",
      "address": "PAYITA, CALLEJÓN LOS LUNAS, CASA# 20",
      "client_identification": "V15490008",
      "nap_box_name": "CTO - 1023",
      "created_at": "2025-04-08T17:37:35.358390",
      "service_detail": {
        "id": 12096,
        "ip": "10.13.71.2",
        "mac": "OEMT3C620FE2",
        "serial": "OEMT3C620FE2",
        "queue": null,
        "interface": "VLAN284_PAYITA",
        "created_at": "2026-03-16T19:04:30.689842",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7895,
      "client_name": "INGRID MARGARITA MILANO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman de Guere",
      "plan": {
        "id": 101,
        "name": "RECURRENTE RESIDENCIAL PLAN 200M",
        "cost": "19.00",
        "code": "FOR200MB",
        "profile": "200Mbps/200Mbps"
      },
      "client_mobile": "04121790421",
      "client_email": "INGRIDMARGARITAMILANO@GMAIL.COM",
      "address": "SAMAN DE GUERE CALLE LIBERTADOR CASA 40",
      "client_identification": "V12737548",
      "nap_box_name": "CE-00099",
      "created_at": "2025-04-09T08:42:10.307125",
      "service_detail": {
        "id": 11842,
        "ip": "10.13.57.2",
        "mac": "HWTC49200902",
        "serial": "HWTC49200902",
        "queue": null,
        "interface": "VLAN139_GUERITO",
        "created_at": "2026-02-27T12:08:06.437494",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7896,
      "client_name": "YURAIMA TERESA QUINTANA LUNA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243392887",
      "client_email": "QUINTAYURAIMATERESA@GMAIL.COM",
      "address": "EZEQUIEL ZAMORA  TORRE 22 PISO 3 APTO 3",
      "client_identification": "V10759366",
      "nap_box_name": "CTO-00464",
      "created_at": "2025-04-09T11:01:36.492685",
      "service_detail": {
        "id": 13006,
        "ip": "10.13.59.2",
        "mac": "OE:MT:3C:62:08:1E",
        "serial": "OEMT3C62081E",
        "queue": null,
        "interface": "VLAN209_ZAMORA_OLT1",
        "created_at": "2026-09-12T10:55:28.002434",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7897,
      "client_name": "MARINELA JOSEFINA MACHADO ENTRADA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "San Pablo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144885686",
      "client_email": "NELACHMACHADO@HOTMAIL.COM",
      "address": "SAN PABLO RESIDENCIA LAGUNA I EDIFICIO 14 APARTAMENTO A 1",
      "client_identification": "V14039054",
      "nap_box_name": "635",
      "created_at": "2025-04-09T11:11:26.140577",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7898,
      "client_name": "AURIS GABRIELA PENA TREJO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ppal Paya",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04125026340",
      "client_email": "AURISGP165@GMAIL.COM",
      "address": "PPAL DE PAYA, VEREDA 16 DE NOVIEMBRE, CASA NO. 1",
      "client_identification": "V15962805",
      "nap_box_name": "CTO - 919",
      "created_at": "2025-04-09T11:49:17.716698",
      "service_detail": {
        "id": 8193,
        "ip": "10.13.60.2",
        "mac": "OEMT3C620DCE",
        "serial": "OEMT3C620DCE",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN261_1ERO_MAYO_ZTE",
        "created_at": "2025-04-09T16:24:28.427696",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7899,
      "client_name": "MARIA ELENA GUTIERREZ GRIBORIO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Concepcion",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04145995945",
      "client_email": "MARIAGRIBORIO24@GMAIL.COM",
      "address": "URBANIZACIÓN SANTA EDUVIGES CALLE 1 PASERLA 14",
      "client_identification": "V11290546",
      "nap_box_name": "CTO-00262",
      "created_at": "2025-04-09T14:18:36.804122",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7900,
      "client_name": "OMAIRA SABINA REYES PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ppal Paya",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243758076",
      "client_email": "OMAIRADECHUAO@GMAIL.COM",
      "address": "SECTOR PALMA REAL, CALLE 5, CASA 77 ROSARIO DE PAYA",
      "client_identification": "V14944132",
      "nap_box_name": "CTO-00391",
      "created_at": "2025-04-09T15:17:59.085912",
      "service_detail": {
        "id": 8195,
        "ip": "10.13.62.2",
        "mac": "OEMT3C62119A",
        "serial": "OEMT3C62119A",
        "queue": "Plan_107915_30181_WispHub",
        "interface": "VLAN244_PALMAREAL",
        "created_at": "2025-04-09T16:33:01.802985",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7901,
      "client_name": "MARIANA BELISOL PALMA CHANG",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ppal Paya",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04125988672",
      "client_email": "MARIANAPALMA0608@GMAIL.COM",
      "address": "SECTOR LAS PALMAS CALLEJON LOS TANQUES CASA NÚMERO 28",
      "client_identification": "V27204730",
      "nap_box_name": "CTO - 919",
      "created_at": "2025-04-09T18:52:11.105010",
      "service_detail": {
        "id": 13126,
        "ip": "10.13.63.2",
        "mac": "HW:TC:49:20:05:33",
        "serial": "HWTC49200533",
        "queue": null,
        "interface": "VLAN261_1ERO_MAYO_ZTE",
        "created_at": "2026-10-06T12:12:43.033555",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7902,
      "client_name": "WILFREDO JESUS PALMA CHANG",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ppal Paya",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121013012",
      "client_email": "WILFREDOPALMA607@GMAIL.COM",
      "address": "CASCO DE TURMERO, SAGRADO CORAZÓN DE JESÚS CASA NÚMERO 26",
      "client_identification": "V28479068",
      "nap_box_name": "CTO-004444",
      "created_at": "2025-04-09T19:12:06.695549",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7903,
      "client_name": "LOYCAR MARGARITA MATUTE LOPEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Concepcion",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04140516533",
      "client_email": "LOYCARMATUTE11@GMAIL.COM",
      "address": "CONJUNTO RESIDENCIAL LOS SAMANES SECTOR GUERITO TORRE 7A APARTAMENTO 4A",
      "client_identification": "V19604910",
      "nap_box_name": "CTO-00456",
      "created_at": "2025-04-09T19:50:09.965298",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7904,
      "client_name": "JOSE ENRIQUE CORTEZ BORGUES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Marcelota",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04162028702",
      "client_email": "ANTONI190613@GMAIL.COM",
      "address": "LA MARCELOTA, CALLE LAGUNITA CASA # 12",
      "client_identification": "V12611956",
      "nap_box_name": "CTO-00256",
      "created_at": "2025-04-09T20:32:19.867929",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7905,
      "client_name": "MARBELYS JACKELINE CASTILLO MENDOZA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243182758",
      "client_email": "MARBELYSCASTILLO1994@GMAIL.COM",
      "address": "EZEQUIEL ZAMORA CALLE CARREÑO CASA N-9",
      "client_identification": "V23783115",
      "nap_box_name": "CTO-00464",
      "created_at": "2025-04-10T11:49:28.775918",
      "service_detail": {
        "id": 8200,
        "ip": "10.13.66.2",
        "mac": "HWTC49200905",
        "serial": "HWTC49200905",
        "queue": "Plan_92300_15811_WispHub",
        "interface": "VLAN209_ZAMORA_OLT1",
        "created_at": "2025-04-10T14:31:31.867427",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7906,
      "client_name": "JOSE DIONICIO MADRIZ ACOSTA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "1ro de Mayo Norte",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04122086902",
      "client_email": "JOSEMADRIZ487@GMAIL.COM",
      "address": "PRIMERO DE MAYO NORTE, CALLE CHACAO, CASA 14",
      "client_identification": "V10357280",
      "nap_box_name": "CTO - 900",
      "created_at": "2025-04-10T12:20:56.529573",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7907,
      "client_name": "YENIFFER RINCON COBA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "SUSPENDIDO_RESIDENCIAL",
      "status_name": "Suspendido",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villas El Carmen",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243782437",
      "client_email": "jeimyb199@gmail.com",
      "address": "VILLAS DEL CARMEN, CALLE 11, CASA NÚMERO 5",
      "client_identification": "V11157959",
      "nap_box_name": "40",
      "created_at": "2025-04-10T13:12:44.523809",
      "service_detail": {
        "id": 12397,
        "ip": "10.13.68.2",
        "mac": "OEMT3C620F3E",
        "serial": "OEMT3C620F3E",
        "queue": null,
        "interface": "VLAN135_VILLAS_CARMEN_OLT_ZTE",
        "created_at": "2026-04-22T19:50:05.939208",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7908,
      "client_name": "JEAN PAUL FUMERO HURTADO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "San Pablo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243603254",
      "client_email": "JPFUMEROH@GMAIL.COM",
      "address": "URBANIZACIÓN SAN PABLO CALLE HICELE CASA 8 TURMERO",
      "client_identification": "V20336383",
      "nap_box_name": "26",
      "created_at": "2025-04-10T14:14:48.446692",
      "service_detail": {
        "id": 10369,
        "ip": "10.13.69.2",
        "mac": "OEMT3C620F42",
        "serial": "OEMT3C620F42",
        "queue": null,
        "interface": "VLAN200_OLTs",
        "created_at": "2025-11-28T09:24:30.375950",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7910,
      "client_name": "KATHERINE KRISS ROJAS GUEVARA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Aduana",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243209647",
      "client_email": "KATTYKRISS40@GMAIL.COM",
      "address": "CALLE MELLAO CASA 4 SECTOR LA ADUANA CENTRO DE TURMERO",
      "client_identification": "V16253923",
      "nap_box_name": "111",
      "created_at": "2025-04-10T14:41:00.208740",
      "service_detail": {
        "id": 8206,
        "ip": "10.13.72.2",
        "mac": "OEMT3C621092",
        "serial": "OEMT3C621092",
        "queue": "Plan_92300_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2025-04-10T14:56:49.891089",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7911,
      "client_name": "AIXA ERLINDA MOREAN VILLEGAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04262011376",
      "client_email": "MOREANAIXA69@GMAIL.COM",
      "address": "MATA CABALLO, CALLE 6, NÚMERO 422",
      "client_identification": "V7560612",
      "nap_box_name": "CTO-00031",
      "created_at": "2025-04-10T14:56:29.534325",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7913,
      "client_name": "NANCY MISAEL MATOS NIEVES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243052057",
      "client_email": "NANCISA28MN@GMAIL.COM",
      "address": "URBANIZACIÓN ANTIGUA HACIENDA EL NÍSPERO EZEQUIEL ZAMORA TORRE 27 PISO 1 APARTAMENTO 2",
      "client_identification": "V10759338",
      "nap_box_name": "CTO-00464",
      "created_at": "2025-04-10T21:08:25.156214",
      "service_detail": {
        "id": 12008,
        "ip": "10.13.76.2",
        "mac": "OEMT3C62090A",
        "serial": "OEMT3C62090A",
        "queue": null,
        "interface": "VLAN209_ZAMORA_OLT1",
        "created_at": "2026-03-08T12:21:59.043239",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7915,
      "client_name": "DAVID JAVIER TARAZONA BERNAL",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ppal Paya",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128908317",
      "client_email": "YULIYANIBEL18052@GMAIL.COM",
      "address": "PPAL DE PAYA, SECTOR PRIMERO DE MAYO, CASA NO. 25",
      "client_identification": "V29923854",
      "nap_box_name": "CTO-00225",
      "created_at": "2025-04-11T08:51:37.253691",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7916,
      "client_name": "ALEXIS OSCAR GONZALEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vallecito",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04125987176",
      "client_email": "RACSOBYAKKO13@GMAIL.COM",
      "address": "VALLECITO, CALLE EL SAMAN, CASA# 2",
      "client_identification": "V10758313",
      "nap_box_name": "CTO - 110",
      "created_at": "2025-04-11T11:31:04.464655",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7917,
      "client_name": "JUAN JESUS SOSA MEZA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "1ro de Mayo Norte",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04122230871",
      "client_email": "JUANSOSAJHONNARY667@GMAIL.COM",
      "address": "PRIMERO DE MAYO NORTE, CALLE TAMANACO, CASA #2",
      "client_identification": "V18701379",
      "nap_box_name": "CTO-00383",
      "created_at": "2025-04-11T12:43:43.009877",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7918,
      "client_name": "GLADIS MARIA PEREZ CARRASQUEL",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Valle del Rosario",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04125879641",
      "client_email": "FELICIDADDIAZR@GMAIL.COM",
      "address": "ROSARIO DE PAYA LAS RURALES CALLE MIGUEL POLEO CASA 15",
      "client_identification": "V26535911",
      "nap_box_name": "CE - 650",
      "created_at": "2025-04-11T12:49:34.755407",
      "service_detail": {
        "id": 8222,
        "ip": "10.13.84.2",
        "mac": "OEMT3C6208FA",
        "serial": "OEMT3C6208FA",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN252_RURALES_PAYA",
        "created_at": "2025-04-14T08:41:05.221482",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7919,
      "client_name": "SELSO ANTONIO FERNANDEZ PERAZA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "SUSPENDIDO_RESIDENCIAL",
      "status_name": "Suspendido",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Guerito",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121576944",
      "client_email": "SELSOF123@GMAIL.COM",
      "address": "SAN MIGUEL, CALLE SIMÓN BOLIVAR, CASA 5",
      "client_identification": "V6516144",
      "nap_box_name": "CE-00099",
      "created_at": "2025-04-11T14:08:43.712709",
      "service_detail": {
        "id": 11839,
        "ip": "10.13.81.2",
        "mac": "OEMT3C620D36",
        "serial": "OEMT3C620D36",
        "queue": null,
        "interface": "VLAN139_GUERITO",
        "created_at": "2026-02-27T12:07:09.105143",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7920,
      "client_name": "VICTOR MANUEL MUNOZ ACOSTA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04141818664",
      "client_email": "YARISMARBRAVO0@GMAIL.COM",
      "address": "RIO SECO, CALLE 7, CASA #13",
      "client_identification": "V18490209",
      "nap_box_name": "CTO-00408",
      "created_at": "2025-04-12T09:06:18.385739",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7921,
      "client_name": "MARIANA PATRICIA SALCEDO GUTIERREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "San Pablo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243424814",
      "client_email": "MARIANASALCEDOG21@GMAIL.COM",
      "address": "URBANIZACIÓN SAN PABLO PRIMERA AVENIDA CASA NUMERO 12",
      "client_identification": "V20335211",
      "nap_box_name": "CTO-00577",
      "created_at": "2025-04-12T11:04:53.625327",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7922,
      "client_name": "LUIS HERNAN YAJURE BERMUDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Valle del Rosario",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04129363957",
      "client_email": "YAJURELUISHERNAN6@GMAIL.COM",
      "address": "ROSARIO DE PAYA SECTOR VALLECITO CALLE LOS NARANJOS CASA 10",
      "client_identification": "V10843462",
      "nap_box_name": "CTO - 00395",
      "created_at": "2025-04-12T12:47:53.962991",
      "service_detail": {
        "id": 8234,
        "ip": "10.13.94.2",
        "mac": "OEMT3C62048A",
        "serial": "OEMT3C62048A",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN258_VALLECITO",
        "created_at": "2025-04-14T12:07:56.687576",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7923,
      "client_name": "ERIKA MARIBEL BRITO ALFONZO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Sector los Mangos",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128900276",
      "client_email": "DENIYERDECASTRO86@GMAIL.COM",
      "address": "ROSARIO DE PAYA SECTOR EL CAMBUR CALLE LAS PALMAS CASA# 28",
      "client_identification": "V17245679",
      "nap_box_name": "CTO-00098",
      "created_at": "2025-04-12T12:59:13.061441",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7924,
      "client_name": "KINBERLIN TATIANA LEDEZMA GUARASMO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "1ro de Mayo Norte",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128898167",
      "client_email": "LUIYER933@GMAIL.COM",
      "address": "PRIMERO DE MAYO NORTE, CALLE INTERCONTINENTAL, BARRIO EL ESFUERZO, CASA NO. 6",
      "client_identification": "V18088099",
      "nap_box_name": "CTO- 908",
      "created_at": "2025-04-12T13:08:38.742580",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7925,
      "client_name": "LILIANA JOSEFINA SALAS DE UTRERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243378086",
      "client_email": "KRO250398@GMAIL.COM",
      "address": "CASCO DE TURMERO, CALLE SALIAS, CRUCE CON RIVAS, CASA #14",
      "client_identification": "V10456230",
      "nap_box_name": "103",
      "created_at": "2025-04-12T14:30:29.700772",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7926,
      "client_name": "DENYERBERTH MIGUEL DIAZ HERNANDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vallecito",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121771568",
      "client_email": "DIAZDENYER0112@GMAIL.COM",
      "address": "CALLE MORICHE CASA NÚMERO 15 SECTOR VALLECITO ROSARIO DE PAYA",
      "client_identification": "V30764646",
      "nap_box_name": "CTO-00115",
      "created_at": "2025-04-12T14:39:33.794244",
      "service_detail": {
        "id": 8227,
        "ip": "10.13.90.2",
        "mac": "OEMT3C62099A",
        "serial": "OEMT3C62099A",
        "queue": "Plan_161895_30183_WispHub",
        "interface": "VLAN258_VALLECITO",
        "created_at": "2025-04-14T09:00:16.347494",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7927,
      "client_name": "MARYORI SABINA ESTEVES ROJAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Sector los Mangos",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04123304532",
      "client_email": "CASAINTERNET930@GMAIL.COM",
      "address": "SECTOR LOS MANGOS CALLE SEGUNDA TRANSVERSAL CASA # 6",
      "client_identification": "V15831556",
      "nap_box_name": "CTO-00MAN",
      "created_at": "2025-04-12T14:45:37.785269",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7928,
      "client_name": "JOSE ALEJANDRO PALACIO AULAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Las Palmas",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128982008",
      "client_email": "JOSEPALACI13@GMAIL.COM",
      "address": "CALLE PRINCIPAL LAS PALMAS CASA NÚMERO 1, SECTOR LAS PALMAS ROSARIO DE PAYA",
      "client_identification": "V30211292",
      "nap_box_name": "CTO-00098",
      "created_at": "2025-04-12T15:49:52.254639",
      "service_detail": {
        "id": 8225,
        "ip": "10.13.87.2",
        "mac": "OEMT3C62070A",
        "serial": "OEMT3C62070A",
        "queue": "Plan_161905_30183_WispHub",
        "interface": "VLAN262_LAS_PALMAS_ZTE",
        "created_at": "2025-04-14T08:48:13.281420",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7930,
      "client_name": "YULIANNY PROVIDENCIA BANDES APONTE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vallecito",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04129683905",
      "client_email": "APONTEYULIANNY45@GMAIL.COM",
      "address": "SECTOR VALLECITO CALLE LOS NARANJOS CASA# 26 ROSARIO DE PAYA",
      "client_identification": "V22948779",
      "nap_box_name": "CTO-00082",
      "created_at": "2025-04-12T17:02:51.115064",
      "service_detail": {
        "id": 12567,
        "ip": "10.13.85.2",
        "mac": "OE:MT:3C:62:0A:D6",
        "serial": "OEMT3C620AD6",
        "queue": null,
        "interface": "VLAN258_VALLECITO",
        "created_at": "2026-06-02T14:12:57.400098",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7931,
      "client_name": "NORMA MICHEL FALCON PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Las Rurales",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04125798167",
      "client_email": "FALCONNORMA815@GMAIL.COM",
      "address": "ROSARIO DE PAYA SECTOR LAS RURALES CALLE SUCRE CASA 2-1",
      "client_identification": "V18975266",
      "nap_box_name": "CTO-00223",
      "created_at": "2025-04-14T10:53:20.952318",
      "service_detail": {
        "id": 8244,
        "ip": "10.13.99.2",
        "mac": "OEMT3C620A02",
        "serial": "OEMT3C620A02",
        "queue": "Plan_107915_30181_WispHub",
        "interface": "VLAN252_RURALES_PAYA",
        "created_at": "2025-04-14T15:26:38.892310",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7932,
      "client_name": "ERIKA ADELHEIS FALCON LUNA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04140535760",
      "client_email": "ERIKAFALCON060401@GMAIL.COM",
      "address": "EZEQUIEL ZAMORA, CALLE CARREÑO, TORRE 9, PISO 1, APARTAMENTO 2",
      "client_identification": "V15129389",
      "nap_box_name": "CTO-00464",
      "created_at": "2025-04-14T13:35:15.111920",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7934,
      "client_name": "YORKA DESIREE MORA ROMERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona I",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243222149",
      "client_email": "YORKAMORA02@GMAIL.COM",
      "address": "AVENIDA INTERCOMUNAL TURMERO LA CASONA 1, CALLE 4 CASA #54",
      "client_identification": "V14860394",
      "nap_box_name": "45",
      "created_at": "2025-04-14T14:52:26.621100",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7935,
      "client_name": "ELIZABETH PORFIRIA GUTIERREZ DE YEPEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144920171",
      "client_email": "ELIGUTI71@GMAIL.COM",
      "address": "LA CASONA I, CALLE 5 CASA 34",
      "client_identification": "V11985337",
      "nap_box_name": "CE - 408",
      "created_at": "2025-04-14T15:00:22.820488",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7936,
      "client_name": "AARON YOENDRY BARRUETA FAGUDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243155702",
      "client_email": "AARONYOENDRY@GMAIL.COM",
      "address": "MATA CABALLO, AV 2, CASA 488, ROSARIO DE PAYA",
      "client_identification": "V17985830",
      "nap_box_name": "CTO-00567 DOS",
      "created_at": "2025-04-14T15:21:29.107466",
      "service_detail": {
        "id": 10906,
        "ip": "10.13.100.2",
        "mac": "HWTC49200986",
        "serial": "HWTC49200986",
        "queue": null,
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2025-12-23T13:06:23.504854",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7937,
      "client_name": "MIGUEL ANGEL CARRILLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Valle Verde",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128869208",
      "client_email": "MIGUEL.CARRILLO1305@GMAIL.COM",
      "address": "VALLE VERDE, CALLE LA TANQUILLA, CASA 20",
      "client_identification": "V9922010",
      "nap_box_name": "CE - 650",
      "created_at": "2025-04-14T16:32:40.634512",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7938,
      "client_name": "MARLIN CAROLINA CORTEZ CARBAJAL",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vallecito",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04262599816",
      "client_email": "MARLINC817@GMAIL.COM",
      "address": "SECTOR VALLECITO CALLEJÓN CIEGO LA CEIBA CASA # 2 ROSARIO DE PAYA",
      "client_identification": "V17247857",
      "nap_box_name": "CTO-00081",
      "created_at": "2025-04-14T18:22:27.590528",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7939,
      "client_name": "NORELKYS GABRIELA VARGAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "1ro de Mayo Norte",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128861714",
      "client_email": "GABRIELA987ROJASSS@GMAIL.COM",
      "address": "CALLE MANAURE CASA 19 SECTOR PRIMERO DE MAYO NORTE ROSARIO DE PAYA",
      "client_identification": "V17459136",
      "nap_box_name": "CE - 846",
      "created_at": "2025-04-14T18:23:19.193907",
      "service_detail": {
        "id": 8252,
        "ip": "10.13.103.2",
        "mac": "OEMT3C620C76",
        "serial": "OEMT3C620C76",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN261_1ERO_MAYO_ZTE",
        "created_at": "2025-04-15T08:48:35.116922",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7940,
      "client_name": "ROSA MARVELIS PINERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Los Mangos",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04122634640",
      "client_email": "rosamarbelisp@gmail.com",
      "address": "CALLEJON MATÓ CASA #7 SECTOR LOS MANGOS ROSARIO DE PAYA",
      "client_identification": "V9437057",
      "nap_box_name": "CTO - 953",
      "created_at": "2025-04-14T18:28:50.042062",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7941,
      "client_name": "ISNOEL PIMENTEL PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Los Mangos",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04129683037",
      "client_email": "ISNOELPIMENTEL6@GMAIL.COM",
      "address": "SECTOR LOS MANGOS CALLEJON MIGUEL POLEO CASA # 22 ROSARIO DE PAYA",
      "client_identification": "V12167776",
      "nap_box_name": "CTO-00223",
      "created_at": "2025-04-14T19:09:37.606593",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7942,
      "client_name": "AURIMAR ADELAIDA VARGAS PRIETO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "San Pablo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243716266",
      "client_email": "AURIMARV97@GMAIL.COM",
      "address": "URBANIZACIÓN SAN PABLO TERCERA AVENIDA CASA 16 TURMERO",
      "client_identification": "V26224566",
      "nap_box_name": "140",
      "created_at": "2025-04-14T19:16:59.411882",
      "service_detail": {
        "id": 8271,
        "ip": "10.13.105.2",
        "mac": "OEMT3C620156",
        "serial": "OEMT3C620156",
        "queue": "Plan_107915_15811_WispHub",
        "interface": "VLAN224_SAN_PABLO_OLT1",
        "created_at": "2025-04-15T19:14:22.409159",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7943,
      "client_name": "LUIS ALFREDO CAMARGO ALVARADO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Betania",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243118183",
      "client_email": "YAMILETTCORRALES80@GMAIL.COM",
      "address": "BETANIA, CALLE 06, CASA #305",
      "client_identification": "V22344784",
      "nap_box_name": "CTO-00348",
      "created_at": "2025-04-15T10:31:53.530634",
      "service_detail": {
        "id": 11328,
        "ip": "10.13.107.2",
        "mac": "OEMT3C6208B2",
        "serial": "OEMT3C6208B2",
        "queue": null,
        "interface": "VLAN255_TERRAZAS_PAYA",
        "created_at": "2026-01-23T11:25:18.949205",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7945,
      "client_name": "MAHILETH YEANMARY VELASQUEZ AGUILAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Santa Eduviges",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144748722",
      "client_email": "VELASQUEZMAHILETH@GMAIL.COM",
      "address": "VIA INTERCOMUNAL URBANIZACIÓN SANTA EDUVIGES CALLE PRINCIPAL NÚMERO 87",
      "client_identification": "V20649789",
      "nap_box_name": "CTO-00262",
      "created_at": "2025-04-15T12:21:11.766562",
      "service_detail": {
        "id": 10967,
        "ip": "10.13.108.2",
        "mac": "OEMT3C621102",
        "serial": "OEMT3C621102",
        "queue": null,
        "interface": "VLAN143_STAEDUVIGES2",
        "created_at": "2025-12-26T19:58:01.083588",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7946,
      "client_name": "NAILIN CELESTE LAYA LAYA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Guanarito",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121486145",
      "client_email": "MERRYLAYA2000@GMAIL.COM",
      "address": "GUANARITO, CALLE GERMAN REQUENA CASA #18",
      "client_identification": "V27286556",
      "nap_box_name": "CTO-00214",
      "created_at": "2025-04-15T14:22:26.217862",
      "service_detail": {
        "id": 8269,
        "ip": "10.13.109.2",
        "mac": "OEMT3C620792",
        "serial": "OEMT3C620792",
        "queue": "Plan_92300_15811_WispHub",
        "interface": "VLAN232_GUANARITO_OLT2",
        "created_at": "2025-04-15T15:41:05.725987",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7947,
      "client_name": "CARMEN ELENA LICON HERNANDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "San Pablo",
      "plan": {
        "id": 16,
        "name": "RECURRENTE RESIDENCIAL PLAN 800M",
        "cost": "55.00",
        "code": "FOR800",
        "profile": "800M/800M"
      },
      "client_mobile": "04127702238",
      "client_email": "CELELI21@GMAIL.COM",
      "address": "SAN PABLO, CONJUNTO RESIDENCIAL LAGUNA PLAZA  SECTOR 2 EDIFICIO 6 PB APARTAMENTO 4",
      "client_identification": "V14437236",
      "nap_box_name": "CE - 140",
      "created_at": "2025-04-15T17:17:50.807482",
      "service_detail": {
        "id": 8276,
        "ip": "10.13.112.2",
        "mac": "HWTC49200987",
        "serial": "HWTC49200987",
        "queue": "Plan_92194_15811_WispHub",
        "interface": "VLAN216_LAGUNA_PLAZA_OLT1",
        "created_at": "2025-04-16T09:04:47.289592",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7948,
      "client_name": "SANCHO PEDRO CAPOTE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Cambur",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04161494902",
      "client_email": "YONMIS4HIJOS@GMAIL.COM",
      "address": "SECTOR EL CAMBUR CALLE PRINCIPAL EL CAMBUR CASA# 30_01 ROSARIO DE PAYA",
      "client_identification": "V5627608",
      "nap_box_name": "CTO - 912",
      "created_at": "2025-04-15T18:28:23.180900",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7949,
      "client_name": "LILIANA CAROLINA AGUILAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Los Hornos",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124614031",
      "client_email": "ALBERTOR23783@GMAIL.COM",
      "address": "ROSARIO DE PAYA SECTOR LOS HORNOS CALLE #6 CASA #6",
      "client_identification": "V23629202",
      "nap_box_name": "CTO-00288",
      "created_at": "2025-04-15T21:08:30.972249",
      "service_detail": {
        "id": 8274,
        "ip": "10.13.110.2",
        "mac": "OEMT3C620956",
        "serial": "OEMT3C620956",
        "queue": "Plan_107915_30181_WispHub",
        "interface": "VLAN247_HORNOS",
        "created_at": "2025-04-16T08:56:38.568544",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7950,
      "client_name": "FELIX ANTONIO CAMPOS ALVARADO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Los Mangos",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144925972",
      "client_email": "FELIXCAMPOS2020@GMAIL.COM",
      "address": "CALLE SEGUNDA CASA NRO 3 SECTOR LOS MANGOS ROSARIO DE PAYA",
      "client_identification": "V8818105",
      "nap_box_name": "CE-00111",
      "created_at": "2025-04-16T10:37:47.271362",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7951,
      "client_name": "YECGARIS FABIOLA GUDINO MORA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Los Mangos",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121484491",
      "client_email": "YECGARISG@GMAIL.COM",
      "address": "SECTOR LOS MANGOS, CALLE MERIDA, CASA NRO115-2 ROSARIO DE PAYA",
      "client_identification": "V26791731",
      "nap_box_name": "CTO - 953",
      "created_at": "2025-04-16T12:26:33.329491",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7952,
      "client_name": "YOLANDA KARLAY VALLADARES FERNANDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243022336",
      "client_email": "KARLAYVALLADARES6@GMAIL.COM",
      "address": "PANTIN CALLE 13B CASA NRO 55 ROSARIO DE PAYA",
      "client_identification": "V24930420",
      "nap_box_name": "CTO-00171",
      "created_at": "2025-04-16T12:54:45.472573",
      "service_detail": {
        "id": 8284,
        "ip": "10.13.116.2",
        "mac": "OEMT3C6204FE",
        "serial": "OEMT3C6204FE",
        "queue": "PLAN_PYME_600M_PAYA",
        "interface": "VLAN229_PANTIN",
        "created_at": "2025-04-16T15:28:06.676108",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7953,
      "client_name": "KEILA DELIMER PANTOJA CASTILLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vallecito",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243492330",
      "client_email": "KEILAPANTOJA86@GMAIL.COM",
      "address": "SECTOR VALLECITO CALLE PRINCIPAL EL MORICHE CASA # 19 ROSARIO DE PAYA",
      "client_identification": "V20334585",
      "nap_box_name": "CTO-00115",
      "created_at": "2025-04-16T12:58:43.176453",
      "service_detail": {
        "id": 9674,
        "ip": "10.13.117.2",
        "mac": "OEMT3C6203A6",
        "serial": "OEMT3C6203A6",
        "queue": null,
        "interface": "VLAN258_VALLECITO",
        "created_at": "2025-11-03T16:11:19.926795",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7954,
      "client_name": "ADEXA JOSEFINA PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vista Hermosa",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121486351",
      "client_email": "PEREZADEXA5@GMAIL.COM",
      "address": "CALLE EL ROSARIO CASA NÚMERO 35 VISTA HERMOSA ROSARIO DE PAYA",
      "client_identification": "V5994527",
      "nap_box_name": "CTO-00060",
      "created_at": "2025-04-16T13:31:29.039778",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7955,
      "client_name": "FRANKLIN EDUARDO YANES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04141104801",
      "client_email": "YANESFRANKLIN06@GMAIL.COM",
      "address": "URBANIZACIÓN LOS NÍSPEROS TORRE 5 ESCALERA 2 PLANTA BAJA APARTAMENTO 1",
      "client_identification": "V16227283",
      "nap_box_name": "CTO-00464",
      "created_at": "2025-04-16T16:34:29.952447",
      "service_detail": {
        "id": 12410,
        "ip": "10.13.119.2",
        "mac": "DF51A640EE04",
        "serial": "DF51A640EE04",
        "queue": null,
        "interface": "VLAN209_ZAMORA_OLT1",
        "created_at": "2026-04-24T19:06:18.663587",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7956,
      "client_name": "CARLOS EDUARDO HURTADO TOVAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "San Pablo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121790300",
      "client_email": "CARLOSHURTADOTOVAR2@GMAIL.COM",
      "address": "URBANIZACIÓN SAN PABLO CALLE HICELE MANZANA 8 UNA CUADRA ANTES DE CC MILAN PLAZA CASA 8",
      "client_identification": "V24433104",
      "nap_box_name": "26",
      "created_at": "2025-04-17T10:13:25.507212",
      "service_detail": {
        "id": 13160,
        "ip": "10.13.127.2",
        "mac": "OE:MT:3C:62:0A:FA",
        "serial": "OEMT3C620AFA",
        "queue": null,
        "interface": "VLAN200_OLTs",
        "created_at": "2026-10-13T13:16:58.800511",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7957,
      "client_name": "DARWINS JOSE BULLON GONZÁLEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144911762",
      "client_email": "DARWINSJABG1@GMAIL.COM",
      "address": "LA CASONA 2, CALLE 12 CASA #13",
      "client_identification": "V11984568",
      "nap_box_name": "322",
      "created_at": "2025-04-17T16:26:51.524816",
      "service_detail": {
        "id": 8297,
        "ip": "10.13.120.2",
        "mac": "HWTC49201015",
        "serial": "HWTC49201015",
        "queue": "Plan_131337_24341_WispHub",
        "interface": "VLAN110_CASONA_2",
        "created_at": "2025-04-18T15:12:45.646965",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7958,
      "client_name": "MIRLA JOSEFINA SANCHEZ TOVAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona I",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243299335",
      "client_email": "MIRLAJOSEFINA2003@GMAIL.COM",
      "address": "AV INTERCOMUNAL URBANIZACIÓN LA CASONA 1 CALLE 9 CASA #98",
      "client_identification": "V7246468",
      "nap_box_name": "45",
      "created_at": "2025-04-17T16:55:42.876247",
      "service_detail": {
        "id": 8298,
        "ip": "10.13.121.2",
        "mac": "HWTC49201010",
        "serial": "HWTC49201010",
        "queue": "Plan_131337_24341_WispHub",
        "interface": "VLAN109_CASONA_1",
        "created_at": "2025-04-18T15:15:31.739070",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7959,
      "client_name": "JESUS MARIA RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vallecito",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144446722",
      "client_email": "NIDIAMARIANANERVIS051925@GMAIL.COM",
      "address": "CALLE LAS ACACIAS CASA #5 COLINAS DE VALLECITO",
      "client_identification": "V8761012",
      "nap_box_name": "CTO-00VALLEC",
      "created_at": "2025-04-17T17:03:38.151616",
      "service_detail": {
        "id": 8300,
        "ip": "10.13.122.2",
        "mac": "OEMT3C62084E",
        "serial": "OEMT3C62084E",
        "queue": "Plan_107915_30181_WispHub",
        "interface": "VLAN258_VALLECITO",
        "created_at": "2025-04-18T18:16:16.536687",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7960,
      "client_name": "JAICELYS ALEJANDRA MARCANO ZABALA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vallecito",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04163058705",
      "client_email": "JAICELYS45@GMAIL.COM",
      "address": "SECTOR VALLECITO CALLE ARAGUANEY CALLEJÓN LAS PIÑAS CASA #01",
      "client_identification": "V26163402",
      "nap_box_name": "CTO - 110",
      "created_at": "2025-04-17T17:31:28.590195",
      "service_detail": {
        "id": 8301,
        "ip": "10.13.123.2",
        "mac": "HWTC49201012",
        "serial": "HWTC49201012",
        "queue": "Plan_107915_30181_WispHub",
        "interface": "VLAN258_VALLECITO",
        "created_at": "2025-04-18T18:19:36.476892",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7961,
      "client_name": "MARCOS ALEXANDER GOYO SERENO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Macaro",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121772446",
      "client_email": "ANASIVIRA77@GMAIL.COM",
      "address": "SAMAN TARAZONERO 1 CALLE 3 CASA 45 EL MACARO",
      "client_identification": "V12509727",
      "nap_box_name": "32",
      "created_at": "2025-04-18T10:48:16.728644",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7963,
      "client_name": "KLEIVERY ESTEPHANY BONACI BRICEÑO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "1ro de Mayo Norte",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04123983508",
      "client_email": "ESTEPHANYBONACI@GMAIL.COM",
      "address": "CALLE AQUILES NAZOA CASA NÚMERO 19 SECTOR SIMÓN BOLIVAR PRIMERO DE MAYO NORTE ROSARIO DE PAYA",
      "client_identification": "V30956721",
      "nap_box_name": "CTO-00538",
      "created_at": "2025-04-18T13:57:22.344400",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7964,
      "client_name": "LUZ MARINA PEREZ PUERTA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Terrazas de Paya",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04129612580",
      "client_email": "LUZMARINA07.1988@GMAIL.COM",
      "address": "TERRAZAS DE PAYA, CALLE 6 MANZANA 5 CASA # 6",
      "client_identification": "V19552645",
      "nap_box_name": "CTO-0417",
      "created_at": "2025-04-18T17:02:17.785832",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7967,
      "client_name": "MARIA ELENA GUEVARA DE ROJAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243209647",
      "client_email": "KATHERINEKRISS40@GMAIL.COM",
      "address": "CASCO DE TURMERO , CALLE RIVAS EDIFICIO SAN JORGE PISO 2 -1",
      "client_identification": "V5978633",
      "nap_box_name": "CTO-00129",
      "created_at": "2025-04-20T07:24:06.086369",
      "service_detail": {
        "id": 8310,
        "ip": "10.13.128.2",
        "mac": "OEMT3C621096",
        "serial": "OEMT3C621096",
        "queue": "Plan_107915_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2025-04-20T13:47:13.769496",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7968,
      "client_name": "PAOLA SARAI YBARRA PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "1ro de Mayo Sur",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124461648",
      "client_email": "PAOLAYBARRA29@GMAIL.COM",
      "address": "ROSARIO DE PAYA 1ERO DE MAYO SUR CALLE N#3 CASAN#13",
      "client_identification": "V25841723",
      "nap_box_name": "CTO-00237",
      "created_at": "2025-04-21T09:47:56.767207",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7969,
      "client_name": "WINSTON ESTEBAN BARRERA LIENDO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04128950935",
      "client_email": "BARRERAWISTON4@GMAIL.COM",
      "address": "CASCO DE TURMERO, CALLE RICAURTE CRUCE CON MADARIAGA #31",
      "client_identification": "V13199230",
      "nap_box_name": "84",
      "created_at": "2025-04-21T09:50:26.218980",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7970,
      "client_name": "HENRY NELSON CARRILLO BRITO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Los Mangos",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04123984084",
      "client_email": "HENRYNELSON0904@GMAIL.COM",
      "address": "CALLE 2DA CASA NRO22-4 SECTOR LOS MANGOS ROSARIO DE PAYA",
      "client_identification": "V6402999",
      "nap_box_name": "CTO-00MAN",
      "created_at": "2025-04-21T10:39:36.221359",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7971,
      "client_name": "DANIEL ERNESTO MARTINEZ LUQUE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Guzman",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144520357",
      "client_email": "TRINALUQUE64@GMAIL.COM",
      "address": "CALLE SAN PABLO CASA NÚMERO 10 ZONA AGRARIA ZONA LA GUZMAN",
      "client_identification": "V8732213",
      "nap_box_name": "CTO-00407",
      "created_at": "2025-04-21T13:15:50.997810",
      "service_detail": {
        "id": 8316,
        "ip": "10.13.132.2",
        "mac": "OEMT3C6207E2",
        "serial": "OEMT3C6207E2",
        "queue": "Plan_107915_30181_WispHub",
        "interface": "VLAN286_LA_GUZMAN",
        "created_at": "2025-04-21T17:07:52.437661",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7972,
      "client_name": "JHON GREGORI PADILLA RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados de Cafetal",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243661347",
      "client_email": "JHONGREGORIPADILLA788@GMAIL.COM",
      "address": "PRADOS DEL CAFETAL CALLE 1 TWHOUSE #3 ROSARIO DE PAYA",
      "client_identification": "V17575862",
      "nap_box_name": "544",
      "created_at": "2025-04-21T13:19:16.777630",
      "service_detail": {
        "id": 8317,
        "ip": "10.13.133.2",
        "mac": "OEMT3C620FDA",
        "serial": "OEMT3C620FDA",
        "queue": "Plan_107915_15811_WispHub",
        "interface": "VLAN221_CAFETAL_OLT1",
        "created_at": "2025-04-21T17:11:27.086705",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7973,
      "client_name": "AREDIS YUSELYN OCHOA FRANCO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Macaro",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243074721",
      "client_email": "AREDISOCHOA23@GMAIL.COM",
      "address": "URBANIZACIÓN TAGUAPIRE \nCALLE 3 \nAPTO 97\nEL MACARO- TURMERO",
      "client_identification": "V15302084",
      "nap_box_name": "289",
      "created_at": "2025-04-21T14:47:25.717407",
      "service_detail": {
        "id": 11643,
        "ip": "10.13.134.2",
        "mac": "OEMT3C6203E6",
        "serial": "OEMT3C6203E6",
        "queue": null,
        "interface": "VLAN129_TAGUAPIRE_ZTE",
        "created_at": "2026-02-17T10:33:02.063178",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7974,
      "client_name": "DEISY JEANETH DELGADO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Los Mangos",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04127484720",
      "client_email": "ABGDEISYDELGADO@GMAIL.COM",
      "address": "LOS MANGOS, SEGUNDA CALLE, CASA #12",
      "client_identification": "V14636460",
      "nap_box_name": "CTO - 919",
      "created_at": "2025-04-21T16:20:57.943095",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7975,
      "client_name": "ANNY MILAGROS VASQUEZ INFANTE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Callejon Los Jabillos",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144866870",
      "client_email": "ANNY223484@GMAIL.COM",
      "address": "CALLE LOS JABILLOS CASA 62-2A , CALLEJÓN LOS JABILLOS rosario de paya",
      "client_identification": "V17513381",
      "nap_box_name": "99",
      "created_at": "2025-04-21T16:30:01.052232",
      "service_detail": {
        "id": 8320,
        "ip": "10.13.135.2",
        "mac": "HWTC49201009",
        "serial": "HWTC49201009",
        "queue": "Plan_92194_15811_WispHub",
        "interface": "VLAN250_LIM_OLT2",
        "created_at": "2025-04-21T17:23:54.149327",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7976,
      "client_name": "YORIANGELIS CAROLINA CHIRINOS CHIQUITO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Concepcion",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04266497485",
      "client_email": "CYORIANGELIS@GMAIL.COM",
      "address": "LA CONCEPCIÓN, CALLE 3 CASA 27",
      "client_identification": "V30755354",
      "nap_box_name": "109",
      "created_at": "2025-04-21T17:18:20.260105",
      "service_detail": {
        "id": 13162,
        "ip": "10.13.136.2",
        "mac": "OE:MT:3C:62:06:1A",
        "serial": "OEMT3C62061A",
        "queue": null,
        "interface": "VLAN111_CONCEPCION",
        "created_at": "2026-10-13T13:25:47.787109",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7977,
      "client_name": "GREISMAR ALEJANDRA AGRAZ BRITO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Las Palmas",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121118717",
      "client_email": "CARLOSLUISPRIETOBORGES@GMAIL.COM",
      "address": "SECTOR LAS PALMAS CALLEJÓN EL TANQUE PARCELA 28 # 171 ROSARIO DE PAYA",
      "client_identification": "V27286132",
      "nap_box_name": "CTO-00098",
      "created_at": "2025-04-21T17:37:17.530384",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7978,
      "client_name": "KAECY FERNANDA HERNANDEZ PINEDA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Los Hornos",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121488801",
      "client_email": "PINEDA27FEER@GMAIL.COM",
      "address": "ROSARIO DE PAYA CALLE LOS HORNOS CASA NÚMERO 23",
      "client_identification": "V30658816",
      "nap_box_name": "594",
      "created_at": "2025-04-21T17:37:26.662228",
      "service_detail": {
        "id": 8388,
        "ip": "10.13.156.2",
        "mac": "HWTC49201019",
        "serial": "HWTC49201019",
        "queue": "Plan_161900_30183_WispHub",
        "interface": "VLAN247_HORNOS",
        "created_at": "2025-04-28T10:49:48.777631",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7979,
      "client_name": "EVA ELENA FLORES BARRETO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vallecito",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243156464",
      "client_email": "FLORESEVA739@GMAIL.COM",
      "address": "AV PRINCIPAL CASA NRO 109 SECTOR VALLECITO ROSARIO DE PAYA",
      "client_identification": "V11977745",
      "nap_box_name": "CE-00080",
      "created_at": "2025-04-21T18:59:46.424899",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7980,
      "client_name": "FREDDY EDUARDO MORALES FERNANDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Payita",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243279872",
      "client_email": "MARIAARANDAB1986@GMAIL.COM",
      "address": "CALLEJON VUELVAN CARAS CASA NRO 4 SECTOR PAYITA",
      "client_identification": "V18854195",
      "nap_box_name": "CTO - 1023",
      "created_at": "2025-04-21T19:09:12.733130",
      "service_detail": {
        "id": 9701,
        "ip": "10.13.139.2",
        "mac": "OEMT3C6201B6",
        "serial": "OEMT3C6201B6",
        "queue": null,
        "interface": "VLAN284_PAYITA",
        "created_at": "2025-11-07T18:49:20.649934",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7982,
      "client_name": "IVETH DEL SOCORRO CUETO ORTIZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "San Pablo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243151605",
      "client_email": "CUETOIVETH640@GMAIL.COM",
      "address": "TURMERO, URBANIZACIÓN CAMELON GUITE CALLE 1 EDIFICIO 3C PISO 1 APARTAMENTO 3C",
      "client_identification": "V24669639",
      "nap_box_name": "CTO-00413",
      "created_at": "2025-04-22T11:53:26.743850",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7983,
      "client_name": "JESICA ROSMARY GUEVARA URBANO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "1ro de Mayo Norte",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04264548794",
      "client_email": "JESIGUEVARA52@GMAIL.COM",
      "address": "INTERCOMUNAL DE PAYA SECTOR SIMÓN BOLIVAR CALLE AQUILES NAZOA CASA# 14",
      "client_identification": "V26535102",
      "nap_box_name": "CTO-00538",
      "created_at": "2025-04-22T13:39:45.058519",
      "service_detail": {
        "id": 8329,
        "ip": "10.13.141.2",
        "mac": "OEMT3C620E9E",
        "serial": "OEMT3C620E9E",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN261_1ERO_MAYO_ZTE",
        "created_at": "2025-04-22T16:56:52.050343",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7984,
      "client_name": "YULEIDY ALEXANDRA MUNOZ BOLIVAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243193633",
      "client_email": "BLANCALANDAETA2@GMAIL.COM",
      "address": "AV INTERNACIONAL CASONA II EDIFICIO 12 PISO 1 APT 2",
      "client_identification": "V23633643",
      "nap_box_name": "CE - 424",
      "created_at": "2025-04-22T16:42:14.099089",
      "service_detail": {
        "id": 11204,
        "ip": "10.13.161.2",
        "mac": "HWTC49201004",
        "serial": "HWTC49201004",
        "queue": null,
        "interface": "VLAN110_CASONA_2",
        "created_at": "2026-01-16T14:48:48.404340",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7985,
      "client_name": "VILMA ELIZABETH OLLARVES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04122165880",
      "client_email": "OLLARVESVILMAELIZABETH@GMAIL.COM",
      "address": "AV INTERCOMUNAL LA CASONA II EDIFICIO 12 PISO PLANTA BAJA 03",
      "client_identification": "V9675672",
      "nap_box_name": "CTO-00086",
      "created_at": "2025-04-22T17:26:40.376061",
      "service_detail": {
        "id": 12792,
        "ip": "10.13.162.2",
        "mac": "HW:TC:49:20:10:06",
        "serial": "HWTC49201006",
        "queue": null,
        "interface": "VLAN110_CASONA_2",
        "created_at": "2026-08-06T08:56:10.964491",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7986,
      "client_name": "YURI CAROLINA MANZO DE LUNA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Valle Verde",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243268911",
      "client_email": "JOSEABLANCO.08@GMAIL.COM",
      "address": "CALLEJON LOS MAMONES CASA NRO  7-4 SECTOR VALLE VERDE ROSARIO DE PAYA",
      "client_identification": "V16435304",
      "nap_box_name": "CTO-00187",
      "created_at": "2025-04-22T17:54:07.111945",
      "service_detail": {
        "id": 8330,
        "ip": "10.13.142.2",
        "mac": "OEMT3C620EA6",
        "serial": "OEMT3C620EA6",
        "queue": "Plan_107915_30181_WispHub",
        "interface": "VLAN253_VALLE_VERDE",
        "created_at": "2025-04-22T21:45:56.391375",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7987,
      "client_name": "NINA ROSA BONASI",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "1ro de Mayo Norte",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04123359411",
      "client_email": "NINABONACI@GMAIL.COM",
      "address": "PRIMERO DE MAYO NORTE, CALLE MARA, CASA # 5. ROSARIO DE PAYA",
      "client_identification": "V15600463",
      "nap_box_name": "CTO-00383",
      "created_at": "2025-04-22T18:06:11.529489",
      "service_detail": {
        "id": 9391,
        "ip": "10.13.163.2",
        "mac": "HWTC49201013",
        "serial": "HWTC49201013",
        "queue": "queue1",
        "interface": "VLAN261_1ERO_MAYO_ZTE",
        "created_at": "2025-08-18T13:31:30.862462",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7988,
      "client_name": "ERIC EFREN TIRADO LANDAETA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243428577",
      "client_email": "ERIC59TIRADO@GMAIL.COM",
      "address": "SAMAN TARAZONERO II, MANZANA B-11 CASA 01",
      "client_identification": "V8732269",
      "nap_box_name": "186",
      "created_at": "2025-04-22T18:37:58.370165",
      "service_detail": {
        "id": 10155,
        "ip": "10.13.143.2",
        "mac": "OEMT3C620556",
        "serial": "OEMT3C620556",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2025-11-15T17:18:43.131649",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7989,
      "client_name": "NORA DEL CARMEN HERNANDEZ DE BLANCO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243593258",
      "client_email": "HGUSTAVOBLANCO@GMAIL.COM",
      "address": "MATA CABALLO , CALLE 4 CASA 246",
      "client_identification": "V8582068",
      "nap_box_name": "CTO-00265",
      "created_at": "2025-04-22T19:37:49.125537",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7991,
      "client_name": "MARIA LIONZA PENA DE BELLORIN",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "SUSPENDIDO_RESIDENCIAL",
      "status_name": "Suspendido",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Marcelota",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243556561",
      "client_email": "MPLIONZA2010@GMAIL.COM",
      "address": "LA MARCELOTA, CALLE PRINCIPAL CASA NÚMERO 26, ROSARIO DE PAYA,TURMERO",
      "client_identification": "V6041383",
      "nap_box_name": "CTO - 1059",
      "created_at": "2025-04-23T09:00:45.695225",
      "service_detail": {
        "id": 12473,
        "ip": "10.13.226.2",
        "mac": "80:D4:A5:A4:2E:C1",
        "serial": "HWTC49200748",
        "queue": null,
        "interface": "VLAN281_MARCELOTA",
        "created_at": "2026-05-07T12:39:41.331023",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7992,
      "client_name": "ESTEBAN JOSE YEPEZ TERAN",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Los Nisperos",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243576687",
      "client_email": "ESTEBANYEPEZ0102@GMAIL.COM",
      "address": "LOS NÍSPEROS TURMERO, AVENIDA CARREÑO EDIFICIO 04- E 01 PISO 03, APARTAMENTO 02",
      "client_identification": "V11406282",
      "nap_box_name": "118",
      "created_at": "2025-04-23T12:28:33.491601",
      "service_detail": {
        "id": 12409,
        "ip": "10.13.146.2",
        "mac": "OEMT3C620F86",
        "serial": "OEMT3C620F86",
        "queue": null,
        "interface": "VLAN209_ZAMORA_OLT1",
        "created_at": "2026-04-24T18:53:11.237811",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7993,
      "client_name": "AMBAR JOHANA ONTIVERO GUEVARA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04262154898",
      "client_email": "AMBARJ.GUEVARA18@GMAIL.COM",
      "address": "CASCO DE TURMERO, CALLE URDANETA CASA N#99",
      "client_identification": "V14861183",
      "nap_box_name": "CTO-00403",
      "created_at": "2025-04-23T14:38:24.387793",
      "service_detail": {
        "id": 8355,
        "ip": "10.13.164.2",
        "mac": "OEMT3C620A9A",
        "serial": "OEMT3C620A9A",
        "queue": "Plan_92300_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2025-04-24T15:17:01.989718",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7994,
      "client_name": "KENIA YANIXA PULIDO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Macaro",
      "plan": {
        "id": 101,
        "name": "RECURRENTE RESIDENCIAL PLAN 200M",
        "cost": "19.00",
        "code": "FOR200MB",
        "profile": "200Mbps/200Mbps"
      },
      "client_mobile": "04121769217",
      "client_email": "KENIAYANIXAPULIDO@GMAIL.COM",
      "address": "EL MACARO URBANIZACIÓN SIMÓN BOLÍVAR CALLE 2 CASA 9",
      "client_identification": "V9533951",
      "nap_box_name": "CTO-00042",
      "created_at": "2025-04-23T15:37:17.887057",
      "service_detail": {
        "id": 8336,
        "ip": "10.13.147.2",
        "mac": "OEMT3C6200FA",
        "serial": "OEMT3C6200FB",
        "queue": "queue1",
        "interface": "VLAN128_SIMON_BOLIVAR_ZTE",
        "created_at": "2025-04-23T16:43:35.916385",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7995,
      "client_name": "MARIA LUCRECIA REYES DIAZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona I",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243794223",
      "client_email": "LUCRESIA.REYES.1963@GMAIL.COM",
      "address": "LA CASONA I, EDIFICIO D PISO 03 APT 02 CONJ. RES. LOS JARDINES",
      "client_identification": "V7246979",
      "nap_box_name": "38",
      "created_at": "2025-04-23T16:33:00.492025",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 7996,
      "client_name": "JOHAN DAMIAN VIVAS CONTRERAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Valle lindo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04145365193",
      "client_email": "DVIVAS13@GMAIL.COM",
      "address": "VALLE LINDO,  CALLE 5, CASA 1. TURMERO",
      "client_identification": "V14786678",
      "nap_box_name": "CE - 952",
      "created_at": "2025-04-23T16:34:08.959717",
      "service_detail": {
        "id": 12954,
        "ip": "10.13.149.2",
        "mac": "OE:MT:3C:62:08:12",
        "serial": "OEMT3C620812",
        "queue": null,
        "interface": "VLAN274_VALLELINDO",
        "created_at": "2026-09-02T13:10:29.662633",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7997,
      "client_name": "RODOLFO VENANCIO PEREZ TOVAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "1ro de Mayo Sur",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04165466387",
      "client_email": "RODOLFOPEREZ1864@GMAIL.COM",
      "address": "PRIMERO DE MAYO SUR, CALLE 2, CASA 2. ROSARIO DE PAYA",
      "client_identification": "V7244608",
      "nap_box_name": "CTO - 00398",
      "created_at": "2025-04-23T16:35:48.117660",
      "service_detail": {
        "id": 8339,
        "ip": "10.13.150.2",
        "mac": "OEMT3C62073A",
        "serial": "OEMT3C62073A",
        "queue": "Plan_107915_30181_WispHub",
        "interface": "VLAN261_1ERO_MAYO_ZTE",
        "created_at": "2025-04-23T18:50:40.696974",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7998,
      "client_name": "GILBERT JOSE RIVERO UZCATEGUI",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Magdalena",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243448951",
      "client_email": "GILBERTRIVEUZ@GMAIL.COM",
      "address": "URBANISMO LOS SAMANES, TERRAZA 9, EDIFICIO B, PISO 1 APARTAMENTO 3-B",
      "client_identification": "V32220777",
      "nap_box_name": "CTO-00072",
      "created_at": "2025-04-23T18:36:03.228529",
      "service_detail": {
        "id": 8340,
        "ip": "10.13.151.2",
        "mac": "OEMT3C620306",
        "serial": "OEMT3C620306",
        "queue": "Plan_131337_24341_WispHub",
        "interface": "VLAN139_GUERITO",
        "created_at": "2025-04-23T19:49:31.910145",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 7999,
      "client_name": "DORA DEL VALLE BARRIOS RIVAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Los Nisperos",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243405148",
      "client_email": "DORABARRIOS2216@GMAIL.COM",
      "address": "CALLE BOLIVAR CONJUNTO RESIDENCIAL LOS NISPEROS TORRE C PISO 6 APARTAMENTO 61",
      "client_identification": "V24402194",
      "nap_box_name": "88",
      "created_at": "2025-04-24T08:14:10.594419",
      "service_detail": {
        "id": 8344,
        "ip": "10.13.154.2",
        "mac": "OEMT3C620AEA",
        "serial": "OEMT3C620AEA",
        "queue": "Plan_107915_15811_WispHub",
        "interface": "VLAN272_EDIF_NISPEROS_OLT3",
        "created_at": "2025-04-24T10:14:36.057817",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8000,
      "client_name": "GISELE CAROLINA GALINDO HERNANDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Guayabita",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243410097",
      "client_email": "GISELE.GALINDO2@GMAIL.COM",
      "address": "GUAYABITA, CASERÍO VALLE DEL RÍO, CALLE PÉREZ ROJAS, CASA 68-1. TURMERO",
      "client_identification": "V16338144",
      "nap_box_name": "CTO - 1075",
      "created_at": "2025-04-24T08:55:38.410671",
      "service_detail": {
        "id": 8342,
        "ip": "10.13.152.2",
        "mac": "OEMT3C620BA6",
        "serial": "OEMT3C620BA6",
        "queue": "Plan_107915_30181_WispHub",
        "interface": "VLAN286_LA_GUZMAN",
        "created_at": "2025-04-24T09:58:16.733119",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8001,
      "client_name": "OSCAR ALEJANDRO RODRIGUEZ ENRIQUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "1ro de Mayo Sur",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04127777691",
      "client_email": "ALEDEK1987@GMAIL.COM",
      "address": "PRIMERO DE MAYO SUR, CALLE 4, CASA NRO 4. ROSARIO DE PAYA",
      "client_identification": "V18474048",
      "nap_box_name": "CTO-00157",
      "created_at": "2025-04-24T09:22:44.119245",
      "service_detail": {
        "id": 8343,
        "ip": "10.13.153.2",
        "mac": "OEMT3C620CAA",
        "serial": "OEMT3C620CAA",
        "queue": "Plan_107915_30181_WispHub",
        "interface": "VLAN261_1ERO_MAYO_ZTE",
        "created_at": "2025-04-24T10:00:41.309098",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8002,
      "client_name": "ELIDE DE FATIMA BERNAL RIVAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "1ro de Mayo Sur",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121598521",
      "client_email": "ELIDE8657@GMAIL.COM",
      "address": "CALLE LA PAZ CASA NRO 10 BARRIO PRIMERO DE MAYO SUR",
      "client_identification": "V28219032",
      "nap_box_name": "CE-00064",
      "created_at": "2025-04-24T10:14:20.834933",
      "service_detail": {
        "id": 8345,
        "ip": "10.13.155.2",
        "mac": "OEMT3C6207F2",
        "serial": "OEMT3C6207F2",
        "queue": "Plan_107915_30181_WispHub",
        "interface": "VLAN261_1ERO_MAYO_ZTE",
        "created_at": "2025-04-24T10:23:32.668764",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8003,
      "client_name": "DULPA JUSTINA DELGADO ZAMBRANO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "1ro de Mayo Sur",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124325577",
      "client_email": "ALVANYSSOFIA@GMAIL.COM",
      "address": "PRIMERO DE MAYO SUR, CALLE LA PAZ CASA # 3 ROSARIO DE PAYA",
      "client_identification": "V21465105",
      "nap_box_name": "CTO - 914",
      "created_at": "2025-04-24T10:30:51.384957",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8004,
      "client_name": "VICTOR EDUARDO BARRADA ROA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "1ro de Mayo Sur",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04127424949",
      "client_email": "ROAE00892@GMAIL.COM",
      "address": "CALLE LA PAZ CASA NRO 1 SECTOR PRIMERO DE MAYO SUR",
      "client_identification": "V29711214",
      "nap_box_name": "CE-00064",
      "created_at": "2025-04-24T11:03:39.429421",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8005,
      "client_name": "BEATRIZ MARIA GOMEZ BORGES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Sector los Mangos",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128496496",
      "client_email": "BG9727173@GMAIL.COM",
      "address": "SECTOR LOS MANGOS AVENIDA PRINCIPAL CASA 28",
      "client_identification": "V10457567",
      "nap_box_name": "CE - 789",
      "created_at": "2025-04-24T12:18:24.244116",
      "service_detail": {
        "id": 8349,
        "ip": "10.13.159.2",
        "mac": "OEMT3C620C92",
        "serial": "OEMT3C620C92",
        "queue": "Plan_107915_30181_WispHub",
        "interface": "VLAN267_LOS_MANGOS_ZTE",
        "created_at": "2025-04-24T13:48:53.347350",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8006,
      "client_name": "CARMEN DOLORES GONZALEZ MONTOYA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "1ro de Mayo Norte",
      "plan": {
        "id": 101,
        "name": "RECURRENTE RESIDENCIAL PLAN 200M",
        "cost": "19.00",
        "code": "FOR200MB",
        "profile": "200Mbps/200Mbps"
      },
      "client_mobile": "04167203409",
      "client_email": "CG139170@GMAIL.COM",
      "address": "PRIMERO DE MAYO NORTE, CALLEJÓN ALI PRIMERA, CASA NRO25",
      "client_identification": "V25708601",
      "nap_box_name": "CTO-00538",
      "created_at": "2025-04-24T12:23:27.669759",
      "service_detail": {
        "id": 9761,
        "ip": "10.13.165.2",
        "mac": "ZTEGD1D06085",
        "serial": "ZTEGD1D06085",
        "queue": null,
        "interface": "VLAN261_1ERO_MAYO_ZTE",
        "created_at": "2025-11-10T12:16:29.071333",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8007,
      "client_name": "OLINTO JOSE SUAREZ ZERPA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04127768327",
      "client_email": "SERVICELSUAREZ@GMAIL.COM",
      "address": "CASCO DE TURMERO, C.C CASA VIEJA LOCAL 1",
      "client_identification": "V21181995",
      "nap_box_name": "CTO-00256",
      "created_at": "2025-04-24T13:14:38.164062",
      "service_detail": {
        "id": 8350,
        "ip": "10.13.160.2",
        "mac": "OEMT3C620C96",
        "serial": "OEMT3C620C96",
        "queue": "Plan_107915_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2025-04-24T13:57:18.841591",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8008,
      "client_name": "GERARDO MIGUEL MARTIGNETTI",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "SUSPENDIDO_RESIDENCIAL",
      "status_name": "Suspendido",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Palmeras I",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04128944168",
      "client_email": "GERARDOMARTIGNETTI16@GMAIL.COM",
      "address": "VIA INTERCOMUNAL, URB LAS PALMERAS CALLE 3 CASA #153",
      "client_identification": "V20817522",
      "nap_box_name": "440",
      "created_at": "2025-04-24T13:53:16.901916",
      "service_detail": {
        "id": 8416,
        "ip": "10.13.166.2",
        "mac": "HWTC49200741",
        "serial": "HWTC49200741",
        "queue": "Plan_131337_24341_WispHub",
        "interface": "VLAN118_PALMERAS_1",
        "created_at": "2025-04-30T13:23:20.439699",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8010,
      "client_name": "ROBERTO RAFAEL GUERRA SOTO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Canaima",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243768796",
      "client_email": "ISAIASALEJANDROGUERRAGIL@GMAIL.COM",
      "address": "PRADOS DE PAYA URBANIZACIÓN CANAIMA CALLE 4 CASA #10 ROSARIO DE PAYA",
      "client_identification": "V15494567",
      "nap_box_name": "CTO-00256",
      "created_at": "2025-04-24T15:04:08.661250",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8011,
      "client_name": "ARNALDO JOSE ALAYON QUERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Las Palmas",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121471437",
      "client_email": "KEROARNALDO@GMAIL.COM",
      "address": "SECTOR LAS PALMAS CALLEJÓN EL TANQUE PARCELA 28 CASA# 171 ROSARIO",
      "client_identification": "V20335117",
      "nap_box_name": "CTO-00253 DOS",
      "created_at": "2025-04-24T17:34:03.966975",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8012,
      "client_name": "MILEIBYS ANDREINA OSORIO SANCHEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona I",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04143437900",
      "client_email": "MILEIBYSOSORIO@GMAIL.COM",
      "address": "LA CASONA I CALLE 4 CASA #38",
      "client_identification": "V22298891",
      "nap_box_name": "44",
      "created_at": "2025-04-24T17:43:48.801189",
      "service_detail": {
        "id": 13028,
        "ip": "10.13.185.2",
        "mac": "HW:TC:49:20:07:32",
        "serial": "HWTC49200732",
        "queue": null,
        "interface": "VLAN109_CASONA_1",
        "created_at": "2026-09-16T12:17:28.776495",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8013,
      "client_name": "SHEILA VIRGINIA TORRES CARRILLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Los Mangos",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124624196",
      "client_email": "ACHIQUESHENNY9@GMAIL.COM",
      "address": "PRIMERA CALLE CASA NÚMERO 6 SECTOR LOS MANGOS ROSARIO DE PAYA",
      "client_identification": "V18044967",
      "nap_box_name": "CE - 789",
      "created_at": "2025-04-24T18:21:56.771527",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8014,
      "client_name": "DIANA FABIOLA ZUNIGA GOMEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona I Edificios",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121582109",
      "client_email": "DIANAZOPSU1@GMAIL.COM",
      "address": "LA CASONA I,  EDIFICIO D PISO 2 APARTAMENTO 3",
      "client_identification": "V27434301",
      "nap_box_name": "CAJA NAP EDIF E CASONA 2",
      "created_at": "2025-04-24T18:32:14.300440",
      "service_detail": {
        "id": 11205,
        "ip": "10.13.203.2",
        "mac": "HWTC49200735",
        "serial": "HWTC49200735",
        "queue": null,
        "interface": "VLAN109_CASONA_1",
        "created_at": "2026-01-16T14:51:09.633833",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8015,
      "client_name": "YSABEL CRISTINA AVILEZ LOPEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero I",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243605747",
      "client_email": "SOTOAVILEZDAYANACAROLINA@GMAIL.COM",
      "address": "SAMAN TARAZONERO I, CALLE 11, CASA 11",
      "client_identification": "V7205672",
      "nap_box_name": "90",
      "created_at": "2025-04-24T18:33:15.104923",
      "service_detail": {
        "id": 8362,
        "ip": "10.13.170.2",
        "mac": "OEMT3C6207FE",
        "serial": "OEMT3C6207FE",
        "queue": "Plan_137413_1574_WispHub",
        "interface": "VLAN140_SMT1_ZTE",
        "created_at": "2025-04-24T20:47:43.360761",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8016,
      "client_name": "JERARDINI WUILEIDY OVIEDO CHAVEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04266391157",
      "client_email": "JERARDINIOVIEDO83@GMAIL.COM",
      "address": "SECTOR RÍO SECO CALLE 9 CASA 42 ROSARIO DÉ PAYA",
      "client_identification": "V16157006",
      "nap_box_name": "CTO-00256",
      "created_at": "2025-04-24T18:36:56.814488",
      "service_detail": {
        "id": 8363,
        "ip": "10.13.171.2",
        "mac": "OEMT3C6207EA",
        "serial": "OEMT3C6207EA",
        "queue": "Plan_107915_30181_WispHub",
        "interface": "VLAN251_RIO_SECO",
        "created_at": "2025-04-24T20:50:28.778258",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8017,
      "client_name": "YAKZOORY ALEXANDRA ORTEGA MORALES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Residencias Mariño",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243710911",
      "client_email": "BARCIYAZU85@GMAIL.COM",
      "address": "CALLE MARIÑO EDIFICIO MARIÑO PISO 3 APARTAMENTO 31,URBANIZACIÓN RESIDENCIAS MARIÑO",
      "client_identification": "V17166405",
      "nap_box_name": "69",
      "created_at": "2025-04-24T19:24:30.285574",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8018,
      "client_name": "CARMEN MARITZA REYES DE ALVARADO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "1ro de Mayo Norte",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124867685",
      "client_email": "ALVARADOANGELA1680@GMAIL.COM",
      "address": "CALLE SOROCAIMA CASA NRO 5 PRIMERO DE MAYO NORTE ROSARIO DE PAYO",
      "client_identification": "V6040363",
      "nap_box_name": "CE - 846",
      "created_at": "2025-04-24T19:28:41.971632",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8019,
      "client_name": "YARITZA YULIMAR LUQUE MONTAÑEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Macarena",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128957873",
      "client_email": "YARITZALUQUE37@GMAIL.COM",
      "address": "URB LA MACARENA II CALLE 9 CASA N#5 SECTOR EL MACARO",
      "client_identification": "V14578718",
      "nap_box_name": "80",
      "created_at": "2025-04-24T20:26:22.856551",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8020,
      "client_name": "NEYLLELIS ANDREINA SEQUEDA PUA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Guerito",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128861760",
      "client_email": "SNEYLLELIS@GMAIL.COM",
      "address": "GUERITO BARRIO SAN MIGUEL CACHIPO NORTE CALLE MARIÑO CASA #157",
      "client_identification": "V31342302",
      "nap_box_name": "CTO-00456",
      "created_at": "2025-04-24T21:46:13.866478",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8021,
      "client_name": "DARIO ORLANDO PEREIRA TIRRE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ppal Paya",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04122982867",
      "client_email": "ORLANDOP3R3IRA@GMAIL.COM",
      "address": "PPAL DE PAYA SECTOR VEGA GRANDE CASA 8",
      "client_identification": "V14740040",
      "nap_box_name": "nap cto 0958",
      "created_at": "2025-04-25T04:09:18.572709",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8022,
      "client_name": "YUSMERI SALOME BAJO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Bosque",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124608767",
      "client_email": "YUSMERISALOMEBAJO@GMAIL.COM",
      "address": "CALLEJÓN ANDRÉS BELLO CASA PARCELA NRO 12 SECTOR EL BOSQUE ROSARIO DE PAYA",
      "client_identification": "V14558538",
      "nap_box_name": "CE - 851",
      "created_at": "2025-04-25T12:07:15.342223",
      "service_detail": {
        "id": 8373,
        "ip": "10.13.175.2",
        "mac": "OEMT3C62109E",
        "serial": "OEMT3C62109E",
        "queue": "Plan_107915_30181_WispHub",
        "interface": "VLAN266_EL_BOSQUE_ZTE",
        "created_at": "2025-04-25T17:16:20.684610",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8023,
      "client_name": "JULIANA ALEJANDRA OCHOA GIRON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Concepcion",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128996847",
      "client_email": "JULIDALYY@GMAIL.COM",
      "address": "LA CONCEPCIÓN, TORRE 3, PB APARTAMENTO 7",
      "client_identification": "V13779317",
      "nap_box_name": "108",
      "created_at": "2025-04-25T15:38:01.180575",
      "service_detail": {
        "id": 8529,
        "ip": "10.13.176.2",
        "mac": "HWTCD2D43F73",
        "serial": "HWTCD2D43F73",
        "queue": "Plan_131341_24341_WispHub",
        "interface": "VLAN111_CONCEPCION",
        "created_at": "2025-05-10T10:02:43.945247",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8024,
      "client_name": "VICTOR XAVIER ALEJANDRO MIRABAL ROMERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243450319",
      "client_email": "joselyaurimary@gmail.com",
      "address": "SAMAN TARAZONERO II VEREDA C10 CASA 02",
      "client_identification": "V24816102",
      "nap_box_name": "64",
      "created_at": "2025-04-25T17:27:50.012092",
      "service_detail": {
        "id": 8421,
        "ip": "10.13.178.2",
        "mac": "HWTC49200726",
        "serial": "HWTC49200726",
        "queue": "Plan_137413_1574_WispHub",
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2025-04-30T13:56:05.872641",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8025,
      "client_name": "LEGNA DEL VALLE PEROZO TORRES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Julia",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04129667400",
      "client_email": "LEGNAPEROZ@GMAIL.COM",
      "address": "CALLE HAYDE MÁRQUEZ CASA 17 URBANIZACIÓN LA NUEVA JULIA TURMERO",
      "client_identification": "V19131482",
      "nap_box_name": "630",
      "created_at": "2025-04-25T18:03:50.728026",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8026,
      "client_name": "ZAIRA MAYRI LABRADOR CORTEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Valle Verde",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124852342",
      "client_email": "ZAIRA2LABRADOR@GMAIL.COM",
      "address": "VALLE VERDE, CALLE SUCRE CASA #27",
      "client_identification": "V14758564",
      "nap_box_name": "CTO-00391",
      "created_at": "2025-04-26T09:43:44.133259",
      "service_detail": {
        "id": 8761,
        "ip": "10.13.181.2",
        "mac": "OEMT3C62106E",
        "serial": "OEMT3C62106E",
        "queue": "queue1",
        "interface": "VLAN253_VALLE_VERDE",
        "created_at": "2025-05-28T16:24:15.625472",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8028,
      "client_name": "DARYELIN HERILIZ FERNANDEZ HURTADO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Arboleda",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243264137",
      "client_email": "FERNANDEZDARYELIN891@GMAIL.COM",
      "address": "CALLE LA ESPINAL CASA NRO 31, SECTOR LA ARBOLEDA ROSARIO DE PAYA",
      "client_identification": "V18266288",
      "nap_box_name": "CE - 772",
      "created_at": "2025-04-26T20:40:21.944383",
      "service_detail": {
        "id": 8750,
        "ip": "10.14.152.2",
        "mac": "OEMT3C620A5E",
        "serial": "OEMT3C620A5E",
        "queue": "queue1",
        "interface": "VLAN251_RIO_SECO",
        "created_at": "2025-05-27T15:55:00.815644",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8029,
      "client_name": "ESTACION POLICIAL MUNICIPAL SANTIAGO MARIÑO POLICIA NACIONAL BOLIVARIANA",
      "client_type_name": "GRATIS",
      "client_subdivision": "ACTIVO_GRATIS",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": false,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 86,
        "name": "PLAN RECURRENTE 80M GRATIS",
        "cost": "0.00",
        "code": "FO-G80",
        "profile": "80M/80M"
      },
      "client_mobile": "04128884247",
      "client_email": "JORGE_LUIS_CONTRERAS_24@HOTMAIL.COM",
      "address": "AVENIDA INTERCOMUNNAL SANTIAGO MARIÑO, SECTOR SAMAN DE GUERE EL MACARO ESTADO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V22039817",
      "nap_box_name": "660",
      "created_at": "2025-04-28T13:55:06.087552",
      "service_detail": {
        "id": 8389,
        "ip": "10.13.177.2",
        "mac": "HWTC49200999",
        "serial": "HWTC49200999",
        "queue": "Plan_137413_1574_WispHub",
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2025-04-28T14:01:11.573177",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8030,
      "client_name": "JESUS ALEXANDER ARRIETA FLORES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243278267",
      "client_email": "ALEX180901@GMAIL.COM",
      "address": "CASCO DE TURMERO, CALLE VILLA CASTIN, CASA NÚMERO 21",
      "client_identification": "V28051746",
      "nap_box_name": "CTO - 857",
      "created_at": "2025-04-28T15:56:43.880312",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8031,
      "client_name": "MIRIAN DEL CARMEN ARIAS FLORES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04143870095",
      "client_email": "ARIASDELCARMEN32@GMAIL.COM",
      "address": "MATA CABALLO CALLE 5 CASA 372",
      "client_identification": "V32418698",
      "nap_box_name": "CTO-00272",
      "created_at": "2025-04-28T15:56:44.193332",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8032,
      "client_name": "JHONNY MOISES RODRIGUEZ LOPEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243345596",
      "client_email": "JHONNYRODRIGUEZ100@GMAIL.COM",
      "address": "LA CASONA II, CALLE 15 CASA 17",
      "client_identification": "V9676480",
      "nap_box_name": "CTO-00088",
      "created_at": "2025-04-28T16:08:10.182683",
      "service_detail": {
        "id": 8452,
        "ip": "10.13.199.2",
        "mac": "HWTC49200743",
        "serial": "HWTC49200743",
        "queue": "Plan_131337_24341_WispHub",
        "interface": "VLAN110_CASONA_2",
        "created_at": "2025-05-01T12:15:33.903587",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8033,
      "client_name": "ROBERTH ANTONIO DE JESUS BORGES NIÑO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243060300",
      "client_email": "ROBERTHBORGES47@GMAIL.COM",
      "address": "SECTOR MATA CABALLO CALLE 5 CASA 341 ROSARIO DE PAYA",
      "client_identification": "V27864249",
      "nap_box_name": "CTO-00182",
      "created_at": "2025-04-28T16:27:26.047419",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8034,
      "client_name": "SCARLET ASERMELYDE LOS ANGELES MAYORA VASQUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Polvorin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243260681",
      "client_email": "SCARLETMAYORA5@GMAIL.COM",
      "address": "CALLE CALLEJÓN MAYORA CASA NRO 6 SECTOR PAYITA-POLVORIN",
      "client_identification": "V30211961",
      "nap_box_name": "CTO-00407",
      "created_at": "2025-04-28T16:34:04.756433",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8035,
      "client_name": "WILMAN JESUS LUNA BRITO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Macarena",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121595356",
      "client_email": "DIEGO13102018@GMAIL.COM",
      "address": "URB LA MACARENA II CALLE 8 CASA #13 EL MACARO",
      "client_identification": "V10456762",
      "nap_box_name": "246",
      "created_at": "2025-04-28T16:57:01.665139",
      "service_detail": {
        "id": 8427,
        "ip": "10.13.205.2",
        "mac": "HWTC49200721",
        "serial": "HWTC49200721",
        "queue": "Plan_137413_1574_WispHub",
        "interface": "VLAN100_OLTs",
        "created_at": "2025-04-30T14:31:02.971443",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8036,
      "client_name": "MERCEDES VICTORIA ESPINOZA DE SERVEN",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04122982657",
      "client_email": "RAFAELAESPINOZA79@GMAIL.COM",
      "address": "SAMAN TARAZONERO II, MANZANA D-9 CASA 18",
      "client_identification": "V5278325",
      "nap_box_name": "278",
      "created_at": "2025-04-28T17:07:38.058200",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8037,
      "client_name": "GABRIELA ALEXANDRA PARABABIRE MONTILLA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Polvorin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243568093",
      "client_email": "GABBYPARABABIRE@GMAIL.COM",
      "address": "CALLE 3 DE MAYO CASA NRO 15 POLVORIN",
      "client_identification": "V24930182",
      "nap_box_name": "CTO-00354",
      "created_at": "2025-04-28T17:20:10.191593",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8038,
      "client_name": "IVAN ALFREDO MARRERO PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Los Mangos",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04162367752",
      "client_email": "YUNIORPEREZ1894@GMAIL.COM",
      "address": "SECTOR LOS MANGOS SEGUNDA CALLE CON PRIMERA TRANSVERSAL ROSARIO DE PAYA",
      "client_identification": "V25066832",
      "nap_box_name": "CTO-00MAN",
      "created_at": "2025-04-28T17:34:21.477169",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8039,
      "client_name": "GREGORIO ANTONIO MONTIEL MANZO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ppal Paya",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04127604736",
      "client_email": "GREGORIOMONTIEL1306@GMAIL.COM",
      "address": "AV PRINCIPAL ROSARIO DE PAYA CASA PARCELA NRO 20 SECTOR LAS RURALES VIEJAS",
      "client_identification": "V13128287",
      "nap_box_name": "CTO-0479",
      "created_at": "2025-04-28T18:33:03.910033",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8040,
      "client_name": "DEIRRE JOSE RAMOS HURTADO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Bosque",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04125974107",
      "client_email": "DEIRREJOSERAMOSHURTADO@GMAIL.COM",
      "address": "SECTOR EL BOSQUE CALLE ARISMENDI CASA # 5 ROSARIO DE PAYA",
      "client_identification": "V29581950",
      "nap_box_name": "CTO-00290",
      "created_at": "2025-04-28T18:46:49.324700",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8041,
      "client_name": "IRIS DALLARYS ACOSTA ROJAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Las Rurales",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243680754",
      "client_email": "YEIGONZALEZACOSTA@GMAIL.COM",
      "address": "SECTOR LAS RURALES CALLE BOLIVAR CASA # 1-1 ROSARIO DE PAYA",
      "client_identification": "V10758071",
      "nap_box_name": "CE-660",
      "created_at": "2025-04-28T19:33:53.175958",
      "service_detail": {
        "id": 8548,
        "ip": "10.13.194.2",
        "mac": "OEMT3C620F7A",
        "serial": "OEMT3C620F7A",
        "queue": "queue1",
        "interface": "VLAN252_RURALES_PAYA",
        "created_at": "2025-05-10T15:01:29.205513",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8042,
      "client_name": "GABRIELIS CAROLINA CALDERON ESPIDEA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243737861",
      "client_email": "CALDERONANYELIS@GMAIL.COM",
      "address": "CASCO DE TURMERO, CALLE BERMUDEZ CASA NÚMERO A-2",
      "client_identification": "V20336332",
      "nap_box_name": "CC VALLE LINDO",
      "created_at": "2025-04-28T19:43:19.855473",
      "service_detail": {
        "id": 12889,
        "ip": "10.13.206.2",
        "mac": "OE:MT:3C:62:0D:C6",
        "serial": "OEMT3C620DC6",
        "queue": null,
        "interface": "VLAN200_OLTs",
        "created_at": "2026-08-20T12:09:06.526016",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8043,
      "client_name": "RAUL DE JESUS GONCALVES CONTRERAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "San Pablo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243741657",
      "client_email": "LOREGONCALVS@HOTMAIL.COM",
      "address": "URBANIZACIÓN SAN PABLO, RESIDENCIAS CAMELO SUITES,TORRE D APARTAMENTO 3",
      "client_identification": "V22287027",
      "nap_box_name": "CTO-00413",
      "created_at": "2025-04-28T20:58:48.393008",
      "service_detail": {
        "id": 8400,
        "ip": "10.13.189.2",
        "mac": "OEMT3C62100E",
        "serial": "OEMT3C62100E",
        "queue": "Plan_92194_15811_WispHub",
        "interface": "VLAN224_SAN_PABLO_OLT1",
        "created_at": "2025-04-29T08:31:36.753700",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8044,
      "client_name": "MIRNA JUSTINA MILLAN SANTAELLA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman de Guere",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243551894",
      "client_email": "MIRNAMIRYESK@GMAIL.COM",
      "address": "SAMAN DE GUERE SUR CALLE PROLONGACIÓN PRINCIPAL CASA 01",
      "client_identification": "V8825004",
      "nap_box_name": "CTO - 1220",
      "created_at": "2025-04-29T06:05:55.521470",
      "service_detail": {
        "id": 11760,
        "ip": "10.13.196.2",
        "mac": "OEMT3C620CCA",
        "serial": "OEMT3C620CCA",
        "queue": null,
        "interface": "VLAN122_SAMAN_GUERE",
        "created_at": "2026-02-27T09:41:42.911174",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8045,
      "client_name": "LUISMER JHAZIEL ALEJANDRO HERRERA RIOS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "1ro de Mayo Norte",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243622741",
      "client_email": "ALEJANDRIOS68@GMAIL.COM",
      "address": "AVENIDA PRINCIPAL ROSARIO DE PAYO NORTE CASA NÚMERO 09 SECTOR PRIMERO DE MAYO NORTE",
      "client_identification": "V27646109",
      "nap_box_name": "CTO-00225",
      "created_at": "2025-04-29T07:33:10.662910",
      "service_detail": {
        "id": 11750,
        "ip": "10.14.44.2",
        "mac": "OEMT3C62035A",
        "serial": "OEMT3C62035A",
        "queue": null,
        "interface": "VLAN261_1ERO_MAYO_ZTE",
        "created_at": "2026-02-26T09:49:48.486206",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8046,
      "client_name": "YASMARY MADERLINE ROJAS MARTINEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243486831",
      "client_email": "YASMARYROJAS12@GMAIL.COM",
      "address": "URBANIZACIÓN LOS NÍSPEROS TORRE C PISO 6 APARTAMENTO 65",
      "client_identification": "V17717212",
      "nap_box_name": "88",
      "created_at": "2025-04-29T08:37:25.167684",
      "service_detail": {
        "id": 8410,
        "ip": "10.13.197.2",
        "mac": "OEMT3C620B46",
        "serial": "OEMT3C620B46",
        "queue": "Plan_107915_15811_WispHub",
        "interface": "VLAN272_EDIF_NISPEROS_OLT3",
        "created_at": "2025-04-29T14:14:14.274276",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8047,
      "client_name": "KHALOA SOLED SERRANO ROMERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04122051723",
      "client_email": "ROMEROKALOA@GMAIL.COM",
      "address": "LA CASONA II, CALLE 15, CASA NÚMERO 4",
      "client_identification": "V17274399",
      "nap_box_name": "CTO-00087 DOS",
      "created_at": "2025-04-29T09:45:18.528116",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8048,
      "client_name": "HUGO RAFAEL PENA ARISTIMUNO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Payita",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243474309",
      "client_email": "IWORIBATRUPO23@GMAIL.COM",
      "address": "SECTOR PAYITA CALLE PRINCIPAL CASA 15 ROSARIO DE PAYA",
      "client_identification": "V4589643",
      "nap_box_name": "CTO - 1023",
      "created_at": "2025-04-29T14:26:17.876378",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8049,
      "client_name": "CARMEN SUHAIL RONDON PIÑERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "1ro de Mayo Sur",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121382088",
      "client_email": "SUHAILARREAZA@GMAIL.COM",
      "address": "PRIMERO DE MAYO SUR, CALLE EL LIMÓN, CASA 6. ROSARIO DE PAYA",
      "client_identification": "V12167990",
      "nap_box_name": "CTO-00470",
      "created_at": "2025-04-29T15:19:47.061667",
      "service_detail": {
        "id": 8431,
        "ip": "10.13.208.2",
        "mac": "HWTC49200750",
        "serial": "HWTC49200750",
        "queue": "Plan_107915_30181_WispHub",
        "interface": "VLAN261_1ERO_MAYO_ZTE",
        "created_at": "2025-04-30T15:44:59.912809",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8050,
      "client_name": "DANIEL BENJAMIN LARA DURAN",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243148446",
      "client_email": "ARELYS.RAMIREZ82@GMAIL.COM",
      "address": "MATA CABALLO AVENIDA 2 A # 519",
      "client_identification": "V11978068",
      "nap_box_name": "CTO-00073",
      "created_at": "2025-04-29T17:12:29.417678",
      "service_detail": {
        "id": 11491,
        "ip": "10.13.209.2",
        "mac": "OEMT3C620D5A",
        "serial": "OEMT3C620D5A",
        "queue": null,
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2026-02-05T10:21:39.936041",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8051,
      "client_name": "RODRIGO JOSÉ ROJAS AREVALO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vallecito",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04125230782",
      "client_email": "RODRIGOROJAS2795@GMAIL.COM",
      "address": "VALLECITO, CALLE LAS ACACIAS CASA #20",
      "client_identification": "V25920886",
      "nap_box_name": "CTO - 99",
      "created_at": "2025-04-29T19:23:31.956482",
      "service_detail": {
        "id": 8547,
        "ip": "10.13.210.2",
        "mac": "OEMT3C6203C2",
        "serial": "OEMT3C6203C2",
        "queue": "queue1",
        "interface": "VLAN258_VALLECITO",
        "created_at": "2025-05-10T14:57:12.471551",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8052,
      "client_name": "ROSDARI MILAGROS VIVAS MENDIBLE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona I Edificios",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04126790277",
      "client_email": "ROSSVIVAS@GMAIL.COM",
      "address": "LA CASONA I, RESIDENCIA LOS JARDINES EDIFICIO E PISO 1 APARTAMENTO 1-6",
      "client_identification": "V13288498",
      "nap_box_name": "CAJA NAP EDIF E CASONA 2",
      "created_at": "2025-04-29T20:50:00.296061",
      "service_detail": {
        "id": 8536,
        "ip": "10.13.211.2",
        "mac": "OEMT3C62021E",
        "serial": "OEMT3C62021E",
        "queue": "Plan_131337_24341_WispHub",
        "interface": "VLAN109_CASONA_1",
        "created_at": "2025-05-10T13:11:38.541681",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8053,
      "client_name": "CARMEN YESENIA RIVAS ACOSTA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vista Hermosa",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04127323153",
      "client_email": "YESSENIARIVAS2024@GMAIL.COM",
      "address": "PAYA, VISTA HERMOSA CALLE EL ROSARIO CASA N# 7",
      "client_identification": "V16435594",
      "nap_box_name": "CTO-00057",
      "created_at": "2025-04-29T21:12:47.002800",
      "service_detail": {
        "id": 11978,
        "ip": "10.13.212.2",
        "mac": "OEMT3C62064E",
        "serial": "OEMT3C62064E",
        "queue": null,
        "interface": "VLAN230_VISTA_HERMOSA",
        "created_at": "2026-03-06T11:37:02.444230",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8054,
      "client_name": "NAIRETH VIRGINIA MIJARES RONDÓN",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vallecito",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04242339751",
      "client_email": "NUNEZJONATHAN022@GMAIL.COM",
      "address": "SECTOR VALLECITO CALLE LOS NARANJOS CASA # 25 ROSARIO DE PAYA",
      "client_identification": "V31341710",
      "nap_box_name": "CTO-00082",
      "created_at": "2025-04-29T22:00:04.174368",
      "service_detail": {
        "id": 8528,
        "ip": "10.13.213.2",
        "mac": "OEMT3C62112A",
        "serial": "OEMT3C62112A",
        "queue": "queue1",
        "interface": "VLAN258_VALLECITO",
        "created_at": "2025-05-09T21:54:41.708796",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8055,
      "client_name": "ALEJANDRO JOSE AZUAJE MALDONADO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "San Sebastian",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04126478860",
      "client_email": "ALEJANDROAZUAJE220@GMAIL.COM",
      "address": "SAN SEBASTIAN CALLE SEGUNDA TRANSVERSAL CASA #08 MACARO",
      "client_identification": "V27929641",
      "nap_box_name": "75",
      "created_at": "2025-04-29T22:29:31.844553",
      "service_detail": {
        "id": 9857,
        "ip": "10.13.214.2",
        "mac": "OEMT3C620F16",
        "serial": "OEMT3C620F16",
        "queue": null,
        "interface": "VLAN125_SAN_SEBASTIAN_ZTE",
        "created_at": "2025-11-10T18:20:55.683528",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8056,
      "client_name": "LUIS ARMANDO LIMPIO RAMIREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144880106",
      "client_email": "LIMPIOLUIS2020@GMAIL.COM",
      "address": "CALLE 18,CASA NÚMERO 13 SECTOR PANTIN",
      "client_identification": "V16022782",
      "nap_box_name": "CTO-00434",
      "created_at": "2025-04-30T08:39:35.058834",
      "service_detail": {
        "id": 8534,
        "ip": "10.13.218.2",
        "mac": "OEMT3C62019E",
        "serial": "OEMT3C62019E",
        "queue": "queue1",
        "interface": "VLAN229_PANTIN",
        "created_at": "2025-05-10T12:51:24.036724",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8057,
      "client_name": "AMARILIS JOSEFINA CASTELLANO LUQUE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Guzman",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243251813",
      "client_email": "ERIKCADALU@GMAIL.COM",
      "address": "CALLE SAN PABLO CASA 34 VALLE DEL RIO , LA GUZMAN",
      "client_identification": "V16850061",
      "nap_box_name": "CTO-00407",
      "created_at": "2025-04-30T09:30:09.510288",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8058,
      "client_name": "LILIANA PATRICIA CASTILLO DE OZORIO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "San Pablo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04165437770",
      "client_email": "LCASTILLO256.LC@GMAIL.COM",
      "address": "RESIDENCIA CAMELO SUITES, TORRE C, PISO 1, APARTAMENTO 4, SAN PABLO",
      "client_identification": "V12611899",
      "nap_box_name": "CTO-00413",
      "created_at": "2025-04-30T10:14:35.051203",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8060,
      "client_name": "LEIDYS YUSMEILY FLORES PRIETO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Dios Es Mi Refugio",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243576003",
      "client_email": "DELMORALPEDRO7@GMAIL.COM",
      "address": "SECTOR COMUNIDAD DIOS ES MI REFUGIO MANZANA 2 PARCELA #10",
      "client_identification": "V18645027",
      "nap_box_name": "CTO-0656",
      "created_at": "2025-04-30T10:58:36.522868",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8061,
      "client_name": "JOSE LUIS TORRES ALEJO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243032603",
      "client_email": "AHLANZAEL162024@GMAIL.COM",
      "address": "MATA CABALLO, CALLE 12 CASA 675-B",
      "client_identification": "V13201566",
      "nap_box_name": "CTO-00022",
      "created_at": "2025-04-30T13:03:05.023058",
      "service_detail": {
        "id": 8424,
        "ip": "10.13.202.2",
        "mac": "HWTC49200734",
        "serial": "HWTC49200734",
        "queue": "Plan: PLAN_A_FACTURAR_250M_N1_R2_PAYA - Router: R2_PAYA",
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2025-04-30T14:10:36.239393",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8062,
      "client_name": "ALECIA GONZALEZ SUAREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128151349",
      "client_email": "3JO2025@GMAIL.COM",
      "address": "CALLE 2 CASA NRO 36 SECTOR PRADOS DE PAYA II",
      "client_identification": "V10855106",
      "nap_box_name": "CTO-00205",
      "created_at": "2025-04-30T21:22:15.237600",
      "service_detail": {
        "id": 8448,
        "ip": "10.13.222.2",
        "mac": "HWTC49200724",
        "serial": "HWTC49200724",
        "queue": "queue1",
        "interface": "VLAN242_PRADOS2",
        "created_at": "2025-05-01T09:50:13.241697",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8063,
      "client_name": "LIUS ALEJANDRA MADRID GALLARDO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243496634",
      "client_email": "ALEMADRID0115@GMAIL.COM",
      "address": "EZEQUIEL ZAMORA, ANTIGUA HACIENDA EL NÍSPERO, TORRE 7 ESCALERA 2 PISO 3 APARTAMENTO 3-1",
      "client_identification": "V26935158",
      "nap_box_name": "CTO-00464",
      "created_at": "2025-05-01T09:36:54.743878",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8064,
      "client_name": "BETZY CAROLINA MARTINEZ GOMEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Palmeras I",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124151808",
      "client_email": "MBETZY53@GMAIL.COM",
      "address": "TURMERO LA JULIA URBANIZACIÓN PALMERAS I, AVENIDA PRINCIPAL CALLE 1 PROLONGACIÓN PEÑALVER CASA #40",
      "client_identification": "V13944819",
      "nap_box_name": "287",
      "created_at": "2025-05-01T10:53:30.064127",
      "service_detail": {
        "id": 8540,
        "ip": "10.13.223.2",
        "mac": "OEMT3C620B1E",
        "serial": "OEMT3C620B1E",
        "queue": "Plan_131341_24341_WispHub",
        "interface": "VLAN118_PALMERAS_1",
        "created_at": "2025-05-10T13:33:56.788296",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8067,
      "client_name": "ELIZMAR CRISBEL RATTIA MADRID",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04127454165",
      "client_email": "MADRIDCRISBEL65@GMAIL.COM",
      "address": "SECTOR PRADO II CALLE 2 CASA 37 ROSARIO DE PAYA",
      "client_identification": "V30147701",
      "nap_box_name": "CTO-00205 DOS",
      "created_at": "2025-05-01T14:38:37.465941",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8069,
      "client_name": "SARA LOYXIBEL ALEXANDRA ABREU PANTOJA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Bosque",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243494368",
      "client_email": "LOYPANTOJA2019@GMAIL.COM",
      "address": "CALLE LUISA CACERES DE ARISMENDI,CASA NÚMERO D-8,SECTOR EL BOSQUE,ROSARIO DE PAYA.",
      "client_identification": "V30498895",
      "nap_box_name": "CTO-00290",
      "created_at": "2025-05-01T18:14:12.672557",
      "service_detail": {
        "id": 12543,
        "ip": "10.13.229.2",
        "mac": "a8:bf:3c:62:0f:52",
        "serial": "OEMT3C620F52",
        "queue": null,
        "interface": "VLAN266_EL_BOSQUE_ZTE",
        "created_at": "2026-05-26T14:18:43.670756",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8070,
      "client_name": "RAMON SAMUEL TOVAR GUERRA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Leocolbo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243528288",
      "client_email": "SAMUELTOVAR12872@GMAIL.COM",
      "address": "VALLES DE LEOCOLBO CALLE A CASA 64",
      "client_identification": "V12142853",
      "nap_box_name": "CE - 623",
      "created_at": "2025-05-01T18:59:03.310526",
      "service_detail": {
        "id": 12676,
        "ip": "10.13.225.2",
        "mac": "VS:OL:00:E1:3A:DB",
        "serial": "VSOL00E13ADB",
        "queue": null,
        "interface": "VLAN144_LEOCOLBO",
        "created_at": "2026-07-04T19:11:14.164200",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8071,
      "client_name": "MAYRA ALEJANDRA VILLARREAL ZAMBRANO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Leocolbo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04120442770",
      "client_email": "MAIRAZANBRANO12@GMAIL.COM",
      "address": "VALLES DE LEOCOLBO CALLE A CASA 07 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V18640587",
      "nap_box_name": "CTO-00371",
      "created_at": "2025-05-01T19:37:43.205908",
      "service_detail": {
        "id": 11801,
        "ip": "10.13.230.2",
        "mac": "HWTC48080118",
        "serial": "HWTC48080118",
        "queue": null,
        "interface": "VLAN144_LEOCOLBO",
        "created_at": "2026-02-27T11:31:14.056595",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8072,
      "client_name": "MAYERLI DEL VALLE CHAPARRO ESCALONA",
      "client_type_name": "EMPLEADO",
      "client_subdivision": "ACTIVO_EMPLEADO",
      "status_name": "Activo",
      "cycle": 25,
      "migrate": true,
      "sector_name": "Guanarito",
      "plan": {
        "id": 78,
        "name": "Plan empleado 80MB",
        "cost": "0.00",
        "code": "FO-80M",
        "profile": "80M/80M"
      },
      "client_mobile": "04243216294",
      "client_email": "DELVALLEMAYERLI@GMAIL.COM",
      "address": "CALLE NERO TOVAR CASA NRO 11 BARRIO GUANARITO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V13907240",
      "nap_box_name": "CTO-00214",
      "created_at": "2025-05-02T11:56:00.625994",
      "service_detail": {
        "id": 8465,
        "ip": "10.13.231.2",
        "mac": "OEMT3C620456",
        "serial": "OEMT3C620456",
        "queue": "Plan_107915_15811_WispHub",
        "interface": "VLAN232_GUANARITO_OLT2",
        "created_at": "2025-05-02T15:33:09.699801",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8073,
      "client_name": "RICARDO ENRIQUE HERNANDEZ OJEDA",
      "client_type_name": "EMPLEADO",
      "client_subdivision": "CANCELADO_EMPLEADO",
      "status_name": "Cancelado",
      "cycle": 25,
      "migrate": true,
      "sector_name": "Valle Fresco",
      "plan": {
        "id": 78,
        "name": "Plan empleado 80MB",
        "cost": "0.00",
        "code": "FO-80M",
        "profile": "80M/80M"
      },
      "client_mobile": "04124432757",
      "client_email": "REHO.UPTA@GMAIL.COM",
      "address": "MANZANA 27 CASA NRO 15 URB VALLE FRESCO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V20693299",
      "nap_box_name": "CTO - 981",
      "created_at": "2025-05-02T13:55:13.481971",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8074,
      "client_name": "YHOSSELLYN VANESA PEREZ JIMENEZ",
      "client_type_name": "EMPLEADO",
      "client_subdivision": "CANCELADO_EMPLEADO",
      "status_name": "Cancelado",
      "cycle": 25,
      "migrate": true,
      "sector_name": "Simon Bolivar",
      "plan": {
        "id": 78,
        "name": "Plan empleado 80MB",
        "cost": "0.00",
        "code": "FO-80M",
        "profile": "80M/80M"
      },
      "client_mobile": "04143840349",
      "client_email": "YHOSSELLYNP@GMAIL.COM",
      "address": "CALLE 10 CASA NRO 03 URB SIMON BOLIVAR TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V25066218",
      "nap_box_name": "CTO-00036",
      "created_at": "2025-05-02T14:06:03.454026",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8075,
      "client_name": "CARLOS JAVIER OVALLES PIÑANGO",
      "client_type_name": "EMPLEADO",
      "client_subdivision": "ACTIVO_EMPLEADO",
      "status_name": "Activo",
      "cycle": 25,
      "migrate": true,
      "sector_name": "San Sebastian",
      "plan": {
        "id": 78,
        "name": "Plan empleado 80MB",
        "cost": "0.00",
        "code": "FO-80M",
        "profile": "80M/80M"
      },
      "client_mobile": "04122900379",
      "client_email": "CARLOSJOP9@GMAIL.COM",
      "address": "CALLE 2 CASA NRO 24 URB SAN SEBASTIAN TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V32046620",
      "nap_box_name": "CTO-SEB",
      "created_at": "2025-05-02T14:11:34.279592",
      "service_detail": {
        "id": 8486,
        "ip": "10.12.221.2",
        "mac": "OEMT3C62083E",
        "serial": "OEMT3C62083E",
        "queue": "queue1",
        "interface": "VLAN125_SAN_SEBASTIAN_ZTE",
        "created_at": "2025-05-06T11:26:57.669927",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8076,
      "client_name": "OBDALIS MARIA RODRIGUEZ DE GONZALEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Simon Bolivar",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124606000",
      "client_email": "OBDALIS801@GMAIL.COM",
      "address": "EL MACARO, SIMON BOLIVAR, CALLE 5 CASA 31 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V6571801",
      "nap_box_name": "CTO-00023",
      "created_at": "2025-05-03T09:59:20.958515",
      "service_detail": {
        "id": 8478,
        "ip": "10.13.237.2",
        "mac": "OEMT3C6205E2",
        "serial": "OEMT3C6205E2",
        "queue": "queue1",
        "interface": "VLAN128_SIMON_BOLIVAR_ZTE",
        "created_at": "2025-05-06T10:26:52.413588",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8077,
      "client_name": "MYLAS SHOP 2024 CA",
      "client_type_name": "PYME",
      "client_subdivision": "SUSPENDIDO_PYME",
      "status_name": "Suspendido",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 102,
        "name": "RECURRENTE PYME PLAN 150M",
        "cost": "27.60",
        "code": "FOP150M",
        "profile": "150Mbps/150Mbps"
      },
      "client_mobile": "04128480337",
      "client_email": "RADICAL1578@GMAIL.COM",
      "address": "CASCO DE TURMERO, CALLE MIRANDA NUMERO 46-2",
      "client_identification": "J505637274",
      "nap_box_name": "CTO-00038",
      "created_at": "2025-05-05T17:58:49.634653",
      "service_detail": {
        "id": 12273,
        "ip": "10.13.232.2",
        "mac": "OEMT3C6203D6",
        "serial": "OEMT3C6203D6",
        "queue": null,
        "interface": "VLAN200_OLTs",
        "created_at": "2026-04-09T18:11:21.604025",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8078,
      "client_name": "ROSANGELA LAYA NIÑO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243390686",
      "client_email": "ROSANGELALAYANINO@GMAIL.COM",
      "address": "EZEQUIEL ZAMORA, EDIFICIO 28 PISO 2 APARTAMENTO 11 turmero Aragua zona postal 2115",
      "client_identification": "V18975832",
      "nap_box_name": "CTO-00225",
      "created_at": "2025-05-06T09:11:21.881628",
      "service_detail": {
        "id": 8475,
        "ip": "10.13.240.2",
        "mac": "OEMT3C620632",
        "serial": "OEMT3C620632",
        "queue": "Plan_107915_15811_WispHub",
        "interface": "VLAN209_ZAMORA_OLT1",
        "created_at": "2025-05-06T09:56:20.842334",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8079,
      "client_name": "BLASINA TRINIDAD PERAZA DIAZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124818631",
      "client_email": "PERAZATRINA@GMAIL.COM",
      "address": "MANZANA 12 CASA 33 PANTIN ROSARIO DE PAYA",
      "client_identification": "V6644303",
      "nap_box_name": "CTO-00166",
      "created_at": "2025-05-06T09:21:43.353921",
      "service_detail": {
        "id": 8476,
        "ip": "10.13.242.2",
        "mac": "OEMT3C620196",
        "serial": "OEMT3C620196",
        "queue": "queue1",
        "interface": "VLAN229_PANTIN",
        "created_at": "2025-05-06T10:03:14.641486",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8080,
      "client_name": "ARACELIZ DE LA CARIDAD ANZOLA JUAREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243244462",
      "client_email": "ARAANZOLAC@GMAIL.COM",
      "address": "LA CASONA II, CALLE 15 CASA 67",
      "client_identification": "V19173374",
      "nap_box_name": "CTO-00120 DOS",
      "created_at": "2025-05-06T09:39:44.366001",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8081,
      "client_name": "JAVIER ANTONIO MAGALLANES SANCHEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona I",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243410512",
      "client_email": "JAVIERMAGALLANEZ96@GMAIL.COM",
      "address": "CALLE 2 CASA  14 SECTOR LA CASONA I, TURMERO",
      "client_identification": "V27520933",
      "nap_box_name": "CE - 408",
      "created_at": "2025-05-06T11:14:04.204017",
      "service_detail": {
        "id": 11761,
        "ip": "10.13.244.2",
        "mac": "OEMT3C62093A",
        "serial": "OEMT3C62093A",
        "queue": null,
        "interface": "VLAN109_CASONA_1",
        "created_at": "2026-02-27T09:42:18.549142",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8082,
      "client_name": "ENYERBER JOSUE PUERTA GALINDE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04123611512",
      "client_email": "NEUTRONIX6@GMAIL.COM",
      "address": "VEREDA 5 MANZANA E CASA 16 SECTOR SAMAN TARAZONERO II",
      "client_identification": "V20334477",
      "nap_box_name": "273",
      "created_at": "2025-05-06T11:22:09.588173",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8083,
      "client_name": "MARIANA SELENA TOVAR RIVAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144750678",
      "client_email": "MARY.ANDREA.TOVAR17@GMAIL.COM",
      "address": "CALLE J5 CASA 38 LA CASONA II",
      "client_identification": "V27286549",
      "nap_box_name": "CTO-00087",
      "created_at": "2025-05-06T11:44:42.896342",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8084,
      "client_name": "YAHANCARLOS BLADIMIR MORENO LAYA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "18 de Septiembre",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04141462843",
      "client_email": "nelvishernandez222@gmail.com",
      "address": "CACHIPO NORTE 18 DE SEPTIEMBRE CALLE 1 CASA 10",
      "client_identification": "V14627841",
      "nap_box_name": "CE - 771",
      "created_at": "2025-05-06T11:57:12.389940",
      "service_detail": {
        "id": 12041,
        "ip": "10.13.236.2",
        "mac": "VSOL00A6E512",
        "serial": "VSOL00A6E512",
        "queue": null,
        "interface": "VLAN139_GUERITO",
        "created_at": "2026-03-12T13:15:41.340290",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8085,
      "client_name": "LIGIA MARGARITA GUTIERREZ VERENZUELA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243577751",
      "client_email": "LIGIAGUTIERREZ.2906@GMAIL.COM",
      "address": "PRADOS DE PAYA II, CALLE 4, CASA 71",
      "client_identification": "V11184409",
      "nap_box_name": "CTO-00449",
      "created_at": "2025-05-06T12:10:05.338596",
      "service_detail": {
        "id": 8525,
        "ip": "10.14.11.2",
        "mac": "HWTC49201014",
        "serial": "HWTC49201014",
        "queue": "queue1",
        "interface": "VLAN242_PRADOS2",
        "created_at": "2025-05-09T10:12:54.111018",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8086,
      "client_name": "IRAYDA JOSEFINA SALAS OBANDO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona I",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124394021",
      "client_email": "JOSEFINAOBANDO776@GMAIL.COM",
      "address": "LA CASONA I, CALLE 4, CASA NO. 50",
      "client_identification": "V9655593",
      "nap_box_name": "CAJA NAP EDIF E CASONA 2",
      "created_at": "2025-05-06T14:51:16.070340",
      "service_detail": {
        "id": 11764,
        "ip": "10.13.235.2",
        "mac": "OEMT3C621062",
        "serial": "OEMT3C621062",
        "queue": null,
        "interface": "VLAN109_CASONA_1",
        "created_at": "2026-02-27T09:43:43.640108",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8087,
      "client_name": "LUIS ALBERTO SANDOVAL",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona I",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124437960",
      "client_email": "LUISALBERTOSANDOVAL2013@GMAIL.COM",
      "address": "LA CASONA I, CONJUNTO RESIDENCIAL LOS JARDINES EDIFICIO D PISO 3 APARTAMENTO 4",
      "client_identification": "V9692306",
      "nap_box_name": "CAJA NAP EDIF E CASONA 2",
      "created_at": "2025-05-06T15:03:21.707753",
      "service_detail": {
        "id": 8519,
        "ip": "10.14.10.2",
        "mac": "HWTC49200729",
        "serial": "HWTC49200729",
        "queue": "Plan_131337_24341_WispHub",
        "interface": "VLAN109_CASONA_1",
        "created_at": "2025-05-08T08:53:57.187976",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8088,
      "client_name": "AGUSTIN ENRIQUE COLMENARES MEJIAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona I",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04142759792",
      "client_email": "AGUSTINCOLMENARES@GMAIL.COM",
      "address": "LA CASONA I, URB LOS JARDINES EDIFICIO D PLANTA BAJA APTO 6",
      "client_identification": "V4563254",
      "nap_box_name": "CAJA NAP EDIF E CASONA 2",
      "created_at": "2025-05-06T15:16:57.878267",
      "service_detail": {
        "id": 8495,
        "ip": "10.13.249.2",
        "mac": "HWTC49200744",
        "serial": "HWTC49200744",
        "queue": "Plan_131337_24341_WispHub",
        "interface": "VLAN109_CASONA_1",
        "created_at": "2025-05-06T16:19:28.474555",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8089,
      "client_name": "EDIMER DE LA CARIDAD RODRIGUEZ BOYER",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "SUSPENDIDO_RESIDENCIAL",
      "status_name": "Suspendido",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04242530646",
      "client_email": "EDIMERBOYER@GMAIL.COM",
      "address": "SAMAN TARAZONERO II, MANZANA B-8 CASA 6",
      "client_identification": "V21335923",
      "nap_box_name": "186",
      "created_at": "2025-05-06T15:29:39.222696",
      "service_detail": {
        "id": 8518,
        "ip": "10.14.9.2",
        "mac": "HWTC49200737",
        "serial": "HWTC49200737",
        "queue": "queue1",
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2025-05-08T08:34:12.252561",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8090,
      "client_name": "JAVIER EPIFANIO MONTEZUMA SOSA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "San Pablo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04120380803",
      "client_email": "JEYJOUJOU680@GMAIL.COM",
      "address": "CALLE FERGUS EDIF. RESIDENCIA CAMELO PISO PB APT A-2 SAN PABLO",
      "client_identification": "V29771075",
      "nap_box_name": "CTO-00413",
      "created_at": "2025-05-06T15:46:50.627267",
      "service_detail": {
        "id": 8496,
        "ip": "10.13.247.2",
        "mac": "OEMT3C620836",
        "serial": "OEMT3C620836",
        "queue": "Plan_107915_15811_WispHub",
        "interface": "VLAN224_SAN_PABLO_OLT1",
        "created_at": "2025-05-06T16:40:11.516999",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8091,
      "client_name": "JOSE FRANK VEGA RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Residencias Mariño",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243595256",
      "client_email": "MIMI33SATORRE@GMAIL.COM",
      "address": "CALLE MARIÑO RESIDENCIA MARIÑO TORRE C PISO 11 APT 112",
      "client_identification": "V84495409",
      "nap_box_name": "CTO-0520",
      "created_at": "2025-05-06T15:51:45.704713",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8092,
      "client_name": "JAROL UZIEL SANCHEZ CONTRERAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "1ro de Mayo Norte",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04264367667",
      "client_email": "UUZIEL889@GMAIL.COM",
      "address": "CALLE INTERCOMUNAL CASA NRO 35-1 SECTOR PRIMERO DE MAYO NORTE",
      "client_identification": "V18177450",
      "nap_box_name": "CTO - 920",
      "created_at": "2025-05-06T16:07:22.911867",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8093,
      "client_name": "MARTHA OSMAIRI CARAPAICA MENA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "1ro de Mayo Norte",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04164067127",
      "client_email": "OSCARLISTANCO@GMAIL.COM",
      "address": "CALLE PARAMACONI PRIMERO MAYO NORTE CASA S/N",
      "client_identification": "V15963042",
      "nap_box_name": "CTO-00383",
      "created_at": "2025-05-06T16:21:24.117445",
      "service_detail": {
        "id": 8507,
        "ip": "10.13.233.2",
        "mac": "OEMT3C62111A",
        "serial": "OEMT3C62111A",
        "queue": "queue1",
        "interface": "VLAN261_1ERO_MAYO_ZTE",
        "created_at": "2025-05-07T15:00:25.475942",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8094,
      "client_name": "DAYANA VIRGINIA MATHEUS LUZON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona I",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04149442381",
      "client_email": "DAYANA.MATHEUS@GMAIL.COM",
      "address": "LA CASONA I, CONJUNTO RESIDENCIAL LOS JARDINES EDIFICIO F PISO 3 APT5",
      "client_identification": "V16011399",
      "nap_box_name": "CAJA NAP EDIF E CASONA 2",
      "created_at": "2025-05-06T16:45:48.327181",
      "service_detail": {
        "id": 8508,
        "ip": "10.13.252.2",
        "mac": "OEMT3C62043A",
        "serial": "OEMT3C62043A",
        "queue": "Plan_131341_24341_WispHub",
        "interface": "VLAN109_CASONA_1",
        "created_at": "2025-05-07T15:38:17.124625",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8095,
      "client_name": "OMAR JOSE RUI BLANCO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Residencias Mariño",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243520169",
      "client_email": "ADRIANAGABI2007@GMAIL.COM",
      "address": "TORRE A RESIDENCIAS MARIÑO PLANTA TIPO 3PISO 32 A",
      "client_identification": "V3435567",
      "nap_box_name": "CTO-0518",
      "created_at": "2025-05-06T16:52:56.739391",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8096,
      "client_name": "YASMIN DEL VALLE MILLAN RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Bicentenario",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243240999",
      "client_email": "YASMINMILLAN165@GMAIL.COM",
      "address": "BICENTENARIO, CALLE LOS ROBLES MANZANA 13 CASA NRO 5/PA URB DESARROLLO URBANÍSTICO ROSARIO DE PAYA",
      "client_identification": "V10224962",
      "nap_box_name": "382",
      "created_at": "2025-05-06T17:09:36.173495",
      "service_detail": {
        "id": 8510,
        "ip": "10.14.2.2",
        "mac": "OEMT3C620F2A",
        "serial": "OEMT3C620F2A",
        "queue": "queue1",
        "interface": "VLAN243_BICENTENARIO",
        "created_at": "2025-05-07T15:59:04.384491",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8097,
      "client_name": "YSRRAEL JONAS MUNOZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Cambur",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04264518703",
      "client_email": "YSMUNO2.033@GMAIL.COM",
      "address": "CALLE PRINCIPAL EL CAMBUR CASA NRO 48",
      "client_identification": "V15037848",
      "nap_box_name": "CTO-00150",
      "created_at": "2025-05-06T17:18:59.728407",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8098,
      "client_name": "CARMEN MARIA CHIRINOS RIVERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Betania",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04269071336",
      "client_email": "CARMENCHIRINOS577@GMAIL.COM",
      "address": "CALLE LOS TULIPANES CASA NRO 161 PARCELAMIENTO 6",
      "client_identification": "V25066220",
      "nap_box_name": "CTO-00376",
      "created_at": "2025-05-06T17:31:05.051393",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8099,
      "client_name": "MIGUEL EUGENIO MORONTA SILVA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Betania",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04247419113",
      "client_email": "YUSMARIANDREINAPEREZ@GMAIL.COM",
      "address": "CALLE 6, CASA NRO 400, SECTOR BETANIA",
      "client_identification": "V9436490",
      "nap_box_name": "CTO-00249",
      "created_at": "2025-05-06T17:37:44.041662",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8100,
      "client_name": "YUSMARI COROMOTO PARRA SOLIS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243618341",
      "client_email": "YUSMARIPARRA1126@GMAIL.COM",
      "address": "PRADO DE PAYA II, CALLE 20 CASA 35",
      "client_identification": "V32003282",
      "nap_box_name": "CTO-00118 DOS",
      "created_at": "2025-05-06T17:47:52.780750",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8101,
      "client_name": "AROLDO JESUS CONTRERAS LOVERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Betania",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124571087",
      "client_email": "marbegonza32@gmail.com",
      "address": "BETANIA, CALLE EL MIRADOR CASA NRO 98 SECTOR PARCELAMIENTO 6 PAYA",
      "client_identification": "V25574960",
      "nap_box_name": "CE - 681",
      "created_at": "2025-05-10T11:53:59.028814",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8102,
      "client_name": "HAROLD WILFREDO OSECHA HACHE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vallecito",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243107098",
      "client_email": "HAROLDWILFREDO28@GMAIL.COM",
      "address": "CALLE EL NARANJAL CASA NRO 12 SECTOR VALLECITO ROSARIO DE PAYA",
      "client_identification": "V17578677",
      "nap_box_name": "CTO - 997",
      "created_at": "2025-05-10T12:08:44.515392",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8103,
      "client_name": "JUDITH SUBDALIA MARQUEZ NIEVES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Esperanza",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124544455",
      "client_email": "JUDIMARQUEZ719@GMAIL.COM",
      "address": "CALLE3 CASA NRO 14 URB LA ESPERANZA MACARO",
      "client_identification": "V8741918",
      "nap_box_name": "CTO-00462",
      "created_at": "2025-05-10T12:20:55.295792",
      "service_detail": {
        "id": 8552,
        "ip": "10.14.36.2",
        "mac": "OEMT3C621152",
        "serial": "OEMT3C621152",
        "queue": "queue1",
        "interface": "VLAN137_LA_ESPERANZA_OLT_ZTE",
        "created_at": "2025-05-10T16:12:57.921926",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8104,
      "client_name": "JEANFRANCO JOSE MONTERO BUSTAMANTE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero I",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128905384",
      "client_email": "JEANFRANCOMONTERO16@GMAIL.COM",
      "address": "CALLE 2 CASA NRO 46 URB SAMAN TARAZONERO I",
      "client_identification": "V28316747",
      "nap_box_name": "444",
      "created_at": "2025-05-10T12:56:30.883777",
      "service_detail": {
        "id": 8553,
        "ip": "10.14.37.2",
        "mac": "OEMT3C621192",
        "serial": "OEMT3C621192",
        "queue": "queue1",
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2025-05-10T16:16:01.185103",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8105,
      "client_name": "ARGELIS MARIA PONTE ESPINOZA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona I Edificios",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04125950755",
      "client_email": "ARGELISPONTE96@GMAIL.COM",
      "address": "CASONA II, EDIFICIO D PISO 3 APTO 6 TURMERO ZONA POSTAL 2115",
      "client_identification": "V25910718",
      "nap_box_name": "CE - 424",
      "created_at": "2025-05-10T13:09:13.706155",
      "service_detail": {
        "id": 8554,
        "ip": "10.14.38.2",
        "mac": "OEMT3C62119E",
        "serial": "OEMT3C62119E",
        "queue": "Plan_131341_24341_WispHub",
        "interface": "VLAN110_CASONA_2",
        "created_at": "2025-05-10T16:19:04.077385",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8106,
      "client_name": "PETRA DOMINGA NUNEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243527229",
      "client_email": "NINOSKALOP80@GMAIL.COM",
      "address": "CALLE MADARIAGA CASA #35 SECTOR CASCO DE TURMERO",
      "client_identification": "V1976676",
      "nap_box_name": "CTO - 939",
      "created_at": "2025-05-10T13:20:27.807021",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8108,
      "client_name": "JOSE ENRIQUE CARMONA BARRIOS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Magdalena",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243262294",
      "client_email": "JCB.258369@GMAIL.COM",
      "address": "CALLE 7 CASA NRO 31 BARRIO LA MAGDALENA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V28387572",
      "nap_box_name": "627 DOS",
      "created_at": "2025-05-10T13:37:17.885702",
      "service_detail": {
        "id": 9883,
        "ip": "10.14.27.2",
        "mac": "OEMT3C62107E",
        "serial": "OEMT3C62107E",
        "queue": null,
        "interface": "VLAN114_MAGDALENA",
        "created_at": "2025-11-10T19:40:24.911702",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8109,
      "client_name": "ANGEL DE LA CRUZ FRANCO CARREÑO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Concepcion III",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04129235372",
      "client_email": "ANGEL102FRANCO@GMAIL.COM",
      "address": "CALLE BOLIVAR CASA 113 SECTOR SAN MIGUEL CACHIPO NORTE",
      "client_identification": "V27289898",
      "nap_box_name": "CTO - 940",
      "created_at": "2025-05-10T13:55:23.587529",
      "service_detail": {
        "id": 11844,
        "ip": "10.13.254.2",
        "mac": "GPON00C420F8",
        "serial": "GPON00C420F8",
        "queue": null,
        "interface": "VLAN139_GUERITO",
        "created_at": "2026-02-27T12:09:05.354330",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8110,
      "client_name": "FRANCISCO XAVIER ALVAREZ ROCHE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Macaro",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04127098719",
      "client_email": "XAVIERALVAREZ052@GMAIL.COM",
      "address": "CALLE HENRY PITIER CASA NRO 31 BARRIO ANTONIO JOSE DE SUCRE EL MACARO",
      "client_identification": "V22286131",
      "nap_box_name": "CE - 523",
      "created_at": "2025-05-10T14:09:56.309947",
      "service_detail": {
        "id": 8558,
        "ip": "10.14.39.2",
        "mac": "HWTC49200746",
        "serial": "HWTC49200746",
        "queue": "queue1",
        "interface": "VLAN127_SANTA_EDUVIGES",
        "created_at": "2025-05-10T16:36:51.354059",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8111,
      "client_name": "CARLOS ROBERTO ESPINOZA ARANGUREN",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villa De San Jose",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243707921",
      "client_email": "C.ESPINOZAD777@GMAIL.COM",
      "address": "CONJ. RESIDENCIAL VALLE DE SAN JOSE CASA 03-12 CALLE 2 MACARO",
      "client_identification": "V12852627",
      "nap_box_name": "CTO-00191",
      "created_at": "2025-05-10T14:24:11.763398",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8112,
      "client_name": "JESSICA ROSSANA ALTUNA LOPEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Macarena",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243739421",
      "client_email": "JESSIALTUNA1984@GMAIL.COM",
      "address": "CALLE 9 CASA #2 LA MACARENA VIA EL MACARO",
      "client_identification": "V17800295",
      "nap_box_name": "667",
      "created_at": "2025-05-10T14:33:54.385189",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8113,
      "client_name": "SECARLET MICHELLS BRAVO CORDERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero I",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04264067543",
      "client_email": "MCHELBRAVO@GMAIL.COM",
      "address": "CALLE 14 CASA #12 EL MACARO SAMAN TARAZONERO I",
      "client_identification": "V25880316",
      "nap_box_name": "674 DOS",
      "created_at": "2025-05-10T14:49:26.441869",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8114,
      "client_name": "JESUS RENATO REYES JASPE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona I",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04168433960",
      "client_email": "RENATOREY88@GMAIL.COM",
      "address": "CALLE PRINCIPAL EDIF D PISO 3 APT 6 LA CASONA I",
      "client_identification": "V24540831",
      "nap_box_name": "CAJA NAP EDIF E CASONA 2",
      "created_at": "2025-05-10T14:59:05.251465",
      "service_detail": {
        "id": 8562,
        "ip": "10.14.43.2",
        "mac": "OEMT3C620D46",
        "serial": "OEMT3C620D46",
        "queue": "Plan_131337_24341_WispHub",
        "interface": "VLAN109_CASONA_1",
        "created_at": "2025-05-10T16:49:56.821520",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8115,
      "client_name": "MARIA DE LOS ANGELES MERENTES FERNANDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona I Edificios",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144325195",
      "client_email": "ANGELESFERNANDEZNAZLY@GMAIL.COM",
      "address": "LA CASONA I, AV INTERCOMUNAL EDIFICIO G PISO 1 APT A TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V8840209",
      "nap_box_name": "CAJA NAP EDIF E CASONA 2",
      "created_at": "2025-05-10T15:10:18.311623",
      "service_detail": {
        "id": 11660,
        "ip": "10.14.49.2",
        "mac": "689FF0CC868F",
        "serial": "QXTLCBE8001B",
        "queue": null,
        "interface": "VLAN109_CASONA_1",
        "created_at": "2026-02-18T11:41:28.224590",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8116,
      "client_name": "ORLANDO ALEIXIS REVERON PARRA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona I",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04145961028",
      "client_email": "REVERONORLANDO1@GMAIL.COM",
      "address": "AV INTERCOMUNAL LA CASONA I, CALLE 10 CASA#35",
      "client_identification": "V9651621",
      "nap_box_name": "CE - 393",
      "created_at": "2025-05-10T15:29:46.828820",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8117,
      "client_name": "ANDRY RAMON ARCIA SALAZAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Guerito",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04129321981",
      "client_email": "JRMATU.7260TE@GMAIL.COM",
      "address": "GUERITO, CALLE PIAR CASA #135 BARRIO SAN MIGUEL",
      "client_identification": "V25444319",
      "nap_box_name": "CTO - 940",
      "created_at": "2025-05-10T15:56:50.598821",
      "service_detail": {
        "id": 11843,
        "ip": "10.14.60.2",
        "mac": "OEMT3C6203FE",
        "serial": "OEMT3C6203FE",
        "queue": null,
        "interface": "VLAN139_GUERITO",
        "created_at": "2026-02-27T12:08:33.046984",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8118,
      "client_name": "VANESSA JULLIETT SOSA CARTAYA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona I Edificios",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243416579",
      "client_email": "CARTAYAANDREA7@GMAIL.COM",
      "address": "AV 102 CASA NRO 4 URB LA JULIA II Turmero Aragua zona postal 2115",
      "client_identification": "V25314205",
      "nap_box_name": "CAJA NAP EDIF E CASONA 2",
      "created_at": "2025-05-10T16:12:30.012683",
      "service_detail": {
        "id": 13115,
        "ip": "10.14.50.2",
        "mac": "QX:TL:CB:45:3C:AD",
        "serial": "QXTLCB453CAD",
        "queue": null,
        "interface": "VLAN109_CASONA_1",
        "created_at": "2026-10-04T16:09:27.070278",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8119,
      "client_name": "ENDER JOSUE PEREZ LOMAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Concepcion III",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124116991",
      "client_email": "QUENDER145@GMAIL.COM",
      "address": "CALLE SECTOR CACHIPO NORTE CASA NRO 41 URB CONJUNTO RESIDENCIAL LA CONCEPCION III.",
      "client_identification": "V27646327",
      "nap_box_name": "CTO-00456",
      "created_at": "2025-05-10T16:25:59.903342",
      "service_detail": {
        "id": 8593,
        "ip": "10.14.55.2",
        "mac": "QXTLCB64D7C2",
        "serial": "QXTLCB64D7C2",
        "queue": "Plan_131337_24341_WispHub",
        "interface": "VLAN111_CONCEPCION",
        "created_at": "2025-05-13T17:27:42.133298",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8120,
      "client_name": "JOHNNY RAFAEL ARTEAGA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243144671",
      "client_email": "SUGEINYARTEAGA@GMAIL.COM",
      "address": "MANZANA 1-8 CASA#16 CALLE 1 SAMAN TARAZONERO II",
      "client_identification": "V12170229",
      "nap_box_name": "504",
      "created_at": "2025-05-10T16:57:44.954636",
      "service_detail": {
        "id": 8564,
        "ip": "10.14.25.2",
        "mac": "HWTC49200747",
        "serial": "HWTC49200747",
        "queue": "queue1",
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2025-05-10T17:09:32.413257",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8122,
      "client_name": "SELENNY MARGARITA PEREZ CONTRERAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Concepcion",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04127794730",
      "client_email": "SELENNYMARGARITA@GMAIL.COM",
      "address": "AV INTERCOMUNAL TURMERO, LA JULIA EDIF 8 PISO 3 APT 5 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V20897807",
      "nap_box_name": "0325",
      "created_at": "2025-05-12T14:16:28.588005",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8124,
      "client_name": "DELIVY DEL CARMEN LANDAETA DE FERRELLI",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Residencias Candys",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121648675",
      "client_email": "DELIVYLANDAETA@GMAIL.COM",
      "address": "CALLE RIVAS RESIDENCIA CANDYS, APT 1-3 PISO 1 TORRE 2",
      "client_identification": "V16850521",
      "nap_box_name": "CTO-0515",
      "created_at": "2025-05-12T14:44:40.665340",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8125,
      "client_name": "MARIO JOSE OTERO ORELLANA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Los Nisperos",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04245338594",
      "client_email": "NANDYYMARIO@GMAIL.COM",
      "address": "CENTRO CASCO CENTRAL TURMERO CALLE PRINCIPAL LAGUNA PLAZA S/N",
      "client_identification": "V16497057",
      "nap_box_name": "CE - 140",
      "created_at": "2025-05-12T14:56:40.452144",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8126,
      "client_name": "JUANA MARIA VASQUEZ GODOY",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Betania",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04262342429",
      "client_email": "JUANAMORILLO854@GMAIL.COM",
      "address": "BETANIA CALLE 4 CASA 357",
      "client_identification": "V18036562",
      "nap_box_name": "CTO-00249",
      "created_at": "2025-05-12T15:05:10.835312",
      "service_detail": {
        "id": 8752,
        "ip": "10.14.154.2",
        "mac": "QXTLCB32D226",
        "serial": "QXTLCB32D226",
        "queue": "queue1",
        "interface": "VLAN260_BETANIA",
        "created_at": "2025-05-28T08:54:34.426370",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8127,
      "client_name": "NESTOR ORANGEL NAVARRO CASTILLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04120369686",
      "client_email": "NESTORORANGEL@GMAIL.COM",
      "address": "CALLE BERMÚDEZ ENTRE MARIÑO Y MIRANDA NIVEL 1 LOCAL 48 ZONA CASCO",
      "client_identification": "V17798803",
      "nap_box_name": "101",
      "created_at": "2025-05-12T15:07:52.088368",
      "service_detail": {
        "id": 11860,
        "ip": "10.14.22.2",
        "mac": "HWTC49200996",
        "serial": "HWTC49200996",
        "queue": null,
        "interface": "VLAN200_OLTs",
        "created_at": "2026-02-27T17:06:16.926947",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8128,
      "client_name": "JOSE ANTONIO MENDEZ NIÑO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144869616",
      "client_email": "NAIRETHCABRERA87@GMAIL.COM",
      "address": "AV 2 CASA 519-B URBANISMO MATA CABALLO",
      "client_identification": "V19132208",
      "nap_box_name": "160",
      "created_at": "2025-05-12T15:16:16.587616",
      "service_detail": {
        "id": 8577,
        "ip": "10.14.16.2",
        "mac": "OEMT3C620486",
        "serial": "OEMT3C620486",
        "queue": "queue1",
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2025-05-12T21:16:40.182376",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8129,
      "client_name": "CARMEN TANIA QUEVEDO DIAZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "SUSPENDIDO_RESIDENCIAL",
      "status_name": "Suspendido",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Cambur",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04120361082",
      "client_email": "QUEVEDOCARMEN0606*@GMAIL.COM",
      "address": "CALLE PRINCIPAL LAS MERCEDES CASA#00 SECTOR EL CAMBUR ROSARIO DE PAYA",
      "client_identification": "V9687372",
      "nap_box_name": "CTO - 883",
      "created_at": "2025-05-12T15:24:42.112177",
      "service_detail": {
        "id": 8601,
        "ip": "10.14.17.2",
        "mac": "QXTLCBFDBF6B",
        "serial": "QXTLCBFDBF6B",
        "queue": "queue1",
        "interface": "VLAN263_EL_CAMBUR",
        "created_at": "2025-05-13T21:48:32.344131",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8130,
      "client_name": "BRAYAN ENRIQUE DUQUE VILLARREAL",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Bicentenario",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121800862",
      "client_email": "IDIELSIGONZALEZ@GMAIL.COM",
      "address": "FUNDABARRIO MANZANA 13 CASA 3 PLANTA ALTA",
      "client_identification": "V26044013",
      "nap_box_name": "381",
      "created_at": "2025-05-12T15:29:06.722625",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8131,
      "client_name": "HECTOR JOSE BLANCO ROJAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Dios Es Mi Refugio",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04145876568",
      "client_email": "BLANCOYANGEIBY@GMAIL.COM",
      "address": "CALLE MANZANA 2 CASA PARCELA 08 ROSARIO DE PAYA",
      "client_identification": "V11028544",
      "nap_box_name": "CTO-0656",
      "created_at": "2025-05-12T15:43:34.302773",
      "service_detail": {
        "id": 12072,
        "ip": "10.14.18.2",
        "mac": "OEMT3C620F26",
        "serial": "OEMT3C620F26",
        "queue": null,
        "interface": "VLAN271_DIOS_ES_MI_REFUGIO_OLT1",
        "created_at": "2026-03-15T15:19:56.569796",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8132,
      "client_name": "ANY DELFINA SANS BARRIOS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144900535",
      "client_email": "ANYDELFINASANS@GMAIL.COM",
      "address": "CALLE PASAJE CAÑAFITOLA CASA #7 SECTOR VILLA CASTIN",
      "client_identification": "V8741117",
      "nap_box_name": "228",
      "created_at": "2025-05-12T15:50:04.240684",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8133,
      "client_name": "ARELIS SOLEDAD CASTRO RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Betania",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243598946",
      "client_email": "CASTROARELIS492@GMAIL.COM",
      "address": "COMUNIDAD BETANIA CALLE 5 CASA #136 BETANIA",
      "client_identification": "V20066165",
      "nap_box_name": "CTO - 1007",
      "created_at": "2025-05-12T16:04:20.710999",
      "service_detail": {
        "id": 8592,
        "ip": "10.14.54.2",
        "mac": "QXTLCB7AA8DE",
        "serial": "QXTLCB7AA8DE",
        "queue": "queue1",
        "interface": "VLAN260_BETANIA",
        "created_at": "2025-05-13T17:25:18.110440",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8134,
      "client_name": "GLEINI JOSEFINA PADILLA DE SANZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Las Rurales",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124829769",
      "client_email": "GLEINI15@GMAIL.COM",
      "address": "CALLE MIGUEL POLEO CASA N#20 LAS RURALES",
      "client_identification": "V17245043",
      "nap_box_name": "CE - 769",
      "created_at": "2025-05-12T16:08:39.426715",
      "service_detail": {
        "id": 8605,
        "ip": "10.14.63.2",
        "mac": "QXTLCB956F7E",
        "serial": "QXTLCB956F7E",
        "queue": "queue1",
        "interface": "VLAN252_RURALES_PAYA",
        "created_at": "2025-05-13T22:02:04.609154",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8135,
      "client_name": "KEVIN JOSE PINEDA TORRES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Payita",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04125102804",
      "client_email": "PINEDAKEVIN120@GMAIL.COM",
      "address": "CALLE CALLEJON ARAGUANEY CASA 01 SECTOR PAYITA",
      "client_identification": "V25501183",
      "nap_box_name": "CTO - 1028",
      "created_at": "2025-05-12T16:14:02.099653",
      "service_detail": {
        "id": 8625,
        "ip": "10.14.32.2",
        "mac": "OEMT3C621076",
        "serial": "OEMT3C621076",
        "queue": "queue1",
        "interface": "VLAN284_PAYITA",
        "created_at": "2025-05-14T16:06:15.285780",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8136,
      "client_name": "ELIXON ELIEZER RICO CASTILLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ppal Paya",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243754013",
      "client_email": "ELINXONRICO6@GMAIL.COM",
      "address": "CALLE EL MIRADOR, CASA N#142 PARCELAMIENTO  N#6, PPAL DE PAYA",
      "client_identification": "V30147815",
      "nap_box_name": "CTO-00271",
      "created_at": "2025-05-12T16:34:32.528807",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8137,
      "client_name": "GRISLEYDA GREGORIA TORIN NADAL",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Guerito",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124197446",
      "client_email": "TORINGRISLEYDA@GMAIL.COM",
      "address": "CALLE PRINCIPAL DE GUERITO EDIF TERRAZA 4-B PISO PB APT B-1",
      "client_identification": "V12995065",
      "nap_box_name": "CE (Proyecto)",
      "created_at": "2025-05-12T16:38:19.305115",
      "service_detail": {
        "id": 8576,
        "ip": "10.14.26.2",
        "mac": "OEMT3C62118A",
        "serial": "OEMT3C62118A",
        "queue": "Plan_131337_24341_WispHub",
        "interface": "VLAN139_GUERITO",
        "created_at": "2025-05-12T21:13:53.260861",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8138,
      "client_name": "MARIA JOSE QUINTANA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "San Pablo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04241956409",
      "client_email": "MQUINTANA_2011@HOTMAIL.COM",
      "address": "URB SAN PABLO CC MILAM PLAZA APTO1-3",
      "client_identification": "V14893321",
      "nap_box_name": "CTO-00588",
      "created_at": "2025-05-12T16:55:28.607706",
      "service_detail": {
        "id": 8582,
        "ip": "10.14.46.2",
        "mac": "HWTC49200749",
        "serial": "HWTC49200749",
        "queue": "Plan_92300_15811_WispHub",
        "interface": "VLAN224_SAN_PABLO_OLT1",
        "created_at": "2025-05-13T10:02:59.051455",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8139,
      "client_name": "ZOHIRA DEL CARMEN GIL DURAND",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "SUSPENDIDO_RESIDENCIAL",
      "status_name": "Suspendido",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121487831",
      "client_email": "LOLEGAMO58@GMAIL.COM",
      "address": "CALLE MARIÑO RESIDENCIAS MARIÑO TORRE B PISO 9 APTO. N#94",
      "client_identification": "V5628422",
      "nap_box_name": "CAJA NAP EDIFICIO ABUUT",
      "created_at": "2025-05-12T16:58:56.487082",
      "service_detail": {
        "id": 8608,
        "ip": "10.14.66.2",
        "mac": "QXTLCB7262F2",
        "serial": "QXTLCB7262F2",
        "queue": "queue1",
        "interface": "VLAN234_R_MARINO_OLT2",
        "created_at": "2025-05-14T08:49:44.505897",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8140,
      "client_name": "MISAEL ANTONIO PARRA LEAL",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121993270",
      "client_email": "MFMAEM@GMAIL.COM",
      "address": "CALLE MARIÑO EDIFICIO LA TRINIDAD LOCAL #03 CASCO DE TURMERO",
      "client_identification": "V19277774",
      "nap_box_name": "CTO-00233",
      "created_at": "2025-05-12T17:07:38.771081",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8141,
      "client_name": "WILMER JOSUE CARRILLO LOPEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "1ro de Mayo Sur",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121977025",
      "client_email": "WILNERCARRILLO64@GMAIL.COM",
      "address": "PRIMERO DE MAYO SUR CALLE MIGUEL RODRIGUEZ CASA #03 ROSARIO DE PAYA",
      "client_identification": "V24445118",
      "nap_box_name": "CTO-00149",
      "created_at": "2025-05-12T18:16:40.860737",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8142,
      "client_name": "DEYCI PAOLA ESCALONA DE SOLORZANO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Terrazas de Paya",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128991914",
      "client_email": "ESCALONADEYSI69@GMAIL.COM",
      "address": "CALLE 8 CASA NRO 12 SECTOR TERRAZA DE PAYA ROSARIO DE PAYA",
      "client_identification": "V9676799",
      "nap_box_name": "595",
      "created_at": "2025-05-12T18:24:31.137418",
      "service_detail": {
        "id": 12739,
        "ip": "10.14.20.2",
        "mac": "a8:bf:3c:62:09:42",
        "serial": "OEMT3C620942",
        "queue": null,
        "interface": "VLAN243_BICENTENARIO",
        "created_at": "2026-07-15T11:46:07.161872",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8143,
      "client_name": "YENIFER CAROLINA SULBARAN HERNANDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Sector los Mangos",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04140327470",
      "client_email": "YENNYSULBA04@GMAIL.COM",
      "address": "AV PRINCIPAL LOS MANGOS CASA # 02 ROSARIO DE PAYA",
      "client_identification": "V24190088",
      "nap_box_name": "CTO - 1112",
      "created_at": "2025-05-12T18:37:01.445381",
      "service_detail": {
        "id": 8591,
        "ip": "10.14.14.2",
        "mac": "OEMT3C620B2A",
        "serial": "OEMT3C620B2A",
        "queue": "queue1",
        "interface": "VLAN267_LOS_MANGOS_ZTE",
        "created_at": "2025-05-13T17:19:22.163866",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8144,
      "client_name": "MARYURI JUDITH ROJAS GUANIPA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04169077456",
      "client_email": "ruizjairimar46@gmail.com",
      "address": "AV CARRETERA VIEJA CARACAS LOS TEQUES SECTOR LAS LOMITAS NRO A-1 CARACAS",
      "client_identification": "V14471824",
      "nap_box_name": "468",
      "created_at": "2025-05-12T18:53:40.756497",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8145,
      "client_name": "FRANKLIN EDUARDO LEON SILVA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vallecito",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04125973735",
      "client_email": "SNOOPY12298@GMAIL.COM",
      "address": "CALLE LOS MANGOS CASA #25 SECTOR VALLECITO ROSARIO DE PAYA",
      "client_identification": "V24930117",
      "nap_box_name": "CTO-00074",
      "created_at": "2025-05-12T19:00:59.075039",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8146,
      "client_name": "PATRICIA VALENTINA DIAZ DIAZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121499909",
      "client_email": "VALENTINADIAZDIAZ217@GMAIL.COM",
      "address": "CALLE CARREÑO EDIF 7 PISO 3 APT 2 URB HACIENDA EL NISPERO TURMERO",
      "client_identification": "V32195771",
      "nap_box_name": "CTO-00513",
      "created_at": "2025-05-12T19:17:17.380178",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8147,
      "client_name": "ECLIPSE NAYARITH CARDOZO MARTINEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "1ro de Mayo Sur",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04122982765",
      "client_email": "ECLIPSECARDOZO@GMAIL.COM",
      "address": "CALLE LA PAZ 1 PRIMERO DE MAYO SUR CASA N#14 ROSARIO DE PAYA",
      "client_identification": "V32619252",
      "nap_box_name": "CTO - 914",
      "created_at": "2025-05-13T08:54:40.754576",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8148,
      "client_name": "JANNETXYS JOSE FUENTES RIVERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "San Pablo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121489756",
      "client_email": "GINECOJANNEF@GMAIL.COM",
      "address": "URB SAN PABLO AV INDUSTRIAL LA LAGUNA I EDIFICIO 13 PISO 4 APTO 13D4",
      "client_identification": "V20117458",
      "nap_box_name": "CTO-0489",
      "created_at": "2025-05-13T09:21:38.468987",
      "service_detail": {
        "id": 12788,
        "ip": "10.14.68.2",
        "mac": "QX:TL:CB:9F:01:11",
        "serial": "QXTLCB9F0111",
        "queue": null,
        "interface": "VLAN224_SAN_PABLO_OLT1",
        "created_at": "2026-08-05T13:09:26.625710",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8149,
      "client_name": "JOSE RAMON ACHE OLIVO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04162071519",
      "client_email": "ACHE54416@GMAIL.COM",
      "address": "EZEQUIEL ZAMORA TORRES 7 PISO 5 APTO 4",
      "client_identification": "V11984168",
      "nap_box_name": "CTO-00225",
      "created_at": "2025-05-13T14:40:37.505157",
      "service_detail": {
        "id": 8670,
        "ip": "10.14.56.2",
        "mac": "HWTC49200535 * L6PW8 *",
        "serial": "HWTC49200535",
        "queue": "Plan_92194_15811_WispHub",
        "interface": "VLAN209_ZAMORA_OLT1",
        "created_at": "2025-05-16T17:04:09.377675",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8150,
      "client_name": "KELLY ANDREA GALIPOLE DE LUCA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "San Pablo",
      "plan": {
        "id": 43,
        "name": "RECURRENTE RESIDENCIAL PLAN 650M",
        "cost": "46.00",
        "code": "FOR650M",
        "profile": "650M/650M"
      },
      "client_mobile": "04140476979",
      "client_email": "ANDREA22815@HOTMAIL.COM",
      "address": "AV PRINCIPAL URBANIZACION SAN PABLO MANZANA 11 CASA 3",
      "client_identification": "V140380454",
      "nap_box_name": "CTO-0637",
      "created_at": "2025-05-13T14:56:31.524652",
      "service_detail": {
        "id": 8598,
        "ip": "10.14.33.2",
        "mac": "OEMT3C620536",
        "serial": "OEMT3C620536",
        "queue": "Plan_92194_15811_WispHub",
        "interface": "VLAN224_SAN_PABLO_OLT1",
        "created_at": "2025-05-13T21:24:30.218604",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8151,
      "client_name": "BLEYDIMAR MARIA BORGES JORDAN",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128641878",
      "client_email": "BLEYDIMARBORGES1@GMAIL.COM",
      "address": "EZEQUIEL ZAMORA  EDIFICIO 8 PISO 2 APTO 2",
      "client_identification": "V22948466",
      "nap_box_name": "CTO-00225",
      "created_at": "2025-05-13T15:14:34.372612",
      "service_detail": {
        "id": 8636,
        "ip": "10.14.69.2",
        "mac": "QXTLCBC9EDB7",
        "serial": "QXTLCBC9EDB7",
        "queue": "Plan_107915_15811_WispHub",
        "interface": "VLAN209_ZAMORA_OLT1",
        "created_at": "2025-05-15T11:41:25.895438",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8152,
      "client_name": "ELIZABETH DELGADO VALERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Cambur",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128970463",
      "client_email": "ED11128738@GMAIL.COM",
      "address": "VIA PRINCIPAL LAS MERCEDES CASA N#113 EL CAMBUR",
      "client_identification": "V11128738",
      "nap_box_name": "CTO-00288",
      "created_at": "2025-05-13T15:38:19.248219",
      "service_detail": {
        "id": 8600,
        "ip": "10.14.61.2",
        "mac": "QXTLCB68B43E",
        "serial": "QXTLCB68B43E",
        "queue": "queue1",
        "interface": "VLAN263_EL_CAMBUR",
        "created_at": "2025-05-13T21:43:48.964525",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8153,
      "client_name": "GRECIA ALEXANDRA MARTINEZ PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ppal Paya",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04161997294",
      "client_email": "GRECIAALEXMAR31@GMAIL.COM",
      "address": "CALLE N#5 CASA N#78 SECTOR LA CABALLERISA",
      "client_identification": "V27453651",
      "nap_box_name": "CE - 535",
      "created_at": "2025-05-13T15:52:46.379481",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8155,
      "client_name": "RICHARD ANTONIO FLORES LINARES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Los Caobos",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128414686",
      "client_email": "GERONIMOFLOREA11@GMAIL.COM",
      "address": "CALLE TERCERA CASA NRO.8-1 SECTOR LOS CAOBOS",
      "client_identification": "V10752366",
      "nap_box_name": "633",
      "created_at": "2025-05-14T10:31:27.419775",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8157,
      "client_name": "ANFERNY GABRIEL MANA NIEVES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Concepcion III",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144617238",
      "client_email": "ANFERNNY95@GMAIL.COM",
      "address": "CONJUNTO RESIDENCIAL LA CONCEPCION CALLE 3 CASA NRO 52 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V25635258",
      "nap_box_name": "CTO-00456",
      "created_at": "2025-05-14T11:11:44.896650",
      "service_detail": {
        "id": 12192,
        "ip": "10.14.72.2",
        "mac": "B0A7B954AE69",
        "serial": "TPLGB954EA69",
        "queue": null,
        "interface": "VLAN136_CONCEPCION_3",
        "created_at": "2026-03-26T19:36:21.167161",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8158,
      "client_name": "GABRIELA ALEJANDRA LOPEZ GUILLEN",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243241381",
      "client_email": "GABRIELAALOPEZG22@GMAIL.COM",
      "address": "CALLE 11 CASA #562-C  MATA CABALLO ROSARIO DE PAYA",
      "client_identification": "V29581713",
      "nap_box_name": "CTO-00022",
      "created_at": "2025-05-14T11:39:25.997867",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8159,
      "client_name": "DENIS ESTHEFANY VEGA DE RIVERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Esperanza",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121489447",
      "client_email": "ESTHEFANYVEGA1@GMAIL.COM",
      "address": "CALLE 3 CASA #09 URBANIZACION LA ESPERANZA",
      "client_identification": "V22510778",
      "nap_box_name": "CTO-00462",
      "created_at": "2025-05-14T11:58:47.748140",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8160,
      "client_name": "ALTAGRACIA DEL CARMEN PIRES HERNANDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243037492",
      "client_email": "ALTAGRACIAPIRESHERNANDEZ@GMAIL.COM",
      "address": "CALLE 13 CASA NRO 103 URB. CASONA II TURMERO ZONA POSTAL 2115",
      "client_identification": "V9641167",
      "nap_box_name": "CTO-00091 DOS",
      "created_at": "2025-05-14T12:49:53.299141",
      "service_detail": {
        "id": 9930,
        "ip": "10.14.155.2",
        "mac": "QXTLCB306C3C",
        "serial": "QXTLCB306C3C",
        "queue": null,
        "interface": "VLAN110_CASONA_2",
        "created_at": "2025-11-11T08:39:03.837087",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8161,
      "client_name": "JUANA PAULA GARCIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Paya Abajo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128517696",
      "client_email": "JUANAGARCIA05@GMAIL.COM",
      "address": "CALLE SAN ANTONIO CASA N#24-1 PAYA ABAJO",
      "client_identification": "V7219743",
      "nap_box_name": "271",
      "created_at": "2025-05-14T13:58:27.227428",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8162,
      "client_name": "JORGE LUIS RIVERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121493262",
      "client_email": "JORGERIVERO2507@GMAIL.COM",
      "address": "CALLE N#2 CASA N#10 PRADOS III",
      "client_identification": "V11982570",
      "nap_box_name": "CTO - 1012",
      "created_at": "2025-05-14T14:10:36.359966",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8163,
      "client_name": "ENGELBERT RAFAEL FIGUEROA MATHEUS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Taguapire",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243794962",
      "client_email": "GELBERT326F24@GMAIL.COM",
      "address": "EL MACARO URB. TAGUAPIRE CALLE 1 CASA 11",
      "client_identification": "V29581405",
      "nap_box_name": "548 DOS",
      "created_at": "2025-05-14T14:30:14.161656",
      "service_detail": {
        "id": 10379,
        "ip": "10.14.77.2",
        "mac": "689FF0CCB59F",
        "serial": "QXTLCB62E124",
        "queue": null,
        "interface": "VLAN129_TAGUAPIRE_ZTE",
        "created_at": "2025-11-28T13:04:40.297843",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8164,
      "client_name": "DANIEL EDUARDO PEREZ MASABE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Paraiso",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04245056261",
      "client_email": "EDUARDOPEREZ300597@GMAIL.COM",
      "address": "URBANIZACION EL PARAISO CASA #117 EL MACARO",
      "client_identification": "V29588638",
      "nap_box_name": "345",
      "created_at": "2025-05-14T14:44:19.044362",
      "service_detail": {
        "id": 8623,
        "ip": "10.14.78.2",
        "mac": "QXTLCB14E935",
        "serial": "QXTLCB14E935",
        "queue": "queue1",
        "interface": "VLAN105_EL_PARAISO_OLT_ZTE",
        "created_at": "2025-05-14T15:50:10.657241",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8165,
      "client_name": "MAY LING DURAN ORTEGA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04261398304",
      "client_email": "lingduranmay444@gmail.com",
      "address": "LA CASONA II, SECTOR 11 CALLE 12 CASA 01",
      "client_identification": "V12567765",
      "nap_box_name": "322",
      "created_at": "2025-05-14T14:58:08.874439",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8166,
      "client_name": "NAYLA YSAEL LOPEZ DE SANTIAGO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Betania",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124591865",
      "client_email": "NAYLALOPEZ165@GMAIL.COM",
      "address": "CALLE N#2 CASA N#115 BETANIA",
      "client_identification": "V16692960",
      "nap_box_name": "CTO-00376",
      "created_at": "2025-05-14T15:21:07.409881",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8167,
      "client_name": "JHONANTHER JOSE TRUJILLO MURILLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Cambur",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04141478761",
      "client_email": "JHONANTHERT@GMAIL.COM",
      "address": "CALLE PRINCIPAL EL CAMBUR CASA  N #07",
      "client_identification": "V20911991",
      "nap_box_name": "CTO-00244",
      "created_at": "2025-05-14T15:33:42.262217",
      "service_detail": {
        "id": 12240,
        "ip": "10.14.86.2",
        "mac": "QXTLCBE22F7C",
        "serial": "QXTLCBE22F7C",
        "queue": null,
        "interface": "VLAN263_EL_CAMBUR",
        "created_at": "2026-04-01T15:28:39.019519",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8168,
      "client_name": "OMAR ANTONIO ALEJOS BATANCOURT",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243791939",
      "client_email": "OMARALEJOS@GMAIL.COM",
      "address": "EZEQUIEL ZAMORA, TORRE N#1 EDIFICIO TIORA PISO N#2 APTO.N #3",
      "client_identification": "V11645986",
      "nap_box_name": "CTO-00225",
      "created_at": "2025-05-14T15:50:33.997299",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8169,
      "client_name": "AMARILIS JOSEGELIN MORALES REYES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124123447",
      "client_email": "AMARILIS210MORALES@GMAIL.COM",
      "address": "CALLE BERMMUDEZ CASA N#44 CASCO DE TURMERO",
      "client_identification": "V20982496",
      "nap_box_name": "CTO-00065",
      "created_at": "2025-05-14T16:13:08.996935",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8170,
      "client_name": "IVETTE MARIA PINEDA TORRES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Payita",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243221540",
      "client_email": "IVETTEMARIAPINEDATORRES@GMAIL.COM",
      "address": "CALLE PRINCIPAL PAYITA CASA N #21 C SECTOR TURMERO",
      "client_identification": "V20650313",
      "nap_box_name": "CTO - 1023",
      "created_at": "2025-05-14T16:24:44.422661",
      "service_detail": {
        "id": 8713,
        "ip": "10.14.82.2",
        "mac": "QXTLCBA61E10",
        "serial": "QXTLCBA61E10",
        "queue": "queue1",
        "interface": "VLAN284_PAYITA",
        "created_at": "2025-05-20T14:16:44.341172",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8171,
      "client_name": "YORIANGEL YUNEXIS RODRIGUEZ JASPE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Santa Barbara",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04127766216",
      "client_email": "YORIANGELRODRIGUEZ.23@GMAIL.COM",
      "address": "BARRIO SANTA BARBARA LA GRAN FAMILIA CALLE 5 CASA #32 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V26935506",
      "nap_box_name": "40",
      "created_at": "2025-05-14T19:02:31.974595",
      "service_detail": {
        "id": 10947,
        "ip": "10.14.83.2",
        "mac": "OEMT3C620D22",
        "serial": "OEMT3C620D22",
        "queue": null,
        "interface": "VLAN135_VILLAS_CARMEN_OLT_ZTE",
        "created_at": "2025-12-26T10:16:50.980654",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8172,
      "client_name": "DAVID JOSUE PEREZ BRAVO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Isaac Oliveira",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121443452",
      "client_email": "DAVIDJOSUE.TX200@GMAIL.COM",
      "address": "URBANIZACION ISAAC OLIVEIRA CALLE 3 CASA 142 LA CONCEPCION",
      "client_identification": "V30873895",
      "nap_box_name": "CTO-00259",
      "created_at": "2025-05-14T19:20:13.689727",
      "service_detail": {
        "id": 11815,
        "ip": "10.14.84.2",
        "mac": "QXTLCB6BCE12",
        "serial": "QXTLCB6BCE12",
        "queue": null,
        "interface": "VLAN107_ISAAC_O",
        "created_at": "2026-02-27T11:44:55.613091",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8173,
      "client_name": "EVANS YOKIRA GARCIA PERDONO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04127768092",
      "client_email": "EVANSGARCIA0@GMAIL.COM",
      "address": "MANZANA B1 CASA 12 URB SAMAN TARAZONERO II",
      "client_identification": "V14061756",
      "nap_box_name": "128",
      "created_at": "2025-05-14T19:49:23.421449",
      "service_detail": {
        "id": 8632,
        "ip": "10.14.85.2",
        "mac": "QXTLCB4F47B7",
        "serial": "QXTLCB4F47B7",
        "queue": "queue1",
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2025-05-15T10:16:17.519025",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8174,
      "client_name": "BETTY ANTONIA VILERA JIMENEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128151233",
      "client_email": "BETTYVILERA897@GMAIL.COM",
      "address": "PRADOS II, CALLE 1 CASA 16 ROSARIO DE PAYA",
      "client_identification": "V7229561",
      "nap_box_name": "CTO-00118 DOS",
      "created_at": "2025-05-15T09:37:25.676293",
      "service_detail": {
        "id": 8641,
        "ip": "10.14.80.2",
        "mac": "BDCM8E002120",
        "serial": "BDCM8E002120",
        "queue": "queue1",
        "interface": "VLAN242_PRADOS2",
        "created_at": "2025-05-15T14:18:36.368424",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8175,
      "client_name": "YOHAN ANTONIO LEON AVILA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243058421",
      "client_email": "YOHANGOTO96@GMAIL.COM",
      "address": "EZEQUIEL ZAMORA TORRES 7 PB 3",
      "client_identification": "V24930435",
      "nap_box_name": "20",
      "created_at": "2025-05-15T13:53:12.093592",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8176,
      "client_name": "GERARDO RAMON GONZALEZ GONZALEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 16,
        "name": "RECURRENTE RESIDENCIAL PLAN 800M",
        "cost": "55.00",
        "code": "FOR800",
        "profile": "800M/800M"
      },
      "client_mobile": "04143567385",
      "client_email": "GERARDORG644@GMAIL.COM",
      "address": "CALLE CAMILO TORRES CRUCE CON CAMPO ELIAS EDF VIRGEN DEL VALLE PISO 1\\ 2 CASCO DE TURMERO",
      "client_identification": "V6842384",
      "nap_box_name": "CTO-931",
      "created_at": "2025-05-15T14:09:30.419339",
      "service_detail": {
        "id": 8643,
        "ip": "10.14.88.2",
        "mac": "QXTLCB342FAB",
        "serial": "QXTLCB342FAB",
        "queue": "Plan_92194_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2025-05-15T14:40:32.967341",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8177,
      "client_name": "THAYRIS YSABEL LIMPIO RAMIREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Pantin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243117400",
      "client_email": "THAYRISMIREZ327@GMAIL.COM",
      "address": "PANTIN CALLE 18\\A CASA 22",
      "client_identification": "V25501605",
      "nap_box_name": "CTO-00321",
      "created_at": "2025-05-15T16:17:00.399307",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8178,
      "client_name": "ANGELA ABIGAIL LOPEZ FREITES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Sector los Mangos",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04125970712",
      "client_email": "ANYELY1400@GMAIL.COM",
      "address": "CALLE LAS BRISAS CASA #18 LOS MANGOS",
      "client_identification": "V23681054",
      "nap_box_name": "CTO-00483",
      "created_at": "2025-05-15T16:44:58.682875",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8179,
      "client_name": "JOSELYN ALEXANDRA OROZCO ROSARIO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Sector los Mangos",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128561013",
      "client_email": "JOSELYNOROZ2@GMAIL.COM",
      "address": "CALLE BOLIVAR CON SUCRE CASA 9-B valle verde",
      "client_identification": "V27048682",
      "nap_box_name": "CTO-9696",
      "created_at": "2025-05-15T17:15:19.535656",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8180,
      "client_name": "JAVIER ANTONIO MORILLO ALVARADO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "El Macaro",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04125097182",
      "client_email": "MORILLOJAVIER41@GMAIL.COM",
      "address": "CALLE 25 DE AGOSTO E/VIA EL MACARO Y WILFREDO SILVIA CASA NRO 16 BARRIO ANTONIO JOSE DE SUCRE TURMERO EDO. ARAGUA",
      "client_identification": "V20055509",
      "nap_box_name": "123",
      "created_at": "2025-05-15T18:19:02.151831",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8181,
      "client_name": "JOHANNA LISSETH MANA NIEVES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "La Concepcion III",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144916245",
      "client_email": "JOHANALMN1234@GMAIL.COM",
      "address": "CALLE 3 CASA 51 CONJUNTO RESIDENCIAL CONCEPCION 3",
      "client_identification": "V14103510",
      "nap_box_name": "CTO-00456",
      "created_at": "2025-05-15T18:24:00.356985",
      "service_detail": {
        "id": 12657,
        "ip": "10.14.91.2",
        "mac": "QX:TL:CB:3F:1B:F8",
        "serial": "QXTLCB3F1BF8",
        "queue": null,
        "interface": "VLAN136_CONCEPCION_3",
        "created_at": "2026-07-02T21:53:37.327524",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8183,
      "client_name": "ERIKA RUIZ PAVIQUE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04129282325",
      "client_email": "ERIKAPAVIQUE@GMAIL.COM",
      "address": "CALLE N#27 CASA 07 RIO SECO",
      "client_identification": "V16474723",
      "nap_box_name": "598",
      "created_at": "2025-05-16T10:39:44.474157",
      "service_detail": {
        "id": 12642,
        "ip": "10.14.93.2",
        "mac": "QX:TL:CB:F3:33:F1",
        "serial": "QXTLCBF333F1",
        "queue": null,
        "interface": "VLAN251_RIO_SECO",
        "created_at": "2026-06-27T19:57:33.414310",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8184,
      "client_name": "LISSETTE GIORDANA BURGOS APONTE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Valle Verde",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121780848",
      "client_email": "JONNATHANMARCANO033@GMAIL.COM",
      "address": "CALLE LOS PORTUGUESES CASA N#7-1 VALLE VERDE",
      "client_identification": "V12169927",
      "nap_box_name": "CTO-00271",
      "created_at": "2025-05-16T10:54:50.265045",
      "service_detail": {
        "id": 9266,
        "ip": "10.14.94.2",
        "mac": "QXTLCBB0600D",
        "serial": "QXTLCBB0600D",
        "queue": "queue1",
        "interface": "VLAN244_PALMAREAL",
        "created_at": "2025-07-26T14:11:55.580526",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8186,
      "client_name": "GLAIDEE YIBELYS PARRA VALBUENA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243401750",
      "client_email": "VENTASILLA174@GMAIL.COM",
      "address": "EZEQUIEL ZAMORA EDIFICIO N #19 PISO N#4 APTO. N#3",
      "client_identification": "V23528701",
      "nap_box_name": "CTO-00225",
      "created_at": "2025-05-16T11:20:59.934665",
      "service_detail": {
        "id": 8681,
        "ip": "10.14.108.2",
        "mac": "QXTLCBAA8E57",
        "serial": "QXTLCBAA8E57",
        "queue": "Plan_92194_15811_WispHub",
        "interface": "VLAN209_ZAMORA_OLT1",
        "created_at": "2025-05-19T11:44:14.247926",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8187,
      "client_name": "RICARDO JOSE VERACIERTA PEDRA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128553415",
      "client_email": "RICARDOJVP1@GMAIL.COM",
      "address": "RESIDENCIAS NELLY PISO N#2 APTO. N#14. CASCO DE TURMERO",
      "client_identification": "V20695139",
      "nap_box_name": "CTO-00072",
      "created_at": "2025-05-16T12:04:40.701329",
      "service_detail": {
        "id": 8682,
        "ip": "10.14.97.2",
        "mac": "QXTLCB451029",
        "serial": "QXTLCB451029",
        "queue": "Plan_107915_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2025-05-19T15:01:42.579934",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8188,
      "client_name": "DILEYDI TAHELI DOMINGUEZ RUIZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243650619",
      "client_email": "DILEYDIDOMINGUEZ@GMAIL.COM",
      "address": "EZEQUIEL ZAMORA EDIF 7 PISO 2 APTO 3",
      "client_identification": "V19173668",
      "nap_box_name": "20",
      "created_at": "2025-05-16T14:03:45.206165",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8189,
      "client_name": "LUIS MIGUEL VILLEGAS BONILLA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Palmeras I",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144476584",
      "client_email": "LUISVILLEGAS2112@GMAIL.COM",
      "address": "URBANIZACION LAS PALMERAS I CALLE 2 CASA 109 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V18692202",
      "nap_box_name": "CTO-00071",
      "created_at": "2025-05-16T14:51:43.432319",
      "service_detail": {
        "id": 8757,
        "ip": "10.14.158.2",
        "mac": "QXTLCBA18B9A",
        "serial": "QXTLCBA18B9A",
        "queue": "queue1",
        "interface": "VLAN118_PALMERAS_1",
        "created_at": "2025-05-28T09:19:03.131680",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8190,
      "client_name": "MARIA DELIA DUQUE DE SILVERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Luz y Vida",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128464901",
      "client_email": "ROBERTHIGUERA551@GMAIL.COM",
      "address": "CALLE 2 CASA NRO 70 SECTOR LUZ Y VIDA ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V9207281",
      "nap_box_name": "CTO-00057 DOS",
      "created_at": "2025-05-16T15:27:44.466953",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8191,
      "client_name": "WILLIAN ADRIAN MELLADO RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Payita",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124626027",
      "client_email": "WILLANXCOROMOTO@GMAIL.COM",
      "address": "CALLE F CASA B21 URB SAN CARLOS TURMERO",
      "client_identification": "V27204714",
      "nap_box_name": "CTO-00073",
      "created_at": "2025-05-16T15:57:15.332479",
      "service_detail": {
        "id": 8664,
        "ip": "10.14.100.2",
        "mac": "QXTLCB477007",
        "serial": "QXTLCB477007",
        "queue": "Plan_107915_15811_WispHub",
        "interface": "VLAN223_SAN_CARLOS_OLT1",
        "created_at": "2025-05-16T16:02:46.245940",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8192,
      "client_name": "JUAN ENRRIQUE TORBELLO OJEDA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "La Guzman",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144640575",
      "client_email": "JO22338123@GMAIL.COM",
      "address": "LA GUZMAN CALLE MEDINA CASA N#13 TURMERO EDO.ARAGUA",
      "client_identification": "V22338123",
      "nap_box_name": "CTO - 1075",
      "created_at": "2025-05-16T16:04:40.051890",
      "service_detail": {
        "id": 8665,
        "ip": "10.14.101.2",
        "mac": "QXTLCB3905E8",
        "serial": "QXTLCB3905E8",
        "queue": "queue1",
        "interface": "VLAN286_LA_GUZMAN",
        "created_at": "2025-05-16T16:08:39.794706",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8194,
      "client_name": "ROSMY WILLIAMS RODRIGUEZ ALVAREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Payita",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243395141",
      "client_email": "RAYNEXUS@GMAIL.COM",
      "address": "CALLE LA CROQUERA CASA 11 SECTOR PAYITA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V18109276",
      "nap_box_name": "CE - 861",
      "created_at": "2025-05-16T16:18:46.327905",
      "service_detail": {
        "id": 13093,
        "ip": "10.14.102.2",
        "mac": "QX:TL:CB:24:D4:7E",
        "serial": "QXTLCB24D47E",
        "queue": null,
        "interface": "VLAN274_VALLELINDO",
        "created_at": "2026-10-01T11:25:43.386889",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8195,
      "client_name": "DEIVIS JOEL LEON MENDOZA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Las Rurales",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128906669",
      "client_email": "JOELYDEXY05@GMAIL.COM",
      "address": "CALLE 1RA TRANSVERSAL CASA NR6 los mangos paya",
      "client_identification": "V21192023",
      "nap_box_name": "CE-00111",
      "created_at": "2025-05-16T16:51:07.007910",
      "service_detail": {
        "id": 8759,
        "ip": "10.14.160.2",
        "mac": "QXTLCB221E5F",
        "serial": "QXTLCB221E5F",
        "queue": "queue1",
        "interface": "VLAN252_RURALES_PAYA",
        "created_at": "2025-05-28T09:49:36.766044",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8196,
      "client_name": "GUO FU ZHENG",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144564889",
      "client_email": "DAVIDZHENG08@GMAIL.COM",
      "address": "CALLE BOLIVAR CC ABRAHAN NIVEL 1 LOCAL 2 CASCO DE TURMERO ESTADO ARAGUA POSTAL 2115",
      "client_identification": "V17552440",
      "nap_box_name": "CTO-00266",
      "created_at": "2025-05-16T16:53:18.271205",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8197,
      "client_name": "CARMEN ROSA GUZMAN MONTENEGRO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Pantin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04141464008",
      "client_email": "ROSAGUZMANMONTES.62@GMAIL.COM",
      "address": "CALLE 6-A CASA N·23 -A URBANIZACION PANTIN TURMERO..EDO. ARAGUA",
      "client_identification": "V7240654",
      "nap_box_name": "CTO-00134",
      "created_at": "2025-05-16T17:05:37.135559",
      "service_detail": {
        "id": 8672,
        "ip": "10.14.104.2",
        "mac": "QXTLCB8C7AA9",
        "serial": "QXTLCB8C7AA9",
        "queue": "queue1",
        "interface": "VLAN229_PANTIN",
        "created_at": "2025-05-16T17:09:39.801841",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8198,
      "client_name": "ANA JUDITH VINA ZARATE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Santa Eduviges",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04140507084",
      "client_email": "ANAJUDITHV2@GMAIL.COM",
      "address": "CALLE1 CASA NRO 4 URB. SANTA EDUVIGES TURMERO ARAGUA ZONA POSTAL 20",
      "client_identification": "V8161709",
      "nap_box_name": "CTO-00257",
      "created_at": "2025-05-16T17:53:49.291912",
      "service_detail": {
        "id": 8675,
        "ip": "10.14.105.2",
        "mac": "QXTLCB6F7C2D",
        "serial": "QXTLCB6F7C2D",
        "queue": "Plan_131337_24341_WispHub",
        "interface": "VLAN143_STAEDUVIGES2",
        "created_at": "2025-05-16T21:22:59.663991",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8199,
      "client_name": "HERNAN ARTURO ROJAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Santa Eduviges",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04167450397",
      "client_email": "HERNANARTUROROJAS1958@GMAIL.COM",
      "address": "SECTOR SANTA EDUVIGES, VEREDA 3, CASA NRO 17, SECTOR EL MACARO, TURMERO EDO ARAGUA, ZONA POSTAL 2115",
      "client_identification": "V7186026",
      "nap_box_name": "62",
      "created_at": "2025-05-17T09:50:16.439042",
      "service_detail": {
        "id": 11396,
        "ip": "10.14.106.2",
        "mac": "QXTLCBA8F5F4",
        "serial": "QXTLCBA8F5F4",
        "queue": null,
        "interface": "VLAN127_SANTA_EDUVIGES",
        "created_at": "2026-01-26T18:39:02.523202",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8200,
      "client_name": "NESTOR RAFAEL MARTINEZ SILVA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121492571",
      "client_email": "NESTOR03MARTINEZ08@GMAIL.COM",
      "address": "EZEQUIEL ZAMORA TORRES 4 PISO 1 APTO 3 TURMERO ESTADO ARAGUA POSTAL 2115",
      "client_identification": "V31895436",
      "nap_box_name": "CTO-00225",
      "created_at": "2025-05-19T08:36:52.285252",
      "service_detail": {
        "id": 8680,
        "ip": "10.14.107.2",
        "mac": "QXTLCB170F4D",
        "serial": "QXTLCB170F4D",
        "queue": "Plan_92194_15811_WispHub",
        "interface": "VLAN209_ZAMORA_OLT1",
        "created_at": "2025-05-19T11:11:08.544294",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8202,
      "client_name": "LUIS EDUARDO BARRADA ROA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "1ro de Mayo Sur",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243020799",
      "client_email": "BARRADALUIS75@GMAIL.COM",
      "address": "CALLE LAS LINEAS CASA N#1-1 PRIMERO DE MAYO SUR ROSARIO DE PAYA.TURMERO EDO ARAGUA.",
      "client_identification": "V30852962",
      "nap_box_name": "CTO-00149",
      "created_at": "2025-05-19T10:43:33.212495",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8203,
      "client_name": "MEIL YOCONDA TOSTA BRICEÑO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04125202803",
      "client_email": "MEILYOCONDA01@GMAIL.COM",
      "address": "CASCO DE TURMERO, CALLE PETION CRUCE CON CALLE MARIÑO CC JARDIN PLANTA NIVEL 2#1-1 TURMERO ESTADO ARAGUA POSTAL 21115",
      "client_identification": "V11092261",
      "nap_box_name": "CTO-00256",
      "created_at": "2025-05-19T10:45:34.300607",
      "service_detail": {
        "id": 8686,
        "ip": "10.14.112.2",
        "mac": "QXTLCB7FF32D",
        "serial": "QXTLCB7FF32D",
        "queue": "Plan_92300_15811_WispHub",
        "interface": "VLAN200_OLTs",
        "created_at": "2025-05-19T16:35:25.144305",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8205,
      "client_name": "LUCIO JOSE CORREA RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Guayabita",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124576856",
      "client_email": "CORREALUCIO214@GMAIL.COM",
      "address": "CALLE CALLEJON CASA AMARILLA  N#97 GUAYABITA.TURMERO EDO ARAGUA",
      "client_identification": "V27864167",
      "nap_box_name": "CE - 954",
      "created_at": "2025-05-19T11:23:04.249393",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8206,
      "client_name": "NORMEDIS TIBAIDIS  MORENO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "SUSPENDIDO_RESIDENCIAL",
      "status_name": "Suspendido",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243596739",
      "client_email": "NORMEIDISTIRBAIDIS@GMAIL.COM",
      "address": "CALLE N#19 CASA N#50 RIO SECO ROSARIO DE PAYA. TURMERO EDO ARAGUA",
      "client_identification": "V15533133",
      "nap_box_name": "CTO-00018",
      "created_at": "2025-05-19T11:42:42.477367",
      "service_detail": {
        "id": 13116,
        "ip": "10.14.114.2",
        "mac": "AD:CG:CC:A3:C0:20",
        "serial": "ADCGCCA3C020",
        "queue": null,
        "interface": "VLAN251_RIO_SECO",
        "created_at": "2026-10-05T11:19:36.712538",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8207,
      "client_name": "MIGLES CAROLINA LIRA BOLSEGUI",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124337331",
      "client_email": "MIGLSLIRA@GMAIL.COM",
      "address": "EZEQUIEL ZAMORA TORRES 6 PISO 3 APTO 4 TURMERO ESTADO ARAGUA POSTAL 21115",
      "client_identification": "V12608216",
      "nap_box_name": "CTO-00225",
      "created_at": "2025-05-19T11:48:06.716624",
      "service_detail": {
        "id": 12660,
        "ip": "10.14.115.2",
        "mac": "QX:TL:CB:52:CB:D3",
        "serial": "QXTLCB52CBD3",
        "queue": null,
        "interface": "VLAN209_ZAMORA_OLT1",
        "created_at": "2026-07-03T10:15:45.235932",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8208,
      "client_name": "DANIELA LEONOR VILLEGAS BONILLA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Palmeras I",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04149352308",
      "client_email": "DANIELAVILLEGAS2112@GMAIL.COM",
      "address": "CALLE PPL, CASA NRO 21 URB PALMERAS I, TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V23783161",
      "nap_box_name": "CTO-00071",
      "created_at": "2025-05-19T12:04:17.894933",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8209,
      "client_name": "REINALDO REYES MONTILLA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "1ro de Mayo Norte",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04123984180",
      "client_email": "MONTILLAREYESREINALDO@GMAIL.COM",
      "address": "CALLE CHORONI CASA N#3  PRIMERO DE MAYO NORTE.TURMERO EDO ARAGUA.",
      "client_identification": "V20649541",
      "nap_box_name": "CTO-00225",
      "created_at": "2025-05-19T12:10:40.073534",
      "service_detail": {
        "id": 8691,
        "ip": "10.14.117.2",
        "mac": "QXTLCB508C15",
        "serial": "QXTLCB508C15",
        "queue": "queue1",
        "interface": "VLAN261_1ERO_MAYO_ZTE",
        "created_at": "2025-05-19T16:49:00.504920",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8211,
      "client_name": "KENDRYS YARISMENDY ELIZ SANCHEZ CERVEN",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Simon Bolivar",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243320888",
      "client_email": "KENDRYSSANCHEZ007@GMAIL.COM",
      "address": "SIMON BOLIVAR CALLE 2 CASA 29 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V21202560",
      "nap_box_name": "CTO-00041",
      "created_at": "2025-05-19T12:31:54.983109",
      "service_detail": {
        "id": 8693,
        "ip": "10.14.119.2",
        "mac": "QXTLCB6F6761",
        "serial": "QXTLCB6F6761",
        "queue": "queue1",
        "interface": "VLAN128_SIMON_BOLIVAR_ZTE",
        "created_at": "2025-05-19T16:53:16.029801",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8213,
      "client_name": "DANIEL JOSUE GRATEROL BOLIVAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "La Concepcion III",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04122941918",
      "client_email": "DANIEL77800205@GMAIL.COM",
      "address": "LA CONCEPCION III CALLE 2 CASA 11 TURMERO ARAGUA ZONA POSTAL 2112",
      "client_identification": "V30818826",
      "nap_box_name": "CE - 252",
      "created_at": "2025-05-19T12:50:39.075207",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8214,
      "client_name": "DELVIA MARILIN MACHINE MONTES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "La Julia",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144743239",
      "client_email": "MARILINMACHINE@GMAIL.COM",
      "address": "CALLE RAFAEL ROJAS CASA14 LA NUEVA JULIA TURMERO ARAGUA ZANA POSTAL 2115",
      "client_identification": "V15735260",
      "nap_box_name": "628",
      "created_at": "2025-05-19T12:57:57.236107",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8215,
      "client_name": "ARGELIA YAMILETH TABARES GUEDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Simon Bolivar",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04122387756",
      "client_email": "TAPIASKIMBERLY0@GMAIL.COM",
      "address": "CALLE 10 CASA 8 SIMON BOLIVAR TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V15864278",
      "nap_box_name": "CTO-00036",
      "created_at": "2025-05-19T13:15:19.461849",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8216,
      "client_name": "RAIMEL JAVIER COLON AREVALO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "El Naranjal",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04167217887",
      "client_email": "RAIMEL80COLON@GMAIL.COM",
      "address": "CALLE LA ESPERANZA CASA N#15 GRANJA EL NARANJAL ROSARIO DE PAYA. TURMERO EDO ARAGUA",
      "client_identification": "V15130671",
      "nap_box_name": "CE - 681",
      "created_at": "2025-05-19T13:18:29.920008",
      "service_detail": {
        "id": 8701,
        "ip": "10.14.125.2",
        "mac": "QXTLCBB920F0",
        "serial": "QXTLCBB920F0",
        "queue": "queue1",
        "interface": "VLAN246_NARANJAL",
        "created_at": "2025-05-19T20:35:43.316240",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8217,
      "client_name": "EDUARDO JOSE MIJARES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Saman de Guere",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243682922",
      "client_email": "EDUARDOMIJARES95@GMAIL.COM",
      "address": "SAMAN DE GUERE CALLE PRIMAVERA CAS 26 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V24344268",
      "nap_box_name": "CTO-00115",
      "created_at": "2025-05-19T13:24:41.374059",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8218,
      "client_name": "EDUARDO MANUEL DUDAMEL MEDRANO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04122599690",
      "client_email": "EDUARDODUDAMEL02@GMAIL.COM",
      "address": "CALLE N#11 CASA N #639-D TETRAS MATA CABALLO ROSARIO DE PAYA .TURMERO EDO ARAGUA",
      "client_identification": "V30755164",
      "nap_box_name": "CTO-0337",
      "created_at": "2025-05-19T13:40:15.963797",
      "service_detail": {
        "id": 8745,
        "ip": "10.14.127.2",
        "mac": "QXTLCB6493F2",
        "serial": "QXTLCB6493F2",
        "queue": "queue1",
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2025-05-26T17:03:10.680621",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8219,
      "client_name": "JORMAN GREGORY DUARTE VILLASMIL",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Simon Bolivar",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04125970643",
      "client_email": "DUARTEJORMAN2014@GMAIL.COM",
      "address": "CALLE 5 CASA 24 SIMON BOLIVAR TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V20108198",
      "nap_box_name": "CTO - 1075",
      "created_at": "2025-05-19T13:42:40.863927",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8220,
      "client_name": "WENDY YOLIMAR GARCIA CAMACHO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Dios Es Mi Refugio",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128844903",
      "client_email": "WENDYGCIA9@GMAIL.COM",
      "address": "MANZANA N#7 PARCELA N#4 DIOS ES MI REFUGIO ROSARIO DE PAYA. TURMERO EDO. ARAGUA",
      "client_identification": "V19530300",
      "nap_box_name": "CTO-0656",
      "created_at": "2025-05-19T13:53:43.049536",
      "service_detail": {
        "id": 8705,
        "ip": "10.14.129.2",
        "mac": "QXTLCBEB6D0B",
        "serial": "QXTLCBEB6D0B",
        "queue": "Plan_107915_15811_WispHub",
        "interface": "VLAN271_DIOS_ES_MI_REFUGIO_OLT1",
        "created_at": "2025-05-19T20:44:52.893194",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8221,
      "client_name": "NADIANNY RUSBET RAMIREZ ROMERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Esperanza",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243166077",
      "client_email": "RAMIREZNADIANNY@GMAIL.COM",
      "address": "CALLE 13 CASA NRO 7 URBANIZACION LA ESPERANZA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V31537104",
      "nap_box_name": "RESERVA 3 TRONCAL LA ESPERANZA",
      "created_at": "2025-05-19T13:58:56.305877",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8222,
      "client_name": "FREYDI SAVIEL ASTUDILLO PEREIRA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Dios Es Mi Refugio",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04242549204",
      "client_email": "LEYDYSLAPRINCES@GMAIL.COM",
      "address": "MANZANA N#03 PARCELA N#4 DIOS ES MI REFUGIO ROSARIO DE PAYA. TURMERO EDO ARAGUA.",
      "client_identification": "V25516189",
      "nap_box_name": "CTO-0656",
      "created_at": "2025-05-19T14:06:10.676105",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8223,
      "client_name": "SORIMAR CARINA TERAN GARCIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Esperanza",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04165469491",
      "client_email": "SORIMARTERAN17@GMAIL.COM",
      "address": "CALLE 17 CASA 13 URBANIZACION LA ESPERANZA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V17015540",
      "nap_box_name": "555",
      "created_at": "2025-05-19T14:09:11.208095",
      "service_detail": {
        "id": 8708,
        "ip": "10.14.132.2",
        "mac": "QXTLCB047338",
        "serial": "QXTLCB047338",
        "queue": "queue1",
        "interface": "VLAN137_LA_ESPERANZA_OLT_ZTE",
        "created_at": "2025-05-19T20:57:48.130149",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8224,
      "client_name": "TEODARDO RAMON APARICIO APARICIO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Betania",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121485843",
      "client_email": "TEODARB84@GMAIL.COM",
      "address": "COMUNIDAD BETANIA CALLE 5 CASA# 129 TURMERO ESTADO ARAGUA POSTAL 2115",
      "client_identification": "V22287142",
      "nap_box_name": "CTO - 1007",
      "created_at": "2025-05-19T14:29:29.696116",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8225,
      "client_name": "LUISA DARYEELNG AGUILAR LOZADA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04221013601",
      "client_email": "dayeerling25091991mnsh@gmail.com",
      "address": "CASCO DE TURMERO CALLE NEGRO PRIMERO CASA 02 TURMERO ESTADO ARAGUA POSTAL 2115",
      "client_identification": "V22870140",
      "nap_box_name": "CTO-00590",
      "created_at": "2025-05-19T15:04:49.062190",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8226,
      "client_name": "JOSE GREGORIO VASQUEZ BUSTAMANTE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Ppal Paya",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124601700",
      "client_email": "JOSEGREGORIO30@GMAIL.COM",
      "address": "CALLE LOS PORTUGUESES CASA N#20 PARCELAMIENTO N#6 PPAL DE PAYA.TURMERO EDO ARAGUA",
      "client_identification": "V21269861",
      "nap_box_name": "CE - 535",
      "created_at": "2025-05-19T15:31:06.249951",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8227,
      "client_name": "NELSON RAFAEL LOPEZ CASTILLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04263301730",
      "client_email": "NLNLOPEZ291@GMAIL.COM",
      "address": "CALLE N #5-A CASA N #03 PANTIN ROSARIO DE PAYA . TURMERO EDO ARAGUA",
      "client_identification": "V7260477",
      "nap_box_name": "CTO-00135",
      "created_at": "2025-05-19T16:54:47.550278",
      "service_detail": {
        "id": 8711,
        "ip": "10.14.135.2",
        "mac": "QXTLCB444232",
        "serial": "QXTLCB444232",
        "queue": "queue1",
        "interface": "VLAN229_PANTIN",
        "created_at": "2025-05-19T21:04:53.821216",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8228,
      "client_name": "YENDER ALEXANDER MORA BUENDIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Guerito",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04123987103",
      "client_email": "YENDERMORA270@GMAIL.COM",
      "address": "CALLE GUERITO CASA NRO 210 SECTOR LA TRINIDAD DOS SAMAN DE GUERE TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V25501254",
      "nap_box_name": "CTO-0657",
      "created_at": "2025-05-19T17:36:59.768720",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8229,
      "client_name": "YIDRI MARGARITA ROJAS",
      "client_type_name": "GRATIS",
      "client_subdivision": "ACTIVO_GRATIS",
      "status_name": "Activo",
      "cycle": 25,
      "migrate": false,
      "sector_name": "Antonio Jose de Sucre",
      "plan": {
        "id": 86,
        "name": "PLAN RECURRENTE 80M GRATIS",
        "cost": "0.00",
        "code": "FO-G80",
        "profile": "80M/80M"
      },
      "client_mobile": "04127766225",
      "client_email": "RR3423517@GMAIL.COM",
      "address": "CALLE HENRI PITTER CASA#11 ANTONIO JOSE DE SUCRE TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V11166590",
      "nap_box_name": "173",
      "created_at": "2025-05-19T19:21:57.588263",
      "service_detail": {
        "id": 8712,
        "ip": "10.14.59.2",
        "mac": "QXTLCBCD6290",
        "serial": "QXTLCBCD6290",
        "queue": "queue1",
        "interface": "VLAN127_SANTA_EDUVIGES",
        "created_at": "2025-05-19T21:18:01.102162",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8230,
      "client_name": "JESUS JUNIOR CAMPERO MONTAÑA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Valle Fresco",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04125009022",
      "client_email": "JJCAMPERO2@GMAIL.COM",
      "address": "VALLE FRESCO AV PRINCIPAL LOS NARANJO, MANZANA C CASA 18  TURMERO ESTADO ARAGUA POSTAL 2115",
      "client_identification": "V12688138",
      "nap_box_name": "CTO-VA",
      "created_at": "2025-05-20T10:42:26.009037",
      "service_detail": {
        "id": 8714,
        "ip": "10.14.136.2",
        "mac": "QXTLCBB38A84",
        "serial": "QXTLCBB38A84",
        "queue": "Plan_92300_15811_WispHub",
        "interface": "VLAN270_VALLE_FRESCO_OLT3",
        "created_at": "2025-05-20T15:20:57.644048",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8231,
      "client_name": "ALIRIO ALBERTO HERRERA DIAZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04141448596",
      "client_email": "ALIRIOALBERTOHERRERADIAZ@GMAIL.COM",
      "address": "CALLE MIRANDA LOCAL COMERCIAL TURMERO N 25-1 CASCO DE TURMERO ESTADO ARAGUA POSTAL 2115",
      "client_identification": "V9883187",
      "nap_box_name": "CAJA NAP BICENTENARIO",
      "created_at": "2025-05-20T14:47:09.572202",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8232,
      "client_name": "CIRA BEATRIZ ZERPA DE COLMENARES",
      "client_type_name": "GRATIS",
      "client_subdivision": "ACTIVO_GRATIS",
      "status_name": "Activo",
      "cycle": 25,
      "migrate": false,
      "sector_name": "Bicentenario",
      "plan": {
        "id": 86,
        "name": "PLAN RECURRENTE 80M GRATIS",
        "cost": "0.00",
        "code": "FO-G80",
        "profile": "80M/80M"
      },
      "client_mobile": "04121479173",
      "client_email": "ZERCIRA346@GMAIL.COM",
      "address": "CALLE ARAGUANEY N#5 PLANTA BAJA SECTOR BICENTENARIO TURMERO EDO. ARAGUA",
      "client_identification": "V9675409",
      "nap_box_name": "CTO-00446",
      "created_at": "2025-05-21T09:56:12.037084",
      "service_detail": {
        "id": 8718,
        "ip": "10.14.109.2",
        "mac": "QXTLCB98E6DE",
        "serial": "QXTLCB98E6DE",
        "queue": "queue1",
        "interface": "VLAN243_BICENTENARIO",
        "created_at": "2025-05-21T09:58:33.250997",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8233,
      "client_name": "ANTONIO JOSE BORGES BRICEÑO",
      "client_type_name": "INTERCAMBIO",
      "client_subdivision": "ACTIVO_INTERCAMBIO",
      "status_name": "Activo",
      "cycle": 25,
      "migrate": false,
      "sector_name": "Laguna Plaza",
      "plan": {
        "id": 83,
        "name": "RECURRENTE INSTITUCIONAL 80M",
        "cost": "0.00",
        "code": "FO-R80",
        "profile": "80M/80M"
      },
      "client_mobile": "04243613131",
      "client_email": "ANTONIOJOSEBORGESBRICENO@GMAIL.COM",
      "address": "LAGUNA PLAZA, CALLE NEGRO PRIMERO EDIF 11 PISO 1 APT PH-3 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V8725664",
      "nap_box_name": "CTO - 1220",
      "created_at": "2025-05-21T10:03:16.185660",
      "service_detail": {
        "id": 8719,
        "ip": "10.14.92.2",
        "mac": "QXTLCB697DE1",
        "serial": "QXTLCB697DE1",
        "queue": "Plan_107915_15811_WispHub",
        "interface": "VLAN216_LAGUNA_PLAZA_OLT1",
        "created_at": "2025-05-21T10:04:10.141703",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8234,
      "client_name": "DENYS JOSE MATA MATA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243765800",
      "client_email": "DENYSMATA89@GMAIL.COM",
      "address": "CALLE 8 CASA NRO. 3, LA CASONA I - A TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V19792016",
      "nap_box_name": "407",
      "created_at": "2025-05-21T10:28:05.520871",
      "service_detail": {
        "id": 8720,
        "ip": "10.14.139.2",
        "mac": "QXTLCBFDD4E9",
        "serial": "QXTLCBFDD4E9",
        "queue": "queue1",
        "interface": "VLAN109_CASONA_1",
        "created_at": "2025-05-21T11:15:19.473444",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8235,
      "client_name": "CARLOS ANDRES MOLERO TORO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Villa De San Jose",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04143178852",
      "client_email": "CARLOSMDERO997@GMAIL.COM",
      "address": "URBANIZACION VILLAS DE SAN JOSE CASA NRO 05 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V12386602",
      "nap_box_name": "CTO-00080",
      "created_at": "2025-05-21T11:19:52.238118",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8237,
      "client_name": "HAYDEE MARGARITA UTRERA SUMOZA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Sector los Mangos",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04122143045",
      "client_email": "MARGARITAUTRERA02@GMAIL.COM",
      "address": "CALLE PRINCIPAL CASA 31 ROSARIO DE PAYA LOS MANGOS",
      "client_identification": "V8740188",
      "nap_box_name": "CTO-00172 ",
      "created_at": "2025-05-21T14:04:02.943851",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8238,
      "client_name": "KAREN ADRIANA BLANCO OTERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Calle Peñalver",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243284371",
      "client_email": "K.A.BLANCO.OTERO@GMAIL.COM",
      "address": "CALLE MARIÑO CRUCE CON PEÑALVERT EDIF QUEIPA PISO 4 APTO 4 URB LOS CASIQUES",
      "client_identification": "V18473477",
      "nap_box_name": "CTO-0559",
      "created_at": "2025-05-21T14:20:12.386368",
      "service_detail": {
        "id": 9034,
        "ip": "10.14.187.2",
        "mac": "QXTLCB355B1A",
        "serial": "QXTLCB355B1A",
        "queue": "queue1",
        "interface": "VLAN200_OLTs",
        "created_at": "2025-06-21T17:09:39.003902",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8239,
      "client_name": "ANGEL JESUS RONDON MACUARE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Los Hornos",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04163439660",
      "client_email": "ANGELRONDON2310@GMAIL.COM",
      "address": "SECTOR LOS HORNOS CALLE 6 CASA 7",
      "client_identification": "V20990488",
      "nap_box_name": "CTO-00288",
      "created_at": "2025-05-22T09:36:32.309434",
      "service_detail": {
        "id": 8726,
        "ip": "10.14.142.2",
        "mac": "QXTLCBEF401D",
        "serial": "QXTLCBEF401D",
        "queue": "queue1",
        "interface": "VLAN247_HORNOS",
        "created_at": "2025-05-22T13:23:38.112813",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8240,
      "client_name": "YARIMAR ANTONELA GALENO ROMERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Dios Es Mi Refugio",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243762586",
      "client_email": "GALENOYARIMAR@GMAIL.COM",
      "address": "MANZANA 3 PARCELA 02 DIOS ES MI REFUGIO",
      "client_identification": "V31303038",
      "nap_box_name": "CTO-0656",
      "created_at": "2025-05-22T09:56:57.642849",
      "service_detail": {
        "id": 8735,
        "ip": "10.14.143.2",
        "mac": "ADCGCCA6ECE2",
        "serial": "ADCGCCA6ECE2",
        "queue": "queue1",
        "interface": "VLAN271_DIOS_ES_MI_REFUGIO_OLT1",
        "created_at": "2025-05-22T16:10:48.403986",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8241,
      "client_name": "ALEXANDRA DEL VALLE QUINTANA RANGEL",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "1ro de Mayo Sur",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243509209",
      "client_email": "QUINTANARANGELALEXANDRADELVALL@GMAIL.COM",
      "address": "CALLE LA PAZ CASA 5 PRIMERO DE MAYO SUR",
      "client_identification": "V24130144",
      "nap_box_name": "CTO - 914",
      "created_at": "2025-05-22T10:14:00.598850",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8242,
      "client_name": "ABDENOUR SOTILLO CHARLETS CHENNYNS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243180910",
      "client_email": "CHARLYDISPROLAC@GMAIL.COM",
      "address": "URB EZEQUIEL ZAMORA TORRE 6 PISO 2 APTO 3",
      "client_identification": "V14183174",
      "nap_box_name": "CTO-00032",
      "created_at": "2025-05-22T15:07:15.641294",
      "service_detail": {
        "id": 8734,
        "ip": "10.14.144.2",
        "mac": "QXTLCB69C3BB",
        "serial": "QXTLCB69C3BB",
        "queue": "queue1",
        "interface": "VLAN209_ZAMORA_OLT1",
        "created_at": "2025-05-22T16:07:39.792400",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8243,
      "client_name": "FEDRA MAHOLIS KATHERINE SALAZAR ACOSTA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "La Concepcion III",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04148519189",
      "client_email": "SALAZARFEDRA@GMAIL.COM",
      "address": "AV. LA JULIA, CONCEPCION 3, CALLE 3 CASA 76 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V18081734",
      "nap_box_name": "CTO-00456",
      "created_at": "2025-05-22T16:52:41.123841",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8244,
      "client_name": "ALBERTO SEGUNDO OVIEDO AGUIRRE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "El Macaro",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04123985849",
      "client_email": "ALBERTOOVIEDO773@GMAIL.COM",
      "address": "CALLE LAS PALMAS CASA NRO-413, EL MACARO",
      "client_identification": "V7210773",
      "nap_box_name": "475",
      "created_at": "2025-05-22T16:56:55.480223",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8245,
      "client_name": "JOSEFINA MONTENEGRO CALANCHE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121308327",
      "client_email": "HENRYJOSETOVAR10@GMAIL.COM",
      "address": "CALLE MANZ1-4 CASA NRO 14 SAMAN TARAZONERO II, TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V7240805",
      "nap_box_name": "119",
      "created_at": "2025-05-22T17:10:04.309815",
      "service_detail": {
        "id": 10255,
        "ip": "10.14.148.2",
        "mac": "QXTLCBF4EDC8",
        "serial": "QXTLCBF4EDC8",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2025-11-22T15:24:02.187117",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8246,
      "client_name": "ANARELY RODRIGUEZ BORGES",
      "client_type_name": "GRATIS",
      "client_subdivision": "ACTIVO_GRATIS",
      "status_name": "Activo",
      "cycle": 25,
      "migrate": false,
      "sector_name": "La Casona II Edificios",
      "plan": {
        "id": 86,
        "name": "PLAN RECURRENTE 80M GRATIS",
        "cost": "0.00",
        "code": "FO-G80",
        "profile": "80M/80M"
      },
      "client_mobile": "04128847138",
      "client_email": "ANA21ISOLE@GMAIL.COM",
      "address": "CASONA II, EDIFICIO 11 PISO 1 APARTAMENTO 3",
      "client_identification": "V6261446",
      "nap_box_name": "CTO-0538",
      "created_at": "2025-05-23T11:12:09.229055",
      "service_detail": {
        "id": 8741,
        "ip": "10.14.73.2",
        "mac": "HWTC49200138",
        "serial": "HWTC49200138",
        "queue": "queue1",
        "interface": "VLAN110_CASONA_2",
        "created_at": "2025-05-23T11:16:31.485058",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8265,
      "client_name": "HAIBERSON GERMAIN ESPEJO ALVAREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Dios Es Mi Refugio",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243602640",
      "client_email": "HAIBERSONESPEJO@GMAIL.COM",
      "address": "MANZANA 10 PARCELA 5 ROSARIO DE PAYA DIOS ES MI REFUGIO",
      "client_identification": "V30428842",
      "nap_box_name": "CE - 941",
      "created_at": "2025-05-26T09:55:37.572543",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8266,
      "client_name": "ELIZABET ALEXANDRA ROJAS CASTILLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243258859",
      "client_email": "ELIZABETH2160@GMAIL.COM",
      "address": "CALLE 2 CASA 64 MATA CABALLO ROSARIO DE PAYA",
      "client_identification": "V21602189",
      "nap_box_name": "CTO-00422",
      "created_at": "2025-05-27T09:46:30.868024",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8267,
      "client_name": "LAURA YAKELIN TORRES PEREIRA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Los Caobos",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243101438",
      "client_email": "LAURAYAKELINTORRES@GMAIL.COM",
      "address": "TERCERA CALLE  1- A LOS CAOBOS LA JULIA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V14469761",
      "nap_box_name": "CE - 617",
      "created_at": "2025-05-28T08:07:44.108929",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8268,
      "client_name": "ALICIA MARIA CALDEIRA DE JESUS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243135158",
      "client_email": "ALICIA.O.M@GMAIL.COM",
      "address": "CALLE MIRANDO LOCAL NRO 26 SECTOR CASCO DE TURMERO",
      "client_identification": "V15489966",
      "nap_box_name": "CAJA NAP BICENTENARIO",
      "created_at": "2025-05-28T10:05:21.579394",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8269,
      "client_name": "LILIANA BAPTISTA HERNANDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "San Pablo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128152085",
      "client_email": "LILIANABAP2@GMAIL.COM",
      "address": "URB VILLA MARINA CALLE 3 CASA 1 SAN PABLO",
      "client_identification": "V12928917",
      "nap_box_name": "57",
      "created_at": "2025-05-28T16:54:08.806784",
      "service_detail": {
        "id": 10214,
        "ip": "10.14.164.2",
        "mac": "QXTLCBD2ED43",
        "serial": "QXTLCBD2ED43",
        "queue": null,
        "interface": "VLAN228_V_CARIBE_OLT1",
        "created_at": "2025-11-20T18:49:33.615419",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8270,
      "client_name": "CESAR JOSE ACOSTA PULGAR",
      "client_type_name": "GRATIS",
      "client_subdivision": "ACTIVO_GRATIS",
      "status_name": "Activo",
      "cycle": 25,
      "migrate": false,
      "sector_name": "Valle Paraiso",
      "plan": {
        "id": 86,
        "name": "PLAN RECURRENTE 80M GRATIS",
        "cost": "0.00",
        "code": "FO-G80",
        "profile": "80M/80M"
      },
      "client_mobile": "04127314994",
      "client_email": "CESARACOSTA0099@GMAIL.COM",
      "address": "ALTOS DE JUAN PABLO II ETAPA, SECTOR SAN PABLO, TURMERO",
      "client_identification": "V27511673",
      "nap_box_name": "CTO-00603",
      "created_at": "2025-05-29T12:22:08.325143",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8271,
      "client_name": "REINA HURTADO HURTADO RUBIO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Paya Abajo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124011411",
      "client_email": "JOCELINGODOYVARGAS@GMAIL.COM",
      "address": "CALLE SAN ANTONIO CASA 3B ROSARIO DE PAYA PAYA ABAJO",
      "client_identification": "V13200067",
      "nap_box_name": "CTO-00434",
      "created_at": "2025-05-30T08:38:14.092842",
      "service_detail": {
        "id": 11390,
        "ip": "10.14.167.2",
        "mac": "OEMT3C624C92",
        "serial": "OEMT3C624C92",
        "queue": null,
        "interface": "VLAN231_PAYABAJO",
        "created_at": "2026-01-26T14:42:33.547941",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8272,
      "client_name": "MIRNA JOSEFINA FERNANDEZ DE CABEZA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Pantin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04262369089",
      "client_email": "MARACAY21MIRFER@GMAIL.COM",
      "address": "CALLE 4 CASA 54 PANTIN  ROSARIO DE PAYA",
      "client_identification": "V11591462",
      "nap_box_name": "CTO-00134",
      "created_at": "2025-05-30T09:01:39.224142",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8273,
      "client_name": "ZURAYI MARIMON REDONDO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "La Orquidea",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04241420709",
      "client_email": "MARIMONZURA@GMAIL.COM",
      "address": "CALLE 3 CASA 46 LA ORQUIDEA PAYA",
      "client_identification": "V9725544",
      "nap_box_name": "CTO-00282",
      "created_at": "2025-05-30T10:39:36.627574",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8274,
      "client_name": "ALEJANDRA YUBIRY REYES CORONADO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Saman Tarazonero I",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04167317284",
      "client_email": "ALEJANDRAREYES961@GMAIL.COM",
      "address": "CALLE 3 CASA 53 SAMAN TARAZONERO I, TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V17470980",
      "nap_box_name": "CTO-00047",
      "created_at": "2025-05-30T10:40:05.874223",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8275,
      "client_name": "JESUS ALEIXIS AVILERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "La Concepcion",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04264742069",
      "client_email": "KF4196430@GMAIL.COM",
      "address": "AV INTERCOMUNAL LA JULIA EDIF. TORRE I PISO 2 APTO 8 CONCEPCION EDIFICIO TURMERO ZONA POSTAL 2115",
      "client_identification": "V9594606",
      "nap_box_name": "623",
      "created_at": "2025-05-30T10:57:27.117629",
      "service_detail": {
        "id": 11919,
        "ip": "10.14.170.2",
        "mac": "QXTLCBAF731E",
        "serial": "QXTLCBAF731E",
        "queue": null,
        "interface": "VLAN111_CONCEPCION",
        "created_at": "2026-03-03T10:53:40.450800",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8276,
      "client_name": "JOSE MANUEL MONTILLA URBINA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243358831",
      "client_email": "JMMONTILLAJOSE@GMAIL.COM",
      "address": "TORRE 5 ESCALERA 1 PISO 1 APTO 2 ESEQUIEL ZAMORA",
      "client_identification": "V27286479",
      "nap_box_name": "CTO-00032 DOS",
      "created_at": "2025-05-30T11:18:19.694046",
      "service_detail": {
        "id": 11395,
        "ip": "10.14.171.2",
        "mac": "QXTLCBD441A8",
        "serial": "QXTLCBD441A8",
        "queue": null,
        "interface": "VLAN209_ZAMORA_OLT1",
        "created_at": "2026-01-26T18:01:04.877819",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8277,
      "client_name": "MARIA CRISTINA LEON MEDINA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Guerito",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04242142096",
      "client_email": "MARIALEONMEDINA@GMAIL.COM",
      "address": "EDIFICIO TERRAZA 5B PISO 2 APT 6, GUERITO, URB LOS SAMANES TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V22670837",
      "nap_box_name": "CE (Proyecto)",
      "created_at": "2025-05-30T11:27:26.710592",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8278,
      "client_name": "IRAMA SENOVIA PEREZ PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "La Casona II Edificios",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04140511571",
      "client_email": "IRAMAPEREZ2011@GMAIL.COM",
      "address": "EDIFICIO LOS ANGELES PISO 3 APARTAMENTO 01 LA CASONA II TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V12722844",
      "nap_box_name": "CTO-00120",
      "created_at": "2025-05-30T11:37:06.623746",
      "service_detail": {
        "id": 12493,
        "ip": "10.14.174.2",
        "mac": "68:9f:f0:cc:90:3f",
        "serial": "QXTLCB3A4C30",
        "queue": null,
        "interface": "VLAN110_CASONA_2",
        "created_at": "2026-05-14T17:59:46.310868",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8279,
      "client_name": "YOSIBEL LUISETT HERNANDEZ HERNANDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Saman Tarazonero I",
      "plan": {
        "id": 101,
        "name": "RECURRENTE RESIDENCIAL PLAN 200M",
        "cost": "19.00",
        "code": "FOR200MB",
        "profile": "200Mbps/200Mbps"
      },
      "client_mobile": "04120642336",
      "client_email": "YOSIBELHERNANDEZ10@GMAIL.COM",
      "address": "CALLE 5 CASA NRO 1 SAMAN TARAZONERO I TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V20960751",
      "nap_box_name": "269",
      "created_at": "2025-05-30T11:43:23.602766",
      "service_detail": {
        "id": 12171,
        "ip": "10.14.175.2",
        "mac": "OEMT3C6254C6",
        "serial": "OEMT3C6254C6",
        "queue": null,
        "interface": "VLAN140_SMT1_ZTE",
        "created_at": "2026-03-23T18:28:46.301397",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8280,
      "client_name": "DELIA YIRMALY LOPEZ MARTINEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Guerito",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243186518",
      "client_email": "DELIAYIRMALYLOPEZMARTINEZ@GMAIL.COM",
      "address": "CALLE JOSE FELIX RIVAS CASA 06 VIA GUERITO SAMAN DE GUERE SUR TURMERO ZONA POSTAL 2115",
      "client_identification": "V19174549",
      "nap_box_name": "CTO - 947",
      "created_at": "2025-05-30T12:14:41.692855",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8281,
      "client_name": "MOHAMAD ALI RMAITI",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144615303",
      "client_email": "MRMAITI45@GMAIL.COM",
      "address": "CALLE MARIÑO CRUCE CON CEDEÑO CASCO DE TURMERO",
      "client_identification": "V36902600",
      "nap_box_name": "CTO-00233",
      "created_at": "2025-05-30T13:00:37.998430",
      "service_detail": {
        "id": 9032,
        "ip": "10.14.184.2",
        "mac": "QXTLCB114299",
        "serial": "QXTLCB114299",
        "queue": "queue1",
        "interface": "VLAN200_OLTs",
        "created_at": "2025-06-21T17:03:59.468143",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8282,
      "client_name": "JORMAN PHIDIAS GONZALEZ CAICEDO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "La Concepcion",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121487711",
      "client_email": "jormandavid03@gmail.com",
      "address": "EDIFIO TORRE 13 SEGUNDO PISO APARTAMENTO 8 LA CONCEPCION TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V29828685",
      "nap_box_name": "0326 DOS",
      "created_at": "2025-05-30T13:16:13.678987",
      "service_detail": {
        "id": 8782,
        "ip": "10.14.177.2",
        "mac": "QXTLCBFEF50D",
        "serial": "QXTLCBFEF50D",
        "queue": "queue1",
        "interface": "VLAN111_CONCEPCION",
        "created_at": "2025-05-30T13:21:12.484603",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8283,
      "client_name": "JOSE ERDEL MONTALBAN MERCHAN",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "La Magdalena",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124553076",
      "client_email": "MONTALBANJOSE832@GMAIL.COM",
      "address": "CALLE 5 CASA NRO 42 LA MAGDALENA TURMERO ZONA POSTAL 2115",
      "client_identification": "V15962715",
      "nap_box_name": "483",
      "created_at": "2025-05-30T13:28:11.020299",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8284,
      "client_name": "LILIAN YOSELIN CASTELLANOS MIRANDA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Luz y Vida",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128840571",
      "client_email": "CASTELLANOSYOSELYN606@GMAIL.COM",
      "address": "CALLE LA CANDELARIA CASA 38 LUZ Y VIDA PAYA",
      "client_identification": "V21376460",
      "nap_box_name": "CTO-00308",
      "created_at": "2025-05-30T15:26:59.662641",
      "service_detail": {
        "id": 11307,
        "ip": "10.14.180.2",
        "mac": "QXTLCBA202B9",
        "serial": "QXTLCBA202B9",
        "queue": null,
        "interface": "VLAN264_LUZYVIDA_ZTE",
        "created_at": "2026-01-22T13:31:19.707096",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8285,
      "client_name": "JUAN MIGUEL OROPEZA OLIVO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Luz y Vida",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243765718",
      "client_email": "OMBARANDREGALINDEZ@GMAIL.COM",
      "address": "CALLE 1 CASA 10 LUZ Y VIDA PAYA",
      "client_identification": "V21466520",
      "nap_box_name": "CTO-00057 DOS",
      "created_at": "2025-05-30T15:36:20.149184",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8286,
      "client_name": "EDIARLY ELENA ALAYON SALMERON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "SUSPENDIDO_RESIDENCIAL",
      "status_name": "Suspendido",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04122525641",
      "client_email": "EDIALAYON18@GMAIL.COM",
      "address": "TORRE 9 EZEQUIEL ZAMORA PISO 2 APTO 2",
      "client_identification": "V30972696",
      "nap_box_name": "CTO-00387",
      "created_at": "2025-05-30T16:40:27.263295",
      "service_detail": {
        "id": 12790,
        "ip": "10.14.181.2",
        "mac": "QX:TL:CB:14:37:CD",
        "serial": "QXTLCB1437CD",
        "queue": null,
        "interface": "VLAN209_ZAMORA_OLT1",
        "created_at": "2026-08-05T15:53:02.712291",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8287,
      "client_name": "LEIDY JOHANA RUMBOS GARCIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121481061",
      "client_email": "JOHANA1480@GMAIL.COM",
      "address": "CAYCAPE EZEQUIEL ZAMORA CASCO DE TURMERO",
      "client_identification": "V16690930",
      "nap_box_name": "130",
      "created_at": "2025-05-30T17:06:19.648854",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8288,
      "client_name": "YETSIBEL JOSEFINA HERRERA MONASTERIO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Leocolbo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243260525",
      "client_email": "YETSIBELHERRERA8@GMAIL.COM",
      "address": "CALLE A, CASA NRO 57, VALLES DE LEOCOLBO, TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V11797529",
      "nap_box_name": "CE - 623",
      "created_at": "2025-05-30T19:19:14.157749",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8289,
      "client_name": "ROSA MARIA MILLAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128981091",
      "client_email": "FROZZIL691@GMAIL.COM",
      "address": "SAMAN TARAZONERO II, CALLE H-5 CASA 03 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V16099968",
      "nap_box_name": "185",
      "created_at": "2025-05-30T19:33:30.053111",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8291,
      "client_name": "BERTHA BENICIA GUTIERREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Betania",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243735300",
      "client_email": "BERTHAGUTIERREZ605@GMAIL.COM",
      "address": "CALLE 4 CASA 358 COMUNIDAD DE BETANIA",
      "client_identification": "V4551605",
      "nap_box_name": "595",
      "created_at": "2025-05-31T08:23:48.738194",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8292,
      "client_name": "GIORGINA VELASQUEZ DIAZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121480523",
      "client_email": "GIORGINAVELASQUEZ386@GMAIL.COM",
      "address": "CALLE 4 A CASA 11 PANTIN ROSARIO DE PAYA",
      "client_identification": "V22952010",
      "nap_box_name": "CTO-00076 DOS",
      "created_at": "2025-05-31T08:47:12.967438",
      "service_detail": {
        "id": 8799,
        "ip": "10.14.189.2",
        "mac": "QXTLCBF874BE",
        "serial": "QXTLCBF874BE",
        "queue": "queue1",
        "interface": "VLAN229_PANTIN",
        "created_at": "2025-06-02T08:22:13.182984",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8294,
      "client_name": "JAVIER OCTAVIO FREITES URIBE",
      "client_type_name": "EMPLEADO",
      "client_subdivision": "CANCELADO_EMPLEADO",
      "status_name": "Cancelado",
      "cycle": 25,
      "migrate": false,
      "sector_name": "La Esperanza",
      "plan": {
        "id": 78,
        "name": "Plan empleado 80MB",
        "cost": "0.00",
        "code": "FO-80M",
        "profile": "80M/80M"
      },
      "client_mobile": "04124618013",
      "client_email": "JFREITES999@GMAIL.COM",
      "address": "CALLE 6 #39 SIMON BOLIVAR",
      "client_identification": "V15076952",
      "nap_box_name": "555",
      "created_at": "2025-05-31T09:19:52.516264",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8295,
      "client_name": "SOBERLY LUCRECIA GARABOTE LORETO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Laguna Plaza",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243446560",
      "client_email": "GARABOTESOBERLY51@GMAIL.COM",
      "address": "CALLE PRINCIPAL EDI 14 PISO 1 APTO B3 LA LAGUNA I",
      "client_identification": "V16646763",
      "nap_box_name": "CTO-0489",
      "created_at": "2025-06-02T08:45:00.285941",
      "service_detail": {
        "id": 9029,
        "ip": "10.14.190.2",
        "mac": "QXTLCBED9661",
        "serial": "QXTLCBED9661",
        "queue": "queue1",
        "interface": "VLAN224_SAN_PABLO_OLT1",
        "created_at": "2025-06-21T16:54:53.340116",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8296,
      "client_name": "FRANCISCO ALBERTO AYALA FIGUEROA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Antigua Hacienda De Paya",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04145797725",
      "client_email": "FCOSAYALAF@GMAIL.COM",
      "address": "CALLEJON 10 CASA VIEJA PARCELA 5 QUINTA LA MILAGROSA PAYA. ANTIGUA HACIENDA DE PAYA",
      "client_identification": "V6193485",
      "nap_box_name": "117",
      "created_at": "2025-06-02T09:00:26.205222",
      "service_detail": {
        "id": 10019,
        "ip": "10.14.191.2",
        "mac": "QXTLCB1E288E",
        "serial": "QXTLCB1E288E",
        "queue": null,
        "interface": "VLAN202_AHP_OLT1",
        "created_at": "2025-11-11T15:14:04.367239",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8297,
      "client_name": "RUDY RAUL CAMEJO RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Luz y Vida",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121402117",
      "client_email": "RAUL8CAMEJO@GMAIL.COM",
      "address": "CALLE PRINCIPAL DE TERRZAS CASA 222 LUZ Y VIDA",
      "client_identification": "V13530407",
      "nap_box_name": "CTO-00308",
      "created_at": "2025-06-02T09:21:25.492381",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8298,
      "client_name": "ELDIS JOSEFINA CAMPOS VERDE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Jabillar",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04123397640",
      "client_email": "ELDYS9@HOTMAIL.COM",
      "address": "AV PRINCIPAL URBANIZACIÓN JABILLAR TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V11984285",
      "nap_box_name": "CE-00141",
      "created_at": "2025-06-02T09:58:04.975013",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8299,
      "client_name": "GENESIS YOSELIN GUANARE SANCHEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04122997477",
      "client_email": "GENESISGUANARE1803@GMAIL.COM",
      "address": "RIO SECO ROSARIO DE PAYA CALLE 13 CASA 18",
      "client_identification": "V24815486",
      "nap_box_name": "CTO-00423",
      "created_at": "2025-06-02T10:30:42.686274",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8301,
      "client_name": "ANA LIONOR VEZGA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "1ro de Mayo Sur",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243689676",
      "client_email": "ANAVEZGA69@GMAIL.COM",
      "address": "CALLE PRINCIPAL, CASA 59, PRIMERO DE MAYO SUR",
      "client_identification": "V9468057",
      "nap_box_name": "CE-00064",
      "created_at": "2025-06-02T11:22:18.691807",
      "service_detail": {
        "id": 8830,
        "ip": "10.14.196.2",
        "mac": "ADCGCCA3FE09",
        "serial": "ADCGCCA3FE09",
        "queue": "queue1",
        "interface": "VLAN261_1ERO_MAYO_ZTE",
        "created_at": "2025-06-03T18:17:47.540169",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8302,
      "client_name": "RAUL ERNESTO PEREZ PONTILES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "San Pablo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04149895139",
      "client_email": "RPER24@GMAIL.COM",
      "address": "CALLE CENTRAL EDIF CONJUNTO RESIDENCIAL ALTOS DE JUAN PABLO PB APT 02 URB VALLE PARAISO",
      "client_identification": "V11769822",
      "nap_box_name": "CTO-00603",
      "created_at": "2025-06-03T08:26:35.878949",
      "service_detail": {
        "id": 9028,
        "ip": "10.14.199.2",
        "mac": "QXTLCB492211",
        "serial": "QXTLCB492211",
        "queue": "queue1",
        "interface": "VLAN227_V_PARAISO_OLT1",
        "created_at": "2025-06-21T16:51:59.358634",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8303,
      "client_name": "KEILIN DANIELA COLMENARES ZERPA",
      "client_type_name": "GRATIS",
      "client_subdivision": "ACTIVO_GRATIS",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": false,
      "sector_name": "Prados I",
      "plan": {
        "id": 86,
        "name": "PLAN RECURRENTE 80M GRATIS",
        "cost": "0.00",
        "code": "FO-G80",
        "profile": "80M/80M"
      },
      "client_mobile": "04122393563",
      "client_email": "CALDERINJOSE834@GMAIL.COM",
      "address": "CALLE 15 CASA 4 PRADOS I, PAYA",
      "client_identification": "V25066262",
      "nap_box_name": "590 DOS",
      "created_at": "2025-06-03T10:38:19.396609",
      "service_detail": {
        "id": 8833,
        "ip": "10.14.195.2",
        "mac": "QXTLCB2D9FB0",
        "serial": "QXTLCB2D9FB0",
        "queue": "queue1",
        "interface": "VLAN239_PRADOS1",
        "created_at": "2025-06-04T09:41:25.668733",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8304,
      "client_name": "MIGUEL ANGEL ZAPATA SOSA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04126828539",
      "client_email": "MUCUTUIZAPATA@GMAIL.COM",
      "address": "SAMAN TARAZONERO II, MANZANA E - 8 CASA 3. TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V17470054",
      "nap_box_name": "161 DOS",
      "created_at": "2025-06-03T12:35:29.643499",
      "service_detail": {
        "id": 12784,
        "ip": "10.14.200.2",
        "mac": "68:9f:f0:2a:d1:ff",
        "serial": "ZXICCDE890C8",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2026-08-02T17:07:27.019830",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8305,
      "client_name": "ILIANA ARACELYS GUADAMO COLINA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128843027",
      "client_email": "ILIANACARS26@GMAIL.COM",
      "address": "SAMAN TARAZONERO II, MANZANA E -10 CASA 22. TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V17273323",
      "nap_box_name": "277",
      "created_at": "2025-06-03T12:41:10.137764",
      "service_detail": {
        "id": 12091,
        "ip": "10.14.201.2",
        "mac": "MONU003B6B55",
        "serial": "MONU003B6B55",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2026-03-16T08:11:40.224676",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8306,
      "client_name": "FRANKLIN ALEIXIS PACHECO GUZMAN",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "La Casona II Edificios",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243777136",
      "client_email": "FRANKLIN.PACHECO.SOSO@GMAIL.COM",
      "address": "EDIFICIO 9 PISO 1 APARTAMENTO S-2 CASONA II TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V9679256",
      "nap_box_name": "CTO-0536",
      "created_at": "2025-06-03T13:00:30.539162",
      "service_detail": {
        "id": 13065,
        "ip": "10.14.198.2",
        "mac": "TP:LG:F9:CD:40:2A",
        "serial": "TPLGF9CD402A",
        "queue": null,
        "interface": "VLAN110_CASONA_2",
        "created_at": "2026-09-22T16:01:17.921493",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8307,
      "client_name": "CARMEN BEATRIZ ALVAREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Macaro",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124351954",
      "client_email": "CARMENVICTORNIKOLAS2022@GMAIL.COM",
      "address": "CARRETERA EL MACARO PARCELA NRO 27 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V18489854",
      "nap_box_name": "CTO-00054",
      "created_at": "2025-06-03T14:30:03.691236",
      "service_detail": {
        "id": 8844,
        "ip": "10.14.207.2",
        "mac": "QXTLCB14C2C2",
        "serial": "QXTLCB14C2C2",
        "queue": "queue1",
        "interface": "VLAN104_EL_MACARO_OLT_ZTE",
        "created_at": "2025-06-04T20:50:45.060167",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8309,
      "client_name": "HEIDY DAIDANA CONTRERAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Las Rurales",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243058041",
      "client_email": "HEIDYCONTRERAS7@GMAIL.COM",
      "address": "ROSARIO DE PAYA SECTOR LAS RURALES CALLE MIRANDA CASA NRO 11 TURMERO EDO ARAGUA",
      "client_identification": "V14261812",
      "nap_box_name": "CE - 658",
      "created_at": "2025-06-04T09:03:55.783196",
      "service_detail": {
        "id": 12341,
        "ip": "10.14.210.2",
        "mac": "QXTLCB6B0892",
        "serial": "QXTLCB6B0892",
        "queue": null,
        "interface": "VLAN252_RURALES_PAYA",
        "created_at": "2026-04-17T14:02:26.335349",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8310,
      "client_name": "YOSSELIN TATIANA CORONA MENDOZA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "1ro de Mayo Norte",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04262424188",
      "client_email": "YOSSELNCORONAMEN@GMAIL.COM",
      "address": "ROSARIO DE PAYA SECTOR SAGRADO CORAZON DE JESUS CALLE JESUS REQUENA CASA NRO 6",
      "client_identification": "V29587797",
      "nap_box_name": "CTO-004444",
      "created_at": "2025-06-04T09:21:48.719212",
      "service_detail": {
        "id": 12309,
        "ip": "10.14.203.2",
        "mac": "QXTLCB441035",
        "serial": "QXTLCB441035",
        "queue": null,
        "interface": "VLAN261_1ERO_MAYO_ZTE",
        "created_at": "2026-04-14T14:25:29.420254",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8313,
      "client_name": "RICHARD ENRIQUE ARCIA URBINA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04262370994",
      "client_email": "ARCIAENRIQUE10@GMAIL.COM",
      "address": "CALLE 103 CASA 8 RIO SECO PAYA",
      "client_identification": "V9917910",
      "nap_box_name": "CE - 667",
      "created_at": "2025-06-04T12:57:48.451290",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8318,
      "client_name": "DANIELA GONZALEZ TORRES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Haras de San Pablo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04125969206",
      "client_email": "DANIELAG4434@GMAIL.COM",
      "address": "CALLE PRINCIPAL CASA 87 URB HARAS DE SAN PABLO",
      "client_identification": "V29574434",
      "nap_box_name": "248",
      "created_at": "2025-06-04T13:11:06.065577",
      "service_detail": {
        "id": 9024,
        "ip": "10.14.205.2",
        "mac": "QXTLCBAF44AF",
        "serial": "QXTLCBAF44AF",
        "queue": "queue1",
        "interface": "VLAN224_SAN_PABLO_OLT1",
        "created_at": "2025-06-21T15:46:12.381749",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8323,
      "client_name": "VANESSA SOCORRO RAMIREZ VELASCO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144551375",
      "client_email": "RAMIREZVELASCOVANESSA@GMAIL.COM",
      "address": "CALLE SALIAS NO 16 ENTRE CALLE PETION Y CARREÑO CASCO TURMERO",
      "client_identification": "V21253568",
      "nap_box_name": "CTO-00907",
      "created_at": "2025-06-04T13:22:43.043179",
      "service_detail": {
        "id": 9023,
        "ip": "10.14.214.2",
        "mac": "QXTLCB386671",
        "serial": "QXTLCB386671",
        "queue": "queue1",
        "interface": "VLAN200_OLTs",
        "created_at": "2025-06-21T15:44:23.418286",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8324,
      "client_name": "VIVIANA CAROLINA GONZALEZ DIAZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04129684102",
      "client_email": "VIVIANACAROLINA2023@GMAIL.COM",
      "address": "SAMAN TARAZONERO II, MANZANA B3 CASA 1",
      "client_identification": "V18778114",
      "nap_box_name": "128",
      "created_at": "2025-06-04T13:41:59.394873",
      "service_detail": {
        "id": 8839,
        "ip": "10.14.206.2",
        "mac": "QXTLCB0DC1A2",
        "serial": "QXTLCB0DC1A2",
        "queue": "queue1",
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2025-06-04T14:07:49.069516",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8325,
      "client_name": "YULILLEIN OFREDA ANGULO RAMOS",
      "client_type_name": "GRATIS",
      "client_subdivision": "ACTIVO_GRATIS",
      "status_name": "Activo",
      "cycle": 25,
      "migrate": false,
      "sector_name": "Antonio Jose de Sucre",
      "plan": {
        "id": 86,
        "name": "PLAN RECURRENTE 80M GRATIS",
        "cost": "0.00",
        "code": "FO-G80",
        "profile": "80M/80M"
      },
      "client_mobile": "04128904861",
      "client_email": "SAULRACHELDIAZ@GMAIL.COM",
      "address": "ANTONIO JOSE DE SUCRE CALLE HENRRI PITIER CASA 07 TURMARO ZONA POSTAL 2115",
      "client_identification": "V11091210",
      "nap_box_name": "173",
      "created_at": "2025-06-04T13:57:23.073061",
      "service_detail": {
        "id": 8838,
        "ip": "10.14.188.2",
        "mac": "QXTLCB3D71D3",
        "serial": "QXTLCB3D71D3",
        "queue": "queue1",
        "interface": "VLAN104_EL_MACARO_OLT_ZTE",
        "created_at": "2025-06-04T14:05:07.911064",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8326,
      "client_name": "WILMARY YAQUELIN ALVARADO LUGO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "La Casona I Edificios",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128868051",
      "client_email": "MARIELALUGO033@GMAIL.COM",
      "address": "LA CASONA II, SECTOR B EDIFICIO D NIVEL 3 APARTAMENTO 1.  TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V27520557",
      "nap_box_name": "CE - 424",
      "created_at": "2025-06-04T15:41:32.191533",
      "service_detail": {
        "id": 8841,
        "ip": "10.14.208.2",
        "mac": "QXTLCBB19204",
        "serial": "QXTLCBB19204",
        "queue": "queue1",
        "interface": "VLAN109_CASONA_1",
        "created_at": "2025-06-04T16:44:00.702806",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8327,
      "client_name": "GLENNE CAROLINA GOMEZ RIVAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128860234",
      "client_email": "GLENNE915@GMAIL.COM",
      "address": "CALLE RIVAS LOCAL DON JORGE NUMERO 7-1 PLANTA BAJA SECTOR CASCO DE TURMERO ZONA POSTAL 2115",
      "client_identification": "V20056752",
      "nap_box_name": "CTO-00129",
      "created_at": "2025-06-05T09:24:12.910394",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8328,
      "client_name": "ELIO RAFAEL FLORES QUEVEDO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vallecito",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04122049355",
      "client_email": "ELIOFLORES2009@GMAIL.COM",
      "address": "CALLE 2 CASA 03 SECTOR EL NARANJAL DE VALLECITO ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V16865072",
      "nap_box_name": "CTO - 997",
      "created_at": "2025-06-05T09:43:17.914885",
      "service_detail": {
        "id": 8848,
        "ip": "10.14.209.2",
        "mac": "QXTLCBDB84C5",
        "serial": "QXTLCBDB84C5",
        "queue": "queue1",
        "interface": "VLAN258_VALLECITO",
        "created_at": "2025-06-05T11:39:07.667461",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8329,
      "client_name": "MARIA CRISTINA NORUEGA FLORES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "La Concepcion III",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04140681924",
      "client_email": "MARIAFLORESNOGUERA@GMAIL.COM",
      "address": "LA CONCEPCION III CALLE PRINCIPAL CASA 125 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V12328115",
      "nap_box_name": "CTO-00456",
      "created_at": "2025-06-05T09:54:52.494282",
      "service_detail": {
        "id": 8853,
        "ip": "10.14.211.2",
        "mac": "QXTLCBB00A06",
        "serial": "QXTLCBB00A06",
        "queue": "queue1",
        "interface": "VLAN111_CONCEPCION",
        "created_at": "2025-06-05T14:57:15.122970",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8330,
      "client_name": "WILLIAMS JOSE BLANCO URRIBARRI",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "La Macarena",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144543565",
      "client_email": "WILLIAMSJOSEBLANCOURRIBARRI@YAHOO.ES",
      "address": "PARCELA 2 CALLE 11 CASA 15 LA MACARENA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V11988575",
      "nap_box_name": "80 DOS",
      "created_at": "2025-06-05T10:06:50.181009",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8331,
      "client_name": "ROMAR EDUARDO RUI SARMIENTO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Los Caobos",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121498364",
      "client_email": "ROMAREDUARDO@GMAIL.COM",
      "address": "CALLE PRINCIPAL CASA NRO 10 BARRIO LOS CAOBOS TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V11093608",
      "nap_box_name": "CTO-0225",
      "created_at": "2025-06-05T10:40:17.715917",
      "service_detail": {
        "id": 8857,
        "ip": "10.14.213.2",
        "mac": "OEMT3C6203B6",
        "serial": "OEMT3C6203B6",
        "queue": "queue1",
        "interface": "VLAN116_CAOBOS",
        "created_at": "2025-06-05T16:02:32.722641",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8332,
      "client_name": "LEONEL EDUARDO HERNANDEZ PINA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Saman de Guere",
      "plan": {
        "id": 19,
        "name": "RECURRENTE RESIDENCIAL PLAN 1GB",
        "cost": "74.70",
        "code": "FOR1GB",
        "profile": "1000M/1000M"
      },
      "client_mobile": "04121482865",
      "client_email": "LEONELHZ29@GMAIL.COM",
      "address": "CALLE PRINCIPAL SAMAN DE GUERE LOCAL NRO 3 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V26679428",
      "nap_box_name": "CTO - 1220",
      "created_at": "2025-06-05T11:10:23.810932",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8333,
      "client_name": "DORIS RAMONA BRACOVICH DE PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero I",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243650317",
      "client_email": "DORISRAMONABRACOVICH@GMAIL.COM",
      "address": "CALLE 15 CASA NRO 11 SAMAN TARAZONERO I TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V5597063",
      "nap_box_name": "674",
      "created_at": "2025-06-05T13:13:46.089251",
      "service_detail": {
        "id": 12697,
        "ip": "10.14.216.2",
        "mac": "QX:TL:CB:3C:0A:76",
        "serial": "QXTLCB3C0A76",
        "queue": null,
        "interface": "VLAN140_SMT1_ZTE",
        "created_at": "2026-07-07T11:27:38.387190",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8334,
      "client_name": "YESICA DEL CARMEN MORALES GIL",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Betania",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124622329",
      "client_email": "MORALESCAROLINA376@GMAIL.COM",
      "address": "ROSARIO DE PAYA SECTOR COMUNIDAD BETANIA CALLE 2 CASA NRO 290 TURMERO EDO ARAGUA",
      "client_identification": "V16370932",
      "nap_box_name": "CTO-00376",
      "created_at": "2025-06-06T08:47:50.323162",
      "service_detail": {
        "id": 12736,
        "ip": "10.14.218.2",
        "mac": "ZX:IC:CD:65:30:57",
        "serial": "ZXICCD653057",
        "queue": null,
        "interface": "VLAN260_BETANIA",
        "created_at": "2026-07-14T15:38:22.961896",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8335,
      "client_name": "JOSE TOMAS BORGES ROMERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128927782",
      "client_email": "JB5546142@GMAIL.COM",
      "address": "CALLE CARREÑO CASA 61 SECTOR CASCO DE TURMERO",
      "client_identification": "V19131103",
      "nap_box_name": "CE-00009",
      "created_at": "2025-06-06T08:57:54.435514",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8336,
      "client_name": "ALFONSO FERNANDEZ MENDOZA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04143473652",
      "client_email": "ALFONSOFM101@GMAIL.COM",
      "address": "ROSARIO DE PAYA SECTOR MATA CABALLO CALLE 3 NASA NRO 154 TURMERO EDO ARAGUA",
      "client_identification": "V17369863",
      "nap_box_name": "CTO-00028",
      "created_at": "2025-06-06T09:04:57.931959",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8337,
      "client_name": "YVAN ENRIQUE RODRIGUEZ LAYA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "San Pablo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128153806",
      "client_email": "YVANRODRIGUEZLAYA@GMAIL.COM",
      "address": "CALLE 3 CASA Nº 3 URBANIZACIÓN VILLA CARIBE SAN PABLO",
      "client_identification": "V6311750",
      "nap_box_name": "57",
      "created_at": "2025-06-06T09:28:07.538436",
      "service_detail": {
        "id": 9020,
        "ip": "10.14.221.2",
        "mac": "QXTLCB26FB96",
        "serial": "QXTLCB26FB96",
        "queue": "queue1",
        "interface": "VLAN287_M_CARIBE",
        "created_at": "2025-06-21T15:34:05.466348",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8338,
      "client_name": "JESUS JAVIER OROPEZA PEREIRA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04127764202",
      "client_email": "JESUSELAUTERIO@GMAIL.COM",
      "address": "CALLE NEGRO PRIMERO CRUCE CON CALLE RICAUTER NRO 60 TURMERO EDO ARAGUA",
      "client_identification": "V16851907",
      "nap_box_name": "CTO-00065",
      "created_at": "2025-06-06T09:30:11.978134",
      "service_detail": {
        "id": 9019,
        "ip": "10.14.222.2",
        "mac": "QXTLCBC9EDB4",
        "serial": "QXTLCBC9EDB4",
        "queue": "queue1",
        "interface": "VLAN200_OLTs",
        "created_at": "2025-06-21T15:31:10.749260",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8339,
      "client_name": "VICENTE VICTOR ORTEGA BOLIVAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "San Pablo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04123994195",
      "client_email": "VICENTEV.ORTEGAB@GMAIL.COM",
      "address": "AV SAN PABLO EDIFICIO CC Y RESIDENCIAL MILAN PLAZA SAN PABLO",
      "client_identification": "V14830551",
      "nap_box_name": "CAJA NAP EDIFICIO ABUUT",
      "created_at": "2025-06-06T09:41:01.274454",
      "service_detail": {
        "id": 9018,
        "ip": "10.14.223.2",
        "mac": "TPLGB954E912",
        "serial": "TPLGB954E912",
        "queue": "queue1",
        "interface": "VLAN224_SAN_PABLO_OLT1",
        "created_at": "2025-06-21T15:28:19.616107",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8340,
      "client_name": "OSCAR LEONARDO SUAREZ LORCA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128496126",
      "client_email": "OSLEONARDO22@GMAIL.COM",
      "address": "CALLE BOLÍVAR LOCAL 66-2 CASCO DE TURMERO",
      "client_identification": "V14182694",
      "nap_box_name": "CAJA NAP EDIFICIO ABUUT",
      "created_at": "2025-06-06T09:53:10.938074",
      "service_detail": {
        "id": 9017,
        "ip": "10.14.224.2",
        "mac": "QXTLCB6A6502",
        "serial": "QXTLCB6A6502",
        "queue": "queue1",
        "interface": "VLAN200_OLTs",
        "created_at": "2025-06-21T15:27:19.381927",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8341,
      "client_name": "GIUZEYDA JOHANNA DI NINO GIRON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "San Pablo",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04149438200",
      "client_email": "JDININO2020@GMAIL.COM",
      "address": "URBANIZACION SAN PABLO 4 TA AVENIDA 21 TURMERO",
      "client_identification": "V17575932",
      "nap_box_name": "CTO-00192",
      "created_at": "2025-06-06T10:05:14.740887",
      "service_detail": {
        "id": 9016,
        "ip": "10.14.225.2",
        "mac": "QXTLCBCF30E1",
        "serial": "QXTLCBCF30E1",
        "queue": "queue1",
        "interface": "VLAN224_SAN_PABLO_OLT1",
        "created_at": "2025-06-21T15:26:03.707680",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8342,
      "client_name": "NELSON RAFAEL SALGADO GOMEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Valle lindo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04120381174",
      "client_email": "NELSONSALGADO174@GMAIL.COM",
      "address": "CALLE 07 SECTOR I CASA # 8 URBANIZACION VALLE LINDO",
      "client_identification": "V21203374",
      "nap_box_name": "CE - 952",
      "created_at": "2025-06-06T10:16:57.178156",
      "service_detail": {
        "id": 9015,
        "ip": "10.14.217.2",
        "mac": "QXTLCB88DAED",
        "serial": "QXTLCB88DAED",
        "queue": "queue1",
        "interface": "VLAN274_VALLELINDO",
        "created_at": "2025-06-21T15:24:55.589784",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8343,
      "client_name": "LUIS GUILLERMO BETANCORT ESPINOZA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Valle lindo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04140519756",
      "client_email": "LUISGUILLERMOB@GMAIL.COM",
      "address": "CALLE 3 CASA SECTOR  2 CASA # 15 VALLE LINDO",
      "client_identification": "V15274980",
      "nap_box_name": "CE - 952",
      "created_at": "2025-06-06T10:45:48.024358",
      "service_detail": {
        "id": 9014,
        "ip": "10.14.227.2",
        "mac": "QXTLCB117AD8",
        "serial": "QXTLCB117AD8",
        "queue": "queue1",
        "interface": "VLAN274_VALLELINDO",
        "created_at": "2025-06-21T15:23:23.239063",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8344,
      "client_name": "OSCAR ANTONIO PALMA ALFONZO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Guayabita",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243501950",
      "client_email": "OP914780@GMAIL.COM",
      "address": "CALLE LAGUNITA CASA NRO 15 GUAYABITA TURMERO EDO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V17051397",
      "nap_box_name": "CTO - 1061",
      "created_at": "2025-06-06T13:15:33.576104",
      "service_detail": {
        "id": 8864,
        "ip": "10.14.228.2",
        "mac": "QXTLCB28AF77",
        "serial": "QXTLCB28AF77",
        "queue": "queue1",
        "interface": "VLAN281_MARCELOTA",
        "created_at": "2025-06-06T13:29:39.748389",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8345,
      "client_name": "SAMUEL RICARDO SUAREZ ORTA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Los Caobos",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128896507",
      "client_email": "SAMUELRSO21@GMAIL.COM",
      "address": "CALLE PRINCIPAL CASA NRO 12 LOS CAOBOS TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V19132258",
      "nap_box_name": "CTO-0225",
      "created_at": "2025-06-06T14:02:48.452876",
      "service_detail": {
        "id": 8866,
        "ip": "10.14.229.2",
        "mac": "HWTC5191746E",
        "serial": "HWTC5191746E",
        "queue": "queue1",
        "interface": "VLAN116_CAOBOS",
        "created_at": "2025-06-06T16:12:47.719727",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8346,
      "client_name": "CHRISTIAN AUGUSTO BAEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "La Casona II Edificios",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04143312879",
      "client_email": "BAEZAUGUSTO4@GMAIL.COM",
      "address": "EDIFICIO C PISO 3 APARTAMENTO 3 LA CASONA II TURMERO ZONA POSTAL 2115",
      "client_identification": "V4459204",
      "nap_box_name": "124",
      "created_at": "2025-06-06T14:16:18.150084",
      "service_detail": {
        "id": 9971,
        "ip": "10.14.231.2",
        "mac": "QXTLCBFCC137",
        "serial": "QXTLCBFCC137",
        "queue": null,
        "interface": "VLAN110_CASONA_2",
        "created_at": "2025-11-11T11:48:34.266415",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8347,
      "client_name": "CARMEN TERESA CARRENO ABZUARDE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "San Pablo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04143449007",
      "client_email": "CARMENTERESA202@GMAIL.COM",
      "address": "PRIMERA AVENIDA CASA 28 URB SAN PABLO",
      "client_identification": "V8728581",
      "nap_box_name": "CTO-00577 DOS",
      "created_at": "2025-06-06T15:05:04.304120",
      "service_detail": {
        "id": 12633,
        "ip": "10.14.230.2",
        "mac": "QX:TL:CB:80:F3:E2",
        "serial": "QXTLCB80F3E2",
        "queue": null,
        "interface": "VLAN224_SAN_PABLO_OLT1",
        "created_at": "2026-06-23T08:41:17.328482",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8348,
      "client_name": "ROSA ANDREINA OCHOA MOYETON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Antonio Jose de Sucre",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04140484881",
      "client_email": "ANDREINAHT@HOTMAIL.COM",
      "address": "URB SANTA EDUVIGES,DESPUÉS DE PASAR EL HOTEL EL SAMAN,SENTIDO TURMERO MACARO LOCAL #5",
      "client_identification": "V19004769",
      "nap_box_name": "87 DOS",
      "created_at": "2025-06-06T16:17:12.206958",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8349,
      "client_name": "LUIS WILFREDO GUILLEN ESTEVEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Tibisay Guevara",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128943709",
      "client_email": "LUISGUILLEN532@GMAIL.COM",
      "address": "CALLE 4 CASA 99 TIBISAY GUEVERA EL MACARO",
      "client_identification": "V20057954",
      "nap_box_name": "CTO-00054",
      "created_at": "2025-06-06T21:15:11.954578",
      "service_detail": {
        "id": 13029,
        "ip": "10.14.240.2",
        "mac": "ZX:IC:CD:C5:14:CB",
        "serial": "ZXICCDC514CB",
        "queue": null,
        "interface": "VLAN248_TIBISAY_OLT2",
        "created_at": "2026-09-16T14:19:47.637613",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8350,
      "client_name": "HELBRUN JOSE BERDUGO VIZCAINO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Guerito",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243018415",
      "client_email": "EDUARJOELN@GMAIL.COM",
      "address": "CALLE SUCRE CASA NRO 34 SAN MIGUEL VIA GUERITO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V13160120",
      "nap_box_name": "CTO-0657",
      "created_at": "2025-06-09T08:19:33.760866",
      "service_detail": {
        "id": 11846,
        "ip": "10.14.232.2",
        "mac": "QXTLCBF9FCDE",
        "serial": "QXTLCBF9FCDE",
        "queue": null,
        "interface": "VLAN139_GUERITO",
        "created_at": "2026-02-27T12:09:33.770663",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8351,
      "client_name": "HECTOR DANIEL RIVERO LOPEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "La Esperanza",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121487938",
      "client_email": "HDCOLOMBIA21@GMAIL.COM",
      "address": "CALLE 3 CASA NRO 13 URBANIZACION LA ESPERANZA EL MACARO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V20336896",
      "nap_box_name": "CTO-00462",
      "created_at": "2025-06-09T08:36:32.640418",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8352,
      "client_name": "SHADAY HARYSAID RENGIFO FLORES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona I",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128465243",
      "client_email": "SHADAYRENGIFO@GMAIL.COM",
      "address": "CALLE 6 CASA 17 LA CASONA I TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V30452910",
      "nap_box_name": "410",
      "created_at": "2025-06-09T08:55:33.346055",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8353,
      "client_name": "JESUS DANIEL ALVARADO JAIMEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Valle lindo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243609069",
      "client_email": "ROSANGELYSOCAMPO5@GMAIL.COM",
      "address": "CALLE 5 CASA # 8 URBANIZACION VALLE LINDO SECTOR 4 CASCO TURMERO",
      "client_identification": "V30327058",
      "nap_box_name": "110",
      "created_at": "2025-06-09T09:01:23.391099",
      "service_detail": {
        "id": 13155,
        "ip": "10.14.238.2",
        "mac": "QX:TL:CB:3D:3B:3C",
        "serial": "QXTLCB3D3B3C",
        "queue": null,
        "interface": "VLAN274_VALLELINDO",
        "created_at": "2026-10-12T10:47:57.445198",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8354,
      "client_name": "NIEVES ELENA ROMERO DEPABLOS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "San Pablo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04241665235",
      "client_email": "NIEVESELENA1309@GMAIL.COM",
      "address": "URBANIZACION SAN PABLO AVENIDA 4 LA CAROLINA TURMERO",
      "client_identification": "V10352068",
      "nap_box_name": "CTO-0637",
      "created_at": "2025-06-09T09:26:49.771801",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8355,
      "client_name": "ROSSANGELA DE JESUS RACHADELL RENGIFO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "La Casona II Edificios",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144674061",
      "client_email": "RRACHADELL@GMAIL.COM",
      "address": "LA CASONA II, EDIFICIO H15, PISO 3 , APARTAMENTO 3. TURMERO ZONA POSTAL 2115",
      "client_identification": "V20757436",
      "nap_box_name": "CTO-0541",
      "created_at": "2025-06-09T11:00:03.307033",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8356,
      "client_name": "MIRNA HILDEGARD GUTIERREZ URBINA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04227999637",
      "client_email": "RAFAELENRRIQUEMATUTERIOS@GMAIL.COM",
      "address": "CALLE MANZANA E CASA 8-1 SAMAN TARAZONERO II TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V16407266",
      "nap_box_name": "161 DOS",
      "created_at": "2025-06-09T11:06:04.608251",
      "service_detail": {
        "id": 8885,
        "ip": "10.14.239.2",
        "mac": "OEMT3C6208FE",
        "serial": "OEMT3C6208FE",
        "queue": "queue1",
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2025-06-09T14:51:33.285055",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8357,
      "client_name": "MARGOT COROMOTO VIVAS ROJAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "El Naranjal",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243133570",
      "client_email": "MARGOSVIVAS@GMAIL.COM",
      "address": "ROSARIO DE PAYA CALLEJON GONZALEZ CASA NRO 13 EL NARANJAL",
      "client_identification": "V16207374",
      "nap_box_name": "CE - 681",
      "created_at": "2025-06-09T14:45:09.787577",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8358,
      "client_name": "YELISBETH GABRIELA GONZALEZ GIL",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243788946",
      "client_email": "YELISBETHGONZALEZ746@GMAIL.COM",
      "address": "CALLE 2 CASA NRO 65 SECTOR MATA CABALLO ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V29786953",
      "nap_box_name": "CTO-00392",
      "created_at": "2025-06-09T16:05:04.478761",
      "service_detail": {
        "id": 8899,
        "ip": "10.14.242.2",
        "mac": "QXTLCB2DED50",
        "serial": "QXTLCB2DED50",
        "queue": "queue1",
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2025-06-10T13:28:22.513320",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8359,
      "client_name": "PAOLA IBETTE BLANCO GONZALEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Guayabita",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128880983",
      "client_email": "VIVAENERGI2025@GMAIL.COM",
      "address": "CALLE PRINCIPAL CASA PARCELA NRO 39 SECTOR EL CENTRAL GUAYABITA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V24174930",
      "nap_box_name": "CTO - 1117",
      "created_at": "2025-06-09T16:50:23.785881",
      "service_detail": {
        "id": 8893,
        "ip": "10.14.243.2",
        "mac": "QXTLCB4A1D42",
        "serial": "QXTLCB4A1D42",
        "queue": "queue1",
        "interface": "VLAN282_ZONA_AGRARIA",
        "created_at": "2025-06-09T20:36:15.544960",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8360,
      "client_name": "CARLOS EDUARDO HERNANDEZ RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Betania",
      "plan": {
        "id": 101,
        "name": "RECURRENTE RESIDENCIAL PLAN 200M",
        "cost": "19.00",
        "code": "FOR200MB",
        "profile": "200Mbps/200Mbps"
      },
      "client_mobile": "04140490598",
      "client_email": "CARLORODRIHERNA.35@GMAIL.COM",
      "address": "ROSARIO DE PAYA SECTOR PARCELAMIENTO 6 CALLE EL MIRADOR CASA NRO 3 TURMERO EDO ARAGUA",
      "client_identification": "V20451803",
      "nap_box_name": "CTO-00271",
      "created_at": "2025-06-10T09:28:16.815213",
      "service_detail": {
        "id": 8895,
        "ip": "10.14.244.2",
        "mac": "QXTLCBEF5C8B",
        "serial": "QXTLCBEF5C8B",
        "queue": "queue1",
        "interface": "VLAN246_NARANJAL",
        "created_at": "2025-06-10T10:53:59.597189",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8361,
      "client_name": "DARYELIS EBELIN RAMIREZ MAGALLANES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Guayabita",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04140291245",
      "client_email": "DARYELISRAMIREZ91@GMAIL.COM",
      "address": "ZONA AGRICOLA GUAYABITA- PARAGUATAN CALLE EL RINCON CASA NRO6",
      "client_identification": "V20694572",
      "nap_box_name": "CTO-00397",
      "created_at": "2025-06-10T09:48:38.356598",
      "service_detail": {
        "id": 8896,
        "ip": "10.14.245.2",
        "mac": "QXTLCB9F88F9",
        "serial": "QXTLCB9F88F9",
        "queue": "queue1",
        "interface": "VLAN283_PARAGUATAN",
        "created_at": "2025-06-10T10:59:32.023931",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8362,
      "client_name": "RAFAEL ANTONIO GOMEZ AZOCAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "San Pablo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04127063233",
      "client_email": "ANTO.FUCHOX@GMAIL.COM",
      "address": "CALLE PRINCIPAL CASA # 59 -C URBANIZACION HARAS DE SAN PABLO",
      "client_identification": "V19255432",
      "nap_box_name": "247",
      "created_at": "2025-06-10T09:52:25.214205",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8363,
      "client_name": "MARINA TRASOLI DE TRANSOLI",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "San Pablo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243028360",
      "client_email": "MARIELAMONCADA672@GMAIL.COM",
      "address": "AV 2DA CASA # 15-17 URBANIZACION SAN PABLO TURMERO",
      "client_identification": "V14183488",
      "nap_box_name": "CTO-00413",
      "created_at": "2025-06-10T10:09:41.880342",
      "service_detail": {
        "id": 9009,
        "ip": "10.14.247.2",
        "mac": "QXTLCBC1E4D4",
        "serial": "QXTLCBC1E4D4",
        "queue": "queue1",
        "interface": "VLAN224_SAN_PABLO_OLT1",
        "created_at": "2025-06-21T15:14:49.872816",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8364,
      "client_name": "CLARA HORTENCIA SOLANO DE RON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "San Pablo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144900465",
      "client_email": "CLARA.S.RON@GMAIL.COM",
      "address": "CALLE PRINCIPAL SAN PABLO  CASA # 17-A URBANIZACION SAN PABLO",
      "client_identification": "V5070110",
      "nap_box_name": "CTO-0637",
      "created_at": "2025-06-10T11:45:43.670138",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8365,
      "client_name": "SANDRA GIOVANNA ESPINOZA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Palmeras I",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128490809",
      "client_email": "SANDRAGIOVANNAESPINOZA@GMAIL.COM",
      "address": "URBANIZACION LAS PALMERAS 1 CALLE 2 # 83",
      "client_identification": "V9641126",
      "nap_box_name": "CTO-00065",
      "created_at": "2025-06-10T12:11:39.501316",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8366,
      "client_name": "ANYIE MARIANA MEDINA RINCON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Canaima",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243434927",
      "client_email": "ANYIEMEDINA7@GMAIL.COM",
      "address": "ROSARIO DE PAYA CANAIMA CALLE 6 CASA NRO 16 ARAGUA ZONA POSTAL 2115",
      "client_identification": "V31182332",
      "nap_box_name": "356",
      "created_at": "2025-06-10T15:29:50.600926",
      "service_detail": {
        "id": 8900,
        "ip": "10.14.250.2",
        "mac": "QXTLCB9FA41B",
        "serial": "QXTLCB9FA41B",
        "queue": "queue1",
        "interface": "VLAN237_CANAIMA",
        "created_at": "2025-06-10T15:52:46.275699",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8367,
      "client_name": "KELLER LEANDER THOMAS PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Villas Del Sur",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243423999",
      "client_email": "kellerthomas2006@gmail.com",
      "address": "VEREDA SANTA BARBARA CASA # 10 URBANIZACION VILLAS DEL SUR",
      "client_identification": "V31466440",
      "nap_box_name": "632",
      "created_at": "2025-06-11T09:32:54.118484",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8368,
      "client_name": "EMILY GABRIELA LAYA RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04126556769",
      "client_email": "EMILYLAYA439@GMAIL.COM",
      "address": "TORRE 18 APARTAMENTO 3 PISO 2 EZEQUIEL ZAMORA",
      "client_identification": "V29659263",
      "nap_box_name": "CTO-00464 DOS",
      "created_at": "2025-06-11T10:04:30.373492",
      "service_detail": {
        "id": 8917,
        "ip": "10.15.27.2",
        "mac": "QXTLCBD553F3",
        "serial": "QXTLCBD553F3",
        "queue": "queue1",
        "interface": "VLAN209_ZAMORA_OLT1",
        "created_at": "2025-06-12T13:52:49.711673",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8369,
      "client_name": "DENIS DEMETRIO RODRIGUEZ GARCIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Guerito",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04226625796",
      "client_email": "GRUPOPROKA@GMAIL.COM",
      "address": "CALLE PROLONGACION LA CEIBA LOCAL GALPON 47 GUERITO SAMAN DE GUERE ARAGUA ZONA POSTAL 2115",
      "client_identification": "V8738641",
      "nap_box_name": "CE - 623",
      "created_at": "2025-06-11T13:22:47.099274",
      "service_detail": {
        "id": 11805,
        "ip": "10.15.5.2",
        "mac": "QXTLCB0C4B56",
        "serial": "QXTLCB0C4B56",
        "queue": null,
        "interface": "VLAN144_LEOCOLBO",
        "created_at": "2026-02-27T11:32:22.894681",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8370,
      "client_name": "ALBERTO JOSE ACOSTA GARCIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Salto Angel",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121327607",
      "client_email": "albertacosta2106@gmail.com",
      "address": "CALLE LOS PINOS CASA 65 URBANIZACION SALTO ANGEL LA JULIA TURMERO ZONA POSTAL 2115",
      "client_identification": "V7242554",
      "nap_box_name": "CTO - 68",
      "created_at": "2025-06-11T13:31:43.160564",
      "service_detail": {
        "id": 9999,
        "ip": "10.15.6.2",
        "mac": "QXTLCB396E6E",
        "serial": "QXTLCB396E6E",
        "queue": null,
        "interface": "VLAN121_S_ANGEL",
        "created_at": "2025-11-11T13:51:58.108550",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8371,
      "client_name": "GRANJA LOS MOLINOS CA",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "San Pablo",
      "plan": {
        "id": 36,
        "name": "RECURRENTE PYME PLAN 650M",
        "cost": "70.18",
        "code": "FOP650M",
        "profile": "650M/650M"
      },
      "client_mobile": "04243374154",
      "client_email": "CUENTASPORPAGARMOLINOS@GMAIL.COM",
      "address": "CALLE PPAL LOCAL 01 SECTOR POLVORIN GUAYABITA",
      "client_identification": "J310314861",
      "nap_box_name": "CTO-00322",
      "created_at": "2025-06-11T15:02:34.716926",
      "service_detail": {
        "id": 12758,
        "ip": "10.17.100.2",
        "mac": "QX:TL:CB:C6:23:2E",
        "serial": "QXTLCBC6232E",
        "queue": null,
        "interface": "VLAN282_ZONA_AGRARIA",
        "created_at": "2026-07-20T16:32:40.204935",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8372,
      "client_name": "GRANJA LOS MOLINOS CA",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "San Pablo",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04243374154",
      "client_email": "CUENTASPORPAGARMOLINOS@GMAIL.COM",
      "address": "CENTRO COMERCIAL SAN PABLO ZONA INDUSTRIAL",
      "client_identification": "J310314861",
      "nap_box_name": "CTO-00322",
      "created_at": "2025-06-11T15:15:13.892982",
      "service_detail": {
        "id": 9007,
        "ip": "10.14.252.2",
        "mac": "QXTLCB8D0BE0",
        "serial": "QXTLCB8D0BE0",
        "queue": "queue1",
        "interface": "VLAN224_SAN_PABLO_OLT1",
        "created_at": "2025-06-21T15:12:12.825486",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8373,
      "client_name": "BELEN JOSEFINA HERMOSO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124432519",
      "client_email": "DASAHE2122@GMAIL.COM",
      "address": "TORRE 4 ESCALERA 2 PISO 3 APTO 1 ezequiel zamora",
      "client_identification": "V13201174",
      "nap_box_name": "CTO-00032 DOS",
      "created_at": "2025-06-11T15:25:19.093376",
      "service_detail": {
        "id": 9006,
        "ip": "10.15.25.2",
        "mac": "QXTLCB081116",
        "serial": "QXTLCB081116",
        "queue": "queue1",
        "interface": "VLAN209_ZAMORA_OLT1",
        "created_at": "2025-06-21T15:11:02.426860",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8374,
      "client_name": "CERLIDER JT CA",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Callejon Rosales",
      "plan": {
        "id": 103,
        "name": "RECURRENTE PYME PLAN 400M",
        "cost": "51.74",
        "code": "FOP400M",
        "profile": "400Mbps/400Mbps"
      },
      "client_mobile": "04243543913",
      "client_email": "CERLIDERJT@GMAIL.COM",
      "address": "CALLE ROSALES Nº 11 PARCELA 6-4 LOCAL 8 SECTOR VALLE DE PAYA ROSARIO DE PAYA TURMERO EDO ARAGUA ZONA POSTAL 2115",
      "client_identification": "J400636272",
      "nap_box_name": "319",
      "created_at": "2025-06-12T09:19:00.091838",
      "service_detail": {
        "id": 9005,
        "ip": "10.15.50.2",
        "mac": "QXTLCBF1569C",
        "serial": "QXTLCBF1569C",
        "queue": "queue1",
        "interface": "VLAN206_ROSALES_OLT2",
        "created_at": "2025-06-21T15:09:15.734979",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8375,
      "client_name": "ADRIAN JOSE COLMENARES ZARRAGA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vallecito",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04125971102",
      "client_email": "COLMENAREADRIAN400@GMAIL.COM",
      "address": "CALLE EL CUJI CASA 24 SECTOR VALLECITO ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V21464006",
      "nap_box_name": "CTO - 81",
      "created_at": "2025-06-12T09:50:02.789867",
      "service_detail": {
        "id": 8931,
        "ip": "10.15.46.2",
        "mac": "QXTLCB881AB6",
        "serial": "QXTLCB881AB6",
        "queue": "queue1",
        "interface": "VLAN258_VALLECITO",
        "created_at": "2025-06-13T14:19:42.143239",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8376,
      "client_name": "RAMON MONTILLA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04125987650",
      "client_email": "ABGRAMONMONTILLA@GMAIL.COM",
      "address": "CALLE MIRANDA EDIFICIO MARINARO OFICINA # 2 CASCO DE TURMERO",
      "client_identification": "V1198185",
      "nap_box_name": "CTO-00038",
      "created_at": "2025-06-12T12:37:35.588091",
      "service_detail": {
        "id": 9004,
        "ip": "10.15.29.2",
        "mac": "QXTLCBB4A34C",
        "serial": "QXTLCBB4A34C",
        "queue": "queue1",
        "interface": "VLAN200_OLTs",
        "created_at": "2025-06-21T15:07:39.226130",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8377,
      "client_name": "ENDER JOHAN OLIVO DIAZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243019261",
      "client_email": "OLDER942@GMAIL.COM",
      "address": "CALLE #8 CASA 570-A URBANIZACION MATA CABALLO PAYA",
      "client_identification": "V17645440",
      "nap_box_name": "CTO-00073",
      "created_at": "2025-06-12T13:19:11.464199",
      "service_detail": {
        "id": 10337,
        "ip": "10.15.47.2",
        "mac": "QXTLCB52BE31",
        "serial": "QXTLCB52BE31",
        "queue": null,
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2025-11-25T16:09:46.479529",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8378,
      "client_name": "STHEFANY VALERIA LOMBONO SANTANA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Terrazas de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04123981009",
      "client_email": "THEFYLOMBANO@GMAIL.COM",
      "address": "CALLE TERRAZA B. CASA # 24 URBANIZACION TERRAZAS DE TURMERO",
      "client_identification": "V30161152",
      "nap_box_name": "118",
      "created_at": "2025-06-12T14:42:16.673597",
      "service_detail": {
        "id": 10051,
        "ip": "10.15.30.2",
        "mac": "QXTLCB3570D2",
        "serial": "QXTLCB3570D2",
        "queue": null,
        "interface": "VLAN225_TERRAZAS_TURMERO_OLT1",
        "created_at": "2025-11-12T08:52:25.040145",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8379,
      "client_name": "YOSSIBERT TIBIZAY PALMA PALMA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Guayabita",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243326639",
      "client_email": "Yossiberthpalmapalma@gmail.com",
      "address": "CALLE PRINCIPAL CASA 46 GUAYABITA POLVORIN ARAGUA ZONA POSTAL 2115",
      "client_identification": "V17954054",
      "nap_box_name": "CE - 956",
      "created_at": "2025-06-12T15:47:33.187922",
      "service_detail": {
        "id": 8921,
        "ip": "10.15.48.2",
        "mac": "QXTLCB1500B8",
        "serial": "QXTLCB1500B8",
        "queue": "queue1",
        "interface": "VLAN285_MANIRITO",
        "created_at": "2025-06-13T10:02:44.882134",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8380,
      "client_name": "MONICA COROMOTO VELASQUEZ MARQUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "San Pablo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128904633",
      "client_email": "MONICACOROMOTOVELASQUEZMARQUEZ@GMAIL.COM",
      "address": "CALLE HARAS EDIFICIO 12 SAN PABLO PISO 1 APTO 12-21 URBANIZACION PARQUE RECIDENCIAL CAMPO ALEGR",
      "client_identification": "V15055580",
      "nap_box_name": "CTO-VA",
      "created_at": "2025-06-12T21:11:40.611561",
      "service_detail": {
        "id": 9002,
        "ip": "10.15.28.2",
        "mac": "QXTLCBE65D78",
        "serial": "QXTLCBE65D78",
        "queue": "queue1",
        "interface": "VLAN224_SAN_PABLO_OLT1",
        "created_at": "2025-06-21T15:03:33.518784",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8381,
      "client_name": "JESUS ALFONSO AMADOR APONTE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Las Rurales",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128928236",
      "client_email": "JESUSALFONSO19834@GMAIL.COM",
      "address": "LAS RURALES ROSARIO DE PAYA CALLE 104 CASA NRO 49 ARAGUA ZONA POSTAL 2115",
      "client_identification": "V19834360",
      "nap_box_name": "CE - 667",
      "created_at": "2025-06-13T09:42:56.449541",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8382,
      "client_name": "YEMELI ALEXANDRA RONDON BARRIOS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128995397",
      "client_email": "YEMELIRONDON07@GMAIL.COM",
      "address": "CALLE CARREÑO TORRE PISO 3 APTO 6 ANTIGUA HACIENDA EL NISPERO TURMERO ZONA POSTAL 2115",
      "client_identification": "V30658856",
      "nap_box_name": "118",
      "created_at": "2025-06-13T11:43:32.369808",
      "service_detail": {
        "id": 12425,
        "ip": "10.15.37.2",
        "mac": "QXTLCB3497BB",
        "serial": "QXTLCB3497BB",
        "queue": null,
        "interface": "VLAN209_ZAMORA_OLT1",
        "created_at": "2026-04-28T13:08:50.664282",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8383,
      "client_name": "ABIGAIL RIVERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vallecito",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04143129074",
      "client_email": "ABIGAILRIVERA.27B@GMAIL.COM",
      "address": "CALLE LOS NARANJOS PARCELAMIENTO SANTA BARBARA 8-A VALLECITO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V26728707",
      "nap_box_name": "CTO - 1090",
      "created_at": "2025-06-13T11:52:26.548337",
      "service_detail": {
        "id": 10988,
        "ip": "10.15.54.2",
        "mac": "QXTLCBFA3F8B",
        "serial": "QXTLCBFA3F8B",
        "queue": null,
        "interface": "VLAN258_VALLECITO",
        "created_at": "2025-12-30T10:24:33.703354",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8384,
      "client_name": "KEVIN DANIEL HERNANDEZ GALAN",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243693846",
      "client_email": "KEVINLOL1309@GMAIL.COM",
      "address": "LA CASONA II, EDIFICIO 12 PISO 3 APARTAMENTO 0-2 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V24930602",
      "nap_box_name": "CE - 279",
      "created_at": "2025-06-13T12:07:11.622515",
      "service_detail": {
        "id": 12001,
        "ip": "10.15.7.2",
        "mac": "QXTLCB0F0E78",
        "serial": "QXTLCB0F0E78",
        "queue": null,
        "interface": "VLAN110_CASONA_2",
        "created_at": "2026-03-07T13:06:00.671659",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8385,
      "client_name": "JOSE ANTONIO PALMA BOLIVAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Saman de Guere",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04122177878",
      "client_email": "JOSEANTONIOPALMABOLIVAR@GMAIL.COM",
      "address": "CALLE PROLONGACION PRINCIPAL CASA NRO 22 SECTOR MANOS DE DIOS SAMAN DE GUERE ZONA POSTAL 2115",
      "client_identification": "V10617995",
      "nap_box_name": "CTO - 1220",
      "created_at": "2025-06-13T12:17:16.672039",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8386,
      "client_name": "YARITZA COROMOTO HERNANDEZ JIMENEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04149446184",
      "client_email": "YARITZAHERNADEZ684@GMAIL.COM",
      "address": "CALLE CARREÑO CASA # 102 CASCO DE TURMERO",
      "client_identification": "V27048417",
      "nap_box_name": "118",
      "created_at": "2025-06-13T12:48:07.619906",
      "service_detail": {
        "id": 9000,
        "ip": "10.15.31.2",
        "mac": "QXTLCB0EA4A1",
        "serial": "QXTLCB0EA4A1",
        "queue": "queue1",
        "interface": "VLAN225_TERRAZAS_TURMERO_OLT1",
        "created_at": "2025-06-21T14:58:36.566162",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8387,
      "client_name": "MOISES DAVID RAMIREZ DELGADO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "El Cambur",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04129000557",
      "client_email": "Moisesrsrami443@gmail.com",
      "address": "CALLE PRINCIPAL EL CAMBUR CASA Nº 35 SECTOR EL CAMBUR ROSARIO DE PAYA TURMERO EDO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V12977737",
      "nap_box_name": "CTO-00150",
      "created_at": "2025-06-13T16:03:16.914159",
      "service_detail": {
        "id": 11302,
        "ip": "10.15.51.2",
        "mac": "QXTLCB36D7B0",
        "serial": "QXTLCB36D7B0",
        "queue": null,
        "interface": "VLAN263_EL_CAMBUR",
        "created_at": "2026-01-22T13:17:58.862107",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8388,
      "client_name": "GRECHYKINDIANA TAHIS PLASENCIA CORRALES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Dios Es Mi Refugio",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243419346",
      "client_email": "GRECHYKINDIANAPLASENCIACO@GMAIL.COM",
      "address": "CALLE PRINCIPAL MANZANA 3 CASA Nº 8 SECTOR DIOS ES MI REFUGIO DE QUIEN TEMERE PAYA ABAJO ROSARIO DE PAYA TURMERO EDO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V20817363",
      "nap_box_name": "CTO-0656",
      "created_at": "2025-06-13T16:19:49.407638",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8389,
      "client_name": "ENEYDA MARLENE MORONTA MORALES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "San Pablo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144483695",
      "client_email": "MARLENEMM@GMAIL.COM",
      "address": "SAN PABLO 3 ERA AVENIDA CASA # 19",
      "client_identification": "V8828635",
      "nap_box_name": "CTO-0637",
      "created_at": "2025-06-13T23:08:34.847153",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8390,
      "client_name": "MIRIAN JOSEFINA BELISARIO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Saman Tarazonero I",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243113032",
      "client_email": "MIRIAMBELIS1992@GMAIL.COM",
      "address": "CALLE 3 CASA  # 25 SAMAN TARAZONERO I, EL MACARO",
      "client_identification": "V9884660",
      "nap_box_name": "291",
      "created_at": "2025-06-14T13:40:37.481319",
      "service_detail": {
        "id": 8961,
        "ip": "10.15.9.2",
        "mac": "QXTLCBF1C839",
        "serial": "QXTLCBF1C839",
        "queue": "queue1",
        "interface": "VLAN140_SMT1_ZTE",
        "created_at": "2025-06-17T08:03:41.081017",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8391,
      "client_name": "ALONZO MANCILLA SUAREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Valle Fresco",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04242500601",
      "client_email": "ALONZONMANCILLA01@GMAIL.COM",
      "address": "URBANIZACION VALLE FRESCO MANZANA 10 CASA 10.7",
      "client_identification": "V4807914",
      "nap_box_name": "MANGA 5",
      "created_at": "2025-06-14T14:03:44.332970",
      "service_detail": {
        "id": 8986,
        "ip": "10.15.38.2",
        "mac": "QXTLCBEA9122",
        "serial": "QXTLCBEA9122",
        "queue": "queue1",
        "interface": "VLAN270_VALLE_FRESCO_OLT3",
        "created_at": "2025-06-20T14:12:39.403044",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8392,
      "client_name": "SONIA MIREYA BARRIOS DE DONATELLI",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "San Pablo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243734745",
      "client_email": "DOGASOMIR@GMAIL.COM",
      "address": "SAN PABLO AVENIDA 3 CASA # 8  SAN PABLO 1",
      "client_identification": "V3514528",
      "nap_box_name": "CTO-0637",
      "created_at": "2025-06-14T14:44:12.629026",
      "service_detail": {
        "id": 8997,
        "ip": "10.15.32.2",
        "mac": "QXTLCB5B2301",
        "serial": "QXTLCB5B2301",
        "queue": "queue1",
        "interface": "VLAN224_SAN_PABLO_OLT1",
        "created_at": "2025-06-21T14:48:01.938054",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8393,
      "client_name": "MARTHA BELMIRA PINTO CARPIO",
      "client_type_name": "EMPLEADO",
      "client_subdivision": "CANCELADO_EMPLEADO",
      "status_name": "Cancelado",
      "cycle": 25,
      "migrate": false,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 78,
        "name": "Plan empleado 80MB",
        "cost": "0.00",
        "code": "FO-80M",
        "profile": "80M/80M"
      },
      "client_mobile": "04124651395",
      "client_email": "MARTHABELMIRAPINTO@GMAIL.COM",
      "address": "SECTOR RIO SECO CALLE 7 CASA #52 ROSARIO DE PAYA TURMERO ARAGUA 2115",
      "client_identification": "V24169270",
      "nap_box_name": "474",
      "created_at": "2025-06-16T08:59:08.088461",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8394,
      "client_name": "EMILIA DEL ROSARIO ESPINOZA MORALES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Betania",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243578386",
      "client_email": "MAYRA122PINEDA@GMAIL.COM",
      "address": "ROSARIO DE PAYA COMUNIDAD BETANIA CALLE 1 CASA NRO 52",
      "client_identification": "V5157641",
      "nap_box_name": "CTO-00376",
      "created_at": "2025-06-16T10:29:28.324462",
      "service_detail": {
        "id": 10761,
        "ip": "10.15.53.2",
        "mac": "QXTLCBC49C6B",
        "serial": "QXTLCBC49C6B",
        "queue": null,
        "interface": "VLAN260_BETANIA",
        "created_at": "2025-12-17T10:59:07.489427",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8395,
      "client_name": "IRIS NORA TOVAR LOPEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Las Palmas",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121886497",
      "client_email": "KAOMAZORA@GMAIL.COM",
      "address": "CALLE PRINCIPAL CASA NRO 183-2 SECTOR LAS PALMAS, ROSARIO DE PAYA. TURMERO EDO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V11089491",
      "nap_box_name": "CTO-00098",
      "created_at": "2025-06-16T10:36:40.735210",
      "service_detail": {
        "id": 11753,
        "ip": "10.15.52.2",
        "mac": "QXTLCB772363",
        "serial": "QXTLCB772363",
        "queue": null,
        "interface": "VLAN262_LAS_PALMAS_ZTE",
        "created_at": "2026-02-26T11:50:31.347540",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8396,
      "client_name": "ISMAEL ADOLFO CABALLERO LARTIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "San Pablo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243788984",
      "client_email": "ISMAELADOLFO@GMAIL.COM",
      "address": "SAN PABLO AVENIDA 3 CASA # 03",
      "client_identification": "V11976077",
      "nap_box_name": "CTO-0637",
      "created_at": "2025-06-16T11:29:10.832241",
      "service_detail": {
        "id": 9772,
        "ip": "10.15.34.2",
        "mac": "QXTLCBBD8AF5",
        "serial": "QXTLCBBD8AF5",
        "queue": null,
        "interface": "VLAN224_SAN_PABLO_OLT1",
        "created_at": "2025-11-10T12:37:31.960583",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8397,
      "client_name": "YOLEIDA TERESA SANGRONIS MORONTA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Payita",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243674188",
      "client_email": "YOLEIDASAN592@GMAIL.COM",
      "address": "CALLE CALLEJON 96 CASA 12 BARRIO PAYITA ROSARIO DE PAYA",
      "client_identification": "V13199497",
      "nap_box_name": "CE - 861",
      "created_at": "2025-06-16T16:03:24.120743",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8398,
      "client_name": "YOHAN JOSE FOFER RUIZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Las Rurales",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04122078995",
      "client_email": "YOANJFR79@GMAIL.COM",
      "address": "CALLE BOLIVAR CASA NRO 34 ROSARIO DE PAYA LAS RURALES ARAGUA ZONA POSTAL",
      "client_identification": "V15054027",
      "nap_box_name": "CTO-0610",
      "created_at": "2025-06-16T21:54:26.669392",
      "service_detail": {
        "id": 8957,
        "ip": "10.15.19.2",
        "mac": "QXTLCB80425D",
        "serial": "QXTLCB80425D",
        "queue": "queue1",
        "interface": "VLAN252_RURALES_PAYA",
        "created_at": "2025-06-16T23:31:33.084779",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8399,
      "client_name": "YRIANNYS JOSE MARCHENA ESBERT",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Payita",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243556595",
      "client_email": "YRIANNYSM@GMAIL.COM",
      "address": "CALLE PRINCIPAL CASA 36 TURMERO PAYITA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V20256541",
      "nap_box_name": "CTO-1045",
      "created_at": "2025-06-16T22:13:45.848144",
      "service_detail": {
        "id": 8956,
        "ip": "10.15.17.2",
        "mac": "QXTLCBFD5710",
        "serial": "QXTLCBFD5710",
        "queue": "queue1",
        "interface": "VLAN284_PAYITA",
        "created_at": "2025-06-16T23:17:05.901987",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8400,
      "client_name": "CARMEN ELENA PAEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121388593",
      "client_email": "GL4114191@GMAIL.COM",
      "address": "CALLE 7 CASA NRO 05 RIO SECO ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V7240721",
      "nap_box_name": "CE - 650",
      "created_at": "2025-06-16T22:25:00.932554",
      "service_detail": {
        "id": 8955,
        "ip": "10.15.16.2",
        "mac": "QXTLCB5DC431",
        "serial": "QXTLCB5DC431",
        "queue": "queue1",
        "interface": "VLAN251_RIO_SECO",
        "created_at": "2025-06-16T23:12:19.424032",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8401,
      "client_name": "MELANI VICTORIA SALAS FLORES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04123359410",
      "client_email": "john_abreu1@hotmail.com",
      "address": "CALLE RIVAS LOCAL 7-3  SECTOR CASCO DE TURMERO",
      "client_identification": "V30976136",
      "nap_box_name": "CTO-00129",
      "created_at": "2025-06-16T23:08:46.271434",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8402,
      "client_name": "FREDDY FRANCISCO MARTINEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villa Los Tamarindos",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04120255443",
      "client_email": "NENOFRANCISCO63@GMAIL.COM",
      "address": "CALLE 8 CASA 4 VILLA LOS TAMARINDOS EL MACARO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V6077045",
      "nap_box_name": "CTO-00593",
      "created_at": "2025-06-17T10:10:01.152723",
      "service_detail": {
        "id": 8973,
        "ip": "10.15.10.2",
        "mac": "QXTLCB56D041",
        "serial": "QXTLCB56D041",
        "queue": "queue1",
        "interface": "VLAN133_VILLA_TAMARINDOS",
        "created_at": "2025-06-18T10:20:49.239432",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8404,
      "client_name": "LUIS REINALDO AMUNDARAY RONDON",
      "client_type_name": "EMPLEADO",
      "client_subdivision": "CANCELADO_EMPLEADO",
      "status_name": "Cancelado",
      "cycle": 25,
      "migrate": false,
      "sector_name": "Haras de San Pablo",
      "plan": {
        "id": 78,
        "name": "Plan empleado 80MB",
        "cost": "0.00",
        "code": "FO-80M",
        "profile": "80M/80M"
      },
      "client_mobile": "04127760084",
      "client_email": "AMUNDARAYA@GMAIL.COM",
      "address": "HARAS SAN PABLO MANZANA B, CASA Nº 38 TURMERO EDO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V13621115",
      "nap_box_name": "CTO-0489",
      "created_at": "2025-06-17T14:49:55.885964",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8408,
      "client_name": "JOSE LUIS SUESCUN CAMACHO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "San Pablo",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04241642872",
      "client_email": "SUESCUNCAMACHOJOSELUIS@GMAI.COM",
      "address": "ZONA INDUSTRIAL DE SAN PABLO, AVENIDA 2 GALPÓN 38 TURMERO, ARAGUA",
      "client_identification": "V11955649",
      "nap_box_name": "CTO-00322",
      "created_at": "2025-06-17T15:16:31.365561",
      "service_detail": {
        "id": 12393,
        "ip": "172.21.90.2",
        "mac": "HWTC45A04437",
        "serial": "HWTC45A04437",
        "queue": null,
        "interface": "VLAN224_SAN_PABLO_OLT1",
        "created_at": "2026-04-21T17:20:31.544372",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8409,
      "client_name": "LILIANA JOSEFINA ASCANIO DE ROJAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "San Pablo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144922733",
      "client_email": "LILIANAJOSEASCANIO@HOTMAIL.COM",
      "address": "URBANIZACION SAN PABLO  3 ERA AVENIDA CASA # 27 SAN PABLO",
      "client_identification": "V6359041",
      "nap_box_name": "CTO-0637",
      "created_at": "2025-06-17T15:30:13.811630",
      "service_detail": {
        "id": 12006,
        "ip": "10.15.35.2",
        "mac": "QXTLCBC647B9",
        "serial": "QXTLCBC647B9",
        "queue": null,
        "interface": "VLAN224_SAN_PABLO_OLT1",
        "created_at": "2026-03-07T18:44:37.613158",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8410,
      "client_name": "CARLOS JAVIER ORTEGA BRICENO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villas El Carmen",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243425977",
      "client_email": "CARLITOSELMANCO@GMAIL.COM",
      "address": "CALLE 8 CASA 17 URBANIZACION VILLAS EL CARMEN TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V29959133",
      "nap_box_name": "CTO-00035",
      "created_at": "2025-06-17T17:53:51.798029",
      "service_detail": {
        "id": 8975,
        "ip": "10.15.12.2",
        "mac": "QXTLCBF0EE72",
        "serial": "QXTLCBF0EE72",
        "queue": "queue1",
        "interface": "VLAN135_VILLAS_CARMEN_OLT_ZTE",
        "created_at": "2025-06-18T10:37:32.584927",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8411,
      "client_name": "EUKER KATHERINE LIMPIO RAMIREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04125079712",
      "client_email": "KATHERINELIMPIO432@GMAIL.COM",
      "address": "CALLE 18 A CASA NRO 22 PANTIN ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V25013356",
      "nap_box_name": "CTO-00434",
      "created_at": "2025-06-18T08:53:28.170616",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8412,
      "client_name": "MAYELYS DEL CARMEN PEREZ HOYO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Betania",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243303198",
      "client_email": "PAULAPHOYO19@GMAIL.COM",
      "address": "CALLE 1 CASA NRO 34 BETANIA ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V27625949",
      "nap_box_name": "CTO-00376",
      "created_at": "2025-06-18T09:28:13.062491",
      "service_detail": {
        "id": 10764,
        "ip": "10.15.22.2",
        "mac": "QXTLCB2C2823",
        "serial": "QXTLCB2C2823",
        "queue": null,
        "interface": "VLAN260_BETANIA",
        "created_at": "2025-12-17T11:02:41.010121",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8413,
      "client_name": "CRISELYS WHITNEEY CHACON SANCHEZ",
      "client_type_name": "GRATIS",
      "client_subdivision": "CANCELADO_GRATIS",
      "status_name": "Cancelado",
      "cycle": 25,
      "migrate": false,
      "sector_name": "Saman Tarazonero I",
      "plan": {
        "id": 86,
        "name": "PLAN RECURRENTE 80M GRATIS",
        "cost": "0.00",
        "code": "FO-G80",
        "profile": "80M/80M"
      },
      "client_mobile": "04123986577",
      "client_email": "CRISELYSCHACON1993@GMAIL.COM",
      "address": "CALLE 3 CASA NUMERO 16, SECTOR SAMAN TARAZONERO 1, TURMERO ESTADO ARAGUA",
      "client_identification": "V25651512",
      "nap_box_name": "291",
      "created_at": "2025-06-18T10:04:04.471552",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8414,
      "client_name": "CRISMARY JUAREZ RIVAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04143870582",
      "client_email": "ABOGADAJUAREZC@GMAIL.COM",
      "address": "CALLE RIVAS EDIFICIO RESIDENCIAS NELLY PISO 4 APARTAMENTO 24 CASCO DE TURMERO",
      "client_identification": "V15601430",
      "nap_box_name": "255",
      "created_at": "2025-06-18T10:18:45.385875",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8415,
      "client_name": "ANIOSCAR HOOYANA MORENO VALLES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "La Guzman",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243338515",
      "client_email": "ANIOSCAR13@GMAIL.COM",
      "address": "CALLE EZEQUIEL ZAMORA NRO 13 LA GUZMAN ARAGUA ZONA POSTAL 2115",
      "client_identification": "V29728318",
      "nap_box_name": "CTO - 1075",
      "created_at": "2025-06-18T14:23:44.625464",
      "service_detail": {
        "id": 8981,
        "ip": "10.15.56.2",
        "mac": "QXTLCBE8F392",
        "serial": "QXTLCBE8F392",
        "queue": "queue1",
        "interface": "VLAN286_LA_GUZMAN",
        "created_at": "2025-06-19T09:16:17.260568",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8416,
      "client_name": "CARLOS ENRIQUE JARAMILLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "San Pablo",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04121487940",
      "client_email": "INVERSIONESJARAMILLO2017@GMAIL.COM",
      "address": "CALLE 5  CASA # 58 URBANIZACION MARINA CARIBE SAN PABLO",
      "client_identification": "V10750451",
      "nap_box_name": "CTO - 940",
      "created_at": "2025-06-18T23:02:03.882777",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8417,
      "client_name": "LINDON ARGENIS NORATO GONZALEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Saman Tarazonero I",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04122377695",
      "client_email": "LINDONNORATO@GMAIL.COM",
      "address": "CALLE 3 CASA 27 SAMAN TARAZONERO I TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V10757270",
      "nap_box_name": "32",
      "created_at": "2025-06-19T09:55:44.688109",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8456,
      "client_name": "DOUGLAS JOSE LUNA RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243827265",
      "client_email": "YENNY98F@GMAIL.COM",
      "address": "CALLE BOLIVAR # 66-1 LOCAL MULTISERVICIOS CASCO DE TURMERO",
      "client_identification": "V13769643",
      "nap_box_name": "CAJA NAP EDIFICIO ABUUT",
      "created_at": "2025-06-21T09:20:14.156089",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8457,
      "client_name": "MARIBEL HERNANDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243209923",
      "client_email": "MHO983430@GMAIL.COM",
      "address": "AV 2 APARTAMENTO 528-D MATA CABALLO ROSARIO DE PAYA TURMERO EDO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V8687815",
      "nap_box_name": "CTO-00222",
      "created_at": "2025-06-21T09:50:01.043347",
      "service_detail": {
        "id": 9048,
        "ip": "10.15.23.2",
        "mac": "QXTLCBE34066",
        "serial": "QXTLCBE34066",
        "queue": "queue1",
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2025-06-23T09:43:50.336867",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8458,
      "client_name": "CESAR MIGUEL LLOVERA APONTE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Edif. El Torreon",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144653614",
      "client_email": "CESARMLLOVERA@GMAIL.COM",
      "address": "SAN PABLO EDIFICIO EL TORREON TORRE A PISO 7 APARTAMENTO 72",
      "client_identification": "V28219979",
      "nap_box_name": "CTO TORREON TORRE A",
      "created_at": "2025-06-21T10:00:34.663421",
      "service_detail": {
        "id": 8993,
        "ip": "10.15.41.2",
        "mac": "QXTLCB6EAE11",
        "serial": "QXTLCB6EAE11",
        "queue": "queue1",
        "interface": "VLAN289_TORREON",
        "created_at": "2025-06-21T14:20:22.718692",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8459,
      "client_name": "YRMA MARIA MONTERO PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124452625",
      "client_email": "YRMA280.2010@GMAIL.COM",
      "address": "MATA CABALLO AV PRINCIPAL TERRAZA 687 A",
      "client_identification": "V12609934",
      "nap_box_name": "CTO-00210",
      "created_at": "2025-06-21T11:23:40.022819",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8460,
      "client_name": "TIRSO GERARDO REYES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Polvorin",
      "plan": {
        "id": 101,
        "name": "RECURRENTE RESIDENCIAL PLAN 200M",
        "cost": "19.00",
        "code": "FOR200MB",
        "profile": "200Mbps/200Mbps"
      },
      "client_mobile": "04121492440",
      "client_email": "TIRSOREYES590@GMAIL.COM",
      "address": "CALLE ESCALONA CASA # 19 PARAGUATAN POLVORIN",
      "client_identification": "V5627255",
      "nap_box_name": "CTO - 1123",
      "created_at": "2025-06-21T11:58:47.403294",
      "service_detail": {
        "id": 9046,
        "ip": "10.15.65.2",
        "mac": "QXTLCB728487",
        "serial": "QXTLCB728487",
        "queue": "queue1",
        "interface": "VLAN280_POLVORIN",
        "created_at": "2025-06-22T21:22:06.835913",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8461,
      "client_name": "MAITHE URIMARE MARTINEZ CORREDOR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Edif. El Torreon",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04122615108",
      "client_email": "MAITE.MAR30@GMAIL.COM",
      "address": "SAN PABLO EDIFICIO EL TORREON TORRE A PISO 4 APARTAMENTO 43",
      "client_identification": "V13200796",
      "nap_box_name": "CTO TORREON TORRE A",
      "created_at": "2025-06-21T18:15:03.898567",
      "service_detail": {
        "id": 9041,
        "ip": "10.15.39.2",
        "mac": "QXTLCBD28344",
        "serial": "QXTLCBD28344",
        "queue": "queue1",
        "interface": "VLAN289_TORREON",
        "created_at": "2025-06-22T09:45:08.980444",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8462,
      "client_name": "ANABELLA COROMOTO MILLAN GIL",
      "client_type_name": "GRATIS",
      "client_subdivision": "ACTIVO_GRATIS",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": false,
      "sector_name": "Edif. El Torreon",
      "plan": {
        "id": 86,
        "name": "PLAN RECURRENTE 80M GRATIS",
        "cost": "0.00",
        "code": "FO-G80",
        "profile": "80M/80M"
      },
      "client_mobile": "04128100816",
      "client_email": "ANABELLACMILLANGIL@GMAIL.COM",
      "address": "SAN PABLO EL TORREON TORRE A PLANTA BAJA CONSERGERIA",
      "client_identification": "V5271408",
      "nap_box_name": "CTO TORREON TORRE A",
      "created_at": "2025-06-21T18:55:21.242607",
      "service_detail": {
        "id": 9040,
        "ip": "10.15.40.2",
        "mac": "QXTLCBF29B3F",
        "serial": "QXTLCBF29B3F",
        "queue": "queue1",
        "interface": "VLAN289_TORREON",
        "created_at": "2025-06-22T09:25:36.232767",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8463,
      "client_name": "JUAN MANUEL CORDERO MILANO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Edif. El Torreon",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243363681",
      "client_email": "JUANCORDERO96@GMAIL.COM",
      "address": "SAN PABLO EDIFICIO EN TORREON TORRE B APARTAMENTO 14",
      "client_identification": "V8730549",
      "nap_box_name": "CTO TORREON TORRE B",
      "created_at": "2025-06-21T19:10:38.394979",
      "service_detail": {
        "id": 9038,
        "ip": "10.15.69.2",
        "mac": "QXTLCB29CA4C",
        "serial": "QXTLCB29CA4C",
        "queue": "queue1",
        "interface": "VLAN289_TORREON",
        "created_at": "2025-06-22T09:15:53.652371",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8464,
      "client_name": "FERNANDO LUIS MARQUEZ C",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Edif. El Torreon",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144557478",
      "client_email": "FMVENTASVE@GMAIL.COM",
      "address": "SAN PABLO EDIFICIO EL TORREON TORRE B PISO 7 APARTAMENTO 72",
      "client_identification": "V18488468",
      "nap_box_name": "CTO TORREON TORRE B",
      "created_at": "2025-06-21T20:27:04.039626",
      "service_detail": {
        "id": 9519,
        "ip": "10.15.70.2",
        "mac": "QXTLCBDC47C3",
        "serial": "QXTLCBDC47C3",
        "queue": "queue1",
        "interface": "VLAN289_TORREON",
        "created_at": "2025-09-13T14:32:36.305551",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8465,
      "client_name": "SANDRA MARIA COLMENARES AMADO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Edif. El Torreon",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243292920",
      "client_email": "SCOLMENARES446@GMAIL.COM",
      "address": "SAN PABLO EDIFICIO EL TORREON TORRE C PISO 7 APARTAMENTO 4",
      "client_identification": "V11179765",
      "nap_box_name": "CTO TORREON TORRE C",
      "created_at": "2025-06-21T22:43:38.366095",
      "service_detail": {
        "id": 9039,
        "ip": "10.15.42.2",
        "mac": "QXTL-CB6BD9E6",
        "serial": "QXTLCB6BD9E6",
        "queue": "queue1",
        "interface": "VLAN289_TORREON",
        "created_at": "2025-06-22T09:21:21.353243",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8466,
      "client_name": "MIRNA XIOMARA DEL PILAR CLEMENTE MEDINA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Edif. El Torreon",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04127570998",
      "client_email": "MIRACLE.CLEMENTEMEDINA13@GMAIL.COM",
      "address": "SAN PABLO EDIFICIO TORREON TORRE C PISO 1 APARTAMENTO 14",
      "client_identification": "V4351301",
      "nap_box_name": "CTO TORREON TORRE C",
      "created_at": "2025-06-21T23:31:26.962575",
      "service_detail": {
        "id": 9051,
        "ip": "10.15.73.2",
        "mac": "QXTLCB05704A",
        "serial": "QXTLCB05704A",
        "queue": "queue1",
        "interface": "VLAN289_TORREON",
        "created_at": "2025-06-23T12:20:59.738851",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8467,
      "client_name": "YEFFERSON WUILKLEY BETANCOURT GOMEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Ppal Paya",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04125988622",
      "client_email": "WUILKLEY2004@GMAIL.COM",
      "address": "CALLE 3 CASA 100 ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V31917383",
      "nap_box_name": "ce-968",
      "created_at": "2025-06-22T14:40:33.148019",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8468,
      "client_name": "NORIANNI ANDREINA SANCHEZ SILVA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Ppal Paya",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04228150794",
      "client_email": "NORIANNISANCHEZ5@GMAIL.COM",
      "address": "CALLE 2 CASA 61 ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V28496061",
      "nap_box_name": "ce-968",
      "created_at": "2025-06-22T14:52:56.477630",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8469,
      "client_name": "JUANA BAUTISTA PERALTA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Guerito",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128419953",
      "client_email": "MAGLIS.PERALTA@GMAIL.COM",
      "address": "AV PRINCIPAL GUERITO CALLE BOLIVAR 1-A SAN MIGUEL TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V4545405",
      "nap_box_name": "CTO - 940",
      "created_at": "2025-06-23T08:40:11.417289",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8470,
      "client_name": "RICHARD RAFAEL AGUIRRE CORRALES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Leocolbo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121492026",
      "client_email": "RICHARDAGUIRRE2008@GMAIL.COM",
      "address": "CALLE CON VEREDA 1 CASA NRO 09 VALLE LEOCOLBO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V8824186",
      "nap_box_name": "CTO-00371",
      "created_at": "2025-06-23T08:53:45.090703",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8471,
      "client_name": "EDGARDO ALFONSO OSORIO PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Edif. El Torreon",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124633323",
      "client_email": "EDGARDOOSORIO2015@GMAIL.COM",
      "address": "SAN PABLO EDIFICIO TORREON TORRE B PISO 3 APARTAMENTO 3-33",
      "client_identification": "V30082349",
      "nap_box_name": "CTO TORREON TORRE B",
      "created_at": "2025-06-23T09:41:41.127032",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8472,
      "client_name": "MARIA MILAGRO PALMA NIEVES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Payita",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124619445",
      "client_email": "RANGELCARLOS163@GMAIL.COM",
      "address": "CALLE 80 CASA NRO 10 PAYITA GUAYABITA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V8737632",
      "nap_box_name": "CTO - 1039",
      "created_at": "2025-06-23T10:32:41.143621",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8473,
      "client_name": "LUIS MAGIN ESPINOZA MARTINEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Dios Es Mi Refugio",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243479811",
      "client_email": "HAIBERALVAREZ@GMAIL.COM",
      "address": "MANZANA 4 PARCELA 01 ROSARIO DE PAYA DIOS ES MI REFUGIO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V13255061",
      "nap_box_name": "CTO-0656",
      "created_at": "2025-06-23T10:45:20.855049",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8474,
      "client_name": "ANDRES RAFAEL RAMOS VILLAFRANCA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Julia",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128390335",
      "client_email": "ANDRESRAMOS51@GMAIL.COM",
      "address": "LA JULIA URBANIZACION SALTO ANGEL DE LOS PINOS 46",
      "client_identification": "V4616428",
      "nap_box_name": "256",
      "created_at": "2025-06-23T12:07:03.332043",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8475,
      "client_name": "SILVIO ORLANDO PADRON GARCIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "San Pablo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144619419",
      "client_email": "ORLANDO_PADRON@GMAIL.COM",
      "address": "SAN PABLO AVENIDA PRINCIPAL CASA # 22",
      "client_identification": "V4230409",
      "nap_box_name": "CTO-00192",
      "created_at": "2025-06-23T16:50:14.684134",
      "service_detail": {
        "id": 9060,
        "ip": "10.15.74.2",
        "mac": "QXTLCB1A6C31",
        "serial": "QXTLCB1A6C31",
        "queue": "queue1",
        "interface": "VLAN224_SAN_PABLO_OLT1",
        "created_at": "2025-06-23T17:00:19.804394",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8476,
      "client_name": "PATRICIA BRUNA DURIGON CALLES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "San Pablo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243004423",
      "client_email": "BRUNO01082006@GMAIL.COM",
      "address": "URBANIZACION VALLE PARAISO CALLE 3 CASA # 13 SAN PABLO",
      "client_identification": "V7254632",
      "nap_box_name": "CTO-0643",
      "created_at": "2025-06-23T20:38:44.237797",
      "service_detail": {
        "id": 11461,
        "ip": "10.15.75.2",
        "mac": "QXTLCBC4F6FD",
        "serial": "QXTLCBC4F6FD",
        "queue": null,
        "interface": "VLAN227_V_PARAISO_OLT1",
        "created_at": "2026-02-04T09:29:54.797353",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8477,
      "client_name": "IL DOLCE PIACERE CA",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "San Pablo",
      "plan": {
        "id": 36,
        "name": "RECURRENTE PYME PLAN 650M",
        "cost": "70.18",
        "code": "FOP650M",
        "profile": "650M/650M"
      },
      "client_mobile": "04128154116",
      "client_email": "ILDOLCEPIACERE21@GMAIL.COM",
      "address": "AV PRINCIPAL DE SAN PABLO C.C RESIDENCIAL MILAN PLAZA LOCAL 4",
      "client_identification": "J506448491",
      "nap_box_name": "144",
      "created_at": "2025-06-24T14:04:45.499844",
      "service_detail": {
        "id": 9981,
        "ip": "10.15.147.2",
        "mac": "QXTLCBBDAF7D",
        "serial": "QXTLCBBDAF7D",
        "queue": null,
        "interface": "VLAN224_SAN_PABLO_OLT1",
        "created_at": "2025-11-11T12:43:30.041246",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8478,
      "client_name": "ADONIS ORLANDO JOSE COLMENARES LOPEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243173760",
      "client_email": "LANNYLOPEZ604@GMAIL.COM",
      "address": "CALLE 10 CASA 616-A SECTOR MATA CABALLO ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V21466050",
      "nap_box_name": "CTO-00569",
      "created_at": "2025-06-24T17:41:47.469580",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8479,
      "client_name": "ANGELO GABRIEL BERNAL MENA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "San Pablo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04122982768",
      "client_email": "ABMPERIODISTA@GMAIL.COM",
      "address": "PARQUE RESIDENCIAL CAMPO ALEGRE EDIFICIO 12 APARTAMENTO  12-22 SAN PABLO",
      "client_identification": "V25527337",
      "nap_box_name": "CTO-VA",
      "created_at": "2025-06-24T17:46:41.310059",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8480,
      "client_name": "DANIELA ANDREINA ROMERO MORA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Valle Paraiso",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04242052052",
      "client_email": "IVANROMERO.BRI@GMAIL.COM",
      "address": "VALLE PARAISO MANZANA 3 CASA 17 SAN PABLO",
      "client_identification": "V20108051",
      "nap_box_name": "CTO-0643",
      "created_at": "2025-06-24T18:30:50.543271",
      "service_detail": {
        "id": 9073,
        "ip": "10.15.76.2",
        "mac": "QXTLCBE29421",
        "serial": "QXTLCBE29421",
        "queue": "queue1",
        "interface": "VLAN227_V_PARAISO_OLT1",
        "created_at": "2025-06-25T11:03:32.548554",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8481,
      "client_name": "GABRIELA CAROLINA AREVALO BRITO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04125325590",
      "client_email": "GABRIELAAREVALO42@GMAIL.COM",
      "address": "MATA CABALLO AV 2 TETRA 524-C TURMERO ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V26535769",
      "nap_box_name": "CTO-00310",
      "created_at": "2025-06-24T19:32:48.528759",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8482,
      "client_name": "EMILI MERCEDES LOPEZ CEBALLOS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Antigua Hacienda De Paya",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04142806072",
      "client_email": "MILYYLOPEZ13@GMAL.COM",
      "address": "CALLEJON LIM CASA NRO 6 ANTIGUA HACIENDA DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V30327708",
      "nap_box_name": "453",
      "created_at": "2025-06-24T19:44:02.624082",
      "service_detail": {
        "id": 9065,
        "ip": "10.15.105.2",
        "mac": "QXTLCBE30F50",
        "serial": "QXTLCBE30F50",
        "queue": "queue1",
        "interface": "VLAN202_AHP_OLT1",
        "created_at": "2025-06-24T20:40:50.836365",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8483,
      "client_name": "GENNY CAROLINA NIEVES HERNANDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Bosque",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243627348",
      "client_email": "NIEVESGENNY@GMAIL.COM",
      "address": "CALE JOSE ANTONIO PAEZ EL BOSQUE ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V9653873",
      "nap_box_name": "CTO-00241",
      "created_at": "2025-06-24T19:58:20.759827",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8484,
      "client_name": "BETSY LORENA PAZ ESCOBAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243756513",
      "client_email": "LORENAPAZ_747@GMAIL.COM",
      "address": "CALLE 07 CASA NRO O1 RIO SECO ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V19111081",
      "nap_box_name": "CTO-00408",
      "created_at": "2025-06-24T20:11:02.476804",
      "service_detail": {
        "id": 10895,
        "ip": "10.15.107.2",
        "mac": "QXTLCB81D4C4",
        "serial": "QXTLCB81D4C4",
        "queue": null,
        "interface": "VLAN251_RIO_SECO",
        "created_at": "2025-12-23T12:35:36.888846",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8485,
      "client_name": "MARIA JESUS MORALES MONROY",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Payita",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04123352855",
      "client_email": "MARIAJESUSMORALESMONROY@GMAIL.COM",
      "address": "CALLEJON ROMERO CASA NRO 56 PAYITA ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V26793051",
      "nap_box_name": "CTO - 1028",
      "created_at": "2025-06-24T20:23:47.114407",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8487,
      "client_name": "JOSE ANTONIO ECHEZURIA RIVAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Simon Bolivar",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04169292398",
      "client_email": "ANTONIOECHEZURIA@GMAIL.COM",
      "address": "CALLE 5 CASA NRO 30 SIMON BOLIVAR TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V11409713",
      "nap_box_name": "CTO-00001",
      "created_at": "2025-06-25T11:15:03.390819",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8489,
      "client_name": "EDGARD ALEXANDER HERNANDEZ SILVA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04127763640",
      "client_email": "EDGARDHERNANDEZ2105@GMAIL.COM",
      "address": "EDIFICIO LOS NISPEROS TORRE A PISO 10 APARTAMENTO 103",
      "client_identification": "V28025396",
      "nap_box_name": "TORRE A EDIF LOS NISPEROS",
      "created_at": "2025-06-25T13:17:14.892082",
      "service_detail": {
        "id": 9076,
        "ip": "10.15.142.2",
        "mac": "QXTLCBA59C29",
        "serial": "QXTLCBA59C29",
        "queue": "queue1",
        "interface": "VLAN272_EDIF_NISPEROS_OLT3",
        "created_at": "2025-06-25T18:43:11.120857",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8490,
      "client_name": "KELLY MARIAN NIEVES VIERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Vallecito",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144079095",
      "client_email": "KELLYNIEVES59018@GMAIL.COM",
      "address": "ROSARIO DE PAYA SECTOR VALLECITO CALLE LOS NARANJOS CASA NRO44",
      "client_identification": "V27048997",
      "nap_box_name": "CTO-00082",
      "created_at": "2025-06-25T14:31:08.994642",
      "service_detail": {
        "id": 9131,
        "ip": "10.15.150.2",
        "mac": "QXTLCB848772",
        "serial": "QXTLCB848772",
        "queue": "queue1",
        "interface": "VLAN258_VALLECITO",
        "created_at": "2025-07-02T07:46:57.275196",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8491,
      "client_name": "JORGE  ALBERTO MARTINEZ LIENDO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04145998098",
      "client_email": "MARTINEZJ2362@GMAIL.COM",
      "address": "AV NEGRO PRIMERO CASA NRO 10. CASCO DE TURMERO",
      "client_identification": "V7235563",
      "nap_box_name": "CTO-00590",
      "created_at": "2025-06-25T14:50:24.010693",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8492,
      "client_name": "LEYCASTER ALEJANDRO PEREZ CRESPO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "El Nispero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04125002454",
      "client_email": "LEYCASTER@GMAIL.COM",
      "address": "URBANIZACION LOS NISPEROS 2DA ETAPA CASA 86",
      "client_identification": "V17575918",
      "nap_box_name": "53",
      "created_at": "2025-06-25T15:00:57.219653",
      "service_detail": {
        "id": 9078,
        "ip": "10.15.144.2",
        "mac": "QXTLCB608A6B",
        "serial": "QXTLCB608A6B",
        "queue": "queue1",
        "interface": "VLAN200_OLTs",
        "created_at": "2025-06-25T21:46:47.758261",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8493,
      "client_name": "CAROLINA RODRIGUEZ ALVES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "San Pablo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243680773",
      "client_email": "CAROLA200814@GMAIL.COM",
      "address": "AVENIDAD FERGUS EDIFICIO CAMELOT SUITES PISO PB APARTAMENTO C1 SAN PABLO",
      "client_identification": "V17571904",
      "nap_box_name": "CTO-00413",
      "created_at": "2025-06-25T20:27:16.528281",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8498,
      "client_name": "MARIA SOLEDAD BLANCO SILVA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman de Guere",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128951661",
      "client_email": "MARIASBS039@GMAIL.COM",
      "address": "CALLE MIRANDA CASA 33 19 DE ABRIL",
      "client_identification": "V9434385",
      "nap_box_name": "184",
      "created_at": "2025-06-26T00:50:45.076883",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8501,
      "client_name": "JOSE ANGEL HERRERA FLORES",
      "client_type_name": "EMPLEADO",
      "client_subdivision": "ACTIVO_EMPLEADO",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "La Macarena",
      "plan": {
        "id": 78,
        "name": "Plan empleado 80MB",
        "cost": "0.00",
        "code": "FO-80M",
        "profile": "80M/80M"
      },
      "client_mobile": "04128380219",
      "client_email": "JOSEANGELHERRERAFLORES4@GMAIL.COM",
      "address": "CALLE 11 CASA NRO 19 LA MACARENA II TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V29527325",
      "nap_box_name": "80 DOS",
      "created_at": "2025-06-26T17:56:11.606064",
      "service_detail": {
        "id": 12900,
        "ip": "10.15.146.2",
        "mac": "A8:BF:3C:62:4D:09",
        "serial": "OEMT3C624D0A",
        "queue": null,
        "interface": "VLAN112_LA_MACARENA_ZTE",
        "created_at": "2026-08-22T16:12:54.528912",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8502,
      "client_name": "JHOSUE ANTONIO GONZALEZ FLORES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Guerito",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121766322",
      "client_email": "ZULYFLORES7619@GMAIL.COM",
      "address": "CALLE BOLIVAR CASA 119 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V30555963",
      "nap_box_name": "CTO - 940",
      "created_at": "2025-06-26T18:11:19.317093",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8503,
      "client_name": "ZULAY CAROLINA BARRIOS YANEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Polvorin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243144068",
      "client_email": "ALEXGABRIEL3000@GMAIL.COM",
      "address": "AVENIDA POLVORIN CASA PARCELA # 11 SECTOR LOS HICACOS TURMERO",
      "client_identification": "V13553896",
      "nap_box_name": "CTO-1111",
      "created_at": "2025-06-26T21:04:10.965441",
      "service_detail": {
        "id": 9132,
        "ip": "10.15.154.2",
        "mac": "QXTLCBDB10E6",
        "serial": "QXTLCBDB10E6",
        "queue": "queue1",
        "interface": "VLAN282_ZONA_AGRARIA",
        "created_at": "2025-07-02T07:52:42.448485",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8505,
      "client_name": "LISMAR MILANULI MENDEZ MARCANO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Ppal Paya",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243086899",
      "client_email": "LISMARMENDEZ396@GMAIL.COM",
      "address": "LOS GUERREROS DE CHAVEZ CASA NRO 48 ROSARIO DE PAYA",
      "client_identification": "V25662243",
      "nap_box_name": "ce-968",
      "created_at": "2025-06-27T08:56:39.056987",
      "service_detail": {
        "id": 12831,
        "ip": "10.15.156.2",
        "mac": "68:9F:F0:2A:9B:6F",
        "serial": "ZXICCDFF66F0",
        "queue": null,
        "interface": "VLAN271_DIOS_ES_MI_REFUGIO_OLT1",
        "created_at": "2026-08-13T16:53:29.669629",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8506,
      "client_name": "JUSMER ANAIS GIL MARTINEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Payita",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144902870",
      "client_email": "JUSMER_GIL@GMAIL.COM",
      "address": "CALLE PRINCIPAL CASA N89 PAYITA",
      "client_identification": "V19833091",
      "nap_box_name": "CTO - 1023",
      "created_at": "2025-06-27T16:07:05.756178",
      "service_detail": {
        "id": 9120,
        "ip": "10.15.157.2",
        "mac": "QXTLCB825076",
        "serial": "QXTLCB825076",
        "queue": "queue1",
        "interface": "VLAN284_PAYITA",
        "created_at": "2025-07-01T13:02:31.609628",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8509,
      "client_name": "LUIS ENRIQUE CASTELLANOS BONILLA",
      "client_type_name": "EMPLEADO",
      "client_subdivision": "CANCELADO_EMPLEADO",
      "status_name": "Cancelado",
      "cycle": 25,
      "migrate": false,
      "sector_name": "Valle Fresco",
      "plan": {
        "id": 78,
        "name": "Plan empleado 80MB",
        "cost": "0.00",
        "code": "FO-80M",
        "profile": "80M/80M"
      },
      "client_mobile": "04243703599",
      "client_email": "LUISBONILLA5021@GMAIL.COM",
      "address": "MANZANA 25 CASA N 3 URB VALLE FRESCO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V19654719",
      "nap_box_name": "CTO - 981",
      "created_at": "2025-06-27T21:05:29.501924",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8511,
      "client_name": "LUIS ALEJANDRO  HIDALGO FLORES",
      "client_type_name": "EMPLEADO",
      "client_subdivision": "ACTIVO_EMPLEADO",
      "status_name": "Activo",
      "cycle": 25,
      "migrate": false,
      "sector_name": "Simon Bolivar",
      "plan": {
        "id": 78,
        "name": "Plan empleado 80MB",
        "cost": "0.00",
        "code": "FO-80M",
        "profile": "80M/80M"
      },
      "client_mobile": "04128150454",
      "client_email": "luishflores2609@gmail.com",
      "address": "CALLE 10 CASA NRO 62 BARRIO SIMON BOLIVAR TURMERO",
      "client_identification": "V30148131",
      "nap_box_name": "CTO-00017 C/5 JABILLAR",
      "created_at": "2025-06-27T21:11:35.224357",
      "service_detail": {
        "id": 12375,
        "ip": "172.19.49.2",
        "mac": "TPLGF5CB0336",
        "serial": "TPLGF5CB0336",
        "queue": null,
        "interface": "VLAN128_SIMON_BOLIVAR_ZTE",
        "created_at": "2026-04-20T12:16:43.393489",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8528,
      "client_name": "MAGALI MARGARITA CHACON TORRES",
      "client_type_name": "GRATIS",
      "client_subdivision": "ACTIVO_GRATIS",
      "status_name": "Activo",
      "cycle": 25,
      "migrate": false,
      "sector_name": "Brisas de Paya",
      "plan": {
        "id": 86,
        "name": "PLAN RECURRENTE 80M GRATIS",
        "cost": "0.00",
        "code": "FO-G80",
        "profile": "80M/80M"
      },
      "client_mobile": "04121484158",
      "client_email": "CHACONMAGALI@GMAIL.COM",
      "address": "SECTOR BRISAS DE PAYA AV PRINCIPAL 1ERA CALLE CASA #2",
      "client_identification": "V4466888",
      "nap_box_name": "367",
      "created_at": "2025-06-28T10:02:04.788894",
      "service_detail": {
        "id": 9100,
        "ip": "172.30.29.2",
        "mac": "GPON0097AEF6",
        "serial": "GPON0097AEF6",
        "queue": "queue1",
        "interface": "VLAN241_BRISAS",
        "created_at": "2025-06-28T10:07:03.865715",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8529,
      "client_name": "EFREN AUGUSTO RODRIGUEZ MARTINEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Laguna Plaza",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04261354046",
      "client_email": "EFRENAUGUSTO@GMAIL.COM",
      "address": "DIRECCIÓN: CALLE NEGRO PRIMERO URBANIZACIÓN LAGUNA PLAZA SECTOR 3 EDIFICIO 19 PB-3",
      "client_identification": "V3744089",
      "nap_box_name": "1",
      "created_at": "2025-06-28T15:37:52.322597",
      "service_detail": {
        "id": 9101,
        "ip": "10.15.159.2",
        "mac": "QXTLCBC7CAD6",
        "serial": "QXTLCBC7CAD6",
        "queue": "queue1",
        "interface": "VLAN216_LAGUNA_PLAZA_OLT1",
        "created_at": "2025-06-28T22:54:58.371970",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8530,
      "client_name": "GENESIS ADRIANA ARRIETA ROMERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Saman Tarazonero I",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04261395111",
      "client_email": "Genesisadrianaarrietaromero@gmail.com",
      "address": "CALLE 2 CASANRO 35 SAMAN TARAZONERO I TURMERO ARAGUA ZONZ POSTAL 2115",
      "client_identification": "V20989836",
      "nap_box_name": "670",
      "created_at": "2025-06-28T18:04:01.411078",
      "service_detail": {
        "id": 9111,
        "ip": "10.15.160.2",
        "mac": "QXTLCB281771",
        "serial": "QXTLCB281771",
        "queue": "queue1",
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2025-06-30T17:48:07.601895",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8531,
      "client_name": "GILYESSMAR FABIOLA ANDRADE CARRILLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "San Pablo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243487136",
      "client_email": "GILYESSMAR@GMAIL.COM",
      "address": "AV. PRINCIPAL SAN PABLO RESIDENCIA CAMPO ALEGRE TORRE 12 APARTAMENTO 24",
      "client_identification": "V25464700",
      "nap_box_name": "CTO-VA",
      "created_at": "2025-06-28T18:55:48.056651",
      "service_detail": {
        "id": 9110,
        "ip": "10.15.161.2",
        "mac": "QXTLCB92C21B",
        "serial": "QXTLCB92C21B",
        "queue": "queue1",
        "interface": "VLAN224_SAN_PABLO_OLT1",
        "created_at": "2025-06-30T17:45:39.037157",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8532,
      "client_name": "ANTHONY REYES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Macaro",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243144832",
      "client_email": "BREYESVE@SISPROTGF.COM",
      "address": "MI CASA",
      "client_identification": "V29808281",
      "nap_box_name": "184",
      "created_at": "2025-06-29T03:18:03.921619",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8533,
      "client_name": "VALENTINA ISABELLA DEL CARMEN HERNANDEZ PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "La Floresta",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04145980598",
      "client_email": "VALENTINAISABELLAHERNANDEZ@GMAIL.COM",
      "address": "URBANIZACION LA FLORESTA CALLE 2 CASA # 21 TURMERO",
      "client_identification": "V25880525",
      "nap_box_name": "32 TRES",
      "created_at": "2025-06-29T16:45:22.138020",
      "service_detail": {
        "id": 9105,
        "ip": "10.15.162.2",
        "mac": "QXTLCB1BD485",
        "serial": "QXTLCB1BD485",
        "queue": "queue1",
        "interface": "VLAN212_FLORESTA_OLT1",
        "created_at": "2025-06-30T07:47:51.694092",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8536,
      "client_name": "MIRTHA CAROLINA LOPEZ CASTILLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "SUSPENDIDO_RESIDENCIAL",
      "status_name": "Suspendido",
      "cycle": 1,
      "migrate": false,
      "sector_name": "San Pablo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243002385",
      "client_email": "MIRCA2264@GMAIL.COM",
      "address": "AV PRINCIPAL HARAS DE SAN PABLO CASA 3 TURMERO EDO ARAGUA",
      "client_identification": "V8732235",
      "nap_box_name": "247",
      "created_at": "2025-06-30T14:51:48.375875",
      "service_detail": {
        "id": 9122,
        "ip": "10.15.164.2",
        "mac": "QXTLCBE64CF7",
        "serial": "QXTLCBE64CF7",
        "queue": "queue1",
        "interface": "VLAN210_HSP_OLT1",
        "created_at": "2025-07-01T20:39:51.143680",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8537,
      "client_name": "YERITZA NATHALY INFANTE CARDOZO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243653193",
      "client_email": "YERITZA1703@GMAIL.COM",
      "address": "CALLE URDANETA CASA 97-1 SECTOR CASCO DE TURMERO",
      "client_identification": "V17789583",
      "nap_box_name": "CTO-00403",
      "created_at": "2025-06-30T15:44:11.841117",
      "service_detail": {
        "id": 9113,
        "ip": "10.15.165.2",
        "mac": "QXTLCB4A7DEB",
        "serial": "QXTLCB4A7DEB",
        "queue": "queue1",
        "interface": "VLAN200_OLTs",
        "created_at": "2025-06-30T20:17:25.035177",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8538,
      "client_name": "CLAUDIA ISABEL VALDEZ ALVAREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Edif. El Portal",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04147056728",
      "client_email": "CLAUDIA2062@GMAIL.COM",
      "address": "CALLE FERGUS EDIF TORRES D PISO 4 APTO 43 RESIDENCIAS EL PORTAL",
      "client_identification": "V5656951",
      "nap_box_name": "CTO - 1388",
      "created_at": "2025-06-30T16:24:43.287675",
      "service_detail": {
        "id": 9114,
        "ip": "10.15.166.2",
        "mac": "QXTLCB703DF5",
        "serial": "QXTLCB703DF5",
        "queue": "queue1",
        "interface": "VLAN224_SAN_PABLO_OLT1",
        "created_at": "2025-06-30T20:25:33.530638",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8539,
      "client_name": "JUAN JOSE GOMEZ MUÑOZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "San Pablo",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04166219179",
      "client_email": "JUANJOSEGOMEZ44@GMAIL.COM",
      "address": "URBANIZACION MARINA CARIBE CALLE GRADISCO ISABEL CASA # 37 TURMERO",
      "client_identification": "V13803989",
      "nap_box_name": "CTO-00285",
      "created_at": "2025-06-30T21:25:33.831668",
      "service_detail": {
        "id": 9125,
        "ip": "10.15.167.2",
        "mac": "QXTLCB54C06E",
        "serial": "QXTLCB54C06E",
        "queue": "queue1",
        "interface": "VLAN287_M_CARIBE",
        "created_at": "2025-07-01T20:54:53.961450",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8540,
      "client_name": "CARLOS EDUARDO PEROZO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "La Orquidea",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04142601584",
      "client_email": "CARLOSEPEROZO18@GMAIL.COM",
      "address": "SECTOR LA ORQUIDEA, CALLE 4, CASA NRO 84, ROSARIO DE PAYA, ARAGUA, ZONA POSTAL 2115",
      "client_identification": "V18176832",
      "nap_box_name": "CTO-00306",
      "created_at": "2025-06-30T22:42:46.699526",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8541,
      "client_name": "REBECA ELIZABETH GOMEZ ACOSTA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "El Macaro",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243697376",
      "client_email": "REBECAGOMEZ975@GMAIL.COM",
      "address": "URB TAGUAPIRE, CALLE 3, APTO 82, EL MACARO, ARAGUA, ZONA POSTAL 2115",
      "client_identification": "V12358047",
      "nap_box_name": "CTO-00386",
      "created_at": "2025-06-30T23:08:19.099038",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8542,
      "client_name": "LILIBE NAZARET LOAIZA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Polvorin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04127766788",
      "client_email": "LILIBENAILS1@GMAIL.COM",
      "address": "CALLE SANTA EDUVIGES, CASA NRO 01, POLVORIN, ARAGUA, ZONA POSTAL 2115",
      "client_identification": "V16690586",
      "nap_box_name": "CTO - 999",
      "created_at": "2025-06-30T23:23:01.614096",
      "service_detail": {
        "id": 9135,
        "ip": "10.15.170.2",
        "mac": "QXTLCB37DD4F",
        "serial": "QXTLCB37DD4F",
        "queue": "queue1",
        "interface": "VLAN280_POLVORIN",
        "created_at": "2025-07-02T15:43:51.599634",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8543,
      "client_name": "LUISANGELIS MERCEDES GOMEZ MANZANILLA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman de Guere",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243006353",
      "client_email": "LUISANGELISGOMEZ9@GMAIL.COM",
      "address": "CALLE LINARES ALCANTARA, CASA NRO 16, SECTOR SAMAN DE GUERE, EL MACARO, ARAGUA, ZONA POSTAL 2115",
      "client_identification": "V30005385",
      "nap_box_name": "CTO - 1359",
      "created_at": "2025-06-30T23:37:15.721051",
      "service_detail": {
        "id": 9144,
        "ip": "10.15.177.2",
        "mac": "MONU003CCAF1",
        "serial": "MONU003CCAF1",
        "queue": "queue1",
        "interface": "VLAN122_SAMAN_GUERE",
        "created_at": "2025-07-04T12:24:17.755998",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8544,
      "client_name": "JOSE NERIO MENDEZ CAMACHO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "La Concepcion",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124599892",
      "client_email": "amandalolymarpen@gmail.com",
      "address": "URB VISTA HERMOSA CALLE D, CASA D12, CALLE CONCEPCION, SECTOR LA JULIA, ZONA POSTAL 2115",
      "client_identification": "V15032487",
      "nap_box_name": "503",
      "created_at": "2025-06-30T23:42:37.797269",
      "service_detail": {
        "id": 9152,
        "ip": "10.15.60.2",
        "mac": "QXTLCB247AE0",
        "serial": "QXTLCB247AE0",
        "queue": "queue1",
        "interface": "VLAN111_CONCEPCION",
        "created_at": "2025-07-06T16:34:25.206309",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8545,
      "client_name": "YESSICA YOSELIN MARTINEZ HERNANDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Esperanza",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128524277",
      "client_email": "YACARAMHERNANDEZ.22@GMAIL.COM",
      "address": "URB LA ESPERANZA, CALLE 3, CASA NRO 21, EL MACARO, TURMERO, ARAGUA, ZONA POSTAL 2115",
      "client_identification": "V18230749",
      "nap_box_name": "CTO-00462",
      "created_at": "2025-06-30T23:50:36.100280",
      "service_detail": {
        "id": 12786,
        "ip": "10.15.172.2",
        "mac": "ZT:EG:CE:83:B4:ED",
        "serial": "ZTEGCE83B4ED",
        "queue": null,
        "interface": "VLAN137_LA_ESPERANZA_OLT_ZTE",
        "created_at": "2026-08-03T11:33:35.939770",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8546,
      "client_name": "MARIA ALEJANDRA BORGES PENA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Vallecito",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04127760981",
      "client_email": "EDECIAPE31@GMAIL.COM",
      "address": "CALLE EL CUJI CASA NRO 12 SECTOR VALLECITO ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V18975302",
      "nap_box_name": "CTO - 81",
      "created_at": "2025-06-30T23:55:50.383517",
      "service_detail": {
        "id": 9126,
        "ip": "10.15.173.2",
        "mac": "QXTLCB75F101",
        "serial": "QXTLCB75F101",
        "queue": "queue1",
        "interface": "VLAN258_VALLECITO",
        "created_at": "2025-07-01T20:55:12.024270",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8547,
      "client_name": "KEMDHERLITH ORLMARYS PEREZ RIVAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04123505268",
      "client_email": "PKEMDHERLITH@GMAIL.COM",
      "address": "CALLE 12, CASA NRO 91, SECTOR LA CASONA II, LA JULIA, TURMERO, ARAGUA, ZONA POSTAL 2115",
      "client_identification": "V29581386",
      "nap_box_name": "CTO-00089",
      "created_at": "2025-06-30T23:59:50.025251",
      "service_detail": {
        "id": 12602,
        "ip": "10.15.174.2",
        "mac": "ZI:CG:CB:82:E8:77",
        "serial": "ZICGCB82E877",
        "queue": null,
        "interface": "VLAN110_CASONA_2",
        "created_at": "2026-06-10T13:33:01.243335",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8548,
      "client_name": "JUAN MANUEL CORDERO MILANO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243363681",
      "client_email": "JUANCORDERO96@GMAIL.COM",
      "address": "CALLE FERGUS EDIFICIO TORREÓN TORRE B PISO 1 APARTAMENTO 14",
      "client_identification": "V8730549",
      "nap_box_name": "1",
      "created_at": "2025-07-01T02:02:34.722058",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8549,
      "client_name": "JUAN MANUEL CORDERO MILANO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243363681",
      "client_email": "JUANCORDERO96@GMAIL.COM",
      "address": "CALLE FERGUS EDIFICIO TORREÓN TORRE B PISO 1 APARTAMENTO 14",
      "client_identification": "V8730549",
      "nap_box_name": "1",
      "created_at": "2025-07-01T02:09:10.548873",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8550,
      "client_name": "JUAN MANUEL CORDERO MILANO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243363681",
      "client_email": "JUANCORDERO96@GMAIL.COM",
      "address": "CALLE FERGUS EDIFICIO TORREÓN TORRE B PISO 1 APARTAMENTO 14",
      "client_identification": "V8730549",
      "nap_box_name": "1",
      "created_at": "2025-07-01T02:24:27.406038",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8551,
      "client_name": "JUAN MANUEL CORDERO MILANO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243363681",
      "client_email": "JUANCORDERO96@GMAIL.COM",
      "address": "CALLE FERGUS EDIFICIO TORREÓN TORRE B PISO 1 APARTAMENTO 14",
      "client_identification": "V8730549",
      "nap_box_name": "1",
      "created_at": "2025-07-01T02:37:07.571045",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8552,
      "client_name": "JUAN MANUEL CORDERO MILANO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243363681",
      "client_email": "JUANCORDERO96@GMAIL.COM",
      "address": "CALLE FERGUS EDIFICIO TORREÓN TORRE B PISO 1 APARTAMENTO 14",
      "client_identification": "V8730549",
      "nap_box_name": "1",
      "created_at": "2025-07-01T12:08:56.231409",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8553,
      "client_name": "JUAN MANUEL CORDERO MILANO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243363681",
      "client_email": "JUANCORDERO96@GMAIL.COM",
      "address": "CALLE FERGUS EDIFICIO TORREÓN TORRE B PISO 1 APARTAMENTO 14",
      "client_identification": "V8730549",
      "nap_box_name": "1",
      "created_at": "2025-07-01T12:10:40.257227",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8554,
      "client_name": "JUAN MANUEL CORDERO MILANO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243363681",
      "client_email": "JUANCORDERO96@GMAIL.COM",
      "address": "CALLE FERGUS EDIFICIO TORREÓN TORRE B PISO 1 APARTAMENTO 14",
      "client_identification": "V8730549",
      "nap_box_name": "1",
      "created_at": "2025-07-01T12:18:26.891331",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8555,
      "client_name": "JUAN MANUEL CORDERO MILANO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243363681",
      "client_email": "JUANCORDERO96@GMAIL.COM",
      "address": "CALLE FERGUS EDIFICIO TORREÓN TORRE B PISO 1 APARTAMENTO 14",
      "client_identification": "V8730549",
      "nap_box_name": "1",
      "created_at": "2025-07-01T14:43:23.482410",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8556,
      "client_name": "JUAN MANUEL CORDERO MILANO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243363681",
      "client_email": "JUANCORDERO96@GMAIL.COM",
      "address": "CALLE FERGUS EDIFICIO TORREÓN TORRE B PISO 1 APARTAMENTO 14",
      "client_identification": "V8730549",
      "nap_box_name": "1",
      "created_at": "2025-07-01T14:54:22.189737",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8557,
      "client_name": "JUAN MANUEL CORDERO MILANO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243363681",
      "client_email": "JUANCORDERO96@GMAIL.COM",
      "address": "CALLE FERGUS EDIFICIO TORREÓN TORRE B PISO 1 APARTAMENTO 14",
      "client_identification": "V8730549",
      "nap_box_name": "1",
      "created_at": "2025-07-01T14:57:01.540920",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8559,
      "client_name": "JOSE LUIS LOPEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Valle Fresco",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243606702",
      "client_email": "PUMALOPEZ98@GMAIL.COM",
      "address": "CALLE 02 CASA 6 VALLE FRESCO TURMERO",
      "client_identification": "V10979430",
      "nap_box_name": "CE - 934",
      "created_at": "2025-07-01T16:03:59.684765",
      "service_detail": {
        "id": 9252,
        "ip": "10.15.176.2",
        "mac": "QXTLCB1D57B4",
        "serial": "QXTLCB1D57B4",
        "queue": "queue1",
        "interface": "VLAN270_VALLE_FRESCO_OLT3",
        "created_at": "2025-07-23T15:11:44.592611",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8561,
      "client_name": "LEONEL OSCAR OVALLE MOLEIRO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "San Pablo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04145184274",
      "client_email": "LEOXOM@GMAIL.COM",
      "address": "URB SAN PABLO TRANSVERSAL 4 TURMERO",
      "client_identification": "V15334473",
      "nap_box_name": "CTO-0637",
      "created_at": "2025-07-01T16:23:03.216964",
      "service_detail": {
        "id": 9147,
        "ip": "10.15.163.2",
        "mac": "QXTLCBDD073F",
        "serial": "QXTLCBDD073F",
        "queue": "queue1",
        "interface": "VLAN224_SAN_PABLO_OLT1",
        "created_at": "2025-07-05T11:51:52.094368",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8564,
      "client_name": "RAMON ESTEBAN APONTE SUAREZ",
      "client_type_name": "PYME",
      "client_subdivision": "CANCELADO_PYME",
      "status_name": "Cancelado",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04124561285",
      "client_email": "STEVEN.APONTE.SUAREZ@GMAIL.COM",
      "address": "TURMERO CALLE MIRANDA CC LORENZO OFICINA 3",
      "client_identification": "V19833686",
      "nap_box_name": "CAJA NAP BICENTENARIO",
      "created_at": "2025-07-01T18:47:55.853908",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8567,
      "client_name": "LIDIA DEL ALBA MENDOZA LINARES",
      "client_type_name": "EMPLEADO",
      "client_subdivision": "CANCELADO_EMPLEADO",
      "status_name": "Cancelado",
      "cycle": 25,
      "migrate": false,
      "sector_name": "La Casona I",
      "plan": {
        "id": 78,
        "name": "Plan empleado 80MB",
        "cost": "0.00",
        "code": "FO-80M",
        "profile": "80M/80M"
      },
      "client_mobile": "04121484163",
      "client_email": "LIDIADELALBAMENDOZALINARES@GMAIL.COM",
      "address": "AV 8 CASA NRO 16 URB LA CASONA 1 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V26055433",
      "nap_box_name": "139",
      "created_at": "2025-07-03T13:30:08.092566",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8568,
      "client_name": "OSNY NADALES VELASQUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Leocolbo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04262437194",
      "client_email": "OSNYNA86@GMAIL.COM",
      "address": "LEOCOLBO CALLE B CASA 20",
      "client_identification": "V19638520",
      "nap_box_name": "CTO-00371",
      "created_at": "2025-07-05T07:28:43.314459",
      "service_detail": {
        "id": 11800,
        "ip": "10.15.15.2",
        "mac": "VSOL00533779",
        "serial": "VSOL00533779",
        "queue": null,
        "interface": "VLAN144_LEOCOLBO",
        "created_at": "2026-02-27T11:31:06.071451",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8569,
      "client_name": "FRANCISCO RAMON MOCADAN RAMIREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Narayola II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243703761",
      "client_email": "FRANCISCOMOCADAN@GMAIL.COM",
      "address": "URB NARAYOLA EDIF 1 PISO 2 APTO 22",
      "client_identification": "V16939881",
      "nap_box_name": "CTO-0521",
      "created_at": "2025-07-05T08:41:20.283968",
      "service_detail": {
        "id": 9149,
        "ip": "10.15.59.2",
        "mac": "QXTLCB9D3D77",
        "serial": "QXTLCB9D3D77",
        "queue": "queue1",
        "interface": "VLAN117_NARAYOLA",
        "created_at": "2025-07-05T14:00:00.744840",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8570,
      "client_name": "ROMEL ENRIQUE PEREZ MEJIAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Valle lindo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121487405",
      "client_email": "ROMELPEREZ370@GMAIL.COM",
      "address": "CALLE 7 CASA Nº 1 URB. VALLE LINDO TURMERO EDO-ARAGUA ZONA POSTAL 2115",
      "client_identification": "V25527269",
      "nap_box_name": "CTO-CE",
      "created_at": "2025-07-05T12:58:27.070157",
      "service_detail": {
        "id": 9148,
        "ip": "10.15.58.2",
        "mac": "QXTLCBB3C4AE",
        "serial": "QXTLCBB3C4AE",
        "queue": "queue1",
        "interface": "VLAN274_VALLELINDO",
        "created_at": "2025-07-05T13:50:50.751735",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8573,
      "client_name": "LINNE AVILA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "San Pablo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243144832",
      "client_email": "BREYESVE@GMAIL.COM",
      "address": "SAN PABLO",
      "client_identification": "V12171199",
      "nap_box_name": "2 DOS",
      "created_at": "2025-07-07T00:55:56.108806",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8578,
      "client_name": "EFRAIN ANGARITA SANTOS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Valle Fresco",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04125685656",
      "client_email": "ENFRAINANGARITASANTOS@GMAIL.COM",
      "address": "VALLE FRESCO MANZANA 11 CASA N-9",
      "client_identification": "V13311101",
      "nap_box_name": "CE - 932",
      "created_at": "2025-07-09T09:41:19.281964",
      "service_detail": {
        "id": 9154,
        "ip": "10.15.109.2",
        "mac": "QXTLCB7983C9",
        "serial": "QXTLCB7983C9",
        "queue": "queue1",
        "interface": "VLAN270_VALLE_FRESCO_OLT3",
        "created_at": "2025-07-09T12:14:16.292905",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8579,
      "client_name": "LUIS SABINO PINTO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Valle Paraiso",
      "plan": {
        "id": 43,
        "name": "RECURRENTE RESIDENCIAL PLAN 650M",
        "cost": "46.00",
        "code": "FOR650M",
        "profile": "650M/650M"
      },
      "client_mobile": "04144567521",
      "client_email": "GULOSABINO2004@GMAIL.COM",
      "address": "SAN PABLO , URBANIZACIÓN VILLA PARAÍSO CONJUNTO RESIDENCIAL RESIDENCIA JUAN PABLO 2DO MANZANA 8 CASA 11",
      "client_identification": "V12143735",
      "nap_box_name": "CE-00254",
      "created_at": "2025-07-09T09:49:53.733283",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8580,
      "client_name": "ENEIDA MARITZA BLANCO ESCORCHA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243065477",
      "client_email": "ENEIDAESCOR@GMAIL.COM",
      "address": "CASCO DE TURMERO CALLE SUCRE CASA N10",
      "client_identification": "V11051640",
      "nap_box_name": "103",
      "created_at": "2025-07-09T10:35:28.147216",
      "service_detail": {
        "id": 9155,
        "ip": "10.15.110.2",
        "mac": "QXTLCB9B458B",
        "serial": "QXTLCB9B458B",
        "queue": "queue1",
        "interface": "VLAN200_OLTs",
        "created_at": "2025-07-09T15:57:11.034919",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8581,
      "client_name": "KAREN GABRIELA BLANCO VIERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04169430005",
      "client_email": "WALEMENDEZ2020@GMAIL.COM",
      "address": "CASCO DE TURMERO CALLE CAMPO ELIAS CASA N 26-1",
      "client_identification": "V17969641",
      "nap_box_name": "CTO-00065",
      "created_at": "2025-07-09T12:57:53.311213",
      "service_detail": {
        "id": 9159,
        "ip": "10.15.11.2",
        "mac": "QXTLCBF867E6",
        "serial": "QXTLCBF867E6",
        "queue": "queue1",
        "interface": "VLAN200_OLTs",
        "created_at": "2025-07-10T07:46:34.104476",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8582,
      "client_name": "JULIO CESAR MANRIQUEZ RAMOS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04125336657",
      "client_email": "MANRIQUEZJULIO255@GMAIL.COM",
      "address": "CALLE MIRANDA CC GIUROS, PISO 2 OFICINA 25. CASCO DE TURMERO",
      "client_identification": "V10362113",
      "nap_box_name": "CE - 616",
      "created_at": "2025-07-09T14:59:38.632663",
      "service_detail": {
        "id": 11923,
        "ip": "10.15.63.2",
        "mac": "QXTLCB5AFFDC",
        "serial": "QXTLCB5AFFDC",
        "queue": null,
        "interface": "VLAN200_OLTs",
        "created_at": "2026-03-03T12:07:47.677955",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8583,
      "client_name": "WILFREDO RAMON RINCON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados III",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243370645",
      "client_email": "WILFRERINCON5@GMAIL.COM",
      "address": "CALLE 2 CASA NRO 9 PRADO III ROSARIO DE PAYA",
      "client_identification": "V7892122",
      "nap_box_name": "CTO - 1012",
      "created_at": "2025-07-09T15:45:04.369742",
      "service_detail": {
        "id": 9161,
        "ip": "10.15.66.2",
        "mac": "OEMT3C62077E",
        "serial": "OEMT3C62077E",
        "queue": "queue1",
        "interface": "VLAN236_PRADOS3",
        "created_at": "2025-07-10T07:53:01.207523",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8584,
      "client_name": "ALEXIS MIGUEL FERNANDEZ HERNANDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Dios Es Mi Refugio",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04149837012",
      "client_email": "CMARIELIS265@GMAIL.COM",
      "address": "SECTOR DIOS ES MI REFUGIO MANZANA 9 PARCELA 2 ROSARIO DE PAYA",
      "client_identification": "V11071950",
      "nap_box_name": "CE - 941",
      "created_at": "2025-07-09T17:53:37.038133",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8585,
      "client_name": "JULIET DEL CARMEN PEREZ PADRINO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona I",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243057917",
      "client_email": "PADRINOJULIET7@GMAIL.COM",
      "address": "CALLE 7 CASA 40 CASONA 1",
      "client_identification": "V32510406",
      "nap_box_name": "411",
      "created_at": "2025-07-09T18:46:24.881881",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8586,
      "client_name": "OSCAR JOSE FUNEZ FUNEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Vallecito",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04129374458",
      "client_email": "FUNEZOSCAR715@GMAIL.COM",
      "address": "PAYA SECTOR VALLECITO CALLE LOS NARANJOS CASA NÚMERO 50",
      "client_identification": "V11118831",
      "nap_box_name": "CTO - 84",
      "created_at": "2025-07-09T20:26:13.741652",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8587,
      "client_name": "ANTONIO JOSE LEON BLANCO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243163831",
      "client_email": "LEONANTONIOJOSE1959@GMAIL.COM",
      "address": "CALLE BOLÍVAR CASA #63-1 CASCO DE TURMERO",
      "client_identification": "V8727460",
      "nap_box_name": "CTO-00194",
      "created_at": "2025-07-09T20:27:10.552283",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8588,
      "client_name": "MONICA OROPEZA ACIEGO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Valle Paraiso",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04140537591",
      "client_email": "MONICAOROPEZA74@GMAIL.COM",
      "address": "AV 1 CASA NR 14 URBANIZACIÓN VALLE PARAÍSO CLL MANZANA 3",
      "client_identification": "V11979177",
      "nap_box_name": "CTO-0643",
      "created_at": "2025-07-09T20:41:29.450338",
      "service_detail": {
        "id": 9167,
        "ip": "10.15.82.2",
        "mac": "OEMT3C620C5E",
        "serial": "OEMT3C620C5E",
        "queue": "queue1",
        "interface": "VLAN227_V_PARAISO_OLT1",
        "created_at": "2025-07-10T08:13:56.925773",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8589,
      "client_name": "RAIZA PATRICIA ERIKA VASQUEZ CARRASQUERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "La Marcelota",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243696891",
      "client_email": "PROTOCOLOYCONTROL.RVASQUEZ@GMAIL.COM",
      "address": "CALLE PRINCESA DE LA MARCELOTA CASA 16 FRENTE LA PARED AMARILLA",
      "client_identification": "V18108177",
      "nap_box_name": "CTO - 1058",
      "created_at": "2025-07-09T22:22:36.273070",
      "service_detail": {
        "id": 9164,
        "ip": "10.15.78.2",
        "mac": "QXTLCB019D4D",
        "serial": "QXTLCB019D4D",
        "queue": "queue1",
        "interface": "VLAN281_MARCELOTA",
        "created_at": "2025-07-10T08:01:38.713418",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8590,
      "client_name": "REBECA YOHALI TARAZONA BLANCO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "1ro de Mayo Sur",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144608538",
      "client_email": "MATIZVERDE.99@GMAIL.COM",
      "address": "SECTOR 1ERO MAYO SUR CALLE MIGUEL RODRÍGUEZ CASA#5 ROSARIO DE PAYA",
      "client_identification": "V16099698",
      "nap_box_name": "CTO-00149",
      "created_at": "2025-07-09T22:59:13.170044",
      "service_detail": {
        "id": 9165,
        "ip": "10.15.79.2",
        "mac": "OEMT3C62073E",
        "serial": "OEMT3C62073E",
        "queue": "queue1",
        "interface": "VLAN261_1ERO_MAYO_ZTE",
        "created_at": "2025-07-10T08:03:50.850283",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8591,
      "client_name": "GLENDYS TERESA VIELMA LICON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "La Floresta",
      "plan": {
        "id": 19,
        "name": "RECURRENTE RESIDENCIAL PLAN 1GB",
        "cost": "74.70",
        "code": "FOR1GB",
        "profile": "1000M/1000M"
      },
      "client_mobile": "04243419378",
      "client_email": "VIELMALICONTERESA@GMAIL.COM",
      "address": "PARQUE RESIDENCIAL LA FLORESTA MUNICIPIO MARIÑO TURMERO EDO ARAGUA",
      "client_identification": "V23785973",
      "nap_box_name": "32 DOS",
      "created_at": "2025-07-10T08:56:31.594503",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8592,
      "client_name": "DUBRASKA ORAI MUNOZ RAMIREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Arturo Luis Berti",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04124571197",
      "client_email": "DUBRASKAMRAMIREZ@GMAIL.COM",
      "address": "TURMERO VÍA EL MACARO, URBANIZACIÓN ARTURO LUIS BERTI 3ERA CALLE CASA #410",
      "client_identification": "V19110622",
      "nap_box_name": "65",
      "created_at": "2025-07-10T09:58:40.500549",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8593,
      "client_name": "JACKSON JOSE PEREZ BORGES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124620888",
      "client_email": "JACKPE538@GMAIL.COM",
      "address": "ANTIGUA HACIENDA EL NÍSPERO EDIFICIO 21 PISO 01. APARTAMENTO 02. EZEQUIEL ZAMORA",
      "client_identification": "V17253538",
      "nap_box_name": "32 TRES",
      "created_at": "2025-07-10T11:30:17.228208",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8594,
      "client_name": "YELITZA NATHALY PALMA MOTA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243620433",
      "client_email": "YELITZAPALMA837@GMAIL.COM",
      "address": "ROSARIO DE PAYA SECTOR MATA CABALLO CALLE 7 APARTAMENTO 535-C",
      "client_identification": "V17976121",
      "nap_box_name": "CTO-00310",
      "created_at": "2025-07-10T12:01:51.535563",
      "service_detail": {
        "id": 9171,
        "ip": "10.15.85.2",
        "mac": "OEMT3C620B8A",
        "serial": "OEMT3C620B8A",
        "queue": "queue1",
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2025-07-10T14:46:29.334880",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8595,
      "client_name": "CHOYGU YELITZA ROJAS SEIJAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128938272",
      "client_email": "CHOYGUROJAS@GMAIL.COM",
      "address": "AV BOLÍVAR N18 MERCADO CAMPESINO FRENTE A LA PLAZA",
      "client_identification": "V15737411",
      "nap_box_name": "CTO-00194",
      "created_at": "2025-07-10T12:15:04.718150",
      "service_detail": {
        "id": 9172,
        "ip": "10.15.108.2",
        "mac": "QXTLCB356F6A",
        "serial": "QXTLCB356F6A",
        "queue": "queue1",
        "interface": "VLAN200_OLTs",
        "created_at": "2025-07-10T14:48:20.841601",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8596,
      "client_name": "ASAER ALBERTO ROMERO PINANGO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128150324",
      "client_email": "ASAERALBERTOROMEROPINANGO@GMAIL.COM",
      "address": "CASCO DE TURMERO CALLE MARIÑO TORRE PACASO CONSEJERÍA",
      "client_identification": "V8813837",
      "nap_box_name": "69",
      "created_at": "2025-07-10T12:16:25.040410",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8597,
      "client_name": "ASAER ALBERTO ROMERO PINANGO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128150324",
      "client_email": "ASAERALBERTOROMEROPINANGO@GMAIL.COM",
      "address": "CASCO DE TURMERO CALLE MARIÑO TORRE PACASO CONSEJERÍA",
      "client_identification": "V8813837",
      "nap_box_name": "69",
      "created_at": "2025-07-10T12:37:51.830002",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8598,
      "client_name": "MARIA GABRIELA RAMOS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Simon Bolivar",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04248282276",
      "client_email": "MARIAGABYRAMOS3@GMAIL.COM",
      "address": "SIMOn BOLIVAR CALLE 10 CASA 20",
      "client_identification": "V20758831",
      "nap_box_name": "CTO-00036",
      "created_at": "2025-07-10T13:27:59.892621",
      "service_detail": {
        "id": 9175,
        "ip": "10.15.95.2",
        "mac": "OEMT3C62030A",
        "serial": "OEMT3C62030A",
        "queue": "queue1",
        "interface": "VLAN128_SIMON_BOLIVAR_ZTE",
        "created_at": "2025-07-10T15:11:06.184702",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8599,
      "client_name": "ASAER ALBERTO ROMERO PINANGO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128150324",
      "client_email": "ASAERALBERTOROMEROPINANGO@GMAIL.COM",
      "address": "CASCO DE TURMERO CALLE MARIÑO TORRE PACASO CONSEJERÍA",
      "client_identification": "V8813837",
      "nap_box_name": "69",
      "created_at": "2025-07-10T13:31:16.587193",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8600,
      "client_name": "ASAER ALBERTO ROMERO PINANGO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128150324",
      "client_email": "ASAERALBERTOROMEROPINANGO@GMAIL.COM",
      "address": "CASCO DE TURMERO CALLE MARIÑO TORRE PACASO CONSEJERÍA",
      "client_identification": "V8813837",
      "nap_box_name": "69",
      "created_at": "2025-07-10T13:33:14.039972",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8601,
      "client_name": "ELIZABETH DEL CARMEN TORRES LANZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Salto Angel",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124389412",
      "client_email": "LILYTRABAJO23@GMAIL.COM",
      "address": "URBANIZACIÓN SALTO ANGEL CALLE LOS ROBLES NÚMERO 46",
      "client_identification": "V20990341",
      "nap_box_name": "CTO - 68",
      "created_at": "2025-07-10T13:50:39.832657",
      "service_detail": {
        "id": 9176,
        "ip": "10.15.96.2",
        "mac": "OEMT3C620922",
        "serial": "OEMT3C620922",
        "queue": "queue1",
        "interface": "VLAN121_S_ANGEL",
        "created_at": "2025-07-10T15:17:10.988281",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8602,
      "client_name": "ELIZABETH DEL CARMEN TORRES LANZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Salto Angel",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124389412",
      "client_email": "LILYTRABAJO23@GMAIL.COM",
      "address": "URBANIZACIÓN SALTO ANGEL CALLE LOS ROBLES NÚMERO 46",
      "client_identification": "V20990341",
      "nap_box_name": "CTO - 68",
      "created_at": "2025-07-10T13:54:49.955333",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8603,
      "client_name": "ELIZABETH DEL CARMEN TORRES LANZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Salto Angel",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124389412",
      "client_email": "LILYTRABAJO23@GMAIL.COM",
      "address": "URBANIZACIÓN SALTO ANGEL CALLE LOS ROBLES NÚMERO 46",
      "client_identification": "V20990341",
      "nap_box_name": "CTO - 68",
      "created_at": "2025-07-10T14:03:29.935697",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8604,
      "client_name": "ELIZABETH DEL CARMEN TORRES LANZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Salto Angel",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124389412",
      "client_email": "LILYTRABAJO23@GMAIL.COM",
      "address": "URBANIZACIÓN SALTO ANGEL CALLE LOS ROBLES NÚMERO 46",
      "client_identification": "V20990341",
      "nap_box_name": "CTO - 68",
      "created_at": "2025-07-10T14:29:29.730592",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8605,
      "client_name": "ELIZABETH DEL CARMEN TORRES LANZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Salto Angel",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124389412",
      "client_email": "LILYTRABAJO23@GMAIL.COM",
      "address": "URBANIZACIÓN SALTO ANGEL CALLE LOS ROBLES NÚMERO 46",
      "client_identification": "V20990341",
      "nap_box_name": "CTO - 68",
      "created_at": "2025-07-10T14:46:17.570311",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8606,
      "client_name": "MARIANELLA AULAR SARABIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Urb. Vista Hermosa La Julia",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144770633",
      "client_email": "MASMG5162@GMAIL.COM",
      "address": "URBANIZACIÓN VISTA HERMOSA, CALLE CONCEPCIÓN CASA D11 LA JULIA",
      "client_identification": "V6809594",
      "nap_box_name": "CTO-00586",
      "created_at": "2025-07-10T18:29:19.542850",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8607,
      "client_name": "MARIANELLA AULAR SARABIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Urb. Vista Hermosa La Julia",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144770633",
      "client_email": "MASMG5162@GMAIL.COM",
      "address": "URBANIZACIÓN VISTA HERMOSA, CALLE CONCEPCIÓN CASA D11 LA JULIA",
      "client_identification": "V6809594",
      "nap_box_name": "CTO-00586",
      "created_at": "2025-07-10T18:33:05.469266",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8608,
      "client_name": "MARIANELLA AULAR SARABIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Urb. Vista Hermosa La Julia",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144770633",
      "client_email": "MASMG5162@GMAIL.COM",
      "address": "URBANIZACIÓN VISTA HERMOSA, CALLE CONCEPCIÓN CASA D11 LA JULIA",
      "client_identification": "V6809594",
      "nap_box_name": "CTO-00586",
      "created_at": "2025-07-10T18:50:39.480098",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8609,
      "client_name": "MARIANELLA AULAR SARABIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Urb. Vista Hermosa La Julia",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144770633",
      "client_email": "MASMG5162@GMAIL.COM",
      "address": "URBANIZACIÓN VISTA HERMOSA, CALLE CONCEPCIÓN CASA D11 LA JULIA",
      "client_identification": "V6809594",
      "nap_box_name": "CTO-00586",
      "created_at": "2025-07-10T18:54:51.398049",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8610,
      "client_name": "MARIANELLA AULAR SARABIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Urb. Vista Hermosa La Julia",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144770633",
      "client_email": "MASMG5162@GMAIL.COM",
      "address": "URBANIZACIÓN VISTA HERMOSA, CALLE CONCEPCIÓN CASA D11 LA JULIA",
      "client_identification": "V6809594",
      "nap_box_name": "CTO-00586",
      "created_at": "2025-07-10T18:58:06.904952",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8611,
      "client_name": "JUDITH YANIRA JIMENEZ NINO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128831031",
      "client_email": "JUDITHJN019@GMAIL.COM",
      "address": "CALLE MARINO C.C CASA VIEJA LOCAL A11. CASCO DE TURMERO",
      "client_identification": "V10457699",
      "nap_box_name": "CTO-00256",
      "created_at": "2025-07-10T18:59:55.289596",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8612,
      "client_name": "JUDITH YANIRA JIMENEZ NINO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128831031",
      "client_email": "JUDITHJN019@GMAIL.COM",
      "address": "CALLE MARINO C.C CASA VIEJA LOCAL A11",
      "client_identification": "V10457699",
      "nap_box_name": "CTO-00256",
      "created_at": "2025-07-10T19:02:37.812939",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8613,
      "client_name": "MARIANELLA AULAR SARABIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Urb. Vista Hermosa La Julia",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144770633",
      "client_email": "MASMG5162@GMAIL.COM",
      "address": "URBANIZACIÓN VISTA HERMOSA, CALLE CONCEPCIÓN CASA D11 LA JULIA",
      "client_identification": "V6809594",
      "nap_box_name": "CTO-00586",
      "created_at": "2025-07-10T19:06:42.136959",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8614,
      "client_name": "JUDITH YANIRA JIMENEZ NINO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128831031",
      "client_email": "JUDITHJN019@GMAIL.COM",
      "address": "CALLE MARINO C.C CASA VIEJA LOCAL A11",
      "client_identification": "V10457699",
      "nap_box_name": "CTO-00256",
      "created_at": "2025-07-10T19:07:20.351008",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8615,
      "client_name": "JUDITH YANIRA JIMENEZ NINO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128831031",
      "client_email": "JUDITHJN019@GMAIL.COM",
      "address": "CALLE MARINO C.C CASA VIEJA LOCAL A11",
      "client_identification": "V10457699",
      "nap_box_name": "CTO-00256",
      "created_at": "2025-07-10T19:07:54.342287",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8616,
      "client_name": "KELVIS KENAY MARQUEZ LOPEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Valle Paraiso",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121479837",
      "client_email": "KENAYM368@GMAIL.COM",
      "address": "AV COLECTORA 29 CASA NR 26 URBANIZACIÓN VILLA JUAN PABLO 2DO, TURMERO",
      "client_identification": "V32601779",
      "nap_box_name": "CE-00254",
      "created_at": "2025-07-10T19:15:04.442432",
      "service_detail": {
        "id": 12819,
        "ip": "10.17.62.2",
        "mac": "OE:MT:3C:62:07:BA",
        "serial": "OEMT3C6207BA",
        "queue": null,
        "interface": "VLAN227_V_PARAISO_OLT1",
        "created_at": "2026-08-11T17:04:37.720757",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8617,
      "client_name": "MARIANELLA AULAR SARABIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Urb. Vista Hermosa La Julia",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144770633",
      "client_email": "MASMG5162@GMAIL.COM",
      "address": "URBANIZACIÓN VISTA HERMOSA, CALLE CONCEPCIÓN CASA D11 LA JULIA",
      "client_identification": "V6809594",
      "nap_box_name": "CTO-00586",
      "created_at": "2025-07-10T20:34:35.373632",
      "service_detail": {
        "id": 9177,
        "ip": "10.15.61.2",
        "mac": "QXTLCB82DA71",
        "serial": "QXTLCB82DA71",
        "queue": "queue1",
        "interface": "VLAN111_CONCEPCION",
        "created_at": "2025-07-11T08:50:47.833592",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8618,
      "client_name": "ASAER ALBERTO ROMERO PINANGO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128150324",
      "client_email": "ASAERALBERTOROMEROPINANGO@GMAIL.COM",
      "address": "CASCO DE TURMERO CALLE MARIÑO TORRE PACASO CONSEJERÍA",
      "client_identification": "V8813837",
      "nap_box_name": "69",
      "created_at": "2025-07-10T21:04:37.048291",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8619,
      "client_name": "ASAER ALBERTO ROMERO PINANGO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128150324",
      "client_email": "ASAERALBERTOROMEROPINANGO@GMAIL.COM",
      "address": "CASCO DE TURMERO CALLE MARIÑO TORRE PACASO CONSEJERÍA",
      "client_identification": "V8813837",
      "nap_box_name": "69",
      "created_at": "2025-07-10T21:08:28.386680",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8620,
      "client_name": "ASAER ALBERTO ROMERO PINANGO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128150324",
      "client_email": "ASAERALBERTOROMEROPINANGO@GMAIL.COM",
      "address": "CASCO DE TURMERO CALLE MARIÑO TORRE PACASO CONSEJERÍA",
      "client_identification": "V8813837",
      "nap_box_name": "69",
      "created_at": "2025-07-10T21:13:24.998544",
      "service_detail": {
        "id": 9183,
        "ip": "10.15.87.2",
        "mac": "OEMT3C620FEA",
        "serial": "OEMT3C620FEA",
        "queue": "queue1",
        "interface": "VLAN200_OLTs",
        "created_at": "2025-07-11T19:06:38.925738",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8623,
      "client_name": "ANGEL FELIPE RODRIGUEZ OCHOA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "1ro de Mayo Norte",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04127767907",
      "client_email": "ANGELFRODRIGUEZOCHOA@GMAIL.COM",
      "address": "PRIMERO DE MAYO NORTE \nCALLE CHACAO #07- CASA CON PORTÓN AZUL AL LADO DE CASA DE DOS PISOS",
      "client_identification": "V12500694",
      "nap_box_name": "CTO - 900",
      "created_at": "2025-07-12T16:26:29.799986",
      "service_detail": {
        "id": 12756,
        "ip": "10.15.148.2",
        "mac": "OE:MT:3C:62:0C:DA",
        "serial": "OEMT3C620CDA",
        "queue": null,
        "interface": "VLAN261_1ERO_MAYO_ZTE",
        "created_at": "2026-07-20T11:57:13.534775",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8624,
      "client_name": "LADY NATHALIE PAIVA CASTILLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Vallecito",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243001027",
      "client_email": "PAIVALADY194@GMAIL.COM",
      "address": "ROSARIO DE PAYA . SECTOR VALLECITO CALLE LOS NARANJOS #19",
      "client_identification": "V16851410",
      "nap_box_name": "CTO-0012345",
      "created_at": "2025-07-14T09:37:31.431758",
      "service_detail": {
        "id": 9213,
        "ip": "10.15.152.2",
        "mac": "HWTC49200626",
        "serial": "HWTC49200626",
        "queue": "queue1",
        "interface": "VLAN253_VALLE_VERDE",
        "created_at": "2025-07-16T16:31:25.353950",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8625,
      "client_name": "JOSE ORTELIO OJEDA ONARTE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 101,
        "name": "RECURRENTE RESIDENCIAL PLAN 200M",
        "cost": "19.00",
        "code": "FOR200MB",
        "profile": "200Mbps/200Mbps"
      },
      "client_mobile": "04245225910",
      "client_email": "ORTELIO27@GMAIL.COM",
      "address": "CALLE RICAURTE CASA NRO 22-2 ZONA CASCO DE TURMERO",
      "client_identification": "V14860902",
      "nap_box_name": "CTO-00403",
      "created_at": "2025-07-14T10:06:20.517513",
      "service_detail": {
        "id": 9187,
        "ip": "10.15.155.2",
        "mac": "OEMT3C620F02",
        "serial": "OEMT3C620F02",
        "queue": "queue1",
        "interface": "VLAN200_OLTs",
        "created_at": "2025-07-14T14:10:17.363607",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8626,
      "client_name": "MAURICIO JOSE ZAMBRANO CARDENAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "1ro de Mayo Norte",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04127659407",
      "client_email": "MAUZAMBRANO01@GMAIL.COM",
      "address": "SECTOR PRIMERO DE MAYO NORTE, CALLE TIUNA, CASA NUMERO 4, INTERCOMUNAL PAYA.",
      "client_identification": "V14015592",
      "nap_box_name": "CTO - 919",
      "created_at": "2025-07-14T10:08:17.514896",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8627,
      "client_name": "JOSE ZEGHEN CHAMI",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243654620",
      "client_email": "JOSEZETA484@GMAIL.COM",
      "address": "CASCO DE TURMERO CALLE URDANETA ENTRE BERMÚDEZ Y RICAURTE NRO 74 EDIFICIO RESIDENCIAS YUSEF APTO NÚMERO PISO 1 ARRIBA DE LA FERRETERÍA Y MATERIALES TYM CA",
      "client_identification": "V17246392",
      "nap_box_name": "CTO-00403",
      "created_at": "2025-07-14T10:56:33.922039",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8628,
      "client_name": "MARVIS CECILIA REYES CASTRO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Santa Eduviges",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04266406863",
      "client_email": "JORGEFELIXSAN@GMAIL.COM",
      "address": "MACARO SANTA EDUVIGES VEREDA 11 CASA NÚMERO 14",
      "client_identification": "V6155841",
      "nap_box_name": "CE-526",
      "created_at": "2025-07-14T15:49:25.282254",
      "service_detail": {
        "id": 12707,
        "ip": "10.15.180.2",
        "mac": "AD:CG:CA:65:9D:45",
        "serial": "ADCGCA659D45",
        "queue": null,
        "interface": "VLAN127_SANTA_EDUVIGES",
        "created_at": "2026-07-08T17:04:53.535879",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8629,
      "client_name": "JOSIMAR NAYMARA SANDOVAL REYES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Taguapire",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243248835",
      "client_email": "SANDOVALJOHANNY8@GMAIL.COM",
      "address": "CALLE 1 APART 10. TAGUAPIRE",
      "client_identification": "V20452208",
      "nap_box_name": "548 DOS",
      "created_at": "2025-07-14T16:27:53.205483",
      "service_detail": {
        "id": 10422,
        "ip": "10.15.181.2",
        "mac": "CIOT096B9D72",
        "serial": "CIOT096B9D72",
        "queue": null,
        "interface": "VLAN129_TAGUAPIRE_ZTE",
        "created_at": "2025-12-01T14:06:57.795494",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8630,
      "client_name": "LORIANA NATALY ALVARADO MORA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Las Palmas",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04125793250",
      "client_email": "LORIANAALVARADO6@GMAIL.COM",
      "address": "CALLEJÓN EL TANQUE CASA NÚMERO 171 SECTOR LAS PALMAS",
      "client_identification": "V26955123",
      "nap_box_name": "CTO-00098",
      "created_at": "2025-07-14T16:58:56.198382",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8631,
      "client_name": "ARNOLDO JOSE RIVAS MORENO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vallecito",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243568991",
      "client_email": "RIVS8726@GMAIL.COM",
      "address": "Calle Los naranjos cruce con Callejón los naranjos casa nro 03 sector vallecito",
      "client_identification": "V12168726",
      "nap_box_name": "CTO-00082",
      "created_at": "2025-07-14T18:23:05.090939",
      "service_detail": {
        "id": 9250,
        "ip": "10.15.183.2",
        "mac": "HWTC2297EE86",
        "serial": "HWTC2297EE86",
        "queue": "queue1",
        "interface": "VLAN258_VALLECITO",
        "created_at": "2025-07-22T16:48:20.308375",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8632,
      "client_name": "CERVANDO JOSE LUGO MIQUELENO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04125970286",
      "client_email": "CERVTDV@GMAIL.COM",
      "address": "CASCO DE TURMERO, CALLE MIRANDA #41 MINI CENTRO GUEVARA PRIMER PISO OFICINA #1",
      "client_identification": "V22949103",
      "nap_box_name": "CTO-00038",
      "created_at": "2025-07-14T21:46:48.973051",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8633,
      "client_name": "AUTOMOTORES Y TALLERES TURMERO CA",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 102,
        "name": "RECURRENTE PYME PLAN 150M",
        "cost": "27.60",
        "code": "FOP150M",
        "profile": "150Mbps/150Mbps"
      },
      "client_mobile": "04145434075",
      "client_email": "AUTOMOTORESTURMERO@GMAIL.COM",
      "address": "CALLE PETION GALPÓN 1 CASCO DE TURMERO",
      "client_identification": "J402802412",
      "nap_box_name": "CTO-00030",
      "created_at": "2025-07-15T08:15:14.051005",
      "service_detail": {
        "id": 9197,
        "ip": "10.15.184.2",
        "mac": "HWTC49200725",
        "serial": "HWTC49200725",
        "queue": "queue1",
        "interface": "VLAN200_OLTs",
        "created_at": "2025-07-15T10:37:05.130629",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8635,
      "client_name": "DUBRASKA NATALIE SANCHEZ HERNANDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Paraguatan",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04243216009",
      "client_email": "DUBRASKAS312@GMAIL.COM",
      "address": "CALLE EL MIRADOR NÚMERO 8-1\nSECTOR PARAGUATAN",
      "client_identification": "V19516355",
      "nap_box_name": "CE - 924",
      "created_at": "2025-07-15T14:08:42.724022",
      "service_detail": {
        "id": 9202,
        "ip": "10.15.185.2",
        "mac": "HWTC49200122",
        "serial": "HWTC49200122",
        "queue": "queue1",
        "interface": "VLAN283_PARAGUATAN",
        "created_at": "2025-07-15T14:38:26.568329",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8636,
      "client_name": "RAMON CELESTINO PIRIZUELA HERNANDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "1ro de Mayo Norte",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04163482928",
      "client_email": "RPIRIZUE62@GMAIL.COM",
      "address": "ROSARIO DE PAYA SECTOR 1 DE MAYO NORTE CALLE 2 CASA 13",
      "client_identification": "V7593746",
      "nap_box_name": "CTO - 00398",
      "created_at": "2025-07-15T17:44:39.175398",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8637,
      "client_name": "RADIO Y COMUNICACIONES CORPORATIVAS CA",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 102,
        "name": "RECURRENTE PYME PLAN 150M",
        "cost": "27.60",
        "code": "FOP150M",
        "profile": "150Mbps/150Mbps"
      },
      "client_mobile": "04124427850",
      "client_email": "LAVOZDETURMERO@GMAIL.COM",
      "address": "CALLE BOLIVAR RESIDENCIAL MARY CASCO DE TURMERO",
      "client_identification": "J316086720",
      "nap_box_name": "88",
      "created_at": "2025-07-16T14:14:31.088472",
      "service_detail": {
        "id": 9209,
        "ip": "10.15.186.2",
        "mac": "TPLGBA688234",
        "serial": "TPLGBA688234",
        "queue": "queue1",
        "interface": "VLAN200_OLTs",
        "created_at": "2025-07-16T16:01:00.658106",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8638,
      "client_name": "LUIS ENRIQUE ALAMO RIVERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "El Nispero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243789814",
      "client_email": "BOGROSE051@GMAIL.COM",
      "address": "ANTIGUA HACIENDA EL NÍSPERO TORRE CAYCAPE PISO 2 APTO 4",
      "client_identification": "V31984048",
      "nap_box_name": "CTO-00464",
      "created_at": "2025-07-16T14:30:29.475604",
      "service_detail": {
        "id": 9210,
        "ip": "10.15.187.2",
        "mac": "OEMT3C620CBE",
        "serial": "OEMT3C620CBE",
        "queue": "queue1",
        "interface": "VLAN209_ZAMORA_OLT1",
        "created_at": "2025-07-16T16:02:47.258914",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8639,
      "client_name": "YULESKI COROMOTO SANCHEZ SILVERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "1ro de Mayo Sur",
      "plan": {
        "id": 43,
        "name": "RECURRENTE RESIDENCIAL PLAN 650M",
        "cost": "46.00",
        "code": "FOR650M",
        "profile": "650M/650M"
      },
      "client_mobile": "04128900375",
      "client_email": "YULESKISANCHEZ1@GMAIL.COM",
      "address": "CALLE EL CUJI #3 PRIMERO DE MAYO SUR ROSARIO DE PAYA",
      "client_identification": "V17245600",
      "nap_box_name": "CTO-00470",
      "created_at": "2025-07-16T14:33:09.992453",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8640,
      "client_name": "LIDIRKA CAROLINA ROBERTO MEDINA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "El Nispero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243405627",
      "client_email": "LIDIRKARIVERO@GMAIL.COM",
      "address": "ANTIGUA HACIENDA EL NÍSPERO TORRE CAYCAPE PISO 3 APTO # 3",
      "client_identification": "V18644388",
      "nap_box_name": "CTO-00464",
      "created_at": "2025-07-16T14:44:08.361579",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8641,
      "client_name": "WILLIAN EDUARDO ROJAS APONTE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Los Caobos",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144579335",
      "client_email": "WR0255871@GMAIL.COM",
      "address": "LOS CAOBOS CALLE PRINCIPAL CASA 8",
      "client_identification": "V12611933",
      "nap_box_name": "CTO-0225",
      "created_at": "2025-07-16T17:29:53.603968",
      "service_detail": {
        "id": 9220,
        "ip": "10.15.189.2",
        "mac": "HWTCCC76664E",
        "serial": "HWTCCC76664E",
        "queue": "queue1",
        "interface": "VLAN116_CAOBOS",
        "created_at": "2025-07-17T15:25:36.993502",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8642,
      "client_name": "LISNEY FABIANA BAPTISTA HERNANDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243664488",
      "client_email": "LISNEY.1515@GMAIL.COM",
      "address": "URBANISMO EZEQUIEL ZAMORA TORRE 17 PB APARTAMENTO 2",
      "client_identification": "V30956204",
      "nap_box_name": "CTO-00464",
      "created_at": "2025-07-16T17:55:59.492269",
      "service_detail": {
        "id": 9221,
        "ip": "10.15.190.2",
        "mac": "HWTC13F4CEA1",
        "serial": "HWTC13F4CEA1",
        "queue": "queue1",
        "interface": "VLAN209_ZAMORA_OLT1",
        "created_at": "2025-07-17T15:32:11.046646",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8643,
      "client_name": "ZENAIDA JOSEFINA CABEZA ACOSTA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "1ro de Mayo Norte",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243382531",
      "client_email": "ACOSTAZENAIDA833@GMAIL.COM",
      "address": "CALLE INTERCOMUNAL, PRIMERO DE MAYO NORTE, CASA #5. ROSARIO DE PAYA",
      "client_identification": "V15600252",
      "nap_box_name": "CTO - 920",
      "created_at": "2025-07-16T18:06:49.768022",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8644,
      "client_name": "JOSE ZEGHEN CHAMI",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243654620",
      "client_email": "JOSEZETA484@GMAIL.COM",
      "address": "CASCO DE TURMERO, CALLE MARIÑO RESIDENCIA EL NÍSPERO APTO N1 PB",
      "client_identification": "V17246392",
      "nap_box_name": "CE-00009",
      "created_at": "2025-07-17T07:53:41.706344",
      "service_detail": {
        "id": 12402,
        "ip": "10.15.192.2",
        "mac": "QXTLCBC026CB",
        "serial": "QXTLCBC026CB",
        "queue": null,
        "interface": "VLAN200_OLTs",
        "created_at": "2026-04-23T15:07:37.072319",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8645,
      "client_name": "NOEL DE JESUS RONDON JIMENEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Saman Tarazonero I",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124628254",
      "client_email": "NRONDON1973@GMAIL.COM",
      "address": "CENTRO COMUNITARIO GRACIAS A DIOS 1 LOCAL A 10",
      "client_identification": "V11088880",
      "nap_box_name": "444",
      "created_at": "2025-07-17T10:58:34.179411",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8647,
      "client_name": "KLEIBER JOSE HERNANDEZ VALBUENA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Los Nisperos",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04227993412",
      "client_email": "KLEIBERHERNANDEZ000@GMAIL.COM",
      "address": "CALLE CARREÑO NORTE, URBANISMO HACIENDA LOS NÍSPEROS TORRE URQUIA PISO 3 APARTAMENTO 5",
      "client_identification": "V23528328",
      "nap_box_name": "CTO-00464",
      "created_at": "2025-07-17T15:19:16.839899",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8648,
      "client_name": "MARIELVYS INDIRA GUERRA PEÑA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Villas Del Sur",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04228861670",
      "client_email": "MARYGUERRA2104@GMAIL.COM",
      "address": "SECTOR LA CANDELARIA SUR II, CALLE PRINCIPAL II, CASA #24, ENTRANDO POR LA JULIA, LA CALLE ANTES DE KSA HOME CENTER",
      "client_identification": "V21466582",
      "nap_box_name": "632",
      "created_at": "2025-07-18T09:34:21.149120",
      "service_detail": {
        "id": 11757,
        "ip": "10.15.195.2",
        "mac": "OEMT3C6200E2",
        "serial": "OEMT3C6200E2",
        "queue": null,
        "interface": "VLAN142_VILLAS_SUR",
        "created_at": "2026-02-26T19:44:08.421218",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8649,
      "client_name": "ANUBIS YUNOKA MILLAN MENDOZA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Callejon Lim",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128901200",
      "client_email": "YANUBISMENDOZA@GMAIL.COM",
      "address": "CARRETERA NACIONAL VIA PAYA CALLEJÓN LIN ,CONJUNTOS RESIDENCIAL VILLAS TURMERO PISO 2 APARTAMENTO 11",
      "client_identification": "V12573793",
      "nap_box_name": "CTO-0449",
      "created_at": "2025-07-18T10:42:35.007263",
      "service_detail": {
        "id": 9232,
        "ip": "10.15.113.2",
        "mac": "OEMT3C62077A",
        "serial": "OEMT3C62077A",
        "queue": "queue1",
        "interface": "VLAN250_LIM_OLT2",
        "created_at": "2025-07-18T12:05:55.416834",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8650,
      "client_name": "PEDRO ANTONIO RODRIGUEZ BARRIOS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Saman Tarazonero I",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04127690086",
      "client_email": "PEDROANTONIORODRIGUEZ78@GMAIL.COM",
      "address": "SAMAN TARAZONERO I, CALLE 9 CASA # 15",
      "client_identification": "V13769722",
      "nap_box_name": "671",
      "created_at": "2025-07-18T12:13:29.990940",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8651,
      "client_name": "ANGELO GABRIEL BERNAL MENA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04122982768",
      "client_email": "ABMPERIODISTA@GMAIL.COM",
      "address": "CALLE URDANETA LOCAL N76, CASCO DE TURMERO.",
      "client_identification": "V25527337",
      "nap_box_name": "25",
      "created_at": "2025-07-18T14:55:19.222013",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8652,
      "client_name": "SHAROL OSMEILY ORTEGA REYES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04143437470",
      "client_email": "Osmeilyreyes209@gmail.com",
      "address": "SAMAN TARAZONERO II MANZANA B7 CASA NÚMERO 13, SECTOR SAMAN DE GUERE MUNICIPIO MARIÑO",
      "client_identification": "V29659795",
      "nap_box_name": "281",
      "created_at": "2025-07-18T15:23:15.014417",
      "service_detail": {
        "id": 9240,
        "ip": "10.15.196.2",
        "mac": "OEMT3C62076A",
        "serial": "OEMT3C62076A",
        "queue": "queue1",
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2025-07-19T19:31:50.190109",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8653,
      "client_name": "ANA OLFIRIA MARTINEZ ZAMBRANO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "La Macarena",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243744829",
      "client_email": "YANEIRETH2019@GMAIL.COM",
      "address": "SECTOR EL MACARO LA MACARENA II CALLE 12 CASA # 18",
      "client_identification": "V11798485",
      "nap_box_name": "51",
      "created_at": "2025-07-21T11:16:53.109243",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8654,
      "client_name": "ARIANA NATHALY GARCIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Magdalena",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04122461333",
      "client_email": "LEONOR591990@GMAIL.COM",
      "address": "LA MAGDALENA CALLE 13 CASA NÚMERO 15",
      "client_identification": "V22946303",
      "nap_box_name": "428",
      "created_at": "2025-07-22T15:37:18.235098",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8655,
      "client_name": "CARLOS ALFREDO CORREDOR MEDINA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "La Casona I",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128557469",
      "client_email": "DTCARLOSCORREDOR7@GMAIL.COM",
      "address": "CALLE 8, CASA NÚMERO 38, URBANIZACIÓN LA CASONA I, TURMERO.",
      "client_identification": "V20758114",
      "nap_box_name": "139",
      "created_at": "2025-07-22T16:05:04.532189",
      "service_detail": {
        "id": 9251,
        "ip": "10.15.198.2",
        "mac": "OEMT3C620766",
        "serial": "OEMT3C620766",
        "queue": "queue1",
        "interface": "VLAN109_CASONA_1",
        "created_at": "2025-07-22T17:00:16.514150",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8656,
      "client_name": "KAREM DAYUVI VERA GARCIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Esperanza",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124522685",
      "client_email": "LAKAREMVERA14@GMAIL.COM",
      "address": "EL MACARO URBANIZACIÓN LA ESPERANZA CALLE 15 NÚMERO 10",
      "client_identification": "V19516922",
      "nap_box_name": "555",
      "created_at": "2025-07-23T14:51:46.218134",
      "service_detail": {
        "id": 12752,
        "ip": "10.15.199.2",
        "mac": "HW:TC:35:E1:81:A2",
        "serial": "HWTC35E181A2",
        "queue": null,
        "interface": "VLAN137_LA_ESPERANZA_OLT_ZTE",
        "created_at": "2026-07-18T12:54:27.678429",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8657,
      "client_name": "KARLEN ANDREINA PEREZ TRUJILLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128909524",
      "client_email": "KARLENPT26@GMAIL.COM",
      "address": "SAMAN TARAZONERO II, MANZANA I CASA 3-3",
      "client_identification": "V25880033",
      "nap_box_name": "CTO-00064",
      "created_at": "2025-07-24T14:44:47.822186",
      "service_detail": {
        "id": 12251,
        "ip": "10.15.116.2",
        "mac": "HWTCCC931565",
        "serial": "HWTCCC931565",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2026-04-05T11:51:03.077739",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8665,
      "client_name": "RAFAEL TOBIOS RIOS RON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Valle Paraiso",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04127837021",
      "client_email": "MIRIAMCAROLINA2701@GMAIL.COM",
      "address": "URBANIZACIÓN VILLA JUAN PABLO 2DO PRIMERA ETAPA MANZANA 8 CASA 5 SAN PABLO",
      "client_identification": "V8556162",
      "nap_box_name": "CE-00254",
      "created_at": "2025-07-31T17:01:10.284305",
      "service_detail": {
        "id": 9279,
        "ip": "10.15.200.2",
        "mac": "OEMT3C620A86",
        "serial": "OEMT3C620A86",
        "queue": "queue1",
        "interface": "VLAN227_V_PARAISO_OLT1",
        "created_at": "2025-08-01T08:14:12.488594",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8666,
      "client_name": "JOSE CIPRIANO LOPEZ ANTON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Valle Paraiso",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121491440",
      "client_email": "ESOJLOPEZ000@GMAIL.COM",
      "address": "URBANIZACIÓN VILLA JUAN PABLO SEGUNDO CALLE H PRIMERA ETAPA MANZANA 8 CASA 3. VALLE PARAISO.",
      "client_identification": "V4686364",
      "nap_box_name": "CE-00254",
      "created_at": "2025-07-31T17:03:10.701776",
      "service_detail": {
        "id": 9280,
        "ip": "10.15.201.2",
        "mac": "OEMT3C620D76",
        "serial": "OEMT3C620D76",
        "queue": "queue1",
        "interface": "VLAN227_V_PARAISO_OLT1",
        "created_at": "2025-08-01T08:16:17.724854",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8667,
      "client_name": "JACQUELINE COROMOTO JIMENEZ BRICEÑO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243839959",
      "client_email": "DHYLAN06ANGEBER@GMAIL.COM",
      "address": "RIO SECO CALLE 21 NRO 19",
      "client_identification": "V19833885",
      "nap_box_name": "603 DOS",
      "created_at": "2025-07-31T17:29:11.554378",
      "service_detail": {
        "id": 9281,
        "ip": "10.15.202.2",
        "mac": "HWTC911C3687",
        "serial": "HWTC911C3687",
        "queue": "queue1",
        "interface": "VLAN251_RIO_SECO",
        "created_at": "2025-08-01T08:20:45.729220",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8668,
      "client_name": "CARMEN CANTALICIA FLORES CONTRERAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Valle Fresco",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04127987624",
      "client_email": "ALEXANDRASAZA@GMAIL.COM",
      "address": "MANZANA 26 CASA #03 VALLE FRESCO",
      "client_identification": "V7221685",
      "nap_box_name": "CTO - 981",
      "created_at": "2025-07-31T17:33:38.719342",
      "service_detail": {
        "id": 12381,
        "ip": "10.15.203.2",
        "mac": "OEMT3C620BCE",
        "serial": "OEMT3C620BCE",
        "queue": null,
        "interface": "VLAN270_VALLE_FRESCO_OLT3",
        "created_at": "2026-04-20T15:46:41.787965",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8669,
      "client_name": "YONNY JOSE DIAZ APONTE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Paraguatan",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "0412-0497443",
      "client_email": "YONNYJOSEDIAZAPONTE@GMAIL.COM",
      "address": "CALLE ESCALONA # 21 PARAGUATAN GUAYABITA -POLVORIN",
      "client_identification": "V24976219",
      "nap_box_name": "CTO-00397",
      "created_at": "2025-07-31T17:34:38.593415",
      "service_detail": {
        "id": 12585,
        "ip": "10.15.204.2",
        "mac": "HW:TC:FA:11:BD:48",
        "serial": "HWTCFA11BD48",
        "queue": null,
        "interface": "VLAN283_PARAGUATAN",
        "created_at": "2026-06-05T19:07:41.982738",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8670,
      "client_name": "YOHAN MANUEL MENDOZA MORENO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Valle Paraiso",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121305371",
      "client_email": "STMELECTROMEDCA@GMAIL.COM",
      "address": "URBANIZACIÓN VALLE PARAÍSO, MANZANA 3 CASA #11. TURMERO ESTADO ARAGUA",
      "client_identification": "V17724700",
      "nap_box_name": "CTO-00595",
      "created_at": "2025-07-31T17:36:45.797563",
      "service_detail": {
        "id": 9287,
        "ip": "10.15.118.2",
        "mac": "OEMT3C62010A",
        "serial": "OEMT3C62010A",
        "queue": "queue1",
        "interface": "VLAN227_V_PARAISO_OLT1",
        "created_at": "2025-08-01T08:56:55.657985",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8671,
      "client_name": "GENESIS ANDREINA PRIETO LOPEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Cambur",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04266308586",
      "client_email": "GENESISPRIETO819@GMAIL.COM",
      "address": "SECTOR EL CAMBUR CALLE PRINCIPAL NÚMERO #52",
      "client_identification": "V28432022",
      "nap_box_name": "CTO-00150",
      "created_at": "2025-07-31T18:22:06.818836",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8672,
      "client_name": "KARLESKA NAZARETH FLORES TORRES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "San Pablo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243331312",
      "client_email": "KARLESKAFT@HOTMAIL.COM",
      "address": "PRINCIPAL DE LA URB SAN PABLO TURMERO PUNTO DE REFERENCIA RESIDENCIA CAMPO ALEGRE",
      "client_identification": "V26535483",
      "nap_box_name": "641",
      "created_at": "2025-07-31T19:53:02.593698",
      "service_detail": {
        "id": 9286,
        "ip": "10.15.117.2",
        "mac": "OEMT3C620D42",
        "serial": "OEMT3C620D42",
        "queue": "queue1",
        "interface": "VLAN224_SAN_PABLO_OLT1",
        "created_at": "2025-08-01T08:33:09.848415",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8673,
      "client_name": "RICHARD FERNANDEZ LAVIN",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Guayabita",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04149441322",
      "client_email": "RICHARDLEE27487@GMAIL.COM",
      "address": "CTRA. VIA POLVORIN, CASA PARCELA #2, SECTOR GUAYABITA. TURMERO - ARAGUA, 2115.",
      "client_identification": "V18851443",
      "nap_box_name": "CE-00164",
      "created_at": "2025-08-01T08:50:07.345602",
      "service_detail": {
        "id": 9309,
        "ip": "10.15.130.2",
        "mac": "OEMT3C62088E",
        "serial": "OEMT3C62088E",
        "queue": "queue1",
        "interface": "VLAN282_ZONA_AGRARIA",
        "created_at": "2025-08-04T16:40:00.429562",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8674,
      "client_name": "LUIS MIGUEL DE SOUSA RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "San Pablo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04123479514",
      "client_email": "SOUSACUBERO@GMAIL.COM",
      "address": "URBANIZACIÓN VILLA DE JUAN PABLO SEGUNDO MANZANA 8 PRIMERA ETAPA CASA 02",
      "client_identification": "V8743247",
      "nap_box_name": "CE-00254",
      "created_at": "2025-08-01T10:22:27.281092",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8675,
      "client_name": "ALBERT HENRIQUE CARPIO GONZALEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04127766803",
      "client_email": "ALBERT280282@GMAIL.COM",
      "address": "CASCO DE TURMERO. CALLE CAMILO TORRES RESIDENCIA TURMERO EDIFICIO 1, PISO 3,  APARTAMENTO 15",
      "client_identification": "V14664843",
      "nap_box_name": "CTO-931",
      "created_at": "2025-08-01T11:16:10.081597",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8676,
      "client_name": "SONIA JOSEFINA COELLO LUGO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Guanarito",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04125970436",
      "client_email": "SONIACOELLO936@GAMIL.COM",
      "address": "GUANARITO, LA CANDELARIA CALLE LOS MANGOS CASA #07",
      "client_identification": "V12167779",
      "nap_box_name": "CTO - 1260",
      "created_at": "2025-08-01T12:58:00.201914",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8677,
      "client_name": "MARIELA DE LA CRUZ AGUIRRE BOLIVAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Prados de Cafetal",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04129155024",
      "client_email": "NOVEDADESTURMERO@GMAIL.COM",
      "address": "AV PRINCIPAL ROSARIO DE PAYA PRADOS DE CAFETAL RESIDENCIA VILLAS DE PRADO CASA 4",
      "client_identification": "V7256208",
      "nap_box_name": "544",
      "created_at": "2025-08-01T15:29:39.661134",
      "service_detail": {
        "id": 11186,
        "ip": "10.11.182.2",
        "mac": "OEMT3C620BC6",
        "serial": "OEMT3C620BC6",
        "queue": null,
        "interface": "VLAN221_CAFETAL_OLT1",
        "created_at": "2026-01-15T16:34:03.348030",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8678,
      "client_name": "EDWIN JOSNIER ORTEGA CORNIELES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Narayola II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04247183639",
      "client_email": "EDWINJO2014@GMAIL.COM",
      "address": "URBANIZACIÓN NARAYOLA II, PLANTA BAJA APARTAMENTO 1",
      "client_identification": "V25795231",
      "nap_box_name": "628",
      "created_at": "2025-08-02T09:50:13.468423",
      "service_detail": {
        "id": 9299,
        "ip": "10.15.119.2",
        "mac": "OEMT3C62074E",
        "serial": "OEMT3C62074E",
        "queue": "queue1",
        "interface": "VLAN117_NARAYOLA",
        "created_at": "2025-08-02T14:53:26.645527",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8679,
      "client_name": "DESIREE CATALINA PANTOJA FLORES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Orquidea",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121492603",
      "client_email": "GERALDINEPANTOJA2026@GMAIL.COM",
      "address": "SECTOR LA ORQUÍDEA CALLE 1 CASA 1 ROSARIO DE PAYA",
      "client_identification": "V13884900",
      "nap_box_name": "CTO-00019",
      "created_at": "2025-08-02T14:52:12.719702",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8680,
      "client_name": "ELIANA MARGARITA PEREZ ALVARADO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Guerrero de Chavez",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243008691",
      "client_email": "ELIANYPEREZ892@GMAIL.COM",
      "address": "GUERREROS DE CHÁVEZ CALLE 3 CASA 84",
      "client_identification": "V30866385",
      "nap_box_name": "CTO-00587",
      "created_at": "2025-08-02T15:57:11.609850",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8681,
      "client_name": "PEDRO MIGUEL MILONE GODOY",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121631096",
      "client_email": "WIZARD445ZX@GMAIL.COM",
      "address": "PASAJE CAMILO TORRE, CASCO DE TURMERO #11",
      "client_identification": "V25527414",
      "nap_box_name": "CTO-",
      "created_at": "2025-08-03T21:08:29.122396",
      "service_detail": {
        "id": 9303,
        "ip": "10.15.207.2",
        "mac": "OEMT3C62016E",
        "serial": "OEMT3C62016E",
        "queue": "queue1",
        "interface": "VLAN200_OLTs",
        "created_at": "2025-08-04T09:58:40.545071",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8682,
      "client_name": "STEFANI YAIMAR OVALLES RIVAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Simon Bolivar",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04228155319",
      "client_email": "CAMPOSNATALIA653@GMAIL.COM",
      "address": "EL MACARO, SIMÓN BOLÍVAR, CALLE 6, CASA #48",
      "client_identification": "V27286086",
      "nap_box_name": "CTO-00023",
      "created_at": "2025-08-04T08:14:42.676655",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8683,
      "client_name": "NANCY DUVRASKA CHAPARDI DE CASTELLANOS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Marina Caribe",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124447786",
      "client_email": "PROFECHAPARDI@GMAIL.COM",
      "address": "URBANIZACIÓN MARINA CARIBE, CALLE C, CASA 25. SAN PABLO TURMERO.",
      "client_identification": "V9688577",
      "nap_box_name": "CTO-00029",
      "created_at": "2025-08-04T10:56:38.168387",
      "service_detail": {
        "id": 9305,
        "ip": "10.15.209.2",
        "mac": "OEMT3C62102E",
        "serial": "OEMT3C62102E",
        "queue": "queue1",
        "interface": "VLAN287_M_CARIBE",
        "created_at": "2025-08-04T13:58:06.988083",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8684,
      "client_name": "OMAR LEONARDO AZUAJE MEZA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Edif. El Portal",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144754446",
      "client_email": "LEONARDOAZUAJE10@GMAIL.COM",
      "address": "CALLE FERGUS, RESIDENCIAS EL PORTAL, TORRE D, PISO 8, APTO 81. TURMERO.",
      "client_identification": "V21369195",
      "nap_box_name": "CTO-00413",
      "created_at": "2025-08-04T12:44:21.684969",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8685,
      "client_name": "ARIANA BEATRIZ PROANO RONDON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Los Nisperos",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128960554",
      "client_email": "HUCARANSITA22@GMAIL.COM",
      "address": "TORRE A. PISO 4-6. CONJUNTO RESIDENCIAL LOS NISPEROS, TURMERO 2115, ARAGUA",
      "client_identification": "V25880747",
      "nap_box_name": "88",
      "created_at": "2025-08-04T12:57:09.867012",
      "service_detail": {
        "id": 9307,
        "ip": "10.15.211.2",
        "mac": "OEMT3C6204A6",
        "serial": "OEMT3C6204A6",
        "queue": "queue1",
        "interface": "VLAN272_EDIF_NISPEROS_OLT3",
        "created_at": "2025-08-04T14:04:45.349452",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8686,
      "client_name": "HUMPHREY BYRON MONTERO ESPINOZA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Marina Caribe",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128990035",
      "client_email": "HBYRONMONTERO@GMAIL.COM",
      "address": "SAN PABLO RESD. MARINA CARIBE CASA 75",
      "client_identification": "V22287576",
      "nap_box_name": "CTO - 940",
      "created_at": "2025-08-04T14:17:52.759189",
      "service_detail": {
        "id": 9308,
        "ip": "10.15.212.2",
        "mac": "OEMT3C6201C2",
        "serial": "OEMT3C6201C2",
        "queue": "queue1",
        "interface": "VLAN287_M_CARIBE",
        "created_at": "2025-08-04T14:50:21.512990",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8687,
      "client_name": "CHUSAN JOSE CHANG MORA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "La Aduana",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "0426-7337048",
      "client_email": "CHUSANCHANG@GMAIL.COM",
      "address": "SECTOR LA ADUANA, URB SAN CARLOS, CALLE C, CASA 9D, TURMERO",
      "client_identification": "V6206199",
      "nap_box_name": "136",
      "created_at": "2025-08-05T14:48:58.652739",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8688,
      "client_name": "ADOLFO APOLINAR RUJANO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04262915244",
      "client_email": "ADOLFO.APOLINAR1971@GMAIL.COM",
      "address": "CALLE BERMÚDEZ CRUCE CON MARIÑO CASA 67, CASCO DE TURMERO.",
      "client_identification": "V10753935",
      "nap_box_name": "101",
      "created_at": "2025-08-05T15:39:05.594582",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8689,
      "client_name": "NOHEMI ALEXANDRA REYES PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Las Rurales",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124651015",
      "client_email": "UNIKREYESNOHEMI@GMAIL.COM",
      "address": "SECTOR LAS RURALES CALLE 107 CASA 69",
      "client_identification": "V13201919",
      "nap_box_name": "CE - 667",
      "created_at": "2025-08-05T17:06:30.789925",
      "service_detail": {
        "id": 11547,
        "ip": "10.15.208.2",
        "mac": "OEMT3C620A36",
        "serial": "OEMT3C620A36",
        "queue": null,
        "interface": "VLAN252_RURALES_PAYA",
        "created_at": "2026-02-08T13:19:07.708361",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8690,
      "client_name": "JULIO CESAR SANDOVAL ESCALONA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "La Casona II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04120673460",
      "client_email": "SANDOVALEJULIO@GMAIL.COM",
      "address": "URB LA CASONA II, CALLE 13, CASA 58",
      "client_identification": "V18783403",
      "nap_box_name": "CTO-00075",
      "created_at": "2025-08-05T23:36:09.788820",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8691,
      "client_name": "DANIELA DEL VALLE SALAZAR ESPINOZA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Antigua Hacienda De Paya",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04145799642",
      "client_email": "DANIELAV.SALAZARE@GMAIL.COM",
      "address": "AV PRINCIPAL DE PAYA CALLE 17 PARCELA 23C ANTIGUA HACIENDA DE PAYA",
      "client_identification": "V9689901",
      "nap_box_name": "CTO-00183",
      "created_at": "2025-08-06T11:28:22.379393",
      "service_detail": {
        "id": 9319,
        "ip": "10.15.216.2",
        "mac": "OEMT3C6202C6",
        "serial": "OEMT3C6202C6",
        "queue": "queue1",
        "interface": "VLAN202_AHP_OLT1",
        "created_at": "2025-08-06T11:59:03.230949",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8692,
      "client_name": "DEISY NAIRUBY CABEZA GUEVARA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Vallecito",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128679711",
      "client_email": "MATILNET2019@GMAIL.COM",
      "address": "CALLE EL MIRADOR CASA # 27, SECTOR VALLECITO ROSARIO DE PAYA",
      "client_identification": "V17578205",
      "nap_box_name": "Cto-92",
      "created_at": "2025-08-06T11:47:17.751345",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8693,
      "client_name": "MARIA JOSE PEREZ GARCIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Valle Fresco",
      "plan": {
        "id": 43,
        "name": "RECURRENTE RESIDENCIAL PLAN 650M",
        "cost": "46.00",
        "code": "FOR650M",
        "profile": "650M/650M"
      },
      "client_mobile": "04143464418",
      "client_email": "MARIJO14PG@GMAIL.COM",
      "address": "URB. VALLE FRESCO MANZANA A CASA NÚMERO 6",
      "client_identification": "V19388063",
      "nap_box_name": "Valle fresco",
      "created_at": "2025-08-06T12:14:34.295742",
      "service_detail": {
        "id": 9322,
        "ip": "10.15.218.2",
        "mac": "OEMT3C620AF2",
        "serial": "OEMT3C620AF2",
        "queue": "queue1",
        "interface": "VLAN270_VALLE_FRESCO_OLT3",
        "created_at": "2025-08-06T14:19:01.550217",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8694,
      "client_name": "WALTER ENRIQUE HENRIQUEZ GOUVEIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Los Nisperos",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128150900",
      "client_email": "WALTERGOUVEIA87@HOTMAIL.COM",
      "address": "CONJUNTO RESIDENCIAL LOS NÍSPEROS, TORRE A , APARTAMENTO 12",
      "client_identification": "V34227755",
      "nap_box_name": "88",
      "created_at": "2025-08-06T13:13:13.941333",
      "service_detail": {
        "id": 9330,
        "ip": "10.15.219.2",
        "mac": "OEMT3C620466",
        "serial": "OEMT3C620466",
        "queue": "queue1",
        "interface": "VLAN272_EDIF_NISPEROS_OLT3",
        "created_at": "2025-08-07T10:43:22.413050",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8695,
      "client_name": "LIDIA DEL ALBA MENDOZA LINARES",
      "client_type_name": "EMPLEADO",
      "client_subdivision": "ACTIVO_EMPLEADO",
      "status_name": "Activo",
      "cycle": 25,
      "migrate": false,
      "sector_name": "La Casona I",
      "plan": {
        "id": 78,
        "name": "Plan empleado 80MB",
        "cost": "0.00",
        "code": "FO-80M",
        "profile": "80M/80M"
      },
      "client_mobile": "04121484163",
      "client_email": "LIDIADELALBAMENDOZALINARES@GMAIL.COM",
      "address": "AV 8 CASA NRO 16 URB LA CASONA 1 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V26055433",
      "nap_box_name": "CTO-00139",
      "created_at": "2025-08-06T14:06:24.149297",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8696,
      "client_name": "FELIX MANUEL LISCANO ARRIECHE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Guerito",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04149440521",
      "client_email": "LISCANO2816INVERSIONES@GMAIL.COM",
      "address": "URB SAN MIGUEL CACHIPO NORTE CALLE RICAURTE CASA 11",
      "client_identification": "V13313082",
      "nap_box_name": "CE - 252",
      "created_at": "2025-08-06T14:20:06.063027",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8697,
      "client_name": "JASSULY COROMOTO AREVALO BERBECIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vallecito",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124613352",
      "client_email": "JASSULYAREVALOCB@GMAIL.COM",
      "address": "CALLE LAS ACACIAS CASA NRO 1.\nSECTOR VALLECITO.\nCERCA DEL ABASTO EL GATO",
      "client_identification": "V22948839",
      "nap_box_name": "CTO-00VALLEC",
      "created_at": "2025-08-06T14:47:37.412959",
      "service_detail": {
        "id": 9325,
        "ip": "10.15.221.2",
        "mac": "2012231218006526",
        "serial": "OEMT3C6255DE",
        "queue": "queue1",
        "interface": "VLAN258_VALLECITO",
        "created_at": "2025-08-06T15:16:11.394244",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8698,
      "client_name": "YANET COROMOTO MEDINA SILVA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Simon Bolivar",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128977587",
      "client_email": "YANETHMEDINA869@GMAIL.COM",
      "address": "URB SIMÓN BOLIVAR CALLE 3 CASA 22",
      "client_identification": "V16864681",
      "nap_box_name": "CTO-00046",
      "created_at": "2025-08-06T16:58:33.714375",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8699,
      "client_name": "MARIA TRINIDAD RITO SOLARTE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Taguapire",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04129127530",
      "client_email": "MARITJOFERALE@GMAIL.COM",
      "address": "TURMERO VÍA AL MACARO URB TAGUAPIRE CALLE 3 NUM 83",
      "client_identification": "V12611895",
      "nap_box_name": "549 DOS",
      "created_at": "2025-08-06T19:23:48.631886",
      "service_detail": {
        "id": 10496,
        "ip": "10.15.223.2",
        "mac": "OEMT3C620E56",
        "serial": "OEMT3C620E56",
        "queue": null,
        "interface": "VLAN129_TAGUAPIRE_ZTE",
        "created_at": "2025-12-02T17:05:17.600556",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8700,
      "client_name": "JORGE HUMBERTO PEREZ PEÑALOZA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 16,
        "name": "RECURRENTE RESIDENCIAL PLAN 800M",
        "cost": "55.00",
        "code": "FOR800",
        "profile": "800M/800M"
      },
      "client_mobile": "04243671200",
      "client_email": "CARLOSFEDOR3@GMAIL.COM",
      "address": "ALCALDÍA MUNICIPIO SANTIAGO MARIÑO. CASCO DE TURMERO",
      "client_identification": "V28142694",
      "nap_box_name": "110",
      "created_at": "2025-08-07T07:58:54.037273",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8701,
      "client_name": "CONJUNTO RESIDENCIAL EL TORREON DE SAN PABLO",
      "client_type_name": "PYME",
      "client_subdivision": "SUSPENDIDO_PYME",
      "status_name": "Suspendido",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Edif. El Portal",
      "plan": {
        "id": 102,
        "name": "RECURRENTE PYME PLAN 150M",
        "cost": "27.60",
        "code": "FOP150M",
        "profile": "150Mbps/150Mbps"
      },
      "client_mobile": "04243038373",
      "client_email": "TORREONTORREC@GMAIL.COM",
      "address": "CALLE FERGUS EDIFICIO EL TORREÓN DE SAN PABLO TORRE C PB SALÓN DE FIESTAS.",
      "client_identification": "J294813402",
      "nap_box_name": "635",
      "created_at": "2025-08-07T10:45:42.479451",
      "service_detail": {
        "id": 9333,
        "ip": "10.15.225.2",
        "mac": "OEMT3C620676",
        "serial": "OEMT3C620676",
        "queue": "queue1",
        "interface": "VLAN289_TORREON",
        "created_at": "2025-08-07T12:30:21.223944",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8702,
      "client_name": "WILFREDO COROMOTO RIVAS BASTO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Valle Paraiso",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04122989541",
      "client_email": "WILFREDRIV01@GMAIL.COM",
      "address": "VALLE PARAÍSO MANZANA 1 CASA 7 SAN PABLO",
      "client_identification": "V3721932",
      "nap_box_name": "CTO-0643",
      "created_at": "2025-08-07T11:53:41.482002",
      "service_detail": {
        "id": 9334,
        "ip": "10.15.226.2",
        "mac": "OEMT3C6205AA",
        "serial": "OEMT3C6205AA",
        "queue": "queue1",
        "interface": "VLAN227_V_PARAISO_OLT1",
        "created_at": "2025-08-07T12:32:03.195592",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8703,
      "client_name": "CARLOS EMILIO FUENTES MOLINA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Los Nisperos",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243167227",
      "client_email": "FCARLOSEMILIO@GMAIL.COM",
      "address": "AVENIDA BOLÍVAR EDIFICIO TORRE A. PISO 8. APARTAMENTO 84. CONJUNTO RESIDENCIAL LOS NÍSPEROS",
      "client_identification": "V9415407",
      "nap_box_name": "88",
      "created_at": "2025-08-07T12:11:34.698336",
      "service_detail": {
        "id": 9346,
        "ip": "10.15.227.2",
        "mac": "OEMT3C621116",
        "serial": "OEMT3C621116",
        "queue": "queue1",
        "interface": "VLAN272_EDIF_NISPEROS_OLT3",
        "created_at": "2025-08-08T14:20:17.851989",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8704,
      "client_name": "MAITA ESTHER CHAVEZ LADERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "19 de Abril",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04125230165",
      "client_email": "ZAIDACHAVEZ6996@GMAIL.COM",
      "address": "SECTOR 19 DE ABRIL CALLE SUCRE CASA 56",
      "client_identification": "V8734637",
      "nap_box_name": "CTO - 1374",
      "created_at": "2025-08-07T12:19:32.364529",
      "service_detail": {
        "id": 9338,
        "ip": "10.15.228.2",
        "mac": "HWTCCC9340AD",
        "serial": "HWTCCC9340AD",
        "queue": "queue1",
        "interface": "VLAN122_SAMAN_GUERE",
        "created_at": "2025-08-07T14:30:24.135773",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8705,
      "client_name": "JENIFFER CAROLINA PARRA RIVERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Turmerito",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243791939",
      "client_email": "OMARALEJOS@GMAIL.COM",
      "address": "TURMERITO EL MACARO CALLE PRINCIPAL LOS PERICOS #42",
      "client_identification": "V16434288",
      "nap_box_name": "CTO - 1460",
      "created_at": "2025-08-07T13:09:07.181565",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8706,
      "client_name": "YEXELYN MARIELA GONZALEZ QUEVEDO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "1ro de Mayo Norte",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124659466",
      "client_email": "YEXELYN25@GMAIL.COM",
      "address": "AVENIDA PRINCIPAL ROSARIO DE PAYA PRIMERO DE MAYO NORTE CASA 126 AUTOLAVADO",
      "client_identification": "V18068130",
      "nap_box_name": "CTO - 919",
      "created_at": "2025-08-07T15:57:40.099030",
      "service_detail": {
        "id": 12004,
        "ip": "10.15.230.2",
        "mac": "OEMT3C6201DA",
        "serial": "OEMT3C6201DA",
        "queue": null,
        "interface": "VLAN261_1ERO_MAYO_ZTE",
        "created_at": "2026-03-07T16:34:34.810326",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8707,
      "client_name": "KATHERINE YENIFER HIDALGO HERNANDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Leocolbo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243709927",
      "client_email": "KATHERINEYENIFER848@GMAIL.COM",
      "address": "VILLA DON PASCUAL CASA N3. AL LADO DE LEO COLVO",
      "client_identification": "V25841466",
      "nap_box_name": "CTO-00371",
      "created_at": "2025-08-07T17:12:20.080451",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8708,
      "client_name": "SUYIN CHIQUINQUIRA SANCHEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "El Cambur",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04125973790",
      "client_email": "SUYINCHIQUI@GMAIL.COM",
      "address": "ROSARIO DE PAYA EL CAMBUR CALLE LAS PALMAS #28 ANTES DE LA PARADA DE LOS AUTOBUSES",
      "client_identification": "V15818283",
      "nap_box_name": "CTO - 911",
      "created_at": "2025-08-07T17:34:46.038052",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8709,
      "client_name": "LEIDYS DEL CARMEN PEREIRA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Dios Es Mi Refugio",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04241490469",
      "client_email": "MANUEL.CISNEROSN96@GMAIL.COM",
      "address": "MANZANA 1 CASA 12 DIOS ES MI REFUGIO PAYA FRENTE  DE MATACABALLO",
      "client_identification": "V14934496",
      "nap_box_name": "CTO-00580",
      "created_at": "2025-08-08T12:09:38.514935",
      "service_detail": {
        "id": 9353,
        "ip": "10.15.232.2",
        "mac": "HWTC11AD1685",
        "serial": "HWTC11AD1685",
        "queue": "queue1",
        "interface": "VLAN271_DIOS_ES_MI_REFUGIO_OLT1",
        "created_at": "2025-08-09T17:12:52.301383",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8710,
      "client_name": "WILFREDO ALBERTO RODRIGUEZ MANAURE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "San Sebastian",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124642754",
      "client_email": "RODRIGUEZMWILFREDO@GMAIL.COM",
      "address": "EL MACARO BARRIO SAN SEBASTIAN CALLE 8 NÚMERO 14",
      "client_identification": "V13701680",
      "nap_box_name": "75",
      "created_at": "2025-08-08T15:11:54.734711",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8711,
      "client_name": "ARMANDO LUIS RAMOS VALERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "SUSPENDIDO_RESIDENCIAL",
      "status_name": "Suspendido",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Valle Fresco",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243210024",
      "client_email": "ARMANDOLUISRAMOS22@GMAIL.COM",
      "address": "URB VALLE FRESCO MANZANA 5, CASA#3",
      "client_identification": "V7225311",
      "nap_box_name": "CTO VALLE FRESCO",
      "created_at": "2025-08-08T20:18:58.262703",
      "service_detail": {
        "id": 12731,
        "ip": "10.15.234.2",
        "mac": "HW:TC:48:08:03:15",
        "serial": "HWTC48080315",
        "queue": null,
        "interface": "VLAN270_VALLE_FRESCO_OLT3",
        "created_at": "2026-07-13T09:13:35.176700",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8712,
      "client_name": "IVAN ENRIQUE ARANGO BORGES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero I",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243029332",
      "client_email": "IVANARANGOB1997@GMAIL.COM",
      "address": "SAMAN TARAZONERO I MANZANA F1 CASA #6. EL MACARO TURMERO ESTADO ARAGUA CODIGO POSTAL 2115",
      "client_identification": "V14060409",
      "nap_box_name": "162",
      "created_at": "2025-08-09T10:30:31.154255",
      "service_detail": {
        "id": 9351,
        "ip": "10.15.235.2",
        "mac": "OEMT3C624562",
        "serial": "OEMT3C624562",
        "queue": "queue1",
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2025-08-09T11:04:52.901977",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8713,
      "client_name": "ZORELYS CHIQUINQUIRA NAVAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121992133",
      "client_email": "ZORELISNAVAS67@GMAIL.COM",
      "address": "SAMÁN TARAZONERO 2 MANZANA D-6 CASA #8.",
      "client_identification": "V9805249",
      "nap_box_name": "268",
      "created_at": "2025-08-11T08:18:58.105727",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8714,
      "client_name": "KATHERINE BETANIA VELASQUEZ PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Los Hornos",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243417502",
      "client_email": "VELASQUEZBETANIA299@GMAIL.COM",
      "address": "ROSARIO DE PAYA HORNOS DOS CALLE 10 CASA 61",
      "client_identification": "V24885925",
      "nap_box_name": "CTO-00288",
      "created_at": "2025-08-11T10:57:34.567994",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8715,
      "client_name": "YYESA DEL CARMEN HERNANDEZ PEROZO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Los Caobos",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144738604",
      "client_email": "YYESAHERNANDEZ@GMAIL.COM",
      "address": "LOS CAOBOS 2, CALLE TULIPAN CASA #45",
      "client_identification": "V8737500",
      "nap_box_name": "CE - 546",
      "created_at": "2025-08-12T08:54:20.421341",
      "service_detail": {
        "id": 9358,
        "ip": "10.15.238.2",
        "mac": "QXTLCBE462F6",
        "serial": "QXTLCBE462F6",
        "queue": "queue1",
        "interface": "VLAN116_CAOBOS",
        "created_at": "2025-08-12T09:43:52.099115",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8716,
      "client_name": "JOHANA ANDREINA CHIRINOS VELASQUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Polvorin",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243079256",
      "client_email": "CHIRINOSJ514@GMAIL.COM",
      "address": "GUAYABITA VIA POLVORÍN SECTOR PARAGUATAN CALLE EL RINCÓN CASA NÚMERO 9-1.. A TRES CASA DE LA CANCHA DEPORTIVA",
      "client_identification": "V18231905",
      "nap_box_name": "CTO-00397",
      "created_at": "2025-08-12T09:31:34.059053",
      "service_detail": {
        "id": 9366,
        "ip": "10.15.239.2",
        "mac": "OEMT3C6205B2",
        "serial": "OEMT3C6205B2",
        "queue": "queue1",
        "interface": "VLAN283_PARAGUATAN",
        "created_at": "2025-08-13T17:09:52.099079",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8717,
      "client_name": "KATHERIN JOHANA VARGAS ANDARA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Guerito",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124406266",
      "client_email": "KARIMORENOVARGAS@GMAIL.COM",
      "address": "GUERITO, CALLE SUCRE, BARRIO SAN MIGUEL #53",
      "client_identification": "V25501232",
      "nap_box_name": "CTO - 1229",
      "created_at": "2025-08-12T13:55:52.046683",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8718,
      "client_name": "JEFATURA DEL ADULTO MAYOR",
      "client_type_name": "GRATIS",
      "client_subdivision": "ACTIVO_GRATIS",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": false,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 86,
        "name": "PLAN RECURRENTE 80M GRATIS",
        "cost": "0.00",
        "code": "FO-G80",
        "profile": "80M/80M"
      },
      "client_mobile": "04243473830",
      "client_email": "INGRIDTESORO385@GMAIL.COM",
      "address": "CALLE CARREÑO NRO 45 TURMERO",
      "client_identification": "V5412327",
      "nap_box_name": "184",
      "created_at": "2025-08-12T14:04:16.381060",
      "service_detail": {
        "id": 12439,
        "ip": "10.15.240.2",
        "mac": "OEMT3C620F9A",
        "serial": "OEMT3C620F9A",
        "queue": null,
        "interface": "VLAN200_OLTs",
        "created_at": "2026-04-30T15:55:15.767859",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8719,
      "client_name": "FERNANDO DAVID MORALES CARABALLO",
      "client_type_name": "EMPLEADO",
      "client_subdivision": "CANCELADO_EMPLEADO",
      "status_name": "Cancelado",
      "cycle": 10,
      "migrate": false,
      "sector_name": "La Casona II",
      "plan": {
        "id": 78,
        "name": "Plan empleado 80MB",
        "cost": "0.00",
        "code": "FO-80M",
        "profile": "80M/80M"
      },
      "client_mobile": "04243231154",
      "client_email": "FERNANDOMORALESFER@GMAIL.COM",
      "address": "CALLE 13 CASA NRO 88 LA CASONA 2",
      "client_identification": "V30956315",
      "nap_box_name": "CTO-00089",
      "created_at": "2025-08-13T15:52:16.167815",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8720,
      "client_name": "ROMMER ALEXANDER SOSA SAAVEDRA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "SUSPENDIDO_RESIDENCIAL",
      "status_name": "Suspendido",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Taguapire",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "0424-3500941",
      "client_email": "ROMMERSOSA@HOTMAIL.COM",
      "address": "URBANIZACIÓN TAGUAPIRE CALLE 1 MODULO 2 PB APARTAMENTO 14",
      "client_identification": "V10108777",
      "nap_box_name": "548 DOS",
      "created_at": "2025-08-14T18:40:33.846029",
      "service_detail": {
        "id": 10381,
        "ip": "10.15.140.2",
        "mac": "TPLGBA6882CB",
        "serial": "TPLGBA6882CB",
        "queue": null,
        "interface": "VLAN129_TAGUAPIRE_ZTE",
        "created_at": "2025-11-28T13:11:41.529246",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8721,
      "client_name": "JAVIER AGUSTIN SOSA BRICENO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Valle Paraiso",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04242572382",
      "client_email": "JAVIERSOSA1970@GMAIL.COM",
      "address": "URB VALLE PARAÍSO MANZANA 3 CASA 19 ,CERCA DEL CC MILÁN PLAZA TURMERO EDO ARAGUA",
      "client_identification": "V10312774",
      "nap_box_name": "CTO-00595",
      "created_at": "2025-08-14T21:37:16.217219",
      "service_detail": {
        "id": 9369,
        "ip": "10.15.241.2",
        "mac": "OEMT3C62038A",
        "serial": "OEMT3C62038A",
        "queue": "queue1",
        "interface": "VLAN227_V_PARAISO_OLT1",
        "created_at": "2025-08-15T07:46:40.317400",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8722,
      "client_name": "YASMERI ZURAIKA YANEZ PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Prados I",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04127702379",
      "client_email": "YANEZYASMERI@GMAIL.COM",
      "address": "PRADOS DE PAYA I CALLE 15 NRO 06",
      "client_identification": "V7243647",
      "nap_box_name": "590 DOS",
      "created_at": "2025-08-15T14:32:57.388086",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8723,
      "client_name": "LUIS EDUARDO JULIO MOVILLA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Prados de Cafetal",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243215898",
      "client_email": "HONALOCKISM@GMAIL.COM",
      "address": "URBANIZACIÓN PRADOS DEL CAFETAL - CALLE 2 - PARCELA 56, CASA 6",
      "client_identification": "V25306168",
      "nap_box_name": "85",
      "created_at": "2025-08-15T19:27:31.373182",
      "service_detail": {
        "id": 9382,
        "ip": "10.15.243.2",
        "mac": "OEMT3C620F2E",
        "serial": "OEMT3C620F2E",
        "queue": "queue1",
        "interface": "VLAN221_CAFETAL_OLT1",
        "created_at": "2025-08-18T07:45:41.945307",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8724,
      "client_name": "WILLYAM EDUARDO BERROTERAN ALAC",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Payita",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04140470603",
      "client_email": "WILLYAMBERROTERAN@GMAIL.COM",
      "address": "CALLE PRINCIPAL CASA NÚMERO 33, SECTOR PAYITA.",
      "client_identification": "V8727254",
      "nap_box_name": "CTO - 1028",
      "created_at": "2025-08-16T13:12:49.829405",
      "service_detail": {
        "id": 9376,
        "ip": "10.15.123.2",
        "mac": "OEMT3C620672",
        "serial": "OEMT3C620672",
        "queue": "queue1",
        "interface": "VLAN284_PAYITA",
        "created_at": "2025-08-16T15:42:13.657751",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8725,
      "client_name": "MARIA EUGENIA LEAL SILVA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Callejon Lim",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04125054760",
      "client_email": "REYNADAVID.1959@GMAIL.COM",
      "address": "CALLEJÓN LIM 6 URBANIZACIÓN VILLA TURMERO TORRE AZUCENA PISO 2  APTO#  11",
      "client_identification": "V16345496",
      "nap_box_name": "CTO-0449",
      "created_at": "2025-08-16T18:43:43.459374",
      "service_detail": {
        "id": 9383,
        "ip": "10.15.244.2",
        "mac": "OEMT3C620B72",
        "serial": "OEMT3C620B72",
        "queue": "queue1",
        "interface": "VLAN250_LIM_OLT2",
        "created_at": "2025-08-18T07:48:14.907586",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8726,
      "client_name": "DILAN IVANOSKY ROMERO FELIU",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243047347",
      "client_email": "FELIUDILAN0812@GMAIL.COM",
      "address": "URBANISMO EZEQUIEL ZAMORA TORRE 8, PISO 3,  APARTAMENTO 2",
      "client_identification": "V28316559",
      "nap_box_name": "CTO-00513",
      "created_at": "2025-08-17T12:18:35.746019",
      "service_detail": {
        "id": 9384,
        "ip": "10.15.245.2",
        "mac": "HWTC392384A2",
        "serial": "HWTC392384A2",
        "queue": "queue1",
        "interface": "VLAN209_ZAMORA_OLT1",
        "created_at": "2025-08-18T07:51:36.353158",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8727,
      "client_name": "BLOOM FASHION 2025 CA",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 102,
        "name": "RECURRENTE PYME PLAN 150M",
        "cost": "27.60",
        "code": "FOP150M",
        "profile": "150Mbps/150Mbps"
      },
      "client_mobile": "04144920282",
      "client_email": "CARLAYENITZA@GMAIL.COM",
      "address": "CALLE RIBAS CRUCE CON CALLE MIRANDA LOCAL MAGORE NÚM 16-02 .",
      "client_identification": "J506069911",
      "nap_box_name": "CAJA NAP PLAZA SANTIAGO MARINO",
      "created_at": "2025-08-18T08:53:29.041617",
      "service_detail": {
        "id": 9386,
        "ip": "10.15.246.2",
        "mac": "OEMT3C620802",
        "serial": "OEMT3C620802",
        "queue": "queue1",
        "interface": "VLAN200_OLTs",
        "created_at": "2025-08-18T09:59:47.162000",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8728,
      "client_name": "GLADYS DEL CARMEN SALCEDO AGUIAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Taguapire",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04125063573",
      "client_email": "GLADYSAGUIAR75@GMAIL.COM",
      "address": "URBANIZACIÓN TAIGUAIPIRE EN EL MACARO 4 CALLE ÚLTIMO MODULO CASA 164",
      "client_identification": "V12768414",
      "nap_box_name": "CTO-00386",
      "created_at": "2025-08-18T09:59:43.439294",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8729,
      "client_name": "SERPUMAR DIRECCION",
      "client_type_name": "INTERCAMBIO",
      "client_subdivision": "ACTIVO_INTERCAMBIO",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": false,
      "sector_name": "Villeguita",
      "plan": {
        "id": 83,
        "name": "RECURRENTE INSTITUCIONAL 80M",
        "cost": "0.00",
        "code": "FO-R80",
        "profile": "80M/80M"
      },
      "client_mobile": "04162613992",
      "client_email": "SERPUMARDIRECCIONPARROQUIALDES@GMAIL.COM",
      "address": "AV INTERCOMUNAL SECTOR  VILLEGUITA TURMERO",
      "client_identification": "V14628940",
      "nap_box_name": "CE - 949",
      "created_at": "2025-08-18T10:43:11.923586",
      "service_detail": {
        "id": 9389,
        "ip": "10.15.122.2",
        "mac": "OEMT3C620C0A",
        "serial": "OEMT3C620C0A",
        "queue": "queue1",
        "interface": "VLAN238_VILLEGUITA",
        "created_at": "2025-08-18T11:00:14.781595",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8730,
      "client_name": "SERPUMAR ASUNTOS ELECTRICOS",
      "client_type_name": "INTERCAMBIO",
      "client_subdivision": "ACTIVO_INTERCAMBIO",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": false,
      "sector_name": "Villeguita",
      "plan": {
        "id": 83,
        "name": "RECURRENTE INSTITUCIONAL 80M",
        "cost": "0.00",
        "code": "FO-R80",
        "profile": "80M/80M"
      },
      "client_mobile": "04126474035",
      "client_email": "FRANKLINPADRINO65@GMAIL.COM",
      "address": "AV INTERCOMUNAL SECTOR VILLEGUITA TURMERO",
      "client_identification": "V5514713",
      "nap_box_name": "CE - 949",
      "created_at": "2025-08-18T11:11:56.339385",
      "service_detail": {
        "id": 9392,
        "ip": "10.15.248.2",
        "mac": "OEMT3C620B0A",
        "serial": "OEMT3C620B0A",
        "queue": "queue1",
        "interface": "VLAN238_VILLEGUITA",
        "created_at": "2025-08-18T14:45:22.396164",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8731,
      "client_name": "FRANCISMAR DAYANA GUAITA CARRILLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "1ro de Mayo Norte",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124069455",
      "client_email": "FRANCISDAYANA02@GMAIL.COM",
      "address": "ROSARIO DE PAYA PRIMERO DE MAYO NORTE SECTOR LOS JABILLOS VEREDA 1 CASA #6 PUNTO DE REFERENCIA DETRÁS DE LA IGLESIA",
      "client_identification": "V25501103",
      "nap_box_name": "CTO-00438",
      "created_at": "2025-08-19T09:51:51.162580",
      "service_detail": {
        "id": 9394,
        "ip": "10.15.252.2",
        "mac": "OEMT3C621012",
        "serial": "OEMT3C621012",
        "queue": "queue1",
        "interface": "VLAN261_1ERO_MAYO_ZTE",
        "created_at": "2025-08-19T10:30:01.631548",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8732,
      "client_name": "CHRISTOPHER GUGLLEIMELLI RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Los Caobos",
      "plan": {
        "id": 19,
        "name": "RECURRENTE RESIDENCIAL PLAN 1GB",
        "cost": "74.70",
        "code": "FOR1GB",
        "profile": "1000M/1000M"
      },
      "client_mobile": "04129324102",
      "client_email": "ING.GUGLIELMELLI@GMAIL.COM",
      "address": "CALLE LOS TULIPANES SECTOR LOS CAOBOS CASA 3",
      "client_identification": "V14454042",
      "nap_box_name": "CE - 546",
      "created_at": "2025-08-19T16:44:16.168785",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8733,
      "client_name": "HECTOR JOSE VASQUEZ CALDERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "SUSPENDIDO_RESIDENCIAL",
      "status_name": "Suspendido",
      "cycle": 1,
      "migrate": false,
      "sector_name": "La Concepcion",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243137630",
      "client_email": "HJVC06@GMAIL.COM",
      "address": "URBANIZACIÓN LA CONCEPCIÓN CALLE 3 CASA NRO 10",
      "client_identification": "V20959605",
      "nap_box_name": "108",
      "created_at": "2025-08-20T16:17:03.553998",
      "service_detail": {
        "id": 12336,
        "ip": "10.15.253.2",
        "mac": "TPLGF5CB08B2",
        "serial": "TPLGF5CB08B2",
        "queue": null,
        "interface": "VLAN111_CONCEPCION",
        "created_at": "2026-04-16T19:27:27.324392",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8734,
      "client_name": "ANGELIN COROMOTO LANZA MARTINEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "La Magdalena",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04123985483",
      "client_email": "ANGELINLANZA161@GMAIL.COM",
      "address": "SAN MIGUEL CACHIPÓN NORTE CALLE RICAURTE CASA NÚMERO 82",
      "client_identification": "V28432311",
      "nap_box_name": "CTO-00524",
      "created_at": "2025-08-21T09:03:34.099493",
      "service_detail": {
        "id": 11849,
        "ip": "10.15.254.2",
        "mac": "MONU003C55AD",
        "serial": "MONU003C55AD",
        "queue": null,
        "interface": "VLAN288_SAN_MIGUEL",
        "created_at": "2026-02-27T12:13:16.076296",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8735,
      "client_name": "DEYCI PAOLA ESCALONA DE SOLORZANO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Pantin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128991914",
      "client_email": "ESCALONADEYSI69@GMAIL.COM",
      "address": "URBANIZACIÓN PANTIN CALLE 8 CASA 19 POR LA CUADRA DE LA PREFECTURA",
      "client_identification": "V9676799",
      "nap_box_name": "CTO-00138",
      "created_at": "2025-08-21T09:07:04.442966",
      "service_detail": {
        "id": 12349,
        "ip": "10.15.255.2",
        "mac": "OEMT3C621172",
        "serial": "OEMT3C621172",
        "queue": null,
        "interface": "VLAN229_PANTIN",
        "created_at": "2026-04-17T19:59:55.408964",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8736,
      "client_name": "MOISES GIOVANNI MEDINA CELIS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "La Concepcion",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243679957",
      "client_email": "MOISESCELIS30@GMAIL.COM",
      "address": "TORRE 11 PISO1 URBANIZACIÓN LA CONCEPCIÓN",
      "client_identification": "V18702360",
      "nap_box_name": "0326",
      "created_at": "2025-08-21T10:12:32.875450",
      "service_detail": {
        "id": 9405,
        "ip": "10.16.1.2",
        "mac": "OEMT3C620D16",
        "serial": "OEMT3C620D16",
        "queue": "queue1",
        "interface": "VLAN111_CONCEPCION",
        "created_at": "2025-08-21T12:18:01.966523",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8737,
      "client_name": "DAVID JOSE TOVAR GUILARTE",
      "client_type_name": "EMPLEADO",
      "client_subdivision": "CANCELADO_EMPLEADO",
      "status_name": "Cancelado",
      "cycle": 10,
      "migrate": false,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 78,
        "name": "Plan empleado 80MB",
        "cost": "0.00",
        "code": "FO-80M",
        "profile": "80M/80M"
      },
      "client_mobile": "04125863406",
      "client_email": "TOVARDAVID550@GMAIL.COM",
      "address": "SAMAN TARAZONERO II MANZANA H CASA #22",
      "client_identification": "V30956290",
      "nap_box_name": "511",
      "created_at": "2025-08-21T11:01:11.767816",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8738,
      "client_name": "NAIRELIS DEL CARMEN PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Paraguatan",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243072832",
      "client_email": "NAIRELISP20@GMAIL.COM",
      "address": "GUAYABITA PARAGUATAN CALLE PRINCIPAL, SECTOR EL RINCÓN #25",
      "client_identification": "V19981930",
      "nap_box_name": "CTO - 1118",
      "created_at": "2025-08-21T11:25:43.426307",
      "service_detail": {
        "id": 9407,
        "ip": "10.16.4.2",
        "mac": "OEMT3C6205FA",
        "serial": "OEMT3C6205FA",
        "queue": "queue1",
        "interface": "VLAN283_PARAGUATAN",
        "created_at": "2025-08-21T12:22:41.447851",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8739,
      "client_name": "ANASTASIA VALENTINA YEPEZ JIMENEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04241105298",
      "client_email": "AVYG93@GMAIL.COM",
      "address": "CALLE BOLIVAR, RESIDENCIAS ABUDE PISO 1 APTO 2, PTO DE REFERENCIA AUTOREPUESTOS YATARAGUA",
      "client_identification": "V22358318",
      "nap_box_name": "CAJA NAP EDIFICIO ABUUT",
      "created_at": "2025-08-21T12:51:33.678011",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8740,
      "client_name": "YUNIOR JESUS TORTOZA APONCIO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Cambur",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128958367",
      "client_email": "YUNIORTORTOZA718@GMAIL.COM",
      "address": "ROSARIO DE PAYA VIA EL CAMBUR SECTOR LAS PALMAS CALLE EL TANQUE PARCELA 28 CASA NÚMERO 171",
      "client_identification": "V17247290",
      "nap_box_name": "CTO - 00521",
      "created_at": "2025-08-21T13:19:17.604617",
      "service_detail": {
        "id": 12845,
        "ip": "10.16.6.2",
        "mac": "VS:OL:00:52:2E:89",
        "serial": "VSOL00522E89",
        "queue": null,
        "interface": "VLAN236_PRADOS3",
        "created_at": "2026-08-15T14:19:03.051395",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8741,
      "client_name": "CESAR ANDREY GIL OLAVARRIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Saman de Guere",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04244290641",
      "client_email": "GILCESAR176@GMAIL.COM",
      "address": "SAMAN DE GUERE CALLE LA CEIBA CASA NRO 62.1B",
      "client_identification": "V20108442",
      "nap_box_name": "124",
      "created_at": "2025-08-21T19:07:15.880764",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8742,
      "client_name": "INVERSIONES CERAMIPEGO CA",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Las Rurales",
      "plan": {
        "id": 36,
        "name": "RECURRENTE PYME PLAN 650M",
        "cost": "70.18",
        "code": "FOP650M",
        "profile": "650M/650M"
      },
      "client_mobile": "04128907125",
      "client_email": "ADMONCERAMIPEGO@GMAIL.COM",
      "address": "AV. INTERCOMUNAL DE PAYA, LOCAL LOTE «E», PARCELA NRO 35, SECTOR EL BOSQUE, LAS RURALES DE PAYA, TURMERO, EDO. ARAGUA.",
      "client_identification": "J295598599",
      "nap_box_name": "CTO-00241",
      "created_at": "2025-08-25T18:11:57.447886",
      "service_detail": {
        "id": 9423,
        "ip": "10.16.8.2",
        "mac": "OEMT3C620412",
        "serial": "OEMT3C620412",
        "queue": "queue1",
        "interface": "VLAN252_RURALES_PAYA",
        "created_at": "2025-08-25T21:08:00.833559",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8743,
      "client_name": "MOISELIS VANESSA LOPEZ CASTILLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Simon Bolivar",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04127416207",
      "client_email": "MOISELISLOPEZ123@GMAIL.COM",
      "address": "SIMÓN BOLIVAR CALLE 7 CASA 45, EL MACARO.",
      "client_identification": "V25066174",
      "nap_box_name": "CTO-00025",
      "created_at": "2025-08-26T08:49:11.013487",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8744,
      "client_name": "MARTHA BELISA CASTRO DE GOMEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Macarena",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124639207",
      "client_email": "BELISACASTRO1103@GMAIL.COM",
      "address": "CALLE 2 CASA NRO 14 LA MACARENA II",
      "client_identification": "V9665276",
      "nap_box_name": "444",
      "created_at": "2025-08-26T09:22:07.446240",
      "service_detail": {
        "id": 9430,
        "ip": "10.16.11.2",
        "mac": "OEMT3C62106A",
        "serial": "OEMT3C62106A",
        "queue": "queue1",
        "interface": "VLAN112_LA_MACARENA_ZTE",
        "created_at": "2025-08-26T16:18:34.633606",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8745,
      "client_name": "ALFREDO ALEJANDRO VEGAS ALBORNOZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Los Caobos",
      "plan": {
        "id": 101,
        "name": "RECURRENTE RESIDENCIAL PLAN 200M",
        "cost": "19.00",
        "code": "FOR200MB",
        "profile": "200Mbps/200Mbps"
      },
      "client_mobile": "04122928992",
      "client_email": "ALFREDOVEGAS1808@GMAIL.COM",
      "address": "CALLE LOS TULIPANES CASA NRO 22 SECTOR LOS CAOBOS II TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V27712684",
      "nap_box_name": "CE - 546",
      "created_at": "2025-08-26T14:46:01.115543",
      "service_detail": {
        "id": 10937,
        "ip": "172.25.31.2",
        "mac": "OEMT3C625886",
        "serial": "OEMT3C625886",
        "queue": null,
        "interface": "VLAN116_CAOBOS",
        "created_at": "2025-12-25T16:02:16.440109",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8746,
      "client_name": "DANIELA DEL CARMEN RODRIGUEZ JARABA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243252807",
      "client_email": "RODRIGUEZDANIELLA997@GMAIL.COM",
      "address": "CALLE 12 APARTAMENTO 665 B MATA CABALLO",
      "client_identification": "V27518461",
      "nap_box_name": "CTO-00020",
      "created_at": "2025-08-27T13:04:07.490944",
      "service_detail": {
        "id": 12080,
        "ip": "10.16.13.2",
        "mac": "HWTC229F1686",
        "serial": "HWTC229F1686",
        "queue": null,
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2026-03-15T16:45:31.703740",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8747,
      "client_name": "ROSSANA LORENA TURTULICI BOSCAN",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villa Caribe",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128820796",
      "client_email": "ROSSANALTB@GMAIL.COM",
      "address": "URB VILLA CARIBE CALLE 2 #34",
      "client_identification": "V10756719",
      "nap_box_name": "57",
      "created_at": "2025-08-27T19:50:08.897935",
      "service_detail": {
        "id": 9435,
        "ip": "10.16.14.2",
        "mac": "OEMT3C620432",
        "serial": "OEMT3C620432",
        "queue": "queue1",
        "interface": "VLAN228_V_CARIBE_OLT1",
        "created_at": "2025-08-27T21:04:45.919348",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8748,
      "client_name": "INVERSIONES GOLDEN 3 CA",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04144905577",
      "client_email": "CAROLINADEBETANCOURT@GMAIL.COM",
      "address": "SECTOR PANTIN , AVENIDA PRINCIPAL, LOCAL 1.",
      "client_identification": "J501908885",
      "nap_box_name": "CE-00048",
      "created_at": "2025-08-28T12:25:48.319108",
      "service_detail": {
        "id": 9441,
        "ip": "10.16.16.2",
        "mac": "OEMT3C624472",
        "serial": "OEMT3C624472",
        "queue": "queue1",
        "interface": "VLAN229_PANTIN",
        "created_at": "2025-08-29T10:11:13.278166",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8749,
      "client_name": "JORGE ALEXANDER TORRES SAAVEDRA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "SUSPENDIDO_RESIDENCIAL",
      "status_name": "Suspendido",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Valle lindo",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04244642419",
      "client_email": "JATSCA@GMAIL.COM",
      "address": "URB VALLE LINDO SECTOR 3 CALLE 2 CASA N 9-1",
      "client_identification": "V13732698",
      "nap_box_name": "CTO - 1010",
      "created_at": "2025-08-28T21:48:01.309048",
      "service_detail": {
        "id": 9440,
        "ip": "10.16.15.2",
        "mac": "QXTLCB75752C",
        "serial": "QXTLCB75752C",
        "queue": "queue1",
        "interface": "VLAN274_VALLELINDO",
        "created_at": "2025-08-29T08:09:16.627605",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8750,
      "client_name": "YOSKARLY NAZARETH SILVA GONZALEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Polvorin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04122034613",
      "client_email": "CESARISAACY@GMAIL.COM",
      "address": "GUAYABITA POLVORIN, CALLE 3 DE MAYO, CASA # 5-3",
      "client_identification": "V26081531",
      "nap_box_name": "CTO-00354",
      "created_at": "2025-08-31T17:39:02.254871",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8751,
      "client_name": "ZULEIDA JOSEFINA ARRIOJAS GUTIERREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Taguapire",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124309464",
      "client_email": "ARRIOJASZULEIDA@GMAIL.COM",
      "address": "URBANIZACIÓN TAGUAPIRE CALLE 1 Nº 18",
      "client_identification": "V7236095",
      "nap_box_name": "CTO-00388 DOS",
      "created_at": "2025-09-02T20:49:26.231038",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8752,
      "client_name": "ALEX VINNY RUIZ TOME",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128836684",
      "client_email": "ALEXV.RUIZ1997@GMAIL.COM",
      "address": "CONJUNTO RESIDENCIAL LOS NÍSPEROS TORRE A PISO 7 APARTAMENTO 7-5 AL LADO DEL POLICLÍNICO TURMERO",
      "client_identification": "V25880717",
      "nap_box_name": "TORRE A EDIF LOS NISPEROS",
      "created_at": "2025-09-02T20:52:10.557526",
      "service_detail": {
        "id": 9466,
        "ip": "10.16.22.2",
        "mac": "OEMT3C6209B2",
        "serial": "OEMT3C6209B2",
        "queue": "queue1",
        "interface": "VLAN272_EDIF_NISPEROS_OLT3",
        "created_at": "2025-09-03T08:19:59.213737",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8753,
      "client_name": "MARIELA ELENA CORDOVA PINANGO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Valle lindo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243473047",
      "client_email": "MECORDOVAP5@GMAIL.COM",
      "address": "SECTOR 5 CALLE 2 CASA 22 URBANIZACIÓN VALLE LINDO",
      "client_identification": "V18778231",
      "nap_box_name": "CE - 286",
      "created_at": "2025-09-02T20:59:40.491866",
      "service_detail": {
        "id": 9467,
        "ip": "10.16.23.2",
        "mac": "MONU004BDA35",
        "serial": "MONU004BDA35",
        "queue": "queue1",
        "interface": "VLAN274_VALLELINDO",
        "created_at": "2025-09-03T08:23:55.709287",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8754,
      "client_name": "BARBARA GABRIELA MONTEVERDE REGGIO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Residencias Candys",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243323556",
      "client_email": "BARBARAMONTEVERDE25@GMAIL.COM",
      "address": "RESIDENCIAS CANDY II APARTAMENTO 1-1, TUMERO",
      "client_identification": "V19208726",
      "nap_box_name": "CTO-0516",
      "created_at": "2025-09-02T21:09:32.538104",
      "service_detail": {
        "id": 9462,
        "ip": "10.16.20.2",
        "mac": "HWTCD199569A",
        "serial": "HWTCD199569A",
        "queue": "queue1",
        "interface": "VLAN254_CANDYS_OLT1",
        "created_at": "2025-09-02T22:50:24.834918",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8755,
      "client_name": "ERICK ANTHONY ESCALANTE ZACARIAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Polvorin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243145507",
      "client_email": "ESCALANTESERICK4@GMAIL.COM",
      "address": "GUAYABITA VIA POLVORÍN SECTOR LOS HICACOS PARCELA N 16",
      "client_identification": "V21465146",
      "nap_box_name": "CTO - 1484",
      "created_at": "2025-09-02T21:17:58.073777",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8756,
      "client_name": "MILAGRO DEL CARMEN MENESES FLORES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Polvorin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144443535",
      "client_email": "MENESESFLORESMILAGRO@GMAIL.COM",
      "address": "CALLE 3 DE MAYO CASA N 29-D",
      "client_identification": "V10757707",
      "nap_box_name": "CTO - 992",
      "created_at": "2025-09-02T21:43:12.472158",
      "service_detail": {
        "id": 9468,
        "ip": "10.16.24.2",
        "mac": "OEMT3C620DB2",
        "serial": "OEMT3C620DB2",
        "queue": "queue1",
        "interface": "VLAN280_POLVORIN",
        "created_at": "2025-09-03T08:25:03.204283",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8757,
      "client_name": "ROBERT PORFIRIO MATAS ACOSTA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Vallecito",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144920179",
      "client_email": "ROBERTMATA425@GMAIL.COM",
      "address": "COLINAS DE VALLECITO CALLE LAS ACACIAS #10 ROSARIO DE PAYA",
      "client_identification": "V9436138",
      "nap_box_name": "CTO-00465",
      "created_at": "2025-09-02T21:46:38.322506",
      "service_detail": {
        "id": 9461,
        "ip": "10.12.127.2",
        "mac": "HWTC49200813",
        "serial": "HWTC49200813",
        "queue": "queue1",
        "interface": "VLAN258_VALLECITO",
        "created_at": "2025-09-02T22:31:05.248813",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8758,
      "client_name": "YELITZA MARIA CALDERAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "SUSPENDIDO_RESIDENCIAL",
      "status_name": "Suspendido",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona II Edificios",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04261354130",
      "client_email": "apdisamandeguerecomandante@gmail.com",
      "address": "AV INTERCOMUNICAL EDIFICIO 10 PISO PB APARTAMENTO 2 URBANIZACIÓN LA CASONA II",
      "client_identification": "V13903781",
      "nap_box_name": "CTO-00145",
      "created_at": "2025-09-02T21:48:35.359765",
      "service_detail": {
        "id": 12974,
        "ip": "10.16.19.2",
        "mac": "MO:NU:00:4B:46:7D",
        "serial": "MONU004B467D",
        "queue": null,
        "interface": "VLAN110_CASONA_2",
        "created_at": "2026-09-03T16:25:33.896955",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8759,
      "client_name": "ILDEMAR ALBERTO ALBARRAN BELISARIO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Cambur",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04167048155",
      "client_email": "ILDEMARALBARRAN978@GMAIL.COM",
      "address": "ROSARIO DE PAYA, CALLE PRINCIPAL EL CAMBUR. CASA #47",
      "client_identification": "V15601363",
      "nap_box_name": "CTO-00150",
      "created_at": "2025-09-02T21:52:39.197263",
      "service_detail": {
        "id": 12810,
        "ip": "10.16.25.2",
        "mac": "HW:TC:96:A3:06:88",
        "serial": "HWTC96A30688",
        "queue": null,
        "interface": "VLAN263_EL_CAMBUR",
        "created_at": "2026-08-08T13:27:35.083109",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8760,
      "client_name": "YURENCY ELINOR RIVERO VERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Luz y Vida",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144911493",
      "client_email": "YURENCYERV12.81@GMAIL.COM",
      "address": "ROSARIO DE PAYA SECTOR LUZ Y VIDA CALLE 1 CASA NRO 62.",
      "client_identification": "V16011227",
      "nap_box_name": "CTO - 73",
      "created_at": "2025-09-03T14:24:59.620150",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8761,
      "client_name": "TOMAS ENRIQUE BORGES RODRIGUEZ",
      "client_type_name": "GRATIS",
      "client_subdivision": "ACTIVO_GRATIS",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": false,
      "sector_name": "Saman Tarazonero I",
      "plan": {
        "id": 86,
        "name": "PLAN RECURRENTE 80M GRATIS",
        "cost": "0.00",
        "code": "FO-G80",
        "profile": "80M/80M"
      },
      "client_mobile": "04267054007",
      "client_email": "BORGESTOMAS759@GMAIL.COM",
      "address": "CALLE 3 CASA NRO 29 URB SAMAN TARAZPNERO I TURMERO",
      "client_identification": "V7176813",
      "nap_box_name": "291",
      "created_at": "2025-09-03T16:15:55.387473",
      "service_detail": {
        "id": 9474,
        "ip": "10.16.28.2",
        "mac": "ZXICC3D37C79",
        "serial": "ZXICC3D37C79",
        "queue": "queue1",
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2025-09-04T16:27:56.741446",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8762,
      "client_name": "JOSE CARLOS LAVIN AJA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Guayabita",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243145507",
      "client_email": "CARLOS_LAVIN@GMIAL.COM",
      "address": "GUAYABITA VÍA POLVORÍN SECTOR LOS HICACOS PARCELA 2",
      "client_identification": "E926828",
      "nap_box_name": "CE-00164",
      "created_at": "2025-09-03T17:19:23.465387",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8763,
      "client_name": "ROSAURA CASTILLO BARRIOS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vallecito",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128208933",
      "client_email": "ROSAURACASTILLO1245@GMAIL.COM",
      "address": "ROSARIO DE PAYA CALLE MORICHE N19 SECTOR VALLECITO",
      "client_identification": "V14389446",
      "nap_box_name": "CTO - 80",
      "created_at": "2025-09-04T14:23:23.250826",
      "service_detail": {
        "id": 9473,
        "ip": "10.16.29.2",
        "mac": "OEMT3C620392",
        "serial": "OEMT3C620392",
        "queue": "queue1",
        "interface": "VLAN258_VALLECITO",
        "created_at": "2025-09-04T16:13:25.769074",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8764,
      "client_name": "INVERSIONES INFINITY COFFEE STORE CA",
      "client_type_name": "PYME",
      "client_subdivision": "SUSPENDIDO_PYME",
      "status_name": "Suspendido",
      "cycle": 10,
      "migrate": true,
      "sector_name": "La Concepcion",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04127827437",
      "client_email": "INFINITYCOFFESTORE@GMAIL.COM",
      "address": "Av intercomunal calle el canal local N 1 sector la concepción",
      "client_identification": "J412506960",
      "nap_box_name": "CE-1087",
      "created_at": "2025-09-04T17:21:20.812777",
      "service_detail": {
        "id": 9934,
        "ip": "10.16.26.2",
        "mac": "OEMT3C621072",
        "serial": "OEMT3C621072",
        "queue": null,
        "interface": "VLAN111_CONCEPCION",
        "created_at": "2025-11-11T08:50:59.035416",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8765,
      "client_name": "ROCKDIN HEYAN TEICEIRA SCORTINO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Los Nisperos",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04128907702",
      "client_email": "ROCKDIN2023@GMAIL.COM",
      "address": "URBANIZACIÓN EL NÍSPERO 1ERA ETAPA CASA # 1",
      "client_identification": "V18443476",
      "nap_box_name": "CTO-00211",
      "created_at": "2025-09-04T21:55:30.590256",
      "service_detail": {
        "id": 9813,
        "ip": "172.31.144.2",
        "mac": "OEMT3C622CCA",
        "serial": "OEMT3C622CCA",
        "queue": null,
        "interface": "VLAN218_NISPEROS_OLT1",
        "created_at": "2025-11-10T16:46:29.234796",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8766,
      "client_name": "RAFAEL ALFREDO ORDONEZ  ARRIOJAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Turmerito",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243516227",
      "client_email": "RAFAEL86@GMAIL.COM",
      "address": "TURMERITO CALLE PERICOCO N°86",
      "client_identification": "V12169473",
      "nap_box_name": "587",
      "created_at": "2025-09-04T21:59:49.457151",
      "service_detail": {
        "id": 11768,
        "ip": "10.16.33.2",
        "mac": "HWTC7B80C17B",
        "serial": "HWTC7B80C17B",
        "queue": null,
        "interface": "VLAN137_LA_ESPERANZA_OLT_ZTE",
        "created_at": "2026-02-27T10:12:56.819695",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8767,
      "client_name": "‎ZULAY MARGARITA MORALES DE MARQUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Simon Bolivar",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04143460559",
      "client_email": "ZULAYMORALES04@GMAIL.COM",
      "address": "SIMÓN BOLÍVAR,CALLE 4 , CASA N° 47",
      "client_identification": "V9647784",
      "nap_box_name": "CTO-00047",
      "created_at": "2025-09-04T22:18:58.223574",
      "service_detail": {
        "id": 9479,
        "ip": "10.16.34.2",
        "mac": "OEMT3C6245CA",
        "serial": "OEMT3C6245CA",
        "queue": "queue1",
        "interface": "VLAN128_SIMON_BOLIVAR_ZTE",
        "created_at": "2025-09-05T08:15:10.620208",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8768,
      "client_name": "MARIA JOSE HERNANDEZ BOLIVAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Callejon Lim",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243361449",
      "client_email": "MARI0284@GMAIL.COM",
      "address": "URBANIZACION VILLAS DE TURMERO, EDIFICIO AZUCENA. PLANTA BAJA APARTAMENTO 4",
      "client_identification": "V16760792",
      "nap_box_name": "TORRE AZUCENA",
      "created_at": "2025-09-04T22:31:44.854585",
      "service_detail": {
        "id": 9480,
        "ip": "10.16.35.2",
        "mac": "OEMT3C624F82",
        "serial": "OEMT3C624F82",
        "queue": "queue1",
        "interface": "VLAN250_LIM_OLT2",
        "created_at": "2025-09-05T08:17:10.944206",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8769,
      "client_name": "CLAUDITH JOSELIN PAEZ ACEVEDO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124623085",
      "client_email": "CLAUJOSELINPAEZACEVEDO@GMAIL.COM",
      "address": "CALLE CARRENO NORTE HACIENDA LOS NÍSPEROS TURMERO PISO 2 APART 01 TORRE 19",
      "client_identification": "V13553731",
      "nap_box_name": "1",
      "created_at": "2025-09-04T22:35:53.098161",
      "service_detail": {
        "id": 13159,
        "ip": "10.16.36.2",
        "mac": "OE:MT:3C:62:0A:5A",
        "serial": "OEMT3C620A5A",
        "queue": null,
        "interface": "VLAN209_ZAMORA_OLT1",
        "created_at": "2026-10-13T13:10:04.230988",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8770,
      "client_name": "JOSE ASENCION ALVAREZ NORENO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Arboleda",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04123692330",
      "client_email": "JOSEALVAREZ4855A@GMAIL.COM",
      "address": "SECTOR LA ARBOLEDA CALLE LOS COCOS CASA#60 ROSARIO DE PAYA",
      "client_identification": "V4855676",
      "nap_box_name": "CTO-00236",
      "created_at": "2025-09-04T22:41:02.028108",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8776,
      "client_name": "MIGUEL DAVID ALBARRAN CARDENAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "PAUSADO_RESIDENCIAL",
      "status_name": "Pausado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Salto Angel",
      "plan": {
        "id": 16,
        "name": "RECURRENTE RESIDENCIAL PLAN 800M",
        "cost": "55.00",
        "code": "FOR800",
        "profile": "800M/800M"
      },
      "client_mobile": "04243411057",
      "client_email": "MIGUELDAVID636@GMAIL.COM",
      "address": "URB SALTO ANGEL CALLE LOS ROBLES MANZANA 05 CASA 15",
      "client_identification": "V14908636",
      "nap_box_name": "478",
      "created_at": "2025-09-06T13:41:46.265515",
      "service_detail": {
        "id": 9491,
        "ip": "10.16.39.2",
        "mac": "OEMT3C620362",
        "serial": "OEMT3C620362",
        "queue": "queue1",
        "interface": "VLAN121_S_ANGEL",
        "created_at": "2025-09-08T12:46:21.269803",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8777,
      "client_name": "YANLIS YUDERQUIS BARRIOS GOMEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "El Macaro",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04145952092",
      "client_email": "YANLISBARRIOS@GMAIL.COM",
      "address": "CALLE 01 CASA 01 URBANIZACIÓN VILLA DEL MACARO",
      "client_identification": "V19110242",
      "nap_box_name": "CTO-0X0X0",
      "created_at": "2025-09-06T14:12:37.350649",
      "service_detail": {
        "id": 11193,
        "ip": "10.16.40.2",
        "mac": "OEMT3C624C46",
        "serial": "OEMT3C624C46",
        "queue": null,
        "interface": "VLAN104_EL_MACARO_OLT_ZTE",
        "created_at": "2026-01-16T08:40:29.309461",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8782,
      "client_name": "LUIS EDUARDO ZAMORA PADRINO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Prados II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04122599664",
      "client_email": "LUISZAMORAP13@GMAIL.COM",
      "address": "SECTOR PRADOS DE PAYA II, CALLE 2 CASA 8",
      "client_identification": "V19516432",
      "nap_box_name": "CTO-00205 DOS",
      "created_at": "2025-09-08T15:52:40.982994",
      "service_detail": {
        "id": 9492,
        "ip": "10.16.41.2",
        "mac": "OEMT3C62109A",
        "serial": "OEMT3C62109A",
        "queue": "queue1",
        "interface": "VLAN242_PRADOS2",
        "created_at": "2025-09-08T20:49:35.390831",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8783,
      "client_name": "EDWARD REINALDO FERNANDEZ GUILLEN",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "La Esperanza",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04123411995",
      "client_email": "FERNADEZEDWARD85@GMAIL.COM",
      "address": "CALLE 21 CASA 20 URB LA ESPERANZA SECTOR EL MACARO PUNTO DE REFERENCIA AL LADO DE LA UPEL .",
      "client_identification": "V17247058",
      "nap_box_name": "555",
      "created_at": "2025-09-08T17:36:13.235870",
      "service_detail": {
        "id": 9493,
        "ip": "10.16.42.2",
        "mac": "OEMT3C620926",
        "serial": "OEMT3C620926",
        "queue": "queue1",
        "interface": "VLAN137_LA_ESPERANZA_OLT_ZTE",
        "created_at": "2025-09-08T20:52:36.159549",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8784,
      "client_name": "ELXY MALYARY APONTE APONTE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Polvorin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243185973",
      "client_email": "ELXY25@GMAIL.COM",
      "address": "CALLE PRINCIPAL CASA #11-1 SECTOR POLVORÍN GUAYABITA",
      "client_identification": "V15084894",
      "nap_box_name": "CTO - 987",
      "created_at": "2025-09-08T18:31:42.176793",
      "service_detail": {
        "id": 9494,
        "ip": "10.16.43.2",
        "mac": "OEMT3C6251F2",
        "serial": "OEMT3C620925",
        "queue": "queue1",
        "interface": "VLAN280_POLVORIN",
        "created_at": "2025-09-08T20:55:44.920650",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8785,
      "client_name": "MASA BISTRO CA",
      "client_type_name": "PYME",
      "client_subdivision": "CANCELADO_PYME",
      "status_name": "Cancelado",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04141070158",
      "client_email": "TORREALBAYASOCIADOS.CP@GMAIL.COM",
      "address": "AV PRINCIPAL ROSARIO DE PAYA, URB PANTY,",
      "client_identification": "J410961740",
      "nap_box_name": "CE-00048",
      "created_at": "2025-09-09T09:49:46.540729",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8791,
      "client_name": "NORKA DAYANA CAMPO MEDINA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villa De San Jose",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "0414 5894879",
      "client_email": "CAMPONORKA4@GMAIL.COM",
      "address": "URBANIZACIÓN VILLA SAN JOSE CALLE PRINCIPAL NÚMERO  0409",
      "client_identification": "V11086922",
      "nap_box_name": "396",
      "created_at": "2025-09-09T19:36:52.365398",
      "service_detail": {
        "id": 9502,
        "ip": "10.16.32.2",
        "mac": "OEMT3C620506",
        "serial": "OEMT3C620506",
        "queue": "queue1",
        "interface": "VLAN134_VILLAS_DSJ_OLT_ZTE",
        "created_at": "2025-09-09T20:56:22.168837",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8792,
      "client_name": "FRANKLIN ERNESTO GONZALEZ YEPEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Taguapire",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243657349",
      "client_email": "MARILYNJIMENEZ07@HOTMAIL.COM",
      "address": "URB. TAGUAPIRE CALLE 3 APTO 81 SECTOR EL MACARO TURMERO",
      "client_identification": "V16849461",
      "nap_box_name": "CTO-00386",
      "created_at": "2025-09-09T19:45:25.725657",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8793,
      "client_name": "YOHANA DESIRE HERNANDEZ DURAN",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Los Mangos",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121491568",
      "client_email": "YOHAHERNANDEZ07@GMAIL.COM",
      "address": "CALLE LAS BRISAS CASA PARCELA NR 03 SECTOR LOS MANGOS",
      "client_identification": "V17247087",
      "nap_box_name": "CTO-00MAN",
      "created_at": "2025-09-09T21:05:47.529383",
      "service_detail": {
        "id": 9504,
        "ip": "10.16.46.2",
        "mac": "OEMT3C62069E",
        "serial": "OEMT3C62069E",
        "queue": "queue1",
        "interface": "VLAN267_LOS_MANGOS_ZTE",
        "created_at": "2025-09-10T08:55:16.609129",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8794,
      "client_name": "ALBA MARINA ESPINOZA VARGAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Paraguatan",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124575258",
      "client_email": "ESPINOZAMARINA731@GMAIL.COM",
      "address": "GUAYABITA. POLVORIN . PARAGUATAN  . CALLE EL RINCÓN NÚMERO.  22 .",
      "client_identification": "V19136381",
      "nap_box_name": "CTO - 1118",
      "created_at": "2025-09-09T21:14:20.892038",
      "service_detail": {
        "id": 10911,
        "ip": "10.16.47.2",
        "mac": "QXTLCB1B9B76",
        "serial": "QXTLCB1B9B76",
        "queue": null,
        "interface": "VLAN283_PARAGUATAN",
        "created_at": "2025-12-23T13:20:34.810553",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8795,
      "client_name": "MAIKEL XAVIER ALBERTO DIAZ ALFONZO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Manirito",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243687083",
      "client_email": "DIAZMAIKEL050@GMAIL.COM",
      "address": "VÍA GUAYABITA POLVORÍN SECTOR MANIRITO CALLE PRINCIPAL CASA #13-4",
      "client_identification": "V28097956",
      "nap_box_name": "CTO - 1089",
      "created_at": "2025-09-09T21:25:19.658193",
      "service_detail": {
        "id": 9506,
        "ip": "10.16.48.2",
        "mac": "OEMT3C6202E2",
        "serial": "OEMT3C6202E2",
        "queue": "queue1",
        "interface": "VLAN285_MANIRITO",
        "created_at": "2025-09-10T09:02:26.669269",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8796,
      "client_name": "ANGELICA DEL VALLE ORTEGA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "San Pablo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124549211",
      "client_email": "LUISNM20356@GMAIL.COM",
      "address": "URB SAN PABLO, MANZANA 3, PARCELA 17. TURMERO",
      "client_identification": "V19701025",
      "nap_box_name": "CTO-0637",
      "created_at": "2025-09-10T09:00:41.179052",
      "service_detail": {
        "id": 9507,
        "ip": "10.16.49.2",
        "mac": "OEMT3C620B6E",
        "serial": "OEMT3C620B6E",
        "queue": "queue1",
        "interface": "VLAN224_SAN_PABLO_OLT1",
        "created_at": "2025-09-10T09:04:16.288495",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8798,
      "client_name": "YHOSSELLYN VANESA PEREZ JIMENEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Saman Tarazonero I",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04143840349",
      "client_email": "YHOSSELLYNP@GMAIL.COM",
      "address": "SAMAN TARAZONERA PRUEBA, CALLE, CASA",
      "client_identification": "V25066218",
      "nap_box_name": "CTO-00256",
      "created_at": "2025-09-10T14:22:28.194171",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8799,
      "client_name": "JACK HANNA KHABBASE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 16,
        "name": "RECURRENTE RESIDENCIAL PLAN 800M",
        "cost": "55.00",
        "code": "FOR800",
        "profile": "800M/800M"
      },
      "client_mobile": "04144908479",
      "client_email": "JACKHANNA1969@GMAIL.COM",
      "address": "CALLE URDANETA RESIDENCIA NELLY PISO 2 APTO 7 CASCO TURMERO, PUNTO DE REFERENCIA DONDE QUEDABA EL ANTIGUO SAN DIEGO.",
      "client_identification": "V9435196",
      "nap_box_name": "CAJA NAP BICENTENARIO",
      "created_at": "2025-09-10T14:41:33.047395",
      "service_detail": {
        "id": 12672,
        "ip": "10.16.52.2",
        "mac": "OE:MT:3C:62:0A:6A",
        "serial": "OEMT3C620A6A",
        "queue": null,
        "interface": "VLAN200_OLTs",
        "created_at": "2026-07-04T11:58:23.274578",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8800,
      "client_name": "FARMACIA SOLUFARMA 2024 CA",
      "client_type_name": "PYME",
      "client_subdivision": "SUSPENDIDO_PYME",
      "status_name": "Suspendido",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 103,
        "name": "RECURRENTE PYME PLAN 400M",
        "cost": "51.74",
        "code": "FOP400M",
        "profile": "400Mbps/400Mbps"
      },
      "client_mobile": "04128728325",
      "client_email": "FERBT1990@GMAIL.COM",
      "address": "CASCO DE TURMERO , CALLE RIVAS LOCAL NR 7-A",
      "client_identification": "J506396955",
      "nap_box_name": "CE - 758",
      "created_at": "2025-09-11T12:33:42.587341",
      "service_detail": {
        "id": 9539,
        "ip": "10.16.53.2",
        "mac": "OEMT3C620382",
        "serial": "OEMT3C620382",
        "queue": "queue1",
        "interface": "VLAN200_OLTs",
        "created_at": "2025-09-18T19:19:24.377997",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8801,
      "client_name": "YENNIFER ALEXANDRA VALDERRAMA SANCHEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Polvorin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04120847743",
      "client_email": "YVALDERRAMA590@GMAIL.COM",
      "address": "POLVORÍN \nCALLE SANTA EDUVIGES \nCASA #16",
      "client_identification": "V27048453",
      "nap_box_name": "CTO - 992",
      "created_at": "2025-09-11T12:49:52.684828",
      "service_detail": {
        "id": 12712,
        "ip": "10.16.54.2",
        "mac": "68:9F:F0:2A:81:AF",
        "serial": "ZXICCDC2C9E4",
        "queue": null,
        "interface": "VLAN280_POLVORIN",
        "created_at": "2026-07-09T10:54:26.045481",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8802,
      "client_name": "IVAN FALCON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Las Rurales",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243173116",
      "client_email": "DOMINGUEZBECTALIS4@GMAIL.COM",
      "address": "CALLE 103 CASA NR 73 SECTOR LAS RURALES NUEVAS",
      "client_identification": "V5262883",
      "nap_box_name": "CTO-00406",
      "created_at": "2025-09-11T12:53:41.143651",
      "service_detail": {
        "id": 9515,
        "ip": "10.16.45.2",
        "mac": "OEMT3C62099E",
        "serial": "OEMT3C62099E",
        "queue": "queue1",
        "interface": "VLAN252_RURALES_PAYA",
        "created_at": "2025-09-11T15:26:56.363011",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8803,
      "client_name": "STUDIOS 412 MOLINA F P",
      "client_type_name": "PYME",
      "client_subdivision": "CANCELADO_PYME",
      "status_name": "Cancelado",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 102,
        "name": "RECURRENTE PYME PLAN 150M",
        "cost": "27.60",
        "code": "FOP150M",
        "profile": "150Mbps/150Mbps"
      },
      "client_mobile": "0412-4621381",
      "client_email": "MOLINAVICTORIA439@GMAIL.COM",
      "address": "CALLE CARRENO C.C CONCEPCION LOCAL # 13 TURMERO ARAGUA",
      "client_identification": "V281872687",
      "nap_box_name": "CTO-00266",
      "created_at": "2025-09-12T09:58:02.476150",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8805,
      "client_name": "JUAN JESUS SOSA MEZA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Brisas de Paya",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04122230871",
      "client_email": "JUANSOSAJHONNARY667@GMAIL.COM",
      "address": "CALLE 1 MANZANA 2 DETRÁS DEL TOVAREÑO",
      "client_identification": "V18701379",
      "nap_box_name": "369",
      "created_at": "2025-09-16T10:29:11.086811",
      "service_detail": {
        "id": 9526,
        "ip": "10.13.82.2",
        "mac": "OEMT3C620ADA",
        "serial": "OEMT3C620ADA",
        "queue": "queue1",
        "interface": "VLAN241_BRISAS",
        "created_at": "2025-09-16T13:41:18.535542",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8806,
      "client_name": "MARIA ALEJANDRA MIRATRIZ GUERRA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04128182414",
      "client_email": "IAMFERRER489@GMAIL.COM",
      "address": "URBANIZACIÓN ANTIGUA HACIENDA EL NÍSPERO (EZEQUIEL ZAMORA) \nTORRE 29 PISO 4 APARTAMENTO 1",
      "client_identification": "V29547640",
      "nap_box_name": "CTO-00207 DOS",
      "created_at": "2025-09-16T11:47:34.916993",
      "service_detail": {
        "id": 12956,
        "ip": "10.16.56.2",
        "mac": "OE:MT:3C:62:11:1E",
        "serial": "OEMT3C62111E",
        "queue": null,
        "interface": "VLAN209_ZAMORA_OLT1",
        "created_at": "2026-09-02T16:59:39.649064",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8807,
      "client_name": "DEISIS YELISMAR MANRIQUE PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "La Casona II",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04120603132",
      "client_email": "DEISISYMANRIQUET@GMAIL.COM",
      "address": "CALLE EL PROGRESO TORRE 2 PISO 3 . URBANIZACIÓN LA CASONA II TURMERO",
      "client_identification": "V145653350",
      "nap_box_name": "CTO-0536",
      "created_at": "2025-09-16T11:53:26.061283",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8808,
      "client_name": "ALIMENTOS INTERNACIONALES SM Y SL",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "San Pablo",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04243649599",
      "client_email": "JUAN.GARCIA@ALIMENTOSVE.COM",
      "address": "ZONA INDUSTRIAL SUR, GALPÓN 4",
      "client_identification": "J001306935",
      "nap_box_name": "55",
      "created_at": "2025-09-16T14:30:32.101849",
      "service_detail": {
        "id": 12766,
        "ip": "10.16.55.2",
        "mac": "ZX:IC:CD:62:C9:AB",
        "serial": "ZXICCD62C9AB",
        "queue": null,
        "interface": "VLAN224_SAN_PABLO_OLT1",
        "created_at": "2026-07-23T10:20:45.315263",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8809,
      "client_name": "DIONY JOSE ZURITA PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Santa Eduviges",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04123868633",
      "client_email": "YMARTINEZCUENCA@GMAIL.COM",
      "address": "PRINCIPAL DEL MACARO, AL LADO DEL HOTEL EL SAMAN BARRIO SANTA EDUVIGES S/N",
      "client_identification": "V18407986",
      "nap_box_name": "87 DOS",
      "created_at": "2025-09-17T11:05:54.904908",
      "service_detail": {
        "id": 9532,
        "ip": "10.16.59.2",
        "mac": "MONU004ACF83",
        "serial": "MONU004ACF83",
        "queue": "queue1",
        "interface": "VLAN127_SANTA_EDUVIGES",
        "created_at": "2025-09-17T14:38:09.376002",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8810,
      "client_name": "DOUBLEIBYS GREGORYS ROMERO TORBELLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Villa Los Tamarindos",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243594838",
      "client_email": "DUBLEIBYSROMERO@GMAIL.COM",
      "address": "URB VILLA LOS TAMARINDOS CALLE 8 CASA #4.",
      "client_identification": "V25880894",
      "nap_box_name": "CTO-00593",
      "created_at": "2025-09-17T11:34:58.152679",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8811,
      "client_name": "KATIANA DEL CARMEN PALMA RIOS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "San Pablo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243355616",
      "client_email": "KPALMA0425@GMAIL.COM",
      "address": "TURMERO, URB. SAN PABLO, CALLE SAN PABLO, CENTRO COMERCIAL MILÁN PLAZA N1",
      "client_identification": "V17275067",
      "nap_box_name": "CTO-00588",
      "created_at": "2025-09-17T16:06:34.484245",
      "service_detail": {
        "id": 9535,
        "ip": "10.16.61.2",
        "mac": "OEMT3C6210D6",
        "serial": "OEMT3C6210D6",
        "queue": "queue1",
        "interface": "VLAN224_SAN_PABLO_OLT1",
        "created_at": "2025-09-17T21:29:33.225519",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8812,
      "client_name": "OSMERY AZAIRY PINERO CARRILLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243297486",
      "client_email": "OSMEE593@GMAIL.COM",
      "address": "CASCO DE TURMERO, LA COMUNA MERCEDES TOVAR CALLE PETION LOCAL 73 PASILLO 4",
      "client_identification": "V17577123",
      "nap_box_name": "CTO-00194",
      "created_at": "2025-09-17T16:16:14.184926",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8813,
      "client_name": "POMPEYO HAYA PONSON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Guayabita",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128902658",
      "client_email": "PEYO84@hotmail.COM",
      "address": "PRINCIPAL DE POLVORIN SECTOR GUAYABITA  PARCELA 16 EDO ARAGUA",
      "client_identification": "V17470743",
      "nap_box_name": "CE - 954",
      "created_at": "2025-09-18T09:12:46.712819",
      "service_detail": {
        "id": 9536,
        "ip": "10.11.209.2",
        "mac": "A8BF3C6249CD",
        "serial": "OEMT3C6249CE",
        "queue": "queue1",
        "interface": "VLAN280_POLVORIN",
        "created_at": "2025-09-18T10:58:54.189476",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8814,
      "client_name": "EMPRENDIMIENTO ELIAS TRUJILLO",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "San Pablo",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04128901669",
      "client_email": "SOYELIASEMANUEL97@GMAIL.COM",
      "address": "TURMERO SAN PABLO AV INDUSTRIAL SUR\nRESIDENCIAS LAGUNA",
      "client_identification": "J506286823",
      "nap_box_name": "CTO-0489",
      "created_at": "2025-09-18T16:21:44.473459",
      "service_detail": {
        "id": 9540,
        "ip": "10.16.63.2",
        "mac": "OEMT3C620A72",
        "serial": "OEMT3C620A72",
        "queue": "queue1",
        "interface": "VLAN224_SAN_PABLO_OLT1",
        "created_at": "2025-09-19T07:31:44.055887",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8821,
      "client_name": "ELISAUL REYES",
      "client_type_name": "PYME",
      "client_subdivision": "CANCELADO_PYME",
      "status_name": "Cancelado",
      "cycle": 25,
      "migrate": true,
      "sector_name": "Saman Tarazonero I",
      "plan": {
        "id": 104,
        "name": "RECURRENTE PYME PLAN 1GB",
        "cost": "161.00",
        "code": "FOP1GB",
        "profile": "1000Mbps/1000Mbps"
      },
      "client_mobile": "04140390506",
      "client_email": "ELIREYESVE@GMAIL.COM",
      "address": "CALLE PRUEBA",
      "client_identification": "V12339072",
      "nap_box_name": "1",
      "created_at": "2025-09-19T00:43:09.410802",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8822,
      "client_name": "OSMERY AZAIRY PINERO CARRILLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243297486",
      "client_email": "OSMEE593@GMAIL.COM",
      "address": "CASCO DE TURMERO LA COMUNA MERCEDES TOVAR CALLE PETION LOCAL 73 PASILLO 4",
      "client_identification": "V17577123",
      "nap_box_name": "CTO-00194",
      "created_at": "2025-09-19T11:13:03.718057",
      "service_detail": {
        "id": 9548,
        "ip": "10.16.64.2",
        "mac": "OEMT3C621146",
        "serial": "OEMT3C621146",
        "queue": "queue1",
        "interface": "VLAN200_OLTs",
        "created_at": "2025-09-23T16:21:44.946825",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8823,
      "client_name": "MARIA LAURA OCHOA AGUILAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Valle Verde",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128151012",
      "client_email": "MARILAU348@GMAIL.COM",
      "address": "ROSARIO DE PAYA VALLE VERDE CALLE SUCRE CASA NUMERO 7",
      "client_identification": "V25349592",
      "nap_box_name": "CTO-9696",
      "created_at": "2025-09-23T16:40:07.472263",
      "service_detail": {
        "id": 12554,
        "ip": "10.16.66.2",
        "mac": "4C:AB:FC:8B:DE:26",
        "serial": "JMKGCE742D0C",
        "queue": null,
        "interface": "VLAN253_VALLE_VERDE",
        "created_at": "2026-05-28T15:12:29.893254",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8824,
      "client_name": "LUIS EDUARDO BURGILLO CHIRINOS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "SUSPENDIDO_RESIDENCIAL",
      "status_name": "Suspendido",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Santa Eduviges",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243139748",
      "client_email": "YORGELISMORENO961696@GMAIL.COM",
      "address": "URBANIZACION, SANTA EDUVIGES, CALLE PRINCIPAL, CASA NUMERO 51.",
      "client_identification": "V21253458",
      "nap_box_name": "CTO-00448",
      "created_at": "2025-09-24T10:48:59.284098",
      "service_detail": {
        "id": 12695,
        "ip": "10.16.67.2",
        "mac": "OE:MT:3C:62:0A:3A",
        "serial": "OEMT3C620A3A",
        "queue": null,
        "interface": "VLAN143_STAEDUVIGES2",
        "created_at": "2026-07-07T09:17:42.377380",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8825,
      "client_name": "ANTHONY ENRIQUE PEREIRA MONTENEGRO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Durpa",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128150773",
      "client_email": "JHASLIANNY123@GMAIL.COM",
      "address": "CALLE LIBERTAD MANZANA 14 CASA NUMERO 36 DURPA",
      "client_identification": "V29846262",
      "nap_box_name": "258",
      "created_at": "2025-09-24T19:51:09.060131",
      "service_detail": {
        "id": 9558,
        "ip": "10.16.68.2",
        "mac": "HWTC30B9FC93",
        "serial": "HWTC30B9FC93",
        "queue": "queue1",
        "interface": "VLAN240_DURPA",
        "created_at": "2025-09-24T21:29:50.859644",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8826,
      "client_name": "SAMMY JIDIGZAN SANTANA RIVERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Los Nisperos",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124602354",
      "client_email": "DASHAIHERRERAS@GMAIL.COM",
      "address": "LOS NISPEROS TORRE D PISO 10 APTO 102",
      "client_identification": "V15861025",
      "nap_box_name": "TORRE D EDIF LOS NISPEROS",
      "created_at": "2025-09-29T10:17:26.248618",
      "service_detail": {
        "id": 9582,
        "ip": "10.16.71.2",
        "mac": "OEMT3C620C06",
        "serial": "OEMT3C620C06",
        "queue": null,
        "interface": "VLAN272_EDIF_NISPEROS_OLT3",
        "created_at": "2025-10-02T22:10:18.716221",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8827,
      "client_name": "EMPRENDIMIENTO JHONDER MENDOZA PEREZ",
      "client_type_name": "PYME",
      "client_subdivision": "CANCELADO_PYME",
      "status_name": "Cancelado",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 102,
        "name": "RECURRENTE PYME PLAN 150M",
        "cost": "27.60",
        "code": "FOP150M",
        "profile": "150Mbps/150Mbps"
      },
      "client_mobile": "04140520676",
      "client_email": "ALCAMPOMARACAY3@GMAIL.COM",
      "address": "CALLE RIVAS, EDIFICIO DON JORGE PLANTA BAJA TURMERO ESTADO ARAGUA, FRENTE A RESIDENCIA CANDY",
      "client_identification": "J507320910",
      "nap_box_name": "CTO-00129",
      "created_at": "2025-09-29T10:41:31.231151",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8828,
      "client_name": "ENDERZO ANTONIO RAMIREZ GONZALEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Betania",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243268113",
      "client_email": "ENDERZORAMIREZ@GMAIL.COM",
      "address": "SECTOR BETANIA CALLE 3 TRANSVERSAL CASA 408",
      "client_identification": "V26791809",
      "nap_box_name": "CTO-Betania1",
      "created_at": "2025-10-02T10:21:45.686465",
      "service_detail": {
        "id": 10242,
        "ip": "10.16.72.2",
        "mac": "HWTC49200354",
        "serial": "HWTC49200354",
        "queue": null,
        "interface": "VLAN260_BETANIA",
        "created_at": "2025-11-21T20:39:29.037176",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8829,
      "client_name": "JHONATAN HEMIR GARCIA PATINO",
      "client_type_name": "GRATIS",
      "client_subdivision": "CANCELADO_GRATIS",
      "status_name": "Cancelado",
      "cycle": 10,
      "migrate": false,
      "sector_name": "19 de Abril",
      "plan": {
        "id": 86,
        "name": "PLAN RECURRENTE 80M GRATIS",
        "cost": "0.00",
        "code": "FO-G80",
        "profile": "80M/80M"
      },
      "client_mobile": "04121491067",
      "client_email": "GARCIAYHONATAN45@GMAIL.COM",
      "address": "CALLE BELLA VISTA CASA NRO 18-A SECTOR 19 DE ABRIL TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V32008045",
      "nap_box_name": "CTO-00464",
      "created_at": "2025-10-02T11:37:28.501787",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8830,
      "client_name": "LUIS REINALDO AMUNDARAY RONDON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Haras de San Pablo",
      "plan": {
        "id": 101,
        "name": "RECURRENTE RESIDENCIAL PLAN 200M",
        "cost": "19.00",
        "code": "FOR200MB",
        "profile": "200Mbps/200Mbps"
      },
      "client_mobile": "04127760084",
      "client_email": "AMUNDARAYA@GMAIL.COM",
      "address": "HARAS SAN PABLO MANZANA B CASA B38",
      "client_identification": "V13621115",
      "nap_box_name": "CTO-00597",
      "created_at": "2025-10-02T20:50:38.367100",
      "service_detail": {
        "id": 9581,
        "ip": "10.15.71.2",
        "mac": "QXTLCB8A64CD",
        "serial": "QXTLCB8A64CD",
        "queue": null,
        "interface": "VLAN224_SAN_PABLO_OLT1",
        "created_at": "2025-10-02T21:15:09.138461",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8831,
      "client_name": "WILMER ORLANDO CORREDOR AGELVIS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Jabillar",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243711417",
      "client_email": "CORREDORWILMER30@GMAIL.COM",
      "address": "URBANIZACIÓN JABILLAR CALLE LOS ROBLES CASA 07-04 EL MACARO",
      "client_identification": "V9672460",
      "nap_box_name": "CTO-0553",
      "created_at": "2025-10-06T09:44:24.709648",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8832,
      "client_name": "WILMER ORLANDO CORREDOR AGELVIS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Jabillar",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243711417",
      "client_email": "CORREDORWILMER30@GMAIL.COM",
      "address": "URBANIZACIÓN JABILLAR CALLE LOS ROBLES CASA 07-04 EL MACARO",
      "client_identification": "V9672460",
      "nap_box_name": "CTO-0553",
      "created_at": "2025-10-06T10:15:13.002768",
      "service_detail": {
        "id": 10747,
        "ip": "10.16.74.2",
        "mac": "OEMT3C62025E",
        "serial": "OEMT3C62025E",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2025-12-16T11:37:36.983512",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8833,
      "client_name": "PEDRO ANTONIO DELGADO CALDERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "La Casona II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04143435258",
      "client_email": "PEDRODELGA.26@GMAIL.COM",
      "address": "CALLE 14 CASA NUMERO# 3 URB. LA CASONA II",
      "client_identification": "V9173716",
      "nap_box_name": "CTO-00075 DOS",
      "created_at": "2025-10-06T19:30:49.971042",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8834,
      "client_name": "ALFONSO VICENTE SALINAS GONZALEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04162434369",
      "client_email": "ALFONSOVICENTESALINASGONZALEZ@GMAIL.COM",
      "address": "SAMAN TARAZONERO 2 MANZANA F 2#5",
      "client_identification": "V6801383",
      "nap_box_name": "162",
      "created_at": "2025-10-07T09:49:21.619689",
      "service_detail": {
        "id": 9610,
        "ip": "10.16.75.2",
        "mac": "HWTC46812BA1",
        "serial": "HWTC46812BA1",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2025-10-14T13:56:35.370173",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8835,
      "client_name": "RAMON EDUARDO DAMASO YANEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "1ro de Mayo Sur",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04122301362",
      "client_email": "DAMASOANTONIO73@GMAIL.COM",
      "address": "AV PRINCIPAL CASA #147 SECTOR 1RO DE MAYOR SUR ROSARIO DE PAYA",
      "client_identification": "V17575258",
      "nap_box_name": "CTO-00225",
      "created_at": "2025-10-07T14:50:48.226952",
      "service_detail": {
        "id": 13124,
        "ip": "10.16.77.2",
        "mac": "JM:KG:CE:D6:BD:9E",
        "serial": "JMKGCED6BD9E",
        "queue": null,
        "interface": "VLAN261_1ERO_MAYO_ZTE",
        "created_at": "2026-10-05T17:52:10.180456",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8836,
      "client_name": "JAIME RAFAEL GUERRA PRIETO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "La Magdalena",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243544479",
      "client_email": "JAIME01GUERRA@GMAIL.COM",
      "address": "URBANIZACIÓN LA MAGDALENA. CALLE 11. CASA NÚMERO 31",
      "client_identification": "V8739759",
      "nap_box_name": "357",
      "created_at": "2025-10-07T15:18:43.870136",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8837,
      "client_name": "FRANZIUS XAVIER MAITA GUEGUI",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Villas Don Pascual",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124319515",
      "client_email": "LANDERXION@GMAIL.COM",
      "address": "LEOCOLBO, VILLA DON PASCUAL CASA N34.",
      "client_identification": "V19196853",
      "nap_box_name": "CTO-00371",
      "created_at": "2025-10-07T16:42:29.902095",
      "service_detail": {
        "id": 11799,
        "ip": "10.15.135.2",
        "mac": "MONU00458D45",
        "serial": "MONU00458D45",
        "queue": null,
        "interface": "VLAN144_LEOCOLBO",
        "created_at": "2026-02-27T11:30:45.028097",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8838,
      "client_name": "ESTRELLA MARIETH HERNANDEZ MORALES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Guerrero de Chavez",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04129868631",
      "client_email": "JESUAENRRIQUEHERRERANIEVES@GMAIL.COM",
      "address": "COMUNIDAD GUERREROS DE CHAVEZ CALLE 2 A 01 PARCELA 5",
      "client_identification": "V31023284",
      "nap_box_name": "CTO-00587",
      "created_at": "2025-10-08T17:39:15.710208",
      "service_detail": {
        "id": 9596,
        "ip": "10.16.80.2",
        "mac": "2012231218005926",
        "serial": "OEMT3C624C7E",
        "queue": null,
        "interface": "VLAN220_PP_PAYA_OLT2",
        "created_at": "2025-10-10T11:58:44.556449",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8839,
      "client_name": "MARIA VERONICA TUA ORTIZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "La Concepcion",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04142948082",
      "client_email": "TUAMARIAVERONICA@GMAIL.COM",
      "address": "AV LA JULIA EDIFICIO 2 PISO 1 APARTAMENTO 3 URBANIZACIÓN LA CONCEPCIÓN TURMERO",
      "client_identification": "V26519720",
      "nap_box_name": "623",
      "created_at": "2025-10-09T09:03:21.906494",
      "service_detail": {
        "id": 9666,
        "ip": "10.16.79.2",
        "mac": "OEMT3C624B4E",
        "serial": "OEMT3C624B4E",
        "queue": null,
        "interface": "VLAN111_CONCEPCION",
        "created_at": "2025-11-03T09:51:07.590421",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8840,
      "client_name": "BEATRIZ NOHEMI MENDOZA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243527075",
      "client_email": "BEATRIZNOHEMI865@GMAIL.COM",
      "address": "CALL 1 CASA N 16 MATACABALLO",
      "client_identification": "V12083709",
      "nap_box_name": "CTO-00131",
      "created_at": "2025-10-11T13:27:05.118427",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8841,
      "client_name": "YARGELIS JOSEFINA CHOURIO BETANCOURT",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Orquidea",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243221876",
      "client_email": "CHOURIOYARGELYS@GMAIL.COM",
      "address": "ROSARIO DE PAYA PRADO I LA ORQUIDEA CALLE 5 NUMERO DE RANCHO 111",
      "client_identification": "V26095694",
      "nap_box_name": "CTO-00306",
      "created_at": "2025-10-11T13:27:20.980614",
      "service_detail": {
        "id": 9608,
        "ip": "10.11.190.2",
        "mac": "HWTC8F6CBB61",
        "serial": "HWTC8F6CBB61",
        "queue": null,
        "interface": "VLAN259_LA_ORQUIDEA",
        "created_at": "2025-10-13T15:02:21.960458",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8842,
      "client_name": "JHONATAN HEMIR GARCIA PATINO",
      "client_type_name": "EMPLEADO",
      "client_subdivision": "ACTIVO_EMPLEADO",
      "status_name": "Activo",
      "cycle": 25,
      "migrate": false,
      "sector_name": "19 de Abril",
      "plan": {
        "id": 78,
        "name": "Plan empleado 80MB",
        "cost": "0.00",
        "code": "FO-80M",
        "profile": "80M/80M"
      },
      "client_mobile": "04121491067",
      "client_email": "GARCIAYHONATAN45@GMAIL.COM",
      "address": "CALLE BELLA VISTA CASA NRO 18-A SECTOR 19 DE ABRIL TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V32008045",
      "nap_box_name": "CTO-00464",
      "created_at": "2025-10-13T13:53:04.288582",
      "service_detail": {
        "id": 10996,
        "ip": "10.16.107.2",
        "mac": "OEMT3C5DF5BE",
        "serial": "OEMT3C5DF5BE",
        "queue": null,
        "interface": "VLAN122_SAMAN_GUERE",
        "created_at": "2025-12-30T12:36:55.500139",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8847,
      "client_name": "MELIDA MARGARITA CHIRINO BELLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "SUSPENDIDO_RESIDENCIAL",
      "status_name": "Suspendido",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Isaac Oliveira",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243590630",
      "client_email": "MELIDACHIRINO75@GMAIL.COM",
      "address": "ISAAC OLIVERA 1ERA CALLE CASA #49",
      "client_identification": "V9656312",
      "nap_box_name": "CTO-00258",
      "created_at": "2025-10-15T09:35:34.738849",
      "service_detail": {
        "id": 11808,
        "ip": "172.26.250.2",
        "mac": "1CEF03D10662",
        "serial": "VSOL00D10663",
        "queue": null,
        "interface": "VLAN107_ISAAC_O",
        "created_at": "2026-02-27T11:42:16.848769",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8848,
      "client_name": "DARWIN JOSE GUERRA BRITO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vista Hermosa",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128311448",
      "client_email": "DARWINGD29@GMAIL.COM",
      "address": "PRADOS DE PAYA SECTOR VISTA HERMOSA CALLE LAS MANDARINAS CASA #94",
      "client_identification": "V18365515",
      "nap_box_name": "237",
      "created_at": "2025-10-15T13:55:14.301919",
      "service_detail": {
        "id": 9683,
        "ip": "10.16.83.2",
        "mac": "OEMT3C6210EE",
        "serial": "OEMT3C6210EE",
        "queue": null,
        "interface": "VLAN230_VISTA_HERMOSA",
        "created_at": "2025-11-04T10:22:53.065401",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8849,
      "client_name": "YORDALYS NEIDEMAR SOTO ESCALONA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Guanarito",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "0414-9580247",
      "client_email": "YORDALYSSOTO@GMAIL.COM",
      "address": "CANDELARIA NORTE CALLE LOS MANGOS CASA 31 , SECTOR GUANARITO.",
      "client_identification": "V24420020",
      "nap_box_name": "CTO-1261",
      "created_at": "2025-10-15T14:11:43.571164",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8850,
      "client_name": "JOSE MAURICIO DE SOUSA SANCHEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Laguna Plaza",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04125126436",
      "client_email": "JOSEDESOUSA494@GMAIL.COM",
      "address": "URB LAGUNA PLAZA TORRE 3 PH 3 TURMERO",
      "client_identification": "V22286905",
      "nap_box_name": "4 DOS",
      "created_at": "2025-10-15T15:12:29.605990",
      "service_detail": {
        "id": 13140,
        "ip": "10.16.82.2",
        "mac": "OE:MT:3C:62:48:AA",
        "serial": "OEMT3C6248AA",
        "queue": null,
        "interface": "VLAN216_LAGUNA_PLAZA_OLT1",
        "created_at": "2026-10-10T10:01:15.673593",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8851,
      "client_name": "CARINA YSABEL FALCON MENDOZA",
      "client_type_name": "PYME",
      "client_subdivision": "CANCELADO_PYME",
      "status_name": "Cancelado",
      "cycle": 10,
      "migrate": false,
      "sector_name": "1ro de Mayo Norte",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04264087111",
      "client_email": "PERALTABRITO13@GMAIL.COM",
      "address": "ROSARIO DE PAYA URBANISMO URIMARE CALLE 1 MÓDULO 1 APARTAMENTO B",
      "client_identification": "V14741849",
      "nap_box_name": "CTO-00458",
      "created_at": "2025-10-16T12:32:18.668794",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8852,
      "client_name": "YAIR ANTONIO GONZALEZ RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Narayola II",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04265866374",
      "client_email": "YAIRGONZALEZ7580@GMAIL.COM",
      "address": "RESIDENCIAS NARAYOLA II  TORRE 1 APARTAMENTO 1-6 AV. INTERCOMUNAL SANTIAGO MARIÑO, TURMERO 2115, ARAGUA",
      "client_identification": "V14485719",
      "nap_box_name": "CTO-0523",
      "created_at": "2025-10-18T21:08:11.720146",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8853,
      "client_name": "SIPNNA CLAUDIA FIGUEROA",
      "client_type_name": "GRATIS",
      "client_subdivision": "CANCELADO_GRATIS",
      "status_name": "Cancelado",
      "cycle": 25,
      "migrate": false,
      "sector_name": "El Macaro",
      "plan": {
        "id": 86,
        "name": "PLAN RECURRENTE 80M GRATIS",
        "cost": "0.00",
        "code": "FO-G80",
        "profile": "80M/80M"
      },
      "client_mobile": "04144696136",
      "client_email": "SIPNNA2022@GMAIL.COM",
      "address": "ALDEA BOLIVARIANA COMUNAL EL MACARO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V12638353",
      "nap_box_name": "493",
      "created_at": "2025-10-19T13:15:17.282499",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8854,
      "client_name": "FLAVIELIS BETZABETH DE SOUSA RONDON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "SUSPENDIDO_RESIDENCIAL",
      "status_name": "Suspendido",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Ciudad Bendita",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04125440024",
      "client_email": "FLAWVERLISRIVASDESOUSA@GMAIL.COM",
      "address": "CIUDAD BENDITA CALLE 4 PARCELA 32 CASA 105",
      "client_identification": "V24279145",
      "nap_box_name": "CE-00014",
      "created_at": "2025-10-20T14:10:05.519348",
      "service_detail": {
        "id": 9640,
        "ip": "172.19.125.2",
        "mac": "HWTC48080513",
        "serial": "HWTC48080513",
        "queue": null,
        "interface": "VLAN249_CBENDITA_OLT2",
        "created_at": "2025-10-21T19:11:43.916581",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8855,
      "client_name": "GENESIS ALEJANDRA RIVAS GUERRERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "La Montaña",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243091918",
      "client_email": "GYGDETALLES@GMAIL.COM",
      "address": "URB LA MONTAÑA,  EDIF. PICO LEON, PISO 3 APTO 2",
      "client_identification": "V22954684",
      "nap_box_name": "68",
      "created_at": "2025-10-20T15:50:05.929280",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8856,
      "client_name": "AIRAM SIVLEY LUCENA GONZALEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Simon Bolivar",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04123988134",
      "client_email": "AIRAM23LUCENA@GMAIL.COM",
      "address": "CALLE 6 CASA NUMERO 41 URB SIMON BOLIVAR EL MACARO FRENTE AL YESTERDAY",
      "client_identification": "V19516712",
      "nap_box_name": "CTO-00023",
      "created_at": "2025-10-21T12:29:07.945700",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8857,
      "client_name": "HENYERBER JOSE ARRIECHE SUAREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121394529",
      "client_email": "HENYELBERTH.A@GMAIL.COM",
      "address": "MANZANA I8 CASA 9",
      "client_identification": "V24446560",
      "nap_box_name": "119",
      "created_at": "2025-10-21T16:17:44.152755",
      "service_detail": {
        "id": 9637,
        "ip": "172.30.123.2",
        "mac": "TPLGF9CD3C71",
        "serial": "TPLGF9CD3C71",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2025-10-21T16:29:05.881897",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8858,
      "client_name": "HENYERBER JOSE ARRIECHE SUAREZ",
      "client_type_name": "EMPLEADO",
      "client_subdivision": "ACTIVO_EMPLEADO",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": false,
      "sector_name": "Leocolbo",
      "plan": {
        "id": 78,
        "name": "Plan empleado 80MB",
        "cost": "0.00",
        "code": "FO-80M",
        "profile": "80M/80M"
      },
      "client_mobile": "04121394529",
      "client_email": "HENYELBERTH.A@GMAIL.COM",
      "address": "CALLE A CASA NRO 61 CASERIO LEOCOLBO 19 DE ABRIL ARAGUA ZONA POSTAL 2115",
      "client_identification": "V24446560",
      "nap_box_name": "CE - 623",
      "created_at": "2025-10-21T17:29:28.719251",
      "service_detail": {
        "id": 12244,
        "ip": "172.31.15.2",
        "mac": "TPLG2ABDC6BC",
        "serial": "TPLG2ABDC6BC",
        "queue": null,
        "interface": "VLAN144_LEOCOLBO",
        "created_at": "2026-04-02T13:34:47.958437",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8859,
      "client_name": "CARINA YSABEL FALCON MENDOZA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "1ro de Mayo Norte",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04264087111",
      "client_email": "PERALTABRITO13@GMAIL.COM",
      "address": "ROSARIO DE PAYA URBANISMO URIMARE CALLE 1 MÓDULO 1 APARTAMENTO B",
      "client_identification": "V14741849",
      "nap_box_name": "CTO - 878",
      "created_at": "2025-10-22T10:17:12.737603",
      "service_detail": {
        "id": 9642,
        "ip": "10.16.85.2",
        "mac": "HWTC3014E793",
        "serial": "HWTC3014E793",
        "queue": null,
        "interface": "VLAN261_1ERO_MAYO_ZTE",
        "created_at": "2025-10-22T11:15:11.607897",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8860,
      "client_name": "GREGORY JHOSSEN TORRES DIAZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Los Nisperos",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04123310660",
      "client_email": "GREGORYTORRES777@GMAIL.COM",
      "address": "URB LOS NÍSPEROS TORRE B PISO 8 APARTAMENTO 82 TURMERO",
      "client_identification": "V20894170",
      "nap_box_name": "TORRE B EDIF LOS NISPEROS",
      "created_at": "2025-10-22T15:40:33.233110",
      "service_detail": {
        "id": 12395,
        "ip": "10.16.87.2",
        "mac": "HWTC48080022",
        "serial": "HWTC48080022",
        "queue": null,
        "interface": "VLAN272_EDIF_NISPEROS_OLT3",
        "created_at": "2026-04-22T14:52:53.732486",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8861,
      "client_name": "MOTO RACING CAGUA CA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Paya Abajo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243204154",
      "client_email": "MOTORACINGCAGUA@GMAIL.COM",
      "address": "AVENIDA PRINCIPAL DE PAYA, SECTOR PAYA ABAJO, LOCAL S/N",
      "client_identification": "J502058958",
      "nap_box_name": "406",
      "created_at": "2025-10-22T16:41:31.190792",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8862,
      "client_name": "GREGORIA PAEZ PINA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04127382980",
      "client_email": "DORA.BRAYHAN2@GMAIL.COM",
      "address": "MATA CABALLO CALLE 12 CASA 673 B",
      "client_identification": "V7228253",
      "nap_box_name": "CTO-0570",
      "created_at": "2025-10-22T18:25:47.506124",
      "service_detail": {
        "id": 9656,
        "ip": "10.15.137.2",
        "mac": "80D4A51EA50",
        "serial": "HWTC48080525",
        "queue": null,
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2025-10-27T09:56:41.611905",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8863,
      "client_name": "DANIEL JESUS DIAZ MEJIAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Taguapire",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128907586",
      "client_email": "DANIEL88873@GMAIL.COM",
      "address": "CARRETERA MARACAY TURMERO EL MACARO PARCELA NUMERO 9 FRENTE AL JABILLAR",
      "client_identification": "V28045513",
      "nap_box_name": "CE-00141",
      "created_at": "2025-10-22T18:52:22.256311",
      "service_detail": {
        "id": 10423,
        "ip": "10.16.94.2",
        "mac": "48352E3C2F64",
        "serial": "MONU003C2F65",
        "queue": null,
        "interface": "VLAN129_TAGUAPIRE_ZTE",
        "created_at": "2025-12-01T14:09:50.085601",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8864,
      "client_name": "ZULAY TRINIDAD GONCALVES DE SOUSA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Callejon Lim",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243761409",
      "client_email": "ZULAYGONCALVES8@GMAIL.COM",
      "address": "CALLEJÓN LIM EDIFICIO AZUCENA APARTAMENTO 16-A.  PAYA",
      "client_identification": "V14183745",
      "nap_box_name": "TORRE AZUCENA",
      "created_at": "2025-10-22T19:11:50.969108",
      "service_detail": {
        "id": 10907,
        "ip": "10.16.89.2",
        "mac": "2012231218005601",
        "serial": "OEMT3C62476A",
        "queue": null,
        "interface": "VLAN250_LIM_OLT2",
        "created_at": "2025-12-23T13:11:12.305382",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8865,
      "client_name": "YULEIDIS ALEJANDRA MARQUEZ RUBIO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "El Macaro",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "0424-3755680",
      "client_email": "YULEIDISM78@GMAIL.COM",
      "address": "‎URBANIZACIÓN VILLAS DEL MACARO CALLE 8, CASA NRO 78",
      "client_identification": "V23528224",
      "nap_box_name": "CTO-0X0X0",
      "created_at": "2025-10-23T08:56:50.901614",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8866,
      "client_name": "LUIS ALBERTO VALERA FLORES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Guanarito",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04228158756",
      "client_email": "ALBERTOLUIS2903@GMAIL.COM",
      "address": "GUANARITO CALLE LOS NARANJOS CASA NUMERO 30",
      "client_identification": "V19246828",
      "nap_box_name": "499",
      "created_at": "2025-10-27T08:52:26.937963",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8867,
      "client_name": "MOTO RACING CAGUA CA",
      "client_type_name": "PYME",
      "client_subdivision": "SUSPENDIDO_PYME",
      "status_name": "Suspendido",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Paya Abajo",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04243204154",
      "client_email": "MOTORACINGCAGUA@GMAIL.COM",
      "address": "AVENIDA PRINCIPAL DE PAYA, SECTOR PAYA ABAJO LOCAL S/N",
      "client_identification": "J502058958",
      "nap_box_name": "406",
      "created_at": "2025-10-30T14:23:11.527787",
      "service_detail": {
        "id": 9662,
        "ip": "172.26.108.2",
        "mac": "HWTCC190C39C",
        "serial": "HWTCC190C39C",
        "queue": null,
        "interface": "VLAN231_PAYABAJO",
        "created_at": "2025-10-30T14:26:08.227430",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8868,
      "client_name": "DANIELA VIRGINIA CASTRO NAVA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04147619184",
      "client_email": "SALUDYVIDANICOLLET@GMAIL.COM",
      "address": "AVENIDA PRINCIPAL CALLE RIVAS, TURMERO FRENTE SERVICIO TRIÁNGULO",
      "client_identification": "V20504814",
      "nap_box_name": "CTO-00129",
      "created_at": "2025-10-30T15:34:01.689913",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8869,
      "client_name": "HECTOR JOSE RODRIGUEZ BRAVO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Taguapire",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124390041",
      "client_email": "HJOSERODRIGUEZB@GMAIL.COM",
      "address": "URB TAGUAPIRE CALLE 1 CASA NÚMERO 18",
      "client_identification": "V13134158",
      "nap_box_name": "548",
      "created_at": "2025-11-02T17:29:46.346358",
      "service_detail": {
        "id": 10383,
        "ip": "10.16.102.2",
        "mac": "2012231218001358",
        "serial": "OEMT3C62051E",
        "queue": null,
        "interface": "VLAN129_TAGUAPIRE_ZTE",
        "created_at": "2025-11-28T13:25:24.701699",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8870,
      "client_name": "CAROLINA ELIZABETH ROMERO AREVALO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Jabillar",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243407680",
      "client_email": "CAROLINAROMERO708@GMAIL.COM",
      "address": "CALLE 07, CASA 07-06, URBANIZACIÓN JABILLAR, MACARO -TURMERO",
      "client_identification": "V21445437",
      "nap_box_name": "CTO-0553",
      "created_at": "2025-11-03T13:33:55.536823",
      "service_detail": {
        "id": 10746,
        "ip": "10.16.103.2",
        "mac": "HWTC48220055",
        "serial": "HWTC48220055",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2025-12-16T11:16:18.125508",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8871,
      "client_name": "GRACIELA VIRGINIA LEON LUGO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "La Esperanza",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04125988776",
      "client_email": "GRACI1711.DM@GMAIL.COM",
      "address": "URBANIZACIÓN LA ESPERANZA, CALLE 21 CASA #19 AL LADO DE LA UPEL EL MACARO",
      "client_identification": "V19834650",
      "nap_box_name": "555",
      "created_at": "2025-11-03T13:40:32.971608",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8872,
      "client_name": "JHON FLAVIANO ZAMBRANO PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Terrazas de Paya",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243772930",
      "client_email": "jhorker7@gmail.com",
      "address": "TERRAZAS DE PAYA MANZANA 3 CASA N10",
      "client_identification": "V14680121",
      "nap_box_name": "421",
      "created_at": "2025-11-03T17:27:04.603227",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8873,
      "client_name": "YURGREGORY JOSE VALBUENA VASQUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Paraguatan",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243781437",
      "client_email": "YURGREGORY00@GMAIL.COM",
      "address": "TURMERO, PARAGUATAN, CALLE PASO REAL, CASA #10",
      "client_identification": "V30914502",
      "nap_box_name": "CTO-00393",
      "created_at": "2025-11-05T13:06:36.430308",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8874,
      "client_name": "JORGE LUIS HOYOS CARO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Valle Fresco",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04142952015",
      "client_email": "FENIXJLHC@GMAIL.COM",
      "address": "CALLE PRINCIPAL SAN PABLO  RESIDENCIAS CAMPO ALEGRE  EDIFICIO 11 PISO 4 NO 11-42",
      "client_identification": "E83162984",
      "nap_box_name": "CTO VALLE FRESCO",
      "created_at": "2025-11-05T14:01:36.648601",
      "service_detail": {
        "id": 12377,
        "ip": "10.16.105.2",
        "mac": "MONU00116099",
        "serial": "MONU00116099",
        "queue": null,
        "interface": "VLAN224_SAN_PABLO_OLT1",
        "created_at": "2026-04-20T13:00:18.676554",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8875,
      "client_name": "LORIANA NATALY ALVARADO MORA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "1ro de Mayo Norte",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04125793250",
      "client_email": "LORIANAALVARADO6@GMAIL.COM",
      "address": "SECTOR PRIMERO DE MAYO NORTE CALLE MANAURE CASA 6",
      "client_identification": "V26955123",
      "nap_box_name": "CTO-00229",
      "created_at": "2025-11-05T16:32:56.925462",
      "service_detail": {
        "id": 9694,
        "ip": "10.15.182.2",
        "mac": "OEMT3C620282",
        "serial": "OEMT3C620282",
        "queue": null,
        "interface": "VLAN261_1ERO_MAYO_ZTE",
        "created_at": "2025-11-06T09:59:59.370334",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8876,
      "client_name": "KHALOA SOLED SERRANO ROMERO",
      "client_type_name": "EMPLEADO",
      "client_subdivision": "ACTIVO_EMPLEADO",
      "status_name": "Activo",
      "cycle": 25,
      "migrate": false,
      "sector_name": "La Casona II",
      "plan": {
        "id": 78,
        "name": "Plan empleado 80MB",
        "cost": "0.00",
        "code": "FO-80M",
        "profile": "80M/80M"
      },
      "client_mobile": "04122051723",
      "client_email": "ROMEROKALOA@GMAIL.COM",
      "address": "CALLE 15 CASA NRO 4 URB LA CASONA II, LA JULIA TURMERI ARAGUA ZONA POSTAL 2115",
      "client_identification": "V17274399",
      "nap_box_name": "CTO-00087",
      "created_at": "2025-11-05T17:05:49.277022",
      "service_detail": {
        "id": 11859,
        "ip": "10.13.220.2",
        "mac": "VSOL00424199",
        "serial": "VSOL00424199",
        "queue": null,
        "interface": "VLAN110_CASONA_2",
        "created_at": "2026-02-27T17:04:22.992227",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8877,
      "client_name": "NORMA MARIA LUNA DE PEREIRA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121799816",
      "client_email": "MLPL03821982@GMAIL.COM",
      "address": "C. CAMPO ELÍAS CASA NRO 2-1 SECTOR CENTRO",
      "client_identification": "V3436853",
      "nap_box_name": "CTO-931",
      "created_at": "2025-11-10T10:35:51.388853",
      "service_detail": {
        "id": 9962,
        "ip": "10.16.109.2",
        "mac": "2012231218001703",
        "serial": "OEMT3C620A82",
        "queue": null,
        "interface": "VLAN200_OLTs",
        "created_at": "2025-11-11T11:14:05.726432",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8878,
      "client_name": "RONALDO MANUEL PENA LEON CICPC",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "SUSPENDIDO_RESIDENCIAL",
      "status_name": "Suspendido",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04148685485",
      "client_email": "VEHICULOSTURMERO2025@GMAIL.COM",
      "address": "CALLÉ PETION, EDIF. CICPC TURMERO, CASCO DE TURMERO, FRENTE AL CONCEJO MUNICIPAL",
      "client_identification": "V25069135",
      "nap_box_name": "CTO-00037",
      "created_at": "2025-11-10T14:21:41.221305",
      "service_detail": {
        "id": 10062,
        "ip": "172.22.85.2",
        "mac": "TPLGB446E96A",
        "serial": "TPLGB446E96A",
        "queue": null,
        "interface": "VLAN200_OLTs",
        "created_at": "2025-11-12T12:30:38.407186",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8879,
      "client_name": "ROBIN ALEXANDER MATOS ESCALONA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Candelaria Sur",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124361489",
      "client_email": "R.MATOSESCALONA@GMAIL.COM",
      "address": "CASA 17 1 EN LA PROLONGACION CALLE CARABOBO SECTOR VILLEGAS TURMERO",
      "client_identification": "V23790292",
      "nap_box_name": "CE-00281",
      "created_at": "2025-11-12T10:07:44.856645",
      "service_detail": {
        "id": 13096,
        "ip": "10.16.110.2",
        "mac": "HW:TC:91:5B:01:87",
        "serial": "HWTC915B0187",
        "queue": null,
        "interface": "VLAN200_OLTs",
        "created_at": "2026-10-01T16:07:54.804871",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8880,
      "client_name": "GUILLERMO ALEXANDER GARCIA FERRAROTTO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144899398",
      "client_email": "GUILLERMOGARCIA0897@GMAIL.COM",
      "address": "CALLE 11, TETRA 638-D URB MATACABALLO",
      "client_identification": "V25880374",
      "nap_box_name": "CTO-00022",
      "created_at": "2025-11-14T09:49:34.604673",
      "service_detail": {
        "id": 10926,
        "ip": "10.16.111.2",
        "mac": "HWTC48080523",
        "serial": "HWTC48080523",
        "queue": null,
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2025-12-24T12:22:52.793692",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8881,
      "client_name": "LUIS AUGUSTO FERNANDEZ RIVERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Terrazas de Juan Pablo",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04124889234",
      "client_email": "FLUIS4500@GMAIL.COM",
      "address": "SAMAN DE GUERE CALLE LA LLANERA URBANIZACIÓN TERRAZAS DE JUAN PABLO CASA B14",
      "client_identification": "V14665924",
      "nap_box_name": "13",
      "created_at": "2025-11-14T10:46:36.396531",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8882,
      "client_name": "ALEX RAFAEL LORCAS PORTE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Valle del Rosario",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04143950330",
      "client_email": "ALEXLORCAS03@GMAIL.COM",
      "address": "EL MACARO, URB VALLE DEL ROSARIO, CALLE ARAGUA CASA #9",
      "client_identification": "V11093466",
      "nap_box_name": "31",
      "created_at": "2025-11-14T12:33:44.324711",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8883,
      "client_name": "ESTEFANI PAOLA VILLARROEL TALABERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "San Pablo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "0412 9671370",
      "client_email": "ESTEFANVILLARR@GMAIL.COM",
      "address": "URB SAN PABLO AV 1 CASA 1 TURMERO",
      "client_identification": "V21100565",
      "nap_box_name": "CTO-00692",
      "created_at": "2025-11-15T14:22:22.889562",
      "service_detail": {
        "id": 10163,
        "ip": "10.16.113.2",
        "mac": "2012231218006295",
        "serial": "OEMT3C625242",
        "queue": null,
        "interface": "VLAN224_SAN_PABLO_OLT1",
        "created_at": "2025-11-17T08:43:57.222648",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8884,
      "client_name": "LUIS ENRIQUE CASTELLANOS BONILLA",
      "client_type_name": "EMPLEADO",
      "client_subdivision": "CANCELADO_EMPLEADO",
      "status_name": "Cancelado",
      "cycle": 10,
      "migrate": false,
      "sector_name": "Palmeras I",
      "plan": {
        "id": 78,
        "name": "Plan empleado 80MB",
        "cost": "0.00",
        "code": "FO-80M",
        "profile": "80M/80M"
      },
      "client_mobile": "04243703599",
      "client_email": "LUISBONILLA5021@GMAIL.COM",
      "address": "URB. LA PALMERA I, CALLE 2, CASA 109",
      "client_identification": "V19654719",
      "nap_box_name": "CTO-00692",
      "created_at": "2025-11-16T15:47:53.457788",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8885,
      "client_name": "FRANCYS JESUSKA ZAMBRANO PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Salto Angel",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128904826",
      "client_email": "FRANCYJZPT@GMAIL.COM",
      "address": "COMUNIDAD SALTO ANGEL , CALLE ROBLE, CASA NÚMERO 49",
      "client_identification": "V18816168",
      "nap_box_name": "CTO - 68",
      "created_at": "2025-11-17T13:46:36.878952",
      "service_detail": {
        "id": 11641,
        "ip": "10.16.114.2",
        "mac": "HWTC30293093",
        "serial": "HWTC30293093",
        "queue": null,
        "interface": "VLAN121_S_ANGEL",
        "created_at": "2026-02-16T20:02:26.854251",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8886,
      "client_name": "ANGELICA MARIA PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144448462",
      "client_email": "ANGELICAMARIAPEREZ1974@GMAIL.COM",
      "address": "CALLE PETION, COMUNA MERCEDES TOVAR, LOCAL 82",
      "client_identification": "V13151154",
      "nap_box_name": "CTO-00194",
      "created_at": "2025-11-17T15:43:24.629823",
      "service_detail": {
        "id": 10180,
        "ip": "10.16.116.2",
        "mac": "80D4A5A1DB50",
        "serial": "HWTC48080285",
        "queue": null,
        "interface": "VLAN200_OLTs",
        "created_at": "2025-11-18T11:22:14.096605",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8887,
      "client_name": "JORGE ALEJANDRO KENT VILLEGAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "La Concepcion",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "0424-3546862",
      "client_email": "KENTJORGE3@GMAIL.COM",
      "address": "‎CALLE CONCEPCIÓN EDIFICIO 13 PISO 2 APTO 5 CONJUNTO RESIDENCIAL LA CONCEPCIÓN ‎TURMERO.",
      "client_identification": "V20451366",
      "nap_box_name": "0326",
      "created_at": "2025-11-18T08:35:20.329256",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8888,
      "client_name": "FRANCISCO JAVIER LEON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Turmerito",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128151493",
      "client_email": "FENIX.07LEON@GMAIL.COM",
      "address": "BARRIO TURMERITO,CALLE PRINCIPAL NRO.37,EL MACARO,PUNTO DE REFERENCIA EL BOTIQUIN.",
      "client_identification": "V3377351",
      "nap_box_name": "CE-00250",
      "created_at": "2025-11-18T09:37:19.892481",
      "service_detail": {
        "id": 13102,
        "ip": "10.16.120.2",
        "mac": "HW:TC:5D:11:83:91",
        "serial": "HWTC5D118391",
        "queue": null,
        "interface": "VLAN137_LA_ESPERANZA_OLT_ZTE",
        "created_at": "2026-10-02T10:47:20.056390",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8889,
      "client_name": "OMAR ENRIQUE MANRIQUE GONZALEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Valle Fresco",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "0424-3478781",
      "client_email": "OMARMANRIQUE1908@GMAIL.COM",
      "address": "TURMERO. URBANIZACIÓN VALLE FRESCO, MANZANA 19, CASA NÚMERO 03.",
      "client_identification": "V23528033",
      "nap_box_name": "CE-00236",
      "created_at": "2025-11-18T10:08:32.615799",
      "service_detail": {
        "id": 12413,
        "ip": "10.16.119.2",
        "mac": "VSOL009E1AB4",
        "serial": "VSOL009E1AB4",
        "queue": null,
        "interface": "VLAN270_VALLE_FRESCO_OLT3",
        "created_at": "2026-04-25T13:11:19.282723",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8890,
      "client_name": "INVERSIONES SIEMPRE LINDA DIAZ F P",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 102,
        "name": "RECURRENTE PYME PLAN 150M",
        "cost": "27.60",
        "code": "FOP150M",
        "profile": "150Mbps/150Mbps"
      },
      "client_mobile": "04125204095",
      "client_email": "JOSEANTONIOHUNG@GMAIL.COM",
      "address": "CALLE MARIÑO CENTRO COMERCIAL PASEO MARIÑO LOCAL PB-04 TURMERO",
      "client_identification": "J212045655",
      "nap_box_name": "CTO-00038",
      "created_at": "2025-11-19T08:34:23.201547",
      "service_detail": {
        "id": 10194,
        "ip": "10.16.118.2",
        "mac": "2012231218001342",
        "serial": "OEMT3C6204DE",
        "queue": null,
        "interface": "VLAN200_OLTs",
        "created_at": "2025-11-19T16:09:52.166260",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8891,
      "client_name": "ARIANA CAROLINA CARTAYA MAHMUT",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Taguapire",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243677371",
      "client_email": "CARTAA0702@GMAIL.COM",
      "address": "URBANIZACIÓN TAGUAPIRE CALLE 2, CASA #50",
      "client_identification": "V20244803",
      "nap_box_name": "548",
      "created_at": "2025-11-20T15:47:23.104059",
      "service_detail": {
        "id": 10526,
        "ip": "10.16.122.2",
        "mac": "TPLGC3CCB7FA",
        "serial": "TPLGC3CCB7FA",
        "queue": null,
        "interface": "VLAN129_TAGUAPIRE_ZTE",
        "created_at": "2025-12-03T12:18:48.486330",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8892,
      "client_name": "REPRESENTACIONES FABIOLA FP",
      "client_type_name": "PYME",
      "client_subdivision": "CANCELADO_PYME",
      "status_name": "Cancelado",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04243279781",
      "client_email": "MARIAENEIDACARMONA@GMAIL.COM",
      "address": "CALLE BOLIVAR LOCAL NÚMERO 20 FRENTE LA PLAZA MARIÑO",
      "client_identification": "V8586978",
      "nap_box_name": "CTO-00038",
      "created_at": "2025-11-20T16:14:08.849316",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8893,
      "client_name": "HUMBERTO DAVID MALDONADO PINTO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "18 de Septiembre",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "‎04125497255",
      "client_email": "DM4774651@GMAIL.COM",
      "address": "‎CALLE 1 CASA NUMERO 12 BARRIO 18 DE \n‎SEPTIEMBRE TURMERO",
      "client_identification": "V13199336",
      "nap_box_name": "CE - 771",
      "created_at": "2025-11-21T08:11:40.914481",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8894,
      "client_name": "ORIANA TIBISAY MATOS ESCALONA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Guanarito",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243185943",
      "client_email": "MATOSORIANA0409@GMAIL.COM",
      "address": "SECTOR LEONARDO RUIZ PINEDA, CALLE NEREO TOVAR CASA NÚMERO 60 URBANIZACIÓN GUANARITO, TURMERO.\n‎",
      "client_identification": "V19913474",
      "nap_box_name": "216",
      "created_at": "2025-11-21T08:21:45.523354",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8895,
      "client_name": "SERVICIO DE ASISTENCIA VIAL CA",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 102,
        "name": "RECURRENTE PYME PLAN 150M",
        "cost": "27.60",
        "code": "FOP150M",
        "profile": "150Mbps/150Mbps"
      },
      "client_mobile": "04247097035",
      "client_email": "JEVELIN58@GMAIL.COM",
      "address": "CALLE RICAURTE EDIF SAN MIGUEL PLANTA BAJA LOCAL 1",
      "client_identification": "J294925391",
      "nap_box_name": "CTO-00037",
      "created_at": "2025-11-21T09:39:31.724863",
      "service_detail": {
        "id": 10290,
        "ip": "10.16.125.2",
        "mac": "HWTC195B43A2",
        "serial": "HWTC195B43A2",
        "queue": null,
        "interface": "VLAN200_OLTs",
        "created_at": "2025-11-24T14:03:06.477421",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8896,
      "client_name": "RAFAEL ANTONIO DORAT CEBALLOS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "La Casona II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243186645",
      "client_email": "RDORAT21@GMAIL.COM",
      "address": "AVENIDA INTERCOMUNAL MARACAY TURMERO CASONA DOS EDIFICIO 9B PLANTA BAJA APTO 6",
      "client_identification": "V19002622",
      "nap_box_name": "CTO-0536",
      "created_at": "2025-11-21T15:08:39.197513",
      "service_detail": {
        "id": 10287,
        "ip": "10.16.126.2",
        "mac": "VSOL0013ECE1",
        "serial": "VSOL0013ECE1",
        "queue": null,
        "interface": "VLAN110_CASONA_2",
        "created_at": "2025-11-24T11:07:25.426495",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8897,
      "client_name": "KELVIN DAYERSON SANCHEZ VARGAS",
      "client_type_name": "EMPLEADO",
      "client_subdivision": "ACTIVO_EMPLEADO",
      "status_name": "Activo",
      "cycle": 25,
      "migrate": false,
      "sector_name": "Prados I",
      "plan": {
        "id": 78,
        "name": "Plan empleado 80MB",
        "cost": "0.00",
        "code": "FO-80M",
        "profile": "80M/80M"
      },
      "client_mobile": "04128858460",
      "client_email": "K.SANCHEZVARGAS1@GMAIL.COM",
      "address": "CALLE 17 CASA NRO 1 SECTOR PRADOS DE PAYA 1, TURMERO EDO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V23783510",
      "nap_box_name": "CTO-00211",
      "created_at": "2025-11-24T10:59:52.883242",
      "service_detail": {
        "id": 10308,
        "ip": "172.17.76.2",
        "mac": "TPLGF4EFC50A",
        "serial": "TPLGF4EFC50A",
        "queue": null,
        "interface": "VLAN239_PRADOS1",
        "created_at": "2025-11-24T17:12:37.387398",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8898,
      "client_name": "VICTORIA SALAVARRIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Payita",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243169293",
      "client_email": "VICKYSALAVARRIA58@GMAIL.COM",
      "address": "TURMERO BARRIO PAYITA  CALLE PRINCIPAL CASA 21-B",
      "client_identification": "V6377605",
      "nap_box_name": "CTO - 1023",
      "created_at": "2025-11-24T12:27:55.166289",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8899,
      "client_name": "LA PRINCESA BEAUTY STUDIO CA",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04121597517",
      "client_email": "LAPRINCESABEAUTYSTUDIO@GMAIL.COM",
      "address": "CALLE MARIÑO LOCAL NRO 48 Y 50 SECTOR TURMERO ARAGUA",
      "client_identification": "J507738450",
      "nap_box_name": "CTO-00256",
      "created_at": "2025-11-25T13:34:34.391204",
      "service_detail": {
        "id": 11729,
        "ip": "10.16.128.2",
        "mac": "QXTLCB18226E",
        "serial": "QXTLCB18226E",
        "queue": null,
        "interface": "VLAN200_OLTs",
        "created_at": "2026-02-24T13:42:04.213066",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8900,
      "client_name": "ELVIS ELOY AGUIRRE SOTO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "1ro de Mayo Sur",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243122087",
      "client_email": "DANII281096@GMAIL.COM",
      "address": "AV. PRINCIPAL ROSARIO DE PAYA, SECTOR 1ERO DE MAYO SUR, CALLE #1, CASA #10. PUNTO DE REFERENCIA. DÓNDE ESTÁ EL TLF PÚBLICO AL ENTRAR EN LA CALLE, DESPUÉS DE LAS LINEAS",
      "client_identification": "V18915762",
      "nap_box_name": "CTO-00285",
      "created_at": "2025-11-25T14:28:59.457243",
      "service_detail": {
        "id": 10377,
        "ip": "10.16.127.2",
        "mac": "80227872A512",
        "serial": "CIOT2272A512",
        "queue": null,
        "interface": "VLAN261_1ERO_MAYO_ZTE",
        "created_at": "2025-11-28T12:04:43.223094",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8901,
      "client_name": "SAMUEL ABRAHAM MONTOYA MARQUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Magdalena",
      "plan": {
        "id": 101,
        "name": "RECURRENTE RESIDENCIAL PLAN 200M",
        "cost": "19.00",
        "code": "FOR200MB",
        "profile": "200Mbps/200Mbps"
      },
      "client_mobile": "04124581775",
      "client_email": "SAMUELMONTOYAM1529@GMAIL.COM",
      "address": "LA MAGDALENA, CALLE AV 2 CASA 1.",
      "client_identification": "V30073055",
      "nap_box_name": "CTO - 946",
      "created_at": "2025-11-25T18:09:32.159770",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8902,
      "client_name": "MARIA EUGENIA MENDOZA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Simon Bolivar",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04125403158",
      "client_email": "MARIAEUGENIA148@GMAIL.COM",
      "address": "URB SIMÓN BOLÍVAR CALLE 10 CASA 50",
      "client_identification": "V13828894",
      "nap_box_name": "CTO-00034",
      "created_at": "2025-11-25T18:21:12.280275",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8903,
      "client_name": "VICTORIA SALAVARRIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Payita",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243169293",
      "client_email": "VICKYSALAVARRIA58@GMAIL.COM",
      "address": "CALLE PRINCIPAL DE PAYITA CASA NRO 21-2 SECTOR PAYITA TURMERO",
      "client_identification": "V6377605",
      "nap_box_name": "CTO - 1023",
      "created_at": "2025-11-25T19:56:32.410984",
      "service_detail": {
        "id": 10343,
        "ip": "10.16.131.2",
        "mac": "2012231218002100",
        "serial": "OEMT3C6210B6",
        "queue": null,
        "interface": "VLAN284_PAYITA",
        "created_at": "2025-11-26T10:40:53.382270",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8904,
      "client_name": "DELKIS TAMARA QUEVEDO AMADOR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Guerito",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04123491700",
      "client_email": "BELKISTAMARAQUEVEDO@GMAIL.COM",
      "address": "CALLE1, CASA #40, SECTOR VIRGEN DEL VALLE, SAMAN DE GUERE. PRIMERA CALLE ENTRANDO A MANO DERECHA, CASA DE PORTON NEGRO.",
      "client_identification": "V16761879",
      "nap_box_name": "CE - 254",
      "created_at": "2025-11-25T20:26:59.991516",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8905,
      "client_name": "PROMOTUR ARAGUA 2026., C.A",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Las Rurales",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04125059654",
      "client_email": "PROMOTURARAGUA@GMAIL.COM",
      "address": "CALLE SUCRE ENTRE RICAUTE Y CEDEÑO  CASA  NRO 28 SECTOR CENTRO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "J508763580",
      "nap_box_name": "CTO-00361",
      "created_at": "2025-11-26T18:00:59.554013",
      "service_detail": {
        "id": 10407,
        "ip": "10.16.133.2",
        "mac": "2012231218005621",
        "serial": "OEMT3C6247BA",
        "queue": null,
        "interface": "VLAN252_RURALES_PAYA",
        "created_at": "2025-11-29T19:06:47.532832",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8906,
      "client_name": "REYMING ESTEBAN MACHADO MARTINEZ",
      "client_type_name": "INTERCAMBIO",
      "client_subdivision": "ACTIVO_INTERCAMBIO",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": false,
      "sector_name": "Saman de Guere",
      "plan": {
        "id": 83,
        "name": "RECURRENTE INSTITUCIONAL 80M",
        "cost": "0.00",
        "code": "FO-R80",
        "profile": "80M/80M"
      },
      "client_mobile": "04265305151",
      "client_email": "REYDPET@GMAIL.COM",
      "address": "PARADA INTELIGENTE. AVENIDA SANTIAGO MARIÑO, TURMERO, ESTADO ARAGUA.",
      "client_identification": "V20336303",
      "nap_box_name": "CTO - 1013",
      "created_at": "2025-11-27T09:11:55.143045",
      "service_detail": {
        "id": 10360,
        "ip": "10.11.30.2",
        "mac": "HWTC48080098",
        "serial": "HWTC48080098",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2025-11-27T09:30:01.435314",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8907,
      "client_name": "JOSE ANGEL TOVAR AVILA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Paraguatan",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04142899427",
      "client_email": "JOSEALGEL37@GMAIL.COM",
      "address": "VÍA GUAYABITA SECTOR PARAGUATAN CALLE LOS PÁEZ PUNTO DE REFERENCIA: IGLESIA PENTECOSTÉS A 15 METROS DE LOS POSTES MOROCHOS.",
      "client_identification": "V21204982",
      "nap_box_name": "CTO-00393",
      "created_at": "2025-11-27T09:36:43.441990",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8908,
      "client_name": "REYMING ESTEBAN MACHADO MARTINEZ",
      "client_type_name": "INTERCAMBIO",
      "client_subdivision": "ACTIVO_INTERCAMBIO",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": false,
      "sector_name": "San Pablo",
      "plan": {
        "id": 83,
        "name": "RECURRENTE INSTITUCIONAL 80M",
        "cost": "0.00",
        "code": "FO-R80",
        "profile": "80M/80M"
      },
      "client_mobile": "04265305151",
      "client_email": "REYDPET@GMAIL.COM",
      "address": "CASA COMUNAL. CALLE PRINCIPAL MANZANA 9 URB SAN PABLO",
      "client_identification": "V20336303",
      "nap_box_name": "CE-00141",
      "created_at": "2025-11-27T10:00:15.137048",
      "service_detail": {
        "id": 10361,
        "ip": "10.15.89.2",
        "mac": "QXTLCB7F0288",
        "serial": "QXTLCB7F0288",
        "queue": null,
        "interface": "VLAN224_SAN_PABLO_OLT1",
        "created_at": "2025-11-27T10:40:41.927521",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8909,
      "client_name": "REYMING ESTEBAN MACHADO MARTINEZ",
      "client_type_name": "INTERCAMBIO",
      "client_subdivision": "CANCELADO_INTERCAMBIO",
      "status_name": "Cancelado",
      "cycle": 10,
      "migrate": false,
      "sector_name": "Palmeras II",
      "plan": {
        "id": 83,
        "name": "RECURRENTE INSTITUCIONAL 80M",
        "cost": "0.00",
        "code": "FO-R80",
        "profile": "80M/80M"
      },
      "client_mobile": "04265305151",
      "client_email": "REYDPET@GMAIL.COM",
      "address": "URBANIZACION PALMERAS II, CALLE 9",
      "client_identification": "V20336303",
      "nap_box_name": "287",
      "created_at": "2025-11-27T14:38:17.372042",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8910,
      "client_name": "YOSMERLINE FABIANNY MARTINEZ BLANCO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "El Cambur",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128661141",
      "client_email": "YOSMERLINE23@GMAIL.COM",
      "address": "SECTOR CORAZÓN DE JESÚS, EL CAMBUR PAYA.",
      "client_identification": "V29866143",
      "nap_box_name": "CTO-004444",
      "created_at": "2025-11-30T16:30:29.927535",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8911,
      "client_name": "ANTHONY KLEIBER TEJADA ALVAREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Taguapire",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243650923",
      "client_email": "ANTHOONYY@GMAIL.COM",
      "address": "CALLE 3 APTO 68 URB TAGUAPIRE TURMERO",
      "client_identification": "V19516571",
      "nap_box_name": "CTO-00386",
      "created_at": "2025-12-01T14:01:02.704087",
      "service_detail": {
        "id": 10495,
        "ip": "172.18.171.2",
        "mac": "TPLG2ABDC6AD",
        "serial": "TPLG2ABDC6AD",
        "queue": null,
        "interface": "VLAN129_TAGUAPIRE_ZTE",
        "created_at": "2025-12-02T16:56:48.097086",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8912,
      "client_name": "CARLOS EDUARDO GUZMAN VENOT",
      "client_type_name": "INTERCAMBIO",
      "client_subdivision": "CANCELADO_INTERCAMBIO",
      "status_name": "Cancelado",
      "cycle": 10,
      "migrate": false,
      "sector_name": "La Julia",
      "plan": {
        "id": 83,
        "name": "RECURRENTE INSTITUCIONAL 80M",
        "cost": "0.00",
        "code": "FO-R80",
        "profile": "80M/80M"
      },
      "client_mobile": "04241813398",
      "client_email": "YOSELYN_2007_MX@GMAIL.COM",
      "address": "URB PLAZA JARDIN SECTOR LA JULIA CASA II TURMERO",
      "client_identification": "V17570976",
      "nap_box_name": "439",
      "created_at": "2025-12-01T17:08:44.303601",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8913,
      "client_name": "JOSE LUIS GUZMAN BRICEÑO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Valle Paraiso",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243191992",
      "client_email": "JOSEGUZBRIC@GMAIL.COM",
      "address": "URBANIZACION VALLE PARAISO MANZANA 10 CASA 7, SAN PABLO TURMERO",
      "client_identification": "V9659305",
      "nap_box_name": "CE-00254",
      "created_at": "2025-12-03T14:25:14.233259",
      "service_detail": {
        "id": 10556,
        "ip": "10.16.135.2",
        "mac": "2012231218001207",
        "serial": "OEMT3C6202C2",
        "queue": null,
        "interface": "VLAN227_V_PARAISO_OLT1",
        "created_at": "2025-12-03T15:25:33.050590",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8914,
      "client_name": "JINEIBY ANDREINA VARGAS MORILLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Betania",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04120449500",
      "client_email": "JINEIBYVARGAS197@GMAIL.COM",
      "address": "TURMERO ROSARIO DE PAYA COMUNIDAD BETANIA CALLE 1",
      "client_identification": "V28187279",
      "nap_box_name": "CTO-00233",
      "created_at": "2025-12-03T15:00:02.912711",
      "service_detail": {
        "id": 12321,
        "ip": "172.22.251.2",
        "mac": "TPLGBA687A68",
        "serial": "TPLGBA687A68",
        "queue": null,
        "interface": "VLAN260_BETANIA",
        "created_at": "2026-04-16T11:00:50.952273",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8915,
      "client_name": "PAOLA VALENTINA GUANIPA BEJAS",
      "client_type_name": "EMPLEADO",
      "client_subdivision": "ACTIVO_EMPLEADO",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": false,
      "sector_name": "Taguapire",
      "plan": {
        "id": 78,
        "name": "Plan empleado 80MB",
        "cost": "0.00",
        "code": "FO-80M",
        "profile": "80M/80M"
      },
      "client_mobile": "04243831915",
      "client_email": "DIEGOARRICHI47@GMAIL.COM",
      "address": "EL MACARO, URBANIZACION TAGUAPIRE, II ETAPA NO. 99 PLANTA ALTA, MODULO 10. TURMERO",
      "client_identification": "V30800722",
      "nap_box_name": "CTO-00388 DOS",
      "created_at": "2025-12-03T15:22:21.832334",
      "service_detail": {
        "id": 12882,
        "ip": "172.30.61.2",
        "mac": "HW:TC:46:34:EE:9B",
        "serial": "HWTC4634EE9B",
        "queue": null,
        "interface": "VLAN129_TAGUAPIRE_ZTE",
        "created_at": "2026-08-18T17:48:52.062848",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8916,
      "client_name": "YSVET YARITZA MARVAL GARCIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Taguapire",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243113361",
      "client_email": "ISVETMARVAK@GMAIL.COM",
      "address": "URBANIZACIÓN TAGUAPIRE CALLE 3 CASA 75",
      "client_identification": "V14838162",
      "nap_box_name": "CTO-00386",
      "created_at": "2025-12-03T16:22:51.439939",
      "service_detail": {
        "id": 10590,
        "ip": "10.16.136.2",
        "mac": "MONU003C279D",
        "serial": "MONU003C279D",
        "queue": null,
        "interface": "VLAN129_TAGUAPIRE_ZTE",
        "created_at": "2025-12-04T15:40:02.797086",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8917,
      "client_name": "CIRO AGUSTIN FLORES SILVA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Los Nisperos",
      "plan": {
        "id": 101,
        "name": "RECURRENTE RESIDENCIAL PLAN 200M",
        "cost": "19.00",
        "code": "FOR200MB",
        "profile": "200Mbps/200Mbps"
      },
      "client_mobile": "04166215897",
      "client_email": "CIROFLORES1@GMAIL.COM",
      "address": "AV BOLIVAR EDIF TORRE B PISO 10 APT 106 URB CONJUNTO RESIDENCIAL LOS NISPEROS TURMERO",
      "client_identification": "V5276069",
      "nap_box_name": "TORRE B EDIF LOS NISPEROS",
      "created_at": "2025-12-03T19:40:17.025346",
      "service_detail": {
        "id": 10607,
        "ip": "172.16.227.2",
        "mac": "OEMT3C6244D2",
        "serial": "OEMT3C6244D2",
        "queue": null,
        "interface": "VLAN272_EDIF_NISPEROS_OLT3",
        "created_at": "2025-12-06T10:29:20.233615",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8918,
      "client_name": "MARIBEL DE JESUS ARMAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Callejon Lim",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144929431",
      "client_email": "01116@GMAIL.COM",
      "address": "TURMERO VIA PAYA URBANIZACIÓN VILLAS TURMERO CALLEJON LIM EDIF AZUCENA  PISO 3 APARTAMENTO 12",
      "client_identification": "V9664737",
      "nap_box_name": "TORRE AZUCENA",
      "created_at": "2025-12-04T10:17:51.888176",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8919,
      "client_name": "DANIELA COROMOTO CARVALLO OVIEDO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Luz y Vida",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04127763111",
      "client_email": "LUCIANACARVALLO99@GMAIL.COM",
      "address": "PARCELAMIENTO LUZ Y VIDA \n‎CALLE 2  CASA 168",
      "client_identification": "V27669633",
      "nap_box_name": "CTO-921",
      "created_at": "2025-12-04T12:51:59.442550",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8920,
      "client_name": "POLICIA MUNICIPAL SANTIAGO MARINO",
      "client_type_name": "INTERCAMBIO",
      "client_subdivision": "ACTIVO_INTERCAMBIO",
      "status_name": "Activo",
      "cycle": 25,
      "migrate": false,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 83,
        "name": "RECURRENTE INSTITUCIONAL 80M",
        "cost": "0.00",
        "code": "FO-R80",
        "profile": "80M/80M"
      },
      "client_mobile": "04128472680",
      "client_email": "NE7@NE.COM",
      "address": "AV FINAL BOLIBAR EDIF SEDE IAPMSM PISO S/N OF S/N SECTOR CENTRO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "G200051337",
      "nap_box_name": "CTO - 1388",
      "created_at": "2025-12-05T16:39:57.204607",
      "service_detail": {
        "id": 10605,
        "ip": "10.16.31.2",
        "mac": "OEMT3c625006",
        "serial": "OEMT3c625006",
        "queue": null,
        "interface": "VLAN200_OLTs",
        "created_at": "2025-12-05T19:44:58.737214",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8921,
      "client_name": "FRANCISCO DE JESUS RATIA MALUENGA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Los Nisperos",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04241840780",
      "client_email": "MALUENGA1961@GMAIL.COM",
      "address": "RESIDENCIA LOS NÍSPEROS TORRE B PISO 1 APTO 11",
      "client_identification": "V7192726",
      "nap_box_name": "TORRE B EDIF LOS NISPEROS",
      "created_at": "2025-12-05T17:51:59.319002",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8922,
      "client_name": "LUIS ENRIQUE CASTELLANOS BONILLA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Palmeras II",
      "plan": {
        "id": 101,
        "name": "RECURRENTE RESIDENCIAL PLAN 200M",
        "cost": "19.00",
        "code": "FOR200MB",
        "profile": "200Mbps/200Mbps"
      },
      "client_mobile": "04243703599",
      "client_email": "LUISBONILLA5021@GMAIL.COM",
      "address": "URB LAS PALMERAS CALLE 2 CASA 109",
      "client_identification": "V19654719",
      "nap_box_name": "6",
      "created_at": "2025-12-06T15:25:57.492990",
      "service_detail": {
        "id": 11423,
        "ip": "10.15.158.2",
        "mac": "QXTLCB1EB4F3",
        "serial": "QXTLCB1EB4F3",
        "queue": null,
        "interface": "VLAN118_PALMERAS_1",
        "created_at": "2026-01-29T22:35:55.542094",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8923,
      "client_name": "DILFA MARINA CHACON MORENO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Urb. Vista Hermosa La Julia",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243783350",
      "client_email": "DILFAMARINA1899@GMAIL.COM",
      "address": "CALLE LAS MANDARINAS CASA NRO 74 SECTOR VISTA HERMOSA ROSARIO DE PAYA",
      "client_identification": "V6498884",
      "nap_box_name": "CTO-00059",
      "created_at": "2025-12-07T18:39:02.761434",
      "service_detail": {
        "id": 10637,
        "ip": "10.15.129.2",
        "mac": "HWTC3C7CFAA2",
        "serial": "HWTC3C7CFAA2",
        "queue": null,
        "interface": "VLAN230_VISTA_HERMOSA",
        "created_at": "2025-12-08T18:10:05.500801",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8924,
      "client_name": "HELIANA NINOSKA CONTRERAS ULLOA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "1ro de Mayo Norte",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04123986473",
      "client_email": "HELIANAN.CONTRERAS@GMAIL.COM",
      "address": "CALLE GUAICAIPURO CASA 126B PRIMERO DE MAYO NORTE ROSARIO DE PAYA",
      "client_identification": "V20706828",
      "nap_box_name": "CTO - 919",
      "created_at": "2025-12-09T08:10:55.220313",
      "service_detail": {
        "id": 10647,
        "ip": "172.31.24.2",
        "mac": "OEMT3C623246",
        "serial": "OEMT3C623246",
        "queue": null,
        "interface": "VLAN261_1ERO_MAYO_ZTE",
        "created_at": "2025-12-10T17:33:40.162357",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8925,
      "client_name": "JOSE MIGUEL REQUENA CARRILLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243771087",
      "client_email": "GENESIS.GG37@GMAIL.COM",
      "address": "TURMERO CASCO CENTRAL CALLEJÓN GRADISCO CASA #3",
      "client_identification": "V25880882",
      "nap_box_name": "CTO-1839",
      "created_at": "2025-12-09T11:59:43.058469",
      "service_detail": {
        "id": 10644,
        "ip": "172.26.208.2",
        "mac": "HWTC5427B0A3",
        "serial": "HWTC5427B0A3",
        "queue": null,
        "interface": "VLAN200_OLTs",
        "created_at": "2025-12-09T15:21:04.601928",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8926,
      "client_name": "TRANSPORTE EMPRENDEDORES PECO SMITH SM 2025 CA",
      "client_type_name": "PYME",
      "client_subdivision": "CANCELADO_PYME",
      "status_name": "Cancelado",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Guerito",
      "plan": {
        "id": 36,
        "name": "RECURRENTE PYME PLAN 650M",
        "cost": "70.18",
        "code": "FOP650M",
        "profile": "650M/650M"
      },
      "client_mobile": "04129343520",
      "client_email": "SMITHPECO@GMAIL.COM",
      "address": "CALLE PIAR CASA 120 SAN MIGUEL SECTOR LA JULIA CACHIPO NORTE",
      "client_identification": "J506122987",
      "nap_box_name": "CE-00099",
      "created_at": "2025-12-09T15:07:52.468700",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8927,
      "client_name": "TRANSPORTE EMPRENDEDORES PECO SMITH SM 2025 CA",
      "client_type_name": "PYME",
      "client_subdivision": "CANCELADO_PYME",
      "status_name": "Cancelado",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Guerito",
      "plan": {
        "id": 36,
        "name": "RECURRENTE PYME PLAN 650M",
        "cost": "70.18",
        "code": "FOP650M",
        "profile": "650M/650M"
      },
      "client_mobile": "04129343520",
      "client_email": "SMITHPECO@GMAIL.COM",
      "address": "CALLE PIAR CASA 120 SAN MIGUEL SECTOR LA JULIA CACHIPO NORTE",
      "client_identification": "J506122987",
      "nap_box_name": "CE-00099",
      "created_at": "2025-12-09T15:11:03.107295",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8928,
      "client_name": "TRANSPORTE EMPRENDEDORES PECO SMITH SM 2025 CA",
      "client_type_name": "PYME",
      "client_subdivision": "CANCELADO_PYME",
      "status_name": "Cancelado",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Guerito",
      "plan": {
        "id": 102,
        "name": "RECURRENTE PYME PLAN 150M",
        "cost": "27.60",
        "code": "FOP150M",
        "profile": "150Mbps/150Mbps"
      },
      "client_mobile": "04129343520",
      "client_email": "SMITHPECO@GMAIL.COM",
      "address": "CALLE PIAR CASA 120 SAN MIGUEL SECTOR LA JULIA CACHIPO NORTE",
      "client_identification": "J506122987",
      "nap_box_name": "CE-00099",
      "created_at": "2025-12-09T15:14:27.654893",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8929,
      "client_name": "TRANSPORTE EMPRENDEDORES PECO SMITH SM 2025 CA",
      "client_type_name": "PYME",
      "client_subdivision": "CANCELADO_PYME",
      "status_name": "Cancelado",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Guerito",
      "plan": {
        "id": 102,
        "name": "RECURRENTE PYME PLAN 150M",
        "cost": "27.60",
        "code": "FOP150M",
        "profile": "150Mbps/150Mbps"
      },
      "client_mobile": "04129343520",
      "client_email": "SMITHPECO@GMAIL.COM",
      "address": "CALLE PIAR CASA 120 SAN MIGUEL SECTOR LA JULIA CACHIPO NORTE",
      "client_identification": "J506122987",
      "nap_box_name": "CE-00099",
      "created_at": "2025-12-09T15:16:53.216909",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8930,
      "client_name": "PEDRO PRUEBA RODRIGUE PRUEBA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Saman Tarazonero I",
      "plan": {
        "id": 19,
        "name": "RECURRENTE RESIDENCIAL PLAN 1GB",
        "cost": "74.70",
        "code": "FOR1GB",
        "profile": "1000M/1000M"
      },
      "client_mobile": "04140390506",
      "client_email": "ELIREYES_VE@YAHOO.ES",
      "address": "SAMAN TARAZONERO CALLE 3 CASA 43 MACARO",
      "client_identification": "V5050505",
      "nap_box_name": "32",
      "created_at": "2025-12-10T09:23:25.437890",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8931,
      "client_name": "JOSE GREGORIO VALERO SIMANCAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Jabillar",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04124576948",
      "client_email": "VALEROSIMANCASJOSEGREGORIO@GMAIL.COM",
      "address": "URBANIZACIÓN JABILLAR CALLE 5 CASA NRO 14",
      "client_identification": "V16205461",
      "nap_box_name": "CTO-00006 C/4 JABILLAR",
      "created_at": "2025-12-11T13:18:43.698351",
      "service_detail": {
        "id": 10671,
        "ip": "10.16.137.2",
        "mac": "MONU0038F6E1",
        "serial": "MONU0038F6E1",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2025-12-12T12:55:35.801164",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8932,
      "client_name": "LUIS ALBERTO RODRIGUES DE ABREU GUZMAN",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243420735",
      "client_email": "LUISRODRIGUESDABREU@GMAIL.COM",
      "address": "URBANIZACIÓN MARIÑO CALLE GIRARDOT CASA NÚMERO TRES, TURMERO.",
      "client_identification": "V10355681",
      "nap_box_name": "53",
      "created_at": "2025-12-12T15:36:13.582705",
      "service_detail": {
        "id": 10729,
        "ip": "10.16.141.2",
        "mac": "2012231218006190",
        "serial": "OEMT3C62509E",
        "queue": null,
        "interface": "VLAN200_OLTs",
        "created_at": "2025-12-15T13:15:05.252293",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8933,
      "client_name": "JHON FLAVIANO ZAMBRANO PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243772930",
      "client_email": "jhorker7@gmail.com",
      "address": "LA CASONA 2, LAS PRIMAVERAS EDIFICIO 9-B, PISO 2 APTO 1",
      "client_identification": "V14680121",
      "nap_box_name": "CTO-0536",
      "created_at": "2025-12-15T09:44:05.658110",
      "service_detail": {
        "id": 12773,
        "ip": "172.23.220.2",
        "mac": "VS:OL:00:13:CF:D1",
        "serial": "VSOL0013CFD1",
        "queue": null,
        "interface": "VLAN110_CASONA_2",
        "created_at": "2026-07-26T09:26:57.531168",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8934,
      "client_name": "ROBERTO ANTONIO SANCHEZ ARRIECHE",
      "client_type_name": "EMPLEADO",
      "client_subdivision": "ACTIVO_EMPLEADO",
      "status_name": "Activo",
      "cycle": 25,
      "migrate": false,
      "sector_name": "Guerito",
      "plan": {
        "id": 78,
        "name": "Plan empleado 80MB",
        "cost": "0.00",
        "code": "FO-80M",
        "profile": "80M/80M"
      },
      "client_mobile": "04243426333",
      "client_email": "RSANCHEZSGF@GMAIL.COM",
      "address": "CALLE JOSE FELIX RIVAS CASA NRO 8 GUERITO EL MACARO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V14943068",
      "nap_box_name": "CTO - 947",
      "created_at": "2025-12-15T10:58:46.438457",
      "service_detail": {
        "id": 11838,
        "ip": "172.30.152.2",
        "mac": "OEMT3C625832",
        "serial": "OEMT3C625832",
        "queue": null,
        "interface": "VLAN139_GUERITO",
        "created_at": "2026-02-27T12:06:40.871241",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8935,
      "client_name": "JIANG JESUS ESCORCHE QUERALES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Isaac Oliveira",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243295599",
      "client_email": "JIANGJESUS25R@GMAIL.COM",
      "address": "URBANIZACIÓN ISAAC OLIVERA CALLE 1 CASA 13 PUNTO DE REFERENCIA A UNA CUADRA DE LA ENTRADA DE LA RESIDENCIA",
      "client_identification": "V28050851",
      "nap_box_name": "CTO-00258",
      "created_at": "2025-12-15T16:32:25.370279",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8936,
      "client_name": "ROXANNA SARAHYS BOLIVAR DELGADO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Vallecito",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04125974063",
      "client_email": "ROXANNASARAHYS@GMAIL.COM",
      "address": "ROSARIO DE PAYA  VALLECITO CALLE LOS CAOBOS CASA NRO 24",
      "client_identification": "V23528123",
      "nap_box_name": "CTO-00067",
      "created_at": "2025-12-16T13:01:36.755971",
      "service_detail": {
        "id": 10784,
        "ip": "10.16.144.2",
        "mac": "689FF0CC80EF",
        "serial": "QXTLCB68771A",
        "queue": null,
        "interface": "VLAN258_VALLECITO",
        "created_at": "2025-12-17T17:31:00.351281",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8937,
      "client_name": "GUILIS EDUARDO MARIN PALMA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Pantin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04125970101",
      "client_email": "GUILLIS777@GMAIL.COM",
      "address": "URBANIZACIÓN PANTIN CALLE #12B CASA #40, ROSARIO DE PAYA .",
      "client_identification": "V12569755",
      "nap_box_name": "CTO-00166",
      "created_at": "2025-12-16T15:47:03.871252",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8938,
      "client_name": "DIANA OLIMAR LAYA MARQUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243220506",
      "client_email": "LAYADIANA892@GMAIL.COM",
      "address": "CALLE NEGRO PRIMERO #26 TURMERO",
      "client_identification": "V18163298",
      "nap_box_name": "CTO-00065",
      "created_at": "2025-12-18T13:10:33.357662",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8939,
      "client_name": "RICHEL SOLEDAD RODRIGUEZ PLASENCIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "San Pablo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04228151260",
      "client_email": "RICHEL2804@GMAIL.COM",
      "address": "HARÁS SAN PABLO LAGUNA 2 TORRE 2, PISO 2 APTO 2-4-13",
      "client_identification": "V10750568",
      "nap_box_name": "CTO-0489",
      "created_at": "2025-12-18T22:56:54.654092",
      "service_detail": {
        "id": 10817,
        "ip": "10.16.145.2",
        "mac": "689FF0CC87DF",
        "serial": "QXTLCB17A91C",
        "queue": null,
        "interface": "VLAN216_LAGUNA_PLAZA_OLT1",
        "created_at": "2025-12-19T08:25:41.219918",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8940,
      "client_name": "APLAUSO FM CA GENTE DE RADIO",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 103,
        "name": "RECURRENTE PYME PLAN 400M",
        "cost": "51.74",
        "code": "FOP400M",
        "profile": "400Mbps/400Mbps"
      },
      "client_mobile": "04243002713",
      "client_email": "GENTEDERADIOAPLAUSOFM@GMAIL.COM",
      "address": "CASCO DE TURMERO FRENTE AL CONSEJO EDIFICIO NONO LORENZO PB",
      "client_identification": "J505391631",
      "nap_box_name": "CTO-00072",
      "created_at": "2025-12-19T13:29:16.401179",
      "service_detail": {
        "id": 10822,
        "ip": "172.22.97.2",
        "mac": "TPLGB68B4EC8",
        "serial": "TPLGB68B4EC8",
        "queue": null,
        "interface": "VLAN200_OLTs",
        "created_at": "2025-12-19T13:44:59.916971",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8941,
      "client_name": "NELLY JUANA MIJARES GARCIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "La Casona II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243395624",
      "client_email": "NELLYMIJARES550@GMAIL.COM",
      "address": "LA CASONA 2 CALLE 13 CASA NÚMERO 46",
      "client_identification": "V6445100",
      "nap_box_name": "CTO-00075 DOS",
      "created_at": "2025-12-22T09:28:06.535966",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8942,
      "client_name": "DARLIS JOSE DIAZ AREVALO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04124563859",
      "client_email": "DARLISJOSEDIAZ@GMAIL.COM",
      "address": "SAMAN TARAZONERO 2, MANZANA C, CASA  8-1",
      "client_identification": "V12343314",
      "nap_box_name": "115",
      "created_at": "2025-12-22T15:10:36.714897",
      "service_detail": {
        "id": 10919,
        "ip": "10.16.146.2",
        "mac": "689FF0CC846F",
        "serial": "QXTLCB960D8F",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2025-12-23T18:06:05.973635",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8943,
      "client_name": "LUIS BRAYAN MEDINA RIVAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243007709",
      "client_email": "LUISDRIS05@GMAIL.COM",
      "address": "CALLE NEGRO PRIMERO CASA NRO 31-1 SECTOR PUEBLO NUEVO TURMERO",
      "client_identification": "V30658968",
      "nap_box_name": "CTO-00065",
      "created_at": "2025-12-22T20:04:30.093348",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8944,
      "client_name": "ENDRINA YOLIMAR BEAUMONT AGRA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Narayola II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128991802",
      "client_email": "ENDRYAGRAZ22@GMAIL.COM",
      "address": "URB NARAYOLA TORRE 1 APTO PB-5 TURMERO",
      "client_identification": "V20990423",
      "nap_box_name": "CTO-0521",
      "created_at": "2025-12-23T14:47:12.612719",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8945,
      "client_name": "TERESA EMILIA GONZALEZ SANCHEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Terrazas de Paya",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128195010",
      "client_email": "TG6790886@GMAIL.COM",
      "address": "TERRAZAS DE PAYA MANZANA 2 # 9 CALLE 3",
      "client_identification": "V7192483",
      "nap_box_name": "0165",
      "created_at": "2025-12-29T15:34:41.459730",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8946,
      "client_name": "TERESA EMILIA GONZALEZ SANCHEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Terrazas de Paya",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128195010",
      "client_email": "TG6790886@GMAIL.COM",
      "address": "TERRAZAS DE PAYA, CALLE 3 MANZANA 2 # 9",
      "client_identification": "V7192483",
      "nap_box_name": "0165",
      "created_at": "2025-12-30T11:49:59.914950",
      "service_detail": {
        "id": 11382,
        "ip": "10.16.148.2",
        "mac": "OEMT3C624782",
        "serial": "OEMT3C624782",
        "queue": null,
        "interface": "VLAN243_BICENTENARIO",
        "created_at": "2026-01-26T11:24:17.925867",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8947,
      "client_name": "SONIA JOSEFINA COELLO LUGO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Guanarito",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04125970436",
      "client_email": "SONIACOELLO936@GAMIL.COM",
      "address": "AV PRINCIPAL POR LAS PALMERAS, PUNTO DE REFERENCIA BODEGA DE TOLDO AZUL.",
      "client_identification": "V12167779",
      "nap_box_name": "632",
      "created_at": "2026-01-09T03:35:44.589591",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8948,
      "client_name": "MARITZA MANRIQUE LUGO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Turmerito",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121419856",
      "client_email": "NICASIALUGO@GMAIL.COM",
      "address": "TURMERITO, EL MACARO CALLE LOS TAMARINDO CASA 1",
      "client_identification": "V8738415",
      "nap_box_name": "CTO - 1460",
      "created_at": "2026-01-09T14:02:38.800274",
      "service_detail": {
        "id": 11767,
        "ip": "10.16.151.2",
        "mac": "HWTC96894B88",
        "serial": "HWTC96894B88",
        "queue": null,
        "interface": "VLAN137_LA_ESPERANZA_OLT_ZTE",
        "created_at": "2026-02-27T10:11:10.406497",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8950,
      "client_name": "YUSMELY NACARIS OROPEZA REYES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Polvorin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243218082",
      "client_email": "YUSME46ORO@GMAIL.COM",
      "address": "CALLE CALLEJON PIMENTEL CASA NRO 3-3 BARRIO POLVORIN TURMERO",
      "client_identification": "V12169585",
      "nap_box_name": "CTO - 991",
      "created_at": "2026-01-09T15:13:42.669813",
      "service_detail": {
        "id": 11143,
        "ip": "10.16.152.2",
        "mac": "ZXICCD34202D",
        "serial": "ZXICCD34202D",
        "queue": null,
        "interface": "VLAN280_POLVORIN",
        "created_at": "2026-01-13T18:32:35.740228",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8951,
      "client_name": "HUGO JOSE TOVAR CARREÑO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Guanarito",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243285839",
      "client_email": "yeilymar.laya23@gmail.com",
      "address": "CALLE PENALVER CENTRO INDUSTRIAL SIMONELLI LOCAL  GALPÓN NRO 6 SECTOR GUANARITO TURMERO ESTADO ARAGUA",
      "client_identification": "V13770135",
      "nap_box_name": "126",
      "created_at": "2026-01-09T16:08:37.196630",
      "service_detail": {
        "id": 11072,
        "ip": "10.16.149.2",
        "mac": "80D4A5A30340",
        "serial": "HWTC48220052",
        "queue": null,
        "interface": "VLAN232_GUANARITO_OLT2",
        "created_at": "2026-01-09T16:18:35.362568",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8952,
      "client_name": "FRANCISCO JOSE PADRON SUAREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Los Caobos",
      "plan": {
        "id": 101,
        "name": "RECURRENTE RESIDENCIAL PLAN 200M",
        "cost": "19.00",
        "code": "FOR200MB",
        "profile": "200Mbps/200Mbps"
      },
      "client_mobile": "04121493567",
      "client_email": "FP13412296@GMAIL.COM",
      "address": "LOS CAOBOS CALLE LOS TULIPANES  CASA 10",
      "client_identification": "V13412296",
      "nap_box_name": "CE - 546",
      "created_at": "2026-01-09T16:30:15.943846",
      "service_detail": {
        "id": 13046,
        "ip": "172.17.150.2",
        "mac": "HW:TC:45:A0:27:47",
        "serial": "HWTC45A02747",
        "queue": null,
        "interface": "VLAN116_CAOBOS",
        "created_at": "2026-09-19T18:23:57.173568",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8953,
      "client_name": "JEHISSON JOSE PEREZ CORTEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "La Esperanza",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "0412-2083571",
      "client_email": "JEHISSONPEREZ260494@GMAIL.COM",
      "address": "CALLE 23 CASA NÚMERO 12 SECTOR LA ESPERANZA EL MACARO",
      "client_identification": "V21425545",
      "nap_box_name": "555",
      "created_at": "2026-01-09T18:06:33.914071",
      "service_detail": {
        "id": 11139,
        "ip": "10.16.150.2",
        "mac": "QXTLCBCF3DDE",
        "serial": "QXTLCBCF3DDE",
        "queue": null,
        "interface": "VLAN137_LA_ESPERANZA_OLT_ZTE",
        "created_at": "2026-01-13T16:58:42.187811",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8954,
      "client_name": "JHOLBER ALEXANDER ROMERO CEGARRA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman de Guere",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144415296",
      "client_email": "JARC.JTH@GMAIL.COM",
      "address": "SECTOR SAMAN DE GUERE CALLE LA LLANERA CASA #6 FUNDO LA TRINIDAD",
      "client_identification": "V22290996",
      "nap_box_name": "290",
      "created_at": "2026-01-12T08:24:37.912146",
      "service_detail": {
        "id": 11188,
        "ip": "172.18.190.2",
        "mac": "TPLGB777B9EA",
        "serial": "TPLGB777B9EA",
        "queue": null,
        "interface": "VLAN122_SAMAN_GUERE",
        "created_at": "2026-01-15T17:21:05.244271",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8955,
      "client_name": "MIREYA RAMONA TORO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Los Nisperos",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "‎04145432674",
      "client_email": "TOROMIREYA09@GMAIL.COM",
      "address": "CALLE PRINCIPAL EDIFICIO TORRE C PISO 03 APTO 35 CONJUNTO RESIDENCIAL LOS NÍSPEROS",
      "client_identification": "V9315501",
      "nap_box_name": "TORRE B EDIF LOS NISPEROS",
      "created_at": "2026-01-13T14:24:32.473708",
      "service_detail": {
        "id": 12396,
        "ip": "10.16.153.2",
        "mac": "QXTLCB8651D1",
        "serial": "QXTLCB8651D1",
        "queue": null,
        "interface": "VLAN272_EDIF_NISPEROS_OLT3",
        "created_at": "2026-04-22T14:55:53.500480",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8956,
      "client_name": "FRANK RAMON CALDERON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243091295",
      "client_email": "FRANKCALDERON245@GMAIL.COM",
      "address": "‎CALLE BERMUDEZ CASA NUMERO A-2 SECTOR TURMERO",
      "client_identification": "V9433535",
      "nap_box_name": "CTO - 942",
      "created_at": "2026-01-13T20:32:25.462209",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8957,
      "client_name": "MARIA MARGARITA OSUNA PEÑA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Betania",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243638975",
      "client_email": "MARGARITAOSUNA309@GMAIL.COM",
      "address": "CALLE 06 CASA NRO 369 SECTOR BETANIA ROSARIO DE PAYA",
      "client_identification": "V20056262",
      "nap_box_name": "0165",
      "created_at": "2026-01-14T10:32:02.682351",
      "service_detail": {
        "id": 11267,
        "ip": "10.16.155.2",
        "mac": "ZXICCD3E0D48",
        "serial": "ZXICCD3E0D48",
        "queue": null,
        "interface": "VLAN260_BETANIA",
        "created_at": "2026-01-21T12:08:08.704498",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8961,
      "client_name": "PEDRO MANUEL RODRIGUEZ ROJAS",
      "client_type_name": "EMPLEADO",
      "client_subdivision": "ACTIVO_EMPLEADO",
      "status_name": "Activo",
      "cycle": 25,
      "migrate": false,
      "sector_name": "Campo Alegre",
      "plan": {
        "id": 78,
        "name": "Plan empleado 80MB",
        "cost": "0.00",
        "code": "FO-80M",
        "profile": "80M/80M"
      },
      "client_mobile": "04124103560",
      "client_email": "tecnologiauctsaragua@gmail.com",
      "address": "Torre 3 Piso 1 departamento # 23",
      "client_identification": "V13908262",
      "nap_box_name": "CTO-00733",
      "created_at": "2026-01-14T10:32:02.682000",
      "service_detail": {
        "id": 12374,
        "ip": "10.16.201.2",
        "mac": "OEMT3C624D76",
        "serial": "OEMT3C624D76",
        "queue": null,
        "interface": "VLAN224_SAN_PABLO_OLT1",
        "created_at": "2026-04-20T11:49:02.281655",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8962,
      "client_name": "CARLOS ELIU ALVAREZ CAMACHO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Guerito",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "‎0412-5783306",
      "client_email": "CA.FAJI28@GMAIL.COM",
      "address": "TORRE 8C, PISO 1, APARTAMENTO 1B CONJUNTO RESIDENCIA LOS SAMANES, GUERITO",
      "client_identification": "V25068450",
      "nap_box_name": "CE (Proyecto)",
      "created_at": "2026-01-14T11:52:11.004100",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8963,
      "client_name": "ANA ROSA RUENDES SEGURA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Los Mangos",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "0424-3391160",
      "client_email": "RUENDESANA809@GMAIL.COM",
      "address": "CALLE LAS BRISAS CASA NÚMERO 24 LOS MANGOS ROSARIO DE PAYA",
      "client_identification": "V32239974",
      "nap_box_name": "CTO-00483",
      "created_at": "2026-01-14T17:53:49.841462",
      "service_detail": {
        "id": 11212,
        "ip": "10.16.157.2",
        "mac": "ZXICCD3C9787",
        "serial": "ZXICCD3C9787",
        "queue": null,
        "interface": "VLAN267_LOS_MANGOS_ZTE",
        "created_at": "2026-01-16T19:41:33.165472",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8966,
      "client_name": "AÑADIDURA DEL REY, C.A.",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04144514265",
      "client_email": "ANAPATI0140@GMAIL.COM",
      "address": "CALLE RIVAS QTA NÚMERO 31 CENTRO TURMERO",
      "client_identification": "J412579916",
      "nap_box_name": "CAJA NAP PLAZA SANTIAGO MARINO",
      "created_at": "2026-01-15T13:57:26.569948",
      "service_detail": {
        "id": 11169,
        "ip": "172.27.77.2",
        "mac": "HWTCD65C679C",
        "serial": "HWTCD65C679C",
        "queue": null,
        "interface": "VLAN200_OLTs",
        "created_at": "2026-01-15T14:05:23.986804",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8967,
      "client_name": "NELSON JOSE CORDERO RAMOS",
      "client_type_name": "INTERCAMBIO",
      "client_subdivision": "ACTIVO_INTERCAMBIO",
      "status_name": "Activo",
      "cycle": 25,
      "migrate": false,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 83,
        "name": "RECURRENTE INSTITUCIONAL 80M",
        "cost": "0.00",
        "code": "FO-R80",
        "profile": "80M/80M"
      },
      "client_mobile": "04243456313",
      "client_email": "nelsoncorderoramos@gmail.com",
      "address": "calle bermudez entre calle mellados piso 3 oficina principal ",
      "client_identification": "V18884724",
      "nap_box_name": "CTO-00097",
      "created_at": "2026-01-15T00:00:00",
      "service_detail": {
        "id": 11676,
        "ip": "172.29.211.2",
        "mac": "OEMT3C62622E",
        "serial": "OEMT3C62622E",
        "queue": null,
        "interface": "VLAN200_OLTs",
        "created_at": "2026-02-19T12:26:32.987676",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8968,
      "client_name": "VICTOR ALEJANDRO HADDAD MANJOUD",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128867279",
      "client_email": "VICTORHADDAD2000@GMAIL.COM",
      "address": "CALLE URDANETA CASA 29 LOS NÍSPEROS, TURMERO",
      "client_identification": "V27434950",
      "nap_box_name": "CTO-00246",
      "created_at": "2026-01-16T11:13:49.211550",
      "service_detail": {
        "id": 11223,
        "ip": "10.16.159.2",
        "mac": "2012231218001099",
        "serial": "OEMT3C620112",
        "queue": null,
        "interface": "VLAN200_OLTs",
        "created_at": "2026-01-18T20:37:12.686220",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8969,
      "client_name": "RAFAEL GUILLERMO PADILLA BARROETA",
      "client_type_name": "INTERCAMBIO",
      "client_subdivision": "ACTIVO_INTERCAMBIO",
      "status_name": "Activo",
      "cycle": 25,
      "migrate": true,
      "sector_name": "Prados III",
      "plan": {
        "id": 83,
        "name": "RECURRENTE INSTITUCIONAL 80M",
        "cost": "0.00",
        "code": "FO-R80",
        "profile": "80M/80M"
      },
      "client_mobile": "04123471333",
      "client_email": "rgpb1234@gmail.com",
      "address": "calle principal rosario de paya  con av. principal prados 3",
      "client_identification": "V12340535",
      "nap_box_name": "237",
      "created_at": "2026-01-16T11:13:49.211000",
      "service_detail": {
        "id": 11227,
        "ip": "10.16.158.2",
        "mac": "PQN0Q8F24053",
        "serial": "ZXICCD380E5E",
        "queue": null,
        "interface": "VLAN236_PRADOS3",
        "created_at": "2026-01-19T13:59:58.159377",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8970,
      "client_name": "LEIDYS JOHANNA LUGO TORRES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Jabillar",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04120330969",
      "client_email": "LEILUGO2812@GMAIL.COM",
      "address": "CALLE ALGARROBOS CASA 04-06 URBANIZACIÓN JABILLAR SECTOR EL MACARO",
      "client_identification": "V15532061",
      "nap_box_name": "CTO-00006 C/4 JABILLAR",
      "created_at": "2026-01-19T13:55:48.746560",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8971,
      "client_name": "ADRIAN PRUEBA PRADO PRUEBA",
      "client_type_name": "PYME",
      "client_subdivision": "CANCELADO_PYME",
      "status_name": "Cancelado",
      "cycle": 10,
      "migrate": false,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 38,
        "name": "RECURRENTE PYME PLAN 800M",
        "cost": "110.40",
        "code": "FOP800M",
        "profile": "800M/800M"
      },
      "client_mobile": "04243026387",
      "client_email": "ADRIANP110702@GMAIL.COM",
      "address": "C.C PASAJE MARIÑO LOCAL PB 01-01",
      "client_identification": "V29786172",
      "nap_box_name": "CTO-00256",
      "created_at": "2026-01-20T10:54:17.056311",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8972,
      "client_name": "KELVIN DAYERSON SANCHEZ VARGAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128858460",
      "client_email": "K.SANCHEZVARGAS1@GMAIL.COM",
      "address": "CC PASEO MARIÑO PISO 1-1",
      "client_identification": "V23783510",
      "nap_box_name": "CTO-00256",
      "created_at": "2026-01-22T13:25:59.543176",
      "service_detail": {
        "id": 13196,
        "ip": "172.17.2.142",
        "mac": "70:2E:22:F3:F7:29",
        "serial": "JMKGCBDC71AD",
        "queue": null,
        "interface": "VLAN229_PANTIN",
        "created_at": "2026-10-19T14:18:45.723620",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8973,
      "client_name": "JESUS RAFAEL VASQUEZ RAMIREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Pantin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144735431",
      "client_email": "INVERSIONESDIGITALES@HOTMAIL.ES",
      "address": "PANTIN CALLE 8 CASA N 14",
      "client_identification": "V19793831",
      "nap_box_name": "CTO-00114",
      "created_at": "2026-01-23T20:38:12.442249",
      "service_detail": {
        "id": 11340,
        "ip": "172.17.59.2",
        "mac": "GPON0097B446",
        "serial": "GPON0097B446",
        "queue": null,
        "interface": "VLAN229_PANTIN",
        "created_at": "2026-01-24T09:48:28.030724",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8974,
      "client_name": "NANCY COROMOTO CAICEDO SANCHEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "El Manantial",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "0414-4904150",
      "client_email": "NANCY17247185@GMAIL.COM",
      "address": "CALLE 2DA TRANSVERSAL, CASA NÚMERO 1 SECTOR EL MANANTIAL DEL MACARO.",
      "client_identification": "V17247185",
      "nap_box_name": "75",
      "created_at": "2026-01-29T14:41:52.314442",
      "service_detail": {
        "id": 11454,
        "ip": "10.16.160.2",
        "mac": "OEMT3C6202E6",
        "serial": "OEMT3C6202E6",
        "queue": null,
        "interface": "VLAN122_SAMAN_GUERE",
        "created_at": "2026-02-03T16:16:22.856314",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8975,
      "client_name": "DANIEL GREGORIO LIENDO MONTENEGRO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Manirito",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124365592",
      "client_email": "DANIEL7992349@GMAIL.COM",
      "address": "MANIRITO PARCELA NÚMERO 2 AL FINAL DEL MURO PERIMETRAL SECTOR GUAYABITA.",
      "client_identification": "V7992349",
      "nap_box_name": "CTO - 1089",
      "created_at": "2026-01-30T09:58:24.553806",
      "service_detail": {
        "id": 13101,
        "ip": "10.16.161.2",
        "mac": "ZX:IC:CD:30:7B:7A",
        "serial": "ZXICCD307B7A",
        "queue": null,
        "interface": "VLAN285_MANIRITO",
        "created_at": "2026-10-02T08:20:55.580299",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8976,
      "client_name": "FRANCO JOSE LOPEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243738646",
      "client_email": "FRANCOLOPEZ4@GMAIL.COM",
      "address": "CALLE BERMÚDEZ ENTRE NEGRO PRIMERO Y MELLAO AL FRENTE DE RESIDENCIAS COSTA DEL SOL",
      "client_identification": "V4798700",
      "nap_box_name": "CTO - 939",
      "created_at": "2026-02-04T11:40:06.692810",
      "service_detail": {
        "id": 11672,
        "ip": "172.28.185.2",
        "mac": "HWTC3CE926A1",
        "serial": "HWTC3CE926A1",
        "queue": null,
        "interface": "VLAN209_ZAMORA_OLT1",
        "created_at": "2026-02-18T16:45:50.995095",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8977,
      "client_name": "JESUS EDUARDO CARDONA UZCANGA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Paya Abajo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128848428",
      "client_email": "CARDONAJESUS1608@GMAIL.COM",
      "address": "CALLE PRINCIPAL EL CENTRO ,CASA NÚMERO 19 SECTOR PAYA ABAJO",
      "client_identification": "V7247160",
      "nap_box_name": "272",
      "created_at": "2026-02-04T14:24:49.286535",
      "service_detail": {
        "id": 11575,
        "ip": "172.29.239.2",
        "mac": "OEMT3C62609A",
        "serial": "OEMT3C62609A",
        "queue": null,
        "interface": "VLAN231_PAYABAJO",
        "created_at": "2026-02-10T09:49:58.873030",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8978,
      "client_name": "‎YOHALY YUSLEINY AREVALO ROJAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "0424-3189208",
      "client_email": "YOHALYAREVALO@GMAIL.COM",
      "address": "CALLE 7 CASA NÚMERO 655 URBANIZACIÓN MATACABALLO",
      "client_identification": "V19277319",
      "nap_box_name": "CTO-00310",
      "created_at": "2026-02-04T18:53:06.676783",
      "service_detail": {
        "id": 11515,
        "ip": "10.16.163.2",
        "mac": "ZXICCD374734",
        "serial": "ZXICCD374734",
        "queue": null,
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2026-02-06T17:22:10.479041",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8979,
      "client_name": "MAYNELIN RODRIGUEZ PRUEBA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "El Macaro",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124440045",
      "client_email": "MAYNELIN.SANDY@GMAIL.COM",
      "address": "CALLE 3 CASA 88 SAMAN TARAZONERO 1",
      "client_identification": "V18221823",
      "nap_box_name": "32",
      "created_at": "2026-02-05T20:11:47.533263",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8980,
      "client_name": "MAYNELIN RODRIGUEZ PRUEBA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "El Macaro",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124440045",
      "client_email": "MAYNELIN.SANDY@GMAIL.COM",
      "address": "CALLE 3 CASA 5 SAMAN TARAZONERO TURMERO",
      "client_identification": "V18221823",
      "nap_box_name": "32",
      "created_at": "2026-02-06T12:18:06.045067",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8981,
      "client_name": "CESAR RUBEN SALDEÑO RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Villas El Carmen",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04127582725",
      "client_email": "CESARSALDENO5@GMAIL.COM",
      "address": "URB VILLAS DEL CARMEN, CALLE 2 CASA 14. EL MACARO.",
      "client_identification": "V33560776",
      "nap_box_name": "50",
      "created_at": "2026-02-09T10:03:57.427363",
      "service_detail": {
        "id": 11563,
        "ip": "10.16.164.2",
        "mac": "HWTC49200625",
        "serial": "HWTC49200625",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2026-02-09T16:41:23.986621",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8982,
      "client_name": "LENIN LEVI AGRAZ ZAMBRANO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "El Paraiso",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04122921562",
      "client_email": "LENINAGRAZ@GMAIL.COM",
      "address": "URB EL PARAÍSO CASA N48 EL MACARO",
      "client_identification": "V20109922",
      "nap_box_name": "344",
      "created_at": "2026-02-09T11:04:08.463443",
      "service_detail": {
        "id": 11593,
        "ip": "172.19.157.2",
        "mac": "TPLGB954FD82",
        "serial": "TPLGB954FD82",
        "queue": null,
        "interface": "VLAN101_AJS",
        "created_at": "2026-02-11T16:50:41.259294",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8983,
      "client_name": "CARLOS JESUS MARIA FAGUNDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Huerta Los Pajaros",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243713046",
      "client_email": "CARLOSJESUSFAGUNDES@GMAIL.COM",
      "address": "CARRETERA NACIONA PAYA - TURMERO, CALLE 3 CASA NÚMERO 12 HUERTA LOS PÁJAROS, ROSARIO DE PAYA",
      "client_identification": "V19207493",
      "nap_box_name": "96",
      "created_at": "2026-02-10T15:33:53.071080",
      "service_detail": {
        "id": 11583,
        "ip": "172.17.151.2",
        "mac": "VSOL00522C89",
        "serial": "VSOL00522C89",
        "queue": null,
        "interface": "VLAN221_CAFETAL_OLT1",
        "created_at": "2026-02-10T16:25:04.512321",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8984,
      "client_name": "CINDY PRUEBA RODRÍGUEZ PRUEBA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124440045",
      "client_email": "MAYNELIN.SANDY@GMAIL.COM",
      "address": "CALLE 5 NÚMERO 8 SAMAN TARAZONERO 2",
      "client_identification": "V14943320",
      "nap_box_name": "CTO-00038",
      "created_at": "2026-02-11T17:02:17.295085",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8985,
      "client_name": "MARIFE FLORES PULIDO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243197666",
      "client_email": "MFLORESP.0706@GMAIL.COM",
      "address": "CALLE 2-A CASA NÚMERO 11 URBANIZACIÓN PANTIN ROSARIO DE PAYA",
      "client_identification": "V18230680",
      "nap_box_name": "CTO-00110",
      "created_at": "2026-02-13T09:32:25.370461",
      "service_detail": {
        "id": 11607,
        "ip": "10.16.165.2",
        "mac": "ZXICCD32B3D6",
        "serial": "ZXICCD32B3D6",
        "queue": null,
        "interface": "VLAN229_PANTIN",
        "created_at": "2026-02-13T16:58:52.539127",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8986,
      "client_name": "YANIRA JOSEFINA RONDON DE GONZALEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "1ro de Mayo Norte",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04123980362",
      "client_email": "YANIRAJOSEFINAGONZALEZ@GMAIL.COM",
      "address": "1RO DE MAYO NORTE CALLE INTERCOMUNAL CASA NRO 2. ROSARIO DE PAYA",
      "client_identification": "V14384409",
      "nap_box_name": "CTO-00477",
      "created_at": "2026-02-19T17:14:30.178004",
      "service_detail": {
        "id": 12169,
        "ip": "10.16.167.2",
        "mac": "HWTCFAA22B48",
        "serial": "HWTCFAA22B48",
        "queue": null,
        "interface": "VLAN261_1ERO_MAYO_ZTE",
        "created_at": "2026-03-23T18:06:26.233759",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8987,
      "client_name": "EGLIS YENNISSY BLANCO MARTINEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Villa De San Jose",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04129675850",
      "client_email": "BLANCOEGLIS731@GMAIL.COM",
      "address": "CARRERA NACIONAL EL MACARO URBANIZACIÓN VILLAS DE SAN JOSÉ CALLE 2 PARCELAS13B LOTE 2 CASA 01-06  PUNTO DE REFERENCIA CHIVERA EL MACARO",
      "client_identification": "V20649493",
      "nap_box_name": "CTO-00080",
      "created_at": "2026-02-19T18:09:27.769711",
      "service_detail": {
        "id": 11681,
        "ip": "172.23.227.2",
        "mac": "VSOL0012A059",
        "serial": "VSOL0012A059",
        "queue": null,
        "interface": "VLAN134_VILLAS_DSJ_OLT_ZTE",
        "created_at": "2026-02-20T10:10:35.849499",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8988,
      "client_name": "MEIBER YERLEMIS SOJO DIAZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Saman Tarazonero I",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "0412-5234648",
      "client_email": "SOJOYETSALI@GMAIL.COM",
      "address": "CALLE 3 , CASA NUMERO 40 BARRIO SAMAN TARAZONERO 1 TURMERO.",
      "client_identification": "V19958962",
      "nap_box_name": "32",
      "created_at": "2026-02-19T18:17:02.907819",
      "service_detail": {
        "id": 11693,
        "ip": "10.16.166.2",
        "mac": "689FF0CCB09F",
        "serial": "QXTLCB688917",
        "queue": null,
        "interface": "VLAN140_SMT1_ZTE",
        "created_at": "2026-02-20T17:10:58.934773",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8989,
      "client_name": "LEONARDO ALEXANDER PERNIA MORALES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "La Marcelota",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243381553",
      "client_email": "ALEXANDER.02.MORALES@GMAIL.COM",
      "address": "FINAL CALLE PRINCIPAL - VEREDA EL PARQUE, CASA NRO 37 ( FRENTE A LA BOMBA DE AGUA)",
      "client_identification": "V27864654",
      "nap_box_name": "CTO - 1060",
      "created_at": "2026-02-21T11:14:38.269620",
      "service_detail": {
        "id": 11714,
        "ip": "10.16.168.2",
        "mac": "PQN0Q8F23711",
        "serial": "ZXICCD33C4CB",
        "queue": null,
        "interface": "VLAN281_MARCELOTA",
        "created_at": "2026-02-23T17:46:43.492705",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8990,
      "client_name": "ANYELI ELIZABETH DELGADO SILVA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04123099258",
      "client_email": "ANYELIYULI@GMAIL.COM",
      "address": "TURMERO SECTOR PUEBLO NUEVO CALLE EL NISPERO CASA #6",
      "client_identification": "V21203860",
      "nap_box_name": "211",
      "created_at": "2026-02-23T16:12:54.052064",
      "service_detail": {
        "id": 12392,
        "ip": "10.16.162.2",
        "mac": "ZXICCD341A08",
        "serial": "ZXICCD341A08",
        "queue": null,
        "interface": "VLAN200_OLTs",
        "created_at": "2026-04-21T17:07:27.315337",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8991,
      "client_name": "JOSE ALEJANDRO MEJIAS RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Simon Bolivar",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04224436886",
      "client_email": "MEJIASJOSEALEJANDRO227@GMAIL.COM",
      "address": "‎URBANIZACIÓN SIMÓN BOLIVAR CALLE 3 CASA NÚMERO 32 EL MACARO.",
      "client_identification": "V27820470",
      "nap_box_name": "CTO-00043",
      "created_at": "2026-02-24T13:30:38.475282",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8992,
      "client_name": "JENNIBETH MARIA ANDREINA CABRERA SOLORZANO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243524367",
      "client_email": "JENNIBETHC100@GMAIL.COM",
      "address": "EDIFICIO: CC RANDAZZO, PISO: PB , LOCAL: 8",
      "client_identification": "V28249323",
      "nap_box_name": "CTO-0650",
      "created_at": "2026-02-24T16:50:12.613244",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8993,
      "client_name": "‎RONVELYS DEL CARMEN ACOSTA PEÑA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "La Esperanza",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "‎04243349302",
      "client_email": "RONVELYS19412@GMAIL.COM",
      "address": "‎CALLE 13 CASA NÚMERO 3 SECTOR LA ESPERANZA EL MACARO",
      "client_identification": "V16851941",
      "nap_box_name": "RESERVA 3 TRONCAL LA ESPERANZA",
      "created_at": "2026-02-25T08:41:41.114401",
      "service_detail": {
        "id": 11857,
        "ip": "10.16.172.2",
        "mac": "HWTC4E3A12AD",
        "serial": "HWTC4E3A12AD",
        "queue": null,
        "interface": "VLAN137_LA_ESPERANZA_OLT_ZTE",
        "created_at": "2026-02-27T15:11:02.804824",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8994,
      "client_name": "‎ALINXON MAGDIEL OROPEZA INFANTE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04243197776",
      "client_email": "FRAUDEYESTAFAMARINO@GMAIL.COM",
      "address": "‎CALLÉ PETION, EDIF. CICPC TURMERO, CASCO DE TURMERO, FRENTE AL CONCEJO MUNICIPAL",
      "client_identification": "V25920999",
      "nap_box_name": "CTO-00194 DOS",
      "created_at": "2026-02-25T09:48:54.199138",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8995,
      "client_name": "MARCOS ALFONSO CARRION SANDIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Los Nisperos",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "0412-8153782",
      "client_email": "MARCOSCARRION15HKLOP@GMAIL.COM",
      "address": "CONJUNTO RESIDENCIAL \"LOS NÍSPEROS\", TORRE B, PISO 2, APARTAMENTO 21",
      "client_identification": "V33269237",
      "nap_box_name": "TORRE B EDIF LOS NISPEROS",
      "created_at": "2026-02-25T15:15:48.579475",
      "service_detail": {
        "id": 12030,
        "ip": "10.16.174.2",
        "mac": "08D4A5A42600",
        "serial": "HWTC49200608",
        "queue": null,
        "interface": "VLAN208_NISPERO_OLT1",
        "created_at": "2026-03-11T15:03:58.119039",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8996,
      "client_name": "INVERSIONES IF 1208 CA",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "La Concepcion",
      "plan": {
        "id": 102,
        "name": "RECURRENTE PYME PLAN 150M",
        "cost": "27.60",
        "code": "FOP150M",
        "profile": "150Mbps/150Mbps"
      },
      "client_mobile": "04122588118",
      "client_email": "INVLACONCEPCION1208@GMAIL.COM",
      "address": "CALLE EL CANAL C/C 02 CASA (PARCELA) NÚMERO 1-1 , SECTOR ASENTAMIENTO CAMPESINO LA CONCEPCIÓN TURMERO",
      "client_identification": "J507033775",
      "nap_box_name": "503",
      "created_at": "2026-02-25T16:24:15.406745",
      "service_detail": {
        "id": 12417,
        "ip": "10.16.173.2",
        "mac": "OEMT3C620FF6",
        "serial": "OEMT3C620FF6",
        "queue": null,
        "interface": "VLAN111_CONCEPCION",
        "created_at": "2026-04-26T14:55:17.344376",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8997,
      "client_name": "CERLIDER JT CA",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Callejon Rosales",
      "plan": {
        "id": 103,
        "name": "RECURRENTE PYME PLAN 400M",
        "cost": "51.74",
        "code": "FOP400M",
        "profile": "400Mbps/400Mbps"
      },
      "client_mobile": "04243543913",
      "client_email": "CERLIDERJT@GMAIL.COM",
      "address": "CALLE ROSALES PARCELA 6-4 LOCAL NRO 8 SECTOR VALLE DE PAYA ROSARIO DE PAYA",
      "client_identification": "J400636272",
      "nap_box_name": "319",
      "created_at": "2026-02-26T09:40:12.843647",
      "service_detail": {
        "id": 11783,
        "ip": "10.16.175.2",
        "mac": "QXTLCB938D58",
        "serial": "QXTLCB938D58",
        "queue": null,
        "interface": "VLAN206_ROSALES_OLT2",
        "created_at": "2026-02-27T11:03:47.476055",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 8998,
      "client_name": "GREICY NAILETH CASTRO BERROTERAN",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Prados I",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04128803252",
      "client_email": "GREICYC999@GMAIL.COM",
      "address": "CALLE 6 CASA 2 DE PRADOS 1. ROSARIO DE PAYA.",
      "client_identification": "V18693630",
      "nap_box_name": "585 DOS",
      "created_at": "2026-02-28T08:00:47.646178",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 8999,
      "client_name": "NORIANNI ANDREINA SANCHEZ SILVA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Guerrero de Chavez",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04228150794",
      "client_email": "NORIANNISANCHEZ5@GMAIL.COM",
      "address": "GUERRERO DE CHÁVEZ CALLE 3 NÚMERO DE RANCHO # 82",
      "client_identification": "V28496061",
      "nap_box_name": "406",
      "created_at": "2026-03-03T09:05:33.718085",
      "service_detail": {
        "id": 11966,
        "ip": "10.16.206.2",
        "mac": "2012231218001848",
        "serial": "OEMT3C620CC6",
        "queue": null,
        "interface": "VLAN271_DIOS_ES_MI_REFUGIO_OLT1",
        "created_at": "2026-03-05T10:54:33.906121",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9000,
      "client_name": "WILYENI CAROLINA GUEVARA PALMA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Manirito",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121402510",
      "client_email": "WILYENIGUEVARA@GMAIL.COM",
      "address": "GUAYABITA. SECTOR MANIRITO #32",
      "client_identification": "V29786557",
      "nap_box_name": "CTO-00411",
      "created_at": "2026-03-03T10:54:17.563013",
      "service_detail": {
        "id": 11972,
        "ip": "10.16.205.2",
        "mac": "OEMT3C620866",
        "serial": "OEMT3C620866",
        "queue": null,
        "interface": "VLAN286_LA_GUZMAN",
        "created_at": "2026-03-05T17:01:36.070271",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9001,
      "client_name": "ARGENIS RAFAEL CASTILLO FLORES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Simon Bolivar",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04123801706",
      "client_email": "ARGENISRAFAEL004@GMAIL.COM",
      "address": "‎URB SIMÓN BOLÍVAR CALLE 6 CASA NUMERO 41",
      "client_identification": "V20056487",
      "nap_box_name": "CTO-00023",
      "created_at": "2026-03-03T11:00:10.683608",
      "service_detail": {
        "id": 12295,
        "ip": "10.16.204.2",
        "mac": "OEMT3C620C12",
        "serial": "OEMT3C620C12",
        "queue": null,
        "interface": "VLAN128_SIMON_BOLIVAR_ZTE",
        "created_at": "2026-04-11T11:09:51.293327",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9002,
      "client_name": "EMILY JOSMAR CASTRO ROJAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04129876954",
      "client_email": "ZULEIMYCASTRO702@GMAIL.COM",
      "address": "CALLE CARREÑO NORTE, URBANISMO HACIENDA LOS NÍSPEROS (EZEQUIEL ZAMORA) TORRE #2 URQUIA,  PISO 3, APARTAMENTO 6 TURMERO",
      "client_identification": "V13200108",
      "nap_box_name": "CTO-00032",
      "created_at": "2026-03-03T11:22:01.826762",
      "service_detail": {
        "id": 11970,
        "ip": "10.16.203.2",
        "mac": "2012231218001659",
        "serial": "OEMT3C6209D2",
        "queue": null,
        "interface": "VLAN209_ZAMORA_OLT1",
        "created_at": "2026-03-05T16:11:20.096811",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9003,
      "client_name": "JOSE GREGORIO ROJAS SANCHEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04143436436",
      "client_email": "JLADERA190@GMAIL.COM",
      "address": "TURMERO, CALLE MARIÑO CON RICAUTE, EDIFICIO TORRE PACASO PISO 11-A",
      "client_identification": "V18262318",
      "nap_box_name": "69",
      "created_at": "2026-03-06T09:13:20.839272",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 9004,
      "client_name": "MARIA VICTORIA PEDRA TRUJILLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Guerrero de Chavez",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04127769585",
      "client_email": "ASISMARI19951111@GMAIL.COM",
      "address": "SECTOR PAYA ABAJO , GUERREROS DE CHÁVEZ CALLE 3 PARCELA #81",
      "client_identification": "V25066275",
      "nap_box_name": "406",
      "created_at": "2026-03-09T09:41:08.199621",
      "service_detail": {
        "id": 12021,
        "ip": "10.16.207.2",
        "mac": "2012231218002075",
        "serial": "OEMT3C621052",
        "queue": null,
        "interface": "VLAN271_DIOS_ES_MI_REFUGIO_OLT1",
        "created_at": "2026-03-09T17:35:20.463374",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9005,
      "client_name": "‎YONNATAN AGUSTIN CRIOLLO BRICEÑO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Residencias Mariño",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04127993589",
      "client_email": "CRIOLLOMASTER@GMAIL.COM",
      "address": "CALLE MARIÑO EDIFICIO TORRE C PISO 2 APTO C-21URB RESIDENCIAS MARIÑO",
      "client_identification": "V14627867",
      "nap_box_name": "CTO-0520",
      "created_at": "2026-03-10T10:34:49.871305",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 9006,
      "client_name": "KAREN YOLIMAR PAEZ MAGALLANES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Prados III",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04126721983",
      "client_email": "KPAEZMAGALLANES@GMAIL.COM",
      "address": "PRADOS 3 CALLE 1 CASA 31",
      "client_identification": "V18702604",
      "nap_box_name": "CTO-00021",
      "created_at": "2026-03-10T15:19:53.992636",
      "service_detail": {
        "id": 12045,
        "ip": "10.16.210.2",
        "mac": "2012231218006448",
        "serial": "OEMT3C6254A6",
        "queue": null,
        "interface": "VLAN229_PANTIN",
        "created_at": "2026-03-12T17:27:08.663830",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9007,
      "client_name": "YORGLEIDER MARQUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Valle Paraiso",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243101822",
      "client_email": "Yorgleiderm@gmail.com",
      "address": "‎URBANIZACIÓN VALLE PARAISO, LOTE 5, CASA 5, TURMERO, MUNICIPIO MARIÑO, ESTADO",
      "client_identification": "V15926496",
      "nap_box_name": "CTO-00598",
      "created_at": "2026-03-11T16:41:25.980680",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 9012,
      "client_name": "ANA SUHAIL SAAVEDRA ESPINOZA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Prados II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04129904696",
      "client_email": "SAAVE3112@GMAIL.COM",
      "address": "PRADOS DE PAYA 2 CALLE 1 NÚMERO 95",
      "client_identification": "V14959063",
      "nap_box_name": "584 DOS",
      "created_at": "2026-03-12T16:26:47.042598",
      "service_detail": {
        "id": 12316,
        "ip": "172.26.85.2",
        "mac": "HWTC9019749B",
        "serial": "HWTC9019749B",
        "queue": null,
        "interface": "VLAN242_PRADOS2",
        "created_at": "2026-04-16T10:20:20.721028",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9017,
      "client_name": "VIRGINIA DUGAIS CASTRO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Taguapire",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04120333547",
      "client_email": "DUGAYSCASTRO123@GMAIL.COM",
      "address": "URBANIZACIÓN TAIGUAPIRE CALLE #3 CASA NÚMERO 63",
      "client_identification": "V9438731",
      "nap_box_name": "CTO-00709",
      "created_at": "2026-03-13T09:09:28.718799",
      "service_detail": {
        "id": 12113,
        "ip": "10.16.212.2",
        "mac": "702E220725B1",
        "serial": "RTEGC607AA68",
        "queue": null,
        "interface": "VLAN129_TAGUAPIRE_ZTE",
        "created_at": "2026-03-17T17:47:36.996960",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9018,
      "client_name": "Freddy Carrillo",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 2,
        "name": "RECURRENTE RESIDENCIAL PLAN 30M",
        "cost": "20.00",
        "code": "FOR30",
        "profile": "30M/30M"
      },
      "client_mobile": "04129950904",
      "client_email": "freddycarrillo1912@gmail.com",
      "address": "CALLE 5 NÚMERO 8 SAMAN TARAZONERO 2",
      "client_identification": "V28458411",
      "nap_box_name": "CTO-00038",
      "created_at": "2026-03-13T10:40:02.353081",
      "service_detail": {
        "id": 13200,
        "ip": "172.00.0.000",
        "mac": "",
        "serial": "AAAAAAAAAA",
        "queue": null,
        "interface": "INTERFACE_FAKE",
        "created_at": "2026-10-19T19:05:52.621353",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9034,
      "client_name": "Freddy Carrillo",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 97,
        "name": "RECURRENTE RESIDENCIAL PLAN 10M",
        "cost": "18.00",
        "code": "[FOR10]",
        "profile": "10Mbps/10Mbps"
      },
      "client_mobile": "04129950904",
      "client_email": "freddycarrillo1912@gmail.com",
      "address": "CALLE 5 NÚMERO 8 SAMAN TARAZONERO 2",
      "client_identification": "V28458411",
      "nap_box_name": "CTO-00038",
      "created_at": "2026-03-13T11:59:11.687326",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 9035,
      "client_name": "YELITZA DEL CARMEN HERNANDEZ LEAL",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Guerrero de Chavez",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04123352674",
      "client_email": "YELIHNDZ2025@GMAIL.COM",
      "address": "ROSARIO DE PAYA, SECTOR GUERREROS DE CHÁVEZ, CALLE 2, RANCHO 58.",
      "client_identification": "V13473631",
      "nap_box_name": "CTO-00587",
      "created_at": "2026-03-15T22:35:03.537015",
      "service_detail": {
        "id": 12106,
        "ip": "10.16.211.2",
        "mac": "HWTC005B9CC1",
        "serial": "HWTC005B9CC1",
        "queue": null,
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2026-03-17T13:41:23.396131",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9036,
      "client_name": "NEYDALYD DEL CARMEN MONTENEGRO ARANGUREN",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Simon Bolivar",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04148428118",
      "client_email": "MONTENEGRONEYDALYD@GMAIL.COM",
      "address": "TURMERO SECTOR EL MACARO URBANIZACIÓN SIMÓN BOLÍVAR CALLE 5 CASA N°41",
      "client_identification": "V20547234",
      "nap_box_name": "CTO-00001",
      "created_at": "2026-03-17T16:05:30.700599",
      "service_detail": {
        "id": 12246,
        "ip": "172.21.237.2",
        "mac": "TPLGB68B506A",
        "serial": "TPLGB68B506A",
        "queue": null,
        "interface": "VLAN128_SIMON_BOLIVAR_ZTE",
        "created_at": "2026-04-03T19:51:24.421420",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9037,
      "client_name": "ALEXANDRA RAMONA GIL CASTILLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Urbanización Santiago Mariño",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04125387018",
      "client_email": "ALEXAGIL1685@GMAIL.COM",
      "address": "URBANIZACIÓN SANTIAGO MARIÑO C. PEÑALVER ,TURMERO CALLE PRINCIPAL MANZANA CASA #15",
      "client_identification": "V16765029",
      "nap_box_name": "632",
      "created_at": "2026-03-18T14:24:37.266251",
      "service_detail": {
        "id": 12132,
        "ip": "172.21.207.2",
        "mac": "TPLGB68B5301",
        "serial": "TPLGB68B5301",
        "queue": null,
        "interface": "VLAN118_PALMERAS_1",
        "created_at": "2026-03-18T17:34:15.187965",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9038,
      "client_name": "ZORGEILYS MICHELLE COUSIN FRANCESCHI",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "La Casona II Edificios",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243281825",
      "client_email": "COUSINZORGEILYS@GMAIL.COM",
      "address": "URBANISMO LA CASONA 2, EDIFICIO 12, PLANTA BAJA APTO 5",
      "client_identification": "V27036892",
      "nap_box_name": "CE - 279",
      "created_at": "2026-03-23T15:59:48.127820",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 9039,
      "client_name": "YESSICA ANDREINA GONZALEZ ACOSTA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "‎0424-3150267",
      "client_email": "GONZALEZYESSICA0812@GMAIL.COM",
      "address": "‎URB MATACABALLO, CALLE 4,CASA 238A. ROSARIO DE PAYA.",
      "client_identification": "V19790910",
      "nap_box_name": "CTO-00265",
      "created_at": "2026-03-25T17:34:52.315218",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 9040,
      "client_name": "KELVIN DAYERSON SANCHEZ VARGAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Vista Hermosa",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128858460",
      "client_email": "K.SANCHEZVARGAS1@GMAIL.COM",
      "address": "VISTA HERMOSA, CALLE LAS MANDARINAS CASA NÚMERO 59",
      "client_identification": "V23783510",
      "nap_box_name": "CTO-00060 DOS",
      "created_at": "2026-03-26T10:36:42.444389",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 9041,
      "client_name": "CARLOS JAVIER OVALLES PIÑANGO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Vista Hermosa",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04122900379",
      "client_email": "CARLOSJOP9@GMAIL.COM",
      "address": "CALLE LAS MANDARINAS CASA NRO 50 SECTOR VISTA HERMOSA ROSARIO DE PAYA",
      "client_identification": "V32046620",
      "nap_box_name": "CTO-00057 DOS",
      "created_at": "2026-03-26T10:38:09.309764",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 9042,
      "client_name": "YERAL EDUARDO JOSE GOMEZ RANGEL",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Vista Hermosa",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243130056",
      "client_email": "YEJGR25@GMAIL.COM",
      "address": "CALLE LAS MANDARINAS CASA NRO 58 SECTOR VISTA HERMOSA ROSARIO DE PAYA",
      "client_identification": "V25708428",
      "nap_box_name": "CTO-00059",
      "created_at": "2026-03-26T10:44:13.838552",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 9043,
      "client_name": "RUFO JEAN PAUL MORALES TERAN",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Vista Hermosa",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04125989734",
      "client_email": "RUFOMORALESA@IRTLOK.ES",
      "address": "PAYA VISTA HERMOSA CALLE LAS MANDARINAS CASA N#27",
      "client_identification": "V21270403",
      "nap_box_name": "CTO-00059",
      "created_at": "2026-03-26T10:44:50.099597",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 9044,
      "client_name": "ARNALDO RAFAEL ROJAS GOMEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Vista Hermosa",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04140398689",
      "client_email": "ARNALDO1ROJAS@GMAIL.COM",
      "address": "CALLE LAS MANDARINAS NRO 38 SECTOR VISTA HERMOSA ROSARIO DE PAYA",
      "client_identification": "V25922903",
      "nap_box_name": "CTO-00058",
      "created_at": "2026-03-26T10:49:07.209718",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 9045,
      "client_name": "INVERSIONES WAWI 2025 CA",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 25,
      "migrate": true,
      "sector_name": "Paya Abajo",
      "plan": {
        "id": 102,
        "name": "RECURRENTE PYME PLAN 150M",
        "cost": "27.60",
        "code": "FOP150M",
        "profile": "150Mbps/150Mbps"
      },
      "client_mobile": "0424-3467219",
      "client_email": "MILLEREZEQUIELRUIZ@GMAIL.COM",
      "address": "AV PRINCIPAL PARCELA NÚMERO 2 SECTOR PAYA ABAJO ROSARIO DE PAYA",
      "client_identification": "J506765144",
      "nap_box_name": "CE - 773",
      "created_at": "2026-03-27T08:35:06.343063",
      "service_detail": {
        "id": 12195,
        "ip": "10.16.180.2",
        "mac": "HWTC0E25CAA1",
        "serial": "HWTC0E25CAA1",
        "queue": null,
        "interface": "VLAN229_PANTIN",
        "created_at": "2026-03-27T13:44:22.129497",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9046,
      "client_name": "‎ELIZMAR GABRIELA MENDEZ GONZALEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121480821",
      "client_email": "MENDEZELIZMAR@GMAIL.COM",
      "address": "‎CALLE MIRANDA C.C NONNO LORENZO PLATA BAJA  AL LADO DE FARMASTORE",
      "client_identification": "V27687851",
      "nap_box_name": "CTO-00037",
      "created_at": "2026-04-06T13:57:03.880428",
      "service_detail": {
        "id": 12480,
        "ip": "10.16.181.2",
        "mac": "VS:OL:00:11:F7:F9",
        "serial": "VSOL0011F7F9",
        "queue": null,
        "interface": "VLAN200_OLTs",
        "created_at": "2026-05-09T09:26:36.837427",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9047,
      "client_name": "KAREN MERCEDES VILLANUEVA VALOR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "San Sebastian",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04149171087",
      "client_email": "KARENVILLANUEVA211@GMAIL.COM",
      "address": "EL MACARO SECTOR SAN SEBASTIÁN CALLE #4 CASA#10 TURMERO",
      "client_identification": "V17121766",
      "nap_box_name": "61",
      "created_at": "2026-04-07T08:45:54.339508",
      "service_detail": {
        "id": 12285,
        "ip": "10.16.182.2",
        "mac": "HWTC49200738",
        "serial": "HWTC49200738",
        "queue": null,
        "interface": "VLAN125_SAN_SEBASTIAN_ZTE",
        "created_at": "2026-04-10T11:05:29.892601",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9048,
      "client_name": "JOSE DE LA TRINIDAD SEGOVIA MAYORCA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Valle Fresco",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144655064",
      "client_email": "JDLTSM@GMAIL.COM",
      "address": "URB VALLE FRESCO, MANZANA 13 CASA 12 CALLE 10",
      "client_identification": "V12139537",
      "nap_box_name": "CTO - 981",
      "created_at": "2026-04-07T17:00:53.138682",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 9049,
      "client_name": "ELSI DISNOIDA OJEDA JIMENEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "La Casona II Edificios",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243691524",
      "client_email": "ELSIOJEDA66@GMAIL.COM",
      "address": "LA CASONA 2 EDIFICIO LA PRIMAVERA TORRE 10 PISO 3 APARTAMENTO 6",
      "client_identification": "V6603435",
      "nap_box_name": "CTO-00145",
      "created_at": "2026-04-08T18:03:00.372409",
      "service_detail": {
        "id": 12268,
        "ip": "10.17.20.2",
        "mac": "OEMT3C6200F2",
        "serial": "OEMT3C6200F2",
        "queue": null,
        "interface": "VLAN110_CASONA_2",
        "created_at": "2026-04-09T08:49:55.588331",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9050,
      "client_name": "ANABELLYS SANCHEZ HERNANDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Paraguatan",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243649815",
      "client_email": "ANABELLYSSANCHEZ43@GMAIL.COM",
      "address": "SECTOR PARAGUATÁN CALLE ESCALONA NRO 8",
      "client_identification": "V12612642",
      "nap_box_name": "CTO-00397",
      "created_at": "2026-04-09T11:08:48.469422",
      "service_detail": {
        "id": 12287,
        "ip": "10.16.183.2",
        "mac": "HWTC8FA92361",
        "serial": "HWTC8FA92361",
        "queue": null,
        "interface": "VLAN283_PARAGUATAN",
        "created_at": "2026-04-10T12:43:48.434804",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9051,
      "client_name": "ANDREINA DEL VALLE GOMEZ GUEVARA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "0424-3266100",
      "client_email": "ANDREINADVGG1997@GMAIL.COM",
      "address": "PRADOS 2 CALLE 2 CASA NÚMERO 18 SECTOR ROSARIO DE PAYA PARROQUIA PEDRO ARÉVALO APONTE",
      "client_identification": "V26320654",
      "nap_box_name": "CTO-00205",
      "created_at": "2026-04-09T13:52:36.276649",
      "service_detail": {
        "id": 12289,
        "ip": "10.16.184.2",
        "mac": "QXTLCBB7ED7A",
        "serial": "QXTLCBB7ED7A",
        "queue": null,
        "interface": "VLAN242_PRADOS2",
        "created_at": "2026-04-10T15:29:47.989868",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9052,
      "client_name": "ELITE IMPORTS TURMERO",
      "client_type_name": "PYME",
      "client_subdivision": "CANCELADO_PYME",
      "status_name": "Cancelado",
      "cycle": 25,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 102,
        "name": "RECURRENTE PYME PLAN 150M",
        "cost": "27.60",
        "code": "FOP150M",
        "profile": "150Mbps/150Mbps"
      },
      "client_mobile": "04128904122",
      "client_email": "elite.imports20@gmail.com",
      "address": "CALLE RICAURTE ENTRE BOLIVAR Y SUCRE LOCAL INMUEBLE 30 NUMERO 3 SECTOR TURMERO",
      "client_identification": "J500339232",
      "nap_box_name": "CAJA NAP EDIFICIO ABUUT",
      "created_at": "2026-04-09T15:21:20.066912",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 9053,
      "client_name": "DERWING JOSE ACEVEDO LAREZ",
      "client_type_name": "EMPLEADO",
      "client_subdivision": "ACTIVO_EMPLEADO",
      "status_name": "Activo",
      "cycle": 25,
      "migrate": false,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 78,
        "name": "Plan empleado 80MB",
        "cost": "0.00",
        "code": "FO-80M",
        "profile": "80M/80M"
      },
      "client_mobile": "4121494173",
      "client_email": "DERWING.D.L@GMAIL.COM",
      "address": "CALLE MANZANA H-4 CASA NRO 12 URB SAMAN TARAZONERO II TURMERO",
      "client_identification": "V27434622",
      "nap_box_name": null,
      "created_at": "2026-04-09T15:21:20.066000",
      "service_detail": {
        "id": 12343,
        "ip": "172.23.79.2",
        "mac": "VSOL0013E851",
        "serial": "VSOL0013E851",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2026-04-17T15:45:34.732440",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9054,
      "client_name": "MIGUEL JOSE MIREYES SANCHEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "SUSPENDIDO_RESIDENCIAL",
      "status_name": "Suspendido",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Palmeras I",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04120180485",
      "client_email": "MJMIREYESS@GMAIL.COM",
      "address": "SECTOR URBANIZACION LAS PALMERAS 1 CALLE PRINCIPAL CASA NUMERO 45 TURMERO LA JULIA",
      "client_identification": "V29711294",
      "nap_box_name": "CTO-00221",
      "created_at": "2026-04-13T18:09:51.726757",
      "service_detail": {
        "id": 12308,
        "ip": "10.16.185.2",
        "mac": "TPLG2ABDC772",
        "serial": "TPLG2ABDC772",
        "queue": null,
        "interface": "VLAN118_PALMERAS_1",
        "created_at": "2026-04-14T11:16:21.205977",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9055,
      "client_name": "DOMINIC GREGOR CORTEZ CARAPAICA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "‎04243484599",
      "client_email": "DORIAMNIC02122010@GMAIL.COM",
      "address": "COMANDO DE PROTECCION CIVIL MARIÑO CALLE BERMIUDEZ NUMERO 84 AL LADO DEL CDI LA ADUANA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V17513261",
      "nap_box_name": "282",
      "created_at": "2026-04-15T13:44:51.019239",
      "service_detail": {
        "id": 12950,
        "ip": "10.16.186.2",
        "mac": "OE:MT:3C:62:45:CE",
        "serial": "OEMT3C6245CE",
        "queue": null,
        "interface": "VLAN200_OLTs",
        "created_at": "2026-09-01T14:48:03.116879",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9056,
      "client_name": "CAROLINA COROMOTO RATTIA DE RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Prados I",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128728325",
      "client_email": "CAROLINAMADRID046@GMAIL.COM",
      "address": "PRADOS DE PAYA 1 CALLE PRINCIPAL NÚMERO 43",
      "client_identification": "V12928987",
      "nap_box_name": "CTO-00304 DOS",
      "created_at": "2026-04-16T08:57:12.150537",
      "service_detail": {
        "id": 12518,
        "ip": "10.16.187.2",
        "mac": "a8:bf:3c:62:24:53",
        "serial": "OEMT3C622452",
        "queue": null,
        "interface": "VLAN239_PRADOS1",
        "created_at": "2026-05-16T19:13:46.369673",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9057,
      "client_name": "‎BRIGGITTE YISNET MARTINEZ JIMENEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Villa Caribe",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04243098018",
      "client_email": "BRIGGITTEYM@GMAIL.COM",
      "address": "CONJUNTO RESIDENCIAL VILLA CARIBE LOTE SECTOR 2 CASA N20",
      "client_identification": "V18552466",
      "nap_box_name": "57",
      "created_at": "2026-04-17T13:54:27.845155",
      "service_detail": {
        "id": 12344,
        "ip": "10.16.214.2",
        "mac": "ZICGCB6172F1",
        "serial": "ZICGCB6172F1",
        "queue": null,
        "interface": "VLAN228_V_CARIBE_OLT1",
        "created_at": "2026-04-17T17:21:28.978496",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9058,
      "client_name": "FRANCISCO JESUS AVILA ASCANIO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121490713",
      "client_email": "FRANCISCOAVILA201780@GMAIL.COM",
      "address": "MATA CABALLO CALLE 10 CASA NRO 626 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V15301516",
      "nap_box_name": "CTO-00167 DOS",
      "created_at": "2026-04-19T18:28:55.178246",
      "service_detail": {
        "id": 12365,
        "ip": "172.30.194.2",
        "mac": "OEMT3C622B92",
        "serial": "OEMT3C622B92",
        "queue": null,
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2026-04-19T18:45:16.875739",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9059,
      "client_name": "ROSIMAR ADRIANA RUI DE FARIÑAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Residencias Mariño",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243520169",
      "client_email": "ADRIANAGABY2007@GMAIL.COM",
      "address": "CALLE MARIÑO RESIDENCIAS MARIÑO APTO 32 TORRE A TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V15076217",
      "nap_box_name": "CTO-0518",
      "created_at": "2026-04-20T09:07:34.086352",
      "service_detail": {
        "id": 12366,
        "ip": "10.14.1.2",
        "mac": "OEMT3C6210BE",
        "serial": "OEMT3C6210BE",
        "queue": null,
        "interface": "VLAN234_R_MARINO_OLT2",
        "created_at": "2026-04-20T09:09:42.358544",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9060,
      "client_name": "‎MICHELL YUSIJEIDY SUARES MAITIN",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Saman Tarazonero I",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04125978061",
      "client_email": "MICHELLMAITIN13@GMAIL.COM",
      "address": "CALLE 3 CASA NÚMERO 20 BARRIO SAMAN TARAZONERO I",
      "client_identification": "V30381695",
      "nap_box_name": "32",
      "created_at": "2026-04-20T18:22:12.939619",
      "service_detail": {
        "id": 12651,
        "ip": "10.16.188.2",
        "mac": "80:d4:a5:a4:3e:a1",
        "serial": "HWTC49201002",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2026-07-01T20:33:48.904573",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9061,
      "client_name": "CESAR ADOLFO SILVA TOVAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "La Casona I Edificios",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04127873582",
      "client_email": "cesaradolfosilvatovar@gmail.com",
      "address": "AV INTERCOMUNAL MARACAY TURMERO EDIFICIO G PISO 2 APARTAMENTO 3 CONJUNTO RESIDENCIAL LOS JARDINES",
      "client_identification": "V8829476",
      "nap_box_name": "CTO-0533",
      "created_at": "2026-04-22T12:33:46.650687",
      "service_detail": {
        "id": 12400,
        "ip": "10.16.189.2",
        "mac": "ZXICCDF0D864",
        "serial": "ZXICCDF0D864",
        "queue": null,
        "interface": "VLAN109_CASONA_1",
        "created_at": "2026-04-23T13:01:00.048419",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9062,
      "client_name": "WILFREDO JOSE BETHELMI GRATEROL",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128649619",
      "client_email": "WJBETHELMI@GMAIL.COM",
      "address": "CALLE BERMUDEZ NUMERO 92 SECTOR LA ADUANA MUNICIPIO SANTIAGO MARIÑO TERNERO ESTADO ARAGUA",
      "client_identification": "V28430772",
      "nap_box_name": "282",
      "created_at": "2026-04-22T12:39:07.321006",
      "service_detail": {
        "id": 12398,
        "ip": "172.26.94.2",
        "mac": "HWTCC126B79C",
        "serial": "HWTCC126B79C",
        "queue": null,
        "interface": "VLAN200_OLTs",
        "created_at": "2026-04-23T08:31:30.113470",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9063,
      "client_name": "ARTURO JOSE VELASQUEZ FONSECA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144918143",
      "client_email": "VEARTURO14@GMAIL.COM",
      "address": "CALLE MIRANDA NUMERO 60 AL FRENTE DE TDK TURMERO ARAGUA",
      "client_identification": "V14637675",
      "nap_box_name": "CTO-00038",
      "created_at": "2026-04-24T08:57:13.046484",
      "service_detail": {
        "id": 12407,
        "ip": "10.16.190.2",
        "mac": "4CABFC13C834",
        "serial": "JMKGCB7BF5DC",
        "queue": null,
        "interface": "VLAN200_OLTs",
        "created_at": "2026-04-24T15:17:43.753368",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9064,
      "client_name": "KEYMAR STEFANY LOPEZ CALDERON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "San Pablo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04140476979",
      "client_email": "KEYMARLOPEZ9@GMAIL.COM",
      "address": "‎AV 5TA CASA PARCELA NRO 3 URB SAN PABLO RESIDENCAS\n‎CAMELOT 3RA ETAPA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V20449913",
      "nap_box_name": "635",
      "created_at": "2026-04-24T12:59:04.585839",
      "service_detail": {
        "id": 12426,
        "ip": "10.16.191.2",
        "mac": "JMKGCF4E7A6E",
        "serial": "JMKGCF4E7A6E",
        "queue": null,
        "interface": "VLAN224_SAN_PABLO_OLT1",
        "created_at": "2026-04-28T14:32:21.347927",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9065,
      "client_name": "CASA DE LOS ABUELOS",
      "client_type_name": "INTERCAMBIO",
      "client_subdivision": "ACTIVO_INTERCAMBIO",
      "status_name": "Activo",
      "cycle": 25,
      "migrate": false,
      "sector_name": "Saman de Guere",
      "plan": {
        "id": 83,
        "name": "RECURRENTE INSTITUCIONAL 80M",
        "cost": "0.00",
        "code": "FO-R80",
        "profile": "80M/80M"
      },
      "client_mobile": "04142178878",
      "client_email": "yelitzaldana@gmail.com",
      "address": "Saman de Guere Calle el Carmen",
      "client_identification": "V15819582",
      "nap_box_name": "11",
      "created_at": "2026-04-27T12:59:04.549000",
      "service_detail": {
        "id": 12418,
        "ip": "10.16.215.2",
        "mac": "2012231218001146",
        "serial": "OEMT3C6201CE",
        "queue": null,
        "interface": "VLAN122_SAMAN_GUERE",
        "created_at": "2026-04-27T12:59:04.549000",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9066,
      "client_name": "EDNYN MILEYDIS LUGO DE CELIS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Valle Fresco",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144773140",
      "client_email": "EDNYNLUGO@GMAIL.COM",
      "address": "URBANIZACIÓN VALLE FRESCO, TURMERO",
      "client_identification": "V6454846",
      "nap_box_name": "Valle fresco",
      "created_at": "2026-04-27T18:41:03.044516",
      "service_detail": {
        "id": 12438,
        "ip": "10.16.192.2",
        "mac": "OEMT3C6260CA",
        "serial": "OEMT3C6260CA",
        "queue": null,
        "interface": "VLAN270_VALLE_FRESCO_OLT3",
        "created_at": "2026-04-30T14:12:47.417242",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9067,
      "client_name": "OFICINA SISPROT TURMERO",
      "client_type_name": "GRATIS",
      "client_subdivision": "ACTIVO_GRATIS",
      "status_name": "Activo",
      "cycle": 25,
      "migrate": false,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 86,
        "name": "PLAN RECURRENTE 80M GRATIS",
        "cost": "0.00",
        "code": "FO-G80",
        "profile": "80M/80M"
      },
      "client_mobile": "04140390506",
      "client_email": "elireyesve@gmail.com",
      "address": "CALLE MARIÑO C.C PASEO MARIÑO NIVEL PB-09 LOCAL PB-09 CENTRO TURMERO, Turmero 2115",
      "client_identification": "V0000001",
      "nap_box_name": "38",
      "created_at": "2026-04-28T10:03:52.436856",
      "service_detail": {
        "id": 12859,
        "ip": "10.15.90.2",
        "mac": "QX:TL:CB:00:50:FE",
        "serial": "QXTLCB0050FE",
        "queue": null,
        "interface": "VLAN200_OLTs",
        "created_at": "2026-08-17T14:05:08.225519",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9069,
      "client_name": "OFICINA SISPROT TURMERO",
      "client_type_name": "GRATIS",
      "client_subdivision": "ACTIVO_GRATIS",
      "status_name": "Activo",
      "cycle": 25,
      "migrate": false,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 86,
        "name": "PLAN RECURRENTE 80M GRATIS",
        "cost": "0.00",
        "code": "FO-G80",
        "profile": "80M/80M"
      },
      "client_mobile": "04140390506",
      "client_email": "elireyesve@gmail.com",
      "address": "CALLE MARINO C.C PASEO MARINO NIVEL PB-09 LOCAL PB-09 CENTRO TURMERO, Turmero 2115",
      "client_identification": "V0000001",
      "nap_box_name": "38",
      "created_at": "2026-04-29T15:40:06.341903",
      "service_detail": {
        "id": 12436,
        "ip": "10.10.155.2",
        "mac": "QXTLC8EB156C",
        "serial": "QXTLC8EB156C",
        "queue": null,
        "interface": "VLAN200_OLTs",
        "created_at": "2026-04-30T10:11:40.324664",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9070,
      "client_name": "OFICINA SISPROT TURMERO",
      "client_type_name": "GRATIS",
      "client_subdivision": "ACTIVO_GRATIS",
      "status_name": "Activo",
      "cycle": 25,
      "migrate": false,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 86,
        "name": "PLAN RECURRENTE 80M GRATIS",
        "cost": "0.00",
        "code": "FO-G80",
        "profile": "80M/80M"
      },
      "client_mobile": "04140390506",
      "client_email": "elireyesve@gmail.com",
      "address": "CALLE MARINO C.C PASEO MARINO NIVEL PB-09 LOCAL PB-09 CENTRO TURMERO, Turmero 2115",
      "client_identification": "V0000001",
      "nap_box_name": "256",
      "created_at": "2026-04-29T15:40:07.458392",
      "service_detail": {
        "id": 12435,
        "ip": "10.10.154.2",
        "mac": "OEMT3C624776",
        "serial": "OEMT3C624776",
        "queue": null,
        "interface": "VLAN216_LAGUNA_PLAZA_OLT1",
        "created_at": "2026-04-30T10:10:30.856825",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9071,
      "client_name": "ELITE IMPORTS TURMERO",
      "client_type_name": "GRATIS",
      "client_subdivision": "ACTIVO_GRATIS",
      "status_name": "Activo",
      "cycle": 25,
      "migrate": false,
      "sector_name": "San Pablo",
      "plan": {
        "id": 86,
        "name": "PLAN RECURRENTE 80M GRATIS",
        "cost": "0.00",
        "code": "FO-G80",
        "profile": "80M/80M"
      },
      "client_mobile": "04128904122",
      "client_email": "elite.imports20@gmail.com",
      "address": "TURMERO, URB. SAN PABLO, CALLE SAN PABLO, CENTRO COMERCIAL MILAN PLAZA",
      "client_identification": "J500339232",
      "nap_box_name": "CTO-00588",
      "created_at": "2026-04-30T09:33:30.435008",
      "service_detail": {
        "id": 12687,
        "ip": "10.16.223.2",
        "mac": "ZX:IC:CD:95:16:C0",
        "serial": "ZXICCD9516C0",
        "queue": null,
        "interface": "VLAN224_SAN_PABLO_OLT1",
        "created_at": "2026-07-05T18:15:22.115070",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9072,
      "client_name": "ANNI JOSE PEREZ BRITO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Bicentenario",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243452696",
      "client_email": "ANNIBRI30@GMAIL.COM",
      "address": "SECTOR BICENTENARIO CONOCIDO ANTIGUAMENTE COMO FUNDA BARRIOS. MANZANA 12 #20PB",
      "client_identification": "V22948399",
      "nap_box_name": "CTO-00453",
      "created_at": "2026-04-30T10:57:27.848768",
      "service_detail": {
        "id": 12442,
        "ip": "10.16.193.2",
        "mac": "ZXICCD650A95",
        "serial": "ZXICCD650A95",
        "queue": null,
        "interface": "VLAN243_BICENTENARIO",
        "created_at": "2026-05-01T11:17:45.616241",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9073,
      "client_name": "MARIUXY EUGENIA TREJO TINEO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04123359336",
      "client_email": "TREJOMARIU11@GMAIL.COM",
      "address": "CALLE MARIÑO EDIFICIO RESIDENCIAS MARIÑO TORRE B, PISO 6 APARTAMENTO 62-B SECTOR TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V24437877",
      "nap_box_name": "CTO-0519",
      "created_at": "2026-04-30T14:48:58.920278",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 9074,
      "client_name": "‎XO STYLO TURMERO, C.A",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04246255924",
      "client_email": "XOTURMERO@GMAIL.COM",
      "address": "CALLE MARIÑO EDIF VIERA PISO PB LOCAL Nº 63-B SECTOR CENTRO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "J508177355",
      "nap_box_name": "CTO-00256",
      "created_at": "2026-05-01T07:50:29.438126",
      "service_detail": {
        "id": 12459,
        "ip": "10.16.195.2",
        "mac": "TPLGB68B50DF",
        "serial": "TPLGB68B50DF",
        "queue": null,
        "interface": "VLAN200_OLTs",
        "created_at": "2026-05-05T09:29:58.817306",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9075,
      "client_name": "MICHAEL EDUARDO PINERO LUNA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Macaro",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128903858",
      "client_email": "MICHAELPINEROLUNA@GMAIL.COM",
      "address": "CALLE HENRY PITTIER, NRO 21, ANTONIO JOSE DE SUCRE, EL MACARO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V26535076",
      "nap_box_name": "173",
      "created_at": "2026-05-04T08:37:33.376443",
      "service_detail": {
        "id": 12458,
        "ip": "10.16.196.2",
        "mac": "JMKGCDA27D90",
        "serial": "JMKGCDA27D90",
        "queue": null,
        "interface": "VLAN101_AJS",
        "created_at": "2026-05-04T17:55:13.566697",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9076,
      "client_name": "ELA SPA BOUTIQUE CA",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 102,
        "name": "RECURRENTE PYME PLAN 150M",
        "cost": "27.60",
        "code": "FOP150M",
        "profile": "150Mbps/150Mbps"
      },
      "client_mobile": "04243499464",
      "client_email": "YESENIAFGUZMANG@GMAIL.COM",
      "address": "DOMICILIO FISCAL CALLE MIRANDA CC NONO LORENZO NIVEL PLANTA BAJA\r\n‎LOCAL N29 SECTOR TURMERO ESTADO ARAGUA ZONA POSTAL 2115",
      "client_identification": "J506315785",
      "nap_box_name": "CAJA NAP BICENTENARIO",
      "created_at": "2026-05-05T15:55:49.117582",
      "service_detail": {
        "id": 12464,
        "ip": "10.16.197.2",
        "mac": "68:9F:F0:0A:DB:7F",
        "serial": "ZXICCD8069A4",
        "queue": null,
        "interface": "VLAN200_OLTs",
        "created_at": "2026-05-06T15:53:15.711157",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9077,
      "client_name": "FELIX ARMANDO PENA ALVAREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Macaro",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04141494843",
      "client_email": "FELIXARMPE1522@GMAIL.COM",
      "address": "URBANIZACION TAGUAPIRE SECTOR EL MACARO CALLE 2 APARTAMENTO 26 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V6522522",
      "nap_box_name": "549 DOS",
      "created_at": "2026-05-05T16:28:29.486696",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 9078,
      "client_name": "LISBOA 2026 CA",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Haras de San Pablo",
      "plan": {
        "id": 102,
        "name": "RECURRENTE PYME PLAN 150M",
        "cost": "27.60",
        "code": "FOP150M",
        "profile": "150Mbps/150Mbps"
      },
      "client_mobile": "04243346011",
      "client_email": "LISBOACA26@GMAIL.COM",
      "address": "CALLE LOTE B, CONDOMINIO C, PARCELAMIENTO DESARROLLO \n‎URBANISTICO HARAS SAN PABLO CASA PARCELA C-1 NRO PARCELA 38\n‎CONJUNTO RESIDENCIAL EL HARAS TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "J507629287",
      "nap_box_name": "641",
      "created_at": "2026-05-06T13:06:02.811962",
      "service_detail": {
        "id": 13000,
        "ip": "10.16.194.2",
        "mac": "JM:KG:CB:4E:4D:A3",
        "serial": "JMKGCB4E4DA3",
        "queue": null,
        "interface": "VLAN224_SAN_PABLO_OLT1",
        "created_at": "2026-09-09T10:09:32.635735",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9079,
      "client_name": "YOHANNYS ALEXANDRA MONTEZUMA CASTILLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Polvorin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243337191",
      "client_email": "MONTEZUMAYOHANNYS3@GMAIL.COM",
      "address": "CALLE LOS MANGOS CASA NUMERO 12 SECTOR POLVORIN TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V30322655",
      "nap_box_name": "CTO - 999",
      "created_at": "2026-05-07T09:15:33.087227",
      "service_detail": {
        "id": 12477,
        "ip": "10.16.241.2",
        "mac": "4C:AB:FC:E8:97:FA",
        "serial": "JMKGC17A5EC1",
        "queue": null,
        "interface": "VLAN280_POLVORIN",
        "created_at": "2026-05-08T09:05:27.382397",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9080,
      "client_name": "‎YESENIA FLORELIS GUZMAN DE ACOSTA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243499464",
      "client_email": "YESENIAFGUZMANG@GMAIL.COM",
      "address": "CALLE NEGRO PRIMERO C/C CAMILO TORRES EDIF 3 PISO PB APARTAMENTO 3 URB URB LAGUNA PLAZA II TUEMRO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V13811957",
      "nap_box_name": "CTO-00346",
      "created_at": "2026-05-07T17:21:54.278763",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 9081,
      "client_name": "DANGELO VITTORIO FERRARROTTO VEGAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Valle lindo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04246602358",
      "client_email": "DANGELOTUB@GMAIL.COM",
      "address": "URBANIZACION VALLE LINDO SECTOR 2 CALLE 8 CASA NUMERO 13 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V29728905",
      "nap_box_name": "CE - 952",
      "created_at": "2026-05-08T08:16:22.245995",
      "service_detail": {
        "id": 12478,
        "ip": "10.16.242.2",
        "mac": "68:9F:F0:OA:DC:4F",
        "serial": "ZXICCD5664DD",
        "queue": null,
        "interface": "VLAN274_VALLELINDO",
        "created_at": "2026-05-08T15:12:26.959732",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9082,
      "client_name": "JESUS DANIEL MATHEUS LUZON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Macaro",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04123438979",
      "client_email": "JDML0904@GMAIL.COM",
      "address": "SAMAN TARAZONERO II MANZANA H-4 CASA NUMERO 13 SECTOR EL MACARO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V21426583",
      "nap_box_name": "510 DOS",
      "created_at": "2026-05-10T15:43:45.533503",
      "service_detail": {
        "id": 12484,
        "ip": "10.16.244.2",
        "mac": "68:9F:FO:OA:91:EF",
        "serial": "ZXICCD8633FD",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2026-05-12T08:18:52.898569",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9083,
      "client_name": "ROBERT GUILLERMO PALENCIA LOPEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Macaro",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243160484",
      "client_email": "ROBERTPALENCIALOPEZ@GMAIL.COM",
      "address": "URBANIZACION VILLA DE SAN JOSE EL MACARO CASA NUMERO 04-10 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V11983289",
      "nap_box_name": "396",
      "created_at": "2026-05-10T15:55:26.645738",
      "service_detail": {
        "id": 12483,
        "ip": "10.16.243.2",
        "mac": "68:9F:FO:OA:C2:2F",
        "serial": "ZXICCD03A0F2",
        "queue": null,
        "interface": "VLAN134_VILLAS_DSJ_OLT_ZTE",
        "created_at": "2026-05-11T15:38:05.467247",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9084,
      "client_name": "MARIA JOSE FERREIRA DE SANZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243695727",
      "client_email": "marijofds@gmail.com",
      "address": "Calle mariño residencias mariño torre A piso 4 apartamento. A-41. Turmero",
      "client_identification": "V9438836",
      "nap_box_name": null,
      "created_at": "2026-05-10T15:55:26.645000",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 9085,
      "client_name": "MARYULI OMALI MENDEZ DE LA CRUZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144903433",
      "client_email": "OMALYM2016@GMAIL.COM",
      "address": "calle Mariño residencias Mariño torre C apartamento 91-C",
      "client_identification": "V12145886",
      "nap_box_name": "CTO-00734",
      "created_at": "2026-05-14T17:44:36.805214",
      "service_detail": {
        "id": 13097,
        "ip": "10.16.246.2",
        "mac": "JM:KG:C9:AD:14:70",
        "serial": "JMKGC9AD1470",
        "queue": null,
        "interface": "VLAN234_R_MARINO_OLT2",
        "created_at": "2026-10-01T16:34:53.672508",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9086,
      "client_name": "VANESSA SOCORRO RAMIREZ VELASCO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Turmero Norte",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144551375",
      "client_email": "RAMIREZVELASCOVANESSA@GMAIL.COM",
      "address": "Urbanización la montañita, calle 2, casa número 49. Turmero.",
      "client_identification": "V21253568",
      "nap_box_name": "CTO-00182",
      "created_at": "2026-05-18T15:46:16.426821",
      "service_detail": {
        "id": 13076,
        "ip": "172.17.1.190",
        "mac": "4C:AB:FC:61:57:0D",
        "serial": "JMKGCF1BD962",
        "queue": null,
        "interface": "VLAN214_MONTANITA_OLT1",
        "created_at": "2026-09-25T12:22:38.901952",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9087,
      "client_name": "Freddy Carrillo",
      "client_type_name": null,
      "client_subdivision": "POR INSTALAR_SIN_TIPO",
      "status_name": "Por instalar",
      "cycle": 25,
      "migrate": true,
      "sector_name": "Antigua Hacienda De Paya",
      "plan": {
        "id": 105,
        "name": "Plan_irrecuperable",
        "cost": "0.00",
        "code": null,
        "profile": "0Mbps/0Mbps"
      },
      "client_mobile": "04129950904",
      "client_email": "freddycarrillo1912@gmail.com",
      "address": "PRUEBA PRUEBA",
      "client_identification": "V28458411",
      "nap_box_name": "CTO-00037",
      "created_at": "2026-05-19T11:34:41.711640",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 9088,
      "client_name": "Freddy Carrillo",
      "client_type_name": null,
      "client_subdivision": "POR INSTALAR_SIN_TIPO",
      "status_name": "Por instalar",
      "cycle": 25,
      "migrate": false,
      "sector_name": "Antigua Hacienda De Paya",
      "plan": {
        "id": 105,
        "name": "Plan_irrecuperable",
        "cost": "0.00",
        "code": null,
        "profile": "0Mbps/0Mbps"
      },
      "client_mobile": "04129950904",
      "client_email": "freddycarrillo1912@gmail.com",
      "address": "PRUEBA PRUEBA",
      "client_identification": "V28458411",
      "nap_box_name": "CTO-00037",
      "created_at": "2026-05-19T11:36:43.499351",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 9089,
      "client_name": "RUGLIS MAGLIS MUDARRA FRAGOZA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados de Cafetal",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124615815",
      "client_email": "RUGLISMUDARRA@GMAIL.COM",
      "address": "PRADOS DE CAFETAL CALLE 1 CASA 7 VIA PAYA",
      "client_identification": "V20266129",
      "nap_box_name": "CTO-00250",
      "created_at": "2026-05-26T14:13:08.551625",
      "service_detail": {
        "id": 12544,
        "ip": "10.16.248.2",
        "mac": "4C:AB:FC:66:08:C3",
        "serial": "JMKGCOA84A6D",
        "queue": null,
        "interface": "VLAN221_CAFETAL_OLT1",
        "created_at": "2026-05-26T14:31:26.134816",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9090,
      "client_name": "RAFAEL EFRAIN PINTO PANTOJA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121796388",
      "client_email": "PINTORAFAELPE@GMAIL.COM",
      "address": "CASCO DE TURMERO CALLE RIVAS CASA 39",
      "client_identification": "V18084871",
      "nap_box_name": "CTO-00066",
      "created_at": "2026-05-26T14:42:02.534736",
      "service_detail": {
        "id": 12545,
        "ip": "10.16.249.2",
        "mac": "68:9F:FO:OA:F3:4F",
        "serial": "ZXICCDDA2D19",
        "queue": null,
        "interface": "VLAN200_OLTs",
        "created_at": "2026-05-26T14:57:43.009432",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9091,
      "client_name": "DANY LUZ GONZALES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124362868",
      "client_email": "KIMBERLYGUTIERREZ5B@GMAIL.COM",
      "address": "SAMAN TARAZONERO 2 MANZANA E 10 CASA #8 SECTOR SAMAN DE GUERE ARAGUA ZPNA POSTAL 2115",
      "client_identification": "V11686264",
      "nap_box_name": "95",
      "created_at": "2026-05-26T15:48:35.867707",
      "service_detail": {
        "id": 13108,
        "ip": "10.16.251.2",
        "mac": "XP:ON:34:58:5F:D6",
        "serial": "XPON34585FD6",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2026-10-02T21:49:28.621910",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9092,
      "client_name": "WILMER JOSUE CARRILLO LOPEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vallecito",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121977025",
      "client_email": "WILNERCARRILLO64@GMAIL.COM",
      "address": "CALLE 2 CASA 5 VALLECITO",
      "client_identification": "V24445118",
      "nap_box_name": "CTO - 97",
      "created_at": "2026-05-27T08:43:19.651158",
      "service_detail": {
        "id": 12575,
        "ip": "10.14.67.2",
        "mac": "68:9f:f0:cc:7e:6f",
        "serial": "QXTLCBAB2EEA",
        "queue": null,
        "interface": "VLAN258_VALLECITO",
        "created_at": "2026-06-03T10:07:27.568000",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9094,
      "client_name": "JENNYMAR TIBISAY HERNANDEZ QUEVEDO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04221788920",
      "client_email": "JENNYMARHERNANDEZ28@GMAIL.COM",
      "address": "CALLE 4 CASA NÚMERO 53 SAMAN TARAZONERO 1 TURMERO",
      "client_identification": "V20334734",
      "nap_box_name": "262",
      "created_at": "2026-05-27T11:50:17.451200",
      "service_detail": {
        "id": 12551,
        "ip": "10.16.252.2",
        "mac": "XP:ON:6B:53:A9:74",
        "serial": "XPON6B53A974",
        "queue": null,
        "interface": "VLAN140_SMT1_ZTE",
        "created_at": "2026-05-27T12:08:53.401315",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9095,
      "client_name": "RAFAEL ANGEL ARDILA PEREZ F.P",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 25,
      "migrate": true,
      "sector_name": "San Pablo",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04143455757",
      "client_email": "RARDILAP@GMAIL.COM",
      "address": "CALLE HECILLE QTA CLARAMARAL NRO  24 URB SAN PABLO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V633472",
      "nap_box_name": "CTO-0642",
      "created_at": "2026-05-27T15:30:51.442211",
      "service_detail": {
        "id": 12564,
        "ip": "172.20.186.2",
        "mac": "TP:LG:B9:54:F9:97",
        "serial": "TPLGB954F997",
        "queue": null,
        "interface": "VLAN224_SAN_PABLO_OLT1",
        "created_at": "2026-06-02T08:40:35.517943",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9096,
      "client_name": "ROSBELY NOHEMY HERNANDEZ CHANG",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Cambur",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04262433077",
      "client_email": "ROSBELYNOHEMI01@GMAIL.COM",
      "address": "EL CAMBUR CORAZON DE JESÚS CALLE JESÚS REQUE #05 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V27646720",
      "nap_box_name": "CTO-004444",
      "created_at": "2026-05-28T17:05:11.642168",
      "service_detail": {
        "id": 12556,
        "ip": "10.16.253.2",
        "mac": "4c:ab:fc:f3:3b:e8",
        "serial": "JMKGC127F06C",
        "queue": null,
        "interface": "VLAN263_EL_CAMBUR",
        "created_at": "2026-05-29T11:37:14.496449",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9097,
      "client_name": "GABRIELA COROMOTO HERNANDEZ PICHARDO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243272248",
      "client_email": "GABRIELAHERNANDEZ830@GMAIL.COM",
      "address": "CALLE BOLIVAR RESIDENCIAS LOS NISPEROS TORRE C TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V28316794",
      "nap_box_name": "TORRE A EDIF LOS NISPEROS",
      "created_at": "2026-05-30T09:51:24.809443",
      "service_detail": {
        "id": 12557,
        "ip": "10.16.254.2",
        "mac": "4C:AB:FC:7O:EF:22",
        "serial": "JMKGC8964C42",
        "queue": null,
        "interface": "VLAN218_NISPEROS_OLT1",
        "created_at": "2026-05-30T11:35:20.228296",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9098,
      "client_name": "ALEJANDRO JAVIER VELASCO TORO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Taguapire",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128859782",
      "client_email": "ALEVELASCOT@GMAIL.COM",
      "address": "CONJUNTO MULTIFAMILIAR URBANIZACION TAGUAPIRE PRIMERA ETAPA APARTAMENTO NÚMERO 51 PLANTA BAJA SEGUNDA CALLE EL MACARO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V27536771",
      "nap_box_name": "549 DOS",
      "created_at": "2026-05-30T13:32:15.577908",
      "service_detail": {
        "id": 12558,
        "ip": "10.16.255.2",
        "mac": "a8:bf:3c:62:47:ee",
        "serial": "OEMT3C6247EE",
        "queue": null,
        "interface": "VLAN129_TAGUAPIRE_ZTE",
        "created_at": "2026-05-30T13:34:31.307856",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9099,
      "client_name": "VICTOR MANUEL MUNOZ ACOSTA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04141818664",
      "client_email": "YARISMARBRAVO0@GMAIL.COM",
      "address": "TORRE 29 PISO 01 APARTAMENTO NÚMERO 2 LOS NÍSPEROS TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V18490209",
      "nap_box_name": "CTO-00269",
      "created_at": "2026-06-01T18:57:48.962642",
      "service_detail": {
        "id": 12566,
        "ip": "10.13.21.2",
        "mac": "80:d4:a5:a4:08:e1",
        "serial": "HWTC49200142",
        "queue": null,
        "interface": "VLAN209_ZAMORA_OLT1",
        "created_at": "2026-06-02T11:46:24.452255",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9100,
      "client_name": "GESTRUDIS BELEN ALVES FAJARDO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Guayabita",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243387223",
      "client_email": "GESTRUDISALVES55@GMAIL.COM",
      "address": "GUAYABITA AV LOS HICACOS PARCELA 17-A VIA POLVORIN TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V12168494",
      "nap_box_name": "CTO-00674",
      "created_at": "2026-06-02T15:31:14.544404",
      "service_detail": {
        "id": 12569,
        "ip": "10.17.22.2",
        "mac": "4C:AB:FC:O4:23:88",
        "serial": "JMKGC0189D97",
        "queue": null,
        "interface": "VLAN280_POLVORIN",
        "created_at": "2026-06-02T15:35:26.612116",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9101,
      "client_name": "MARI LENIS RAMOS ALVARADO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Callejon Lim",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144670157",
      "client_email": "MARIRAMOSGESTIONES@GMAIL.COM",
      "address": "CALLE LIM EDIFICION GLADIOLA PISO 1 APARTAMENTO 6 CONJUNTO RESIDENCIAL VILLAS DE TURMERO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V13502308",
      "nap_box_name": "CTO-00744",
      "created_at": "2026-06-03T06:56:51.840094",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 9102,
      "client_name": "AZALIA YANILETH QUEVEDO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "SUSPENDIDO_RESIDENCIAL",
      "status_name": "Suspendido",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Guerito",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128998229",
      "client_email": "AZAQUEVEDO72@GMAIL.COM",
      "address": "CALLE MARIÑO CASA NUMERO 143 SECTOR GUERITO URBANIZACIÓN SAN MIGUEL TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V11749583",
      "nap_box_name": "CTO-000735",
      "created_at": "2026-06-03T16:21:42.035532",
      "service_detail": {
        "id": 12579,
        "ip": "10.17.24.2",
        "mac": "MO:NU:00:48:5D:2D",
        "serial": "MONU00485D2D",
        "queue": null,
        "interface": "VLAN139_GUERITO",
        "created_at": "2026-06-04T11:56:56.887043",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9103,
      "client_name": "JONATHAN MOISES NUNEZ RONDON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vallecito",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04226464672",
      "client_email": "NUNEZJONATHAN022@GMAIL.COM",
      "address": "CALLE EL CUJI LOS NARANJOS SECTOR VALLECITO ROSARIO DE PAYA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V29608990",
      "nap_box_name": "CTO - 108",
      "created_at": "2026-06-04T15:52:54.546562",
      "service_detail": {
        "id": 12580,
        "ip": "10.17.25.2",
        "mac": "HW:TC:57:16:88:B3",
        "serial": "HWTC571688B3",
        "queue": null,
        "interface": "VLAN258_VALLECITO",
        "created_at": "2026-06-04T16:46:43.255435",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9104,
      "client_name": "DARWING EDUARDO GALINDEZ CONTRERAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Jabillar",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243395135",
      "client_email": "DARWINEDUARDO_21@HOTMAIL.COM",
      "address": "URBANIZACION JABILLAR CALLE LOS SAUCES CASA 10/13 EL MACARO SAMAN DE GUERE TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V17273314",
      "nap_box_name": "CTO-00007",
      "created_at": "2026-06-05T14:15:20.474945",
      "service_detail": {
        "id": 12582,
        "ip": "10.17.27.2",
        "mac": "68:9F:FO:OA:D6:5F",
        "serial": "ZXICCD49C347",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2026-06-05T16:00:35.253274",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9105,
      "client_name": "FERREAGRICOLAS LA COLONIA CA",
      "client_type_name": "PYME",
      "client_subdivision": "CANCELADO_PYME",
      "status_name": "Cancelado",
      "cycle": 25,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04243162015",
      "client_email": "FERREAGRICOLASLACOLONIA@GMAIL.COM",
      "address": "CALLE GIRARDOT LOCAL NUMERO 12 SECTOR TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "J298962976",
      "nap_box_name": "CTO-00440",
      "created_at": "2026-06-05T15:24:09.931719",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 9106,
      "client_name": "BRAIANA MARIELL LANDAETA DIAZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Las Palmas",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04127761945",
      "client_email": "BRAIANAMARIELLL@GMAIL.COM",
      "address": "AVENIDA PRINCIPAL ROSARIO DE PAYA CASA 183 LAS PALMAS TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V26140813",
      "nap_box_name": "CTO-00098",
      "created_at": "2026-06-06T17:53:41.441987",
      "service_detail": {
        "id": 12594,
        "ip": "172.29.28.2",
        "mac": "OE:MT:3C:62:60:FE",
        "serial": "OEMT3C6260FE",
        "queue": null,
        "interface": "VLAN262_LAS_PALMAS_ZTE",
        "created_at": "2026-06-07T11:17:51.675019",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9107,
      "client_name": "MARIA FERNANDA PEREZ JUAREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243745857",
      "client_email": "PMAFER659@GMAIL.COM",
      "address": "URBANIZACION LA CASONA II CALLE 15 CASA NUMERO 72 TURMERO LA JULIA ARAGUA ZONA POSTAL 2115",
      "client_identification": "V24172190",
      "nap_box_name": "CTO-0303",
      "created_at": "2026-06-07T08:35:22.538369",
      "service_detail": {
        "id": 12598,
        "ip": "10.16.218.2",
        "mac": "4C:AB:FC:C0:E4:09",
        "serial": "JMKGC76023D5",
        "queue": null,
        "interface": "VLAN110_CASONA_2",
        "created_at": "2026-06-07T17:30:45.771415",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9108,
      "client_name": "ELVA GREGORIO SEIJAS NIEVES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Guerito",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128907350",
      "client_email": "SEIJASELVA5@GMAIL.COM",
      "address": "URBANIZACION SAN MIGUEL CASA NUMERO 88 CALLE RICAURTE CON MARIÑO SECTOR GUERITO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V10278901",
      "nap_box_name": "CTO-00524",
      "created_at": "2026-06-07T13:36:02.895717",
      "service_detail": {
        "id": 12597,
        "ip": "10.16.217.2",
        "mac": "48:35:2E:37:5F:00",
        "serial": "MONU00375F01",
        "queue": null,
        "interface": "VLAN139_GUERITO",
        "created_at": "2026-06-07T14:49:22.452851",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9109,
      "client_name": "ALBERTO JOSE JIMENEZ HERRERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243529871",
      "client_email": "UNEFAALBERT91@GMAIL.COM",
      "address": "CALLE EL CENTRO CASA NRO 15 SECTOR PUEBLO NUEVO TURMERO ESTADO ARAGUA",
      "client_identification": "V18778847",
      "nap_box_name": "211",
      "created_at": "2026-06-08T13:44:59.234355",
      "service_detail": {
        "id": 12613,
        "ip": "172.20.7.2",
        "mac": "3C:84:6A:FA:FF:0A",
        "serial": "TPLGB7656242",
        "queue": null,
        "interface": "VLAN200_OLTs",
        "created_at": "2026-06-12T15:30:18.495105",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9110,
      "client_name": "LUIS FELIPE DE TOVAR PANTIN",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Antigua Hacienda De Paya",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04145888150",
      "client_email": "DETOVAR@HOTMAIL.COM",
      "address": "CALLE 19 URBANIZACION ANTIGUA HACIENDA DE PAYA CASA NUMERO 1 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V4085485",
      "nap_box_name": "223",
      "created_at": "2026-06-09T18:23:12.929696",
      "service_detail": {
        "id": 12604,
        "ip": "10.16.30.2",
        "mac": "4C:AB:FC:31:7A:08",
        "serial": "JMKGCB18A952",
        "queue": null,
        "interface": "VLAN202_AHP_OLT1",
        "created_at": "2026-06-10T17:59:27.160391",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9111,
      "client_name": "LUIS FELIPE DE TOVAR PANTIN",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Antigua Hacienda De Paya",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04145888150",
      "client_email": "DETOVAR@HOTMAIL.COM",
      "address": "ANTIGUA HACIENDA PAYA, CALLE 17 DOMINGO DE TOVAR. CASA NUMERO 1 LA TOVAREÑA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V4085485",
      "nap_box_name": "247",
      "created_at": "2026-06-10T15:29:09.834376",
      "service_detail": {
        "id": 12606,
        "ip": "10.17.29.2",
        "mac": "JM:KG:CE:3E:0F:73",
        "serial": "JMKGCE3E0F73",
        "queue": null,
        "interface": "VLAN202_AHP_OLT1",
        "created_at": "2026-06-10T18:58:53.290849",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9112,
      "client_name": "JOEL ANTONIO LEAL HERRERA",
      "client_type_name": "EMPLEADO",
      "client_subdivision": "ACTIVO_EMPLEADO",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": false,
      "sector_name": "Saman Tarazonero I",
      "plan": {
        "id": 78,
        "name": "Plan empleado 80MB",
        "cost": "0.00",
        "code": "FO-80M",
        "profile": "80M/80M"
      },
      "client_mobile": "4128905922",
      "client_email": "SHIRLEYJOHANA45@GMAIL.COM",
      "address": "SAMAN TARAZONERO I CALLE 3 CASA 33 EL MACARO",
      "client_identification": "V13876050",
      "nap_box_name": "CTO-00680",
      "created_at": "2026-06-11T07:18:42.879898",
      "service_detail": {
        "id": 12619,
        "ip": "10.17.32.2",
        "mac": "HW:TC:48:08:02:93",
        "serial": "HWTC48080293",
        "queue": null,
        "interface": "VLAN140_SMT1_ZTE",
        "created_at": "2026-06-16T14:42:20.257543",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9113,
      "client_name": "MARCOS ALEXANDER GOYO SERENO",
      "client_type_name": "EMPLEADO",
      "client_subdivision": "CANCELADO_EMPLEADO",
      "status_name": "Cancelado",
      "cycle": 10,
      "migrate": false,
      "sector_name": "Saman Tarazonero I",
      "plan": {
        "id": 78,
        "name": "Plan empleado 80MB",
        "cost": "0.00",
        "code": "FO-80M",
        "profile": "80M/80M"
      },
      "client_mobile": "04121772446",
      "client_email": "ANASIVIRA77@GMAIL.COM",
      "address": "SAMAN TARAZONERO 1 CALLE 3 CASA 45 EL MACARO",
      "client_identification": "V12509727",
      "nap_box_name": "CTO-00680",
      "created_at": "2026-06-11T07:20:04.236825",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 9114,
      "client_name": "MARCOS ALEXANDER GOYO SERENO",
      "client_type_name": "EMPLEADO",
      "client_subdivision": "ACTIVO_EMPLEADO",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": false,
      "sector_name": "Saman Tarazonero I",
      "plan": {
        "id": 78,
        "name": "Plan empleado 80MB",
        "cost": "0.00",
        "code": "FO-80M",
        "profile": "80M/80M"
      },
      "client_mobile": "04121772446",
      "client_email": "ANASIVIRA77@GMAIL.COM",
      "address": "SAMAN TARAZONERO 1 CALLE 3 CASA 45 EL MACARO",
      "client_identification": "V12509727",
      "nap_box_name": "CTO-00680",
      "created_at": "2026-06-11T08:20:25.425965",
      "service_detail": {
        "id": 12609,
        "ip": "10.13.124.2",
        "mac": "A8:BF:3C:62:0D:D2",
        "serial": "OEMT3C620DD2",
        "queue": null,
        "interface": "VLAN140_SMT1_ZTE",
        "created_at": "2026-06-11T08:20:25.566173",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9115,
      "client_name": "MILTHA ALEJANDRA GIL ARANGUREN",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona I",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124826209",
      "client_email": "MGILARANGUREN@GMAIL.COM",
      "address": "LA CASONA 1 INTERCOMUNAL LA CASONA L CALLE 2 CASA#10 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V27894471",
      "nap_box_name": "451",
      "created_at": "2026-06-11T17:32:31.457859",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 9116,
      "client_name": "WILLIAM ALEJANDRO LEVITAN ABDELNOUR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Haras de San Pablo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04243227916",
      "client_email": "LEVITANW@GMAIL.COM",
      "address": "CONJUNTO RESIDENCIAL EL HARAS SAN PABLO AV 2 CASA 53",
      "client_identification": "V24930477",
      "nap_box_name": "247",
      "created_at": "2026-06-12T12:55:39.610821",
      "service_detail": {
        "id": 12612,
        "ip": "10.17.31.2",
        "mac": "68:9F:F0:0A:BB:9F",
        "serial": "ZXICCDAB01B8",
        "queue": null,
        "interface": "VLAN210_HSP_OLT1",
        "created_at": "2026-06-12T15:12:25.444651",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9117,
      "client_name": "SUJEINS SORANGEL MADERO ORTEGA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Las Rurales",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128903811",
      "client_email": "SUJEINSMADERO@GMAIL.COM",
      "address": "CALLE SUCRE POR LA ESCUELA SEIGA CASA NUMERO 13 LAS RURALES ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V13699970",
      "nap_box_name": "CE-00067",
      "created_at": "2026-06-15T10:11:56.185808",
      "service_detail": {
        "id": 12615,
        "ip": "10.16.219.2",
        "mac": "68:9F:F0:0A:97:9F",
        "serial": "ZXICCD9C8728",
        "queue": null,
        "interface": "VLAN252_RURALES_PAYA",
        "created_at": "2026-06-15T13:01:02.912266",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9118,
      "client_name": "LUDY ONEIDA LOPEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128926319",
      "client_email": "ludyl6824@gmail.com",
      "address": "SECTOR RIO SECO CALLE 7 CASA 13 ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V15123846",
      "nap_box_name": "CE-00067",
      "created_at": "2026-06-15T16:24:25.722114",
      "service_detail": {
        "id": 12617,
        "ip": "10.12.230.2",
        "mac": "HW:TC:49:20:01:32",
        "serial": "HWTC49200132",
        "queue": null,
        "interface": "VLAN251_RIO_SECO",
        "created_at": "2026-06-15T16:55:17.109339",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9119,
      "client_name": "MILAGRO MARGARITA LOPEZ MATOS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Polvorin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04163300087",
      "client_email": "MILAGROMARGARITALOPEZMATOS@GMAIL.COM",
      "address": "POLVORIN SECTOR GUAYABITA CALLE 3 DE MAYO NUMERO 19 ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V11088948",
      "nap_box_name": "CTO - 991",
      "created_at": "2026-06-18T10:09:13.384047",
      "service_detail": {
        "id": 12621,
        "ip": "10.17.28.2",
        "mac": "68:9F:F0:0A:DC:FF",
        "serial": "ZXICCD4343FD",
        "queue": null,
        "interface": "VLAN280_POLVORIN",
        "created_at": "2026-06-18T12:22:51.329251",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9120,
      "client_name": "YEMISON EDUARDO DELGADO MADERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Las Rurales",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243657843",
      "client_email": "YEMISONDELGADO11@GMAIL.COM",
      "address": "CALLE SUCRE CALLE 13 SECTOR LAS RURALES",
      "client_identification": "V25620731",
      "nap_box_name": "CE - 658",
      "created_at": "2026-06-19T10:37:09.997374",
      "service_detail": {
        "id": 12623,
        "ip": "10.17.33.2",
        "mac": "68:9F:F0:ED:1C:5F",
        "serial": "ZXICCC6363E1",
        "queue": null,
        "interface": "VLAN252_RURALES_PAYA",
        "created_at": "2026-06-19T12:21:40.441707",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9121,
      "client_name": "JUANA FRANCISCA PANTOJA CAPOTE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Cambur",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04123987047",
      "client_email": "JUANABENDECIDA27@GMAIL.COM",
      "address": "CALLE PRINCIPAL CASA NÚMERO 30-3 SECTOR EL CAMBUR - ROSARIO DE PAYA",
      "client_identification": "V12168542",
      "nap_box_name": "CTO - 912",
      "created_at": "2026-06-20T11:34:57.115512",
      "service_detail": {
        "id": 12665,
        "ip": "10.16.221.2",
        "mac": "A8:bf:3C:62:57:fd",
        "serial": "OEMT3C6257FE",
        "queue": null,
        "interface": "VLAN263_EL_CAMBUR",
        "created_at": "2026-07-03T12:06:36.612497",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9122,
      "client_name": "NEYIS JOSEFINA CANACHE BLANCA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Concepcion",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243000420",
      "client_email": "NEYISCANACHE1@GMAIL.COM",
      "address": "AV INTERCOMUNAL LA JULIA EDIFICIO 11 APARTAMENTO NUMERO 2 URB NUESTRA SEÑORA DE LA CONCEPCION TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V12595363",
      "nap_box_name": "0326 DOS",
      "created_at": "2026-06-22T16:30:22.853334",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 9123,
      "client_name": "ROXANA MICHELE ARROYO VELASQUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Laguna Plaza",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04223312462",
      "client_email": "roxanaarroyo04@gmail.com",
      "address": "CONDOMINIO DEL CONJUNTO RESIDENCIAL LAGUNA PLAZA SECTOR 4, APARTAMENTO 12 PH 3 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V23919814",
      "nap_box_name": "3",
      "created_at": "2026-06-23T12:06:12.759402",
      "service_detail": {
        "id": 12634,
        "ip": "10.17.36.2",
        "mac": "ZX:IC:CD:A5:F5:A0",
        "serial": "ZXICCDA5F5A0",
        "queue": null,
        "interface": "VLAN216_LAGUNA_PLAZA_OLT1",
        "created_at": "2026-06-23T13:59:51.984735",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9124,
      "client_name": "STEFANI YAIMAR OVALLES RIVAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero I",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04228155319",
      "client_email": "CAMPOSNATALIA653@GMAIL.COM",
      "address": "CALLE 6 SECTOR SAMAN TARAZONERO I EL MACARO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V27286086",
      "nap_box_name": "667",
      "created_at": "2026-06-26T12:00:57.435627",
      "service_detail": {
        "id": 12637,
        "ip": "172.29.159.2",
        "mac": "HW:TC:24:A6:F2:90",
        "serial": "HWTC24A6F290",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2026-06-26T13:49:21.839072",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9125,
      "client_name": "ALEJANDRO ANTONIO SORETT GARCIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Antigua Hacienda De Paya",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144876639",
      "client_email": "SORETTALEJANDRO5@GMAIL.COM",
      "address": "CALLE MOLINA ESTE CASA NUMERO 1 ANTIGUA HACIENDA PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V30033029",
      "nap_box_name": "CE - 941",
      "created_at": "2026-06-29T11:11:14.911648",
      "service_detail": {
        "id": 12643,
        "ip": "10.17.37.2",
        "mac": "68:9F:F0:0A:F1:FF",
        "serial": "ZXICCDD7B9C9",
        "queue": null,
        "interface": "VLAN202_AHP_OLT1",
        "created_at": "2026-06-29T11:14:25.228505",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9126,
      "client_name": "LURIANNY BETZABETH CORREA BELISARIO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados I",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144053832",
      "client_email": "LURIANNYCORREA585@GMAIL.COM",
      "address": "CALLE 1 PRADOS 1 CASA NUMERO 3 PARROQUIA PEDRO AREVALO APONTE TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V31231502",
      "nap_box_name": "CTO-00206",
      "created_at": "2026-06-29T11:20:27.300192",
      "service_detail": {
        "id": 12644,
        "ip": "10.17.38.2",
        "mac": "68:9f:f0:0a:dd:3f",
        "serial": "ZXICCDFC868D",
        "queue": null,
        "interface": "VLAN239_PRADOS1",
        "created_at": "2026-06-29T14:04:07.865573",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9127,
      "client_name": "ANGEL FRANCISCO GALLARDO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Naranjal",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243637010",
      "client_email": "GALLARDOANGELF19@GMAIL.COM",
      "address": "CALLE NARANJAL CASA NUMERO 31 SECTOR EL NARANJAL TUMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V15038034",
      "nap_box_name": "CE - 681",
      "created_at": "2026-06-29T14:51:24.811393",
      "service_detail": {
        "id": 12645,
        "ip": "10.17.39.2",
        "mac": "68:9f:f0:0a:f2:ef",
        "serial": "ZXICCD940225",
        "queue": null,
        "interface": "VLAN246_NARANJAL",
        "created_at": "2026-06-29T16:08:13.928238",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9128,
      "client_name": "IRAM JESUS PALMA PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121484806",
      "client_email": "JESUSPALMASKRT97@GMAIL.COM",
      "address": "CALLE CARREÑO CASA NUMERO 3 URB HACIENDA LOS NISPEROS TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V29786069",
      "nap_box_name": "CTO-00464",
      "created_at": "2026-06-29T17:51:01.705852",
      "service_detail": {
        "id": 12646,
        "ip": "10.17.40.2",
        "mac": "68:9f:f0:cc:b9:ff",
        "serial": "QXTLCBF12F7A",
        "queue": null,
        "interface": "VLAN209_ZAMORA_OLT1",
        "created_at": "2026-06-29T17:54:44.430794",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9129,
      "client_name": "MAYELI CAROLINA PEREZ CARRASQUEL",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "1ro de Mayo Norte",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04123986152",
      "client_email": "DANIELALEOTA95@GMAIL.COM",
      "address": "CALLE INTERNACIONAL NUMERO 31 PRIMERO DE MAYO NORTE ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V30596623",
      "nap_box_name": "CTO- 908",
      "created_at": "2026-07-02T16:17:37.734781",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 9130,
      "client_name": "EYLYN MARELEN SOLUOTTO MANTILLA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados de Cafetal",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243159966",
      "client_email": "EYLYNMARELEN@GMAIL.COM",
      "address": "CALLE EL PEAJE PRADO 6-3-2 D1 SECTOR PRADOS DE CAFETAL TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V14318104",
      "nap_box_name": "545",
      "created_at": "2026-07-03T10:08:27.136069",
      "service_detail": {
        "id": 12661,
        "ip": "10.17.42.2",
        "mac": "TP:LG:B9:54:FB:A4",
        "serial": "TPLGB954FBA4",
        "queue": null,
        "interface": "VLAN221_CAFETAL_OLT1",
        "created_at": "2026-07-03T10:25:18.029159",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9131,
      "client_name": "ALBERTO LUIS HORTELANO GOMEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Paya Abajo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124302539",
      "client_email": "ALBERTOHORTELANO21@GMAIL.COM",
      "address": "SECTOR PAYA ABAJO CALLE LA CAPILLA CASA PARCELA NUMERO 4 ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V20057711",
      "nap_box_name": "CTO-00307",
      "created_at": "2026-07-03T12:39:40.115013",
      "service_detail": {
        "id": 12763,
        "ip": "10.17.43.2",
        "mac": "68:9F:F0:2A:92:2F",
        "serial": "ZXICCD96B664",
        "queue": null,
        "interface": "VLAN231_PAYABAJO",
        "created_at": "2026-07-22T11:41:56.976068",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9132,
      "client_name": "ADRIANA JOSEFINA PERES HERRERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04123982142",
      "client_email": "ADRIPEREZHERRERA57@GMAIL.COM",
      "address": "CALLE VILLACASTIN NÚMERO 25-1",
      "client_identification": "V22948985",
      "nap_box_name": "CTO-0248",
      "created_at": "2026-07-03T18:51:10.755048",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 9134,
      "client_name": "HUMBERTO JAVIER MORALES PADRON",
      "client_type_name": "INTERCAMBIO",
      "client_subdivision": "ACTIVO_INTERCAMBIO",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "San Pablo",
      "plan": {
        "id": 83,
        "name": "RECURRENTE INSTITUCIONAL 80M",
        "cost": "0.00",
        "code": "FO-R80",
        "profile": "80M/80M"
      },
      "client_mobile": "4144534868",
      "client_email": "tribunalagrarioturmero@gmail.com",
      "address": "centro comercial el portal local 01 calle rivas, frente al cementerio municipal de turmero",
      "client_identification": "v18779468",
      "nap_box_name": "CTO-00693",
      "created_at": "2026-07-04T12:29:03.436232",
      "service_detail": {
        "id": 12724,
        "ip": "10.17.46.2",
        "mac": "ZX:IC:CD:CE:9C:89",
        "serial": "ZXICCDCE9C89",
        "queue": null,
        "interface": "VLAN200_OLTs",
        "created_at": "2026-07-11T14:53:52.554093",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9135,
      "client_name": "PAOLA ISABELLA VIZCAYA CORREA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04122251892",
      "client_email": "PAOISABELLA26@GMAIL.COM",
      "address": "URB LA CASONA 2 CALLE 18 CASA 13 INTERCOMUNAL TURMERO  ARAGUA ZONA POSTAL 2115",
      "client_identification": "V27864691",
      "nap_box_name": "CTO-00086",
      "created_at": "2026-07-04T15:05:55.342061",
      "service_detail": {
        "id": 12678,
        "ip": "10.16.222.2",
        "mac": "ZX:IC:CD:63:85:66",
        "serial": "ZXICCD638566",
        "queue": null,
        "interface": "VLAN110_CASONA_2",
        "created_at": "2026-07-05T09:53:48.029783",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9136,
      "client_name": "JEAN CANDELARIO LOPEZ MONTILLA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Terrazas de Juan Pablo",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04145905155",
      "client_email": "JCLOPEZMONTILLA1@GMAIL.COM",
      "address": "URB TERRAZAS DE JUAN PABLO II SECTOR SAMAN DE GUERE TURMERO EDO ARAGUA APTO C07",
      "client_identification": "V14086736",
      "nap_box_name": "12",
      "created_at": "2026-07-06T11:53:28.794980",
      "service_detail": {
        "id": 12690,
        "ip": "172.25.23.2",
        "mac": "TP:LG:2A:BD:C6:93",
        "serial": "TPLG2ABDC693",
        "queue": null,
        "interface": "VLAN130_TERRAZAS_JP",
        "created_at": "2026-07-06T12:09:43.366285",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9137,
      "client_name": "MARVIS YOHANA PAREJO ALAYON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Guerito",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04141442518",
      "client_email": "PAREJOMARVIS@GMAIL.COM",
      "address": "CONJUNTO RESIDENCIAL LOS SAMANES TERRAZA 8 TORRE B SECTOR GUERITO EL MACARO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V17511607",
      "nap_box_name": "CE (Proyecto)",
      "created_at": "2026-07-06T19:36:45.803276",
      "service_detail": {
        "id": 12709,
        "ip": "172.23.113.2",
        "mac": "XP:ON:23:13:4C:C0",
        "serial": "XPON23134CC0",
        "queue": null,
        "interface": "VLAN139_GUERITO",
        "created_at": "2026-07-08T17:15:11.688877",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9138,
      "client_name": "ANA KARINA GARCIA IBARRA",
      "client_type_name": "GRATIS",
      "client_subdivision": "CANCELADO_GRATIS",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 86,
        "name": "PLAN RECURRENTE 80M GRATIS",
        "cost": "0.00",
        "code": "FO-G80",
        "profile": "80M/80M"
      },
      "client_mobile": "4127314994",
      "client_email": "garciaibarraanakarina@gmail.com",
      "address": "calle urdaneta numero 31 casco de turmero",
      "client_identification": "v25827611",
      "nap_box_name": "CTO-00246",
      "created_at": "2026-07-07T11:32:31.866633",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 9139,
      "client_name": "ANA KARINA GARCIA IBARRA",
      "client_type_name": "GRATIS",
      "client_subdivision": "ACTIVO_GRATIS",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 86,
        "name": "PLAN RECURRENTE 80M GRATIS",
        "cost": "0.00",
        "code": "FO-G80",
        "profile": "80M/80M"
      },
      "client_mobile": "4127314994",
      "client_email": "garciaibarraanakarina@gmail.com",
      "address": "calle urdaneta numero 31 casco de turmero",
      "client_identification": "v25827611",
      "nap_box_name": "CTO-00246",
      "created_at": "2026-07-07T11:35:31.832355",
      "service_detail": {
        "id": 12699,
        "ip": "10.14.150.2",
        "mac": "HW:TC:49:20:07:28",
        "serial": "HWTC49200728",
        "queue": null,
        "interface": "VLAN200_OLTs",
        "created_at": "2026-07-07T12:05:03.236608",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9140,
      "client_name": "LUIS EDUARDO BARRADA ROA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Bosque",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243020799",
      "client_email": "BARRADALUIS75@GMAIL.COM",
      "address": "CALLE ARISMENDI CASA NRO 5 SECTOR EL BOSQUE ROSARIO DE PAYA",
      "client_identification": "V30852962",
      "nap_box_name": "CTO-00290",
      "created_at": "2026-07-07T12:12:42.525405",
      "service_detail": {
        "id": 12701,
        "ip": "10.14.110.2",
        "mac": "QX:TL:CB:3A:02:6E",
        "serial": "QXTLCB3A026E",
        "queue": null,
        "interface": "VLAN266_EL_BOSQUE_ZTE",
        "created_at": "2026-07-07T15:09:42.221742",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9141,
      "client_name": "MERKI DELFINA LUNA LADERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman de Guere",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124583804",
      "client_email": "LUNAMERKI1@GMAIL.COM",
      "address": "CALLE LINARES ALCANTARA CASA NRO 57 B SECTOR SAMAN DE GUERE TURMERO",
      "client_identification": "V10753746",
      "nap_box_name": "CE - 1078",
      "created_at": "2026-07-07T15:01:50.502257",
      "service_detail": {
        "id": 12703,
        "ip": "10.17.47.2",
        "mac": "ZX:IC:CD:FD:50:56",
        "serial": "ZXICCDFD5056",
        "queue": null,
        "interface": "VLAN122_SAMAN_GUERE",
        "created_at": "2026-07-07T17:27:17.165680",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9142,
      "client_name": "ADRIAN ALEJANDRO RODRIGUEZ MONTILLA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Dios Es Mi Refugio",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124685774",
      "client_email": "ALEJANDROMONTILLA277@GMAIL.COM",
      "address": "AV PRINCIPAL DE ROSARIO DE PAYA MANZANA 1 NRO 2 SECTOR DIOS ES MI REFUGIO",
      "client_identification": "V27866553",
      "nap_box_name": "406",
      "created_at": "2026-07-08T09:27:44.055856",
      "service_detail": {
        "id": 12710,
        "ip": "10.17.48.2",
        "mac": "ZX:IC:CD:49:6E:04",
        "serial": "ZXICCD496E04",
        "queue": null,
        "interface": "VLAN271_DIOS_ES_MI_REFUGIO_OLT1",
        "created_at": "2026-07-08T18:26:20.854821",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9143,
      "client_name": "GREGORI BERNARDO BORGES GRAFFE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128870448",
      "client_email": "GREGORYGRAFFE34@GMAIL.COM",
      "address": "CALLE NEGRO PRIMERO CASA 2-1 CASCO DE TURMERO, TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V15302952",
      "nap_box_name": "53",
      "created_at": "2026-07-08T14:54:02.270571",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 9144,
      "client_name": "ANDREINA COROMOTO GARCIA CAMACHO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124359767",
      "client_email": "GANDREINA583@GMAIL.COM",
      "address": "SECTOR MATA CABALLO CALLE 8 TETRA 579D ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V18852184",
      "nap_box_name": "CTO-00130",
      "created_at": "2026-07-09T14:46:49.985480",
      "service_detail": {
        "id": 12713,
        "ip": "10.16.224.2",
        "mac": "68:9F:F0:2A:76:CF",
        "serial": "ZXICCD75E207",
        "queue": null,
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2026-07-09T14:50:16.278943",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9145,
      "client_name": "PABLO JOSE DIAZ HERRERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Valle Fresco",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04163465252",
      "client_email": "PROTOKULTURA76@GMAIL.COM",
      "address": "CALLE 2-A MANZANA 8 CASA NUMERO 8-7 URB VALLE FRESCO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V12145980",
      "nap_box_name": "CTO - 924",
      "created_at": "2026-07-10T09:20:13.782523",
      "service_detail": {
        "id": 12725,
        "ip": "10.16.226.2",
        "mac": "ZX:IC:CD:31:4E:C9",
        "serial": "ZXICCD314EC9",
        "queue": null,
        "interface": "VLAN270_VALLE_FRESCO_OLT3",
        "created_at": "2026-07-11T16:35:39.955765",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9146,
      "client_name": "PAULIMAR STEFANY DIAZ CANCELADO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "1ro de Mayo Sur",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04242798353",
      "client_email": "PAULIMARSDC@GMAIL.COM",
      "address": "CALLE EL CUJI CASA NÚMERO 8 - A SECTOR PRIMERO DE MAYO SUR TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V28387561",
      "nap_box_name": "CTO-00470",
      "created_at": "2026-07-10T10:18:22.483138",
      "service_detail": {
        "id": 12719,
        "ip": "10.16.225.2",
        "mac": "68:9f:f0:0a:f3:0f",
        "serial": "ZXICCD0F3AC0",
        "queue": null,
        "interface": "VLAN261_1ERO_MAYO_ZTE",
        "created_at": "2026-07-10T14:09:49.942760",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9147,
      "client_name": "HUGO JOSE TOVAR CARREÑO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Haras de San Pablo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243285839",
      "client_email": "yeilymar.laya23@gmail.com",
      "address": "URBANIZACION VALLE PARAISO DESARROLLO URBANISTICO HARAS DE SAN PABLO CALLE CENTRAL CONJUNTO RESIDENCIAL ALTOS DE JUAN PABLO SEGUNDO APARTAMENTO NUMERO 6 PLANTA ALTA TUEMRO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V13770135",
      "nap_box_name": "26",
      "created_at": "2026-07-10T16:41:26.041048",
      "service_detail": {
        "id": 12722,
        "ip": "10.16.227.2",
        "mac": "ZX:IC:CD:48:CE:80",
        "serial": "ZXICCD48CE80",
        "queue": null,
        "interface": "VLAN224_SAN_PABLO_OLT1",
        "created_at": "2026-07-10T17:12:19.334007",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9148,
      "client_name": "LINA RAQUEL LOPEZ OSORIO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Terrazas de Juan Pablo",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243421224",
      "client_email": "LINARAQUELOPEZO@GMAIL.COM",
      "address": "URBANIZACION TERRAZAS DE JUAN PABLO APTO C3 CALLE LA LLANERA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V14491767",
      "nap_box_name": "12",
      "created_at": "2026-07-11T11:28:13.594730",
      "service_detail": {
        "id": 12729,
        "ip": "172.10.26.2",
        "mac": "TP:LG:B7:65:63:64",
        "serial": "TPLGB7656364",
        "queue": null,
        "interface": "VLAN130_TERRAZAS_JP",
        "created_at": "2026-07-12T10:50:31.703451",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9149,
      "client_name": "RUTH NAIROVITH CAMACHO DUARTE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Narayola II",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04120349951",
      "client_email": "RUTHCAMACHO83@GMAIL.COM",
      "address": "‎URB NARAYOLA 2 TORRE 2 APTO 2-4 AVENIDA INTERCOMUNAL LA JULIA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V15767845",
      "nap_box_name": "CTO-0522",
      "created_at": "2026-07-11T11:30:43.813455",
      "service_detail": {
        "id": 12728,
        "ip": "10.17.49.2",
        "mac": "ZX:IC:CD:7A:72:0E",
        "serial": "ZXICCD7A720E",
        "queue": null,
        "interface": "VLAN117_NARAYOLA",
        "created_at": "2026-07-12T10:23:48.774730",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9150,
      "client_name": "RAFAEL EDUARDO ARIAS JIMENEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "San Pablo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04165438921",
      "client_email": "RAFARIAS04@HOTMAIL.COM",
      "address": "URB SAN PABLO 4TA AVENIDA MANZANA 5 CASA NUMERO 12-A TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V11087519",
      "nap_box_name": "635",
      "created_at": "2026-07-12T12:12:10.322451",
      "service_detail": {
        "id": 12730,
        "ip": "10.17.50.2",
        "mac": "ZX:IC:CD:97:A4:B1",
        "serial": "ZXICCD97A4B1",
        "queue": null,
        "interface": "VLAN224_SAN_PABLO_OLT1",
        "created_at": "2026-07-12T12:20:41.621191",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9151,
      "client_name": "GEISMAR DE NAZARET VILLAZANA RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Guanarito",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04228158768",
      "client_email": "VILLAZANAGEISMAR@GMAIL.COM",
      "address": "TURMERO GUANARITO CALLE LOS NARANJOS CASA NR 30 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V30081844",
      "nap_box_name": "499",
      "created_at": "2026-07-14T14:25:01.972233",
      "service_detail": {
        "id": 12741,
        "ip": "10.17.53.2",
        "mac": "OE:MT:3C:61:F0:5E",
        "serial": "OEMT3C61F05E",
        "queue": null,
        "interface": "VLAN232_GUANARITO_OLT2",
        "created_at": "2026-07-15T16:28:15.841709",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9152,
      "client_name": "MARIANA JOSEFINA MARTINEZ LOZADA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "San Pablo",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04127081242",
      "client_email": "MARIANAMARTINEZ_14L@HOTMAIL.COM",
      "address": "URBANIZACION SAN PABLO 1 AV ESTE MANZANA 15 CASA 21 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V20559158",
      "nap_box_name": "CTO-00662",
      "created_at": "2026-07-14T15:13:08.363940",
      "service_detail": {
        "id": 12737,
        "ip": "10.17.52.2",
        "mac": "ZX:IC:CD:02:45:EE",
        "serial": "ZXICCD0245EE",
        "queue": null,
        "interface": "VLAN224_SAN_PABLO_OLT1",
        "created_at": "2026-07-14T16:56:56.373835",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9153,
      "client_name": "HUMBERTO JAVIER MORALES PADRON",
      "client_type_name": "GRATIS",
      "client_subdivision": "CANCELADO_GRATIS",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": false,
      "sector_name": "San Pablo",
      "plan": {
        "id": 86,
        "name": "PLAN RECURRENTE 80M GRATIS",
        "cost": "0.00",
        "code": "FO-G80",
        "profile": "80M/80M"
      },
      "client_mobile": "4144534868",
      "client_email": "tribunalagrarioturmero@gmail.com",
      "address": "centro comercial el portal local 01 calle rivas, frente al cementerio municipal de turmero",
      "client_identification": "v18779468",
      "nap_box_name": "CTO-00693",
      "created_at": "2026-07-17T13:19:38.910030",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 9154,
      "client_name": "LUIS ALEJANDRO  HIDALGO FLORES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 2,
        "name": "RECURRENTE RESIDENCIAL PLAN 30M",
        "cost": "20.00",
        "code": "FOR30",
        "profile": "30M/30M"
      },
      "client_mobile": "04128150454",
      "client_email": "luishflores2609@gmail.com",
      "address": "calle 1b casa 67",
      "client_identification": "V30148131",
      "nap_box_name": "125",
      "created_at": "2026-07-17T13:52:15.668324",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 9155,
      "client_name": "YHOSSELLYN VANESA PEREZ JIMENEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Macaro",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04143840349",
      "client_email": "YHOSSELLYNP@GMAIL.COM",
      "address": "URBANIZACION SIMON BOLIVAR CALLE 10 CASA NRO 03 SECTOR EL MACARO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V25066218",
      "nap_box_name": "CTO-00036",
      "created_at": "2026-07-19T12:36:51.057935",
      "service_detail": {
        "id": 12755,
        "ip": "10.13.238.2",
        "mac": "OE:MT:3C:62:02:0E",
        "serial": "OEMT3C62020E",
        "queue": null,
        "interface": "VLAN128_SIMON_BOLIVAR_ZTE",
        "created_at": "2026-07-19T12:57:01.980965",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9156,
      "client_name": "YULI YSABEL GOMES FERNANDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243328602",
      "client_email": "YULIG2@GMAIL.COM",
      "address": "CALLE MARIÑO EDIFICIO MARIÑO PISO 9 APARTAMENTO 91-B CONJUNTO RESIDENCIAL MARIÑO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V15600835",
      "nap_box_name": "CTO-0519",
      "created_at": "2026-07-20T09:06:36.783955",
      "service_detail": {
        "id": 13098,
        "ip": "10.17.55.2",
        "mac": "ZX:IC:CD:B4:9E:6C",
        "serial": "ZXICCDB49E6C",
        "queue": null,
        "interface": "VLAN234_R_MARINO_OLT2",
        "created_at": "2026-10-01T16:53:16.068759",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9157,
      "client_name": "MARIA GISELA ARAUJO PATIÑO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "San Pablo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04127345196",
      "client_email": "MARIAGISELAITALIA@GMAIL.COM",
      "address": "SECTOR SAN PABLO URBANIZACION MARINA CARIBE CALLE ISABEL CASA A 50 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V6024707",
      "nap_box_name": "CTO - 940",
      "created_at": "2026-07-20T14:30:02.953875",
      "service_detail": {
        "id": 12762,
        "ip": "10.16.228.2",
        "mac": "68:9F:F0:2A:C4:5F",
        "serial": "ZXICCD447A34",
        "queue": null,
        "interface": "VLAN287_M_CARIBE",
        "created_at": "2026-07-21T15:37:26.068137",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9158,
      "client_name": "JESSICA ANDREINA HENRIQUEZ MORIN",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "El Macaro",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04125058089",
      "client_email": "JESSICAHENRIQUEZ1981@GMAIL.COM",
      "address": "CALLE MARIÑO PASANDO EL PUENTE DEL MACARO FRENTE A EL ESTACIONAMIENTO DE TRANSITO CASA HOGAR EL GRAN MANDAMIENTO EL MACARO TURMERO",
      "client_identification": "V16128568",
      "nap_box_name": "CTO-00174",
      "created_at": "2026-07-21T10:08:09.350142",
      "service_detail": {
        "id": 12761,
        "ip": "10.10.119.2",
        "mac": "HW:TC:48:08:02:73",
        "serial": "HWTC48080273",
        "queue": null,
        "interface": "VLAN249_CBENDITA_OLT2",
        "created_at": "2026-07-21T12:35:53.032931",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9159,
      "client_name": "AMANDA LISETH MILLAN VIELMA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128995208",
      "client_email": "ELIAMNIS212@GMAIL.COM",
      "address": "SAMAN TARAZONERO 2 MANZANA C7 CASA 14 EL MACARO TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V15609730",
      "nap_box_name": "263",
      "created_at": "2026-07-24T09:02:56.189765",
      "service_detail": {
        "id": 12769,
        "ip": "10.16.229.2",
        "mac": "1C:EF:03:13:85:90",
        "serial": "VSOL00138591",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2026-07-24T11:05:11.300588",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9160,
      "client_name": "JOSUE SAMUEL APONTE MORENO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Simon Bolivar",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04127656223",
      "client_email": "GEORGINAA.CONTACTO@GMAIL.COM",
      "address": "SECTOR EL MACARO URBANIZACION SIMON BOLIVAR CALLE 4 CASA 42 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V30499461",
      "nap_box_name": "CTO-00047",
      "created_at": "2026-07-24T09:06:55.770120",
      "service_detail": {
        "id": 12770,
        "ip": "10.16.230.2",
        "mac": "ZX:IC:cd:f5:7e:78",
        "serial": "ZXICcdf57e78",
        "queue": null,
        "interface": "VLAN128_SIMON_BOLIVAR_ZTE",
        "created_at": "2026-07-24T17:15:29.553477",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9161,
      "client_name": "LUIS ALFONSO GARCIA ARENAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "San Pablo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04121493144",
      "client_email": "LUISGARARENAS@GMAIL.COM",
      "address": "AV PRINCIPAL SAN PABLO RESIDENCIA LAS ISABELLAS TORRE A APARTAMENTO 10-4 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V28444491",
      "nap_box_name": "CTO-00686",
      "created_at": "2026-07-27T14:28:40.831140",
      "service_detail": {
        "id": 12774,
        "ip": "10.17.56.2",
        "mac": "ZX:IC:CD:8C:2D:65",
        "serial": "ZXICCD8C2D65",
        "queue": null,
        "interface": "VLAN224_SAN_PABLO_OLT1",
        "created_at": "2026-07-27T15:14:24.975901",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9162,
      "client_name": "YANITZA LISSETTE BLANCO DE LACRUZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Villas El Carmen",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04246636295",
      "client_email": "YANILISBLANCOM@HOTMAIL.COM",
      "address": "SECTOR EL MACARO URBANIZACION VILLAS DEL CARMEN CALLE 8 CASA NUMERO 7 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V16202208",
      "nap_box_name": "41",
      "created_at": "2026-07-29T15:15:03.883055",
      "service_detail": {
        "id": 12777,
        "ip": "10.16.232.2",
        "mac": "ZX:IC:CD:35:12:F0",
        "serial": "ZXICCD3512F0",
        "queue": null,
        "interface": "VLAN135_VILLAS_CARMEN_OLT_ZTE",
        "created_at": "2026-07-29T18:25:07.558850",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9163,
      "client_name": "OMAR LEONARDO AZUAJE MEZA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Valle Fresco",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144754446",
      "client_email": "LEONARDOAZUAJE10@GMAIL.COM",
      "address": "VALLE FRESCO MANZANA NUMERO 23 CASA NUMERO 24-6 TURMERO ZONA POSTAL 2115",
      "client_identification": "V21369195",
      "nap_box_name": "CTO - 981",
      "created_at": "2026-08-05T14:44:55.945389",
      "service_detail": {
        "id": 12803,
        "ip": "10.15.210.2",
        "mac": "OE:MT:3C:62:0E:72",
        "serial": "OEMT3C620E72",
        "queue": null,
        "interface": "VLAN270_VALLE_FRESCO_OLT3",
        "created_at": "2026-08-07T09:01:10.284451",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9164,
      "client_name": "JUAN LUIS RUIZ MONCADA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Terrazas de Juan Pablo",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04144587068",
      "client_email": "corogonzalez2023@gmail.com",
      "address": "CALLE LA LLANERA CASA NRO PB D 1 URB TERRAZA DE JUAN\nPABLO TURMERO ARAGUA",
      "client_identification": "V14344185",
      "nap_box_name": "12",
      "created_at": "2026-08-05T16:01:48.877874",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 9165,
      "client_name": "ELENNY KATIUSKA CORONADO RODRIGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "SUSPENDIDO_RESIDENCIAL",
      "status_name": "Suspendido",
      "cycle": 1,
      "migrate": true,
      "sector_name": "San Pablo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "+5255778533",
      "client_email": "ELENNYCORONADO7@GMAIL.COM",
      "address": "URBANIZACION SAN PABLO CALLE HYCELLE PARCELA NUMERO 19 CONJUNTO RESINDENCIAL CAMELOT SUITE APARTAMENTO 4 PLANTA ALTA TURMERO ZONA POSTAL 2115",
      "client_identification": "V12612672",
      "nap_box_name": "140",
      "created_at": "2026-08-05T16:29:00.055920",
      "service_detail": {
        "id": 12791,
        "ip": "172.24.42.2",
        "mac": "HW:TC:45:A0:28:97",
        "serial": "HWTC45A02897",
        "queue": null,
        "interface": "VLAN200_OLTs",
        "created_at": "2026-08-06T08:41:46.801481",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9166,
      "client_name": "MARIANYELI VANESSA RIVAS ROJA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "SUSPENDIDO_RESIDENCIAL",
      "status_name": "Suspendido",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Valle Verde",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243533854",
      "client_email": "ANDRIFABIAN2580@GMAIL.COM",
      "address": "PAYA SECTOR VALLE VERDE CALLÉ RO SECO CASA NÚMERO 20 TURMERO ZONA POSTAL 2115",
      "client_identification": "V24445141",
      "nap_box_name": "CTO-00676",
      "created_at": "2026-08-06T10:29:11.704887",
      "service_detail": {
        "id": 12804,
        "ip": "10.16.234.2",
        "mac": "ZX:IC:C9:C6:1A:91",
        "serial": "ZXICC9C61A91",
        "queue": null,
        "interface": "VLAN253_VALLE_VERDE",
        "created_at": "2026-08-07T11:01:03.132758",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9167,
      "client_name": "MARLES LUCIA ALFONZO BRETO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados I",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144651737",
      "client_email": "MARLESAL2023@GMAIL.COM",
      "address": "PRADOS DE PAYA I CALLE 3 CASA NUMERO 6 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V22286655",
      "nap_box_name": "587 DOS",
      "created_at": "2026-08-06T12:28:17.783542",
      "service_detail": {
        "id": 12795,
        "ip": "10.17.57.2",
        "mac": "TP:LG:F9:CD:3D:85",
        "serial": "TPLGF9CD3D85",
        "queue": null,
        "interface": "VLAN239_PRADOS1",
        "created_at": "2026-08-06T13:01:13.267815",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9168,
      "client_name": "YUNAIKA COROMOTO PACHECO  ARTEAGA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Valle del Rosario",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04228150668",
      "client_email": "YUNAIKA3009@GMAIL.COM",
      "address": "VALLE DEL ROSARIO CALLE MARIÑO CASA NUMERO 17 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V14532955",
      "nap_box_name": "30",
      "created_at": "2026-08-06T12:53:55.313725",
      "service_detail": {
        "id": 12801,
        "ip": "10.17.58.2",
        "mac": "ZX:IC:CD:46:E2:CB",
        "serial": "ZXICCD46E2CB",
        "queue": null,
        "interface": "VLAN132_VALLE_ROSARIO",
        "created_at": "2026-08-06T16:04:35.946571",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9169,
      "client_name": "ESCUELA COMUNITARIA CARIBE",
      "client_type_name": "GRATIS",
      "client_subdivision": "ACTIVO_GRATIS",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Simon Bolivar",
      "plan": {
        "id": 86,
        "name": "PLAN RECURRENTE 80M GRATIS",
        "cost": "0.00",
        "code": "FO-G80",
        "profile": "80M/80M"
      },
      "client_mobile": "04267416390",
      "client_email": "ecidcaribefutsal@gmail.com",
      "address": "calle 1 simon bolivar el macaro turmero",
      "client_identification": "V070815059",
      "nap_box_name": "CTO-00041",
      "created_at": "2026-08-06T13:10:57.808219",
      "service_detail": {
        "id": 12981,
        "ip": "10.16.233.2",
        "mac": "ZX:IC:CD:DF:A2:74",
        "serial": "ZXICCDDFA274",
        "queue": null,
        "interface": "VLAN128_SIMON_BOLIVAR_ZTE",
        "created_at": "2026-09-04T11:22:31.946807",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9170,
      "client_name": "CAROLINA DA COSTA DE ASCENCAO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "San Pablo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04127768109",
      "client_email": "CARODC490@HOTMAIL.COM",
      "address": "4TA AVENIDA ESTE DE SAN PABLO, CASA NUMEROO 13-1 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V15129490",
      "nap_box_name": "CTO-00629",
      "created_at": "2026-08-06T15:03:35.869284",
      "service_detail": {
        "id": 12807,
        "ip": "10.16.236.2",
        "mac": "OE:MT:3C:62:59:22",
        "serial": "OEMT3C625922",
        "queue": null,
        "interface": "VLAN224_SAN_PABLO_OLT1",
        "created_at": "2026-08-07T17:28:54.615840",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9171,
      "client_name": "INVERSIONES COLBOX VEN CA",
      "client_type_name": "PYME",
      "client_subdivision": "PAUSADO_PYME",
      "status_name": "Pausado",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Guerito",
      "plan": {
        "id": 36,
        "name": "RECURRENTE PYME PLAN 650M",
        "cost": "70.18",
        "code": "FOP650M",
        "profile": "650M/650M"
      },
      "client_mobile": "04121998554",
      "client_email": "INVERSIONESCOLBOXVEN@GMAIL.COM",
      "address": "AV INTERCOMUNAL TURMERO MARACAY LOCAL NRO 4-B SECTOR SAMAN DE GUERE GALPON 3",
      "client_identification": "J500445270",
      "nap_box_name": "542",
      "created_at": "2024-07-17T09:45:46.679900",
      "service_detail": {
        "id": 13168,
        "ip": "10.17.59.2",
        "mac": "JM:KG:39:2C:DA:85",
        "serial": "JMKG392CDA85",
        "queue": null,
        "interface": "VLAN139_GUERITO",
        "created_at": "2026-10-14T15:27:02.618409",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9172,
      "client_name": "RITA ELENA RAMIREZ CHIRINOS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman de Guere",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243563113",
      "client_email": "RITACHIRINIS1974@GMAIL.COM",
      "address": "SECTOR SAMAN DE GUERE CALLE EL CARMEN CASA NUMERO 19 ARAGUA ZONA POSTAL 2115",
      "client_identification": "V12144491",
      "nap_box_name": "303",
      "created_at": "2026-08-07T15:41:09.409419",
      "service_detail": {
        "id": 12817,
        "ip": "10.16.235.2",
        "mac": "GP:ON:00:97:D9:26",
        "serial": "GPON0097D926",
        "queue": null,
        "interface": "VLAN122_SAMAN_GUERE",
        "created_at": "2026-08-11T08:38:51.975996",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9174,
      "client_name": "KAIRELIS DEL CARMEN TORO PEREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Paraguatan",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04228152384",
      "client_email": "TORKAIRELIS25@GMAIL.COM",
      "address": "CALLE EL RINCON CASA NUMERO 25 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V31023107",
      "nap_box_name": "CTO - 1118",
      "created_at": "2026-08-07T22:16:07.956381",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 9175,
      "client_name": "CARMEN OLIDA CONTRERAS RAMIREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados III",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128972090",
      "client_email": "carmenolidacontrerasramirez@gmail.com",
      "address": "calle 2 casa numero 12 prados iii turmero aragua zona postal 2115",
      "client_identification": "v10740876",
      "nap_box_name": null,
      "created_at": "2026-08-11T21:15:30.703083",
      "service_detail": {
        "id": 12838,
        "ip": "10.14.138.2",
        "mac": "HW:TC:49:20:01:39",
        "serial": "HWTC49200139",
        "queue": null,
        "interface": "VLAN236_PRADOS3",
        "created_at": "2026-08-14T15:17:16.957244",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9176,
      "client_name": "DOUBLEIBYS GREGORYS ROMERO TORBELLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Terrazas de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243594838",
      "client_email": "DUBLEIBYSROMERO@GMAIL.COM",
      "address": "urbanizacion terrazas de turmero calle 1 casa v22 turmero aragua zona postal 2115",
      "client_identification": "V25880894",
      "nap_box_name": "118",
      "created_at": "2026-08-11T21:15:31.772492",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 9177,
      "client_name": "LILIANA MERCEDES ALVARES CHACON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "SUSPENDIDO_RESIDENCIAL",
      "status_name": "Suspendido",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243572788",
      "client_email": "lilianamercedes94@gmail.com",
      "address": "urbanizacion mata caballo calle 11 casa numero 650-a turmero aragua zona postal 2115",
      "client_identification": "v12336239",
      "nap_box_name": "CTO-00022",
      "created_at": "2026-08-11T21:15:33.134691",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 9179,
      "client_name": "Maria Carolina Rodriguez Coello",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Paraguatan",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04125238413",
      "client_email": "lacatirarodriguez27@gmail.com",
      "address": "calle principal el rincón paraguatan casa número #30",
      "client_identification": "V23569371",
      "nap_box_name": "CTO-00673",
      "created_at": "2026-08-11T21:15:43.185861",
      "service_detail": {
        "id": 12863,
        "ip": "10.16.237.2",
        "mac": "JM:KG:C2:9E:EF:8D",
        "serial": "JMKGC29EEF8D",
        "queue": null,
        "interface": "VLAN283_PARAGUATAN",
        "created_at": "2026-08-17T17:04:20.991507",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9180,
      "client_name": "Jorge Manuel Rodriguez Gonzalez",
      "client_type_name": "PYME",
      "client_subdivision": "POR INSTALAR_PYME",
      "status_name": "Por instalar",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Paraguatan",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04144640773",
      "client_email": "a23423815a@gmail.com",
      "address": "calle principal el rincón paraguatan casa número #11",
      "client_identification": "v19701565",
      "nap_box_name": "CTO-00673",
      "created_at": "2026-08-11T21:15:44.505874",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 9182,
      "client_name": "YULEIDYS CAROLINA MARIN PALMA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04224435759",
      "client_email": "Yuli7391marin@gmail.com",
      "address": "centro de turmero calle rivas cruce con calle girardot numero 03 .",
      "client_identification": "v20057472",
      "nap_box_name": "CTO-00590",
      "created_at": "2026-08-12T16:06:04.605949",
      "service_detail": {
        "id": 12835,
        "ip": "10.17.63.2",
        "mac": "JM:KG:C8:2B:AF:36",
        "serial": "JMKGC82BAF36",
        "queue": null,
        "interface": "VLAN200_OLTs",
        "created_at": "2026-08-13T18:30:33.856837",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9183,
      "client_name": "KARELYS NAZARET MENESES BETANCOURT",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Polvorin",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04144497495",
      "client_email": "KARELYSMENESES0106@GMAIL.COM",
      "address": "polvorín calle 3 de mayo casa numero 29#a",
      "client_identification": "v27520867",
      "nap_box_name": null,
      "created_at": "2026-08-14T13:23:06.045172",
      "service_detail": {
        "id": 13051,
        "ip": "10.17.61.2",
        "mac": "JM:KG:8C:DB:F5:31",
        "serial": "JMKG8CDBF531",
        "queue": null,
        "interface": "VLAN280_POLVORIN",
        "created_at": "2026-09-21T10:41:30.169744",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9184,
      "client_name": "MIGUEL EDUARDO RODRIGUEZ TOVAR",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "SUSPENDIDO_RESIDENCIAL",
      "status_name": "Suspendido",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Paya Abajo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04129672963",
      "client_email": "MIGUEL.ROD.96.MR@GMAIL.COM",
      "address": "calle campo elias 12-2 paya abajo, rosario de paya turmero aragua zona postal 2115",
      "client_identification": "V24930716",
      "nap_box_name": null,
      "created_at": "2026-08-14T16:40:30.447134",
      "service_detail": {
        "id": 12847,
        "ip": "172.17.172.2",
        "mac": "VS:OL:00:52:14:71",
        "serial": "VSOL00521471",
        "queue": null,
        "interface": "VLAN231_PAYABAJO",
        "created_at": "2026-08-15T17:05:08.310807",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9185,
      "client_name": "JENNY ESTHER MORENO ARGUIZONES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "4128154370",
      "client_email": "JM1350267@GMAIL.COM",
      "address": "urbanizacion ezequiel zamora edificio urquia piso 2 apto 6 turmero aragua zona postal 2115",
      "client_identification": "v14230844",
      "nap_box_name": "CTO-00296",
      "created_at": "2026-08-14T16:40:32.650951",
      "service_detail": {
        "id": 12860,
        "ip": "10.17.65.2",
        "mac": "JM:KG:CC:2E:77:72",
        "serial": "JMKGCC2E7772",
        "queue": null,
        "interface": "VLAN209_ZAMORA_OLT1",
        "created_at": "2026-08-17T15:15:42.849598",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9186,
      "client_name": "Michell Yhainilin Velasquez Mariño",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "4243796480",
      "client_email": "michelyhainilinmarinovelasques@gmail.com",
      "address": "urbanizacion pantin calle 1 casa # 13",
      "client_identification": "28187407",
      "nap_box_name": null,
      "created_at": "2026-08-15T14:09:04.376312",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 9187,
      "client_name": "Carolina Lisbeth Rattia Perez",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "4127764522",
      "client_email": "carolinarattia1507@gmail.com",
      "address": "urbanizacion pantin calle 17-b casa #36",
      "client_identification": "V20334399",
      "nap_box_name": "CTO-00048",
      "created_at": "2026-08-15T14:09:05.876790",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 9188,
      "client_name": "MARIA GABRIELA PERDOMO FLORES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Pantin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "4243245546",
      "client_email": "perdomog776@gmail.com",
      "address": "urbanización los pantin calle 14 a #21",
      "client_identification": "V22298085",
      "nap_box_name": "CTO-00169",
      "created_at": "2026-08-17T07:44:44.645576",
      "service_detail": {
        "id": 12877,
        "ip": "10.17.64.2",
        "mac": "JM:KG:CD:D8:F3:80",
        "serial": "JMKGCDD8F380",
        "queue": null,
        "interface": "VLAN229_PANTIN",
        "created_at": "2026-08-18T15:45:10.850605",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9196,
      "client_name": "Enrique Eulijio Carrero Marrero",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "4128971056",
      "client_email": "carreroenrique707@gmail.com",
      "address": "calle fergus edificio d el portal 10 apartamento  101 urb san pablo",
      "client_identification": "v28514444",
      "nap_box_name": "TORRE D EDIF LOS NISPEROS",
      "created_at": "2026-08-18T15:57:20.900201",
      "service_detail": {
        "id": 12886,
        "ip": "172.17.1.10",
        "mac": "JM:KG:C1:94:61:A6",
        "serial": "JMKGC19461A6",
        "queue": null,
        "interface": "VLAN224_SAN_PABLO_OLT1",
        "created_at": "2026-08-19T08:34:32.551256",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9197,
      "client_name": "JUAN FRANCISCO YANEZ MORILLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero I",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04262337637",
      "client_email": "Juanyanez908@gmail.com",
      "address": "calle 7 casa número 21 barrio saman  tarazonero 1",
      "client_identification": "V7249187",
      "nap_box_name": null,
      "created_at": "2026-08-18T17:44:50.973880",
      "service_detail": {
        "id": 12883,
        "ip": "172.17.1.6",
        "mac": "HW:TC:1E:C5:F4:A3",
        "serial": "HWTC1EC5F4A3",
        "queue": null,
        "interface": "VLAN140_SMT1_ZTE",
        "created_at": "2026-08-18T18:17:52.994343",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9198,
      "client_name": "Gleiger Del Carmen Torbello Murga",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "SUSPENDIDO_RESIDENCIAL",
      "status_name": "Suspendido",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Paraguatan",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "4243071717",
      "client_email": "gleigertorbello05@gmail.com",
      "address": "paraguatan calle escalona casa#20",
      "client_identification": "V26336154",
      "nap_box_name": null,
      "created_at": "2026-08-18T17:44:53.164656",
      "service_detail": {
        "id": 12916,
        "ip": "10.17.66.2",
        "mac": "JM:KG:CB:40:80:03",
        "serial": "JMKGCB408003",
        "queue": null,
        "interface": "VLAN283_PARAGUATAN",
        "created_at": "2026-08-27T09:50:28.553146",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9199,
      "client_name": "ANA LUCIA RODRIGUEZ DE SULBARAN",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "SUSPENDIDO_RESIDENCIAL",
      "status_name": "Suspendido",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Simon Bolivar",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "4243103566",
      "client_email": "aguabendita91@gmail.com",
      "address": "simón bolivar calle 4 casa 56 el macaro",
      "client_identification": "V14149384",
      "nap_box_name": "CTO-00047",
      "created_at": "2026-08-18T21:02:47.409139",
      "service_detail": {
        "id": 13074,
        "ip": "172.17.1.14",
        "mac": "JM:KG:27:D5:3C:0B",
        "serial": "JMKG27D53C0B",
        "queue": null,
        "interface": "VLAN128_SIMON_BOLIVAR_ZTE",
        "created_at": "2026-09-24T16:58:48.277965",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9200,
      "client_name": "EFRAIN SANTIAGO MEJIAS LOPEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman Tarazonero I",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "4243194031",
      "client_email": "EFRAINMEJIAS2374@GMAIL.COM",
      "address": "SAMAN TARAZONERO 2 MZNA.D-4 #11",
      "client_identification": "V12238121",
      "nap_box_name": "CTO-00687",
      "created_at": "2026-08-20T10:53:48.034851",
      "service_detail": {
        "id": 13067,
        "ip": "172.17.1.18",
        "mac": "JM:KG:3F:C6:D4:28",
        "serial": "JMKG3FC6D428",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2026-09-23T11:48:40.113818",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9202,
      "client_name": "ZULAY EMILIA MADRID ZAMBRANO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Guerito",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "4125988392",
      "client_email": "MADRIDZULAY54@GMAIL.COM",
      "address": "COMUNIDAD LA TRINIDAD, SECTOR FUNDÓ SAN JOSÉ CALLE #2 MANZANA #4 CASA #47",
      "client_identification": "V10752157",
      "nap_box_name": "CTO-00632",
      "created_at": "2026-08-20T12:42:00.403209",
      "service_detail": {
        "id": 12890,
        "ip": "172.17.1.22",
        "mac": "JM:KG:C4:b5:45:53",
        "serial": "JMKGC4b54553",
        "queue": null,
        "interface": "VLAN137_LA_ESPERANZA_OLT_ZTE",
        "created_at": "2026-08-20T12:43:06.785643",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9203,
      "client_name": "ARMANDO RAMON SAMUEL GRANADO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124911853",
      "client_email": "WILLYHERNAN47@GMAIL.COM",
      "address": "CALLE 8, CASA 12 SECTOR PANTYN, ROSARIO DE PAYA, TURMEEO ESTADO ARAHUA",
      "client_identification": "V7272479",
      "nap_box_name": "CTO-00114 C/ 8",
      "created_at": "2026-08-20T15:56:31.613298",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 9204,
      "client_name": "JOSE RAMON GARCIA MEDINA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Pantin",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243250891",
      "client_email": "JG8490391@GMAIL.COM",
      "address": "PANTIN CALLE 4B CASA # 7",
      "client_identification": "V6445191",
      "nap_box_name": "CTO-00076",
      "created_at": "2026-08-20T18:31:15.409123",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 9205,
      "client_name": "PEDRO PABLO INOJOSA GARCÍA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "SUSPENDIDO_RESIDENCIAL",
      "status_name": "Suspendido",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Payita",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "4243352383",
      "client_email": "PEDROINOJOSA6@GMAIL.COM",
      "address": "PAYITA CALLEJÓN 96 CASA NÚMERO 2",
      "client_identification": "V20336829",
      "nap_box_name": "1",
      "created_at": "2026-08-22T15:16:39.437948",
      "service_detail": {
        "id": 13047,
        "ip": "172.17.1.34",
        "mac": "JM:KG:63:94:FD:E0",
        "serial": "JMKG6394FDE0",
        "queue": null,
        "interface": "VLAN284_PAYITA",
        "created_at": "2026-09-20T09:43:16.946804",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9206,
      "client_name": "MARIA VICTORIA JARAMILLO SILVA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vallecito",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04126029026",
      "client_email": "VICTORIA10200822@GMAIL.COM",
      "address": "CALLE EL BUSCARÉ CASA NUMERO 6 SECTOR VALLECITO ROSARIO DE PAYA",
      "client_identification": "V22291225",
      "nap_box_name": "CE - 406",
      "created_at": "2026-08-22T23:06:56.036247",
      "service_detail": {
        "id": 13177,
        "ip": "172.17.1.38",
        "mac": "4c:ab:fc:48:d2:9f",
        "serial": "JMKGCF58BAAB",
        "queue": null,
        "interface": "VLAN258_VALLECITO",
        "created_at": "2026-10-15T23:50:11.376896",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9207,
      "client_name": "PNB TRANSITO ARC INSPECTOR BRACHO",
      "client_type_name": "GRATIS",
      "client_subdivision": "ACTIVO_GRATIS",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "San Pablo",
      "plan": {
        "id": 86,
        "name": "PLAN RECURRENTE 80M GRATIS",
        "cost": "0.00",
        "code": "FO-G80",
        "profile": "80M/80M"
      },
      "client_mobile": "04267415025",
      "client_email": "RRHHSTARC@GMAIL.COM",
      "address": "ZONA INDUSTRIAL SAN PABLO CALLE INDUSTRIAL.TURMERO ARAGUA.",
      "client_identification": "G200093277",
      "nap_box_name": "1",
      "created_at": "2026-08-24T12:53:17.843761",
      "service_detail": {
        "id": 12904,
        "ip": "172.17.1.2",
        "mac": "ZX:IC:CD:2D:9F:8f",
        "serial": "ZXICCD2D9F8F",
        "queue": null,
        "interface": "VLAN224_SAN_PABLO_OLT1",
        "created_at": "2026-08-24T13:24:09.913498",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9208,
      "client_name": "JORGE  ALBERTO MARTINEZ LIENDO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "SUSPENDIDO_RESIDENCIAL",
      "status_name": "Suspendido",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Payita",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04145998098",
      "client_email": "MARTINEZJ2362@GMAIL.COM",
      "address": "CALLE PRINCIPAL DE PAYITA CALLEJON CANTE V CASA NUMERO 61-2 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V7235563",
      "nap_box_name": "1",
      "created_at": "2026-08-24T21:10:17.849077",
      "service_detail": {
        "id": 12911,
        "ip": "172.17.1.62",
        "mac": "QX:TL:CB:62:46:FB",
        "serial": "QXTLCB6246FB",
        "queue": null,
        "interface": "VLAN284_PAYITA",
        "created_at": "2026-08-26T15:25:23.477354",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9209,
      "client_name": "ISABEL MARIA RODRIGUEZ SANCHEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "SUSPENDIDO_RESIDENCIAL",
      "status_name": "Suspendido",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona I",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "4120140532",
      "client_email": "SUGEISMARIA1972@GMAIL.COM",
      "address": "CASONA 1 EDIF 5C PLANTA BAJA APARTAMENTO NUMERO 6",
      "client_identification": "V4546311",
      "nap_box_name": "530 edificio c",
      "created_at": "2026-08-26T14:55:03.283546",
      "service_detail": {
        "id": 12912,
        "ip": "172.17.1.30",
        "mac": "JM:KG:CA:4A:3F:64",
        "serial": "JMKGCA4A3F64",
        "queue": null,
        "interface": "VLAN109_CASONA_1",
        "created_at": "2026-08-26T16:03:19.544151",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9210,
      "client_name": "CARMEN ROSA CONTRERAS CARRERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Concepcion",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "4145434075",
      "client_email": "CARMENROSACARRERO@GMAIL.COM",
      "address": "URBANIZACION VISTA HERMOSA CASA B-6 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V17109604",
      "nap_box_name": "CTO-00586",
      "created_at": "2026-08-26T14:55:05.423419",
      "service_detail": {
        "id": 13068,
        "ip": "172.17.1.42",
        "mac": "JM:KG:A8:B2:5F:E0",
        "serial": "JMKGA8B25FE0",
        "queue": null,
        "interface": "VLAN111_CONCEPCION",
        "created_at": "2026-09-23T12:56:47.547717",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9211,
      "client_name": "CRISTOFER RUSSELL MORILLO ROMERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Polvorin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "4228480297",
      "client_email": "CRISTOFERMORILLO43@GMAIL.COM",
      "address": "POLVORÍN FRENTE LA IGLESIA",
      "client_identification": "V30102702",
      "nap_box_name": "CTO-00353",
      "created_at": "2026-08-26T14:55:11.455160",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 9212,
      "client_name": "NAIROBI WILERMA DE LOURDES MACHADO REYES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "San Pablo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "4144863572",
      "client_email": "NAIROBIMACHADO@HOTMAIL.COM",
      "address": "AV PRINCIPAL MANZANA 11 CASA NRO  URB SAN PABLO TURMERO EDO ARAGUA",
      "client_identification": "V15181008",
      "nap_box_name": "CTO-00161",
      "created_at": "2026-08-26T14:55:17.209230",
      "service_detail": {
        "id": 13203,
        "ip": "172.17.1.54",
        "mac": "JM:KG:1E:B8:4C:35",
        "serial": "JMKG1EB84C35",
        "queue": null,
        "interface": "VLAN224_SAN_PABLO_OLT1",
        "created_at": "2026-10-20T10:25:17.099284",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9213,
      "client_name": "CLARIBEL LUGO YNOJOSA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "SUSPENDIDO_RESIDENCIAL",
      "status_name": "Suspendido",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Nispero",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "4128649477",
      "client_email": "ASUNTOS.MUJER2009@GMAIL.COM",
      "address": "LOS NÍSPERO ETAPA 1",
      "client_identification": "V10756993",
      "nap_box_name": "CTO-00720",
      "created_at": "2026-08-26T14:57:19.712772",
      "service_detail": {
        "id": 13070,
        "ip": "172.17.1.46",
        "mac": "JM:KG:DE:4B:71:05",
        "serial": "JMKGDE4B7105",
        "queue": null,
        "interface": "VLAN208_NISPERO_OLT1",
        "created_at": "2026-09-24T12:17:09.529926",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9214,
      "client_name": "UNIDAD EDUCATIVA PRIVADA VERDAD Y VIDA ,C.A.",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Polvorin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "4243479920",
      "client_email": "UEPVERDADYVIDA@GMAIL.COM",
      "address": "VÍA PRINCIPAL GUAYABITA, SECTOR LAS TRES CRUCES, PARCELA 44",
      "client_identification": "J312213310",
      "nap_box_name": "1",
      "created_at": "2026-08-27T12:42:53.012869",
      "service_detail": {
        "id": 12928,
        "ip": "172.17.1.214",
        "mac": "4C:AB:FC:11:EB:AB",
        "serial": "JMKGC676F68C",
        "queue": null,
        "interface": "VLAN282_ZONA_AGRARIA",
        "created_at": "2026-08-29T14:09:38.994275",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9215,
      "client_name": "ANA CONCEPCION BARRETO ARIAS",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Polvorin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "4228156450",
      "client_email": "ANABARRETO63@GMAIL",
      "address": "CALLE DE DE MAYO #11 POLVORÍN FRENTE AL TERMINAL",
      "client_identification": "V8488565",
      "nap_box_name": "CTO-00353",
      "created_at": "2026-08-27T12:42:59.367801",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 9216,
      "client_name": "Sisprot Taurus",
      "client_type_name": "PYME",
      "client_subdivision": "CANCELADO_PYME",
      "status_name": "Cancelado",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Edif. El Torreon",
      "plan": {
        "id": 34,
        "name": "RECURRENTE PYME PLAN 300M",
        "cost": "39.09",
        "code": "FOP300M",
        "profile": "300M/300M"
      },
      "client_mobile": "04124006962",
      "client_email": "breyesve@gmail.com",
      "address": "PRUEBA",
      "client_identification": "J297241175",
      "nap_box_name": "CTO-00180",
      "created_at": "2026-08-27T16:00:51.163742",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 9217,
      "client_name": "Freddy Carrillo",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "POR INSTALAR_RESIDENCIAL",
      "status_name": "Por instalar",
      "cycle": 1,
      "migrate": true,
      "sector_name": "19 de Abril",
      "plan": {
        "id": 8,
        "name": "RECURRENTE RESIDENCIAL PLAN 750M",
        "cost": "49.50",
        "code": "FOR750M",
        "profile": "750M/750M"
      },
      "client_mobile": "04129950904",
      "client_email": "freddycarrillo1912@gmail.com",
      "address": "JEKEHEKHEKEJEJWJWHW",
      "client_identification": "V28458411",
      "nap_box_name": "CTO-00142 C/ 9-A",
      "created_at": "2026-08-27T17:20:08.030119",
      "service_detail": {
        "id": 12921,
        "ip": "172.16.15.2",
        "mac": "XNXNXN912929",
        "serial": "XNXNXN912929",
        "queue": null,
        "interface": "VLAN229_PANTIN",
        "created_at": "2026-08-27T17:20:08.036644",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9218,
      "client_name": "MARIA ELENA GUTIERREZ GRIBORIO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Salto Angel",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04145995945",
      "client_email": "MARIAGRIBORIO24@GMAIL.COM",
      "address": "EL SAMÁN NÚMERO 14, SECTOR SANTO ANGEL, PARROQUIA SANTIAGO MARIÑO",
      "client_identification": "V11290546",
      "nap_box_name": null,
      "created_at": "2026-08-29T10:25:10.162163",
      "service_detail": {
        "id": 12929,
        "ip": "10.13.61.2",
        "mac": "OE:MT:3C:62:02:56",
        "serial": "OEMT3C620256",
        "queue": null,
        "interface": "VLAN121_S_ANGEL",
        "created_at": "2026-08-29T17:50:30.584322",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9219,
      "client_name": "LUIS EDUARDO BETANCOURT",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Polvorin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "4243582830",
      "client_email": "IB6733646@GMAIL.COM",
      "address": "POLVORIN CALLE MIRADOR CASA 1",
      "client_identification": "V8736563",
      "nap_box_name": null,
      "created_at": "2026-08-29T13:46:36.283791",
      "service_detail": {
        "id": 13075,
        "ip": "172.17.1.74",
        "mac": "JM:KG:9F:BA:D7:10",
        "serial": "JMKG9FBAD710",
        "queue": null,
        "interface": "VLAN280_POLVORIN",
        "created_at": "2026-09-25T09:55:57.170063",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9220,
      "client_name": "NAYLIN DESIREE CORRO CAMACHO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Guerrero de Chavez",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "4122989247",
      "client_email": "NAILYNCORRO@GMAIL.COM",
      "address": "SECTOR ROSARIO DE PAYA COMUNIDAD GERREROS DE CHÁVEZ CALLE 3 CASA 105",
      "client_identification": "V22286603",
      "nap_box_name": "CTO-00587",
      "created_at": "2026-08-29T13:47:56.309560",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 9221,
      "client_name": "ISAURA MIGUELINA FOFE COLINA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Polvorin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "4122078153",
      "client_email": "JESUSES754@GMAIL.COM",
      "address": "POLVORIN CALLEJON LOS MAGOS CASA #1",
      "client_identification": "V16996651",
      "nap_box_name": "CTO-00353",
      "created_at": "2026-08-31T16:39:13.906647",
      "service_detail": {
        "id": 12988,
        "ip": "172.17.1.218",
        "mac": "JM:KG:C0:28:7C:21",
        "serial": "JMKGC0287C21",
        "queue": null,
        "interface": "VLAN280_POLVORIN",
        "created_at": "2026-09-06T10:18:57.881401",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9222,
      "client_name": "Sisprot Taurus",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "POR INSTALAR_RESIDENCIAL",
      "status_name": "Por instalar",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Guzman",
      "plan": {
        "id": 43,
        "name": "RECURRENTE RESIDENCIAL PLAN 650M",
        "cost": "46.00",
        "code": "FOR650M",
        "profile": "650M/650M"
      },
      "client_mobile": "04124006962",
      "client_email": "breyesve@gmail.com",
      "address": "HGEBEJE",
      "client_identification": "J297241175",
      "nap_box_name": "Prueba",
      "created_at": "2026-08-31T17:46:27.110271",
      "service_detail": {
        "id": 12939,
        "ip": "172.10.1.2",
        "mac": "LKSAKP0993",
        "serial": "LKSAKP0993",
        "queue": null,
        "interface": "VLAN100_OLTs",
        "created_at": "2026-08-31T17:46:27.113672",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9235,
      "client_name": "KARELMA CAMACHO GOMEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "San Pablo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04142892669",
      "client_email": "KHARELMALACRISTALINA@GMAIL.COM",
      "address": "SAN PABLO CALLE 4 CASA 8, TURMERO",
      "client_identification": "V12640648",
      "nap_box_name": "CTO-00583",
      "created_at": "2026-09-01T13:03:12.936216",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 9236,
      "client_name": "BRYANT JOSE ALEJANDRO VASQUEZ TORO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ciudad Bendita",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04163322046",
      "client_email": "MACUTOFIJO@GMAIL.COM",
      "address": "CALLE 3 CASA S/N CIUDAD BENDITA EL MACARO",
      "client_identification": "V30415948",
      "nap_box_name": "CTO - 1228",
      "created_at": "2026-09-02T19:17:01.688866",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 9240,
      "client_name": "ELEY CAROLINA PACHECO PERDOMO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ciudad Bendita",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04242963056",
      "client_email": "ELEYPACHECO0@GMAIL.COM",
      "address": "CALLE 2 CASA #8 CIUDAD BENDITA EL MACARO TURMERO",
      "client_identification": "V26526480",
      "nap_box_name": "CTO - 1230",
      "created_at": "2026-09-03T11:22:43.364045",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 9241,
      "client_name": "VICMAR ADABELLIS COLMENARES HERRERA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Paraguatan",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "4243061875",
      "client_email": "COLMENARESVICMAR7@GMAIL.COM",
      "address": "CALLE EL MIRADOR CASA #6-1",
      "client_identification": "V15962687",
      "nap_box_name": "CTO-00673",
      "created_at": "2026-09-03T16:13:13.734916",
      "service_detail": {
        "id": 13014,
        "ip": "172.17.1.226",
        "mac": "JM:KG:C8:94:CA:3B",
        "serial": "JMKGC894CA3B",
        "queue": null,
        "interface": "VLAN283_PARAGUATAN",
        "created_at": "2026-09-13T14:24:50.005901",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9242,
      "client_name": "CARLA DEL VALLE CAMARAN OROPEZA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Paraguatan",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "4127031605",
      "client_email": "CAMARANESFOLKLORE@GMAIL.COM",
      "address": "PARAGUATAN CALLE ESCALONA CASA 10-1",
      "client_identification": "V20056126",
      "nap_box_name": "CTO-00397",
      "created_at": "2026-09-03T16:13:15.723093",
      "service_detail": {
        "id": 13178,
        "ip": "172.17.1.230",
        "mac": "JM:KG:C3:1F:BD:94",
        "serial": "JMKGC31FBD94",
        "queue": null,
        "interface": "VLAN283_PARAGUATAN",
        "created_at": "2026-10-16T12:23:46.491260",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9243,
      "client_name": "ARIANA ALEXANDRA MATAMOROS DIAZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "SUSPENDIDO_RESIDENCIAL",
      "status_name": "Suspendido",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Macaro",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121330453",
      "client_email": "ARIANA.ALEXANDRA.MATAMOROS.DIAZ@GMAIL.COM",
      "address": "CALLE 2 CASA 17 URB VILLAS DEL CARMEN ELMACARO TURMERO",
      "client_identification": "V20757228",
      "nap_box_name": "CTO - 1157",
      "created_at": "2026-09-05T18:07:56.638188",
      "service_detail": {
        "id": 12987,
        "ip": "172.17.1.114",
        "mac": "JM:KG:CE:7E:BE:94",
        "serial": "JMKGCE7EBE94",
        "queue": null,
        "interface": "VLAN135_VILLAS_CARMEN_OLT_ZTE",
        "created_at": "2026-09-05T18:14:06.120284",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9244,
      "client_name": "MAYRA ALEJANDRA TORRENSE  PERAZA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Taguapire",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243665402",
      "client_email": "ALEJANDRASION30@GMAIL.COM",
      "address": "URB TAGUAPIRE CALLE 2 MÓDULO 6 APTO 57",
      "client_identification": "V17471375",
      "nap_box_name": "CTO-00687 · Splitter 1",
      "created_at": "2026-09-05T18:09:21.987645",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 9245,
      "client_name": "MIRIAM AYOLEIDA GONZALEZ GOMEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "SUSPENDIDO_RESIDENCIAL",
      "status_name": "Suspendido",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "4125429652",
      "client_email": "MIRIAM.TRABAJO2026@GMAIL.COM",
      "address": "AV. SANTIAGO MARIÑO EDIF. PEGASO PISO 11 APTO. 11-A",
      "client_identification": "V10377043",
      "nap_box_name": null,
      "created_at": "2026-09-06T03:45:56.060786",
      "service_detail": {
        "id": 13048,
        "ip": "172.17.1.98",
        "mac": "JM:KG:10:89:BA:D4",
        "serial": "JMKG1089BAD4",
        "queue": null,
        "interface": "VLAN200_OLTs",
        "created_at": "2026-09-20T11:35:09.987140",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9246,
      "client_name": "WILSON ESNEIDER GORDILLO TELLEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Los Nisperos",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "4248838991",
      "client_email": "WILLEGOTE@GMAIL.COM",
      "address": "LOS NISPEROS TORRE A, APTO 45",
      "client_identification": "E84274912",
      "nap_box_name": null,
      "created_at": "2026-09-06T03:56:49.127090",
      "service_detail": {
        "id": 12990,
        "ip": "172.17.1.238",
        "mac": "ZX:IC:CD:7B:02:97",
        "serial": "ZXICCD7B0297",
        "queue": null,
        "interface": "VLAN272_EDIF_NISPEROS_OLT3",
        "created_at": "2026-09-06T11:41:43.573995",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9247,
      "client_name": "WUILIAM ARMANDO BAYERA LOPEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Valle lindo",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04140528706",
      "client_email": "WUILIAMBAYERA17@GMAIL.COM",
      "address": "VALLE LINDO 2 AV 6 NORTE CASA 1-10 AL FRENTE DEL CEMENTERIO DE TURMERO",
      "client_identification": "V15600195",
      "nap_box_name": null,
      "created_at": "2026-09-06T03:56:54.436909",
      "service_detail": {
        "id": 13015,
        "ip": "172.17.1.234",
        "mac": "JM:KG:C6:05:7F:65",
        "serial": "JMKGC6057F65",
        "queue": null,
        "interface": "VLAN200_OLTs",
        "created_at": "2026-09-14T11:41:37.276936",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9248,
      "client_name": "GLENNYS DEL CARMEN GUZMAN MARQUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128151244",
      "client_email": "GLENNYSGM20@GMAIL.COM",
      "address": "MATA CABALLO CALLE 10 APTO 632-A",
      "client_identification": "V20758952",
      "nap_box_name": null,
      "created_at": "2026-09-06T03:59:29.050917",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 9249,
      "client_name": "MAYRA ALEJANDRA TORRENSE  PERAZA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Taguapire",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243665402",
      "client_email": "ALEJANDRASION30@GMAIL.COM",
      "address": "TAGUAPIRE MODULO 6 APTO 57",
      "client_identification": "V17471375",
      "nap_box_name": null,
      "created_at": "2026-09-06T03:59:30.842556",
      "service_detail": {
        "id": 13056,
        "ip": "172.17.1.110",
        "mac": "JM:KG:4A:ED:96:BC",
        "serial": "JMKG4AED96BC",
        "queue": null,
        "interface": "VLAN129_TAGUAPIRE_ZTE",
        "created_at": "2026-09-21T12:34:25.756192",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9250,
      "client_name": "ELISA DEL CARMEN VALLADARES CORTEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman de Guere",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "4124509261",
      "client_email": "VALLADARESELISA340@GMAIL.COM",
      "address": "CALLE ISAÍAS MEDINA ANGARITA CASA #32-A",
      "client_identification": "V283354942",
      "nap_box_name": null,
      "created_at": "2026-09-07T10:36:57.610804",
      "service_detail": {
        "id": 12991,
        "ip": "172.17.1.118",
        "mac": "XPON2311AE60",
        "serial": "XPON2311AE60",
        "queue": null,
        "interface": "VLAN122_SAMAN_GUERE",
        "created_at": "2026-09-07T10:36:57.965625",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9251,
      "client_name": "FREDDY ANTONIO MORALES AZUAJE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ciudad Bendita",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04224434489",
      "client_email": "MORALESAZUAJEF@GMAIL.COM",
      "address": "CALLE 2 CASA 24 CIUDAD BENDITA EL MACARO",
      "client_identification": "V17175017",
      "nap_box_name": "CTO - 1229",
      "created_at": "2026-09-07T16:03:01.340260",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 9253,
      "client_name": "DEYSI ANDREINA LEON CASTILLO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ciudad Bendita",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128906171",
      "client_email": "DEYSILEON170@GMAIL.COM",
      "address": "CALLE 4 CASA 96 CIUDAD BENDITA DEL MACARO",
      "client_identification": "V17016870",
      "nap_box_name": "CTO - 1230",
      "created_at": "2026-09-07T17:10:43.134581",
      "service_detail": {
        "id": 12997,
        "ip": "172.17.1.242",
        "mac": "ZX:IC:C9:C6:53:5D",
        "serial": "ZXICC9C6535D",
        "queue": null,
        "interface": "VLAN104_EL_MACARO_OLT_ZTE",
        "created_at": "2026-09-07T17:15:21.614754",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9254,
      "client_name": "FREDDY EDUARDO TERAN DIAZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Paraguatan",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243718609",
      "client_email": "FT232487@GMAIL.COM",
      "address": "PARAGUATAN CALLÉ ESCALONA CASA #23",
      "client_identification": "V8585946",
      "nap_box_name": "CTO-00673",
      "created_at": "2026-09-08T12:26:27.899067",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 9255,
      "client_name": "MARIA HERMINIA ROMERO DE PIÑERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Haras de San Pablo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243441555",
      "client_email": "MABELTERE23@GMAIL.COM",
      "address": "HARÁS DE SAN PABLO MANZANA A NÚMERO 24 TURMERO EDO ARAGUA",
      "client_identification": "V4590636",
      "nap_box_name": "CTO-00597",
      "created_at": "2026-09-09T11:41:29.425523",
      "service_detail": {
        "id": 13001,
        "ip": "172.17.1.126",
        "mac": "JMKG0A627384",
        "serial": "JMKG0A627384",
        "queue": null,
        "interface": "VLAN210_HSP_OLT1",
        "created_at": "2026-09-09T11:41:29.434240",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9256,
      "client_name": "VANESSA NATHALY GUEVARA PADILLA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Floresta",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04140384659",
      "client_email": "VANESSANGUEVARAP@GMAIL.COM",
      "address": "URBANIZACIÓN LA FLORESTA CALLE 4 CASA H14",
      "client_identification": "V21203192",
      "nap_box_name": null,
      "created_at": "2026-09-10T14:52:30.885321",
      "service_detail": {
        "id": 13003,
        "ip": "172.17.1.130",
        "mac": "ZX:IC:CD:80:9E:18",
        "serial": "ZXICCD809E18",
        "queue": null,
        "interface": "VLAN212_FLORESTA_OLT1",
        "created_at": "2026-09-10T15:38:28.787294",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9257,
      "client_name": "RINA VERENICE PENA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Vallecito",
      "plan": {
        "id": 21,
        "name": "RECURRENTE RESIDENCIAL PLAN 450M",
        "cost": "34.50",
        "code": "FOR450M",
        "profile": "450M/450M"
      },
      "client_mobile": "04125092260",
      "client_email": "FRANCOANTONI28@GMAIL.COM",
      "address": "ROSARIO DE PAYA SECTOR VALLECITO CALLE ARAGUANEY CASA #59",
      "client_identification": "V13520156",
      "nap_box_name": "CTO-00062",
      "created_at": "2026-09-10T14:52:46.267200",
      "service_detail": {
        "id": 13002,
        "ip": "172.17.1.134",
        "mac": "JMKG5B243F6D",
        "serial": "JMKG5B243F6D",
        "queue": null,
        "interface": "VLAN258_VALLECITO",
        "created_at": "2026-09-10T14:52:47.293939",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9258,
      "client_name": "KAREM PATRICIA RONDON RIVERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "San Pablo",
      "plan": {
        "id": 3,
        "name": "RECURRENTE RESIDENCIAL PLAN 600M",
        "cost": "40.25",
        "code": "FOR600M",
        "profile": "600M/600M"
      },
      "client_mobile": "04243468373",
      "client_email": "KAREMP.RONDON@GMAIL.COM",
      "address": "URBANIZACIÓN SAN PABLO, CALLE HICELES NORTE, RESIDENCIAS CAMELOT, APARTAMENTO",
      "client_identification": "V12957742",
      "nap_box_name": "CTO-00049",
      "created_at": "2026-09-10T14:53:02.077054",
      "service_detail": {
        "id": 13010,
        "ip": "172.17.1.254",
        "mac": "JM:KG:41:8E:D5:03",
        "serial": "JMKG418ED503",
        "queue": null,
        "interface": "VLAN224_SAN_PABLO_OLT1",
        "created_at": "2026-09-12T13:55:35.872979",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9259,
      "client_name": "WILMER ALFREDO VEGAS GUZMAN",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados de Cafetal",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128837771",
      "client_email": "WILMERVEGAS16@GMAIL.COM",
      "address": "URB PRADOS DE CAFETAL CALLE 4 PARCELA 25_1 AL FINAL DEL CALLEJÓN",
      "client_identification": "V13134547",
      "nap_box_name": "CTO-00731",
      "created_at": "2026-09-11T15:50:20.329332",
      "service_detail": {
        "id": 13082,
        "ip": "172.17.1.138",
        "mac": "JM:KG:32:76:54:DB",
        "serial": "JMKG327654DB",
        "queue": null,
        "interface": "VLAN221_CAFETAL_OLT1",
        "created_at": "2026-09-27T12:01:33.820073",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9260,
      "client_name": "ARIANNA DEL VALLE GIL BENITEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman de Guere",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124406266",
      "client_email": "GILARIANNA1804@GMAIL.COM",
      "address": "CALLE ISAÍAS MEDINA ANGARITA CASA #32-A",
      "client_identification": "V33799195",
      "nap_box_name": null,
      "created_at": "2026-09-12T13:19:42.866450",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 9261,
      "client_name": "GAUDY AMARIA RIOS HERNANDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman de Guere",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04127176079",
      "client_email": "GAUDYRIOS24@GMAIL.COM",
      "address": "SAMAN DE GUERE FUNDA LIBERTADOR SECTOR APOLO CJON LOS MANGOS CASA 10",
      "client_identification": "V14104430",
      "nap_box_name": null,
      "created_at": "2026-09-13T02:45:55.140369",
      "service_detail": {
        "id": 13013,
        "ip": "172.17.2.6",
        "mac": "ZXICC9CB4E70",
        "serial": "ZXICC9CB4E70",
        "queue": null,
        "interface": "VLAN139_GUERITO",
        "created_at": "2026-09-13T02:45:55.571909",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9262,
      "client_name": "GAUDY AMARIA RIOS HERNANDEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "POR INSTALAR_RESIDENCIAL",
      "status_name": "Por instalar",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman de Guere",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04127176079",
      "client_email": "GAUDYRIOS24@GMAIL.COM",
      "address": "SAMAN DE GUERE FUNDA LIBERTADOR SECTOR APOLO CJON LOS MANGOS CASA 10",
      "client_identification": "V14104430",
      "nap_box_name": null,
      "created_at": "2026-09-13T02:47:08.482872",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 9263,
      "client_name": "CARMEN RAMONA LOPEZ MOSCADA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Saman de Guere",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04249280646",
      "client_email": "CARMENLMNCD49@GMAIL.COM",
      "address": "RESIDENCIAS TERRAZAS DE JUAN PABLO TURMERO CALLE LA LLANERA",
      "client_identification": "V8628515",
      "nap_box_name": "12",
      "created_at": "2026-09-18T10:04:40.171804",
      "service_detail": {
        "id": 13035,
        "ip": "172.17.1.158",
        "mac": "JM:KG:71:60:D5:F4",
        "serial": "JMKG7160D5F4",
        "queue": null,
        "interface": "VLAN130_TERRAZAS_JP",
        "created_at": "2026-09-18T10:16:06.037074",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9264,
      "client_name": "JESUS YSNARDO LAYA MOLINA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Laguna Plaza",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243069350",
      "client_email": "INGENIEROLAYA05@GMAIL.COM",
      "address": "URBANIZACION LAGUNA PLAZA PH3-17 TURMERO CALLE NEGRO PRIMERO",
      "client_identification": "V12476951",
      "nap_box_name": "CTO-00241",
      "created_at": "2026-09-18T10:04:45.401620",
      "service_detail": {
        "id": 13036,
        "ip": "172.17.1.154",
        "mac": "HW:TC:8F:7D:9B:61",
        "serial": "HWTC8F7D9B61",
        "queue": null,
        "interface": "VLAN216_LAGUNA_PLAZA_OLT1",
        "created_at": "2026-09-18T10:31:49.353392",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9265,
      "client_name": "YUSBELIS MARIA ARAUJO GRATEROL",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "El Bosque",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121407400",
      "client_email": "ARAUJOZORELYS@GMAIL.COM",
      "address": "TURMERO ROSARIO DE PAYA SECTOR EL BOSQUE CALLE FRANCISCO DE MIRANDA NUMERO A04",
      "client_identification": "V15600638",
      "nap_box_name": null,
      "created_at": "2026-09-18T10:04:50.236809",
      "service_detail": {
        "id": 13037,
        "ip": "172.17.1.162",
        "mac": "ZT:EG:C4:5D:78:C0",
        "serial": "ZTEGC45D78C0",
        "queue": null,
        "interface": "VLAN266_EL_BOSQUE_ZTE",
        "created_at": "2026-09-18T10:36:50.912416",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9266,
      "client_name": "MARIANGELA PLACENCIA GARBOZO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "CANCELADO_RESIDENCIAL",
      "status_name": "Cancelado",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04129801582",
      "client_email": "MARIANGELAPLACENCIAGARBOZA@OUTLOOK.ES",
      "address": "CALLE CARREÑO CON SUCRE NÚMERO 24",
      "client_identification": "V28256062",
      "nap_box_name": "CTO-00266",
      "created_at": "2026-09-19T17:55:19.296353",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 9267,
      "client_name": "SARA CASTRO FARIDE FATIMA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Jabillar",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144505675",
      "client_email": "FARIDE893@GMAIL.COM",
      "address": "CALLE MARIÑO VÍA EL MACARO, URB. EL JABILLAR TC, CONDOMINIO 9 CHAGUARAMOS, CASA 09-07 TURMERO ARAGUA",
      "client_identification": "V7246893",
      "nap_box_name": null,
      "created_at": "2026-09-19T17:55:21.804713",
      "service_detail": {
        "id": 13045,
        "ip": "172.17.2.10",
        "mac": "68:9f:f0:2a:7f:ef",
        "serial": "ZXICCD43BC52",
        "queue": null,
        "interface": "VLAN124_SMT2_ZTE",
        "created_at": "2026-09-19T18:17:00.027631",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9268,
      "client_name": "CARMEN ARISTIDA BLADIN LOPEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "POR INSTALAR_RESIDENCIAL",
      "status_name": "Por instalar",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Polvorin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04120269044",
      "client_email": "BLANDINCARMEN22@GMAIL.COM",
      "address": "CALLE PRINCIPAL VIA EL RIO POLVORÍN CASA #43",
      "client_identification": "V26320286",
      "nap_box_name": null,
      "created_at": "2026-09-19T17:55:24.402400",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 9269,
      "client_name": "JHON HARRISON MEJIAS URBINA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "SUSPENDIDO_RESIDENCIAL",
      "status_name": "Suspendido",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243794814",
      "client_email": "YELITZAPEREIRAHIJO01@GMAIL.COM",
      "address": "EZEQUIEL ZAMORA TORRE 20 PISO 4 APARTAMENTO 2",
      "client_identification": "V15077604",
      "nap_box_name": null,
      "created_at": "2026-09-19T17:55:30.917397",
      "service_detail": {
        "id": 13069,
        "ip": "172.17.1.178",
        "mac": "JM:KG:57:98:12:AD",
        "serial": "JMKG579812AD",
        "queue": null,
        "interface": "VLAN209_ZAMORA_OLT1",
        "created_at": "2026-09-23T14:54:34.743802",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9270,
      "client_name": "JOSE GREGORIO MENDEZ DOMINGUEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Valle Paraiso",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243130780",
      "client_email": "JOSEGREGORIOMENDEZ391@GMAIL.COM",
      "address": "CALLE PRINCIPAL CASA MI SUEÑO NRO 4 URB VALLE PARAISO. TURMERO EDO. ARAGUA",
      "client_identification": "V8815509",
      "nap_box_name": null,
      "created_at": "2026-09-19T17:55:37.475997",
      "service_detail": {
        "id": 13073,
        "ip": "172.17.1.186",
        "mac": "JM:KG:0F:9B:4A:21",
        "serial": "JMKG0F9B4A21",
        "queue": null,
        "interface": "VLAN227_V_PARAISO_OLT1",
        "created_at": "2026-09-24T13:00:37.521000",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9271,
      "client_name": "MAURIBEL TAISLENI URBINA UZTARIZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "SUSPENDIDO_RESIDENCIAL",
      "status_name": "Suspendido",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243328382",
      "client_email": "MARIBELXXY@GMAIL.COM",
      "address": "URBANIZACIÓN MATACABALLO CALLE 2 CASA 50",
      "client_identification": "V13530166",
      "nap_box_name": null,
      "created_at": "2026-09-19T17:55:43.996522",
      "service_detail": {
        "id": 13044,
        "ip": "172.17.2.14",
        "mac": "30:86:39:4F:B7:D0",
        "serial": "JMKG394FB7D0",
        "queue": null,
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2026-09-19T18:13:56.878826",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9272,
      "client_name": "NEYLIN MAYLIN GUZMAN MORONTA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128483037",
      "client_email": "MAYLINGUZMAN1993@GMAIL.COM",
      "address": "URBANISMO EZEQUIEL ZAMORA CALLE CRREÑO TORRE TIORA APARTAMENTO 06 PISO 2",
      "client_identification": "V26535055",
      "nap_box_name": "CTO-00296",
      "created_at": "2026-09-22T13:43:04.913509",
      "service_detail": {
        "id": 13064,
        "ip": "172.17.1.170",
        "mac": "JM:KG:CE:BF:5A:06",
        "serial": "JMKGCEBF5A06",
        "queue": null,
        "interface": "VLAN209_ZAMORA_OLT1",
        "created_at": "2026-09-22T15:58:29.750252",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9273,
      "client_name": "LABORATORIO FONTI PHARMACEUTICAL CA",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "La morita",
      "plan": {
        "id": 36,
        "name": "RECURRENTE PYME PLAN 650M",
        "cost": "70.18",
        "code": "FOP650M",
        "profile": "650M/650M"
      },
      "client_mobile": "04122988744",
      "client_email": "YOULINLOBOS@GRUPOFONTI.COM",
      "address": "CALLE PAEZ LOCAL NRO 17 VILLEGUITA TURMERO",
      "client_identification": "J500370962",
      "nap_box_name": null,
      "created_at": "2026-09-22T13:43:21.585612",
      "service_detail": {
        "id": 13060,
        "ip": "172.17.2.26",
        "mac": "JM:KG:6A:CB:5E:0F",
        "serial": "JMKG6ACB5E0F",
        "queue": null,
        "interface": "VLAN122_SAMAN_GUERE",
        "created_at": "2026-09-22T13:54:41.372469",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9274,
      "client_name": "ESTACION DE SERVICIO SAN LUIS C.A",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "El Macaro",
      "plan": {
        "id": 102,
        "name": "RECURRENTE PYME PLAN 150M",
        "cost": "27.60",
        "code": "FOP150M",
        "profile": "150Mbps/150Mbps"
      },
      "client_mobile": "04140528706",
      "client_email": "WUILIAMBAYERA17@GMAIL.COM",
      "address": "PRINCIPAL DEL MACARO SECTOR SAN LUIS NUMERO 28 TURMERO EL MACARO",
      "client_identification": "J075398408",
      "nap_box_name": null,
      "created_at": "2026-09-22T13:55:53.464562",
      "service_detail": {
        "id": 13062,
        "ip": "172.17.1.166",
        "mac": "GP:ON:00:97:CA:86",
        "serial": "GPON0097CA86",
        "queue": null,
        "interface": "VLAN104_EL_MACARO_OLT_ZTE",
        "created_at": "2026-09-22T13:57:36.119941",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9275,
      "client_name": "IRIS MERCEDES RAMIREZ CARPIO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "POR INSTALAR_RESIDENCIAL",
      "status_name": "Por instalar",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Payita",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04267488525",
      "client_email": "MERCEDESIRIS73@GMAIL.COM",
      "address": "RIOSECO CALLE 7 NRO 52",
      "client_identification": "V1610040",
      "nap_box_name": null,
      "created_at": "2026-09-27T14:03:32.995890",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 9276,
      "client_name": "ANA CRISTINA GOMEZ SANCHEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "SUSPENDIDO_RESIDENCIAL",
      "status_name": "Suspendido",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243623014",
      "client_email": "CG3534468@GMAIL.COM",
      "address": "URBANIZACION MATA CABALLO CALLE #9 TETRA 599",
      "client_identification": "V8685421",
      "nap_box_name": null,
      "created_at": "2026-09-27T14:03:35.197680",
      "service_detail": {
        "id": 13084,
        "ip": "172.17.2.38",
        "mac": "JM:KG:2D:FE:A8:C3",
        "serial": "JMKG2DFEA8C3",
        "queue": null,
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2026-09-27T17:29:28.373899",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9277,
      "client_name": "IRIS YEHIMAR AVILA ALFONZO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Orquidea",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "4127767286",
      "client_email": "IRISAVILA755@GMAIL.COM",
      "address": "ORQUÍDEA CALLE 6 CASA 138",
      "client_identification": "V30500236",
      "nap_box_name": "CTO-00306",
      "created_at": "2026-09-28T10:16:06.333162",
      "service_detail": {
        "id": 13088,
        "ip": "172.17.2.42",
        "mac": "MO:NU:00:4A:CE:EF",
        "serial": "MONU004ACEEF",
        "queue": null,
        "interface": "VLAN259_LA_ORQUIDEA",
        "created_at": "2026-09-28T12:09:35.327668",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9278,
      "client_name": "KRISBEL YANITZ BRICEÑO TALES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "POR INSTALAR_RESIDENCIAL",
      "status_name": "Por instalar",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04141467952",
      "client_email": "YANITZATALES@GMAIL.COM",
      "address": "CALLE CARRENO EDIF 22 PISO 4 APT 2 URB HACIENDA EL NISPERO",
      "client_identification": "V2294314",
      "nap_box_name": null,
      "created_at": "2026-09-29T12:00:48.530440",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 9279,
      "client_name": "KRISBEL YANITZ BRICEÑO TALES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04141467952",
      "client_email": "YANITZATALES@GMAIL.COM",
      "address": "CALLE CARRENO EDIF 22 PISO 4 APT 2 URB HACIENDA EL NISPERO",
      "client_identification": "V22943146",
      "nap_box_name": null,
      "created_at": "2026-10-01T17:11:18.319380",
      "service_detail": {
        "id": 13104,
        "ip": "172.17.1.202",
        "mac": "00:11:41:0f:a1:72",
        "serial": "HWTCA20FA171",
        "queue": null,
        "interface": "VLAN209_ZAMORA_OLT1",
        "created_at": "2026-10-02T11:02:58.995036",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9280,
      "client_name": "JOSE RAFAEL BERBECIA BLANCO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243465908",
      "client_email": "JOSERAFAELBERBECIABLANCO@GMAIL.COM",
      "address": "MATACABALLO CALLE 4 CASA 203",
      "client_identification": "V11242961",
      "nap_box_name": "CTO-00274",
      "created_at": "2026-10-01T17:11:20.390021",
      "service_detail": {
        "id": 13105,
        "ip": "172.17.1.198",
        "mac": "6c:68:a4:a7:d4:2b",
        "serial": "VSOL00A7D422",
        "queue": null,
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2026-10-02T11:04:12.522829",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9281,
      "client_name": "HANDERSON GABRIEL ALEJOS LAGUNA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04125838282",
      "client_email": "HANDERSON123ALEJOS@GMAIL.COM",
      "address": "HACIENDA LOS NÍSPEROS EZEQUIEL ZAMORA, TORRE 17, APARTAMENTO #03, PISO 04",
      "client_identification": "V29866284",
      "nap_box_name": null,
      "created_at": "2026-10-01T17:11:22.543183",
      "service_detail": {
        "id": 13106,
        "ip": "172.17.1.206",
        "mac": "e0:ae:a2:69:9f:fd",
        "serial": "HWTC1EA6CEB5",
        "queue": null,
        "interface": "VLAN209_ZAMORA_OLT1",
        "created_at": "2026-10-02T11:05:53.038010",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9284,
      "client_name": "DORIS IBONNE RONDON CHACON",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Antonio Jose de Sucre",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04143470200",
      "client_email": "GUS251175@GMAIL.COM",
      "address": "URB ANTONIO JOSÉ DE SUCRE CALLE 20 DE AGOSTO",
      "client_identification": "V12927991",
      "nap_box_name": null,
      "created_at": "2026-10-03T16:01:19.192850",
      "service_detail": {
        "id": 13132,
        "ip": "172.17.1.210",
        "mac": "1c:ef:03:c7:be:69",
        "serial": "VSOL00C7BE68",
        "queue": null,
        "interface": "VLAN101_AJS",
        "created_at": "2026-10-07T14:59:36.063311",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9285,
      "client_name": "LEINNERKER GUZMAN CASTAÑO TORRE",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "SUSPENDIDO_RESIDENCIAL",
      "status_name": "Suspendido",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Callejon Lim",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243249991",
      "client_email": "LAINERCASTA2204@GMAIL.COM",
      "address": "VILLAS TURMERO CALLEJÓN LIM EDIFICIO VIOLETA",
      "client_identification": "V19699252",
      "nap_box_name": null,
      "created_at": "2026-10-03T16:01:24.248253",
      "service_detail": {
        "id": 13113,
        "ip": "172.17.2.46",
        "mac": "JM:KG:B2:7E:10:FC",
        "serial": "JMKGB27E10FC",
        "queue": null,
        "interface": "VLAN250_LIM_OLT2",
        "created_at": "2026-10-03T19:26:34.614132",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9286,
      "client_name": "JOSE ENRIQUE VARGAS BRAVO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "SUSPENDIDO_RESIDENCIAL",
      "status_name": "Suspendido",
      "cycle": 1,
      "migrate": true,
      "sector_name": "VILLAS DEL CARMEN",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124589024",
      "client_email": "ENRI3021@GMAIL.COM",
      "address": "SECTOR EL MACARO, URB VILLAS DEL CARMEN, TORRE CUCHILLO, APTO NÚMERO 11, SEGUNDO PISO",
      "client_identification": "V25953713",
      "nap_box_name": "58",
      "created_at": "2026-10-05T08:10:37.701277",
      "service_detail": {
        "id": 13117,
        "ip": "172.17.2.50",
        "mac": "30:86:0d:43:9c:b8",
        "serial": "JMKG0D439CB8",
        "queue": null,
        "interface": "VLAN135_VILLAS_CARMEN_OLT_ZTE",
        "created_at": "2026-10-05T12:00:10.258245",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9287,
      "client_name": "MIGUEL ALEJANDRO ALIENDRES BORGES",
      "client_type_name": "EMPLEADO",
      "client_subdivision": "ACTIVO_EMPLEADO",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Valle Paraiso",
      "plan": {
        "id": 78,
        "name": "Plan empleado 80MB",
        "cost": "0.00",
        "code": "FO-80M",
        "profile": "80M/80M"
      },
      "client_mobile": "04124571643",
      "client_email": "ALEJANDROALIENDRES490@GMAIL.COM",
      "address": "FINAL AV SAN PABLO URB. VALLE PARAISO MANZANA 2 CASA #13",
      "client_identification": "V31931519",
      "nap_box_name": null,
      "created_at": "2026-10-05T14:03:37.525834",
      "service_detail": {
        "id": 13179,
        "ip": "172.17.2.90",
        "mac": "JM:KG:CC:E4:8D:2E",
        "serial": "JMKGCCE48D2E",
        "queue": null,
        "interface": "VLAN227_V_PARAISO_OLT1",
        "created_at": "2026-10-16T14:53:56.674553",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9288,
      "client_name": "JOSEPH FELIPE CARRILLO REQUENA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Polvorin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243201735",
      "client_email": "JOSEPHCARRILLO1401@GMAIL.COM",
      "address": "CALLE SANTA EDUVIGES CASA NÚMERO 29-E CASERÍO POLVORÍN",
      "client_identification": "V14830695",
      "nap_box_name": null,
      "created_at": "2026-10-07T12:36:30.434492",
      "service_detail": {
        "id": 13131,
        "ip": "172.17.2.54",
        "mac": "JM:KG:F6:9C:E4:3D",
        "serial": "JMKGF69CE43D",
        "queue": null,
        "interface": "VLAN280_POLVORIN",
        "created_at": "2026-10-07T13:10:35.337513",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9289,
      "client_name": "HEITER EUDALDO OLIVAR RAMIREZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "POR INSTALAR_RESIDENCIAL",
      "status_name": "Por instalar",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04124432519",
      "client_email": "HEITERO1956@GMAIL.COM",
      "address": "CALLE CARREÑO URBANISMO EL NÍSPERO TORRE 4 PISO 3 ESCALERA 2 APTO 01 TURMERO",
      "client_identification": "V4367309",
      "nap_box_name": null,
      "created_at": "2026-10-07T12:36:36.344122",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 9290,
      "client_name": "CONTRALORIA MUNICIPAL SANTIAGO MARIÑO",
      "client_type_name": "PYME",
      "client_subdivision": "ACTIVO_PYME",
      "status_name": "Activo",
      "cycle": 10,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 103,
        "name": "RECURRENTE PYME PLAN 400M",
        "cost": "51.74",
        "code": "FOP400M",
        "profile": "400Mbps/400Mbps"
      },
      "client_mobile": "04243375877",
      "client_email": "CSMESTADOARAGUA@GMAIL.COM",
      "address": "CALLE CEDEÑO CON CALLE MIRANDA EDIF CENTRO PROFESIONAL LOS CHAGUARAMOS PISO 1 OF 1 SECTOR CENTRO TURMERO ARAGUA",
      "client_identification": "G200014474",
      "nap_box_name": "279",
      "created_at": "2026-10-07T12:37:12.179040",
      "service_detail": {
        "id": 13133,
        "ip": "172.27.112.2",
        "mac": "1c:ef:03:49:88:11",
        "serial": "VSOL00498811",
        "queue": null,
        "interface": "VLAN200_OLTs",
        "created_at": "2026-10-07T15:06:59.968495",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9291,
      "client_name": "BELEN TIBISAY JIMENEZ SARRIA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Prados de Cafetal",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128528979",
      "client_email": "BELENJ932@GMAIL.COM",
      "address": "URBANIZACIÓN PRADOS DEL CAFETAL CALLE TRANSVERSAL CASA 6_3_4_B",
      "client_identification": "V8581914",
      "nap_box_name": null,
      "created_at": "2026-10-12T09:34:42.845811",
      "service_detail": {
        "id": 13157,
        "ip": "172.17.2.70",
        "mac": "HW:TC:38:ED:38:A1",
        "serial": "HWTC38ED38A1",
        "queue": null,
        "interface": "VLAN221_CAFETAL_OLT1",
        "created_at": "2026-10-13T11:55:08.962950",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9292,
      "client_name": "SERVIRIA JOSEFINA RON PAEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Callejon Lim",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04144895056",
      "client_email": "SERVI.R11@HOTMAIL.COM",
      "address": "CALLE LIM EDIFICIO VIOLETA PISO PLANTA BAJA APARTAMENTO PB1 URB VILLAS DE TURMERO",
      "client_identification": "V11087705",
      "nap_box_name": null,
      "created_at": "2026-10-12T09:34:44.966696",
      "service_detail": {
        "id": 13153,
        "ip": "172.17.2.65",
        "mac": "JM:KG:D0:7E:5A:2B",
        "serial": "JMKGD07E5A2B",
        "queue": null,
        "interface": "VLAN250_LIM_OLT2",
        "created_at": "2026-10-12T10:05:27.761196",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9293,
      "client_name": "CARMEN OBDULIA VERA DE TORO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Callejon Lim",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04121485198",
      "client_email": "cv045433@GMAIL.COM",
      "address": "AVENIDA CALLEJÓN LIM VÍA PAYA EDIFICIO VIOLETA PISO 1 APARTAMENTO 5 URB VILLA DE TURMERO",
      "client_identification": "V4842199",
      "nap_box_name": null,
      "created_at": "2026-10-12T09:34:50.500644",
      "service_detail": {
        "id": 13154,
        "ip": "172.17.2.62",
        "mac": "JM:KG:B7:A0:FD:23",
        "serial": "JMKGB7A0FD23",
        "queue": null,
        "interface": "VLAN250_LIM_OLT2",
        "created_at": "2026-10-12T10:09:43.747765",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9294,
      "client_name": "MERY MARIA ACOSTA NIEVES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Casco de Turmero",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04167201195",
      "client_email": "ACOSTANIEVESMERYMARIA@GMAIL.COM",
      "address": "CALLE CEDEÑO CASA 56",
      "client_identification": "V12000699",
      "nap_box_name": "CTO-00433",
      "created_at": "2026-10-12T09:34:55.860103",
      "service_detail": {
        "id": 13181,
        "ip": "172.17.2.78",
        "mac": "TP:LG:B9:54:EB:B4",
        "serial": "TPLGB954EBB4",
        "queue": null,
        "interface": "VLAN200_OLTs",
        "created_at": "2026-10-16T20:30:51.594395",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9295,
      "client_name": "MARIA ALEXANDRA NAVARRO DE NUÑEZ",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243003540",
      "client_email": "NAVARROALEXANDRA392@GMAIL.COM",
      "address": "LA CASONA 2 CALLE 14 CASA NUMERO 64 TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V29502194",
      "nap_box_name": "CTO-00120",
      "created_at": "2026-10-13T18:54:30.179864",
      "service_detail": {
        "id": 13174,
        "ip": "172.17.2.58",
        "mac": "HW:TC:CA:A6:0E:F8",
        "serial": "HWTCCAA60EF8",
        "queue": null,
        "interface": "VLAN110_CASONA_2",
        "created_at": "2026-10-15T11:10:35.004293",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9296,
      "client_name": "EDWAR JESUS ESCALONA ZAMBRANO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Rio Seco",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128496508",
      "client_email": "ELARQUITECTO.EEZ@GMAIL.COM",
      "address": "RIO SECO CALLE 9 NUMERO 63 TURMERO ZONA POSTAL 2115",
      "client_identification": "V27864140",
      "nap_box_name": null,
      "created_at": "2026-10-13T18:54:32.256963",
      "service_detail": {
        "id": 13175,
        "ip": "172.17.2.74",
        "mac": "CI:OT:03:A5:47:28",
        "serial": "CIOT03A54728",
        "queue": null,
        "interface": "VLAN251_RIO_SECO",
        "created_at": "2026-10-15T11:11:38.045320",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9297,
      "client_name": "REBECA LEONOR PACHECO LOZADA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Mata Caballo",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243605238",
      "client_email": "REBECAPACHECO3108@GMAIL.COM",
      "address": "SECTOR MATA CABALLO CALLE 4 CASA NUMERO 224 ROSARIO DE PAYA TURMERO ARAGUA ZONA POSTAL 2115",
      "client_identification": "V19269900",
      "nap_box_name": "CTO-00265",
      "created_at": "2026-10-13T18:54:33.985469",
      "service_detail": {
        "id": 13163,
        "ip": "10.11.85.2",
        "mac": "HW:TC:45:B1:32:19",
        "serial": "HWTC45B13219",
        "queue": null,
        "interface": "VLAN219_MATA_CABALLO",
        "created_at": "2026-10-14T09:47:49.141653",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9298,
      "client_name": "JUSNEIDY GABRIELA LARA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Betania",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04123987171",
      "client_email": "JUSNEIDYLARA@GMAIL.COM",
      "address": "ROSARIO DE PAYA COMUNIDAD BETANIA",
      "client_identification": "V22511204",
      "nap_box_name": "CTO-00376",
      "created_at": "2026-10-14T16:45:34.265405",
      "service_detail": {
        "id": 13173,
        "ip": "172.17.2.82",
        "mac": "HW:TC:30:A9:06:93",
        "serial": "HWTC30A90693",
        "queue": null,
        "interface": "VLAN260_BETANIA",
        "created_at": "2026-10-15T10:52:36.446695",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9299,
      "client_name": "KATHERYNE RAMIREZ LINARES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Esperanza",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128648484",
      "client_email": "KATHERYNELINARESRAMIREZ@GMAIL.COM",
      "address": "EL MACARO LA ESPERANZA CALLE 11",
      "client_identification": "V26734645",
      "nap_box_name": null,
      "created_at": "2026-10-14T16:45:36.449221",
      "service_detail": {
        "id": 13171,
        "ip": "172.17.2.86",
        "mac": "JM:KG:CF:8D:C5:3D",
        "serial": "JMKGCF8DC53D",
        "queue": null,
        "interface": "VLAN137_LA_ESPERANZA_OLT_ZTE",
        "created_at": "2026-10-15T10:31:52.589005",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9311,
      "client_name": "LUIS ALEJANDRO  HIDALGO FLORES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "SUSPENDIDO_RESIDENCIAL",
      "status_name": "Suspendido",
      "cycle": 1,
      "migrate": false,
      "sector_name": "Pantin",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128150454",
      "client_email": "luishflores2609@gmail.com",
      "address": "AHAHAHAH",
      "client_identification": "V30148131",
      "nap_box_name": "CTO-00121 C/ 10-A",
      "created_at": "2026-10-17T19:21:56.534272",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 9313,
      "client_name": "PEDRO EMILIO VEGA BUSCEMA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Ezequiel Zamora",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04243567999",
      "client_email": "PEDRISEMI4@GMAIL.COM",
      "address": "URBANISMO LOS NÍSPEROS N#14 TORRE 28 PISO 3",
      "client_identification": "V18474196",
      "nap_box_name": "CTO-00269",
      "created_at": "2026-10-19T12:59:28.953305",
      "service_detail": {
        "id": 13197,
        "ip": "172.17.2.94",
        "mac": "HW:TC:6C:89:BE:7E",
        "serial": "HWTC49200728",
        "queue": null,
        "interface": "VLAN209_ZAMORA_OLT1",
        "created_at": "2026-10-19T17:59:02.959390",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9314,
      "client_name": "CRUZ MANUEL GONZALEZ PIÑERO",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Las Rurales",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128671300",
      "client_email": "CRUZMANUELGP@GMAIL.COM",
      "address": "ROSARIO DE PAYA CALLE 103 SECTOR LAS RURALES",
      "client_identification": "V10459644",
      "nap_box_name": "468",
      "created_at": "2026-10-19T12:59:34.608577",
      "service_detail": {
        "id": 13198,
        "ip": "172.17.2.102",
        "mac": "JM:KG:B9:3A:78:25",
        "serial": "JMKGB93A7825",
        "queue": null,
        "interface": "VLAN252_RURALES_PAYA",
        "created_at": "2026-10-19T19:05:52.621353",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    },
    {
      "id": 9315,
      "client_name": "ANA MARIA MOGUERA MONTES",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "POR INSTALAR_RESIDENCIAL",
      "status_name": "Por instalar",
      "cycle": 1,
      "migrate": true,
      "sector_name": "La Casona II",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04163425355",
      "client_email": "ANAMARIAMOGUERA06@GMAIL.COM",
      "address": "LA CASONA II CALLE 18",
      "client_identification": "V18277990",
      "nap_box_name": "CTO-00086",
      "created_at": "2026-10-19T12:59:41.550725",
      "service_detail": null,
      "installation_invoice_cost": null
    },
    {
      "id": 9316,
      "client_name": "LUIS GUILLERMO MIJARES MOTA",
      "client_type_name": "RESIDENCIAL",
      "client_subdivision": "ACTIVO_RESIDENCIAL",
      "status_name": "Activo",
      "cycle": 1,
      "migrate": true,
      "sector_name": "Valle Fresco",
      "plan": {
        "id": 100,
        "name": "RECURRENTE RESIDENCIAL PLAN 300M",
        "cost": "27.60",
        "code": "FOR300M",
        "profile": "300Mbps/300Mbps"
      },
      "client_mobile": "04128907334",
      "client_email": "LUISGUILLERMOMIJARESS@GMAIL.COM",
      "address": "VALLE FRESCO MANZANA: 16 CASA 4 TURMERO",
      "client_identification": "V19834292",
      "nap_box_name": null,
      "created_at": "2026-10-19T12:59:53.228424",
      "service_detail": {
        "id": 13204,
        "ip": "172.17.2.98",
        "mac": "JM:KG:F0:C8:46:1D",
        "serial": "JMKGF0C8461D",
        "queue": null,
        "interface": "VLAN270_VALLE_FRESCO_OLT3",
        "created_at": "2026-10-20T11:43:15.543297",
        "created_by_name": null
      },
      "installation_invoice_cost": null
    }
  ]
}
export default largeArraydata;
